function ownKeys(e, r) { var t = Object.keys(e); if (Object.getOwnPropertySymbols) { var o = Object.getOwnPropertySymbols(e); r && (o = o.filter(function (r) { return Object.getOwnPropertyDescriptor(e, r).enumerable; })), t.push.apply(t, o); } return t; }
function _objectSpread(e) { for (var r = 1; r < arguments.length; r++) { var t = null != arguments[r] ? arguments[r] : {}; r % 2 ? ownKeys(Object(t), !0).forEach(function (r) { _defineProperty(e, r, t[r]); }) : Object.getOwnPropertyDescriptors ? Object.defineProperties(e, Object.getOwnPropertyDescriptors(t)) : ownKeys(Object(t)).forEach(function (r) { Object.defineProperty(e, r, Object.getOwnPropertyDescriptor(t, r)); }); } return e; }
function _defineProperty(e, r, t) { return (r = _toPropertyKey(r)) in e ? Object.defineProperty(e, r, { value: t, enumerable: !0, configurable: !0, writable: !0 }) : e[r] = t, e; }
function _classCallCheck(a, n) { if (!(a instanceof n)) throw new TypeError("Cannot call a class as a function"); }
function _defineProperties(e, r) { for (var t = 0; t < r.length; t++) { var o = r[t]; o.enumerable = o.enumerable || !1, o.configurable = !0, "value" in o && (o.writable = !0), Object.defineProperty(e, _toPropertyKey(o.key), o); } }
function _createClass(e, r, t) { return r && _defineProperties(e.prototype, r), t && _defineProperties(e, t), Object.defineProperty(e, "prototype", { writable: !1 }), e; }
function _toPropertyKey(t) { var i = _toPrimitive(t, "string"); return "symbol" == _typeof(i) ? i : i + ""; }
function _toPrimitive(t, r) { if ("object" != _typeof(t) || !t) return t; var e = t[Symbol.toPrimitive]; if (void 0 !== e) { var i = e.call(t, r || "default"); if ("object" != _typeof(i)) return i; throw new TypeError("@@toPrimitive must return a primitive value."); } return ("string" === r ? String : Number)(t); }
function _typeof(o) { "@babel/helpers - typeof"; return _typeof = "function" == typeof Symbol && "symbol" == typeof Symbol.iterator ? function (o) { return typeof o; } : function (o) { return o && "function" == typeof Symbol && o.constructor === Symbol && o !== Symbol.prototype ? "symbol" : typeof o; }, _typeof(o); }
/*!
 * jQuery JavaScript Library v3.7.1
 * https://jquery.com/
 *
 * Copyright OpenJS Foundation and other contributors
 * Released under the MIT license
 * https://jquery.org/license
 *
 * Date: 2023-08-28T13:37Z
 */
(function (global, factory) {
  "use strict";

  if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === "object" && _typeof(module.exports) === "object") {
    // For CommonJS and CommonJS-like environments where a proper `window`
    // is present, execute the factory and get jQuery.
    // For environments that do not have a `window` with a `document`
    // (such as Node.js), expose a factory as module.exports.
    // This accentuates the need for the creation of a real `window`.
    // e.g. var jQuery = require("jquery")(window);
    // See ticket trac-14549 for more info.
    module.exports = global.document ? factory(global, true) : function (w) {
      if (!w.document) {
        throw new Error("jQuery requires a window with a document");
      }
      return factory(w);
    };
  } else {
    factory(global);
  }

  // Pass this if window is not defined yet
})(typeof window !== "undefined" ? window : this, function (window, noGlobal) {
  // Edge <= 12 - 13+, Firefox <=18 - 45+, IE 10 - 11, Safari 5.1 - 9+, iOS 6 - 9.1
  // throw exceptions when non-strict code (e.g., ASP.NET 4.5) accesses strict mode
  // arguments.callee.caller (trac-13335). But as of jQuery 3.0 (2016), strict mode should be common
  // enough that all such attempts are guarded in a try block.
  "use strict";

  var arr = [];
  var getProto = Object.getPrototypeOf;
  var _slice = arr.slice;
  var flat = arr.flat ? function (array) {
    return arr.flat.call(array);
  } : function (array) {
    return arr.concat.apply([], array);
  };
  var push = arr.push;
  var indexOf = arr.indexOf;
  var class2type = {};
  var toString = class2type.toString;
  var hasOwn = class2type.hasOwnProperty;
  var fnToString = hasOwn.toString;
  var ObjectFunctionString = fnToString.call(Object);
  var support = {};
  var isFunction = function isFunction(obj) {
    // Support: Chrome <=57, Firefox <=52
    // In some browsers, typeof returns "function" for HTML <object> elements
    // (i.e., `typeof document.createElement( "object" ) === "function"`).
    // We don't want to classify *any* DOM node as a function.
    // Support: QtWeb <=3.8.5, WebKit <=534.34, wkhtmltopdf tool <=0.12.5
    // Plus for old WebKit, typeof returns "function" for HTML collections
    // (e.g., `typeof document.getElementsByTagName("div") === "function"`). (gh-4756)
    return typeof obj === "function" && typeof obj.nodeType !== "number" && typeof obj.item !== "function";
  };
  var isWindow = function isWindow(obj) {
    return obj != null && obj === obj.window;
  };
  var document = window.document;
  var preservedScriptAttributes = {
    type: true,
    src: true,
    nonce: true,
    noModule: true
  };
  function DOMEval(code, node, doc) {
    doc = doc || document;
    var i,
      val,
      script = doc.createElement("script");
    script.text = code;
    if (node) {
      for (i in preservedScriptAttributes) {
        // Support: Firefox 64+, Edge 18+
        // Some browsers don't support the "nonce" property on scripts.
        // On the other hand, just using `getAttribute` is not enough as
        // the `nonce` attribute is reset to an empty string whenever it
        // becomes browsing-context connected.
        // See https://github.com/whatwg/html/issues/2369
        // See https://html.spec.whatwg.org/#nonce-attributes
        // The `node.getAttribute` check was added for the sake of
        // `jQuery.globalEval` so that it can fake a nonce-containing node
        // via an object.
        val = node[i] || node.getAttribute && node.getAttribute(i);
        if (val) {
          script.setAttribute(i, val);
        }
      }
    }
    doc.head.appendChild(script).parentNode.removeChild(script);
  }
  function toType(obj) {
    if (obj == null) {
      return obj + "";
    }

    // Support: Android <=2.3 only (functionish RegExp)
    return _typeof(obj) === "object" || typeof obj === "function" ? class2type[toString.call(obj)] || "object" : _typeof(obj);
  }
  /* global Symbol */
  // Defining this global in .eslintrc.json would create a danger of using the global
  // unguarded in another place, it seems safer to define global only for this module

  var version = "3.7.1",
    rhtmlSuffix = /HTML$/i,
    // Define a local copy of jQuery
    jQuery = function (_jQuery2) {
      function jQuery(_x, _x2) {
        return _jQuery2.apply(this, arguments);
      }
      jQuery.toString = function () {
        return _jQuery2.toString();
      };
      return jQuery;
    }(function (selector, context) {
      // The jQuery object is actually just the init constructor 'enhanced'
      // Need init if jQuery is called (just allow error to be thrown if not included)
      return new jQuery.fn.init(selector, context);
    });
  jQuery.fn = jQuery.prototype = {
    // The current version of jQuery being used
    jquery: version,
    constructor: jQuery,
    // The default length of a jQuery object is 0
    length: 0,
    toArray: function toArray() {
      return _slice.call(this);
    },
    // Get the Nth element in the matched element set OR
    // Get the whole matched element set as a clean array
    get: function get(num) {
      // Return all the elements in a clean array
      if (num == null) {
        return _slice.call(this);
      }

      // Return just the one element from the set
      return num < 0 ? this[num + this.length] : this[num];
    },
    // Take an array of elements and push it onto the stack
    // (returning the new matched element set)
    pushStack: function pushStack(elems) {
      // Build a new jQuery matched element set
      var ret = jQuery.merge(this.constructor(), elems);

      // Add the old object onto the stack (as a reference)
      ret.prevObject = this;

      // Return the newly-formed element set
      return ret;
    },
    // Execute a callback for every element in the matched set.
    each: function each(callback) {
      return jQuery.each(this, callback);
    },
    map: function map(callback) {
      return this.pushStack(jQuery.map(this, function (elem, i) {
        return callback.call(elem, i, elem);
      }));
    },
    slice: function slice() {
      return this.pushStack(_slice.apply(this, arguments));
    },
    first: function first() {
      return this.eq(0);
    },
    last: function last() {
      return this.eq(-1);
    },
    even: function even() {
      return this.pushStack(jQuery.grep(this, function (_elem, i) {
        return (i + 1) % 2;
      }));
    },
    odd: function odd() {
      return this.pushStack(jQuery.grep(this, function (_elem, i) {
        return i % 2;
      }));
    },
    eq: function eq(i) {
      var len = this.length,
        j = +i + (i < 0 ? len : 0);
      return this.pushStack(j >= 0 && j < len ? [this[j]] : []);
    },
    end: function end() {
      return this.prevObject || this.constructor();
    },
    // For internal use only.
    // Behaves like an Array's method, not like a jQuery method.
    push: push,
    sort: arr.sort,
    splice: arr.splice
  };
  jQuery.extend = jQuery.fn.extend = function () {
    var options,
      name,
      src,
      copy,
      copyIsArray,
      clone,
      target = arguments[0] || {},
      i = 1,
      length = arguments.length,
      deep = false;

    // Handle a deep copy situation
    if (typeof target === "boolean") {
      deep = target;

      // Skip the boolean and the target
      target = arguments[i] || {};
      i++;
    }

    // Handle case when target is a string or something (possible in deep copy)
    if (_typeof(target) !== "object" && !isFunction(target)) {
      target = {};
    }

    // Extend jQuery itself if only one argument is passed
    if (i === length) {
      target = this;
      i--;
    }
    for (; i < length; i++) {
      // Only deal with non-null/undefined values
      if ((options = arguments[i]) != null) {
        // Extend the base object
        for (name in options) {
          copy = options[name];

          // Prevent Object.prototype pollution
          // Prevent never-ending loop
          if (name === "__proto__" || target === copy) {
            continue;
          }

          // Recurse if we're merging plain objects or arrays
          if (deep && copy && (jQuery.isPlainObject(copy) || (copyIsArray = Array.isArray(copy)))) {
            src = target[name];

            // Ensure proper type for the source value
            if (copyIsArray && !Array.isArray(src)) {
              clone = [];
            } else if (!copyIsArray && !jQuery.isPlainObject(src)) {
              clone = {};
            } else {
              clone = src;
            }
            copyIsArray = false;

            // Never move original objects, clone them
            target[name] = jQuery.extend(deep, clone, copy);

            // Don't bring in undefined values
          } else if (copy !== undefined) {
            target[name] = copy;
          }
        }
      }
    }

    // Return the modified object
    return target;
  };
  jQuery.extend({
    // Unique for each copy of jQuery on the page
    expando: "jQuery" + (version + Math.random()).replace(/\D/g, ""),
    // Assume jQuery is ready without the ready module
    isReady: true,
    error: function error(msg) {
      throw new Error(msg);
    },
    noop: function noop() {},
    isPlainObject: function isPlainObject(obj) {
      var proto, Ctor;

      // Detect obvious negatives
      // Use toString instead of jQuery.type to catch host objects
      if (!obj || toString.call(obj) !== "[object Object]") {
        return false;
      }
      proto = getProto(obj);

      // Objects with no prototype (e.g., `Object.create( null )`) are plain
      if (!proto) {
        return true;
      }

      // Objects with prototype are plain iff they were constructed by a global Object function
      Ctor = hasOwn.call(proto, "constructor") && proto.constructor;
      return typeof Ctor === "function" && fnToString.call(Ctor) === ObjectFunctionString;
    },
    isEmptyObject: function isEmptyObject(obj) {
      var name;
      for (name in obj) {
        return false;
      }
      return true;
    },
    // Evaluates a script in a provided context; falls back to the global one
    // if not specified.
    globalEval: function globalEval(code, options, doc) {
      DOMEval(code, {
        nonce: options && options.nonce
      }, doc);
    },
    each: function each(obj, callback) {
      var length,
        i = 0;
      if (isArrayLike(obj)) {
        length = obj.length;
        for (; i < length; i++) {
          if (callback.call(obj[i], i, obj[i]) === false) {
            break;
          }
        }
      } else {
        for (i in obj) {
          if (callback.call(obj[i], i, obj[i]) === false) {
            break;
          }
        }
      }
      return obj;
    },
    // Retrieve the text value of an array of DOM nodes
    text: function text(elem) {
      var node,
        ret = "",
        i = 0,
        nodeType = elem.nodeType;
      if (!nodeType) {
        // If no nodeType, this is expected to be an array
        while (node = elem[i++]) {
          // Do not traverse comment nodes
          ret += jQuery.text(node);
        }
      }
      if (nodeType === 1 || nodeType === 11) {
        return elem.textContent;
      }
      if (nodeType === 9) {
        return elem.documentElement.textContent;
      }
      if (nodeType === 3 || nodeType === 4) {
        return elem.nodeValue;
      }

      // Do not include comment or processing instruction nodes

      return ret;
    },
    // results is for internal usage only
    makeArray: function makeArray(arr, results) {
      var ret = results || [];
      if (arr != null) {
        if (isArrayLike(Object(arr))) {
          jQuery.merge(ret, typeof arr === "string" ? [arr] : arr);
        } else {
          push.call(ret, arr);
        }
      }
      return ret;
    },
    inArray: function inArray(elem, arr, i) {
      return arr == null ? -1 : indexOf.call(arr, elem, i);
    },
    isXMLDoc: function isXMLDoc(elem) {
      var namespace = elem && elem.namespaceURI,
        docElem = elem && (elem.ownerDocument || elem).documentElement;

      // Assume HTML when documentElement doesn't yet exist, such as inside
      // document fragments.
      return !rhtmlSuffix.test(namespace || docElem && docElem.nodeName || "HTML");
    },
    // Support: Android <=4.0 only, PhantomJS 1 only
    // push.apply(_, arraylike) throws on ancient WebKit
    merge: function merge(first, second) {
      var len = +second.length,
        j = 0,
        i = first.length;
      for (; j < len; j++) {
        first[i++] = second[j];
      }
      first.length = i;
      return first;
    },
    grep: function grep(elems, callback, invert) {
      var callbackInverse,
        matches = [],
        i = 0,
        length = elems.length,
        callbackExpect = !invert;

      // Go through the array, only saving the items
      // that pass the validator function
      for (; i < length; i++) {
        callbackInverse = !callback(elems[i], i);
        if (callbackInverse !== callbackExpect) {
          matches.push(elems[i]);
        }
      }
      return matches;
    },
    // arg is for internal usage only
    map: function map(elems, callback, arg) {
      var length,
        value,
        i = 0,
        ret = [];

      // Go through the array, translating each of the items to their new values
      if (isArrayLike(elems)) {
        length = elems.length;
        for (; i < length; i++) {
          value = callback(elems[i], i, arg);
          if (value != null) {
            ret.push(value);
          }
        }

        // Go through every key on the object,
      } else {
        for (i in elems) {
          value = callback(elems[i], i, arg);
          if (value != null) {
            ret.push(value);
          }
        }
      }

      // Flatten any nested arrays
      return flat(ret);
    },
    // A global GUID counter for objects
    guid: 1,
    // jQuery.support is not used in Core but other projects attach their
    // properties to it so it needs to exist.
    support: support
  });
  if (typeof Symbol === "function") {
    jQuery.fn[Symbol.iterator] = arr[Symbol.iterator];
  }

  // Populate the class2type map
  jQuery.each("Boolean Number String Function Array Date RegExp Object Error Symbol".split(" "), function (_i, name) {
    class2type["[object " + name + "]"] = name.toLowerCase();
  });
  function isArrayLike(obj) {
    // Support: real iOS 8.2 only (not reproducible in simulator)
    // `in` check used to prevent JIT error (gh-2145)
    // hasOwn isn't used here due to false negatives
    // regarding Nodelist length in IE
    var length = !!obj && "length" in obj && obj.length,
      type = toType(obj);
    if (isFunction(obj) || isWindow(obj)) {
      return false;
    }
    return type === "array" || length === 0 || typeof length === "number" && length > 0 && length - 1 in obj;
  }
  function nodeName(elem, name) {
    return elem.nodeName && elem.nodeName.toLowerCase() === name.toLowerCase();
  }
  var pop = arr.pop;
  var sort = arr.sort;
  var splice = arr.splice;
  var whitespace = "[\\x20\\t\\r\\n\\f]";
  var rtrimCSS = new RegExp("^" + whitespace + "+|((?:^|[^\\\\])(?:\\\\.)*)" + whitespace + "+$", "g");

  // Note: an element does not contain itself
  jQuery.contains = function (a, b) {
    var bup = b && b.parentNode;
    return a === bup || !!(bup && bup.nodeType === 1 && (
    // Support: IE 9 - 11+
    // IE doesn't have `contains` on SVG.
    a.contains ? a.contains(bup) : a.compareDocumentPosition && a.compareDocumentPosition(bup) & 16));
  };

  // CSS string/identifier serialization
  // https://drafts.csswg.org/cssom/#common-serializing-idioms
  var rcssescape = /([\0-\x1f\x7f]|^-?\d)|^-$|[^\x80-\uFFFF\w-]/g;
  function fcssescape(ch, asCodePoint) {
    if (asCodePoint) {
      // U+0000 NULL becomes U+FFFD REPLACEMENT CHARACTER
      if (ch === "\0") {
        return "\uFFFD";
      }

      // Control characters and (dependent upon position) numbers get escaped as code points
      return ch.slice(0, -1) + "\\" + ch.charCodeAt(ch.length - 1).toString(16) + " ";
    }

    // Other potentially-special ASCII characters get backslash-escaped
    return "\\" + ch;
  }
  jQuery.escapeSelector = function (sel) {
    return (sel + "").replace(rcssescape, fcssescape);
  };
  var preferredDoc = document,
    pushNative = push;
  (function () {
    var i,
      Expr,
      outermostContext,
      sortInput,
      hasDuplicate,
      push = pushNative,
      // Local document vars
      document,
      documentElement,
      documentIsHTML,
      rbuggyQSA,
      matches,
      // Instance-specific data
      expando = jQuery.expando,
      dirruns = 0,
      done = 0,
      classCache = createCache(),
      tokenCache = createCache(),
      compilerCache = createCache(),
      nonnativeSelectorCache = createCache(),
      sortOrder = function sortOrder(a, b) {
        if (a === b) {
          hasDuplicate = true;
        }
        return 0;
      },
      booleans = "checked|selected|async|autofocus|autoplay|controls|defer|disabled|hidden|ismap|" + "loop|multiple|open|readonly|required|scoped",
      // Regular expressions

      // https://www.w3.org/TR/css-syntax-3/#ident-token-diagram
      identifier = "(?:\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\[^\\r\\n\\f]|[\\w-]|[^\0-\\x7f])+",
      // Attribute selectors: https://www.w3.org/TR/selectors/#attribute-selectors
      attributes = "\\[" + whitespace + "*(" + identifier + ")(?:" + whitespace +
      // Operator (capture 2)
      "*([*^$|!~]?=)" + whitespace +
      // "Attribute values must be CSS identifiers [capture 5] or strings [capture 3 or capture 4]"
      "*(?:'((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\"|(" + identifier + "))|)" + whitespace + "*\\]",
      pseudos = ":(" + identifier + ")(?:\\((" +
      // To reduce the number of selectors needing tokenize in the preFilter, prefer arguments:
      // 1. quoted (capture 3; capture 4 or capture 5)
      "('((?:\\\\.|[^\\\\'])*)'|\"((?:\\\\.|[^\\\\\"])*)\")|" +
      // 2. simple (capture 6)
      "((?:\\\\.|[^\\\\()[\\]]|" + attributes + ")*)|" +
      // 3. anything else (capture 2)
      ".*" + ")\\)|)",
      // Leading and non-escaped trailing whitespace, capturing some non-whitespace characters preceding the latter
      rwhitespace = new RegExp(whitespace + "+", "g"),
      rcomma = new RegExp("^" + whitespace + "*," + whitespace + "*"),
      rleadingCombinator = new RegExp("^" + whitespace + "*([>+~]|" + whitespace + ")" + whitespace + "*"),
      rdescend = new RegExp(whitespace + "|>"),
      rpseudo = new RegExp(pseudos),
      ridentifier = new RegExp("^" + identifier + "$"),
      matchExpr = {
        ID: new RegExp("^#(" + identifier + ")"),
        CLASS: new RegExp("^\\.(" + identifier + ")"),
        TAG: new RegExp("^(" + identifier + "|[*])"),
        ATTR: new RegExp("^" + attributes),
        PSEUDO: new RegExp("^" + pseudos),
        CHILD: new RegExp("^:(only|first|last|nth|nth-last)-(child|of-type)(?:\\(" + whitespace + "*(even|odd|(([+-]|)(\\d*)n|)" + whitespace + "*(?:([+-]|)" + whitespace + "*(\\d+)|))" + whitespace + "*\\)|)", "i"),
        bool: new RegExp("^(?:" + booleans + ")$", "i"),
        // For use in libraries implementing .is()
        // We use this for POS matching in `select`
        needsContext: new RegExp("^" + whitespace + "*[>+~]|:(even|odd|eq|gt|lt|nth|first|last)(?:\\(" + whitespace + "*((?:-\\d)?\\d*)" + whitespace + "*\\)|)(?=[^-]|$)", "i")
      },
      rinputs = /^(?:input|select|textarea|button)$/i,
      rheader = /^h\d$/i,
      // Easily-parseable/retrievable ID or TAG or CLASS selectors
      rquickExpr = /^(?:#([\w-]+)|(\w+)|\.([\w-]+))$/,
      rsibling = /[+~]/,
      // CSS escapes
      // https://www.w3.org/TR/CSS21/syndata.html#escaped-characters
      runescape = new RegExp("\\\\[\\da-fA-F]{1,6}" + whitespace + "?|\\\\([^\\r\\n\\f])", "g"),
      funescape = function funescape(escape, nonHex) {
        var high = "0x" + escape.slice(1) - 0x10000;
        if (nonHex) {
          // Strip the backslash prefix from a non-hex escape sequence
          return nonHex;
        }

        // Replace a hexadecimal escape sequence with the encoded Unicode code point
        // Support: IE <=11+
        // For values outside the Basic Multilingual Plane (BMP), manually construct a
        // surrogate pair
        return high < 0 ? String.fromCharCode(high + 0x10000) : String.fromCharCode(high >> 10 | 0xD800, high & 0x3FF | 0xDC00);
      },
      // Used for iframes; see `setDocument`.
      // Support: IE 9 - 11+, Edge 12 - 18+
      // Removing the function wrapper causes a "Permission Denied"
      // error in IE/Edge.
      unloadHandler = function unloadHandler() {
        setDocument();
      },
      inDisabledFieldset = addCombinator(function (elem) {
        return elem.disabled === true && nodeName(elem, "fieldset");
      }, {
        dir: "parentNode",
        next: "legend"
      });

    // Support: IE <=9 only
    // Accessing document.activeElement can throw unexpectedly
    // https://bugs.jquery.com/ticket/13393
    function safeActiveElement() {
      try {
        return document.activeElement;
      } catch (err) {}
    }

    // Optimize for push.apply( _, NodeList )
    try {
      push.apply(arr = _slice.call(preferredDoc.childNodes), preferredDoc.childNodes);

      // Support: Android <=4.0
      // Detect silently failing push.apply
      // eslint-disable-next-line no-unused-expressions
      arr[preferredDoc.childNodes.length].nodeType;
    } catch (e) {
      push = {
        apply: function apply(target, els) {
          pushNative.apply(target, _slice.call(els));
        },
        call: function call(target) {
          pushNative.apply(target, _slice.call(arguments, 1));
        }
      };
    }
    function find(selector, context, results, seed) {
      var m,
        i,
        elem,
        nid,
        match,
        groups,
        newSelector,
        newContext = context && context.ownerDocument,
        // nodeType defaults to 9, since context defaults to document
        nodeType = context ? context.nodeType : 9;
      results = results || [];

      // Return early from calls with invalid selector or context
      if (typeof selector !== "string" || !selector || nodeType !== 1 && nodeType !== 9 && nodeType !== 11) {
        return results;
      }

      // Try to shortcut find operations (as opposed to filters) in HTML documents
      if (!seed) {
        setDocument(context);
        context = context || document;
        if (documentIsHTML) {
          // If the selector is sufficiently simple, try using a "get*By*" DOM method
          // (excepting DocumentFragment context, where the methods don't exist)
          if (nodeType !== 11 && (match = rquickExpr.exec(selector))) {
            // ID selector
            if (m = match[1]) {
              // Document context
              if (nodeType === 9) {
                if (elem = context.getElementById(m)) {
                  // Support: IE 9 only
                  // getElementById can match elements by name instead of ID
                  if (elem.id === m) {
                    push.call(results, elem);
                    return results;
                  }
                } else {
                  return results;
                }

                // Element context
              } else {
                // Support: IE 9 only
                // getElementById can match elements by name instead of ID
                if (newContext && (elem = newContext.getElementById(m)) && find.contains(context, elem) && elem.id === m) {
                  push.call(results, elem);
                  return results;
                }
              }

              // Type selector
            } else if (match[2]) {
              push.apply(results, context.getElementsByTagName(selector));
              return results;

              // Class selector
            } else if ((m = match[3]) && context.getElementsByClassName) {
              push.apply(results, context.getElementsByClassName(m));
              return results;
            }
          }

          // Take advantage of querySelectorAll
          if (!nonnativeSelectorCache[selector + " "] && (!rbuggyQSA || !rbuggyQSA.test(selector))) {
            newSelector = selector;
            newContext = context;

            // qSA considers elements outside a scoping root when evaluating child or
            // descendant combinators, which is not what we want.
            // In such cases, we work around the behavior by prefixing every selector in the
            // list with an ID selector referencing the scope context.
            // The technique has to be used as well when a leading combinator is used
            // as such selectors are not recognized by querySelectorAll.
            // Thanks to Andrew Dupont for this technique.
            if (nodeType === 1 && (rdescend.test(selector) || rleadingCombinator.test(selector))) {
              // Expand context for sibling selectors
              newContext = rsibling.test(selector) && testContext(context.parentNode) || context;

              // We can use :scope instead of the ID hack if the browser
              // supports it & if we're not changing the context.
              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when
              // strict-comparing two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if (newContext != context || !support.scope) {
                // Capture the context ID, setting it first if necessary
                if (nid = context.getAttribute("id")) {
                  nid = jQuery.escapeSelector(nid);
                } else {
                  context.setAttribute("id", nid = expando);
                }
              }

              // Prefix every selector in the list
              groups = tokenize(selector);
              i = groups.length;
              while (i--) {
                groups[i] = (nid ? "#" + nid : ":scope") + " " + toSelector(groups[i]);
              }
              newSelector = groups.join(",");
            }
            try {
              push.apply(results, newContext.querySelectorAll(newSelector));
              return results;
            } catch (qsaError) {
              nonnativeSelectorCache(selector, true);
            } finally {
              if (nid === expando) {
                context.removeAttribute("id");
              }
            }
          }
        }
      }

      // All others
      return select(selector.replace(rtrimCSS, "$1"), context, results, seed);
    }

    /**
     * Create key-value caches of limited size
     * @returns {function(string, object)} Returns the Object data after storing it on itself with
     *	property name the (space-suffixed) string and (if the cache is larger than Expr.cacheLength)
     *	deleting the oldest entry
     */
    function createCache() {
      var keys = [];
      function cache(key, value) {
        // Use (key + " ") to avoid collision with native prototype properties
        // (see https://github.com/jquery/sizzle/issues/157)
        if (keys.push(key + " ") > Expr.cacheLength) {
          // Only keep the most recent entries
          delete cache[keys.shift()];
        }
        return cache[key + " "] = value;
      }
      return cache;
    }

    /**
     * Mark a function for special use by jQuery selector module
     * @param {Function} fn The function to mark
     */
    function markFunction(fn) {
      fn[expando] = true;
      return fn;
    }

    /**
     * Support testing using an element
     * @param {Function} fn Passed the created element and returns a boolean result
     */
    function assert(fn) {
      var el = document.createElement("fieldset");
      try {
        return !!fn(el);
      } catch (e) {
        return false;
      } finally {
        // Remove from its parent by default
        if (el.parentNode) {
          el.parentNode.removeChild(el);
        }

        // release memory in IE
        el = null;
      }
    }

    /**
     * Returns a function to use in pseudos for input types
     * @param {String} type
     */
    function createInputPseudo(type) {
      return function (elem) {
        return nodeName(elem, "input") && elem.type === type;
      };
    }

    /**
     * Returns a function to use in pseudos for buttons
     * @param {String} type
     */
    function createButtonPseudo(type) {
      return function (elem) {
        return (nodeName(elem, "input") || nodeName(elem, "button")) && elem.type === type;
      };
    }

    /**
     * Returns a function to use in pseudos for :enabled/:disabled
     * @param {Boolean} disabled true for :disabled; false for :enabled
     */
    function createDisabledPseudo(disabled) {
      // Known :disabled false positives: fieldset[disabled] > legend:nth-of-type(n+2) :can-disable
      return function (elem) {
        // Only certain elements can match :enabled or :disabled
        // https://html.spec.whatwg.org/multipage/scripting.html#selector-enabled
        // https://html.spec.whatwg.org/multipage/scripting.html#selector-disabled
        if ("form" in elem) {
          // Check for inherited disabledness on relevant non-disabled elements:
          // * listed form-associated elements in a disabled fieldset
          //   https://html.spec.whatwg.org/multipage/forms.html#category-listed
          //   https://html.spec.whatwg.org/multipage/forms.html#concept-fe-disabled
          // * option elements in a disabled optgroup
          //   https://html.spec.whatwg.org/multipage/forms.html#concept-option-disabled
          // All such elements have a "form" property.
          if (elem.parentNode && elem.disabled === false) {
            // Option elements defer to a parent optgroup if present
            if ("label" in elem) {
              if ("label" in elem.parentNode) {
                return elem.parentNode.disabled === disabled;
              } else {
                return elem.disabled === disabled;
              }
            }

            // Support: IE 6 - 11+
            // Use the isDisabled shortcut property to check for disabled fieldset ancestors
            return elem.isDisabled === disabled ||
            // Where there is no isDisabled, check manually
            elem.isDisabled !== !disabled && inDisabledFieldset(elem) === disabled;
          }
          return elem.disabled === disabled;

          // Try to winnow out elements that can't be disabled before trusting the disabled property.
          // Some victims get caught in our net (label, legend, menu, track), but it shouldn't
          // even exist on them, let alone have a boolean value.
        } else if ("label" in elem) {
          return elem.disabled === disabled;
        }

        // Remaining elements are neither :enabled nor :disabled
        return false;
      };
    }

    /**
     * Returns a function to use in pseudos for positionals
     * @param {Function} fn
     */
    function createPositionalPseudo(fn) {
      return markFunction(function (argument) {
        argument = +argument;
        return markFunction(function (seed, matches) {
          var j,
            matchIndexes = fn([], seed.length, argument),
            i = matchIndexes.length;

          // Match elements found at the specified indexes
          while (i--) {
            if (seed[j = matchIndexes[i]]) {
              seed[j] = !(matches[j] = seed[j]);
            }
          }
        });
      });
    }

    /**
     * Checks a node for validity as a jQuery selector context
     * @param {Element|Object=} context
     * @returns {Element|Object|Boolean} The input node if acceptable, otherwise a falsy value
     */
    function testContext(context) {
      return context && typeof context.getElementsByTagName !== "undefined" && context;
    }

    /**
     * Sets document-related variables once based on the current document
     * @param {Element|Object} [node] An element or document object to use to set the document
     * @returns {Object} Returns the current document
     */
    function setDocument(node) {
      var subWindow,
        doc = node ? node.ownerDocument || node : preferredDoc;

      // Return early if doc is invalid or already selected
      // Support: IE 11+, Edge 17 - 18+
      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
      // two documents; shallow comparisons work.
      // eslint-disable-next-line eqeqeq
      if (doc == document || doc.nodeType !== 9 || !doc.documentElement) {
        return document;
      }

      // Update global variables
      document = doc;
      documentElement = document.documentElement;
      documentIsHTML = !jQuery.isXMLDoc(document);

      // Support: iOS 7 only, IE 9 - 11+
      // Older browsers didn't support unprefixed `matches`.
      matches = documentElement.matches || documentElement.webkitMatchesSelector || documentElement.msMatchesSelector;

      // Support: IE 9 - 11+, Edge 12 - 18+
      // Accessing iframe documents after unload throws "permission denied" errors
      // (see trac-13936).
      // Limit the fix to IE & Edge Legacy; despite Edge 15+ implementing `matches`,
      // all IE 9+ and Edge Legacy versions implement `msMatchesSelector` as well.
      if (documentElement.msMatchesSelector &&
      // Support: IE 11+, Edge 17 - 18+
      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
      // two documents; shallow comparisons work.
      // eslint-disable-next-line eqeqeq
      preferredDoc != document && (subWindow = document.defaultView) && subWindow.top !== subWindow) {
        // Support: IE 9 - 11+, Edge 12 - 18+
        subWindow.addEventListener("unload", unloadHandler);
      }

      // Support: IE <10
      // Check if getElementById returns elements by name
      // The broken getElementById methods don't pick up programmatically-set names,
      // so use a roundabout getElementsByName test
      support.getById = assert(function (el) {
        documentElement.appendChild(el).id = jQuery.expando;
        return !document.getElementsByName || !document.getElementsByName(jQuery.expando).length;
      });

      // Support: IE 9 only
      // Check to see if it's possible to do matchesSelector
      // on a disconnected node.
      support.disconnectedMatch = assert(function (el) {
        return matches.call(el, "*");
      });

      // Support: IE 9 - 11+, Edge 12 - 18+
      // IE/Edge don't support the :scope pseudo-class.
      support.scope = assert(function () {
        return document.querySelectorAll(":scope");
      });

      // Support: Chrome 105 - 111 only, Safari 15.4 - 16.3 only
      // Make sure the `:has()` argument is parsed unforgivingly.
      // We include `*` in the test to detect buggy implementations that are
      // _selectively_ forgiving (specifically when the list includes at least
      // one valid selector).
      // Note that we treat complete lack of support for `:has()` as if it were
      // spec-compliant support, which is fine because use of `:has()` in such
      // environments will fail in the qSA path and fall back to jQuery traversal
      // anyway.
      support.cssHas = assert(function () {
        try {
          document.querySelector(":has(*,:jqfake)");
          return false;
        } catch (e) {
          return true;
        }
      });

      // ID filter and find
      if (support.getById) {
        Expr.filter.ID = function (id) {
          var attrId = id.replace(runescape, funescape);
          return function (elem) {
            return elem.getAttribute("id") === attrId;
          };
        };
        Expr.find.ID = function (id, context) {
          if (typeof context.getElementById !== "undefined" && documentIsHTML) {
            var elem = context.getElementById(id);
            return elem ? [elem] : [];
          }
        };
      } else {
        Expr.filter.ID = function (id) {
          var attrId = id.replace(runescape, funescape);
          return function (elem) {
            var node = typeof elem.getAttributeNode !== "undefined" && elem.getAttributeNode("id");
            return node && node.value === attrId;
          };
        };

        // Support: IE 6 - 7 only
        // getElementById is not reliable as a find shortcut
        Expr.find.ID = function (id, context) {
          if (typeof context.getElementById !== "undefined" && documentIsHTML) {
            var node,
              i,
              elems,
              elem = context.getElementById(id);
            if (elem) {
              // Verify the id attribute
              node = elem.getAttributeNode("id");
              if (node && node.value === id) {
                return [elem];
              }

              // Fall back on getElementsByName
              elems = context.getElementsByName(id);
              i = 0;
              while (elem = elems[i++]) {
                node = elem.getAttributeNode("id");
                if (node && node.value === id) {
                  return [elem];
                }
              }
            }
            return [];
          }
        };
      }

      // Tag
      Expr.find.TAG = function (tag, context) {
        if (typeof context.getElementsByTagName !== "undefined") {
          return context.getElementsByTagName(tag);

          // DocumentFragment nodes don't have gEBTN
        } else {
          return context.querySelectorAll(tag);
        }
      };

      // Class
      Expr.find.CLASS = function (className, context) {
        if (typeof context.getElementsByClassName !== "undefined" && documentIsHTML) {
          return context.getElementsByClassName(className);
        }
      };

      /* QSA/matchesSelector
      ---------------------------------------------------------------------- */

      // QSA and matchesSelector support

      rbuggyQSA = [];

      // Build QSA regex
      // Regex strategy adopted from Diego Perini
      assert(function (el) {
        var input;
        documentElement.appendChild(el).innerHTML = "<a id='" + expando + "' href='' disabled='disabled'></a>" + "<select id='" + expando + "-\r\\' disabled='disabled'>" + "<option selected=''></option></select>";

        // Support: iOS <=7 - 8 only
        // Boolean attributes and "value" are not treated correctly in some XML documents
        if (!el.querySelectorAll("[selected]").length) {
          rbuggyQSA.push("\\[" + whitespace + "*(?:value|" + booleans + ")");
        }

        // Support: iOS <=7 - 8 only
        if (!el.querySelectorAll("[id~=" + expando + "-]").length) {
          rbuggyQSA.push("~=");
        }

        // Support: iOS 8 only
        // https://bugs.webkit.org/show_bug.cgi?id=136851
        // In-page `selector#id sibling-combinator selector` fails
        if (!el.querySelectorAll("a#" + expando + "+*").length) {
          rbuggyQSA.push(".#.+[+~]");
        }

        // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
        // In some of the document kinds, these selectors wouldn't work natively.
        // This is probably OK but for backwards compatibility we want to maintain
        // handling them through jQuery traversal in jQuery 3.x.
        if (!el.querySelectorAll(":checked").length) {
          rbuggyQSA.push(":checked");
        }

        // Support: Windows 8 Native Apps
        // The type and name attributes are restricted during .innerHTML assignment
        input = document.createElement("input");
        input.setAttribute("type", "hidden");
        el.appendChild(input).setAttribute("name", "D");

        // Support: IE 9 - 11+
        // IE's :disabled selector does not pick up the children of disabled fieldsets
        // Support: Chrome <=105+, Firefox <=104+, Safari <=15.4+
        // In some of the document kinds, these selectors wouldn't work natively.
        // This is probably OK but for backwards compatibility we want to maintain
        // handling them through jQuery traversal in jQuery 3.x.
        documentElement.appendChild(el).disabled = true;
        if (el.querySelectorAll(":disabled").length !== 2) {
          rbuggyQSA.push(":enabled", ":disabled");
        }

        // Support: IE 11+, Edge 15 - 18+
        // IE 11/Edge don't find elements on a `[name='']` query in some cases.
        // Adding a temporary attribute to the document before the selection works
        // around the issue.
        // Interestingly, IE 10 & older don't seem to have the issue.
        input = document.createElement("input");
        input.setAttribute("name", "");
        el.appendChild(input);
        if (!el.querySelectorAll("[name='']").length) {
          rbuggyQSA.push("\\[" + whitespace + "*name" + whitespace + "*=" + whitespace + "*(?:''|\"\")");
        }
      });
      if (!support.cssHas) {
        // Support: Chrome 105 - 110+, Safari 15.4 - 16.3+
        // Our regular `try-catch` mechanism fails to detect natively-unsupported
        // pseudo-classes inside `:has()` (such as `:has(:contains("Foo"))`)
        // in browsers that parse the `:has()` argument as a forgiving selector list.
        // https://drafts.csswg.org/selectors/#relational now requires the argument
        // to be parsed unforgivingly, but browsers have not yet fully adjusted.
        rbuggyQSA.push(":has");
      }
      rbuggyQSA = rbuggyQSA.length && new RegExp(rbuggyQSA.join("|"));

      /* Sorting
      ---------------------------------------------------------------------- */

      // Document order sorting
      sortOrder = function sortOrder(a, b) {
        // Flag for duplicate removal
        if (a === b) {
          hasDuplicate = true;
          return 0;
        }

        // Sort on method existence if only one input has compareDocumentPosition
        var compare = !a.compareDocumentPosition - !b.compareDocumentPosition;
        if (compare) {
          return compare;
        }

        // Calculate position if both inputs belong to the same document
        // Support: IE 11+, Edge 17 - 18+
        // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
        // two documents; shallow comparisons work.
        // eslint-disable-next-line eqeqeq
        compare = (a.ownerDocument || a) == (b.ownerDocument || b) ? a.compareDocumentPosition(b) :
        // Otherwise we know they are disconnected
        1;

        // Disconnected nodes
        if (compare & 1 || !support.sortDetached && b.compareDocumentPosition(a) === compare) {
          // Choose the first element that is related to our preferred document
          // Support: IE 11+, Edge 17 - 18+
          // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
          // two documents; shallow comparisons work.
          // eslint-disable-next-line eqeqeq
          if (a === document || a.ownerDocument == preferredDoc && find.contains(preferredDoc, a)) {
            return -1;
          }

          // Support: IE 11+, Edge 17 - 18+
          // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
          // two documents; shallow comparisons work.
          // eslint-disable-next-line eqeqeq
          if (b === document || b.ownerDocument == preferredDoc && find.contains(preferredDoc, b)) {
            return 1;
          }

          // Maintain original order
          return sortInput ? indexOf.call(sortInput, a) - indexOf.call(sortInput, b) : 0;
        }
        return compare & 4 ? -1 : 1;
      };
      return document;
    }
    find.matches = function (expr, elements) {
      return find(expr, null, null, elements);
    };
    find.matchesSelector = function (elem, expr) {
      setDocument(elem);
      if (documentIsHTML && !nonnativeSelectorCache[expr + " "] && (!rbuggyQSA || !rbuggyQSA.test(expr))) {
        try {
          var ret = matches.call(elem, expr);

          // IE 9's matchesSelector returns false on disconnected nodes
          if (ret || support.disconnectedMatch ||
          // As well, disconnected nodes are said to be in a document
          // fragment in IE 9
          elem.document && elem.document.nodeType !== 11) {
            return ret;
          }
        } catch (e) {
          nonnativeSelectorCache(expr, true);
        }
      }
      return find(expr, document, null, [elem]).length > 0;
    };
    find.contains = function (context, elem) {
      // Set document vars if needed
      // Support: IE 11+, Edge 17 - 18+
      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
      // two documents; shallow comparisons work.
      // eslint-disable-next-line eqeqeq
      if ((context.ownerDocument || context) != document) {
        setDocument(context);
      }
      return jQuery.contains(context, elem);
    };
    find.attr = function (elem, name) {
      // Set document vars if needed
      // Support: IE 11+, Edge 17 - 18+
      // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
      // two documents; shallow comparisons work.
      // eslint-disable-next-line eqeqeq
      if ((elem.ownerDocument || elem) != document) {
        setDocument(elem);
      }
      var fn = Expr.attrHandle[name.toLowerCase()],
        // Don't get fooled by Object.prototype properties (see trac-13807)
        val = fn && hasOwn.call(Expr.attrHandle, name.toLowerCase()) ? fn(elem, name, !documentIsHTML) : undefined;
      if (val !== undefined) {
        return val;
      }
      return elem.getAttribute(name);
    };
    find.error = function (msg) {
      throw new Error("Syntax error, unrecognized expression: " + msg);
    };

    /**
     * Document sorting and removing duplicates
     * @param {ArrayLike} results
     */
    jQuery.uniqueSort = function (results) {
      var elem,
        duplicates = [],
        j = 0,
        i = 0;

      // Unless we *know* we can detect duplicates, assume their presence
      //
      // Support: Android <=4.0+
      // Testing for detecting duplicates is unpredictable so instead assume we can't
      // depend on duplicate detection in all browsers without a stable sort.
      hasDuplicate = !support.sortStable;
      sortInput = !support.sortStable && _slice.call(results, 0);
      sort.call(results, sortOrder);
      if (hasDuplicate) {
        while (elem = results[i++]) {
          if (elem === results[i]) {
            j = duplicates.push(i);
          }
        }
        while (j--) {
          splice.call(results, duplicates[j], 1);
        }
      }

      // Clear input after sorting to release objects
      // See https://github.com/jquery/sizzle/pull/225
      sortInput = null;
      return results;
    };
    jQuery.fn.uniqueSort = function () {
      return this.pushStack(jQuery.uniqueSort(_slice.apply(this)));
    };
    Expr = jQuery.expr = {
      // Can be adjusted by the user
      cacheLength: 50,
      createPseudo: markFunction,
      match: matchExpr,
      attrHandle: {},
      find: {},
      relative: {
        ">": {
          dir: "parentNode",
          first: true
        },
        " ": {
          dir: "parentNode"
        },
        "+": {
          dir: "previousSibling",
          first: true
        },
        "~": {
          dir: "previousSibling"
        }
      },
      preFilter: {
        ATTR: function ATTR(match) {
          match[1] = match[1].replace(runescape, funescape);

          // Move the given value to match[3] whether quoted or unquoted
          match[3] = (match[3] || match[4] || match[5] || "").replace(runescape, funescape);
          if (match[2] === "~=") {
            match[3] = " " + match[3] + " ";
          }
          return match.slice(0, 4);
        },
        CHILD: function CHILD(match) {
          /* matches from matchExpr["CHILD"]
          	1 type (only|nth|...)
          	2 what (child|of-type)
          	3 argument (even|odd|\d*|\d*n([+-]\d+)?|...)
          	4 xn-component of xn+y argument ([+-]?\d*n|)
          	5 sign of xn-component
          	6 x of xn-component
          	7 sign of y-component
          	8 y of y-component
          */
          match[1] = match[1].toLowerCase();
          if (match[1].slice(0, 3) === "nth") {
            // nth-* requires argument
            if (!match[3]) {
              find.error(match[0]);
            }

            // numeric x and y parameters for Expr.filter.CHILD
            // remember that false/true cast respectively to 0/1
            match[4] = +(match[4] ? match[5] + (match[6] || 1) : 2 * (match[3] === "even" || match[3] === "odd"));
            match[5] = +(match[7] + match[8] || match[3] === "odd");

            // other types prohibit arguments
          } else if (match[3]) {
            find.error(match[0]);
          }
          return match;
        },
        PSEUDO: function PSEUDO(match) {
          var excess,
            unquoted = !match[6] && match[2];
          if (matchExpr.CHILD.test(match[0])) {
            return null;
          }

          // Accept quoted arguments as-is
          if (match[3]) {
            match[2] = match[4] || match[5] || "";

            // Strip excess characters from unquoted arguments
          } else if (unquoted && rpseudo.test(unquoted) && (
          // Get excess from tokenize (recursively)
          excess = tokenize(unquoted, true)) && (
          // advance to the next closing parenthesis
          excess = unquoted.indexOf(")", unquoted.length - excess) - unquoted.length)) {
            // excess is a negative index
            match[0] = match[0].slice(0, excess);
            match[2] = unquoted.slice(0, excess);
          }

          // Return only captures needed by the pseudo filter method (type and argument)
          return match.slice(0, 3);
        }
      },
      filter: {
        TAG: function TAG(nodeNameSelector) {
          var expectedNodeName = nodeNameSelector.replace(runescape, funescape).toLowerCase();
          return nodeNameSelector === "*" ? function () {
            return true;
          } : function (elem) {
            return nodeName(elem, expectedNodeName);
          };
        },
        CLASS: function CLASS(className) {
          var pattern = classCache[className + " "];
          return pattern || (pattern = new RegExp("(^|" + whitespace + ")" + className + "(" + whitespace + "|$)")) && classCache(className, function (elem) {
            return pattern.test(typeof elem.className === "string" && elem.className || typeof elem.getAttribute !== "undefined" && elem.getAttribute("class") || "");
          });
        },
        ATTR: function ATTR(name, operator, check) {
          return function (elem) {
            var result = find.attr(elem, name);
            if (result == null) {
              return operator === "!=";
            }
            if (!operator) {
              return true;
            }
            result += "";
            if (operator === "=") {
              return result === check;
            }
            if (operator === "!=") {
              return result !== check;
            }
            if (operator === "^=") {
              return check && result.indexOf(check) === 0;
            }
            if (operator === "*=") {
              return check && result.indexOf(check) > -1;
            }
            if (operator === "$=") {
              return check && result.slice(-check.length) === check;
            }
            if (operator === "~=") {
              return (" " + result.replace(rwhitespace, " ") + " ").indexOf(check) > -1;
            }
            if (operator === "|=") {
              return result === check || result.slice(0, check.length + 1) === check + "-";
            }
            return false;
          };
        },
        CHILD: function CHILD(type, what, _argument, first, last) {
          var simple = type.slice(0, 3) !== "nth",
            forward = type.slice(-4) !== "last",
            ofType = what === "of-type";
          return first === 1 && last === 0 ?
          // Shortcut for :nth-*(n)
          function (elem) {
            return !!elem.parentNode;
          } : function (elem, _context, xml) {
            var cache,
              outerCache,
              node,
              nodeIndex,
              start,
              dir = simple !== forward ? "nextSibling" : "previousSibling",
              parent = elem.parentNode,
              name = ofType && elem.nodeName.toLowerCase(),
              useCache = !xml && !ofType,
              diff = false;
            if (parent) {
              // :(first|last|only)-(child|of-type)
              if (simple) {
                while (dir) {
                  node = elem;
                  while (node = node[dir]) {
                    if (ofType ? nodeName(node, name) : node.nodeType === 1) {
                      return false;
                    }
                  }

                  // Reverse direction for :only-* (if we haven't yet done so)
                  start = dir = type === "only" && !start && "nextSibling";
                }
                return true;
              }
              start = [forward ? parent.firstChild : parent.lastChild];

              // non-xml :nth-child(...) stores cache data on `parent`
              if (forward && useCache) {
                // Seek `elem` from a previously-cached index
                outerCache = parent[expando] || (parent[expando] = {});
                cache = outerCache[type] || [];
                nodeIndex = cache[0] === dirruns && cache[1];
                diff = nodeIndex && cache[2];
                node = nodeIndex && parent.childNodes[nodeIndex];
                while (node = ++nodeIndex && node && node[dir] || (
                // Fallback to seeking `elem` from the start
                diff = nodeIndex = 0) || start.pop()) {
                  // When found, cache indexes on `parent` and break
                  if (node.nodeType === 1 && ++diff && node === elem) {
                    outerCache[type] = [dirruns, nodeIndex, diff];
                    break;
                  }
                }
              } else {
                // Use previously-cached element index if available
                if (useCache) {
                  outerCache = elem[expando] || (elem[expando] = {});
                  cache = outerCache[type] || [];
                  nodeIndex = cache[0] === dirruns && cache[1];
                  diff = nodeIndex;
                }

                // xml :nth-child(...)
                // or :nth-last-child(...) or :nth(-last)?-of-type(...)
                if (diff === false) {
                  // Use the same loop as above to seek `elem` from the start
                  while (node = ++nodeIndex && node && node[dir] || (diff = nodeIndex = 0) || start.pop()) {
                    if ((ofType ? nodeName(node, name) : node.nodeType === 1) && ++diff) {
                      // Cache the index of each encountered element
                      if (useCache) {
                        outerCache = node[expando] || (node[expando] = {});
                        outerCache[type] = [dirruns, diff];
                      }
                      if (node === elem) {
                        break;
                      }
                    }
                  }
                }
              }

              // Incorporate the offset, then check against cycle size
              diff -= last;
              return diff === first || diff % first === 0 && diff / first >= 0;
            }
          };
        },
        PSEUDO: function PSEUDO(pseudo, argument) {
          // pseudo-class names are case-insensitive
          // https://www.w3.org/TR/selectors/#pseudo-classes
          // Prioritize by case sensitivity in case custom pseudos are added with uppercase letters
          // Remember that setFilters inherits from pseudos
          var args,
            fn = Expr.pseudos[pseudo] || Expr.setFilters[pseudo.toLowerCase()] || find.error("unsupported pseudo: " + pseudo);

          // The user may use createPseudo to indicate that
          // arguments are needed to create the filter function
          // just as jQuery does
          if (fn[expando]) {
            return fn(argument);
          }

          // But maintain support for old signatures
          if (fn.length > 1) {
            args = [pseudo, pseudo, "", argument];
            return Expr.setFilters.hasOwnProperty(pseudo.toLowerCase()) ? markFunction(function (seed, matches) {
              var idx,
                matched = fn(seed, argument),
                i = matched.length;
              while (i--) {
                idx = indexOf.call(seed, matched[i]);
                seed[idx] = !(matches[idx] = matched[i]);
              }
            }) : function (elem) {
              return fn(elem, 0, args);
            };
          }
          return fn;
        }
      },
      pseudos: {
        // Potentially complex pseudos
        not: markFunction(function (selector) {
          // Trim the selector passed to compile
          // to avoid treating leading and trailing
          // spaces as combinators
          var input = [],
            results = [],
            matcher = compile(selector.replace(rtrimCSS, "$1"));
          return matcher[expando] ? markFunction(function (seed, matches, _context, xml) {
            var elem,
              unmatched = matcher(seed, null, xml, []),
              i = seed.length;

            // Match elements unmatched by `matcher`
            while (i--) {
              if (elem = unmatched[i]) {
                seed[i] = !(matches[i] = elem);
              }
            }
          }) : function (elem, _context, xml) {
            input[0] = elem;
            matcher(input, null, xml, results);

            // Don't keep the element
            // (see https://github.com/jquery/sizzle/issues/299)
            input[0] = null;
            return !results.pop();
          };
        }),
        has: markFunction(function (selector) {
          return function (elem) {
            return find(selector, elem).length > 0;
          };
        }),
        contains: markFunction(function (text) {
          text = text.replace(runescape, funescape);
          return function (elem) {
            return (elem.textContent || jQuery.text(elem)).indexOf(text) > -1;
          };
        }),
        // "Whether an element is represented by a :lang() selector
        // is based solely on the element's language value
        // being equal to the identifier C,
        // or beginning with the identifier C immediately followed by "-".
        // The matching of C against the element's language value is performed case-insensitively.
        // The identifier C does not have to be a valid language name."
        // https://www.w3.org/TR/selectors/#lang-pseudo
        lang: markFunction(function (lang) {
          // lang value must be a valid identifier
          if (!ridentifier.test(lang || "")) {
            find.error("unsupported lang: " + lang);
          }
          lang = lang.replace(runescape, funescape).toLowerCase();
          return function (elem) {
            var elemLang;
            do {
              if (elemLang = documentIsHTML ? elem.lang : elem.getAttribute("xml:lang") || elem.getAttribute("lang")) {
                elemLang = elemLang.toLowerCase();
                return elemLang === lang || elemLang.indexOf(lang + "-") === 0;
              }
            } while ((elem = elem.parentNode) && elem.nodeType === 1);
            return false;
          };
        }),
        // Miscellaneous
        target: function target(elem) {
          var hash = window.location && window.location.hash;
          return hash && hash.slice(1) === elem.id;
        },
        root: function root(elem) {
          return elem === documentElement;
        },
        focus: function focus(elem) {
          return elem === safeActiveElement() && document.hasFocus() && !!(elem.type || elem.href || ~elem.tabIndex);
        },
        // Boolean properties
        enabled: createDisabledPseudo(false),
        disabled: createDisabledPseudo(true),
        checked: function checked(elem) {
          // In CSS3, :checked should return both checked and selected elements
          // https://www.w3.org/TR/2011/REC-css3-selectors-20110929/#checked
          return nodeName(elem, "input") && !!elem.checked || nodeName(elem, "option") && !!elem.selected;
        },
        selected: function selected(elem) {
          // Support: IE <=11+
          // Accessing the selectedIndex property
          // forces the browser to treat the default option as
          // selected when in an optgroup.
          if (elem.parentNode) {
            // eslint-disable-next-line no-unused-expressions
            elem.parentNode.selectedIndex;
          }
          return elem.selected === true;
        },
        // Contents
        empty: function empty(elem) {
          // https://www.w3.org/TR/selectors/#empty-pseudo
          // :empty is negated by element (1) or content nodes (text: 3; cdata: 4; entity ref: 5),
          //   but not by others (comment: 8; processing instruction: 7; etc.)
          // nodeType < 6 works because attributes (2) do not appear as children
          for (elem = elem.firstChild; elem; elem = elem.nextSibling) {
            if (elem.nodeType < 6) {
              return false;
            }
          }
          return true;
        },
        parent: function parent(elem) {
          return !Expr.pseudos.empty(elem);
        },
        // Element/input types
        header: function header(elem) {
          return rheader.test(elem.nodeName);
        },
        input: function input(elem) {
          return rinputs.test(elem.nodeName);
        },
        button: function button(elem) {
          return nodeName(elem, "input") && elem.type === "button" || nodeName(elem, "button");
        },
        text: function text(elem) {
          var attr;
          return nodeName(elem, "input") && elem.type === "text" && (
          // Support: IE <10 only
          // New HTML5 attribute values (e.g., "search") appear
          // with elem.type === "text"
          (attr = elem.getAttribute("type")) == null || attr.toLowerCase() === "text");
        },
        // Position-in-collection
        first: createPositionalPseudo(function () {
          return [0];
        }),
        last: createPositionalPseudo(function (_matchIndexes, length) {
          return [length - 1];
        }),
        eq: createPositionalPseudo(function (_matchIndexes, length, argument) {
          return [argument < 0 ? argument + length : argument];
        }),
        even: createPositionalPseudo(function (matchIndexes, length) {
          var i = 0;
          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        odd: createPositionalPseudo(function (matchIndexes, length) {
          var i = 1;
          for (; i < length; i += 2) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        lt: createPositionalPseudo(function (matchIndexes, length, argument) {
          var i;
          if (argument < 0) {
            i = argument + length;
          } else if (argument > length) {
            i = length;
          } else {
            i = argument;
          }
          for (; --i >= 0;) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        }),
        gt: createPositionalPseudo(function (matchIndexes, length, argument) {
          var i = argument < 0 ? argument + length : argument;
          for (; ++i < length;) {
            matchIndexes.push(i);
          }
          return matchIndexes;
        })
      }
    };
    Expr.pseudos.nth = Expr.pseudos.eq;

    // Add button/input type pseudos
    for (i in {
      radio: true,
      checkbox: true,
      file: true,
      password: true,
      image: true
    }) {
      Expr.pseudos[i] = createInputPseudo(i);
    }
    for (i in {
      submit: true,
      reset: true
    }) {
      Expr.pseudos[i] = createButtonPseudo(i);
    }

    // Easy API for creating new setFilters
    function setFilters() {}
    setFilters.prototype = Expr.filters = Expr.pseudos;
    Expr.setFilters = new setFilters();
    function tokenize(selector, parseOnly) {
      var matched,
        match,
        tokens,
        type,
        soFar,
        groups,
        preFilters,
        cached = tokenCache[selector + " "];
      if (cached) {
        return parseOnly ? 0 : cached.slice(0);
      }
      soFar = selector;
      groups = [];
      preFilters = Expr.preFilter;
      while (soFar) {
        // Comma and first run
        if (!matched || (match = rcomma.exec(soFar))) {
          if (match) {
            // Don't consume trailing commas as valid
            soFar = soFar.slice(match[0].length) || soFar;
          }
          groups.push(tokens = []);
        }
        matched = false;

        // Combinators
        if (match = rleadingCombinator.exec(soFar)) {
          matched = match.shift();
          tokens.push({
            value: matched,
            // Cast descendant combinators to space
            type: match[0].replace(rtrimCSS, " ")
          });
          soFar = soFar.slice(matched.length);
        }

        // Filters
        for (type in Expr.filter) {
          if ((match = matchExpr[type].exec(soFar)) && (!preFilters[type] || (match = preFilters[type](match)))) {
            matched = match.shift();
            tokens.push({
              value: matched,
              type: type,
              matches: match
            });
            soFar = soFar.slice(matched.length);
          }
        }
        if (!matched) {
          break;
        }
      }

      // Return the length of the invalid excess
      // if we're just parsing
      // Otherwise, throw an error or return tokens
      if (parseOnly) {
        return soFar.length;
      }
      return soFar ? find.error(selector) :
      // Cache the tokens
      tokenCache(selector, groups).slice(0);
    }
    function toSelector(tokens) {
      var i = 0,
        len = tokens.length,
        selector = "";
      for (; i < len; i++) {
        selector += tokens[i].value;
      }
      return selector;
    }
    function addCombinator(matcher, combinator, base) {
      var dir = combinator.dir,
        skip = combinator.next,
        key = skip || dir,
        checkNonElements = base && key === "parentNode",
        doneName = done++;
      return combinator.first ?
      // Check against closest ancestor/preceding element
      function (elem, context, xml) {
        while (elem = elem[dir]) {
          if (elem.nodeType === 1 || checkNonElements) {
            return matcher(elem, context, xml);
          }
        }
        return false;
      } :
      // Check against all ancestor/preceding elements
      function (elem, context, xml) {
        var oldCache,
          outerCache,
          newCache = [dirruns, doneName];

        // We can't set arbitrary data on XML nodes, so they don't benefit from combinator caching
        if (xml) {
          while (elem = elem[dir]) {
            if (elem.nodeType === 1 || checkNonElements) {
              if (matcher(elem, context, xml)) {
                return true;
              }
            }
          }
        } else {
          while (elem = elem[dir]) {
            if (elem.nodeType === 1 || checkNonElements) {
              outerCache = elem[expando] || (elem[expando] = {});
              if (skip && nodeName(elem, skip)) {
                elem = elem[dir] || elem;
              } else if ((oldCache = outerCache[key]) && oldCache[0] === dirruns && oldCache[1] === doneName) {
                // Assign to newCache so results back-propagate to previous elements
                return newCache[2] = oldCache[2];
              } else {
                // Reuse newcache so results back-propagate to previous elements
                outerCache[key] = newCache;

                // A match means we're done; a fail means we have to keep checking
                if (newCache[2] = matcher(elem, context, xml)) {
                  return true;
                }
              }
            }
          }
        }
        return false;
      };
    }
    function elementMatcher(matchers) {
      return matchers.length > 1 ? function (elem, context, xml) {
        var i = matchers.length;
        while (i--) {
          if (!matchers[i](elem, context, xml)) {
            return false;
          }
        }
        return true;
      } : matchers[0];
    }
    function multipleContexts(selector, contexts, results) {
      var i = 0,
        len = contexts.length;
      for (; i < len; i++) {
        find(selector, contexts[i], results);
      }
      return results;
    }
    function condense(unmatched, map, filter, context, xml) {
      var elem,
        newUnmatched = [],
        i = 0,
        len = unmatched.length,
        mapped = map != null;
      for (; i < len; i++) {
        if (elem = unmatched[i]) {
          if (!filter || filter(elem, context, xml)) {
            newUnmatched.push(elem);
            if (mapped) {
              map.push(i);
            }
          }
        }
      }
      return newUnmatched;
    }
    function setMatcher(preFilter, selector, matcher, postFilter, postFinder, postSelector) {
      if (postFilter && !postFilter[expando]) {
        postFilter = setMatcher(postFilter);
      }
      if (postFinder && !postFinder[expando]) {
        postFinder = setMatcher(postFinder, postSelector);
      }
      return markFunction(function (seed, results, context, xml) {
        var temp,
          i,
          elem,
          matcherOut,
          preMap = [],
          postMap = [],
          preexisting = results.length,
          // Get initial elements from seed or context
          elems = seed || multipleContexts(selector || "*", context.nodeType ? [context] : context, []),
          // Prefilter to get matcher input, preserving a map for seed-results synchronization
          matcherIn = preFilter && (seed || !selector) ? condense(elems, preMap, preFilter, context, xml) : elems;
        if (matcher) {
          // If we have a postFinder, or filtered seed, or non-seed postFilter
          // or preexisting results,
          matcherOut = postFinder || (seed ? preFilter : preexisting || postFilter) ?
          // ...intermediate processing is necessary
          [] :
          // ...otherwise use results directly
          results;

          // Find primary matches
          matcher(matcherIn, matcherOut, context, xml);
        } else {
          matcherOut = matcherIn;
        }

        // Apply postFilter
        if (postFilter) {
          temp = condense(matcherOut, postMap);
          postFilter(temp, [], context, xml);

          // Un-match failing elements by moving them back to matcherIn
          i = temp.length;
          while (i--) {
            if (elem = temp[i]) {
              matcherOut[postMap[i]] = !(matcherIn[postMap[i]] = elem);
            }
          }
        }
        if (seed) {
          if (postFinder || preFilter) {
            if (postFinder) {
              // Get the final matcherOut by condensing this intermediate into postFinder contexts
              temp = [];
              i = matcherOut.length;
              while (i--) {
                if (elem = matcherOut[i]) {
                  // Restore matcherIn since elem is not yet a final match
                  temp.push(matcherIn[i] = elem);
                }
              }
              postFinder(null, matcherOut = [], temp, xml);
            }

            // Move matched elements from seed to results to keep them synchronized
            i = matcherOut.length;
            while (i--) {
              if ((elem = matcherOut[i]) && (temp = postFinder ? indexOf.call(seed, elem) : preMap[i]) > -1) {
                seed[temp] = !(results[temp] = elem);
              }
            }
          }

          // Add elements to results, through postFinder if defined
        } else {
          matcherOut = condense(matcherOut === results ? matcherOut.splice(preexisting, matcherOut.length) : matcherOut);
          if (postFinder) {
            postFinder(null, results, matcherOut, xml);
          } else {
            push.apply(results, matcherOut);
          }
        }
      });
    }
    function matcherFromTokens(tokens) {
      var checkContext,
        matcher,
        j,
        len = tokens.length,
        leadingRelative = Expr.relative[tokens[0].type],
        implicitRelative = leadingRelative || Expr.relative[" "],
        i = leadingRelative ? 1 : 0,
        // The foundational matcher ensures that elements are reachable from top-level context(s)
        matchContext = addCombinator(function (elem) {
          return elem === checkContext;
        }, implicitRelative, true),
        matchAnyContext = addCombinator(function (elem) {
          return indexOf.call(checkContext, elem) > -1;
        }, implicitRelative, true),
        matchers = [function (elem, context, xml) {
          // Support: IE 11+, Edge 17 - 18+
          // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
          // two documents; shallow comparisons work.
          // eslint-disable-next-line eqeqeq
          var ret = !leadingRelative && (xml || context != outermostContext) || ((checkContext = context).nodeType ? matchContext(elem, context, xml) : matchAnyContext(elem, context, xml));

          // Avoid hanging onto element
          // (see https://github.com/jquery/sizzle/issues/299)
          checkContext = null;
          return ret;
        }];
      for (; i < len; i++) {
        if (matcher = Expr.relative[tokens[i].type]) {
          matchers = [addCombinator(elementMatcher(matchers), matcher)];
        } else {
          matcher = Expr.filter[tokens[i].type].apply(null, tokens[i].matches);

          // Return special upon seeing a positional matcher
          if (matcher[expando]) {
            // Find the next relative operator (if any) for proper handling
            j = ++i;
            for (; j < len; j++) {
              if (Expr.relative[tokens[j].type]) {
                break;
              }
            }
            return setMatcher(i > 1 && elementMatcher(matchers), i > 1 && toSelector(
            // If the preceding token was a descendant combinator, insert an implicit any-element `*`
            tokens.slice(0, i - 1).concat({
              value: tokens[i - 2].type === " " ? "*" : ""
            })).replace(rtrimCSS, "$1"), matcher, i < j && matcherFromTokens(tokens.slice(i, j)), j < len && matcherFromTokens(tokens = tokens.slice(j)), j < len && toSelector(tokens));
          }
          matchers.push(matcher);
        }
      }
      return elementMatcher(matchers);
    }
    function matcherFromGroupMatchers(elementMatchers, setMatchers) {
      var bySet = setMatchers.length > 0,
        byElement = elementMatchers.length > 0,
        superMatcher = function superMatcher(seed, context, xml, results, outermost) {
          var elem,
            j,
            matcher,
            matchedCount = 0,
            i = "0",
            unmatched = seed && [],
            setMatched = [],
            contextBackup = outermostContext,
            // We must always have either seed elements or outermost context
            elems = seed || byElement && Expr.find.TAG("*", outermost),
            // Use integer dirruns iff this is the outermost matcher
            dirrunsUnique = dirruns += contextBackup == null ? 1 : Math.random() || 0.1,
            len = elems.length;
          if (outermost) {
            // Support: IE 11+, Edge 17 - 18+
            // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
            // two documents; shallow comparisons work.
            // eslint-disable-next-line eqeqeq
            outermostContext = context == document || context || outermost;
          }

          // Add elements passing elementMatchers directly to results
          // Support: iOS <=7 - 9 only
          // Tolerate NodeList properties (IE: "length"; Safari: <number>) matching
          // elements by id. (see trac-14142)
          for (; i !== len && (elem = elems[i]) != null; i++) {
            if (byElement && elem) {
              j = 0;

              // Support: IE 11+, Edge 17 - 18+
              // IE/Edge sometimes throw a "Permission denied" error when strict-comparing
              // two documents; shallow comparisons work.
              // eslint-disable-next-line eqeqeq
              if (!context && elem.ownerDocument != document) {
                setDocument(elem);
                xml = !documentIsHTML;
              }
              while (matcher = elementMatchers[j++]) {
                if (matcher(elem, context || document, xml)) {
                  push.call(results, elem);
                  break;
                }
              }
              if (outermost) {
                dirruns = dirrunsUnique;
              }
            }

            // Track unmatched elements for set filters
            if (bySet) {
              // They will have gone through all possible matchers
              if (elem = !matcher && elem) {
                matchedCount--;
              }

              // Lengthen the array for every element, matched or not
              if (seed) {
                unmatched.push(elem);
              }
            }
          }

          // `i` is now the count of elements visited above, and adding it to `matchedCount`
          // makes the latter nonnegative.
          matchedCount += i;

          // Apply set filters to unmatched elements
          // NOTE: This can be skipped if there are no unmatched elements (i.e., `matchedCount`
          // equals `i`), unless we didn't visit _any_ elements in the above loop because we have
          // no element matchers and no seed.
          // Incrementing an initially-string "0" `i` allows `i` to remain a string only in that
          // case, which will result in a "00" `matchedCount` that differs from `i` but is also
          // numerically zero.
          if (bySet && i !== matchedCount) {
            j = 0;
            while (matcher = setMatchers[j++]) {
              matcher(unmatched, setMatched, context, xml);
            }
            if (seed) {
              // Reintegrate element matches to eliminate the need for sorting
              if (matchedCount > 0) {
                while (i--) {
                  if (!(unmatched[i] || setMatched[i])) {
                    setMatched[i] = pop.call(results);
                  }
                }
              }

              // Discard index placeholder values to get only actual matches
              setMatched = condense(setMatched);
            }

            // Add matches to results
            push.apply(results, setMatched);

            // Seedless set matches succeeding multiple successful matchers stipulate sorting
            if (outermost && !seed && setMatched.length > 0 && matchedCount + setMatchers.length > 1) {
              jQuery.uniqueSort(results);
            }
          }

          // Override manipulation of globals by nested matchers
          if (outermost) {
            dirruns = dirrunsUnique;
            outermostContext = contextBackup;
          }
          return unmatched;
        };
      return bySet ? markFunction(superMatcher) : superMatcher;
    }
    function compile(selector, match /* Internal Use Only */) {
      var i,
        setMatchers = [],
        elementMatchers = [],
        cached = compilerCache[selector + " "];
      if (!cached) {
        // Generate a function of recursive functions that can be used to check each element
        if (!match) {
          match = tokenize(selector);
        }
        i = match.length;
        while (i--) {
          cached = matcherFromTokens(match[i]);
          if (cached[expando]) {
            setMatchers.push(cached);
          } else {
            elementMatchers.push(cached);
          }
        }

        // Cache the compiled function
        cached = compilerCache(selector, matcherFromGroupMatchers(elementMatchers, setMatchers));

        // Save selector and tokenization
        cached.selector = selector;
      }
      return cached;
    }

    /**
     * A low-level selection function that works with jQuery's compiled
     *  selector functions
     * @param {String|Function} selector A selector or a pre-compiled
     *  selector function built with jQuery selector compile
     * @param {Element} context
     * @param {Array} [results]
     * @param {Array} [seed] A set of elements to match against
     */
    function select(selector, context, results, seed) {
      var i,
        tokens,
        token,
        type,
        find,
        compiled = typeof selector === "function" && selector,
        match = !seed && tokenize(selector = compiled.selector || selector);
      results = results || [];

      // Try to minimize operations if there is only one selector in the list and no seed
      // (the latter of which guarantees us context)
      if (match.length === 1) {
        // Reduce context if the leading compound selector is an ID
        tokens = match[0] = match[0].slice(0);
        if (tokens.length > 2 && (token = tokens[0]).type === "ID" && context.nodeType === 9 && documentIsHTML && Expr.relative[tokens[1].type]) {
          context = (Expr.find.ID(token.matches[0].replace(runescape, funescape), context) || [])[0];
          if (!context) {
            return results;

            // Precompiled matchers will still verify ancestry, so step up a level
          } else if (compiled) {
            context = context.parentNode;
          }
          selector = selector.slice(tokens.shift().value.length);
        }

        // Fetch a seed set for right-to-left matching
        i = matchExpr.needsContext.test(selector) ? 0 : tokens.length;
        while (i--) {
          token = tokens[i];

          // Abort if we hit a combinator
          if (Expr.relative[type = token.type]) {
            break;
          }
          if (find = Expr.find[type]) {
            // Search, expanding context for leading sibling combinators
            if (seed = find(token.matches[0].replace(runescape, funescape), rsibling.test(tokens[0].type) && testContext(context.parentNode) || context)) {
              // If seed is empty or no tokens remain, we can return early
              tokens.splice(i, 1);
              selector = seed.length && toSelector(tokens);
              if (!selector) {
                push.apply(results, seed);
                return results;
              }
              break;
            }
          }
        }
      }

      // Compile and execute a filtering function if one is not provided
      // Provide `match` to avoid retokenization if we modified the selector above
      (compiled || compile(selector, match))(seed, context, !documentIsHTML, results, !context || rsibling.test(selector) && testContext(context.parentNode) || context);
      return results;
    }

    // One-time assignments

    // Support: Android <=4.0 - 4.1+
    // Sort stability
    support.sortStable = expando.split("").sort(sortOrder).join("") === expando;

    // Initialize against the default document
    setDocument();

    // Support: Android <=4.0 - 4.1+
    // Detached nodes confoundingly follow *each other*
    support.sortDetached = assert(function (el) {
      // Should return 1, but returns 4 (following)
      return el.compareDocumentPosition(document.createElement("fieldset")) & 1;
    });
    jQuery.find = find;

    // Deprecated
    jQuery.expr[":"] = jQuery.expr.pseudos;
    jQuery.unique = jQuery.uniqueSort;

    // These have always been private, but they used to be documented as part of
    // Sizzle so let's maintain them for now for backwards compatibility purposes.
    find.compile = compile;
    find.select = select;
    find.setDocument = setDocument;
    find.tokenize = tokenize;
    find.escape = jQuery.escapeSelector;
    find.getText = jQuery.text;
    find.isXML = jQuery.isXMLDoc;
    find.selectors = jQuery.expr;
    find.support = jQuery.support;
    find.uniqueSort = jQuery.uniqueSort;

    /* eslint-enable */
  })();
  var dir = function dir(elem, _dir, until) {
    var matched = [],
      truncate = until !== undefined;
    while ((elem = elem[_dir]) && elem.nodeType !== 9) {
      if (elem.nodeType === 1) {
        if (truncate && jQuery(elem).is(until)) {
          break;
        }
        matched.push(elem);
      }
    }
    return matched;
  };
  var _siblings = function siblings(n, elem) {
    var matched = [];
    for (; n; n = n.nextSibling) {
      if (n.nodeType === 1 && n !== elem) {
        matched.push(n);
      }
    }
    return matched;
  };
  var rneedsContext = jQuery.expr.match.needsContext;
  var rsingleTag = /^<([a-z][^\/\0>:\x20\t\r\n\f]*)[\x20\t\r\n\f]*\/?>(?:<\/\1>|)$/i;

  // Implement the identical functionality for filter and not
  function winnow(elements, qualifier, not) {
    if (isFunction(qualifier)) {
      return jQuery.grep(elements, function (elem, i) {
        return !!qualifier.call(elem, i, elem) !== not;
      });
    }

    // Single element
    if (qualifier.nodeType) {
      return jQuery.grep(elements, function (elem) {
        return elem === qualifier !== not;
      });
    }

    // Arraylike of elements (jQuery, arguments, Array)
    if (typeof qualifier !== "string") {
      return jQuery.grep(elements, function (elem) {
        return indexOf.call(qualifier, elem) > -1 !== not;
      });
    }

    // Filtered directly for both simple and complex selectors
    return jQuery.filter(qualifier, elements, not);
  }
  jQuery.filter = function (expr, elems, not) {
    var elem = elems[0];
    if (not) {
      expr = ":not(" + expr + ")";
    }
    if (elems.length === 1 && elem.nodeType === 1) {
      return jQuery.find.matchesSelector(elem, expr) ? [elem] : [];
    }
    return jQuery.find.matches(expr, jQuery.grep(elems, function (elem) {
      return elem.nodeType === 1;
    }));
  };
  jQuery.fn.extend({
    find: function find(selector) {
      var i,
        ret,
        len = this.length,
        self = this;
      if (typeof selector !== "string") {
        return this.pushStack(jQuery(selector).filter(function () {
          for (i = 0; i < len; i++) {
            if (jQuery.contains(self[i], this)) {
              return true;
            }
          }
        }));
      }
      ret = this.pushStack([]);
      for (i = 0; i < len; i++) {
        jQuery.find(selector, self[i], ret);
      }
      return len > 1 ? jQuery.uniqueSort(ret) : ret;
    },
    filter: function filter(selector) {
      return this.pushStack(winnow(this, selector || [], false));
    },
    not: function not(selector) {
      return this.pushStack(winnow(this, selector || [], true));
    },
    is: function is(selector) {
      return !!winnow(this,
      // If this is a positional/relative selector, check membership in the returned set
      // so $("p:first").is("p:last") won't return true for a doc with two "p".
      typeof selector === "string" && rneedsContext.test(selector) ? jQuery(selector) : selector || [], false).length;
    }
  });

  // Initialize a jQuery object

  // A central reference to the root jQuery(document)
  var rootjQuery,
    // A simple way to check for HTML strings
    // Prioritize #id over <tag> to avoid XSS via location.hash (trac-9521)
    // Strict HTML recognition (trac-11290: must start with <)
    // Shortcut simple #id case for speed
    rquickExpr = /^(?:\s*(<[\w\W]+>)[^>]*|#([\w-]+))$/,
    init = jQuery.fn.init = function (selector, context, root) {
      var match, elem;

      // HANDLE: $(""), $(null), $(undefined), $(false)
      if (!selector) {
        return this;
      }

      // Method init() accepts an alternate rootjQuery
      // so migrate can support jQuery.sub (gh-2101)
      root = root || rootjQuery;

      // Handle HTML strings
      if (typeof selector === "string") {
        if (selector[0] === "<" && selector[selector.length - 1] === ">" && selector.length >= 3) {
          // Assume that strings that start and end with <> are HTML and skip the regex check
          match = [null, selector, null];
        } else {
          match = rquickExpr.exec(selector);
        }

        // Match html or make sure no context is specified for #id
        if (match && (match[1] || !context)) {
          // HANDLE: $(html) -> $(array)
          if (match[1]) {
            context = context instanceof jQuery ? context[0] : context;

            // Option to run scripts is true for back-compat
            // Intentionally let the error be thrown if parseHTML is not present
            jQuery.merge(this, jQuery.parseHTML(match[1], context && context.nodeType ? context.ownerDocument || context : document, true));

            // HANDLE: $(html, props)
            if (rsingleTag.test(match[1]) && jQuery.isPlainObject(context)) {
              for (match in context) {
                // Properties of context are called as methods if possible
                if (isFunction(this[match])) {
                  this[match](context[match]);

                  // ...and otherwise set as attributes
                } else {
                  this.attr(match, context[match]);
                }
              }
            }
            return this;

            // HANDLE: $(#id)
          } else {
            elem = document.getElementById(match[2]);
            if (elem) {
              // Inject the element directly into the jQuery object
              this[0] = elem;
              this.length = 1;
            }
            return this;
          }

          // HANDLE: $(expr, $(...))
        } else if (!context || context.jquery) {
          return (context || root).find(selector);

          // HANDLE: $(expr, context)
          // (which is just equivalent to: $(context).find(expr)
        } else {
          return this.constructor(context).find(selector);
        }

        // HANDLE: $(DOMElement)
      } else if (selector.nodeType) {
        this[0] = selector;
        this.length = 1;
        return this;

        // HANDLE: $(function)
        // Shortcut for document ready
      } else if (isFunction(selector)) {
        return root.ready !== undefined ? root.ready(selector) :
        // Execute immediately if ready is not present
        selector(jQuery);
      }
      return jQuery.makeArray(selector, this);
    };

  // Give the init function the jQuery prototype for later instantiation
  init.prototype = jQuery.fn;

  // Initialize central reference
  rootjQuery = jQuery(document);
  var rparentsprev = /^(?:parents|prev(?:Until|All))/,
    // Methods guaranteed to produce a unique set when starting from a unique set
    guaranteedUnique = {
      children: true,
      contents: true,
      next: true,
      prev: true
    };
  jQuery.fn.extend({
    has: function has(target) {
      var targets = jQuery(target, this),
        l = targets.length;
      return this.filter(function () {
        var i = 0;
        for (; i < l; i++) {
          if (jQuery.contains(this, targets[i])) {
            return true;
          }
        }
      });
    },
    closest: function closest(selectors, context) {
      var cur,
        i = 0,
        l = this.length,
        matched = [],
        targets = typeof selectors !== "string" && jQuery(selectors);

      // Positional selectors never match, since there's no _selection_ context
      if (!rneedsContext.test(selectors)) {
        for (; i < l; i++) {
          for (cur = this[i]; cur && cur !== context; cur = cur.parentNode) {
            // Always skip document fragments
            if (cur.nodeType < 11 && (targets ? targets.index(cur) > -1 :
            // Don't pass non-elements to jQuery#find
            cur.nodeType === 1 && jQuery.find.matchesSelector(cur, selectors))) {
              matched.push(cur);
              break;
            }
          }
        }
      }
      return this.pushStack(matched.length > 1 ? jQuery.uniqueSort(matched) : matched);
    },
    // Determine the position of an element within the set
    index: function index(elem) {
      // No argument, return index in parent
      if (!elem) {
        return this[0] && this[0].parentNode ? this.first().prevAll().length : -1;
      }

      // Index in selector
      if (typeof elem === "string") {
        return indexOf.call(jQuery(elem), this[0]);
      }

      // Locate the position of the desired element
      return indexOf.call(this,
      // If it receives a jQuery object, the first element is used
      elem.jquery ? elem[0] : elem);
    },
    add: function add(selector, context) {
      return this.pushStack(jQuery.uniqueSort(jQuery.merge(this.get(), jQuery(selector, context))));
    },
    addBack: function addBack(selector) {
      return this.add(selector == null ? this.prevObject : this.prevObject.filter(selector));
    }
  });
  function sibling(cur, dir) {
    while ((cur = cur[dir]) && cur.nodeType !== 1) {}
    return cur;
  }
  jQuery.each({
    parent: function parent(elem) {
      var parent = elem.parentNode;
      return parent && parent.nodeType !== 11 ? parent : null;
    },
    parents: function parents(elem) {
      return dir(elem, "parentNode");
    },
    parentsUntil: function parentsUntil(elem, _i, until) {
      return dir(elem, "parentNode", until);
    },
    next: function next(elem) {
      return sibling(elem, "nextSibling");
    },
    prev: function prev(elem) {
      return sibling(elem, "previousSibling");
    },
    nextAll: function nextAll(elem) {
      return dir(elem, "nextSibling");
    },
    prevAll: function prevAll(elem) {
      return dir(elem, "previousSibling");
    },
    nextUntil: function nextUntil(elem, _i, until) {
      return dir(elem, "nextSibling", until);
    },
    prevUntil: function prevUntil(elem, _i, until) {
      return dir(elem, "previousSibling", until);
    },
    siblings: function siblings(elem) {
      return _siblings((elem.parentNode || {}).firstChild, elem);
    },
    children: function children(elem) {
      return _siblings(elem.firstChild);
    },
    contents: function contents(elem) {
      if (elem.contentDocument != null &&
      // Support: IE 11+
      // <object> elements with no `data` attribute has an object
      // `contentDocument` with a `null` prototype.
      getProto(elem.contentDocument)) {
        return elem.contentDocument;
      }

      // Support: IE 9 - 11 only, iOS 7 only, Android Browser <=4.3 only
      // Treat the template element as a regular one in browsers that
      // don't support it.
      if (nodeName(elem, "template")) {
        elem = elem.content || elem;
      }
      return jQuery.merge([], elem.childNodes);
    }
  }, function (name, fn) {
    jQuery.fn[name] = function (until, selector) {
      var matched = jQuery.map(this, fn, until);
      if (name.slice(-5) !== "Until") {
        selector = until;
      }
      if (selector && typeof selector === "string") {
        matched = jQuery.filter(selector, matched);
      }
      if (this.length > 1) {
        // Remove duplicates
        if (!guaranteedUnique[name]) {
          jQuery.uniqueSort(matched);
        }

        // Reverse order for parents* and prev-derivatives
        if (rparentsprev.test(name)) {
          matched.reverse();
        }
      }
      return this.pushStack(matched);
    };
  });
  var rnothtmlwhite = /[^\x20\t\r\n\f]+/g;

  // Convert String-formatted options into Object-formatted ones
  function createOptions(options) {
    var object = {};
    jQuery.each(options.match(rnothtmlwhite) || [], function (_, flag) {
      object[flag] = true;
    });
    return object;
  }

  /*
   * Create a callback list using the following parameters:
   *
   *	options: an optional list of space-separated options that will change how
   *			the callback list behaves or a more traditional option object
   *
   * By default a callback list will act like an event callback list and can be
   * "fired" multiple times.
   *
   * Possible options:
   *
   *	once:			will ensure the callback list can only be fired once (like a Deferred)
   *
   *	memory:			will keep track of previous values and will call any callback added
   *					after the list has been fired right away with the latest "memorized"
   *					values (like a Deferred)
   *
   *	unique:			will ensure a callback can only be added once (no duplicate in the list)
   *
   *	stopOnFalse:	interrupt callings when a callback returns false
   *
   */
  jQuery.Callbacks = function (options) {
    // Convert options from String-formatted to Object-formatted if needed
    // (we check in cache first)
    options = typeof options === "string" ? createOptions(options) : jQuery.extend({}, options);
    var
      // Flag to know if list is currently firing
      firing,
      // Last fire value for non-forgettable lists
      memory,
      // Flag to know if list was already fired
      _fired,
      // Flag to prevent firing
      _locked,
      // Actual callback list
      list = [],
      // Queue of execution data for repeatable lists
      queue = [],
      // Index of currently firing callback (modified by add/remove as needed)
      firingIndex = -1,
      // Fire callbacks
      fire = function fire() {
        // Enforce single-firing
        _locked = _locked || options.once;

        // Execute callbacks for all pending executions,
        // respecting firingIndex overrides and runtime changes
        _fired = firing = true;
        for (; queue.length; firingIndex = -1) {
          memory = queue.shift();
          while (++firingIndex < list.length) {
            // Run callback and check for early termination
            if (list[firingIndex].apply(memory[0], memory[1]) === false && options.stopOnFalse) {
              // Jump to end and forget the data so .add doesn't re-fire
              firingIndex = list.length;
              memory = false;
            }
          }
        }

        // Forget the data if we're done with it
        if (!options.memory) {
          memory = false;
        }
        firing = false;

        // Clean up if we're done firing for good
        if (_locked) {
          // Keep an empty list if we have data for future add calls
          if (memory) {
            list = [];

            // Otherwise, this object is spent
          } else {
            list = "";
          }
        }
      },
      // Actual Callbacks object
      self = {
        // Add a callback or a collection of callbacks to the list
        add: function add() {
          if (list) {
            // If we have memory from a past run, we should fire after adding
            if (memory && !firing) {
              firingIndex = list.length - 1;
              queue.push(memory);
            }
            (function add(args) {
              jQuery.each(args, function (_, arg) {
                if (isFunction(arg)) {
                  if (!options.unique || !self.has(arg)) {
                    list.push(arg);
                  }
                } else if (arg && arg.length && toType(arg) !== "string") {
                  // Inspect recursively
                  add(arg);
                }
              });
            })(arguments);
            if (memory && !firing) {
              fire();
            }
          }
          return this;
        },
        // Remove a callback from the list
        remove: function remove() {
          jQuery.each(arguments, function (_, arg) {
            var index;
            while ((index = jQuery.inArray(arg, list, index)) > -1) {
              list.splice(index, 1);

              // Handle firing indexes
              if (index <= firingIndex) {
                firingIndex--;
              }
            }
          });
          return this;
        },
        // Check if a given callback is in the list.
        // If no argument is given, return whether or not list has callbacks attached.
        has: function has(fn) {
          return fn ? jQuery.inArray(fn, list) > -1 : list.length > 0;
        },
        // Remove all callbacks from the list
        empty: function empty() {
          if (list) {
            list = [];
          }
          return this;
        },
        // Disable .fire and .add
        // Abort any current/pending executions
        // Clear all callbacks and values
        disable: function disable() {
          _locked = queue = [];
          list = memory = "";
          return this;
        },
        disabled: function disabled() {
          return !list;
        },
        // Disable .fire
        // Also disable .add unless we have memory (since it would have no effect)
        // Abort any pending executions
        lock: function lock() {
          _locked = queue = [];
          if (!memory && !firing) {
            list = memory = "";
          }
          return this;
        },
        locked: function locked() {
          return !!_locked;
        },
        // Call all callbacks with the given context and arguments
        fireWith: function fireWith(context, args) {
          if (!_locked) {
            args = args || [];
            args = [context, args.slice ? args.slice() : args];
            queue.push(args);
            if (!firing) {
              fire();
            }
          }
          return this;
        },
        // Call all the callbacks with the given arguments
        fire: function fire() {
          self.fireWith(this, arguments);
          return this;
        },
        // To know if the callbacks have already been called at least once
        fired: function fired() {
          return !!_fired;
        }
      };
    return self;
  };
  function Identity(v) {
    return v;
  }
  function Thrower(ex) {
    throw ex;
  }
  function adoptValue(value, resolve, reject, noValue) {
    var method;
    try {
      // Check for promise aspect first to privilege synchronous behavior
      if (value && isFunction(method = value.promise)) {
        method.call(value).done(resolve).fail(reject);

        // Other thenables
      } else if (value && isFunction(method = value.then)) {
        method.call(value, resolve, reject);

        // Other non-thenables
      } else {
        // Control `resolve` arguments by letting Array#slice cast boolean `noValue` to integer:
        // * false: [ value ].slice( 0 ) => resolve( value )
        // * true: [ value ].slice( 1 ) => resolve()
        resolve.apply(undefined, [value].slice(noValue));
      }

      // For Promises/A+, convert exceptions into rejections
      // Since jQuery.when doesn't unwrap thenables, we can skip the extra checks appearing in
      // Deferred#then to conditionally suppress rejection.
    } catch (value) {
      // Support: Android 4.0 only
      // Strict mode functions invoked without .call/.apply get global-object context
      reject.apply(undefined, [value]);
    }
  }
  jQuery.extend({
    Deferred: function Deferred(func) {
      var tuples = [
        // action, add listener, callbacks,
        // ... .then handlers, argument index, [final state]
        ["notify", "progress", jQuery.Callbacks("memory"), jQuery.Callbacks("memory"), 2], ["resolve", "done", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 0, "resolved"], ["reject", "fail", jQuery.Callbacks("once memory"), jQuery.Callbacks("once memory"), 1, "rejected"]],
        _state2 = "pending",
        _promise = {
          state: function state() {
            return _state2;
          },
          always: function always() {
            deferred.done(arguments).fail(arguments);
            return this;
          },
          "catch": function _catch(fn) {
            return _promise.then(null, fn);
          },
          // Keep pipe for back-compat
          pipe: function pipe(/* fnDone, fnFail, fnProgress */
          ) {
            var fns = arguments;
            return jQuery.Deferred(function (newDefer) {
              jQuery.each(tuples, function (_i, tuple) {
                // Map tuples (progress, done, fail) to arguments (done, fail, progress)
                var fn = isFunction(fns[tuple[4]]) && fns[tuple[4]];

                // deferred.progress(function() { bind to newDefer or newDefer.notify })
                // deferred.done(function() { bind to newDefer or newDefer.resolve })
                // deferred.fail(function() { bind to newDefer or newDefer.reject })
                deferred[tuple[1]](function () {
                  var returned = fn && fn.apply(this, arguments);
                  if (returned && isFunction(returned.promise)) {
                    returned.promise().progress(newDefer.notify).done(newDefer.resolve).fail(newDefer.reject);
                  } else {
                    newDefer[tuple[0] + "With"](this, fn ? [returned] : arguments);
                  }
                });
              });
              fns = null;
            }).promise();
          },
          then: function then(onFulfilled, onRejected, onProgress) {
            var maxDepth = 0;
            function resolve(depth, deferred, handler, special) {
              return function () {
                var that = this,
                  args = arguments,
                  mightThrow = function mightThrow() {
                    var returned, then;

                    // Support: Promises/A+ section 2.3.3.3.3
                    // https://promisesaplus.com/#point-59
                    // Ignore double-resolution attempts
                    if (depth < maxDepth) {
                      return;
                    }
                    returned = handler.apply(that, args);

                    // Support: Promises/A+ section 2.3.1
                    // https://promisesaplus.com/#point-48
                    if (returned === deferred.promise()) {
                      throw new TypeError("Thenable self-resolution");
                    }

                    // Support: Promises/A+ sections 2.3.3.1, 3.5
                    // https://promisesaplus.com/#point-54
                    // https://promisesaplus.com/#point-75
                    // Retrieve `then` only once
                    then = returned && (
                    // Support: Promises/A+ section 2.3.4
                    // https://promisesaplus.com/#point-64
                    // Only check objects and functions for thenability
                    _typeof(returned) === "object" || typeof returned === "function") && returned.then;

                    // Handle a returned thenable
                    if (isFunction(then)) {
                      // Special processors (notify) just wait for resolution
                      if (special) {
                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special));

                        // Normal processors (resolve) also hook into progress
                      } else {
                        // ...and disregard older resolution values
                        maxDepth++;
                        then.call(returned, resolve(maxDepth, deferred, Identity, special), resolve(maxDepth, deferred, Thrower, special), resolve(maxDepth, deferred, Identity, deferred.notifyWith));
                      }

                      // Handle all other returned values
                    } else {
                      // Only substitute handlers pass on context
                      // and multiple values (non-spec behavior)
                      if (handler !== Identity) {
                        that = undefined;
                        args = [returned];
                      }

                      // Process the value(s)
                      // Default process is resolve
                      (special || deferred.resolveWith)(that, args);
                    }
                  },
                  // Only normal processors (resolve) catch and reject exceptions
                  process = special ? mightThrow : function () {
                    try {
                      mightThrow();
                    } catch (e) {
                      if (jQuery.Deferred.exceptionHook) {
                        jQuery.Deferred.exceptionHook(e, process.error);
                      }

                      // Support: Promises/A+ section 2.3.3.3.4.1
                      // https://promisesaplus.com/#point-61
                      // Ignore post-resolution exceptions
                      if (depth + 1 >= maxDepth) {
                        // Only substitute handlers pass on context
                        // and multiple values (non-spec behavior)
                        if (handler !== Thrower) {
                          that = undefined;
                          args = [e];
                        }
                        deferred.rejectWith(that, args);
                      }
                    }
                  };

                // Support: Promises/A+ section 2.3.3.3.1
                // https://promisesaplus.com/#point-57
                // Re-resolve promises immediately to dodge false rejection from
                // subsequent errors
                if (depth) {
                  process();
                } else {
                  // Call an optional hook to record the error, in case of exception
                  // since it's otherwise lost when execution goes async
                  if (jQuery.Deferred.getErrorHook) {
                    process.error = jQuery.Deferred.getErrorHook();

                    // The deprecated alias of the above. While the name suggests
                    // returning the stack, not an error instance, jQuery just passes
                    // it directly to `console.warn` so both will work; an instance
                    // just better cooperates with source maps.
                  } else if (jQuery.Deferred.getStackHook) {
                    process.error = jQuery.Deferred.getStackHook();
                  }
                  window.setTimeout(process);
                }
              };
            }
            return jQuery.Deferred(function (newDefer) {
              // progress_handlers.add( ... )
              tuples[0][3].add(resolve(0, newDefer, isFunction(onProgress) ? onProgress : Identity, newDefer.notifyWith));

              // fulfilled_handlers.add( ... )
              tuples[1][3].add(resolve(0, newDefer, isFunction(onFulfilled) ? onFulfilled : Identity));

              // rejected_handlers.add( ... )
              tuples[2][3].add(resolve(0, newDefer, isFunction(onRejected) ? onRejected : Thrower));
            }).promise();
          },
          // Get a promise for this deferred
          // If obj is provided, the promise aspect is added to the object
          promise: function promise(obj) {
            return obj != null ? jQuery.extend(obj, _promise) : _promise;
          }
        },
        deferred = {};

      // Add list-specific methods
      jQuery.each(tuples, function (i, tuple) {
        var list = tuple[2],
          stateString = tuple[5];

        // promise.progress = list.add
        // promise.done = list.add
        // promise.fail = list.add
        _promise[tuple[1]] = list.add;

        // Handle state
        if (stateString) {
          list.add(function () {
            // state = "resolved" (i.e., fulfilled)
            // state = "rejected"
            _state2 = stateString;
          },
          // rejected_callbacks.disable
          // fulfilled_callbacks.disable
          tuples[3 - i][2].disable,
          // rejected_handlers.disable
          // fulfilled_handlers.disable
          tuples[3 - i][3].disable,
          // progress_callbacks.lock
          tuples[0][2].lock,
          // progress_handlers.lock
          tuples[0][3].lock);
        }

        // progress_handlers.fire
        // fulfilled_handlers.fire
        // rejected_handlers.fire
        list.add(tuple[3].fire);

        // deferred.notify = function() { deferred.notifyWith(...) }
        // deferred.resolve = function() { deferred.resolveWith(...) }
        // deferred.reject = function() { deferred.rejectWith(...) }
        deferred[tuple[0]] = function () {
          deferred[tuple[0] + "With"](this === deferred ? undefined : this, arguments);
          return this;
        };

        // deferred.notifyWith = list.fireWith
        // deferred.resolveWith = list.fireWith
        // deferred.rejectWith = list.fireWith
        deferred[tuple[0] + "With"] = list.fireWith;
      });

      // Make the deferred a promise
      _promise.promise(deferred);

      // Call given func if any
      if (func) {
        func.call(deferred, deferred);
      }

      // All done!
      return deferred;
    },
    // Deferred helper
    when: function when(singleValue) {
      var
        // count of uncompleted subordinates
        remaining = arguments.length,
        // count of unprocessed arguments
        i = remaining,
        // subordinate fulfillment data
        resolveContexts = Array(i),
        resolveValues = _slice.call(arguments),
        // the primary Deferred
        primary = jQuery.Deferred(),
        // subordinate callback factory
        updateFunc = function updateFunc(i) {
          return function (value) {
            resolveContexts[i] = this;
            resolveValues[i] = arguments.length > 1 ? _slice.call(arguments) : value;
            if (! --remaining) {
              primary.resolveWith(resolveContexts, resolveValues);
            }
          };
        };

      // Single- and empty arguments are adopted like Promise.resolve
      if (remaining <= 1) {
        adoptValue(singleValue, primary.done(updateFunc(i)).resolve, primary.reject, !remaining);

        // Use .then() to unwrap secondary thenables (cf. gh-3000)
        if (primary.state() === "pending" || isFunction(resolveValues[i] && resolveValues[i].then)) {
          return primary.then();
        }
      }

      // Multiple arguments are aggregated like Promise.all array elements
      while (i--) {
        adoptValue(resolveValues[i], updateFunc(i), primary.reject);
      }
      return primary.promise();
    }
  });

  // These usually indicate a programmer mistake during development,
  // warn about them ASAP rather than swallowing them by default.
  var rerrorNames = /^(Eval|Internal|Range|Reference|Syntax|Type|URI)Error$/;

  // If `jQuery.Deferred.getErrorHook` is defined, `asyncError` is an error
  // captured before the async barrier to get the original error cause
  // which may otherwise be hidden.
  jQuery.Deferred.exceptionHook = function (error, asyncError) {
    // Support: IE 8 - 9 only
    // Console exists when dev tools are open, which can happen at any time
    if (window.console && window.console.warn && error && rerrorNames.test(error.name)) {
      window.console.warn("jQuery.Deferred exception: " + error.message, error.stack, asyncError);
    }
  };
  jQuery.readyException = function (error) {
    window.setTimeout(function () {
      throw error;
    });
  };

  // The deferred used on DOM ready
  var readyList = jQuery.Deferred();
  jQuery.fn.ready = function (fn) {
    readyList.then(fn)

    // Wrap jQuery.readyException in a function so that the lookup
    // happens at the time of error handling instead of callback
    // registration.
    ["catch"](function (error) {
      jQuery.readyException(error);
    });
    return this;
  };
  jQuery.extend({
    // Is the DOM ready to be used? Set to true once it occurs.
    isReady: false,
    // A counter to track how many items to wait for before
    // the ready event fires. See trac-6781
    readyWait: 1,
    // Handle when the DOM is ready
    ready: function ready(wait) {
      // Abort if there are pending holds or we're already ready
      if (wait === true ? --jQuery.readyWait : jQuery.isReady) {
        return;
      }

      // Remember that the DOM is ready
      jQuery.isReady = true;

      // If a normal DOM Ready event fired, decrement, and wait if need be
      if (wait !== true && --jQuery.readyWait > 0) {
        return;
      }

      // If there are functions bound, to execute
      readyList.resolveWith(document, [jQuery]);
    }
  });
  jQuery.ready.then = readyList.then;

  // The ready event handler and self cleanup method
  function completed() {
    document.removeEventListener("DOMContentLoaded", completed);
    window.removeEventListener("load", completed);
    jQuery.ready();
  }

  // Catch cases where $(document).ready() is called
  // after the browser event has already occurred.
  // Support: IE <=9 - 10 only
  // Older IE sometimes signals "interactive" too soon
  if (document.readyState === "complete" || document.readyState !== "loading" && !document.documentElement.doScroll) {
    // Handle it asynchronously to allow scripts the opportunity to delay ready
    window.setTimeout(jQuery.ready);
  } else {
    // Use the handy event callback
    document.addEventListener("DOMContentLoaded", completed);

    // A fallback to window.onload, that will always work
    window.addEventListener("load", completed);
  }

  // Multifunctional method to get and set values of a collection
  // The value/s can optionally be executed if it's a function
  var _access = function access(elems, fn, key, value, chainable, emptyGet, raw) {
    var i = 0,
      len = elems.length,
      bulk = key == null;

    // Sets many values
    if (toType(key) === "object") {
      chainable = true;
      for (i in key) {
        _access(elems, fn, i, key[i], true, emptyGet, raw);
      }

      // Sets one value
    } else if (value !== undefined) {
      chainable = true;
      if (!isFunction(value)) {
        raw = true;
      }
      if (bulk) {
        // Bulk operations run against the entire set
        if (raw) {
          fn.call(elems, value);
          fn = null;

          // ...except when executing function values
        } else {
          bulk = fn;
          fn = function fn(elem, _key, value) {
            return bulk.call(jQuery(elem), value);
          };
        }
      }
      if (fn) {
        for (; i < len; i++) {
          fn(elems[i], key, raw ? value : value.call(elems[i], i, fn(elems[i], key)));
        }
      }
    }
    if (chainable) {
      return elems;
    }

    // Gets
    if (bulk) {
      return fn.call(elems);
    }
    return len ? fn(elems[0], key) : emptyGet;
  };

  // Matches dashed string for camelizing
  var rmsPrefix = /^-ms-/,
    rdashAlpha = /-([a-z])/g;

  // Used by camelCase as callback to replace()
  function fcamelCase(_all, letter) {
    return letter.toUpperCase();
  }

  // Convert dashed to camelCase; used by the css and data modules
  // Support: IE <=9 - 11, Edge 12 - 15
  // Microsoft forgot to hump their vendor prefix (trac-9572)
  function camelCase(string) {
    return string.replace(rmsPrefix, "ms-").replace(rdashAlpha, fcamelCase);
  }
  var acceptData = function acceptData(owner) {
    // Accepts only:
    //  - Node
    //    - Node.ELEMENT_NODE
    //    - Node.DOCUMENT_NODE
    //  - Object
    //    - Any
    return owner.nodeType === 1 || owner.nodeType === 9 || !+owner.nodeType;
  };
  function Data() {
    this.expando = jQuery.expando + Data.uid++;
  }
  Data.uid = 1;
  Data.prototype = {
    cache: function cache(owner) {
      // Check if the owner object already has a cache
      var value = owner[this.expando];

      // If not, create one
      if (!value) {
        value = {};

        // We can accept data for non-element nodes in modern browsers,
        // but we should not, see trac-8335.
        // Always return an empty object.
        if (acceptData(owner)) {
          // If it is a node unlikely to be stringify-ed or looped over
          // use plain assignment
          if (owner.nodeType) {
            owner[this.expando] = value;

            // Otherwise secure it in a non-enumerable property
            // configurable must be true to allow the property to be
            // deleted when data is removed
          } else {
            Object.defineProperty(owner, this.expando, {
              value: value,
              configurable: true
            });
          }
        }
      }
      return value;
    },
    set: function set(owner, data, value) {
      var prop,
        cache = this.cache(owner);

      // Handle: [ owner, key, value ] args
      // Always use camelCase key (gh-2257)
      if (typeof data === "string") {
        cache[camelCase(data)] = value;

        // Handle: [ owner, { properties } ] args
      } else {
        // Copy the properties one-by-one to the cache object
        for (prop in data) {
          cache[camelCase(prop)] = data[prop];
        }
      }
      return cache;
    },
    get: function get(owner, key) {
      return key === undefined ? this.cache(owner) :
      // Always use camelCase key (gh-2257)
      owner[this.expando] && owner[this.expando][camelCase(key)];
    },
    access: function access(owner, key, value) {
      // In cases where either:
      //
      //   1. No key was specified
      //   2. A string key was specified, but no value provided
      //
      // Take the "read" path and allow the get method to determine
      // which value to return, respectively either:
      //
      //   1. The entire cache object
      //   2. The data stored at the key
      //
      if (key === undefined || key && typeof key === "string" && value === undefined) {
        return this.get(owner, key);
      }

      // When the key is not a string, or both a key and value
      // are specified, set or extend (existing objects) with either:
      //
      //   1. An object of properties
      //   2. A key and value
      //
      this.set(owner, key, value);

      // Since the "set" path can have two possible entry points
      // return the expected data based on which path was taken[*]
      return value !== undefined ? value : key;
    },
    remove: function remove(owner, key) {
      var i,
        cache = owner[this.expando];
      if (cache === undefined) {
        return;
      }
      if (key !== undefined) {
        // Support array or space separated string of keys
        if (Array.isArray(key)) {
          // If key is an array of keys...
          // We always set camelCase keys, so remove that.
          key = key.map(camelCase);
        } else {
          key = camelCase(key);

          // If a key with the spaces exists, use it.
          // Otherwise, create an array by matching non-whitespace
          key = key in cache ? [key] : key.match(rnothtmlwhite) || [];
        }
        i = key.length;
        while (i--) {
          delete cache[key[i]];
        }
      }

      // Remove the expando if there's no more data
      if (key === undefined || jQuery.isEmptyObject(cache)) {
        // Support: Chrome <=35 - 45
        // Webkit & Blink performance suffers when deleting properties
        // from DOM nodes, so set to undefined instead
        // https://bugs.chromium.org/p/chromium/issues/detail?id=378607 (bug restricted)
        if (owner.nodeType) {
          owner[this.expando] = undefined;
        } else {
          delete owner[this.expando];
        }
      }
    },
    hasData: function hasData(owner) {
      var cache = owner[this.expando];
      return cache !== undefined && !jQuery.isEmptyObject(cache);
    }
  };
  var dataPriv = new Data();
  var dataUser = new Data();

  //	Implementation Summary
  //
  //	1. Enforce API surface and semantic compatibility with 1.9.x branch
  //	2. Improve the module's maintainability by reducing the storage
  //		paths to a single mechanism.
  //	3. Use the same single mechanism to support "private" and "user" data.
  //	4. _Never_ expose "private" data to user code (TODO: Drop _data, _removeData)
  //	5. Avoid exposing implementation details on user objects (eg. expando properties)
  //	6. Provide a clear path for implementation upgrade to WeakMap in 2014

  var rbrace = /^(?:\{[\w\W]*\}|\[[\w\W]*\])$/,
    rmultiDash = /[A-Z]/g;
  function getData(data) {
    if (data === "true") {
      return true;
    }
    if (data === "false") {
      return false;
    }
    if (data === "null") {
      return null;
    }

    // Only convert to a number if it doesn't change the string
    if (data === +data + "") {
      return +data;
    }
    if (rbrace.test(data)) {
      return JSON.parse(data);
    }
    return data;
  }
  function dataAttr(elem, key, data) {
    var name;

    // If nothing was found internally, try to fetch any
    // data from the HTML5 data-* attribute
    if (data === undefined && elem.nodeType === 1) {
      name = "data-" + key.replace(rmultiDash, "-$&").toLowerCase();
      data = elem.getAttribute(name);
      if (typeof data === "string") {
        try {
          data = getData(data);
        } catch (e) {}

        // Make sure we set the data so it isn't changed later
        dataUser.set(elem, key, data);
      } else {
        data = undefined;
      }
    }
    return data;
  }
  jQuery.extend({
    hasData: function hasData(elem) {
      return dataUser.hasData(elem) || dataPriv.hasData(elem);
    },
    data: function data(elem, name, _data2) {
      return dataUser.access(elem, name, _data2);
    },
    removeData: function removeData(elem, name) {
      dataUser.remove(elem, name);
    },
    // TODO: Now that all calls to _data and _removeData have been replaced
    // with direct calls to dataPriv methods, these can be deprecated.
    _data: function _data(elem, name, data) {
      return dataPriv.access(elem, name, data);
    },
    _removeData: function _removeData(elem, name) {
      dataPriv.remove(elem, name);
    }
  });
  jQuery.fn.extend({
    data: function data(key, value) {
      var i,
        name,
        data,
        elem = this[0],
        attrs = elem && elem.attributes;

      // Gets all values
      if (key === undefined) {
        if (this.length) {
          data = dataUser.get(elem);
          if (elem.nodeType === 1 && !dataPriv.get(elem, "hasDataAttrs")) {
            i = attrs.length;
            while (i--) {
              // Support: IE 11 only
              // The attrs elements can be null (trac-14894)
              if (attrs[i]) {
                name = attrs[i].name;
                if (name.indexOf("data-") === 0) {
                  name = camelCase(name.slice(5));
                  dataAttr(elem, name, data[name]);
                }
              }
            }
            dataPriv.set(elem, "hasDataAttrs", true);
          }
        }
        return data;
      }

      // Sets multiple values
      if (_typeof(key) === "object") {
        return this.each(function () {
          dataUser.set(this, key);
        });
      }
      return _access(this, function (value) {
        var data;

        // The calling jQuery object (element matches) is not empty
        // (and therefore has an element appears at this[ 0 ]) and the
        // `value` parameter was not undefined. An empty jQuery object
        // will result in `undefined` for elem = this[ 0 ] which will
        // throw an exception if an attempt to read a data cache is made.
        if (elem && value === undefined) {
          // Attempt to get data from the cache
          // The key will always be camelCased in Data
          data = dataUser.get(elem, key);
          if (data !== undefined) {
            return data;
          }

          // Attempt to "discover" the data in
          // HTML5 custom data-* attrs
          data = dataAttr(elem, key);
          if (data !== undefined) {
            return data;
          }

          // We tried really hard, but the data doesn't exist.
          return;
        }

        // Set the data...
        this.each(function () {
          // We always store the camelCased key
          dataUser.set(this, key, value);
        });
      }, null, value, arguments.length > 1, null, true);
    },
    removeData: function removeData(key) {
      return this.each(function () {
        dataUser.remove(this, key);
      });
    }
  });
  jQuery.extend({
    queue: function queue(elem, type, data) {
      var queue;
      if (elem) {
        type = (type || "fx") + "queue";
        queue = dataPriv.get(elem, type);

        // Speed up dequeue by getting out quickly if this is just a lookup
        if (data) {
          if (!queue || Array.isArray(data)) {
            queue = dataPriv.access(elem, type, jQuery.makeArray(data));
          } else {
            queue.push(data);
          }
        }
        return queue || [];
      }
    },
    dequeue: function dequeue(elem, type) {
      type = type || "fx";
      var queue = jQuery.queue(elem, type),
        startLength = queue.length,
        fn = queue.shift(),
        hooks = jQuery._queueHooks(elem, type),
        next = function next() {
          jQuery.dequeue(elem, type);
        };

      // If the fx queue is dequeued, always remove the progress sentinel
      if (fn === "inprogress") {
        fn = queue.shift();
        startLength--;
      }
      if (fn) {
        // Add a progress sentinel to prevent the fx queue from being
        // automatically dequeued
        if (type === "fx") {
          queue.unshift("inprogress");
        }

        // Clear up the last queue stop function
        delete hooks.stop;
        fn.call(elem, next, hooks);
      }
      if (!startLength && hooks) {
        hooks.empty.fire();
      }
    },
    // Not public - generate a queueHooks object, or return the current one
    _queueHooks: function _queueHooks(elem, type) {
      var key = type + "queueHooks";
      return dataPriv.get(elem, key) || dataPriv.access(elem, key, {
        empty: jQuery.Callbacks("once memory").add(function () {
          dataPriv.remove(elem, [type + "queue", key]);
        })
      });
    }
  });
  jQuery.fn.extend({
    queue: function queue(type, data) {
      var setter = 2;
      if (typeof type !== "string") {
        data = type;
        type = "fx";
        setter--;
      }
      if (arguments.length < setter) {
        return jQuery.queue(this[0], type);
      }
      return data === undefined ? this : this.each(function () {
        var queue = jQuery.queue(this, type, data);

        // Ensure a hooks for this queue
        jQuery._queueHooks(this, type);
        if (type === "fx" && queue[0] !== "inprogress") {
          jQuery.dequeue(this, type);
        }
      });
    },
    dequeue: function dequeue(type) {
      return this.each(function () {
        jQuery.dequeue(this, type);
      });
    },
    clearQueue: function clearQueue(type) {
      return this.queue(type || "fx", []);
    },
    // Get a promise resolved when queues of a certain type
    // are emptied (fx is the type by default)
    promise: function promise(type, obj) {
      var tmp,
        count = 1,
        defer = jQuery.Deferred(),
        elements = this,
        i = this.length,
        resolve = function resolve() {
          if (! --count) {
            defer.resolveWith(elements, [elements]);
          }
        };
      if (typeof type !== "string") {
        obj = type;
        type = undefined;
      }
      type = type || "fx";
      while (i--) {
        tmp = dataPriv.get(elements[i], type + "queueHooks");
        if (tmp && tmp.empty) {
          count++;
          tmp.empty.add(resolve);
        }
      }
      resolve();
      return defer.promise(obj);
    }
  });
  var pnum = /[+-]?(?:\d*\.|)\d+(?:[eE][+-]?\d+|)/.source;
  var rcssNum = new RegExp("^(?:([+-])=|)(" + pnum + ")([a-z%]*)$", "i");
  var cssExpand = ["Top", "Right", "Bottom", "Left"];
  var documentElement = document.documentElement;
  var isAttached = function isAttached(elem) {
      return jQuery.contains(elem.ownerDocument, elem);
    },
    composed = {
      composed: true
    };

  // Support: IE 9 - 11+, Edge 12 - 18+, iOS 10.0 - 10.2 only
  // Check attachment across shadow DOM boundaries when possible (gh-3504)
  // Support: iOS 10.0-10.2 only
  // Early iOS 10 versions support `attachShadow` but not `getRootNode`,
  // leading to errors. We need to check for `getRootNode`.
  if (documentElement.getRootNode) {
    isAttached = function isAttached(elem) {
      return jQuery.contains(elem.ownerDocument, elem) || elem.getRootNode(composed) === elem.ownerDocument;
    };
  }
  var isHiddenWithinTree = function isHiddenWithinTree(elem, el) {
    // isHiddenWithinTree might be called from jQuery#filter function;
    // in that case, element will be second argument
    elem = el || elem;

    // Inline style trumps all
    return elem.style.display === "none" || elem.style.display === "" &&
    // Otherwise, check computed style
    // Support: Firefox <=43 - 45
    // Disconnected elements can have computed display: none, so first confirm that elem is
    // in the document.
    isAttached(elem) && jQuery.css(elem, "display") === "none";
  };
  function adjustCSS(elem, prop, valueParts, tween) {
    var adjusted,
      scale,
      maxIterations = 20,
      currentValue = tween ? function () {
        return tween.cur();
      } : function () {
        return jQuery.css(elem, prop, "");
      },
      initial = currentValue(),
      unit = valueParts && valueParts[3] || (jQuery.cssNumber[prop] ? "" : "px"),
      // Starting value computation is required for potential unit mismatches
      initialInUnit = elem.nodeType && (jQuery.cssNumber[prop] || unit !== "px" && +initial) && rcssNum.exec(jQuery.css(elem, prop));
    if (initialInUnit && initialInUnit[3] !== unit) {
      // Support: Firefox <=54
      // Halve the iteration target value to prevent interference from CSS upper bounds (gh-2144)
      initial = initial / 2;

      // Trust units reported by jQuery.css
      unit = unit || initialInUnit[3];

      // Iteratively approximate from a nonzero starting point
      initialInUnit = +initial || 1;
      while (maxIterations--) {
        // Evaluate and update our best guess (doubling guesses that zero out).
        // Finish if the scale equals or crosses 1 (making the old*new product non-positive).
        jQuery.style(elem, prop, initialInUnit + unit);
        if ((1 - scale) * (1 - (scale = currentValue() / initial || 0.5)) <= 0) {
          maxIterations = 0;
        }
        initialInUnit = initialInUnit / scale;
      }
      initialInUnit = initialInUnit * 2;
      jQuery.style(elem, prop, initialInUnit + unit);

      // Make sure we update the tween properties later on
      valueParts = valueParts || [];
    }
    if (valueParts) {
      initialInUnit = +initialInUnit || +initial || 0;

      // Apply relative offset (+=/-=) if specified
      adjusted = valueParts[1] ? initialInUnit + (valueParts[1] + 1) * valueParts[2] : +valueParts[2];
      if (tween) {
        tween.unit = unit;
        tween.start = initialInUnit;
        tween.end = adjusted;
      }
    }
    return adjusted;
  }
  var defaultDisplayMap = {};
  function getDefaultDisplay(elem) {
    var temp,
      doc = elem.ownerDocument,
      nodeName = elem.nodeName,
      display = defaultDisplayMap[nodeName];
    if (display) {
      return display;
    }
    temp = doc.body.appendChild(doc.createElement(nodeName));
    display = jQuery.css(temp, "display");
    temp.parentNode.removeChild(temp);
    if (display === "none") {
      display = "block";
    }
    defaultDisplayMap[nodeName] = display;
    return display;
  }
  function showHide(elements, show) {
    var display,
      elem,
      values = [],
      index = 0,
      length = elements.length;

    // Determine new display value for elements that need to change
    for (; index < length; index++) {
      elem = elements[index];
      if (!elem.style) {
        continue;
      }
      display = elem.style.display;
      if (show) {
        // Since we force visibility upon cascade-hidden elements, an immediate (and slow)
        // check is required in this first loop unless we have a nonempty display value (either
        // inline or about-to-be-restored)
        if (display === "none") {
          values[index] = dataPriv.get(elem, "display") || null;
          if (!values[index]) {
            elem.style.display = "";
          }
        }
        if (elem.style.display === "" && isHiddenWithinTree(elem)) {
          values[index] = getDefaultDisplay(elem);
        }
      } else {
        if (display !== "none") {
          values[index] = "none";

          // Remember what we're overwriting
          dataPriv.set(elem, "display", display);
        }
      }
    }

    // Set the display of the elements in a second loop to avoid constant reflow
    for (index = 0; index < length; index++) {
      if (values[index] != null) {
        elements[index].style.display = values[index];
      }
    }
    return elements;
  }
  jQuery.fn.extend({
    show: function show() {
      return showHide(this, true);
    },
    hide: function hide() {
      return showHide(this);
    },
    toggle: function toggle(state) {
      if (typeof state === "boolean") {
        return state ? this.show() : this.hide();
      }
      return this.each(function () {
        if (isHiddenWithinTree(this)) {
          jQuery(this).show();
        } else {
          jQuery(this).hide();
        }
      });
    }
  });
  var rcheckableType = /^(?:checkbox|radio)$/i;
  var rtagName = /<([a-z][^\/\0>\x20\t\r\n\f]*)/i;
  var rscriptType = /^$|^module$|\/(?:java|ecma)script/i;
  (function () {
    var fragment = document.createDocumentFragment(),
      div = fragment.appendChild(document.createElement("div")),
      input = document.createElement("input");

    // Support: Android 4.0 - 4.3 only
    // Check state lost if the name is set (trac-11217)
    // Support: Windows Web Apps (WWA)
    // `name` and `type` must use .setAttribute for WWA (trac-14901)
    input.setAttribute("type", "radio");
    input.setAttribute("checked", "checked");
    input.setAttribute("name", "t");
    div.appendChild(input);

    // Support: Android <=4.1 only
    // Older WebKit doesn't clone checked state correctly in fragments
    support.checkClone = div.cloneNode(true).cloneNode(true).lastChild.checked;

    // Support: IE <=11 only
    // Make sure textarea (and checkbox) defaultValue is properly cloned
    div.innerHTML = "<textarea>x</textarea>";
    support.noCloneChecked = !!div.cloneNode(true).lastChild.defaultValue;

    // Support: IE <=9 only
    // IE <=9 replaces <option> tags with their contents when inserted outside of
    // the select element.
    div.innerHTML = "<option></option>";
    support.option = !!div.lastChild;
  })();

  // We have to close these tags to support XHTML (trac-13200)
  var wrapMap = {
    // XHTML parsers do not magically insert elements in the
    // same way that tag soup parsers do. So we cannot shorten
    // this by omitting <tbody> or other required elements.
    thead: [1, "<table>", "</table>"],
    col: [2, "<table><colgroup>", "</colgroup></table>"],
    tr: [2, "<table><tbody>", "</tbody></table>"],
    td: [3, "<table><tbody><tr>", "</tr></tbody></table>"],
    _default: [0, "", ""]
  };
  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
  wrapMap.th = wrapMap.td;

  // Support: IE <=9 only
  if (!support.option) {
    wrapMap.optgroup = wrapMap.option = [1, "<select multiple='multiple'>", "</select>"];
  }
  function getAll(context, tag) {
    // Support: IE <=9 - 11 only
    // Use typeof to avoid zero-argument method invocation on host objects (trac-15151)
    var ret;
    if (typeof context.getElementsByTagName !== "undefined") {
      ret = context.getElementsByTagName(tag || "*");
    } else if (typeof context.querySelectorAll !== "undefined") {
      ret = context.querySelectorAll(tag || "*");
    } else {
      ret = [];
    }
    if (tag === undefined || tag && nodeName(context, tag)) {
      return jQuery.merge([context], ret);
    }
    return ret;
  }

  // Mark scripts as having already been evaluated
  function setGlobalEval(elems, refElements) {
    var i = 0,
      l = elems.length;
    for (; i < l; i++) {
      dataPriv.set(elems[i], "globalEval", !refElements || dataPriv.get(refElements[i], "globalEval"));
    }
  }
  var rhtml = /<|&#?\w+;/;
  function buildFragment(elems, context, scripts, selection, ignored) {
    var elem,
      tmp,
      tag,
      wrap,
      attached,
      j,
      fragment = context.createDocumentFragment(),
      nodes = [],
      i = 0,
      l = elems.length;
    for (; i < l; i++) {
      elem = elems[i];
      if (elem || elem === 0) {
        // Add nodes directly
        if (toType(elem) === "object") {
          // Support: Android <=4.0 only, PhantomJS 1 only
          // push.apply(_, arraylike) throws on ancient WebKit
          jQuery.merge(nodes, elem.nodeType ? [elem] : elem);

          // Convert non-html into a text node
        } else if (!rhtml.test(elem)) {
          nodes.push(context.createTextNode(elem));

          // Convert html into DOM nodes
        } else {
          tmp = tmp || fragment.appendChild(context.createElement("div"));

          // Deserialize a standard representation
          tag = (rtagName.exec(elem) || ["", ""])[1].toLowerCase();
          wrap = wrapMap[tag] || wrapMap._default;
          tmp.innerHTML = wrap[1] + jQuery.htmlPrefilter(elem) + wrap[2];

          // Descend through wrappers to the right content
          j = wrap[0];
          while (j--) {
            tmp = tmp.lastChild;
          }

          // Support: Android <=4.0 only, PhantomJS 1 only
          // push.apply(_, arraylike) throws on ancient WebKit
          jQuery.merge(nodes, tmp.childNodes);

          // Remember the top-level container
          tmp = fragment.firstChild;

          // Ensure the created nodes are orphaned (trac-12392)
          tmp.textContent = "";
        }
      }
    }

    // Remove wrapper from fragment
    fragment.textContent = "";
    i = 0;
    while (elem = nodes[i++]) {
      // Skip elements already in the context collection (trac-4087)
      if (selection && jQuery.inArray(elem, selection) > -1) {
        if (ignored) {
          ignored.push(elem);
        }
        continue;
      }
      attached = isAttached(elem);

      // Append to fragment
      tmp = getAll(fragment.appendChild(elem), "script");

      // Preserve script evaluation history
      if (attached) {
        setGlobalEval(tmp);
      }

      // Capture executables
      if (scripts) {
        j = 0;
        while (elem = tmp[j++]) {
          if (rscriptType.test(elem.type || "")) {
            scripts.push(elem);
          }
        }
      }
    }
    return fragment;
  }
  var rtypenamespace = /^([^.]*)(?:\.(.+)|)/;
  function returnTrue() {
    return true;
  }
  function returnFalse() {
    return false;
  }
  function _on(elem, types, selector, data, fn, one) {
    var origFn, type;

    // Types can be a map of types/handlers
    if (_typeof(types) === "object") {
      // ( types-Object, selector, data )
      if (typeof selector !== "string") {
        // ( types-Object, data )
        data = data || selector;
        selector = undefined;
      }
      for (type in types) {
        _on(elem, type, selector, data, types[type], one);
      }
      return elem;
    }
    if (data == null && fn == null) {
      // ( types, fn )
      fn = selector;
      data = selector = undefined;
    } else if (fn == null) {
      if (typeof selector === "string") {
        // ( types, selector, fn )
        fn = data;
        data = undefined;
      } else {
        // ( types, data, fn )
        fn = data;
        data = selector;
        selector = undefined;
      }
    }
    if (fn === false) {
      fn = returnFalse;
    } else if (!fn) {
      return elem;
    }
    if (one === 1) {
      origFn = fn;
      fn = function fn(event) {
        // Can use an empty set, since event contains the info
        jQuery().off(event);
        return origFn.apply(this, arguments);
      };

      // Use same guid so caller can remove using origFn
      fn.guid = origFn.guid || (origFn.guid = jQuery.guid++);
    }
    return elem.each(function () {
      jQuery.event.add(this, types, fn, data, selector);
    });
  }

  /*
   * Helper functions for managing events -- not part of the public interface.
   * Props to Dean Edwards' addEvent library for many of the ideas.
   */
  jQuery.event = {
    global: {},
    add: function add(elem, types, handler, data, selector) {
      var handleObjIn,
        eventHandle,
        tmp,
        events,
        t,
        handleObj,
        special,
        handlers,
        type,
        namespaces,
        origType,
        elemData = dataPriv.get(elem);

      // Only attach events to objects that accept data
      if (!acceptData(elem)) {
        return;
      }

      // Caller can pass in an object of custom data in lieu of the handler
      if (handler.handler) {
        handleObjIn = handler;
        handler = handleObjIn.handler;
        selector = handleObjIn.selector;
      }

      // Ensure that invalid selectors throw exceptions at attach time
      // Evaluate against documentElement in case elem is a non-element node (e.g., document)
      if (selector) {
        jQuery.find.matchesSelector(documentElement, selector);
      }

      // Make sure that the handler has a unique ID, used to find/remove it later
      if (!handler.guid) {
        handler.guid = jQuery.guid++;
      }

      // Init the element's event structure and main handler, if this is the first
      if (!(events = elemData.events)) {
        events = elemData.events = Object.create(null);
      }
      if (!(eventHandle = elemData.handle)) {
        eventHandle = elemData.handle = function (e) {
          // Discard the second event of a jQuery.event.trigger() and
          // when an event is called after a page has unloaded
          return typeof jQuery !== "undefined" && jQuery.event.triggered !== e.type ? jQuery.event.dispatch.apply(elem, arguments) : undefined;
        };
      }

      // Handle multiple events separated by a space
      types = (types || "").match(rnothtmlwhite) || [""];
      t = types.length;
      while (t--) {
        tmp = rtypenamespace.exec(types[t]) || [];
        type = origType = tmp[1];
        namespaces = (tmp[2] || "").split(".").sort();

        // There *must* be a type, no attaching namespace-only handlers
        if (!type) {
          continue;
        }

        // If event changes its type, use the special event handlers for the changed type
        special = jQuery.event.special[type] || {};

        // If selector defined, determine special event api type, otherwise given type
        type = (selector ? special.delegateType : special.bindType) || type;

        // Update special based on newly reset type
        special = jQuery.event.special[type] || {};

        // handleObj is passed to all event handlers
        handleObj = jQuery.extend({
          type: type,
          origType: origType,
          data: data,
          handler: handler,
          guid: handler.guid,
          selector: selector,
          needsContext: selector && jQuery.expr.match.needsContext.test(selector),
          namespace: namespaces.join(".")
        }, handleObjIn);

        // Init the event handler queue if we're the first
        if (!(handlers = events[type])) {
          handlers = events[type] = [];
          handlers.delegateCount = 0;

          // Only use addEventListener if the special events handler returns false
          if (!special.setup || special.setup.call(elem, data, namespaces, eventHandle) === false) {
            if (elem.addEventListener) {
              elem.addEventListener(type, eventHandle);
            }
          }
        }
        if (special.add) {
          special.add.call(elem, handleObj);
          if (!handleObj.handler.guid) {
            handleObj.handler.guid = handler.guid;
          }
        }

        // Add to the element's handler list, delegates in front
        if (selector) {
          handlers.splice(handlers.delegateCount++, 0, handleObj);
        } else {
          handlers.push(handleObj);
        }

        // Keep track of which events have ever been used, for event optimization
        jQuery.event.global[type] = true;
      }
    },
    // Detach an event or set of events from an element
    remove: function remove(elem, types, handler, selector, mappedTypes) {
      var j,
        origCount,
        tmp,
        events,
        t,
        handleObj,
        special,
        handlers,
        type,
        namespaces,
        origType,
        elemData = dataPriv.hasData(elem) && dataPriv.get(elem);
      if (!elemData || !(events = elemData.events)) {
        return;
      }

      // Once for each type.namespace in types; type may be omitted
      types = (types || "").match(rnothtmlwhite) || [""];
      t = types.length;
      while (t--) {
        tmp = rtypenamespace.exec(types[t]) || [];
        type = origType = tmp[1];
        namespaces = (tmp[2] || "").split(".").sort();

        // Unbind all events (on this namespace, if provided) for the element
        if (!type) {
          for (type in events) {
            jQuery.event.remove(elem, type + types[t], handler, selector, true);
          }
          continue;
        }
        special = jQuery.event.special[type] || {};
        type = (selector ? special.delegateType : special.bindType) || type;
        handlers = events[type] || [];
        tmp = tmp[2] && new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)");

        // Remove matching events
        origCount = j = handlers.length;
        while (j--) {
          handleObj = handlers[j];
          if ((mappedTypes || origType === handleObj.origType) && (!handler || handler.guid === handleObj.guid) && (!tmp || tmp.test(handleObj.namespace)) && (!selector || selector === handleObj.selector || selector === "**" && handleObj.selector)) {
            handlers.splice(j, 1);
            if (handleObj.selector) {
              handlers.delegateCount--;
            }
            if (special.remove) {
              special.remove.call(elem, handleObj);
            }
          }
        }

        // Remove generic event handler if we removed something and no more handlers exist
        // (avoids potential for endless recursion during removal of special event handlers)
        if (origCount && !handlers.length) {
          if (!special.teardown || special.teardown.call(elem, namespaces, elemData.handle) === false) {
            jQuery.removeEvent(elem, type, elemData.handle);
          }
          delete events[type];
        }
      }

      // Remove data and the expando if it's no longer used
      if (jQuery.isEmptyObject(events)) {
        dataPriv.remove(elem, "handle events");
      }
    },
    dispatch: function dispatch(nativeEvent) {
      var i,
        j,
        ret,
        matched,
        handleObj,
        handlerQueue,
        args = new Array(arguments.length),
        // Make a writable jQuery.Event from the native event object
        event = jQuery.event.fix(nativeEvent),
        handlers = (dataPriv.get(this, "events") || Object.create(null))[event.type] || [],
        special = jQuery.event.special[event.type] || {};

      // Use the fix-ed jQuery.Event rather than the (read-only) native event
      args[0] = event;
      for (i = 1; i < arguments.length; i++) {
        args[i] = arguments[i];
      }
      event.delegateTarget = this;

      // Call the preDispatch hook for the mapped type, and let it bail if desired
      if (special.preDispatch && special.preDispatch.call(this, event) === false) {
        return;
      }

      // Determine handlers
      handlerQueue = jQuery.event.handlers.call(this, event, handlers);

      // Run delegates first; they may want to stop propagation beneath us
      i = 0;
      while ((matched = handlerQueue[i++]) && !event.isPropagationStopped()) {
        event.currentTarget = matched.elem;
        j = 0;
        while ((handleObj = matched.handlers[j++]) && !event.isImmediatePropagationStopped()) {
          // If the event is namespaced, then each handler is only invoked if it is
          // specially universal or its namespaces are a superset of the event's.
          if (!event.rnamespace || handleObj.namespace === false || event.rnamespace.test(handleObj.namespace)) {
            event.handleObj = handleObj;
            event.data = handleObj.data;
            ret = ((jQuery.event.special[handleObj.origType] || {}).handle || handleObj.handler).apply(matched.elem, args);
            if (ret !== undefined) {
              if ((event.result = ret) === false) {
                event.preventDefault();
                event.stopPropagation();
              }
            }
          }
        }
      }

      // Call the postDispatch hook for the mapped type
      if (special.postDispatch) {
        special.postDispatch.call(this, event);
      }
      return event.result;
    },
    handlers: function handlers(event, _handlers) {
      var i,
        handleObj,
        sel,
        matchedHandlers,
        matchedSelectors,
        handlerQueue = [],
        delegateCount = _handlers.delegateCount,
        cur = event.target;

      // Find delegate handlers
      if (delegateCount &&
      // Support: IE <=9
      // Black-hole SVG <use> instance trees (trac-13180)
      cur.nodeType &&
      // Support: Firefox <=42
      // Suppress spec-violating clicks indicating a non-primary pointer button (trac-3861)
      // https://www.w3.org/TR/DOM-Level-3-Events/#event-type-click
      // Support: IE 11 only
      // ...but not arrow key "clicks" of radio inputs, which can have `button` -1 (gh-2343)
      !(event.type === "click" && event.button >= 1)) {
        for (; cur !== this; cur = cur.parentNode || this) {
          // Don't check non-elements (trac-13208)
          // Don't process clicks on disabled elements (trac-6911, trac-8165, trac-11382, trac-11764)
          if (cur.nodeType === 1 && !(event.type === "click" && cur.disabled === true)) {
            matchedHandlers = [];
            matchedSelectors = {};
            for (i = 0; i < delegateCount; i++) {
              handleObj = _handlers[i];

              // Don't conflict with Object.prototype properties (trac-13203)
              sel = handleObj.selector + " ";
              if (matchedSelectors[sel] === undefined) {
                matchedSelectors[sel] = handleObj.needsContext ? jQuery(sel, this).index(cur) > -1 : jQuery.find(sel, this, null, [cur]).length;
              }
              if (matchedSelectors[sel]) {
                matchedHandlers.push(handleObj);
              }
            }
            if (matchedHandlers.length) {
              handlerQueue.push({
                elem: cur,
                handlers: matchedHandlers
              });
            }
          }
        }
      }

      // Add the remaining (directly-bound) handlers
      cur = this;
      if (delegateCount < _handlers.length) {
        handlerQueue.push({
          elem: cur,
          handlers: _handlers.slice(delegateCount)
        });
      }
      return handlerQueue;
    },
    addProp: function addProp(name, hook) {
      Object.defineProperty(jQuery.Event.prototype, name, {
        enumerable: true,
        configurable: true,
        get: isFunction(hook) ? function () {
          if (this.originalEvent) {
            return hook(this.originalEvent);
          }
        } : function () {
          if (this.originalEvent) {
            return this.originalEvent[name];
          }
        },
        set: function set(value) {
          Object.defineProperty(this, name, {
            enumerable: true,
            configurable: true,
            writable: true,
            value: value
          });
        }
      });
    },
    fix: function fix(originalEvent) {
      return originalEvent[jQuery.expando] ? originalEvent : new jQuery.Event(originalEvent);
    },
    special: {
      load: {
        // Prevent triggered image.load events from bubbling to window.load
        noBubble: true
      },
      click: {
        // Utilize native event to ensure correct state for checkable inputs
        setup: function setup(data) {
          // For mutual compressibility with _default, replace `this` access with a local var.
          // `|| data` is dead code meant only to preserve the variable through minification.
          var el = this || data;

          // Claim the first handler
          if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
            // dataPriv.set( el, "click", ... )
            leverageNative(el, "click", true);
          }

          // Return false to allow normal processing in the caller
          return false;
        },
        trigger: function trigger(data) {
          // For mutual compressibility with _default, replace `this` access with a local var.
          // `|| data` is dead code meant only to preserve the variable through minification.
          var el = this || data;

          // Force setup before triggering a click
          if (rcheckableType.test(el.type) && el.click && nodeName(el, "input")) {
            leverageNative(el, "click");
          }

          // Return non-false to allow normal event-path propagation
          return true;
        },
        // For cross-browser consistency, suppress native .click() on links
        // Also prevent it if we're currently inside a leveraged native-event stack
        _default: function _default(event) {
          var target = event.target;
          return rcheckableType.test(target.type) && target.click && nodeName(target, "input") && dataPriv.get(target, "click") || nodeName(target, "a");
        }
      },
      beforeunload: {
        postDispatch: function postDispatch(event) {
          // Support: Firefox 20+
          // Firefox doesn't alert if the returnValue field is not set.
          if (event.result !== undefined && event.originalEvent) {
            event.originalEvent.returnValue = event.result;
          }
        }
      }
    }
  };

  // Ensure the presence of an event listener that handles manually-triggered
  // synthetic events by interrupting progress until reinvoked in response to
  // *native* events that it fires directly, ensuring that state changes have
  // already occurred before other listeners are invoked.
  function leverageNative(el, type, isSetup) {
    // Missing `isSetup` indicates a trigger call, which must force setup through jQuery.event.add
    if (!isSetup) {
      if (dataPriv.get(el, type) === undefined) {
        jQuery.event.add(el, type, returnTrue);
      }
      return;
    }

    // Register the controller as a special universal handler for all event namespaces
    dataPriv.set(el, type, false);
    jQuery.event.add(el, type, {
      namespace: false,
      handler: function handler(event) {
        var result,
          saved = dataPriv.get(this, type);
        if (event.isTrigger & 1 && this[type]) {
          // Interrupt processing of the outer synthetic .trigger()ed event
          if (!saved) {
            // Store arguments for use when handling the inner native event
            // There will always be at least one argument (an event object), so this array
            // will not be confused with a leftover capture object.
            saved = _slice.call(arguments);
            dataPriv.set(this, type, saved);

            // Trigger the native event and capture its result
            this[type]();
            result = dataPriv.get(this, type);
            dataPriv.set(this, type, false);
            if (saved !== result) {
              // Cancel the outer synthetic event
              event.stopImmediatePropagation();
              event.preventDefault();
              return result;
            }

            // If this is an inner synthetic event for an event with a bubbling surrogate
            // (focus or blur), assume that the surrogate already propagated from triggering
            // the native event and prevent that from happening again here.
            // This technically gets the ordering wrong w.r.t. to `.trigger()` (in which the
            // bubbling surrogate propagates *after* the non-bubbling base), but that seems
            // less bad than duplication.
          } else if ((jQuery.event.special[type] || {}).delegateType) {
            event.stopPropagation();
          }

          // If this is a native event triggered above, everything is now in order
          // Fire an inner synthetic event with the original arguments
        } else if (saved) {
          // ...and capture the result
          dataPriv.set(this, type, jQuery.event.trigger(saved[0], saved.slice(1), this));

          // Abort handling of the native event by all jQuery handlers while allowing
          // native handlers on the same element to run. On target, this is achieved
          // by stopping immediate propagation just on the jQuery event. However,
          // the native event is re-wrapped by a jQuery one on each level of the
          // propagation so the only way to stop it for jQuery is to stop it for
          // everyone via native `stopPropagation()`. This is not a problem for
          // focus/blur which don't bubble, but it does also stop click on checkboxes
          // and radios. We accept this limitation.
          event.stopPropagation();
          event.isImmediatePropagationStopped = returnTrue;
        }
      }
    });
  }
  jQuery.removeEvent = function (elem, type, handle) {
    // This "if" is needed for plain objects
    if (elem.removeEventListener) {
      elem.removeEventListener(type, handle);
    }
  };
  jQuery.Event = function (src, props) {
    // Allow instantiation without the 'new' keyword
    if (!(this instanceof jQuery.Event)) {
      return new jQuery.Event(src, props);
    }

    // Event object
    if (src && src.type) {
      this.originalEvent = src;
      this.type = src.type;

      // Events bubbling up the document may have been marked as prevented
      // by a handler lower down the tree; reflect the correct value.
      this.isDefaultPrevented = src.defaultPrevented || src.defaultPrevented === undefined &&
      // Support: Android <=2.3 only
      src.returnValue === false ? returnTrue : returnFalse;

      // Create target properties
      // Support: Safari <=6 - 7 only
      // Target should not be a text node (trac-504, trac-13143)
      this.target = src.target && src.target.nodeType === 3 ? src.target.parentNode : src.target;
      this.currentTarget = src.currentTarget;
      this.relatedTarget = src.relatedTarget;

      // Event type
    } else {
      this.type = src;
    }

    // Put explicitly provided properties onto the event object
    if (props) {
      jQuery.extend(this, props);
    }

    // Create a timestamp if incoming event doesn't have one
    this.timeStamp = src && src.timeStamp || Date.now();

    // Mark it as fixed
    this[jQuery.expando] = true;
  };

  // jQuery.Event is based on DOM3 Events as specified by the ECMAScript Language Binding
  // https://www.w3.org/TR/2003/WD-DOM-Level-3-Events-20030331/ecma-script-binding.html
  jQuery.Event.prototype = {
    constructor: jQuery.Event,
    isDefaultPrevented: returnFalse,
    isPropagationStopped: returnFalse,
    isImmediatePropagationStopped: returnFalse,
    isSimulated: false,
    preventDefault: function preventDefault() {
      var e = this.originalEvent;
      this.isDefaultPrevented = returnTrue;
      if (e && !this.isSimulated) {
        e.preventDefault();
      }
    },
    stopPropagation: function stopPropagation() {
      var e = this.originalEvent;
      this.isPropagationStopped = returnTrue;
      if (e && !this.isSimulated) {
        e.stopPropagation();
      }
    },
    stopImmediatePropagation: function stopImmediatePropagation() {
      var e = this.originalEvent;
      this.isImmediatePropagationStopped = returnTrue;
      if (e && !this.isSimulated) {
        e.stopImmediatePropagation();
      }
      this.stopPropagation();
    }
  };

  // Includes all common event props including KeyEvent and MouseEvent specific props
  jQuery.each({
    altKey: true,
    bubbles: true,
    cancelable: true,
    changedTouches: true,
    ctrlKey: true,
    detail: true,
    eventPhase: true,
    metaKey: true,
    pageX: true,
    pageY: true,
    shiftKey: true,
    view: true,
    "char": true,
    code: true,
    charCode: true,
    key: true,
    keyCode: true,
    button: true,
    buttons: true,
    clientX: true,
    clientY: true,
    offsetX: true,
    offsetY: true,
    pointerId: true,
    pointerType: true,
    screenX: true,
    screenY: true,
    targetTouches: true,
    toElement: true,
    touches: true,
    which: true
  }, jQuery.event.addProp);
  jQuery.each({
    focus: "focusin",
    blur: "focusout"
  }, function (type, delegateType) {
    function focusMappedHandler(nativeEvent) {
      if (document.documentMode) {
        // Support: IE 11+
        // Attach a single focusin/focusout handler on the document while someone wants
        // focus/blur. This is because the former are synchronous in IE while the latter
        // are async. In other browsers, all those handlers are invoked synchronously.

        // `handle` from private data would already wrap the event, but we need
        // to change the `type` here.
        var handle = dataPriv.get(this, "handle"),
          event = jQuery.event.fix(nativeEvent);
        event.type = nativeEvent.type === "focusin" ? "focus" : "blur";
        event.isSimulated = true;

        // First, handle focusin/focusout
        handle(nativeEvent);

        // ...then, handle focus/blur
        //
        // focus/blur don't bubble while focusin/focusout do; simulate the former by only
        // invoking the handler at the lower level.
        if (event.target === event.currentTarget) {
          // The setup part calls `leverageNative`, which, in turn, calls
          // `jQuery.event.add`, so event handle will already have been set
          // by this point.
          handle(event);
        }
      } else {
        // For non-IE browsers, attach a single capturing handler on the document
        // while someone wants focusin/focusout.
        jQuery.event.simulate(delegateType, nativeEvent.target, jQuery.event.fix(nativeEvent));
      }
    }
    jQuery.event.special[type] = {
      // Utilize native event if possible so blur/focus sequence is correct
      setup: function setup() {
        var attaches;

        // Claim the first handler
        // dataPriv.set( this, "focus", ... )
        // dataPriv.set( this, "blur", ... )
        leverageNative(this, type, true);
        if (document.documentMode) {
          // Support: IE 9 - 11+
          // We use the same native handler for focusin & focus (and focusout & blur)
          // so we need to coordinate setup & teardown parts between those events.
          // Use `delegateType` as the key as `type` is already used by `leverageNative`.
          attaches = dataPriv.get(this, delegateType);
          if (!attaches) {
            this.addEventListener(delegateType, focusMappedHandler);
          }
          dataPriv.set(this, delegateType, (attaches || 0) + 1);
        } else {
          // Return false to allow normal processing in the caller
          return false;
        }
      },
      trigger: function trigger() {
        // Force setup before trigger
        leverageNative(this, type);

        // Return non-false to allow normal event-path propagation
        return true;
      },
      teardown: function teardown() {
        var attaches;
        if (document.documentMode) {
          attaches = dataPriv.get(this, delegateType) - 1;
          if (!attaches) {
            this.removeEventListener(delegateType, focusMappedHandler);
            dataPriv.remove(this, delegateType);
          } else {
            dataPriv.set(this, delegateType, attaches);
          }
        } else {
          // Return false to indicate standard teardown should be applied
          return false;
        }
      },
      // Suppress native focus or blur if we're currently inside
      // a leveraged native-event stack
      _default: function _default(event) {
        return dataPriv.get(event.target, type);
      },
      delegateType: delegateType
    };

    // Support: Firefox <=44
    // Firefox doesn't have focus(in | out) events
    // Related ticket - https://bugzilla.mozilla.org/show_bug.cgi?id=687787
    //
    // Support: Chrome <=48 - 49, Safari <=9.0 - 9.1
    // focus(in | out) events fire after focus & blur events,
    // which is spec violation - http://www.w3.org/TR/DOM-Level-3-Events/#events-focusevent-event-order
    // Related ticket - https://bugs.chromium.org/p/chromium/issues/detail?id=449857
    //
    // Support: IE 9 - 11+
    // To preserve relative focusin/focus & focusout/blur event order guaranteed on the 3.x branch,
    // attach a single handler for both events in IE.
    jQuery.event.special[delegateType] = {
      setup: function setup() {
        // Handle: regular nodes (via `this.ownerDocument`), window
        // (via `this.document`) & document (via `this`).
        var doc = this.ownerDocument || this.document || this,
          dataHolder = document.documentMode ? this : doc,
          attaches = dataPriv.get(dataHolder, delegateType);

        // Support: IE 9 - 11+
        // We use the same native handler for focusin & focus (and focusout & blur)
        // so we need to coordinate setup & teardown parts between those events.
        // Use `delegateType` as the key as `type` is already used by `leverageNative`.
        if (!attaches) {
          if (document.documentMode) {
            this.addEventListener(delegateType, focusMappedHandler);
          } else {
            doc.addEventListener(type, focusMappedHandler, true);
          }
        }
        dataPriv.set(dataHolder, delegateType, (attaches || 0) + 1);
      },
      teardown: function teardown() {
        var doc = this.ownerDocument || this.document || this,
          dataHolder = document.documentMode ? this : doc,
          attaches = dataPriv.get(dataHolder, delegateType) - 1;
        if (!attaches) {
          if (document.documentMode) {
            this.removeEventListener(delegateType, focusMappedHandler);
          } else {
            doc.removeEventListener(type, focusMappedHandler, true);
          }
          dataPriv.remove(dataHolder, delegateType);
        } else {
          dataPriv.set(dataHolder, delegateType, attaches);
        }
      }
    };
  });

  // Create mouseenter/leave events using mouseover/out and event-time checks
  // so that event delegation works in jQuery.
  // Do the same for pointerenter/pointerleave and pointerover/pointerout
  //
  // Support: Safari 7 only
  // Safari sends mouseenter too often; see:
  // https://bugs.chromium.org/p/chromium/issues/detail?id=470258
  // for the description of the bug (it existed in older Chrome versions as well).
  jQuery.each({
    mouseenter: "mouseover",
    mouseleave: "mouseout",
    pointerenter: "pointerover",
    pointerleave: "pointerout"
  }, function (orig, fix) {
    jQuery.event.special[orig] = {
      delegateType: fix,
      bindType: fix,
      handle: function handle(event) {
        var ret,
          target = this,
          related = event.relatedTarget,
          handleObj = event.handleObj;

        // For mouseenter/leave call the handler if related is outside the target.
        // NB: No relatedTarget if the mouse left/entered the browser window
        if (!related || related !== target && !jQuery.contains(target, related)) {
          event.type = handleObj.origType;
          ret = handleObj.handler.apply(this, arguments);
          event.type = fix;
        }
        return ret;
      }
    };
  });
  jQuery.fn.extend({
    on: function on(types, selector, data, fn) {
      return _on(this, types, selector, data, fn);
    },
    one: function one(types, selector, data, fn) {
      return _on(this, types, selector, data, fn, 1);
    },
    off: function off(types, selector, fn) {
      var handleObj, type;
      if (types && types.preventDefault && types.handleObj) {
        // ( event )  dispatched jQuery.Event
        handleObj = types.handleObj;
        jQuery(types.delegateTarget).off(handleObj.namespace ? handleObj.origType + "." + handleObj.namespace : handleObj.origType, handleObj.selector, handleObj.handler);
        return this;
      }
      if (_typeof(types) === "object") {
        // ( types-object [, selector] )
        for (type in types) {
          this.off(type, selector, types[type]);
        }
        return this;
      }
      if (selector === false || typeof selector === "function") {
        // ( types [, fn] )
        fn = selector;
        selector = undefined;
      }
      if (fn === false) {
        fn = returnFalse;
      }
      return this.each(function () {
        jQuery.event.remove(this, types, fn, selector);
      });
    }
  });
  var
    // Support: IE <=10 - 11, Edge 12 - 13 only
    // In IE/Edge using regex groups here causes severe slowdowns.
    // See https://connect.microsoft.com/IE/feedback/details/1736512/
    rnoInnerhtml = /<script|<style|<link/i,
    // checked="checked" or checked
    rchecked = /checked\s*(?:[^=]|=\s*.checked.)/i,
    rcleanScript = /^\s*<!\[CDATA\[|\]\]>\s*$/g;

  // Prefer a tbody over its parent table for containing new rows
  function manipulationTarget(elem, content) {
    if (nodeName(elem, "table") && nodeName(content.nodeType !== 11 ? content : content.firstChild, "tr")) {
      return jQuery(elem).children("tbody")[0] || elem;
    }
    return elem;
  }

  // Replace/restore the type attribute of script elements for safe DOM manipulation
  function disableScript(elem) {
    elem.type = (elem.getAttribute("type") !== null) + "/" + elem.type;
    return elem;
  }
  function restoreScript(elem) {
    if ((elem.type || "").slice(0, 5) === "true/") {
      elem.type = elem.type.slice(5);
    } else {
      elem.removeAttribute("type");
    }
    return elem;
  }
  function cloneCopyEvent(src, dest) {
    var i, l, type, pdataOld, udataOld, udataCur, events;
    if (dest.nodeType !== 1) {
      return;
    }

    // 1. Copy private data: events, handlers, etc.
    if (dataPriv.hasData(src)) {
      pdataOld = dataPriv.get(src);
      events = pdataOld.events;
      if (events) {
        dataPriv.remove(dest, "handle events");
        for (type in events) {
          for (i = 0, l = events[type].length; i < l; i++) {
            jQuery.event.add(dest, type, events[type][i]);
          }
        }
      }
    }

    // 2. Copy user data
    if (dataUser.hasData(src)) {
      udataOld = dataUser.access(src);
      udataCur = jQuery.extend({}, udataOld);
      dataUser.set(dest, udataCur);
    }
  }

  // Fix IE bugs, see support tests
  function fixInput(src, dest) {
    var nodeName = dest.nodeName.toLowerCase();

    // Fails to persist the checked state of a cloned checkbox or radio button.
    if (nodeName === "input" && rcheckableType.test(src.type)) {
      dest.checked = src.checked;

      // Fails to return the selected option to the default selected state when cloning options
    } else if (nodeName === "input" || nodeName === "textarea") {
      dest.defaultValue = src.defaultValue;
    }
  }
  function domManip(collection, args, callback, ignored) {
    // Flatten any nested arrays
    args = flat(args);
    var fragment,
      first,
      scripts,
      hasScripts,
      node,
      doc,
      i = 0,
      l = collection.length,
      iNoClone = l - 1,
      value = args[0],
      valueIsFunction = isFunction(value);

    // We can't cloneNode fragments that contain checked, in WebKit
    if (valueIsFunction || l > 1 && typeof value === "string" && !support.checkClone && rchecked.test(value)) {
      return collection.each(function (index) {
        var self = collection.eq(index);
        if (valueIsFunction) {
          args[0] = value.call(this, index, self.html());
        }
        domManip(self, args, callback, ignored);
      });
    }
    if (l) {
      fragment = buildFragment(args, collection[0].ownerDocument, false, collection, ignored);
      first = fragment.firstChild;
      if (fragment.childNodes.length === 1) {
        fragment = first;
      }

      // Require either new content or an interest in ignored elements to invoke the callback
      if (first || ignored) {
        scripts = jQuery.map(getAll(fragment, "script"), disableScript);
        hasScripts = scripts.length;

        // Use the original fragment for the last item
        // instead of the first because it can end up
        // being emptied incorrectly in certain situations (trac-8070).
        for (; i < l; i++) {
          node = fragment;
          if (i !== iNoClone) {
            node = jQuery.clone(node, true, true);

            // Keep references to cloned scripts for later restoration
            if (hasScripts) {
              // Support: Android <=4.0 only, PhantomJS 1 only
              // push.apply(_, arraylike) throws on ancient WebKit
              jQuery.merge(scripts, getAll(node, "script"));
            }
          }
          callback.call(collection[i], node, i);
        }
        if (hasScripts) {
          doc = scripts[scripts.length - 1].ownerDocument;

          // Re-enable scripts
          jQuery.map(scripts, restoreScript);

          // Evaluate executable scripts on first document insertion
          for (i = 0; i < hasScripts; i++) {
            node = scripts[i];
            if (rscriptType.test(node.type || "") && !dataPriv.access(node, "globalEval") && jQuery.contains(doc, node)) {
              if (node.src && (node.type || "").toLowerCase() !== "module") {
                // Optional AJAX dependency, but won't run scripts if not present
                if (jQuery._evalUrl && !node.noModule) {
                  jQuery._evalUrl(node.src, {
                    nonce: node.nonce || node.getAttribute("nonce")
                  }, doc);
                }
              } else {
                // Unwrap a CDATA section containing script contents. This shouldn't be
                // needed as in XML documents they're already not visible when
                // inspecting element contents and in HTML documents they have no
                // meaning but we're preserving that logic for backwards compatibility.
                // This will be removed completely in 4.0. See gh-4904.
                DOMEval(node.textContent.replace(rcleanScript, ""), node, doc);
              }
            }
          }
        }
      }
    }
    return collection;
  }
  function _remove(elem, selector, keepData) {
    var node,
      nodes = selector ? jQuery.filter(selector, elem) : elem,
      i = 0;
    for (; (node = nodes[i]) != null; i++) {
      if (!keepData && node.nodeType === 1) {
        jQuery.cleanData(getAll(node));
      }
      if (node.parentNode) {
        if (keepData && isAttached(node)) {
          setGlobalEval(getAll(node, "script"));
        }
        node.parentNode.removeChild(node);
      }
    }
    return elem;
  }
  jQuery.extend({
    htmlPrefilter: function htmlPrefilter(html) {
      return html;
    },
    clone: function clone(elem, dataAndEvents, deepDataAndEvents) {
      var i,
        l,
        srcElements,
        destElements,
        clone = elem.cloneNode(true),
        inPage = isAttached(elem);

      // Fix IE cloning issues
      if (!support.noCloneChecked && (elem.nodeType === 1 || elem.nodeType === 11) && !jQuery.isXMLDoc(elem)) {
        // We eschew jQuery#find here for performance reasons:
        // https://jsperf.com/getall-vs-sizzle/2
        destElements = getAll(clone);
        srcElements = getAll(elem);
        for (i = 0, l = srcElements.length; i < l; i++) {
          fixInput(srcElements[i], destElements[i]);
        }
      }

      // Copy the events from the original to the clone
      if (dataAndEvents) {
        if (deepDataAndEvents) {
          srcElements = srcElements || getAll(elem);
          destElements = destElements || getAll(clone);
          for (i = 0, l = srcElements.length; i < l; i++) {
            cloneCopyEvent(srcElements[i], destElements[i]);
          }
        } else {
          cloneCopyEvent(elem, clone);
        }
      }

      // Preserve script evaluation history
      destElements = getAll(clone, "script");
      if (destElements.length > 0) {
        setGlobalEval(destElements, !inPage && getAll(elem, "script"));
      }

      // Return the cloned set
      return clone;
    },
    cleanData: function cleanData(elems) {
      var data,
        elem,
        type,
        special = jQuery.event.special,
        i = 0;
      for (; (elem = elems[i]) !== undefined; i++) {
        if (acceptData(elem)) {
          if (data = elem[dataPriv.expando]) {
            if (data.events) {
              for (type in data.events) {
                if (special[type]) {
                  jQuery.event.remove(elem, type);

                  // This is a shortcut to avoid jQuery.event.remove's overhead
                } else {
                  jQuery.removeEvent(elem, type, data.handle);
                }
              }
            }

            // Support: Chrome <=35 - 45+
            // Assign undefined instead of using delete, see Data#remove
            elem[dataPriv.expando] = undefined;
          }
          if (elem[dataUser.expando]) {
            // Support: Chrome <=35 - 45+
            // Assign undefined instead of using delete, see Data#remove
            elem[dataUser.expando] = undefined;
          }
        }
      }
    }
  });
  jQuery.fn.extend({
    detach: function detach(selector) {
      return _remove(this, selector, true);
    },
    remove: function remove(selector) {
      return _remove(this, selector);
    },
    text: function text(value) {
      return _access(this, function (value) {
        return value === undefined ? jQuery.text(this) : this.empty().each(function () {
          if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
            this.textContent = value;
          }
        });
      }, null, value, arguments.length);
    },
    append: function append() {
      return domManip(this, arguments, function (elem) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var target = manipulationTarget(this, elem);
          target.appendChild(elem);
        }
      });
    },
    prepend: function prepend() {
      return domManip(this, arguments, function (elem) {
        if (this.nodeType === 1 || this.nodeType === 11 || this.nodeType === 9) {
          var target = manipulationTarget(this, elem);
          target.insertBefore(elem, target.firstChild);
        }
      });
    },
    before: function before() {
      return domManip(this, arguments, function (elem) {
        if (this.parentNode) {
          this.parentNode.insertBefore(elem, this);
        }
      });
    },
    after: function after() {
      return domManip(this, arguments, function (elem) {
        if (this.parentNode) {
          this.parentNode.insertBefore(elem, this.nextSibling);
        }
      });
    },
    empty: function empty() {
      var elem,
        i = 0;
      for (; (elem = this[i]) != null; i++) {
        if (elem.nodeType === 1) {
          // Prevent memory leaks
          jQuery.cleanData(getAll(elem, false));

          // Remove any remaining nodes
          elem.textContent = "";
        }
      }
      return this;
    },
    clone: function clone(dataAndEvents, deepDataAndEvents) {
      dataAndEvents = dataAndEvents == null ? false : dataAndEvents;
      deepDataAndEvents = deepDataAndEvents == null ? dataAndEvents : deepDataAndEvents;
      return this.map(function () {
        return jQuery.clone(this, dataAndEvents, deepDataAndEvents);
      });
    },
    html: function html(value) {
      return _access(this, function (value) {
        var elem = this[0] || {},
          i = 0,
          l = this.length;
        if (value === undefined && elem.nodeType === 1) {
          return elem.innerHTML;
        }

        // See if we can take a shortcut and just use innerHTML
        if (typeof value === "string" && !rnoInnerhtml.test(value) && !wrapMap[(rtagName.exec(value) || ["", ""])[1].toLowerCase()]) {
          value = jQuery.htmlPrefilter(value);
          try {
            for (; i < l; i++) {
              elem = this[i] || {};

              // Remove element nodes and prevent memory leaks
              if (elem.nodeType === 1) {
                jQuery.cleanData(getAll(elem, false));
                elem.innerHTML = value;
              }
            }
            elem = 0;

            // If using innerHTML throws an exception, use the fallback method
          } catch (e) {}
        }
        if (elem) {
          this.empty().append(value);
        }
      }, null, value, arguments.length);
    },
    replaceWith: function replaceWith() {
      var ignored = [];

      // Make the changes, replacing each non-ignored context element with the new content
      return domManip(this, arguments, function (elem) {
        var parent = this.parentNode;
        if (jQuery.inArray(this, ignored) < 0) {
          jQuery.cleanData(getAll(this));
          if (parent) {
            parent.replaceChild(elem, this);
          }
        }

        // Force callback invocation
      }, ignored);
    }
  });
  jQuery.each({
    appendTo: "append",
    prependTo: "prepend",
    insertBefore: "before",
    insertAfter: "after",
    replaceAll: "replaceWith"
  }, function (name, original) {
    jQuery.fn[name] = function (selector) {
      var elems,
        ret = [],
        insert = jQuery(selector),
        last = insert.length - 1,
        i = 0;
      for (; i <= last; i++) {
        elems = i === last ? this : this.clone(true);
        jQuery(insert[i])[original](elems);

        // Support: Android <=4.0 only, PhantomJS 1 only
        // .get() because push.apply(_, arraylike) throws on ancient WebKit
        push.apply(ret, elems.get());
      }
      return this.pushStack(ret);
    };
  });
  var rnumnonpx = new RegExp("^(" + pnum + ")(?!px)[a-z%]+$", "i");
  var rcustomProp = /^--/;
  var getStyles = function getStyles(elem) {
    // Support: IE <=11 only, Firefox <=30 (trac-15098, trac-14150)
    // IE throws on elements created in popups
    // FF meanwhile throws on frame elements through "defaultView.getComputedStyle"
    var view = elem.ownerDocument.defaultView;
    if (!view || !view.opener) {
      view = window;
    }
    return view.getComputedStyle(elem);
  };
  var swap = function swap(elem, options, callback) {
    var ret,
      name,
      old = {};

    // Remember the old values, and insert the new ones
    for (name in options) {
      old[name] = elem.style[name];
      elem.style[name] = options[name];
    }
    ret = callback.call(elem);

    // Revert the old values
    for (name in options) {
      elem.style[name] = old[name];
    }
    return ret;
  };
  var rboxStyle = new RegExp(cssExpand.join("|"), "i");
  (function () {
    // Executing both pixelPosition & boxSizingReliable tests require only one layout
    // so they're executed at the same time to save the second computation.
    function computeStyleTests() {
      // This is a singleton, we need to execute it only once
      if (!div) {
        return;
      }
      container.style.cssText = "position:absolute;left:-11111px;width:60px;" + "margin-top:1px;padding:0;border:0";
      div.style.cssText = "position:relative;display:block;box-sizing:border-box;overflow:scroll;" + "margin:auto;border:1px;padding:1px;" + "width:60%;top:1%";
      documentElement.appendChild(container).appendChild(div);
      var divStyle = window.getComputedStyle(div);
      pixelPositionVal = divStyle.top !== "1%";

      // Support: Android 4.0 - 4.3 only, Firefox <=3 - 44
      reliableMarginLeftVal = roundPixelMeasures(divStyle.marginLeft) === 12;

      // Support: Android 4.0 - 4.3 only, Safari <=9.1 - 10.1, iOS <=7.0 - 9.3
      // Some styles come back with percentage values, even though they shouldn't
      div.style.right = "60%";
      pixelBoxStylesVal = roundPixelMeasures(divStyle.right) === 36;

      // Support: IE 9 - 11 only
      // Detect misreporting of content dimensions for box-sizing:border-box elements
      boxSizingReliableVal = roundPixelMeasures(divStyle.width) === 36;

      // Support: IE 9 only
      // Detect overflow:scroll screwiness (gh-3699)
      // Support: Chrome <=64
      // Don't get tricked when zoom affects offsetWidth (gh-4029)
      div.style.position = "absolute";
      scrollboxSizeVal = roundPixelMeasures(div.offsetWidth / 3) === 12;
      documentElement.removeChild(container);

      // Nullify the div so it wouldn't be stored in the memory and
      // it will also be a sign that checks already performed
      div = null;
    }
    function roundPixelMeasures(measure) {
      return Math.round(parseFloat(measure));
    }
    var pixelPositionVal,
      boxSizingReliableVal,
      scrollboxSizeVal,
      pixelBoxStylesVal,
      reliableTrDimensionsVal,
      reliableMarginLeftVal,
      container = document.createElement("div"),
      div = document.createElement("div");

    // Finish early in limited (non-browser) environments
    if (!div.style) {
      return;
    }

    // Support: IE <=9 - 11 only
    // Style of cloned element affects source element cloned (trac-8908)
    div.style.backgroundClip = "content-box";
    div.cloneNode(true).style.backgroundClip = "";
    support.clearCloneStyle = div.style.backgroundClip === "content-box";
    jQuery.extend(support, {
      boxSizingReliable: function boxSizingReliable() {
        computeStyleTests();
        return boxSizingReliableVal;
      },
      pixelBoxStyles: function pixelBoxStyles() {
        computeStyleTests();
        return pixelBoxStylesVal;
      },
      pixelPosition: function pixelPosition() {
        computeStyleTests();
        return pixelPositionVal;
      },
      reliableMarginLeft: function reliableMarginLeft() {
        computeStyleTests();
        return reliableMarginLeftVal;
      },
      scrollboxSize: function scrollboxSize() {
        computeStyleTests();
        return scrollboxSizeVal;
      },
      // Support: IE 9 - 11+, Edge 15 - 18+
      // IE/Edge misreport `getComputedStyle` of table rows with width/height
      // set in CSS while `offset*` properties report correct values.
      // Behavior in IE 9 is more subtle than in newer versions & it passes
      // some versions of this test; make sure not to make it pass there!
      //
      // Support: Firefox 70+
      // Only Firefox includes border widths
      // in computed dimensions. (gh-4529)
      reliableTrDimensions: function reliableTrDimensions() {
        var table, tr, trChild, trStyle;
        if (reliableTrDimensionsVal == null) {
          table = document.createElement("table");
          tr = document.createElement("tr");
          trChild = document.createElement("div");
          table.style.cssText = "position:absolute;left:-11111px;border-collapse:separate";
          tr.style.cssText = "box-sizing:content-box;border:1px solid";

          // Support: Chrome 86+
          // Height set through cssText does not get applied.
          // Computed height then comes back as 0.
          tr.style.height = "1px";
          trChild.style.height = "9px";

          // Support: Android 8 Chrome 86+
          // In our bodyBackground.html iframe,
          // display for all div elements is set to "inline",
          // which causes a problem only in Android 8 Chrome 86.
          // Ensuring the div is `display: block`
          // gets around this issue.
          trChild.style.display = "block";
          documentElement.appendChild(table).appendChild(tr).appendChild(trChild);
          trStyle = window.getComputedStyle(tr);
          reliableTrDimensionsVal = parseInt(trStyle.height, 10) + parseInt(trStyle.borderTopWidth, 10) + parseInt(trStyle.borderBottomWidth, 10) === tr.offsetHeight;
          documentElement.removeChild(table);
        }
        return reliableTrDimensionsVal;
      }
    });
  })();
  function curCSS(elem, name, computed) {
    var width,
      minWidth,
      maxWidth,
      ret,
      isCustomProp = rcustomProp.test(name),
      // Support: Firefox 51+
      // Retrieving style before computed somehow
      // fixes an issue with getting wrong values
      // on detached elements
      style = elem.style;
    computed = computed || getStyles(elem);

    // getPropertyValue is needed for:
    //   .css('filter') (IE 9 only, trac-12537)
    //   .css('--customProperty) (gh-3144)
    if (computed) {
      // Support: IE <=9 - 11+
      // IE only supports `"float"` in `getPropertyValue`; in computed styles
      // it's only available as `"cssFloat"`. We no longer modify properties
      // sent to `.css()` apart from camelCasing, so we need to check both.
      // Normally, this would create difference in behavior: if
      // `getPropertyValue` returns an empty string, the value returned
      // by `.css()` would be `undefined`. This is usually the case for
      // disconnected elements. However, in IE even disconnected elements
      // with no styles return `"none"` for `getPropertyValue( "float" )`
      ret = computed.getPropertyValue(name) || computed[name];
      if (isCustomProp && ret) {
        // Support: Firefox 105+, Chrome <=105+
        // Spec requires trimming whitespace for custom properties (gh-4926).
        // Firefox only trims leading whitespace. Chrome just collapses
        // both leading & trailing whitespace to a single space.
        //
        // Fall back to `undefined` if empty string returned.
        // This collapses a missing definition with property defined
        // and set to an empty string but there's no standard API
        // allowing us to differentiate them without a performance penalty
        // and returning `undefined` aligns with older jQuery.
        //
        // rtrimCSS treats U+000D CARRIAGE RETURN and U+000C FORM FEED
        // as whitespace while CSS does not, but this is not a problem
        // because CSS preprocessing replaces them with U+000A LINE FEED
        // (which *is* CSS whitespace)
        // https://www.w3.org/TR/css-syntax-3/#input-preprocessing
        ret = ret.replace(rtrimCSS, "$1") || undefined;
      }
      if (ret === "" && !isAttached(elem)) {
        ret = jQuery.style(elem, name);
      }

      // A tribute to the "awesome hack by Dean Edwards"
      // Android Browser returns percentage for some values,
      // but width seems to be reliably pixels.
      // This is against the CSSOM draft spec:
      // https://drafts.csswg.org/cssom/#resolved-values
      if (!support.pixelBoxStyles() && rnumnonpx.test(ret) && rboxStyle.test(name)) {
        // Remember the original values
        width = style.width;
        minWidth = style.minWidth;
        maxWidth = style.maxWidth;

        // Put in the new values to get a computed value out
        style.minWidth = style.maxWidth = style.width = ret;
        ret = computed.width;

        // Revert the changed values
        style.width = width;
        style.minWidth = minWidth;
        style.maxWidth = maxWidth;
      }
    }
    return ret !== undefined ?
    // Support: IE <=9 - 11 only
    // IE returns zIndex value as an integer.
    ret + "" : ret;
  }
  function addGetHookIf(conditionFn, hookFn) {
    // Define the hook, we'll check on the first run if it's really needed.
    return {
      get: function get() {
        if (conditionFn()) {
          // Hook not needed (or it's not possible to use it due
          // to missing dependency), remove it.
          delete this.get;
          return;
        }

        // Hook needed; redefine it so that the support test is not executed again.
        return (this.get = hookFn).apply(this, arguments);
      }
    };
  }
  var cssPrefixes = ["Webkit", "Moz", "ms"],
    emptyStyle = document.createElement("div").style,
    vendorProps = {};

  // Return a vendor-prefixed property or undefined
  function vendorPropName(name) {
    // Check for vendor prefixed names
    var capName = name[0].toUpperCase() + name.slice(1),
      i = cssPrefixes.length;
    while (i--) {
      name = cssPrefixes[i] + capName;
      if (name in emptyStyle) {
        return name;
      }
    }
  }

  // Return a potentially-mapped jQuery.cssProps or vendor prefixed property
  function finalPropName(name) {
    var _final = jQuery.cssProps[name] || vendorProps[name];
    if (_final) {
      return _final;
    }
    if (name in emptyStyle) {
      return name;
    }
    return vendorProps[name] = vendorPropName(name) || name;
  }
  var
    // Swappable if display is none or starts with table
    // except "table", "table-cell", or "table-caption"
    // See here for display values: https://developer.mozilla.org/en-US/docs/CSS/display
    rdisplayswap = /^(none|table(?!-c[ea]).+)/,
    cssShow = {
      position: "absolute",
      visibility: "hidden",
      display: "block"
    },
    cssNormalTransform = {
      letterSpacing: "0",
      fontWeight: "400"
    };
  function setPositiveNumber(_elem, value, subtract) {
    // Any relative (+/-) values have already been
    // normalized at this point
    var matches = rcssNum.exec(value);
    return matches ?
    // Guard against undefined "subtract", e.g., when used as in cssHooks
    Math.max(0, matches[2] - (subtract || 0)) + (matches[3] || "px") : value;
  }
  function boxModelAdjustment(elem, dimension, box, isBorderBox, styles, computedVal) {
    var i = dimension === "width" ? 1 : 0,
      extra = 0,
      delta = 0,
      marginDelta = 0;

    // Adjustment may not be necessary
    if (box === (isBorderBox ? "border" : "content")) {
      return 0;
    }
    for (; i < 4; i += 2) {
      // Both box models exclude margin
      // Count margin delta separately to only add it after scroll gutter adjustment.
      // This is needed to make negative margins work with `outerHeight( true )` (gh-3982).
      if (box === "margin") {
        marginDelta += jQuery.css(elem, box + cssExpand[i], true, styles);
      }

      // If we get here with a content-box, we're seeking "padding" or "border" or "margin"
      if (!isBorderBox) {
        // Add padding
        delta += jQuery.css(elem, "padding" + cssExpand[i], true, styles);

        // For "border" or "margin", add border
        if (box !== "padding") {
          delta += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);

          // But still keep track of it otherwise
        } else {
          extra += jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        }

        // If we get here with a border-box (content + padding + border), we're seeking "content" or
        // "padding" or "margin"
      } else {
        // For "content", subtract padding
        if (box === "content") {
          delta -= jQuery.css(elem, "padding" + cssExpand[i], true, styles);
        }

        // For "content" or "padding", subtract border
        if (box !== "margin") {
          delta -= jQuery.css(elem, "border" + cssExpand[i] + "Width", true, styles);
        }
      }
    }

    // Account for positive content-box scroll gutter when requested by providing computedVal
    if (!isBorderBox && computedVal >= 0) {
      // offsetWidth/offsetHeight is a rounded sum of content, padding, scroll gutter, and border
      // Assuming integer scroll gutter, subtract the rest and round down
      delta += Math.max(0, Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - computedVal - delta - extra - 0.5

      // If offsetWidth/offsetHeight is unknown, then we can't determine content-box scroll gutter
      // Use an explicit zero to avoid NaN (gh-3964)
      )) || 0;
    }
    return delta + marginDelta;
  }
  function getWidthOrHeight(elem, dimension, extra) {
    // Start with computed style
    var styles = getStyles(elem),
      // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-4322).
      // Fake content-box until we know it's needed to know the true value.
      boxSizingNeeded = !support.boxSizingReliable() || extra,
      isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
      valueIsBorderBox = isBorderBox,
      val = curCSS(elem, dimension, styles),
      offsetProp = "offset" + dimension[0].toUpperCase() + dimension.slice(1);

    // Support: Firefox <=54
    // Return a confounding non-pixel value or feign ignorance, as appropriate.
    if (rnumnonpx.test(val)) {
      if (!extra) {
        return val;
      }
      val = "auto";
    }

    // Support: IE 9 - 11 only
    // Use offsetWidth/offsetHeight for when box sizing is unreliable.
    // In those cases, the computed value can be trusted to be border-box.
    if ((!support.boxSizingReliable() && isBorderBox ||
    // Support: IE 10 - 11+, Edge 15 - 18+
    // IE/Edge misreport `getComputedStyle` of table rows with width/height
    // set in CSS while `offset*` properties report correct values.
    // Interestingly, in some cases IE 9 doesn't suffer from this issue.
    !support.reliableTrDimensions() && nodeName(elem, "tr") ||
    // Fall back to offsetWidth/offsetHeight when value is "auto"
    // This happens for inline elements with no explicit setting (gh-3571)
    val === "auto" ||
    // Support: Android <=4.1 - 4.3 only
    // Also use offsetWidth/offsetHeight for misreported inline dimensions (gh-3602)
    !parseFloat(val) && jQuery.css(elem, "display", false, styles) === "inline") &&
    // Make sure the element is visible & connected
    elem.getClientRects().length) {
      isBorderBox = jQuery.css(elem, "boxSizing", false, styles) === "border-box";

      // Where available, offsetWidth/offsetHeight approximate border box dimensions.
      // Where not available (e.g., SVG), assume unreliable box-sizing and interpret the
      // retrieved value as a content box dimension.
      valueIsBorderBox = offsetProp in elem;
      if (valueIsBorderBox) {
        val = elem[offsetProp];
      }
    }

    // Normalize "" and auto
    val = parseFloat(val) || 0;

    // Adjust for the element's box model
    return val + boxModelAdjustment(elem, dimension, extra || (isBorderBox ? "border" : "content"), valueIsBorderBox, styles,
    // Provide the current computed size to request scroll gutter calculation (gh-3589)
    val) + "px";
  }
  jQuery.extend({
    // Add in style property hooks for overriding the default
    // behavior of getting and setting a style property
    cssHooks: {
      opacity: {
        get: function get(elem, computed) {
          if (computed) {
            // We should always get a number back from opacity
            var ret = curCSS(elem, "opacity");
            return ret === "" ? "1" : ret;
          }
        }
      }
    },
    // Don't automatically add "px" to these possibly-unitless properties
    cssNumber: {
      animationIterationCount: true,
      aspectRatio: true,
      borderImageSlice: true,
      columnCount: true,
      flexGrow: true,
      flexShrink: true,
      fontWeight: true,
      gridArea: true,
      gridColumn: true,
      gridColumnEnd: true,
      gridColumnStart: true,
      gridRow: true,
      gridRowEnd: true,
      gridRowStart: true,
      lineHeight: true,
      opacity: true,
      order: true,
      orphans: true,
      scale: true,
      widows: true,
      zIndex: true,
      zoom: true,
      // SVG-related
      fillOpacity: true,
      floodOpacity: true,
      stopOpacity: true,
      strokeMiterlimit: true,
      strokeOpacity: true
    },
    // Add in properties whose names you wish to fix before
    // setting or getting the value
    cssProps: {},
    // Get and set the style property on a DOM Node
    style: function style(elem, name, value, extra) {
      // Don't set styles on text and comment nodes
      if (!elem || elem.nodeType === 3 || elem.nodeType === 8 || !elem.style) {
        return;
      }

      // Make sure that we're working with the right name
      var ret,
        type,
        hooks,
        origName = camelCase(name),
        isCustomProp = rcustomProp.test(name),
        style = elem.style;

      // Make sure that we're working with the right name. We don't
      // want to query the value if it is a CSS custom property
      // since they are user-defined.
      if (!isCustomProp) {
        name = finalPropName(origName);
      }

      // Gets hook for the prefixed version, then unprefixed version
      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

      // Check if we're setting a value
      if (value !== undefined) {
        type = _typeof(value);

        // Convert "+=" or "-=" to relative numbers (trac-7345)
        if (type === "string" && (ret = rcssNum.exec(value)) && ret[1]) {
          value = adjustCSS(elem, name, ret);

          // Fixes bug trac-9237
          type = "number";
        }

        // Make sure that null and NaN values aren't set (trac-7116)
        if (value == null || value !== value) {
          return;
        }

        // If a number was passed in, add the unit (except for certain CSS properties)
        // The isCustomProp check can be removed in jQuery 4.0 when we only auto-append
        // "px" to a few hardcoded values.
        if (type === "number" && !isCustomProp) {
          value += ret && ret[3] || (jQuery.cssNumber[origName] ? "" : "px");
        }

        // background-* props affect original clone's values
        if (!support.clearCloneStyle && value === "" && name.indexOf("background") === 0) {
          style[name] = "inherit";
        }

        // If a hook was provided, use that value, otherwise just set the specified value
        if (!hooks || !("set" in hooks) || (value = hooks.set(elem, value, extra)) !== undefined) {
          if (isCustomProp) {
            style.setProperty(name, value);
          } else {
            style[name] = value;
          }
        }
      } else {
        // If a hook was provided get the non-computed value from there
        if (hooks && "get" in hooks && (ret = hooks.get(elem, false, extra)) !== undefined) {
          return ret;
        }

        // Otherwise just get the value from the style object
        return style[name];
      }
    },
    css: function css(elem, name, extra, styles) {
      var val,
        num,
        hooks,
        origName = camelCase(name),
        isCustomProp = rcustomProp.test(name);

      // Make sure that we're working with the right name. We don't
      // want to modify the value if it is a CSS custom property
      // since they are user-defined.
      if (!isCustomProp) {
        name = finalPropName(origName);
      }

      // Try prefixed name followed by the unprefixed name
      hooks = jQuery.cssHooks[name] || jQuery.cssHooks[origName];

      // If a hook was provided get the computed value from there
      if (hooks && "get" in hooks) {
        val = hooks.get(elem, true, extra);
      }

      // Otherwise, if a way to get the computed value exists, use that
      if (val === undefined) {
        val = curCSS(elem, name, styles);
      }

      // Convert "normal" to computed value
      if (val === "normal" && name in cssNormalTransform) {
        val = cssNormalTransform[name];
      }

      // Make numeric if forced or a qualifier was provided and val looks numeric
      if (extra === "" || extra) {
        num = parseFloat(val);
        return extra === true || isFinite(num) ? num || 0 : val;
      }
      return val;
    }
  });
  jQuery.each(["height", "width"], function (_i, dimension) {
    jQuery.cssHooks[dimension] = {
      get: function get(elem, computed, extra) {
        if (computed) {
          // Certain elements can have dimension info if we invisibly show them
          // but it must have a current display style that would benefit
          return rdisplayswap.test(jQuery.css(elem, "display")) && (
          // Support: Safari 8+
          // Table columns in Safari have non-zero offsetWidth & zero
          // getBoundingClientRect().width unless display is changed.
          // Support: IE <=11 only
          // Running getBoundingClientRect on a disconnected node
          // in IE throws an error.
          !elem.getClientRects().length || !elem.getBoundingClientRect().width) ? swap(elem, cssShow, function () {
            return getWidthOrHeight(elem, dimension, extra);
          }) : getWidthOrHeight(elem, dimension, extra);
        }
      },
      set: function set(elem, value, extra) {
        var matches,
          styles = getStyles(elem),
          // Only read styles.position if the test has a chance to fail
          // to avoid forcing a reflow.
          scrollboxSizeBuggy = !support.scrollboxSize() && styles.position === "absolute",
          // To avoid forcing a reflow, only fetch boxSizing if we need it (gh-3991)
          boxSizingNeeded = scrollboxSizeBuggy || extra,
          isBorderBox = boxSizingNeeded && jQuery.css(elem, "boxSizing", false, styles) === "border-box",
          subtract = extra ? boxModelAdjustment(elem, dimension, extra, isBorderBox, styles) : 0;

        // Account for unreliable border-box dimensions by comparing offset* to computed and
        // faking a content-box to get border and padding (gh-3699)
        if (isBorderBox && scrollboxSizeBuggy) {
          subtract -= Math.ceil(elem["offset" + dimension[0].toUpperCase() + dimension.slice(1)] - parseFloat(styles[dimension]) - boxModelAdjustment(elem, dimension, "border", false, styles) - 0.5);
        }

        // Convert to pixels if value adjustment is needed
        if (subtract && (matches = rcssNum.exec(value)) && (matches[3] || "px") !== "px") {
          elem.style[dimension] = value;
          value = jQuery.css(elem, dimension);
        }
        return setPositiveNumber(elem, value, subtract);
      }
    };
  });
  jQuery.cssHooks.marginLeft = addGetHookIf(support.reliableMarginLeft, function (elem, computed) {
    if (computed) {
      return (parseFloat(curCSS(elem, "marginLeft")) || elem.getBoundingClientRect().left - swap(elem, {
        marginLeft: 0
      }, function () {
        return elem.getBoundingClientRect().left;
      })) + "px";
    }
  });

  // These hooks are used by animate to expand properties
  jQuery.each({
    margin: "",
    padding: "",
    border: "Width"
  }, function (prefix, suffix) {
    jQuery.cssHooks[prefix + suffix] = {
      expand: function expand(value) {
        var i = 0,
          expanded = {},
          // Assumes a single number if not a string
          parts = typeof value === "string" ? value.split(" ") : [value];
        for (; i < 4; i++) {
          expanded[prefix + cssExpand[i] + suffix] = parts[i] || parts[i - 2] || parts[0];
        }
        return expanded;
      }
    };
    if (prefix !== "margin") {
      jQuery.cssHooks[prefix + suffix].set = setPositiveNumber;
    }
  });
  jQuery.fn.extend({
    css: function css(name, value) {
      return _access(this, function (elem, name, value) {
        var styles,
          len,
          map = {},
          i = 0;
        if (Array.isArray(name)) {
          styles = getStyles(elem);
          len = name.length;
          for (; i < len; i++) {
            map[name[i]] = jQuery.css(elem, name[i], false, styles);
          }
          return map;
        }
        return value !== undefined ? jQuery.style(elem, name, value) : jQuery.css(elem, name);
      }, name, value, arguments.length > 1);
    }
  });
  function Tween(elem, options, prop, end, easing) {
    return new Tween.prototype.init(elem, options, prop, end, easing);
  }
  jQuery.Tween = Tween;
  Tween.prototype = {
    constructor: Tween,
    init: function init(elem, options, prop, end, easing, unit) {
      this.elem = elem;
      this.prop = prop;
      this.easing = easing || jQuery.easing._default;
      this.options = options;
      this.start = this.now = this.cur();
      this.end = end;
      this.unit = unit || (jQuery.cssNumber[prop] ? "" : "px");
    },
    cur: function cur() {
      var hooks = Tween.propHooks[this.prop];
      return hooks && hooks.get ? hooks.get(this) : Tween.propHooks._default.get(this);
    },
    run: function run(percent) {
      var eased,
        hooks = Tween.propHooks[this.prop];
      if (this.options.duration) {
        this.pos = eased = jQuery.easing[this.easing](percent, this.options.duration * percent, 0, 1, this.options.duration);
      } else {
        this.pos = eased = percent;
      }
      this.now = (this.end - this.start) * eased + this.start;
      if (this.options.step) {
        this.options.step.call(this.elem, this.now, this);
      }
      if (hooks && hooks.set) {
        hooks.set(this);
      } else {
        Tween.propHooks._default.set(this);
      }
      return this;
    }
  };
  Tween.prototype.init.prototype = Tween.prototype;
  Tween.propHooks = {
    _default: {
      get: function get(tween) {
        var result;

        // Use a property on the element directly when it is not a DOM element,
        // or when there is no matching style property that exists.
        if (tween.elem.nodeType !== 1 || tween.elem[tween.prop] != null && tween.elem.style[tween.prop] == null) {
          return tween.elem[tween.prop];
        }

        // Passing an empty string as a 3rd parameter to .css will automatically
        // attempt a parseFloat and fallback to a string if the parse fails.
        // Simple values such as "10px" are parsed to Float;
        // complex values such as "rotate(1rad)" are returned as-is.
        result = jQuery.css(tween.elem, tween.prop, "");

        // Empty strings, null, undefined and "auto" are converted to 0.
        return !result || result === "auto" ? 0 : result;
      },
      set: function set(tween) {
        // Use step hook for back compat.
        // Use cssHook if its there.
        // Use .style if available and use plain properties where available.
        if (jQuery.fx.step[tween.prop]) {
          jQuery.fx.step[tween.prop](tween);
        } else if (tween.elem.nodeType === 1 && (jQuery.cssHooks[tween.prop] || tween.elem.style[finalPropName(tween.prop)] != null)) {
          jQuery.style(tween.elem, tween.prop, tween.now + tween.unit);
        } else {
          tween.elem[tween.prop] = tween.now;
        }
      }
    }
  };

  // Support: IE <=9 only
  // Panic based approach to setting things on disconnected nodes
  Tween.propHooks.scrollTop = Tween.propHooks.scrollLeft = {
    set: function set(tween) {
      if (tween.elem.nodeType && tween.elem.parentNode) {
        tween.elem[tween.prop] = tween.now;
      }
    }
  };
  jQuery.easing = {
    linear: function linear(p) {
      return p;
    },
    swing: function swing(p) {
      return 0.5 - Math.cos(p * Math.PI) / 2;
    },
    _default: "swing"
  };
  jQuery.fx = Tween.prototype.init;

  // Back compat <1.8 extension point
  jQuery.fx.step = {};
  var fxNow,
    inProgress,
    rfxtypes = /^(?:toggle|show|hide)$/,
    rrun = /queueHooks$/;
  function schedule() {
    if (inProgress) {
      if (document.hidden === false && window.requestAnimationFrame) {
        window.requestAnimationFrame(schedule);
      } else {
        window.setTimeout(schedule, jQuery.fx.interval);
      }
      jQuery.fx.tick();
    }
  }

  // Animations created synchronously will run synchronously
  function createFxNow() {
    window.setTimeout(function () {
      fxNow = undefined;
    });
    return fxNow = Date.now();
  }

  // Generate parameters to create a standard animation
  function genFx(type, includeWidth) {
    var which,
      i = 0,
      attrs = {
        height: type
      };

    // If we include width, step value is 1 to do all cssExpand values,
    // otherwise step value is 2 to skip over Left and Right
    includeWidth = includeWidth ? 1 : 0;
    for (; i < 4; i += 2 - includeWidth) {
      which = cssExpand[i];
      attrs["margin" + which] = attrs["padding" + which] = type;
    }
    if (includeWidth) {
      attrs.opacity = attrs.width = type;
    }
    return attrs;
  }
  function createTween(value, prop, animation) {
    var tween,
      collection = (Animation.tweeners[prop] || []).concat(Animation.tweeners["*"]),
      index = 0,
      length = collection.length;
    for (; index < length; index++) {
      if (tween = collection[index].call(animation, prop, value)) {
        // We're done with this property
        return tween;
      }
    }
  }
  function defaultPrefilter(elem, props, opts) {
    var prop,
      value,
      toggle,
      hooks,
      oldfire,
      propTween,
      restoreDisplay,
      display,
      isBox = "width" in props || "height" in props,
      anim = this,
      orig = {},
      style = elem.style,
      hidden = elem.nodeType && isHiddenWithinTree(elem),
      dataShow = dataPriv.get(elem, "fxshow");

    // Queue-skipping animations hijack the fx hooks
    if (!opts.queue) {
      hooks = jQuery._queueHooks(elem, "fx");
      if (hooks.unqueued == null) {
        hooks.unqueued = 0;
        oldfire = hooks.empty.fire;
        hooks.empty.fire = function () {
          if (!hooks.unqueued) {
            oldfire();
          }
        };
      }
      hooks.unqueued++;
      anim.always(function () {
        // Ensure the complete handler is called before this completes
        anim.always(function () {
          hooks.unqueued--;
          if (!jQuery.queue(elem, "fx").length) {
            hooks.empty.fire();
          }
        });
      });
    }

    // Detect show/hide animations
    for (prop in props) {
      value = props[prop];
      if (rfxtypes.test(value)) {
        delete props[prop];
        toggle = toggle || value === "toggle";
        if (value === (hidden ? "hide" : "show")) {
          // Pretend to be hidden if this is a "show" and
          // there is still data from a stopped show/hide
          if (value === "show" && dataShow && dataShow[prop] !== undefined) {
            hidden = true;

            // Ignore all other no-op show/hide data
          } else {
            continue;
          }
        }
        orig[prop] = dataShow && dataShow[prop] || jQuery.style(elem, prop);
      }
    }

    // Bail out if this is a no-op like .hide().hide()
    propTween = !jQuery.isEmptyObject(props);
    if (!propTween && jQuery.isEmptyObject(orig)) {
      return;
    }

    // Restrict "overflow" and "display" styles during box animations
    if (isBox && elem.nodeType === 1) {
      // Support: IE <=9 - 11, Edge 12 - 15
      // Record all 3 overflow attributes because IE does not infer the shorthand
      // from identically-valued overflowX and overflowY and Edge just mirrors
      // the overflowX value there.
      opts.overflow = [style.overflow, style.overflowX, style.overflowY];

      // Identify a display type, preferring old show/hide data over the CSS cascade
      restoreDisplay = dataShow && dataShow.display;
      if (restoreDisplay == null) {
        restoreDisplay = dataPriv.get(elem, "display");
      }
      display = jQuery.css(elem, "display");
      if (display === "none") {
        if (restoreDisplay) {
          display = restoreDisplay;
        } else {
          // Get nonempty value(s) by temporarily forcing visibility
          showHide([elem], true);
          restoreDisplay = elem.style.display || restoreDisplay;
          display = jQuery.css(elem, "display");
          showHide([elem]);
        }
      }

      // Animate inline elements as inline-block
      if (display === "inline" || display === "inline-block" && restoreDisplay != null) {
        if (jQuery.css(elem, "float") === "none") {
          // Restore the original display value at the end of pure show/hide animations
          if (!propTween) {
            anim.done(function () {
              style.display = restoreDisplay;
            });
            if (restoreDisplay == null) {
              display = style.display;
              restoreDisplay = display === "none" ? "" : display;
            }
          }
          style.display = "inline-block";
        }
      }
    }
    if (opts.overflow) {
      style.overflow = "hidden";
      anim.always(function () {
        style.overflow = opts.overflow[0];
        style.overflowX = opts.overflow[1];
        style.overflowY = opts.overflow[2];
      });
    }

    // Implement show/hide animations
    propTween = false;
    for (prop in orig) {
      // General show/hide setup for this element animation
      if (!propTween) {
        if (dataShow) {
          if ("hidden" in dataShow) {
            hidden = dataShow.hidden;
          }
        } else {
          dataShow = dataPriv.access(elem, "fxshow", {
            display: restoreDisplay
          });
        }

        // Store hidden/visible for toggle so `.stop().toggle()` "reverses"
        if (toggle) {
          dataShow.hidden = !hidden;
        }

        // Show elements before animating them
        if (hidden) {
          showHide([elem], true);
        }

        /* eslint-disable no-loop-func */

        anim.done(function () {
          /* eslint-enable no-loop-func */

          // The final step of a "hide" animation is actually hiding the element
          if (!hidden) {
            showHide([elem]);
          }
          dataPriv.remove(elem, "fxshow");
          for (prop in orig) {
            jQuery.style(elem, prop, orig[prop]);
          }
        });
      }

      // Per-property setup
      propTween = createTween(hidden ? dataShow[prop] : 0, prop, anim);
      if (!(prop in dataShow)) {
        dataShow[prop] = propTween.start;
        if (hidden) {
          propTween.end = propTween.start;
          propTween.start = 0;
        }
      }
    }
  }
  function propFilter(props, specialEasing) {
    var index, name, easing, value, hooks;

    // camelCase, specialEasing and expand cssHook pass
    for (index in props) {
      name = camelCase(index);
      easing = specialEasing[name];
      value = props[index];
      if (Array.isArray(value)) {
        easing = value[1];
        value = props[index] = value[0];
      }
      if (index !== name) {
        props[name] = value;
        delete props[index];
      }
      hooks = jQuery.cssHooks[name];
      if (hooks && "expand" in hooks) {
        value = hooks.expand(value);
        delete props[name];

        // Not quite $.extend, this won't overwrite existing keys.
        // Reusing 'index' because we have the correct "name"
        for (index in value) {
          if (!(index in props)) {
            props[index] = value[index];
            specialEasing[index] = easing;
          }
        }
      } else {
        specialEasing[name] = easing;
      }
    }
  }
  function Animation(elem, properties, options) {
    var result,
      stopped,
      index = 0,
      length = Animation.prefilters.length,
      deferred = jQuery.Deferred().always(function () {
        // Don't match elem in the :animated selector
        delete tick.elem;
      }),
      tick = function tick() {
        if (stopped) {
          return false;
        }
        var currentTime = fxNow || createFxNow(),
          remaining = Math.max(0, animation.startTime + animation.duration - currentTime),
          // Support: Android 2.3 only
          // Archaic crash bug won't allow us to use `1 - ( 0.5 || 0 )` (trac-12497)
          temp = remaining / animation.duration || 0,
          percent = 1 - temp,
          index = 0,
          length = animation.tweens.length;
        for (; index < length; index++) {
          animation.tweens[index].run(percent);
        }
        deferred.notifyWith(elem, [animation, percent, remaining]);

        // If there's more to do, yield
        if (percent < 1 && length) {
          return remaining;
        }

        // If this was an empty animation, synthesize a final progress notification
        if (!length) {
          deferred.notifyWith(elem, [animation, 1, 0]);
        }

        // Resolve the animation and report its conclusion
        deferred.resolveWith(elem, [animation]);
        return false;
      },
      animation = deferred.promise({
        elem: elem,
        props: jQuery.extend({}, properties),
        opts: jQuery.extend(true, {
          specialEasing: {},
          easing: jQuery.easing._default
        }, options),
        originalProperties: properties,
        originalOptions: options,
        startTime: fxNow || createFxNow(),
        duration: options.duration,
        tweens: [],
        createTween: function createTween(prop, end) {
          var tween = jQuery.Tween(elem, animation.opts, prop, end, animation.opts.specialEasing[prop] || animation.opts.easing);
          animation.tweens.push(tween);
          return tween;
        },
        stop: function stop(gotoEnd) {
          var index = 0,
            // If we are going to the end, we want to run all the tweens
            // otherwise we skip this part
            length = gotoEnd ? animation.tweens.length : 0;
          if (stopped) {
            return this;
          }
          stopped = true;
          for (; index < length; index++) {
            animation.tweens[index].run(1);
          }

          // Resolve when we played the last frame; otherwise, reject
          if (gotoEnd) {
            deferred.notifyWith(elem, [animation, 1, 0]);
            deferred.resolveWith(elem, [animation, gotoEnd]);
          } else {
            deferred.rejectWith(elem, [animation, gotoEnd]);
          }
          return this;
        }
      }),
      props = animation.props;
    propFilter(props, animation.opts.specialEasing);
    for (; index < length; index++) {
      result = Animation.prefilters[index].call(animation, elem, props, animation.opts);
      if (result) {
        if (isFunction(result.stop)) {
          jQuery._queueHooks(animation.elem, animation.opts.queue).stop = result.stop.bind(result);
        }
        return result;
      }
    }
    jQuery.map(props, createTween, animation);
    if (isFunction(animation.opts.start)) {
      animation.opts.start.call(elem, animation);
    }

    // Attach callbacks from options
    animation.progress(animation.opts.progress).done(animation.opts.done, animation.opts.complete).fail(animation.opts.fail).always(animation.opts.always);
    jQuery.fx.timer(jQuery.extend(tick, {
      elem: elem,
      anim: animation,
      queue: animation.opts.queue
    }));
    return animation;
  }
  jQuery.Animation = jQuery.extend(Animation, {
    tweeners: {
      "*": [function (prop, value) {
        var tween = this.createTween(prop, value);
        adjustCSS(tween.elem, prop, rcssNum.exec(value), tween);
        return tween;
      }]
    },
    tweener: function tweener(props, callback) {
      if (isFunction(props)) {
        callback = props;
        props = ["*"];
      } else {
        props = props.match(rnothtmlwhite);
      }
      var prop,
        index = 0,
        length = props.length;
      for (; index < length; index++) {
        prop = props[index];
        Animation.tweeners[prop] = Animation.tweeners[prop] || [];
        Animation.tweeners[prop].unshift(callback);
      }
    },
    prefilters: [defaultPrefilter],
    prefilter: function prefilter(callback, prepend) {
      if (prepend) {
        Animation.prefilters.unshift(callback);
      } else {
        Animation.prefilters.push(callback);
      }
    }
  });
  jQuery.speed = function (speed, easing, fn) {
    var opt = speed && _typeof(speed) === "object" ? jQuery.extend({}, speed) : {
      complete: fn || !fn && easing || isFunction(speed) && speed,
      duration: speed,
      easing: fn && easing || easing && !isFunction(easing) && easing
    };

    // Go to the end state if fx are off
    if (jQuery.fx.off) {
      opt.duration = 0;
    } else {
      if (typeof opt.duration !== "number") {
        if (opt.duration in jQuery.fx.speeds) {
          opt.duration = jQuery.fx.speeds[opt.duration];
        } else {
          opt.duration = jQuery.fx.speeds._default;
        }
      }
    }

    // Normalize opt.queue - true/undefined/null -> "fx"
    if (opt.queue == null || opt.queue === true) {
      opt.queue = "fx";
    }

    // Queueing
    opt.old = opt.complete;
    opt.complete = function () {
      if (isFunction(opt.old)) {
        opt.old.call(this);
      }
      if (opt.queue) {
        jQuery.dequeue(this, opt.queue);
      }
    };
    return opt;
  };
  jQuery.fn.extend({
    fadeTo: function fadeTo(speed, to, easing, callback) {
      // Show any hidden elements after setting opacity to 0
      return this.filter(isHiddenWithinTree).css("opacity", 0).show()

      // Animate to the value specified
      .end().animate({
        opacity: to
      }, speed, easing, callback);
    },
    animate: function animate(prop, speed, easing, callback) {
      var empty = jQuery.isEmptyObject(prop),
        optall = jQuery.speed(speed, easing, callback),
        doAnimation = function doAnimation() {
          // Operate on a copy of prop so per-property easing won't be lost
          var anim = Animation(this, jQuery.extend({}, prop), optall);

          // Empty animations, or finishing resolves immediately
          if (empty || dataPriv.get(this, "finish")) {
            anim.stop(true);
          }
        };
      doAnimation.finish = doAnimation;
      return empty || optall.queue === false ? this.each(doAnimation) : this.queue(optall.queue, doAnimation);
    },
    stop: function stop(type, clearQueue, gotoEnd) {
      var stopQueue = function stopQueue(hooks) {
        var stop = hooks.stop;
        delete hooks.stop;
        stop(gotoEnd);
      };
      if (typeof type !== "string") {
        gotoEnd = clearQueue;
        clearQueue = type;
        type = undefined;
      }
      if (clearQueue) {
        this.queue(type || "fx", []);
      }
      return this.each(function () {
        var dequeue = true,
          index = type != null && type + "queueHooks",
          timers = jQuery.timers,
          data = dataPriv.get(this);
        if (index) {
          if (data[index] && data[index].stop) {
            stopQueue(data[index]);
          }
        } else {
          for (index in data) {
            if (data[index] && data[index].stop && rrun.test(index)) {
              stopQueue(data[index]);
            }
          }
        }
        for (index = timers.length; index--;) {
          if (timers[index].elem === this && (type == null || timers[index].queue === type)) {
            timers[index].anim.stop(gotoEnd);
            dequeue = false;
            timers.splice(index, 1);
          }
        }

        // Start the next in the queue if the last step wasn't forced.
        // Timers currently will call their complete callbacks, which
        // will dequeue but only if they were gotoEnd.
        if (dequeue || !gotoEnd) {
          jQuery.dequeue(this, type);
        }
      });
    },
    finish: function finish(type) {
      if (type !== false) {
        type = type || "fx";
      }
      return this.each(function () {
        var index,
          data = dataPriv.get(this),
          queue = data[type + "queue"],
          hooks = data[type + "queueHooks"],
          timers = jQuery.timers,
          length = queue ? queue.length : 0;

        // Enable finishing flag on private data
        data.finish = true;

        // Empty the queue first
        jQuery.queue(this, type, []);
        if (hooks && hooks.stop) {
          hooks.stop.call(this, true);
        }

        // Look for any active animations, and finish them
        for (index = timers.length; index--;) {
          if (timers[index].elem === this && timers[index].queue === type) {
            timers[index].anim.stop(true);
            timers.splice(index, 1);
          }
        }

        // Look for any animations in the old queue and finish them
        for (index = 0; index < length; index++) {
          if (queue[index] && queue[index].finish) {
            queue[index].finish.call(this);
          }
        }

        // Turn off finishing flag
        delete data.finish;
      });
    }
  });
  jQuery.each(["toggle", "show", "hide"], function (_i, name) {
    var cssFn = jQuery.fn[name];
    jQuery.fn[name] = function (speed, easing, callback) {
      return speed == null || typeof speed === "boolean" ? cssFn.apply(this, arguments) : this.animate(genFx(name, true), speed, easing, callback);
    };
  });

  // Generate shortcuts for custom animations
  jQuery.each({
    slideDown: genFx("show"),
    slideUp: genFx("hide"),
    slideToggle: genFx("toggle"),
    fadeIn: {
      opacity: "show"
    },
    fadeOut: {
      opacity: "hide"
    },
    fadeToggle: {
      opacity: "toggle"
    }
  }, function (name, props) {
    jQuery.fn[name] = function (speed, easing, callback) {
      return this.animate(props, speed, easing, callback);
    };
  });
  jQuery.timers = [];
  jQuery.fx.tick = function () {
    var timer,
      i = 0,
      timers = jQuery.timers;
    fxNow = Date.now();
    for (; i < timers.length; i++) {
      timer = timers[i];

      // Run the timer and safely remove it when done (allowing for external removal)
      if (!timer() && timers[i] === timer) {
        timers.splice(i--, 1);
      }
    }
    if (!timers.length) {
      jQuery.fx.stop();
    }
    fxNow = undefined;
  };
  jQuery.fx.timer = function (timer) {
    jQuery.timers.push(timer);
    jQuery.fx.start();
  };
  jQuery.fx.interval = 13;
  jQuery.fx.start = function () {
    if (inProgress) {
      return;
    }
    inProgress = true;
    schedule();
  };
  jQuery.fx.stop = function () {
    inProgress = null;
  };
  jQuery.fx.speeds = {
    slow: 600,
    fast: 200,
    // Default speed
    _default: 400
  };

  // Based off of the plugin by Clint Helfers, with permission.
  jQuery.fn.delay = function (time, type) {
    time = jQuery.fx ? jQuery.fx.speeds[time] || time : time;
    type = type || "fx";
    return this.queue(type, function (next, hooks) {
      var timeout = window.setTimeout(next, time);
      hooks.stop = function () {
        window.clearTimeout(timeout);
      };
    });
  };
  (function () {
    var input = document.createElement("input"),
      select = document.createElement("select"),
      opt = select.appendChild(document.createElement("option"));
    input.type = "checkbox";

    // Support: Android <=4.3 only
    // Default value for a checkbox should be "on"
    support.checkOn = input.value !== "";

    // Support: IE <=11 only
    // Must access selectedIndex to make default options select
    support.optSelected = opt.selected;

    // Support: IE <=11 only
    // An input loses its value after becoming a radio
    input = document.createElement("input");
    input.value = "t";
    input.type = "radio";
    support.radioValue = input.value === "t";
  })();
  var boolHook,
    attrHandle = jQuery.expr.attrHandle;
  jQuery.fn.extend({
    attr: function attr(name, value) {
      return _access(this, jQuery.attr, name, value, arguments.length > 1);
    },
    removeAttr: function removeAttr(name) {
      return this.each(function () {
        jQuery.removeAttr(this, name);
      });
    }
  });
  jQuery.extend({
    attr: function attr(elem, name, value) {
      var ret,
        hooks,
        nType = elem.nodeType;

      // Don't get/set attributes on text, comment and attribute nodes
      if (nType === 3 || nType === 8 || nType === 2) {
        return;
      }

      // Fallback to prop when attributes are not supported
      if (typeof elem.getAttribute === "undefined") {
        return jQuery.prop(elem, name, value);
      }

      // Attribute hooks are determined by the lowercase version
      // Grab necessary hook if one is defined
      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
        hooks = jQuery.attrHooks[name.toLowerCase()] || (jQuery.expr.match.bool.test(name) ? boolHook : undefined);
      }
      if (value !== undefined) {
        if (value === null) {
          jQuery.removeAttr(elem, name);
          return;
        }
        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
          return ret;
        }
        elem.setAttribute(name, value + "");
        return value;
      }
      if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
        return ret;
      }
      ret = jQuery.find.attr(elem, name);

      // Non-existent attributes return null, we normalize to undefined
      return ret == null ? undefined : ret;
    },
    attrHooks: {
      type: {
        set: function set(elem, value) {
          if (!support.radioValue && value === "radio" && nodeName(elem, "input")) {
            var val = elem.value;
            elem.setAttribute("type", value);
            if (val) {
              elem.value = val;
            }
            return value;
          }
        }
      }
    },
    removeAttr: function removeAttr(elem, value) {
      var name,
        i = 0,
        // Attribute names can contain non-HTML whitespace characters
        // https://html.spec.whatwg.org/multipage/syntax.html#attributes-2
        attrNames = value && value.match(rnothtmlwhite);
      if (attrNames && elem.nodeType === 1) {
        while (name = attrNames[i++]) {
          elem.removeAttribute(name);
        }
      }
    }
  });

  // Hooks for boolean attributes
  boolHook = {
    set: function set(elem, value, name) {
      if (value === false) {
        // Remove boolean attributes when set to false
        jQuery.removeAttr(elem, name);
      } else {
        elem.setAttribute(name, name);
      }
      return name;
    }
  };
  jQuery.each(jQuery.expr.match.bool.source.match(/\w+/g), function (_i, name) {
    var getter = attrHandle[name] || jQuery.find.attr;
    attrHandle[name] = function (elem, name, isXML) {
      var ret,
        handle,
        lowercaseName = name.toLowerCase();
      if (!isXML) {
        // Avoid an infinite loop by temporarily removing this function from the getter
        handle = attrHandle[lowercaseName];
        attrHandle[lowercaseName] = ret;
        ret = getter(elem, name, isXML) != null ? lowercaseName : null;
        attrHandle[lowercaseName] = handle;
      }
      return ret;
    };
  });
  var rfocusable = /^(?:input|select|textarea|button)$/i,
    rclickable = /^(?:a|area)$/i;
  jQuery.fn.extend({
    prop: function prop(name, value) {
      return _access(this, jQuery.prop, name, value, arguments.length > 1);
    },
    removeProp: function removeProp(name) {
      return this.each(function () {
        delete this[jQuery.propFix[name] || name];
      });
    }
  });
  jQuery.extend({
    prop: function prop(elem, name, value) {
      var ret,
        hooks,
        nType = elem.nodeType;

      // Don't get/set properties on text, comment and attribute nodes
      if (nType === 3 || nType === 8 || nType === 2) {
        return;
      }
      if (nType !== 1 || !jQuery.isXMLDoc(elem)) {
        // Fix name and attach hooks
        name = jQuery.propFix[name] || name;
        hooks = jQuery.propHooks[name];
      }
      if (value !== undefined) {
        if (hooks && "set" in hooks && (ret = hooks.set(elem, value, name)) !== undefined) {
          return ret;
        }
        return elem[name] = value;
      }
      if (hooks && "get" in hooks && (ret = hooks.get(elem, name)) !== null) {
        return ret;
      }
      return elem[name];
    },
    propHooks: {
      tabIndex: {
        get: function get(elem) {
          // Support: IE <=9 - 11 only
          // elem.tabIndex doesn't always return the
          // correct value when it hasn't been explicitly set
          // Use proper attribute retrieval (trac-12072)
          var tabindex = jQuery.find.attr(elem, "tabindex");
          if (tabindex) {
            return parseInt(tabindex, 10);
          }
          if (rfocusable.test(elem.nodeName) || rclickable.test(elem.nodeName) && elem.href) {
            return 0;
          }
          return -1;
        }
      }
    },
    propFix: {
      "for": "htmlFor",
      "class": "className"
    }
  });

  // Support: IE <=11 only
  // Accessing the selectedIndex property
  // forces the browser to respect setting selected
  // on the option
  // The getter ensures a default option is selected
  // when in an optgroup
  // eslint rule "no-unused-expressions" is disabled for this code
  // since it considers such accessions noop
  if (!support.optSelected) {
    jQuery.propHooks.selected = {
      get: function get(elem) {
        /* eslint no-unused-expressions: "off" */

        var parent = elem.parentNode;
        if (parent && parent.parentNode) {
          parent.parentNode.selectedIndex;
        }
        return null;
      },
      set: function set(elem) {
        /* eslint no-unused-expressions: "off" */

        var parent = elem.parentNode;
        if (parent) {
          parent.selectedIndex;
          if (parent.parentNode) {
            parent.parentNode.selectedIndex;
          }
        }
      }
    };
  }
  jQuery.each(["tabIndex", "readOnly", "maxLength", "cellSpacing", "cellPadding", "rowSpan", "colSpan", "useMap", "frameBorder", "contentEditable"], function () {
    jQuery.propFix[this.toLowerCase()] = this;
  });

  // Strip and collapse whitespace according to HTML spec
  // https://infra.spec.whatwg.org/#strip-and-collapse-ascii-whitespace
  function stripAndCollapse(value) {
    var tokens = value.match(rnothtmlwhite) || [];
    return tokens.join(" ");
  }
  function getClass(elem) {
    return elem.getAttribute && elem.getAttribute("class") || "";
  }
  function classesToArray(value) {
    if (Array.isArray(value)) {
      return value;
    }
    if (typeof value === "string") {
      return value.match(rnothtmlwhite) || [];
    }
    return [];
  }
  jQuery.fn.extend({
    addClass: function addClass(value) {
      var classNames, cur, curValue, className, i, finalValue;
      if (isFunction(value)) {
        return this.each(function (j) {
          jQuery(this).addClass(value.call(this, j, getClass(this)));
        });
      }
      classNames = classesToArray(value);
      if (classNames.length) {
        return this.each(function () {
          curValue = getClass(this);
          cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
          if (cur) {
            for (i = 0; i < classNames.length; i++) {
              className = classNames[i];
              if (cur.indexOf(" " + className + " ") < 0) {
                cur += className + " ";
              }
            }

            // Only assign if different to avoid unneeded rendering.
            finalValue = stripAndCollapse(cur);
            if (curValue !== finalValue) {
              this.setAttribute("class", finalValue);
            }
          }
        });
      }
      return this;
    },
    removeClass: function removeClass(value) {
      var classNames, cur, curValue, className, i, finalValue;
      if (isFunction(value)) {
        return this.each(function (j) {
          jQuery(this).removeClass(value.call(this, j, getClass(this)));
        });
      }
      if (!arguments.length) {
        return this.attr("class", "");
      }
      classNames = classesToArray(value);
      if (classNames.length) {
        return this.each(function () {
          curValue = getClass(this);

          // This expression is here for better compressibility (see addClass)
          cur = this.nodeType === 1 && " " + stripAndCollapse(curValue) + " ";
          if (cur) {
            for (i = 0; i < classNames.length; i++) {
              className = classNames[i];

              // Remove *all* instances
              while (cur.indexOf(" " + className + " ") > -1) {
                cur = cur.replace(" " + className + " ", " ");
              }
            }

            // Only assign if different to avoid unneeded rendering.
            finalValue = stripAndCollapse(cur);
            if (curValue !== finalValue) {
              this.setAttribute("class", finalValue);
            }
          }
        });
      }
      return this;
    },
    toggleClass: function toggleClass(value, stateVal) {
      var classNames,
        className,
        i,
        self,
        type = _typeof(value),
        isValidValue = type === "string" || Array.isArray(value);
      if (isFunction(value)) {
        return this.each(function (i) {
          jQuery(this).toggleClass(value.call(this, i, getClass(this), stateVal), stateVal);
        });
      }
      if (typeof stateVal === "boolean" && isValidValue) {
        return stateVal ? this.addClass(value) : this.removeClass(value);
      }
      classNames = classesToArray(value);
      return this.each(function () {
        if (isValidValue) {
          // Toggle individual class names
          self = jQuery(this);
          for (i = 0; i < classNames.length; i++) {
            className = classNames[i];

            // Check each className given, space separated list
            if (self.hasClass(className)) {
              self.removeClass(className);
            } else {
              self.addClass(className);
            }
          }

          // Toggle whole class name
        } else if (value === undefined || type === "boolean") {
          className = getClass(this);
          if (className) {
            // Store className if set
            dataPriv.set(this, "__className__", className);
          }

          // If the element has a class name or if we're passed `false`,
          // then remove the whole classname (if there was one, the above saved it).
          // Otherwise bring back whatever was previously saved (if anything),
          // falling back to the empty string if nothing was stored.
          if (this.setAttribute) {
            this.setAttribute("class", className || value === false ? "" : dataPriv.get(this, "__className__") || "");
          }
        }
      });
    },
    hasClass: function hasClass(selector) {
      var className,
        elem,
        i = 0;
      className = " " + selector + " ";
      while (elem = this[i++]) {
        if (elem.nodeType === 1 && (" " + stripAndCollapse(getClass(elem)) + " ").indexOf(className) > -1) {
          return true;
        }
      }
      return false;
    }
  });
  var rreturn = /\r/g;
  jQuery.fn.extend({
    val: function val(value) {
      var hooks,
        ret,
        valueIsFunction,
        elem = this[0];
      if (!arguments.length) {
        if (elem) {
          hooks = jQuery.valHooks[elem.type] || jQuery.valHooks[elem.nodeName.toLowerCase()];
          if (hooks && "get" in hooks && (ret = hooks.get(elem, "value")) !== undefined) {
            return ret;
          }
          ret = elem.value;

          // Handle most common string cases
          if (typeof ret === "string") {
            return ret.replace(rreturn, "");
          }

          // Handle cases where value is null/undef or number
          return ret == null ? "" : ret;
        }
        return;
      }
      valueIsFunction = isFunction(value);
      return this.each(function (i) {
        var val;
        if (this.nodeType !== 1) {
          return;
        }
        if (valueIsFunction) {
          val = value.call(this, i, jQuery(this).val());
        } else {
          val = value;
        }

        // Treat null/undefined as ""; convert numbers to string
        if (val == null) {
          val = "";
        } else if (typeof val === "number") {
          val += "";
        } else if (Array.isArray(val)) {
          val = jQuery.map(val, function (value) {
            return value == null ? "" : value + "";
          });
        }
        hooks = jQuery.valHooks[this.type] || jQuery.valHooks[this.nodeName.toLowerCase()];

        // If set returns undefined, fall back to normal setting
        if (!hooks || !("set" in hooks) || hooks.set(this, val, "value") === undefined) {
          this.value = val;
        }
      });
    }
  });
  jQuery.extend({
    valHooks: {
      option: {
        get: function get(elem) {
          var val = jQuery.find.attr(elem, "value");
          return val != null ? val :
          // Support: IE <=10 - 11 only
          // option.text throws exceptions (trac-14686, trac-14858)
          // Strip and collapse whitespace
          // https://html.spec.whatwg.org/#strip-and-collapse-whitespace
          stripAndCollapse(jQuery.text(elem));
        }
      },
      select: {
        get: function get(elem) {
          var value,
            option,
            i,
            options = elem.options,
            index = elem.selectedIndex,
            one = elem.type === "select-one",
            values = one ? null : [],
            max = one ? index + 1 : options.length;
          if (index < 0) {
            i = max;
          } else {
            i = one ? index : 0;
          }

          // Loop through all the selected options
          for (; i < max; i++) {
            option = options[i];

            // Support: IE <=9 only
            // IE8-9 doesn't update selected after form reset (trac-2551)
            if ((option.selected || i === index) &&
            // Don't return options that are disabled or in a disabled optgroup
            !option.disabled && (!option.parentNode.disabled || !nodeName(option.parentNode, "optgroup"))) {
              // Get the specific value for the option
              value = jQuery(option).val();

              // We don't need an array for one selects
              if (one) {
                return value;
              }

              // Multi-Selects return an array
              values.push(value);
            }
          }
          return values;
        },
        set: function set(elem, value) {
          var optionSet,
            option,
            options = elem.options,
            values = jQuery.makeArray(value),
            i = options.length;
          while (i--) {
            option = options[i];

            /* eslint-disable no-cond-assign */

            if (option.selected = jQuery.inArray(jQuery.valHooks.option.get(option), values) > -1) {
              optionSet = true;
            }

            /* eslint-enable no-cond-assign */
          }

          // Force browsers to behave consistently when non-matching value is set
          if (!optionSet) {
            elem.selectedIndex = -1;
          }
          return values;
        }
      }
    }
  });

  // Radios and checkboxes getter/setter
  jQuery.each(["radio", "checkbox"], function () {
    jQuery.valHooks[this] = {
      set: function set(elem, value) {
        if (Array.isArray(value)) {
          return elem.checked = jQuery.inArray(jQuery(elem).val(), value) > -1;
        }
      }
    };
    if (!support.checkOn) {
      jQuery.valHooks[this].get = function (elem) {
        return elem.getAttribute("value") === null ? "on" : elem.value;
      };
    }
  });

  // Return jQuery for attributes-only inclusion
  var location = window.location;
  var nonce = {
    guid: Date.now()
  };
  var rquery = /\?/;

  // Cross-browser xml parsing
  jQuery.parseXML = function (data) {
    var xml, parserErrorElem;
    if (!data || typeof data !== "string") {
      return null;
    }

    // Support: IE 9 - 11 only
    // IE throws on parseFromString with invalid input.
    try {
      xml = new window.DOMParser().parseFromString(data, "text/xml");
    } catch (e) {}
    parserErrorElem = xml && xml.getElementsByTagName("parsererror")[0];
    if (!xml || parserErrorElem) {
      jQuery.error("Invalid XML: " + (parserErrorElem ? jQuery.map(parserErrorElem.childNodes, function (el) {
        return el.textContent;
      }).join("\n") : data));
    }
    return xml;
  };
  var rfocusMorph = /^(?:focusinfocus|focusoutblur)$/,
    stopPropagationCallback = function stopPropagationCallback(e) {
      e.stopPropagation();
    };
  jQuery.extend(jQuery.event, {
    trigger: function trigger(event, data, elem, onlyHandlers) {
      var i,
        cur,
        tmp,
        bubbleType,
        ontype,
        handle,
        special,
        lastElement,
        eventPath = [elem || document],
        type = hasOwn.call(event, "type") ? event.type : event,
        namespaces = hasOwn.call(event, "namespace") ? event.namespace.split(".") : [];
      cur = lastElement = tmp = elem = elem || document;

      // Don't do events on text and comment nodes
      if (elem.nodeType === 3 || elem.nodeType === 8) {
        return;
      }

      // focus/blur morphs to focusin/out; ensure we're not firing them right now
      if (rfocusMorph.test(type + jQuery.event.triggered)) {
        return;
      }
      if (type.indexOf(".") > -1) {
        // Namespaced trigger; create a regexp to match event type in handle()
        namespaces = type.split(".");
        type = namespaces.shift();
        namespaces.sort();
      }
      ontype = type.indexOf(":") < 0 && "on" + type;

      // Caller can pass in a jQuery.Event object, Object, or just an event type string
      event = event[jQuery.expando] ? event : new jQuery.Event(type, _typeof(event) === "object" && event);

      // Trigger bitmask: & 1 for native handlers; & 2 for jQuery (always true)
      event.isTrigger = onlyHandlers ? 2 : 3;
      event.namespace = namespaces.join(".");
      event.rnamespace = event.namespace ? new RegExp("(^|\\.)" + namespaces.join("\\.(?:.*\\.|)") + "(\\.|$)") : null;

      // Clean up the event in case it is being reused
      event.result = undefined;
      if (!event.target) {
        event.target = elem;
      }

      // Clone any incoming data and prepend the event, creating the handler arg list
      data = data == null ? [event] : jQuery.makeArray(data, [event]);

      // Allow special events to draw outside the lines
      special = jQuery.event.special[type] || {};
      if (!onlyHandlers && special.trigger && special.trigger.apply(elem, data) === false) {
        return;
      }

      // Determine event propagation path in advance, per W3C events spec (trac-9951)
      // Bubble up to document, then to window; watch for a global ownerDocument var (trac-9724)
      if (!onlyHandlers && !special.noBubble && !isWindow(elem)) {
        bubbleType = special.delegateType || type;
        if (!rfocusMorph.test(bubbleType + type)) {
          cur = cur.parentNode;
        }
        for (; cur; cur = cur.parentNode) {
          eventPath.push(cur);
          tmp = cur;
        }

        // Only add window if we got to document (e.g., not plain obj or detached DOM)
        if (tmp === (elem.ownerDocument || document)) {
          eventPath.push(tmp.defaultView || tmp.parentWindow || window);
        }
      }

      // Fire handlers on the event path
      i = 0;
      while ((cur = eventPath[i++]) && !event.isPropagationStopped()) {
        lastElement = cur;
        event.type = i > 1 ? bubbleType : special.bindType || type;

        // jQuery handler
        handle = (dataPriv.get(cur, "events") || Object.create(null))[event.type] && dataPriv.get(cur, "handle");
        if (handle) {
          handle.apply(cur, data);
        }

        // Native handler
        handle = ontype && cur[ontype];
        if (handle && handle.apply && acceptData(cur)) {
          event.result = handle.apply(cur, data);
          if (event.result === false) {
            event.preventDefault();
          }
        }
      }
      event.type = type;

      // If nobody prevented the default action, do it now
      if (!onlyHandlers && !event.isDefaultPrevented()) {
        if ((!special._default || special._default.apply(eventPath.pop(), data) === false) && acceptData(elem)) {
          // Call a native DOM method on the target with the same name as the event.
          // Don't do default actions on window, that's where global variables be (trac-6170)
          if (ontype && isFunction(elem[type]) && !isWindow(elem)) {
            // Don't re-trigger an onFOO event when we call its FOO() method
            tmp = elem[ontype];
            if (tmp) {
              elem[ontype] = null;
            }

            // Prevent re-triggering of the same event, since we already bubbled it above
            jQuery.event.triggered = type;
            if (event.isPropagationStopped()) {
              lastElement.addEventListener(type, stopPropagationCallback);
            }
            elem[type]();
            if (event.isPropagationStopped()) {
              lastElement.removeEventListener(type, stopPropagationCallback);
            }
            jQuery.event.triggered = undefined;
            if (tmp) {
              elem[ontype] = tmp;
            }
          }
        }
      }
      return event.result;
    },
    // Piggyback on a donor event to simulate a different one
    // Used only for `focus(in | out)` events
    simulate: function simulate(type, elem, event) {
      var e = jQuery.extend(new jQuery.Event(), event, {
        type: type,
        isSimulated: true
      });
      jQuery.event.trigger(e, null, elem);
    }
  });
  jQuery.fn.extend({
    trigger: function trigger(type, data) {
      return this.each(function () {
        jQuery.event.trigger(type, data, this);
      });
    },
    triggerHandler: function triggerHandler(type, data) {
      var elem = this[0];
      if (elem) {
        return jQuery.event.trigger(type, data, elem, true);
      }
    }
  });
  var rbracket = /\[\]$/,
    rCRLF = /\r?\n/g,
    rsubmitterTypes = /^(?:submit|button|image|reset|file)$/i,
    rsubmittable = /^(?:input|select|textarea|keygen)/i;
  function buildParams(prefix, obj, traditional, add) {
    var name;
    if (Array.isArray(obj)) {
      // Serialize array item.
      jQuery.each(obj, function (i, v) {
        if (traditional || rbracket.test(prefix)) {
          // Treat each array item as a scalar.
          add(prefix, v);
        } else {
          // Item is non-scalar (array or object), encode its numeric index.
          buildParams(prefix + "[" + (_typeof(v) === "object" && v != null ? i : "") + "]", v, traditional, add);
        }
      });
    } else if (!traditional && toType(obj) === "object") {
      // Serialize object item.
      for (name in obj) {
        buildParams(prefix + "[" + name + "]", obj[name], traditional, add);
      }
    } else {
      // Serialize scalar item.
      add(prefix, obj);
    }
  }

  // Serialize an array of form elements or a set of
  // key/values into a query string
  jQuery.param = function (a, traditional) {
    var prefix,
      s = [],
      add = function add(key, valueOrFunction) {
        // If value is a function, invoke it and use its return value
        var value = isFunction(valueOrFunction) ? valueOrFunction() : valueOrFunction;
        s[s.length] = encodeURIComponent(key) + "=" + encodeURIComponent(value == null ? "" : value);
      };
    if (a == null) {
      return "";
    }

    // If an array was passed in, assume that it is an array of form elements.
    if (Array.isArray(a) || a.jquery && !jQuery.isPlainObject(a)) {
      // Serialize the form elements
      jQuery.each(a, function () {
        add(this.name, this.value);
      });
    } else {
      // If traditional, encode the "old" way (the way 1.3.2 or older
      // did it), otherwise encode params recursively.
      for (prefix in a) {
        buildParams(prefix, a[prefix], traditional, add);
      }
    }

    // Return the resulting serialization
    return s.join("&");
  };
  jQuery.fn.extend({
    serialize: function serialize() {
      return jQuery.param(this.serializeArray());
    },
    serializeArray: function serializeArray() {
      return this.map(function () {
        // Can add propHook for "elements" to filter or add form elements
        var elements = jQuery.prop(this, "elements");
        return elements ? jQuery.makeArray(elements) : this;
      }).filter(function () {
        var type = this.type;

        // Use .is( ":disabled" ) so that fieldset[disabled] works
        return this.name && !jQuery(this).is(":disabled") && rsubmittable.test(this.nodeName) && !rsubmitterTypes.test(type) && (this.checked || !rcheckableType.test(type));
      }).map(function (_i, elem) {
        var val = jQuery(this).val();
        if (val == null) {
          return null;
        }
        if (Array.isArray(val)) {
          return jQuery.map(val, function (val) {
            return {
              name: elem.name,
              value: val.replace(rCRLF, "\r\n")
            };
          });
        }
        return {
          name: elem.name,
          value: val.replace(rCRLF, "\r\n")
        };
      }).get();
    }
  });
  var r20 = /%20/g,
    rhash = /#.*$/,
    rantiCache = /([?&])_=[^&]*/,
    rheaders = /^(.*?):[ \t]*([^\r\n]*)$/mg,
    // trac-7653, trac-8125, trac-8152: local protocol detection
    rlocalProtocol = /^(?:about|app|app-storage|.+-extension|file|res|widget):$/,
    rnoContent = /^(?:GET|HEAD)$/,
    rprotocol = /^\/\//,
    /* Prefilters
     * 1) They are useful to introduce custom dataTypes (see ajax/jsonp.js for an example)
     * 2) These are called:
     *    - BEFORE asking for a transport
     *    - AFTER param serialization (s.data is a string if s.processData is true)
     * 3) key is the dataType
     * 4) the catchall symbol "*" can be used
     * 5) execution will start with transport dataType and THEN continue down to "*" if needed
     */
    prefilters = {},
    /* Transports bindings
     * 1) key is the dataType
     * 2) the catchall symbol "*" can be used
     * 3) selection will start with transport dataType and THEN go to "*" if needed
     */
    transports = {},
    // Avoid comment-prolog char sequence (trac-10098); must appease lint and evade compression
    allTypes = "*/".concat("*"),
    // Anchor tag for parsing the document origin
    originAnchor = document.createElement("a");
  originAnchor.href = location.href;

  // Base "constructor" for jQuery.ajaxPrefilter and jQuery.ajaxTransport
  function addToPrefiltersOrTransports(structure) {
    // dataTypeExpression is optional and defaults to "*"
    return function (dataTypeExpression, func) {
      if (typeof dataTypeExpression !== "string") {
        func = dataTypeExpression;
        dataTypeExpression = "*";
      }
      var dataType,
        i = 0,
        dataTypes = dataTypeExpression.toLowerCase().match(rnothtmlwhite) || [];
      if (isFunction(func)) {
        // For each dataType in the dataTypeExpression
        while (dataType = dataTypes[i++]) {
          // Prepend if requested
          if (dataType[0] === "+") {
            dataType = dataType.slice(1) || "*";
            (structure[dataType] = structure[dataType] || []).unshift(func);

            // Otherwise append
          } else {
            (structure[dataType] = structure[dataType] || []).push(func);
          }
        }
      }
    };
  }

  // Base inspection function for prefilters and transports
  function inspectPrefiltersOrTransports(structure, options, originalOptions, jqXHR) {
    var inspected = {},
      seekingTransport = structure === transports;
    function inspect(dataType) {
      var selected;
      inspected[dataType] = true;
      jQuery.each(structure[dataType] || [], function (_, prefilterOrFactory) {
        var dataTypeOrTransport = prefilterOrFactory(options, originalOptions, jqXHR);
        if (typeof dataTypeOrTransport === "string" && !seekingTransport && !inspected[dataTypeOrTransport]) {
          options.dataTypes.unshift(dataTypeOrTransport);
          inspect(dataTypeOrTransport);
          return false;
        } else if (seekingTransport) {
          return !(selected = dataTypeOrTransport);
        }
      });
      return selected;
    }
    return inspect(options.dataTypes[0]) || !inspected["*"] && inspect("*");
  }

  // A special extend for ajax options
  // that takes "flat" options (not to be deep extended)
  // Fixes trac-9887
  function ajaxExtend(target, src) {
    var key,
      deep,
      flatOptions = jQuery.ajaxSettings.flatOptions || {};
    for (key in src) {
      if (src[key] !== undefined) {
        (flatOptions[key] ? target : deep || (deep = {}))[key] = src[key];
      }
    }
    if (deep) {
      jQuery.extend(true, target, deep);
    }
    return target;
  }

  /* Handles responses to an ajax request:
   * - finds the right dataType (mediates between content-type and expected dataType)
   * - returns the corresponding response
   */
  function ajaxHandleResponses(s, jqXHR, responses) {
    var ct,
      type,
      finalDataType,
      firstDataType,
      contents = s.contents,
      dataTypes = s.dataTypes;

    // Remove auto dataType and get content-type in the process
    while (dataTypes[0] === "*") {
      dataTypes.shift();
      if (ct === undefined) {
        ct = s.mimeType || jqXHR.getResponseHeader("Content-Type");
      }
    }

    // Check if we're dealing with a known content-type
    if (ct) {
      for (type in contents) {
        if (contents[type] && contents[type].test(ct)) {
          dataTypes.unshift(type);
          break;
        }
      }
    }

    // Check to see if we have a response for the expected dataType
    if (dataTypes[0] in responses) {
      finalDataType = dataTypes[0];
    } else {
      // Try convertible dataTypes
      for (type in responses) {
        if (!dataTypes[0] || s.converters[type + " " + dataTypes[0]]) {
          finalDataType = type;
          break;
        }
        if (!firstDataType) {
          firstDataType = type;
        }
      }

      // Or just use first one
      finalDataType = finalDataType || firstDataType;
    }

    // If we found a dataType
    // We add the dataType to the list if needed
    // and return the corresponding response
    if (finalDataType) {
      if (finalDataType !== dataTypes[0]) {
        dataTypes.unshift(finalDataType);
      }
      return responses[finalDataType];
    }
  }

  /* Chain conversions given the request and the original response
   * Also sets the responseXXX fields on the jqXHR instance
   */
  function ajaxConvert(s, response, jqXHR, isSuccess) {
    var conv2,
      current,
      conv,
      tmp,
      prev,
      converters = {},
      // Work with a copy of dataTypes in case we need to modify it for conversion
      dataTypes = s.dataTypes.slice();

    // Create converters map with lowercased keys
    if (dataTypes[1]) {
      for (conv in s.converters) {
        converters[conv.toLowerCase()] = s.converters[conv];
      }
    }
    current = dataTypes.shift();

    // Convert to each sequential dataType
    while (current) {
      if (s.responseFields[current]) {
        jqXHR[s.responseFields[current]] = response;
      }

      // Apply the dataFilter if provided
      if (!prev && isSuccess && s.dataFilter) {
        response = s.dataFilter(response, s.dataType);
      }
      prev = current;
      current = dataTypes.shift();
      if (current) {
        // There's only work to do if current dataType is non-auto
        if (current === "*") {
          current = prev;

          // Convert response if prev dataType is non-auto and differs from current
        } else if (prev !== "*" && prev !== current) {
          // Seek a direct converter
          conv = converters[prev + " " + current] || converters["* " + current];

          // If none found, seek a pair
          if (!conv) {
            for (conv2 in converters) {
              // If conv2 outputs current
              tmp = conv2.split(" ");
              if (tmp[1] === current) {
                // If prev can be converted to accepted input
                conv = converters[prev + " " + tmp[0]] || converters["* " + tmp[0]];
                if (conv) {
                  // Condense equivalence converters
                  if (conv === true) {
                    conv = converters[conv2];

                    // Otherwise, insert the intermediate dataType
                  } else if (converters[conv2] !== true) {
                    current = tmp[0];
                    dataTypes.unshift(tmp[1]);
                  }
                  break;
                }
              }
            }
          }

          // Apply converter (if not an equivalence)
          if (conv !== true) {
            // Unless errors are allowed to bubble, catch and return them
            if (conv && s["throws"]) {
              response = conv(response);
            } else {
              try {
                response = conv(response);
              } catch (e) {
                return {
                  state: "parsererror",
                  error: conv ? e : "No conversion from " + prev + " to " + current
                };
              }
            }
          }
        }
      }
    }
    return {
      state: "success",
      data: response
    };
  }
  jQuery.extend({
    // Counter for holding the number of active queries
    active: 0,
    // Last-Modified header cache for next request
    lastModified: {},
    etag: {},
    ajaxSettings: {
      url: location.href,
      type: "GET",
      isLocal: rlocalProtocol.test(location.protocol),
      global: true,
      processData: true,
      async: true,
      contentType: "application/x-www-form-urlencoded; charset=UTF-8",
      /*
      timeout: 0,
      data: null,
      dataType: null,
      username: null,
      password: null,
      cache: null,
      throws: false,
      traditional: false,
      headers: {},
      */

      accepts: {
        "*": allTypes,
        text: "text/plain",
        html: "text/html",
        xml: "application/xml, text/xml",
        json: "application/json, text/javascript"
      },
      contents: {
        xml: /\bxml\b/,
        html: /\bhtml/,
        json: /\bjson\b/
      },
      responseFields: {
        xml: "responseXML",
        text: "responseText",
        json: "responseJSON"
      },
      // Data converters
      // Keys separate source (or catchall "*") and destination types with a single space
      converters: {
        // Convert anything to text
        "* text": String,
        // Text to html (true = no transformation)
        "text html": true,
        // Evaluate text as a json expression
        "text json": JSON.parse,
        // Parse text as xml
        "text xml": jQuery.parseXML
      },
      // For options that shouldn't be deep extended:
      // you can add your own custom options here if
      // and when you create one that shouldn't be
      // deep extended (see ajaxExtend)
      flatOptions: {
        url: true,
        context: true
      }
    },
    // Creates a full fledged settings object into target
    // with both ajaxSettings and settings fields.
    // If target is omitted, writes into ajaxSettings.
    ajaxSetup: function ajaxSetup(target, settings) {
      return settings ?
      // Building a settings object
      ajaxExtend(ajaxExtend(target, jQuery.ajaxSettings), settings) :
      // Extending ajaxSettings
      ajaxExtend(jQuery.ajaxSettings, target);
    },
    ajaxPrefilter: addToPrefiltersOrTransports(prefilters),
    ajaxTransport: addToPrefiltersOrTransports(transports),
    // Main method
    ajax: function ajax(url, options) {
      // If url is an object, simulate pre-1.5 signature
      if (_typeof(url) === "object") {
        options = url;
        url = undefined;
      }

      // Force options to be an object
      options = options || {};
      var transport,
        // URL without anti-cache param
        cacheURL,
        // Response headers
        responseHeadersString,
        responseHeaders,
        // timeout handle
        timeoutTimer,
        // Url cleanup var
        urlAnchor,
        // Request state (becomes false upon send and true upon completion)
        completed,
        // To know if global events are to be dispatched
        fireGlobals,
        // Loop variable
        i,
        // uncached part of the url
        uncached,
        // Create the final options object
        s = jQuery.ajaxSetup({}, options),
        // Callbacks context
        callbackContext = s.context || s,
        // Context for global events is callbackContext if it is a DOM node or jQuery collection
        globalEventContext = s.context && (callbackContext.nodeType || callbackContext.jquery) ? jQuery(callbackContext) : jQuery.event,
        // Deferreds
        deferred = jQuery.Deferred(),
        completeDeferred = jQuery.Callbacks("once memory"),
        // Status-dependent callbacks
        _statusCode = s.statusCode || {},
        // Headers (they are sent all at once)
        requestHeaders = {},
        requestHeadersNames = {},
        // Default abort message
        strAbort = "canceled",
        // Fake xhr
        jqXHR = {
          readyState: 0,
          // Builds headers hashtable if needed
          getResponseHeader: function getResponseHeader(key) {
            var match;
            if (completed) {
              if (!responseHeaders) {
                responseHeaders = {};
                while (match = rheaders.exec(responseHeadersString)) {
                  responseHeaders[match[1].toLowerCase() + " "] = (responseHeaders[match[1].toLowerCase() + " "] || []).concat(match[2]);
                }
              }
              match = responseHeaders[key.toLowerCase() + " "];
            }
            return match == null ? null : match.join(", ");
          },
          // Raw string
          getAllResponseHeaders: function getAllResponseHeaders() {
            return completed ? responseHeadersString : null;
          },
          // Caches the header
          setRequestHeader: function setRequestHeader(name, value) {
            if (completed == null) {
              name = requestHeadersNames[name.toLowerCase()] = requestHeadersNames[name.toLowerCase()] || name;
              requestHeaders[name] = value;
            }
            return this;
          },
          // Overrides response content-type header
          overrideMimeType: function overrideMimeType(type) {
            if (completed == null) {
              s.mimeType = type;
            }
            return this;
          },
          // Status-dependent callbacks
          statusCode: function statusCode(map) {
            var code;
            if (map) {
              if (completed) {
                // Execute the appropriate callbacks
                jqXHR.always(map[jqXHR.status]);
              } else {
                // Lazy-add the new callbacks in a way that preserves old ones
                for (code in map) {
                  _statusCode[code] = [_statusCode[code], map[code]];
                }
              }
            }
            return this;
          },
          // Cancel the request
          abort: function abort(statusText) {
            var finalText = statusText || strAbort;
            if (transport) {
              transport.abort(finalText);
            }
            done(0, finalText);
            return this;
          }
        };

      // Attach deferreds
      deferred.promise(jqXHR);

      // Add protocol if not provided (prefilters might expect it)
      // Handle falsy url in the settings object (trac-10093: consistency with old signature)
      // We also use the url parameter if available
      s.url = ((url || s.url || location.href) + "").replace(rprotocol, location.protocol + "//");

      // Alias method option to type as per ticket trac-12004
      s.type = options.method || options.type || s.method || s.type;

      // Extract dataTypes list
      s.dataTypes = (s.dataType || "*").toLowerCase().match(rnothtmlwhite) || [""];

      // A cross-domain request is in order when the origin doesn't match the current origin.
      if (s.crossDomain == null) {
        urlAnchor = document.createElement("a");

        // Support: IE <=8 - 11, Edge 12 - 15
        // IE throws exception on accessing the href property if url is malformed,
        // e.g. http://example.com:80x/
        try {
          urlAnchor.href = s.url;

          // Support: IE <=8 - 11 only
          // Anchor's host property isn't correctly set when s.url is relative
          urlAnchor.href = urlAnchor.href;
          s.crossDomain = originAnchor.protocol + "//" + originAnchor.host !== urlAnchor.protocol + "//" + urlAnchor.host;
        } catch (e) {
          // If there is an error parsing the URL, assume it is crossDomain,
          // it can be rejected by the transport if it is invalid
          s.crossDomain = true;
        }
      }

      // Convert data if not already a string
      if (s.data && s.processData && typeof s.data !== "string") {
        s.data = jQuery.param(s.data, s.traditional);
      }

      // Apply prefilters
      inspectPrefiltersOrTransports(prefilters, s, options, jqXHR);

      // If request was aborted inside a prefilter, stop there
      if (completed) {
        return jqXHR;
      }

      // We can fire global events as of now if asked to
      // Don't fire events if jQuery.event is undefined in an AMD-usage scenario (trac-15118)
      fireGlobals = jQuery.event && s.global;

      // Watch for a new set of requests
      if (fireGlobals && jQuery.active++ === 0) {
        jQuery.event.trigger("ajaxStart");
      }

      // Uppercase the type
      s.type = s.type.toUpperCase();

      // Determine if request has content
      s.hasContent = !rnoContent.test(s.type);

      // Save the URL in case we're toying with the If-Modified-Since
      // and/or If-None-Match header later on
      // Remove hash to simplify url manipulation
      cacheURL = s.url.replace(rhash, "");

      // More options handling for requests with no content
      if (!s.hasContent) {
        // Remember the hash so we can put it back
        uncached = s.url.slice(cacheURL.length);

        // If data is available and should be processed, append data to url
        if (s.data && (s.processData || typeof s.data === "string")) {
          cacheURL += (rquery.test(cacheURL) ? "&" : "?") + s.data;

          // trac-9682: remove data so that it's not used in an eventual retry
          delete s.data;
        }

        // Add or update anti-cache param if needed
        if (s.cache === false) {
          cacheURL = cacheURL.replace(rantiCache, "$1");
          uncached = (rquery.test(cacheURL) ? "&" : "?") + "_=" + nonce.guid++ + uncached;
        }

        // Put hash and anti-cache on the URL that will be requested (gh-1732)
        s.url = cacheURL + uncached;

        // Change '%20' to '+' if this is encoded form body content (gh-2658)
      } else if (s.data && s.processData && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0) {
        s.data = s.data.replace(r20, "+");
      }

      // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
      if (s.ifModified) {
        if (jQuery.lastModified[cacheURL]) {
          jqXHR.setRequestHeader("If-Modified-Since", jQuery.lastModified[cacheURL]);
        }
        if (jQuery.etag[cacheURL]) {
          jqXHR.setRequestHeader("If-None-Match", jQuery.etag[cacheURL]);
        }
      }

      // Set the correct header, if data is being sent
      if (s.data && s.hasContent && s.contentType !== false || options.contentType) {
        jqXHR.setRequestHeader("Content-Type", s.contentType);
      }

      // Set the Accepts header for the server, depending on the dataType
      jqXHR.setRequestHeader("Accept", s.dataTypes[0] && s.accepts[s.dataTypes[0]] ? s.accepts[s.dataTypes[0]] + (s.dataTypes[0] !== "*" ? ", " + allTypes + "; q=0.01" : "") : s.accepts["*"]);

      // Check for headers option
      for (i in s.headers) {
        jqXHR.setRequestHeader(i, s.headers[i]);
      }

      // Allow custom headers/mimetypes and early abort
      if (s.beforeSend && (s.beforeSend.call(callbackContext, jqXHR, s) === false || completed)) {
        // Abort if not done already and return
        return jqXHR.abort();
      }

      // Aborting is no longer a cancellation
      strAbort = "abort";

      // Install callbacks on deferreds
      completeDeferred.add(s.complete);
      jqXHR.done(s.success);
      jqXHR.fail(s.error);

      // Get transport
      transport = inspectPrefiltersOrTransports(transports, s, options, jqXHR);

      // If no transport, we auto-abort
      if (!transport) {
        done(-1, "No Transport");
      } else {
        jqXHR.readyState = 1;

        // Send global event
        if (fireGlobals) {
          globalEventContext.trigger("ajaxSend", [jqXHR, s]);
        }

        // If request was aborted inside ajaxSend, stop there
        if (completed) {
          return jqXHR;
        }

        // Timeout
        if (s.async && s.timeout > 0) {
          timeoutTimer = window.setTimeout(function () {
            jqXHR.abort("timeout");
          }, s.timeout);
        }
        try {
          completed = false;
          transport.send(requestHeaders, done);
        } catch (e) {
          // Rethrow post-completion exceptions
          if (completed) {
            throw e;
          }

          // Propagate others as results
          done(-1, e);
        }
      }

      // Callback for when everything is done
      function done(status, nativeStatusText, responses, headers) {
        var isSuccess,
          success,
          error,
          response,
          modified,
          statusText = nativeStatusText;

        // Ignore repeat invocations
        if (completed) {
          return;
        }
        completed = true;

        // Clear timeout if it exists
        if (timeoutTimer) {
          window.clearTimeout(timeoutTimer);
        }

        // Dereference transport for early garbage collection
        // (no matter how long the jqXHR object will be used)
        transport = undefined;

        // Cache response headers
        responseHeadersString = headers || "";

        // Set readyState
        jqXHR.readyState = status > 0 ? 4 : 0;

        // Determine if successful
        isSuccess = status >= 200 && status < 300 || status === 304;

        // Get response data
        if (responses) {
          response = ajaxHandleResponses(s, jqXHR, responses);
        }

        // Use a noop converter for missing script but not if jsonp
        if (!isSuccess && jQuery.inArray("script", s.dataTypes) > -1 && jQuery.inArray("json", s.dataTypes) < 0) {
          s.converters["text script"] = function () {};
        }

        // Convert no matter what (that way responseXXX fields are always set)
        response = ajaxConvert(s, response, jqXHR, isSuccess);

        // If successful, handle type chaining
        if (isSuccess) {
          // Set the If-Modified-Since and/or If-None-Match header, if in ifModified mode.
          if (s.ifModified) {
            modified = jqXHR.getResponseHeader("Last-Modified");
            if (modified) {
              jQuery.lastModified[cacheURL] = modified;
            }
            modified = jqXHR.getResponseHeader("etag");
            if (modified) {
              jQuery.etag[cacheURL] = modified;
            }
          }

          // if no content
          if (status === 204 || s.type === "HEAD") {
            statusText = "nocontent";

            // if not modified
          } else if (status === 304) {
            statusText = "notmodified";

            // If we have data, let's convert it
          } else {
            statusText = response.state;
            success = response.data;
            error = response.error;
            isSuccess = !error;
          }
        } else {
          // Extract error from statusText and normalize for non-aborts
          error = statusText;
          if (status || !statusText) {
            statusText = "error";
            if (status < 0) {
              status = 0;
            }
          }
        }

        // Set data for the fake xhr object
        jqXHR.status = status;
        jqXHR.statusText = (nativeStatusText || statusText) + "";

        // Success/Error
        if (isSuccess) {
          deferred.resolveWith(callbackContext, [success, statusText, jqXHR]);
        } else {
          deferred.rejectWith(callbackContext, [jqXHR, statusText, error]);
        }

        // Status-dependent callbacks
        jqXHR.statusCode(_statusCode);
        _statusCode = undefined;
        if (fireGlobals) {
          globalEventContext.trigger(isSuccess ? "ajaxSuccess" : "ajaxError", [jqXHR, s, isSuccess ? success : error]);
        }

        // Complete
        completeDeferred.fireWith(callbackContext, [jqXHR, statusText]);
        if (fireGlobals) {
          globalEventContext.trigger("ajaxComplete", [jqXHR, s]);

          // Handle the global AJAX counter
          if (! --jQuery.active) {
            jQuery.event.trigger("ajaxStop");
          }
        }
      }
      return jqXHR;
    },
    getJSON: function getJSON(url, data, callback) {
      return jQuery.get(url, data, callback, "json");
    },
    getScript: function getScript(url, callback) {
      return jQuery.get(url, undefined, callback, "script");
    }
  });
  jQuery.each(["get", "post"], function (_i, method) {
    jQuery[method] = function (url, data, callback, type) {
      // Shift arguments if data argument was omitted
      if (isFunction(data)) {
        type = type || callback;
        callback = data;
        data = undefined;
      }

      // The url can be an options object (which then must have .url)
      return jQuery.ajax(jQuery.extend({
        url: url,
        type: method,
        dataType: type,
        data: data,
        success: callback
      }, jQuery.isPlainObject(url) && url));
    };
  });
  jQuery.ajaxPrefilter(function (s) {
    var i;
    for (i in s.headers) {
      if (i.toLowerCase() === "content-type") {
        s.contentType = s.headers[i] || "";
      }
    }
  });
  jQuery._evalUrl = function (url, options, doc) {
    return jQuery.ajax({
      url: url,
      // Make this explicit, since user can override this through ajaxSetup (trac-11264)
      type: "GET",
      dataType: "script",
      cache: true,
      async: false,
      global: false,
      // Only evaluate the response if it is successful (gh-4126)
      // dataFilter is not invoked for failure responses, so using it instead
      // of the default converter is kludgy but it works.
      converters: {
        "text script": function text_script() {}
      },
      dataFilter: function dataFilter(response) {
        jQuery.globalEval(response, options, doc);
      }
    });
  };
  jQuery.fn.extend({
    wrapAll: function wrapAll(html) {
      var wrap;
      if (this[0]) {
        if (isFunction(html)) {
          html = html.call(this[0]);
        }

        // The elements to wrap the target around
        wrap = jQuery(html, this[0].ownerDocument).eq(0).clone(true);
        if (this[0].parentNode) {
          wrap.insertBefore(this[0]);
        }
        wrap.map(function () {
          var elem = this;
          while (elem.firstElementChild) {
            elem = elem.firstElementChild;
          }
          return elem;
        }).append(this);
      }
      return this;
    },
    wrapInner: function wrapInner(html) {
      if (isFunction(html)) {
        return this.each(function (i) {
          jQuery(this).wrapInner(html.call(this, i));
        });
      }
      return this.each(function () {
        var self = jQuery(this),
          contents = self.contents();
        if (contents.length) {
          contents.wrapAll(html);
        } else {
          self.append(html);
        }
      });
    },
    wrap: function wrap(html) {
      var htmlIsFunction = isFunction(html);
      return this.each(function (i) {
        jQuery(this).wrapAll(htmlIsFunction ? html.call(this, i) : html);
      });
    },
    unwrap: function unwrap(selector) {
      this.parent(selector).not("body").each(function () {
        jQuery(this).replaceWith(this.childNodes);
      });
      return this;
    }
  });
  jQuery.expr.pseudos.hidden = function (elem) {
    return !jQuery.expr.pseudos.visible(elem);
  };
  jQuery.expr.pseudos.visible = function (elem) {
    return !!(elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length);
  };
  jQuery.ajaxSettings.xhr = function () {
    try {
      return new window.XMLHttpRequest();
    } catch (e) {}
  };
  var xhrSuccessStatus = {
      // File protocol always yields status code 0, assume 200
      0: 200,
      // Support: IE <=9 only
      // trac-1450: sometimes IE returns 1223 when it should be 204
      1223: 204
    },
    xhrSupported = jQuery.ajaxSettings.xhr();
  support.cors = !!xhrSupported && "withCredentials" in xhrSupported;
  support.ajax = xhrSupported = !!xhrSupported;
  jQuery.ajaxTransport(function (options) {
    var _callback, errorCallback;

    // Cross domain only allowed if supported through XMLHttpRequest
    if (support.cors || xhrSupported && !options.crossDomain) {
      return {
        send: function send(headers, complete) {
          var i,
            xhr = options.xhr();
          xhr.open(options.type, options.url, options.async, options.username, options.password);

          // Apply custom fields if provided
          if (options.xhrFields) {
            for (i in options.xhrFields) {
              xhr[i] = options.xhrFields[i];
            }
          }

          // Override mime type if needed
          if (options.mimeType && xhr.overrideMimeType) {
            xhr.overrideMimeType(options.mimeType);
          }

          // X-Requested-With header
          // For cross-domain requests, seeing as conditions for a preflight are
          // akin to a jigsaw puzzle, we simply never set it to be sure.
          // (it can always be set on a per-request basis or even using ajaxSetup)
          // For same-domain requests, won't change header if already provided.
          if (!options.crossDomain && !headers["X-Requested-With"]) {
            headers["X-Requested-With"] = "XMLHttpRequest";
          }

          // Set headers
          for (i in headers) {
            xhr.setRequestHeader(i, headers[i]);
          }

          // Callback
          _callback = function callback(type) {
            return function () {
              if (_callback) {
                _callback = errorCallback = xhr.onload = xhr.onerror = xhr.onabort = xhr.ontimeout = xhr.onreadystatechange = null;
                if (type === "abort") {
                  xhr.abort();
                } else if (type === "error") {
                  // Support: IE <=9 only
                  // On a manual native abort, IE9 throws
                  // errors on any property access that is not readyState
                  if (typeof xhr.status !== "number") {
                    complete(0, "error");
                  } else {
                    complete(
                    // File: protocol always yields status 0; see trac-8605, trac-14207
                    xhr.status, xhr.statusText);
                  }
                } else {
                  complete(xhrSuccessStatus[xhr.status] || xhr.status, xhr.statusText,
                  // Support: IE <=9 only
                  // IE9 has no XHR2 but throws on binary (trac-11426)
                  // For XHR2 non-text, let the caller handle it (gh-2498)
                  (xhr.responseType || "text") !== "text" || typeof xhr.responseText !== "string" ? {
                    binary: xhr.response
                  } : {
                    text: xhr.responseText
                  }, xhr.getAllResponseHeaders());
                }
              }
            };
          };

          // Listen to events
          xhr.onload = _callback();
          errorCallback = xhr.onerror = xhr.ontimeout = _callback("error");

          // Support: IE 9 only
          // Use onreadystatechange to replace onabort
          // to handle uncaught aborts
          if (xhr.onabort !== undefined) {
            xhr.onabort = errorCallback;
          } else {
            xhr.onreadystatechange = function () {
              // Check readyState before timeout as it changes
              if (xhr.readyState === 4) {
                // Allow onerror to be called first,
                // but that will not handle a native abort
                // Also, save errorCallback to a variable
                // as xhr.onerror cannot be accessed
                window.setTimeout(function () {
                  if (_callback) {
                    errorCallback();
                  }
                });
              }
            };
          }

          // Create the abort callback
          _callback = _callback("abort");
          try {
            // Do send the request (this may raise an exception)
            xhr.send(options.hasContent && options.data || null);
          } catch (e) {
            // trac-14683: Only rethrow if this hasn't been notified as an error yet
            if (_callback) {
              throw e;
            }
          }
        },
        abort: function abort() {
          if (_callback) {
            _callback();
          }
        }
      };
    }
  });

  // Prevent auto-execution of scripts when no explicit dataType was provided (See gh-2432)
  jQuery.ajaxPrefilter(function (s) {
    if (s.crossDomain) {
      s.contents.script = false;
    }
  });

  // Install script dataType
  jQuery.ajaxSetup({
    accepts: {
      script: "text/javascript, application/javascript, " + "application/ecmascript, application/x-ecmascript"
    },
    contents: {
      script: /\b(?:java|ecma)script\b/
    },
    converters: {
      "text script": function text_script(text) {
        jQuery.globalEval(text);
        return text;
      }
    }
  });

  // Handle cache's special case and crossDomain
  jQuery.ajaxPrefilter("script", function (s) {
    if (s.cache === undefined) {
      s.cache = false;
    }
    if (s.crossDomain) {
      s.type = "GET";
    }
  });

  // Bind script tag hack transport
  jQuery.ajaxTransport("script", function (s) {
    // This transport only deals with cross domain or forced-by-attrs requests
    if (s.crossDomain || s.scriptAttrs) {
      var script, _callback2;
      return {
        send: function send(_, complete) {
          script = jQuery("<script>").attr(s.scriptAttrs || {}).prop({
            charset: s.scriptCharset,
            src: s.url
          }).on("load error", _callback2 = function callback(evt) {
            script.remove();
            _callback2 = null;
            if (evt) {
              complete(evt.type === "error" ? 404 : 200, evt.type);
            }
          });

          // Use native DOM manipulation to avoid our domManip AJAX trickery
          document.head.appendChild(script[0]);
        },
        abort: function abort() {
          if (_callback2) {
            _callback2();
          }
        }
      };
    }
  });
  var oldCallbacks = [],
    rjsonp = /(=)\?(?=&|$)|\?\?/;

  // Default jsonp settings
  jQuery.ajaxSetup({
    jsonp: "callback",
    jsonpCallback: function jsonpCallback() {
      var callback = oldCallbacks.pop() || jQuery.expando + "_" + nonce.guid++;
      this[callback] = true;
      return callback;
    }
  });

  // Detect, normalize options and install callbacks for jsonp requests
  jQuery.ajaxPrefilter("json jsonp", function (s, originalSettings, jqXHR) {
    var callbackName,
      overwritten,
      responseContainer,
      jsonProp = s.jsonp !== false && (rjsonp.test(s.url) ? "url" : typeof s.data === "string" && (s.contentType || "").indexOf("application/x-www-form-urlencoded") === 0 && rjsonp.test(s.data) && "data");

    // Handle iff the expected data type is "jsonp" or we have a parameter to set
    if (jsonProp || s.dataTypes[0] === "jsonp") {
      // Get callback name, remembering preexisting value associated with it
      callbackName = s.jsonpCallback = isFunction(s.jsonpCallback) ? s.jsonpCallback() : s.jsonpCallback;

      // Insert callback into url or form data
      if (jsonProp) {
        s[jsonProp] = s[jsonProp].replace(rjsonp, "$1" + callbackName);
      } else if (s.jsonp !== false) {
        s.url += (rquery.test(s.url) ? "&" : "?") + s.jsonp + "=" + callbackName;
      }

      // Use data converter to retrieve json after script execution
      s.converters["script json"] = function () {
        if (!responseContainer) {
          jQuery.error(callbackName + " was not called");
        }
        return responseContainer[0];
      };

      // Force json dataType
      s.dataTypes[0] = "json";

      // Install callback
      overwritten = window[callbackName];
      window[callbackName] = function () {
        responseContainer = arguments;
      };

      // Clean-up function (fires after converters)
      jqXHR.always(function () {
        // If previous value didn't exist - remove it
        if (overwritten === undefined) {
          jQuery(window).removeProp(callbackName);

          // Otherwise restore preexisting value
        } else {
          window[callbackName] = overwritten;
        }

        // Save back as free
        if (s[callbackName]) {
          // Make sure that re-using the options doesn't screw things around
          s.jsonpCallback = originalSettings.jsonpCallback;

          // Save the callback name for future use
          oldCallbacks.push(callbackName);
        }

        // Call if it was a function and we have a response
        if (responseContainer && isFunction(overwritten)) {
          overwritten(responseContainer[0]);
        }
        responseContainer = overwritten = undefined;
      });

      // Delegate to script
      return "script";
    }
  });

  // Support: Safari 8 only
  // In Safari 8 documents created via document.implementation.createHTMLDocument
  // collapse sibling forms: the second one becomes a child of the first one.
  // Because of that, this security measure has to be disabled in Safari 8.
  // https://bugs.webkit.org/show_bug.cgi?id=137337
  support.createHTMLDocument = function () {
    var body = document.implementation.createHTMLDocument("").body;
    body.innerHTML = "<form></form><form></form>";
    return body.childNodes.length === 2;
  }();

  // Argument "data" should be string of html
  // context (optional): If specified, the fragment will be created in this context,
  // defaults to document
  // keepScripts (optional): If true, will include scripts passed in the html string
  jQuery.parseHTML = function (data, context, keepScripts) {
    if (typeof data !== "string") {
      return [];
    }
    if (typeof context === "boolean") {
      keepScripts = context;
      context = false;
    }
    var base, parsed, scripts;
    if (!context) {
      // Stop scripts or inline event handlers from being executed immediately
      // by using document.implementation
      if (support.createHTMLDocument) {
        context = document.implementation.createHTMLDocument("");

        // Set the base href for the created document
        // so any parsed elements with URLs
        // are based on the document's URL (gh-2965)
        base = context.createElement("base");
        base.href = document.location.href;
        context.head.appendChild(base);
      } else {
        context = document;
      }
    }
    parsed = rsingleTag.exec(data);
    scripts = !keepScripts && [];

    // Single tag
    if (parsed) {
      return [context.createElement(parsed[1])];
    }
    parsed = buildFragment([data], context, scripts);
    if (scripts && scripts.length) {
      jQuery(scripts).remove();
    }
    return jQuery.merge([], parsed.childNodes);
  };

  /**
   * Load a url into a page
   */
  jQuery.fn.load = function (url, params, callback) {
    var selector,
      type,
      response,
      self = this,
      off = url.indexOf(" ");
    if (off > -1) {
      selector = stripAndCollapse(url.slice(off));
      url = url.slice(0, off);
    }

    // If it's a function
    if (isFunction(params)) {
      // We assume that it's the callback
      callback = params;
      params = undefined;

      // Otherwise, build a param string
    } else if (params && _typeof(params) === "object") {
      type = "POST";
    }

    // If we have elements to modify, make the request
    if (self.length > 0) {
      jQuery.ajax({
        url: url,
        // If "type" variable is undefined, then "GET" method will be used.
        // Make value of this field explicit since
        // user can override it through ajaxSetup method
        type: type || "GET",
        dataType: "html",
        data: params
      }).done(function (responseText) {
        // Save response for use in complete callback
        response = arguments;
        self.html(selector ?
        // If a selector was specified, locate the right elements in a dummy div
        // Exclude scripts to avoid IE 'Permission Denied' errors
        jQuery("<div>").append(jQuery.parseHTML(responseText)).find(selector) :
        // Otherwise use the full result
        responseText);

        // If the request succeeds, this function gets "data", "status", "jqXHR"
        // but they are ignored because response was set above.
        // If it fails, this function gets "jqXHR", "status", "error"
      }).always(callback && function (jqXHR, status) {
        self.each(function () {
          callback.apply(this, response || [jqXHR.responseText, status, jqXHR]);
        });
      });
    }
    return this;
  };
  jQuery.expr.pseudos.animated = function (elem) {
    return jQuery.grep(jQuery.timers, function (fn) {
      return elem === fn.elem;
    }).length;
  };
  jQuery.offset = {
    setOffset: function setOffset(elem, options, i) {
      var curPosition,
        curLeft,
        curCSSTop,
        curTop,
        curOffset,
        curCSSLeft,
        calculatePosition,
        position = jQuery.css(elem, "position"),
        curElem = jQuery(elem),
        props = {};

      // Set position first, in-case top/left are set even on static elem
      if (position === "static") {
        elem.style.position = "relative";
      }
      curOffset = curElem.offset();
      curCSSTop = jQuery.css(elem, "top");
      curCSSLeft = jQuery.css(elem, "left");
      calculatePosition = (position === "absolute" || position === "fixed") && (curCSSTop + curCSSLeft).indexOf("auto") > -1;

      // Need to be able to calculate position if either
      // top or left is auto and position is either absolute or fixed
      if (calculatePosition) {
        curPosition = curElem.position();
        curTop = curPosition.top;
        curLeft = curPosition.left;
      } else {
        curTop = parseFloat(curCSSTop) || 0;
        curLeft = parseFloat(curCSSLeft) || 0;
      }
      if (isFunction(options)) {
        // Use jQuery.extend here to allow modification of coordinates argument (gh-1848)
        options = options.call(elem, i, jQuery.extend({}, curOffset));
      }
      if (options.top != null) {
        props.top = options.top - curOffset.top + curTop;
      }
      if (options.left != null) {
        props.left = options.left - curOffset.left + curLeft;
      }
      if ("using" in options) {
        options.using.call(elem, props);
      } else {
        curElem.css(props);
      }
    }
  };
  jQuery.fn.extend({
    // offset() relates an element's border box to the document origin
    offset: function offset(options) {
      // Preserve chaining for setter
      if (arguments.length) {
        return options === undefined ? this : this.each(function (i) {
          jQuery.offset.setOffset(this, options, i);
        });
      }
      var rect,
        win,
        elem = this[0];
      if (!elem) {
        return;
      }

      // Return zeros for disconnected and hidden (display: none) elements (gh-2310)
      // Support: IE <=11 only
      // Running getBoundingClientRect on a
      // disconnected node in IE throws an error
      if (!elem.getClientRects().length) {
        return {
          top: 0,
          left: 0
        };
      }

      // Get document-relative position by adding viewport scroll to viewport-relative gBCR
      rect = elem.getBoundingClientRect();
      win = elem.ownerDocument.defaultView;
      return {
        top: rect.top + win.pageYOffset,
        left: rect.left + win.pageXOffset
      };
    },
    // position() relates an element's margin box to its offset parent's padding box
    // This corresponds to the behavior of CSS absolute positioning
    position: function position() {
      if (!this[0]) {
        return;
      }
      var offsetParent,
        offset,
        doc,
        elem = this[0],
        parentOffset = {
          top: 0,
          left: 0
        };

      // position:fixed elements are offset from the viewport, which itself always has zero offset
      if (jQuery.css(elem, "position") === "fixed") {
        // Assume position:fixed implies availability of getBoundingClientRect
        offset = elem.getBoundingClientRect();
      } else {
        offset = this.offset();

        // Account for the *real* offset parent, which can be the document or its root element
        // when a statically positioned element is identified
        doc = elem.ownerDocument;
        offsetParent = elem.offsetParent || doc.documentElement;
        while (offsetParent && (offsetParent === doc.body || offsetParent === doc.documentElement) && jQuery.css(offsetParent, "position") === "static") {
          offsetParent = offsetParent.parentNode;
        }
        if (offsetParent && offsetParent !== elem && offsetParent.nodeType === 1) {
          // Incorporate borders into its offset, since they are outside its content origin
          parentOffset = jQuery(offsetParent).offset();
          parentOffset.top += jQuery.css(offsetParent, "borderTopWidth", true);
          parentOffset.left += jQuery.css(offsetParent, "borderLeftWidth", true);
        }
      }

      // Subtract parent offsets and element margins
      return {
        top: offset.top - parentOffset.top - jQuery.css(elem, "marginTop", true),
        left: offset.left - parentOffset.left - jQuery.css(elem, "marginLeft", true)
      };
    },
    // This method will return documentElement in the following cases:
    // 1) For the element inside the iframe without offsetParent, this method will return
    //    documentElement of the parent window
    // 2) For the hidden or detached element
    // 3) For body or html element, i.e. in case of the html node - it will return itself
    //
    // but those exceptions were never presented as a real life use-cases
    // and might be considered as more preferable results.
    //
    // This logic, however, is not guaranteed and can change at any point in the future
    offsetParent: function offsetParent() {
      return this.map(function () {
        var offsetParent = this.offsetParent;
        while (offsetParent && jQuery.css(offsetParent, "position") === "static") {
          offsetParent = offsetParent.offsetParent;
        }
        return offsetParent || documentElement;
      });
    }
  });

  // Create scrollLeft and scrollTop methods
  jQuery.each({
    scrollLeft: "pageXOffset",
    scrollTop: "pageYOffset"
  }, function (method, prop) {
    var top = "pageYOffset" === prop;
    jQuery.fn[method] = function (val) {
      return _access(this, function (elem, method, val) {
        // Coalesce documents and windows
        var win;
        if (isWindow(elem)) {
          win = elem;
        } else if (elem.nodeType === 9) {
          win = elem.defaultView;
        }
        if (val === undefined) {
          return win ? win[prop] : elem[method];
        }
        if (win) {
          win.scrollTo(!top ? val : win.pageXOffset, top ? val : win.pageYOffset);
        } else {
          elem[method] = val;
        }
      }, method, val, arguments.length);
    };
  });

  // Support: Safari <=7 - 9.1, Chrome <=37 - 49
  // Add the top/left cssHooks using jQuery.fn.position
  // Webkit bug: https://bugs.webkit.org/show_bug.cgi?id=29084
  // Blink bug: https://bugs.chromium.org/p/chromium/issues/detail?id=589347
  // getComputedStyle returns percent when specified for top/left/bottom/right;
  // rather than make the css module depend on the offset module, just check for it here
  jQuery.each(["top", "left"], function (_i, prop) {
    jQuery.cssHooks[prop] = addGetHookIf(support.pixelPosition, function (elem, computed) {
      if (computed) {
        computed = curCSS(elem, prop);

        // If curCSS returns percentage, fallback to offset
        return rnumnonpx.test(computed) ? jQuery(elem).position()[prop] + "px" : computed;
      }
    });
  });

  // Create innerHeight, innerWidth, height, width, outerHeight and outerWidth methods
  jQuery.each({
    Height: "height",
    Width: "width"
  }, function (name, type) {
    jQuery.each({
      padding: "inner" + name,
      content: type,
      "": "outer" + name
    }, function (defaultExtra, funcName) {
      // Margin is only for outerHeight, outerWidth
      jQuery.fn[funcName] = function (margin, value) {
        var chainable = arguments.length && (defaultExtra || typeof margin !== "boolean"),
          extra = defaultExtra || (margin === true || value === true ? "margin" : "border");
        return _access(this, function (elem, type, value) {
          var doc;
          if (isWindow(elem)) {
            // $( window ).outerWidth/Height return w/h including scrollbars (gh-1729)
            return funcName.indexOf("outer") === 0 ? elem["inner" + name] : elem.document.documentElement["client" + name];
          }

          // Get document width or height
          if (elem.nodeType === 9) {
            doc = elem.documentElement;

            // Either scroll[Width/Height] or offset[Width/Height] or client[Width/Height],
            // whichever is greatest
            return Math.max(elem.body["scroll" + name], doc["scroll" + name], elem.body["offset" + name], doc["offset" + name], doc["client" + name]);
          }
          return value === undefined ?
          // Get width or height on the element, requesting but not forcing parseFloat
          jQuery.css(elem, type, extra) :
          // Set width or height on the element
          jQuery.style(elem, type, value, extra);
        }, type, chainable ? margin : undefined, chainable);
      };
    });
  });
  jQuery.each(["ajaxStart", "ajaxStop", "ajaxComplete", "ajaxError", "ajaxSuccess", "ajaxSend"], function (_i, type) {
    jQuery.fn[type] = function (fn) {
      return this.on(type, fn);
    };
  });
  jQuery.fn.extend({
    bind: function bind(types, data, fn) {
      return this.on(types, null, data, fn);
    },
    unbind: function unbind(types, fn) {
      return this.off(types, null, fn);
    },
    delegate: function delegate(selector, types, data, fn) {
      return this.on(types, selector, data, fn);
    },
    undelegate: function undelegate(selector, types, fn) {
      // ( namespace ) or ( selector, types [, fn] )
      return arguments.length === 1 ? this.off(selector, "**") : this.off(types, selector || "**", fn);
    },
    hover: function hover(fnOver, fnOut) {
      return this.on("mouseenter", fnOver).on("mouseleave", fnOut || fnOver);
    }
  });
  jQuery.each(("blur focus focusin focusout resize scroll click dblclick " + "mousedown mouseup mousemove mouseover mouseout mouseenter mouseleave " + "change select submit keydown keypress keyup contextmenu").split(" "), function (_i, name) {
    // Handle event binding
    jQuery.fn[name] = function (data, fn) {
      return arguments.length > 0 ? this.on(name, null, data, fn) : this.trigger(name);
    };
  });

  // Support: Android <=4.0 only
  // Make sure we trim BOM and NBSP
  // Require that the "whitespace run" starts from a non-whitespace
  // to avoid O(N^2) behavior when the engine would try matching "\s+$" at each space position.
  var rtrim = /^[\s\uFEFF\xA0]+|([^\s\uFEFF\xA0])[\s\uFEFF\xA0]+$/g;

  // Bind a function to a context, optionally partially applying any
  // arguments.
  // jQuery.proxy is deprecated to promote standards (specifically Function#bind)
  // However, it is not slated for removal any time soon
  jQuery.proxy = function (fn, context) {
    var tmp, args, proxy;
    if (typeof context === "string") {
      tmp = fn[context];
      context = fn;
      fn = tmp;
    }

    // Quick check to determine if target is callable, in the spec
    // this throws a TypeError, but we will just return undefined.
    if (!isFunction(fn)) {
      return undefined;
    }

    // Simulated bind
    args = _slice.call(arguments, 2);
    proxy = function proxy() {
      return fn.apply(context || this, args.concat(_slice.call(arguments)));
    };

    // Set the guid of unique handler to the same of original handler, so it can be removed
    proxy.guid = fn.guid = fn.guid || jQuery.guid++;
    return proxy;
  };
  jQuery.holdReady = function (hold) {
    if (hold) {
      jQuery.readyWait++;
    } else {
      jQuery.ready(true);
    }
  };
  jQuery.isArray = Array.isArray;
  jQuery.parseJSON = JSON.parse;
  jQuery.nodeName = nodeName;
  jQuery.isFunction = isFunction;
  jQuery.isWindow = isWindow;
  jQuery.camelCase = camelCase;
  jQuery.type = toType;
  jQuery.now = Date.now;
  jQuery.isNumeric = function (obj) {
    // As of jQuery 3.0, isNumeric is limited to
    // strings and numbers (primitives or objects)
    // that can be coerced to finite numbers (gh-2662)
    var type = jQuery.type(obj);
    return (type === "number" || type === "string") &&
    // parseFloat NaNs numeric-cast false positives ("")
    // ...but misinterprets leading-number strings, particularly hex literals ("0x...")
    // subtraction forces infinities to NaN
    !isNaN(obj - parseFloat(obj));
  };
  jQuery.trim = function (text) {
    return text == null ? "" : (text + "").replace(rtrim, "$1");
  };

  // Register as a named AMD module, since jQuery can be concatenated with other
  // files that may use define, but not via a proper concatenation script that
  // understands anonymous AMD modules. A named AMD is safest and most robust
  // way to register. Lowercase jquery is used because AMD module names are
  // derived from file names, and jQuery is normally delivered in a lowercase
  // file name. Do this after creating the global so that if an AMD module wants
  // to call noConflict to hide this version of jQuery, it will work.

  // Note that for maximum portability, libraries that are not jQuery should
  // declare themselves as anonymous modules, and avoid setting a global if an
  // AMD loader is present. jQuery is a special case. For more information, see
  // https://github.com/jrburke/requirejs/wiki/Updating-existing-libraries#wiki-anon

  if (typeof define === "function" && define.amd) {
    define("jquery", [], function () {
      return jQuery;
    });
  }
  var
    // Map over jQuery in case of overwrite
    _jQuery = window.jQuery,
    // Map over the $ in case of overwrite
    _$ = window.$;
  jQuery.noConflict = function (deep) {
    if (window.$ === jQuery) {
      window.$ = _$;
    }
    if (deep && window.jQuery === jQuery) {
      window.jQuery = _jQuery;
    }
    return jQuery;
  };

  // Expose jQuery and $ identifiers, even in AMD
  // (trac-7102#comment:10, https://github.com/jquery/jquery/pull/557)
  // and CommonJS for browser emulators (trac-13566)
  if (typeof noGlobal === "undefined") {
    window.jQuery = window.$ = jQuery;
  }
  return jQuery;
});

/**
 * @license AngularJS v1.8.2
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function (window) {
  'use strict';

  /* exported
    minErrConfig,
    errorHandlingConfig,
    isValidObjectMaxDepth
  */
  var minErrConfig = {
    objectMaxDepth: 5,
    urlErrorParamsEnabled: true
  };

  /**
   * @ngdoc function
   * @name angular.errorHandlingConfig
   * @module ng
   * @kind function
   *
   * @description
   * Configure several aspects of error handling in AngularJS if used as a setter or return the
   * current configuration if used as a getter. The following options are supported:
   *
   * - **objectMaxDepth**: The maximum depth to which objects are traversed when stringified for error messages.
   *
   * Omitted or undefined options will leave the corresponding configuration values unchanged.
   *
   * @param {Object=} config - The configuration object. May only contain the options that need to be
   *     updated. Supported keys:
   *
   * * `objectMaxDepth`  **{Number}** - The max depth for stringifying objects. Setting to a
   *   non-positive or non-numeric value, removes the max depth limit.
   *   Default: 5
   *
   * * `urlErrorParamsEnabled`  **{Boolean}** - Specifies whether the generated error url will
   *   contain the parameters of the thrown error. Disabling the parameters can be useful if the
   *   generated error url is very long.
   *
   *   Default: true. When used without argument, it returns the current value.
   */
  function errorHandlingConfig(config) {
    if (isObject(config)) {
      if (isDefined(config.objectMaxDepth)) {
        minErrConfig.objectMaxDepth = isValidObjectMaxDepth(config.objectMaxDepth) ? config.objectMaxDepth : NaN;
      }
      if (isDefined(config.urlErrorParamsEnabled) && isBoolean(config.urlErrorParamsEnabled)) {
        minErrConfig.urlErrorParamsEnabled = config.urlErrorParamsEnabled;
      }
    } else {
      return minErrConfig;
    }
  }

  /**
   * @private
   * @param {Number} maxDepth
   * @return {boolean}
   */
  function isValidObjectMaxDepth(maxDepth) {
    return isNumber(maxDepth) && maxDepth > 0;
  }

  /**
   * @description
   *
   * This object provides a utility for producing rich Error messages within
   * AngularJS. It can be called as follows:
   *
   * var exampleMinErr = minErr('example');
   * throw exampleMinErr('one', 'This {0} is {1}', foo, bar);
   *
   * The above creates an instance of minErr in the example namespace. The
   * resulting error will have a namespaced error code of example.one.  The
   * resulting error will replace {0} with the value of foo, and {1} with the
   * value of bar. The object is not restricted in the number of arguments it can
   * take.
   *
   * If fewer arguments are specified than necessary for interpolation, the extra
   * interpolation markers will be preserved in the final string.
   *
   * Since data will be parsed statically during a build step, some restrictions
   * are applied with respect to how minErr instances are created and called.
   * Instances should have names of the form namespaceMinErr for a minErr created
   * using minErr('namespace'). Error codes, namespaces and template strings
   * should all be static strings, not variables or general expressions.
   *
   * @param {string} module The namespace to use for the new minErr instance.
   * @param {function} ErrorConstructor Custom error constructor to be instantiated when returning
   *   error from returned function, for cases when a particular type of error is useful.
   * @returns {function(code:string, template:string, ...templateArgs): Error} minErr instance
   */

  function minErr(module, ErrorConstructor) {
    ErrorConstructor = ErrorConstructor || Error;
    var url = 'https://errors.angularjs.org/1.8.2/';
    var regex = url.replace('.', '\\.') + '[\\s\\S]*';
    var errRegExp = new RegExp(regex, 'g');
    return function () {
      var code = arguments[0],
        template = arguments[1],
        message = '[' + (module ? module + ':' : '') + code + '] ',
        templateArgs = sliceArgs(arguments, 2).map(function (arg) {
          return toDebugString(arg, minErrConfig.objectMaxDepth);
        }),
        paramPrefix,
        i;

      // A minErr message has two parts: the message itself and the url that contains the
      // encoded message.
      // The message's parameters can contain other error messages which also include error urls.
      // To prevent the messages from getting too long, we strip the error urls from the parameters.

      message += template.replace(/\{\d+\}/g, function (match) {
        var index = +match.slice(1, -1);
        if (index < templateArgs.length) {
          return templateArgs[index].replace(errRegExp, '');
        }
        return match;
      });
      message += '\n' + url + (module ? module + '/' : '') + code;
      if (minErrConfig.urlErrorParamsEnabled) {
        for (i = 0, paramPrefix = '?'; i < templateArgs.length; i++, paramPrefix = '&') {
          message += paramPrefix + 'p' + i + '=' + encodeURIComponent(templateArgs[i]);
        }
      }
      return new ErrorConstructor(message);
    };
  }

  /* We need to tell ESLint what variables are being exported */
  /* exported
    angular,
    msie,
    jqLite,
    jQuery,
    slice,
    splice,
    push,
    toString,
    minErrConfig,
    errorHandlingConfig,
    isValidObjectMaxDepth,
    ngMinErr,
    angularModule,
    uid,
    REGEX_STRING_REGEXP,
    VALIDITY_STATE_PROPERTY,
  
    lowercase,
    uppercase,
    nodeName_,
    isArrayLike,
    forEach,
    forEachSorted,
    reverseParams,
    nextUid,
    setHashKey,
    extend,
    toInt,
    inherit,
    merge,
    noop,
    identity,
    valueFn,
    isUndefined,
    isDefined,
    isObject,
    isBlankObject,
    isString,
    isNumber,
    isNumberNaN,
    isDate,
    isError,
    isArray,
    isFunction,
    isRegExp,
    isWindow,
    isScope,
    isFile,
    isFormData,
    isBlob,
    isBoolean,
    isPromiseLike,
    trim,
    escapeForRegexp,
    isElement,
    makeMap,
    includes,
    arrayRemove,
    copy,
    simpleCompare,
    equals,
    csp,
    jq,
    concat,
    sliceArgs,
    bind,
    toJsonReplacer,
    toJson,
    fromJson,
    convertTimezoneToLocal,
    timezoneToOffset,
    addDateMinutes,
    startingTag,
    tryDecodeURIComponent,
    parseKeyValue,
    toKeyValue,
    encodeUriSegment,
    encodeUriQuery,
    angularInit,
    bootstrap,
    getTestability,
    snake_case,
    bindJQuery,
    assertArg,
    assertArgFn,
    assertNotHasOwnProperty,
    getter,
    getBlockNodes,
    hasOwnProperty,
    createMap,
    stringify,
    UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
  
    NODE_TYPE_ELEMENT,
    NODE_TYPE_ATTRIBUTE,
    NODE_TYPE_TEXT,
    NODE_TYPE_COMMENT,
    NODE_TYPE_DOCUMENT,
    NODE_TYPE_DOCUMENT_FRAGMENT
  */

  ////////////////////////////////////

  /**
   * @ngdoc module
   * @name ng
   * @module ng
   * @installation
   * @description
   *
   * The ng module is loaded by default when an AngularJS application is started. The module itself
   * contains the essential components for an AngularJS application to function. The table below
   * lists a high level breakdown of each of the services/factories, filters, directives and testing
   * components available within this core module.
   *
   */

  var REGEX_STRING_REGEXP = /^\/(.+)\/([a-z]*)$/;

  // The name of a form control's ValidityState property.
  // This is used so that it's possible for internal tests to create mock ValidityStates.
  var VALIDITY_STATE_PROPERTY = 'validity';
  var hasOwnProperty = Object.prototype.hasOwnProperty;

  /**
   * @private
   *
   * @description Converts the specified string to lowercase.
   * @param {string} string String to be converted to lowercase.
   * @returns {string} Lowercased string.
   */
  var lowercase = function lowercase(string) {
    return isString(string) ? string.toLowerCase() : string;
  };

  /**
   * @private
   *
   * @description Converts the specified string to uppercase.
   * @param {string} string String to be converted to uppercase.
   * @returns {string} Uppercased string.
   */
  var uppercase = function uppercase(string) {
    return isString(string) ? string.toUpperCase() : string;
  };
  var msie,
    // holds major version number for IE, or NaN if UA is not IE.
    jqLite,
    // delay binding since jQuery could be loaded after us.
    jQuery,
    // delay binding
    slice = [].slice,
    splice = [].splice,
    push = [].push,
    toString = Object.prototype.toString,
    getPrototypeOf = Object.getPrototypeOf,
    ngMinErr = minErr('ng'),
    /** @name angular */
    angular = window.angular || (window.angular = {}),
    angularModule,
    uid = 0;

  // Support: IE 9-11 only
  /**
   * documentMode is an IE-only property
   * http://msdn.microsoft.com/en-us/library/ie/cc196988(v=vs.85).aspx
   */
  msie = window.document.documentMode;

  /**
   * @private
   * @param {*} obj
   * @return {boolean} Returns true if `obj` is an array or array-like object (NodeList, Arguments,
   *                   String ...)
   */
  function isArrayLike(obj) {
    // `null`, `undefined` and `window` are not array-like
    if (obj == null || isWindow(obj)) return false;

    // arrays, strings and jQuery/jqLite objects are array like
    // * jqLite is either the jQuery or jqLite constructor function
    // * we have to check the existence of jqLite first as this method is called
    //   via the forEach method when constructing the jqLite object in the first place
    if (isArray(obj) || isString(obj) || jqLite && obj instanceof jqLite) return true;

    // Support: iOS 8.2 (not reproducible in simulator)
    // "length" in obj used to prevent JIT error (gh-11508)
    var length = 'length' in Object(obj) && obj.length;

    // NodeList objects (with `item` method) and
    // other objects with suitable length characteristics are array-like
    return isNumber(length) && (length >= 0 && length - 1 in obj || typeof obj.item === 'function');
  }

  /**
   * @ngdoc function
   * @name angular.forEach
   * @module ng
   * @kind function
   *
   * @description
   * Invokes the `iterator` function once for each item in `obj` collection, which can be either an
   * object or an array. The `iterator` function is invoked with `iterator(value, key, obj)`, where `value`
   * is the value of an object property or an array element, `key` is the object property key or
   * array element index and obj is the `obj` itself. Specifying a `context` for the function is optional.
   *
   * It is worth noting that `.forEach` does not iterate over inherited properties because it filters
   * using the `hasOwnProperty` method.
   *
   * Unlike ES262's
   * [Array.prototype.forEach](http://www.ecma-international.org/ecma-262/5.1/#sec-15.4.4.18),
   * providing 'undefined' or 'null' values for `obj` will not throw a TypeError, but rather just
   * return the value provided.
   *
     ```js
       var values = {name: 'misko', gender: 'male'};
       var log = [];
       angular.forEach(values, function(value, key) {
         this.push(key + ': ' + value);
       }, log);
       expect(log).toEqual(['name: misko', 'gender: male']);
     ```
   *
   * @param {Object|Array} obj Object to iterate over.
   * @param {Function} iterator Iterator function.
   * @param {Object=} context Object to become context (`this`) for the iterator function.
   * @returns {Object|Array} Reference to `obj`.
   */

  function forEach(obj, iterator, context) {
    var key, length;
    if (obj) {
      if (isFunction(obj)) {
        for (key in obj) {
          if (key !== 'prototype' && key !== 'length' && key !== 'name' && obj.hasOwnProperty(key)) {
            iterator.call(context, obj[key], key, obj);
          }
        }
      } else if (isArray(obj) || isArrayLike(obj)) {
        var isPrimitive = _typeof(obj) !== 'object';
        for (key = 0, length = obj.length; key < length; key++) {
          if (isPrimitive || key in obj) {
            iterator.call(context, obj[key], key, obj);
          }
        }
      } else if (obj.forEach && obj.forEach !== forEach) {
        obj.forEach(iterator, context, obj);
      } else if (isBlankObject(obj)) {
        // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
        for (key in obj) {
          iterator.call(context, obj[key], key, obj);
        }
      } else if (typeof obj.hasOwnProperty === 'function') {
        // Slow path for objects inheriting Object.prototype, hasOwnProperty check needed
        for (key in obj) {
          if (obj.hasOwnProperty(key)) {
            iterator.call(context, obj[key], key, obj);
          }
        }
      } else {
        // Slow path for objects which do not have a method `hasOwnProperty`
        for (key in obj) {
          if (hasOwnProperty.call(obj, key)) {
            iterator.call(context, obj[key], key, obj);
          }
        }
      }
    }
    return obj;
  }
  function forEachSorted(obj, iterator, context) {
    var keys = Object.keys(obj).sort();
    for (var i = 0; i < keys.length; i++) {
      iterator.call(context, obj[keys[i]], keys[i]);
    }
    return keys;
  }

  /**
   * when using forEach the params are value, key, but it is often useful to have key, value.
   * @param {function(string, *)} iteratorFn
   * @returns {function(*, string)}
   */
  function reverseParams(iteratorFn) {
    return function (value, key) {
      iteratorFn(key, value);
    };
  }

  /**
   * A consistent way of creating unique IDs in angular.
   *
   * Using simple numbers allows us to generate 28.6 million unique ids per second for 10 years before
   * we hit number precision issues in JavaScript.
   *
   * Math.pow(2,53) / 60 / 60 / 24 / 365 / 10 = 28.6M
   *
   * @returns {number} an unique alpha-numeric string
   */
  function nextUid() {
    return ++uid;
  }

  /**
   * Set or clear the hashkey for an object.
   * @param obj object
   * @param h the hashkey (!truthy to delete the hashkey)
   */
  function setHashKey(obj, h) {
    if (h) {
      obj.$$hashKey = h;
    } else {
      delete obj.$$hashKey;
    }
  }
  function baseExtend(dst, objs, deep) {
    var h = dst.$$hashKey;
    for (var i = 0, ii = objs.length; i < ii; ++i) {
      var obj = objs[i];
      if (!isObject(obj) && !isFunction(obj)) continue;
      var keys = Object.keys(obj);
      for (var j = 0, jj = keys.length; j < jj; j++) {
        var key = keys[j];
        var src = obj[key];
        if (deep && isObject(src)) {
          if (isDate(src)) {
            dst[key] = new Date(src.valueOf());
          } else if (isRegExp(src)) {
            dst[key] = new RegExp(src);
          } else if (src.nodeName) {
            dst[key] = src.cloneNode(true);
          } else if (isElement(src)) {
            dst[key] = src.clone();
          } else {
            if (key !== '__proto__') {
              if (!isObject(dst[key])) dst[key] = isArray(src) ? [] : {};
              baseExtend(dst[key], [src], true);
            }
          }
        } else {
          dst[key] = src;
        }
      }
    }
    setHashKey(dst, h);
    return dst;
  }

  /**
   * @ngdoc function
   * @name angular.extend
   * @module ng
   * @kind function
   *
   * @description
   * Extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
   * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
   * by passing an empty object as the target: `var object = angular.extend({}, object1, object2)`.
   *
   * **Note:** Keep in mind that `angular.extend` does not support recursive merge (deep copy). Use
   * {@link angular.merge} for this.
   *
   * @param {Object} dst Destination object.
   * @param {...Object} src Source object(s).
   * @returns {Object} Reference to `dst`.
   */
  function extend(dst) {
    return baseExtend(dst, slice.call(arguments, 1), false);
  }

  /**
  * @ngdoc function
  * @name angular.merge
  * @module ng
  * @kind function
  *
  * @description
  * Deeply extends the destination object `dst` by copying own enumerable properties from the `src` object(s)
  * to `dst`. You can specify multiple `src` objects. If you want to preserve original objects, you can do so
  * by passing an empty object as the target: `var object = angular.merge({}, object1, object2)`.
  *
  * Unlike {@link angular.extend extend()}, `merge()` recursively descends into object properties of source
  * objects, performing a deep copy.
  *
  * @deprecated
  * sinceVersion="1.6.5"
  * This function is deprecated, but will not be removed in the 1.x lifecycle.
  * There are edge cases (see {@link angular.merge#known-issues known issues}) that are not
  * supported by this function. We suggest using another, similar library for all-purpose merging,
  * such as [lodash's merge()](https://lodash.com/docs/4.17.4#merge).
  *
  * @knownIssue
  * This is a list of (known) object types that are not handled correctly by this function:
  * - [`Blob`](https://developer.mozilla.org/docs/Web/API/Blob)
  * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
  * - [`CanvasGradient`](https://developer.mozilla.org/docs/Web/API/CanvasGradient)
  * - AngularJS {@link $rootScope.Scope scopes};
  *
  * `angular.merge` also does not support merging objects with circular references.
  *
  * @param {Object} dst Destination object.
  * @param {...Object} src Source object(s).
  * @returns {Object} Reference to `dst`.
  */
  function merge(dst) {
    return baseExtend(dst, slice.call(arguments, 1), true);
  }
  function toInt(str) {
    return parseInt(str, 10);
  }
  var isNumberNaN = Number.isNaN || function isNumberNaN(num) {
    // eslint-disable-next-line no-self-compare
    return num !== num;
  };
  function inherit(parent, extra) {
    return extend(Object.create(parent), extra);
  }

  /**
   * @ngdoc function
   * @name angular.noop
   * @module ng
   * @kind function
   *
   * @description
   * A function that performs no operations. This function can be useful when writing code in the
   * functional style.
     ```js
       function foo(callback) {
         var result = calculateResult();
         (callback || angular.noop)(result);
       }
     ```
   */
  function noop() {}
  noop.$inject = [];

  /**
   * @ngdoc function
   * @name angular.identity
   * @module ng
   * @kind function
   *
   * @description
   * A function that returns its first argument. This function is useful when writing code in the
   * functional style.
   *
     ```js
     function transformer(transformationFn, value) {
       return (transformationFn || angular.identity)(value);
     };
  
     // E.g.
     function getResult(fn, input) {
       return (fn || angular.identity)(input);
     };
  
     getResult(function(n) { return n * 2; }, 21);   // returns 42
     getResult(null, 21);                            // returns 21
     getResult(undefined, 21);                       // returns 21
     ```
   *
   * @param {*} value to be returned.
   * @returns {*} the value passed in.
   */
  function identity($) {
    return $;
  }
  identity.$inject = [];
  function valueFn(value) {
    return function valueRef() {
      return value;
    };
  }
  function hasCustomToString(obj) {
    return isFunction(obj.toString) && obj.toString !== toString;
  }

  /**
   * @ngdoc function
   * @name angular.isUndefined
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is undefined.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is undefined.
   */
  function isUndefined(value) {
    return typeof value === 'undefined';
  }

  /**
   * @ngdoc function
   * @name angular.isDefined
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is defined.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is defined.
   */
  function isDefined(value) {
    return typeof value !== 'undefined';
  }

  /**
   * @ngdoc function
   * @name angular.isObject
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is an `Object`. Unlike `typeof` in JavaScript, `null`s are not
   * considered to be objects. Note that JavaScript arrays are objects.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is an `Object` but not `null`.
   */
  function isObject(value) {
    // http://jsperf.com/isobject4
    return value !== null && _typeof(value) === 'object';
  }

  /**
   * Determine if a value is an object with a null prototype
   *
   * @returns {boolean} True if `value` is an `Object` with a null prototype
   */
  function isBlankObject(value) {
    return value !== null && _typeof(value) === 'object' && !getPrototypeOf(value);
  }

  /**
   * @ngdoc function
   * @name angular.isString
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is a `String`.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `String`.
   */
  function isString(value) {
    return typeof value === 'string';
  }

  /**
   * @ngdoc function
   * @name angular.isNumber
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is a `Number`.
   *
   * This includes the "special" numbers `NaN`, `+Infinity` and `-Infinity`.
   *
   * If you wish to exclude these then you can use the native
   * [`isFinite'](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/isFinite)
   * method.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `Number`.
   */
  function isNumber(value) {
    return typeof value === 'number';
  }

  /**
   * @ngdoc function
   * @name angular.isDate
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a value is a date.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `Date`.
   */
  function isDate(value) {
    return toString.call(value) === '[object Date]';
  }

  /**
   * @ngdoc function
   * @name angular.isArray
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is an `Array`.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is an `Array`.
   */
  function isArray(arr) {
    return Array.isArray(arr) || arr instanceof Array;
  }

  /**
   * @description
   * Determines if a reference is an `Error`.
   * Loosely based on https://www.npmjs.com/package/iserror
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is an `Error`.
   */
  function isError(value) {
    var tag = toString.call(value);
    switch (tag) {
      case '[object Error]':
        return true;
      case '[object Exception]':
        return true;
      case '[object DOMException]':
        return true;
      default:
        return value instanceof Error;
    }
  }

  /**
   * @ngdoc function
   * @name angular.isFunction
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is a `Function`.
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `Function`.
   */
  function isFunction(value) {
    return typeof value === 'function';
  }

  /**
   * Determines if a value is a regular expression object.
   *
   * @private
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a `RegExp`.
   */
  function isRegExp(value) {
    return toString.call(value) === '[object RegExp]';
  }

  /**
   * Checks if `obj` is a window object.
   *
   * @private
   * @param {*} obj Object to check
   * @returns {boolean} True if `obj` is a window obj.
   */
  function isWindow(obj) {
    return obj && obj.window === obj;
  }
  function isScope(obj) {
    return obj && obj.$evalAsync && obj.$watch;
  }
  function isFile(obj) {
    return toString.call(obj) === '[object File]';
  }
  function isFormData(obj) {
    return toString.call(obj) === '[object FormData]';
  }
  function isBlob(obj) {
    return toString.call(obj) === '[object Blob]';
  }
  function isBoolean(value) {
    return typeof value === 'boolean';
  }
  function isPromiseLike(obj) {
    return obj && isFunction(obj.then);
  }
  var TYPED_ARRAY_REGEXP = /^\[object (?:Uint8|Uint8Clamped|Uint16|Uint32|Int8|Int16|Int32|Float32|Float64)Array]$/;
  function isTypedArray(value) {
    return value && isNumber(value.length) && TYPED_ARRAY_REGEXP.test(toString.call(value));
  }
  function isArrayBuffer(obj) {
    return toString.call(obj) === '[object ArrayBuffer]';
  }
  var trim = function trim(value) {
    return isString(value) ? value.trim() : value;
  };

  // Copied from:
  // http://docs.closure-library.googlecode.com/git/local_closure_goog_string_string.js.source.html#line1021
  // Prereq: s is a string.
  var escapeForRegexp = function escapeForRegexp(s) {
    return s.replace(/([-()[\]{}+?*.$^|,:#<!\\])/g, '\\$1')
    // eslint-disable-next-line no-control-regex
    .replace(/\x08/g, '\\x08');
  };

  /**
   * @ngdoc function
   * @name angular.isElement
   * @module ng
   * @kind function
   *
   * @description
   * Determines if a reference is a DOM element (or wrapped jQuery element).
   *
   * @param {*} value Reference to check.
   * @returns {boolean} True if `value` is a DOM element (or wrapped jQuery element).
   */
  function isElement(node) {
    return !!(node && (node.nodeName // We are a direct element.
    || node.prop && node.attr && node.find)); // We have an on and find method part of jQuery API.
  }

  /**
   * @param str 'key1,key2,...'
   * @returns {object} in the form of {key1:true, key2:true, ...}
   */
  function makeMap(str) {
    var obj = {},
      items = str.split(','),
      i;
    for (i = 0; i < items.length; i++) {
      obj[items[i]] = true;
    }
    return obj;
  }
  function nodeName_(element) {
    return lowercase(element.nodeName || element[0] && element[0].nodeName);
  }
  function includes(array, obj) {
    return Array.prototype.indexOf.call(array, obj) !== -1;
  }
  function arrayRemove(array, value) {
    var index = array.indexOf(value);
    if (index >= 0) {
      array.splice(index, 1);
    }
    return index;
  }

  /**
   * @ngdoc function
   * @name angular.copy
   * @module ng
   * @kind function
   *
   * @description
   * Creates a deep copy of `source`, which should be an object or an array. This functions is used
   * internally, mostly in the change-detection code. It is not intended as an all-purpose copy
   * function, and has several limitations (see below).
   *
   * * If no destination is supplied, a copy of the object or array is created.
   * * If a destination is provided, all of its elements (for arrays) or properties (for objects)
   *   are deleted and then all elements/properties from the source are copied to it.
   * * If `source` is not an object or array (inc. `null` and `undefined`), `source` is returned.
   * * If `source` is identical to `destination` an exception will be thrown.
   *
   * <br />
   *
   * <div class="alert alert-warning">
   *   Only enumerable properties are taken into account. Non-enumerable properties (both on `source`
   *   and on `destination`) will be ignored.
   * </div>
   *
   * <div class="alert alert-warning">
   *   `angular.copy` does not check if destination and source are of the same type. It's the
   *   developer's responsibility to make sure they are compatible.
   * </div>
   *
   * @knownIssue
   * This is a non-exhaustive list of object types / features that are not handled correctly by
   * `angular.copy`. Note that since this functions is used by the change detection code, this
   * means binding or watching objects of these types (or that include these types) might not work
   * correctly.
   * - [`File`](https://developer.mozilla.org/docs/Web/API/File)
   * - [`Map`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Map)
   * - [`ImageData`](https://developer.mozilla.org/docs/Web/API/ImageData)
   * - [`MediaStream`](https://developer.mozilla.org/docs/Web/API/MediaStream)
   * - [`Set`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/Set)
   * - [`WeakMap`](https://developer.mozilla.org/docs/Web/JavaScript/Reference/Global_Objects/WeakMap)
   * - [`getter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/get)/
   *   [`setter`](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Functions/set)
   *
   * @param {*} source The source that will be used to make a copy. Can be any type, including
   *     primitives, `null`, and `undefined`.
   * @param {(Object|Array)=} destination Destination into which the source is copied. If provided,
   *     must be of the same type as `source`.
   * @returns {*} The copy or updated `destination`, if `destination` was specified.
   *
   * @example
    <example module="copyExample" name="angular-copy">
      <file name="index.html">
        <div ng-controller="ExampleController">
          <form novalidate class="simple-form">
            <label>Name: <input type="text" ng-model="user.name" /></label><br />
            <label>Age:  <input type="number" ng-model="user.age" /></label><br />
            Gender: <label><input type="radio" ng-model="user.gender" value="male" />male</label>
                    <label><input type="radio" ng-model="user.gender" value="female" />female</label><br />
            <button ng-click="reset()">RESET</button>
            <button ng-click="update(user)">SAVE</button>
          </form>
          <pre>form = {{user | json}}</pre>
          <pre>leader = {{leader | json}}</pre>
        </div>
      </file>
      <file name="script.js">
        // Module: copyExample
        angular.
          module('copyExample', []).
          controller('ExampleController', ['$scope', function($scope) {
            $scope.leader = {};
  
            $scope.reset = function() {
              // Example with 1 argument
              $scope.user = angular.copy($scope.leader);
            };
  
            $scope.update = function(user) {
              // Example with 2 arguments
              angular.copy(user, $scope.leader);
            };
  
            $scope.reset();
          }]);
      </file>
    </example>
   */
  function copy(source, destination, maxDepth) {
    var stackSource = [];
    var stackDest = [];
    maxDepth = isValidObjectMaxDepth(maxDepth) ? maxDepth : NaN;
    if (destination) {
      if (isTypedArray(destination) || isArrayBuffer(destination)) {
        throw ngMinErr('cpta', 'Can\'t copy! TypedArray destination cannot be mutated.');
      }
      if (source === destination) {
        throw ngMinErr('cpi', 'Can\'t copy! Source and destination are identical.');
      }

      // Empty the destination object
      if (isArray(destination)) {
        destination.length = 0;
      } else {
        forEach(destination, function (value, key) {
          if (key !== '$$hashKey') {
            delete destination[key];
          }
        });
      }
      stackSource.push(source);
      stackDest.push(destination);
      return copyRecurse(source, destination, maxDepth);
    }
    return copyElement(source, maxDepth);
    function copyRecurse(source, destination, maxDepth) {
      maxDepth--;
      if (maxDepth < 0) {
        return '...';
      }
      var h = destination.$$hashKey;
      var key;
      if (isArray(source)) {
        for (var i = 0, ii = source.length; i < ii; i++) {
          destination.push(copyElement(source[i], maxDepth));
        }
      } else if (isBlankObject(source)) {
        // createMap() fast path --- Safe to avoid hasOwnProperty check because prototype chain is empty
        for (key in source) {
          destination[key] = copyElement(source[key], maxDepth);
        }
      } else if (source && typeof source.hasOwnProperty === 'function') {
        // Slow path, which must rely on hasOwnProperty
        for (key in source) {
          if (source.hasOwnProperty(key)) {
            destination[key] = copyElement(source[key], maxDepth);
          }
        }
      } else {
        // Slowest path --- hasOwnProperty can't be called as a method
        for (key in source) {
          if (hasOwnProperty.call(source, key)) {
            destination[key] = copyElement(source[key], maxDepth);
          }
        }
      }
      setHashKey(destination, h);
      return destination;
    }
    function copyElement(source, maxDepth) {
      // Simple values
      if (!isObject(source)) {
        return source;
      }

      // Already copied values
      var index = stackSource.indexOf(source);
      if (index !== -1) {
        return stackDest[index];
      }
      if (isWindow(source) || isScope(source)) {
        throw ngMinErr('cpws', 'Can\'t copy! Making copies of Window or Scope instances is not supported.');
      }
      var needsRecurse = false;
      var destination = copyType(source);
      if (destination === undefined) {
        destination = isArray(source) ? [] : Object.create(getPrototypeOf(source));
        needsRecurse = true;
      }
      stackSource.push(source);
      stackDest.push(destination);
      return needsRecurse ? copyRecurse(source, destination, maxDepth) : destination;
    }
    function copyType(source) {
      switch (toString.call(source)) {
        case '[object Int8Array]':
        case '[object Int16Array]':
        case '[object Int32Array]':
        case '[object Float32Array]':
        case '[object Float64Array]':
        case '[object Uint8Array]':
        case '[object Uint8ClampedArray]':
        case '[object Uint16Array]':
        case '[object Uint32Array]':
          return new source.constructor(copyElement(source.buffer), source.byteOffset, source.length);
        case '[object ArrayBuffer]':
          // Support: IE10
          if (!source.slice) {
            // If we're in this case we know the environment supports ArrayBuffer
            /* eslint-disable no-undef */
            var copied = new ArrayBuffer(source.byteLength);
            new Uint8Array(copied).set(new Uint8Array(source));
            /* eslint-enable */
            return copied;
          }
          return source.slice(0);
        case '[object Boolean]':
        case '[object Number]':
        case '[object String]':
        case '[object Date]':
          return new source.constructor(source.valueOf());
        case '[object RegExp]':
          var re = new RegExp(source.source, source.toString().match(/[^/]*$/)[0]);
          re.lastIndex = source.lastIndex;
          return re;
        case '[object Blob]':
          return new source.constructor([source], {
            type: source.type
          });
      }
      if (isFunction(source.cloneNode)) {
        return source.cloneNode(true);
      }
    }
  }

  // eslint-disable-next-line no-self-compare
  function simpleCompare(a, b) {
    return a === b || a !== a && b !== b;
  }

  /**
   * @ngdoc function
   * @name angular.equals
   * @module ng
   * @kind function
   *
   * @description
   * Determines if two objects or two values are equivalent. Supports value types, regular
   * expressions, arrays and objects.
   *
   * Two objects or values are considered equivalent if at least one of the following is true:
   *
   * * Both objects or values pass `===` comparison.
   * * Both objects or values are of the same type and all of their properties are equal by
   *   comparing them with `angular.equals`.
   * * Both values are NaN. (In JavaScript, NaN == NaN => false. But we consider two NaN as equal)
   * * Both values represent the same regular expression (In JavaScript,
   *   /abc/ == /abc/ => false. But we consider two regular expressions as equal when their textual
   *   representation matches).
   *
   * During a property comparison, properties of `function` type and properties with names
   * that begin with `$` are ignored.
   *
   * Scope and DOMWindow objects are being compared only by identify (`===`).
   *
   * @param {*} o1 Object or value to compare.
   * @param {*} o2 Object or value to compare.
   * @returns {boolean} True if arguments are equal.
   *
   * @example
     <example module="equalsExample" name="equalsExample">
       <file name="index.html">
        <div ng-controller="ExampleController">
          <form novalidate>
            <h3>User 1</h3>
            Name: <input type="text" ng-model="user1.name">
            Age: <input type="number" ng-model="user1.age">
  
            <h3>User 2</h3>
            Name: <input type="text" ng-model="user2.name">
            Age: <input type="number" ng-model="user2.age">
  
            <div>
              <br/>
              <input type="button" value="Compare" ng-click="compare()">
            </div>
            User 1: <pre>{{user1 | json}}</pre>
            User 2: <pre>{{user2 | json}}</pre>
            Equal: <pre>{{result}}</pre>
          </form>
        </div>
      </file>
      <file name="script.js">
          angular.module('equalsExample', []).controller('ExampleController', ['$scope', function($scope) {
            $scope.user1 = {};
            $scope.user2 = {};
            $scope.compare = function() {
              $scope.result = angular.equals($scope.user1, $scope.user2);
            };
          }]);
      </file>
    </example>
   */
  function equals(o1, o2) {
    if (o1 === o2) return true;
    if (o1 === null || o2 === null) return false;
    // eslint-disable-next-line no-self-compare
    if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
    var t1 = _typeof(o1),
      t2 = _typeof(o2),
      length,
      key,
      keySet;
    if (t1 === t2 && t1 === 'object') {
      if (isArray(o1)) {
        if (!isArray(o2)) return false;
        if ((length = o1.length) === o2.length) {
          for (key = 0; key < length; key++) {
            if (!equals(o1[key], o2[key])) return false;
          }
          return true;
        }
      } else if (isDate(o1)) {
        if (!isDate(o2)) return false;
        return simpleCompare(o1.getTime(), o2.getTime());
      } else if (isRegExp(o1)) {
        if (!isRegExp(o2)) return false;
        return o1.toString() === o2.toString();
      } else {
        if (isScope(o1) || isScope(o2) || isWindow(o1) || isWindow(o2) || isArray(o2) || isDate(o2) || isRegExp(o2)) return false;
        keySet = createMap();
        for (key in o1) {
          if (key.charAt(0) === '$' || isFunction(o1[key])) continue;
          if (!equals(o1[key], o2[key])) return false;
          keySet[key] = true;
        }
        for (key in o2) {
          if (!(key in keySet) && key.charAt(0) !== '$' && isDefined(o2[key]) && !isFunction(o2[key])) return false;
        }
        return true;
      }
    }
    return false;
  }
  var _csp = function csp() {
    if (!isDefined(_csp.rules)) {
      var ngCspElement = window.document.querySelector('[ng-csp]') || window.document.querySelector('[data-ng-csp]');
      if (ngCspElement) {
        var ngCspAttribute = ngCspElement.getAttribute('ng-csp') || ngCspElement.getAttribute('data-ng-csp');
        _csp.rules = {
          noUnsafeEval: !ngCspAttribute || ngCspAttribute.indexOf('no-unsafe-eval') !== -1,
          noInlineStyle: !ngCspAttribute || ngCspAttribute.indexOf('no-inline-style') !== -1
        };
      } else {
        _csp.rules = {
          noUnsafeEval: noUnsafeEval(),
          noInlineStyle: false
        };
      }
    }
    return _csp.rules;
    function noUnsafeEval() {
      try {
        // eslint-disable-next-line no-new, no-new-func
        new Function('');
        return false;
      } catch (e) {
        return true;
      }
    }
  };

  /**
   * @ngdoc directive
   * @module ng
   * @name ngJq
   *
   * @element ANY
   * @param {string=} ngJq the name of the library available under `window`
   * to be used for angular.element
   * @description
   * Use this directive to force the angular.element library.  This should be
   * used to force either jqLite by leaving ng-jq blank or setting the name of
   * the jquery variable under window (eg. jQuery).
   *
   * Since AngularJS looks for this directive when it is loaded (doesn't wait for the
   * DOMContentLoaded event), it must be placed on an element that comes before the script
   * which loads angular. Also, only the first instance of `ng-jq` will be used and all
   * others ignored.
   *
   * @example
   * This example shows how to force jqLite using the `ngJq` directive to the `html` tag.
   ```html
   <!doctype html>
   <html ng-app ng-jq>
   ...
   ...
   </html>
   ```
   * @example
   * This example shows how to use a jQuery based library of a different name.
   * The library name must be available at the top most 'window'.
   ```html
   <!doctype html>
   <html ng-app ng-jq="jQueryLib">
   ...
   ...
   </html>
   ```
   */
  var _jq = function jq() {
    if (isDefined(_jq.name_)) return _jq.name_;
    var el;
    var i,
      ii = ngAttrPrefixes.length,
      prefix,
      name;
    for (i = 0; i < ii; ++i) {
      prefix = ngAttrPrefixes[i];
      el = window.document.querySelector('[' + prefix.replace(':', '\\:') + 'jq]');
      if (el) {
        name = el.getAttribute(prefix + 'jq');
        break;
      }
    }
    return _jq.name_ = name;
  };
  function concat(array1, array2, index) {
    return array1.concat(slice.call(array2, index));
  }
  function sliceArgs(args, startIndex) {
    return slice.call(args, startIndex || 0);
  }

  /**
   * @ngdoc function
   * @name angular.bind
   * @module ng
   * @kind function
   *
   * @description
   * Returns a function which calls function `fn` bound to `self` (`self` becomes the `this` for
   * `fn`). You can supply optional `args` that are prebound to the function. This feature is also
   * known as [partial application](http://en.wikipedia.org/wiki/Partial_application), as
   * distinguished from [function currying](http://en.wikipedia.org/wiki/Currying#Contrast_with_partial_function_application).
   *
   * @param {Object} self Context which `fn` should be evaluated in.
   * @param {function()} fn Function to be bound.
   * @param {...*} args Optional arguments to be prebound to the `fn` function call.
   * @returns {function()} Function that wraps the `fn` with all the specified bindings.
   */
  function bind(self, fn) {
    var curryArgs = arguments.length > 2 ? sliceArgs(arguments, 2) : [];
    if (isFunction(fn) && !(fn instanceof RegExp)) {
      return curryArgs.length ? function () {
        return arguments.length ? fn.apply(self, concat(curryArgs, arguments, 0)) : fn.apply(self, curryArgs);
      } : function () {
        return arguments.length ? fn.apply(self, arguments) : fn.call(self);
      };
    } else {
      // In IE, native methods are not functions so they cannot be bound (note: they don't need to be).
      return fn;
    }
  }
  function toJsonReplacer(key, value) {
    var val = value;
    if (typeof key === 'string' && key.charAt(0) === '$' && key.charAt(1) === '$') {
      val = undefined;
    } else if (isWindow(value)) {
      val = '$WINDOW';
    } else if (value && window.document === value) {
      val = '$DOCUMENT';
    } else if (isScope(value)) {
      val = '$SCOPE';
    }
    return val;
  }

  /**
   * @ngdoc function
   * @name angular.toJson
   * @module ng
   * @kind function
   *
   * @description
   * Serializes input into a JSON-formatted string. Properties with leading $$ characters will be
   * stripped since AngularJS uses this notation internally.
   *
   * @param {Object|Array|Date|string|number|boolean} obj Input to be serialized into JSON.
   * @param {boolean|number} [pretty=2] If set to true, the JSON output will contain newlines and whitespace.
   *    If set to an integer, the JSON output will contain that many spaces per indentation.
   * @returns {string|undefined} JSON-ified string representing `obj`.
   * @knownIssue
   *
   * The Safari browser throws a `RangeError` instead of returning `null` when it tries to stringify a `Date`
   * object with an invalid date value. The only reliable way to prevent this is to monkeypatch the
   * `Date.prototype.toJSON` method as follows:
   *
   * ```
   * var _DatetoJSON = Date.prototype.toJSON;
   * Date.prototype.toJSON = function() {
   *   try {
   *     return _DatetoJSON.call(this);
   *   } catch(e) {
   *     if (e instanceof RangeError) {
   *       return null;
   *     }
   *     throw e;
   *   }
   * };
   * ```
   *
   * See https://github.com/angular/angular.js/pull/14221 for more information.
   */
  function toJson(obj, pretty) {
    if (isUndefined(obj)) return undefined;
    if (!isNumber(pretty)) {
      pretty = pretty ? 2 : null;
    }
    return JSON.stringify(obj, toJsonReplacer, pretty);
  }

  /**
   * @ngdoc function
   * @name angular.fromJson
   * @module ng
   * @kind function
   *
   * @description
   * Deserializes a JSON string.
   *
   * @param {string} json JSON string to deserialize.
   * @returns {Object|Array|string|number} Deserialized JSON string.
   */
  function fromJson(json) {
    return isString(json) ? JSON.parse(json) : json;
  }
  var ALL_COLONS = /:/g;
  function timezoneToOffset(timezone, fallback) {
    // Support: IE 9-11 only, Edge 13-15+
    // IE/Edge do not "understand" colon (`:`) in timezone
    timezone = timezone.replace(ALL_COLONS, '');
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNumberNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }
  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }
  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var dateTimezoneOffset = date.getTimezoneOffset();
    var timezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
    return addDateMinutes(date, reverse * (timezoneOffset - dateTimezoneOffset));
  }

  /**
   * @returns {string} Returns the string representation of the element.
   */
  function startingTag(element) {
    element = jqLite(element).clone().empty();
    var elemHtml = jqLite('<div></div>').append(element).html();
    try {
      return element[0].nodeType === NODE_TYPE_TEXT ? lowercase(elemHtml) : elemHtml.match(/^(<[^>]+>)/)[1].replace(/^<([\w-]+)/, function (match, nodeName) {
        return '<' + lowercase(nodeName);
      });
    } catch (e) {
      return lowercase(elemHtml);
    }
  }

  /////////////////////////////////////////////////

  /**
   * Tries to decode the URI component without throwing an exception.
   *
   * @private
   * @param str value potential URI component to check.
   * @returns {boolean} True if `value` can be decoded
   * with the decodeURIComponent function.
   */
  function tryDecodeURIComponent(value) {
    try {
      return decodeURIComponent(value);
    } catch (e) {
      // Ignore any invalid uri component.
    }
  }

  /**
   * Parses an escaped url query string into key-value pairs.
   * @returns {Object.<string,boolean|Array>}
   */
  function parseKeyValue(/**string*/keyValue) {
    var obj = {};
    forEach((keyValue || '').split('&'), function (keyValue) {
      var splitPoint, key, val;
      if (keyValue) {
        key = keyValue = keyValue.replace(/\+/g, '%20');
        splitPoint = keyValue.indexOf('=');
        if (splitPoint !== -1) {
          key = keyValue.substring(0, splitPoint);
          val = keyValue.substring(splitPoint + 1);
        }
        key = tryDecodeURIComponent(key);
        if (isDefined(key)) {
          val = isDefined(val) ? tryDecodeURIComponent(val) : true;
          if (!hasOwnProperty.call(obj, key)) {
            obj[key] = val;
          } else if (isArray(obj[key])) {
            obj[key].push(val);
          } else {
            obj[key] = [obj[key], val];
          }
        }
      }
    });
    return obj;
  }
  function toKeyValue(obj) {
    var parts = [];
    forEach(obj, function (value, key) {
      if (isArray(value)) {
        forEach(value, function (arrayValue) {
          parts.push(encodeUriQuery(key, true) + (arrayValue === true ? '' : '=' + encodeUriQuery(arrayValue, true)));
        });
      } else {
        parts.push(encodeUriQuery(key, true) + (value === true ? '' : '=' + encodeUriQuery(value, true)));
      }
    });
    return parts.length ? parts.join('&') : '';
  }

  /**
   * We need our custom method because encodeURIComponent is too aggressive and doesn't follow
   * http://www.ietf.org/rfc/rfc3986.txt with regards to the character set (pchar) allowed in path
   * segments:
   *    segment       = *pchar
   *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
   *    pct-encoded   = "%" HEXDIG HEXDIG
   *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
   *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
   *                     / "*" / "+" / "," / ";" / "="
   */
  function encodeUriSegment(val) {
    return encodeUriQuery(val, true).replace(/%26/gi, '&').replace(/%3D/gi, '=').replace(/%2B/gi, '+');
  }

  /**
   * This method is intended for encoding *key* or *value* parts of query component. We need a custom
   * method because encodeURIComponent is too aggressive and encodes stuff that doesn't have to be
   * encoded per http://tools.ietf.org/html/rfc3986:
   *    query         = *( pchar / "/" / "?" )
   *    pchar         = unreserved / pct-encoded / sub-delims / ":" / "@"
   *    unreserved    = ALPHA / DIGIT / "-" / "." / "_" / "~"
   *    pct-encoded   = "%" HEXDIG HEXDIG
   *    sub-delims    = "!" / "$" / "&" / "'" / "(" / ")"
   *                     / "*" / "+" / "," / ";" / "="
   */
  function encodeUriQuery(val, pctEncodeSpaces) {
    return encodeURIComponent(val).replace(/%40/gi, '@').replace(/%3A/gi, ':').replace(/%24/g, '$').replace(/%2C/gi, ',').replace(/%3B/gi, ';').replace(/%20/g, pctEncodeSpaces ? '%20' : '+');
  }
  var ngAttrPrefixes = ['ng-', 'data-ng-', 'ng:', 'x-ng-'];
  function getNgAttribute(element, ngAttr) {
    var attr,
      i,
      ii = ngAttrPrefixes.length;
    for (i = 0; i < ii; ++i) {
      attr = ngAttrPrefixes[i] + ngAttr;
      if (isString(attr = element.getAttribute(attr))) {
        return attr;
      }
    }
    return null;
  }
  function allowAutoBootstrap(document) {
    var script = document.currentScript;
    if (!script) {
      // Support: IE 9-11 only
      // IE does not have `document.currentScript`
      return true;
    }

    // If the `currentScript` property has been clobbered just return false, since this indicates a probable attack
    if (!(script instanceof window.HTMLScriptElement || script instanceof window.SVGScriptElement)) {
      return false;
    }
    var attributes = script.attributes;
    var srcs = [attributes.getNamedItem('src'), attributes.getNamedItem('href'), attributes.getNamedItem('xlink:href')];
    return srcs.every(function (src) {
      if (!src) {
        return true;
      }
      if (!src.value) {
        return false;
      }
      var link = document.createElement('a');
      link.href = src.value;
      if (document.location.origin === link.origin) {
        // Same-origin resources are always allowed, even for banned URL schemes.
        return true;
      }
      // Disabled bootstrapping unless angular.js was loaded from a known scheme used on the web.
      // This is to prevent angular.js bundled with browser extensions from being used to bypass the
      // content security policy in web pages and other browser extensions.
      switch (link.protocol) {
        case 'http:':
        case 'https:':
        case 'ftp:':
        case 'blob:':
        case 'file:':
        case 'data:':
          return true;
        default:
          return false;
      }
    });
  }

  // Cached as it has to run during loading so that document.currentScript is available.
  var isAutoBootstrapAllowed = allowAutoBootstrap(window.document);

  /**
   * @ngdoc directive
   * @name ngApp
   * @module ng
   *
   * @element ANY
   * @param {angular.Module} ngApp an optional application
   *   {@link angular.module module} name to load.
   * @param {boolean=} ngStrictDi if this attribute is present on the app element, the injector will be
   *   created in "strict-di" mode. This means that the application will fail to invoke functions which
   *   do not use explicit function annotation (and are thus unsuitable for minification), as described
   *   in {@link guide/di the Dependency Injection guide}, and useful debugging info will assist in
   *   tracking down the root of these bugs.
   *
   * @description
   *
   * Use this directive to **auto-bootstrap** an AngularJS application. The `ngApp` directive
   * designates the **root element** of the application and is typically placed near the root element
   * of the page - e.g. on the `<body>` or `<html>` tags.
   *
   * There are a few things to keep in mind when using `ngApp`:
   * - only one AngularJS application can be auto-bootstrapped per HTML document. The first `ngApp`
   *   found in the document will be used to define the root element to auto-bootstrap as an
   *   application. To run multiple applications in an HTML document you must manually bootstrap them using
   *   {@link angular.bootstrap} instead.
   * - AngularJS applications cannot be nested within each other.
   * - Do not use a directive that uses {@link ng.$compile#transclusion transclusion} on the same element as `ngApp`.
   *   This includes directives such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and
   *   {@link ngRoute.ngView `ngView`}.
   *   Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
   *   causing animations to stop working and making the injector inaccessible from outside the app.
   *
   * You can specify an **AngularJS module** to be used as the root module for the application.  This
   * module will be loaded into the {@link auto.$injector} when the application is bootstrapped. It
   * should contain the application code needed or have dependencies on other modules that will
   * contain the code. See {@link angular.module} for more information.
   *
   * In the example below if the `ngApp` directive were not placed on the `html` element then the
   * document would not be compiled, the `AppController` would not be instantiated and the `{{ a+b }}`
   * would not be resolved to `3`.
   *
   * @example
   *
   * ### Simple Usage
   *
   * `ngApp` is the easiest, and most common way to bootstrap an application.
   *
   <example module="ngAppDemo" name="ng-app">
     <file name="index.html">
     <div ng-controller="ngAppDemoController">
       I can add: {{a}} + {{b}} =  {{ a+b }}
     </div>
     </file>
     <file name="script.js">
     angular.module('ngAppDemo', []).controller('ngAppDemoController', function($scope) {
       $scope.a = 1;
       $scope.b = 2;
     });
     </file>
   </example>
   *
   * @example
   *
   * ### With `ngStrictDi`
   *
   * Using `ngStrictDi`, you would see something like this:
   *
   <example ng-app-included="true" name="strict-di">
     <file name="index.html">
     <div ng-app="ngAppStrictDemo" ng-strict-di>
         <div ng-controller="GoodController1">
             I can add: {{a}} + {{b}} =  {{ a+b }}
  
             <p>This renders because the controller does not fail to
                instantiate, by using explicit annotation style (see
                script.js for details)
             </p>
         </div>
  
         <div ng-controller="GoodController2">
             Name: <input ng-model="name"><br />
             Hello, {{name}}!
  
             <p>This renders because the controller does not fail to
                instantiate, by using explicit annotation style
                (see script.js for details)
             </p>
         </div>
  
         <div ng-controller="BadController">
             I can add: {{a}} + {{b}} =  {{ a+b }}
  
             <p>The controller could not be instantiated, due to relying
                on automatic function annotations (which are disabled in
                strict mode). As such, the content of this section is not
                interpolated, and there should be an error in your web console.
             </p>
         </div>
     </div>
     </file>
     <file name="script.js">
     angular.module('ngAppStrictDemo', [])
       // BadController will fail to instantiate, due to relying on automatic function annotation,
       // rather than an explicit annotation
       .controller('BadController', function($scope) {
         $scope.a = 1;
         $scope.b = 2;
       })
       // Unlike BadController, GoodController1 and GoodController2 will not fail to be instantiated,
       // due to using explicit annotations using the array style and $inject property, respectively.
       .controller('GoodController1', ['$scope', function($scope) {
         $scope.a = 1;
         $scope.b = 2;
       }])
       .controller('GoodController2', GoodController2);
       function GoodController2($scope) {
         $scope.name = 'World';
       }
       GoodController2.$inject = ['$scope'];
     </file>
     <file name="style.css">
     div[ng-controller] {
         margin-bottom: 1em;
         -webkit-border-radius: 4px;
         border-radius: 4px;
         border: 1px solid;
         padding: .5em;
     }
     div[ng-controller^=Good] {
         border-color: #d6e9c6;
         background-color: #dff0d8;
         color: #3c763d;
     }
     div[ng-controller^=Bad] {
         border-color: #ebccd1;
         background-color: #f2dede;
         color: #a94442;
         margin-bottom: 0;
     }
     </file>
   </example>
   */
  function angularInit(element, bootstrap) {
    var appElement,
      module,
      config = {};

    // The element `element` has priority over any other element.
    forEach(ngAttrPrefixes, function (prefix) {
      var name = prefix + 'app';
      if (!appElement && element.hasAttribute && element.hasAttribute(name)) {
        appElement = element;
        module = element.getAttribute(name);
      }
    });
    forEach(ngAttrPrefixes, function (prefix) {
      var name = prefix + 'app';
      var candidate;
      if (!appElement && (candidate = element.querySelector('[' + name.replace(':', '\\:') + ']'))) {
        appElement = candidate;
        module = candidate.getAttribute(name);
      }
    });
    if (appElement) {
      if (!isAutoBootstrapAllowed) {
        window.console.error('AngularJS: disabling automatic bootstrap. <script> protocol indicates ' + 'an extension, document.location.href does not match.');
        return;
      }
      config.strictDi = getNgAttribute(appElement, 'strict-di') !== null;
      bootstrap(appElement, module ? [module] : [], config);
    }
  }

  /**
   * @ngdoc function
   * @name angular.bootstrap
   * @module ng
   * @description
   * Use this function to manually start up AngularJS application.
   *
   * For more information, see the {@link guide/bootstrap Bootstrap guide}.
   *
   * AngularJS will detect if it has been loaded into the browser more than once and only allow the
   * first loaded script to be bootstrapped and will report a warning to the browser console for
   * each of the subsequent scripts. This prevents strange results in applications, where otherwise
   * multiple instances of AngularJS try to work on the DOM.
   *
   * <div class="alert alert-warning">
   * **Note:** Protractor based end-to-end tests cannot use this function to bootstrap manually.
   * They must use {@link ng.directive:ngApp ngApp}.
   * </div>
   *
   * <div class="alert alert-warning">
   * **Note:** Do not bootstrap the app on an element with a directive that uses {@link ng.$compile#transclusion transclusion},
   * such as {@link ng.ngIf `ngIf`}, {@link ng.ngInclude `ngInclude`} and {@link ngRoute.ngView `ngView`}.
   * Doing this misplaces the app {@link ng.$rootElement `$rootElement`} and the app's {@link auto.$injector injector},
   * causing animations to stop working and making the injector inaccessible from outside the app.
   * </div>
   *
   * ```html
   * <!doctype html>
   * <html>
   * <body>
   * <div ng-controller="WelcomeController">
   *   {{greeting}}
   * </div>
   *
   * <script src="angular.js"></script>
   * <script>
   *   var app = angular.module('demo', [])
   *   .controller('WelcomeController', function($scope) {
   *       $scope.greeting = 'Welcome!';
   *   });
   *   angular.bootstrap(document, ['demo']);
   * </script>
   * </body>
   * </html>
   * ```
   *
   * @param {DOMElement} element DOM element which is the root of AngularJS application.
   * @param {Array<String|Function|Array>=} modules an array of modules to load into the application.
   *     Each item in the array should be the name of a predefined module or a (DI annotated)
   *     function that will be invoked by the injector as a `config` block.
   *     See: {@link angular.module modules}
   * @param {Object=} config an object for defining configuration options for the application. The
   *     following keys are supported:
   *
   * * `strictDi` - disable automatic function annotation for the application. This is meant to
   *   assist in finding bugs which break minified code. Defaults to `false`.
   *
   * @returns {auto.$injector} Returns the newly created injector for this app.
   */
  function bootstrap(element, modules, config) {
    if (!isObject(config)) config = {};
    var defaultConfig = {
      strictDi: false
    };
    config = extend(defaultConfig, config);
    var doBootstrap = function doBootstrap() {
      element = jqLite(element);
      if (element.injector()) {
        var tag = element[0] === window.document ? 'document' : startingTag(element);
        // Encode angle brackets to prevent input from being sanitized to empty string #8683.
        throw ngMinErr('btstrpd', 'App already bootstrapped with this element \'{0}\'', tag.replace(/</, '&lt;').replace(/>/, '&gt;'));
      }
      modules = modules || [];
      modules.unshift(['$provide', function ($provide) {
        $provide.value('$rootElement', element);
      }]);
      if (config.debugInfoEnabled) {
        // Pushing so that this overrides `debugInfoEnabled` setting defined in user's `modules`.
        modules.push(['$compileProvider', function ($compileProvider) {
          $compileProvider.debugInfoEnabled(true);
        }]);
      }
      modules.unshift('ng');
      var injector = createInjector(modules, config.strictDi);
      injector.invoke(['$rootScope', '$rootElement', '$compile', '$injector', function bootstrapApply(scope, element, compile, injector) {
        scope.$apply(function () {
          element.data('$injector', injector);
          compile(element)(scope);
        });
      }]);
      return injector;
    };
    var NG_ENABLE_DEBUG_INFO = /^NG_ENABLE_DEBUG_INFO!/;
    var NG_DEFER_BOOTSTRAP = /^NG_DEFER_BOOTSTRAP!/;
    if (window && NG_ENABLE_DEBUG_INFO.test(window.name)) {
      config.debugInfoEnabled = true;
      window.name = window.name.replace(NG_ENABLE_DEBUG_INFO, '');
    }
    if (window && !NG_DEFER_BOOTSTRAP.test(window.name)) {
      return doBootstrap();
    }
    window.name = window.name.replace(NG_DEFER_BOOTSTRAP, '');
    angular.resumeBootstrap = function (extraModules) {
      forEach(extraModules, function (module) {
        modules.push(module);
      });
      return doBootstrap();
    };
    if (isFunction(angular.resumeDeferredBootstrap)) {
      angular.resumeDeferredBootstrap();
    }
  }

  /**
   * @ngdoc function
   * @name angular.reloadWithDebugInfo
   * @module ng
   * @description
   * Use this function to reload the current application with debug information turned on.
   * This takes precedence over a call to `$compileProvider.debugInfoEnabled(false)`.
   *
   * See {@link ng.$compileProvider#debugInfoEnabled} for more.
   */
  function reloadWithDebugInfo() {
    window.name = 'NG_ENABLE_DEBUG_INFO!' + window.name;
    window.location.reload();
  }

  /**
   * @name angular.getTestability
   * @module ng
   * @description
   * Get the testability service for the instance of AngularJS on the given
   * element.
   * @param {DOMElement} element DOM element which is the root of AngularJS application.
   */
  function getTestability(rootElement) {
    var injector = angular.element(rootElement).injector();
    if (!injector) {
      throw ngMinErr('test', 'no injector found for element argument to getTestability');
    }
    return injector.get('$$testability');
  }
  var SNAKE_CASE_REGEXP = /[A-Z]/g;
  function snake_case(name, separator) {
    separator = separator || '_';
    return name.replace(SNAKE_CASE_REGEXP, function (letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }
  var bindJQueryFired = false;
  function bindJQuery() {
    var originalCleanData;
    if (bindJQueryFired) {
      return;
    }

    // bind to jQuery if present;
    var jqName = _jq();
    jQuery = isUndefined(jqName) ? window.jQuery :
    // use jQuery (if present)
    !jqName ? undefined :
    // use jqLite
    window[jqName]; // use jQuery specified by `ngJq`

    // Use jQuery if it exists with proper functionality, otherwise default to us.
    // AngularJS 1.2+ requires jQuery 1.7+ for on()/off() support.
    // AngularJS 1.3+ technically requires at least jQuery 2.1+ but it may work with older
    // versions. It will not work for sure with jQuery <1.7, though.
    if (jQuery && jQuery.fn.on) {
      jqLite = jQuery;
      extend(jQuery.fn, {
        scope: JQLitePrototype.scope,
        isolateScope: JQLitePrototype.isolateScope,
        controller: /** @type {?} */JQLitePrototype.controller,
        injector: JQLitePrototype.injector,
        inheritedData: JQLitePrototype.inheritedData
      });
    } else {
      jqLite = JQLite;
    }

    // All nodes removed from the DOM via various jqLite/jQuery APIs like .remove()
    // are passed through jqLite/jQuery.cleanData. Monkey-patch this method to fire
    // the $destroy event on all removed nodes.
    originalCleanData = jqLite.cleanData;
    jqLite.cleanData = function (elems) {
      var events;
      for (var i = 0, elem; (elem = elems[i]) != null; i++) {
        events = (jqLite._data(elem) || {}).events;
        if (events && events.$destroy) {
          jqLite(elem).triggerHandler('$destroy');
        }
      }
      originalCleanData(elems);
    };
    angular.element = jqLite;

    // Prevent double-proxying.
    bindJQueryFired = true;
  }

  /**
   * @ngdoc function
   * @name angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement
   * @module ng
   * @kind function
   *
   * @description
   * Restores the pre-1.8 behavior of jqLite that turns XHTML-like strings like
   * `<div /><span />` to `<div></div><span></span>` instead of `<div><span></span></div>`.
   * The new behavior is a security fix. Thus, if you need to call this function, please try to adjust
   * your code for this change and remove your use of this function as soon as possible.
  
   * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
   * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
   * about the workarounds.
   */
  function UNSAFE_restoreLegacyJqLiteXHTMLReplacement() {
    JQLite.legacyXHTMLReplacement = true;
  }

  /**
   * throw error if the argument is falsy.
   */
  function assertArg(arg, name, reason) {
    if (!arg) {
      throw ngMinErr('areq', 'Argument \'{0}\' is {1}', name || '?', reason || 'required');
    }
    return arg;
  }
  function assertArgFn(arg, name, acceptArrayAnnotation) {
    if (acceptArrayAnnotation && isArray(arg)) {
      arg = arg[arg.length - 1];
    }
    assertArg(isFunction(arg), name, 'not a function, got ' + (arg && _typeof(arg) === 'object' ? arg.constructor.name || 'Object' : _typeof(arg)));
    return arg;
  }

  /**
   * throw error if the name given is hasOwnProperty
   * @param  {String} name    the name to test
   * @param  {String} context the context in which the name is used, such as module or directive
   */
  function assertNotHasOwnProperty(name, context) {
    if (name === 'hasOwnProperty') {
      throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
    }
  }

  /**
   * Return the value accessible from the object by path. Any undefined traversals are ignored
   * @param {Object} obj starting object
   * @param {String} path path to traverse
   * @param {boolean} [bindFnToScope=true]
   * @returns {Object} value as accessible by path
   */
  //TODO(misko): this function needs to be removed
  function getter(obj, path, bindFnToScope) {
    if (!path) return obj;
    var keys = path.split('.');
    var key;
    var lastInstance = obj;
    var len = keys.length;
    for (var i = 0; i < len; i++) {
      key = keys[i];
      if (obj) {
        obj = (lastInstance = obj)[key];
      }
    }
    if (!bindFnToScope && isFunction(obj)) {
      return bind(lastInstance, obj);
    }
    return obj;
  }

  /**
   * Return the DOM siblings between the first and last node in the given array.
   * @param {Array} array like object
   * @returns {Array} the inputted object or a jqLite collection containing the nodes
   */
  function getBlockNodes(nodes) {
    // TODO(perf): update `nodes` instead of creating a new object?
    var node = nodes[0];
    var endNode = nodes[nodes.length - 1];
    var blockNodes;
    for (var i = 1; node !== endNode && (node = node.nextSibling); i++) {
      if (blockNodes || nodes[i] !== node) {
        if (!blockNodes) {
          blockNodes = jqLite(slice.call(nodes, 0, i));
        }
        blockNodes.push(node);
      }
    }
    return blockNodes || nodes;
  }

  /**
   * Creates a new object without a prototype. This object is useful for lookup without having to
   * guard against prototypically inherited properties via hasOwnProperty.
   *
   * Related micro-benchmarks:
   * - http://jsperf.com/object-create2
   * - http://jsperf.com/proto-map-lookup/2
   * - http://jsperf.com/for-in-vs-object-keys2
   *
   * @returns {Object}
   */
  function createMap() {
    return Object.create(null);
  }
  function stringify(value) {
    if (value == null) {
      // null || undefined
      return '';
    }
    switch (_typeof(value)) {
      case 'string':
        break;
      case 'number':
        value = '' + value;
        break;
      default:
        if (hasCustomToString(value) && !isArray(value) && !isDate(value)) {
          value = value.toString();
        } else {
          value = toJson(value);
        }
    }
    return value;
  }
  var NODE_TYPE_ELEMENT = 1;
  var NODE_TYPE_ATTRIBUTE = 2;
  var NODE_TYPE_TEXT = 3;
  var NODE_TYPE_COMMENT = 8;
  var NODE_TYPE_DOCUMENT = 9;
  var NODE_TYPE_DOCUMENT_FRAGMENT = 11;

  /**
   * @ngdoc type
   * @name angular.Module
   * @module ng
   * @description
   *
   * Interface for configuring AngularJS {@link angular.module modules}.
   */

  function setupModuleLoader(window) {
    var $injectorMinErr = minErr('$injector');
    var ngMinErr = minErr('ng');
    function ensure(obj, name, factory) {
      return obj[name] || (obj[name] = factory());
    }
    var angular = ensure(window, 'angular', Object);

    // We need to expose `angular.$$minErr` to modules such as `ngResource` that reference it during bootstrap
    angular.$$minErr = angular.$$minErr || minErr;
    return ensure(angular, 'module', function () {
      /** @type {Object.<string, angular.Module>} */
      var modules = {};

      /**
       * @ngdoc function
       * @name angular.module
       * @module ng
       * @description
       *
       * The `angular.module` is a global place for creating, registering and retrieving AngularJS
       * modules.
       * All modules (AngularJS core or 3rd party) that should be available to an application must be
       * registered using this mechanism.
       *
       * Passing one argument retrieves an existing {@link angular.Module},
       * whereas passing more than one argument creates a new {@link angular.Module}
       *
       *
       * # Module
       *
       * A module is a collection of services, directives, controllers, filters, and configuration information.
       * `angular.module` is used to configure the {@link auto.$injector $injector}.
       *
       * ```js
       * // Create a new module
       * var myModule = angular.module('myModule', []);
       *
       * // register a new service
       * myModule.value('appName', 'MyCoolApp');
       *
       * // configure existing services inside initialization blocks.
       * myModule.config(['$locationProvider', function($locationProvider) {
       *   // Configure existing providers
       *   $locationProvider.hashPrefix('!');
       * }]);
       * ```
       *
       * Then you can create an injector and load your modules like this:
       *
       * ```js
       * var injector = angular.injector(['ng', 'myModule'])
       * ```
       *
       * However it's more likely that you'll just use
       * {@link ng.directive:ngApp ngApp} or
       * {@link angular.bootstrap} to simplify this process for you.
       *
       * @param {!string} name The name of the module to create or retrieve.
       * @param {!Array.<string>=} requires If specified then new module is being created. If
       *        unspecified then the module is being retrieved for further configuration.
       * @param {Function=} configFn Optional configuration function for the module. Same as
       *        {@link angular.Module#config Module#config()}.
       * @returns {angular.Module} new module with the {@link angular.Module} api.
       */
      return function module(name, requires, configFn) {
        var _info = {};
        var assertNotHasOwnProperty = function assertNotHasOwnProperty(name, context) {
          if (name === 'hasOwnProperty') {
            throw ngMinErr('badname', 'hasOwnProperty is not a valid {0} name', context);
          }
        };
        assertNotHasOwnProperty(name, 'module');
        if (requires && modules.hasOwnProperty(name)) {
          modules[name] = null;
        }
        return ensure(modules, name, function () {
          if (!requires) {
            throw $injectorMinErr('nomod', 'Module \'{0}\' is not available! You either misspelled ' + 'the module name or forgot to load it. If registering a module ensure that you ' + 'specify the dependencies as the second argument.', name);
          }

          /** @type {!Array.<Array.<*>>} */
          var invokeQueue = [];

          /** @type {!Array.<Function>} */
          var configBlocks = [];

          /** @type {!Array.<Function>} */
          var runBlocks = [];
          var config = invokeLater('$injector', 'invoke', 'push', configBlocks);

          /** @type {angular.Module} */
          var moduleInstance = {
            // Private state
            _invokeQueue: invokeQueue,
            _configBlocks: configBlocks,
            _runBlocks: runBlocks,
            /**
             * @ngdoc method
             * @name angular.Module#info
             * @module ng
             *
             * @param {Object=} info Information about the module
             * @returns {Object|Module} The current info object for this module if called as a getter,
             *                          or `this` if called as a setter.
             *
             * @description
             * Read and write custom information about this module.
             * For example you could put the version of the module in here.
             *
             * ```js
             * angular.module('myModule', []).info({ version: '1.0.0' });
             * ```
             *
             * The version could then be read back out by accessing the module elsewhere:
             *
             * ```
             * var version = angular.module('myModule').info().version;
             * ```
             *
             * You can also retrieve this information during runtime via the
             * {@link $injector#modules `$injector.modules`} property:
             *
             * ```js
             * var version = $injector.modules['myModule'].info().version;
             * ```
             */
            info: function info(value) {
              if (isDefined(value)) {
                if (!isObject(value)) throw ngMinErr('aobj', 'Argument \'{0}\' must be an object', 'value');
                _info = value;
                return this;
              }
              return _info;
            },
            /**
             * @ngdoc property
             * @name angular.Module#requires
             * @module ng
             *
             * @description
             * Holds the list of modules which the injector will load before the current module is
             * loaded.
             */
            requires: requires,
            /**
             * @ngdoc property
             * @name angular.Module#name
             * @module ng
             *
             * @description
             * Name of the module.
             */
            name: name,
            /**
             * @ngdoc method
             * @name angular.Module#provider
             * @module ng
             * @param {string} name service name
             * @param {Function} providerType Construction function for creating new instance of the
             *                                service.
             * @description
             * See {@link auto.$provide#provider $provide.provider()}.
             */
            provider: invokeLaterAndSetModuleName('$provide', 'provider'),
            /**
             * @ngdoc method
             * @name angular.Module#factory
             * @module ng
             * @param {string} name service name
             * @param {Function} providerFunction Function for creating new instance of the service.
             * @description
             * See {@link auto.$provide#factory $provide.factory()}.
             */
            factory: invokeLaterAndSetModuleName('$provide', 'factory'),
            /**
             * @ngdoc method
             * @name angular.Module#service
             * @module ng
             * @param {string} name service name
             * @param {Function} constructor A constructor function that will be instantiated.
             * @description
             * See {@link auto.$provide#service $provide.service()}.
             */
            service: invokeLaterAndSetModuleName('$provide', 'service'),
            /**
             * @ngdoc method
             * @name angular.Module#value
             * @module ng
             * @param {string} name service name
             * @param {*} object Service instance object.
             * @description
             * See {@link auto.$provide#value $provide.value()}.
             */
            value: invokeLater('$provide', 'value'),
            /**
             * @ngdoc method
             * @name angular.Module#constant
             * @module ng
             * @param {string} name constant name
             * @param {*} object Constant value.
             * @description
             * Because the constants are fixed, they get applied before other provide methods.
             * See {@link auto.$provide#constant $provide.constant()}.
             */
            constant: invokeLater('$provide', 'constant', 'unshift'),
            /**
            * @ngdoc method
            * @name angular.Module#decorator
            * @module ng
            * @param {string} name The name of the service to decorate.
            * @param {Function} decorFn This function will be invoked when the service needs to be
            *                           instantiated and should return the decorated service instance.
            * @description
            * See {@link auto.$provide#decorator $provide.decorator()}.
            */
            decorator: invokeLaterAndSetModuleName('$provide', 'decorator', configBlocks),
            /**
             * @ngdoc method
             * @name angular.Module#animation
             * @module ng
             * @param {string} name animation name
             * @param {Function} animationFactory Factory function for creating new instance of an
             *                                    animation.
             * @description
             *
             * **NOTE**: animations take effect only if the **ngAnimate** module is loaded.
             *
             *
             * Defines an animation hook that can be later used with
             * {@link $animate $animate} service and directives that use this service.
             *
             * ```js
             * module.animation('.animation-name', function($inject1, $inject2) {
             *   return {
             *     eventName : function(element, done) {
             *       //code to run the animation
             *       //once complete, then run done()
             *       return function cancellationFunction(element) {
             *         //code to cancel the animation
             *       }
             *     }
             *   }
             * })
             * ```
             *
             * See {@link ng.$animateProvider#register $animateProvider.register()} and
             * {@link ngAnimate ngAnimate module} for more information.
             */
            animation: invokeLaterAndSetModuleName('$animateProvider', 'register'),
            /**
             * @ngdoc method
             * @name angular.Module#filter
             * @module ng
             * @param {string} name Filter name - this must be a valid AngularJS expression identifier
             * @param {Function} filterFactory Factory function for creating new instance of filter.
             * @description
             * See {@link ng.$filterProvider#register $filterProvider.register()}.
             *
             * <div class="alert alert-warning">
             * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
             * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
             * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
             * (`myapp_subsection_filterx`).
             * </div>
             */
            filter: invokeLaterAndSetModuleName('$filterProvider', 'register'),
            /**
             * @ngdoc method
             * @name angular.Module#controller
             * @module ng
             * @param {string|Object} name Controller name, or an object map of controllers where the
             *    keys are the names and the values are the constructors.
             * @param {Function} constructor Controller constructor function.
             * @description
             * See {@link ng.$controllerProvider#register $controllerProvider.register()}.
             */
            controller: invokeLaterAndSetModuleName('$controllerProvider', 'register'),
            /**
             * @ngdoc method
             * @name angular.Module#directive
             * @module ng
             * @param {string|Object} name Directive name, or an object map of directives where the
             *    keys are the names and the values are the factories.
             * @param {Function} directiveFactory Factory function for creating new instance of
             * directives.
             * @description
             * See {@link ng.$compileProvider#directive $compileProvider.directive()}.
             */
            directive: invokeLaterAndSetModuleName('$compileProvider', 'directive'),
            /**
             * @ngdoc method
             * @name angular.Module#component
             * @module ng
             * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
             *    or an object map of components where the keys are the names and the values are the component definition objects.
             * @param {Object} options Component definition object (a simplified
             *    {@link ng.$compile#directive-definition-object directive definition object})
             *
             * @description
             * See {@link ng.$compileProvider#component $compileProvider.component()}.
             */
            component: invokeLaterAndSetModuleName('$compileProvider', 'component'),
            /**
             * @ngdoc method
             * @name angular.Module#config
             * @module ng
             * @param {Function} configFn Execute this function on module load. Useful for service
             *    configuration.
             * @description
             * Use this method to configure services by injecting their
             * {@link angular.Module#provider `providers`}, e.g. for adding routes to the
             * {@link ngRoute.$routeProvider $routeProvider}.
             *
             * Note that you can only inject {@link angular.Module#provider `providers`} and
             * {@link angular.Module#constant `constants`} into this function.
             *
             * For more about how to configure services, see
             * {@link providers#provider-recipe Provider Recipe}.
             */
            config: config,
            /**
             * @ngdoc method
             * @name angular.Module#run
             * @module ng
             * @param {Function} initializationFn Execute this function after injector creation.
             *    Useful for application initialization.
             * @description
             * Use this method to register work which should be performed when the injector is done
             * loading all modules.
             */
            run: function run(block) {
              runBlocks.push(block);
              return this;
            }
          };
          if (configFn) {
            config(configFn);
          }
          return moduleInstance;

          /**
           * @param {string} provider
           * @param {string} method
           * @param {String=} insertMethod
           * @returns {angular.Module}
           */
          function invokeLater(provider, method, insertMethod, queue) {
            if (!queue) queue = invokeQueue;
            return function () {
              queue[insertMethod || 'push']([provider, method, arguments]);
              return moduleInstance;
            };
          }

          /**
           * @param {string} provider
           * @param {string} method
           * @returns {angular.Module}
           */
          function invokeLaterAndSetModuleName(provider, method, queue) {
            if (!queue) queue = invokeQueue;
            return function (recipeName, factoryFunction) {
              if (factoryFunction && isFunction(factoryFunction)) factoryFunction.$$moduleName = name;
              queue.push([provider, method, arguments]);
              return moduleInstance;
            };
          }
        });
      };
    });
  }

  /* global shallowCopy: true */

  /**
   * Creates a shallow copy of an object, an array or a primitive.
   *
   * Assumes that there are no proto properties for objects.
   */
  function shallowCopy(src, dst) {
    if (isArray(src)) {
      dst = dst || [];
      for (var i = 0, ii = src.length; i < ii; i++) {
        dst[i] = src[i];
      }
    } else if (isObject(src)) {
      dst = dst || {};
      for (var key in src) {
        if (!(key.charAt(0) === '$' && key.charAt(1) === '$')) {
          dst[key] = src[key];
        }
      }
    }
    return dst || src;
  }

  /* exported toDebugString */

  function serializeObject(obj, maxDepth) {
    var seen = [];

    // There is no direct way to stringify object until reaching a specific depth
    // and a very deep object can cause a performance issue, so we copy the object
    // based on this specific depth and then stringify it.
    if (isValidObjectMaxDepth(maxDepth)) {
      // This file is also included in `angular-loader`, so `copy()` might not always be available in
      // the closure. Therefore, it is lazily retrieved as `angular.copy()` when needed.
      obj = angular.copy(obj, null, maxDepth);
    }
    return JSON.stringify(obj, function (key, val) {
      val = toJsonReplacer(key, val);
      if (isObject(val)) {
        if (seen.indexOf(val) >= 0) return '...';
        seen.push(val);
      }
      return val;
    });
  }
  function toDebugString(obj, maxDepth) {
    if (typeof obj === 'function') {
      return obj.toString().replace(/ \{[\s\S]*$/, '');
    } else if (isUndefined(obj)) {
      return 'undefined';
    } else if (typeof obj !== 'string') {
      return serializeObject(obj, maxDepth);
    }
    return obj;
  }

  /* global angularModule: true,
    version: true,
  
    $CompileProvider,
  
    htmlAnchorDirective,
    inputDirective,
    hiddenInputBrowserCacheDirective,
    formDirective,
    scriptDirective,
    selectDirective,
    optionDirective,
    ngBindDirective,
    ngBindHtmlDirective,
    ngBindTemplateDirective,
    ngClassDirective,
    ngClassEvenDirective,
    ngClassOddDirective,
    ngCloakDirective,
    ngControllerDirective,
    ngFormDirective,
    ngHideDirective,
    ngIfDirective,
    ngIncludeDirective,
    ngIncludeFillContentDirective,
    ngInitDirective,
    ngNonBindableDirective,
    ngPluralizeDirective,
    ngRefDirective,
    ngRepeatDirective,
    ngShowDirective,
    ngStyleDirective,
    ngSwitchDirective,
    ngSwitchWhenDirective,
    ngSwitchDefaultDirective,
    ngOptionsDirective,
    ngTranscludeDirective,
    ngModelDirective,
    ngListDirective,
    ngChangeDirective,
    patternDirective,
    patternDirective,
    requiredDirective,
    requiredDirective,
    minlengthDirective,
    minlengthDirective,
    maxlengthDirective,
    maxlengthDirective,
    ngValueDirective,
    ngModelOptionsDirective,
    ngAttributeAliasDirectives,
    ngEventDirectives,
  
    $AnchorScrollProvider,
    $AnimateProvider,
    $CoreAnimateCssProvider,
    $$CoreAnimateJsProvider,
    $$CoreAnimateQueueProvider,
    $$AnimateRunnerFactoryProvider,
    $$AnimateAsyncRunFactoryProvider,
    $BrowserProvider,
    $CacheFactoryProvider,
    $ControllerProvider,
    $DateProvider,
    $DocumentProvider,
    $$IsDocumentHiddenProvider,
    $ExceptionHandlerProvider,
    $FilterProvider,
    $$ForceReflowProvider,
    $InterpolateProvider,
    $$IntervalFactoryProvider,
    $IntervalProvider,
    $HttpProvider,
    $HttpParamSerializerProvider,
    $HttpParamSerializerJQLikeProvider,
    $HttpBackendProvider,
    $xhrFactoryProvider,
    $jsonpCallbacksProvider,
    $LocationProvider,
    $LogProvider,
    $$MapProvider,
    $ParseProvider,
    $RootScopeProvider,
    $QProvider,
    $$QProvider,
    $$SanitizeUriProvider,
    $SceProvider,
    $SceDelegateProvider,
    $SnifferProvider,
    $$TaskTrackerFactoryProvider,
    $TemplateCacheProvider,
    $TemplateRequestProvider,
    $$TestabilityProvider,
    $TimeoutProvider,
    $$RAFProvider,
    $WindowProvider,
    $$jqLiteProvider,
    $$CookieReaderProvider
  */

  /**
   * @ngdoc object
   * @name angular.version
   * @module ng
   * @description
   * An object that contains information about the current AngularJS version.
   *
   * This object has the following properties:
   *
   * - `full` – `{string}` – Full version string, such as "0.9.18".
   * - `major` – `{number}` – Major version number, such as "0".
   * - `minor` – `{number}` – Minor version number, such as "9".
   * - `dot` – `{number}` – Dot version number, such as "18".
   * - `codeName` – `{string}` – Code name of the release, such as "jiggling-armfat".
   */
  var version = {
    // These placeholder strings will be replaced by grunt's `build` task.
    // They need to be double- or single-quoted.
    full: '1.8.2',
    major: 1,
    minor: 8,
    dot: 2,
    codeName: 'meteoric-mining'
  };
  function publishExternalAPI(angular) {
    extend(angular, {
      'errorHandlingConfig': errorHandlingConfig,
      'bootstrap': bootstrap,
      'copy': copy,
      'extend': extend,
      'merge': merge,
      'equals': equals,
      'element': jqLite,
      'forEach': forEach,
      'injector': createInjector,
      'noop': noop,
      'bind': bind,
      'toJson': toJson,
      'fromJson': fromJson,
      'identity': identity,
      'isUndefined': isUndefined,
      'isDefined': isDefined,
      'isString': isString,
      'isFunction': isFunction,
      'isObject': isObject,
      'isNumber': isNumber,
      'isElement': isElement,
      'isArray': isArray,
      'version': version,
      'isDate': isDate,
      'callbacks': {
        $$counter: 0
      },
      'getTestability': getTestability,
      'reloadWithDebugInfo': reloadWithDebugInfo,
      'UNSAFE_restoreLegacyJqLiteXHTMLReplacement': UNSAFE_restoreLegacyJqLiteXHTMLReplacement,
      '$$minErr': minErr,
      '$$csp': _csp,
      '$$encodeUriSegment': encodeUriSegment,
      '$$encodeUriQuery': encodeUriQuery,
      '$$lowercase': lowercase,
      '$$stringify': stringify,
      '$$uppercase': uppercase
    });
    angularModule = setupModuleLoader(window);
    angularModule('ng', ['ngLocale'], ['$provide', function ngModule($provide) {
      // $$sanitizeUriProvider needs to be before $compileProvider as it is used by it.
      $provide.provider({
        $$sanitizeUri: $$SanitizeUriProvider
      });
      $provide.provider('$compile', $CompileProvider).directive({
        a: htmlAnchorDirective,
        input: inputDirective,
        textarea: inputDirective,
        form: formDirective,
        script: scriptDirective,
        select: selectDirective,
        option: optionDirective,
        ngBind: ngBindDirective,
        ngBindHtml: ngBindHtmlDirective,
        ngBindTemplate: ngBindTemplateDirective,
        ngClass: ngClassDirective,
        ngClassEven: ngClassEvenDirective,
        ngClassOdd: ngClassOddDirective,
        ngCloak: ngCloakDirective,
        ngController: ngControllerDirective,
        ngForm: ngFormDirective,
        ngHide: ngHideDirective,
        ngIf: ngIfDirective,
        ngInclude: ngIncludeDirective,
        ngInit: ngInitDirective,
        ngNonBindable: ngNonBindableDirective,
        ngPluralize: ngPluralizeDirective,
        ngRef: ngRefDirective,
        ngRepeat: ngRepeatDirective,
        ngShow: ngShowDirective,
        ngStyle: ngStyleDirective,
        ngSwitch: ngSwitchDirective,
        ngSwitchWhen: ngSwitchWhenDirective,
        ngSwitchDefault: ngSwitchDefaultDirective,
        ngOptions: ngOptionsDirective,
        ngTransclude: ngTranscludeDirective,
        ngModel: ngModelDirective,
        ngList: ngListDirective,
        ngChange: ngChangeDirective,
        pattern: patternDirective,
        ngPattern: patternDirective,
        required: requiredDirective,
        ngRequired: requiredDirective,
        minlength: minlengthDirective,
        ngMinlength: minlengthDirective,
        maxlength: maxlengthDirective,
        ngMaxlength: maxlengthDirective,
        ngValue: ngValueDirective,
        ngModelOptions: ngModelOptionsDirective
      }).directive({
        ngInclude: ngIncludeFillContentDirective,
        input: hiddenInputBrowserCacheDirective
      }).directive(ngAttributeAliasDirectives).directive(ngEventDirectives);
      $provide.provider({
        $anchorScroll: $AnchorScrollProvider,
        $animate: $AnimateProvider,
        $animateCss: $CoreAnimateCssProvider,
        $$animateJs: $$CoreAnimateJsProvider,
        $$animateQueue: $$CoreAnimateQueueProvider,
        $$AnimateRunner: $$AnimateRunnerFactoryProvider,
        $$animateAsyncRun: $$AnimateAsyncRunFactoryProvider,
        $browser: $BrowserProvider,
        $cacheFactory: $CacheFactoryProvider,
        $controller: $ControllerProvider,
        $document: $DocumentProvider,
        $$isDocumentHidden: $$IsDocumentHiddenProvider,
        $exceptionHandler: $ExceptionHandlerProvider,
        $filter: $FilterProvider,
        $$forceReflow: $$ForceReflowProvider,
        $interpolate: $InterpolateProvider,
        $interval: $IntervalProvider,
        $$intervalFactory: $$IntervalFactoryProvider,
        $http: $HttpProvider,
        $httpParamSerializer: $HttpParamSerializerProvider,
        $httpParamSerializerJQLike: $HttpParamSerializerJQLikeProvider,
        $httpBackend: $HttpBackendProvider,
        $xhrFactory: $xhrFactoryProvider,
        $jsonpCallbacks: $jsonpCallbacksProvider,
        $location: $LocationProvider,
        $log: $LogProvider,
        $parse: $ParseProvider,
        $rootScope: $RootScopeProvider,
        $q: $QProvider,
        $$q: $$QProvider,
        $sce: $SceProvider,
        $sceDelegate: $SceDelegateProvider,
        $sniffer: $SnifferProvider,
        $$taskTrackerFactory: $$TaskTrackerFactoryProvider,
        $templateCache: $TemplateCacheProvider,
        $templateRequest: $TemplateRequestProvider,
        $$testability: $$TestabilityProvider,
        $timeout: $TimeoutProvider,
        $window: $WindowProvider,
        $$rAF: $$RAFProvider,
        $$jqLite: $$jqLiteProvider,
        $$Map: $$MapProvider,
        $$cookieReader: $$CookieReaderProvider
      });
    }]).info({
      angularVersion: '1.8.2'
    });
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   *     Any commits to this file should be reviewed with security in mind.  *
   *   Changes to this file can potentially create security vulnerabilities. *
   *          An approval from 2 Core members with history of modifying      *
   *                         this file is required.                          *
   *                                                                         *
   *  Does the change somehow allow for arbitrary javascript to be executed? *
   *    Or allows for someone to change the prototype of built-in objects?   *
   *     Or gives undesired access to variables likes document or window?    *
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  /* global
    JQLitePrototype: true,
    BOOLEAN_ATTR: true,
    ALIASED_ATTR: true
  */

  //////////////////////////////////
  //JQLite
  //////////////////////////////////

  /**
   * @ngdoc function
   * @name angular.element
   * @module ng
   * @kind function
   *
   * @description
   * Wraps a raw DOM element or HTML string as a [jQuery](http://jquery.com) element.
   *
   * If jQuery is available, `angular.element` is an alias for the
   * [jQuery](http://api.jquery.com/jQuery/) function. If jQuery is not available, `angular.element`
   * delegates to AngularJS's built-in subset of jQuery, called "jQuery lite" or **jqLite**.
   *
   * jqLite is a tiny, API-compatible subset of jQuery that allows
   * AngularJS to manipulate the DOM in a cross-browser compatible way. jqLite implements only the most
   * commonly needed functionality with the goal of having a very small footprint.
   *
   * To use `jQuery`, simply ensure it is loaded before the `angular.js` file. You can also use the
   * {@link ngJq `ngJq`} directive to specify that jqlite should be used over jQuery, or to use a
   * specific version of jQuery if multiple versions exist on the page.
   *
   * <div class="alert alert-info">**Note:** All element references in AngularJS are always wrapped with jQuery or
   * jqLite (such as the element argument in a directive's compile / link function). They are never raw DOM references.</div>
   *
   * <div class="alert alert-warning">**Note:** Keep in mind that this function will not find elements
   * by tag name / CSS selector. For lookups by tag name, try instead `angular.element(document).find(...)`
   * or `$document.find()`, or use the standard DOM APIs, e.g. `document.querySelectorAll()`.</div>
   *
   * ## AngularJS's jqLite
   * jqLite provides only the following jQuery methods:
   *
   * - [`addClass()`](http://api.jquery.com/addClass/) - Does not support a function as first argument
   * - [`after()`](http://api.jquery.com/after/)
   * - [`append()`](http://api.jquery.com/append/) - Contrary to jQuery, this doesn't clone elements
   *   so will not work correctly when invoked on a jqLite object containing more than one DOM node
   * - [`attr()`](http://api.jquery.com/attr/) - Does not support functions as parameters
   * - [`bind()`](http://api.jquery.com/bind/) (_deprecated_, use [`on()`](http://api.jquery.com/on/)) - Does not support namespaces, selectors or eventData
   * - [`children()`](http://api.jquery.com/children/) - Does not support selectors
   * - [`clone()`](http://api.jquery.com/clone/)
   * - [`contents()`](http://api.jquery.com/contents/)
   * - [`css()`](http://api.jquery.com/css/) - Only retrieves inline-styles, does not call `getComputedStyle()`.
   *   As a setter, does not convert numbers to strings or append 'px', and also does not have automatic property prefixing.
   * - [`data()`](http://api.jquery.com/data/)
   * - [`detach()`](http://api.jquery.com/detach/)
   * - [`empty()`](http://api.jquery.com/empty/)
   * - [`eq()`](http://api.jquery.com/eq/)
   * - [`find()`](http://api.jquery.com/find/) - Limited to lookups by tag name
   * - [`hasClass()`](http://api.jquery.com/hasClass/)
   * - [`html()`](http://api.jquery.com/html/)
   * - [`next()`](http://api.jquery.com/next/) - Does not support selectors
   * - [`on()`](http://api.jquery.com/on/) - Does not support namespaces, selectors or eventData
   * - [`off()`](http://api.jquery.com/off/) - Does not support namespaces, selectors or event object as parameter
   * - [`one()`](http://api.jquery.com/one/) - Does not support namespaces or selectors
   * - [`parent()`](http://api.jquery.com/parent/) - Does not support selectors
   * - [`prepend()`](http://api.jquery.com/prepend/)
   * - [`prop()`](http://api.jquery.com/prop/)
   * - [`ready()`](http://api.jquery.com/ready/) (_deprecated_, use `angular.element(callback)` instead of `angular.element(document).ready(callback)`)
   * - [`remove()`](http://api.jquery.com/remove/)
   * - [`removeAttr()`](http://api.jquery.com/removeAttr/) - Does not support multiple attributes
   * - [`removeClass()`](http://api.jquery.com/removeClass/) - Does not support a function as first argument
   * - [`removeData()`](http://api.jquery.com/removeData/)
   * - [`replaceWith()`](http://api.jquery.com/replaceWith/)
   * - [`text()`](http://api.jquery.com/text/)
   * - [`toggleClass()`](http://api.jquery.com/toggleClass/) - Does not support a function as first argument
   * - [`triggerHandler()`](http://api.jquery.com/triggerHandler/) - Passes a dummy event object to handlers
   * - [`unbind()`](http://api.jquery.com/unbind/) (_deprecated_, use [`off()`](http://api.jquery.com/off/)) - Does not support namespaces or event object as parameter
   * - [`val()`](http://api.jquery.com/val/)
   * - [`wrap()`](http://api.jquery.com/wrap/)
   *
   * jqLite also provides a method restoring pre-1.8 insecure treatment of XHTML-like tags.
   * This legacy behavior turns input like `<div /><span />` to `<div></div><span></span>`
   * instead of `<div><span></span></div>` like version 1.8 & newer do. To restore it, invoke:
   * ```js
   * angular.UNSAFE_restoreLegacyJqLiteXHTMLReplacement();
   * ```
   * Note that this only patches jqLite. If you use jQuery 3.5.0 or newer, please read the
   * [jQuery 3.5 upgrade guide](https://jquery.com/upgrade-guide/3.5/) for more details
   * about the workarounds.
   *
   * ## jQuery/jqLite Extras
   * AngularJS also provides the following additional methods and events to both jQuery and jqLite:
   *
   * ### Events
   * - `$destroy` - AngularJS intercepts all jqLite/jQuery's DOM destruction apis and fires this event
   *    on all DOM nodes being removed.  This can be used to clean up any 3rd party bindings to the DOM
   *    element before it is removed.
   *
   * ### Methods
   * - `controller(name)` - retrieves the controller of the current element or its parent. By default
   *   retrieves controller associated with the `ngController` directive. If `name` is provided as
   *   camelCase directive name, then the controller for this directive will be retrieved (e.g.
   *   `'ngModel'`).
   * - `injector()` - retrieves the injector of the current element or its parent.
   * - `scope()` - retrieves the {@link ng.$rootScope.Scope scope} of the current
   *   element or its parent. Requires {@link guide/production#disabling-debug-data Debug Data} to
   *   be enabled.
   * - `isolateScope()` - retrieves an isolate {@link ng.$rootScope.Scope scope} if one is attached directly to the
   *   current element. This getter should be used only on elements that contain a directive which starts a new isolate
   *   scope. Calling `scope()` on this element always returns the original non-isolate scope.
   *   Requires {@link guide/production#disabling-debug-data Debug Data} to be enabled.
   * - `inheritedData()` - same as `data()`, but walks up the DOM until a value is found or the top
   *   parent element is reached.
   *
   * @knownIssue You cannot spy on `angular.element` if you are using Jasmine version 1.x. See
   * https://github.com/angular/angular.js/issues/14251 for more information.
   *
   * @param {string|DOMElement} element HTML string or DOMElement to be wrapped into jQuery.
   * @returns {Object} jQuery object.
   */

  JQLite.expando = 'ng339';
  var jqCache = JQLite.cache = {},
    jqId = 1;

  /*
   * !!! This is an undocumented "private" function !!!
   */
  JQLite._data = function (node) {
    //jQuery always returns an object on cache miss
    return this.cache[node[this.expando]] || {};
  };
  function jqNextId() {
    return ++jqId;
  }
  var DASH_LOWERCASE_REGEXP = /-([a-z])/g;
  var MS_HACK_REGEXP = /^-ms-/;
  var MOUSE_EVENT_MAP = {
    mouseleave: 'mouseout',
    mouseenter: 'mouseover'
  };
  var jqLiteMinErr = minErr('jqLite');

  /**
   * Converts kebab-case to camelCase.
   * There is also a special case for the ms prefix starting with a lowercase letter.
   * @param name Name to normalize
   */
  function cssKebabToCamel(name) {
    return kebabToCamel(name.replace(MS_HACK_REGEXP, 'ms-'));
  }
  function fnCamelCaseReplace(all, letter) {
    return letter.toUpperCase();
  }

  /**
   * Converts kebab-case to camelCase.
   * @param name Name to normalize
   */
  function kebabToCamel(name) {
    return name.replace(DASH_LOWERCASE_REGEXP, fnCamelCaseReplace);
  }
  var SINGLE_TAG_REGEXP = /^<([\w-]+)\s*\/?>(?:<\/\1>|)$/;
  var HTML_REGEXP = /<|&#?\w+;/;
  var TAG_NAME_REGEXP = /<([\w:-]+)/;
  var XHTML_TAG_REGEXP = /<(?!area|br|col|embed|hr|img|input|link|meta|param)(([\w:-]+)[^>]*)\/>/gi;

  // Table parts need to be wrapped with `<table>` or they're
  // stripped to their contents when put in a div.
  // XHTML parsers do not magically insert elements in the
  // same way that tag soup parsers do, so we cannot shorten
  // this by omitting <tbody> or other required elements.
  var wrapMap = {
    thead: ['table'],
    col: ['colgroup', 'table'],
    tr: ['tbody', 'table'],
    td: ['tr', 'tbody', 'table']
  };
  wrapMap.tbody = wrapMap.tfoot = wrapMap.colgroup = wrapMap.caption = wrapMap.thead;
  wrapMap.th = wrapMap.td;

  // Support: IE <10 only
  // IE 9 requires an option wrapper & it needs to have the whole table structure
  // set up in advance; assigning `"<td></td>"` to `tr.innerHTML` doesn't work, etc.
  var wrapMapIE9 = {
    option: [1, '<select multiple="multiple">', '</select>'],
    _default: [0, '', '']
  };
  for (var key in wrapMap) {
    var wrapMapValueClosing = wrapMap[key];
    var wrapMapValue = wrapMapValueClosing.slice().reverse();
    wrapMapIE9[key] = [wrapMapValue.length, '<' + wrapMapValue.join('><') + '>', '</' + wrapMapValueClosing.join('></') + '>'];
  }
  wrapMapIE9.optgroup = wrapMapIE9.option;
  function jqLiteIsTextNode(html) {
    return !HTML_REGEXP.test(html);
  }
  function jqLiteAcceptsData(node) {
    // The window object can accept data but has no nodeType
    // Otherwise we are only interested in elements (1) and documents (9)
    var nodeType = node.nodeType;
    return nodeType === NODE_TYPE_ELEMENT || !nodeType || nodeType === NODE_TYPE_DOCUMENT;
  }
  function jqLiteHasData(node) {
    for (var key in jqCache[node.ng339]) {
      return true;
    }
    return false;
  }
  function jqLiteBuildFragment(html, context) {
    var tmp,
      tag,
      wrap,
      finalHtml,
      fragment = context.createDocumentFragment(),
      nodes = [],
      i;
    if (jqLiteIsTextNode(html)) {
      // Convert non-html into a text node
      nodes.push(context.createTextNode(html));
    } else {
      // Convert html into DOM nodes
      tmp = fragment.appendChild(context.createElement('div'));
      tag = (TAG_NAME_REGEXP.exec(html) || ['', ''])[1].toLowerCase();
      finalHtml = JQLite.legacyXHTMLReplacement ? html.replace(XHTML_TAG_REGEXP, '<$1></$2>') : html;
      if (msie < 10) {
        wrap = wrapMapIE9[tag] || wrapMapIE9._default;
        tmp.innerHTML = wrap[1] + finalHtml + wrap[2];

        // Descend through wrappers to the right content
        i = wrap[0];
        while (i--) {
          tmp = tmp.firstChild;
        }
      } else {
        wrap = wrapMap[tag] || [];

        // Create wrappers & descend into them
        i = wrap.length;
        while (--i > -1) {
          tmp.appendChild(window.document.createElement(wrap[i]));
          tmp = tmp.firstChild;
        }
        tmp.innerHTML = finalHtml;
      }
      nodes = concat(nodes, tmp.childNodes);
      tmp = fragment.firstChild;
      tmp.textContent = '';
    }

    // Remove wrapper from fragment
    fragment.textContent = '';
    fragment.innerHTML = ''; // Clear inner HTML
    forEach(nodes, function (node) {
      fragment.appendChild(node);
    });
    return fragment;
  }
  function jqLiteParseHTML(html, context) {
    context = context || window.document;
    var parsed;
    if (parsed = SINGLE_TAG_REGEXP.exec(html)) {
      return [context.createElement(parsed[1])];
    }
    if (parsed = jqLiteBuildFragment(html, context)) {
      return parsed.childNodes;
    }
    return [];
  }
  function jqLiteWrapNode(node, wrapper) {
    var parent = node.parentNode;
    if (parent) {
      parent.replaceChild(wrapper, node);
    }
    wrapper.appendChild(node);
  }

  // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
  var jqLiteContains = window.Node.prototype.contains || /** @this */function (arg) {
    // eslint-disable-next-line no-bitwise
    return !!(this.compareDocumentPosition(arg) & 16);
  };

  /////////////////////////////////////////////
  function JQLite(element) {
    if (element instanceof JQLite) {
      return element;
    }
    var argIsString;
    if (isString(element)) {
      element = trim(element);
      argIsString = true;
    }
    if (!(this instanceof JQLite)) {
      if (argIsString && element.charAt(0) !== '<') {
        throw jqLiteMinErr('nosel', 'Looking up elements via selectors is not supported by jqLite! See: http://docs.angularjs.org/api/angular.element');
      }
      return new JQLite(element);
    }
    if (argIsString) {
      jqLiteAddNodes(this, jqLiteParseHTML(element));
    } else if (isFunction(element)) {
      jqLiteReady(element);
    } else {
      jqLiteAddNodes(this, element);
    }
  }
  function jqLiteClone(element) {
    return element.cloneNode(true);
  }
  function jqLiteDealoc(element, onlyDescendants) {
    if (!onlyDescendants && jqLiteAcceptsData(element)) jqLite.cleanData([element]);
    if (element.querySelectorAll) {
      jqLite.cleanData(element.querySelectorAll('*'));
    }
  }
  function isEmptyObject(obj) {
    var name;
    for (name in obj) {
      return false;
    }
    return true;
  }
  function removeIfEmptyData(element) {
    var expandoId = element.ng339;
    var expandoStore = expandoId && jqCache[expandoId];
    var events = expandoStore && expandoStore.events;
    var data = expandoStore && expandoStore.data;
    if ((!data || isEmptyObject(data)) && (!events || isEmptyObject(events))) {
      delete jqCache[expandoId];
      element.ng339 = undefined; // don't delete DOM expandos. IE and Chrome don't like it
    }
  }
  function jqLiteOff(element, type, fn, unsupported) {
    if (isDefined(unsupported)) throw jqLiteMinErr('offargs', 'jqLite#off() does not support the `selector` argument');
    var expandoStore = jqLiteExpandoStore(element);
    var events = expandoStore && expandoStore.events;
    var handle = expandoStore && expandoStore.handle;
    if (!handle) return; //no listeners registered

    if (!type) {
      for (type in events) {
        if (type !== '$destroy') {
          element.removeEventListener(type, handle);
        }
        delete events[type];
      }
    } else {
      var removeHandler = function removeHandler(type) {
        var listenerFns = events[type];
        if (isDefined(fn)) {
          arrayRemove(listenerFns || [], fn);
        }
        if (!(isDefined(fn) && listenerFns && listenerFns.length > 0)) {
          element.removeEventListener(type, handle);
          delete events[type];
        }
      };
      forEach(type.split(' '), function (type) {
        removeHandler(type);
        if (MOUSE_EVENT_MAP[type]) {
          removeHandler(MOUSE_EVENT_MAP[type]);
        }
      });
    }
    removeIfEmptyData(element);
  }
  function jqLiteRemoveData(element, name) {
    var expandoId = element.ng339;
    var expandoStore = expandoId && jqCache[expandoId];
    if (expandoStore) {
      if (name) {
        delete expandoStore.data[name];
      } else {
        expandoStore.data = {};
      }
      removeIfEmptyData(element);
    }
  }
  function jqLiteExpandoStore(element, createIfNecessary) {
    var expandoId = element.ng339,
      expandoStore = expandoId && jqCache[expandoId];
    if (createIfNecessary && !expandoStore) {
      element.ng339 = expandoId = jqNextId();
      expandoStore = jqCache[expandoId] = {
        events: {},
        data: {},
        handle: undefined
      };
    }
    return expandoStore;
  }
  function jqLiteData(element, key, value) {
    if (jqLiteAcceptsData(element)) {
      var prop;
      var isSimpleSetter = isDefined(value);
      var isSimpleGetter = !isSimpleSetter && key && !isObject(key);
      var massGetter = !key;
      var expandoStore = jqLiteExpandoStore(element, !isSimpleGetter);
      var data = expandoStore && expandoStore.data;
      if (isSimpleSetter) {
        // data('key', value)
        data[kebabToCamel(key)] = value;
      } else {
        if (massGetter) {
          // data()
          return data;
        } else {
          if (isSimpleGetter) {
            // data('key')
            // don't force creation of expandoStore if it doesn't exist yet
            return data && data[kebabToCamel(key)];
          } else {
            // mass-setter: data({key1: val1, key2: val2})
            for (prop in key) {
              data[kebabToCamel(prop)] = key[prop];
            }
          }
        }
      }
    }
  }
  function jqLiteHasClass(element, selector) {
    if (!element.getAttribute) return false;
    return (' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ').indexOf(' ' + selector + ' ') > -1;
  }
  function jqLiteRemoveClass(element, cssClasses) {
    if (cssClasses && element.setAttribute) {
      var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ');
      var newClasses = existingClasses;
      forEach(cssClasses.split(' '), function (cssClass) {
        cssClass = trim(cssClass);
        newClasses = newClasses.replace(' ' + cssClass + ' ', ' ');
      });
      if (newClasses !== existingClasses) {
        element.setAttribute('class', trim(newClasses));
      }
    }
  }
  function jqLiteAddClass(element, cssClasses) {
    if (cssClasses && element.setAttribute) {
      var existingClasses = (' ' + (element.getAttribute('class') || '') + ' ').replace(/[\n\t]/g, ' ');
      var newClasses = existingClasses;
      forEach(cssClasses.split(' '), function (cssClass) {
        cssClass = trim(cssClass);
        if (newClasses.indexOf(' ' + cssClass + ' ') === -1) {
          newClasses += cssClass + ' ';
        }
      });
      if (newClasses !== existingClasses) {
        element.setAttribute('class', trim(newClasses));
      }
    }
  }
  function jqLiteAddNodes(root, elements) {
    // THIS CODE IS VERY HOT. Don't make changes without benchmarking.

    if (elements) {
      // if a Node (the most common case)
      if (elements.nodeType) {
        root[root.length++] = elements;
      } else {
        var length = elements.length;

        // if an Array or NodeList and not a Window
        if (typeof length === 'number' && elements.window !== elements) {
          if (length) {
            for (var i = 0; i < length; i++) {
              root[root.length++] = elements[i];
            }
          }
        } else {
          root[root.length++] = elements;
        }
      }
    }
  }
  function jqLiteController(element, name) {
    return jqLiteInheritedData(element, '$' + (name || 'ngController') + 'Controller');
  }
  function jqLiteInheritedData(element, name, value) {
    // if element is the document object work with the html element instead
    // this makes $(document).scope() possible
    if (element.nodeType === NODE_TYPE_DOCUMENT) {
      element = element.documentElement;
    }
    var names = isArray(name) ? name : [name];
    while (element) {
      for (var i = 0, ii = names.length; i < ii; i++) {
        if (isDefined(value = jqLite.data(element, names[i]))) return value;
      }

      // If dealing with a document fragment node with a host element, and no parent, use the host
      // element as the parent. This enables directives within a Shadow DOM or polyfilled Shadow DOM
      // to lookup parent controllers.
      element = element.parentNode || element.nodeType === NODE_TYPE_DOCUMENT_FRAGMENT && element.host;
    }
  }
  function jqLiteEmpty(element) {
    jqLiteDealoc(element, true);
    while (element.firstChild) {
      element.removeChild(element.firstChild);
    }
  }
  function jqLiteRemove(element, keepData) {
    if (!keepData) jqLiteDealoc(element);
    var parent = element.parentNode;
    if (parent) parent.removeChild(element);
  }
  function jqLiteDocumentLoaded(action, win) {
    win = win || window;
    if (win.document.readyState === 'complete') {
      // Force the action to be run async for consistent behavior
      // from the action's point of view
      // i.e. it will definitely not be in a $apply
      win.setTimeout(action);
    } else {
      // No need to unbind this handler as load is only ever called once
      jqLite(win).on('load', action);
    }
  }
  function jqLiteReady(fn) {
    function trigger() {
      window.document.removeEventListener('DOMContentLoaded', trigger);
      window.removeEventListener('load', trigger);
      fn();
    }

    // check if document is already loaded
    if (window.document.readyState === 'complete') {
      window.setTimeout(fn);
    } else {
      // We can not use jqLite since we are not done loading and jQuery could be loaded later.

      // Works for modern browsers and IE9
      window.document.addEventListener('DOMContentLoaded', trigger);

      // Fallback to window.onload for others
      window.addEventListener('load', trigger);
    }
  }

  //////////////////////////////////////////
  // Functions which are declared directly.
  //////////////////////////////////////////
  var JQLitePrototype = JQLite.prototype = {
    ready: jqLiteReady,
    toString: function toString() {
      var value = [];
      forEach(this, function (e) {
        value.push('' + e);
      });
      return '[' + value.join(', ') + ']';
    },
    eq: function eq(index) {
      return index >= 0 ? jqLite(this[index]) : jqLite(this[this.length + index]);
    },
    length: 0,
    push: push,
    sort: [].sort,
    splice: [].splice
  };

  //////////////////////////////////////////
  // Functions iterating getter/setters.
  // these functions return self on setter and
  // value on get.
  //////////////////////////////////////////
  var BOOLEAN_ATTR = {};
  forEach('multiple,selected,checked,disabled,readOnly,required,open'.split(','), function (value) {
    BOOLEAN_ATTR[lowercase(value)] = value;
  });
  var BOOLEAN_ELEMENTS = {};
  forEach('input,select,option,textarea,button,form,details'.split(','), function (value) {
    BOOLEAN_ELEMENTS[value] = true;
  });
  var ALIASED_ATTR = {
    'ngMinlength': 'minlength',
    'ngMaxlength': 'maxlength',
    'ngMin': 'min',
    'ngMax': 'max',
    'ngPattern': 'pattern',
    'ngStep': 'step'
  };
  function getBooleanAttrName(element, name) {
    // check dom last since we will most likely fail on name
    var booleanAttr = BOOLEAN_ATTR[name.toLowerCase()];

    // booleanAttr is here twice to minimize DOM access
    return booleanAttr && BOOLEAN_ELEMENTS[nodeName_(element)] && booleanAttr;
  }
  function getAliasedAttrName(name) {
    return ALIASED_ATTR[name];
  }
  forEach({
    data: jqLiteData,
    removeData: jqLiteRemoveData,
    hasData: jqLiteHasData,
    cleanData: function jqLiteCleanData(nodes) {
      for (var i = 0, ii = nodes.length; i < ii; i++) {
        jqLiteRemoveData(nodes[i]);
        jqLiteOff(nodes[i]);
      }
    }
  }, function (fn, name) {
    JQLite[name] = fn;
  });
  forEach({
    data: jqLiteData,
    inheritedData: jqLiteInheritedData,
    scope: function scope(element) {
      // Can't use jqLiteData here directly so we stay compatible with jQuery!
      return jqLite.data(element, '$scope') || jqLiteInheritedData(element.parentNode || element, ['$isolateScope', '$scope']);
    },
    isolateScope: function isolateScope(element) {
      // Can't use jqLiteData here directly so we stay compatible with jQuery!
      return jqLite.data(element, '$isolateScope') || jqLite.data(element, '$isolateScopeNoTemplate');
    },
    controller: jqLiteController,
    injector: function injector(element) {
      return jqLiteInheritedData(element, '$injector');
    },
    removeAttr: function removeAttr(element, name) {
      element.removeAttribute(name);
    },
    hasClass: jqLiteHasClass,
    css: function css(element, name, value) {
      name = cssKebabToCamel(name);
      if (isDefined(value)) {
        element.style[name] = value;
      } else {
        return element.style[name];
      }
    },
    attr: function attr(element, name, value) {
      var ret;
      var nodeType = element.nodeType;
      if (nodeType === NODE_TYPE_TEXT || nodeType === NODE_TYPE_ATTRIBUTE || nodeType === NODE_TYPE_COMMENT || !element.getAttribute) {
        return;
      }
      var lowercasedName = lowercase(name);
      var isBooleanAttr = BOOLEAN_ATTR[lowercasedName];
      if (isDefined(value)) {
        // setter

        if (value === null || value === false && isBooleanAttr) {
          element.removeAttribute(name);
        } else {
          element.setAttribute(name, isBooleanAttr ? lowercasedName : value);
        }
      } else {
        // getter

        ret = element.getAttribute(name);
        if (isBooleanAttr && ret !== null) {
          ret = lowercasedName;
        }
        // Normalize non-existing attributes to undefined (as jQuery).
        return ret === null ? undefined : ret;
      }
    },
    prop: function prop(element, name, value) {
      if (isDefined(value)) {
        element[name] = value;
      } else {
        return element[name];
      }
    },
    text: function () {
      getText.$dv = '';
      return getText;
      function getText(element, value) {
        if (isUndefined(value)) {
          var nodeType = element.nodeType;
          return nodeType === NODE_TYPE_ELEMENT || nodeType === NODE_TYPE_TEXT ? element.textContent : '';
        }
        element.textContent = value;
      }
    }(),
    val: function val(element, value) {
      if (isUndefined(value)) {
        if (element.multiple && nodeName_(element) === 'select') {
          var result = [];
          forEach(element.options, function (option) {
            if (option.selected) {
              result.push(option.value || option.text);
            }
          });
          return result;
        }
        return element.value;
      }
      element.value = value;
    },
    html: function html(element, value) {
      if (isUndefined(value)) {
        return element.innerHTML;
      }
      jqLiteDealoc(element, true);
      element.innerHTML = value;
    },
    empty: jqLiteEmpty
  }, function (fn, name) {
    /**
     * Properties: writes return selection, reads return first value
     */
    JQLite.prototype[name] = function (arg1, arg2) {
      var i, key;
      var nodeCount = this.length;

      // jqLiteHasClass has only two arguments, but is a getter-only fn, so we need to special-case it
      // in a way that survives minification.
      // jqLiteEmpty takes no arguments but is a setter.
      if (fn !== jqLiteEmpty && isUndefined(fn.length === 2 && fn !== jqLiteHasClass && fn !== jqLiteController ? arg1 : arg2)) {
        if (isObject(arg1)) {
          // we are a write, but the object properties are the key/values
          for (i = 0; i < nodeCount; i++) {
            if (fn === jqLiteData) {
              // data() takes the whole object in jQuery
              fn(this[i], arg1);
            } else {
              for (key in arg1) {
                fn(this[i], key, arg1[key]);
              }
            }
          }
          // return self for chaining
          return this;
        } else {
          // we are a read, so read the first child.
          // TODO: do we still need this?
          var value = fn.$dv;
          // Only if we have $dv do we iterate over all, otherwise it is just the first element.
          var jj = isUndefined(value) ? Math.min(nodeCount, 1) : nodeCount;
          for (var j = 0; j < jj; j++) {
            var nodeValue = fn(this[j], arg1, arg2);
            value = value ? value + nodeValue : nodeValue;
          }
          return value;
        }
      } else {
        // we are a write, so apply to all children
        for (i = 0; i < nodeCount; i++) {
          fn(this[i], arg1, arg2);
        }
        // return self for chaining
        return this;
      }
    };
  });
  function createEventHandler(element, events) {
    var eventHandler = function eventHandler(event, type) {
      // jQuery specific api
      event.isDefaultPrevented = function () {
        return event.defaultPrevented;
      };
      var eventFns = events[type || event.type];
      var eventFnsLength = eventFns ? eventFns.length : 0;
      if (!eventFnsLength) return;
      if (isUndefined(event.immediatePropagationStopped)) {
        var originalStopImmediatePropagation = event.stopImmediatePropagation;
        event.stopImmediatePropagation = function () {
          event.immediatePropagationStopped = true;
          if (event.stopPropagation) {
            event.stopPropagation();
          }
          if (originalStopImmediatePropagation) {
            originalStopImmediatePropagation.call(event);
          }
        };
      }
      event.isImmediatePropagationStopped = function () {
        return event.immediatePropagationStopped === true;
      };

      // Some events have special handlers that wrap the real handler
      var handlerWrapper = eventFns.specialHandlerWrapper || defaultHandlerWrapper;

      // Copy event handlers in case event handlers array is modified during execution.
      if (eventFnsLength > 1) {
        eventFns = shallowCopy(eventFns);
      }
      for (var i = 0; i < eventFnsLength; i++) {
        if (!event.isImmediatePropagationStopped()) {
          handlerWrapper(element, event, eventFns[i]);
        }
      }
    };

    // TODO: this is a hack for angularMocks/clearDataCache that makes it possible to deregister all
    //       events on `element`
    eventHandler.elem = element;
    return eventHandler;
  }
  function defaultHandlerWrapper(element, event, handler) {
    handler.call(element, event);
  }
  function specialMouseHandlerWrapper(target, event, handler) {
    // Refer to jQuery's implementation of mouseenter & mouseleave
    // Read about mouseenter and mouseleave:
    // http://www.quirksmode.org/js/events_mouse.html#link8
    var related = event.relatedTarget;
    // For mousenter/leave call the handler if related is outside the target.
    // NB: No relatedTarget if the mouse left/entered the browser window
    if (!related || related !== target && !jqLiteContains.call(target, related)) {
      handler.call(target, event);
    }
  }

  //////////////////////////////////////////
  // Functions iterating traversal.
  // These functions chain results into a single
  // selector.
  //////////////////////////////////////////
  forEach({
    removeData: jqLiteRemoveData,
    on: function jqLiteOn(element, type, fn, unsupported) {
      if (isDefined(unsupported)) throw jqLiteMinErr('onargs', 'jqLite#on() does not support the `selector` or `eventData` parameters');

      // Do not add event handlers to non-elements because they will not be cleaned up.
      if (!jqLiteAcceptsData(element)) {
        return;
      }
      var expandoStore = jqLiteExpandoStore(element, true);
      var events = expandoStore.events;
      var handle = expandoStore.handle;
      if (!handle) {
        handle = expandoStore.handle = createEventHandler(element, events);
      }

      // http://jsperf.com/string-indexof-vs-split
      var types = type.indexOf(' ') >= 0 ? type.split(' ') : [type];
      var i = types.length;
      var addHandler = function addHandler(type, specialHandlerWrapper, noEventListener) {
        var eventFns = events[type];
        if (!eventFns) {
          eventFns = events[type] = [];
          eventFns.specialHandlerWrapper = specialHandlerWrapper;
          if (type !== '$destroy' && !noEventListener) {
            element.addEventListener(type, handle);
          }
        }
        eventFns.push(fn);
      };
      while (i--) {
        type = types[i];
        if (MOUSE_EVENT_MAP[type]) {
          addHandler(MOUSE_EVENT_MAP[type], specialMouseHandlerWrapper);
          addHandler(type, undefined, true);
        } else {
          addHandler(type);
        }
      }
    },
    off: jqLiteOff,
    one: function one(element, type, fn) {
      element = jqLite(element);

      //add the listener twice so that when it is called
      //you can remove the original function and still be
      //able to call element.off(ev, fn) normally
      element.on(type, function onFn() {
        element.off(type, fn);
        element.off(type, onFn);
      });
      element.on(type, fn);
    },
    replaceWith: function replaceWith(element, replaceNode) {
      var index,
        parent = element.parentNode;
      jqLiteDealoc(element);
      forEach(new JQLite(replaceNode), function (node) {
        if (index) {
          parent.insertBefore(node, index.nextSibling);
        } else {
          parent.replaceChild(node, element);
        }
        index = node;
      });
    },
    children: function children(element) {
      var children = [];
      forEach(element.childNodes, function (element) {
        if (element.nodeType === NODE_TYPE_ELEMENT) {
          children.push(element);
        }
      });
      return children;
    },
    contents: function contents(element) {
      return element.contentDocument || element.childNodes || [];
    },
    append: function append(element, node) {
      var nodeType = element.nodeType;
      if (nodeType !== NODE_TYPE_ELEMENT && nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT) return;
      node = new JQLite(node);
      for (var i = 0, ii = node.length; i < ii; i++) {
        var child = node[i];
        element.appendChild(child);
      }
    },
    prepend: function prepend(element, node) {
      if (element.nodeType === NODE_TYPE_ELEMENT) {
        var index = element.firstChild;
        forEach(new JQLite(node), function (child) {
          element.insertBefore(child, index);
        });
      }
    },
    wrap: function wrap(element, wrapNode) {
      jqLiteWrapNode(element, jqLite(wrapNode).eq(0).clone()[0]);
    },
    remove: jqLiteRemove,
    detach: function detach(element) {
      jqLiteRemove(element, true);
    },
    after: function after(element, newElement) {
      var index = element,
        parent = element.parentNode;
      if (parent) {
        newElement = new JQLite(newElement);
        for (var i = 0, ii = newElement.length; i < ii; i++) {
          var node = newElement[i];
          parent.insertBefore(node, index.nextSibling);
          index = node;
        }
      }
    },
    addClass: jqLiteAddClass,
    removeClass: jqLiteRemoveClass,
    toggleClass: function toggleClass(element, selector, condition) {
      if (selector) {
        forEach(selector.split(' '), function (className) {
          var classCondition = condition;
          if (isUndefined(classCondition)) {
            classCondition = !jqLiteHasClass(element, className);
          }
          (classCondition ? jqLiteAddClass : jqLiteRemoveClass)(element, className);
        });
      }
    },
    parent: function parent(element) {
      var parent = element.parentNode;
      return parent && parent.nodeType !== NODE_TYPE_DOCUMENT_FRAGMENT ? parent : null;
    },
    next: function next(element) {
      return element.nextElementSibling;
    },
    find: function find(element, selector) {
      if (element.getElementsByTagName) {
        return element.getElementsByTagName(selector);
      } else {
        return [];
      }
    },
    clone: jqLiteClone,
    triggerHandler: function triggerHandler(element, event, extraParameters) {
      var dummyEvent, eventFnsCopy, handlerArgs;
      var eventName = event.type || event;
      var expandoStore = jqLiteExpandoStore(element);
      var events = expandoStore && expandoStore.events;
      var eventFns = events && events[eventName];
      if (eventFns) {
        // Create a dummy event to pass to the handlers
        dummyEvent = {
          preventDefault: function preventDefault() {
            this.defaultPrevented = true;
          },
          isDefaultPrevented: function isDefaultPrevented() {
            return this.defaultPrevented === true;
          },
          stopImmediatePropagation: function stopImmediatePropagation() {
            this.immediatePropagationStopped = true;
          },
          isImmediatePropagationStopped: function isImmediatePropagationStopped() {
            return this.immediatePropagationStopped === true;
          },
          stopPropagation: noop,
          type: eventName,
          target: element
        };

        // If a custom event was provided then extend our dummy event with it
        if (event.type) {
          dummyEvent = extend(dummyEvent, event);
        }

        // Copy event handlers in case event handlers array is modified during execution.
        eventFnsCopy = shallowCopy(eventFns);
        handlerArgs = extraParameters ? [dummyEvent].concat(extraParameters) : [dummyEvent];
        forEach(eventFnsCopy, function (fn) {
          if (!dummyEvent.isImmediatePropagationStopped()) {
            fn.apply(element, handlerArgs);
          }
        });
      }
    }
  }, function (fn, name) {
    /**
     * chaining functions
     */
    JQLite.prototype[name] = function (arg1, arg2, arg3) {
      var value;
      for (var i = 0, ii = this.length; i < ii; i++) {
        if (isUndefined(value)) {
          value = fn(this[i], arg1, arg2, arg3);
          if (isDefined(value)) {
            // any function which returns a value needs to be wrapped
            value = jqLite(value);
          }
        } else {
          jqLiteAddNodes(value, fn(this[i], arg1, arg2, arg3));
        }
      }
      return isDefined(value) ? value : this;
    };
  });

  // bind legacy bind/unbind to on/off
  JQLite.prototype.bind = JQLite.prototype.on;
  JQLite.prototype.unbind = JQLite.prototype.off;

  // Provider for private $$jqLite service
  /** @this */
  function $$jqLiteProvider() {
    this.$get = function $$jqLite() {
      return extend(JQLite, {
        hasClass: function hasClass(node, classes) {
          if (node.attr) node = node[0];
          return jqLiteHasClass(node, classes);
        },
        addClass: function addClass(node, classes) {
          if (node.attr) node = node[0];
          return jqLiteAddClass(node, classes);
        },
        removeClass: function removeClass(node, classes) {
          if (node.attr) node = node[0];
          return jqLiteRemoveClass(node, classes);
        }
      });
    };
  }

  /**
   * Computes a hash of an 'obj'.
   * Hash of a:
   *  string is string
   *  number is number as string
   *  object is either result of calling $$hashKey function on the object or uniquely generated id,
   *         that is also assigned to the $$hashKey property of the object.
   *
   * @param obj
   * @returns {string} hash string such that the same input will have the same hash string.
   *         The resulting string key is in 'type:hashKey' format.
   */
  function hashKey(obj, nextUidFn) {
    var key = obj && obj.$$hashKey;
    if (key) {
      if (typeof key === 'function') {
        key = obj.$$hashKey();
      }
      return key;
    }
    var objType = _typeof(obj);
    if (objType === 'function' || objType === 'object' && obj !== null) {
      key = obj.$$hashKey = objType + ':' + (nextUidFn || nextUid)();
    } else {
      key = objType + ':' + obj;
    }
    return key;
  }

  // A minimal ES2015 Map implementation.
  // Should be bug/feature equivalent to the native implementations of supported browsers
  // (for the features required in Angular).
  // See https://kangax.github.io/compat-table/es6/#test-Map
  var nanKey = Object.create(null);
  function NgMapShim() {
    this._keys = [];
    this._values = [];
    this._lastKey = NaN;
    this._lastIndex = -1;
  }
  NgMapShim.prototype = {
    _idx: function _idx(key) {
      if (key !== this._lastKey) {
        this._lastKey = key;
        this._lastIndex = this._keys.indexOf(key);
      }
      return this._lastIndex;
    },
    _transformKey: function _transformKey(key) {
      return isNumberNaN(key) ? nanKey : key;
    },
    get: function get(key) {
      key = this._transformKey(key);
      var idx = this._idx(key);
      if (idx !== -1) {
        return this._values[idx];
      }
    },
    has: function has(key) {
      key = this._transformKey(key);
      var idx = this._idx(key);
      return idx !== -1;
    },
    set: function set(key, value) {
      key = this._transformKey(key);
      var idx = this._idx(key);
      if (idx === -1) {
        idx = this._lastIndex = this._keys.length;
      }
      this._keys[idx] = key;
      this._values[idx] = value;

      // Support: IE11
      // Do not `return this` to simulate the partial IE11 implementation
    },
    "delete": function _delete(key) {
      key = this._transformKey(key);
      var idx = this._idx(key);
      if (idx === -1) {
        return false;
      }
      this._keys.splice(idx, 1);
      this._values.splice(idx, 1);
      this._lastKey = NaN;
      this._lastIndex = -1;
      return true;
    }
  };

  // For now, always use `NgMapShim`, even if `window.Map` is available. Some native implementations
  // are still buggy (often in subtle ways) and can cause hard-to-debug failures. When native `Map`
  // implementations get more stable, we can reconsider switching to `window.Map` (when available).
  var NgMap = NgMapShim;
  var $$MapProvider = [/** @this */function () {
    this.$get = [function () {
      return NgMap;
    }];
  }];

  /**
   * @ngdoc function
   * @module ng
   * @name angular.injector
   * @kind function
   *
   * @description
   * Creates an injector object that can be used for retrieving services as well as for
   * dependency injection (see {@link guide/di dependency injection}).
   *
   * @param {Array.<string|Function>} modules A list of module functions or their aliases. See
   *     {@link angular.module}. The `ng` module must be explicitly added.
   * @param {boolean=} [strictDi=false] Whether the injector should be in strict mode, which
   *     disallows argument name annotation inference.
   * @returns {injector} Injector object. See {@link auto.$injector $injector}.
   *
   * @example
   * Typical usage
   * ```js
   *   // create an injector
   *   var $injector = angular.injector(['ng']);
   *
   *   // use the injector to kick off your application
   *   // use the type inference to auto inject arguments, or use implicit injection
   *   $injector.invoke(function($rootScope, $compile, $document) {
   *     $compile($document)($rootScope);
   *     $rootScope.$digest();
   *   });
   * ```
   *
   * Sometimes you want to get access to the injector of a currently running AngularJS app
   * from outside AngularJS. Perhaps, you want to inject and compile some markup after the
   * application has been bootstrapped. You can do this using the extra `injector()` added
   * to JQuery/jqLite elements. See {@link angular.element}.
   *
   * *This is fairly rare but could be the case if a third party library is injecting the
   * markup.*
   *
   * In the following example a new block of HTML containing a `ng-controller`
   * directive is added to the end of the document body by JQuery. We then compile and link
   * it into the current AngularJS scope.
   *
   * ```js
   * var $div = $('<div ng-controller="MyCtrl">{{content.label}}</div>');
   * $(document.body).append($div);
   *
   * angular.element(document).injector().invoke(function($compile) {
   *   var scope = angular.element($div).scope();
   *   $compile($div)(scope);
   * });
   * ```
   */

  /**
   * @ngdoc module
   * @name auto
   * @installation
   * @description
   *
   * Implicit module which gets automatically added to each {@link auto.$injector $injector}.
   */

  var ARROW_ARG = /^([^(]+?)=>/;
  var FN_ARGS = /^[^(]*\(\s*([^)]*)\)/m;
  var FN_ARG_SPLIT = /,/;
  var FN_ARG = /^\s*(_?)(\S+?)\1\s*$/;
  var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/mg;
  var $injectorMinErr = minErr('$injector');
  function stringifyFn(fn) {
    return Function.prototype.toString.call(fn);
  }
  function extractArgs(fn) {
    var fnText = stringifyFn(fn).replace(STRIP_COMMENTS, ''),
      args = fnText.match(ARROW_ARG) || fnText.match(FN_ARGS);
    return args;
  }
  function anonFn(fn) {
    // For anonymous functions, showing at the very least the function signature can help in
    // debugging.
    var args = extractArgs(fn);
    if (args) {
      return 'function(' + (args[1] || '').replace(/[\s\r\n]+/, ' ') + ')';
    }
    return 'fn';
  }
  function annotate(fn, strictDi, name) {
    var $inject, argDecl, last;
    if (typeof fn === 'function') {
      if (!($inject = fn.$inject)) {
        $inject = [];
        if (fn.length) {
          if (strictDi) {
            if (!isString(name) || !name) {
              name = fn.name || anonFn(fn);
            }
            throw $injectorMinErr('strictdi', '{0} is not using explicit annotation and cannot be invoked in strict mode', name);
          }
          argDecl = extractArgs(fn);
          forEach(argDecl[1].split(FN_ARG_SPLIT), function (arg) {
            arg.replace(FN_ARG, function (all, underscore, name) {
              $inject.push(name);
            });
          });
        }
        fn.$inject = $inject;
      }
    } else if (isArray(fn)) {
      last = fn.length - 1;
      assertArgFn(fn[last], 'fn');
      $inject = fn.slice(0, last);
    } else {
      assertArgFn(fn, 'fn', true);
    }
    return $inject;
  }

  ///////////////////////////////////////

  /**
   * @ngdoc service
   * @name $injector
   *
   * @description
   *
   * `$injector` is used to retrieve object instances as defined by
   * {@link auto.$provide provider}, instantiate types, invoke methods,
   * and load modules.
   *
   * The following always holds true:
   *
   * ```js
   *   var $injector = angular.injector();
   *   expect($injector.get('$injector')).toBe($injector);
   *   expect($injector.invoke(function($injector) {
   *     return $injector;
   *   })).toBe($injector);
   * ```
   *
   * ## Injection Function Annotation
   *
   * JavaScript does not have annotations, and annotations are needed for dependency injection. The
   * following are all valid ways of annotating function with injection arguments and are equivalent.
   *
   * ```js
   *   // inferred (only works if code not minified/obfuscated)
   *   $injector.invoke(function(serviceA){});
   *
   *   // annotated
   *   function explicit(serviceA) {};
   *   explicit.$inject = ['serviceA'];
   *   $injector.invoke(explicit);
   *
   *   // inline
   *   $injector.invoke(['serviceA', function(serviceA){}]);
   * ```
   *
   * ### Inference
   *
   * In JavaScript calling `toString()` on a function returns the function definition. The definition
   * can then be parsed and the function arguments can be extracted. This method of discovering
   * annotations is disallowed when the injector is in strict mode.
   * *NOTE:* This does not work with minification, and obfuscation tools since these tools change the
   * argument names.
   *
   * ### `$inject` Annotation
   * By adding an `$inject` property onto a function the injection parameters can be specified.
   *
   * ### Inline
   * As an array of injection names, where the last item in the array is the function to call.
   */

  /**
   * @ngdoc property
   * @name $injector#modules
   * @type {Object}
   * @description
   * A hash containing all the modules that have been loaded into the
   * $injector.
   *
   * You can use this property to find out information about a module via the
   * {@link angular.Module#info `myModule.info(...)`} method.
   *
   * For example:
   *
   * ```
   * var info = $injector.modules['ngAnimate'].info();
   * ```
   *
   * **Do not use this property to attempt to modify the modules after the application
   * has been bootstrapped.**
   */

  /**
   * @ngdoc method
   * @name $injector#get
   *
   * @description
   * Return an instance of the service.
   *
   * @param {string} name The name of the instance to retrieve.
   * @param {string=} caller An optional string to provide the origin of the function call for error messages.
   * @return {*} The instance.
   */

  /**
   * @ngdoc method
   * @name $injector#invoke
   *
   * @description
   * Invoke the method and supply the method arguments from the `$injector`.
   *
   * @param {Function|Array.<string|Function>} fn The injectable function to invoke. Function parameters are
   *   injected according to the {@link guide/di $inject Annotation} rules.
   * @param {Object=} self The `this` for the invoked method.
   * @param {Object=} locals Optional object. If preset then any argument names are read from this
   *                         object first, before the `$injector` is consulted.
   * @returns {*} the value returned by the invoked `fn` function.
   */

  /**
   * @ngdoc method
   * @name $injector#has
   *
   * @description
   * Allows the user to query if the particular service exists.
   *
   * @param {string} name Name of the service to query.
   * @returns {boolean} `true` if injector has given service.
   */

  /**
   * @ngdoc method
   * @name $injector#instantiate
   * @description
   * Create a new instance of JS type. The method takes a constructor function, invokes the new
   * operator, and supplies all of the arguments to the constructor function as specified by the
   * constructor annotation.
   *
   * @param {Function} Type Annotated constructor function.
   * @param {Object=} locals Optional object. If preset then any argument names are read from this
   * object first, before the `$injector` is consulted.
   * @returns {Object} new instance of `Type`.
   */

  /**
   * @ngdoc method
   * @name $injector#annotate
   *
   * @description
   * Returns an array of service names which the function is requesting for injection. This API is
   * used by the injector to determine which services need to be injected into the function when the
   * function is invoked. There are three ways in which the function can be annotated with the needed
   * dependencies.
   *
   * #### Argument names
   *
   * The simplest form is to extract the dependencies from the arguments of the function. This is done
   * by converting the function into a string using `toString()` method and extracting the argument
   * names.
   * ```js
   *   // Given
   *   function MyController($scope, $route) {
   *     // ...
   *   }
   *
   *   // Then
   *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
   * ```
   *
   * You can disallow this method by using strict injection mode.
   *
   * This method does not work with code minification / obfuscation. For this reason the following
   * annotation strategies are supported.
   *
   * #### The `$inject` property
   *
   * If a function has an `$inject` property and its value is an array of strings, then the strings
   * represent names of services to be injected into the function.
   * ```js
   *   // Given
   *   var MyController = function(obfuscatedScope, obfuscatedRoute) {
   *     // ...
   *   }
   *   // Define function dependencies
   *   MyController['$inject'] = ['$scope', '$route'];
   *
   *   // Then
   *   expect(injector.annotate(MyController)).toEqual(['$scope', '$route']);
   * ```
   *
   * #### The array notation
   *
   * It is often desirable to inline Injected functions and that's when setting the `$inject` property
   * is very inconvenient. In these situations using the array notation to specify the dependencies in
   * a way that survives minification is a better choice:
   *
   * ```js
   *   // We wish to write this (not minification / obfuscation safe)
   *   injector.invoke(function($compile, $rootScope) {
   *     // ...
   *   });
   *
   *   // We are forced to write break inlining
   *   var tmpFn = function(obfuscatedCompile, obfuscatedRootScope) {
   *     // ...
   *   };
   *   tmpFn.$inject = ['$compile', '$rootScope'];
   *   injector.invoke(tmpFn);
   *
   *   // To better support inline function the inline annotation is supported
   *   injector.invoke(['$compile', '$rootScope', function(obfCompile, obfRootScope) {
   *     // ...
   *   }]);
   *
   *   // Therefore
   *   expect(injector.annotate(
   *      ['$compile', '$rootScope', function(obfus_$compile, obfus_$rootScope) {}])
   *    ).toEqual(['$compile', '$rootScope']);
   * ```
   *
   * @param {Function|Array.<string|Function>} fn Function for which dependent service names need to
   * be retrieved as described above.
   *
   * @param {boolean=} [strictDi=false] Disallow argument name annotation inference.
   *
   * @returns {Array.<string>} The names of the services which the function requires.
   */
  /**
   * @ngdoc method
   * @name $injector#loadNewModules
   *
   * @description
   *
   * **This is a dangerous API, which you use at your own risk!**
   *
   * Add the specified modules to the current injector.
   *
   * This method will add each of the injectables to the injector and execute all of the config and run
   * blocks for each module passed to the method.
   *
   * If a module has already been loaded into the injector then it will not be loaded again.
   *
   * * The application developer is responsible for loading the code containing the modules; and for
   * ensuring that lazy scripts are not downloaded and executed more often that desired.
   * * Previously compiled HTML will not be affected by newly loaded directives, filters and components.
   * * Modules cannot be unloaded.
   *
   * You can use {@link $injector#modules `$injector.modules`} to check whether a module has been loaded
   * into the injector, which may indicate whether the script has been executed already.
   *
   * @example
   * Here is an example of loading a bundle of modules, with a utility method called `getScript`:
   *
   * ```javascript
   * app.factory('loadModule', function($injector) {
   *   return function loadModule(moduleName, bundleUrl) {
   *     return getScript(bundleUrl).then(function() { $injector.loadNewModules([moduleName]); });
   *   };
   * })
   * ```
   *
   * @param {Array<String|Function|Array>=} mods an array of modules to load into the application.
   *     Each item in the array should be the name of a predefined module or a (DI annotated)
   *     function that will be invoked by the injector as a `config` block.
   *     See: {@link angular.module modules}
   */

  /**
   * @ngdoc service
   * @name $provide
   *
   * @description
   *
   * The {@link auto.$provide $provide} service has a number of methods for registering components
   * with the {@link auto.$injector $injector}. Many of these functions are also exposed on
   * {@link angular.Module}.
   *
   * An AngularJS **service** is a singleton object created by a **service factory**.  These **service
   * factories** are functions which, in turn, are created by a **service provider**.
   * The **service providers** are constructor functions. When instantiated they must contain a
   * property called `$get`, which holds the **service factory** function.
   *
   * When you request a service, the {@link auto.$injector $injector} is responsible for finding the
   * correct **service provider**, instantiating it and then calling its `$get` **service factory**
   * function to get the instance of the **service**.
   *
   * Often services have no configuration options and there is no need to add methods to the service
   * provider.  The provider will be no more than a constructor function with a `$get` property. For
   * these cases the {@link auto.$provide $provide} service has additional helper methods to register
   * services without specifying a provider.
   *
   * * {@link auto.$provide#provider provider(name, provider)} - registers a **service provider** with the
   *     {@link auto.$injector $injector}
   * * {@link auto.$provide#constant constant(name, obj)} - registers a value/object that can be accessed by
   *     providers and services.
   * * {@link auto.$provide#value value(name, obj)} - registers a value/object that can only be accessed by
   *     services, not providers.
   * * {@link auto.$provide#factory factory(name, fn)} - registers a service **factory function**
   *     that will be wrapped in a **service provider** object, whose `$get` property will contain the
   *     given factory function.
   * * {@link auto.$provide#service service(name, Fn)} - registers a **constructor function**
   *     that will be wrapped in a **service provider** object, whose `$get` property will instantiate
   *      a new object using the given constructor function.
   * * {@link auto.$provide#decorator decorator(name, decorFn)} - registers a **decorator function** that
   *      will be able to modify or replace the implementation of another service.
   *
   * See the individual methods for more information and examples.
   */

  /**
   * @ngdoc method
   * @name $provide#provider
   * @description
   *
   * Register a **provider function** with the {@link auto.$injector $injector}. Provider functions
   * are constructor functions, whose instances are responsible for "providing" a factory for a
   * service.
   *
   * Service provider names start with the name of the service they provide followed by `Provider`.
   * For example, the {@link ng.$log $log} service has a provider called
   * {@link ng.$logProvider $logProvider}.
   *
   * Service provider objects can have additional methods which allow configuration of the provider
   * and its service. Importantly, you can configure what kind of service is created by the `$get`
   * method, or how that service will act. For example, the {@link ng.$logProvider $logProvider} has a
   * method {@link ng.$logProvider#debugEnabled debugEnabled}
   * which lets you specify whether the {@link ng.$log $log} service will log debug messages to the
   * console or not.
   *
   * It is possible to inject other providers into the provider function,
   * but the injected provider must have been defined before the one that requires it.
   *
   * @param {string} name The name of the instance. NOTE: the provider will be available under `name +
                          'Provider'` key.
   * @param {(Object|function())} provider If the provider is:
   *
   *   - `Object`: then it should have a `$get` method. The `$get` method will be invoked using
   *     {@link auto.$injector#invoke $injector.invoke()} when an instance needs to be created.
   *   - `Constructor`: a new instance of the provider will be created using
   *     {@link auto.$injector#instantiate $injector.instantiate()}, then treated as `object`.
   *
   * @returns {Object} registered provider instance
  
   * @example
   *
   * The following example shows how to create a simple event tracking service and register it using
   * {@link auto.$provide#provider $provide.provider()}.
   *
   * ```js
   *  // Define the eventTracker provider
   *  function EventTrackerProvider() {
   *    var trackingUrl = '/track';
   *
   *    // A provider method for configuring where the tracked events should been saved
   *    this.setTrackingUrl = function(url) {
   *      trackingUrl = url;
   *    };
   *
   *    // The service factory function
   *    this.$get = ['$http', function($http) {
   *      var trackedEvents = {};
   *      return {
   *        // Call this to track an event
   *        event: function(event) {
   *          var count = trackedEvents[event] || 0;
   *          count += 1;
   *          trackedEvents[event] = count;
   *          return count;
   *        },
   *        // Call this to save the tracked events to the trackingUrl
   *        save: function() {
   *          $http.post(trackingUrl, trackedEvents);
   *        }
   *      };
   *    }];
   *  }
   *
   *  describe('eventTracker', function() {
   *    var postSpy;
   *
   *    beforeEach(module(function($provide) {
   *      // Register the eventTracker provider
   *      $provide.provider('eventTracker', EventTrackerProvider);
   *    }));
   *
   *    beforeEach(module(function(eventTrackerProvider) {
   *      // Configure eventTracker provider
   *      eventTrackerProvider.setTrackingUrl('/custom-track');
   *    }));
   *
   *    it('tracks events', inject(function(eventTracker) {
   *      expect(eventTracker.event('login')).toEqual(1);
   *      expect(eventTracker.event('login')).toEqual(2);
   *    }));
   *
   *    it('saves to the tracking url', inject(function(eventTracker, $http) {
   *      postSpy = spyOn($http, 'post');
   *      eventTracker.event('login');
   *      eventTracker.save();
   *      expect(postSpy).toHaveBeenCalled();
   *      expect(postSpy.mostRecentCall.args[0]).not.toEqual('/track');
   *      expect(postSpy.mostRecentCall.args[0]).toEqual('/custom-track');
   *      expect(postSpy.mostRecentCall.args[1]).toEqual({ 'login': 1 });
   *    }));
   *  });
   * ```
   */

  /**
   * @ngdoc method
   * @name $provide#factory
   * @description
   *
   * Register a **service factory**, which will be called to return the service instance.
   * This is short for registering a service where its provider consists of only a `$get` property,
   * which is the given service factory function.
   * You should use {@link auto.$provide#factory $provide.factory(getFn)} if you do not need to
   * configure your service in a provider.
   *
   * @param {string} name The name of the instance.
   * @param {Function|Array.<string|Function>} $getFn The injectable $getFn for the instance creation.
   *                      Internally this is a short hand for `$provide.provider(name, {$get: $getFn})`.
   * @returns {Object} registered provider instance
   *
   * @example
   * Here is an example of registering a service
   * ```js
   *   $provide.factory('ping', ['$http', function($http) {
   *     return function ping() {
   *       return $http.send('/ping');
   *     };
   *   }]);
   * ```
   * You would then inject and use this service like this:
   * ```js
   *   someModule.controller('Ctrl', ['ping', function(ping) {
   *     ping();
   *   }]);
   * ```
   */

  /**
   * @ngdoc method
   * @name $provide#service
   * @description
   *
   * Register a **service constructor**, which will be invoked with `new` to create the service
   * instance.
   * This is short for registering a service where its provider's `$get` property is a factory
   * function that returns an instance instantiated by the injector from the service constructor
   * function.
   *
   * Internally it looks a bit like this:
   *
   * ```
   * {
   *   $get: function() {
   *     return $injector.instantiate(constructor);
   *   }
   * }
   * ```
   *
   *
   * You should use {@link auto.$provide#service $provide.service(class)} if you define your service
   * as a type/class.
   *
   * @param {string} name The name of the instance.
   * @param {Function|Array.<string|Function>} constructor An injectable class (constructor function)
   *     that will be instantiated.
   * @returns {Object} registered provider instance
   *
   * @example
   * Here is an example of registering a service using
   * {@link auto.$provide#service $provide.service(class)}.
   * ```js
   *   var Ping = function($http) {
   *     this.$http = $http;
   *   };
   *
   *   Ping.$inject = ['$http'];
   *
   *   Ping.prototype.send = function() {
   *     return this.$http.get('/ping');
   *   };
   *   $provide.service('ping', Ping);
   * ```
   * You would then inject and use this service like this:
   * ```js
   *   someModule.controller('Ctrl', ['ping', function(ping) {
   *     ping.send();
   *   }]);
   * ```
   */

  /**
   * @ngdoc method
   * @name $provide#value
   * @description
   *
   * Register a **value service** with the {@link auto.$injector $injector}, such as a string, a
   * number, an array, an object or a function. This is short for registering a service where its
   * provider's `$get` property is a factory function that takes no arguments and returns the **value
   * service**. That also means it is not possible to inject other services into a value service.
   *
   * Value services are similar to constant services, except that they cannot be injected into a
   * module configuration function (see {@link angular.Module#config}) but they can be overridden by
   * an AngularJS {@link auto.$provide#decorator decorator}.
   *
   * @param {string} name The name of the instance.
   * @param {*} value The value.
   * @returns {Object} registered provider instance
   *
   * @example
   * Here are some examples of creating value services.
   * ```js
   *   $provide.value('ADMIN_USER', 'admin');
   *
   *   $provide.value('RoleLookup', { admin: 0, writer: 1, reader: 2 });
   *
   *   $provide.value('halfOf', function(value) {
   *     return value / 2;
   *   });
   * ```
   */

  /**
   * @ngdoc method
   * @name $provide#constant
   * @description
   *
   * Register a **constant service** with the {@link auto.$injector $injector}, such as a string,
   * a number, an array, an object or a function. Like the {@link auto.$provide#value value}, it is not
   * possible to inject other services into a constant.
   *
   * But unlike {@link auto.$provide#value value}, a constant can be
   * injected into a module configuration function (see {@link angular.Module#config}) and it cannot
   * be overridden by an AngularJS {@link auto.$provide#decorator decorator}.
   *
   * @param {string} name The name of the constant.
   * @param {*} value The constant value.
   * @returns {Object} registered instance
   *
   * @example
   * Here a some examples of creating constants:
   * ```js
   *   $provide.constant('SHARD_HEIGHT', 306);
   *
   *   $provide.constant('MY_COLOURS', ['red', 'blue', 'grey']);
   *
   *   $provide.constant('double', function(value) {
   *     return value * 2;
   *   });
   * ```
   */

  /**
   * @ngdoc method
   * @name $provide#decorator
   * @description
   *
   * Register a **decorator function** with the {@link auto.$injector $injector}. A decorator function
   * intercepts the creation of a service, allowing it to override or modify the behavior of the
   * service. The return value of the decorator function may be the original service, or a new service
   * that replaces (or wraps and delegates to) the original service.
   *
   * You can find out more about using decorators in the {@link guide/decorators} guide.
   *
   * @param {string} name The name of the service to decorate.
   * @param {Function|Array.<string|Function>} decorator This function will be invoked when the service needs to be
   *    provided and should return the decorated service instance. The function is called using
   *    the {@link auto.$injector#invoke injector.invoke} method and is therefore fully injectable.
   *    Local injection arguments:
   *
   *    * `$delegate` - The original service instance, which can be replaced, monkey patched, configured,
   *      decorated or delegated to.
   *
   * @example
   * Here we decorate the {@link ng.$log $log} service to convert warnings to errors by intercepting
   * calls to {@link ng.$log#error $log.warn()}.
   * ```js
   *   $provide.decorator('$log', ['$delegate', function($delegate) {
   *     $delegate.warn = $delegate.error;
   *     return $delegate;
   *   }]);
   * ```
   */

  function createInjector(modulesToLoad, strictDi) {
    strictDi = strictDi === true;
    var INSTANTIATING = {},
      providerSuffix = 'Provider',
      path = [],
      loadedModules = new NgMap(),
      providerCache = {
        $provide: {
          provider: supportObject(provider),
          factory: supportObject(factory),
          service: supportObject(service),
          value: supportObject(value),
          constant: supportObject(constant),
          decorator: decorator
        }
      },
      providerInjector = providerCache.$injector = createInternalInjector(providerCache, function (serviceName, caller) {
        if (angular.isString(caller)) {
          path.push(caller);
        }
        throw $injectorMinErr('unpr', 'Unknown provider: {0}', path.join(' <- '));
      }),
      instanceCache = {},
      protoInstanceInjector = createInternalInjector(instanceCache, function (serviceName, caller) {
        var provider = providerInjector.get(serviceName + providerSuffix, caller);
        return instanceInjector.invoke(provider.$get, provider, undefined, serviceName);
      }),
      instanceInjector = protoInstanceInjector;
    providerCache['$injector' + providerSuffix] = {
      $get: valueFn(protoInstanceInjector)
    };
    instanceInjector.modules = providerInjector.modules = createMap();
    var runBlocks = loadModules(modulesToLoad);
    instanceInjector = protoInstanceInjector.get('$injector');
    instanceInjector.strictDi = strictDi;
    forEach(runBlocks, function (fn) {
      if (fn) instanceInjector.invoke(fn);
    });
    instanceInjector.loadNewModules = function (mods) {
      forEach(loadModules(mods), function (fn) {
        if (fn) instanceInjector.invoke(fn);
      });
    };
    return instanceInjector;

    ////////////////////////////////////
    // $provider
    ////////////////////////////////////

    function supportObject(delegate) {
      return function (key, value) {
        if (isObject(key)) {
          forEach(key, reverseParams(delegate));
        } else {
          return delegate(key, value);
        }
      };
    }
    function provider(name, provider_) {
      assertNotHasOwnProperty(name, 'service');
      if (isFunction(provider_) || isArray(provider_)) {
        provider_ = providerInjector.instantiate(provider_);
      }
      if (!provider_.$get) {
        throw $injectorMinErr('pget', 'Provider \'{0}\' must define $get factory method.', name);
      }
      return providerCache[name + providerSuffix] = provider_;
    }
    function enforceReturnValue(name, factory) {
      return /** @this */function enforcedReturnValue() {
        var result = instanceInjector.invoke(factory, this);
        if (isUndefined(result)) {
          throw $injectorMinErr('undef', 'Provider \'{0}\' must return a value from $get factory method.', name);
        }
        return result;
      };
    }
    function factory(name, factoryFn, enforce) {
      return provider(name, {
        $get: enforce !== false ? enforceReturnValue(name, factoryFn) : factoryFn
      });
    }
    function service(name, constructor) {
      return factory(name, ['$injector', function ($injector) {
        return $injector.instantiate(constructor);
      }]);
    }
    function value(name, val) {
      return factory(name, valueFn(val), false);
    }
    function constant(name, value) {
      assertNotHasOwnProperty(name, 'constant');
      providerCache[name] = value;
      instanceCache[name] = value;
    }
    function decorator(serviceName, decorFn) {
      var origProvider = providerInjector.get(serviceName + providerSuffix),
        orig$get = origProvider.$get;
      origProvider.$get = function () {
        var origInstance = instanceInjector.invoke(orig$get, origProvider);
        return instanceInjector.invoke(decorFn, null, {
          $delegate: origInstance
        });
      };
    }

    ////////////////////////////////////
    // Module Loading
    ////////////////////////////////////
    function loadModules(modulesToLoad) {
      assertArg(isUndefined(modulesToLoad) || isArray(modulesToLoad), 'modulesToLoad', 'not an array');
      var runBlocks = [],
        moduleFn;
      forEach(modulesToLoad, function (module) {
        if (loadedModules.get(module)) return;
        loadedModules.set(module, true);
        function runInvokeQueue(queue) {
          var i, ii;
          for (i = 0, ii = queue.length; i < ii; i++) {
            var invokeArgs = queue[i],
              provider = providerInjector.get(invokeArgs[0]);
            provider[invokeArgs[1]].apply(provider, invokeArgs[2]);
          }
        }
        try {
          if (isString(module)) {
            moduleFn = angularModule(module);
            instanceInjector.modules[module] = moduleFn;
            runBlocks = runBlocks.concat(loadModules(moduleFn.requires)).concat(moduleFn._runBlocks);
            runInvokeQueue(moduleFn._invokeQueue);
            runInvokeQueue(moduleFn._configBlocks);
          } else if (isFunction(module)) {
            runBlocks.push(providerInjector.invoke(module));
          } else if (isArray(module)) {
            runBlocks.push(providerInjector.invoke(module));
          } else {
            assertArgFn(module, 'module');
          }
        } catch (e) {
          if (isArray(module)) {
            module = module[module.length - 1];
          }
          if (e.message && e.stack && e.stack.indexOf(e.message) === -1) {
            // Safari & FF's stack traces don't contain error.message content
            // unlike those of Chrome and IE
            // So if stack doesn't contain message, we create a new string that contains both.
            // Since error.stack is read-only in Safari, I'm overriding e and not e.stack here.
            // eslint-disable-next-line no-ex-assign
            e = e.message + '\n' + e.stack;
          }
          throw $injectorMinErr('modulerr', 'Failed to instantiate module {0} due to:\n{1}', module, e.stack || e.message || e);
        }
      });
      return runBlocks;
    }

    ////////////////////////////////////
    // internal Injector
    ////////////////////////////////////

    function createInternalInjector(cache, factory) {
      function getService(serviceName, caller) {
        if (cache.hasOwnProperty(serviceName)) {
          if (cache[serviceName] === INSTANTIATING) {
            throw $injectorMinErr('cdep', 'Circular dependency found: {0}', serviceName + ' <- ' + path.join(' <- '));
          }
          return cache[serviceName];
        } else {
          try {
            path.unshift(serviceName);
            cache[serviceName] = INSTANTIATING;
            cache[serviceName] = factory(serviceName, caller);
            return cache[serviceName];
          } catch (err) {
            if (cache[serviceName] === INSTANTIATING) {
              delete cache[serviceName];
            }
            throw err;
          } finally {
            path.shift();
          }
        }
      }
      function injectionArgs(fn, locals, serviceName) {
        var args = [],
          $inject = createInjector.$$annotate(fn, strictDi, serviceName);
        for (var i = 0, length = $inject.length; i < length; i++) {
          var key = $inject[i];
          if (typeof key !== 'string') {
            throw $injectorMinErr('itkn', 'Incorrect injection token! Expected service name as string, got {0}', key);
          }
          args.push(locals && locals.hasOwnProperty(key) ? locals[key] : getService(key, serviceName));
        }
        return args;
      }
      function isClass(func) {
        // Support: IE 9-11 only
        // IE 9-11 do not support classes and IE9 leaks with the code below.
        if (msie || typeof func !== 'function') {
          return false;
        }
        var result = func.$$ngIsClass;
        if (!isBoolean(result)) {
          result = func.$$ngIsClass = /^class\b/.test(stringifyFn(func));
        }
        return result;
      }
      function invoke(fn, self, locals, serviceName) {
        if (typeof locals === 'string') {
          serviceName = locals;
          locals = null;
        }
        var args = injectionArgs(fn, locals, serviceName);
        if (isArray(fn)) {
          fn = fn[fn.length - 1];
        }
        if (!isClass(fn)) {
          // http://jsperf.com/angularjs-invoke-apply-vs-switch
          // #5388
          return fn.apply(self, args);
        } else {
          args.unshift(null);
          return new (Function.prototype.bind.apply(fn, args))();
        }
      }
      function instantiate(Type, locals, serviceName) {
        // Check if Type is annotated and use just the given function at n-1 as parameter
        // e.g. someModule.factory('greeter', ['$window', function(renamed$window) {}]);
        var ctor = isArray(Type) ? Type[Type.length - 1] : Type;
        var args = injectionArgs(Type, locals, serviceName);
        // Empty object at position 0 is ignored for invocation with `new`, but required.
        args.unshift(null);
        return new (Function.prototype.bind.apply(ctor, args))();
      }
      return {
        invoke: invoke,
        instantiate: instantiate,
        get: getService,
        annotate: createInjector.$$annotate,
        has: function has(name) {
          return providerCache.hasOwnProperty(name + providerSuffix) || cache.hasOwnProperty(name);
        }
      };
    }
  }
  createInjector.$$annotate = annotate;

  /**
   * @ngdoc provider
   * @name $anchorScrollProvider
   * @this
   *
   * @description
   * Use `$anchorScrollProvider` to disable automatic scrolling whenever
   * {@link ng.$location#hash $location.hash()} changes.
   */
  function $AnchorScrollProvider() {
    var autoScrollingEnabled = true;

    /**
     * @ngdoc method
     * @name $anchorScrollProvider#disableAutoScrolling
     *
     * @description
     * By default, {@link ng.$anchorScroll $anchorScroll()} will automatically detect changes to
     * {@link ng.$location#hash $location.hash()} and scroll to the element matching the new hash.<br />
     * Use this method to disable automatic scrolling.
     *
     * If automatic scrolling is disabled, one must explicitly call
     * {@link ng.$anchorScroll $anchorScroll()} in order to scroll to the element related to the
     * current hash.
     */
    this.disableAutoScrolling = function () {
      autoScrollingEnabled = false;
    };

    /**
     * @ngdoc service
     * @name $anchorScroll
     * @kind function
     * @requires $window
     * @requires $location
     * @requires $rootScope
     *
     * @description
     * When called, it scrolls to the element related to the specified `hash` or (if omitted) to the
     * current value of {@link ng.$location#hash $location.hash()}, according to the rules specified
     * in the
     * [HTML5 spec](http://www.w3.org/html/wg/drafts/html/master/browsers.html#an-indicated-part-of-the-document).
     *
     * It also watches the {@link ng.$location#hash $location.hash()} and automatically scrolls to
     * match any anchor whenever it changes. This can be disabled by calling
     * {@link ng.$anchorScrollProvider#disableAutoScrolling $anchorScrollProvider.disableAutoScrolling()}.
     *
     * Additionally, you can use its {@link ng.$anchorScroll#yOffset yOffset} property to specify a
     * vertical scroll-offset (either fixed or dynamic).
     *
     * @param {string=} hash The hash specifying the element to scroll to. If omitted, the value of
     *                       {@link ng.$location#hash $location.hash()} will be used.
     *
     * @property {(number|function|jqLite)} yOffset
     * If set, specifies a vertical scroll-offset. This is often useful when there are fixed
     * positioned elements at the top of the page, such as navbars, headers etc.
     *
     * `yOffset` can be specified in various ways:
     * - **number**: A fixed number of pixels to be used as offset.<br /><br />
     * - **function**: A getter function called everytime `$anchorScroll()` is executed. Must return
     *   a number representing the offset (in pixels).<br /><br />
     * - **jqLite**: A jqLite/jQuery element to be used for specifying the offset. The distance from
     *   the top of the page to the element's bottom will be used as offset.<br />
     *   **Note**: The element will be taken into account only as long as its `position` is set to
     *   `fixed`. This option is useful, when dealing with responsive navbars/headers that adjust
     *   their height and/or positioning according to the viewport's size.
     *
     * <br />
     * <div class="alert alert-warning">
     * In order for `yOffset` to work properly, scrolling should take place on the document's root and
     * not some child element.
     * </div>
     *
     * @example
       <example module="anchorScrollExample" name="anchor-scroll">
         <file name="index.html">
           <div id="scrollArea" ng-controller="ScrollController">
             <a ng-click="gotoBottom()">Go to bottom</a>
             <a id="bottom"></a> You're at the bottom!
           </div>
         </file>
         <file name="script.js">
           angular.module('anchorScrollExample', [])
             .controller('ScrollController', ['$scope', '$location', '$anchorScroll',
               function($scope, $location, $anchorScroll) {
                 $scope.gotoBottom = function() {
                   // set the location.hash to the id of
                   // the element you wish to scroll to.
                   $location.hash('bottom');
                    // call $anchorScroll()
                   $anchorScroll();
                 };
               }]);
         </file>
         <file name="style.css">
           #scrollArea {
             height: 280px;
             overflow: auto;
           }
            #bottom {
             display: block;
             margin-top: 2000px;
           }
         </file>
       </example>
     *
     * <hr />
     * The example below illustrates the use of a vertical scroll-offset (specified as a fixed value).
     * See {@link ng.$anchorScroll#yOffset $anchorScroll.yOffset} for more details.
     *
     * @example
       <example module="anchorScrollOffsetExample" name="anchor-scroll-offset">
         <file name="index.html">
           <div class="fixed-header" ng-controller="headerCtrl">
             <a href="" ng-click="gotoAnchor(x)" ng-repeat="x in [1,2,3,4,5]">
               Go to anchor {{x}}
             </a>
           </div>
           <div id="anchor{{x}}" class="anchor" ng-repeat="x in [1,2,3,4,5]">
             Anchor {{x}} of 5
           </div>
         </file>
         <file name="script.js">
           angular.module('anchorScrollOffsetExample', [])
             .run(['$anchorScroll', function($anchorScroll) {
               $anchorScroll.yOffset = 50;   // always scroll by 50 extra pixels
             }])
             .controller('headerCtrl', ['$anchorScroll', '$location', '$scope',
               function($anchorScroll, $location, $scope) {
                 $scope.gotoAnchor = function(x) {
                   var newHash = 'anchor' + x;
                   if ($location.hash() !== newHash) {
                     // set the $location.hash to `newHash` and
                     // $anchorScroll will automatically scroll to it
                     $location.hash('anchor' + x);
                   } else {
                     // call $anchorScroll() explicitly,
                     // since $location.hash hasn't changed
                     $anchorScroll();
                   }
                 };
               }
             ]);
         </file>
         <file name="style.css">
           body {
             padding-top: 50px;
           }
            .anchor {
             border: 2px dashed DarkOrchid;
             padding: 10px 10px 200px 10px;
           }
            .fixed-header {
             background-color: rgba(0, 0, 0, 0.2);
             height: 50px;
             position: fixed;
             top: 0; left: 0; right: 0;
           }
            .fixed-header > a {
             display: inline-block;
             margin: 5px 15px;
           }
         </file>
       </example>
     */
    this.$get = ['$window', '$location', '$rootScope', function ($window, $location, $rootScope) {
      var document = $window.document;

      // Helper function to get first anchor from a NodeList
      // (using `Array#some()` instead of `angular#forEach()` since it's more performant
      //  and working in all supported browsers.)
      function getFirstAnchor(list) {
        var result = null;
        Array.prototype.some.call(list, function (element) {
          if (nodeName_(element) === 'a') {
            result = element;
            return true;
          }
        });
        return result;
      }
      function getYOffset() {
        var offset = scroll.yOffset;
        if (isFunction(offset)) {
          offset = offset();
        } else if (isElement(offset)) {
          var elem = offset[0];
          var style = $window.getComputedStyle(elem);
          if (style.position !== 'fixed') {
            offset = 0;
          } else {
            offset = elem.getBoundingClientRect().bottom;
          }
        } else if (!isNumber(offset)) {
          offset = 0;
        }
        return offset;
      }
      function scrollTo(elem) {
        if (elem) {
          elem.scrollIntoView();
          var offset = getYOffset();
          if (offset) {
            // `offset` is the number of pixels we should scroll UP in order to align `elem` properly.
            // This is true ONLY if the call to `elem.scrollIntoView()` initially aligns `elem` at the
            // top of the viewport.
            //
            // IF the number of pixels from the top of `elem` to the end of the page's content is less
            // than the height of the viewport, then `elem.scrollIntoView()` will align the `elem` some
            // way down the page.
            //
            // This is often the case for elements near the bottom of the page.
            //
            // In such cases we do not need to scroll the whole `offset` up, just the difference between
            // the top of the element and the offset, which is enough to align the top of `elem` at the
            // desired position.
            var elemTop = elem.getBoundingClientRect().top;
            $window.scrollBy(0, elemTop - offset);
          }
        } else {
          $window.scrollTo(0, 0);
        }
      }
      function scroll(hash) {
        // Allow numeric hashes
        hash = isString(hash) ? hash : isNumber(hash) ? hash.toString() : $location.hash();
        var elm;

        // empty hash, scroll to the top of the page
        if (!hash) scrollTo(null);

        // element with given id
        else if (elm = document.getElementById(hash)) scrollTo(elm);

        // first anchor with given name :-D
        else if (elm = getFirstAnchor(document.getElementsByName(hash))) scrollTo(elm);

        // no element and hash === 'top', scroll to the top of the page
        else if (hash === 'top') scrollTo(null);
      }

      // does not scroll when user clicks on anchor link that is currently on
      // (no url change, no $location.hash() change), browser native does scroll
      if (autoScrollingEnabled) {
        $rootScope.$watch(function autoScrollWatch() {
          return $location.hash();
        }, function autoScrollWatchAction(newVal, oldVal) {
          // skip the initial scroll if $location.hash is empty
          if (newVal === oldVal && newVal === '') return;
          jqLiteDocumentLoaded(function () {
            $rootScope.$evalAsync(scroll);
          });
        });
      }
      return scroll;
    }];
  }
  var $animateMinErr = minErr('$animate');
  var ELEMENT_NODE = 1;
  var NG_ANIMATE_CLASSNAME = 'ng-animate';
  function mergeClasses(a, b) {
    if (!a && !b) return '';
    if (!a) return b;
    if (!b) return a;
    if (isArray(a)) a = a.join(' ');
    if (isArray(b)) b = b.join(' ');
    return a + ' ' + b;
  }
  function extractElementNode(element) {
    for (var i = 0; i < element.length; i++) {
      var elm = element[i];
      if (elm.nodeType === ELEMENT_NODE) {
        return elm;
      }
    }
  }
  function splitClasses(classes) {
    if (isString(classes)) {
      classes = classes.split(' ');
    }

    // Use createMap() to prevent class assumptions involving property names in
    // Object.prototype
    var obj = createMap();
    forEach(classes, function (klass) {
      // sometimes the split leaves empty string values
      // incase extra spaces were applied to the options
      if (klass.length) {
        obj[klass] = true;
      }
    });
    return obj;
  }

  // if any other type of options value besides an Object value is
  // passed into the $animate.method() animation then this helper code
  // will be run which will ignore it. While this patch is not the
  // greatest solution to this, a lot of existing plugins depend on
  // $animate to either call the callback (< 1.2) or return a promise
  // that can be changed. This helper function ensures that the options
  // are wiped clean incase a callback function is provided.
  function prepareAnimateOptions(options) {
    return isObject(options) ? options : {};
  }
  var $$CoreAnimateJsProvider = /** @this */function $$CoreAnimateJsProvider() {
    this.$get = noop;
  };

  // this is prefixed with Core since it conflicts with
  // the animateQueueProvider defined in ngAnimate/animateQueue.js
  var $$CoreAnimateQueueProvider = /** @this */function $$CoreAnimateQueueProvider() {
    var postDigestQueue = new NgMap();
    var postDigestElements = [];
    this.$get = ['$$AnimateRunner', '$rootScope', function ($$AnimateRunner, $rootScope) {
      return {
        enabled: noop,
        on: noop,
        off: noop,
        pin: noop,
        push: function push(element, event, options, domOperation) {
          if (domOperation) {
            domOperation();
          }
          options = options || {};
          if (options.from) {
            element.css(options.from);
          }
          if (options.to) {
            element.css(options.to);
          }
          if (options.addClass || options.removeClass) {
            addRemoveClassesPostDigest(element, options.addClass, options.removeClass);
          }
          var runner = new $$AnimateRunner();

          // since there are no animations to run the runner needs to be
          // notified that the animation call is complete.
          runner.complete();
          return runner;
        }
      };
      function updateData(data, classes, value) {
        var changed = false;
        if (classes) {
          classes = isString(classes) ? classes.split(' ') : isArray(classes) ? classes : [];
          forEach(classes, function (className) {
            if (className) {
              changed = true;
              data[className] = value;
            }
          });
        }
        return changed;
      }
      function handleCSSClassChanges() {
        forEach(postDigestElements, function (element) {
          var data = postDigestQueue.get(element);
          if (data) {
            var existing = splitClasses(element.attr('class'));
            var toAdd = '';
            var toRemove = '';
            forEach(data, function (status, className) {
              var hasClass = !!existing[className];
              if (status !== hasClass) {
                if (status) {
                  toAdd += (toAdd.length ? ' ' : '') + className;
                } else {
                  toRemove += (toRemove.length ? ' ' : '') + className;
                }
              }
            });
            forEach(element, function (elm) {
              if (toAdd) {
                jqLiteAddClass(elm, toAdd);
              }
              if (toRemove) {
                jqLiteRemoveClass(elm, toRemove);
              }
            });
            postDigestQueue["delete"](element);
          }
        });
        postDigestElements.length = 0;
      }
      function addRemoveClassesPostDigest(element, add, remove) {
        var data = postDigestQueue.get(element) || {};
        var classesAdded = updateData(data, add, true);
        var classesRemoved = updateData(data, remove, false);
        if (classesAdded || classesRemoved) {
          postDigestQueue.set(element, data);
          postDigestElements.push(element);
          if (postDigestElements.length === 1) {
            $rootScope.$$postDigest(handleCSSClassChanges);
          }
        }
      }
    }];
  };

  /**
   * @ngdoc provider
   * @name $animateProvider
   *
   * @description
   * Default implementation of $animate that doesn't perform any animations, instead just
   * synchronously performs DOM updates and resolves the returned runner promise.
   *
   * In order to enable animations the `ngAnimate` module has to be loaded.
   *
   * To see the functional implementation check out `src/ngAnimate/animate.js`.
   */
  var $AnimateProvider = ['$provide', /** @this */function ($provide) {
    var provider = this;
    var classNameFilter = null;
    var customFilter = null;
    this.$$registeredAnimations = Object.create(null);

    /**
    * @ngdoc method
    * @name $animateProvider#register
    *
    * @description
    * Registers a new injectable animation factory function. The factory function produces the
    * animation object which contains callback functions for each event that is expected to be
    * animated.
    *
    *   * `eventFn`: `function(element, ... , doneFunction, options)`
    *   The element to animate, the `doneFunction` and the options fed into the animation. Depending
    *   on the type of animation additional arguments will be injected into the animation function. The
    *   list below explains the function signatures for the different animation methods:
    *
    *   - setClass: function(element, addedClasses, removedClasses, doneFunction, options)
    *   - addClass: function(element, addedClasses, doneFunction, options)
    *   - removeClass: function(element, removedClasses, doneFunction, options)
    *   - enter, leave, move: function(element, doneFunction, options)
    *   - animate: function(element, fromStyles, toStyles, doneFunction, options)
    *
    *   Make sure to trigger the `doneFunction` once the animation is fully complete.
    *
    * ```js
    *   return {
    *     //enter, leave, move signature
    *     eventFn : function(element, done, options) {
    *       //code to run the animation
    *       //once complete, then run done()
    *       return function endFunction(wasCancelled) {
    *         //code to cancel the animation
    *       }
    *     }
    *   }
    * ```
    *
    * @param {string} name The name of the animation (this is what the class-based CSS value will be compared to).
    * @param {Function} factory The factory function that will be executed to return the animation
    *                           object.
    */
    this.register = function (name, factory) {
      if (name && name.charAt(0) !== '.') {
        throw $animateMinErr('notcsel', 'Expecting class selector starting with \'.\' got \'{0}\'.', name);
      }
      var key = name + '-animation';
      provider.$$registeredAnimations[name.substr(1)] = key;
      $provide.factory(key, factory);
    };

    /**
     * @ngdoc method
     * @name $animateProvider#customFilter
     *
     * @description
     * Sets and/or returns the custom filter function that is used to "filter" animations, i.e.
     * determine if an animation is allowed or not. When no filter is specified (the default), no
     * animation will be blocked. Setting the `customFilter` value will only allow animations for
     * which the filter function's return value is truthy.
     *
     * This allows to easily create arbitrarily complex rules for filtering animations, such as
     * allowing specific events only, or enabling animations on specific subtrees of the DOM, etc.
     * Filtering animations can also boost performance for low-powered devices, as well as
     * applications containing a lot of structural operations.
     *
     * <div class="alert alert-success">
     *   **Best Practice:**
     *   Keep the filtering function as lean as possible, because it will be called for each DOM
     *   action (e.g. insertion, removal, class change) performed by "animation-aware" directives.
     *   See {@link guide/animations#which-directives-support-animations- here} for a list of built-in
     *   directives that support animations.
     *   Performing computationally expensive or time-consuming operations on each call of the
     *   filtering function can make your animations sluggish.
     * </div>
     *
     * **Note:** If present, `customFilter` will be checked before
     * {@link $animateProvider#classNameFilter classNameFilter}.
     *
     * @param {Function=} filterFn - The filter function which will be used to filter all animations.
     *   If a falsy value is returned, no animation will be performed. The function will be called
     *   with the following arguments:
     *   - **node** `{DOMElement}` - The DOM element to be animated.
     *   - **event** `{String}` - The name of the animation event (e.g. `enter`, `leave`, `addClass`
     *     etc).
     *   - **options** `{Object}` - A collection of options/styles used for the animation.
     * @return {Function} The current filter function or `null` if there is none set.
     */
    this.customFilter = function (filterFn) {
      if (arguments.length === 1) {
        customFilter = isFunction(filterFn) ? filterFn : null;
      }
      return customFilter;
    };

    /**
     * @ngdoc method
     * @name $animateProvider#classNameFilter
     *
     * @description
     * Sets and/or returns the CSS class regular expression that is checked when performing
     * an animation. Upon bootstrap the classNameFilter value is not set at all and will
     * therefore enable $animate to attempt to perform an animation on any element that is triggered.
     * When setting the `classNameFilter` value, animations will only be performed on elements
     * that successfully match the filter expression. This in turn can boost performance
     * for low-powered devices as well as applications containing a lot of structural operations.
     *
     * **Note:** If present, `classNameFilter` will be checked after
     * {@link $animateProvider#customFilter customFilter}. If `customFilter` is present and returns
     * false, `classNameFilter` will not be checked.
     *
     * @param {RegExp=} expression The className expression which will be checked against all animations
     * @return {RegExp} The current CSS className expression value. If null then there is no expression value
     */
    this.classNameFilter = function (expression) {
      if (arguments.length === 1) {
        classNameFilter = expression instanceof RegExp ? expression : null;
        if (classNameFilter) {
          var reservedRegex = new RegExp('[(\\s|\\/)]' + NG_ANIMATE_CLASSNAME + '[(\\s|\\/)]');
          if (reservedRegex.test(classNameFilter.toString())) {
            classNameFilter = null;
            throw $animateMinErr('nongcls', '$animateProvider.classNameFilter(regex) prohibits accepting a regex value which matches/contains the "{0}" CSS class.', NG_ANIMATE_CLASSNAME);
          }
        }
      }
      return classNameFilter;
    };
    this.$get = ['$$animateQueue', function ($$animateQueue) {
      function domInsert(element, parentElement, afterElement) {
        // if for some reason the previous element was removed
        // from the dom sometime before this code runs then let's
        // just stick to using the parent element as the anchor
        if (afterElement) {
          var afterNode = extractElementNode(afterElement);
          if (afterNode && !afterNode.parentNode && !afterNode.previousElementSibling) {
            afterElement = null;
          }
        }
        if (afterElement) {
          afterElement.after(element);
        } else {
          parentElement.prepend(element);
        }
      }

      /**
       * @ngdoc service
       * @name $animate
       * @description The $animate service exposes a series of DOM utility methods that provide support
       * for animation hooks. The default behavior is the application of DOM operations, however,
       * when an animation is detected (and animations are enabled), $animate will do the heavy lifting
       * to ensure that animation runs with the triggered DOM operation.
       *
       * By default $animate doesn't trigger any animations. This is because the `ngAnimate` module isn't
       * included and only when it is active then the animation hooks that `$animate` triggers will be
       * functional. Once active then all structural `ng-` directives will trigger animations as they perform
       * their DOM-related operations (enter, leave and move). Other directives such as `ngClass`,
       * `ngShow`, `ngHide` and `ngMessages` also provide support for animations.
       *
       * It is recommended that the`$animate` service is always used when executing DOM-related procedures within directives.
       *
       * To learn more about enabling animation support, click here to visit the
       * {@link ngAnimate ngAnimate module page}.
       */
      return {
        // we don't call it directly since non-existant arguments may
        // be interpreted as null within the sub enabled function

        /**
         *
         * @ngdoc method
         * @name $animate#on
         * @kind function
         * @description Sets up an event listener to fire whenever the animation event (enter, leave, move, etc...)
         *    has fired on the given element or among any of its children. Once the listener is fired, the provided callback
         *    is fired with the following params:
         *
         * ```js
         * $animate.on('enter', container,
         *    function callback(element, phase) {
         *      // cool we detected an enter animation within the container
         *    }
         * );
         * ```
         *
         * <div class="alert alert-warning">
         * **Note**: Generally, the events that are fired correspond 1:1 to `$animate` method names,
         * e.g. {@link ng.$animate#addClass addClass()} will fire `addClass`, and {@link ng.ngClass}
         * will fire `addClass` if classes are added, and `removeClass` if classes are removed.
         * However, there are two exceptions:
         *
         * <ul>
         *   <li>if both an {@link ng.$animate#addClass addClass()} and a
         *   {@link ng.$animate#removeClass removeClass()} action are performed during the same
         *   animation, the event fired will be `setClass`. This is true even for `ngClass`.</li>
         *   <li>an {@link ng.$animate#animate animate()} call that adds and removes classes will fire
         *   the `setClass` event, but if it either removes or adds classes,
         *   it will fire `animate` instead.</li>
         * </ul>
         *
         * </div>
         *
         * @param {string} event the animation event that will be captured (e.g. enter, leave, move, addClass, removeClass, etc...)
         * @param {DOMElement} container the container element that will capture each of the animation events that are fired on itself
         *     as well as among its children
         * @param {Function} callback the callback function that will be fired when the listener is triggered.
         *
         * The arguments present in the callback function are:
         * * `element` - The captured DOM element that the animation was fired on.
         * * `phase` - The phase of the animation. The two possible phases are **start** (when the animation starts) and **close** (when it ends).
         * * `data` - an object with these properties:
         *     * addClass - `{string|null}` - space-separated CSS classes to add to the element
         *     * removeClass - `{string|null}` - space-separated CSS classes to remove from the element
         *     * from - `{Object|null}` - CSS properties & values at the beginning of the animation
         *     * to - `{Object|null}` - CSS properties & values at the end of the animation
         *
         * Note that the callback does not trigger a scope digest. Wrap your call into a
         * {@link $rootScope.Scope#$apply scope.$apply} to propagate changes to the scope.
         */
        on: $$animateQueue.on,
        /**
         *
         * @ngdoc method
         * @name $animate#off
         * @kind function
         * @description Deregisters an event listener based on the event which has been associated with the provided element. This method
         * can be used in three different ways depending on the arguments:
         *
         * ```js
         * // remove all the animation event listeners listening for `enter`
         * $animate.off('enter');
         *
         * // remove listeners for all animation events from the container element
         * $animate.off(container);
         *
         * // remove all the animation event listeners listening for `enter` on the given element and its children
         * $animate.off('enter', container);
         *
         * // remove the event listener function provided by `callback` that is set
         * // to listen for `enter` on the given `container` as well as its children
         * $animate.off('enter', container, callback);
         * ```
         *
         * @param {string|DOMElement} event|container the animation event (e.g. enter, leave, move,
         * addClass, removeClass, etc...), or the container element. If it is the element, all other
         * arguments are ignored.
         * @param {DOMElement=} container the container element the event listener was placed on
         * @param {Function=} callback the callback function that was registered as the listener
         */
        off: $$animateQueue.off,
        /**
         * @ngdoc method
         * @name $animate#pin
         * @kind function
         * @description Associates the provided element with a host parent element to allow the element to be animated even if it exists
         *    outside of the DOM structure of the AngularJS application. By doing so, any animation triggered via `$animate` can be issued on the
         *    element despite being outside the realm of the application or within another application. Say for example if the application
         *    was bootstrapped on an element that is somewhere inside of the `<body>` tag, but we wanted to allow for an element to be situated
         *    as a direct child of `document.body`, then this can be achieved by pinning the element via `$animate.pin(element)`. Keep in mind
         *    that calling `$animate.pin(element, parentElement)` will not actually insert into the DOM anywhere; it will just create the association.
         *
         *    Note that this feature is only active when the `ngAnimate` module is used.
         *
         * @param {DOMElement} element the external element that will be pinned
         * @param {DOMElement} parentElement the host parent element that will be associated with the external element
         */
        pin: $$animateQueue.pin,
        /**
         *
         * @ngdoc method
         * @name $animate#enabled
         * @kind function
         * @description Used to get and set whether animations are enabled or not on the entire application or on an element and its children. This
         * function can be called in four ways:
         *
         * ```js
         * // returns true or false
         * $animate.enabled();
         *
         * // changes the enabled state for all animations
         * $animate.enabled(false);
         * $animate.enabled(true);
         *
         * // returns true or false if animations are enabled for an element
         * $animate.enabled(element);
         *
         * // changes the enabled state for an element and its children
         * $animate.enabled(element, true);
         * $animate.enabled(element, false);
         * ```
         *
         * @param {DOMElement=} element the element that will be considered for checking/setting the enabled state
         * @param {boolean=} enabled whether or not the animations will be enabled for the element
         *
         * @return {boolean} whether or not animations are enabled
         */
        enabled: $$animateQueue.enabled,
        /**
         * @ngdoc method
         * @name $animate#cancel
         * @kind function
         * @description Cancels the provided animation and applies the end state of the animation.
         * Note that this does not cancel the underlying operation, e.g. the setting of classes or
         * adding the element to the DOM.
         *
         * @param {animationRunner} animationRunner An animation runner returned by an $animate function.
         *
         * @example
          <example module="animationExample" deps="angular-animate.js" animations="true" name="animate-cancel">
            <file name="app.js">
              angular.module('animationExample', ['ngAnimate']).component('cancelExample', {
                templateUrl: 'template.html',
                controller: function($element, $animate) {
                  this.runner = null;
                   this.addClass = function() {
                    this.runner = $animate.addClass($element.find('div'), 'red');
                    var ctrl = this;
                    this.runner.finally(function() {
                      ctrl.runner = null;
                    });
                  };
                   this.removeClass = function() {
                    this.runner = $animate.removeClass($element.find('div'), 'red');
                    var ctrl = this;
                    this.runner.finally(function() {
                      ctrl.runner = null;
                    });
                  };
                   this.cancel = function() {
                    $animate.cancel(this.runner);
                  };
                }
              });
            </file>
            <file name="template.html">
              <p>
                <button id="add" ng-click="$ctrl.addClass()">Add</button>
                <button ng-click="$ctrl.removeClass()">Remove</button>
                <br>
                <button id="cancel" ng-click="$ctrl.cancel()" ng-disabled="!$ctrl.runner">Cancel</button>
                <br>
                <div id="target">CSS-Animated Text</div>
              </p>
            </file>
            <file name="index.html">
              <cancel-example></cancel-example>
            </file>
            <file name="style.css">
              .red-add, .red-remove {
                transition: all 4s cubic-bezier(0.250, 0.460, 0.450, 0.940);
              }
               .red,
              .red-add.red-add-active {
                color: #FF0000;
                font-size: 40px;
              }
               .red-remove.red-remove-active {
                font-size: 10px;
                color: black;
              }
             </file>
          </example>
         */
        cancel: function cancel(runner) {
          if (runner.cancel) {
            runner.cancel();
          }
        },
        /**
         *
         * @ngdoc method
         * @name $animate#enter
         * @kind function
         * @description Inserts the element into the DOM either after the `after` element (if provided) or
         *   as the first child within the `parent` element and then triggers an animation.
         *   A promise is returned that will be resolved during the next digest once the animation
         *   has completed.
         *
         * @param {DOMElement} element the element which will be inserted into the DOM
         * @param {DOMElement} parent the parent element which will append the element as
         *   a child (so long as the after element is not present)
         * @param {DOMElement=} after the sibling element after which the element will be appended
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Runner} the animation runner
         */
        enter: function enter(element, parent, after, options) {
          parent = parent && jqLite(parent);
          after = after && jqLite(after);
          parent = parent || after.parent();
          domInsert(element, parent, after);
          return $$animateQueue.push(element, 'enter', prepareAnimateOptions(options));
        },
        /**
         *
         * @ngdoc method
         * @name $animate#move
         * @kind function
         * @description Inserts (moves) the element into its new position in the DOM either after
         *   the `after` element (if provided) or as the first child within the `parent` element
         *   and then triggers an animation. A promise is returned that will be resolved
         *   during the next digest once the animation has completed.
         *
         * @param {DOMElement} element the element which will be moved into the new DOM position
         * @param {DOMElement} parent the parent element which will append the element as
         *   a child (so long as the after element is not present)
         * @param {DOMElement=} after the sibling element after which the element will be appended
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Runner} the animation runner
         */
        move: function move(element, parent, after, options) {
          parent = parent && jqLite(parent);
          after = after && jqLite(after);
          parent = parent || after.parent();
          domInsert(element, parent, after);
          return $$animateQueue.push(element, 'move', prepareAnimateOptions(options));
        },
        /**
         * @ngdoc method
         * @name $animate#leave
         * @kind function
         * @description Triggers an animation and then removes the element from the DOM.
         * When the function is called a promise is returned that will be resolved during the next
         * digest once the animation has completed.
         *
         * @param {DOMElement} element the element which will be removed from the DOM
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Runner} the animation runner
         */
        leave: function leave(element, options) {
          return $$animateQueue.push(element, 'leave', prepareAnimateOptions(options), function () {
            element.remove();
          });
        },
        /**
         * @ngdoc method
         * @name $animate#addClass
         * @kind function
         *
         * @description Triggers an addClass animation surrounding the addition of the provided CSS class(es). Upon
         *   execution, the addClass operation will only be handled after the next digest and it will not trigger an
         *   animation if element already contains the CSS class or if the class is removed at a later step.
         *   Note that class-based animations are treated differently compared to structural animations
         *   (like enter, move and leave) since the CSS classes may be added/removed at different points
         *   depending if CSS or JavaScript animations are used.
         *
         * @param {DOMElement} element the element which the CSS classes will be applied to
         * @param {string} className the CSS class(es) that will be added (multiple classes are separated via spaces)
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Runner} animationRunner the animation runner
         */
        addClass: function addClass(element, className, options) {
          options = prepareAnimateOptions(options);
          options.addClass = mergeClasses(options.addclass, className);
          return $$animateQueue.push(element, 'addClass', options);
        },
        /**
         * @ngdoc method
         * @name $animate#removeClass
         * @kind function
         *
         * @description Triggers a removeClass animation surrounding the removal of the provided CSS class(es). Upon
         *   execution, the removeClass operation will only be handled after the next digest and it will not trigger an
         *   animation if element does not contain the CSS class or if the class is added at a later step.
         *   Note that class-based animations are treated differently compared to structural animations
         *   (like enter, move and leave) since the CSS classes may be added/removed at different points
         *   depending if CSS or JavaScript animations are used.
         *
         * @param {DOMElement} element the element which the CSS classes will be applied to
         * @param {string} className the CSS class(es) that will be removed (multiple classes are separated via spaces)
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Runner} the animation runner
         */
        removeClass: function removeClass(element, className, options) {
          options = prepareAnimateOptions(options);
          options.removeClass = mergeClasses(options.removeClass, className);
          return $$animateQueue.push(element, 'removeClass', options);
        },
        /**
         * @ngdoc method
         * @name $animate#setClass
         * @kind function
         *
         * @description Performs both the addition and removal of a CSS classes on an element and (during the process)
         *    triggers an animation surrounding the class addition/removal. Much like `$animate.addClass` and
         *    `$animate.removeClass`, `setClass` will only evaluate the classes being added/removed once a digest has
         *    passed. Note that class-based animations are treated differently compared to structural animations
         *    (like enter, move and leave) since the CSS classes may be added/removed at different points
         *    depending if CSS or JavaScript animations are used.
         *
         * @param {DOMElement} element the element which the CSS classes will be applied to
         * @param {string} add the CSS class(es) that will be added (multiple classes are separated via spaces)
         * @param {string} remove the CSS class(es) that will be removed (multiple classes are separated via spaces)
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Runner} the animation runner
         */
        setClass: function setClass(element, add, remove, options) {
          options = prepareAnimateOptions(options);
          options.addClass = mergeClasses(options.addClass, add);
          options.removeClass = mergeClasses(options.removeClass, remove);
          return $$animateQueue.push(element, 'setClass', options);
        },
        /**
         * @ngdoc method
         * @name $animate#animate
         * @kind function
         *
         * @description Performs an inline animation on the element which applies the provided to and from CSS styles to the element.
         * If any detected CSS transition, keyframe or JavaScript matches the provided className value, then the animation will take
         * on the provided styles. For example, if a transition animation is set for the given className, then the provided `from` and
         * `to` styles will be applied alongside the given transition. If the CSS style provided in `from` does not have a corresponding
         * style in `to`, the style in `from` is applied immediately, and no animation is run.
         * If a JavaScript animation is detected then the provided styles will be given in as function parameters into the `animate`
         * method (or as part of the `options` parameter):
         *
         * ```js
         * ngModule.animation('.my-inline-animation', function() {
         *   return {
         *     animate : function(element, from, to, done, options) {
         *       //animation
         *       done();
         *     }
         *   }
         * });
         * ```
         *
         * @param {DOMElement} element the element which the CSS styles will be applied to
         * @param {object} from the from (starting) CSS styles that will be applied to the element and across the animation.
         * @param {object} to the to (destination) CSS styles that will be applied to the element and across the animation.
         * @param {string=} className an optional CSS class that will be applied to the element for the duration of the animation. If
         *    this value is left as empty then a CSS class of `ng-inline-animate` will be applied to the element.
         *    (Note that if no animation is detected then this value will not be applied to the element.)
         * @param {object=} options an optional collection of options/styles that will be applied to the element.
         *   The object can have the following properties:
         *
         *   - **addClass** - `{string}` - space-separated CSS classes to add to element
         *   - **from** - `{Object}` - CSS properties & values at the beginning of animation. Must have matching `to`
         *   - **removeClass** - `{string}` - space-separated CSS classes to remove from element
         *   - **to** - `{Object}` - CSS properties & values at end of animation. Must have matching `from`
         *
         * @return {Runner} the animation runner
         */
        animate: function animate(element, from, to, className, options) {
          options = prepareAnimateOptions(options);
          options.from = options.from ? extend(options.from, from) : from;
          options.to = options.to ? extend(options.to, to) : to;
          className = className || 'ng-inline-animate';
          options.tempClasses = mergeClasses(options.tempClasses, className);
          return $$animateQueue.push(element, 'animate', options);
        }
      };
    }];
  }];
  var $$AnimateAsyncRunFactoryProvider = /** @this */function $$AnimateAsyncRunFactoryProvider() {
    this.$get = ['$$rAF', function ($$rAF) {
      var waitQueue = [];
      function waitForTick(fn) {
        waitQueue.push(fn);
        if (waitQueue.length > 1) return;
        $$rAF(function () {
          for (var i = 0; i < waitQueue.length; i++) {
            waitQueue[i]();
          }
          waitQueue = [];
        });
      }
      return function () {
        var passed = false;
        waitForTick(function () {
          passed = true;
        });
        return function (callback) {
          if (passed) {
            callback();
          } else {
            waitForTick(callback);
          }
        };
      };
    }];
  };
  var $$AnimateRunnerFactoryProvider = /** @this */function $$AnimateRunnerFactoryProvider() {
    this.$get = ['$q', '$sniffer', '$$animateAsyncRun', '$$isDocumentHidden', '$timeout', function ($q, $sniffer, $$animateAsyncRun, $$isDocumentHidden, $timeout) {
      var INITIAL_STATE = 0;
      var DONE_PENDING_STATE = 1;
      var DONE_COMPLETE_STATE = 2;
      AnimateRunner.chain = function (chain, callback) {
        var index = 0;
        next();
        function next() {
          if (index === chain.length) {
            callback(true);
            return;
          }
          chain[index](function (response) {
            if (response === false) {
              callback(false);
              return;
            }
            index++;
            next();
          });
        }
      };
      AnimateRunner.all = function (runners, callback) {
        var count = 0;
        var status = true;
        forEach(runners, function (runner) {
          runner.done(onProgress);
        });
        function onProgress(response) {
          status = status && response;
          if (++count === runners.length) {
            callback(status);
          }
        }
      };
      function AnimateRunner(host) {
        this.setHost(host);
        var rafTick = $$animateAsyncRun();
        var timeoutTick = function timeoutTick(fn) {
          $timeout(fn, 0, false);
        };
        this._doneCallbacks = [];
        this._tick = function (fn) {
          if ($$isDocumentHidden()) {
            timeoutTick(fn);
          } else {
            rafTick(fn);
          }
        };
        this._state = 0;
      }
      AnimateRunner.prototype = {
        setHost: function setHost(host) {
          this.host = host || {};
        },
        done: function done(fn) {
          if (this._state === DONE_COMPLETE_STATE) {
            fn();
          } else {
            this._doneCallbacks.push(fn);
          }
        },
        progress: noop,
        getPromise: function getPromise() {
          if (!this.promise) {
            var self = this;
            this.promise = $q(function (resolve, reject) {
              self.done(function (status) {
                if (status === false) {
                  reject();
                } else {
                  resolve();
                }
              });
            });
          }
          return this.promise;
        },
        then: function then(resolveHandler, rejectHandler) {
          return this.getPromise().then(resolveHandler, rejectHandler);
        },
        'catch': function _catch(handler) {
          return this.getPromise()['catch'](handler);
        },
        'finally': function _finally(handler) {
          return this.getPromise()['finally'](handler);
        },
        pause: function pause() {
          if (this.host.pause) {
            this.host.pause();
          }
        },
        resume: function resume() {
          if (this.host.resume) {
            this.host.resume();
          }
        },
        end: function end() {
          if (this.host.end) {
            this.host.end();
          }
          this._resolve(true);
        },
        cancel: function cancel() {
          if (this.host.cancel) {
            this.host.cancel();
          }
          this._resolve(false);
        },
        complete: function complete(response) {
          var self = this;
          if (self._state === INITIAL_STATE) {
            self._state = DONE_PENDING_STATE;
            self._tick(function () {
              self._resolve(response);
            });
          }
        },
        _resolve: function _resolve(response) {
          if (this._state !== DONE_COMPLETE_STATE) {
            forEach(this._doneCallbacks, function (fn) {
              fn(response);
            });
            this._doneCallbacks.length = 0;
            this._state = DONE_COMPLETE_STATE;
          }
        }
      };
      return AnimateRunner;
    }];
  };

  /* exported $CoreAnimateCssProvider */

  /**
   * @ngdoc service
   * @name $animateCss
   * @kind object
   * @this
   *
   * @description
   * This is the core version of `$animateCss`. By default, only when the `ngAnimate` is included,
   * then the `$animateCss` service will actually perform animations.
   *
   * Click here {@link ngAnimate.$animateCss to read the documentation for $animateCss}.
   */
  var $CoreAnimateCssProvider = function $CoreAnimateCssProvider() {
    this.$get = ['$$rAF', '$q', '$$AnimateRunner', function ($$rAF, $q, $$AnimateRunner) {
      return function (element, initialOptions) {
        // all of the animation functions should create
        // a copy of the options data, however, if a
        // parent service has already created a copy then
        // we should stick to using that
        var options = initialOptions || {};
        if (!options.$$prepared) {
          options = copy(options);
        }

        // there is no point in applying the styles since
        // there is no animation that goes on at all in
        // this version of $animateCss.
        if (options.cleanupStyles) {
          options.from = options.to = null;
        }
        if (options.from) {
          element.css(options.from);
          options.from = null;
        }
        var closed,
          runner = new $$AnimateRunner();
        return {
          start: run,
          end: run
        };
        function run() {
          $$rAF(function () {
            applyAnimationContents();
            if (!closed) {
              runner.complete();
            }
            closed = true;
          });
          return runner;
        }
        function applyAnimationContents() {
          if (options.addClass) {
            element.addClass(options.addClass);
            options.addClass = null;
          }
          if (options.removeClass) {
            element.removeClass(options.removeClass);
            options.removeClass = null;
          }
          if (options.to) {
            element.css(options.to);
            options.to = null;
          }
        }
      };
    }];
  };

  /* global getHash: true, stripHash: false */

  function getHash(url) {
    var index = url.indexOf('#');
    return index === -1 ? '' : url.substr(index);
  }
  function trimEmptyHash(url) {
    return url.replace(/#$/, '');
  }

  /**
   * ! This is a private undocumented service !
   *
   * @name $browser
   * @requires $log
   * @description
   * This object has two goals:
   *
   * - hide all the global state in the browser caused by the window object
   * - abstract away all the browser specific features and inconsistencies
   *
   * For tests we provide {@link ngMock.$browser mock implementation} of the `$browser`
   * service, which can be used for convenient testing of the application without the interaction with
   * the real browser apis.
   */
  /**
   * @param {object} window The global window object.
   * @param {object} document jQuery wrapped document.
   * @param {object} $log window.console or an object with the same interface.
   * @param {object} $sniffer $sniffer service
   */
  function Browser(window, document, $log, $sniffer, $$taskTrackerFactory) {
    var self = this,
      location = window.location,
      history = window.history,
      setTimeout = window.setTimeout,
      clearTimeout = window.clearTimeout,
      pendingDeferIds = {},
      taskTracker = $$taskTrackerFactory($log);
    self.isMock = false;

    //////////////////////////////////////////////////////////////
    // Task-tracking API
    //////////////////////////////////////////////////////////////

    // TODO(vojta): remove this temporary api
    self.$$completeOutstandingRequest = taskTracker.completeTask;
    self.$$incOutstandingRequestCount = taskTracker.incTaskCount;

    // TODO(vojta): prefix this method with $$ ?
    self.notifyWhenNoOutstandingRequests = taskTracker.notifyWhenNoPendingTasks;

    //////////////////////////////////////////////////////////////
    // URL API
    //////////////////////////////////////////////////////////////

    var cachedState,
      lastHistoryState,
      lastBrowserUrl = location.href,
      baseElement = document.find('base'),
      pendingLocation = null,
      getCurrentState = !$sniffer.history ? noop : function getCurrentState() {
        try {
          return history.state;
        } catch (e) {
          // MSIE can reportedly throw when there is no state (UNCONFIRMED).
        }
      };
    cacheState();

    /**
     * @name $browser#url
     *
     * @description
     * GETTER:
     * Without any argument, this method just returns current value of `location.href` (with a
     * trailing `#` stripped of if the hash is empty).
     *
     * SETTER:
     * With at least one argument, this method sets url to new value.
     * If html5 history api supported, `pushState`/`replaceState` is used, otherwise
     * `location.href`/`location.replace` is used.
     * Returns its own instance to allow chaining.
     *
     * NOTE: this api is intended for use only by the `$location` service. Please use the
     * {@link ng.$location $location service} to change url.
     *
     * @param {string} url New url (when used as setter)
     * @param {boolean=} replace Should new url replace current history record?
     * @param {object=} state State object to use with `pushState`/`replaceState`
     */
    self.url = function (url, replace, state) {
      // In modern browsers `history.state` is `null` by default; treating it separately
      // from `undefined` would cause `$browser.url('/foo')` to change `history.state`
      // to undefined via `pushState`. Instead, let's change `undefined` to `null` here.
      if (isUndefined(state)) {
        state = null;
      }

      // Android Browser BFCache causes location, history reference to become stale.
      if (location !== window.location) location = window.location;
      if (history !== window.history) history = window.history;

      // setter
      if (url) {
        var sameState = lastHistoryState === state;

        // Normalize the inputted URL
        url = urlResolve(url).href;

        // Don't change anything if previous and current URLs and states match. This also prevents
        // IE<10 from getting into redirect loop when in LocationHashbangInHtml5Url mode.
        // See https://github.com/angular/angular.js/commit/ffb2701
        if (lastBrowserUrl === url && (!$sniffer.history || sameState)) {
          return self;
        }
        var sameBase = lastBrowserUrl && stripHash(lastBrowserUrl) === stripHash(url);
        lastBrowserUrl = url;
        lastHistoryState = state;
        // Don't use history API if only the hash changed
        // due to a bug in IE10/IE11 which leads
        // to not firing a `hashchange` nor `popstate` event
        // in some cases (see #9143).
        if ($sniffer.history && (!sameBase || !sameState)) {
          history[replace ? 'replaceState' : 'pushState'](state, '', url);
          cacheState();
        } else {
          if (!sameBase) {
            pendingLocation = url;
          }
          if (replace) {
            location.replace(url);
          } else if (!sameBase) {
            location.href = url;
          } else {
            location.hash = getHash(url);
          }
          if (location.href !== url) {
            pendingLocation = url;
          }
        }
        if (pendingLocation) {
          pendingLocation = url;
        }
        return self;
        // getter
      } else {
        // - pendingLocation is needed as browsers don't allow to read out
        //   the new location.href if a reload happened or if there is a bug like in iOS 9 (see
        //   https://openradar.appspot.com/22186109).
        return trimEmptyHash(pendingLocation || location.href);
      }
    };

    /**
     * @name $browser#state
     *
     * @description
     * This method is a getter.
     *
     * Return history.state or null if history.state is undefined.
     *
     * @returns {object} state
     */
    self.state = function () {
      return cachedState;
    };
    var urlChangeListeners = [],
      urlChangeInit = false;
    function cacheStateAndFireUrlChange() {
      pendingLocation = null;
      fireStateOrUrlChange();
    }

    // This variable should be used *only* inside the cacheState function.
    var lastCachedState = null;
    function cacheState() {
      // This should be the only place in $browser where `history.state` is read.
      cachedState = getCurrentState();
      cachedState = isUndefined(cachedState) ? null : cachedState;

      // Prevent callbacks fo fire twice if both hashchange & popstate were fired.
      if (equals(cachedState, lastCachedState)) {
        cachedState = lastCachedState;
      }
      lastCachedState = cachedState;
      lastHistoryState = cachedState;
    }
    function fireStateOrUrlChange() {
      var prevLastHistoryState = lastHistoryState;
      cacheState();
      if (lastBrowserUrl === self.url() && prevLastHistoryState === cachedState) {
        return;
      }
      lastBrowserUrl = self.url();
      lastHistoryState = cachedState;
      forEach(urlChangeListeners, function (listener) {
        listener(self.url(), cachedState);
      });
    }

    /**
     * @name $browser#onUrlChange
     *
     * @description
     * Register callback function that will be called, when url changes.
     *
     * It's only called when the url is changed from outside of AngularJS:
     * - user types different url into address bar
     * - user clicks on history (forward/back) button
     * - user clicks on a link
     *
     * It's not called when url is changed by $browser.url() method
     *
     * The listener gets called with new url as parameter.
     *
     * NOTE: this api is intended for use only by the $location service. Please use the
     * {@link ng.$location $location service} to monitor url changes in AngularJS apps.
     *
     * @param {function(string)} listener Listener function to be called when url changes.
     * @return {function(string)} Returns the registered listener fn - handy if the fn is anonymous.
     */
    self.onUrlChange = function (callback) {
      // TODO(vojta): refactor to use node's syntax for events
      if (!urlChangeInit) {
        // We listen on both (hashchange/popstate) when available, as some browsers don't
        // fire popstate when user changes the address bar and don't fire hashchange when url
        // changed by push/replaceState

        // html5 history api - popstate event
        if ($sniffer.history) jqLite(window).on('popstate', cacheStateAndFireUrlChange);
        // hashchange event
        jqLite(window).on('hashchange', cacheStateAndFireUrlChange);
        urlChangeInit = true;
      }
      urlChangeListeners.push(callback);
      return callback;
    };

    /**
     * @private
     * Remove popstate and hashchange handler from window.
     *
     * NOTE: this api is intended for use only by $rootScope.
     */
    self.$$applicationDestroyed = function () {
      jqLite(window).off('hashchange popstate', cacheStateAndFireUrlChange);
    };

    /**
     * Checks whether the url has changed outside of AngularJS.
     * Needs to be exported to be able to check for changes that have been done in sync,
     * as hashchange/popstate events fire in async.
     */
    self.$$checkUrlChange = fireStateOrUrlChange;

    //////////////////////////////////////////////////////////////
    // Misc API
    //////////////////////////////////////////////////////////////

    /**
     * @name $browser#baseHref
     *
     * @description
     * Returns current <base href>
     * (always relative - without domain)
     *
     * @returns {string} The current base href
     */
    self.baseHref = function () {
      var href = baseElement.attr('href');
      return href ? href.replace(/^(https?:)?\/\/[^/]*/, '') : '';
    };

    /**
     * @name $browser#defer
     * @param {function()} fn A function, who's execution should be deferred.
     * @param {number=} [delay=0] Number of milliseconds to defer the function execution.
     * @param {string=} [taskType=DEFAULT_TASK_TYPE] The type of task that is deferred.
     * @returns {*} DeferId that can be used to cancel the task via `$browser.defer.cancel()`.
     *
     * @description
     * Executes a fn asynchronously via `setTimeout(fn, delay)`.
     *
     * Unlike when calling `setTimeout` directly, in test this function is mocked and instead of using
     * `setTimeout` in tests, the fns are queued in an array, which can be programmatically flushed
     * via `$browser.defer.flush()`.
     *
     */
    self.defer = function (fn, delay, taskType) {
      var timeoutId;
      delay = delay || 0;
      taskType = taskType || taskTracker.DEFAULT_TASK_TYPE;
      taskTracker.incTaskCount(taskType);
      timeoutId = setTimeout(function () {
        delete pendingDeferIds[timeoutId];
        taskTracker.completeTask(fn, taskType);
      }, delay);
      pendingDeferIds[timeoutId] = taskType;
      return timeoutId;
    };

    /**
     * @name $browser#defer.cancel
     *
     * @description
     * Cancels a deferred task identified with `deferId`.
     *
     * @param {*} deferId Token returned by the `$browser.defer` function.
     * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
     *                    canceled.
     */
    self.defer.cancel = function (deferId) {
      if (pendingDeferIds.hasOwnProperty(deferId)) {
        var taskType = pendingDeferIds[deferId];
        delete pendingDeferIds[deferId];
        clearTimeout(deferId);
        taskTracker.completeTask(noop, taskType);
        return true;
      }
      return false;
    };
  }

  /** @this */
  function $BrowserProvider() {
    this.$get = ['$window', '$log', '$sniffer', '$document', '$$taskTrackerFactory', function ($window, $log, $sniffer, $document, $$taskTrackerFactory) {
      return new Browser($window, $document, $log, $sniffer, $$taskTrackerFactory);
    }];
  }

  /**
   * @ngdoc service
   * @name $cacheFactory
   * @this
   *
   * @description
   * Factory that constructs {@link $cacheFactory.Cache Cache} objects and gives access to
   * them.
   *
   * ```js
   *
   *  var cache = $cacheFactory('cacheId');
   *  expect($cacheFactory.get('cacheId')).toBe(cache);
   *  expect($cacheFactory.get('noSuchCacheId')).not.toBeDefined();
   *
   *  cache.put("key", "value");
   *  cache.put("another key", "another value");
   *
   *  // We've specified no options on creation
   *  expect(cache.info()).toEqual({id: 'cacheId', size: 2});
   *
   * ```
   *
   *
   * @param {string} cacheId Name or id of the newly created cache.
   * @param {object=} options Options object that specifies the cache behavior. Properties:
   *
   *   - `{number=}` `capacity` — turns the cache into LRU cache.
   *
   * @returns {object} Newly created cache object with the following set of methods:
   *
   * - `{object}` `info()` — Returns id, size, and options of cache.
   * - `{{*}}` `put({string} key, {*} value)` — Puts a new key-value pair into the cache and returns
   *   it.
   * - `{{*}}` `get({string} key)` — Returns cached value for `key` or undefined for cache miss.
   * - `{void}` `remove({string} key)` — Removes a key-value pair from the cache.
   * - `{void}` `removeAll()` — Removes all cached values.
   * - `{void}` `destroy()` — Removes references to this cache from $cacheFactory.
   *
   * @example
     <example module="cacheExampleApp" name="cache-factory">
       <file name="index.html">
         <div ng-controller="CacheController">
           <input ng-model="newCacheKey" placeholder="Key">
           <input ng-model="newCacheValue" placeholder="Value">
           <button ng-click="put(newCacheKey, newCacheValue)">Cache</button>
  
           <p ng-if="keys.length">Cached Values</p>
           <div ng-repeat="key in keys">
             <span ng-bind="key"></span>
             <span>: </span>
             <b ng-bind="cache.get(key)"></b>
           </div>
  
           <p>Cache Info</p>
           <div ng-repeat="(key, value) in cache.info()">
             <span ng-bind="key"></span>
             <span>: </span>
             <b ng-bind="value"></b>
           </div>
         </div>
       </file>
       <file name="script.js">
         angular.module('cacheExampleApp', []).
           controller('CacheController', ['$scope', '$cacheFactory', function($scope, $cacheFactory) {
             $scope.keys = [];
             $scope.cache = $cacheFactory('cacheId');
             $scope.put = function(key, value) {
               if (angular.isUndefined($scope.cache.get(key))) {
                 $scope.keys.push(key);
               }
               $scope.cache.put(key, angular.isUndefined(value) ? null : value);
             };
           }]);
       </file>
       <file name="style.css">
         p {
           margin: 10px 0 3px;
         }
       </file>
     </example>
   */
  function $CacheFactoryProvider() {
    this.$get = function () {
      var caches = {};
      function cacheFactory(cacheId, options) {
        if (cacheId in caches) {
          throw minErr('$cacheFactory')('iid', 'CacheId \'{0}\' is already taken!', cacheId);
        }
        var size = 0,
          stats = extend({}, options, {
            id: cacheId
          }),
          data = createMap(),
          capacity = options && options.capacity || Number.MAX_VALUE,
          lruHash = createMap(),
          freshEnd = null,
          staleEnd = null;

        /**
         * @ngdoc type
         * @name $cacheFactory.Cache
         *
         * @description
         * A cache object used to store and retrieve data, primarily used by
         * {@link $templateRequest $templateRequest} and the {@link ng.directive:script script}
         * directive to cache templates and other data.
         *
         * ```js
         *  angular.module('superCache')
         *    .factory('superCache', ['$cacheFactory', function($cacheFactory) {
         *      return $cacheFactory('super-cache');
         *    }]);
         * ```
         *
         * Example test:
         *
         * ```js
         *  it('should behave like a cache', inject(function(superCache) {
         *    superCache.put('key', 'value');
         *    superCache.put('another key', 'another value');
         *
         *    expect(superCache.info()).toEqual({
         *      id: 'super-cache',
         *      size: 2
         *    });
         *
         *    superCache.remove('another key');
         *    expect(superCache.get('another key')).toBeUndefined();
         *
         *    superCache.removeAll();
         *    expect(superCache.info()).toEqual({
         *      id: 'super-cache',
         *      size: 0
         *    });
         *  }));
         * ```
         */
        return caches[cacheId] = {
          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#put
           * @kind function
           *
           * @description
           * Inserts a named entry into the {@link $cacheFactory.Cache Cache} object to be
           * retrieved later, and incrementing the size of the cache if the key was not already
           * present in the cache. If behaving like an LRU cache, it will also remove stale
           * entries from the set.
           *
           * It will not insert undefined values into the cache.
           *
           * @param {string} key the key under which the cached data is stored.
           * @param {*} value the value to store alongside the key. If it is undefined, the key
           *    will not be stored.
           * @returns {*} the value stored.
           */
          put: function put(key, value) {
            if (isUndefined(value)) return;
            if (capacity < Number.MAX_VALUE) {
              var lruEntry = lruHash[key] || (lruHash[key] = {
                key: key
              });
              refresh(lruEntry);
            }
            if (!(key in data)) size++;
            data[key] = value;
            if (size > capacity) {
              this.remove(staleEnd.key);
            }
            return value;
          },
          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#get
           * @kind function
           *
           * @description
           * Retrieves named data stored in the {@link $cacheFactory.Cache Cache} object.
           *
           * @param {string} key the key of the data to be retrieved
           * @returns {*} the value stored.
           */
          get: function get(key) {
            if (capacity < Number.MAX_VALUE) {
              var lruEntry = lruHash[key];
              if (!lruEntry) return;
              refresh(lruEntry);
            }
            return data[key];
          },
          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#remove
           * @kind function
           *
           * @description
           * Removes an entry from the {@link $cacheFactory.Cache Cache} object.
           *
           * @param {string} key the key of the entry to be removed
           */
          remove: function remove(key) {
            if (capacity < Number.MAX_VALUE) {
              var lruEntry = lruHash[key];
              if (!lruEntry) return;
              if (lruEntry === freshEnd) freshEnd = lruEntry.p;
              if (lruEntry === staleEnd) staleEnd = lruEntry.n;
              link(lruEntry.n, lruEntry.p);
              delete lruHash[key];
            }
            if (!(key in data)) return;
            delete data[key];
            size--;
          },
          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#removeAll
           * @kind function
           *
           * @description
           * Clears the cache object of any entries.
           */
          removeAll: function removeAll() {
            data = createMap();
            size = 0;
            lruHash = createMap();
            freshEnd = staleEnd = null;
          },
          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#destroy
           * @kind function
           *
           * @description
           * Destroys the {@link $cacheFactory.Cache Cache} object entirely,
           * removing it from the {@link $cacheFactory $cacheFactory} set.
           */
          destroy: function destroy() {
            data = null;
            stats = null;
            lruHash = null;
            delete caches[cacheId];
          },
          /**
           * @ngdoc method
           * @name $cacheFactory.Cache#info
           * @kind function
           *
           * @description
           * Retrieve information regarding a particular {@link $cacheFactory.Cache Cache}.
           *
           * @returns {object} an object with the following properties:
           *   <ul>
           *     <li>**id**: the id of the cache instance</li>
           *     <li>**size**: the number of entries kept in the cache instance</li>
           *     <li>**...**: any additional properties from the options object when creating the
           *       cache.</li>
           *   </ul>
           */
          info: function info() {
            return extend({}, stats, {
              size: size
            });
          }
        };

        /**
         * makes the `entry` the freshEnd of the LRU linked list
         */
        function refresh(entry) {
          if (entry !== freshEnd) {
            if (!staleEnd) {
              staleEnd = entry;
            } else if (staleEnd === entry) {
              staleEnd = entry.n;
            }
            link(entry.n, entry.p);
            link(entry, freshEnd);
            freshEnd = entry;
            freshEnd.n = null;
          }
        }

        /**
         * bidirectionally links two entries of the LRU linked list
         */
        function link(nextEntry, prevEntry) {
          if (nextEntry !== prevEntry) {
            if (nextEntry) nextEntry.p = prevEntry; //p stands for previous, 'prev' didn't minify
            if (prevEntry) prevEntry.n = nextEntry; //n stands for next, 'next' didn't minify
          }
        }
      }

      /**
       * @ngdoc method
       * @name $cacheFactory#info
       *
       * @description
       * Get information about all the caches that have been created
       *
       * @returns {Object} - key-value map of `cacheId` to the result of calling `cache#info`
       */
      cacheFactory.info = function () {
        var info = {};
        forEach(caches, function (cache, cacheId) {
          info[cacheId] = cache.info();
        });
        return info;
      };

      /**
       * @ngdoc method
       * @name $cacheFactory#get
       *
       * @description
       * Get access to a cache object by the `cacheId` used when it was created.
       *
       * @param {string} cacheId Name or id of a cache to access.
       * @returns {object} Cache object identified by the cacheId or undefined if no such cache.
       */
      cacheFactory.get = function (cacheId) {
        return caches[cacheId];
      };
      return cacheFactory;
    };
  }

  /**
   * @ngdoc service
   * @name $templateCache
   * @this
   *
   * @description
   * `$templateCache` is a {@link $cacheFactory.Cache Cache object} created by the
   * {@link ng.$cacheFactory $cacheFactory}.
   *
   * The first time a template is used, it is loaded in the template cache for quick retrieval. You
   * can load templates directly into the cache in a `script` tag, by using {@link $templateRequest},
   * or by consuming the `$templateCache` service directly.
   *
   * Adding via the `script` tag:
   *
   * ```html
   *   <script type="text/ng-template" id="templateId.html">
   *     <p>This is the content of the template</p>
   *   </script>
   * ```
   *
   * **Note:** the `script` tag containing the template does not need to be included in the `head` of
   * the document, but it must be a descendent of the {@link ng.$rootElement $rootElement} (e.g.
   * element with {@link ngApp} attribute), otherwise the template will be ignored.
   *
   * Adding via the `$templateCache` service:
   *
   * ```js
   * var myApp = angular.module('myApp', []);
   * myApp.run(function($templateCache) {
   *   $templateCache.put('templateId.html', 'This is the content of the template');
   * });
   * ```
   *
   * To retrieve the template later, simply use it in your component:
   * ```js
   * myApp.component('myComponent', {
   *    templateUrl: 'templateId.html'
   * });
   * ```
   *
   * or get it via the `$templateCache` service:
   * ```js
   * $templateCache.get('templateId.html')
   * ```
   *
   */
  function $TemplateCacheProvider() {
    this.$get = ['$cacheFactory', function ($cacheFactory) {
      return $cacheFactory('templates');
    }];
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   *     Any commits to this file should be reviewed with security in mind.  *
   *   Changes to this file can potentially create security vulnerabilities. *
   *          An approval from 2 Core members with history of modifying      *
   *                         this file is required.                          *
   *                                                                         *
   *  Does the change somehow allow for arbitrary javascript to be executed? *
   *    Or allows for someone to change the prototype of built-in objects?   *
   *     Or gives undesired access to variables like document or window?    *
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  /* ! VARIABLE/FUNCTION NAMING CONVENTIONS THAT APPLY TO THIS FILE!
   *
   * DOM-related variables:
   *
   * - "node" - DOM Node
   * - "element" - DOM Element or Node
   * - "$node" or "$element" - jqLite-wrapped node or element
   *
   *
   * Compiler related stuff:
   *
   * - "linkFn" - linking fn of a single directive
   * - "nodeLinkFn" - function that aggregates all linking fns for a particular node
   * - "childLinkFn" -  function that aggregates all linking fns for child nodes of a particular node
   * - "compositeLinkFn" - function that aggregates all linking fns for a compilation root (nodeList)
   */

  /**
   * @ngdoc service
   * @name $compile
   * @kind function
   *
   * @description
   * Compiles an HTML string or DOM into a template and produces a template function, which
   * can then be used to link {@link ng.$rootScope.Scope `scope`} and the template together.
   *
   * The compilation is a process of walking the DOM tree and matching DOM elements to
   * {@link ng.$compileProvider#directive directives}.
   *
   * <div class="alert alert-warning">
   * **Note:** This document is an in-depth reference of all directive options.
   * For a gentle introduction to directives with examples of common use cases,
   * see the {@link guide/directive directive guide}.
   * </div>
   *
   * ## Comprehensive Directive API
   *
   * There are many different options for a directive.
   *
   * The difference resides in the return value of the factory function.
   * You can either return a {@link $compile#directive-definition-object Directive Definition Object (see below)}
   * that defines the directive properties, or just the `postLink` function (all other properties will have
   * the default values).
   *
   * <div class="alert alert-success">
   * **Best Practice:** It's recommended to use the "directive definition object" form.
   * </div>
   *
   * Here's an example directive declared with a Directive Definition Object:
   *
   * ```js
   *   var myModule = angular.module(...);
   *
   *   myModule.directive('directiveName', function factory(injectables) {
   *     var directiveDefinitionObject = {
   *       {@link $compile#-priority- priority}: 0,
   *       {@link $compile#-template- template}: '<div></div>', // or // function(tElement, tAttrs) { ... },
   *       // or
   *       // {@link $compile#-templateurl- templateUrl}: 'directive.html', // or // function(tElement, tAttrs) { ... },
   *       {@link $compile#-transclude- transclude}: false,
   *       {@link $compile#-restrict- restrict}: 'A',
   *       {@link $compile#-templatenamespace- templateNamespace}: 'html',
   *       {@link $compile#-scope- scope}: false,
   *       {@link $compile#-controller- controller}: function($scope, $element, $attrs, $transclude, otherInjectables) { ... },
   *       {@link $compile#-controlleras- controllerAs}: 'stringIdentifier',
   *       {@link $compile#-bindtocontroller- bindToController}: false,
   *       {@link $compile#-require- require}: 'siblingDirectiveName', // or // ['^parentDirectiveName', '?optionalDirectiveName', '?^optionalParent'],
   *       {@link $compile#-multielement- multiElement}: false,
   *       {@link $compile#-compile- compile}: function compile(tElement, tAttrs, transclude) {
   *         return {
   *            {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
   *            {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
   *         }
   *         // or
   *         // return function postLink( ... ) { ... }
   *       },
   *       // or
   *       // {@link $compile#-link- link}: {
   *       //  {@link $compile#pre-linking-function pre}: function preLink(scope, iElement, iAttrs, controller) { ... },
   *       //  {@link $compile#post-linking-function post}: function postLink(scope, iElement, iAttrs, controller) { ... }
   *       // }
   *       // or
   *       // {@link $compile#-link- link}: function postLink( ... ) { ... }
   *     };
   *     return directiveDefinitionObject;
   *   });
   * ```
   *
   * <div class="alert alert-warning">
   * **Note:** Any unspecified options will use the default value. You can see the default values below.
   * </div>
   *
   * Therefore the above can be simplified as:
   *
   * ```js
   *   var myModule = angular.module(...);
   *
   *   myModule.directive('directiveName', function factory(injectables) {
   *     var directiveDefinitionObject = {
   *       link: function postLink(scope, iElement, iAttrs) { ... }
   *     };
   *     return directiveDefinitionObject;
   *     // or
   *     // return function postLink(scope, iElement, iAttrs) { ... }
   *   });
   * ```
   *
   * ### Life-cycle hooks
   * Directive controllers can provide the following methods that are called by AngularJS at points in the life-cycle of the
   * directive:
   * * `$onInit()` - Called on each controller after all the controllers on an element have been constructed and
   *   had their bindings initialized (and before the pre &amp; post linking functions for the directives on
   *   this element). This is a good place to put initialization code for your controller.
   * * `$onChanges(changesObj)` - Called whenever one-way (`<`) or interpolation (`@`) bindings are updated. The
   *   `changesObj` is a hash whose keys are the names of the bound properties that have changed, and the values are an
   *   object of the form `{ currentValue, previousValue, isFirstChange() }`. Use this hook to trigger updates within a
   *   component such as cloning the bound value to prevent accidental mutation of the outer value. Note that this will
   *   also be called when your bindings are initialized.
   * * `$doCheck()` - Called on each turn of the digest cycle. Provides an opportunity to detect and act on
   *   changes. Any actions that you wish to take in response to the changes that you detect must be
   *   invoked from this hook; implementing this has no effect on when `$onChanges` is called. For example, this hook
   *   could be useful if you wish to perform a deep equality check, or to check a Date object, changes to which would not
   *   be detected by AngularJS's change detector and thus not trigger `$onChanges`. This hook is invoked with no arguments;
   *   if detecting changes, you must store the previous value(s) for comparison to the current values.
   * * `$onDestroy()` - Called on a controller when its containing scope is destroyed. Use this hook for releasing
   *   external resources, watches and event handlers. Note that components have their `$onDestroy()` hooks called in
   *   the same order as the `$scope.$broadcast` events are triggered, which is top down. This means that parent
   *   components will have their `$onDestroy()` hook called before child components.
   * * `$postLink()` - Called after this controller's element and its children have been linked. Similar to the post-link
   *   function this hook can be used to set up DOM event handlers and do direct DOM manipulation.
   *   Note that child elements that contain `templateUrl` directives will not have been compiled and linked since
   *   they are waiting for their template to load asynchronously and their own compilation and linking has been
   *   suspended until that occurs.
   *
   * #### Comparison with life-cycle hooks in the new Angular
   * The new Angular also uses life-cycle hooks for its components. While the AngularJS life-cycle hooks are similar there are
   * some differences that you should be aware of, especially when it comes to moving your code from AngularJS to Angular:
   *
   * * AngularJS hooks are prefixed with `$`, such as `$onInit`. Angular hooks are prefixed with `ng`, such as `ngOnInit`.
   * * AngularJS hooks can be defined on the controller prototype or added to the controller inside its constructor.
   *   In Angular you can only define hooks on the prototype of the Component class.
   * * Due to the differences in change-detection, you may get many more calls to `$doCheck` in AngularJS than you would to
   *   `ngDoCheck` in Angular.
   * * Changes to the model inside `$doCheck` will trigger new turns of the digest loop, which will cause the changes to be
   *   propagated throughout the application.
   *   Angular does not allow the `ngDoCheck` hook to trigger a change outside of the component. It will either throw an
   *   error or do nothing depending upon the state of `enableProdMode()`.
   *
   * #### Life-cycle hook examples
   *
   * This example shows how you can check for mutations to a Date object even though the identity of the object
   * has not changed.
   *
   * <example name="doCheckDateExample" module="do-check-module">
   *   <file name="app.js">
   *     angular.module('do-check-module', [])
   *       .component('app', {
   *         template:
   *           'Month: <input ng-model="$ctrl.month" ng-change="$ctrl.updateDate()">' +
   *           'Date: {{ $ctrl.date }}' +
   *           '<test date="$ctrl.date"></test>',
   *         controller: function() {
   *           this.date = new Date();
   *           this.month = this.date.getMonth();
   *           this.updateDate = function() {
   *             this.date.setMonth(this.month);
   *           };
   *         }
   *       })
   *       .component('test', {
   *         bindings: { date: '<' },
   *         template:
   *           '<pre>{{ $ctrl.log | json }}</pre>',
   *         controller: function() {
   *           var previousValue;
   *           this.log = [];
   *           this.$doCheck = function() {
   *             var currentValue = this.date && this.date.valueOf();
   *             if (previousValue !== currentValue) {
   *               this.log.push('doCheck: date mutated: ' + this.date);
   *               previousValue = currentValue;
   *             }
   *           };
   *         }
   *       });
   *   </file>
   *   <file name="index.html">
   *     <app></app>
   *   </file>
   * </example>
   *
   * This example show how you might use `$doCheck` to trigger changes in your component's inputs even if the
   * actual identity of the component doesn't change. (Be aware that cloning and deep equality checks on large
   * arrays or objects can have a negative impact on your application performance.)
   *
   * <example name="doCheckArrayExample" module="do-check-module">
   *   <file name="index.html">
   *     <div ng-init="items = []">
   *       <button ng-click="items.push(items.length)">Add Item</button>
   *       <button ng-click="items = []">Reset Items</button>
   *       <pre>{{ items }}</pre>
   *       <test items="items"></test>
   *     </div>
   *   </file>
   *   <file name="app.js">
   *      angular.module('do-check-module', [])
   *        .component('test', {
   *          bindings: { items: '<' },
   *          template:
   *            '<pre>{{ $ctrl.log | json }}</pre>',
   *          controller: function() {
   *            this.log = [];
   *
   *            this.$doCheck = function() {
   *              if (this.items_ref !== this.items) {
   *                this.log.push('doCheck: items changed');
   *                this.items_ref = this.items;
   *              }
   *              if (!angular.equals(this.items_clone, this.items)) {
   *                this.log.push('doCheck: items mutated');
   *                this.items_clone = angular.copy(this.items);
   *              }
   *            };
   *          }
   *        });
   *   </file>
   * </example>
   *
   *
   * ### Directive Definition Object
   *
   * The directive definition object provides instructions to the {@link ng.$compile
   * compiler}. The attributes are:
   *
   * #### `multiElement`
   * When this property is set to true (default is `false`), the HTML compiler will collect DOM nodes between
   * nodes with the attributes `directive-name-start` and `directive-name-end`, and group them
   * together as the directive elements. It is recommended that this feature be used on directives
   * which are not strictly behavioral (such as {@link ngClick}), and which
   * do not manipulate or replace child nodes (such as {@link ngInclude}).
   *
   * #### `priority`
   * When there are multiple directives defined on a single DOM element, sometimes it
   * is necessary to specify the order in which the directives are applied. The `priority` is used
   * to sort the directives before their `compile` functions get called. Priority is defined as a
   * number. Directives with greater numerical `priority` are compiled first. Pre-link functions
   * are also run in priority order, but post-link functions are run in reverse order. The order
   * of directives with the same priority is undefined. The default priority is `0`.
   *
   * #### `terminal`
   * If set to true then the current `priority` will be the last set of directives
   * which will execute (any directives at the current priority will still execute
   * as the order of execution on same `priority` is undefined). Note that expressions
   * and other directives used in the directive's template will also be excluded from execution.
   *
   * #### `scope`
   * The scope property can be `false`, `true`, or an object:
   *
   * * **`false` (default):** No scope will be created for the directive. The directive will use its
   * parent's scope.
   *
   * * **`true`:** A new child scope that prototypically inherits from its parent will be created for
   * the directive's element. If multiple directives on the same element request a new scope,
   * only one new scope is created.
   *
   * * **`{...}` (an object hash):** A new "isolate" scope is created for the directive's template.
   * The 'isolate' scope differs from normal scope in that it does not prototypically
   * inherit from its parent scope. This is useful when creating reusable components, which should not
   * accidentally read or modify data in the parent scope. Note that an isolate scope
   * directive without a `template` or `templateUrl` will not apply the isolate scope
   * to its children elements.
   *
   * The 'isolate' scope object hash defines a set of local scope properties derived from attributes on the
   * directive's element. These local properties are useful for aliasing values for templates. The keys in
   * the object hash map to the name of the property on the isolate scope; the values define how the property
   * is bound to the parent scope, via matching attributes on the directive's element:
   *
   * * `@` or `@attr` - bind a local scope property to the value of DOM attribute. The result is
   *   always a string since DOM attributes are strings. If no `attr` name is specified then the
   *   attribute name is assumed to be the same as the local name. Given `<my-component
   *   my-attr="hello {{name}}">` and the isolate scope definition `scope: { localName:'@myAttr' }`,
   *   the directive's scope property `localName` will reflect the interpolated value of `hello
   *   {{name}}`. As the `name` attribute changes so will the `localName` property on the directive's
   *   scope. The `name` is read from the parent scope (not the directive's scope).
   *
   * * `=` or `=attr` - set up a bidirectional binding between a local scope property and an expression
   *   passed via the attribute `attr`. The expression is evaluated in the context of the parent scope.
   *   If no `attr` name is specified then the attribute name is assumed to be the same as the local
   *   name. Given `<my-component my-attr="parentModel">` and the isolate scope definition `scope: {
   *   localModel: '=myAttr' }`, the property `localModel` on the directive's scope will reflect the
   *   value of `parentModel` on the parent scope. Changes to `parentModel` will be reflected in
   *   `localModel` and vice versa. If the binding expression is non-assignable, or if the attribute
   *   isn't  optional and doesn't exist, an exception
   *   ({@link error/$compile/nonassign `$compile:nonassign`}) will be thrown upon discovering changes
   *   to the local value, since it will be impossible to sync them back to the parent scope.
   *
   *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
   *   method is used for tracking changes, and the equality check is based on object identity.
   *   However, if an object literal or an array literal is passed as the binding expression, the
   *   equality check is done by value (using the {@link angular.equals} function). It's also possible
   *   to watch the evaluated value shallowly with {@link ng.$rootScope.Scope#$watchCollection
   *   `$watchCollection`}: use `=*` or `=*attr`
   *
    * * `<` or `<attr` - set up a one-way (one-directional) binding between a local scope property and an
   *   expression passed via the attribute `attr`. The expression is evaluated in the context of the
   *   parent scope. If no `attr` name is specified then the attribute name is assumed to be the same as the
   *   local name.
   *
   *   For example, given `<my-component my-attr="parentModel">` and directive definition of
   *   `scope: { localModel:'<myAttr' }`, then the isolated scope property `localModel` will reflect the
   *   value of `parentModel` on the parent scope. Any changes to `parentModel` will be reflected
   *   in `localModel`, but changes in `localModel` will not reflect in `parentModel`. There are however
   *   two caveats:
   *     1. one-way binding does not copy the value from the parent to the isolate scope, it simply
   *     sets the same value. That means if your bound value is an object, changes to its properties
   *     in the isolated scope will be reflected in the parent scope (because both reference the same object).
   *     2. one-way binding watches changes to the **identity** of the parent value. That means the
   *     {@link ng.$rootScope.Scope#$watch `$watch`} on the parent value only fires if the reference
   *     to the value has changed. In most cases, this should not be of concern, but can be important
   *     to know if you one-way bind to an object, and then replace that object in the isolated scope.
   *     If you now change a property of the object in your parent scope, the change will not be
   *     propagated to the isolated scope, because the identity of the object on the parent scope
   *     has not changed. Instead you must assign a new object.
   *
   *   One-way binding is useful if you do not plan to propagate changes to your isolated scope bindings
   *   back to the parent. However, it does not make this completely impossible.
   *
   *   By default, the {@link ng.$rootScope.Scope#$watch `$watch`}
   *   method is used for tracking changes, and the equality check is based on object identity.
   *   It's also possible to watch the evaluated value shallowly with
   *   {@link ng.$rootScope.Scope#$watchCollection `$watchCollection`}: use `<*` or `<*attr`
   *
   * * `&` or `&attr` - provides a way to execute an expression in the context of the parent scope. If
   *   no `attr` name is specified then the attribute name is assumed to be the same as the local name.
   *   Given `<my-component my-attr="count = count + value">` and the isolate scope definition `scope: {
   *   localFn:'&myAttr' }`, the isolate scope property `localFn` will point to a function wrapper for
   *   the `count = count + value` expression. Often it's desirable to pass data from the isolated scope
   *   via an expression to the parent scope. This can be done by passing a map of local variable names
   *   and values into the expression wrapper fn. For example, if the expression is `increment(amount)`
   *   then we can specify the amount value by calling the `localFn` as `localFn({amount: 22})`.
   *
   * All 4 kinds of bindings (`@`, `=`, `<`, and `&`) can be made optional by adding `?` to the expression.
   * The marker must come after the mode and before the attribute name.
   * See the {@link error/$compile/iscp Invalid Isolate Scope Definition error} for definition examples.
   * This is useful to refine the interface directives provide.
   * One subtle difference between optional and non-optional happens **when the binding attribute is not
   * set**:
   * - the binding is optional: the property will not be defined
   * - the binding is not optional: the property is defined
   *
   * ```js
   *app.directive('testDir', function() {
      return {
        scope: {
          notoptional: '=',
          optional: '=?',
        },
        bindToController: true,
        controller: function() {
          this.$onInit = function() {
            console.log(this.hasOwnProperty('notoptional')) // true
            console.log(this.hasOwnProperty('optional')) // false
          }
        }
      }
    })
   *```
   *
   *
   * ##### Combining directives with different scope defintions
   *
   * In general it's possible to apply more than one directive to one element, but there might be limitations
   * depending on the type of scope required by the directives. The following points will help explain these limitations.
   * For simplicity only two directives are taken into account, but it is also applicable for several directives:
   *
   * * **no scope** + **no scope** => Two directives which don't require their own scope will use their parent's scope
   * * **child scope** + **no scope** =>  Both directives will share one single child scope
   * * **child scope** + **child scope** =>  Both directives will share one single child scope
   * * **isolated scope** + **no scope** =>  The isolated directive will use it's own created isolated scope. The other directive will use
   * its parent's scope
   * * **isolated scope** + **child scope** =>  **Won't work!** Only one scope can be related to one element. Therefore these directives cannot
   * be applied to the same element.
   * * **isolated scope** + **isolated scope**  =>  **Won't work!** Only one scope can be related to one element. Therefore these directives
   * cannot be applied to the same element.
   *
   *
   * #### `bindToController`
   * This property is used to bind scope properties directly to the controller. It can be either
   * `true` or an object hash with the same format as the `scope` property.
   *
   * When an isolate scope is used for a directive (see above), `bindToController: true` will
   * allow a component to have its properties bound to the controller, rather than to scope.
   *
   * After the controller is instantiated, the initial values of the isolate scope bindings will be bound to the controller
   * properties. You can access these bindings once they have been initialized by providing a controller method called
   * `$onInit`, which is called after all the controllers on an element have been constructed and had their bindings
   * initialized.
   *
   * It is also possible to set `bindToController` to an object hash with the same format as the `scope` property.
   * This will set up the scope bindings to the controller directly. Note that `scope` can still be used
   * to define which kind of scope is created. By default, no scope is created. Use `scope: {}` to create an isolate
   * scope (useful for component directives).
   *
   * If both `bindToController` and `scope` are defined and have object hashes, `bindToController` overrides `scope`.
   *
   *
   * #### `controller`
   * Controller constructor function. The controller is instantiated before the
   * pre-linking phase and can be accessed by other directives (see
   * `require` attribute). This allows the directives to communicate with each other and augment
   * each other's behavior. The controller is injectable (and supports bracket notation) with the following locals:
   *
   * * `$scope` - Current scope associated with the element
   * * `$element` - Current element
   * * `$attrs` - Current attributes object for the element
   * * `$transclude` - A transclude linking function pre-bound to the correct transclusion scope:
   *   `function([scope], cloneLinkingFn, futureParentElement, slotName)`:
   *    * `scope`: (optional) override the scope.
   *    * `cloneLinkingFn`: (optional) argument to create clones of the original transcluded content.
   *    * `futureParentElement` (optional):
   *        * defines the parent to which the `cloneLinkingFn` will add the cloned elements.
   *        * default: `$element.parent()` resp. `$element` for `transclude:'element'` resp. `transclude:true`.
   *        * only needed for transcludes that are allowed to contain non html elements (e.g. SVG elements)
   *          and when the `cloneLinkingFn` is passed,
   *          as those elements need to created and cloned in a special way when they are defined outside their
   *          usual containers (e.g. like `<svg>`).
   *        * See also the `directive.templateNamespace` property.
   *    * `slotName`: (optional) the name of the slot to transclude. If falsy (e.g. `null`, `undefined` or `''`)
   *      then the default transclusion is provided.
   *    The `$transclude` function also has a method on it, `$transclude.isSlotFilled(slotName)`, which returns
   *    `true` if the specified slot contains content (i.e. one or more DOM nodes).
   *
   * #### `require`
   * Require another directive and inject its controller as the fourth argument to the linking function. The
   * `require` property can be a string, an array or an object:
   * * a **string** containing the name of the directive to pass to the linking function
   * * an **array** containing the names of directives to pass to the linking function. The argument passed to the
   * linking function will be an array of controllers in the same order as the names in the `require` property
   * * an **object** whose property values are the names of the directives to pass to the linking function. The argument
   * passed to the linking function will also be an object with matching keys, whose values will hold the corresponding
   * controllers.
   *
   * If the `require` property is an object and `bindToController` is truthy, then the required controllers are
   * bound to the controller using the keys of the `require` property. This binding occurs after all the controllers
   * have been constructed but before `$onInit` is called.
   * If the name of the required controller is the same as the local name (the key), the name can be
   * omitted. For example, `{parentDir: '^^'}` is equivalent to `{parentDir: '^^parentDir'}`.
   * See the {@link $compileProvider#component} helper for an example of how this can be used.
   * If no such required directive(s) can be found, or if the directive does not have a controller, then an error is
   * raised (unless no link function is specified and the required controllers are not being bound to the directive
   * controller, in which case error checking is skipped). The name can be prefixed with:
   *
   * * (no prefix) - Locate the required controller on the current element. Throw an error if not found.
   * * `?` - Attempt to locate the required controller or pass `null` to the `link` fn if not found.
   * * `^` - Locate the required controller by searching the element and its parents. Throw an error if not found.
   * * `^^` - Locate the required controller by searching the element's parents. Throw an error if not found.
   * * `?^` - Attempt to locate the required controller by searching the element and its parents or pass
   *   `null` to the `link` fn if not found.
   * * `?^^` - Attempt to locate the required controller by searching the element's parents, or pass
   *   `null` to the `link` fn if not found.
   *
   *
   * #### `controllerAs`
   * Identifier name for a reference to the controller in the directive's scope.
   * This allows the controller to be referenced from the directive template. This is especially
   * useful when a directive is used as component, i.e. with an `isolate` scope. It's also possible
   * to use it in a directive without an `isolate` / `new` scope, but you need to be aware that the
   * `controllerAs` reference might overwrite a property that already exists on the parent scope.
   *
   *
   * #### `restrict`
   * String of subset of `EACM` which restricts the directive to a specific directive
   * declaration style. If omitted, the defaults (elements and attributes) are used.
   *
   * * `E` - Element name (default): `<my-directive></my-directive>`
   * * `A` - Attribute (default): `<div my-directive="exp"></div>`
   * * `C` - Class: `<div class="my-directive: exp;"></div>`
   * * `M` - Comment: `<!-- directive: my-directive exp -->`
   *
   *
   * #### `templateNamespace`
   * String representing the document type used by the markup in the template.
   * AngularJS needs this information as those elements need to be created and cloned
   * in a special way when they are defined outside their usual containers like `<svg>` and `<math>`.
   *
   * * `html` - All root nodes in the template are HTML. Root nodes may also be
   *   top-level elements such as `<svg>` or `<math>`.
   * * `svg` - The root nodes in the template are SVG elements (excluding `<math>`).
   * * `math` - The root nodes in the template are MathML elements (excluding `<svg>`).
   *
   * If no `templateNamespace` is specified, then the namespace is considered to be `html`.
   *
   * #### `template`
   * HTML markup that may:
   * * Replace the contents of the directive's element (default).
   * * Replace the directive's element itself (if `replace` is true - DEPRECATED).
   * * Wrap the contents of the directive's element (if `transclude` is true).
   *
   * Value may be:
   *
   * * A string. For example `<div red-on-hover>{{delete_str}}</div>`.
   * * A function which takes two arguments `tElement` and `tAttrs` (described in the `compile`
   *   function api below) and returns a string value.
   *
   *
   * #### `templateUrl`
   * This is similar to `template` but the template is loaded from the specified URL, asynchronously.
   *
   * Because template loading is asynchronous the compiler will suspend compilation of directives on that element
   * for later when the template has been resolved.  In the meantime it will continue to compile and link
   * sibling and parent elements as though this element had not contained any directives.
   *
   * The compiler does not suspend the entire compilation to wait for templates to be loaded because this
   * would result in the whole app "stalling" until all templates are loaded asynchronously - even in the
   * case when only one deeply nested directive has `templateUrl`.
   *
   * Template loading is asynchronous even if the template has been preloaded into the {@link $templateCache}.
   *
   * You can specify `templateUrl` as a string representing the URL or as a function which takes two
   * arguments `tElement` and `tAttrs` (described in the `compile` function api below) and returns
   * a string value representing the url.  In either case, the template URL is passed through {@link
   * $sce#getTrustedResourceUrl $sce.getTrustedResourceUrl}.
   *
   *
   * #### `replace`
   * <div class="alert alert-danger">
   * **Note:** `replace` is deprecated in AngularJS and has been removed in the new Angular (v2+).
   * </div>
   *
   * Specifies what the template should replace. Defaults to `false`.
   *
   * * `true` - the template will replace the directive's element.
   * * `false` - the template will replace the contents of the directive's element.
   *
   * The replacement process migrates all of the attributes / classes from the old element to the new
   * one. See the {@link guide/directive#template-expanding-directive
   * Directives Guide} for an example.
   *
   * There are very few scenarios where element replacement is required for the application function,
   * the main one being reusable custom components that are used within SVG contexts
   * (because SVG doesn't work with custom elements in the DOM tree).
   *
   * #### `transclude`
   * Extract the contents of the element where the directive appears and make it available to the directive.
   * The contents are compiled and provided to the directive as a **transclusion function**. See the
   * {@link $compile#transclusion Transclusion} section below.
   *
   *
   * #### `compile`
   *
   * ```js
   *   function compile(tElement, tAttrs, transclude) { ... }
   * ```
   *
   * The compile function deals with transforming the template DOM. Since most directives do not do
   * template transformation, it is not used often. The compile function takes the following arguments:
   *
   *   * `tElement` - template element - The element where the directive has been declared. It is
   *     safe to do template transformation on the element and child elements only.
   *
   *   * `tAttrs` - template attributes - Normalized list of attributes declared on this element shared
   *     between all directive compile functions.
   *
   *   * `transclude` -  [*DEPRECATED*!] A transclude linking function: `function(scope, cloneLinkingFn)`
   *
   * <div class="alert alert-warning">
   * **Note:** The template instance and the link instance may be different objects if the template has
   * been cloned. For this reason it is **not** safe to do anything other than DOM transformations that
   * apply to all cloned DOM nodes within the compile function. Specifically, DOM listener registration
   * should be done in a linking function rather than in a compile function.
   * </div>
  
   * <div class="alert alert-warning">
   * **Note:** The compile function cannot handle directives that recursively use themselves in their
   * own templates or compile functions. Compiling these directives results in an infinite loop and
   * stack overflow errors.
   *
   * This can be avoided by manually using `$compile` in the postLink function to imperatively compile
   * a directive's template instead of relying on automatic template compilation via `template` or
   * `templateUrl` declaration or manual compilation inside the compile function.
   * </div>
   *
   * <div class="alert alert-danger">
   * **Note:** The `transclude` function that is passed to the compile function is deprecated, as it
   *   e.g. does not know about the right outer scope. Please use the transclude function that is passed
   *   to the link function instead.
   * </div>
  
   * A compile function can have a return value which can be either a function or an object.
   *
   * * returning a (post-link) function - is equivalent to registering the linking function via the
   *   `link` property of the config object when the compile function is empty.
   *
   * * returning an object with function(s) registered via `pre` and `post` properties - allows you to
   *   control when a linking function should be called during the linking phase. See info about
   *   pre-linking and post-linking functions below.
   *
   *
   * #### `link`
   * This property is used only if the `compile` property is not defined.
   *
   * ```js
   *   function link(scope, iElement, iAttrs, controller, transcludeFn) { ... }
   * ```
   *
   * The link function is responsible for registering DOM listeners as well as updating the DOM. It is
   * executed after the template has been cloned. This is where most of the directive logic will be
   * put.
   *
   *   * `scope` - {@link ng.$rootScope.Scope Scope} - The scope to be used by the
   *     directive for registering {@link ng.$rootScope.Scope#$watch watches}.
   *
   *   * `iElement` - instance element - The element where the directive is to be used. It is safe to
   *     manipulate the children of the element only in `postLink` function since the children have
   *     already been linked.
   *
   *   * `iAttrs` - instance attributes - Normalized list of attributes declared on this element shared
   *     between all directive linking functions.
   *
   *   * `controller` - the directive's required controller instance(s) - Instances are shared
   *     among all directives, which allows the directives to use the controllers as a communication
   *     channel. The exact value depends on the directive's `require` property:
   *       * no controller(s) required: the directive's own controller, or `undefined` if it doesn't have one
   *       * `string`: the controller instance
   *       * `array`: array of controller instances
   *
   *     If a required controller cannot be found, and it is optional, the instance is `null`,
   *     otherwise the {@link error:$compile:ctreq Missing Required Controller} error is thrown.
   *
   *     Note that you can also require the directive's own controller - it will be made available like
   *     any other controller.
   *
   *   * `transcludeFn` - A transclude linking function pre-bound to the correct transclusion scope.
   *     This is the same as the `$transclude` parameter of directive controllers,
   *     see {@link ng.$compile#-controller- the controller section for details}.
   *     `function([scope], cloneLinkingFn, futureParentElement)`.
   *
   * #### Pre-linking function
   *
   * Executed before the child elements are linked. Not safe to do DOM transformation since the
   * compiler linking function will fail to locate the correct elements for linking.
   *
   * #### Post-linking function
   *
   * Executed after the child elements are linked.
   *
   * Note that child elements that contain `templateUrl` directives will not have been compiled
   * and linked since they are waiting for their template to load asynchronously and their own
   * compilation and linking has been suspended until that occurs.
   *
   * It is safe to do DOM transformation in the post-linking function on elements that are not waiting
   * for their async templates to be resolved.
   *
   *
   * ### Transclusion
   *
   * Transclusion is the process of extracting a collection of DOM elements from one part of the DOM and
   * copying them to another part of the DOM, while maintaining their connection to the original AngularJS
   * scope from where they were taken.
   *
   * Transclusion is used (often with {@link ngTransclude}) to insert the
   * original contents of a directive's element into a specified place in the template of the directive.
   * The benefit of transclusion, over simply moving the DOM elements manually, is that the transcluded
   * content has access to the properties on the scope from which it was taken, even if the directive
   * has isolated scope.
   * See the {@link guide/directive#creating-a-directive-that-wraps-other-elements Directives Guide}.
   *
   * This makes it possible for the widget to have private state for its template, while the transcluded
   * content has access to its originating scope.
   *
   * <div class="alert alert-warning">
   * **Note:** When testing an element transclude directive you must not place the directive at the root of the
   * DOM fragment that is being compiled. See {@link guide/unit-testing#testing-transclusion-directives
   * Testing Transclusion Directives}.
   * </div>
   *
   * There are three kinds of transclusion depending upon whether you want to transclude just the contents of the
   * directive's element, the entire element or multiple parts of the element contents:
   *
   * * `true` - transclude the content (i.e. the child nodes) of the directive's element.
   * * `'element'` - transclude the whole of the directive's element including any directives on this
   *   element that are defined at a lower priority than this directive. When used, the `template`
   *   property is ignored.
   * * **`{...}` (an object hash):** - map elements of the content onto transclusion "slots" in the template.
   *
   * **Multi-slot transclusion** is declared by providing an object for the `transclude` property.
   *
   * This object is a map where the keys are the name of the slot to fill and the value is an element selector
   * used to match the HTML to the slot. The element selector should be in normalized form (e.g. `myElement`)
   * and will match the standard element variants (e.g. `my-element`, `my:element`, `data-my-element`, etc).
   *
   * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}.
   *
   * If the element selector is prefixed with a `?` then that slot is optional.
   *
   * For example, the transclude object `{ slotA: '?myCustomElement' }` maps `<my-custom-element>` elements to
   * the `slotA` slot, which can be accessed via the `$transclude` function or via the {@link ngTransclude} directive.
   *
   * Slots that are not marked as optional (`?`) will trigger a compile time error if there are no matching elements
   * in the transclude content. If you wish to know if an optional slot was filled with content, then you can call
   * `$transclude.isSlotFilled(slotName)` on the transclude function passed to the directive's link function and
   * injectable into the directive's controller.
   *
   *
   * #### Transclusion Functions
   *
   * When a directive requests transclusion, the compiler extracts its contents and provides a **transclusion
   * function** to the directive's `link` function and `controller`. This transclusion function is a special
   * **linking function** that will return the compiled contents linked to a new transclusion scope.
   *
   * <div class="alert alert-info">
   * If you are just using {@link ngTransclude} then you don't need to worry about this function, since
   * ngTransclude will deal with it for us.
   * </div>
   *
   * If you want to manually control the insertion and removal of the transcluded content in your directive
   * then you must use this transclude function. When you call a transclude function it returns a jqLite/JQuery
   * object that contains the compiled DOM, which is linked to the correct transclusion scope.
   *
   * When you call a transclusion function you can pass in a **clone attach function**. This function accepts
   * two parameters, `function(clone, scope) { ... }`, where the `clone` is a fresh compiled copy of your transcluded
   * content and the `scope` is the newly created transclusion scope, which the clone will be linked to.
   *
   * <div class="alert alert-info">
   * **Best Practice**: Always provide a `cloneFn` (clone attach function) when you call a transclude function
   * since you then get a fresh clone of the original DOM and also have access to the new transclusion scope.
   * </div>
   *
   * It is normal practice to attach your transcluded content (`clone`) to the DOM inside your **clone
   * attach function**:
   *
   * ```js
   * var transcludedContent, transclusionScope;
   *
   * $transclude(function(clone, scope) {
   *   element.append(clone);
   *   transcludedContent = clone;
   *   transclusionScope = scope;
   * });
   * ```
   *
   * Later, if you want to remove the transcluded content from your DOM then you should also destroy the
   * associated transclusion scope:
   *
   * ```js
   * transcludedContent.remove();
   * transclusionScope.$destroy();
   * ```
   *
   * <div class="alert alert-info">
   * **Best Practice**: if you intend to add and remove transcluded content manually in your directive
   * (by calling the transclude function to get the DOM and calling `element.remove()` to remove it),
   * then you are also responsible for calling `$destroy` on the transclusion scope.
   * </div>
   *
   * The built-in DOM manipulation directives, such as {@link ngIf}, {@link ngSwitch} and {@link ngRepeat}
   * automatically destroy their transcluded clones as necessary so you do not need to worry about this if
   * you are simply using {@link ngTransclude} to inject the transclusion into your directive.
   *
   *
   * #### Transclusion Scopes
   *
   * When you call a transclude function it returns a DOM fragment that is pre-bound to a **transclusion
   * scope**. This scope is special, in that it is a child of the directive's scope (and so gets destroyed
   * when the directive's scope gets destroyed) but it inherits the properties of the scope from which it
   * was taken.
   *
   * For example consider a directive that uses transclusion and isolated scope. The DOM hierarchy might look
   * like this:
   *
   * ```html
   * <div ng-app>
   *   <div isolate>
   *     <div transclusion>
   *     </div>
   *   </div>
   * </div>
   * ```
   *
   * The `$parent` scope hierarchy will look like this:
   *
     ```
     - $rootScope
       - isolate
         - transclusion
     ```
   *
   * but the scopes will inherit prototypically from different scopes to their `$parent`.
   *
     ```
     - $rootScope
       - transclusion
     - isolate
     ```
   *
   *
   * ### Attributes
   *
   * The {@link ng.$compile.directive.Attributes Attributes} object - passed as a parameter in the
   * `link()` or `compile()` functions. It has a variety of uses.
   *
   * * *Accessing normalized attribute names:* Directives like `ngBind` can be expressed in many ways:
   *   `ng:bind`, `data-ng-bind`, or `x-ng-bind`. The attributes object allows for normalized access
   *   to the attributes.
   *
   * * *Directive inter-communication:* All directives share the same instance of the attributes
   *   object which allows the directives to use the attributes object as inter directive
   *   communication.
   *
   * * *Supports interpolation:* Interpolation attributes are assigned to the attribute object
   *   allowing other directives to read the interpolated value.
   *
   * * *Observing interpolated attributes:* Use `$observe` to observe the value changes of attributes
   *   that contain interpolation (e.g. `src="{{bar}}"`). Not only is this very efficient but it's also
   *   the only way to easily get the actual value because during the linking phase the interpolation
   *   hasn't been evaluated yet and so the value is at this time set to `undefined`.
   *
   * ```js
   * function linkingFn(scope, elm, attrs, ctrl) {
   *   // get the attribute value
   *   console.log(attrs.ngModel);
   *
   *   // change the attribute
   *   attrs.$set('ngModel', 'new value');
   *
   *   // observe changes to interpolated attribute
   *   attrs.$observe('ngModel', function(value) {
   *     console.log('ngModel has changed value to ' + value);
   *   });
   * }
   * ```
   *
   * ## Example
   *
   * <div class="alert alert-warning">
   * **Note**: Typically directives are registered with `module.directive`. The example below is
   * to illustrate how `$compile` works.
   * </div>
   *
   <example module="compileExample" name="compile">
     <file name="index.html">
      <script>
        angular.module('compileExample', [], function($compileProvider) {
          // Configure new 'compile' directive by passing a directive
          // factory function. The factory function injects '$compile'.
          $compileProvider.directive('compile', function($compile) {
            // The directive factory creates a link function.
            return function(scope, element, attrs) {
              scope.$watch(
                function(scope) {
                  // Watch the 'compile' expression for changes.
                  return scope.$eval(attrs.compile);
                },
                function(value) {
                  // When the 'compile' expression changes
                  // assign it into the current DOM.
                  element.html(value);
  
                  // Compile the new DOM and link it to the current scope.
                  // NOTE: we only compile '.childNodes' so that we
                  // don't get into an infinite loop compiling ourselves.
                  $compile(element.contents())(scope);
                }
              );
            };
          });
        })
        .controller('GreeterController', ['$scope', function($scope) {
          $scope.name = 'AngularJS';
          $scope.html = 'Hello {{name}}';
        }]);
      </script>
      <div ng-controller="GreeterController">
        <input ng-model="name"> <br/>
        <textarea ng-model="html"></textarea> <br/>
        <div compile="html"></div>
      </div>
     </file>
     <file name="protractor.js" type="protractor">
       it('should auto compile', function() {
         var textarea = $('textarea');
         var output = $('div[compile]');
         // The initial state reads 'Hello AngularJS'.
         expect(output.getText()).toBe('Hello AngularJS');
         textarea.clear();
         textarea.sendKeys('{{name}}!');
         expect(output.getText()).toBe('AngularJS!');
       });
     </file>
   </example>
  
   *
   *
   * @param {string|DOMElement} element Element or HTML string to compile into a template function.
   * @param {function(angular.Scope, cloneAttachFn=)} transclude function available to directives - DEPRECATED.
   *
   * <div class="alert alert-danger">
   * **Note:** Passing a `transclude` function to the $compile function is deprecated, as it
   *   e.g. will not use the right outer scope. Please pass the transclude function as a
   *   `parentBoundTranscludeFn` to the link function instead.
   * </div>
   *
   * @param {number} maxPriority only apply directives lower than given priority (Only effects the
   *                 root element(s), not their children)
   * @returns {function(scope, cloneAttachFn=, options=)} a link function which is used to bind template
   * (a DOM element/tree) to a scope. Where:
   *
   *  * `scope` - A {@link ng.$rootScope.Scope Scope} to bind to.
   *  * `cloneAttachFn` - If `cloneAttachFn` is provided, then the link function will clone the
   *  `template` and call the `cloneAttachFn` function allowing the caller to attach the
   *  cloned elements to the DOM document at the appropriate place. The `cloneAttachFn` is
   *  called as: <br/> `cloneAttachFn(clonedElement, scope)` where:
   *
   *      * `clonedElement` - is a clone of the original `element` passed into the compiler.
   *      * `scope` - is the current scope with which the linking function is working with.
   *
   *  * `options` - An optional object hash with linking options. If `options` is provided, then the following
   *  keys may be used to control linking behavior:
   *
   *      * `parentBoundTranscludeFn` - the transclude function made available to
   *        directives; if given, it will be passed through to the link functions of
   *        directives found in `element` during compilation.
   *      * `transcludeControllers` - an object hash with keys that map controller names
   *        to a hash with the key `instance`, which maps to the controller instance;
   *        if given, it will make the controllers available to directives on the compileNode:
   *        ```
   *        {
   *          parent: {
   *            instance: parentControllerInstance
   *          }
   *        }
   *        ```
   *      * `futureParentElement` - defines the parent to which the `cloneAttachFn` will add
   *        the cloned elements; only needed for transcludes that are allowed to contain non HTML
   *        elements (e.g. SVG elements). See also the `directive.controller` property.
   *
   * Calling the linking function returns the element of the template. It is either the original
   * element passed in, or the clone of the element if the `cloneAttachFn` is provided.
   *
   * After linking the view is not updated until after a call to `$digest`, which typically is done by
   * AngularJS automatically.
   *
   * If you need access to the bound view, there are two ways to do it:
   *
   * - If you are not asking the linking function to clone the template, create the DOM element(s)
   *   before you send them to the compiler and keep this reference around.
   *   ```js
   *     var element = angular.element('<p>{{total}}</p>');
   *     $compile(element)(scope);
   *   ```
   *
   * - if on the other hand, you need the element to be cloned, the view reference from the original
   *   example would not point to the clone, but rather to the original template that was cloned. In
   *   this case, you can access the clone either via the `cloneAttachFn` or the value returned by the
   *   linking function:
   *   ```js
   *     var templateElement = angular.element('<p>{{total}}</p>');
   *     var clonedElement = $compile(templateElement)(scope, function(clonedElement, scope) {
   *       // Attach the clone to DOM document at the right place.
   *     });
   *
   *     // Now we have reference to the cloned DOM via `clonedElement`.
   *     // NOTE: The `clonedElement` returned by the linking function is the same as the
   *     //       `clonedElement` passed to `cloneAttachFn`.
   *   ```
   *
   *
   * For information on how the compiler works, see the
   * {@link guide/compiler AngularJS HTML Compiler} section of the Developer Guide.
   *
   * @knownIssue
   *
   * ### Double Compilation
   *
     Double compilation occurs when an already compiled part of the DOM gets
     compiled again. This is an undesired effect and can lead to misbehaving directives, performance issues,
     and memory leaks. Refer to the Compiler Guide {@link guide/compiler#double-compilation-and-how-to-avoid-it
     section on double compilation} for an in-depth explanation and ways to avoid it.
  
   * @knownIssue
  
     ### Issues with `replace: true`
   *
   * <div class="alert alert-danger">
   *   **Note**: {@link $compile#-replace- `replace: true`} is deprecated and not recommended to use,
   *   mainly due to the issues listed here. It has been completely removed in the new Angular.
   * </div>
   *
   * #### Attribute values are not merged
   *
   * When a `replace` directive encounters the same attribute on the original and the replace node,
   * it will simply deduplicate the attribute and join the values with a space or with a `;` in case of
   * the `style` attribute.
   * ```html
   * Original Node: <span class="original" style="color: red;"></span>
   * Replace Template: <span class="replaced" style="background: blue;"></span>
   * Result: <span class="original replaced" style="color: red; background: blue;"></span>
   * ```
   *
   * That means attributes that contain AngularJS expressions will not be merged correctly, e.g.
   * {@link ngShow} or {@link ngClass} will cause a {@link $parse} error:
   *
   * ```html
   * Original Node: <span ng-class="{'something': something}" ng-show="!condition"></span>
   * Replace Template: <span ng-class="{'else': else}" ng-show="otherCondition"></span>
   * Result: <span ng-class="{'something': something} {'else': else}" ng-show="!condition otherCondition"></span>
   * ```
   *
   * See issue [#5695](https://github.com/angular/angular.js/issues/5695).
   *
   * #### Directives are not deduplicated before compilation
   *
   * When the original node and the replace template declare the same directive(s), they will be
   * {@link guide/compiler#double-compilation-and-how-to-avoid-it compiled twice} because the compiler
   * does not deduplicate them. In many cases, this is not noticeable, but e.g. {@link ngModel} will
   * attach `$formatters` and `$parsers` twice.
   *
   * See issue [#2573](https://github.com/angular/angular.js/issues/2573).
   *
   * #### `transclude: element` in the replace template root can have unexpected effects
   *
   * When the replace template has a directive at the root node that uses
   * {@link $compile#-transclude- `transclude: element`}, e.g.
   * {@link ngIf} or {@link ngRepeat}, the DOM structure or scope inheritance can be incorrect.
   * See the following issues:
   *
   * - Incorrect scope on replaced element:
   * [#9837](https://github.com/angular/angular.js/issues/9837)
   * - Different DOM between `template` and `templateUrl`:
   * [#10612](https://github.com/angular/angular.js/issues/14326)
   *
   */

  /**
   * @ngdoc directive
   * @name ngProp
   * @restrict A
   * @element ANY
   *
   * @usage
   *
   * ```html
   * <ANY ng-prop-propname="expression">
   * </ANY>
   * ```
   *
   * or with uppercase letters in property (e.g. "propName"):
   *
   *
   * ```html
   * <ANY ng-prop-prop_name="expression">
   * </ANY>
   * ```
   *
   *
   * @description
   * The `ngProp` directive binds an expression to a DOM element property.
   * `ngProp` allows writing to arbitrary properties by including
   * the property name in the attribute, e.g. `ng-prop-value="'my value'"` binds 'my value' to
   * the `value` property.
   *
   * Usually, it's not necessary to write to properties in AngularJS, as the built-in directives
   * handle the most common use cases (instead of the above example, you would use {@link ngValue}).
   *
   * However, [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements)
   * often use custom properties to hold data, and `ngProp` can be used to provide input to these
   * custom elements.
   *
   * ## Binding to camelCase properties
   *
   * Since HTML attributes are case-insensitive, camelCase properties like `innerHTML` must be escaped.
   * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
   * `innerHTML`  must be written as `ng-prop-inner_h_t_m_l="expression"` (Note that this is just an
   * example, and for binding HTML {@link ngBindHtml} should be used.
   *
   * ## Security
   *
   * Binding expressions to arbitrary properties poses a security risk, as  properties like `innerHTML`
   * can insert potentially dangerous HTML into the application, e.g. script tags that execute
   * malicious code.
   * For this reason, `ngProp` applies Strict Contextual Escaping with the {@link ng.$sce $sce service}.
   * This means vulnerable properties require their content to be "trusted", based on the
   * context of the property. For example, the `innerHTML` is in the `HTML` context, and the
   * `iframe.src` property is in the `RESOURCE_URL` context, which requires that values written to
   * this property are trusted as a `RESOURCE_URL`.
   *
   * This can be set explicitly by calling $sce.trustAs(type, value) on the value that is
   * trusted before passing it to the `ng-prop-*` directive. There are exist shorthand methods for
   * each context type in the form of {@link ng.$sce#trustAsResourceUrl $sce.trustAsResourceUrl()} et al.
   *
   * In some cases you can also rely upon automatic sanitization of untrusted values - see below.
   *
   * Based on the context, other options may exist to mark a value as trusted / configure the behavior
   * of {@link ng.$sce}. For example, to restrict the `RESOURCE_URL` context to specific origins, use
   * the {@link $sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList()}
   * and {@link $sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList()}.
   *
   * {@link ng.$sce#what-trusted-context-types-are-supported- Find out more about the different context types}.
   *
   * ### HTML Sanitization
   *
   * By default, `$sce` will throw an error if it detects untrusted HTML content, and will not bind the
   * content.
   * However, if you include the {@link ngSanitize ngSanitize module}, it will try to sanitize the
   * potentially dangerous HTML, e.g. strip non-trusted tags and attributes when binding to
   * `innerHTML`.
   *
   * @example
   * ### Binding to different contexts
   *
   * <example name="ngProp" module="exampleNgProp">
   *   <file name="app.js">
   *     angular.module('exampleNgProp', [])
   *       .component('main', {
   *         templateUrl: 'main.html',
   *         controller: function($sce) {
   *           this.safeContent = '<strong>Safe content</strong>';
   *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
   *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
   *         }
   *       });
   *   </file>
   *   <file name="main.html">
   *     <div>
   *       <div class="prop-unit">
   *         Binding to a property without security context:
   *         <div class="prop-binding" ng-prop-inner_text="$ctrl.safeContent"></div>
   *         <span class="prop-note">innerText</span> (safeContent)
   *       </div>
   *
   *       <div class="prop-unit">
   *         "Safe" content that requires a security context will throw because the contents could potentially be dangerous ...
   *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
   *         <span class="prop-note">innerHTML</span> (safeContent)
   *       </div>
   *
   *       <div class="prop-unit">
   *         ... so that actually dangerous content cannot be executed:
   *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
   *         <span class="prop-note">innerHTML</span> (unsafeContent)
   *       </div>
   *
   *       <div class="prop-unit">
   *         ... but unsafe Content that has been trusted explicitly works - only do this if you are 100% sure!
   *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
   *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
   *       </div>
   *     </div>
   *   </file>
   *   <file name="index.html">
   *     <main></main>
   *   </file>
   *   <file name="styles.css">
   *     .prop-unit {
   *       margin-bottom: 10px;
   *     }
   *
   *     .prop-binding {
   *       min-height: 30px;
   *       border: 1px solid blue;
   *     }
   *
   *     .prop-note {
   *       font-family: Monospace;
   *     }
   *   </file>
   * </example>
   *
   *
   * @example
   * ### Binding to innerHTML with ngSanitize
   *
   * <example name="ngProp" module="exampleNgProp" deps="angular-sanitize.js">
   *   <file name="app.js">
   *     angular.module('exampleNgProp', ['ngSanitize'])
   *       .component('main', {
   *         templateUrl: 'main.html',
   *         controller: function($sce) {
   *           this.safeContent = '<strong>Safe content</strong>';
   *           this.unsafeContent = '<button onclick="alert(\'Hello XSS!\')">Click for XSS</button>';
   *           this.trustedUnsafeContent = $sce.trustAsHtml(this.unsafeContent);
   *         }
   *       });
   *   </file>
   *   <file name="main.html">
   *     <div>
   *       <div class="prop-unit">
   *         "Safe" content will be sanitized ...
   *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.safeContent"></div>
   *         <span class="prop-note">innerHTML</span> (safeContent)
   *       </div>
   *
   *       <div class="prop-unit">
   *         ... as will dangerous content:
   *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.unsafeContent"></div>
   *         <span class="prop-note">innerHTML</span> (unsafeContent)
   *       </div>
   *
   *       <div class="prop-unit">
   *         ... and content that has been trusted explicitly works the same as without ngSanitize:
   *         <div class="prop-binding" ng-prop-inner_h_t_m_l="$ctrl.trustedUnsafeContent"></div>
   *         <span class="prop-note">innerHTML</span> (trustedUnsafeContent)
   *       </div>
   *     </div>
   *   </file>
   *   <file name="index.html">
   *     <main></main>
   *   </file>
   *   <file name="styles.css">
   *     .prop-unit {
   *       margin-bottom: 10px;
   *     }
   *
   *     .prop-binding {
   *       min-height: 30px;
   *       border: 1px solid blue;
   *     }
   *
   *     .prop-note {
   *       font-family: Monospace;
   *     }
   *   </file>
   * </example>
   *
   */

  /** @ngdoc directive
   * @name ngOn
   * @restrict A
   * @element ANY
   *
   * @usage
   *
   * ```html
   * <ANY ng-on-eventname="expression">
   * </ANY>
   * ```
   *
   * or with uppercase letters in property (e.g. "eventName"):
   *
   *
   * ```html
   * <ANY ng-on-event_name="expression">
   * </ANY>
   * ```
   *
   * @description
   * The `ngOn` directive adds an event listener to a DOM element via
   * {@link angular.element angular.element().on()}, and evaluates an expression when the event is
   * fired.
   * `ngOn` allows adding listeners for arbitrary events by including
   * the event name in the attribute, e.g. `ng-on-drop="onDrop()"` executes the 'onDrop()' expression
   * when the `drop` event is fired.
   *
   * AngularJS provides specific directives for many events, such as {@link ngClick}, so in most
   * cases it is not necessary to use `ngOn`. However, AngularJS does not support all events
   * (e.g. the `drop` event in the example above), and new events might be introduced in later DOM
   * standards.
   *
   * Another use-case for `ngOn` is listening to
   * [custom events](https://developer.mozilla.org/docs/Web/Guide/Events/Creating_and_triggering_events)
   * fired by
   * [custom elements](https://developer.mozilla.org/docs/Web/Web_Components/Using_custom_elements).
   *
   * ## Binding to camelCase properties
   *
   * Since HTML attributes are case-insensitive, camelCase properties like `myEvent` must be escaped.
   * AngularJS uses the underscore (_) in front of a character to indicate that it is uppercase, so
   * `myEvent` must be written as `ng-on-my_event="expression"`.
   *
   * @example
   * ### Bind to built-in DOM events
   *
   * <example name="ngOn" module="exampleNgOn">
   *   <file name="app.js">
   *     angular.module('exampleNgOn', [])
   *       .component('main', {
   *         templateUrl: 'main.html',
   *         controller: function() {
   *           this.clickCount = 0;
   *           this.mouseoverCount = 0;
   *
   *           this.loadingState = 0;
   *         }
   *       });
   *   </file>
   *   <file name="main.html">
   *     <div>
   *       This is equivalent to `ngClick` and `ngMouseover`:<br>
   *       <button
   *         ng-on-click="$ctrl.clickCount = $ctrl.clickCount + 1"
   *         ng-on-mouseover="$ctrl.mouseoverCount = $ctrl.mouseoverCount + 1">Click or mouseover</button><br>
   *       clickCount: {{$ctrl.clickCount}}<br>
   *       mouseover: {{$ctrl.mouseoverCount}}
   *
   *       <hr>
   *
   *       For the `error` and `load` event on images no built-in AngularJS directives exist:<br>
   *       <img src="thisimagedoesnotexist.png" ng-on-error="$ctrl.loadingState = -1" ng-on-load="$ctrl.loadingState = 1"><br>
   *       <div ng-switch="$ctrl.loadingState">
   *         <span ng-switch-when="0">Image is loading</span>
   *         <span ng-switch-when="-1">Image load error</span>
   *         <span ng-switch-when="1">Image loaded successfully</span>
   *       </div>
   *     </div>
   *   </file>
   *   <file name="index.html">
   *     <main></main>
   *   </file>
   * </example>
   *
   *
   * @example
   * ### Bind to custom DOM events
   *
   * <example name="ngOnCustom" module="exampleNgOn">
   *   <file name="app.js">
   *     angular.module('exampleNgOn', [])
   *       .component('main', {
   *         templateUrl: 'main.html',
   *         controller: function() {
   *           this.eventLog = '';
   *
   *           this.listener = function($event) {
   *             this.eventLog = 'Event with type "' + $event.type + '" fired at ' + $event.detail;
   *           };
   *         }
   *       })
   *       .component('childComponent', {
   *         templateUrl: 'child.html',
   *         controller: function($element) {
   *           this.fireEvent = function() {
   *             var event = new CustomEvent('customtype', { detail: new Date()});
   *
   *             $element[0].dispatchEvent(event);
   *           };
   *         }
   *       });
   *   </file>
   *   <file name="main.html">
   *     <child-component ng-on-customtype="$ctrl.listener($event)"></child-component><br>
   *     <span>Event log: {{$ctrl.eventLog}}</span>
   *   </file>
   *   <file name="child.html">
        <button ng-click="$ctrl.fireEvent()">Fire custom event</button>
   *   </file>
   *   <file name="index.html">
   *     <main></main>
   *   </file>
   * </example>
   */

  var $compileMinErr = minErr('$compile');
  function UNINITIALIZED_VALUE() {}
  var _UNINITIALIZED_VALUE = new UNINITIALIZED_VALUE();

  /**
   * @ngdoc provider
   * @name $compileProvider
   *
   * @description
   */
  $CompileProvider.$inject = ['$provide', '$$sanitizeUriProvider'];
  /** @this */
  function $CompileProvider($provide, $$sanitizeUriProvider) {
    var hasDirectives = {},
      Suffix = 'Directive',
      COMMENT_DIRECTIVE_REGEXP = /^\s*directive:\s*([\w-]+)\s+(.*)$/,
      CLASS_DIRECTIVE_REGEXP = /(([\w-]+)(?::([^;]+))?;?)/,
      ALL_OR_NOTHING_ATTRS = makeMap('ngSrc,ngSrcset,src,srcset'),
      REQUIRE_PREFIX_REGEXP = /^(?:(\^\^?)?(\?)?(\^\^?)?)?/;

    // Ref: http://developers.whatwg.org/webappapis.html#event-handler-idl-attributes
    // The assumption is that future DOM event attribute names will begin with
    // 'on' and be composed of only English letters.
    var EVENT_HANDLER_ATTR_REGEXP = /^(on[a-z]+|formaction)$/;
    var bindingCache = createMap();
    function parseIsolateBindings(scope, directiveName, isController) {
      var LOCAL_REGEXP = /^([@&]|[=<](\*?))(\??)\s*([\w$]*)$/;
      var bindings = createMap();
      forEach(scope, function (definition, scopeName) {
        definition = definition.trim();
        if (definition in bindingCache) {
          bindings[scopeName] = bindingCache[definition];
          return;
        }
        var match = definition.match(LOCAL_REGEXP);
        if (!match) {
          throw $compileMinErr('iscp', 'Invalid {3} for directive \'{0}\'.' + ' Definition: {... {1}: \'{2}\' ...}', directiveName, scopeName, definition, isController ? 'controller bindings definition' : 'isolate scope definition');
        }
        bindings[scopeName] = {
          mode: match[1][0],
          collection: match[2] === '*',
          optional: match[3] === '?',
          attrName: match[4] || scopeName
        };
        if (match[4]) {
          bindingCache[definition] = bindings[scopeName];
        }
      });
      return bindings;
    }
    function parseDirectiveBindings(directive, directiveName) {
      var bindings = {
        isolateScope: null,
        bindToController: null
      };
      if (isObject(directive.scope)) {
        if (directive.bindToController === true) {
          bindings.bindToController = parseIsolateBindings(directive.scope, directiveName, true);
          bindings.isolateScope = {};
        } else {
          bindings.isolateScope = parseIsolateBindings(directive.scope, directiveName, false);
        }
      }
      if (isObject(directive.bindToController)) {
        bindings.bindToController = parseIsolateBindings(directive.bindToController, directiveName, true);
      }
      if (bindings.bindToController && !directive.controller) {
        // There is no controller
        throw $compileMinErr('noctrl', 'Cannot bind to controller without directive \'{0}\'s controller.', directiveName);
      }
      return bindings;
    }
    function assertValidDirectiveName(name) {
      var letter = name.charAt(0);
      if (!letter || letter !== lowercase(letter)) {
        throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The first character must be a lowercase letter', name);
      }
      if (name !== name.trim()) {
        throw $compileMinErr('baddir', 'Directive/Component name \'{0}\' is invalid. The name should not contain leading or trailing whitespaces', name);
      }
    }
    function getDirectiveRequire(directive) {
      var require = directive.require || directive.controller && directive.name;
      if (!isArray(require) && isObject(require)) {
        forEach(require, function (value, key) {
          var match = value.match(REQUIRE_PREFIX_REGEXP);
          var name = value.substring(match[0].length);
          if (!name) require[key] = match[0] + key;
        });
      }
      return require;
    }
    function getDirectiveRestrict(restrict, name) {
      if (restrict && !(isString(restrict) && /[EACM]/.test(restrict))) {
        throw $compileMinErr('badrestrict', 'Restrict property \'{0}\' of directive \'{1}\' is invalid', restrict, name);
      }
      return restrict || 'EA';
    }

    /**
     * @ngdoc method
     * @name $compileProvider#directive
     * @kind function
     *
     * @description
     * Register a new directive with the compiler.
     *
     * @param {string|Object} name Name of the directive in camel-case (i.e. `ngBind` which will match
     *    as `ng-bind`), or an object map of directives where the keys are the names and the values
     *    are the factories.
     * @param {Function|Array} directiveFactory An injectable directive factory function. See the
     *    {@link guide/directive directive guide} and the {@link $compile compile API} for more info.
     * @returns {ng.$compileProvider} Self for chaining.
     */
    this.directive = function registerDirective(name, directiveFactory) {
      assertArg(name, 'name');
      assertNotHasOwnProperty(name, 'directive');
      if (isString(name)) {
        assertValidDirectiveName(name);
        assertArg(directiveFactory, 'directiveFactory');
        if (!hasDirectives.hasOwnProperty(name)) {
          hasDirectives[name] = [];
          $provide.factory(name + Suffix, ['$injector', '$exceptionHandler', function ($injector, $exceptionHandler) {
            var directives = [];
            forEach(hasDirectives[name], function (directiveFactory, index) {
              try {
                var directive = $injector.invoke(directiveFactory);
                if (isFunction(directive)) {
                  directive = {
                    compile: valueFn(directive)
                  };
                } else if (!directive.compile && directive.link) {
                  directive.compile = valueFn(directive.link);
                }
                directive.priority = directive.priority || 0;
                directive.index = index;
                directive.name = directive.name || name;
                directive.require = getDirectiveRequire(directive);
                directive.restrict = getDirectiveRestrict(directive.restrict, name);
                directive.$$moduleName = directiveFactory.$$moduleName;
                directives.push(directive);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
            return directives;
          }]);
        }
        hasDirectives[name].push(directiveFactory);
      } else {
        forEach(name, reverseParams(registerDirective));
      }
      return this;
    };

    /**
     * @ngdoc method
     * @name $compileProvider#component
     * @module ng
     * @param {string|Object} name Name of the component in camelCase (i.e. `myComp` which will match `<my-comp>`),
     *    or an object map of components where the keys are the names and the values are the component definition objects.
     * @param {Object} options Component definition object (a simplified
     *    {@link ng.$compile#directive-definition-object directive definition object}),
     *    with the following properties (all optional):
     *
     *    - `controller` – `{(string|function()=}` – controller constructor function that should be
     *      associated with newly created scope or the name of a {@link ng.$compile#-controller-
     *      registered controller} if passed as a string. An empty `noop` function by default.
     *    - `controllerAs` – `{string=}` – identifier name for to reference the controller in the component's scope.
     *      If present, the controller will be published to scope under the `controllerAs` name.
     *      If not present, this will default to be `$ctrl`.
     *    - `template` – `{string=|function()=}` – html template as a string or a function that
     *      returns an html template as a string which should be used as the contents of this component.
     *      Empty string by default.
     *
     *      If `template` is a function, then it is {@link auto.$injector#invoke injected} with
     *      the following locals:
     *
     *      - `$element` - Current element
     *      - `$attrs` - Current attributes object for the element
     *
     *    - `templateUrl` – `{string=|function()=}` – path or function that returns a path to an html
     *      template that should be used  as the contents of this component.
     *
     *      If `templateUrl` is a function, then it is {@link auto.$injector#invoke injected} with
     *      the following locals:
     *
     *      - `$element` - Current element
     *      - `$attrs` - Current attributes object for the element
     *
     *    - `bindings` – `{object=}` – defines bindings between DOM attributes and component properties.
     *      Component properties are always bound to the component controller and not to the scope.
     *      See {@link ng.$compile#-bindtocontroller- `bindToController`}.
     *    - `transclude` – `{boolean=}` – whether {@link $compile#transclusion content transclusion} is enabled.
     *      Disabled by default.
     *    - `require` - `{Object<string, string>=}` - requires the controllers of other directives and binds them to
     *      this component's controller. The object keys specify the property names under which the required
     *      controllers (object values) will be bound. See {@link ng.$compile#-require- `require`}.
     *    - `$...` – additional properties to attach to the directive factory function and the controller
     *      constructor function. (This is used by the component router to annotate)
     *
     * @returns {ng.$compileProvider} the compile provider itself, for chaining of function calls.
     * @description
     * Register a **component definition** with the compiler. This is a shorthand for registering a special
     * type of directive, which represents a self-contained UI component in your application. Such components
     * are always isolated (i.e. `scope: {}`) and are always restricted to elements (i.e. `restrict: 'E'`).
     *
     * Component definitions are very simple and do not require as much configuration as defining general
     * directives. Component definitions usually consist only of a template and a controller backing it.
     *
     * In order to make the definition easier, components enforce best practices like use of `controllerAs`,
     * `bindToController`. They always have **isolate scope** and are restricted to elements.
     *
     * Here are a few examples of how you would usually define components:
     *
     * ```js
     *   var myMod = angular.module(...);
     *   myMod.component('myComp', {
     *     template: '<div>My name is {{$ctrl.name}}</div>',
     *     controller: function() {
     *       this.name = 'shahar';
     *     }
     *   });
     *
     *   myMod.component('myComp', {
     *     template: '<div>My name is {{$ctrl.name}}</div>',
     *     bindings: {name: '@'}
     *   });
     *
     *   myMod.component('myComp', {
     *     templateUrl: 'views/my-comp.html',
     *     controller: 'MyCtrl',
     *     controllerAs: 'ctrl',
     *     bindings: {name: '@'}
     *   });
     *
     * ```
     * For more examples, and an in-depth guide, see the {@link guide/component component guide}.
     *
     * <br />
     * See also {@link ng.$compileProvider#directive $compileProvider.directive()}.
     */
    this.component = function registerComponent(name, options) {
      if (!isString(name)) {
        forEach(name, reverseParams(bind(this, registerComponent)));
        return this;
      }
      var controller = options.controller || function () {};
      function factory($injector) {
        function makeInjectable(fn) {
          if (isFunction(fn) || isArray(fn)) {
            return /** @this */function (tElement, tAttrs) {
              return $injector.invoke(fn, this, {
                $element: tElement,
                $attrs: tAttrs
              });
            };
          } else {
            return fn;
          }
        }
        var template = !options.template && !options.templateUrl ? '' : options.template;
        var ddo = {
          controller: controller,
          controllerAs: identifierForController(options.controller) || options.controllerAs || '$ctrl',
          template: makeInjectable(template),
          templateUrl: makeInjectable(options.templateUrl),
          transclude: options.transclude,
          scope: {},
          bindToController: options.bindings || {},
          restrict: 'E',
          require: options.require
        };

        // Copy annotations (starting with $) over to the DDO
        forEach(options, function (val, key) {
          if (key.charAt(0) === '$') ddo[key] = val;
        });
        return ddo;
      }

      // TODO(pete) remove the following `forEach` before we release 1.6.0
      // The component-router@0.2.0 looks for the annotations on the controller constructor
      // Nothing in AngularJS looks for annotations on the factory function but we can't remove
      // it from 1.5.x yet.

      // Copy any annotation properties (starting with $) over to the factory and controller constructor functions
      // These could be used by libraries such as the new component router
      forEach(options, function (val, key) {
        if (key.charAt(0) === '$') {
          factory[key] = val;
          // Don't try to copy over annotations to named controller
          if (isFunction(controller)) controller[key] = val;
        }
      });
      factory.$inject = ['$injector'];
      return this.directive(name, factory);
    };

    /**
     * @ngdoc method
     * @name $compileProvider#aHrefSanitizationTrustedUrlList
     * @kind function
     *
     * @description
     * Retrieves or overrides the default regular expression that is used for determining trusted safe
     * urls during a[href] sanitization.
     *
     * The sanitization is a security measure aimed at preventing XSS attacks via html links.
     *
     * Any url about to be assigned to a[href] via data-binding is first normalized and turned into
     * an absolute url. Afterwards, the url is matched against the `aHrefSanitizationTrustedUrlList`
     * regular expression. If a match is found, the original url is written into the dom. Otherwise,
     * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
     *
     * @param {RegExp=} regexp New regexp to trust urls with.
     * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
     *    chaining otherwise.
     */
    this.aHrefSanitizationTrustedUrlList = function (regexp) {
      if (isDefined(regexp)) {
        $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList(regexp);
        return this;
      } else {
        return $$sanitizeUriProvider.aHrefSanitizationTrustedUrlList();
      }
    };

    /**
     * @ngdoc method
     * @name $compileProvider#aHrefSanitizationWhitelist
     * @kind function
     *
     * @deprecated
     * sinceVersion="1.8.1"
     *
     * This method is deprecated. Use {@link $compileProvider#aHrefSanitizationTrustedUrlList
     * aHrefSanitizationTrustedUrlList} instead.
     */
    Object.defineProperty(this, 'aHrefSanitizationWhitelist', {
      get: function get() {
        return this.aHrefSanitizationTrustedUrlList;
      },
      set: function set(value) {
        this.aHrefSanitizationTrustedUrlList = value;
      }
    });

    /**
     * @ngdoc method
     * @name $compileProvider#imgSrcSanitizationTrustedUrlList
     * @kind function
     *
     * @description
     * Retrieves or overrides the default regular expression that is used for determining trusted safe
     * urls during img[src] sanitization.
     *
     * The sanitization is a security measure aimed at prevent XSS attacks via html links.
     *
     * Any url about to be assigned to img[src] via data-binding is first normalized and turned into
     * an absolute url. Afterwards, the url is matched against the `imgSrcSanitizationTrustedUrlList`
     * regular expression. If a match is found, the original url is written into the dom. Otherwise,
     * the absolute url is prefixed with `'unsafe:'` string and only then is it written into the DOM.
     *
     * @param {RegExp=} regexp New regexp to trust urls with.
     * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
     *    chaining otherwise.
     */
    this.imgSrcSanitizationTrustedUrlList = function (regexp) {
      if (isDefined(regexp)) {
        $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList(regexp);
        return this;
      } else {
        return $$sanitizeUriProvider.imgSrcSanitizationTrustedUrlList();
      }
    };

    /**
     * @ngdoc method
     * @name $compileProvider#imgSrcSanitizationWhitelist
     * @kind function
     *
     * @deprecated
     * sinceVersion="1.8.1"
     *
     * This method is deprecated. Use {@link $compileProvider#imgSrcSanitizationTrustedUrlList
     * imgSrcSanitizationTrustedUrlList} instead.
     */
    Object.defineProperty(this, 'imgSrcSanitizationWhitelist', {
      get: function get() {
        return this.imgSrcSanitizationTrustedUrlList;
      },
      set: function set(value) {
        this.imgSrcSanitizationTrustedUrlList = value;
      }
    });

    /**
     * @ngdoc method
     * @name  $compileProvider#debugInfoEnabled
     *
     * @param {boolean=} enabled update the debugInfoEnabled state if provided, otherwise just return the
     * current debugInfoEnabled state
     * @returns {*} current value if used as getter or itself (chaining) if used as setter
     *
     * @kind function
     *
     * @description
     * Call this method to enable/disable various debug runtime information in the compiler such as adding
     * binding information and a reference to the current scope on to DOM elements.
     * If enabled, the compiler will add the following to DOM elements that have been bound to the scope
     * * `ng-binding` CSS class
     * * `ng-scope` and `ng-isolated-scope` CSS classes
     * * `$binding` data property containing an array of the binding expressions
     * * Data properties used by the {@link angular.element#methods `scope()`/`isolateScope()` methods} to return
     *   the element's scope.
     * * Placeholder comments will contain information about what directive and binding caused the placeholder.
     *   E.g. `<!-- ngIf: shouldShow() -->`.
     *
     * You may want to disable this in production for a significant performance boost. See
     * {@link guide/production#disabling-debug-data Disabling Debug Data} for more.
     *
     * The default value is true.
     */
    var debugInfoEnabled = true;
    this.debugInfoEnabled = function (enabled) {
      if (isDefined(enabled)) {
        debugInfoEnabled = enabled;
        return this;
      }
      return debugInfoEnabled;
    };

    /**
     * @ngdoc method
     * @name  $compileProvider#strictComponentBindingsEnabled
     *
     * @param {boolean=} enabled update the strictComponentBindingsEnabled state if provided,
     * otherwise return the current strictComponentBindingsEnabled state.
     * @returns {*} current value if used as getter or itself (chaining) if used as setter
     *
     * @kind function
     *
     * @description
     * Call this method to enable / disable the strict component bindings check. If enabled, the
     * compiler will enforce that all scope / controller bindings of a
     * {@link $compileProvider#directive directive} / {@link $compileProvider#component component}
     * that are not set as optional with `?`, must be provided when the directive is instantiated.
     * If not provided, the compiler will throw the
     * {@link error/$compile/missingattr $compile:missingattr error}.
     *
     * The default value is false.
     */
    var strictComponentBindingsEnabled = false;
    this.strictComponentBindingsEnabled = function (enabled) {
      if (isDefined(enabled)) {
        strictComponentBindingsEnabled = enabled;
        return this;
      }
      return strictComponentBindingsEnabled;
    };
    var TTL = 10;
    /**
     * @ngdoc method
     * @name $compileProvider#onChangesTtl
     * @description
     *
     * Sets the number of times `$onChanges` hooks can trigger new changes before giving up and
     * assuming that the model is unstable.
     *
     * The current default is 10 iterations.
     *
     * In complex applications it's possible that dependencies between `$onChanges` hooks and bindings will result
     * in several iterations of calls to these hooks. However if an application needs more than the default 10
     * iterations to stabilize then you should investigate what is causing the model to continuously change during
     * the `$onChanges` hook execution.
     *
     * Increasing the TTL could have performance implications, so you should not change it without proper justification.
     *
     * @param {number} limit The number of `$onChanges` hook iterations.
     * @returns {number|object} the current limit (or `this` if called as a setter for chaining)
     */
    this.onChangesTtl = function (value) {
      if (arguments.length) {
        TTL = value;
        return this;
      }
      return TTL;
    };
    var commentDirectivesEnabledConfig = true;
    /**
     * @ngdoc method
     * @name $compileProvider#commentDirectivesEnabled
     * @description
     *
     * It indicates to the compiler
     * whether or not directives on comments should be compiled.
     * Defaults to `true`.
     *
     * Calling this function with false disables the compilation of directives
     * on comments for the whole application.
     * This results in a compilation performance gain,
     * as the compiler doesn't have to check comments when looking for directives.
     * This should however only be used if you are sure that no comment directives are used in
     * the application (including any 3rd party directives).
     *
     * @param {boolean} enabled `false` if the compiler may ignore directives on comments
     * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
     */
    this.commentDirectivesEnabled = function (value) {
      if (arguments.length) {
        commentDirectivesEnabledConfig = value;
        return this;
      }
      return commentDirectivesEnabledConfig;
    };
    var cssClassDirectivesEnabledConfig = true;
    /**
     * @ngdoc method
     * @name $compileProvider#cssClassDirectivesEnabled
     * @description
     *
     * It indicates to the compiler
     * whether or not directives on element classes should be compiled.
     * Defaults to `true`.
     *
     * Calling this function with false disables the compilation of directives
     * on element classes for the whole application.
     * This results in a compilation performance gain,
     * as the compiler doesn't have to check element classes when looking for directives.
     * This should however only be used if you are sure that no class directives are used in
     * the application (including any 3rd party directives).
     *
     * @param {boolean} enabled `false` if the compiler may ignore directives on element classes
     * @returns {boolean|object} the current value (or `this` if called as a setter for chaining)
     */
    this.cssClassDirectivesEnabled = function (value) {
      if (arguments.length) {
        cssClassDirectivesEnabledConfig = value;
        return this;
      }
      return cssClassDirectivesEnabledConfig;
    };

    /**
     * The security context of DOM Properties.
     * @private
     */
    var PROP_CONTEXTS = createMap();

    /**
     * @ngdoc method
     * @name $compileProvider#addPropertySecurityContext
     * @description
     *
     * Defines the security context for DOM properties bound by ng-prop-*.
     *
     * @param {string} elementName The element name or '*' to match any element.
     * @param {string} propertyName The DOM property name.
     * @param {string} ctx The {@link $sce} security context in which this value is safe for use, e.g. `$sce.URL`
     * @returns {object} `this` for chaining
     */
    this.addPropertySecurityContext = function (elementName, propertyName, ctx) {
      var key = elementName.toLowerCase() + '|' + propertyName.toLowerCase();
      if (key in PROP_CONTEXTS && PROP_CONTEXTS[key] !== ctx) {
        throw $compileMinErr('ctxoverride', 'Property context \'{0}.{1}\' already set to \'{2}\', cannot override to \'{3}\'.', elementName, propertyName, PROP_CONTEXTS[key], ctx);
      }
      PROP_CONTEXTS[key] = ctx;
      return this;
    };

    /* Default property contexts.
     *
     * Copy of https://github.com/angular/angular/blob/6.0.6/packages/compiler/src/schema/dom_security_schema.ts#L31-L58
     * Changing:
     * - SecurityContext.* => SCE_CONTEXTS/$sce.*
     * - STYLE => CSS
     * - various URL => MEDIA_URL
     * - *|formAction, form|action URL => RESOURCE_URL (like the attribute)
     */
    (function registerNativePropertyContexts() {
      function registerContext(ctx, values) {
        forEach(values, function (v) {
          PROP_CONTEXTS[v.toLowerCase()] = ctx;
        });
      }
      registerContext(SCE_CONTEXTS.HTML, ['iframe|srcdoc', '*|innerHTML', '*|outerHTML']);
      registerContext(SCE_CONTEXTS.CSS, ['*|style']);
      registerContext(SCE_CONTEXTS.URL, ['area|href', 'area|ping', 'a|href', 'a|ping', 'blockquote|cite', 'body|background', 'del|cite', 'input|src', 'ins|cite', 'q|cite']);
      registerContext(SCE_CONTEXTS.MEDIA_URL, ['audio|src', 'img|src', 'img|srcset', 'source|src', 'source|srcset', 'track|src', 'video|src', 'video|poster']);
      registerContext(SCE_CONTEXTS.RESOURCE_URL, ['*|formAction', 'applet|code', 'applet|codebase', 'base|href', 'embed|src', 'frame|src', 'form|action', 'head|profile', 'html|manifest', 'iframe|src', 'link|href', 'media|src', 'object|codebase', 'object|data', 'script|src']);
    })();
    this.$get = ['$injector', '$interpolate', '$exceptionHandler', '$templateRequest', '$parse', '$controller', '$rootScope', '$sce', '$animate', function ($injector, $interpolate, $exceptionHandler, $templateRequest, $parse, $controller, $rootScope, $sce, $animate) {
      var SIMPLE_ATTR_NAME = /^\w/;
      var specialAttrHolder = window.document.createElement('div');
      var commentDirectivesEnabled = commentDirectivesEnabledConfig;
      var cssClassDirectivesEnabled = cssClassDirectivesEnabledConfig;
      var onChangesTtl = TTL;
      // The onChanges hooks should all be run together in a single digest
      // When changes occur, the call to trigger their hooks will be added to this queue
      var onChangesQueue;

      // This function is called in a $$postDigest to trigger all the onChanges hooks in a single digest
      function flushOnChangesQueue() {
        try {
          if (! --onChangesTtl) {
            // We have hit the TTL limit so reset everything
            onChangesQueue = undefined;
            throw $compileMinErr('infchng', '{0} $onChanges() iterations reached. Aborting!\n', TTL);
          }
          // We must run this hook in an apply since the $$postDigest runs outside apply
          $rootScope.$apply(function () {
            for (var i = 0, ii = onChangesQueue.length; i < ii; ++i) {
              try {
                onChangesQueue[i]();
              } catch (e) {
                $exceptionHandler(e);
              }
            }
            // Reset the queue to trigger a new schedule next time there is a change
            onChangesQueue = undefined;
          });
        } finally {
          onChangesTtl++;
        }
      }
      function sanitizeSrcset(value, invokeType) {
        if (!value) {
          return value;
        }
        if (!isString(value)) {
          throw $compileMinErr('srcset', 'Can\'t pass trusted values to `{0}`: "{1}"', invokeType, value.toString());
        }

        // Such values are a bit too complex to handle automatically inside $sce.
        // Instead, we sanitize each of the URIs individually, which works, even dynamically.

        // It's not possible to work around this using `$sce.trustAsMediaUrl`.
        // If you want to programmatically set explicitly trusted unsafe URLs, you should use
        // `$sce.trustAsHtml` on the whole `img` tag and inject it into the DOM using the
        // `ng-bind-html` directive.

        var result = '';

        // first check if there are spaces because it's not the same pattern
        var trimmedSrcset = trim(value);
        //                (   999x   ,|   999w   ,|   ,|,   )
        var srcPattern = /(\s+\d+x\s*,|\s+\d+w\s*,|\s+,|,\s+)/;
        var pattern = /\s/.test(trimmedSrcset) ? srcPattern : /(,)/;

        // split srcset into tuple of uri and descriptor except for the last item
        var rawUris = trimmedSrcset.split(pattern);

        // for each tuples
        var nbrUrisWith2parts = Math.floor(rawUris.length / 2);
        for (var i = 0; i < nbrUrisWith2parts; i++) {
          var innerIdx = i * 2;
          // sanitize the uri
          result += $sce.getTrustedMediaUrl(trim(rawUris[innerIdx]));
          // add the descriptor
          result += ' ' + trim(rawUris[innerIdx + 1]);
        }

        // split the last item into uri and descriptor
        var lastTuple = trim(rawUris[i * 2]).split(/\s/);

        // sanitize the last uri
        result += $sce.getTrustedMediaUrl(trim(lastTuple[0]));

        // and add the last descriptor if any
        if (lastTuple.length === 2) {
          result += ' ' + trim(lastTuple[1]);
        }
        return result;
      }
      function Attributes(element, attributesToCopy) {
        if (attributesToCopy) {
          var keys = Object.keys(attributesToCopy);
          var i, l, key;
          for (i = 0, l = keys.length; i < l; i++) {
            key = keys[i];
            this[key] = attributesToCopy[key];
          }
        } else {
          this.$attr = {};
        }
        this.$$element = element;
      }
      Attributes.prototype = {
        /**
         * @ngdoc method
         * @name $compile.directive.Attributes#$normalize
         * @kind function
         *
         * @description
         * Converts an attribute name (e.g. dash/colon/underscore-delimited string, optionally prefixed with `x-` or
         * `data-`) to its normalized, camelCase form.
         *
         * Also there is special case for Moz prefix starting with upper case letter.
         *
         * For further information check out the guide on {@link guide/directive#matching-directives Matching Directives}
         *
         * @param {string} name Name to normalize
         */
        $normalize: directiveNormalize,
        /**
         * @ngdoc method
         * @name $compile.directive.Attributes#$addClass
         * @kind function
         *
         * @description
         * Adds the CSS class value specified by the classVal parameter to the element. If animations
         * are enabled then an animation will be triggered for the class addition.
         *
         * @param {string} classVal The className value that will be added to the element
         */
        $addClass: function $addClass(classVal) {
          if (classVal && classVal.length > 0) {
            $animate.addClass(this.$$element, classVal);
          }
        },
        /**
         * @ngdoc method
         * @name $compile.directive.Attributes#$removeClass
         * @kind function
         *
         * @description
         * Removes the CSS class value specified by the classVal parameter from the element. If
         * animations are enabled then an animation will be triggered for the class removal.
         *
         * @param {string} classVal The className value that will be removed from the element
         */
        $removeClass: function $removeClass(classVal) {
          if (classVal && classVal.length > 0) {
            $animate.removeClass(this.$$element, classVal);
          }
        },
        /**
         * @ngdoc method
         * @name $compile.directive.Attributes#$updateClass
         * @kind function
         *
         * @description
         * Adds and removes the appropriate CSS class values to the element based on the difference
         * between the new and old CSS class values (specified as newClasses and oldClasses).
         *
         * @param {string} newClasses The current CSS className value
         * @param {string} oldClasses The former CSS className value
         */
        $updateClass: function $updateClass(newClasses, oldClasses) {
          var toAdd = tokenDifference(newClasses, oldClasses);
          if (toAdd && toAdd.length) {
            $animate.addClass(this.$$element, toAdd);
          }
          var toRemove = tokenDifference(oldClasses, newClasses);
          if (toRemove && toRemove.length) {
            $animate.removeClass(this.$$element, toRemove);
          }
        },
        /**
         * Set a normalized attribute on the element in a way such that all directives
         * can share the attribute. This function properly handles boolean attributes.
         * @param {string} key Normalized key. (ie ngAttribute)
         * @param {string|boolean} value The value to set. If `null` attribute will be deleted.
         * @param {boolean=} writeAttr If false, does not write the value to DOM element attribute.
         *     Defaults to true.
         * @param {string=} attrName Optional none normalized name. Defaults to key.
         */
        $set: function $set(key, value, writeAttr, attrName) {
          // TODO: decide whether or not to throw an error if "class"
          // is set through this function since it may cause $updateClass to
          // become unstable.

          var node = this.$$element[0],
            booleanKey = getBooleanAttrName(node, key),
            aliasedKey = getAliasedAttrName(key),
            observer = key,
            nodeName;
          if (booleanKey) {
            this.$$element.prop(key, value);
            attrName = booleanKey;
          } else if (aliasedKey) {
            this[aliasedKey] = value;
            observer = aliasedKey;
          }
          this[key] = value;

          // translate normalized key to actual key
          if (attrName) {
            this.$attr[key] = attrName;
          } else {
            attrName = this.$attr[key];
            if (!attrName) {
              this.$attr[key] = attrName = snake_case(key, '-');
            }
          }
          nodeName = nodeName_(this.$$element);

          // Sanitize img[srcset] values.
          if (nodeName === 'img' && key === 'srcset') {
            this[key] = value = sanitizeSrcset(value, '$set(\'srcset\', value)');
          }
          if (writeAttr !== false) {
            if (value === null || isUndefined(value)) {
              this.$$element.removeAttr(attrName);
            } else {
              if (SIMPLE_ATTR_NAME.test(attrName)) {
                // jQuery skips special boolean attrs treatment in XML nodes for
                // historical reasons and hence AngularJS cannot freely call
                // `.attr(attrName, false) with such attributes. To avoid issues
                // in XHTML, call `removeAttr` in such cases instead.
                // See https://github.com/jquery/jquery/issues/4249
                if (booleanKey && value === false) {
                  this.$$element.removeAttr(attrName);
                } else {
                  this.$$element.attr(attrName, value);
                }
              } else {
                setSpecialAttr(this.$$element[0], attrName, value);
              }
            }
          }

          // fire observers
          var $$observers = this.$$observers;
          if ($$observers) {
            forEach($$observers[observer], function (fn) {
              try {
                fn(value);
              } catch (e) {
                $exceptionHandler(e);
              }
            });
          }
        },
        /**
         * @ngdoc method
         * @name $compile.directive.Attributes#$observe
         * @kind function
         *
         * @description
         * Observes an interpolated attribute.
         *
         * The observer function will be invoked once during the next `$digest` following
         * compilation. The observer is then invoked whenever the interpolated value
         * changes.
         *
         * @param {string} key Normalized key. (ie ngAttribute) .
         * @param {function(interpolatedValue)} fn Function that will be called whenever
                  the interpolated value of the attribute changes.
         *        See the {@link guide/interpolation#how-text-and-attribute-bindings-work Interpolation
         *        guide} for more info.
         * @returns {function()} Returns a deregistration function for this observer.
         */
        $observe: function $observe(key, fn) {
          var attrs = this,
            $$observers = attrs.$$observers || (attrs.$$observers = createMap()),
            listeners = $$observers[key] || ($$observers[key] = []);
          listeners.push(fn);
          $rootScope.$evalAsync(function () {
            if (!listeners.$$inter && attrs.hasOwnProperty(key) && !isUndefined(attrs[key])) {
              // no one registered attribute interpolation function, so lets call it manually
              fn(attrs[key]);
            }
          });
          return function () {
            arrayRemove(listeners, fn);
          };
        }
      };
      function setSpecialAttr(element, attrName, value) {
        // Attributes names that do not start with letters (such as `(click)`) cannot be set using `setAttribute`
        // so we have to jump through some hoops to get such an attribute
        // https://github.com/angular/angular.js/pull/13318
        specialAttrHolder.innerHTML = '<span ' + attrName + '>';
        var attributes = specialAttrHolder.firstChild.attributes;
        var attribute = attributes[0];
        // We have to remove the attribute from its container element before we can add it to the destination element
        attributes.removeNamedItem(attribute.name);
        attribute.value = value;
        element.attributes.setNamedItem(attribute);
      }
      function safeAddClass($element, className) {
        try {
          $element.addClass(className);
        } catch (e) {
          // ignore, since it means that we are trying to set class on
          // SVG element, where class name is read-only.
        }
      }
      var startSymbol = $interpolate.startSymbol(),
        endSymbol = $interpolate.endSymbol(),
        denormalizeTemplate = startSymbol === '{{' && endSymbol === '}}' ? identity : function denormalizeTemplate(template) {
          return template.replace(/\{\{/g, startSymbol).replace(/}}/g, endSymbol);
        },
        NG_PREFIX_BINDING = /^ng(Attr|Prop|On)([A-Z].*)$/;
      var MULTI_ELEMENT_DIR_RE = /^(.+)Start$/;
      compile.$$addBindingInfo = debugInfoEnabled ? function $$addBindingInfo($element, binding) {
        var bindings = $element.data('$binding') || [];
        if (isArray(binding)) {
          bindings = bindings.concat(binding);
        } else {
          bindings.push(binding);
        }
        $element.data('$binding', bindings);
      } : noop;
      compile.$$addBindingClass = debugInfoEnabled ? function $$addBindingClass($element) {
        safeAddClass($element, 'ng-binding');
      } : noop;
      compile.$$addScopeInfo = debugInfoEnabled ? function $$addScopeInfo($element, scope, isolated, noTemplate) {
        var dataName = isolated ? noTemplate ? '$isolateScopeNoTemplate' : '$isolateScope' : '$scope';
        $element.data(dataName, scope);
      } : noop;
      compile.$$addScopeClass = debugInfoEnabled ? function $$addScopeClass($element, isolated) {
        safeAddClass($element, isolated ? 'ng-isolate-scope' : 'ng-scope');
      } : noop;
      compile.$$createComment = function (directiveName, comment) {
        var content = '';
        if (debugInfoEnabled) {
          content = ' ' + (directiveName || '') + ': ';
          if (comment) content += comment + ' ';
        }
        return window.document.createComment(content);
      };
      return compile;

      //================================

      function compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
        if (!($compileNodes instanceof jqLite)) {
          // jquery always rewraps, whereas we need to preserve the original selector so that we can
          // modify it.
          $compileNodes = jqLite($compileNodes);
        }
        var compositeLinkFn = compileNodes($compileNodes, transcludeFn, $compileNodes, maxPriority, ignoreDirective, previousCompileContext);
        compile.$$addScopeClass($compileNodes);
        var namespace = null;
        return function publicLinkFn(scope, cloneConnectFn, options) {
          if (!$compileNodes) {
            throw $compileMinErr('multilink', 'This element has already been linked.');
          }
          assertArg(scope, 'scope');
          if (previousCompileContext && previousCompileContext.needsNewScope) {
            // A parent directive did a replace and a directive on this element asked
            // for transclusion, which caused us to lose a layer of element on which
            // we could hold the new transclusion scope, so we will create it manually
            // here.
            scope = scope.$parent.$new();
          }
          options = options || {};
          var parentBoundTranscludeFn = options.parentBoundTranscludeFn,
            transcludeControllers = options.transcludeControllers,
            futureParentElement = options.futureParentElement;

          // When `parentBoundTranscludeFn` is passed, it is a
          // `controllersBoundTransclude` function (it was previously passed
          // as `transclude` to directive.link) so we must unwrap it to get
          // its `boundTranscludeFn`
          if (parentBoundTranscludeFn && parentBoundTranscludeFn.$$boundTransclude) {
            parentBoundTranscludeFn = parentBoundTranscludeFn.$$boundTransclude;
          }
          if (!namespace) {
            namespace = detectNamespaceForChildElements(futureParentElement);
          }
          var $linkNode;
          if (namespace !== 'html') {
            // When using a directive with replace:true and templateUrl the $compileNodes
            // (or a child element inside of them)
            // might change, so we need to recreate the namespace adapted compileNodes
            // for call to the link function.
            // Note: This will already clone the nodes...
            $linkNode = jqLite(wrapTemplate(namespace, jqLite('<div></div>').append($compileNodes).html()));
          } else if (cloneConnectFn) {
            // important!!: we must call our jqLite.clone() since the jQuery one is trying to be smart
            // and sometimes changes the structure of the DOM.
            $linkNode = JQLitePrototype.clone.call($compileNodes);
          } else {
            $linkNode = $compileNodes;
          }
          if (transcludeControllers) {
            for (var controllerName in transcludeControllers) {
              $linkNode.data('$' + controllerName + 'Controller', transcludeControllers[controllerName].instance);
            }
          }
          compile.$$addScopeInfo($linkNode, scope);
          if (cloneConnectFn) cloneConnectFn($linkNode, scope);
          if (compositeLinkFn) compositeLinkFn(scope, $linkNode, $linkNode, parentBoundTranscludeFn);
          if (!cloneConnectFn) {
            $compileNodes = compositeLinkFn = null;
          }
          return $linkNode;
        };
      }
      function detectNamespaceForChildElements(parentElement) {
        // TODO: Make this detect MathML as well...
        var node = parentElement && parentElement[0];
        if (!node) {
          return 'html';
        } else {
          return nodeName_(node) !== 'foreignobject' && toString.call(node).match(/SVG/) ? 'svg' : 'html';
        }
      }

      /**
       * Compile function matches each node in nodeList against the directives. Once all directives
       * for a particular node are collected their compile functions are executed. The compile
       * functions return values - the linking functions - are combined into a composite linking
       * function, which is the a linking function for the node.
       *
       * @param {NodeList} nodeList an array of nodes or NodeList to compile
       * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
       *        scope argument is auto-generated to the new child of the transcluded parent scope.
       * @param {DOMElement=} $rootElement If the nodeList is the root of the compilation tree then
       *        the rootElement must be set the jqLite collection of the compile root. This is
       *        needed so that the jqLite collection items can be replaced with widgets.
       * @param {number=} maxPriority Max directive priority.
       * @returns {Function} A composite linking function of all of the matched directives or null.
       */
      function compileNodes(nodeList, transcludeFn, $rootElement, maxPriority, ignoreDirective, previousCompileContext) {
        var linkFns = [],
          // `nodeList` can be either an element's `.childNodes` (live NodeList)
          // or a jqLite/jQuery collection or an array
          notLiveList = isArray(nodeList) || nodeList instanceof jqLite,
          attrs,
          directives,
          nodeLinkFn,
          childNodes,
          childLinkFn,
          linkFnFound,
          nodeLinkFnFound;
        for (var i = 0; i < nodeList.length; i++) {
          attrs = new Attributes();

          // Support: IE 11 only
          // Workaround for #11781 and #14924
          if (msie === 11) {
            mergeConsecutiveTextNodes(nodeList, i, notLiveList);
          }

          // We must always refer to `nodeList[i]` hereafter,
          // since the nodes can be replaced underneath us.
          directives = collectDirectives(nodeList[i], [], attrs, i === 0 ? maxPriority : undefined, ignoreDirective);
          nodeLinkFn = directives.length ? applyDirectivesToNode(directives, nodeList[i], attrs, transcludeFn, $rootElement, null, [], [], previousCompileContext) : null;
          if (nodeLinkFn && nodeLinkFn.scope) {
            compile.$$addScopeClass(attrs.$$element);
          }
          childLinkFn = nodeLinkFn && nodeLinkFn.terminal || !(childNodes = nodeList[i].childNodes) || !childNodes.length ? null : compileNodes(childNodes, nodeLinkFn ? (nodeLinkFn.transcludeOnThisElement || !nodeLinkFn.templateOnThisElement) && nodeLinkFn.transclude : transcludeFn);
          if (nodeLinkFn || childLinkFn) {
            linkFns.push(i, nodeLinkFn, childLinkFn);
            linkFnFound = true;
            nodeLinkFnFound = nodeLinkFnFound || nodeLinkFn;
          }

          //use the previous context only for the first element in the virtual group
          previousCompileContext = null;
        }

        // return a linking function if we have found anything, null otherwise
        return linkFnFound ? compositeLinkFn : null;
        function compositeLinkFn(scope, nodeList, $rootElement, parentBoundTranscludeFn) {
          var nodeLinkFn, childLinkFn, node, childScope, i, ii, idx, childBoundTranscludeFn;
          var stableNodeList;
          if (nodeLinkFnFound) {
            // copy nodeList so that if a nodeLinkFn removes or adds an element at this DOM level our
            // offsets don't get screwed up
            var nodeListLength = nodeList.length;
            stableNodeList = new Array(nodeListLength);

            // create a sparse array by only copying the elements which have a linkFn
            for (i = 0; i < linkFns.length; i += 3) {
              idx = linkFns[i];
              stableNodeList[idx] = nodeList[idx];
            }
          } else {
            stableNodeList = nodeList;
          }
          for (i = 0, ii = linkFns.length; i < ii;) {
            node = stableNodeList[linkFns[i++]];
            nodeLinkFn = linkFns[i++];
            childLinkFn = linkFns[i++];
            if (nodeLinkFn) {
              if (nodeLinkFn.scope) {
                childScope = scope.$new();
                compile.$$addScopeInfo(jqLite(node), childScope);
              } else {
                childScope = scope;
              }
              if (nodeLinkFn.transcludeOnThisElement) {
                childBoundTranscludeFn = createBoundTranscludeFn(scope, nodeLinkFn.transclude, parentBoundTranscludeFn);
              } else if (!nodeLinkFn.templateOnThisElement && parentBoundTranscludeFn) {
                childBoundTranscludeFn = parentBoundTranscludeFn;
              } else if (!parentBoundTranscludeFn && transcludeFn) {
                childBoundTranscludeFn = createBoundTranscludeFn(scope, transcludeFn);
              } else {
                childBoundTranscludeFn = null;
              }
              nodeLinkFn(childLinkFn, childScope, node, $rootElement, childBoundTranscludeFn);
            } else if (childLinkFn) {
              childLinkFn(scope, node.childNodes, undefined, parentBoundTranscludeFn);
            }
          }
        }
      }
      function mergeConsecutiveTextNodes(nodeList, idx, notLiveList) {
        var node = nodeList[idx];
        var parent = node.parentNode;
        var sibling;
        if (node.nodeType !== NODE_TYPE_TEXT) {
          return;
        }
        while (true) {
          sibling = parent ? node.nextSibling : nodeList[idx + 1];
          if (!sibling || sibling.nodeType !== NODE_TYPE_TEXT) {
            break;
          }
          node.nodeValue = node.nodeValue + sibling.nodeValue;
          if (sibling.parentNode) {
            sibling.parentNode.removeChild(sibling);
          }
          if (notLiveList && sibling === nodeList[idx + 1]) {
            nodeList.splice(idx + 1, 1);
          }
        }
      }
      function createBoundTranscludeFn(scope, transcludeFn, previousBoundTranscludeFn) {
        function boundTranscludeFn(transcludedScope, cloneFn, controllers, futureParentElement, containingScope) {
          if (!transcludedScope) {
            transcludedScope = scope.$new(false, containingScope);
            transcludedScope.$$transcluded = true;
          }
          return transcludeFn(transcludedScope, cloneFn, {
            parentBoundTranscludeFn: previousBoundTranscludeFn,
            transcludeControllers: controllers,
            futureParentElement: futureParentElement
          });
        }

        // We need  to attach the transclusion slots onto the `boundTranscludeFn`
        // so that they are available inside the `controllersBoundTransclude` function
        var boundSlots = boundTranscludeFn.$$slots = createMap();
        for (var slotName in transcludeFn.$$slots) {
          if (transcludeFn.$$slots[slotName]) {
            boundSlots[slotName] = createBoundTranscludeFn(scope, transcludeFn.$$slots[slotName], previousBoundTranscludeFn);
          } else {
            boundSlots[slotName] = null;
          }
        }
        return boundTranscludeFn;
      }

      /**
       * Looks for directives on the given node and adds them to the directive collection which is
       * sorted.
       *
       * @param node Node to search.
       * @param directives An array to which the directives are added to. This array is sorted before
       *        the function returns.
       * @param attrs The shared attrs object which is used to populate the normalized attributes.
       * @param {number=} maxPriority Max directive priority.
       */
      function collectDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
        var nodeType = node.nodeType,
          attrsMap = attrs.$attr,
          match,
          nodeName,
          className;
        switch (nodeType) {
          case NODE_TYPE_ELEMENT:
            /* Element */

            nodeName = nodeName_(node);

            // use the node name: <directive>
            addDirective(directives, directiveNormalize(nodeName), 'E', maxPriority, ignoreDirective);

            // iterate over the attributes
            for (var attr, name, nName, value, ngPrefixMatch, nAttrs = node.attributes, j = 0, jj = nAttrs && nAttrs.length; j < jj; j++) {
              var attrStartName = false;
              var attrEndName = false;
              var isNgAttr = false,
                isNgProp = false,
                isNgEvent = false;
              var multiElementMatch;
              attr = nAttrs[j];
              name = attr.name;
              value = attr.value;
              nName = directiveNormalize(name.toLowerCase());

              // Support ng-attr-*, ng-prop-* and ng-on-*
              if (ngPrefixMatch = nName.match(NG_PREFIX_BINDING)) {
                isNgAttr = ngPrefixMatch[1] === 'Attr';
                isNgProp = ngPrefixMatch[1] === 'Prop';
                isNgEvent = ngPrefixMatch[1] === 'On';

                // Normalize the non-prefixed name
                name = name.replace(PREFIX_REGEXP, '').toLowerCase().substr(4 + ngPrefixMatch[1].length).replace(/_(.)/g, function (match, letter) {
                  return letter.toUpperCase();
                });

                // Support *-start / *-end multi element directives
              } else if ((multiElementMatch = nName.match(MULTI_ELEMENT_DIR_RE)) && directiveIsMultiElement(multiElementMatch[1])) {
                attrStartName = name;
                attrEndName = name.substr(0, name.length - 5) + 'end';
                name = name.substr(0, name.length - 6);
              }
              if (isNgProp || isNgEvent) {
                attrs[nName] = value;
                attrsMap[nName] = attr.name;
                if (isNgProp) {
                  addPropertyDirective(node, directives, nName, name);
                } else {
                  addEventDirective(directives, nName, name);
                }
              } else {
                // Update nName for cases where a prefix was removed
                // NOTE: the .toLowerCase() is unnecessary and causes https://github.com/angular/angular.js/issues/16624 for ng-attr-*
                nName = directiveNormalize(name.toLowerCase());
                attrsMap[nName] = name;
                if (isNgAttr || !attrs.hasOwnProperty(nName)) {
                  attrs[nName] = value;
                  if (getBooleanAttrName(node, nName)) {
                    attrs[nName] = true; // presence means true
                  }
                }
                addAttrInterpolateDirective(node, directives, value, nName, isNgAttr);
                addDirective(directives, nName, 'A', maxPriority, ignoreDirective, attrStartName, attrEndName);
              }
            }
            if (nodeName === 'input' && node.getAttribute('type') === 'hidden') {
              // Hidden input elements can have strange behaviour when navigating back to the page
              // This tells the browser not to try to cache and reinstate previous values
              node.setAttribute('autocomplete', 'off');
            }

            // use class as directive
            if (!cssClassDirectivesEnabled) break;
            className = node.className;
            if (isObject(className)) {
              // Maybe SVGAnimatedString
              className = className.animVal;
            }
            if (isString(className) && className !== '') {
              while (match = CLASS_DIRECTIVE_REGEXP.exec(className)) {
                nName = directiveNormalize(match[2]);
                if (addDirective(directives, nName, 'C', maxPriority, ignoreDirective)) {
                  attrs[nName] = trim(match[3]);
                }
                className = className.substr(match.index + match[0].length);
              }
            }
            break;
          case NODE_TYPE_TEXT:
            /* Text Node */
            addTextInterpolateDirective(directives, node.nodeValue);
            break;
          case NODE_TYPE_COMMENT:
            /* Comment */
            if (!commentDirectivesEnabled) break;
            collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective);
            break;
        }
        directives.sort(byPriority);
        return directives;
      }
      function collectCommentDirectives(node, directives, attrs, maxPriority, ignoreDirective) {
        // function created because of performance, try/catch disables
        // the optimization of the whole function #14848
        try {
          var match = COMMENT_DIRECTIVE_REGEXP.exec(node.nodeValue);
          if (match) {
            var nName = directiveNormalize(match[1]);
            if (addDirective(directives, nName, 'M', maxPriority, ignoreDirective)) {
              attrs[nName] = trim(match[2]);
            }
          }
        } catch (e) {
          // turns out that under some circumstances IE9 throws errors when one attempts to read
          // comment's node value.
          // Just ignore it and continue. (Can't seem to reproduce in test case.)
        }
      }

      /**
       * Given a node with a directive-start it collects all of the siblings until it finds
       * directive-end.
       * @param node
       * @param attrStart
       * @param attrEnd
       * @returns {*}
       */
      function groupScan(node, attrStart, attrEnd) {
        var nodes = [];
        var depth = 0;
        if (attrStart && node.hasAttribute && node.hasAttribute(attrStart)) {
          do {
            if (!node) {
              throw $compileMinErr('uterdir', 'Unterminated attribute, found \'{0}\' but no matching \'{1}\' found.', attrStart, attrEnd);
            }
            if (node.nodeType === NODE_TYPE_ELEMENT) {
              if (node.hasAttribute(attrStart)) depth++;
              if (node.hasAttribute(attrEnd)) depth--;
            }
            nodes.push(node);
            node = node.nextSibling;
          } while (depth > 0);
        } else {
          nodes.push(node);
        }
        return jqLite(nodes);
      }

      /**
       * Wrapper for linking function which converts normal linking function into a grouped
       * linking function.
       * @param linkFn
       * @param attrStart
       * @param attrEnd
       * @returns {Function}
       */
      function groupElementsLinkFnWrapper(linkFn, attrStart, attrEnd) {
        return function groupedElementsLink(scope, element, attrs, controllers, transcludeFn) {
          element = groupScan(element[0], attrStart, attrEnd);
          return linkFn(scope, element, attrs, controllers, transcludeFn);
        };
      }

      /**
       * A function generator that is used to support both eager and lazy compilation
       * linking function.
       * @param eager
       * @param $compileNodes
       * @param transcludeFn
       * @param maxPriority
       * @param ignoreDirective
       * @param previousCompileContext
       * @returns {Function}
       */
      function compilationGenerator(eager, $compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext) {
        var compiled;
        if (eager) {
          return compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);
        }
        return /** @this */function lazyCompilation() {
          if (!compiled) {
            compiled = compile($compileNodes, transcludeFn, maxPriority, ignoreDirective, previousCompileContext);

            // Null out all of these references in order to make them eligible for garbage collection
            // since this is a potentially long lived closure
            $compileNodes = transcludeFn = previousCompileContext = null;
          }
          return compiled.apply(this, arguments);
        };
      }

      /**
       * Once the directives have been collected, their compile functions are executed. This method
       * is responsible for inlining directive templates as well as terminating the application
       * of the directives if the terminal directive has been reached.
       *
       * @param {Array} directives Array of collected directives to execute their compile function.
       *        this needs to be pre-sorted by priority order.
       * @param {Node} compileNode The raw DOM node to apply the compile functions to
       * @param {Object} templateAttrs The shared attribute function
       * @param {function(angular.Scope, cloneAttachFn=)} transcludeFn A linking function, where the
       *                                                  scope argument is auto-generated to the new
       *                                                  child of the transcluded parent scope.
       * @param {JQLite} jqCollection If we are working on the root of the compile tree then this
       *                              argument has the root jqLite array so that we can replace nodes
       *                              on it.
       * @param {Object=} originalReplaceDirective An optional directive that will be ignored when
       *                                           compiling the transclusion.
       * @param {Array.<Function>} preLinkFns
       * @param {Array.<Function>} postLinkFns
       * @param {Object} previousCompileContext Context used for previous compilation of the current
       *                                        node
       * @returns {Function} linkFn
       */
      function applyDirectivesToNode(directives, compileNode, templateAttrs, transcludeFn, jqCollection, originalReplaceDirective, preLinkFns, postLinkFns, previousCompileContext) {
        previousCompileContext = previousCompileContext || {};
        var terminalPriority = -Number.MAX_VALUE,
          newScopeDirective = previousCompileContext.newScopeDirective,
          controllerDirectives = previousCompileContext.controllerDirectives,
          newIsolateScopeDirective = previousCompileContext.newIsolateScopeDirective,
          templateDirective = previousCompileContext.templateDirective,
          nonTlbTranscludeDirective = previousCompileContext.nonTlbTranscludeDirective,
          hasTranscludeDirective = false,
          hasTemplate = false,
          hasElementTranscludeDirective = previousCompileContext.hasElementTranscludeDirective,
          $compileNode = templateAttrs.$$element = jqLite(compileNode),
          directive,
          directiveName,
          $template,
          replaceDirective = originalReplaceDirective,
          childTranscludeFn = transcludeFn,
          linkFn,
          didScanForMultipleTransclusion = false,
          mightHaveMultipleTransclusionError = false,
          directiveValue;

        // executes all directives on the current element
        for (var i = 0, ii = directives.length; i < ii; i++) {
          directive = directives[i];
          var attrStart = directive.$$start;
          var attrEnd = directive.$$end;

          // collect multiblock sections
          if (attrStart) {
            $compileNode = groupScan(compileNode, attrStart, attrEnd);
          }
          $template = undefined;
          if (terminalPriority > directive.priority) {
            break; // prevent further processing of directives
          }
          directiveValue = directive.scope;
          if (directiveValue) {
            // skip the check for directives with async templates, we'll check the derived sync
            // directive when the template arrives
            if (!directive.templateUrl) {
              if (isObject(directiveValue)) {
                // This directive is trying to add an isolated scope.
                // Check that there is no scope of any kind already
                assertNoDuplicate('new/isolated scope', newIsolateScopeDirective || newScopeDirective, directive, $compileNode);
                newIsolateScopeDirective = directive;
              } else {
                // This directive is trying to add a child scope.
                // Check that there is no isolated scope already
                assertNoDuplicate('new/isolated scope', newIsolateScopeDirective, directive, $compileNode);
              }
            }
            newScopeDirective = newScopeDirective || directive;
          }
          directiveName = directive.name;

          // If we encounter a condition that can result in transclusion on the directive,
          // then scan ahead in the remaining directives for others that may cause a multiple
          // transclusion error to be thrown during the compilation process.  If a matching directive
          // is found, then we know that when we encounter a transcluded directive, we need to eagerly
          // compile the `transclude` function rather than doing it lazily in order to throw
          // exceptions at the correct time
          if (!didScanForMultipleTransclusion && (directive.replace && (directive.templateUrl || directive.template) || directive.transclude && !directive.$$tlb)) {
            var candidateDirective;
            for (var scanningIndex = i + 1; candidateDirective = directives[scanningIndex++];) {
              if (candidateDirective.transclude && !candidateDirective.$$tlb || candidateDirective.replace && (candidateDirective.templateUrl || candidateDirective.template)) {
                mightHaveMultipleTransclusionError = true;
                break;
              }
            }
            didScanForMultipleTransclusion = true;
          }
          if (!directive.templateUrl && directive.controller) {
            controllerDirectives = controllerDirectives || createMap();
            assertNoDuplicate('\'' + directiveName + '\' controller', controllerDirectives[directiveName], directive, $compileNode);
            controllerDirectives[directiveName] = directive;
          }
          directiveValue = directive.transclude;
          if (directiveValue) {
            hasTranscludeDirective = true;

            // Special case ngIf and ngRepeat so that we don't complain about duplicate transclusion.
            // This option should only be used by directives that know how to safely handle element transclusion,
            // where the transcluded nodes are added or replaced after linking.
            if (!directive.$$tlb) {
              assertNoDuplicate('transclusion', nonTlbTranscludeDirective, directive, $compileNode);
              nonTlbTranscludeDirective = directive;
            }
            if (directiveValue === 'element') {
              hasElementTranscludeDirective = true;
              terminalPriority = directive.priority;
              $template = $compileNode;
              $compileNode = templateAttrs.$$element = jqLite(compile.$$createComment(directiveName, templateAttrs[directiveName]));
              compileNode = $compileNode[0];
              replaceWith(jqCollection, sliceArgs($template), compileNode);
              childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, terminalPriority, replaceDirective && replaceDirective.name, {
                // Don't pass in:
                // - controllerDirectives - otherwise we'll create duplicates controllers
                // - newIsolateScopeDirective or templateDirective - combining templates with
                //   element transclusion doesn't make sense.
                //
                // We need only nonTlbTranscludeDirective so that we prevent putting transclusion
                // on the same element more than once.
                nonTlbTranscludeDirective: nonTlbTranscludeDirective
              });
            } else {
              var slots = createMap();
              if (!isObject(directiveValue)) {
                $template = jqLite(jqLiteClone(compileNode)).contents();
              } else {
                // We have transclusion slots,
                // collect them up, compile them and store their transclusion functions
                $template = window.document.createDocumentFragment();
                var slotMap = createMap();
                var filledSlots = createMap();

                // Parse the element selectors
                forEach(directiveValue, function (elementSelector, slotName) {
                  // If an element selector starts with a ? then it is optional
                  var optional = elementSelector.charAt(0) === '?';
                  elementSelector = optional ? elementSelector.substring(1) : elementSelector;
                  slotMap[elementSelector] = slotName;

                  // We explicitly assign `null` since this implies that a slot was defined but not filled.
                  // Later when calling boundTransclusion functions with a slot name we only error if the
                  // slot is `undefined`
                  slots[slotName] = null;

                  // filledSlots contains `true` for all slots that are either optional or have been
                  // filled. This is used to check that we have not missed any required slots
                  filledSlots[slotName] = optional;
                });

                // Add the matching elements into their slot
                forEach($compileNode.contents(), function (node) {
                  var slotName = slotMap[directiveNormalize(nodeName_(node))];
                  if (slotName) {
                    filledSlots[slotName] = true;
                    slots[slotName] = slots[slotName] || window.document.createDocumentFragment();
                    slots[slotName].appendChild(node);
                  } else {
                    $template.appendChild(node);
                  }
                });

                // Check for required slots that were not filled
                forEach(filledSlots, function (filled, slotName) {
                  if (!filled) {
                    throw $compileMinErr('reqslot', 'Required transclusion slot `{0}` was not filled.', slotName);
                  }
                });
                for (var slotName in slots) {
                  if (slots[slotName]) {
                    // Only define a transclusion function if the slot was filled
                    var slotCompileNodes = jqLite(slots[slotName].childNodes);
                    slots[slotName] = compilationGenerator(mightHaveMultipleTransclusionError, slotCompileNodes, transcludeFn);
                  }
                }
                $template = jqLite($template.childNodes);
              }
              $compileNode.empty(); // clear contents
              childTranscludeFn = compilationGenerator(mightHaveMultipleTransclusionError, $template, transcludeFn, undefined, undefined, {
                needsNewScope: directive.$$isolateScope || directive.$$newScope
              });
              childTranscludeFn.$$slots = slots;
            }
          }
          if (directive.template) {
            hasTemplate = true;
            assertNoDuplicate('template', templateDirective, directive, $compileNode);
            templateDirective = directive;
            directiveValue = isFunction(directive.template) ? directive.template($compileNode, templateAttrs) : directive.template;
            directiveValue = denormalizeTemplate(directiveValue);
            if (directive.replace) {
              replaceDirective = directive;
              if (jqLiteIsTextNode(directiveValue)) {
                $template = [];
              } else {
                $template = removeComments(wrapTemplate(directive.templateNamespace, trim(directiveValue)));
              }
              compileNode = $template[0];
              if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
                throw $compileMinErr('tplrt', 'Template for directive \'{0}\' must have exactly one root element. {1}', directiveName, '');
              }
              replaceWith(jqCollection, $compileNode, compileNode);
              var newTemplateAttrs = {
                $attr: {}
              };

              // combine directives from the original node and from the template:
              // - take the array of directives for this element
              // - split it into two parts, those that already applied (processed) and those that weren't (unprocessed)
              // - collect directives from the template and sort them by priority
              // - combine directives as: processed + template + unprocessed
              var templateDirectives = collectDirectives(compileNode, [], newTemplateAttrs);
              var unprocessedDirectives = directives.splice(i + 1, directives.length - (i + 1));
              if (newIsolateScopeDirective || newScopeDirective) {
                // The original directive caused the current element to be replaced but this element
                // also needs to have a new scope, so we need to tell the template directives
                // that they would need to get their scope from further up, if they require transclusion
                markDirectiveScope(templateDirectives, newIsolateScopeDirective, newScopeDirective);
              }
              directives = directives.concat(templateDirectives).concat(unprocessedDirectives);
              mergeTemplateAttributes(templateAttrs, newTemplateAttrs);
              ii = directives.length;
            } else {
              $compileNode.html(directiveValue);
            }
          }
          if (directive.templateUrl) {
            hasTemplate = true;
            assertNoDuplicate('template', templateDirective, directive, $compileNode);
            templateDirective = directive;
            if (directive.replace) {
              replaceDirective = directive;
            }

            // eslint-disable-next-line no-func-assign
            nodeLinkFn = compileTemplateUrl(directives.splice(i, directives.length - i), $compileNode, templateAttrs, jqCollection, hasTranscludeDirective && childTranscludeFn, preLinkFns, postLinkFns, {
              controllerDirectives: controllerDirectives,
              newScopeDirective: newScopeDirective !== directive && newScopeDirective,
              newIsolateScopeDirective: newIsolateScopeDirective,
              templateDirective: templateDirective,
              nonTlbTranscludeDirective: nonTlbTranscludeDirective
            });
            ii = directives.length;
          } else if (directive.compile) {
            try {
              linkFn = directive.compile($compileNode, templateAttrs, childTranscludeFn);
              var context = directive.$$originalDirective || directive;
              if (isFunction(linkFn)) {
                addLinkFns(null, bind(context, linkFn), attrStart, attrEnd);
              } else if (linkFn) {
                addLinkFns(bind(context, linkFn.pre), bind(context, linkFn.post), attrStart, attrEnd);
              }
            } catch (e) {
              $exceptionHandler(e, startingTag($compileNode));
            }
          }
          if (directive.terminal) {
            nodeLinkFn.terminal = true;
            terminalPriority = Math.max(terminalPriority, directive.priority);
          }
        }
        nodeLinkFn.scope = newScopeDirective && newScopeDirective.scope === true;
        nodeLinkFn.transcludeOnThisElement = hasTranscludeDirective;
        nodeLinkFn.templateOnThisElement = hasTemplate;
        nodeLinkFn.transclude = childTranscludeFn;
        previousCompileContext.hasElementTranscludeDirective = hasElementTranscludeDirective;

        // might be normal or delayed nodeLinkFn depending on if templateUrl is present
        return nodeLinkFn;

        ////////////////////

        function addLinkFns(pre, post, attrStart, attrEnd) {
          if (pre) {
            if (attrStart) pre = groupElementsLinkFnWrapper(pre, attrStart, attrEnd);
            pre.require = directive.require;
            pre.directiveName = directiveName;
            if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
              pre = cloneAndAnnotateFn(pre, {
                isolateScope: true
              });
            }
            preLinkFns.push(pre);
          }
          if (post) {
            if (attrStart) post = groupElementsLinkFnWrapper(post, attrStart, attrEnd);
            post.require = directive.require;
            post.directiveName = directiveName;
            if (newIsolateScopeDirective === directive || directive.$$isolateScope) {
              post = cloneAndAnnotateFn(post, {
                isolateScope: true
              });
            }
            postLinkFns.push(post);
          }
        }
        function nodeLinkFn(childLinkFn, scope, linkNode, $rootElement, boundTranscludeFn) {
          var i, ii, linkFn, isolateScope, controllerScope, elementControllers, transcludeFn, $element, attrs, scopeBindingInfo;
          if (compileNode === linkNode) {
            attrs = templateAttrs;
            $element = templateAttrs.$$element;
          } else {
            $element = jqLite(linkNode);
            attrs = new Attributes($element, templateAttrs);
          }
          controllerScope = scope;
          if (newIsolateScopeDirective) {
            isolateScope = scope.$new(true);
          } else if (newScopeDirective) {
            controllerScope = scope.$parent;
          }
          if (boundTranscludeFn) {
            // track `boundTranscludeFn` so it can be unwrapped if `transcludeFn`
            // is later passed as `parentBoundTranscludeFn` to `publicLinkFn`
            transcludeFn = controllersBoundTransclude;
            transcludeFn.$$boundTransclude = boundTranscludeFn;
            // expose the slots on the `$transclude` function
            transcludeFn.isSlotFilled = function (slotName) {
              return !!boundTranscludeFn.$$slots[slotName];
            };
          }
          if (controllerDirectives) {
            elementControllers = setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective);
          }
          if (newIsolateScopeDirective) {
            // Initialize isolate scope bindings for new isolate scope directive.
            compile.$$addScopeInfo($element, isolateScope, true, !(templateDirective && (templateDirective === newIsolateScopeDirective || templateDirective === newIsolateScopeDirective.$$originalDirective)));
            compile.$$addScopeClass($element, true);
            isolateScope.$$isolateBindings = newIsolateScopeDirective.$$isolateBindings;
            scopeBindingInfo = initializeDirectiveBindings(scope, attrs, isolateScope, isolateScope.$$isolateBindings, newIsolateScopeDirective);
            if (scopeBindingInfo.removeWatches) {
              isolateScope.$on('$destroy', scopeBindingInfo.removeWatches);
            }
          }

          // Initialize bindToController bindings
          for (var name in elementControllers) {
            var controllerDirective = controllerDirectives[name];
            var controller = elementControllers[name];
            var bindings = controllerDirective.$$bindings.bindToController;
            controller.instance = controller();
            $element.data('$' + controllerDirective.name + 'Controller', controller.instance);
            controller.bindingInfo = initializeDirectiveBindings(controllerScope, attrs, controller.instance, bindings, controllerDirective);
          }

          // Bind the required controllers to the controller, if `require` is an object and `bindToController` is truthy
          forEach(controllerDirectives, function (controllerDirective, name) {
            var require = controllerDirective.require;
            if (controllerDirective.bindToController && !isArray(require) && isObject(require)) {
              extend(elementControllers[name].instance, getControllers(name, require, $element, elementControllers));
            }
          });

          // Handle the init and destroy lifecycle hooks on all controllers that have them
          forEach(elementControllers, function (controller) {
            var controllerInstance = controller.instance;
            if (isFunction(controllerInstance.$onChanges)) {
              try {
                controllerInstance.$onChanges(controller.bindingInfo.initialChanges);
              } catch (e) {
                $exceptionHandler(e);
              }
            }
            if (isFunction(controllerInstance.$onInit)) {
              try {
                controllerInstance.$onInit();
              } catch (e) {
                $exceptionHandler(e);
              }
            }
            if (isFunction(controllerInstance.$doCheck)) {
              controllerScope.$watch(function () {
                controllerInstance.$doCheck();
              });
              controllerInstance.$doCheck();
            }
            if (isFunction(controllerInstance.$onDestroy)) {
              controllerScope.$on('$destroy', function callOnDestroyHook() {
                controllerInstance.$onDestroy();
              });
            }
          });

          // PRELINKING
          for (i = 0, ii = preLinkFns.length; i < ii; i++) {
            linkFn = preLinkFns[i];
            invokeLinkFn(linkFn, linkFn.isolateScope ? isolateScope : scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);
          }

          // RECURSION
          // We only pass the isolate scope, if the isolate directive has a template,
          // otherwise the child elements do not belong to the isolate directive.
          var scopeToChild = scope;
          if (newIsolateScopeDirective && (newIsolateScopeDirective.template || newIsolateScopeDirective.templateUrl === null)) {
            scopeToChild = isolateScope;
          }
          if (childLinkFn) {
            childLinkFn(scopeToChild, linkNode.childNodes, undefined, boundTranscludeFn);
          }

          // POSTLINKING
          for (i = postLinkFns.length - 1; i >= 0; i--) {
            linkFn = postLinkFns[i];
            invokeLinkFn(linkFn, linkFn.isolateScope ? isolateScope : scope, $element, attrs, linkFn.require && getControllers(linkFn.directiveName, linkFn.require, $element, elementControllers), transcludeFn);
          }

          // Trigger $postLink lifecycle hooks
          forEach(elementControllers, function (controller) {
            var controllerInstance = controller.instance;
            if (isFunction(controllerInstance.$postLink)) {
              controllerInstance.$postLink();
            }
          });

          // This is the function that is injected as `$transclude`.
          // Note: all arguments are optional!
          function controllersBoundTransclude(scope, cloneAttachFn, futureParentElement, slotName) {
            var transcludeControllers;
            // No scope passed in:
            if (!isScope(scope)) {
              slotName = futureParentElement;
              futureParentElement = cloneAttachFn;
              cloneAttachFn = scope;
              scope = undefined;
            }
            if (hasElementTranscludeDirective) {
              transcludeControllers = elementControllers;
            }
            if (!futureParentElement) {
              futureParentElement = hasElementTranscludeDirective ? $element.parent() : $element;
            }
            if (slotName) {
              // slotTranscludeFn can be one of three things:
              //  * a transclude function - a filled slot
              //  * `null` - an optional slot that was not filled
              //  * `undefined` - a slot that was not declared (i.e. invalid)
              var slotTranscludeFn = boundTranscludeFn.$$slots[slotName];
              if (slotTranscludeFn) {
                return slotTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
              } else if (isUndefined(slotTranscludeFn)) {
                throw $compileMinErr('noslot', 'No parent directive that requires a transclusion with slot name "{0}". ' + 'Element: {1}', slotName, startingTag($element));
              }
            } else {
              return boundTranscludeFn(scope, cloneAttachFn, transcludeControllers, futureParentElement, scopeToChild);
            }
          }
        }
      }
      function getControllers(directiveName, require, $element, elementControllers) {
        var value;
        if (isString(require)) {
          var match = require.match(REQUIRE_PREFIX_REGEXP);
          var name = require.substring(match[0].length);
          var inheritType = match[1] || match[3];
          var optional = match[2] === '?';

          //If only parents then start at the parent element
          if (inheritType === '^^') {
            $element = $element.parent();
            //Otherwise attempt getting the controller from elementControllers in case
            //the element is transcluded (and has no data) and to avoid .data if possible
          } else {
            value = elementControllers && elementControllers[name];
            value = value && value.instance;
          }
          if (!value) {
            var dataName = '$' + name + 'Controller';
            if (inheritType === '^^' && $element[0] && $element[0].nodeType === NODE_TYPE_DOCUMENT) {
              // inheritedData() uses the documentElement when it finds the document, so we would
              // require from the element itself.
              value = null;
            } else {
              value = inheritType ? $element.inheritedData(dataName) : $element.data(dataName);
            }
          }
          if (!value && !optional) {
            throw $compileMinErr('ctreq', 'Controller \'{0}\', required by directive \'{1}\', can\'t be found!', name, directiveName);
          }
        } else if (isArray(require)) {
          value = [];
          for (var i = 0, ii = require.length; i < ii; i++) {
            value[i] = getControllers(directiveName, require[i], $element, elementControllers);
          }
        } else if (isObject(require)) {
          value = {};
          forEach(require, function (controller, property) {
            value[property] = getControllers(directiveName, controller, $element, elementControllers);
          });
        }
        return value || null;
      }
      function setupControllers($element, attrs, transcludeFn, controllerDirectives, isolateScope, scope, newIsolateScopeDirective) {
        var elementControllers = createMap();
        for (var controllerKey in controllerDirectives) {
          var directive = controllerDirectives[controllerKey];
          var locals = {
            $scope: directive === newIsolateScopeDirective || directive.$$isolateScope ? isolateScope : scope,
            $element: $element,
            $attrs: attrs,
            $transclude: transcludeFn
          };
          var controller = directive.controller;
          if (controller === '@') {
            controller = attrs[directive.name];
          }
          var controllerInstance = $controller(controller, locals, true, directive.controllerAs);

          // For directives with element transclusion the element is a comment.
          // In this case .data will not attach any data.
          // Instead, we save the controllers for the element in a local hash and attach to .data
          // later, once we have the actual element.
          elementControllers[directive.name] = controllerInstance;
          $element.data('$' + directive.name + 'Controller', controllerInstance.instance);
        }
        return elementControllers;
      }

      // Depending upon the context in which a directive finds itself it might need to have a new isolated
      // or child scope created. For instance:
      // * if the directive has been pulled into a template because another directive with a higher priority
      // asked for element transclusion
      // * if the directive itself asks for transclusion but it is at the root of a template and the original
      // element was replaced. See https://github.com/angular/angular.js/issues/12936
      function markDirectiveScope(directives, isolateScope, newScope) {
        for (var j = 0, jj = directives.length; j < jj; j++) {
          directives[j] = inherit(directives[j], {
            $$isolateScope: isolateScope,
            $$newScope: newScope
          });
        }
      }

      /**
       * looks up the directive and decorates it with exception handling and proper parameters. We
       * call this the boundDirective.
       *
       * @param {string} name name of the directive to look up.
       * @param {string} location The directive must be found in specific format.
       *   String containing any of theses characters:
       *
       *   * `E`: element name
       *   * `A': attribute
       *   * `C`: class
       *   * `M`: comment
       * @returns {boolean} true if directive was added.
       */
      function addDirective(tDirectives, name, location, maxPriority, ignoreDirective, startAttrName, endAttrName) {
        if (name === ignoreDirective) return null;
        var match = null;
        if (hasDirectives.hasOwnProperty(name)) {
          for (var directive, directives = $injector.get(name + Suffix), i = 0, ii = directives.length; i < ii; i++) {
            directive = directives[i];
            if ((isUndefined(maxPriority) || maxPriority > directive.priority) && directive.restrict.indexOf(location) !== -1) {
              if (startAttrName) {
                directive = inherit(directive, {
                  $$start: startAttrName,
                  $$end: endAttrName
                });
              }
              if (!directive.$$bindings) {
                var bindings = directive.$$bindings = parseDirectiveBindings(directive, directive.name);
                if (isObject(bindings.isolateScope)) {
                  directive.$$isolateBindings = bindings.isolateScope;
                }
              }
              tDirectives.push(directive);
              match = directive;
            }
          }
        }
        return match;
      }

      /**
       * looks up the directive and returns true if it is a multi-element directive,
       * and therefore requires DOM nodes between -start and -end markers to be grouped
       * together.
       *
       * @param {string} name name of the directive to look up.
       * @returns true if directive was registered as multi-element.
       */
      function directiveIsMultiElement(name) {
        if (hasDirectives.hasOwnProperty(name)) {
          for (var directive, directives = $injector.get(name + Suffix), i = 0, ii = directives.length; i < ii; i++) {
            directive = directives[i];
            if (directive.multiElement) {
              return true;
            }
          }
        }
        return false;
      }

      /**
       * When the element is replaced with HTML template then the new attributes
       * on the template need to be merged with the existing attributes in the DOM.
       * The desired effect is to have both of the attributes present.
       *
       * @param {object} dst destination attributes (original DOM)
       * @param {object} src source attributes (from the directive template)
       */
      function mergeTemplateAttributes(dst, src) {
        var srcAttr = src.$attr,
          dstAttr = dst.$attr;

        // reapply the old attributes to the new element
        forEach(dst, function (value, key) {
          if (key.charAt(0) !== '$') {
            if (src[key] && src[key] !== value) {
              if (value.length) {
                value += (key === 'style' ? ';' : ' ') + src[key];
              } else {
                value = src[key];
              }
            }
            dst.$set(key, value, true, srcAttr[key]);
          }
        });

        // copy the new attributes on the old attrs object
        forEach(src, function (value, key) {
          // Check if we already set this attribute in the loop above.
          // `dst` will never contain hasOwnProperty as DOM parser won't let it.
          // You will get an "InvalidCharacterError: DOM Exception 5" error if you
          // have an attribute like "has-own-property" or "data-has-own-property", etc.
          if (!dst.hasOwnProperty(key) && key.charAt(0) !== '$') {
            dst[key] = value;
            if (key !== 'class' && key !== 'style') {
              dstAttr[key] = srcAttr[key];
            }
          }
        });
      }
      function compileTemplateUrl(directives, $compileNode, tAttrs, $rootElement, childTranscludeFn, preLinkFns, postLinkFns, previousCompileContext) {
        var linkQueue = [],
          afterTemplateNodeLinkFn,
          afterTemplateChildLinkFn,
          beforeTemplateCompileNode = $compileNode[0],
          origAsyncDirective = directives.shift(),
          derivedSyncDirective = inherit(origAsyncDirective, {
            templateUrl: null,
            transclude: null,
            replace: null,
            $$originalDirective: origAsyncDirective
          }),
          templateUrl = isFunction(origAsyncDirective.templateUrl) ? origAsyncDirective.templateUrl($compileNode, tAttrs) : origAsyncDirective.templateUrl,
          templateNamespace = origAsyncDirective.templateNamespace;
        $compileNode.empty();
        $templateRequest(templateUrl).then(function (content) {
          var compileNode, tempTemplateAttrs, $template, childBoundTranscludeFn;
          content = denormalizeTemplate(content);
          if (origAsyncDirective.replace) {
            if (jqLiteIsTextNode(content)) {
              $template = [];
            } else {
              $template = removeComments(wrapTemplate(templateNamespace, trim(content)));
            }
            compileNode = $template[0];
            if ($template.length !== 1 || compileNode.nodeType !== NODE_TYPE_ELEMENT) {
              throw $compileMinErr('tplrt', 'Template for directive \'{0}\' must have exactly one root element. {1}', origAsyncDirective.name, templateUrl);
            }
            tempTemplateAttrs = {
              $attr: {}
            };
            replaceWith($rootElement, $compileNode, compileNode);
            var templateDirectives = collectDirectives(compileNode, [], tempTemplateAttrs);
            if (isObject(origAsyncDirective.scope)) {
              // the original directive that caused the template to be loaded async required
              // an isolate scope
              markDirectiveScope(templateDirectives, true);
            }
            directives = templateDirectives.concat(directives);
            mergeTemplateAttributes(tAttrs, tempTemplateAttrs);
          } else {
            compileNode = beforeTemplateCompileNode;
            $compileNode.html(content);
          }
          directives.unshift(derivedSyncDirective);
          afterTemplateNodeLinkFn = applyDirectivesToNode(directives, compileNode, tAttrs, childTranscludeFn, $compileNode, origAsyncDirective, preLinkFns, postLinkFns, previousCompileContext);
          forEach($rootElement, function (node, i) {
            if (node === compileNode) {
              $rootElement[i] = $compileNode[0];
            }
          });
          afterTemplateChildLinkFn = compileNodes($compileNode[0].childNodes, childTranscludeFn);
          while (linkQueue.length) {
            var scope = linkQueue.shift(),
              beforeTemplateLinkNode = linkQueue.shift(),
              linkRootElement = linkQueue.shift(),
              boundTranscludeFn = linkQueue.shift(),
              linkNode = $compileNode[0];
            if (scope.$$destroyed) continue;
            if (beforeTemplateLinkNode !== beforeTemplateCompileNode) {
              var oldClasses = beforeTemplateLinkNode.className;
              if (!(previousCompileContext.hasElementTranscludeDirective && origAsyncDirective.replace)) {
                // it was cloned therefore we have to clone as well.
                linkNode = jqLiteClone(compileNode);
              }
              replaceWith(linkRootElement, jqLite(beforeTemplateLinkNode), linkNode);

              // Copy in CSS classes from original node
              safeAddClass(jqLite(linkNode), oldClasses);
            }
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            } else {
              childBoundTranscludeFn = boundTranscludeFn;
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, linkNode, $rootElement, childBoundTranscludeFn);
          }
          linkQueue = null;
        })["catch"](function (error) {
          if (isError(error)) {
            $exceptionHandler(error);
          }
        });
        return function delayedNodeLinkFn(ignoreChildLinkFn, scope, node, rootElement, boundTranscludeFn) {
          var childBoundTranscludeFn = boundTranscludeFn;
          if (scope.$$destroyed) return;
          if (linkQueue) {
            linkQueue.push(scope, node, rootElement, childBoundTranscludeFn);
          } else {
            if (afterTemplateNodeLinkFn.transcludeOnThisElement) {
              childBoundTranscludeFn = createBoundTranscludeFn(scope, afterTemplateNodeLinkFn.transclude, boundTranscludeFn);
            }
            afterTemplateNodeLinkFn(afterTemplateChildLinkFn, scope, node, rootElement, childBoundTranscludeFn);
          }
        };
      }

      /**
       * Sorting function for bound directives.
       */
      function byPriority(a, b) {
        var diff = b.priority - a.priority;
        if (diff !== 0) return diff;
        if (a.name !== b.name) return a.name < b.name ? -1 : 1;
        return a.index - b.index;
      }
      function assertNoDuplicate(what, previousDirective, directive, element) {
        function wrapModuleNameIfDefined(moduleName) {
          return moduleName ? ' (module: ' + moduleName + ')' : '';
        }
        if (previousDirective) {
          throw $compileMinErr('multidir', 'Multiple directives [{0}{1}, {2}{3}] asking for {4} on: {5}', previousDirective.name, wrapModuleNameIfDefined(previousDirective.$$moduleName), directive.name, wrapModuleNameIfDefined(directive.$$moduleName), what, startingTag(element));
        }
      }
      function addTextInterpolateDirective(directives, text) {
        var interpolateFn = $interpolate(text, true);
        if (interpolateFn) {
          directives.push({
            priority: 0,
            compile: function textInterpolateCompileFn(templateNode) {
              var templateNodeParent = templateNode.parent(),
                hasCompileParent = !!templateNodeParent.length;

              // When transcluding a template that has bindings in the root
              // we don't have a parent and thus need to add the class during linking fn.
              if (hasCompileParent) compile.$$addBindingClass(templateNodeParent);
              return function textInterpolateLinkFn(scope, node) {
                var parent = node.parent();
                if (!hasCompileParent) compile.$$addBindingClass(parent);
                compile.$$addBindingInfo(parent, interpolateFn.expressions);
                scope.$watch(interpolateFn, function interpolateFnWatchAction(value) {
                  node[0].nodeValue = value;
                });
              };
            }
          });
        }
      }
      function wrapTemplate(type, template) {
        type = lowercase(type || 'html');
        switch (type) {
          case 'svg':
          case 'math':
            var wrapper = window.document.createElement('div');
            wrapper.innerHTML = '<' + type + '>' + template + '</' + type + '>';
            return wrapper.childNodes[0].childNodes;
          default:
            return template;
        }
      }
      function getTrustedAttrContext(nodeName, attrNormalizedName) {
        if (attrNormalizedName === 'srcdoc') {
          return $sce.HTML;
        }
        // All nodes with src attributes require a RESOURCE_URL value, except for
        // img and various html5 media nodes, which require the MEDIA_URL context.
        if (attrNormalizedName === 'src' || attrNormalizedName === 'ngSrc') {
          if (['img', 'video', 'audio', 'source', 'track'].indexOf(nodeName) === -1) {
            return $sce.RESOURCE_URL;
          }
          return $sce.MEDIA_URL;
        } else if (attrNormalizedName === 'xlinkHref') {
          // Some xlink:href are okay, most aren't
          if (nodeName === 'image') return $sce.MEDIA_URL;
          if (nodeName === 'a') return $sce.URL;
          return $sce.RESOURCE_URL;
        } else if (
        // Formaction
        nodeName === 'form' && attrNormalizedName === 'action' ||
        // If relative URLs can go where they are not expected to, then
        // all sorts of trust issues can arise.
        nodeName === 'base' && attrNormalizedName === 'href' ||
        // links can be stylesheets or imports, which can run script in the current origin
        nodeName === 'link' && attrNormalizedName === 'href') {
          return $sce.RESOURCE_URL;
        } else if (nodeName === 'a' && (attrNormalizedName === 'href' || attrNormalizedName === 'ngHref')) {
          return $sce.URL;
        }
      }
      function getTrustedPropContext(nodeName, propNormalizedName) {
        var prop = propNormalizedName.toLowerCase();
        return PROP_CONTEXTS[nodeName + '|' + prop] || PROP_CONTEXTS['*|' + prop];
      }
      function sanitizeSrcsetPropertyValue(value) {
        return sanitizeSrcset($sce.valueOf(value), 'ng-prop-srcset');
      }
      function addPropertyDirective(node, directives, attrName, propName) {
        if (EVENT_HANDLER_ATTR_REGEXP.test(propName)) {
          throw $compileMinErr('nodomevents', 'Property bindings for HTML DOM event properties are disallowed');
        }
        var nodeName = nodeName_(node);
        var trustedContext = getTrustedPropContext(nodeName, propName);
        var sanitizer = identity;
        // Sanitize img[srcset] + source[srcset] values.
        if (propName === 'srcset' && (nodeName === 'img' || nodeName === 'source')) {
          sanitizer = sanitizeSrcsetPropertyValue;
        } else if (trustedContext) {
          sanitizer = $sce.getTrusted.bind($sce, trustedContext);
        }
        directives.push({
          priority: 100,
          compile: function ngPropCompileFn(_, attr) {
            var ngPropGetter = $parse(attr[attrName]);
            var ngPropWatch = $parse(attr[attrName], function sceValueOf(val) {
              // Unwrap the value to compare the actual inner safe value, not the wrapper object.
              return $sce.valueOf(val);
            });
            return {
              pre: function ngPropPreLinkFn(scope, $element) {
                function applyPropValue() {
                  var propValue = ngPropGetter(scope);
                  $element[0][propName] = sanitizer(propValue);
                }
                applyPropValue();
                scope.$watch(ngPropWatch, applyPropValue);
              }
            };
          }
        });
      }
      function addEventDirective(directives, attrName, eventName) {
        directives.push(createEventDirective($parse, $rootScope, $exceptionHandler, attrName, eventName, /*forceAsync=*/false));
      }
      function addAttrInterpolateDirective(node, directives, value, name, isNgAttr) {
        var nodeName = nodeName_(node);
        var trustedContext = getTrustedAttrContext(nodeName, name);
        var mustHaveExpression = !isNgAttr;
        var allOrNothing = ALL_OR_NOTHING_ATTRS[name] || isNgAttr;
        var interpolateFn = $interpolate(value, mustHaveExpression, trustedContext, allOrNothing);

        // no interpolation found -> ignore
        if (!interpolateFn) return;
        if (name === 'multiple' && nodeName === 'select') {
          throw $compileMinErr('selmulti', 'Binding to the \'multiple\' attribute is not supported. Element: {0}', startingTag(node));
        }
        if (EVENT_HANDLER_ATTR_REGEXP.test(name)) {
          throw $compileMinErr('nodomevents', 'Interpolations for HTML DOM event attributes are disallowed');
        }
        directives.push({
          priority: 100,
          compile: function compile() {
            return {
              pre: function attrInterpolatePreLinkFn(scope, element, attr) {
                var $$observers = attr.$$observers || (attr.$$observers = createMap());

                // If the attribute has changed since last $interpolate()ed
                var newValue = attr[name];
                if (newValue !== value) {
                  // we need to interpolate again since the attribute value has been updated
                  // (e.g. by another directive's compile function)
                  // ensure unset/empty values make interpolateFn falsy
                  interpolateFn = newValue && $interpolate(newValue, true, trustedContext, allOrNothing);
                  value = newValue;
                }

                // if attribute was updated so that there is no interpolation going on we don't want to
                // register any observers
                if (!interpolateFn) return;

                // initialize attr object so that it's ready in case we need the value for isolate
                // scope initialization, otherwise the value would not be available from isolate
                // directive's linking fn during linking phase
                attr[name] = interpolateFn(scope);
                ($$observers[name] || ($$observers[name] = [])).$$inter = true;
                (attr.$$observers && attr.$$observers[name].$$scope || scope).$watch(interpolateFn, function interpolateFnWatchAction(newValue, oldValue) {
                  //special case for class attribute addition + removal
                  //so that class changes can tap into the animation
                  //hooks provided by the $animate service. Be sure to
                  //skip animations when the first digest occurs (when
                  //both the new and the old values are the same) since
                  //the CSS classes are the non-interpolated values
                  if (name === 'class' && newValue !== oldValue) {
                    attr.$updateClass(newValue, oldValue);
                  } else {
                    attr.$set(name, newValue);
                  }
                });
              }
            };
          }
        });
      }

      /**
       * This is a special jqLite.replaceWith, which can replace items which
       * have no parents, provided that the containing jqLite collection is provided.
       *
       * @param {JqLite=} $rootElement The root of the compile tree. Used so that we can replace nodes
       *                               in the root of the tree.
       * @param {JqLite} elementsToRemove The jqLite element which we are going to replace. We keep
       *                                  the shell, but replace its DOM node reference.
       * @param {Node} newNode The new DOM node.
       */
      function replaceWith($rootElement, elementsToRemove, newNode) {
        var firstElementToRemove = elementsToRemove[0],
          removeCount = elementsToRemove.length,
          parent = firstElementToRemove.parentNode,
          i,
          ii;
        if ($rootElement) {
          for (i = 0, ii = $rootElement.length; i < ii; i++) {
            if ($rootElement[i] === firstElementToRemove) {
              $rootElement[i++] = newNode;
              for (var j = i, j2 = j + removeCount - 1, jj = $rootElement.length; j < jj; j++, j2++) {
                if (j2 < jj) {
                  $rootElement[j] = $rootElement[j2];
                } else {
                  delete $rootElement[j];
                }
              }
              $rootElement.length -= removeCount - 1;

              // If the replaced element is also the jQuery .context then replace it
              // .context is a deprecated jQuery api, so we should set it only when jQuery set it
              // http://api.jquery.com/context/
              if ($rootElement.context === firstElementToRemove) {
                $rootElement.context = newNode;
              }
              break;
            }
          }
        }
        if (parent) {
          parent.replaceChild(newNode, firstElementToRemove);
        }

        // Append all the `elementsToRemove` to a fragment. This will...
        // - remove them from the DOM
        // - allow them to still be traversed with .nextSibling
        // - allow a single fragment.qSA to fetch all elements being removed
        var fragment = window.document.createDocumentFragment();
        for (i = 0; i < removeCount; i++) {
          fragment.appendChild(elementsToRemove[i]);
        }
        if (jqLite.hasData(firstElementToRemove)) {
          // Copy over user data (that includes AngularJS's $scope etc.). Don't copy private
          // data here because there's no public interface in jQuery to do that and copying over
          // event listeners (which is the main use of private data) wouldn't work anyway.
          jqLite.data(newNode, jqLite.data(firstElementToRemove));

          // Remove $destroy event listeners from `firstElementToRemove`
          jqLite(firstElementToRemove).off('$destroy');
        }

        // Cleanup any data/listeners on the elements and children.
        // This includes invoking the $destroy event on any elements with listeners.
        jqLite.cleanData(fragment.querySelectorAll('*'));

        // Update the jqLite collection to only contain the `newNode`
        for (i = 1; i < removeCount; i++) {
          delete elementsToRemove[i];
        }
        elementsToRemove[0] = newNode;
        elementsToRemove.length = 1;
      }
      function cloneAndAnnotateFn(fn, annotation) {
        return extend(function () {
          return fn.apply(null, arguments);
        }, fn, annotation);
      }
      function invokeLinkFn(linkFn, scope, $element, attrs, controllers, transcludeFn) {
        try {
          linkFn(scope, $element, attrs, controllers, transcludeFn);
        } catch (e) {
          $exceptionHandler(e, startingTag($element));
        }
      }
      function strictBindingsCheck(attrName, directiveName) {
        if (strictComponentBindingsEnabled) {
          throw $compileMinErr('missingattr', 'Attribute \'{0}\' of \'{1}\' is non-optional and must be set!', attrName, directiveName);
        }
      }

      // Set up $watches for isolate scope and controller bindings.
      function initializeDirectiveBindings(scope, attrs, destination, bindings, directive) {
        var removeWatchCollection = [];
        var initialChanges = {};
        var changes;
        forEach(bindings, function initializeBinding(definition, scopeName) {
          var attrName = definition.attrName,
            optional = definition.optional,
            mode = definition.mode,
            // @, =, <, or &
            lastValue,
            parentGet,
            parentSet,
            compare,
            removeWatch;
          switch (mode) {
            case '@':
              if (!optional && !hasOwnProperty.call(attrs, attrName)) {
                strictBindingsCheck(attrName, directive.name);
                destination[scopeName] = attrs[attrName] = undefined;
              }
              removeWatch = attrs.$observe(attrName, function (value) {
                if (isString(value) || isBoolean(value)) {
                  var oldValue = destination[scopeName];
                  recordChanges(scopeName, value, oldValue);
                  destination[scopeName] = value;
                }
              });
              attrs.$$observers[attrName].$$scope = scope;
              lastValue = attrs[attrName];
              if (isString(lastValue)) {
                // If the attribute has been provided then we trigger an interpolation to ensure
                // the value is there for use in the link fn
                destination[scopeName] = $interpolate(lastValue)(scope);
              } else if (isBoolean(lastValue)) {
                // If the attributes is one of the BOOLEAN_ATTR then AngularJS will have converted
                // the value to boolean rather than a string, so we special case this situation
                destination[scopeName] = lastValue;
              }
              initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
              removeWatchCollection.push(removeWatch);
              break;
            case '=':
              if (!hasOwnProperty.call(attrs, attrName)) {
                if (optional) break;
                strictBindingsCheck(attrName, directive.name);
                attrs[attrName] = undefined;
              }
              if (optional && !attrs[attrName]) break;
              parentGet = $parse(attrs[attrName]);
              if (parentGet.literal) {
                compare = equals;
              } else {
                compare = simpleCompare;
              }
              parentSet = parentGet.assign || function () {
                // reset the change, or we will throw this exception on every $digest
                lastValue = destination[scopeName] = parentGet(scope);
                throw $compileMinErr('nonassign', 'Expression \'{0}\' in attribute \'{1}\' used with directive \'{2}\' is non-assignable!', attrs[attrName], attrName, directive.name);
              };
              lastValue = destination[scopeName] = parentGet(scope);
              var parentValueWatch = function parentValueWatch(parentValue) {
                if (!compare(parentValue, destination[scopeName])) {
                  // we are out of sync and need to copy
                  if (!compare(parentValue, lastValue)) {
                    // parent changed and it has precedence
                    destination[scopeName] = parentValue;
                  } else {
                    // if the parent can be assigned then do so
                    parentSet(scope, parentValue = destination[scopeName]);
                  }
                }
                lastValue = parentValue;
                return lastValue;
              };
              parentValueWatch.$stateful = true;
              if (definition.collection) {
                removeWatch = scope.$watchCollection(attrs[attrName], parentValueWatch);
              } else {
                removeWatch = scope.$watch($parse(attrs[attrName], parentValueWatch), null, parentGet.literal);
              }
              removeWatchCollection.push(removeWatch);
              break;
            case '<':
              if (!hasOwnProperty.call(attrs, attrName)) {
                if (optional) break;
                strictBindingsCheck(attrName, directive.name);
                attrs[attrName] = undefined;
              }
              if (optional && !attrs[attrName]) break;
              parentGet = $parse(attrs[attrName]);
              var isLiteral = parentGet.literal;
              var initialValue = destination[scopeName] = parentGet(scope);
              initialChanges[scopeName] = new SimpleChange(_UNINITIALIZED_VALUE, destination[scopeName]);
              removeWatch = scope[definition.collection ? '$watchCollection' : '$watch'](parentGet, function parentValueWatchAction(newValue, oldValue) {
                if (oldValue === newValue) {
                  if (oldValue === initialValue || isLiteral && equals(oldValue, initialValue)) {
                    return;
                  }
                  oldValue = initialValue;
                }
                recordChanges(scopeName, newValue, oldValue);
                destination[scopeName] = newValue;
              });
              removeWatchCollection.push(removeWatch);
              break;
            case '&':
              if (!optional && !hasOwnProperty.call(attrs, attrName)) {
                strictBindingsCheck(attrName, directive.name);
              }
              // Don't assign Object.prototype method to scope
              parentGet = attrs.hasOwnProperty(attrName) ? $parse(attrs[attrName]) : noop;

              // Don't assign noop to destination if expression is not valid
              if (parentGet === noop && optional) break;
              destination[scopeName] = function (locals) {
                return parentGet(scope, locals);
              };
              break;
          }
        });
        function recordChanges(key, currentValue, previousValue) {
          if (isFunction(destination.$onChanges) && !simpleCompare(currentValue, previousValue)) {
            // If we have not already scheduled the top level onChangesQueue handler then do so now
            if (!onChangesQueue) {
              scope.$$postDigest(flushOnChangesQueue);
              onChangesQueue = [];
            }
            // If we have not already queued a trigger of onChanges for this controller then do so now
            if (!changes) {
              changes = {};
              onChangesQueue.push(triggerOnChangesHook);
            }
            // If the has been a change on this property already then we need to reuse the previous value
            if (changes[key]) {
              previousValue = changes[key].previousValue;
            }
            // Store this change
            changes[key] = new SimpleChange(previousValue, currentValue);
          }
        }
        function triggerOnChangesHook() {
          destination.$onChanges(changes);
          // Now clear the changes so that we schedule onChanges when more changes arrive
          changes = undefined;
        }
        return {
          initialChanges: initialChanges,
          removeWatches: removeWatchCollection.length && function removeWatches() {
            for (var i = 0, ii = removeWatchCollection.length; i < ii; ++i) {
              removeWatchCollection[i]();
            }
          }
        };
      }
    }];
  }
  function SimpleChange(previous, current) {
    this.previousValue = previous;
    this.currentValue = current;
  }
  SimpleChange.prototype.isFirstChange = function () {
    return this.previousValue === _UNINITIALIZED_VALUE;
  };
  var PREFIX_REGEXP = /^((?:x|data)[:\-_])/i;
  var SPECIAL_CHARS_REGEXP = /[:\-_]+(.)/g;

  /**
   * Converts all accepted directives format into proper directive name.
   * @param name Name to normalize
   */
  function directiveNormalize(name) {
    return name.replace(PREFIX_REGEXP, '').replace(SPECIAL_CHARS_REGEXP, function (_, letter, offset) {
      return offset ? letter.toUpperCase() : letter;
    });
  }

  /**
   * @ngdoc type
   * @name $compile.directive.Attributes
   *
   * @description
   * A shared object between directive compile / linking functions which contains normalized DOM
   * element attributes. The values reflect current binding state `{{ }}`. The normalization is
   * needed since all of these are treated as equivalent in AngularJS:
   *
   * ```
   *    <span ng:bind="a" ng-bind="a" data-ng-bind="a" x-ng-bind="a">
   * ```
   */

  /**
   * @ngdoc property
   * @name $compile.directive.Attributes#$attr
   *
   * @description
   * A map of DOM element attribute names to the normalized name. This is
   * needed to do reverse lookup from normalized name back to actual name.
   */

  /**
   * @ngdoc method
   * @name $compile.directive.Attributes#$set
   * @kind function
   *
   * @description
   * Set DOM element attribute value.
   *
   *
   * @param {string} name Normalized element attribute name of the property to modify. The name is
   *          reverse-translated using the {@link ng.$compile.directive.Attributes#$attr $attr}
   *          property to the original name.
   * @param {string} value Value to set the attribute to. The value can be an interpolated string.
   */

  /**
   * Closure compiler type information
   */

  function nodesetLinkingFn(/* angular.Scope */scope, /* NodeList */nodeList, /* Element */rootElement, /* function(Function) */boundTranscludeFn) {}
  function directiveLinkingFn(/* nodesetLinkingFn */nodesetLinkingFn, /* angular.Scope */scope, /* Node */node, /* Element */rootElement, /* function(Function) */boundTranscludeFn) {}
  function tokenDifference(str1, str2) {
    var values = '',
      tokens1 = str1.split(/\s+/),
      tokens2 = str2.split(/\s+/);
    outer: for (var i = 0; i < tokens1.length; i++) {
      var token = tokens1[i];
      for (var j = 0; j < tokens2.length; j++) {
        if (token === tokens2[j]) continue outer;
      }
      values += (values.length > 0 ? ' ' : '') + token;
    }
    return values;
  }
  function removeComments(jqNodes) {
    jqNodes = jqLite(jqNodes);
    var i = jqNodes.length;
    if (i <= 1) {
      return jqNodes;
    }
    while (i--) {
      var node = jqNodes[i];
      if (node.nodeType === NODE_TYPE_COMMENT || node.nodeType === NODE_TYPE_TEXT && node.nodeValue.trim() === '') {
        splice.call(jqNodes, i, 1);
      }
    }
    return jqNodes;
  }
  var $controllerMinErr = minErr('$controller');
  var CNTRL_REG = /^(\S+)(\s+as\s+([\w$]+))?$/;
  function identifierForController(controller, ident) {
    if (ident && isString(ident)) return ident;
    if (isString(controller)) {
      var match = CNTRL_REG.exec(controller);
      if (match) return match[3];
    }
  }

  /**
   * @ngdoc provider
   * @name $controllerProvider
   * @this
   *
   * @description
   * The {@link ng.$controller $controller service} is used by AngularJS to create new
   * controllers.
   *
   * This provider allows controller registration via the
   * {@link ng.$controllerProvider#register register} method.
   */
  function $ControllerProvider() {
    var controllers = {};

    /**
     * @ngdoc method
     * @name $controllerProvider#has
     * @param {string} name Controller name to check.
     */
    this.has = function (name) {
      return controllers.hasOwnProperty(name);
    };

    /**
     * @ngdoc method
     * @name $controllerProvider#register
     * @param {string|Object} name Controller name, or an object map of controllers where the keys are
     *    the names and the values are the constructors.
     * @param {Function|Array} constructor Controller constructor fn (optionally decorated with DI
     *    annotations in the array notation).
     */
    this.register = function (name, constructor) {
      assertNotHasOwnProperty(name, 'controller');
      if (isObject(name)) {
        extend(controllers, name);
      } else {
        controllers[name] = constructor;
      }
    };
    this.$get = ['$injector', function ($injector) {
      /**
       * @ngdoc service
       * @name $controller
       * @requires $injector
       *
       * @param {Function|string} constructor If called with a function then it's considered to be the
       *    controller constructor function. Otherwise it's considered to be a string which is used
       *    to retrieve the controller constructor using the following steps:
       *
       *    * check if a controller with given name is registered via `$controllerProvider`
       *    * check if evaluating the string on the current scope returns a constructor
       *
       *    The string can use the `controller as property` syntax, where the controller instance is published
       *    as the specified property on the `scope`; the `scope` must be injected into `locals` param for this
       *    to work correctly.
       *
       * @param {Object} locals Injection locals for Controller.
       * @return {Object} Instance of given controller.
       *
       * @description
       * `$controller` service is responsible for instantiating controllers.
       *
       * It's just a simple call to {@link auto.$injector $injector}, but extracted into
       * a service, so that one can override this service with [BC version](https://gist.github.com/1649788).
       */
      return function $controller(expression, locals, later, ident) {
        // PRIVATE API:
        //   param `later` --- indicates that the controller's constructor is invoked at a later time.
        //                     If true, $controller will allocate the object with the correct
        //                     prototype chain, but will not invoke the controller until a returned
        //                     callback is invoked.
        //   param `ident` --- An optional label which overrides the label parsed from the controller
        //                     expression, if any.
        var instance, match, constructor, identifier;
        later = later === true;
        if (ident && isString(ident)) {
          identifier = ident;
        }
        if (isString(expression)) {
          match = expression.match(CNTRL_REG);
          if (!match) {
            throw $controllerMinErr('ctrlfmt', 'Badly formed controller string \'{0}\'. ' + 'Must match `__name__ as __id__` or `__name__`.', expression);
          }
          constructor = match[1];
          identifier = identifier || match[3];
          expression = controllers.hasOwnProperty(constructor) ? controllers[constructor] : getter(locals.$scope, constructor, true);
          if (!expression) {
            throw $controllerMinErr('ctrlreg', 'The controller with the name \'{0}\' is not registered.', constructor);
          }
          assertArgFn(expression, constructor, true);
        }
        if (later) {
          // Instantiate controller later:
          // This machinery is used to create an instance of the object before calling the
          // controller's constructor itself.
          //
          // This allows properties to be added to the controller before the constructor is
          // invoked. Primarily, this is used for isolate scope bindings in $compile.
          //
          // This feature is not intended for use by applications, and is thus not documented
          // publicly.
          // Object creation: http://jsperf.com/create-constructor/2
          var controllerPrototype = (isArray(expression) ? expression[expression.length - 1] : expression).prototype;
          instance = Object.create(controllerPrototype || null);
          if (identifier) {
            addIdentifier(locals, identifier, instance, constructor || expression.name);
          }
          return extend(function $controllerInit() {
            var result = $injector.invoke(expression, instance, locals, constructor);
            if (result !== instance && (isObject(result) || isFunction(result))) {
              instance = result;
              if (identifier) {
                // If result changed, re-assign controllerAs value to scope.
                addIdentifier(locals, identifier, instance, constructor || expression.name);
              }
            }
            return instance;
          }, {
            instance: instance,
            identifier: identifier
          });
        }
        instance = $injector.instantiate(expression, locals, constructor);
        if (identifier) {
          addIdentifier(locals, identifier, instance, constructor || expression.name);
        }
        return instance;
      };
      function addIdentifier(locals, identifier, instance, name) {
        if (!(locals && isObject(locals.$scope))) {
          throw minErr('$controller')('noscp', 'Cannot export controller \'{0}\' as \'{1}\'! No $scope object provided via `locals`.', name, identifier);
        }
        locals.$scope[identifier] = instance;
      }
    }];
  }

  /**
   * @ngdoc service
   * @name $document
   * @requires $window
   * @this
   *
   * @description
   * A {@link angular.element jQuery or jqLite} wrapper for the browser's `window.document` object.
   *
   * @example
     <example module="documentExample" name="document">
       <file name="index.html">
         <div ng-controller="ExampleController">
           <p>$document title: <b ng-bind="title"></b></p>
           <p>window.document title: <b ng-bind="windowTitle"></b></p>
         </div>
       </file>
       <file name="script.js">
         angular.module('documentExample', [])
           .controller('ExampleController', ['$scope', '$document', function($scope, $document) {
             $scope.title = $document[0].title;
             $scope.windowTitle = angular.element(window.document)[0].title;
           }]);
       </file>
     </example>
   */
  function $DocumentProvider() {
    this.$get = ['$window', function (window) {
      return jqLite(window.document);
    }];
  }

  /**
   * @private
   * @this
   * Listens for document visibility change and makes the current status accessible.
   */
  function $$IsDocumentHiddenProvider() {
    this.$get = ['$document', '$rootScope', function ($document, $rootScope) {
      var doc = $document[0];
      var hidden = doc && doc.hidden;
      $document.on('visibilitychange', changeListener);
      $rootScope.$on('$destroy', function () {
        $document.off('visibilitychange', changeListener);
      });
      function changeListener() {
        hidden = doc.hidden;
      }
      return function () {
        return hidden;
      };
    }];
  }

  /**
   * @ngdoc service
   * @name $exceptionHandler
   * @requires ng.$log
   * @this
   *
   * @description
   * Any uncaught exception in AngularJS expressions is delegated to this service.
   * The default implementation simply delegates to `$log.error` which logs it into
   * the browser console.
   *
   * In unit tests, if `angular-mocks.js` is loaded, this service is overridden by
   * {@link ngMock.$exceptionHandler mock $exceptionHandler} which aids in testing.
   *
   * ## Example:
   *
   * The example below will overwrite the default `$exceptionHandler` in order to (a) log uncaught
   * errors to the backend for later inspection by the developers and (b) to use `$log.warn()` instead
   * of `$log.error()`.
   *
   * ```js
   *   angular.
   *     module('exceptionOverwrite', []).
   *     factory('$exceptionHandler', ['$log', 'logErrorsToBackend', function($log, logErrorsToBackend) {
   *       return function myExceptionHandler(exception, cause) {
   *         logErrorsToBackend(exception, cause);
   *         $log.warn(exception, cause);
   *       };
   *     }]);
   * ```
   *
   * <hr />
   * Note, that code executed in event-listeners (even those registered using jqLite's `on`/`bind`
   * methods) does not delegate exceptions to the {@link ng.$exceptionHandler $exceptionHandler}
   * (unless executed during a digest).
   *
   * If you wish, you can manually delegate exceptions, e.g.
   * `try { ... } catch(e) { $exceptionHandler(e); }`
   *
   * @param {Error} exception Exception associated with the error.
   * @param {string=} cause Optional information about the context in which
   *       the error was thrown.
   *
   */
  function $ExceptionHandlerProvider() {
    this.$get = ['$log', function ($log) {
      return function (exception, cause) {
        $log.error.apply($log, arguments);
      };
    }];
  }
  var $$ForceReflowProvider = /** @this */function $$ForceReflowProvider() {
    this.$get = ['$document', function ($document) {
      return function (domNode) {
        //the line below will force the browser to perform a repaint so
        //that all the animated elements within the animation frame will
        //be properly updated and drawn on screen. This is required to
        //ensure that the preparation animation is properly flushed so that
        //the active state picks up from there. DO NOT REMOVE THIS LINE.
        //DO NOT OPTIMIZE THIS LINE. THE MINIFIER WILL REMOVE IT OTHERWISE WHICH
        //WILL RESULT IN AN UNPREDICTABLE BUG THAT IS VERY HARD TO TRACK DOWN AND
        //WILL TAKE YEARS AWAY FROM YOUR LIFE.
        if (domNode) {
          if (!domNode.nodeType && domNode instanceof jqLite) {
            domNode = domNode[0];
          }
        } else {
          domNode = $document[0].body;
        }
        return domNode.offsetWidth + 1;
      };
    }];
  };
  var APPLICATION_JSON = 'application/json';
  var CONTENT_TYPE_APPLICATION_JSON = {
    'Content-Type': APPLICATION_JSON + ';charset=utf-8'
  };
  var JSON_START = /^\[|^\{(?!\{)/;
  var JSON_ENDS = {
    '[': /]$/,
    '{': /}$/
  };
  var JSON_PROTECTION_PREFIX = /^\)]\}',?\n/;
  var $httpMinErr = minErr('$http');
  function serializeValue(v) {
    if (isObject(v)) {
      return isDate(v) ? v.toISOString() : toJson(v);
    }
    return v;
  }

  /** @this */
  function $HttpParamSerializerProvider() {
    /**
     * @ngdoc service
     * @name $httpParamSerializer
     * @description
     *
     * Default {@link $http `$http`} params serializer that converts objects to strings
     * according to the following rules:
     *
     * * `{'foo': 'bar'}` results in `foo=bar`
     * * `{'foo': Date.now()}` results in `foo=2015-04-01T09%3A50%3A49.262Z` (`toISOString()` and encoded representation of a Date object)
     * * `{'foo': ['bar', 'baz']}` results in `foo=bar&foo=baz` (repeated key for each array element)
     * * `{'foo': {'bar':'baz'}}` results in `foo=%7B%22bar%22%3A%22baz%22%7D` (stringified and encoded representation of an object)
     *
     * Note that serializer will sort the request parameters alphabetically.
     */

    this.$get = function () {
      return function ngParamSerializer(params) {
        if (!params) return '';
        var parts = [];
        forEachSorted(params, function (value, key) {
          if (value === null || isUndefined(value) || isFunction(value)) return;
          if (isArray(value)) {
            forEach(value, function (v) {
              parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(v)));
            });
          } else {
            parts.push(encodeUriQuery(key) + '=' + encodeUriQuery(serializeValue(value)));
          }
        });
        return parts.join('&');
      };
    };
  }

  /** @this */
  function $HttpParamSerializerJQLikeProvider() {
    /**
     * @ngdoc service
     * @name $httpParamSerializerJQLike
     *
     * @description
     *
     * Alternative {@link $http `$http`} params serializer that follows
     * jQuery's [`param()`](http://api.jquery.com/jquery.param/) method logic.
     * The serializer will also sort the params alphabetically.
     *
     * To use it for serializing `$http` request parameters, set it as the `paramSerializer` property:
     *
     * ```js
     * $http({
     *   url: myUrl,
     *   method: 'GET',
     *   params: myParams,
     *   paramSerializer: '$httpParamSerializerJQLike'
     * });
     * ```
     *
     * It is also possible to set it as the default `paramSerializer` in the
     * {@link $httpProvider#defaults `$httpProvider`}.
     *
     * Additionally, you can inject the serializer and use it explicitly, for example to serialize
     * form data for submission:
     *
     * ```js
     * .controller(function($http, $httpParamSerializerJQLike) {
     *   //...
     *
     *   $http({
     *     url: myUrl,
     *     method: 'POST',
     *     data: $httpParamSerializerJQLike(myData),
     *     headers: {
     *       'Content-Type': 'application/x-www-form-urlencoded'
     *     }
     *   });
     *
     * });
     * ```
     *
     */
    this.$get = function () {
      return function jQueryLikeParamSerializer(params) {
        if (!params) return '';
        var parts = [];
        serialize(params, '', true);
        return parts.join('&');
        function serialize(toSerialize, prefix, topLevel) {
          if (isArray(toSerialize)) {
            forEach(toSerialize, function (value, index) {
              serialize(value, prefix + '[' + (isObject(value) ? index : '') + ']');
            });
          } else if (isObject(toSerialize) && !isDate(toSerialize)) {
            forEachSorted(toSerialize, function (value, key) {
              serialize(value, prefix + (topLevel ? '' : '[') + key + (topLevel ? '' : ']'));
            });
          } else {
            if (isFunction(toSerialize)) {
              toSerialize = toSerialize();
            }
            parts.push(encodeUriQuery(prefix) + '=' + (toSerialize == null ? '' : encodeUriQuery(serializeValue(toSerialize))));
          }
        }
      };
    };
  }
  function defaultHttpResponseTransform(data, headers) {
    if (isString(data)) {
      // Strip json vulnerability protection prefix and trim whitespace
      var tempData = data.replace(JSON_PROTECTION_PREFIX, '').trim();
      if (tempData) {
        var contentType = headers('Content-Type');
        var hasJsonContentType = contentType && contentType.indexOf(APPLICATION_JSON) === 0;
        if (hasJsonContentType || isJsonLike(tempData)) {
          try {
            data = fromJson(tempData);
          } catch (e) {
            if (!hasJsonContentType) {
              return data;
            }
            throw $httpMinErr('baddata', 'Data must be a valid JSON object. Received: "{0}". ' + 'Parse error: "{1}"', data, e);
          }
        }
      }
    }
    return data;
  }
  function isJsonLike(str) {
    var jsonStart = str.match(JSON_START);
    return jsonStart && JSON_ENDS[jsonStart[0]].test(str);
  }

  /**
   * Parse headers into key value object
   *
   * @param {string} headers Raw headers as a string
   * @returns {Object} Parsed headers as key value object
   */
  function parseHeaders(headers) {
    var parsed = createMap(),
      i;
    function fillInParsed(key, val) {
      if (key) {
        parsed[key] = parsed[key] ? parsed[key] + ', ' + val : val;
      }
    }
    if (isString(headers)) {
      forEach(headers.split('\n'), function (line) {
        i = line.indexOf(':');
        fillInParsed(lowercase(trim(line.substr(0, i))), trim(line.substr(i + 1)));
      });
    } else if (isObject(headers)) {
      forEach(headers, function (headerVal, headerKey) {
        fillInParsed(lowercase(headerKey), trim(headerVal));
      });
    }
    return parsed;
  }

  /**
   * Returns a function that provides access to parsed headers.
   *
   * Headers are lazy parsed when first requested.
   * @see parseHeaders
   *
   * @param {(string|Object)} headers Headers to provide access to.
   * @returns {function(string=)} Returns a getter function which if called with:
   *
   *   - if called with an argument returns a single header value or null
   *   - if called with no arguments returns an object containing all headers.
   */
  function headersGetter(headers) {
    var headersObj;
    return function (name) {
      if (!headersObj) headersObj = parseHeaders(headers);
      if (name) {
        var value = headersObj[lowercase(name)];
        if (value === undefined) {
          value = null;
        }
        return value;
      }
      return headersObj;
    };
  }

  /**
   * Chain all given functions
   *
   * This function is used for both request and response transforming
   *
   * @param {*} data Data to transform.
   * @param {function(string=)} headers HTTP headers getter fn.
   * @param {number} status HTTP status code of the response.
   * @param {(Function|Array.<Function>)} fns Function or an array of functions.
   * @returns {*} Transformed data.
   */
  function transformData(data, headers, status, fns) {
    if (isFunction(fns)) {
      return fns(data, headers, status);
    }
    forEach(fns, function (fn) {
      data = fn(data, headers, status);
    });
    return data;
  }
  function isSuccess(status) {
    return 200 <= status && status < 300;
  }

  /**
   * @ngdoc provider
   * @name $httpProvider
   * @this
   *
   * @description
   * Use `$httpProvider` to change the default behavior of the {@link ng.$http $http} service.
   */
  function $HttpProvider() {
    /**
     * @ngdoc property
     * @name $httpProvider#defaults
     * @description
     *
     * Object containing default values for all {@link ng.$http $http} requests.
     *
     * - **`defaults.cache`** - {boolean|Object} - A boolean value or object created with
     * {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of HTTP responses
     * by default. See {@link $http#caching $http Caching} for more information.
     *
     * - **`defaults.headers`** - {Object} - Default headers for all $http requests.
     * Refer to {@link ng.$http#setting-http-headers $http} for documentation on
     * setting default headers.
     *     - **`defaults.headers.common`**
     *     - **`defaults.headers.post`**
     *     - **`defaults.headers.put`**
     *     - **`defaults.headers.patch`**
     *
     * - **`defaults.jsonpCallbackParam`** - `{string}` - the name of the query parameter that passes the name of the
     * callback in a JSONP request. The value of this parameter will be replaced with the expression generated by the
     * {@link $jsonpCallbacks} service. Defaults to `'callback'`.
     *
     * - **`defaults.paramSerializer`** - `{string|function(Object<string,string>):string}` - A function
     *  used to the prepare string representation of request parameters (specified as an object).
     *  If specified as string, it is interpreted as a function registered with the {@link auto.$injector $injector}.
     *  Defaults to {@link ng.$httpParamSerializer $httpParamSerializer}.
     *
     * - **`defaults.transformRequest`** -
     * `{Array<function(data, headersGetter)>|function(data, headersGetter)}` -
     * An array of functions (or a single function) which are applied to the request data.
     * By default, this is an array with one request transformation function:
     *
     *   - If the `data` property of the request configuration object contains an object, serialize it
     *     into JSON format.
     *
     * - **`defaults.transformResponse`** -
     * `{Array<function(data, headersGetter, status)>|function(data, headersGetter, status)}` -
     * An array of functions (or a single function) which are applied to the response data. By default,
     * this is an array which applies one response transformation function that does two things:
     *
     *  - If XSRF prefix is detected, strip it
     *    (see {@link ng.$http#security-considerations Security Considerations in the $http docs}).
     *  - If the `Content-Type` is `application/json` or the response looks like JSON,
     *    deserialize it using a JSON parser.
     *
     * - **`defaults.xsrfCookieName`** - {string} - Name of cookie containing the XSRF token.
     * Defaults value is `'XSRF-TOKEN'`.
     *
     * - **`defaults.xsrfHeaderName`** - {string} - Name of HTTP header to populate with the
     * XSRF token. Defaults value is `'X-XSRF-TOKEN'`.
     *
     */
    var defaults = this.defaults = {
      // transform incoming response data
      transformResponse: [defaultHttpResponseTransform],
      // transform outgoing request data
      transformRequest: [function (d) {
        return isObject(d) && !isFile(d) && !isBlob(d) && !isFormData(d) ? toJson(d) : d;
      }],
      // default headers
      headers: {
        common: {
          'Accept': 'application/json, text/plain, */*'
        },
        post: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
        put: shallowCopy(CONTENT_TYPE_APPLICATION_JSON),
        patch: shallowCopy(CONTENT_TYPE_APPLICATION_JSON)
      },
      xsrfCookieName: 'XSRF-TOKEN',
      xsrfHeaderName: 'X-XSRF-TOKEN',
      paramSerializer: '$httpParamSerializer',
      jsonpCallbackParam: 'callback'
    };
    var useApplyAsync = false;
    /**
     * @ngdoc method
     * @name $httpProvider#useApplyAsync
     * @description
     *
     * Configure $http service to combine processing of multiple http responses received at around
     * the same time via {@link ng.$rootScope.Scope#$applyAsync $rootScope.$applyAsync}. This can result in
     * significant performance improvement for bigger applications that make many HTTP requests
     * concurrently (common during application bootstrap).
     *
     * Defaults to false. If no value is specified, returns the current configured value.
     *
     * @param {boolean=} value If true, when requests are loaded, they will schedule a deferred
     *    "apply" on the next tick, giving time for subsequent requests in a roughly ~10ms window
     *    to load and share the same digest cycle.
     *
     * @returns {boolean|Object} If a value is specified, returns the $httpProvider for chaining.
     *    otherwise, returns the current configured value.
     */
    this.useApplyAsync = function (value) {
      if (isDefined(value)) {
        useApplyAsync = !!value;
        return this;
      }
      return useApplyAsync;
    };

    /**
     * @ngdoc property
     * @name $httpProvider#interceptors
     * @description
     *
     * Array containing service factories for all synchronous or asynchronous {@link ng.$http $http}
     * pre-processing of request or postprocessing of responses.
     *
     * These service factories are ordered by request, i.e. they are applied in the same order as the
     * array, on request, but reverse order, on response.
     *
     * {@link ng.$http#interceptors Interceptors detailed info}
     */
    var interceptorFactories = this.interceptors = [];

    /**
     * @ngdoc property
     * @name $httpProvider#xsrfTrustedOrigins
     * @description
     *
     * Array containing URLs whose origins are trusted to receive the XSRF token. See the
     * {@link ng.$http#security-considerations Security Considerations} sections for more details on
     * XSRF.
     *
     * **Note:** An "origin" consists of the [URI scheme](https://en.wikipedia.org/wiki/URI_scheme),
     * the [hostname](https://en.wikipedia.org/wiki/Hostname) and the
     * [port number](https://en.wikipedia.org/wiki/Port_(computer_networking). For `http:` and
     * `https:`, the port number can be omitted if using th default ports (80 and 443 respectively).
     * Examples: `http://example.com`, `https://api.example.com:9876`
     *
     * <div class="alert alert-warning">
     *   It is not possible to trust specific URLs/paths. The `path`, `query` and `fragment` parts
     *   of a URL will be ignored. For example, `https://foo.com/path/bar?query=baz#fragment` will be
     *   treated as `https://foo.com`, meaning that **all** requests to URLs starting with
     *   `https://foo.com/` will include the XSRF token.
     * </div>
     *
     * @example
     *
     * ```js
     * // App served from `https://example.com/`.
     * angular.
     *   module('xsrfTrustedOriginsExample', []).
     *   config(['$httpProvider', function($httpProvider) {
     *     $httpProvider.xsrfTrustedOrigins.push('https://api.example.com');
     *   }]).
     *   run(['$http', function($http) {
     *     // The XSRF token will be sent.
     *     $http.get('https://api.example.com/preferences').then(...);
     *
     *     // The XSRF token will NOT be sent.
     *     $http.get('https://stats.example.com/activity').then(...);
     *   }]);
     * ```
     */
    var xsrfTrustedOrigins = this.xsrfTrustedOrigins = [];

    /**
     * @ngdoc property
     * @name $httpProvider#xsrfWhitelistedOrigins
     * @description
     *
     * @deprecated
     * sinceVersion="1.8.1"
     *
     * This property is deprecated. Use {@link $httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}
     * instead.
     */
    Object.defineProperty(this, 'xsrfWhitelistedOrigins', {
      get: function get() {
        return this.xsrfTrustedOrigins;
      },
      set: function set(origins) {
        this.xsrfTrustedOrigins = origins;
      }
    });
    this.$get = ['$browser', '$httpBackend', '$$cookieReader', '$cacheFactory', '$rootScope', '$q', '$injector', '$sce', function ($browser, $httpBackend, $$cookieReader, $cacheFactory, $rootScope, $q, $injector, $sce) {
      var defaultCache = $cacheFactory('$http');

      /**
       * Make sure that default param serializer is exposed as a function
       */
      defaults.paramSerializer = isString(defaults.paramSerializer) ? $injector.get(defaults.paramSerializer) : defaults.paramSerializer;

      /**
       * Interceptors stored in reverse order. Inner interceptors before outer interceptors.
       * The reversal is needed so that we can build up the interception chain around the
       * server request.
       */
      var reversedInterceptors = [];
      forEach(interceptorFactories, function (interceptorFactory) {
        reversedInterceptors.unshift(isString(interceptorFactory) ? $injector.get(interceptorFactory) : $injector.invoke(interceptorFactory));
      });

      /**
       * A function to check request URLs against a list of allowed origins.
       */
      var urlIsAllowedOrigin = urlIsAllowedOriginFactory(xsrfTrustedOrigins);

      /**
       * @ngdoc service
       * @kind function
       * @name $http
       * @requires ng.$httpBackend
       * @requires $cacheFactory
       * @requires $rootScope
       * @requires $q
       * @requires $injector
       *
       * @description
       * The `$http` service is a core AngularJS service that facilitates communication with the remote
       * HTTP servers via the browser's [XMLHttpRequest](https://developer.mozilla.org/en/xmlhttprequest)
       * object or via [JSONP](http://en.wikipedia.org/wiki/JSONP).
       *
       * For unit testing applications that use `$http` service, see
       * {@link ngMock.$httpBackend $httpBackend mock}.
       *
       * For a higher level of abstraction, please check out the {@link ngResource.$resource
       * $resource} service.
       *
       * The $http API is based on the {@link ng.$q deferred/promise APIs} exposed by
       * the $q service. While for simple usage patterns this doesn't matter much, for advanced usage
       * it is important to familiarize yourself with these APIs and the guarantees they provide.
       *
       *
       * ## General usage
       * The `$http` service is a function which takes a single argument — a {@link $http#usage configuration object} —
       * that is used to generate an HTTP request and returns  a {@link ng.$q promise} that is
       * resolved (request success) or rejected (request failure) with a
       * {@link ng.$http#$http-returns response} object.
       *
       * ```js
       *   // Simple GET request example:
       *   $http({
       *     method: 'GET',
       *     url: '/someUrl'
       *   }).then(function successCallback(response) {
       *       // this callback will be called asynchronously
       *       // when the response is available
       *     }, function errorCallback(response) {
       *       // called asynchronously if an error occurs
       *       // or server returns response with an error status.
       *     });
       * ```
       *
       *
       * ## Shortcut methods
       *
       * Shortcut methods are also available. All shortcut methods require passing in the URL, and
       * request data must be passed in for POST/PUT requests. An optional config can be passed as the
       * last argument.
       *
       * ```js
       *   $http.get('/someUrl', config).then(successCallback, errorCallback);
       *   $http.post('/someUrl', data, config).then(successCallback, errorCallback);
       * ```
       *
       * Complete list of shortcut methods:
       *
       * - {@link ng.$http#get $http.get}
       * - {@link ng.$http#head $http.head}
       * - {@link ng.$http#post $http.post}
       * - {@link ng.$http#put $http.put}
       * - {@link ng.$http#delete $http.delete}
       * - {@link ng.$http#jsonp $http.jsonp}
       * - {@link ng.$http#patch $http.patch}
       *
       *
       * ## Writing Unit Tests that use $http
       * When unit testing (using {@link ngMock ngMock}), it is necessary to call
       * {@link ngMock.$httpBackend#flush $httpBackend.flush()} to flush each pending
       * request using trained responses.
       *
       * ```
       * $httpBackend.expectGET(...);
       * $http.get(...);
       * $httpBackend.flush();
       * ```
       *
       * ## Setting HTTP Headers
       *
       * The $http service will automatically add certain HTTP headers to all requests. These defaults
       * can be fully configured by accessing the `$httpProvider.defaults.headers` configuration
       * object, which currently contains this default configuration:
       *
       * - `$httpProvider.defaults.headers.common` (headers that are common for all requests):
       *   - <code>Accept: application/json, text/plain, \*&#65279;/&#65279;\*</code>
       * - `$httpProvider.defaults.headers.post`: (header defaults for POST requests)
       *   - `Content-Type: application/json`
       * - `$httpProvider.defaults.headers.put` (header defaults for PUT requests)
       *   - `Content-Type: application/json`
       *
       * To add or overwrite these defaults, simply add or remove a property from these configuration
       * objects. To add headers for an HTTP method other than POST or PUT, simply add a new object
       * with the lowercased HTTP method name as the key, e.g.
       * `$httpProvider.defaults.headers.get = { 'My-Header' : 'value' }`.
       *
       * The defaults can also be set at runtime via the `$http.defaults` object in the same
       * fashion. For example:
       *
       * ```
       * module.run(function($http) {
       *   $http.defaults.headers.common.Authorization = 'Basic YmVlcDpib29w';
       * });
       * ```
       *
       * In addition, you can supply a `headers` property in the config object passed when
       * calling `$http(config)`, which overrides the defaults without changing them globally.
       *
       * To explicitly remove a header automatically added via $httpProvider.defaults.headers on a per request basis,
       * Use the `headers` property, setting the desired header to `undefined`. For example:
       *
       * ```js
       * var req = {
       *  method: 'POST',
       *  url: 'http://example.com',
       *  headers: {
       *    'Content-Type': undefined
       *  },
       *  data: { test: 'test' }
       * }
       *
       * $http(req).then(function(){...}, function(){...});
       * ```
       *
       * ## Transforming Requests and Responses
       *
       * Both requests and responses can be transformed using transformation functions: `transformRequest`
       * and `transformResponse`. These properties can be a single function that returns
       * the transformed value (`function(data, headersGetter, status)`) or an array of such transformation functions,
       * which allows you to `push` or `unshift` a new transformation function into the transformation chain.
       *
       * <div class="alert alert-warning">
       * **Note:** AngularJS does not make a copy of the `data` parameter before it is passed into the `transformRequest` pipeline.
       * That means changes to the properties of `data` are not local to the transform function (since Javascript passes objects by reference).
       * For example, when calling `$http.get(url, $scope.myObject)`, modifications to the object's properties in a transformRequest
       * function will be reflected on the scope and in any templates where the object is data-bound.
       * To prevent this, transform functions should have no side-effects.
       * If you need to modify properties, it is recommended to make a copy of the data, or create new object to return.
       * </div>
       *
       * ### Default Transformations
       *
       * The `$httpProvider` provider and `$http` service expose `defaults.transformRequest` and
       * `defaults.transformResponse` properties. If a request does not provide its own transformations
       * then these will be applied.
       *
       * You can augment or replace the default transformations by modifying these properties by adding to or
       * replacing the array.
       *
       * AngularJS provides the following default transformations:
       *
       * Request transformations (`$httpProvider.defaults.transformRequest` and `$http.defaults.transformRequest`) is
       * an array with one function that does the following:
       *
       * - If the `data` property of the request configuration object contains an object, serialize it
       *   into JSON format.
       *
       * Response transformations (`$httpProvider.defaults.transformResponse` and `$http.defaults.transformResponse`) is
       * an array with one function that does the following:
       *
       *  - If XSRF prefix is detected, strip it (see Security Considerations section below).
       *  - If the `Content-Type` is `application/json` or the response looks like JSON,
      *      deserialize it using a JSON parser.
       *
       *
       * ### Overriding the Default Transformations Per Request
       *
       * If you wish to override the request/response transformations only for a single request then provide
       * `transformRequest` and/or `transformResponse` properties on the configuration object passed
       * into `$http`.
       *
       * Note that if you provide these properties on the config object the default transformations will be
       * overwritten. If you wish to augment the default transformations then you must include them in your
       * local transformation array.
       *
       * The following code demonstrates adding a new response transformation to be run after the default response
       * transformations have been run.
       *
       * ```js
       * function appendTransform(defaults, transform) {
       *
       *   // We can't guarantee that the default transformation is an array
       *   defaults = angular.isArray(defaults) ? defaults : [defaults];
       *
       *   // Append the new transformation to the defaults
       *   return defaults.concat(transform);
       * }
       *
       * $http({
       *   url: '...',
       *   method: 'GET',
       *   transformResponse: appendTransform($http.defaults.transformResponse, function(value) {
       *     return doTransform(value);
       *   })
       * });
       * ```
       *
       *
       * ## Caching
       *
       * {@link ng.$http `$http`} responses are not cached by default. To enable caching, you must
       * set the config.cache value or the default cache value to TRUE or to a cache object (created
       * with {@link ng.$cacheFactory `$cacheFactory`}). If defined, the value of config.cache takes
       * precedence over the default cache value.
       *
       * In order to:
       *   * cache all responses - set the default cache value to TRUE or to a cache object
       *   * cache a specific response - set config.cache value to TRUE or to a cache object
       *
       * If caching is enabled, but neither the default cache nor config.cache are set to a cache object,
       * then the default `$cacheFactory("$http")` object is used.
       *
       * The default cache value can be set by updating the
       * {@link ng.$http#defaults `$http.defaults.cache`} property or the
       * {@link $httpProvider#defaults `$httpProvider.defaults.cache`} property.
       *
       * When caching is enabled, {@link ng.$http `$http`} stores the response from the server using
       * the relevant cache object. The next time the same request is made, the response is returned
       * from the cache without sending a request to the server.
       *
       * Take note that:
       *
       *   * Only GET and JSONP requests are cached.
       *   * The cache key is the request URL including search parameters; headers are not considered.
       *   * Cached responses are returned asynchronously, in the same way as responses from the server.
       *   * If multiple identical requests are made using the same cache, which is not yet populated,
       *     one request will be made to the server and remaining requests will return the same response.
       *   * A cache-control header on the response does not affect if or how responses are cached.
       *
       *
       * ## Interceptors
       *
       * Before you start creating interceptors, be sure to understand the
       * {@link ng.$q $q and deferred/promise APIs}.
       *
       * For purposes of global error handling, authentication, or any kind of synchronous or
       * asynchronous pre-processing of request or postprocessing of responses, it is desirable to be
       * able to intercept requests before they are handed to the server and
       * responses before they are handed over to the application code that
       * initiated these requests. The interceptors leverage the {@link ng.$q
       * promise APIs} to fulfill this need for both synchronous and asynchronous pre-processing.
       *
       * The interceptors are service factories that are registered with the `$httpProvider` by
       * adding them to the `$httpProvider.interceptors` array. The factory is called and
       * injected with dependencies (if specified) and returns the interceptor.
       *
       * There are two kinds of interceptors (and two kinds of rejection interceptors):
       *
       *   * `request`: interceptors get called with a http {@link $http#usage config} object. The function is free to
       *     modify the `config` object or create a new one. The function needs to return the `config`
       *     object directly, or a promise containing the `config` or a new `config` object.
       *   * `requestError`: interceptor gets called when a previous interceptor threw an error or
       *     resolved with a rejection.
       *   * `response`: interceptors get called with http `response` object. The function is free to
       *     modify the `response` object or create a new one. The function needs to return the `response`
       *     object directly, or as a promise containing the `response` or a new `response` object.
       *   * `responseError`: interceptor gets called when a previous interceptor threw an error or
       *     resolved with a rejection.
       *
       *
       * ```js
       *   // register the interceptor as a service
       *   $provide.factory('myHttpInterceptor', function($q, dependency1, dependency2) {
       *     return {
       *       // optional method
       *       'request': function(config) {
       *         // do something on success
       *         return config;
       *       },
       *
       *       // optional method
       *      'requestError': function(rejection) {
       *         // do something on error
       *         if (canRecover(rejection)) {
       *           return responseOrNewPromise
       *         }
       *         return $q.reject(rejection);
       *       },
       *
       *
       *
       *       // optional method
       *       'response': function(response) {
       *         // do something on success
       *         return response;
       *       },
       *
       *       // optional method
       *      'responseError': function(rejection) {
       *         // do something on error
       *         if (canRecover(rejection)) {
       *           return responseOrNewPromise
       *         }
       *         return $q.reject(rejection);
       *       }
       *     };
       *   });
       *
       *   $httpProvider.interceptors.push('myHttpInterceptor');
       *
       *
       *   // alternatively, register the interceptor via an anonymous factory
       *   $httpProvider.interceptors.push(function($q, dependency1, dependency2) {
       *     return {
       *      'request': function(config) {
       *          // same as above
       *       },
       *
       *       'response': function(response) {
       *          // same as above
       *       }
       *     };
       *   });
       * ```
       *
       * ## Security Considerations
       *
       * When designing web applications, consider security threats from:
       *
       * - [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
       * - [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery)
       *
       * Both server and the client must cooperate in order to eliminate these threats. AngularJS comes
       * pre-configured with strategies that address these issues, but for this to work backend server
       * cooperation is required.
       *
       * ### JSON Vulnerability Protection
       *
       * A [JSON vulnerability](http://haacked.com/archive/2008/11/20/anatomy-of-a-subtle-json-vulnerability.aspx)
       * allows third party website to turn your JSON resource URL into
       * [JSONP](http://en.wikipedia.org/wiki/JSONP) request under some conditions. To
       * counter this your server can prefix all JSON requests with following string `")]}',\n"`.
       * AngularJS will automatically strip the prefix before processing it as JSON.
       *
       * For example if your server needs to return:
       * ```js
       * ['one','two']
       * ```
       *
       * which is vulnerable to attack, your server can return:
       * ```js
       * )]}',
       * ['one','two']
       * ```
       *
       * AngularJS will strip the prefix, before processing the JSON.
       *
       *
       * ### Cross Site Request Forgery (XSRF) Protection
       *
       * [XSRF](http://en.wikipedia.org/wiki/Cross-site_request_forgery) is an attack technique by
       * which the attacker can trick an authenticated user into unknowingly executing actions on your
       * website. AngularJS provides a mechanism to counter XSRF. When performing XHR requests, the
       * $http service reads a token from a cookie (by default, `XSRF-TOKEN`) and sets it as an HTTP
       * header (by default `X-XSRF-TOKEN`). Since only JavaScript that runs on your domain could read
       * the cookie, your server can be assured that the XHR came from JavaScript running on your
       * domain.
       *
       * To take advantage of this, your server needs to set a token in a JavaScript readable session
       * cookie called `XSRF-TOKEN` on the first HTTP GET request. On subsequent XHR requests the
       * server can verify that the cookie matches the `X-XSRF-TOKEN` HTTP header, and therefore be
       * sure that only JavaScript running on your domain could have sent the request. The token must
       * be unique for each user and must be verifiable by the server (to prevent the JavaScript from
       * making up its own tokens). We recommend that the token is a digest of your site's
       * authentication cookie with a [salt](https://en.wikipedia.org/wiki/Salt_(cryptography&#41;)
       * for added security.
       *
       * The header will &mdash; by default &mdash; **not** be set for cross-domain requests. This
       * prevents unauthorized servers (e.g. malicious or compromised 3rd-party APIs) from gaining
       * access to your users' XSRF tokens and exposing them to Cross Site Request Forgery. If you
       * want to, you can trust additional origins to also receive the XSRF token, by adding them
       * to {@link ng.$httpProvider#xsrfTrustedOrigins xsrfTrustedOrigins}. This might be
       * useful, for example, if your application, served from `example.com`, needs to access your API
       * at `api.example.com`.
       * See {@link ng.$httpProvider#xsrfTrustedOrigins $httpProvider.xsrfTrustedOrigins} for
       * more details.
       *
       * <div class="alert alert-danger">
       *   **Warning**<br />
       *   Only trusted origins that you have control over and make sure you understand the
       *   implications of doing so.
       * </div>
       *
       * The name of the cookie and the header can be specified using the `xsrfCookieName` and
       * `xsrfHeaderName` properties of either `$httpProvider.defaults` at config-time,
       * `$http.defaults` at run-time, or the per-request config object.
       *
       * In order to prevent collisions in environments where multiple AngularJS apps share the
       * same domain or subdomain, we recommend that each application uses a unique cookie name.
       *
       *
       * @param {object} config Object describing the request to be made and how it should be
       *    processed. The object has following properties:
       *
       *    - **method** – `{string}` – HTTP method (e.g. 'GET', 'POST', etc)
       *    - **url** – `{string|TrustedObject}` – Absolute or relative URL of the resource that is being requested;
       *      or an object created by a call to `$sce.trustAsResourceUrl(url)`.
       *    - **params** – `{Object.<string|Object>}` – Map of strings or objects which will be serialized
       *      with the `paramSerializer` and appended as GET parameters.
       *    - **data** – `{string|Object}` – Data to be sent as the request message data.
       *    - **headers** – `{Object}` – Map of strings or functions which return strings representing
       *      HTTP headers to send to the server. If the return value of a function is null, the
       *      header will not be sent. Functions accept a config object as an argument.
       *    - **eventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest object.
       *      To bind events to the XMLHttpRequest upload object, use `uploadEventHandlers`.
       *      The handler will be called in the context of a `$apply` block.
       *    - **uploadEventHandlers** - `{Object}` - Event listeners to be bound to the XMLHttpRequest upload
       *      object. To bind events to the XMLHttpRequest object, use `eventHandlers`.
       *      The handler will be called in the context of a `$apply` block.
       *    - **xsrfHeaderName** – `{string}` – Name of HTTP header to populate with the XSRF token.
       *    - **xsrfCookieName** – `{string}` – Name of cookie containing the XSRF token.
       *    - **transformRequest** –
       *      `{function(data, headersGetter)|Array.<function(data, headersGetter)>}` –
       *      transform function or an array of such functions. The transform function takes the http
       *      request body and headers and returns its transformed (typically serialized) version.
       *      See {@link ng.$http#overriding-the-default-transformations-per-request
       *      Overriding the Default Transformations}
       *    - **transformResponse** –
       *      `{function(data, headersGetter, status)|Array.<function(data, headersGetter, status)>}` –
       *      transform function or an array of such functions. The transform function takes the http
       *      response body, headers and status and returns its transformed (typically deserialized) version.
       *      See {@link ng.$http#overriding-the-default-transformations-per-request
       *      Overriding the Default Transformations}
       *    - **paramSerializer** - `{string|function(Object<string,string>):string}` - A function used to
       *      prepare the string representation of request parameters (specified as an object).
       *      If specified as string, it is interpreted as function registered with the
       *      {@link $injector $injector}, which means you can create your own serializer
       *      by registering it as a {@link auto.$provide#service service}.
       *      The default serializer is the {@link $httpParamSerializer $httpParamSerializer};
       *      alternatively, you can use the {@link $httpParamSerializerJQLike $httpParamSerializerJQLike}
       *    - **cache** – `{boolean|Object}` – A boolean value or object created with
       *      {@link ng.$cacheFactory `$cacheFactory`} to enable or disable caching of the HTTP response.
       *      See {@link $http#caching $http Caching} for more information.
       *    - **timeout** – `{number|Promise}` – timeout in milliseconds, or {@link ng.$q promise}
       *      that should abort the request when resolved.
       *
       *      A numerical timeout or a promise returned from {@link ng.$timeout $timeout}, will set
       *      the `xhrStatus` in the {@link $http#$http-returns response} to "timeout", and any other
       *      resolved promise will set it to "abort", following standard XMLHttpRequest behavior.
       *
       *    - **withCredentials** - `{boolean}` - whether to set the `withCredentials` flag on the
       *      XHR object. See [requests with credentials](https://developer.mozilla.org/docs/Web/HTTP/Access_control_CORS#Requests_with_credentials)
       *      for more information.
       *    - **responseType** - `{string}` - see
       *      [XMLHttpRequest.responseType](https://developer.mozilla.org/en-US/docs/Web/API/XMLHttpRequest#xmlhttprequest-responsetype).
       *
       * @returns {HttpPromise} A {@link ng.$q `Promise}` that will be resolved (request success)
       *   or rejected (request failure) with a response object.
       *
       *   The response object has these properties:
       *
       *   - **data** – `{string|Object}` – The response body transformed with
       *     the transform functions.
       *   - **status** – `{number}` – HTTP status code of the response.
       *   - **headers** – `{function([headerName])}` – Header getter function.
       *   - **config** – `{Object}` – The configuration object that was used
       *     to generate the request.
       *   - **statusText** – `{string}` – HTTP status text of the response.
       *   - **xhrStatus** – `{string}` – Status of the XMLHttpRequest
       *     (`complete`, `error`, `timeout` or `abort`).
       *
       *
       *   A response status code between 200 and 299 is considered a success status
       *   and will result in the success callback being called. Any response status
       *   code outside of that range is considered an error status and will result
       *   in the error callback being called.
       *   Also, status codes less than -1 are normalized to zero. -1 usually means
       *   the request was aborted, e.g. using a `config.timeout`. More information
       *   about the status might be available in the `xhrStatus` property.
       *
       *   Note that if the response is a redirect, XMLHttpRequest will transparently
       *   follow it, meaning that the outcome (success or error) will be determined
       *   by the final response status code.
       *
       *
       * @property {Array.<Object>} pendingRequests Array of config objects for currently pending
       *   requests. This is primarily meant to be used for debugging purposes.
       *
       *
       * @example
      <example module="httpExample" name="http-service">
      <file name="index.html">
      <div ng-controller="FetchController">
      <select ng-model="method" aria-label="Request method">
        <option>GET</option>
        <option>JSONP</option>
      </select>
      <input type="text" ng-model="url" size="80" aria-label="URL" />
      <button id="fetchbtn" ng-click="fetch()">fetch</button><br>
      <button id="samplegetbtn" ng-click="updateModel('GET', 'http-hello.html')">Sample GET</button>
      <button id="samplejsonpbtn"
        ng-click="updateModel('JSONP',
                      'https://angularjs.org/greet.php?name=Super%20Hero')">
        Sample JSONP
      </button>
      <button id="invalidjsonpbtn"
        ng-click="updateModel('JSONP', 'https://angularjs.org/doesntexist')">
          Invalid JSONP
        </button>
      <pre>http status code: {{status}}</pre>
      <pre>http response data: {{data}}</pre>
      </div>
      </file>
      <file name="script.js">
      angular.module('httpExample', [])
      .config(['$sceDelegateProvider', function($sceDelegateProvider) {
        // We must add the JSONP endpoint that we are using to the trusted list to show that we trust it
        $sceDelegateProvider.trustedResourceUrlList([
          'self',
          'https://angularjs.org/**'
        ]);
      }])
      .controller('FetchController', ['$scope', '$http', '$templateCache',
        function($scope, $http, $templateCache) {
          $scope.method = 'GET';
          $scope.url = 'http-hello.html';
           $scope.fetch = function() {
            $scope.code = null;
            $scope.response = null;
             $http({method: $scope.method, url: $scope.url, cache: $templateCache}).
              then(function(response) {
                $scope.status = response.status;
                $scope.data = response.data;
              }, function(response) {
                $scope.data = response.data || 'Request failed';
                $scope.status = response.status;
            });
          };
           $scope.updateModel = function(method, url) {
            $scope.method = method;
            $scope.url = url;
          };
        }]);
      </file>
      <file name="http-hello.html">
      Hello, $http!
      </file>
      <file name="protractor.js" type="protractor">
      var status = element(by.binding('status'));
      var data = element(by.binding('data'));
      var fetchBtn = element(by.id('fetchbtn'));
      var sampleGetBtn = element(by.id('samplegetbtn'));
      var invalidJsonpBtn = element(by.id('invalidjsonpbtn'));
      it('should make an xhr GET request', function() {
      sampleGetBtn.click();
      fetchBtn.click();
      expect(status.getText()).toMatch('200');
      expect(data.getText()).toMatch(/Hello, \$http!/);
      });
      // Commented out due to flakes. See https://github.com/angular/angular.js/issues/9185
      // it('should make a JSONP request to angularjs.org', function() {
      //   var sampleJsonpBtn = element(by.id('samplejsonpbtn'));
      //   sampleJsonpBtn.click();
      //   fetchBtn.click();
      //   expect(status.getText()).toMatch('200');
      //   expect(data.getText()).toMatch(/Super Hero!/);
      // });
      it('should make JSONP request to invalid URL and invoke the error handler',
        function() {
      invalidJsonpBtn.click();
      fetchBtn.click();
      expect(status.getText()).toMatch('0');
      expect(data.getText()).toMatch('Request failed');
      });
      </file>
      </example>
       */
      function $http(requestConfig) {
        if (!isObject(requestConfig)) {
          throw minErr('$http')('badreq', 'Http request configuration must be an object.  Received: {0}', requestConfig);
        }
        if (!isString($sce.valueOf(requestConfig.url))) {
          throw minErr('$http')('badreq', 'Http request configuration url must be a string or a $sce trusted object.  Received: {0}', requestConfig.url);
        }
        var config = extend({
          method: 'get',
          transformRequest: defaults.transformRequest,
          transformResponse: defaults.transformResponse,
          paramSerializer: defaults.paramSerializer,
          jsonpCallbackParam: defaults.jsonpCallbackParam
        }, requestConfig);
        config.headers = mergeHeaders(requestConfig);
        config.method = uppercase(config.method);
        config.paramSerializer = isString(config.paramSerializer) ? $injector.get(config.paramSerializer) : config.paramSerializer;
        $browser.$$incOutstandingRequestCount('$http');
        var requestInterceptors = [];
        var responseInterceptors = [];
        var promise = $q.resolve(config);

        // apply interceptors
        forEach(reversedInterceptors, function (interceptor) {
          if (interceptor.request || interceptor.requestError) {
            requestInterceptors.unshift(interceptor.request, interceptor.requestError);
          }
          if (interceptor.response || interceptor.responseError) {
            responseInterceptors.push(interceptor.response, interceptor.responseError);
          }
        });
        promise = chainInterceptors(promise, requestInterceptors);
        promise = promise.then(serverRequest);
        promise = chainInterceptors(promise, responseInterceptors);
        promise = promise["finally"](completeOutstandingRequest);
        return promise;
        function chainInterceptors(promise, interceptors) {
          for (var i = 0, ii = interceptors.length; i < ii;) {
            var thenFn = interceptors[i++];
            var rejectFn = interceptors[i++];
            promise = promise.then(thenFn, rejectFn);
          }
          interceptors.length = 0;
          return promise;
        }
        function completeOutstandingRequest() {
          $browser.$$completeOutstandingRequest(noop, '$http');
        }
        function executeHeaderFns(headers, config) {
          var headerContent,
            processedHeaders = {};
          forEach(headers, function (headerFn, header) {
            if (isFunction(headerFn)) {
              headerContent = headerFn(config);
              if (headerContent != null) {
                processedHeaders[header] = headerContent;
              }
            } else {
              processedHeaders[header] = headerFn;
            }
          });
          return processedHeaders;
        }
        function mergeHeaders(config) {
          var defHeaders = defaults.headers,
            reqHeaders = extend({}, config.headers),
            defHeaderName,
            lowercaseDefHeaderName,
            reqHeaderName;
          defHeaders = extend({}, defHeaders.common, defHeaders[lowercase(config.method)]);

          // using for-in instead of forEach to avoid unnecessary iteration after header has been found
          defaultHeadersIteration: for (defHeaderName in defHeaders) {
            lowercaseDefHeaderName = lowercase(defHeaderName);
            for (reqHeaderName in reqHeaders) {
              if (lowercase(reqHeaderName) === lowercaseDefHeaderName) {
                continue defaultHeadersIteration;
              }
            }
            reqHeaders[defHeaderName] = defHeaders[defHeaderName];
          }

          // execute if header value is a function for merged headers
          return executeHeaderFns(reqHeaders, shallowCopy(config));
        }
        function serverRequest(config) {
          var headers = config.headers;
          var reqData = transformData(config.data, headersGetter(headers), undefined, config.transformRequest);

          // strip content-type if data is undefined
          if (isUndefined(reqData)) {
            forEach(headers, function (value, header) {
              if (lowercase(header) === 'content-type') {
                delete headers[header];
              }
            });
          }
          if (isUndefined(config.withCredentials) && !isUndefined(defaults.withCredentials)) {
            config.withCredentials = defaults.withCredentials;
          }

          // send request
          return sendReq(config, reqData).then(transformResponse, transformResponse);
        }
        function transformResponse(response) {
          // make a copy since the response must be cacheable
          var resp = extend({}, response);
          resp.data = transformData(response.data, response.headers, response.status, config.transformResponse);
          return isSuccess(response.status) ? resp : $q.reject(resp);
        }
      }
      $http.pendingRequests = [];

      /**
       * @ngdoc method
       * @name $http#get
       *
       * @description
       * Shortcut method to perform `GET` request.
       *
       * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
       *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
       * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
       * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
       * See {@link ng.$http#$http-returns `$http()` return value}.
       */

      /**
       * @ngdoc method
       * @name $http#delete
       *
       * @description
       * Shortcut method to perform `DELETE` request.
       *
       * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
       *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
       * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
       * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
       * See {@link ng.$http#$http-returns `$http()` return value}.
       */

      /**
       * @ngdoc method
       * @name $http#head
       *
       * @description
       * Shortcut method to perform `HEAD` request.
       *
       * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
       *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
       * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
       * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
       * See {@link ng.$http#$http-returns `$http()` return value}.
       */

      /**
       * @ngdoc method
       * @name $http#jsonp
       *
       * @description
       * Shortcut method to perform `JSONP` request.
       *
       * Note that, since JSONP requests are sensitive because the response is given full access to the browser,
       * the url must be declared, via {@link $sce} as a trusted resource URL.
       * You can trust a URL by adding it to the trusted resource URL list via
       * {@link $sceDelegateProvider#trustedResourceUrlList  `$sceDelegateProvider.trustedResourceUrlList`} or
       * by explicitly trusting the URL via {@link $sce#trustAsResourceUrl `$sce.trustAsResourceUrl(url)`}.
       *
       * You should avoid generating the URL for the JSONP request from user provided data.
       * Provide additional query parameters via `params` property of the `config` parameter, rather than
       * modifying the URL itself.
       *
       * JSONP requests must specify a callback to be used in the response from the server. This callback
       * is passed as a query parameter in the request. You must specify the name of this parameter by
       * setting the `jsonpCallbackParam` property on the request config object.
       *
       * ```
       * $http.jsonp('some/trusted/url', {jsonpCallbackParam: 'callback'})
       * ```
       *
       * You can also specify a default callback parameter name in `$http.defaults.jsonpCallbackParam`.
       * Initially this is set to `'callback'`.
       *
       * <div class="alert alert-danger">
       * You can no longer use the `JSON_CALLBACK` string as a placeholder for specifying where the callback
       * parameter value should go.
       * </div>
       *
       * If you would like to customise where and how the callbacks are stored then try overriding
       * or decorating the {@link $jsonpCallbacks} service.
       *
       * @param {string|TrustedObject} url Absolute or relative URL of the resource that is being requested;
       *                                   or an object created by a call to `$sce.trustAsResourceUrl(url)`.
       * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
       * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
       * See {@link ng.$http#$http-returns `$http()` return value}.
       */
      createShortMethods('get', 'delete', 'head', 'jsonp');

      /**
       * @ngdoc method
       * @name $http#post
       *
       * @description
       * Shortcut method to perform `POST` request.
       *
       * @param {string} url Relative or absolute URL specifying the destination of the request
       * @param {*} data Request content
       * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
       * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
       * See {@link ng.$http#$http-returns `$http()` return value}.
       */

      /**
       * @ngdoc method
       * @name $http#put
       *
       * @description
       * Shortcut method to perform `PUT` request.
       *
       * @param {string} url Relative or absolute URL specifying the destination of the request
       * @param {*} data Request content
       * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
       * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
       * See {@link ng.$http#$http-returns `$http()` return value}.
       */

      /**
       * @ngdoc method
       * @name $http#patch
       *
       * @description
       * Shortcut method to perform `PATCH` request.
       *
       * @param {string} url Relative or absolute URL specifying the destination of the request
       * @param {*} data Request content
       * @param {Object=} config Optional configuration object. See {@link ng.$http#$http-arguments `$http()` arguments}.
       * @returns {HttpPromise}  A Promise that will be resolved or rejected with a response object.
       * See {@link ng.$http#$http-returns `$http()` return value}.
       */
      createShortMethodsWithData('post', 'put', 'patch');

      /**
       * @ngdoc property
       * @name $http#defaults
       *
       * @description
       * Runtime equivalent of the `$httpProvider.defaults` property. Allows configuration of
       * default headers, withCredentials as well as request and response transformations.
       *
       * See "Setting HTTP Headers" and "Transforming Requests and Responses" sections above.
       */
      $http.defaults = defaults;
      return $http;
      function createShortMethods(names) {
        forEach(arguments, function (name) {
          $http[name] = function (url, config) {
            return $http(extend({}, config || {}, {
              method: name,
              url: url
            }));
          };
        });
      }
      function createShortMethodsWithData(name) {
        forEach(arguments, function (name) {
          $http[name] = function (url, data, config) {
            return $http(extend({}, config || {}, {
              method: name,
              url: url,
              data: data
            }));
          };
        });
      }

      /**
       * Makes the request.
       *
       * !!! ACCESSES CLOSURE VARS:
       * $httpBackend, defaults, $log, $rootScope, defaultCache, $http.pendingRequests
       */
      function sendReq(config, reqData) {
        var deferred = $q.defer(),
          promise = deferred.promise,
          cache,
          cachedResp,
          reqHeaders = config.headers,
          isJsonp = lowercase(config.method) === 'jsonp',
          url = config.url;
        if (isJsonp) {
          // JSONP is a pretty sensitive operation where we're allowing a script to have full access to
          // our DOM and JS space.  So we require that the URL satisfies SCE.RESOURCE_URL.
          url = $sce.getTrustedResourceUrl(url);
        } else if (!isString(url)) {
          // If it is not a string then the URL must be a $sce trusted object
          url = $sce.valueOf(url);
        }
        url = buildUrl(url, config.paramSerializer(config.params));
        if (isJsonp) {
          // Check the url and add the JSONP callback placeholder
          url = sanitizeJsonpCallbackParam(url, config.jsonpCallbackParam);
        }
        $http.pendingRequests.push(config);
        promise.then(removePendingReq, removePendingReq);
        if ((config.cache || defaults.cache) && config.cache !== false && (config.method === 'GET' || config.method === 'JSONP')) {
          cache = isObject(config.cache) ? config.cache : isObject(/** @type {?} */defaults.cache) ? /** @type {?} */defaults.cache : defaultCache;
        }
        if (cache) {
          cachedResp = cache.get(url);
          if (isDefined(cachedResp)) {
            if (isPromiseLike(cachedResp)) {
              // cached request has already been sent, but there is no response yet
              cachedResp.then(resolvePromiseWithResult, resolvePromiseWithResult);
            } else {
              // serving from cache
              if (isArray(cachedResp)) {
                resolvePromise(cachedResp[1], cachedResp[0], shallowCopy(cachedResp[2]), cachedResp[3], cachedResp[4]);
              } else {
                resolvePromise(cachedResp, 200, {}, 'OK', 'complete');
              }
            }
          } else {
            // put the promise for the non-transformed response into cache as a placeholder
            cache.put(url, promise);
          }
        }

        // if we won't have the response in cache, set the xsrf headers and
        // send the request to the backend
        if (isUndefined(cachedResp)) {
          var xsrfValue = urlIsAllowedOrigin(config.url) ? $$cookieReader()[config.xsrfCookieName || defaults.xsrfCookieName] : undefined;
          if (xsrfValue) {
            reqHeaders[config.xsrfHeaderName || defaults.xsrfHeaderName] = xsrfValue;
          }
          $httpBackend(config.method, url, reqData, done, reqHeaders, config.timeout, config.withCredentials, config.responseType, createApplyHandlers(config.eventHandlers), createApplyHandlers(config.uploadEventHandlers));
        }
        return promise;
        function createApplyHandlers(eventHandlers) {
          if (eventHandlers) {
            var applyHandlers = {};
            forEach(eventHandlers, function (eventHandler, key) {
              applyHandlers[key] = function (event) {
                if (useApplyAsync) {
                  $rootScope.$applyAsync(callEventHandler);
                } else if ($rootScope.$$phase) {
                  callEventHandler();
                } else {
                  $rootScope.$apply(callEventHandler);
                }
                function callEventHandler() {
                  eventHandler(event);
                }
              };
            });
            return applyHandlers;
          }
        }

        /**
         * Callback registered to $httpBackend():
         *  - caches the response if desired
         *  - resolves the raw $http promise
         *  - calls $apply
         */
        function done(status, response, headersString, statusText, xhrStatus) {
          if (cache) {
            if (isSuccess(status)) {
              cache.put(url, [status, response, parseHeaders(headersString), statusText, xhrStatus]);
            } else {
              // remove promise from the cache
              cache.remove(url);
            }
          }
          function resolveHttpPromise() {
            resolvePromise(response, status, headersString, statusText, xhrStatus);
          }
          if (useApplyAsync) {
            $rootScope.$applyAsync(resolveHttpPromise);
          } else {
            resolveHttpPromise();
            if (!$rootScope.$$phase) $rootScope.$apply();
          }
        }

        /**
         * Resolves the raw $http promise.
         */
        function resolvePromise(response, status, headers, statusText, xhrStatus) {
          //status: HTTP response status code, 0, -1 (aborted by timeout / promise)
          status = status >= -1 ? status : 0;
          (isSuccess(status) ? deferred.resolve : deferred.reject)({
            data: response,
            status: status,
            headers: headersGetter(headers),
            config: config,
            statusText: statusText,
            xhrStatus: xhrStatus
          });
        }
        function resolvePromiseWithResult(result) {
          resolvePromise(result.data, result.status, shallowCopy(result.headers()), result.statusText, result.xhrStatus);
        }
        function removePendingReq() {
          var idx = $http.pendingRequests.indexOf(config);
          if (idx !== -1) $http.pendingRequests.splice(idx, 1);
        }
      }
      function buildUrl(url, serializedParams) {
        if (serializedParams.length > 0) {
          url += (url.indexOf('?') === -1 ? '?' : '&') + serializedParams;
        }
        return url;
      }
      function sanitizeJsonpCallbackParam(url, cbKey) {
        var parts = url.split('?');
        if (parts.length > 2) {
          // Throw if the url contains more than one `?` query indicator
          throw $httpMinErr('badjsonp', 'Illegal use more than one "?", in url, "{1}"', url);
        }
        var params = parseKeyValue(parts[1]);
        forEach(params, function (value, key) {
          if (value === 'JSON_CALLBACK') {
            // Throw if the url already contains a reference to JSON_CALLBACK
            throw $httpMinErr('badjsonp', 'Illegal use of JSON_CALLBACK in url, "{0}"', url);
          }
          if (key === cbKey) {
            // Throw if the callback param was already provided
            throw $httpMinErr('badjsonp', 'Illegal use of callback param, "{0}", in url, "{1}"', cbKey, url);
          }
        });

        // Add in the JSON_CALLBACK callback param value
        url += (url.indexOf('?') === -1 ? '?' : '&') + cbKey + '=JSON_CALLBACK';
        return url;
      }
    }];
  }

  /**
   * @ngdoc service
   * @name $xhrFactory
   * @this
   *
   * @description
   * Factory function used to create XMLHttpRequest objects.
   *
   * Replace or decorate this service to create your own custom XMLHttpRequest objects.
   *
   * ```
   * angular.module('myApp', [])
   * .factory('$xhrFactory', function() {
   *   return function createXhr(method, url) {
   *     return new window.XMLHttpRequest({mozSystem: true});
   *   };
   * });
   * ```
   *
   * @param {string} method HTTP method of the request (GET, POST, PUT, ..)
   * @param {string} url URL of the request.
   */
  function $xhrFactoryProvider() {
    this.$get = function () {
      return function createXhr() {
        return new window.XMLHttpRequest();
      };
    };
  }

  /**
   * @ngdoc service
   * @name $httpBackend
   * @requires $jsonpCallbacks
   * @requires $document
   * @requires $xhrFactory
   * @this
   *
   * @description
   * HTTP backend used by the {@link ng.$http service} that delegates to
   * XMLHttpRequest object or JSONP and deals with browser incompatibilities.
   *
   * You should never need to use this service directly, instead use the higher-level abstractions:
   * {@link ng.$http $http} or {@link ngResource.$resource $resource}.
   *
   * During testing this implementation is swapped with {@link ngMock.$httpBackend mock
   * $httpBackend} which can be trained with responses.
   */
  function $HttpBackendProvider() {
    this.$get = ['$browser', '$jsonpCallbacks', '$document', '$xhrFactory', function ($browser, $jsonpCallbacks, $document, $xhrFactory) {
      return createHttpBackend($browser, $xhrFactory, $browser.defer, $jsonpCallbacks, $document[0]);
    }];
  }
  function createHttpBackend($browser, createXhr, $browserDefer, callbacks, rawDocument) {
    // TODO(vojta): fix the signature
    return function (method, url, post, callback, headers, timeout, withCredentials, responseType, eventHandlers, uploadEventHandlers) {
      url = url || $browser.url();
      if (lowercase(method) === 'jsonp') {
        var callbackPath = callbacks.createCallback(url);
        var jsonpDone = jsonpReq(url, callbackPath, function (status, text) {
          // jsonpReq only ever sets status to 200 (OK), 404 (ERROR) or -1 (WAITING)
          var response = status === 200 && callbacks.getResponse(callbackPath);
          completeRequest(callback, status, response, '', text, 'complete');
          callbacks.removeCallback(callbackPath);
        });
      } else {
        var xhr = createXhr(method, url);
        var abortedByTimeout = false;
        xhr.open(method, url, true);
        forEach(headers, function (value, key) {
          if (isDefined(value)) {
            xhr.setRequestHeader(key, value);
          }
        });
        xhr.onload = function requestLoaded() {
          var statusText = xhr.statusText || '';

          // responseText is the old-school way of retrieving response (supported by IE9)
          // response/responseType properties were introduced in XHR Level2 spec (supported by IE10)
          var response = 'response' in xhr ? xhr.response : xhr.responseText;

          // normalize IE9 bug (http://bugs.jquery.com/ticket/1450)
          var status = xhr.status === 1223 ? 204 : xhr.status;

          // fix status code when it is 0 (0 status is undocumented).
          // Occurs when accessing file resources or on Android 4.1 stock browser
          // while retrieving files from application cache.
          if (status === 0) {
            status = response ? 200 : urlResolve(url).protocol === 'file' ? 404 : 0;
          }
          completeRequest(callback, status, response, xhr.getAllResponseHeaders(), statusText, 'complete');
        };
        var requestError = function requestError() {
          // The response is always empty
          // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
          completeRequest(callback, -1, null, null, '', 'error');
        };
        var requestAborted = function requestAborted() {
          completeRequest(callback, -1, null, null, '', abortedByTimeout ? 'timeout' : 'abort');
        };
        var requestTimeout = function requestTimeout() {
          // The response is always empty
          // See https://xhr.spec.whatwg.org/#request-error-steps and https://fetch.spec.whatwg.org/#concept-network-error
          completeRequest(callback, -1, null, null, '', 'timeout');
        };
        xhr.onerror = requestError;
        xhr.ontimeout = requestTimeout;
        xhr.onabort = requestAborted;
        forEach(eventHandlers, function (value, key) {
          xhr.addEventListener(key, value);
        });
        forEach(uploadEventHandlers, function (value, key) {
          xhr.upload.addEventListener(key, value);
        });
        if (withCredentials) {
          xhr.withCredentials = true;
        }
        if (responseType) {
          try {
            xhr.responseType = responseType;
          } catch (e) {
            // WebKit added support for the json responseType value on 09/03/2013
            // https://bugs.webkit.org/show_bug.cgi?id=73648. Versions of Safari prior to 7 are
            // known to throw when setting the value "json" as the response type. Other older
            // browsers implementing the responseType
            //
            // The json response type can be ignored if not supported, because JSON payloads are
            // parsed on the client-side regardless.
            if (responseType !== 'json') {
              throw e;
            }
          }
        }
        xhr.send(isUndefined(post) ? null : post);
      }

      // Since we are using xhr.abort() when a request times out, we have to set a flag that
      // indicates to requestAborted if the request timed out or was aborted.
      //
      // http.timeout = numerical timeout   timeout
      // http.timeout = $timeout            timeout
      // http.timeout = promise             abort
      // xhr.abort()                        abort (The xhr object is normally inaccessible, but
      //                                    can be exposed with the xhrFactory)
      if (timeout > 0) {
        var timeoutId = $browserDefer(function () {
          timeoutRequest('timeout');
        }, timeout);
      } else if (isPromiseLike(timeout)) {
        timeout.then(function () {
          timeoutRequest(isDefined(timeout.$$timeoutId) ? 'timeout' : 'abort');
        });
      }
      function timeoutRequest(reason) {
        abortedByTimeout = reason === 'timeout';
        if (jsonpDone) {
          jsonpDone();
        }
        if (xhr) {
          xhr.abort();
        }
      }
      function completeRequest(callback, status, response, headersString, statusText, xhrStatus) {
        // cancel timeout and subsequent timeout promise resolution
        if (isDefined(timeoutId)) {
          $browserDefer.cancel(timeoutId);
        }
        jsonpDone = xhr = null;
        callback(status, response, headersString, statusText, xhrStatus);
      }
    };
    function jsonpReq(url, callbackPath, done) {
      url = url.replace('JSON_CALLBACK', callbackPath);
      // we can't use jQuery/jqLite here because jQuery does crazy stuff with script elements, e.g.:
      // - fetches local scripts via XHR and evals them
      // - adds and immediately removes script elements from the document
      var script = rawDocument.createElement('script'),
        _callback3 = null;
      script.type = 'text/javascript';
      script.src = url;
      script.async = true;
      _callback3 = function callback(event) {
        script.removeEventListener('load', _callback3);
        script.removeEventListener('error', _callback3);
        rawDocument.body.removeChild(script);
        script = null;
        var status = -1;
        var text = 'unknown';
        if (event) {
          if (event.type === 'load' && !callbacks.wasCalled(callbackPath)) {
            event = {
              type: 'error'
            };
          }
          text = event.type;
          status = event.type === 'error' ? 404 : 200;
        }
        if (done) {
          done(status, text);
        }
      };
      script.addEventListener('load', _callback3);
      script.addEventListener('error', _callback3);
      rawDocument.body.appendChild(script);
      return _callback3;
    }
  }
  var $interpolateMinErr = angular.$interpolateMinErr = minErr('$interpolate');
  $interpolateMinErr.throwNoconcat = function (text) {
    throw $interpolateMinErr('noconcat', 'Error while interpolating: {0}\nStrict Contextual Escaping disallows ' + 'interpolations that concatenate multiple expressions when a trusted value is ' + 'required.  See http://docs.angularjs.org/api/ng.$sce', text);
  };
  $interpolateMinErr.interr = function (text, err) {
    return $interpolateMinErr('interr', 'Can\'t interpolate: {0}\n{1}', text, err.toString());
  };

  /**
   * @ngdoc provider
   * @name $interpolateProvider
   * @this
   *
   * @description
   *
   * Used for configuring the interpolation markup. Defaults to `{{` and `}}`.
   *
   * <div class="alert alert-danger">
   * This feature is sometimes used to mix different markup languages, e.g. to wrap an AngularJS
   * template within a Python Jinja template (or any other template language). Mixing templating
   * languages is **very dangerous**. The embedding template language will not safely escape AngularJS
   * expressions, so any user-controlled values in the template will cause Cross Site Scripting (XSS)
   * security bugs!
   * </div>
   *
   * @example
  <example name="custom-interpolation-markup" module="customInterpolationApp">
  <file name="index.html">
  <script>
    var customInterpolationApp = angular.module('customInterpolationApp', []);
  
    customInterpolationApp.config(function($interpolateProvider) {
      $interpolateProvider.startSymbol('//');
      $interpolateProvider.endSymbol('//');
    });
  
  
    customInterpolationApp.controller('DemoController', function() {
        this.label = "This binding is brought you by // interpolation symbols.";
    });
  </script>
  <div ng-controller="DemoController as demo">
      //demo.label//
  </div>
  </file>
  <file name="protractor.js" type="protractor">
    it('should interpolate binding with custom symbols', function() {
      expect(element(by.binding('demo.label')).getText()).toBe('This binding is brought you by // interpolation symbols.');
    });
  </file>
  </example>
   */
  function $InterpolateProvider() {
    var startSymbol = '{{';
    var endSymbol = '}}';

    /**
     * @ngdoc method
     * @name $interpolateProvider#startSymbol
     * @description
     * Symbol to denote start of expression in the interpolated string. Defaults to `{{`.
     *
     * @param {string=} value new value to set the starting symbol to.
     * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
     */
    this.startSymbol = function (value) {
      if (value) {
        startSymbol = value;
        return this;
      }
      return startSymbol;
    };

    /**
     * @ngdoc method
     * @name $interpolateProvider#endSymbol
     * @description
     * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
     *
     * @param {string=} value new value to set the ending symbol to.
     * @returns {string|self} Returns the symbol when used as getter and self if used as setter.
     */
    this.endSymbol = function (value) {
      if (value) {
        endSymbol = value;
        return this;
      }
      return endSymbol;
    };
    this.$get = ['$parse', '$exceptionHandler', '$sce', function ($parse, $exceptionHandler, $sce) {
      var startSymbolLength = startSymbol.length,
        endSymbolLength = endSymbol.length,
        escapedStartRegexp = new RegExp(startSymbol.replace(/./g, escape), 'g'),
        escapedEndRegexp = new RegExp(endSymbol.replace(/./g, escape), 'g');
      function escape(ch) {
        return '\\\\\\' + ch;
      }
      function unescapeText(text) {
        return text.replace(escapedStartRegexp, startSymbol).replace(escapedEndRegexp, endSymbol);
      }

      // TODO: this is the same as the constantWatchDelegate in parse.js
      function constantWatchDelegate(scope, listener, objectEquality, constantInterp) {
        var unwatch = scope.$watch(function constantInterpolateWatch(scope) {
          unwatch();
          return constantInterp(scope);
        }, listener, objectEquality);
        return unwatch;
      }

      /**
       * @ngdoc service
       * @name $interpolate
       * @kind function
       *
       * @requires $parse
       * @requires $sce
       *
       * @description
       *
       * Compiles a string with markup into an interpolation function. This service is used by the
       * HTML {@link ng.$compile $compile} service for data binding. See
       * {@link ng.$interpolateProvider $interpolateProvider} for configuring the
       * interpolation markup.
       *
       *
       * ```js
       *   var $interpolate = ...; // injected
       *   var exp = $interpolate('Hello {{name | uppercase}}!');
       *   expect(exp({name:'AngularJS'})).toEqual('Hello ANGULARJS!');
       * ```
       *
       * `$interpolate` takes an optional fourth argument, `allOrNothing`. If `allOrNothing` is
       * `true`, the interpolation function will return `undefined` unless all embedded expressions
       * evaluate to a value other than `undefined`.
       *
       * ```js
       *   var $interpolate = ...; // injected
       *   var context = {greeting: 'Hello', name: undefined };
       *
       *   // default "forgiving" mode
       *   var exp = $interpolate('{{greeting}} {{name}}!');
       *   expect(exp(context)).toEqual('Hello !');
       *
       *   // "allOrNothing" mode
       *   exp = $interpolate('{{greeting}} {{name}}!', false, null, true);
       *   expect(exp(context)).toBeUndefined();
       *   context.name = 'AngularJS';
       *   expect(exp(context)).toEqual('Hello AngularJS!');
       * ```
       *
       * `allOrNothing` is useful for interpolating URLs. `ngSrc` and `ngSrcset` use this behavior.
       *
       * #### Escaped Interpolation
       * $interpolate provides a mechanism for escaping interpolation markers. Start and end markers
       * can be escaped by preceding each of their characters with a REVERSE SOLIDUS U+005C (backslash).
       * It will be rendered as a regular start/end marker, and will not be interpreted as an expression
       * or binding.
       *
       * This enables web-servers to prevent script injection attacks and defacing attacks, to some
       * degree, while also enabling code examples to work without relying on the
       * {@link ng.directive:ngNonBindable ngNonBindable} directive.
       *
       * **For security purposes, it is strongly encouraged that web servers escape user-supplied data,
       * replacing angle brackets (&lt;, &gt;) with &amp;lt; and &amp;gt; respectively, and replacing all
       * interpolation start/end markers with their escaped counterparts.**
       *
       * Escaped interpolation markers are only replaced with the actual interpolation markers in rendered
       * output when the $interpolate service processes the text. So, for HTML elements interpolated
       * by {@link ng.$compile $compile}, or otherwise interpolated with the `mustHaveExpression` parameter
       * set to `true`, the interpolated text must contain an unescaped interpolation expression. As such,
       * this is typically useful only when user-data is used in rendering a template from the server, or
       * when otherwise untrusted data is used by a directive.
       *
       * <example name="interpolation">
       *  <file name="index.html">
       *    <div ng-init="username='A user'">
       *      <p ng-init="apptitle='Escaping demo'">{{apptitle}}: \{\{ username = "defaced value"; \}\}
       *        </p>
       *      <p><strong>{{username}}</strong> attempts to inject code which will deface the
       *        application, but fails to accomplish their task, because the server has correctly
       *        escaped the interpolation start/end markers with REVERSE SOLIDUS U+005C (backslash)
       *        characters.</p>
       *      <p>Instead, the result of the attempted script injection is visible, and can be removed
       *        from the database by an administrator.</p>
       *    </div>
       *  </file>
       * </example>
       *
       * @knownIssue
       * It is currently not possible for an interpolated expression to contain the interpolation end
       * symbol. For example, `{{ '}}' }}` will be incorrectly interpreted as `{{ ' }}` + `' }}`, i.e.
       * an interpolated expression consisting of a single-quote (`'`) and the `' }}` string.
       *
       * @knownIssue
       * All directives and components must use the standard `{{` `}}` interpolation symbols
       * in their templates. If you change the application interpolation symbols the {@link $compile}
       * service will attempt to denormalize the standard symbols to the custom symbols.
       * The denormalization process is not clever enough to know not to replace instances of the standard
       * symbols where they would not normally be treated as interpolation symbols. For example in the following
       * code snippet the closing braces of the literal object will get incorrectly denormalized:
       *
       * ```
       * <div data-context='{"context":{"id":3,"type":"page"}}">
       * ```
       *
       * The workaround is to ensure that such instances are separated by whitespace:
       * ```
       * <div data-context='{"context":{"id":3,"type":"page"} }">
       * ```
       *
       * See https://github.com/angular/angular.js/pull/14610#issuecomment-219401099 for more information.
       *
       * @param {string} text The text with markup to interpolate.
       * @param {boolean=} mustHaveExpression if set to true then the interpolation string must have
       *    embedded expression in order to return an interpolation function. Strings with no
       *    embedded expression will return null for the interpolation function.
       * @param {string=} trustedContext when provided, the returned function passes the interpolated
       *    result through {@link ng.$sce#getTrusted $sce.getTrusted(interpolatedResult,
       *    trustedContext)} before returning it.  Refer to the {@link ng.$sce $sce} service that
       *    provides Strict Contextual Escaping for details.
       * @param {boolean=} allOrNothing if `true`, then the returned function returns undefined
       *    unless all embedded expressions evaluate to a value other than `undefined`.
       * @returns {function(context)} an interpolation function which is used to compute the
       *    interpolated string. The function has these parameters:
       *
       * - `context`: evaluation context for all expressions embedded in the interpolated text
       */
      function $interpolate(text, mustHaveExpression, trustedContext, allOrNothing) {
        var contextAllowsConcatenation = trustedContext === $sce.URL || trustedContext === $sce.MEDIA_URL;

        // Provide a quick exit and simplified result function for text with no interpolation
        if (!text.length || text.indexOf(startSymbol) === -1) {
          if (mustHaveExpression) return;
          var unescapedText = unescapeText(text);
          if (contextAllowsConcatenation) {
            unescapedText = $sce.getTrusted(trustedContext, unescapedText);
          }
          var constantInterp = valueFn(unescapedText);
          constantInterp.exp = text;
          constantInterp.expressions = [];
          constantInterp.$$watchDelegate = constantWatchDelegate;
          return constantInterp;
        }
        allOrNothing = !!allOrNothing;
        var startIndex,
          endIndex,
          index = 0,
          expressions = [],
          parseFns,
          textLength = text.length,
          exp,
          concat = [],
          expressionPositions = [],
          singleExpression;
        while (index < textLength) {
          if ((startIndex = text.indexOf(startSymbol, index)) !== -1 && (endIndex = text.indexOf(endSymbol, startIndex + startSymbolLength)) !== -1) {
            if (index !== startIndex) {
              concat.push(unescapeText(text.substring(index, startIndex)));
            }
            exp = text.substring(startIndex + startSymbolLength, endIndex);
            expressions.push(exp);
            index = endIndex + endSymbolLength;
            expressionPositions.push(concat.length);
            concat.push(''); // Placeholder that will get replaced with the evaluated expression.
          } else {
            // we did not find an interpolation, so we have to add the remainder to the separators array
            if (index !== textLength) {
              concat.push(unescapeText(text.substring(index)));
            }
            break;
          }
        }
        singleExpression = concat.length === 1 && expressionPositions.length === 1;
        // Intercept expression if we need to stringify concatenated inputs, which may be SCE trusted
        // objects rather than simple strings
        // (we don't modify the expression if the input consists of only a single trusted input)
        var interceptor = contextAllowsConcatenation && singleExpression ? undefined : parseStringifyInterceptor;
        parseFns = expressions.map(function (exp) {
          return $parse(exp, interceptor);
        });

        // Concatenating expressions makes it hard to reason about whether some combination of
        // concatenated values are unsafe to use and could easily lead to XSS.  By requiring that a
        // single expression be used for some $sce-managed secure contexts (RESOURCE_URLs mostly),
        // we ensure that the value that's used is assigned or constructed by some JS code somewhere
        // that is more testable or make it obvious that you bound the value to some user controlled
        // value.  This helps reduce the load when auditing for XSS issues.

        // Note that URL and MEDIA_URL $sce contexts do not need this, since `$sce` can sanitize the values
        // passed to it. In that case, `$sce.getTrusted` will be called on either the single expression
        // or on the overall concatenated string (losing trusted types used in the mix, by design).
        // Both these methods will sanitize plain strings. Also, HTML could be included, but since it's
        // only used in srcdoc attributes, this would not be very useful.

        if (!mustHaveExpression || expressions.length) {
          var compute = function compute(values) {
            for (var i = 0, ii = expressions.length; i < ii; i++) {
              if (allOrNothing && isUndefined(values[i])) return;
              concat[expressionPositions[i]] = values[i];
            }
            if (contextAllowsConcatenation) {
              // If `singleExpression` then `concat[0]` might be a "trusted" value or `null`, rather than a string
              return $sce.getTrusted(trustedContext, singleExpression ? concat[0] : concat.join(''));
            } else if (trustedContext && concat.length > 1) {
              // This context does not allow more than one part, e.g. expr + string or exp + exp.
              $interpolateMinErr.throwNoconcat(text);
            }
            // In an unprivileged context or only one part: just concatenate and return.
            return concat.join('');
          };
          return extend(function interpolationFn(context) {
            var i = 0;
            var ii = expressions.length;
            var values = new Array(ii);
            try {
              for (; i < ii; i++) {
                values[i] = parseFns[i](context);
              }
              return compute(values);
            } catch (err) {
              $exceptionHandler($interpolateMinErr.interr(text, err));
            }
          }, {
            // all of these properties are undocumented for now
            exp: text,
            //just for compatibility with regular watchers created via $watch
            expressions: expressions,
            $$watchDelegate: function $$watchDelegate(scope, listener) {
              var lastValue;
              return scope.$watchGroup(parseFns, /** @this */function interpolateFnWatcher(values, oldValues) {
                var currValue = compute(values);
                listener.call(this, currValue, values !== oldValues ? lastValue : currValue, scope);
                lastValue = currValue;
              });
            }
          });
        }
        function parseStringifyInterceptor(value) {
          try {
            // In concatenable contexts, getTrusted comes at the end, to avoid sanitizing individual
            // parts of a full URL. We don't care about losing the trustedness here.
            // In non-concatenable contexts, where there is only one expression, this interceptor is
            // not applied to the expression.
            value = trustedContext && !contextAllowsConcatenation ? $sce.getTrusted(trustedContext, value) : $sce.valueOf(value);
            return allOrNothing && !isDefined(value) ? value : stringify(value);
          } catch (err) {
            $exceptionHandler($interpolateMinErr.interr(text, err));
          }
        }
      }

      /**
       * @ngdoc method
       * @name $interpolate#startSymbol
       * @description
       * Symbol to denote the start of expression in the interpolated string. Defaults to `{{`.
       *
       * Use {@link ng.$interpolateProvider#startSymbol `$interpolateProvider.startSymbol`} to change
       * the symbol.
       *
       * @returns {string} start symbol.
       */
      $interpolate.startSymbol = function () {
        return startSymbol;
      };

      /**
       * @ngdoc method
       * @name $interpolate#endSymbol
       * @description
       * Symbol to denote the end of expression in the interpolated string. Defaults to `}}`.
       *
       * Use {@link ng.$interpolateProvider#endSymbol `$interpolateProvider.endSymbol`} to change
       * the symbol.
       *
       * @returns {string} end symbol.
       */
      $interpolate.endSymbol = function () {
        return endSymbol;
      };
      return $interpolate;
    }];
  }
  var $intervalMinErr = minErr('$interval');

  /** @this */
  function $IntervalProvider() {
    this.$get = ['$$intervalFactory', '$window', function ($$intervalFactory, $window) {
      var intervals = {};
      var setIntervalFn = function setIntervalFn(tick, delay, deferred) {
        var id = $window.setInterval(tick, delay);
        intervals[id] = deferred;
        return id;
      };
      var clearIntervalFn = function clearIntervalFn(id) {
        $window.clearInterval(id);
        delete intervals[id];
      };

      /**
       * @ngdoc service
       * @name $interval
       *
       * @description
       * AngularJS's wrapper for `window.setInterval`. The `fn` function is executed every `delay`
       * milliseconds.
       *
       * The return value of registering an interval function is a promise. This promise will be
       * notified upon each tick of the interval, and will be resolved after `count` iterations, or
       * run indefinitely if `count` is not defined. The value of the notification will be the
       * number of iterations that have run.
       * To cancel an interval, call `$interval.cancel(promise)`.
       *
       * In tests you can use {@link ngMock.$interval#flush `$interval.flush(millis)`} to
       * move forward by `millis` milliseconds and trigger any functions scheduled to run in that
       * time.
       *
       * <div class="alert alert-warning">
       * **Note**: Intervals created by this service must be explicitly destroyed when you are finished
       * with them.  In particular they are not automatically destroyed when a controller's scope or a
       * directive's element are destroyed.
       * You should take this into consideration and make sure to always cancel the interval at the
       * appropriate moment.  See the example below for more details on how and when to do this.
       * </div>
       *
       * @param {function()} fn A function that should be called repeatedly. If no additional arguments
       *   are passed (see below), the function is called with the current iteration count.
       * @param {number} delay Number of milliseconds between each function call.
       * @param {number=} [count=0] Number of times to repeat. If not set, or 0, will repeat
       *   indefinitely.
       * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
       *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
       * @param {...*=} Pass additional parameters to the executed function.
       * @returns {promise} A promise which will be notified on each iteration. It will resolve once all iterations of the interval complete.
       *
       * @example
       * <example module="intervalExample" name="interval-service">
       * <file name="index.html">
       *   <script>
       *     angular.module('intervalExample', [])
       *       .controller('ExampleController', ['$scope', '$interval',
       *         function($scope, $interval) {
       *           $scope.format = 'M/d/yy h:mm:ss a';
       *           $scope.blood_1 = 100;
       *           $scope.blood_2 = 120;
       *
       *           var stop;
       *           $scope.fight = function() {
       *             // Don't start a new fight if we are already fighting
       *             if ( angular.isDefined(stop) ) return;
       *
       *             stop = $interval(function() {
       *               if ($scope.blood_1 > 0 && $scope.blood_2 > 0) {
       *                 $scope.blood_1 = $scope.blood_1 - 3;
       *                 $scope.blood_2 = $scope.blood_2 - 4;
       *               } else {
       *                 $scope.stopFight();
       *               }
       *             }, 100);
       *           };
       *
       *           $scope.stopFight = function() {
       *             if (angular.isDefined(stop)) {
       *               $interval.cancel(stop);
       *               stop = undefined;
       *             }
       *           };
       *
       *           $scope.resetFight = function() {
       *             $scope.blood_1 = 100;
       *             $scope.blood_2 = 120;
       *           };
       *
       *           $scope.$on('$destroy', function() {
       *             // Make sure that the interval is destroyed too
       *             $scope.stopFight();
       *           });
       *         }])
       *       // Register the 'myCurrentTime' directive factory method.
       *       // We inject $interval and dateFilter service since the factory method is DI.
       *       .directive('myCurrentTime', ['$interval', 'dateFilter',
       *         function($interval, dateFilter) {
       *           // return the directive link function. (compile function not needed)
       *           return function(scope, element, attrs) {
       *             var format,  // date format
       *                 stopTime; // so that we can cancel the time updates
       *
       *             // used to update the UI
       *             function updateTime() {
       *               element.text(dateFilter(new Date(), format));
       *             }
       *
       *             // watch the expression, and update the UI on change.
       *             scope.$watch(attrs.myCurrentTime, function(value) {
       *               format = value;
       *               updateTime();
       *             });
       *
       *             stopTime = $interval(updateTime, 1000);
       *
       *             // listen on DOM destroy (removal) event, and cancel the next UI update
       *             // to prevent updating time after the DOM element was removed.
       *             element.on('$destroy', function() {
       *               $interval.cancel(stopTime);
       *             });
       *           }
       *         }]);
       *   </script>
       *
       *   <div>
       *     <div ng-controller="ExampleController">
       *       <label>Date format: <input ng-model="format"></label> <hr/>
       *       Current time is: <span my-current-time="format"></span>
       *       <hr/>
       *       Blood 1 : <font color='red'>{{blood_1}}</font>
       *       Blood 2 : <font color='red'>{{blood_2}}</font>
       *       <button type="button" data-ng-click="fight()">Fight</button>
       *       <button type="button" data-ng-click="stopFight()">StopFight</button>
       *       <button type="button" data-ng-click="resetFight()">resetFight</button>
       *     </div>
       *   </div>
       *
       * </file>
       * </example>
       */
      var interval = $$intervalFactory(setIntervalFn, clearIntervalFn);

      /**
       * @ngdoc method
       * @name $interval#cancel
       *
       * @description
       * Cancels a task associated with the `promise`.
       *
       * @param {Promise=} promise returned by the `$interval` function.
       * @returns {boolean} Returns `true` if the task was successfully canceled.
       */
      interval.cancel = function (promise) {
        if (!promise) return false;
        if (!promise.hasOwnProperty('$$intervalId')) {
          throw $intervalMinErr('badprom', '`$interval.cancel()` called with a promise that was not generated by `$interval()`.');
        }
        if (!intervals.hasOwnProperty(promise.$$intervalId)) return false;
        var id = promise.$$intervalId;
        var deferred = intervals[id];

        // Interval cancels should not report an unhandled promise.
        markQExceptionHandled(deferred.promise);
        deferred.reject('canceled');
        clearIntervalFn(id);
        return true;
      };
      return interval;
    }];
  }

  /** @this */
  function $$IntervalFactoryProvider() {
    this.$get = ['$browser', '$q', '$$q', '$rootScope', function ($browser, $q, $$q, $rootScope) {
      return function intervalFactory(setIntervalFn, clearIntervalFn) {
        return function intervalFn(fn, delay, count, invokeApply) {
          var hasParams = arguments.length > 4,
            args = hasParams ? sliceArgs(arguments, 4) : [],
            iteration = 0,
            skipApply = isDefined(invokeApply) && !invokeApply,
            deferred = (skipApply ? $$q : $q).defer(),
            promise = deferred.promise;
          count = isDefined(count) ? count : 0;
          function callback() {
            if (!hasParams) {
              fn(iteration);
            } else {
              fn.apply(null, args);
            }
          }
          function tick() {
            if (skipApply) {
              $browser.defer(callback);
            } else {
              $rootScope.$evalAsync(callback);
            }
            deferred.notify(iteration++);
            if (count > 0 && iteration >= count) {
              deferred.resolve(iteration);
              clearIntervalFn(promise.$$intervalId);
            }
            if (!skipApply) $rootScope.$apply();
          }
          promise.$$intervalId = setIntervalFn(tick, delay, deferred, skipApply);
          return promise;
        };
      };
    }];
  }

  /**
   * @ngdoc service
   * @name $jsonpCallbacks
   * @requires $window
   * @description
   * This service handles the lifecycle of callbacks to handle JSONP requests.
   * Override this service if you wish to customise where the callbacks are stored and
   * how they vary compared to the requested url.
   */
  var $jsonpCallbacksProvider = /** @this */function $jsonpCallbacksProvider() {
    this.$get = function () {
      var callbacks = angular.callbacks;
      var callbackMap = {};
      function _createCallback(callbackId) {
        var _callback4 = function callback(data) {
          _callback4.data = data;
          _callback4.called = true;
        };
        _callback4.id = callbackId;
        return _callback4;
      }
      return {
        /**
         * @ngdoc method
         * @name $jsonpCallbacks#createCallback
         * @param {string} url the url of the JSONP request
         * @returns {string} the callback path to send to the server as part of the JSONP request
         * @description
         * {@link $httpBackend} calls this method to create a callback and get hold of the path to the callback
         * to pass to the server, which will be used to call the callback with its payload in the JSONP response.
         */
        createCallback: function createCallback(url) {
          var callbackId = '_' + (callbacks.$$counter++).toString(36);
          var callbackPath = 'angular.callbacks.' + callbackId;
          var callback = _createCallback(callbackId);
          callbackMap[callbackPath] = callbacks[callbackId] = callback;
          return callbackPath;
        },
        /**
         * @ngdoc method
         * @name $jsonpCallbacks#wasCalled
         * @param {string} callbackPath the path to the callback that was sent in the JSONP request
         * @returns {boolean} whether the callback has been called, as a result of the JSONP response
         * @description
         * {@link $httpBackend} calls this method to find out whether the JSONP response actually called the
         * callback that was passed in the request.
         */
        wasCalled: function wasCalled(callbackPath) {
          return callbackMap[callbackPath].called;
        },
        /**
         * @ngdoc method
         * @name $jsonpCallbacks#getResponse
         * @param {string} callbackPath the path to the callback that was sent in the JSONP request
         * @returns {*} the data received from the response via the registered callback
         * @description
         * {@link $httpBackend} calls this method to get hold of the data that was provided to the callback
         * in the JSONP response.
         */
        getResponse: function getResponse(callbackPath) {
          return callbackMap[callbackPath].data;
        },
        /**
         * @ngdoc method
         * @name $jsonpCallbacks#removeCallback
         * @param {string} callbackPath the path to the callback that was sent in the JSONP request
         * @description
         * {@link $httpBackend} calls this method to remove the callback after the JSONP request has
         * completed or timed-out.
         */
        removeCallback: function removeCallback(callbackPath) {
          var callback = callbackMap[callbackPath];
          delete callbacks[callback.id];
          delete callbackMap[callbackPath];
        }
      };
    };
  };

  /**
   * @ngdoc service
   * @name $locale
   *
   * @description
   * $locale service provides localization rules for various AngularJS components. As of right now the
   * only public api is:
   *
   * * `id` – `{string}` – locale id formatted as `languageId-countryId` (e.g. `en-us`)
   */

  /* global stripHash: true */

  var PATH_MATCH = /^([^?#]*)(\?([^#]*))?(#(.*))?$/,
    DEFAULT_PORTS = {
      'http': 80,
      'https': 443,
      'ftp': 21
    };
  var $locationMinErr = minErr('$location');

  /**
   * Encode path using encodeUriSegment, ignoring forward slashes
   *
   * @param {string} path Path to encode
   * @returns {string}
   */
  function encodePath(path) {
    var segments = path.split('/'),
      i = segments.length;
    while (i--) {
      // decode forward slashes to prevent them from being double encoded
      segments[i] = encodeUriSegment(segments[i].replace(/%2F/g, '/'));
    }
    return segments.join('/');
  }
  function decodePath(path, html5Mode) {
    var segments = path.split('/'),
      i = segments.length;
    while (i--) {
      segments[i] = decodeURIComponent(segments[i]);
      if (html5Mode) {
        // encode forward slashes to prevent them from being mistaken for path separators
        segments[i] = segments[i].replace(/\//g, '%2F');
      }
    }
    return segments.join('/');
  }
  function normalizePath(pathValue, searchValue, hashValue) {
    var search = toKeyValue(searchValue),
      hash = hashValue ? '#' + encodeUriSegment(hashValue) : '',
      path = encodePath(pathValue);
    return path + (search ? '?' + search : '') + hash;
  }
  function parseAbsoluteUrl(absoluteUrl, locationObj) {
    var parsedUrl = urlResolve(absoluteUrl);
    locationObj.$$protocol = parsedUrl.protocol;
    locationObj.$$host = parsedUrl.hostname;
    locationObj.$$port = toInt(parsedUrl.port) || DEFAULT_PORTS[parsedUrl.protocol] || null;
  }
  var DOUBLE_SLASH_REGEX = /^\s*[\\/]{2,}/;
  function parseAppUrl(url, locationObj, html5Mode) {
    if (DOUBLE_SLASH_REGEX.test(url)) {
      throw $locationMinErr('badpath', 'Invalid url "{0}".', url);
    }
    var prefixed = url.charAt(0) !== '/';
    if (prefixed) {
      url = '/' + url;
    }
    var match = urlResolve(url);
    var path = prefixed && match.pathname.charAt(0) === '/' ? match.pathname.substring(1) : match.pathname;
    locationObj.$$path = decodePath(path, html5Mode);
    locationObj.$$search = parseKeyValue(match.search);
    locationObj.$$hash = decodeURIComponent(match.hash);

    // make sure path starts with '/';
    if (locationObj.$$path && locationObj.$$path.charAt(0) !== '/') {
      locationObj.$$path = '/' + locationObj.$$path;
    }
  }
  function startsWith(str, search) {
    return str.slice(0, search.length) === search;
  }

  /**
   *
   * @param {string} base
   * @param {string} url
   * @returns {string} returns text from `url` after `base` or `undefined` if it does not begin with
   *                   the expected string.
   */
  function stripBaseUrl(base, url) {
    if (startsWith(url, base)) {
      return url.substr(base.length);
    }
  }
  function stripHash(url) {
    var index = url.indexOf('#');
    return index === -1 ? url : url.substr(0, index);
  }
  function stripFile(url) {
    return url.substr(0, stripHash(url).lastIndexOf('/') + 1);
  }

  /* return the server only (scheme://host:port) */
  function serverBase(url) {
    return url.substring(0, url.indexOf('/', url.indexOf('//') + 2));
  }

  /**
   * LocationHtml5Url represents a URL
   * This object is exposed as $location service when HTML5 mode is enabled and supported
   *
   * @constructor
   * @param {string} appBase application base URL
   * @param {string} appBaseNoFile application base URL stripped of any filename
   * @param {string} basePrefix URL path prefix
   */
  function LocationHtml5Url(appBase, appBaseNoFile, basePrefix) {
    this.$$html5 = true;
    basePrefix = basePrefix || '';
    parseAbsoluteUrl(appBase, this);

    /**
     * Parse given HTML5 (regular) URL string into properties
     * @param {string} url HTML5 URL
     * @private
     */
    this.$$parse = function (url) {
      var pathUrl = stripBaseUrl(appBaseNoFile, url);
      if (!isString(pathUrl)) {
        throw $locationMinErr('ipthprfx', 'Invalid url "{0}", missing path prefix "{1}".', url, appBaseNoFile);
      }
      parseAppUrl(pathUrl, this, true);
      if (!this.$$path) {
        this.$$path = '/';
      }
      this.$$compose();
    };
    this.$$normalizeUrl = function (url) {
      return appBaseNoFile + url.substr(1); // first char is always '/'
    };
    this.$$parseLinkUrl = function (url, relHref) {
      if (relHref && relHref[0] === '#') {
        // special case for links to hash fragments:
        // keep the old url and only replace the hash fragment
        this.hash(relHref.slice(1));
        return true;
      }
      var appUrl, prevAppUrl;
      var rewrittenUrl;
      if (isDefined(appUrl = stripBaseUrl(appBase, url))) {
        prevAppUrl = appUrl;
        if (basePrefix && isDefined(appUrl = stripBaseUrl(basePrefix, appUrl))) {
          rewrittenUrl = appBaseNoFile + (stripBaseUrl('/', appUrl) || appUrl);
        } else {
          rewrittenUrl = appBase + prevAppUrl;
        }
      } else if (isDefined(appUrl = stripBaseUrl(appBaseNoFile, url))) {
        rewrittenUrl = appBaseNoFile + appUrl;
      } else if (appBaseNoFile === url + '/') {
        rewrittenUrl = appBaseNoFile;
      }
      if (rewrittenUrl) {
        this.$$parse(rewrittenUrl);
      }
      return !!rewrittenUrl;
    };
  }

  /**
   * LocationHashbangUrl represents URL
   * This object is exposed as $location service when developer doesn't opt into html5 mode.
   * It also serves as the base class for html5 mode fallback on legacy browsers.
   *
   * @constructor
   * @param {string} appBase application base URL
   * @param {string} appBaseNoFile application base URL stripped of any filename
   * @param {string} hashPrefix hashbang prefix
   */
  function LocationHashbangUrl(appBase, appBaseNoFile, hashPrefix) {
    parseAbsoluteUrl(appBase, this);

    /**
     * Parse given hashbang URL into properties
     * @param {string} url Hashbang URL
     * @private
     */
    this.$$parse = function (url) {
      var withoutBaseUrl = stripBaseUrl(appBase, url) || stripBaseUrl(appBaseNoFile, url);
      var withoutHashUrl;
      if (!isUndefined(withoutBaseUrl) && withoutBaseUrl.charAt(0) === '#') {
        // The rest of the URL starts with a hash so we have
        // got either a hashbang path or a plain hash fragment
        withoutHashUrl = stripBaseUrl(hashPrefix, withoutBaseUrl);
        if (isUndefined(withoutHashUrl)) {
          // There was no hashbang prefix so we just have a hash fragment
          withoutHashUrl = withoutBaseUrl;
        }
      } else {
        // There was no hashbang path nor hash fragment:
        // If we are in HTML5 mode we use what is left as the path;
        // Otherwise we ignore what is left
        if (this.$$html5) {
          withoutHashUrl = withoutBaseUrl;
        } else {
          withoutHashUrl = '';
          if (isUndefined(withoutBaseUrl)) {
            appBase = url;
            /** @type {?} */
            this.replace();
          }
        }
      }
      parseAppUrl(withoutHashUrl, this, false);
      this.$$path = removeWindowsDriveName(this.$$path, withoutHashUrl, appBase);
      this.$$compose();

      /*
       * In Windows, on an anchor node on documents loaded from
       * the filesystem, the browser will return a pathname
       * prefixed with the drive name ('/C:/path') when a
       * pathname without a drive is set:
       *  * a.setAttribute('href', '/foo')
       *   * a.pathname === '/C:/foo' //true
       *
       * Inside of AngularJS, we're always using pathnames that
       * do not include drive names for routing.
       */
      function removeWindowsDriveName(path, url, base) {
        /*
        Matches paths for file protocol on windows,
        such as /C:/foo/bar, and captures only /foo/bar.
        */
        var windowsFilePathExp = /^\/[A-Z]:(\/.*)/;
        var firstPathSegmentMatch;

        //Get the relative path from the input URL.
        if (startsWith(url, base)) {
          url = url.replace(base, '');
        }

        // The input URL intentionally contains a first path segment that ends with a colon.
        if (windowsFilePathExp.exec(url)) {
          return path;
        }
        firstPathSegmentMatch = windowsFilePathExp.exec(path);
        return firstPathSegmentMatch ? firstPathSegmentMatch[1] : path;
      }
    };
    this.$$normalizeUrl = function (url) {
      return appBase + (url ? hashPrefix + url : '');
    };
    this.$$parseLinkUrl = function (url, relHref) {
      if (stripHash(appBase) === stripHash(url)) {
        this.$$parse(url);
        return true;
      }
      return false;
    };
  }

  /**
   * LocationHashbangUrl represents URL
   * This object is exposed as $location service when html5 history api is enabled but the browser
   * does not support it.
   *
   * @constructor
   * @param {string} appBase application base URL
   * @param {string} appBaseNoFile application base URL stripped of any filename
   * @param {string} hashPrefix hashbang prefix
   */
  function LocationHashbangInHtml5Url(appBase, appBaseNoFile, hashPrefix) {
    this.$$html5 = true;
    LocationHashbangUrl.apply(this, arguments);
    this.$$parseLinkUrl = function (url, relHref) {
      if (relHref && relHref[0] === '#') {
        // special case for links to hash fragments:
        // keep the old url and only replace the hash fragment
        this.hash(relHref.slice(1));
        return true;
      }
      var rewrittenUrl;
      var appUrl;
      if (appBase === stripHash(url)) {
        rewrittenUrl = url;
      } else if (appUrl = stripBaseUrl(appBaseNoFile, url)) {
        rewrittenUrl = appBase + hashPrefix + appUrl;
      } else if (appBaseNoFile === url + '/') {
        rewrittenUrl = appBaseNoFile;
      }
      if (rewrittenUrl) {
        this.$$parse(rewrittenUrl);
      }
      return !!rewrittenUrl;
    };
    this.$$normalizeUrl = function (url) {
      // include hashPrefix in $$absUrl when $$url is empty so IE9 does not reload page because of removal of '#'
      return appBase + hashPrefix + url;
    };
  }
  var locationPrototype = {
    /**
     * Ensure absolute URL is initialized.
     * @private
     */
    $$absUrl: '',
    /**
     * Are we in html5 mode?
     * @private
     */
    $$html5: false,
    /**
     * Has any change been replacing?
     * @private
     */
    $$replace: false,
    /**
     * Compose url and update `url` and `absUrl` property
     * @private
     */
    $$compose: function $$compose() {
      this.$$url = normalizePath(this.$$path, this.$$search, this.$$hash);
      this.$$absUrl = this.$$normalizeUrl(this.$$url);
      this.$$urlUpdatedByLocation = true;
    },
    /**
     * @ngdoc method
     * @name $location#absUrl
     *
     * @description
     * This method is getter only.
     *
     * Return full URL representation with all segments encoded according to rules specified in
     * [RFC 3986](http://www.ietf.org/rfc/rfc3986.txt).
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var absUrl = $location.absUrl();
     * // => "http://example.com/#/some/path?foo=bar&baz=xoxo"
     * ```
     *
     * @return {string} full URL
     */
    absUrl: locationGetter('$$absUrl'),
    /**
     * @ngdoc method
     * @name $location#url
     *
     * @description
     * This method is getter / setter.
     *
     * Return URL (e.g. `/path?a=b#hash`) when called without any parameter.
     *
     * Change path, search and hash, when called with parameter and return `$location`.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var url = $location.url();
     * // => "/some/path?foo=bar&baz=xoxo"
     * ```
     *
     * @param {string=} url New URL without base prefix (e.g. `/path?a=b#hash`)
     * @return {string} url
     */
    url: function url(_url) {
      if (isUndefined(_url)) {
        return this.$$url;
      }
      var match = PATH_MATCH.exec(_url);
      if (match[1] || _url === '') this.path(decodeURIComponent(match[1]));
      if (match[2] || match[1] || _url === '') this.search(match[3] || '');
      this.hash(match[5] || '');
      return this;
    },
    /**
     * @ngdoc method
     * @name $location#protocol
     *
     * @description
     * This method is getter only.
     *
     * Return protocol of current URL.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var protocol = $location.protocol();
     * // => "http"
     * ```
     *
     * @return {string} protocol of current URL
     */
    protocol: locationGetter('$$protocol'),
    /**
     * @ngdoc method
     * @name $location#host
     *
     * @description
     * This method is getter only.
     *
     * Return host of current URL.
     *
     * Note: compared to the non-AngularJS version `location.host` which returns `hostname:port`, this returns the `hostname` portion only.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var host = $location.host();
     * // => "example.com"
     *
     * // given URL http://user:password@example.com:8080/#/some/path?foo=bar&baz=xoxo
     * host = $location.host();
     * // => "example.com"
     * host = location.host;
     * // => "example.com:8080"
     * ```
     *
     * @return {string} host of current URL.
     */
    host: locationGetter('$$host'),
    /**
     * @ngdoc method
     * @name $location#port
     *
     * @description
     * This method is getter only.
     *
     * Return port of current URL.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var port = $location.port();
     * // => 80
     * ```
     *
     * @return {Number} port
     */
    port: locationGetter('$$port'),
    /**
     * @ngdoc method
     * @name $location#path
     *
     * @description
     * This method is getter / setter.
     *
     * Return path of current URL when called without any parameter.
     *
     * Change path when called with parameter and return `$location`.
     *
     * Note: Path should always begin with forward slash (/), this method will add the forward slash
     * if it is missing.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var path = $location.path();
     * // => "/some/path"
     * ```
     *
     * @param {(string|number)=} path New path
     * @return {(string|object)} path if called with no parameters, or `$location` if called with a parameter
     */
    path: locationGetterSetter('$$path', function (path) {
      path = path !== null ? path.toString() : '';
      return path.charAt(0) === '/' ? path : '/' + path;
    }),
    /**
     * @ngdoc method
     * @name $location#search
     *
     * @description
     * This method is getter / setter.
     *
     * Return search part (as object) of current URL when called without any parameter.
     *
     * Change search part when called with parameter and return `$location`.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo
     * var searchObject = $location.search();
     * // => {foo: 'bar', baz: 'xoxo'}
     *
     * // set foo to 'yipee'
     * $location.search('foo', 'yipee');
     * // $location.search() => {foo: 'yipee', baz: 'xoxo'}
     * ```
     *
     * @param {string|Object.<string>|Object.<Array.<string>>} search New search params - string or
     * hash object.
     *
     * When called with a single argument the method acts as a setter, setting the `search` component
     * of `$location` to the specified value.
     *
     * If the argument is a hash object containing an array of values, these values will be encoded
     * as duplicate search parameters in the URL.
     *
     * @param {(string|Number|Array<string>|boolean)=} paramValue If `search` is a string or number, then `paramValue`
     * will override only a single search property.
     *
     * If `paramValue` is an array, it will override the property of the `search` component of
     * `$location` specified via the first argument.
     *
     * If `paramValue` is `null`, the property specified via the first argument will be deleted.
     *
     * If `paramValue` is `true`, the property specified via the first argument will be added with no
     * value nor trailing equal sign.
     *
     * @return {Object} If called with no arguments returns the parsed `search` object. If called with
     * one or more arguments returns `$location` object itself.
     */
    search: function search(_search, paramValue) {
      switch (arguments.length) {
        case 0:
          return this.$$search;
        case 1:
          if (isString(_search) || isNumber(_search)) {
            _search = _search.toString();
            this.$$search = parseKeyValue(_search);
          } else if (isObject(_search)) {
            _search = copy(_search, {});
            // remove object undefined or null properties
            forEach(_search, function (value, key) {
              if (value == null) delete _search[key];
            });
            this.$$search = _search;
          } else {
            throw $locationMinErr('isrcharg', 'The first argument of the `$location#search()` call must be a string or an object.');
          }
          break;
        default:
          if (isUndefined(paramValue) || paramValue === null) {
            delete this.$$search[_search];
          } else {
            this.$$search[_search] = paramValue;
          }
      }
      this.$$compose();
      return this;
    },
    /**
     * @ngdoc method
     * @name $location#hash
     *
     * @description
     * This method is getter / setter.
     *
     * Returns the hash fragment when called without any parameters.
     *
     * Changes the hash fragment when called with a parameter and returns `$location`.
     *
     *
     * ```js
     * // given URL http://example.com/#/some/path?foo=bar&baz=xoxo#hashValue
     * var hash = $location.hash();
     * // => "hashValue"
     * ```
     *
     * @param {(string|number)=} hash New hash fragment
     * @return {string} hash
     */
    hash: locationGetterSetter('$$hash', function (hash) {
      return hash !== null ? hash.toString() : '';
    }),
    /**
     * @ngdoc method
     * @name $location#replace
     *
     * @description
     * If called, all changes to $location during the current `$digest` will replace the current history
     * record, instead of adding a new one.
     */
    replace: function replace() {
      this.$$replace = true;
      return this;
    }
  };
  forEach([LocationHashbangInHtml5Url, LocationHashbangUrl, LocationHtml5Url], function (Location) {
    Location.prototype = Object.create(locationPrototype);

    /**
     * @ngdoc method
     * @name $location#state
     *
     * @description
     * This method is getter / setter.
     *
     * Return the history state object when called without any parameter.
     *
     * Change the history state object when called with one parameter and return `$location`.
     * The state object is later passed to `pushState` or `replaceState`.
     *
     * NOTE: This method is supported only in HTML5 mode and only in browsers supporting
     * the HTML5 History API (i.e. methods `pushState` and `replaceState`). If you need to support
     * older browsers (like IE9 or Android < 4.0), don't use this method.
     *
     * @param {object=} state State object for pushState or replaceState
     * @return {object} state
     */
    Location.prototype.state = function (state) {
      if (!arguments.length) {
        return this.$$state;
      }
      if (Location !== LocationHtml5Url || !this.$$html5) {
        throw $locationMinErr('nostate', 'History API state support is available only ' + 'in HTML5 mode and only in browsers supporting HTML5 History API');
      }
      // The user might modify `stateObject` after invoking `$location.state(stateObject)`
      // but we're changing the $$state reference to $browser.state() during the $digest
      // so the modification window is narrow.
      this.$$state = isUndefined(state) ? null : state;
      this.$$urlUpdatedByLocation = true;
      return this;
    };
  });
  function locationGetter(property) {
    return /** @this */function () {
      return this[property];
    };
  }
  function locationGetterSetter(property, preprocess) {
    return /** @this */function (value) {
      if (isUndefined(value)) {
        return this[property];
      }
      this[property] = preprocess(value);
      this.$$compose();
      return this;
    };
  }

  /**
   * @ngdoc service
   * @name $location
   *
   * @requires $rootElement
   *
   * @description
   * The $location service parses the URL in the browser address bar (based on the
   * [window.location](https://developer.mozilla.org/en/window.location)) and makes the URL
   * available to your application. Changes to the URL in the address bar are reflected into
   * $location service and changes to $location are reflected into the browser address bar.
   *
   * **The $location service:**
   *
   * - Exposes the current URL in the browser address bar, so you can
   *   - Watch and observe the URL.
   *   - Change the URL.
   * - Synchronizes the URL with the browser when the user
   *   - Changes the address bar.
   *   - Clicks the back or forward button (or clicks a History link).
   *   - Clicks on a link.
   * - Represents the URL object as a set of methods (protocol, host, port, path, search, hash).
   *
   * For more information see {@link guide/$location Developer Guide: Using $location}
   */

  /**
   * @ngdoc provider
   * @name $locationProvider
   * @this
   *
   * @description
   * Use the `$locationProvider` to configure how the application deep linking paths are stored.
   */
  function $LocationProvider() {
    var hashPrefix = '!',
      html5Mode = {
        enabled: false,
        requireBase: true,
        rewriteLinks: true
      };

    /**
     * @ngdoc method
     * @name $locationProvider#hashPrefix
     * @description
     * The default value for the prefix is `'!'`.
     * @param {string=} prefix Prefix for hash part (containing path and search)
     * @returns {*} current value if used as getter or itself (chaining) if used as setter
     */
    this.hashPrefix = function (prefix) {
      if (isDefined(prefix)) {
        hashPrefix = prefix;
        return this;
      } else {
        return hashPrefix;
      }
    };

    /**
     * @ngdoc method
     * @name $locationProvider#html5Mode
     * @description
     * @param {(boolean|Object)=} mode If boolean, sets `html5Mode.enabled` to value.
     *   If object, sets `enabled`, `requireBase` and `rewriteLinks` to respective values. Supported
     *   properties:
     *   - **enabled** – `{boolean}` – (default: false) If true, will rely on `history.pushState` to
     *     change urls where supported. Will fall back to hash-prefixed paths in browsers that do not
     *     support `pushState`.
     *   - **requireBase** - `{boolean}` - (default: `true`) When html5Mode is enabled, specifies
     *     whether or not a <base> tag is required to be present. If `enabled` and `requireBase` are
     *     true, and a base tag is not present, an error will be thrown when `$location` is injected.
     *     See the {@link guide/$location $location guide for more information}
     *   - **rewriteLinks** - `{boolean|string}` - (default: `true`) When html5Mode is enabled,
     *     enables/disables URL rewriting for relative links. If set to a string, URL rewriting will
     *     only happen on links with an attribute that matches the given string. For example, if set
     *     to `'internal-link'`, then the URL will only be rewritten for `<a internal-link>` links.
     *     Note that [attribute name normalization](guide/directive#normalization) does not apply
     *     here, so `'internalLink'` will **not** match `'internal-link'`.
     *
     * @returns {Object} html5Mode object if used as getter or itself (chaining) if used as setter
     */
    this.html5Mode = function (mode) {
      if (isBoolean(mode)) {
        html5Mode.enabled = mode;
        return this;
      } else if (isObject(mode)) {
        if (isBoolean(mode.enabled)) {
          html5Mode.enabled = mode.enabled;
        }
        if (isBoolean(mode.requireBase)) {
          html5Mode.requireBase = mode.requireBase;
        }
        if (isBoolean(mode.rewriteLinks) || isString(mode.rewriteLinks)) {
          html5Mode.rewriteLinks = mode.rewriteLinks;
        }
        return this;
      } else {
        return html5Mode;
      }
    };

    /**
     * @ngdoc event
     * @name $location#$locationChangeStart
     * @eventType broadcast on root scope
     * @description
     * Broadcasted before a URL will change.
     *
     * This change can be prevented by calling
     * `preventDefault` method of the event. See {@link ng.$rootScope.Scope#$on} for more
     * details about event object. Upon successful change
     * {@link ng.$location#$locationChangeSuccess $locationChangeSuccess} is fired.
     *
     * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
     * the browser supports the HTML5 History API.
     *
     * @param {Object} angularEvent Synthetic event object.
     * @param {string} newUrl New URL
     * @param {string=} oldUrl URL that was before it was changed.
     * @param {string=} newState New history state object
     * @param {string=} oldState History state object that was before it was changed.
     */

    /**
     * @ngdoc event
     * @name $location#$locationChangeSuccess
     * @eventType broadcast on root scope
     * @description
     * Broadcasted after a URL was changed.
     *
     * The `newState` and `oldState` parameters may be defined only in HTML5 mode and when
     * the browser supports the HTML5 History API.
     *
     * @param {Object} angularEvent Synthetic event object.
     * @param {string} newUrl New URL
     * @param {string=} oldUrl URL that was before it was changed.
     * @param {string=} newState New history state object
     * @param {string=} oldState History state object that was before it was changed.
     */

    this.$get = ['$rootScope', '$browser', '$sniffer', '$rootElement', '$window', function ($rootScope, $browser, $sniffer, $rootElement, $window) {
      var $location,
        LocationMode,
        baseHref = $browser.baseHref(),
        // if base[href] is undefined, it defaults to ''
        initialUrl = $browser.url(),
        appBase;
      if (html5Mode.enabled) {
        if (!baseHref && html5Mode.requireBase) {
          throw $locationMinErr('nobase', '$location in HTML5 mode requires a <base> tag to be present!');
        }
        appBase = serverBase(initialUrl) + (baseHref || '/');
        LocationMode = $sniffer.history ? LocationHtml5Url : LocationHashbangInHtml5Url;
      } else {
        appBase = stripHash(initialUrl);
        LocationMode = LocationHashbangUrl;
      }
      var appBaseNoFile = stripFile(appBase);
      $location = new LocationMode(appBase, appBaseNoFile, '#' + hashPrefix);
      $location.$$parseLinkUrl(initialUrl, initialUrl);
      $location.$$state = $browser.state();
      var IGNORE_URI_REGEXP = /^\s*(javascript|mailto):/i;

      // Determine if two URLs are equal despite potentially having different encoding/normalizing
      //  such as $location.absUrl() vs $browser.url()
      // See https://github.com/angular/angular.js/issues/16592
      function urlsEqual(a, b) {
        return a === b || urlResolve(a).href === urlResolve(b).href;
      }
      function setBrowserUrlWithFallback(url, replace, state) {
        var oldUrl = $location.url();
        var oldState = $location.$$state;
        try {
          $browser.url(url, replace, state);

          // Make sure $location.state() returns referentially identical (not just deeply equal)
          // state object; this makes possible quick checking if the state changed in the digest
          // loop. Checking deep equality would be too expensive.
          $location.$$state = $browser.state();
        } catch (e) {
          // Restore old values if pushState fails
          $location.url(oldUrl);
          $location.$$state = oldState;
          throw e;
        }
      }
      $rootElement.on('click', function (event) {
        var rewriteLinks = html5Mode.rewriteLinks;
        // TODO(vojta): rewrite link when opening in new tab/window (in legacy browser)
        // currently we open nice url link and redirect then

        if (!rewriteLinks || event.ctrlKey || event.metaKey || event.shiftKey || event.which === 2 || event.button === 2) return;
        var elm = jqLite(event.target);

        // traverse the DOM up to find first A tag
        while (nodeName_(elm[0]) !== 'a') {
          // ignore rewriting if no A tag (reached root element, or no parent - removed from document)
          if (elm[0] === $rootElement[0] || !(elm = elm.parent())[0]) return;
        }
        if (isString(rewriteLinks) && isUndefined(elm.attr(rewriteLinks))) return;
        var absHref = elm.prop('href');
        // get the actual href attribute - see
        // http://msdn.microsoft.com/en-us/library/ie/dd347148(v=vs.85).aspx
        var relHref = elm.attr('href') || elm.attr('xlink:href');
        if (isObject(absHref) && absHref.toString() === '[object SVGAnimatedString]') {
          // SVGAnimatedString.animVal should be identical to SVGAnimatedString.baseVal, unless during
          // an animation.
          absHref = urlResolve(absHref.animVal).href;
        }

        // Ignore when url is started with javascript: or mailto:
        if (IGNORE_URI_REGEXP.test(absHref)) return;
        if (absHref && !elm.attr('target') && !event.isDefaultPrevented()) {
          if ($location.$$parseLinkUrl(absHref, relHref)) {
            // We do a preventDefault for all urls that are part of the AngularJS application,
            // in html5mode and also without, so that we are able to abort navigation without
            // getting double entries in the location history.
            event.preventDefault();
            // update location manually
            if ($location.absUrl() !== $browser.url()) {
              $rootScope.$apply();
            }
          }
        }
      });

      // rewrite hashbang url <> html5 url
      if ($location.absUrl() !== initialUrl) {
        $browser.url($location.absUrl(), true);
      }
      var initializing = true;

      // update $location when $browser url changes
      $browser.onUrlChange(function (newUrl, newState) {
        if (!startsWith(newUrl, appBaseNoFile)) {
          // If we are navigating outside of the app then force a reload
          $window.location.href = newUrl;
          return;
        }
        $rootScope.$evalAsync(function () {
          var oldUrl = $location.absUrl();
          var oldState = $location.$$state;
          var defaultPrevented;
          $location.$$parse(newUrl);
          $location.$$state = newState;
          defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl, newState, oldState).defaultPrevented;

          // if the location was changed by a `$locationChangeStart` handler then stop
          // processing this location change
          if ($location.absUrl() !== newUrl) return;
          if (defaultPrevented) {
            $location.$$parse(oldUrl);
            $location.$$state = oldState;
            setBrowserUrlWithFallback(oldUrl, false, oldState);
          } else {
            initializing = false;
            afterLocationChange(oldUrl, oldState);
          }
        });
        if (!$rootScope.$$phase) $rootScope.$digest();
      });

      // update browser
      $rootScope.$watch(function $locationWatch() {
        if (initializing || $location.$$urlUpdatedByLocation) {
          $location.$$urlUpdatedByLocation = false;
          var oldUrl = $browser.url();
          var newUrl = $location.absUrl();
          var oldState = $browser.state();
          var currentReplace = $location.$$replace;
          var urlOrStateChanged = !urlsEqual(oldUrl, newUrl) || $location.$$html5 && $sniffer.history && oldState !== $location.$$state;
          if (initializing || urlOrStateChanged) {
            initializing = false;
            $rootScope.$evalAsync(function () {
              var newUrl = $location.absUrl();
              var defaultPrevented = $rootScope.$broadcast('$locationChangeStart', newUrl, oldUrl, $location.$$state, oldState).defaultPrevented;

              // if the location was changed by a `$locationChangeStart` handler then stop
              // processing this location change
              if ($location.absUrl() !== newUrl) return;
              if (defaultPrevented) {
                $location.$$parse(oldUrl);
                $location.$$state = oldState;
              } else {
                if (urlOrStateChanged) {
                  setBrowserUrlWithFallback(newUrl, currentReplace, oldState === $location.$$state ? null : $location.$$state);
                }
                afterLocationChange(oldUrl, oldState);
              }
            });
          }
        }
        $location.$$replace = false;

        // we don't need to return anything because $evalAsync will make the digest loop dirty when
        // there is a change
      });
      return $location;
      function afterLocationChange(oldUrl, oldState) {
        $rootScope.$broadcast('$locationChangeSuccess', $location.absUrl(), oldUrl, $location.$$state, oldState);
      }
    }];
  }

  /**
   * @ngdoc service
   * @name $log
   * @requires $window
   *
   * @description
   * Simple service for logging. Default implementation safely writes the message
   * into the browser's console (if present).
   *
   * The main purpose of this service is to simplify debugging and troubleshooting.
   *
   * To reveal the location of the calls to `$log` in the JavaScript console,
   * you can "blackbox" the AngularJS source in your browser:
   *
   * [Mozilla description of blackboxing](https://developer.mozilla.org/en-US/docs/Tools/Debugger/How_to/Black_box_a_source).
   * [Chrome description of blackboxing](https://developer.chrome.com/devtools/docs/blackboxing).
   *
   * Note: Not all browsers support blackboxing.
   *
   * The default is to log `debug` messages. You can use
   * {@link ng.$logProvider ng.$logProvider#debugEnabled} to change this.
   *
   * @example
     <example module="logExample" name="log-service">
       <file name="script.js">
         angular.module('logExample', [])
           .controller('LogController', ['$scope', '$log', function($scope, $log) {
             $scope.$log = $log;
             $scope.message = 'Hello World!';
           }]);
       </file>
       <file name="index.html">
         <div ng-controller="LogController">
           <p>Reload this page with open console, enter text and hit the log button...</p>
           <label>Message:
           <input type="text" ng-model="message" /></label>
           <button ng-click="$log.log(message)">log</button>
           <button ng-click="$log.warn(message)">warn</button>
           <button ng-click="$log.info(message)">info</button>
           <button ng-click="$log.error(message)">error</button>
           <button ng-click="$log.debug(message)">debug</button>
         </div>
       </file>
     </example>
   */

  /**
   * @ngdoc provider
   * @name $logProvider
   * @this
   *
   * @description
   * Use the `$logProvider` to configure how the application logs messages
   */
  function $LogProvider() {
    var debug = true,
      self = this;

    /**
     * @ngdoc method
     * @name $logProvider#debugEnabled
     * @description
     * @param {boolean=} flag enable or disable debug level messages
     * @returns {*} current value if used as getter or itself (chaining) if used as setter
     */
    this.debugEnabled = function (flag) {
      if (isDefined(flag)) {
        debug = flag;
        return this;
      } else {
        return debug;
      }
    };
    this.$get = ['$window', function ($window) {
      // Support: IE 9-11, Edge 12-14+
      // IE/Edge display errors in such a way that it requires the user to click in 4 places
      // to see the stack trace. There is no way to feature-detect it so there's a chance
      // of the user agent sniffing to go wrong but since it's only about logging, this shouldn't
      // break apps. Other browsers display errors in a sensible way and some of them map stack
      // traces along source maps if available so it makes sense to let browsers display it
      // as they want.
      var formatStackTrace = msie || /\bEdge\//.test($window.navigator && $window.navigator.userAgent);
      return {
        /**
         * @ngdoc method
         * @name $log#log
         *
         * @description
         * Write a log message
         */
        log: consoleLog('log'),
        /**
         * @ngdoc method
         * @name $log#info
         *
         * @description
         * Write an information message
         */
        info: consoleLog('info'),
        /**
         * @ngdoc method
         * @name $log#warn
         *
         * @description
         * Write a warning message
         */
        warn: consoleLog('warn'),
        /**
         * @ngdoc method
         * @name $log#error
         *
         * @description
         * Write an error message
         */
        error: consoleLog('error'),
        /**
         * @ngdoc method
         * @name $log#debug
         *
         * @description
         * Write a debug message
         */
        debug: function () {
          var fn = consoleLog('debug');
          return function () {
            if (debug) {
              fn.apply(self, arguments);
            }
          };
        }()
      };
      function formatError(arg) {
        if (isError(arg)) {
          if (arg.stack && formatStackTrace) {
            arg = arg.message && arg.stack.indexOf(arg.message) === -1 ? 'Error: ' + arg.message + '\n' + arg.stack : arg.stack;
          } else if (arg.sourceURL) {
            arg = arg.message + '\n' + arg.sourceURL + ':' + arg.line;
          }
        }
        return arg;
      }
      function consoleLog(type) {
        var console = $window.console || {},
          logFn = console[type] || console.log || noop;
        return function () {
          var args = [];
          forEach(arguments, function (arg) {
            args.push(formatError(arg));
          });
          // Support: IE 9 only
          // console methods don't inherit from Function.prototype in IE 9 so we can't
          // call `logFn.apply(console, args)` directly.
          return Function.prototype.apply.call(logFn, console, args);
        };
      }
    }];
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   *     Any commits to this file should be reviewed with security in mind.  *
   *   Changes to this file can potentially create security vulnerabilities. *
   *          An approval from 2 Core members with history of modifying      *
   *                         this file is required.                          *
   *                                                                         *
   *  Does the change somehow allow for arbitrary javascript to be executed? *
   *    Or allows for someone to change the prototype of built-in objects?   *
   *     Or gives undesired access to variables likes document or window?    *
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  var $parseMinErr = minErr('$parse');
  var objectValueOf = {}.constructor.prototype.valueOf;

  // Sandboxing AngularJS Expressions
  // ------------------------------
  // AngularJS expressions are no longer sandboxed. So it is now even easier to access arbitrary JS code by
  // various means such as obtaining a reference to native JS functions like the Function constructor.
  //
  // As an example, consider the following AngularJS expression:
  //
  //   {}.toString.constructor('alert("evil JS code")')
  //
  // It is important to realize that if you create an expression from a string that contains user provided
  // content then it is possible that your application contains a security vulnerability to an XSS style attack.
  //
  // See https://docs.angularjs.org/guide/security

  function getStringValue(name) {
    // Property names must be strings. This means that non-string objects cannot be used
    // as keys in an object. Any non-string object, including a number, is typecasted
    // into a string via the toString method.
    // -- MDN, https://developer.mozilla.org/en/docs/Web/JavaScript/Reference/Operators/Property_accessors#Property_names
    //
    // So, to ensure that we are checking the same `name` that JavaScript would use, we cast it
    // to a string. It's not always possible. If `name` is an object and its `toString` method is
    // 'broken' (doesn't return a string, isn't a function, etc.), an error will be thrown:
    //
    // TypeError: Cannot convert object to primitive value
    //
    // For performance reasons, we don't catch this error here and allow it to propagate up the call
    // stack. Note that you'll get the same error in JavaScript if you try to access a property using
    // such a 'broken' object as a key.
    return name + '';
  }
  var OPERATORS = createMap();
  forEach('+ - * / % === !== == != < > <= >= && || ! = |'.split(' '), function (operator) {
    OPERATORS[operator] = true;
  });
  var ESCAPE = {
    'n': '\n',
    'f': '\f',
    'r': '\r',
    't': '\t',
    'v': '\v',
    '\'': '\'',
    '"': '"'
  };

  /////////////////////////////////////////

  /**
   * @constructor
   */
  var Lexer = function Lexer(options) {
    this.options = options;
  };
  Lexer.prototype = {
    constructor: Lexer,
    lex: function lex(text) {
      this.text = text;
      this.index = 0;
      this.tokens = [];
      while (this.index < this.text.length) {
        var ch = this.text.charAt(this.index);
        if (ch === '"' || ch === '\'') {
          this.readString(ch);
        } else if (this.isNumber(ch) || ch === '.' && this.isNumber(this.peek())) {
          this.readNumber();
        } else if (this.isIdentifierStart(this.peekMultichar())) {
          this.readIdent();
        } else if (this.is(ch, '(){}[].,;:?')) {
          this.tokens.push({
            index: this.index,
            text: ch
          });
          this.index++;
        } else if (this.isWhitespace(ch)) {
          this.index++;
        } else {
          var ch2 = ch + this.peek();
          var ch3 = ch2 + this.peek(2);
          var op1 = OPERATORS[ch];
          var op2 = OPERATORS[ch2];
          var op3 = OPERATORS[ch3];
          if (op1 || op2 || op3) {
            var token = op3 ? ch3 : op2 ? ch2 : ch;
            this.tokens.push({
              index: this.index,
              text: token,
              operator: true
            });
            this.index += token.length;
          } else {
            this.throwError('Unexpected next character ', this.index, this.index + 1);
          }
        }
      }
      return this.tokens;
    },
    is: function is(ch, chars) {
      return chars.indexOf(ch) !== -1;
    },
    peek: function peek(i) {
      var num = i || 1;
      return this.index + num < this.text.length ? this.text.charAt(this.index + num) : false;
    },
    isNumber: function isNumber(ch) {
      return '0' <= ch && ch <= '9' && typeof ch === 'string';
    },
    isWhitespace: function isWhitespace(ch) {
      // IE treats non-breaking space as \u00A0
      return ch === ' ' || ch === '\r' || ch === '\t' || ch === '\n' || ch === '\v' || ch === "\xA0";
    },
    isIdentifierStart: function isIdentifierStart(ch) {
      return this.options.isIdentifierStart ? this.options.isIdentifierStart(ch, this.codePointAt(ch)) : this.isValidIdentifierStart(ch);
    },
    isValidIdentifierStart: function isValidIdentifierStart(ch) {
      return 'a' <= ch && ch <= 'z' || 'A' <= ch && ch <= 'Z' || '_' === ch || ch === '$';
    },
    isIdentifierContinue: function isIdentifierContinue(ch) {
      return this.options.isIdentifierContinue ? this.options.isIdentifierContinue(ch, this.codePointAt(ch)) : this.isValidIdentifierContinue(ch);
    },
    isValidIdentifierContinue: function isValidIdentifierContinue(ch, cp) {
      return this.isValidIdentifierStart(ch, cp) || this.isNumber(ch);
    },
    codePointAt: function codePointAt(ch) {
      if (ch.length === 1) return ch.charCodeAt(0);
      // eslint-disable-next-line no-bitwise
      return (ch.charCodeAt(0) << 10) + ch.charCodeAt(1) - 0x35FDC00;
    },
    peekMultichar: function peekMultichar() {
      var ch = this.text.charAt(this.index);
      var peek = this.peek();
      if (!peek) {
        return ch;
      }
      var cp1 = ch.charCodeAt(0);
      var cp2 = peek.charCodeAt(0);
      if (cp1 >= 0xD800 && cp1 <= 0xDBFF && cp2 >= 0xDC00 && cp2 <= 0xDFFF) {
        return ch + peek;
      }
      return ch;
    },
    isExpOperator: function isExpOperator(ch) {
      return ch === '-' || ch === '+' || this.isNumber(ch);
    },
    throwError: function throwError(error, start, end) {
      end = end || this.index;
      var colStr = isDefined(start) ? 's ' + start + '-' + this.index + ' [' + this.text.substring(start, end) + ']' : ' ' + end;
      throw $parseMinErr('lexerr', 'Lexer Error: {0} at column{1} in expression [{2}].', error, colStr, this.text);
    },
    readNumber: function readNumber() {
      var number = '';
      var start = this.index;
      while (this.index < this.text.length) {
        var ch = lowercase(this.text.charAt(this.index));
        if (ch === '.' || this.isNumber(ch)) {
          number += ch;
        } else {
          var peekCh = this.peek();
          if (ch === 'e' && this.isExpOperator(peekCh)) {
            number += ch;
          } else if (this.isExpOperator(ch) && peekCh && this.isNumber(peekCh) && number.charAt(number.length - 1) === 'e') {
            number += ch;
          } else if (this.isExpOperator(ch) && (!peekCh || !this.isNumber(peekCh)) && number.charAt(number.length - 1) === 'e') {
            this.throwError('Invalid exponent');
          } else {
            break;
          }
        }
        this.index++;
      }
      this.tokens.push({
        index: start,
        text: number,
        constant: true,
        value: Number(number)
      });
    },
    readIdent: function readIdent() {
      var start = this.index;
      this.index += this.peekMultichar().length;
      while (this.index < this.text.length) {
        var ch = this.peekMultichar();
        if (!this.isIdentifierContinue(ch)) {
          break;
        }
        this.index += ch.length;
      }
      this.tokens.push({
        index: start,
        text: this.text.slice(start, this.index),
        identifier: true
      });
    },
    readString: function readString(quote) {
      var start = this.index;
      this.index++;
      var string = '';
      var rawString = quote;
      var escape = false;
      while (this.index < this.text.length) {
        var ch = this.text.charAt(this.index);
        rawString += ch;
        if (escape) {
          if (ch === 'u') {
            var hex = this.text.substring(this.index + 1, this.index + 5);
            if (!hex.match(/[\da-f]{4}/i)) {
              this.throwError("Invalid unicode escape [\\u" + hex + ']');
            }
            this.index += 4;
            string += String.fromCharCode(parseInt(hex, 16));
          } else {
            var rep = ESCAPE[ch];
            string = string + (rep || ch);
          }
          escape = false;
        } else if (ch === '\\') {
          escape = true;
        } else if (ch === quote) {
          this.index++;
          this.tokens.push({
            index: start,
            text: rawString,
            constant: true,
            value: string
          });
          return;
        } else {
          string += ch;
        }
        this.index++;
      }
      this.throwError('Unterminated quote', start);
    }
  };
  var AST = function AST(lexer, options) {
    this.lexer = lexer;
    this.options = options;
  };
  AST.Program = 'Program';
  AST.ExpressionStatement = 'ExpressionStatement';
  AST.AssignmentExpression = 'AssignmentExpression';
  AST.ConditionalExpression = 'ConditionalExpression';
  AST.LogicalExpression = 'LogicalExpression';
  AST.BinaryExpression = 'BinaryExpression';
  AST.UnaryExpression = 'UnaryExpression';
  AST.CallExpression = 'CallExpression';
  AST.MemberExpression = 'MemberExpression';
  AST.Identifier = 'Identifier';
  AST.Literal = 'Literal';
  AST.ArrayExpression = 'ArrayExpression';
  AST.Property = 'Property';
  AST.ObjectExpression = 'ObjectExpression';
  AST.ThisExpression = 'ThisExpression';
  AST.LocalsExpression = 'LocalsExpression';

  // Internal use only
  AST.NGValueParameter = 'NGValueParameter';
  AST.prototype = {
    ast: function ast(text) {
      this.text = text;
      this.tokens = this.lexer.lex(text);
      var value = this.program();
      if (this.tokens.length !== 0) {
        this.throwError('is an unexpected token', this.tokens[0]);
      }
      return value;
    },
    program: function program() {
      var body = [];
      while (true) {
        if (this.tokens.length > 0 && !this.peek('}', ')', ';', ']')) body.push(this.expressionStatement());
        if (!this.expect(';')) {
          return {
            type: AST.Program,
            body: body
          };
        }
      }
    },
    expressionStatement: function expressionStatement() {
      return {
        type: AST.ExpressionStatement,
        expression: this.filterChain()
      };
    },
    filterChain: function filterChain() {
      var left = this.expression();
      while (this.expect('|')) {
        left = this.filter(left);
      }
      return left;
    },
    expression: function expression() {
      return this.assignment();
    },
    assignment: function assignment() {
      var result = this.ternary();
      if (this.expect('=')) {
        if (!isAssignable(result)) {
          throw $parseMinErr('lval', 'Trying to assign a value to a non l-value');
        }
        result = {
          type: AST.AssignmentExpression,
          left: result,
          right: this.assignment(),
          operator: '='
        };
      }
      return result;
    },
    ternary: function ternary() {
      var test = this.logicalOR();
      var alternate;
      var consequent;
      if (this.expect('?')) {
        alternate = this.expression();
        if (this.consume(':')) {
          consequent = this.expression();
          return {
            type: AST.ConditionalExpression,
            test: test,
            alternate: alternate,
            consequent: consequent
          };
        }
      }
      return test;
    },
    logicalOR: function logicalOR() {
      var left = this.logicalAND();
      while (this.expect('||')) {
        left = {
          type: AST.LogicalExpression,
          operator: '||',
          left: left,
          right: this.logicalAND()
        };
      }
      return left;
    },
    logicalAND: function logicalAND() {
      var left = this.equality();
      while (this.expect('&&')) {
        left = {
          type: AST.LogicalExpression,
          operator: '&&',
          left: left,
          right: this.equality()
        };
      }
      return left;
    },
    equality: function equality() {
      var left = this.relational();
      var token;
      while (token = this.expect('==', '!=', '===', '!==')) {
        left = {
          type: AST.BinaryExpression,
          operator: token.text,
          left: left,
          right: this.relational()
        };
      }
      return left;
    },
    relational: function relational() {
      var left = this.additive();
      var token;
      while (token = this.expect('<', '>', '<=', '>=')) {
        left = {
          type: AST.BinaryExpression,
          operator: token.text,
          left: left,
          right: this.additive()
        };
      }
      return left;
    },
    additive: function additive() {
      var left = this.multiplicative();
      var token;
      while (token = this.expect('+', '-')) {
        left = {
          type: AST.BinaryExpression,
          operator: token.text,
          left: left,
          right: this.multiplicative()
        };
      }
      return left;
    },
    multiplicative: function multiplicative() {
      var left = this.unary();
      var token;
      while (token = this.expect('*', '/', '%')) {
        left = {
          type: AST.BinaryExpression,
          operator: token.text,
          left: left,
          right: this.unary()
        };
      }
      return left;
    },
    unary: function unary() {
      var token;
      if (token = this.expect('+', '-', '!')) {
        return {
          type: AST.UnaryExpression,
          operator: token.text,
          prefix: true,
          argument: this.unary()
        };
      } else {
        return this.primary();
      }
    },
    primary: function primary() {
      var primary;
      if (this.expect('(')) {
        primary = this.filterChain();
        this.consume(')');
      } else if (this.expect('[')) {
        primary = this.arrayDeclaration();
      } else if (this.expect('{')) {
        primary = this.object();
      } else if (this.selfReferential.hasOwnProperty(this.peek().text)) {
        primary = copy(this.selfReferential[this.consume().text]);
      } else if (this.options.literals.hasOwnProperty(this.peek().text)) {
        primary = {
          type: AST.Literal,
          value: this.options.literals[this.consume().text]
        };
      } else if (this.peek().identifier) {
        primary = this.identifier();
      } else if (this.peek().constant) {
        primary = this.constant();
      } else {
        this.throwError('not a primary expression', this.peek());
      }
      var next;
      while (next = this.expect('(', '[', '.')) {
        if (next.text === '(') {
          primary = {
            type: AST.CallExpression,
            callee: primary,
            arguments: this.parseArguments()
          };
          this.consume(')');
        } else if (next.text === '[') {
          primary = {
            type: AST.MemberExpression,
            object: primary,
            property: this.expression(),
            computed: true
          };
          this.consume(']');
        } else if (next.text === '.') {
          primary = {
            type: AST.MemberExpression,
            object: primary,
            property: this.identifier(),
            computed: false
          };
        } else {
          this.throwError('IMPOSSIBLE');
        }
      }
      return primary;
    },
    filter: function filter(baseExpression) {
      var args = [baseExpression];
      var result = {
        type: AST.CallExpression,
        callee: this.identifier(),
        arguments: args,
        filter: true
      };
      while (this.expect(':')) {
        args.push(this.expression());
      }
      return result;
    },
    parseArguments: function parseArguments() {
      var args = [];
      if (this.peekToken().text !== ')') {
        do {
          args.push(this.filterChain());
        } while (this.expect(','));
      }
      return args;
    },
    identifier: function identifier() {
      var token = this.consume();
      if (!token.identifier) {
        this.throwError('is not a valid identifier', token);
      }
      return {
        type: AST.Identifier,
        name: token.text
      };
    },
    constant: function constant() {
      // TODO check that it is a constant
      return {
        type: AST.Literal,
        value: this.consume().value
      };
    },
    arrayDeclaration: function arrayDeclaration() {
      var elements = [];
      if (this.peekToken().text !== ']') {
        do {
          if (this.peek(']')) {
            // Support trailing commas per ES5.1.
            break;
          }
          elements.push(this.expression());
        } while (this.expect(','));
      }
      this.consume(']');
      return {
        type: AST.ArrayExpression,
        elements: elements
      };
    },
    object: function object() {
      var properties = [],
        property;
      if (this.peekToken().text !== '}') {
        do {
          if (this.peek('}')) {
            // Support trailing commas per ES5.1.
            break;
          }
          property = {
            type: AST.Property,
            kind: 'init'
          };
          if (this.peek().constant) {
            property.key = this.constant();
            property.computed = false;
            this.consume(':');
            property.value = this.expression();
          } else if (this.peek().identifier) {
            property.key = this.identifier();
            property.computed = false;
            if (this.peek(':')) {
              this.consume(':');
              property.value = this.expression();
            } else {
              property.value = property.key;
            }
          } else if (this.peek('[')) {
            this.consume('[');
            property.key = this.expression();
            this.consume(']');
            property.computed = true;
            this.consume(':');
            property.value = this.expression();
          } else {
            this.throwError('invalid key', this.peek());
          }
          properties.push(property);
        } while (this.expect(','));
      }
      this.consume('}');
      return {
        type: AST.ObjectExpression,
        properties: properties
      };
    },
    throwError: function throwError(msg, token) {
      throw $parseMinErr('syntax', 'Syntax Error: Token \'{0}\' {1} at column {2} of the expression [{3}] starting at [{4}].', token.text, msg, token.index + 1, this.text, this.text.substring(token.index));
    },
    consume: function consume(e1) {
      if (this.tokens.length === 0) {
        throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
      }
      var token = this.expect(e1);
      if (!token) {
        this.throwError('is unexpected, expecting [' + e1 + ']', this.peek());
      }
      return token;
    },
    peekToken: function peekToken() {
      if (this.tokens.length === 0) {
        throw $parseMinErr('ueoe', 'Unexpected end of expression: {0}', this.text);
      }
      return this.tokens[0];
    },
    peek: function peek(e1, e2, e3, e4) {
      return this.peekAhead(0, e1, e2, e3, e4);
    },
    peekAhead: function peekAhead(i, e1, e2, e3, e4) {
      if (this.tokens.length > i) {
        var token = this.tokens[i];
        var t = token.text;
        if (t === e1 || t === e2 || t === e3 || t === e4 || !e1 && !e2 && !e3 && !e4) {
          return token;
        }
      }
      return false;
    },
    expect: function expect(e1, e2, e3, e4) {
      var token = this.peek(e1, e2, e3, e4);
      if (token) {
        this.tokens.shift();
        return token;
      }
      return false;
    },
    selfReferential: {
      'this': {
        type: AST.ThisExpression
      },
      '$locals': {
        type: AST.LocalsExpression
      }
    }
  };
  function ifDefined(v, d) {
    return typeof v !== 'undefined' ? v : d;
  }
  function plusFn(l, r) {
    if (typeof l === 'undefined') return r;
    if (typeof r === 'undefined') return l;
    return l + r;
  }
  function isStateless($filter, filterName) {
    var fn = $filter(filterName);
    return !fn.$stateful;
  }
  var PURITY_ABSOLUTE = 1;
  var PURITY_RELATIVE = 2;

  // Detect nodes which could depend on non-shallow state of objects
  function isPure(node, parentIsPure) {
    switch (node.type) {
      // Computed members might invoke a stateful toString()
      case AST.MemberExpression:
        if (node.computed) {
          return false;
        }
        break;

      // Unary always convert to primative
      case AST.UnaryExpression:
        return PURITY_ABSOLUTE;

      // The binary + operator can invoke a stateful toString().
      case AST.BinaryExpression:
        return node.operator !== '+' ? PURITY_ABSOLUTE : false;

      // Functions / filters probably read state from within objects
      case AST.CallExpression:
        return false;
    }
    return undefined === parentIsPure ? PURITY_RELATIVE : parentIsPure;
  }
  function findConstantAndWatchExpressions(ast, $filter, parentIsPure) {
    var allConstants;
    var argsToWatch;
    var isStatelessFilter;
    var astIsPure = ast.isPure = isPure(ast, parentIsPure);
    switch (ast.type) {
      case AST.Program:
        allConstants = true;
        forEach(ast.body, function (expr) {
          findConstantAndWatchExpressions(expr.expression, $filter, astIsPure);
          allConstants = allConstants && expr.expression.constant;
        });
        ast.constant = allConstants;
        break;
      case AST.Literal:
        ast.constant = true;
        ast.toWatch = [];
        break;
      case AST.UnaryExpression:
        findConstantAndWatchExpressions(ast.argument, $filter, astIsPure);
        ast.constant = ast.argument.constant;
        ast.toWatch = ast.argument.toWatch;
        break;
      case AST.BinaryExpression:
        findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
        ast.constant = ast.left.constant && ast.right.constant;
        ast.toWatch = ast.left.toWatch.concat(ast.right.toWatch);
        break;
      case AST.LogicalExpression:
        findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
        ast.constant = ast.left.constant && ast.right.constant;
        ast.toWatch = ast.constant ? [] : [ast];
        break;
      case AST.ConditionalExpression:
        findConstantAndWatchExpressions(ast.test, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.alternate, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.consequent, $filter, astIsPure);
        ast.constant = ast.test.constant && ast.alternate.constant && ast.consequent.constant;
        ast.toWatch = ast.constant ? [] : [ast];
        break;
      case AST.Identifier:
        ast.constant = false;
        ast.toWatch = [ast];
        break;
      case AST.MemberExpression:
        findConstantAndWatchExpressions(ast.object, $filter, astIsPure);
        if (ast.computed) {
          findConstantAndWatchExpressions(ast.property, $filter, astIsPure);
        }
        ast.constant = ast.object.constant && (!ast.computed || ast.property.constant);
        ast.toWatch = ast.constant ? [] : [ast];
        break;
      case AST.CallExpression:
        isStatelessFilter = ast.filter ? isStateless($filter, ast.callee.name) : false;
        allConstants = isStatelessFilter;
        argsToWatch = [];
        forEach(ast.arguments, function (expr) {
          findConstantAndWatchExpressions(expr, $filter, astIsPure);
          allConstants = allConstants && expr.constant;
          argsToWatch.push.apply(argsToWatch, expr.toWatch);
        });
        ast.constant = allConstants;
        ast.toWatch = isStatelessFilter ? argsToWatch : [ast];
        break;
      case AST.AssignmentExpression:
        findConstantAndWatchExpressions(ast.left, $filter, astIsPure);
        findConstantAndWatchExpressions(ast.right, $filter, astIsPure);
        ast.constant = ast.left.constant && ast.right.constant;
        ast.toWatch = [ast];
        break;
      case AST.ArrayExpression:
        allConstants = true;
        argsToWatch = [];
        forEach(ast.elements, function (expr) {
          findConstantAndWatchExpressions(expr, $filter, astIsPure);
          allConstants = allConstants && expr.constant;
          argsToWatch.push.apply(argsToWatch, expr.toWatch);
        });
        ast.constant = allConstants;
        ast.toWatch = argsToWatch;
        break;
      case AST.ObjectExpression:
        allConstants = true;
        argsToWatch = [];
        forEach(ast.properties, function (property) {
          findConstantAndWatchExpressions(property.value, $filter, astIsPure);
          allConstants = allConstants && property.value.constant;
          argsToWatch.push.apply(argsToWatch, property.value.toWatch);
          if (property.computed) {
            //`{[key]: value}` implicitly does `key.toString()` which may be non-pure
            findConstantAndWatchExpressions(property.key, $filter, /*parentIsPure=*/false);
            allConstants = allConstants && property.key.constant;
            argsToWatch.push.apply(argsToWatch, property.key.toWatch);
          }
        });
        ast.constant = allConstants;
        ast.toWatch = argsToWatch;
        break;
      case AST.ThisExpression:
        ast.constant = false;
        ast.toWatch = [];
        break;
      case AST.LocalsExpression:
        ast.constant = false;
        ast.toWatch = [];
        break;
    }
  }
  function getInputs(body) {
    if (body.length !== 1) return;
    var lastExpression = body[0].expression;
    var candidate = lastExpression.toWatch;
    if (candidate.length !== 1) return candidate;
    return candidate[0] !== lastExpression ? candidate : undefined;
  }
  function isAssignable(ast) {
    return ast.type === AST.Identifier || ast.type === AST.MemberExpression;
  }
  function assignableAST(ast) {
    if (ast.body.length === 1 && isAssignable(ast.body[0].expression)) {
      return {
        type: AST.AssignmentExpression,
        left: ast.body[0].expression,
        right: {
          type: AST.NGValueParameter
        },
        operator: '='
      };
    }
  }
  function isLiteral(ast) {
    return ast.body.length === 0 || ast.body.length === 1 && (ast.body[0].expression.type === AST.Literal || ast.body[0].expression.type === AST.ArrayExpression || ast.body[0].expression.type === AST.ObjectExpression);
  }
  function isConstant(ast) {
    return ast.constant;
  }
  function ASTCompiler($filter) {
    this.$filter = $filter;
  }
  ASTCompiler.prototype = {
    compile: function compile(ast) {
      var self = this;
      this.state = {
        nextId: 0,
        filters: {},
        fn: {
          vars: [],
          body: [],
          own: {}
        },
        assign: {
          vars: [],
          body: [],
          own: {}
        },
        inputs: []
      };
      findConstantAndWatchExpressions(ast, self.$filter);
      var extra = '';
      var assignable;
      this.stage = 'assign';
      if (assignable = assignableAST(ast)) {
        this.state.computing = 'assign';
        var result = this.nextId();
        this.recurse(assignable, result);
        this.return_(result);
        extra = 'fn.assign=' + this.generateFunction('assign', 's,v,l');
      }
      var toWatch = getInputs(ast.body);
      self.stage = 'inputs';
      forEach(toWatch, function (watch, key) {
        var fnKey = 'fn' + key;
        self.state[fnKey] = {
          vars: [],
          body: [],
          own: {}
        };
        self.state.computing = fnKey;
        var intoId = self.nextId();
        self.recurse(watch, intoId);
        self.return_(intoId);
        self.state.inputs.push({
          name: fnKey,
          isPure: watch.isPure
        });
        watch.watchId = key;
      });
      this.state.computing = 'fn';
      this.stage = 'main';
      this.recurse(ast);
      var fnString =
      // The build and minification steps remove the string "use strict" from the code, but this is done using a regex.
      // This is a workaround for this until we do a better job at only removing the prefix only when we should.
      '"' + this.USE + ' ' + this.STRICT + '";\n' + this.filterPrefix() + 'var fn=' + this.generateFunction('fn', 's,l,a,i') + extra + this.watchFns() + 'return fn;';

      // eslint-disable-next-line no-new-func
      var fn = new Function('$filter', 'getStringValue', 'ifDefined', 'plus', fnString)(this.$filter, getStringValue, ifDefined, plusFn);
      this.state = this.stage = undefined;
      return fn;
    },
    USE: 'use',
    STRICT: 'strict',
    watchFns: function watchFns() {
      var result = [];
      var inputs = this.state.inputs;
      var self = this;
      forEach(inputs, function (input) {
        result.push('var ' + input.name + '=' + self.generateFunction(input.name, 's'));
        if (input.isPure) {
          result.push(input.name, '.isPure=' + JSON.stringify(input.isPure) + ';');
        }
      });
      if (inputs.length) {
        result.push('fn.inputs=[' + inputs.map(function (i) {
          return i.name;
        }).join(',') + '];');
      }
      return result.join('');
    },
    generateFunction: function generateFunction(name, params) {
      return 'function(' + params + '){' + this.varsPrefix(name) + this.body(name) + '};';
    },
    filterPrefix: function filterPrefix() {
      var parts = [];
      var self = this;
      forEach(this.state.filters, function (id, filter) {
        parts.push(id + '=$filter(' + self.escape(filter) + ')');
      });
      if (parts.length) return 'var ' + parts.join(',') + ';';
      return '';
    },
    varsPrefix: function varsPrefix(section) {
      return this.state[section].vars.length ? 'var ' + this.state[section].vars.join(',') + ';' : '';
    },
    body: function body(section) {
      return this.state[section].body.join('');
    },
    recurse: function recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
      var left,
        right,
        self = this,
        args,
        expression,
        computed;
      recursionFn = recursionFn || noop;
      if (!skipWatchIdCheck && isDefined(ast.watchId)) {
        intoId = intoId || this.nextId();
        this.if_('i', this.lazyAssign(intoId, this.computedMember('i', ast.watchId)), this.lazyRecurse(ast, intoId, nameId, recursionFn, create, true));
        return;
      }
      switch (ast.type) {
        case AST.Program:
          forEach(ast.body, function (expression, pos) {
            self.recurse(expression.expression, undefined, undefined, function (expr) {
              right = expr;
            });
            if (pos !== ast.body.length - 1) {
              self.current().body.push(right, ';');
            } else {
              self.return_(right);
            }
          });
          break;
        case AST.Literal:
          expression = this.escape(ast.value);
          this.assign(intoId, expression);
          recursionFn(intoId || expression);
          break;
        case AST.UnaryExpression:
          this.recurse(ast.argument, undefined, undefined, function (expr) {
            right = expr;
          });
          expression = ast.operator + '(' + this.ifDefined(right, 0) + ')';
          this.assign(intoId, expression);
          recursionFn(expression);
          break;
        case AST.BinaryExpression:
          this.recurse(ast.left, undefined, undefined, function (expr) {
            left = expr;
          });
          this.recurse(ast.right, undefined, undefined, function (expr) {
            right = expr;
          });
          if (ast.operator === '+') {
            expression = this.plus(left, right);
          } else if (ast.operator === '-') {
            expression = this.ifDefined(left, 0) + ast.operator + this.ifDefined(right, 0);
          } else {
            expression = '(' + left + ')' + ast.operator + '(' + right + ')';
          }
          this.assign(intoId, expression);
          recursionFn(expression);
          break;
        case AST.LogicalExpression:
          intoId = intoId || this.nextId();
          self.recurse(ast.left, intoId);
          self.if_(ast.operator === '&&' ? intoId : self.not(intoId), self.lazyRecurse(ast.right, intoId));
          recursionFn(intoId);
          break;
        case AST.ConditionalExpression:
          intoId = intoId || this.nextId();
          self.recurse(ast.test, intoId);
          self.if_(intoId, self.lazyRecurse(ast.alternate, intoId), self.lazyRecurse(ast.consequent, intoId));
          recursionFn(intoId);
          break;
        case AST.Identifier:
          intoId = intoId || this.nextId();
          if (nameId) {
            nameId.context = self.stage === 'inputs' ? 's' : this.assign(this.nextId(), this.getHasOwnProperty('l', ast.name) + '?l:s');
            nameId.computed = false;
            nameId.name = ast.name;
          }
          self.if_(self.stage === 'inputs' || self.not(self.getHasOwnProperty('l', ast.name)), function () {
            self.if_(self.stage === 'inputs' || 's', function () {
              if (create && create !== 1) {
                self.if_(self.isNull(self.nonComputedMember('s', ast.name)), self.lazyAssign(self.nonComputedMember('s', ast.name), '{}'));
              }
              self.assign(intoId, self.nonComputedMember('s', ast.name));
            });
          }, intoId && self.lazyAssign(intoId, self.nonComputedMember('l', ast.name)));
          recursionFn(intoId);
          break;
        case AST.MemberExpression:
          left = nameId && (nameId.context = this.nextId()) || this.nextId();
          intoId = intoId || this.nextId();
          self.recurse(ast.object, left, undefined, function () {
            self.if_(self.notNull(left), function () {
              if (ast.computed) {
                right = self.nextId();
                self.recurse(ast.property, right);
                self.getStringValue(right);
                if (create && create !== 1) {
                  self.if_(self.not(self.computedMember(left, right)), self.lazyAssign(self.computedMember(left, right), '{}'));
                }
                expression = self.computedMember(left, right);
                self.assign(intoId, expression);
                if (nameId) {
                  nameId.computed = true;
                  nameId.name = right;
                }
              } else {
                if (create && create !== 1) {
                  self.if_(self.isNull(self.nonComputedMember(left, ast.property.name)), self.lazyAssign(self.nonComputedMember(left, ast.property.name), '{}'));
                }
                expression = self.nonComputedMember(left, ast.property.name);
                self.assign(intoId, expression);
                if (nameId) {
                  nameId.computed = false;
                  nameId.name = ast.property.name;
                }
              }
            }, function () {
              self.assign(intoId, 'undefined');
            });
            recursionFn(intoId);
          }, !!create);
          break;
        case AST.CallExpression:
          intoId = intoId || this.nextId();
          if (ast.filter) {
            right = self.filter(ast.callee.name);
            args = [];
            forEach(ast.arguments, function (expr) {
              var argument = self.nextId();
              self.recurse(expr, argument);
              args.push(argument);
            });
            expression = right + '(' + args.join(',') + ')';
            self.assign(intoId, expression);
            recursionFn(intoId);
          } else {
            right = self.nextId();
            left = {};
            args = [];
            self.recurse(ast.callee, right, left, function () {
              self.if_(self.notNull(right), function () {
                forEach(ast.arguments, function (expr) {
                  self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function (argument) {
                    args.push(argument);
                  });
                });
                if (left.name) {
                  expression = self.member(left.context, left.name, left.computed) + '(' + args.join(',') + ')';
                } else {
                  expression = right + '(' + args.join(',') + ')';
                }
                self.assign(intoId, expression);
              }, function () {
                self.assign(intoId, 'undefined');
              });
              recursionFn(intoId);
            });
          }
          break;
        case AST.AssignmentExpression:
          right = this.nextId();
          left = {};
          this.recurse(ast.left, undefined, left, function () {
            self.if_(self.notNull(left.context), function () {
              self.recurse(ast.right, right);
              expression = self.member(left.context, left.name, left.computed) + ast.operator + right;
              self.assign(intoId, expression);
              recursionFn(intoId || expression);
            });
          }, 1);
          break;
        case AST.ArrayExpression:
          args = [];
          forEach(ast.elements, function (expr) {
            self.recurse(expr, ast.constant ? undefined : self.nextId(), undefined, function (argument) {
              args.push(argument);
            });
          });
          expression = '[' + args.join(',') + ']';
          this.assign(intoId, expression);
          recursionFn(intoId || expression);
          break;
        case AST.ObjectExpression:
          args = [];
          computed = false;
          forEach(ast.properties, function (property) {
            if (property.computed) {
              computed = true;
            }
          });
          if (computed) {
            intoId = intoId || this.nextId();
            this.assign(intoId, '{}');
            forEach(ast.properties, function (property) {
              if (property.computed) {
                left = self.nextId();
                self.recurse(property.key, left);
              } else {
                left = property.key.type === AST.Identifier ? property.key.name : '' + property.key.value;
              }
              right = self.nextId();
              self.recurse(property.value, right);
              self.assign(self.member(intoId, left, property.computed), right);
            });
          } else {
            forEach(ast.properties, function (property) {
              self.recurse(property.value, ast.constant ? undefined : self.nextId(), undefined, function (expr) {
                args.push(self.escape(property.key.type === AST.Identifier ? property.key.name : '' + property.key.value) + ':' + expr);
              });
            });
            expression = '{' + args.join(',') + '}';
            this.assign(intoId, expression);
          }
          recursionFn(intoId || expression);
          break;
        case AST.ThisExpression:
          this.assign(intoId, 's');
          recursionFn(intoId || 's');
          break;
        case AST.LocalsExpression:
          this.assign(intoId, 'l');
          recursionFn(intoId || 'l');
          break;
        case AST.NGValueParameter:
          this.assign(intoId, 'v');
          recursionFn(intoId || 'v');
          break;
      }
    },
    getHasOwnProperty: function getHasOwnProperty(element, property) {
      var key = element + '.' + property;
      var own = this.current().own;
      if (!own.hasOwnProperty(key)) {
        own[key] = this.nextId(false, element + '&&(' + this.escape(property) + ' in ' + element + ')');
      }
      return own[key];
    },
    assign: function assign(id, value) {
      if (!id) return;
      this.current().body.push(id, '=', value, ';');
      return id;
    },
    filter: function filter(filterName) {
      if (!this.state.filters.hasOwnProperty(filterName)) {
        this.state.filters[filterName] = this.nextId(true);
      }
      return this.state.filters[filterName];
    },
    ifDefined: function ifDefined(id, defaultValue) {
      return 'ifDefined(' + id + ',' + this.escape(defaultValue) + ')';
    },
    plus: function plus(left, right) {
      return 'plus(' + left + ',' + right + ')';
    },
    return_: function return_(id) {
      this.current().body.push('return ', id, ';');
    },
    if_: function if_(test, alternate, consequent) {
      if (test === true) {
        alternate();
      } else {
        var body = this.current().body;
        body.push('if(', test, '){');
        alternate();
        body.push('}');
        if (consequent) {
          body.push('else{');
          consequent();
          body.push('}');
        }
      }
    },
    not: function not(expression) {
      return '!(' + expression + ')';
    },
    isNull: function isNull(expression) {
      return expression + '==null';
    },
    notNull: function notNull(expression) {
      return expression + '!=null';
    },
    nonComputedMember: function nonComputedMember(left, right) {
      var SAFE_IDENTIFIER = /^[$_a-zA-Z][$_a-zA-Z0-9]*$/;
      var UNSAFE_CHARACTERS = /[^$_a-zA-Z0-9]/g;
      if (SAFE_IDENTIFIER.test(right)) {
        return left + '.' + right;
      } else {
        return left + '["' + right.replace(UNSAFE_CHARACTERS, this.stringEscapeFn) + '"]';
      }
    },
    computedMember: function computedMember(left, right) {
      return left + '[' + right + ']';
    },
    member: function member(left, right, computed) {
      if (computed) return this.computedMember(left, right);
      return this.nonComputedMember(left, right);
    },
    getStringValue: function getStringValue(item) {
      this.assign(item, 'getStringValue(' + item + ')');
    },
    lazyRecurse: function lazyRecurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck) {
      var self = this;
      return function () {
        self.recurse(ast, intoId, nameId, recursionFn, create, skipWatchIdCheck);
      };
    },
    lazyAssign: function lazyAssign(id, value) {
      var self = this;
      return function () {
        self.assign(id, value);
      };
    },
    stringEscapeRegex: /[^ a-zA-Z0-9]/g,
    stringEscapeFn: function stringEscapeFn(c) {
      return "\\u" + ('0000' + c.charCodeAt(0).toString(16)).slice(-4);
    },
    escape: function escape(value) {
      if (isString(value)) return '\'' + value.replace(this.stringEscapeRegex, this.stringEscapeFn) + '\'';
      if (isNumber(value)) return value.toString();
      if (value === true) return 'true';
      if (value === false) return 'false';
      if (value === null) return 'null';
      if (typeof value === 'undefined') return 'undefined';
      throw $parseMinErr('esc', 'IMPOSSIBLE');
    },
    nextId: function nextId(skip, init) {
      var id = 'v' + this.state.nextId++;
      if (!skip) {
        this.current().vars.push(id + (init ? '=' + init : ''));
      }
      return id;
    },
    current: function current() {
      return this.state[this.state.computing];
    }
  };
  function ASTInterpreter($filter) {
    this.$filter = $filter;
  }
  ASTInterpreter.prototype = {
    compile: function compile(ast) {
      var self = this;
      findConstantAndWatchExpressions(ast, self.$filter);
      var assignable;
      var assign;
      if (assignable = assignableAST(ast)) {
        assign = this.recurse(assignable);
      }
      var toWatch = getInputs(ast.body);
      var inputs;
      if (toWatch) {
        inputs = [];
        forEach(toWatch, function (watch, key) {
          var input = self.recurse(watch);
          input.isPure = watch.isPure;
          watch.input = input;
          inputs.push(input);
          watch.watchId = key;
        });
      }
      var expressions = [];
      forEach(ast.body, function (expression) {
        expressions.push(self.recurse(expression.expression));
      });
      var fn = ast.body.length === 0 ? noop : ast.body.length === 1 ? expressions[0] : function (scope, locals) {
        var lastValue;
        forEach(expressions, function (exp) {
          lastValue = exp(scope, locals);
        });
        return lastValue;
      };
      if (assign) {
        fn.assign = function (scope, value, locals) {
          return assign(scope, locals, value);
        };
      }
      if (inputs) {
        fn.inputs = inputs;
      }
      return fn;
    },
    recurse: function recurse(ast, context, create) {
      var left,
        right,
        self = this,
        args;
      if (ast.input) {
        return this.inputs(ast.input, ast.watchId);
      }
      switch (ast.type) {
        case AST.Literal:
          return this.value(ast.value, context);
        case AST.UnaryExpression:
          right = this.recurse(ast.argument);
          return this['unary' + ast.operator](right, context);
        case AST.BinaryExpression:
          left = this.recurse(ast.left);
          right = this.recurse(ast.right);
          return this['binary' + ast.operator](left, right, context);
        case AST.LogicalExpression:
          left = this.recurse(ast.left);
          right = this.recurse(ast.right);
          return this['binary' + ast.operator](left, right, context);
        case AST.ConditionalExpression:
          return this['ternary?:'](this.recurse(ast.test), this.recurse(ast.alternate), this.recurse(ast.consequent), context);
        case AST.Identifier:
          return self.identifier(ast.name, context, create);
        case AST.MemberExpression:
          left = this.recurse(ast.object, false, !!create);
          if (!ast.computed) {
            right = ast.property.name;
          }
          if (ast.computed) right = this.recurse(ast.property);
          return ast.computed ? this.computedMember(left, right, context, create) : this.nonComputedMember(left, right, context, create);
        case AST.CallExpression:
          args = [];
          forEach(ast.arguments, function (expr) {
            args.push(self.recurse(expr));
          });
          if (ast.filter) right = this.$filter(ast.callee.name);
          if (!ast.filter) right = this.recurse(ast.callee, true);
          return ast.filter ? function (scope, locals, assign, inputs) {
            var values = [];
            for (var i = 0; i < args.length; ++i) {
              values.push(args[i](scope, locals, assign, inputs));
            }
            var value = right.apply(undefined, values, inputs);
            return context ? {
              context: undefined,
              name: undefined,
              value: value
            } : value;
          } : function (scope, locals, assign, inputs) {
            var rhs = right(scope, locals, assign, inputs);
            var value;
            if (rhs.value != null) {
              var values = [];
              for (var i = 0; i < args.length; ++i) {
                values.push(args[i](scope, locals, assign, inputs));
              }
              value = rhs.value.apply(rhs.context, values);
            }
            return context ? {
              value: value
            } : value;
          };
        case AST.AssignmentExpression:
          left = this.recurse(ast.left, true, 1);
          right = this.recurse(ast.right);
          return function (scope, locals, assign, inputs) {
            var lhs = left(scope, locals, assign, inputs);
            var rhs = right(scope, locals, assign, inputs);
            lhs.context[lhs.name] = rhs;
            return context ? {
              value: rhs
            } : rhs;
          };
        case AST.ArrayExpression:
          args = [];
          forEach(ast.elements, function (expr) {
            args.push(self.recurse(expr));
          });
          return function (scope, locals, assign, inputs) {
            var value = [];
            for (var i = 0; i < args.length; ++i) {
              value.push(args[i](scope, locals, assign, inputs));
            }
            return context ? {
              value: value
            } : value;
          };
        case AST.ObjectExpression:
          args = [];
          forEach(ast.properties, function (property) {
            if (property.computed) {
              args.push({
                key: self.recurse(property.key),
                computed: true,
                value: self.recurse(property.value)
              });
            } else {
              args.push({
                key: property.key.type === AST.Identifier ? property.key.name : '' + property.key.value,
                computed: false,
                value: self.recurse(property.value)
              });
            }
          });
          return function (scope, locals, assign, inputs) {
            var value = {};
            for (var i = 0; i < args.length; ++i) {
              if (args[i].computed) {
                value[args[i].key(scope, locals, assign, inputs)] = args[i].value(scope, locals, assign, inputs);
              } else {
                value[args[i].key] = args[i].value(scope, locals, assign, inputs);
              }
            }
            return context ? {
              value: value
            } : value;
          };
        case AST.ThisExpression:
          return function (scope) {
            return context ? {
              value: scope
            } : scope;
          };
        case AST.LocalsExpression:
          return function (scope, locals) {
            return context ? {
              value: locals
            } : locals;
          };
        case AST.NGValueParameter:
          return function (scope, locals, assign) {
            return context ? {
              value: assign
            } : assign;
          };
      }
    },
    'unary+': function unary(argument, context) {
      return function (scope, locals, assign, inputs) {
        var arg = argument(scope, locals, assign, inputs);
        if (isDefined(arg)) {
          arg = +arg;
        } else {
          arg = 0;
        }
        return context ? {
          value: arg
        } : arg;
      };
    },
    'unary-': function unary(argument, context) {
      return function (scope, locals, assign, inputs) {
        var arg = argument(scope, locals, assign, inputs);
        if (isDefined(arg)) {
          arg = -arg;
        } else {
          arg = -0;
        }
        return context ? {
          value: arg
        } : arg;
      };
    },
    'unary!': function unary(argument, context) {
      return function (scope, locals, assign, inputs) {
        var arg = !argument(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary+': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        var arg = plusFn(lhs, rhs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary-': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs = right(scope, locals, assign, inputs);
        var arg = (isDefined(lhs) ? lhs : 0) - (isDefined(rhs) ? rhs : 0);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary*': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) * right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary/': function binary_(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) / right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary%': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) % right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary===': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) === right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary!==': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) !== right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary==': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        // eslint-disable-next-line eqeqeq
        var arg = left(scope, locals, assign, inputs) == right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary!=': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        // eslint-disable-next-line eqeqeq
        var arg = left(scope, locals, assign, inputs) != right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary<': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) < right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary>': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) > right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary<=': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) <= right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary>=': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) >= right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary&&': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) && right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'binary||': function binary(left, right, context) {
      return function (scope, locals, assign, inputs) {
        var arg = left(scope, locals, assign, inputs) || right(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    'ternary?:': function ternary(test, alternate, consequent, context) {
      return function (scope, locals, assign, inputs) {
        var arg = test(scope, locals, assign, inputs) ? alternate(scope, locals, assign, inputs) : consequent(scope, locals, assign, inputs);
        return context ? {
          value: arg
        } : arg;
      };
    },
    value: function value(_value2, context) {
      return function () {
        return context ? {
          context: undefined,
          name: undefined,
          value: _value2
        } : _value2;
      };
    },
    identifier: function identifier(name, context, create) {
      return function (scope, locals, assign, inputs) {
        var base = locals && name in locals ? locals : scope;
        if (create && create !== 1 && base && base[name] == null) {
          base[name] = {};
        }
        var value = base ? base[name] : undefined;
        if (context) {
          return {
            context: base,
            name: name,
            value: value
          };
        } else {
          return value;
        }
      };
    },
    computedMember: function computedMember(left, right, context, create) {
      return function (scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        var rhs;
        var value;
        if (lhs != null) {
          rhs = right(scope, locals, assign, inputs);
          rhs = getStringValue(rhs);
          if (create && create !== 1) {
            if (lhs && !lhs[rhs]) {
              lhs[rhs] = {};
            }
          }
          value = lhs[rhs];
        }
        if (context) {
          return {
            context: lhs,
            name: rhs,
            value: value
          };
        } else {
          return value;
        }
      };
    },
    nonComputedMember: function nonComputedMember(left, right, context, create) {
      return function (scope, locals, assign, inputs) {
        var lhs = left(scope, locals, assign, inputs);
        if (create && create !== 1) {
          if (lhs && lhs[right] == null) {
            lhs[right] = {};
          }
        }
        var value = lhs != null ? lhs[right] : undefined;
        if (context) {
          return {
            context: lhs,
            name: right,
            value: value
          };
        } else {
          return value;
        }
      };
    },
    inputs: function inputs(input, watchId) {
      return function (scope, value, locals, inputs) {
        if (inputs) return inputs[watchId];
        return input(scope, value, locals);
      };
    }
  };

  /**
   * @constructor
   */
  function Parser(lexer, $filter, options) {
    this.ast = new AST(lexer, options);
    this.astCompiler = options.csp ? new ASTInterpreter($filter) : new ASTCompiler($filter);
  }
  Parser.prototype = {
    constructor: Parser,
    parse: function parse(text) {
      var ast = this.getAst(text);
      var fn = this.astCompiler.compile(ast.ast);
      fn.literal = isLiteral(ast.ast);
      fn.constant = isConstant(ast.ast);
      fn.oneTime = ast.oneTime;
      return fn;
    },
    getAst: function getAst(exp) {
      var oneTime = false;
      exp = exp.trim();
      if (exp.charAt(0) === ':' && exp.charAt(1) === ':') {
        oneTime = true;
        exp = exp.substring(2);
      }
      return {
        ast: this.ast.ast(exp),
        oneTime: oneTime
      };
    }
  };
  function getValueOf(value) {
    return isFunction(value.valueOf) ? value.valueOf() : objectValueOf.call(value);
  }

  ///////////////////////////////////

  /**
   * @ngdoc service
   * @name $parse
   * @kind function
   *
   * @description
   *
   * Converts AngularJS {@link guide/expression expression} into a function.
   *
   * ```js
   *   var getter = $parse('user.name');
   *   var setter = getter.assign;
   *   var context = {user:{name:'AngularJS'}};
   *   var locals = {user:{name:'local'}};
   *
   *   expect(getter(context)).toEqual('AngularJS');
   *   setter(context, 'newValue');
   *   expect(context.user.name).toEqual('newValue');
   *   expect(getter(context, locals)).toEqual('local');
   * ```
   *
   *
   * @param {string} expression String expression to compile.
   * @returns {function(context, locals)} a function which represents the compiled expression:
   *
   *    * `context` – `{object}` – an object against which any expressions embedded in the strings
   *      are evaluated against (typically a scope object).
   *    * `locals` – `{object=}` – local variables context object, useful for overriding values in
   *      `context`.
   *
   *    The returned function also has the following properties:
   *      * `literal` – `{boolean}` – whether the expression's top-level node is a JavaScript
   *        literal.
   *      * `constant` – `{boolean}` – whether the expression is made entirely of JavaScript
   *        constant literals.
   *      * `assign` – `{?function(context, value)}` – if the expression is assignable, this will be
   *        set to a function to change its value on the given context.
   *
   */

  /**
   * @ngdoc provider
   * @name $parseProvider
   * @this
   *
   * @description
   * `$parseProvider` can be used for configuring the default behavior of the {@link ng.$parse $parse}
   *  service.
   */
  function $ParseProvider() {
    var cache = createMap();
    var literals = {
      'true': true,
      'false': false,
      'null': null,
      'undefined': undefined
    };
    var identStart, identContinue;

    /**
     * @ngdoc method
     * @name $parseProvider#addLiteral
     * @description
     *
     * Configure $parse service to add literal values that will be present as literal at expressions.
     *
     * @param {string} literalName Token for the literal value. The literal name value must be a valid literal name.
     * @param {*} literalValue Value for this literal. All literal values must be primitives or `undefined`.
     *
     **/
    this.addLiteral = function (literalName, literalValue) {
      literals[literalName] = literalValue;
    };

    /**
     * @ngdoc method
     * @name $parseProvider#setIdentifierFns
     *
     * @description
     *
     * Allows defining the set of characters that are allowed in AngularJS expressions. The function
     * `identifierStart` will get called to know if a given character is a valid character to be the
     * first character for an identifier. The function `identifierContinue` will get called to know if
     * a given character is a valid character to be a follow-up identifier character. The functions
     * `identifierStart` and `identifierContinue` will receive as arguments the single character to be
     * identifier and the character code point. These arguments will be `string` and `numeric`. Keep in
     * mind that the `string` parameter can be two characters long depending on the character
     * representation. It is expected for the function to return `true` or `false`, whether that
     * character is allowed or not.
     *
     * Since this function will be called extensively, keep the implementation of these functions fast,
     * as the performance of these functions have a direct impact on the expressions parsing speed.
     *
     * @param {function=} identifierStart The function that will decide whether the given character is
     *   a valid identifier start character.
     * @param {function=} identifierContinue The function that will decide whether the given character is
     *   a valid identifier continue character.
     */
    this.setIdentifierFns = function (identifierStart, identifierContinue) {
      identStart = identifierStart;
      identContinue = identifierContinue;
      return this;
    };
    this.$get = ['$filter', function ($filter) {
      var noUnsafeEval = _csp().noUnsafeEval;
      var $parseOptions = {
        csp: noUnsafeEval,
        literals: copy(literals),
        isIdentifierStart: isFunction(identStart) && identStart,
        isIdentifierContinue: isFunction(identContinue) && identContinue
      };
      $parse.$$getAst = $$getAst;
      return $parse;
      function $parse(exp, interceptorFn) {
        var parsedExpression, cacheKey;
        switch (_typeof(exp)) {
          case 'string':
            exp = exp.trim();
            cacheKey = exp;
            parsedExpression = cache[cacheKey];
            if (!parsedExpression) {
              var lexer = new Lexer($parseOptions);
              var parser = new Parser(lexer, $filter, $parseOptions);
              parsedExpression = parser.parse(exp);
              cache[cacheKey] = addWatchDelegate(parsedExpression);
            }
            return addInterceptor(parsedExpression, interceptorFn);
          case 'function':
            return addInterceptor(exp, interceptorFn);
          default:
            return addInterceptor(noop, interceptorFn);
        }
      }
      function $$getAst(exp) {
        var lexer = new Lexer($parseOptions);
        var parser = new Parser(lexer, $filter, $parseOptions);
        return parser.getAst(exp).ast;
      }
      function expressionInputDirtyCheck(newValue, oldValueOfValue, compareObjectIdentity) {
        if (newValue == null || oldValueOfValue == null) {
          // null/undefined
          return newValue === oldValueOfValue;
        }
        if (_typeof(newValue) === 'object') {
          // attempt to convert the value to a primitive type
          // TODO(docs): add a note to docs that by implementing valueOf even objects and arrays can
          //             be cheaply dirty-checked
          newValue = getValueOf(newValue);
          if (_typeof(newValue) === 'object' && !compareObjectIdentity) {
            // objects/arrays are not supported - deep-watching them would be too expensive
            return false;
          }

          // fall-through to the primitive equality check
        }

        //Primitive or NaN
        // eslint-disable-next-line no-self-compare
        return newValue === oldValueOfValue || newValue !== newValue && oldValueOfValue !== oldValueOfValue;
      }
      function inputsWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
        var inputExpressions = parsedExpression.inputs;
        var lastResult;
        if (inputExpressions.length === 1) {
          var oldInputValueOf = expressionInputDirtyCheck; // init to something unique so that equals check fails
          inputExpressions = inputExpressions[0];
          return scope.$watch(function expressionInputWatch(scope) {
            var newInputValue = inputExpressions(scope);
            if (!expressionInputDirtyCheck(newInputValue, oldInputValueOf, inputExpressions.isPure)) {
              lastResult = parsedExpression(scope, undefined, undefined, [newInputValue]);
              oldInputValueOf = newInputValue && getValueOf(newInputValue);
            }
            return lastResult;
          }, listener, objectEquality, prettyPrintExpression);
        }
        var oldInputValueOfValues = [];
        var oldInputValues = [];
        for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
          oldInputValueOfValues[i] = expressionInputDirtyCheck; // init to something unique so that equals check fails
          oldInputValues[i] = null;
        }
        return scope.$watch(function expressionInputsWatch(scope) {
          var changed = false;
          for (var i = 0, ii = inputExpressions.length; i < ii; i++) {
            var newInputValue = inputExpressions[i](scope);
            if (changed || (changed = !expressionInputDirtyCheck(newInputValue, oldInputValueOfValues[i], inputExpressions[i].isPure))) {
              oldInputValues[i] = newInputValue;
              oldInputValueOfValues[i] = newInputValue && getValueOf(newInputValue);
            }
          }
          if (changed) {
            lastResult = parsedExpression(scope, undefined, undefined, oldInputValues);
          }
          return lastResult;
        }, listener, objectEquality, prettyPrintExpression);
      }
      function oneTimeWatchDelegate(scope, listener, objectEquality, parsedExpression, prettyPrintExpression) {
        var isDone = parsedExpression.literal ? isAllDefined : isDefined;
        var unwatch, lastValue;
        var exp = parsedExpression.$$intercepted || parsedExpression;
        var post = parsedExpression.$$interceptor || identity;
        var useInputs = parsedExpression.inputs && !exp.inputs;

        // Propogate the literal/inputs/constant attributes
        // ... but not oneTime since we are handling it
        oneTimeWatch.literal = parsedExpression.literal;
        oneTimeWatch.constant = parsedExpression.constant;
        oneTimeWatch.inputs = parsedExpression.inputs;

        // Allow other delegates to run on this wrapped expression
        addWatchDelegate(oneTimeWatch);
        unwatch = scope.$watch(oneTimeWatch, listener, objectEquality, prettyPrintExpression);
        return unwatch;
        function unwatchIfDone() {
          if (isDone(lastValue)) {
            unwatch();
          }
        }
        function oneTimeWatch(scope, locals, assign, inputs) {
          lastValue = useInputs && inputs ? inputs[0] : exp(scope, locals, assign, inputs);
          if (isDone(lastValue)) {
            scope.$$postDigest(unwatchIfDone);
          }
          return post(lastValue);
        }
      }
      function isAllDefined(value) {
        var allDefined = true;
        forEach(value, function (val) {
          if (!isDefined(val)) allDefined = false;
        });
        return allDefined;
      }
      function constantWatchDelegate(scope, listener, objectEquality, parsedExpression) {
        var unwatch = scope.$watch(function constantWatch(scope) {
          unwatch();
          return parsedExpression(scope);
        }, listener, objectEquality);
        return unwatch;
      }
      function addWatchDelegate(parsedExpression) {
        if (parsedExpression.constant) {
          parsedExpression.$$watchDelegate = constantWatchDelegate;
        } else if (parsedExpression.oneTime) {
          parsedExpression.$$watchDelegate = oneTimeWatchDelegate;
        } else if (parsedExpression.inputs) {
          parsedExpression.$$watchDelegate = inputsWatchDelegate;
        }
        return parsedExpression;
      }
      function chainInterceptors(first, second) {
        function chainedInterceptor(value) {
          return second(first(value));
        }
        chainedInterceptor.$stateful = first.$stateful || second.$stateful;
        chainedInterceptor.$$pure = first.$$pure && second.$$pure;
        return chainedInterceptor;
      }
      function addInterceptor(parsedExpression, interceptorFn) {
        if (!interceptorFn) return parsedExpression;

        // Extract any existing interceptors out of the parsedExpression
        // to ensure the original parsedExpression is always the $$intercepted
        if (parsedExpression.$$interceptor) {
          interceptorFn = chainInterceptors(parsedExpression.$$interceptor, interceptorFn);
          parsedExpression = parsedExpression.$$intercepted;
        }
        var useInputs = false;
        var fn = function interceptedExpression(scope, locals, assign, inputs) {
          var value = useInputs && inputs ? inputs[0] : parsedExpression(scope, locals, assign, inputs);
          return interceptorFn(value);
        };

        // Maintain references to the interceptor/intercepted
        fn.$$intercepted = parsedExpression;
        fn.$$interceptor = interceptorFn;

        // Propogate the literal/oneTime/constant attributes
        fn.literal = parsedExpression.literal;
        fn.oneTime = parsedExpression.oneTime;
        fn.constant = parsedExpression.constant;

        // Treat the interceptor like filters.
        // If it is not $stateful then only watch its inputs.
        // If the expression itself has no inputs then use the full expression as an input.
        if (!interceptorFn.$stateful) {
          useInputs = !parsedExpression.inputs;
          fn.inputs = parsedExpression.inputs ? parsedExpression.inputs : [parsedExpression];
          if (!interceptorFn.$$pure) {
            fn.inputs = fn.inputs.map(function (e) {
              // Remove the isPure flag of inputs when it is not absolute because they are now wrapped in a
              // non-pure interceptor function.
              if (e.isPure === PURITY_RELATIVE) {
                return function depurifier(s) {
                  return e(s);
                };
              }
              return e;
            });
          }
        }
        return addWatchDelegate(fn);
      }
    }];
  }

  /**
   * @ngdoc service
   * @name $q
   * @requires $rootScope
   *
   * @description
   * A service that helps you run functions asynchronously, and use their return values (or exceptions)
   * when they are done processing.
   *
   * This is a [Promises/A+](https://promisesaplus.com/)-compliant implementation of promises/deferred
   * objects inspired by [Kris Kowal's Q](https://github.com/kriskowal/q).
   *
   * $q can be used in two fashions --- one which is more similar to Kris Kowal's Q or jQuery's Deferred
   * implementations, and the other which resembles ES6 (ES2015) promises to some degree.
   *
   * ## $q constructor
   *
   * The streamlined ES6 style promise is essentially just using $q as a constructor which takes a `resolver`
   * function as the first argument. This is similar to the native Promise implementation from ES6,
   * see [MDN](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Promise).
   *
   * While the constructor-style use is supported, not all of the supporting methods from ES6 promises are
   * available yet.
   *
   * It can be used like so:
   *
   * ```js
   *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
   *   // are available in the current lexical scope (they could have been injected or passed in).
   *
   *   function asyncGreet(name) {
   *     // perform some asynchronous operation, resolve or reject the promise when appropriate.
   *     return $q(function(resolve, reject) {
   *       setTimeout(function() {
   *         if (okToGreet(name)) {
   *           resolve('Hello, ' + name + '!');
   *         } else {
   *           reject('Greeting ' + name + ' is not allowed.');
   *         }
   *       }, 1000);
   *     });
   *   }
   *
   *   var promise = asyncGreet('Robin Hood');
   *   promise.then(function(greeting) {
   *     alert('Success: ' + greeting);
   *   }, function(reason) {
   *     alert('Failed: ' + reason);
   *   });
   * ```
   *
   * Note: progress/notify callbacks are not currently supported via the ES6-style interface.
   *
   * Note: unlike ES6 behavior, an exception thrown in the constructor function will NOT implicitly reject the promise.
   *
   * However, the more traditional CommonJS-style usage is still available, and documented below.
   *
   * [The CommonJS Promise proposal](http://wiki.commonjs.org/wiki/Promises) describes a promise as an
   * interface for interacting with an object that represents the result of an action that is
   * performed asynchronously, and may or may not be finished at any given point in time.
   *
   * From the perspective of dealing with error handling, deferred and promise APIs are to
   * asynchronous programming what `try`, `catch` and `throw` keywords are to synchronous programming.
   *
   * ```js
   *   // for the purpose of this example let's assume that variables `$q` and `okToGreet`
   *   // are available in the current lexical scope (they could have been injected or passed in).
   *
   *   function asyncGreet(name) {
   *     var deferred = $q.defer();
   *
   *     setTimeout(function() {
   *       deferred.notify('About to greet ' + name + '.');
   *
   *       if (okToGreet(name)) {
   *         deferred.resolve('Hello, ' + name + '!');
   *       } else {
   *         deferred.reject('Greeting ' + name + ' is not allowed.');
   *       }
   *     }, 1000);
   *
   *     return deferred.promise;
   *   }
   *
   *   var promise = asyncGreet('Robin Hood');
   *   promise.then(function(greeting) {
   *     alert('Success: ' + greeting);
   *   }, function(reason) {
   *     alert('Failed: ' + reason);
   *   }, function(update) {
   *     alert('Got notification: ' + update);
   *   });
   * ```
   *
   * At first it might not be obvious why this extra complexity is worth the trouble. The payoff
   * comes in the way of guarantees that promise and deferred APIs make, see
   * https://github.com/kriskowal/uncommonjs/blob/master/promises/specification.md.
   *
   * Additionally the promise api allows for composition that is very hard to do with the
   * traditional callback ([CPS](http://en.wikipedia.org/wiki/Continuation-passing_style)) approach.
   * For more on this please see the [Q documentation](https://github.com/kriskowal/q) especially the
   * section on serial or parallel joining of promises.
   *
   * ## The Deferred API
   *
   * A new instance of deferred is constructed by calling `$q.defer()`.
   *
   * The purpose of the deferred object is to expose the associated Promise instance as well as APIs
   * that can be used for signaling the successful or unsuccessful completion, as well as the status
   * of the task.
   *
   * **Methods**
   *
   * - `resolve(value)` – resolves the derived promise with the `value`. If the value is a rejection
   *   constructed via `$q.reject`, the promise will be rejected instead.
   * - `reject(reason)` – rejects the derived promise with the `reason`. This is equivalent to
   *   resolving it with a rejection constructed via `$q.reject`.
   * - `notify(value)` - provides updates on the status of the promise's execution. This may be called
   *   multiple times before the promise is either resolved or rejected.
   *
   * **Properties**
   *
   * - promise – `{Promise}` – promise object associated with this deferred.
   *
   *
   * ## The Promise API
   *
   * A new promise instance is created when a deferred instance is created and can be retrieved by
   * calling `deferred.promise`.
   *
   * The purpose of the promise object is to allow for interested parties to get access to the result
   * of the deferred task when it completes.
   *
   * **Methods**
   *
   * - `then(successCallback, [errorCallback], [notifyCallback])` – regardless of when the promise was or
   *   will be resolved or rejected, `then` calls one of the success or error callbacks asynchronously
   *   as soon as the result is available. The callbacks are called with a single argument: the result
   *   or rejection reason. Additionally, the notify callback may be called zero or more times to
   *   provide a progress indication, before the promise is resolved or rejected.
   *
   *   This method *returns a new promise* which is resolved or rejected via the return value of the
   *   `successCallback`, `errorCallback` (unless that value is a promise, in which case it is resolved
   *   with the value which is resolved in that promise using
   *   [promise chaining](http://www.html5rocks.com/en/tutorials/es6/promises/#toc-promises-queues)).
   *   It also notifies via the return value of the `notifyCallback` method. The promise cannot be
   *   resolved or rejected from the notifyCallback method. The errorCallback and notifyCallback
   *   arguments are optional.
   *
   * - `catch(errorCallback)` – shorthand for `promise.then(null, errorCallback)`
   *
   * - `finally(callback, notifyCallback)` – allows you to observe either the fulfillment or rejection of a promise,
   *   but to do so without modifying the final value. This is useful to release resources or do some
   *   clean-up that needs to be done whether the promise was rejected or resolved. See the [full
   *   specification](https://github.com/kriskowal/q/wiki/API-Reference#promisefinallycallback) for
   *   more information.
   *
   * ## Chaining promises
   *
   * Because calling the `then` method of a promise returns a new derived promise, it is easily
   * possible to create a chain of promises:
   *
   * ```js
   *   promiseB = promiseA.then(function(result) {
   *     return result + 1;
   *   });
   *
   *   // promiseB will be resolved immediately after promiseA is resolved and its value
   *   // will be the result of promiseA incremented by 1
   * ```
   *
   * It is possible to create chains of any length and since a promise can be resolved with another
   * promise (which will defer its resolution further), it is possible to pause/defer resolution of
   * the promises at any point in the chain. This makes it possible to implement powerful APIs like
   * $http's response interceptors.
   *
   *
   * ## Differences between Kris Kowal's Q and $q
   *
   *  There are two main differences:
   *
   * - $q is integrated with the {@link ng.$rootScope.Scope} Scope model observation
   *   mechanism in AngularJS, which means faster propagation of resolution or rejection into your
   *   models and avoiding unnecessary browser repaints, which would result in flickering UI.
   * - Q has many more features than $q, but that comes at a cost of bytes. $q is tiny, but contains
   *   all the important functionality needed for common async tasks.
   *
   * ## Testing
   *
   *  ```js
   *    it('should simulate promise', inject(function($q, $rootScope) {
   *      var deferred = $q.defer();
   *      var promise = deferred.promise;
   *      var resolvedValue;
   *
   *      promise.then(function(value) { resolvedValue = value; });
   *      expect(resolvedValue).toBeUndefined();
   *
   *      // Simulate resolving of promise
   *      deferred.resolve(123);
   *      // Note that the 'then' function does not get called synchronously.
   *      // This is because we want the promise API to always be async, whether or not
   *      // it got called synchronously or asynchronously.
   *      expect(resolvedValue).toBeUndefined();
   *
   *      // Propagate promise resolution to 'then' functions using $apply().
   *      $rootScope.$apply();
   *      expect(resolvedValue).toEqual(123);
   *    }));
   *  ```
   *
   * @param {function(function, function)} resolver Function which is responsible for resolving or
   *   rejecting the newly created promise. The first parameter is a function which resolves the
   *   promise, the second parameter is a function which rejects the promise.
   *
   * @returns {Promise} The newly created promise.
   */
  /**
   * @ngdoc provider
   * @name $qProvider
   * @this
   *
   * @description
   */
  function $QProvider() {
    var errorOnUnhandledRejections = true;
    this.$get = ['$rootScope', '$exceptionHandler', function ($rootScope, $exceptionHandler) {
      return qFactory(function (callback) {
        $rootScope.$evalAsync(callback);
      }, $exceptionHandler, errorOnUnhandledRejections);
    }];

    /**
     * @ngdoc method
     * @name $qProvider#errorOnUnhandledRejections
     * @kind function
     *
     * @description
     * Retrieves or overrides whether to generate an error when a rejected promise is not handled.
     * This feature is enabled by default.
     *
     * @param {boolean=} value Whether to generate an error when a rejected promise is not handled.
     * @returns {boolean|ng.$qProvider} Current value when called without a new value or self for
     *    chaining otherwise.
     */
    this.errorOnUnhandledRejections = function (value) {
      if (isDefined(value)) {
        errorOnUnhandledRejections = value;
        return this;
      } else {
        return errorOnUnhandledRejections;
      }
    };
  }

  /** @this */
  function $$QProvider() {
    var errorOnUnhandledRejections = true;
    this.$get = ['$browser', '$exceptionHandler', function ($browser, $exceptionHandler) {
      return qFactory(function (callback) {
        $browser.defer(callback);
      }, $exceptionHandler, errorOnUnhandledRejections);
    }];
    this.errorOnUnhandledRejections = function (value) {
      if (isDefined(value)) {
        errorOnUnhandledRejections = value;
        return this;
      } else {
        return errorOnUnhandledRejections;
      }
    };
  }

  /**
   * Constructs a promise manager.
   *
   * @param {function(function)} nextTick Function for executing functions in the next turn.
   * @param {function(...*)} exceptionHandler Function into which unexpected exceptions are passed for
   *     debugging purposes.
   * @param {boolean=} errorOnUnhandledRejections Whether an error should be generated on unhandled
   *     promises rejections.
   * @returns {object} Promise manager.
   */
  function qFactory(nextTick, exceptionHandler, errorOnUnhandledRejections) {
    var $qMinErr = minErr('$q', TypeError);
    var queueSize = 0;
    var checkQueue = [];

    /**
     * @ngdoc method
     * @name ng.$q#defer
     * @kind function
     *
     * @description
     * Creates a `Deferred` object which represents a task which will finish in the future.
     *
     * @returns {Deferred} Returns a new instance of deferred.
     */
    function defer() {
      return new Deferred();
    }
    function Deferred() {
      var promise = this.promise = new Promise();
      //Non prototype methods necessary to support unbound execution :/
      this.resolve = function (val) {
        resolvePromise(promise, val);
      };
      this.reject = function (reason) {
        rejectPromise(promise, reason);
      };
      this.notify = function (progress) {
        notifyPromise(promise, progress);
      };
    }
    function Promise() {
      this.$$state = {
        status: 0
      };
    }
    extend(Promise.prototype, {
      then: function then(onFulfilled, onRejected, progressBack) {
        if (isUndefined(onFulfilled) && isUndefined(onRejected) && isUndefined(progressBack)) {
          return this;
        }
        var result = new Promise();
        this.$$state.pending = this.$$state.pending || [];
        this.$$state.pending.push([result, onFulfilled, onRejected, progressBack]);
        if (this.$$state.status > 0) scheduleProcessQueue(this.$$state);
        return result;
      },
      'catch': function _catch(callback) {
        return this.then(null, callback);
      },
      'finally': function _finally(callback, progressBack) {
        return this.then(function (value) {
          return handleCallback(value, resolve, callback);
        }, function (error) {
          return handleCallback(error, reject, callback);
        }, progressBack);
      }
    });
    function processQueue(state) {
      var fn, promise, pending;
      pending = state.pending;
      state.processScheduled = false;
      state.pending = undefined;
      try {
        for (var i = 0, ii = pending.length; i < ii; ++i) {
          markQStateExceptionHandled(state);
          promise = pending[i][0];
          fn = pending[i][state.status];
          try {
            if (isFunction(fn)) {
              resolvePromise(promise, fn(state.value));
            } else if (state.status === 1) {
              resolvePromise(promise, state.value);
            } else {
              rejectPromise(promise, state.value);
            }
          } catch (e) {
            rejectPromise(promise, e);
            // This error is explicitly marked for being passed to the $exceptionHandler
            if (e && e.$$passToExceptionHandler === true) {
              exceptionHandler(e);
            }
          }
        }
      } finally {
        --queueSize;
        if (errorOnUnhandledRejections && queueSize === 0) {
          nextTick(processChecks);
        }
      }
    }
    function processChecks() {
      // eslint-disable-next-line no-unmodified-loop-condition
      while (!queueSize && checkQueue.length) {
        var toCheck = checkQueue.shift();
        if (!isStateExceptionHandled(toCheck)) {
          markQStateExceptionHandled(toCheck);
          var errorMessage = 'Possibly unhandled rejection: ' + toDebugString(toCheck.value);
          if (isError(toCheck.value)) {
            exceptionHandler(toCheck.value, errorMessage);
          } else {
            exceptionHandler(errorMessage);
          }
        }
      }
    }
    function scheduleProcessQueue(state) {
      if (errorOnUnhandledRejections && !state.pending && state.status === 2 && !isStateExceptionHandled(state)) {
        if (queueSize === 0 && checkQueue.length === 0) {
          nextTick(processChecks);
        }
        checkQueue.push(state);
      }
      if (state.processScheduled || !state.pending) return;
      state.processScheduled = true;
      ++queueSize;
      nextTick(function () {
        processQueue(state);
      });
    }
    function resolvePromise(promise, val) {
      if (promise.$$state.status) return;
      if (val === promise) {
        $$reject(promise, $qMinErr('qcycle', 'Expected promise to be resolved with value other than itself \'{0}\'', val));
      } else {
        $$resolve(promise, val);
      }
    }
    function $$resolve(promise, val) {
      var then;
      var done = false;
      try {
        if (isObject(val) || isFunction(val)) then = val.then;
        if (isFunction(then)) {
          promise.$$state.status = -1;
          then.call(val, doResolve, doReject, doNotify);
        } else {
          promise.$$state.value = val;
          promise.$$state.status = 1;
          scheduleProcessQueue(promise.$$state);
        }
      } catch (e) {
        doReject(e);
      }
      function doResolve(val) {
        if (done) return;
        done = true;
        $$resolve(promise, val);
      }
      function doReject(val) {
        if (done) return;
        done = true;
        $$reject(promise, val);
      }
      function doNotify(progress) {
        notifyPromise(promise, progress);
      }
    }
    function rejectPromise(promise, reason) {
      if (promise.$$state.status) return;
      $$reject(promise, reason);
    }
    function $$reject(promise, reason) {
      promise.$$state.value = reason;
      promise.$$state.status = 2;
      scheduleProcessQueue(promise.$$state);
    }
    function notifyPromise(promise, progress) {
      var callbacks = promise.$$state.pending;
      if (promise.$$state.status <= 0 && callbacks && callbacks.length) {
        nextTick(function () {
          var callback, result;
          for (var i = 0, ii = callbacks.length; i < ii; i++) {
            result = callbacks[i][0];
            callback = callbacks[i][3];
            try {
              notifyPromise(result, isFunction(callback) ? callback(progress) : progress);
            } catch (e) {
              exceptionHandler(e);
            }
          }
        });
      }
    }

    /**
     * @ngdoc method
     * @name $q#reject
     * @kind function
     *
     * @description
     * Creates a promise that is resolved as rejected with the specified `reason`. This api should be
     * used to forward rejection in a chain of promises. If you are dealing with the last promise in
     * a promise chain, you don't need to worry about it.
     *
     * When comparing deferreds/promises to the familiar behavior of try/catch/throw, think of
     * `reject` as the `throw` keyword in JavaScript. This also means that if you "catch" an error via
     * a promise error callback and you want to forward the error to the promise derived from the
     * current promise, you have to "rethrow" the error by returning a rejection constructed via
     * `reject`.
     *
     * ```js
     *   promiseB = promiseA.then(function(result) {
     *     // success: do something and resolve promiseB
     *     //          with the old or a new result
     *     return result;
     *   }, function(reason) {
     *     // error: handle the error if possible and
     *     //        resolve promiseB with newPromiseOrValue,
     *     //        otherwise forward the rejection to promiseB
     *     if (canHandle(reason)) {
     *      // handle the error and recover
     *      return newPromiseOrValue;
     *     }
     *     return $q.reject(reason);
     *   });
     * ```
     *
     * @param {*} reason Constant, message, exception or an object representing the rejection reason.
     * @returns {Promise} Returns a promise that was already resolved as rejected with the `reason`.
     */
    function reject(reason) {
      var result = new Promise();
      rejectPromise(result, reason);
      return result;
    }
    function handleCallback(value, resolver, callback) {
      var callbackOutput = null;
      try {
        if (isFunction(callback)) callbackOutput = callback();
      } catch (e) {
        return reject(e);
      }
      if (isPromiseLike(callbackOutput)) {
        return callbackOutput.then(function () {
          return resolver(value);
        }, reject);
      } else {
        return resolver(value);
      }
    }

    /**
     * @ngdoc method
     * @name $q#when
     * @kind function
     *
     * @description
     * Wraps an object that might be a value or a (3rd party) then-able promise into a $q promise.
     * This is useful when you are dealing with an object that might or might not be a promise, or if
     * the promise comes from a source that can't be trusted.
     *
     * @param {*} value Value or a promise
     * @param {Function=} successCallback
     * @param {Function=} errorCallback
     * @param {Function=} progressCallback
     * @returns {Promise} Returns a promise of the passed value or promise
     */

    function when(value, callback, errback, progressBack) {
      var result = new Promise();
      resolvePromise(result, value);
      return result.then(callback, errback, progressBack);
    }

    /**
     * @ngdoc method
     * @name $q#resolve
     * @kind function
     *
     * @description
     * Alias of {@link ng.$q#when when} to maintain naming consistency with ES6.
     *
     * @param {*} value Value or a promise
     * @param {Function=} successCallback
     * @param {Function=} errorCallback
     * @param {Function=} progressCallback
     * @returns {Promise} Returns a promise of the passed value or promise
     */
    var resolve = when;

    /**
     * @ngdoc method
     * @name $q#all
     * @kind function
     *
     * @description
     * Combines multiple promises into a single promise that is resolved when all of the input
     * promises are resolved.
     *
     * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
     * @returns {Promise} Returns a single promise that will be resolved with an array/hash of values,
     *   each value corresponding to the promise at the same index/key in the `promises` array/hash.
     *   If any of the promises is resolved with a rejection, this resulting promise will be rejected
     *   with the same rejection value.
     */

    function all(promises) {
      var result = new Promise(),
        counter = 0,
        results = isArray(promises) ? [] : {};
      forEach(promises, function (promise, key) {
        counter++;
        when(promise).then(function (value) {
          results[key] = value;
          if (! --counter) resolvePromise(result, results);
        }, function (reason) {
          rejectPromise(result, reason);
        });
      });
      if (counter === 0) {
        resolvePromise(result, results);
      }
      return result;
    }

    /**
     * @ngdoc method
     * @name $q#race
     * @kind function
     *
     * @description
     * Returns a promise that resolves or rejects as soon as one of those promises
     * resolves or rejects, with the value or reason from that promise.
     *
     * @param {Array.<Promise>|Object.<Promise>} promises An array or hash of promises.
     * @returns {Promise} a promise that resolves or rejects as soon as one of the `promises`
     * resolves or rejects, with the value or reason from that promise.
     */

    function race(promises) {
      var deferred = defer();
      forEach(promises, function (promise) {
        when(promise).then(deferred.resolve, deferred.reject);
      });
      return deferred.promise;
    }
    function $Q(resolver) {
      if (!isFunction(resolver)) {
        throw $qMinErr('norslvr', 'Expected resolverFn, got \'{0}\'', resolver);
      }
      var promise = new Promise();
      function resolveFn(value) {
        resolvePromise(promise, value);
      }
      function rejectFn(reason) {
        rejectPromise(promise, reason);
      }
      resolver(resolveFn, rejectFn);
      return promise;
    }

    // Let's make the instanceof operator work for promises, so that
    // `new $q(fn) instanceof $q` would evaluate to true.
    $Q.prototype = Promise.prototype;
    $Q.defer = defer;
    $Q.reject = reject;
    $Q.when = when;
    $Q.resolve = resolve;
    $Q.all = all;
    $Q.race = race;
    return $Q;
  }
  function isStateExceptionHandled(state) {
    return !!state.pur;
  }
  function markQStateExceptionHandled(state) {
    state.pur = true;
  }
  function markQExceptionHandled(q) {
    // Built-in `$q` promises will always have a `$$state` property. This check is to allow
    // overwriting `$q` with a different promise library (e.g. Bluebird + angular-bluebird-promises).
    // (Currently, this is the only method that might be called with a promise, even if it is not
    // created by the built-in `$q`.)
    if (q.$$state) {
      markQStateExceptionHandled(q.$$state);
    }
  }

  /** @this */
  function $$RAFProvider() {
    //rAF
    this.$get = ['$window', '$timeout', function ($window, $timeout) {
      var requestAnimationFrame = $window.requestAnimationFrame || $window.webkitRequestAnimationFrame;
      var cancelAnimationFrame = $window.cancelAnimationFrame || $window.webkitCancelAnimationFrame || $window.webkitCancelRequestAnimationFrame;
      var rafSupported = !!requestAnimationFrame;
      var raf = rafSupported ? function (fn) {
        var id = requestAnimationFrame(fn);
        return function () {
          cancelAnimationFrame(id);
        };
      } : function (fn) {
        var timer = $timeout(fn, 16.66, false); // 1000 / 60 = 16.666
        return function () {
          $timeout.cancel(timer);
        };
      };
      raf.supported = rafSupported;
      return raf;
    }];
  }

  /**
   * DESIGN NOTES
   *
   * The design decisions behind the scope are heavily favored for speed and memory consumption.
   *
   * The typical use of scope is to watch the expressions, which most of the time return the same
   * value as last time so we optimize the operation.
   *
   * Closures construction is expensive in terms of speed as well as memory:
   *   - No closures, instead use prototypical inheritance for API
   *   - Internal state needs to be stored on scope directly, which means that private state is
   *     exposed as $$____ properties
   *
   * Loop operations are optimized by using while(count--) { ... }
   *   - This means that in order to keep the same order of execution as addition we have to add
   *     items to the array at the beginning (unshift) instead of at the end (push)
   *
   * Child scopes are created and removed often
   *   - Using an array would be slow since inserts in the middle are expensive; so we use linked lists
   *
   * There are fewer watches than observers. This is why you don't want the observer to be implemented
   * in the same way as watch. Watch requires return of the initialization function which is expensive
   * to construct.
   */

  /**
   * @ngdoc provider
   * @name $rootScopeProvider
   * @description
   *
   * Provider for the $rootScope service.
   */

  /**
   * @ngdoc method
   * @name $rootScopeProvider#digestTtl
   * @description
   *
   * Sets the number of `$digest` iterations the scope should attempt to execute before giving up and
   * assuming that the model is unstable.
   *
   * The current default is 10 iterations.
   *
   * In complex applications it's possible that the dependencies between `$watch`s will result in
   * several digest iterations. However if an application needs more than the default 10 digest
   * iterations for its model to stabilize then you should investigate what is causing the model to
   * continuously change during the digest.
   *
   * Increasing the TTL could have performance implications, so you should not change it without
   * proper justification.
   *
   * @param {number} limit The number of digest iterations.
   */

  /**
   * @ngdoc service
   * @name $rootScope
   * @this
   *
   * @description
   *
   * Every application has a single root {@link ng.$rootScope.Scope scope}.
   * All other scopes are descendant scopes of the root scope. Scopes provide separation
   * between the model and the view, via a mechanism for watching the model for changes.
   * They also provide event emission/broadcast and subscription facility. See the
   * {@link guide/scope developer guide on scopes}.
   */
  function $RootScopeProvider() {
    var TTL = 10;
    var $rootScopeMinErr = minErr('$rootScope');
    var lastDirtyWatch = null;
    var applyAsyncId = null;
    this.digestTtl = function (value) {
      if (arguments.length) {
        TTL = value;
      }
      return TTL;
    };
    function createChildScopeClass(parent) {
      function ChildScope() {
        this.$$watchers = this.$$nextSibling = this.$$childHead = this.$$childTail = null;
        this.$$listeners = {};
        this.$$listenerCount = {};
        this.$$watchersCount = 0;
        this.$id = nextUid();
        this.$$ChildScope = null;
        this.$$suspended = false;
      }
      ChildScope.prototype = parent;
      return ChildScope;
    }
    this.$get = ['$exceptionHandler', '$parse', '$browser', function ($exceptionHandler, $parse, $browser) {
      function destroyChildScope($event) {
        $event.currentScope.$$destroyed = true;
      }
      function cleanUpScope($scope) {
        // Support: IE 9 only
        if (msie === 9) {
          // There is a memory leak in IE9 if all child scopes are not disconnected
          // completely when a scope is destroyed. So this code will recurse up through
          // all this scopes children
          //
          // See issue https://github.com/angular/angular.js/issues/10706
          if ($scope.$$childHead) {
            cleanUpScope($scope.$$childHead);
          }
          if ($scope.$$nextSibling) {
            cleanUpScope($scope.$$nextSibling);
          }
        }

        // The code below works around IE9 and V8's memory leaks
        //
        // See:
        // - https://code.google.com/p/v8/issues/detail?id=2073#c26
        // - https://github.com/angular/angular.js/issues/6794#issuecomment-38648909
        // - https://github.com/angular/angular.js/issues/1313#issuecomment-10378451

        $scope.$parent = $scope.$$nextSibling = $scope.$$prevSibling = $scope.$$childHead = $scope.$$childTail = $scope.$root = $scope.$$watchers = null;
      }

      /**
       * @ngdoc type
       * @name $rootScope.Scope
       *
       * @description
       * A root scope can be retrieved using the {@link ng.$rootScope $rootScope} key from the
       * {@link auto.$injector $injector}. Child scopes are created using the
       * {@link ng.$rootScope.Scope#$new $new()} method. (Most scopes are created automatically when
       * compiled HTML template is executed.) See also the {@link guide/scope Scopes guide} for
       * an in-depth introduction and usage examples.
       *
       *
       * ## Inheritance
       * A scope can inherit from a parent scope, as in this example:
       * ```js
           var parent = $rootScope;
           var child = parent.$new();
            parent.salutation = "Hello";
           expect(child.salutation).toEqual('Hello');
            child.salutation = "Welcome";
           expect(child.salutation).toEqual('Welcome');
           expect(parent.salutation).toEqual('Hello');
       * ```
       *
       * When interacting with `Scope` in tests, additional helper methods are available on the
       * instances of `Scope` type. See {@link ngMock.$rootScope.Scope ngMock Scope} for additional
       * details.
       *
       *
       * @param {Object.<string, function()>=} providers Map of service factory which need to be
       *                                       provided for the current scope. Defaults to {@link ng}.
       * @param {Object.<string, *>=} instanceCache Provides pre-instantiated services which should
       *                              append/override services provided by `providers`. This is handy
       *                              when unit-testing and having the need to override a default
       *                              service.
       * @returns {Object} Newly created scope.
       *
       */
      function Scope() {
        this.$id = nextUid();
        this.$$phase = this.$parent = this.$$watchers = this.$$nextSibling = this.$$prevSibling = this.$$childHead = this.$$childTail = null;
        this.$root = this;
        this.$$destroyed = false;
        this.$$suspended = false;
        this.$$listeners = {};
        this.$$listenerCount = {};
        this.$$watchersCount = 0;
        this.$$isolateBindings = null;
      }

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$id
       *
       * @description
       * Unique scope ID (monotonically increasing) useful for debugging.
       */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$parent
       *
       * @description
       * Reference to the parent scope.
       */

      /**
       * @ngdoc property
       * @name $rootScope.Scope#$root
       *
       * @description
       * Reference to the root scope.
       */

      Scope.prototype = {
        constructor: Scope,
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$new
         * @kind function
         *
         * @description
         * Creates a new child {@link ng.$rootScope.Scope scope}.
         *
         * The parent scope will propagate the {@link ng.$rootScope.Scope#$digest $digest()} event.
         * The scope can be removed from the scope hierarchy using {@link ng.$rootScope.Scope#$destroy $destroy()}.
         *
         * {@link ng.$rootScope.Scope#$destroy $destroy()} must be called on a scope when it is
         * desired for the scope and its child scopes to be permanently detached from the parent and
         * thus stop participating in model change detection and listener notification by invoking.
         *
         * @param {boolean} isolate If true, then the scope does not prototypically inherit from the
         *         parent scope. The scope is isolated, as it can not see parent scope properties.
         *         When creating widgets, it is useful for the widget to not accidentally read parent
         *         state.
         *
         * @param {Scope} [parent=this] The {@link ng.$rootScope.Scope `Scope`} that will be the `$parent`
         *                              of the newly created scope. Defaults to `this` scope if not provided.
         *                              This is used when creating a transclude scope to correctly place it
         *                              in the scope hierarchy while maintaining the correct prototypical
         *                              inheritance.
         *
         * @returns {Object} The newly created child scope.
         *
         */
        $new: function $new(isolate, parent) {
          var child;
          parent = parent || this;
          if (isolate) {
            child = new Scope();
            child.$root = this.$root;
          } else {
            // Only create a child scope class if somebody asks for one,
            // but cache it to allow the VM to optimize lookups.
            if (!this.$$ChildScope) {
              this.$$ChildScope = createChildScopeClass(this);
            }
            child = new this.$$ChildScope();
          }
          child.$parent = parent;
          child.$$prevSibling = parent.$$childTail;
          if (parent.$$childHead) {
            parent.$$childTail.$$nextSibling = child;
            parent.$$childTail = child;
          } else {
            parent.$$childHead = parent.$$childTail = child;
          }

          // When the new scope is not isolated or we inherit from `this`, and
          // the parent scope is destroyed, the property `$$destroyed` is inherited
          // prototypically. In all other cases, this property needs to be set
          // when the parent scope is destroyed.
          // The listener needs to be added after the parent is set
          if (isolate || parent !== this) child.$on('$destroy', destroyChildScope);
          return child;
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$watch
         * @kind function
         *
         * @description
         * Registers a `listener` callback to be executed whenever the `watchExpression` changes.
         *
         * - The `watchExpression` is called on every call to {@link ng.$rootScope.Scope#$digest
         *   $digest()} and should return the value that will be watched. (`watchExpression` should not change
         *   its value when executed multiple times with the same input because it may be executed multiple
         *   times by {@link ng.$rootScope.Scope#$digest $digest()}. That is, `watchExpression` should be
         *   [idempotent](http://en.wikipedia.org/wiki/Idempotence).)
         * - The `listener` is called only when the value from the current `watchExpression` and the
         *   previous call to `watchExpression` are not equal (with the exception of the initial run,
         *   see below). Inequality is determined according to reference inequality,
         *   [strict comparison](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/Comparison_Operators)
         *    via the `!==` Javascript operator, unless `objectEquality == true`
         *   (see next point)
         * - When `objectEquality == true`, inequality of the `watchExpression` is determined
         *   according to the {@link angular.equals} function. To save the value of the object for
         *   later comparison, the {@link angular.copy} function is used. This therefore means that
         *   watching complex objects will have adverse memory and performance implications.
         * - This should not be used to watch for changes in objects that are (or contain)
         *   [File](https://developer.mozilla.org/docs/Web/API/File) objects due to limitations with {@link angular.copy `angular.copy`}.
         * - The watch `listener` may change the model, which may trigger other `listener`s to fire.
         *   This is achieved by rerunning the watchers until no changes are detected. The rerun
         *   iteration limit is 10 to prevent an infinite loop deadlock.
         *
         *
         * If you want to be notified whenever {@link ng.$rootScope.Scope#$digest $digest} is called,
         * you can register a `watchExpression` function with no `listener`. (Be prepared for
         * multiple calls to your `watchExpression` because it will execute multiple times in a
         * single {@link ng.$rootScope.Scope#$digest $digest} cycle if a change is detected.)
         *
         * After a watcher is registered with the scope, the `listener` fn is called asynchronously
         * (via {@link ng.$rootScope.Scope#$evalAsync $evalAsync}) to initialize the
         * watcher. In rare cases, this is undesirable because the listener is called when the result
         * of `watchExpression` didn't change. To detect this scenario within the `listener` fn, you
         * can compare the `newVal` and `oldVal`. If these two values are identical (`===`) then the
         * listener was called due to initialization.
         *
         *
         *
         * @example
         * ```js
             // let's assume that scope was dependency injected as the $rootScope
             var scope = $rootScope;
             scope.name = 'misko';
             scope.counter = 0;
              expect(scope.counter).toEqual(0);
             scope.$watch('name', function(newValue, oldValue) {
               scope.counter = scope.counter + 1;
             });
             expect(scope.counter).toEqual(0);
              scope.$digest();
             // the listener is always called during the first $digest loop after it was registered
             expect(scope.counter).toEqual(1);
              scope.$digest();
             // but now it will not be called unless the value changes
             expect(scope.counter).toEqual(1);
              scope.name = 'adam';
             scope.$digest();
             expect(scope.counter).toEqual(2);
                // Using a function as a watchExpression
             var food;
             scope.foodCounter = 0;
             expect(scope.foodCounter).toEqual(0);
             scope.$watch(
               // This function returns the value being watched. It is called for each turn of the $digest loop
               function() { return food; },
               // This is the change listener, called when the value returned from the above function changes
               function(newValue, oldValue) {
                 if ( newValue !== oldValue ) {
                   // Only increment the counter if the value changed
                   scope.foodCounter = scope.foodCounter + 1;
                 }
               }
             );
             // No digest has been run so the counter will be zero
             expect(scope.foodCounter).toEqual(0);
              // Run the digest but since food has not changed count will still be zero
             scope.$digest();
             expect(scope.foodCounter).toEqual(0);
              // Update food and run digest.  Now the counter will increment
             food = 'cheeseburger';
             scope.$digest();
             expect(scope.foodCounter).toEqual(1);
          * ```
         *
         *
         *
         * @param {(function()|string)} watchExpression Expression that is evaluated on each
         *    {@link ng.$rootScope.Scope#$digest $digest} cycle. A change in the return value triggers
         *    a call to the `listener`.
         *
         *    - `string`: Evaluated as {@link guide/expression expression}
         *    - `function(scope)`: called with current `scope` as a parameter.
         * @param {function(newVal, oldVal, scope)} listener Callback called whenever the value
         *    of `watchExpression` changes.
         *
         *    - `newVal` contains the current value of the `watchExpression`
         *    - `oldVal` contains the previous value of the `watchExpression`
         *    - `scope` refers to the current scope
         * @param {boolean=} [objectEquality=false] Compare for object equality using {@link angular.equals} instead of
         *     comparing for reference equality.
         * @returns {function()} Returns a deregistration function for this listener.
         */
        $watch: function $watch(watchExp, listener, objectEquality, prettyPrintExpression) {
          var get = $parse(watchExp);
          var fn = isFunction(listener) ? listener : noop;
          if (get.$$watchDelegate) {
            return get.$$watchDelegate(this, fn, objectEquality, get, watchExp);
          }
          var scope = this,
            array = scope.$$watchers,
            watcher = {
              fn: fn,
              last: initWatchVal,
              get: get,
              exp: prettyPrintExpression || watchExp,
              eq: !!objectEquality
            };
          lastDirtyWatch = null;
          if (!array) {
            array = scope.$$watchers = [];
            array.$$digestWatchIndex = -1;
          }
          // we use unshift since we use a while loop in $digest for speed.
          // the while loop reads in reverse order.
          array.unshift(watcher);
          array.$$digestWatchIndex++;
          incrementWatchersCount(this, 1);
          return function deregisterWatch() {
            var index = arrayRemove(array, watcher);
            if (index >= 0) {
              incrementWatchersCount(scope, -1);
              if (index < array.$$digestWatchIndex) {
                array.$$digestWatchIndex--;
              }
            }
            lastDirtyWatch = null;
          };
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$watchGroup
         * @kind function
         *
         * @description
         * A variant of {@link ng.$rootScope.Scope#$watch $watch()} where it watches an array of `watchExpressions`.
         * If any one expression in the collection changes the `listener` is executed.
         *
         * - The items in the `watchExpressions` array are observed via the standard `$watch` operation. Their return
         *   values are examined for changes on every call to `$digest`.
         * - The `listener` is called whenever any expression in the `watchExpressions` array changes.
         *
         * @param {Array.<string|Function(scope)>} watchExpressions Array of expressions that will be individually
         * watched using {@link ng.$rootScope.Scope#$watch $watch()}
         *
         * @param {function(newValues, oldValues, scope)} listener Callback called whenever the return value of any
         *    expression in `watchExpressions` changes
         *    The `newValues` array contains the current values of the `watchExpressions`, with the indexes matching
         *    those of `watchExpression`
         *    and the `oldValues` array contains the previous values of the `watchExpressions`, with the indexes matching
         *    those of `watchExpression`
         *    The `scope` refers to the current scope.
         * @returns {function()} Returns a de-registration function for all listeners.
         */
        $watchGroup: function $watchGroup(watchExpressions, listener) {
          var oldValues = new Array(watchExpressions.length);
          var newValues = new Array(watchExpressions.length);
          var deregisterFns = [];
          var self = this;
          var changeReactionScheduled = false;
          var firstRun = true;
          if (!watchExpressions.length) {
            // No expressions means we call the listener ASAP
            var shouldCall = true;
            self.$evalAsync(function () {
              if (shouldCall) listener(newValues, newValues, self);
            });
            return function deregisterWatchGroup() {
              shouldCall = false;
            };
          }
          if (watchExpressions.length === 1) {
            // Special case size of one
            return this.$watch(watchExpressions[0], function watchGroupAction(value, oldValue, scope) {
              newValues[0] = value;
              oldValues[0] = oldValue;
              listener(newValues, value === oldValue ? newValues : oldValues, scope);
            });
          }
          forEach(watchExpressions, function (expr, i) {
            var unwatchFn = self.$watch(expr, function watchGroupSubAction(value) {
              newValues[i] = value;
              if (!changeReactionScheduled) {
                changeReactionScheduled = true;
                self.$evalAsync(watchGroupAction);
              }
            });
            deregisterFns.push(unwatchFn);
          });
          function watchGroupAction() {
            changeReactionScheduled = false;
            try {
              if (firstRun) {
                firstRun = false;
                listener(newValues, newValues, self);
              } else {
                listener(newValues, oldValues, self);
              }
            } finally {
              for (var i = 0; i < watchExpressions.length; i++) {
                oldValues[i] = newValues[i];
              }
            }
          }
          return function deregisterWatchGroup() {
            while (deregisterFns.length) {
              deregisterFns.shift()();
            }
          };
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$watchCollection
         * @kind function
         *
         * @description
         * Shallow watches the properties of an object and fires whenever any of the properties change
         * (for arrays, this implies watching the array items; for object maps, this implies watching
         * the properties). If a change is detected, the `listener` callback is fired.
         *
         * - The `obj` collection is observed via standard $watch operation and is examined on every
         *   call to $digest() to see if any items have been added, removed, or moved.
         * - The `listener` is called whenever anything within the `obj` has changed. Examples include
         *   adding, removing, and moving items belonging to an object or array.
         *
         *
         * @example
         * ```js
            $scope.names = ['igor', 'matias', 'misko', 'james'];
            $scope.dataCount = 4;
             $scope.$watchCollection('names', function(newNames, oldNames) {
              $scope.dataCount = newNames.length;
            });
             expect($scope.dataCount).toEqual(4);
            $scope.$digest();
             //still at 4 ... no changes
            expect($scope.dataCount).toEqual(4);
             $scope.names.pop();
            $scope.$digest();
             //now there's been a change
            expect($scope.dataCount).toEqual(3);
         * ```
         *
         *
         * @param {string|function(scope)} obj Evaluated as {@link guide/expression expression}. The
         *    expression value should evaluate to an object or an array which is observed on each
         *    {@link ng.$rootScope.Scope#$digest $digest} cycle. Any shallow change within the
         *    collection will trigger a call to the `listener`.
         *
         * @param {function(newCollection, oldCollection, scope)} listener a callback function called
         *    when a change is detected.
         *    - The `newCollection` object is the newly modified data obtained from the `obj` expression
         *    - The `oldCollection` object is a copy of the former collection data.
         *      Due to performance considerations, the`oldCollection` value is computed only if the
         *      `listener` function declares two or more arguments.
         *    - The `scope` argument refers to the current scope.
         *
         * @returns {function()} Returns a de-registration function for this listener. When the
         *    de-registration function is executed, the internal watch operation is terminated.
         */
        $watchCollection: function $watchCollection(obj, listener) {
          // Mark the interceptor as
          // ... $$pure when literal since the instance will change when any input changes
          $watchCollectionInterceptor.$$pure = $parse(obj).literal;
          // ... $stateful when non-literal since we must read the state of the collection
          $watchCollectionInterceptor.$stateful = !$watchCollectionInterceptor.$$pure;
          var self = this;
          // the current value, updated on each dirty-check run
          var newValue;
          // a shallow copy of the newValue from the last dirty-check run,
          // updated to match newValue during dirty-check run
          var oldValue;
          // a shallow copy of the newValue from when the last change happened
          var veryOldValue;
          // only track veryOldValue if the listener is asking for it
          var trackVeryOldValue = listener.length > 1;
          var changeDetected = 0;
          var changeDetector = $parse(obj, $watchCollectionInterceptor);
          var internalArray = [];
          var internalObject = {};
          var initRun = true;
          var oldLength = 0;
          function $watchCollectionInterceptor(_value) {
            newValue = _value;
            var newLength, key, bothNaN, newItem, oldItem;

            // If the new value is undefined, then return undefined as the watch may be a one-time watch
            if (isUndefined(newValue)) return;
            if (!isObject(newValue)) {
              // if primitive
              if (oldValue !== newValue) {
                oldValue = newValue;
                changeDetected++;
              }
            } else if (isArrayLike(newValue)) {
              if (oldValue !== internalArray) {
                // we are transitioning from something which was not an array into array.
                oldValue = internalArray;
                oldLength = oldValue.length = 0;
                changeDetected++;
              }
              newLength = newValue.length;
              if (oldLength !== newLength) {
                // if lengths do not match we need to trigger change notification
                changeDetected++;
                oldValue.length = oldLength = newLength;
              }
              // copy the items to oldValue and look for changes.
              for (var i = 0; i < newLength; i++) {
                oldItem = oldValue[i];
                newItem = newValue[i];

                // eslint-disable-next-line no-self-compare
                bothNaN = oldItem !== oldItem && newItem !== newItem;
                if (!bothNaN && oldItem !== newItem) {
                  changeDetected++;
                  oldValue[i] = newItem;
                }
              }
            } else {
              if (oldValue !== internalObject) {
                // we are transitioning from something which was not an object into object.
                oldValue = internalObject = {};
                oldLength = 0;
                changeDetected++;
              }
              // copy the items to oldValue and look for changes.
              newLength = 0;
              for (key in newValue) {
                if (hasOwnProperty.call(newValue, key)) {
                  newLength++;
                  newItem = newValue[key];
                  oldItem = oldValue[key];
                  if (key in oldValue) {
                    // eslint-disable-next-line no-self-compare
                    bothNaN = oldItem !== oldItem && newItem !== newItem;
                    if (!bothNaN && oldItem !== newItem) {
                      changeDetected++;
                      oldValue[key] = newItem;
                    }
                  } else {
                    oldLength++;
                    oldValue[key] = newItem;
                    changeDetected++;
                  }
                }
              }
              if (oldLength > newLength) {
                // we used to have more keys, need to find them and destroy them.
                changeDetected++;
                for (key in oldValue) {
                  if (!hasOwnProperty.call(newValue, key)) {
                    oldLength--;
                    delete oldValue[key];
                  }
                }
              }
            }
            return changeDetected;
          }
          function $watchCollectionAction() {
            if (initRun) {
              initRun = false;
              listener(newValue, newValue, self);
            } else {
              listener(newValue, veryOldValue, self);
            }

            // make a copy for the next time a collection is changed
            if (trackVeryOldValue) {
              if (!isObject(newValue)) {
                //primitive
                veryOldValue = newValue;
              } else if (isArrayLike(newValue)) {
                veryOldValue = new Array(newValue.length);
                for (var i = 0; i < newValue.length; i++) {
                  veryOldValue[i] = newValue[i];
                }
              } else {
                // if object
                veryOldValue = {};
                for (var key in newValue) {
                  if (hasOwnProperty.call(newValue, key)) {
                    veryOldValue[key] = newValue[key];
                  }
                }
              }
            }
          }
          return this.$watch(changeDetector, $watchCollectionAction);
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$digest
         * @kind function
         *
         * @description
         * Processes all of the {@link ng.$rootScope.Scope#$watch watchers} of the current scope and
         * its children. Because a {@link ng.$rootScope.Scope#$watch watcher}'s listener can change
         * the model, the `$digest()` keeps calling the {@link ng.$rootScope.Scope#$watch watchers}
         * until no more listeners are firing. This means that it is possible to get into an infinite
         * loop. This function will throw `'Maximum iteration limit exceeded.'` if the number of
         * iterations exceeds 10.
         *
         * Usually, you don't call `$digest()` directly in
         * {@link ng.directive:ngController controllers} or in
         * {@link ng.$compileProvider#directive directives}.
         * Instead, you should call {@link ng.$rootScope.Scope#$apply $apply()} (typically from within
         * a {@link ng.$compileProvider#directive directive}), which will force a `$digest()`.
         *
         * If you want to be notified whenever `$digest()` is called,
         * you can register a `watchExpression` function with
         * {@link ng.$rootScope.Scope#$watch $watch()} with no `listener`.
         *
         * In unit tests, you may need to call `$digest()` to simulate the scope life cycle.
         *
         * @example
         * ```js
             var scope = ...;
             scope.name = 'misko';
             scope.counter = 0;
              expect(scope.counter).toEqual(0);
             scope.$watch('name', function(newValue, oldValue) {
               scope.counter = scope.counter + 1;
             });
             expect(scope.counter).toEqual(0);
              scope.$digest();
             // the listener is always called during the first $digest loop after it was registered
             expect(scope.counter).toEqual(1);
              scope.$digest();
             // but now it will not be called unless the value changes
             expect(scope.counter).toEqual(1);
              scope.name = 'adam';
             scope.$digest();
             expect(scope.counter).toEqual(2);
         * ```
         *
         */
        $digest: function $digest() {
          var watch,
            value,
            last,
            fn,
            get,
            watchers,
            dirty,
            ttl = TTL,
            next,
            current,
            target = asyncQueue.length ? $rootScope : this,
            watchLog = [],
            logIdx,
            asyncTask;
          beginPhase('$digest');
          // Check for changes to browser url that happened in sync before the call to $digest
          $browser.$$checkUrlChange();
          if (this === $rootScope && applyAsyncId !== null) {
            // If this is the root scope, and $applyAsync has scheduled a deferred $apply(), then
            // cancel the scheduled $apply and flush the queue of expressions to be evaluated.
            $browser.defer.cancel(applyAsyncId);
            flushApplyAsync();
          }
          lastDirtyWatch = null;
          do {
            // "while dirty" loop
            dirty = false;
            current = target;

            // It's safe for asyncQueuePosition to be a local variable here because this loop can't
            // be reentered recursively. Calling $digest from a function passed to $evalAsync would
            // lead to a '$digest already in progress' error.
            for (var asyncQueuePosition = 0; asyncQueuePosition < asyncQueue.length; asyncQueuePosition++) {
              try {
                asyncTask = asyncQueue[asyncQueuePosition];
                fn = asyncTask.fn;
                fn(asyncTask.scope, asyncTask.locals);
              } catch (e) {
                $exceptionHandler(e);
              }
              lastDirtyWatch = null;
            }
            asyncQueue.length = 0;
            traverseScopesLoop: do {
              // "traverse the scopes" loop
              if (watchers = !current.$$suspended && current.$$watchers) {
                // process our watches
                watchers.$$digestWatchIndex = watchers.length;
                while (watchers.$$digestWatchIndex--) {
                  try {
                    watch = watchers[watchers.$$digestWatchIndex];
                    // Most common watches are on primitives, in which case we can short
                    // circuit it with === operator, only when === fails do we use .equals
                    if (watch) {
                      get = watch.get;
                      if ((value = get(current)) !== (last = watch.last) && !(watch.eq ? equals(value, last) : isNumberNaN(value) && isNumberNaN(last))) {
                        dirty = true;
                        lastDirtyWatch = watch;
                        watch.last = watch.eq ? copy(value, null) : value;
                        fn = watch.fn;
                        fn(value, last === initWatchVal ? value : last, current);
                        if (ttl < 5) {
                          logIdx = 4 - ttl;
                          if (!watchLog[logIdx]) watchLog[logIdx] = [];
                          watchLog[logIdx].push({
                            msg: isFunction(watch.exp) ? 'fn: ' + (watch.exp.name || watch.exp.toString()) : watch.exp,
                            newVal: value,
                            oldVal: last
                          });
                        }
                      } else if (watch === lastDirtyWatch) {
                        // If the most recently dirty watcher is now clean, short circuit since the remaining watchers
                        // have already been tested.
                        dirty = false;
                        break traverseScopesLoop;
                      }
                    }
                  } catch (e) {
                    $exceptionHandler(e);
                  }
                }
              }

              // Insanity Warning: scope depth-first traversal
              // yes, this code is a bit crazy, but it works and we have tests to prove it!
              // this piece should be kept in sync with the traversal in $broadcast
              // (though it differs due to having the extra check for $$suspended and does not
              // check $$listenerCount)
              if (!(next = !current.$$suspended && current.$$watchersCount && current.$$childHead || current !== target && current.$$nextSibling)) {
                while (current !== target && !(next = current.$$nextSibling)) {
                  current = current.$parent;
                }
              }
            } while (current = next);

            // `break traverseScopesLoop;` takes us to here

            if ((dirty || asyncQueue.length) && !ttl--) {
              clearPhase();
              throw $rootScopeMinErr('infdig', '{0} $digest() iterations reached. Aborting!\n' + 'Watchers fired in the last 5 iterations: {1}', TTL, watchLog);
            }
          } while (dirty || asyncQueue.length);
          clearPhase();

          // postDigestQueuePosition isn't local here because this loop can be reentered recursively.
          while (postDigestQueuePosition < postDigestQueue.length) {
            try {
              postDigestQueue[postDigestQueuePosition++]();
            } catch (e) {
              $exceptionHandler(e);
            }
          }
          postDigestQueue.length = postDigestQueuePosition = 0;

          // Check for changes to browser url that happened during the $digest
          // (for which no event is fired; e.g. via `history.pushState()`)
          $browser.$$checkUrlChange();
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$suspend
         * @kind function
         *
         * @description
         * Suspend watchers of this scope subtree so that they will not be invoked during digest.
         *
         * This can be used to optimize your application when you know that running those watchers
         * is redundant.
         *
         * **Warning**
         *
         * Suspending scopes from the digest cycle can have unwanted and difficult to debug results.
         * Only use this approach if you are confident that you know what you are doing and have
         * ample tests to ensure that bindings get updated as you expect.
         *
         * Some of the things to consider are:
         *
         * * Any external event on a directive/component will not trigger a digest while the hosting
         *   scope is suspended - even if the event handler calls `$apply()` or `$rootScope.$digest()`.
         * * Transcluded content exists on a scope that inherits from outside a directive but exists
         *   as a child of the directive's containing scope. If the containing scope is suspended the
         *   transcluded scope will also be suspended, even if the scope from which the transcluded
         *   scope inherits is not suspended.
         * * Multiple directives trying to manage the suspended status of a scope can confuse each other:
         *    * A call to `$suspend()` on an already suspended scope is a no-op.
         *    * A call to `$resume()` on a non-suspended scope is a no-op.
         *    * If two directives suspend a scope, then one of them resumes the scope, the scope will no
         *      longer be suspended. This could result in the other directive believing a scope to be
         *      suspended when it is not.
         * * If a parent scope is suspended then all its descendants will be also excluded from future
         *   digests whether or not they have been suspended themselves. Note that this also applies to
         *   isolate child scopes.
         * * Calling `$digest()` directly on a descendant of a suspended scope will still run the watchers
         *   for that scope and its descendants. When digesting we only check whether the current scope is
         *   locally suspended, rather than checking whether it has a suspended ancestor.
         * * Calling `$resume()` on a scope that has a suspended ancestor will not cause the scope to be
         *   included in future digests until all its ancestors have been resumed.
         * * Resolved promises, e.g. from explicit `$q` deferreds and `$http` calls, trigger `$apply()`
         *   against the `$rootScope` and so will still trigger a global digest even if the promise was
         *   initiated by a component that lives on a suspended scope.
         */
        $suspend: function $suspend() {
          this.$$suspended = true;
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$isSuspended
         * @kind function
         *
         * @description
         * Call this method to determine if this scope has been explicitly suspended. It will not
         * tell you whether an ancestor has been suspended.
         * To determine if this scope will be excluded from a digest triggered at the $rootScope,
         * for example, you must check all its ancestors:
         *
         * ```
         * function isExcludedFromDigest(scope) {
         *   while(scope) {
         *     if (scope.$isSuspended()) return true;
         *     scope = scope.$parent;
         *   }
         *   return false;
         * ```
         *
         * Be aware that a scope may not be included in digests if it has a suspended ancestor,
         * even if `$isSuspended()` returns false.
         *
         * @returns true if the current scope has been suspended.
         */
        $isSuspended: function $isSuspended() {
          return this.$$suspended;
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$resume
         * @kind function
         *
         * @description
         * Resume watchers of this scope subtree in case it was suspended.
         *
         * See {@link $rootScope.Scope#$suspend} for information about the dangers of using this approach.
         */
        $resume: function $resume() {
          this.$$suspended = false;
        },
        /**
         * @ngdoc event
         * @name $rootScope.Scope#$destroy
         * @eventType broadcast on scope being destroyed
         *
         * @description
         * Broadcasted when a scope and its children are being destroyed.
         *
         * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
         * clean up DOM bindings before an element is removed from the DOM.
         */

        /**
         * @ngdoc method
         * @name $rootScope.Scope#$destroy
         * @kind function
         *
         * @description
         * Removes the current scope (and all of its children) from the parent scope. Removal implies
         * that calls to {@link ng.$rootScope.Scope#$digest $digest()} will no longer
         * propagate to the current scope and its children. Removal also implies that the current
         * scope is eligible for garbage collection.
         *
         * The `$destroy()` is usually used by directives such as
         * {@link ng.directive:ngRepeat ngRepeat} for managing the
         * unrolling of the loop.
         *
         * Just before a scope is destroyed, a `$destroy` event is broadcasted on this scope.
         * Application code can register a `$destroy` event handler that will give it a chance to
         * perform any necessary cleanup.
         *
         * Note that, in AngularJS, there is also a `$destroy` jQuery event, which can be used to
         * clean up DOM bindings before an element is removed from the DOM.
         */
        $destroy: function $destroy() {
          // We can't destroy a scope that has been already destroyed.
          if (this.$$destroyed) return;
          var parent = this.$parent;
          this.$broadcast('$destroy');
          this.$$destroyed = true;
          if (this === $rootScope) {
            //Remove handlers attached to window when $rootScope is removed
            $browser.$$applicationDestroyed();
          }
          incrementWatchersCount(this, -this.$$watchersCount);
          for (var eventName in this.$$listenerCount) {
            decrementListenerCount(this, this.$$listenerCount[eventName], eventName);
          }

          // sever all the references to parent scopes (after this cleanup, the current scope should
          // not be retained by any of our references and should be eligible for garbage collection)
          if (parent && parent.$$childHead === this) parent.$$childHead = this.$$nextSibling;
          if (parent && parent.$$childTail === this) parent.$$childTail = this.$$prevSibling;
          if (this.$$prevSibling) this.$$prevSibling.$$nextSibling = this.$$nextSibling;
          if (this.$$nextSibling) this.$$nextSibling.$$prevSibling = this.$$prevSibling;

          // Disable listeners, watchers and apply/digest methods
          this.$destroy = this.$digest = this.$apply = this.$evalAsync = this.$applyAsync = noop;
          this.$on = this.$watch = this.$watchGroup = function () {
            return noop;
          };
          this.$$listeners = {};

          // Disconnect the next sibling to prevent `cleanUpScope` destroying those too
          this.$$nextSibling = null;
          cleanUpScope(this);
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$eval
         * @kind function
         *
         * @description
         * Executes the `expression` on the current scope and returns the result. Any exceptions in
         * the expression are propagated (uncaught). This is useful when evaluating AngularJS
         * expressions.
         *
         * @example
         * ```js
             var scope = ng.$rootScope.Scope();
             scope.a = 1;
             scope.b = 2;
              expect(scope.$eval('a+b')).toEqual(3);
             expect(scope.$eval(function(scope){ return scope.a + scope.b; })).toEqual(3);
         * ```
         *
         * @param {(string|function())=} expression An AngularJS expression to be executed.
         *
         *    - `string`: execute using the rules as defined in  {@link guide/expression expression}.
         *    - `function(scope)`: execute the function with the current `scope` parameter.
         *
         * @param {(object)=} locals Local variables object, useful for overriding values in scope.
         * @returns {*} The result of evaluating the expression.
         */
        $eval: function $eval(expr, locals) {
          return $parse(expr)(this, locals);
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$evalAsync
         * @kind function
         *
         * @description
         * Executes the expression on the current scope at a later point in time.
         *
         * The `$evalAsync` makes no guarantees as to when the `expression` will be executed, only
         * that:
         *
         *   - it will execute after the function that scheduled the evaluation (preferably before DOM
         *     rendering).
         *   - at least one {@link ng.$rootScope.Scope#$digest $digest cycle} will be performed after
         *     `expression` execution.
         *
         * Any exceptions from the execution of the expression are forwarded to the
         * {@link ng.$exceptionHandler $exceptionHandler} service.
         *
         * __Note:__ if this function is called outside of a `$digest` cycle, a new `$digest` cycle
         * will be scheduled. However, it is encouraged to always call code that changes the model
         * from within an `$apply` call. That includes code evaluated via `$evalAsync`.
         *
         * @param {(string|function())=} expression An AngularJS expression to be executed.
         *
         *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
         *    - `function(scope)`: execute the function with the current `scope` parameter.
         *
         * @param {(object)=} locals Local variables object, useful for overriding values in scope.
         */
        $evalAsync: function $evalAsync(expr, locals) {
          // if we are outside of an $digest loop and this is the first time we are scheduling async
          // task also schedule async auto-flush
          if (!$rootScope.$$phase && !asyncQueue.length) {
            $browser.defer(function () {
              if (asyncQueue.length) {
                $rootScope.$digest();
              }
            }, null, '$evalAsync');
          }
          asyncQueue.push({
            scope: this,
            fn: $parse(expr),
            locals: locals
          });
        },
        $$postDigest: function $$postDigest(fn) {
          postDigestQueue.push(fn);
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$apply
         * @kind function
         *
         * @description
         * `$apply()` is used to execute an expression in AngularJS from outside of the AngularJS
         * framework. (For example from browser DOM events, setTimeout, XHR or third party libraries).
         * Because we are calling into the AngularJS framework we need to perform proper scope life
         * cycle of {@link ng.$exceptionHandler exception handling},
         * {@link ng.$rootScope.Scope#$digest executing watches}.
         *
         * **Life cycle: Pseudo-Code of `$apply()`**
         *
         * ```js
             function $apply(expr) {
               try {
                 return $eval(expr);
               } catch (e) {
                 $exceptionHandler(e);
               } finally {
                 $root.$digest();
               }
             }
         * ```
         *
         *
         * Scope's `$apply()` method transitions through the following stages:
         *
         * 1. The {@link guide/expression expression} is executed using the
         *    {@link ng.$rootScope.Scope#$eval $eval()} method.
         * 2. Any exceptions from the execution of the expression are forwarded to the
         *    {@link ng.$exceptionHandler $exceptionHandler} service.
         * 3. The {@link ng.$rootScope.Scope#$watch watch} listeners are fired immediately after the
         *    expression was executed using the {@link ng.$rootScope.Scope#$digest $digest()} method.
         *
         *
         * @param {(string|function())=} exp An AngularJS expression to be executed.
         *
         *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
         *    - `function(scope)`: execute the function with current `scope` parameter.
         *
         * @returns {*} The result of evaluating the expression.
         */
        $apply: function $apply(expr) {
          try {
            beginPhase('$apply');
            try {
              return this.$eval(expr);
            } finally {
              clearPhase();
            }
          } catch (e) {
            $exceptionHandler(e);
          } finally {
            try {
              $rootScope.$digest();
            } catch (e) {
              $exceptionHandler(e);
              // eslint-disable-next-line no-unsafe-finally
              throw e;
            }
          }
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$applyAsync
         * @kind function
         *
         * @description
         * Schedule the invocation of $apply to occur at a later time. The actual time difference
         * varies across browsers, but is typically around ~10 milliseconds.
         *
         * This can be used to queue up multiple expressions which need to be evaluated in the same
         * digest.
         *
         * @param {(string|function())=} exp An AngularJS expression to be executed.
         *
         *    - `string`: execute using the rules as defined in {@link guide/expression expression}.
         *    - `function(scope)`: execute the function with current `scope` parameter.
         */
        $applyAsync: function $applyAsync(expr) {
          var scope = this;
          if (expr) {
            applyAsyncQueue.push($applyAsyncExpression);
          }
          expr = $parse(expr);
          scheduleApplyAsync();
          function $applyAsyncExpression() {
            scope.$eval(expr);
          }
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$on
         * @kind function
         *
         * @description
         * Listens on events of a given type. See {@link ng.$rootScope.Scope#$emit $emit} for
         * discussion of event life cycle.
         *
         * The event listener function format is: `function(event, args...)`. The `event` object
         * passed into the listener has the following attributes:
         *
         *   - `targetScope` - `{Scope}`: the scope on which the event was `$emit`-ed or
         *     `$broadcast`-ed.
         *   - `currentScope` - `{Scope}`: the scope that is currently handling the event. Once the
         *     event propagates through the scope hierarchy, this property is set to null.
         *   - `name` - `{string}`: name of the event.
         *   - `stopPropagation` - `{function=}`: calling `stopPropagation` function will cancel
         *     further event propagation (available only for events that were `$emit`-ed).
         *   - `preventDefault` - `{function}`: calling `preventDefault` sets `defaultPrevented` flag
         *     to true.
         *   - `defaultPrevented` - `{boolean}`: true if `preventDefault` was called.
         *
         * @param {string} name Event name to listen on.
         * @param {function(event, ...args)} listener Function to call when the event is emitted.
         * @returns {function()} Returns a deregistration function for this listener.
         */
        $on: function $on(name, listener) {
          var namedListeners = this.$$listeners[name];
          if (!namedListeners) {
            this.$$listeners[name] = namedListeners = [];
          }
          namedListeners.push(listener);
          var current = this;
          do {
            if (!current.$$listenerCount[name]) {
              current.$$listenerCount[name] = 0;
            }
            current.$$listenerCount[name]++;
          } while (current = current.$parent);
          var self = this;
          return function () {
            var indexOfListener = namedListeners.indexOf(listener);
            if (indexOfListener !== -1) {
              // Use delete in the hope of the browser deallocating the memory for the array entry,
              // while not shifting the array indexes of other listeners.
              // See issue https://github.com/angular/angular.js/issues/16135
              delete namedListeners[indexOfListener];
              decrementListenerCount(self, 1, name);
            }
          };
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$emit
         * @kind function
         *
         * @description
         * Dispatches an event `name` upwards through the scope hierarchy notifying the
         * registered {@link ng.$rootScope.Scope#$on} listeners.
         *
         * The event life cycle starts at the scope on which `$emit` was called. All
         * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
         * notified. Afterwards, the event traverses upwards toward the root scope and calls all
         * registered listeners along the way. The event will stop propagating if one of the listeners
         * cancels it.
         *
         * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
         * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
         *
         * @param {string} name Event name to emit.
         * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
         * @return {Object} Event object (see {@link ng.$rootScope.Scope#$on}).
         */
        $emit: function $emit(name, args) {
          var empty = [],
            namedListeners,
            scope = this,
            _stopPropagation = false,
            event = {
              name: name,
              targetScope: scope,
              stopPropagation: function stopPropagation() {
                _stopPropagation = true;
              },
              preventDefault: function preventDefault() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            },
            listenerArgs = concat([event], arguments, 1),
            i,
            length;
          do {
            namedListeners = scope.$$listeners[name] || empty;
            event.currentScope = scope;
            for (i = 0, length = namedListeners.length; i < length; i++) {
              // if listeners were deregistered, defragment the array
              if (!namedListeners[i]) {
                namedListeners.splice(i, 1);
                i--;
                length--;
                continue;
              }
              try {
                //allow all listeners attached to the current scope to run
                namedListeners[i].apply(null, listenerArgs);
              } catch (e) {
                $exceptionHandler(e);
              }
            }
            //if any listener on the current scope stops propagation, prevent bubbling
            if (_stopPropagation) {
              break;
            }
            //traverse upwards
            scope = scope.$parent;
          } while (scope);
          event.currentScope = null;
          return event;
        },
        /**
         * @ngdoc method
         * @name $rootScope.Scope#$broadcast
         * @kind function
         *
         * @description
         * Dispatches an event `name` downwards to all child scopes (and their children) notifying the
         * registered {@link ng.$rootScope.Scope#$on} listeners.
         *
         * The event life cycle starts at the scope on which `$broadcast` was called. All
         * {@link ng.$rootScope.Scope#$on listeners} listening for `name` event on this scope get
         * notified. Afterwards, the event propagates to all direct and indirect scopes of the current
         * scope and calls all registered listeners along the way. The event cannot be canceled.
         *
         * Any exception emitted from the {@link ng.$rootScope.Scope#$on listeners} will be passed
         * onto the {@link ng.$exceptionHandler $exceptionHandler} service.
         *
         * @param {string} name Event name to broadcast.
         * @param {...*} args Optional one or more arguments which will be passed onto the event listeners.
         * @return {Object} Event object, see {@link ng.$rootScope.Scope#$on}
         */
        $broadcast: function $broadcast(name, args) {
          var target = this,
            current = target,
            next = target,
            event = {
              name: name,
              targetScope: target,
              preventDefault: function preventDefault() {
                event.defaultPrevented = true;
              },
              defaultPrevented: false
            };
          if (!target.$$listenerCount[name]) return event;
          var listenerArgs = concat([event], arguments, 1),
            listeners,
            i,
            length;

          //down while you can, then up and next sibling or up and next sibling until back at root
          while (current = next) {
            event.currentScope = current;
            listeners = current.$$listeners[name] || [];
            for (i = 0, length = listeners.length; i < length; i++) {
              // if listeners were deregistered, defragment the array
              if (!listeners[i]) {
                listeners.splice(i, 1);
                i--;
                length--;
                continue;
              }
              try {
                listeners[i].apply(null, listenerArgs);
              } catch (e) {
                $exceptionHandler(e);
              }
            }

            // Insanity Warning: scope depth-first traversal
            // yes, this code is a bit crazy, but it works and we have tests to prove it!
            // this piece should be kept in sync with the traversal in $digest
            // (though it differs due to having the extra check for $$listenerCount and
            // does not check $$suspended)
            if (!(next = current.$$listenerCount[name] && current.$$childHead || current !== target && current.$$nextSibling)) {
              while (current !== target && !(next = current.$$nextSibling)) {
                current = current.$parent;
              }
            }
          }
          event.currentScope = null;
          return event;
        }
      };
      var $rootScope = new Scope();

      //The internal queues. Expose them on the $rootScope for debugging/testing purposes.
      var asyncQueue = $rootScope.$$asyncQueue = [];
      var postDigestQueue = $rootScope.$$postDigestQueue = [];
      var applyAsyncQueue = $rootScope.$$applyAsyncQueue = [];
      var postDigestQueuePosition = 0;
      return $rootScope;
      function beginPhase(phase) {
        if ($rootScope.$$phase) {
          throw $rootScopeMinErr('inprog', '{0} already in progress', $rootScope.$$phase);
        }
        $rootScope.$$phase = phase;
      }
      function clearPhase() {
        $rootScope.$$phase = null;
      }
      function incrementWatchersCount(current, count) {
        do {
          current.$$watchersCount += count;
        } while (current = current.$parent);
      }
      function decrementListenerCount(current, count, name) {
        do {
          current.$$listenerCount[name] -= count;
          if (current.$$listenerCount[name] === 0) {
            delete current.$$listenerCount[name];
          }
        } while (current = current.$parent);
      }

      /**
       * function used as an initial value for watchers.
       * because it's unique we can easily tell it apart from other values
       */
      function initWatchVal() {}
      function flushApplyAsync() {
        while (applyAsyncQueue.length) {
          try {
            applyAsyncQueue.shift()();
          } catch (e) {
            $exceptionHandler(e);
          }
        }
        applyAsyncId = null;
      }
      function scheduleApplyAsync() {
        if (applyAsyncId === null) {
          applyAsyncId = $browser.defer(function () {
            $rootScope.$apply(flushApplyAsync);
          }, null, '$applyAsync');
        }
      }
    }];
  }

  /**
   * @ngdoc service
   * @name $rootElement
   *
   * @description
   * The root element of AngularJS application. This is either the element where {@link
   * ng.directive:ngApp ngApp} was declared or the element passed into
   * {@link angular.bootstrap}. The element represents the root element of application. It is also the
   * location where the application's {@link auto.$injector $injector} service gets
   * published, and can be retrieved using `$rootElement.injector()`.
   */

  // the implementation is in angular.bootstrap

  /**
   * @this
   * @description
   * Private service to sanitize uris for links and images. Used by $compile and $sanitize.
   */
  function $$SanitizeUriProvider() {
    var aHrefSanitizationTrustedUrlList = /^\s*(https?|s?ftp|mailto|tel|file):/,
      imgSrcSanitizationTrustedUrlList = /^\s*((https?|ftp|file|blob):|data:image\/)/;

    /**
     * @description
     * Retrieves or overrides the default regular expression that is used for determining trusted safe
     * urls during a[href] sanitization.
     *
     * The sanitization is a security measure aimed at prevent XSS attacks via HTML anchor links.
     *
     * Any url due to be assigned to an `a[href]` attribute via interpolation is marked as requiring
     * the $sce.URL security context. When interpolation occurs a call is made to `$sce.trustAsUrl(url)`
     * which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize the potentially malicious URL.
     *
     * If the URL matches the `aHrefSanitizationTrustedUrlList` regular expression, it is returned unchanged.
     *
     * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
     * to the DOM it is inactive and potentially malicious code will not be executed.
     *
     * @param {RegExp=} regexp New regexp to trust urls with.
     * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
     *    chaining otherwise.
     */
    this.aHrefSanitizationTrustedUrlList = function (regexp) {
      if (isDefined(regexp)) {
        aHrefSanitizationTrustedUrlList = regexp;
        return this;
      }
      return aHrefSanitizationTrustedUrlList;
    };

    /**
     * @description
     * Retrieves or overrides the default regular expression that is used for determining trusted safe
     * urls during img[src] sanitization.
     *
     * The sanitization is a security measure aimed at prevent XSS attacks via HTML image src links.
     *
     * Any URL due to be assigned to an `img[src]` attribute via interpolation is marked as requiring
     * the $sce.MEDIA_URL security context. When interpolation occurs a call is made to
     * `$sce.trustAsMediaUrl(url)` which in turn may call `$$sanitizeUri(url, isMedia)` to sanitize
     * the potentially malicious URL.
     *
     * If the URL matches the `imgSrcSanitizationTrustedUrlList` regular expression, it is returned
     * unchanged.
     *
     * If there is no match the URL is returned prefixed with `'unsafe:'` to ensure that when it is written
     * to the DOM it is inactive and potentially malicious code will not be executed.
     *
     * @param {RegExp=} regexp New regexp to trust urls with.
     * @returns {RegExp|ng.$compileProvider} Current RegExp if called without value or self for
     *    chaining otherwise.
     */
    this.imgSrcSanitizationTrustedUrlList = function (regexp) {
      if (isDefined(regexp)) {
        imgSrcSanitizationTrustedUrlList = regexp;
        return this;
      }
      return imgSrcSanitizationTrustedUrlList;
    };
    this.$get = function () {
      return function sanitizeUri(uri, isMediaUrl) {
        // if (!uri) return uri;
        var regex = isMediaUrl ? imgSrcSanitizationTrustedUrlList : aHrefSanitizationTrustedUrlList;
        var normalizedVal = urlResolve(uri && uri.trim()).href;
        if (normalizedVal !== '' && !normalizedVal.match(regex)) {
          return 'unsafe:' + normalizedVal;
        }
        return uri;
      };
    };
  }

  /* * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * *
   *     Any commits to this file should be reviewed with security in mind.  *
   *   Changes to this file can potentially create security vulnerabilities. *
   *          An approval from 2 Core members with history of modifying      *
   *                         this file is required.                          *
   *                                                                         *
   *  Does the change somehow allow for arbitrary javascript to be executed? *
   *    Or allows for someone to change the prototype of built-in objects?   *
   *     Or gives undesired access to variables likes document or window?    *
   * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * * */

  /* exported $SceProvider, $SceDelegateProvider */

  var $sceMinErr = minErr('$sce');
  var SCE_CONTEXTS = {
    // HTML is used when there's HTML rendered (e.g. ng-bind-html, iframe srcdoc binding).
    HTML: 'html',
    // Style statements or stylesheets. Currently unused in AngularJS.
    CSS: 'css',
    // An URL used in a context where it refers to the source of media, which are not expected to be run
    // as scripts, such as an image, audio, video, etc.
    MEDIA_URL: 'mediaUrl',
    // An URL used in a context where it does not refer to a resource that loads code.
    // A value that can be trusted as a URL can also trusted as a MEDIA_URL.
    URL: 'url',
    // RESOURCE_URL is a subtype of URL used where the referred-to resource could be interpreted as
    // code. (e.g. ng-include, script src binding, templateUrl)
    // A value that can be trusted as a RESOURCE_URL, can also trusted as a URL and a MEDIA_URL.
    RESOURCE_URL: 'resourceUrl',
    // Script. Currently unused in AngularJS.
    JS: 'js'
  };

  // Helper functions follow.

  var UNDERSCORE_LOWERCASE_REGEXP = /_([a-z])/g;
  function snakeToCamel(name) {
    return name.replace(UNDERSCORE_LOWERCASE_REGEXP, fnCamelCaseReplace);
  }
  function adjustMatcher(matcher) {
    if (matcher === 'self') {
      return matcher;
    } else if (isString(matcher)) {
      // Strings match exactly except for 2 wildcards - '*' and '**'.
      // '*' matches any character except those from the set ':/.?&'.
      // '**' matches any character (like .* in a RegExp).
      // More than 2 *'s raises an error as it's ill defined.
      if (matcher.indexOf('***') > -1) {
        throw $sceMinErr('iwcard', 'Illegal sequence *** in string matcher.  String: {0}', matcher);
      }
      matcher = escapeForRegexp(matcher).replace(/\\\*\\\*/g, '.*').replace(/\\\*/g, '[^:/.?&;]*');
      return new RegExp('^' + matcher + '$');
    } else if (isRegExp(matcher)) {
      // The only other type of matcher allowed is a Regexp.
      // Match entire URL / disallow partial matches.
      // Flags are reset (i.e. no global, ignoreCase or multiline)
      return new RegExp('^' + matcher.source + '$');
    } else {
      throw $sceMinErr('imatcher', 'Matchers may only be "self", string patterns or RegExp objects');
    }
  }
  function adjustMatchers(matchers) {
    var adjustedMatchers = [];
    if (isDefined(matchers)) {
      forEach(matchers, function (matcher) {
        adjustedMatchers.push(adjustMatcher(matcher));
      });
    }
    return adjustedMatchers;
  }

  /**
   * @ngdoc service
   * @name $sceDelegate
   * @kind function
   *
   * @description
   *
   * `$sceDelegate` is a service that is used by the `$sce` service to provide {@link ng.$sce Strict
   * Contextual Escaping (SCE)} services to AngularJS.
   *
   * For an overview of this service and the functionnality it provides in AngularJS, see the main
   * page for {@link ng.$sce SCE}. The current page is targeted for developers who need to alter how
   * SCE works in their application, which shouldn't be needed in most cases.
   *
   * <div class="alert alert-danger">
   * AngularJS strongly relies on contextual escaping for the security of bindings: disabling or
   * modifying this might cause cross site scripting (XSS) vulnerabilities. For libraries owners,
   * changes to this service will also influence users, so be extra careful and document your changes.
   * </div>
   *
   * Typically, you would configure or override the {@link ng.$sceDelegate $sceDelegate} instead of
   * the `$sce` service to customize the way Strict Contextual Escaping works in AngularJS.  This is
   * because, while the `$sce` provides numerous shorthand methods, etc., you really only need to
   * override 3 core functions (`trustAs`, `getTrusted` and `valueOf`) to replace the way things
   * work because `$sce` delegates to `$sceDelegate` for these operations.
   *
   * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} to configure this service.
   *
   * The default instance of `$sceDelegate` should work out of the box with little pain.  While you
   * can override it completely to change the behavior of `$sce`, the common case would
   * involve configuring the {@link ng.$sceDelegateProvider $sceDelegateProvider} instead by setting
   * your own trusted and banned resource lists for trusting URLs used for loading AngularJS resources
   * such as templates.  Refer {@link ng.$sceDelegateProvider#trustedResourceUrlList
   * $sceDelegateProvider.trustedResourceUrlList} and {@link
   * ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList}
   */

  /**
   * @ngdoc provider
   * @name $sceDelegateProvider
   * @this
   *
   * @description
   *
   * The `$sceDelegateProvider` provider allows developers to configure the {@link ng.$sceDelegate
   * $sceDelegate service}, used as a delegate for {@link ng.$sce Strict Contextual Escaping (SCE)}.
   *
   * The `$sceDelegateProvider` allows one to get/set the `trustedResourceUrlList` and
   * `bannedResourceUrlList` used to ensure that the URLs used for sourcing AngularJS templates and
   * other script-running URLs are safe (all places that use the `$sce.RESOURCE_URL` context). See
   * {@link ng.$sceDelegateProvider#trustedResourceUrlList
   * $sceDelegateProvider.trustedResourceUrlList} and
   * {@link ng.$sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider.bannedResourceUrlList},
   *
   * For the general details about this service in AngularJS, read the main page for {@link ng.$sce
   * Strict Contextual Escaping (SCE)}.
   *
   * **Example**:  Consider the following case. <a name="example"></a>
   *
   * - your app is hosted at url `http://myapp.example.com/`
   * - but some of your templates are hosted on other domains you control such as
   *   `http://srv01.assets.example.com/`, `http://srv02.assets.example.com/`, etc.
   * - and you have an open redirect at `http://myapp.example.com/clickThru?...`.
   *
   * Here is what a secure configuration for this scenario might look like:
   *
   * ```
   *  angular.module('myApp', []).config(function($sceDelegateProvider) {
   *    $sceDelegateProvider.trustedResourceUrlList([
   *      // Allow same origin resource loads.
   *      'self',
   *      // Allow loading from our assets domain.  Notice the difference between * and **.
   *      'http://srv*.assets.example.com/**'
   *    ]);
   *
   *    // The banned resource URL list overrides the trusted resource URL list so the open redirect
   *    // here is blocked.
   *    $sceDelegateProvider.bannedResourceUrlList([
   *      'http://myapp.example.com/clickThru**'
   *    ]);
   *  });
   * ```
   * Note that an empty trusted resource URL list will block every resource URL from being loaded, and will require
   * you to manually mark each one as trusted with `$sce.trustAsResourceUrl`. However, templates
   * requested by {@link ng.$templateRequest $templateRequest} that are present in
   * {@link ng.$templateCache $templateCache} will not go through this check. If you have a mechanism
   * to populate your templates in that cache at config time, then it is a good idea to remove 'self'
   * from the trusted resource URL lsit. This helps to mitigate the security impact of certain types
   * of issues, like for instance attacker-controlled `ng-includes`.
   */

  function $SceDelegateProvider() {
    this.SCE_CONTEXTS = SCE_CONTEXTS;

    // Resource URLs can also be trusted by policy.
    var trustedResourceUrlList = ['self'],
      bannedResourceUrlList = [];

    /**
     * @ngdoc method
     * @name $sceDelegateProvider#trustedResourceUrlList
     * @kind function
     *
     * @param {Array=} trustedResourceUrlList When provided, replaces the trustedResourceUrlList with
     *     the value provided.  This must be an array or null.  A snapshot of this array is used so
     *     further changes to the array are ignored.
     *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
     *     allowed in this array.
     *
     * @return {Array} The currently set trusted resource URL array.
     *
     * @description
     * Sets/Gets the list trusted of resource URLs.
     *
     * The **default value** when no `trustedResourceUrlList` has been explicitly set is `['self']`
     * allowing only same origin resource requests.
     *
     * <div class="alert alert-warning">
     * **Note:** the default `trustedResourceUrlList` of 'self' is not recommended if your app shares
     * its origin with other apps! It is a good idea to limit it to only your application's directory.
     * </div>
     */
    this.trustedResourceUrlList = function (value) {
      if (arguments.length) {
        trustedResourceUrlList = adjustMatchers(value);
      }
      return trustedResourceUrlList;
    };

    /**
     * @ngdoc method
     * @name $sceDelegateProvider#resourceUrlWhitelist
     * @kind function
     *
     * @deprecated
     * sinceVersion="1.8.1"
     *
     * This method is deprecated. Use {@link $sceDelegateProvider#trustedResourceUrlList
     * trustedResourceUrlList} instead.
     */
    Object.defineProperty(this, 'resourceUrlWhitelist', {
      get: function get() {
        return this.trustedResourceUrlList;
      },
      set: function set(value) {
        this.trustedResourceUrlList = value;
      }
    });

    /**
     * @ngdoc method
     * @name $sceDelegateProvider#bannedResourceUrlList
     * @kind function
     *
     * @param {Array=} bannedResourceUrlList When provided, replaces the `bannedResourceUrlList` with
     *     the value provided. This must be an array or null. A snapshot of this array is used so
     *     further changes to the array are ignored.</p><p>
     *     Follow {@link ng.$sce#resourceUrlPatternItem this link} for a description of the items
     *     allowed in this array.</p><p>
     *     The typical usage for the `bannedResourceUrlList` is to **block
     *     [open redirects](http://cwe.mitre.org/data/definitions/601.html)** served by your domain as
     *     these would otherwise be trusted but actually return content from the redirected domain.
     *     </p><p>
     *     Finally, **the banned resource URL list overrides the trusted resource URL list** and has
     *     the final say.
     *
     * @return {Array} The currently set `bannedResourceUrlList` array.
     *
     * @description
     * Sets/Gets the `bannedResourceUrlList` of trusted resource URLs.
     *
     * The **default value** when no trusted resource URL list has been explicitly set is the empty
     * array (i.e. there is no `bannedResourceUrlList`.)
     */
    this.bannedResourceUrlList = function (value) {
      if (arguments.length) {
        bannedResourceUrlList = adjustMatchers(value);
      }
      return bannedResourceUrlList;
    };

    /**
     * @ngdoc method
     * @name $sceDelegateProvider#resourceUrlBlacklist
     * @kind function
     *
     * @deprecated
     * sinceVersion="1.8.1"
     *
     * This method is deprecated. Use {@link $sceDelegateProvider#bannedResourceUrlList
     * bannedResourceUrlList} instead.
     */
    Object.defineProperty(this, 'resourceUrlBlacklist', {
      get: function get() {
        return this.bannedResourceUrlList;
      },
      set: function set(value) {
        this.bannedResourceUrlList = value;
      }
    });
    this.$get = ['$injector', '$$sanitizeUri', function ($injector, $$sanitizeUri) {
      var htmlSanitizer = function htmlSanitizer(html) {
        throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
      };
      if ($injector.has('$sanitize')) {
        htmlSanitizer = $injector.get('$sanitize');
      }
      function matchUrl(matcher, parsedUrl) {
        if (matcher === 'self') {
          return urlIsSameOrigin(parsedUrl) || urlIsSameOriginAsBaseUrl(parsedUrl);
        } else {
          // definitely a regex.  See adjustMatchers()
          return !!matcher.exec(parsedUrl.href);
        }
      }
      function isResourceUrlAllowedByPolicy(url) {
        var parsedUrl = urlResolve(url.toString());
        var i,
          n,
          allowed = false;
        // Ensure that at least one item from the trusted resource URL list allows this url.
        for (i = 0, n = trustedResourceUrlList.length; i < n; i++) {
          if (matchUrl(trustedResourceUrlList[i], parsedUrl)) {
            allowed = true;
            break;
          }
        }
        if (allowed) {
          // Ensure that no item from the banned resource URL list has blocked this url.
          for (i = 0, n = bannedResourceUrlList.length; i < n; i++) {
            if (matchUrl(bannedResourceUrlList[i], parsedUrl)) {
              allowed = false;
              break;
            }
          }
        }
        return allowed;
      }
      function generateHolderType(Base) {
        var holderType = function TrustedValueHolderType(trustedValue) {
          this.$$unwrapTrustedValue = function () {
            return trustedValue;
          };
        };
        if (Base) {
          holderType.prototype = new Base();
        }
        holderType.prototype.valueOf = function sceValueOf() {
          return this.$$unwrapTrustedValue();
        };
        holderType.prototype.toString = function sceToString() {
          return this.$$unwrapTrustedValue().toString();
        };
        return holderType;
      }
      var trustedValueHolderBase = generateHolderType(),
        byType = {};
      byType[SCE_CONTEXTS.HTML] = generateHolderType(trustedValueHolderBase);
      byType[SCE_CONTEXTS.CSS] = generateHolderType(trustedValueHolderBase);
      byType[SCE_CONTEXTS.MEDIA_URL] = generateHolderType(trustedValueHolderBase);
      byType[SCE_CONTEXTS.URL] = generateHolderType(byType[SCE_CONTEXTS.MEDIA_URL]);
      byType[SCE_CONTEXTS.JS] = generateHolderType(trustedValueHolderBase);
      byType[SCE_CONTEXTS.RESOURCE_URL] = generateHolderType(byType[SCE_CONTEXTS.URL]);

      /**
       * @ngdoc method
       * @name $sceDelegate#trustAs
       *
       * @description
       * Returns a trusted representation of the parameter for the specified context. This trusted
       * object will later on be used as-is, without any security check, by bindings or directives
       * that require this security context.
       * For instance, marking a string as trusted for the `$sce.HTML` context will entirely bypass
       * the potential `$sanitize` call in corresponding `$sce.HTML` bindings or directives, such as
       * `ng-bind-html`. Note that in most cases you won't need to call this function: if you have the
       * sanitizer loaded, passing the value itself will render all the HTML that does not pose a
       * security risk.
       *
       * See {@link ng.$sceDelegate#getTrusted getTrusted} for the function that will consume those
       * trusted values, and {@link ng.$sce $sce} for general documentation about strict contextual
       * escaping.
       *
       * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
       *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
       *
       * @param {*} value The value that should be considered trusted.
       * @return {*} A trusted representation of value, that can be used in the given context.
       */
      function trustAs(type, trustedValue) {
        var Constructor = byType.hasOwnProperty(type) ? byType[type] : null;
        if (!Constructor) {
          throw $sceMinErr('icontext', 'Attempted to trust a value in invalid context. Context: {0}; Value: {1}', type, trustedValue);
        }
        if (trustedValue === null || isUndefined(trustedValue) || trustedValue === '') {
          return trustedValue;
        }
        // All the current contexts in SCE_CONTEXTS happen to be strings.  In order to avoid trusting
        // mutable objects, we ensure here that the value passed in is actually a string.
        if (typeof trustedValue !== 'string') {
          throw $sceMinErr('itype', 'Attempted to trust a non-string value in a content requiring a string: Context: {0}', type);
        }
        return new Constructor(trustedValue);
      }

      /**
       * @ngdoc method
       * @name $sceDelegate#valueOf
       *
       * @description
       * If the passed parameter had been returned by a prior call to {@link ng.$sceDelegate#trustAs
       * `$sceDelegate.trustAs`}, returns the value that had been passed to {@link
       * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}.
       *
       * If the passed parameter is not a value that had been returned by {@link
       * ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}, it must be returned as-is.
       *
       * @param {*} value The result of a prior {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}
       *     call or anything else.
       * @return {*} The `value` that was originally provided to {@link ng.$sceDelegate#trustAs
       *     `$sceDelegate.trustAs`} if `value` is the result of such a call.  Otherwise, returns
       *     `value` unchanged.
       */
      function valueOf(maybeTrusted) {
        if (maybeTrusted instanceof trustedValueHolderBase) {
          return maybeTrusted.$$unwrapTrustedValue();
        } else {
          return maybeTrusted;
        }
      }

      /**
       * @ngdoc method
       * @name $sceDelegate#getTrusted
       *
       * @description
       * Given an object and a security context in which to assign it, returns a value that's safe to
       * use in this context, which was represented by the parameter. To do so, this function either
       * unwraps the safe type it has been given (for instance, a {@link ng.$sceDelegate#trustAs
       * `$sceDelegate.trustAs`} result), or it might try to sanitize the value given, depending on
       * the context and sanitizer availablility.
       *
       * The contexts that can be sanitized are $sce.MEDIA_URL, $sce.URL and $sce.HTML. The first two are available
       * by default, and the third one relies on the `$sanitize` service (which may be loaded through
       * the `ngSanitize` module). Furthermore, for $sce.RESOURCE_URL context, a plain string may be
       * accepted if the resource url policy defined by {@link ng.$sceDelegateProvider#trustedResourceUrlList
       * `$sceDelegateProvider.trustedResourceUrlList`} and {@link ng.$sceDelegateProvider#bannedResourceUrlList
       * `$sceDelegateProvider.bannedResourceUrlList`} accepts that resource.
       *
       * This function will throw if the safe type isn't appropriate for this context, or if the
       * value given cannot be accepted in the context (which might be caused by sanitization not
       * being available, or the value not being recognized as safe).
       *
       * <div class="alert alert-danger">
       * Disabling auto-escaping is extremely dangerous, it usually creates a Cross Site Scripting
       * (XSS) vulnerability in your application.
       * </div>
       *
       * @param {string} type The context in which this value is to be used (such as `$sce.HTML`).
       * @param {*} maybeTrusted The result of a prior {@link ng.$sceDelegate#trustAs
       *     `$sceDelegate.trustAs`} call, or anything else (which will not be considered trusted.)
       * @return {*} A version of the value that's safe to use in the given context, or throws an
       *     exception if this is impossible.
       */
      function getTrusted(type, maybeTrusted) {
        if (maybeTrusted === null || isUndefined(maybeTrusted) || maybeTrusted === '') {
          return maybeTrusted;
        }
        var constructor = byType.hasOwnProperty(type) ? byType[type] : null;
        // If maybeTrusted is a trusted class instance or subclass instance, then unwrap and return
        // as-is.
        if (constructor && maybeTrusted instanceof constructor) {
          return maybeTrusted.$$unwrapTrustedValue();
        }

        // If maybeTrusted is a trusted class instance but not of the correct trusted type
        // then unwrap it and allow it to pass through to the rest of the checks
        if (isFunction(maybeTrusted.$$unwrapTrustedValue)) {
          maybeTrusted = maybeTrusted.$$unwrapTrustedValue();
        }

        // If we get here, then we will either sanitize the value or throw an exception.
        if (type === SCE_CONTEXTS.MEDIA_URL || type === SCE_CONTEXTS.URL) {
          // we attempt to sanitize non-resource URLs
          return $$sanitizeUri(maybeTrusted.toString(), type === SCE_CONTEXTS.MEDIA_URL);
        } else if (type === SCE_CONTEXTS.RESOURCE_URL) {
          if (isResourceUrlAllowedByPolicy(maybeTrusted)) {
            return maybeTrusted;
          } else {
            throw $sceMinErr('insecurl', 'Blocked loading resource from url not allowed by $sceDelegate policy.  URL: {0}', maybeTrusted.toString());
          }
        } else if (type === SCE_CONTEXTS.HTML) {
          // htmlSanitizer throws its own error when no sanitizer is available.
          return htmlSanitizer(maybeTrusted);
        }
        // Default error when the $sce service has no way to make the input safe.
        throw $sceMinErr('unsafe', 'Attempting to use an unsafe value in a safe context.');
      }
      return {
        trustAs: trustAs,
        getTrusted: getTrusted,
        valueOf: valueOf
      };
    }];
  }

  /**
   * @ngdoc provider
   * @name $sceProvider
   * @this
   *
   * @description
   *
   * The $sceProvider provider allows developers to configure the {@link ng.$sce $sce} service.
   * -   enable/disable Strict Contextual Escaping (SCE) in a module
   * -   override the default implementation with a custom delegate
   *
   * Read more about {@link ng.$sce Strict Contextual Escaping (SCE)}.
   */

  /**
   * @ngdoc service
   * @name $sce
   * @kind function
   *
   * @description
   *
   * `$sce` is a service that provides Strict Contextual Escaping services to AngularJS.
   *
   * ## Strict Contextual Escaping
   *
   * Strict Contextual Escaping (SCE) is a mode in which AngularJS constrains bindings to only render
   * trusted values. Its goal is to assist in writing code in a way that (a) is secure by default, and
   * (b) makes auditing for security vulnerabilities such as XSS, clickjacking, etc. a lot easier.
   *
   * ### Overview
   *
   * To systematically block XSS security bugs, AngularJS treats all values as untrusted by default in
   * HTML or sensitive URL bindings. When binding untrusted values, AngularJS will automatically
   * run security checks on them (sanitizations, trusted URL resource, depending on context), or throw
   * when it cannot guarantee the security of the result. That behavior depends strongly on contexts:
   * HTML can be sanitized, but template URLs cannot, for instance.
   *
   * To illustrate this, consider the `ng-bind-html` directive. It renders its value directly as HTML:
   * we call that the *context*. When given an untrusted input, AngularJS will attempt to sanitize it
   * before rendering if a sanitizer is available, and throw otherwise. To bypass sanitization and
   * render the input as-is, you will need to mark it as trusted for that context before attempting
   * to bind it.
   *
   * As of version 1.2, AngularJS ships with SCE enabled by default.
   *
   * ### In practice
   *
   * Here's an example of a binding in a privileged context:
   *
   * ```
   * <input ng-model="userHtml" aria-label="User input">
   * <div ng-bind-html="userHtml"></div>
   * ```
   *
   * Notice that `ng-bind-html` is bound to `userHtml` controlled by the user.  With SCE
   * disabled, this application allows the user to render arbitrary HTML into the DIV, which would
   * be an XSS security bug. In a more realistic example, one may be rendering user comments, blog
   * articles, etc. via bindings. (HTML is just one example of a context where rendering user
   * controlled input creates security vulnerabilities.)
   *
   * For the case of HTML, you might use a library, either on the client side, or on the server side,
   * to sanitize unsafe HTML before binding to the value and rendering it in the document.
   *
   * How would you ensure that every place that used these types of bindings was bound to a value that
   * was sanitized by your library (or returned as safe for rendering by your server?)  How can you
   * ensure that you didn't accidentally delete the line that sanitized the value, or renamed some
   * properties/fields and forgot to update the binding to the sanitized value?
   *
   * To be secure by default, AngularJS makes sure bindings go through that sanitization, or
   * any similar validation process, unless there's a good reason to trust the given value in this
   * context.  That trust is formalized with a function call. This means that as a developer, you
   * can assume all untrusted bindings are safe. Then, to audit your code for binding security issues,
   * you just need to ensure the values you mark as trusted indeed are safe - because they were
   * received from your server, sanitized by your library, etc. You can organize your codebase to
   * help with this - perhaps allowing only the files in a specific directory to do this.
   * Ensuring that the internal API exposed by that code doesn't markup arbitrary values as safe then
   * becomes a more manageable task.
   *
   * In the case of AngularJS' SCE service, one uses {@link ng.$sce#trustAs $sce.trustAs}
   * (and shorthand methods such as {@link ng.$sce#trustAsHtml $sce.trustAsHtml}, etc.) to
   * build the trusted versions of your values.
   *
   * ### How does it work?
   *
   * In privileged contexts, directives and code will bind to the result of {@link ng.$sce#getTrusted
   * $sce.getTrusted(context, value)} rather than to the value directly.  Think of this function as
   * a way to enforce the required security context in your data sink. Directives use {@link
   * ng.$sce#parseAs $sce.parseAs} rather than `$parse` to watch attribute bindings, which performs
   * the {@link ng.$sce#getTrusted $sce.getTrusted} behind the scenes on non-constant literals. Also,
   * when binding without directives, AngularJS will understand the context of your bindings
   * automatically.
   *
   * As an example, {@link ng.directive:ngBindHtml ngBindHtml} uses {@link
   * ng.$sce#parseAsHtml $sce.parseAsHtml(binding expression)}.  Here's the actual code (slightly
   * simplified):
   *
   * ```
   * var ngBindHtmlDirective = ['$sce', function($sce) {
   *   return function(scope, element, attr) {
   *     scope.$watch($sce.parseAsHtml(attr.ngBindHtml), function(value) {
   *       element.html(value || '');
   *     });
   *   };
   * }];
   * ```
   *
   * ### Impact on loading templates
   *
   * This applies both to the {@link ng.directive:ngInclude `ng-include`} directive as well as
   * `templateUrl`'s specified by {@link guide/directive directives}.
   *
   * By default, AngularJS only loads templates from the same domain and protocol as the application
   * document.  This is done by calling {@link ng.$sce#getTrustedResourceUrl
   * $sce.getTrustedResourceUrl} on the template URL.  To load templates from other domains and/or
   * protocols, you may either add them to the {@link ng.$sceDelegateProvider#trustedResourceUrlList
   * trustedResourceUrlList} or {@link ng.$sce#trustAsResourceUrl wrap them} into trusted values.
   *
   * *Please note*:
   * The browser's
   * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
   * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
   * policy apply in addition to this and may further restrict whether the template is successfully
   * loaded.  This means that without the right CORS policy, loading templates from a different domain
   * won't work on all browsers.  Also, loading templates from `file://` URL does not work on some
   * browsers.
   *
   * ### This feels like too much overhead
   *
   * It's important to remember that SCE only applies to interpolation expressions.
   *
   * If your expressions are constant literals, they're automatically trusted and you don't need to
   * call `$sce.trustAs` on them (e.g.
   * `<div ng-bind-html="'<b>implicitly trusted</b>'"></div>`) just works (remember to include the
   * `ngSanitize` module). The `$sceDelegate` will also use the `$sanitize` service if it is available
   * when binding untrusted values to `$sce.HTML` context.
   * AngularJS provides an implementation in `angular-sanitize.js`, and if you
   * wish to use it, you will also need to depend on the {@link ngSanitize `ngSanitize`} module in
   * your application.
   *
   * The included {@link ng.$sceDelegate $sceDelegate} comes with sane defaults to allow you to load
   * templates in `ng-include` from your application's domain without having to even know about SCE.
   * It blocks loading templates from other domains or loading templates over http from an https
   * served document.  You can change these by setting your own custom {@link
   * ng.$sceDelegateProvider#trustedResourceUrlList trusted resource URL list} and {@link
   * ng.$sceDelegateProvider#bannedResourceUrlList banned resource URL list} for matching such URLs.
   *
   * This significantly reduces the overhead.  It is far easier to pay the small overhead and have an
   * application that's secure and can be audited to verify that with much more ease than bolting
   * security onto an application later.
   *
   * <a name="contexts"></a>
   * ### What trusted context types are supported?
   *
   * | Context             | Notes          |
   * |---------------------|----------------|
   * | `$sce.HTML`         | For HTML that's safe to source into the application.  The {@link ng.directive:ngBindHtml ngBindHtml} directive uses this context for bindings. If an unsafe value is encountered and the {@link ngSanitize $sanitize} module is present this will sanitize the value instead of throwing an error. |
   * | `$sce.CSS`          | For CSS that's safe to source into the application.  Currently unused.  Feel free to use it in your own directives. |
   * | `$sce.MEDIA_URL`    | For URLs that are safe to render as media. Is automatically converted from string by sanitizing when needed. |
   * | `$sce.URL`          | For URLs that are safe to follow as links. Is automatically converted from string by sanitizing when needed. Note that `$sce.URL` makes a stronger statement about the URL than `$sce.MEDIA_URL` does and therefore contexts requiring values trusted for `$sce.URL` can be used anywhere that values trusted for `$sce.MEDIA_URL` are required.|
   * | `$sce.RESOURCE_URL` | For URLs that are not only safe to follow as links, but whose contents are also safe to include in your application.  Examples include `ng-include`, `src` / `ngSrc` bindings for tags other than `IMG` (e.g. `IFRAME`, `OBJECT`, etc.)  <br><br>Note that `$sce.RESOURCE_URL` makes a stronger statement about the URL than `$sce.URL` or `$sce.MEDIA_URL` do and therefore contexts requiring values trusted for `$sce.RESOURCE_URL` can be used anywhere that values trusted for `$sce.URL` or `$sce.MEDIA_URL` are required. <br><br> The {@link $sceDelegateProvider#trustedResourceUrlList $sceDelegateProvider#trustedResourceUrlList()} and {@link $sceDelegateProvider#bannedResourceUrlList $sceDelegateProvider#bannedResourceUrlList()} can be used to restrict trusted origins for `RESOURCE_URL` |
   * | `$sce.JS`           | For JavaScript that is safe to execute in your application's context.  Currently unused.  Feel free to use it in your own directives. |
   *
   *
   * <div class="alert alert-warning">
   * Be aware that, before AngularJS 1.7.0, `a[href]` and `img[src]` used to sanitize their
   * interpolated values directly rather than rely upon {@link ng.$sce#getTrusted `$sce.getTrusted`}.
   *
   * **As of 1.7.0, this is no longer the case.**
   *
   * Now such interpolations are marked as requiring `$sce.URL` (for `a[href]`) or `$sce.MEDIA_URL`
   * (for `img[src]`), so that the sanitization happens (via `$sce.getTrusted...`) when the `$interpolate`
   * service evaluates the expressions.
   * </div>
   *
   * There are no CSS or JS context bindings in AngularJS currently, so their corresponding `$sce.trustAs`
   * functions aren't useful yet. This might evolve.
   *
   * ### Format of items in {@link ng.$sceDelegateProvider#trustedResourceUrlList trustedResourceUrlList}/{@link ng.$sceDelegateProvider#bannedResourceUrlList bannedResourceUrlList} <a name="resourceUrlPatternItem"></a>
   *
   *  Each element in these arrays must be one of the following:
   *
   *  - **'self'**
   *    - The special **string**, `'self'`, can be used to match against all URLs of the **same
   *      domain** as the application document using the **same protocol**.
   *  - **String** (except the special value `'self'`)
   *    - The string is matched against the full *normalized / absolute URL* of the resource
   *      being tested (substring matches are not good enough.)
   *    - There are exactly **two wildcard sequences** - `*` and `**`.  All other characters
   *      match themselves.
   *    - `*`: matches zero or more occurrences of any character other than one of the following 6
   *      characters: '`:`', '`/`', '`.`', '`?`', '`&`' and '`;`'.  It's a useful wildcard for use
   *      for matching resource URL lists.
   *    - `**`: matches zero or more occurrences of *any* character.  As such, it's not
   *      appropriate for use in a scheme, domain, etc. as it would match too much.  (e.g.
   *      http://**.example.com/ would match http://evil.com/?ignore=.example.com/ and that might
   *      not have been the intention.)  Its usage at the very end of the path is ok.  (e.g.
   *      http://foo.example.com/templates/**).
   *  - **RegExp** (*see caveat below*)
   *    - *Caveat*:  While regular expressions are powerful and offer great flexibility,  their syntax
   *      (and all the inevitable escaping) makes them *harder to maintain*.  It's easy to
   *      accidentally introduce a bug when one updates a complex expression (imho, all regexes should
   *      have good test coverage).  For instance, the use of `.` in the regex is correct only in a
   *      small number of cases.  A `.` character in the regex used when matching the scheme or a
   *      subdomain could be matched against a `:` or literal `.` that was likely not intended.   It
   *      is highly recommended to use the string patterns and only fall back to regular expressions
   *      as a last resort.
   *    - The regular expression must be an instance of RegExp (i.e. not a string.)  It is
   *      matched against the **entire** *normalized / absolute URL* of the resource being tested
   *      (even when the RegExp did not have the `^` and `$` codes.)  In addition, any flags
   *      present on the RegExp (such as multiline, global, ignoreCase) are ignored.
   *    - If you are generating your JavaScript from some other templating engine (not
   *      recommended, e.g. in issue [#4006](https://github.com/angular/angular.js/issues/4006)),
   *      remember to escape your regular expression (and be aware that you might need more than
   *      one level of escaping depending on your templating engine and the way you interpolated
   *      the value.)  Do make use of your platform's escaping mechanism as it might be good
   *      enough before coding your own.  E.g. Ruby has
   *      [Regexp.escape(str)](http://www.ruby-doc.org/core-2.0.0/Regexp.html#method-c-escape)
   *      and Python has [re.escape](http://docs.python.org/library/re.html#re.escape).
   *      Javascript lacks a similar built in function for escaping.  Take a look at Google
   *      Closure library's [goog.string.regExpEscape(s)](
   *      http://docs.closure-library.googlecode.com/git/closure_goog_string_string.js.source.html#line962).
   *
   * Refer {@link ng.$sceDelegateProvider $sceDelegateProvider} for an example.
   *
   * ### Show me an example using SCE.
   *
   * <example module="mySceApp" deps="angular-sanitize.js" name="sce-service">
   * <file name="index.html">
   *   <div ng-controller="AppController as myCtrl">
   *     <i ng-bind-html="myCtrl.explicitlyTrustedHtml" id="explicitlyTrustedHtml"></i><br><br>
   *     <b>User comments</b><br>
   *     By default, HTML that isn't explicitly trusted (e.g. Alice's comment) is sanitized when
   *     $sanitize is available.  If $sanitize isn't available, this results in an error instead of an
   *     exploit.
   *     <div class="well">
   *       <div ng-repeat="userComment in myCtrl.userComments">
   *         <b>{{userComment.name}}</b>:
   *         <span ng-bind-html="userComment.htmlComment" class="htmlComment"></span>
   *         <br>
   *       </div>
   *     </div>
   *   </div>
   * </file>
   *
   * <file name="script.js">
   *   angular.module('mySceApp', ['ngSanitize'])
   *     .controller('AppController', ['$http', '$templateCache', '$sce',
   *       function AppController($http, $templateCache, $sce) {
   *         var self = this;
   *         $http.get('test_data.json', {cache: $templateCache}).then(function(response) {
   *           self.userComments = response.data;
   *         });
   *         self.explicitlyTrustedHtml = $sce.trustAsHtml(
   *             '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
   *             'sanitization.&quot;">Hover over this text.</span>');
   *       }]);
   * </file>
   *
   * <file name="test_data.json">
   * [
   *   { "name": "Alice",
   *     "htmlComment":
   *         "<span onmouseover='this.textContent=\"PWN3D!\"'>Is <i>anyone</i> reading this?</span>"
   *   },
   *   { "name": "Bob",
   *     "htmlComment": "<i>Yes!</i>  Am I the only other one?"
   *   }
   * ]
   * </file>
   *
   * <file name="protractor.js" type="protractor">
   *   describe('SCE doc demo', function() {
   *     it('should sanitize untrusted values', function() {
   *       expect(element.all(by.css('.htmlComment')).first().getAttribute('innerHTML'))
   *           .toBe('<span>Is <i>anyone</i> reading this?</span>');
   *     });
   *
   *     it('should NOT sanitize explicitly trusted values', function() {
   *       expect(element(by.id('explicitlyTrustedHtml')).getAttribute('innerHTML')).toBe(
   *           '<span onmouseover="this.textContent=&quot;Explicitly trusted HTML bypasses ' +
   *           'sanitization.&quot;">Hover over this text.</span>');
   *     });
   *   });
   * </file>
   * </example>
   *
   *
   *
   * ## Can I disable SCE completely?
   *
   * Yes, you can.  However, this is strongly discouraged.  SCE gives you a lot of security benefits
   * for little coding overhead.  It will be much harder to take an SCE disabled application and
   * either secure it on your own or enable SCE at a later stage.  It might make sense to disable SCE
   * for cases where you have a lot of existing code that was written before SCE was introduced and
   * you're migrating them a module at a time. Also do note that this is an app-wide setting, so if
   * you are writing a library, you will cause security bugs applications using it.
   *
   * That said, here's how you can completely disable SCE:
   *
   * ```
   * angular.module('myAppWithSceDisabledmyApp', []).config(function($sceProvider) {
   *   // Completely disable SCE.  For demonstration purposes only!
   *   // Do not use in new projects or libraries.
   *   $sceProvider.enabled(false);
   * });
   * ```
   *
   */

  function $SceProvider() {
    var enabled = true;

    /**
     * @ngdoc method
     * @name $sceProvider#enabled
     * @kind function
     *
     * @param {boolean=} value If provided, then enables/disables SCE application-wide.
     * @return {boolean} True if SCE is enabled, false otherwise.
     *
     * @description
     * Enables/disables SCE and returns the current value.
     */
    this.enabled = function (value) {
      if (arguments.length) {
        enabled = !!value;
      }
      return enabled;
    };

    /* Design notes on the default implementation for SCE.
     *
     * The API contract for the SCE delegate
     * -------------------------------------
     * The SCE delegate object must provide the following 3 methods:
     *
     * - trustAs(contextEnum, value)
     *     This method is used to tell the SCE service that the provided value is OK to use in the
     *     contexts specified by contextEnum.  It must return an object that will be accepted by
     *     getTrusted() for a compatible contextEnum and return this value.
     *
     * - valueOf(value)
     *     For values that were not produced by trustAs(), return them as is.  For values that were
     *     produced by trustAs(), return the corresponding input value to trustAs.  Basically, if
     *     trustAs is wrapping the given values into some type, this operation unwraps it when given
     *     such a value.
     *
     * - getTrusted(contextEnum, value)
     *     This function should return the value that is safe to use in the context specified by
     *     contextEnum or throw and exception otherwise.
     *
     * NOTE: This contract deliberately does NOT state that values returned by trustAs() must be
     * opaque or wrapped in some holder object.  That happens to be an implementation detail.  For
     * instance, an implementation could maintain a registry of all trusted objects by context.  In
     * such a case, trustAs() would return the same object that was passed in.  getTrusted() would
     * return the same object passed in if it was found in the registry under a compatible context or
     * throw an exception otherwise.  An implementation might only wrap values some of the time based
     * on some criteria.  getTrusted() might return a value and not throw an exception for special
     * constants or objects even if not wrapped.  All such implementations fulfill this contract.
     *
     *
     * A note on the inheritance model for SCE contexts
     * ------------------------------------------------
     * I've used inheritance and made RESOURCE_URL wrapped types a subtype of URL wrapped types.  This
     * is purely an implementation details.
     *
     * The contract is simply this:
     *
     *     getTrusted($sce.RESOURCE_URL, value) succeeding implies that getTrusted($sce.URL, value)
     *     will also succeed.
     *
     * Inheritance happens to capture this in a natural way. In some future, we may not use
     * inheritance anymore. That is OK because no code outside of sce.js and sceSpecs.js would need to
     * be aware of this detail.
     */

    this.$get = ['$parse', '$sceDelegate', function ($parse, $sceDelegate) {
      // Support: IE 9-11 only
      // Prereq: Ensure that we're not running in IE<11 quirks mode.  In that mode, IE < 11 allow
      // the "expression(javascript expression)" syntax which is insecure.
      if (enabled && msie < 8) {
        throw $sceMinErr('iequirks', 'Strict Contextual Escaping does not support Internet Explorer version < 11 in quirks ' + 'mode.  You can fix this by adding the text <!doctype html> to the top of your HTML ' + 'document.  See http://docs.angularjs.org/api/ng.$sce for more information.');
      }
      var sce = shallowCopy(SCE_CONTEXTS);

      /**
       * @ngdoc method
       * @name $sce#isEnabled
       * @kind function
       *
       * @return {Boolean} True if SCE is enabled, false otherwise.  If you want to set the value, you
       *     have to do it at module config time on {@link ng.$sceProvider $sceProvider}.
       *
       * @description
       * Returns a boolean indicating if SCE is enabled.
       */
      sce.isEnabled = function () {
        return enabled;
      };
      sce.trustAs = $sceDelegate.trustAs;
      sce.getTrusted = $sceDelegate.getTrusted;
      sce.valueOf = $sceDelegate.valueOf;
      if (!enabled) {
        sce.trustAs = sce.getTrusted = function (type, value) {
          return value;
        };
        sce.valueOf = identity;
      }

      /**
       * @ngdoc method
       * @name $sce#parseAs
       *
       * @description
       * Converts AngularJS {@link guide/expression expression} into a function.  This is like {@link
       * ng.$parse $parse} and is identical when the expression is a literal constant.  Otherwise, it
       * wraps the expression in a call to {@link ng.$sce#getTrusted $sce.getTrusted(*type*,
       * *result*)}
       *
       * @param {string} type The SCE context in which this result will be used.
       * @param {string} expression String expression to compile.
       * @return {function(context, locals)} A function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the
       *      strings are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values
       *      in `context`.
       */
      sce.parseAs = function sceParseAs(type, expr) {
        var parsed = $parse(expr);
        if (parsed.literal && parsed.constant) {
          return parsed;
        } else {
          return $parse(expr, function (value) {
            return sce.getTrusted(type, value);
          });
        }
      };

      /**
       * @ngdoc method
       * @name $sce#trustAs
       *
       * @description
       * Delegates to {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs`}. As such, returns a
       * wrapped object that represents your value, and the trust you have in its safety for the given
       * context. AngularJS can then use that value as-is in bindings of the specified secure context.
       * This is used in bindings for `ng-bind-html`, `ng-include`, and most `src` attribute
       * interpolations. See {@link ng.$sce $sce} for strict contextual escaping.
       *
       * @param {string} type The context in which this value is safe for use, e.g. `$sce.URL`,
       *     `$sce.RESOURCE_URL`, `$sce.HTML`, `$sce.JS` or `$sce.CSS`.
       *
       * @param {*} value The value that that should be considered trusted.
       * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
       *     in the context you specified.
       */

      /**
       * @ngdoc method
       * @name $sce#trustAsHtml
       *
       * @description
       * Shorthand method.  `$sce.trustAsHtml(value)` →
       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.HTML, value)`}
       *
       * @param {*} value The value to mark as trusted for `$sce.HTML` context.
       * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
       *     in `$sce.HTML` context (like `ng-bind-html`).
       */

      /**
       * @ngdoc method
       * @name $sce#trustAsCss
       *
       * @description
       * Shorthand method.  `$sce.trustAsCss(value)` →
       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.CSS, value)`}
       *
       * @param {*} value The value to mark as trusted for `$sce.CSS` context.
       * @return {*} A wrapped version of value that can be used as a trusted variant
       *     of your `value` in `$sce.CSS` context. This context is currently unused, so there are
       *     almost no reasons to use this function so far.
       */

      /**
       * @ngdoc method
       * @name $sce#trustAsUrl
       *
       * @description
       * Shorthand method.  `$sce.trustAsUrl(value)` →
       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.URL, value)`}
       *
       * @param {*} value The value to mark as trusted for `$sce.URL` context.
       * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
       *     in `$sce.URL` context. That context is currently unused, so there are almost no reasons
       *     to use this function so far.
       */

      /**
       * @ngdoc method
       * @name $sce#trustAsResourceUrl
       *
       * @description
       * Shorthand method.  `$sce.trustAsResourceUrl(value)` →
       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.RESOURCE_URL, value)`}
       *
       * @param {*} value The value to mark as trusted for `$sce.RESOURCE_URL` context.
       * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
       *     in `$sce.RESOURCE_URL` context (template URLs in `ng-include`, most `src` attribute
       *     bindings, ...)
       */

      /**
       * @ngdoc method
       * @name $sce#trustAsJs
       *
       * @description
       * Shorthand method.  `$sce.trustAsJs(value)` →
       *     {@link ng.$sceDelegate#trustAs `$sceDelegate.trustAs($sce.JS, value)`}
       *
       * @param {*} value The value to mark as trusted for `$sce.JS` context.
       * @return {*} A wrapped version of value that can be used as a trusted variant of your `value`
       *     in `$sce.JS` context. That context is currently unused, so there are almost no reasons to
       *     use this function so far.
       */

      /**
       * @ngdoc method
       * @name $sce#getTrusted
       *
       * @description
       * Delegates to {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted`}.  As such,
       * takes any input, and either returns a value that's safe to use in the specified context,
       * or throws an exception. This function is aware of trusted values created by the `trustAs`
       * function and its shorthands, and when contexts are appropriate, returns the unwrapped value
       * as-is. Finally, this function can also throw when there is no way to turn `maybeTrusted` in a
       * safe value (e.g., no sanitization is available or possible.)
       *
       * @param {string} type The context in which this value is to be used.
       * @param {*} maybeTrusted The result of a prior {@link ng.$sce#trustAs
       *     `$sce.trustAs`} call, or anything else (which will not be considered trusted.)
       * @return {*} A version of the value that's safe to use in the given context, or throws an
       *     exception if this is impossible.
       */

      /**
       * @ngdoc method
       * @name $sce#getTrustedHtml
       *
       * @description
       * Shorthand method.  `$sce.getTrustedHtml(value)` →
       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.HTML, value)`}
       *
       * @param {*} value The value to pass to `$sce.getTrusted`.
       * @return {*} The return value of `$sce.getTrusted($sce.HTML, value)`
       */

      /**
       * @ngdoc method
       * @name $sce#getTrustedCss
       *
       * @description
       * Shorthand method.  `$sce.getTrustedCss(value)` →
       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.CSS, value)`}
       *
       * @param {*} value The value to pass to `$sce.getTrusted`.
       * @return {*} The return value of `$sce.getTrusted($sce.CSS, value)`
       */

      /**
       * @ngdoc method
       * @name $sce#getTrustedUrl
       *
       * @description
       * Shorthand method.  `$sce.getTrustedUrl(value)` →
       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.URL, value)`}
       *
       * @param {*} value The value to pass to `$sce.getTrusted`.
       * @return {*} The return value of `$sce.getTrusted($sce.URL, value)`
       */

      /**
       * @ngdoc method
       * @name $sce#getTrustedResourceUrl
       *
       * @description
       * Shorthand method.  `$sce.getTrustedResourceUrl(value)` →
       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.RESOURCE_URL, value)`}
       *
       * @param {*} value The value to pass to `$sceDelegate.getTrusted`.
       * @return {*} The return value of `$sce.getTrusted($sce.RESOURCE_URL, value)`
       */

      /**
       * @ngdoc method
       * @name $sce#getTrustedJs
       *
       * @description
       * Shorthand method.  `$sce.getTrustedJs(value)` →
       *     {@link ng.$sceDelegate#getTrusted `$sceDelegate.getTrusted($sce.JS, value)`}
       *
       * @param {*} value The value to pass to `$sce.getTrusted`.
       * @return {*} The return value of `$sce.getTrusted($sce.JS, value)`
       */

      /**
       * @ngdoc method
       * @name $sce#parseAsHtml
       *
       * @description
       * Shorthand method.  `$sce.parseAsHtml(expression string)` →
       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.HTML, value)`}
       *
       * @param {string} expression String expression to compile.
       * @return {function(context, locals)} A function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the
       *      strings are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values
       *      in `context`.
       */

      /**
       * @ngdoc method
       * @name $sce#parseAsCss
       *
       * @description
       * Shorthand method.  `$sce.parseAsCss(value)` →
       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.CSS, value)`}
       *
       * @param {string} expression String expression to compile.
       * @return {function(context, locals)} A function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the
       *      strings are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values
       *      in `context`.
       */

      /**
       * @ngdoc method
       * @name $sce#parseAsUrl
       *
       * @description
       * Shorthand method.  `$sce.parseAsUrl(value)` →
       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.URL, value)`}
       *
       * @param {string} expression String expression to compile.
       * @return {function(context, locals)} A function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the
       *      strings are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values
       *      in `context`.
       */

      /**
       * @ngdoc method
       * @name $sce#parseAsResourceUrl
       *
       * @description
       * Shorthand method.  `$sce.parseAsResourceUrl(value)` →
       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.RESOURCE_URL, value)`}
       *
       * @param {string} expression String expression to compile.
       * @return {function(context, locals)} A function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the
       *      strings are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values
       *      in `context`.
       */

      /**
       * @ngdoc method
       * @name $sce#parseAsJs
       *
       * @description
       * Shorthand method.  `$sce.parseAsJs(value)` →
       *     {@link ng.$sce#parseAs `$sce.parseAs($sce.JS, value)`}
       *
       * @param {string} expression String expression to compile.
       * @return {function(context, locals)} A function which represents the compiled expression:
       *
       *    * `context` – `{object}` – an object against which any expressions embedded in the
       *      strings are evaluated against (typically a scope object).
       *    * `locals` – `{object=}` – local variables context object, useful for overriding values
       *      in `context`.
       */

      // Shorthand delegations.
      var parse = sce.parseAs,
        getTrusted = sce.getTrusted,
        trustAs = sce.trustAs;
      forEach(SCE_CONTEXTS, function (enumValue, name) {
        var lName = lowercase(name);
        sce[snakeToCamel('parse_as_' + lName)] = function (expr) {
          return parse(enumValue, expr);
        };
        sce[snakeToCamel('get_trusted_' + lName)] = function (value) {
          return getTrusted(enumValue, value);
        };
        sce[snakeToCamel('trust_as_' + lName)] = function (value) {
          return trustAs(enumValue, value);
        };
      });
      return sce;
    }];
  }

  /* exported $SnifferProvider */

  /**
   * !!! This is an undocumented "private" service !!!
   *
   * @name $sniffer
   * @requires $window
   * @requires $document
   * @this
   *
   * @property {boolean} history Does the browser support html5 history api ?
   * @property {boolean} transitions Does the browser support CSS transition events ?
   * @property {boolean} animations Does the browser support CSS animation events ?
   *
   * @description
   * This is very simple implementation of testing browser's features.
   */
  function $SnifferProvider() {
    this.$get = ['$window', '$document', function ($window, $document) {
      var eventSupport = {},
        // Chrome Packaged Apps are not allowed to access `history.pushState`.
        // If not sandboxed, they can be detected by the presence of `chrome.app.runtime`
        // (see https://developer.chrome.com/apps/api_index). If sandboxed, they can be detected by
        // the presence of an extension runtime ID and the absence of other Chrome runtime APIs
        // (see https://developer.chrome.com/apps/manifest/sandbox).
        // (NW.js apps have access to Chrome APIs, but do support `history`.)
        isNw = $window.nw && $window.nw.process,
        isChromePackagedApp = !isNw && $window.chrome && ($window.chrome.app && $window.chrome.app.runtime || !$window.chrome.app && $window.chrome.runtime && $window.chrome.runtime.id),
        hasHistoryPushState = !isChromePackagedApp && $window.history && $window.history.pushState,
        android = toInt((/android (\d+)/.exec(lowercase(($window.navigator || {}).userAgent)) || [])[1]),
        boxee = /Boxee/i.test(($window.navigator || {}).userAgent),
        document = $document[0] || {},
        bodyStyle = document.body && document.body.style,
        transitions = false,
        animations = false;
      if (bodyStyle) {
        // Support: Android <5, Blackberry Browser 10, default Chrome in Android 4.4.x
        // Mentioned browsers need a -webkit- prefix for transitions & animations.
        transitions = !!('transition' in bodyStyle || 'webkitTransition' in bodyStyle);
        animations = !!('animation' in bodyStyle || 'webkitAnimation' in bodyStyle);
      }
      return {
        // Android has history.pushState, but it does not update location correctly
        // so let's not use the history API at all.
        // http://code.google.com/p/android/issues/detail?id=17471
        // https://github.com/angular/angular.js/issues/904

        // older webkit browser (533.9) on Boxee box has exactly the same problem as Android has
        // so let's not use the history API also
        // We are purposefully using `!(android < 4)` to cover the case when `android` is undefined
        history: !!(hasHistoryPushState && !(android < 4) && !boxee),
        hasEvent: function hasEvent(event) {
          // Support: IE 9-11 only
          // IE9 implements 'input' event it's so fubared that we rather pretend that it doesn't have
          // it. In particular the event is not fired when backspace or delete key are pressed or
          // when cut operation is performed.
          // IE10+ implements 'input' event but it erroneously fires under various situations,
          // e.g. when placeholder changes, or a form is focused.
          if (event === 'input' && msie) return false;
          if (isUndefined(eventSupport[event])) {
            var divElm = document.createElement('div');
            eventSupport[event] = 'on' + event in divElm;
          }
          return eventSupport[event];
        },
        csp: _csp(),
        transitions: transitions,
        animations: animations,
        android: android
      };
    }];
  }

  /**
   * ! This is a private undocumented service !
   *
   * @name $$taskTrackerFactory
   * @description
   * A function to create `TaskTracker` instances.
   *
   * A `TaskTracker` can keep track of pending tasks (grouped by type) and can notify interested
   * parties when all pending tasks (or tasks of a specific type) have been completed.
   *
   * @param {$log} log - A logger instance (such as `$log`). Used to log error during callback
   *     execution.
   *
   * @this
   */
  function $$TaskTrackerFactoryProvider() {
    this.$get = valueFn(function (log) {
      return new TaskTracker(log);
    });
  }
  function TaskTracker(log) {
    var self = this;
    var taskCounts = {};
    var taskCallbacks = [];
    var ALL_TASKS_TYPE = self.ALL_TASKS_TYPE = '$$all$$';
    var DEFAULT_TASK_TYPE = self.DEFAULT_TASK_TYPE = '$$default$$';

    /**
     * Execute the specified function and decrement the appropriate `taskCounts` counter.
     * If the counter reaches 0, all corresponding `taskCallbacks` are executed.
     *
     * @param {Function} fn - The function to execute.
     * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task that is being completed.
     */
    self.completeTask = completeTask;

    /**
     * Increase the task count for the specified task type (or the default task type if non is
     * specified).
     *
     * @param {string=} [taskType=DEFAULT_TASK_TYPE] - The type of task whose count will be increased.
     */
    self.incTaskCount = incTaskCount;

    /**
     * Execute the specified callback when all pending tasks have been completed.
     *
     * If there are no pending tasks, the callback is executed immediately. You can optionally limit
     * the tasks that will be waited for to a specific type, by passing a `taskType`.
     *
     * @param {function} callback - The function to call when there are no pending tasks.
     * @param {string=} [taskType=ALL_TASKS_TYPE] - The type of tasks that will be waited for.
     */
    self.notifyWhenNoPendingTasks = notifyWhenNoPendingTasks;
    function completeTask(fn, taskType) {
      taskType = taskType || DEFAULT_TASK_TYPE;
      try {
        fn();
      } finally {
        decTaskCount(taskType);
        var countForType = taskCounts[taskType];
        var countForAll = taskCounts[ALL_TASKS_TYPE];

        // If at least one of the queues (`ALL_TASKS_TYPE` or `taskType`) is empty, run callbacks.
        if (!countForAll || !countForType) {
          var getNextCallback = !countForAll ? getLastCallback : getLastCallbackForType;
          var nextCb;
          while (nextCb = getNextCallback(taskType)) {
            try {
              nextCb();
            } catch (e) {
              log.error(e);
            }
          }
        }
      }
    }
    function decTaskCount(taskType) {
      taskType = taskType || DEFAULT_TASK_TYPE;
      if (taskCounts[taskType]) {
        taskCounts[taskType]--;
        taskCounts[ALL_TASKS_TYPE]--;
      }
    }
    function getLastCallback() {
      var cbInfo = taskCallbacks.pop();
      return cbInfo && cbInfo.cb;
    }
    function getLastCallbackForType(taskType) {
      for (var i = taskCallbacks.length - 1; i >= 0; --i) {
        var cbInfo = taskCallbacks[i];
        if (cbInfo.type === taskType) {
          taskCallbacks.splice(i, 1);
          return cbInfo.cb;
        }
      }
    }
    function incTaskCount(taskType) {
      taskType = taskType || DEFAULT_TASK_TYPE;
      taskCounts[taskType] = (taskCounts[taskType] || 0) + 1;
      taskCounts[ALL_TASKS_TYPE] = (taskCounts[ALL_TASKS_TYPE] || 0) + 1;
    }
    function notifyWhenNoPendingTasks(callback, taskType) {
      taskType = taskType || ALL_TASKS_TYPE;
      if (!taskCounts[taskType]) {
        callback();
      } else {
        taskCallbacks.push({
          type: taskType,
          cb: callback
        });
      }
    }
  }
  var $templateRequestMinErr = minErr('$templateRequest');

  /**
   * @ngdoc provider
   * @name $templateRequestProvider
   * @this
   *
   * @description
   * Used to configure the options passed to the {@link $http} service when making a template request.
   *
   * For example, it can be used for specifying the "Accept" header that is sent to the server, when
   * requesting a template.
   */
  function $TemplateRequestProvider() {
    var httpOptions;

    /**
     * @ngdoc method
     * @name $templateRequestProvider#httpOptions
     * @description
     * The options to be passed to the {@link $http} service when making the request.
     * You can use this to override options such as the "Accept" header for template requests.
     *
     * The {@link $templateRequest} will set the `cache` and the `transformResponse` properties of the
     * options if not overridden here.
     *
     * @param {string=} value new value for the {@link $http} options.
     * @returns {string|self} Returns the {@link $http} options when used as getter and self if used as setter.
     */
    this.httpOptions = function (val) {
      if (val) {
        httpOptions = val;
        return this;
      }
      return httpOptions;
    };

    /**
     * @ngdoc service
     * @name $templateRequest
     *
     * @description
     * The `$templateRequest` service runs security checks then downloads the provided template using
     * `$http` and, upon success, stores the contents inside of `$templateCache`. If the HTTP request
     * fails or the response data of the HTTP request is empty, a `$compile` error will be thrown (the
     * exception can be thwarted by setting the 2nd parameter of the function to true). Note that the
     * contents of `$templateCache` are trusted, so the call to `$sce.getTrustedUrl(tpl)` is omitted
     * when `tpl` is of type string and `$templateCache` has the matching entry.
     *
     * If you want to pass custom options to the `$http` service, such as setting the Accept header you
     * can configure this via {@link $templateRequestProvider#httpOptions}.
     *
     * `$templateRequest` is used internally by {@link $compile}, {@link ngRoute.$route}, and directives such
     * as {@link ngInclude} to download and cache templates.
     *
     * 3rd party modules should use `$templateRequest` if their services or directives are loading
     * templates.
     *
     * @param {string|TrustedResourceUrl} tpl The HTTP request template URL
     * @param {boolean=} ignoreRequestError Whether or not to ignore the exception when the request fails or the template is empty
     *
     * @return {Promise} a promise for the HTTP response data of the given URL.
     *
     * @property {number} totalPendingRequests total amount of pending template requests being downloaded.
     */
    this.$get = ['$exceptionHandler', '$templateCache', '$http', '$q', '$sce', function ($exceptionHandler, $templateCache, $http, $q, $sce) {
      function handleRequestFn(tpl, ignoreRequestError) {
        handleRequestFn.totalPendingRequests++;

        // We consider the template cache holds only trusted templates, so
        // there's no need to go through adding the template again to the trusted
        // resources for keys that already are included in there. This also makes
        // AngularJS accept any script directive, no matter its name. However, we
        // still need to unwrap trusted types.
        if (!isString(tpl) || isUndefined($templateCache.get(tpl))) {
          tpl = $sce.getTrustedResourceUrl(tpl);
        }
        var transformResponse = $http.defaults && $http.defaults.transformResponse;
        if (isArray(transformResponse)) {
          transformResponse = transformResponse.filter(function (transformer) {
            return transformer !== defaultHttpResponseTransform;
          });
        } else if (transformResponse === defaultHttpResponseTransform) {
          transformResponse = null;
        }
        return $http.get(tpl, extend({
          cache: $templateCache,
          transformResponse: transformResponse
        }, httpOptions))["finally"](function () {
          handleRequestFn.totalPendingRequests--;
        }).then(function (response) {
          return $templateCache.put(tpl, response.data);
        }, handleError);
        function handleError(resp) {
          if (!ignoreRequestError) {
            resp = $templateRequestMinErr('tpload', 'Failed to load template: {0} (HTTP status: {1} {2})', tpl, resp.status, resp.statusText);
            $exceptionHandler(resp);
          }
          return $q.reject(resp);
        }
      }
      handleRequestFn.totalPendingRequests = 0;
      return handleRequestFn;
    }];
  }

  /** @this */
  function $$TestabilityProvider() {
    this.$get = ['$rootScope', '$browser', '$location', function ($rootScope, $browser, $location) {
      /**
       * @name $testability
       *
       * @description
       * The private $$testability service provides a collection of methods for use when debugging
       * or by automated test and debugging tools.
       */
      var testability = {};

      /**
       * @name $$testability#findBindings
       *
       * @description
       * Returns an array of elements that are bound (via ng-bind or {{}})
       * to expressions matching the input.
       *
       * @param {Element} element The element root to search from.
       * @param {string} expression The binding expression to match.
       * @param {boolean} opt_exactMatch If true, only returns exact matches
       *     for the expression. Filters and whitespace are ignored.
       */
      testability.findBindings = function (element, expression, opt_exactMatch) {
        var bindings = element.getElementsByClassName('ng-binding');
        var matches = [];
        forEach(bindings, function (binding) {
          var dataBinding = angular.element(binding).data('$binding');
          if (dataBinding) {
            forEach(dataBinding, function (bindingName) {
              if (opt_exactMatch) {
                var matcher = new RegExp('(^|\\s)' + escapeForRegexp(expression) + '(\\s|\\||$)');
                if (matcher.test(bindingName)) {
                  matches.push(binding);
                }
              } else {
                if (bindingName.indexOf(expression) !== -1) {
                  matches.push(binding);
                }
              }
            });
          }
        });
        return matches;
      };

      /**
       * @name $$testability#findModels
       *
       * @description
       * Returns an array of elements that are two-way found via ng-model to
       * expressions matching the input.
       *
       * @param {Element} element The element root to search from.
       * @param {string} expression The model expression to match.
       * @param {boolean} opt_exactMatch If true, only returns exact matches
       *     for the expression.
       */
      testability.findModels = function (element, expression, opt_exactMatch) {
        var prefixes = ['ng-', 'data-ng-', 'ng\\:'];
        for (var p = 0; p < prefixes.length; ++p) {
          var attributeEquals = opt_exactMatch ? '=' : '*=';
          var selector = '[' + prefixes[p] + 'model' + attributeEquals + '"' + expression + '"]';
          var elements = element.querySelectorAll(selector);
          if (elements.length) {
            return elements;
          }
        }
      };

      /**
       * @name $$testability#getLocation
       *
       * @description
       * Shortcut for getting the location in a browser agnostic way. Returns
       *     the path, search, and hash. (e.g. /path?a=b#hash)
       */
      testability.getLocation = function () {
        return $location.url();
      };

      /**
       * @name $$testability#setLocation
       *
       * @description
       * Shortcut for navigating to a location without doing a full page reload.
       *
       * @param {string} url The location url (path, search and hash,
       *     e.g. /path?a=b#hash) to go to.
       */
      testability.setLocation = function (url) {
        if (url !== $location.url()) {
          $location.url(url);
          $rootScope.$digest();
        }
      };

      /**
       * @name $$testability#whenStable
       *
       * @description
       * Calls the callback when all pending tasks are completed.
       *
       * Types of tasks waited for include:
       * - Pending timeouts (via {@link $timeout}).
       * - Pending HTTP requests (via {@link $http}).
       * - In-progress route transitions (via {@link $route}).
       * - Pending tasks scheduled via {@link $rootScope#$applyAsync}.
       * - Pending tasks scheduled via {@link $rootScope#$evalAsync}.
       *   These include tasks scheduled via `$evalAsync()` indirectly (such as {@link $q} promises).
       *
       * @param {function} callback
       */
      testability.whenStable = function (callback) {
        $browser.notifyWhenNoOutstandingRequests(callback);
      };
      return testability;
    }];
  }
  var $timeoutMinErr = minErr('$timeout');

  /** @this */
  function $TimeoutProvider() {
    this.$get = ['$rootScope', '$browser', '$q', '$$q', '$exceptionHandler', function ($rootScope, $browser, $q, $$q, $exceptionHandler) {
      var deferreds = {};

      /**
       * @ngdoc service
       * @name $timeout
       *
       * @description
       * AngularJS's wrapper for `window.setTimeout`. The `fn` function is wrapped into a try/catch
       * block and delegates any exceptions to
       * {@link ng.$exceptionHandler $exceptionHandler} service.
       *
       * The return value of calling `$timeout` is a promise, which will be resolved when
       * the delay has passed and the timeout function, if provided, is executed.
       *
       * To cancel a timeout request, call `$timeout.cancel(promise)`.
       *
       * In tests you can use {@link ngMock.$timeout `$timeout.flush()`} to
       * synchronously flush the queue of deferred functions.
       *
       * If you only want a promise that will be resolved after some specified delay
       * then you can call `$timeout` without the `fn` function.
       *
       * @param {function()=} fn A function, whose execution should be delayed.
       * @param {number=} [delay=0] Delay in milliseconds.
       * @param {boolean=} [invokeApply=true] If set to `false` skips model dirty checking, otherwise
       *   will invoke `fn` within the {@link ng.$rootScope.Scope#$apply $apply} block.
       * @param {...*=} Pass additional parameters to the executed function.
       * @returns {Promise} Promise that will be resolved when the timeout is reached. The promise
       *   will be resolved with the return value of the `fn` function.
       *
       */
      function timeout(fn, delay, invokeApply) {
        if (!isFunction(fn)) {
          invokeApply = delay;
          delay = fn;
          fn = noop;
        }
        var args = sliceArgs(arguments, 3),
          skipApply = isDefined(invokeApply) && !invokeApply,
          deferred = (skipApply ? $$q : $q).defer(),
          promise = deferred.promise,
          timeoutId;
        timeoutId = $browser.defer(function () {
          try {
            deferred.resolve(fn.apply(null, args));
          } catch (e) {
            deferred.reject(e);
            $exceptionHandler(e);
          } finally {
            delete deferreds[promise.$$timeoutId];
          }
          if (!skipApply) $rootScope.$apply();
        }, delay, '$timeout');
        promise.$$timeoutId = timeoutId;
        deferreds[timeoutId] = deferred;
        return promise;
      }

      /**
       * @ngdoc method
       * @name $timeout#cancel
       *
       * @description
       * Cancels a task associated with the `promise`. As a result of this, the promise will be
       * resolved with a rejection.
       *
       * @param {Promise=} promise Promise returned by the `$timeout` function.
       * @returns {boolean} Returns `true` if the task hasn't executed yet and was successfully
       *   canceled.
       */
      timeout.cancel = function (promise) {
        if (!promise) return false;
        if (!promise.hasOwnProperty('$$timeoutId')) {
          throw $timeoutMinErr('badprom', '`$timeout.cancel()` called with a promise that was not generated by `$timeout()`.');
        }
        if (!deferreds.hasOwnProperty(promise.$$timeoutId)) return false;
        var id = promise.$$timeoutId;
        var deferred = deferreds[id];

        // Timeout cancels should not report an unhandled promise.
        markQExceptionHandled(deferred.promise);
        deferred.reject('canceled');
        delete deferreds[id];
        return $browser.defer.cancel(id);
      };
      return timeout;
    }];
  }

  // NOTE:  The usage of window and document instead of $window and $document here is
  // deliberate.  This service depends on the specific behavior of anchor nodes created by the
  // browser (resolving and parsing URLs) that is unlikely to be provided by mock objects and
  // cause us to break tests.  In addition, when the browser resolves a URL for XHR, it
  // doesn't know about mocked locations and resolves URLs to the real document - which is
  // exactly the behavior needed here.  There is little value is mocking these out for this
  // service.
  var urlParsingNode = window.document.createElement('a');
  var originUrl = urlResolve(window.location.href);
  var baseUrlParsingNode;
  urlParsingNode.href = 'http://[::1]';

  // Support: IE 9-11 only, Edge 16-17 only (fixed in 18 Preview)
  // IE/Edge don't wrap IPv6 addresses' hostnames in square brackets
  // when parsed out of an anchor element.
  var ipv6InBrackets = urlParsingNode.hostname === '[::1]';

  /**
   *
   * Implementation Notes for non-IE browsers
   * ----------------------------------------
   * Assigning a URL to the href property of an anchor DOM node, even one attached to the DOM,
   * results both in the normalizing and parsing of the URL.  Normalizing means that a relative
   * URL will be resolved into an absolute URL in the context of the application document.
   * Parsing means that the anchor node's host, hostname, protocol, port, pathname and related
   * properties are all populated to reflect the normalized URL.  This approach has wide
   * compatibility - Safari 1+, Mozilla 1+ etc.  See
   * http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
   *
   * Implementation Notes for IE
   * ---------------------------
   * IE <= 10 normalizes the URL when assigned to the anchor node similar to the other
   * browsers.  However, the parsed components will not be set if the URL assigned did not specify
   * them.  (e.g. if you assign a.href = "foo", then a.protocol, a.host, etc. will be empty.)  We
   * work around that by performing the parsing in a 2nd step by taking a previously normalized
   * URL (e.g. by assigning to a.href) and assigning it a.href again.  This correctly populates the
   * properties such as protocol, hostname, port, etc.
   *
   * References:
   *   http://developer.mozilla.org/en-US/docs/Web/API/HTMLAnchorElement
   *   http://www.aptana.com/reference/html/api/HTMLAnchorElement.html
   *   http://url.spec.whatwg.org/#urlutils
   *   https://github.com/angular/angular.js/pull/2902
   *   http://james.padolsey.com/javascript/parsing-urls-with-the-dom/
   *
   * @kind function
   * @param {string|object} url The URL to be parsed. If `url` is not a string, it will be returned
   *     unchanged.
   * @description Normalizes and parses a URL.
   * @returns {object} Returns the normalized URL as a dictionary.
   *
   *   | member name   | Description                                                            |
   *   |---------------|------------------------------------------------------------------------|
   *   | href          | A normalized version of the provided URL if it was not an absolute URL |
   *   | protocol      | The protocol without the trailing colon                                |
   *   | host          | The host and port (if the port is non-default) of the normalizedUrl    |
   *   | search        | The search params, minus the question mark                             |
   *   | hash          | The hash string, minus the hash symbol                                 |
   *   | hostname      | The hostname                                                           |
   *   | port          | The port, without ":"                                                  |
   *   | pathname      | The pathname, beginning with "/"                                       |
   *
   */
  function urlResolve(url) {
    if (!isString(url)) return url;
    var href = url;

    // Support: IE 9-11 only
    if (msie) {
      // Normalize before parse.  Refer Implementation Notes on why this is
      // done in two steps on IE.
      urlParsingNode.setAttribute('href', href);
      href = urlParsingNode.href;
    }
    urlParsingNode.setAttribute('href', href);
    var hostname = urlParsingNode.hostname;
    if (!ipv6InBrackets && hostname.indexOf(':') > -1) {
      hostname = '[' + hostname + ']';
    }
    return {
      href: urlParsingNode.href,
      protocol: urlParsingNode.protocol ? urlParsingNode.protocol.replace(/:$/, '') : '',
      host: urlParsingNode.host,
      search: urlParsingNode.search ? urlParsingNode.search.replace(/^\?/, '') : '',
      hash: urlParsingNode.hash ? urlParsingNode.hash.replace(/^#/, '') : '',
      hostname: hostname,
      port: urlParsingNode.port,
      pathname: urlParsingNode.pathname.charAt(0) === '/' ? urlParsingNode.pathname : '/' + urlParsingNode.pathname
    };
  }

  /**
   * Parse a request URL and determine whether this is a same-origin request as the application
   * document.
   *
   * @param {string|object} requestUrl The url of the request as a string that will be resolved
   * or a parsed URL object.
   * @returns {boolean} Whether the request is for the same origin as the application document.
   */
  function urlIsSameOrigin(requestUrl) {
    return urlsAreSameOrigin(requestUrl, originUrl);
  }

  /**
   * Parse a request URL and determine whether it is same-origin as the current document base URL.
   *
   * Note: The base URL is usually the same as the document location (`location.href`) but can
   * be overriden by using the `<base>` tag.
   *
   * @param {string|object} requestUrl The url of the request as a string that will be resolved
   * or a parsed URL object.
   * @returns {boolean} Whether the URL is same-origin as the document base URL.
   */
  function urlIsSameOriginAsBaseUrl(requestUrl) {
    return urlsAreSameOrigin(requestUrl, getBaseUrl());
  }

  /**
   * Create a function that can check a URL's origin against a list of allowed/trusted origins.
   * The current location's origin is implicitly trusted.
   *
   * @param {string[]} trustedOriginUrls - A list of URLs (strings), whose origins are trusted.
   *
   * @returns {Function} - A function that receives a URL (string or parsed URL object) and returns
   *     whether it is of an allowed origin.
   */
  function urlIsAllowedOriginFactory(trustedOriginUrls) {
    var parsedAllowedOriginUrls = [originUrl].concat(trustedOriginUrls.map(urlResolve));

    /**
     * Check whether the specified URL (string or parsed URL object) has an origin that is allowed
     * based on a list of trusted-origin URLs. The current location's origin is implicitly
     * trusted.
     *
     * @param {string|Object} requestUrl - The URL to be checked (provided as a string that will be
     *     resolved or a parsed URL object).
     *
     * @returns {boolean} - Whether the specified URL is of an allowed origin.
     */
    return function urlIsAllowedOrigin(requestUrl) {
      var parsedUrl = urlResolve(requestUrl);
      return parsedAllowedOriginUrls.some(urlsAreSameOrigin.bind(null, parsedUrl));
    };
  }

  /**
   * Determine if two URLs share the same origin.
   *
   * @param {string|Object} url1 - First URL to compare as a string or a normalized URL in the form of
   *     a dictionary object returned by `urlResolve()`.
   * @param {string|object} url2 - Second URL to compare as a string or a normalized URL in the form
   *     of a dictionary object returned by `urlResolve()`.
   *
   * @returns {boolean} - True if both URLs have the same origin, and false otherwise.
   */
  function urlsAreSameOrigin(url1, url2) {
    url1 = urlResolve(url1);
    url2 = urlResolve(url2);
    return url1.protocol === url2.protocol && url1.host === url2.host;
  }

  /**
   * Returns the current document base URL.
   * @returns {string}
   */
  function getBaseUrl() {
    if (window.document.baseURI) {
      return window.document.baseURI;
    }

    // `document.baseURI` is available everywhere except IE
    if (!baseUrlParsingNode) {
      baseUrlParsingNode = window.document.createElement('a');
      baseUrlParsingNode.href = '.';

      // Work-around for IE bug described in Implementation Notes. The fix in `urlResolve()` is not
      // suitable here because we need to track changes to the base URL.
      baseUrlParsingNode = baseUrlParsingNode.cloneNode(false);
    }
    return baseUrlParsingNode.href;
  }

  /**
   * @ngdoc service
   * @name $window
   * @this
   *
   * @description
   * A reference to the browser's `window` object. While `window`
   * is globally available in JavaScript, it causes testability problems, because
   * it is a global variable. In AngularJS we always refer to it through the
   * `$window` service, so it may be overridden, removed or mocked for testing.
   *
   * Expressions, like the one defined for the `ngClick` directive in the example
   * below, are evaluated with respect to the current scope.  Therefore, there is
   * no risk of inadvertently coding in a dependency on a global value in such an
   * expression.
   *
   * @example
     <example module="windowExample" name="window-service">
       <file name="index.html">
         <script>
           angular.module('windowExample', [])
             .controller('ExampleController', ['$scope', '$window', function($scope, $window) {
               $scope.greeting = 'Hello, World!';
               $scope.doGreeting = function(greeting) {
                 $window.alert(greeting);
               };
             }]);
         </script>
         <div ng-controller="ExampleController">
           <input type="text" ng-model="greeting" aria-label="greeting" />
           <button ng-click="doGreeting(greeting)">ALERT</button>
         </div>
       </file>
       <file name="protractor.js" type="protractor">
        it('should display the greeting in the input box', function() {
         element(by.model('greeting')).sendKeys('Hello, E2E Tests');
         // If we click the button it will block the test runner
         // element(':button').click();
        });
       </file>
     </example>
   */
  function $WindowProvider() {
    this.$get = valueFn(window);
  }

  /**
   * @name $$cookieReader
   * @requires $document
   *
   * @description
   * This is a private service for reading cookies used by $http and ngCookies
   *
   * @return {Object} a key/value map of the current cookies
   */
  function $$CookieReader($document) {
    var rawDocument = $document[0] || {};
    var lastCookies = {};
    var lastCookieString = '';
    function safeGetCookie(rawDocument) {
      try {
        return rawDocument.cookie || '';
      } catch (e) {
        return '';
      }
    }
    function safeDecodeURIComponent(str) {
      try {
        return decodeURIComponent(str);
      } catch (e) {
        return str;
      }
    }
    return function () {
      var cookieArray, cookie, i, index, name;
      var currentCookieString = safeGetCookie(rawDocument);
      if (currentCookieString !== lastCookieString) {
        lastCookieString = currentCookieString;
        cookieArray = lastCookieString.split('; ');
        lastCookies = {};
        for (i = 0; i < cookieArray.length; i++) {
          cookie = cookieArray[i];
          index = cookie.indexOf('=');
          if (index > 0) {
            //ignore nameless cookies
            name = safeDecodeURIComponent(cookie.substring(0, index));
            // the first value that is seen for a cookie is the most
            // specific one.  values for the same cookie name that
            // follow are for less specific paths.
            if (isUndefined(lastCookies[name])) {
              lastCookies[name] = safeDecodeURIComponent(cookie.substring(index + 1));
            }
          }
        }
      }
      return lastCookies;
    };
  }
  $$CookieReader.$inject = ['$document'];

  /** @this */
  function $$CookieReaderProvider() {
    this.$get = $$CookieReader;
  }

  /* global currencyFilter: true,
   dateFilter: true,
   filterFilter: true,
   jsonFilter: true,
   limitToFilter: true,
   lowercaseFilter: true,
   numberFilter: true,
   orderByFilter: true,
   uppercaseFilter: true,
   */

  /**
   * @ngdoc provider
   * @name $filterProvider
   * @description
   *
   * Filters are just functions which transform input to an output. However filters need to be
   * Dependency Injected. To achieve this a filter definition consists of a factory function which is
   * annotated with dependencies and is responsible for creating a filter function.
   *
   * <div class="alert alert-warning">
   * **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
   * Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
   * your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
   * (`myapp_subsection_filterx`).
   * </div>
   *
   * ```js
   *   // Filter registration
   *   function MyModule($provide, $filterProvider) {
   *     // create a service to demonstrate injection (not always needed)
   *     $provide.value('greet', function(name){
   *       return 'Hello ' + name + '!';
   *     });
   *
   *     // register a filter factory which uses the
   *     // greet service to demonstrate DI.
   *     $filterProvider.register('greet', function(greet){
   *       // return the filter function which uses the greet service
   *       // to generate salutation
   *       return function(text) {
   *         // filters need to be forgiving so check input validity
   *         return text && greet(text) || text;
   *       };
   *     });
   *   }
   * ```
   *
   * The filter function is registered with the `$injector` under the filter name suffix with
   * `Filter`.
   *
   * ```js
   *   it('should be the same instance', inject(
   *     function($filterProvider) {
   *       $filterProvider.register('reverse', function(){
   *         return ...;
   *       });
   *     },
   *     function($filter, reverseFilter) {
   *       expect($filter('reverse')).toBe(reverseFilter);
   *     });
   * ```
   *
   *
   * For more information about how AngularJS filters work, and how to create your own filters, see
   * {@link guide/filter Filters} in the AngularJS Developer Guide.
   */

  /**
   * @ngdoc service
   * @name $filter
   * @kind function
   * @description
   * Filters are used for formatting data displayed to the user.
   *
   * They can be used in view templates, controllers or services. AngularJS comes
   * with a collection of [built-in filters](api/ng/filter), but it is easy to
   * define your own as well.
   *
   * The general syntax in templates is as follows:
   *
   * ```html
   * {{ expression [| filter_name[:parameter_value] ... ] }}
   * ```
   *
   * @param {String} name Name of the filter function to retrieve
   * @return {Function} the filter function
   * @example
     <example name="$filter" module="filterExample">
       <file name="index.html">
         <div ng-controller="MainCtrl">
          <h3>{{ originalText }}</h3>
          <h3>{{ filteredText }}</h3>
         </div>
       </file>
  
       <file name="script.js">
        angular.module('filterExample', [])
        .controller('MainCtrl', function($scope, $filter) {
          $scope.originalText = 'hello';
          $scope.filteredText = $filter('uppercase')($scope.originalText);
        });
       </file>
     </example>
    */
  $FilterProvider.$inject = ['$provide'];
  /** @this */
  function $FilterProvider($provide) {
    var suffix = 'Filter';

    /**
     * @ngdoc method
     * @name $filterProvider#register
     * @param {string|Object} name Name of the filter function, or an object map of filters where
     *    the keys are the filter names and the values are the filter factories.
     *
     *    <div class="alert alert-warning">
     *    **Note:** Filter names must be valid AngularJS {@link expression} identifiers, such as `uppercase` or `orderBy`.
     *    Names with special characters, such as hyphens and dots, are not allowed. If you wish to namespace
     *    your filters, then you can use capitalization (`myappSubsectionFilterx`) or underscores
     *    (`myapp_subsection_filterx`).
     *    </div>
      * @param {Function} factory If the first argument was a string, a factory function for the filter to be registered.
     * @returns {Object} Registered filter instance, or if a map of filters was provided then a map
     *    of the registered filter instances.
     */
    function register(name, factory) {
      if (isObject(name)) {
        var filters = {};
        forEach(name, function (filter, key) {
          filters[key] = register(key, filter);
        });
        return filters;
      } else {
        return $provide.factory(name + suffix, factory);
      }
    }
    this.register = register;
    this.$get = ['$injector', function ($injector) {
      return function (name) {
        return $injector.get(name + suffix);
      };
    }];

    ////////////////////////////////////////

    /* global
      currencyFilter: false,
      dateFilter: false,
      filterFilter: false,
      jsonFilter: false,
      limitToFilter: false,
      lowercaseFilter: false,
      numberFilter: false,
      orderByFilter: false,
      uppercaseFilter: false
    */

    register('currency', currencyFilter);
    register('date', dateFilter);
    register('filter', filterFilter);
    register('json', jsonFilter);
    register('limitTo', limitToFilter);
    register('lowercase', lowercaseFilter);
    register('number', numberFilter);
    register('orderBy', orderByFilter);
    register('uppercase', uppercaseFilter);
  }

  /**
   * @ngdoc filter
   * @name filter
   * @kind function
   *
   * @description
   * Selects a subset of items from `array` and returns it as a new array.
   *
   * @param {Array} array The source array.
   * <div class="alert alert-info">
   *   **Note**: If the array contains objects that reference themselves, filtering is not possible.
   * </div>
   * @param {string|Object|function()} expression The predicate to be used for selecting items from
   *   `array`.
   *
   *   Can be one of:
   *
   *   - `string`: The string is used for matching against the contents of the `array`. All strings or
   *     objects with string properties in `array` that match this string will be returned. This also
   *     applies to nested object properties.
   *     The predicate can be negated by prefixing the string with `!`.
   *
   *   - `Object`: A pattern object can be used to filter specific properties on objects contained
   *     by `array`. For example `{name:"M", phone:"1"}` predicate will return an array of items
   *     which have property `name` containing "M" and property `phone` containing "1". A special
   *     property name (`$` by default) can be used (e.g. as in `{$: "text"}`) to accept a match
   *     against any property of the object or its nested object properties. That's equivalent to the
   *     simple substring match with a `string` as described above. The special property name can be
   *     overwritten, using the `anyPropertyKey` parameter.
   *     The predicate can be negated by prefixing the string with `!`.
   *     For example `{name: "!M"}` predicate will return an array of items which have property `name`
   *     not containing "M".
   *
   *     Note that a named property will match properties on the same level only, while the special
   *     `$` property will match properties on the same level or deeper. E.g. an array item like
   *     `{name: {first: 'John', last: 'Doe'}}` will **not** be matched by `{name: 'John'}`, but
   *     **will** be matched by `{$: 'John'}`.
   *
   *   - `function(value, index, array)`: A predicate function can be used to write arbitrary filters.
   *     The function is called for each element of the array, with the element, its index, and
   *     the entire array itself as arguments.
   *
   *     The final result is an array of those elements that the predicate returned true for.
   *
   * @param {function(actual, expected)|true|false} [comparator] Comparator which is used in
   *     determining if values retrieved using `expression` (when it is not a function) should be
   *     considered a match based on the expected value (from the filter expression) and actual
   *     value (from the object in the array).
   *
   *   Can be one of:
   *
   *   - `function(actual, expected)`:
   *     The function will be given the object value and the predicate value to compare and
   *     should return true if both values should be considered equal.
   *
   *   - `true`: A shorthand for `function(actual, expected) { return angular.equals(actual, expected)}`.
   *     This is essentially strict comparison of expected and actual.
   *
   *   - `false`: A short hand for a function which will look for a substring match in a case
   *     insensitive way. Primitive values are converted to strings. Objects are not compared against
   *     primitives, unless they have a custom `toString` method (e.g. `Date` objects).
   *
   *
   *   Defaults to `false`.
   *
   * @param {string} [anyPropertyKey] The special property name that matches against any property.
   *     By default `$`.
   *
   * @example
     <example name="filter-filter">
       <file name="index.html">
         <div ng-init="friends = [{name:'John', phone:'555-1276'},
                                  {name:'Mary', phone:'800-BIG-MARY'},
                                  {name:'Mike', phone:'555-4321'},
                                  {name:'Adam', phone:'555-5678'},
                                  {name:'Julie', phone:'555-8765'},
                                  {name:'Juliette', phone:'555-5678'}]"></div>
  
         <label>Search: <input ng-model="searchText"></label>
         <table id="searchTextResults">
           <tr><th>Name</th><th>Phone</th></tr>
           <tr ng-repeat="friend in friends | filter:searchText">
             <td>{{friend.name}}</td>
             <td>{{friend.phone}}</td>
           </tr>
         </table>
         <hr>
         <label>Any: <input ng-model="search.$"></label> <br>
         <label>Name only <input ng-model="search.name"></label><br>
         <label>Phone only <input ng-model="search.phone"></label><br>
         <label>Equality <input type="checkbox" ng-model="strict"></label><br>
         <table id="searchObjResults">
           <tr><th>Name</th><th>Phone</th></tr>
           <tr ng-repeat="friendObj in friends | filter:search:strict">
             <td>{{friendObj.name}}</td>
             <td>{{friendObj.phone}}</td>
           </tr>
         </table>
       </file>
       <file name="protractor.js" type="protractor">
         var expectFriendNames = function(expectedNames, key) {
           element.all(by.repeater(key + ' in friends').column(key + '.name')).then(function(arr) {
             arr.forEach(function(wd, i) {
               expect(wd.getText()).toMatch(expectedNames[i]);
             });
           });
         };
  
         it('should search across all fields when filtering with a string', function() {
           var searchText = element(by.model('searchText'));
           searchText.clear();
           searchText.sendKeys('m');
           expectFriendNames(['Mary', 'Mike', 'Adam'], 'friend');
  
           searchText.clear();
           searchText.sendKeys('76');
           expectFriendNames(['John', 'Julie'], 'friend');
         });
  
         it('should search in specific fields when filtering with a predicate object', function() {
           var searchAny = element(by.model('search.$'));
           searchAny.clear();
           searchAny.sendKeys('i');
           expectFriendNames(['Mary', 'Mike', 'Julie', 'Juliette'], 'friendObj');
         });
         it('should use a equal comparison when comparator is true', function() {
           var searchName = element(by.model('search.name'));
           var strict = element(by.model('strict'));
           searchName.clear();
           searchName.sendKeys('Julie');
           strict.click();
           expectFriendNames(['Julie'], 'friendObj');
         });
       </file>
     </example>
   */

  function filterFilter() {
    return function (array, expression, comparator, anyPropertyKey) {
      if (!isArrayLike(array)) {
        if (array == null) {
          return array;
        } else {
          throw minErr('filter')('notarray', 'Expected array but received: {0}', array);
        }
      }
      anyPropertyKey = anyPropertyKey || '$';
      var expressionType = getTypeForFilter(expression);
      var predicateFn;
      var matchAgainstAnyProp;
      switch (expressionType) {
        case 'function':
          predicateFn = expression;
          break;
        case 'boolean':
        case 'null':
        case 'number':
        case 'string':
          matchAgainstAnyProp = true;
        // falls through
        case 'object':
          predicateFn = createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp);
          break;
        default:
          return array;
      }
      return Array.prototype.filter.call(array, predicateFn);
    };
  }

  // Helper functions for `filterFilter`
  function createPredicateFn(expression, comparator, anyPropertyKey, matchAgainstAnyProp) {
    var shouldMatchPrimitives = isObject(expression) && anyPropertyKey in expression;
    var predicateFn;
    if (comparator === true) {
      comparator = equals;
    } else if (!isFunction(comparator)) {
      comparator = function comparator(actual, expected) {
        if (isUndefined(actual)) {
          // No substring matching against `undefined`
          return false;
        }
        if (actual === null || expected === null) {
          // No substring matching against `null`; only match against `null`
          return actual === expected;
        }
        if (isObject(expected) || isObject(actual) && !hasCustomToString(actual)) {
          // Should not compare primitives against objects, unless they have custom `toString` method
          return false;
        }
        actual = lowercase('' + actual);
        expected = lowercase('' + expected);
        return actual.indexOf(expected) !== -1;
      };
    }
    predicateFn = function predicateFn(item) {
      if (shouldMatchPrimitives && !isObject(item)) {
        return deepCompare(item, expression[anyPropertyKey], comparator, anyPropertyKey, false);
      }
      return deepCompare(item, expression, comparator, anyPropertyKey, matchAgainstAnyProp);
    };
    return predicateFn;
  }
  function deepCompare(actual, expected, comparator, anyPropertyKey, matchAgainstAnyProp, dontMatchWholeObject) {
    var actualType = getTypeForFilter(actual);
    var expectedType = getTypeForFilter(expected);
    if (expectedType === 'string' && expected.charAt(0) === '!') {
      return !deepCompare(actual, expected.substring(1), comparator, anyPropertyKey, matchAgainstAnyProp);
    } else if (isArray(actual)) {
      // In case `actual` is an array, consider it a match
      // if ANY of it's items matches `expected`
      return actual.some(function (item) {
        return deepCompare(item, expected, comparator, anyPropertyKey, matchAgainstAnyProp);
      });
    }
    switch (actualType) {
      case 'object':
        var key;
        if (matchAgainstAnyProp) {
          for (key in actual) {
            // Under certain, rare, circumstances, key may not be a string and `charAt` will be undefined
            // See: https://github.com/angular/angular.js/issues/15644
            if (key.charAt && key.charAt(0) !== '$' && deepCompare(actual[key], expected, comparator, anyPropertyKey, true)) {
              return true;
            }
          }
          return dontMatchWholeObject ? false : deepCompare(actual, expected, comparator, anyPropertyKey, false);
        } else if (expectedType === 'object') {
          for (key in expected) {
            var expectedVal = expected[key];
            if (isFunction(expectedVal) || isUndefined(expectedVal)) {
              continue;
            }
            var matchAnyProperty = key === anyPropertyKey;
            var actualVal = matchAnyProperty ? actual : actual[key];
            if (!deepCompare(actualVal, expectedVal, comparator, anyPropertyKey, matchAnyProperty, matchAnyProperty)) {
              return false;
            }
          }
          return true;
        } else {
          return comparator(actual, expected);
        }
      case 'function':
        return false;
      default:
        return comparator(actual, expected);
    }
  }

  // Used for easily differentiating between `null` and actual `object`
  function getTypeForFilter(val) {
    return val === null ? 'null' : _typeof(val);
  }
  var MAX_DIGITS = 22;
  var DECIMAL_SEP = '.';
  var ZERO_CHAR = '0';

  /**
   * @ngdoc filter
   * @name currency
   * @kind function
   *
   * @description
   * Formats a number as a currency (ie $1,234.56). When no currency symbol is provided, default
   * symbol for current locale is used.
   *
   * @param {number} amount Input to filter.
   * @param {string=} symbol Currency symbol or identifier to be displayed.
   * @param {number=} fractionSize Number of decimal places to round the amount to, defaults to default max fraction size for current locale
   * @returns {string} Formatted number.
   *
   *
   * @example
     <example module="currencyExample" name="currency-filter">
       <file name="index.html">
         <script>
           angular.module('currencyExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.amount = 1234.56;
             }]);
         </script>
         <div ng-controller="ExampleController">
           <input type="number" ng-model="amount" aria-label="amount"> <br>
           default currency symbol ($): <span id="currency-default">{{amount | currency}}</span><br>
           custom currency identifier (USD$): <span id="currency-custom">{{amount | currency:"USD$"}}</span><br>
           no fractions (0): <span id="currency-no-fractions">{{amount | currency:"USD$":0}}</span>
         </div>
       </file>
       <file name="protractor.js" type="protractor">
         it('should init with 1234.56', function() {
           expect(element(by.id('currency-default')).getText()).toBe('$1,234.56');
           expect(element(by.id('currency-custom')).getText()).toBe('USD$1,234.56');
           expect(element(by.id('currency-no-fractions')).getText()).toBe('USD$1,235');
         });
         it('should update', function() {
           if (browser.params.browser === 'safari') {
             // Safari does not understand the minus key. See
             // https://github.com/angular/protractor/issues/481
             return;
           }
           element(by.model('amount')).clear();
           element(by.model('amount')).sendKeys('-1234');
           expect(element(by.id('currency-default')).getText()).toBe('-$1,234.00');
           expect(element(by.id('currency-custom')).getText()).toBe('-USD$1,234.00');
           expect(element(by.id('currency-no-fractions')).getText()).toBe('-USD$1,234');
         });
       </file>
     </example>
   */
  currencyFilter.$inject = ['$locale'];
  function currencyFilter($locale) {
    var formats = $locale.NUMBER_FORMATS;
    return function (amount, currencySymbol, fractionSize) {
      if (isUndefined(currencySymbol)) {
        currencySymbol = formats.CURRENCY_SYM;
      }
      if (isUndefined(fractionSize)) {
        fractionSize = formats.PATTERNS[1].maxFrac;
      }

      // If the currency symbol is empty, trim whitespace around the symbol
      var currencySymbolRe = !currencySymbol ? /\s*\u00A4\s*/g : /\u00A4/g;

      // if null or undefined pass it through
      return amount == null ? amount : formatNumber(amount, formats.PATTERNS[1], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize).replace(currencySymbolRe, currencySymbol);
    };
  }

  /**
   * @ngdoc filter
   * @name number
   * @kind function
   *
   * @description
   * Formats a number as text.
   *
   * If the input is null or undefined, it will just be returned.
   * If the input is infinite (Infinity or -Infinity), the Infinity symbol '∞' or '-∞' is returned, respectively.
   * If the input is not a number an empty string is returned.
   *
   *
   * @param {number|string} number Number to format.
   * @param {(number|string)=} fractionSize Number of decimal places to round the number to.
   * If this is not provided then the fraction size is computed from the current locale's number
   * formatting pattern. In the case of the default locale, it will be 3.
   * @returns {string} Number rounded to `fractionSize` appropriately formatted based on the current
   *                   locale (e.g., in the en_US locale it will have "." as the decimal separator and
   *                   include "," group separators after each third digit).
   *
   * @example
     <example module="numberFilterExample" name="number-filter">
       <file name="index.html">
         <script>
           angular.module('numberFilterExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.val = 1234.56789;
             }]);
         </script>
         <div ng-controller="ExampleController">
           <label>Enter number: <input ng-model='val'></label><br>
           Default formatting: <span id='number-default'>{{val | number}}</span><br>
           No fractions: <span>{{val | number:0}}</span><br>
           Negative number: <span>{{-val | number:4}}</span>
         </div>
       </file>
       <file name="protractor.js" type="protractor">
         it('should format numbers', function() {
           expect(element(by.id('number-default')).getText()).toBe('1,234.568');
           expect(element(by.binding('val | number:0')).getText()).toBe('1,235');
           expect(element(by.binding('-val | number:4')).getText()).toBe('-1,234.5679');
         });
  
         it('should update', function() {
           element(by.model('val')).clear();
           element(by.model('val')).sendKeys('3374.333');
           expect(element(by.id('number-default')).getText()).toBe('3,374.333');
           expect(element(by.binding('val | number:0')).getText()).toBe('3,374');
           expect(element(by.binding('-val | number:4')).getText()).toBe('-3,374.3330');
        });
       </file>
     </example>
   */
  numberFilter.$inject = ['$locale'];
  function numberFilter($locale) {
    var formats = $locale.NUMBER_FORMATS;
    return function (number, fractionSize) {
      // if null or undefined pass it through
      return number == null ? number : formatNumber(number, formats.PATTERNS[0], formats.GROUP_SEP, formats.DECIMAL_SEP, fractionSize);
    };
  }

  /**
   * Parse a number (as a string) into three components that can be used
   * for formatting the number.
   *
   * (Significant bits of this parse algorithm came from https://github.com/MikeMcl/big.js/)
   *
   * @param  {string} numStr The number to parse
   * @return {object} An object describing this number, containing the following keys:
   *  - d : an array of digits containing leading zeros as necessary
   *  - i : the number of the digits in `d` that are to the left of the decimal point
   *  - e : the exponent for numbers that would need more than `MAX_DIGITS` digits in `d`
   *
   */
  function parse(numStr) {
    var exponent = 0,
      digits,
      numberOfIntegerDigits;
    var i, j, zeros;

    // Decimal point?
    if ((numberOfIntegerDigits = numStr.indexOf(DECIMAL_SEP)) > -1) {
      numStr = numStr.replace(DECIMAL_SEP, '');
    }

    // Exponential form?
    if ((i = numStr.search(/e/i)) > 0) {
      // Work out the exponent.
      if (numberOfIntegerDigits < 0) numberOfIntegerDigits = i;
      numberOfIntegerDigits += +numStr.slice(i + 1);
      numStr = numStr.substring(0, i);
    } else if (numberOfIntegerDigits < 0) {
      // There was no decimal point or exponent so it is an integer.
      numberOfIntegerDigits = numStr.length;
    }

    // Count the number of leading zeros.
    for (i = 0; numStr.charAt(i) === ZERO_CHAR; i++) {/* empty */}
    if (i === (zeros = numStr.length)) {
      // The digits are all zero.
      digits = [0];
      numberOfIntegerDigits = 1;
    } else {
      // Count the number of trailing zeros
      zeros--;
      while (numStr.charAt(zeros) === ZERO_CHAR) zeros--;

      // Trailing zeros are insignificant so ignore them
      numberOfIntegerDigits -= i;
      digits = [];
      // Convert string to array of digits without leading/trailing zeros.
      for (j = 0; i <= zeros; i++, j++) {
        digits[j] = +numStr.charAt(i);
      }
    }

    // If the number overflows the maximum allowed digits then use an exponent.
    if (numberOfIntegerDigits > MAX_DIGITS) {
      digits = digits.splice(0, MAX_DIGITS - 1);
      exponent = numberOfIntegerDigits - 1;
      numberOfIntegerDigits = 1;
    }
    return {
      d: digits,
      e: exponent,
      i: numberOfIntegerDigits
    };
  }

  /**
   * Round the parsed number to the specified number of decimal places
   * This function changed the parsedNumber in-place
   */
  function roundNumber(parsedNumber, fractionSize, minFrac, maxFrac) {
    var digits = parsedNumber.d;
    var fractionLen = digits.length - parsedNumber.i;

    // determine fractionSize if it is not specified; `+fractionSize` converts it to a number
    fractionSize = isUndefined(fractionSize) ? Math.min(Math.max(minFrac, fractionLen), maxFrac) : +fractionSize;

    // The index of the digit to where rounding is to occur
    var roundAt = fractionSize + parsedNumber.i;
    var digit = digits[roundAt];
    if (roundAt > 0) {
      // Drop fractional digits beyond `roundAt`
      digits.splice(Math.max(parsedNumber.i, roundAt));

      // Set non-fractional digits beyond `roundAt` to 0
      for (var j = roundAt; j < digits.length; j++) {
        digits[j] = 0;
      }
    } else {
      // We rounded to zero so reset the parsedNumber
      fractionLen = Math.max(0, fractionLen);
      parsedNumber.i = 1;
      digits.length = Math.max(1, roundAt = fractionSize + 1);
      digits[0] = 0;
      for (var i = 1; i < roundAt; i++) digits[i] = 0;
    }
    if (digit >= 5) {
      if (roundAt - 1 < 0) {
        for (var k = 0; k > roundAt; k--) {
          digits.unshift(0);
          parsedNumber.i++;
        }
        digits.unshift(1);
        parsedNumber.i++;
      } else {
        digits[roundAt - 1]++;
      }
    }

    // Pad out with zeros to get the required fraction length
    for (; fractionLen < Math.max(0, fractionSize); fractionLen++) digits.push(0);

    // Do any carrying, e.g. a digit was rounded up to 10
    var carry = digits.reduceRight(function (carry, d, i, digits) {
      d = d + carry;
      digits[i] = d % 10;
      return Math.floor(d / 10);
    }, 0);
    if (carry) {
      digits.unshift(carry);
      parsedNumber.i++;
    }
  }

  /**
   * Format a number into a string
   * @param  {number} number       The number to format
   * @param  {{
   *           minFrac, // the minimum number of digits required in the fraction part of the number
   *           maxFrac, // the maximum number of digits required in the fraction part of the number
   *           gSize,   // number of digits in each group of separated digits
   *           lgSize,  // number of digits in the last group of digits before the decimal separator
   *           negPre,  // the string to go in front of a negative number (e.g. `-` or `(`))
   *           posPre,  // the string to go in front of a positive number
   *           negSuf,  // the string to go after a negative number (e.g. `)`)
   *           posSuf   // the string to go after a positive number
   *         }} pattern
   * @param  {string} groupSep     The string to separate groups of number (e.g. `,`)
   * @param  {string} decimalSep   The string to act as the decimal separator (e.g. `.`)
   * @param  {[type]} fractionSize The size of the fractional part of the number
   * @return {string}              The number formatted as a string
   */
  function formatNumber(number, pattern, groupSep, decimalSep, fractionSize) {
    if (!(isString(number) || isNumber(number)) || isNaN(number)) return '';
    var isInfinity = !isFinite(number);
    var isZero = false;
    var numStr = Math.abs(number) + '',
      formattedText = '',
      parsedNumber;
    if (isInfinity) {
      formattedText = "\u221E";
    } else {
      parsedNumber = parse(numStr);
      roundNumber(parsedNumber, fractionSize, pattern.minFrac, pattern.maxFrac);
      var digits = parsedNumber.d;
      var integerLen = parsedNumber.i;
      var exponent = parsedNumber.e;
      var decimals = [];
      isZero = digits.reduce(function (isZero, d) {
        return isZero && !d;
      }, true);

      // pad zeros for small numbers
      while (integerLen < 0) {
        digits.unshift(0);
        integerLen++;
      }

      // extract decimals digits
      if (integerLen > 0) {
        decimals = digits.splice(integerLen, digits.length);
      } else {
        decimals = digits;
        digits = [0];
      }

      // format the integer digits with grouping separators
      var groups = [];
      if (digits.length >= pattern.lgSize) {
        groups.unshift(digits.splice(-pattern.lgSize, digits.length).join(''));
      }
      while (digits.length > pattern.gSize) {
        groups.unshift(digits.splice(-pattern.gSize, digits.length).join(''));
      }
      if (digits.length) {
        groups.unshift(digits.join(''));
      }
      formattedText = groups.join(groupSep);

      // append the decimal digits
      if (decimals.length) {
        formattedText += decimalSep + decimals.join('');
      }
      if (exponent) {
        formattedText += 'e+' + exponent;
      }
    }
    if (number < 0 && !isZero) {
      return pattern.negPre + formattedText + pattern.negSuf;
    } else {
      return pattern.posPre + formattedText + pattern.posSuf;
    }
  }
  function padNumber(num, digits, trim, negWrap) {
    var neg = '';
    if (num < 0 || negWrap && num <= 0) {
      if (negWrap) {
        num = -num + 1;
      } else {
        num = -num;
        neg = '-';
      }
    }
    num = '' + num;
    while (num.length < digits) num = ZERO_CHAR + num;
    if (trim) {
      num = num.substr(num.length - digits);
    }
    return neg + num;
  }
  function dateGetter(name, size, offset, trim, negWrap) {
    offset = offset || 0;
    return function (date) {
      var value = date['get' + name]();
      if (offset > 0 || value > -offset) {
        value += offset;
      }
      if (value === 0 && offset === -12) value = 12;
      return padNumber(value, size, trim, negWrap);
    };
  }
  function dateStrGetter(name, shortForm, standAlone) {
    return function (date, formats) {
      var value = date['get' + name]();
      var propPrefix = (standAlone ? 'STANDALONE' : '') + (shortForm ? 'SHORT' : '');
      var get = uppercase(propPrefix + name);
      return formats[get][value];
    };
  }
  function timeZoneGetter(date, formats, offset) {
    var zone = -1 * offset;
    var paddedZone = zone >= 0 ? '+' : '';
    paddedZone += padNumber(Math[zone > 0 ? 'floor' : 'ceil'](zone / 60), 2) + padNumber(Math.abs(zone % 60), 2);
    return paddedZone;
  }
  function getFirstThursdayOfYear(year) {
    // 0 = index of January
    var dayOfWeekOnFirst = new Date(year, 0, 1).getDay();
    // 4 = index of Thursday (+1 to account for 1st = 5)
    // 11 = index of *next* Thursday (+1 account for 1st = 12)
    return new Date(year, 0, (dayOfWeekOnFirst <= 4 ? 5 : 12) - dayOfWeekOnFirst);
  }
  function getThursdayThisWeek(datetime) {
    return new Date(datetime.getFullYear(), datetime.getMonth(),
    // 4 = index of Thursday
    datetime.getDate() + (4 - datetime.getDay()));
  }
  function weekGetter(size) {
    return function (date) {
      var firstThurs = getFirstThursdayOfYear(date.getFullYear()),
        thisThurs = getThursdayThisWeek(date);
      var diff = +thisThurs - +firstThurs,
        result = 1 + Math.round(diff / 6.048e8); // 6.048e8 ms per week

      return padNumber(result, size);
    };
  }
  function ampmGetter(date, formats) {
    return date.getHours() < 12 ? formats.AMPMS[0] : formats.AMPMS[1];
  }
  function eraGetter(date, formats) {
    return date.getFullYear() <= 0 ? formats.ERAS[0] : formats.ERAS[1];
  }
  function longEraGetter(date, formats) {
    return date.getFullYear() <= 0 ? formats.ERANAMES[0] : formats.ERANAMES[1];
  }
  var DATE_FORMATS = {
    yyyy: dateGetter('FullYear', 4, 0, false, true),
    yy: dateGetter('FullYear', 2, 0, true, true),
    y: dateGetter('FullYear', 1, 0, false, true),
    MMMM: dateStrGetter('Month'),
    MMM: dateStrGetter('Month', true),
    MM: dateGetter('Month', 2, 1),
    M: dateGetter('Month', 1, 1),
    LLLL: dateStrGetter('Month', false, true),
    dd: dateGetter('Date', 2),
    d: dateGetter('Date', 1),
    HH: dateGetter('Hours', 2),
    H: dateGetter('Hours', 1),
    hh: dateGetter('Hours', 2, -12),
    h: dateGetter('Hours', 1, -12),
    mm: dateGetter('Minutes', 2),
    m: dateGetter('Minutes', 1),
    ss: dateGetter('Seconds', 2),
    s: dateGetter('Seconds', 1),
    // while ISO 8601 requires fractions to be prefixed with `.` or `,`
    // we can be just safely rely on using `sss` since we currently don't support single or two digit fractions
    sss: dateGetter('Milliseconds', 3),
    EEEE: dateStrGetter('Day'),
    EEE: dateStrGetter('Day', true),
    a: ampmGetter,
    Z: timeZoneGetter,
    ww: weekGetter(2),
    w: weekGetter(1),
    G: eraGetter,
    GG: eraGetter,
    GGG: eraGetter,
    GGGG: longEraGetter
  };
  var DATE_FORMATS_SPLIT = /((?:[^yMLdHhmsaZEwG']+)|(?:'(?:[^']|'')*')|(?:E+|y+|M+|L+|d+|H+|h+|m+|s+|a|Z|G+|w+))([\s\S]*)/,
    NUMBER_STRING = /^-?\d+$/;

  /**
   * @ngdoc filter
   * @name date
   * @kind function
   *
   * @description
   *   Formats `date` to a string based on the requested `format`.
   *
   *   `format` string can be composed of the following elements:
   *
   *   * `'yyyy'`: 4 digit representation of year (e.g. AD 1 => 0001, AD 2010 => 2010)
   *   * `'yy'`: 2 digit representation of year, padded (00-99). (e.g. AD 2001 => 01, AD 2010 => 10)
   *   * `'y'`: 1 digit representation of year, e.g. (AD 1 => 1, AD 199 => 199)
   *   * `'MMMM'`: Month in year (January-December)
   *   * `'MMM'`: Month in year (Jan-Dec)
   *   * `'MM'`: Month in year, padded (01-12)
   *   * `'M'`: Month in year (1-12)
   *   * `'LLLL'`: Stand-alone month in year (January-December)
   *   * `'dd'`: Day in month, padded (01-31)
   *   * `'d'`: Day in month (1-31)
   *   * `'EEEE'`: Day in Week,(Sunday-Saturday)
   *   * `'EEE'`: Day in Week, (Sun-Sat)
   *   * `'HH'`: Hour in day, padded (00-23)
   *   * `'H'`: Hour in day (0-23)
   *   * `'hh'`: Hour in AM/PM, padded (01-12)
   *   * `'h'`: Hour in AM/PM, (1-12)
   *   * `'mm'`: Minute in hour, padded (00-59)
   *   * `'m'`: Minute in hour (0-59)
   *   * `'ss'`: Second in minute, padded (00-59)
   *   * `'s'`: Second in minute (0-59)
   *   * `'sss'`: Millisecond in second, padded (000-999)
   *   * `'a'`: AM/PM marker
   *   * `'Z'`: 4 digit (+sign) representation of the timezone offset (-1200-+1200)
   *   * `'ww'`: Week of year, padded (00-53). Week 01 is the week with the first Thursday of the year
   *   * `'w'`: Week of year (0-53). Week 1 is the week with the first Thursday of the year
   *   * `'G'`, `'GG'`, `'GGG'`: The abbreviated form of the era string (e.g. 'AD')
   *   * `'GGGG'`: The long form of the era string (e.g. 'Anno Domini')
   *
   *   `format` string can also be one of the following predefined
   *   {@link guide/i18n localizable formats}:
   *
   *   * `'medium'`: equivalent to `'MMM d, y h:mm:ss a'` for en_US locale
   *     (e.g. Sep 3, 2010 12:05:08 PM)
   *   * `'short'`: equivalent to `'M/d/yy h:mm a'` for en_US  locale (e.g. 9/3/10 12:05 PM)
   *   * `'fullDate'`: equivalent to `'EEEE, MMMM d, y'` for en_US  locale
   *     (e.g. Friday, September 3, 2010)
   *   * `'longDate'`: equivalent to `'MMMM d, y'` for en_US  locale (e.g. September 3, 2010)
   *   * `'mediumDate'`: equivalent to `'MMM d, y'` for en_US  locale (e.g. Sep 3, 2010)
   *   * `'shortDate'`: equivalent to `'M/d/yy'` for en_US locale (e.g. 9/3/10)
   *   * `'mediumTime'`: equivalent to `'h:mm:ss a'` for en_US locale (e.g. 12:05:08 PM)
   *   * `'shortTime'`: equivalent to `'h:mm a'` for en_US locale (e.g. 12:05 PM)
   *
   *   `format` string can contain literal values. These need to be escaped by surrounding with single quotes (e.g.
   *   `"h 'in the morning'"`). In order to output a single quote, escape it - i.e., two single quotes in a sequence
   *   (e.g. `"h 'o''clock'"`).
   *
   *   Any other characters in the `format` string will be output as-is.
   *
   * @param {(Date|number|string)} date Date to format either as Date object, milliseconds (string or
   *    number) or various ISO 8601 datetime string formats (e.g. yyyy-MM-ddTHH:mm:ss.sssZ and its
   *    shorter versions like yyyy-MM-ddTHH:mmZ, yyyy-MM-dd or yyyyMMddTHHmmssZ). If no timezone is
   *    specified in the string input, the time is considered to be in the local timezone.
   * @param {string=} format Formatting rules (see Description). If not specified,
   *    `mediumDate` is used.
   * @param {string=} timezone Timezone to be used for formatting. It understands UTC/GMT and the
   *    continental US time zone abbreviations, but for general use, use a time zone offset, for
   *    example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
   *    If not specified, the timezone of the browser will be used.
   * @returns {string} Formatted string or the input if input is not recognized as date/millis.
   *
   * @example
     <example name="filter-date">
       <file name="index.html">
         <span ng-non-bindable>{{1288323623006 | date:'medium'}}</span>:
             <span>{{1288323623006 | date:'medium'}}</span><br>
         <span ng-non-bindable>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span>:
            <span>{{1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'}}</span><br>
         <span ng-non-bindable>{{1288323623006 | date:'MM/dd/yyyy @ h:mma'}}</span>:
            <span>{{'1288323623006' | date:'MM/dd/yyyy @ h:mma'}}</span><br>
         <span ng-non-bindable>{{1288323623006 | date:"MM/dd/yyyy 'at' h:mma"}}</span>:
            <span>{{'1288323623006' | date:"MM/dd/yyyy 'at' h:mma"}}</span><br>
       </file>
       <file name="protractor.js" type="protractor">
         it('should format date', function() {
           expect(element(by.binding("1288323623006 | date:'medium'")).getText()).
              toMatch(/Oct 2\d, 2010 \d{1,2}:\d{2}:\d{2} (AM|PM)/);
           expect(element(by.binding("1288323623006 | date:'yyyy-MM-dd HH:mm:ss Z'")).getText()).
              toMatch(/2010-10-2\d \d{2}:\d{2}:\d{2} (-|\+)?\d{4}/);
           expect(element(by.binding("'1288323623006' | date:'MM/dd/yyyy @ h:mma'")).getText()).
              toMatch(/10\/2\d\/2010 @ \d{1,2}:\d{2}(AM|PM)/);
           expect(element(by.binding("'1288323623006' | date:\"MM/dd/yyyy 'at' h:mma\"")).getText()).
              toMatch(/10\/2\d\/2010 at \d{1,2}:\d{2}(AM|PM)/);
         });
       </file>
     </example>
   */
  dateFilter.$inject = ['$locale'];
  function dateFilter($locale) {
    var R_ISO8601_STR = /^(\d{4})-?(\d\d)-?(\d\d)(?:T(\d\d)(?::?(\d\d)(?::?(\d\d)(?:\.(\d+))?)?)?(Z|([+-])(\d\d):?(\d\d))?)?$/;
    // 1        2       3         4          5          6          7          8  9     10      11
    function jsonStringToDate(string) {
      var match;
      if (match = string.match(R_ISO8601_STR)) {
        var date = new Date(0),
          tzHour = 0,
          tzMin = 0,
          dateSetter = match[8] ? date.setUTCFullYear : date.setFullYear,
          timeSetter = match[8] ? date.setUTCHours : date.setHours;
        if (match[9]) {
          tzHour = toInt(match[9] + match[10]);
          tzMin = toInt(match[9] + match[11]);
        }
        dateSetter.call(date, toInt(match[1]), toInt(match[2]) - 1, toInt(match[3]));
        var h = toInt(match[4] || 0) - tzHour;
        var m = toInt(match[5] || 0) - tzMin;
        var s = toInt(match[6] || 0);
        var ms = Math.round(parseFloat('0.' + (match[7] || 0)) * 1000);
        timeSetter.call(date, h, m, s, ms);
        return date;
      }
      return string;
    }
    return function (date, format, timezone) {
      var text = '',
        parts = [],
        fn,
        match;
      format = format || 'mediumDate';
      format = $locale.DATETIME_FORMATS[format] || format;
      if (isString(date)) {
        date = NUMBER_STRING.test(date) ? toInt(date) : jsonStringToDate(date);
      }
      if (isNumber(date)) {
        date = new Date(date);
      }
      if (!isDate(date) || !isFinite(date.getTime())) {
        return date;
      }
      while (format) {
        match = DATE_FORMATS_SPLIT.exec(format);
        if (match) {
          parts = concat(parts, match, 1);
          format = parts.pop();
        } else {
          parts.push(format);
          format = null;
        }
      }
      var dateTimezoneOffset = date.getTimezoneOffset();
      if (timezone) {
        dateTimezoneOffset = timezoneToOffset(timezone, dateTimezoneOffset);
        date = convertTimezoneToLocal(date, timezone, true);
      }
      forEach(parts, function (value) {
        fn = DATE_FORMATS[value];
        text += fn ? fn(date, $locale.DATETIME_FORMATS, dateTimezoneOffset) : value === '\'\'' ? '\'' : value.replace(/(^'|'$)/g, '').replace(/''/g, '\'');
      });
      return text;
    };
  }

  /**
   * @ngdoc filter
   * @name json
   * @kind function
   *
   * @description
   *   Allows you to convert a JavaScript object into JSON string.
   *
   *   This filter is mostly useful for debugging. When using the double curly {{value}} notation
   *   the binding is automatically converted to JSON.
   *
   * @param {*} object Any JavaScript object (including arrays and primitive types) to filter.
   * @param {number=} spacing The number of spaces to use per indentation, defaults to 2.
   * @returns {string} JSON string.
   *
   *
   * @example
     <example name="filter-json">
       <file name="index.html">
         <pre id="default-spacing">{{ {'name':'value'} | json }}</pre>
         <pre id="custom-spacing">{{ {'name':'value'} | json:4 }}</pre>
       </file>
       <file name="protractor.js" type="protractor">
         it('should jsonify filtered objects', function() {
           expect(element(by.id('default-spacing')).getText()).toMatch(/\{\n {2}"name": ?"value"\n}/);
           expect(element(by.id('custom-spacing')).getText()).toMatch(/\{\n {4}"name": ?"value"\n}/);
         });
       </file>
     </example>
   *
   */
  function jsonFilter() {
    return function (object, spacing) {
      if (isUndefined(spacing)) {
        spacing = 2;
      }
      return toJson(object, spacing);
    };
  }

  /**
   * @ngdoc filter
   * @name lowercase
   * @kind function
   * @description
   * Converts string to lowercase.
   *
   * See the {@link ng.uppercase uppercase filter documentation} for a functionally identical example.
   *
   * @see angular.lowercase
   */
  var lowercaseFilter = valueFn(lowercase);

  /**
   * @ngdoc filter
   * @name uppercase
   * @kind function
   * @description
   * Converts string to uppercase.
   * @example
     <example module="uppercaseFilterExample" name="filter-uppercase">
       <file name="index.html">
         <script>
           angular.module('uppercaseFilterExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.title = 'This is a title';
             }]);
         </script>
         <div ng-controller="ExampleController">
           <!-- This title should be formatted normally -->
           <h1>{{title}}</h1>
           <!-- This title should be capitalized -->
           <h1>{{title | uppercase}}</h1>
         </div>
       </file>
     </example>
   */
  var uppercaseFilter = valueFn(uppercase);

  /**
   * @ngdoc filter
   * @name limitTo
   * @kind function
   *
   * @description
   * Creates a new array or string containing only a specified number of elements. The elements are
   * taken from either the beginning or the end of the source array, string or number, as specified by
   * the value and sign (positive or negative) of `limit`. Other array-like objects are also supported
   * (e.g. array subclasses, NodeLists, jqLite/jQuery collections etc). If a number is used as input,
   * it is converted to a string.
   *
   * @param {Array|ArrayLike|string|number} input - Array/array-like, string or number to be limited.
   * @param {string|number} limit - The length of the returned array or string. If the `limit` number
   *     is positive, `limit` number of items from the beginning of the source array/string are copied.
   *     If the number is negative, `limit` number  of items from the end of the source array/string
   *     are copied. The `limit` will be trimmed if it exceeds `array.length`. If `limit` is undefined,
   *     the input will be returned unchanged.
   * @param {(string|number)=} begin - Index at which to begin limitation. As a negative index,
   *     `begin` indicates an offset from the end of `input`. Defaults to `0`.
   * @returns {Array|string} A new sub-array or substring of length `limit` or less if the input had
   *     less than `limit` elements.
   *
   * @example
     <example module="limitToExample" name="limit-to-filter">
       <file name="index.html">
         <script>
           angular.module('limitToExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.numbers = [1,2,3,4,5,6,7,8,9];
               $scope.letters = "abcdefghi";
               $scope.longNumber = 2345432342;
               $scope.numLimit = 3;
               $scope.letterLimit = 3;
               $scope.longNumberLimit = 3;
             }]);
         </script>
         <div ng-controller="ExampleController">
           <label>
              Limit {{numbers}} to:
              <input type="number" step="1" ng-model="numLimit">
           </label>
           <p>Output numbers: {{ numbers | limitTo:numLimit }}</p>
           <label>
              Limit {{letters}} to:
              <input type="number" step="1" ng-model="letterLimit">
           </label>
           <p>Output letters: {{ letters | limitTo:letterLimit }}</p>
           <label>
              Limit {{longNumber}} to:
              <input type="number" step="1" ng-model="longNumberLimit">
           </label>
           <p>Output long number: {{ longNumber | limitTo:longNumberLimit }}</p>
         </div>
       </file>
       <file name="protractor.js" type="protractor">
         var numLimitInput = element(by.model('numLimit'));
         var letterLimitInput = element(by.model('letterLimit'));
         var longNumberLimitInput = element(by.model('longNumberLimit'));
         var limitedNumbers = element(by.binding('numbers | limitTo:numLimit'));
         var limitedLetters = element(by.binding('letters | limitTo:letterLimit'));
         var limitedLongNumber = element(by.binding('longNumber | limitTo:longNumberLimit'));
  
         it('should limit the number array to first three items', function() {
           expect(numLimitInput.getAttribute('value')).toBe('3');
           expect(letterLimitInput.getAttribute('value')).toBe('3');
           expect(longNumberLimitInput.getAttribute('value')).toBe('3');
           expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3]');
           expect(limitedLetters.getText()).toEqual('Output letters: abc');
           expect(limitedLongNumber.getText()).toEqual('Output long number: 234');
         });
  
         // There is a bug in safari and protractor that doesn't like the minus key
         // it('should update the output when -3 is entered', function() {
         //   numLimitInput.clear();
         //   numLimitInput.sendKeys('-3');
         //   letterLimitInput.clear();
         //   letterLimitInput.sendKeys('-3');
         //   longNumberLimitInput.clear();
         //   longNumberLimitInput.sendKeys('-3');
         //   expect(limitedNumbers.getText()).toEqual('Output numbers: [7,8,9]');
         //   expect(limitedLetters.getText()).toEqual('Output letters: ghi');
         //   expect(limitedLongNumber.getText()).toEqual('Output long number: 342');
         // });
  
         it('should not exceed the maximum size of input array', function() {
           numLimitInput.clear();
           numLimitInput.sendKeys('100');
           letterLimitInput.clear();
           letterLimitInput.sendKeys('100');
           longNumberLimitInput.clear();
           longNumberLimitInput.sendKeys('100');
           expect(limitedNumbers.getText()).toEqual('Output numbers: [1,2,3,4,5,6,7,8,9]');
           expect(limitedLetters.getText()).toEqual('Output letters: abcdefghi');
           expect(limitedLongNumber.getText()).toEqual('Output long number: 2345432342');
         });
       </file>
     </example>
  */
  function limitToFilter() {
    return function (input, limit, begin) {
      if (Math.abs(Number(limit)) === Infinity) {
        limit = Number(limit);
      } else {
        limit = toInt(limit);
      }
      if (isNumberNaN(limit)) return input;
      if (isNumber(input)) input = input.toString();
      if (!isArrayLike(input)) return input;
      begin = !begin || isNaN(begin) ? 0 : toInt(begin);
      begin = begin < 0 ? Math.max(0, input.length + begin) : begin;
      if (limit >= 0) {
        return sliceFn(input, begin, begin + limit);
      } else {
        if (begin === 0) {
          return sliceFn(input, limit, input.length);
        } else {
          return sliceFn(input, Math.max(0, begin + limit), begin);
        }
      }
    };
  }
  function sliceFn(input, begin, end) {
    if (isString(input)) return input.slice(begin, end);
    return slice.call(input, begin, end);
  }

  /**
   * @ngdoc filter
   * @name orderBy
   * @kind function
   *
   * @description
   * Returns an array containing the items from the specified `collection`, ordered by a `comparator`
   * function based on the values computed using the `expression` predicate.
   *
   * For example, `[{id: 'foo'}, {id: 'bar'}] | orderBy:'id'` would result in
   * `[{id: 'bar'}, {id: 'foo'}]`.
   *
   * The `collection` can be an Array or array-like object (e.g. NodeList, jQuery object, TypedArray,
   * String, etc).
   *
   * The `expression` can be a single predicate, or a list of predicates each serving as a tie-breaker
   * for the preceding one. The `expression` is evaluated against each item and the output is used
   * for comparing with other items.
   *
   * You can change the sorting order by setting `reverse` to `true`. By default, items are sorted in
   * ascending order.
   *
   * The comparison is done using the `comparator` function. If none is specified, a default, built-in
   * comparator is used (see below for details - in a nutshell, it compares numbers numerically and
   * strings alphabetically).
   *
   * ### Under the hood
   *
   * Ordering the specified `collection` happens in two phases:
   *
   * 1. All items are passed through the predicate (or predicates), and the returned values are saved
   *    along with their type (`string`, `number` etc). For example, an item `{label: 'foo'}`, passed
   *    through a predicate that extracts the value of the `label` property, would be transformed to:
   *    ```
   *    {
   *      value: 'foo',
   *      type: 'string',
   *      index: ...
   *    }
   *    ```
   *    **Note:** `null` values use `'null'` as their type.
   * 2. The comparator function is used to sort the items, based on the derived values, types and
   *    indices.
   *
   * If you use a custom comparator, it will be called with pairs of objects of the form
   * `{value: ..., type: '...', index: ...}` and is expected to return `0` if the objects are equal
   * (as far as the comparator is concerned), `-1` if the 1st one should be ranked higher than the
   * second, or `1` otherwise.
   *
   * In order to ensure that the sorting will be deterministic across platforms, if none of the
   * specified predicates can distinguish between two items, `orderBy` will automatically introduce a
   * dummy predicate that returns the item's index as `value`.
   * (If you are using a custom comparator, make sure it can handle this predicate as well.)
   *
   * If a custom comparator still can't distinguish between two items, then they will be sorted based
   * on their index using the built-in comparator.
   *
   * Finally, in an attempt to simplify things, if a predicate returns an object as the extracted
   * value for an item, `orderBy` will try to convert that object to a primitive value, before passing
   * it to the comparator. The following rules govern the conversion:
   *
   * 1. If the object has a `valueOf()` method that returns a primitive, its return value will be
   *    used instead.<br />
   *    (If the object has a `valueOf()` method that returns another object, then the returned object
   *    will be used in subsequent steps.)
   * 2. If the object has a custom `toString()` method (i.e. not the one inherited from `Object`) that
   *    returns a primitive, its return value will be used instead.<br />
   *    (If the object has a `toString()` method that returns another object, then the returned object
   *    will be used in subsequent steps.)
   * 3. No conversion; the object itself is used.
   *
   * ### The default comparator
   *
   * The default, built-in comparator should be sufficient for most usecases. In short, it compares
   * numbers numerically, strings alphabetically (and case-insensitively), for objects falls back to
   * using their index in the original collection, sorts values of different types by type and puts
   * `undefined` and `null` values at the end of the sorted list.
   *
   * More specifically, it follows these steps to determine the relative order of items:
   *
   * 1. If the compared values are of different types:
   *    - If one of the values is undefined, consider it "greater than" the other.
   *    - Else if one of the values is null, consider it "greater than" the other.
   *    - Else compare the types themselves alphabetically.
   * 2. If both values are of type `string`, compare them alphabetically in a case- and
   *    locale-insensitive way.
   * 3. If both values are objects, compare their indices instead.
   * 4. Otherwise, return:
   *    -  `0`, if the values are equal (by strict equality comparison, i.e. using `===`).
   *    - `-1`, if the 1st value is "less than" the 2nd value (compared using the `<` operator).
   *    -  `1`, otherwise.
   *
   * **Note:** If you notice numbers not being sorted as expected, make sure they are actually being
   *           saved as numbers and not strings.
   * **Note:** For the purpose of sorting, `null` and `undefined` are considered "greater than"
   *           any other value (with undefined "greater than" null). This effectively means that `null`
   *           and `undefined` values end up at the end of a list sorted in ascending order.
   * **Note:** `null` values use `'null'` as their type to be able to distinguish them from objects.
   *
   * @param {Array|ArrayLike} collection - The collection (array or array-like object) to sort.
   * @param {(Function|string|Array.<Function|string>)=} expression - A predicate (or list of
   *    predicates) to be used by the comparator to determine the order of elements.
   *
   *    Can be one of:
   *
   *    - `Function`: A getter function. This function will be called with each item as argument and
   *      the return value will be used for sorting.
   *    - `string`: An AngularJS expression. This expression will be evaluated against each item and the
   *      result will be used for sorting. For example, use `'label'` to sort by a property called
   *      `label` or `'label.substring(0, 3)'` to sort by the first 3 characters of the `label`
   *      property.<br />
   *      (The result of a constant expression is interpreted as a property name to be used for
   *      comparison. For example, use `'"special name"'` (note the extra pair of quotes) to sort by a
   *      property called `special name`.)<br />
   *      An expression can be optionally prefixed with `+` or `-` to control the sorting direction,
   *      ascending or descending. For example, `'+label'` or `'-label'`. If no property is provided,
   *      (e.g. `'+'` or `'-'`), the collection element itself is used in comparisons.
   *    - `Array`: An array of function and/or string predicates. If a predicate cannot determine the
   *      relative order of two items, the next predicate is used as a tie-breaker.
   *
   * **Note:** If the predicate is missing or empty then it defaults to `'+'`.
   *
   * @param {boolean=} reverse - If `true`, reverse the sorting order.
   * @param {(Function)=} comparator - The comparator function used to determine the relative order of
   *    value pairs. If omitted, the built-in comparator will be used.
   *
   * @returns {Array} - The sorted array.
   *
   *
   * @example
   * ### Ordering a table with `ngRepeat`
   *
   * The example below demonstrates a simple {@link ngRepeat ngRepeat}, where the data is sorted by
   * age in descending order (expression is set to `'-age'`). The `comparator` is not set, which means
   * it defaults to the built-in comparator.
   *
     <example name="orderBy-static" module="orderByExample1">
       <file name="index.html">
         <div ng-controller="ExampleController">
           <table class="friends">
             <tr>
               <th>Name</th>
               <th>Phone Number</th>
               <th>Age</th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:'-age'">
               <td>{{friend.name}}</td>
               <td>{{friend.phone}}</td>
               <td>{{friend.age}}</td>
             </tr>
           </table>
         </div>
       </file>
       <file name="script.js">
         angular.module('orderByExample1', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.friends = [
               {name: 'John',   phone: '555-1212',  age: 10},
               {name: 'Mary',   phone: '555-9876',  age: 19},
               {name: 'Mike',   phone: '555-4321',  age: 21},
               {name: 'Adam',   phone: '555-5678',  age: 35},
               {name: 'Julie',  phone: '555-8765',  age: 29}
             ];
           }]);
       </file>
       <file name="style.css">
         .friends {
           border-collapse: collapse;
         }
  
         .friends th {
           border-bottom: 1px solid;
         }
         .friends td, .friends th {
           border-left: 1px solid;
           padding: 5px 10px;
         }
         .friends td:first-child, .friends th:first-child {
           border-left: none;
         }
       </file>
       <file name="protractor.js" type="protractor">
         // Element locators
         var names = element.all(by.repeater('friends').column('friend.name'));
  
         it('should sort friends by age in reverse order', function() {
           expect(names.get(0).getText()).toBe('Adam');
           expect(names.get(1).getText()).toBe('Julie');
           expect(names.get(2).getText()).toBe('Mike');
           expect(names.get(3).getText()).toBe('Mary');
           expect(names.get(4).getText()).toBe('John');
         });
       </file>
     </example>
   * <hr />
   *
   * @example
   * ### Changing parameters dynamically
   *
   * All parameters can be changed dynamically. The next example shows how you can make the columns of
   * a table sortable, by binding the `expression` and `reverse` parameters to scope properties.
   *
     <example name="orderBy-dynamic" module="orderByExample2">
       <file name="index.html">
         <div ng-controller="ExampleController">
           <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
           <hr/>
           <button ng-click="propertyName = null; reverse = false">Set to unsorted</button>
           <hr/>
           <table class="friends">
             <tr>
               <th>
                 <button ng-click="sortBy('name')">Name</button>
                 <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
               </th>
               <th>
                 <button ng-click="sortBy('phone')">Phone Number</button>
                 <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
               </th>
               <th>
                 <button ng-click="sortBy('age')">Age</button>
                 <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
               </th>
             </tr>
             <tr ng-repeat="friend in friends | orderBy:propertyName:reverse">
               <td>{{friend.name}}</td>
               <td>{{friend.phone}}</td>
               <td>{{friend.age}}</td>
             </tr>
           </table>
         </div>
       </file>
       <file name="script.js">
         angular.module('orderByExample2', [])
           .controller('ExampleController', ['$scope', function($scope) {
             var friends = [
               {name: 'John',   phone: '555-1212',  age: 10},
               {name: 'Mary',   phone: '555-9876',  age: 19},
               {name: 'Mike',   phone: '555-4321',  age: 21},
               {name: 'Adam',   phone: '555-5678',  age: 35},
               {name: 'Julie',  phone: '555-8765',  age: 29}
             ];
  
             $scope.propertyName = 'age';
             $scope.reverse = true;
             $scope.friends = friends;
  
             $scope.sortBy = function(propertyName) {
               $scope.reverse = ($scope.propertyName === propertyName) ? !$scope.reverse : false;
               $scope.propertyName = propertyName;
             };
           }]);
       </file>
       <file name="style.css">
         .friends {
           border-collapse: collapse;
         }
  
         .friends th {
           border-bottom: 1px solid;
         }
         .friends td, .friends th {
           border-left: 1px solid;
           padding: 5px 10px;
         }
         .friends td:first-child, .friends th:first-child {
           border-left: none;
         }
  
         .sortorder:after {
           content: '\25b2';   // BLACK UP-POINTING TRIANGLE
         }
         .sortorder.reverse:after {
           content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
         }
       </file>
       <file name="protractor.js" type="protractor">
         // Element locators
         var unsortButton = element(by.partialButtonText('unsorted'));
         var nameHeader = element(by.partialButtonText('Name'));
         var phoneHeader = element(by.partialButtonText('Phone'));
         var ageHeader = element(by.partialButtonText('Age'));
         var firstName = element(by.repeater('friends').column('friend.name').row(0));
         var lastName = element(by.repeater('friends').column('friend.name').row(4));
  
         it('should sort friends by some property, when clicking on the column header', function() {
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
  
           phoneHeader.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Mary');
  
           nameHeader.click();
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('Mike');
  
           ageHeader.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Adam');
         });
  
         it('should sort friends in reverse order, when clicking on the same column', function() {
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
  
           ageHeader.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Adam');
  
           ageHeader.click();
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
         });
  
         it('should restore the original order, when clicking "Set to unsorted"', function() {
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
  
           unsortButton.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Julie');
         });
       </file>
     </example>
   * <hr />
   *
   * @example
   * ### Using `orderBy` inside a controller
   *
   * It is also possible to call the `orderBy` filter manually, by injecting `orderByFilter`, and
   * calling it with the desired parameters. (Alternatively, you could inject the `$filter` factory
   * and retrieve the `orderBy` filter with `$filter('orderBy')`.)
   *
     <example name="orderBy-call-manually" module="orderByExample3">
       <file name="index.html">
         <div ng-controller="ExampleController">
           <pre>Sort by = {{propertyName}}; reverse = {{reverse}}</pre>
           <hr/>
           <button ng-click="sortBy(null)">Set to unsorted</button>
           <hr/>
           <table class="friends">
             <tr>
               <th>
                 <button ng-click="sortBy('name')">Name</button>
                 <span class="sortorder" ng-show="propertyName === 'name'" ng-class="{reverse: reverse}"></span>
               </th>
               <th>
                 <button ng-click="sortBy('phone')">Phone Number</button>
                 <span class="sortorder" ng-show="propertyName === 'phone'" ng-class="{reverse: reverse}"></span>
               </th>
               <th>
                 <button ng-click="sortBy('age')">Age</button>
                 <span class="sortorder" ng-show="propertyName === 'age'" ng-class="{reverse: reverse}"></span>
               </th>
             </tr>
             <tr ng-repeat="friend in friends">
               <td>{{friend.name}}</td>
               <td>{{friend.phone}}</td>
               <td>{{friend.age}}</td>
             </tr>
           </table>
         </div>
       </file>
       <file name="script.js">
         angular.module('orderByExample3', [])
           .controller('ExampleController', ['$scope', 'orderByFilter', function($scope, orderBy) {
             var friends = [
               {name: 'John',   phone: '555-1212',  age: 10},
               {name: 'Mary',   phone: '555-9876',  age: 19},
               {name: 'Mike',   phone: '555-4321',  age: 21},
               {name: 'Adam',   phone: '555-5678',  age: 35},
               {name: 'Julie',  phone: '555-8765',  age: 29}
             ];
  
             $scope.propertyName = 'age';
             $scope.reverse = true;
             $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
  
             $scope.sortBy = function(propertyName) {
               $scope.reverse = (propertyName !== null && $scope.propertyName === propertyName)
                   ? !$scope.reverse : false;
               $scope.propertyName = propertyName;
               $scope.friends = orderBy(friends, $scope.propertyName, $scope.reverse);
             };
           }]);
       </file>
       <file name="style.css">
         .friends {
           border-collapse: collapse;
         }
  
         .friends th {
           border-bottom: 1px solid;
         }
         .friends td, .friends th {
           border-left: 1px solid;
           padding: 5px 10px;
         }
         .friends td:first-child, .friends th:first-child {
           border-left: none;
         }
  
         .sortorder:after {
           content: '\25b2';   // BLACK UP-POINTING TRIANGLE
         }
         .sortorder.reverse:after {
           content: '\25bc';   // BLACK DOWN-POINTING TRIANGLE
         }
       </file>
       <file name="protractor.js" type="protractor">
         // Element locators
         var unsortButton = element(by.partialButtonText('unsorted'));
         var nameHeader = element(by.partialButtonText('Name'));
         var phoneHeader = element(by.partialButtonText('Phone'));
         var ageHeader = element(by.partialButtonText('Age'));
         var firstName = element(by.repeater('friends').column('friend.name').row(0));
         var lastName = element(by.repeater('friends').column('friend.name').row(4));
  
         it('should sort friends by some property, when clicking on the column header', function() {
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
  
           phoneHeader.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Mary');
  
           nameHeader.click();
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('Mike');
  
           ageHeader.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Adam');
         });
  
         it('should sort friends in reverse order, when clicking on the same column', function() {
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
  
           ageHeader.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Adam');
  
           ageHeader.click();
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
         });
  
         it('should restore the original order, when clicking "Set to unsorted"', function() {
           expect(firstName.getText()).toBe('Adam');
           expect(lastName.getText()).toBe('John');
  
           unsortButton.click();
           expect(firstName.getText()).toBe('John');
           expect(lastName.getText()).toBe('Julie');
         });
       </file>
     </example>
   * <hr />
   *
   * @example
   * ### Using a custom comparator
   *
   * If you have very specific requirements about the way items are sorted, you can pass your own
   * comparator function. For example, you might need to compare some strings in a locale-sensitive
   * way. (When specifying a custom comparator, you also need to pass a value for the `reverse`
   * argument - passing `false` retains the default sorting order, i.e. ascending.)
   *
     <example name="orderBy-custom-comparator" module="orderByExample4">
       <file name="index.html">
         <div ng-controller="ExampleController">
           <div class="friends-container custom-comparator">
             <h3>Locale-sensitive Comparator</h3>
             <table class="friends">
               <tr>
                 <th>Name</th>
                 <th>Favorite Letter</th>
               </tr>
               <tr ng-repeat="friend in friends | orderBy:'favoriteLetter':false:localeSensitiveComparator">
                 <td>{{friend.name}}</td>
                 <td>{{friend.favoriteLetter}}</td>
               </tr>
             </table>
           </div>
           <div class="friends-container default-comparator">
             <h3>Default Comparator</h3>
             <table class="friends">
               <tr>
                 <th>Name</th>
                 <th>Favorite Letter</th>
               </tr>
               <tr ng-repeat="friend in friends | orderBy:'favoriteLetter'">
                 <td>{{friend.name}}</td>
                 <td>{{friend.favoriteLetter}}</td>
               </tr>
             </table>
           </div>
         </div>
       </file>
       <file name="script.js">
         angular.module('orderByExample4', [])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.friends = [
               {name: 'John',   favoriteLetter: 'Ä'},
               {name: 'Mary',   favoriteLetter: 'Ü'},
               {name: 'Mike',   favoriteLetter: 'Ö'},
               {name: 'Adam',   favoriteLetter: 'H'},
               {name: 'Julie',  favoriteLetter: 'Z'}
             ];
  
             $scope.localeSensitiveComparator = function(v1, v2) {
               // If we don't get strings, just compare by index
               if (v1.type !== 'string' || v2.type !== 'string') {
                 return (v1.index < v2.index) ? -1 : 1;
               }
  
               // Compare strings alphabetically, taking locale into account
               return v1.value.localeCompare(v2.value);
             };
           }]);
       </file>
       <file name="style.css">
         .friends-container {
           display: inline-block;
           margin: 0 30px;
         }
  
         .friends {
           border-collapse: collapse;
         }
  
         .friends th {
           border-bottom: 1px solid;
         }
         .friends td, .friends th {
           border-left: 1px solid;
           padding: 5px 10px;
         }
         .friends td:first-child, .friends th:first-child {
           border-left: none;
         }
       </file>
       <file name="protractor.js" type="protractor">
         // Element locators
         var container = element(by.css('.custom-comparator'));
         var names = container.all(by.repeater('friends').column('friend.name'));
  
         it('should sort friends by favorite letter (in correct alphabetical order)', function() {
           expect(names.get(0).getText()).toBe('John');
           expect(names.get(1).getText()).toBe('Adam');
           expect(names.get(2).getText()).toBe('Mike');
           expect(names.get(3).getText()).toBe('Mary');
           expect(names.get(4).getText()).toBe('Julie');
         });
       </file>
     </example>
   *
   */
  orderByFilter.$inject = ['$parse'];
  function orderByFilter($parse) {
    return function (array, sortPredicate, reverseOrder, compareFn) {
      if (array == null) return array;
      if (!isArrayLike(array)) {
        throw minErr('orderBy')('notarray', 'Expected array but received: {0}', array);
      }
      if (!isArray(sortPredicate)) {
        sortPredicate = [sortPredicate];
      }
      if (sortPredicate.length === 0) {
        sortPredicate = ['+'];
      }
      var predicates = processPredicates(sortPredicate);
      var descending = reverseOrder ? -1 : 1;

      // Define the `compare()` function. Use a default comparator if none is specified.
      var compare = isFunction(compareFn) ? compareFn : defaultCompare;

      // The next three lines are a version of a Swartzian Transform idiom from Perl
      // (sometimes called the Decorate-Sort-Undecorate idiom)
      // See https://en.wikipedia.org/wiki/Schwartzian_transform
      var compareValues = Array.prototype.map.call(array, getComparisonObject);
      compareValues.sort(doComparison);
      array = compareValues.map(function (item) {
        return item.value;
      });
      return array;
      function getComparisonObject(value, index) {
        // NOTE: We are adding an extra `tieBreaker` value based on the element's index.
        // This will be used to keep the sort stable when none of the input predicates can
        // distinguish between two elements.
        return {
          value: value,
          tieBreaker: {
            value: index,
            type: 'number',
            index: index
          },
          predicateValues: predicates.map(function (predicate) {
            return getPredicateValue(predicate.get(value), index);
          })
        };
      }
      function doComparison(v1, v2) {
        for (var i = 0, ii = predicates.length; i < ii; i++) {
          var result = compare(v1.predicateValues[i], v2.predicateValues[i]);
          if (result) {
            return result * predicates[i].descending * descending;
          }
        }
        return (compare(v1.tieBreaker, v2.tieBreaker) || defaultCompare(v1.tieBreaker, v2.tieBreaker)) * descending;
      }
    };
    function processPredicates(sortPredicates) {
      return sortPredicates.map(function (predicate) {
        var descending = 1,
          get = identity;
        if (isFunction(predicate)) {
          get = predicate;
        } else if (isString(predicate)) {
          if (predicate.charAt(0) === '+' || predicate.charAt(0) === '-') {
            descending = predicate.charAt(0) === '-' ? -1 : 1;
            predicate = predicate.substring(1);
          }
          if (predicate !== '') {
            get = $parse(predicate);
            if (get.constant) {
              var key = get();
              get = function get(value) {
                return value[key];
              };
            }
          }
        }
        return {
          get: get,
          descending: descending
        };
      });
    }
    function isPrimitive(value) {
      switch (_typeof(value)) {
        case 'number': /* falls through */
        case 'boolean': /* falls through */
        case 'string':
          return true;
        default:
          return false;
      }
    }
    function objectValue(value) {
      // If `valueOf` is a valid function use that
      if (isFunction(value.valueOf)) {
        value = value.valueOf();
        if (isPrimitive(value)) return value;
      }
      // If `toString` is a valid function and not the one from `Object.prototype` use that
      if (hasCustomToString(value)) {
        value = value.toString();
        if (isPrimitive(value)) return value;
      }
      return value;
    }
    function getPredicateValue(value, index) {
      var type = _typeof(value);
      if (value === null) {
        type = 'null';
      } else if (type === 'object') {
        value = objectValue(value);
      }
      return {
        value: value,
        type: type,
        index: index
      };
    }
    function defaultCompare(v1, v2) {
      var result = 0;
      var type1 = v1.type;
      var type2 = v2.type;
      if (type1 === type2) {
        var value1 = v1.value;
        var value2 = v2.value;
        if (type1 === 'string') {
          // Compare strings case-insensitively
          value1 = value1.toLowerCase();
          value2 = value2.toLowerCase();
        } else if (type1 === 'object') {
          // For basic objects, use the position of the object
          // in the collection instead of the value
          if (isObject(value1)) value1 = v1.index;
          if (isObject(value2)) value2 = v2.index;
        }
        if (value1 !== value2) {
          result = value1 < value2 ? -1 : 1;
        }
      } else {
        result = type1 === 'undefined' ? 1 : type2 === 'undefined' ? -1 : type1 === 'null' ? 1 : type2 === 'null' ? -1 : type1 < type2 ? -1 : 1;
      }
      return result;
    }
  }
  function ngDirective(directive) {
    if (isFunction(directive)) {
      directive = {
        link: directive
      };
    }
    directive.restrict = directive.restrict || 'AC';
    return valueFn(directive);
  }

  /**
   * @ngdoc directive
   * @name a
   * @restrict E
   *
   * @description
   * Modifies the default behavior of the html a tag so that the default action is prevented when
   * the href attribute is empty.
   *
   * For dynamically creating `href` attributes for a tags, see the {@link ng.ngHref `ngHref`} directive.
   */
  var htmlAnchorDirective = valueFn({
    restrict: 'E',
    compile: function compile(element, attr) {
      if (!attr.href && !attr.xlinkHref) {
        return function (scope, element) {
          // If the linked element is not an anchor tag anymore, do nothing
          if (element[0].nodeName.toLowerCase() !== 'a') return;

          // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
          var href = toString.call(element.prop('href')) === '[object SVGAnimatedString]' ? 'xlink:href' : 'href';
          element.on('click', function (event) {
            // if we have no href url, then don't navigate anywhere.
            if (!element.attr(href)) {
              event.preventDefault();
            }
          });
        };
      }
    }
  });

  /**
   * @ngdoc directive
   * @name ngHref
   * @restrict A
   * @priority 99
   *
   * @description
   * Using AngularJS markup like `{{hash}}` in an href attribute will
   * make the link go to the wrong URL if the user clicks it before
   * AngularJS has a chance to replace the `{{hash}}` markup with its
   * value. Until AngularJS replaces the markup the link will be broken
   * and will most likely return a 404 error. The `ngHref` directive
   * solves this problem.
   *
   * The wrong way to write it:
   * ```html
   * <a href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
   * ```
   *
   * The correct way to write it:
   * ```html
   * <a ng-href="http://www.gravatar.com/avatar/{{hash}}">link1</a>
   * ```
   *
   * @element A
   * @param {template} ngHref any string which can contain `{{}}` markup.
   *
   * @example
   * This example shows various combinations of `href`, `ng-href` and `ng-click` attributes
   * in links and their different behaviors:
      <example name="ng-href">
        <file name="index.html">
          <input ng-model="value" /><br />
          <a id="link-1" href ng-click="value = 1">link 1</a> (link, don't reload)<br />
          <a id="link-2" href="" ng-click="value = 2">link 2</a> (link, don't reload)<br />
          <a id="link-3" ng-href="/{{'123'}}">link 3</a> (link, reload!)<br />
          <a id="link-4" href="" name="xx" ng-click="value = 4">anchor</a> (link, don't reload)<br />
          <a id="link-5" name="xxx" ng-click="value = 5">anchor</a> (no link)<br />
          <a id="link-6" ng-href="{{value}}">link</a> (link, change location)
        </file>
        <file name="protractor.js" type="protractor">
          it('should execute ng-click but not reload when href without value', function() {
            element(by.id('link-1')).click();
            expect(element(by.model('value')).getAttribute('value')).toEqual('1');
            expect(element(by.id('link-1')).getAttribute('href')).toBe('');
          });
  
          it('should execute ng-click but not reload when href empty string', function() {
            element(by.id('link-2')).click();
            expect(element(by.model('value')).getAttribute('value')).toEqual('2');
            expect(element(by.id('link-2')).getAttribute('href')).toBe('');
          });
  
          it('should execute ng-click and change url when ng-href specified', function() {
            expect(element(by.id('link-3')).getAttribute('href')).toMatch(/\/123$/);
  
            element(by.id('link-3')).click();
  
            // At this point, we navigate away from an AngularJS page, so we need
            // to use browser.driver to get the base webdriver.
  
            browser.wait(function() {
              return browser.driver.getCurrentUrl().then(function(url) {
                return url.match(/\/123$/);
              });
            }, 5000, 'page should navigate to /123');
          });
  
          it('should execute ng-click but not reload when href empty string and name specified', function() {
            element(by.id('link-4')).click();
            expect(element(by.model('value')).getAttribute('value')).toEqual('4');
            expect(element(by.id('link-4')).getAttribute('href')).toBe('');
          });
  
          it('should execute ng-click but not reload when no href but name specified', function() {
            element(by.id('link-5')).click();
            expect(element(by.model('value')).getAttribute('value')).toEqual('5');
            expect(element(by.id('link-5')).getAttribute('href')).toBe(null);
          });
  
          it('should only change url when only ng-href', function() {
            element(by.model('value')).clear();
            element(by.model('value')).sendKeys('6');
            expect(element(by.id('link-6')).getAttribute('href')).toMatch(/\/6$/);
  
            element(by.id('link-6')).click();
  
            // At this point, we navigate away from an AngularJS page, so we need
            // to use browser.driver to get the base webdriver.
            browser.wait(function() {
              return browser.driver.getCurrentUrl().then(function(url) {
                return url.match(/\/6$/);
              });
            }, 5000, 'page should navigate to /6');
          });
        </file>
      </example>
   */

  /**
   * @ngdoc directive
   * @name ngSrc
   * @restrict A
   * @priority 99
   *
   * @description
   * Using AngularJS markup like `{{hash}}` in a `src` attribute doesn't
   * work right: The browser will fetch from the URL with the literal
   * text `{{hash}}` until AngularJS replaces the expression inside
   * `{{hash}}`. The `ngSrc` directive solves this problem.
   *
   * The buggy way to write it:
   * ```html
   * <img src="http://www.gravatar.com/avatar/{{hash}}" alt="Description"/>
   * ```
   *
   * The correct way to write it:
   * ```html
   * <img ng-src="http://www.gravatar.com/avatar/{{hash}}" alt="Description" />
   * ```
   *
   * @element IMG
   * @param {template} ngSrc any string which can contain `{{}}` markup.
   */

  /**
   * @ngdoc directive
   * @name ngSrcset
   * @restrict A
   * @priority 99
   *
   * @description
   * Using AngularJS markup like `{{hash}}` in a `srcset` attribute doesn't
   * work right: The browser will fetch from the URL with the literal
   * text `{{hash}}` until AngularJS replaces the expression inside
   * `{{hash}}`. The `ngSrcset` directive solves this problem.
   *
   * The buggy way to write it:
   * ```html
   * <img srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description"/>
   * ```
   *
   * The correct way to write it:
   * ```html
   * <img ng-srcset="http://www.gravatar.com/avatar/{{hash}} 2x" alt="Description" />
   * ```
   *
   * @element IMG
   * @param {template} ngSrcset any string which can contain `{{}}` markup.
   */

  /**
   * @ngdoc directive
   * @name ngDisabled
   * @restrict A
   * @priority 100
   *
   * @description
   *
   * This directive sets the `disabled` attribute on the element (typically a form control,
   * e.g. `input`, `button`, `select` etc.) if the
   * {@link guide/expression expression} inside `ngDisabled` evaluates to truthy.
   *
   * A special directive is necessary because we cannot use interpolation inside the `disabled`
   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
   *
   * @example
      <example name="ng-disabled">
        <file name="index.html">
          <label>Click me to toggle: <input type="checkbox" ng-model="checked"></label><br/>
          <button ng-model="button" ng-disabled="checked">Button</button>
        </file>
        <file name="protractor.js" type="protractor">
          it('should toggle button', function() {
            expect(element(by.css('button')).getAttribute('disabled')).toBeFalsy();
            element(by.model('checked')).click();
            expect(element(by.css('button')).getAttribute('disabled')).toBeTruthy();
          });
        </file>
      </example>
   *
   * @param {expression} ngDisabled If the {@link guide/expression expression} is truthy,
   *     then the `disabled` attribute will be set on the element
   */

  /**
   * @ngdoc directive
   * @name ngChecked
   * @restrict A
   * @priority 100
   *
   * @description
   * Sets the `checked` attribute on the element, if the expression inside `ngChecked` is truthy.
   *
   * Note that this directive should not be used together with {@link ngModel `ngModel`},
   * as this can lead to unexpected behavior.
   *
   * A special directive is necessary because we cannot use interpolation inside the `checked`
   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
   *
   * @example
      <example name="ng-checked">
        <file name="index.html">
          <label>Check me to check both: <input type="checkbox" ng-model="leader"></label><br/>
          <input id="checkFollower" type="checkbox" ng-checked="leader" aria-label="Follower input">
        </file>
        <file name="protractor.js" type="protractor">
          it('should check both checkBoxes', function() {
            expect(element(by.id('checkFollower')).getAttribute('checked')).toBeFalsy();
            element(by.model('leader')).click();
            expect(element(by.id('checkFollower')).getAttribute('checked')).toBeTruthy();
          });
        </file>
      </example>
   *
   * @element INPUT
   * @param {expression} ngChecked If the {@link guide/expression expression} is truthy,
   *     then the `checked` attribute will be set on the element
   */

  /**
   * @ngdoc directive
   * @name ngReadonly
   * @restrict A
   * @priority 100
   *
   * @description
   *
   * Sets the `readonly` attribute on the element, if the expression inside `ngReadonly` is truthy.
   * Note that `readonly` applies only to `input` elements with specific types. [See the input docs on
   * MDN](https://developer.mozilla.org/en-US/docs/Web/HTML/Element/input#attr-readonly) for more information.
   *
   * A special directive is necessary because we cannot use interpolation inside the `readonly`
   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
   *
   * @example
      <example name="ng-readonly">
        <file name="index.html">
          <label>Check me to make text readonly: <input type="checkbox" ng-model="checked"></label><br/>
          <input type="text" ng-readonly="checked" value="I'm AngularJS" aria-label="Readonly field" />
        </file>
        <file name="protractor.js" type="protractor">
          it('should toggle readonly attr', function() {
            expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeFalsy();
            element(by.model('checked')).click();
            expect(element(by.css('[type="text"]')).getAttribute('readonly')).toBeTruthy();
          });
        </file>
      </example>
   *
   * @element INPUT
   * @param {expression} ngReadonly If the {@link guide/expression expression} is truthy,
   *     then special attribute "readonly" will be set on the element
   */

  /**
   * @ngdoc directive
   * @name ngSelected
   * @restrict A
   * @priority 100
   *
   * @description
   *
   * Sets the `selected` attribute on the element, if the expression inside `ngSelected` is truthy.
   *
   * A special directive is necessary because we cannot use interpolation inside the `selected`
   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
   *
   * <div class="alert alert-warning">
   *   **Note:** `ngSelected` does not interact with the `select` and `ngModel` directives, it only
   *   sets the `selected` attribute on the element. If you are using `ngModel` on the select, you
   *   should not use `ngSelected` on the options, as `ngModel` will set the select value and
   *   selected options.
   * </div>
   *
   * @example
      <example name="ng-selected">
        <file name="index.html">
          <label>Check me to select: <input type="checkbox" ng-model="selected"></label><br/>
          <select aria-label="ngSelected demo">
            <option>Hello!</option>
            <option id="greet" ng-selected="selected">Greetings!</option>
          </select>
        </file>
        <file name="protractor.js" type="protractor">
          it('should select Greetings!', function() {
            expect(element(by.id('greet')).getAttribute('selected')).toBeFalsy();
            element(by.model('selected')).click();
            expect(element(by.id('greet')).getAttribute('selected')).toBeTruthy();
          });
        </file>
      </example>
   *
   * @element OPTION
   * @param {expression} ngSelected If the {@link guide/expression expression} is truthy,
   *     then special attribute "selected" will be set on the element
   */

  /**
   * @ngdoc directive
   * @name ngOpen
   * @restrict A
   * @priority 100
   *
   * @description
   *
   * Sets the `open` attribute on the element, if the expression inside `ngOpen` is truthy.
   *
   * A special directive is necessary because we cannot use interpolation inside the `open`
   * attribute. See the {@link guide/interpolation interpolation guide} for more info.
   *
   * ## A note about browser compatibility
   *
   * Internet Explorer and Edge do not support the `details` element, it is
   * recommended to use {@link ng.ngShow} and {@link ng.ngHide} instead.
   *
   * @example
       <example name="ng-open">
         <file name="index.html">
           <label>Toggle details: <input type="checkbox" ng-model="open"></label><br/>
           <details id="details" ng-open="open">
              <summary>List</summary>
              <ul>
                <li>Apple</li>
                <li>Orange</li>
                <li>Durian</li>
              </ul>
           </details>
         </file>
         <file name="protractor.js" type="protractor">
           it('should toggle open', function() {
             expect(element(by.id('details')).getAttribute('open')).toBeFalsy();
             element(by.model('open')).click();
             expect(element(by.id('details')).getAttribute('open')).toBeTruthy();
           });
         </file>
       </example>
   *
   * @element DETAILS
   * @param {expression} ngOpen If the {@link guide/expression expression} is truthy,
   *     then special attribute "open" will be set on the element
   */

  var ngAttributeAliasDirectives = {};

  // boolean attrs are evaluated
  forEach(BOOLEAN_ATTR, function (propName, attrName) {
    // binding to multiple is not supported
    if (propName === 'multiple') return;
    function defaultLinkFn(scope, element, attr) {
      scope.$watch(attr[normalized], function ngBooleanAttrWatchAction(value) {
        attr.$set(attrName, !!value);
      });
    }
    var normalized = directiveNormalize('ng-' + attrName);
    var linkFn = defaultLinkFn;
    if (propName === 'checked') {
      linkFn = function linkFn(scope, element, attr) {
        // ensuring ngChecked doesn't interfere with ngModel when both are set on the same input
        if (attr.ngModel !== attr[normalized]) {
          defaultLinkFn(scope, element, attr);
        }
      };
    }
    ngAttributeAliasDirectives[normalized] = function () {
      return {
        restrict: 'A',
        priority: 100,
        link: linkFn
      };
    };
  });

  // aliased input attrs are evaluated
  forEach(ALIASED_ATTR, function (htmlAttr, ngAttr) {
    ngAttributeAliasDirectives[ngAttr] = function () {
      return {
        priority: 100,
        link: function link(scope, element, attr) {
          //special case ngPattern when a literal regular expression value
          //is used as the expression (this way we don't have to watch anything).
          if (ngAttr === 'ngPattern' && attr.ngPattern.charAt(0) === '/') {
            var match = attr.ngPattern.match(REGEX_STRING_REGEXP);
            if (match) {
              attr.$set('ngPattern', new RegExp(match[1], match[2]));
              return;
            }
          }
          scope.$watch(attr[ngAttr], function ngAttrAliasWatchAction(value) {
            attr.$set(ngAttr, value);
          });
        }
      };
    };
  });

  // ng-src, ng-srcset, ng-href are interpolated
  forEach(['src', 'srcset', 'href'], function (attrName) {
    var normalized = directiveNormalize('ng-' + attrName);
    ngAttributeAliasDirectives[normalized] = ['$sce', function ($sce) {
      return {
        priority: 99,
        // it needs to run after the attributes are interpolated
        link: function link(scope, element, attr) {
          var propName = attrName,
            name = attrName;
          if (attrName === 'href' && toString.call(element.prop('href')) === '[object SVGAnimatedString]') {
            name = 'xlinkHref';
            attr.$attr[name] = 'xlink:href';
            propName = null;
          }

          // We need to sanitize the url at least once, in case it is a constant
          // non-interpolated attribute.
          attr.$set(normalized, $sce.getTrustedMediaUrl(attr[normalized]));
          attr.$observe(normalized, function (value) {
            if (!value) {
              if (attrName === 'href') {
                attr.$set(name, null);
              }
              return;
            }
            attr.$set(name, value);

            // Support: IE 9-11 only
            // On IE, if "ng:src" directive declaration is used and "src" attribute doesn't exist
            // then calling element.setAttribute('src', 'foo') doesn't do anything, so we need
            // to set the property as well to achieve the desired effect.
            // We use attr[attrName] value since $set might have sanitized the url.
            if (msie && propName) element.prop(propName, attr[name]);
          });
        }
      };
    }];
  });

  /* global -nullFormCtrl, -PENDING_CLASS, -SUBMITTED_CLASS
   */
  var nullFormCtrl = {
      $addControl: noop,
      $getControls: valueFn([]),
      $$renameControl: nullFormRenameControl,
      $removeControl: noop,
      $setValidity: noop,
      $setDirty: noop,
      $setPristine: noop,
      $setSubmitted: noop,
      $$setSubmitted: noop
    },
    PENDING_CLASS = 'ng-pending',
    SUBMITTED_CLASS = 'ng-submitted';
  function nullFormRenameControl(control, name) {
    control.$name = name;
  }

  /**
   * @ngdoc type
   * @name form.FormController
   *
   * @property {boolean} $pristine True if user has not interacted with the form yet.
   * @property {boolean} $dirty True if user has already interacted with the form.
   * @property {boolean} $valid True if all of the containing forms and controls are valid.
   * @property {boolean} $invalid True if at least one containing control or form is invalid.
   * @property {boolean} $submitted True if user has submitted the form even if its invalid.
   *
   * @property {Object} $pending An object hash, containing references to controls or forms with
   *  pending validators, where:
   *
   *  - keys are validations tokens (error names).
   *  - values are arrays of controls or forms that have a pending validator for the given error name.
   *
   * See {@link form.FormController#$error $error} for a list of built-in validation tokens.
   *
   * @property {Object} $error An object hash, containing references to controls or forms with failing
   *  validators, where:
   *
   *  - keys are validation tokens (error names),
   *  - values are arrays of controls or forms that have a failing validator for the given error name.
   *
   *  Built-in validation tokens:
   *  - `email`
   *  - `max`
   *  - `maxlength`
   *  - `min`
   *  - `minlength`
   *  - `number`
   *  - `pattern`
   *  - `required`
   *  - `url`
   *  - `date`
   *  - `datetimelocal`
   *  - `time`
   *  - `week`
   *  - `month`
   *
   * @description
   * `FormController` keeps track of all its controls and nested forms as well as the state of them,
   * such as being valid/invalid or dirty/pristine.
   *
   * Each {@link ng.directive:form form} directive creates an instance
   * of `FormController`.
   *
   */
  //asks for $scope to fool the BC controller module
  FormController.$inject = ['$element', '$attrs', '$scope', '$animate', '$interpolate'];
  function FormController($element, $attrs, $scope, $animate, $interpolate) {
    this.$$controls = [];

    // init state
    this.$error = {};
    this.$$success = {};
    this.$pending = undefined;
    this.$name = $interpolate($attrs.name || $attrs.ngForm || '')($scope);
    this.$dirty = false;
    this.$pristine = true;
    this.$valid = true;
    this.$invalid = false;
    this.$submitted = false;
    this.$$parentForm = nullFormCtrl;
    this.$$element = $element;
    this.$$animate = $animate;
    setupValidity(this);
  }
  FormController.prototype = {
    /**
     * @ngdoc method
     * @name form.FormController#$rollbackViewValue
     *
     * @description
     * Rollback all form controls pending updates to the `$modelValue`.
     *
     * Updates may be pending by a debounced event or because the input is waiting for a some future
     * event defined in `ng-model-options`. This method is typically needed by the reset button of
     * a form that uses `ng-model-options` to pend updates.
     */
    $rollbackViewValue: function $rollbackViewValue() {
      forEach(this.$$controls, function (control) {
        control.$rollbackViewValue();
      });
    },
    /**
     * @ngdoc method
     * @name form.FormController#$commitViewValue
     *
     * @description
     * Commit all form controls pending updates to the `$modelValue`.
     *
     * Updates may be pending by a debounced event or because the input is waiting for a some future
     * event defined in `ng-model-options`. This method is rarely needed as `NgModelController`
     * usually handles calling this in response to input events.
     */
    $commitViewValue: function $commitViewValue() {
      forEach(this.$$controls, function (control) {
        control.$commitViewValue();
      });
    },
    /**
     * @ngdoc method
     * @name form.FormController#$addControl
     * @param {object} control control object, either a {@link form.FormController} or an
     * {@link ngModel.NgModelController}
     *
     * @description
     * Register a control with the form. Input elements using ngModelController do this automatically
     * when they are linked.
     *
     * Note that the current state of the control will not be reflected on the new parent form. This
     * is not an issue with normal use, as freshly compiled and linked controls are in a `$pristine`
     * state.
     *
     * However, if the method is used programmatically, for example by adding dynamically created controls,
     * or controls that have been previously removed without destroying their corresponding DOM element,
     * it's the developers responsibility to make sure the current state propagates to the parent form.
     *
     * For example, if an input control is added that is already `$dirty` and has `$error` properties,
     * calling `$setDirty()` and `$validate()` afterwards will propagate the state to the parent form.
     */
    $addControl: function $addControl(control) {
      // Breaking change - before, inputs whose name was "hasOwnProperty" were quietly ignored
      // and not added to the scope.  Now we throw an error.
      assertNotHasOwnProperty(control.$name, 'input');
      this.$$controls.push(control);
      if (control.$name) {
        this[control.$name] = control;
      }
      control.$$parentForm = this;
    },
    /**
     * @ngdoc method
     * @name form.FormController#$getControls
     * @returns {Array} the controls that are currently part of this form
     *
     * @description
     * This method returns a **shallow copy** of the controls that are currently part of this form.
     * The controls can be instances of {@link form.FormController `FormController`}
     * ({@link ngForm "child-forms"}) and of {@link ngModel.NgModelController `NgModelController`}.
     * If you need access to the controls of child-forms, you have to call `$getControls()`
     * recursively on them.
     * This can be used for example to iterate over all controls to validate them.
     *
     * The controls can be accessed normally, but adding to, or removing controls from the array has
     * no effect on the form. Instead, use {@link form.FormController#$addControl `$addControl()`} and
     * {@link form.FormController#$removeControl `$removeControl()`} for this use-case.
     * Likewise, adding a control to, or removing a control from the form is not reflected
     * in the shallow copy. That means you should get a fresh copy from `$getControls()` every time
     * you need access to the controls.
     */
    $getControls: function $getControls() {
      return shallowCopy(this.$$controls);
    },
    // Private API: rename a form control
    $$renameControl: function $$renameControl(control, newName) {
      var oldName = control.$name;
      if (this[oldName] === control) {
        delete this[oldName];
      }
      this[newName] = control;
      control.$name = newName;
    },
    /**
     * @ngdoc method
     * @name form.FormController#$removeControl
     * @param {object} control control object, either a {@link form.FormController} or an
     * {@link ngModel.NgModelController}
     *
     * @description
     * Deregister a control from the form.
     *
     * Input elements using ngModelController do this automatically when they are destroyed.
     *
     * Note that only the removed control's validation state (`$errors`etc.) will be removed from the
     * form. `$dirty`, `$submitted` states will not be changed, because the expected behavior can be
     * different from case to case. For example, removing the only `$dirty` control from a form may or
     * may not mean that the form is still `$dirty`.
     */
    $removeControl: function $removeControl(control) {
      if (control.$name && this[control.$name] === control) {
        delete this[control.$name];
      }
      forEach(this.$pending, function (value, name) {
        // eslint-disable-next-line no-invalid-this
        this.$setValidity(name, null, control);
      }, this);
      forEach(this.$error, function (value, name) {
        // eslint-disable-next-line no-invalid-this
        this.$setValidity(name, null, control);
      }, this);
      forEach(this.$$success, function (value, name) {
        // eslint-disable-next-line no-invalid-this
        this.$setValidity(name, null, control);
      }, this);
      arrayRemove(this.$$controls, control);
      control.$$parentForm = nullFormCtrl;
    },
    /**
     * @ngdoc method
     * @name form.FormController#$setDirty
     *
     * @description
     * Sets the form to a dirty state.
     *
     * This method can be called to add the 'ng-dirty' class and set the form to a dirty
     * state (ng-dirty class). This method will also propagate to parent forms.
     */
    $setDirty: function $setDirty() {
      this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
      this.$$animate.addClass(this.$$element, DIRTY_CLASS);
      this.$dirty = true;
      this.$pristine = false;
      this.$$parentForm.$setDirty();
    },
    /**
     * @ngdoc method
     * @name form.FormController#$setPristine
     *
     * @description
     * Sets the form to its pristine state.
     *
     * This method sets the form's `$pristine` state to true, the `$dirty` state to false, removes
     * the `ng-dirty` class and adds the `ng-pristine` class. Additionally, it sets the `$submitted`
     * state to false.
     *
     * This method will also propagate to all the controls contained in this form.
     *
     * Setting a form back to a pristine state is often useful when we want to 'reuse' a form after
     * saving or resetting it.
     */
    $setPristine: function $setPristine() {
      this.$$animate.setClass(this.$$element, PRISTINE_CLASS, DIRTY_CLASS + ' ' + SUBMITTED_CLASS);
      this.$dirty = false;
      this.$pristine = true;
      this.$submitted = false;
      forEach(this.$$controls, function (control) {
        control.$setPristine();
      });
    },
    /**
     * @ngdoc method
     * @name form.FormController#$setUntouched
     *
     * @description
     * Sets the form to its untouched state.
     *
     * This method can be called to remove the 'ng-touched' class and set the form controls to their
     * untouched state (ng-untouched class).
     *
     * Setting a form controls back to their untouched state is often useful when setting the form
     * back to its pristine state.
     */
    $setUntouched: function $setUntouched() {
      forEach(this.$$controls, function (control) {
        control.$setUntouched();
      });
    },
    /**
     * @ngdoc method
     * @name form.FormController#$setSubmitted
     *
     * @description
     * Sets the form to its `$submitted` state. This will also set `$submitted` on all child and
     * parent forms of the form.
     */
    $setSubmitted: function $setSubmitted() {
      var rootForm = this;
      while (rootForm.$$parentForm && rootForm.$$parentForm !== nullFormCtrl) {
        rootForm = rootForm.$$parentForm;
      }
      rootForm.$$setSubmitted();
    },
    $$setSubmitted: function $$setSubmitted() {
      this.$$animate.addClass(this.$$element, SUBMITTED_CLASS);
      this.$submitted = true;
      forEach(this.$$controls, function (control) {
        if (control.$$setSubmitted) {
          control.$$setSubmitted();
        }
      });
    }
  };

  /**
   * @ngdoc method
   * @name form.FormController#$setValidity
   *
   * @description
   * Change the validity state of the form, and notify the parent form (if any).
   *
   * Application developers will rarely need to call this method directly. It is used internally, by
   * {@link ngModel.NgModelController#$setValidity NgModelController.$setValidity()}, to propagate a
   * control's validity state to the parent `FormController`.
   *
   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be
   *        assigned to either `$error[validationErrorKey]` or `$pending[validationErrorKey]` (for
   *        unfulfilled `$asyncValidators`), so that it is available for data-binding. The
   *        `validationErrorKey` should be in camelCase and will get converted into dash-case for
   *        class name. Example: `myError` will result in `ng-valid-my-error` and
   *        `ng-invalid-my-error` classes and can be bound to as `{{ someForm.$error.myError }}`.
   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending
   *        (undefined),  or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
   *        Skipped is used by AngularJS when validators do not run because of parse errors and when
   *        `$asyncValidators` do not run because any of the `$validators` failed.
   * @param {NgModelController | FormController} controller - The controller whose validity state is
   *        triggering the change.
   */
  addSetValidityMethod({
    clazz: FormController,
    set: function set(object, property, controller) {
      var list = object[property];
      if (!list) {
        object[property] = [controller];
      } else {
        var index = list.indexOf(controller);
        if (index === -1) {
          list.push(controller);
        }
      }
    },
    unset: function unset(object, property, controller) {
      var list = object[property];
      if (!list) {
        return;
      }
      arrayRemove(list, controller);
      if (list.length === 0) {
        delete object[property];
      }
    }
  });

  /**
   * @ngdoc directive
   * @name ngForm
   * @restrict EAC
   *
   * @description
   * Helper directive that makes it possible to create control groups inside a
   * {@link ng.directive:form `form`} directive.
   * These "child forms" can be used, for example, to determine the validity of a sub-group of
   * controls.
   *
   * <div class="alert alert-danger">
   * **Note**: `ngForm` cannot be used as a replacement for `<form>`, because it lacks its
   * [built-in HTML functionality](https://html.spec.whatwg.org/#the-form-element).
   * Specifically, you cannot submit `ngForm` like a `<form>` tag. That means,
   * you cannot send data to the server with `ngForm`, or integrate it with
   * {@link ng.directive:ngSubmit `ngSubmit`}.
   * </div>
   *
   * @param {string=} ngForm|name Name of the form. If specified, the form controller will
   *                              be published into the related scope, under this name.
   *
   */

  /**
  * @ngdoc directive
  * @name form
  * @restrict E
  *
  * @description
  * Directive that instantiates
  * {@link form.FormController FormController}.
  *
  * If the `name` attribute is specified, the form controller is published onto the current scope under
  * this name.
  *
  * ## Alias: {@link ng.directive:ngForm `ngForm`}
  *
  * In AngularJS, forms can be nested. This means that the outer form is valid when all of the child
  * forms are valid as well. However, browsers do not allow nesting of `<form>` elements, so
  * AngularJS provides the {@link ng.directive:ngForm `ngForm`} directive, which behaves identically to
  * `form` but can be nested. Nested forms can be useful, for example, if the validity of a sub-group
  * of controls needs to be determined.
  *
  * ## CSS classes
  *  - `ng-valid` is set if the form is valid.
  *  - `ng-invalid` is set if the form is invalid.
  *  - `ng-pending` is set if the form is pending.
  *  - `ng-pristine` is set if the form is pristine.
  *  - `ng-dirty` is set if the form is dirty.
  *  - `ng-submitted` is set if the form was submitted.
  *
  * Keep in mind that ngAnimate can detect each of these classes when added and removed.
  *
  *
  * ## Submitting a form and preventing the default action
  *
  * Since the role of forms in client-side AngularJS applications is different than in classical
  * roundtrip apps, it is desirable for the browser not to translate the form submission into a full
  * page reload that sends the data to the server. Instead some javascript logic should be triggered
  * to handle the form submission in an application-specific way.
  *
  * For this reason, AngularJS prevents the default action (form submission to the server) unless the
  * `<form>` element has an `action` attribute specified.
  *
  * You can use one of the following two ways to specify what javascript method should be called when
  * a form is submitted:
  *
  * - {@link ng.directive:ngSubmit ngSubmit} directive on the form element
  * - {@link ng.directive:ngClick ngClick} directive on the first
   *  button or input field of type submit (input[type=submit])
  *
  * To prevent double execution of the handler, use only one of the {@link ng.directive:ngSubmit ngSubmit}
  * or {@link ng.directive:ngClick ngClick} directives.
  * This is because of the following form submission rules in the HTML specification:
  *
  * - If a form has only one input field then hitting enter in this field triggers form submit
  * (`ngSubmit`)
  * - if a form has 2+ input fields and no buttons or input[type=submit] then hitting enter
  * doesn't trigger submit
  * - if a form has one or more input fields and one or more buttons or input[type=submit] then
  * hitting enter in any of the input fields will trigger the click handler on the *first* button or
  * input[type=submit] (`ngClick`) *and* a submit handler on the enclosing form (`ngSubmit`)
  *
  * Any pending `ngModelOptions` changes will take place immediately when an enclosing form is
  * submitted. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
  * to have access to the updated model.
  *
  * @animations
  * Animations in ngForm are triggered when any of the associated CSS classes are added and removed.
  * These classes are: `.ng-pristine`, `.ng-dirty`, `.ng-invalid` and `.ng-valid` as well as any
  * other validations that are performed within the form. Animations in ngForm are similar to how
  * they work in ngClass and animations can be hooked into using CSS transitions, keyframes as well
  * as JS animations.
  *
  * The following example shows a simple way to utilize CSS transitions to style a form element
  * that has been rendered as invalid after it has been validated:
  *
  * <pre>
  * //be sure to include ngAnimate as a module to hook into more
  * //advanced animations
  * .my-form {
  *   transition:0.5s linear all;
  *   background: white;
  * }
  * .my-form.ng-invalid {
  *   background: red;
  *   color:white;
  * }
  * </pre>
  *
  * @example
     <example name="ng-form" deps="angular-animate.js" animations="true" fixBase="true" module="formExample">
       <file name="index.html">
        <script>
          angular.module('formExample', [])
            .controller('FormController', ['$scope', function($scope) {
              $scope.userType = 'guest';
            }]);
        </script>
        <style>
         .my-form {
           transition:all linear 0.5s;
           background: transparent;
         }
         .my-form.ng-invalid {
           background: red;
         }
        </style>
        <form name="myForm" ng-controller="FormController" class="my-form">
          userType: <input name="input" ng-model="userType" required>
          <span class="error" ng-show="myForm.input.$error.required">Required!</span><br>
          <code>userType = {{userType}}</code><br>
          <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br>
          <code>myForm.input.$error = {{myForm.input.$error}}</code><br>
          <code>myForm.$valid = {{myForm.$valid}}</code><br>
          <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br>
         </form>
       </file>
       <file name="protractor.js" type="protractor">
         it('should initialize to model', function() {
           var userType = element(by.binding('userType'));
           var valid = element(by.binding('myForm.input.$valid'));
            expect(userType.getText()).toContain('guest');
           expect(valid.getText()).toContain('true');
         });
          it('should be invalid if empty', function() {
           var userType = element(by.binding('userType'));
           var valid = element(by.binding('myForm.input.$valid'));
           var userInput = element(by.model('userType'));
            userInput.clear();
           userInput.sendKeys('');
            expect(userType.getText()).toEqual('userType =');
           expect(valid.getText()).toContain('false');
         });
       </file>
     </example>
  *
  * @param {string=} name Name of the form. If specified, the form controller will be published into
  *                       related scope, under this name.
  */
  var formDirectiveFactory = function formDirectiveFactory(isNgForm) {
    return ['$timeout', '$parse', function ($timeout, $parse) {
      var formDirective = {
        name: 'form',
        restrict: isNgForm ? 'EAC' : 'E',
        require: ['form', '^^?form'],
        //first is the form's own ctrl, second is an optional parent form
        controller: FormController,
        compile: function ngFormCompile(formElement, attr) {
          // Setup initial state of the control
          formElement.addClass(PRISTINE_CLASS).addClass(VALID_CLASS);
          var nameAttr = attr.name ? 'name' : isNgForm && attr.ngForm ? 'ngForm' : false;
          return {
            pre: function ngFormPreLink(scope, formElement, attr, ctrls) {
              var controller = ctrls[0];

              // if `action` attr is not present on the form, prevent the default action (submission)
              if (!('action' in attr)) {
                // we can't use jq events because if a form is destroyed during submission the default
                // action is not prevented. see #1238
                //
                // IE 9 is not affected because it doesn't fire a submit event and try to do a full
                // page reload if the form was destroyed by submission of the form via a click handler
                // on a button in the form. Looks like an IE9 specific bug.
                var handleFormSubmission = function handleFormSubmission(event) {
                  scope.$apply(function () {
                    controller.$commitViewValue();
                    controller.$setSubmitted();
                  });
                  event.preventDefault();
                };
                formElement[0].addEventListener('submit', handleFormSubmission);

                // unregister the preventDefault listener so that we don't not leak memory but in a
                // way that will achieve the prevention of the default action.
                formElement.on('$destroy', function () {
                  $timeout(function () {
                    formElement[0].removeEventListener('submit', handleFormSubmission);
                  }, 0, false);
                });
              }
              var parentFormCtrl = ctrls[1] || controller.$$parentForm;
              parentFormCtrl.$addControl(controller);
              var setter = nameAttr ? getSetter(controller.$name) : noop;
              if (nameAttr) {
                setter(scope, controller);
                attr.$observe(nameAttr, function (newValue) {
                  if (controller.$name === newValue) return;
                  setter(scope, undefined);
                  controller.$$parentForm.$$renameControl(controller, newValue);
                  setter = getSetter(controller.$name);
                  setter(scope, controller);
                });
              }
              formElement.on('$destroy', function () {
                controller.$$parentForm.$removeControl(controller);
                setter(scope, undefined);
                extend(controller, nullFormCtrl); //stop propagating child destruction handlers upwards
              });
            }
          };
        }
      };
      return formDirective;
      function getSetter(expression) {
        if (expression === '') {
          //create an assignable expression, so forms with an empty name can be renamed later
          return $parse('this[""]').assign;
        }
        return $parse(expression).assign || noop;
      }
    }];
  };
  var formDirective = formDirectiveFactory();
  var ngFormDirective = formDirectiveFactory(true);

  // helper methods
  function setupValidity(instance) {
    instance.$$classCache = {};
    instance.$$classCache[INVALID_CLASS] = !(instance.$$classCache[VALID_CLASS] = instance.$$element.hasClass(VALID_CLASS));
  }
  function addSetValidityMethod(context) {
    var clazz = context.clazz,
      set = context.set,
      unset = context.unset;
    clazz.prototype.$setValidity = function (validationErrorKey, state, controller) {
      if (isUndefined(state)) {
        createAndSet(this, '$pending', validationErrorKey, controller);
      } else {
        unsetAndCleanup(this, '$pending', validationErrorKey, controller);
      }
      if (!isBoolean(state)) {
        unset(this.$error, validationErrorKey, controller);
        unset(this.$$success, validationErrorKey, controller);
      } else {
        if (state) {
          unset(this.$error, validationErrorKey, controller);
          set(this.$$success, validationErrorKey, controller);
        } else {
          set(this.$error, validationErrorKey, controller);
          unset(this.$$success, validationErrorKey, controller);
        }
      }
      if (this.$pending) {
        cachedToggleClass(this, PENDING_CLASS, true);
        this.$valid = this.$invalid = undefined;
        toggleValidationCss(this, '', null);
      } else {
        cachedToggleClass(this, PENDING_CLASS, false);
        this.$valid = isObjectEmpty(this.$error);
        this.$invalid = !this.$valid;
        toggleValidationCss(this, '', this.$valid);
      }

      // re-read the state as the set/unset methods could have
      // combined state in this.$error[validationError] (used for forms),
      // where setting/unsetting only increments/decrements the value,
      // and does not replace it.
      var combinedState;
      if (this.$pending && this.$pending[validationErrorKey]) {
        combinedState = undefined;
      } else if (this.$error[validationErrorKey]) {
        combinedState = false;
      } else if (this.$$success[validationErrorKey]) {
        combinedState = true;
      } else {
        combinedState = null;
      }
      toggleValidationCss(this, validationErrorKey, combinedState);
      this.$$parentForm.$setValidity(validationErrorKey, combinedState, this);
    };
    function createAndSet(ctrl, name, value, controller) {
      if (!ctrl[name]) {
        ctrl[name] = {};
      }
      set(ctrl[name], value, controller);
    }
    function unsetAndCleanup(ctrl, name, value, controller) {
      if (ctrl[name]) {
        unset(ctrl[name], value, controller);
      }
      if (isObjectEmpty(ctrl[name])) {
        ctrl[name] = undefined;
      }
    }
    function cachedToggleClass(ctrl, className, switchValue) {
      if (switchValue && !ctrl.$$classCache[className]) {
        ctrl.$$animate.addClass(ctrl.$$element, className);
        ctrl.$$classCache[className] = true;
      } else if (!switchValue && ctrl.$$classCache[className]) {
        ctrl.$$animate.removeClass(ctrl.$$element, className);
        ctrl.$$classCache[className] = false;
      }
    }
    function toggleValidationCss(ctrl, validationErrorKey, isValid) {
      validationErrorKey = validationErrorKey ? '-' + snake_case(validationErrorKey, '-') : '';
      cachedToggleClass(ctrl, VALID_CLASS + validationErrorKey, isValid === true);
      cachedToggleClass(ctrl, INVALID_CLASS + validationErrorKey, isValid === false);
    }
  }
  function isObjectEmpty(obj) {
    if (obj) {
      for (var prop in obj) {
        if (obj.hasOwnProperty(prop)) {
          return false;
        }
      }
    }
    return true;
  }

  /* global
    VALID_CLASS: false,
    INVALID_CLASS: false,
    PRISTINE_CLASS: false,
    DIRTY_CLASS: false,
    ngModelMinErr: false
  */

  // Regex code was initially obtained from SO prior to modification: https://stackoverflow.com/questions/3143070/javascript-regex-iso-datetime#answer-3143231
  var ISO_DATE_REGEXP = /^\d{4,}-[01]\d-[0-3]\dT[0-2]\d:[0-5]\d:[0-5]\d\.\d+(?:[+-][0-2]\d:[0-5]\d|Z)$/;
  // See valid URLs in RFC3987 (http://tools.ietf.org/html/rfc3987)
  // Note: We are being more lenient, because browsers are too.
  //   1. Scheme
  //   2. Slashes
  //   3. Username
  //   4. Password
  //   5. Hostname
  //   6. Port
  //   7. Path
  //   8. Query
  //   9. Fragment
  //                 1111111111111111 222   333333    44444        55555555555555555555555     666     77777777     8888888     999
  var URL_REGEXP = /^[a-z][a-z\d.+-]*:\/*(?:[^:@]+(?::[^@]+)?@)?(?:[^\s:/?#]+|\[[a-f\d:]+])(?::\d+)?(?:\/[^?#]*)?(?:\?[^#]*)?(?:#.*)?$/i;
  // eslint-disable-next-line max-len
  var EMAIL_REGEXP = /^(?=.{1,254}$)(?=.{1,64}@)[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+(\.[-!#$%&'*+/0-9=?A-Z^_`a-z{|}~]+)*@[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?(\.[A-Za-z0-9]([A-Za-z0-9-]{0,61}[A-Za-z0-9])?)*$/;
  var NUMBER_REGEXP = /^\s*(-|\+)?(\d+|(\d*(\.\d*)))([eE][+-]?\d+)?\s*$/;
  var DATE_REGEXP = /^(\d{4,})-(\d{2})-(\d{2})$/;
  var DATETIMELOCAL_REGEXP = /^(\d{4,})-(\d\d)-(\d\d)T(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
  var WEEK_REGEXP = /^(\d{4,})-W(\d\d)$/;
  var MONTH_REGEXP = /^(\d{4,})-(\d\d)$/;
  var TIME_REGEXP = /^(\d\d):(\d\d)(?::(\d\d)(\.\d{1,3})?)?$/;
  var PARTIAL_VALIDATION_EVENTS = 'keydown wheel mousedown';
  var PARTIAL_VALIDATION_TYPES = createMap();
  forEach('date,datetime-local,month,time,week'.split(','), function (type) {
    PARTIAL_VALIDATION_TYPES[type] = true;
  });
  var inputType = {
    /**
     * @ngdoc input
     * @name input[text]
     *
     * @description
     * Standard HTML text input with AngularJS data binding, inherited by most of the `input` elements.
     *
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} required Adds `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
     *    minlength.
     * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
     *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
     *    any length.
     * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
     *    that contains the regular expression body that will be converted to a regular expression
     *    as in the ngPattern directive.
     * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
     *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
     *    If the expression evaluates to a RegExp object, then this is used directly.
     *    If the expression evaluates to a string, then it will be converted to a RegExp
     *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
     *    `new RegExp('^abc$')`.<br />
     *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
     *    start at the index of the last search's match, thus not taking the whole input value into
     *    account.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
     *    This parameter is ignored for input[type=password] controls, which will never trim the
     *    input.
     *
     * @example
        <example name="text-input-directive" module="textInputExample">
          <file name="index.html">
           <script>
             angular.module('textInputExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.example = {
                   text: 'guest',
                   word: /^\s*\w*\s*$/
                 };
               }]);
           </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Single word:
               <input type="text" name="input" ng-model="example.text"
                      ng-pattern="example.word" required ng-trim="false">
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.pattern">
                 Single word only!</span>
             </div>
             <code>text = {{example.text}}</code><br/>
             <code>myForm.input.$valid = {{myForm.input.$valid}}</code><br/>
             <code>myForm.input.$error = {{myForm.input.$error}}</code><br/>
             <code>myForm.$valid = {{myForm.$valid}}</code><br/>
             <code>myForm.$error.required = {{!!myForm.$error.required}}</code><br/>
            </form>
          </file>
          <file name="protractor.js" type="protractor">
            var text = element(by.binding('example.text'));
            var valid = element(by.binding('myForm.input.$valid'));
            var input = element(by.model('example.text'));
             it('should initialize to model', function() {
              expect(text.getText()).toContain('guest');
              expect(valid.getText()).toContain('true');
            });
             it('should be invalid if empty', function() {
              input.clear();
              input.sendKeys('');
               expect(text.getText()).toEqual('text =');
              expect(valid.getText()).toContain('false');
            });
             it('should be invalid if multi word', function() {
              input.clear();
              input.sendKeys('hello world');
               expect(valid.getText()).toContain('false');
            });
          </file>
        </example>
     */
    'text': textInputType,
    /**
     * @ngdoc input
     * @name input[date]
     *
     * @description
     * Input with date validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, text must be entered in a valid ISO-8601
     * date format (yyyy-MM-dd), for example: `2009-01-06`. Since many
     * modern browsers do not yet support this input type, it is important to provide cues to users on the
     * expected input format via a placeholder or label.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`. This must be a
     *   valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `min="{{minDate | date:'yyyy-MM-dd'}}"`). Note that `min` will also add native HTML5
     *   constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`. This must be
     *   a valid ISO date string (yyyy-MM-dd). You can also use interpolation inside this attribute
     *   (e.g. `max="{{maxDate | date:'yyyy-MM-dd'}}"`). Note that `max` will also add native HTML5
     *   constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO date string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO date string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="date-input-directive" module="dateInputExample">
     <file name="index.html">
       <script>
          angular.module('dateInputExample', [])
            .controller('DateController', ['$scope', function($scope) {
              $scope.example = {
                value: new Date(2013, 9, 22)
              };
            }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a date in 2013:</label>
          <input type="date" id="exampleInput" name="input" ng-model="example.value"
              placeholder="yyyy-MM-dd" min="2013-01-01" max="2013-12-31" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.date">
                Not a valid date!</span>
           </div>
           <tt>value = {{example.value | date: "yyyy-MM-dd"}}</tt><br/>
           <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
           <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM-dd"'));
        var valid = element(by.binding('myForm.input.$valid'));
         // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (see https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }
         it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10-22');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });
         it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
         it('should be invalid if over max', function() {
          setInput('2015-01-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
    'date': createDateInputType('date', DATE_REGEXP, createDateParser(DATE_REGEXP, ['yyyy', 'MM', 'dd']), 'yyyy-MM-dd'),
    /**
     * @ngdoc input
     * @name input[datetime-local]
     *
     * @description
     * Input with datetime validation and transformation. In browsers that do not yet support
     * the HTML5 date input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
     * local datetime format (yyyy-MM-ddTHH:mm:ss), for example: `2010-12-28T14:57:00`.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * The format of the displayed time can be adjusted with the
     * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
     * and `timeStripZeroSeconds`.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
     *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
     *   inside this attribute (e.g. `min="{{minDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
     *   Note that `min` will also add native HTML5 constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
     *   This must be a valid ISO datetime format (yyyy-MM-ddTHH:mm:ss). You can also use interpolation
     *   inside this attribute (e.g. `max="{{maxDatetimeLocal | date:'yyyy-MM-ddTHH:mm:ss'}}"`).
     *   Note that `max` will also add native HTML5 constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation error key to the Date / ISO datetime string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation error key to the Date / ISO datetime string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="datetimelocal-input-directive" module="dateExample">
     <file name="index.html">
       <script>
         angular.module('dateExample', [])
           .controller('DateController', ['$scope', function($scope) {
             $scope.example = {
               value: new Date(2010, 11, 28, 14, 57)
             };
           }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
         <label for="exampleInput">Pick a date between in 2013:</label>
         <input type="datetime-local" id="exampleInput" name="input" ng-model="example.value"
             placeholder="yyyy-MM-ddTHH:mm:ss" min="2001-01-01T00:00:00" max="2013-12-31T00:00:00" required />
         <div role="alert">
           <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
           <span class="error" ng-show="myForm.input.$error.datetimelocal">
               Not a valid date!</span>
         </div>
         <tt>value = {{example.value | date: "yyyy-MM-ddTHH:mm:ss"}}</tt><br/>
         <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
         <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
       var value = element(by.binding('example.value | date: "yyyy-MM-ddTHH:mm:ss"'));
       var valid = element(by.binding('myForm.input.$valid'));
        // currently protractor/webdriver does not support
       // sending keys to all known HTML5 input controls
       // for various browsers (https://github.com/angular/protractor/issues/562).
       function setInput(val) {
         // set the value of the element and force validation.
         var scr = "var ipt = document.getElementById('exampleInput'); " +
         "ipt.value = '" + val + "';" +
         "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
         browser.executeScript(scr);
       }
        it('should initialize to model', function() {
         expect(value.getText()).toContain('2010-12-28T14:57:00');
         expect(valid.getText()).toContain('myForm.input.$valid = true');
       });
        it('should be invalid if empty', function() {
         setInput('');
         expect(value.getText()).toEqual('value =');
         expect(valid.getText()).toContain('myForm.input.$valid = false');
       });
        it('should be invalid if over max', function() {
         setInput('2015-01-01T23:59:00');
         expect(value.getText()).toContain('');
         expect(valid.getText()).toContain('myForm.input.$valid = false');
       });
     </file>
     </example>
     */
    'datetime-local': createDateInputType('datetimelocal', DATETIMELOCAL_REGEXP, createDateParser(DATETIMELOCAL_REGEXP, ['yyyy', 'MM', 'dd', 'HH', 'mm', 'ss', 'sss']), 'yyyy-MM-ddTHH:mm:ss.sss'),
    /**
     * @ngdoc input
     * @name input[time]
     *
     * @description
     * Input with time validation and transformation. In browsers that do not yet support
     * the HTML5 time input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
     * local time format (HH:mm:ss), for example: `14:57:00`. Model must be a Date object. This binding will always output a
     * Date object to the model of January 1, 1970, or local date `new Date(1970, 0, 1, HH, mm, ss)`.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions}. By default,
     * this is the timezone of the browser.
     *
     * The format of the displayed time can be adjusted with the
     * {@link ng.directive:ngModelOptions#ngModelOptions-arguments ngModelOptions} `timeSecondsFormat`
     * and `timeStripZeroSeconds`.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
     *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
     *   attribute (e.g. `min="{{minTime | date:'HH:mm:ss'}}"`). Note that `min` will also add
     *   native HTML5 constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
     *   This must be a valid ISO time format (HH:mm:ss). You can also use interpolation inside this
     *   attribute (e.g. `max="{{maxTime | date:'HH:mm:ss'}}"`). Note that `max` will also add
     *   native HTML5 constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO time string the
     *   `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO time string the
     *   `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="time-input-directive" module="timeExample">
     <file name="index.html">
       <script>
        angular.module('timeExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(1970, 0, 1, 14, 57, 0)
            };
          }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
          <label for="exampleInput">Pick a time between 8am and 5pm:</label>
          <input type="time" id="exampleInput" name="input" ng-model="example.value"
              placeholder="HH:mm:ss" min="08:00:00" max="17:00:00" required />
          <div role="alert">
            <span class="error" ng-show="myForm.input.$error.required">
                Required!</span>
            <span class="error" ng-show="myForm.input.$error.time">
                Not a valid date!</span>
          </div>
          <tt>value = {{example.value | date: "HH:mm:ss"}}</tt><br/>
          <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
          <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
          <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
          <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "HH:mm:ss"'));
        var valid = element(by.binding('myForm.input.$valid'));
         // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }
         it('should initialize to model', function() {
          expect(value.getText()).toContain('14:57:00');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });
         it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
         it('should be invalid if over max', function() {
          setInput('23:59:00');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
    'time': createDateInputType('time', TIME_REGEXP, createDateParser(TIME_REGEXP, ['HH', 'mm', 'ss', 'sss']), 'HH:mm:ss.sss'),
    /**
     * @ngdoc input
     * @name input[week]
     *
     * @description
     * Input with week-of-the-year validation and transformation to Date. In browsers that do not yet support
     * the HTML5 week input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
     * week format (yyyy-W##), for example: `2013-W02`.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     *
     * The value of the resulting Date object will be set to Thursday at 00:00:00 of the requested week,
     * due to ISO-8601 week numbering standards. Information on ISO's system for numbering the weeks of the
     * year can be found at: https://en.wikipedia.org/wiki/ISO_8601#Week_dates
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
     *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
     *   attribute (e.g. `min="{{minWeek | date:'yyyy-Www'}}"`). Note that `min` will also add
     *   native HTML5 constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
     *   This must be a valid ISO week format (yyyy-W##). You can also use interpolation inside this
     *   attribute (e.g. `max="{{maxWeek | date:'yyyy-Www'}}"`). Note that `max` will also add
     *   native HTML5 constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="week-input-directive" module="weekExample">
     <file name="index.html">
       <script>
       angular.module('weekExample', [])
         .controller('DateController', ['$scope', function($scope) {
           $scope.example = {
             value: new Date(2013, 0, 3)
           };
         }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
         <label>Pick a date between in 2013:
           <input id="exampleInput" type="week" name="input" ng-model="example.value"
                  placeholder="YYYY-W##" min="2012-W32"
                  max="2013-W52" required />
         </label>
         <div role="alert">
           <span class="error" ng-show="myForm.input.$error.required">
               Required!</span>
           <span class="error" ng-show="myForm.input.$error.week">
               Not a valid date!</span>
         </div>
         <tt>value = {{example.value | date: "yyyy-Www"}}</tt><br/>
         <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
         <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
       var value = element(by.binding('example.value | date: "yyyy-Www"'));
       var valid = element(by.binding('myForm.input.$valid'));
        // currently protractor/webdriver does not support
       // sending keys to all known HTML5 input controls
       // for various browsers (https://github.com/angular/protractor/issues/562).
       function setInput(val) {
         // set the value of the element and force validation.
         var scr = "var ipt = document.getElementById('exampleInput'); " +
         "ipt.value = '" + val + "';" +
         "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
         browser.executeScript(scr);
       }
        it('should initialize to model', function() {
         expect(value.getText()).toContain('2013-W01');
         expect(valid.getText()).toContain('myForm.input.$valid = true');
       });
        it('should be invalid if empty', function() {
         setInput('');
         expect(value.getText()).toEqual('value =');
         expect(valid.getText()).toContain('myForm.input.$valid = false');
       });
        it('should be invalid if over max', function() {
         setInput('2015-W01');
         expect(value.getText()).toContain('');
         expect(valid.getText()).toContain('myForm.input.$valid = false');
       });
     </file>
     </example>
     */
    'week': createDateInputType('week', WEEK_REGEXP, weekParser, 'yyyy-Www'),
    /**
     * @ngdoc input
     * @name input[month]
     *
     * @description
     * Input with month validation and transformation. In browsers that do not yet support
     * the HTML5 month input, a text element will be used. In that case, the text must be entered in a valid ISO-8601
     * month format (yyyy-MM), for example: `2009-01`.
     *
     * The model must always be a Date object, otherwise AngularJS will throw an error.
     * Invalid `Date` objects (dates whose `getTime()` is `NaN`) will be rendered as an empty string.
     * If the model is not set to the first of the month, the next view to model update will set it
     * to the first of the month.
     *
     * The timezone to be used to read/write the `Date` instance in the model can be defined using
     * {@link ng.directive:ngModelOptions ngModelOptions}. By default, this is the timezone of the browser.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
     *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
     *   attribute (e.g. `min="{{minMonth | date:'yyyy-MM'}}"`). Note that `min` will also add
     *   native HTML5 constraint validation.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
     *   This must be a valid ISO month format (yyyy-MM). You can also use interpolation inside this
     *   attribute (e.g. `max="{{maxMonth | date:'yyyy-MM'}}"`). Note that `max` will also add
     *   native HTML5 constraint validation.
     * @param {(date|string)=} ngMin Sets the `min` validation constraint to the Date / ISO week string
     *   the `ngMin` expression evaluates to. Note that it does not set the `min` attribute.
     * @param {(date|string)=} ngMax Sets the `max` validation constraint to the Date / ISO week string
     *   the `ngMax` expression evaluates to. Note that it does not set the `max` attribute.
      * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
     <example name="month-input-directive" module="monthExample">
     <file name="index.html">
       <script>
        angular.module('monthExample', [])
          .controller('DateController', ['$scope', function($scope) {
            $scope.example = {
              value: new Date(2013, 9, 1)
            };
          }]);
       </script>
       <form name="myForm" ng-controller="DateController as dateCtrl">
         <label for="exampleInput">Pick a month in 2013:</label>
         <input id="exampleInput" type="month" name="input" ng-model="example.value"
            placeholder="yyyy-MM" min="2013-01" max="2013-12" required />
         <div role="alert">
           <span class="error" ng-show="myForm.input.$error.required">
              Required!</span>
           <span class="error" ng-show="myForm.input.$error.month">
              Not a valid month!</span>
         </div>
         <tt>value = {{example.value | date: "yyyy-MM"}}</tt><br/>
         <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
         <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
         <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
         <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
       </form>
     </file>
     <file name="protractor.js" type="protractor">
        var value = element(by.binding('example.value | date: "yyyy-MM"'));
        var valid = element(by.binding('myForm.input.$valid'));
         // currently protractor/webdriver does not support
        // sending keys to all known HTML5 input controls
        // for various browsers (https://github.com/angular/protractor/issues/562).
        function setInput(val) {
          // set the value of the element and force validation.
          var scr = "var ipt = document.getElementById('exampleInput'); " +
          "ipt.value = '" + val + "';" +
          "angular.element(ipt).scope().$apply(function(s) { s.myForm[ipt.name].$setViewValue('" + val + "'); });";
          browser.executeScript(scr);
        }
         it('should initialize to model', function() {
          expect(value.getText()).toContain('2013-10');
          expect(valid.getText()).toContain('myForm.input.$valid = true');
        });
         it('should be invalid if empty', function() {
          setInput('');
          expect(value.getText()).toEqual('value =');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
         it('should be invalid if over max', function() {
          setInput('2015-01');
          expect(value.getText()).toContain('');
          expect(valid.getText()).toContain('myForm.input.$valid = false');
        });
     </file>
     </example>
     */
    'month': createDateInputType('month', MONTH_REGEXP, createDateParser(MONTH_REGEXP, ['yyyy', 'MM']), 'yyyy-MM'),
    /**
     * @ngdoc input
     * @name input[number]
     *
     * @description
     * Text input with number validation and transformation. Sets the `number` validation
     * error if not a valid number.
     *
     * <div class="alert alert-warning">
     * The model must always be of type `number` otherwise AngularJS will throw an error.
     * Be aware that a string containing a number is not enough. See the {@link ngModel:numfmt}
     * error docs for more information and an example of how to convert your model if necessary.
     * </div>
     *
     *
     *
     * @knownIssue
     *
     * ### HTML5 constraint validation and `allowInvalid`
     *
     * In browsers that follow the
     * [HTML5 specification](https://html.spec.whatwg.org/multipage/forms.html#number-state-%28type=number%29),
     * `input[number]` does not work as expected with {@link ngModelOptions `ngModelOptions.allowInvalid`}.
     * If a non-number is entered in the input, the browser will report the value as an empty string,
     * which means the view / model values in `ngModel` and subsequently the scope value
     * will also be an empty string.
     *
     * @knownIssue
     *
     * ### Large numbers and `step` validation
     *
     * The `step` validation will not work correctly for very large numbers (e.g. 9999999999) due to
     * Javascript's arithmetic limitations. If you need to handle large numbers, purpose-built
     * libraries (e.g. https://github.com/MikeMcl/big.js/), can be included into AngularJS by
     * {@link guide/forms#modifying-built-in-validators overwriting the validators}
     * for `number` and / or `step`, or by {@link guide/forms#custom-validation applying custom validators}
     * to an `input[text]` element. The source for `input[number]` type can be used as a starting
     * point for both implementations.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation error key if the value entered is less than `min`.
     *    Can be interpolated.
     * @param {string=} max Sets the `max` validation error key if the value entered is greater than `max`.
     *    Can be interpolated.
     * @param {string=} ngMin Like `min`, sets the `min` validation error key if the value entered is less than `ngMin`,
     *    but does not trigger HTML5 native validation. Takes an expression.
     * @param {string=} ngMax Like `max`, sets the `max` validation error key if the value entered is greater than `ngMax`,
     *    but does not trigger HTML5 native validation. Takes an expression.
     * @param {string=} step Sets the `step` validation error key if the value entered does not fit the `step` constraint.
     *    Can be interpolated.
     * @param {string=} ngStep Like `step`, sets the `step` validation error key if the value entered does not fit the `ngStep` constraint,
     *    but does not trigger HTML5 native validation. Takes an expression.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
     *    minlength.
     * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
     *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
     *    any length.
     * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
     *    that contains the regular expression body that will be converted to a regular expression
     *    as in the ngPattern directive.
     * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
     *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
     *    If the expression evaluates to a RegExp object, then this is used directly.
     *    If the expression evaluates to a string, then it will be converted to a RegExp
     *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
     *    `new RegExp('^abc$')`.<br />
     *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
     *    start at the index of the last search's match, thus not taking the whole input value into
     *    account.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
        <example name="number-input-directive" module="numberExample">
          <file name="index.html">
           <script>
             angular.module('numberExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.example = {
                   value: 12
                 };
               }]);
           </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Number:
               <input type="number" name="input" ng-model="example.value"
                      min="0" max="99" required>
            </label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.number">
                 Not valid number!</span>
             </div>
             <tt>value = {{example.value}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
            </form>
          </file>
          <file name="protractor.js" type="protractor">
            var value = element(by.binding('example.value'));
            var valid = element(by.binding('myForm.input.$valid'));
            var input = element(by.model('example.value'));
             it('should initialize to model', function() {
              expect(value.getText()).toContain('12');
              expect(valid.getText()).toContain('true');
            });
             it('should be invalid if empty', function() {
              input.clear();
              input.sendKeys('');
              expect(value.getText()).toEqual('value =');
              expect(valid.getText()).toContain('false');
            });
             it('should be invalid if over max', function() {
              input.clear();
              input.sendKeys('123');
              expect(value.getText()).toEqual('value =');
              expect(valid.getText()).toContain('false');
            });
          </file>
        </example>
     */
    'number': numberInputType,
    /**
     * @ngdoc input
     * @name input[url]
     *
     * @description
     * Text input with URL validation. Sets the `url` validation error key if the content is not a
     * valid URL.
     *
     * <div class="alert alert-warning">
     * **Note:** `input[url]` uses a regex to validate urls that is derived from the regex
     * used in Chromium. If you need stricter validation, you can use `ng-pattern` or modify
     * the built-in validators (see the {@link guide/forms Forms guide})
     * </div>
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
     *    minlength.
     * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
     *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
     *    any length.
     * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
     *    that contains the regular expression body that will be converted to a regular expression
     *    as in the ngPattern directive.
     * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
     *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
     *    If the expression evaluates to a RegExp object, then this is used directly.
     *    If the expression evaluates to a string, then it will be converted to a RegExp
     *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
     *    `new RegExp('^abc$')`.<br />
     *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
     *    start at the index of the last search's match, thus not taking the whole input value into
     *    account.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
        <example name="url-input-directive" module="urlExample">
          <file name="index.html">
           <script>
             angular.module('urlExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.url = {
                   text: 'http://google.com'
                 };
               }]);
           </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>URL:
               <input type="url" name="input" ng-model="url.text" required>
             <label>
             <div role="alert">
               <span class="error" ng-show="myForm.input.$error.required">
                 Required!</span>
               <span class="error" ng-show="myForm.input.$error.url">
                 Not valid url!</span>
             </div>
             <tt>text = {{url.text}}</tt><br/>
             <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
             <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
             <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
             <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
             <tt>myForm.$error.url = {{!!myForm.$error.url}}</tt><br/>
            </form>
          </file>
          <file name="protractor.js" type="protractor">
            var text = element(by.binding('url.text'));
            var valid = element(by.binding('myForm.input.$valid'));
            var input = element(by.model('url.text'));
             it('should initialize to model', function() {
              expect(text.getText()).toContain('http://google.com');
              expect(valid.getText()).toContain('true');
            });
             it('should be invalid if empty', function() {
              input.clear();
              input.sendKeys('');
               expect(text.getText()).toEqual('text =');
              expect(valid.getText()).toContain('false');
            });
             it('should be invalid if not url', function() {
              input.clear();
              input.sendKeys('box');
               expect(valid.getText()).toContain('false');
            });
          </file>
        </example>
     */
    'url': urlInputType,
    /**
     * @ngdoc input
     * @name input[email]
     *
     * @description
     * Text input with email validation. Sets the `email` validation error key if not a valid email
     * address.
     *
     * <div class="alert alert-warning">
     * **Note:** `input[email]` uses a regex to validate email addresses that is derived from the regex
     * used in Chromium, which may not fulfill your app's requirements.
     * If you need stricter (e.g. requiring a top-level domain), or more relaxed validation
     * (e.g. allowing IPv6 address literals) you can use `ng-pattern` or
     * modify the built-in validators (see the {@link guide/forms Forms guide}).
     * </div>
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} required Sets `required` validation error key if the value is not entered.
     * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
     *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
     *    `required` when you want to data-bind to the `required` attribute.
     * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
     *    minlength.
     * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
     *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of
     *    any length.
     * @param {string=} pattern Similar to `ngPattern` except that the attribute value is the actual string
     *    that contains the regular expression body that will be converted to a regular expression
     *    as in the ngPattern directive.
     * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
     *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
     *    If the expression evaluates to a RegExp object, then this is used directly.
     *    If the expression evaluates to a string, then it will be converted to a RegExp
     *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
     *    `new RegExp('^abc$')`.<br />
     *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
     *    start at the index of the last search's match, thus not taking the whole input value into
     *    account.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
        <example name="email-input-directive" module="emailExample">
          <file name="index.html">
           <script>
             angular.module('emailExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.email = {
                   text: 'me@example.com'
                 };
               }]);
           </script>
             <form name="myForm" ng-controller="ExampleController">
               <label>Email:
                 <input type="email" name="input" ng-model="email.text" required>
               </label>
               <div role="alert">
                 <span class="error" ng-show="myForm.input.$error.required">
                   Required!</span>
                 <span class="error" ng-show="myForm.input.$error.email">
                   Not valid email!</span>
               </div>
               <tt>text = {{email.text}}</tt><br/>
               <tt>myForm.input.$valid = {{myForm.input.$valid}}</tt><br/>
               <tt>myForm.input.$error = {{myForm.input.$error}}</tt><br/>
               <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
               <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
               <tt>myForm.$error.email = {{!!myForm.$error.email}}</tt><br/>
             </form>
           </file>
          <file name="protractor.js" type="protractor">
            var text = element(by.binding('email.text'));
            var valid = element(by.binding('myForm.input.$valid'));
            var input = element(by.model('email.text'));
             it('should initialize to model', function() {
              expect(text.getText()).toContain('me@example.com');
              expect(valid.getText()).toContain('true');
            });
             it('should be invalid if empty', function() {
              input.clear();
              input.sendKeys('');
              expect(text.getText()).toEqual('text =');
              expect(valid.getText()).toContain('false');
            });
             it('should be invalid if not email', function() {
              input.clear();
              input.sendKeys('xxx');
               expect(valid.getText()).toContain('false');
            });
          </file>
        </example>
     */
    'email': emailInputType,
    /**
     * @ngdoc input
     * @name input[radio]
     *
     * @description
     * HTML radio button.
     *
     * **Note:**<br>
     * All inputs controlled by {@link ngModel ngModel} (including those of type `radio`) will use the
     * value of their `name` attribute to determine the property under which their
     * {@link ngModel.NgModelController NgModelController} will be published on the parent
     * {@link form.FormController FormController}. Thus, if you use the same `name` for multiple
     * inputs of a form (e.g. a group of radio inputs), only _one_ `NgModelController` will be
     * published on the parent `FormController` under that name. The rest of the controllers will
     * continue to work as expected, but you won't be able to access them as properties on the parent
     * `FormController`.
     *
     * <div class="alert alert-info">
     *   <p>
     *     In plain HTML forms, the `name` attribute is used to identify groups of radio inputs, so
     *     that the browser can manage their state (checked/unchecked) based on the state of other
     *     inputs in the same group.
     *   </p>
     *   <p>
     *     In AngularJS forms, this is not necessary. The input's state will be updated based on the
     *     value of the underlying model data.
     *   </p>
     * </div>
     *
     * <div class="alert alert-success">
     *   If you omit the `name` attribute on a radio input, `ngModel` will automatically assign it a
     *   unique name.
     * </div>
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string} value The value to which the `ngModel` expression should be set when selected.
     *    Note that `value` only supports `string` values, i.e. the scope model needs to be a string,
     *    too. Use `ngValue` if you need complex models (`number`, `object`, ...).
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     * @param {string} ngValue AngularJS expression to which `ngModel` will be be set when the radio
     *    is selected. Should be used instead of the `value` attribute if you need
     *    a non-string `ngModel` (`boolean`, `array`, ...).
     *
     * @example
        <example name="radio-input-directive" module="radioExample">
          <file name="index.html">
           <script>
             angular.module('radioExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.color = {
                   name: 'blue'
                 };
                 $scope.specialValue = {
                   "id": "12345",
                   "value": "green"
                 };
               }]);
           </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>
               <input type="radio" ng-model="color.name" value="red">
               Red
             </label><br/>
             <label>
               <input type="radio" ng-model="color.name" ng-value="specialValue">
               Green
             </label><br/>
             <label>
               <input type="radio" ng-model="color.name" value="blue">
               Blue
             </label><br/>
             <tt>color = {{color.name | json}}</tt><br/>
            </form>
            Note that `ng-value="specialValue"` sets radio item's value to be the value of `$scope.specialValue`.
          </file>
          <file name="protractor.js" type="protractor">
            it('should change state', function() {
              var inputs = element.all(by.model('color.name'));
              var color = element(by.binding('color.name'));
               expect(color.getText()).toContain('blue');
               inputs.get(0).click();
              expect(color.getText()).toContain('red');
               inputs.get(1).click();
              expect(color.getText()).toContain('green');
            });
          </file>
        </example>
     */
    'radio': radioInputType,
    /**
     * @ngdoc input
     * @name input[range]
     *
     * @description
     * Native range input with validation and transformation.
     *
     * The model for the range input must always be a `Number`.
     *
     * IE9 and other browsers that do not support the `range` type fall back
     * to a text input without any default values for `min`, `max` and `step`. Model binding,
     * validation and number parsing are nevertheless supported.
     *
     * Browsers that support range (latest Chrome, Safari, Firefox, Edge) treat `input[range]`
     * in a way that never allows the input to hold an invalid value. That means:
     * - any non-numerical value is set to `(max + min) / 2`.
     * - any numerical value that is less than the current min val, or greater than the current max val
     * is set to the min / max val respectively.
     * - additionally, the current `step` is respected, so the nearest value that satisfies a step
     * is used.
     *
     * See the [HTML Spec on input[type=range]](https://www.w3.org/TR/html5/forms.html#range-state-(type=range))
     * for more info.
     *
     * This has the following consequences for AngularJS:
     *
     * Since the element value should always reflect the current model value, a range input
     * will set the bound ngModel expression to the value that the browser has set for the
     * input element. For example, in the following input `<input type="range" ng-model="model.value">`,
     * if the application sets `model.value = null`, the browser will set the input to `'50'`.
     * AngularJS will then set the model to `50`, to prevent input and model value being out of sync.
     *
     * That means the model for range will immediately be set to `50` after `ngModel` has been
     * initialized. It also means a range input can never have the required error.
     *
     * This does not only affect changes to the model value, but also to the values of the `min`,
     * `max`, and `step` attributes. When these change in a way that will cause the browser to modify
     * the input value, AngularJS will also update the model value.
     *
     * Automatic value adjustment also means that a range input element can never have the `required`,
     * `min`, or `max` errors.
     *
     * However, `step` is currently only fully implemented by Firefox. Other browsers have problems
     * when the step value changes dynamically - they do not adjust the element value correctly, but
     * instead may set the `stepMismatch` error. If that's the case, the AngularJS will set the `step`
     * error on the input, and set the model to `undefined`.
     *
     * Note that `input[range]` is not compatible with`ngMax`, `ngMin`, and `ngStep`, because they do
     * not set the `min` and `max` attributes, which means that the browser won't automatically adjust
     * the input value based on their values, and will always assume min = 0, max = 100, and step = 1.
     *
     * @param {string}  ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {string=} min Sets the `min` validation to ensure that the value entered is greater
     *                  than `min`. Can be interpolated.
     * @param {string=} max Sets the `max` validation to ensure that the value entered is less than `max`.
     *                  Can be interpolated.
     * @param {string=} step Sets the `step` validation to ensure that the value entered matches the `step`
     *                  Can be interpolated.
     * @param {expression=} ngChange AngularJS expression to be executed when the ngModel value changes due
     *                      to user interaction with the input element.
     * @param {expression=} ngChecked If the expression is truthy, then the `checked` attribute will be set on the
     *                      element. **Note** : `ngChecked` should not be used alongside `ngModel`.
     *                      Checkout {@link ng.directive:ngChecked ngChecked} for usage.
     *
     * @example
        <example name="range-input-directive" module="rangeExample">
          <file name="index.html">
            <script>
              angular.module('rangeExample', [])
                .controller('ExampleController', ['$scope', function($scope) {
                  $scope.value = 75;
                  $scope.min = 10;
                  $scope.max = 90;
                }]);
            </script>
            <form name="myForm" ng-controller="ExampleController">
               Model as range: <input type="range" name="range" ng-model="value" min="{{min}}"  max="{{max}}">
              <hr>
              Model as number: <input type="number" ng-model="value"><br>
              Min: <input type="number" ng-model="min"><br>
              Max: <input type="number" ng-model="max"><br>
              value = <code>{{value}}</code><br/>
              myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
              myForm.range.$error = <code>{{myForm.range.$error}}</code>
            </form>
          </file>
        </example>
      * ## Range Input with ngMin & ngMax attributes
      * @example
        <example name="range-input-directive-ng" module="rangeExample">
          <file name="index.html">
            <script>
              angular.module('rangeExample', [])
                .controller('ExampleController', ['$scope', function($scope) {
                  $scope.value = 75;
                  $scope.min = 10;
                  $scope.max = 90;
                }]);
            </script>
            <form name="myForm" ng-controller="ExampleController">
              Model as range: <input type="range" name="range" ng-model="value" ng-min="min" ng-max="max">
              <hr>
              Model as number: <input type="number" ng-model="value"><br>
              Min: <input type="number" ng-model="min"><br>
              Max: <input type="number" ng-model="max"><br>
              value = <code>{{value}}</code><br/>
              myForm.range.$valid = <code>{{myForm.range.$valid}}</code><br/>
              myForm.range.$error = <code>{{myForm.range.$error}}</code>
            </form>
          </file>
        </example>
      */
    'range': rangeInputType,
    /**
     * @ngdoc input
     * @name input[checkbox]
     *
     * @description
     * HTML checkbox.
     *
     * @param {string} ngModel Assignable AngularJS expression to data-bind to.
     * @param {string=} name Property name of the form under which the control is published.
     * @param {expression=} ngTrueValue The value to which the expression should be set when selected.
     * @param {expression=} ngFalseValue The value to which the expression should be set when not selected.
     * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
     *    interaction with the input element.
     *
     * @example
        <example name="checkbox-input-directive" module="checkboxExample">
          <file name="index.html">
           <script>
             angular.module('checkboxExample', [])
               .controller('ExampleController', ['$scope', function($scope) {
                 $scope.checkboxModel = {
                  value1 : true,
                  value2 : 'YES'
                };
               }]);
           </script>
           <form name="myForm" ng-controller="ExampleController">
             <label>Value1:
               <input type="checkbox" ng-model="checkboxModel.value1">
             </label><br/>
             <label>Value2:
               <input type="checkbox" ng-model="checkboxModel.value2"
                      ng-true-value="'YES'" ng-false-value="'NO'">
              </label><br/>
             <tt>value1 = {{checkboxModel.value1}}</tt><br/>
             <tt>value2 = {{checkboxModel.value2}}</tt><br/>
            </form>
          </file>
          <file name="protractor.js" type="protractor">
            it('should change state', function() {
              var value1 = element(by.binding('checkboxModel.value1'));
              var value2 = element(by.binding('checkboxModel.value2'));
               expect(value1.getText()).toContain('true');
              expect(value2.getText()).toContain('YES');
               element(by.model('checkboxModel.value1')).click();
              element(by.model('checkboxModel.value2')).click();
               expect(value1.getText()).toContain('false');
              expect(value2.getText()).toContain('NO');
            });
          </file>
        </example>
     */
    'checkbox': checkboxInputType,
    'hidden': noop,
    'button': noop,
    'submit': noop,
    'reset': noop,
    'file': noop
  };
  function stringBasedInputType(ctrl) {
    ctrl.$formatters.push(function (value) {
      return ctrl.$isEmpty(value) ? value : value.toString();
    });
  }
  function textInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    stringBasedInputType(ctrl);
  }
  function baseInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    var type = lowercase(element[0].type);

    // In composition mode, users are still inputting intermediate text buffer,
    // hold the listener until composition is done.
    // More about composition events: https://developer.mozilla.org/en-US/docs/Web/API/CompositionEvent
    if (!$sniffer.android) {
      var composing = false;
      element.on('compositionstart', function () {
        composing = true;
      });

      // Support: IE9+
      element.on('compositionupdate', function (ev) {
        // End composition when ev.data is empty string on 'compositionupdate' event.
        // When the input de-focusses (e.g. by clicking away), IE triggers 'compositionupdate'
        // instead of 'compositionend'.
        if (isUndefined(ev.data) || ev.data === '') {
          composing = false;
        }
      });
      element.on('compositionend', function () {
        composing = false;
        listener();
      });
    }
    var timeout;
    var listener = function listener(ev) {
      if (timeout) {
        $browser.defer.cancel(timeout);
        timeout = null;
      }
      if (composing) return;
      var value = element.val(),
        event = ev && ev.type;

      // By default we will trim the value
      // If the attribute ng-trim exists we will avoid trimming
      // If input type is 'password', the value is never trimmed
      if (type !== 'password' && (!attr.ngTrim || attr.ngTrim !== 'false')) {
        value = trim(value);
      }

      // If a control is suffering from bad input (due to native validators), browsers discard its
      // value, so it may be necessary to revalidate (by calling $setViewValue again) even if the
      // control's value is the same empty value twice in a row.
      if (ctrl.$viewValue !== value || value === '' && ctrl.$$hasNativeValidators) {
        ctrl.$setViewValue(value, event);
      }
    };

    // if the browser does support "input" event, we are fine - except on IE9 which doesn't fire the
    // input event on backspace, delete or cut
    if ($sniffer.hasEvent('input')) {
      element.on('input', listener);
    } else {
      var deferListener = function deferListener(ev, input, origValue) {
        if (!timeout) {
          timeout = $browser.defer(function () {
            timeout = null;
            if (!input || input.value !== origValue) {
              listener(ev);
            }
          });
        }
      };
      element.on('keydown', /** @this */function (event) {
        var key = event.keyCode;

        // ignore
        //    command            modifiers                   arrows
        if (key === 91 || 15 < key && key < 19 || 37 <= key && key <= 40) return;
        deferListener(event, this, this.value);
      });

      // if user modifies input value using context menu in IE, we need "paste", "cut" and "drop" events to catch it
      if ($sniffer.hasEvent('paste')) {
        element.on('paste cut drop', deferListener);
      }
    }

    // if user paste into input using mouse on older browser
    // or form autocomplete on newer browser, we need "change" event to catch it
    element.on('change', listener);

    // Some native input types (date-family) have the ability to change validity without
    // firing any input/change events.
    // For these event types, when native validators are present and the browser supports the type,
    // check for validity changes on various DOM events.
    if (PARTIAL_VALIDATION_TYPES[type] && ctrl.$$hasNativeValidators && type === attr.type) {
      element.on(PARTIAL_VALIDATION_EVENTS, /** @this */function (ev) {
        if (!timeout) {
          var validity = this[VALIDITY_STATE_PROPERTY];
          var origBadInput = validity.badInput;
          var origTypeMismatch = validity.typeMismatch;
          timeout = $browser.defer(function () {
            timeout = null;
            if (validity.badInput !== origBadInput || validity.typeMismatch !== origTypeMismatch) {
              listener(ev);
            }
          });
        }
      });
    }
    ctrl.$render = function () {
      // Workaround for Firefox validation #12102.
      var value = ctrl.$isEmpty(ctrl.$viewValue) ? '' : ctrl.$viewValue;
      if (element.val() !== value) {
        element.val(value);
      }
    };
  }
  function weekParser(isoWeek, existingDate) {
    if (isDate(isoWeek)) {
      return isoWeek;
    }
    if (isString(isoWeek)) {
      WEEK_REGEXP.lastIndex = 0;
      var parts = WEEK_REGEXP.exec(isoWeek);
      if (parts) {
        var year = +parts[1],
          week = +parts[2],
          hours = 0,
          minutes = 0,
          seconds = 0,
          milliseconds = 0,
          firstThurs = getFirstThursdayOfYear(year),
          addDays = (week - 1) * 7;
        if (existingDate) {
          hours = existingDate.getHours();
          minutes = existingDate.getMinutes();
          seconds = existingDate.getSeconds();
          milliseconds = existingDate.getMilliseconds();
        }
        return new Date(year, 0, firstThurs.getDate() + addDays, hours, minutes, seconds, milliseconds);
      }
    }
    return NaN;
  }
  function createDateParser(regexp, mapping) {
    return function (iso, previousDate) {
      var parts, map;
      if (isDate(iso)) {
        return iso;
      }
      if (isString(iso)) {
        // When a date is JSON'ified to wraps itself inside of an extra
        // set of double quotes. This makes the date parsing code unable
        // to match the date string and parse it as a date.
        if (iso.charAt(0) === '"' && iso.charAt(iso.length - 1) === '"') {
          iso = iso.substring(1, iso.length - 1);
        }
        if (ISO_DATE_REGEXP.test(iso)) {
          return new Date(iso);
        }
        regexp.lastIndex = 0;
        parts = regexp.exec(iso);
        if (parts) {
          parts.shift();
          if (previousDate) {
            map = {
              yyyy: previousDate.getFullYear(),
              MM: previousDate.getMonth() + 1,
              dd: previousDate.getDate(),
              HH: previousDate.getHours(),
              mm: previousDate.getMinutes(),
              ss: previousDate.getSeconds(),
              sss: previousDate.getMilliseconds() / 1000
            };
          } else {
            map = {
              yyyy: 1970,
              MM: 1,
              dd: 1,
              HH: 0,
              mm: 0,
              ss: 0,
              sss: 0
            };
          }
          forEach(parts, function (part, index) {
            if (index < mapping.length) {
              map[mapping[index]] = +part;
            }
          });
          var date = new Date(map.yyyy, map.MM - 1, map.dd, map.HH, map.mm, map.ss || 0, map.sss * 1000 || 0);
          if (map.yyyy < 100) {
            // In the constructor, 2-digit years map to 1900-1999.
            // Use `setFullYear()` to set the correct year.
            date.setFullYear(map.yyyy);
          }
          return date;
        }
      }
      return NaN;
    };
  }
  function createDateInputType(type, regexp, parseDate, format) {
    return function dynamicDateInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
      badInputChecker(scope, element, attr, ctrl, type);
      baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
      var isTimeType = type === 'time' || type === 'datetimelocal';
      var previousDate;
      var previousTimezone;
      ctrl.$parsers.push(function (value) {
        if (ctrl.$isEmpty(value)) return null;
        if (regexp.test(value)) {
          // Note: We cannot read ctrl.$modelValue, as there might be a different
          // parser/formatter in the processing chain so that the model
          // contains some different data format!
          return parseDateAndConvertTimeZoneToLocal(value, previousDate);
        }
        ctrl.$$parserName = type;
        return undefined;
      });
      ctrl.$formatters.push(function (value) {
        if (value && !isDate(value)) {
          throw ngModelMinErr('datefmt', 'Expected `{0}` to be a date', value);
        }
        if (isValidDate(value)) {
          previousDate = value;
          var timezone = ctrl.$options.getOption('timezone');
          if (timezone) {
            previousTimezone = timezone;
            previousDate = convertTimezoneToLocal(previousDate, timezone, true);
          }
          return formatter(value, timezone);
        } else {
          previousDate = null;
          previousTimezone = null;
          return '';
        }
      });
      if (isDefined(attr.min) || attr.ngMin) {
        var minVal = attr.min || $parse(attr.ngMin)(scope);
        var parsedMinVal = parseObservedDateValue(minVal);
        ctrl.$validators.min = function (value) {
          return !isValidDate(value) || isUndefined(parsedMinVal) || parseDate(value) >= parsedMinVal;
        };
        attr.$observe('min', function (val) {
          if (val !== minVal) {
            parsedMinVal = parseObservedDateValue(val);
            minVal = val;
            ctrl.$validate();
          }
        });
      }
      if (isDefined(attr.max) || attr.ngMax) {
        var maxVal = attr.max || $parse(attr.ngMax)(scope);
        var parsedMaxVal = parseObservedDateValue(maxVal);
        ctrl.$validators.max = function (value) {
          return !isValidDate(value) || isUndefined(parsedMaxVal) || parseDate(value) <= parsedMaxVal;
        };
        attr.$observe('max', function (val) {
          if (val !== maxVal) {
            parsedMaxVal = parseObservedDateValue(val);
            maxVal = val;
            ctrl.$validate();
          }
        });
      }
      function isValidDate(value) {
        // Invalid Date: getTime() returns NaN
        return value && !(value.getTime && value.getTime() !== value.getTime());
      }
      function parseObservedDateValue(val) {
        return isDefined(val) && !isDate(val) ? parseDateAndConvertTimeZoneToLocal(val) || undefined : val;
      }
      function parseDateAndConvertTimeZoneToLocal(value, previousDate) {
        var timezone = ctrl.$options.getOption('timezone');
        if (previousTimezone && previousTimezone !== timezone) {
          // If the timezone has changed, adjust the previousDate to the default timezone
          // so that the new date is converted with the correct timezone offset
          previousDate = addDateMinutes(previousDate, timezoneToOffset(previousTimezone));
        }
        var parsedDate = parseDate(value, previousDate);
        if (!isNaN(parsedDate) && timezone) {
          parsedDate = convertTimezoneToLocal(parsedDate, timezone);
        }
        return parsedDate;
      }
      function formatter(value, timezone) {
        var targetFormat = format;
        if (isTimeType && isString(ctrl.$options.getOption('timeSecondsFormat'))) {
          targetFormat = format.replace('ss.sss', ctrl.$options.getOption('timeSecondsFormat')).replace(/:$/, '');
        }
        var formatted = $filter('date')(value, targetFormat, timezone);
        if (isTimeType && ctrl.$options.getOption('timeStripZeroSeconds')) {
          formatted = formatted.replace(/(?::00)?(?:\.000)?$/, '');
        }
        return formatted;
      }
    };
  }
  function badInputChecker(scope, element, attr, ctrl, parserName) {
    var node = element[0];
    var nativeValidation = ctrl.$$hasNativeValidators = isObject(node.validity);
    if (nativeValidation) {
      ctrl.$parsers.push(function (value) {
        var validity = element.prop(VALIDITY_STATE_PROPERTY) || {};
        if (validity.badInput || validity.typeMismatch) {
          ctrl.$$parserName = parserName;
          return undefined;
        }
        return value;
      });
    }
  }
  function numberFormatterParser(ctrl) {
    ctrl.$parsers.push(function (value) {
      if (ctrl.$isEmpty(value)) return null;
      if (NUMBER_REGEXP.test(value)) return parseFloat(value);
      ctrl.$$parserName = 'number';
      return undefined;
    });
    ctrl.$formatters.push(function (value) {
      if (!ctrl.$isEmpty(value)) {
        if (!isNumber(value)) {
          throw ngModelMinErr('numfmt', 'Expected `{0}` to be a number', value);
        }
        value = value.toString();
      }
      return value;
    });
  }
  function parseNumberAttrVal(val) {
    if (isDefined(val) && !isNumber(val)) {
      val = parseFloat(val);
    }
    return !isNumberNaN(val) ? val : undefined;
  }
  function isNumberInteger(num) {
    // See http://stackoverflow.com/questions/14636536/how-to-check-if-a-variable-is-an-integer-in-javascript#14794066
    // (minus the assumption that `num` is a number)

    // eslint-disable-next-line no-bitwise
    return (num | 0) === num;
  }
  function countDecimals(num) {
    var numString = num.toString();
    var decimalSymbolIndex = numString.indexOf('.');
    if (decimalSymbolIndex === -1) {
      if (-1 < num && num < 1) {
        // It may be in the exponential notation format (`1e-X`)
        var match = /e-(\d+)$/.exec(numString);
        if (match) {
          return Number(match[1]);
        }
      }
      return 0;
    }
    return numString.length - decimalSymbolIndex - 1;
  }
  function isValidForStep(viewValue, stepBase, step) {
    // At this point `stepBase` and `step` are expected to be non-NaN values
    // and `viewValue` is expected to be a valid stringified number.
    var value = Number(viewValue);
    var isNonIntegerValue = !isNumberInteger(value);
    var isNonIntegerStepBase = !isNumberInteger(stepBase);
    var isNonIntegerStep = !isNumberInteger(step);

    // Due to limitations in Floating Point Arithmetic (e.g. `0.3 - 0.2 !== 0.1` or
    // `0.5 % 0.1 !== 0`), we need to convert all numbers to integers.
    if (isNonIntegerValue || isNonIntegerStepBase || isNonIntegerStep) {
      var valueDecimals = isNonIntegerValue ? countDecimals(value) : 0;
      var stepBaseDecimals = isNonIntegerStepBase ? countDecimals(stepBase) : 0;
      var stepDecimals = isNonIntegerStep ? countDecimals(step) : 0;
      var decimalCount = Math.max(valueDecimals, stepBaseDecimals, stepDecimals);
      var multiplier = Math.pow(10, decimalCount);
      value = value * multiplier;
      stepBase = stepBase * multiplier;
      step = step * multiplier;
      if (isNonIntegerValue) value = Math.round(value);
      if (isNonIntegerStepBase) stepBase = Math.round(stepBase);
      if (isNonIntegerStep) step = Math.round(step);
    }
    return (value - stepBase) % step === 0;
  }
  function numberInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
    badInputChecker(scope, element, attr, ctrl, 'number');
    numberFormatterParser(ctrl);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    var parsedMinVal;
    if (isDefined(attr.min) || attr.ngMin) {
      var minVal = attr.min || $parse(attr.ngMin)(scope);
      parsedMinVal = parseNumberAttrVal(minVal);
      ctrl.$validators.min = function (modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(parsedMinVal) || viewValue >= parsedMinVal;
      };
      attr.$observe('min', function (val) {
        if (val !== minVal) {
          parsedMinVal = parseNumberAttrVal(val);
          minVal = val;
          // TODO(matsko): implement validateLater to reduce number of validations
          ctrl.$validate();
        }
      });
    }
    if (isDefined(attr.max) || attr.ngMax) {
      var maxVal = attr.max || $parse(attr.ngMax)(scope);
      var parsedMaxVal = parseNumberAttrVal(maxVal);
      ctrl.$validators.max = function (modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(parsedMaxVal) || viewValue <= parsedMaxVal;
      };
      attr.$observe('max', function (val) {
        if (val !== maxVal) {
          parsedMaxVal = parseNumberAttrVal(val);
          maxVal = val;
          // TODO(matsko): implement validateLater to reduce number of validations
          ctrl.$validate();
        }
      });
    }
    if (isDefined(attr.step) || attr.ngStep) {
      var stepVal = attr.step || $parse(attr.ngStep)(scope);
      var parsedStepVal = parseNumberAttrVal(stepVal);
      ctrl.$validators.step = function (modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(parsedStepVal) || isValidForStep(viewValue, parsedMinVal || 0, parsedStepVal);
      };
      attr.$observe('step', function (val) {
        // TODO(matsko): implement validateLater to reduce number of validations
        if (val !== stepVal) {
          parsedStepVal = parseNumberAttrVal(val);
          stepVal = val;
          ctrl.$validate();
        }
      });
    }
  }
  function rangeInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    badInputChecker(scope, element, attr, ctrl, 'range');
    numberFormatterParser(ctrl);
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    var supportsRange = ctrl.$$hasNativeValidators && element[0].type === 'range',
      minVal = supportsRange ? 0 : undefined,
      maxVal = supportsRange ? 100 : undefined,
      stepVal = supportsRange ? 1 : undefined,
      validity = element[0].validity,
      hasMinAttr = isDefined(attr.min),
      hasMaxAttr = isDefined(attr.max),
      hasStepAttr = isDefined(attr.step);
    var originalRender = ctrl.$render;
    ctrl.$render = supportsRange && isDefined(validity.rangeUnderflow) && isDefined(validity.rangeOverflow) ?
    //Browsers that implement range will set these values automatically, but reading the adjusted values after
    //$render would cause the min / max validators to be applied with the wrong value
    function rangeRender() {
      originalRender();
      ctrl.$setViewValue(element.val());
    } : originalRender;
    if (hasMinAttr) {
      minVal = parseNumberAttrVal(attr.min);
      ctrl.$validators.min = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMinValidator() {
        return true;
      } :
      // non-support browsers validate the min val
      function minValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(minVal) || viewValue >= minVal;
      };
      setInitialValueAndObserver('min', minChange);
    }
    if (hasMaxAttr) {
      maxVal = parseNumberAttrVal(attr.max);
      ctrl.$validators.max = supportsRange ?
      // Since all browsers set the input to a valid value, we don't need to check validity
      function noopMaxValidator() {
        return true;
      } :
      // non-support browsers validate the max val
      function maxValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(maxVal) || viewValue <= maxVal;
      };
      setInitialValueAndObserver('max', maxChange);
    }
    if (hasStepAttr) {
      stepVal = parseNumberAttrVal(attr.step);
      ctrl.$validators.step = supportsRange ? function nativeStepValidator() {
        // Currently, only FF implements the spec on step change correctly (i.e. adjusting the
        // input element value to a valid value). It's possible that other browsers set the stepMismatch
        // validity error instead, so we can at least report an error in that case.
        return !validity.stepMismatch;
      } :
      // ngStep doesn't set the setp attr, so the browser doesn't adjust the input value as setting step would
      function stepValidator(modelValue, viewValue) {
        return ctrl.$isEmpty(viewValue) || isUndefined(stepVal) || isValidForStep(viewValue, minVal || 0, stepVal);
      };
      setInitialValueAndObserver('step', stepChange);
    }
    function setInitialValueAndObserver(htmlAttrName, changeFn) {
      // interpolated attributes set the attribute value only after a digest, but we need the
      // attribute value when the input is first rendered, so that the browser can adjust the
      // input value based on the min/max value
      element.attr(htmlAttrName, attr[htmlAttrName]);
      var oldVal = attr[htmlAttrName];
      attr.$observe(htmlAttrName, function wrappedObserver(val) {
        if (val !== oldVal) {
          oldVal = val;
          changeFn(val);
        }
      });
    }
    function minChange(val) {
      minVal = parseNumberAttrVal(val);
      // ignore changes before model is initialized
      if (isNumberNaN(ctrl.$modelValue)) {
        return;
      }
      if (supportsRange) {
        var elVal = element.val();
        // IE11 doesn't set the el val correctly if the minVal is greater than the element value
        if (minVal > elVal) {
          elVal = minVal;
          element.val(elVal);
        }
        ctrl.$setViewValue(elVal);
      } else {
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    }
    function maxChange(val) {
      maxVal = parseNumberAttrVal(val);
      // ignore changes before model is initialized
      if (isNumberNaN(ctrl.$modelValue)) {
        return;
      }
      if (supportsRange) {
        var elVal = element.val();
        // IE11 doesn't set the el val correctly if the maxVal is less than the element value
        if (maxVal < elVal) {
          element.val(maxVal);
          // IE11 and Chrome don't set the value to the minVal when max < min
          elVal = maxVal < minVal ? minVal : maxVal;
        }
        ctrl.$setViewValue(elVal);
      } else {
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      }
    }
    function stepChange(val) {
      stepVal = parseNumberAttrVal(val);
      // ignore changes before model is initialized
      if (isNumberNaN(ctrl.$modelValue)) {
        return;
      }

      // Some browsers don't adjust the input value correctly, but set the stepMismatch error
      if (!supportsRange) {
        // TODO(matsko): implement validateLater to reduce number of validations
        ctrl.$validate();
      } else if (ctrl.$viewValue !== element.val()) {
        ctrl.$setViewValue(element.val());
      }
    }
  }
  function urlInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    // Note: no badInputChecker here by purpose as `url` is only a validation
    // in browsers, i.e. we can always read out input.value even if it is not valid!
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    stringBasedInputType(ctrl);
    ctrl.$validators.url = function (modelValue, viewValue) {
      var value = modelValue || viewValue;
      return ctrl.$isEmpty(value) || URL_REGEXP.test(value);
    };
  }
  function emailInputType(scope, element, attr, ctrl, $sniffer, $browser) {
    // Note: no badInputChecker here by purpose as `url` is only a validation
    // in browsers, i.e. we can always read out input.value even if it is not valid!
    baseInputType(scope, element, attr, ctrl, $sniffer, $browser);
    stringBasedInputType(ctrl);
    ctrl.$validators.email = function (modelValue, viewValue) {
      var value = modelValue || viewValue;
      return ctrl.$isEmpty(value) || EMAIL_REGEXP.test(value);
    };
  }
  function radioInputType(scope, element, attr, ctrl) {
    var doTrim = !attr.ngTrim || trim(attr.ngTrim) !== 'false';
    // make the name unique, if not defined
    if (isUndefined(attr.name)) {
      element.attr('name', nextUid());
    }
    var listener = function listener(ev) {
      var value;
      if (element[0].checked) {
        value = attr.value;
        if (doTrim) {
          value = trim(value);
        }
        ctrl.$setViewValue(value, ev && ev.type);
      }
    };
    element.on('change', listener);
    ctrl.$render = function () {
      var value = attr.value;
      if (doTrim) {
        value = trim(value);
      }
      element[0].checked = value === ctrl.$viewValue;
    };
    attr.$observe('value', ctrl.$render);
  }
  function parseConstantExpr($parse, context, name, expression, fallback) {
    var parseFn;
    if (isDefined(expression)) {
      parseFn = $parse(expression);
      if (!parseFn.constant) {
        throw ngModelMinErr('constexpr', 'Expected constant expression for `{0}`, but saw ' + '`{1}`.', name, expression);
      }
      return parseFn(context);
    }
    return fallback;
  }
  function checkboxInputType(scope, element, attr, ctrl, $sniffer, $browser, $filter, $parse) {
    var trueValue = parseConstantExpr($parse, scope, 'ngTrueValue', attr.ngTrueValue, true);
    var falseValue = parseConstantExpr($parse, scope, 'ngFalseValue', attr.ngFalseValue, false);
    var listener = function listener(ev) {
      ctrl.$setViewValue(element[0].checked, ev && ev.type);
    };
    element.on('change', listener);
    ctrl.$render = function () {
      element[0].checked = ctrl.$viewValue;
    };

    // Override the standard `$isEmpty` because the $viewValue of an empty checkbox is always set to `false`
    // This is because of the parser below, which compares the `$modelValue` with `trueValue` to convert
    // it to a boolean.
    ctrl.$isEmpty = function (value) {
      return value === false;
    };
    ctrl.$formatters.push(function (value) {
      return equals(value, trueValue);
    });
    ctrl.$parsers.push(function (value) {
      return value ? trueValue : falseValue;
    });
  }

  /**
   * @ngdoc directive
   * @name textarea
   * @restrict E
   *
   * @description
   * HTML textarea element control with AngularJS data-binding. The data-binding and validation
   * properties of this element are exactly the same as those of the
   * {@link ng.directive:input input element}.
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
   *    length.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
   *
   * @knownIssue
   *
   * When specifying the `placeholder` attribute of `<textarea>`, Internet Explorer will temporarily
   * insert the placeholder value as the textarea's content. If the placeholder value contains
   * interpolation (`{{ ... }}`), an error will be logged in the console when AngularJS tries to update
   * the value of the by-then-removed text node. This doesn't affect the functionality of the
   * textarea, but can be undesirable.
   *
   * You can work around this Internet Explorer issue by using `ng-attr-placeholder` instead of
   * `placeholder` on textareas, whenever you need interpolation in the placeholder value. You can
   * find more details on `ngAttr` in the
   * [Interpolation](guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes) section of the
   * Developer Guide.
   */

  /**
   * @ngdoc directive
   * @name input
   * @restrict E
   *
   * @description
   * HTML input element control. When used together with {@link ngModel `ngModel`}, it provides data-binding,
   * input state control, and validation.
   * Input control follows HTML5 input types and polyfills the HTML5 validation behavior for older browsers.
   *
   * <div class="alert alert-warning">
   * **Note:** Not every feature offered is available for all input types.
   * Specifically, data binding and event handling via `ng-model` is unsupported for `input[file]`.
   * </div>
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {boolean=} ngRequired Sets `required` attribute if set to true
   * @param {number=} ngMinlength Sets `minlength` validation error key if the value is shorter than
   *    minlength.
   * @param {number=} ngMaxlength Sets `maxlength` validation error key if the value is longer than
   *    maxlength. Setting the attribute to a negative or non-numeric value, allows view values of any
   *    length.
   * @param {string=} ngPattern Sets `pattern` validation error key if the ngModel {@link ngModel.NgModelController#$viewValue $viewValue}
   *    value does not match a RegExp found by evaluating the AngularJS expression given in the attribute value.
   *    If the expression evaluates to a RegExp object, then this is used directly.
   *    If the expression evaluates to a string, then it will be converted to a RegExp
   *    after wrapping it in `^` and `$` characters. For instance, `"abc"` will be converted to
   *    `new RegExp('^abc$')`.<br />
   *    **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   *    start at the index of the last search's match, thus not taking the whole input value into
   *    account.
   * @param {string=} ngChange AngularJS expression to be executed when input changes due to user
   *    interaction with the input element.
   * @param {boolean=} [ngTrim=true] If set to false AngularJS will not automatically trim the input.
   *    This parameter is ignored for input[type=password] controls, which will never trim the
   *    input.
   *
   * @example
      <example name="input-directive" module="inputExample">
        <file name="index.html">
         <script>
            angular.module('inputExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.user = {name: 'guest', last: 'visitor'};
              }]);
         </script>
         <div ng-controller="ExampleController">
           <form name="myForm">
             <label>
                User name:
                <input type="text" name="userName" ng-model="user.name" required>
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.userName.$error.required">
                Required!</span>
             </div>
             <label>
                Last name:
                <input type="text" name="lastName" ng-model="user.last"
                ng-minlength="3" ng-maxlength="10">
             </label>
             <div role="alert">
               <span class="error" ng-show="myForm.lastName.$error.minlength">
                 Too short!</span>
               <span class="error" ng-show="myForm.lastName.$error.maxlength">
                 Too long!</span>
             </div>
           </form>
           <hr>
           <tt>user = {{user}}</tt><br/>
           <tt>myForm.userName.$valid = {{myForm.userName.$valid}}</tt><br/>
           <tt>myForm.userName.$error = {{myForm.userName.$error}}</tt><br/>
           <tt>myForm.lastName.$valid = {{myForm.lastName.$valid}}</tt><br/>
           <tt>myForm.lastName.$error = {{myForm.lastName.$error}}</tt><br/>
           <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
           <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
           <tt>myForm.$error.minlength = {{!!myForm.$error.minlength}}</tt><br/>
           <tt>myForm.$error.maxlength = {{!!myForm.$error.maxlength}}</tt><br/>
         </div>
        </file>
        <file name="protractor.js" type="protractor">
          var user = element(by.exactBinding('user'));
          var userNameValid = element(by.binding('myForm.userName.$valid'));
          var lastNameValid = element(by.binding('myForm.lastName.$valid'));
          var lastNameError = element(by.binding('myForm.lastName.$error'));
          var formValid = element(by.binding('myForm.$valid'));
          var userNameInput = element(by.model('user.name'));
          var userLastInput = element(by.model('user.last'));
  
          it('should initialize to model', function() {
            expect(user.getText()).toContain('{"name":"guest","last":"visitor"}');
            expect(userNameValid.getText()).toContain('true');
            expect(formValid.getText()).toContain('true');
          });
  
          it('should be invalid if empty when required', function() {
            userNameInput.clear();
            userNameInput.sendKeys('');
  
            expect(user.getText()).toContain('{"last":"visitor"}');
            expect(userNameValid.getText()).toContain('false');
            expect(formValid.getText()).toContain('false');
          });
  
          it('should be valid if empty when min length is set', function() {
            userLastInput.clear();
            userLastInput.sendKeys('');
  
            expect(user.getText()).toContain('{"name":"guest","last":""}');
            expect(lastNameValid.getText()).toContain('true');
            expect(formValid.getText()).toContain('true');
          });
  
          it('should be invalid if less than required min length', function() {
            userLastInput.clear();
            userLastInput.sendKeys('xx');
  
            expect(user.getText()).toContain('{"name":"guest"}');
            expect(lastNameValid.getText()).toContain('false');
            expect(lastNameError.getText()).toContain('minlength');
            expect(formValid.getText()).toContain('false');
          });
  
          it('should be invalid if longer than max length', function() {
            userLastInput.clear();
            userLastInput.sendKeys('some ridiculously long name');
  
            expect(user.getText()).toContain('{"name":"guest"}');
            expect(lastNameValid.getText()).toContain('false');
            expect(lastNameError.getText()).toContain('maxlength');
            expect(formValid.getText()).toContain('false');
          });
        </file>
      </example>
   */
  var inputDirective = ['$browser', '$sniffer', '$filter', '$parse', function ($browser, $sniffer, $filter, $parse) {
    return {
      restrict: 'E',
      require: ['?ngModel'],
      link: {
        pre: function pre(scope, element, attr, ctrls) {
          if (ctrls[0]) {
            (inputType[lowercase(attr.type)] || inputType.text)(scope, element, attr, ctrls[0], $sniffer, $browser, $filter, $parse);
          }
        }
      }
    };
  }];
  var hiddenInputBrowserCacheDirective = function hiddenInputBrowserCacheDirective() {
    var valueProperty = {
      configurable: true,
      enumerable: false,
      get: function get() {
        return this.getAttribute('value') || '';
      },
      set: function set(val) {
        this.setAttribute('value', val);
      }
    };
    return {
      restrict: 'E',
      priority: 200,
      compile: function compile(_, attr) {
        if (lowercase(attr.type) !== 'hidden') {
          return;
        }
        return {
          pre: function pre(scope, element, attr, ctrls) {
            var node = element[0];

            // Support: Edge
            // Moving the DOM around prevents autofillling
            if (node.parentNode) {
              node.parentNode.insertBefore(node, node.nextSibling);
            }

            // Support: FF, IE
            // Avoiding direct assignment to .value prevents autofillling
            if (Object.defineProperty) {
              Object.defineProperty(node, 'value', valueProperty);
            }
          }
        };
      }
    };
  };
  var CONSTANT_VALUE_REGEXP = /^(true|false|\d+)$/;
  /**
   * @ngdoc directive
   * @name ngValue
   * @restrict A
   * @priority 100
   *
   * @description
   * Binds the given expression to the value of the element.
   *
   * It is mainly used on {@link input[radio] `input[radio]`} and option elements,
   * so that when the element is selected, the {@link ngModel `ngModel`} of that element (or its
   * {@link select `select`} parent element) is set to the bound value. It is especially useful
   * for dynamically generated lists using {@link ngRepeat `ngRepeat`}, as shown below.
   *
   * It can also be used to achieve one-way binding of a given expression to an input element
   * such as an `input[text]` or a `textarea`, when that element does not use ngModel.
   *
   * @element ANY
   * @param {string=} ngValue AngularJS expression, whose value will be bound to the `value` attribute
   * and `value` property of the element.
   *
   * @example
      <example name="ngValue-directive" module="valueExample">
        <file name="index.html">
         <script>
            angular.module('valueExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.names = ['pizza', 'unicorns', 'robots'];
                $scope.my = { favorite: 'unicorns' };
              }]);
         </script>
          <form ng-controller="ExampleController">
            <h2>Which is your favorite?</h2>
              <label ng-repeat="name in names" for="{{name}}">
                {{name}}
                <input type="radio"
                       ng-model="my.favorite"
                       ng-value="name"
                       id="{{name}}"
                       name="favorite">
              </label>
            <div>You chose {{my.favorite}}</div>
          </form>
        </file>
        <file name="protractor.js" type="protractor">
          var favorite = element(by.binding('my.favorite'));
  
          it('should initialize to model', function() {
            expect(favorite.getText()).toContain('unicorns');
          });
          it('should bind the values to the inputs', function() {
            element.all(by.model('my.favorite')).get(0).click();
            expect(favorite.getText()).toContain('pizza');
          });
        </file>
      </example>
   */
  var ngValueDirective = function ngValueDirective() {
    /**
     *  inputs use the value attribute as their default value if the value property is not set.
     *  Once the value property has been set (by adding input), it will not react to changes to
     *  the value attribute anymore. Setting both attribute and property fixes this behavior, and
     *  makes it possible to use ngValue as a sort of one-way bind.
     */
    function updateElementValue(element, attr, value) {
      // Support: IE9 only
      // In IE9 values are converted to string (e.g. `input.value = null` results in `input.value === 'null'`).
      var propValue = isDefined(value) ? value : msie === 9 ? '' : null;
      element.prop('value', propValue);
      attr.$set('value', value);
    }
    return {
      restrict: 'A',
      priority: 100,
      compile: function compile(tpl, tplAttr) {
        if (CONSTANT_VALUE_REGEXP.test(tplAttr.ngValue)) {
          return function ngValueConstantLink(scope, elm, attr) {
            var value = scope.$eval(attr.ngValue);
            updateElementValue(elm, attr, value);
          };
        } else {
          return function ngValueLink(scope, elm, attr) {
            scope.$watch(attr.ngValue, function valueWatchAction(value) {
              updateElementValue(elm, attr, value);
            });
          };
        }
      }
    };
  };

  /**
   * @ngdoc directive
   * @name ngBind
   * @restrict AC
   *
   * @description
   * The `ngBind` attribute tells AngularJS to replace the text content of the specified HTML element
   * with the value of a given expression, and to update the text content when the value of that
   * expression changes.
   *
   * Typically, you don't use `ngBind` directly, but instead you use the double curly markup like
   * `{{ expression }}` which is similar but less verbose.
   *
   * It is preferable to use `ngBind` instead of `{{ expression }}` if a template is momentarily
   * displayed by the browser in its raw state before AngularJS compiles it. Since `ngBind` is an
   * element attribute, it makes the bindings invisible to the user while the page is loading.
   *
   * An alternative solution to this problem would be using the
   * {@link ng.directive:ngCloak ngCloak} directive.
   *
   *
   * @element ANY
   * @param {expression} ngBind {@link guide/expression Expression} to evaluate.
   *
   * @example
   * Enter a name in the Live Preview text box; the greeting below the text box changes instantly.
     <example module="bindExample" name="ng-bind">
       <file name="index.html">
         <script>
           angular.module('bindExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.name = 'Whirled';
             }]);
         </script>
         <div ng-controller="ExampleController">
           <label>Enter name: <input type="text" ng-model="name"></label><br>
           Hello <span ng-bind="name"></span>!
         </div>
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-bind', function() {
           var nameInput = element(by.model('name'));
  
           expect(element(by.binding('name')).getText()).toBe('Whirled');
           nameInput.clear();
           nameInput.sendKeys('world');
           expect(element(by.binding('name')).getText()).toBe('world');
         });
       </file>
     </example>
   */
  var ngBindDirective = ['$compile', function ($compile) {
    return {
      restrict: 'AC',
      compile: function ngBindCompile(templateElement) {
        $compile.$$addBindingClass(templateElement);
        return function ngBindLink(scope, element, attr) {
          $compile.$$addBindingInfo(element, attr.ngBind);
          element = element[0];
          scope.$watch(attr.ngBind, function ngBindWatchAction(value) {
            element.textContent = stringify(value);
          });
        };
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngBindTemplate
   *
   * @description
   * The `ngBindTemplate` directive specifies that the element
   * text content should be replaced with the interpolation of the template
   * in the `ngBindTemplate` attribute.
   * Unlike `ngBind`, the `ngBindTemplate` can contain multiple `{{` `}}`
   * expressions. This directive is needed since some HTML elements
   * (such as TITLE and OPTION) cannot contain SPAN elements.
   *
   * @element ANY
   * @param {string} ngBindTemplate template of form
   *   <tt>{{</tt> <tt>expression</tt> <tt>}}</tt> to eval.
   *
   * @example
   * Try it here: enter text in text box and watch the greeting change.
     <example module="bindExample" name="ng-bind-template">
       <file name="index.html">
         <script>
           angular.module('bindExample', [])
             .controller('ExampleController', ['$scope', function($scope) {
               $scope.salutation = 'Hello';
               $scope.name = 'World';
             }]);
         </script>
         <div ng-controller="ExampleController">
          <label>Salutation: <input type="text" ng-model="salutation"></label><br>
          <label>Name: <input type="text" ng-model="name"></label><br>
          <pre ng-bind-template="{{salutation}} {{name}}!"></pre>
         </div>
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-bind', function() {
           var salutationElem = element(by.binding('salutation'));
           var salutationInput = element(by.model('salutation'));
           var nameInput = element(by.model('name'));
  
           expect(salutationElem.getText()).toBe('Hello World!');
  
           salutationInput.clear();
           salutationInput.sendKeys('Greetings');
           nameInput.clear();
           nameInput.sendKeys('user');
  
           expect(salutationElem.getText()).toBe('Greetings user!');
         });
       </file>
     </example>
   */
  var ngBindTemplateDirective = ['$interpolate', '$compile', function ($interpolate, $compile) {
    return {
      compile: function ngBindTemplateCompile(templateElement) {
        $compile.$$addBindingClass(templateElement);
        return function ngBindTemplateLink(scope, element, attr) {
          var interpolateFn = $interpolate(element.attr(attr.$attr.ngBindTemplate));
          $compile.$$addBindingInfo(element, interpolateFn.expressions);
          element = element[0];
          attr.$observe('ngBindTemplate', function (value) {
            element.textContent = isUndefined(value) ? '' : value;
          });
        };
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngBindHtml
   *
   * @description
   * Evaluates the expression and inserts the resulting HTML into the element in a secure way. By default,
   * the resulting HTML content will be sanitized using the {@link ngSanitize.$sanitize $sanitize} service.
   * To utilize this functionality, ensure that `$sanitize` is available, for example, by including {@link
   * ngSanitize} in your module's dependencies (not in core AngularJS). In order to use {@link ngSanitize}
   * in your module's dependencies, you need to include "angular-sanitize.js" in your application.
   *
   * You may also bypass sanitization for values you know are safe. To do so, bind to
   * an explicitly trusted value via {@link ng.$sce#trustAsHtml $sce.trustAsHtml}.  See the example
   * under {@link ng.$sce#show-me-an-example-using-sce- Strict Contextual Escaping (SCE)}.
   *
   * Note: If a `$sanitize` service is unavailable and the bound value isn't explicitly trusted, you
   * will have an exception (instead of an exploit.)
   *
   * @element ANY
   * @param {expression} ngBindHtml {@link guide/expression Expression} to evaluate.
   *
   * @example
  
     <example module="bindHtmlExample" deps="angular-sanitize.js" name="ng-bind-html">
       <file name="index.html">
         <div ng-controller="ExampleController">
          <p ng-bind-html="myHTML"></p>
         </div>
       </file>
  
       <file name="script.js">
         angular.module('bindHtmlExample', ['ngSanitize'])
           .controller('ExampleController', ['$scope', function($scope) {
             $scope.myHTML =
                'I am an <code>HTML</code>string with ' +
                '<a href="#">links!</a> and other <em>stuff</em>';
           }]);
       </file>
  
       <file name="protractor.js" type="protractor">
         it('should check ng-bind-html', function() {
           expect(element(by.binding('myHTML')).getText()).toBe(
               'I am an HTMLstring with links! and other stuff');
         });
       </file>
     </example>
   */
  var ngBindHtmlDirective = ['$sce', '$parse', '$compile', function ($sce, $parse, $compile) {
    return {
      restrict: 'A',
      compile: function ngBindHtmlCompile(tElement, tAttrs) {
        var ngBindHtmlGetter = $parse(tAttrs.ngBindHtml);
        var ngBindHtmlWatch = $parse(tAttrs.ngBindHtml, function sceValueOf(val) {
          // Unwrap the value to compare the actual inner safe value, not the wrapper object.
          return $sce.valueOf(val);
        });
        $compile.$$addBindingClass(tElement);
        return function ngBindHtmlLink(scope, element, attr) {
          $compile.$$addBindingInfo(element, attr.ngBindHtml);
          scope.$watch(ngBindHtmlWatch, function ngBindHtmlWatchAction() {
            // The watched value is the unwrapped value. To avoid re-escaping, use the direct getter.
            var value = ngBindHtmlGetter(scope);
            element.html($sce.getTrustedHtml(value) || '');
          });
        };
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngChange
   * @restrict A
   *
   * @description
   * Evaluate the given expression when the user changes the input.
   * The expression is evaluated immediately, unlike the JavaScript onchange event
   * which only triggers at the end of a change (usually, when the user leaves the
   * form element or presses the return key).
   *
   * The `ngChange` expression is only evaluated when a change in the input value causes
   * a new value to be committed to the model.
   *
   * It will not be evaluated:
   * * if the value returned from the `$parsers` transformation pipeline has not changed
   * * if the input has continued to be invalid since the model will stay `null`
   * * if the model is changed programmatically and not by a change to the input value
   *
   *
   * Note, this directive requires `ngModel` to be present.
   *
   * @element ANY
   * @param {expression} ngChange {@link guide/expression Expression} to evaluate upon change
   * in input value.
   *
   * @example
   * <example name="ngChange-directive" module="changeExample">
   *   <file name="index.html">
   *     <script>
   *       angular.module('changeExample', [])
   *         .controller('ExampleController', ['$scope', function($scope) {
   *           $scope.counter = 0;
   *           $scope.change = function() {
   *             $scope.counter++;
   *           };
   *         }]);
   *     </script>
   *     <div ng-controller="ExampleController">
   *       <input type="checkbox" ng-model="confirmed" ng-change="change()" id="ng-change-example1" />
   *       <input type="checkbox" ng-model="confirmed" id="ng-change-example2" />
   *       <label for="ng-change-example2">Confirmed</label><br />
   *       <tt>debug = {{confirmed}}</tt><br/>
   *       <tt>counter = {{counter}}</tt><br/>
   *     </div>
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *     var counter = element(by.binding('counter'));
   *     var debug = element(by.binding('confirmed'));
   *
   *     it('should evaluate the expression if changing from view', function() {
   *       expect(counter.getText()).toContain('0');
   *
   *       element(by.id('ng-change-example1')).click();
   *
   *       expect(counter.getText()).toContain('1');
   *       expect(debug.getText()).toContain('true');
   *     });
   *
   *     it('should not evaluate the expression if changing from model', function() {
   *       element(by.id('ng-change-example2')).click();
  
   *       expect(counter.getText()).toContain('0');
   *       expect(debug.getText()).toContain('true');
   *     });
   *   </file>
   * </example>
   */
  var ngChangeDirective = valueFn({
    restrict: 'A',
    require: 'ngModel',
    link: function link(scope, element, attr, ctrl) {
      ctrl.$viewChangeListeners.push(function () {
        scope.$eval(attr.ngChange);
      });
    }
  });

  /* exported
    ngClassDirective,
    ngClassEvenDirective,
    ngClassOddDirective
  */

  function classDirective(name, selector) {
    name = 'ngClass' + name;
    var indexWatchExpression;
    return ['$parse', function ($parse) {
      return {
        restrict: 'AC',
        link: function link(scope, element, attr) {
          var classCounts = element.data('$classCounts');
          var oldModulo = true;
          var oldClassString;
          if (!classCounts) {
            // Use createMap() to prevent class assumptions involving property
            // names in Object.prototype
            classCounts = createMap();
            element.data('$classCounts', classCounts);
          }
          if (name !== 'ngClass') {
            if (!indexWatchExpression) {
              indexWatchExpression = $parse('$index', function moduloTwo($index) {
                // eslint-disable-next-line no-bitwise
                return $index & 1;
              });
            }
            scope.$watch(indexWatchExpression, ngClassIndexWatchAction);
          }
          scope.$watch($parse(attr[name], toClassString), ngClassWatchAction);
          function addClasses(classString) {
            classString = digestClassCounts(split(classString), 1);
            attr.$addClass(classString);
          }
          function removeClasses(classString) {
            classString = digestClassCounts(split(classString), -1);
            attr.$removeClass(classString);
          }
          function updateClasses(oldClassString, newClassString) {
            var oldClassArray = split(oldClassString);
            var newClassArray = split(newClassString);
            var toRemoveArray = arrayDifference(oldClassArray, newClassArray);
            var toAddArray = arrayDifference(newClassArray, oldClassArray);
            var toRemoveString = digestClassCounts(toRemoveArray, -1);
            var toAddString = digestClassCounts(toAddArray, 1);
            attr.$addClass(toAddString);
            attr.$removeClass(toRemoveString);
          }
          function digestClassCounts(classArray, count) {
            var classesToUpdate = [];
            forEach(classArray, function (className) {
              if (count > 0 || classCounts[className]) {
                classCounts[className] = (classCounts[className] || 0) + count;
                if (classCounts[className] === +(count > 0)) {
                  classesToUpdate.push(className);
                }
              }
            });
            return classesToUpdate.join(' ');
          }
          function ngClassIndexWatchAction(newModulo) {
            // This watch-action should run before the `ngClassWatchAction()`, thus it
            // adds/removes `oldClassString`. If the `ngClass` expression has changed as well, the
            // `ngClassWatchAction()` will update the classes.
            if (newModulo === selector) {
              addClasses(oldClassString);
            } else {
              removeClasses(oldClassString);
            }
            oldModulo = newModulo;
          }
          function ngClassWatchAction(newClassString) {
            if (oldModulo === selector) {
              updateClasses(oldClassString, newClassString);
            }
            oldClassString = newClassString;
          }
        }
      };
    }];

    // Helpers
    function arrayDifference(tokens1, tokens2) {
      if (!tokens1 || !tokens1.length) return [];
      if (!tokens2 || !tokens2.length) return tokens1;
      var values = [];
      outer: for (var i = 0; i < tokens1.length; i++) {
        var token = tokens1[i];
        for (var j = 0; j < tokens2.length; j++) {
          if (token === tokens2[j]) continue outer;
        }
        values.push(token);
      }
      return values;
    }
    function split(classString) {
      return classString && classString.split(' ');
    }
    function toClassString(classValue) {
      if (!classValue) return classValue;
      var classString = classValue;
      if (isArray(classValue)) {
        classString = classValue.map(toClassString).join(' ');
      } else if (isObject(classValue)) {
        classString = Object.keys(classValue).filter(function (key) {
          return classValue[key];
        }).join(' ');
      } else if (!isString(classValue)) {
        classString = classValue + '';
      }
      return classString;
    }
  }

  /**
   * @ngdoc directive
   * @name ngClass
   * @restrict AC
   * @element ANY
   *
   * @description
   * The `ngClass` directive allows you to dynamically set CSS classes on an HTML element by databinding
   * an expression that represents all classes to be added.
   *
   * The directive operates in three different ways, depending on which of three types the expression
   * evaluates to:
   *
   * 1. If the expression evaluates to a string, the string should be one or more space-delimited class
   * names.
   *
   * 2. If the expression evaluates to an object, then for each key-value pair of the
   * object with a truthy value the corresponding key is used as a class name.
   *
   * 3. If the expression evaluates to an array, each element of the array should either be a string as in
   * type 1 or an object as in type 2. This means that you can mix strings and objects together in an array
   * to give you more control over what CSS classes appear. See the code below for an example of this.
   *
   *
   * The directive won't add duplicate classes if a particular class was already set.
   *
   * When the expression changes, the previously added classes are removed and only then are the
   * new classes added.
   *
   * @knownIssue
   * You should not use {@link guide/interpolation interpolation} in the value of the `class`
   * attribute, when using the `ngClass` directive on the same element.
   * See {@link guide/interpolation#known-issues here} for more info.
   *
   * @animations
   * | Animation                        | Occurs                              |
   * |----------------------------------|-------------------------------------|
   * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
   * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
   * | {@link ng.$animate#setClass setClass} | just before classes are added and classes are removed from the element at the same time |
   *
   * ### ngClass and pre-existing CSS3 Transitions/Animations
     The ngClass directive still supports CSS3 Transitions/Animations even if they do not follow the ngAnimate CSS naming structure.
     Upon animation ngAnimate will apply supplementary CSS classes to track the start and end of an animation, but this will not hinder
     any pre-existing CSS transitions already on the element. To get an idea of what happens during a class-based animation, be sure
     to view the step by step details of {@link $animate#addClass $animate.addClass} and
     {@link $animate#removeClass $animate.removeClass}.
   *
   * @param {expression} ngClass {@link guide/expression Expression} to eval. The result
   *   of the evaluation can be a string representing space delimited class
   *   names, an array, or a map of class names to boolean values. In the case of a map, the
   *   names of the properties whose values are truthy will be added as css classes to the
   *   element.
   *
   * @example
   * ### Basic
     <example name="ng-class">
       <file name="index.html">
         <p ng-class="{strike: deleted, bold: important, 'has-error': error}">Map Syntax Example</p>
         <label>
            <input type="checkbox" ng-model="deleted">
            deleted (apply "strike" class)
         </label><br>
         <label>
            <input type="checkbox" ng-model="important">
            important (apply "bold" class)
         </label><br>
         <label>
            <input type="checkbox" ng-model="error">
            error (apply "has-error" class)
         </label>
         <hr>
         <p ng-class="style">Using String Syntax</p>
         <input type="text" ng-model="style"
                placeholder="Type: bold strike red" aria-label="Type: bold strike red">
         <hr>
         <p ng-class="[style1, style2, style3]">Using Array Syntax</p>
         <input ng-model="style1"
                placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red"><br>
         <input ng-model="style2"
                placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 2"><br>
         <input ng-model="style3"
                placeholder="Type: bold, strike or red" aria-label="Type: bold, strike or red 3"><br>
         <hr>
         <p ng-class="[style4, {orange: warning}]">Using Array and Map Syntax</p>
         <input ng-model="style4" placeholder="Type: bold, strike" aria-label="Type: bold, strike"><br>
         <label><input type="checkbox" ng-model="warning"> warning (apply "orange" class)</label>
       </file>
       <file name="style.css">
         .strike {
             text-decoration: line-through;
         }
         .bold {
             font-weight: bold;
         }
         .red {
             color: red;
         }
         .has-error {
             color: red;
             background-color: yellow;
         }
         .orange {
             color: orange;
         }
       </file>
       <file name="protractor.js" type="protractor">
         var ps = element.all(by.css('p'));
  
         it('should let you toggle the class', function() {
  
           expect(ps.first().getAttribute('class')).not.toMatch(/bold/);
           expect(ps.first().getAttribute('class')).not.toMatch(/has-error/);
  
           element(by.model('important')).click();
           expect(ps.first().getAttribute('class')).toMatch(/bold/);
  
           element(by.model('error')).click();
           expect(ps.first().getAttribute('class')).toMatch(/has-error/);
         });
  
         it('should let you toggle string example', function() {
           expect(ps.get(1).getAttribute('class')).toBe('');
           element(by.model('style')).clear();
           element(by.model('style')).sendKeys('red');
           expect(ps.get(1).getAttribute('class')).toBe('red');
         });
  
         it('array example should have 3 classes', function() {
           expect(ps.get(2).getAttribute('class')).toBe('');
           element(by.model('style1')).sendKeys('bold');
           element(by.model('style2')).sendKeys('strike');
           element(by.model('style3')).sendKeys('red');
           expect(ps.get(2).getAttribute('class')).toBe('bold strike red');
         });
  
         it('array with map example should have 2 classes', function() {
           expect(ps.last().getAttribute('class')).toBe('');
           element(by.model('style4')).sendKeys('bold');
           element(by.model('warning')).click();
           expect(ps.last().getAttribute('class')).toBe('bold orange');
         });
       </file>
     </example>
  
     @example
     ### Animations
  
     The example below demonstrates how to perform animations using ngClass.
  
     <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class">
       <file name="index.html">
        <input id="setbtn" type="button" value="set" ng-click="myVar='my-class'">
        <input id="clearbtn" type="button" value="clear" ng-click="myVar=''">
        <br>
        <span class="base-class" ng-class="myVar">Sample Text</span>
       </file>
       <file name="style.css">
         .base-class {
           transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
         }
  
         .base-class.my-class {
           color: red;
           font-size:3em;
         }
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-class', function() {
           expect(element(by.css('.base-class')).getAttribute('class')).not.
             toMatch(/my-class/);
  
           element(by.id('setbtn')).click();
  
           expect(element(by.css('.base-class')).getAttribute('class')).
             toMatch(/my-class/);
  
           element(by.id('clearbtn')).click();
  
           expect(element(by.css('.base-class')).getAttribute('class')).not.
             toMatch(/my-class/);
         });
       </file>
     </example>
   */
  var ngClassDirective = classDirective('', true);

  /**
   * @ngdoc directive
   * @name ngClassOdd
   * @restrict AC
   *
   * @description
   * The `ngClassOdd` and `ngClassEven` directives work exactly as
   * {@link ng.directive:ngClass ngClass}, except they work in
   * conjunction with `ngRepeat` and take effect only on odd (even) rows.
   *
   * This directive can be applied only within the scope of an
   * {@link ng.directive:ngRepeat ngRepeat}.
   *
   * @animations
   * | Animation                        | Occurs                              |
   * |----------------------------------|-------------------------------------|
   * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
   * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
   *
   * @element ANY
   * @param {expression} ngClassOdd {@link guide/expression Expression} to eval. The result
   *   of the evaluation can be a string representing space delimited class names or an array.
   *
   * @example
     <example name="ng-class-odd">
       <file name="index.html">
          <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
            <li ng-repeat="name in names">
             <span ng-class-odd="'odd'" ng-class-even="'even'">
               {{name}}
             </span>
            </li>
          </ol>
       </file>
       <file name="style.css">
         .odd {
           color: red;
         }
         .even {
           color: blue;
         }
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-class-odd and ng-class-even', function() {
           expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
             toMatch(/odd/);
           expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
             toMatch(/even/);
         });
       </file>
     </example>
   *
   * <hr />
   * @example
   * An example on how to implement animations using `ngClassOdd`:
   *
     <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-odd-animate">
       <file name="index.html">
         <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
           <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
           <hr />
           <table>
             <tr ng-repeat="item in items" ng-class-odd="'odd'">
               <td>{{ item }}</td>
             </tr>
           </table>
         </div>
       </file>
       <file name="style.css">
         .odd {
           background: rgba(255, 255, 0, 0.25);
         }
  
         .odd-add, .odd-remove {
           transition: 1.5s;
         }
       </file>
       <file name="protractor.js" type="protractor">
         it('should add new entries to the beginning of the list', function() {
           var button = element(by.buttonText('Add item'));
           var rows = element.all(by.repeater('item in items'));
  
           expect(rows.count()).toBe(4);
           expect(rows.get(0).getText()).toBe('Item 3');
           expect(rows.get(1).getText()).toBe('Item 2');
  
           button.click();
  
           expect(rows.count()).toBe(5);
           expect(rows.get(0).getText()).toBe('Item 4');
           expect(rows.get(1).getText()).toBe('Item 3');
         });
  
         it('should add odd class to odd entries', function() {
           var button = element(by.buttonText('Add item'));
           var rows = element.all(by.repeater('item in items'));
  
           expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
           expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
  
           button.click();
  
           expect(rows.get(0).getAttribute('class')).toMatch(/odd/);
           expect(rows.get(1).getAttribute('class')).not.toMatch(/odd/);
         });
       </file>
     </example>
   */
  var ngClassOddDirective = classDirective('Odd', 0);

  /**
   * @ngdoc directive
   * @name ngClassEven
   * @restrict AC
   *
   * @description
   * The `ngClassOdd` and `ngClassEven` directives work exactly as
   * {@link ng.directive:ngClass ngClass}, except they work in
   * conjunction with `ngRepeat` and take effect only on odd (even) rows.
   *
   * This directive can be applied only within the scope of an
   * {@link ng.directive:ngRepeat ngRepeat}.
   *
   * @animations
   * | Animation                        | Occurs                              |
   * |----------------------------------|-------------------------------------|
   * | {@link ng.$animate#addClass addClass}       | just before the class is applied to the element   |
   * | {@link ng.$animate#removeClass removeClass} | just before the class is removed from the element |
   *
   * @element ANY
   * @param {expression} ngClassEven {@link guide/expression Expression} to eval. The
   *   result of the evaluation can be a string representing space delimited class names or an array.
   *
   * @example
     <example name="ng-class-even">
       <file name="index.html">
          <ol ng-init="names=['John', 'Mary', 'Cate', 'Suz']">
            <li ng-repeat="name in names">
             <span ng-class-odd="'odd'" ng-class-even="'even'">
               {{name}} &nbsp; &nbsp; &nbsp;
             </span>
            </li>
          </ol>
       </file>
       <file name="style.css">
         .odd {
           color: red;
         }
         .even {
           color: blue;
         }
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-class-odd and ng-class-even', function() {
           expect(element(by.repeater('name in names').row(0).column('name')).getAttribute('class')).
             toMatch(/odd/);
           expect(element(by.repeater('name in names').row(1).column('name')).getAttribute('class')).
             toMatch(/even/);
         });
       </file>
     </example>
   *
   * <hr />
   * @example
   * An example on how to implement animations using `ngClassEven`:
   *
     <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-class-even-animate">
       <file name="index.html">
         <div ng-init="items=['Item 3', 'Item 2', 'Item 1', 'Item 0']">
           <button ng-click="items.unshift('Item ' + items.length)">Add item</button>
           <hr />
           <table>
             <tr ng-repeat="item in items" ng-class-even="'even'">
               <td>{{ item }}</td>
             </tr>
           </table>
         </div>
       </file>
       <file name="style.css">
         .even {
           background: rgba(255, 255, 0, 0.25);
         }
  
         .even-add, .even-remove {
           transition: 1.5s;
         }
       </file>
       <file name="protractor.js" type="protractor">
         it('should add new entries to the beginning of the list', function() {
           var button = element(by.buttonText('Add item'));
           var rows = element.all(by.repeater('item in items'));
  
           expect(rows.count()).toBe(4);
           expect(rows.get(0).getText()).toBe('Item 3');
           expect(rows.get(1).getText()).toBe('Item 2');
  
           button.click();
  
           expect(rows.count()).toBe(5);
           expect(rows.get(0).getText()).toBe('Item 4');
           expect(rows.get(1).getText()).toBe('Item 3');
         });
  
         it('should add even class to even entries', function() {
           var button = element(by.buttonText('Add item'));
           var rows = element.all(by.repeater('item in items'));
  
           expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
           expect(rows.get(1).getAttribute('class')).toMatch(/even/);
  
           button.click();
  
           expect(rows.get(0).getAttribute('class')).not.toMatch(/even/);
           expect(rows.get(1).getAttribute('class')).toMatch(/even/);
         });
       </file>
     </example>
   */
  var ngClassEvenDirective = classDirective('Even', 1);

  /**
   * @ngdoc directive
   * @name ngCloak
   * @restrict AC
   *
   * @description
   * The `ngCloak` directive is used to prevent the AngularJS html template from being briefly
   * displayed by the browser in its raw (uncompiled) form while your application is loading. Use this
   * directive to avoid the undesirable flicker effect caused by the html template display.
   *
   * The directive can be applied to the `<body>` element, but the preferred usage is to apply
   * multiple `ngCloak` directives to small portions of the page to permit progressive rendering
   * of the browser view.
   *
   * `ngCloak` works in cooperation with the following css rule embedded within `angular.js` and
   * `angular.min.js`.
   * For CSP mode please add `angular-csp.css` to your html file (see {@link ng.directive:ngCsp ngCsp}).
   *
   * ```css
   * [ng\:cloak], [ng-cloak], [data-ng-cloak], [x-ng-cloak], .ng-cloak, .x-ng-cloak {
   *   display: none !important;
   * }
   * ```
   *
   * When this css rule is loaded by the browser, all html elements (including their children) that
   * are tagged with the `ngCloak` directive are hidden. When AngularJS encounters this directive
   * during the compilation of the template it deletes the `ngCloak` element attribute, making
   * the compiled element visible.
   *
   * For the best result, the `angular.js` script must be loaded in the head section of the html
   * document; alternatively, the css rule above must be included in the external stylesheet of the
   * application.
   *
   * @element ANY
   *
   * @example
     <example name="ng-cloak">
       <file name="index.html">
          <div id="template1" ng-cloak>{{ 'hello' }}</div>
          <div id="template2" class="ng-cloak">{{ 'world' }}</div>
       </file>
       <file name="protractor.js" type="protractor">
         it('should remove the template directive and css class', function() {
           expect($('#template1').getAttribute('ng-cloak')).
             toBeNull();
           expect($('#template2').getAttribute('ng-cloak')).
             toBeNull();
         });
       </file>
     </example>
   *
   */
  var ngCloakDirective = ngDirective({
    compile: function compile(element, attr) {
      attr.$set('ngCloak', undefined);
      element.removeClass('ng-cloak');
    }
  });

  /**
   * @ngdoc directive
   * @name ngController
   *
   * @description
   * The `ngController` directive attaches a controller class to the view. This is a key aspect of how angular
   * supports the principles behind the Model-View-Controller design pattern.
   *
   * MVC components in angular:
   *
   * * Model — Models are the properties of a scope; scopes are attached to the DOM where scope properties
   *   are accessed through bindings.
   * * View — The template (HTML with data bindings) that is rendered into the View.
   * * Controller — The `ngController` directive specifies a Controller class; the class contains business
   *   logic behind the application to decorate the scope with functions and values
   *
   * Note that you can also attach controllers to the DOM by declaring it in a route definition
   * via the {@link ngRoute.$route $route} service. A common mistake is to declare the controller
   * again using `ng-controller` in the template itself.  This will cause the controller to be attached
   * and executed twice.
   *
   * @element ANY
   * @scope
   * @priority 500
   * @param {expression} ngController Name of a constructor function registered with the current
   * {@link ng.$controllerProvider $controllerProvider} or an {@link guide/expression expression}
   * that on the current scope evaluates to a constructor function.
   *
   * The controller instance can be published into a scope property by specifying
   * `ng-controller="as propertyName"`.
   *
   * @example
   * Here is a simple form for editing user contact information. Adding, removing, clearing, and
   * greeting are methods declared on the controller (see source tab). These methods can
   * easily be called from the AngularJS markup. Any changes to the data are automatically reflected
   * in the View without the need for a manual update.
   *
   * Two different declaration styles are included below:
   *
   * * one binds methods and properties directly onto the controller using `this`:
   * `ng-controller="SettingsController1 as settings"`
   * * one injects `$scope` into the controller:
   * `ng-controller="SettingsController2"`
   *
   * The second option is more common in the AngularJS community, and is generally used in boilerplates
   * and in this guide. However, there are advantages to binding properties directly to the controller
   * and avoiding scope.
   *
   * * Using `controller as` makes it obvious which controller you are accessing in the template when
   * multiple controllers apply to an element.
   * * If you are writing your controllers as classes you have easier access to the properties and
   * methods, which will appear on the scope, from inside the controller code.
   * * Since there is always a `.` in the bindings, you don't have to worry about prototypal
   * inheritance masking primitives.
   *
   * This example demonstrates the `controller as` syntax.
   *
   * <example name="ngControllerAs" module="controllerAsExample">
   *   <file name="index.html">
   *    <div id="ctrl-as-exmpl" ng-controller="SettingsController1 as settings">
   *      <label>Name: <input type="text" ng-model="settings.name"/></label>
   *      <button ng-click="settings.greet()">greet</button><br/>
   *      Contact:
   *      <ul>
   *        <li ng-repeat="contact in settings.contacts">
   *          <select ng-model="contact.type" aria-label="Contact method" id="select_{{$index}}">
   *             <option>phone</option>
   *             <option>email</option>
   *          </select>
   *          <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
   *          <button ng-click="settings.clearContact(contact)">clear</button>
   *          <button ng-click="settings.removeContact(contact)" aria-label="Remove">X</button>
   *        </li>
   *        <li><button ng-click="settings.addContact()">add</button></li>
   *     </ul>
   *    </div>
   *   </file>
   *   <file name="app.js">
   *    angular.module('controllerAsExample', [])
   *      .controller('SettingsController1', SettingsController1);
   *
   *    function SettingsController1() {
   *      this.name = 'John Smith';
   *      this.contacts = [
   *        {type: 'phone', value: '408 555 1212'},
   *        {type: 'email', value: 'john.smith@example.org'}
   *      ];
   *    }
   *
   *    SettingsController1.prototype.greet = function() {
   *      alert(this.name);
   *    };
   *
   *    SettingsController1.prototype.addContact = function() {
   *      this.contacts.push({type: 'email', value: 'yourname@example.org'});
   *    };
   *
   *    SettingsController1.prototype.removeContact = function(contactToRemove) {
   *     var index = this.contacts.indexOf(contactToRemove);
   *      this.contacts.splice(index, 1);
   *    };
   *
   *    SettingsController1.prototype.clearContact = function(contact) {
   *      contact.type = 'phone';
   *      contact.value = '';
   *    };
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *     it('should check controller as', function() {
   *       var container = element(by.id('ctrl-as-exmpl'));
   *         expect(container.element(by.model('settings.name'))
   *           .getAttribute('value')).toBe('John Smith');
   *
   *       var firstRepeat =
   *           container.element(by.repeater('contact in settings.contacts').row(0));
   *       var secondRepeat =
   *           container.element(by.repeater('contact in settings.contacts').row(1));
   *
   *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
   *           .toBe('408 555 1212');
   *
   *       expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
   *           .toBe('john.smith@example.org');
   *
   *       firstRepeat.element(by.buttonText('clear')).click();
   *
   *       expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
   *           .toBe('');
   *
   *       container.element(by.buttonText('add')).click();
   *
   *       expect(container.element(by.repeater('contact in settings.contacts').row(2))
   *           .element(by.model('contact.value'))
   *           .getAttribute('value'))
   *           .toBe('yourname@example.org');
   *     });
   *   </file>
   * </example>
   *
   * This example demonstrates the "attach to `$scope`" style of controller.
   *
   * <example name="ngController" module="controllerExample">
   *  <file name="index.html">
   *   <div id="ctrl-exmpl" ng-controller="SettingsController2">
   *     <label>Name: <input type="text" ng-model="name"/></label>
   *     <button ng-click="greet()">greet</button><br/>
   *     Contact:
   *     <ul>
   *       <li ng-repeat="contact in contacts">
   *         <select ng-model="contact.type" id="select_{{$index}}">
   *            <option>phone</option>
   *            <option>email</option>
   *         </select>
   *         <input type="text" ng-model="contact.value" aria-labelledby="select_{{$index}}" />
   *         <button ng-click="clearContact(contact)">clear</button>
   *         <button ng-click="removeContact(contact)">X</button>
   *       </li>
   *       <li>[ <button ng-click="addContact()">add</button> ]</li>
   *    </ul>
   *   </div>
   *  </file>
   *  <file name="app.js">
   *   angular.module('controllerExample', [])
   *     .controller('SettingsController2', ['$scope', SettingsController2]);
   *
   *   function SettingsController2($scope) {
   *     $scope.name = 'John Smith';
   *     $scope.contacts = [
   *       {type:'phone', value:'408 555 1212'},
   *       {type:'email', value:'john.smith@example.org'}
   *     ];
   *
   *     $scope.greet = function() {
   *       alert($scope.name);
   *     };
   *
   *     $scope.addContact = function() {
   *       $scope.contacts.push({type:'email', value:'yourname@example.org'});
   *     };
   *
   *     $scope.removeContact = function(contactToRemove) {
   *       var index = $scope.contacts.indexOf(contactToRemove);
   *       $scope.contacts.splice(index, 1);
   *     };
   *
   *     $scope.clearContact = function(contact) {
   *       contact.type = 'phone';
   *       contact.value = '';
   *     };
   *   }
   *  </file>
   *  <file name="protractor.js" type="protractor">
   *    it('should check controller', function() {
   *      var container = element(by.id('ctrl-exmpl'));
   *
   *      expect(container.element(by.model('name'))
   *          .getAttribute('value')).toBe('John Smith');
   *
   *      var firstRepeat =
   *          container.element(by.repeater('contact in contacts').row(0));
   *      var secondRepeat =
   *          container.element(by.repeater('contact in contacts').row(1));
   *
   *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
   *          .toBe('408 555 1212');
   *      expect(secondRepeat.element(by.model('contact.value')).getAttribute('value'))
   *          .toBe('john.smith@example.org');
   *
   *      firstRepeat.element(by.buttonText('clear')).click();
   *
   *      expect(firstRepeat.element(by.model('contact.value')).getAttribute('value'))
   *          .toBe('');
   *
   *      container.element(by.buttonText('add')).click();
   *
   *      expect(container.element(by.repeater('contact in contacts').row(2))
   *          .element(by.model('contact.value'))
   *          .getAttribute('value'))
   *          .toBe('yourname@example.org');
   *    });
   *  </file>
   *</example>
  
   */
  var ngControllerDirective = [function () {
    return {
      restrict: 'A',
      scope: true,
      controller: '@',
      priority: 500
    };
  }];

  /**
   * @ngdoc directive
   * @name ngCsp
   *
   * @restrict A
   * @element ANY
   * @description
   *
   * AngularJS has some features that can conflict with certain restrictions that are applied when using
   * [CSP (Content Security Policy)](https://developer.mozilla.org/en/Security/CSP) rules.
   *
   * If you intend to implement CSP with these rules then you must tell AngularJS not to use these
   * features.
   *
   * This is necessary when developing things like Google Chrome Extensions or Universal Windows Apps.
   *
   *
   * The following default rules in CSP affect AngularJS:
   *
   * * The use of `eval()`, `Function(string)` and similar functions to dynamically create and execute
   * code from strings is forbidden. AngularJS makes use of this in the {@link $parse} service to
   * provide a 30% increase in the speed of evaluating AngularJS expressions. (This CSP rule can be
   * disabled with the CSP keyword `unsafe-eval`, but it is generally not recommended as it would
   * weaken the protections offered by CSP.)
   *
   * * The use of inline resources, such as inline `<script>` and `<style>` elements, are forbidden.
   * This prevents apps from injecting custom styles directly into the document. AngularJS makes use of
   * this to include some CSS rules (e.g. {@link ngCloak} and {@link ngHide}). To make these
   * directives work when a CSP rule is blocking inline styles, you must link to the `angular-csp.css`
   * in your HTML manually. (This CSP rule can be disabled with the CSP keyword `unsafe-inline`, but
   * it is generally not recommended as it would weaken the protections offered by CSP.)
   *
   * If you do not provide `ngCsp` then AngularJS tries to autodetect if CSP is blocking dynamic code
   * creation from strings (e.g., `unsafe-eval` not specified in CSP header) and automatically
   * deactivates this feature in the {@link $parse} service. This autodetection, however, triggers a
   * CSP error to be logged in the console:
   *
   * ```
   * Refused to evaluate a string as JavaScript because 'unsafe-eval' is not an allowed source of
   * script in the following Content Security Policy directive: "default-src 'self'". Note that
   * 'script-src' was not explicitly set, so 'default-src' is used as a fallback.
   * ```
   *
   * This error is harmless but annoying. To prevent the error from showing up, put the `ngCsp`
   * directive on an element of the HTML document that appears before the `<script>` tag that loads
   * the `angular.js` file.
   *
   * *Note: This directive is only available in the `ng-csp` and `data-ng-csp` attribute form.*
   *
   * You can specify which of the CSP related AngularJS features should be deactivated by providing
   * a value for the `ng-csp` attribute. The options are as follows:
   *
   * * no-inline-style: this stops AngularJS from injecting CSS styles into the DOM
   *
   * * no-unsafe-eval: this stops AngularJS from optimizing $parse with unsafe eval of strings
   *
   * You can use these values in the following combinations:
   *
   *
   * * No declaration means that AngularJS will assume that you can do inline styles, but it will do
   * a runtime check for unsafe-eval. E.g. `<body>`. This is backwardly compatible with previous
   * versions of AngularJS.
   *
   * * A simple `ng-csp` (or `data-ng-csp`) attribute will tell AngularJS to deactivate both inline
   * styles and unsafe eval. E.g. `<body ng-csp>`. This is backwardly compatible with previous
   * versions of AngularJS.
   *
   * * Specifying only `no-unsafe-eval` tells AngularJS that we must not use eval, but that we can
   * inject inline styles. E.g. `<body ng-csp="no-unsafe-eval">`.
   *
   * * Specifying only `no-inline-style` tells AngularJS that we must not inject styles, but that we can
   * run eval - no automatic check for unsafe eval will occur. E.g. `<body ng-csp="no-inline-style">`
   *
   * * Specifying both `no-unsafe-eval` and `no-inline-style` tells AngularJS that we must not inject
   * styles nor use eval, which is the same as an empty: ng-csp.
   * E.g.`<body ng-csp="no-inline-style;no-unsafe-eval">`
   *
   * @example
   *
   * This example shows how to apply the `ngCsp` directive to the `html` tag.
     ```html
       <!doctype html>
       <html ng-app ng-csp>
       ...
       ...
       </html>
     ```
  
    <!-- Note: the `.csp` suffix in the example name triggers CSP mode in our http server! -->
    <example name="example.csp" module="cspExample" ng-csp="true">
      <file name="index.html">
        <div ng-controller="MainController as ctrl">
          <div>
            <button ng-click="ctrl.inc()" id="inc">Increment</button>
            <span id="counter">
              {{ctrl.counter}}
            </span>
          </div>
  
          <div>
            <button ng-click="ctrl.evil()" id="evil">Evil</button>
            <span id="evilError">
              {{ctrl.evilError}}
            </span>
          </div>
        </div>
      </file>
      <file name="script.js">
         angular.module('cspExample', [])
           .controller('MainController', function MainController() {
              this.counter = 0;
              this.inc = function() {
                this.counter++;
              };
              this.evil = function() {
                try {
                  eval('1+2'); // eslint-disable-line no-eval
                } catch (e) {
                  this.evilError = e.message;
                }
              };
            });
      </file>
      <file name="protractor.js" type="protractor">
        var util, webdriver;
  
        var incBtn = element(by.id('inc'));
        var counter = element(by.id('counter'));
        var evilBtn = element(by.id('evil'));
        var evilError = element(by.id('evilError'));
  
        function getAndClearSevereErrors() {
          return browser.manage().logs().get('browser').then(function(browserLog) {
            return browserLog.filter(function(logEntry) {
              return logEntry.level.value > webdriver.logging.Level.WARNING.value;
            });
          });
        }
  
        function clearErrors() {
          getAndClearSevereErrors();
        }
  
        function expectNoErrors() {
          getAndClearSevereErrors().then(function(filteredLog) {
            expect(filteredLog.length).toEqual(0);
            if (filteredLog.length) {
              console.log('browser console errors: ' + util.inspect(filteredLog));
            }
          });
        }
  
        function expectError(regex) {
          getAndClearSevereErrors().then(function(filteredLog) {
            var found = false;
            filteredLog.forEach(function(log) {
              if (log.message.match(regex)) {
                found = true;
              }
            });
            if (!found) {
              throw new Error('expected an error that matches ' + regex);
            }
          });
        }
  
        beforeEach(function() {
          util = require('util');
          webdriver = require('selenium-webdriver');
        });
  
        // For now, we only test on Chrome,
        // as Safari does not load the page with Protractor's injected scripts,
        // and Firefox webdriver always disables content security policy (#6358)
        if (browser.params.browser !== 'chrome') {
          return;
        }
  
        it('should not report errors when the page is loaded', function() {
          // clear errors so we are not dependent on previous tests
          clearErrors();
          // Need to reload the page as the page is already loaded when
          // we come here
          browser.driver.getCurrentUrl().then(function(url) {
            browser.get(url);
          });
          expectNoErrors();
        });
  
        it('should evaluate expressions', function() {
          expect(counter.getText()).toEqual('0');
          incBtn.click();
          expect(counter.getText()).toEqual('1');
          expectNoErrors();
        });
  
        it('should throw and report an error when using "eval"', function() {
          evilBtn.click();
          expect(evilError.getText()).toMatch(/Content Security Policy/);
          expectError(/Content Security Policy/);
        });
      </file>
    </example>
    */

  // `ngCsp` is not implemented as a proper directive any more, because we need it be processed while
  // we bootstrap the app (before `$parse` is instantiated). For this reason, we just have the `csp()`
  // fn that looks for the `ng-csp` attribute anywhere in the current doc.

  /**
   * @ngdoc directive
   * @name ngClick
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * The ngClick directive allows you to specify custom behavior when
   * an element is clicked.
   *
   * @param {expression} ngClick {@link guide/expression Expression} to evaluate upon
   * click. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-click">
       <file name="index.html">
        <button ng-click="count = count + 1" ng-init="count=0">
          Increment
        </button>
        <span>
          count: {{count}}
        </span>
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-click', function() {
           expect(element(by.binding('count')).getText()).toMatch('0');
           element(by.css('button')).click();
           expect(element(by.binding('count')).getText()).toMatch('1');
         });
       </file>
     </example>
   */
  /*
   * A collection of directives that allows creation of custom event handlers that are defined as
   * AngularJS expressions and are compiled and executed within the current scope.
   */
  var ngEventDirectives = {};

  // For events that might fire synchronously during DOM manipulation
  // we need to execute their event handlers asynchronously using $evalAsync,
  // so that they are not executed in an inconsistent state.
  var forceAsyncEvents = {
    'blur': true,
    'focus': true
  };
  forEach('click dblclick mousedown mouseup mouseover mouseout mousemove mouseenter mouseleave keydown keyup keypress submit focus blur copy cut paste'.split(' '), function (eventName) {
    var directiveName = directiveNormalize('ng-' + eventName);
    ngEventDirectives[directiveName] = ['$parse', '$rootScope', '$exceptionHandler', function ($parse, $rootScope, $exceptionHandler) {
      return createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsyncEvents[eventName]);
    }];
  });
  function createEventDirective($parse, $rootScope, $exceptionHandler, directiveName, eventName, forceAsync) {
    return {
      restrict: 'A',
      compile: function compile($element, attr) {
        // NOTE:
        // We expose the powerful `$event` object on the scope that provides access to the Window,
        // etc. This is OK, because expressions are not sandboxed any more (and the expression
        // sandbox was never meant to be a security feature anyway).
        var fn = $parse(attr[directiveName]);
        return function ngEventHandler(scope, element) {
          element.on(eventName, function (event) {
            var callback = function callback() {
              fn(scope, {
                $event: event
              });
            };
            if (!$rootScope.$$phase) {
              scope.$apply(callback);
            } else if (forceAsync) {
              scope.$evalAsync(callback);
            } else {
              try {
                callback();
              } catch (error) {
                $exceptionHandler(error);
              }
            }
          });
        };
      }
    };
  }

  /**
   * @ngdoc directive
   * @name ngDblclick
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * The `ngDblclick` directive allows you to specify custom behavior on a dblclick event.
   *
   * @param {expression} ngDblclick {@link guide/expression Expression} to evaluate upon
   * a dblclick. (The Event object is available as `$event`)
   *
   * @example
     <example name="ng-dblclick">
       <file name="index.html">
        <button ng-dblclick="count = count + 1" ng-init="count=0">
          Increment (on double click)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngMousedown
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * The ngMousedown directive allows you to specify custom behavior on mousedown event.
   *
   * @param {expression} ngMousedown {@link guide/expression Expression} to evaluate upon
   * mousedown. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-mousedown">
       <file name="index.html">
        <button ng-mousedown="count = count + 1" ng-init="count=0">
          Increment (on mouse down)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngMouseup
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on mouseup event.
   *
   * @param {expression} ngMouseup {@link guide/expression Expression} to evaluate upon
   * mouseup. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-mouseup">
       <file name="index.html">
        <button ng-mouseup="count = count + 1" ng-init="count=0">
          Increment (on mouse up)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngMouseover
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on mouseover event.
   *
   * @param {expression} ngMouseover {@link guide/expression Expression} to evaluate upon
   * mouseover. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-mouseover">
       <file name="index.html">
        <button ng-mouseover="count = count + 1" ng-init="count=0">
          Increment (when mouse is over)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngMouseenter
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on mouseenter event.
   *
   * @param {expression} ngMouseenter {@link guide/expression Expression} to evaluate upon
   * mouseenter. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-mouseenter">
       <file name="index.html">
        <button ng-mouseenter="count = count + 1" ng-init="count=0">
          Increment (when mouse enters)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngMouseleave
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on mouseleave event.
   *
   * @param {expression} ngMouseleave {@link guide/expression Expression} to evaluate upon
   * mouseleave. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-mouseleave">
       <file name="index.html">
        <button ng-mouseleave="count = count + 1" ng-init="count=0">
          Increment (when mouse leaves)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngMousemove
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on mousemove event.
   *
   * @param {expression} ngMousemove {@link guide/expression Expression} to evaluate upon
   * mousemove. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-mousemove">
       <file name="index.html">
        <button ng-mousemove="count = count + 1" ng-init="count=0">
          Increment (when mouse moves)
        </button>
        count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngKeydown
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on keydown event.
   *
   * @param {expression} ngKeydown {@link guide/expression Expression} to evaluate upon
   * keydown. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
   *
   * @example
     <example name="ng-keydown">
       <file name="index.html">
        <input ng-keydown="count = count + 1" ng-init="count=0">
        key down count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngKeyup
   * @restrict A
   * @element ANY
   * @priority 0
   *
   * @description
   * Specify custom behavior on keyup event.
   *
   * @param {expression} ngKeyup {@link guide/expression Expression} to evaluate upon
   * keyup. (Event object is available as `$event` and can be interrogated for keyCode, altKey, etc.)
   *
   * @example
     <example name="ng-keyup">
       <file name="index.html">
         <p>Typing in the input box below updates the key count</p>
         <input ng-keyup="count = count + 1" ng-init="count=0"> key up count: {{count}}
  
         <p>Typing in the input box below updates the keycode</p>
         <input ng-keyup="event=$event">
         <p>event keyCode: {{ event.keyCode }}</p>
         <p>event altKey: {{ event.altKey }}</p>
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngKeypress
   * @restrict A
   * @element ANY
   *
   * @description
   * Specify custom behavior on keypress event.
   *
   * @param {expression} ngKeypress {@link guide/expression Expression} to evaluate upon
   * keypress. ({@link guide/expression#-event- Event object is available as `$event`}
   * and can be interrogated for keyCode, altKey, etc.)
   *
   * @example
     <example name="ng-keypress">
       <file name="index.html">
        <input ng-keypress="count = count + 1" ng-init="count=0">
        key press count: {{count}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngSubmit
   * @restrict A
   * @element form
   * @priority 0
   *
   * @description
   * Enables binding AngularJS expressions to onsubmit events.
   *
   * Additionally it prevents the default action (which for form means sending the request to the
   * server and reloading the current page), but only if the form does not contain `action`,
   * `data-action`, or `x-action` attributes.
   *
   * <div class="alert alert-warning">
   * **Warning:** Be careful not to cause "double-submission" by using both the `ngClick` and
   * `ngSubmit` handlers together. See the
   * {@link form#submitting-a-form-and-preventing-the-default-action `form` directive documentation}
   * for a detailed discussion of when `ngSubmit` may be triggered.
   * </div>
   *
   * @param {expression} ngSubmit {@link guide/expression Expression} to eval.
   * ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example module="submitExample" name="ng-submit">
       <file name="index.html">
        <script>
          angular.module('submitExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.list = [];
              $scope.text = 'hello';
              $scope.submit = function() {
                if ($scope.text) {
                  $scope.list.push(this.text);
                  $scope.text = '';
                }
              };
            }]);
        </script>
        <form ng-submit="submit()" ng-controller="ExampleController">
          Enter text and hit enter:
          <input type="text" ng-model="text" name="text" />
          <input type="submit" id="submit" value="Submit" />
          <pre>list={{list}}</pre>
        </form>
       </file>
       <file name="protractor.js" type="protractor">
         it('should check ng-submit', function() {
           expect(element(by.binding('list')).getText()).toBe('list=[]');
           element(by.css('#submit')).click();
           expect(element(by.binding('list')).getText()).toContain('hello');
           expect(element(by.model('text')).getAttribute('value')).toBe('');
         });
         it('should ignore empty strings', function() {
           expect(element(by.binding('list')).getText()).toBe('list=[]');
           element(by.css('#submit')).click();
           element(by.css('#submit')).click();
           expect(element(by.binding('list')).getText()).toContain('hello');
          });
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngFocus
   * @restrict A
   * @element window, input, select, textarea, a
   * @priority 0
   *
   * @description
   * Specify custom behavior on focus event.
   *
   * Note: As the `focus` event is executed synchronously when calling `input.focus()`
   * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
   * during an `$apply` to ensure a consistent state.
   *
   * @param {expression} ngFocus {@link guide/expression Expression} to evaluate upon
   * focus. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
   * See {@link ng.directive:ngClick ngClick}
   */

  /**
   * @ngdoc directive
   * @name ngBlur
   * @restrict A
   * @element window, input, select, textarea, a
   * @priority 0
   *
   * @description
   * Specify custom behavior on blur event.
   *
   * A [blur event](https://developer.mozilla.org/en-US/docs/Web/Events/blur) fires when
   * an element has lost focus.
   *
   * Note: As the `blur` event is executed synchronously also during DOM manipulations
   * (e.g. removing a focussed input),
   * AngularJS executes the expression using `scope.$evalAsync` if the event is fired
   * during an `$apply` to ensure a consistent state.
   *
   * @param {expression} ngBlur {@link guide/expression Expression} to evaluate upon
   * blur. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
   * See {@link ng.directive:ngClick ngClick}
   */

  /**
   * @ngdoc directive
   * @name ngCopy
   * @restrict A
   * @element window, input, select, textarea, a
   * @priority 0
   *
   * @description
   * Specify custom behavior on copy event.
   *
   * @param {expression} ngCopy {@link guide/expression Expression} to evaluate upon
   * copy. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-copy">
       <file name="index.html">
        <input ng-copy="copied=true" ng-init="copied=false; value='copy me'" ng-model="value">
        copied: {{copied}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngCut
   * @restrict A
   * @element window, input, select, textarea, a
   * @priority 0
   *
   * @description
   * Specify custom behavior on cut event.
   *
   * @param {expression} ngCut {@link guide/expression Expression} to evaluate upon
   * cut. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-cut">
       <file name="index.html">
        <input ng-cut="cut=true" ng-init="cut=false; value='cut me'" ng-model="value">
        cut: {{cut}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngPaste
   * @restrict A
   * @element window, input, select, textarea, a
   * @priority 0
   *
   * @description
   * Specify custom behavior on paste event.
   *
   * @param {expression} ngPaste {@link guide/expression Expression} to evaluate upon
   * paste. ({@link guide/expression#-event- Event object is available as `$event`})
   *
   * @example
     <example name="ng-paste">
       <file name="index.html">
        <input ng-paste="paste=true" ng-init="paste=false" placeholder='paste here'>
        pasted: {{paste}}
       </file>
     </example>
   */

  /**
   * @ngdoc directive
   * @name ngIf
   * @restrict A
   * @multiElement
   *
   * @description
   * The `ngIf` directive removes or recreates a portion of the DOM tree based on an
   * {expression}. If the expression assigned to `ngIf` evaluates to a false
   * value then the element is removed from the DOM, otherwise a clone of the
   * element is reinserted into the DOM.
   *
   * `ngIf` differs from `ngShow` and `ngHide` in that `ngIf` completely removes and recreates the
   * element in the DOM rather than changing its visibility via the `display` css property.  A common
   * case when this difference is significant is when using css selectors that rely on an element's
   * position within the DOM, such as the `:first-child` or `:last-child` pseudo-classes.
   *
   * Note that when an element is removed using `ngIf` its scope is destroyed and a new scope
   * is created when the element is restored.  The scope created within `ngIf` inherits from
   * its parent scope using
   * [prototypal inheritance](https://github.com/angular/angular.js/wiki/Understanding-Scopes#javascript-prototypal-inheritance).
   * An important implication of this is if `ngModel` is used within `ngIf` to bind to
   * a javascript primitive defined in the parent scope. In this case any modifications made to the
   * variable within the child scope will override (hide) the value in the parent scope.
   *
   * Also, `ngIf` recreates elements using their compiled state. An example of this behavior
   * is if an element's class attribute is directly modified after it's compiled, using something like
   * jQuery's `.addClass()` method, and the element is later removed. When `ngIf` recreates the element
   * the added class will be lost because the original compiled state is used to regenerate the element.
   *
   * Additionally, you can provide animations via the `ngAnimate` module to animate the `enter`
   * and `leave` effects.
   *
   * @animations
   * | Animation                        | Occurs                               |
   * |----------------------------------|-------------------------------------|
   * | {@link ng.$animate#enter enter}  | just after the `ngIf` contents change and a new DOM element is created and injected into the `ngIf` container |
   * | {@link ng.$animate#leave leave}  | just before the `ngIf` contents are removed from the DOM |
   *
   * @element ANY
   * @scope
   * @priority 600
   * @param {expression} ngIf If the {@link guide/expression expression} is falsy then
   *     the element is removed from the DOM tree. If it is truthy a copy of the compiled
   *     element is added to the DOM tree.
   *
   * @example
    <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-if">
      <file name="index.html">
        <label>Click me: <input type="checkbox" ng-model="checked" ng-init="checked=true" /></label><br/>
        Show when checked:
        <span ng-if="checked" class="animate-if">
          This is removed when the checkbox is unchecked.
        </span>
      </file>
      <file name="animations.css">
        .animate-if {
          background:white;
          border:1px solid black;
          padding:10px;
        }
  
        .animate-if.ng-enter, .animate-if.ng-leave {
          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
        }
  
        .animate-if.ng-enter,
        .animate-if.ng-leave.ng-leave-active {
          opacity:0;
        }
  
        .animate-if.ng-leave,
        .animate-if.ng-enter.ng-enter-active {
          opacity:1;
        }
      </file>
    </example>
   */
  var ngIfDirective = ['$animate', '$compile', function ($animate, $compile) {
    return {
      multiElement: true,
      transclude: 'element',
      priority: 600,
      terminal: true,
      restrict: 'A',
      $$tlb: true,
      link: function link($scope, $element, $attr, ctrl, $transclude) {
        var block, childScope, previousElements;
        $scope.$watch($attr.ngIf, function ngIfWatchAction(value) {
          if (value) {
            if (!childScope) {
              $transclude(function (clone, newScope) {
                childScope = newScope;
                clone[clone.length++] = $compile.$$createComment('end ngIf', $attr.ngIf);
                // Note: We only need the first/last node of the cloned nodes.
                // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                // by a directive with templateUrl when its template arrives.
                block = {
                  clone: clone
                };
                $animate.enter(clone, $element.parent(), $element);
              });
            }
          } else {
            if (previousElements) {
              previousElements.remove();
              previousElements = null;
            }
            if (childScope) {
              childScope.$destroy();
              childScope = null;
            }
            if (block) {
              previousElements = getBlockNodes(block.clone);
              $animate.leave(previousElements).done(function (response) {
                if (response !== false) previousElements = null;
              });
              block = null;
            }
          }
        });
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngInclude
   * @restrict ECA
   * @scope
   * @priority -400
   *
   * @description
   * Fetches, compiles and includes an external HTML fragment.
   *
   * By default, the template URL is restricted to the same domain and protocol as the
   * application document. This is done by calling {@link $sce#getTrustedResourceUrl
   * $sce.getTrustedResourceUrl} on it. To load templates from other domains or protocols
   * you may either add them to your {@link ng.$sceDelegateProvider#trustedResourceUrlList trusted
   * resource URL list} or {@link $sce#trustAsResourceUrl wrap them} as trusted values. Refer to
   * AngularJS's {@link ng.$sce Strict Contextual Escaping}.
   *
   * In addition, the browser's
   * [Same Origin Policy](https://code.google.com/p/browsersec/wiki/Part2#Same-origin_policy_for_XMLHttpRequest)
   * and [Cross-Origin Resource Sharing (CORS)](http://www.w3.org/TR/cors/)
   * policy may further restrict whether the template is successfully loaded.
   * For example, `ngInclude` won't work for cross-domain requests on all browsers and for `file://`
   * access on some browsers.
   *
   * @animations
   * | Animation                        | Occurs                              |
   * |----------------------------------|-------------------------------------|
   * | {@link ng.$animate#enter enter}  | when the expression changes, on the new include |
   * | {@link ng.$animate#leave leave}  | when the expression changes, on the old include |
   *
   * The enter and leave animation occur concurrently.
   *
   * @param {string} ngInclude|src AngularJS expression evaluating to URL. If the source is a string constant,
   *                 make sure you wrap it in **single** quotes, e.g. `src="'myPartialTemplate.html'"`.
   * @param {string=} onload Expression to evaluate when a new partial is loaded.
   *                  <div class="alert alert-warning">
   *                  **Note:** When using onload on SVG elements in IE11, the browser will try to call
   *                  a function with the name on the window element, which will usually throw a
   *                  "function is undefined" error. To fix this, you can instead use `data-onload` or a
   *                  different form that {@link guide/directive#normalization matches} `onload`.
   *                  </div>
     *
   * @param {string=} autoscroll Whether `ngInclude` should call {@link ng.$anchorScroll
   *                  $anchorScroll} to scroll the viewport after the content is loaded.
   *
   *                  - If the attribute is not set, disable scrolling.
   *                  - If the attribute is set without value, enable scrolling.
   *                  - Otherwise enable scrolling only if the expression evaluates to truthy value.
   *
   * @example
    <example module="includeExample" deps="angular-animate.js" animations="true" name="ng-include">
      <file name="index.html">
       <div ng-controller="ExampleController">
         <select ng-model="template" ng-options="t.name for t in templates">
          <option value="">(blank)</option>
         </select>
         url of the template: <code>{{template.url}}</code>
         <hr/>
         <div class="slide-animate-container">
           <div class="slide-animate" ng-include="template.url"></div>
         </div>
       </div>
      </file>
      <file name="script.js">
        angular.module('includeExample', ['ngAnimate'])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.templates =
              [{ name: 'template1.html', url: 'template1.html'},
               { name: 'template2.html', url: 'template2.html'}];
            $scope.template = $scope.templates[0];
          }]);
       </file>
      <file name="template1.html">
        Content of template1.html
      </file>
      <file name="template2.html">
        Content of template2.html
      </file>
      <file name="animations.css">
        .slide-animate-container {
          position:relative;
          background:white;
          border:1px solid black;
          height:40px;
          overflow:hidden;
        }
  
        .slide-animate {
          padding:10px;
        }
  
        .slide-animate.ng-enter, .slide-animate.ng-leave {
          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
  
          position:absolute;
          top:0;
          left:0;
          right:0;
          bottom:0;
          display:block;
          padding:10px;
        }
  
        .slide-animate.ng-enter {
          top:-50px;
        }
        .slide-animate.ng-enter.ng-enter-active {
          top:0;
        }
  
        .slide-animate.ng-leave {
          top:0;
        }
        .slide-animate.ng-leave.ng-leave-active {
          top:50px;
        }
      </file>
      <file name="protractor.js" type="protractor">
        var templateSelect = element(by.model('template'));
        var includeElem = element(by.css('[ng-include]'));
  
        it('should load template1.html', function() {
          expect(includeElem.getText()).toMatch(/Content of template1.html/);
        });
  
        it('should load template2.html', function() {
          if (browser.params.browser === 'firefox') {
            // Firefox can't handle using selects
            // See https://github.com/angular/protractor/issues/480
            return;
          }
          templateSelect.click();
          templateSelect.all(by.css('option')).get(2).click();
          expect(includeElem.getText()).toMatch(/Content of template2.html/);
        });
  
        it('should change to blank', function() {
          if (browser.params.browser === 'firefox') {
            // Firefox can't handle using selects
            return;
          }
          templateSelect.click();
          templateSelect.all(by.css('option')).get(0).click();
          expect(includeElem.isPresent()).toBe(false);
        });
      </file>
    </example>
   */

  /**
   * @ngdoc event
   * @name ngInclude#$includeContentRequested
   * @eventType emit on the scope ngInclude was declared in
   * @description
   * Emitted every time the ngInclude content is requested.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {String} src URL of content to load.
   */

  /**
   * @ngdoc event
   * @name ngInclude#$includeContentLoaded
   * @eventType emit on the current ngInclude scope
   * @description
   * Emitted every time the ngInclude content is reloaded.
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {String} src URL of content to load.
   */

  /**
   * @ngdoc event
   * @name ngInclude#$includeContentError
   * @eventType emit on the scope ngInclude was declared in
   * @description
   * Emitted when a template HTTP request yields an erroneous response (status < 200 || status > 299)
   *
   * @param {Object} angularEvent Synthetic event object.
   * @param {String} src URL of content to load.
   */
  var ngIncludeDirective = ['$templateRequest', '$anchorScroll', '$animate', function ($templateRequest, $anchorScroll, $animate) {
    return {
      restrict: 'ECA',
      priority: 400,
      terminal: true,
      transclude: 'element',
      controller: angular.noop,
      compile: function compile(element, attr) {
        var srcExp = attr.ngInclude || attr.src,
          onloadExp = attr.onload || '',
          autoScrollExp = attr.autoscroll;
        return function (scope, $element, $attr, ctrl, $transclude) {
          var changeCounter = 0,
            currentScope,
            previousElement,
            currentElement;
          var cleanupLastIncludeContent = function cleanupLastIncludeContent() {
            if (previousElement) {
              previousElement.remove();
              previousElement = null;
            }
            if (currentScope) {
              currentScope.$destroy();
              currentScope = null;
            }
            if (currentElement) {
              $animate.leave(currentElement).done(function (response) {
                if (response !== false) previousElement = null;
              });
              previousElement = currentElement;
              currentElement = null;
            }
          };
          scope.$watch(srcExp, function ngIncludeWatchAction(src) {
            var afterAnimation = function afterAnimation(response) {
              if (response !== false && isDefined(autoScrollExp) && (!autoScrollExp || scope.$eval(autoScrollExp))) {
                $anchorScroll();
              }
            };
            var thisChangeId = ++changeCounter;
            if (src) {
              //set the 2nd param to true to ignore the template request error so that the inner
              //contents and scope can be cleaned up.
              $templateRequest(src, true).then(function (response) {
                if (scope.$$destroyed) return;
                if (thisChangeId !== changeCounter) return;
                var newScope = scope.$new();
                ctrl.template = response;

                // Note: This will also link all children of ng-include that were contained in the original
                // html. If that content contains controllers, ... they could pollute/change the scope.
                // However, using ng-include on an element with additional content does not make sense...
                // Note: We can't remove them in the cloneAttchFn of $transclude as that
                // function is called before linking the content, which would apply child
                // directives to non existing elements.
                var clone = $transclude(newScope, function (clone) {
                  cleanupLastIncludeContent();
                  $animate.enter(clone, null, $element).done(afterAnimation);
                });
                currentScope = newScope;
                currentElement = clone;
                currentScope.$emit('$includeContentLoaded', src);
                scope.$eval(onloadExp);
              }, function () {
                if (scope.$$destroyed) return;
                if (thisChangeId === changeCounter) {
                  cleanupLastIncludeContent();
                  scope.$emit('$includeContentError', src);
                }
              });
              scope.$emit('$includeContentRequested', src);
            } else {
              cleanupLastIncludeContent();
              ctrl.template = null;
            }
          });
        };
      }
    };
  }];

  // This directive is called during the $transclude call of the first `ngInclude` directive.
  // It will replace and compile the content of the element with the loaded template.
  // We need this directive so that the element content is already filled when
  // the link function of another directive on the same element as ngInclude
  // is called.
  var ngIncludeFillContentDirective = ['$compile', function ($compile) {
    return {
      restrict: 'ECA',
      priority: -400,
      require: 'ngInclude',
      link: function link(scope, $element, $attr, ctrl) {
        if (toString.call($element[0]).match(/SVG/)) {
          // WebKit: https://bugs.webkit.org/show_bug.cgi?id=135698 --- SVG elements do not
          // support innerHTML, so detect this here and try to generate the contents
          // specially.
          $element.empty();
          $compile(jqLiteBuildFragment(ctrl.template, window.document).childNodes)(scope, function namespaceAdaptedClone(clone) {
            $element.append(clone);
          }, {
            futureParentElement: $element
          });
          return;
        }
        $element.html(ctrl.template);
        $compile($element.contents())(scope);
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngInit
   * @restrict AC
   * @priority 450
   * @element ANY
   *
   * @param {expression} ngInit {@link guide/expression Expression} to eval.
   *
   * @description
   * The `ngInit` directive allows you to evaluate an expression in the
   * current scope.
   *
   * <div class="alert alert-danger">
   * This directive can be abused to add unnecessary amounts of logic into your templates.
   * There are only a few appropriate uses of `ngInit`:
   * <ul>
   *   <li>aliasing special properties of {@link ng.directive:ngRepeat `ngRepeat`},
   *     as seen in the demo below.</li>
   *   <li>initializing data during development, or for examples, as seen throughout these docs.</li>
   *   <li>injecting data via server side scripting.</li>
   * </ul>
   *
   * Besides these few cases, you should use {@link guide/component Components} or
   * {@link guide/controller Controllers} rather than `ngInit` to initialize values on a scope.
   * </div>
   *
   * <div class="alert alert-warning">
   * **Note**: If you have assignment in `ngInit` along with a {@link ng.$filter `filter`}, make
   * sure you have parentheses to ensure correct operator precedence:
   * <pre class="prettyprint">
   * `<div ng-init="test1 = ($index | toString)"></div>`
   * </pre>
   * </div>
   *
   * @example
     <example module="initExample" name="ng-init">
       <file name="index.html">
     <script>
       angular.module('initExample', [])
         .controller('ExampleController', ['$scope', function($scope) {
           $scope.list = [['a', 'b'], ['c', 'd']];
         }]);
     </script>
     <div ng-controller="ExampleController">
       <div ng-repeat="innerList in list" ng-init="outerIndex = $index">
         <div ng-repeat="value in innerList" ng-init="innerIndex = $index">
            <span class="example-init">list[ {{outerIndex}} ][ {{innerIndex}} ] = {{value}};</span>
         </div>
       </div>
     </div>
       </file>
       <file name="protractor.js" type="protractor">
         it('should alias index positions', function() {
           var elements = element.all(by.css('.example-init'));
           expect(elements.get(0).getText()).toBe('list[ 0 ][ 0 ] = a;');
           expect(elements.get(1).getText()).toBe('list[ 0 ][ 1 ] = b;');
           expect(elements.get(2).getText()).toBe('list[ 1 ][ 0 ] = c;');
           expect(elements.get(3).getText()).toBe('list[ 1 ][ 1 ] = d;');
         });
       </file>
     </example>
   */
  var ngInitDirective = ngDirective({
    priority: 450,
    compile: function compile() {
      return {
        pre: function pre(scope, element, attrs) {
          scope.$eval(attrs.ngInit);
        }
      };
    }
  });

  /**
   * @ngdoc directive
   * @name ngList
   * @restrict A
   * @priority 100
   *
   * @param {string=} ngList optional delimiter that should be used to split the value.
   *
   * @description
   * Text input that converts between a delimited string and an array of strings. The default
   * delimiter is a comma followed by a space - equivalent to `ng-list=", "`. You can specify a custom
   * delimiter as the value of the `ngList` attribute - for example, `ng-list=" | "`.
   *
   * The behaviour of the directive is affected by the use of the `ngTrim` attribute.
   * * If `ngTrim` is set to `"false"` then whitespace around both the separator and each
   *   list item is respected. This implies that the user of the directive is responsible for
   *   dealing with whitespace but also allows you to use whitespace as a delimiter, such as a
   *   tab or newline character.
   * * Otherwise whitespace around the delimiter is ignored when splitting (although it is respected
   *   when joining the list items back together) and whitespace around each list item is stripped
   *   before it is added to the model.
   *
   * @example
   * ### Validation
   *
   * <example name="ngList-directive" module="listExample">
   *   <file name="app.js">
   *      angular.module('listExample', [])
   *        .controller('ExampleController', ['$scope', function($scope) {
   *          $scope.names = ['morpheus', 'neo', 'trinity'];
   *        }]);
   *   </file>
   *   <file name="index.html">
   *    <form name="myForm" ng-controller="ExampleController">
   *      <label>List: <input name="namesInput" ng-model="names" ng-list required></label>
   *      <span role="alert">
   *        <span class="error" ng-show="myForm.namesInput.$error.required">
   *        Required!</span>
   *      </span>
   *      <br>
   *      <tt>names = {{names}}</tt><br/>
   *      <tt>myForm.namesInput.$valid = {{myForm.namesInput.$valid}}</tt><br/>
   *      <tt>myForm.namesInput.$error = {{myForm.namesInput.$error}}</tt><br/>
   *      <tt>myForm.$valid = {{myForm.$valid}}</tt><br/>
   *      <tt>myForm.$error.required = {{!!myForm.$error.required}}</tt><br/>
   *     </form>
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *     var listInput = element(by.model('names'));
   *     var names = element(by.exactBinding('names'));
   *     var valid = element(by.binding('myForm.namesInput.$valid'));
   *     var error = element(by.css('span.error'));
   *
   *     it('should initialize to model', function() {
   *       expect(names.getText()).toContain('["morpheus","neo","trinity"]');
   *       expect(valid.getText()).toContain('true');
   *       expect(error.getCssValue('display')).toBe('none');
   *     });
   *
   *     it('should be invalid if empty', function() {
   *       listInput.clear();
   *       listInput.sendKeys('');
   *
   *       expect(names.getText()).toContain('');
   *       expect(valid.getText()).toContain('false');
   *       expect(error.getCssValue('display')).not.toBe('none');
   *     });
   *   </file>
   * </example>
   *
   * @example
   * ### Splitting on newline
   *
   * <example name="ngList-directive-newlines">
   *   <file name="index.html">
   *    <textarea ng-model="list" ng-list="&#10;" ng-trim="false"></textarea>
   *    <pre>{{ list | json }}</pre>
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *     it("should split the text by newlines", function() {
   *       var listInput = element(by.model('list'));
   *       var output = element(by.binding('list | json'));
   *       listInput.sendKeys('abc\ndef\nghi');
   *       expect(output.getText()).toContain('[\n  "abc",\n  "def",\n  "ghi"\n]');
   *     });
   *   </file>
   * </example>
   *
   */
  var ngListDirective = function ngListDirective() {
    return {
      restrict: 'A',
      priority: 100,
      require: 'ngModel',
      link: function link(scope, element, attr, ctrl) {
        var ngList = attr.ngList || ', ';
        var trimValues = attr.ngTrim !== 'false';
        var separator = trimValues ? trim(ngList) : ngList;
        var parse = function parse(viewValue) {
          // If the viewValue is invalid (say required but empty) it will be `undefined`
          if (isUndefined(viewValue)) return;
          var list = [];
          if (viewValue) {
            forEach(viewValue.split(separator), function (value) {
              if (value) list.push(trimValues ? trim(value) : value);
            });
          }
          return list;
        };
        ctrl.$parsers.push(parse);
        ctrl.$formatters.push(function (value) {
          if (isArray(value)) {
            return value.join(ngList);
          }
          return undefined;
        });

        // Override the standard $isEmpty because an empty array means the input is empty.
        ctrl.$isEmpty = function (value) {
          return !value || !value.length;
        };
      }
    };
  };

  /* global VALID_CLASS: true,
    INVALID_CLASS: true,
    PRISTINE_CLASS: true,
    DIRTY_CLASS: true,
    UNTOUCHED_CLASS: true,
    TOUCHED_CLASS: true,
    PENDING_CLASS: true,
    addSetValidityMethod: true,
    setupValidity: true,
    defaultModelOptions: false
  */

  var VALID_CLASS = 'ng-valid',
    INVALID_CLASS = 'ng-invalid',
    PRISTINE_CLASS = 'ng-pristine',
    DIRTY_CLASS = 'ng-dirty',
    UNTOUCHED_CLASS = 'ng-untouched',
    TOUCHED_CLASS = 'ng-touched',
    EMPTY_CLASS = 'ng-empty',
    NOT_EMPTY_CLASS = 'ng-not-empty';
  var ngModelMinErr = minErr('ngModel');

  /**
   * @ngdoc type
   * @name ngModel.NgModelController
   * @property {*} $viewValue The actual value from the control's view. For `input` elements, this is a
   * String. See {@link ngModel.NgModelController#$setViewValue} for information about when the $viewValue
   * is set.
   *
   * @property {*} $modelValue The value in the model that the control is bound to.
   *
   * @property {Array.<Function>} $parsers Array of functions to execute, as a pipeline, whenever
   *  the control updates the ngModelController with a new {@link ngModel.NgModelController#$viewValue
      `$viewValue`} from the DOM, usually via user input.
      See {@link ngModel.NgModelController#$setViewValue `$setViewValue()`} for a detailed lifecycle explanation.
      Note that the `$parsers` are not called when the bound ngModel expression changes programmatically.
  
    The functions are called in array order, each passing
      its return value through to the next. The last return value is forwarded to the
      {@link ngModel.NgModelController#$validators `$validators`} collection.
  
    Parsers are used to sanitize / convert the {@link ngModel.NgModelController#$viewValue
      `$viewValue`}.
  
    Returning `undefined` from a parser means a parse error occurred. In that case,
      no {@link ngModel.NgModelController#$validators `$validators`} will run and the `ngModel`
      will be set to `undefined` unless {@link ngModelOptions `ngModelOptions.allowInvalid`}
      is set to `true`. The parse error is stored in `ngModel.$error.parse`.
  
    This simple example shows a parser that would convert text input value to lowercase:
   * ```js
   * function parse(value) {
   *   if (value) {
   *     return value.toLowerCase();
   *   }
   * }
   * ngModelController.$parsers.push(parse);
   * ```
  
   *
   * @property {Array.<Function>} $formatters Array of functions to execute, as a pipeline, whenever
      the bound ngModel expression changes programmatically. The `$formatters` are not called when the
      value of the control is changed by user interaction.
  
    Formatters are used to format / convert the {@link ngModel.NgModelController#$modelValue
      `$modelValue`} for display in the control.
  
    The functions are called in reverse array order, each passing the value through to the
      next. The last return value is used as the actual DOM value.
  
    This simple example shows a formatter that would convert the model value to uppercase:
  
   * ```js
   * function format(value) {
   *   if (value) {
   *     return value.toUpperCase();
   *   }
   * }
   * ngModel.$formatters.push(format);
   * ```
   *
   * @property {Object.<string, function>} $validators A collection of validators that are applied
   *      whenever the model value changes. The key value within the object refers to the name of the
   *      validator while the function refers to the validation operation. The validation operation is
   *      provided with the model value as an argument and must return a true or false value depending
   *      on the response of that validation.
   *
   * ```js
   * ngModel.$validators.validCharacters = function(modelValue, viewValue) {
   *   var value = modelValue || viewValue;
   *   return /[0-9]+/.test(value) &&
   *          /[a-z]+/.test(value) &&
   *          /[A-Z]+/.test(value) &&
   *          /\W+/.test(value);
   * };
   * ```
   *
   * @property {Object.<string, function>} $asyncValidators A collection of validations that are expected to
   *      perform an asynchronous validation (e.g. a HTTP request). The validation function that is provided
   *      is expected to return a promise when it is run during the model validation process. Once the promise
   *      is delivered then the validation status will be set to true when fulfilled and false when rejected.
   *      When the asynchronous validators are triggered, each of the validators will run in parallel and the model
   *      value will only be updated once all validators have been fulfilled. As long as an asynchronous validator
   *      is unfulfilled, its key will be added to the controllers `$pending` property. Also, all asynchronous validators
   *      will only run once all synchronous validators have passed.
   *
   * Please note that if $http is used then it is important that the server returns a success HTTP response code
   * in order to fulfill the validation and a status level of `4xx` in order to reject the validation.
   *
   * ```js
   * ngModel.$asyncValidators.uniqueUsername = function(modelValue, viewValue) {
   *   var value = modelValue || viewValue;
   *
   *   // Lookup user by username
   *   return $http.get('/api/users/' + value).
   *      then(function resolved() {
   *        //username exists, this means validation fails
   *        return $q.reject('exists');
   *      }, function rejected() {
   *        //username does not exist, therefore this validation passes
   *        return true;
   *      });
   * };
   * ```
   *
   * @property {Array.<Function>} $viewChangeListeners Array of functions to execute whenever
   *     a change to {@link ngModel.NgModelController#$viewValue `$viewValue`} has caused a change
   *     to {@link ngModel.NgModelController#$modelValue `$modelValue`}.
   *     It is called with no arguments, and its return value is ignored.
   *     This can be used in place of additional $watches against the model value.
   *
   * @property {Object} $error An object hash with all failing validator ids as keys.
   * @property {Object} $pending An object hash with all pending validator ids as keys.
   *
   * @property {boolean} $untouched True if control has not lost focus yet.
   * @property {boolean} $touched True if control has lost focus.
   * @property {boolean} $pristine True if user has not interacted with the control yet.
   * @property {boolean} $dirty True if user has already interacted with the control.
   * @property {boolean} $valid True if there is no error.
   * @property {boolean} $invalid True if at least one error on the control.
   * @property {string} $name The name attribute of the control.
   *
   * @description
   *
   * `NgModelController` provides API for the {@link ngModel `ngModel`} directive.
   * The controller contains services for data-binding, validation, CSS updates, and value formatting
   * and parsing. It purposefully does not contain any logic which deals with DOM rendering or
   * listening to DOM events.
   * Such DOM related logic should be provided by other directives which make use of
   * `NgModelController` for data-binding to control elements.
   * AngularJS provides this DOM logic for most {@link input `input`} elements.
   * At the end of this page you can find a {@link ngModel.NgModelController#custom-control-example
   * custom control example} that uses `ngModelController` to bind to `contenteditable` elements.
   *
   * @example
   * ### Custom Control Example
   * This example shows how to use `NgModelController` with a custom control to achieve
   * data-binding. Notice how different directives (`contenteditable`, `ng-model`, and `required`)
   * collaborate together to achieve the desired result.
   *
   * `contenteditable` is an HTML5 attribute, which tells the browser to let the element
   * contents be edited in place by the user.
   *
   * We are using the {@link ng.service:$sce $sce} service here and include the {@link ngSanitize $sanitize}
   * module to automatically remove "bad" content like inline event listener (e.g. `<span onclick="...">`).
   * However, as we are using `$sce` the model can still decide to provide unsafe content if it marks
   * that content using the `$sce` service.
   *
   * <example name="NgModelController" module="customControl" deps="angular-sanitize.js">
      <file name="style.css">
        [contenteditable] {
          border: 1px solid black;
          background-color: white;
          min-height: 20px;
        }
  
        .ng-invalid {
          border: 1px solid red;
        }
  
      </file>
      <file name="script.js">
        angular.module('customControl', ['ngSanitize']).
          directive('contenteditable', ['$sce', function($sce) {
            return {
              restrict: 'A', // only activate on element attribute
              require: '?ngModel', // get a hold of NgModelController
              link: function(scope, element, attrs, ngModel) {
                if (!ngModel) return; // do nothing if no ng-model
  
                // Specify how UI should be updated
                ngModel.$render = function() {
                  element.html($sce.getTrustedHtml(ngModel.$viewValue || ''));
                };
  
                // Listen for change events to enable binding
                element.on('blur keyup change', function() {
                  scope.$evalAsync(read);
                });
                read(); // initialize
  
                // Write data to the model
                function read() {
                  var html = element.html();
                  // When we clear the content editable the browser leaves a <br> behind
                  // If strip-br attribute is provided then we strip this out
                  if (attrs.stripBr && html === '<br>') {
                    html = '';
                  }
                  ngModel.$setViewValue(html);
                }
              }
            };
          }]);
      </file>
      <file name="index.html">
        <form name="myForm">
         <div contenteditable
              name="myWidget" ng-model="userContent"
              strip-br="true"
              required>Change me!</div>
          <span ng-show="myForm.myWidget.$error.required">Required!</span>
         <hr>
         <textarea ng-model="userContent" aria-label="Dynamic textarea"></textarea>
        </form>
      </file>
      <file name="protractor.js" type="protractor">
      it('should data-bind and become invalid', function() {
        if (browser.params.browser === 'safari' || browser.params.browser === 'firefox') {
          // SafariDriver can't handle contenteditable
          // and Firefox driver can't clear contenteditables very well
          return;
        }
        var contentEditable = element(by.css('[contenteditable]'));
        var content = 'Change me!';
  
        expect(contentEditable.getText()).toEqual(content);
  
        contentEditable.clear();
        contentEditable.sendKeys(protractor.Key.BACK_SPACE);
        expect(contentEditable.getText()).toEqual('');
        expect(contentEditable.getAttribute('class')).toMatch(/ng-invalid-required/);
      });
      </file>
   * </example>
   *
   *
   */
  NgModelController.$inject = ['$scope', '$exceptionHandler', '$attrs', '$element', '$parse', '$animate', '$timeout', '$q', '$interpolate'];
  function NgModelController($scope, $exceptionHandler, $attr, $element, $parse, $animate, $timeout, $q, $interpolate) {
    this.$viewValue = Number.NaN;
    this.$modelValue = Number.NaN;
    this.$$rawModelValue = undefined; // stores the parsed modelValue / model set from scope regardless of validity.
    this.$validators = {};
    this.$asyncValidators = {};
    this.$parsers = [];
    this.$formatters = [];
    this.$viewChangeListeners = [];
    this.$untouched = true;
    this.$touched = false;
    this.$pristine = true;
    this.$dirty = false;
    this.$valid = true;
    this.$invalid = false;
    this.$error = {}; // keep invalid keys here
    this.$$success = {}; // keep valid keys here
    this.$pending = undefined; // keep pending keys here
    this.$name = $interpolate($attr.name || '', false)($scope);
    this.$$parentForm = nullFormCtrl;
    this.$options = defaultModelOptions;
    this.$$updateEvents = '';
    // Attach the correct context to the event handler function for updateOn
    this.$$updateEventHandler = this.$$updateEventHandler.bind(this);
    this.$$parsedNgModel = $parse($attr.ngModel);
    this.$$parsedNgModelAssign = this.$$parsedNgModel.assign;
    this.$$ngModelGet = this.$$parsedNgModel;
    this.$$ngModelSet = this.$$parsedNgModelAssign;
    this.$$pendingDebounce = null;
    this.$$parserValid = undefined;
    this.$$parserName = 'parse';
    this.$$currentValidationRunId = 0;
    this.$$scope = $scope;
    this.$$rootScope = $scope.$root;
    this.$$attr = $attr;
    this.$$element = $element;
    this.$$animate = $animate;
    this.$$timeout = $timeout;
    this.$$parse = $parse;
    this.$$q = $q;
    this.$$exceptionHandler = $exceptionHandler;
    setupValidity(this);
    setupModelWatcher(this);
  }
  NgModelController.prototype = {
    $$initGetterSetters: function $$initGetterSetters() {
      if (this.$options.getOption('getterSetter')) {
        var invokeModelGetter = this.$$parse(this.$$attr.ngModel + '()'),
          invokeModelSetter = this.$$parse(this.$$attr.ngModel + '($$$p)');
        this.$$ngModelGet = function ($scope) {
          var modelValue = this.$$parsedNgModel($scope);
          if (isFunction(modelValue)) {
            modelValue = invokeModelGetter($scope);
          }
          return modelValue;
        };
        this.$$ngModelSet = function ($scope, newValue) {
          if (isFunction(this.$$parsedNgModel($scope))) {
            invokeModelSetter($scope, {
              $$$p: newValue
            });
          } else {
            this.$$parsedNgModelAssign($scope, newValue);
          }
        };
      } else if (!this.$$parsedNgModel.assign) {
        throw ngModelMinErr('nonassign', 'Expression \'{0}\' is non-assignable. Element: {1}', this.$$attr.ngModel, startingTag(this.$$element));
      }
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$render
     *
     * @description
     * Called when the view needs to be updated. It is expected that the user of the ng-model
     * directive will implement this method.
     *
     * The `$render()` method is invoked in the following situations:
     *
     * * `$rollbackViewValue()` is called.  If we are rolling back the view value to the last
     *   committed value then `$render()` is called to update the input control.
     * * The value referenced by `ng-model` is changed programmatically and both the `$modelValue` and
     *   the `$viewValue` are different from last time.
     *
     * Since `ng-model` does not do a deep watch, `$render()` is only invoked if the values of
     * `$modelValue` and `$viewValue` are actually different from their previous values. If `$modelValue`
     * or `$viewValue` are objects (rather than a string or number) then `$render()` will not be
     * invoked if you only change a property on the objects.
     */
    $render: noop,
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$isEmpty
     *
     * @description
     * This is called when we need to determine if the value of an input is empty.
     *
     * For instance, the required directive does this to work out if the input has data or not.
     *
     * The default `$isEmpty` function checks whether the value is `undefined`, `''`, `null` or `NaN`.
     *
     * You can override this for input directives whose concept of being empty is different from the
     * default. The `checkboxInputType` directive does this because in its case a value of `false`
     * implies empty.
     *
     * @param {*} value The value of the input to check for emptiness.
     * @returns {boolean} True if `value` is "empty".
     */
    $isEmpty: function $isEmpty(value) {
      // eslint-disable-next-line no-self-compare
      return isUndefined(value) || value === '' || value === null || value !== value;
    },
    $$updateEmptyClasses: function $$updateEmptyClasses(value) {
      if (this.$isEmpty(value)) {
        this.$$animate.removeClass(this.$$element, NOT_EMPTY_CLASS);
        this.$$animate.addClass(this.$$element, EMPTY_CLASS);
      } else {
        this.$$animate.removeClass(this.$$element, EMPTY_CLASS);
        this.$$animate.addClass(this.$$element, NOT_EMPTY_CLASS);
      }
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setPristine
     *
     * @description
     * Sets the control to its pristine state.
     *
     * This method can be called to remove the `ng-dirty` class and set the control to its pristine
     * state (`ng-pristine` class). A model is considered to be pristine when the control
     * has not been changed from when first compiled.
     */
    $setPristine: function $setPristine() {
      this.$dirty = false;
      this.$pristine = true;
      this.$$animate.removeClass(this.$$element, DIRTY_CLASS);
      this.$$animate.addClass(this.$$element, PRISTINE_CLASS);
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setDirty
     *
     * @description
     * Sets the control to its dirty state.
     *
     * This method can be called to remove the `ng-pristine` class and set the control to its dirty
     * state (`ng-dirty` class). A model is considered to be dirty when the control has been changed
     * from when first compiled.
     */
    $setDirty: function $setDirty() {
      this.$dirty = true;
      this.$pristine = false;
      this.$$animate.removeClass(this.$$element, PRISTINE_CLASS);
      this.$$animate.addClass(this.$$element, DIRTY_CLASS);
      this.$$parentForm.$setDirty();
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setUntouched
     *
     * @description
     * Sets the control to its untouched state.
     *
     * This method can be called to remove the `ng-touched` class and set the control to its
     * untouched state (`ng-untouched` class). Upon compilation, a model is set as untouched
     * by default, however this function can be used to restore that state if the model has
     * already been touched by the user.
     */
    $setUntouched: function $setUntouched() {
      this.$touched = false;
      this.$untouched = true;
      this.$$animate.setClass(this.$$element, UNTOUCHED_CLASS, TOUCHED_CLASS);
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setTouched
     *
     * @description
     * Sets the control to its touched state.
     *
     * This method can be called to remove the `ng-untouched` class and set the control to its
     * touched state (`ng-touched` class). A model is considered to be touched when the user has
     * first focused the control element and then shifted focus away from the control (blur event).
     */
    $setTouched: function $setTouched() {
      this.$touched = true;
      this.$untouched = false;
      this.$$animate.setClass(this.$$element, TOUCHED_CLASS, UNTOUCHED_CLASS);
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$rollbackViewValue
     *
     * @description
     * Cancel an update and reset the input element's value to prevent an update to the `$modelValue`,
     * which may be caused by a pending debounced event or because the input is waiting for some
     * future event.
     *
     * If you have an input that uses `ng-model-options` to set up debounced updates or updates that
     * depend on special events such as `blur`, there can be a period when the `$viewValue` is out of
     * sync with the ngModel's `$modelValue`.
     *
     * In this case, you can use `$rollbackViewValue()` to manually cancel the debounced / future update
     * and reset the input to the last committed view value.
     *
     * It is also possible that you run into difficulties if you try to update the ngModel's `$modelValue`
     * programmatically before these debounced/future events have resolved/occurred, because AngularJS's
     * dirty checking mechanism is not able to tell whether the model has actually changed or not.
     *
     * The `$rollbackViewValue()` method should be called before programmatically changing the model of an
     * input which may have such events pending. This is important in order to make sure that the
     * input field will be updated with the new model value and any pending operations are cancelled.
     *
     * @example
     * <example name="ng-model-cancel-update" module="cancel-update-example">
     *   <file name="app.js">
     *     angular.module('cancel-update-example', [])
     *
     *     .controller('CancelUpdateController', ['$scope', function($scope) {
     *       $scope.model = {value1: '', value2: ''};
     *
     *       $scope.setEmpty = function(e, value, rollback) {
     *         if (e.keyCode === 27) {
     *           e.preventDefault();
     *           if (rollback) {
     *             $scope.myForm[value].$rollbackViewValue();
     *           }
     *           $scope.model[value] = '';
     *         }
     *       };
     *     }]);
     *   </file>
     *   <file name="index.html">
     *     <div ng-controller="CancelUpdateController">
     *       <p>Both of these inputs are only updated if they are blurred. Hitting escape should
     *       empty them. Follow these steps and observe the difference:</p>
     *       <ol>
     *         <li>Type something in the input. You will see that the model is not yet updated</li>
     *         <li>Press the Escape key.
     *           <ol>
     *             <li> In the first example, nothing happens, because the model is already '', and no
     *             update is detected. If you blur the input, the model will be set to the current view.
     *             </li>
     *             <li> In the second example, the pending update is cancelled, and the input is set back
     *             to the last committed view value (''). Blurring the input does nothing.
     *             </li>
     *           </ol>
     *         </li>
     *       </ol>
     *
     *       <form name="myForm" ng-model-options="{ updateOn: 'blur' }">
     *         <div>
     *           <p id="inputDescription1">Without $rollbackViewValue():</p>
     *           <input name="value1" aria-describedby="inputDescription1" ng-model="model.value1"
     *                  ng-keydown="setEmpty($event, 'value1')">
     *           value1: "{{ model.value1 }}"
     *         </div>
     *
     *         <div>
     *           <p id="inputDescription2">With $rollbackViewValue():</p>
     *           <input name="value2" aria-describedby="inputDescription2" ng-model="model.value2"
     *                  ng-keydown="setEmpty($event, 'value2', true)">
     *           value2: "{{ model.value2 }}"
     *         </div>
     *       </form>
     *     </div>
     *   </file>
         <file name="style.css">
            div {
              display: table-cell;
            }
            div:nth-child(1) {
              padding-right: 30px;
            }
           </file>
     * </example>
     */
    $rollbackViewValue: function $rollbackViewValue() {
      this.$$timeout.cancel(this.$$pendingDebounce);
      this.$viewValue = this.$$lastCommittedViewValue;
      this.$render();
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$validate
     *
     * @description
     * Runs each of the registered validators (first synchronous validators and then
     * asynchronous validators).
     * If the validity changes to invalid, the model will be set to `undefined`,
     * unless {@link ngModelOptions `ngModelOptions.allowInvalid`} is `true`.
     * If the validity changes to valid, it will set the model to the last available valid
     * `$modelValue`, i.e. either the last parsed value or the last value set from the scope.
     */
    $validate: function $validate() {
      // ignore $validate before model is initialized
      if (isNumberNaN(this.$modelValue)) {
        return;
      }
      var viewValue = this.$$lastCommittedViewValue;
      // Note: we use the $$rawModelValue as $modelValue might have been
      // set to undefined during a view -> model update that found validation
      // errors. We can't parse the view here, since that could change
      // the model although neither viewValue nor the model on the scope changed
      var modelValue = this.$$rawModelValue;
      var prevValid = this.$valid;
      var prevModelValue = this.$modelValue;
      var allowInvalid = this.$options.getOption('allowInvalid');
      var that = this;
      this.$$runValidators(modelValue, viewValue, function (allValid) {
        // If there was no change in validity, don't update the model
        // This prevents changing an invalid modelValue to undefined
        if (!allowInvalid && prevValid !== allValid) {
          // Note: Don't check this.$valid here, as we could have
          // external validators (e.g. calculated on the server),
          // that just call $setValidity and need the model value
          // to calculate their validity.
          that.$modelValue = allValid ? modelValue : undefined;
          if (that.$modelValue !== prevModelValue) {
            that.$$writeModelToScope();
          }
        }
      });
    },
    $$runValidators: function $$runValidators(modelValue, viewValue, doneCallback) {
      this.$$currentValidationRunId++;
      var localValidationRunId = this.$$currentValidationRunId;
      var that = this;

      // check parser error
      if (!processParseErrors()) {
        validationDone(false);
        return;
      }
      if (!processSyncValidators()) {
        validationDone(false);
        return;
      }
      processAsyncValidators();
      function processParseErrors() {
        var errorKey = that.$$parserName;
        if (isUndefined(that.$$parserValid)) {
          setValidity(errorKey, null);
        } else {
          if (!that.$$parserValid) {
            forEach(that.$validators, function (v, name) {
              setValidity(name, null);
            });
            forEach(that.$asyncValidators, function (v, name) {
              setValidity(name, null);
            });
          }

          // Set the parse error last, to prevent unsetting it, should a $validators key == parserName
          setValidity(errorKey, that.$$parserValid);
          return that.$$parserValid;
        }
        return true;
      }
      function processSyncValidators() {
        var syncValidatorsValid = true;
        forEach(that.$validators, function (validator, name) {
          var result = Boolean(validator(modelValue, viewValue));
          syncValidatorsValid = syncValidatorsValid && result;
          setValidity(name, result);
        });
        if (!syncValidatorsValid) {
          forEach(that.$asyncValidators, function (v, name) {
            setValidity(name, null);
          });
          return false;
        }
        return true;
      }
      function processAsyncValidators() {
        var validatorPromises = [];
        var allValid = true;
        forEach(that.$asyncValidators, function (validator, name) {
          var promise = validator(modelValue, viewValue);
          if (!isPromiseLike(promise)) {
            throw ngModelMinErr('nopromise', 'Expected asynchronous validator to return a promise but got \'{0}\' instead.', promise);
          }
          setValidity(name, undefined);
          validatorPromises.push(promise.then(function () {
            setValidity(name, true);
          }, function () {
            allValid = false;
            setValidity(name, false);
          }));
        });
        if (!validatorPromises.length) {
          validationDone(true);
        } else {
          that.$$q.all(validatorPromises).then(function () {
            validationDone(allValid);
          }, noop);
        }
      }
      function setValidity(name, isValid) {
        if (localValidationRunId === that.$$currentValidationRunId) {
          that.$setValidity(name, isValid);
        }
      }
      function validationDone(allValid) {
        if (localValidationRunId === that.$$currentValidationRunId) {
          doneCallback(allValid);
        }
      }
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$commitViewValue
     *
     * @description
     * Commit a pending update to the `$modelValue`.
     *
     * Updates may be pending by a debounced event or because the input is waiting for a some future
     * event defined in `ng-model-options`. this method is rarely needed as `NgModelController`
     * usually handles calling this in response to input events.
     */
    $commitViewValue: function $commitViewValue() {
      var viewValue = this.$viewValue;
      this.$$timeout.cancel(this.$$pendingDebounce);

      // If the view value has not changed then we should just exit, except in the case where there is
      // a native validator on the element. In this case the validation state may have changed even though
      // the viewValue has stayed empty.
      if (this.$$lastCommittedViewValue === viewValue && (viewValue !== '' || !this.$$hasNativeValidators)) {
        return;
      }
      this.$$updateEmptyClasses(viewValue);
      this.$$lastCommittedViewValue = viewValue;

      // change to dirty
      if (this.$pristine) {
        this.$setDirty();
      }
      this.$$parseAndValidate();
    },
    $$parseAndValidate: function $$parseAndValidate() {
      var viewValue = this.$$lastCommittedViewValue;
      var modelValue = viewValue;
      var that = this;
      this.$$parserValid = isUndefined(modelValue) ? undefined : true;

      // Reset any previous parse error
      this.$setValidity(this.$$parserName, null);
      this.$$parserName = 'parse';
      if (this.$$parserValid) {
        for (var i = 0; i < this.$parsers.length; i++) {
          modelValue = this.$parsers[i](modelValue);
          if (isUndefined(modelValue)) {
            this.$$parserValid = false;
            break;
          }
        }
      }
      if (isNumberNaN(this.$modelValue)) {
        // this.$modelValue has not been touched yet...
        this.$modelValue = this.$$ngModelGet(this.$$scope);
      }
      var prevModelValue = this.$modelValue;
      var allowInvalid = this.$options.getOption('allowInvalid');
      this.$$rawModelValue = modelValue;
      if (allowInvalid) {
        this.$modelValue = modelValue;
        writeToModelIfNeeded();
      }

      // Pass the $$lastCommittedViewValue here, because the cached viewValue might be out of date.
      // This can happen if e.g. $setViewValue is called from inside a parser
      this.$$runValidators(modelValue, this.$$lastCommittedViewValue, function (allValid) {
        if (!allowInvalid) {
          // Note: Don't check this.$valid here, as we could have
          // external validators (e.g. calculated on the server),
          // that just call $setValidity and need the model value
          // to calculate their validity.
          that.$modelValue = allValid ? modelValue : undefined;
          writeToModelIfNeeded();
        }
      });
      function writeToModelIfNeeded() {
        if (that.$modelValue !== prevModelValue) {
          that.$$writeModelToScope();
        }
      }
    },
    $$writeModelToScope: function $$writeModelToScope() {
      this.$$ngModelSet(this.$$scope, this.$modelValue);
      forEach(this.$viewChangeListeners, function (listener) {
        try {
          listener();
        } catch (e) {
          // eslint-disable-next-line no-invalid-this
          this.$$exceptionHandler(e);
        }
      }, this);
    },
    /**
     * @ngdoc method
     * @name ngModel.NgModelController#$setViewValue
     *
     * @description
     * Update the view value.
     *
     * This method should be called when a control wants to change the view value; typically,
     * this is done from within a DOM event handler. For example, the {@link ng.directive:input input}
     * directive calls it when the value of the input changes and {@link ng.directive:select select}
     * calls it when an option is selected.
     *
     * When `$setViewValue` is called, the new `value` will be staged for committing through the `$parsers`
     * and `$validators` pipelines. If there are no special {@link ngModelOptions} specified then the staged
     * value is sent directly for processing through the `$parsers` pipeline. After this, the `$validators` and
     * `$asyncValidators` are called and the value is applied to `$modelValue`.
     * Finally, the value is set to the **expression** specified in the `ng-model` attribute and
     * all the registered change listeners, in the `$viewChangeListeners` list are called.
     *
     * In case the {@link ng.directive:ngModelOptions ngModelOptions} directive is used with `updateOn`
     * and the `default` trigger is not listed, all those actions will remain pending until one of the
     * `updateOn` events is triggered on the DOM element.
     * All these actions will be debounced if the {@link ng.directive:ngModelOptions ngModelOptions}
     * directive is used with a custom debounce for this particular event.
     * Note that a `$digest` is only triggered once the `updateOn` events are fired, or if `debounce`
     * is specified, once the timer runs out.
     *
     * When used with standard inputs, the view value will always be a string (which is in some cases
     * parsed into another type, such as a `Date` object for `input[date]`.)
     * However, custom controls might also pass objects to this method. In this case, we should make
     * a copy of the object before passing it to `$setViewValue`. This is because `ngModel` does not
     * perform a deep watch of objects, it only looks for a change of identity. If you only change
     * the property of the object then ngModel will not realize that the object has changed and
     * will not invoke the `$parsers` and `$validators` pipelines. For this reason, you should
     * not change properties of the copy once it has been passed to `$setViewValue`.
     * Otherwise you may cause the model value on the scope to change incorrectly.
     *
     * <div class="alert alert-info">
     * In any case, the value passed to the method should always reflect the current value
     * of the control. For example, if you are calling `$setViewValue` for an input element,
     * you should pass the input DOM value. Otherwise, the control and the scope model become
     * out of sync. It's also important to note that `$setViewValue` does not call `$render` or change
     * the control's DOM value in any way. If we want to change the control's DOM value
     * programmatically, we should update the `ngModel` scope expression. Its new value will be
     * picked up by the model controller, which will run it through the `$formatters`, `$render` it
     * to update the DOM, and finally call `$validate` on it.
     * </div>
     *
     * @param {*} value value from the view.
     * @param {string} trigger Event that triggered the update.
     */
    $setViewValue: function $setViewValue(value, trigger) {
      this.$viewValue = value;
      if (this.$options.getOption('updateOnDefault')) {
        this.$$debounceViewValueCommit(trigger);
      }
    },
    $$debounceViewValueCommit: function $$debounceViewValueCommit(trigger) {
      var debounceDelay = this.$options.getOption('debounce');
      if (isNumber(debounceDelay[trigger])) {
        debounceDelay = debounceDelay[trigger];
      } else if (isNumber(debounceDelay['default']) && this.$options.getOption('updateOn').indexOf(trigger) === -1) {
        debounceDelay = debounceDelay['default'];
      } else if (isNumber(debounceDelay['*'])) {
        debounceDelay = debounceDelay['*'];
      }
      this.$$timeout.cancel(this.$$pendingDebounce);
      var that = this;
      if (debounceDelay > 0) {
        // this fails if debounceDelay is an object
        this.$$pendingDebounce = this.$$timeout(function () {
          that.$commitViewValue();
        }, debounceDelay);
      } else if (this.$$rootScope.$$phase) {
        this.$commitViewValue();
      } else {
        this.$$scope.$apply(function () {
          that.$commitViewValue();
        });
      }
    },
    /**
     * @ngdoc method
     *
     * @name ngModel.NgModelController#$overrideModelOptions
     *
     * @description
     *
     * Override the current model options settings programmatically.
     *
     * The previous `ModelOptions` value will not be modified. Instead, a
     * new `ModelOptions` object will inherit from the previous one overriding
     * or inheriting settings that are defined in the given parameter.
     *
     * See {@link ngModelOptions} for information about what options can be specified
     * and how model option inheritance works.
     *
     * <div class="alert alert-warning">
     * **Note:** this function only affects the options set on the `ngModelController`,
     * and not the options on the {@link ngModelOptions} directive from which they might have been
     * obtained initially.
     * </div>
     *
     * <div class="alert alert-danger">
     * **Note:** it is not possible to override the `getterSetter` option.
     * </div>
     *
     * @param {Object} options a hash of settings to override the previous options
     *
     */
    $overrideModelOptions: function $overrideModelOptions(options) {
      this.$options = this.$options.createChild(options);
      this.$$setUpdateOnEvents();
    },
    /**
     * @ngdoc method
     *
     * @name  ngModel.NgModelController#$processModelValue
      * @description
     *
     * Runs the model -> view pipeline on the current
     * {@link ngModel.NgModelController#$modelValue $modelValue}.
     *
     * The following actions are performed by this method:
     *
     * - the `$modelValue` is run through the {@link ngModel.NgModelController#$formatters $formatters}
     * and the result is set to the {@link ngModel.NgModelController#$viewValue $viewValue}
     * - the `ng-empty` or `ng-not-empty` class is set on the element
     * - if the `$viewValue` has changed:
     *   - {@link ngModel.NgModelController#$render $render} is called on the control
     *   - the {@link ngModel.NgModelController#$validators $validators} are run and
     *   the validation status is set.
     *
     * This method is called by ngModel internally when the bound scope value changes.
     * Application developers usually do not have to call this function themselves.
     *
     * This function can be used when the `$viewValue` or the rendered DOM value are not correctly
     * formatted and the `$modelValue` must be run through the `$formatters` again.
     *
     * @example
     * Consider a text input with an autocomplete list (for fruit), where the items are
     * objects with a name and an id.
     * A user enters `ap` and then selects `Apricot` from the list.
     * Based on this, the autocomplete widget will call `$setViewValue({name: 'Apricot', id: 443})`,
     * but the rendered value will still be `ap`.
     * The widget can then call `ctrl.$processModelValue()` to run the model -> view
     * pipeline again, which formats the object to the string `Apricot`,
     * then updates the `$viewValue`, and finally renders it in the DOM.
     *
     * <example module="inputExample" name="ng-model-process">
       <file name="index.html">
        <div ng-controller="inputController" style="display: flex;">
          <div style="margin-right: 30px;">
            Search Fruit:
            <basic-autocomplete items="items" on-select="selectedFruit = item"></basic-autocomplete>
          </div>
          <div>
            Model:<br>
            <pre>{{selectedFruit | json}}</pre>
          </div>
        </div>
       </file>
       <file name="app.js">
        angular.module('inputExample', [])
          .controller('inputController', function($scope) {
            $scope.items = [
              {name: 'Apricot', id: 443},
              {name: 'Clementine', id: 972},
              {name: 'Durian', id: 169},
              {name: 'Jackfruit', id: 982},
              {name: 'Strawberry', id: 863}
            ];
          })
          .component('basicAutocomplete', {
            bindings: {
              items: '<',
              onSelect: '&'
            },
            templateUrl: 'autocomplete.html',
            controller: function($element, $scope) {
              var that = this;
              var ngModel;
               that.$postLink = function() {
                ngModel = $element.find('input').controller('ngModel');
                 ngModel.$formatters.push(function(value) {
                  return (value && value.name) || value;
                });
                 ngModel.$parsers.push(function(value) {
                  var match = value;
                  for (var i = 0; i < that.items.length; i++) {
                    if (that.items[i].name === value) {
                      match = that.items[i];
                      break;
                    }
                  }
                   return match;
                });
              };
               that.selectItem = function(item) {
                ngModel.$setViewValue(item);
                ngModel.$processModelValue();
                that.onSelect({item: item});
              };
            }
          });
       </file>
       <file name="autocomplete.html">
         <div>
           <input type="search" ng-model="$ctrl.searchTerm" />
           <ul>
             <li ng-repeat="item in $ctrl.items | filter:$ctrl.searchTerm">
               <button ng-click="$ctrl.selectItem(item)">{{ item.name }}</button>
             </li>
           </ul>
         </div>
       </file>
     * </example>
     *
     */
    $processModelValue: function $processModelValue() {
      var viewValue = this.$$format();
      if (this.$viewValue !== viewValue) {
        this.$$updateEmptyClasses(viewValue);
        this.$viewValue = this.$$lastCommittedViewValue = viewValue;
        this.$render();
        // It is possible that model and view value have been updated during render
        this.$$runValidators(this.$modelValue, this.$viewValue, noop);
      }
    },
    /**
     * This method is called internally to run the $formatters on the $modelValue
     */
    $$format: function $$format() {
      var formatters = this.$formatters,
        idx = formatters.length;
      var viewValue = this.$modelValue;
      while (idx--) {
        viewValue = formatters[idx](viewValue);
      }
      return viewValue;
    },
    /**
     * This method is called internally when the bound scope value changes.
     */
    $$setModelValue: function $$setModelValue(modelValue) {
      this.$modelValue = this.$$rawModelValue = modelValue;
      this.$$parserValid = undefined;
      this.$processModelValue();
    },
    $$setUpdateOnEvents: function $$setUpdateOnEvents() {
      if (this.$$updateEvents) {
        this.$$element.off(this.$$updateEvents, this.$$updateEventHandler);
      }
      this.$$updateEvents = this.$options.getOption('updateOn');
      if (this.$$updateEvents) {
        this.$$element.on(this.$$updateEvents, this.$$updateEventHandler);
      }
    },
    $$updateEventHandler: function $$updateEventHandler(ev) {
      this.$$debounceViewValueCommit(ev && ev.type);
    }
  };
  function setupModelWatcher(ctrl) {
    // model -> value
    // Note: we cannot use a normal scope.$watch as we want to detect the following:
    // 1. scope value is 'a'
    // 2. user enters 'b'
    // 3. ng-change kicks in and reverts scope value to 'a'
    //    -> scope value did not change since the last digest as
    //       ng-change executes in apply phase
    // 4. view should be changed back to 'a'
    ctrl.$$scope.$watch(function ngModelWatch(scope) {
      var modelValue = ctrl.$$ngModelGet(scope);

      // if scope model value and ngModel value are out of sync
      // This cannot be moved to the action function, because it would not catch the
      // case where the model is changed in the ngChange function or the model setter
      if (modelValue !== ctrl.$modelValue && (
      // checks for NaN is needed to allow setting the model to NaN when there's an asyncValidator
      // eslint-disable-next-line no-self-compare
      ctrl.$modelValue === ctrl.$modelValue || modelValue === modelValue)) {
        ctrl.$$setModelValue(modelValue);
      }
      return modelValue;
    });
  }

  /**
   * @ngdoc method
   * @name ngModel.NgModelController#$setValidity
   *
   * @description
   * Change the validity state, and notify the form.
   *
   * This method can be called within $parsers/$formatters or a custom validation implementation.
   * However, in most cases it should be sufficient to use the `ngModel.$validators` and
   * `ngModel.$asyncValidators` collections which will call `$setValidity` automatically.
   *
   * @param {string} validationErrorKey Name of the validator. The `validationErrorKey` will be assigned
   *        to either `$error[validationErrorKey]` or `$pending[validationErrorKey]`
   *        (for unfulfilled `$asyncValidators`), so that it is available for data-binding.
   *        The `validationErrorKey` should be in camelCase and will get converted into dash-case
   *        for class name. Example: `myError` will result in `ng-valid-my-error` and `ng-invalid-my-error`
   *        classes and can be bound to as `{{ someForm.someControl.$error.myError }}`.
   * @param {boolean} isValid Whether the current state is valid (true), invalid (false), pending (undefined),
   *                          or skipped (null). Pending is used for unfulfilled `$asyncValidators`.
   *                          Skipped is used by AngularJS when validators do not run because of parse errors and
   *                          when `$asyncValidators` do not run because any of the `$validators` failed.
   */
  addSetValidityMethod({
    clazz: NgModelController,
    set: function set(object, property) {
      object[property] = true;
    },
    unset: function unset(object, property) {
      delete object[property];
    }
  });

  /**
   * @ngdoc directive
   * @name ngModel
   * @restrict A
   * @priority 1
   * @param {expression} ngModel assignable {@link guide/expression Expression} to bind to.
   *
   * @description
   * The `ngModel` directive binds an `input`,`select`, `textarea` (or custom form control) to a
   * property on the scope using {@link ngModel.NgModelController NgModelController},
   * which is created and exposed by this directive.
   *
   * `ngModel` is responsible for:
   *
   * - Binding the view into the model, which other directives such as `input`, `textarea` or `select`
   *   require.
   * - Providing validation behavior (i.e. required, number, email, url).
   * - Keeping the state of the control (valid/invalid, dirty/pristine, touched/untouched, validation errors).
   * - Setting related css classes on the element (`ng-valid`, `ng-invalid`, `ng-dirty`, `ng-pristine`, `ng-touched`,
   *   `ng-untouched`, `ng-empty`, `ng-not-empty`) including animations.
   * - Registering the control with its parent {@link ng.directive:form form}.
   *
   * Note: `ngModel` will try to bind to the property given by evaluating the expression on the
   * current scope. If the property doesn't already exist on this scope, it will be created
   * implicitly and added to the scope.
   *
   * For best practices on using `ngModel`, see:
   *
   *  - [Understanding Scopes](https://github.com/angular/angular.js/wiki/Understanding-Scopes)
   *
   * For basic examples, how to use `ngModel`, see:
   *
   *  - {@link ng.directive:input input}
   *    - {@link input[text] text}
   *    - {@link input[checkbox] checkbox}
   *    - {@link input[radio] radio}
   *    - {@link input[number] number}
   *    - {@link input[email] email}
   *    - {@link input[url] url}
   *    - {@link input[date] date}
   *    - {@link input[datetime-local] datetime-local}
   *    - {@link input[time] time}
   *    - {@link input[month] month}
   *    - {@link input[week] week}
   *  - {@link ng.directive:select select}
   *  - {@link ng.directive:textarea textarea}
   *
   * ## Complex Models (objects or collections)
   *
   * By default, `ngModel` watches the model by reference, not value. This is important to know when
   * binding inputs to models that are objects (e.g. `Date`) or collections (e.g. arrays). If only properties of the
   * object or collection change, `ngModel` will not be notified and so the input will not be  re-rendered.
   *
   * The model must be assigned an entirely new object or collection before a re-rendering will occur.
   *
   * Some directives have options that will cause them to use a custom `$watchCollection` on the model expression
   * - for example, `ngOptions` will do so when a `track by` clause is included in the comprehension expression or
   * if the select is given the `multiple` attribute.
   *
   * The `$watchCollection()` method only does a shallow comparison, meaning that changing properties deeper than the
   * first level of the object (or only changing the properties of an item in the collection if it's an array) will still
   * not trigger a re-rendering of the model.
   *
   * ## CSS classes
   * The following CSS classes are added and removed on the associated input/select/textarea element
   * depending on the validity of the model.
   *
   *  - `ng-valid`: the model is valid
   *  - `ng-invalid`: the model is invalid
   *  - `ng-valid-[key]`: for each valid key added by `$setValidity`
   *  - `ng-invalid-[key]`: for each invalid key added by `$setValidity`
   *  - `ng-pristine`: the control hasn't been interacted with yet
   *  - `ng-dirty`: the control has been interacted with
   *  - `ng-touched`: the control has been blurred
   *  - `ng-untouched`: the control hasn't been blurred
   *  - `ng-pending`: any `$asyncValidators` are unfulfilled
   *  - `ng-empty`: the view does not contain a value or the value is deemed "empty", as defined
   *     by the {@link ngModel.NgModelController#$isEmpty} method
   *  - `ng-not-empty`: the view contains a non-empty value
   *
   * Keep in mind that ngAnimate can detect each of these classes when added and removed.
   *
   * @animations
   * Animations within models are triggered when any of the associated CSS classes are added and removed
   * on the input element which is attached to the model. These classes include: `.ng-pristine`, `.ng-dirty`,
   * `.ng-invalid` and `.ng-valid` as well as any other validations that are performed on the model itself.
   * The animations that are triggered within ngModel are similar to how they work in ngClass and
   * animations can be hooked into using CSS transitions, keyframes as well as JS animations.
   *
   * The following example shows a simple way to utilize CSS transitions to style an input element
   * that has been rendered as invalid after it has been validated:
   *
   * <pre>
   * //be sure to include ngAnimate as a module to hook into more
   * //advanced animations
   * .my-input {
   *   transition:0.5s linear all;
   *   background: white;
   * }
   * .my-input.ng-invalid {
   *   background: red;
   *   color:white;
   * }
   * </pre>
   *
   * @example
   * ### Basic Usage
   * <example deps="angular-animate.js" animations="true" fixBase="true" module="inputExample" name="ng-model">
       <file name="index.html">
         <script>
          angular.module('inputExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.val = '1';
            }]);
         </script>
         <style>
           .my-input {
             transition:all linear 0.5s;
             background: transparent;
           }
           .my-input.ng-invalid {
             color:white;
             background: red;
           }
         </style>
         <p id="inputDescription">
          Update input to see transitions when valid/invalid.
          Integer is a valid value.
         </p>
         <form name="testForm" ng-controller="ExampleController">
           <input ng-model="val" ng-pattern="/^\d+$/" name="anim" class="my-input"
                  aria-describedby="inputDescription" />
         </form>
       </file>
   * </example>
   *
   * @example
   * ### Binding to a getter/setter
   *
   * Sometimes it's helpful to bind `ngModel` to a getter/setter function.  A getter/setter is a
   * function that returns a representation of the model when called with zero arguments, and sets
   * the internal state of a model when called with an argument. It's sometimes useful to use this
   * for models that have an internal representation that's different from what the model exposes
   * to the view.
   *
   * <div class="alert alert-success">
   * **Best Practice:** It's best to keep getters fast because AngularJS is likely to call them more
   * frequently than other parts of your code.
   * </div>
   *
   * You use this behavior by adding `ng-model-options="{ getterSetter: true }"` to an element that
   * has `ng-model` attached to it. You can also add `ng-model-options="{ getterSetter: true }"` to
   * a `<form>`, which will enable this behavior for all `<input>`s within it. See
   * {@link ng.directive:ngModelOptions `ngModelOptions`} for more.
   *
   * The following example shows how to use `ngModel` with a getter/setter:
   *
   * @example
   * <example name="ngModel-getter-setter" module="getterSetterExample">
       <file name="index.html">
         <div ng-controller="ExampleController">
           <form name="userForm">
             <label>Name:
               <input type="text" name="userName"
                      ng-model="user.name"
                      ng-model-options="{ getterSetter: true }" />
             </label>
           </form>
           <pre>user.name = <span ng-bind="user.name()"></span></pre>
         </div>
       </file>
       <file name="app.js">
         angular.module('getterSetterExample', [])
           .controller('ExampleController', ['$scope', function($scope) {
             var _name = 'Brian';
             $scope.user = {
               name: function(newName) {
                // Note that newName can be undefined for two reasons:
                // 1. Because it is called as a getter and thus called with no arguments
                // 2. Because the property should actually be set to undefined. This happens e.g. if the
                //    input is invalid
                return arguments.length ? (_name = newName) : _name;
               }
             };
           }]);
       </file>
   * </example>
   */
  var ngModelDirective = ['$rootScope', function ($rootScope) {
    return {
      restrict: 'A',
      require: ['ngModel', '^?form', '^?ngModelOptions'],
      controller: NgModelController,
      // Prelink needs to run before any input directive
      // so that we can set the NgModelOptions in NgModelController
      // before anyone else uses it.
      priority: 1,
      compile: function ngModelCompile(element) {
        // Setup initial state of the control
        element.addClass(PRISTINE_CLASS).addClass(UNTOUCHED_CLASS).addClass(VALID_CLASS);
        return {
          pre: function ngModelPreLink(scope, element, attr, ctrls) {
            var modelCtrl = ctrls[0],
              formCtrl = ctrls[1] || modelCtrl.$$parentForm,
              optionsCtrl = ctrls[2];
            if (optionsCtrl) {
              modelCtrl.$options = optionsCtrl.$options;
            }
            modelCtrl.$$initGetterSetters();

            // notify others, especially parent forms
            formCtrl.$addControl(modelCtrl);
            attr.$observe('name', function (newValue) {
              if (modelCtrl.$name !== newValue) {
                modelCtrl.$$parentForm.$$renameControl(modelCtrl, newValue);
              }
            });
            scope.$on('$destroy', function () {
              modelCtrl.$$parentForm.$removeControl(modelCtrl);
            });
          },
          post: function ngModelPostLink(scope, element, attr, ctrls) {
            var modelCtrl = ctrls[0];
            modelCtrl.$$setUpdateOnEvents();
            function setTouched() {
              modelCtrl.$setTouched();
            }
            element.on('blur', function () {
              if (modelCtrl.$touched) return;
              if ($rootScope.$$phase) {
                scope.$evalAsync(setTouched);
              } else {
                scope.$apply(setTouched);
              }
            });
          }
        };
      }
    };
  }];

  /* exported defaultModelOptions */
  var defaultModelOptions;
  var DEFAULT_REGEXP = /(\s+|^)default(\s+|$)/;

  /**
   * @ngdoc type
   * @name ModelOptions
   * @description
   * A container for the options set by the {@link ngModelOptions} directive
   */
  function ModelOptions(options) {
    this.$$options = options;
  }
  ModelOptions.prototype = {
    /**
     * @ngdoc method
     * @name ModelOptions#getOption
     * @param {string} name the name of the option to retrieve
     * @returns {*} the value of the option
     * @description
     * Returns the value of the given option
     */
    getOption: function getOption(name) {
      return this.$$options[name];
    },
    /**
     * @ngdoc method
     * @name ModelOptions#createChild
     * @param {Object} options a hash of options for the new child that will override the parent's options
     * @return {ModelOptions} a new `ModelOptions` object initialized with the given options.
     */
    createChild: function createChild(options) {
      var inheritAll = false;

      // make a shallow copy
      options = extend({}, options);

      // Inherit options from the parent if specified by the value `"$inherit"`
      forEach(options, /** @this */function (option, key) {
        if (option === '$inherit') {
          if (key === '*') {
            inheritAll = true;
          } else {
            options[key] = this.$$options[key];
            // `updateOn` is special so we must also inherit the `updateOnDefault` option
            if (key === 'updateOn') {
              options.updateOnDefault = this.$$options.updateOnDefault;
            }
          }
        } else {
          if (key === 'updateOn') {
            // If the `updateOn` property contains the `default` event then we have to remove
            // it from the event list and set the `updateOnDefault` flag.
            options.updateOnDefault = false;
            options[key] = trim(option.replace(DEFAULT_REGEXP, function () {
              options.updateOnDefault = true;
              return ' ';
            }));
          }
        }
      }, this);
      if (inheritAll) {
        // We have a property of the form: `"*": "$inherit"`
        delete options['*'];
        defaults(options, this.$$options);
      }

      // Finally add in any missing defaults
      defaults(options, defaultModelOptions.$$options);
      return new ModelOptions(options);
    }
  };
  defaultModelOptions = new ModelOptions({
    updateOn: '',
    updateOnDefault: true,
    debounce: 0,
    getterSetter: false,
    allowInvalid: false,
    timezone: null
  });

  /**
   * @ngdoc directive
   * @name ngModelOptions
   * @restrict A
   * @priority 10
   *
   * @description
   * This directive allows you to modify the behaviour of {@link ngModel} directives within your
   * application. You can specify an `ngModelOptions` directive on any element. All {@link ngModel}
   * directives will use the options of their nearest `ngModelOptions` ancestor.
   *
   * The `ngModelOptions` settings are found by evaluating the value of the attribute directive as
   * an AngularJS expression. This expression should evaluate to an object, whose properties contain
   * the settings. For example: `<div ng-model-options="{ debounce: 100 }"`.
   *
   * ## Inheriting Options
   *
   * You can specify that an `ngModelOptions` setting should be inherited from a parent `ngModelOptions`
   * directive by giving it the value of `"$inherit"`.
   * Then it will inherit that setting from the first `ngModelOptions` directive found by traversing up the
   * DOM tree. If there is no ancestor element containing an `ngModelOptions` directive then default settings
   * will be used.
   *
   * For example given the following fragment of HTML
   *
   *
   * ```html
   * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
   *   <form ng-model-options="{ updateOn: 'blur', allowInvalid: '$inherit' }">
   *     <input ng-model-options="{ updateOn: 'default', allowInvalid: '$inherit' }" />
   *   </form>
   * </div>
   * ```
   *
   * the `input` element will have the following settings
   *
   * ```js
   * { allowInvalid: true, updateOn: 'default', debounce: 0 }
   * ```
   *
   * Notice that the `debounce` setting was not inherited and used the default value instead.
   *
   * You can specify that all undefined settings are automatically inherited from an ancestor by
   * including a property with key of `"*"` and value of `"$inherit"`.
   *
   * For example given the following fragment of HTML
   *
   *
   * ```html
   * <div ng-model-options="{ allowInvalid: true, debounce: 200 }">
   *   <form ng-model-options="{ updateOn: 'blur', "*": '$inherit' }">
   *     <input ng-model-options="{ updateOn: 'default', "*": '$inherit' }" />
   *   </form>
   * </div>
   * ```
   *
   * the `input` element will have the following settings
   *
   * ```js
   * { allowInvalid: true, updateOn: 'default', debounce: 200 }
   * ```
   *
   * Notice that the `debounce` setting now inherits the value from the outer `<div>` element.
   *
   * If you are creating a reusable component then you should be careful when using `"*": "$inherit"`
   * since you may inadvertently inherit a setting in the future that changes the behavior of your component.
   *
   *
   * ## Triggering and debouncing model updates
   *
   * The `updateOn` and `debounce` properties allow you to specify a custom list of events that will
   * trigger a model update and/or a debouncing delay so that the actual update only takes place when
   * a timer expires; this timer will be reset after another change takes place.
   *
   * Given the nature of `ngModelOptions`, the value displayed inside input fields in the view might
   * be different from the value in the actual model. This means that if you update the model you
   * should also invoke {@link ngModel.NgModelController#$rollbackViewValue} on the relevant input field in
   * order to make sure it is synchronized with the model and that any debounced action is canceled.
   *
   * The easiest way to reference the control's {@link ngModel.NgModelController#$rollbackViewValue}
   * method is by making sure the input is placed inside a form that has a `name` attribute. This is
   * important because `form` controllers are published to the related scope under the name in their
   * `name` attribute.
   *
   * Any pending changes will take place immediately when an enclosing form is submitted via the
   * `submit` event. Note that `ngClick` events will occur before the model is updated. Use `ngSubmit`
   * to have access to the updated model.
   *
   * ### Overriding immediate updates
   *
   * The following example shows how to override immediate updates. Changes on the inputs within the
   * form will update the model only when the control loses focus (blur event). If `escape` key is
   * pressed while the input field is focused, the value is reset to the value in the current model.
   *
   * <example name="ngModelOptions-directive-blur" module="optionsExample">
   *   <file name="index.html">
   *     <div ng-controller="ExampleController">
   *       <form name="userForm">
   *         <label>
   *           Name:
   *           <input type="text" name="userName"
   *                  ng-model="user.name"
   *                  ng-model-options="{ updateOn: 'blur' }"
   *                  ng-keyup="cancel($event)" />
   *         </label><br />
   *         <label>
   *           Other data:
   *           <input type="text" ng-model="user.data" />
   *         </label><br />
   *       </form>
   *       <pre>user.name = <span ng-bind="user.name"></span></pre>
   *     </div>
   *   </file>
   *   <file name="app.js">
   *     angular.module('optionsExample', [])
   *       .controller('ExampleController', ['$scope', function($scope) {
   *         $scope.user = { name: 'say', data: '' };
   *
   *         $scope.cancel = function(e) {
   *           if (e.keyCode === 27) {
   *             $scope.userForm.userName.$rollbackViewValue();
   *           }
   *         };
   *       }]);
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *     var model = element(by.binding('user.name'));
   *     var input = element(by.model('user.name'));
   *     var other = element(by.model('user.data'));
   *
   *     it('should allow custom events', function() {
   *       input.sendKeys(' hello');
   *       input.click();
   *       expect(model.getText()).toEqual('say');
   *       other.click();
   *       expect(model.getText()).toEqual('say hello');
   *     });
   *
   *     it('should $rollbackViewValue when model changes', function() {
   *       input.sendKeys(' hello');
   *       expect(input.getAttribute('value')).toEqual('say hello');
   *       input.sendKeys(protractor.Key.ESCAPE);
   *       expect(input.getAttribute('value')).toEqual('say');
   *       other.click();
   *       expect(model.getText()).toEqual('say');
   *     });
   *   </file>
   * </example>
   *
   * ### Debouncing updates
   *
   * The next example shows how to debounce model changes. Model will be updated only 1 sec after last change.
   * If the `Clear` button is pressed, any debounced action is canceled and the value becomes empty.
   *
   * <example name="ngModelOptions-directive-debounce" module="optionsExample">
   *   <file name="index.html">
   *     <div ng-controller="ExampleController">
   *       <form name="userForm">
   *         Name:
   *         <input type="text" name="userName"
   *                ng-model="user.name"
   *                ng-model-options="{ debounce: 1000 }" />
   *         <button ng-click="userForm.userName.$rollbackViewValue(); user.name=''">Clear</button><br />
   *       </form>
   *       <pre>user.name = <span ng-bind="user.name"></span></pre>
   *     </div>
   *   </file>
   *   <file name="app.js">
   *     angular.module('optionsExample', [])
   *       .controller('ExampleController', ['$scope', function($scope) {
   *         $scope.user = { name: 'say' };
   *       }]);
   *   </file>
   * </example>
   *
   * ### Default events, extra triggers, and catch-all debounce values
   *
   * This example shows the relationship between "default" update events and
   * additional `updateOn` triggers.
   *
   * `default` events are those that are bound to the control, and when fired, update the `$viewValue`
   * via {@link ngModel.NgModelController#$setViewValue $setViewValue}. Every event that is not listed
   * in `updateOn` is considered a "default" event, since different control types have different
   * default events.
   *
   * The control in this example updates by "default", "click", and "blur", with different `debounce`
   * values. You can see that "click" doesn't have an individual `debounce` value -
   * therefore it uses the `*` debounce value.
   *
   * There is also a button that calls {@link ngModel.NgModelController#$setViewValue $setViewValue}
   * directly with a "custom" event. Since "custom" is not defined in the `updateOn` list,
   * it is considered a "default" event and will update the
   * control if "default" is defined in `updateOn`, and will receive the "default" debounce value.
   * Note that this is just to illustrate how custom controls would possibly call `$setViewValue`.
   *
   * You can change the `updateOn` and `debounce` configuration to test different scenarios. This
   * is done with {@link ngModel.NgModelController#$overrideModelOptions $overrideModelOptions}.
   *
    <example name="ngModelOptions-advanced" module="optionsExample">
      <file name="index.html">
         <model-update-demo></model-update-demo>
      </file>
      <file name="app.js">
        angular.module('optionsExample', [])
          .component('modelUpdateDemo', {
            templateUrl: 'template.html',
            controller: function() {
              this.name = 'Chinua';
  
              this.options = {
                updateOn: 'default blur click',
                debounce: {
                  default: 2000,
                  blur: 0,
                  '*': 1000
                }
              };
  
              this.updateEvents = function() {
                var eventList = this.options.updateOn.split(' ');
                eventList.push('*');
                var events = {};
  
                for (var i = 0; i < eventList.length; i++) {
                  events[eventList[i]] = this.options.debounce[eventList[i]];
                }
  
                this.events = events;
              };
  
              this.updateOptions = function() {
                var options = angular.extend(this.options, {
                  updateOn: Object.keys(this.events).join(' ').replace('*', ''),
                  debounce: this.events
                });
  
                this.form.input.$overrideModelOptions(options);
              };
  
              // Initialize the event form
              this.updateEvents();
            }
          });
      </file>
      <file name="template.html">
        <form name="$ctrl.form">
          Input: <input type="text" name="input" ng-model="$ctrl.name" ng-model-options="$ctrl.options" />
        </form>
        Model: <tt>{{$ctrl.name}}</tt>
        <hr>
        <button ng-click="$ctrl.form.input.$setViewValue('some value', 'custom')">Trigger setViewValue with 'some value' and 'custom' event</button>
  
        <hr>
        <form ng-submit="$ctrl.updateOptions()">
          <b>updateOn</b><br>
          <input type="text" ng-model="$ctrl.options.updateOn" ng-change="$ctrl.updateEvents()" ng-model-options="{debounce: 500}">
  
          <table>
            <tr>
              <th>Option</th>
              <th>Debounce value</th>
            </tr>
            <tr ng-repeat="(key, value) in $ctrl.events">
              <td>{{key}}</td>
              <td><input type="number" ng-model="$ctrl.events[key]" /></td>
            </tr>
          </table>
  
          <br>
          <input type="submit" value="Update options">
        </form>
      </file>
    </example>
   *
   *
   * ## Model updates and validation
   *
   * The default behaviour in `ngModel` is that the model value is set to `undefined` when the
   * validation determines that the value is invalid. By setting the `allowInvalid` property to true,
   * the model will still be updated even if the value is invalid.
   *
   *
   * ## Connecting to the scope
   *
   * By setting the `getterSetter` property to true you are telling ngModel that the `ngModel` expression
   * on the scope refers to a "getter/setter" function rather than the value itself.
   *
   * The following example shows how to bind to getter/setters:
   *
   * <example name="ngModelOptions-directive-getter-setter" module="getterSetterExample">
   *   <file name="index.html">
   *     <div ng-controller="ExampleController">
   *       <form name="userForm">
   *         <label>
   *           Name:
   *           <input type="text" name="userName"
   *                  ng-model="user.name"
   *                  ng-model-options="{ getterSetter: true }" />
   *         </label>
   *       </form>
   *       <pre>user.name = <span ng-bind="user.name()"></span></pre>
   *     </div>
   *   </file>
   *   <file name="app.js">
   *     angular.module('getterSetterExample', [])
   *       .controller('ExampleController', ['$scope', function($scope) {
   *         var _name = 'Brian';
   *         $scope.user = {
   *           name: function(newName) {
   *             return angular.isDefined(newName) ? (_name = newName) : _name;
   *           }
   *         };
   *       }]);
   *   </file>
   * </example>
   *
   *
   * ## Programmatically changing options
   *
   * The `ngModelOptions` expression is only evaluated once when the directive is linked; it is not
   * watched for changes. However, it is possible to override the options on a single
   * {@link ngModel.NgModelController} instance with
   * {@link ngModel.NgModelController#$overrideModelOptions `NgModelController#$overrideModelOptions()`}.
   * See also the example for
   * {@link ngModelOptions#default-events-extra-triggers-and-catch-all-debounce-values
   * Default events, extra triggers, and catch-all debounce values}.
   *
   *
   * ## Specifying timezones
   *
   * You can specify the timezone that date/time input directives expect by providing its name in the
   * `timezone` property.
   *
   *
   * ## Formatting the value of `time` and `datetime-local`
   *
   * With the options `timeSecondsFormat` and `timeStripZeroSeconds` it is possible to adjust the value
   * that is displayed in the control. Note that browsers may apply their own formatting
   * in the user interface.
   *
     <example name="ngModelOptions-time-format" module="timeExample">
       <file name="index.html">
         <time-example></time-example>
       </file>
       <file name="script.js">
          angular.module('timeExample', [])
            .component('timeExample', {
              templateUrl: 'timeExample.html',
              controller: function() {
                this.time = new Date(1970, 0, 1, 14, 57, 0);
  
                this.options = {
                  timeSecondsFormat: 'ss',
                  timeStripZeroSeconds: true
                };
  
                this.optionChange = function() {
                  this.timeForm.timeFormatted.$overrideModelOptions(this.options);
                  this.time = new Date(this.time);
                };
              }
            });
       </file>
       <file name="timeExample.html">
         <form name="$ctrl.timeForm">
           <strong>Default</strong>:
           <input type="time" ng-model="$ctrl.time" step="any" /><br>
           <strong>With options</strong>:
           <input type="time" name="timeFormatted" ng-model="$ctrl.time" step="any" ng-model-options="$ctrl.options" />
           <br>
  
           Options:<br>
           <code>timeSecondsFormat</code>:
           <input
             type="text"
             ng-model="$ctrl.options.timeSecondsFormat"
             ng-change="$ctrl.optionChange()">
           <br>
           <code>timeStripZeroSeconds</code>:
           <input
             type="checkbox"
             ng-model="$ctrl.options.timeStripZeroSeconds"
             ng-change="$ctrl.optionChange()">
          </form>
        </file>
   *  </example>
   *
   * @param {Object} ngModelOptions options to apply to {@link ngModel} directives on this element and
   *   and its descendents.
   *
   * **General options**:
   *
   *   - `updateOn`: string specifying which event should the input be bound to. You can set several
   *     events using an space delimited list. There is a special event called `default` that
   *     matches the default events belonging to the control. These are the events that are bound to
   *     the control, and when fired, update the `$viewValue` via `$setViewValue`.
   *
   *     `ngModelOptions` considers every event that is not listed in `updateOn` a "default" event,
   *     since different control types use different default events.
   *
   *     See also the section {@link ngModelOptions#triggering-and-debouncing-model-updates
   *     Triggering and debouncing model updates}.
   *
   *   - `debounce`: integer value which contains the debounce model update value in milliseconds. A
   *     value of 0 triggers an immediate update. If an object is supplied instead, you can specify a
   *     custom value for each event. For example:
   *     ```
   *     ng-model-options="{
   *       updateOn: 'default blur',
   *       debounce: { 'default': 500, 'blur': 0 }
   *     }"
   *     ```
   *     You can use the `*` key to specify a debounce value that applies to all events that are not
   *     specifically listed. In the following example, `mouseup` would have a debounce delay of 1000:
   *     ```
   *     ng-model-options="{
   *       updateOn: 'default blur mouseup',
   *       debounce: { 'default': 500, 'blur': 0, '*': 1000 }
   *     }"
   *     ```
   *   - `allowInvalid`: boolean value which indicates that the model can be set with values that did
   *     not validate correctly instead of the default behavior of setting the model to undefined.
   *   - `getterSetter`: boolean value which determines whether or not to treat functions bound to
   *     `ngModel` as getters/setters.
   *
   *
   *  **Input-type specific options**:
   *
   *   - `timezone`: Defines the timezone to be used to read/write the `Date` instance in the model for
   *     `<input type="date" />`, `<input type="time" />`, ... . It understands UTC/GMT and the
   *     continental US time zone abbreviations, but for general use, use a time zone offset, for
   *     example, `'+0430'` (4 hours, 30 minutes east of the Greenwich meridian)
   *     If not specified, the timezone of the browser will be used.
   *     Note that changing the timezone will have no effect on the current date, and is only applied after
   *     the next input / model change.
   *
   *   - `timeSecondsFormat`: Defines if the `time` and `datetime-local` types should show seconds and
   *     milliseconds. The option follows the format string of {@link date date filter}.
   *     By default, the options is `undefined` which is equal to `'ss.sss'` (seconds and milliseconds).
   *     The other options are `'ss'` (strips milliseconds), and `''` (empty string), which strips both
   *     seconds and milliseconds.
   *     Note that browsers that support `time` and `datetime-local` require the hour and minutes
   *     part of the time string, and may show the value differently in the user interface.
   *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
   *
   *   - `timeStripZeroSeconds`: Defines if the `time` and `datetime-local` types should strip the
   *     seconds and milliseconds from the formatted value if they are zero. This option is applied
   *     after `timeSecondsFormat`.
   *     This option can be used to make the formatting consistent over different browsers, as some
   *     browsers with support for `time` will natively hide the milliseconds and
   *     seconds if they are zero, but others won't, and browsers that don't implement these input
   *     types will always show the full string.
   *     {@link ngModelOptions#formatting-the-value-of-time-and-datetime-local- See the example}.
   *
   */
  var ngModelOptionsDirective = function ngModelOptionsDirective() {
    NgModelOptionsController.$inject = ['$attrs', '$scope'];
    function NgModelOptionsController($attrs, $scope) {
      this.$$attrs = $attrs;
      this.$$scope = $scope;
    }
    NgModelOptionsController.prototype = {
      $onInit: function $onInit() {
        var parentOptions = this.parentCtrl ? this.parentCtrl.$options : defaultModelOptions;
        var modelOptionsDefinition = this.$$scope.$eval(this.$$attrs.ngModelOptions);
        this.$options = parentOptions.createChild(modelOptionsDefinition);
      }
    };
    return {
      restrict: 'A',
      // ngModelOptions needs to run before ngModel and input directives
      priority: 10,
      require: {
        parentCtrl: '?^^ngModelOptions'
      },
      bindToController: true,
      controller: NgModelOptionsController
    };
  };

  // shallow copy over values from `src` that are not already specified on `dst`
  function defaults(dst, src) {
    forEach(src, function (value, key) {
      if (!isDefined(dst[key])) {
        dst[key] = value;
      }
    });
  }

  /**
   * @ngdoc directive
   * @name ngNonBindable
   * @restrict AC
   * @priority 1000
   * @element ANY
   *
   * @description
   * The `ngNonBindable` directive tells AngularJS not to compile or bind the contents of the current
   * DOM element, including directives on the element itself that have a lower priority than
   * `ngNonBindable`. This is useful if the element contains what appears to be AngularJS directives
   * and bindings but which should be ignored by AngularJS. This could be the case if you have a site
   * that displays snippets of code, for instance.
   *
   * @example
   * In this example there are two locations where a simple interpolation binding (`{{}}`) is present,
   * but the one wrapped in `ngNonBindable` is left alone.
   *
    <example name="ng-non-bindable">
      <file name="index.html">
        <div>Normal: {{1 + 2}}</div>
        <div ng-non-bindable>Ignored: {{1 + 2}}</div>
      </file>
      <file name="protractor.js" type="protractor">
       it('should check ng-non-bindable', function() {
         expect(element(by.binding('1 + 2')).getText()).toContain('3');
         expect(element.all(by.css('div')).last().getText()).toMatch(/1 \+ 2/);
       });
      </file>
    </example>
   */
  var ngNonBindableDirective = ngDirective({
    terminal: true,
    priority: 1000
  });

  /* exported ngOptionsDirective */

  /* global jqLiteRemove */

  var ngOptionsMinErr = minErr('ngOptions');

  /**
   * @ngdoc directive
   * @name ngOptions
   * @restrict A
   *
   * @description
   *
   * The `ngOptions` attribute can be used to dynamically generate a list of `<option>`
   * elements for the `<select>` element using the array or object obtained by evaluating the
   * `ngOptions` comprehension expression.
   *
   * In many cases, {@link ng.directive:ngRepeat ngRepeat} can be used on `<option>` elements instead of
   * `ngOptions` to achieve a similar result. However, `ngOptions` provides some benefits:
   * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
   * comprehension expression
   * - reduced memory consumption by not creating a new scope for each repeated instance
   * - increased render speed by creating the options in a documentFragment instead of individually
   *
   * When an item in the `<select>` menu is selected, the array element or object property
   * represented by the selected option will be bound to the model identified by the `ngModel`
   * directive.
   *
   * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
   * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
   * option. See example below for demonstration.
   *
   * ## Complex Models (objects or collections)
   *
   * By default, `ngModel` watches the model by reference, not value. This is important to know when
   * binding the select to a model that is an object or a collection.
   *
   * One issue occurs if you want to preselect an option. For example, if you set
   * the model to an object that is equal to an object in your collection, `ngOptions` won't be able to set the selection,
   * because the objects are not identical. So by default, you should always reference the item in your collection
   * for preselections, e.g.: `$scope.selected = $scope.collection[3]`.
   *
   * Another solution is to use a `track by` clause, because then `ngOptions` will track the identity
   * of the item not by reference, but by the result of the `track by` expression. For example, if your
   * collection items have an id property, you would `track by item.id`.
   *
   * A different issue with objects or collections is that ngModel won't detect if an object property or
   * a collection item changes. For that reason, `ngOptions` additionally watches the model using
   * `$watchCollection`, when the expression contains a `track by` clause or the the select has the `multiple` attribute.
   * This allows ngOptions to trigger a re-rendering of the options even if the actual object/collection
   * has not changed identity, but only a property on the object or an item in the collection changes.
   *
   * Note that `$watchCollection` does a shallow comparison of the properties of the object (or the items in the collection
   * if the model is an array). This means that changing a property deeper than the first level inside the
   * object/collection will not trigger a re-rendering.
   *
   * ## `select` **`as`**
   *
   * Using `select` **`as`** will bind the result of the `select` expression to the model, but
   * the value of the `<select>` and `<option>` html elements will be either the index (for array data sources)
   * or property name (for object data sources) of the value within the collection. If a **`track by`** expression
   * is used, the result of that expression will be set as the value of the `option` and `select` elements.
   *
   *
   * ### `select` **`as`** and **`track by`**
   *
   * <div class="alert alert-warning">
   * Be careful when using `select` **`as`** and **`track by`** in the same expression.
   * </div>
   *
   * Given this array of items on the $scope:
   *
   * ```js
   * $scope.items = [{
   *   id: 1,
   *   label: 'aLabel',
   *   subItem: { name: 'aSubItem' }
   * }, {
   *   id: 2,
   *   label: 'bLabel',
   *   subItem: { name: 'bSubItem' }
   * }];
   * ```
   *
   * This will work:
   *
   * ```html
   * <select ng-options="item as item.label for item in items track by item.id" ng-model="selected"></select>
   * ```
   * ```js
   * $scope.selected = $scope.items[0];
   * ```
   *
   * but this will not work:
   *
   * ```html
   * <select ng-options="item.subItem as item.label for item in items track by item.id" ng-model="selected"></select>
   * ```
   * ```js
   * $scope.selected = $scope.items[0].subItem;
   * ```
   *
   * In both examples, the **`track by`** expression is applied successfully to each `item` in the
   * `items` array. Because the selected option has been set programmatically in the controller, the
   * **`track by`** expression is also applied to the `ngModel` value. In the first example, the
   * `ngModel` value is `items[0]` and the **`track by`** expression evaluates to `items[0].id` with
   * no issue. In the second example, the `ngModel` value is `items[0].subItem` and the **`track by`**
   * expression evaluates to `items[0].subItem.id` (which is undefined). As a result, the model value
   * is not matched against any `<option>` and the `<select>` appears as having no selected value.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {comprehension_expression} ngOptions in one of the following forms:
   *
   *   * for array data sources:
   *     * `label` **`for`** `value` **`in`** `array`
   *     * `select` **`as`** `label` **`for`** `value` **`in`** `array`
   *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array`
   *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array`
   *     * `label` **`group by`** `group` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
   *     * `label` **`disable when`** `disable` **`for`** `value` **`in`** `array` **`track by`** `trackexpr`
   *     * `label` **`for`** `value` **`in`** `array` | orderBy:`orderexpr` **`track by`** `trackexpr`
   *        (for including a filter with `track by`)
   *   * for object data sources:
   *     * `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
   *     * `select` **`as`** `label` **`for (`**`key` **`,`** `value`**`) in`** `object`
   *     * `label` **`group by`** `group` **`for (`**`key`**`,`** `value`**`) in`** `object`
   *     * `label` **`disable when`** `disable` **`for (`**`key`**`,`** `value`**`) in`** `object`
   *     * `select` **`as`** `label` **`group by`** `group`
   *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
   *     * `select` **`as`** `label` **`disable when`** `disable`
   *         **`for` `(`**`key`**`,`** `value`**`) in`** `object`
   *
   * Where:
   *
   *   * `array` / `object`: an expression which evaluates to an array / object to iterate over.
   *   * `value`: local variable which will refer to each item in the `array` or each property value
   *      of `object` during iteration.
   *   * `key`: local variable which will refer to a property name in `object` during iteration.
   *   * `label`: The result of this expression will be the label for `<option>` element. The
   *     `expression` will most likely refer to the `value` variable (e.g. `value.propertyName`).
   *   * `select`: The result of this expression will be bound to the model of the parent `<select>`
   *      element. If not specified, `select` expression will default to `value`.
   *   * `group`: The result of this expression will be used to group options using the `<optgroup>`
   *      DOM element.
   *   * `disable`: The result of this expression will be used to disable the rendered `<option>`
   *      element. Return `true` to disable.
   *   * `trackexpr`: Used when working with an array of objects. The result of this expression will be
   *      used to identify the objects in the array. The `trackexpr` will most likely refer to the
   *     `value` variable (e.g. `value.propertyName`). With this the selection is preserved
   *      even when the options are recreated (e.g. reloaded from the server).
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} required The control is considered valid only if value is entered.
   * @param {string=} ngRequired Adds `required` attribute and `required` validation constraint to
   *    the element when the ngRequired expression evaluates to true. Use `ngRequired` instead of
   *    `required` when you want to data-bind to the `required` attribute.
   * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
   * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
   *
   * @example
      <example module="selectExample" name="select">
        <file name="index.html">
          <script>
          angular.module('selectExample', [])
            .controller('ExampleController', ['$scope', function($scope) {
              $scope.colors = [
                {name:'black', shade:'dark'},
                {name:'white', shade:'light', notAnOption: true},
                {name:'red', shade:'dark'},
                {name:'blue', shade:'dark', notAnOption: true},
                {name:'yellow', shade:'light', notAnOption: false}
              ];
              $scope.myColor = $scope.colors[2]; // red
            }]);
          </script>
          <div ng-controller="ExampleController">
            <ul>
              <li ng-repeat="color in colors">
                <label>Name: <input ng-model="color.name"></label>
                <label><input type="checkbox" ng-model="color.notAnOption"> Disabled?</label>
                <button ng-click="colors.splice($index, 1)" aria-label="Remove">X</button>
              </li>
              <li>
                <button ng-click="colors.push({})">add</button>
              </li>
            </ul>
            <hr/>
            <label>Color (null not allowed):
              <select ng-model="myColor" ng-options="color.name for color in colors"></select>
            </label><br/>
            <label>Color (null allowed):
            <span  class="nullable">
              <select ng-model="myColor" ng-options="color.name for color in colors">
                <option value="">-- choose color --</option>
              </select>
            </span></label><br/>
  
            <label>Color grouped by shade:
              <select ng-model="myColor" ng-options="color.name group by color.shade for color in colors">
              </select>
            </label><br/>
  
            <label>Color grouped by shade, with some disabled:
              <select ng-model="myColor"
                    ng-options="color.name group by color.shade disable when color.notAnOption for color in colors">
              </select>
            </label><br/>
  
  
  
            Select <button ng-click="myColor = { name:'not in list', shade: 'other' }">bogus</button>.
            <br/>
            <hr/>
            Currently selected: {{ {selected_color:myColor} }}
            <div style="border:solid 1px black; height:20px"
                 ng-style="{'background-color':myColor.name}">
            </div>
          </div>
        </file>
        <file name="protractor.js" type="protractor">
           it('should check ng-options', function() {
             expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('red');
             element.all(by.model('myColor')).first().click();
             element.all(by.css('select[ng-model="myColor"] option')).first().click();
             expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('black');
             element(by.css('.nullable select[ng-model="myColor"]')).click();
             element.all(by.css('.nullable select[ng-model="myColor"] option')).first().click();
             expect(element(by.binding('{selected_color:myColor}')).getText()).toMatch('null');
           });
        </file>
      </example>
   */

  /* eslint-disable max-len */
  //                     //00001111111111000000000002222222222000000000000000000000333333333300000000000000000000000004444444444400000000000005555555555555000000000666666666666600000007777777777777000000000000000888888888800000000000000000009999999999
  var NG_OPTIONS_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+group\s+by\s+([\s\S]+?))?(?:\s+disable\s+when\s+([\s\S]+?))?\s+for\s+(?:([$\w][$\w]*)|(?:\(\s*([$\w][$\w]*)\s*,\s*([$\w][$\w]*)\s*\)))\s+in\s+([\s\S]+?)(?:\s+track\s+by\s+([\s\S]+?))?$/;
  // 1: value expression (valueFn)
  // 2: label expression (displayFn)
  // 3: group by expression (groupByFn)
  // 4: disable when expression (disableWhenFn)
  // 5: array item variable name
  // 6: object item key variable name
  // 7: object item value variable name
  // 8: collection expression
  // 9: track by expression
  /* eslint-enable */

  var ngOptionsDirective = ['$compile', '$document', '$parse', function ($compile, $document, $parse) {
    function parseOptionsExpression(optionsExp, selectElement, scope) {
      var match = optionsExp.match(NG_OPTIONS_REGEXP);
      if (!match) {
        throw ngOptionsMinErr('iexp', 'Expected expression in form of ' + '\'_select_ (as _label_)? for (_key_,)?_value_ in _collection_\'' + ' but got \'{0}\'. Element: {1}', optionsExp, startingTag(selectElement));
      }

      // Extract the parts from the ngOptions expression

      // The variable name for the value of the item in the collection
      var valueName = match[5] || match[7];
      // The variable name for the key of the item in the collection
      var keyName = match[6];

      // An expression that generates the viewValue for an option if there is a label expression
      var selectAs = / as /.test(match[0]) && match[1];
      // An expression that is used to track the id of each object in the options collection
      var trackBy = match[9];
      // An expression that generates the viewValue for an option if there is no label expression
      var valueFn = $parse(match[2] ? match[1] : valueName);
      var selectAsFn = selectAs && $parse(selectAs);
      var viewValueFn = selectAsFn || valueFn;
      var trackByFn = trackBy && $parse(trackBy);

      // Get the value by which we are going to track the option
      // if we have a trackFn then use that (passing scope and locals)
      // otherwise just hash the given viewValue
      var getTrackByValueFn = trackBy ? function (value, locals) {
        return trackByFn(scope, locals);
      } : function getHashOfValue(value) {
        return hashKey(value);
      };
      var getTrackByValue = function getTrackByValue(value, key) {
        return getTrackByValueFn(value, getLocals(value, key));
      };
      var displayFn = $parse(match[2] || match[1]);
      var groupByFn = $parse(match[3] || '');
      var disableWhenFn = $parse(match[4] || '');
      var valuesFn = $parse(match[8]);
      var locals = {};
      var getLocals = keyName ? function (value, key) {
        locals[keyName] = key;
        locals[valueName] = value;
        return locals;
      } : function (value) {
        locals[valueName] = value;
        return locals;
      };
      function Option(selectValue, viewValue, label, group, disabled) {
        this.selectValue = selectValue;
        this.viewValue = viewValue;
        this.label = label;
        this.group = group;
        this.disabled = disabled;
      }
      function getOptionValuesKeys(optionValues) {
        var optionValuesKeys;
        if (!keyName && isArrayLike(optionValues)) {
          optionValuesKeys = optionValues;
        } else {
          // if object, extract keys, in enumeration order, unsorted
          optionValuesKeys = [];
          for (var itemKey in optionValues) {
            if (optionValues.hasOwnProperty(itemKey) && itemKey.charAt(0) !== '$') {
              optionValuesKeys.push(itemKey);
            }
          }
        }
        return optionValuesKeys;
      }
      return {
        trackBy: trackBy,
        getTrackByValue: getTrackByValue,
        getWatchables: $parse(valuesFn, function (optionValues) {
          // Create a collection of things that we would like to watch (watchedArray)
          // so that they can all be watched using a single $watchCollection
          // that only runs the handler once if anything changes
          var watchedArray = [];
          optionValues = optionValues || [];
          var optionValuesKeys = getOptionValuesKeys(optionValues);
          var optionValuesLength = optionValuesKeys.length;
          for (var index = 0; index < optionValuesLength; index++) {
            var key = optionValues === optionValuesKeys ? index : optionValuesKeys[index];
            var value = optionValues[key];
            var locals = getLocals(value, key);
            var selectValue = getTrackByValueFn(value, locals);
            watchedArray.push(selectValue);

            // Only need to watch the displayFn if there is a specific label expression
            if (match[2] || match[1]) {
              var label = displayFn(scope, locals);
              watchedArray.push(label);
            }

            // Only need to watch the disableWhenFn if there is a specific disable expression
            if (match[4]) {
              var disableWhen = disableWhenFn(scope, locals);
              watchedArray.push(disableWhen);
            }
          }
          return watchedArray;
        }),
        getOptions: function getOptions() {
          var optionItems = [];
          var selectValueMap = {};

          // The option values were already computed in the `getWatchables` fn,
          // which must have been called to trigger `getOptions`
          var optionValues = valuesFn(scope) || [];
          var optionValuesKeys = getOptionValuesKeys(optionValues);
          var optionValuesLength = optionValuesKeys.length;
          for (var index = 0; index < optionValuesLength; index++) {
            var key = optionValues === optionValuesKeys ? index : optionValuesKeys[index];
            var value = optionValues[key];
            var locals = getLocals(value, key);
            var viewValue = viewValueFn(scope, locals);
            var selectValue = getTrackByValueFn(viewValue, locals);
            var label = displayFn(scope, locals);
            var group = groupByFn(scope, locals);
            var disabled = disableWhenFn(scope, locals);
            var optionItem = new Option(selectValue, viewValue, label, group, disabled);
            optionItems.push(optionItem);
            selectValueMap[selectValue] = optionItem;
          }
          return {
            items: optionItems,
            selectValueMap: selectValueMap,
            getOptionFromViewValue: function getOptionFromViewValue(value) {
              return selectValueMap[getTrackByValue(value)];
            },
            getViewValueFromOption: function getViewValueFromOption(option) {
              // If the viewValue could be an object that may be mutated by the application,
              // we need to make a copy and not return the reference to the value on the option.
              return trackBy ? copy(option.viewValue) : option.viewValue;
            }
          };
        }
      };
    }

    // Support: IE 9 only
    // We can't just jqLite('<option>') since jqLite is not smart enough
    // to create it in <select> and IE barfs otherwise.
    var optionTemplate = window.document.createElement('option'),
      optGroupTemplate = window.document.createElement('optgroup');
    function ngOptionsPostLink(scope, selectElement, attr, ctrls) {
      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];
      var multiple = attr.multiple;

      // The emptyOption allows the application developer to provide their own custom "empty"
      // option when the viewValue does not match any of the option values.
      for (var i = 0, children = selectElement.children(), ii = children.length; i < ii; i++) {
        if (children[i].value === '') {
          selectCtrl.hasEmptyOption = true;
          selectCtrl.emptyOption = children.eq(i);
          break;
        }
      }

      // The empty option will be compiled and rendered before we first generate the options
      selectElement.empty();
      var providedEmptyOption = !!selectCtrl.emptyOption;
      var unknownOption = jqLite(optionTemplate.cloneNode(false));
      unknownOption.val('?');
      var options;
      var ngOptions = parseOptionsExpression(attr.ngOptions, selectElement, scope);
      // This stores the newly created options before they are appended to the select.
      // Since the contents are removed from the fragment when it is appended,
      // we only need to create it once.
      var listFragment = $document[0].createDocumentFragment();

      // Overwrite the implementation. ngOptions doesn't use hashes
      selectCtrl.generateUnknownOptionValue = function (val) {
        return '?';
      };

      // Update the controller methods for multiple selectable options
      if (!multiple) {
        selectCtrl.writeValue = function writeNgOptionsValue(value) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;
          var selectedOption = selectElement[0].options[selectElement[0].selectedIndex];
          var option = options.getOptionFromViewValue(value);

          // Make sure to remove the selected attribute from the previously selected option
          // Otherwise, screen readers might get confused
          if (selectedOption) selectedOption.removeAttribute('selected');
          if (option) {
            // Don't update the option when it is already selected.
            // For example, the browser will select the first option by default. In that case,
            // most properties are set automatically - except the `selected` attribute, which we
            // set always

            if (selectElement[0].value !== option.selectValue) {
              selectCtrl.removeUnknownOption();
              selectElement[0].value = option.selectValue;
              option.element.selected = true;
            }
            option.element.setAttribute('selected', 'selected');
          } else {
            selectCtrl.selectUnknownOrEmptyOption(value);
          }
        };
        selectCtrl.readValue = function readNgOptionsValue() {
          var selectedOption = options.selectValueMap[selectElement.val()];
          if (selectedOption && !selectedOption.disabled) {
            selectCtrl.unselectEmptyOption();
            selectCtrl.removeUnknownOption();
            return options.getViewValueFromOption(selectedOption);
          }
          return null;
        };

        // If we are using `track by` then we must watch the tracked value on the model
        // since ngModel only watches for object identity change
        // FIXME: When a user selects an option, this watch will fire needlessly
        if (ngOptions.trackBy) {
          scope.$watch(function () {
            return ngOptions.getTrackByValue(ngModelCtrl.$viewValue);
          }, function () {
            ngModelCtrl.$render();
          });
        }
      } else {
        selectCtrl.writeValue = function writeNgOptionsMultiple(values) {
          // The options might not be defined yet when ngModel tries to render
          if (!options) return;

          // Only set `<option>.selected` if necessary, in order to prevent some browsers from
          // scrolling to `<option>` elements that are outside the `<select>` element's viewport.
          var selectedOptions = values && values.map(getAndUpdateSelectedOption) || [];
          options.items.forEach(function (option) {
            if (option.element.selected && !includes(selectedOptions, option)) {
              option.element.selected = false;
            }
          });
        };
        selectCtrl.readValue = function readNgOptionsMultiple() {
          var selectedValues = selectElement.val() || [],
            selections = [];
          forEach(selectedValues, function (value) {
            var option = options.selectValueMap[value];
            if (option && !option.disabled) selections.push(options.getViewValueFromOption(option));
          });
          return selections;
        };

        // If we are using `track by` then we must watch these tracked values on the model
        // since ngModel only watches for object identity change
        if (ngOptions.trackBy) {
          scope.$watchCollection(function () {
            if (isArray(ngModelCtrl.$viewValue)) {
              return ngModelCtrl.$viewValue.map(function (value) {
                return ngOptions.getTrackByValue(value);
              });
            }
          }, function () {
            ngModelCtrl.$render();
          });
        }
      }
      if (providedEmptyOption) {
        // compile the element since there might be bindings in it
        $compile(selectCtrl.emptyOption)(scope);
        selectElement.prepend(selectCtrl.emptyOption);
        if (selectCtrl.emptyOption[0].nodeType === NODE_TYPE_COMMENT) {
          // This means the empty option has currently no actual DOM node, probably because
          // it has been modified by a transclusion directive.
          selectCtrl.hasEmptyOption = false;

          // Redefine the registerOption function, which will catch
          // options that are added by ngIf etc. (rendering of the node is async because of
          // lazy transclusion)
          selectCtrl.registerOption = function (optionScope, optionEl) {
            if (optionEl.val() === '') {
              selectCtrl.hasEmptyOption = true;
              selectCtrl.emptyOption = optionEl;
              selectCtrl.emptyOption.removeClass('ng-scope');
              // This ensures the new empty option is selected if previously no option was selected
              ngModelCtrl.$render();
              optionEl.on('$destroy', function () {
                var needsRerender = selectCtrl.$isEmptyOptionSelected();
                selectCtrl.hasEmptyOption = false;
                selectCtrl.emptyOption = undefined;
                if (needsRerender) ngModelCtrl.$render();
              });
            }
          };
        } else {
          // remove the class, which is added automatically because we recompile the element and it
          // becomes the compilation root
          selectCtrl.emptyOption.removeClass('ng-scope');
        }
      }

      // We will re-render the option elements if the option values or labels change
      scope.$watchCollection(ngOptions.getWatchables, updateOptions);

      // ------------------------------------------------------------------ //

      function addOptionElement(option, parent) {
        var optionElement = optionTemplate.cloneNode(false);
        parent.appendChild(optionElement);
        updateOptionElement(option, optionElement);
      }
      function getAndUpdateSelectedOption(viewValue) {
        var option = options.getOptionFromViewValue(viewValue);
        var element = option && option.element;
        if (element && !element.selected) element.selected = true;
        return option;
      }
      function updateOptionElement(option, element) {
        option.element = element;
        element.disabled = option.disabled;
        // Support: IE 11 only, Edge 12-13 only
        // NOTE: The label must be set before the value, otherwise IE 11 & Edge create unresponsive
        // selects in certain circumstances when multiple selects are next to each other and display
        // the option list in listbox style, i.e. the select is [multiple], or specifies a [size].
        // See https://github.com/angular/angular.js/issues/11314 for more info.
        // This is unfortunately untestable with unit / e2e tests
        if (option.label !== element.label) {
          element.label = option.label;
          element.textContent = option.label;
        }
        element.value = option.selectValue;
      }
      function updateOptions() {
        var previousValue = options && selectCtrl.readValue();

        // We must remove all current options, but cannot simply set innerHTML = null
        // since the providedEmptyOption might have an ngIf on it that inserts comments which we
        // must preserve.
        // Instead, iterate over the current option elements and remove them or their optgroup
        // parents
        if (options) {
          for (var i = options.items.length - 1; i >= 0; i--) {
            var option = options.items[i];
            if (isDefined(option.group)) {
              jqLiteRemove(option.element.parentNode);
            } else {
              jqLiteRemove(option.element);
            }
          }
        }
        options = ngOptions.getOptions();
        var groupElementMap = {};
        options.items.forEach(function addOption(option) {
          var groupElement;
          if (isDefined(option.group)) {
            // This option is to live in a group
            // See if we have already created this group
            groupElement = groupElementMap[option.group];
            if (!groupElement) {
              groupElement = optGroupTemplate.cloneNode(false);
              listFragment.appendChild(groupElement);

              // Update the label on the group element
              // "null" is special cased because of Safari
              groupElement.label = option.group === null ? 'null' : option.group;

              // Store it for use later
              groupElementMap[option.group] = groupElement;
            }
            addOptionElement(option, groupElement);
          } else {
            // This option is not in a group
            addOptionElement(option, listFragment);
          }
        });
        selectElement[0].appendChild(listFragment);
        ngModelCtrl.$render();

        // Check to see if the value has changed due to the update to the options
        if (!ngModelCtrl.$isEmpty(previousValue)) {
          var nextValue = selectCtrl.readValue();
          var isNotPrimitive = ngOptions.trackBy || multiple;
          if (isNotPrimitive ? !equals(previousValue, nextValue) : previousValue !== nextValue) {
            ngModelCtrl.$setViewValue(nextValue);
            ngModelCtrl.$render();
          }
        }
      }
    }
    return {
      restrict: 'A',
      terminal: true,
      require: ['select', 'ngModel'],
      link: {
        pre: function ngOptionsPreLink(scope, selectElement, attr, ctrls) {
          // Deactivate the SelectController.register method to prevent
          // option directives from accidentally registering themselves
          // (and unwanted $destroy handlers etc.)
          ctrls[0].registerOption = noop;
        },
        post: ngOptionsPostLink
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngPluralize
   * @restrict EA
   *
   * @description
   * `ngPluralize` is a directive that displays messages according to en-US localization rules.
   * These rules are bundled with angular.js, but can be overridden
   * (see {@link guide/i18n AngularJS i18n} dev guide). You configure ngPluralize directive
   * by specifying the mappings between
   * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
   * and the strings to be displayed.
   *
   * ## Plural categories and explicit number rules
   * There are two
   * [plural categories](http://unicode.org/repos/cldr-tmp/trunk/diff/supplemental/language_plural_rules.html)
   * in AngularJS's default en-US locale: "one" and "other".
   *
   * While a plural category may match many numbers (for example, in en-US locale, "other" can match
   * any number that is not 1), an explicit number rule can only match one number. For example, the
   * explicit number rule for "3" matches the number 3. There are examples of plural categories
   * and explicit number rules throughout the rest of this documentation.
   *
   * ## Configuring ngPluralize
   * You configure ngPluralize by providing 2 attributes: `count` and `when`.
   * You can also provide an optional attribute, `offset`.
   *
   * The value of the `count` attribute can be either a string or an {@link guide/expression
   * AngularJS expression}; these are evaluated on the current scope for its bound value.
   *
   * The `when` attribute specifies the mappings between plural categories and the actual
   * string to be displayed. The value of the attribute should be a JSON object.
   *
   * The following example shows how to configure ngPluralize:
   *
   * ```html
   * <ng-pluralize count="personCount"
                   when="{'0': 'Nobody is viewing.',
   *                      'one': '1 person is viewing.',
   *                      'other': '{} people are viewing.'}">
   * </ng-pluralize>
   *```
   *
   * In the example, `"0: Nobody is viewing."` is an explicit number rule. If you did not
   * specify this rule, 0 would be matched to the "other" category and "0 people are viewing"
   * would be shown instead of "Nobody is viewing". You can specify an explicit number rule for
   * other numbers, for example 12, so that instead of showing "12 people are viewing", you can
   * show "a dozen people are viewing".
   *
   * You can use a set of closed braces (`{}`) as a placeholder for the number that you want substituted
   * into pluralized strings. In the previous example, AngularJS will replace `{}` with
   * <span ng-non-bindable>`{{personCount}}`</span>. The closed braces `{}` is a placeholder
   * for <span ng-non-bindable>{{numberExpression}}</span>.
   *
   * If no rule is defined for a category, then an empty string is displayed and a warning is generated.
   * Note that some locales define more categories than `one` and `other`. For example, fr-fr defines `few` and `many`.
   *
   * ## Configuring ngPluralize with offset
   * The `offset` attribute allows further customization of pluralized text, which can result in
   * a better user experience. For example, instead of the message "4 people are viewing this document",
   * you might display "John, Kate and 2 others are viewing this document".
   * The offset attribute allows you to offset a number by any desired value.
   * Let's take a look at an example:
   *
   * ```html
   * <ng-pluralize count="personCount" offset=2
   *               when="{'0': 'Nobody is viewing.',
   *                      '1': '{{person1}} is viewing.',
   *                      '2': '{{person1}} and {{person2}} are viewing.',
   *                      'one': '{{person1}}, {{person2}} and one other person are viewing.',
   *                      'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
   * </ng-pluralize>
   * ```
   *
   * Notice that we are still using two plural categories(one, other), but we added
   * three explicit number rules 0, 1 and 2.
   * When one person, perhaps John, views the document, "John is viewing" will be shown.
   * When three people view the document, no explicit number rule is found, so
   * an offset of 2 is taken off 3, and AngularJS uses 1 to decide the plural category.
   * In this case, plural category 'one' is matched and "John, Mary and one other person are viewing"
   * is shown.
   *
   * Note that when you specify offsets, you must provide explicit number rules for
   * numbers from 0 up to and including the offset. If you use an offset of 3, for example,
   * you must provide explicit number rules for 0, 1, 2 and 3. You must also provide plural strings for
   * plural categories "one" and "other".
   *
   * @param {string|expression} count The variable to be bound to.
   * @param {string} when The mapping between plural category to its corresponding strings.
   * @param {number=} offset Offset to deduct from the total number.
   *
   * @example
      <example module="pluralizeExample" name="ng-pluralize">
        <file name="index.html">
          <script>
            angular.module('pluralizeExample', [])
              .controller('ExampleController', ['$scope', function($scope) {
                $scope.person1 = 'Igor';
                $scope.person2 = 'Misko';
                $scope.personCount = 1;
              }]);
          </script>
          <div ng-controller="ExampleController">
            <label>Person 1:<input type="text" ng-model="person1" value="Igor" /></label><br/>
            <label>Person 2:<input type="text" ng-model="person2" value="Misko" /></label><br/>
            <label>Number of People:<input type="text" ng-model="personCount" value="1" /></label><br/>
  
            <!--- Example with simple pluralization rules for en locale --->
            Without Offset:
            <ng-pluralize count="personCount"
                          when="{'0': 'Nobody is viewing.',
                                 'one': '1 person is viewing.',
                                 'other': '{} people are viewing.'}">
            </ng-pluralize><br>
  
            <!--- Example with offset --->
            With Offset(2):
            <ng-pluralize count="personCount" offset=2
                          when="{'0': 'Nobody is viewing.',
                                 '1': '{{person1}} is viewing.',
                                 '2': '{{person1}} and {{person2}} are viewing.',
                                 'one': '{{person1}}, {{person2}} and one other person are viewing.',
                                 'other': '{{person1}}, {{person2}} and {} other people are viewing.'}">
            </ng-pluralize>
          </div>
        </file>
        <file name="protractor.js" type="protractor">
          it('should show correct pluralized string', function() {
            var withoutOffset = element.all(by.css('ng-pluralize')).get(0);
            var withOffset = element.all(by.css('ng-pluralize')).get(1);
            var countInput = element(by.model('personCount'));
  
            expect(withoutOffset.getText()).toEqual('1 person is viewing.');
            expect(withOffset.getText()).toEqual('Igor is viewing.');
  
            countInput.clear();
            countInput.sendKeys('0');
  
            expect(withoutOffset.getText()).toEqual('Nobody is viewing.');
            expect(withOffset.getText()).toEqual('Nobody is viewing.');
  
            countInput.clear();
            countInput.sendKeys('2');
  
            expect(withoutOffset.getText()).toEqual('2 people are viewing.');
            expect(withOffset.getText()).toEqual('Igor and Misko are viewing.');
  
            countInput.clear();
            countInput.sendKeys('3');
  
            expect(withoutOffset.getText()).toEqual('3 people are viewing.');
            expect(withOffset.getText()).toEqual('Igor, Misko and one other person are viewing.');
  
            countInput.clear();
            countInput.sendKeys('4');
  
            expect(withoutOffset.getText()).toEqual('4 people are viewing.');
            expect(withOffset.getText()).toEqual('Igor, Misko and 2 other people are viewing.');
          });
          it('should show data-bound names', function() {
            var withOffset = element.all(by.css('ng-pluralize')).get(1);
            var personCount = element(by.model('personCount'));
            var person1 = element(by.model('person1'));
            var person2 = element(by.model('person2'));
            personCount.clear();
            personCount.sendKeys('4');
            person1.clear();
            person1.sendKeys('Di');
            person2.clear();
            person2.sendKeys('Vojta');
            expect(withOffset.getText()).toEqual('Di, Vojta and 2 other people are viewing.');
          });
        </file>
      </example>
   */
  var ngPluralizeDirective = ['$locale', '$interpolate', '$log', function ($locale, $interpolate, $log) {
    var BRACE = /{}/g,
      IS_WHEN = /^when(Minus)?(.+)$/;
    return {
      link: function link(scope, element, attr) {
        var numberExp = attr.count,
          whenExp = attr.$attr.when && element.attr(attr.$attr.when),
          // we have {{}} in attrs
          offset = attr.offset || 0,
          whens = scope.$eval(whenExp) || {},
          whensExpFns = {},
          startSymbol = $interpolate.startSymbol(),
          endSymbol = $interpolate.endSymbol(),
          braceReplacement = startSymbol + numberExp + '-' + offset + endSymbol,
          watchRemover = angular.noop,
          lastCount;
        forEach(attr, function (expression, attributeName) {
          var tmpMatch = IS_WHEN.exec(attributeName);
          if (tmpMatch) {
            var whenKey = (tmpMatch[1] ? '-' : '') + lowercase(tmpMatch[2]);
            whens[whenKey] = element.attr(attr.$attr[attributeName]);
          }
        });
        forEach(whens, function (expression, key) {
          whensExpFns[key] = $interpolate(expression.replace(BRACE, braceReplacement));
        });
        scope.$watch(numberExp, function ngPluralizeWatchAction(newVal) {
          var count = parseFloat(newVal);
          var countIsNaN = isNumberNaN(count);
          if (!countIsNaN && !(count in whens)) {
            // If an explicit number rule such as 1, 2, 3... is defined, just use it.
            // Otherwise, check it against pluralization rules in $locale service.
            count = $locale.pluralCat(count - offset);
          }

          // If both `count` and `lastCount` are NaN, we don't need to re-register a watch.
          // In JS `NaN !== NaN`, so we have to explicitly check.
          if (count !== lastCount && !(countIsNaN && isNumberNaN(lastCount))) {
            watchRemover();
            var whenExpFn = whensExpFns[count];
            if (isUndefined(whenExpFn)) {
              if (newVal != null) {
                $log.debug('ngPluralize: no rule defined for \'' + count + '\' in ' + whenExp);
              }
              watchRemover = noop;
              updateElementText();
            } else {
              watchRemover = scope.$watch(whenExpFn, updateElementText);
            }
            lastCount = count;
          }
        });
        function updateElementText(newText) {
          element.text(newText || '');
        }
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngRef
   * @restrict A
   *
   * @description
   * The `ngRef` attribute tells AngularJS to assign the controller of a component (or a directive)
   * to the given property in the current scope. It is also possible to add the jqlite-wrapped DOM
   * element to the scope.
   *
   * If the element with `ngRef` is destroyed `null` is assigned to the property.
   *
   * Note that if you want to assign from a child into the parent scope, you must initialize the
   * target property on the parent scope, otherwise `ngRef` will assign on the child scope.
   * This commonly happens when assigning elements or components wrapped in {@link ngIf} or
   * {@link ngRepeat}. See the second example below.
   *
   *
   * @element ANY
   * @param {string} ngRef property name - A valid AngularJS expression identifier to which the
   *                       controller or jqlite-wrapped DOM element will be bound.
   * @param {string=} ngRefRead read value - The name of a directive (or component) on this element,
   *                            or the special string `$element`. If a name is provided, `ngRef` will
   *                            assign the matching controller. If `$element` is provided, the element
   *                            itself is assigned (even if a controller is available).
   *
   *
   * @example
   * ### Simple toggle
   * This example shows how the controller of the component toggle
   * is reused in the template through the scope to use its logic.
   * <example name="ng-ref-component" module="myApp">
   *   <file name="index.html">
   *     <my-toggle ng-ref="myToggle"></my-toggle>
   *     <button ng-click="myToggle.toggle()">Toggle</button>
   *     <div ng-show="myToggle.isOpen()">
   *       You are using a component in the same template to show it.
   *     </div>
   *   </file>
   *   <file name="index.js">
   *     angular.module('myApp', [])
   *     .component('myToggle', {
   *       controller: function ToggleController() {
   *         var opened = false;
   *         this.isOpen = function() { return opened; };
   *         this.toggle = function() { opened = !opened; };
   *       }
   *     });
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *      it('should publish the toggle into the scope', function() {
   *        var toggle = element(by.buttonText('Toggle'));
   *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(false);
   *        toggle.click();
   *        expect(toggle.evaluate('myToggle.isOpen()')).toEqual(true);
   *      });
   *   </file>
   * </example>
   *
   * @example
   * ### ngRef inside scopes
   * This example shows how `ngRef` works with child scopes. The `ngRepeat`-ed `myWrapper` components
   * are assigned to the scope of `myRoot`, because the `toggles` property has been initialized.
   * The repeated `myToggle` components are published to the child scopes created by `ngRepeat`.
   * `ngIf` behaves similarly - the assignment of `myToggle` happens in the `ngIf` child scope,
   * because the target property has not been initialized on the `myRoot` component controller.
   *
   * <example name="ng-ref-scopes" module="myApp">
   *   <file name="index.html">
   *     <my-root></my-root>
   *   </file>
   *   <file name="index.js">
   *     angular.module('myApp', [])
   *     .component('myRoot', {
   *       templateUrl: 'root.html',
   *       controller: function() {
   *         this.wrappers = []; // initialize the array so that the wrappers are assigned into the parent scope
   *       }
   *     })
   *     .component('myToggle', {
   *       template: '<strong>myToggle</strong><button ng-click="$ctrl.toggle()" ng-transclude></button>',
   *       transclude: true,
   *       controller: function ToggleController() {
   *         var opened = false;
   *         this.isOpen = function() { return opened; };
   *         this.toggle = function() { opened = !opened; };
   *       }
   *     })
   *     .component('myWrapper', {
   *       transclude: true,
   *       template: '<strong>myWrapper</strong>' +
   *         '<div>ngRepeatToggle.isOpen(): {{$ctrl.ngRepeatToggle.isOpen() | json}}</div>' +
   *         '<my-toggle ng-ref="$ctrl.ngRepeatToggle"><ng-transclude></ng-transclude></my-toggle>'
   *     });
   *   </file>
   *   <file name="root.html">
   *     <strong>myRoot</strong>
   *     <my-toggle ng-ref="$ctrl.outerToggle">Outer Toggle</my-toggle>
   *     <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
   *     <div><em>wrappers assigned to root</em><br>
   *     <div ng-repeat="wrapper in $ctrl.wrappers">
   *       wrapper.ngRepeatToggle.isOpen(): {{wrapper.ngRepeatToggle.isOpen() | json}}
   *     </div>
   *
   *     <ul>
   *       <li ng-repeat="(index, value) in [1,2,3]">
   *         <strong>ngRepeat</strong>
   *         <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
   *         <my-wrapper ng-ref="$ctrl.wrappers[index]">ngRepeat Toggle {{$index + 1}}</my-wrapper>
   *       </li>
   *     </ul>
   *
   *     <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen()}} // This is always undefined because it's
   *       assigned to the child scope created by ngIf.
   *     </div>
   *     <div ng-if="true">
            <strong>ngIf</strong>
   *        <my-toggle ng-ref="ngIfToggle">ngIf Toggle</my-toggle>
   *        <div>ngIfToggle.isOpen(): {{ngIfToggle.isOpen() | json}}</div>
   *        <div>outerToggle.isOpen(): {{$ctrl.outerToggle.isOpen() | json}}</div>
   *     </div>
   *   </file>
   *   <file name="styles.css">
   *     ul {
   *       list-style: none;
   *       padding-left: 0;
   *     }
   *
   *     li[ng-repeat] {
   *       background: lightgreen;
   *       padding: 8px;
   *       margin: 8px;
   *     }
   *
   *     [ng-if] {
   *       background: lightgrey;
   *       padding: 8px;
   *     }
   *
   *     my-root {
   *       background: lightgoldenrodyellow;
   *       padding: 8px;
   *       display: block;
   *     }
   *
   *     my-wrapper {
   *       background: lightsalmon;
   *       padding: 8px;
   *       display: block;
   *     }
   *
   *     my-toggle {
   *       background: lightblue;
   *       padding: 8px;
   *       display: block;
   *     }
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *      var OuterToggle = function() {
   *        this.toggle = function() {
   *          element(by.buttonText('Outer Toggle')).click();
   *        };
   *        this.isOpen = function() {
   *          return element.all(by.binding('outerToggle.isOpen()')).first().getText();
   *        };
   *      };
   *      var NgRepeatToggle = function(i) {
   *        var parent = element.all(by.repeater('(index, value) in [1,2,3]')).get(i - 1);
   *        this.toggle = function() {
   *          element(by.buttonText('ngRepeat Toggle ' + i)).click();
   *        };
   *        this.isOpen = function() {
   *          return parent.element(by.binding('ngRepeatToggle.isOpen() | json')).getText();
   *        };
   *        this.isOuterOpen = function() {
   *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
   *        };
   *      };
   *      var NgRepeatToggles = function() {
   *        var toggles = [1,2,3].map(function(i) { return new NgRepeatToggle(i); });
   *        this.forEach = function(fn) {
   *          toggles.forEach(fn);
   *        };
   *        this.isOuterOpen = function(i) {
   *          return toggles[i - 1].isOuterOpen();
   *        };
   *      };
   *      var NgIfToggle = function() {
   *        var parent = element(by.css('[ng-if]'));
   *        this.toggle = function() {
   *          element(by.buttonText('ngIf Toggle')).click();
   *        };
   *        this.isOpen = function() {
   *          return by.binding('ngIfToggle.isOpen() | json').getText();
   *        };
   *        this.isOuterOpen = function() {
   *          return parent.element(by.binding('outerToggle.isOpen() | json')).getText();
   *        };
   *      };
   *
   *      it('should toggle the outer toggle', function() {
   *        var outerToggle = new OuterToggle();
   *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
   *        outerToggle.toggle();
   *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
   *      });
   *
   *      it('should toggle all outer toggles', function() {
   *        var outerToggle = new OuterToggle();
   *        var repeatToggles = new NgRepeatToggles();
   *        var ifToggle = new NgIfToggle();
   *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): false');
   *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): false');
   *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): false');
   *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): false');
   *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
   *        outerToggle.toggle();
   *        expect(outerToggle.isOpen()).toEqual('outerToggle.isOpen(): true');
   *        expect(repeatToggles.isOuterOpen(1)).toEqual('outerToggle.isOpen(): true');
   *        expect(repeatToggles.isOuterOpen(2)).toEqual('outerToggle.isOpen(): true');
   *        expect(repeatToggles.isOuterOpen(3)).toEqual('outerToggle.isOpen(): true');
   *        expect(ifToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): true');
   *      });
   *
   *      it('should toggle each repeat iteration separately', function() {
   *        var repeatToggles = new NgRepeatToggles();
   *
   *        repeatToggles.forEach(function(repeatToggle) {
   *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): false');
   *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
   *          repeatToggle.toggle();
   *          expect(repeatToggle.isOpen()).toEqual('ngRepeatToggle.isOpen(): true');
   *          expect(repeatToggle.isOuterOpen()).toEqual('outerToggle.isOpen(): false');
   *        });
   *      });
   *   </file>
   * </example>
   *
   */

  var ngRefMinErr = minErr('ngRef');
  var ngRefDirective = ['$parse', function ($parse) {
    return {
      priority: -1,
      // Needed for compatibility with element transclusion on the same element
      restrict: 'A',
      compile: function compile(tElement, tAttrs) {
        // Get the expected controller name, converts <data-some-thing> into "someThing"
        var controllerName = directiveNormalize(nodeName_(tElement));

        // Get the expression for value binding
        var getter = $parse(tAttrs.ngRef);
        var setter = getter.assign || function () {
          throw ngRefMinErr('nonassign', 'Expression in ngRef="{0}" is non-assignable!', tAttrs.ngRef);
        };
        return function (scope, element, attrs) {
          var refValue;
          if (attrs.hasOwnProperty('ngRefRead')) {
            if (attrs.ngRefRead === '$element') {
              refValue = element;
            } else {
              refValue = element.data('$' + attrs.ngRefRead + 'Controller');
              if (!refValue) {
                throw ngRefMinErr('noctrl', 'The controller for ngRefRead="{0}" could not be found on ngRef="{1}"', attrs.ngRefRead, tAttrs.ngRef);
              }
            }
          } else {
            refValue = element.data('$' + controllerName + 'Controller');
          }
          refValue = refValue || element;
          setter(scope, refValue);

          // when the element is removed, remove it (nullify it)
          element.on('$destroy', function () {
            // only remove it if value has not changed,
            // because animations (and other procedures) may duplicate elements
            if (getter(scope) === refValue) {
              setter(scope, null);
            }
          });
        };
      }
    };
  }];

  /* exported ngRepeatDirective */

  /**
   * @ngdoc directive
   * @name ngRepeat
   * @multiElement
   * @restrict A
   *
   * @description
   * The `ngRepeat` directive instantiates a template once per item from a collection. Each template
   * instance gets its own scope, where the given loop variable is set to the current collection item,
   * and `$index` is set to the item index or key.
   *
   * Special properties are exposed on the local scope of each template instance, including:
   *
   * | Variable  | Type            | Details                                                                     |
   * |-----------|-----------------|-----------------------------------------------------------------------------|
   * | `$index`  | {@type number}  | iterator offset of the repeated element (0..length-1)                       |
   * | `$first`  | {@type boolean} | true if the repeated element is first in the iterator.                      |
   * | `$middle` | {@type boolean} | true if the repeated element is between the first and last in the iterator. |
   * | `$last`   | {@type boolean} | true if the repeated element is last in the iterator.                       |
   * | `$even`   | {@type boolean} | true if the iterator position `$index` is even (otherwise false).           |
   * | `$odd`    | {@type boolean} | true if the iterator position `$index` is odd (otherwise false).            |
   *
   * <div class="alert alert-info">
   *   Creating aliases for these properties is possible with {@link ng.directive:ngInit `ngInit`}.
   *   This may be useful when, for instance, nesting ngRepeats.
   * </div>
   *
   *
   * ## Iterating over object properties
   *
   * It is possible to get `ngRepeat` to iterate over the properties of an object using the following
   * syntax:
   *
   * ```js
   * <div ng-repeat="(key, value) in myObj"> ... </div>
   * ```
   *
   * However, there are a few limitations compared to array iteration:
   *
   * - The JavaScript specification does not define the order of keys
   *   returned for an object, so AngularJS relies on the order returned by the browser
   *   when running `for key in myObj`. Browsers generally follow the strategy of providing
   *   keys in the order in which they were defined, although there are exceptions when keys are deleted
   *   and reinstated. See the
   *   [MDN page on `delete` for more info](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Operators/delete#Cross-browser_notes).
   *
   * - `ngRepeat` will silently *ignore* object keys starting with `$`, because
   *   it's a prefix used by AngularJS for public (`$`) and private (`$$`) properties.
   *
   * - The built-in filters {@link ng.orderBy orderBy} and {@link ng.filter filter} do not work with
   *   objects, and will throw an error if used with one.
   *
   * If you are hitting any of these limitations, the recommended workaround is to convert your object into an array
   * that is sorted into the order that you prefer before providing it to `ngRepeat`. You could
   * do this with a filter such as [toArrayFilter](http://ngmodules.org/modules/angular-toArrayFilter)
   * or implement a `$watch` on the object yourself.
   *
   *
   * ## Tracking and Duplicates
   *
   * `ngRepeat` uses {@link $rootScope.Scope#$watchCollection $watchCollection} to detect changes in
   * the collection. When a change happens, `ngRepeat` then makes the corresponding changes to the DOM:
   *
   * * When an item is added, a new instance of the template is added to the DOM.
   * * When an item is removed, its template instance is removed from the DOM.
   * * When items are reordered, their respective templates are reordered in the DOM.
   *
   * To minimize creation of DOM elements, `ngRepeat` uses a function
   * to "keep track" of all items in the collection and their corresponding DOM elements.
   * For example, if an item is added to the collection, `ngRepeat` will know that all other items
   * already have DOM elements, and will not re-render them.
   *
   * All different types of tracking functions, their syntax, and their support for duplicate
   * items in collections can be found in the
   * {@link ngRepeat#ngRepeat-arguments ngRepeat expression description}.
   *
   * <div class="alert alert-success">
   * **Best Practice:** If you are working with objects that have a unique identifier property, you
   * should track by this identifier instead of the object instance,
   * e.g. `item in items track by item.id`.
   * Should you reload your data later, `ngRepeat` will not have to rebuild the DOM elements for items
   * it has already rendered, even if the JavaScript objects in the collection have been substituted
   * for new ones. For large collections, this significantly improves rendering performance.
   * </div>
   *
   * ### Effects of DOM Element re-use
   *
   * When DOM elements are re-used, ngRepeat updates the scope for the element, which will
   * automatically update any active bindings on the template. However, other
   * functionality will not be updated, because the element is not re-created:
   *
   * - Directives are not re-compiled
   * - {@link guide/expression#one-time-binding one-time expressions} on the repeated template are not
   * updated if they have stabilized.
   *
   * The above affects all kinds of element re-use due to tracking, but may be especially visible
   * when tracking by `$index` due to the way ngRepeat re-uses elements.
   *
   * The following example shows the effects of different actions with tracking:
  
    <example module="ngRepeat" name="ngRepeat-tracking" deps="angular-animate.js" animations="true">
      <file name="script.js">
        angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
          var friends = [
            {name:'John', age:25},
            {name:'Mary', age:40},
            {name:'Peter', age:85}
          ];
  
          $scope.removeFirst = function() {
            $scope.friends.shift();
          };
  
          $scope.updateAge = function() {
            $scope.friends.forEach(function(el) {
              el.age = el.age + 5;
            });
          };
  
          $scope.copy = function() {
            $scope.friends = angular.copy($scope.friends);
          };
  
          $scope.reset = function() {
            $scope.friends = angular.copy(friends);
          };
  
          $scope.reset();
        });
      </file>
      <file name="index.html">
        <div ng-controller="repeatController">
          <ol>
            <li>When you click "Update Age", only the first list updates the age, because all others have
            a one-time binding on the age property. If you then click "Copy", the current friend list
            is copied, and now the second list updates the age, because the identity of the collection items
            has changed and the list must be re-rendered. The 3rd and 4th list stay the same, because all the
            items are already known according to their tracking functions.
            </li>
            <li>When you click "Remove First", the 4th list has the wrong age on both remaining items. This is
            due to tracking by $index: when the first collection item is removed, ngRepeat reuses the first
            DOM element for the new first collection item, and so on. Since the age property is one-time
            bound, the value remains from the collection item which was previously at this index.
            </li>
          </ol>
  
          <button ng-click="removeFirst()">Remove First</button>
          <button ng-click="updateAge()">Update Age</button>
          <button ng-click="copy()">Copy</button>
          <br><button ng-click="reset()">Reset List</button>
          <br>
          <code>track by $id(friend)</code> (default):
          <ul class="example-animate-container">
            <li class="animate-repeat" ng-repeat="friend in friends">
              {{friend.name}} is {{friend.age}} years old.
            </li>
          </ul>
          <code>track by $id(friend)</code> (default), with age one-time binding:
          <ul class="example-animate-container">
            <li class="animate-repeat" ng-repeat="friend in friends">
              {{friend.name}} is {{::friend.age}} years old.
            </li>
          </ul>
          <code>track by friend.name</code>, with age one-time binding:
          <ul class="example-animate-container">
            <li class="animate-repeat" ng-repeat="friend in friends track by friend.name">
              {{friend.name}}  is {{::friend.age}} years old.
            </li>
          </ul>
          <code>track by $index</code>, with age one-time binding:
          <ul class="example-animate-container">
            <li class="animate-repeat" ng-repeat="friend in friends track by $index">
              {{friend.name}} is {{::friend.age}} years old.
            </li>
          </ul>
        </div>
      </file>
      <file name="animations.css">
        .example-animate-container {
          background:white;
          border:1px solid black;
          list-style:none;
          margin:0;
          padding:0 10px;
        }
  
        .animate-repeat {
          line-height:30px;
          list-style:none;
          box-sizing:border-box;
        }
  
        .animate-repeat.ng-move,
        .animate-repeat.ng-enter,
        .animate-repeat.ng-leave {
          transition:all linear 0.5s;
        }
  
        .animate-repeat.ng-leave.ng-leave-active,
        .animate-repeat.ng-move,
        .animate-repeat.ng-enter {
          opacity:0;
          max-height:0;
        }
  
        .animate-repeat.ng-leave,
        .animate-repeat.ng-move.ng-move-active,
        .animate-repeat.ng-enter.ng-enter-active {
          opacity:1;
          max-height:30px;
        }
      </file>
    </example>
  
   *
   * ## Special repeat start and end points
   * To repeat a series of elements instead of just one parent element, ngRepeat (as well as other ng directives) supports extending
   * the range of the repeater by defining explicit start and end points by using **ng-repeat-start** and **ng-repeat-end** respectively.
   * The **ng-repeat-start** directive works the same as **ng-repeat**, but will repeat all the HTML code (including the tag it's defined on)
   * up to and including the ending HTML tag where **ng-repeat-end** is placed.
   *
   * The example below makes use of this feature:
   * ```html
   *   <header ng-repeat-start="item in items">
   *     Header {{ item }}
   *   </header>
   *   <div class="body">
   *     Body {{ item }}
   *   </div>
   *   <footer ng-repeat-end>
   *     Footer {{ item }}
   *   </footer>
   * ```
   *
   * And with an input of {@type ['A','B']} for the items variable in the example above, the output will evaluate to:
   * ```html
   *   <header>
   *     Header A
   *   </header>
   *   <div class="body">
   *     Body A
   *   </div>
   *   <footer>
   *     Footer A
   *   </footer>
   *   <header>
   *     Header B
   *   </header>
   *   <div class="body">
   *     Body B
   *   </div>
   *   <footer>
   *     Footer B
   *   </footer>
   * ```
   *
   * The custom start and end points for ngRepeat also support all other HTML directive syntax flavors provided in AngularJS (such
   * as **data-ng-repeat-start**, **x-ng-repeat-start** and **ng:repeat-start**).
   *
   * @animations
   * | Animation                        | Occurs                              |
   * |----------------------------------|-------------------------------------|
   * | {@link ng.$animate#enter enter} | when a new item is added to the list or when an item is revealed after a filter |
   * | {@link ng.$animate#leave leave} | when an item is removed from the list or when an item is filtered out |
   * | {@link ng.$animate#move move } | when an adjacent item is filtered out causing a reorder or when the item contents are reordered |
   *
   * See the example below for defining CSS animations with ngRepeat.
   *
   * @element ANY
   * @scope
   * @priority 1000
   * @param {repeat_expression} ngRepeat The expression indicating how to enumerate a collection. These
   *   formats are currently supported:
   *
   *   * `variable in expression` – where variable is the user defined loop variable and `expression`
   *     is a scope expression giving the collection to enumerate.
   *
   *     For example: `album in artist.albums`.
   *
   *   * `(key, value) in expression` – where `key` and `value` can be any user defined identifiers,
   *     and `expression` is the scope expression giving the collection to enumerate.
   *
   *     For example: `(name, age) in {'adam':10, 'amalie':12}`.
   *
   *   * `variable in expression track by tracking_expression` – You can also provide an optional tracking expression
   *     which can be used to associate the objects in the collection with the DOM elements. If no tracking expression
   *     is specified, ng-repeat associates elements by identity. It is an error to have
   *     more than one tracking expression value resolve to the same key. (This would mean that two distinct objects are
   *     mapped to the same DOM element, which is not possible.)
   *
   *     *Default tracking: $id()*: `item in items` is equivalent to `item in items track by $id(item)`.
   *     This implies that the DOM elements will be associated by item identity in the collection.
   *
   *     The built-in `$id()` function can be used to assign a unique
   *     `$$hashKey` property to each item in the collection. This property is then used as a key to associated DOM elements
   *     with the corresponding item in the collection by identity. Moving the same object would move
   *     the DOM element in the same way in the DOM.
   *     Note that the default id function does not support duplicate primitive values (`number`, `string`),
   *     but supports duplictae non-primitive values (`object`) that are *equal* in shape.
   *
   *     *Custom Expression*: It is possible to use any AngularJS expression to compute the tracking
   *     id, for example with a function, or using a property on the collection items.
   *     `item in items track by item.id` is a typical pattern when the items have a unique identifier,
   *     e.g. database id. In this case the object identity does not matter. Two objects are considered
   *     equivalent as long as their `id` property is same.
   *     Tracking by unique identifier is the most performant way and should be used whenever possible.
   *
   *     *$index*: This special property tracks the collection items by their index, and
   *     re-uses the DOM elements that match that index, e.g. `item in items track by $index`. This can
   *     be used for a performance improvement if no unique identfier is available and the identity of
   *     the collection items cannot be easily computed. It also allows duplicates.
   *
   *     <div class="alert alert-warning">
   *       <strong>Note:</strong> Re-using DOM elements can have unforeseen effects. Read the
   *       {@link ngRepeat#tracking-and-duplicates section on tracking and duplicates} for
   *       more info.
   *     </div>
   *
   *     <div class="alert alert-warning">
   *       <strong>Note:</strong> the `track by` expression must come last - after any filters, and the alias expression:
   *       `item in items | filter:searchText as results  track by item.id`
   *     </div>
   *
   *   * `variable in expression as alias_expression` – You can also provide an optional alias expression which will then store the
   *     intermediate results of the repeater after the filters have been applied. Typically this is used to render a special message
   *     when a filter is active on the repeater, but the filtered result set is empty.
   *
   *     For example: `item in items | filter:x as results` will store the fragment of the repeated items as `results`, but only after
   *     the items have been processed through the filter.
   *
   *     Please note that `as [variable name]` is not an operator but rather a part of ngRepeat
   *     micro-syntax so it can be used only after all filters (and not as operator, inside an expression).
   *
   *     For example: `item in items | filter : x | orderBy : order | limitTo : limit as results track by item.id` .
   *
   * @example
   * This example uses `ngRepeat` to display a list of people. A filter is used to restrict the displayed
   * results by name or by age. New (entering) and removed (leaving) items are animated.
    <example module="ngRepeat" name="ngRepeat" deps="angular-animate.js" animations="true">
      <file name="index.html">
        <div ng-controller="repeatController">
          I have {{friends.length}} friends. They are:
          <input type="search" ng-model="q" placeholder="filter friends..." aria-label="filter friends" />
          <ul class="example-animate-container">
            <li class="animate-repeat" ng-repeat="friend in friends | filter:q as results track by friend.name">
              [{{$index + 1}}] {{friend.name}} who is {{friend.age}} years old.
            </li>
            <li class="animate-repeat" ng-if="results.length === 0">
              <strong>No results found...</strong>
            </li>
          </ul>
        </div>
      </file>
      <file name="script.js">
        angular.module('ngRepeat', ['ngAnimate']).controller('repeatController', function($scope) {
          $scope.friends = [
            {name:'John', age:25, gender:'boy'},
            {name:'Jessie', age:30, gender:'girl'},
            {name:'Johanna', age:28, gender:'girl'},
            {name:'Joy', age:15, gender:'girl'},
            {name:'Mary', age:28, gender:'girl'},
            {name:'Peter', age:95, gender:'boy'},
            {name:'Sebastian', age:50, gender:'boy'},
            {name:'Erika', age:27, gender:'girl'},
            {name:'Patrick', age:40, gender:'boy'},
            {name:'Samantha', age:60, gender:'girl'}
          ];
        });
      </file>
      <file name="animations.css">
        .example-animate-container {
          background:white;
          border:1px solid black;
          list-style:none;
          margin:0;
          padding:0 10px;
        }
  
        .animate-repeat {
          line-height:30px;
          list-style:none;
          box-sizing:border-box;
        }
  
        .animate-repeat.ng-move,
        .animate-repeat.ng-enter,
        .animate-repeat.ng-leave {
          transition:all linear 0.5s;
        }
  
        .animate-repeat.ng-leave.ng-leave-active,
        .animate-repeat.ng-move,
        .animate-repeat.ng-enter {
          opacity:0;
          max-height:0;
        }
  
        .animate-repeat.ng-leave,
        .animate-repeat.ng-move.ng-move-active,
        .animate-repeat.ng-enter.ng-enter-active {
          opacity:1;
          max-height:30px;
        }
      </file>
      <file name="protractor.js" type="protractor">
        var friends = element.all(by.repeater('friend in friends'));
  
        it('should render initial data set', function() {
          expect(friends.count()).toBe(10);
          expect(friends.get(0).getText()).toEqual('[1] John who is 25 years old.');
          expect(friends.get(1).getText()).toEqual('[2] Jessie who is 30 years old.');
          expect(friends.last().getText()).toEqual('[10] Samantha who is 60 years old.');
          expect(element(by.binding('friends.length')).getText())
              .toMatch("I have 10 friends. They are:");
        });
  
         it('should update repeater when filter predicate changes', function() {
           expect(friends.count()).toBe(10);
  
           element(by.model('q')).sendKeys('ma');
  
           expect(friends.count()).toBe(2);
           expect(friends.get(0).getText()).toEqual('[1] Mary who is 28 years old.');
           expect(friends.last().getText()).toEqual('[2] Samantha who is 60 years old.');
         });
        </file>
      </example>
   */
  var ngRepeatDirective = ['$parse', '$animate', '$compile', function ($parse, $animate, $compile) {
    var NG_REMOVED = '$$NG_REMOVED';
    var ngRepeatMinErr = minErr('ngRepeat');
    var updateScope = function updateScope(scope, index, valueIdentifier, value, keyIdentifier, key, arrayLength) {
      // TODO(perf): generate setters to shave off ~40ms or 1-1.5%
      scope[valueIdentifier] = value;
      if (keyIdentifier) scope[keyIdentifier] = key;
      scope.$index = index;
      scope.$first = index === 0;
      scope.$last = index === arrayLength - 1;
      scope.$middle = !(scope.$first || scope.$last);
      // eslint-disable-next-line no-bitwise
      scope.$odd = !(scope.$even = (index & 1) === 0);
    };
    var getBlockStart = function getBlockStart(block) {
      return block.clone[0];
    };
    var getBlockEnd = function getBlockEnd(block) {
      return block.clone[block.clone.length - 1];
    };
    var trackByIdArrayFn = function trackByIdArrayFn($scope, key, value) {
      return hashKey(value);
    };
    var trackByIdObjFn = function trackByIdObjFn($scope, key) {
      return key;
    };
    return {
      restrict: 'A',
      multiElement: true,
      transclude: 'element',
      priority: 1000,
      terminal: true,
      $$tlb: true,
      compile: function ngRepeatCompile($element, $attr) {
        var expression = $attr.ngRepeat;
        var ngRepeatEndComment = $compile.$$createComment('end ngRepeat', expression);
        var match = expression.match(/^\s*([\s\S]+?)\s+in\s+([\s\S]+?)(?:\s+as\s+([\s\S]+?))?(?:\s+track\s+by\s+([\s\S]+?))?\s*$/);
        if (!match) {
          throw ngRepeatMinErr('iexp', 'Expected expression in form of \'_item_ in _collection_[ track by _id_]\' but got \'{0}\'.', expression);
        }
        var lhs = match[1];
        var rhs = match[2];
        var aliasAs = match[3];
        var trackByExp = match[4];
        match = lhs.match(/^(?:(\s*[$\w]+)|\(\s*([$\w]+)\s*,\s*([$\w]+)\s*\))$/);
        if (!match) {
          throw ngRepeatMinErr('iidexp', '\'_item_\' in \'_item_ in _collection_\' should be an identifier or \'(_key_, _value_)\' expression, but got \'{0}\'.', lhs);
        }
        var valueIdentifier = match[3] || match[1];
        var keyIdentifier = match[2];
        if (aliasAs && (!/^[$a-zA-Z_][$a-zA-Z0-9_]*$/.test(aliasAs) || /^(null|undefined|this|\$index|\$first|\$middle|\$last|\$even|\$odd|\$parent|\$root|\$id)$/.test(aliasAs))) {
          throw ngRepeatMinErr('badident', 'alias \'{0}\' is invalid --- must be a valid JS identifier which is not a reserved name.', aliasAs);
        }
        var trackByIdExpFn;
        if (trackByExp) {
          var hashFnLocals = {
            $id: hashKey
          };
          var trackByExpGetter = $parse(trackByExp);
          trackByIdExpFn = function trackByIdExpFn($scope, key, value, index) {
            // assign key, value, and $index to the locals so that they can be used in hash functions
            if (keyIdentifier) hashFnLocals[keyIdentifier] = key;
            hashFnLocals[valueIdentifier] = value;
            hashFnLocals.$index = index;
            return trackByExpGetter($scope, hashFnLocals);
          };
        }
        return function ngRepeatLink($scope, $element, $attr, ctrl, $transclude) {
          // Store a list of elements from previous run. This is a hash where key is the item from the
          // iterator, and the value is objects with following properties.
          //   - scope: bound scope
          //   - clone: previous element.
          //   - index: position
          //
          // We are using no-proto object so that we don't need to guard against inherited props via
          // hasOwnProperty.
          var lastBlockMap = createMap();

          //watch props
          $scope.$watchCollection(rhs, function ngRepeatAction(collection) {
            var index,
              length,
              previousNode = $element[0],
              // node that cloned nodes should be inserted after
              // initialized to the comment node anchor
              nextNode,
              // Same as lastBlockMap but it has the current state. It will become the
              // lastBlockMap on the next iteration.
              nextBlockMap = createMap(),
              collectionLength,
              key,
              value,
              // key/value of iteration
              trackById,
              trackByIdFn,
              collectionKeys,
              block,
              // last object information {scope, element, id}
              nextBlockOrder,
              elementsToRemove;
            if (aliasAs) {
              $scope[aliasAs] = collection;
            }
            if (isArrayLike(collection)) {
              collectionKeys = collection;
              trackByIdFn = trackByIdExpFn || trackByIdArrayFn;
            } else {
              trackByIdFn = trackByIdExpFn || trackByIdObjFn;
              // if object, extract keys, in enumeration order, unsorted
              collectionKeys = [];
              for (var itemKey in collection) {
                if (hasOwnProperty.call(collection, itemKey) && itemKey.charAt(0) !== '$') {
                  collectionKeys.push(itemKey);
                }
              }
            }
            collectionLength = collectionKeys.length;
            nextBlockOrder = new Array(collectionLength);

            // locate existing items
            for (index = 0; index < collectionLength; index++) {
              key = collection === collectionKeys ? index : collectionKeys[index];
              value = collection[key];
              trackById = trackByIdFn($scope, key, value, index);
              if (lastBlockMap[trackById]) {
                // found previously seen block
                block = lastBlockMap[trackById];
                delete lastBlockMap[trackById];
                nextBlockMap[trackById] = block;
                nextBlockOrder[index] = block;
              } else if (nextBlockMap[trackById]) {
                // if collision detected. restore lastBlockMap and throw an error
                forEach(nextBlockOrder, function (block) {
                  if (block && block.scope) lastBlockMap[block.id] = block;
                });
                throw ngRepeatMinErr('dupes', 'Duplicates in a repeater are not allowed. Use \'track by\' expression to specify unique keys. Repeater: {0}, Duplicate key: {1}, Duplicate value: {2}', expression, trackById, value);
              } else {
                // new never before seen block
                nextBlockOrder[index] = {
                  id: trackById,
                  scope: undefined,
                  clone: undefined
                };
                nextBlockMap[trackById] = true;
              }
            }

            // Clear the value property from the hashFnLocals object to prevent a reference to the last value
            // being leaked into the ngRepeatCompile function scope
            if (hashFnLocals) {
              hashFnLocals[valueIdentifier] = undefined;
            }

            // remove leftover items
            for (var blockKey in lastBlockMap) {
              block = lastBlockMap[blockKey];
              elementsToRemove = getBlockNodes(block.clone);
              $animate.leave(elementsToRemove);
              if (elementsToRemove[0].parentNode) {
                // if the element was not removed yet because of pending animation, mark it as deleted
                // so that we can ignore it later
                for (index = 0, length = elementsToRemove.length; index < length; index++) {
                  elementsToRemove[index][NG_REMOVED] = true;
                }
              }
              block.scope.$destroy();
            }

            // we are not using forEach for perf reasons (trying to avoid #call)
            for (index = 0; index < collectionLength; index++) {
              key = collection === collectionKeys ? index : collectionKeys[index];
              value = collection[key];
              block = nextBlockOrder[index];
              if (block.scope) {
                // if we have already seen this object, then we need to reuse the
                // associated scope/element

                nextNode = previousNode;

                // skip nodes that are already pending removal via leave animation
                do {
                  nextNode = nextNode.nextSibling;
                } while (nextNode && nextNode[NG_REMOVED]);
                if (getBlockStart(block) !== nextNode) {
                  // existing item which got moved
                  $animate.move(getBlockNodes(block.clone), null, previousNode);
                }
                previousNode = getBlockEnd(block);
                updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
              } else {
                // new item which we don't know about
                $transclude(function ngRepeatTransclude(clone, scope) {
                  block.scope = scope;
                  // http://jsperf.com/clone-vs-createcomment
                  var endNode = ngRepeatEndComment.cloneNode(false);
                  clone[clone.length++] = endNode;
                  $animate.enter(clone, null, previousNode);
                  previousNode = endNode;
                  // Note: We only need the first/last node of the cloned nodes.
                  // However, we need to keep the reference to the jqlite wrapper as it might be changed later
                  // by a directive with templateUrl when its template arrives.
                  block.clone = clone;
                  nextBlockMap[block.id] = block;
                  updateScope(block.scope, index, valueIdentifier, value, keyIdentifier, key, collectionLength);
                });
              }
            }
            lastBlockMap = nextBlockMap;
          });
        };
      }
    };
  }];
  var NG_HIDE_CLASS = 'ng-hide';
  var NG_HIDE_IN_PROGRESS_CLASS = 'ng-hide-animate';
  /**
   * @ngdoc directive
   * @name ngShow
   * @multiElement
   *
   * @description
   * The `ngShow` directive shows or hides the given HTML element based on the expression provided to
   * the `ngShow` attribute.
   *
   * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
   * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
   * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
   * {@link ng.directive:ngCsp ngCsp}).
   *
   * ```html
   * <!-- when $scope.myValue is truthy (element is visible) -->
   * <div ng-show="myValue"></div>
   *
   * <!-- when $scope.myValue is falsy (element is hidden) -->
   * <div ng-show="myValue" class="ng-hide"></div>
   * ```
   *
   * When the `ngShow` expression evaluates to a falsy value then the `.ng-hide` CSS class is added
   * to the class attribute on the element causing it to become hidden. When truthy, the `.ng-hide`
   * CSS class is removed from the element causing the element not to appear hidden.
   *
   * ## Why is `!important` used?
   *
   * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
   * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
   * simple as changing the display style on a HTML list item would make hidden elements appear
   * visible. This also becomes a bigger issue when dealing with CSS frameworks.
   *
   * By using `!important`, the show and hide behavior will work as expected despite any clash between
   * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
   * developer chooses to override the styling to change how to hide an element then it is just a
   * matter of using `!important` in their own CSS code.
   *
   * ### Overriding `.ng-hide`
   *
   * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
   * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
   * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
   * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
   *
   * ```css
   * .ng-hide:not(.ng-hide-animate) {
   *   /&#42; These are just alternative ways of hiding an element &#42;/
   *   display: block!important;
   *   position: absolute;
   *   top: -9999px;
   *   left: -9999px;
   * }
   * ```
   *
   * By default you don't need to override anything in CSS and the animations will work around the
   * display style.
   *
   * @animations
   * | Animation                                           | Occurs                                                                                                        |
   * |-----------------------------------------------------|---------------------------------------------------------------------------------------------------------------|
   * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngShow` expression evaluates to a non truthy value and just before the contents are set to hidden. |
   * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngShow` expression evaluates to a truthy value and just before contents are set to visible.        |
   *
   * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
   * directive expression is true and false. This system works like the animation system present with
   * `ngClass` except that you must also include the `!important` flag to override the display
   * property so that the elements are not actually hidden during the animation.
   *
   * ```css
   * /&#42; A working example can be found at the bottom of this page. &#42;/
   * .my-element.ng-hide-add, .my-element.ng-hide-remove {
   *   transition: all 0.5s linear;
   * }
   *
   * .my-element.ng-hide-add { ... }
   * .my-element.ng-hide-add.ng-hide-add-active { ... }
   * .my-element.ng-hide-remove { ... }
   * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
   * ```
   *
   * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
   * to block during animation states - ngAnimate will automatically handle the style toggling for you.
   *
   * @element ANY
   * @param {expression} ngShow If the {@link guide/expression expression} is truthy/falsy then the
   *                            element is shown/hidden respectively.
   *
   * @example
   * A simple example, animating the element's opacity:
   *
    <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-simple">
      <file name="index.html">
        Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
        <div class="check-element animate-show-hide" ng-show="checked">
          I show up when your checkbox is checked.
        </div>
      </file>
      <file name="animations.css">
        .animate-show-hide.ng-hide {
          opacity: 0;
        }
  
        .animate-show-hide.ng-hide-add,
        .animate-show-hide.ng-hide-remove {
          transition: all linear 0.5s;
        }
  
        .check-element {
          border: 1px solid black;
          opacity: 1;
          padding: 10px;
        }
      </file>
      <file name="protractor.js" type="protractor">
        it('should check ngShow', function() {
          var checkbox = element(by.model('checked'));
          var checkElem = element(by.css('.check-element'));
  
          expect(checkElem.isDisplayed()).toBe(false);
          checkbox.click();
          expect(checkElem.isDisplayed()).toBe(true);
        });
      </file>
    </example>
   *
   * <hr />
   * @example
   * A more complex example, featuring different show/hide animations:
   *
    <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-show-complex">
      <file name="index.html">
        Show: <input type="checkbox" ng-model="checked" aria-label="Toggle ngShow"><br />
        <div class="check-element funky-show-hide" ng-show="checked">
          I show up when your checkbox is checked.
        </div>
      </file>
      <file name="animations.css">
        body {
          overflow: hidden;
          perspective: 1000px;
        }
  
        .funky-show-hide.ng-hide-add {
          transform: rotateZ(0);
          transform-origin: right;
          transition: all 0.5s ease-in-out;
        }
  
        .funky-show-hide.ng-hide-add.ng-hide-add-active {
          transform: rotateZ(-135deg);
        }
  
        .funky-show-hide.ng-hide-remove {
          transform: rotateY(90deg);
          transform-origin: left;
          transition: all 0.5s ease;
        }
  
        .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
          transform: rotateY(0);
        }
  
        .check-element {
          border: 1px solid black;
          opacity: 1;
          padding: 10px;
        }
      </file>
      <file name="protractor.js" type="protractor">
        it('should check ngShow', function() {
          var checkbox = element(by.model('checked'));
          var checkElem = element(by.css('.check-element'));
  
          expect(checkElem.isDisplayed()).toBe(false);
          checkbox.click();
          expect(checkElem.isDisplayed()).toBe(true);
        });
      </file>
    </example>
   *
   * @knownIssue
   *
   * ### Flickering when using ngShow to toggle between elements
   *
   * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
   * happen that both the element to show and the element to hide are visible for a very short time.
   *
   * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
   * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
   * other browsers.
   *
   * There are several way to mitigate this problem:
   *
   * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
   * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
   * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
   * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
   * - Define an animation on the affected elements.
   */
  var ngShowDirective = ['$animate', function ($animate) {
    return {
      restrict: 'A',
      multiElement: true,
      link: function link(scope, element, attr) {
        scope.$watch(attr.ngShow, function ngShowWatchAction(value) {
          // we're adding a temporary, animation-specific class for ng-hide since this way
          // we can control when the element is actually displayed on screen without having
          // to have a global/greedy CSS selector that breaks when other animations are run.
          // Read: https://github.com/angular/angular.js/issues/9103#issuecomment-58335845
          $animate[value ? 'removeClass' : 'addClass'](element, NG_HIDE_CLASS, {
            tempClasses: NG_HIDE_IN_PROGRESS_CLASS
          });
        });
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngHide
   * @multiElement
   *
   * @description
   * The `ngHide` directive shows or hides the given HTML element based on the expression provided to
   * the `ngHide` attribute.
   *
   * The element is shown or hidden by removing or adding the `.ng-hide` CSS class onto the element.
   * The `.ng-hide` CSS class is predefined in AngularJS and sets the display style to none (using an
   * `!important` flag). For CSP mode please add `angular-csp.css` to your HTML file (see
   * {@link ng.directive:ngCsp ngCsp}).
   *
   * ```html
   * <!-- when $scope.myValue is truthy (element is hidden) -->
   * <div ng-hide="myValue" class="ng-hide"></div>
   *
   * <!-- when $scope.myValue is falsy (element is visible) -->
   * <div ng-hide="myValue"></div>
   * ```
   *
   * When the `ngHide` expression evaluates to a truthy value then the `.ng-hide` CSS class is added
   * to the class attribute on the element causing it to become hidden. When falsy, the `.ng-hide`
   * CSS class is removed from the element causing the element not to appear hidden.
   *
   * ## Why is `!important` used?
   *
   * You may be wondering why `!important` is used for the `.ng-hide` CSS class. This is because the
   * `.ng-hide` selector can be easily overridden by heavier selectors. For example, something as
   * simple as changing the display style on a HTML list item would make hidden elements appear
   * visible. This also becomes a bigger issue when dealing with CSS frameworks.
   *
   * By using `!important`, the show and hide behavior will work as expected despite any clash between
   * CSS selector specificity (when `!important` isn't used with any conflicting styles). If a
   * developer chooses to override the styling to change how to hide an element then it is just a
   * matter of using `!important` in their own CSS code.
   *
   * ### Overriding `.ng-hide`
   *
   * By default, the `.ng-hide` class will style the element with `display: none !important`. If you
   * wish to change the hide behavior with `ngShow`/`ngHide`, you can simply overwrite the styles for
   * the `.ng-hide` CSS class. Note that the selector that needs to be used is actually
   * `.ng-hide:not(.ng-hide-animate)` to cope with extra animation classes that can be added.
   *
   * ```css
   * .ng-hide:not(.ng-hide-animate) {
   *   /&#42; These are just alternative ways of hiding an element &#42;/
   *   display: block!important;
   *   position: absolute;
   *   top: -9999px;
   *   left: -9999px;
   * }
   * ```
   *
   * By default you don't need to override in CSS anything and the animations will work around the
   * display style.
   *
   * @animations
   * | Animation                                           | Occurs                                                                                                     |
   * |-----------------------------------------------------|------------------------------------------------------------------------------------------------------------|
   * | {@link $animate#addClass addClass} `.ng-hide`       | After the `ngHide` expression evaluates to a truthy value and just before the contents are set to hidden.  |
   * | {@link $animate#removeClass removeClass} `.ng-hide` | After the `ngHide` expression evaluates to a non truthy value and just before contents are set to visible. |
   *
   * Animations in `ngShow`/`ngHide` work with the show and hide events that are triggered when the
   * directive expression is true and false. This system works like the animation system present with
   * `ngClass` except that you must also include the `!important` flag to override the display
   * property so that the elements are not actually hidden during the animation.
   *
   * ```css
   * /&#42; A working example can be found at the bottom of this page. &#42;/
   * .my-element.ng-hide-add, .my-element.ng-hide-remove {
   *   transition: all 0.5s linear;
   * }
   *
   * .my-element.ng-hide-add { ... }
   * .my-element.ng-hide-add.ng-hide-add-active { ... }
   * .my-element.ng-hide-remove { ... }
   * .my-element.ng-hide-remove.ng-hide-remove-active { ... }
   * ```
   *
   * Keep in mind that, as of AngularJS version 1.3, there is no need to change the display property
   * to block during animation states - ngAnimate will automatically handle the style toggling for you.
   *
   * @element ANY
   * @param {expression} ngHide If the {@link guide/expression expression} is truthy/falsy then the
   *                            element is hidden/shown respectively.
   *
   * @example
   * A simple example, animating the element's opacity:
   *
    <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-simple">
      <file name="index.html">
        Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
        <div class="check-element animate-show-hide" ng-hide="checked">
          I hide when your checkbox is checked.
        </div>
      </file>
      <file name="animations.css">
        .animate-show-hide.ng-hide {
          opacity: 0;
        }
  
        .animate-show-hide.ng-hide-add,
        .animate-show-hide.ng-hide-remove {
          transition: all linear 0.5s;
        }
  
        .check-element {
          border: 1px solid black;
          opacity: 1;
          padding: 10px;
        }
      </file>
      <file name="protractor.js" type="protractor">
        it('should check ngHide', function() {
          var checkbox = element(by.model('checked'));
          var checkElem = element(by.css('.check-element'));
  
          expect(checkElem.isDisplayed()).toBe(true);
          checkbox.click();
          expect(checkElem.isDisplayed()).toBe(false);
        });
      </file>
    </example>
   *
   * <hr />
   * @example
   * A more complex example, featuring different show/hide animations:
   *
    <example module="ngAnimate" deps="angular-animate.js" animations="true" name="ng-hide-complex">
      <file name="index.html">
        Hide: <input type="checkbox" ng-model="checked" aria-label="Toggle ngHide"><br />
        <div class="check-element funky-show-hide" ng-hide="checked">
          I hide when your checkbox is checked.
        </div>
      </file>
      <file name="animations.css">
        body {
          overflow: hidden;
          perspective: 1000px;
        }
  
        .funky-show-hide.ng-hide-add {
          transform: rotateZ(0);
          transform-origin: right;
          transition: all 0.5s ease-in-out;
        }
  
        .funky-show-hide.ng-hide-add.ng-hide-add-active {
          transform: rotateZ(-135deg);
        }
  
        .funky-show-hide.ng-hide-remove {
          transform: rotateY(90deg);
          transform-origin: left;
          transition: all 0.5s ease;
        }
  
        .funky-show-hide.ng-hide-remove.ng-hide-remove-active {
          transform: rotateY(0);
        }
  
        .check-element {
          border: 1px solid black;
          opacity: 1;
          padding: 10px;
        }
      </file>
      <file name="protractor.js" type="protractor">
        it('should check ngHide', function() {
          var checkbox = element(by.model('checked'));
          var checkElem = element(by.css('.check-element'));
  
          expect(checkElem.isDisplayed()).toBe(true);
          checkbox.click();
          expect(checkElem.isDisplayed()).toBe(false);
        });
      </file>
    </example>
   *
   * @knownIssue
   *
   * ### Flickering when using ngHide to toggle between elements
   *
   * When using {@link ngShow} and / or {@link ngHide} to toggle between elements, it can
   * happen that both the element to show and the element to hide are visible for a very short time.
   *
   * This usually happens when the {@link ngAnimate ngAnimate module} is included, but no actual animations
   * are defined for {@link ngShow} / {@link ngHide}. Internet Explorer is affected more often than
   * other browsers.
   *
   * There are several way to mitigate this problem:
   *
   * - {@link guide/animations#how-to-selectively-enable-disable-and-skip-animations Disable animations on the affected elements}.
   * - Use {@link ngIf} or {@link ngSwitch} instead of {@link ngShow} / {@link ngHide}.
   * - Use the special CSS selector `ng-hide.ng-hide-animate` to set `{display: none}` or similar on the affected elements.
   * - Use `ng-class="{'ng-hide': expression}` instead of instead of {@link ngShow} / {@link ngHide}.
   * - Define an animation on the affected elements.
   */
  var ngHideDirective = ['$animate', function ($animate) {
    return {
      restrict: 'A',
      multiElement: true,
      link: function link(scope, element, attr) {
        scope.$watch(attr.ngHide, function ngHideWatchAction(value) {
          // The comment inside of the ngShowDirective explains why we add and
          // remove a temporary class for the show/hide animation
          $animate[value ? 'addClass' : 'removeClass'](element, NG_HIDE_CLASS, {
            tempClasses: NG_HIDE_IN_PROGRESS_CLASS
          });
        });
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngStyle
   * @restrict AC
   *
   * @description
   * The `ngStyle` directive allows you to set CSS style on an HTML element conditionally.
   *
   * @knownIssue
   * You should not use {@link guide/interpolation interpolation} in the value of the `style`
   * attribute, when using the `ngStyle` directive on the same element.
   * See {@link guide/interpolation#known-issues here} for more info.
   *
   * @element ANY
   * @param {expression} ngStyle
   *
   * {@link guide/expression Expression} which evals to an
   * object whose keys are CSS style names and values are corresponding values for those CSS
   * keys.
   *
   * Since some CSS style names are not valid keys for an object, they must be quoted.
   * See the 'background-color' style in the example below.
   *
   * @example
     <example name="ng-style">
       <file name="index.html">
          <input type="button" value="set color" ng-click="myStyle={color:'red'}">
          <input type="button" value="set background" ng-click="myStyle={'background-color':'blue'}">
          <input type="button" value="clear" ng-click="myStyle={}">
          <br/>
          <span ng-style="myStyle">Sample Text</span>
          <pre>myStyle={{myStyle}}</pre>
       </file>
       <file name="style.css">
         span {
           color: black;
         }
       </file>
       <file name="protractor.js" type="protractor">
         var colorSpan = element(by.css('span'));
  
         it('should check ng-style', function() {
           expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
           element(by.css('input[value=\'set color\']')).click();
           expect(colorSpan.getCssValue('color')).toMatch(/rgba\(255, 0, 0, 1\)|rgb\(255, 0, 0\)/);
           element(by.css('input[value=clear]')).click();
           expect(colorSpan.getCssValue('color')).toMatch(/rgba\(0, 0, 0, 1\)|rgb\(0, 0, 0\)/);
         });
       </file>
     </example>
   */
  var ngStyleDirective = ngDirective(function (scope, element, attr) {
    scope.$watchCollection(attr.ngStyle, function ngStyleWatchAction(newStyles, oldStyles) {
      if (oldStyles && newStyles !== oldStyles) {
        forEach(oldStyles, function (val, style) {
          element.css(style, '');
        });
      }
      if (newStyles) element.css(newStyles);
    });
  });

  /**
   * @ngdoc directive
   * @name ngSwitch
   * @restrict EA
   *
   * @description
   * The `ngSwitch` directive is used to conditionally swap DOM structure on your template based on a scope expression.
   * Elements within `ngSwitch` but without `ngSwitchWhen` or `ngSwitchDefault` directives will be preserved at the location
   * as specified in the template.
   *
   * The directive itself works similar to ngInclude, however, instead of downloading template code (or loading it
   * from the template cache), `ngSwitch` simply chooses one of the nested elements and makes it visible based on which element
   * matches the value obtained from the evaluated expression. In other words, you define a container element
   * (where you place the directive), place an expression on the **`on="..."` attribute**
   * (or the **`ng-switch="..."` attribute**), define any inner elements inside of the directive and place
   * a when attribute per element. The when attribute is used to inform ngSwitch which element to display when the on
   * expression is evaluated. If a matching expression is not found via a when attribute then an element with the default
   * attribute is displayed.
   *
   * <div class="alert alert-info">
   * Be aware that the attribute values to match against cannot be expressions. They are interpreted
   * as literal string values to match against.
   * For example, **`ng-switch-when="someVal"`** will match against the string `"someVal"` not against the
   * value of the expression `$scope.someVal`.
   * </div>
  
   * @animations
   * | Animation                        | Occurs                              |
   * |----------------------------------|-------------------------------------|
   * | {@link ng.$animate#enter enter}  | after the ngSwitch contents change and the matched child element is placed inside the container |
   * | {@link ng.$animate#leave leave}  | after the ngSwitch contents change and just before the former contents are removed from the DOM |
   *
   * @usage
   *
   * ```
   * <ANY ng-switch="expression">
   *   <ANY ng-switch-when="matchValue1">...</ANY>
   *   <ANY ng-switch-when="matchValue2">...</ANY>
   *   <ANY ng-switch-default>...</ANY>
   * </ANY>
   * ```
   *
   *
   * @scope
   * @priority 1200
   * @param {*} ngSwitch|on expression to match against <code>ng-switch-when</code>.
   * On child elements add:
   *
   * * `ngSwitchWhen`: the case statement to match against. If match then this
   *   case will be displayed. If the same match appears multiple times, all the
   *   elements will be displayed. It is possible to associate multiple values to
   *   the same `ngSwitchWhen` by defining the optional attribute
   *   `ngSwitchWhenSeparator`. The separator will be used to split the value of
   *   the `ngSwitchWhen` attribute into multiple tokens, and the element will show
   *   if any of the `ngSwitch` evaluates to any of these tokens.
   * * `ngSwitchDefault`: the default case when no other case match. If there
   *   are multiple default cases, all of them will be displayed when no other
   *   case match.
   *
   *
   * @example
    <example module="switchExample" deps="angular-animate.js" animations="true" name="ng-switch">
      <file name="index.html">
        <div ng-controller="ExampleController">
          <select ng-model="selection" ng-options="item for item in items">
          </select>
          <code>selection={{selection}}</code>
          <hr/>
          <div class="animate-switch-container"
            ng-switch on="selection">
              <div class="animate-switch" ng-switch-when="settings|options" ng-switch-when-separator="|">Settings Div</div>
              <div class="animate-switch" ng-switch-when="home">Home Span</div>
              <div class="animate-switch" ng-switch-default>default</div>
          </div>
        </div>
      </file>
      <file name="script.js">
        angular.module('switchExample', ['ngAnimate'])
          .controller('ExampleController', ['$scope', function($scope) {
            $scope.items = ['settings', 'home', 'options', 'other'];
            $scope.selection = $scope.items[0];
          }]);
      </file>
      <file name="animations.css">
        .animate-switch-container {
          position:relative;
          background:white;
          border:1px solid black;
          height:40px;
          overflow:hidden;
        }
  
        .animate-switch {
          padding:10px;
        }
  
        .animate-switch.ng-animate {
          transition:all cubic-bezier(0.250, 0.460, 0.450, 0.940) 0.5s;
  
          position:absolute;
          top:0;
          left:0;
          right:0;
          bottom:0;
        }
  
        .animate-switch.ng-leave.ng-leave-active,
        .animate-switch.ng-enter {
          top:-50px;
        }
        .animate-switch.ng-leave,
        .animate-switch.ng-enter.ng-enter-active {
          top:0;
        }
      </file>
      <file name="protractor.js" type="protractor">
        var switchElem = element(by.css('[ng-switch]'));
        var select = element(by.model('selection'));
  
        it('should start in settings', function() {
          expect(switchElem.getText()).toMatch(/Settings Div/);
        });
        it('should change to home', function() {
          select.all(by.css('option')).get(1).click();
          expect(switchElem.getText()).toMatch(/Home Span/);
        });
        it('should change to settings via "options"', function() {
          select.all(by.css('option')).get(2).click();
          expect(switchElem.getText()).toMatch(/Settings Div/);
        });
        it('should select default', function() {
          select.all(by.css('option')).get(3).click();
          expect(switchElem.getText()).toMatch(/default/);
        });
      </file>
    </example>
   */
  var ngSwitchDirective = ['$animate', '$compile', function ($animate, $compile) {
    return {
      require: 'ngSwitch',
      // asks for $scope to fool the BC controller module
      controller: ['$scope', function NgSwitchController() {
        this.cases = {};
      }],
      link: function link(scope, element, attr, ngSwitchController) {
        var watchExpr = attr.ngSwitch || attr.on,
          selectedTranscludes = [],
          selectedElements = [],
          previousLeaveAnimations = [],
          selectedScopes = [];
        var spliceFactory = function spliceFactory(array, index) {
          return function (response) {
            if (response !== false) array.splice(index, 1);
          };
        };
        scope.$watch(watchExpr, function ngSwitchWatchAction(value) {
          var i, ii;

          // Start with the last, in case the array is modified during the loop
          while (previousLeaveAnimations.length) {
            $animate.cancel(previousLeaveAnimations.pop());
          }
          for (i = 0, ii = selectedScopes.length; i < ii; ++i) {
            var selected = getBlockNodes(selectedElements[i].clone);
            selectedScopes[i].$destroy();
            var runner = previousLeaveAnimations[i] = $animate.leave(selected);
            runner.done(spliceFactory(previousLeaveAnimations, i));
          }
          selectedElements.length = 0;
          selectedScopes.length = 0;
          if (selectedTranscludes = ngSwitchController.cases['!' + value] || ngSwitchController.cases['?']) {
            forEach(selectedTranscludes, function (selectedTransclude) {
              selectedTransclude.transclude(function (caseElement, selectedScope) {
                selectedScopes.push(selectedScope);
                var anchor = selectedTransclude.element;
                caseElement[caseElement.length++] = $compile.$$createComment('end ngSwitchWhen');
                var block = {
                  clone: caseElement
                };
                selectedElements.push(block);
                $animate.enter(caseElement, anchor.parent(), anchor);
              });
            });
          }
        });
      }
    };
  }];
  var ngSwitchWhenDirective = ngDirective({
    transclude: 'element',
    priority: 1200,
    require: '^ngSwitch',
    multiElement: true,
    link: function link(scope, element, attrs, ctrl, $transclude) {
      var cases = attrs.ngSwitchWhen.split(attrs.ngSwitchWhenSeparator).sort().filter(
      // Filter duplicate cases
      function (element, index, array) {
        return array[index - 1] !== element;
      });
      forEach(cases, function (whenCase) {
        ctrl.cases['!' + whenCase] = ctrl.cases['!' + whenCase] || [];
        ctrl.cases['!' + whenCase].push({
          transclude: $transclude,
          element: element
        });
      });
    }
  });
  var ngSwitchDefaultDirective = ngDirective({
    transclude: 'element',
    priority: 1200,
    require: '^ngSwitch',
    multiElement: true,
    link: function link(scope, element, attr, ctrl, $transclude) {
      ctrl.cases['?'] = ctrl.cases['?'] || [];
      ctrl.cases['?'].push({
        transclude: $transclude,
        element: element
      });
    }
  });

  /**
   * @ngdoc directive
   * @name ngTransclude
   * @restrict EAC
   *
   * @description
   * Directive that marks the insertion point for the transcluded DOM of the nearest parent directive that uses transclusion.
   *
   * You can specify that you want to insert a named transclusion slot, instead of the default slot, by providing the slot name
   * as the value of the `ng-transclude` or `ng-transclude-slot` attribute.
   *
   * If the transcluded content is not empty (i.e. contains one or more DOM nodes, including whitespace text nodes), any existing
   * content of this element will be removed before the transcluded content is inserted.
   * If the transcluded content is empty (or only whitespace), the existing content is left intact. This lets you provide fallback
   * content in the case that no transcluded content is provided.
   *
   * @element ANY
   *
   * @param {string} ngTransclude|ngTranscludeSlot the name of the slot to insert at this point. If this is not provided, is empty
   *                                               or its value is the same as the name of the attribute then the default slot is used.
   *
   * @example
   * ### Basic transclusion
   * This example demonstrates basic transclusion of content into a component directive.
   * <example name="simpleTranscludeExample" module="transcludeExample">
   *   <file name="index.html">
   *     <script>
   *       angular.module('transcludeExample', [])
   *        .directive('pane', function(){
   *           return {
   *             restrict: 'E',
   *             transclude: true,
   *             scope: { title:'@' },
   *             template: '<div style="border: 1px solid black;">' +
   *                         '<div style="background-color: gray">{{title}}</div>' +
   *                         '<ng-transclude></ng-transclude>' +
   *                       '</div>'
   *           };
   *       })
   *       .controller('ExampleController', ['$scope', function($scope) {
   *         $scope.title = 'Lorem Ipsum';
   *         $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
   *       }]);
   *     </script>
   *     <div ng-controller="ExampleController">
   *       <input ng-model="title" aria-label="title"> <br/>
   *       <textarea ng-model="text" aria-label="text"></textarea> <br/>
   *       <pane title="{{title}}"><span>{{text}}</span></pane>
   *     </div>
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *      it('should have transcluded', function() {
   *        var titleElement = element(by.model('title'));
   *        titleElement.clear();
   *        titleElement.sendKeys('TITLE');
   *        var textElement = element(by.model('text'));
   *        textElement.clear();
   *        textElement.sendKeys('TEXT');
   *        expect(element(by.binding('title')).getText()).toEqual('TITLE');
   *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
   *      });
   *   </file>
   * </example>
   *
   * @example
   * ### Transclude fallback content
   * This example shows how to use `NgTransclude` with fallback content, that
   * is displayed if no transcluded content is provided.
   *
   * <example module="transcludeFallbackContentExample" name="ng-transclude">
   * <file name="index.html">
   * <script>
   * angular.module('transcludeFallbackContentExample', [])
   * .directive('myButton', function(){
   *             return {
   *               restrict: 'E',
   *               transclude: true,
   *               scope: true,
   *               template: '<button style="cursor: pointer;">' +
   *                           '<ng-transclude>' +
   *                             '<b style="color: red;">Button1</b>' +
   *                           '</ng-transclude>' +
   *                         '</button>'
   *             };
   *         });
   * </script>
   * <!-- fallback button content -->
   * <my-button id="fallback"></my-button>
   * <!-- modified button content -->
   * <my-button id="modified">
   *   <i style="color: green;">Button2</i>
   * </my-button>
   * </file>
   * <file name="protractor.js" type="protractor">
   * it('should have different transclude element content', function() {
   *          expect(element(by.id('fallback')).getText()).toBe('Button1');
   *          expect(element(by.id('modified')).getText()).toBe('Button2');
   *        });
   * </file>
   * </example>
   *
   * @example
   * ### Multi-slot transclusion
   * This example demonstrates using multi-slot transclusion in a component directive.
   * <example name="multiSlotTranscludeExample" module="multiSlotTranscludeExample">
   *   <file name="index.html">
   *    <style>
   *      .title, .footer {
   *        background-color: gray
   *      }
   *    </style>
   *    <div ng-controller="ExampleController">
   *      <input ng-model="title" aria-label="title"> <br/>
   *      <textarea ng-model="text" aria-label="text"></textarea> <br/>
   *      <pane>
   *        <pane-title><a ng-href="{{link}}">{{title}}</a></pane-title>
   *        <pane-body><p>{{text}}</p></pane-body>
   *      </pane>
   *    </div>
   *   </file>
   *   <file name="app.js">
   *    angular.module('multiSlotTranscludeExample', [])
   *     .directive('pane', function() {
   *        return {
   *          restrict: 'E',
   *          transclude: {
   *            'title': '?paneTitle',
   *            'body': 'paneBody',
   *            'footer': '?paneFooter'
   *          },
   *          template: '<div style="border: 1px solid black;">' +
   *                      '<div class="title" ng-transclude="title">Fallback Title</div>' +
   *                      '<div ng-transclude="body"></div>' +
   *                      '<div class="footer" ng-transclude="footer">Fallback Footer</div>' +
   *                    '</div>'
   *        };
   *    })
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.title = 'Lorem Ipsum';
   *      $scope.link = 'https://google.com';
   *      $scope.text = 'Neque porro quisquam est qui dolorem ipsum quia dolor...';
   *    }]);
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *      it('should have transcluded the title and the body', function() {
   *        var titleElement = element(by.model('title'));
   *        titleElement.clear();
   *        titleElement.sendKeys('TITLE');
   *        var textElement = element(by.model('text'));
   *        textElement.clear();
   *        textElement.sendKeys('TEXT');
   *        expect(element(by.css('.title')).getText()).toEqual('TITLE');
   *        expect(element(by.binding('text')).getText()).toEqual('TEXT');
   *        expect(element(by.css('.footer')).getText()).toEqual('Fallback Footer');
   *      });
   *   </file>
   * </example>
   */
  var ngTranscludeMinErr = minErr('ngTransclude');
  var ngTranscludeDirective = ['$compile', function ($compile) {
    return {
      restrict: 'EAC',
      compile: function ngTranscludeCompile(tElement) {
        // Remove and cache any original content to act as a fallback
        var fallbackLinkFn = $compile(tElement.contents());
        tElement.empty();
        return function ngTranscludePostLink($scope, $element, $attrs, controller, $transclude) {
          if (!$transclude) {
            throw ngTranscludeMinErr('orphan', 'Illegal use of ngTransclude directive in the template! ' + 'No parent directive that requires a transclusion found. ' + 'Element: {0}', startingTag($element));
          }

          // If the attribute is of the form: `ng-transclude="ng-transclude"` then treat it like the default
          if ($attrs.ngTransclude === $attrs.$attr.ngTransclude) {
            $attrs.ngTransclude = '';
          }
          var slotName = $attrs.ngTransclude || $attrs.ngTranscludeSlot;

          // If the slot is required and no transclusion content is provided then this call will throw an error
          $transclude(ngTranscludeCloneAttachFn, null, slotName);

          // If the slot is optional and no transclusion content is provided then use the fallback content
          if (slotName && !$transclude.isSlotFilled(slotName)) {
            useFallbackContent();
          }
          function ngTranscludeCloneAttachFn(clone, transcludedScope) {
            if (clone.length && notWhitespace(clone)) {
              $element.append(clone);
            } else {
              useFallbackContent();
              // There is nothing linked against the transcluded scope since no content was available,
              // so it should be safe to clean up the generated scope.
              transcludedScope.$destroy();
            }
          }
          function useFallbackContent() {
            // Since this is the fallback content rather than the transcluded content,
            // we link against the scope of this directive rather than the transcluded scope
            fallbackLinkFn($scope, function (clone) {
              $element.append(clone);
            });
          }
          function notWhitespace(nodes) {
            for (var i = 0, ii = nodes.length; i < ii; i++) {
              var node = nodes[i];
              if (node.nodeType !== NODE_TYPE_TEXT || node.nodeValue.trim()) {
                return true;
              }
            }
          }
        };
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name script
   * @restrict E
   *
   * @description
   * Load the content of a `<script>` element into {@link ng.$templateCache `$templateCache`}, so that the
   * template can be used by {@link ng.directive:ngInclude `ngInclude`},
   * {@link ngRoute.directive:ngView `ngView`}, or {@link guide/directive directives}. The type of the
   * `<script>` element must be specified as `text/ng-template`, and a cache name for the template must be
   * assigned through the element's `id`, which can then be used as a directive's `templateUrl`.
   *
   * @param {string} type Must be set to `'text/ng-template'`.
   * @param {string} id Cache name of the template.
   *
   * @example
    <example  name="script-tag">
      <file name="index.html">
        <script type="text/ng-template" id="/tpl.html">
          Content of the template.
        </script>
  
        <a ng-click="currentTpl='/tpl.html'" id="tpl-link">Load inlined template</a>
        <div id="tpl-content" ng-include src="currentTpl"></div>
      </file>
      <file name="protractor.js" type="protractor">
        it('should load template defined inside script tag', function() {
          element(by.css('#tpl-link')).click();
          expect(element(by.css('#tpl-content')).getText()).toMatch(/Content of the template/);
        });
      </file>
    </example>
   */
  var scriptDirective = ['$templateCache', function ($templateCache) {
    return {
      restrict: 'E',
      terminal: true,
      compile: function compile(element, attr) {
        if (attr.type === 'text/ng-template') {
          var templateUrl = attr.id,
            text = element[0].text;
          $templateCache.put(templateUrl, text);
        }
      }
    };
  }];

  /* exported selectDirective, optionDirective */

  var noopNgModelController = {
    $setViewValue: noop,
    $render: noop
  };
  function setOptionSelectedStatus(optionEl, value) {
    optionEl.prop('selected', value);
    /**
     * When unselecting an option, setting the property to null / false should be enough
     * However, screenreaders might react to the selected attribute instead, see
     * https://github.com/angular/angular.js/issues/14419
     * Note: "selected" is a boolean attr and will be removed when the "value" arg in attr() is false
     * or null
     */
    optionEl.attr('selected', value);
  }

  /**
   * @ngdoc type
   * @name  select.SelectController
   *
   * @description
   * The controller for the {@link ng.select select} directive. The controller exposes
   * a few utility methods that can be used to augment the behavior of a regular or an
   * {@link ng.ngOptions ngOptions} select element.
   *
   * @example
   * ### Set a custom error when the unknown option is selected
   *
   * This example sets a custom error "unknownValue" on the ngModelController
   * when the select element's unknown option is selected, i.e. when the model is set to a value
   * that is not matched by any option.
   *
   * <example name="select-unknown-value-error" module="staticSelect">
   * <file name="index.html">
   * <div ng-controller="ExampleController">
   *   <form name="myForm">
   *     <label for="testSelect"> Single select: </label><br>
   *     <select name="testSelect" ng-model="selected" unknown-value-error>
   *       <option value="option-1">Option 1</option>
   *       <option value="option-2">Option 2</option>
   *     </select><br>
   *     <span class="error" ng-if="myForm.testSelect.$error.unknownValue">
   *       Error: The current model doesn't match any option</span><br>
   *
   *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
   *   </form>
   * </div>
   * </file>
   * <file name="app.js">
   *  angular.module('staticSelect', [])
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.selected = null;
   *
   *      $scope.forceUnknownOption = function() {
   *        $scope.selected = 'nonsense';
   *      };
   *   }])
   *   .directive('unknownValueError', function() {
   *     return {
   *       require: ['ngModel', 'select'],
   *       link: function(scope, element, attrs, ctrls) {
   *         var ngModelCtrl = ctrls[0];
   *         var selectCtrl = ctrls[1];
   *
   *         ngModelCtrl.$validators.unknownValue = function(modelValue, viewValue) {
   *           if (selectCtrl.$isUnknownOptionSelected()) {
   *             return false;
   *           }
   *
   *           return true;
   *         };
   *       }
   *
   *     };
   *   });
   * </file>
   *</example>
   *
   *
   * @example
   * ### Set the "required" error when the unknown option is selected.
   *
   * By default, the "required" error on the ngModelController is only set on a required select
   * when the empty option is selected. This example adds a custom directive that also sets the
   * error when the unknown option is selected.
   *
   * <example name="select-unknown-value-required" module="staticSelect">
   * <file name="index.html">
   * <div ng-controller="ExampleController">
   *   <form name="myForm">
   *     <label for="testSelect"> Select: </label><br>
   *     <select name="testSelect" ng-model="selected" required unknown-value-required>
   *       <option value="option-1">Option 1</option>
   *       <option value="option-2">Option 2</option>
   *     </select><br>
   *     <span class="error" ng-if="myForm.testSelect.$error.required">Error: Please select a value</span><br>
   *
   *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
   *   </form>
   * </div>
   * </file>
   * <file name="app.js">
   *  angular.module('staticSelect', [])
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.selected = null;
   *
   *      $scope.forceUnknownOption = function() {
   *        $scope.selected = 'nonsense';
   *      };
   *   }])
   *   .directive('unknownValueRequired', function() {
   *     return {
   *       priority: 1, // This directive must run after the required directive has added its validator
   *       require: ['ngModel', 'select'],
   *       link: function(scope, element, attrs, ctrls) {
   *         var ngModelCtrl = ctrls[0];
   *         var selectCtrl = ctrls[1];
   *
   *         var originalRequiredValidator = ngModelCtrl.$validators.required;
   *
   *         ngModelCtrl.$validators.required = function() {
   *           if (attrs.required && selectCtrl.$isUnknownOptionSelected()) {
   *             return false;
   *           }
   *
   *           return originalRequiredValidator.apply(this, arguments);
   *         };
   *       }
   *     };
   *   });
   * </file>
   * <file name="protractor.js" type="protractor">
   *  it('should show the error message when the unknown option is selected', function() {
  
        var error = element(by.className('error'));
  
        expect(error.getText()).toBe('Error: Please select a value');
  
        element(by.cssContainingText('option', 'Option 1')).click();
  
        expect(error.isPresent()).toBe(false);
  
        element(by.tagName('button')).click();
  
        expect(error.getText()).toBe('Error: Please select a value');
      });
   * </file>
   *</example>
   *
   *
   */
  var SelectController = ['$element', '$scope', /** @this */function ($element, $scope) {
    var self = this,
      optionsMap = new NgMap();
    self.selectValueMap = {}; // Keys are the hashed values, values the original values

    // If the ngModel doesn't get provided then provide a dummy noop version to prevent errors
    self.ngModelCtrl = noopNgModelController;
    self.multiple = false;

    // The "unknown" option is one that is prepended to the list if the viewValue
    // does not match any of the options. When it is rendered the value of the unknown
    // option is '? XXX ?' where XXX is the hashKey of the value that is not known.
    //
    // Support: IE 9 only
    // We can't just jqLite('<option>') since jqLite is not smart enough
    // to create it in <select> and IE barfs otherwise.
    self.unknownOption = jqLite(window.document.createElement('option'));

    // The empty option is an option with the value '' that the application developer can
    // provide inside the select. It is always selectable and indicates that a "null" selection has
    // been made by the user.
    // If the select has an empty option, and the model of the select is set to "undefined" or "null",
    // the empty option is selected.
    // If the model is set to a different unmatched value, the unknown option is rendered and
    // selected, i.e both are present, because a "null" selection and an unknown value are different.
    self.hasEmptyOption = false;
    self.emptyOption = undefined;
    self.renderUnknownOption = function (val) {
      var unknownVal = self.generateUnknownOptionValue(val);
      self.unknownOption.val(unknownVal);
      $element.prepend(self.unknownOption);
      setOptionSelectedStatus(self.unknownOption, true);
      $element.val(unknownVal);
    };
    self.updateUnknownOption = function (val) {
      var unknownVal = self.generateUnknownOptionValue(val);
      self.unknownOption.val(unknownVal);
      setOptionSelectedStatus(self.unknownOption, true);
      $element.val(unknownVal);
    };
    self.generateUnknownOptionValue = function (val) {
      return '? ' + hashKey(val) + ' ?';
    };
    self.removeUnknownOption = function () {
      if (self.unknownOption.parent()) self.unknownOption.remove();
    };
    self.selectEmptyOption = function () {
      if (self.emptyOption) {
        $element.val('');
        setOptionSelectedStatus(self.emptyOption, true);
      }
    };
    self.unselectEmptyOption = function () {
      if (self.hasEmptyOption) {
        setOptionSelectedStatus(self.emptyOption, false);
      }
    };
    $scope.$on('$destroy', function () {
      // disable unknown option so that we don't do work when the whole select is being destroyed
      self.renderUnknownOption = noop;
    });

    // Read the value of the select control, the implementation of this changes depending
    // upon whether the select can have multiple values and whether ngOptions is at work.
    self.readValue = function readSingleValue() {
      var val = $element.val();
      // ngValue added option values are stored in the selectValueMap, normal interpolations are not
      var realVal = val in self.selectValueMap ? self.selectValueMap[val] : val;
      if (self.hasOption(realVal)) {
        return realVal;
      }
      return null;
    };

    // Write the value to the select control, the implementation of this changes depending
    // upon whether the select can have multiple values and whether ngOptions is at work.
    self.writeValue = function writeSingleValue(value) {
      // Make sure to remove the selected attribute from the previously selected option
      // Otherwise, screen readers might get confused
      var currentlySelectedOption = $element[0].options[$element[0].selectedIndex];
      if (currentlySelectedOption) setOptionSelectedStatus(jqLite(currentlySelectedOption), false);
      if (self.hasOption(value)) {
        self.removeUnknownOption();
        var hashedVal = hashKey(value);
        $element.val(hashedVal in self.selectValueMap ? hashedVal : value);

        // Set selected attribute and property on selected option for screen readers
        var selectedOption = $element[0].options[$element[0].selectedIndex];
        setOptionSelectedStatus(jqLite(selectedOption), true);
      } else {
        self.selectUnknownOrEmptyOption(value);
      }
    };

    // Tell the select control that an option, with the given value, has been added
    self.addOption = function (value, element) {
      // Skip comment nodes, as they only pollute the `optionsMap`
      if (element[0].nodeType === NODE_TYPE_COMMENT) return;
      assertNotHasOwnProperty(value, '"option value"');
      if (value === '') {
        self.hasEmptyOption = true;
        self.emptyOption = element;
      }
      var count = optionsMap.get(value) || 0;
      optionsMap.set(value, count + 1);
      // Only render at the end of a digest. This improves render performance when many options
      // are added during a digest and ensures all relevant options are correctly marked as selected
      scheduleRender();
    };

    // Tell the select control that an option, with the given value, has been removed
    self.removeOption = function (value) {
      var count = optionsMap.get(value);
      if (count) {
        if (count === 1) {
          optionsMap["delete"](value);
          if (value === '') {
            self.hasEmptyOption = false;
            self.emptyOption = undefined;
          }
        } else {
          optionsMap.set(value, count - 1);
        }
      }
    };

    // Check whether the select control has an option matching the given value
    self.hasOption = function (value) {
      return !!optionsMap.get(value);
    };

    /**
     * @ngdoc method
     * @name select.SelectController#$hasEmptyOption
     *
     * @description
     *
     * Returns `true` if the select element currently has an empty option
     * element, i.e. an option that signifies that the select is empty / the selection is null.
     *
     */
    self.$hasEmptyOption = function () {
      return self.hasEmptyOption;
    };

    /**
     * @ngdoc method
     * @name select.SelectController#$isUnknownOptionSelected
     *
     * @description
     *
     * Returns `true` if the select element's unknown option is selected. The unknown option is added
     * and automatically selected whenever the select model doesn't match any option.
     *
     */
    self.$isUnknownOptionSelected = function () {
      // Presence of the unknown option means it is selected
      return $element[0].options[0] === self.unknownOption[0];
    };

    /**
     * @ngdoc method
     * @name select.SelectController#$isEmptyOptionSelected
     *
     * @description
     *
     * Returns `true` if the select element has an empty option and this empty option is currently
     * selected. Returns `false` if the select element has no empty option or it is not selected.
     *
     */
    self.$isEmptyOptionSelected = function () {
      return self.hasEmptyOption && $element[0].options[$element[0].selectedIndex] === self.emptyOption[0];
    };
    self.selectUnknownOrEmptyOption = function (value) {
      if (value == null && self.emptyOption) {
        self.removeUnknownOption();
        self.selectEmptyOption();
      } else if (self.unknownOption.parent().length) {
        self.updateUnknownOption(value);
      } else {
        self.renderUnknownOption(value);
      }
    };
    var renderScheduled = false;
    function scheduleRender() {
      if (renderScheduled) return;
      renderScheduled = true;
      $scope.$$postDigest(function () {
        renderScheduled = false;
        self.ngModelCtrl.$render();
      });
    }
    var updateScheduled = false;
    function scheduleViewValueUpdate(renderAfter) {
      if (updateScheduled) return;
      updateScheduled = true;
      $scope.$$postDigest(function () {
        if ($scope.$$destroyed) return;
        updateScheduled = false;
        self.ngModelCtrl.$setViewValue(self.readValue());
        if (renderAfter) self.ngModelCtrl.$render();
      });
    }
    self.registerOption = function (optionScope, optionElement, optionAttrs, interpolateValueFn, interpolateTextFn) {
      if (optionAttrs.$attr.ngValue) {
        // The value attribute is set by ngValue
        var oldVal, hashedVal;
        optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
          var removal;
          var previouslySelected = optionElement.prop('selected');
          if (isDefined(hashedVal)) {
            self.removeOption(oldVal);
            delete self.selectValueMap[hashedVal];
            removal = true;
          }
          hashedVal = hashKey(newVal);
          oldVal = newVal;
          self.selectValueMap[hashedVal] = newVal;
          self.addOption(newVal, optionElement);
          // Set the attribute directly instead of using optionAttrs.$set - this stops the observer
          // from firing a second time. Other $observers on value will also get the result of the
          // ngValue expression, not the hashed value
          optionElement.attr('value', hashedVal);
          if (removal && previouslySelected) {
            scheduleViewValueUpdate();
          }
        });
      } else if (interpolateValueFn) {
        // The value attribute is interpolated
        optionAttrs.$observe('value', function valueAttributeObserveAction(newVal) {
          // This method is overwritten in ngOptions and has side-effects!
          self.readValue();
          var removal;
          var previouslySelected = optionElement.prop('selected');
          if (isDefined(oldVal)) {
            self.removeOption(oldVal);
            removal = true;
          }
          oldVal = newVal;
          self.addOption(newVal, optionElement);
          if (removal && previouslySelected) {
            scheduleViewValueUpdate();
          }
        });
      } else if (interpolateTextFn) {
        // The text content is interpolated
        optionScope.$watch(interpolateTextFn, function interpolateWatchAction(newVal, oldVal) {
          optionAttrs.$set('value', newVal);
          var previouslySelected = optionElement.prop('selected');
          if (oldVal !== newVal) {
            self.removeOption(oldVal);
          }
          self.addOption(newVal, optionElement);
          if (oldVal && previouslySelected) {
            scheduleViewValueUpdate();
          }
        });
      } else {
        // The value attribute is static
        self.addOption(optionAttrs.value, optionElement);
      }
      optionAttrs.$observe('disabled', function (newVal) {
        // Since model updates will also select disabled options (like ngOptions),
        // we only have to handle options becoming disabled, not enabled

        if (newVal === 'true' || newVal && optionElement.prop('selected')) {
          if (self.multiple) {
            scheduleViewValueUpdate(true);
          } else {
            self.ngModelCtrl.$setViewValue(null);
            self.ngModelCtrl.$render();
          }
        }
      });
      optionElement.on('$destroy', function () {
        var currentValue = self.readValue();
        var removeValue = optionAttrs.value;
        self.removeOption(removeValue);
        scheduleRender();
        if (self.multiple && currentValue && currentValue.indexOf(removeValue) !== -1 || currentValue === removeValue) {
          // When multiple (selected) options are destroyed at the same time, we don't want
          // to run a model update for each of them. Instead, run a single update in the $$postDigest
          scheduleViewValueUpdate(true);
        }
      });
    };
  }];

  /**
   * @ngdoc directive
   * @name select
   * @restrict E
   *
   * @description
   * HTML `select` element with AngularJS data-binding.
   *
   * The `select` directive is used together with {@link ngModel `ngModel`} to provide data-binding
   * between the scope and the `<select>` control (including setting default values).
   * It also handles dynamic `<option>` elements, which can be added using the {@link ngRepeat `ngRepeat}` or
   * {@link ngOptions `ngOptions`} directives.
   *
   * When an item in the `<select>` menu is selected, the value of the selected option will be bound
   * to the model identified by the `ngModel` directive. With static or repeated options, this is
   * the content of the `value` attribute or the textContent of the `<option>`, if the value attribute is missing.
   * Value and textContent can be interpolated.
   *
   * The {@link select.SelectController select controller} exposes utility functions that can be used
   * to manipulate the select's behavior.
   *
   * ## Matching model and option values
   *
   * In general, the match between the model and an option is evaluated by strictly comparing the model
   * value against the value of the available options.
   *
   * If you are setting the option value with the option's `value` attribute, or textContent, the
   * value will always be a `string` which means that the model value must also be a string.
   * Otherwise the `select` directive cannot match them correctly.
   *
   * To bind the model to a non-string value, you can use one of the following strategies:
   * - the {@link ng.ngOptions `ngOptions`} directive
   *   ({@link ng.select#using-select-with-ngoptions-and-setting-a-default-value})
   * - the {@link ng.ngValue `ngValue`} directive, which allows arbitrary expressions to be
   *   option values ({@link ng.select#using-ngvalue-to-bind-the-model-to-an-array-of-objects Example})
   * - model $parsers / $formatters to convert the string value
   *   ({@link ng.select#binding-select-to-a-non-string-value-via-ngmodel-parsing-formatting Example})
   *
   * If the viewValue of `ngModel` does not match any of the options, then the control
   * will automatically add an "unknown" option, which it then removes when the mismatch is resolved.
   *
   * Optionally, a single hard-coded `<option>` element, with the value set to an empty string, can
   * be nested into the `<select>` element. This element will then represent the `null` or "not selected"
   * option. See example below for demonstration.
   *
   * ## Choosing between `ngRepeat` and `ngOptions`
   *
   * In many cases, `ngRepeat` can be used on `<option>` elements instead of {@link ng.directive:ngOptions
   * ngOptions} to achieve a similar result. However, `ngOptions` provides some benefits:
   * - more flexibility in how the `<select>`'s model is assigned via the `select` **`as`** part of the
   * comprehension expression
   * - reduced memory consumption by not creating a new scope for each repeated instance
   * - increased render speed by creating the options in a documentFragment instead of individually
   *
   * Specifically, select with repeated options slows down significantly starting at 2000 options in
   * Chrome and Internet Explorer / Edge.
   *
   *
   * @param {string} ngModel Assignable AngularJS expression to data-bind to.
   * @param {string=} name Property name of the form under which the control is published.
   * @param {string=} multiple Allows multiple options to be selected. The selected values will be
   *     bound to the model as an array.
   * @param {string=} required Sets `required` validation error key if the value is not entered.
   * @param {string=} ngRequired Adds required attribute and required validation constraint to
   * the element when the ngRequired expression evaluates to true. Use ngRequired instead of required
   * when you want to data-bind to the required attribute.
   * @param {string=} ngChange AngularJS expression to be executed when selected option(s) changes due to user
   *    interaction with the select element.
   * @param {string=} ngOptions sets the options that the select is populated with and defines what is
   * set on the model on selection. See {@link ngOptions `ngOptions`}.
   * @param {string=} ngAttrSize sets the size of the select element dynamically. Uses the
   * {@link guide/interpolation#-ngattr-for-binding-to-arbitrary-attributes ngAttr} directive.
   *
   *
   * @example
   * ### Simple `select` elements with static options
   *
   * <example name="static-select" module="staticSelect">
   * <file name="index.html">
   * <div ng-controller="ExampleController">
   *   <form name="myForm">
   *     <label for="singleSelect"> Single select: </label><br>
   *     <select name="singleSelect" ng-model="data.singleSelect">
   *       <option value="option-1">Option 1</option>
   *       <option value="option-2">Option 2</option>
   *     </select><br>
   *
   *     <label for="singleSelect"> Single select with "not selected" option and dynamic option values: </label><br>
   *     <select name="singleSelect" id="singleSelect" ng-model="data.singleSelect">
   *       <option value="">---Please select---</option> <!-- not selected / blank option -->
   *       <option value="{{data.option1}}">Option 1</option> <!-- interpolation -->
   *       <option value="option-2">Option 2</option>
   *     </select><br>
   *     <button ng-click="forceUnknownOption()">Force unknown option</button><br>
   *     <tt>singleSelect = {{data.singleSelect}}</tt>
   *
   *     <hr>
   *     <label for="multipleSelect"> Multiple select: </label><br>
   *     <select name="multipleSelect" id="multipleSelect" ng-model="data.multipleSelect" multiple>
   *       <option value="option-1">Option 1</option>
   *       <option value="option-2">Option 2</option>
   *       <option value="option-3">Option 3</option>
   *     </select><br>
   *     <tt>multipleSelect = {{data.multipleSelect}}</tt><br/>
   *   </form>
   * </div>
   * </file>
   * <file name="app.js">
   *  angular.module('staticSelect', [])
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.data = {
   *       singleSelect: null,
   *       multipleSelect: [],
   *       option1: 'option-1'
   *      };
   *
   *      $scope.forceUnknownOption = function() {
   *        $scope.data.singleSelect = 'nonsense';
   *      };
   *   }]);
   * </file>
   *</example>
   *
   * @example
   * ### Using `ngRepeat` to generate `select` options
   * <example name="select-ngrepeat" module="ngrepeatSelect">
   * <file name="index.html">
   * <div ng-controller="ExampleController">
   *   <form name="myForm">
   *     <label for="repeatSelect"> Repeat select: </label>
   *     <select name="repeatSelect" id="repeatSelect" ng-model="data.model">
   *       <option ng-repeat="option in data.availableOptions" value="{{option.id}}">{{option.name}}</option>
   *     </select>
   *   </form>
   *   <hr>
   *   <tt>model = {{data.model}}</tt><br/>
   * </div>
   * </file>
   * <file name="app.js">
   *  angular.module('ngrepeatSelect', [])
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.data = {
   *       model: null,
   *       availableOptions: [
   *         {id: '1', name: 'Option A'},
   *         {id: '2', name: 'Option B'},
   *         {id: '3', name: 'Option C'}
   *       ]
   *      };
   *   }]);
   * </file>
   *</example>
   *
   * @example
   * ### Using `ngValue` to bind the model to an array of objects
   * <example name="select-ngvalue" module="ngvalueSelect">
   * <file name="index.html">
   * <div ng-controller="ExampleController">
   *   <form name="myForm">
   *     <label for="ngvalueselect"> ngvalue select: </label>
   *     <select size="6" name="ngvalueselect" ng-model="data.model" multiple>
   *       <option ng-repeat="option in data.availableOptions" ng-value="option.value">{{option.name}}</option>
   *     </select>
   *   </form>
   *   <hr>
   *   <pre>model = {{data.model | json}}</pre><br/>
   * </div>
   * </file>
   * <file name="app.js">
   *  angular.module('ngvalueSelect', [])
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.data = {
   *       model: null,
   *       availableOptions: [
             {value: 'myString', name: 'string'},
             {value: 1, name: 'integer'},
             {value: true, name: 'boolean'},
             {value: null, name: 'null'},
             {value: {prop: 'value'}, name: 'object'},
             {value: ['a'], name: 'array'}
   *       ]
   *      };
   *   }]);
   * </file>
   *</example>
   *
   * @example
   * ### Using `select` with `ngOptions` and setting a default value
   * See the {@link ngOptions ngOptions documentation} for more `ngOptions` usage examples.
   *
   * <example name="select-with-default-values" module="defaultValueSelect">
   * <file name="index.html">
   * <div ng-controller="ExampleController">
   *   <form name="myForm">
   *     <label for="mySelect">Make a choice:</label>
   *     <select name="mySelect" id="mySelect"
   *       ng-options="option.name for option in data.availableOptions track by option.id"
   *       ng-model="data.selectedOption"></select>
   *   </form>
   *   <hr>
   *   <tt>option = {{data.selectedOption}}</tt><br/>
   * </div>
   * </file>
   * <file name="app.js">
   *  angular.module('defaultValueSelect', [])
   *    .controller('ExampleController', ['$scope', function($scope) {
   *      $scope.data = {
   *       availableOptions: [
   *         {id: '1', name: 'Option A'},
   *         {id: '2', name: 'Option B'},
   *         {id: '3', name: 'Option C'}
   *       ],
   *       selectedOption: {id: '3', name: 'Option C'} //This sets the default value of the select in the ui
   *       };
   *   }]);
   * </file>
   *</example>
   *
   * @example
   * ### Binding `select` to a non-string value via `ngModel` parsing / formatting
   *
   * <example name="select-with-non-string-options" module="nonStringSelect">
   *   <file name="index.html">
   *     <select ng-model="model.id" convert-to-number>
   *       <option value="0">Zero</option>
   *       <option value="1">One</option>
   *       <option value="2">Two</option>
   *     </select>
   *     {{ model }}
   *   </file>
   *   <file name="app.js">
   *     angular.module('nonStringSelect', [])
   *       .run(function($rootScope) {
   *         $rootScope.model = { id: 2 };
   *       })
   *       .directive('convertToNumber', function() {
   *         return {
   *           require: 'ngModel',
   *           link: function(scope, element, attrs, ngModel) {
   *             ngModel.$parsers.push(function(val) {
   *               return parseInt(val, 10);
   *             });
   *             ngModel.$formatters.push(function(val) {
   *               return '' + val;
   *             });
   *           }
   *         };
   *       });
   *   </file>
   *   <file name="protractor.js" type="protractor">
   *     it('should initialize to model', function() {
   *       expect(element(by.model('model.id')).$('option:checked').getText()).toEqual('Two');
   *     });
   *   </file>
   * </example>
   *
   */
  var selectDirective = function selectDirective() {
    return {
      restrict: 'E',
      require: ['select', '?ngModel'],
      controller: SelectController,
      priority: 1,
      link: {
        pre: selectPreLink,
        post: selectPostLink
      }
    };
    function selectPreLink(scope, element, attr, ctrls) {
      var selectCtrl = ctrls[0];
      var ngModelCtrl = ctrls[1];

      // if ngModel is not defined, we don't need to do anything but set the registerOption
      // function to noop, so options don't get added internally
      if (!ngModelCtrl) {
        selectCtrl.registerOption = noop;
        return;
      }
      selectCtrl.ngModelCtrl = ngModelCtrl;

      // When the selected item(s) changes we delegate getting the value of the select control
      // to the `readValue` method, which can be changed if the select can have multiple
      // selected values or if the options are being generated by `ngOptions`
      element.on('change', function () {
        selectCtrl.removeUnknownOption();
        scope.$apply(function () {
          ngModelCtrl.$setViewValue(selectCtrl.readValue());
        });
      });

      // If the select allows multiple values then we need to modify how we read and write
      // values from and to the control; also what it means for the value to be empty and
      // we have to add an extra watch since ngModel doesn't work well with arrays - it
      // doesn't trigger rendering if only an item in the array changes.
      if (attr.multiple) {
        selectCtrl.multiple = true;

        // Read value now needs to check each option to see if it is selected
        selectCtrl.readValue = function readMultipleValue() {
          var array = [];
          forEach(element.find('option'), function (option) {
            if (option.selected && !option.disabled) {
              var val = option.value;
              array.push(val in selectCtrl.selectValueMap ? selectCtrl.selectValueMap[val] : val);
            }
          });
          return array;
        };

        // Write value now needs to set the selected property of each matching option
        selectCtrl.writeValue = function writeMultipleValue(value) {
          forEach(element.find('option'), function (option) {
            var shouldBeSelected = !!value && (includes(value, option.value) || includes(value, selectCtrl.selectValueMap[option.value]));
            var currentlySelected = option.selected;

            // Support: IE 9-11 only, Edge 12-15+
            // In IE and Edge adding options to the selection via shift+click/UP/DOWN
            // will de-select already selected options if "selected" on those options was set
            // more than once (i.e. when the options were already selected)
            // So we only modify the selected property if necessary.
            // Note: this behavior cannot be replicated via unit tests because it only shows in the
            // actual user interface.
            if (shouldBeSelected !== currentlySelected) {
              setOptionSelectedStatus(jqLite(option), shouldBeSelected);
            }
          });
        };

        // we have to do it on each watch since ngModel watches reference, but
        // we need to work of an array, so we need to see if anything was inserted/removed
        var lastView,
          lastViewRef = NaN;
        scope.$watch(function selectMultipleWatch() {
          if (lastViewRef === ngModelCtrl.$viewValue && !equals(lastView, ngModelCtrl.$viewValue)) {
            lastView = shallowCopy(ngModelCtrl.$viewValue);
            ngModelCtrl.$render();
          }
          lastViewRef = ngModelCtrl.$viewValue;
        });

        // If we are a multiple select then value is now a collection
        // so the meaning of $isEmpty changes
        ngModelCtrl.$isEmpty = function (value) {
          return !value || value.length === 0;
        };
      }
    }
    function selectPostLink(scope, element, attrs, ctrls) {
      // if ngModel is not defined, we don't need to do anything
      var ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) return;
      var selectCtrl = ctrls[0];

      // We delegate rendering to the `writeValue` method, which can be changed
      // if the select can have multiple selected values or if the options are being
      // generated by `ngOptions`.
      // This must be done in the postLink fn to prevent $render to be called before
      // all nodes have been linked correctly.
      ngModelCtrl.$render = function () {
        selectCtrl.writeValue(ngModelCtrl.$viewValue);
      };
    }
  };

  // The option directive is purely designed to communicate the existence (or lack of)
  // of dynamically created (and destroyed) option elements to their containing select
  // directive via its controller.
  var optionDirective = ['$interpolate', function ($interpolate) {
    return {
      restrict: 'E',
      priority: 100,
      compile: function compile(element, attr) {
        var interpolateValueFn, interpolateTextFn;
        if (isDefined(attr.ngValue)) {
          // Will be handled by registerOption
        } else if (isDefined(attr.value)) {
          // If the value attribute is defined, check if it contains an interpolation
          interpolateValueFn = $interpolate(attr.value, true);
        } else {
          // If the value attribute is not defined then we fall back to the
          // text content of the option element, which may be interpolated
          interpolateTextFn = $interpolate(element.text(), true);
          if (!interpolateTextFn) {
            attr.$set('value', element.text());
          }
        }
        return function (scope, element, attr) {
          // This is an optimization over using ^^ since we don't want to have to search
          // all the way to the root of the DOM for every single option element
          var selectCtrlName = '$selectController',
            parent = element.parent(),
            selectCtrl = parent.data(selectCtrlName) || parent.parent().data(selectCtrlName); // in case we are in optgroup

          if (selectCtrl) {
            selectCtrl.registerOption(scope, element, attr, interpolateValueFn, interpolateTextFn);
          }
        };
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngRequired
   * @restrict A
   *
   * @param {expression} ngRequired AngularJS expression. If it evaluates to `true`, it sets the
   *                                `required` attribute to the element and adds the `required`
   *                                {@link ngModel.NgModelController#$validators `validator`}.
   *
   * @description
   *
   * ngRequired adds the required {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
   * It is most often used for {@link input `input`} and {@link select `select`} controls, but can also be
   * applied to custom controls.
   *
   * The directive sets the `required` attribute on the element if the AngularJS expression inside
   * `ngRequired` evaluates to true. A special directive for setting `required` is necessary because we
   * cannot use interpolation inside `required`. See the {@link guide/interpolation interpolation guide}
   * for more info.
   *
   * The validator will set the `required` error key to true if the `required` attribute is set and
   * calling {@link ngModel.NgModelController#$isEmpty `NgModelController.$isEmpty`} with the
   * {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`} returns `true`. For example, the
   * `$isEmpty()` implementation for `input[text]` checks the length of the `$viewValue`. When developing
   * custom controls, `$isEmpty()` can be overwritten to account for a $viewValue that is not string-based.
   *
   * @example
   * <example name="ngRequiredDirective" module="ngRequiredExample">
   *   <file name="index.html">
   *     <script>
   *       angular.module('ngRequiredExample', [])
   *         .controller('ExampleController', ['$scope', function($scope) {
   *           $scope.required = true;
   *         }]);
   *     </script>
   *     <div ng-controller="ExampleController">
   *       <form name="form">
   *         <label for="required">Toggle required: </label>
   *         <input type="checkbox" ng-model="required" id="required" />
   *         <br>
   *         <label for="input">This input must be filled if `required` is true: </label>
   *         <input type="text" ng-model="model" id="input" name="input" ng-required="required" /><br>
   *         <hr>
   *         required error set? = <code>{{form.input.$error.required}}</code><br>
   *         model = <code>{{model}}</code>
   *       </form>
   *     </div>
   *   </file>
   *   <file name="protractor.js" type="protractor">
         var required = element(by.binding('form.input.$error.required'));
         var model = element(by.binding('model'));
         var input = element(by.id('input'));
  
         it('should set the required error', function() {
           expect(required.getText()).toContain('true');
  
           input.sendKeys('123');
           expect(required.getText()).not.toContain('true');
           expect(model.getText()).toContain('123');
         });
   *   </file>
   * </example>
   */
  var requiredDirective = ['$parse', function ($parse) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function link(scope, elm, attr, ctrl) {
        if (!ctrl) return;
        // For boolean attributes like required, presence means true
        var value = attr.hasOwnProperty('required') || $parse(attr.ngRequired)(scope);
        if (!attr.ngRequired) {
          // force truthy in case we are on non input element
          // (input elements do this automatically for boolean attributes like required)
          attr.required = true;
        }
        ctrl.$validators.required = function (modelValue, viewValue) {
          return !value || !ctrl.$isEmpty(viewValue);
        };
        attr.$observe('required', function (newVal) {
          if (value !== newVal) {
            value = newVal;
            ctrl.$validate();
          }
        });
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngPattern
   * @restrict A
   *
   * @param {expression|RegExp} ngPattern AngularJS expression that must evaluate to a `RegExp` or a `String`
   *                                      parsable into a `RegExp`, or a `RegExp` literal. See above for
   *                                      more details.
   *
   * @description
   *
   * ngPattern adds the pattern {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
   * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
   *
   * The validator sets the `pattern` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
   * does not match a RegExp which is obtained from the `ngPattern` attribute value:
   * - the value is an AngularJS expression:
   *   - If the expression evaluates to a RegExp object, then this is used directly.
   *   - If the expression evaluates to a string, then it will be converted to a RegExp after wrapping it
   *     in `^` and `$` characters. For instance, `"abc"` will be converted to `new RegExp('^abc$')`.
   * - If the value is a RegExp literal, e.g. `ngPattern="/^\d+$/"`, it is used directly.
   *
   * <div class="alert alert-info">
   * **Note:** Avoid using the `g` flag on the RegExp, as it will cause each successive search to
   * start at the index of the last search's match, thus not taking the whole input value into
   * account.
   * </div>
   *
   * <div class="alert alert-info">
   * **Note:** This directive is also added when the plain `pattern` attribute is used, with two
   * differences:
   * <ol>
   *   <li>
   *     `ngPattern` does not set the `pattern` attribute and therefore HTML5 constraint validation is
   *     not available.
   *   </li>
   *   <li>
   *     The `ngPattern` attribute must be an expression, while the `pattern` value must be
   *     interpolated.
   *   </li>
   * </ol>
   * </div>
   *
   * @example
   * <example name="ngPatternDirective" module="ngPatternExample">
   *   <file name="index.html">
   *     <script>
   *       angular.module('ngPatternExample', [])
   *         .controller('ExampleController', ['$scope', function($scope) {
   *           $scope.regex = '\\d+';
   *         }]);
   *     </script>
   *     <div ng-controller="ExampleController">
   *       <form name="form">
   *         <label for="regex">Set a pattern (regex string): </label>
   *         <input type="text" ng-model="regex" id="regex" />
   *         <br>
   *         <label for="input">This input is restricted by the current pattern: </label>
   *         <input type="text" ng-model="model" id="input" name="input" ng-pattern="regex" /><br>
   *         <hr>
   *         input valid? = <code>{{form.input.$valid}}</code><br>
   *         model = <code>{{model}}</code>
   *       </form>
   *     </div>
   *   </file>
   *   <file name="protractor.js" type="protractor">
         var model = element(by.binding('model'));
         var input = element(by.id('input'));
  
         it('should validate the input with the default pattern', function() {
           input.sendKeys('aaa');
           expect(model.getText()).not.toContain('aaa');
  
           input.clear().then(function() {
             input.sendKeys('123');
             expect(model.getText()).toContain('123');
           });
         });
   *   </file>
   * </example>
   */
  var patternDirective = ['$parse', function ($parse) {
    return {
      restrict: 'A',
      require: '?ngModel',
      compile: function compile(tElm, tAttr) {
        var patternExp;
        var parseFn;
        if (tAttr.ngPattern) {
          patternExp = tAttr.ngPattern;

          // ngPattern might be a scope expression, or an inlined regex, which is not parsable.
          // We get value of the attribute here, so we can compare the old and the new value
          // in the observer to avoid unnecessary validations
          if (tAttr.ngPattern.charAt(0) === '/' && REGEX_STRING_REGEXP.test(tAttr.ngPattern)) {
            parseFn = function parseFn() {
              return tAttr.ngPattern;
            };
          } else {
            parseFn = $parse(tAttr.ngPattern);
          }
        }
        return function (scope, elm, attr, ctrl) {
          if (!ctrl) return;
          var attrVal = attr.pattern;
          if (attr.ngPattern) {
            attrVal = parseFn(scope);
          } else {
            patternExp = attr.pattern;
          }
          var regexp = parsePatternAttr(attrVal, patternExp, elm);
          attr.$observe('pattern', function (newVal) {
            var oldRegexp = regexp;
            regexp = parsePatternAttr(newVal, patternExp, elm);
            if ((oldRegexp && oldRegexp.toString()) !== (regexp && regexp.toString())) {
              ctrl.$validate();
            }
          });
          ctrl.$validators.pattern = function (modelValue, viewValue) {
            // HTML5 pattern constraint validates the input value, so we validate the viewValue
            return ctrl.$isEmpty(viewValue) || isUndefined(regexp) || regexp.test(viewValue);
          };
        };
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngMaxlength
   * @restrict A
   *
   * @param {expression} ngMaxlength AngularJS expression that must evaluate to a `Number` or `String`
   *                                 parsable into a `Number`. Used as value for the `maxlength`
   *                                 {@link ngModel.NgModelController#$validators validator}.
   *
   * @description
   *
   * ngMaxlength adds the maxlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
   * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
   *
   * The validator sets the `maxlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
   * is longer than the integer obtained by evaluating the AngularJS expression given in the
   * `ngMaxlength` attribute value.
   *
   * <div class="alert alert-info">
   * **Note:** This directive is also added when the plain `maxlength` attribute is used, with two
   * differences:
   * <ol>
   *   <li>
   *     `ngMaxlength` does not set the `maxlength` attribute and therefore HTML5 constraint
   *     validation is not available.
   *   </li>
   *   <li>
   *     The `ngMaxlength` attribute must be an expression, while the `maxlength` value must be
   *     interpolated.
   *   </li>
   * </ol>
   * </div>
   *
   * @example
   * <example name="ngMaxlengthDirective" module="ngMaxlengthExample">
   *   <file name="index.html">
   *     <script>
   *       angular.module('ngMaxlengthExample', [])
   *         .controller('ExampleController', ['$scope', function($scope) {
   *           $scope.maxlength = 5;
   *         }]);
   *     </script>
   *     <div ng-controller="ExampleController">
   *       <form name="form">
   *         <label for="maxlength">Set a maxlength: </label>
   *         <input type="number" ng-model="maxlength" id="maxlength" />
   *         <br>
   *         <label for="input">This input is restricted by the current maxlength: </label>
   *         <input type="text" ng-model="model" id="input" name="input" ng-maxlength="maxlength" /><br>
   *         <hr>
   *         input valid? = <code>{{form.input.$valid}}</code><br>
   *         model = <code>{{model}}</code>
   *       </form>
   *     </div>
   *   </file>
   *   <file name="protractor.js" type="protractor">
         var model = element(by.binding('model'));
         var input = element(by.id('input'));
  
         it('should validate the input with the default maxlength', function() {
           input.sendKeys('abcdef');
           expect(model.getText()).not.toContain('abcdef');
  
           input.clear().then(function() {
             input.sendKeys('abcde');
             expect(model.getText()).toContain('abcde');
           });
         });
   *   </file>
   * </example>
   */
  var maxlengthDirective = ['$parse', function ($parse) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function link(scope, elm, attr, ctrl) {
        if (!ctrl) return;
        var maxlength = attr.maxlength || $parse(attr.ngMaxlength)(scope);
        var maxlengthParsed = parseLength(maxlength);
        attr.$observe('maxlength', function (value) {
          if (maxlength !== value) {
            maxlengthParsed = parseLength(value);
            maxlength = value;
            ctrl.$validate();
          }
        });
        ctrl.$validators.maxlength = function (modelValue, viewValue) {
          return maxlengthParsed < 0 || ctrl.$isEmpty(viewValue) || viewValue.length <= maxlengthParsed;
        };
      }
    };
  }];

  /**
   * @ngdoc directive
   * @name ngMinlength
   * @restrict A
   *
   * @param {expression} ngMinlength AngularJS expression that must evaluate to a `Number` or `String`
   *                                 parsable into a `Number`. Used as value for the `minlength`
   *                                 {@link ngModel.NgModelController#$validators validator}.
   *
   * @description
   *
   * ngMinlength adds the minlength {@link ngModel.NgModelController#$validators `validator`} to {@link ngModel `ngModel`}.
   * It is most often used for text-based {@link input `input`} controls, but can also be applied to custom text-based controls.
   *
   * The validator sets the `minlength` error key if the {@link ngModel.NgModelController#$viewValue `ngModel.$viewValue`}
   * is shorter than the integer obtained by evaluating the AngularJS expression given in the
   * `ngMinlength` attribute value.
   *
   * <div class="alert alert-info">
   * **Note:** This directive is also added when the plain `minlength` attribute is used, with two
   * differences:
   * <ol>
   *   <li>
   *     `ngMinlength` does not set the `minlength` attribute and therefore HTML5 constraint
   *     validation is not available.
   *   </li>
   *   <li>
   *     The `ngMinlength` value must be an expression, while the `minlength` value must be
   *     interpolated.
   *   </li>
   * </ol>
   * </div>
   *
   * @example
   * <example name="ngMinlengthDirective" module="ngMinlengthExample">
   *   <file name="index.html">
   *     <script>
   *       angular.module('ngMinlengthExample', [])
   *         .controller('ExampleController', ['$scope', function($scope) {
   *           $scope.minlength = 3;
   *         }]);
   *     </script>
   *     <div ng-controller="ExampleController">
   *       <form name="form">
   *         <label for="minlength">Set a minlength: </label>
   *         <input type="number" ng-model="minlength" id="minlength" />
   *         <br>
   *         <label for="input">This input is restricted by the current minlength: </label>
   *         <input type="text" ng-model="model" id="input" name="input" ng-minlength="minlength" /><br>
   *         <hr>
   *         input valid? = <code>{{form.input.$valid}}</code><br>
   *         model = <code>{{model}}</code>
   *       </form>
   *     </div>
   *   </file>
   *   <file name="protractor.js" type="protractor">
         var model = element(by.binding('model'));
         var input = element(by.id('input'));
  
         it('should validate the input with the default minlength', function() {
           input.sendKeys('ab');
           expect(model.getText()).not.toContain('ab');
  
           input.sendKeys('abc');
           expect(model.getText()).toContain('abc');
         });
   *   </file>
   * </example>
   */
  var minlengthDirective = ['$parse', function ($parse) {
    return {
      restrict: 'A',
      require: '?ngModel',
      link: function link(scope, elm, attr, ctrl) {
        if (!ctrl) return;
        var minlength = attr.minlength || $parse(attr.ngMinlength)(scope);
        var minlengthParsed = parseLength(minlength) || -1;
        attr.$observe('minlength', function (value) {
          if (minlength !== value) {
            minlengthParsed = parseLength(value) || -1;
            minlength = value;
            ctrl.$validate();
          }
        });
        ctrl.$validators.minlength = function (modelValue, viewValue) {
          return ctrl.$isEmpty(viewValue) || viewValue.length >= minlengthParsed;
        };
      }
    };
  }];
  function parsePatternAttr(regex, patternExp, elm) {
    if (!regex) return undefined;
    if (isString(regex)) {
      regex = new RegExp('^' + regex + '$');
    }
    if (!regex.test) {
      throw minErr('ngPattern')('noregexp', 'Expected {0} to be a RegExp but was {1}. Element: {2}', patternExp, regex, startingTag(elm));
    }
    return regex;
  }
  function parseLength(val) {
    var intVal = toInt(val);
    return isNumberNaN(intVal) ? -1 : intVal;
  }
  if (window.angular.bootstrap) {
    // AngularJS is already loaded, so we can return here...
    if (window.console) {
      console.log('WARNING: Tried to load AngularJS more than once.');
    }
    return;
  }

  // try to bind to jquery now so that one can write jqLite(fn)
  // but we will rebind on bootstrap again.
  bindJQuery();
  publishExternalAPI(angular);
  angular.module("ngLocale", [], ["$provide", function ($provide) {
    var PLURAL_CATEGORY = {
      ZERO: "zero",
      ONE: "one",
      TWO: "two",
      FEW: "few",
      MANY: "many",
      OTHER: "other"
    };
    function getDecimals(n) {
      n = n + '';
      var i = n.indexOf('.');
      return i == -1 ? 0 : n.length - i - 1;
    }
    function getVF(n, opt_precision) {
      var v = opt_precision;
      if (undefined === v) {
        v = Math.min(getDecimals(n), 3);
      }
      var base = Math.pow(10, v);
      var f = (n * base | 0) % base;
      return {
        v: v,
        f: f
      };
    }
    $provide.value("$locale", {
      "DATETIME_FORMATS": {
        "AMPMS": ["AM", "PM"],
        "DAY": ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"],
        "ERANAMES": ["Before Christ", "Anno Domini"],
        "ERAS": ["BC", "AD"],
        "FIRSTDAYOFWEEK": 6,
        "MONTH": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        "SHORTDAY": ["Sun", "Mon", "Tue", "Wed", "Thu", "Fri", "Sat"],
        "SHORTMONTH": ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"],
        "STANDALONEMONTH": ["January", "February", "March", "April", "May", "June", "July", "August", "September", "October", "November", "December"],
        "WEEKENDRANGE": [5, 6],
        "fullDate": "EEEE, MMMM d, y",
        "longDate": "MMMM d, y",
        "medium": "MMM d, y h:mm:ss a",
        "mediumDate": "MMM d, y",
        "mediumTime": "h:mm:ss a",
        "short": "M/d/yy h:mm a",
        "shortDate": "M/d/yy",
        "shortTime": "h:mm a"
      },
      "NUMBER_FORMATS": {
        "CURRENCY_SYM": "$",
        "DECIMAL_SEP": ".",
        "GROUP_SEP": ",",
        "PATTERNS": [{
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 3,
          "minFrac": 0,
          "minInt": 1,
          "negPre": "-",
          "negSuf": "",
          "posPre": "",
          "posSuf": ""
        }, {
          "gSize": 3,
          "lgSize": 3,
          "maxFrac": 2,
          "minFrac": 2,
          "minInt": 1,
          "negPre": "-\xA4",
          "negSuf": "",
          "posPre": "\xA4",
          "posSuf": ""
        }]
      },
      "id": "en-us",
      "localeID": "en_US",
      "pluralCat": function pluralCat(n, opt_precision) {
        var i = n | 0;
        var vf = getVF(n, opt_precision);
        if (i == 1 && vf.v == 0) {
          return PLURAL_CATEGORY.ONE;
        }
        return PLURAL_CATEGORY.OTHER;
      }
    });
  }]);
  jqLite(function () {
    angularInit(window.document, bootstrap);
  });
})(window);
!window.angular.$$csp().noInlineStyle && window.angular.element(document.head).prepend(window.angular.element('<style>').text('@charset "UTF-8";[ng\\:cloak],[ng-cloak],[data-ng-cloak],[x-ng-cloak],.ng-cloak,.x-ng-cloak,.ng-hide:not(.ng-hide-animate){display:none !important;}ng\\:form{display:block;}.ng-animate-shim{visibility:hidden;}.ng-anchor{position:absolute;}'));
/**
 * @license AngularJS v1.8.2
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function (window, angular) {
  'use strict';

  var ELEMENT_NODE = 1;
  var COMMENT_NODE = 8;
  var ADD_CLASS_SUFFIX = '-add';
  var REMOVE_CLASS_SUFFIX = '-remove';
  var EVENT_CLASS_PREFIX = 'ng-';
  var ACTIVE_CLASS_SUFFIX = '-active';
  var PREPARE_CLASS_SUFFIX = '-prepare';
  var NG_ANIMATE_CLASSNAME = 'ng-animate';
  var NG_ANIMATE_CHILDREN_DATA = '$$ngAnimateChildren';

  // Detect proper transitionend/animationend event names.
  var CSS_PREFIX = '',
    TRANSITION_PROP,
    TRANSITIONEND_EVENT,
    ANIMATION_PROP,
    ANIMATIONEND_EVENT;

  // If unprefixed events are not supported but webkit-prefixed are, use the latter.
  // Otherwise, just use W3C names, browsers not supporting them at all will just ignore them.
  // Note: Chrome implements `window.onwebkitanimationend` and doesn't implement `window.onanimationend`
  // but at the same time dispatches the `animationend` event and not `webkitAnimationEnd`.
  // Register both events in case `window.onanimationend` is not supported because of that,
  // do the same for `transitionend` as Safari is likely to exhibit similar behavior.
  // Also, the only modern browser that uses vendor prefixes for transitions/keyframes is webkit
  // therefore there is no reason to test anymore for other vendor prefixes:
  // http://caniuse.com/#search=transition
  if (window.ontransitionend === undefined && window.onwebkittransitionend !== undefined) {
    CSS_PREFIX = '-webkit-';
    TRANSITION_PROP = 'WebkitTransition';
    TRANSITIONEND_EVENT = 'webkitTransitionEnd transitionend';
  } else {
    TRANSITION_PROP = 'transition';
    TRANSITIONEND_EVENT = 'transitionend';
  }
  if (window.onanimationend === undefined && window.onwebkitanimationend !== undefined) {
    CSS_PREFIX = '-webkit-';
    ANIMATION_PROP = 'WebkitAnimation';
    ANIMATIONEND_EVENT = 'webkitAnimationEnd animationend';
  } else {
    ANIMATION_PROP = 'animation';
    ANIMATIONEND_EVENT = 'animationend';
  }
  var DURATION_KEY = 'Duration';
  var PROPERTY_KEY = 'Property';
  var DELAY_KEY = 'Delay';
  var TIMING_KEY = 'TimingFunction';
  var ANIMATION_ITERATION_COUNT_KEY = 'IterationCount';
  var ANIMATION_PLAYSTATE_KEY = 'PlayState';
  var SAFE_FAST_FORWARD_DURATION_VALUE = 9999;
  var ANIMATION_DELAY_PROP = ANIMATION_PROP + DELAY_KEY;
  var ANIMATION_DURATION_PROP = ANIMATION_PROP + DURATION_KEY;
  var TRANSITION_DELAY_PROP = TRANSITION_PROP + DELAY_KEY;
  var TRANSITION_DURATION_PROP = TRANSITION_PROP + DURATION_KEY;
  var ngMinErr = angular.$$minErr('ng');
  function assertArg(arg, name, reason) {
    if (!arg) {
      throw ngMinErr('areq', 'Argument \'{0}\' is {1}', name || '?', reason || 'required');
    }
    return arg;
  }
  function mergeClasses(a, b) {
    if (!a && !b) return '';
    if (!a) return b;
    if (!b) return a;
    if (isArray(a)) a = a.join(' ');
    if (isArray(b)) b = b.join(' ');
    return a + ' ' + b;
  }
  function packageStyles(options) {
    var styles = {};
    if (options && (options.to || options.from)) {
      styles.to = options.to;
      styles.from = options.from;
    }
    return styles;
  }
  function pendClasses(classes, fix, isPrefix) {
    var className = '';
    classes = isArray(classes) ? classes : classes && isString(classes) && classes.length ? classes.split(/\s+/) : [];
    forEach(classes, function (klass, i) {
      if (klass && klass.length > 0) {
        className += i > 0 ? ' ' : '';
        className += isPrefix ? fix + klass : klass + fix;
      }
    });
    return className;
  }
  function removeFromArray(arr, val) {
    var index = arr.indexOf(val);
    if (val >= 0) {
      arr.splice(index, 1);
    }
  }
  function stripCommentsFromElement(element) {
    if (element instanceof jqLite) {
      switch (element.length) {
        case 0:
          return element;
        case 1:
          // there is no point of stripping anything if the element
          // is the only element within the jqLite wrapper.
          // (it's important that we retain the element instance.)
          if (element[0].nodeType === ELEMENT_NODE) {
            return element;
          }
          break;
        default:
          return jqLite(extractElementNode(element));
      }
    }
    if (element.nodeType === ELEMENT_NODE) {
      return jqLite(element);
    }
  }
  function extractElementNode(element) {
    if (!element[0]) return element;
    for (var i = 0; i < element.length; i++) {
      var elm = element[i];
      if (elm.nodeType === ELEMENT_NODE) {
        return elm;
      }
    }
  }
  function $$addClass($$jqLite, element, className) {
    forEach(element, function (elm) {
      $$jqLite.addClass(elm, className);
    });
  }
  function $$removeClass($$jqLite, element, className) {
    forEach(element, function (elm) {
      $$jqLite.removeClass(elm, className);
    });
  }
  function applyAnimationClassesFactory($$jqLite) {
    return function (element, options) {
      if (options.addClass) {
        $$addClass($$jqLite, element, options.addClass);
        options.addClass = null;
      }
      if (options.removeClass) {
        $$removeClass($$jqLite, element, options.removeClass);
        options.removeClass = null;
      }
    };
  }
  function prepareAnimationOptions(options) {
    options = options || {};
    if (!options.$$prepared) {
      var domOperation = options.domOperation || noop;
      options.domOperation = function () {
        options.$$domOperationFired = true;
        domOperation();
        domOperation = noop;
      };
      options.$$prepared = true;
    }
    return options;
  }
  function applyAnimationStyles(element, options) {
    applyAnimationFromStyles(element, options);
    applyAnimationToStyles(element, options);
  }
  function applyAnimationFromStyles(element, options) {
    if (options.from) {
      element.css(options.from);
      options.from = null;
    }
  }
  function applyAnimationToStyles(element, options) {
    if (options.to) {
      element.css(options.to);
      options.to = null;
    }
  }
  function mergeAnimationDetails(element, oldAnimation, newAnimation) {
    var target = oldAnimation.options || {};
    var newOptions = newAnimation.options || {};
    var toAdd = (target.addClass || '') + ' ' + (newOptions.addClass || '');
    var toRemove = (target.removeClass || '') + ' ' + (newOptions.removeClass || '');
    var classes = resolveElementClasses(element.attr('class'), toAdd, toRemove);
    if (newOptions.preparationClasses) {
      target.preparationClasses = concatWithSpace(newOptions.preparationClasses, target.preparationClasses);
      delete newOptions.preparationClasses;
    }

    // noop is basically when there is no callback; otherwise something has been set
    var realDomOperation = target.domOperation !== noop ? target.domOperation : null;
    extend(target, newOptions);

    // TODO(matsko or sreeramu): proper fix is to maintain all animation callback in array and call at last,but now only leave has the callback so no issue with this.
    if (realDomOperation) {
      target.domOperation = realDomOperation;
    }
    if (classes.addClass) {
      target.addClass = classes.addClass;
    } else {
      target.addClass = null;
    }
    if (classes.removeClass) {
      target.removeClass = classes.removeClass;
    } else {
      target.removeClass = null;
    }
    oldAnimation.addClass = target.addClass;
    oldAnimation.removeClass = target.removeClass;
    return target;
  }
  function resolveElementClasses(existing, toAdd, toRemove) {
    var ADD_CLASS = 1;
    var REMOVE_CLASS = -1;
    var flags = {};
    existing = splitClassesToLookup(existing);
    toAdd = splitClassesToLookup(toAdd);
    forEach(toAdd, function (value, key) {
      flags[key] = ADD_CLASS;
    });
    toRemove = splitClassesToLookup(toRemove);
    forEach(toRemove, function (value, key) {
      flags[key] = flags[key] === ADD_CLASS ? null : REMOVE_CLASS;
    });
    var classes = {
      addClass: '',
      removeClass: ''
    };
    forEach(flags, function (val, klass) {
      var prop, allow;
      if (val === ADD_CLASS) {
        prop = 'addClass';
        allow = !existing[klass] || existing[klass + REMOVE_CLASS_SUFFIX];
      } else if (val === REMOVE_CLASS) {
        prop = 'removeClass';
        allow = existing[klass] || existing[klass + ADD_CLASS_SUFFIX];
      }
      if (allow) {
        if (classes[prop].length) {
          classes[prop] += ' ';
        }
        classes[prop] += klass;
      }
    });
    function splitClassesToLookup(classes) {
      if (isString(classes)) {
        classes = classes.split(' ');
      }
      var obj = {};
      forEach(classes, function (klass) {
        // sometimes the split leaves empty string values
        // incase extra spaces were applied to the options
        if (klass.length) {
          obj[klass] = true;
        }
      });
      return obj;
    }
    return classes;
  }
  function getDomNode(element) {
    return element instanceof jqLite ? element[0] : element;
  }
  function applyGeneratedPreparationClasses($$jqLite, element, event, options) {
    var classes = '';
    if (event) {
      classes = pendClasses(event, EVENT_CLASS_PREFIX, true);
    }
    if (options.addClass) {
      classes = concatWithSpace(classes, pendClasses(options.addClass, ADD_CLASS_SUFFIX));
    }
    if (options.removeClass) {
      classes = concatWithSpace(classes, pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX));
    }
    if (classes.length) {
      options.preparationClasses = classes;
      element.addClass(classes);
    }
  }
  function clearGeneratedClasses(element, options) {
    if (options.preparationClasses) {
      element.removeClass(options.preparationClasses);
      options.preparationClasses = null;
    }
    if (options.activeClasses) {
      element.removeClass(options.activeClasses);
      options.activeClasses = null;
    }
  }
  function blockKeyframeAnimations(node, applyBlock) {
    var value = applyBlock ? 'paused' : '';
    var key = ANIMATION_PROP + ANIMATION_PLAYSTATE_KEY;
    applyInlineStyle(node, [key, value]);
    return [key, value];
  }
  function applyInlineStyle(node, styleTuple) {
    var prop = styleTuple[0];
    var value = styleTuple[1];
    node.style[prop] = value;
  }
  function concatWithSpace(a, b) {
    if (!a) return b;
    if (!b) return a;
    return a + ' ' + b;
  }
  var helpers = {
    blockTransitions: function blockTransitions(node, duration) {
      // we use a negative delay value since it performs blocking
      // yet it doesn't kill any existing transitions running on the
      // same element which makes this safe for class-based animations
      var value = duration ? '-' + duration + 's' : '';
      applyInlineStyle(node, [TRANSITION_DELAY_PROP, value]);
      return [TRANSITION_DELAY_PROP, value];
    }
  };
  var $$rAFSchedulerFactory = ['$$rAF', function ($$rAF) {
    var queue, cancelFn;
    function scheduler(tasks) {
      // we make a copy since RAFScheduler mutates the state
      // of the passed in array variable and this would be difficult
      // to track down on the outside code
      queue = queue.concat(tasks);
      nextTick();
    }
    queue = scheduler.queue = [];

    /* waitUntilQuiet does two things:
     * 1. It will run the FINAL `fn` value only when an uncanceled RAF has passed through
     * 2. It will delay the next wave of tasks from running until the quiet `fn` has run.
     *
     * The motivation here is that animation code can request more time from the scheduler
     * before the next wave runs. This allows for certain DOM properties such as classes to
     * be resolved in time for the next animation to run.
     */
    scheduler.waitUntilQuiet = function (fn) {
      if (cancelFn) cancelFn();
      cancelFn = $$rAF(function () {
        cancelFn = null;
        fn();
        nextTick();
      });
    };
    return scheduler;
    function nextTick() {
      if (!queue.length) return;
      var items = queue.shift();
      for (var i = 0; i < items.length; i++) {
        items[i]();
      }
      if (!cancelFn) {
        $$rAF(function () {
          if (!cancelFn) nextTick();
        });
      }
    }
  }];

  /**
   * @ngdoc directive
   * @name ngAnimateChildren
   * @restrict AE
   * @element ANY
   *
   * @description
   *
   * ngAnimateChildren allows you to specify that children of this element should animate even if any
   * of the children's parents are currently animating. By default, when an element has an active `enter`, `leave`, or `move`
   * (structural) animation, child elements that also have an active structural animation are not animated.
   *
   * Note that even if `ngAnimateChildren` is set, no child animations will run when the parent element is removed from the DOM (`leave` animation).
   *
   *
   * @param {string} ngAnimateChildren If the value is empty, `true` or `on`,
   *     then child animations are allowed. If the value is `false`, child animations are not allowed.
   *
   * @example
   * <example module="ngAnimateChildren" name="ngAnimateChildren" deps="angular-animate.js" animations="true">
       <file name="index.html">
         <div ng-controller="MainController as main">
           <label>Show container? <input type="checkbox" ng-model="main.enterElement" /></label>
           <label>Animate children? <input type="checkbox" ng-model="main.animateChildren" /></label>
           <hr>
           <div ng-animate-children="{{main.animateChildren}}">
             <div ng-if="main.enterElement" class="container">
               List of items:
               <div ng-repeat="item in [0, 1, 2, 3]" class="item">Item {{item}}</div>
             </div>
           </div>
         </div>
       </file>
       <file name="animations.css">
  
        .container.ng-enter,
        .container.ng-leave {
          transition: all ease 1.5s;
        }
  
        .container.ng-enter,
        .container.ng-leave-active {
          opacity: 0;
        }
  
        .container.ng-leave,
        .container.ng-enter-active {
          opacity: 1;
        }
  
        .item {
          background: firebrick;
          color: #FFF;
          margin-bottom: 10px;
        }
  
        .item.ng-enter,
        .item.ng-leave {
          transition: transform 1.5s ease;
        }
  
        .item.ng-enter {
          transform: translateX(50px);
        }
  
        .item.ng-enter-active {
          transform: translateX(0);
        }
      </file>
      <file name="script.js">
        angular.module('ngAnimateChildren', ['ngAnimate'])
          .controller('MainController', function MainController() {
            this.animateChildren = false;
            this.enterElement = false;
          });
      </file>
    </example>
   */
  var $$AnimateChildrenDirective = ['$interpolate', function ($interpolate) {
    return {
      link: function link(scope, element, attrs) {
        var val = attrs.ngAnimateChildren;
        if (isString(val) && val.length === 0) {
          //empty attribute
          element.data(NG_ANIMATE_CHILDREN_DATA, true);
        } else {
          // Interpolate and set the value, so that it is available to
          // animations that run right after compilation
          setData($interpolate(val)(scope));
          attrs.$observe('ngAnimateChildren', setData);
        }
        function setData(value) {
          value = value === 'on' || value === 'true';
          element.data(NG_ANIMATE_CHILDREN_DATA, value);
        }
      }
    };
  }];

  /* exported $AnimateCssProvider */

  var ANIMATE_TIMER_KEY = '$$animateCss';

  /**
   * @ngdoc service
   * @name $animateCss
   * @kind object
   *
   * @description
   * The `$animateCss` service is a useful utility to trigger customized CSS-based transitions/keyframes
   * from a JavaScript-based animation or directly from a directive. The purpose of `$animateCss` is NOT
   * to side-step how `$animate` and ngAnimate work, but the goal is to allow pre-existing animations or
   * directives to create more complex animations that can be purely driven using CSS code.
   *
   * Note that only browsers that support CSS transitions and/or keyframe animations are capable of
   * rendering animations triggered via `$animateCss` (bad news for IE9 and lower).
   *
   * ## General Use
   * Once again, `$animateCss` is designed to be used inside of a registered JavaScript animation that
   * is powered by ngAnimate. It is possible to use `$animateCss` directly inside of a directive, however,
   * any automatic control over cancelling animations and/or preventing animations from being run on
   * child elements will not be handled by AngularJS. For this to work as expected, please use `$animate` to
   * trigger the animation and then setup a JavaScript animation that injects `$animateCss` to trigger
   * the CSS animation.
   *
   * The example below shows how we can create a folding animation on an element using `ng-if`:
   *
   * ```html
   * <!-- notice the `fold-animation` CSS class -->
   * <div ng-if="onOff" class="fold-animation">
   *   This element will go BOOM
   * </div>
   * <button ng-click="onOff=true">Fold In</button>
   * ```
   *
   * Now we create the **JavaScript animation** that will trigger the CSS transition:
   *
   * ```js
   * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
   *   return {
   *     enter: function(element, doneFn) {
   *       var height = element[0].offsetHeight;
   *       return $animateCss(element, {
   *         from: { height:'0px' },
   *         to: { height:height + 'px' },
   *         duration: 1 // one second
   *       });
   *     }
   *   }
   * }]);
   * ```
   *
   * ## More Advanced Uses
   *
   * `$animateCss` is the underlying code that ngAnimate uses to power **CSS-based animations** behind the scenes. Therefore CSS hooks
   * like `.ng-EVENT`, `.ng-EVENT-active`, `.ng-EVENT-stagger` are all features that can be triggered using `$animateCss` via JavaScript code.
   *
   * This also means that just about any combination of adding classes, removing classes, setting styles, dynamically setting a keyframe animation,
   * applying a hardcoded duration or delay value, changing the animation easing or applying a stagger animation are all options that work with
   * `$animateCss`. The service itself is smart enough to figure out the combination of options and examine the element styling properties in order
   * to provide a working animation that will run in CSS.
   *
   * The example below showcases a more advanced version of the `.fold-animation` from the example above:
   *
   * ```js
   * ngModule.animation('.fold-animation', ['$animateCss', function($animateCss) {
   *   return {
   *     enter: function(element, doneFn) {
   *       var height = element[0].offsetHeight;
   *       return $animateCss(element, {
   *         addClass: 'red large-text pulse-twice',
   *         easing: 'ease-out',
   *         from: { height:'0px' },
   *         to: { height:height + 'px' },
   *         duration: 1 // one second
   *       });
   *     }
   *   }
   * }]);
   * ```
   *
   * Since we're adding/removing CSS classes then the CSS transition will also pick those up:
   *
   * ```css
   * /&#42; since a hardcoded duration value of 1 was provided in the JavaScript animation code,
   * the CSS classes below will be transitioned despite them being defined as regular CSS classes &#42;/
   * .red { background:red; }
   * .large-text { font-size:20px; }
   *
   * /&#42; we can also use a keyframe animation and $animateCss will make it work alongside the transition &#42;/
   * .pulse-twice {
   *   animation: 0.5s pulse linear 2;
   *   -webkit-animation: 0.5s pulse linear 2;
   * }
   *
   * @keyframes pulse {
   *   from { transform: scale(0.5); }
   *   to { transform: scale(1.5); }
   * }
   *
   * @-webkit-keyframes pulse {
   *   from { -webkit-transform: scale(0.5); }
   *   to { -webkit-transform: scale(1.5); }
   * }
   * ```
   *
   * Given this complex combination of CSS classes, styles and options, `$animateCss` will figure everything out and make the animation happen.
   *
   * ## How the Options are handled
   *
   * `$animateCss` is very versatile and intelligent when it comes to figuring out what configurations to apply to the element to ensure the animation
   * works with the options provided. Say for example we were adding a class that contained a keyframe value and we wanted to also animate some inline
   * styles using the `from` and `to` properties.
   *
   * ```js
   * var animator = $animateCss(element, {
   *   from: { background:'red' },
   *   to: { background:'blue' }
   * });
   * animator.start();
   * ```
   *
   * ```css
   * .rotating-animation {
   *   animation:0.5s rotate linear;
   *   -webkit-animation:0.5s rotate linear;
   * }
   *
   * @keyframes rotate {
   *   from { transform: rotate(0deg); }
   *   to { transform: rotate(360deg); }
   * }
   *
   * @-webkit-keyframes rotate {
   *   from { -webkit-transform: rotate(0deg); }
   *   to { -webkit-transform: rotate(360deg); }
   * }
   * ```
   *
   * The missing pieces here are that we do not have a transition set (within the CSS code nor within the `$animateCss` options) and the duration of the animation is
   * going to be detected from what the keyframe styles on the CSS class are. In this event, `$animateCss` will automatically create an inline transition
   * style matching the duration detected from the keyframe style (which is present in the CSS class that is being added) and then prepare both the transition
   * and keyframe animations to run in parallel on the element. Then when the animation is underway the provided `from` and `to` CSS styles will be applied
   * and spread across the transition and keyframe animation.
   *
   * ## What is returned
   *
   * `$animateCss` works in two stages: a preparation phase and an animation phase. Therefore when `$animateCss` is first called it will NOT actually
   * start the animation. All that is going on here is that the element is being prepared for the animation (which means that the generated CSS classes are
   * added and removed on the element). Once `$animateCss` is called it will return an object with the following properties:
   *
   * ```js
   * var animator = $animateCss(element, { ... });
   * ```
   *
   * Now what do the contents of our `animator` variable look like:
   *
   * ```js
   * {
   *   // starts the animation
   *   start: Function,
   *
   *   // ends (aborts) the animation
   *   end: Function
   * }
   * ```
   *
   * To actually start the animation we need to run `animation.start()` which will then return a promise that we can hook into to detect when the animation ends.
   * If we choose not to run the animation then we MUST run `animation.end()` to perform a cleanup on the element (since some CSS classes and styles may have been
   * applied to the element during the preparation phase). Note that all other properties such as duration, delay, transitions and keyframes are just properties
   * and that changing them will not reconfigure the parameters of the animation.
   *
   * ### runner.done() vs runner.then()
   * It is documented that `animation.start()` will return a promise object and this is true, however, there is also an additional method available on the
   * runner called `.done(callbackFn)`. The done method works the same as `.finally(callbackFn)`, however, it does **not trigger a digest to occur**.
   * Therefore, for performance reasons, it's always best to use `runner.done(callback)` instead of `runner.then()`, `runner.catch()` or `runner.finally()`
   * unless you really need a digest to kick off afterwards.
   *
   * Keep in mind that, to make this easier, ngAnimate has tweaked the JS animations API to recognize when a runner instance is returned from $animateCss
   * (so there is no need to call `runner.done(doneFn)` inside of your JavaScript animation code).
   * Check the {@link ngAnimate.$animateCss#usage animation code above} to see how this works.
   *
   * @param {DOMElement} element the element that will be animated
   * @param {object} options the animation-related options that will be applied during the animation
   *
   * * `event` - The DOM event (e.g. enter, leave, move). When used, a generated CSS class of `ng-EVENT` and `ng-EVENT-active` will be applied
   * to the element during the animation. Multiple events can be provided when spaces are used as a separator. (Note that this will not perform any DOM operation.)
   * * `structural` - Indicates that the `ng-` prefix will be added to the event class. Setting to `false` or omitting will turn `ng-EVENT` and
   * `ng-EVENT-active` in `EVENT` and `EVENT-active`. Unused if `event` is omitted.
   * * `easing` - The CSS easing value that will be applied to the transition or keyframe animation (or both).
   * * `transitionStyle` - The raw CSS transition style that will be used (e.g. `1s linear all`).
   * * `keyframeStyle` - The raw CSS keyframe animation style that will be used (e.g. `1s my_animation linear`).
   * * `from` - The starting CSS styles (a key/value object) that will be applied at the start of the animation.
   * * `to` - The ending CSS styles (a key/value object) that will be applied across the animation via a CSS transition.
   * * `addClass` - A space separated list of CSS classes that will be added to the element and spread across the animation.
   * * `removeClass` - A space separated list of CSS classes that will be removed from the element and spread across the animation.
   * * `duration` - A number value representing the total duration of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `0`
   * is provided then the animation will be skipped entirely.
   * * `delay` - A number value representing the total delay of the transition and/or keyframe (note that a value of 1 is 1000ms). If a value of `true` is
   * used then whatever delay value is detected from the CSS classes will be mirrored on the elements styles (e.g. by setting delay true then the style value
   * of the element will be `transition-delay: DETECTED_VALUE`). Using `true` is useful when you want the CSS classes and inline styles to all share the same
   * CSS delay value.
   * * `stagger` - A numeric time value representing the delay between successively animated elements
   * ({@link ngAnimate#css-staggering-animations Click here to learn how CSS-based staggering works in ngAnimate.})
   * * `staggerIndex` - The numeric index representing the stagger item (e.g. a value of 5 is equal to the sixth item in the stagger; therefore when a
   *   `stagger` option value of `0.1` is used then there will be a stagger delay of `600ms`)
   * * `applyClassesEarly` - Whether or not the classes being added or removed will be used when detecting the animation. This is set by `$animate` when enter/leave/move animations are fired to ensure that the CSS classes are resolved in time. (Note that this will prevent any transitions from occurring on the classes being added and removed.)
   * * `cleanupStyles` - Whether or not the provided `from` and `to` styles will be removed once
   *    the animation is closed. This is useful for when the styles are used purely for the sake of
   *    the animation and do not have a lasting visual effect on the element (e.g. a collapse and open animation).
   *    By default this value is set to `false`.
   *
   * @return {object} an object with start and end methods and details about the animation.
   *
   * * `start` - The method to start the animation. This will return a `Promise` when called.
   * * `end` - This method will cancel the animation and remove all applied CSS classes and styles.
   */
  var ONE_SECOND = 1000;
  var ELAPSED_TIME_MAX_DECIMAL_PLACES = 3;
  var CLOSING_TIME_BUFFER = 1.5;
  var DETECT_CSS_PROPERTIES = {
    transitionDuration: TRANSITION_DURATION_PROP,
    transitionDelay: TRANSITION_DELAY_PROP,
    transitionProperty: TRANSITION_PROP + PROPERTY_KEY,
    animationDuration: ANIMATION_DURATION_PROP,
    animationDelay: ANIMATION_DELAY_PROP,
    animationIterationCount: ANIMATION_PROP + ANIMATION_ITERATION_COUNT_KEY
  };
  var DETECT_STAGGER_CSS_PROPERTIES = {
    transitionDuration: TRANSITION_DURATION_PROP,
    transitionDelay: TRANSITION_DELAY_PROP,
    animationDuration: ANIMATION_DURATION_PROP,
    animationDelay: ANIMATION_DELAY_PROP
  };
  function getCssKeyframeDurationStyle(duration) {
    return [ANIMATION_DURATION_PROP, duration + 's'];
  }
  function getCssDelayStyle(delay, isKeyframeAnimation) {
    var prop = isKeyframeAnimation ? ANIMATION_DELAY_PROP : TRANSITION_DELAY_PROP;
    return [prop, delay + 's'];
  }
  function computeCssStyles($window, element, properties) {
    var styles = Object.create(null);
    var detectedStyles = $window.getComputedStyle(element) || {};
    forEach(properties, function (formalStyleName, actualStyleName) {
      var val = detectedStyles[formalStyleName];
      if (val) {
        var c = val.charAt(0);

        // only numerical-based values have a negative sign or digit as the first value
        if (c === '-' || c === '+' || c >= 0) {
          val = parseMaxTime(val);
        }

        // by setting this to null in the event that the delay is not set or is set directly as 0
        // then we can still allow for negative values to be used later on and not mistake this
        // value for being greater than any other negative value.
        if (val === 0) {
          val = null;
        }
        styles[actualStyleName] = val;
      }
    });
    return styles;
  }
  function parseMaxTime(str) {
    var maxValue = 0;
    var values = str.split(/\s*,\s*/);
    forEach(values, function (value) {
      // it's always safe to consider only second values and omit `ms` values since
      // getComputedStyle will always handle the conversion for us
      if (value.charAt(value.length - 1) === 's') {
        value = value.substring(0, value.length - 1);
      }
      value = parseFloat(value) || 0;
      maxValue = maxValue ? Math.max(value, maxValue) : value;
    });
    return maxValue;
  }
  function truthyTimingValue(val) {
    return val === 0 || val != null;
  }
  function getCssTransitionDurationStyle(duration, applyOnlyDuration) {
    var style = TRANSITION_PROP;
    var value = duration + 's';
    if (applyOnlyDuration) {
      style += DURATION_KEY;
    } else {
      value += ' linear all';
    }
    return [style, value];
  }

  // we do not reassign an already present style value since
  // if we detect the style property value again we may be
  // detecting styles that were added via the `from` styles.
  // We make use of `isDefined` here since an empty string
  // or null value (which is what getPropertyValue will return
  // for a non-existing style) will still be marked as a valid
  // value for the style (a falsy value implies that the style
  // is to be removed at the end of the animation). If we had a simple
  // "OR" statement then it would not be enough to catch that.
  function registerRestorableStyles(backup, node, properties) {
    forEach(properties, function (prop) {
      backup[prop] = isDefined(backup[prop]) ? backup[prop] : node.style.getPropertyValue(prop);
    });
  }
  var $AnimateCssProvider = ['$animateProvider', /** @this */function ($animateProvider) {
    this.$get = ['$window', '$$jqLite', '$$AnimateRunner', '$timeout', '$$animateCache', '$$forceReflow', '$sniffer', '$$rAFScheduler', '$$animateQueue', function ($window, $$jqLite, $$AnimateRunner, $timeout, $$animateCache, $$forceReflow, $sniffer, $$rAFScheduler, $$animateQueue) {
      var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
      function computeCachedCssStyles(node, className, cacheKey, allowNoDuration, properties) {
        var timings = $$animateCache.get(cacheKey);
        if (!timings) {
          timings = computeCssStyles($window, node, properties);
          if (timings.animationIterationCount === 'infinite') {
            timings.animationIterationCount = 1;
          }
        }

        // if a css animation has no duration we
        // should mark that so that repeated addClass/removeClass calls are skipped
        var hasDuration = allowNoDuration || timings.transitionDuration > 0 || timings.animationDuration > 0;

        // we keep putting this in multiple times even though the value and the cacheKey are the same
        // because we're keeping an internal tally of how many duplicate animations are detected.
        $$animateCache.put(cacheKey, timings, hasDuration);
        return timings;
      }
      function computeCachedCssStaggerStyles(node, className, cacheKey, properties) {
        var stagger;
        var staggerCacheKey = 'stagger-' + cacheKey;

        // if we have one or more existing matches of matching elements
        // containing the same parent + CSS styles (which is how cacheKey works)
        // then staggering is possible
        if ($$animateCache.count(cacheKey) > 0) {
          stagger = $$animateCache.get(staggerCacheKey);
          if (!stagger) {
            var staggerClassName = pendClasses(className, '-stagger');
            $$jqLite.addClass(node, staggerClassName);
            stagger = computeCssStyles($window, node, properties);

            // force the conversion of a null value to zero incase not set
            stagger.animationDuration = Math.max(stagger.animationDuration, 0);
            stagger.transitionDuration = Math.max(stagger.transitionDuration, 0);
            $$jqLite.removeClass(node, staggerClassName);
            $$animateCache.put(staggerCacheKey, stagger, true);
          }
        }
        return stagger || {};
      }
      var rafWaitQueue = [];
      function waitUntilQuiet(callback) {
        rafWaitQueue.push(callback);
        $$rAFScheduler.waitUntilQuiet(function () {
          $$animateCache.flush();

          // DO NOT REMOVE THIS LINE OR REFACTOR OUT THE `pageWidth` variable.
          // PLEASE EXAMINE THE `$$forceReflow` service to understand why.
          var pageWidth = $$forceReflow();

          // we use a for loop to ensure that if the queue is changed
          // during this looping then it will consider new requests
          for (var i = 0; i < rafWaitQueue.length; i++) {
            rafWaitQueue[i](pageWidth);
          }
          rafWaitQueue.length = 0;
        });
      }
      function computeTimings(node, className, cacheKey, allowNoDuration) {
        var timings = computeCachedCssStyles(node, className, cacheKey, allowNoDuration, DETECT_CSS_PROPERTIES);
        var aD = timings.animationDelay;
        var tD = timings.transitionDelay;
        timings.maxDelay = aD && tD ? Math.max(aD, tD) : aD || tD;
        timings.maxDuration = Math.max(timings.animationDuration * timings.animationIterationCount, timings.transitionDuration);
        return timings;
      }
      return function init(element, initialOptions) {
        // all of the animation functions should create
        // a copy of the options data, however, if a
        // parent service has already created a copy then
        // we should stick to using that
        var options = initialOptions || {};
        if (!options.$$prepared) {
          options = prepareAnimationOptions(copy(options));
        }
        var restoreStyles = {};
        var node = getDomNode(element);
        if (!node || !node.parentNode || !$$animateQueue.enabled()) {
          return closeAndReturnNoopAnimator();
        }
        var temporaryStyles = [];
        var classes = element.attr('class');
        var styles = packageStyles(options);
        var animationClosed;
        var animationPaused;
        var animationCompleted;
        var runner;
        var runnerHost;
        var maxDelay;
        var maxDelayTime;
        var maxDuration;
        var maxDurationTime;
        var startTime;
        var events = [];
        if (options.duration === 0 || !$sniffer.animations && !$sniffer.transitions) {
          return closeAndReturnNoopAnimator();
        }
        var method = options.event && isArray(options.event) ? options.event.join(' ') : options.event;
        var isStructural = method && options.structural;
        var structuralClassName = '';
        var addRemoveClassName = '';
        if (isStructural) {
          structuralClassName = pendClasses(method, EVENT_CLASS_PREFIX, true);
        } else if (method) {
          structuralClassName = method;
        }
        if (options.addClass) {
          addRemoveClassName += pendClasses(options.addClass, ADD_CLASS_SUFFIX);
        }
        if (options.removeClass) {
          if (addRemoveClassName.length) {
            addRemoveClassName += ' ';
          }
          addRemoveClassName += pendClasses(options.removeClass, REMOVE_CLASS_SUFFIX);
        }

        // there may be a situation where a structural animation is combined together
        // with CSS classes that need to resolve before the animation is computed.
        // However this means that there is no explicit CSS code to block the animation
        // from happening (by setting 0s none in the class name). If this is the case
        // we need to apply the classes before the first rAF so we know to continue if
        // there actually is a detected transition or keyframe animation
        if (options.applyClassesEarly && addRemoveClassName.length) {
          applyAnimationClasses(element, options);
        }
        var preparationClasses = [structuralClassName, addRemoveClassName].join(' ').trim();
        var fullClassName = classes + ' ' + preparationClasses;
        var hasToStyles = styles.to && Object.keys(styles.to).length > 0;
        var containsKeyframeAnimation = (options.keyframeStyle || '').length > 0;

        // there is no way we can trigger an animation if no styles and
        // no classes are being applied which would then trigger a transition,
        // unless there a is raw keyframe value that is applied to the element.
        if (!containsKeyframeAnimation && !hasToStyles && !preparationClasses) {
          return closeAndReturnNoopAnimator();
        }
        var stagger,
          cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
        if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
          preparationClasses = null;
          return closeAndReturnNoopAnimator();
        }
        if (options.stagger > 0) {
          var staggerVal = parseFloat(options.stagger);
          stagger = {
            transitionDelay: staggerVal,
            animationDelay: staggerVal,
            transitionDuration: 0,
            animationDuration: 0
          };
        } else {
          stagger = computeCachedCssStaggerStyles(node, preparationClasses, cacheKey, DETECT_STAGGER_CSS_PROPERTIES);
        }
        if (!options.$$skipPreparationClasses) {
          $$jqLite.addClass(element, preparationClasses);
        }
        var applyOnlyDuration;
        if (options.transitionStyle) {
          var transitionStyle = [TRANSITION_PROP, options.transitionStyle];
          applyInlineStyle(node, transitionStyle);
          temporaryStyles.push(transitionStyle);
        }
        if (options.duration >= 0) {
          applyOnlyDuration = node.style[TRANSITION_PROP].length > 0;
          var durationStyle = getCssTransitionDurationStyle(options.duration, applyOnlyDuration);

          // we set the duration so that it will be picked up by getComputedStyle later
          applyInlineStyle(node, durationStyle);
          temporaryStyles.push(durationStyle);
        }
        if (options.keyframeStyle) {
          var keyframeStyle = [ANIMATION_PROP, options.keyframeStyle];
          applyInlineStyle(node, keyframeStyle);
          temporaryStyles.push(keyframeStyle);
        }
        var itemIndex = stagger ? options.staggerIndex >= 0 ? options.staggerIndex : $$animateCache.count(cacheKey) : 0;
        var isFirst = itemIndex === 0;

        // this is a pre-emptive way of forcing the setup classes to be added and applied INSTANTLY
        // without causing any combination of transitions to kick in. By adding a negative delay value
        // it forces the setup class' transition to end immediately. We later then remove the negative
        // transition delay to allow for the transition to naturally do it's thing. The beauty here is
        // that if there is no transition defined then nothing will happen and this will also allow
        // other transitions to be stacked on top of each other without any chopping them out.
        if (isFirst && !options.skipBlocking) {
          helpers.blockTransitions(node, SAFE_FAST_FORWARD_DURATION_VALUE);
        }
        var timings = computeTimings(node, fullClassName, cacheKey, !isStructural);
        var relativeDelay = timings.maxDelay;
        maxDelay = Math.max(relativeDelay, 0);
        maxDuration = timings.maxDuration;
        var flags = {};
        flags.hasTransitions = timings.transitionDuration > 0;
        flags.hasAnimations = timings.animationDuration > 0;
        flags.hasTransitionAll = flags.hasTransitions && timings.transitionProperty === 'all';
        flags.applyTransitionDuration = hasToStyles && (flags.hasTransitions && !flags.hasTransitionAll || flags.hasAnimations && !flags.hasTransitions);
        flags.applyAnimationDuration = options.duration && flags.hasAnimations;
        flags.applyTransitionDelay = truthyTimingValue(options.delay) && (flags.applyTransitionDuration || flags.hasTransitions);
        flags.applyAnimationDelay = truthyTimingValue(options.delay) && flags.hasAnimations;
        flags.recalculateTimingStyles = addRemoveClassName.length > 0;
        if (flags.applyTransitionDuration || flags.applyAnimationDuration) {
          maxDuration = options.duration ? parseFloat(options.duration) : maxDuration;
          if (flags.applyTransitionDuration) {
            flags.hasTransitions = true;
            timings.transitionDuration = maxDuration;
            applyOnlyDuration = node.style[TRANSITION_PROP + PROPERTY_KEY].length > 0;
            temporaryStyles.push(getCssTransitionDurationStyle(maxDuration, applyOnlyDuration));
          }
          if (flags.applyAnimationDuration) {
            flags.hasAnimations = true;
            timings.animationDuration = maxDuration;
            temporaryStyles.push(getCssKeyframeDurationStyle(maxDuration));
          }
        }
        if (maxDuration === 0 && !flags.recalculateTimingStyles) {
          return closeAndReturnNoopAnimator();
        }
        var activeClasses = pendClasses(preparationClasses, ACTIVE_CLASS_SUFFIX);
        if (options.delay != null) {
          var delayStyle;
          if (typeof options.delay !== 'boolean') {
            delayStyle = parseFloat(options.delay);
            // number in options.delay means we have to recalculate the delay for the closing timeout
            maxDelay = Math.max(delayStyle, 0);
          }
          if (flags.applyTransitionDelay) {
            temporaryStyles.push(getCssDelayStyle(delayStyle));
          }
          if (flags.applyAnimationDelay) {
            temporaryStyles.push(getCssDelayStyle(delayStyle, true));
          }
        }

        // we need to recalculate the delay value since we used a pre-emptive negative
        // delay value and the delay value is required for the final event checking. This
        // property will ensure that this will happen after the RAF phase has passed.
        if (options.duration == null && timings.transitionDuration > 0) {
          flags.recalculateTimingStyles = flags.recalculateTimingStyles || isFirst;
        }
        maxDelayTime = maxDelay * ONE_SECOND;
        maxDurationTime = maxDuration * ONE_SECOND;
        if (!options.skipBlocking) {
          flags.blockTransition = timings.transitionDuration > 0;
          flags.blockKeyframeAnimation = timings.animationDuration > 0 && stagger.animationDelay > 0 && stagger.animationDuration === 0;
        }
        if (options.from) {
          if (options.cleanupStyles) {
            registerRestorableStyles(restoreStyles, node, Object.keys(options.from));
          }
          applyAnimationFromStyles(element, options);
        }
        if (flags.blockTransition || flags.blockKeyframeAnimation) {
          applyBlocking(maxDuration);
        } else if (!options.skipBlocking) {
          helpers.blockTransitions(node, false);
        }

        // TODO(matsko): for 1.5 change this code to have an animator object for better debugging
        return {
          $$willAnimate: true,
          end: endFn,
          start: function start() {
            if (animationClosed) return;
            runnerHost = {
              end: endFn,
              cancel: cancelFn,
              resume: null,
              //this will be set during the start() phase
              pause: null
            };
            runner = new $$AnimateRunner(runnerHost);
            waitUntilQuiet(_start);

            // we don't have access to pause/resume the animation
            // since it hasn't run yet. AnimateRunner will therefore
            // set noop functions for resume and pause and they will
            // later be overridden once the animation is triggered
            return runner;
          }
        };
        function endFn() {
          close();
        }
        function cancelFn() {
          close(true);
        }
        function close(rejected) {
          // if the promise has been called already then we shouldn't close
          // the animation again
          if (animationClosed || animationCompleted && animationPaused) return;
          animationClosed = true;
          animationPaused = false;
          if (preparationClasses && !options.$$skipPreparationClasses) {
            $$jqLite.removeClass(element, preparationClasses);
          }
          if (activeClasses) {
            $$jqLite.removeClass(element, activeClasses);
          }
          blockKeyframeAnimations(node, false);
          helpers.blockTransitions(node, false);
          forEach(temporaryStyles, function (entry) {
            // There is only one way to remove inline style properties entirely from elements.
            // By using `removeProperty` this works, but we need to convert camel-cased CSS
            // styles down to hyphenated values.
            node.style[entry[0]] = '';
          });
          applyAnimationClasses(element, options);
          applyAnimationStyles(element, options);
          if (Object.keys(restoreStyles).length) {
            forEach(restoreStyles, function (value, prop) {
              if (value) {
                node.style.setProperty(prop, value);
              } else {
                node.style.removeProperty(prop);
              }
            });
          }

          // the reason why we have this option is to allow a synchronous closing callback
          // that is fired as SOON as the animation ends (when the CSS is removed) or if
          // the animation never takes off at all. A good example is a leave animation since
          // the element must be removed just after the animation is over or else the element
          // will appear on screen for one animation frame causing an overbearing flicker.
          if (options.onDone) {
            options.onDone();
          }
          if (events && events.length) {
            // Remove the transitionend / animationend listener(s)
            element.off(events.join(' '), onAnimationProgress);
          }

          //Cancel the fallback closing timeout and remove the timer data
          var animationTimerData = element.data(ANIMATE_TIMER_KEY);
          if (animationTimerData) {
            $timeout.cancel(animationTimerData[0].timer);
            element.removeData(ANIMATE_TIMER_KEY);
          }

          // if the preparation function fails then the promise is not setup
          if (runner) {
            runner.complete(!rejected);
          }
        }
        function applyBlocking(duration) {
          if (flags.blockTransition) {
            helpers.blockTransitions(node, duration);
          }
          if (flags.blockKeyframeAnimation) {
            blockKeyframeAnimations(node, !!duration);
          }
        }
        function closeAndReturnNoopAnimator() {
          runner = new $$AnimateRunner({
            end: endFn,
            cancel: cancelFn
          });

          // should flush the cache animation
          waitUntilQuiet(noop);
          close();
          return {
            $$willAnimate: false,
            start: function start() {
              return runner;
            },
            end: endFn
          };
        }
        function onAnimationProgress(event) {
          event.stopPropagation();
          var ev = event.originalEvent || event;
          if (ev.target !== node) {
            // Since TransitionEvent / AnimationEvent bubble up,
            // we have to ignore events by finished child animations
            return;
          }

          // we now always use `Date.now()` due to the recent changes with
          // event.timeStamp in Firefox, Webkit and Chrome (see #13494 for more info)
          var timeStamp = ev.$manualTimeStamp || Date.now();

          /* Firefox (or possibly just Gecko) likes to not round values up
           * when a ms measurement is used for the animation */
          var elapsedTime = parseFloat(ev.elapsedTime.toFixed(ELAPSED_TIME_MAX_DECIMAL_PLACES));

          /* $manualTimeStamp is a mocked timeStamp value which is set
           * within browserTrigger(). This is only here so that tests can
           * mock animations properly. Real events fallback to event.timeStamp,
           * or, if they don't, then a timeStamp is automatically created for them.
           * We're checking to see if the timeStamp surpasses the expected delay,
           * but we're using elapsedTime instead of the timeStamp on the 2nd
           * pre-condition since animationPauseds sometimes close off early */
          if (Math.max(timeStamp - startTime, 0) >= maxDelayTime && elapsedTime >= maxDuration) {
            // we set this flag to ensure that if the transition is paused then, when resumed,
            // the animation will automatically close itself since transitions cannot be paused.
            animationCompleted = true;
            close();
          }
        }
        function _start() {
          if (animationClosed) return;
          if (!node.parentNode) {
            close();
            return;
          }

          // even though we only pause keyframe animations here the pause flag
          // will still happen when transitions are used. Only the transition will
          // not be paused since that is not possible. If the animation ends when
          // paused then it will not complete until unpaused or cancelled.
          var playPause = function playPause(playAnimation) {
            if (!animationCompleted) {
              animationPaused = !playAnimation;
              if (timings.animationDuration) {
                var value = blockKeyframeAnimations(node, animationPaused);
                if (animationPaused) {
                  temporaryStyles.push(value);
                } else {
                  removeFromArray(temporaryStyles, value);
                }
              }
            } else if (animationPaused && playAnimation) {
              animationPaused = false;
              close();
            }
          };

          // checking the stagger duration prevents an accidentally cascade of the CSS delay style
          // being inherited from the parent. If the transition duration is zero then we can safely
          // rely that the delay value is an intentional stagger delay style.
          var maxStagger = itemIndex > 0 && (timings.transitionDuration && stagger.transitionDuration === 0 || timings.animationDuration && stagger.animationDuration === 0) && Math.max(stagger.animationDelay, stagger.transitionDelay);
          if (maxStagger) {
            $timeout(triggerAnimationStart, Math.floor(maxStagger * itemIndex * ONE_SECOND), false);
          } else {
            triggerAnimationStart();
          }

          // this will decorate the existing promise runner with pause/resume methods
          runnerHost.resume = function () {
            playPause(true);
          };
          runnerHost.pause = function () {
            playPause(false);
          };
          function triggerAnimationStart() {
            // just incase a stagger animation kicks in when the animation
            // itself was cancelled entirely
            if (animationClosed) return;
            applyBlocking(false);
            forEach(temporaryStyles, function (entry) {
              var key = entry[0];
              var value = entry[1];
              node.style[key] = value;
            });
            applyAnimationClasses(element, options);
            $$jqLite.addClass(element, activeClasses);
            if (flags.recalculateTimingStyles) {
              fullClassName = node.getAttribute('class') + ' ' + preparationClasses;
              cacheKey = $$animateCache.cacheKey(node, method, options.addClass, options.removeClass);
              timings = computeTimings(node, fullClassName, cacheKey, false);
              relativeDelay = timings.maxDelay;
              maxDelay = Math.max(relativeDelay, 0);
              maxDuration = timings.maxDuration;
              if (maxDuration === 0) {
                close();
                return;
              }
              flags.hasTransitions = timings.transitionDuration > 0;
              flags.hasAnimations = timings.animationDuration > 0;
            }
            if (flags.applyAnimationDelay) {
              relativeDelay = typeof options.delay !== 'boolean' && truthyTimingValue(options.delay) ? parseFloat(options.delay) : relativeDelay;
              maxDelay = Math.max(relativeDelay, 0);
              timings.animationDelay = relativeDelay;
              delayStyle = getCssDelayStyle(relativeDelay, true);
              temporaryStyles.push(delayStyle);
              node.style[delayStyle[0]] = delayStyle[1];
            }
            maxDelayTime = maxDelay * ONE_SECOND;
            maxDurationTime = maxDuration * ONE_SECOND;
            if (options.easing) {
              var easeProp,
                easeVal = options.easing;
              if (flags.hasTransitions) {
                easeProp = TRANSITION_PROP + TIMING_KEY;
                temporaryStyles.push([easeProp, easeVal]);
                node.style[easeProp] = easeVal;
              }
              if (flags.hasAnimations) {
                easeProp = ANIMATION_PROP + TIMING_KEY;
                temporaryStyles.push([easeProp, easeVal]);
                node.style[easeProp] = easeVal;
              }
            }
            if (timings.transitionDuration) {
              events.push(TRANSITIONEND_EVENT);
            }
            if (timings.animationDuration) {
              events.push(ANIMATIONEND_EVENT);
            }
            startTime = Date.now();
            var timerTime = maxDelayTime + CLOSING_TIME_BUFFER * maxDurationTime;
            var endTime = startTime + timerTime;
            var animationsData = element.data(ANIMATE_TIMER_KEY) || [];
            var setupFallbackTimer = true;
            if (animationsData.length) {
              var currentTimerData = animationsData[0];
              setupFallbackTimer = endTime > currentTimerData.expectedEndTime;
              if (setupFallbackTimer) {
                $timeout.cancel(currentTimerData.timer);
              } else {
                animationsData.push(close);
              }
            }
            if (setupFallbackTimer) {
              var timer = $timeout(onAnimationExpired, timerTime, false);
              animationsData[0] = {
                timer: timer,
                expectedEndTime: endTime
              };
              animationsData.push(close);
              element.data(ANIMATE_TIMER_KEY, animationsData);
            }
            if (events.length) {
              element.on(events.join(' '), onAnimationProgress);
            }
            if (options.to) {
              if (options.cleanupStyles) {
                registerRestorableStyles(restoreStyles, node, Object.keys(options.to));
              }
              applyAnimationToStyles(element, options);
            }
          }
          function onAnimationExpired() {
            var animationsData = element.data(ANIMATE_TIMER_KEY);

            // this will be false in the event that the element was
            // removed from the DOM (via a leave animation or something
            // similar)
            if (animationsData) {
              for (var i = 1; i < animationsData.length; i++) {
                animationsData[i]();
              }
              element.removeData(ANIMATE_TIMER_KEY);
            }
          }
        }
      };
    }];
  }];
  var $$AnimateCssDriverProvider = ['$$animationProvider', /** @this */function ($$animationProvider) {
    $$animationProvider.drivers.push('$$animateCssDriver');
    var NG_ANIMATE_SHIM_CLASS_NAME = 'ng-animate-shim';
    var NG_ANIMATE_ANCHOR_CLASS_NAME = 'ng-anchor';
    var NG_OUT_ANCHOR_CLASS_NAME = 'ng-anchor-out';
    var NG_IN_ANCHOR_CLASS_NAME = 'ng-anchor-in';
    function isDocumentFragment(node) {
      return node.parentNode && node.parentNode.nodeType === 11;
    }
    this.$get = ['$animateCss', '$rootScope', '$$AnimateRunner', '$rootElement', '$sniffer', '$$jqLite', '$document', function ($animateCss, $rootScope, $$AnimateRunner, $rootElement, $sniffer, $$jqLite, $document) {
      // only browsers that support these properties can render animations
      if (!$sniffer.animations && !$sniffer.transitions) return noop;
      var bodyNode = $document[0].body;
      var rootNode = getDomNode($rootElement);
      var rootBodyElement = jqLite(
      // this is to avoid using something that exists outside of the body
      // we also special case the doc fragment case because our unit test code
      // appends the $rootElement to the body after the app has been bootstrapped
      isDocumentFragment(rootNode) || bodyNode.contains(rootNode) ? rootNode : bodyNode);
      return function initDriverFn(animationDetails) {
        return animationDetails.from && animationDetails.to ? prepareFromToAnchorAnimation(animationDetails.from, animationDetails.to, animationDetails.classes, animationDetails.anchors) : prepareRegularAnimation(animationDetails);
      };
      function filterCssClasses(classes) {
        //remove all the `ng-` stuff
        return classes.replace(/\bng-\S+\b/g, '');
      }
      function getUniqueValues(a, b) {
        if (isString(a)) a = a.split(' ');
        if (isString(b)) b = b.split(' ');
        return a.filter(function (val) {
          return b.indexOf(val) === -1;
        }).join(' ');
      }
      function prepareAnchoredAnimation(classes, outAnchor, inAnchor) {
        var clone = jqLite(getDomNode(outAnchor).cloneNode(true));
        var startingClasses = filterCssClasses(getClassVal(clone));
        outAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
        inAnchor.addClass(NG_ANIMATE_SHIM_CLASS_NAME);
        clone.addClass(NG_ANIMATE_ANCHOR_CLASS_NAME);
        rootBodyElement.append(clone);
        var animatorIn,
          animatorOut = prepareOutAnimation();

        // the user may not end up using the `out` animation and
        // only making use of the `in` animation or vice-versa.
        // In either case we should allow this and not assume the
        // animation is over unless both animations are not used.
        if (!animatorOut) {
          animatorIn = prepareInAnimation();
          if (!animatorIn) {
            return end();
          }
        }
        var startingAnimator = animatorOut || animatorIn;
        return {
          start: function start() {
            var runner;
            var currentAnimation = startingAnimator.start();
            currentAnimation.done(function () {
              currentAnimation = null;
              if (!animatorIn) {
                animatorIn = prepareInAnimation();
                if (animatorIn) {
                  currentAnimation = animatorIn.start();
                  currentAnimation.done(function () {
                    currentAnimation = null;
                    end();
                    runner.complete();
                  });
                  return currentAnimation;
                }
              }
              // in the event that there is no `in` animation
              end();
              runner.complete();
            });
            runner = new $$AnimateRunner({
              end: endFn,
              cancel: endFn
            });
            return runner;
            function endFn() {
              if (currentAnimation) {
                currentAnimation.end();
              }
            }
          }
        };
        function calculateAnchorStyles(anchor) {
          var styles = {};
          var coords = getDomNode(anchor).getBoundingClientRect();

          // we iterate directly since safari messes up and doesn't return
          // all the keys for the coords object when iterated
          forEach(['width', 'height', 'top', 'left'], function (key) {
            var value = coords[key];
            switch (key) {
              case 'top':
                value += bodyNode.scrollTop;
                break;
              case 'left':
                value += bodyNode.scrollLeft;
                break;
            }
            styles[key] = Math.floor(value) + 'px';
          });
          return styles;
        }
        function prepareOutAnimation() {
          var animator = $animateCss(clone, {
            addClass: NG_OUT_ANCHOR_CLASS_NAME,
            delay: true,
            from: calculateAnchorStyles(outAnchor)
          });

          // read the comment within `prepareRegularAnimation` to understand
          // why this check is necessary
          return animator.$$willAnimate ? animator : null;
        }
        function getClassVal(element) {
          return element.attr('class') || '';
        }
        function prepareInAnimation() {
          var endingClasses = filterCssClasses(getClassVal(inAnchor));
          var toAdd = getUniqueValues(endingClasses, startingClasses);
          var toRemove = getUniqueValues(startingClasses, endingClasses);
          var animator = $animateCss(clone, {
            to: calculateAnchorStyles(inAnchor),
            addClass: NG_IN_ANCHOR_CLASS_NAME + ' ' + toAdd,
            removeClass: NG_OUT_ANCHOR_CLASS_NAME + ' ' + toRemove,
            delay: true
          });

          // read the comment within `prepareRegularAnimation` to understand
          // why this check is necessary
          return animator.$$willAnimate ? animator : null;
        }
        function end() {
          clone.remove();
          outAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
          inAnchor.removeClass(NG_ANIMATE_SHIM_CLASS_NAME);
        }
      }
      function prepareFromToAnchorAnimation(from, to, classes, anchors) {
        var fromAnimation = prepareRegularAnimation(from, noop);
        var toAnimation = prepareRegularAnimation(to, noop);
        var anchorAnimations = [];
        forEach(anchors, function (anchor) {
          var outElement = anchor['out'];
          var inElement = anchor['in'];
          var animator = prepareAnchoredAnimation(classes, outElement, inElement);
          if (animator) {
            anchorAnimations.push(animator);
          }
        });

        // no point in doing anything when there are no elements to animate
        if (!fromAnimation && !toAnimation && anchorAnimations.length === 0) return;
        return {
          start: function start() {
            var animationRunners = [];
            if (fromAnimation) {
              animationRunners.push(fromAnimation.start());
            }
            if (toAnimation) {
              animationRunners.push(toAnimation.start());
            }
            forEach(anchorAnimations, function (animation) {
              animationRunners.push(animation.start());
            });
            var runner = new $$AnimateRunner({
              end: endFn,
              cancel: endFn // CSS-driven animations cannot be cancelled, only ended
            });
            $$AnimateRunner.all(animationRunners, function (status) {
              runner.complete(status);
            });
            return runner;
            function endFn() {
              forEach(animationRunners, function (runner) {
                runner.end();
              });
            }
          }
        };
      }
      function prepareRegularAnimation(animationDetails) {
        var element = animationDetails.element;
        var options = animationDetails.options || {};
        if (animationDetails.structural) {
          options.event = animationDetails.event;
          options.structural = true;
          options.applyClassesEarly = true;

          // we special case the leave animation since we want to ensure that
          // the element is removed as soon as the animation is over. Otherwise
          // a flicker might appear or the element may not be removed at all
          if (animationDetails.event === 'leave') {
            options.onDone = options.domOperation;
          }
        }

        // We assign the preparationClasses as the actual animation event since
        // the internals of $animateCss will just suffix the event token values
        // with `-active` to trigger the animation.
        if (options.preparationClasses) {
          options.event = concatWithSpace(options.event, options.preparationClasses);
        }
        var animator = $animateCss(element, options);

        // the driver lookup code inside of $$animation attempts to spawn a
        // driver one by one until a driver returns a.$$willAnimate animator object.
        // $animateCss will always return an object, however, it will pass in
        // a flag as a hint as to whether an animation was detected or not
        return animator.$$willAnimate ? animator : null;
      }
    }];
  }];

  // TODO(matsko): use caching here to speed things up for detection
  // TODO(matsko): add documentation
  //  by the time...

  var $$AnimateJsProvider = ['$animateProvider', /** @this */function ($animateProvider) {
    this.$get = ['$injector', '$$AnimateRunner', '$$jqLite', function ($injector, $$AnimateRunner, $$jqLite) {
      var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
      // $animateJs(element, 'enter');
      return function (element, event, classes, options) {
        var animationClosed = false;

        // the `classes` argument is optional and if it is not used
        // then the classes will be resolved from the element's className
        // property as well as options.addClass/options.removeClass.
        if (arguments.length === 3 && isObject(classes)) {
          options = classes;
          classes = null;
        }
        options = prepareAnimationOptions(options);
        if (!classes) {
          classes = element.attr('class') || '';
          if (options.addClass) {
            classes += ' ' + options.addClass;
          }
          if (options.removeClass) {
            classes += ' ' + options.removeClass;
          }
        }
        var classesToAdd = options.addClass;
        var classesToRemove = options.removeClass;

        // the lookupAnimations function returns a series of animation objects that are
        // matched up with one or more of the CSS classes. These animation objects are
        // defined via the module.animation factory function. If nothing is detected then
        // we don't return anything which then makes $animation query the next driver.
        var animations = lookupAnimations(classes);
        var before, after;
        if (animations.length) {
          var afterFn, beforeFn;
          if (event === 'leave') {
            beforeFn = 'leave';
            afterFn = 'afterLeave'; // TODO(matsko): get rid of this
          } else {
            beforeFn = 'before' + event.charAt(0).toUpperCase() + event.substr(1);
            afterFn = event;
          }
          if (event !== 'enter' && event !== 'move') {
            before = packageAnimations(element, event, options, animations, beforeFn);
          }
          after = packageAnimations(element, event, options, animations, afterFn);
        }

        // no matching animations
        if (!before && !after) return;
        function applyOptions() {
          options.domOperation();
          applyAnimationClasses(element, options);
        }
        function close() {
          animationClosed = true;
          applyOptions();
          applyAnimationStyles(element, options);
        }
        var runner;
        return {
          $$willAnimate: true,
          end: function end() {
            if (runner) {
              runner.end();
            } else {
              close();
              runner = new $$AnimateRunner();
              runner.complete(true);
            }
            return runner;
          },
          start: function start() {
            if (runner) {
              return runner;
            }
            runner = new $$AnimateRunner();
            var closeActiveAnimations;
            var chain = [];
            if (before) {
              chain.push(function (fn) {
                closeActiveAnimations = before(fn);
              });
            }
            if (chain.length) {
              chain.push(function (fn) {
                applyOptions();
                fn(true);
              });
            } else {
              applyOptions();
            }
            if (after) {
              chain.push(function (fn) {
                closeActiveAnimations = after(fn);
              });
            }
            runner.setHost({
              end: function end() {
                endAnimations();
              },
              cancel: function cancel() {
                endAnimations(true);
              }
            });
            $$AnimateRunner.chain(chain, onComplete);
            return runner;
            function onComplete(success) {
              close(success);
              runner.complete(success);
            }
            function endAnimations(cancelled) {
              if (!animationClosed) {
                (closeActiveAnimations || noop)(cancelled);
                onComplete(cancelled);
              }
            }
          }
        };
        function executeAnimationFn(fn, element, event, options, onDone) {
          var args;
          switch (event) {
            case 'animate':
              args = [element, options.from, options.to, onDone];
              break;
            case 'setClass':
              args = [element, classesToAdd, classesToRemove, onDone];
              break;
            case 'addClass':
              args = [element, classesToAdd, onDone];
              break;
            case 'removeClass':
              args = [element, classesToRemove, onDone];
              break;
            default:
              args = [element, onDone];
              break;
          }
          args.push(options);
          var value = fn.apply(fn, args);
          if (value) {
            if (isFunction(value.start)) {
              value = value.start();
            }
            if (value instanceof $$AnimateRunner) {
              value.done(onDone);
            } else if (isFunction(value)) {
              // optional onEnd / onCancel callback
              return value;
            }
          }
          return noop;
        }
        function groupEventedAnimations(element, event, options, animations, fnName) {
          var operations = [];
          forEach(animations, function (ani) {
            var animation = ani[fnName];
            if (!animation) return;

            // note that all of these animations will run in parallel
            operations.push(function () {
              var runner;
              var endProgressCb;
              var resolved = false;
              var onAnimationComplete = function onAnimationComplete(rejected) {
                if (!resolved) {
                  resolved = true;
                  (endProgressCb || noop)(rejected);
                  runner.complete(!rejected);
                }
              };
              runner = new $$AnimateRunner({
                end: function end() {
                  onAnimationComplete();
                },
                cancel: function cancel() {
                  onAnimationComplete(true);
                }
              });
              endProgressCb = executeAnimationFn(animation, element, event, options, function (result) {
                var cancelled = result === false;
                onAnimationComplete(cancelled);
              });
              return runner;
            });
          });
          return operations;
        }
        function packageAnimations(element, event, options, animations, fnName) {
          var operations = groupEventedAnimations(element, event, options, animations, fnName);
          if (operations.length === 0) {
            var a, b;
            if (fnName === 'beforeSetClass') {
              a = groupEventedAnimations(element, 'removeClass', options, animations, 'beforeRemoveClass');
              b = groupEventedAnimations(element, 'addClass', options, animations, 'beforeAddClass');
            } else if (fnName === 'setClass') {
              a = groupEventedAnimations(element, 'removeClass', options, animations, 'removeClass');
              b = groupEventedAnimations(element, 'addClass', options, animations, 'addClass');
            }
            if (a) {
              operations = operations.concat(a);
            }
            if (b) {
              operations = operations.concat(b);
            }
          }
          if (operations.length === 0) return;

          // TODO(matsko): add documentation
          return function startAnimation(callback) {
            var runners = [];
            if (operations.length) {
              forEach(operations, function (animateFn) {
                runners.push(animateFn());
              });
            }
            if (runners.length) {
              $$AnimateRunner.all(runners, callback);
            } else {
              callback();
            }
            return function endFn(reject) {
              forEach(runners, function (runner) {
                if (reject) {
                  runner.cancel();
                } else {
                  runner.end();
                }
              });
            };
          };
        }
      };
      function lookupAnimations(classes) {
        classes = isArray(classes) ? classes : classes.split(' ');
        var matches = [],
          flagMap = {};
        for (var i = 0; i < classes.length; i++) {
          var klass = classes[i],
            animationFactory = $animateProvider.$$registeredAnimations[klass];
          if (animationFactory && !flagMap[klass]) {
            matches.push($injector.get(animationFactory));
            flagMap[klass] = true;
          }
        }
        return matches;
      }
    }];
  }];
  var $$AnimateJsDriverProvider = ['$$animationProvider', /** @this */function ($$animationProvider) {
    $$animationProvider.drivers.push('$$animateJsDriver');
    this.$get = ['$$animateJs', '$$AnimateRunner', function ($$animateJs, $$AnimateRunner) {
      return function initDriverFn(animationDetails) {
        if (animationDetails.from && animationDetails.to) {
          var fromAnimation = prepareAnimation(animationDetails.from);
          var toAnimation = prepareAnimation(animationDetails.to);
          if (!fromAnimation && !toAnimation) return;
          return {
            start: function start() {
              var animationRunners = [];
              if (fromAnimation) {
                animationRunners.push(fromAnimation.start());
              }
              if (toAnimation) {
                animationRunners.push(toAnimation.start());
              }
              $$AnimateRunner.all(animationRunners, done);
              var runner = new $$AnimateRunner({
                end: endFnFactory(),
                cancel: endFnFactory()
              });
              return runner;
              function endFnFactory() {
                return function () {
                  forEach(animationRunners, function (runner) {
                    // at this point we cannot cancel animations for groups just yet. 1.5+
                    runner.end();
                  });
                };
              }
              function done(status) {
                runner.complete(status);
              }
            }
          };
        } else {
          return prepareAnimation(animationDetails);
        }
      };
      function prepareAnimation(animationDetails) {
        // TODO(matsko): make sure to check for grouped animations and delegate down to normal animations
        var element = animationDetails.element;
        var event = animationDetails.event;
        var options = animationDetails.options;
        var classes = animationDetails.classes;
        return $$animateJs(element, event, classes, options);
      }
    }];
  }];
  var NG_ANIMATE_ATTR_NAME = 'data-ng-animate';
  var NG_ANIMATE_PIN_DATA = '$ngAnimatePin';
  var $$AnimateQueueProvider = ['$animateProvider', /** @this */function ($animateProvider) {
    var PRE_DIGEST_STATE = 1;
    var RUNNING_STATE = 2;
    var ONE_SPACE = ' ';
    var rules = this.rules = {
      skip: [],
      cancel: [],
      join: []
    };
    function getEventData(options) {
      return {
        addClass: options.addClass,
        removeClass: options.removeClass,
        from: options.from,
        to: options.to
      };
    }
    function makeTruthyCssClassMap(classString) {
      if (!classString) {
        return null;
      }
      var keys = classString.split(ONE_SPACE);
      var map = Object.create(null);
      forEach(keys, function (key) {
        map[key] = true;
      });
      return map;
    }
    function hasMatchingClasses(newClassString, currentClassString) {
      if (newClassString && currentClassString) {
        var currentClassMap = makeTruthyCssClassMap(currentClassString);
        return newClassString.split(ONE_SPACE).some(function (className) {
          return currentClassMap[className];
        });
      }
    }
    function isAllowed(ruleType, currentAnimation, previousAnimation) {
      return rules[ruleType].some(function (fn) {
        return fn(currentAnimation, previousAnimation);
      });
    }
    function hasAnimationClasses(animation, and) {
      var a = (animation.addClass || '').length > 0;
      var b = (animation.removeClass || '').length > 0;
      return and ? a && b : a || b;
    }
    rules.join.push(function (newAnimation, currentAnimation) {
      // if the new animation is class-based then we can just tack that on
      return !newAnimation.structural && hasAnimationClasses(newAnimation);
    });
    rules.skip.push(function (newAnimation, currentAnimation) {
      // there is no need to animate anything if no classes are being added and
      // there is no structural animation that will be triggered
      return !newAnimation.structural && !hasAnimationClasses(newAnimation);
    });
    rules.skip.push(function (newAnimation, currentAnimation) {
      // why should we trigger a new structural animation if the element will
      // be removed from the DOM anyway?
      return currentAnimation.event === 'leave' && newAnimation.structural;
    });
    rules.skip.push(function (newAnimation, currentAnimation) {
      // if there is an ongoing current animation then don't even bother running the class-based animation
      return currentAnimation.structural && currentAnimation.state === RUNNING_STATE && !newAnimation.structural;
    });
    rules.cancel.push(function (newAnimation, currentAnimation) {
      // there can never be two structural animations running at the same time
      return currentAnimation.structural && newAnimation.structural;
    });
    rules.cancel.push(function (newAnimation, currentAnimation) {
      // if the previous animation is already running, but the new animation will
      // be triggered, but the new animation is structural
      return currentAnimation.state === RUNNING_STATE && newAnimation.structural;
    });
    rules.cancel.push(function (newAnimation, currentAnimation) {
      // cancel the animation if classes added / removed in both animation cancel each other out,
      // but only if the current animation isn't structural

      if (currentAnimation.structural) return false;
      var nA = newAnimation.addClass;
      var nR = newAnimation.removeClass;
      var cA = currentAnimation.addClass;
      var cR = currentAnimation.removeClass;

      // early detection to save the global CPU shortage :)
      if (isUndefined(nA) && isUndefined(nR) || isUndefined(cA) && isUndefined(cR)) {
        return false;
      }
      return hasMatchingClasses(nA, cR) || hasMatchingClasses(nR, cA);
    });
    this.$get = ['$$rAF', '$rootScope', '$rootElement', '$document', '$$Map', '$$animation', '$$AnimateRunner', '$templateRequest', '$$jqLite', '$$forceReflow', '$$isDocumentHidden', function ($$rAF, $rootScope, $rootElement, $document, $$Map, $$animation, $$AnimateRunner, $templateRequest, $$jqLite, $$forceReflow, $$isDocumentHidden) {
      var activeAnimationsLookup = new $$Map();
      var disabledElementsLookup = new $$Map();
      var animationsEnabled = null;
      function removeFromDisabledElementsLookup(evt) {
        disabledElementsLookup["delete"](evt.target);
      }
      function postDigestTaskFactory() {
        var postDigestCalled = false;
        return function (fn) {
          // we only issue a call to postDigest before
          // it has first passed. This prevents any callbacks
          // from not firing once the animation has completed
          // since it will be out of the digest cycle.
          if (postDigestCalled) {
            fn();
          } else {
            $rootScope.$$postDigest(function () {
              postDigestCalled = true;
              fn();
            });
          }
        };
      }

      // Wait until all directive and route-related templates are downloaded and
      // compiled. The $templateRequest.totalPendingRequests variable keeps track of
      // all of the remote templates being currently downloaded. If there are no
      // templates currently downloading then the watcher will still fire anyway.
      var deregisterWatch = $rootScope.$watch(function () {
        return $templateRequest.totalPendingRequests === 0;
      }, function (isEmpty) {
        if (!isEmpty) return;
        deregisterWatch();

        // Now that all templates have been downloaded, $animate will wait until
        // the post digest queue is empty before enabling animations. By having two
        // calls to $postDigest calls we can ensure that the flag is enabled at the
        // very end of the post digest queue. Since all of the animations in $animate
        // use $postDigest, it's important that the code below executes at the end.
        // This basically means that the page is fully downloaded and compiled before
        // any animations are triggered.
        $rootScope.$$postDigest(function () {
          $rootScope.$$postDigest(function () {
            // we check for null directly in the event that the application already called
            // .enabled() with whatever arguments that it provided it with
            if (animationsEnabled === null) {
              animationsEnabled = true;
            }
          });
        });
      });
      var callbackRegistry = Object.create(null);

      // remember that the `customFilter`/`classNameFilter` are set during the
      // provider/config stage therefore we can optimize here and setup helper functions
      var customFilter = $animateProvider.customFilter();
      var classNameFilter = $animateProvider.classNameFilter();
      var returnTrue = function returnTrue() {
        return true;
      };
      var isAnimatableByFilter = customFilter || returnTrue;
      var isAnimatableClassName = !classNameFilter ? returnTrue : function (node, options) {
        var className = [node.getAttribute('class'), options.addClass, options.removeClass].join(' ');
        return classNameFilter.test(className);
      };
      var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
      function normalizeAnimationDetails(element, animation) {
        return mergeAnimationDetails(element, animation, {});
      }

      // IE9-11 has no method "contains" in SVG element and in Node.prototype. Bug #10259.
      var contains = window.Node.prototype.contains || /** @this */function (arg) {
        // eslint-disable-next-line no-bitwise
        return this === arg || !!(this.compareDocumentPosition(arg) & 16);
      };
      function findCallbacks(targetParentNode, targetNode, event) {
        var matches = [];
        var entries = callbackRegistry[event];
        if (entries) {
          forEach(entries, function (entry) {
            if (contains.call(entry.node, targetNode)) {
              matches.push(entry.callback);
            } else if (event === 'leave' && contains.call(entry.node, targetParentNode)) {
              matches.push(entry.callback);
            }
          });
        }
        return matches;
      }
      function filterFromRegistry(list, matchContainer, matchCallback) {
        var containerNode = extractElementNode(matchContainer);
        return list.filter(function (entry) {
          var isMatch = entry.node === containerNode && (!matchCallback || entry.callback === matchCallback);
          return !isMatch;
        });
      }
      function cleanupEventListeners(phase, node) {
        if (phase === 'close' && !node.parentNode) {
          // If the element is not attached to a parentNode, it has been removed by
          // the domOperation, and we can safely remove the event callbacks
          $animate.off(node);
        }
      }
      var $animate = {
        on: function on(event, container, callback) {
          var node = extractElementNode(container);
          callbackRegistry[event] = callbackRegistry[event] || [];
          callbackRegistry[event].push({
            node: node,
            callback: callback
          });

          // Remove the callback when the element is removed from the DOM
          jqLite(container).on('$destroy', function () {
            var animationDetails = activeAnimationsLookup.get(node);
            if (!animationDetails) {
              // If there's an animation ongoing, the callback calling code will remove
              // the event listeners. If we'd remove here, the callbacks would be removed
              // before the animation ends
              $animate.off(event, container, callback);
            }
          });
        },
        off: function off(event, container, callback) {
          if (arguments.length === 1 && !isString(arguments[0])) {
            container = arguments[0];
            for (var eventType in callbackRegistry) {
              callbackRegistry[eventType] = filterFromRegistry(callbackRegistry[eventType], container);
            }
            return;
          }
          var entries = callbackRegistry[event];
          if (!entries) return;
          callbackRegistry[event] = arguments.length === 1 ? null : filterFromRegistry(entries, container, callback);
        },
        pin: function pin(element, parentElement) {
          assertArg(isElement(element), 'element', 'not an element');
          assertArg(isElement(parentElement), 'parentElement', 'not an element');
          element.data(NG_ANIMATE_PIN_DATA, parentElement);
        },
        push: function push(element, event, options, domOperation) {
          options = options || {};
          options.domOperation = domOperation;
          return queueAnimation(element, event, options);
        },
        // this method has four signatures:
        //  () - global getter
        //  (bool) - global setter
        //  (element) - element getter
        //  (element, bool) - element setter<F37>
        enabled: function enabled(element, bool) {
          var argCount = arguments.length;
          if (argCount === 0) {
            // () - Global getter
            bool = !!animationsEnabled;
          } else {
            var hasElement = isElement(element);
            if (!hasElement) {
              // (bool) - Global setter
              bool = animationsEnabled = !!element;
            } else {
              var node = getDomNode(element);
              if (argCount === 1) {
                // (element) - Element getter
                bool = !disabledElementsLookup.get(node);
              } else {
                // (element, bool) - Element setter
                if (!disabledElementsLookup.has(node)) {
                  // The element is added to the map for the first time.
                  // Create a listener to remove it on `$destroy` (to avoid memory leak).
                  jqLite(element).on('$destroy', removeFromDisabledElementsLookup);
                }
                disabledElementsLookup.set(node, !bool);
              }
            }
          }
          return bool;
        }
      };
      return $animate;
      function queueAnimation(originalElement, event, initialOptions) {
        // we always make a copy of the options since
        // there should never be any side effects on
        // the input data when running `$animateCss`.
        var options = copy(initialOptions);
        var element = stripCommentsFromElement(originalElement);
        var node = getDomNode(element);
        var parentNode = node && node.parentNode;
        options = prepareAnimationOptions(options);

        // we create a fake runner with a working promise.
        // These methods will become available after the digest has passed
        var runner = new $$AnimateRunner();

        // this is used to trigger callbacks in postDigest mode
        var runInNextPostDigestOrNow = postDigestTaskFactory();
        if (isArray(options.addClass)) {
          options.addClass = options.addClass.join(' ');
        }
        if (options.addClass && !isString(options.addClass)) {
          options.addClass = null;
        }
        if (isArray(options.removeClass)) {
          options.removeClass = options.removeClass.join(' ');
        }
        if (options.removeClass && !isString(options.removeClass)) {
          options.removeClass = null;
        }
        if (options.from && !isObject(options.from)) {
          options.from = null;
        }
        if (options.to && !isObject(options.to)) {
          options.to = null;
        }

        // If animations are hard-disabled for the whole application there is no need to continue.
        // There are also situations where a directive issues an animation for a jqLite wrapper that
        // contains only comment nodes. In this case, there is no way we can perform an animation.
        if (!animationsEnabled || !node || !isAnimatableByFilter(node, event, initialOptions) || !isAnimatableClassName(node, options)) {
          close();
          return runner;
        }
        var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;
        var documentHidden = $$isDocumentHidden();

        // This is a hard disable of all animations the element itself, therefore  there is no need to
        // continue further past this point if not enabled
        // Animations are also disabled if the document is currently hidden (page is not visible
        // to the user), because browsers slow down or do not flush calls to requestAnimationFrame
        var skipAnimations = documentHidden || disabledElementsLookup.get(node);
        var existingAnimation = !skipAnimations && activeAnimationsLookup.get(node) || {};
        var hasExistingAnimation = !!existingAnimation.state;

        // there is no point in traversing the same collection of parent ancestors if a followup
        // animation will be run on the same element that already did all that checking work
        if (!skipAnimations && (!hasExistingAnimation || existingAnimation.state !== PRE_DIGEST_STATE)) {
          skipAnimations = !areAnimationsAllowed(node, parentNode, event);
        }
        if (skipAnimations) {
          // Callbacks should fire even if the document is hidden (regression fix for issue #14120)
          if (documentHidden) notifyProgress(runner, event, 'start', getEventData(options));
          close();
          if (documentHidden) notifyProgress(runner, event, 'close', getEventData(options));
          return runner;
        }
        if (isStructural) {
          closeChildAnimations(node);
        }
        var newAnimation = {
          structural: isStructural,
          element: element,
          event: event,
          addClass: options.addClass,
          removeClass: options.removeClass,
          close: close,
          options: options,
          runner: runner
        };
        if (hasExistingAnimation) {
          var skipAnimationFlag = isAllowed('skip', newAnimation, existingAnimation);
          if (skipAnimationFlag) {
            if (existingAnimation.state === RUNNING_STATE) {
              close();
              return runner;
            } else {
              mergeAnimationDetails(element, existingAnimation, newAnimation);
              return existingAnimation.runner;
            }
          }
          var cancelAnimationFlag = isAllowed('cancel', newAnimation, existingAnimation);
          if (cancelAnimationFlag) {
            if (existingAnimation.state === RUNNING_STATE) {
              // this will end the animation right away and it is safe
              // to do so since the animation is already running and the
              // runner callback code will run in async
              existingAnimation.runner.end();
            } else if (existingAnimation.structural) {
              // this means that the animation is queued into a digest, but
              // hasn't started yet. Therefore it is safe to run the close
              // method which will call the runner methods in async.
              existingAnimation.close();
            } else {
              // this will merge the new animation options into existing animation options
              mergeAnimationDetails(element, existingAnimation, newAnimation);
              return existingAnimation.runner;
            }
          } else {
            // a joined animation means that this animation will take over the existing one
            // so an example would involve a leave animation taking over an enter. Then when
            // the postDigest kicks in the enter will be ignored.
            var joinAnimationFlag = isAllowed('join', newAnimation, existingAnimation);
            if (joinAnimationFlag) {
              if (existingAnimation.state === RUNNING_STATE) {
                normalizeAnimationDetails(element, newAnimation);
              } else {
                applyGeneratedPreparationClasses($$jqLite, element, isStructural ? event : null, options);
                event = newAnimation.event = existingAnimation.event;
                options = mergeAnimationDetails(element, existingAnimation, newAnimation);

                //we return the same runner since only the option values of this animation will
                //be fed into the `existingAnimation`.
                return existingAnimation.runner;
              }
            }
          }
        } else {
          // normalization in this case means that it removes redundant CSS classes that
          // already exist (addClass) or do not exist (removeClass) on the element
          normalizeAnimationDetails(element, newAnimation);
        }

        // when the options are merged and cleaned up we may end up not having to do
        // an animation at all, therefore we should check this before issuing a post
        // digest callback. Structural animations will always run no matter what.
        var isValidAnimation = newAnimation.structural;
        if (!isValidAnimation) {
          // animate (from/to) can be quickly checked first, otherwise we check if any classes are present
          isValidAnimation = newAnimation.event === 'animate' && Object.keys(newAnimation.options.to || {}).length > 0 || hasAnimationClasses(newAnimation);
        }
        if (!isValidAnimation) {
          close();
          clearElementAnimationState(node);
          return runner;
        }

        // the counter keeps track of cancelled animations
        var counter = (existingAnimation.counter || 0) + 1;
        newAnimation.counter = counter;
        markElementAnimationState(node, PRE_DIGEST_STATE, newAnimation);
        $rootScope.$$postDigest(function () {
          // It is possible that the DOM nodes inside `originalElement` have been replaced. This can
          // happen if the animated element is a transcluded clone and also has a `templateUrl`
          // directive on it. Therefore, we must recreate `element` in order to interact with the
          // actual DOM nodes.
          // Note: We still need to use the old `node` for certain things, such as looking up in
          //       HashMaps where it was used as the key.

          element = stripCommentsFromElement(originalElement);
          var animationDetails = activeAnimationsLookup.get(node);
          var animationCancelled = !animationDetails;
          animationDetails = animationDetails || {};

          // if addClass/removeClass is called before something like enter then the
          // registered parent element may not be present. The code below will ensure
          // that a final value for parent element is obtained
          var parentElement = element.parent() || [];

          // animate/structural/class-based animations all have requirements. Otherwise there
          // is no point in performing an animation. The parent node must also be set.
          var isValidAnimation = parentElement.length > 0 && (animationDetails.event === 'animate' || animationDetails.structural || hasAnimationClasses(animationDetails));

          // this means that the previous animation was cancelled
          // even if the follow-up animation is the same event
          if (animationCancelled || animationDetails.counter !== counter || !isValidAnimation) {
            // if another animation did not take over then we need
            // to make sure that the domOperation and options are
            // handled accordingly
            if (animationCancelled) {
              applyAnimationClasses(element, options);
              applyAnimationStyles(element, options);
            }

            // if the event changed from something like enter to leave then we do
            // it, otherwise if it's the same then the end result will be the same too
            if (animationCancelled || isStructural && animationDetails.event !== event) {
              options.domOperation();
              runner.end();
            }

            // in the event that the element animation was not cancelled or a follow-up animation
            // isn't allowed to animate from here then we need to clear the state of the element
            // so that any future animations won't read the expired animation data.
            if (!isValidAnimation) {
              clearElementAnimationState(node);
            }
            return;
          }

          // this combined multiple class to addClass / removeClass into a setClass event
          // so long as a structural event did not take over the animation
          event = !animationDetails.structural && hasAnimationClasses(animationDetails, true) ? 'setClass' : animationDetails.event;
          markElementAnimationState(node, RUNNING_STATE);
          var realRunner = $$animation(element, event, animationDetails.options);

          // this will update the runner's flow-control events based on
          // the `realRunner` object.
          runner.setHost(realRunner);
          notifyProgress(runner, event, 'start', getEventData(options));
          realRunner.done(function (status) {
            close(!status);
            var animationDetails = activeAnimationsLookup.get(node);
            if (animationDetails && animationDetails.counter === counter) {
              clearElementAnimationState(node);
            }
            notifyProgress(runner, event, 'close', getEventData(options));
          });
        });
        return runner;
        function notifyProgress(runner, event, phase, data) {
          runInNextPostDigestOrNow(function () {
            var callbacks = findCallbacks(parentNode, node, event);
            if (callbacks.length) {
              // do not optimize this call here to RAF because
              // we don't know how heavy the callback code here will
              // be and if this code is buffered then this can
              // lead to a performance regression.
              $$rAF(function () {
                forEach(callbacks, function (callback) {
                  callback(element, phase, data);
                });
                cleanupEventListeners(phase, node);
              });
            } else {
              cleanupEventListeners(phase, node);
            }
          });
          runner.progress(event, phase, data);
        }
        function close(reject) {
          clearGeneratedClasses(element, options);
          applyAnimationClasses(element, options);
          applyAnimationStyles(element, options);
          options.domOperation();
          runner.complete(!reject);
        }
      }
      function closeChildAnimations(node) {
        var children = node.querySelectorAll('[' + NG_ANIMATE_ATTR_NAME + ']');
        forEach(children, function (child) {
          var state = parseInt(child.getAttribute(NG_ANIMATE_ATTR_NAME), 10);
          var animationDetails = activeAnimationsLookup.get(child);
          if (animationDetails) {
            switch (state) {
              case RUNNING_STATE:
                animationDetails.runner.end();
              /* falls through */
              case PRE_DIGEST_STATE:
                activeAnimationsLookup["delete"](child);
                break;
            }
          }
        });
      }
      function clearElementAnimationState(node) {
        node.removeAttribute(NG_ANIMATE_ATTR_NAME);
        activeAnimationsLookup["delete"](node);
      }

      /**
       * This fn returns false if any of the following is true:
       * a) animations on any parent element are disabled, and animations on the element aren't explicitly allowed
       * b) a parent element has an ongoing structural animation, and animateChildren is false
       * c) the element is not a child of the body
       * d) the element is not a child of the $rootElement
       */
      function areAnimationsAllowed(node, parentNode, event) {
        var bodyNode = $document[0].body;
        var rootNode = getDomNode($rootElement);
        var bodyNodeDetected = node === bodyNode || node.nodeName === 'HTML';
        var rootNodeDetected = node === rootNode;
        var parentAnimationDetected = false;
        var elementDisabled = disabledElementsLookup.get(node);
        var animateChildren;
        var parentHost = jqLite.data(node, NG_ANIMATE_PIN_DATA);
        if (parentHost) {
          parentNode = getDomNode(parentHost);
        }
        while (parentNode) {
          if (!rootNodeDetected) {
            // AngularJS doesn't want to attempt to animate elements outside of the application
            // therefore we need to ensure that the rootElement is an ancestor of the current element
            rootNodeDetected = parentNode === rootNode;
          }
          if (parentNode.nodeType !== ELEMENT_NODE) {
            // no point in inspecting the #document element
            break;
          }
          var details = activeAnimationsLookup.get(parentNode) || {};
          // either an enter, leave or move animation will commence
          // therefore we can't allow any animations to take place
          // but if a parent animation is class-based then that's ok
          if (!parentAnimationDetected) {
            var parentNodeDisabled = disabledElementsLookup.get(parentNode);
            if (parentNodeDisabled === true && elementDisabled !== false) {
              // disable animations if the user hasn't explicitly enabled animations on the
              // current element
              elementDisabled = true;
              // element is disabled via parent element, no need to check anything else
              break;
            } else if (parentNodeDisabled === false) {
              elementDisabled = false;
            }
            parentAnimationDetected = details.structural;
          }
          if (isUndefined(animateChildren) || animateChildren === true) {
            var value = jqLite.data(parentNode, NG_ANIMATE_CHILDREN_DATA);
            if (isDefined(value)) {
              animateChildren = value;
            }
          }

          // there is no need to continue traversing at this point
          if (parentAnimationDetected && animateChildren === false) break;
          if (!bodyNodeDetected) {
            // we also need to ensure that the element is or will be a part of the body element
            // otherwise it is pointless to even issue an animation to be rendered
            bodyNodeDetected = parentNode === bodyNode;
          }
          if (bodyNodeDetected && rootNodeDetected) {
            // If both body and root have been found, any other checks are pointless,
            // as no animation data should live outside the application
            break;
          }
          if (!rootNodeDetected) {
            // If `rootNode` is not detected, check if `parentNode` is pinned to another element
            parentHost = jqLite.data(parentNode, NG_ANIMATE_PIN_DATA);
            if (parentHost) {
              // The pin target element becomes the next parent element
              parentNode = getDomNode(parentHost);
              continue;
            }
          }
          parentNode = parentNode.parentNode;
        }
        var allowAnimation = (!parentAnimationDetected || animateChildren) && elementDisabled !== true;
        return allowAnimation && rootNodeDetected && bodyNodeDetected;
      }
      function markElementAnimationState(node, state, details) {
        details = details || {};
        details.state = state;
        node.setAttribute(NG_ANIMATE_ATTR_NAME, state);
        var oldValue = activeAnimationsLookup.get(node);
        var newValue = oldValue ? extend(oldValue, details) : details;
        activeAnimationsLookup.set(node, newValue);
      }
    }];
  }];

  /** @this */
  var $$AnimateCacheProvider = function $$AnimateCacheProvider() {
    var KEY = '$$ngAnimateParentKey';
    var parentCounter = 0;
    var cache = Object.create(null);
    this.$get = [function () {
      return {
        cacheKey: function cacheKey(node, method, addClass, removeClass) {
          var parentNode = node.parentNode;
          var parentID = parentNode[KEY] || (parentNode[KEY] = ++parentCounter);
          var parts = [parentID, method, node.getAttribute('class')];
          if (addClass) {
            parts.push(addClass);
          }
          if (removeClass) {
            parts.push(removeClass);
          }
          return parts.join(' ');
        },
        containsCachedAnimationWithoutDuration: function containsCachedAnimationWithoutDuration(key) {
          var entry = cache[key];

          // nothing cached, so go ahead and animate
          // otherwise it should be a valid animation
          return entry && !entry.isValid || false;
        },
        flush: function flush() {
          cache = Object.create(null);
        },
        count: function count(key) {
          var entry = cache[key];
          return entry ? entry.total : 0;
        },
        get: function get(key) {
          var entry = cache[key];
          return entry && entry.value;
        },
        put: function put(key, value, isValid) {
          if (!cache[key]) {
            cache[key] = {
              total: 1,
              value: value,
              isValid: isValid
            };
          } else {
            cache[key].total++;
            cache[key].value = value;
          }
        }
      };
    }];
  };

  /* exported $$AnimationProvider */

  var $$AnimationProvider = ['$animateProvider', /** @this */function ($animateProvider) {
    var NG_ANIMATE_REF_ATTR = 'ng-animate-ref';
    var drivers = this.drivers = [];
    var RUNNER_STORAGE_KEY = '$$animationRunner';
    var PREPARE_CLASSES_KEY = '$$animatePrepareClasses';
    function setRunner(element, runner) {
      element.data(RUNNER_STORAGE_KEY, runner);
    }
    function removeRunner(element) {
      element.removeData(RUNNER_STORAGE_KEY);
    }
    function getRunner(element) {
      return element.data(RUNNER_STORAGE_KEY);
    }
    this.$get = ['$$jqLite', '$rootScope', '$injector', '$$AnimateRunner', '$$Map', '$$rAFScheduler', '$$animateCache', function ($$jqLite, $rootScope, $injector, $$AnimateRunner, $$Map, $$rAFScheduler, $$animateCache) {
      var animationQueue = [];
      var applyAnimationClasses = applyAnimationClassesFactory($$jqLite);
      function sortAnimations(animations) {
        var tree = {
          children: []
        };
        var i,
          lookup = new $$Map();

        // this is done first beforehand so that the map
        // is filled with a list of the elements that will be animated
        for (i = 0; i < animations.length; i++) {
          var animation = animations[i];
          lookup.set(animation.domNode, animations[i] = {
            domNode: animation.domNode,
            element: animation.element,
            fn: animation.fn,
            children: []
          });
        }
        for (i = 0; i < animations.length; i++) {
          processNode(animations[i]);
        }
        return flatten(tree);
        function processNode(entry) {
          if (entry.processed) return entry;
          entry.processed = true;
          var elementNode = entry.domNode;
          var parentNode = elementNode.parentNode;
          lookup.set(elementNode, entry);
          var parentEntry;
          while (parentNode) {
            parentEntry = lookup.get(parentNode);
            if (parentEntry) {
              if (!parentEntry.processed) {
                parentEntry = processNode(parentEntry);
              }
              break;
            }
            parentNode = parentNode.parentNode;
          }
          (parentEntry || tree).children.push(entry);
          return entry;
        }
        function flatten(tree) {
          var result = [];
          var queue = [];
          var i;
          for (i = 0; i < tree.children.length; i++) {
            queue.push(tree.children[i]);
          }
          var remainingLevelEntries = queue.length;
          var nextLevelEntries = 0;
          var row = [];
          for (i = 0; i < queue.length; i++) {
            var entry = queue[i];
            if (remainingLevelEntries <= 0) {
              remainingLevelEntries = nextLevelEntries;
              nextLevelEntries = 0;
              result.push(row);
              row = [];
            }
            row.push(entry);
            entry.children.forEach(function (childEntry) {
              nextLevelEntries++;
              queue.push(childEntry);
            });
            remainingLevelEntries--;
          }
          if (row.length) {
            result.push(row);
          }
          return result;
        }
      }

      // TODO(matsko): document the signature in a better way
      return function (element, event, options) {
        options = prepareAnimationOptions(options);
        var isStructural = ['enter', 'move', 'leave'].indexOf(event) >= 0;

        // there is no animation at the current moment, however
        // these runner methods will get later updated with the
        // methods leading into the driver's end/cancel methods
        // for now they just stop the animation from starting
        var runner = new $$AnimateRunner({
          end: function end() {
            close();
          },
          cancel: function cancel() {
            close(true);
          }
        });
        if (!drivers.length) {
          close();
          return runner;
        }
        var classes = mergeClasses(element.attr('class'), mergeClasses(options.addClass, options.removeClass));
        var tempClasses = options.tempClasses;
        if (tempClasses) {
          classes += ' ' + tempClasses;
          options.tempClasses = null;
        }
        if (isStructural) {
          element.data(PREPARE_CLASSES_KEY, 'ng-' + event + PREPARE_CLASS_SUFFIX);
        }
        setRunner(element, runner);
        animationQueue.push({
          // this data is used by the postDigest code and passed into
          // the driver step function
          element: element,
          classes: classes,
          event: event,
          structural: isStructural,
          options: options,
          beforeStart: beforeStart,
          close: close
        });
        element.on('$destroy', handleDestroyedElement);

        // we only want there to be one function called within the post digest
        // block. This way we can group animations for all the animations that
        // were apart of the same postDigest flush call.
        if (animationQueue.length > 1) return runner;
        $rootScope.$$postDigest(function () {
          var animations = [];
          forEach(animationQueue, function (entry) {
            // the element was destroyed early on which removed the runner
            // form its storage. This means we can't animate this element
            // at all and it already has been closed due to destruction.
            if (getRunner(entry.element)) {
              animations.push(entry);
            } else {
              entry.close();
            }
          });

          // now any future animations will be in another postDigest
          animationQueue.length = 0;
          var groupedAnimations = groupAnimations(animations);
          var toBeSortedAnimations = [];
          forEach(groupedAnimations, function (animationEntry) {
            var element = animationEntry.from ? animationEntry.from.element : animationEntry.element;
            var extraClasses = options.addClass;
            extraClasses = (extraClasses ? extraClasses + ' ' : '') + NG_ANIMATE_CLASSNAME;
            var cacheKey = $$animateCache.cacheKey(element[0], animationEntry.event, extraClasses, options.removeClass);
            toBeSortedAnimations.push({
              element: element,
              domNode: getDomNode(element),
              fn: function triggerAnimationStart() {
                var startAnimationFn,
                  closeFn = animationEntry.close;

                // in the event that we've cached the animation status for this element
                // and it's in fact an invalid animation (something that has duration = 0)
                // then we should skip all the heavy work from here on
                if ($$animateCache.containsCachedAnimationWithoutDuration(cacheKey)) {
                  closeFn();
                  return;
                }

                // it's important that we apply the `ng-animate` CSS class and the
                // temporary classes before we do any driver invoking since these
                // CSS classes may be required for proper CSS detection.
                animationEntry.beforeStart();

                // in the event that the element was removed before the digest runs or
                // during the RAF sequencing then we should not trigger the animation.
                var targetElement = animationEntry.anchors ? animationEntry.from.element || animationEntry.to.element : animationEntry.element;
                if (getRunner(targetElement)) {
                  var operation = invokeFirstDriver(animationEntry);
                  if (operation) {
                    startAnimationFn = operation.start;
                  }
                }
                if (!startAnimationFn) {
                  closeFn();
                } else {
                  var animationRunner = startAnimationFn();
                  animationRunner.done(function (status) {
                    closeFn(!status);
                  });
                  updateAnimationRunners(animationEntry, animationRunner);
                }
              }
            });
          });

          // we need to sort each of the animations in order of parent to child
          // relationships. This ensures that the child classes are applied at the
          // right time.
          var finalAnimations = sortAnimations(toBeSortedAnimations);
          for (var i = 0; i < finalAnimations.length; i++) {
            var innerArray = finalAnimations[i];
            for (var j = 0; j < innerArray.length; j++) {
              var entry = innerArray[j];
              var element = entry.element;

              // the RAFScheduler code only uses functions
              finalAnimations[i][j] = entry.fn;

              // the first row of elements shouldn't have a prepare-class added to them
              // since the elements are at the top of the animation hierarchy and they
              // will be applied without a RAF having to pass...
              if (i === 0) {
                element.removeData(PREPARE_CLASSES_KEY);
                continue;
              }
              var prepareClassName = element.data(PREPARE_CLASSES_KEY);
              if (prepareClassName) {
                $$jqLite.addClass(element, prepareClassName);
              }
            }
          }
          $$rAFScheduler(finalAnimations);
        });
        return runner;

        // TODO(matsko): change to reference nodes
        function getAnchorNodes(node) {
          var SELECTOR = '[' + NG_ANIMATE_REF_ATTR + ']';
          var items = node.hasAttribute(NG_ANIMATE_REF_ATTR) ? [node] : node.querySelectorAll(SELECTOR);
          var anchors = [];
          forEach(items, function (node) {
            var attr = node.getAttribute(NG_ANIMATE_REF_ATTR);
            if (attr && attr.length) {
              anchors.push(node);
            }
          });
          return anchors;
        }
        function groupAnimations(animations) {
          var preparedAnimations = [];
          var refLookup = {};
          forEach(animations, function (animation, index) {
            var element = animation.element;
            var node = getDomNode(element);
            var event = animation.event;
            var enterOrMove = ['enter', 'move'].indexOf(event) >= 0;
            var anchorNodes = animation.structural ? getAnchorNodes(node) : [];
            if (anchorNodes.length) {
              var direction = enterOrMove ? 'to' : 'from';
              forEach(anchorNodes, function (anchor) {
                var key = anchor.getAttribute(NG_ANIMATE_REF_ATTR);
                refLookup[key] = refLookup[key] || {};
                refLookup[key][direction] = {
                  animationID: index,
                  element: jqLite(anchor)
                };
              });
            } else {
              preparedAnimations.push(animation);
            }
          });
          var usedIndicesLookup = {};
          var anchorGroups = {};
          forEach(refLookup, function (operations, key) {
            var from = operations.from;
            var to = operations.to;
            if (!from || !to) {
              // only one of these is set therefore we can't have an
              // anchor animation since all three pieces are required
              var index = from ? from.animationID : to.animationID;
              var indexKey = index.toString();
              if (!usedIndicesLookup[indexKey]) {
                usedIndicesLookup[indexKey] = true;
                preparedAnimations.push(animations[index]);
              }
              return;
            }
            var fromAnimation = animations[from.animationID];
            var toAnimation = animations[to.animationID];
            var lookupKey = from.animationID.toString();
            if (!anchorGroups[lookupKey]) {
              var group = anchorGroups[lookupKey] = {
                structural: true,
                beforeStart: function beforeStart() {
                  fromAnimation.beforeStart();
                  toAnimation.beforeStart();
                },
                close: function close() {
                  fromAnimation.close();
                  toAnimation.close();
                },
                classes: cssClassesIntersection(fromAnimation.classes, toAnimation.classes),
                from: fromAnimation,
                to: toAnimation,
                anchors: [] // TODO(matsko): change to reference nodes
              };

              // the anchor animations require that the from and to elements both have at least
              // one shared CSS class which effectively marries the two elements together to use
              // the same animation driver and to properly sequence the anchor animation.
              if (group.classes.length) {
                preparedAnimations.push(group);
              } else {
                preparedAnimations.push(fromAnimation);
                preparedAnimations.push(toAnimation);
              }
            }
            anchorGroups[lookupKey].anchors.push({
              'out': from.element,
              'in': to.element
            });
          });
          return preparedAnimations;
        }
        function cssClassesIntersection(a, b) {
          a = a.split(' ');
          b = b.split(' ');
          var matches = [];
          for (var i = 0; i < a.length; i++) {
            var aa = a[i];
            if (aa.substring(0, 3) === 'ng-') continue;
            for (var j = 0; j < b.length; j++) {
              if (aa === b[j]) {
                matches.push(aa);
                break;
              }
            }
          }
          return matches.join(' ');
        }
        function invokeFirstDriver(animationDetails) {
          // we loop in reverse order since the more general drivers (like CSS and JS)
          // may attempt more elements, but custom drivers are more particular
          for (var i = drivers.length - 1; i >= 0; i--) {
            var driverName = drivers[i];
            var factory = $injector.get(driverName);
            var driver = factory(animationDetails);
            if (driver) {
              return driver;
            }
          }
        }
        function beforeStart() {
          tempClasses = (tempClasses ? tempClasses + ' ' : '') + NG_ANIMATE_CLASSNAME;
          $$jqLite.addClass(element, tempClasses);
          var prepareClassName = element.data(PREPARE_CLASSES_KEY);
          if (prepareClassName) {
            $$jqLite.removeClass(element, prepareClassName);
            prepareClassName = null;
          }
        }
        function updateAnimationRunners(animation, newRunner) {
          if (animation.from && animation.to) {
            update(animation.from.element);
            update(animation.to.element);
          } else {
            update(animation.element);
          }
          function update(element) {
            var runner = getRunner(element);
            if (runner) runner.setHost(newRunner);
          }
        }
        function handleDestroyedElement() {
          var runner = getRunner(element);
          if (runner && (event !== 'leave' || !options.$$domOperationFired)) {
            runner.end();
          }
        }
        function close(rejected) {
          element.off('$destroy', handleDestroyedElement);
          removeRunner(element);
          applyAnimationClasses(element, options);
          applyAnimationStyles(element, options);
          options.domOperation();
          if (tempClasses) {
            $$jqLite.removeClass(element, tempClasses);
          }
          runner.complete(!rejected);
        }
      };
    }];
  }];

  /**
   * @ngdoc directive
   * @name ngAnimateSwap
   * @restrict A
   * @scope
   *
   * @description
   *
   * ngAnimateSwap is a animation-oriented directive that allows for the container to
   * be removed and entered in whenever the associated expression changes. A
   * common usecase for this directive is a rotating banner or slider component which
   * contains one image being present at a time. When the active image changes
   * then the old image will perform a `leave` animation and the new element
   * will be inserted via an `enter` animation.
   *
   * @animations
   * | Animation                        | Occurs                               |
   * |----------------------------------|--------------------------------------|
   * | {@link ng.$animate#enter enter}  | when the new element is inserted to the DOM  |
   * | {@link ng.$animate#leave leave}  | when the old element is removed from the DOM |
   *
   * @example
   * <example name="ngAnimateSwap-directive" module="ngAnimateSwapExample"
   *          deps="angular-animate.js"
   *          animations="true" fixBase="true">
   *   <file name="index.html">
   *     <div class="container" ng-controller="AppCtrl">
   *       <div ng-animate-swap="number" class="cell swap-animation" ng-class="colorClass(number)">
   *         {{ number }}
   *       </div>
   *     </div>
   *   </file>
   *   <file name="script.js">
   *     angular.module('ngAnimateSwapExample', ['ngAnimate'])
   *       .controller('AppCtrl', ['$scope', '$interval', function($scope, $interval) {
   *         $scope.number = 0;
   *         $interval(function() {
   *           $scope.number++;
   *         }, 1000);
   *
   *         var colors = ['red','blue','green','yellow','orange'];
   *         $scope.colorClass = function(number) {
   *           return colors[number % colors.length];
   *         };
   *       }]);
   *   </file>
   *  <file name="animations.css">
   *  .container {
   *    height:250px;
   *    width:250px;
   *    position:relative;
   *    overflow:hidden;
   *    border:2px solid black;
   *  }
   *  .container .cell {
   *    font-size:150px;
   *    text-align:center;
   *    line-height:250px;
   *    position:absolute;
   *    top:0;
   *    left:0;
   *    right:0;
   *    border-bottom:2px solid black;
   *  }
   *  .swap-animation.ng-enter, .swap-animation.ng-leave {
   *    transition:0.5s linear all;
   *  }
   *  .swap-animation.ng-enter {
   *    top:-250px;
   *  }
   *  .swap-animation.ng-enter-active {
   *    top:0px;
   *  }
   *  .swap-animation.ng-leave {
   *    top:0px;
   *  }
   *  .swap-animation.ng-leave-active {
   *    top:250px;
   *  }
   *  .red { background:red; }
   *  .green { background:green; }
   *  .blue { background:blue; }
   *  .yellow { background:yellow; }
   *  .orange { background:orange; }
   *  </file>
   * </example>
   */
  var ngAnimateSwapDirective = ['$animate', function ($animate) {
    return {
      restrict: 'A',
      transclude: 'element',
      terminal: true,
      priority: 550,
      // We use 550 here to ensure that the directive is caught before others,
      // but after `ngIf` (at priority 600).
      link: function link(scope, $element, attrs, ctrl, $transclude) {
        var previousElement, previousScope;
        scope.$watchCollection(attrs.ngAnimateSwap || attrs['for'], function (value) {
          if (previousElement) {
            $animate.leave(previousElement);
          }
          if (previousScope) {
            previousScope.$destroy();
            previousScope = null;
          }
          if (value || value === 0) {
            $transclude(function (clone, childScope) {
              previousElement = clone;
              previousScope = childScope;
              $animate.enter(clone, null, $element);
            });
          }
        });
      }
    };
  }];

  /**
   * @ngdoc module
   * @name ngAnimate
   * @description
   *
   * The `ngAnimate` module provides support for CSS-based animations (keyframes and transitions) as well as JavaScript-based animations via
   * callback hooks. Animations are not enabled by default, however, by including `ngAnimate` the animation hooks are enabled for an AngularJS app.
   *
   * ## Usage
   * Simply put, there are two ways to make use of animations when ngAnimate is used: by using **CSS** and **JavaScript**. The former works purely based
   * using CSS (by using matching CSS selectors/styles) and the latter triggers animations that are registered via `module.animation()`. For
   * both CSS and JS animations the sole requirement is to have a matching `CSS class` that exists both in the registered animation and within
   * the HTML element that the animation will be triggered on.
   *
   * ## Directive Support
   * The following directives are "animation aware":
   *
   * | Directive                                                                     | Supported Animations                                                      |
   * |-------------------------------------------------------------------------------|---------------------------------------------------------------------------|
   * | {@link ng.directive:form#animations form / ngForm}                            | add and remove ({@link ng.directive:form#css-classes various classes})    |
   * | {@link ngAnimate.directive:ngAnimateSwap#animations ngAnimateSwap}            | enter and leave                                                           |
   * | {@link ng.directive:ngClass#animations ngClass / {{class&#125;&#8203;&#125;}  | add and remove                                                            |
   * | {@link ng.directive:ngClassEven#animations ngClassEven}                       | add and remove                                                            |
   * | {@link ng.directive:ngClassOdd#animations ngClassOdd}                         | add and remove                                                            |
   * | {@link ng.directive:ngHide#animations ngHide}                                 | add and remove (the `ng-hide` class)                                      |
   * | {@link ng.directive:ngIf#animations ngIf}                                     | enter and leave                                                           |
   * | {@link ng.directive:ngInclude#animations ngInclude}                           | enter and leave                                                           |
   * | {@link module:ngMessages#animations ngMessage / ngMessageExp}                 | enter and leave                                                           |
   * | {@link module:ngMessages#animations ngMessages}                               | add and remove (the `ng-active`/`ng-inactive` classes)                    |
   * | {@link ng.directive:ngModel#animations ngModel}                               | add and remove ({@link ng.directive:ngModel#css-classes various classes}) |
   * | {@link ng.directive:ngRepeat#animations ngRepeat}                             | enter, leave, and move                                                    |
   * | {@link ng.directive:ngShow#animations ngShow}                                 | add and remove (the `ng-hide` class)                                      |
   * | {@link ng.directive:ngSwitch#animations ngSwitch}                             | enter and leave                                                           |
   * | {@link ngRoute.directive:ngView#animations ngView}                            | enter and leave                                                           |
   *
   * (More information can be found by visiting the documentation associated with each directive.)
   *
   * For a full breakdown of the steps involved during each animation event, refer to the
   * {@link ng.$animate `$animate` API docs}.
   *
   * ## CSS-based Animations
   *
   * CSS-based animations with ngAnimate are unique since they require no JavaScript code at all. By using a CSS class that we reference between our HTML
   * and CSS code we can create an animation that will be picked up by AngularJS when an underlying directive performs an operation.
   *
   * The example below shows how an `enter` animation can be made possible on an element using `ng-if`:
   *
   * ```html
   * <div ng-if="bool" class="fade">
   *    Fade me in out
   * </div>
   * <button ng-click="bool=true">Fade In!</button>
   * <button ng-click="bool=false">Fade Out!</button>
   * ```
   *
   * Notice the CSS class **fade**? We can now create the CSS transition code that references this class:
   *
   * ```css
   * /&#42; The starting CSS styles for the enter animation &#42;/
   * .fade.ng-enter {
   *   transition:0.5s linear all;
   *   opacity:0;
   * }
   *
   * /&#42; The finishing CSS styles for the enter animation &#42;/
   * .fade.ng-enter.ng-enter-active {
   *   opacity:1;
   * }
   * ```
   *
   * The key thing to remember here is that, depending on the animation event (which each of the directives above trigger depending on what's going on) two
   * generated CSS classes will be applied to the element; in the example above we have `.ng-enter` and `.ng-enter-active`. For CSS transitions, the transition
   * code **must** be defined within the starting CSS class (in this case `.ng-enter`). The destination class is what the transition will animate towards.
   *
   * If for example we wanted to create animations for `leave` and `move` (ngRepeat triggers move) then we can do so using the same CSS naming conventions:
   *
   * ```css
   * /&#42; now the element will fade out before it is removed from the DOM &#42;/
   * .fade.ng-leave {
   *   transition:0.5s linear all;
   *   opacity:1;
   * }
   * .fade.ng-leave.ng-leave-active {
   *   opacity:0;
   * }
   * ```
   *
   * We can also make use of **CSS Keyframes** by referencing the keyframe animation within the starting CSS class:
   *
   * ```css
   * /&#42; there is no need to define anything inside of the destination
   * CSS class since the keyframe will take charge of the animation &#42;/
   * .fade.ng-leave {
   *   animation: my_fade_animation 0.5s linear;
   *   -webkit-animation: my_fade_animation 0.5s linear;
   * }
   *
   * @keyframes my_fade_animation {
   *   from { opacity:1; }
   *   to { opacity:0; }
   * }
   *
   * @-webkit-keyframes my_fade_animation {
   *   from { opacity:1; }
   *   to { opacity:0; }
   * }
   * ```
   *
   * Feel free also mix transitions and keyframes together as well as any other CSS classes on the same element.
   *
   * ### CSS Class-based Animations
   *
   * Class-based animations (animations that are triggered via `ngClass`, `ngShow`, `ngHide` and some other directives) have a slightly different
   * naming convention. Class-based animations are basic enough that a standard transition or keyframe can be referenced on the class being added
   * and removed.
   *
   * For example if we wanted to do a CSS animation for `ngHide` then we place an animation on the `.ng-hide` CSS class:
   *
   * ```html
   * <div ng-show="bool" class="fade">
   *   Show and hide me
   * </div>
   * <button ng-click="bool=!bool">Toggle</button>
   *
   * <style>
   * .fade.ng-hide {
   *   transition:0.5s linear all;
   *   opacity:0;
   * }
   * </style>
   * ```
   *
   * All that is going on here with ngShow/ngHide behind the scenes is the `.ng-hide` class is added/removed (when the hidden state is valid). Since
   * ngShow and ngHide are animation aware then we can match up a transition and ngAnimate handles the rest.
   *
   * In addition the addition and removal of the CSS class, ngAnimate also provides two helper methods that we can use to further decorate the animation
   * with CSS styles.
   *
   * ```html
   * <div ng-class="{on:onOff}" class="highlight">
   *   Highlight this box
   * </div>
   * <button ng-click="onOff=!onOff">Toggle</button>
   *
   * <style>
   * .highlight {
   *   transition:0.5s linear all;
   * }
   * .highlight.on-add {
   *   background:white;
   * }
   * .highlight.on {
   *   background:yellow;
   * }
   * .highlight.on-remove {
   *   background:black;
   * }
   * </style>
   * ```
   *
   * We can also make use of CSS keyframes by placing them within the CSS classes.
   *
   *
   * ### CSS Staggering Animations
   * A Staggering animation is a collection of animations that are issued with a slight delay in between each successive operation resulting in a
   * curtain-like effect. The ngAnimate module (versions >=1.2) supports staggering animations and the stagger effect can be
   * performed by creating a **ng-EVENT-stagger** CSS class and attaching that class to the base CSS class used for
   * the animation. The style property expected within the stagger class can either be a **transition-delay** or an
   * **animation-delay** property (or both if your animation contains both transitions and keyframe animations).
   *
   * ```css
   * .my-animation.ng-enter {
   *   /&#42; standard transition code &#42;/
   *   transition: 1s linear all;
   *   opacity:0;
   * }
   * .my-animation.ng-enter-stagger {
   *   /&#42; this will have a 100ms delay between each successive leave animation &#42;/
   *   transition-delay: 0.1s;
   *
   *   /&#42; As of 1.4.4, this must always be set: it signals ngAnimate
   *     to not accidentally inherit a delay property from another CSS class &#42;/
   *   transition-duration: 0s;
   *
   *   /&#42; if you are using animations instead of transitions you should configure as follows:
   *     animation-delay: 0.1s;
   *     animation-duration: 0s; &#42;/
   * }
   * .my-animation.ng-enter.ng-enter-active {
   *   /&#42; standard transition styles &#42;/
   *   opacity:1;
   * }
   * ```
   *
   * Staggering animations work by default in ngRepeat (so long as the CSS class is defined). Outside of ngRepeat, to use staggering animations
   * on your own, they can be triggered by firing multiple calls to the same event on $animate. However, the restrictions surrounding this
   * are that each of the elements must have the same CSS className value as well as the same parent element. A stagger operation
   * will also be reset if one or more animation frames have passed since the multiple calls to `$animate` were fired.
   *
   * The following code will issue the **ng-leave-stagger** event on the element provided:
   *
   * ```js
   * var kids = parent.children();
   *
   * $animate.leave(kids[0]); //stagger index=0
   * $animate.leave(kids[1]); //stagger index=1
   * $animate.leave(kids[2]); //stagger index=2
   * $animate.leave(kids[3]); //stagger index=3
   * $animate.leave(kids[4]); //stagger index=4
   *
   * window.requestAnimationFrame(function() {
   *   //stagger has reset itself
   *   $animate.leave(kids[5]); //stagger index=0
   *   $animate.leave(kids[6]); //stagger index=1
   *
   *   $scope.$digest();
   * });
   * ```
   *
   * Stagger animations are currently only supported within CSS-defined animations.
   *
   * ### The `ng-animate` CSS class
   *
   * When ngAnimate is animating an element it will apply the `ng-animate` CSS class to the element for the duration of the animation.
   * This is a temporary CSS class and it will be removed once the animation is over (for both JavaScript and CSS-based animations).
   *
   * Therefore, animations can be applied to an element using this temporary class directly via CSS.
   *
   * ```css
   * .zipper.ng-animate {
   *   transition:0.5s linear all;
   * }
   * .zipper.ng-enter {
   *   opacity:0;
   * }
   * .zipper.ng-enter.ng-enter-active {
   *   opacity:1;
   * }
   * .zipper.ng-leave {
   *   opacity:1;
   * }
   * .zipper.ng-leave.ng-leave-active {
   *   opacity:0;
   * }
   * ```
   *
   * (Note that the `ng-animate` CSS class is reserved and it cannot be applied on an element directly since ngAnimate will always remove
   * the CSS class once an animation has completed.)
   *
   *
   * ### The `ng-[event]-prepare` class
   *
   * This is a special class that can be used to prevent unwanted flickering / flash of content before
   * the actual animation starts. The class is added as soon as an animation is initialized, but removed
   * before the actual animation starts (after waiting for a $digest).
   * It is also only added for *structural* animations (`enter`, `move`, and `leave`).
   *
   * In practice, flickering can appear when nesting elements with structural animations such as `ngIf`
   * into elements that have class-based animations such as `ngClass`.
   *
   * ```html
   * <div ng-class="{red: myProp}">
   *   <div ng-class="{blue: myProp}">
   *     <div class="message" ng-if="myProp"></div>
   *   </div>
   * </div>
   * ```
   *
   * It is possible that during the `enter` animation, the `.message` div will be briefly visible before it starts animating.
   * In that case, you can add styles to the CSS that make sure the element stays hidden before the animation starts:
   *
   * ```css
   * .message.ng-enter-prepare {
   *   opacity: 0;
   * }
   * ```
   *
   * ### Animating between value changes
   *
   * Sometimes you need to animate between different expression states, whose values
   * don't necessary need to be known or referenced in CSS styles.
   * Unless possible with another {@link ngAnimate#directive-support "animation aware" directive},
   * that specific use case can always be covered with {@link ngAnimate.directive:ngAnimateSwap} as
   * can be seen in {@link ngAnimate.directive:ngAnimateSwap#examples this example}.
   *
   * Note that {@link ngAnimate.directive:ngAnimateSwap} is a *structural directive*, which means it
   * creates a new instance of the element (including any other/child directives it may have) and
   * links it to a new scope every time *swap* happens. In some cases this might not be desirable
   * (e.g. for performance reasons, or when you wish to retain internal state on the original
   * element instance).
   *
   * ## JavaScript-based Animations
   *
   * ngAnimate also allows for animations to be consumed by JavaScript code. The approach is similar to CSS-based animations (where there is a shared
   * CSS class that is referenced in our HTML code) but in addition we need to register the JavaScript animation on the module. By making use of the
   * `module.animation()` module function we can register the animation.
   *
   * Let's see an example of a enter/leave animation using `ngRepeat`:
   *
   * ```html
   * <div ng-repeat="item in items" class="slide">
   *   {{ item }}
   * </div>
   * ```
   *
   * See the **slide** CSS class? Let's use that class to define an animation that we'll structure in our module code by using `module.animation`:
   *
   * ```js
   * myModule.animation('.slide', [function() {
   *   return {
   *     // make note that other events (like addClass/removeClass)
   *     // have different function input parameters
   *     enter: function(element, doneFn) {
   *       jQuery(element).fadeIn(1000, doneFn);
   *
   *       // remember to call doneFn so that AngularJS
   *       // knows that the animation has concluded
   *     },
   *
   *     move: function(element, doneFn) {
   *       jQuery(element).fadeIn(1000, doneFn);
   *     },
   *
   *     leave: function(element, doneFn) {
   *       jQuery(element).fadeOut(1000, doneFn);
   *     }
   *   }
   * }]);
   * ```
   *
   * The nice thing about JS-based animations is that we can inject other services and make use of advanced animation libraries such as
   * greensock.js and velocity.js.
   *
   * If our animation code class-based (meaning that something like `ngClass`, `ngHide` and `ngShow` triggers it) then we can still define
   * our animations inside of the same registered animation, however, the function input arguments are a bit different:
   *
   * ```html
   * <div ng-class="color" class="colorful">
   *   this box is moody
   * </div>
   * <button ng-click="color='red'">Change to red</button>
   * <button ng-click="color='blue'">Change to blue</button>
   * <button ng-click="color='green'">Change to green</button>
   * ```
   *
   * ```js
   * myModule.animation('.colorful', [function() {
   *   return {
   *     addClass: function(element, className, doneFn) {
   *       // do some cool animation and call the doneFn
   *     },
   *     removeClass: function(element, className, doneFn) {
   *       // do some cool animation and call the doneFn
   *     },
   *     setClass: function(element, addedClass, removedClass, doneFn) {
   *       // do some cool animation and call the doneFn
   *     }
   *   }
   * }]);
   * ```
   *
   * ## CSS + JS Animations Together
   *
   * AngularJS 1.4 and higher has taken steps to make the amalgamation of CSS and JS animations more flexible. However, unlike earlier versions of AngularJS,
   * defining CSS and JS animations to work off of the same CSS class will not work anymore. Therefore the example below will only result in **JS animations taking
   * charge of the animation**:
   *
   * ```html
   * <div ng-if="bool" class="slide">
   *   Slide in and out
   * </div>
   * ```
   *
   * ```js
   * myModule.animation('.slide', [function() {
   *   return {
   *     enter: function(element, doneFn) {
   *       jQuery(element).slideIn(1000, doneFn);
   *     }
   *   }
   * }]);
   * ```
   *
   * ```css
   * .slide.ng-enter {
   *   transition:0.5s linear all;
   *   transform:translateY(-100px);
   * }
   * .slide.ng-enter.ng-enter-active {
   *   transform:translateY(0);
   * }
   * ```
   *
   * Does this mean that CSS and JS animations cannot be used together? Do JS-based animations always have higher priority? We can make up for the
   * lack of CSS animations by using the `$animateCss` service to trigger our own tweaked-out, CSS-based animations directly from
   * our own JS-based animation code:
   *
   * ```js
   * myModule.animation('.slide', ['$animateCss', function($animateCss) {
   *   return {
   *     enter: function(element) {
  *        // this will trigger `.slide.ng-enter` and `.slide.ng-enter-active`.
   *       return $animateCss(element, {
   *         event: 'enter',
   *         structural: true
   *       });
   *     }
   *   }
   * }]);
   * ```
   *
   * The nice thing here is that we can save bandwidth by sticking to our CSS-based animation code and we don't need to rely on a 3rd-party animation framework.
   *
   * The `$animateCss` service is very powerful since we can feed in all kinds of extra properties that will be evaluated and fed into a CSS transition or
   * keyframe animation. For example if we wanted to animate the height of an element while adding and removing classes then we can do so by providing that
   * data into `$animateCss` directly:
   *
   * ```js
   * myModule.animation('.slide', ['$animateCss', function($animateCss) {
   *   return {
   *     enter: function(element) {
   *       return $animateCss(element, {
   *         event: 'enter',
   *         structural: true,
   *         addClass: 'maroon-setting',
   *         from: { height:0 },
   *         to: { height: 200 }
   *       });
   *     }
   *   }
   * }]);
   * ```
   *
   * Now we can fill in the rest via our transition CSS code:
   *
   * ```css
   * /&#42; the transition tells ngAnimate to make the animation happen &#42;/
   * .slide.ng-enter { transition:0.5s linear all; }
   *
   * /&#42; this extra CSS class will be absorbed into the transition
   * since the $animateCss code is adding the class &#42;/
   * .maroon-setting { background:red; }
   * ```
   *
   * And `$animateCss` will figure out the rest. Just make sure to have the `done()` callback fire the `doneFn` function to signal when the animation is over.
   *
   * To learn more about what's possible be sure to visit the {@link ngAnimate.$animateCss $animateCss service}.
   *
   * ## Animation Anchoring (via `ng-animate-ref`)
   *
   * ngAnimate in AngularJS 1.4 comes packed with the ability to cross-animate elements between
   * structural areas of an application (like views) by pairing up elements using an attribute
   * called `ng-animate-ref`.
   *
   * Let's say for example we have two views that are managed by `ng-view` and we want to show
   * that there is a relationship between two components situated in within these views. By using the
   * `ng-animate-ref` attribute we can identify that the two components are paired together and we
   * can then attach an animation, which is triggered when the view changes.
   *
   * Say for example we have the following template code:
   *
   * ```html
   * <!-- index.html -->
   * <div ng-view class="view-animation">
   * </div>
   *
   * <!-- home.html -->
   * <a href="#/banner-page">
   *   <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
   * </a>
   *
   * <!-- banner-page.html -->
   * <img src="./banner.jpg" class="banner" ng-animate-ref="banner">
   * ```
   *
   * Now, when the view changes (once the link is clicked), ngAnimate will examine the
   * HTML contents to see if there is a match reference between any components in the view
   * that is leaving and the view that is entering. It will scan both the view which is being
   * removed (leave) and inserted (enter) to see if there are any paired DOM elements that
   * contain a matching ref value.
   *
   * The two images match since they share the same ref value. ngAnimate will now create a
   * transport element (which is a clone of the first image element) and it will then attempt
   * to animate to the position of the second image element in the next view. For the animation to
   * work a special CSS class called `ng-anchor` will be added to the transported element.
   *
   * We can now attach a transition onto the `.banner.ng-anchor` CSS class and then
   * ngAnimate will handle the entire transition for us as well as the addition and removal of
   * any changes of CSS classes between the elements:
   *
   * ```css
   * .banner.ng-anchor {
   *   /&#42; this animation will last for 1 second since there are
   *          two phases to the animation (an `in` and an `out` phase) &#42;/
   *   transition:0.5s linear all;
   * }
   * ```
   *
   * We also **must** include animations for the views that are being entered and removed
   * (otherwise anchoring wouldn't be possible since the new view would be inserted right away).
   *
   * ```css
   * .view-animation.ng-enter, .view-animation.ng-leave {
   *   transition:0.5s linear all;
   *   position:fixed;
   *   left:0;
   *   top:0;
   *   width:100%;
   * }
   * .view-animation.ng-enter {
   *   transform:translateX(100%);
   * }
   * .view-animation.ng-leave,
   * .view-animation.ng-enter.ng-enter-active {
   *   transform:translateX(0%);
   * }
   * .view-animation.ng-leave.ng-leave-active {
   *   transform:translateX(-100%);
   * }
   * ```
   *
   * Now we can jump back to the anchor animation. When the animation happens, there are two stages that occur:
   * an `out` and an `in` stage. The `out` stage happens first and that is when the element is animated away
   * from its origin. Once that animation is over then the `in` stage occurs which animates the
   * element to its destination. The reason why there are two animations is to give enough time
   * for the enter animation on the new element to be ready.
   *
   * The example above sets up a transition for both the in and out phases, but we can also target the out or
   * in phases directly via `ng-anchor-out` and `ng-anchor-in`.
   *
   * ```css
   * .banner.ng-anchor-out {
   *   transition: 0.5s linear all;
   *
   *   /&#42; the scale will be applied during the out animation,
   *          but will be animated away when the in animation runs &#42;/
   *   transform: scale(1.2);
   * }
   *
   * .banner.ng-anchor-in {
   *   transition: 1s linear all;
   * }
   * ```
   *
   *
   *
   *
   * ### Anchoring Demo
   *
    <example module="anchoringExample"
             name="anchoringExample"
             id="anchoringExample"
             deps="angular-animate.js;angular-route.js"
             animations="true">
      <file name="index.html">
        <a href="#!/">Home</a>
        <hr />
        <div class="view-container">
          <div ng-view class="view"></div>
        </div>
      </file>
      <file name="script.js">
        angular.module('anchoringExample', ['ngAnimate', 'ngRoute'])
          .config(['$routeProvider', function($routeProvider) {
            $routeProvider.when('/', {
              templateUrl: 'home.html',
              controller: 'HomeController as home'
            });
            $routeProvider.when('/profile/:id', {
              templateUrl: 'profile.html',
              controller: 'ProfileController as profile'
            });
          }])
          .run(['$rootScope', function($rootScope) {
            $rootScope.records = [
              { id: 1, title: 'Miss Beulah Roob' },
              { id: 2, title: 'Trent Morissette' },
              { id: 3, title: 'Miss Ava Pouros' },
              { id: 4, title: 'Rod Pouros' },
              { id: 5, title: 'Abdul Rice' },
              { id: 6, title: 'Laurie Rutherford Sr.' },
              { id: 7, title: 'Nakia McLaughlin' },
              { id: 8, title: 'Jordon Blanda DVM' },
              { id: 9, title: 'Rhoda Hand' },
              { id: 10, title: 'Alexandrea Sauer' }
            ];
          }])
          .controller('HomeController', [function() {
            //empty
          }])
          .controller('ProfileController', ['$rootScope', '$routeParams',
              function ProfileController($rootScope, $routeParams) {
            var index = parseInt($routeParams.id, 10);
            var record = $rootScope.records[index - 1];
  
            this.title = record.title;
            this.id = record.id;
          }]);
      </file>
      <file name="home.html">
        <h2>Welcome to the home page</h1>
        <p>Please click on an element</p>
        <a class="record"
           ng-href="#!/profile/{{ record.id }}"
           ng-animate-ref="{{ record.id }}"
           ng-repeat="record in records">
          {{ record.title }}
        </a>
      </file>
      <file name="profile.html">
        <div class="profile record" ng-animate-ref="{{ profile.id }}">
          {{ profile.title }}
        </div>
      </file>
      <file name="animations.css">
        .record {
          display:block;
          font-size:20px;
        }
        .profile {
          background:black;
          color:white;
          font-size:100px;
        }
        .view-container {
          position:relative;
        }
        .view-container > .view.ng-animate {
          position:absolute;
          top:0;
          left:0;
          width:100%;
          min-height:500px;
        }
        .view.ng-enter, .view.ng-leave,
        .record.ng-anchor {
          transition:0.5s linear all;
        }
        .view.ng-enter {
          transform:translateX(100%);
        }
        .view.ng-enter.ng-enter-active, .view.ng-leave {
          transform:translateX(0%);
        }
        .view.ng-leave.ng-leave-active {
          transform:translateX(-100%);
        }
        .record.ng-anchor-out {
          background:red;
        }
      </file>
    </example>
   *
   * ### How is the element transported?
   *
   * When an anchor animation occurs, ngAnimate will clone the starting element and position it exactly where the starting
   * element is located on screen via absolute positioning. The cloned element will be placed inside of the root element
   * of the application (where ng-app was defined) and all of the CSS classes of the starting element will be applied. The
   * element will then animate into the `out` and `in` animations and will eventually reach the coordinates and match
   * the dimensions of the destination element. During the entire animation a CSS class of `.ng-animate-shim` will be applied
   * to both the starting and destination elements in order to hide them from being visible (the CSS styling for the class
   * is: `visibility:hidden`). Once the anchor reaches its destination then it will be removed and the destination element
   * will become visible since the shim class will be removed.
   *
   * ### How is the morphing handled?
   *
   * CSS Anchoring relies on transitions and keyframes and the internal code is intelligent enough to figure out
   * what CSS classes differ between the starting element and the destination element. These different CSS classes
   * will be added/removed on the anchor element and a transition will be applied (the transition that is provided
   * in the anchor class). Long story short, ngAnimate will figure out what classes to add and remove which will
   * make the transition of the element as smooth and automatic as possible. Be sure to use simple CSS classes that
   * do not rely on DOM nesting structure so that the anchor element appears the same as the starting element (since
   * the cloned element is placed inside of root element which is likely close to the body element).
   *
   * Note that if the root element is on the `<html>` element then the cloned node will be placed inside of body.
   *
   *
   * ## Using $animate in your directive code
   *
   * So far we've explored how to feed in animations into an AngularJS application, but how do we trigger animations within our own directives in our application?
   * By injecting the `$animate` service into our directive code, we can trigger structural and class-based hooks which can then be consumed by animations. Let's
   * imagine we have a greeting box that shows and hides itself when the data changes
   *
   * ```html
   * <greeting-box active="onOrOff">Hi there</greeting-box>
   * ```
   *
   * ```js
   * ngModule.directive('greetingBox', ['$animate', function($animate) {
   *   return function(scope, element, attrs) {
   *     attrs.$observe('active', function(value) {
   *       value ? $animate.addClass(element, 'on') : $animate.removeClass(element, 'on');
   *     });
   *   });
   * }]);
   * ```
   *
   * Now the `on` CSS class is added and removed on the greeting box component. Now if we add a CSS class on top of the greeting box element
   * in our HTML code then we can trigger a CSS or JS animation to happen.
   *
   * ```css
   * /&#42; normally we would create a CSS class to reference on the element &#42;/
   * greeting-box.on { transition:0.5s linear all; background:green; color:white; }
   * ```
   *
   * The `$animate` service contains a variety of other methods like `enter`, `leave`, `animate` and `setClass`. To learn more about what's
   * possible be sure to visit the {@link ng.$animate $animate service API page}.
   *
   *
   * ## Callbacks and Promises
   *
   * When `$animate` is called it returns a promise that can be used to capture when the animation has ended. Therefore if we were to trigger
   * an animation (within our directive code) then we can continue performing directive and scope related activities after the animation has
   * ended by chaining onto the returned promise that animation method returns.
   *
   * ```js
   * // somewhere within the depths of the directive
   * $animate.enter(element, parent).then(function() {
   *   //the animation has completed
   * });
   * ```
   *
   * (Note that earlier versions of AngularJS prior to v1.4 required the promise code to be wrapped using `$scope.$apply(...)`. This is not the case
   * anymore.)
   *
   * In addition to the animation promise, we can also make use of animation-related callbacks within our directives and controller code by registering
   * an event listener using the `$animate` service. Let's say for example that an animation was triggered on our view
   * routing controller to hook into that:
   *
   * ```js
   * ngModule.controller('HomePageController', ['$animate', function($animate) {
   *   $animate.on('enter', ngViewElement, function(element) {
   *     // the animation for this route has completed
   *   }]);
   * }])
   * ```
   *
   * (Note that you will need to trigger a digest within the callback to get AngularJS to notice any scope-related changes.)
   */

  var copy;
  var extend;
  var forEach;
  var isArray;
  var isDefined;
  var isElement;
  var isFunction;
  var isObject;
  var isString;
  var isUndefined;
  var jqLite;
  var noop;

  /**
   * @ngdoc service
   * @name $animate
   * @kind object
   *
   * @description
   * The ngAnimate `$animate` service documentation is the same for the core `$animate` service.
   *
   * Click here {@link ng.$animate to learn more about animations with `$animate`}.
   */
  angular.module('ngAnimate', [], function initAngularHelpers() {
    // Access helpers from AngularJS core.
    // Do it inside a `config` block to ensure `window.angular` is available.
    noop = angular.noop;
    copy = angular.copy;
    extend = angular.extend;
    jqLite = angular.element;
    forEach = angular.forEach;
    isArray = angular.isArray;
    isString = angular.isString;
    isObject = angular.isObject;
    isUndefined = angular.isUndefined;
    isDefined = angular.isDefined;
    isFunction = angular.isFunction;
    isElement = angular.isElement;
  }).info({
    angularVersion: '1.8.2'
  }).directive('ngAnimateSwap', ngAnimateSwapDirective).directive('ngAnimateChildren', $$AnimateChildrenDirective).factory('$$rAFScheduler', $$rAFSchedulerFactory).provider('$$animateQueue', $$AnimateQueueProvider).provider('$$animateCache', $$AnimateCacheProvider).provider('$$animation', $$AnimationProvider).provider('$animateCss', $AnimateCssProvider).provider('$$animateCssDriver', $$AnimateCssDriverProvider).provider('$$animateJs', $$AnimateJsProvider).provider('$$animateJsDriver', $$AnimateJsDriverProvider);
})(window, window.angular);

/**
 * @license AngularJS v1.8.2
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function (window, angular) {
  'use strict';

  /**
   * @ngdoc module
   * @name ngCookies
   * @description
   *
   * The `ngCookies` module provides a convenient wrapper for reading and writing browser cookies.
   *
   * See {@link ngCookies.$cookies `$cookies`} for usage.
   */
  angular.module('ngCookies', ['ng']).info({
    angularVersion: '1.8.2'
  }).
  /**
   * @ngdoc provider
   * @name $cookiesProvider
   * @description
   * Use `$cookiesProvider` to change the default behavior of the {@link ngCookies.$cookies $cookies} service.
   * */
  provider('$cookies', [/** @this */function $CookiesProvider() {
    /**
     * @ngdoc property
     * @name $cookiesProvider#defaults
     * @description
     *
     * Object containing default options to pass when setting cookies.
     *
     * The object may have following properties:
     *
     * - **path** - `{string}` - The cookie will be available only for this path and its
     *   sub-paths. By default, this is the URL that appears in your `<base>` tag.
     * - **domain** - `{string}` - The cookie will be available only for this domain and
     *   its sub-domains. For security reasons the user agent will not accept the cookie
     *   if the current domain is not a sub-domain of this domain or equal to it.
     * - **expires** - `{string|Date}` - String of the form "Wdy, DD Mon YYYY HH:MM:SS GMT"
     *   or a Date object indicating the exact date/time this cookie will expire.
     * - **secure** - `{boolean}` - If `true`, then the cookie will only be available through a
     *   secured connection.
     * - **samesite** - `{string}` - prevents the browser from sending the cookie along with cross-site requests.
     *   Accepts the values `lax` and `strict`. See the [OWASP Wiki](https://www.owasp.org/index.php/SameSite)
     *   for more info. Note that as of May 2018, not all browsers support `SameSite`,
     *   so it cannot be used as a single measure against Cross-Site-Request-Forgery (CSRF) attacks.
     *
     * Note: By default, the address that appears in your `<base>` tag will be used as the path.
     * This is important so that cookies will be visible for all routes when html5mode is enabled.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesProviderExample', ['ngCookies'])
     *   .config(['$cookiesProvider', function($cookiesProvider) {
     *     // Setting default options
     *     $cookiesProvider.defaults.domain = 'foo.com';
     *     $cookiesProvider.defaults.secure = true;
     *   }]);
     * ```
     **/
    var defaults = this.defaults = {};
    function calcOptions(options) {
      return options ? angular.extend({}, defaults, options) : defaults;
    }

    /**
     * @ngdoc service
     * @name $cookies
     *
     * @description
     * Provides read/write access to browser's cookies.
     *
     * <div class="alert alert-info">
     * Up until AngularJS 1.3, `$cookies` exposed properties that represented the
     * current browser cookie values. In version 1.4, this behavior has changed, and
     * `$cookies` now provides a standard api of getters, setters etc.
     * </div>
     *
     * Requires the {@link ngCookies `ngCookies`} module to be installed.
     *
     * @example
     *
     * ```js
     * angular.module('cookiesExample', ['ngCookies'])
     *   .controller('ExampleController', ['$cookies', function($cookies) {
     *     // Retrieving a cookie
     *     var favoriteCookie = $cookies.get('myFavorite');
     *     // Setting a cookie
     *     $cookies.put('myFavorite', 'oatmeal');
     *   }]);
     * ```
     */
    this.$get = ['$$cookieReader', '$$cookieWriter', function ($$cookieReader, $$cookieWriter) {
      return {
        /**
         * @ngdoc method
         * @name $cookies#get
         *
         * @description
         * Returns the value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {string} Raw cookie value.
         */
        get: function get(key) {
          return $$cookieReader()[key];
        },
        /**
         * @ngdoc method
         * @name $cookies#getObject
         *
         * @description
         * Returns the deserialized value of given cookie key
         *
         * @param {string} key Id to use for lookup.
         * @returns {Object} Deserialized cookie value.
         */
        getObject: function getObject(key) {
          var value = this.get(key);
          return value ? angular.fromJson(value) : value;
        },
        /**
         * @ngdoc method
         * @name $cookies#getAll
         *
         * @description
         * Returns a key value object with all the cookies
         *
         * @returns {Object} All cookies
         */
        getAll: function getAll() {
          return $$cookieReader();
        },
        /**
         * @ngdoc method
         * @name $cookies#put
         *
         * @description
         * Sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {string} value Raw value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        put: function put(key, value, options) {
          $$cookieWriter(key, value, calcOptions(options));
        },
        /**
         * @ngdoc method
         * @name $cookies#putObject
         *
         * @description
         * Serializes and sets a value for given cookie key
         *
         * @param {string} key Id for the `value`.
         * @param {Object} value Value to be stored.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        putObject: function putObject(key, value, options) {
          this.put(key, angular.toJson(value), options);
        },
        /**
         * @ngdoc method
         * @name $cookies#remove
         *
         * @description
         * Remove given cookie
         *
         * @param {string} key Id of the key-value pair to delete.
         * @param {Object=} options Options object.
         *    See {@link ngCookies.$cookiesProvider#defaults $cookiesProvider.defaults}
         */
        remove: function remove(key, options) {
          $$cookieWriter(key, undefined, calcOptions(options));
        }
      };
    }];
  }]);

  /**
   * @name $$cookieWriter
   * @requires $document
   *
   * @description
   * This is a private service for writing cookies
   *
   * @param {string} name Cookie name
   * @param {string=} value Cookie value (if undefined, cookie will be deleted)
   * @param {Object=} options Object with options that need to be stored for the cookie.
   */
  function $$CookieWriter($document, $log, $browser) {
    var cookiePath = $browser.baseHref();
    var rawDocument = $document[0];
    function buildCookieString(name, value, options) {
      var path, expires;
      options = options || {};
      expires = options.expires;
      path = angular.isDefined(options.path) ? options.path : cookiePath;
      if (angular.isUndefined(value)) {
        expires = 'Thu, 01 Jan 1970 00:00:00 GMT';
        value = '';
      }
      if (angular.isString(expires)) {
        expires = new Date(expires);
      }
      var str = encodeURIComponent(name) + '=' + encodeURIComponent(value);
      str += path ? ';path=' + path : '';
      str += options.domain ? ';domain=' + options.domain : '';
      str += expires ? ';expires=' + expires.toUTCString() : '';
      str += options.secure ? ';secure' : '';
      str += options.samesite ? ';samesite=' + options.samesite : '';

      // per http://www.ietf.org/rfc/rfc2109.txt browser must allow at minimum:
      // - 300 cookies
      // - 20 cookies per unique domain
      // - 4096 bytes per cookie
      var cookieLength = str.length + 1;
      if (cookieLength > 4096) {
        $log.warn('Cookie \'' + name + '\' possibly not set or overflowed because it was too large (' + cookieLength + ' > 4096 bytes)!');
      }
      return str;
    }
    return function (name, value, options) {
      rawDocument.cookie = buildCookieString(name, value, options);
    };
  }
  $$CookieWriter.$inject = ['$document', '$log', '$browser'];
  angular.module('ngCookies').provider('$$cookieWriter', /** @this */function $$CookieWriterProvider() {
    this.$get = $$CookieWriter;
  });
})(window, window.angular);

/**
 * @license AngularJS v1.8.2
 * (c) 2010-2020 Google LLC. http://angularjs.org
 * License: MIT
 */
(function (window, angular) {
  'use strict';

  /**
   * @ngdoc module
   * @name ngTouch
   * @description
   *
   * The `ngTouch` module provides helpers for touch-enabled devices.
   * The implementation is based on jQuery Mobile touch event handling
   * ([jquerymobile.com](http://jquerymobile.com/)). *
   *
   * See {@link ngTouch.$swipe `$swipe`} for usage.
   *
   * @deprecated
   * sinceVersion="1.7.0"
   * The ngTouch module with the {@link ngTouch.$swipe `$swipe`} service and
   * the {@link ngTouch.ngSwipeLeft} and {@link ngTouch.ngSwipeRight} directives are
   * deprecated. Instead, stand-alone libraries for touch handling and gesture interaction
   * should be used, for example [HammerJS](https://hammerjs.github.io/) (which is also used by
   * Angular).
   */

  // define ngTouch module
  /* global ngTouch */
  var ngTouch = angular.module('ngTouch', []);
  ngTouch.info({
    angularVersion: '1.8.2'
  });
  function nodeName_(element) {
    return angular.$$lowercase(element.nodeName || element[0] && element[0].nodeName);
  }

  /* global ngTouch: false */

  /**
   * @ngdoc service
   * @name $swipe
   *
   * @deprecated
   * sinceVersion="1.7.0"
   *
   * See the {@link ngTouch module} documentation for more information.
   *
   * @description
   * The `$swipe` service is a service that abstracts the messier details of hold-and-drag swipe
   * behavior, to make implementing swipe-related directives more convenient.
   *
   * Requires the {@link ngTouch `ngTouch`} module to be installed.
   *
   * `$swipe` is used by the `ngSwipeLeft` and `ngSwipeRight` directives in `ngTouch`.
   *
   * # Usage
   * The `$swipe` service is an object with a single method: `bind`. `bind` takes an element
   * which is to be watched for swipes, and an object with four handler functions. See the
   * documentation for `bind` below.
   */

  ngTouch.factory('$swipe', [function () {
    // The total distance in any direction before we make the call on swipe vs. scroll.
    var MOVE_BUFFER_RADIUS = 10;
    var POINTER_EVENTS = {
      'mouse': {
        start: 'mousedown',
        move: 'mousemove',
        end: 'mouseup'
      },
      'touch': {
        start: 'touchstart',
        move: 'touchmove',
        end: 'touchend',
        cancel: 'touchcancel'
      },
      'pointer': {
        start: 'pointerdown',
        move: 'pointermove',
        end: 'pointerup',
        cancel: 'pointercancel'
      }
    };
    function getCoordinates(event) {
      var originalEvent = event.originalEvent || event;
      var touches = originalEvent.touches && originalEvent.touches.length ? originalEvent.touches : [originalEvent];
      var e = originalEvent.changedTouches && originalEvent.changedTouches[0] || touches[0];
      return {
        x: e.clientX,
        y: e.clientY
      };
    }
    function getEvents(pointerTypes, eventType) {
      var res = [];
      angular.forEach(pointerTypes, function (pointerType) {
        var eventName = POINTER_EVENTS[pointerType][eventType];
        if (eventName) {
          res.push(eventName);
        }
      });
      return res.join(' ');
    }
    return {
      /**
       * @ngdoc method
       * @name $swipe#bind
       *
       * @description
       * The main method of `$swipe`. It takes an element to be watched for swipe motions, and an
       * object containing event handlers.
       * The pointer types that should be used can be specified via the optional
       * third argument, which is an array of strings `'mouse'`, `'touch'` and `'pointer'`. By default,
       * `$swipe` will listen for `mouse`, `touch` and `pointer` events.
       *
       * The four events are `start`, `move`, `end`, and `cancel`. `start`, `move`, and `end`
       * receive as a parameter a coordinates object of the form `{ x: 150, y: 310 }` and the raw
       * `event`. `cancel` receives the raw `event` as its single parameter.
       *
       * `start` is called on either `mousedown`, `touchstart` or `pointerdown`. After this event, `$swipe` is
       * watching for `touchmove`, `mousemove` or `pointermove` events. These events are ignored until the total
       * distance moved in either dimension exceeds a small threshold.
       *
       * Once this threshold is exceeded, either the horizontal or vertical delta is greater.
       * - If the horizontal distance is greater, this is a swipe and `move` and `end` events follow.
       * - If the vertical distance is greater, this is a scroll, and we let the browser take over.
       *   A `cancel` event is sent.
       *
       * `move` is called on `mousemove`, `touchmove` and `pointermove` after the above logic has determined that
       * a swipe is in progress.
       *
       * `end` is called when a swipe is successfully completed with a `touchend`, `mouseup` or `pointerup`.
       *
       * `cancel` is called either on a `touchcancel` or `pointercancel`  from the browser, or when we begin scrolling
       * as described above.
       *
       */
      bind: function bind(element, eventHandlers, pointerTypes) {
        // Absolute total movement, used to control swipe vs. scroll.
        var totalX, totalY;
        // Coordinates of the start position.
        var startCoords;
        // Last event's position.
        var lastPos;
        // Whether a swipe is active.
        var active = false;
        pointerTypes = pointerTypes || ['mouse', 'touch', 'pointer'];
        element.on(getEvents(pointerTypes, 'start'), function (event) {
          startCoords = getCoordinates(event);
          active = true;
          totalX = 0;
          totalY = 0;
          lastPos = startCoords;
          if (eventHandlers['start']) {
            eventHandlers['start'](startCoords, event);
          }
        });
        var events = getEvents(pointerTypes, 'cancel');
        if (events) {
          element.on(events, function (event) {
            active = false;
            if (eventHandlers['cancel']) {
              eventHandlers['cancel'](event);
            }
          });
        }
        element.on(getEvents(pointerTypes, 'move'), function (event) {
          if (!active) return;

          // Android will send a touchcancel if it thinks we're starting to scroll.
          // So when the total distance (+ or - or both) exceeds 10px in either direction,
          // we either:
          // - On totalX > totalY, we send preventDefault() and treat this as a swipe.
          // - On totalY > totalX, we let the browser handle it as a scroll.

          if (!startCoords) return;
          var coords = getCoordinates(event);
          totalX += Math.abs(coords.x - lastPos.x);
          totalY += Math.abs(coords.y - lastPos.y);
          lastPos = coords;
          if (totalX < MOVE_BUFFER_RADIUS && totalY < MOVE_BUFFER_RADIUS) {
            return;
          }

          // One of totalX or totalY has exceeded the buffer, so decide on swipe vs. scroll.
          if (totalY > totalX) {
            // Allow native scrolling to take over.
            active = false;
            if (eventHandlers['cancel']) {
              eventHandlers['cancel'](event);
            }
            return;
          } else {
            // Prevent the browser from scrolling.
            event.preventDefault();
            if (eventHandlers['move']) {
              eventHandlers['move'](coords, event);
            }
          }
        });
        element.on(getEvents(pointerTypes, 'end'), function (event) {
          if (!active) return;
          active = false;
          if (eventHandlers['end']) {
            eventHandlers['end'](getCoordinates(event), event);
          }
        });
      }
    };
  }]);

  /* global ngTouch: false */

  /**
   * @ngdoc directive
   * @name ngSwipeLeft
   *
   * @deprecated
   * sinceVersion="1.7.0"
   *
   * See the {@link ngTouch module} documentation for more information.
   *
   * @description
   * Specify custom behavior when an element is swiped to the left on a touchscreen device.
   * A leftward swipe is a quick, right-to-left slide of the finger.
   * Though ngSwipeLeft is designed for touch-based devices, it will work with a mouse click and drag
   * too.
   *
   * To disable the mouse click and drag functionality, add `ng-swipe-disable-mouse` to
   * the `ng-swipe-left` or `ng-swipe-right` DOM Element.
   *
   * Requires the {@link ngTouch `ngTouch`} module to be installed.
   *
   * @element ANY
   * @param {expression} ngSwipeLeft {@link guide/expression Expression} to evaluate
   * upon left swipe. (Event object is available as `$event`)
   *
   * @example
      <example module="ngSwipeLeftExample" deps="angular-touch.js" name="ng-swipe-left">
        <file name="index.html">
          <div ng-show="!showActions" ng-swipe-left="showActions = true">
            Some list content, like an email in the inbox
          </div>
          <div ng-show="showActions" ng-swipe-right="showActions = false">
            <button ng-click="reply()">Reply</button>
            <button ng-click="delete()">Delete</button>
          </div>
        </file>
        <file name="script.js">
          angular.module('ngSwipeLeftExample', ['ngTouch']);
        </file>
      </example>
   */

  /**
   * @ngdoc directive
   * @name ngSwipeRight
   *
   * @deprecated
   * sinceVersion="1.7.0"
   *
   * See the {@link ngTouch module} documentation for more information.
   *
   * @description
   * Specify custom behavior when an element is swiped to the right on a touchscreen device.
   * A rightward swipe is a quick, left-to-right slide of the finger.
   * Though ngSwipeRight is designed for touch-based devices, it will work with a mouse click and drag
   * too.
   *
   * Requires the {@link ngTouch `ngTouch`} module to be installed.
   *
   * @element ANY
   * @param {expression} ngSwipeRight {@link guide/expression Expression} to evaluate
   * upon right swipe. (Event object is available as `$event`)
   *
   * @example
      <example module="ngSwipeRightExample" deps="angular-touch.js" name="ng-swipe-right">
        <file name="index.html">
          <div ng-show="!showActions" ng-swipe-left="showActions = true">
            Some list content, like an email in the inbox
          </div>
          <div ng-show="showActions" ng-swipe-right="showActions = false">
            <button ng-click="reply()">Reply</button>
            <button ng-click="delete()">Delete</button>
          </div>
        </file>
        <file name="script.js">
          angular.module('ngSwipeRightExample', ['ngTouch']);
        </file>
      </example>
   */

  function makeSwipeDirective(directiveName, direction, eventName) {
    ngTouch.directive(directiveName, ['$parse', '$swipe', function ($parse, $swipe) {
      // The maximum vertical delta for a swipe should be less than 75px.
      var MAX_VERTICAL_DISTANCE = 75;
      // Vertical distance should not be more than a fraction of the horizontal distance.
      var MAX_VERTICAL_RATIO = 0.3;
      // At least a 30px lateral motion is necessary for a swipe.
      var MIN_HORIZONTAL_DISTANCE = 30;
      return function (scope, element, attr) {
        var swipeHandler = $parse(attr[directiveName]);
        var startCoords, valid;
        function validSwipe(coords) {
          // Check that it's within the coordinates.
          // Absolute vertical distance must be within tolerances.
          // Horizontal distance, we take the current X - the starting X.
          // This is negative for leftward swipes and positive for rightward swipes.
          // After multiplying by the direction (-1 for left, +1 for right), legal swipes
          // (ie. same direction as the directive wants) will have a positive delta and
          // illegal ones a negative delta.
          // Therefore this delta must be positive, and larger than the minimum.
          if (!startCoords) return false;
          var deltaY = Math.abs(coords.y - startCoords.y);
          var deltaX = (coords.x - startCoords.x) * direction;
          return valid &&
          // Short circuit for already-invalidated swipes.
          deltaY < MAX_VERTICAL_DISTANCE && deltaX > 0 && deltaX > MIN_HORIZONTAL_DISTANCE && deltaY / deltaX < MAX_VERTICAL_RATIO;
        }
        var pointerTypes = ['touch'];
        if (!angular.isDefined(attr['ngSwipeDisableMouse'])) {
          pointerTypes.push('mouse');
        }
        $swipe.bind(element, {
          'start': function start(coords, event) {
            startCoords = coords;
            valid = true;
          },
          'cancel': function cancel(event) {
            valid = false;
          },
          'end': function end(coords, event) {
            if (validSwipe(coords)) {
              scope.$apply(function () {
                element.triggerHandler(eventName);
                swipeHandler(scope, {
                  $event: event
                });
              });
            }
          }
        }, pointerTypes);
      };
    }]);
  }

  // Left is negative X-coordinate, right is positive.
  makeSwipeDirective('ngSwipeLeft', -1, 'swipeleft');
  makeSwipeDirective('ngSwipeRight', 1, 'swiperight');
})(window, window.angular);

/**
 * State-based routing for AngularJS 1.x
 * NOTICE: This monolithic bundle also bundles the @uirouter/core code.
 *         This causes it to be incompatible with plugins that depend on @uirouter/core.
 *         We recommend switching to the ui-router-core.js and ui-router-angularjs.js bundles instead.
 *         For more information, see https://ui-router.github.io/blog/uirouter-for-angularjs-umd-bundles
 * @version v1.0.30
 * @link https://ui-router.github.io
 * @license MIT License, http://www.opensource.org/licenses/MIT
 */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? factory(exports, require('angular')) : typeof define === 'function' && define.amd ? define(['exports', 'angular'], factory) : (global = global || self, factory(global['@uirouter/angularjs'] = {}, global.angular));
})(this, function (exports, ng_from_import) {
  'use strict';

  /** @publicapi @module ng1 */ /** */
  /** @hidden */
  var ng_from_global = angular;
  /** @hidden */
  var ng = ng_from_import && ng_from_import.module ? ng_from_import : ng_from_global;

  /**
   * Higher order functions
   *
   * These utility functions are exported, but are subject to change without notice.
   *
   * @packageDocumentation
   */
  var __spreadArrays = undefined && undefined.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
    return r;
  };
  /**
   * Returns a new function for [Partial Application](https://en.wikipedia.org/wiki/Partial_application) of the original function.
   *
   * Given a function with N parameters, returns a new function that supports partial application.
   * The new function accepts anywhere from 1 to N parameters.  When that function is called with M parameters,
   * where M is less than N, it returns a new function that accepts the remaining parameters.  It continues to
   * accept more parameters until all N parameters have been supplied.
   *
   *
   * This contrived example uses a partially applied function as an predicate, which returns true
   * if an object is found in both arrays.
   * @example
   * ```
   * // returns true if an object is in both of the two arrays
   * function inBoth(array1, array2, object) {
   *   return array1.indexOf(object) !== -1 &&
   *          array2.indexOf(object) !== 1;
   * }
   * let obj1, obj2, obj3, obj4, obj5, obj6, obj7
   * let foos = [obj1, obj3]
   * let bars = [obj3, obj4, obj5]
   *
   * // A curried "copy" of inBoth
   * let curriedInBoth = curry(inBoth);
   * // Partially apply both the array1 and array2
   * let inFoosAndBars = curriedInBoth(foos, bars);
   *
   * // Supply the final argument; since all arguments are
   * // supplied, the original inBoth function is then called.
   * let obj1InBoth = inFoosAndBars(obj1); // false
   *
   * // Use the inFoosAndBars as a predicate.
   * // Filter, on each iteration, supplies the final argument
   * let allObjs = [ obj1, obj2, obj3, obj4, obj5, obj6, obj7 ];
   * let foundInBoth = allObjs.filter(inFoosAndBars); // [ obj3 ]
   *
   * ```
   *
   * @param fn
   * @returns {*|function(): (*|any)}
   */
  function curry(fn) {
    return function curried() {
      if (arguments.length >= fn.length) {
        return fn.apply(this, arguments);
      }
      var args = Array.prototype.slice.call(arguments);
      return curried.bind.apply(curried, __spreadArrays([this], args));
    };
  }
  /**
   * Given a varargs list of functions, returns a function that composes the argument functions, right-to-left
   * given: f(x), g(x), h(x)
   * let composed = compose(f,g,h)
   * then, composed is: f(g(h(x)))
   */
  function compose() {
    var args = arguments;
    var start = args.length - 1;
    return function () {
      var i = start,
        result = args[start].apply(this, arguments);
      while (i--) result = args[i].call(this, result);
      return result;
    };
  }
  /**
   * Given a varargs list of functions, returns a function that is composes the argument functions, left-to-right
   * given: f(x), g(x), h(x)
   * let piped = pipe(f,g,h);
   * then, piped is: h(g(f(x)))
   */
  function pipe() {
    var funcs = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      funcs[_i] = arguments[_i];
    }
    return compose.apply(null, [].slice.call(arguments).reverse());
  }
  /**
   * Given a property name, returns a function that returns that property from an object
   * let obj = { foo: 1, name: "blarg" };
   * let getName = prop("name");
   * getName(obj) === "blarg"
   */
  var prop = function prop(name) {
    return function (obj) {
      return obj && obj[name];
    };
  };
  /**
   * Given a property name and a value, returns a function that returns a boolean based on whether
   * the passed object has a property that matches the value
   * let obj = { foo: 1, name: "blarg" };
   * let getName = propEq("name", "blarg");
   * getName(obj) === true
   */
  var propEq = curry(function (name, _val, obj) {
    return obj && obj[name] === _val;
  });
  /**
   * Given a dotted property name, returns a function that returns a nested property from an object, or undefined
   * let obj = { id: 1, nestedObj: { foo: 1, name: "blarg" }, };
   * let getName = prop("nestedObj.name");
   * getName(obj) === "blarg"
   * let propNotFound = prop("this.property.doesnt.exist");
   * propNotFound(obj) === undefined
   */
  var parse = function parse(name) {
    return pipe.apply(null, name.split('.').map(prop));
  };
  /**
   * Given a function that returns a truthy or falsey value, returns a
   * function that returns the opposite (falsey or truthy) value given the same inputs
   */
  var not = function not(fn) {
    return function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return !fn.apply(null, args);
    };
  };
  /**
   * Given two functions that return truthy or falsey values, returns a function that returns truthy
   * if both functions return truthy for the given arguments
   */
  function and(fn1, fn2) {
    return function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return fn1.apply(null, args) && fn2.apply(null, args);
    };
  }
  /**
   * Given two functions that return truthy or falsey values, returns a function that returns truthy
   * if at least one of the functions returns truthy for the given arguments
   */
  function or(fn1, fn2) {
    return function () {
      var args = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        args[_i] = arguments[_i];
      }
      return fn1.apply(null, args) || fn2.apply(null, args);
    };
  }
  /**
   * Check if all the elements of an array match a predicate function
   *
   * @param fn1 a predicate function `fn1`
   * @returns a function which takes an array and returns true if `fn1` is true for all elements of the array
   */
  var all = function all(fn1) {
    return function (arr) {
      return arr.reduce(function (b, x) {
        return b && !!fn1(x);
      }, true);
    };
  };
  // tslint:disable-next-line:variable-name
  var any = function any(fn1) {
    return function (arr) {
      return arr.reduce(function (b, x) {
        return b || !!fn1(x);
      }, false);
    };
  };
  /** Given a class, returns a Predicate function that returns true if the object is of that class */
  var is = function is(ctor) {
    return function (obj) {
      return obj != null && obj.constructor === ctor || obj instanceof ctor;
    };
  };
  /** Given a value, returns a Predicate function that returns true if another value is === equal to the original value */
  var eq = function eq(value) {
    return function (other) {
      return value === other;
    };
  };
  /** Given a value, returns a function which returns the value */
  var val = function val(v) {
    return function () {
      return v;
    };
  };
  function invoke(fnName, args) {
    return function (obj) {
      return obj[fnName].apply(obj, args);
    };
  }
  /**
   * Sorta like Pattern Matching (a functional programming conditional construct)
   *
   * See http://c2.com/cgi/wiki?PatternMatching
   *
   * This is a conditional construct which allows a series of predicates and output functions
   * to be checked and then applied.  Each predicate receives the input.  If the predicate
   * returns truthy, then its matching output function (mapping function) is provided with
   * the input and, then the result is returned.
   *
   * Each combination (2-tuple) of predicate + output function should be placed in an array
   * of size 2: [ predicate, mapFn ]
   *
   * These 2-tuples should be put in an outer array.
   *
   * @example
   * ```
   *
   * // Here's a 2-tuple where the first element is the isString predicate
   * // and the second element is a function that returns a description of the input
   * let firstTuple = [ angular.isString, (input) => `Heres your string ${input}` ];
   *
   * // Second tuple: predicate "isNumber", mapfn returns a description
   * let secondTuple = [ angular.isNumber, (input) => `(${input}) That's a number!` ];
   *
   * let third = [ (input) => input === null,  (input) => `Oh, null...` ];
   *
   * let fourth = [ (input) => input === undefined,  (input) => `notdefined` ];
   *
   * let descriptionOf = pattern([ firstTuple, secondTuple, third, fourth ]);
   *
   * console.log(descriptionOf(undefined)); // 'notdefined'
   * console.log(descriptionOf(55)); // '(55) That's a number!'
   * console.log(descriptionOf("foo")); // 'Here's your string foo'
   * ```
   *
   * @param struct A 2D array.  Each element of the array should be an array, a 2-tuple,
   * with a Predicate and a mapping/output function
   * @returns {function(any): *}
   */
  function pattern(struct) {
    return function (x) {
      for (var i = 0; i < struct.length; i++) {
        if (struct[i][0](x)) return struct[i][1](x);
      }
    };
  }

  /**
   * Predicates
   *
   * These predicates return true/false based on the input.
   * Although these functions are exported, they are subject to change without notice.
   *
   * @packageDocumentation
   */
  var toStr = Object.prototype.toString;
  var tis = function tis(t) {
    return function (x) {
      return _typeof(x) === t;
    };
  };
  var isUndefined = tis('undefined');
  var isDefined = not(isUndefined);
  var isNull = function isNull(o) {
    return o === null;
  };
  var isNullOrUndefined = or(isNull, isUndefined);
  var isFunction = tis('function');
  var isNumber = tis('number');
  var isString = tis('string');
  var isObject = function isObject(x) {
    return x !== null && _typeof(x) === 'object';
  };
  var isArray = Array.isArray;
  var isDate = function isDate(x) {
    return toStr.call(x) === '[object Date]';
  };
  var isRegExp = function isRegExp(x) {
    return toStr.call(x) === '[object RegExp]';
  };
  /**
   * Predicate which checks if a value is injectable
   *
   * A value is "injectable" if it is a function, or if it is an ng1 array-notation-style array
   * where all the elements in the array are Strings, except the last one, which is a Function
   */
  function isInjectable(val) {
    if (isArray(val) && val.length) {
      var head = val.slice(0, -1),
        tail = val.slice(-1);
      return !(head.filter(not(isString)).length || tail.filter(not(isFunction)).length);
    }
    return isFunction(val);
  }
  /**
   * Predicate which checks if a value looks like a Promise
   *
   * It is probably a Promise if it's an object, and it has a `then` property which is a Function
   */
  var isPromise = and(isObject, pipe(prop('then'), isFunction));
  var noImpl = function noImpl(fnname) {
    return function () {
      throw new Error("No implementation for " + fnname + ". The framework specific code did not implement this method.");
    };
  };
  var makeStub = function makeStub(service, methods) {
    return methods.reduce(function (acc, key) {
      return acc[key] = noImpl(service + "." + key + "()"), acc;
    }, {});
  };
  var services = {
    $q: undefined,
    $injector: undefined
  };
  var __spreadArrays$1 = undefined && undefined.__spreadArrays || function () {
    for (var s = 0, i = 0, il = arguments.length; i < il; i++) s += arguments[i].length;
    for (var r = Array(s), k = 0, i = 0; i < il; i++) for (var a = arguments[i], j = 0, jl = a.length; j < jl; j++, k++) r[k] = a[j];
    return r;
  };
  var root = (typeof self === "undefined" ? "undefined" : _typeof(self)) === 'object' && self.self === self && self || (typeof global === "undefined" ? "undefined" : _typeof(global)) === 'object' && global.global === global && global || undefined;
  var angular$1 = root.angular || {};
  var fromJson = angular$1.fromJson || JSON.parse.bind(JSON);
  var toJson = angular$1.toJson || JSON.stringify.bind(JSON);
  var forEach = angular$1.forEach || _forEach;
  var extend = Object.assign || _extend;
  var equals = angular$1.equals || _equals;
  function identity(x) {
    return x;
  }
  function noop() {}
  /**
   * Builds proxy functions on the `to` object which pass through to the `from` object.
   *
   * For each key in `fnNames`, creates a proxy function on the `to` object.
   * The proxy function calls the real function on the `from` object.
   *
   *
   * #### Example:
   * This example creates an new class instance whose functions are prebound to the new'd object.
   * ```js
   * class Foo {
   *   constructor(data) {
   *     // Binds all functions from Foo.prototype to 'this',
   *     // then copies them to 'this'
   *     bindFunctions(Foo.prototype, this, this);
   *     this.data = data;
   *   }
   *
   *   log() {
   *     console.log(this.data);
   *   }
   * }
   *
   * let myFoo = new Foo([1,2,3]);
   * var logit = myFoo.log;
   * logit(); // logs [1, 2, 3] from the myFoo 'this' instance
   * ```
   *
   * #### Example:
   * This example creates a bound version of a service function, and copies it to another object
   * ```
   *
   * var SomeService = {
   *   this.data = [3, 4, 5];
   *   this.log = function() {
   *     console.log(this.data);
   *   }
   * }
   *
   * // Constructor fn
   * function OtherThing() {
   *   // Binds all functions from SomeService to SomeService,
   *   // then copies them to 'this'
   *   bindFunctions(SomeService, this, SomeService);
   * }
   *
   * let myOtherThing = new OtherThing();
   * myOtherThing.log(); // logs [3, 4, 5] from SomeService's 'this'
   * ```
   *
   * @param source A function that returns the source object which contains the original functions to be bound
   * @param target A function that returns the target object which will receive the bound functions
   * @param bind A function that returns the object which the functions will be bound to
   * @param fnNames The function names which will be bound (Defaults to all the functions found on the 'from' object)
   * @param latebind If true, the binding of the function is delayed until the first time it's invoked
   */
  function createProxyFunctions(source, target, bind, fnNames, latebind) {
    if (latebind === void 0) {
      latebind = false;
    }
    var bindFunction = function bindFunction(fnName) {
      return source()[fnName].bind(bind());
    };
    var makeLateRebindFn = function makeLateRebindFn(fnName) {
      return function lateRebindFunction() {
        target[fnName] = bindFunction(fnName);
        return target[fnName].apply(null, arguments);
      };
    };
    fnNames = fnNames || Object.keys(source());
    return fnNames.reduce(function (acc, name) {
      acc[name] = latebind ? makeLateRebindFn(name) : bindFunction(name);
      return acc;
    }, target);
  }
  /**
   * prototypal inheritance helper.
   * Creates a new object which has `parent` object as its prototype, and then copies the properties from `extra` onto it
   */
  var inherit = function inherit(parent, extra) {
    return extend(Object.create(parent), extra);
  };
  /** Given an array, returns true if the object is found in the array, (using indexOf) */
  var inArray = curry(_inArray);
  function _inArray(array, obj) {
    return array.indexOf(obj) !== -1;
  }
  /**
   * Given an array, and an item, if the item is found in the array, it removes it (in-place).
   * The same array is returned
   */
  var removeFrom = curry(_removeFrom);
  function _removeFrom(array, obj) {
    var idx = array.indexOf(obj);
    if (idx >= 0) array.splice(idx, 1);
    return array;
  }
  /** pushes a values to an array and returns the value */
  var pushTo = curry(_pushTo);
  function _pushTo(arr, val) {
    return arr.push(val), val;
  }
  /** Given an array of (deregistration) functions, calls all functions and removes each one from the source array */
  var deregAll = function deregAll(functions) {
    return functions.slice().forEach(function (fn) {
      typeof fn === 'function' && fn();
      removeFrom(functions, fn);
    });
  };
  /**
   * Applies a set of defaults to an options object.  The options object is filtered
   * to only those properties of the objects in the defaultsList.
   * Earlier objects in the defaultsList take precedence when applying defaults.
   */
  function defaults(opts) {
    var defaultsList = [];
    for (var _i = 1; _i < arguments.length; _i++) {
      defaultsList[_i - 1] = arguments[_i];
    }
    var defaultVals = extend.apply(void 0, __spreadArrays$1([{}], defaultsList.reverse()));
    return extend(defaultVals, pick(opts || {}, Object.keys(defaultVals)));
  }
  /** Reduce function that merges each element of the list into a single object, using extend */
  var mergeR = function mergeR(memo, item) {
    return extend(memo, item);
  };
  /**
   * Finds the common ancestor path between two states.
   *
   * @param {Object} first The first state.
   * @param {Object} second The second state.
   * @return {Array} Returns an array of state names in descending order, not including the root.
   */
  function ancestors(first, second) {
    var path = [];
    // tslint:disable-next-line:forin
    for (var n in first.path) {
      if (first.path[n] !== second.path[n]) break;
      path.push(first.path[n]);
    }
    return path;
  }
  /**
   * Return a copy of the object only containing the whitelisted properties.
   *
   * #### Example:
   * ```
   * var foo = { a: 1, b: 2, c: 3 };
   * var ab = pick(foo, ['a', 'b']); // { a: 1, b: 2 }
   * ```
   * @param obj the source object
   * @param propNames an Array of strings, which are the whitelisted property names
   */
  function pick(obj, propNames) {
    var objCopy = {};
    for (var _prop in obj) {
      if (propNames.indexOf(_prop) !== -1) {
        objCopy[_prop] = obj[_prop];
      }
    }
    return objCopy;
  }
  /**
   * Return a copy of the object omitting the blacklisted properties.
   *
   * @example
   * ```
   *
   * var foo = { a: 1, b: 2, c: 3 };
   * var ab = omit(foo, ['a', 'b']); // { c: 3 }
   * ```
   * @param obj the source object
   * @param propNames an Array of strings, which are the blacklisted property names
   */
  function omit(obj, propNames) {
    return Object.keys(obj).filter(not(inArray(propNames))).reduce(function (acc, key) {
      return acc[key] = obj[key], acc;
    }, {});
  }
  /**
   * Maps an array, or object to a property (by name)
   */
  function pluck(collection, propName) {
    return map(collection, prop(propName));
  }
  /** Filters an Array or an Object's properties based on a predicate */
  function filter(collection, callback) {
    var arr = isArray(collection),
      result = arr ? [] : {};
    var accept = arr ? function (x) {
      return result.push(x);
    } : function (x, key) {
      return result[key] = x;
    };
    forEach(collection, function (item, i) {
      if (callback(item, i)) accept(item, i);
    });
    return result;
  }
  /** Finds an object from an array, or a property of an object, that matches a predicate */
  function find(collection, callback) {
    var result;
    forEach(collection, function (item, i) {
      if (result) return;
      if (callback(item, i)) result = item;
    });
    return result;
  }
  /** Given an object, returns a new object, where each property is transformed by the callback function */
  var mapObj = map;
  /** Maps an array or object properties using a callback function */
  function map(collection, callback, target) {
    target = target || (isArray(collection) ? [] : {});
    forEach(collection, function (item, i) {
      return target[i] = callback(item, i);
    });
    return target;
  }
  /**
   * Given an object, return its enumerable property values
   *
   * @example
   * ```
   *
   * let foo = { a: 1, b: 2, c: 3 }
   * let vals = values(foo); // [ 1, 2, 3 ]
   * ```
   */
  var values = function values(obj) {
    return Object.keys(obj).map(function (key) {
      return obj[key];
    });
  };
  /**
   * Reduce function that returns true if all of the values are truthy.
   *
   * @example
   * ```
   *
   * let vals = [ 1, true, {}, "hello world"];
   * vals.reduce(allTrueR, true); // true
   *
   * vals.push(0);
   * vals.reduce(allTrueR, true); // false
   * ```
   */
  var allTrueR = function allTrueR(memo, elem) {
    return memo && elem;
  };
  /**
   * Reduce function that returns true if any of the values are truthy.
   *
   *  * @example
   * ```
   *
   * let vals = [ 0, null, undefined ];
   * vals.reduce(anyTrueR, true); // false
   *
   * vals.push("hello world");
   * vals.reduce(anyTrueR, true); // true
   * ```
   */
  var anyTrueR = function anyTrueR(memo, elem) {
    return memo || elem;
  };
  /**
   * Reduce function which un-nests a single level of arrays
   * @example
   * ```
   *
   * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
   * input.reduce(unnestR, []) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
   * ```
   */
  var unnestR = function unnestR(memo, elem) {
    return memo.concat(elem);
  };
  /**
   * Reduce function which recursively un-nests all arrays
   *
   * @example
   * ```
   *
   * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
   * input.reduce(unnestR, []) // [ "a", "b", "c", "d", "double, "nested" ]
   * ```
   */
  var _flattenR = function flattenR(memo, elem) {
    return isArray(elem) ? memo.concat(elem.reduce(_flattenR, [])) : pushR(memo, elem);
  };
  /**
   * Reduce function that pushes an object to an array, then returns the array.
   * Mostly just for [[flattenR]] and [[uniqR]]
   */
  function pushR(arr, obj) {
    arr.push(obj);
    return arr;
  }
  /** Reduce function that filters out duplicates */
  var uniqR = function uniqR(acc, token) {
    return inArray(acc, token) ? acc : pushR(acc, token);
  };
  /**
   * Return a new array with a single level of arrays unnested.
   *
   * @example
   * ```
   *
   * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
   * unnest(input) // [ "a", "b", "c", "d", [ "double, "nested" ] ]
   * ```
   */
  var unnest = function unnest(arr) {
    return arr.reduce(unnestR, []);
  };
  /**
   * Return a completely flattened version of an array.
   *
   * @example
   * ```
   *
   * let input = [ [ "a", "b" ], [ "c", "d" ], [ [ "double", "nested" ] ] ];
   * flatten(input) // [ "a", "b", "c", "d", "double, "nested" ]
   * ```
   */
  var flatten = function flatten(arr) {
    return arr.reduce(_flattenR, []);
  };
  /**
   * Given a .filter Predicate, builds a .filter Predicate which throws an error if any elements do not pass.
   * @example
   * ```
   *
   * let isNumber = (obj) => typeof(obj) === 'number';
   * let allNumbers = [ 1, 2, 3, 4, 5 ];
   * allNumbers.filter(assertPredicate(isNumber)); //OK
   *
   * let oneString = [ 1, 2, 3, 4, "5" ];
   * oneString.filter(assertPredicate(isNumber, "Not all numbers")); // throws Error(""Not all numbers"");
   * ```
   */
  var assertPredicate = assertFn;
  /**
   * Given a .map function, builds a .map function which throws an error if any mapped elements do not pass a truthyness test.
   * @example
   * ```
   *
   * var data = { foo: 1, bar: 2 };
   *
   * let keys = [ 'foo', 'bar' ]
   * let values = keys.map(assertMap(key => data[key], "Key not found"));
   * // values is [1, 2]
   *
   * let keys = [ 'foo', 'bar', 'baz' ]
   * let values = keys.map(assertMap(key => data[key], "Key not found"));
   * // throws Error("Key not found")
   * ```
   */
  var assertMap = assertFn;
  function assertFn(predicateOrMap, errMsg) {
    if (errMsg === void 0) {
      errMsg = 'assert failure';
    }
    return function (obj) {
      var result = predicateOrMap(obj);
      if (!result) {
        throw new Error(isFunction(errMsg) ? errMsg(obj) : errMsg);
      }
      return result;
    };
  }
  /**
   * Like _.pairs: Given an object, returns an array of key/value pairs
   *
   * @example
   * ```
   *
   * pairs({ foo: "FOO", bar: "BAR }) // [ [ "foo", "FOO" ], [ "bar": "BAR" ] ]
   * ```
   */
  var pairs = function pairs(obj) {
    return Object.keys(obj).map(function (key) {
      return [key, obj[key]];
    });
  };
  /**
   * Given two or more parallel arrays, returns an array of tuples where
   * each tuple is composed of [ a[i], b[i], ... z[i] ]
   *
   * @example
   * ```
   *
   * let foo = [ 0, 2, 4, 6 ];
   * let bar = [ 1, 3, 5, 7 ];
   * let baz = [ 10, 30, 50, 70 ];
   * arrayTuples(foo, bar);       // [ [0, 1], [2, 3], [4, 5], [6, 7] ]
   * arrayTuples(foo, bar, baz);  // [ [0, 1, 10], [2, 3, 30], [4, 5, 50], [6, 7, 70] ]
   * ```
   */
  function arrayTuples() {
    var args = [];
    for (var _i = 0; _i < arguments.length; _i++) {
      args[_i] = arguments[_i];
    }
    if (args.length === 0) return [];
    var maxArrayLen = args.reduce(function (min, arr) {
      return Math.min(arr.length, min);
    }, 9007199254740991); // aka 2^53 − 1 aka Number.MAX_SAFE_INTEGER
    var result = [];
    var _loop_1 = function _loop_1(i) {
      // This is a hot function
      // Unroll when there are 1-4 arguments
      switch (args.length) {
        case 1:
          result.push([args[0][i]]);
          break;
        case 2:
          result.push([args[0][i], args[1][i]]);
          break;
        case 3:
          result.push([args[0][i], args[1][i], args[2][i]]);
          break;
        case 4:
          result.push([args[0][i], args[1][i], args[2][i], args[3][i]]);
          break;
        default:
          result.push(args.map(function (array) {
            return array[i];
          }));
          break;
      }
    };
    for (var i = 0; i < maxArrayLen; i++) {
      _loop_1(i);
    }
    return result;
  }
  /**
   * Reduce function which builds an object from an array of [key, value] pairs.
   *
   * Each iteration sets the key/val pair on the memo object, then returns the memo for the next iteration.
   *
   * Each keyValueTuple should be an array with values [ key: string, value: any ]
   *
   * @example
   * ```
   *
   * var pairs = [ ["fookey", "fooval"], ["barkey", "barval"] ]
   *
   * var pairsToObj = pairs.reduce((memo, pair) => applyPairs(memo, pair), {})
   * // pairsToObj == { fookey: "fooval", barkey: "barval" }
   *
   * // Or, more simply:
   * var pairsToObj = pairs.reduce(applyPairs, {})
   * // pairsToObj == { fookey: "fooval", barkey: "barval" }
   * ```
   */
  function applyPairs(memo, keyValTuple) {
    var key, value;
    if (isArray(keyValTuple)) key = keyValTuple[0], value = keyValTuple[1];
    if (!isString(key)) throw new Error('invalid parameters to applyPairs');
    memo[key] = value;
    return memo;
  }
  /** Get the last element of an array */
  function tail(arr) {
    return arr.length && arr[arr.length - 1] || undefined;
  }
  /**
   * shallow copy from src to dest
   */
  function copy(src, dest) {
    if (dest) Object.keys(dest).forEach(function (key) {
      return delete dest[key];
    });
    if (!dest) dest = {};
    return extend(dest, src);
  }
  /** Naive forEach implementation works with Objects or Arrays */
  function _forEach(obj, cb, _this) {
    if (isArray(obj)) return obj.forEach(cb, _this);
    Object.keys(obj).forEach(function (key) {
      return cb(obj[key], key);
    });
  }
  function _extend(toObj) {
    for (var i = 1; i < arguments.length; i++) {
      var obj = arguments[i];
      if (!obj) continue;
      var keys = Object.keys(obj);
      for (var j = 0; j < keys.length; j++) {
        toObj[keys[j]] = obj[keys[j]];
      }
    }
    return toObj;
  }
  function _equals(o1, o2) {
    if (o1 === o2) return true;
    if (o1 === null || o2 === null) return false;
    if (o1 !== o1 && o2 !== o2) return true; // NaN === NaN
    var t1 = _typeof(o1),
      t2 = _typeof(o2);
    if (t1 !== t2 || t1 !== 'object') return false;
    var tup = [o1, o2];
    if (all(isArray)(tup)) return _arraysEq(o1, o2);
    if (all(isDate)(tup)) return o1.getTime() === o2.getTime();
    if (all(isRegExp)(tup)) return o1.toString() === o2.toString();
    if (all(isFunction)(tup)) return true; // meh
    var predicates = [isFunction, isArray, isDate, isRegExp];
    if (predicates.map(any).reduce(function (b, fn) {
      return b || !!fn(tup);
    }, false)) return false;
    var keys = {};
    // tslint:disable-next-line:forin
    for (var key in o1) {
      if (!_equals(o1[key], o2[key])) return false;
      keys[key] = true;
    }
    for (var key in o2) {
      if (!keys[key]) return false;
    }
    return true;
  }
  function _arraysEq(a1, a2) {
    if (a1.length !== a2.length) return false;
    return arrayTuples(a1, a2).reduce(function (b, t) {
      return b && _equals(t[0], t[1]);
    }, true);
  }
  // issue #2676
  var silenceUncaughtInPromise = function silenceUncaughtInPromise(promise) {
    return promise["catch"](function (e) {
      return 0;
    }) && promise;
  };
  var silentRejection = function silentRejection(error) {
    return silenceUncaughtInPromise(services.$q.reject(error));
  };

  /**
   * Matches state names using glob-like pattern strings.
   *
   * Globs can be used in specific APIs including:
   *
   * - [[StateService.is]]
   * - [[StateService.includes]]
   * - The first argument to Hook Registration functions like [[TransitionService.onStart]]
   *    - [[HookMatchCriteria]] and [[HookMatchCriterion]]
   *
   * A `Glob` string is a pattern which matches state names.
   * Nested state names are split into segments (separated by a dot) when processing.
   * The state named `foo.bar.baz` is split into three segments ['foo', 'bar', 'baz']
   *
   * Globs work according to the following rules:
   *
   * ### Exact match:
   *
   * The glob `'A.B'` matches the state named exactly `'A.B'`.
   *
   * | Glob        |Matches states named|Does not match state named|
   * |:------------|:--------------------|:---------------------|
   * | `'A'`       | `'A'`               | `'B'` , `'A.C'`      |
   * | `'A.B'`     | `'A.B'`             | `'A'` , `'A.B.C'`    |
   * | `'foo'`     | `'foo'`             | `'FOO'` , `'foo.bar'`|
   *
   * ### Single star (`*`)
   *
   * A single star (`*`) is a wildcard that matches exactly one segment.
   *
   * | Glob        |Matches states named  |Does not match state named |
   * |:------------|:---------------------|:--------------------------|
   * | `'*'`       | `'A'` , `'Z'`        | `'A.B'` , `'Z.Y.X'`       |
   * | `'A.*'`     | `'A.B'` , `'A.C'`    | `'A'` , `'A.B.C'`         |
   * | `'A.*.*'`   | `'A.B.C'` , `'A.X.Y'`| `'A'`, `'A.B'` , `'Z.Y.X'`|
   *
   * ### Double star (`**`)
   *
   * A double star (`'**'`) is a wildcard that matches *zero or more segments*
   *
   * | Glob        |Matches states named                           |Does not match state named         |
   * |:------------|:----------------------------------------------|:----------------------------------|
   * | `'**'`      | `'A'` , `'A.B'`, `'Z.Y.X'`                    | (matches all states)              |
   * | `'A.**'`    | `'A'` , `'A.B'` , `'A.C.X'`                   | `'Z.Y.X'`                         |
   * | `'**.X'`    | `'X'` , `'A.X'` , `'Z.Y.X'`                   | `'A'` , `'A.login.Z'`             |
   * | `'A.**.X'`  | `'A.X'` , `'A.B.X'` , `'A.B.C.X'`             | `'A'` , `'A.B.C'`                 |
   *
   * @packageDocumentation
   */
  var Glob = /** @class */function () {
    function Glob(text) {
      this.text = text;
      this.glob = text.split('.');
      var regexpString = this.text.split('.').map(function (seg) {
        if (seg === '**') return '(?:|(?:\\.[^.]*)*)';
        if (seg === '*') return '\\.[^.]*';
        return '\\.' + seg;
      }).join('');
      this.regexp = new RegExp('^' + regexpString + '$');
    }
    /** Returns true if the string has glob-like characters in it */
    Glob.is = function (text) {
      return !!/[!,*]+/.exec(text);
    };
    /** Returns a glob from the string, or null if the string isn't Glob-like */
    Glob.fromString = function (text) {
      return Glob.is(text) ? new Glob(text) : null;
    };
    Glob.prototype.matches = function (name) {
      return this.regexp.test('.' + name);
    };
    return Glob;
  }();
  var Queue = /** @class */function () {
    function Queue(_items, _limit) {
      if (_items === void 0) {
        _items = [];
      }
      if (_limit === void 0) {
        _limit = null;
      }
      this._items = _items;
      this._limit = _limit;
      this._evictListeners = [];
      this.onEvict = pushTo(this._evictListeners);
    }
    Queue.prototype.enqueue = function (item) {
      var items = this._items;
      items.push(item);
      if (this._limit && items.length > this._limit) this.evict();
      return item;
    };
    Queue.prototype.evict = function () {
      var item = this._items.shift();
      this._evictListeners.forEach(function (fn) {
        return fn(item);
      });
      return item;
    };
    Queue.prototype.dequeue = function () {
      if (this.size()) return this._items.splice(0, 1)[0];
    };
    Queue.prototype.clear = function () {
      var current = this._items;
      this._items = [];
      return current;
    };
    Queue.prototype.size = function () {
      return this._items.length;
    };
    Queue.prototype.remove = function (item) {
      var idx = this._items.indexOf(item);
      return idx > -1 && this._items.splice(idx, 1)[0];
    };
    Queue.prototype.peekTail = function () {
      return this._items[this._items.length - 1];
    };
    Queue.prototype.peekHead = function () {
      if (this.size()) return this._items[0];
    };
    return Queue;
  }();

  /** An enum for Transition Rejection reasons */

  (function (RejectType) {
    /**
     * A new transition superseded this one.
     *
     * While this transition was running, a new transition started.
     * This transition is cancelled because it was superseded by new transition.
     */
    RejectType[RejectType["SUPERSEDED"] = 2] = "SUPERSEDED";
    /**
     * The transition was aborted
     *
     * The transition was aborted by a hook which returned `false`
     */
    RejectType[RejectType["ABORTED"] = 3] = "ABORTED";
    /**
     * The transition was invalid
     *
     * The transition was never started because it was invalid
     */
    RejectType[RejectType["INVALID"] = 4] = "INVALID";
    /**
     * The transition was ignored
     *
     * The transition was ignored because it would have no effect.
     *
     * Either:
     *
     * - The transition is targeting the current state and parameter values
     * - The transition is targeting the same state and parameter values as the currently running transition.
     */
    RejectType[RejectType["IGNORED"] = 5] = "IGNORED";
    /**
     * The transition errored.
     *
     * This generally means a hook threw an error or returned a rejected promise
     */
    RejectType[RejectType["ERROR"] = 6] = "ERROR";
  })(exports.RejectType || (exports.RejectType = {}));
  /** @internal */
  var id = 0;
  var Rejection = /** @class */function () {
    function Rejection(type, message, detail) {
      /** @internal */
      this.$id = id++;
      this.type = type;
      this.message = message;
      this.detail = detail;
    }
    /** Returns true if the obj is a rejected promise created from the `asPromise` factory */
    Rejection.isRejectionPromise = function (obj) {
      return obj && typeof obj.then === 'function' && is(Rejection)(obj._transitionRejection);
    };
    /** Returns a Rejection due to transition superseded */
    Rejection.superseded = function (detail, options) {
      var message = 'The transition has been superseded by a different transition';
      var rejection = new Rejection(exports.RejectType.SUPERSEDED, message, detail);
      if (options && options.redirected) {
        rejection.redirected = true;
      }
      return rejection;
    };
    /** Returns a Rejection due to redirected transition */
    Rejection.redirected = function (detail) {
      return Rejection.superseded(detail, {
        redirected: true
      });
    };
    /** Returns a Rejection due to invalid transition */
    Rejection.invalid = function (detail) {
      var message = 'This transition is invalid';
      return new Rejection(exports.RejectType.INVALID, message, detail);
    };
    /** Returns a Rejection due to ignored transition */
    Rejection.ignored = function (detail) {
      var message = 'The transition was ignored';
      return new Rejection(exports.RejectType.IGNORED, message, detail);
    };
    /** Returns a Rejection due to aborted transition */
    Rejection.aborted = function (detail) {
      var message = 'The transition has been aborted';
      return new Rejection(exports.RejectType.ABORTED, message, detail);
    };
    /** Returns a Rejection due to aborted transition */
    Rejection.errored = function (detail) {
      var message = 'The transition errored';
      return new Rejection(exports.RejectType.ERROR, message, detail);
    };
    /**
     * Returns a Rejection
     *
     * Normalizes a value as a Rejection.
     * If the value is already a Rejection, returns it.
     * Otherwise, wraps and returns the value as a Rejection (Rejection type: ERROR).
     *
     * @returns `detail` if it is already a `Rejection`, else returns an ERROR Rejection.
     */
    Rejection.normalize = function (detail) {
      return is(Rejection)(detail) ? detail : Rejection.errored(detail);
    };
    Rejection.prototype.toString = function () {
      var detailString = function detailString(d) {
        return d && d.toString !== Object.prototype.toString ? d.toString() : stringify(d);
      };
      var detail = detailString(this.detail);
      var _a = this,
        $id = _a.$id,
        type = _a.type,
        message = _a.message;
      return "Transition Rejection($id: " + $id + " type: " + type + ", message: " + message + ", detail: " + detail + ")";
    };
    Rejection.prototype.toPromise = function () {
      return extend(silentRejection(this), {
        _transitionRejection: this
      });
    };
    return Rejection;
  }();

  /**
   * Functions that manipulate strings
   *
   * Although these functions are exported, they are subject to change without notice.
   *
   * @packageDocumentation
   */
  /**
   * Returns a string shortened to a maximum length
   *
   * If the string is already less than the `max` length, return the string.
   * Else return the string, shortened to `max - 3` and append three dots ("...").
   *
   * @param max the maximum length of the string to return
   * @param str the input string
   */
  function maxLength(max, str) {
    if (str.length <= max) return str;
    return str.substr(0, max - 3) + '...';
  }
  /**
   * Returns a string, with spaces added to the end, up to a desired str length
   *
   * If the string is already longer than the desired length, return the string.
   * Else returns the string, with extra spaces on the end, such that it reaches `length` characters.
   *
   * @param length the desired length of the string to return
   * @param str the input string
   */
  function padString(length, str) {
    while (str.length < length) str += ' ';
    return str;
  }
  function kebobString(camelCase) {
    return camelCase.replace(/^([A-Z])/, function ($1) {
      return $1.toLowerCase();
    }) // replace first char
    .replace(/([A-Z])/g, function ($1) {
      return '-' + $1.toLowerCase();
    }); // replace rest
  }
  function functionToString(fn) {
    var fnStr = fnToString(fn);
    var namedFunctionMatch = fnStr.match(/^(function [^ ]+\([^)]*\))/);
    var toStr = namedFunctionMatch ? namedFunctionMatch[1] : fnStr;
    var fnName = fn['name'] || '';
    if (fnName && toStr.match(/function \(/)) {
      return 'function ' + fnName + toStr.substr(9);
    }
    return toStr;
  }
  function fnToString(fn) {
    var _fn = isArray(fn) ? fn.slice(-1)[0] : fn;
    return _fn && _fn.toString() || 'undefined';
  }
  function stringify(o) {
    var seen = [];
    var isRejection = Rejection.isRejectionPromise;
    var hasToString = function hasToString(obj) {
      return isObject(obj) && !isArray(obj) && obj.constructor !== Object && isFunction(obj.toString);
    };
    var stringifyPattern = pattern([[isUndefined, val('undefined')], [isNull, val('null')], [isPromise, val('[Promise]')], [isRejection, function (x) {
      return x._transitionRejection.toString();
    }], [hasToString, function (x) {
      return x.toString();
    }], [isInjectable, functionToString], [val(true), identity]]);
    function format(value) {
      if (isObject(value)) {
        if (seen.indexOf(value) !== -1) return '[circular ref]';
        seen.push(value);
      }
      return stringifyPattern(value);
    }
    if (isUndefined(o)) {
      // Workaround for IE & Edge Spec incompatibility where replacer function would not be called when JSON.stringify
      // is given `undefined` as value. To work around that, we simply detect `undefined` and bail out early by
      // manually stringifying it.
      return format(o);
    }
    return JSON.stringify(o, function (key, value) {
      return format(value);
    }).replace(/\\"/g, '"');
  }
  /** Returns a function that splits a string on a character or substring */
  var beforeAfterSubstr = function beforeAfterSubstr(_char) {
    return function (str) {
      if (!str) return ['', ''];
      var idx = str.indexOf(_char);
      if (idx === -1) return [str, ''];
      return [str.substr(0, idx), str.substr(idx + 1)];
    };
  };
  var hostRegex = new RegExp('^(?:[a-z]+:)?//[^/]+/');
  var stripLastPathElement = function stripLastPathElement(str) {
    return str.replace(/\/[^/]*$/, '');
  };
  var splitHash = beforeAfterSubstr('#');
  var splitQuery = beforeAfterSubstr('?');
  var splitEqual = beforeAfterSubstr('=');
  var trimHashVal = function trimHashVal(str) {
    return str ? str.replace(/^#/, '') : '';
  };
  /**
   * Splits on a delimiter, but returns the delimiters in the array
   *
   * #### Example:
   * ```js
   * var splitOnSlashes = splitOnDelim('/');
   * splitOnSlashes("/foo"); // ["/", "foo"]
   * splitOnSlashes("/foo/"); // ["/", "foo", "/"]
   * ```
   */
  function splitOnDelim(delim) {
    var re = new RegExp('(' + delim + ')', 'g');
    return function (str) {
      return str.split(re).filter(identity);
    };
  }
  /**
   * Reduce fn that joins neighboring strings
   *
   * Given an array of strings, returns a new array
   * where all neighboring strings have been joined.
   *
   * #### Example:
   * ```js
   * let arr = ["foo", "bar", 1, "baz", "", "qux" ];
   * arr.reduce(joinNeighborsR, []) // ["foobar", 1, "bazqux" ]
   * ```
   */
  function joinNeighborsR(acc, x) {
    if (isString(tail(acc)) && isString(x)) return acc.slice(0, -1).concat(tail(acc) + x);
    return pushR(acc, x);
  }

  /**
   * workaround for missing console object in IE9 when dev tools haven't been opened o_O
   * @packageDocumentation
   */
  var noopConsoleStub = {
    log: noop,
    error: noop,
    table: noop
  };
  function ie9Console(console) {
    var bound = function bound(fn) {
      return Function.prototype.bind.call(fn, console);
    };
    return {
      log: bound(console.log),
      error: bound(console.log),
      table: bound(console.log)
    };
  }
  function fallbackConsole(console) {
    var log = console.log.bind(console);
    var error = console.error ? console.error.bind(console) : log;
    var table = console.table ? console.table.bind(console) : log;
    return {
      log: log,
      error: error,
      table: table
    };
  }
  function getSafeConsole() {
    // @ts-ignore
    var isIE9 = typeof document !== 'undefined' && document.documentMode && document.documentMode === 9;
    if (isIE9) {
      return window && window.console ? ie9Console(window.console) : noopConsoleStub;
    } else if (!console.table || !console.error) {
      return fallbackConsole(console);
    } else {
      return console;
    }
  }
  var safeConsole = getSafeConsole();

  /**
   * # Transition tracing (debug)
   *
   * Enable transition tracing to print transition information to the console,
   * in order to help debug your application.
   * Tracing logs detailed information about each Transition to your console.
   *
   * To enable tracing, import the [[Trace]] singleton and enable one or more categories.
   *
   * ### ES6
   * ```js
   * import {trace} from "@uirouter/core";
   * trace.enable(1, 5); // TRANSITION and VIEWCONFIG
   * ```
   *
   * ### CJS
   * ```js
   * let trace = require("@uirouter/core").trace;
   * trace.enable("TRANSITION", "VIEWCONFIG");
   * ```
   *
   * ### Globals
   * ```js
   * let trace = window["@uirouter/core"].trace;
   * trace.enable(); // Trace everything (very verbose)
   * ```
   *
   * ### Angular 1:
   * ```js
   * app.run($trace => $trace.enable());
   * ```
   *
   * @packageDocumentation
   */
  function uiViewString(uiview) {
    if (!uiview) return 'ui-view (defunct)';
    var state = uiview.creationContext ? uiview.creationContext.name || '(root)' : '(none)';
    return "[ui-view#" + uiview.id + " " + uiview.$type + ":" + uiview.fqn + " (" + uiview.name + "@" + state + ")]";
  }
  var viewConfigString = function viewConfigString(viewConfig) {
    var view = viewConfig.viewDecl;
    var state = view.$context.name || '(root)';
    return "[View#" + viewConfig.$id + " from '" + state + "' state]: target ui-view: '" + view.$uiViewName + "@" + view.$uiViewContextAnchor + "'";
  };
  function normalizedCat(input) {
    return isNumber(input) ? exports.Category[input] : exports.Category[exports.Category[input]];
  }
  /**
   * Trace categories Enum
   *
   * Enable or disable a category using [[Trace.enable]] or [[Trace.disable]]
   *
   * `trace.enable(Category.TRANSITION)`
   *
   * These can also be provided using a matching string, or position ordinal
   *
   * `trace.enable("TRANSITION")`
   *
   * `trace.enable(1)`
   */

  (function (Category) {
    Category[Category["RESOLVE"] = 0] = "RESOLVE";
    Category[Category["TRANSITION"] = 1] = "TRANSITION";
    Category[Category["HOOK"] = 2] = "HOOK";
    Category[Category["UIVIEW"] = 3] = "UIVIEW";
    Category[Category["VIEWCONFIG"] = 4] = "VIEWCONFIG";
  })(exports.Category || (exports.Category = {}));
  var _tid = parse('$id');
  var _rid = parse('router.$id');
  var transLbl = function transLbl(trans) {
    return "Transition #" + _tid(trans) + "-" + _rid(trans);
  };
  /**
   * Prints UI-Router Transition trace information to the console.
   */
  var Trace = /** @class */function () {
    /** @internal */
    function Trace() {
      /** @internal */
      this._enabled = {};
      this.approximateDigests = 0;
    }
    /** @internal */
    Trace.prototype._set = function (enabled, categories) {
      var _this = this;
      if (!categories.length) {
        categories = Object.keys(exports.Category).map(function (k) {
          return parseInt(k, 10);
        }).filter(function (k) {
          return !isNaN(k);
        }).map(function (key) {
          return exports.Category[key];
        });
      }
      categories.map(normalizedCat).forEach(function (category) {
        return _this._enabled[category] = enabled;
      });
    };
    Trace.prototype.enable = function () {
      var categories = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        categories[_i] = arguments[_i];
      }
      this._set(true, categories);
    };
    Trace.prototype.disable = function () {
      var categories = [];
      for (var _i = 0; _i < arguments.length; _i++) {
        categories[_i] = arguments[_i];
      }
      this._set(false, categories);
    };
    /**
     * Retrieves the enabled stateus of a [[Category]]
     *
     * ```js
     * trace.enabled("VIEWCONFIG"); // true or false
     * ```
     *
     * @returns boolean true if the category is enabled
     */
    Trace.prototype.enabled = function (category) {
      return !!this._enabled[normalizedCat(category)];
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceTransitionStart = function (trans) {
      if (!this.enabled(exports.Category.TRANSITION)) return;
      safeConsole.log(transLbl(trans) + ": Started  -> " + stringify(trans));
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceTransitionIgnored = function (trans) {
      if (!this.enabled(exports.Category.TRANSITION)) return;
      safeConsole.log(transLbl(trans) + ": Ignored  <> " + stringify(trans));
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceHookInvocation = function (step, trans, options) {
      if (!this.enabled(exports.Category.HOOK)) return;
      var event = parse('traceData.hookType')(options) || 'internal',
        context = parse('traceData.context.state.name')(options) || parse('traceData.context')(options) || 'unknown',
        name = functionToString(step.registeredHook.callback);
      safeConsole.log(transLbl(trans) + ":   Hook -> " + event + " context: " + context + ", " + maxLength(200, name));
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceHookResult = function (hookResult, trans, transitionOptions) {
      if (!this.enabled(exports.Category.HOOK)) return;
      safeConsole.log(transLbl(trans) + ":   <- Hook returned: " + maxLength(200, stringify(hookResult)));
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceResolvePath = function (path, when, trans) {
      if (!this.enabled(exports.Category.RESOLVE)) return;
      safeConsole.log(transLbl(trans) + ":         Resolving " + path + " (" + when + ")");
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceResolvableResolved = function (resolvable, trans) {
      if (!this.enabled(exports.Category.RESOLVE)) return;
      safeConsole.log(transLbl(trans) + ":               <- Resolved  " + resolvable + " to: " + maxLength(200, stringify(resolvable.data)));
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceError = function (reason, trans) {
      if (!this.enabled(exports.Category.TRANSITION)) return;
      safeConsole.log(transLbl(trans) + ": <- Rejected " + stringify(trans) + ", reason: " + reason);
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceSuccess = function (finalState, trans) {
      if (!this.enabled(exports.Category.TRANSITION)) return;
      safeConsole.log(transLbl(trans) + ": <- Success  " + stringify(trans) + ", final state: " + finalState.name);
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceUIViewEvent = function (event, viewData, extra) {
      if (extra === void 0) {
        extra = '';
      }
      if (!this.enabled(exports.Category.UIVIEW)) return;
      safeConsole.log("ui-view: " + padString(30, event) + " " + uiViewString(viewData) + extra);
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceUIViewConfigUpdated = function (viewData, context) {
      if (!this.enabled(exports.Category.UIVIEW)) return;
      this.traceUIViewEvent('Updating', viewData, " with ViewConfig from context='" + context + "'");
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceUIViewFill = function (viewData, html) {
      if (!this.enabled(exports.Category.UIVIEW)) return;
      this.traceUIViewEvent('Fill', viewData, " with: " + maxLength(200, html));
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceViewSync = function (pairs) {
      if (!this.enabled(exports.Category.VIEWCONFIG)) return;
      var uivheader = 'uiview component fqn';
      var cfgheader = 'view config state (view name)';
      var mapping = pairs.map(function (_a) {
        var _b;
        var uiView = _a.uiView,
          viewConfig = _a.viewConfig;
        var uiv = uiView && uiView.fqn;
        var cfg = viewConfig && viewConfig.viewDecl.$context.name + ": (" + viewConfig.viewDecl.$name + ")";
        return _b = {}, _b[uivheader] = uiv, _b[cfgheader] = cfg, _b;
      }).sort(function (a, b) {
        return (a[uivheader] || '').localeCompare(b[uivheader] || '');
      });
      safeConsole.table(mapping);
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceViewServiceEvent = function (event, viewConfig) {
      if (!this.enabled(exports.Category.VIEWCONFIG)) return;
      safeConsole.log("VIEWCONFIG: " + event + " " + viewConfigString(viewConfig));
    };
    /** @internal called by ui-router code */
    Trace.prototype.traceViewServiceUIViewEvent = function (event, viewData) {
      if (!this.enabled(exports.Category.VIEWCONFIG)) return;
      safeConsole.log("VIEWCONFIG: " + event + " " + uiViewString(viewData));
    };
    return Trace;
  }();
  /**
   * The [[Trace]] singleton
   *
   * #### Example:
   * ```js
   * import {trace} from "@uirouter/core";
   * trace.enable(1, 5);
   * ```
   */
  var trace = new Trace();

  /**
   * An internal class which implements [[ParamTypeDefinition]].
   *
   * A [[ParamTypeDefinition]] is a plain javascript object used to register custom parameter types.
   * When a param type definition is registered, an instance of this class is created internally.
   *
   * This class has naive implementations for all the [[ParamTypeDefinition]] methods.
   *
   * Used by [[UrlMatcher]] when matching or formatting URLs, or comparing and validating parameter values.
   *
   * #### Example:
   * ```js
   * var paramTypeDef = {
   *   decode: function(val) { return parseInt(val, 10); },
   *   encode: function(val) { return val && val.toString(); },
   *   equals: function(a, b) { return this.is(a) && a === b; },
   *   is: function(val) { return angular.isNumber(val) && isFinite(val) && val % 1 === 0; },
   *   pattern: /\d+/
   * }
   *
   * var paramType = new ParamType(paramTypeDef);
   * ```
   */
  var ParamType = /** @class */function () {
    /**
     * @param def  A configuration object which contains the custom type definition.  The object's
     *        properties will override the default methods and/or pattern in `ParamType`'s public interface.
     * @returns a new ParamType object
     */
    function ParamType(def) {
      /** @inheritdoc */
      this.pattern = /.*/;
      /** @inheritdoc */
      this.inherit = true;
      extend(this, def);
    }
    // consider these four methods to be "abstract methods" that should be overridden
    /** @inheritdoc */
    ParamType.prototype.is = function (val, key) {
      return true;
    };
    /** @inheritdoc */
    ParamType.prototype.encode = function (val, key) {
      return val;
    };
    /** @inheritdoc */
    ParamType.prototype.decode = function (val, key) {
      return val;
    };
    /** @inheritdoc */
    ParamType.prototype.equals = function (a, b) {
      // tslint:disable-next-line:triple-equals
      return a == b;
    };
    ParamType.prototype.$subPattern = function () {
      var sub = this.pattern.toString();
      return sub.substr(1, sub.length - 2);
    };
    ParamType.prototype.toString = function () {
      return "{ParamType:" + this.name + "}";
    };
    /** Given an encoded string, or a decoded object, returns a decoded object */
    ParamType.prototype.$normalize = function (val) {
      return this.is(val) ? val : this.decode(val);
    };
    /**
     * Wraps an existing custom ParamType as an array of ParamType, depending on 'mode'.
     * e.g.:
     * - urlmatcher pattern "/path?{queryParam[]:int}"
     * - url: "/path?queryParam=1&queryParam=2
     * - $stateParams.queryParam will be [1, 2]
     * if `mode` is "auto", then
     * - url: "/path?queryParam=1 will create $stateParams.queryParam: 1
     * - url: "/path?queryParam=1&queryParam=2 will create $stateParams.queryParam: [1, 2]
     */
    ParamType.prototype.$asArray = function (mode, isSearch) {
      if (!mode) return this;
      if (mode === 'auto' && !isSearch) throw new Error("'auto' array mode is for query parameters only");
      return new ArrayType(this, mode);
    };
    return ParamType;
  }();
  /** Wraps up a `ParamType` object to handle array values. */
  function ArrayType(type, mode) {
    var _this = this;
    // Wrap non-array value as array
    function arrayWrap(val) {
      return isArray(val) ? val : isDefined(val) ? [val] : [];
    }
    // Unwrap array value for "auto" mode. Return undefined for empty array.
    function arrayUnwrap(val) {
      switch (val.length) {
        case 0:
          return undefined;
        case 1:
          return mode === 'auto' ? val[0] : val;
        default:
          return val;
      }
    }
    // Wraps type (.is/.encode/.decode) functions to operate on each value of an array
    function arrayHandler(callback, allTruthyMode) {
      return function handleArray(val) {
        if (isArray(val) && val.length === 0) return val;
        var arr = arrayWrap(val);
        var result = map(arr, callback);
        return allTruthyMode === true ? filter(result, function (x) {
          return !x;
        }).length === 0 : arrayUnwrap(result);
      };
    }
    // Wraps type (.equals) functions to operate on each value of an array
    function arrayEqualsHandler(callback) {
      return function handleArray(val1, val2) {
        var left = arrayWrap(val1),
          right = arrayWrap(val2);
        if (left.length !== right.length) return false;
        for (var i = 0; i < left.length; i++) {
          if (!callback(left[i], right[i])) return false;
        }
        return true;
      };
    }
    ['encode', 'decode', 'equals', '$normalize'].forEach(function (name) {
      var paramTypeFn = type[name].bind(type);
      var wrapperFn = name === 'equals' ? arrayEqualsHandler : arrayHandler;
      _this[name] = wrapperFn(paramTypeFn);
    });
    extend(this, {
      dynamic: type.dynamic,
      name: type.name,
      pattern: type.pattern,
      inherit: type.inherit,
      raw: type.raw,
      is: arrayHandler(type.is.bind(type), true),
      $arrayMode: mode
    });
  }
  var hasOwn = Object.prototype.hasOwnProperty;
  var isShorthand = function isShorthand(cfg) {
    return ['value', 'type', 'squash', 'array', 'dynamic'].filter(hasOwn.bind(cfg || {})).length === 0;
  };
  (function (DefType) {
    DefType[DefType["PATH"] = 0] = "PATH";
    DefType[DefType["SEARCH"] = 1] = "SEARCH";
    DefType[DefType["CONFIG"] = 2] = "CONFIG";
  })(exports.DefType || (exports.DefType = {}));
  function getParamDeclaration(paramName, location, state) {
    var noReloadOnSearch = state.reloadOnSearch === false && location === exports.DefType.SEARCH || undefined;
    var dynamic = find([state.dynamic, noReloadOnSearch], isDefined);
    var defaultConfig = isDefined(dynamic) ? {
      dynamic: dynamic
    } : {};
    var paramConfig = unwrapShorthand(state && state.params && state.params[paramName]);
    return extend(defaultConfig, paramConfig);
  }
  function unwrapShorthand(cfg) {
    cfg = isShorthand(cfg) ? {
      value: cfg
    } : cfg;
    getStaticDefaultValue['__cacheable'] = true;
    function getStaticDefaultValue() {
      return cfg.value;
    }
    var $$fn = isInjectable(cfg.value) ? cfg.value : getStaticDefaultValue;
    return extend(cfg, {
      $$fn: $$fn
    });
  }
  function getType(cfg, urlType, location, id, paramTypes) {
    if (cfg.type && urlType && urlType.name !== 'string') throw new Error("Param '" + id + "' has two type configurations.");
    if (cfg.type && urlType && urlType.name === 'string' && paramTypes.type(cfg.type)) return paramTypes.type(cfg.type);
    if (urlType) return urlType;
    if (!cfg.type) {
      var type = location === exports.DefType.CONFIG ? 'any' : location === exports.DefType.PATH ? 'path' : location === exports.DefType.SEARCH ? 'query' : 'string';
      return paramTypes.type(type);
    }
    return cfg.type instanceof ParamType ? cfg.type : paramTypes.type(cfg.type);
  }
  /** returns false, true, or the squash value to indicate the "default parameter url squash policy". */
  function getSquashPolicy(config, isOptional, defaultPolicy) {
    var squash = config.squash;
    if (!isOptional || squash === false) return false;
    if (!isDefined(squash) || squash == null) return defaultPolicy;
    if (squash === true || isString(squash)) return squash;
    throw new Error("Invalid squash policy: '" + squash + "'. Valid policies: false, true, or arbitrary string");
  }
  function getReplace(config, arrayMode, isOptional, squash) {
    var defaultPolicy = [{
      from: '',
      to: isOptional || arrayMode ? undefined : ''
    }, {
      from: null,
      to: isOptional || arrayMode ? undefined : ''
    }];
    var replace = isArray(config.replace) ? config.replace : [];
    if (isString(squash)) replace.push({
      from: squash,
      to: undefined
    });
    var configuredKeys = map(replace, prop('from'));
    return filter(defaultPolicy, function (item) {
      return configuredKeys.indexOf(item.from) === -1;
    }).concat(replace);
  }
  var Param = /** @class */function () {
    function Param(id, type, location, urlConfig, state) {
      var config = getParamDeclaration(id, location, state);
      type = getType(config, type, location, id, urlConfig.paramTypes);
      var arrayMode = getArrayMode();
      type = arrayMode ? type.$asArray(arrayMode, location === exports.DefType.SEARCH) : type;
      var isOptional = config.value !== undefined || location === exports.DefType.SEARCH;
      var dynamic = isDefined(config.dynamic) ? !!config.dynamic : !!type.dynamic;
      var raw = isDefined(config.raw) ? !!config.raw : !!type.raw;
      var squash = getSquashPolicy(config, isOptional, urlConfig.defaultSquashPolicy());
      var replace = getReplace(config, arrayMode, isOptional, squash);
      var inherit = isDefined(config.inherit) ? !!config.inherit : !!type.inherit;
      // array config: param name (param[]) overrides default settings.  explicit config overrides param name.
      function getArrayMode() {
        var arrayDefaults = {
          array: location === exports.DefType.SEARCH ? 'auto' : false
        };
        var arrayParamNomenclature = id.match(/\[\]$/) ? {
          array: true
        } : {};
        return extend(arrayDefaults, arrayParamNomenclature, config).array;
      }
      extend(this, {
        id: id,
        type: type,
        location: location,
        isOptional: isOptional,
        dynamic: dynamic,
        raw: raw,
        squash: squash,
        replace: replace,
        inherit: inherit,
        array: arrayMode,
        config: config
      });
    }
    Param.values = function (params, values) {
      if (values === void 0) {
        values = {};
      }
      var paramValues = {};
      for (var _i = 0, params_1 = params; _i < params_1.length; _i++) {
        var param = params_1[_i];
        paramValues[param.id] = param.value(values[param.id]);
      }
      return paramValues;
    };
    /**
     * Finds [[Param]] objects which have different param values
     *
     * Filters a list of [[Param]] objects to only those whose parameter values differ in two param value objects
     *
     * @param params: The list of Param objects to filter
     * @param values1: The first set of parameter values
     * @param values2: the second set of parameter values
     *
     * @returns any Param objects whose values were different between values1 and values2
     */
    Param.changed = function (params, values1, values2) {
      if (values1 === void 0) {
        values1 = {};
      }
      if (values2 === void 0) {
        values2 = {};
      }
      return params.filter(function (param) {
        return !param.type.equals(values1[param.id], values2[param.id]);
      });
    };
    /**
     * Checks if two param value objects are equal (for a set of [[Param]] objects)
     *
     * @param params The list of [[Param]] objects to check
     * @param values1 The first set of param values
     * @param values2 The second set of param values
     *
     * @returns true if the param values in values1 and values2 are equal
     */
    Param.equals = function (params, values1, values2) {
      if (values1 === void 0) {
        values1 = {};
      }
      if (values2 === void 0) {
        values2 = {};
      }
      return Param.changed(params, values1, values2).length === 0;
    };
    /** Returns true if a the parameter values are valid, according to the Param definitions */
    Param.validates = function (params, values) {
      if (values === void 0) {
        values = {};
      }
      return params.map(function (param) {
        return param.validates(values[param.id]);
      }).reduce(allTrueR, true);
    };
    Param.prototype.isDefaultValue = function (value) {
      return this.isOptional && this.type.equals(this.value(), value);
    };
    /**
     * [Internal] Gets the decoded representation of a value if the value is defined, otherwise, returns the
     * default value, which may be the result of an injectable function.
     */
    Param.prototype.value = function (value) {
      var _this = this;
      /**
       * [Internal] Get the default value of a parameter, which may be an injectable function.
       */
      var getDefaultValue = function getDefaultValue() {
        if (_this._defaultValueCache) return _this._defaultValueCache.defaultValue;
        if (!services.$injector) throw new Error('Injectable functions cannot be called at configuration time');
        var defaultValue = services.$injector.invoke(_this.config.$$fn);
        if (defaultValue !== null && defaultValue !== undefined && !_this.type.is(defaultValue)) throw new Error("Default value (" + defaultValue + ") for parameter '" + _this.id + "' is not an instance of ParamType (" + _this.type.name + ")");
        if (_this.config.$$fn['__cacheable']) {
          _this._defaultValueCache = {
            defaultValue: defaultValue
          };
        }
        return defaultValue;
      };
      var replaceSpecialValues = function replaceSpecialValues(val) {
        for (var _i = 0, _a = _this.replace; _i < _a.length; _i++) {
          var tuple = _a[_i];
          if (tuple.from === val) return tuple.to;
        }
        return val;
      };
      value = replaceSpecialValues(value);
      return isUndefined(value) ? getDefaultValue() : this.type.$normalize(value);
    };
    Param.prototype.isSearch = function () {
      return this.location === exports.DefType.SEARCH;
    };
    Param.prototype.validates = function (value) {
      // There was no parameter value, but the param is optional
      if ((isUndefined(value) || value === null) && this.isOptional) return true;
      // The value was not of the correct ParamType, and could not be decoded to the correct ParamType
      var normalized = this.type.$normalize(value);
      if (!this.type.is(normalized)) return false;
      // The value was of the correct type, but when encoded, did not match the ParamType's regexp
      var encoded = this.type.encode(normalized);
      return !(isString(encoded) && !this.type.pattern.exec(encoded));
    };
    Param.prototype.toString = function () {
      return "{Param:" + this.id + " " + this.type + " squash: '" + this.squash + "' optional: " + this.isOptional + "}";
    };
    return Param;
  }();

  /**
   * A registry for parameter types.
   *
   * This registry manages the built-in (and custom) parameter types.
   *
   * The built-in parameter types are:
   *
   * - [[string]]
   * - [[path]]
   * - [[query]]
   * - [[hash]]
   * - [[int]]
   * - [[bool]]
   * - [[date]]
   * - [[json]]
   * - [[any]]
   *
   * To register custom parameter types, use [[UrlConfig.type]], i.e.,
   *
   * ```js
   * router.urlService.config.type(customType)
   * ```
   */
  var ParamTypes = /** @class */function () {
    function ParamTypes() {
      this.enqueue = true;
      this.typeQueue = [];
      this.defaultTypes = pick(ParamTypes.prototype, ['hash', 'string', 'query', 'path', 'int', 'bool', 'date', 'json', 'any']);
      // Register default types. Store them in the prototype of this.types.
      var makeType = function makeType(definition, name) {
        return new ParamType(extend({
          name: name
        }, definition));
      };
      this.types = inherit(map(this.defaultTypes, makeType), {});
    }
    ParamTypes.prototype.dispose = function () {
      this.types = {};
    };
    /**
     * Registers a parameter type
     *
     * End users should call [[UrlMatcherFactory.type]], which delegates to this method.
     */
    ParamTypes.prototype.type = function (name, definition, definitionFn) {
      if (!isDefined(definition)) return this.types[name];
      if (this.types.hasOwnProperty(name)) throw new Error("A type named '" + name + "' has already been defined.");
      this.types[name] = new ParamType(extend({
        name: name
      }, definition));
      if (definitionFn) {
        this.typeQueue.push({
          name: name,
          def: definitionFn
        });
        if (!this.enqueue) this._flushTypeQueue();
      }
      return this;
    };
    ParamTypes.prototype._flushTypeQueue = function () {
      while (this.typeQueue.length) {
        var type = this.typeQueue.shift();
        if (type.pattern) throw new Error("You cannot override a type's .pattern at runtime.");
        extend(this.types[type.name], services.$injector.invoke(type.def));
      }
    };
    return ParamTypes;
  }();
  function initDefaultTypes() {
    var makeDefaultType = function makeDefaultType(def) {
      var valToString = function valToString(val) {
        return val != null ? val.toString() : val;
      };
      var defaultTypeBase = {
        encode: valToString,
        decode: valToString,
        is: is(String),
        pattern: /.*/,
        // tslint:disable-next-line:triple-equals
        equals: function equals(a, b) {
          return a == b;
        }
      };
      return extend({}, defaultTypeBase, def);
    };
    // Default Parameter Type Definitions
    extend(ParamTypes.prototype, {
      string: makeDefaultType({}),
      path: makeDefaultType({
        pattern: /[^/]*/
      }),
      query: makeDefaultType({}),
      hash: makeDefaultType({
        inherit: false
      }),
      "int": makeDefaultType({
        decode: function decode(val) {
          return parseInt(val, 10);
        },
        is: function is(val) {
          return !isNullOrUndefined(val) && this.decode(val.toString()) === val;
        },
        pattern: /-?\d+/
      }),
      bool: makeDefaultType({
        encode: function encode(val) {
          return val && 1 || 0;
        },
        decode: function decode(val) {
          return parseInt(val, 10) !== 0;
        },
        is: is(Boolean),
        pattern: /0|1/
      }),
      date: makeDefaultType({
        encode: function encode(val) {
          return !this.is(val) ? undefined : [val.getFullYear(), ('0' + (val.getMonth() + 1)).slice(-2), ('0' + val.getDate()).slice(-2)].join('-');
        },
        decode: function decode(val) {
          if (this.is(val)) return val;
          var match = this.capture.exec(val);
          return match ? new Date(match[1], match[2] - 1, match[3]) : undefined;
        },
        is: function is(val) {
          return val instanceof Date && !isNaN(val.valueOf());
        },
        equals: function equals(l, r) {
          return ['getFullYear', 'getMonth', 'getDate'].reduce(function (acc, fn) {
            return acc && l[fn]() === r[fn]();
          }, true);
        },
        pattern: /[0-9]{4}-(?:0[1-9]|1[0-2])-(?:0[1-9]|[1-2][0-9]|3[0-1])/,
        capture: /([0-9]{4})-(0[1-9]|1[0-2])-(0[1-9]|[1-2][0-9]|3[0-1])/
      }),
      json: makeDefaultType({
        encode: toJson,
        decode: fromJson,
        is: is(Object),
        equals: equals,
        pattern: /[^/]*/
      }),
      // does not encode/decode
      any: makeDefaultType({
        encode: identity,
        decode: identity,
        is: function is() {
          return true;
        },
        equals: equals
      })
    });
  }
  initDefaultTypes();
  var StateParams = /** @class */function () {
    function StateParams(params) {
      if (params === void 0) {
        params = {};
      }
      extend(this, params);
    }
    /**
     * Merges a set of parameters with all parameters inherited between the common parents of the
     * current state and a given destination state.
     *
     * @param {Object} newParams The set of parameters which will be composited with inherited params.
     * @param {Object} $current Internal definition of object representing the current state.
     * @param {Object} $to Internal definition of object representing state to transition to.
     */
    StateParams.prototype.$inherit = function (newParams, $current, $to) {
      var parentParams;
      var parents = ancestors($current, $to),
        inherited = {},
        inheritList = [];
      for (var i in parents) {
        if (!parents[i] || !parents[i].params) continue;
        parentParams = Object.keys(parents[i].params);
        if (!parentParams.length) continue;
        for (var j in parentParams) {
          if (inheritList.indexOf(parentParams[j]) >= 0) continue;
          inheritList.push(parentParams[j]);
          inherited[parentParams[j]] = this[parentParams[j]];
        }
      }
      return extend({}, inherited, newParams);
    };
    return StateParams;
  }();

  /**
   * A node in a [[TreeChanges]] path
   *
   * For a [[TreeChanges]] path, this class holds the stateful information for a single node in the path.
   * Each PathNode corresponds to a state being entered, exited, or retained.
   * The stateful information includes parameter values and resolve data.
   */
  var PathNode = /** @class */function () {
    function PathNode(stateOrNode) {
      if (stateOrNode instanceof PathNode) {
        var node = stateOrNode;
        this.state = node.state;
        this.paramSchema = node.paramSchema.slice();
        this.paramValues = extend({}, node.paramValues);
        this.resolvables = node.resolvables.slice();
        this.views = node.views && node.views.slice();
      } else {
        var state = stateOrNode;
        this.state = state;
        this.paramSchema = state.parameters({
          inherit: false
        });
        this.paramValues = {};
        this.resolvables = state.resolvables.map(function (res) {
          return res.clone();
        });
      }
    }
    PathNode.prototype.clone = function () {
      return new PathNode(this);
    };
    /** Sets [[paramValues]] for the node, from the values of an object hash */
    PathNode.prototype.applyRawParams = function (params) {
      var getParamVal = function getParamVal(paramDef) {
        return [paramDef.id, paramDef.value(params[paramDef.id])];
      };
      this.paramValues = this.paramSchema.reduce(function (memo, pDef) {
        return applyPairs(memo, getParamVal(pDef));
      }, {});
      return this;
    };
    /** Gets a specific [[Param]] metadata that belongs to the node */
    PathNode.prototype.parameter = function (name) {
      return find(this.paramSchema, propEq('id', name));
    };
    /**
     * @returns true if the state and parameter values for another PathNode are
     * equal to the state and param values for this PathNode
     */
    PathNode.prototype.equals = function (node, paramsFn) {
      var diff = this.diff(node, paramsFn);
      return diff && diff.length === 0;
    };
    /**
     * Finds Params with different parameter values on another PathNode.
     *
     * Given another node (of the same state), finds the parameter values which differ.
     * Returns the [[Param]] (schema objects) whose parameter values differ.
     *
     * Given another node for a different state, returns `false`
     *
     * @param node The node to compare to
     * @param paramsFn A function that returns which parameters should be compared.
     * @returns The [[Param]]s which differ, or null if the two nodes are for different states
     */
    PathNode.prototype.diff = function (node, paramsFn) {
      if (this.state !== node.state) return false;
      var params = paramsFn ? paramsFn(this) : this.paramSchema;
      return Param.changed(params, this.paramValues, node.paramValues);
    };
    /**
     * Returns a clone of the PathNode
     * @deprecated use instance method `node.clone()`
     */
    PathNode.clone = function (node) {
      return node.clone();
    };
    return PathNode;
  }();

  /**
   * Encapsulate the target (destination) state/params/options of a [[Transition]].
   *
   * This class is frequently used to redirect a transition to a new destination.
   *
   * See:
   *
   * - [[HookResult]]
   * - [[TransitionHookFn]]
   * - [[TransitionService.onStart]]
   *
   * To create a `TargetState`, use [[StateService.target]].
   *
   * ---
   *
   * This class wraps:
   *
   * 1) an identifier for a state
   * 2) a set of parameters
   * 3) and transition options
   * 4) the registered state object (the [[StateDeclaration]])
   *
   * Many UI-Router APIs such as [[StateService.go]] take a [[StateOrName]] argument which can
   * either be a *state object* (a [[StateDeclaration]] or [[StateObject]]) or a *state name* (a string).
   * The `TargetState` class normalizes those options.
   *
   * A `TargetState` may be valid (the state being targeted exists in the registry)
   * or invalid (the state being targeted is not registered).
   */
  var TargetState = /** @class */function () {
    /**
     * The TargetState constructor
     *
     * Note: Do not construct a `TargetState` manually.
     * To create a `TargetState`, use the [[StateService.target]] factory method.
     *
     * @param _stateRegistry The StateRegistry to use to look up the _definition
     * @param _identifier An identifier for a state.
     *    Either a fully-qualified state name, or the object used to define the state.
     * @param _params Parameters for the target state
     * @param _options Transition options.
     *
     * @internal
     */
    function TargetState(_stateRegistry, _identifier, _params, _options) {
      this._stateRegistry = _stateRegistry;
      this._identifier = _identifier;
      this._identifier = _identifier;
      this._params = extend({}, _params || {});
      this._options = extend({}, _options || {});
      this._definition = _stateRegistry.matcher.find(_identifier, this._options.relative);
    }
    /** The name of the state this object targets */
    TargetState.prototype.name = function () {
      return this._definition && this._definition.name || this._identifier;
    };
    /** The identifier used when creating this TargetState */
    TargetState.prototype.identifier = function () {
      return this._identifier;
    };
    /** The target parameter values */
    TargetState.prototype.params = function () {
      return this._params;
    };
    /** The internal state object (if it was found) */
    TargetState.prototype.$state = function () {
      return this._definition;
    };
    /** The internal state declaration (if it was found) */
    TargetState.prototype.state = function () {
      return this._definition && this._definition.self;
    };
    /** The target options */
    TargetState.prototype.options = function () {
      return this._options;
    };
    /** True if the target state was found */
    TargetState.prototype.exists = function () {
      return !!(this._definition && this._definition.self);
    };
    /** True if the object is valid */
    TargetState.prototype.valid = function () {
      return !this.error();
    };
    /** If the object is invalid, returns the reason why */
    TargetState.prototype.error = function () {
      var base = this.options().relative;
      if (!this._definition && !!base) {
        var stateName = base.name ? base.name : base;
        return "Could not resolve '" + this.name() + "' from state '" + stateName + "'";
      }
      if (!this._definition) return "No such state '" + this.name() + "'";
      if (!this._definition.self) return "State '" + this.name() + "' has an invalid definition";
    };
    TargetState.prototype.toString = function () {
      return "'" + this.name() + "'" + stringify(this.params());
    };
    /**
     * Returns a copy of this TargetState which targets a different state.
     * The new TargetState has the same parameter values and transition options.
     *
     * @param state The new state that should be targeted
     */
    TargetState.prototype.withState = function (state) {
      return new TargetState(this._stateRegistry, state, this._params, this._options);
    };
    /**
     * Returns a copy of this TargetState, using the specified parameter values.
     *
     * @param params the new parameter values to use
     * @param replace When false (default) the new parameter values will be merged with the current values.
     *                When true the parameter values will be used instead of the current values.
     */
    TargetState.prototype.withParams = function (params, replace) {
      if (replace === void 0) {
        replace = false;
      }
      var newParams = replace ? params : extend({}, this._params, params);
      return new TargetState(this._stateRegistry, this._identifier, newParams, this._options);
    };
    /**
     * Returns a copy of this TargetState, using the specified Transition Options.
     *
     * @param options the new options to use
     * @param replace When false (default) the new options will be merged with the current options.
     *                When true the options will be used instead of the current options.
     */
    TargetState.prototype.withOptions = function (options, replace) {
      if (replace === void 0) {
        replace = false;
      }
      var newOpts = replace ? options : extend({}, this._options, options);
      return new TargetState(this._stateRegistry, this._identifier, this._params, newOpts);
    };
    /** Returns true if the object has a state property that might be a state or state name */
    TargetState.isDef = function (obj) {
      return obj && obj.state && (isString(obj.state) || isObject(obj.state) && isString(obj.state.name));
    };
    return TargetState;
  }();

  /**
   * This class contains functions which convert TargetStates, Nodes and paths from one type to another.
   */
  var PathUtils = /** @class */function () {
    function PathUtils() {}
    /** Given a PathNode[], create an TargetState */
    PathUtils.makeTargetState = function (registry, path) {
      var state = tail(path).state;
      return new TargetState(registry, state, path.map(prop('paramValues')).reduce(mergeR, {}), {});
    };
    PathUtils.buildPath = function (targetState) {
      var toParams = targetState.params();
      return targetState.$state().path.map(function (state) {
        return new PathNode(state).applyRawParams(toParams);
      });
    };
    /** Given a fromPath: PathNode[] and a TargetState, builds a toPath: PathNode[] */
    PathUtils.buildToPath = function (fromPath, targetState) {
      var toPath = PathUtils.buildPath(targetState);
      if (targetState.options().inherit) {
        return PathUtils.inheritParams(fromPath, toPath, Object.keys(targetState.params()));
      }
      return toPath;
    };
    /**
     * Creates ViewConfig objects and adds to nodes.
     *
     * On each [[PathNode]], creates ViewConfig objects from the views: property of the node's state
     */
    PathUtils.applyViewConfigs = function ($view, path, states) {
      // Only apply the viewConfigs to the nodes for the given states
      path.filter(function (node) {
        return inArray(states, node.state);
      }).forEach(function (node) {
        var viewDecls = values(node.state.views || {});
        var subPath = PathUtils.subPath(path, function (n) {
          return n === node;
        });
        var viewConfigs = viewDecls.map(function (view) {
          return $view.createViewConfig(subPath, view);
        });
        node.views = viewConfigs.reduce(unnestR, []);
      });
    };
    /**
     * Given a fromPath and a toPath, returns a new to path which inherits parameters from the fromPath
     *
     * For a parameter in a node to be inherited from the from path:
     * - The toPath's node must have a matching node in the fromPath (by state).
     * - The parameter name must not be found in the toKeys parameter array.
     *
     * Note: the keys provided in toKeys are intended to be those param keys explicitly specified by some
     * caller, for instance, $state.transitionTo(..., toParams).  If a key was found in toParams,
     * it is not inherited from the fromPath.
     */
    PathUtils.inheritParams = function (fromPath, toPath, toKeys) {
      if (toKeys === void 0) {
        toKeys = [];
      }
      function nodeParamVals(path, state) {
        var node = find(path, propEq('state', state));
        return extend({}, node && node.paramValues);
      }
      var noInherit = fromPath.map(function (node) {
        return node.paramSchema;
      }).reduce(unnestR, []).filter(function (param) {
        return !param.inherit;
      }).map(prop('id'));
      /**
       * Given an [[PathNode]] "toNode", return a new [[PathNode]] with param values inherited from the
       * matching node in fromPath.  Only inherit keys that aren't found in "toKeys" from the node in "fromPath""
       */
      function makeInheritedParamsNode(toNode) {
        // All param values for the node (may include default key/vals, when key was not found in toParams)
        var toParamVals = extend({}, toNode && toNode.paramValues);
        // limited to only those keys found in toParams
        var incomingParamVals = pick(toParamVals, toKeys);
        toParamVals = omit(toParamVals, toKeys);
        var fromParamVals = omit(nodeParamVals(fromPath, toNode.state) || {}, noInherit);
        // extend toParamVals with any fromParamVals, then override any of those those with incomingParamVals
        var ownParamVals = extend(toParamVals, fromParamVals, incomingParamVals);
        return new PathNode(toNode.state).applyRawParams(ownParamVals);
      }
      // The param keys specified by the incoming toParams
      return toPath.map(makeInheritedParamsNode);
    };
    /**
     * Computes the tree changes (entering, exiting) between a fromPath and toPath.
     */
    PathUtils.treeChanges = function (fromPath, toPath, reloadState) {
      var max = Math.min(fromPath.length, toPath.length);
      var keep = 0;
      var nodesMatch = function nodesMatch(node1, node2) {
        return node1.equals(node2, PathUtils.nonDynamicParams);
      };
      while (keep < max && fromPath[keep].state !== reloadState && nodesMatch(fromPath[keep], toPath[keep])) {
        keep++;
      }
      /** Given a retained node, return a new node which uses the to node's param values */
      function applyToParams(retainedNode, idx) {
        var cloned = retainedNode.clone();
        cloned.paramValues = toPath[idx].paramValues;
        return cloned;
      }
      var from, retained, exiting, entering, to;
      from = fromPath;
      retained = from.slice(0, keep);
      exiting = from.slice(keep);
      // Create a new retained path (with shallow copies of nodes) which have the params of the toPath mapped
      var retainedWithToParams = retained.map(applyToParams);
      entering = toPath.slice(keep);
      to = retainedWithToParams.concat(entering);
      return {
        from: from,
        to: to,
        retained: retained,
        retainedWithToParams: retainedWithToParams,
        exiting: exiting,
        entering: entering
      };
    };
    /**
     * Returns a new path which is: the subpath of the first path which matches the second path.
     *
     * The new path starts from root and contains any nodes that match the nodes in the second path.
     * It stops before the first non-matching node.
     *
     * Nodes are compared using their state property and their parameter values.
     * If a `paramsFn` is provided, only the [[Param]] returned by the function will be considered when comparing nodes.
     *
     * @param pathA the first path
     * @param pathB the second path
     * @param paramsFn a function which returns the parameters to consider when comparing
     *
     * @returns an array of PathNodes from the first path which match the nodes in the second path
     */
    PathUtils.matching = function (pathA, pathB, paramsFn) {
      var done = false;
      var tuples = arrayTuples(pathA, pathB);
      return tuples.reduce(function (matching, _a) {
        var nodeA = _a[0],
          nodeB = _a[1];
        done = done || !nodeA.equals(nodeB, paramsFn);
        return done ? matching : matching.concat(nodeA);
      }, []);
    };
    /**
     * Returns true if two paths are identical.
     *
     * @param pathA
     * @param pathB
     * @param paramsFn a function which returns the parameters to consider when comparing
     * @returns true if the the states and parameter values for both paths are identical
     */
    PathUtils.equals = function (pathA, pathB, paramsFn) {
      return pathA.length === pathB.length && PathUtils.matching(pathA, pathB, paramsFn).length === pathA.length;
    };
    /**
     * Return a subpath of a path, which stops at the first matching node
     *
     * Given an array of nodes, returns a subset of the array starting from the first node,
     * stopping when the first node matches the predicate.
     *
     * @param path a path of [[PathNode]]s
     * @param predicate a [[Predicate]] fn that matches [[PathNode]]s
     * @returns a subpath up to the matching node, or undefined if no match is found
     */
    PathUtils.subPath = function (path, predicate) {
      var node = find(path, predicate);
      var elementIdx = path.indexOf(node);
      return elementIdx === -1 ? undefined : path.slice(0, elementIdx + 1);
    };
    PathUtils.nonDynamicParams = function (node) {
      return node.state.parameters({
        inherit: false
      }).filter(function (param) {
        return !param.dynamic;
      });
    };
    /** Gets the raw parameter values from a path */
    PathUtils.paramValues = function (path) {
      return path.reduce(function (acc, node) {
        return extend(acc, node.paramValues);
      }, {});
    };
    return PathUtils;
  }();
  var resolvePolicies = {
    when: {
      LAZY: 'LAZY',
      EAGER: 'EAGER'
    },
    async: {
      WAIT: 'WAIT',
      NOWAIT: 'NOWAIT'
    }
  };

  // TODO: explicitly make this user configurable
  var defaultResolvePolicy = {
    when: 'LAZY',
    async: 'WAIT'
  };
  /**
   * The basic building block for the resolve system.
   *
   * Resolvables encapsulate a state's resolve's resolveFn, the resolveFn's declared dependencies, the wrapped (.promise),
   * and the unwrapped-when-complete (.data) result of the resolveFn.
   *
   * Resolvable.get() either retrieves the Resolvable's existing promise, or else invokes resolve() (which invokes the
   * resolveFn) and returns the resulting promise.
   *
   * Resolvable.get() and Resolvable.resolve() both execute within a context path, which is passed as the first
   * parameter to those fns.
   */
  var Resolvable = /** @class */function () {
    function Resolvable(arg1, resolveFn, deps, policy, data) {
      this.resolved = false;
      this.promise = undefined;
      if (arg1 instanceof Resolvable) {
        extend(this, arg1);
      } else if (isFunction(resolveFn)) {
        if (isNullOrUndefined(arg1)) throw new Error('new Resolvable(): token argument is required');
        if (!isFunction(resolveFn)) throw new Error('new Resolvable(): resolveFn argument must be a function');
        this.token = arg1;
        this.policy = policy;
        this.resolveFn = resolveFn;
        this.deps = deps || [];
        this.data = data;
        this.resolved = data !== undefined;
        this.promise = this.resolved ? services.$q.when(this.data) : undefined;
      } else if (isObject(arg1) && arg1.token && (arg1.hasOwnProperty('resolveFn') || arg1.hasOwnProperty('data'))) {
        var literal = arg1;
        return new Resolvable(literal.token, literal.resolveFn, literal.deps, literal.policy, literal.data);
      }
    }
    Resolvable.prototype.getPolicy = function (state) {
      var thisPolicy = this.policy || {};
      var statePolicy = state && state.resolvePolicy || {};
      return {
        when: thisPolicy.when || statePolicy.when || defaultResolvePolicy.when,
        async: thisPolicy.async || statePolicy.async || defaultResolvePolicy.async
      };
    };
    /**
     * Asynchronously resolve this Resolvable's data
     *
     * Given a ResolveContext that this Resolvable is found in:
     * Wait for this Resolvable's dependencies, then invoke this Resolvable's function
     * and update the Resolvable's state
     */
    Resolvable.prototype.resolve = function (resolveContext, trans) {
      var _this = this;
      var $q = services.$q;
      // Gets all dependencies from ResolveContext and wait for them to be resolved
      var getResolvableDependencies = function getResolvableDependencies() {
        return $q.all(resolveContext.getDependencies(_this).map(function (resolvable) {
          return resolvable.get(resolveContext, trans);
        }));
      };
      // Invokes the resolve function passing the resolved dependencies as arguments
      var invokeResolveFn = function invokeResolveFn(resolvedDeps) {
        return _this.resolveFn.apply(null, resolvedDeps);
      };
      var node = resolveContext.findNode(this);
      var state = node && node.state;
      var asyncPolicy = this.getPolicy(state).async;
      var customAsyncPolicy = isFunction(asyncPolicy) ? asyncPolicy : identity;
      // After the final value has been resolved, update the state of the Resolvable
      var applyResolvedValue = function applyResolvedValue(resolvedValue) {
        _this.data = resolvedValue;
        _this.resolved = true;
        _this.resolveFn = null;
        trace.traceResolvableResolved(_this, trans);
        return _this.data;
      };
      // Sets the promise property first, then getsResolvableDependencies in the context of the promise chain. Always waits one tick.
      return this.promise = $q.when().then(getResolvableDependencies).then(invokeResolveFn).then(customAsyncPolicy).then(applyResolvedValue);
    };
    /**
     * Gets a promise for this Resolvable's data.
     *
     * Fetches the data and returns a promise.
     * Returns the existing promise if it has already been fetched once.
     */
    Resolvable.prototype.get = function (resolveContext, trans) {
      return this.promise || this.resolve(resolveContext, trans);
    };
    Resolvable.prototype.toString = function () {
      return "Resolvable(token: " + stringify(this.token) + ", requires: [" + this.deps.map(stringify) + "])";
    };
    Resolvable.prototype.clone = function () {
      return new Resolvable(this);
    };
    Resolvable.fromData = function (token, data) {
      return new Resolvable(token, function () {
        return data;
      }, null, null, data);
    };
    return Resolvable;
  }();
  var whens = resolvePolicies.when;
  var ALL_WHENS = [whens.EAGER, whens.LAZY];
  var EAGER_WHENS = [whens.EAGER];
  // tslint:disable-next-line:no-inferrable-types
  var NATIVE_INJECTOR_TOKEN = 'Native Injector';
  /**
   * Encapsulates Dependency Injection for a path of nodes
   *
   * UI-Router states are organized as a tree.
   * A nested state has a path of ancestors to the root of the tree.
   * When a state is being activated, each element in the path is wrapped as a [[PathNode]].
   * A `PathNode` is a stateful object that holds things like parameters and resolvables for the state being activated.
   *
   * The ResolveContext closes over the [[PathNode]]s, and provides DI for the last node in the path.
   */
  var ResolveContext = /** @class */function () {
    function ResolveContext(_path) {
      this._path = _path;
    }
    /** Gets all the tokens found in the resolve context, de-duplicated */
    ResolveContext.prototype.getTokens = function () {
      return this._path.reduce(function (acc, node) {
        return acc.concat(node.resolvables.map(function (r) {
          return r.token;
        }));
      }, []).reduce(uniqR, []);
    };
    /**
     * Gets the Resolvable that matches the token
     *
     * Gets the last Resolvable that matches the token in this context, or undefined.
     * Throws an error if it doesn't exist in the ResolveContext
     */
    ResolveContext.prototype.getResolvable = function (token) {
      var matching = this._path.map(function (node) {
        return node.resolvables;
      }).reduce(unnestR, []).filter(function (r) {
        return r.token === token;
      });
      return tail(matching);
    };
    /** Returns the [[ResolvePolicy]] for the given [[Resolvable]] */
    ResolveContext.prototype.getPolicy = function (resolvable) {
      var node = this.findNode(resolvable);
      return resolvable.getPolicy(node.state);
    };
    /**
     * Returns a ResolveContext that includes a portion of this one
     *
     * Given a state, this method creates a new ResolveContext from this one.
     * The new context starts at the first node (root) and stops at the node for the `state` parameter.
     *
     * #### Why
     *
     * When a transition is created, the nodes in the "To Path" are injected from a ResolveContext.
     * A ResolveContext closes over a path of [[PathNode]]s and processes the resolvables.
     * The "To State" can inject values from its own resolvables, as well as those from all its ancestor state's (node's).
     * This method is used to create a narrower context when injecting ancestor nodes.
     *
     * @example
     * `let ABCD = new ResolveContext([A, B, C, D]);`
     *
     * Given a path `[A, B, C, D]`, where `A`, `B`, `C` and `D` are nodes for states `a`, `b`, `c`, `d`:
     * When injecting `D`, `D` should have access to all resolvables from `A`, `B`, `C`, `D`.
     * However, `B` should only be able to access resolvables from `A`, `B`.
     *
     * When resolving for the `B` node, first take the full "To Path" Context `[A,B,C,D]` and limit to the subpath `[A,B]`.
     * `let AB = ABCD.subcontext(a)`
     */
    ResolveContext.prototype.subContext = function (state) {
      return new ResolveContext(PathUtils.subPath(this._path, function (node) {
        return node.state === state;
      }));
    };
    /**
     * Adds Resolvables to the node that matches the state
     *
     * This adds a [[Resolvable]] (generally one created on the fly; not declared on a [[StateDeclaration.resolve]] block).
     * The resolvable is added to the node matching the `state` parameter.
     *
     * These new resolvables are not automatically fetched.
     * The calling code should either fetch them, fetch something that depends on them,
     * or rely on [[resolvePath]] being called when some state is being entered.
     *
     * Note: each resolvable's [[ResolvePolicy]] is merged with the state's policy, and the global default.
     *
     * @param newResolvables the new Resolvables
     * @param state Used to find the node to put the resolvable on
     */
    ResolveContext.prototype.addResolvables = function (newResolvables, state) {
      var node = find(this._path, propEq('state', state));
      var keys = newResolvables.map(function (r) {
        return r.token;
      });
      node.resolvables = node.resolvables.filter(function (r) {
        return keys.indexOf(r.token) === -1;
      }).concat(newResolvables);
    };
    /**
     * Returns a promise for an array of resolved path Element promises
     *
     * @param when
     * @param trans
     * @returns {Promise<any>|any}
     */
    ResolveContext.prototype.resolvePath = function (when, trans) {
      var _this = this;
      if (when === void 0) {
        when = 'LAZY';
      }
      // This option determines which 'when' policy Resolvables we are about to fetch.
      var whenOption = inArray(ALL_WHENS, when) ? when : 'LAZY';
      // If the caller specified EAGER, only the EAGER Resolvables are fetched.
      // if the caller specified LAZY, both EAGER and LAZY Resolvables are fetched.`
      var matchedWhens = whenOption === resolvePolicies.when.EAGER ? EAGER_WHENS : ALL_WHENS;
      // get the subpath to the state argument, if provided
      trace.traceResolvePath(this._path, when, trans);
      var matchesPolicy = function matchesPolicy(acceptedVals, whenOrAsync) {
        return function (resolvable) {
          return inArray(acceptedVals, _this.getPolicy(resolvable)[whenOrAsync]);
        };
      };
      // Trigger all the (matching) Resolvables in the path
      // Reduce all the "WAIT" Resolvables into an array
      var promises = this._path.reduce(function (acc, node) {
        var nodeResolvables = node.resolvables.filter(matchesPolicy(matchedWhens, 'when'));
        var nowait = nodeResolvables.filter(matchesPolicy(['NOWAIT'], 'async'));
        var wait = nodeResolvables.filter(not(matchesPolicy(['NOWAIT'], 'async')));
        // For the matching Resolvables, start their async fetch process.
        var subContext = _this.subContext(node.state);
        var getResult = function getResult(r) {
          return r.get(subContext, trans)
          // Return a tuple that includes the Resolvable's token
          .then(function (value) {
            return {
              token: r.token,
              value: value
            };
          });
        };
        nowait.forEach(getResult);
        return acc.concat(wait.map(getResult));
      }, []);
      // Wait for all the "WAIT" resolvables
      return services.$q.all(promises);
    };
    ResolveContext.prototype.injector = function () {
      return this._injector || (this._injector = new UIInjectorImpl(this));
    };
    ResolveContext.prototype.findNode = function (resolvable) {
      return find(this._path, function (node) {
        return inArray(node.resolvables, resolvable);
      });
    };
    /**
     * Gets the async dependencies of a Resolvable
     *
     * Given a Resolvable, returns its dependencies as a Resolvable[]
     */
    ResolveContext.prototype.getDependencies = function (resolvable) {
      var _this = this;
      var node = this.findNode(resolvable);
      // Find which other resolvables are "visible" to the `resolvable` argument
      // subpath stopping at resolvable's node, or the whole path (if the resolvable isn't in the path)
      var subPath = PathUtils.subPath(this._path, function (x) {
        return x === node;
      }) || this._path;
      var availableResolvables = subPath.reduce(function (acc, _node) {
        return acc.concat(_node.resolvables);
      }, []) // all of subpath's resolvables
      .filter(function (res) {
        return res !== resolvable;
      }); // filter out the `resolvable` argument
      var getDependency = function getDependency(token) {
        var matching = availableResolvables.filter(function (r) {
          return r.token === token;
        });
        if (matching.length) return tail(matching);
        var fromInjector = _this.injector().getNative(token);
        if (isUndefined(fromInjector)) {
          throw new Error('Could not find Dependency Injection token: ' + stringify(token));
        }
        return new Resolvable(token, function () {
          return fromInjector;
        }, [], fromInjector);
      };
      return resolvable.deps.map(getDependency);
    };
    return ResolveContext;
  }();
  /** @internal */
  var UIInjectorImpl = /** @class */function () {
    function UIInjectorImpl(context) {
      this.context = context;
      this["native"] = this.get(NATIVE_INJECTOR_TOKEN) || services.$injector;
    }
    UIInjectorImpl.prototype.get = function (token) {
      var resolvable = this.context.getResolvable(token);
      if (resolvable) {
        if (this.context.getPolicy(resolvable).async === 'NOWAIT') {
          return resolvable.get(this.context);
        }
        if (!resolvable.resolved) {
          throw new Error('Resolvable async .get() not complete:' + stringify(resolvable.token));
        }
        return resolvable.data;
      }
      return this.getNative(token);
    };
    UIInjectorImpl.prototype.getAsync = function (token) {
      var resolvable = this.context.getResolvable(token);
      if (resolvable) return resolvable.get(this.context);
      return services.$q.when(this["native"].get(token));
    };
    UIInjectorImpl.prototype.getNative = function (token) {
      return this["native"] && this["native"].get(token);
    };
    return UIInjectorImpl;
  }();
  var parseUrl = function parseUrl(url) {
    if (!isString(url)) return false;
    var root = url.charAt(0) === '^';
    return {
      val: root ? url.substring(1) : url,
      root: root
    };
  };
  function nameBuilder(state) {
    return state.name;
  }
  function selfBuilder(state) {
    state.self.$$state = function () {
      return state;
    };
    return state.self;
  }
  function dataBuilder(state) {
    if (state.parent && state.parent.data) {
      state.data = state.self.data = inherit(state.parent.data, state.data);
    }
    return state.data;
  }
  var getUrlBuilder = function getUrlBuilder($urlMatcherFactoryProvider, root) {
    return function urlBuilder(stateObject) {
      var stateDec = stateObject.self;
      // For future states, i.e., states whose name ends with `.**`,
      // match anything that starts with the url prefix
      if (stateDec && stateDec.url && stateDec.name && stateDec.name.match(/\.\*\*$/)) {
        var newStateDec = {};
        copy(stateDec, newStateDec);
        newStateDec.url += '{remainder:any}'; // match any path (.*)
        stateDec = newStateDec;
      }
      var parent = stateObject.parent;
      var parsed = parseUrl(stateDec.url);
      var url = !parsed ? stateDec.url : $urlMatcherFactoryProvider.compile(parsed.val, {
        state: stateDec
      });
      if (!url) return null;
      if (!$urlMatcherFactoryProvider.isMatcher(url)) throw new Error("Invalid url '" + url + "' in state '" + stateObject + "'");
      return parsed && parsed.root ? url : (parent && parent.navigable || root()).url.append(url);
    };
  };
  var getNavigableBuilder = function getNavigableBuilder(isRoot) {
    return function navigableBuilder(state) {
      return !isRoot(state) && state.url ? state : state.parent ? state.parent.navigable : null;
    };
  };
  var getParamsBuilder = function getParamsBuilder(paramFactory) {
    return function paramsBuilder(state) {
      var makeConfigParam = function makeConfigParam(config, id) {
        return paramFactory.fromConfig(id, null, state.self);
      };
      var urlParams = state.url && state.url.parameters({
        inherit: false
      }) || [];
      var nonUrlParams = values(mapObj(omit(state.params || {}, urlParams.map(prop('id'))), makeConfigParam));
      return urlParams.concat(nonUrlParams).map(function (p) {
        return [p.id, p];
      }).reduce(applyPairs, {});
    };
  };
  function pathBuilder(state) {
    return state.parent ? state.parent.path.concat(state) : /*root*/[state];
  }
  function includesBuilder(state) {
    var includes = state.parent ? extend({}, state.parent.includes) : {};
    includes[state.name] = true;
    return includes;
  }
  /**
   * This is a [[StateBuilder.builder]] function for the `resolve:` block on a [[StateDeclaration]].
   *
   * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
   * validates the `resolve` property and converts it to a [[Resolvable]] array.
   *
   * resolve: input value can be:
   *
   * {
   *   // analyzed but not injected
   *   myFooResolve: function() { return "myFooData"; },
   *
   *   // function.toString() parsed, "DependencyName" dep as string (not min-safe)
   *   myBarResolve: function(DependencyName) { return DependencyName.fetchSomethingAsPromise() },
   *
   *   // Array split; "DependencyName" dep as string
   *   myBazResolve: [ "DependencyName", function(dep) { return dep.fetchSomethingAsPromise() },
   *
   *   // Array split; DependencyType dep as token (compared using ===)
   *   myQuxResolve: [ DependencyType, function(dep) { return dep.fetchSometingAsPromise() },
   *
   *   // val.$inject used as deps
   *   // where:
   *   //     corgeResolve.$inject = ["DependencyName"];
   *   //     function corgeResolve(dep) { dep.fetchSometingAsPromise() }
   *   // then "DependencyName" dep as string
   *   myCorgeResolve: corgeResolve,
   *
   *  // inject service by name
   *  // When a string is found, desugar creating a resolve that injects the named service
   *   myGraultResolve: "SomeService"
   * }
   *
   * or:
   *
   * [
   *   new Resolvable("myFooResolve", function() { return "myFooData" }),
   *   new Resolvable("myBarResolve", function(dep) { return dep.fetchSomethingAsPromise() }, [ "DependencyName" ]),
   *   { provide: "myBazResolve", useFactory: function(dep) { dep.fetchSomethingAsPromise() }, deps: [ "DependencyName" ] }
   * ]
   */
  function resolvablesBuilder(state) {
    /** convert resolve: {} and resolvePolicy: {} objects to an array of tuples */
    var objects2Tuples = function objects2Tuples(resolveObj, resolvePolicies) {
      return Object.keys(resolveObj || {}).map(function (token) {
        return {
          token: token,
          val: resolveObj[token],
          deps: undefined,
          policy: resolvePolicies[token]
        };
      });
    };
    /** fetch DI annotations from a function or ng1-style array */
    var annotate = function annotate(fn) {
      var $injector = services.$injector;
      // ng1 doesn't have an $injector until runtime.
      // If the $injector doesn't exist, use "deferred" literal as a
      // marker indicating they should be annotated when runtime starts
      return fn['$inject'] || $injector && $injector.annotate(fn, $injector.strictDi) || 'deferred';
    };
    /** true if the object has both `token` and `resolveFn`, and is probably a [[ResolveLiteral]] */
    var isResolveLiteral = function isResolveLiteral(obj) {
      return !!(obj.token && obj.resolveFn);
    };
    /** true if the object looks like a provide literal, or a ng2 Provider */
    var isLikeNg2Provider = function isLikeNg2Provider(obj) {
      return !!((obj.provide || obj.token) && (obj.useValue || obj.useFactory || obj.useExisting || obj.useClass));
    };
    /** true if the object looks like a tuple from obj2Tuples */
    var isTupleFromObj = function isTupleFromObj(obj) {
      return !!(obj && obj.val && (isString(obj.val) || isArray(obj.val) || isFunction(obj.val)));
    };
    /** extracts the token from a Provider or provide literal */
    var getToken = function getToken(p) {
      return p.provide || p.token;
    };
    // prettier-ignore: Given a literal resolve or provider object, returns a Resolvable
    var literal2Resolvable = pattern([[prop('resolveFn'), function (p) {
      return new Resolvable(getToken(p), p.resolveFn, p.deps, p.policy);
    }], [prop('useFactory'), function (p) {
      return new Resolvable(getToken(p), p.useFactory, p.deps || p.dependencies, p.policy);
    }], [prop('useClass'), function (p) {
      return new Resolvable(getToken(p), function () {
        return new p.useClass();
      }, [], p.policy);
    }], [prop('useValue'), function (p) {
      return new Resolvable(getToken(p), function () {
        return p.useValue;
      }, [], p.policy, p.useValue);
    }], [prop('useExisting'), function (p) {
      return new Resolvable(getToken(p), identity, [p.useExisting], p.policy);
    }]]);
    // prettier-ignore
    var tuple2Resolvable = pattern([[pipe(prop('val'), isString), function (tuple) {
      return new Resolvable(tuple.token, identity, [tuple.val], tuple.policy);
    }], [pipe(prop('val'), isArray), function (tuple) {
      return new Resolvable(tuple.token, tail(tuple.val), tuple.val.slice(0, -1), tuple.policy);
    }], [pipe(prop('val'), isFunction), function (tuple) {
      return new Resolvable(tuple.token, tuple.val, annotate(tuple.val), tuple.policy);
    }]]);
    // prettier-ignore
    var item2Resolvable = pattern([[is(Resolvable), function (r) {
      return r;
    }], [isResolveLiteral, literal2Resolvable], [isLikeNg2Provider, literal2Resolvable], [isTupleFromObj, tuple2Resolvable], [val(true), function (obj) {
      throw new Error('Invalid resolve value: ' + stringify(obj));
    }]]);
    // If resolveBlock is already an array, use it as-is.
    // Otherwise, assume it's an object and convert to an Array of tuples
    var decl = state.resolve;
    var items = isArray(decl) ? decl : objects2Tuples(decl, state.resolvePolicy || {});
    return items.map(item2Resolvable);
  }
  /**
   * A internal global service
   *
   * StateBuilder is a factory for the internal [[StateObject]] objects.
   *
   * When you register a state with the [[StateRegistry]], you register a plain old javascript object which
   * conforms to the [[StateDeclaration]] interface.  This factory takes that object and builds the corresponding
   * [[StateObject]] object, which has an API and is used internally.
   *
   * Custom properties or API may be added to the internal [[StateObject]] object by registering a decorator function
   * using the [[builder]] method.
   */
  var StateBuilder = /** @class */function () {
    function StateBuilder(matcher, urlMatcherFactory) {
      this.matcher = matcher;
      var self = this;
      var root = function root() {
        return matcher.find('');
      };
      var isRoot = function isRoot(state) {
        return state.name === '';
      };
      function parentBuilder(state) {
        if (isRoot(state)) return null;
        return matcher.find(self.parentName(state)) || root();
      }
      this.builders = {
        name: [nameBuilder],
        self: [selfBuilder],
        parent: [parentBuilder],
        data: [dataBuilder],
        // Build a URLMatcher if necessary, either via a relative or absolute URL
        url: [getUrlBuilder(urlMatcherFactory, root)],
        // Keep track of the closest ancestor state that has a URL (i.e. is navigable)
        navigable: [getNavigableBuilder(isRoot)],
        params: [getParamsBuilder(urlMatcherFactory.paramFactory)],
        // Each framework-specific ui-router implementation should define its own `views` builder
        // e.g., src/ng1/statebuilders/views.ts
        views: [],
        // Keep a full path from the root down to this state as this is needed for state activation.
        path: [pathBuilder],
        // Speed up $state.includes() as it's used a lot
        includes: [includesBuilder],
        resolvables: [resolvablesBuilder]
      };
    }
    StateBuilder.prototype.builder = function (name, fn) {
      var builders = this.builders;
      var array = builders[name] || [];
      // Backwards compat: if only one builder exists, return it, else return whole arary.
      if (isString(name) && !isDefined(fn)) return array.length > 1 ? array : array[0];
      if (!isString(name) || !isFunction(fn)) return;
      builders[name] = array;
      builders[name].push(fn);
      return function () {
        return builders[name].splice(builders[name].indexOf(fn, 1)) && null;
      };
    };
    /**
     * Builds all of the properties on an essentially blank State object, returning a State object which has all its
     * properties and API built.
     *
     * @param state an uninitialized State object
     * @returns the built State object
     */
    StateBuilder.prototype.build = function (state) {
      var _a = this,
        matcher = _a.matcher,
        builders = _a.builders;
      var parent = this.parentName(state);
      if (parent && !matcher.find(parent, undefined, false)) {
        return null;
      }
      for (var key in builders) {
        if (!builders.hasOwnProperty(key)) continue;
        var chain = builders[key].reduce(function (parentFn, step) {
          return function (_state) {
            return step(_state, parentFn);
          };
        }, noop);
        state[key] = chain(state);
      }
      return state;
    };
    StateBuilder.prototype.parentName = function (state) {
      // name = 'foo.bar.baz.**'
      var name = state.name || '';
      // segments = ['foo', 'bar', 'baz', '.**']
      var segments = name.split('.');
      // segments = ['foo', 'bar', 'baz']
      var lastSegment = segments.pop();
      // segments = ['foo', 'bar'] (ignore .** segment for future states)
      if (lastSegment === '**') segments.pop();
      if (segments.length) {
        if (state.parent) {
          throw new Error("States that specify the 'parent:' property should not have a '.' in their name (" + name + ")");
        }
        // 'foo.bar'
        return segments.join('.');
      }
      if (!state.parent) return '';
      return isString(state.parent) ? state.parent : state.parent.name;
    };
    StateBuilder.prototype.name = function (state) {
      var name = state.name;
      if (name.indexOf('.') !== -1 || !state.parent) return name;
      var parentName = isString(state.parent) ? state.parent : state.parent.name;
      return parentName ? parentName + '.' + name : name;
    };
    return StateBuilder;
  }();

  /**
   * Internal representation of a UI-Router state.
   *
   * Instances of this class are created when a [[StateDeclaration]] is registered with the [[StateRegistry]].
   *
   * A registered [[StateDeclaration]] is augmented with a getter ([[StateDeclaration.$$state]]) which returns the corresponding [[StateObject]] object.
   *
   * This class prototypally inherits from the corresponding [[StateDeclaration]].
   * Each of its own properties (i.e., `hasOwnProperty`) are built using builders from the [[StateBuilder]].
   */
  var StateObject = /** @class */function () {
    /** @deprecated use State.create() */
    function StateObject(config) {
      return StateObject.create(config || {});
    }
    /**
     * Create a state object to put the private/internal implementation details onto.
     * The object's prototype chain looks like:
     * (Internal State Object) -> (Copy of State.prototype) -> (State Declaration object) -> (State Declaration's prototype...)
     *
     * @param stateDecl the user-supplied State Declaration
     * @returns {StateObject} an internal State object
     */
    StateObject.create = function (stateDecl) {
      stateDecl = StateObject.isStateClass(stateDecl) ? new stateDecl() : stateDecl;
      var state = inherit(inherit(stateDecl, StateObject.prototype));
      stateDecl.$$state = function () {
        return state;
      };
      state.self = stateDecl;
      state.__stateObjectCache = {
        nameGlob: Glob.fromString(state.name)
      };
      return state;
    };
    /**
     * Returns true if the provided parameter is the same state.
     *
     * Compares the identity of the state against the passed value, which is either an object
     * reference to the actual `State` instance, the original definition object passed to
     * `$stateProvider.state()`, or the fully-qualified name.
     *
     * @param ref Can be one of (a) a `State` instance, (b) an object that was passed
     *        into `$stateProvider.state()`, (c) the fully-qualified name of a state as a string.
     * @returns Returns `true` if `ref` matches the current `State` instance.
     */
    StateObject.prototype.is = function (ref) {
      return this === ref || this.self === ref || this.fqn() === ref;
    };
    /**
     * @deprecated this does not properly handle dot notation
     * @returns Returns a dot-separated name of the state.
     */
    StateObject.prototype.fqn = function () {
      if (!this.parent || !(this.parent instanceof this.constructor)) return this.name;
      var name = this.parent.fqn();
      return name ? name + '.' + this.name : this.name;
    };
    /**
     * Returns the root node of this state's tree.
     *
     * @returns The root of this state's tree.
     */
    StateObject.prototype.root = function () {
      return this.parent && this.parent.root() || this;
    };
    /**
     * Gets the state's `Param` objects
     *
     * Gets the list of [[Param]] objects owned by the state.
     * If `opts.inherit` is true, it also includes the ancestor states' [[Param]] objects.
     * If `opts.matchingKeys` exists, returns only `Param`s whose `id` is a key on the `matchingKeys` object
     *
     * @param opts options
     */
    StateObject.prototype.parameters = function (opts) {
      opts = defaults(opts, {
        inherit: true,
        matchingKeys: null
      });
      var inherited = opts.inherit && this.parent && this.parent.parameters() || [];
      return inherited.concat(values(this.params)).filter(function (param) {
        return !opts.matchingKeys || opts.matchingKeys.hasOwnProperty(param.id);
      });
    };
    /**
     * Returns a single [[Param]] that is owned by the state
     *
     * If `opts.inherit` is true, it also searches the ancestor states` [[Param]]s.
     * @param id the name of the [[Param]] to return
     * @param opts options
     */
    StateObject.prototype.parameter = function (id, opts) {
      if (opts === void 0) {
        opts = {};
      }
      return this.url && this.url.parameter(id, opts) || find(values(this.params), propEq('id', id)) || opts.inherit && this.parent && this.parent.parameter(id);
    };
    StateObject.prototype.toString = function () {
      return this.fqn();
    };
    /** Predicate which returns true if the object is an class with @State() decorator */
    StateObject.isStateClass = function (stateDecl) {
      return isFunction(stateDecl) && stateDecl['__uiRouterState'] === true;
    };
    /** Predicate which returns true if the object is a [[StateDeclaration]] object */
    StateObject.isStateDeclaration = function (obj) {
      return isFunction(obj['$$state']);
    };
    /** Predicate which returns true if the object is an internal [[StateObject]] object */
    StateObject.isState = function (obj) {
      return isObject(obj['__stateObjectCache']);
    };
    return StateObject;
  }();
  var StateMatcher = /** @class */function () {
    function StateMatcher(_states) {
      this._states = _states;
    }
    StateMatcher.prototype.isRelative = function (stateName) {
      stateName = stateName || '';
      return stateName.indexOf('.') === 0 || stateName.indexOf('^') === 0;
    };
    StateMatcher.prototype.find = function (stateOrName, base, matchGlob) {
      if (matchGlob === void 0) {
        matchGlob = true;
      }
      if (!stateOrName && stateOrName !== '') return undefined;
      var isStr = isString(stateOrName);
      var name = isStr ? stateOrName : stateOrName.name;
      if (this.isRelative(name)) name = this.resolvePath(name, base);
      var state = this._states[name];
      if (state && (isStr || !isStr && (state === stateOrName || state.self === stateOrName))) {
        return state;
      } else if (isStr && matchGlob) {
        var _states = values(this._states);
        var matches = _states.filter(function (_state) {
          return _state.__stateObjectCache.nameGlob && _state.__stateObjectCache.nameGlob.matches(name);
        });
        if (matches.length > 1) {
          safeConsole.error("stateMatcher.find: Found multiple matches for " + name + " using glob: ", matches.map(function (match) {
            return match.name;
          }));
        }
        return matches[0];
      }
      return undefined;
    };
    StateMatcher.prototype.resolvePath = function (name, base) {
      if (!base) throw new Error("No reference point given for path '" + name + "'");
      var baseState = this.find(base);
      var splitName = name.split('.');
      var pathLength = splitName.length;
      var i = 0,
        current = baseState;
      for (; i < pathLength; i++) {
        if (splitName[i] === '' && i === 0) {
          current = baseState;
          continue;
        }
        if (splitName[i] === '^') {
          if (!current.parent) throw new Error("Path '" + name + "' not valid for state '" + baseState.name + "'");
          current = current.parent;
          continue;
        }
        break;
      }
      var relName = splitName.slice(i).join('.');
      return current.name + (current.name && relName ? '.' : '') + relName;
    };
    return StateMatcher;
  }();
  var StateQueueManager = /** @class */function () {
    function StateQueueManager(router, states, builder, listeners) {
      this.router = router;
      this.states = states;
      this.builder = builder;
      this.listeners = listeners;
      this.queue = [];
    }
    StateQueueManager.prototype.dispose = function () {
      this.queue = [];
    };
    StateQueueManager.prototype.register = function (stateDecl) {
      var queue = this.queue;
      var state = StateObject.create(stateDecl);
      var name = state.name;
      if (!isString(name)) throw new Error('State must have a valid name');
      if (this.states.hasOwnProperty(name) || inArray(queue.map(prop('name')), name)) throw new Error("State '" + name + "' is already defined");
      queue.push(state);
      this.flush();
      return state;
    };
    StateQueueManager.prototype.flush = function () {
      var _this = this;
      var _a = this,
        queue = _a.queue,
        states = _a.states,
        builder = _a.builder;
      var registered = [],
        // states that got registered
        orphans = [],
        // states that don't yet have a parent registered
        previousQueueLength = {}; // keep track of how long the queue when an orphan was first encountered
      var getState = function getState(name) {
        return _this.states.hasOwnProperty(name) && _this.states[name];
      };
      var notifyListeners = function notifyListeners() {
        if (registered.length) {
          _this.listeners.forEach(function (listener) {
            return listener('registered', registered.map(function (s) {
              return s.self;
            }));
          });
        }
      };
      while (queue.length > 0) {
        var state = queue.shift();
        var name_1 = state.name;
        var result = builder.build(state);
        var orphanIdx = orphans.indexOf(state);
        if (result) {
          var existingState = getState(name_1);
          if (existingState && existingState.name === name_1) {
            throw new Error("State '" + name_1 + "' is already defined");
          }
          var existingFutureState = getState(name_1 + '.**');
          if (existingFutureState) {
            // Remove future state of the same name
            this.router.stateRegistry.deregister(existingFutureState);
          }
          states[name_1] = state;
          this.attachRoute(state);
          if (orphanIdx >= 0) orphans.splice(orphanIdx, 1);
          registered.push(state);
          continue;
        }
        var prev = previousQueueLength[name_1];
        previousQueueLength[name_1] = queue.length;
        if (orphanIdx >= 0 && prev === queue.length) {
          // Wait until two consecutive iterations where no additional states were dequeued successfully.
          // throw new Error(`Cannot register orphaned state '${name}'`);
          queue.push(state);
          notifyListeners();
          return states;
        } else if (orphanIdx < 0) {
          orphans.push(state);
        }
        queue.push(state);
      }
      notifyListeners();
      return states;
    };
    StateQueueManager.prototype.attachRoute = function (state) {
      if (state["abstract"] || !state.url) return;
      var rulesApi = this.router.urlService.rules;
      rulesApi.rule(rulesApi.urlRuleFactory.create(state));
    };
    return StateQueueManager;
  }();

  /**
   * A registry for all of the application's [[StateDeclaration]]s
   *
   * This API is found at `router.stateRegistry` ([[UIRouter.stateRegistry]])
   */
  var StateRegistry = /** @class */function () {
    /** @internal */
    function StateRegistry(router) {
      this.router = router;
      this.states = {};
      /** @internal */
      this.listeners = [];
      this.matcher = new StateMatcher(this.states);
      this.builder = new StateBuilder(this.matcher, router.urlMatcherFactory);
      this.stateQueue = new StateQueueManager(router, this.states, this.builder, this.listeners);
      this._registerRoot();
    }
    /** @internal */
    StateRegistry.prototype._registerRoot = function () {
      var rootStateDef = {
        name: '',
        url: '^',
        views: null,
        params: {
          '#': {
            value: null,
            type: 'hash',
            dynamic: true
          }
        },
        "abstract": true
      };
      var _root = this._root = this.stateQueue.register(rootStateDef);
      _root.navigable = null;
    };
    /** @internal */
    StateRegistry.prototype.dispose = function () {
      var _this = this;
      this.stateQueue.dispose();
      this.listeners = [];
      this.get().forEach(function (state) {
        return _this.get(state) && _this.deregister(state);
      });
    };
    /**
     * Listen for a State Registry events
     *
     * Adds a callback that is invoked when states are registered or deregistered with the StateRegistry.
     *
     * #### Example:
     * ```js
     * let allStates = registry.get();
     *
     * // Later, invoke deregisterFn() to remove the listener
     * let deregisterFn = registry.onStatesChanged((event, states) => {
     *   switch(event) {
     *     case: 'registered':
     *       states.forEach(state => allStates.push(state));
     *       break;
     *     case: 'deregistered':
     *       states.forEach(state => {
     *         let idx = allStates.indexOf(state);
     *         if (idx !== -1) allStates.splice(idx, 1);
     *       });
     *       break;
     *   }
     * });
     * ```
     *
     * @param listener a callback function invoked when the registered states changes.
     *        The function receives two parameters, `event` and `state`.
     *        See [[StateRegistryListener]]
     * @return a function that deregisters the listener
     */
    StateRegistry.prototype.onStatesChanged = function (listener) {
      this.listeners.push(listener);
      return function deregisterListener() {
        removeFrom(this.listeners)(listener);
      }.bind(this);
    };
    /**
     * Gets the implicit root state
     *
     * Gets the root of the state tree.
     * The root state is implicitly created by UI-Router.
     * Note: this returns the internal [[StateObject]] representation, not a [[StateDeclaration]]
     *
     * @return the root [[StateObject]]
     */
    StateRegistry.prototype.root = function () {
      return this._root;
    };
    /**
     * Adds a state to the registry
     *
     * Registers a [[StateDeclaration]] or queues it for registration.
     *
     * Note: a state will be queued if the state's parent isn't yet registered.
     *
     * @param stateDefinition the definition of the state to register.
     * @returns the internal [[StateObject]] object.
     *          If the state was successfully registered, then the object is fully built (See: [[StateBuilder]]).
     *          If the state was only queued, then the object is not fully built.
     */
    StateRegistry.prototype.register = function (stateDefinition) {
      return this.stateQueue.register(stateDefinition);
    };
    /** @internal */
    StateRegistry.prototype._deregisterTree = function (state) {
      var _this = this;
      var all = this.get().map(function (s) {
        return s.$$state();
      });
      var _getChildren = function getChildren(states) {
        var _children = all.filter(function (s) {
          return states.indexOf(s.parent) !== -1;
        });
        return _children.length === 0 ? _children : _children.concat(_getChildren(_children));
      };
      var children = _getChildren([state]);
      var deregistered = [state].concat(children).reverse();
      deregistered.forEach(function (_state) {
        var rulesApi = _this.router.urlService.rules;
        // Remove URL rule
        rulesApi.rules().filter(propEq('state', _state)).forEach(function (rule) {
          return rulesApi.removeRule(rule);
        });
        // Remove state from registry
        delete _this.states[_state.name];
      });
      return deregistered;
    };
    /**
     * Removes a state from the registry
     *
     * This removes a state from the registry.
     * If the state has children, they are are also removed from the registry.
     *
     * @param stateOrName the state's name or object representation
     * @returns {StateObject[]} a list of removed states
     */
    StateRegistry.prototype.deregister = function (stateOrName) {
      var _state = this.get(stateOrName);
      if (!_state) throw new Error("Can't deregister state; not found: " + stateOrName);
      var deregisteredStates = this._deregisterTree(_state.$$state());
      this.listeners.forEach(function (listener) {
        return listener('deregistered', deregisteredStates.map(function (s) {
          return s.self;
        }));
      });
      return deregisteredStates;
    };
    StateRegistry.prototype.get = function (stateOrName, base) {
      var _this = this;
      if (arguments.length === 0) return Object.keys(this.states).map(function (name) {
        return _this.states[name].self;
      });
      var found = this.matcher.find(stateOrName, base);
      return found && found.self || null;
    };
    /**
     * Registers a [[BuilderFunction]] for a specific [[StateObject]] property (e.g., `parent`, `url`, or `path`).
     * More than one BuilderFunction can be registered for a given property.
     *
     * The BuilderFunction(s) will be used to define the property on any subsequently built [[StateObject]] objects.
     *
     * @param property The name of the State property being registered for.
     * @param builderFunction The BuilderFunction which will be used to build the State property
     * @returns a function which deregisters the BuilderFunction
     */
    StateRegistry.prototype.decorator = function (property, builderFunction) {
      return this.builder.builder(property, builderFunction);
    };
    return StateRegistry;
  }();
  (function (TransitionHookPhase) {
    TransitionHookPhase[TransitionHookPhase["CREATE"] = 0] = "CREATE";
    TransitionHookPhase[TransitionHookPhase["BEFORE"] = 1] = "BEFORE";
    TransitionHookPhase[TransitionHookPhase["RUN"] = 2] = "RUN";
    TransitionHookPhase[TransitionHookPhase["SUCCESS"] = 3] = "SUCCESS";
    TransitionHookPhase[TransitionHookPhase["ERROR"] = 4] = "ERROR";
  })(exports.TransitionHookPhase || (exports.TransitionHookPhase = {}));
  (function (TransitionHookScope) {
    TransitionHookScope[TransitionHookScope["TRANSITION"] = 0] = "TRANSITION";
    TransitionHookScope[TransitionHookScope["STATE"] = 1] = "STATE";
  })(exports.TransitionHookScope || (exports.TransitionHookScope = {}));
  var defaultOptions = {
    current: noop,
    transition: null,
    traceData: {},
    bind: null
  };
  var TransitionHook = /** @class */function () {
    function TransitionHook(transition, stateContext, registeredHook, options) {
      var _this = this;
      this.transition = transition;
      this.stateContext = stateContext;
      this.registeredHook = registeredHook;
      this.options = options;
      this.isSuperseded = function () {
        return _this.type.hookPhase === exports.TransitionHookPhase.RUN && !_this.options.transition.isActive();
      };
      this.options = defaults(options, defaultOptions);
      this.type = registeredHook.eventType;
    }
    /**
     * Chains together an array of TransitionHooks.
     *
     * Given a list of [[TransitionHook]] objects, chains them together.
     * Each hook is invoked after the previous one completes.
     *
     * #### Example:
     * ```js
     * var hooks: TransitionHook[] = getHooks();
     * let promise: Promise<any> = TransitionHook.chain(hooks);
     *
     * promise.then(handleSuccess, handleError);
     * ```
     *
     * @param hooks the list of hooks to chain together
     * @param waitFor if provided, the chain is `.then()`'ed off this promise
     * @returns a `Promise` for sequentially invoking the hooks (in order)
     */
    TransitionHook.chain = function (hooks, waitFor) {
      // Chain the next hook off the previous
      var createHookChainR = function createHookChainR(prev, nextHook) {
        return prev.then(function () {
          return nextHook.invokeHook();
        });
      };
      return hooks.reduce(createHookChainR, waitFor || services.$q.when());
    };
    /**
     * Invokes all the provided TransitionHooks, in order.
     * Each hook's return value is checked.
     * If any hook returns a promise, then the rest of the hooks are chained off that promise, and the promise is returned.
     * If no hook returns a promise, then all hooks are processed synchronously.
     *
     * @param hooks the list of TransitionHooks to invoke
     * @param doneCallback a callback that is invoked after all the hooks have successfully completed
     *
     * @returns a promise for the async result, or the result of the callback
     */
    TransitionHook.invokeHooks = function (hooks, doneCallback) {
      for (var idx = 0; idx < hooks.length; idx++) {
        var hookResult = hooks[idx].invokeHook();
        if (isPromise(hookResult)) {
          var remainingHooks = hooks.slice(idx + 1);
          return TransitionHook.chain(remainingHooks, hookResult).then(doneCallback);
        }
      }
      return doneCallback();
    };
    /**
     * Run all TransitionHooks, ignoring their return value.
     */
    TransitionHook.runAllHooks = function (hooks) {
      hooks.forEach(function (hook) {
        return hook.invokeHook();
      });
    };
    TransitionHook.prototype.logError = function (err) {
      this.transition.router.stateService.defaultErrorHandler()(err);
    };
    TransitionHook.prototype.invokeHook = function () {
      var _this = this;
      var hook = this.registeredHook;
      if (hook._deregistered) return;
      var notCurrent = this.getNotCurrentRejection();
      if (notCurrent) return notCurrent;
      var options = this.options;
      trace.traceHookInvocation(this, this.transition, options);
      var invokeCallback = function invokeCallback() {
        return hook.callback.call(options.bind, _this.transition, _this.stateContext);
      };
      var normalizeErr = function normalizeErr(err) {
        return Rejection.normalize(err).toPromise();
      };
      var handleError = function handleError(err) {
        return hook.eventType.getErrorHandler(_this)(err);
      };
      var handleResult = function handleResult(result) {
        return hook.eventType.getResultHandler(_this)(result);
      };
      try {
        var result = invokeCallback();
        if (!this.type.synchronous && isPromise(result)) {
          return result["catch"](normalizeErr).then(handleResult, handleError);
        } else {
          return handleResult(result);
        }
      } catch (err) {
        // If callback throws (synchronously)
        return handleError(Rejection.normalize(err));
      } finally {
        if (hook.invokeLimit && ++hook.invokeCount >= hook.invokeLimit) {
          hook.deregister();
        }
      }
    };
    /**
     * This method handles the return value of a Transition Hook.
     *
     * A hook can return false (cancel), a TargetState (redirect),
     * or a promise (which may later resolve to false or a redirect)
     *
     * This also handles "transition superseded" -- when a new transition
     * was started while the hook was still running
     */
    TransitionHook.prototype.handleHookResult = function (result) {
      var _this = this;
      var notCurrent = this.getNotCurrentRejection();
      if (notCurrent) return notCurrent;
      // Hook returned a promise
      if (isPromise(result)) {
        // Wait for the promise, then reprocess with the resulting value
        return result.then(function (val) {
          return _this.handleHookResult(val);
        });
      }
      trace.traceHookResult(result, this.transition, this.options);
      // Hook returned false
      if (result === false) {
        // Abort this Transition
        return Rejection.aborted('Hook aborted transition').toPromise();
      }
      var isTargetState = is(TargetState);
      // hook returned a TargetState
      if (isTargetState(result)) {
        // Halt the current Transition and redirect (a new Transition) to the TargetState.
        return Rejection.redirected(result).toPromise();
      }
    };
    /**
     * Return a Rejection promise if the transition is no longer current due
     * to a stopped router (disposed), or a new transition has started and superseded this one.
     */
    TransitionHook.prototype.getNotCurrentRejection = function () {
      var router = this.transition.router;
      // The router is stopped
      if (router._disposed) {
        return Rejection.aborted("UIRouter instance #" + router.$id + " has been stopped (disposed)").toPromise();
      }
      if (this.transition._aborted) {
        return Rejection.aborted().toPromise();
      }
      // This transition is no longer current.
      // Another transition started while this hook was still running.
      if (this.isSuperseded()) {
        // Abort this transition
        return Rejection.superseded(this.options.current()).toPromise();
      }
    };
    TransitionHook.prototype.toString = function () {
      var _a = this,
        options = _a.options,
        registeredHook = _a.registeredHook;
      var event = parse('traceData.hookType')(options) || 'internal',
        context = parse('traceData.context.state.name')(options) || parse('traceData.context')(options) || 'unknown',
        name = fnToString(registeredHook.callback);
      return event + " context: " + context + ", " + maxLength(200, name);
    };
    /**
     * These GetResultHandler(s) are used by [[invokeHook]] below
     * Each HookType chooses a GetResultHandler (See: [[TransitionService._defineCoreEvents]])
     */
    TransitionHook.HANDLE_RESULT = function (hook) {
      return function (result) {
        return hook.handleHookResult(result);
      };
    };
    /**
     * If the result is a promise rejection, log it.
     * Otherwise, ignore the result.
     */
    TransitionHook.LOG_REJECTED_RESULT = function (hook) {
      return function (result) {
        isPromise(result) && result["catch"](function (err) {
          return hook.logError(Rejection.normalize(err));
        });
        return undefined;
      };
    };
    /**
     * These GetErrorHandler(s) are used by [[invokeHook]] below
     * Each HookType chooses a GetErrorHandler (See: [[TransitionService._defineCoreEvents]])
     */
    TransitionHook.LOG_ERROR = function (hook) {
      return function (error) {
        return hook.logError(error);
      };
    };
    TransitionHook.REJECT_ERROR = function (hook) {
      return function (error) {
        return silentRejection(error);
      };
    };
    TransitionHook.THROW_ERROR = function (hook) {
      return function (error) {
        throw error;
      };
    };
    return TransitionHook;
  }();

  /**
   * Determines if the given state matches the matchCriteria
   *
   * @internal
   *
   * @param state a State Object to test against
   * @param criterion
   * - If a string, matchState uses the string as a glob-matcher against the state name
   * - If an array (of strings), matchState uses each string in the array as a glob-matchers against the state name
   *   and returns a positive match if any of the globs match.
   * - If a function, matchState calls the function with the state and returns true if the function's result is truthy.
   * @returns {boolean}
   */
  function matchState(state, criterion, transition) {
    var toMatch = isString(criterion) ? [criterion] : criterion;
    function matchGlobs(_state) {
      var globStrings = toMatch;
      for (var i = 0; i < globStrings.length; i++) {
        var glob = new Glob(globStrings[i]);
        if (glob && glob.matches(_state.name) || !glob && globStrings[i] === _state.name) {
          return true;
        }
      }
      return false;
    }
    var matchFn = isFunction(toMatch) ? toMatch : matchGlobs;
    return !!matchFn(state, transition);
  }
  /**
   * The registration data for a registered transition hook
   */
  var RegisteredHook = /** @class */function () {
    function RegisteredHook(tranSvc, eventType, callback, matchCriteria, removeHookFromRegistry, options) {
      if (options === void 0) {
        options = {};
      }
      this.tranSvc = tranSvc;
      this.eventType = eventType;
      this.callback = callback;
      this.matchCriteria = matchCriteria;
      this.removeHookFromRegistry = removeHookFromRegistry;
      this.invokeCount = 0;
      this._deregistered = false;
      this.priority = options.priority || 0;
      this.bind = options.bind || null;
      this.invokeLimit = options.invokeLimit;
    }
    /**
     * Gets the matching [[PathNode]]s
     *
     * Given an array of [[PathNode]]s, and a [[HookMatchCriterion]], returns an array containing
     * the [[PathNode]]s that the criteria matches, or `null` if there were no matching nodes.
     *
     * Returning `null` is significant to distinguish between the default
     * "match-all criterion value" of `true` compared to a `() => true` function,
     * when the nodes is an empty array.
     *
     * This is useful to allow a transition match criteria of `entering: true`
     * to still match a transition, even when `entering === []`.  Contrast that
     * with `entering: (state) => true` which only matches when a state is actually
     * being entered.
     */
    RegisteredHook.prototype._matchingNodes = function (nodes, criterion, transition) {
      if (criterion === true) return nodes;
      var matching = nodes.filter(function (node) {
        return matchState(node.state, criterion, transition);
      });
      return matching.length ? matching : null;
    };
    /**
     * Gets the default match criteria (all `true`)
     *
     * Returns an object which has all the criteria match paths as keys and `true` as values, i.e.:
     *
     * ```js
     * {
     *   to: true,
     *   from: true,
     *   entering: true,
     *   exiting: true,
     *   retained: true,
     * }
     */
    RegisteredHook.prototype._getDefaultMatchCriteria = function () {
      return mapObj(this.tranSvc._pluginapi._getPathTypes(), function () {
        return true;
      });
    };
    /**
     * Gets matching nodes as [[IMatchingNodes]]
     *
     * Create a IMatchingNodes object from the TransitionHookTypes that is roughly equivalent to:
     *
     * ```js
     * let matches: IMatchingNodes = {
     *   to:       _matchingNodes([tail(treeChanges.to)],   mc.to),
     *   from:     _matchingNodes([tail(treeChanges.from)], mc.from),
     *   exiting:  _matchingNodes(treeChanges.exiting,      mc.exiting),
     *   retained: _matchingNodes(treeChanges.retained,     mc.retained),
     *   entering: _matchingNodes(treeChanges.entering,     mc.entering),
     * };
     * ```
     */
    RegisteredHook.prototype._getMatchingNodes = function (treeChanges, transition) {
      var _this = this;
      var criteria = extend(this._getDefaultMatchCriteria(), this.matchCriteria);
      var paths = values(this.tranSvc._pluginapi._getPathTypes());
      return paths.reduce(function (mn, pathtype) {
        // STATE scope criteria matches against every node in the path.
        // TRANSITION scope criteria matches against only the last node in the path
        var isStateHook = pathtype.scope === exports.TransitionHookScope.STATE;
        var path = treeChanges[pathtype.name] || [];
        var nodes = isStateHook ? path : [tail(path)];
        mn[pathtype.name] = _this._matchingNodes(nodes, criteria[pathtype.name], transition);
        return mn;
      }, {});
    };
    /**
     * Determines if this hook's [[matchCriteria]] match the given [[TreeChanges]]
     *
     * @returns an IMatchingNodes object, or null. If an IMatchingNodes object is returned, its values
     * are the matching [[PathNode]]s for each [[HookMatchCriterion]] (to, from, exiting, retained, entering)
     */
    RegisteredHook.prototype.matches = function (treeChanges, transition) {
      var matches = this._getMatchingNodes(treeChanges, transition);
      // Check if all the criteria matched the TreeChanges object
      var allMatched = values(matches).every(identity);
      return allMatched ? matches : null;
    };
    RegisteredHook.prototype.deregister = function () {
      this.removeHookFromRegistry(this);
      this._deregistered = true;
    };
    return RegisteredHook;
  }();
  /** Return a registration function of the requested type. */
  function makeEvent(registry, transitionService, eventType) {
    // Create the object which holds the registered transition hooks.
    var _registeredHooks = registry._registeredHooks = registry._registeredHooks || {};
    var hooks = _registeredHooks[eventType.name] = [];
    var removeHookFn = removeFrom(hooks);
    // Create hook registration function on the IHookRegistry for the event
    registry[eventType.name] = hookRegistrationFn;
    function hookRegistrationFn(matchObject, callback, options) {
      if (options === void 0) {
        options = {};
      }
      var registeredHook = new RegisteredHook(transitionService, eventType, callback, matchObject, removeHookFn, options);
      hooks.push(registeredHook);
      return registeredHook.deregister.bind(registeredHook);
    }
    return hookRegistrationFn;
  }

  /**
   * This class returns applicable TransitionHooks for a specific Transition instance.
   *
   * Hooks ([[RegisteredHook]]) may be registered globally, e.g., $transitions.onEnter(...), or locally, e.g.
   * myTransition.onEnter(...).  The HookBuilder finds matching RegisteredHooks (where the match criteria is
   * determined by the type of hook)
   *
   * The HookBuilder also converts RegisteredHooks objects to TransitionHook objects, which are used to run a Transition.
   *
   * The HookBuilder constructor is given the $transitions service and a Transition instance.  Thus, a HookBuilder
   * instance may only be used for one specific Transition object. (side note: the _treeChanges accessor is private
   * in the Transition class, so we must also provide the Transition's _treeChanges)
   */
  var HookBuilder = /** @class */function () {
    function HookBuilder(transition) {
      this.transition = transition;
    }
    HookBuilder.prototype.buildHooksForPhase = function (phase) {
      var _this = this;
      var $transitions = this.transition.router.transitionService;
      return $transitions._pluginapi._getEvents(phase).map(function (type) {
        return _this.buildHooks(type);
      }).reduce(unnestR, []).filter(identity);
    };
    /**
     * Returns an array of newly built TransitionHook objects.
     *
     * - Finds all RegisteredHooks registered for the given `hookType` which matched the transition's [[TreeChanges]].
     * - Finds [[PathNode]] (or `PathNode[]`) to use as the TransitionHook context(s)
     * - For each of the [[PathNode]]s, creates a TransitionHook
     *
     * @param hookType the type of the hook registration function, e.g., 'onEnter', 'onFinish'.
     */
    HookBuilder.prototype.buildHooks = function (hookType) {
      var transition = this.transition;
      var treeChanges = transition.treeChanges();
      // Find all the matching registered hooks for a given hook type
      var matchingHooks = this.getMatchingHooks(hookType, treeChanges, transition);
      if (!matchingHooks) return [];
      var baseHookOptions = {
        transition: transition,
        current: transition.options().current
      };
      var makeTransitionHooks = function makeTransitionHooks(hook) {
        // Fetch the Nodes that caused this hook to match.
        var matches = hook.matches(treeChanges, transition);
        // Select the PathNode[] that will be used as TransitionHook context objects
        var matchingNodes = matches[hookType.criteriaMatchPath.name];
        // Return an array of HookTuples
        return matchingNodes.map(function (node) {
          var _options = extend({
            bind: hook.bind,
            traceData: {
              hookType: hookType.name,
              context: node
            }
          }, baseHookOptions);
          var state = hookType.criteriaMatchPath.scope === exports.TransitionHookScope.STATE ? node.state.self : null;
          var transitionHook = new TransitionHook(transition, state, hook, _options);
          return {
            hook: hook,
            node: node,
            transitionHook: transitionHook
          };
        });
      };
      return matchingHooks.map(makeTransitionHooks).reduce(unnestR, []).sort(tupleSort(hookType.reverseSort)).map(function (tuple) {
        return tuple.transitionHook;
      });
    };
    /**
     * Finds all RegisteredHooks from:
     * - The Transition object instance hook registry
     * - The TransitionService ($transitions) global hook registry
     *
     * which matched:
     * - the eventType
     * - the matchCriteria (to, from, exiting, retained, entering)
     *
     * @returns an array of matched [[RegisteredHook]]s
     */
    HookBuilder.prototype.getMatchingHooks = function (hookType, treeChanges, transition) {
      var isCreate = hookType.hookPhase === exports.TransitionHookPhase.CREATE;
      // Instance and Global hook registries
      var $transitions = this.transition.router.transitionService;
      var registries = isCreate ? [$transitions] : [this.transition, $transitions];
      return registries.map(function (reg) {
        return reg.getHooks(hookType.name);
      }) // Get named hooks from registries
      .filter(assertPredicate(isArray, "broken event named: " + hookType.name)) // Sanity check
      .reduce(unnestR, []) // Un-nest RegisteredHook[][] to RegisteredHook[] array
      .filter(function (hook) {
        return hook.matches(treeChanges, transition);
      }); // Only those satisfying matchCriteria
    };
    return HookBuilder;
  }();
  /**
   * A factory for a sort function for HookTuples.
   *
   * The sort function first compares the PathNode depth (how deep in the state tree a node is), then compares
   * the EventHook priority.
   *
   * @param reverseDepthSort a boolean, when true, reverses the sort order for the node depth
   * @returns a tuple sort function
   */
  function tupleSort(reverseDepthSort) {
    if (reverseDepthSort === void 0) {
      reverseDepthSort = false;
    }
    return function nodeDepthThenPriority(l, r) {
      var factor = reverseDepthSort ? -1 : 1;
      var depthDelta = (l.node.state.path.length - r.node.state.path.length) * factor;
      return depthDelta !== 0 ? depthDelta : r.hook.priority - l.hook.priority;
    };
  }

  /** @internal */
  var stateSelf = prop('self');
  /**
   * Represents a transition between two states.
   *
   * When navigating to a state, we are transitioning **from** the current state **to** the new state.
   *
   * This object contains all contextual information about the to/from states, parameters, resolves.
   * It has information about all states being entered and exited as a result of the transition.
   */
  var Transition = /** @class */function () {
    /**
     * Creates a new Transition object.
     *
     * If the target state is not valid, an error is thrown.
     *
     * @internal
     *
     * @param fromPath The path of [[PathNode]]s from which the transition is leaving.  The last node in the `fromPath`
     *        encapsulates the "from state".
     * @param targetState The target state and parameters being transitioned to (also, the transition options)
     * @param router The [[UIRouter]] instance
     * @internal
     */
    function Transition(fromPath, targetState, router) {
      var _this = this;
      /** @internal */
      this._deferred = services.$q.defer();
      /**
       * This promise is resolved or rejected based on the outcome of the Transition.
       *
       * When the transition is successful, the promise is resolved
       * When the transition is unsuccessful, the promise is rejected with the [[Rejection]] or javascript error
       */
      this.promise = this._deferred.promise;
      /** @internal Holds the hook registration functions such as those passed to Transition.onStart() */
      this._registeredHooks = {};
      /** @internal */
      this._hookBuilder = new HookBuilder(this);
      /** Checks if this transition is currently active/running. */
      this.isActive = function () {
        return _this.router.globals.transition === _this;
      };
      this.router = router;
      this._targetState = targetState;
      if (!targetState.valid()) {
        throw new Error(targetState.error());
      }
      // current() is assumed to come from targetState.options, but provide a naive implementation otherwise.
      this._options = extend({
        current: val(this)
      }, targetState.options());
      this.$id = router.transitionService._transitionCount++;
      var toPath = PathUtils.buildToPath(fromPath, targetState);
      this._treeChanges = PathUtils.treeChanges(fromPath, toPath, this._options.reloadState);
      this.createTransitionHookRegFns();
      var onCreateHooks = this._hookBuilder.buildHooksForPhase(exports.TransitionHookPhase.CREATE);
      TransitionHook.invokeHooks(onCreateHooks, function () {
        return null;
      });
      this.applyViewConfigs(router);
    }
    /** @internal */
    Transition.prototype.onBefore = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    Transition.prototype.onStart = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    Transition.prototype.onExit = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    Transition.prototype.onRetain = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    Transition.prototype.onEnter = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    Transition.prototype.onFinish = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    Transition.prototype.onSuccess = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    Transition.prototype.onError = function (criteria, callback, options) {
      return;
    };
    /** @internal
     * Creates the transition-level hook registration functions
     * (which can then be used to register hooks)
     */
    Transition.prototype.createTransitionHookRegFns = function () {
      var _this = this;
      this.router.transitionService._pluginapi._getEvents().filter(function (type) {
        return type.hookPhase !== exports.TransitionHookPhase.CREATE;
      }).forEach(function (type) {
        return makeEvent(_this, _this.router.transitionService, type);
      });
    };
    /** @internal */
    Transition.prototype.getHooks = function (hookName) {
      return this._registeredHooks[hookName];
    };
    Transition.prototype.applyViewConfigs = function (router) {
      var enteringStates = this._treeChanges.entering.map(function (node) {
        return node.state;
      });
      PathUtils.applyViewConfigs(router.transitionService.$view, this._treeChanges.to, enteringStates);
    };
    /**
     * @internal
     * @returns the internal from [State] object
     */
    Transition.prototype.$from = function () {
      return tail(this._treeChanges.from).state;
    };
    /**
     * @internal
     * @returns the internal to [State] object
     */
    Transition.prototype.$to = function () {
      return tail(this._treeChanges.to).state;
    };
    /**
     * Returns the "from state"
     *
     * Returns the state that the transition is coming *from*.
     *
     * @returns The state declaration object for the Transition's ("from state").
     */
    Transition.prototype.from = function () {
      return this.$from().self;
    };
    /**
     * Returns the "to state"
     *
     * Returns the state that the transition is going *to*.
     *
     * @returns The state declaration object for the Transition's target state ("to state").
     */
    Transition.prototype.to = function () {
      return this.$to().self;
    };
    /**
     * Gets the Target State
     *
     * A transition's [[TargetState]] encapsulates the [[to]] state, the [[params]], and the [[options]] as a single object.
     *
     * @returns the [[TargetState]] of this Transition
     */
    Transition.prototype.targetState = function () {
      return this._targetState;
    };
    /**
     * Determines whether two transitions are equivalent.
     * @deprecated
     */
    Transition.prototype.is = function (compare) {
      if (compare instanceof Transition) {
        // TODO: Also compare parameters
        return this.is({
          to: compare.$to().name,
          from: compare.$from().name
        });
      }
      return !(compare.to && !matchState(this.$to(), compare.to, this) || compare.from && !matchState(this.$from(), compare.from, this));
    };
    Transition.prototype.params = function (pathname) {
      if (pathname === void 0) {
        pathname = 'to';
      }
      return Object.freeze(this._treeChanges[pathname].map(prop('paramValues')).reduce(mergeR, {}));
    };
    Transition.prototype.paramsChanged = function () {
      var fromParams = this.params('from');
      var toParams = this.params('to');
      // All the parameters declared on both the "to" and "from" paths
      var allParamDescriptors = [].concat(this._treeChanges.to).concat(this._treeChanges.from).map(function (pathNode) {
        return pathNode.paramSchema;
      }).reduce(_flattenR, []).reduce(uniqR, []);
      var changedParamDescriptors = Param.changed(allParamDescriptors, fromParams, toParams);
      return changedParamDescriptors.reduce(function (changedValues, descriptor) {
        changedValues[descriptor.id] = toParams[descriptor.id];
        return changedValues;
      }, {});
    };
    /**
     * Creates a [[UIInjector]] Dependency Injector
     *
     * Returns a Dependency Injector for the Transition's target state (to state).
     * The injector provides resolve values which the target state has access to.
     *
     * The `UIInjector` can also provide values from the native root/global injector (ng1/ng2).
     *
     * #### Example:
     * ```js
     * .onEnter({ entering: 'myState' }, trans => {
     *   var myResolveValue = trans.injector().get('myResolve');
     *   // Inject a global service from the global/native injector (if it exists)
     *   var MyService = trans.injector().get('MyService');
     * })
     * ```
     *
     * In some cases (such as `onBefore`), you may need access to some resolve data but it has not yet been fetched.
     * You can use [[UIInjector.getAsync]] to get a promise for the data.
     * #### Example:
     * ```js
     * .onBefore({}, trans => {
     *   return trans.injector().getAsync('myResolve').then(myResolveValue =>
     *     return myResolveValue !== 'ABORT';
     *   });
     * });
     * ```
     *
     * If a `state` is provided, the injector that is returned will be limited to resolve values that the provided state has access to.
     * This can be useful if both a parent state `foo` and a child state `foo.bar` have both defined a resolve such as `data`.
     * #### Example:
     * ```js
     * .onEnter({ to: 'foo.bar' }, trans => {
     *   // returns result of `foo` state's `myResolve` resolve
     *   // even though `foo.bar` also has a `myResolve` resolve
     *   var fooData = trans.injector('foo').get('myResolve');
     * });
     * ```
     *
     * If you need resolve data from the exiting states, pass `'from'` as `pathName`.
     * The resolve data from the `from` path will be returned.
     * #### Example:
     * ```js
     * .onExit({ exiting: 'foo.bar' }, trans => {
     *   // Gets the resolve value of `myResolve` from the state being exited
     *   var fooData = trans.injector(null, 'from').get('myResolve');
     * });
     * ```
     *
     *
     * @param state Limits the resolves provided to only the resolves the provided state has access to.
     * @param pathName Default: `'to'`: Chooses the path for which to create the injector. Use this to access resolves for `exiting` states.
     *
     * @returns a [[UIInjector]]
     */
    Transition.prototype.injector = function (state, pathName) {
      if (pathName === void 0) {
        pathName = 'to';
      }
      var path = this._treeChanges[pathName];
      if (state) path = PathUtils.subPath(path, function (node) {
        return node.state === state || node.state.name === state;
      });
      return new ResolveContext(path).injector();
    };
    /**
     * Gets all available resolve tokens (keys)
     *
     * This method can be used in conjunction with [[injector]] to inspect the resolve values
     * available to the Transition.
     *
     * This returns all the tokens defined on [[StateDeclaration.resolve]] blocks, for the states
     * in the Transition's [[TreeChanges.to]] path.
     *
     * #### Example:
     * This example logs all resolve values
     * ```js
     * let tokens = trans.getResolveTokens();
     * tokens.forEach(token => console.log(token + " = " + trans.injector().get(token)));
     * ```
     *
     * #### Example:
     * This example creates promises for each resolve value.
     * This triggers fetches of resolves (if any have not yet been fetched).
     * When all promises have all settled, it logs the resolve values.
     * ```js
     * let tokens = trans.getResolveTokens();
     * let promise = tokens.map(token => trans.injector().getAsync(token));
     * Promise.all(promises).then(values => console.log("Resolved values: " + values));
     * ```
     *
     * Note: Angular 1 users whould use `$q.all()`
     *
     * @param pathname resolve context's path name (e.g., `to` or `from`)
     *
     * @returns an array of resolve tokens (keys)
     */
    Transition.prototype.getResolveTokens = function (pathname) {
      if (pathname === void 0) {
        pathname = 'to';
      }
      return new ResolveContext(this._treeChanges[pathname]).getTokens();
    };
    /**
     * Dynamically adds a new [[Resolvable]] (i.e., [[StateDeclaration.resolve]]) to this transition.
     *
     * Allows a transition hook to dynamically add a Resolvable to this Transition.
     *
     * Use the [[Transition.injector]] to retrieve the resolved data in subsequent hooks ([[UIInjector.get]]).
     *
     * If a `state` argument is provided, the Resolvable is processed when that state is being entered.
     * If no `state` is provided then the root state is used.
     * If the given `state` has already been entered, the Resolvable is processed when any child state is entered.
     * If no child states will be entered, the Resolvable is processed during the `onFinish` phase of the Transition.
     *
     * The `state` argument also scopes the resolved data.
     * The resolved data is available from the injector for that `state` and any children states.
     *
     * #### Example:
     * ```js
     * transitionService.onBefore({}, transition => {
     *   transition.addResolvable({
     *     token: 'myResolve',
     *     deps: ['MyService'],
     *     resolveFn: myService => myService.getData()
     *   });
     * });
     * ```
     *
     * @param resolvable a [[ResolvableLiteral]] object (or a [[Resolvable]])
     * @param state the state in the "to path" which should receive the new resolve (otherwise, the root state)
     */
    Transition.prototype.addResolvable = function (resolvable, state) {
      if (state === void 0) {
        state = '';
      }
      resolvable = is(Resolvable)(resolvable) ? resolvable : new Resolvable(resolvable);
      var stateName = typeof state === 'string' ? state : state.name;
      var topath = this._treeChanges.to;
      var targetNode = find(topath, function (node) {
        return node.state.name === stateName;
      });
      var resolveContext = new ResolveContext(topath);
      resolveContext.addResolvables([resolvable], targetNode.state);
    };
    /**
     * Gets the transition from which this transition was redirected.
     *
     * If the current transition is a redirect, this method returns the transition that was redirected.
     *
     * #### Example:
     * ```js
     * let transitionA = $state.go('A').transition
     * transitionA.onStart({}, () => $state.target('B'));
     * $transitions.onSuccess({ to: 'B' }, (trans) => {
     *   trans.to().name === 'B'; // true
     *   trans.redirectedFrom() === transitionA; // true
     * });
     * ```
     *
     * @returns The previous Transition, or null if this Transition is not the result of a redirection
     */
    Transition.prototype.redirectedFrom = function () {
      return this._options.redirectedFrom || null;
    };
    /**
     * Gets the original transition in a redirect chain
     *
     * A transition might belong to a long chain of multiple redirects.
     * This method walks the [[redirectedFrom]] chain back to the original (first) transition in the chain.
     *
     * #### Example:
     * ```js
     * // states
     * registry.register({ name: 'A', redirectTo: 'B' });
     * registry.register({ name: 'B', redirectTo: 'C' });
     * registry.register({ name: 'C', redirectTo: 'D' });
     * registry.register({ name: 'D' });
     *
     * let transitionA = $state.go('A').transition
     *
     * $transitions.onSuccess({ to: 'D' }, (trans) => {
     *   trans.to().name === 'D'; // true
     *   trans.redirectedFrom().to().name === 'C'; // true
     *   trans.originalTransition() === transitionA; // true
     *   trans.originalTransition().to().name === 'A'; // true
     * });
     * ```
     *
     * @returns The original Transition that started a redirect chain
     */
    Transition.prototype.originalTransition = function () {
      var rf = this.redirectedFrom();
      return rf && rf.originalTransition() || this;
    };
    /**
     * Get the transition options
     *
     * @returns the options for this Transition.
     */
    Transition.prototype.options = function () {
      return this._options;
    };
    /**
     * Gets the states being entered.
     *
     * @returns an array of states that will be entered during this transition.
     */
    Transition.prototype.entering = function () {
      return map(this._treeChanges.entering, prop('state')).map(stateSelf);
    };
    /**
     * Gets the states being exited.
     *
     * @returns an array of states that will be exited during this transition.
     */
    Transition.prototype.exiting = function () {
      return map(this._treeChanges.exiting, prop('state')).map(stateSelf).reverse();
    };
    /**
     * Gets the states being retained.
     *
     * @returns an array of states that are already entered from a previous Transition, that will not be
     *    exited during this Transition
     */
    Transition.prototype.retained = function () {
      return map(this._treeChanges.retained, prop('state')).map(stateSelf);
    };
    /**
     * Get the [[ViewConfig]]s associated with this Transition
     *
     * Each state can define one or more views (template/controller), which are encapsulated as `ViewConfig` objects.
     * This method fetches the `ViewConfigs` for a given path in the Transition (e.g., "to" or "entering").
     *
     * @param pathname the name of the path to fetch views for:
     *   (`'to'`, `'from'`, `'entering'`, `'exiting'`, `'retained'`)
     * @param state If provided, only returns the `ViewConfig`s for a single state in the path
     *
     * @returns a list of ViewConfig objects for the given path.
     */
    Transition.prototype.views = function (pathname, state) {
      if (pathname === void 0) {
        pathname = 'entering';
      }
      var path = this._treeChanges[pathname];
      path = !state ? path : path.filter(propEq('state', state));
      return path.map(prop('views')).filter(identity).reduce(unnestR, []);
    };
    Transition.prototype.treeChanges = function (pathname) {
      return pathname ? this._treeChanges[pathname] : this._treeChanges;
    };
    /**
     * Creates a new transition that is a redirection of the current one.
     *
     * This transition can be returned from a [[TransitionService]] hook to
     * redirect a transition to a new state and/or set of parameters.
     *
     * @internal
     *
     * @returns Returns a new [[Transition]] instance.
     */
    Transition.prototype.redirect = function (targetState) {
      var redirects = 1,
        trans = this;
      // tslint:disable-next-line:no-conditional-assignment
      while ((trans = trans.redirectedFrom()) != null) {
        if (++redirects > 20) throw new Error("Too many consecutive Transition redirects (20+)");
      }
      var redirectOpts = {
        redirectedFrom: this,
        source: 'redirect'
      };
      // If the original transition was caused by URL sync, then use { location: 'replace' }
      // on the new transition (unless the target state explicitly specifies location: false).
      // This causes the original url to be replaced with the url for the redirect target
      // so the original url disappears from the browser history.
      if (this.options().source === 'url' && targetState.options().location !== false) {
        redirectOpts.location = 'replace';
      }
      var newOptions = extend({}, this.options(), targetState.options(), redirectOpts);
      targetState = targetState.withOptions(newOptions, true);
      var newTransition = this.router.transitionService.create(this._treeChanges.from, targetState);
      var originalEnteringNodes = this._treeChanges.entering;
      var redirectEnteringNodes = newTransition._treeChanges.entering;
      // --- Re-use resolve data from original transition ---
      // When redirecting from a parent state to a child state where the parent parameter values haven't changed
      // (because of the redirect), the resolves fetched by the original transition are still valid in the
      // redirected transition.
      //
      // This allows you to define a redirect on a parent state which depends on an async resolve value.
      // You can wait for the resolve, then redirect to a child state based on the result.
      // The redirected transition does not have to re-fetch the resolve.
      // ---------------------------------------------------------
      var nodeIsReloading = function nodeIsReloading(reloadState) {
        return function (node) {
          return reloadState && node.state.includes[reloadState.name];
        };
      };
      // Find any "entering" nodes in the redirect path that match the original path and aren't being reloaded
      var matchingEnteringNodes = PathUtils.matching(redirectEnteringNodes, originalEnteringNodes, PathUtils.nonDynamicParams).filter(not(nodeIsReloading(targetState.options().reloadState)));
      // Use the existing (possibly pre-resolved) resolvables for the matching entering nodes.
      matchingEnteringNodes.forEach(function (node, idx) {
        node.resolvables = originalEnteringNodes[idx].resolvables;
      });
      return newTransition;
    };
    /** @internal If a transition doesn't exit/enter any states, returns any [[Param]] whose value changed */
    Transition.prototype._changedParams = function () {
      var tc = this._treeChanges;
      /** Return undefined if it's not a "dynamic" transition, for the following reasons */
      // If user explicitly wants a reload
      if (this._options.reload) return undefined;
      // If any states are exiting or entering
      if (tc.exiting.length || tc.entering.length) return undefined;
      // If to/from path lengths differ
      if (tc.to.length !== tc.from.length) return undefined;
      // If the to/from paths are different
      var pathsDiffer = arrayTuples(tc.to, tc.from).map(function (tuple) {
        return tuple[0].state !== tuple[1].state;
      }).reduce(anyTrueR, false);
      if (pathsDiffer) return undefined;
      // Find any parameter values that differ
      var nodeSchemas = tc.to.map(function (node) {
        return node.paramSchema;
      });
      var _a = [tc.to, tc.from].map(function (path) {
          return path.map(function (x) {
            return x.paramValues;
          });
        }),
        toValues = _a[0],
        fromValues = _a[1];
      var tuples = arrayTuples(nodeSchemas, toValues, fromValues);
      return tuples.map(function (_a) {
        var schema = _a[0],
          toVals = _a[1],
          fromVals = _a[2];
        return Param.changed(schema, toVals, fromVals);
      }).reduce(unnestR, []);
    };
    /**
     * Returns true if the transition is dynamic.
     *
     * A transition is dynamic if no states are entered nor exited, but at least one dynamic parameter has changed.
     *
     * @returns true if the Transition is dynamic
     */
    Transition.prototype.dynamic = function () {
      var changes = this._changedParams();
      return !changes ? false : changes.map(function (x) {
        return x.dynamic;
      }).reduce(anyTrueR, false);
    };
    /**
     * Returns true if the transition is ignored.
     *
     * A transition is ignored if no states are entered nor exited, and no parameter values have changed.
     *
     * @returns true if the Transition is ignored.
     */
    Transition.prototype.ignored = function () {
      return !!this._ignoredReason();
    };
    /** @internal */
    Transition.prototype._ignoredReason = function () {
      var pending = this.router.globals.transition;
      var reloadState = this._options.reloadState;
      var same = function same(pathA, pathB) {
        if (pathA.length !== pathB.length) return false;
        var matching = PathUtils.matching(pathA, pathB);
        return pathA.length === matching.filter(function (node) {
          return !reloadState || !node.state.includes[reloadState.name];
        }).length;
      };
      var newTC = this.treeChanges();
      var pendTC = pending && pending.treeChanges();
      if (pendTC && same(pendTC.to, newTC.to) && same(pendTC.exiting, newTC.exiting)) return 'SameAsPending';
      if (newTC.exiting.length === 0 && newTC.entering.length === 0 && same(newTC.from, newTC.to)) return 'SameAsCurrent';
    };
    /**
     * Runs the transition
     *
     * This method is generally called from the [[StateService.transitionTo]]
     *
     * @internal
     *
     * @returns a promise for a successful transition.
     */
    Transition.prototype.run = function () {
      var _this = this;
      var runAllHooks = TransitionHook.runAllHooks;
      // Gets transition hooks array for the given phase
      var getHooksFor = function getHooksFor(phase) {
        return _this._hookBuilder.buildHooksForPhase(phase);
      };
      // When the chain is complete, then resolve or reject the deferred
      var transitionSuccess = function transitionSuccess() {
        trace.traceSuccess(_this.$to(), _this);
        _this.success = true;
        _this._deferred.resolve(_this.to());
        runAllHooks(getHooksFor(exports.TransitionHookPhase.SUCCESS));
      };
      var transitionError = function transitionError(reason) {
        trace.traceError(reason, _this);
        _this.success = false;
        _this._deferred.reject(reason);
        _this._error = reason;
        runAllHooks(getHooksFor(exports.TransitionHookPhase.ERROR));
      };
      var runTransition = function runTransition() {
        // Wait to build the RUN hook chain until the BEFORE hooks are done
        // This allows a BEFORE hook to dynamically add additional RUN hooks via the Transition object.
        var allRunHooks = getHooksFor(exports.TransitionHookPhase.RUN);
        var done = function done() {
          return services.$q.when(undefined);
        };
        return TransitionHook.invokeHooks(allRunHooks, done);
      };
      var startTransition = function startTransition() {
        var globals = _this.router.globals;
        globals.lastStartedTransitionId = _this.$id;
        globals.transition = _this;
        globals.transitionHistory.enqueue(_this);
        trace.traceTransitionStart(_this);
        return services.$q.when(undefined);
      };
      var allBeforeHooks = getHooksFor(exports.TransitionHookPhase.BEFORE);
      TransitionHook.invokeHooks(allBeforeHooks, startTransition).then(runTransition).then(transitionSuccess, transitionError);
      return this.promise;
    };
    /**
     * Checks if the Transition is valid
     *
     * @returns true if the Transition is valid
     */
    Transition.prototype.valid = function () {
      return !this.error() || this.success !== undefined;
    };
    /**
     * Aborts this transition
     *
     * Imperative API to abort a Transition.
     * This only applies to Transitions that are not yet complete.
     */
    Transition.prototype.abort = function () {
      // Do not set flag if the transition is already complete
      if (isUndefined(this.success)) {
        this._aborted = true;
      }
    };
    /**
     * The Transition error reason.
     *
     * If the transition is invalid (and could not be run), returns the reason the transition is invalid.
     * If the transition was valid and ran, but was not successful, returns the reason the transition failed.
     *
     * @returns a transition rejection explaining why the transition is invalid, or the reason the transition failed.
     */
    Transition.prototype.error = function () {
      var state = this.$to();
      if (state.self["abstract"]) {
        return Rejection.invalid("Cannot transition to abstract state '" + state.name + "'");
      }
      var paramDefs = state.parameters();
      var values = this.params();
      var invalidParams = paramDefs.filter(function (param) {
        return !param.validates(values[param.id]);
      });
      if (invalidParams.length) {
        var invalidValues = invalidParams.map(function (param) {
          return "[" + param.id + ":" + stringify(values[param.id]) + "]";
        }).join(', ');
        var detail = "The following parameter values are not valid for state '" + state.name + "': " + invalidValues;
        return Rejection.invalid(detail);
      }
      if (this.success === false) return this._error;
    };
    /**
     * A string representation of the Transition
     *
     * @returns A string representation of the Transition
     */
    Transition.prototype.toString = function () {
      var fromStateOrName = this.from();
      var toStateOrName = this.to();
      var avoidEmptyHash = function avoidEmptyHash(params) {
        return params['#'] !== null && params['#'] !== undefined ? params : omit(params, ['#']);
      };
      // (X) means the to state is invalid.
      var id = this.$id,
        from = isObject(fromStateOrName) ? fromStateOrName.name : fromStateOrName,
        fromParams = stringify(avoidEmptyHash(this._treeChanges.from.map(prop('paramValues')).reduce(mergeR, {}))),
        toValid = this.valid() ? '' : '(X) ',
        to = isObject(toStateOrName) ? toStateOrName.name : toStateOrName,
        toParams = stringify(avoidEmptyHash(this.params()));
      return "Transition#" + id + "( '" + from + "'" + fromParams + " -> " + toValid + "'" + to + "'" + toParams + " )";
    };
    /** @internal */
    Transition.diToken = Transition;
    return Transition;
  }();
  function quoteRegExp(str, param) {
    var surroundPattern = ['', ''],
      result = str.replace(/[\\\[\]\^$*+?.()|{}]/g, '\\$&');
    if (!param) return result;
    switch (param.squash) {
      case false:
        surroundPattern = ['(', ')' + (param.isOptional ? '?' : '')];
        break;
      case true:
        result = result.replace(/\/$/, '');
        surroundPattern = ['(?:/(', ')|/)?'];
        break;
      default:
        surroundPattern = ["(" + param.squash + "|", ')?'];
        break;
    }
    return result + surroundPattern[0] + param.type.pattern.source + surroundPattern[1];
  }
  var memoizeTo = function memoizeTo(obj, _prop, fn) {
    return obj[_prop] = obj[_prop] || fn();
  };
  var splitOnSlash = splitOnDelim('/');
  var defaultConfig = {
    state: {
      params: {}
    },
    strict: true,
    caseInsensitive: true,
    decodeParams: true
  };
  /**
   * Matches URLs against patterns.
   *
   * Matches URLs against patterns and extracts named parameters from the path or the search
   * part of the URL.
   *
   * A URL pattern consists of a path pattern, optionally followed by '?' and a list of search (query)
   * parameters. Multiple search parameter names are separated by '&'. Search parameters
   * do not influence whether or not a URL is matched, but their values are passed through into
   * the matched parameters returned by [[UrlMatcher.exec]].
   *
   * - *Path parameters* are defined using curly brace placeholders (`/somepath/{param}`)
   * or colon placeholders (`/somePath/:param`).
   *
   * - *A parameter RegExp* may be defined for a param after a colon
   * (`/somePath/{param:[a-zA-Z0-9]+}`) in a curly brace placeholder.
   * The regexp must match for the url to be matched.
   * Should the regexp itself contain curly braces, they must be in matched pairs or escaped with a backslash.
   *
   * Note: a RegExp parameter will encode its value using either [[ParamTypes.path]] or [[ParamTypes.query]].
   *
   * - *Custom parameter types* may also be specified after a colon (`/somePath/{param:int}`) in curly brace parameters.
   *   See [[UrlMatcherFactory.type]] for more information.
   *
   * - *Catch-all parameters* are defined using an asterisk placeholder (`/somepath/*catchallparam`).
   *   A catch-all * parameter value will contain the remainder of the URL.
   *
   * ---
   *
   * Parameter names may contain only word characters (latin letters, digits, and underscore) and
   * must be unique within the pattern (across both path and search parameters).
   * A path parameter matches any number of characters other than '/'. For catch-all
   * placeholders the path parameter matches any number of characters.
   *
   * Examples:
   *
   * * `'/hello/'` - Matches only if the path is exactly '/hello/'. There is no special treatment for
   *   trailing slashes, and patterns have to match the entire path, not just a prefix.
   * * `'/user/:id'` - Matches '/user/bob' or '/user/1234!!!' or even '/user/' but not '/user' or
   *   '/user/bob/details'. The second path segment will be captured as the parameter 'id'.
   * * `'/user/{id}'` - Same as the previous example, but using curly brace syntax.
   * * `'/user/{id:[^/]*}'` - Same as the previous example.
   * * `'/user/{id:[0-9a-fA-F]{1,8}}'` - Similar to the previous example, but only matches if the id
   *   parameter consists of 1 to 8 hex digits.
   * * `'/files/{path:.*}'` - Matches any URL starting with '/files/' and captures the rest of the
   *   path into the parameter 'path'.
   * * `'/files/*path'` - ditto.
   * * `'/calendar/{start:date}'` - Matches "/calendar/2014-11-12" (because the pattern defined
   *   in the built-in  `date` ParamType matches `2014-11-12`) and provides a Date object in $stateParams.start
   *
   */
  var UrlMatcher = /** @class */function () {
    /**
     * @param pattern The pattern to compile into a matcher.
     * @param paramTypes The [[ParamTypes]] registry
     * @param paramFactory A [[ParamFactory]] object
     * @param config  A [[UrlMatcherCompileConfig]] configuration object
     */
    function UrlMatcher(pattern, paramTypes, paramFactory, config) {
      var _this = this;
      /** @internal */
      this._cache = {
        path: [this]
      };
      /** @internal */
      this._children = [];
      /** @internal */
      this._params = [];
      /** @internal */
      this._segments = [];
      /** @internal */
      this._compiled = [];
      this.config = config = defaults(config, defaultConfig);
      this.pattern = pattern;
      // Find all placeholders and create a compiled pattern, using either classic or curly syntax:
      //   '*' name
      //   ':' name
      //   '{' name '}'
      //   '{' name ':' regexp '}'
      // The regular expression is somewhat complicated due to the need to allow curly braces
      // inside the regular expression. The placeholder regexp breaks down as follows:
      //    ([:*])([\w\[\]]+)              - classic placeholder ($1 / $2) (search version has - for snake-case)
      //    \{([\w\[\]]+)(?:\:\s*( ... ))?\}  - curly brace placeholder ($3) with optional regexp/type ... ($4) (search version has - for snake-case
      //    (?: ... | ... | ... )+         - the regexp consists of any number of atoms, an atom being either
      //    [^{}\\]+                       - anything other than curly braces or backslash
      //    \\.                            - a backslash escape
      //    \{(?:[^{}\\]+|\\.)*\}          - a matched set of curly braces containing other atoms
      var placeholder = /([:*])([\w\[\]]+)|\{([\w\[\]]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
      var searchPlaceholder = /([:]?)([\w\[\].-]+)|\{([\w\[\].-]+)(?:\:\s*((?:[^{}\\]+|\\.|\{(?:[^{}\\]+|\\.)*\})+))?\}/g;
      var patterns = [];
      var last = 0;
      var matchArray;
      var checkParamErrors = function checkParamErrors(id) {
        if (!UrlMatcher.nameValidator.test(id)) throw new Error("Invalid parameter name '" + id + "' in pattern '" + pattern + "'");
        if (find(_this._params, propEq('id', id))) throw new Error("Duplicate parameter name '" + id + "' in pattern '" + pattern + "'");
      };
      // Split into static segments separated by path parameter placeholders.
      // The number of segments is always 1 more than the number of parameters.
      var matchDetails = function matchDetails(m, isSearch) {
        // IE[78] returns '' for unmatched groups instead of null
        var id = m[2] || m[3];
        var regexp = isSearch ? m[4] : m[4] || (m[1] === '*' ? '[\\s\\S]*' : null);
        var makeRegexpType = function makeRegexpType(str) {
          return inherit(paramTypes.type(isSearch ? 'query' : 'path'), {
            pattern: new RegExp(str, _this.config.caseInsensitive ? 'i' : undefined)
          });
        };
        return {
          id: id,
          regexp: regexp,
          segment: pattern.substring(last, m.index),
          type: !regexp ? null : paramTypes.type(regexp) || makeRegexpType(regexp)
        };
      };
      var details;
      var segment;
      // tslint:disable-next-line:no-conditional-assignment
      while (matchArray = placeholder.exec(pattern)) {
        details = matchDetails(matchArray, false);
        if (details.segment.indexOf('?') >= 0) break; // we're into the search part
        checkParamErrors(details.id);
        this._params.push(paramFactory.fromPath(details.id, details.type, config.state));
        this._segments.push(details.segment);
        patterns.push([details.segment, tail(this._params)]);
        last = placeholder.lastIndex;
      }
      segment = pattern.substring(last);
      // Find any search parameter names and remove them from the last segment
      var i = segment.indexOf('?');
      if (i >= 0) {
        var search = segment.substring(i);
        segment = segment.substring(0, i);
        if (search.length > 0) {
          last = 0;
          // tslint:disable-next-line:no-conditional-assignment
          while (matchArray = searchPlaceholder.exec(search)) {
            details = matchDetails(matchArray, true);
            checkParamErrors(details.id);
            this._params.push(paramFactory.fromSearch(details.id, details.type, config.state));
            last = placeholder.lastIndex;
            // check if ?&
          }
        }
      }
      this._segments.push(segment);
      this._compiled = patterns.map(function (_pattern) {
        return quoteRegExp.apply(null, _pattern);
      }).concat(quoteRegExp(segment));
    }
    /** @internal */
    UrlMatcher.encodeDashes = function (str) {
      // Replace dashes with encoded "\-"
      return encodeURIComponent(str).replace(/-/g, function (c) {
        return "%5C%" + c.charCodeAt(0).toString(16).toUpperCase();
      });
    };
    /** @internal Given a matcher, return an array with the matcher's path segments and path params, in order */
    UrlMatcher.pathSegmentsAndParams = function (matcher) {
      var staticSegments = matcher._segments;
      var pathParams = matcher._params.filter(function (p) {
        return p.location === exports.DefType.PATH;
      });
      return arrayTuples(staticSegments, pathParams.concat(undefined)).reduce(unnestR, []).filter(function (x) {
        return x !== '' && isDefined(x);
      });
    };
    /** @internal Given a matcher, return an array with the matcher's query params */
    UrlMatcher.queryParams = function (matcher) {
      return matcher._params.filter(function (p) {
        return p.location === exports.DefType.SEARCH;
      });
    };
    /**
     * Compare two UrlMatchers
     *
     * This comparison function converts a UrlMatcher into static and dynamic path segments.
     * Each static path segment is a static string between a path separator (slash character).
     * Each dynamic segment is a path parameter.
     *
     * The comparison function sorts static segments before dynamic ones.
     */
    UrlMatcher.compare = function (a, b) {
      /**
       * Turn a UrlMatcher and all its parent matchers into an array
       * of slash literals '/', string literals, and Param objects
       *
       * This example matcher matches strings like "/foo/:param/tail":
       * var matcher = $umf.compile("/foo").append($umf.compile("/:param")).append($umf.compile("/")).append($umf.compile("tail"));
       * var result = segments(matcher); // [ '/', 'foo', '/', Param, '/', 'tail' ]
       *
       * Caches the result as `matcher._cache.segments`
       */
      var segments = function segments(matcher) {
        return matcher._cache.segments = matcher._cache.segments || matcher._cache.path.map(UrlMatcher.pathSegmentsAndParams).reduce(unnestR, []).reduce(joinNeighborsR, []).map(function (x) {
          return isString(x) ? splitOnSlash(x) : x;
        }).reduce(unnestR, []);
      };
      /**
       * Gets the sort weight for each segment of a UrlMatcher
       *
       * Caches the result as `matcher._cache.weights`
       */
      var weights = function weights(matcher) {
        return matcher._cache.weights = matcher._cache.weights || segments(matcher).map(function (segment) {
          // Sort slashes first, then static strings, the Params
          if (segment === '/') return 1;
          if (isString(segment)) return 2;
          if (segment instanceof Param) return 3;
        });
      };
      /**
       * Pads shorter array in-place (mutates)
       */
      var padArrays = function padArrays(l, r, padVal) {
        var len = Math.max(l.length, r.length);
        while (l.length < len) l.push(padVal);
        while (r.length < len) r.push(padVal);
      };
      var weightsA = weights(a),
        weightsB = weights(b);
      padArrays(weightsA, weightsB, 0);
      var _pairs = arrayTuples(weightsA, weightsB);
      var cmp, i;
      for (i = 0; i < _pairs.length; i++) {
        cmp = _pairs[i][0] - _pairs[i][1];
        if (cmp !== 0) return cmp;
      }
      return 0;
    };
    /**
     * Creates a new concatenated UrlMatcher
     *
     * Builds a new UrlMatcher by appending another UrlMatcher to this one.
     *
     * @param url A `UrlMatcher` instance to append as a child of the current `UrlMatcher`.
     */
    UrlMatcher.prototype.append = function (url) {
      this._children.push(url);
      url._cache = {
        path: this._cache.path.concat(url),
        parent: this,
        pattern: null
      };
      return url;
    };
    /** @internal */
    UrlMatcher.prototype.isRoot = function () {
      return this._cache.path[0] === this;
    };
    /** Returns the input pattern string */
    UrlMatcher.prototype.toString = function () {
      return this.pattern;
    };
    UrlMatcher.prototype._getDecodedParamValue = function (value, param) {
      if (isDefined(value)) {
        if (this.config.decodeParams && !param.type.raw) {
          if (isArray(value)) {
            value = value.map(function (paramValue) {
              return decodeURIComponent(paramValue);
            });
          } else {
            value = decodeURIComponent(value);
          }
        }
        value = param.type.decode(value);
      }
      return param.value(value);
    };
    /**
     * Tests the specified url/path against this matcher.
     *
     * Tests if the given url matches this matcher's pattern, and returns an object containing the captured
     * parameter values.  Returns null if the path does not match.
     *
     * The returned object contains the values
     * of any search parameters that are mentioned in the pattern, but their value may be null if
     * they are not present in `search`. This means that search parameters are always treated
     * as optional.
     *
     * #### Example:
     * ```js
     * new UrlMatcher('/user/{id}?q&r').exec('/user/bob', {
     *   x: '1', q: 'hello'
     * });
     * // returns { id: 'bob', q: 'hello', r: null }
     * ```
     *
     * @param path    The URL path to match, e.g. `$location.path()`.
     * @param search  URL search parameters, e.g. `$location.search()`.
     * @param hash    URL hash e.g. `$location.hash()`.
     * @param options
     *
     * @returns The captured parameter values.
     */
    UrlMatcher.prototype.exec = function (path, search, hash, options) {
      var _this = this;
      if (search === void 0) {
        search = {};
      }
      var match = memoizeTo(this._cache, 'pattern', function () {
        return new RegExp(['^', unnest(_this._cache.path.map(prop('_compiled'))).join(''), _this.config.strict === false ? '/?' : '', '$'].join(''), _this.config.caseInsensitive ? 'i' : undefined);
      }).exec(path);
      if (!match) return null;
      // options = defaults(options, { isolate: false });
      var allParams = this.parameters(),
        pathParams = allParams.filter(function (param) {
          return !param.isSearch();
        }),
        searchParams = allParams.filter(function (param) {
          return param.isSearch();
        }),
        nPathSegments = this._cache.path.map(function (urlm) {
          return urlm._segments.length - 1;
        }).reduce(function (a, x) {
          return a + x;
        }),
        values = {};
      if (nPathSegments !== match.length - 1) throw new Error("Unbalanced capture group in route '" + this.pattern + "'");
      function decodePathArray(paramVal) {
        var reverseString = function reverseString(str) {
          return str.split('').reverse().join('');
        };
        var unquoteDashes = function unquoteDashes(str) {
          return str.replace(/\\-/g, '-');
        };
        var split = reverseString(paramVal).split(/-(?!\\)/);
        var allReversed = map(split, reverseString);
        return map(allReversed, unquoteDashes).reverse();
      }
      for (var i = 0; i < nPathSegments; i++) {
        var param = pathParams[i];
        var value = match[i + 1];
        // if the param value matches a pre-replace pair, replace the value before decoding.
        for (var j = 0; j < param.replace.length; j++) {
          if (param.replace[j].from === value) value = param.replace[j].to;
        }
        if (value && param.array === true) value = decodePathArray(value);
        values[param.id] = this._getDecodedParamValue(value, param);
      }
      searchParams.forEach(function (param) {
        var value = search[param.id];
        for (var j = 0; j < param.replace.length; j++) {
          if (param.replace[j].from === value) value = param.replace[j].to;
        }
        values[param.id] = _this._getDecodedParamValue(value, param);
      });
      if (hash) values['#'] = hash;
      return values;
    };
    /**
     * @internal
     * Returns all the [[Param]] objects of all path and search parameters of this pattern in order of appearance.
     *
     * @returns {Array.<Param>}  An array of [[Param]] objects. Must be treated as read-only. If the
     *    pattern has no parameters, an empty array is returned.
     */
    UrlMatcher.prototype.parameters = function (opts) {
      if (opts === void 0) {
        opts = {};
      }
      if (opts.inherit === false) return this._params;
      return unnest(this._cache.path.map(function (matcher) {
        return matcher._params;
      }));
    };
    /**
     * @internal
     * Returns a single parameter from this UrlMatcher by id
     *
     * @param id
     * @param opts
     * @returns {T|Param|any|boolean|UrlMatcher|null}
     */
    UrlMatcher.prototype.parameter = function (id, opts) {
      var _this = this;
      if (opts === void 0) {
        opts = {};
      }
      var findParam = function findParam() {
        for (var _i = 0, _a = _this._params; _i < _a.length; _i++) {
          var param = _a[_i];
          if (param.id === id) return param;
        }
      };
      var parent = this._cache.parent;
      return findParam() || opts.inherit !== false && parent && parent.parameter(id, opts) || null;
    };
    /**
     * Validates the input parameter values against this UrlMatcher
     *
     * Checks an object hash of parameters to validate their correctness according to the parameter
     * types of this `UrlMatcher`.
     *
     * @param params The object hash of parameters to validate.
     * @returns Returns `true` if `params` validates, otherwise `false`.
     */
    UrlMatcher.prototype.validates = function (params) {
      var validParamVal = function validParamVal(param, val) {
        return !param || param.validates(val);
      };
      params = params || {};
      // I'm not sure why this checks only the param keys passed in, and not all the params known to the matcher
      var paramSchema = this.parameters().filter(function (paramDef) {
        return params.hasOwnProperty(paramDef.id);
      });
      return paramSchema.map(function (paramDef) {
        return validParamVal(paramDef, params[paramDef.id]);
      }).reduce(allTrueR, true);
    };
    /**
     * Given a set of parameter values, creates a URL from this UrlMatcher.
     *
     * Creates a URL that matches this pattern by substituting the specified values
     * for the path and search parameters.
     *
     * #### Example:
     * ```js
     * new UrlMatcher('/user/{id}?q').format({ id:'bob', q:'yes' });
     * // returns '/user/bob?q=yes'
     * ```
     *
     * @param values  the values to substitute for the parameters in this pattern.
     * @returns the formatted URL (path and optionally search part).
     */
    UrlMatcher.prototype.format = function (values) {
      if (values === void 0) {
        values = {};
      }
      // Build the full path of UrlMatchers (including all parent UrlMatchers)
      var urlMatchers = this._cache.path;
      // Extract all the static segments and Params (processed as ParamDetails)
      // into an ordered array
      var pathSegmentsAndParams = urlMatchers.map(UrlMatcher.pathSegmentsAndParams).reduce(unnestR, []).map(function (x) {
        return isString(x) ? x : getDetails(x);
      });
      // Extract the query params into a separate array
      var queryParams = urlMatchers.map(UrlMatcher.queryParams).reduce(unnestR, []).map(getDetails);
      var isInvalid = function isInvalid(param) {
        return param.isValid === false;
      };
      if (pathSegmentsAndParams.concat(queryParams).filter(isInvalid).length) {
        return null;
      }
      /**
       * Given a Param, applies the parameter value, then returns detailed information about it
       */
      function getDetails(param) {
        // Normalize to typed value
        var value = param.value(values[param.id]);
        var isValid = param.validates(value);
        var isDefaultValue = param.isDefaultValue(value);
        // Check if we're in squash mode for the parameter
        var squash = isDefaultValue ? param.squash : false;
        // Allow the Parameter's Type to encode the value
        var encoded = param.type.encode(value);
        return {
          param: param,
          value: value,
          isValid: isValid,
          isDefaultValue: isDefaultValue,
          squash: squash,
          encoded: encoded
        };
      }
      // Build up the path-portion from the list of static segments and parameters
      var pathString = pathSegmentsAndParams.reduce(function (acc, x) {
        // The element is a static segment (a raw string); just append it
        if (isString(x)) return acc + x;
        // Otherwise, it's a ParamDetails.
        var squash = x.squash,
          encoded = x.encoded,
          param = x.param;
        // If squash is === true, try to remove a slash from the path
        if (squash === true) return acc.match(/\/$/) ? acc.slice(0, -1) : acc;
        // If squash is a string, use the string for the param value
        if (isString(squash)) return acc + squash;
        if (squash !== false) return acc; // ?
        if (encoded == null) return acc;
        // If this parameter value is an array, encode the value using encodeDashes
        if (isArray(encoded)) return acc + map(encoded, UrlMatcher.encodeDashes).join('-');
        // If the parameter type is "raw", then do not encodeURIComponent
        if (param.raw) return acc + encoded;
        // Encode the value
        return acc + encodeURIComponent(encoded);
      }, '');
      // Build the query string by applying parameter values (array or regular)
      // then mapping to key=value, then flattening and joining using "&"
      var queryString = queryParams.map(function (paramDetails) {
        var param = paramDetails.param,
          squash = paramDetails.squash,
          encoded = paramDetails.encoded,
          isDefaultValue = paramDetails.isDefaultValue;
        if (encoded == null || isDefaultValue && squash !== false) return;
        if (!isArray(encoded)) encoded = [encoded];
        if (encoded.length === 0) return;
        if (!param.raw) encoded = map(encoded, encodeURIComponent);
        return encoded.map(function (val) {
          return param.id + "=" + val;
        });
      }).filter(identity).reduce(unnestR, []).join('&');
      // Concat the pathstring with the queryString (if exists) and the hashString (if exists)
      return pathString + (queryString ? "?" + queryString : '') + (values['#'] ? '#' + values['#'] : '');
    };
    /** @internal */
    UrlMatcher.nameValidator = /^\w+([-.]+\w+)*(?:\[\])?$/;
    return UrlMatcher;
  }();
  var __assign = undefined && undefined.__assign || function () {
    __assign = Object.assign || function (t) {
      for (var s, i = 1, n = arguments.length; i < n; i++) {
        s = arguments[i];
        for (var p in s) if (Object.prototype.hasOwnProperty.call(s, p)) t[p] = s[p];
      }
      return t;
    };
    return __assign.apply(this, arguments);
  };
  var ParamFactory = /** @class */function () {
    function ParamFactory(router) {
      this.router = router;
    }
    ParamFactory.prototype.fromConfig = function (id, type, state) {
      return new Param(id, type, exports.DefType.CONFIG, this.router.urlService.config, state);
    };
    ParamFactory.prototype.fromPath = function (id, type, state) {
      return new Param(id, type, exports.DefType.PATH, this.router.urlService.config, state);
    };
    ParamFactory.prototype.fromSearch = function (id, type, state) {
      return new Param(id, type, exports.DefType.SEARCH, this.router.urlService.config, state);
    };
    return ParamFactory;
  }();
  /**
   * Factory for [[UrlMatcher]] instances.
   *
   * The factory is available to ng1 services as
   * `$urlMatcherFactory` or ng1 providers as `$urlMatcherFactoryProvider`.
   */
  var UrlMatcherFactory = /** @class */function () {
    // TODO: move implementations to UrlConfig (urlService.config)
    function UrlMatcherFactory(/** @internal */router) {
      var _this = this;
      this.router = router;
      /** Creates a new [[Param]] for a given location (DefType) */
      this.paramFactory = new ParamFactory(this.router);
      // TODO: Check if removal of this will break anything, then remove these
      this.UrlMatcher = UrlMatcher;
      this.Param = Param;
      /** @deprecated use [[UrlConfig.caseInsensitive]] */
      this.caseInsensitive = function (value) {
        return _this.router.urlService.config.caseInsensitive(value);
      };
      /** @deprecated use [[UrlConfig.defaultSquashPolicy]] */
      this.defaultSquashPolicy = function (value) {
        return _this.router.urlService.config.defaultSquashPolicy(value);
      };
      /** @deprecated use [[UrlConfig.strictMode]] */
      this.strictMode = function (value) {
        return _this.router.urlService.config.strictMode(value);
      };
      /** @deprecated use [[UrlConfig.type]] */
      this.type = function (name, definition, definitionFn) {
        return _this.router.urlService.config.type(name, definition, definitionFn) || _this;
      };
    }
    /**
     * Creates a [[UrlMatcher]] for the specified pattern.
     *
     * @param pattern  The URL pattern.
     * @param config  The config object hash.
     * @returns The UrlMatcher.
     */
    UrlMatcherFactory.prototype.compile = function (pattern, config) {
      var urlConfig = this.router.urlService.config;
      // backward-compatible support for config.params -> config.state.params
      var params = config && !config.state && config.params;
      config = params ? __assign({
        state: {
          params: params
        }
      }, config) : config;
      var globalConfig = {
        strict: urlConfig._isStrictMode,
        caseInsensitive: urlConfig._isCaseInsensitive,
        decodeParams: urlConfig._decodeParams
      };
      return new UrlMatcher(pattern, urlConfig.paramTypes, this.paramFactory, extend(globalConfig, config));
    };
    /**
     * Returns true if the specified object is a [[UrlMatcher]], or false otherwise.
     *
     * @param object  The object to perform the type check against.
     * @returns `true` if the object matches the `UrlMatcher` interface, by
     *          implementing all the same methods.
     */
    UrlMatcherFactory.prototype.isMatcher = function (object) {
      // TODO: typeof?
      if (!isObject(object)) return false;
      var result = true;
      forEach(UrlMatcher.prototype, function (val, name) {
        if (isFunction(val)) result = result && isDefined(object[name]) && isFunction(object[name]);
      });
      return result;
    };
    /** @internal */
    UrlMatcherFactory.prototype.$get = function () {
      var urlConfig = this.router.urlService.config;
      urlConfig.paramTypes.enqueue = false;
      urlConfig.paramTypes._flushTypeQueue();
      return this;
    };
    return UrlMatcherFactory;
  }();

  /**
   * Creates a [[UrlRule]]
   *
   * Creates a [[UrlRule]] from a:
   *
   * - `string`
   * - [[UrlMatcher]]
   * - `RegExp`
   * - [[StateObject]]
   */
  var UrlRuleFactory = /** @class */function () {
    function UrlRuleFactory(router) {
      this.router = router;
    }
    UrlRuleFactory.prototype.compile = function (str) {
      return this.router.urlMatcherFactory.compile(str);
    };
    UrlRuleFactory.prototype.create = function (what, handler) {
      var _this = this;
      var isState = StateObject.isState,
        isStateDeclaration = StateObject.isStateDeclaration;
      var makeRule = pattern([[isString, function (_what) {
        return makeRule(_this.compile(_what));
      }], [is(UrlMatcher), function (_what) {
        return _this.fromUrlMatcher(_what, handler);
      }], [or(isState, isStateDeclaration), function (_what) {
        return _this.fromState(_what, _this.router);
      }], [is(RegExp), function (_what) {
        return _this.fromRegExp(_what, handler);
      }], [isFunction, function (_what) {
        return new BaseUrlRule(_what, handler);
      }]]);
      var rule = makeRule(what);
      if (!rule) throw new Error("invalid 'what' in when()");
      return rule;
    };
    /**
     * A UrlRule which matches based on a UrlMatcher
     *
     * The `handler` may be either a `string`, a [[UrlRuleHandlerFn]] or another [[UrlMatcher]]
     *
     * ## Handler as a function
     *
     * If `handler` is a function, the function is invoked with:
     *
     * - matched parameter values ([[RawParams]] from [[UrlMatcher.exec]])
     * - url: the current Url ([[UrlParts]])
     * - router: the router object ([[UIRouter]])
     *
     * #### Example:
     * ```js
     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
     * var rule = factory.fromUrlMatcher(urlMatcher, match => "/home/" + match.fooId + "/" + match.barId);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match); // '/home/123/456'
     * ```
     *
     * ## Handler as UrlMatcher
     *
     * If `handler` is a UrlMatcher, the handler matcher is used to create the new url.
     * The `handler` UrlMatcher is formatted using the matched param from the first matcher.
     * The url is replaced with the result.
     *
     * #### Example:
     * ```js
     * var urlMatcher = $umf.compile("/foo/:fooId/:barId");
     * var handler = $umf.compile("/home/:fooId/:barId");
     * var rule = factory.fromUrlMatcher(urlMatcher, handler);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match); // '/home/123/456'
     * ```
     */
    UrlRuleFactory.prototype.fromUrlMatcher = function (urlMatcher, handler) {
      var _handler = handler;
      if (isString(handler)) handler = this.router.urlMatcherFactory.compile(handler);
      if (is(UrlMatcher)(handler)) _handler = function _handler(match) {
        return handler.format(match);
      };
      function matchUrlParamters(url) {
        var params = urlMatcher.exec(url.path, url.search, url.hash);
        return urlMatcher.validates(params) && params;
      }
      // Prioritize URLs, lowest to highest:
      // - Some optional URL parameters, but none matched
      // - No optional parameters in URL
      // - Some optional parameters, some matched
      // - Some optional parameters, all matched
      function matchPriority(params) {
        var optional = urlMatcher.parameters().filter(function (param) {
          return param.isOptional;
        });
        if (!optional.length) return 0.000001;
        var matched = optional.filter(function (param) {
          return params[param.id];
        });
        return matched.length / optional.length;
      }
      var details = {
        urlMatcher: urlMatcher,
        matchPriority: matchPriority,
        type: 'URLMATCHER'
      };
      return extend(new BaseUrlRule(matchUrlParamters, _handler), details);
    };
    /**
     * A UrlRule which matches a state by its url
     *
     * #### Example:
     * ```js
     * var rule = factory.fromState($state.get('foo'), router);
     * var match = rule.match('/foo/123/456'); // results in { fooId: '123', barId: '456' }
     * var result = rule.handler(match);
     * // Starts a transition to 'foo' with params: { fooId: '123', barId: '456' }
     * ```
     */
    UrlRuleFactory.prototype.fromState = function (stateOrDecl, router) {
      var state = StateObject.isStateDeclaration(stateOrDecl) ? stateOrDecl.$$state() : stateOrDecl;
      /**
       * Handles match by transitioning to matched state
       *
       * First checks if the router should start a new transition.
       * A new transition is not required if the current state's URL
       * and the new URL are already identical
       */
      var handler = function handler(match) {
        var $state = router.stateService;
        var globals = router.globals;
        if ($state.href(state, match) !== $state.href(globals.current, globals.params)) {
          $state.transitionTo(state, match, {
            inherit: true,
            source: 'url'
          });
        }
      };
      var details = {
        state: state,
        type: 'STATE'
      };
      return extend(this.fromUrlMatcher(state.url, handler), details);
    };
    /**
     * A UrlRule which matches based on a regular expression
     *
     * The `handler` may be either a [[UrlRuleHandlerFn]] or a string.
     *
     * ## Handler as a function
     *
     * If `handler` is a function, the function is invoked with:
     *
     * - regexp match array (from `regexp`)
     * - url: the current Url ([[UrlParts]])
     * - router: the router object ([[UIRouter]])
     *
     * #### Example:
     * ```js
     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, match => "/home/" + match[1])
     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
     * var result = rule.handler(match); // '/home/bar'
     * ```
     *
     * ## Handler as string
     *
     * If `handler` is a string, the url is *replaced by the string* when the Rule is invoked.
     * The string is first interpolated using `string.replace()` style pattern.
     *
     * #### Example:
     * ```js
     * var rule = factory.fromRegExp(/^\/foo\/(bar|baz)$/, "/home/$1")
     * var match = rule.match('/foo/bar'); // results in [ '/foo/bar', 'bar' ]
     * var result = rule.handler(match); // '/home/bar'
     * ```
     */
    UrlRuleFactory.prototype.fromRegExp = function (regexp, handler) {
      if (regexp.global || regexp.sticky) throw new Error('Rule RegExp must not be global or sticky');
      /**
       * If handler is a string, the url will be replaced by the string.
       * If the string has any String.replace() style variables in it (like `$2`),
       * they will be replaced by the captures from [[match]]
       */
      var redirectUrlTo = function redirectUrlTo(match) {
        // Interpolates matched values into $1 $2, etc using a String.replace()-style pattern
        return handler.replace(/\$(\$|\d{1,2})/, function (m, what) {
          return match[what === '$' ? 0 : Number(what)];
        });
      };
      var _handler = isString(handler) ? redirectUrlTo : handler;
      var matchParamsFromRegexp = function matchParamsFromRegexp(url) {
        return regexp.exec(url.path);
      };
      var details = {
        regexp: regexp,
        type: 'REGEXP'
      };
      return extend(new BaseUrlRule(matchParamsFromRegexp, _handler), details);
    };
    UrlRuleFactory.isUrlRule = function (obj) {
      return obj && ['type', 'match', 'handler'].every(function (key) {
        return isDefined(obj[key]);
      });
    };
    return UrlRuleFactory;
  }();
  /**
   * A base rule which calls `match`
   *
   * The value from the `match` function is passed through to the `handler`.
   * @internal
   */
  var BaseUrlRule = /** @class */function () {
    function BaseUrlRule(match, handler) {
      var _this = this;
      this.match = match;
      this.type = 'RAW';
      this.matchPriority = function (match) {
        return 0 - _this.$id;
      };
      this.handler = handler || identity;
    }
    return BaseUrlRule;
  }();
  function appendBasePath(url, isHtml5, absolute, baseHref) {
    if (baseHref === '/') return url;
    if (isHtml5) return stripLastPathElement(baseHref) + url;
    if (absolute) return baseHref.slice(1) + url;
    return url;
  }
  /**
   * Updates URL and responds to URL changes
   *
   * ### Deprecation warning:
   * This class is now considered to be an internal API
   * Use the [[UrlService]] instead.
   * For configuring URL rules, use the [[UrlRules]] which can be found as [[UrlService.rules]].
   */
  var UrlRouter = /** @class */function () {
    /** @internal */
    function UrlRouter(/** @internal */router) {
      var _this = this;
      this.router = router;
      // Delegate these calls to [[UrlService]]
      /** @deprecated use [[UrlService.sync]]*/
      this.sync = function (evt) {
        return _this.router.urlService.sync(evt);
      };
      /** @deprecated use [[UrlService.listen]]*/
      this.listen = function (enabled) {
        return _this.router.urlService.listen(enabled);
      };
      /** @deprecated use [[UrlService.deferIntercept]]*/
      this.deferIntercept = function (defer) {
        return _this.router.urlService.deferIntercept(defer);
      };
      /** @deprecated use [[UrlService.match]]*/
      this.match = function (urlParts) {
        return _this.router.urlService.match(urlParts);
      };
      // Delegate these calls to [[UrlRules]]
      /** @deprecated use [[UrlRules.initial]]*/
      this.initial = function (handler) {
        return _this.router.urlService.rules.initial(handler);
      };
      /** @deprecated use [[UrlRules.otherwise]]*/
      this.otherwise = function (handler) {
        return _this.router.urlService.rules.otherwise(handler);
      };
      /** @deprecated use [[UrlRules.removeRule]]*/
      this.removeRule = function (rule) {
        return _this.router.urlService.rules.removeRule(rule);
      };
      /** @deprecated use [[UrlRules.rule]]*/
      this.rule = function (rule) {
        return _this.router.urlService.rules.rule(rule);
      };
      /** @deprecated use [[UrlRules.rules]]*/
      this.rules = function () {
        return _this.router.urlService.rules.rules();
      };
      /** @deprecated use [[UrlRules.sort]]*/
      this.sort = function (compareFn) {
        return _this.router.urlService.rules.sort(compareFn);
      };
      /** @deprecated use [[UrlRules.when]]*/
      this.when = function (matcher, handler, options) {
        return _this.router.urlService.rules.when(matcher, handler, options);
      };
      this.urlRuleFactory = new UrlRuleFactory(router);
    }
    /** Internal API. */
    UrlRouter.prototype.update = function (read) {
      var $url = this.router.locationService;
      if (read) {
        this.location = $url.url();
        return;
      }
      if ($url.url() === this.location) return;
      $url.url(this.location, true);
    };
    /**
     * Internal API.
     *
     * Pushes a new location to the browser history.
     *
     * @internal
     * @param urlMatcher
     * @param params
     * @param options
     */
    UrlRouter.prototype.push = function (urlMatcher, params, options) {
      var replace = options && !!options.replace;
      this.router.urlService.url(urlMatcher.format(params || {}), replace);
    };
    /**
     * Builds and returns a URL with interpolated parameters
     *
     * #### Example:
     * ```js
     * matcher = $umf.compile("/about/:person");
     * params = { person: "bob" };
     * $bob = $urlRouter.href(matcher, params);
     * // $bob == "/about/bob";
     * ```
     *
     * @param urlMatcher The [[UrlMatcher]] object which is used as the template of the URL to generate.
     * @param params An object of parameter values to fill the matcher's required parameters.
     * @param options Options object. The options are:
     *
     * - **`absolute`** - {boolean=false},  If true will generate an absolute url, e.g. "http://www.example.com/fullurl".
     *
     * @returns Returns the fully compiled URL, or `null` if `params` fail validation against `urlMatcher`
     */
    UrlRouter.prototype.href = function (urlMatcher, params, options) {
      var url = urlMatcher.format(params);
      if (url == null) return null;
      options = options || {
        absolute: false
      };
      var cfg = this.router.urlService.config;
      var isHtml5 = cfg.html5Mode();
      if (!isHtml5 && url !== null) {
        url = '#' + cfg.hashPrefix() + url;
      }
      url = appendBasePath(url, isHtml5, options.absolute, cfg.baseHref());
      if (!options.absolute || !url) {
        return url;
      }
      var slash = !isHtml5 && url ? '/' : '';
      var cfgPort = cfg.port();
      var port = cfgPort === 80 || cfgPort === 443 ? '' : ':' + cfgPort;
      return [cfg.protocol(), '://', cfg.host(), port, slash, url].join('');
    };
    Object.defineProperty(UrlRouter.prototype, "interceptDeferred", {
      /** @deprecated use [[UrlService.interceptDeferred]]*/
      get: function get() {
        return this.router.urlService.interceptDeferred;
      },
      enumerable: false,
      configurable: true
    });
    return UrlRouter;
  }();

  /**
   * The View service
   *
   * This service pairs existing `ui-view` components (which live in the DOM)
   * with view configs (from the state declaration objects: [[StateDeclaration.views]]).
   *
   * - After a successful Transition, the views from the newly entered states are activated via [[activateViewConfig]].
   *   The views from exited states are deactivated via [[deactivateViewConfig]].
   *   (See: the [[registerActivateViews]] Transition Hook)
   *
   * - As `ui-view` components pop in and out of existence, they register themselves using [[registerUIView]].
   *
   * - When the [[sync]] function is called, the registered `ui-view`(s) ([[ActiveUIView]])
   * are configured with the matching [[ViewConfig]](s)
   *
   */
  var ViewService = /** @class */function () {
    /** @internal */
    function ViewService(/** @internal */router) {
      var _this = this;
      this.router = router;
      /** @internal */
      this._uiViews = [];
      /** @internal */
      this._viewConfigs = [];
      /** @internal */
      this._viewConfigFactories = {};
      /** @internal */
      this._listeners = [];
      /** @internal */
      this._pluginapi = {
        _rootViewContext: this._rootViewContext.bind(this),
        _viewConfigFactory: this._viewConfigFactory.bind(this),
        _registeredUIView: function _registeredUIView(id) {
          return find(_this._uiViews, function (view) {
            return _this.router.$id + "." + view.id === id;
          });
        },
        _registeredUIViews: function _registeredUIViews() {
          return _this._uiViews;
        },
        _activeViewConfigs: function _activeViewConfigs() {
          return _this._viewConfigs;
        },
        _onSync: function _onSync(listener) {
          _this._listeners.push(listener);
          return function () {
            return removeFrom(_this._listeners, listener);
          };
        }
      };
    }
    /**
     * Normalizes a view's name from a state.views configuration block.
     *
     * This should be used by a framework implementation to calculate the values for
     * [[_ViewDeclaration.$uiViewName]] and [[_ViewDeclaration.$uiViewContextAnchor]].
     *
     * @param context the context object (state declaration) that the view belongs to
     * @param rawViewName the name of the view, as declared in the [[StateDeclaration.views]]
     *
     * @returns the normalized uiViewName and uiViewContextAnchor that the view targets
     */
    ViewService.normalizeUIViewTarget = function (context, rawViewName) {
      if (rawViewName === void 0) {
        rawViewName = '';
      }
      // TODO: Validate incoming view name with a regexp to allow:
      // ex: "view.name@foo.bar" , "^.^.view.name" , "view.name@^.^" , "" ,
      // "@" , "$default@^" , "!$default.$default" , "!foo.bar"
      var viewAtContext = rawViewName.split('@');
      var uiViewName = viewAtContext[0] || '$default'; // default to unnamed view
      var uiViewContextAnchor = isString(viewAtContext[1]) ? viewAtContext[1] : '^'; // default to parent context
      // Handle relative view-name sugar syntax.
      // Matches rawViewName "^.^.^.foo.bar" into array: ["^.^.^.foo.bar", "^.^.^", "foo.bar"],
      var relativeViewNameSugar = /^(\^(?:\.\^)*)\.(.*$)/.exec(uiViewName);
      if (relativeViewNameSugar) {
        // Clobbers existing contextAnchor (rawViewName validation will fix this)
        uiViewContextAnchor = relativeViewNameSugar[1]; // set anchor to "^.^.^"
        uiViewName = relativeViewNameSugar[2]; // set view-name to "foo.bar"
      }
      if (uiViewName.charAt(0) === '!') {
        uiViewName = uiViewName.substr(1);
        uiViewContextAnchor = ''; // target absolutely from root
      }
      // handle parent relative targeting "^.^.^"
      var relativeMatch = /^(\^(?:\.\^)*)$/;
      if (relativeMatch.exec(uiViewContextAnchor)) {
        var anchorState = uiViewContextAnchor.split('.').reduce(function (anchor, x) {
          return anchor.parent;
        }, context);
        uiViewContextAnchor = anchorState.name;
      } else if (uiViewContextAnchor === '.') {
        uiViewContextAnchor = context.name;
      }
      return {
        uiViewName: uiViewName,
        uiViewContextAnchor: uiViewContextAnchor
      };
    };
    /** @internal */
    ViewService.prototype._rootViewContext = function (context) {
      return this._rootContext = context || this._rootContext;
    };
    /** @internal */
    ViewService.prototype._viewConfigFactory = function (viewType, factory) {
      this._viewConfigFactories[viewType] = factory;
    };
    ViewService.prototype.createViewConfig = function (path, decl) {
      var cfgFactory = this._viewConfigFactories[decl.$type];
      if (!cfgFactory) throw new Error('ViewService: No view config factory registered for type ' + decl.$type);
      var cfgs = cfgFactory(path, decl);
      return isArray(cfgs) ? cfgs : [cfgs];
    };
    /**
     * Deactivates a ViewConfig.
     *
     * This function deactivates a `ViewConfig`.
     * After calling [[sync]], it will un-pair from any `ui-view` with which it is currently paired.
     *
     * @param viewConfig The ViewConfig view to deregister.
     */
    ViewService.prototype.deactivateViewConfig = function (viewConfig) {
      trace.traceViewServiceEvent('<- Removing', viewConfig);
      removeFrom(this._viewConfigs, viewConfig);
    };
    ViewService.prototype.activateViewConfig = function (viewConfig) {
      trace.traceViewServiceEvent('-> Registering', viewConfig);
      this._viewConfigs.push(viewConfig);
    };
    ViewService.prototype.sync = function () {
      var _this = this;
      var uiViewsByFqn = this._uiViews.map(function (uiv) {
        return [uiv.fqn, uiv];
      }).reduce(applyPairs, {});
      // Return a weighted depth value for a uiView.
      // The depth is the nesting depth of ui-views (based on FQN; times 10,000)
      // plus the depth of the state that is populating the uiView
      function uiViewDepth(uiView) {
        var _stateDepth = function stateDepth(context) {
          return context && context.parent ? _stateDepth(context.parent) + 1 : 1;
        };
        return uiView.fqn.split('.').length * 10000 + _stateDepth(uiView.creationContext);
      }
      // Return the ViewConfig's context's depth in the context tree.
      function viewConfigDepth(config) {
        var context = config.viewDecl.$context,
          count = 0;
        while (++count && context.parent) context = context.parent;
        return count;
      }
      // Given a depth function, returns a compare function which can return either ascending or descending order
      var depthCompare = curry(function (depthFn, posNeg, left, right) {
        return posNeg * (depthFn(left) - depthFn(right));
      });
      var matchingConfigPair = function matchingConfigPair(uiView) {
        var matchingConfigs = _this._viewConfigs.filter(ViewService.matches(uiViewsByFqn, uiView));
        if (matchingConfigs.length > 1) {
          // This is OK.  Child states can target a ui-view that the parent state also targets (the child wins)
          // Sort by depth and return the match from the deepest child
          // console.log(`Multiple matching view configs for ${uiView.fqn}`, matchingConfigs);
          matchingConfigs.sort(depthCompare(viewConfigDepth, -1)); // descending
        }
        return {
          uiView: uiView,
          viewConfig: matchingConfigs[0]
        };
      };
      var configureUIView = function configureUIView(tuple) {
        // If a parent ui-view is reconfigured, it could destroy child ui-views.
        // Before configuring a child ui-view, make sure it's still in the active uiViews array.
        if (_this._uiViews.indexOf(tuple.uiView) !== -1) tuple.uiView.configUpdated(tuple.viewConfig);
      };
      // Sort views by FQN and state depth. Process uiviews nearest the root first.
      var uiViewTuples = this._uiViews.sort(depthCompare(uiViewDepth, 1)).map(matchingConfigPair);
      var matchedViewConfigs = uiViewTuples.map(function (tuple) {
        return tuple.viewConfig;
      });
      var unmatchedConfigTuples = this._viewConfigs.filter(function (config) {
        return !inArray(matchedViewConfigs, config);
      }).map(function (viewConfig) {
        return {
          uiView: undefined,
          viewConfig: viewConfig
        };
      });
      uiViewTuples.forEach(configureUIView);
      var allTuples = uiViewTuples.concat(unmatchedConfigTuples);
      this._listeners.forEach(function (cb) {
        return cb(allTuples);
      });
      trace.traceViewSync(allTuples);
    };
    /**
     * Registers a `ui-view` component
     *
     * When a `ui-view` component is created, it uses this method to register itself.
     * After registration the [[sync]] method is used to ensure all `ui-view` are configured with the proper [[ViewConfig]].
     *
     * Note: the `ui-view` component uses the `ViewConfig` to determine what view should be loaded inside the `ui-view`,
     * and what the view's state context is.
     *
     * Note: There is no corresponding `deregisterUIView`.
     *       A `ui-view` should hang on to the return value of `registerUIView` and invoke it to deregister itself.
     *
     * @param uiView The metadata for a UIView
     * @return a de-registration function used when the view is destroyed.
     */
    ViewService.prototype.registerUIView = function (uiView) {
      trace.traceViewServiceUIViewEvent('-> Registering', uiView);
      var uiViews = this._uiViews;
      var fqnAndTypeMatches = function fqnAndTypeMatches(uiv) {
        return uiv.fqn === uiView.fqn && uiv.$type === uiView.$type;
      };
      if (uiViews.filter(fqnAndTypeMatches).length) trace.traceViewServiceUIViewEvent('!!!! duplicate uiView named:', uiView);
      uiViews.push(uiView);
      this.sync();
      return function () {
        var idx = uiViews.indexOf(uiView);
        if (idx === -1) {
          trace.traceViewServiceUIViewEvent('Tried removing non-registered uiView', uiView);
          return;
        }
        trace.traceViewServiceUIViewEvent('<- Deregistering', uiView);
        removeFrom(uiViews)(uiView);
      };
    };
    /**
     * Returns the list of views currently available on the page, by fully-qualified name.
     *
     * @return {Array} Returns an array of fully-qualified view names.
     */
    ViewService.prototype.available = function () {
      return this._uiViews.map(prop('fqn'));
    };
    /**
     * Returns the list of views on the page containing loaded content.
     *
     * @return {Array} Returns an array of fully-qualified view names.
     */
    ViewService.prototype.active = function () {
      return this._uiViews.filter(prop('$config')).map(prop('name'));
    };
    /**
     * Given a ui-view and a ViewConfig, determines if they "match".
     *
     * A ui-view has a fully qualified name (fqn) and a context object.  The fqn is built from its overall location in
     * the DOM, describing its nesting relationship to any parent ui-view tags it is nested inside of.
     *
     * A ViewConfig has a target ui-view name and a context anchor.  The ui-view name can be a simple name, or
     * can be a segmented ui-view path, describing a portion of a ui-view fqn.
     *
     * In order for a ui-view to match ViewConfig, ui-view's $type must match the ViewConfig's $type
     *
     * If the ViewConfig's target ui-view name is a simple name (no dots), then a ui-view matches if:
     * - the ui-view's name matches the ViewConfig's target name
     * - the ui-view's context matches the ViewConfig's anchor
     *
     * If the ViewConfig's target ui-view name is a segmented name (with dots), then a ui-view matches if:
     * - There exists a parent ui-view where:
     *    - the parent ui-view's name matches the first segment (index 0) of the ViewConfig's target name
     *    - the parent ui-view's context matches the ViewConfig's anchor
     * - And the remaining segments (index 1..n) of the ViewConfig's target name match the tail of the ui-view's fqn
     *
     * Example:
     *
     * DOM:
     * <ui-view>                        <!-- created in the root context (name: "") -->
     *   <ui-view name="foo">                <!-- created in the context named: "A"      -->
     *     <ui-view>                    <!-- created in the context named: "A.B"    -->
     *       <ui-view name="bar">            <!-- created in the context named: "A.B.C"  -->
     *       </ui-view>
     *     </ui-view>
     *   </ui-view>
     * </ui-view>
     *
     * uiViews: [
     *  { fqn: "$default",                  creationContext: { name: "" } },
     *  { fqn: "$default.foo",              creationContext: { name: "A" } },
     *  { fqn: "$default.foo.$default",     creationContext: { name: "A.B" } }
     *  { fqn: "$default.foo.$default.bar", creationContext: { name: "A.B.C" } }
     * ]
     *
     * These four view configs all match the ui-view with the fqn: "$default.foo.$default.bar":
     *
     * - ViewConfig1: { uiViewName: "bar",                       uiViewContextAnchor: "A.B.C" }
     * - ViewConfig2: { uiViewName: "$default.bar",              uiViewContextAnchor: "A.B" }
     * - ViewConfig3: { uiViewName: "foo.$default.bar",          uiViewContextAnchor: "A" }
     * - ViewConfig4: { uiViewName: "$default.foo.$default.bar", uiViewContextAnchor: "" }
     *
     * Using ViewConfig3 as an example, it matches the ui-view with fqn "$default.foo.$default.bar" because:
     * - The ViewConfig's segmented target name is: [ "foo", "$default", "bar" ]
     * - There exists a parent ui-view (which has fqn: "$default.foo") where:
     *    - the parent ui-view's name "foo" matches the first segment "foo" of the ViewConfig's target name
     *    - the parent ui-view's context "A" matches the ViewConfig's anchor context "A"
     * - And the remaining segments [ "$default", "bar" ].join("."_ of the ViewConfig's target name match
     *   the tail of the ui-view's fqn "default.bar"
     *
     * @internal
     */
    ViewService.matches = function (uiViewsByFqn, uiView) {
      return function (viewConfig) {
        // Don't supply an ng1 ui-view with an ng2 ViewConfig, etc
        if (uiView.$type !== viewConfig.viewDecl.$type) return false;
        // Split names apart from both viewConfig and uiView into segments
        var vc = viewConfig.viewDecl;
        var vcSegments = vc.$uiViewName.split('.');
        var uivSegments = uiView.fqn.split('.');
        // Check if the tails of the segment arrays match. ex, these arrays' tails match:
        // vc: ["foo", "bar"], uiv fqn: ["$default", "foo", "bar"]
        if (!equals(vcSegments, uivSegments.slice(0 - vcSegments.length))) return false;
        // Now check if the fqn ending at the first segment of the viewConfig matches the context:
        // ["$default", "foo"].join(".") == "$default.foo", does the ui-view $default.foo context match?
        var negOffset = 1 - vcSegments.length || undefined;
        var fqnToFirstSegment = uivSegments.slice(0, negOffset).join('.');
        var uiViewContext = uiViewsByFqn[fqnToFirstSegment].creationContext;
        return vc.$uiViewContextAnchor === (uiViewContext && uiViewContext.name);
      };
    };
    return ViewService;
  }();

  /**
   * Global router state
   *
   * This is where we hold the global mutable state such as current state, current
   * params, current transition, etc.
   */
  var UIRouterGlobals = /** @class */function () {
    function UIRouterGlobals() {
      /**
       * Current parameter values
       *
       * The parameter values from the latest successful transition
       */
      this.params = new StateParams();
      /** @internal */
      this.lastStartedTransitionId = -1;
      /** @internal */
      this.transitionHistory = new Queue([], 1);
      /** @internal */
      this.successfulTransitions = new Queue([], 1);
    }
    UIRouterGlobals.prototype.dispose = function () {
      this.transitionHistory.clear();
      this.successfulTransitions.clear();
      this.transition = null;
    };
    return UIRouterGlobals;
  }();
  var prioritySort = function prioritySort(a, b) {
    return (b.priority || 0) - (a.priority || 0);
  };
  var typeSort = function typeSort(a, b) {
    var weights = {
      STATE: 4,
      URLMATCHER: 4,
      REGEXP: 3,
      RAW: 2,
      OTHER: 1
    };
    return (weights[a.type] || 0) - (weights[b.type] || 0);
  };
  var urlMatcherSort = function urlMatcherSort(a, b) {
    return !a.urlMatcher || !b.urlMatcher ? 0 : UrlMatcher.compare(a.urlMatcher, b.urlMatcher);
  };
  var idSort = function idSort(a, b) {
    // Identically sorted STATE and URLMATCHER best rule will be chosen by `matchPriority` after each rule matches the URL
    var useMatchPriority = {
      STATE: true,
      URLMATCHER: true
    };
    var equal = useMatchPriority[a.type] && useMatchPriority[b.type];
    return equal ? 0 : (a.$id || 0) - (b.$id || 0);
  };
  /**
   * Default rule priority sorting function.
   *
   * Sorts rules by:
   *
   * - Explicit priority (set rule priority using [[UrlRules.when]])
   * - Rule type (STATE: 4, URLMATCHER: 4, REGEXP: 3, RAW: 2, OTHER: 1)
   * - `UrlMatcher` specificity ([[UrlMatcher.compare]]): works for STATE and URLMATCHER types to pick the most specific rule.
   * - Rule registration order (for rule types other than STATE and URLMATCHER)
   *   - Equally sorted State and UrlMatcher rules will each match the URL.
   *     Then, the *best* match is chosen based on how many parameter values were matched.
   */
  var defaultRuleSortFn;
  defaultRuleSortFn = function defaultRuleSortFn(a, b) {
    var cmp = prioritySort(a, b);
    if (cmp !== 0) return cmp;
    cmp = typeSort(a, b);
    if (cmp !== 0) return cmp;
    cmp = urlMatcherSort(a, b);
    if (cmp !== 0) return cmp;
    return idSort(a, b);
  };
  function getHandlerFn(handler) {
    if (!isFunction(handler) && !isString(handler) && !is(TargetState)(handler) && !TargetState.isDef(handler)) {
      throw new Error("'handler' must be a string, function, TargetState, or have a state: 'newtarget' property");
    }
    return isFunction(handler) ? handler : val(handler);
  }
  /**
   * API for managing URL rules
   *
   * This API is used to create and manage URL rules.
   * URL rules are a mechanism to respond to specific URL patterns.
   *
   * The most commonly used methods are [[otherwise]] and [[when]].
   *
   * This API is found at `router.urlService.rules` (see: [[UIRouter.urlService]], [[URLService.rules]])
   */
  var UrlRules = /** @class */function () {
    /** @internal */
    function UrlRules(/** @internal */router) {
      this.router = router;
      /** @internal */
      this._sortFn = defaultRuleSortFn;
      /** @internal */
      this._rules = [];
      /** @internal */
      this._id = 0;
      this.urlRuleFactory = new UrlRuleFactory(router);
    }
    /** @internal */
    UrlRules.prototype.dispose = function (router) {
      this._rules = [];
      delete this._otherwiseFn;
    };
    /**
     * Defines the initial state, path, or behavior to use when the app starts.
     *
     * This rule defines the initial/starting state for the application.
     *
     * This rule is triggered the first time the URL is checked (when the app initially loads).
     * The rule is triggered only when the url matches either `""` or `"/"`.
     *
     * Note: The rule is intended to be used when the root of the application is directly linked to.
     * When the URL is *not* `""` or `"/"` and doesn't match other rules, the [[otherwise]] rule is triggered.
     * This allows 404-like behavior when an unknown URL is deep-linked.
     *
     * #### Example:
     * Start app at `home` state.
     * ```js
     * .initial({ state: 'home' });
     * ```
     *
     * #### Example:
     * Start app at `/home` (by url)
     * ```js
     * .initial('/home');
     * ```
     *
     * #### Example:
     * When no other url rule matches, go to `home` state
     * ```js
     * .initial((matchValue, url, router) => {
     *   console.log('initial state');
     *   return { state: 'home' };
     * })
     * ```
     *
     * @param handler The initial state or url path, or a function which returns the state or url path (or performs custom logic).
     */
    UrlRules.prototype.initial = function (handler) {
      var handlerFn = getHandlerFn(handler);
      var matchFn = function matchFn(urlParts, router) {
        return router.globals.transitionHistory.size() === 0 && !!/^\/?$/.exec(urlParts.path);
      };
      this.rule(this.urlRuleFactory.create(matchFn, handlerFn));
    };
    /**
     * Defines the state, url, or behavior to use when no other rule matches the URL.
     *
     * This rule is matched when *no other rule* matches.
     * It is generally used to handle unknown URLs (similar to "404" behavior, but on the client side).
     *
     * - If `handler` a string, it is treated as a url redirect
     *
     * #### Example:
     * When no other url rule matches, redirect to `/index`
     * ```js
     * .otherwise('/index');
     * ```
     *
     * - If `handler` is an object with a `state` property, the state is activated.
     *
     * #### Example:
     * When no other url rule matches, redirect to `home` and provide a `dashboard` parameter value.
     * ```js
     * .otherwise({ state: 'home', params: { dashboard: 'default' } });
     * ```
     *
     * - If `handler` is a function, the function receives the current url ([[UrlParts]]) and the [[UIRouter]] object.
     *   The function can perform actions, and/or return a value.
     *
     * #### Example:
     * When no other url rule matches, manually trigger a transition to the `home` state
     * ```js
     * .otherwise((matchValue, urlParts, router) => {
     *   router.stateService.go('home');
     * });
     * ```
     *
     * #### Example:
     * When no other url rule matches, go to `home` state
     * ```js
     * .otherwise((matchValue, urlParts, router) => {
     *   return { state: 'home' };
     * });
     * ```
     *
     * @param handler The url path to redirect to, or a function which returns the url path (or performs custom logic).
     */
    UrlRules.prototype.otherwise = function (handler) {
      var handlerFn = getHandlerFn(handler);
      this._otherwiseFn = this.urlRuleFactory.create(val(true), handlerFn);
      this._sorted = false;
    };
    /**
     * Remove a rule previously registered
     *
     * @param rule the matcher rule that was previously registered using [[rule]]
     */
    UrlRules.prototype.removeRule = function (rule) {
      removeFrom(this._rules, rule);
    };
    /**
     * Manually adds a URL Rule.
     *
     * Usually, a url rule is added using [[StateDeclaration.url]] or [[when]].
     * This api can be used directly for more control (to register a [[BaseUrlRule]], for example).
     * Rules can be created using [[urlRuleFactory]], or created manually as simple objects.
     *
     * A rule should have a `match` function which returns truthy if the rule matched.
     * It should also have a `handler` function which is invoked if the rule is the best match.
     *
     * @return a function that deregisters the rule
     */
    UrlRules.prototype.rule = function (rule) {
      var _this = this;
      if (!UrlRuleFactory.isUrlRule(rule)) throw new Error('invalid rule');
      rule.$id = this._id++;
      rule.priority = rule.priority || 0;
      this._rules.push(rule);
      this._sorted = false;
      return function () {
        return _this.removeRule(rule);
      };
    };
    /**
     * Gets all registered rules
     *
     * @returns an array of all the registered rules
     */
    UrlRules.prototype.rules = function () {
      this.ensureSorted();
      return this._rules.concat(this._otherwiseFn ? [this._otherwiseFn] : []);
    };
    /**
     * Defines URL Rule priorities
     *
     * More than one rule ([[UrlRule]]) might match a given URL.
     * This `compareFn` is used to sort the rules by priority.
     * Higher priority rules should sort earlier.
     *
     * The [[defaultRuleSortFn]] is used by default.
     *
     * You only need to call this function once.
     * The `compareFn` will be used to sort the rules as each is registered.
     *
     * If called without any parameter, it will re-sort the rules.
     *
     * ---
     *
     * Url rules may come from multiple sources: states's urls ([[StateDeclaration.url]]), [[when]], and [[rule]].
     * Each rule has a (user-provided) [[UrlRule.priority]], a [[UrlRule.type]], and a [[UrlRule.$id]]
     * The `$id` is is the order in which the rule was registered.
     *
     * The sort function should use these data, or data found on a specific type
     * of [[UrlRule]] (such as [[StateRule.state]]), to order the rules as desired.
     *
     * #### Example:
     * This compare function prioritizes rules by the order in which the rules were registered.
     * A rule registered earlier has higher priority.
     *
     * ```js
     * function compareFn(a, b) {
     *   return a.$id - b.$id;
     * }
     * ```
     *
     * @param compareFn a function that compares to [[UrlRule]] objects.
     *    The `compareFn` should abide by the `Array.sort` compare function rules.
     *    Given two rules, `a` and `b`, return a negative number if `a` should be higher priority.
     *    Return a positive number if `b` should be higher priority.
     *    Return `0` if the rules are identical.
     *
     *    See the [mozilla reference](https://developer.mozilla.org/en-US/docs/Web/JavaScript/Reference/Global_Objects/Array/sort#Description)
     *    for details.
     */
    UrlRules.prototype.sort = function (compareFn) {
      var sorted = this.stableSort(this._rules, this._sortFn = compareFn || this._sortFn);
      // precompute _sortGroup values and apply to each rule
      var group = 0;
      for (var i = 0; i < sorted.length; i++) {
        sorted[i]._group = group;
        if (i < sorted.length - 1 && this._sortFn(sorted[i], sorted[i + 1]) !== 0) {
          group++;
        }
      }
      this._rules = sorted;
      this._sorted = true;
    };
    /** @internal */
    UrlRules.prototype.ensureSorted = function () {
      this._sorted || this.sort();
    };
    /** @internal */
    UrlRules.prototype.stableSort = function (arr, compareFn) {
      var arrOfWrapper = arr.map(function (elem, idx) {
        return {
          elem: elem,
          idx: idx
        };
      });
      arrOfWrapper.sort(function (wrapperA, wrapperB) {
        var cmpDiff = compareFn(wrapperA.elem, wrapperB.elem);
        return cmpDiff === 0 ? wrapperA.idx - wrapperB.idx : cmpDiff;
      });
      return arrOfWrapper.map(function (wrapper) {
        return wrapper.elem;
      });
    };
    /**
     * Registers a `matcher` and `handler` for custom URLs handling.
     *
     * The `matcher` can be:
     *
     * - a [[UrlMatcher]]: See: [[UrlMatcherFactory.compile]]
     * - a `string`: The string is compiled to a [[UrlMatcher]]
     * - a `RegExp`: The regexp is used to match the url.
     *
     * The `handler` can be:
     *
     * - a string: The url is redirected to the value of the string.
     * - a function: The url is redirected to the return value of the function.
     *
     * ---
     *
     * When the `handler` is a `string` and the `matcher` is a `UrlMatcher` (or string), the redirect
     * string is interpolated with parameter values.
     *
     * #### Example:
     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
     * ```js
     * .when("/foo/:param1", "/bar/:param1")
     * ```
     *
     * ---
     *
     * When the `handler` is a string and the `matcher` is a `RegExp`, the redirect string is
     * interpolated with capture groups from the RegExp.
     *
     * #### Example:
     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
     * ```js
     * .when(new RegExp("^/foo/(.*)$"), "/bar/$1");
     * ```
     *
     * ---
     *
     * When the handler is a function, it receives the matched value, the current URL, and the `UIRouter` object (See [[UrlRuleHandlerFn]]).
     * The "matched value" differs based on the `matcher`.
     * For [[UrlMatcher]]s, it will be the matched state params.
     * For `RegExp`, it will be the match array from `regexp.exec()`.
     *
     * If the handler returns a string, the URL is redirected to the string.
     *
     * #### Example:
     * When the URL is `/foo/123` the rule will redirect to `/bar/123`.
     * ```js
     * .when(new RegExp("^/foo/(.*)$"), match => "/bar/" + match[1]);
     * ```
     *
     * Note: the `handler` may also invoke arbitrary code, such as `$state.go()`
     *
     * @param matcher A pattern `string` to match, compiled as a [[UrlMatcher]], or a `RegExp`.
     * @param handler The path to redirect to, or a function that returns the path.
     * @param options `{ priority: number }`
     *
     * @return the registered [[UrlRule]]
     */
    UrlRules.prototype.when = function (matcher, handler, options) {
      var rule = this.urlRuleFactory.create(matcher, handler);
      if (isDefined(options && options.priority)) rule.priority = options.priority;
      this.rule(rule);
      return rule;
    };
    return UrlRules;
  }();

  /**
   * An API to customize the URL behavior and retrieve URL configuration
   *
   * This API is used to customize the behavior of the URL.
   * This includes optional trailing slashes ([[strictMode]]), case sensitivity ([[caseInsensitive]]),
   * and custom parameter encoding (custom [[type]]).
   *
   * It also has information about the location (url) configuration such as [[port]] and [[baseHref]].
   * This information can be used to build absolute URLs, such as
   * `https://example.com:443/basepath/state/substate?param1=a#hashvalue`;
   *
   * This API is found at `router.urlService.config` (see: [[UIRouter.urlService]], [[URLService.config]])
   */
  var UrlConfig = /** @class */function () {
    /** @internal */function UrlConfig(/** @internal */router) {
      var _this = this;
      this.router = router;
      /** @internal */
      this.paramTypes = new ParamTypes();
      /** @internal */
      this._decodeParams = true;
      /** @internal */
      this._isCaseInsensitive = false;
      /** @internal */
      this._isStrictMode = true;
      /** @internal */
      this._defaultSquashPolicy = false;
      /** @internal */
      this.dispose = function () {
        return _this.paramTypes.dispose();
      };
      // Delegate these calls to the current LocationConfig implementation
      /**
       * Gets the base Href, e.g., `http://localhost/approot/`
       *
       * @return the application's base href
       */
      this.baseHref = function () {
        return _this.router.locationConfig.baseHref();
      };
      /**
       * Gets or sets the hashPrefix
       *
       * This only applies when not running in [[html5Mode]] (pushstate mode)
       *
       * If the current url is `http://localhost/app#!/uirouter/path/#anchor`, it returns `!` which is the prefix for the "hashbang" portion.
       *
       * @return the hash prefix
       */
      this.hashPrefix = function (newprefix) {
        return _this.router.locationConfig.hashPrefix(newprefix);
      };
      /**
       * Gets the host, e.g., `localhost`
       *
       * @return the protocol
       */
      this.host = function () {
        return _this.router.locationConfig.host();
      };
      /**
       * Returns true when running in pushstate mode
       *
       * @return true when running in html5 mode (pushstate mode).
       */
      this.html5Mode = function () {
        return _this.router.locationConfig.html5Mode();
      };
      /**
       * Gets the port, e.g., `80`
       *
       * @return the port number
       */
      this.port = function () {
        return _this.router.locationConfig.port();
      };
      /**
       * Gets the protocol, e.g., `http`
       *
       * @return the protocol
       */
      this.protocol = function () {
        return _this.router.locationConfig.protocol();
      };
    }
    /**
     * Defines whether URL matching should be case sensitive (the default behavior), or not.
     *
     * #### Example:
     * ```js
     * // Allow case insensitive url matches
     * urlService.config.caseInsensitive(true);
     * ```
     *
     * @param value `false` to match URL in a case sensitive manner; otherwise `true`;
     * @returns the current value of caseInsensitive
     */
    UrlConfig.prototype.caseInsensitive = function (value) {
      return this._isCaseInsensitive = isDefined(value) ? value : this._isCaseInsensitive;
    };
    /**
     * Sets the default behavior when generating or matching URLs with default parameter values.
     *
     * #### Example:
     * ```js
     * // Remove default parameter values from the url
     * urlService.config.defaultSquashPolicy(true);
     * ```
     *
     * @param value A string that defines the default parameter URL squashing behavior.
     *    - `nosquash`: When generating an href with a default parameter value, do not squash the parameter value from the URL
     *    - `slash`: When generating an href with a default parameter value, squash (remove) the parameter value, and, if the
     *      parameter is surrounded by slashes, squash (remove) one slash from the URL
     *    - any other string, e.g. "~": When generating an href with a default parameter value, squash (remove)
     *      the parameter value from the URL and replace it with this string.
     * @returns the current value of defaultSquashPolicy
     */
    UrlConfig.prototype.defaultSquashPolicy = function (value) {
      if (isDefined(value) && value !== true && value !== false && !isString(value)) throw new Error("Invalid squash policy: " + value + ". Valid policies: false, true, arbitrary-string");
      return this._defaultSquashPolicy = isDefined(value) ? value : this._defaultSquashPolicy;
    };
    /**
     * Defines whether URLs should match trailing slashes, or not (the default behavior).
     *
     * #### Example:
     * ```js
     * // Allow optional trailing slashes
     * urlService.config.strictMode(false);
     * ```
     *
     * @param value `false` to match trailing slashes in URLs, otherwise `true`.
     * @returns the current value of strictMode
     */
    UrlConfig.prototype.strictMode = function (value) {
      return this._isStrictMode = isDefined(value) ? value : this._isStrictMode;
    };
    /**
     * Creates and registers a custom [[ParamType]] object
     *
     * A custom parameter type can be used to generate URLs with typed parameters or custom encoding/decoding.
     *
     * #### Note: Register custom types *before using them* in a state definition.
     *
     * #### Example:
     * ```js
     * // Encode object parameter as JSON string
     * urlService.config.type('myjson', {
     *   encode: (obj) => JSON.stringify(obj),
     *   decode: (str) => JSON.parse(str),
     *   is: (val) => typeof(val) === 'object',
     *   pattern: /[^/]+/,
     *   equals: (a, b) => _.isEqual(a, b),
     * });
     * ```
     *
     * See [[ParamTypeDefinition]] for more examples
     *
     * @param name The type name.
     * @param definition The type definition. See [[ParamTypeDefinition]] for information on the values accepted.
     * @param definitionFn A function that is injected before the app runtime starts.
     *        The result of this function should be a [[ParamTypeDefinition]].
     *        The result is merged into the existing `definition`.
     *        See [[ParamType]] for information on the values accepted.
     *
     * @returns if only the `name` parameter was specified: the currently registered [[ParamType]] object, or undefined
     */
    UrlConfig.prototype.type = function (name, definition, definitionFn) {
      var type = this.paramTypes.type(name, definition, definitionFn);
      return !isDefined(definition) ? type : this;
    };
    return UrlConfig;
  }();

  /**
   * API for URL management
   */
  var UrlService = /** @class */function () {
    /** @internal */
    function UrlService(/** @internal */router) {
      var _this = this;
      this.router = router;
      /** @internal */
      this.interceptDeferred = false;
      /**
       * The nested [[UrlRules]] API for managing URL rules and rewrites
       *
       * See: [[UrlRules]] for details
       */
      this.rules = new UrlRules(this.router);
      /**
       * The nested [[UrlConfig]] API to configure the URL and retrieve URL information
       *
       * See: [[UrlConfig]] for details
       */
      this.config = new UrlConfig(this.router);
      // Delegate these calls to the current LocationServices implementation
      /**
       * Gets the current url, or updates the url
       *
       * ### Getting the current URL
       *
       * When no arguments are passed, returns the current URL.
       * The URL is normalized using the internal [[path]]/[[search]]/[[hash]] values.
       *
       * For example, the URL may be stored in the hash ([[HashLocationServices]]) or
       * have a base HREF prepended ([[PushStateLocationServices]]).
       *
       * The raw URL in the browser might be:
       *
       * ```
       * http://mysite.com/somepath/index.html#/internal/path/123?param1=foo#anchor
       * ```
       *
       * or
       *
       * ```
       * http://mysite.com/basepath/internal/path/123?param1=foo#anchor
       * ```
       *
       * then this method returns:
       *
       * ```
       * /internal/path/123?param1=foo#anchor
       * ```
       *
       *
       * #### Example:
       * ```js
       * locationServices.url(); // "/some/path?query=value#anchor"
       * ```
       *
       * ### Updating the URL
       *
       * When `newurl` arguments is provided, changes the URL to reflect `newurl`
       *
       * #### Example:
       * ```js
       * locationServices.url("/some/path?query=value#anchor", true);
       * ```
       *
       * @param newurl The new value for the URL.
       *               This url should reflect only the new internal [[path]], [[search]], and [[hash]] values.
       *               It should not include the protocol, site, port, or base path of an absolute HREF.
       * @param replace When true, replaces the current history entry (instead of appending it) with this new url
       * @param state The history's state object, i.e., pushState (if the LocationServices implementation supports it)
       *
       * @return the url (after potentially being processed)
       */
      this.url = function (newurl, replace, state) {
        return _this.router.locationService.url(newurl, replace, state);
      };
      /**
       * Gets the path part of the current url
       *
       * If the current URL is `/some/path?query=value#anchor`, this returns `/some/path`
       *
       * @return the path portion of the url
       */
      this.path = function () {
        return _this.router.locationService.path();
      };
      /**
       * Gets the search part of the current url as an object
       *
       * If the current URL is `/some/path?query=value#anchor`, this returns `{ query: 'value' }`
       *
       * @return the search (query) portion of the url, as an object
       */
      this.search = function () {
        return _this.router.locationService.search();
      };
      /**
       * Gets the hash part of the current url
       *
       * If the current URL is `/some/path?query=value#anchor`, this returns `anchor`
       *
       * @return the hash (anchor) portion of the url
       */
      this.hash = function () {
        return _this.router.locationService.hash();
      };
      /**
       * @internal
       *
       * Registers a low level url change handler
       *
       * Note: Because this is a low level handler, it's not recommended for general use.
       *
       * #### Example:
       * ```js
       * let deregisterFn = locationServices.onChange((evt) => console.log("url change", evt));
       * ```
       *
       * @param callback a function that will be called when the url is changing
       * @return a function that de-registers the callback
       */
      this.onChange = function (callback) {
        return _this.router.locationService.onChange(callback);
      };
    }
    /** @internal */
    UrlService.prototype.dispose = function () {
      this.listen(false);
      this.rules.dispose();
    };
    /**
     * Gets the current URL parts
     *
     * This method returns the different parts of the current URL (the [[path]], [[search]], and [[hash]]) as a [[UrlParts]] object.
     */
    UrlService.prototype.parts = function () {
      return {
        path: this.path(),
        search: this.search(),
        hash: this.hash()
      };
    };
    /**
     * Activates the best rule for the current URL
     *
     * Checks the current URL for a matching [[UrlRule]], then invokes that rule's handler.
     * This method is called internally any time the URL has changed.
     *
     * This effectively activates the state (or redirect, etc) which matches the current URL.
     *
     * #### Example:
     * ```js
     * urlService.deferIntercept();
     *
     * fetch('/states.json').then(resp => resp.json()).then(data => {
     *   data.forEach(state => $stateRegistry.register(state));
     *   urlService.listen();
     *   // Find the matching URL and invoke the handler.
     *   urlService.sync();
     * });
     * ```
     */
    UrlService.prototype.sync = function (evt) {
      if (evt && evt.defaultPrevented) return;
      var _a = this.router,
        urlService = _a.urlService,
        stateService = _a.stateService;
      var url = {
        path: urlService.path(),
        search: urlService.search(),
        hash: urlService.hash()
      };
      var best = this.match(url);
      var applyResult = pattern([[isString, function (newurl) {
        return urlService.url(newurl, true);
      }], [TargetState.isDef, function (def) {
        return stateService.go(def.state, def.params, def.options);
      }], [is(TargetState), function (target) {
        return stateService.go(target.state(), target.params(), target.options());
      }]]);
      applyResult(best && best.rule.handler(best.match, url, this.router));
    };
    /**
     * Starts or stops listening for URL changes
     *
     * Call this sometime after calling [[deferIntercept]] to start monitoring the url.
     * This causes UI-Router to start listening for changes to the URL, if it wasn't already listening.
     *
     * If called with `false`, UI-Router will stop listening (call listen(true) to start listening again).
     *
     * #### Example:
     * ```js
     * urlService.deferIntercept();
     *
     * fetch('/states.json').then(resp => resp.json()).then(data => {
     *   data.forEach(state => $stateRegistry.register(state));
     *   // Start responding to URL changes
     *   urlService.listen();
     *   urlService.sync();
     * });
     * ```
     *
     * @param enabled `true` or `false` to start or stop listening to URL changes
     */
    UrlService.prototype.listen = function (enabled) {
      var _this = this;
      if (enabled === false) {
        this._stopListeningFn && this._stopListeningFn();
        delete this._stopListeningFn;
      } else {
        return this._stopListeningFn = this._stopListeningFn || this.router.urlService.onChange(function (evt) {
          return _this.sync(evt);
        });
      }
    };
    /**
     * Disables monitoring of the URL.
     *
     * Call this method before UI-Router has bootstrapped.
     * It will stop UI-Router from performing the initial url sync.
     *
     * This can be useful to perform some asynchronous initialization before the router starts.
     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
     *
     * #### Example:
     * ```js
     * // Prevent UI-Router from automatically intercepting URL changes when it starts;
     * urlService.deferIntercept();
     *
     * fetch('/states.json').then(resp => resp.json()).then(data => {
     *   data.forEach(state => $stateRegistry.register(state));
     *   urlService.listen();
     *   urlService.sync();
     * });
     * ```
     *
     * @param defer Indicates whether to defer location change interception.
     *        Passing no parameter is equivalent to `true`.
     */
    UrlService.prototype.deferIntercept = function (defer) {
      if (defer === undefined) defer = true;
      this.interceptDeferred = defer;
    };
    /**
     * Matches a URL
     *
     * Given a URL (as a [[UrlParts]] object), check all rules and determine the best matching rule.
     * Return the result as a [[MatchResult]].
     */
    UrlService.prototype.match = function (url) {
      var _this = this;
      url = extend({
        path: '',
        search: {},
        hash: ''
      }, url);
      var rules = this.rules.rules();
      // Checks a single rule. Returns { rule: rule, match: match, weight: weight } if it matched, or undefined
      var checkRule = function checkRule(rule) {
        var match = rule.match(url, _this.router);
        return match && {
          match: match,
          rule: rule,
          weight: rule.matchPriority(match)
        };
      };
      // The rules are pre-sorted.
      // - Find the first matching rule.
      // - Find any other matching rule that sorted *exactly the same*, according to `.sort()`.
      // - Choose the rule with the highest match weight.
      var best;
      for (var i = 0; i < rules.length; i++) {
        // Stop when there is a 'best' rule and the next rule sorts differently than it.
        if (best && best.rule._group !== rules[i]._group) break;
        var current = checkRule(rules[i]);
        // Pick the best MatchResult
        best = !best || current && current.weight > best.weight ? current : best;
      }
      return best;
    };
    return UrlService;
  }();

  /** @internal */
  var _routerInstance = 0;
  /** @internal */
  var locSvcFns = ['url', 'path', 'search', 'hash', 'onChange'];
  /** @internal */
  var locCfgFns = ['port', 'protocol', 'host', 'baseHref', 'html5Mode', 'hashPrefix'];
  /** @internal */
  var locationServiceStub = makeStub('LocationServices', locSvcFns);
  /** @internal */
  var locationConfigStub = makeStub('LocationConfig', locCfgFns);
  /**
   * An instance of UI-Router.
   *
   * This object contains references to service APIs which define your application's routing behavior.
   */
  var UIRouter = /** @class */function () {
    /**
     * Creates a new `UIRouter` object
     *
     * @param locationService a [[LocationServices]] implementation
     * @param locationConfig a [[LocationConfig]] implementation
     * @internal
     */
    function UIRouter(locationService, locationConfig) {
      if (locationService === void 0) {
        locationService = locationServiceStub;
      }
      if (locationConfig === void 0) {
        locationConfig = locationConfigStub;
      }
      this.locationService = locationService;
      this.locationConfig = locationConfig;
      /** @internal */
      this.$id = _routerInstance++;
      /** @internal */
      this._disposed = false;
      /** @internal */
      this._disposables = [];
      /** Enable/disable tracing to the javascript console */
      this.trace = trace;
      /** Provides services related to ui-view synchronization */
      this.viewService = new ViewService(this);
      /** An object that contains global router state, such as the current state and params */
      this.globals = new UIRouterGlobals();
      /** A service that exposes global Transition Hooks */
      this.transitionService = new TransitionService(this);
      /**
       * Deprecated for public use. Use [[urlService]] instead.
       * @deprecated Use [[urlService]] instead
       */
      this.urlMatcherFactory = new UrlMatcherFactory(this);
      /**
       * Deprecated for public use. Use [[urlService]] instead.
       * @deprecated Use [[urlService]] instead
       */
      this.urlRouter = new UrlRouter(this);
      /** Provides services related to the URL */
      this.urlService = new UrlService(this);
      /** Provides a registry for states, and related registration services */
      this.stateRegistry = new StateRegistry(this);
      /** Provides services related to states */
      this.stateService = new StateService(this);
      /** @internal plugin instances are registered here */
      this._plugins = {};
      this.viewService._pluginapi._rootViewContext(this.stateRegistry.root());
      this.globals.$current = this.stateRegistry.root();
      this.globals.current = this.globals.$current.self;
      this.disposable(this.globals);
      this.disposable(this.stateService);
      this.disposable(this.stateRegistry);
      this.disposable(this.transitionService);
      this.disposable(this.urlService);
      this.disposable(locationService);
      this.disposable(locationConfig);
    }
    /** Registers an object to be notified when the router is disposed */
    UIRouter.prototype.disposable = function (disposable) {
      this._disposables.push(disposable);
    };
    /**
     * Disposes this router instance
     *
     * When called, clears resources retained by the router by calling `dispose(this)` on all
     * registered [[disposable]] objects.
     *
     * Or, if a `disposable` object is provided, calls `dispose(this)` on that object only.
     *
     * @internal
     * @param disposable (optional) the disposable to dispose
     */
    UIRouter.prototype.dispose = function (disposable) {
      var _this = this;
      if (disposable && isFunction(disposable.dispose)) {
        disposable.dispose(this);
        return undefined;
      }
      this._disposed = true;
      this._disposables.slice().forEach(function (d) {
        try {
          typeof d.dispose === 'function' && d.dispose(_this);
          removeFrom(_this._disposables, d);
        } catch (ignored) {}
      });
    };
    /**
     * Adds a plugin to UI-Router
     *
     * This method adds a UI-Router Plugin.
     * A plugin can enhance or change UI-Router behavior using any public API.
     *
     * #### Example:
     * ```js
     * import { MyCoolPlugin } from "ui-router-cool-plugin";
     *
     * var plugin = router.addPlugin(MyCoolPlugin);
     * ```
     *
     * ### Plugin authoring
     *
     * A plugin is simply a class (or constructor function) which accepts a [[UIRouter]] instance and (optionally) an options object.
     *
     * The plugin can implement its functionality using any of the public APIs of [[UIRouter]].
     * For example, it may configure router options or add a Transition Hook.
     *
     * The plugin can then be published as a separate module.
     *
     * #### Example:
     * ```js
     * export class MyAuthPlugin implements UIRouterPlugin {
     *   constructor(router: UIRouter, options: any) {
     *     this.name = "MyAuthPlugin";
     *     let $transitions = router.transitionService;
     *     let $state = router.stateService;
     *
     *     let authCriteria = {
     *       to: (state) => state.data && state.data.requiresAuth
     *     };
     *
     *     function authHook(transition: Transition) {
     *       let authService = transition.injector().get('AuthService');
     *       if (!authService.isAuthenticated()) {
     *         return $state.target('login');
     *       }
     *     }
     *
     *     $transitions.onStart(authCriteria, authHook);
     *   }
     * }
     * ```
     *
     * @param plugin one of:
     *        - a plugin class which implements [[UIRouterPlugin]]
     *        - a constructor function for a [[UIRouterPlugin]] which accepts a [[UIRouter]] instance
     *        - a factory function which accepts a [[UIRouter]] instance and returns a [[UIRouterPlugin]] instance
     * @param options options to pass to the plugin class/factory
     * @returns the registered plugin instance
     */
    UIRouter.prototype.plugin = function (plugin, options) {
      if (options === void 0) {
        options = {};
      }
      var pluginInstance = new plugin(this, options);
      if (!pluginInstance.name) throw new Error('Required property `name` missing on plugin: ' + pluginInstance);
      this._disposables.push(pluginInstance);
      return this._plugins[pluginInstance.name] = pluginInstance;
    };
    UIRouter.prototype.getPlugin = function (pluginName) {
      return pluginName ? this._plugins[pluginName] : values(this._plugins);
    };
    return UIRouter;
  }();
  function addCoreResolvables(trans) {
    trans.addResolvable(Resolvable.fromData(UIRouter, trans.router), '');
    trans.addResolvable(Resolvable.fromData(Transition, trans), '');
    trans.addResolvable(Resolvable.fromData('$transition$', trans), '');
    trans.addResolvable(Resolvable.fromData('$stateParams', trans.params()), '');
    trans.entering().forEach(function (state) {
      trans.addResolvable(Resolvable.fromData('$state$', state), state);
    });
  }
  var registerAddCoreResolvables = function registerAddCoreResolvables(transitionService) {
    return transitionService.onCreate({}, addCoreResolvables);
  };
  var TRANSITION_TOKENS = ['$transition$', Transition];
  var isTransition = inArray(TRANSITION_TOKENS);
  // References to Transition in the treeChanges pathnodes makes all
  // previous Transitions reachable in memory, causing a memory leak
  // This function removes resolves for '$transition$' and `Transition` from the treeChanges.
  // Do not use this on current transitions, only on old ones.
  var treeChangesCleanup = function treeChangesCleanup(trans) {
    var nodes = values(trans.treeChanges()).reduce(unnestR, []).reduce(uniqR, []);
    // If the resolvable is a Transition, return a new resolvable with null data
    var replaceTransitionWithNull = function replaceTransitionWithNull(r) {
      return isTransition(r.token) ? Resolvable.fromData(r.token, null) : r;
    };
    nodes.forEach(function (node) {
      node.resolvables = node.resolvables.map(replaceTransitionWithNull);
    });
  };

  /**
   * A [[TransitionHookFn]] that redirects to a different state or params
   *
   * Registered using `transitionService.onStart({ to: (state) => !!state.redirectTo }, redirectHook);`
   *
   * See [[StateDeclaration.redirectTo]]
   */
  var redirectToHook = function redirectToHook(trans) {
    var redirect = trans.to().redirectTo;
    if (!redirect) return;
    var $state = trans.router.stateService;
    function handleResult(result) {
      if (!result) return;
      if (result instanceof TargetState) return result;
      if (isString(result)) return $state.target(result, trans.params(), trans.options());
      if (result['state'] || result['params']) return $state.target(result['state'] || trans.to(), result['params'] || trans.params(), trans.options());
    }
    if (isFunction(redirect)) {
      return services.$q.when(redirect(trans)).then(handleResult);
    }
    return handleResult(redirect);
  };
  var registerRedirectToHook = function registerRedirectToHook(transitionService) {
    return transitionService.onStart({
      to: function to(state) {
        return !!state.redirectTo;
      }
    }, redirectToHook);
  };

  /**
   * A factory which creates an onEnter, onExit or onRetain transition hook function
   *
   * The returned function invokes the (for instance) state.onEnter hook when the
   * state is being entered.
   */
  function makeEnterExitRetainHook(hookName) {
    return function (transition, state) {
      var _state = state.$$state();
      var hookFn = _state[hookName];
      return hookFn(transition, state);
    };
  }
  /**
   * The [[TransitionStateHookFn]] for onExit
   *
   * When the state is being exited, the state's .onExit function is invoked.
   *
   * Registered using `transitionService.onExit({ exiting: (state) => !!state.onExit }, onExitHook);`
   *
   * See: [[IHookRegistry.onExit]]
   */
  var onExitHook = makeEnterExitRetainHook('onExit');
  var registerOnExitHook = function registerOnExitHook(transitionService) {
    return transitionService.onExit({
      exiting: function exiting(state) {
        return !!state.onExit;
      }
    }, onExitHook);
  };
  /**
   * The [[TransitionStateHookFn]] for onRetain
   *
   * When the state was already entered, and is not being exited or re-entered, the state's .onRetain function is invoked.
   *
   * Registered using `transitionService.onRetain({ retained: (state) => !!state.onRetain }, onRetainHook);`
   *
   * See: [[IHookRegistry.onRetain]]
   */
  var onRetainHook = makeEnterExitRetainHook('onRetain');
  var registerOnRetainHook = function registerOnRetainHook(transitionService) {
    return transitionService.onRetain({
      retained: function retained(state) {
        return !!state.onRetain;
      }
    }, onRetainHook);
  };
  /**
   * The [[TransitionStateHookFn]] for onEnter
   *
   * When the state is being entered, the state's .onEnter function is invoked.
   *
   * Registered using `transitionService.onEnter({ entering: (state) => !!state.onEnter }, onEnterHook);`
   *
   * See: [[IHookRegistry.onEnter]]
   */
  var onEnterHook = makeEnterExitRetainHook('onEnter');
  var registerOnEnterHook = function registerOnEnterHook(transitionService) {
    return transitionService.onEnter({
      entering: function entering(state) {
        return !!state.onEnter;
      }
    }, onEnterHook);
  };
  var RESOLVE_HOOK_PRIORITY = 1000;
  /**
   * A [[TransitionHookFn]] which resolves all EAGER Resolvables in the To Path
   *
   * Registered using `transitionService.onStart({}, eagerResolvePath, { priority: 1000 });`
   *
   * When a Transition starts, this hook resolves all the EAGER Resolvables, which the transition then waits for.
   *
   * See [[StateDeclaration.resolve]]
   */
  var eagerResolvePath = function eagerResolvePath(trans) {
    return new ResolveContext(trans.treeChanges().to).resolvePath('EAGER', trans).then(noop);
  };
  var registerEagerResolvePath = function registerEagerResolvePath(transitionService) {
    return transitionService.onStart({}, eagerResolvePath, {
      priority: RESOLVE_HOOK_PRIORITY
    });
  };
  /**
   * A [[TransitionHookFn]] which resolves all LAZY Resolvables for the state (and all its ancestors) in the To Path
   *
   * Registered using `transitionService.onEnter({ entering: () => true }, lazyResolveState, { priority: 1000 });`
   *
   * When a State is being entered, this hook resolves all the Resolvables for this state, which the transition then waits for.
   *
   * See [[StateDeclaration.resolve]]
   */
  var lazyResolveState = function lazyResolveState(trans, state) {
    return new ResolveContext(trans.treeChanges().to).subContext(state.$$state()).resolvePath('LAZY', trans).then(noop);
  };
  var registerLazyResolveState = function registerLazyResolveState(transitionService) {
    return transitionService.onEnter({
      entering: val(true)
    }, lazyResolveState, {
      priority: RESOLVE_HOOK_PRIORITY
    });
  };
  /**
   * A [[TransitionHookFn]] which resolves any dynamically added (LAZY or EAGER) Resolvables.
   *
   * Registered using `transitionService.onFinish({}, eagerResolvePath, { priority: 1000 });`
   *
   * After all entering states have been entered, this hook resolves any remaining Resolvables.
   * These are typically dynamic resolves which were added by some Transition Hook using [[Transition.addResolvable]].
   *
   * See [[StateDeclaration.resolve]]
   */
  var resolveRemaining = function resolveRemaining(trans) {
    return new ResolveContext(trans.treeChanges().to).resolvePath('LAZY', trans).then(noop);
  };
  var registerResolveRemaining = function registerResolveRemaining(transitionService) {
    return transitionService.onFinish({}, resolveRemaining, {
      priority: RESOLVE_HOOK_PRIORITY
    });
  };

  /**
   * A [[TransitionHookFn]] which waits for the views to load
   *
   * Registered using `transitionService.onStart({}, loadEnteringViews);`
   *
   * Allows the views to do async work in [[ViewConfig.load]] before the transition continues.
   * In angular 1, this includes loading the templates.
   */
  var loadEnteringViews = function loadEnteringViews(transition) {
    var $q = services.$q;
    var enteringViews = transition.views('entering');
    if (!enteringViews.length) return;
    return $q.all(enteringViews.map(function (view) {
      return $q.when(view.load());
    })).then(noop);
  };
  var registerLoadEnteringViews = function registerLoadEnteringViews(transitionService) {
    return transitionService.onFinish({}, loadEnteringViews);
  };
  /**
   * A [[TransitionHookFn]] which activates the new views when a transition is successful.
   *
   * Registered using `transitionService.onSuccess({}, activateViews);`
   *
   * After a transition is complete, this hook deactivates the old views from the previous state,
   * and activates the new views from the destination state.
   *
   * See [[ViewService]]
   */
  var activateViews = function activateViews(transition) {
    var enteringViews = transition.views('entering');
    var exitingViews = transition.views('exiting');
    if (!enteringViews.length && !exitingViews.length) return;
    var $view = transition.router.viewService;
    exitingViews.forEach(function (vc) {
      return $view.deactivateViewConfig(vc);
    });
    enteringViews.forEach(function (vc) {
      return $view.activateViewConfig(vc);
    });
    $view.sync();
  };
  var registerActivateViews = function registerActivateViews(transitionService) {
    return transitionService.onSuccess({}, activateViews);
  };

  /**
   * A [[TransitionHookFn]] which updates global UI-Router state
   *
   * Registered using `transitionService.onBefore({}, updateGlobalState);`
   *
   * Before a [[Transition]] starts, updates the global value of "the current transition" ([[Globals.transition]]).
   * After a successful [[Transition]], updates the global values of "the current state"
   * ([[Globals.current]] and [[Globals.$current]]) and "the current param values" ([[Globals.params]]).
   *
   * See also the deprecated properties:
   * [[StateService.transition]], [[StateService.current]], [[StateService.params]]
   */
  var updateGlobalState = function updateGlobalState(trans) {
    var globals = trans.router.globals;
    var transitionSuccessful = function transitionSuccessful() {
      globals.successfulTransitions.enqueue(trans);
      globals.$current = trans.$to();
      globals.current = globals.$current.self;
      copy(trans.params(), globals.params);
    };
    var clearCurrentTransition = function clearCurrentTransition() {
      // Do not clear globals.transition if a different transition has started in the meantime
      if (globals.transition === trans) globals.transition = null;
    };
    trans.onSuccess({}, transitionSuccessful, {
      priority: 10000
    });
    trans.promise.then(clearCurrentTransition, clearCurrentTransition);
  };
  var registerUpdateGlobalState = function registerUpdateGlobalState(transitionService) {
    return transitionService.onCreate({}, updateGlobalState);
  };

  /**
   * A [[TransitionHookFn]] which updates the URL after a successful transition
   *
   * Registered using `transitionService.onSuccess({}, updateUrl);`
   */
  var updateUrl = function updateUrl(transition) {
    var options = transition.options();
    var $state = transition.router.stateService;
    var $urlRouter = transition.router.urlRouter;
    // Dont update the url in these situations:
    // The transition was triggered by a URL sync (options.source === 'url')
    // The user doesn't want the url to update (options.location === false)
    // The destination state, and all parents have no navigable url
    if (options.source !== 'url' && options.location && $state.$current.navigable) {
      var urlOptions = {
        replace: options.location === 'replace'
      };
      $urlRouter.push($state.$current.navigable.url, $state.params, urlOptions);
    }
    $urlRouter.update(true);
  };
  var registerUpdateUrl = function registerUpdateUrl(transitionService) {
    return transitionService.onSuccess({}, updateUrl, {
      priority: 9999
    });
  };

  /**
   * A [[TransitionHookFn]] that performs lazy loading
   *
   * When entering a state "abc" which has a `lazyLoad` function defined:
   * - Invoke the `lazyLoad` function (unless it is already in process)
   *   - Flag the hook function as "in process"
   *   - The function should return a promise (that resolves when lazy loading is complete)
   * - Wait for the promise to settle
   *   - If the promise resolves to a [[LazyLoadResult]], then register those states
   *   - Flag the hook function as "not in process"
   * - If the hook was successful
   *   - Remove the `lazyLoad` function from the state declaration
   * - If all the hooks were successful
   *   - Retry the transition (by returning a TargetState)
   *
   * ```
   * .state('abc', {
   *   component: 'fooComponent',
   *   lazyLoad: () => import('./fooComponent')
   *   });
   * ```
   *
   * See [[StateDeclaration.lazyLoad]]
   */
  var lazyLoadHook = function lazyLoadHook(transition) {
    var router = transition.router;
    function retryTransition() {
      if (transition.originalTransition().options().source !== 'url') {
        // The original transition was not triggered via url sync
        // The lazy state should be loaded now, so re-try the original transition
        var orig = transition.targetState();
        return router.stateService.target(orig.identifier(), orig.params(), orig.options());
      }
      // The original transition was triggered via url sync
      // Run the URL rules and find the best match
      var $url = router.urlService;
      var result = $url.match($url.parts());
      var rule = result && result.rule;
      // If the best match is a state, redirect the transition (instead
      // of calling sync() which supersedes the current transition)
      if (rule && rule.type === 'STATE') {
        var state = rule.state;
        var params = result.match;
        return router.stateService.target(state, params, transition.options());
      }
      // No matching state found, so let .sync() choose the best non-state match/otherwise
      router.urlService.sync();
    }
    var promises = transition.entering().filter(function (state) {
      return !!state.$$state().lazyLoad;
    }).map(function (state) {
      return lazyLoadState(transition, state);
    });
    return services.$q.all(promises).then(retryTransition);
  };
  var registerLazyLoadHook = function registerLazyLoadHook(transitionService) {
    return transitionService.onBefore({
      entering: function entering(state) {
        return !!state.lazyLoad;
      }
    }, lazyLoadHook);
  };
  /**
   * Invokes a state's lazy load function
   *
   * @param transition a Transition context
   * @param state the state to lazy load
   * @returns A promise for the lazy load result
   */
  function lazyLoadState(transition, state) {
    var lazyLoadFn = state.$$state().lazyLoad;
    // Store/get the lazy load promise on/from the hookfn so it doesn't get re-invoked
    var promise = lazyLoadFn['_promise'];
    if (!promise) {
      var success = function success(result) {
        delete state.lazyLoad;
        delete state.$$state().lazyLoad;
        delete lazyLoadFn['_promise'];
        return result;
      };
      var error = function error(err) {
        delete lazyLoadFn['_promise'];
        return services.$q.reject(err);
      };
      promise = lazyLoadFn['_promise'] = services.$q.when(lazyLoadFn(transition, state)).then(updateStateRegistry).then(success, error);
    }
    /** Register any lazy loaded state definitions */
    function updateStateRegistry(result) {
      if (result && Array.isArray(result.states)) {
        result.states.forEach(function (_state) {
          return transition.router.stateRegistry.register(_state);
        });
      }
      return result;
    }
    return promise;
  }

  /**
   * This class defines a type of hook, such as `onBefore` or `onEnter`.
   * Plugins can define custom hook types, such as sticky states does for `onInactive`.
   */
  var TransitionEventType = /** @class */function () {
    /* tslint:disable:no-inferrable-types */
    function TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
      if (reverseSort === void 0) {
        reverseSort = false;
      }
      if (getResultHandler === void 0) {
        getResultHandler = TransitionHook.HANDLE_RESULT;
      }
      if (getErrorHandler === void 0) {
        getErrorHandler = TransitionHook.REJECT_ERROR;
      }
      if (synchronous === void 0) {
        synchronous = false;
      }
      this.name = name;
      this.hookPhase = hookPhase;
      this.hookOrder = hookOrder;
      this.criteriaMatchPath = criteriaMatchPath;
      this.reverseSort = reverseSort;
      this.getResultHandler = getResultHandler;
      this.getErrorHandler = getErrorHandler;
      this.synchronous = synchronous;
    }
    return TransitionEventType;
  }();

  /**
   * A [[TransitionHookFn]] that skips a transition if it should be ignored
   *
   * This hook is invoked at the end of the onBefore phase.
   *
   * If the transition should be ignored (because no parameter or states changed)
   * then the transition is ignored and not processed.
   */
  function ignoredHook(trans) {
    var ignoredReason = trans._ignoredReason();
    if (!ignoredReason) return;
    trace.traceTransitionIgnored(trans);
    var pending = trans.router.globals.transition;
    // The user clicked a link going back to the *current state* ('A')
    // However, there is also a pending transition in flight (to 'B')
    // Abort the transition to 'B' because the user now wants to be back at 'A'.
    if (ignoredReason === 'SameAsCurrent' && pending) {
      pending.abort();
    }
    return Rejection.ignored().toPromise();
  }
  var registerIgnoredTransitionHook = function registerIgnoredTransitionHook(transitionService) {
    return transitionService.onBefore({}, ignoredHook, {
      priority: -9999
    });
  };

  /**
   * A [[TransitionHookFn]] that rejects the Transition if it is invalid
   *
   * This hook is invoked at the end of the onBefore phase.
   * If the transition is invalid (for example, param values do not validate)
   * then the transition is rejected.
   */
  function invalidTransitionHook(trans) {
    if (!trans.valid()) {
      throw new Error(trans.error().toString());
    }
  }
  var registerInvalidTransitionHook = function registerInvalidTransitionHook(transitionService) {
    return transitionService.onBefore({}, invalidTransitionHook, {
      priority: -10000
    });
  };

  /**
   * The default [[Transition]] options.
   *
   * Include this object when applying custom defaults:
   * let reloadOpts = { reload: true, notify: true }
   * let options = defaults(theirOpts, customDefaults, defaultOptions);
   */
  var defaultTransOpts = {
    location: true,
    relative: null,
    inherit: false,
    notify: true,
    reload: false,
    supercede: true,
    custom: {},
    current: function current() {
      return null;
    },
    source: 'unknown'
  };
  /**
   * This class provides services related to Transitions.
   *
   * - Most importantly, it allows global Transition Hooks to be registered.
   * - It allows the default transition error handler to be set.
   * - It also has a factory function for creating new [[Transition]] objects, (used internally by the [[StateService]]).
   *
   * At bootstrap, [[UIRouter]] creates a single instance (singleton) of this class.
   *
   * This API is located at `router.transitionService` ([[UIRouter.transitionService]])
   */
  var TransitionService = /** @class */function () {
    /** @internal */
    function TransitionService(_router) {
      /** @internal */
      this._transitionCount = 0;
      /** The transition hook types, such as `onEnter`, `onStart`, etc */
      this._eventTypes = [];
      /** @internal The registered transition hooks */
      this._registeredHooks = {};
      /** The  paths on a criteria object */
      this._criteriaPaths = {};
      this._router = _router;
      this.$view = _router.viewService;
      this._deregisterHookFns = {};
      this._pluginapi = createProxyFunctions(val(this), {}, val(this), ['_definePathType', '_defineEvent', '_getPathTypes', '_getEvents', 'getHooks']);
      this._defineCorePaths();
      this._defineCoreEvents();
      this._registerCoreTransitionHooks();
      _router.globals.successfulTransitions.onEvict(treeChangesCleanup);
    }
    /**
     * Registers a [[TransitionHookFn]], called *while a transition is being constructed*.
     *
     * Registers a transition lifecycle hook, which is invoked during transition construction.
     *
     * This low level hook should only be used by plugins.
     * This can be a useful time for plugins to add resolves or mutate the transition as needed.
     * The Sticky States plugin uses this hook to modify the treechanges.
     *
     * ### Lifecycle
     *
     * `onCreate` hooks are invoked *while a transition is being constructed*.
     *
     * ### Return value
     *
     * The hook's return value is ignored
     *
     * @internal
     * @param criteria defines which Transitions the Hook should be invoked for.
     * @param callback the hook function which will be invoked.
     * @param options the registration options
     * @returns a function which deregisters the hook.
     */
    TransitionService.prototype.onCreate = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onBefore = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onStart = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onExit = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onRetain = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onEnter = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onFinish = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onSuccess = function (criteria, callback, options) {
      return;
    };
    /** @inheritdoc */
    TransitionService.prototype.onError = function (criteria, callback, options) {
      return;
    };
    /**
     * dispose
     * @internal
     */
    TransitionService.prototype.dispose = function (router) {
      values(this._registeredHooks).forEach(function (hooksArray) {
        return hooksArray.forEach(function (hook) {
          hook._deregistered = true;
          removeFrom(hooksArray, hook);
        });
      });
    };
    /**
     * Creates a new [[Transition]] object
     *
     * This is a factory function for creating new Transition objects.
     * It is used internally by the [[StateService]] and should generally not be called by application code.
     *
     * @internal
     * @param fromPath the path to the current state (the from state)
     * @param targetState the target state (destination)
     * @returns a Transition
     */
    TransitionService.prototype.create = function (fromPath, targetState) {
      return new Transition(fromPath, targetState, this._router);
    };
    /** @internal */
    TransitionService.prototype._defineCoreEvents = function () {
      var Phase = exports.TransitionHookPhase;
      var TH = TransitionHook;
      var paths = this._criteriaPaths;
      var NORMAL_SORT = false,
        REVERSE_SORT = true;
      var SYNCHRONOUS = true;
      this._defineEvent('onCreate', Phase.CREATE, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.THROW_ERROR, SYNCHRONOUS);
      this._defineEvent('onBefore', Phase.BEFORE, 0, paths.to);
      this._defineEvent('onStart', Phase.RUN, 0, paths.to);
      this._defineEvent('onExit', Phase.RUN, 100, paths.exiting, REVERSE_SORT);
      this._defineEvent('onRetain', Phase.RUN, 200, paths.retained);
      this._defineEvent('onEnter', Phase.RUN, 300, paths.entering);
      this._defineEvent('onFinish', Phase.RUN, 400, paths.to);
      this._defineEvent('onSuccess', Phase.SUCCESS, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
      this._defineEvent('onError', Phase.ERROR, 0, paths.to, NORMAL_SORT, TH.LOG_REJECTED_RESULT, TH.LOG_ERROR, SYNCHRONOUS);
    };
    /** @internal */
    TransitionService.prototype._defineCorePaths = function () {
      var STATE = exports.TransitionHookScope.STATE,
        TRANSITION = exports.TransitionHookScope.TRANSITION;
      this._definePathType('to', TRANSITION);
      this._definePathType('from', TRANSITION);
      this._definePathType('exiting', STATE);
      this._definePathType('retained', STATE);
      this._definePathType('entering', STATE);
    };
    /** @internal */
    TransitionService.prototype._defineEvent = function (name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous) {
      if (reverseSort === void 0) {
        reverseSort = false;
      }
      if (getResultHandler === void 0) {
        getResultHandler = TransitionHook.HANDLE_RESULT;
      }
      if (getErrorHandler === void 0) {
        getErrorHandler = TransitionHook.REJECT_ERROR;
      }
      if (synchronous === void 0) {
        synchronous = false;
      }
      var eventType = new TransitionEventType(name, hookPhase, hookOrder, criteriaMatchPath, reverseSort, getResultHandler, getErrorHandler, synchronous);
      this._eventTypes.push(eventType);
      makeEvent(this, this, eventType);
    };
    /** @internal */
    TransitionService.prototype._getEvents = function (phase) {
      var transitionHookTypes = isDefined(phase) ? this._eventTypes.filter(function (type) {
        return type.hookPhase === phase;
      }) : this._eventTypes.slice();
      return transitionHookTypes.sort(function (l, r) {
        var cmpByPhase = l.hookPhase - r.hookPhase;
        return cmpByPhase === 0 ? l.hookOrder - r.hookOrder : cmpByPhase;
      });
    };
    /**
     * Adds a Path to be used as a criterion against a TreeChanges path
     *
     * For example: the `exiting` path in [[HookMatchCriteria]] is a STATE scoped path.
     * It was defined by calling `defineTreeChangesCriterion('exiting', TransitionHookScope.STATE)`
     * Each state in the exiting path is checked against the criteria and returned as part of the match.
     *
     * Another example: the `to` path in [[HookMatchCriteria]] is a TRANSITION scoped path.
     * It was defined by calling `defineTreeChangesCriterion('to', TransitionHookScope.TRANSITION)`
     * Only the tail of the `to` path is checked against the criteria and returned as part of the match.
     *
     * @internal
     */
    TransitionService.prototype._definePathType = function (name, hookScope) {
      this._criteriaPaths[name] = {
        name: name,
        scope: hookScope
      };
    };
    /** @internal */
    // tslint:disable-next-line
    TransitionService.prototype._getPathTypes = function () {
      return this._criteriaPaths;
    };
    /** @internal */
    TransitionService.prototype.getHooks = function (hookName) {
      return this._registeredHooks[hookName];
    };
    /** @internal */
    TransitionService.prototype._registerCoreTransitionHooks = function () {
      var fns = this._deregisterHookFns;
      fns.addCoreResolves = registerAddCoreResolvables(this);
      fns.ignored = registerIgnoredTransitionHook(this);
      fns.invalid = registerInvalidTransitionHook(this);
      // Wire up redirectTo hook
      fns.redirectTo = registerRedirectToHook(this);
      // Wire up onExit/Retain/Enter state hooks
      fns.onExit = registerOnExitHook(this);
      fns.onRetain = registerOnRetainHook(this);
      fns.onEnter = registerOnEnterHook(this);
      // Wire up Resolve hooks
      fns.eagerResolve = registerEagerResolvePath(this);
      fns.lazyResolve = registerLazyResolveState(this);
      fns.resolveAll = registerResolveRemaining(this);
      // Wire up the View management hooks
      fns.loadViews = registerLoadEnteringViews(this);
      fns.activateViews = registerActivateViews(this);
      // Updates global state after a transition
      fns.updateGlobals = registerUpdateGlobalState(this);
      // After globals.current is updated at priority: 10000
      fns.updateUrl = registerUpdateUrl(this);
      // Lazy load state trees
      fns.lazyLoad = registerLazyLoadHook(this);
    };
    return TransitionService;
  }();

  /**
   * Provides services related to ui-router states.
   *
   * This API is located at `router.stateService` ([[UIRouter.stateService]])
   */
  var StateService = /** @class */function () {
    /** @internal */
    function StateService(/** @internal */router) {
      this.router = router;
      /** @internal */
      this.invalidCallbacks = [];
      /** @internal */
      this._defaultErrorHandler = function $defaultErrorHandler($error$) {
        if ($error$ instanceof Error && $error$.stack) {
          console.error($error$);
          console.error($error$.stack);
        } else if ($error$ instanceof Rejection) {
          console.error($error$.toString());
          if ($error$.detail && $error$.detail.stack) console.error($error$.detail.stack);
        } else {
          console.error($error$);
        }
      };
      var getters = ['current', '$current', 'params', 'transition'];
      var boundFns = Object.keys(StateService.prototype).filter(not(inArray(getters)));
      createProxyFunctions(val(StateService.prototype), this, val(this), boundFns);
    }
    Object.defineProperty(StateService.prototype, "transition", {
      /**
       * The [[Transition]] currently in progress (or null)
       *
       * @deprecated This is a passthrough through to [[UIRouterGlobals.transition]]
       */
      get: function get() {
        return this.router.globals.transition;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(StateService.prototype, "params", {
      /**
       * The latest successful state parameters
       *
       * @deprecated This is a passthrough through to [[UIRouterGlobals.params]]
       */
      get: function get() {
        return this.router.globals.params;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(StateService.prototype, "current", {
      /**
       * The current [[StateDeclaration]]
       *
       * @deprecated This is a passthrough through to [[UIRouterGlobals.current]]
       */
      get: function get() {
        return this.router.globals.current;
      },
      enumerable: false,
      configurable: true
    });
    Object.defineProperty(StateService.prototype, "$current", {
      /**
       * The current [[StateObject]] (an internal API)
       *
       * @deprecated This is a passthrough through to [[UIRouterGlobals.$current]]
       */
      get: function get() {
        return this.router.globals.$current;
      },
      enumerable: false,
      configurable: true
    });
    /** @internal */
    StateService.prototype.dispose = function () {
      this.defaultErrorHandler(noop);
      this.invalidCallbacks = [];
    };
    /**
     * Handler for when [[transitionTo]] is called with an invalid state.
     *
     * Invokes the [[onInvalid]] callbacks, in natural order.
     * Each callback's return value is checked in sequence until one of them returns an instance of TargetState.
     * The results of the callbacks are wrapped in $q.when(), so the callbacks may return promises.
     *
     * If a callback returns an TargetState, then it is used as arguments to $state.transitionTo() and the result returned.
     *
     * @internal
     */
    StateService.prototype._handleInvalidTargetState = function (fromPath, toState) {
      var _this = this;
      var fromState = PathUtils.makeTargetState(this.router.stateRegistry, fromPath);
      var globals = this.router.globals;
      var latestThing = function latestThing() {
        return globals.transitionHistory.peekTail();
      };
      var latest = latestThing();
      var callbackQueue = new Queue(this.invalidCallbacks.slice());
      var injector = new ResolveContext(fromPath).injector();
      var checkForRedirect = function checkForRedirect(result) {
        if (!(result instanceof TargetState)) {
          return;
        }
        var target = result;
        // Recreate the TargetState, in case the state is now defined.
        target = _this.target(target.identifier(), target.params(), target.options());
        if (!target.valid()) {
          return Rejection.invalid(target.error()).toPromise();
        }
        if (latestThing() !== latest) {
          return Rejection.superseded().toPromise();
        }
        return _this.transitionTo(target.identifier(), target.params(), target.options());
      };
      function invokeNextCallback() {
        var nextCallback = callbackQueue.dequeue();
        if (nextCallback === undefined) return Rejection.invalid(toState.error()).toPromise();
        var callbackResult = services.$q.when(nextCallback(toState, fromState, injector));
        return callbackResult.then(checkForRedirect).then(function (result) {
          return result || invokeNextCallback();
        });
      }
      return invokeNextCallback();
    };
    /**
     * Registers an Invalid State handler
     *
     * Registers a [[OnInvalidCallback]] function to be invoked when [[StateService.transitionTo]]
     * has been called with an invalid state reference parameter
     *
     * Example:
     * ```js
     * stateService.onInvalid(function(to, from, injector) {
     *   if (to.name() === 'foo') {
     *     let lazyLoader = injector.get('LazyLoadService');
     *     return lazyLoader.load('foo')
     *         .then(() => stateService.target('foo'));
     *   }
     * });
     * ```
     *
     * @param {function} callback invoked when the toState is invalid
     *   This function receives the (invalid) toState, the fromState, and an injector.
     *   The function may optionally return a [[TargetState]] or a Promise for a TargetState.
     *   If one is returned, it is treated as a redirect.
     *
     * @returns a function which deregisters the callback
     */
    StateService.prototype.onInvalid = function (callback) {
      this.invalidCallbacks.push(callback);
      return function deregisterListener() {
        removeFrom(this.invalidCallbacks)(callback);
      }.bind(this);
    };
    /**
     * Reloads the current state
     *
     * A method that force reloads the current state, or a partial state hierarchy.
     * All resolves are re-resolved, and components reinstantiated.
     *
     * #### Example:
     * ```js
     * let app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     $state.reload();
     *   }
     * });
     * ```
     *
     * Note: `reload()` is just an alias for:
     *
     * ```js
     * $state.transitionTo($state.current, $state.params, {
     *   reload: true, inherit: false
     * });
     * ```
     *
     * @param reloadState A state name or a state object.
     *    If present, this state and all its children will be reloaded, but ancestors will not reload.
     *
     * #### Example:
     * ```js
     * //assuming app application consists of 3 states: 'contacts', 'contacts.detail', 'contacts.detail.item'
     * //and current state is 'contacts.detail.item'
     * let app angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.reload = function(){
     *     //will reload 'contact.detail' and nested 'contact.detail.item' states
     *     $state.reload('contact.detail');
     *   }
     * });
     * ```
     *
     * @returns A promise representing the state of the new transition. See [[StateService.go]]
     */
    StateService.prototype.reload = function (reloadState) {
      return this.transitionTo(this.current, this.params, {
        reload: isDefined(reloadState) ? reloadState : true,
        inherit: false,
        notify: false
      });
    };
    /**
     * Transition to a different state and/or parameters
     *
     * Convenience method for transitioning to a new state.
     *
     * `$state.go` calls `$state.transitionTo` internally but automatically sets options to
     * `{ location: true, inherit: true, relative: router.globals.$current, notify: true }`.
     * This allows you to use either an absolute or relative `to` argument (because of `relative: router.globals.$current`).
     * It also allows you to specify * only the parameters you'd like to update, while letting unspecified parameters
     * inherit from the current parameter values (because of `inherit: true`).
     *
     * #### Example:
     * ```js
     * let app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.go('contact.detail');
     *   };
     * });
     * ```
     *
     * @param to Absolute state name, state object, or relative state path (relative to current state).
     *
     * Some examples:
     *
     * - `$state.go('contact.detail')` - will go to the `contact.detail` state
     * - `$state.go('^')` - will go to the parent state
     * - `$state.go('^.sibling')` - if current state is `home.child`, will go to the `home.sibling` state
     * - `$state.go('.child.grandchild')` - if current state is home, will go to the `home.child.grandchild` state
     *
     * @param params A map of the parameters that will be sent to the state, will populate $stateParams.
     *
     *    Any parameters that are not specified will be inherited from current parameter values (because of `inherit: true`).
     *    This allows, for example, going to a sibling state that shares parameters defined by a parent state.
     *
     * @param options Transition options
     *
     * @returns {promise} A promise representing the state of the new transition.
     */
    StateService.prototype.go = function (to, params, options) {
      var defautGoOpts = {
        relative: this.$current,
        inherit: true
      };
      var transOpts = defaults(options, defautGoOpts, defaultTransOpts);
      return this.transitionTo(to, params, transOpts);
    };
    /**
     * Creates a [[TargetState]]
     *
     * This is a factory method for creating a TargetState
     *
     * This may be returned from a Transition Hook to redirect a transition, for example.
     */
    StateService.prototype.target = function (identifier, params, options) {
      if (options === void 0) {
        options = {};
      }
      // If we're reloading, find the state object to reload from
      if (isObject(options.reload) && !options.reload.name) throw new Error('Invalid reload state object');
      var reg = this.router.stateRegistry;
      options.reloadState = options.reload === true ? reg.root() : reg.matcher.find(options.reload, options.relative);
      if (options.reload && !options.reloadState) throw new Error("No such reload state '" + (isString(options.reload) ? options.reload : options.reload.name) + "'");
      return new TargetState(this.router.stateRegistry, identifier, params, options);
    };
    /** @internal */
    StateService.prototype.getCurrentPath = function () {
      var _this = this;
      var globals = this.router.globals;
      var latestSuccess = globals.successfulTransitions.peekTail();
      var rootPath = function rootPath() {
        return [new PathNode(_this.router.stateRegistry.root())];
      };
      return latestSuccess ? latestSuccess.treeChanges().to : rootPath();
    };
    /**
     * Low-level method for transitioning to a new state.
     *
     * The [[go]] method (which uses `transitionTo` internally) is recommended in most situations.
     *
     * #### Example:
     * ```js
     * let app = angular.module('app', ['ui.router']);
     *
     * app.controller('ctrl', function ($scope, $state) {
     *   $scope.changeState = function () {
     *     $state.transitionTo('contact.detail');
     *   };
     * });
     * ```
     *
     * @param to State name or state object.
     * @param toParams A map of the parameters that will be sent to the state,
     *      will populate $stateParams.
     * @param options Transition options
     *
     * @returns A promise representing the state of the new transition. See [[go]]
     */
    StateService.prototype.transitionTo = function (to, toParams, options) {
      var _this = this;
      if (toParams === void 0) {
        toParams = {};
      }
      if (options === void 0) {
        options = {};
      }
      var router = this.router;
      var globals = router.globals;
      options = defaults(options, defaultTransOpts);
      var getCurrent = function getCurrent() {
        return globals.transition;
      };
      options = extend(options, {
        current: getCurrent
      });
      var ref = this.target(to, toParams, options);
      var currentPath = this.getCurrentPath();
      if (!ref.exists()) return this._handleInvalidTargetState(currentPath, ref);
      if (!ref.valid()) return silentRejection(ref.error());
      if (options.supercede === false && getCurrent()) {
        return Rejection.ignored('Another transition is in progress and supercede has been set to false in TransitionOptions for the transition. So the transition was ignored in favour of the existing one in progress.').toPromise();
      }
      /**
       * Special handling for Ignored, Aborted, and Redirected transitions
       *
       * The semantics for the transition.run() promise and the StateService.transitionTo()
       * promise differ. For instance, the run() promise may be rejected because it was
       * IGNORED, but the transitionTo() promise is resolved because from the user perspective
       * no error occurred.  Likewise, the transition.run() promise may be rejected because of
       * a Redirect, but the transitionTo() promise is chained to the new Transition's promise.
       */
      var _rejectedTransitionHandler = function rejectedTransitionHandler(trans) {
        return function (error) {
          if (error instanceof Rejection) {
            var isLatest = router.globals.lastStartedTransitionId <= trans.$id;
            if (error.type === exports.RejectType.IGNORED) {
              isLatest && router.urlRouter.update();
              // Consider ignored `Transition.run()` as a successful `transitionTo`
              return services.$q.when(globals.current);
            }
            var detail = error.detail;
            if (error.type === exports.RejectType.SUPERSEDED && error.redirected && detail instanceof TargetState) {
              // If `Transition.run()` was redirected, allow the `transitionTo()` promise to resolve successfully
              // by returning the promise for the new (redirect) `Transition.run()`.
              var redirect = trans.redirect(detail);
              return redirect.run()["catch"](_rejectedTransitionHandler(redirect));
            }
            if (error.type === exports.RejectType.ABORTED) {
              isLatest && router.urlRouter.update();
              return services.$q.reject(error);
            }
          }
          var errorHandler = _this.defaultErrorHandler();
          errorHandler(error);
          return services.$q.reject(error);
        };
      };
      var transition = this.router.transitionService.create(currentPath, ref);
      var transitionToPromise = transition.run()["catch"](_rejectedTransitionHandler(transition));
      silenceUncaughtInPromise(transitionToPromise); // issue #2676
      // Return a promise for the transition, which also has the transition object on it.
      return extend(transitionToPromise, {
        transition: transition
      });
    };
    /**
     * Checks if the current state *is* the provided state
     *
     * Similar to [[includes]] but only checks for the full state name.
     * If params is supplied then it will be tested for strict equality against the current
     * active params object, so all params must match with none missing and no extras.
     *
     * #### Example:
     * ```js
     * $state.$current.name = 'contacts.details.item';
     *
     * // absolute name
     * $state.is('contact.details.item'); // returns true
     * $state.is(contactDetailItemStateObject); // returns true
     * ```
     *
     * // relative name (. and ^), typically from a template
     * // E.g. from the 'contacts.details' template
     * ```html
     * <div ng-class="{highlighted: $state.is('.item')}">Item</div>
     * ```
     *
     * @param stateOrName The state name (absolute or relative) or state object you'd like to check.
     * @param params A param object, e.g. `{sectionId: section.id}`, that you'd like
     * to test against the current active state.
     * @param options An options object. The options are:
     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
     *     test relative to `options.relative` state (or name).
     *
     * @returns Returns true if it is the state.
     */
    StateService.prototype.is = function (stateOrName, params, options) {
      options = defaults(options, {
        relative: this.$current
      });
      var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
      if (!isDefined(state)) return undefined;
      if (this.$current !== state) return false;
      if (!params) return true;
      var schema = state.parameters({
        inherit: true,
        matchingKeys: params
      });
      return Param.equals(schema, Param.values(schema, params), this.params);
    };
    /**
     * Checks if the current state *includes* the provided state
     *
     * A method to determine if the current active state is equal to or is the child of the
     * state stateName. If any params are passed then they will be tested for a match as well.
     * Not all the parameters need to be passed, just the ones you'd like to test for equality.
     *
     * #### Example when `$state.$current.name === 'contacts.details.item'`
     * ```js
     * // Using partial names
     * $state.includes("contacts"); // returns true
     * $state.includes("contacts.details"); // returns true
     * $state.includes("contacts.details.item"); // returns true
     * $state.includes("contacts.list"); // returns false
     * $state.includes("about"); // returns false
     * ```
     *
     * #### Glob Examples when `* $state.$current.name === 'contacts.details.item.url'`:
     * ```js
     * $state.includes("*.details.*.*"); // returns true
     * $state.includes("*.details.**"); // returns true
     * $state.includes("**.item.**"); // returns true
     * $state.includes("*.details.item.url"); // returns true
     * $state.includes("*.details.*.url"); // returns true
     * $state.includes("*.details.*"); // returns false
     * $state.includes("item.**"); // returns false
     * ```
     *
     * @param stateOrName A partial name, relative name, glob pattern,
     *   or state object to be searched for within the current state name.
     * @param params A param object, e.g. `{sectionId: section.id}`,
     *   that you'd like to test against the current active state.
     * @param options An options object. The options are:
     *   - `relative`: If `stateOrName` is a relative state name and `options.relative` is set, .is will
     *     test relative to `options.relative` state (or name).
     *
     * @returns {boolean} Returns true if it does include the state
     */
    StateService.prototype.includes = function (stateOrName, params, options) {
      options = defaults(options, {
        relative: this.$current
      });
      var glob = isString(stateOrName) && Glob.fromString(stateOrName);
      if (glob) {
        if (!glob.matches(this.$current.name)) return false;
        stateOrName = this.$current.name;
      }
      var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative),
        include = this.$current.includes;
      if (!isDefined(state)) return undefined;
      if (!isDefined(include[state.name])) return false;
      if (!params) return true;
      var schema = state.parameters({
        inherit: true,
        matchingKeys: params
      });
      return Param.equals(schema, Param.values(schema, params), this.params);
    };
    /**
     * Generates a URL for a state and parameters
     *
     * Returns the url for the given state populated with the given params.
     *
     * #### Example:
     * ```js
     * expect($state.href("about.person", { person: "bob" })).toEqual("/about/bob");
     * ```
     *
     * @param stateOrName The state name or state object you'd like to generate a url from.
     * @param params An object of parameter values to fill the state's required parameters.
     * @param options Options object. The options are:
     *
     * @returns {string} compiled state url
     */
    StateService.prototype.href = function (stateOrName, params, options) {
      var defaultHrefOpts = {
        lossy: true,
        inherit: true,
        absolute: false,
        relative: this.$current
      };
      options = defaults(options, defaultHrefOpts);
      params = params || {};
      var state = this.router.stateRegistry.matcher.find(stateOrName, options.relative);
      if (!isDefined(state)) return null;
      if (options.inherit) params = this.params.$inherit(params, this.$current, state);
      var nav = state && options.lossy ? state.navigable : state;
      if (!nav || nav.url === undefined || nav.url === null) {
        return null;
      }
      return this.router.urlRouter.href(nav.url, params, {
        absolute: options.absolute
      });
    };
    /**
     * Sets or gets the default [[transitionTo]] error handler.
     *
     * The error handler is called when a [[Transition]] is rejected or when any error occurred during the Transition.
     * This includes errors caused by resolves and transition hooks.
     *
     * Note:
     * This handler does not receive certain Transition rejections.
     * Redirected and Ignored Transitions are not considered to be errors by [[StateService.transitionTo]].
     *
     * The built-in default error handler logs the error to the console.
     *
     * You can provide your own custom handler.
     *
     * #### Example:
     * ```js
     * stateService.defaultErrorHandler(function() {
     *   // Do not log transitionTo errors
     * });
     * ```
     *
     * @param handler a global error handler function
     * @returns the current global error handler
     */
    StateService.prototype.defaultErrorHandler = function (handler) {
      return this._defaultErrorHandler = handler || this._defaultErrorHandler;
    };
    StateService.prototype.get = function (stateOrName, base) {
      var reg = this.router.stateRegistry;
      if (arguments.length === 0) return reg.get();
      return reg.get(stateOrName, base || this.$current);
    };
    /**
     * Lazy loads a state
     *
     * Explicitly runs a state's [[StateDeclaration.lazyLoad]] function.
     *
     * @param stateOrName the state that should be lazy loaded
     * @param transition the optional Transition context to use (if the lazyLoad function requires an injector, etc)
     * Note: If no transition is provided, a noop transition is created using the from the current state to the current state.
     * This noop transition is not actually run.
     *
     * @returns a promise to lazy load
     */
    StateService.prototype.lazyLoad = function (stateOrName, transition) {
      var state = this.get(stateOrName);
      if (!state || !state.lazyLoad) throw new Error('Can not lazy load ' + stateOrName);
      var currentPath = this.getCurrentPath();
      var target = PathUtils.makeTargetState(this.router.stateRegistry, currentPath);
      transition = transition || this.router.transitionService.create(currentPath, target);
      return lazyLoadState(transition, state);
    };
    return StateService;
  }();

  /**
   * An angular1-like promise api
   *
   * This object implements four methods similar to the
   * [angular 1 promise api](https://docs.angularjs.org/api/ng/service/$q)
   *
   * UI-Router evolved from an angular 1 library to a framework agnostic library.
   * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
   *
   * This API provides native ES6 promise support wrapped as a $q-like API.
   * Internally, UI-Router uses this $q object to perform promise operations.
   * The `angular-ui-router` (ui-router for angular 1) uses the $q API provided by angular.
   *
   * $q-like promise api
   */
  var $q = {
    /** Normalizes a value as a promise */
    when: function when(val) {
      return new Promise(function (resolve, reject) {
        return resolve(val);
      });
    },
    /** Normalizes a value as a promise rejection */
    reject: function reject(val) {
      return new Promise(function (resolve, reject) {
        reject(val);
      });
    },
    /** @returns a deferred object, which has `resolve` and `reject` functions */
    defer: function defer() {
      var deferred = {};
      deferred.promise = new Promise(function (resolve, reject) {
        deferred.resolve = resolve;
        deferred.reject = reject;
      });
      return deferred;
    },
    /** Like Promise.all(), but also supports object key/promise notation like $q */
    all: function all(promises) {
      if (isArray(promises)) {
        return Promise.all(promises);
      }
      if (isObject(promises)) {
        // Convert promises map to promises array.
        // When each promise resolves, map it to a tuple { key: key, val: val }
        var chain = Object.keys(promises).map(function (key) {
          return promises[key].then(function (val) {
            return {
              key: key,
              val: val
            };
          });
        });
        // Then wait for all promises to resolve, and convert them back to an object
        return $q.all(chain).then(function (values) {
          return values.reduce(function (acc, tuple) {
            acc[tuple.key] = tuple.val;
            return acc;
          }, {});
        });
      }
    }
  };

  // globally available injectables
  var globals = {};
  var STRIP_COMMENTS = /((\/\/.*$)|(\/\*[\s\S]*?\*\/))/gm;
  var ARGUMENT_NAMES = /([^\s,]+)/g;
  /**
   * A basic angular1-like injector api
   *
   * This object implements four methods similar to the
   * [angular 1 dependency injector](https://docs.angularjs.org/api/auto/service/$injector)
   *
   * UI-Router evolved from an angular 1 library to a framework agnostic library.
   * However, some of the `@uirouter/core` code uses these ng1 style APIs to support ng1 style dependency injection.
   *
   * This object provides a naive implementation of a globally scoped dependency injection system.
   * It supports the following DI approaches:
   *
   * ### Function parameter names
   *
   * A function's `.toString()` is called, and the parameter names are parsed.
   * This only works when the parameter names aren't "mangled" by a minifier such as UglifyJS.
   *
   * ```js
   * function injectedFunction(FooService, BarService) {
   *   // FooService and BarService are injected
   * }
   * ```
   *
   * ### Function annotation
   *
   * A function may be annotated with an array of dependency names as the `$inject` property.
   *
   * ```js
   * injectedFunction.$inject = [ 'FooService', 'BarService' ];
   * function injectedFunction(fs, bs) {
   *   // FooService and BarService are injected as fs and bs parameters
   * }
   * ```
   *
   * ### Array notation
   *
   * An array provides the names of the dependencies to inject (as strings).
   * The function is the last element of the array.
   *
   * ```js
   * [ 'FooService', 'BarService', function (fs, bs) {
   *   // FooService and BarService are injected as fs and bs parameters
   * }]
   * ```
   *
   * @type {$InjectorLike}
   */
  var $injector = {
    /** Gets an object from DI based on a string token */
    get: function get(name) {
      return globals[name];
    },
    /** Returns true if an object named `name` exists in global DI */
    has: function has(name) {
      return $injector.get(name) != null;
    },
    /**
     * Injects a function
     *
     * @param fn the function to inject
     * @param context the function's `this` binding
     * @param locals An object with additional DI tokens and values, such as `{ someToken: { foo: 1 } }`
     */
    invoke: function invoke(fn, context, locals) {
      var all = extend({}, globals, locals || {});
      var params = $injector.annotate(fn);
      var ensureExist = assertPredicate(function (key) {
        return all.hasOwnProperty(key);
      }, function (key) {
        return "DI can't find injectable: '" + key + "'";
      });
      var args = params.filter(ensureExist).map(function (x) {
        return all[x];
      });
      if (isFunction(fn)) return fn.apply(context, args);else return fn.slice(-1)[0].apply(context, args);
    },
    /**
     * Returns a function's dependencies
     *
     * Analyzes a function (or array) and returns an array of DI tokens that the function requires.
     * @return an array of `string`s
     */
    annotate: function annotate(fn) {
      if (!isInjectable(fn)) throw new Error("Not an injectable function: " + fn);
      if (fn && fn.$inject) return fn.$inject;
      if (isArray(fn)) return fn.slice(0, -1);
      var fnStr = fn.toString().replace(STRIP_COMMENTS, '');
      var result = fnStr.slice(fnStr.indexOf('(') + 1, fnStr.indexOf(')')).match(ARGUMENT_NAMES);
      return result || [];
    }
  };
  var keyValsToObjectR = function keyValsToObjectR(accum, _a) {
    var key = _a[0],
      val = _a[1];
    if (!accum.hasOwnProperty(key)) {
      accum[key] = val;
    } else if (isArray(accum[key])) {
      accum[key].push(val);
    } else {
      accum[key] = [accum[key], val];
    }
    return accum;
  };
  var getParams = function getParams(queryString) {
    return queryString.split('&').filter(identity).map(splitEqual).reduce(keyValsToObjectR, {});
  };
  function parseUrl$1(url) {
    var orEmptyString = function orEmptyString(x) {
      return x || '';
    };
    var _a = splitHash(url).map(orEmptyString),
      beforehash = _a[0],
      hash = _a[1];
    var _b = splitQuery(beforehash).map(orEmptyString),
      path = _b[0],
      search = _b[1];
    return {
      path: path,
      search: search,
      hash: hash,
      url: url
    };
  }
  var buildUrl = function buildUrl(loc) {
    var path = loc.path();
    var searchObject = loc.search();
    var hash = loc.hash();
    var search = Object.keys(searchObject).map(function (key) {
      var param = searchObject[key];
      var vals = isArray(param) ? param : [param];
      return vals.map(function (val) {
        return key + '=' + val;
      });
    }).reduce(unnestR, []).join('&');
    return path + (search ? '?' + search : '') + (hash ? '#' + hash : '');
  };
  function locationPluginFactory(name, isHtml5, serviceClass, configurationClass) {
    return function (uiRouter) {
      var service = uiRouter.locationService = new serviceClass(uiRouter);
      var configuration = uiRouter.locationConfig = new configurationClass(uiRouter, isHtml5);
      function dispose(router) {
        router.dispose(service);
        router.dispose(configuration);
      }
      return {
        name: name,
        service: service,
        configuration: configuration,
        dispose: dispose
      };
    };
  }

  /** A base `LocationServices` */
  var BaseLocationServices = /** @class */function () {
    function BaseLocationServices(router, fireAfterUpdate) {
      var _this = this;
      this.fireAfterUpdate = fireAfterUpdate;
      this._listeners = [];
      this._listener = function (evt) {
        return _this._listeners.forEach(function (cb) {
          return cb(evt);
        });
      };
      this.hash = function () {
        return parseUrl$1(_this._get()).hash;
      };
      this.path = function () {
        return parseUrl$1(_this._get()).path;
      };
      this.search = function () {
        return getParams(parseUrl$1(_this._get()).search);
      };
      this._location = root.location;
      this._history = root.history;
    }
    BaseLocationServices.prototype.url = function (url, replace) {
      if (replace === void 0) {
        replace = true;
      }
      if (isDefined(url) && url !== this._get()) {
        this._set(null, null, url, replace);
        if (this.fireAfterUpdate) {
          this._listeners.forEach(function (cb) {
            return cb({
              url: url
            });
          });
        }
      }
      return buildUrl(this);
    };
    BaseLocationServices.prototype.onChange = function (cb) {
      var _this = this;
      this._listeners.push(cb);
      return function () {
        return removeFrom(_this._listeners, cb);
      };
    };
    BaseLocationServices.prototype.dispose = function (router) {
      deregAll(this._listeners);
    };
    return BaseLocationServices;
  }();
  var __extends = undefined && undefined.__extends || function () {
    var _extendStatics = function extendStatics(d, b) {
      _extendStatics = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
      return _extendStatics(d, b);
    };
    return function (d, b) {
      _extendStatics(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  /** A `LocationServices` that uses the browser hash "#" to get/set the current location */
  var HashLocationService = /** @class */function (_super) {
    __extends(HashLocationService, _super);
    function HashLocationService(router) {
      var _this = _super.call(this, router, false) || this;
      root.addEventListener('hashchange', _this._listener, false);
      return _this;
    }
    HashLocationService.prototype._get = function () {
      return trimHashVal(this._location.hash);
    };
    HashLocationService.prototype._set = function (state, title, url, replace) {
      this._location.hash = url;
    };
    HashLocationService.prototype.dispose = function (router) {
      _super.prototype.dispose.call(this, router);
      root.removeEventListener('hashchange', this._listener);
    };
    return HashLocationService;
  }(BaseLocationServices);
  var __extends$1 = undefined && undefined.__extends || function () {
    var _extendStatics2 = function extendStatics(d, b) {
      _extendStatics2 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
      return _extendStatics2(d, b);
    };
    return function (d, b) {
      _extendStatics2(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  /** A `LocationServices` that gets/sets the current location from an in-memory object */
  var MemoryLocationService = /** @class */function (_super) {
    __extends$1(MemoryLocationService, _super);
    function MemoryLocationService(router) {
      return _super.call(this, router, true) || this;
    }
    MemoryLocationService.prototype._get = function () {
      return this._url;
    };
    MemoryLocationService.prototype._set = function (state, title, url, replace) {
      this._url = url;
    };
    return MemoryLocationService;
  }(BaseLocationServices);
  var __extends$2 = undefined && undefined.__extends || function () {
    var _extendStatics3 = function extendStatics(d, b) {
      _extendStatics3 = Object.setPrototypeOf || {
        __proto__: []
      } instanceof Array && function (d, b) {
        d.__proto__ = b;
      } || function (d, b) {
        for (var p in b) if (b.hasOwnProperty(p)) d[p] = b[p];
      };
      return _extendStatics3(d, b);
    };
    return function (d, b) {
      _extendStatics3(d, b);
      function __() {
        this.constructor = d;
      }
      d.prototype = b === null ? Object.create(b) : (__.prototype = b.prototype, new __());
    };
  }();
  /**
   * A `LocationServices` that gets/sets the current location using the browser's `location` and `history` apis
   *
   * Uses `history.pushState` and `history.replaceState`
   */
  var PushStateLocationService = /** @class */function (_super) {
    __extends$2(PushStateLocationService, _super);
    function PushStateLocationService(router) {
      var _this = _super.call(this, router, true) || this;
      _this._config = router.urlService.config;
      root.addEventListener('popstate', _this._listener, false);
      return _this;
    }
    /**
     * Gets the base prefix without:
     * - trailing slash
     * - trailing filename
     * - protocol and hostname
     *
     * If <base href='/base/'>, this returns '/base'.
     * If <base href='/foo/base/'>, this returns '/foo/base'.
     * If <base href='/base/index.html'>, this returns '/base'.
     * If <base href='http://localhost:8080/base/index.html'>, this returns '/base'.
     * If <base href='/base'>, this returns ''.
     * If <base href='http://localhost:8080'>, this returns ''.
     * If <base href='http://localhost:8080/'>, this returns ''.
     *
     * See: https://html.spec.whatwg.org/dev/semantics.html#the-base-element
     */
    PushStateLocationService.prototype._getBasePrefix = function () {
      return stripLastPathElement(this._config.baseHref());
    };
    PushStateLocationService.prototype._get = function () {
      var _a = this._location,
        pathname = _a.pathname,
        hash = _a.hash,
        search = _a.search;
      search = splitQuery(search)[1]; // strip ? if found
      hash = splitHash(hash)[1]; // strip # if found
      var basePrefix = this._getBasePrefix();
      var exactBaseHrefMatch = pathname === this._config.baseHref();
      var startsWithBase = pathname.substr(0, basePrefix.length) === basePrefix;
      pathname = exactBaseHrefMatch ? '/' : startsWithBase ? pathname.substring(basePrefix.length) : pathname;
      return pathname + (search ? '?' + search : '') + (hash ? '#' + hash : '');
    };
    PushStateLocationService.prototype._set = function (state, title, url, replace) {
      var basePrefix = this._getBasePrefix();
      var slash = url && url[0] !== '/' ? '/' : '';
      var fullUrl = url === '' || url === '/' ? this._config.baseHref() : basePrefix + slash + url;
      if (replace) {
        this._history.replaceState(state, title, fullUrl);
      } else {
        this._history.pushState(state, title, fullUrl);
      }
    };
    PushStateLocationService.prototype.dispose = function (router) {
      _super.prototype.dispose.call(this, router);
      root.removeEventListener('popstate', this._listener);
    };
    return PushStateLocationService;
  }(BaseLocationServices);

  /** A `LocationConfig` mock that gets/sets all config from an in-memory object */
  var MemoryLocationConfig = /** @class */function () {
    function MemoryLocationConfig() {
      var _this = this;
      this.dispose = noop;
      this._baseHref = '';
      this._port = 80;
      this._protocol = 'http';
      this._host = 'localhost';
      this._hashPrefix = '';
      this.port = function () {
        return _this._port;
      };
      this.protocol = function () {
        return _this._protocol;
      };
      this.host = function () {
        return _this._host;
      };
      this.baseHref = function () {
        return _this._baseHref;
      };
      this.html5Mode = function () {
        return false;
      };
      this.hashPrefix = function (newval) {
        return isDefined(newval) ? _this._hashPrefix = newval : _this._hashPrefix;
      };
    }
    return MemoryLocationConfig;
  }();

  /** A `LocationConfig` that delegates to the browser's `location` object */
  var BrowserLocationConfig = /** @class */function () {
    function BrowserLocationConfig(router, _isHtml5) {
      if (_isHtml5 === void 0) {
        _isHtml5 = false;
      }
      this._isHtml5 = _isHtml5;
      this._baseHref = undefined;
      this._hashPrefix = '';
    }
    BrowserLocationConfig.prototype.port = function () {
      if (location.port) {
        return Number(location.port);
      }
      return this.protocol() === 'https' ? 443 : 80;
    };
    BrowserLocationConfig.prototype.protocol = function () {
      return location.protocol.replace(/:/g, '');
    };
    BrowserLocationConfig.prototype.host = function () {
      return location.hostname;
    };
    BrowserLocationConfig.prototype.html5Mode = function () {
      return this._isHtml5;
    };
    BrowserLocationConfig.prototype.hashPrefix = function (newprefix) {
      return isDefined(newprefix) ? this._hashPrefix = newprefix : this._hashPrefix;
    };
    BrowserLocationConfig.prototype.baseHref = function (href) {
      if (isDefined(href)) this._baseHref = href;
      if (isUndefined(this._baseHref)) this._baseHref = this.getBaseHref();
      return this._baseHref;
    };
    BrowserLocationConfig.prototype.getBaseHref = function () {
      var baseTag = document.getElementsByTagName('base')[0];
      if (baseTag && baseTag.href) {
        return baseTag.href.replace(/^([^/:]*:)?\/\/[^/]*/, '');
      }
      return this._isHtml5 ? '/' : location.pathname || '/';
    };
    BrowserLocationConfig.prototype.dispose = function () {};
    return BrowserLocationConfig;
  }();
  function servicesPlugin(router) {
    services.$injector = $injector;
    services.$q = $q;
    return {
      name: 'vanilla.services',
      $q: $q,
      $injector: $injector,
      dispose: function dispose() {
        return null;
      }
    };
  }
  /** A `UIRouterPlugin` uses the browser hash to get/set the current location */
  var hashLocationPlugin = locationPluginFactory('vanilla.hashBangLocation', false, HashLocationService, BrowserLocationConfig);
  /** A `UIRouterPlugin` that gets/sets the current location using the browser's `location` and `history` apis */
  var pushStateLocationPlugin = locationPluginFactory('vanilla.pushStateLocation', true, PushStateLocationService, BrowserLocationConfig);
  /** A `UIRouterPlugin` that gets/sets the current location from an in-memory object */
  var memoryLocationPlugin = locationPluginFactory('vanilla.memoryLocation', false, MemoryLocationService, MemoryLocationConfig);
  var UIRouterPluginBase = /** @class */function () {
    function UIRouterPluginBase() {}
    UIRouterPluginBase.prototype.dispose = function (router) {};
    return UIRouterPluginBase;
  }();
  var index = /*#__PURE__*/Object.freeze({
    __proto__: null,
    root: root,
    fromJson: fromJson,
    toJson: toJson,
    forEach: forEach,
    extend: extend,
    equals: equals,
    identity: identity,
    noop: noop,
    createProxyFunctions: createProxyFunctions,
    inherit: inherit,
    inArray: inArray,
    _inArray: _inArray,
    removeFrom: removeFrom,
    _removeFrom: _removeFrom,
    pushTo: pushTo,
    _pushTo: _pushTo,
    deregAll: deregAll,
    defaults: defaults,
    mergeR: mergeR,
    ancestors: ancestors,
    pick: pick,
    omit: omit,
    pluck: pluck,
    filter: filter,
    find: find,
    mapObj: mapObj,
    map: map,
    values: values,
    allTrueR: allTrueR,
    anyTrueR: anyTrueR,
    unnestR: unnestR,
    flattenR: _flattenR,
    pushR: pushR,
    uniqR: uniqR,
    unnest: unnest,
    flatten: flatten,
    assertPredicate: assertPredicate,
    assertMap: assertMap,
    assertFn: assertFn,
    pairs: pairs,
    arrayTuples: arrayTuples,
    applyPairs: applyPairs,
    tail: tail,
    copy: copy,
    _extend: _extend,
    silenceUncaughtInPromise: silenceUncaughtInPromise,
    silentRejection: silentRejection,
    makeStub: makeStub,
    services: services,
    Glob: Glob,
    curry: curry,
    compose: compose,
    pipe: pipe,
    prop: prop,
    propEq: propEq,
    parse: parse,
    not: not,
    and: and,
    or: or,
    all: all,
    any: any,
    is: is,
    eq: eq,
    val: val,
    invoke: invoke,
    pattern: pattern,
    isUndefined: isUndefined,
    isDefined: isDefined,
    isNull: isNull,
    isNullOrUndefined: isNullOrUndefined,
    isFunction: isFunction,
    isNumber: isNumber,
    isString: isString,
    isObject: isObject,
    isArray: isArray,
    isDate: isDate,
    isRegExp: isRegExp,
    isInjectable: isInjectable,
    isPromise: isPromise,
    Queue: Queue,
    maxLength: maxLength,
    padString: padString,
    kebobString: kebobString,
    functionToString: functionToString,
    fnToString: fnToString,
    stringify: stringify,
    beforeAfterSubstr: beforeAfterSubstr,
    hostRegex: hostRegex,
    stripLastPathElement: stripLastPathElement,
    splitHash: splitHash,
    splitQuery: splitQuery,
    splitEqual: splitEqual,
    trimHashVal: trimHashVal,
    splitOnDelim: splitOnDelim,
    joinNeighborsR: joinNeighborsR,
    get Category() {
      return exports.Category;
    },
    Trace: Trace,
    trace: trace,
    get DefType() {
      return exports.DefType;
    },
    Param: Param,
    ParamTypes: ParamTypes,
    StateParams: StateParams,
    ParamType: ParamType,
    PathNode: PathNode,
    PathUtils: PathUtils,
    resolvePolicies: resolvePolicies,
    defaultResolvePolicy: defaultResolvePolicy,
    Resolvable: Resolvable,
    NATIVE_INJECTOR_TOKEN: NATIVE_INJECTOR_TOKEN,
    ResolveContext: ResolveContext,
    resolvablesBuilder: resolvablesBuilder,
    StateBuilder: StateBuilder,
    StateObject: StateObject,
    StateMatcher: StateMatcher,
    StateQueueManager: StateQueueManager,
    StateRegistry: StateRegistry,
    StateService: StateService,
    TargetState: TargetState,
    get TransitionHookPhase() {
      return exports.TransitionHookPhase;
    },
    get TransitionHookScope() {
      return exports.TransitionHookScope;
    },
    HookBuilder: HookBuilder,
    matchState: matchState,
    RegisteredHook: RegisteredHook,
    makeEvent: makeEvent,
    get RejectType() {
      return exports.RejectType;
    },
    Rejection: Rejection,
    Transition: Transition,
    TransitionHook: TransitionHook,
    TransitionEventType: TransitionEventType,
    defaultTransOpts: defaultTransOpts,
    TransitionService: TransitionService,
    UrlRules: UrlRules,
    UrlConfig: UrlConfig,
    UrlMatcher: UrlMatcher,
    ParamFactory: ParamFactory,
    UrlMatcherFactory: UrlMatcherFactory,
    UrlRouter: UrlRouter,
    UrlRuleFactory: UrlRuleFactory,
    BaseUrlRule: BaseUrlRule,
    UrlService: UrlService,
    ViewService: ViewService,
    UIRouterGlobals: UIRouterGlobals,
    UIRouter: UIRouter,
    $q: $q,
    $injector: $injector,
    BaseLocationServices: BaseLocationServices,
    HashLocationService: HashLocationService,
    MemoryLocationService: MemoryLocationService,
    PushStateLocationService: PushStateLocationService,
    MemoryLocationConfig: MemoryLocationConfig,
    BrowserLocationConfig: BrowserLocationConfig,
    keyValsToObjectR: keyValsToObjectR,
    getParams: getParams,
    parseUrl: parseUrl$1,
    buildUrl: buildUrl,
    locationPluginFactory: locationPluginFactory,
    servicesPlugin: servicesPlugin,
    hashLocationPlugin: hashLocationPlugin,
    pushStateLocationPlugin: pushStateLocationPlugin,
    memoryLocationPlugin: memoryLocationPlugin,
    UIRouterPluginBase: UIRouterPluginBase
  });

  /** @publicapi @module ng1 */ /** */
  /** @internalapi */
  function getNg1ViewConfigFactory() {
    var templateFactory = null;
    return function (path, view) {
      templateFactory = templateFactory || services.$injector.get('$templateFactory');
      return [new Ng1ViewConfig(path, view, templateFactory)];
    };
  }
  /** @internalapi */
  var hasAnyKey = function hasAnyKey(keys, obj) {
    return keys.reduce(function (acc, key) {
      return acc || isDefined(obj[key]);
    }, false);
  };
  /**
   * This is a [[StateBuilder.builder]] function for angular1 `views`.
   *
   * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
   * handles the `views` property with logic specific to @uirouter/angularjs (ng1).
   *
   * If no `views: {}` property exists on the [[StateDeclaration]], then it creates the `views` object
   * and applies the state-level configuration to a view named `$default`.
   *
   * @internalapi
   */
  function ng1ViewsBuilder(state) {
    // Do not process root state
    if (!state.parent) return {};
    var tplKeys = ['templateProvider', 'templateUrl', 'template', 'notify', 'async'],
      ctrlKeys = ['controller', 'controllerProvider', 'controllerAs', 'resolveAs'],
      compKeys = ['component', 'bindings', 'componentProvider'],
      nonCompKeys = tplKeys.concat(ctrlKeys),
      allViewKeys = compKeys.concat(nonCompKeys);
    // Do not allow a state to have both state-level props and also a `views: {}` property.
    // A state without a `views: {}` property can declare properties for the `$default` view as properties of the state.
    // However, the `$default` approach should not be mixed with a separate `views: ` block.
    if (isDefined(state.views) && hasAnyKey(allViewKeys, state)) {
      throw new Error("State '" + state.name + "' has a 'views' object. " + "It cannot also have \"view properties\" at the state level.  " + "Move the following properties into a view (in the 'views' object): " + (" " + allViewKeys.filter(function (key) {
        return isDefined(state[key]);
      }).join(', ')));
    }
    var views = {},
      viewsObject = state.views || {
        $default: pick(state, allViewKeys)
      };
    forEach(viewsObject, function (config, name) {
      // Account for views: { "": { template... } }
      name = name || '$default';
      // Account for views: { header: "headerComponent" }
      if (isString(config)) config = {
        component: config
      };
      // Make a shallow copy of the config object
      config = extend({}, config);
      // Do not allow a view to mix props for component-style view with props for template/controller-style view
      if (hasAnyKey(compKeys, config) && hasAnyKey(nonCompKeys, config)) {
        throw new Error("Cannot combine: " + compKeys.join('|') + " with: " + nonCompKeys.join('|') + " in stateview: '" + name + "@" + state.name + "'");
      }
      config.resolveAs = config.resolveAs || '$resolve';
      config.$type = 'ng1';
      config.$context = state;
      config.$name = name;
      var normalized = ViewService.normalizeUIViewTarget(config.$context, config.$name);
      config.$uiViewName = normalized.uiViewName;
      config.$uiViewContextAnchor = normalized.uiViewContextAnchor;
      views[name] = config;
    });
    return views;
  }
  /** @hidden */
  var id$1 = 0;
  /** @internalapi */
  var Ng1ViewConfig = /** @class */function () {
    function Ng1ViewConfig(path, viewDecl, factory) {
      var _this = this;
      this.path = path;
      this.viewDecl = viewDecl;
      this.factory = factory;
      this.$id = id$1++;
      this.loaded = false;
      this.getTemplate = function (uiView, context) {
        return _this.component ? _this.factory.makeComponentTemplate(uiView, context, _this.component, _this.viewDecl.bindings) : _this.template;
      };
    }
    Ng1ViewConfig.prototype.load = function () {
      var _this = this;
      var $q = services.$q;
      var context = new ResolveContext(this.path);
      var params = this.path.reduce(function (acc, node) {
        return extend(acc, node.paramValues);
      }, {});
      var promises = {
        template: $q.when(this.factory.fromConfig(this.viewDecl, params, context)),
        controller: $q.when(this.getController(context))
      };
      return $q.all(promises).then(function (results) {
        trace.traceViewServiceEvent('Loaded', _this);
        _this.controller = results.controller;
        extend(_this, results.template); // Either { template: "tpl" } or { component: "cmpName" }
        return _this;
      });
    };
    /**
     * Gets the controller for a view configuration.
     *
     * @returns {Function|Promise.<Function>} Returns a controller, or a promise that resolves to a controller.
     */
    Ng1ViewConfig.prototype.getController = function (context) {
      var provider = this.viewDecl.controllerProvider;
      if (!isInjectable(provider)) return this.viewDecl.controller;
      var deps = services.$injector.annotate(provider);
      var providerFn = isArray(provider) ? tail(provider) : provider;
      var resolvable = new Resolvable('', providerFn, deps);
      return resolvable.get(context);
    };
    return Ng1ViewConfig;
  }();

  /** @publicapi @module view */ /** */
  /**
   * Service which manages loading of templates from a ViewConfig.
   */
  var TemplateFactory = /** @class */function () {
    function TemplateFactory() {
      var _this = this;
      /** @hidden */
      this._useHttp = ng.version.minor < 3;
      /** @hidden */
      this.$get = ['$http', '$templateCache', '$injector', function ($http, $templateCache, $injector) {
        _this.$templateRequest = $injector.has && $injector.has('$templateRequest') && $injector.get('$templateRequest');
        _this.$http = $http;
        _this.$templateCache = $templateCache;
        return _this;
      }];
    }
    /** @hidden */
    TemplateFactory.prototype.useHttpService = function (value) {
      this._useHttp = value;
    };
    /**
     * Creates a template from a configuration object.
     *
     * @param config Configuration object for which to load a template.
     * The following properties are search in the specified order, and the first one
     * that is defined is used to create the template:
     *
     * @param params  Parameters to pass to the template function.
     * @param context The resolve context associated with the template's view
     *
     * @return {string|object}  The template html as a string, or a promise for
     * that string,or `null` if no template is configured.
     */
    TemplateFactory.prototype.fromConfig = function (config, params, context) {
      var defaultTemplate = '<ui-view></ui-view>';
      var asTemplate = function asTemplate(result) {
        return services.$q.when(result).then(function (str) {
          return {
            template: str
          };
        });
      };
      var asComponent = function asComponent(result) {
        return services.$q.when(result).then(function (str) {
          return {
            component: str
          };
        });
      };
      return isDefined(config.template) ? asTemplate(this.fromString(config.template, params)) : isDefined(config.templateUrl) ? asTemplate(this.fromUrl(config.templateUrl, params)) : isDefined(config.templateProvider) ? asTemplate(this.fromProvider(config.templateProvider, params, context)) : isDefined(config.component) ? asComponent(config.component) : isDefined(config.componentProvider) ? asComponent(this.fromComponentProvider(config.componentProvider, params, context)) : asTemplate(defaultTemplate);
    };
    /**
     * Creates a template from a string or a function returning a string.
     *
     * @param template html template as a string or function that returns an html template as a string.
     * @param params Parameters to pass to the template function.
     *
     * @return {string|object} The template html as a string, or a promise for that
     * string.
     */
    TemplateFactory.prototype.fromString = function (template, params) {
      return isFunction(template) ? template(params) : template;
    };
    /**
     * Loads a template from the a URL via `$http` and `$templateCache`.
     *
     * @param {string|Function} url url of the template to load, or a function
     * that returns a url.
     * @param {Object} params Parameters to pass to the url function.
     * @return {string|Promise.<string>} The template html as a string, or a promise
     * for that string.
     */
    TemplateFactory.prototype.fromUrl = function (url, params) {
      if (isFunction(url)) url = url(params);
      if (url == null) return null;
      if (this._useHttp) {
        return this.$http.get(url, {
          cache: this.$templateCache,
          headers: {
            Accept: 'text/html'
          }
        }).then(function (response) {
          return response.data;
        });
      }
      return this.$templateRequest(url);
    };
    /**
     * Creates a template by invoking an injectable provider function.
     *
     * @param provider Function to invoke via `locals`
     * @param {Function} injectFn a function used to invoke the template provider
     * @return {string|Promise.<string>} The template html as a string, or a promise
     * for that string.
     */
    TemplateFactory.prototype.fromProvider = function (provider, params, context) {
      var deps = services.$injector.annotate(provider);
      var providerFn = isArray(provider) ? tail(provider) : provider;
      var resolvable = new Resolvable('', providerFn, deps);
      return resolvable.get(context);
    };
    /**
     * Creates a component's template by invoking an injectable provider function.
     *
     * @param provider Function to invoke via `locals`
     * @param {Function} injectFn a function used to invoke the template provider
     * @return {string} The template html as a string: "<component-name input1='::$resolve.foo'></component-name>".
     */
    TemplateFactory.prototype.fromComponentProvider = function (provider, params, context) {
      var deps = services.$injector.annotate(provider);
      var providerFn = isArray(provider) ? tail(provider) : provider;
      var resolvable = new Resolvable('', providerFn, deps);
      return resolvable.get(context);
    };
    /**
     * Creates a template from a component's name
     *
     * This implements route-to-component.
     * It works by retrieving the component (directive) metadata from the injector.
     * It analyses the component's bindings, then constructs a template that instantiates the component.
     * The template wires input and output bindings to resolves or from the parent component.
     *
     * @param uiView {object} The parent ui-view (for binding outputs to callbacks)
     * @param context The ResolveContext (for binding outputs to callbacks returned from resolves)
     * @param component {string} Component's name in camel case.
     * @param bindings An object defining the component's bindings: {foo: '<'}
     * @return {string} The template as a string: "<component-name input1='::$resolve.foo'></component-name>".
     */
    TemplateFactory.prototype.makeComponentTemplate = function (uiView, context, component, bindings) {
      bindings = bindings || {};
      // Bind once prefix
      var prefix = ng.version.minor >= 3 ? '::' : '';
      // Convert to kebob name. Add x- prefix if the string starts with `x-` or `data-`
      var kebob = function kebob(camelCase) {
        var kebobed = kebobString(camelCase);
        return /^(x|data)-/.exec(kebobed) ? "x-" + kebobed : kebobed;
      };
      var attributeTpl = function attributeTpl(input) {
        var name = input.name,
          type = input.type;
        var attrName = kebob(name);
        // If the ui-view has an attribute which matches a binding on the routed component
        // then pass that attribute through to the routed component template.
        // Prefer ui-view wired mappings to resolve data, unless the resolve was explicitly bound using `bindings:`
        if (uiView.attr(attrName) && !bindings[name]) return attrName + "='" + uiView.attr(attrName) + "'";
        var resolveName = bindings[name] || name;
        // Pre-evaluate the expression for "@" bindings by enclosing in {{ }}
        // some-attr="{{ ::$resolve.someResolveName }}"
        if (type === '@') return attrName + "='{{" + prefix + "$resolve." + resolveName + "}}'";
        // Wire "&" callbacks to resolves that return a callback function
        // Get the result of the resolve (should be a function) and annotate it to get its arguments.
        // some-attr="$resolve.someResolveResultName(foo, bar)"
        if (type === '&') {
          var res = context.getResolvable(resolveName);
          var fn = res && res.data;
          var args = fn && services.$injector.annotate(fn) || [];
          // account for array style injection, i.e., ['foo', function(foo) {}]
          var arrayIdxStr = isArray(fn) ? "[" + (fn.length - 1) + "]" : '';
          return attrName + "='$resolve." + resolveName + arrayIdxStr + "(" + args.join(',') + ")'";
        }
        // some-attr="::$resolve.someResolveName"
        return attrName + "='" + prefix + "$resolve." + resolveName + "'";
      };
      var attrs = getComponentBindings(component).map(attributeTpl).join(' ');
      var kebobName = kebob(component);
      return "<" + kebobName + " " + attrs + "></" + kebobName + ">";
    };
    return TemplateFactory;
  }();
  // Gets all the directive(s)' inputs ('@', '=', and '<') and outputs ('&')
  function getComponentBindings(name) {
    var cmpDefs = services.$injector.get(name + 'Directive'); // could be multiple
    if (!cmpDefs || !cmpDefs.length) throw new Error("Unable to find component named '" + name + "'");
    return cmpDefs.map(getBindings).reduce(unnestR, []);
  }
  // Given a directive definition, find its object input attributes
  // Use different properties, depending on the type of directive (component, bindToController, normal)
  var getBindings = function getBindings(def) {
    if (isObject(def.bindToController)) return scopeBindings(def.bindToController);
    return scopeBindings(def.scope);
  };
  // for ng 1.2 style, process the scope: { input: "=foo" }
  // for ng 1.3 through ng 1.5, process the component's bindToController: { input: "=foo" } object
  var scopeBindings = function scopeBindings(bindingsObj) {
    return Object.keys(bindingsObj || {})
    // [ 'input', [ '=foo', '=', 'foo' ] ]
    .map(function (key) {
      return [key, /^([=<@&])[?]?(.*)/.exec(bindingsObj[key])];
    })
    // skip malformed values
    .filter(function (tuple) {
      return isDefined(tuple) && isArray(tuple[1]);
    })
    // { name: ('foo' || 'input'), type: '=' }
    .map(function (tuple) {
      return {
        name: tuple[1][2] || tuple[0],
        type: tuple[1][1]
      };
    });
  };

  /** @publicapi @module ng1 */ /** */
  /**
   * The Angular 1 `StateProvider`
   *
   * The `$stateProvider` works similar to Angular's v1 router, but it focuses purely
   * on state.
   *
   * A state corresponds to a "place" in the application in terms of the overall UI and
   * navigation. A state describes (via the controller / template / view properties) what
   * the UI looks like and does at that place.
   *
   * States often have things in common, and the primary way of factoring out these
   * commonalities in this model is via the state hierarchy, i.e. parent/child states aka
   * nested states.
   *
   * The `$stateProvider` provides interfaces to declare these states for your app.
   */
  var StateProvider = /** @class */function () {
    function StateProvider(stateRegistry, stateService) {
      this.stateRegistry = stateRegistry;
      this.stateService = stateService;
      createProxyFunctions(val(StateProvider.prototype), this, val(this));
    }
    /**
     * Decorates states when they are registered
     *
     * Allows you to extend (carefully) or override (at your own peril) the
     * `stateBuilder` object used internally by [[StateRegistry]].
     * This can be used to add custom functionality to ui-router,
     * for example inferring templateUrl based on the state name.
     *
     * When passing only a name, it returns the current (original or decorated) builder
     * function that matches `name`.
     *
     * The builder functions that can be decorated are listed below. Though not all
     * necessarily have a good use case for decoration, that is up to you to decide.
     *
     * In addition, users can attach custom decorators, which will generate new
     * properties within the state's internal definition. There is currently no clear
     * use-case for this beyond accessing internal states (i.e. $state.$current),
     * however, expect this to become increasingly relevant as we introduce additional
     * meta-programming features.
     *
     * **Warning**: Decorators should not be interdependent because the order of
     * execution of the builder functions in non-deterministic. Builder functions
     * should only be dependent on the state definition object and super function.
     *
     *
     * Existing builder functions and current return values:
     *
     * - **parent** `{object}` - returns the parent state object.
     * - **data** `{object}` - returns state data, including any inherited data that is not
     *   overridden by own values (if any).
     * - **url** `{object}` - returns a {@link ui.router.util.type:UrlMatcher UrlMatcher}
     *   or `null`.
     * - **navigable** `{object}` - returns closest ancestor state that has a URL (aka is
     *   navigable).
     * - **params** `{object}` - returns an array of state params that are ensured to
     *   be a super-set of parent's params.
     * - **views** `{object}` - returns a views object where each key is an absolute view
     *   name (i.e. "viewName@stateName") and each value is the config object
     *   (template, controller) for the view. Even when you don't use the views object
     *   explicitly on a state config, one is still created for you internally.
     *   So by decorating this builder function you have access to decorating template
     *   and controller properties.
     * - **ownParams** `{object}` - returns an array of params that belong to the state,
     *   not including any params defined by ancestor states.
     * - **path** `{string}` - returns the full path from the root down to this state.
     *   Needed for state activation.
     * - **includes** `{object}` - returns an object that includes every state that
     *   would pass a `$state.includes()` test.
     *
     * #### Example:
     * Override the internal 'views' builder with a function that takes the state
     * definition, and a reference to the internal function being overridden:
     * ```js
     * $stateProvider.decorator('views', function (state, parent) {
     *   let result = {},
     *       views = parent(state);
     *
     *   angular.forEach(views, function (config, name) {
     *     let autoName = (state.name + '.' + name).replace('.', '/');
     *     config.templateUrl = config.templateUrl || '/partials/' + autoName + '.html';
     *     result[name] = config;
     *   });
     *   return result;
     * });
     *
     * $stateProvider.state('home', {
     *   views: {
     *     'contact.list': { controller: 'ListController' },
     *     'contact.item': { controller: 'ItemController' }
     *   }
     * });
     * ```
     *
     *
     * ```js
     * // Auto-populates list and item views with /partials/home/contact/list.html,
     * // and /partials/home/contact/item.html, respectively.
     * $state.go('home');
     * ```
     *
     * @param {string} name The name of the builder function to decorate.
     * @param {object} func A function that is responsible for decorating the original
     * builder function. The function receives two parameters:
     *
     *   - `{object}` - state - The state config object.
     *   - `{object}` - super - The original builder function.
     *
     * @return {object} $stateProvider - $stateProvider instance
     */
    StateProvider.prototype.decorator = function (name, func) {
      return this.stateRegistry.decorator(name, func) || this;
    };
    StateProvider.prototype.state = function (name, definition) {
      if (isObject(name)) {
        definition = name;
      } else {
        definition.name = name;
      }
      this.stateRegistry.register(definition);
      return this;
    };
    /**
     * Registers an invalid state handler
     *
     * This is a passthrough to [[StateService.onInvalid]] for ng1.
     */
    StateProvider.prototype.onInvalid = function (callback) {
      return this.stateService.onInvalid(callback);
    };
    return StateProvider;
  }();

  /** @publicapi @module ng1 */ /** */
  /**
   * This is a [[StateBuilder.builder]] function for angular1 `onEnter`, `onExit`,
   * `onRetain` callback hooks on a [[Ng1StateDeclaration]].
   *
   * When the [[StateBuilder]] builds a [[StateObject]] object from a raw [[StateDeclaration]], this builder
   * ensures that those hooks are injectable for @uirouter/angularjs (ng1).
   *
   * @internalapi
   */
  var getStateHookBuilder = function getStateHookBuilder(hookName) {
    return function stateHookBuilder(stateObject) {
      var hook = stateObject[hookName];
      var pathname = hookName === 'onExit' ? 'from' : 'to';
      function decoratedNg1Hook(trans, state) {
        var resolveContext = new ResolveContext(trans.treeChanges(pathname));
        var subContext = resolveContext.subContext(state.$$state());
        var locals = extend(getLocals(subContext), {
          $state$: state,
          $transition$: trans
        });
        return services.$injector.invoke(hook, this, locals);
      }
      return hook ? decoratedNg1Hook : undefined;
    };
  };

  /** @publicapi @module ng1 */ /** */
  /**
   * Implements UI-Router LocationServices and LocationConfig using Angular 1's $location service
   * @internalapi
   */
  var Ng1LocationServices = /** @class */function () {
    function Ng1LocationServices($locationProvider) {
      // .onChange() registry
      this._urlListeners = [];
      this.$locationProvider = $locationProvider;
      var _lp = val($locationProvider);
      createProxyFunctions(_lp, this, _lp, ['hashPrefix']);
    }
    /**
     * Applys ng1-specific path parameter encoding
     *
     * The Angular 1 `$location` service is a bit weird.
     * It doesn't allow slashes to be encoded/decoded bi-directionally.
     *
     * See the writeup at https://github.com/angular-ui/ui-router/issues/2598
     *
     * This code patches the `path` parameter type so it encoded/decodes slashes as ~2F
     *
     * @param router
     */
    Ng1LocationServices.monkeyPatchPathParameterType = function (router) {
      var pathType = router.urlMatcherFactory.type('path');
      pathType.encode = function (x) {
        return x != null ? x.toString().replace(/(~|\/)/g, function (m) {
          return {
            '~': '~~',
            '/': '~2F'
          }[m];
        }) : x;
      };
      pathType.decode = function (x) {
        return x != null ? x.toString().replace(/(~~|~2F)/g, function (m) {
          return {
            '~~': '~',
            '~2F': '/'
          }[m];
        }) : x;
      };
    };
    // eslint-disable-next-line @typescript-eslint/no-empty-function
    Ng1LocationServices.prototype.dispose = function () {};
    Ng1LocationServices.prototype.onChange = function (callback) {
      var _this = this;
      this._urlListeners.push(callback);
      return function () {
        return removeFrom(_this._urlListeners)(callback);
      };
    };
    Ng1LocationServices.prototype.html5Mode = function () {
      var html5Mode = this.$locationProvider.html5Mode();
      html5Mode = isObject(html5Mode) ? html5Mode.enabled : html5Mode;
      return html5Mode && this.$sniffer.history;
    };
    Ng1LocationServices.prototype.baseHref = function () {
      return this._baseHref || (this._baseHref = this.$browser.baseHref() || this.$window.location.pathname);
    };
    Ng1LocationServices.prototype.url = function (newUrl, replace, state) {
      if (replace === void 0) {
        replace = false;
      }
      if (isDefined(newUrl)) this.$location.url(newUrl);
      if (replace) this.$location.replace();
      if (state) this.$location.state(state);
      return this.$location.url();
    };
    Ng1LocationServices.prototype._runtimeServices = function ($rootScope, $location, $sniffer, $browser, $window) {
      var _this = this;
      this.$location = $location;
      this.$sniffer = $sniffer;
      this.$browser = $browser;
      this.$window = $window;
      // Bind $locationChangeSuccess to the listeners registered in LocationService.onChange
      $rootScope.$on('$locationChangeSuccess', function (evt) {
        return _this._urlListeners.forEach(function (fn) {
          return fn(evt);
        });
      });
      var _loc = val($location);
      // Bind these LocationService functions to $location
      createProxyFunctions(_loc, this, _loc, ['replace', 'path', 'search', 'hash']);
      // Bind these LocationConfig functions to $location
      createProxyFunctions(_loc, this, _loc, ['port', 'protocol', 'host']);
    };
    return Ng1LocationServices;
  }();

  /** @publicapi @module url */ /** */
  /**
   * Manages rules for client-side URL
   *
   * ### Deprecation warning:
   * This class is now considered to be an internal API
   * Use the [[UrlService]] instead.
   * For configuring URL rules, use the [[UrlRulesApi]] which can be found as [[UrlService.rules]].
   *
   * This class manages the router rules for what to do when the URL changes.
   *
   * This provider remains for backwards compatibility.
   *
   * @internalapi
   * @deprecated
   */
  var UrlRouterProvider = /** @class */function () {
    /** @hidden */
    function UrlRouterProvider(/** @hidden */router) {
      this.router = router;
    }
    UrlRouterProvider.injectableHandler = function (router, handler) {
      return function (match) {
        return services.$injector.invoke(handler, null, {
          $match: match,
          $stateParams: router.globals.params
        });
      };
    };
    /** @hidden */
    UrlRouterProvider.prototype.$get = function () {
      var urlService = this.router.urlService;
      this.router.urlRouter.update(true);
      if (!urlService.interceptDeferred) urlService.listen();
      return this.router.urlRouter;
    };
    /**
     * Registers a url handler function.
     *
     * Registers a low level url handler (a `rule`).
     * A rule detects specific URL patterns and returns a redirect, or performs some action.
     *
     * If a rule returns a string, the URL is replaced with the string, and all rules are fired again.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // Here's an example of how you might allow case insensitive urls
     *   $urlRouterProvider.rule(function ($injector, $location) {
     *     var path = $location.path(),
     *         normalized = path.toLowerCase();
     *
     *     if (path !== normalized) {
     *       return normalized;
     *     }
     *   });
     * });
     * ```
     *
     * @param ruleFn
     * Handler function that takes `$injector` and `$location` services as arguments.
     * You can use them to detect a url and return a different url as a string.
     *
     * @return [[UrlRouterProvider]] (`this`)
     */
    UrlRouterProvider.prototype.rule = function (ruleFn) {
      var _this = this;
      if (!isFunction(ruleFn)) throw new Error("'rule' must be a function");
      var match = function match() {
        return ruleFn(services.$injector, _this.router.locationService);
      };
      var rule = new BaseUrlRule(match, identity);
      this.router.urlService.rules.rule(rule);
      return this;
    };
    /**
     * Defines the path or behavior to use when no url can be matched.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // if the path doesn't match any of the urls you configured
     *   // otherwise will take care of routing the user to the
     *   // specified url
     *   $urlRouterProvider.otherwise('/index');
     *
     *   // Example of using function rule as param
     *   $urlRouterProvider.otherwise(function ($injector, $location) {
     *     return '/a/valid/url';
     *   });
     * });
     * ```
     *
     * @param rule
     * The url path you want to redirect to or a function rule that returns the url path or performs a `$state.go()`.
     * The function version is passed two params: `$injector` and `$location` services, and should return a url string.
     *
     * @return {object} `$urlRouterProvider` - `$urlRouterProvider` instance
     */
    UrlRouterProvider.prototype.otherwise = function (rule) {
      var _this = this;
      var urlRules = this.router.urlService.rules;
      if (isString(rule)) {
        urlRules.otherwise(rule);
      } else if (isFunction(rule)) {
        urlRules.otherwise(function () {
          return rule(services.$injector, _this.router.locationService);
        });
      } else {
        throw new Error("'rule' must be a string or function");
      }
      return this;
    };
    /**
     * Registers a handler for a given url matching.
     *
     * If the handler is a string, it is
     * treated as a redirect, and is interpolated according to the syntax of match
     * (i.e. like `String.replace()` for `RegExp`, or like a `UrlMatcher` pattern otherwise).
     *
     * If the handler is a function, it is injectable.
     * It gets invoked if `$location` matches.
     * You have the option of inject the match object as `$match`.
     *
     * The handler can return
     *
     * - **falsy** to indicate that the rule didn't match after all, then `$urlRouter`
     *   will continue trying to find another one that matches.
     * - **string** which is treated as a redirect and passed to `$location.url()`
     * - **void** or any **truthy** value tells `$urlRouter` that the url was handled.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   $urlRouterProvider.when($state.url, function ($match, $stateParams) {
     *     if ($state.$current.navigable !== state ||
     *         !equalForKeys($match, $stateParams) {
     *      $state.transitionTo(state, $match, false);
     *     }
     *   });
     * });
     * ```
     *
     * @param what A pattern string to match, compiled as a [[UrlMatcher]].
     * @param handler The path (or function that returns a path) that you want to redirect your user to.
     * @param ruleCallback [optional] A callback that receives the `rule` registered with [[UrlMatcher.rule]]
     *
     * Note: the handler may also invoke arbitrary code, such as `$state.go()`
     */
    UrlRouterProvider.prototype.when = function (what, handler) {
      if (isArray(handler) || isFunction(handler)) {
        handler = UrlRouterProvider.injectableHandler(this.router, handler);
      }
      this.router.urlService.rules.when(what, handler);
      return this;
    };
    /**
     * Disables monitoring of the URL.
     *
     * Call this method before UI-Router has bootstrapped.
     * It will stop UI-Router from performing the initial url sync.
     *
     * This can be useful to perform some asynchronous initialization before the router starts.
     * Once the initialization is complete, call [[listen]] to tell UI-Router to start watching and synchronizing the URL.
     *
     * #### Example:
     * ```js
     * var app = angular.module('app', ['ui.router']);
     *
     * app.config(function ($urlRouterProvider) {
     *   // Prevent $urlRouter from automatically intercepting URL changes;
     *   $urlRouterProvider.deferIntercept();
     * })
     *
     * app.run(function (MyService, $urlRouter, $http) {
     *   $http.get("/stuff").then(function(resp) {
     *     MyService.doStuff(resp.data);
     *     $urlRouter.listen();
     *     $urlRouter.sync();
     *   });
     * });
     * ```
     *
     * @param defer Indicates whether to defer location change interception.
     *        Passing no parameter is equivalent to `true`.
     */
    UrlRouterProvider.prototype.deferIntercept = function (defer) {
      this.router.urlService.deferIntercept(defer);
    };
    return UrlRouterProvider;
  }();

  /* eslint-disable @typescript-eslint/no-empty-function */
  ng.module('ui.router.angular1', []);
  var mod_init = ng.module('ui.router.init', ['ng']);
  var mod_util = ng.module('ui.router.util', ['ui.router.init']);
  var mod_rtr = ng.module('ui.router.router', ['ui.router.util']);
  var mod_state = ng.module('ui.router.state', ['ui.router.router', 'ui.router.util', 'ui.router.angular1']);
  var mod_main = ng.module('ui.router', ['ui.router.init', 'ui.router.state', 'ui.router.angular1']);
  var mod_cmpt = ng.module('ui.router.compat', ['ui.router']);
  var router = null;
  $uiRouterProvider.$inject = ['$locationProvider'];
  /** This angular 1 provider instantiates a Router and exposes its services via the angular injector */
  function $uiRouterProvider($locationProvider) {
    // Create a new instance of the Router when the $uiRouterProvider is initialized
    router = this.router = new UIRouter();
    router.stateProvider = new StateProvider(router.stateRegistry, router.stateService);
    // Apply ng1 specific StateBuilder code for `views`, `resolve`, and `onExit/Retain/Enter` properties
    router.stateRegistry.decorator('views', ng1ViewsBuilder);
    router.stateRegistry.decorator('onExit', getStateHookBuilder('onExit'));
    router.stateRegistry.decorator('onRetain', getStateHookBuilder('onRetain'));
    router.stateRegistry.decorator('onEnter', getStateHookBuilder('onEnter'));
    router.viewService._pluginapi._viewConfigFactory('ng1', getNg1ViewConfigFactory());
    // Disable decoding of params by UrlMatcherFactory because $location already handles this
    router.urlService.config._decodeParams = false;
    var ng1LocationService = router.locationService = router.locationConfig = new Ng1LocationServices($locationProvider);
    Ng1LocationServices.monkeyPatchPathParameterType(router);
    // backwards compat: also expose router instance as $uiRouterProvider.router
    router['router'] = router;
    router['$get'] = $get;
    $get.$inject = ['$location', '$browser', '$window', '$sniffer', '$rootScope', '$http', '$templateCache'];
    function $get($location, $browser, $window, $sniffer, $rootScope, $http, $templateCache) {
      ng1LocationService._runtimeServices($rootScope, $location, $sniffer, $browser, $window);
      delete router['router'];
      delete router['$get'];
      return router;
    }
    return router;
  }
  var getProviderFor = function getProviderFor(serviceName) {
    return ['$uiRouterProvider', function ($urp) {
      var service = $urp.router[serviceName];
      service['$get'] = function () {
        return service;
      };
      return service;
    }];
  };
  // This effectively calls $get() on `$uiRouterProvider` to trigger init (when ng enters runtime)
  runBlock.$inject = ['$injector', '$q', '$uiRouter'];
  function runBlock($injector, $q, $uiRouter) {
    services.$injector = $injector;
    services.$q = $q;
    // https://github.com/angular-ui/ui-router/issues/3678
    if (!Object.prototype.hasOwnProperty.call($injector, 'strictDi')) {
      try {
        $injector.invoke(function (checkStrictDi) {});
      } catch (error) {
        $injector.strictDi = !!/strict mode/.exec(error && error.toString());
      }
    }
    // The $injector is now available.
    // Find any resolvables that had dependency annotation deferred
    $uiRouter.stateRegistry.get().map(function (x) {
      return x.$$state().resolvables;
    }).reduce(unnestR, []).filter(function (x) {
      return x.deps === 'deferred';
    }).forEach(function (resolvable) {
      return resolvable.deps = $injector.annotate(resolvable.resolveFn, $injector.strictDi);
    });
  }
  // $urlRouter service and $urlRouterProvider
  var getUrlRouterProvider = function getUrlRouterProvider(uiRouter) {
    return uiRouter.urlRouterProvider = new UrlRouterProvider(uiRouter);
  };
  // $state service and $stateProvider
  // $urlRouter service and $urlRouterProvider
  var getStateProvider = function getStateProvider() {
    return extend(router.stateProvider, {
      $get: function $get() {
        return router.stateService;
      }
    });
  };
  watchDigests.$inject = ['$rootScope'];
  function watchDigests($rootScope) {
    $rootScope.$watch(function () {
      trace.approximateDigests++;
    });
  }
  mod_init.provider('$uiRouter', $uiRouterProvider);
  mod_rtr.provider('$urlRouter', ['$uiRouterProvider', getUrlRouterProvider]);
  mod_util.provider('$urlService', getProviderFor('urlService'));
  mod_util.provider('$urlMatcherFactory', ['$uiRouterProvider', function () {
    return router.urlMatcherFactory;
  }]);
  mod_util.provider('$templateFactory', function () {
    return new TemplateFactory();
  });
  mod_state.provider('$stateRegistry', getProviderFor('stateRegistry'));
  mod_state.provider('$uiRouterGlobals', getProviderFor('globals'));
  mod_state.provider('$transitions', getProviderFor('transitionService'));
  mod_state.provider('$state', ['$uiRouterProvider', getStateProvider]);
  mod_state.factory('$stateParams', ['$uiRouter', function ($uiRouter) {
    return $uiRouter.globals.params;
  }]);
  mod_main.factory('$view', function () {
    return router.viewService;
  });
  mod_main.service('$trace', function () {
    return trace;
  });
  mod_main.run(watchDigests);
  mod_util.run(['$urlMatcherFactory', function ($urlMatcherFactory) {}]);
  mod_state.run(['$state', function ($state) {}]);
  mod_rtr.run(['$urlRouter', function ($urlRouter) {}]);
  mod_init.run(runBlock);
  /** @hidden TODO: find a place to move this */
  var getLocals = function getLocals(ctx) {
    var tokens = ctx.getTokens().filter(isString);
    var tuples = tokens.map(function (key) {
      var resolvable = ctx.getResolvable(key);
      var waitPolicy = ctx.getPolicy(resolvable).async;
      return [key, waitPolicy === 'NOWAIT' ? resolvable.promise : resolvable.data];
    });
    return tuples.reduce(applyPairs, {});
  };

  /* eslint-disable @typescript-eslint/no-empty-interface */
  /** @hidden */
  function parseStateRef(ref) {
    var paramsOnly = ref.match(/^\s*({[^}]*})\s*$/);
    if (paramsOnly) ref = '(' + paramsOnly[1] + ')';
    var parsed = ref.replace(/\n/g, ' ').match(/^\s*([^(]*?)\s*(\((.*)\))?\s*$/);
    if (!parsed || parsed.length !== 4) throw new Error("Invalid state ref '" + ref + "'");
    return {
      state: parsed[1] || null,
      paramExpr: parsed[3] || null
    };
  }
  /** @hidden */
  function stateContext(el) {
    var $uiView = el.parent().inheritedData('$uiView');
    var path = parse('$cfg.path')($uiView);
    return path ? tail(path).state.name : undefined;
  }
  /** @hidden */
  function processedDef($state, $element, def) {
    var uiState = def.uiState || $state.current.name;
    var uiStateOpts = extend(defaultOpts($element, $state), def.uiStateOpts || {});
    var href = $state.href(uiState, def.uiStateParams, uiStateOpts);
    return {
      uiState: uiState,
      uiStateParams: def.uiStateParams,
      uiStateOpts: uiStateOpts,
      href: href
    };
  }
  /** @hidden */
  function getTypeInfo(el) {
    // SVGAElement does not use the href attribute, but rather the 'xlinkHref' attribute.
    var isSvg = Object.prototype.toString.call(el.prop('href')) === '[object SVGAnimatedString]';
    var isForm = el[0].nodeName === 'FORM';
    return {
      attr: isForm ? 'action' : isSvg ? 'xlink:href' : 'href',
      isAnchor: el.prop('tagName').toUpperCase() === 'A',
      clickable: !isForm
    };
  }
  /** @hidden */
  function clickHook(el, $state, $timeout, type, getDef) {
    return function (e) {
      var button = e.which || e.button,
        target = getDef();
      if (!(button > 1 || e.ctrlKey || e.metaKey || e.shiftKey || e.altKey || el.attr('target'))) {
        // HACK: This is to allow ng-clicks to be processed before the transition is initiated:
        var transition_1 = $timeout(function () {
          if (!el.attr('disabled')) {
            $state.go(target.uiState, target.uiStateParams, target.uiStateOpts);
          }
        });
        e.preventDefault();
        // if the state has no URL, ignore one preventDefault from the <a> directive.
        var ignorePreventDefaultCount_1 = type.isAnchor && !target.href ? 1 : 0;
        e.preventDefault = function () {
          if (ignorePreventDefaultCount_1-- <= 0) $timeout.cancel(transition_1);
        };
      }
    };
  }
  /** @hidden */
  function defaultOpts(el, $state) {
    return {
      relative: stateContext(el) || $state.$current,
      inherit: true,
      source: 'sref'
    };
  }
  /** @hidden */
  function bindEvents(element, scope, hookFn, uiStateOpts) {
    var events;
    if (uiStateOpts) {
      events = uiStateOpts.events;
    }
    if (!isArray(events)) {
      events = ['click'];
    }
    var on = element.on ? 'on' : 'bind';
    for (var _i = 0, events_1 = events; _i < events_1.length; _i++) {
      var event_1 = events_1[_i];
      element[on](event_1, hookFn);
    }
    scope.$on('$destroy', function () {
      var off = element.off ? 'off' : 'unbind';
      for (var _i = 0, events_2 = events; _i < events_2.length; _i++) {
        var event_2 = events_2[_i];
        element[off](event_2, hookFn);
      }
    });
  }
  /**
   * `ui-sref`: A directive for linking to a state
   *
   * A directive which links to a state (and optionally, parameters).
   * When clicked, this directive activates the linked state with the supplied parameter values.
   *
   * ### Linked State
   * The attribute value of the `ui-sref` is the name of the state to link to.
   *
   * #### Example:
   * This will activate the `home` state when the link is clicked.
   * ```html
   * <a ui-sref="home">Home</a>
   * ```
   *
   * ### Relative Links
   * You can also use relative state paths within `ui-sref`, just like a relative path passed to `$state.go()` ([[StateService.go]]).
   * You just need to be aware that the path is relative to the state that *created* the link.
   * This allows a state to create a relative `ui-sref` which always targets the same destination.
   *
   * #### Example:
   * Both these links are relative to the parent state, even when a child state is currently active.
   * ```html
   * <a ui-sref=".child1">child 1 state</a>
   * <a ui-sref=".child2">child 2 state</a>
   * ```
   *
   * This link activates the parent state.
   * ```html
   * <a ui-sref="^">Return</a>
   * ```
   *
   * ### hrefs
   * If the linked state has a URL, the directive will automatically generate and
   * update the `href` attribute (using the [[StateService.href]]  method).
   *
   * #### Example:
   * Assuming the `users` state has a url of `/users/`
   * ```html
   * <a ui-sref="users" href="/users/">Users</a>
   * ```
   *
   * ### Parameter Values
   * In addition to the state name, a `ui-sref` can include parameter values which are applied when activating the state.
   * Param values can be provided in the `ui-sref` value after the state name, enclosed by parentheses.
   * The content inside the parentheses is an expression, evaluated to the parameter values.
   *
   * #### Example:
   * This example renders a list of links to users.
   * The state's `userId` parameter value comes from each user's `user.id` property.
   * ```html
   * <li ng-repeat="user in users">
   *   <a ui-sref="users.detail({ userId: user.id })">{{ user.displayName }}</a>
   * </li>
   * ```
   *
   * Note:
   * The parameter values expression is `$watch`ed for updates.
   *
   * ### Transition Options
   * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-sref-opts` attribute.
   * Options are restricted to `location`, `inherit`, and `reload`.
   *
   * #### Example:
   * ```html
   * <a ui-sref="home" ui-sref-opts="{ reload: true }">Home</a>
   * ```
   *
   * ### Other DOM Events
   *
   * You can also customize which DOM events to respond to (instead of `click`) by
   * providing an `events` array in the `ui-sref-opts` attribute.
   *
   * #### Example:
   * ```html
   * <input type="text" ui-sref="contacts" ui-sref-opts="{ events: ['change', 'blur'] }">
   * ```
   *
   * ### Highlighting the active link
   * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
   *
   * ### Examples
   * If you have the following template:
   *
   * ```html
   * <a ui-sref="home">Home</a>
   * <a ui-sref="about">About</a>
   * <a ui-sref="{page: 2}">Next page</a>
   *
   * <ul>
   *     <li ng-repeat="contact in contacts">
   *         <a ui-sref="contacts.detail({ id: contact.id })">{{ contact.name }}</a>
   *     </li>
   * </ul>
   * ```
   *
   * Then (assuming the current state is `contacts`) the rendered html including hrefs would be:
   *
   * ```html
   * <a href="#/home" ui-sref="home">Home</a>
   * <a href="#/about" ui-sref="about">About</a>
   * <a href="#/contacts?page=2" ui-sref="{page: 2}">Next page</a>
   *
   * <ul>
   *     <li ng-repeat="contact in contacts">
   *         <a href="#/contacts/1" ui-sref="contacts.detail({ id: contact.id })">Joe</a>
   *     </li>
   *     <li ng-repeat="contact in contacts">
   *         <a href="#/contacts/2" ui-sref="contacts.detail({ id: contact.id })">Alice</a>
   *     </li>
   *     <li ng-repeat="contact in contacts">
   *         <a href="#/contacts/3" ui-sref="contacts.detail({ id: contact.id })">Bob</a>
   *     </li>
   * </ul>
   *
   * <a href="#/home" ui-sref="home" ui-sref-opts="{reload: true}">Home</a>
   * ```
   *
   * ### Notes
   *
   * - You can use `ui-sref` to change **only the parameter values** by omitting the state name and parentheses.
   * #### Example:
   * Sets the `lang` parameter to `en` and remains on the same state.
   *
   * ```html
   * <a ui-sref="{ lang: 'en' }">English</a>
   * ```
   *
   * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
   *
   * - Unlike the parameter values expression, the state name is not `$watch`ed (for performance reasons).
   * If you need to dynamically update the state being linked to, use the fully dynamic [[uiState]] directive.
   */
  var uiSrefDirective;
  uiSrefDirective = ['$uiRouter', '$timeout', function $StateRefDirective($uiRouter, $timeout) {
    var $state = $uiRouter.stateService;
    return {
      restrict: 'A',
      require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
      link: function link(scope, element, attrs, uiSrefActive) {
        var type = getTypeInfo(element);
        var active = uiSrefActive[1] || uiSrefActive[0];
        var unlinkInfoFn = null;
        var rawDef = {};
        var getDef = function getDef() {
          return processedDef($state, element, rawDef);
        };
        var ref = parseStateRef(attrs.uiSref);
        rawDef.uiState = ref.state;
        rawDef.uiStateOpts = attrs.uiSrefOpts ? scope.$eval(attrs.uiSrefOpts) : {};
        function update() {
          var def = getDef();
          if (unlinkInfoFn) unlinkInfoFn();
          if (active) unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
          if (def.href != null) attrs.$set(type.attr, def.href);
        }
        if (ref.paramExpr) {
          scope.$watch(ref.paramExpr, function (val) {
            rawDef.uiStateParams = extend({}, val);
            update();
          }, true);
          rawDef.uiStateParams = extend({}, scope.$eval(ref.paramExpr));
        }
        update();
        scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
        scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
        if (!type.clickable) return;
        var hookFn = clickHook(element, $state, $timeout, type, getDef);
        bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
      }
    };
  }];
  /**
   * `ui-state`: A fully dynamic directive for linking to a state
   *
   * A directive which links to a state (and optionally, parameters).
   * When clicked, this directive activates the linked state with the supplied parameter values.
   *
   * **This directive is very similar to [[uiSref]], but it `$observe`s and `$watch`es/evaluates all its inputs.**
   *
   * A directive which links to a state (and optionally, parameters).
   * When clicked, this directive activates the linked state with the supplied parameter values.
   *
   * ### Linked State
   * The attribute value of `ui-state` is an expression which is `$watch`ed and evaluated as the state to link to.
   * **This is in contrast with `ui-sref`, which takes a state name as a string literal.**
   *
   * #### Example:
   * Create a list of links.
   * ```html
   * <li ng-repeat="link in navlinks">
   *   <a ui-state="link.state">{{ link.displayName }}</a>
   * </li>
   * ```
   *
   * ### Relative Links
   * If the expression evaluates to a relative path, it is processed like [[uiSref]].
   * You just need to be aware that the path is relative to the state that *created* the link.
   * This allows a state to create relative `ui-state` which always targets the same destination.
   *
   * ### hrefs
   * If the linked state has a URL, the directive will automatically generate and
   * update the `href` attribute (using the [[StateService.href]]  method).
   *
   * ### Parameter Values
   * In addition to the state name expression, a `ui-state` can include parameter values which are applied when activating the state.
   * Param values should be provided using the `ui-state-params` attribute.
   * The `ui-state-params` attribute value is `$watch`ed and evaluated as an expression.
   *
   * #### Example:
   * This example renders a list of links with param values.
   * The state's `userId` parameter value comes from each user's `user.id` property.
   * ```html
   * <li ng-repeat="link in navlinks">
   *   <a ui-state="link.state" ui-state-params="link.params">{{ link.displayName }}</a>
   * </li>
   * ```
   *
   * ### Transition Options
   * You can specify [[TransitionOptions]] to pass to [[StateService.go]] by using the `ui-state-opts` attribute.
   * Options are restricted to `location`, `inherit`, and `reload`.
   * The value of the `ui-state-opts` is `$watch`ed and evaluated as an expression.
   *
   * #### Example:
   * ```html
   * <a ui-state="returnto.state" ui-state-opts="{ reload: true }">Home</a>
   * ```
   *
   * ### Other DOM Events
   *
   * You can also customize which DOM events to respond to (instead of `click`) by
   * providing an `events` array in the `ui-state-opts` attribute.
   *
   * #### Example:
   * ```html
   * <input type="text" ui-state="contacts" ui-state-opts="{ events: ['change', 'blur'] }">
   * ```
   *
   * ### Highlighting the active link
   * This directive can be used in conjunction with [[uiSrefActive]] to highlight the active link.
   *
   * ### Notes
   *
   * - You can use `ui-params` to change **only the parameter values** by omitting the state name and supplying only `ui-state-params`.
   *   However, it might be simpler to use [[uiSref]] parameter-only links.
   *
   * #### Example:
   * Sets the `lang` parameter to `en` and remains on the same state.
   *
   * ```html
   * <a ui-state="" ui-state-params="{ lang: 'en' }">English</a>
   * ```
   *
   * - A middle-click, right-click, or ctrl-click is handled (natively) by the browser to open the href in a new window, for example.
   * ```
   */
  var uiStateDirective;
  uiStateDirective = ['$uiRouter', '$timeout', function $StateRefDynamicDirective($uiRouter, $timeout) {
    var $state = $uiRouter.stateService;
    return {
      restrict: 'A',
      require: ['?^uiSrefActive', '?^uiSrefActiveEq'],
      link: function link(scope, element, attrs, uiSrefActive) {
        var type = getTypeInfo(element);
        var active = uiSrefActive[1] || uiSrefActive[0];
        var unlinkInfoFn = null;
        var hookFn;
        var rawDef = {};
        var getDef = function getDef() {
          return processedDef($state, element, rawDef);
        };
        var inputAttrs = ['uiState', 'uiStateParams', 'uiStateOpts'];
        var watchDeregFns = inputAttrs.reduce(function (acc, attr) {
          return acc[attr] = noop, acc;
        }, {});
        function update() {
          var def = getDef();
          if (unlinkInfoFn) unlinkInfoFn();
          if (active) unlinkInfoFn = active.$$addStateInfo(def.uiState, def.uiStateParams);
          if (def.href != null) attrs.$set(type.attr, def.href);
        }
        inputAttrs.forEach(function (field) {
          rawDef[field] = attrs[field] ? scope.$eval(attrs[field]) : null;
          attrs.$observe(field, function (expr) {
            watchDeregFns[field]();
            watchDeregFns[field] = scope.$watch(expr, function (newval) {
              rawDef[field] = newval;
              update();
            }, true);
          });
        });
        update();
        scope.$on('$destroy', $uiRouter.stateRegistry.onStatesChanged(update));
        scope.$on('$destroy', $uiRouter.transitionService.onSuccess({}, update));
        if (!type.clickable) return;
        hookFn = clickHook(element, $state, $timeout, type, getDef);
        bindEvents(element, scope, hookFn, rawDef.uiStateOpts);
      }
    };
  }];
  /**
   * `ui-sref-active` and `ui-sref-active-eq`: A directive that adds a CSS class when a `ui-sref` is active
   *
   * A directive working alongside [[uiSref]] and [[uiState]] to add classes to an element when the
   * related directive's state is active (and remove them when it is inactive).
   *
   * The primary use-case is to highlight the active link in navigation menus,
   * distinguishing it from the inactive menu items.
   *
   * ### Linking to a `ui-sref` or `ui-state`
   * `ui-sref-active` can live on the same element as `ui-sref`/`ui-state`, or it can be on a parent element.
   * If a `ui-sref-active` is a parent to more than one `ui-sref`/`ui-state`, it will apply the CSS class when **any of the links are active**.
   *
   * ### Matching
   *
   * The `ui-sref-active` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state **or any child state is active**.
   * This is a "fuzzy match" which uses [[StateService.includes]].
   *
   * The `ui-sref-active-eq` directive applies the CSS class when the `ui-sref`/`ui-state`'s target state is directly active (not when child states are active).
   * This is an "exact match" which uses [[StateService.is]].
   *
   * ### Parameter values
   * If the `ui-sref`/`ui-state` includes parameter values, the current parameter values must match the link's values for the link to be highlighted.
   * This allows a list of links to the same state with different parameters to be rendered, and the correct one highlighted.
   *
   * #### Example:
   * ```html
   * <li ng-repeat="user in users" ui-sref-active="active">
   *   <a ui-sref="user.details({ userId: user.id })">{{ user.lastName }}</a>
   * </li>
   * ```
   *
   * ### Examples
   *
   * Given the following template:
   * #### Example:
   * ```html
   * <ul>
   *   <li ui-sref-active="active" class="item">
   *     <a href ui-sref="app.user({user: 'bilbobaggins'})">@bilbobaggins</a>
   *   </li>
   * </ul>
   * ```
   *
   * When the app state is `app.user` (or any child state),
   * and contains the state parameter "user" with value "bilbobaggins",
   * the resulting HTML will appear as (note the 'active' class):
   *
   * ```html
   * <ul>
   *   <li ui-sref-active="active" class="item active">
   *     <a ui-sref="app.user({user: 'bilbobaggins'})" href="/users/bilbobaggins">@bilbobaggins</a>
   *   </li>
   * </ul>
   * ```
   *
   * ### Glob mode
   *
   * It is possible to pass `ui-sref-active` an expression that evaluates to an object.
   * The objects keys represent active class names and values represent the respective state names/globs.
   * `ui-sref-active` will match if the current active state **includes** any of
   * the specified state names/globs, even the abstract ones.
   *
   * #### Example:
   * Given the following template, with "admin" being an abstract state:
   * ```html
   * <div ui-sref-active="{'active': 'admin.**'}">
   *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
   * </div>
   * ```
   *
   * Arrays are also supported as values in the `ngClass`-like interface.
   * This allows multiple states to add `active` class.
   *
   * #### Example:
   * Given the following template, with "admin.roles" being the current state, the class will be added too:
   * ```html
   * <div ui-sref-active="{'active': ['owner.**', 'admin.**']}">
   *   <a ui-sref-active="active" ui-sref="admin.roles">Roles</a>
   * </div>
   * ```
   *
   * When the current state is "admin.roles" the "active" class will be applied to both the `<div>` and `<a>` elements.
   * It is important to note that the state names/globs passed to `ui-sref-active` override any state provided by a linked `ui-sref`.
   *
   * ### Notes:
   *
   * - The class name is interpolated **once** during the directives link time (any further changes to the
   * interpolated value are ignored).
   *
   * - Multiple classes may be specified in a space-separated format: `ui-sref-active='class1 class2 class3'`
   */
  var uiSrefActiveDirective;
  uiSrefActiveDirective = ['$state', '$stateParams', '$interpolate', '$uiRouter', function $StateRefActiveDirective($state, $stateParams, $interpolate, $uiRouter) {
    return {
      restrict: 'A',
      controller: ['$scope', '$element', '$attrs', function ($scope, $element, $attrs) {
        var states = [];
        var activeEqClass;
        var uiSrefActive;
        // There probably isn't much point in $observing this
        // uiSrefActive and uiSrefActiveEq share the same directive object with some
        // slight difference in logic routing
        activeEqClass = $interpolate($attrs.uiSrefActiveEq || '', false)($scope);
        try {
          uiSrefActive = $scope.$eval($attrs.uiSrefActive);
        } catch (e) {
          // Do nothing. uiSrefActive is not a valid expression.
          // Fall back to using $interpolate below
        }
        uiSrefActive = uiSrefActive || $interpolate($attrs.uiSrefActive || '', false)($scope);
        setStatesFromDefinitionObject(uiSrefActive);
        // Allow uiSref to communicate with uiSrefActive[Equals]
        this.$$addStateInfo = function (newState, newParams) {
          // we already got an explicit state provided by ui-sref-active, so we
          // shadow the one that comes from ui-sref
          if (isObject(uiSrefActive) && states.length > 0) {
            return;
          }
          var deregister = addState(newState, newParams, uiSrefActive);
          update();
          return deregister;
        };
        function updateAfterTransition(trans) {
          trans.promise.then(update, noop);
        }
        $scope.$on('$destroy', setupEventListeners());
        if ($uiRouter.globals.transition) {
          updateAfterTransition($uiRouter.globals.transition);
        }
        function setupEventListeners() {
          var deregisterStatesChangedListener = $uiRouter.stateRegistry.onStatesChanged(handleStatesChanged);
          var deregisterOnStartListener = $uiRouter.transitionService.onStart({}, updateAfterTransition);
          var deregisterStateChangeSuccessListener = $scope.$on('$stateChangeSuccess', update);
          return function cleanUp() {
            deregisterStatesChangedListener();
            deregisterOnStartListener();
            deregisterStateChangeSuccessListener();
          };
        }
        function handleStatesChanged() {
          setStatesFromDefinitionObject(uiSrefActive);
        }
        function setStatesFromDefinitionObject(statesDefinition) {
          if (isObject(statesDefinition)) {
            states = [];
            forEach(statesDefinition, function (stateOrName, activeClass) {
              // Helper function to abstract adding state.
              var addStateForClass = function addStateForClass(stateOrName, activeClass) {
                var ref = parseStateRef(stateOrName);
                addState(ref.state, $scope.$eval(ref.paramExpr), activeClass);
              };
              if (isString(stateOrName)) {
                // If state is string, just add it.
                addStateForClass(stateOrName, activeClass);
              } else if (isArray(stateOrName)) {
                // If state is an array, iterate over it and add each array item individually.
                forEach(stateOrName, function (stateOrName) {
                  addStateForClass(stateOrName, activeClass);
                });
              }
            });
          }
        }
        function addState(stateName, stateParams, activeClass) {
          var state = $state.get(stateName, stateContext($element));
          var stateInfo = {
            state: state || {
              name: stateName
            },
            params: stateParams,
            activeClass: activeClass
          };
          states.push(stateInfo);
          return function removeState() {
            removeFrom(states)(stateInfo);
          };
        }
        // Update route state
        function update() {
          var splitClasses = function splitClasses(str) {
            return str.split(/\s/).filter(identity);
          };
          var getClasses = function getClasses(stateList) {
            return stateList.map(function (x) {
              return x.activeClass;
            }).map(splitClasses).reduce(unnestR, []);
          };
          var allClasses = getClasses(states).concat(splitClasses(activeEqClass)).reduce(uniqR, []);
          var fuzzyClasses = getClasses(states.filter(function (x) {
            return $state.includes(x.state.name, x.params);
          }));
          var exactlyMatchesAny = !!states.filter(function (x) {
            return $state.is(x.state.name, x.params);
          }).length;
          var exactClasses = exactlyMatchesAny ? splitClasses(activeEqClass) : [];
          var addClasses = fuzzyClasses.concat(exactClasses).reduce(uniqR, []);
          var removeClasses = allClasses.filter(function (cls) {
            return !inArray(addClasses, cls);
          });
          $scope.$evalAsync(function () {
            addClasses.forEach(function (className) {
              return $element.addClass(className);
            });
            removeClasses.forEach(function (className) {
              return $element.removeClass(className);
            });
          });
        }
        update();
      }]
    };
  }];
  ng.module('ui.router.state').directive('uiSref', uiSrefDirective).directive('uiSrefActive', uiSrefActiveDirective).directive('uiSrefActiveEq', uiSrefActiveDirective).directive('uiState', uiStateDirective);

  /** @publicapi @module ng1 */ /** */
  /**
   * `isState` Filter: truthy if the current state is the parameter
   *
   * Translates to [[StateService.is]] `$state.is("stateName")`.
   *
   * #### Example:
   * ```html
   * <div ng-if="'stateName' | isState">show if state is 'stateName'</div>
   * ```
   */
  $IsStateFilter.$inject = ['$state'];
  function $IsStateFilter($state) {
    var isFilter = function isFilter(state, params, options) {
      return $state.is(state, params, options);
    };
    isFilter.$stateful = true;
    return isFilter;
  }
  /**
   * `includedByState` Filter: truthy if the current state includes the parameter
   *
   * Translates to [[StateService.includes]]` $state.is("fullOrPartialStateName")`.
   *
   * #### Example:
   * ```html
   * <div ng-if="'fullOrPartialStateName' | includedByState">show if state includes 'fullOrPartialStateName'</div>
   * ```
   */
  $IncludedByStateFilter.$inject = ['$state'];
  function $IncludedByStateFilter($state) {
    var includesFilter = function includesFilter(state, params, options) {
      return $state.includes(state, params, options);
    };
    includesFilter.$stateful = true;
    return includesFilter;
  }
  ng.module('ui.router.state').filter('isState', $IsStateFilter).filter('includedByState', $IncludedByStateFilter);

  /** @publicapi @module directives */ /** */
  /**
   * `ui-view`: A viewport directive which is filled in by a view from the active state.
   *
   * ### Attributes
   *
   * - `name`: (Optional) A view name.
   *   The name should be unique amongst the other views in the same state.
   *   You can have views of the same name that live in different states.
   *   The ui-view can be targeted in a View using the name ([[Ng1StateDeclaration.views]]).
   *
   * - `autoscroll`: an expression. When it evaluates to true, the `ui-view` will be scrolled into view when it is activated.
   *   Uses [[$uiViewScroll]] to do the scrolling.
   *
   * - `onload`: Expression to evaluate whenever the view updates.
   *
   * #### Example:
   * A view can be unnamed or named.
   * ```html
   * <!-- Unnamed -->
   * <div ui-view></div>
   *
   * <!-- Named -->
   * <div ui-view="viewName"></div>
   *
   * <!-- Named (different style) -->
   * <ui-view name="viewName"></ui-view>
   * ```
   *
   * You can only have one unnamed view within any template (or root html). If you are only using a
   * single view and it is unnamed then you can populate it like so:
   *
   * ```html
   * <div ui-view></div>
   * $stateProvider.state("home", {
   *   template: "<h1>HELLO!</h1>"
   * })
   * ```
   *
   * The above is a convenient shortcut equivalent to specifying your view explicitly with the
   * [[Ng1StateDeclaration.views]] config property, by name, in this case an empty name:
   *
   * ```js
   * $stateProvider.state("home", {
   *   views: {
   *     "": {
   *       template: "<h1>HELLO!</h1>"
   *     }
   *   }
   * })
   * ```
   *
   * But typically you'll only use the views property if you name your view or have more than one view
   * in the same template. There's not really a compelling reason to name a view if its the only one,
   * but you could if you wanted, like so:
   *
   * ```html
   * <div ui-view="main"></div>
   * ```
   *
   * ```js
   * $stateProvider.state("home", {
   *   views: {
   *     "main": {
   *       template: "<h1>HELLO!</h1>"
   *     }
   *   }
   * })
   * ```
   *
   * Really though, you'll use views to set up multiple views:
   *
   * ```html
   * <div ui-view></div>
   * <div ui-view="chart"></div>
   * <div ui-view="data"></div>
   * ```
   *
   * ```js
   * $stateProvider.state("home", {
   *   views: {
   *     "": {
   *       template: "<h1>HELLO!</h1>"
   *     },
   *     "chart": {
   *       template: "<chart_thing/>"
   *     },
   *     "data": {
   *       template: "<data_thing/>"
   *     }
   *   }
   * })
   * ```
   *
   * #### Examples for `autoscroll`:
   * ```html
   * <!-- If autoscroll present with no expression,
   *      then scroll ui-view into view -->
   * <ui-view autoscroll/>
   *
   * <!-- If autoscroll present with valid expression,
   *      then scroll ui-view into view if expression evaluates to true -->
   * <ui-view autoscroll='true'/>
   * <ui-view autoscroll='false'/>
   * <ui-view autoscroll='scopeVariable'/>
   * ```
   *
   * Resolve data:
   *
   * The resolved data from the state's `resolve` block is placed on the scope as `$resolve` (this
   * can be customized using [[Ng1ViewDeclaration.resolveAs]]).  This can be then accessed from the template.
   *
   * Note that when `controllerAs` is being used, `$resolve` is set on the controller instance *after* the
   * controller is instantiated.  The `$onInit()` hook can be used to perform initialization code which
   * depends on `$resolve` data.
   *
   * #### Example:
   * ```js
   * $stateProvider.state('home', {
   *   template: '<my-component user="$resolve.user"></my-component>',
   *   resolve: {
   *     user: function(UserService) { return UserService.fetchUser(); }
   *   }
   * });
   * ```
   */
  var uiView;
  // eslint-disable-next-line prefer-const
  uiView = ['$view', '$animate', '$uiViewScroll', '$interpolate', '$q', function $ViewDirective($view, $animate, $uiViewScroll, $interpolate, $q) {
    function getRenderer() {
      return {
        enter: function enter(element, target, cb) {
          if (ng.version.minor > 2) {
            $animate.enter(element, null, target).then(cb);
          } else {
            $animate.enter(element, null, target, cb);
          }
        },
        leave: function leave(element, cb) {
          if (ng.version.minor > 2) {
            $animate.leave(element).then(cb);
          } else {
            $animate.leave(element, cb);
          }
        }
      };
    }
    function configsEqual(config1, config2) {
      return config1 === config2;
    }
    var rootData = {
      $cfg: {
        viewDecl: {
          $context: $view._pluginapi._rootViewContext()
        }
      },
      $uiView: {}
    };
    var directive = {
      count: 0,
      restrict: 'ECA',
      terminal: true,
      priority: 400,
      transclude: 'element',
      compile: function compile(tElement, tAttrs, $transclude) {
        return function (scope, $element, attrs) {
          var onloadExp = attrs['onload'] || '',
            autoScrollExp = attrs['autoscroll'],
            renderer = getRenderer(),
            inherited = $element.inheritedData('$uiView') || rootData,
            name = $interpolate(attrs['uiView'] || attrs['name'] || '')(scope) || '$default';
          var previousEl, currentEl, currentScope, viewConfig;
          var activeUIView = {
            $type: 'ng1',
            id: directive.count++,
            name: name,
            fqn: inherited.$uiView.fqn ? inherited.$uiView.fqn + '.' + name : name,
            config: null,
            configUpdated: configUpdatedCallback,
            get creationContext() {
              // The context in which this ui-view "tag" was created
              var fromParentTagConfig = parse('$cfg.viewDecl.$context')(inherited);
              // Allow <ui-view name="foo"><ui-view name="bar"></ui-view></ui-view>
              // See https://github.com/angular-ui/ui-router/issues/3355
              var fromParentTag = parse('$uiView.creationContext')(inherited);
              return fromParentTagConfig || fromParentTag;
            }
          };
          trace.traceUIViewEvent('Linking', activeUIView);
          function configUpdatedCallback(config) {
            if (config && !(config instanceof Ng1ViewConfig)) return;
            if (configsEqual(viewConfig, config)) return;
            trace.traceUIViewConfigUpdated(activeUIView, config && config.viewDecl && config.viewDecl.$context);
            viewConfig = config;
            updateView(config);
          }
          $element.data('$uiView', {
            $uiView: activeUIView
          });
          updateView();
          var unregister = $view.registerUIView(activeUIView);
          scope.$on('$destroy', function () {
            trace.traceUIViewEvent('Destroying/Unregistering', activeUIView);
            unregister();
          });
          function cleanupLastView() {
            if (previousEl) {
              trace.traceUIViewEvent('Removing (previous) el', previousEl.data('$uiView'));
              previousEl.remove();
              previousEl = null;
            }
            if (currentScope) {
              trace.traceUIViewEvent('Destroying scope', activeUIView);
              currentScope.$destroy();
              currentScope = null;
            }
            if (currentEl) {
              var _viewData_1 = currentEl.data('$uiViewAnim');
              trace.traceUIViewEvent('Animate out', _viewData_1);
              renderer.leave(currentEl, function () {
                _viewData_1.$$animLeave.resolve();
                previousEl = null;
              });
              previousEl = currentEl;
              currentEl = null;
            }
          }
          function updateView(config) {
            var newScope = scope.$new();
            var animEnter = $q.defer(),
              animLeave = $q.defer();
            var $uiViewData = {
              $cfg: config,
              $uiView: activeUIView
            };
            var $uiViewAnim = {
              $animEnter: animEnter.promise,
              $animLeave: animLeave.promise,
              $$animLeave: animLeave
            };
            /**
             * @ngdoc event
             * @name ui.router.state.directive:ui-view#$viewContentLoading
             * @eventOf ui.router.state.directive:ui-view
             * @eventType emits on ui-view directive scope
             * @description
             *
             * Fired once the view **begins loading**, *before* the DOM is rendered.
             *
             * @param {Object} event Event object.
             * @param {string} viewName Name of the view.
             */
            newScope.$emit('$viewContentLoading', name);
            var cloned = $transclude(newScope, function (clone) {
              clone.data('$uiViewAnim', $uiViewAnim);
              clone.data('$uiView', $uiViewData);
              renderer.enter(clone, $element, function onUIViewEnter() {
                animEnter.resolve();
                if (currentScope) currentScope.$emit('$viewContentAnimationEnded');
                if (isDefined(autoScrollExp) && !autoScrollExp || scope.$eval(autoScrollExp)) {
                  $uiViewScroll(clone);
                }
              });
              cleanupLastView();
            });
            currentEl = cloned;
            currentScope = newScope;
            /**
             * @ngdoc event
             * @name ui.router.state.directive:ui-view#$viewContentLoaded
             * @eventOf ui.router.state.directive:ui-view
             * @eventType emits on ui-view directive scope
             * @description           *
             * Fired once the view is **loaded**, *after* the DOM is rendered.
             *
             * @param {Object} event Event object.
             */
            currentScope.$emit('$viewContentLoaded', config || viewConfig);
            currentScope.$eval(onloadExp);
          }
        };
      }
    };
    return directive;
  }];
  $ViewDirectiveFill.$inject = ['$compile', '$controller', '$transitions', '$view', '$q'];
  /** @hidden */
  function $ViewDirectiveFill($compile, $controller, $transitions, $view, $q) {
    var getControllerAs = parse('viewDecl.controllerAs');
    var getResolveAs = parse('viewDecl.resolveAs');
    return {
      restrict: 'ECA',
      priority: -400,
      compile: function compile(tElement) {
        var initial = tElement.html();
        tElement.empty();
        return function (scope, $element) {
          var data = $element.data('$uiView');
          if (!data) {
            $element.html(initial);
            $compile($element.contents())(scope);
            return;
          }
          var cfg = data.$cfg || {
            viewDecl: {},
            getTemplate: noop
          };
          var resolveCtx = cfg.path && new ResolveContext(cfg.path);
          $element.html(cfg.getTemplate($element, resolveCtx) || initial);
          trace.traceUIViewFill(data.$uiView, $element.html());
          var link = $compile($element.contents());
          var controller = cfg.controller;
          var controllerAs = getControllerAs(cfg);
          var resolveAs = getResolveAs(cfg);
          var locals = resolveCtx && getLocals(resolveCtx);
          scope[resolveAs] = locals;
          if (controller) {
            var controllerInstance = $controller(controller, extend({}, locals, {
              $scope: scope,
              $element: $element
            }));
            if (controllerAs) {
              scope[controllerAs] = controllerInstance;
              scope[controllerAs][resolveAs] = locals;
            }
            // TODO: Use $view service as a central point for registering component-level hooks
            // Then, when a component is created, tell the $view service, so it can invoke hooks
            // $view.componentLoaded(controllerInstance, { $scope: scope, $element: $element });
            // scope.$on('$destroy', () => $view.componentUnloaded(controllerInstance, { $scope: scope, $element: $element }));
            $element.data('$ngControllerController', controllerInstance);
            $element.children().data('$ngControllerController', controllerInstance);
            registerControllerCallbacks($q, $transitions, controllerInstance, scope, cfg);
          }
          // Wait for the component to appear in the DOM
          if (isString(cfg.component)) {
            var kebobName = kebobString(cfg.component);
            var tagRegexp_1 = new RegExp("^(x-|data-)?" + kebobName + "$", 'i');
            var getComponentController = function getComponentController() {
              var directiveEl = [].slice.call($element[0].children).filter(function (el) {
                return el && el.tagName && tagRegexp_1.exec(el.tagName);
              });
              return directiveEl && ng.element(directiveEl).data("$" + cfg.component + "Controller");
            };
            var deregisterWatch_1 = scope.$watch(getComponentController, function (ctrlInstance) {
              if (!ctrlInstance) return;
              registerControllerCallbacks($q, $transitions, ctrlInstance, scope, cfg);
              deregisterWatch_1();
            });
          }
          link(scope);
        };
      }
    };
  }
  /** @hidden */
  var hasComponentImpl = typeof ng.module('ui.router')['component'] === 'function';
  /** @hidden incrementing id */
  var _uiCanExitId = 0;
  /** @hidden TODO: move these callbacks to $view and/or `/hooks/components.ts` or something */
  function registerControllerCallbacks($q, $transitions, controllerInstance, $scope, cfg) {
    // Call $onInit() ASAP
    if (isFunction(controllerInstance.$onInit) && !((cfg.viewDecl.component || cfg.viewDecl.componentProvider) && hasComponentImpl)) {
      controllerInstance.$onInit();
    }
    var viewState = tail(cfg.path).state.self;
    var hookOptions = {
      bind: controllerInstance
    };
    // Add component-level hook for onUiParamsChanged
    if (isFunction(controllerInstance.uiOnParamsChanged)) {
      var resolveContext = new ResolveContext(cfg.path);
      var viewCreationTrans_1 = resolveContext.getResolvable('$transition$').data;
      // Fire callback on any successful transition
      var paramsUpdated = function paramsUpdated($transition$) {
        // Exit early if the $transition$ is the same as the view was created within.
        // Exit early if the $transition$ will exit the state the view is for.
        if ($transition$ === viewCreationTrans_1 || $transition$.exiting().indexOf(viewState) !== -1) return;
        var toParams = $transition$.params('to');
        var fromParams = $transition$.params('from');
        var getNodeSchema = function getNodeSchema(node) {
          return node.paramSchema;
        };
        var toSchema = $transition$.treeChanges('to').map(getNodeSchema).reduce(unnestR, []);
        var fromSchema = $transition$.treeChanges('from').map(getNodeSchema).reduce(unnestR, []);
        // Find the to params that have different values than the from params
        var changedToParams = toSchema.filter(function (param) {
          var idx = fromSchema.indexOf(param);
          return idx === -1 || !fromSchema[idx].type.equals(toParams[param.id], fromParams[param.id]);
        });
        // Only trigger callback if a to param has changed or is new
        if (changedToParams.length) {
          var changedKeys_1 = changedToParams.map(function (x) {
            return x.id;
          });
          // Filter the params to only changed/new to params.  `$transition$.params()` may be used to get all params.
          var newValues = filter(toParams, function (val, key) {
            return changedKeys_1.indexOf(key) !== -1;
          });
          controllerInstance.uiOnParamsChanged(newValues, $transition$);
        }
      };
      $scope.$on('$destroy', $transitions.onSuccess({}, paramsUpdated, hookOptions));
    }
    // Add component-level hook for uiCanExit
    if (isFunction(controllerInstance.uiCanExit)) {
      var id_1 = _uiCanExitId++;
      var cacheProp_1 = '_uiCanExitIds';
      // Returns true if a redirect transition already answered truthy
      var _prevTruthyAnswer_ = function prevTruthyAnswer_1(trans) {
        return !!trans && (trans[cacheProp_1] && trans[cacheProp_1][id_1] === true || _prevTruthyAnswer_(trans.redirectedFrom()));
      };
      // If a user answered yes, but the transition was later redirected, don't also ask for the new redirect transition
      var wrappedHook = function wrappedHook(trans) {
        var promise;
        var ids = trans[cacheProp_1] = trans[cacheProp_1] || {};
        if (!_prevTruthyAnswer_(trans)) {
          promise = $q.when(controllerInstance.uiCanExit(trans));
          promise.then(function (val) {
            return ids[id_1] = val !== false;
          });
        }
        return promise;
      };
      var criteria = {
        exiting: viewState.name
      };
      $scope.$on('$destroy', $transitions.onBefore(criteria, wrappedHook, hookOptions));
    }
  }
  ng.module('ui.router.state').directive('uiView', uiView);
  ng.module('ui.router.state').directive('uiView', $ViewDirectiveFill);

  /** @publicapi @module ng1 */ /** */
  /** @hidden */
  function $ViewScrollProvider() {
    var useAnchorScroll = false;
    this.useAnchorScroll = function () {
      useAnchorScroll = true;
    };
    this.$get = ['$anchorScroll', '$timeout', function ($anchorScroll, $timeout) {
      if (useAnchorScroll) {
        return $anchorScroll;
      }
      return function ($element) {
        return $timeout(function () {
          $element[0].scrollIntoView();
        }, 0, false);
      };
    }];
  }
  ng.module('ui.router.state').provider('$uiViewScroll', $ViewScrollProvider);

  /**
   * Main entry point for angular 1.x build
   * @publicapi @module ng1
   */ /** */
  var index$1 = 'ui.router';
  exports.$injector = $injector;
  exports.$q = $q;
  exports.BaseLocationServices = BaseLocationServices;
  exports.BaseUrlRule = BaseUrlRule;
  exports.BrowserLocationConfig = BrowserLocationConfig;
  exports.Glob = Glob;
  exports.HashLocationService = HashLocationService;
  exports.HookBuilder = HookBuilder;
  exports.MemoryLocationConfig = MemoryLocationConfig;
  exports.MemoryLocationService = MemoryLocationService;
  exports.NATIVE_INJECTOR_TOKEN = NATIVE_INJECTOR_TOKEN;
  exports.Ng1ViewConfig = Ng1ViewConfig;
  exports.Param = Param;
  exports.ParamFactory = ParamFactory;
  exports.ParamType = ParamType;
  exports.ParamTypes = ParamTypes;
  exports.PathNode = PathNode;
  exports.PathUtils = PathUtils;
  exports.PushStateLocationService = PushStateLocationService;
  exports.Queue = Queue;
  exports.RegisteredHook = RegisteredHook;
  exports.Rejection = Rejection;
  exports.Resolvable = Resolvable;
  exports.ResolveContext = ResolveContext;
  exports.StateBuilder = StateBuilder;
  exports.StateMatcher = StateMatcher;
  exports.StateObject = StateObject;
  exports.StateParams = StateParams;
  exports.StateProvider = StateProvider;
  exports.StateQueueManager = StateQueueManager;
  exports.StateRegistry = StateRegistry;
  exports.StateService = StateService;
  exports.TargetState = TargetState;
  exports.Trace = Trace;
  exports.Transition = Transition;
  exports.TransitionEventType = TransitionEventType;
  exports.TransitionHook = TransitionHook;
  exports.TransitionService = TransitionService;
  exports.UIRouter = UIRouter;
  exports.UIRouterGlobals = UIRouterGlobals;
  exports.UIRouterPluginBase = UIRouterPluginBase;
  exports.UrlConfig = UrlConfig;
  exports.UrlMatcher = UrlMatcher;
  exports.UrlMatcherFactory = UrlMatcherFactory;
  exports.UrlRouter = UrlRouter;
  exports.UrlRouterProvider = UrlRouterProvider;
  exports.UrlRuleFactory = UrlRuleFactory;
  exports.UrlRules = UrlRules;
  exports.UrlService = UrlService;
  exports.ViewService = ViewService;
  exports._extend = _extend;
  exports._inArray = _inArray;
  exports._pushTo = _pushTo;
  exports._removeFrom = _removeFrom;
  exports.all = all;
  exports.allTrueR = allTrueR;
  exports.ancestors = ancestors;
  exports.and = and;
  exports.any = any;
  exports.anyTrueR = anyTrueR;
  exports.applyPairs = applyPairs;
  exports.arrayTuples = arrayTuples;
  exports.assertFn = assertFn;
  exports.assertMap = assertMap;
  exports.assertPredicate = assertPredicate;
  exports.beforeAfterSubstr = beforeAfterSubstr;
  exports.buildUrl = buildUrl;
  exports.compose = compose;
  exports.copy = copy;
  exports.core = index;
  exports.createProxyFunctions = createProxyFunctions;
  exports.curry = curry;
  exports["default"] = index$1;
  exports.defaultResolvePolicy = defaultResolvePolicy;
  exports.defaultTransOpts = defaultTransOpts;
  exports.defaults = defaults;
  exports.deregAll = deregAll;
  exports.eq = eq;
  exports.equals = equals;
  exports.extend = extend;
  exports.filter = filter;
  exports.find = find;
  exports.flatten = flatten;
  exports.flattenR = _flattenR;
  exports.fnToString = fnToString;
  exports.forEach = forEach;
  exports.fromJson = fromJson;
  exports.functionToString = functionToString;
  exports.getLocals = getLocals;
  exports.getNg1ViewConfigFactory = getNg1ViewConfigFactory;
  exports.getParams = getParams;
  exports.hashLocationPlugin = hashLocationPlugin;
  exports.hostRegex = hostRegex;
  exports.identity = identity;
  exports.inArray = inArray;
  exports.inherit = inherit;
  exports.invoke = invoke;
  exports.is = is;
  exports.isArray = isArray;
  exports.isDate = isDate;
  exports.isDefined = isDefined;
  exports.isFunction = isFunction;
  exports.isInjectable = isInjectable;
  exports.isNull = isNull;
  exports.isNullOrUndefined = isNullOrUndefined;
  exports.isNumber = isNumber;
  exports.isObject = isObject;
  exports.isPromise = isPromise;
  exports.isRegExp = isRegExp;
  exports.isString = isString;
  exports.isUndefined = isUndefined;
  exports.joinNeighborsR = joinNeighborsR;
  exports.kebobString = kebobString;
  exports.keyValsToObjectR = keyValsToObjectR;
  exports.locationPluginFactory = locationPluginFactory;
  exports.makeEvent = makeEvent;
  exports.makeStub = makeStub;
  exports.map = map;
  exports.mapObj = mapObj;
  exports.matchState = matchState;
  exports.maxLength = maxLength;
  exports.memoryLocationPlugin = memoryLocationPlugin;
  exports.mergeR = mergeR;
  exports.ng1ViewsBuilder = ng1ViewsBuilder;
  exports.noop = noop;
  exports.not = not;
  exports.omit = omit;
  exports.or = or;
  exports.padString = padString;
  exports.pairs = pairs;
  exports.parse = parse;
  exports.parseUrl = parseUrl$1;
  exports.pattern = pattern;
  exports.pick = pick;
  exports.pipe = pipe;
  exports.pluck = pluck;
  exports.prop = prop;
  exports.propEq = propEq;
  exports.pushR = pushR;
  exports.pushStateLocationPlugin = pushStateLocationPlugin;
  exports.pushTo = pushTo;
  exports.removeFrom = removeFrom;
  exports.resolvablesBuilder = resolvablesBuilder;
  exports.resolvePolicies = resolvePolicies;
  exports.root = root;
  exports.services = services;
  exports.servicesPlugin = servicesPlugin;
  exports.silenceUncaughtInPromise = silenceUncaughtInPromise;
  exports.silentRejection = silentRejection;
  exports.splitEqual = splitEqual;
  exports.splitHash = splitHash;
  exports.splitOnDelim = splitOnDelim;
  exports.splitQuery = splitQuery;
  exports.stringify = stringify;
  exports.stripLastPathElement = stripLastPathElement;
  exports.tail = tail;
  exports.toJson = toJson;
  exports.trace = trace;
  exports.trimHashVal = trimHashVal;
  exports.uniqR = uniqR;
  exports.unnest = unnest;
  exports.unnestR = unnestR;
  exports.val = val;
  exports.values = values;
  exports.watchDigests = watchDigests;
  Object.defineProperty(exports, '__esModule', {
    value: true
  });
});


/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 1.1.2 - 2016-02-01
 * License: MIT
 */
angular.module("ui.bootstrap", ["ui.bootstrap.collapse", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.isClass", "ui.bootstrap.position", "ui.bootstrap.datepicker", "ui.bootstrap.debounce", "ui.bootstrap.dropdown", "ui.bootstrap.stackedMap", "ui.bootstrap.modal", "ui.bootstrap.paging", "ui.bootstrap.pager", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]);
angular.module('ui.bootstrap.collapse', []).directive('uibCollapse', ['$animate', '$q', '$parse', '$injector', function ($animate, $q, $parse, $injector) {
  var $animateCss = $injector.has('$animateCss') ? $injector.get('$animateCss') : null;
  return {
    link: function link(scope, element, attrs) {
      var expandingExpr = $parse(attrs.expanding),
        expandedExpr = $parse(attrs.expanded),
        collapsingExpr = $parse(attrs.collapsing),
        collapsedExpr = $parse(attrs.collapsed);
      if (!scope.$eval(attrs.uibCollapse)) {
        element.addClass('in').addClass('collapse').attr('aria-expanded', true).attr('aria-hidden', false).css({
          height: 'auto'
        });
      }
      function expand() {
        if (element.hasClass('collapse') && element.hasClass('in')) {
          return;
        }
        $q.resolve(expandingExpr(scope)).then(function () {
          element.removeClass('collapse').addClass('collapsing').attr('aria-expanded', true).attr('aria-hidden', false);
          if ($animateCss) {
            $animateCss(element, {
              addClass: 'in',
              easing: 'ease',
              to: {
                height: element[0].scrollHeight + 'px'
              }
            }).start()['finally'](expandDone);
          } else {
            $animate.addClass(element, 'in', {
              to: {
                height: element[0].scrollHeight + 'px'
              }
            }).then(expandDone);
          }
        });
      }
      function expandDone() {
        element.removeClass('collapsing').addClass('collapse').css({
          height: 'auto'
        });
        expandedExpr(scope);
      }
      function collapse() {
        if (!element.hasClass('collapse') && !element.hasClass('in')) {
          return collapseDone();
        }
        $q.resolve(collapsingExpr(scope)).then(function () {
          element
          // IMPORTANT: The height must be set before adding "collapsing" class.
          // Otherwise, the browser attempts to animate from height 0 (in
          // collapsing class) to the given height here.
          .css({
            height: element[0].scrollHeight + 'px'
          })
          // initially all panel collapse have the collapse class, this removal
          // prevents the animation from jumping to collapsed state
          .removeClass('collapse').addClass('collapsing').attr('aria-expanded', false).attr('aria-hidden', true);
          if ($animateCss) {
            $animateCss(element, {
              removeClass: 'in',
              to: {
                height: '0'
              }
            }).start()['finally'](collapseDone);
          } else {
            $animate.removeClass(element, 'in', {
              to: {
                height: '0'
              }
            }).then(collapseDone);
          }
        });
      }
      function collapseDone() {
        element.css({
          height: '0'
        }); // Required so that collapse works when animation is disabled
        element.removeClass('collapsing').addClass('collapse');
        collapsedExpr(scope);
      }
      scope.$watch(attrs.uibCollapse, function (shouldCollapse) {
        if (shouldCollapse) {
          collapse();
        } else {
          expand();
        }
      });
    }
  };
}]);
angular.module('ui.bootstrap.accordion', ['ui.bootstrap.collapse']).constant('uibAccordionConfig', {
  closeOthers: true
}).controller('UibAccordionController', ['$scope', '$attrs', 'uibAccordionConfig', function ($scope, $attrs, accordionConfig) {
  // This array keeps track of the accordion groups
  this.groups = [];

  // Ensure that all the groups in this accordion are closed, unless close-others explicitly says not to
  this.closeOthers = function (openGroup) {
    var closeOthers = angular.isDefined($attrs.closeOthers) ? $scope.$eval($attrs.closeOthers) : accordionConfig.closeOthers;
    if (closeOthers) {
      angular.forEach(this.groups, function (group) {
        if (group !== openGroup) {
          group.isOpen = false;
        }
      });
    }
  };

  // This is called from the accordion-group directive to add itself to the accordion
  this.addGroup = function (groupScope) {
    var that = this;
    this.groups.push(groupScope);
    groupScope.$on('$destroy', function (event) {
      that.removeGroup(groupScope);
    });
  };

  // This is called from the accordion-group directive when to remove itself
  this.removeGroup = function (group) {
    var index = this.groups.indexOf(group);
    if (index !== -1) {
      this.groups.splice(index, 1);
    }
  };
}])

// The accordion directive simply sets up the directive controller
// and adds an accordion CSS class to itself element.
.directive('uibAccordion', function () {
  return {
    controller: 'UibAccordionController',
    controllerAs: 'accordion',
    transclude: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion.html';
    }
  };
})

// The accordion-group directive indicates a block of html that will expand and collapse in an accordion
.directive('uibAccordionGroup', function () {
  return {
    require: '^uibAccordion',
    // We need this directive to be inside an accordion
    transclude: true,
    // It transcludes the contents of the directive into the template
    replace: true,
    // The element containing the directive will be replaced with the template
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/accordion/accordion-group.html';
    },
    scope: {
      heading: '@',
      // Interpolate the heading attribute onto this scope
      isOpen: '=?',
      isDisabled: '=?'
    },
    controller: function controller() {
      this.setHeading = function (element) {
        this.heading = element;
      };
    },
    link: function link(scope, element, attrs, accordionCtrl) {
      accordionCtrl.addGroup(scope);
      scope.openClass = attrs.openClass || 'panel-open';
      scope.panelClass = attrs.panelClass || 'panel-default';
      scope.$watch('isOpen', function (value) {
        element.toggleClass(scope.openClass, !!value);
        if (value) {
          accordionCtrl.closeOthers(scope);
        }
      });
      scope.toggleOpen = function ($event) {
        if (!scope.isDisabled) {
          if (!$event || $event.which === 32) {
            scope.isOpen = !scope.isOpen;
          }
        }
      };
      var id = 'accordiongroup-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
      scope.headingId = id + '-tab';
      scope.panelId = id + '-panel';
    }
  };
})

// Use accordion-heading below an accordion-group to provide a heading containing HTML
.directive('uibAccordionHeading', function () {
  return {
    transclude: true,
    // Grab the contents to be used as the heading
    template: '',
    // In effect remove this element!
    replace: true,
    require: '^uibAccordionGroup',
    link: function link(scope, element, attrs, accordionGroupCtrl, transclude) {
      // Pass the heading to the accordion-group controller
      // so that it can be transcluded into the right place in the template
      // [The second parameter to transclude causes the elements to be cloned so that they work in ng-repeat]
      accordionGroupCtrl.setHeading(transclude(scope, angular.noop));
    }
  };
})

// Use in the accordion-group template to indicate where you want the heading to be transcluded
// You must provide the property on the accordion-group controller that will hold the transcluded element
.directive('uibAccordionTransclude', function () {
  return {
    require: '^uibAccordionGroup',
    link: function link(scope, element, attrs, controller) {
      scope.$watch(function () {
        return controller[attrs.uibAccordionTransclude];
      }, function (heading) {
        if (heading) {
          element.find('span').html('');
          element.find('span').append(heading);
        }
      });
    }
  };
});
angular.module('ui.bootstrap.alert', []).controller('UibAlertController', ['$scope', '$attrs', '$interpolate', '$timeout', function ($scope, $attrs, $interpolate, $timeout) {
  $scope.closeable = !!$attrs.close;
  var dismissOnTimeout = angular.isDefined($attrs.dismissOnTimeout) ? $interpolate($attrs.dismissOnTimeout)($scope.$parent) : null;
  if (dismissOnTimeout) {
    $timeout(function () {
      $scope.close();
    }, parseInt(dismissOnTimeout, 10));
  }
}]).directive('uibAlert', function () {
  return {
    controller: 'UibAlertController',
    controllerAs: 'alert',
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/alert/alert.html';
    },
    transclude: true,
    replace: true,
    scope: {
      type: '@',
      close: '&'
    }
  };
});
angular.module('ui.bootstrap.buttons', []).constant('uibButtonConfig', {
  activeClass: 'active',
  toggleEvent: 'click'
}).controller('UibButtonsController', ['uibButtonConfig', function (buttonConfig) {
  this.activeClass = buttonConfig.activeClass || 'active';
  this.toggleEvent = buttonConfig.toggleEvent || 'click';
}]).directive('uibBtnRadio', ['$parse', function ($parse) {
  return {
    require: ['uibBtnRadio', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'buttons',
    link: function link(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      var uncheckableExpr = $parse(attrs.uibUncheckable);
      element.find('input').css({
        display: 'none'
      });

      //model -> UI
      ngModelCtrl.$render = function () {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, scope.$eval(attrs.uibBtnRadio)));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function () {
        if (attrs.disabled) {
          return;
        }
        var isActive = element.hasClass(buttonsCtrl.activeClass);
        if (!isActive || angular.isDefined(attrs.uncheckable)) {
          scope.$apply(function () {
            ngModelCtrl.$setViewValue(isActive ? null : scope.$eval(attrs.uibBtnRadio));
            ngModelCtrl.$render();
          });
        }
      });
      if (attrs.uibUncheckable) {
        scope.$watch(uncheckableExpr, function (uncheckable) {
          attrs.$set('uncheckable', uncheckable ? '' : null);
        });
      }
    }
  };
}]).directive('uibBtnCheckbox', function () {
  return {
    require: ['uibBtnCheckbox', 'ngModel'],
    controller: 'UibButtonsController',
    controllerAs: 'button',
    link: function link(scope, element, attrs, ctrls) {
      var buttonsCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      element.find('input').css({
        display: 'none'
      });
      function getTrueValue() {
        return getCheckboxValue(attrs.btnCheckboxTrue, true);
      }
      function getFalseValue() {
        return getCheckboxValue(attrs.btnCheckboxFalse, false);
      }
      function getCheckboxValue(attribute, defaultValue) {
        return angular.isDefined(attribute) ? scope.$eval(attribute) : defaultValue;
      }

      //model -> UI
      ngModelCtrl.$render = function () {
        element.toggleClass(buttonsCtrl.activeClass, angular.equals(ngModelCtrl.$modelValue, getTrueValue()));
      };

      //ui->model
      element.on(buttonsCtrl.toggleEvent, function () {
        if (attrs.disabled) {
          return;
        }
        scope.$apply(function () {
          ngModelCtrl.$setViewValue(element.hasClass(buttonsCtrl.activeClass) ? getFalseValue() : getTrueValue());
          ngModelCtrl.$render();
        });
      });
    }
  };
});
angular.module('ui.bootstrap.carousel', []).controller('UibCarouselController', ['$scope', '$element', '$interval', '$timeout', '$animate', function ($scope, $element, $interval, $timeout, $animate) {
  var self = this,
    slides = self.slides = $scope.slides = [],
    SLIDE_DIRECTION = 'uib-slideDirection',
    currentIndex = -1,
    currentInterval,
    isPlaying,
    bufferedTransitions = [];
  self.currentSlide = null;
  var destroyed = false;
  self.addSlide = function (slide, element) {
    slide.$element = element;
    slides.push(slide);
    //if this is the first slide or the slide is set to active, select it
    if (slides.length === 1 || slide.active) {
      if ($scope.$currentTransition) {
        $scope.$currentTransition = null;
      }
      self.select(slides[slides.length - 1]);
      if (slides.length === 1) {
        $scope.play();
      }
    } else {
      slide.active = false;
    }
  };
  self.getCurrentIndex = function () {
    if (self.currentSlide && angular.isDefined(self.currentSlide.index)) {
      return +self.currentSlide.index;
    }
    return currentIndex;
  };
  self.next = $scope.next = function () {
    var newIndex = (self.getCurrentIndex() + 1) % slides.length;
    if (newIndex === 0 && $scope.noWrap()) {
      $scope.pause();
      return;
    }
    return self.select(getSlideByIndex(newIndex), 'next');
  };
  self.prev = $scope.prev = function () {
    var newIndex = self.getCurrentIndex() - 1 < 0 ? slides.length - 1 : self.getCurrentIndex() - 1;
    if ($scope.noWrap() && newIndex === slides.length - 1) {
      $scope.pause();
      return;
    }
    return self.select(getSlideByIndex(newIndex), 'prev');
  };
  self.removeSlide = function (slide) {
    if (angular.isDefined(slide.index)) {
      slides.sort(function (a, b) {
        return +a.index > +b.index;
      });
    }
    var bufferedIndex = bufferedTransitions.indexOf(slide);
    if (bufferedIndex !== -1) {
      bufferedTransitions.splice(bufferedIndex, 1);
    }
    //get the index of the slide inside the carousel
    var index = slides.indexOf(slide);
    slides.splice(index, 1);
    $timeout(function () {
      if (slides.length > 0 && slide.active) {
        if (index >= slides.length) {
          self.select(slides[index - 1]);
        } else {
          self.select(slides[index]);
        }
      } else if (currentIndex > index) {
        currentIndex--;
      }
    });

    //clean the currentSlide when no more slide
    if (slides.length === 0) {
      self.currentSlide = null;
      clearBufferedTransitions();
    }
  };

  /* direction: "prev" or "next" */
  self.select = $scope.select = function (nextSlide, direction) {
    var nextIndex = $scope.indexOfSlide(nextSlide);
    //Decide direction if it's not given
    if (direction === undefined) {
      direction = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
    }
    //Prevent this user-triggered transition from occurring if there is already one in progress
    if (nextSlide && nextSlide !== self.currentSlide && !$scope.$currentTransition) {
      goNext(nextSlide, nextIndex, direction);
    } else if (nextSlide && nextSlide !== self.currentSlide && $scope.$currentTransition) {
      bufferedTransitions.push(nextSlide);
      nextSlide.active = false;
    }
  };

  /* Allow outside people to call indexOf on slides array */
  $scope.indexOfSlide = function (slide) {
    return angular.isDefined(slide.index) ? +slide.index : slides.indexOf(slide);
  };
  $scope.isActive = function (slide) {
    return self.currentSlide === slide;
  };
  $scope.pause = function () {
    if (!$scope.noPause) {
      isPlaying = false;
      resetTimer();
    }
  };
  $scope.play = function () {
    if (!isPlaying) {
      isPlaying = true;
      restartTimer();
    }
  };
  $scope.$on('$destroy', function () {
    destroyed = true;
    resetTimer();
  });
  $scope.$watch('noTransition', function (noTransition) {
    $animate.enabled($element, !noTransition);
  });
  $scope.$watch('interval', restartTimer);
  $scope.$watchCollection('slides', resetTransition);
  function clearBufferedTransitions() {
    while (bufferedTransitions.length) {
      bufferedTransitions.shift();
    }
  }
  function getSlideByIndex(index) {
    if (angular.isUndefined(slides[index].index)) {
      return slides[index];
    }
    for (var i = 0, l = slides.length; i < l; ++i) {
      if (slides[i].index === index) {
        return slides[i];
      }
    }
  }
  function goNext(slide, index, direction) {
    if (destroyed) {
      return;
    }
    angular.extend(slide, {
      direction: direction,
      active: true
    });
    angular.extend(self.currentSlide || {}, {
      direction: direction,
      active: false
    });
    if ($animate.enabled($element) && !$scope.$currentTransition && slide.$element && self.slides.length > 1) {
      slide.$element.data(SLIDE_DIRECTION, slide.direction);
      if (self.currentSlide && self.currentSlide.$element) {
        self.currentSlide.$element.data(SLIDE_DIRECTION, slide.direction);
      }
      $scope.$currentTransition = true;
      $animate.on('addClass', slide.$element, function (element, phase) {
        if (phase === 'close') {
          $scope.$currentTransition = null;
          $animate.off('addClass', element);
          if (bufferedTransitions.length) {
            var nextSlide = bufferedTransitions.pop();
            var nextIndex = $scope.indexOfSlide(nextSlide);
            var nextDirection = nextIndex > self.getCurrentIndex() ? 'next' : 'prev';
            clearBufferedTransitions();
            goNext(nextSlide, nextIndex, nextDirection);
          }
        }
      });
    }
    self.currentSlide = slide;
    currentIndex = index;

    //every time you change slides, reset the timer
    restartTimer();
  }
  function resetTimer() {
    if (currentInterval) {
      $interval.cancel(currentInterval);
      currentInterval = null;
    }
  }
  function resetTransition(slides) {
    if (!slides.length) {
      $scope.$currentTransition = null;
      clearBufferedTransitions();
    }
  }
  function restartTimer() {
    resetTimer();
    var interval = +$scope.interval;
    if (!isNaN(interval) && interval > 0) {
      currentInterval = $interval(timerFn, interval);
    }
  }
  function timerFn() {
    var interval = +$scope.interval;
    if (isPlaying && !isNaN(interval) && interval > 0 && slides.length) {
      $scope.next();
    } else {
      $scope.pause();
    }
  }
}]).directive('uibCarousel', function () {
  return {
    transclude: true,
    replace: true,
    controller: 'UibCarouselController',
    controllerAs: 'carousel',
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/carousel.html';
    },
    scope: {
      interval: '=',
      noTransition: '=',
      noPause: '=',
      noWrap: '&'
    }
  };
}).directive('uibSlide', function () {
  return {
    require: '^uibCarousel',
    transclude: true,
    replace: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/carousel/slide.html';
    },
    scope: {
      active: '=?',
      actual: '=?',
      index: '=?'
    },
    link: function link(scope, element, attrs, carouselCtrl) {
      carouselCtrl.addSlide(scope, element);
      //when the scope is destroyed then remove the slide from the current slides array
      scope.$on('$destroy', function () {
        carouselCtrl.removeSlide(scope);
      });
      scope.$watch('active', function (active) {
        if (active) {
          carouselCtrl.select(scope);
        }
      });
    }
  };
}).animation('.item', ['$animateCss', function ($animateCss) {
  var SLIDE_DIRECTION = 'uib-slideDirection';
  function removeClass(element, className, callback) {
    element.removeClass(className);
    if (callback) {
      callback();
    }
  }
  return {
    beforeAddClass: function beforeAddClass(element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass + ' ' + direction, done);
        element.addClass(direction);
        $animateCss(element, {
          addClass: directionClass
        }).start().done(removeClassFn);
        return function () {
          stopped = true;
        };
      }
      done();
    },
    beforeRemoveClass: function beforeRemoveClass(element, className, done) {
      if (className === 'active') {
        var stopped = false;
        var direction = element.data(SLIDE_DIRECTION);
        var directionClass = direction === 'next' ? 'left' : 'right';
        var removeClassFn = removeClass.bind(this, element, directionClass, done);
        $animateCss(element, {
          addClass: directionClass
        }).start().done(removeClassFn);
        return function () {
          stopped = true;
        };
      }
      done();
    }
  };
}]);
angular.module('ui.bootstrap.dateparser', []).service('uibDateParser', ['$log', '$locale', 'dateFilter', 'orderByFilter', function ($log, $locale, dateFilter, orderByFilter) {
  // Pulled from https://github.com/mbostock/d3/blob/master/src/format/requote.js
  var SPECIAL_CHARACTERS_REGEXP = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
  var localeId;
  var formatCodeToRegex;
  this.init = function () {
    localeId = $locale.id;
    this.parsers = {};
    this.formatters = {};
    formatCodeToRegex = [{
      key: 'yyyy',
      regex: '\\d{4}',
      apply: function apply(value) {
        this.year = +value;
      },
      formatter: function formatter(date) {
        var _date = new Date();
        _date.setFullYear(Math.abs(date.getFullYear()));
        return dateFilter(_date, 'yyyy');
      }
    }, {
      key: 'yy',
      regex: '\\d{2}',
      apply: function apply(value) {
        this.year = +value + 2000;
      },
      formatter: function formatter(date) {
        var _date = new Date();
        _date.setFullYear(Math.abs(date.getFullYear()));
        return dateFilter(_date, 'yy');
      }
    }, {
      key: 'y',
      regex: '\\d{1,4}',
      apply: function apply(value) {
        this.year = +value;
      },
      formatter: function formatter(date) {
        var _date = new Date();
        _date.setFullYear(Math.abs(date.getFullYear()));
        return dateFilter(_date, 'y');
      }
    }, {
      key: 'M!',
      regex: '0?[1-9]|1[0-2]',
      apply: function apply(value) {
        this.month = value - 1;
      },
      formatter: function formatter(date) {
        var value = date.getMonth();
        if (/^[0-9]$/.test(value)) {
          return dateFilter(date, 'MM');
        }
        return dateFilter(date, 'M');
      }
    }, {
      key: 'MMMM',
      regex: $locale.DATETIME_FORMATS.MONTH.join('|'),
      apply: function apply(value) {
        this.month = $locale.DATETIME_FORMATS.MONTH.indexOf(value);
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'MMMM');
      }
    }, {
      key: 'MMM',
      regex: $locale.DATETIME_FORMATS.SHORTMONTH.join('|'),
      apply: function apply(value) {
        this.month = $locale.DATETIME_FORMATS.SHORTMONTH.indexOf(value);
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'MMM');
      }
    }, {
      key: 'MM',
      regex: '0[1-9]|1[0-2]',
      apply: function apply(value) {
        this.month = value - 1;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'MM');
      }
    }, {
      key: 'M',
      regex: '[1-9]|1[0-2]',
      apply: function apply(value) {
        this.month = value - 1;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'M');
      }
    }, {
      key: 'd!',
      regex: '[0-2]?[0-9]{1}|3[0-1]{1}',
      apply: function apply(value) {
        this.date = +value;
      },
      formatter: function formatter(date) {
        var value = date.getDate();
        if (/^[1-9]$/.test(value)) {
          return dateFilter(date, 'dd');
        }
        return dateFilter(date, 'd');
      }
    }, {
      key: 'dd',
      regex: '[0-2][0-9]{1}|3[0-1]{1}',
      apply: function apply(value) {
        this.date = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'dd');
      }
    }, {
      key: 'd',
      regex: '[1-2]?[0-9]{1}|3[0-1]{1}',
      apply: function apply(value) {
        this.date = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'd');
      }
    }, {
      key: 'EEEE',
      regex: $locale.DATETIME_FORMATS.DAY.join('|'),
      formatter: function formatter(date) {
        return dateFilter(date, 'EEEE');
      }
    }, {
      key: 'EEE',
      regex: $locale.DATETIME_FORMATS.SHORTDAY.join('|'),
      formatter: function formatter(date) {
        return dateFilter(date, 'EEE');
      }
    }, {
      key: 'HH',
      regex: '(?:0|1)[0-9]|2[0-3]',
      apply: function apply(value) {
        this.hours = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'HH');
      }
    }, {
      key: 'hh',
      regex: '0[0-9]|1[0-2]',
      apply: function apply(value) {
        this.hours = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'hh');
      }
    }, {
      key: 'H',
      regex: '1?[0-9]|2[0-3]',
      apply: function apply(value) {
        this.hours = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'H');
      }
    }, {
      key: 'h',
      regex: '[0-9]|1[0-2]',
      apply: function apply(value) {
        this.hours = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'h');
      }
    }, {
      key: 'mm',
      regex: '[0-5][0-9]',
      apply: function apply(value) {
        this.minutes = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'mm');
      }
    }, {
      key: 'm',
      regex: '[0-9]|[1-5][0-9]',
      apply: function apply(value) {
        this.minutes = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'm');
      }
    }, {
      key: 'sss',
      regex: '[0-9][0-9][0-9]',
      apply: function apply(value) {
        this.milliseconds = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'sss');
      }
    }, {
      key: 'ss',
      regex: '[0-5][0-9]',
      apply: function apply(value) {
        this.seconds = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'ss');
      }
    }, {
      key: 's',
      regex: '[0-9]|[1-5][0-9]',
      apply: function apply(value) {
        this.seconds = +value;
      },
      formatter: function formatter(date) {
        return dateFilter(date, 's');
      }
    }, {
      key: 'a',
      regex: $locale.DATETIME_FORMATS.AMPMS.join('|'),
      apply: function apply(value) {
        if (this.hours === 12) {
          this.hours = 0;
        }
        if (value === 'PM') {
          this.hours += 12;
        }
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'a');
      }
    }, {
      key: 'Z',
      regex: '[+-]\\d{4}',
      apply: function apply(value) {
        var matches = value.match(/([+-])(\d{2})(\d{2})/),
          sign = matches[1],
          hours = matches[2],
          minutes = matches[3];
        this.hours += toInt(sign + hours);
        this.minutes += toInt(sign + minutes);
      },
      formatter: function formatter(date) {
        return dateFilter(date, 'Z');
      }
    }, {
      key: 'ww',
      regex: '[0-4][0-9]|5[0-3]',
      formatter: function formatter(date) {
        return dateFilter(date, 'ww');
      }
    }, {
      key: 'w',
      regex: '[0-9]|[1-4][0-9]|5[0-3]',
      formatter: function formatter(date) {
        return dateFilter(date, 'w');
      }
    }, {
      key: 'GGGG',
      regex: $locale.DATETIME_FORMATS.ERANAMES.join('|').replace(/\s/g, '\\s'),
      formatter: function formatter(date) {
        return dateFilter(date, 'GGGG');
      }
    }, {
      key: 'GGG',
      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
      formatter: function formatter(date) {
        return dateFilter(date, 'GGG');
      }
    }, {
      key: 'GG',
      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
      formatter: function formatter(date) {
        return dateFilter(date, 'GG');
      }
    }, {
      key: 'G',
      regex: $locale.DATETIME_FORMATS.ERAS.join('|'),
      formatter: function formatter(date) {
        return dateFilter(date, 'G');
      }
    }];
  };
  this.init();
  function createParser(format, func) {
    var map = [],
      regex = format.split('');

    // check for literal values
    var quoteIndex = format.indexOf('\'');
    if (quoteIndex > -1) {
      var inLiteral = false;
      format = format.split('');
      for (var i = quoteIndex; i < format.length; i++) {
        if (inLiteral) {
          if (format[i] === '\'') {
            if (i + 1 < format.length && format[i + 1] === '\'') {
              // escaped single quote
              format[i + 1] = '$';
              regex[i + 1] = '';
            } else {
              // end of literal
              regex[i] = '';
              inLiteral = false;
            }
          }
          format[i] = '$';
        } else {
          if (format[i] === '\'') {
            // start of literal
            format[i] = '$';
            regex[i] = '';
            inLiteral = true;
          }
        }
      }
      format = format.join('');
    }
    angular.forEach(formatCodeToRegex, function (data) {
      var index = format.indexOf(data.key);
      if (index > -1) {
        format = format.split('');
        regex[index] = '(' + data.regex + ')';
        format[index] = '$'; // Custom symbol to define consumed part of format
        for (var i = index + 1, n = index + data.key.length; i < n; i++) {
          regex[i] = '';
          format[i] = '$';
        }
        format = format.join('');
        map.push({
          index: index,
          key: data.key,
          apply: data[func],
          matcher: data.regex
        });
      }
    });
    return {
      regex: new RegExp('^' + regex.join('') + '$'),
      map: orderByFilter(map, 'index')
    };
  }
  this.filter = function (date, format) {
    if (!angular.isDate(date) || isNaN(date) || !format) {
      return '';
    }
    format = $locale.DATETIME_FORMATS[format] || format;
    if ($locale.id !== localeId) {
      this.init();
    }
    if (!this.formatters[format]) {
      this.formatters[format] = createParser(format, 'formatter');
    }
    var parser = this.formatters[format],
      map = parser.map;
    var _format = format;
    return map.reduce(function (str, mapper, i) {
      var match = _format.match(new RegExp('(.*)' + mapper.key));
      if (match && angular.isString(match[1])) {
        str += match[1];
        _format = _format.replace(match[1] + mapper.key, '');
      }
      if (mapper.apply) {
        return str + mapper.apply.call(null, date);
      }
      return str;
    }, '');
  };
  this.parse = function (input, format, baseDate) {
    if (!angular.isString(input) || !format) {
      return input;
    }
    format = $locale.DATETIME_FORMATS[format] || format;
    format = format.replace(SPECIAL_CHARACTERS_REGEXP, '\\$&');
    if ($locale.id !== localeId) {
      this.init();
    }
    if (!this.parsers[format]) {
      this.parsers[format] = createParser(format, 'apply');
    }
    var parser = this.parsers[format],
      regex = parser.regex,
      map = parser.map,
      results = input.match(regex),
      tzOffset = false;
    if (results && results.length) {
      var fields, dt;
      if (angular.isDate(baseDate) && !isNaN(baseDate.getTime())) {
        fields = {
          year: baseDate.getFullYear(),
          month: baseDate.getMonth(),
          date: baseDate.getDate(),
          hours: baseDate.getHours(),
          minutes: baseDate.getMinutes(),
          seconds: baseDate.getSeconds(),
          milliseconds: baseDate.getMilliseconds()
        };
      } else {
        if (baseDate) {
          $log.warn('dateparser:', 'baseDate is not a valid date');
        }
        fields = {
          year: 1900,
          month: 0,
          date: 1,
          hours: 0,
          minutes: 0,
          seconds: 0,
          milliseconds: 0
        };
      }
      for (var i = 1, n = results.length; i < n; i++) {
        var mapper = map[i - 1];
        if (mapper.matcher === 'Z') {
          tzOffset = true;
        }
        if (mapper.apply) {
          mapper.apply.call(fields, results[i]);
        }
      }
      var datesetter = tzOffset ? Date.prototype.setUTCFullYear : Date.prototype.setFullYear;
      var timesetter = tzOffset ? Date.prototype.setUTCHours : Date.prototype.setHours;
      if (isValid(fields.year, fields.month, fields.date)) {
        if (angular.isDate(baseDate) && !isNaN(baseDate.getTime()) && !tzOffset) {
          dt = new Date(baseDate);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours, fields.minutes, fields.seconds, fields.milliseconds);
        } else {
          dt = new Date(0);
          datesetter.call(dt, fields.year, fields.month, fields.date);
          timesetter.call(dt, fields.hours || 0, fields.minutes || 0, fields.seconds || 0, fields.milliseconds || 0);
        }
      }
      return dt;
    }
  };

  // Check if date is valid for specific month (and year for February).
  // Month: 0 = Jan, 1 = Feb, etc
  function isValid(year, month, date) {
    if (date < 1) {
      return false;
    }
    if (month === 1 && date > 28) {
      return date === 29 && (year % 4 === 0 && year % 100 !== 0 || year % 400 === 0);
    }
    if (month === 3 || month === 5 || month === 8 || month === 10) {
      return date < 31;
    }
    return true;
  }
  function toInt(str) {
    return parseInt(str, 10);
  }
  this.toTimezone = toTimezone;
  this.fromTimezone = fromTimezone;
  this.timezoneToOffset = timezoneToOffset;
  this.addDateMinutes = addDateMinutes;
  this.convertTimezoneToLocal = convertTimezoneToLocal;
  function toTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone) : date;
  }
  function fromTimezone(date, timezone) {
    return date && timezone ? convertTimezoneToLocal(date, timezone, true) : date;
  }

  //https://github.com/angular/angular.js/blob/4daafd3dbe6a80d578f5a31df1bb99c77559543e/src/Angular.js#L1207
  function timezoneToOffset(timezone, fallback) {
    var requestedTimezoneOffset = Date.parse('Jan 01, 1970 00:00:00 ' + timezone) / 60000;
    return isNaN(requestedTimezoneOffset) ? fallback : requestedTimezoneOffset;
  }
  function addDateMinutes(date, minutes) {
    date = new Date(date.getTime());
    date.setMinutes(date.getMinutes() + minutes);
    return date;
  }
  function convertTimezoneToLocal(date, timezone, reverse) {
    reverse = reverse ? -1 : 1;
    var timezoneOffset = timezoneToOffset(timezone, date.getTimezoneOffset());
    return addDateMinutes(date, reverse * (timezoneOffset - date.getTimezoneOffset()));
  }
}]);

// Avoiding use of ng-class as it creates a lot of watchers when a class is to be applied to
// at most one element.
angular.module('ui.bootstrap.isClass', []).directive('uibIsClass', ['$animate', function ($animate) {
  //                    11111111          22222222
  var ON_REGEXP = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/;
  //                    11111111           22222222
  var IS_REGEXP = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;
  var dataPerTracked = {};
  return {
    restrict: 'A',
    compile: function compile(tElement, tAttrs) {
      var linkedScopes = [];
      var instances = [];
      var expToData = {};
      var lastActivated = null;
      var onExpMatches = tAttrs.uibIsClass.match(ON_REGEXP);
      var onExp = onExpMatches[2];
      var expsStr = onExpMatches[1];
      var exps = expsStr.split(',');
      return linkFn;
      function linkFn(scope, element, attrs) {
        linkedScopes.push(scope);
        instances.push({
          scope: scope,
          element: element
        });
        exps.forEach(function (exp, k) {
          addForExp(exp, scope);
        });
        scope.$on('$destroy', removeScope);
      }
      function addForExp(exp, scope) {
        var matches = exp.match(IS_REGEXP);
        var clazz = scope.$eval(matches[1]);
        var compareWithExp = matches[2];
        var data = expToData[exp];
        if (!data) {
          var watchFn = function watchFn(compareWithVal) {
            var newActivated = null;
            instances.some(function (instance) {
              var thisVal = instance.scope.$eval(onExp);
              if (thisVal === compareWithVal) {
                newActivated = instance;
                return true;
              }
            });
            if (data.lastActivated !== newActivated) {
              if (data.lastActivated) {
                $animate.removeClass(data.lastActivated.element, clazz);
              }
              if (newActivated) {
                $animate.addClass(newActivated.element, clazz);
              }
              data.lastActivated = newActivated;
            }
          };
          expToData[exp] = data = {
            lastActivated: null,
            scope: scope,
            watchFn: watchFn,
            compareWithExp: compareWithExp,
            watcher: scope.$watch(compareWithExp, watchFn)
          };
        }
        data.watchFn(scope.$eval(compareWithExp));
      }
      function removeScope(e) {
        var removedScope = e.targetScope;
        var index = linkedScopes.indexOf(removedScope);
        linkedScopes.splice(index, 1);
        instances.splice(index, 1);
        if (linkedScopes.length) {
          var newWatchScope = linkedScopes[0];
          angular.forEach(expToData, function (data) {
            if (data.scope === removedScope) {
              data.watcher = newWatchScope.$watch(data.compareWithExp, data.watchFn);
              data.scope = newWatchScope;
            }
          });
        } else {
          expToData = {};
        }
      }
    }
  };
}]);
angular.module('ui.bootstrap.position', [])

/**
 * A set of utility methods for working with the DOM.
 * It is meant to be used where we need to absolute-position elements in
 * relation to another element (this is the case for tooltips, popovers,
 * typeahead suggestions etc.).
 */.factory('$uibPosition', ['$document', '$window', function ($document, $window) {
  /**
   * Used by scrollbarWidth() function to cache scrollbar's width.
   * Do not access this variable directly, use scrollbarWidth() instead.
   */
  var SCROLLBAR_WIDTH;
  var OVERFLOW_REGEX = {
    normal: /(auto|scroll)/,
    hidden: /(auto|scroll|hidden)/
  };
  var PLACEMENT_REGEX = {
    auto: /\s?auto?\s?/i,
    primary: /^(top|bottom|left|right)$/,
    secondary: /^(top|bottom|left|right|center)$/,
    vertical: /^(top|bottom)$/
  };
  return {
    /**
     * Provides a raw DOM element from a jQuery/jQLite element.
     *
     * @param {element} elem - The element to convert.
     *
     * @returns {element} A HTML element.
     */
    getRawNode: function getRawNode(elem) {
      return elem[0] || elem;
    },
    /**
     * Provides a parsed number for a style property.  Strips
     * units and casts invalid numbers to 0.
     *
     * @param {string} value - The style value to parse.
     *
     * @returns {number} A valid number.
     */
    parseStyle: function parseStyle(value) {
      value = parseFloat(value);
      return isFinite(value) ? value : 0;
    },
    /**
     * Provides the closest positioned ancestor.
     *
     * @param {element} element - The element to get the offest parent for.
     *
     * @returns {element} The closest positioned ancestor.
     */
    offsetParent: function offsetParent(elem) {
      elem = this.getRawNode(elem);
      var offsetParent = elem.offsetParent || $document[0].documentElement;
      function isStaticPositioned(el) {
        return ($window.getComputedStyle(el).position || 'static') === 'static';
      }
      while (offsetParent && offsetParent !== $document[0].documentElement && isStaticPositioned(offsetParent)) {
        offsetParent = offsetParent.offsetParent;
      }
      return offsetParent || $document[0].documentElement;
    },
    /**
     * Provides the scrollbar width, concept from TWBS measureScrollbar()
     * function in https://github.com/twbs/bootstrap/blob/master/js/modal.js
     *
     * @returns {number} The width of the browser scollbar.
     */
    scrollbarWidth: function scrollbarWidth() {
      if (angular.isUndefined(SCROLLBAR_WIDTH)) {
        var scrollElem = angular.element('<div style="position: absolute; top: -9999px; width: 50px; height: 50px; overflow: scroll;"></div>');
        $document.find('body').append(scrollElem);
        SCROLLBAR_WIDTH = scrollElem[0].offsetWidth - scrollElem[0].clientWidth;
        SCROLLBAR_WIDTH = isFinite(SCROLLBAR_WIDTH) ? SCROLLBAR_WIDTH : 0;
        scrollElem.remove();
      }
      return SCROLLBAR_WIDTH;
    },
    /**
     * Provides the closest scrollable ancestor.
     * A port of the jQuery UI scrollParent method:
     * https://github.com/jquery/jquery-ui/blob/master/ui/scroll-parent.js
     *
     * @param {element} elem - The element to find the scroll parent of.
     * @param {boolean=} [includeHidden=false] - Should scroll style of 'hidden' be considered,
     *   default is false.
     *
     * @returns {element} A HTML element.
     */
    scrollParent: function scrollParent(elem, includeHidden) {
      elem = this.getRawNode(elem);
      var overflowRegex = includeHidden ? OVERFLOW_REGEX.hidden : OVERFLOW_REGEX.normal;
      var documentEl = $document[0].documentElement;
      var elemStyle = $window.getComputedStyle(elem);
      var excludeStatic = elemStyle.position === 'absolute';
      var scrollParent = elem.parentElement || documentEl;
      if (scrollParent === documentEl || elemStyle.position === 'fixed') {
        return documentEl;
      }
      while (scrollParent.parentElement && scrollParent !== documentEl) {
        var spStyle = $window.getComputedStyle(scrollParent);
        if (excludeStatic && spStyle.position !== 'static') {
          excludeStatic = false;
        }
        if (!excludeStatic && overflowRegex.test(spStyle.overflow + spStyle.overflowY + spStyle.overflowX)) {
          break;
        }
        scrollParent = scrollParent.parentElement;
      }
      return scrollParent;
    },
    /**
     * Provides read-only equivalent of jQuery's position function:
     * http://api.jquery.com/position/ - distance to closest positioned
     * ancestor.  Does not account for margins by default like jQuery position.
     *
     * @param {element} elem - The element to caclulate the position on.
     * @param {boolean=} [includeMargins=false] - Should margins be accounted
     * for, default is false.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**width**: the width of the element</li>
     *     <li>**height**: the height of the element</li>
     *     <li>**top**: distance to top edge of offset parent</li>
     *     <li>**left**: distance to left edge of offset parent</li>
     *   </ul>
     */
    position: function position(elem, includeMagins) {
      elem = this.getRawNode(elem);
      var elemOffset = this.offset(elem);
      if (includeMagins) {
        var elemStyle = $window.getComputedStyle(elem);
        elemOffset.top -= this.parseStyle(elemStyle.marginTop);
        elemOffset.left -= this.parseStyle(elemStyle.marginLeft);
      }
      var parent = this.offsetParent(elem);
      var parentOffset = {
        top: 0,
        left: 0
      };
      if (parent !== $document[0].documentElement) {
        parentOffset = this.offset(parent);
        parentOffset.top += parent.clientTop - parent.scrollTop;
        parentOffset.left += parent.clientLeft - parent.scrollLeft;
      }
      return {
        width: Math.round(angular.isNumber(elemOffset.width) ? elemOffset.width : elem.offsetWidth),
        height: Math.round(angular.isNumber(elemOffset.height) ? elemOffset.height : elem.offsetHeight),
        top: Math.round(elemOffset.top - parentOffset.top),
        left: Math.round(elemOffset.left - parentOffset.left)
      };
    },
    /**
     * Provides read-only equivalent of jQuery's offset function:
     * http://api.jquery.com/offset/ - distance to viewport.  Does
     * not account for borders, margins, or padding on the body
     * element.
     *
     * @param {element} elem - The element to calculate the offset on.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**width**: the width of the element</li>
     *     <li>**height**: the height of the element</li>
     *     <li>**top**: distance to top edge of viewport</li>
     *     <li>**right**: distance to bottom edge of viewport</li>
     *   </ul>
     */
    offset: function offset(elem) {
      elem = this.getRawNode(elem);
      var elemBCR = elem.getBoundingClientRect();
      return {
        width: Math.round(angular.isNumber(elemBCR.width) ? elemBCR.width : elem.offsetWidth),
        height: Math.round(angular.isNumber(elemBCR.height) ? elemBCR.height : elem.offsetHeight),
        top: Math.round(elemBCR.top + ($window.pageYOffset || $document[0].documentElement.scrollTop)),
        left: Math.round(elemBCR.left + ($window.pageXOffset || $document[0].documentElement.scrollLeft))
      };
    },
    /**
     * Provides offset distance to the closest scrollable ancestor
     * or viewport.  Accounts for border and scrollbar width.
     *
     * Right and bottom dimensions represent the distance to the
     * respective edge of the viewport element.  If the element
     * edge extends beyond the viewport, a negative value will be
     * reported.
     *
     * @param {element} elem - The element to get the viewport offset for.
     * @param {boolean=} [useDocument=false] - Should the viewport be the document element instead
     * of the first scrollable element, default is false.
     * @param {boolean=} [includePadding=true] - Should the padding on the offset parent element
     * be accounted for, default is true.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**top**: distance to the top content edge of viewport element</li>
     *     <li>**bottom**: distance to the bottom content edge of viewport element</li>
     *     <li>**left**: distance to the left content edge of viewport element</li>
     *     <li>**right**: distance to the right content edge of viewport element</li>
     *   </ul>
     */
    viewportOffset: function viewportOffset(elem, useDocument, includePadding) {
      elem = this.getRawNode(elem);
      includePadding = includePadding !== false ? true : false;
      var elemBCR = elem.getBoundingClientRect();
      var offsetBCR = {
        top: 0,
        left: 0,
        bottom: 0,
        right: 0
      };
      var offsetParent = useDocument ? $document[0].documentElement : this.scrollParent(elem);
      var offsetParentBCR = offsetParent.getBoundingClientRect();
      offsetBCR.top = offsetParentBCR.top + offsetParent.clientTop;
      offsetBCR.left = offsetParentBCR.left + offsetParent.clientLeft;
      if (offsetParent === $document[0].documentElement) {
        offsetBCR.top += $window.pageYOffset;
        offsetBCR.left += $window.pageXOffset;
      }
      offsetBCR.bottom = offsetBCR.top + offsetParent.clientHeight;
      offsetBCR.right = offsetBCR.left + offsetParent.clientWidth;
      if (includePadding) {
        var offsetParentStyle = $window.getComputedStyle(offsetParent);
        offsetBCR.top += this.parseStyle(offsetParentStyle.paddingTop);
        offsetBCR.bottom -= this.parseStyle(offsetParentStyle.paddingBottom);
        offsetBCR.left += this.parseStyle(offsetParentStyle.paddingLeft);
        offsetBCR.right -= this.parseStyle(offsetParentStyle.paddingRight);
      }
      return {
        top: Math.round(elemBCR.top - offsetBCR.top),
        bottom: Math.round(offsetBCR.bottom - elemBCR.bottom),
        left: Math.round(elemBCR.left - offsetBCR.left),
        right: Math.round(offsetBCR.right - elemBCR.right)
      };
    },
    /**
     * Provides an array of placement values parsed from a placement string.
     * Along with the 'auto' indicator, supported placement strings are:
     *   <ul>
     *     <li>top: element on top, horizontally centered on host element.</li>
     *     <li>top-left: element on top, left edge aligned with host element left edge.</li>
     *     <li>top-right: element on top, lerightft edge aligned with host element right edge.</li>
     *     <li>bottom: element on bottom, horizontally centered on host element.</li>
     *     <li>bottom-left: element on bottom, left edge aligned with host element left edge.</li>
     *     <li>bottom-right: element on bottom, right edge aligned with host element right edge.</li>
     *     <li>left: element on left, vertically centered on host element.</li>
     *     <li>left-top: element on left, top edge aligned with host element top edge.</li>
     *     <li>left-bottom: element on left, bottom edge aligned with host element bottom edge.</li>
     *     <li>right: element on right, vertically centered on host element.</li>
     *     <li>right-top: element on right, top edge aligned with host element top edge.</li>
     *     <li>right-bottom: element on right, bottom edge aligned with host element bottom edge.</li>
     *   </ul>
     * A placement string with an 'auto' indicator is expected to be
     * space separated from the placement, i.e: 'auto bottom-left'  If
     * the primary and secondary placement values do not match 'top,
     * bottom, left, right' then 'top' will be the primary placement and
     * 'center' will be the secondary placement.  If 'auto' is passed, true
     * will be returned as the 3rd value of the array.
     *
     * @param {string} placement - The placement string to parse.
     *
     * @returns {array} An array with the following values
     * <ul>
     *   <li>**[0]**: The primary placement.</li>
     *   <li>**[1]**: The secondary placement.</li>
     *   <li>**[2]**: If auto is passed: true, else undefined.</li>
     * </ul>
     */
    parsePlacement: function parsePlacement(placement) {
      var autoPlace = PLACEMENT_REGEX.auto.test(placement);
      if (autoPlace) {
        placement = placement.replace(PLACEMENT_REGEX.auto, '');
      }
      placement = placement.split('-');
      placement[0] = placement[0] || 'top';
      if (!PLACEMENT_REGEX.primary.test(placement[0])) {
        placement[0] = 'top';
      }
      placement[1] = placement[1] || 'center';
      if (!PLACEMENT_REGEX.secondary.test(placement[1])) {
        placement[1] = 'center';
      }
      if (autoPlace) {
        placement[2] = true;
      } else {
        placement[2] = false;
      }
      return placement;
    },
    /**
     * Provides coordinates for an element to be positioned relative to
     * another element.  Passing 'auto' as part of the placement parameter
     * will enable smart placement - where the element fits. i.e:
     * 'auto left-top' will check to see if there is enough space to the left
     * of the hostElem to fit the targetElem, if not place right (same for secondary
     * top placement).  Available space is calculated using the viewportOffset
     * function.
     *
     * @param {element} hostElem - The element to position against.
     * @param {element} targetElem - The element to position.
     * @param {string=} [placement=top] - The placement for the targetElem,
     *   default is 'top'. 'center' is assumed as secondary placement for
     *   'top', 'left', 'right', and 'bottom' placements.  Available placements are:
     *   <ul>
     *     <li>top</li>
     *     <li>top-right</li>
     *     <li>top-left</li>
     *     <li>bottom</li>
     *     <li>bottom-left</li>
     *     <li>bottom-right</li>
     *     <li>left</li>
     *     <li>left-top</li>
     *     <li>left-bottom</li>
     *     <li>right</li>
     *     <li>right-top</li>
     *     <li>right-bottom</li>
     *   </ul>
     * @param {boolean=} [appendToBody=false] - Should the top and left values returned
     *   be calculated from the body element, default is false.
     *
     * @returns {object} An object with the following properties:
     *   <ul>
     *     <li>**top**: Value for targetElem top.</li>
     *     <li>**left**: Value for targetElem left.</li>
     *     <li>**placement**: The resolved placement.</li>
     *   </ul>
     */
    positionElements: function positionElements(hostElem, targetElem, placement, appendToBody) {
      hostElem = this.getRawNode(hostElem);
      targetElem = this.getRawNode(targetElem);

      // need to read from prop to support tests.
      var targetWidth = angular.isDefined(targetElem.offsetWidth) ? targetElem.offsetWidth : targetElem.prop('offsetWidth');
      var targetHeight = angular.isDefined(targetElem.offsetHeight) ? targetElem.offsetHeight : targetElem.prop('offsetHeight');
      placement = this.parsePlacement(placement);
      var hostElemPos = appendToBody ? this.offset(hostElem) : this.position(hostElem);
      var targetElemPos = {
        top: 0,
        left: 0,
        placement: ''
      };
      if (placement[2]) {
        var viewportOffset = this.viewportOffset(hostElem);
        var targetElemStyle = $window.getComputedStyle(targetElem);
        var adjustedSize = {
          width: targetWidth + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginLeft) + this.parseStyle(targetElemStyle.marginRight))),
          height: targetHeight + Math.round(Math.abs(this.parseStyle(targetElemStyle.marginTop) + this.parseStyle(targetElemStyle.marginBottom)))
        };
        placement[0] = placement[0] === 'top' && adjustedSize.height > viewportOffset.top && adjustedSize.height <= viewportOffset.bottom ? 'bottom' : placement[0] === 'bottom' && adjustedSize.height > viewportOffset.bottom && adjustedSize.height <= viewportOffset.top ? 'top' : placement[0] === 'left' && adjustedSize.width > viewportOffset.left && adjustedSize.width <= viewportOffset.right ? 'right' : placement[0] === 'right' && adjustedSize.width > viewportOffset.right && adjustedSize.width <= viewportOffset.left ? 'left' : placement[0];
        placement[1] = placement[1] === 'top' && adjustedSize.height - hostElemPos.height > viewportOffset.bottom && adjustedSize.height - hostElemPos.height <= viewportOffset.top ? 'bottom' : placement[1] === 'bottom' && adjustedSize.height - hostElemPos.height > viewportOffset.top && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom ? 'top' : placement[1] === 'left' && adjustedSize.width - hostElemPos.width > viewportOffset.right && adjustedSize.width - hostElemPos.width <= viewportOffset.left ? 'right' : placement[1] === 'right' && adjustedSize.width - hostElemPos.width > viewportOffset.left && adjustedSize.width - hostElemPos.width <= viewportOffset.right ? 'left' : placement[1];
        if (placement[1] === 'center') {
          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
            var xOverflow = hostElemPos.width / 2 - targetWidth / 2;
            if (viewportOffset.left + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.right) {
              placement[1] = 'left';
            } else if (viewportOffset.right + xOverflow < 0 && adjustedSize.width - hostElemPos.width <= viewportOffset.left) {
              placement[1] = 'right';
            }
          } else {
            var yOverflow = hostElemPos.height / 2 - adjustedSize.height / 2;
            if (viewportOffset.top + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.bottom) {
              placement[1] = 'top';
            } else if (viewportOffset.bottom + yOverflow < 0 && adjustedSize.height - hostElemPos.height <= viewportOffset.top) {
              placement[1] = 'bottom';
            }
          }
        }
      }
      switch (placement[0]) {
        case 'top':
          targetElemPos.top = hostElemPos.top - targetHeight;
          break;
        case 'bottom':
          targetElemPos.top = hostElemPos.top + hostElemPos.height;
          break;
        case 'left':
          targetElemPos.left = hostElemPos.left - targetWidth;
          break;
        case 'right':
          targetElemPos.left = hostElemPos.left + hostElemPos.width;
          break;
      }
      switch (placement[1]) {
        case 'top':
          targetElemPos.top = hostElemPos.top;
          break;
        case 'bottom':
          targetElemPos.top = hostElemPos.top + hostElemPos.height - targetHeight;
          break;
        case 'left':
          targetElemPos.left = hostElemPos.left;
          break;
        case 'right':
          targetElemPos.left = hostElemPos.left + hostElemPos.width - targetWidth;
          break;
        case 'center':
          if (PLACEMENT_REGEX.vertical.test(placement[0])) {
            targetElemPos.left = hostElemPos.left + hostElemPos.width / 2 - targetWidth / 2;
          } else {
            targetElemPos.top = hostElemPos.top + hostElemPos.height / 2 - targetHeight / 2;
          }
          break;
      }
      targetElemPos.top = Math.round(targetElemPos.top);
      targetElemPos.left = Math.round(targetElemPos.left);
      targetElemPos.placement = placement[1] === 'center' ? placement[0] : placement[0] + '-' + placement[1];
      return targetElemPos;
    },
    /**
    * Provides a way for positioning tooltip & dropdown
    * arrows when using placement options beyond the standard
    * left, right, top, or bottom.
    *
    * @param {element} elem - The tooltip/dropdown element.
    * @param {string} placement - The placement for the elem.
    */
    positionArrow: function positionArrow(elem, placement) {
      elem = this.getRawNode(elem);
      var innerElem = elem.querySelector('.tooltip-inner, .popover-inner');
      if (!innerElem) {
        return;
      }
      var isTooltip = angular.element(innerElem).hasClass('tooltip-inner');
      var arrowElem = isTooltip ? elem.querySelector('.tooltip-arrow') : elem.querySelector('.arrow');
      if (!arrowElem) {
        return;
      }
      placement = this.parsePlacement(placement);
      if (placement[1] === 'center') {
        // no adjustment necessary - just reset styles
        angular.element(arrowElem).css({
          top: '',
          bottom: '',
          right: '',
          left: '',
          margin: ''
        });
        return;
      }
      var borderProp = 'border-' + placement[0] + '-width';
      var borderWidth = $window.getComputedStyle(arrowElem)[borderProp];
      var borderRadiusProp = 'border-';
      if (PLACEMENT_REGEX.vertical.test(placement[0])) {
        borderRadiusProp += placement[0] + '-' + placement[1];
      } else {
        borderRadiusProp += placement[1] + '-' + placement[0];
      }
      borderRadiusProp += '-radius';
      var borderRadius = $window.getComputedStyle(isTooltip ? innerElem : elem)[borderRadiusProp];
      var arrowCss = {
        top: 'auto',
        bottom: 'auto',
        left: 'auto',
        right: 'auto',
        margin: 0
      };
      switch (placement[0]) {
        case 'top':
          arrowCss.bottom = isTooltip ? '0' : '-' + borderWidth;
          break;
        case 'bottom':
          arrowCss.top = isTooltip ? '0' : '-' + borderWidth;
          break;
        case 'left':
          arrowCss.right = isTooltip ? '0' : '-' + borderWidth;
          break;
        case 'right':
          arrowCss.left = isTooltip ? '0' : '-' + borderWidth;
          break;
      }
      arrowCss[placement[1]] = borderRadius;
      angular.element(arrowElem).css(arrowCss);
    }
  };
}]);
angular.module('ui.bootstrap.datepicker', ['ui.bootstrap.dateparser', 'ui.bootstrap.isClass', 'ui.bootstrap.position']).value('$datepickerSuppressError', false).constant('uibDatepickerConfig', {
  datepickerMode: 'day',
  formatDay: 'dd',
  formatMonth: 'MMMM',
  formatYear: 'yyyy',
  formatDayHeader: 'EEE',
  formatDayTitle: 'MMMM yyyy',
  formatMonthTitle: 'yyyy',
  maxDate: null,
  maxMode: 'year',
  minDate: null,
  minMode: 'day',
  ngModelOptions: {},
  shortcutPropagation: false,
  showWeeks: true,
  yearColumns: 5,
  yearRows: 4
}).controller('UibDatepickerController', ['$scope', '$attrs', '$parse', '$interpolate', '$locale', '$log', 'dateFilter', 'uibDatepickerConfig', '$datepickerSuppressError', 'uibDateParser', function ($scope, $attrs, $parse, $interpolate, $locale, $log, dateFilter, datepickerConfig, $datepickerSuppressError, dateParser) {
  var self = this,
    ngModelCtrl = {
      $setViewValue: angular.noop
    },
    // nullModelCtrl;
    ngModelOptions = {},
    watchListeners = [];

  // Modes chain
  this.modes = ['day', 'month', 'year'];
  if ($attrs.datepickerOptions) {
    angular.forEach(['formatDay', 'formatDayHeader', 'formatDayTitle', 'formatMonth', 'formatMonthTitle', 'formatYear', 'initDate', 'maxDate', 'maxMode', 'minDate', 'minMode', 'showWeeks', 'shortcutPropagation', 'startingDay', 'yearColumns', 'yearRows'], function (key) {
      switch (key) {
        case 'formatDay':
        case 'formatDayHeader':
        case 'formatDayTitle':
        case 'formatMonth':
        case 'formatMonthTitle':
        case 'formatYear':
          self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $interpolate($scope.datepickerOptions[key])($scope.$parent) : datepickerConfig[key];
          break;
        case 'showWeeks':
        case 'shortcutPropagation':
        case 'yearColumns':
        case 'yearRows':
          self[key] = angular.isDefined($scope.datepickerOptions[key]) ? $scope.datepickerOptions[key] : datepickerConfig[key];
          break;
        case 'startingDay':
          if (angular.isDefined($scope.datepickerOptions.startingDay)) {
            self.startingDay = $scope.datepickerOptions.startingDay;
          } else if (angular.isNumber(datepickerConfig.startingDay)) {
            self.startingDay = datepickerConfig.startingDay;
          } else {
            self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
          }
          break;
        case 'maxDate':
        case 'minDate':
          if ($scope.datepickerOptions[key]) {
            $scope.$watch(function () {
              return $scope.datepickerOptions[key];
            }, function (value) {
              if (value) {
                if (angular.isDate(value)) {
                  self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
                } else {
                  self[key] = new Date(dateFilter(value, 'medium'));
                }
              } else {
                self[key] = null;
              }
              self.refreshView();
            });
          } else {
            self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.timezone) : null;
          }
          break;
        case 'maxMode':
        case 'minMode':
          if ($scope.datepickerOptions[key]) {
            $scope.$watch(function () {
              return $scope.datepickerOptions[key];
            }, function (value) {
              self[key] = $scope[key] = angular.isDefined(value) ? value : datepickerOptions[key];
              if (key === 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key]) || key === 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key])) {
                $scope.datepickerMode = self[key];
              }
            });
          } else {
            self[key] = $scope[key] = datepickerConfig[key] || null;
          }
          break;
        case 'initDate':
          if ($scope.datepickerOptions.initDate) {
            this.activeDate = dateParser.fromTimezone($scope.datepickerOptions.initDate, ngModelOptions.timezone) || new Date();
            $scope.$watch(function () {
              return $scope.datepickerOptions.initDate;
            }, function (initDate) {
              if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
                self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.timezone);
                self.refreshView();
              }
            });
          } else {
            this.activeDate = new Date();
          }
      }
    });
  } else {
    // Interpolated configuration attributes
    angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle'], function (key) {
      self[key] = angular.isDefined($attrs[key]) ? $interpolate($attrs[key])($scope.$parent) : datepickerConfig[key];
    });

    // Evaled configuration attributes
    angular.forEach(['showWeeks', 'yearRows', 'yearColumns', 'shortcutPropagation'], function (key) {
      self[key] = angular.isDefined($attrs[key]) ? $scope.$parent.$eval($attrs[key]) : datepickerConfig[key];
    });
    if (angular.isDefined($attrs.startingDay)) {
      self.startingDay = $scope.$parent.$eval($attrs.startingDay);
    } else if (angular.isNumber(datepickerConfig.startingDay)) {
      self.startingDay = datepickerConfig.startingDay;
    } else {
      self.startingDay = ($locale.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
    }

    // Watchable date attributes
    angular.forEach(['minDate', 'maxDate'], function (key) {
      if ($attrs[key]) {
        watchListeners.push($scope.$parent.$watch($attrs[key], function (value) {
          if (value) {
            if (angular.isDate(value)) {
              self[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
            } else {
              self[key] = new Date(dateFilter(value, 'medium'));
            }
          } else {
            self[key] = null;
          }
          self.refreshView();
        }));
      } else {
        self[key] = datepickerConfig[key] ? dateParser.fromTimezone(new Date(datepickerConfig[key]), ngModelOptions.timezone) : null;
      }
    });
    angular.forEach(['minMode', 'maxMode'], function (key) {
      if ($attrs[key]) {
        watchListeners.push($scope.$parent.$watch($attrs[key], function (value) {
          self[key] = $scope[key] = angular.isDefined(value) ? value : $attrs[key];
          if (key === 'minMode' && self.modes.indexOf($scope.datepickerMode) < self.modes.indexOf(self[key]) || key === 'maxMode' && self.modes.indexOf($scope.datepickerMode) > self.modes.indexOf(self[key])) {
            $scope.datepickerMode = self[key];
          }
        }));
      } else {
        self[key] = $scope[key] = datepickerConfig[key] || null;
      }
    });
    if (angular.isDefined($attrs.initDate)) {
      this.activeDate = dateParser.fromTimezone($scope.$parent.$eval($attrs.initDate), ngModelOptions.timezone) || new Date();
      watchListeners.push($scope.$parent.$watch($attrs.initDate, function (initDate) {
        if (initDate && (ngModelCtrl.$isEmpty(ngModelCtrl.$modelValue) || ngModelCtrl.$invalid)) {
          self.activeDate = dateParser.fromTimezone(initDate, ngModelOptions.timezone);
          self.refreshView();
        }
      }));
    } else {
      this.activeDate = new Date();
    }
  }
  $scope.datepickerMode = $scope.datepickerMode || datepickerConfig.datepickerMode;
  $scope.uniqueId = 'datepicker-' + $scope.$id + '-' + Math.floor(Math.random() * 10000);
  $scope.disabled = angular.isDefined($attrs.disabled) || false;
  if (angular.isDefined($attrs.ngDisabled)) {
    watchListeners.push($scope.$parent.$watch($attrs.ngDisabled, function (disabled) {
      $scope.disabled = disabled;
      self.refreshView();
    }));
  }
  $scope.isActive = function (dateObject) {
    if (self.compare(dateObject.date, self.activeDate) === 0) {
      $scope.activeDateId = dateObject.uid;
      return true;
    }
    return false;
  };
  this.init = function (ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelOptions = ngModelCtrl_.$options || datepickerConfig.ngModelOptions;
    if (ngModelCtrl.$modelValue) {
      this.activeDate = ngModelCtrl.$modelValue;
    }
    ngModelCtrl.$render = function () {
      self.render();
    };
  };
  this.render = function () {
    if (ngModelCtrl.$viewValue) {
      var date = new Date(ngModelCtrl.$viewValue),
        isValid = !isNaN(date);
      if (isValid) {
        this.activeDate = dateParser.fromTimezone(date, ngModelOptions.timezone);
      } else if (!$datepickerSuppressError) {
        $log.error('Datepicker directive: "ng-model" value must be a Date object');
      }
    }
    this.refreshView();
  };
  this.refreshView = function () {
    if (this.element) {
      $scope.selectedDt = null;
      this._refreshView();
      if ($scope.activeDt) {
        $scope.activeDateId = $scope.activeDt.uid;
      }
      var date = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
      date = dateParser.fromTimezone(date, ngModelOptions.timezone);
      ngModelCtrl.$setValidity('dateDisabled', !date || this.element && !this.isDisabled(date));
    }
  };
  this.createDateObject = function (date, format) {
    var model = ngModelCtrl.$viewValue ? new Date(ngModelCtrl.$viewValue) : null;
    model = dateParser.fromTimezone(model, ngModelOptions.timezone);
    var dt = {
      date: date,
      label: dateParser.filter(date, format),
      selected: model && this.compare(date, model) === 0,
      disabled: this.isDisabled(date),
      current: this.compare(date, new Date()) === 0,
      customClass: this.customClass(date) || null
    };
    if (model && this.compare(date, model) === 0) {
      $scope.selectedDt = dt;
    }
    if (self.activeDate && this.compare(dt.date, self.activeDate) === 0) {
      $scope.activeDt = dt;
    }
    return dt;
  };
  this.isDisabled = function (date) {
    return $scope.disabled || this.minDate && this.compare(date, this.minDate) < 0 || this.maxDate && this.compare(date, this.maxDate) > 0 || $attrs.dateDisabled && $scope.dateDisabled({
      date: date,
      mode: $scope.datepickerMode
    });
  };
  this.customClass = function (date) {
    return $scope.customClass({
      date: date,
      mode: $scope.datepickerMode
    });
  };

  // Split array into smaller arrays
  this.split = function (arr, size) {
    var arrays = [];
    while (arr.length > 0) {
      arrays.push(arr.splice(0, size));
    }
    return arrays;
  };
  $scope.select = function (date) {
    if ($scope.datepickerMode === self.minMode) {
      var dt = ngModelCtrl.$viewValue ? dateParser.fromTimezone(new Date(ngModelCtrl.$viewValue), ngModelOptions.timezone) : new Date(0, 0, 0, 0, 0, 0, 0);
      dt.setFullYear(date.getFullYear(), date.getMonth(), date.getDate());
      dt = dateParser.toTimezone(dt, ngModelOptions.timezone);
      ngModelCtrl.$setViewValue(dt);
      ngModelCtrl.$render();
    } else {
      self.activeDate = date;
      $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) - 1];
    }
  };
  $scope.move = function (direction) {
    var year = self.activeDate.getFullYear() + direction * (self.step.years || 0),
      month = self.activeDate.getMonth() + direction * (self.step.months || 0);
    self.activeDate.setFullYear(year, month, 1);
    self.refreshView();
  };
  $scope.toggleMode = function (direction) {
    direction = direction || 1;
    if ($scope.datepickerMode === self.maxMode && direction === 1 || $scope.datepickerMode === self.minMode && direction === -1) {
      return;
    }
    $scope.datepickerMode = self.modes[self.modes.indexOf($scope.datepickerMode) + direction];
  };

  // Key event mapper
  $scope.keys = {
    13: 'enter',
    32: 'space',
    33: 'pageup',
    34: 'pagedown',
    35: 'end',
    36: 'home',
    37: 'left',
    38: 'up',
    39: 'right',
    40: 'down'
  };
  var focusElement = function focusElement() {
    self.element[0].focus();
  };

  // Listen for focus requests from popup directive
  $scope.$on('uib:datepicker.focus', focusElement);
  $scope.keydown = function (evt) {
    var key = $scope.keys[evt.which];
    if (!key || evt.shiftKey || evt.altKey || $scope.disabled) {
      return;
    }
    evt.preventDefault();
    if (!self.shortcutPropagation) {
      evt.stopPropagation();
    }
    if (key === 'enter' || key === 'space') {
      if (self.isDisabled(self.activeDate)) {
        return; // do nothing
      }
      $scope.select(self.activeDate);
    } else if (evt.ctrlKey && (key === 'up' || key === 'down')) {
      $scope.toggleMode(key === 'up' ? 1 : -1);
    } else {
      self.handleKeyDown(key, evt);
      self.refreshView();
    }
  };
  $scope.$on("$destroy", function () {
    //Clear all watch listeners on destroy
    while (watchListeners.length) {
      watchListeners.shift()();
    }
  });
}]).controller('UibDaypickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
  var DAYS_IN_MONTH = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  this.step = {
    months: 1
  };
  this.element = $element;
  function getDaysInMonth(year, month) {
    return month === 1 && year % 4 === 0 && (year % 100 !== 0 || year % 400 === 0) ? 29 : DAYS_IN_MONTH[month];
  }
  this.init = function (ctrl) {
    angular.extend(ctrl, this);
    scope.showWeeks = ctrl.showWeeks;
    ctrl.refreshView();
  };
  this.getDates = function (startDate, n) {
    var dates = new Array(n),
      current = new Date(startDate),
      i = 0,
      date;
    while (i < n) {
      date = new Date(current);
      dates[i++] = date;
      current.setDate(current.getDate() + 1);
    }
    return dates;
  };
  this._refreshView = function () {
    var year = this.activeDate.getFullYear(),
      month = this.activeDate.getMonth(),
      firstDayOfMonth = new Date(this.activeDate);
    firstDayOfMonth.setFullYear(year, month, 1);
    var difference = this.startingDay - firstDayOfMonth.getDay(),
      numDisplayedFromPreviousMonth = difference > 0 ? 7 - difference : -difference,
      firstDate = new Date(firstDayOfMonth);
    if (numDisplayedFromPreviousMonth > 0) {
      firstDate.setDate(-numDisplayedFromPreviousMonth + 1);
    }

    // 42 is the number of days on a six-week calendar
    var days = this.getDates(firstDate, 42);
    for (var i = 0; i < 42; i++) {
      days[i] = angular.extend(this.createDateObject(days[i], this.formatDay), {
        secondary: days[i].getMonth() !== month,
        uid: scope.uniqueId + '-' + i
      });
    }
    scope.labels = new Array(7);
    for (var j = 0; j < 7; j++) {
      scope.labels[j] = {
        abbr: dateFilter(days[j].date, this.formatDayHeader),
        full: dateFilter(days[j].date, 'EEEE')
      };
    }
    scope.title = dateFilter(this.activeDate, this.formatDayTitle);
    scope.rows = this.split(days, 7);
    if (scope.showWeeks) {
      scope.weekNumbers = [];
      var thursdayIndex = (4 + 7 - this.startingDay) % 7,
        numWeeks = scope.rows.length;
      for (var curWeek = 0; curWeek < numWeeks; curWeek++) {
        scope.weekNumbers.push(getISO8601WeekNumber(scope.rows[curWeek][thursdayIndex].date));
      }
    }
  };
  this.compare = function (date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth(), date1.getDate());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };
  function getISO8601WeekNumber(date) {
    var checkDate = new Date(date);
    checkDate.setDate(checkDate.getDate() + 4 - (checkDate.getDay() || 7)); // Thursday
    var time = checkDate.getTime();
    checkDate.setMonth(0); // Compare with Jan 1
    checkDate.setDate(1);
    return Math.floor(Math.round((time - checkDate) / 86400000) / 7) + 1;
  }
  this.handleKeyDown = function (key, evt) {
    var date = this.activeDate.getDate();
    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - 7;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + 7;
    } else if (key === 'pageup' || key === 'pagedown') {
      var month = this.activeDate.getMonth() + (key === 'pageup' ? -1 : 1);
      this.activeDate.setMonth(month, 1);
      date = Math.min(getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth()), date);
    } else if (key === 'home') {
      date = 1;
    } else if (key === 'end') {
      date = getDaysInMonth(this.activeDate.getFullYear(), this.activeDate.getMonth());
    }
    this.activeDate.setDate(date);
  };
}]).controller('UibMonthpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
  this.step = {
    years: 1
  };
  this.element = $element;
  this.init = function (ctrl) {
    angular.extend(ctrl, this);
    ctrl.refreshView();
  };
  this._refreshView = function () {
    var months = new Array(12),
      year = this.activeDate.getFullYear(),
      date;
    for (var i = 0; i < 12; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(year, i, 1);
      months[i] = angular.extend(this.createDateObject(date, this.formatMonth), {
        uid: scope.uniqueId + '-' + i
      });
    }
    scope.title = dateFilter(this.activeDate, this.formatMonthTitle);
    scope.rows = this.split(months, 3);
  };
  this.compare = function (date1, date2) {
    var _date1 = new Date(date1.getFullYear(), date1.getMonth());
    var _date2 = new Date(date2.getFullYear(), date2.getMonth());
    _date1.setFullYear(date1.getFullYear());
    _date2.setFullYear(date2.getFullYear());
    return _date1 - _date2;
  };
  this.handleKeyDown = function (key, evt) {
    var date = this.activeDate.getMonth();
    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - 3;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + 3;
    } else if (key === 'pageup' || key === 'pagedown') {
      var year = this.activeDate.getFullYear() + (key === 'pageup' ? -1 : 1);
      this.activeDate.setFullYear(year);
    } else if (key === 'home') {
      date = 0;
    } else if (key === 'end') {
      date = 11;
    }
    this.activeDate.setMonth(date);
  };
}]).controller('UibYearpickerController', ['$scope', '$element', 'dateFilter', function (scope, $element, dateFilter) {
  var columns, range;
  this.element = $element;
  function getStartingYear(year) {
    return parseInt((year - 1) / range, 10) * range + 1;
  }
  this.yearpickerInit = function () {
    columns = this.yearColumns;
    range = this.yearRows * columns;
    this.step = {
      years: range
    };
  };
  this._refreshView = function () {
    var years = new Array(range),
      date;
    for (var i = 0, start = getStartingYear(this.activeDate.getFullYear()); i < range; i++) {
      date = new Date(this.activeDate);
      date.setFullYear(start + i, 0, 1);
      years[i] = angular.extend(this.createDateObject(date, this.formatYear), {
        uid: scope.uniqueId + '-' + i
      });
    }
    scope.title = [years[0].label, years[range - 1].label].join(' - ');
    scope.rows = this.split(years, columns);
    scope.columns = columns;
  };
  this.compare = function (date1, date2) {
    return date1.getFullYear() - date2.getFullYear();
  };
  this.handleKeyDown = function (key, evt) {
    var date = this.activeDate.getFullYear();
    if (key === 'left') {
      date = date - 1;
    } else if (key === 'up') {
      date = date - columns;
    } else if (key === 'right') {
      date = date + 1;
    } else if (key === 'down') {
      date = date + columns;
    } else if (key === 'pageup' || key === 'pagedown') {
      date += (key === 'pageup' ? -1 : 1) * range;
    } else if (key === 'home') {
      date = getStartingYear(this.activeDate.getFullYear());
    } else if (key === 'end') {
      date = getStartingYear(this.activeDate.getFullYear()) + range - 1;
    }
    this.activeDate.setFullYear(date);
  };
}]).directive('uibDatepicker', function () {
  return {
    replace: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/datepicker.html';
    },
    scope: {
      datepickerMode: '=?',
      datepickerOptions: '=?',
      dateDisabled: '&',
      customClass: '&',
      shortcutPropagation: '&?'
    },
    require: ['uibDatepicker', '^ngModel'],
    controller: 'UibDatepickerController',
    controllerAs: 'datepicker',
    link: function link(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      datepickerCtrl.init(ngModelCtrl);
    }
  };
}).directive('uibDaypicker', function () {
  return {
    replace: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/day.html';
    },
    require: ['^uibDatepicker', 'uibDaypicker'],
    controller: 'UibDaypickerController',
    link: function link(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        daypickerCtrl = ctrls[1];
      daypickerCtrl.init(datepickerCtrl);
    }
  };
}).directive('uibMonthpicker', function () {
  return {
    replace: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/month.html';
    },
    require: ['^uibDatepicker', 'uibMonthpicker'],
    controller: 'UibMonthpickerController',
    link: function link(scope, element, attrs, ctrls) {
      var datepickerCtrl = ctrls[0],
        monthpickerCtrl = ctrls[1];
      monthpickerCtrl.init(datepickerCtrl);
    }
  };
}).directive('uibYearpicker', function () {
  return {
    replace: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/year.html';
    },
    require: ['^uibDatepicker', 'uibYearpicker'],
    controller: 'UibYearpickerController',
    link: function link(scope, element, attrs, ctrls) {
      var ctrl = ctrls[0];
      angular.extend(ctrl, ctrls[1]);
      ctrl.yearpickerInit();
      ctrl.refreshView();
    }
  };
}).constant('uibDatepickerPopupConfig', {
  altInputFormats: [],
  appendToBody: false,
  clearText: 'Clear',
  closeOnDateSelection: true,
  closeText: 'Done',
  currentText: 'Today',
  datepickerPopup: 'yyyy-MM-dd',
  datepickerPopupTemplateUrl: 'uib/template/datepicker/popup.html',
  datepickerTemplateUrl: 'uib/template/datepicker/datepicker.html',
  html5Types: {
    date: 'yyyy-MM-dd',
    'datetime-local': 'yyyy-MM-ddTHH:mm:ss.sss',
    'month': 'yyyy-MM'
  },
  onOpenFocus: true,
  showButtonBar: true
}).controller('UibDatepickerPopupController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$document', '$rootScope', '$uibPosition', 'dateFilter', 'uibDateParser', 'uibDatepickerPopupConfig', '$timeout', 'uibDatepickerConfig', function (scope, element, attrs, $compile, $parse, $document, $rootScope, $position, dateFilter, dateParser, datepickerPopupConfig, $timeout, datepickerConfig) {
  var cache = {},
    isHtml5DateInput = false;
  var dateFormat,
    closeOnDateSelection,
    appendToBody,
    onOpenFocus,
    datepickerPopupTemplateUrl,
    datepickerTemplateUrl,
    popupEl,
    datepickerEl,
    ngModel,
    ngModelOptions,
    $popup,
    altInputFormats,
    watchListeners = [];
  scope.watchData = {};
  this.init = function (_ngModel_) {
    ngModel = _ngModel_;
    ngModelOptions = _ngModel_.$options || datepickerConfig.ngModelOptions;
    closeOnDateSelection = angular.isDefined(attrs.closeOnDateSelection) ? scope.$parent.$eval(attrs.closeOnDateSelection) : datepickerPopupConfig.closeOnDateSelection;
    appendToBody = angular.isDefined(attrs.datepickerAppendToBody) ? scope.$parent.$eval(attrs.datepickerAppendToBody) : datepickerPopupConfig.appendToBody;
    onOpenFocus = angular.isDefined(attrs.onOpenFocus) ? scope.$parent.$eval(attrs.onOpenFocus) : datepickerPopupConfig.onOpenFocus;
    datepickerPopupTemplateUrl = angular.isDefined(attrs.datepickerPopupTemplateUrl) ? attrs.datepickerPopupTemplateUrl : datepickerPopupConfig.datepickerPopupTemplateUrl;
    datepickerTemplateUrl = angular.isDefined(attrs.datepickerTemplateUrl) ? attrs.datepickerTemplateUrl : datepickerPopupConfig.datepickerTemplateUrl;
    altInputFormats = angular.isDefined(attrs.altInputFormats) ? scope.$parent.$eval(attrs.altInputFormats) : datepickerPopupConfig.altInputFormats;
    scope.showButtonBar = angular.isDefined(attrs.showButtonBar) ? scope.$parent.$eval(attrs.showButtonBar) : datepickerPopupConfig.showButtonBar;
    if (datepickerPopupConfig.html5Types[attrs.type]) {
      dateFormat = datepickerPopupConfig.html5Types[attrs.type];
      isHtml5DateInput = true;
    } else {
      dateFormat = attrs.uibDatepickerPopup || datepickerPopupConfig.datepickerPopup;
      attrs.$observe('uibDatepickerPopup', function (value, oldValue) {
        var newDateFormat = value || datepickerPopupConfig.datepickerPopup;
        // Invalidate the $modelValue to ensure that formatters re-run
        // FIXME: Refactor when PR is merged: https://github.com/angular/angular.js/pull/10764
        if (newDateFormat !== dateFormat) {
          dateFormat = newDateFormat;
          ngModel.$modelValue = null;
          if (!dateFormat) {
            throw new Error('uibDatepickerPopup must have a date format specified.');
          }
        }
      });
    }
    if (!dateFormat) {
      throw new Error('uibDatepickerPopup must have a date format specified.');
    }
    if (isHtml5DateInput && attrs.uibDatepickerPopup) {
      throw new Error('HTML5 date input types do not support custom formats.');
    }

    // popup element used to display calendar
    popupEl = angular.element('<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>');
    scope.ngModelOptions = angular.copy(ngModelOptions);
    scope.ngModelOptions.timezone = null;
    popupEl.attr({
      'ng-model': 'date',
      'ng-model-options': 'ngModelOptions',
      'ng-change': 'dateSelection(date)',
      'template-url': datepickerPopupTemplateUrl
    });

    // datepicker element
    datepickerEl = angular.element(popupEl.children()[0]);
    datepickerEl.attr('template-url', datepickerTemplateUrl);
    if (isHtml5DateInput) {
      if (attrs.type === 'month') {
        datepickerEl.attr('datepicker-mode', '"month"');
        datepickerEl.attr('min-mode', 'month');
      }
    }
    if (scope.datepickerOptions) {
      angular.forEach(scope.datepickerOptions, function (value, option) {
        // Ignore this options, will be managed later
        if (['minDate', 'maxDate', 'minMode', 'maxMode', 'initDate', 'datepickerMode'].indexOf(option) === -1) {
          datepickerEl.attr(cameltoDash(option), value);
        } else {
          datepickerEl.attr(cameltoDash(option), 'datepickerOptions.' + option);
        }
      });
    }
    angular.forEach(['minMode', 'maxMode', 'datepickerMode', 'shortcutPropagation'], function (key) {
      if (attrs[key]) {
        var getAttribute = $parse(attrs[key]);
        var propConfig = {
          get: function get() {
            return getAttribute(scope.$parent);
          }
        };
        datepickerEl.attr(cameltoDash(key), 'watchData.' + key);

        // Propagate changes from datepicker to outside
        if (key === 'datepickerMode') {
          var setAttribute = getAttribute.assign;
          propConfig.set = function (v) {
            setAttribute(scope.$parent, v);
          };
        }
        Object.defineProperty(scope.watchData, key, propConfig);
      }
    });
    angular.forEach(['minDate', 'maxDate', 'initDate'], function (key) {
      if (attrs[key]) {
        var getAttribute = $parse(attrs[key]);
        watchListeners.push(scope.$parent.$watch(getAttribute, function (value) {
          if (key === 'minDate' || key === 'maxDate') {
            if (value === null) {
              cache[key] = null;
            } else if (angular.isDate(value)) {
              cache[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
            } else {
              cache[key] = new Date(dateFilter(value, 'medium'));
            }
            scope.watchData[key] = value === null ? null : cache[key];
          } else {
            scope.watchData[key] = dateParser.fromTimezone(new Date(value), ngModelOptions.timezone);
          }
        }));
        datepickerEl.attr(cameltoDash(key), 'watchData.' + key);
      }
    });
    if (attrs.dateDisabled) {
      datepickerEl.attr('date-disabled', 'dateDisabled({ date: date, mode: mode })');
    }
    angular.forEach(['formatDay', 'formatMonth', 'formatYear', 'formatDayHeader', 'formatDayTitle', 'formatMonthTitle', 'showWeeks', 'startingDay', 'yearRows', 'yearColumns'], function (key) {
      if (angular.isDefined(attrs[key])) {
        datepickerEl.attr(cameltoDash(key), attrs[key]);
      }
    });
    if (attrs.customClass) {
      datepickerEl.attr('custom-class', 'customClass({ date: date, mode: mode })');
    }
    if (!isHtml5DateInput) {
      // Internal API to maintain the correct ng-invalid-[key] class
      ngModel.$$parserName = 'date';
      ngModel.$validators.date = validator;
      ngModel.$parsers.unshift(parseDate);
      ngModel.$formatters.push(function (value) {
        if (ngModel.$isEmpty(value)) {
          scope.date = value;
          return value;
        }
        scope.date = dateParser.fromTimezone(value, ngModelOptions.timezone);
        if (angular.isNumber(scope.date)) {
          scope.date = new Date(scope.date);
        }
        return dateParser.filter(scope.date, dateFormat);
      });
    } else {
      ngModel.$formatters.push(function (value) {
        scope.date = dateParser.fromTimezone(value, ngModelOptions.timezone);
        return value;
      });
    }

    // Detect changes in the view from the text box
    ngModel.$viewChangeListeners.push(function () {
      scope.date = parseDateString(ngModel.$viewValue);
    });
    element.on('keydown', inputKeydownBind);
    $popup = $compile(popupEl)(scope);
    // Prevent jQuery cache memory leak (template is now redundant after linking)
    popupEl.remove();
    if (appendToBody) {
      $document.find('body').append($popup);
    } else {
      element.after($popup);
    }
    scope.$on('$destroy', function () {
      if (scope.isOpen === true) {
        if (!$rootScope.$$phase) {
          scope.$apply(function () {
            scope.isOpen = false;
          });
        }
      }
      $popup.remove();
      element.off('keydown', inputKeydownBind);
      $document.off('click', documentClickBind);

      //Clear all watch listeners on destroy
      while (watchListeners.length) {
        watchListeners.shift()();
      }
    });
  };
  scope.getText = function (key) {
    return scope[key + 'Text'] || datepickerPopupConfig[key + 'Text'];
  };
  scope.isDisabled = function (date) {
    if (date === 'today') {
      date = new Date();
    }
    return scope.watchData.minDate && scope.compare(date, cache.minDate) < 0 || scope.watchData.maxDate && scope.compare(date, cache.maxDate) > 0;
  };
  scope.compare = function (date1, date2) {
    return new Date(date1.getFullYear(), date1.getMonth(), date1.getDate()) - new Date(date2.getFullYear(), date2.getMonth(), date2.getDate());
  };

  // Inner change
  scope.dateSelection = function (dt) {
    if (angular.isDefined(dt)) {
      scope.date = dt;
    }
    var date = scope.date ? dateParser.filter(scope.date, dateFormat) : null; // Setting to NULL is necessary for form validators to function
    element.val(date);
    ngModel.$setViewValue(date);
    if (closeOnDateSelection) {
      scope.isOpen = false;
      element[0].focus();
    }
  };
  scope.keydown = function (evt) {
    if (evt.which === 27) {
      evt.stopPropagation();
      scope.isOpen = false;
      element[0].focus();
    }
  };
  scope.select = function (date) {
    if (date === 'today') {
      var today = new Date();
      if (angular.isDate(scope.date)) {
        date = new Date(scope.date);
        date.setFullYear(today.getFullYear(), today.getMonth(), today.getDate());
      } else {
        date = new Date(today.setHours(0, 0, 0, 0));
      }
    }
    scope.dateSelection(date);
  };
  scope.close = function () {
    scope.isOpen = false;
    element[0].focus();
  };
  scope.disabled = angular.isDefined(attrs.disabled) || false;
  if (attrs.ngDisabled) {
    watchListeners.push(scope.$parent.$watch($parse(attrs.ngDisabled), function (disabled) {
      scope.disabled = disabled;
    }));
  }
  scope.$watch('isOpen', function (value) {
    if (value) {
      if (!scope.disabled) {
        scope.position = appendToBody ? $position.offset(element) : $position.position(element);
        scope.position.top = scope.position.top + element.prop('offsetHeight');
        $timeout(function () {
          if (onOpenFocus) {
            scope.$broadcast('uib:datepicker.focus');
          }
          $document.on('click', documentClickBind);
        }, 0, false);
      } else {
        scope.isOpen = false;
      }
    } else {
      $document.off('click', documentClickBind);
    }
  });
  function cameltoDash(string) {
    return string.replace(/([A-Z])/g, function ($1) {
      return '-' + $1.toLowerCase();
    });
  }
  function parseDateString(viewValue) {
    var date = dateParser.parse(viewValue, dateFormat, scope.date);
    if (isNaN(date)) {
      for (var i = 0; i < altInputFormats.length; i++) {
        date = dateParser.parse(viewValue, altInputFormats[i], scope.date);
        if (!isNaN(date)) {
          return date;
        }
      }
    }
    return date;
  }
  function parseDate(viewValue) {
    if (angular.isNumber(viewValue)) {
      // presumably timestamp to date object
      viewValue = new Date(viewValue);
    }
    if (!viewValue) {
      return null;
    }
    if (angular.isDate(viewValue) && !isNaN(viewValue)) {
      return viewValue;
    }
    if (angular.isString(viewValue)) {
      var date = parseDateString(viewValue);
      if (!isNaN(date)) {
        return dateParser.toTimezone(date, ngModelOptions.timezone);
      }
    }
    return ngModel.$options && ngModel.$options.allowInvalid ? viewValue : undefined;
  }
  function validator(modelValue, viewValue) {
    var value = modelValue || viewValue;
    if (!attrs.ngRequired && !value) {
      return true;
    }
    if (angular.isNumber(value)) {
      value = new Date(value);
    }
    if (!value) {
      return true;
    }
    if (angular.isDate(value) && !isNaN(value)) {
      return true;
    }
    if (angular.isString(value)) {
      return !isNaN(parseDateString(viewValue));
    }
    return false;
  }
  function documentClickBind(event) {
    if (!scope.isOpen && scope.disabled) {
      return;
    }
    var popup = $popup[0];
    var dpContainsTarget = element[0].contains(event.target);
    // The popup node may not be an element node
    // In some browsers (IE) only element nodes have the 'contains' function
    var popupContainsTarget = popup.contains !== undefined && popup.contains(event.target);
    if (scope.isOpen && !(dpContainsTarget || popupContainsTarget)) {
      scope.$apply(function () {
        scope.isOpen = false;
      });
    }
  }
  function inputKeydownBind(evt) {
    if (evt.which === 27 && scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      scope.$apply(function () {
        scope.isOpen = false;
      });
      element[0].focus();
    } else if (evt.which === 40 && !scope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      scope.$apply(function () {
        scope.isOpen = true;
      });
    }
  }
}]).directive('uibDatepickerPopup', function () {
  return {
    require: ['ngModel', 'uibDatepickerPopup'],
    controller: 'UibDatepickerPopupController',
    scope: {
      datepickerOptions: '=?',
      isOpen: '=?',
      currentText: '@',
      clearText: '@',
      closeText: '@',
      dateDisabled: '&',
      customClass: '&'
    },
    link: function link(scope, element, attrs, ctrls) {
      var ngModel = ctrls[0],
        ctrl = ctrls[1];
      ctrl.init(ngModel);
    }
  };
}).directive('uibDatepickerPopupWrap', function () {
  return {
    replace: true,
    transclude: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/datepicker/popup.html';
    }
  };
});
angular.module('ui.bootstrap.debounce', [])
/**
 * A helper, internal service that debounces a function
 */.factory('$$debounce', ['$timeout', function ($timeout) {
  return function (callback, debounceTime) {
    var timeoutPromise;
    return function () {
      var self = this;
      var args = Array.prototype.slice.call(arguments);
      if (timeoutPromise) {
        $timeout.cancel(timeoutPromise);
      }
      timeoutPromise = $timeout(function () {
        callback.apply(self, args);
      }, debounceTime);
    };
  };
}]);
angular.module('ui.bootstrap.dropdown', ['ui.bootstrap.position']).constant('uibDropdownConfig', {
  appendToOpenClass: 'uib-dropdown-open',
  openClass: 'open'
}).service('uibDropdownService', ['$document', '$rootScope', function ($document, $rootScope) {
  var openScope = null;
  this.open = function (dropdownScope) {
    if (!openScope) {
      $document.on('click', closeDropdown);
      $document.on('keydown', keybindFilter);
    }
    if (openScope && openScope !== dropdownScope) {
      openScope.isOpen = false;
    }
    openScope = dropdownScope;
  };
  this.close = function (dropdownScope) {
    if (openScope === dropdownScope) {
      openScope = null;
      $document.off('click', closeDropdown);
      $document.off('keydown', keybindFilter);
    }
  };
  var closeDropdown = function closeDropdown(evt) {
    // This method may still be called during the same mouse event that
    // unbound this event handler. So check openScope before proceeding.
    if (!openScope) {
      return;
    }
    if (evt && openScope.getAutoClose() === 'disabled') {
      return;
    }
    if (evt && evt.which === 3) {
      return;
    }
    var toggleElement = openScope.getToggleElement();
    if (evt && toggleElement && toggleElement[0].contains(evt.target)) {
      return;
    }
    var dropdownElement = openScope.getDropdownElement();
    if (evt && openScope.getAutoClose() === 'outsideClick' && dropdownElement && dropdownElement[0].contains(evt.target)) {
      return;
    }
    openScope.isOpen = false;
    if (!$rootScope.$$phase) {
      openScope.$apply();
    }
  };
  var keybindFilter = function keybindFilter(evt) {
    if (evt.which === 27) {
      openScope.focusToggleElement();
      closeDropdown();
    } else if (openScope.isKeynavEnabled() && [38, 40].indexOf(evt.which) !== -1 && openScope.isOpen) {
      evt.preventDefault();
      evt.stopPropagation();
      openScope.focusDropdownEntry(evt.which);
    }
  };
}]).controller('UibDropdownController', ['$scope', '$element', '$attrs', '$parse', 'uibDropdownConfig', 'uibDropdownService', '$animate', '$uibPosition', '$document', '$compile', '$templateRequest', function ($scope, $element, $attrs, $parse, dropdownConfig, uibDropdownService, $animate, $position, $document, $compile, $templateRequest) {
  var self = this,
    scope = $scope.$new(),
    // create a child scope so we are not polluting original one
    templateScope,
    appendToOpenClass = dropdownConfig.appendToOpenClass,
    openClass = dropdownConfig.openClass,
    getIsOpen,
    setIsOpen = angular.noop,
    toggleInvoker = $attrs.onToggle ? $parse($attrs.onToggle) : angular.noop,
    appendToBody = false,
    appendTo = null,
    keynavEnabled = false,
    selectedOption = null,
    body = $document.find('body');
  $element.addClass('dropdown');
  this.init = function () {
    if ($attrs.isOpen) {
      getIsOpen = $parse($attrs.isOpen);
      setIsOpen = getIsOpen.assign;
      $scope.$watch(getIsOpen, function (value) {
        scope.isOpen = !!value;
      });
    }
    if (angular.isDefined($attrs.dropdownAppendTo)) {
      var appendToEl = $parse($attrs.dropdownAppendTo)(scope);
      if (appendToEl) {
        appendTo = angular.element(appendToEl);
      }
    }
    appendToBody = angular.isDefined($attrs.dropdownAppendToBody);
    keynavEnabled = angular.isDefined($attrs.keyboardNav);
    if (appendToBody && !appendTo) {
      appendTo = body;
    }
    if (appendTo && self.dropdownMenu) {
      appendTo.append(self.dropdownMenu);
      $element.on('$destroy', function handleDestroyEvent() {
        self.dropdownMenu.remove();
      });
    }
  };
  this.toggle = function (open) {
    return scope.isOpen = arguments.length ? !!open : !scope.isOpen;
  };

  // Allow other directives to watch status
  this.isOpen = function () {
    return scope.isOpen;
  };
  scope.getToggleElement = function () {
    return self.toggleElement;
  };
  scope.getAutoClose = function () {
    return $attrs.autoClose || 'always'; //or 'outsideClick' or 'disabled'
  };
  scope.getElement = function () {
    return $element;
  };
  scope.isKeynavEnabled = function () {
    return keynavEnabled;
  };
  scope.focusDropdownEntry = function (keyCode) {
    var elems = self.dropdownMenu ?
    //If append to body is used.
    angular.element(self.dropdownMenu).find('a') : $element.find('ul').eq(0).find('a');
    switch (keyCode) {
      case 40:
        {
          if (!angular.isNumber(self.selectedOption)) {
            self.selectedOption = 0;
          } else {
            self.selectedOption = self.selectedOption === elems.length - 1 ? self.selectedOption : self.selectedOption + 1;
          }
          break;
        }
      case 38:
        {
          if (!angular.isNumber(self.selectedOption)) {
            self.selectedOption = elems.length - 1;
          } else {
            self.selectedOption = self.selectedOption === 0 ? 0 : self.selectedOption - 1;
          }
          break;
        }
    }
    elems[self.selectedOption].focus();
  };
  scope.getDropdownElement = function () {
    return self.dropdownMenu;
  };
  scope.focusToggleElement = function () {
    if (self.toggleElement) {
      self.toggleElement[0].focus();
    }
  };
  scope.$watch('isOpen', function (isOpen, wasOpen) {
    if (appendTo && self.dropdownMenu) {
      var pos = $position.positionElements($element, self.dropdownMenu, 'bottom-left', true),
        css,
        rightalign;
      css = {
        top: pos.top + 'px',
        display: isOpen ? 'block' : 'none'
      };
      rightalign = self.dropdownMenu.hasClass('dropdown-menu-right');
      if (!rightalign) {
        css.left = pos.left + 'px';
        css.right = 'auto';
      } else {
        css.left = 'auto';
        css.right = window.innerWidth - (pos.left + $element.prop('offsetWidth')) + 'px';
      }

      // Need to adjust our positioning to be relative to the appendTo container
      // if it's not the body element
      if (!appendToBody) {
        var appendOffset = $position.offset(appendTo);
        css.top = pos.top - appendOffset.top + 'px';
        if (!rightalign) {
          css.left = pos.left - appendOffset.left + 'px';
        } else {
          css.right = window.innerWidth - (pos.left - appendOffset.left + $element.prop('offsetWidth')) + 'px';
        }
      }
      self.dropdownMenu.css(css);
    }
    var openContainer = appendTo ? appendTo : $element;
    $animate[isOpen ? 'addClass' : 'removeClass'](openContainer, appendTo ? appendToOpenClass : openClass).then(function () {
      if (angular.isDefined(isOpen) && isOpen !== wasOpen) {
        toggleInvoker($scope, {
          open: !!isOpen
        });
      }
    });
    if (isOpen) {
      if (self.dropdownMenuTemplateUrl) {
        $templateRequest(self.dropdownMenuTemplateUrl).then(function (tplContent) {
          templateScope = scope.$new();
          $compile(tplContent.trim())(templateScope, function (dropdownElement) {
            var newEl = dropdownElement;
            self.dropdownMenu.replaceWith(newEl);
            self.dropdownMenu = newEl;
          });
        });
      }
      scope.focusToggleElement();
      uibDropdownService.open(scope);
    } else {
      if (self.dropdownMenuTemplateUrl) {
        if (templateScope) {
          templateScope.$destroy();
        }
        var newEl = angular.element('<ul class="dropdown-menu"></ul>');
        self.dropdownMenu.replaceWith(newEl);
        self.dropdownMenu = newEl;
      }
      uibDropdownService.close(scope);
      self.selectedOption = null;
    }
    if (angular.isFunction(setIsOpen)) {
      setIsOpen($scope, isOpen);
    }
  });
  $scope.$on('$locationChangeSuccess', function () {
    if (scope.getAutoClose() !== 'disabled') {
      scope.isOpen = false;
    }
  });
}]).directive('uibDropdown', function () {
  return {
    controller: 'UibDropdownController',
    link: function link(scope, element, attrs, dropdownCtrl) {
      dropdownCtrl.init();
    }
  };
}).directive('uibDropdownMenu', function () {
  return {
    restrict: 'A',
    require: '?^uibDropdown',
    link: function link(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl || angular.isDefined(attrs.dropdownNested)) {
        return;
      }
      element.addClass('dropdown-menu');
      var tplUrl = attrs.templateUrl;
      if (tplUrl) {
        dropdownCtrl.dropdownMenuTemplateUrl = tplUrl;
      }
      if (!dropdownCtrl.dropdownMenu) {
        dropdownCtrl.dropdownMenu = element;
      }
    }
  };
}).directive('uibDropdownToggle', function () {
  return {
    require: '?^uibDropdown',
    link: function link(scope, element, attrs, dropdownCtrl) {
      if (!dropdownCtrl) {
        return;
      }
      element.addClass('dropdown-toggle');
      dropdownCtrl.toggleElement = element;
      var toggleDropdown = function toggleDropdown(event) {
        event.preventDefault();
        if (!element.hasClass('disabled') && !attrs.disabled) {
          scope.$apply(function () {
            dropdownCtrl.toggle();
          });
        }
      };
      element.bind('click', toggleDropdown);

      // WAI-ARIA
      element.attr({
        'aria-haspopup': true,
        'aria-expanded': false
      });
      scope.$watch(dropdownCtrl.isOpen, function (isOpen) {
        element.attr('aria-expanded', !!isOpen);
      });
      scope.$on('$destroy', function () {
        element.unbind('click', toggleDropdown);
      });
    }
  };
});
angular.module('ui.bootstrap.stackedMap', [])
/**
 * A helper, internal data structure that acts as a map but also allows getting / removing
 * elements in the LIFO order
 */.factory('$$stackedMap', function () {
  return {
    createNew: function createNew() {
      var stack = [];
      return {
        add: function add(key, value) {
          stack.push({
            key: key,
            value: value
          });
        },
        get: function get(key) {
          for (var i = 0; i < stack.length; i++) {
            if (key === stack[i].key) {
              return stack[i];
            }
          }
        },
        keys: function keys() {
          var keys = [];
          for (var i = 0; i < stack.length; i++) {
            keys.push(stack[i].key);
          }
          return keys;
        },
        top: function top() {
          return stack[stack.length - 1];
        },
        remove: function remove(key) {
          var idx = -1;
          for (var i = 0; i < stack.length; i++) {
            if (key === stack[i].key) {
              idx = i;
              break;
            }
          }
          return stack.splice(idx, 1)[0];
        },
        removeTop: function removeTop() {
          return stack.splice(stack.length - 1, 1)[0];
        },
        length: function length() {
          return stack.length;
        }
      };
    }
  };
});
angular.module('ui.bootstrap.modal', ['ui.bootstrap.stackedMap'])
/**
 * A helper, internal data structure that stores all references attached to key
 */.factory('$$multiMap', function () {
  return {
    createNew: function createNew() {
      var map = {};
      return {
        entries: function entries() {
          return Object.keys(map).map(function (key) {
            return {
              key: key,
              value: map[key]
            };
          });
        },
        get: function get(key) {
          return map[key];
        },
        hasKey: function hasKey(key) {
          return !!map[key];
        },
        keys: function keys() {
          return Object.keys(map);
        },
        put: function put(key, value) {
          if (!map[key]) {
            map[key] = [];
          }
          map[key].push(value);
        },
        remove: function remove(key, value) {
          var values = map[key];
          if (!values) {
            return;
          }
          var idx = values.indexOf(value);
          if (idx !== -1) {
            values.splice(idx, 1);
          }
          if (!values.length) {
            delete map[key];
          }
        }
      };
    }
  };
})

/**
 * Pluggable resolve mechanism for the modal resolve resolution
 * Supports UI Router's $resolve service
 */.provider('$uibResolve', function () {
  var resolve = this;
  this.resolver = null;
  this.setResolver = function (resolver) {
    this.resolver = resolver;
  };
  this.$get = ['$injector', '$q', function ($injector, $q) {
    var resolver = resolve.resolver ? $injector.get(resolve.resolver) : null;
    return {
      resolve: function resolve(invocables, locals, parent, self) {
        if (resolver) {
          return resolver.resolve(invocables, locals, parent, self);
        }
        var promises = [];
        angular.forEach(invocables, function (value) {
          if (angular.isFunction(value) || angular.isArray(value)) {
            promises.push($q.resolve($injector.invoke(value)));
          } else if (angular.isString(value)) {
            promises.push($q.resolve($injector.get(value)));
          } else {
            promises.push($q.resolve(value));
          }
        });
        return $q.all(promises).then(function (resolves) {
          var resolveObj = {};
          var resolveIter = 0;
          angular.forEach(invocables, function (value, key) {
            resolveObj[key] = resolves[resolveIter++];
          });
          return resolveObj;
        });
      }
    };
  }];
})

/**
 * A helper directive for the $modal service. It creates a backdrop element.
 */.directive('uibModalBackdrop', ['$animateCss', '$injector', '$uibModalStack', function ($animateCss, $injector, $modalStack) {
  return {
    replace: true,
    templateUrl: 'uib/template/modal/backdrop.html',
    compile: function compile(tElement, tAttrs) {
      tElement.addClass(tAttrs.backdropClass);
      return linkFn;
    }
  };
  function linkFn(scope, element, attrs) {
    if (attrs.modalInClass) {
      $animateCss(element, {
        addClass: attrs.modalInClass
      }).start();
      scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
        var done = setIsAsync();
        if (scope.modalOptions.animation) {
          $animateCss(element, {
            removeClass: attrs.modalInClass
          }).start().then(done);
        } else {
          done();
        }
      });
    }
  }
}]).directive('uibModalWindow', ['$uibModalStack', '$q', '$animate', '$animateCss', '$document', function ($modalStack, $q, $animate, $animateCss, $document) {
  return {
    scope: {
      index: '@'
    },
    replace: true,
    transclude: true,
    templateUrl: function templateUrl(tElement, tAttrs) {
      return tAttrs.templateUrl || 'uib/template/modal/window.html';
    },
    link: function link(scope, element, attrs) {
      element.addClass(attrs.windowClass || '');
      element.addClass(attrs.windowTopClass || '');
      scope.size = attrs.size;
      scope.close = function (evt) {
        var modal = $modalStack.getTop();
        if (modal && modal.value.backdrop && modal.value.backdrop !== 'static' && evt.target === evt.currentTarget) {
          evt.preventDefault();
          evt.stopPropagation();
          $modalStack.dismiss(modal.key, 'backdrop click');
        }
      };

      // moved from template to fix issue #2280
      element.on('click', scope.close);

      // This property is only added to the scope for the purpose of detecting when this directive is rendered.
      // We can detect that by using this property in the template associated with this directive and then use
      // {@link Attribute#$observe} on it. For more details please see {@link TableColumnResize}.
      scope.$isRendered = true;

      // Deferred object that will be resolved when this modal is render.
      var modalRenderDeferObj = $q.defer();
      // Observe function will be called on next digest cycle after compilation, ensuring that the DOM is ready.
      // In order to use this way of finding whether DOM is ready, we need to observe a scope property used in modal's template.
      attrs.$observe('modalRender', function (value) {
        if (value === 'true') {
          modalRenderDeferObj.resolve();
        }
      });
      modalRenderDeferObj.promise.then(function () {
        var animationPromise = null;
        if (attrs.modalInClass) {
          animationPromise = $animateCss(element, {
            addClass: attrs.modalInClass
          }).start();
          scope.$on($modalStack.NOW_CLOSING_EVENT, function (e, setIsAsync) {
            var done = setIsAsync();
            if ($animateCss) {
              $animateCss(element, {
                removeClass: attrs.modalInClass
              }).start().then(done);
            } else {
              $animate.removeClass(element, attrs.modalInClass).then(done);
            }
          });
        }
        $q.when(animationPromise).then(function () {
          /**
           * If something within the freshly-opened modal already has focus (perhaps via a
           * directive that causes focus). then no need to try and focus anything.
           */
          if (!($document[0].activeElement && element[0].contains($document[0].activeElement))) {
            var inputWithAutofocus = element[0].querySelector('[autofocus]');
            /**
             * Auto-focusing of a freshly-opened modal element causes any child elements
             * with the autofocus attribute to lose focus. This is an issue on touch
             * based devices which will show and then hide the onscreen keyboard.
             * Attempts to refocus the autofocus element via JavaScript will not reopen
             * the onscreen keyboard. Fixed by updated the focusing logic to only autofocus
             * the modal element if the modal does not contain an autofocus element.
             */
            if (inputWithAutofocus) {
              inputWithAutofocus.focus();
            } else {
              element[0].focus();
            }
          }
        });

        // Notify {@link $modalStack} that modal is rendered.
        var modal = $modalStack.getTop();
        if (modal) {
          $modalStack.modalRendered(modal.key);
        }
      });
    }
  };
}]).directive('uibModalAnimationClass', function () {
  return {
    compile: function compile(tElement, tAttrs) {
      if (tAttrs.modalAnimation) {
        tElement.addClass(tAttrs.uibModalAnimationClass);
      }
    }
  };
}).directive('uibModalTransclude', function () {
  return {
    link: function link(scope, element, attrs, controller, transclude) {
      transclude(scope.$parent, function (clone) {
        element.empty();
        element.append(clone);
      });
    }
  };
}).factory('$uibModalStack', ['$animate', '$animateCss', '$document', '$compile', '$rootScope', '$q', '$$multiMap', '$$stackedMap', function ($animate, $animateCss, $document, $compile, $rootScope, $q, $$multiMap, $$stackedMap) {
  var OPENED_MODAL_CLASS = 'modal-open';
  var backdropDomEl, backdropScope;
  var openedWindows = $$stackedMap.createNew();
  var openedClasses = $$multiMap.createNew();
  var $modalStack = {
    NOW_CLOSING_EVENT: 'modal.stack.now-closing'
  };

  //Modal focus behavior
  var focusableElementList;
  var focusIndex = 0;
  var tababbleSelector = 'a[href], area[href], input:not([disabled]), ' + 'button:not([disabled]),select:not([disabled]), textarea:not([disabled]), ' + 'iframe, object, embed, *[tabindex], *[contenteditable=true]';
  function backdropIndex() {
    var topBackdropIndex = -1;
    var opened = openedWindows.keys();
    for (var i = 0; i < opened.length; i++) {
      if (openedWindows.get(opened[i]).value.backdrop) {
        topBackdropIndex = i;
      }
    }
    return topBackdropIndex;
  }
  $rootScope.$watch(backdropIndex, function (newBackdropIndex) {
    if (backdropScope) {
      backdropScope.index = newBackdropIndex;
    }
  });
  function removeModalWindow(modalInstance, elementToReceiveFocus) {
    var modalWindow = openedWindows.get(modalInstance).value;
    var appendToElement = modalWindow.appendTo;

    //clean up the stack
    openedWindows.remove(modalInstance);
    removeAfterAnimate(modalWindow.modalDomEl, modalWindow.modalScope, function () {
      var modalBodyClass = modalWindow.openedClass || OPENED_MODAL_CLASS;
      openedClasses.remove(modalBodyClass, modalInstance);
      appendToElement.toggleClass(modalBodyClass, openedClasses.hasKey(modalBodyClass));
      toggleTopWindowClass(true);
    }, modalWindow.closedDeferred);
    checkRemoveBackdrop();

    //move focus to specified element if available, or else to body
    if (elementToReceiveFocus && elementToReceiveFocus.focus) {
      elementToReceiveFocus.focus();
    } else if (appendToElement.focus) {
      appendToElement.focus();
    }
  }

  // Add or remove "windowTopClass" from the top window in the stack
  function toggleTopWindowClass(toggleSwitch) {
    var modalWindow;
    if (openedWindows.length() > 0) {
      modalWindow = openedWindows.top().value;
      modalWindow.modalDomEl.toggleClass(modalWindow.windowTopClass || '', toggleSwitch);
    }
  }
  function checkRemoveBackdrop() {
    //remove backdrop if no longer needed
    if (backdropDomEl && backdropIndex() === -1) {
      var backdropScopeRef = backdropScope;
      removeAfterAnimate(backdropDomEl, backdropScope, function () {
        backdropScopeRef = null;
      });
      backdropDomEl = undefined;
      backdropScope = undefined;
    }
  }
  function removeAfterAnimate(domEl, scope, done, closedDeferred) {
    var asyncDeferred;
    var asyncPromise = null;
    var setIsAsync = function setIsAsync() {
      if (!asyncDeferred) {
        asyncDeferred = $q.defer();
        asyncPromise = asyncDeferred.promise;
      }
      return function asyncDone() {
        asyncDeferred.resolve();
      };
    };
    scope.$broadcast($modalStack.NOW_CLOSING_EVENT, setIsAsync);

    // Note that it's intentional that asyncPromise might be null.
    // That's when setIsAsync has not been called during the
    // NOW_CLOSING_EVENT broadcast.
    return $q.when(asyncPromise).then(afterAnimating);
    function afterAnimating() {
      if (afterAnimating.done) {
        return;
      }
      afterAnimating.done = true;
      $animateCss(domEl, {
        event: 'leave'
      }).start().then(function () {
        domEl.remove();
        if (closedDeferred) {
          closedDeferred.resolve();
        }
      });
      scope.$destroy();
      if (done) {
        done();
      }
    }
  }
  $document.on('keydown', keydownListener);
  $rootScope.$on('$destroy', function () {
    $document.off('keydown', keydownListener);
  });
  function keydownListener(evt) {
    if (evt.isDefaultPrevented()) {
      return evt;
    }
    var modal = openedWindows.top();
    if (modal) {
      switch (evt.which) {
        case 27:
          {
            if (modal.value.keyboard) {
              evt.preventDefault();
              $rootScope.$apply(function () {
                $modalStack.dismiss(modal.key, 'escape key press');
              });
            }
            break;
          }
        case 9:
          {
            $modalStack.loadFocusElementList(modal);
            var focusChanged = false;
            if (evt.shiftKey) {
              if ($modalStack.isFocusInFirstItem(evt) || $modalStack.isModalFocused(evt, modal)) {
                focusChanged = $modalStack.focusLastFocusableElement();
              }
            } else {
              if ($modalStack.isFocusInLastItem(evt)) {
                focusChanged = $modalStack.focusFirstFocusableElement();
              }
            }
            if (focusChanged) {
              evt.preventDefault();
              evt.stopPropagation();
            }
            break;
          }
      }
    }
  }
  $modalStack.open = function (modalInstance, modal) {
    var modalOpener = $document[0].activeElement,
      modalBodyClass = modal.openedClass || OPENED_MODAL_CLASS;
    toggleTopWindowClass(false);
    openedWindows.add(modalInstance, {
      deferred: modal.deferred,
      renderDeferred: modal.renderDeferred,
      closedDeferred: modal.closedDeferred,
      modalScope: modal.scope,
      backdrop: modal.backdrop,
      keyboard: modal.keyboard,
      openedClass: modal.openedClass,
      windowTopClass: modal.windowTopClass,
      animation: modal.animation,
      appendTo: modal.appendTo
    });
    openedClasses.put(modalBodyClass, modalInstance);
    var appendToElement = modal.appendTo,
      currBackdropIndex = backdropIndex();
    if (!appendToElement.length) {
      throw new Error('appendTo element not found. Make sure that the element passed is in DOM.');
    }
    if (currBackdropIndex >= 0 && !backdropDomEl) {
      backdropScope = $rootScope.$new(true);
      backdropScope.modalOptions = modal;
      backdropScope.index = currBackdropIndex;
      backdropDomEl = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>');
      backdropDomEl.attr('backdrop-class', modal.backdropClass);
      if (modal.animation) {
        backdropDomEl.attr('modal-animation', 'true');
      }
      $compile(backdropDomEl)(backdropScope);
      $animate.enter(backdropDomEl, appendToElement);
    }
    var angularDomEl = angular.element('<div uib-modal-window="modal-window"></div>');
    angularDomEl.attr({
      'template-url': modal.windowTemplateUrl,
      'window-class': modal.windowClass,
      'window-top-class': modal.windowTopClass,
      'size': modal.size,
      'index': openedWindows.length() - 1,
      'animate': 'animate'
    }).html(modal.content);
    if (modal.animation) {
      angularDomEl.attr('modal-animation', 'true');
    }
    $animate.enter($compile(angularDomEl)(modal.scope), appendToElement).then(function () {
      $animate.addClass(appendToElement, modalBodyClass);
    });
    openedWindows.top().value.modalDomEl = angularDomEl;
    openedWindows.top().value.modalOpener = modalOpener;
    $modalStack.clearFocusListCache();
  };
  function broadcastClosing(modalWindow, resultOrReason, closing) {
    return !modalWindow.value.modalScope.$broadcast('modal.closing', resultOrReason, closing).defaultPrevented;
  }
  $modalStack.close = function (modalInstance, result) {
    var modalWindow = openedWindows.get(modalInstance);
    if (modalWindow && broadcastClosing(modalWindow, result, true)) {
      modalWindow.value.modalScope.$$uibDestructionScheduled = true;
      modalWindow.value.deferred.resolve(result);
      removeModalWindow(modalInstance, modalWindow.value.modalOpener);
      return true;
    }
    return !modalWindow;
  };
  $modalStack.dismiss = function (modalInstance, reason) {
    var modalWindow = openedWindows.get(modalInstance);
    if (modalWindow && broadcastClosing(modalWindow, reason, false)) {
      modalWindow.value.modalScope.$$uibDestructionScheduled = true;
      modalWindow.value.deferred.reject(reason);
      removeModalWindow(modalInstance, modalWindow.value.modalOpener);
      return true;
    }
    return !modalWindow;
  };
  $modalStack.dismissAll = function (reason) {
    var topModal = this.getTop();
    while (topModal && this.dismiss(topModal.key, reason)) {
      topModal = this.getTop();
    }
  };
  $modalStack.getTop = function () {
    return openedWindows.top();
  };
  $modalStack.modalRendered = function (modalInstance) {
    var modalWindow = openedWindows.get(modalInstance);
    if (modalWindow) {
      modalWindow.value.renderDeferred.resolve();
    }
  };
  $modalStack.focusFirstFocusableElement = function () {
    if (focusableElementList.length > 0) {
      focusableElementList[0].focus();
      return true;
    }
    return false;
  };
  $modalStack.focusLastFocusableElement = function () {
    if (focusableElementList.length > 0) {
      focusableElementList[focusableElementList.length - 1].focus();
      return true;
    }
    return false;
  };
  $modalStack.isModalFocused = function (evt, modalWindow) {
    if (evt && modalWindow) {
      var modalDomEl = modalWindow.value.modalDomEl;
      if (modalDomEl && modalDomEl.length) {
        return (evt.target || evt.srcElement) === modalDomEl[0];
      }
    }
    return false;
  };
  $modalStack.isFocusInFirstItem = function (evt) {
    if (focusableElementList.length > 0) {
      return (evt.target || evt.srcElement) === focusableElementList[0];
    }
    return false;
  };
  $modalStack.isFocusInLastItem = function (evt) {
    if (focusableElementList.length > 0) {
      return (evt.target || evt.srcElement) === focusableElementList[focusableElementList.length - 1];
    }
    return false;
  };
  $modalStack.clearFocusListCache = function () {
    focusableElementList = [];
    focusIndex = 0;
  };
  $modalStack.loadFocusElementList = function (modalWindow) {
    if (focusableElementList === undefined || !focusableElementList.length) {
      if (modalWindow) {
        var modalDomE1 = modalWindow.value.modalDomEl;
        if (modalDomE1 && modalDomE1.length) {
          focusableElementList = modalDomE1[0].querySelectorAll(tababbleSelector);
        }
      }
    }
  };
  return $modalStack;
}]).provider('$uibModal', function () {
  var $modalProvider = {
    options: {
      animation: true,
      backdrop: true,
      //can also be false or 'static'
      keyboard: true
    },
    $get: ['$rootScope', '$q', '$document', '$templateRequest', '$controller', '$uibResolve', '$uibModalStack', function ($rootScope, $q, $document, $templateRequest, $controller, $uibResolve, $modalStack) {
      var $modal = {};
      function getTemplatePromise(options) {
        return options.template ? $q.when(options.template) : $templateRequest(angular.isFunction(options.templateUrl) ? options.templateUrl() : options.templateUrl);
      }
      var promiseChain = null;
      $modal.getPromiseChain = function () {
        return promiseChain;
      };
      $modal.open = function (modalOptions) {
        var modalResultDeferred = $q.defer();
        var modalOpenedDeferred = $q.defer();
        var modalClosedDeferred = $q.defer();
        var modalRenderDeferred = $q.defer();

        //prepare an instance of a modal to be injected into controllers and returned to a caller
        var modalInstance = {
          result: modalResultDeferred.promise,
          opened: modalOpenedDeferred.promise,
          closed: modalClosedDeferred.promise,
          rendered: modalRenderDeferred.promise,
          close: function close(result) {
            return $modalStack.close(modalInstance, result);
          },
          dismiss: function dismiss(reason) {
            return $modalStack.dismiss(modalInstance, reason);
          }
        };

        //merge and clean up options
        modalOptions = angular.extend({}, $modalProvider.options, modalOptions);
        modalOptions.resolve = modalOptions.resolve || {};
        modalOptions.appendTo = modalOptions.appendTo || $document.find('body').eq(0);

        //verify options
        if (!modalOptions.template && !modalOptions.templateUrl) {
          throw new Error('One of template or templateUrl options is required.');
        }
        var templateAndResolvePromise = $q.all([getTemplatePromise(modalOptions), $uibResolve.resolve(modalOptions.resolve, {}, null, null)]);
        function resolveWithTemplate() {
          return templateAndResolvePromise;
        }

        // Wait for the resolution of the existing promise chain.
        // Then switch to our own combined promise dependency (regardless of how the previous modal fared).
        // Then add to $modalStack and resolve opened.
        // Finally clean up the chain variable if no subsequent modal has overwritten it.
        var samePromise;
        samePromise = promiseChain = $q.all([promiseChain]).then(resolveWithTemplate, resolveWithTemplate).then(function resolveSuccess(tplAndVars) {
          var providedScope = modalOptions.scope || $rootScope;
          var modalScope = providedScope.$new();
          modalScope.$close = modalInstance.close;
          modalScope.$dismiss = modalInstance.dismiss;
          modalScope.$on('$destroy', function () {
            if (!modalScope.$$uibDestructionScheduled) {
              modalScope.$dismiss('$uibUnscheduledDestruction');
            }
          });
          var ctrlInstance,
            ctrlLocals = {};

          //controllers
          if (modalOptions.controller) {
            ctrlLocals.$scope = modalScope;
            ctrlLocals.$uibModalInstance = modalInstance;
            angular.forEach(tplAndVars[1], function (value, key) {
              ctrlLocals[key] = value;
            });
            ctrlInstance = $controller(modalOptions.controller, ctrlLocals);
            if (modalOptions.controllerAs) {
              if (modalOptions.bindToController) {
                ctrlInstance.$close = modalScope.$close;
                ctrlInstance.$dismiss = modalScope.$dismiss;
                angular.extend(ctrlInstance, providedScope);
              }
              modalScope[modalOptions.controllerAs] = ctrlInstance;
            }
          }
          $modalStack.open(modalInstance, {
            scope: modalScope,
            deferred: modalResultDeferred,
            renderDeferred: modalRenderDeferred,
            closedDeferred: modalClosedDeferred,
            content: tplAndVars[0],
            animation: modalOptions.animation,
            backdrop: modalOptions.backdrop,
            keyboard: modalOptions.keyboard,
            backdropClass: modalOptions.backdropClass,
            windowTopClass: modalOptions.windowTopClass,
            windowClass: modalOptions.windowClass,
            windowTemplateUrl: modalOptions.windowTemplateUrl,
            size: modalOptions.size,
            openedClass: modalOptions.openedClass,
            appendTo: modalOptions.appendTo
          });
          modalOpenedDeferred.resolve(true);
        }, function resolveError(reason) {
          modalOpenedDeferred.reject(reason);
          modalResultDeferred.reject(reason);
        })['finally'](function () {
          if (promiseChain === samePromise) {
            promiseChain = null;
          }
        });
        return modalInstance;
      };
      return $modal;
    }]
  };
  return $modalProvider;
});
angular.module('ui.bootstrap.paging', [])
/**
 * Helper internal service for generating common controller code between the
 * pager and pagination components
 */.factory('uibPaging', ['$parse', function ($parse) {
  return {
    create: function create(ctrl, $scope, $attrs) {
      ctrl.setNumPages = $attrs.numPages ? $parse($attrs.numPages).assign : angular.noop;
      ctrl.ngModelCtrl = {
        $setViewValue: angular.noop
      }; // nullModelCtrl
      ctrl._watchers = [];
      ctrl.init = function (ngModelCtrl, config) {
        ctrl.ngModelCtrl = ngModelCtrl;
        ctrl.config = config;
        ngModelCtrl.$render = function () {
          ctrl.render();
        };
        if ($attrs.itemsPerPage) {
          ctrl._watchers.push($scope.$parent.$watch($parse($attrs.itemsPerPage), function (value) {
            ctrl.itemsPerPage = parseInt(value, 10);
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }));
        } else {
          ctrl.itemsPerPage = config.itemsPerPage;
        }
        $scope.$watch('totalItems', function (newTotal, oldTotal) {
          if (angular.isDefined(newTotal) || newTotal !== oldTotal) {
            $scope.totalPages = ctrl.calculateTotalPages();
            ctrl.updatePage();
          }
        });
      };
      ctrl.calculateTotalPages = function () {
        var totalPages = ctrl.itemsPerPage < 1 ? 1 : Math.ceil($scope.totalItems / ctrl.itemsPerPage);
        return Math.max(totalPages || 0, 1);
      };
      ctrl.render = function () {
        $scope.page = parseInt(ctrl.ngModelCtrl.$viewValue, 10) || 1;
      };
      $scope.selectPage = function (page, evt) {
        if (evt) {
          evt.preventDefault();
        }
        var clickAllowed = !$scope.ngDisabled || !evt;
        if (clickAllowed && $scope.page !== page && page > 0 && page <= $scope.totalPages) {
          if (evt && evt.target) {
            evt.target.blur();
          }
          ctrl.ngModelCtrl.$setViewValue(page);
          ctrl.ngModelCtrl.$render();
        }
      };
      $scope.getText = function (key) {
        return $scope[key + 'Text'] || ctrl.config[key + 'Text'];
      };
      $scope.noPrevious = function () {
        return $scope.page === 1;
      };
      $scope.noNext = function () {
        return $scope.page === $scope.totalPages;
      };
      ctrl.updatePage = function () {
        ctrl.setNumPages($scope.$parent, $scope.totalPages); // Readonly variable

        if ($scope.page > $scope.totalPages) {
          $scope.selectPage($scope.totalPages);
        } else {
          ctrl.ngModelCtrl.$render();
        }
      };
      $scope.$on('$destroy', function () {
        while (ctrl._watchers.length) {
          ctrl._watchers.shift()();
        }
      });
    }
  };
}]);
angular.module('ui.bootstrap.pager', ['ui.bootstrap.paging']).controller('UibPagerController', ['$scope', '$attrs', 'uibPaging', 'uibPagerConfig', function ($scope, $attrs, uibPaging, uibPagerConfig) {
  $scope.align = angular.isDefined($attrs.align) ? $scope.$parent.$eval($attrs.align) : uibPagerConfig.align;
  uibPaging.create(this, $scope, $attrs);
}]).constant('uibPagerConfig', {
  itemsPerPage: 10,
  previousText: '« Previous',
  nextText: 'Next »',
  align: true
}).directive('uibPager', ['uibPagerConfig', function (uibPagerConfig) {
  return {
    scope: {
      totalItems: '=',
      previousText: '@',
      nextText: '@',
      ngDisabled: '='
    },
    require: ['uibPager', '?ngModel'],
    controller: 'UibPagerController',
    controllerAs: 'pager',
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/pager/pager.html';
    },
    replace: true,
    link: function link(scope, element, attrs, ctrls) {
      var paginationCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }
      paginationCtrl.init(ngModelCtrl, uibPagerConfig);
    }
  };
}]);
angular.module('ui.bootstrap.pagination', ['ui.bootstrap.paging']).controller('UibPaginationController', ['$scope', '$attrs', '$parse', 'uibPaging', 'uibPaginationConfig', function ($scope, $attrs, $parse, uibPaging, uibPaginationConfig) {
  var ctrl = this;
  // Setup configuration parameters
  var maxSize = angular.isDefined($attrs.maxSize) ? $scope.$parent.$eval($attrs.maxSize) : uibPaginationConfig.maxSize,
    rotate = angular.isDefined($attrs.rotate) ? $scope.$parent.$eval($attrs.rotate) : uibPaginationConfig.rotate,
    forceEllipses = angular.isDefined($attrs.forceEllipses) ? $scope.$parent.$eval($attrs.forceEllipses) : uibPaginationConfig.forceEllipses,
    boundaryLinkNumbers = angular.isDefined($attrs.boundaryLinkNumbers) ? $scope.$parent.$eval($attrs.boundaryLinkNumbers) : uibPaginationConfig.boundaryLinkNumbers;
  $scope.boundaryLinks = angular.isDefined($attrs.boundaryLinks) ? $scope.$parent.$eval($attrs.boundaryLinks) : uibPaginationConfig.boundaryLinks;
  $scope.directionLinks = angular.isDefined($attrs.directionLinks) ? $scope.$parent.$eval($attrs.directionLinks) : uibPaginationConfig.directionLinks;
  uibPaging.create(this, $scope, $attrs);
  if ($attrs.maxSize) {
    ctrl._watchers.push($scope.$parent.$watch($parse($attrs.maxSize), function (value) {
      maxSize = parseInt(value, 10);
      ctrl.render();
    }));
  }

  // Create page object used in template
  function makePage(number, text, isActive) {
    return {
      number: number,
      text: text,
      active: isActive
    };
  }
  function getPages(currentPage, totalPages) {
    var pages = [];

    // Default page limits
    var startPage = 1,
      endPage = totalPages;
    var isMaxSized = angular.isDefined(maxSize) && maxSize < totalPages;

    // recompute if maxSize
    if (isMaxSized) {
      if (rotate) {
        // Current page is displayed in the middle of the visible ones
        startPage = Math.max(currentPage - Math.floor(maxSize / 2), 1);
        endPage = startPage + maxSize - 1;

        // Adjust if limit is exceeded
        if (endPage > totalPages) {
          endPage = totalPages;
          startPage = endPage - maxSize + 1;
        }
      } else {
        // Visible pages are paginated with maxSize
        startPage = (Math.ceil(currentPage / maxSize) - 1) * maxSize + 1;

        // Adjust last page if limit is exceeded
        endPage = Math.min(startPage + maxSize - 1, totalPages);
      }
    }

    // Add page number links
    for (var number = startPage; number <= endPage; number++) {
      var page = makePage(number, number, number === currentPage);
      pages.push(page);
    }

    // Add links to move between page sets
    if (isMaxSized && maxSize > 0 && (!rotate || forceEllipses || boundaryLinkNumbers)) {
      if (startPage > 1) {
        if (!boundaryLinkNumbers || startPage > 3) {
          //need ellipsis for all options unless range is too close to beginning
          var previousPageSet = makePage(startPage - 1, '...', false);
          pages.unshift(previousPageSet);
        }
        if (boundaryLinkNumbers) {
          if (startPage === 3) {
            //need to replace ellipsis when the buttons would be sequential
            var secondPageLink = makePage(2, '2', false);
            pages.unshift(secondPageLink);
          }
          //add the first page
          var firstPageLink = makePage(1, '1', false);
          pages.unshift(firstPageLink);
        }
      }
      if (endPage < totalPages) {
        if (!boundaryLinkNumbers || endPage < totalPages - 2) {
          //need ellipsis for all options unless range is too close to end
          var nextPageSet = makePage(endPage + 1, '...', false);
          pages.push(nextPageSet);
        }
        if (boundaryLinkNumbers) {
          if (endPage === totalPages - 2) {
            //need to replace ellipsis when the buttons would be sequential
            var secondToLastPageLink = makePage(totalPages - 1, totalPages - 1, false);
            pages.push(secondToLastPageLink);
          }
          //add the last page
          var lastPageLink = makePage(totalPages, totalPages, false);
          pages.push(lastPageLink);
        }
      }
    }
    return pages;
  }
  var originalRender = this.render;
  this.render = function () {
    originalRender();
    if ($scope.page > 0 && $scope.page <= $scope.totalPages) {
      $scope.pages = getPages($scope.page, $scope.totalPages);
    }
  };
}]).constant('uibPaginationConfig', {
  itemsPerPage: 10,
  boundaryLinks: false,
  boundaryLinkNumbers: false,
  directionLinks: true,
  firstText: 'First',
  previousText: 'Previous',
  nextText: 'Next',
  lastText: 'Last',
  rotate: true,
  forceEllipses: false
}).directive('uibPagination', ['$parse', 'uibPaginationConfig', function ($parse, uibPaginationConfig) {
  return {
    scope: {
      totalItems: '=',
      firstText: '@',
      previousText: '@',
      nextText: '@',
      lastText: '@',
      ngDisabled: '='
    },
    require: ['uibPagination', '?ngModel'],
    controller: 'UibPaginationController',
    controllerAs: 'pagination',
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || 'uib/template/pagination/pagination.html';
    },
    replace: true,
    link: function link(scope, element, attrs, ctrls) {
      var paginationCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      if (!ngModelCtrl) {
        return; // do nothing if no ng-model
      }
      paginationCtrl.init(ngModelCtrl, uibPaginationConfig);
    }
  };
}]);

/**
 * The following features are still outstanding: animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, html tooltips, and selector delegation.
 */
angular.module('ui.bootstrap.tooltip', ['ui.bootstrap.position', 'ui.bootstrap.stackedMap'])

/**
 * The $tooltip service creates tooltip- and popover-like directives as well as
 * houses global options for them.
 */.provider('$uibTooltip', function () {
  // The default options tooltip and popover.
  var defaultOptions = {
    placement: 'top',
    placementClassPrefix: '',
    animation: true,
    popupDelay: 0,
    popupCloseDelay: 0,
    useContentExp: false
  };

  // Default hide triggers for each show trigger
  var triggerMap = {
    'mouseenter': 'mouseleave',
    'click': 'click',
    'outsideClick': 'outsideClick',
    'focus': 'blur',
    'none': ''
  };

  // The options specified to the provider globally.
  var globalOptions = {};

  /**
   * `options({})` allows global configuration of all tooltips in the
   * application.
   *
   *   var app = angular.module( 'App', ['ui.bootstrap.tooltip'], function( $tooltipProvider ) {
   *     // place tooltips left instead of top by default
   *     $tooltipProvider.options( { placement: 'left' } );
   *   });
   */
  this.options = function (value) {
    angular.extend(globalOptions, value);
  };

  /**
   * This allows you to extend the set of trigger mappings available. E.g.:
   *
   *   $tooltipProvider.setTriggers( 'openTrigger': 'closeTrigger' );
   */
  this.setTriggers = function setTriggers(triggers) {
    angular.extend(triggerMap, triggers);
  };

  /**
   * This is a helper function for translating camel-case to snake_case.
   */
  function snake_case(name) {
    var regexp = /[A-Z]/g;
    var separator = '-';
    return name.replace(regexp, function (letter, pos) {
      return (pos ? separator : '') + letter.toLowerCase();
    });
  }

  /**
   * Returns the actual instance of the $tooltip service.
   * TODO support multiple triggers
   */
  this.$get = ['$window', '$compile', '$timeout', '$document', '$uibPosition', '$interpolate', '$rootScope', '$parse', '$$stackedMap', function ($window, $compile, $timeout, $document, $position, $interpolate, $rootScope, $parse, $$stackedMap) {
    var openedTooltips = $$stackedMap.createNew();
    $document.on('keypress', keypressListener);
    $rootScope.$on('$destroy', function () {
      $document.off('keypress', keypressListener);
    });
    function keypressListener(e) {
      if (e.which === 27) {
        var last = openedTooltips.top();
        if (last) {
          last.value.close();
          openedTooltips.removeTop();
          last = null;
        }
      }
    }
    return function $tooltip(ttType, prefix, defaultTriggerShow, options) {
      options = angular.extend({}, defaultOptions, globalOptions, options);

      /**
       * Returns an object of show and hide triggers.
       *
       * If a trigger is supplied,
       * it is used to show the tooltip; otherwise, it will use the `trigger`
       * option passed to the `$tooltipProvider.options` method; else it will
       * default to the trigger supplied to this directive factory.
       *
       * The hide trigger is based on the show trigger. If the `trigger` option
       * was passed to the `$tooltipProvider.options` method, it will use the
       * mapped trigger from `triggerMap` or the passed trigger if the map is
       * undefined; otherwise, it uses the `triggerMap` value of the show
       * trigger; else it will just use the show trigger.
       */
      function getTriggers(trigger) {
        var show = (trigger || options.trigger || defaultTriggerShow).split(' ');
        var hide = show.map(function (trigger) {
          return triggerMap[trigger] || trigger;
        });
        return {
          show: show,
          hide: hide
        };
      }
      var directiveName = snake_case(ttType);
      var startSym = $interpolate.startSymbol();
      var endSym = $interpolate.endSymbol();
      var template = '<div ' + directiveName + '-popup ' + 'title="' + startSym + 'title' + endSym + '" ' + (options.useContentExp ? 'content-exp="contentExp()" ' : 'content="' + startSym + 'content' + endSym + '" ') + 'placement="' + startSym + 'placement' + endSym + '" ' + 'popup-class="' + startSym + 'popupClass' + endSym + '" ' + 'animation="animation" ' + 'is-open="isOpen"' + 'origin-scope="origScope" ' + 'style="visibility: hidden; display: block; top: -9999px; left: -9999px;"' + '>' + '</div>';
      return {
        compile: function compile(tElem, tAttrs) {
          var tooltipLinker = $compile(template);
          return function link(scope, element, attrs, tooltipCtrl) {
            var tooltip;
            var tooltipLinkedScope;
            var transitionTimeout;
            var showTimeout;
            var hideTimeout;
            var positionTimeout;
            var appendToBody = angular.isDefined(options.appendToBody) ? options.appendToBody : false;
            var triggers = getTriggers(undefined);
            var hasEnableExp = angular.isDefined(attrs[prefix + 'Enable']);
            var ttScope = scope.$new(true);
            var repositionScheduled = false;
            var isOpenParse = angular.isDefined(attrs[prefix + 'IsOpen']) ? $parse(attrs[prefix + 'IsOpen']) : false;
            var contentParse = options.useContentExp ? $parse(attrs[ttType]) : false;
            var observers = [];
            var positionTooltip = function positionTooltip() {
              // check if tooltip exists and is not empty
              if (!tooltip || !tooltip.html()) {
                return;
              }
              if (!positionTimeout) {
                positionTimeout = $timeout(function () {
                  // Reset the positioning.
                  tooltip.css({
                    top: 0,
                    left: 0
                  });

                  // Now set the calculated positioning.
                  var ttPosition = $position.positionElements(element, tooltip, ttScope.placement, appendToBody);
                  tooltip.css({
                    top: ttPosition.top + 'px',
                    left: ttPosition.left + 'px',
                    visibility: 'visible'
                  });

                  // If the placement class is prefixed, still need
                  // to remove the TWBS standard class.
                  if (options.placementClassPrefix) {
                    tooltip.removeClass('top bottom left right');
                  }
                  tooltip.removeClass(options.placementClassPrefix + 'top ' + options.placementClassPrefix + 'top-left ' + options.placementClassPrefix + 'top-right ' + options.placementClassPrefix + 'bottom ' + options.placementClassPrefix + 'bottom-left ' + options.placementClassPrefix + 'bottom-right ' + options.placementClassPrefix + 'left ' + options.placementClassPrefix + 'left-top ' + options.placementClassPrefix + 'left-bottom ' + options.placementClassPrefix + 'right ' + options.placementClassPrefix + 'right-top ' + options.placementClassPrefix + 'right-bottom');
                  var placement = ttPosition.placement.split('-');
                  tooltip.addClass(placement[0] + ' ' + options.placementClassPrefix + ttPosition.placement);
                  $position.positionArrow(tooltip, ttPosition.placement);
                  positionTimeout = null;
                }, 0, false);
              }
            };

            // Set up the correct scope to allow transclusion later
            ttScope.origScope = scope;

            // By default, the tooltip is not open.
            // TODO add ability to start tooltip opened
            ttScope.isOpen = false;
            openedTooltips.add(ttScope, {
              close: hide
            });
            function toggleTooltipBind() {
              if (!ttScope.isOpen) {
                showTooltipBind();
              } else {
                hideTooltipBind();
              }
            }

            // Show the tooltip with delay if specified, otherwise show it immediately
            function showTooltipBind() {
              if (hasEnableExp && !scope.$eval(attrs[prefix + 'Enable'])) {
                return;
              }
              cancelHide();
              prepareTooltip();
              if (ttScope.popupDelay) {
                // Do nothing if the tooltip was already scheduled to pop-up.
                // This happens if show is triggered multiple times before any hide is triggered.
                if (!showTimeout) {
                  showTimeout = $timeout(show, ttScope.popupDelay, false);
                }
              } else {
                show();
              }
            }
            function hideTooltipBind() {
              cancelShow();
              if (ttScope.popupCloseDelay) {
                if (!hideTimeout) {
                  hideTimeout = $timeout(hide, ttScope.popupCloseDelay, false);
                }
              } else {
                hide();
              }
            }

            // Show the tooltip popup element.
            function show() {
              cancelShow();
              cancelHide();

              // Don't show empty tooltips.
              if (!ttScope.content) {
                return angular.noop;
              }
              createTooltip();

              // And show the tooltip.
              ttScope.$evalAsync(function () {
                ttScope.isOpen = true;
                assignIsOpen(true);
                positionTooltip();
              });
            }
            function cancelShow() {
              if (showTimeout) {
                $timeout.cancel(showTimeout);
                showTimeout = null;
              }
              if (positionTimeout) {
                $timeout.cancel(positionTimeout);
                positionTimeout = null;
              }
            }

            // Hide the tooltip popup element.
            function hide() {
              if (!ttScope) {
                return;
              }

              // First things first: we don't show it anymore.
              ttScope.$evalAsync(function () {
                if (ttScope) {
                  ttScope.isOpen = false;
                  assignIsOpen(false);
                  // And now we remove it from the DOM. However, if we have animation, we
                  // need to wait for it to expire beforehand.
                  // FIXME: this is a placeholder for a port of the transitions library.
                  // The fade transition in TWBS is 150ms.
                  if (ttScope.animation) {
                    if (!transitionTimeout) {
                      transitionTimeout = $timeout(removeTooltip, 150, false);
                    }
                  } else {
                    removeTooltip();
                  }
                }
              });
            }
            function cancelHide() {
              if (hideTimeout) {
                $timeout.cancel(hideTimeout);
                hideTimeout = null;
              }
              if (transitionTimeout) {
                $timeout.cancel(transitionTimeout);
                transitionTimeout = null;
              }
            }
            function createTooltip() {
              // There can only be one tooltip element per directive shown at once.
              if (tooltip) {
                return;
              }
              tooltipLinkedScope = ttScope.$new();
              tooltip = tooltipLinker(tooltipLinkedScope, function (tooltip) {
                if (appendToBody) {
                  $document.find('body').append(tooltip);
                } else {
                  element.after(tooltip);
                }
              });
              prepObservers();
            }
            function removeTooltip() {
              cancelShow();
              cancelHide();
              unregisterObservers();
              if (tooltip) {
                tooltip.remove();
                tooltip = null;
              }
              if (tooltipLinkedScope) {
                tooltipLinkedScope.$destroy();
                tooltipLinkedScope = null;
              }
            }

            /**
             * Set the initial scope values. Once
             * the tooltip is created, the observers
             * will be added to keep things in sync.
             */
            function prepareTooltip() {
              ttScope.title = attrs[prefix + 'Title'];
              if (contentParse) {
                ttScope.content = contentParse(scope);
              } else {
                ttScope.content = attrs[ttType];
              }
              ttScope.popupClass = attrs[prefix + 'Class'];
              ttScope.placement = angular.isDefined(attrs[prefix + 'Placement']) ? attrs[prefix + 'Placement'] : options.placement;
              var delay = parseInt(attrs[prefix + 'PopupDelay'], 10);
              var closeDelay = parseInt(attrs[prefix + 'PopupCloseDelay'], 10);
              ttScope.popupDelay = !isNaN(delay) ? delay : options.popupDelay;
              ttScope.popupCloseDelay = !isNaN(closeDelay) ? closeDelay : options.popupCloseDelay;
            }
            function assignIsOpen(isOpen) {
              if (isOpenParse && angular.isFunction(isOpenParse.assign)) {
                isOpenParse.assign(scope, isOpen);
              }
            }
            ttScope.contentExp = function () {
              return ttScope.content;
            };

            /**
             * Observe the relevant attributes.
             */
            attrs.$observe('disabled', function (val) {
              if (val) {
                cancelShow();
              }
              if (val && ttScope.isOpen) {
                hide();
              }
            });
            if (isOpenParse) {
              scope.$watch(isOpenParse, function (val) {
                if (ttScope && !val === ttScope.isOpen) {
                  toggleTooltipBind();
                }
              });
            }
            function prepObservers() {
              observers.length = 0;
              if (contentParse) {
                observers.push(scope.$watch(contentParse, function (val) {
                  ttScope.content = val;
                  if (!val && ttScope.isOpen) {
                    hide();
                  }
                }));
                observers.push(tooltipLinkedScope.$watch(function () {
                  if (!repositionScheduled) {
                    repositionScheduled = true;
                    tooltipLinkedScope.$$postDigest(function () {
                      repositionScheduled = false;
                      if (ttScope && ttScope.isOpen) {
                        positionTooltip();
                      }
                    });
                  }
                }));
              } else {
                observers.push(attrs.$observe(ttType, function (val) {
                  ttScope.content = val;
                  if (!val && ttScope.isOpen) {
                    hide();
                  } else {
                    positionTooltip();
                  }
                }));
              }
              observers.push(attrs.$observe(prefix + 'Title', function (val) {
                ttScope.title = val;
                if (ttScope.isOpen) {
                  positionTooltip();
                }
              }));
              observers.push(attrs.$observe(prefix + 'Placement', function (val) {
                ttScope.placement = val ? val : options.placement;
                if (ttScope.isOpen) {
                  positionTooltip();
                }
              }));
            }
            function unregisterObservers() {
              if (observers.length) {
                angular.forEach(observers, function (observer) {
                  observer();
                });
                observers.length = 0;
              }
            }

            // hide tooltips/popovers for outsideClick trigger
            function bodyHideTooltipBind(e) {
              if (!ttScope || !ttScope.isOpen || !tooltip) {
                return;
              }
              // make sure the tooltip/popover link or tool tooltip/popover itself were not clicked
              if (!element[0].contains(e.target) && !tooltip[0].contains(e.target)) {
                hideTooltipBind();
              }
            }
            var unregisterTriggers = function unregisterTriggers() {
              triggers.show.forEach(function (trigger) {
                if (trigger === 'outsideClick') {
                  element.off('click', toggleTooltipBind);
                } else {
                  element.off(trigger, showTooltipBind);
                  element.off(trigger, toggleTooltipBind);
                }
              });
              triggers.hide.forEach(function (trigger) {
                if (trigger === 'outsideClick') {
                  $document.off('click', bodyHideTooltipBind);
                } else {
                  element.off(trigger, hideTooltipBind);
                }
              });
            };
            function prepTriggers() {
              var val = attrs[prefix + 'Trigger'];
              unregisterTriggers();
              triggers = getTriggers(val);
              if (triggers.show !== 'none') {
                triggers.show.forEach(function (trigger, idx) {
                  if (trigger === 'outsideClick') {
                    element.on('click', toggleTooltipBind);
                    $document.on('click', bodyHideTooltipBind);
                  } else if (trigger === triggers.hide[idx]) {
                    element.on(trigger, toggleTooltipBind);
                  } else if (trigger) {
                    element.on(trigger, showTooltipBind);
                    element.on(triggers.hide[idx], hideTooltipBind);
                  }
                  element.on('keypress', function (e) {
                    if (e.which === 27) {
                      hideTooltipBind();
                    }
                  });
                });
              }
            }
            prepTriggers();
            var animation = scope.$eval(attrs[prefix + 'Animation']);
            ttScope.animation = angular.isDefined(animation) ? !!animation : options.animation;
            var appendToBodyVal;
            var appendKey = prefix + 'AppendToBody';
            if (appendKey in attrs && attrs[appendKey] === undefined) {
              appendToBodyVal = true;
            } else {
              appendToBodyVal = scope.$eval(attrs[appendKey]);
            }
            appendToBody = angular.isDefined(appendToBodyVal) ? appendToBodyVal : appendToBody;

            // Make sure tooltip is destroyed and removed.
            scope.$on('$destroy', function onDestroyTooltip() {
              unregisterTriggers();
              removeTooltip();
              openedTooltips.remove(ttScope);
              ttScope = null;
            });
          };
        }
      };
    };
  }];
})

// This is mostly ngInclude code but with a custom scope
.directive('uibTooltipTemplateTransclude', ['$animate', '$sce', '$compile', '$templateRequest', function ($animate, $sce, $compile, $templateRequest) {
  return {
    link: function link(scope, elem, attrs) {
      var origScope = scope.$eval(attrs.tooltipTemplateTranscludeScope);
      var changeCounter = 0,
        currentScope,
        previousElement,
        currentElement;
      var cleanupLastIncludeContent = function cleanupLastIncludeContent() {
        if (previousElement) {
          previousElement.remove();
          previousElement = null;
        }
        if (currentScope) {
          currentScope.$destroy();
          currentScope = null;
        }
        if (currentElement) {
          $animate.leave(currentElement).then(function () {
            previousElement = null;
          });
          previousElement = currentElement;
          currentElement = null;
        }
      };
      scope.$watch($sce.parseAsResourceUrl(attrs.uibTooltipTemplateTransclude), function (src) {
        var thisChangeId = ++changeCounter;
        if (src) {
          //set the 2nd param to true to ignore the template request error so that the inner
          //contents and scope can be cleaned up.
          $templateRequest(src, true).then(function (response) {
            if (thisChangeId !== changeCounter) {
              return;
            }
            var newScope = origScope.$new();
            var template = response;
            var clone = $compile(template)(newScope, function (clone) {
              cleanupLastIncludeContent();
              $animate.enter(clone, elem);
            });
            currentScope = newScope;
            currentElement = clone;
            currentScope.$emit('$includeContentLoaded', src);
          }, function () {
            if (thisChangeId === changeCounter) {
              cleanupLastIncludeContent();
              scope.$emit('$includeContentError', src);
            }
          });
          scope.$emit('$includeContentRequested', src);
        } else {
          cleanupLastIncludeContent();
        }
      });
      scope.$on('$destroy', cleanupLastIncludeContent);
    }
  };
}])

/**
 * Note that it's intentional that these classes are *not* applied through $animate.
 * They must not be animated as they're expected to be present on the tooltip on
 * initialization.
 */.directive('uibTooltipClasses', ['$uibPosition', function ($uibPosition) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      // need to set the primary position so the
      // arrow has space during position measure.
      // tooltip.positionTooltip()
      if (scope.placement) {
        // // There are no top-left etc... classes
        // // in TWBS, so we need the primary position.
        var position = $uibPosition.parsePlacement(scope.placement);
        element.addClass(position[0]);
      } else {
        element.addClass('top');
      }
      if (scope.popupClass) {
        element.addClass(scope.popupClass);
      }
      if (scope.animation()) {
        element.addClass(attrs.tooltipAnimationClass);
      }
    }
  };
}]).directive('uibTooltipPopup', function () {
  return {
    replace: true,
    scope: {
      content: '@',
      placement: '@',
      popupClass: '@',
      animation: '&',
      isOpen: '&'
    },
    templateUrl: 'uib/template/tooltip/tooltip-popup.html'
  };
}).directive('uibTooltip', ['$uibTooltip', function ($uibTooltip) {
  return $uibTooltip('uibTooltip', 'tooltip', 'mouseenter');
}]).directive('uibTooltipTemplatePopup', function () {
  return {
    replace: true,
    scope: {
      contentExp: '&',
      placement: '@',
      popupClass: '@',
      animation: '&',
      isOpen: '&',
      originScope: '&'
    },
    templateUrl: 'uib/template/tooltip/tooltip-template-popup.html'
  };
}).directive('uibTooltipTemplate', ['$uibTooltip', function ($uibTooltip) {
  return $uibTooltip('uibTooltipTemplate', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}]).directive('uibTooltipHtmlPopup', function () {
  return {
    replace: true,
    scope: {
      contentExp: '&',
      placement: '@',
      popupClass: '@',
      animation: '&',
      isOpen: '&'
    },
    templateUrl: 'uib/template/tooltip/tooltip-html-popup.html'
  };
}).directive('uibTooltipHtml', ['$uibTooltip', function ($uibTooltip) {
  return $uibTooltip('uibTooltipHtml', 'tooltip', 'mouseenter', {
    useContentExp: true
  });
}]);

/**
 * The following features are still outstanding: popup delay, animation as a
 * function, placement as a function, inside, support for more triggers than
 * just mouse enter/leave, and selector delegatation.
 */
angular.module('ui.bootstrap.popover', ['ui.bootstrap.tooltip']).directive('uibPopoverTemplatePopup', function () {
  return {
    replace: true,
    scope: {
      title: '@',
      contentExp: '&',
      placement: '@',
      popupClass: '@',
      animation: '&',
      isOpen: '&',
      originScope: '&'
    },
    templateUrl: 'uib/template/popover/popover-template.html'
  };
}).directive('uibPopoverTemplate', ['$uibTooltip', function ($uibTooltip) {
  return $uibTooltip('uibPopoverTemplate', 'popover', 'click', {
    useContentExp: true
  });
}]).directive('uibPopoverHtmlPopup', function () {
  return {
    replace: true,
    scope: {
      contentExp: '&',
      title: '@',
      placement: '@',
      popupClass: '@',
      animation: '&',
      isOpen: '&'
    },
    templateUrl: 'uib/template/popover/popover-html.html'
  };
}).directive('uibPopoverHtml', ['$uibTooltip', function ($uibTooltip) {
  return $uibTooltip('uibPopoverHtml', 'popover', 'click', {
    useContentExp: true
  });
}]).directive('uibPopoverPopup', function () {
  return {
    replace: true,
    scope: {
      title: '@',
      content: '@',
      placement: '@',
      popupClass: '@',
      animation: '&',
      isOpen: '&'
    },
    templateUrl: 'uib/template/popover/popover.html'
  };
}).directive('uibPopover', ['$uibTooltip', function ($uibTooltip) {
  return $uibTooltip('uibPopover', 'popover', 'click');
}]);
angular.module('ui.bootstrap.progressbar', []).constant('uibProgressConfig', {
  animate: true,
  max: 100
}).controller('UibProgressController', ['$scope', '$attrs', 'uibProgressConfig', function ($scope, $attrs, progressConfig) {
  var self = this,
    animate = angular.isDefined($attrs.animate) ? $scope.$parent.$eval($attrs.animate) : progressConfig.animate;
  this.bars = [];
  $scope.max = angular.isDefined($scope.max) ? $scope.max : progressConfig.max;
  this.addBar = function (bar, element, attrs) {
    if (!animate) {
      element.css({
        'transition': 'none'
      });
    }
    this.bars.push(bar);
    bar.max = $scope.max;
    bar.title = attrs && angular.isDefined(attrs.title) ? attrs.title : 'progressbar';
    bar.$watch('value', function (value) {
      bar.recalculatePercentage();
    });
    bar.recalculatePercentage = function () {
      var totalPercentage = self.bars.reduce(function (total, bar) {
        bar.percent = +(100 * bar.value / bar.max).toFixed(2);
        return total + bar.percent;
      }, 0);
      if (totalPercentage > 100) {
        bar.percent -= totalPercentage - 100;
      }
    };
    bar.$on('$destroy', function () {
      element = null;
      self.removeBar(bar);
    });
  };
  this.removeBar = function (bar) {
    this.bars.splice(this.bars.indexOf(bar), 1);
    this.bars.forEach(function (bar) {
      bar.recalculatePercentage();
    });
  };
  $scope.$watch('max', function (max) {
    self.bars.forEach(function (bar) {
      bar.max = $scope.max;
      bar.recalculatePercentage();
    });
  });
}]).directive('uibProgress', function () {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    require: 'uibProgress',
    scope: {
      max: '=?'
    },
    templateUrl: 'uib/template/progressbar/progress.html'
  };
}).directive('uibBar', function () {
  return {
    replace: true,
    transclude: true,
    require: '^uibProgress',
    scope: {
      value: '=',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/bar.html',
    link: function link(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, element, attrs);
    }
  };
}).directive('uibProgressbar', function () {
  return {
    replace: true,
    transclude: true,
    controller: 'UibProgressController',
    scope: {
      value: '=',
      max: '=?',
      type: '@'
    },
    templateUrl: 'uib/template/progressbar/progressbar.html',
    link: function link(scope, element, attrs, progressCtrl) {
      progressCtrl.addBar(scope, angular.element(element.children()[0]), {
        title: attrs.title
      });
    }
  };
});
angular.module('ui.bootstrap.rating', []).constant('uibRatingConfig', {
  max: 5,
  stateOn: null,
  stateOff: null,
  titles: ['one', 'two', 'three', 'four', 'five']
}).controller('UibRatingController', ['$scope', '$attrs', 'uibRatingConfig', function ($scope, $attrs, ratingConfig) {
  var ngModelCtrl = {
    $setViewValue: angular.noop
  };
  this.init = function (ngModelCtrl_) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;
    ngModelCtrl.$formatters.push(function (value) {
      if (angular.isNumber(value) && value << 0 !== value) {
        value = Math.round(value);
      }
      return value;
    });
    this.stateOn = angular.isDefined($attrs.stateOn) ? $scope.$parent.$eval($attrs.stateOn) : ratingConfig.stateOn;
    this.stateOff = angular.isDefined($attrs.stateOff) ? $scope.$parent.$eval($attrs.stateOff) : ratingConfig.stateOff;
    var tmpTitles = angular.isDefined($attrs.titles) ? $scope.$parent.$eval($attrs.titles) : ratingConfig.titles;
    this.titles = angular.isArray(tmpTitles) && tmpTitles.length > 0 ? tmpTitles : ratingConfig.titles;
    var ratingStates = angular.isDefined($attrs.ratingStates) ? $scope.$parent.$eval($attrs.ratingStates) : new Array(angular.isDefined($attrs.max) ? $scope.$parent.$eval($attrs.max) : ratingConfig.max);
    $scope.range = this.buildTemplateObjects(ratingStates);
  };
  this.buildTemplateObjects = function (states) {
    for (var i = 0, n = states.length; i < n; i++) {
      states[i] = angular.extend({
        index: i
      }, {
        stateOn: this.stateOn,
        stateOff: this.stateOff,
        title: this.getTitle(i)
      }, states[i]);
    }
    return states;
  };
  this.getTitle = function (index) {
    if (index >= this.titles.length) {
      return index + 1;
    }
    return this.titles[index];
  };
  $scope.rate = function (value) {
    if (!$scope.readonly && value >= 0 && value <= $scope.range.length) {
      ngModelCtrl.$setViewValue(ngModelCtrl.$viewValue === value ? 0 : value);
      ngModelCtrl.$render();
    }
  };
  $scope.enter = function (value) {
    if (!$scope.readonly) {
      $scope.value = value;
    }
    $scope.onHover({
      value: value
    });
  };
  $scope.reset = function () {
    $scope.value = ngModelCtrl.$viewValue;
    $scope.onLeave();
  };
  $scope.onKeydown = function (evt) {
    if (/(37|38|39|40)/.test(evt.which)) {
      evt.preventDefault();
      evt.stopPropagation();
      $scope.rate($scope.value + (evt.which === 38 || evt.which === 39 ? 1 : -1));
    }
  };
  this.render = function () {
    $scope.value = ngModelCtrl.$viewValue;
  };
}]).directive('uibRating', function () {
  return {
    require: ['uibRating', 'ngModel'],
    scope: {
      readonly: '=?',
      onHover: '&',
      onLeave: '&'
    },
    controller: 'UibRatingController',
    templateUrl: 'uib/template/rating/rating.html',
    replace: true,
    link: function link(scope, element, attrs, ctrls) {
      var ratingCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      ratingCtrl.init(ngModelCtrl);
    }
  };
});
angular.module('ui.bootstrap.tabs', []).controller('UibTabsetController', ['$scope', function ($scope) {
  var ctrl = this,
    tabs = ctrl.tabs = $scope.tabs = [];
  ctrl.select = function (selectedTab) {
    angular.forEach(tabs, function (tab) {
      if (tab.active && tab !== selectedTab) {
        tab.active = false;
        tab.onDeselect();
        selectedTab.selectCalled = false;
      }
    });
    selectedTab.active = true;
    // only call select if it has not already been called
    if (!selectedTab.selectCalled) {
      selectedTab.onSelect();
      selectedTab.selectCalled = true;
    }
  };
  ctrl.addTab = function addTab(tab) {
    tabs.push(tab);
    // we can't run the select function on the first tab
    // since that would select it twice
    if (tabs.length === 1 && tab.active !== false) {
      tab.active = true;
    } else if (tab.active) {
      ctrl.select(tab);
    } else {
      tab.active = false;
    }
  };
  ctrl.removeTab = function removeTab(tab) {
    var index = tabs.indexOf(tab);
    //Select a new tab if the tab to be removed is selected and not destroyed
    if (tab.active && tabs.length > 1 && !destroyed) {
      //If this is the last tab, select the previous tab. else, the next tab.
      var newActiveIndex = index === tabs.length - 1 ? index - 1 : index + 1;
      ctrl.select(tabs[newActiveIndex]);
    }
    tabs.splice(index, 1);
  };
  var destroyed;
  $scope.$on('$destroy', function () {
    destroyed = true;
  });
}]).directive('uibTabset', function () {
  return {
    transclude: true,
    replace: true,
    scope: {
      type: '@'
    },
    controller: 'UibTabsetController',
    templateUrl: 'uib/template/tabs/tabset.html',
    link: function link(scope, element, attrs) {
      scope.vertical = angular.isDefined(attrs.vertical) ? scope.$parent.$eval(attrs.vertical) : false;
      scope.justified = angular.isDefined(attrs.justified) ? scope.$parent.$eval(attrs.justified) : false;
    }
  };
}).directive('uibTab', ['$parse', function ($parse) {
  return {
    require: '^uibTabset',
    replace: true,
    templateUrl: 'uib/template/tabs/tab.html',
    transclude: true,
    scope: {
      active: '=?',
      heading: '@',
      onSelect: '&select',
      //This callback is called in contentHeadingTransclude
      //once it inserts the tab's content into the dom
      onDeselect: '&deselect'
    },
    controller: function controller() {
      //Empty controller so other directives can require being 'under' a tab
    },
    controllerAs: 'tab',
    link: function link(scope, elm, attrs, tabsetCtrl, transclude) {
      scope.$watch('active', function (active) {
        if (active) {
          tabsetCtrl.select(scope);
        }
      });
      scope.disabled = false;
      if (attrs.disable) {
        scope.$parent.$watch($parse(attrs.disable), function (value) {
          scope.disabled = !!value;
        });
      }
      scope.select = function () {
        if (!scope.disabled) {
          scope.active = true;
        }
      };
      tabsetCtrl.addTab(scope);
      scope.$on('$destroy', function () {
        tabsetCtrl.removeTab(scope);
      });

      //We need to transclude later, once the content container is ready.
      //when this link happens, we're inside a tab heading.
      scope.$transcludeFn = transclude;
    }
  };
}]).directive('uibTabHeadingTransclude', function () {
  return {
    restrict: 'A',
    require: '^uibTab',
    link: function link(scope, elm) {
      scope.$watch('headingElement', function updateHeadingElement(heading) {
        if (heading) {
          elm.html('');
          elm.append(heading);
        }
      });
    }
  };
}).directive('uibTabContentTransclude', function () {
  return {
    restrict: 'A',
    require: '^uibTabset',
    link: function link(scope, elm, attrs) {
      var tab = scope.$eval(attrs.uibTabContentTransclude);

      //Now our tab is ready to be transcluded: both the tab heading area
      //and the tab content area are loaded.  Transclude 'em both.
      tab.$transcludeFn(tab.$parent, function (contents) {
        angular.forEach(contents, function (node) {
          if (isTabHeading(node)) {
            //Let tabHeadingTransclude know.
            tab.headingElement = node;
          } else {
            elm.append(node);
          }
        });
      });
    }
  };
  function isTabHeading(node) {
    return node.tagName && (node.hasAttribute('uib-tab-heading') || node.hasAttribute('data-uib-tab-heading') || node.hasAttribute('x-uib-tab-heading') || node.tagName.toLowerCase() === 'uib-tab-heading' || node.tagName.toLowerCase() === 'data-uib-tab-heading' || node.tagName.toLowerCase() === 'x-uib-tab-heading');
  }
});
angular.module('ui.bootstrap.timepicker', []).constant('uibTimepickerConfig', {
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  showMeridian: true,
  showSeconds: false,
  meridians: null,
  readonlyInput: false,
  mousewheel: true,
  arrowkeys: true,
  showSpinners: true,
  templateUrl: 'uib/template/timepicker/timepicker.html'
}).controller('UibTimepickerController', ['$scope', '$element', '$attrs', '$parse', '$log', '$locale', 'uibTimepickerConfig', function ($scope, $element, $attrs, $parse, $log, $locale, timepickerConfig) {
  var selected = new Date(),
    watchers = [],
    ngModelCtrl = {
      $setViewValue: angular.noop
    },
    // nullModelCtrl
    meridians = angular.isDefined($attrs.meridians) ? $scope.$parent.$eval($attrs.meridians) : timepickerConfig.meridians || $locale.DATETIME_FORMATS.AMPMS;
  $scope.tabindex = angular.isDefined($attrs.tabindex) ? $attrs.tabindex : 0;
  $element.removeAttr('tabindex');
  this.init = function (ngModelCtrl_, inputs) {
    ngModelCtrl = ngModelCtrl_;
    ngModelCtrl.$render = this.render;
    ngModelCtrl.$formatters.unshift(function (modelValue) {
      return modelValue ? new Date(modelValue) : null;
    });
    var hoursInputEl = inputs.eq(0),
      minutesInputEl = inputs.eq(1),
      secondsInputEl = inputs.eq(2);
    var mousewheel = angular.isDefined($attrs.mousewheel) ? $scope.$parent.$eval($attrs.mousewheel) : timepickerConfig.mousewheel;
    if (mousewheel) {
      this.setupMousewheelEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }
    var arrowkeys = angular.isDefined($attrs.arrowkeys) ? $scope.$parent.$eval($attrs.arrowkeys) : timepickerConfig.arrowkeys;
    if (arrowkeys) {
      this.setupArrowkeyEvents(hoursInputEl, minutesInputEl, secondsInputEl);
    }
    $scope.readonlyInput = angular.isDefined($attrs.readonlyInput) ? $scope.$parent.$eval($attrs.readonlyInput) : timepickerConfig.readonlyInput;
    this.setupInputEvents(hoursInputEl, minutesInputEl, secondsInputEl);
  };
  var hourStep = timepickerConfig.hourStep;
  if ($attrs.hourStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.hourStep), function (value) {
      hourStep = +value;
    }));
  }
  var minuteStep = timepickerConfig.minuteStep;
  if ($attrs.minuteStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.minuteStep), function (value) {
      minuteStep = +value;
    }));
  }
  var min;
  watchers.push($scope.$parent.$watch($parse($attrs.min), function (value) {
    var dt = new Date(value);
    min = isNaN(dt) ? undefined : dt;
  }));
  var max;
  watchers.push($scope.$parent.$watch($parse($attrs.max), function (value) {
    var dt = new Date(value);
    max = isNaN(dt) ? undefined : dt;
  }));
  var disabled = false;
  if ($attrs.ngDisabled) {
    watchers.push($scope.$parent.$watch($parse($attrs.ngDisabled), function (value) {
      disabled = value;
    }));
  }
  $scope.noIncrementHours = function () {
    var incrementedSelected = addMinutes(selected, hourStep * 60);
    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
  };
  $scope.noDecrementHours = function () {
    var decrementedSelected = addMinutes(selected, -hourStep * 60);
    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
  };
  $scope.noIncrementMinutes = function () {
    var incrementedSelected = addMinutes(selected, minuteStep);
    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
  };
  $scope.noDecrementMinutes = function () {
    var decrementedSelected = addMinutes(selected, -minuteStep);
    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
  };
  $scope.noIncrementSeconds = function () {
    var incrementedSelected = addSeconds(selected, secondStep);
    return disabled || incrementedSelected > max || incrementedSelected < selected && incrementedSelected < min;
  };
  $scope.noDecrementSeconds = function () {
    var decrementedSelected = addSeconds(selected, -secondStep);
    return disabled || decrementedSelected < min || decrementedSelected > selected && decrementedSelected > max;
  };
  $scope.noToggleMeridian = function () {
    if (selected.getHours() < 12) {
      return disabled || addMinutes(selected, 12 * 60) > max;
    }
    return disabled || addMinutes(selected, -12 * 60) < min;
  };
  var secondStep = timepickerConfig.secondStep;
  if ($attrs.secondStep) {
    watchers.push($scope.$parent.$watch($parse($attrs.secondStep), function (value) {
      secondStep = +value;
    }));
  }
  $scope.showSeconds = timepickerConfig.showSeconds;
  if ($attrs.showSeconds) {
    watchers.push($scope.$parent.$watch($parse($attrs.showSeconds), function (value) {
      $scope.showSeconds = !!value;
    }));
  }

  // 12H / 24H mode
  $scope.showMeridian = timepickerConfig.showMeridian;
  if ($attrs.showMeridian) {
    watchers.push($scope.$parent.$watch($parse($attrs.showMeridian), function (value) {
      $scope.showMeridian = !!value;
      if (ngModelCtrl.$error.time) {
        // Evaluate from template
        var hours = getHoursFromTemplate(),
          minutes = getMinutesFromTemplate();
        if (angular.isDefined(hours) && angular.isDefined(minutes)) {
          selected.setHours(hours);
          refresh();
        }
      } else {
        updateTemplate();
      }
    }));
  }

  // Get $scope.hours in 24H mode if valid
  function getHoursFromTemplate() {
    var hours = +$scope.hours;
    var valid = $scope.showMeridian ? hours > 0 && hours < 13 : hours >= 0 && hours < 24;
    if (!valid) {
      return undefined;
    }
    if ($scope.showMeridian) {
      if (hours === 12) {
        hours = 0;
      }
      if ($scope.meridian === meridians[1]) {
        hours = hours + 12;
      }
    }
    return hours;
  }
  function getMinutesFromTemplate() {
    var minutes = +$scope.minutes;
    return minutes >= 0 && minutes < 60 ? minutes : undefined;
  }
  function getSecondsFromTemplate() {
    var seconds = +$scope.seconds;
    return seconds >= 0 && seconds < 60 ? seconds : undefined;
  }
  function pad(value) {
    if (value === null) {
      return '';
    }
    return angular.isDefined(value) && value.toString().length < 2 ? '0' + value : value.toString();
  }

  // Respond on mousewheel spin
  this.setupMousewheelEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
    var isScrollingUp = function isScrollingUp(e) {
      if (e.originalEvent) {
        e = e.originalEvent;
      }
      //pick correct delta variable depending on event
      var delta = e.wheelDelta ? e.wheelDelta : -e.deltaY;
      return e.detail || delta > 0;
    };
    hoursInputEl.bind('mousewheel wheel', function (e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementHours() : $scope.decrementHours());
      }
      e.preventDefault();
    });
    minutesInputEl.bind('mousewheel wheel', function (e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementMinutes() : $scope.decrementMinutes());
      }
      e.preventDefault();
    });
    secondsInputEl.bind('mousewheel wheel', function (e) {
      if (!disabled) {
        $scope.$apply(isScrollingUp(e) ? $scope.incrementSeconds() : $scope.decrementSeconds());
      }
      e.preventDefault();
    });
  };

  // Respond on up/down arrowkeys
  this.setupArrowkeyEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
    hoursInputEl.bind('keydown', function (e) {
      if (!disabled) {
        if (e.which === 38) {
          // up
          e.preventDefault();
          $scope.incrementHours();
          $scope.$apply();
        } else if (e.which === 40) {
          // down
          e.preventDefault();
          $scope.decrementHours();
          $scope.$apply();
        }
      }
    });
    minutesInputEl.bind('keydown', function (e) {
      if (!disabled) {
        if (e.which === 38) {
          // up
          e.preventDefault();
          $scope.incrementMinutes();
          $scope.$apply();
        } else if (e.which === 40) {
          // down
          e.preventDefault();
          $scope.decrementMinutes();
          $scope.$apply();
        }
      }
    });
    secondsInputEl.bind('keydown', function (e) {
      if (!disabled) {
        if (e.which === 38) {
          // up
          e.preventDefault();
          $scope.incrementSeconds();
          $scope.$apply();
        } else if (e.which === 40) {
          // down
          e.preventDefault();
          $scope.decrementSeconds();
          $scope.$apply();
        }
      }
    });
  };
  this.setupInputEvents = function (hoursInputEl, minutesInputEl, secondsInputEl) {
    if ($scope.readonlyInput) {
      $scope.updateHours = angular.noop;
      $scope.updateMinutes = angular.noop;
      $scope.updateSeconds = angular.noop;
      return;
    }
    var invalidate = function invalidate(invalidHours, invalidMinutes, invalidSeconds) {
      ngModelCtrl.$setViewValue(null);
      ngModelCtrl.$setValidity('time', false);
      if (angular.isDefined(invalidHours)) {
        $scope.invalidHours = invalidHours;
      }
      if (angular.isDefined(invalidMinutes)) {
        $scope.invalidMinutes = invalidMinutes;
      }
      if (angular.isDefined(invalidSeconds)) {
        $scope.invalidSeconds = invalidSeconds;
      }
    };
    $scope.updateHours = function () {
      var hours = getHoursFromTemplate(),
        minutes = getMinutesFromTemplate();
      ngModelCtrl.$setDirty();
      if (angular.isDefined(hours) && angular.isDefined(minutes)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(true);
        } else {
          refresh('h');
        }
      } else {
        invalidate(true);
      }
    };
    hoursInputEl.bind('blur', function (e) {
      ngModelCtrl.$setTouched();
      if ($scope.hours === null || $scope.hours === '') {
        invalidate(true);
      } else if (!$scope.invalidHours && $scope.hours < 10) {
        $scope.$apply(function () {
          $scope.hours = pad($scope.hours);
        });
      }
    });
    $scope.updateMinutes = function () {
      var minutes = getMinutesFromTemplate(),
        hours = getHoursFromTemplate();
      ngModelCtrl.$setDirty();
      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        selected.setHours(hours);
        selected.setMinutes(minutes);
        if (selected < min || selected > max) {
          invalidate(undefined, true);
        } else {
          refresh('m');
        }
      } else {
        invalidate(undefined, true);
      }
    };
    minutesInputEl.bind('blur', function (e) {
      ngModelCtrl.$setTouched();
      if ($scope.minutes === null) {
        invalidate(undefined, true);
      } else if (!$scope.invalidMinutes && $scope.minutes < 10) {
        $scope.$apply(function () {
          $scope.minutes = pad($scope.minutes);
        });
      }
    });
    $scope.updateSeconds = function () {
      var seconds = getSecondsFromTemplate();
      ngModelCtrl.$setDirty();
      if (angular.isDefined(seconds)) {
        selected.setSeconds(seconds);
        refresh('s');
      } else {
        invalidate(undefined, undefined, true);
      }
    };
    secondsInputEl.bind('blur', function (e) {
      if (!$scope.invalidSeconds && $scope.seconds < 10) {
        $scope.$apply(function () {
          $scope.seconds = pad($scope.seconds);
        });
      }
    });
  };
  this.render = function () {
    var date = ngModelCtrl.$viewValue;
    if (isNaN(date)) {
      ngModelCtrl.$setValidity('time', false);
      $log.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.');
    } else {
      if (date) {
        selected = date;
      }
      if (selected < min || selected > max) {
        ngModelCtrl.$setValidity('time', false);
        $scope.invalidHours = true;
        $scope.invalidMinutes = true;
      } else {
        makeValid();
      }
      updateTemplate();
    }
  };

  // Call internally when we know that model is valid.
  function refresh(keyboardChange) {
    makeValid();
    ngModelCtrl.$setViewValue(new Date(selected));
    updateTemplate(keyboardChange);
  }
  function makeValid() {
    ngModelCtrl.$setValidity('time', true);
    $scope.invalidHours = false;
    $scope.invalidMinutes = false;
    $scope.invalidSeconds = false;
  }
  function updateTemplate(keyboardChange) {
    if (!ngModelCtrl.$modelValue) {
      $scope.hours = null;
      $scope.minutes = null;
      $scope.seconds = null;
      $scope.meridian = meridians[0];
    } else {
      var hours = selected.getHours(),
        minutes = selected.getMinutes(),
        seconds = selected.getSeconds();
      if ($scope.showMeridian) {
        hours = hours === 0 || hours === 12 ? 12 : hours % 12; // Convert 24 to 12 hour system
      }
      $scope.hours = keyboardChange === 'h' ? hours : pad(hours);
      if (keyboardChange !== 'm') {
        $scope.minutes = pad(minutes);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
      if (keyboardChange !== 's') {
        $scope.seconds = pad(seconds);
      }
      $scope.meridian = selected.getHours() < 12 ? meridians[0] : meridians[1];
    }
  }
  function addSecondsToSelected(seconds) {
    selected = addSeconds(selected, seconds);
    refresh();
  }
  function addMinutes(selected, minutes) {
    return addSeconds(selected, minutes * 60);
  }
  function addSeconds(date, seconds) {
    var dt = new Date(date.getTime() + seconds * 1000);
    var newDate = new Date(date);
    newDate.setHours(dt.getHours(), dt.getMinutes(), dt.getSeconds());
    return newDate;
  }
  $scope.showSpinners = angular.isDefined($attrs.showSpinners) ? $scope.$parent.$eval($attrs.showSpinners) : timepickerConfig.showSpinners;
  $scope.incrementHours = function () {
    if (!$scope.noIncrementHours()) {
      addSecondsToSelected(hourStep * 60 * 60);
    }
  };
  $scope.decrementHours = function () {
    if (!$scope.noDecrementHours()) {
      addSecondsToSelected(-hourStep * 60 * 60);
    }
  };
  $scope.incrementMinutes = function () {
    if (!$scope.noIncrementMinutes()) {
      addSecondsToSelected(minuteStep * 60);
    }
  };
  $scope.decrementMinutes = function () {
    if (!$scope.noDecrementMinutes()) {
      addSecondsToSelected(-minuteStep * 60);
    }
  };
  $scope.incrementSeconds = function () {
    if (!$scope.noIncrementSeconds()) {
      addSecondsToSelected(secondStep);
    }
  };
  $scope.decrementSeconds = function () {
    if (!$scope.noDecrementSeconds()) {
      addSecondsToSelected(-secondStep);
    }
  };
  $scope.toggleMeridian = function () {
    var minutes = getMinutesFromTemplate(),
      hours = getHoursFromTemplate();
    if (!$scope.noToggleMeridian()) {
      if (angular.isDefined(minutes) && angular.isDefined(hours)) {
        addSecondsToSelected(12 * 60 * (selected.getHours() < 12 ? 60 : -60));
      } else {
        $scope.meridian = $scope.meridian === meridians[0] ? meridians[1] : meridians[0];
      }
    }
  };
  $scope.blur = function () {
    ngModelCtrl.$setTouched();
  };
  $scope.$on('$destroy', function () {
    while (watchers.length) {
      watchers.shift()();
    }
  });
}]).directive('uibTimepicker', ['uibTimepickerConfig', function (uibTimepickerConfig) {
  return {
    require: ['uibTimepicker', '?^ngModel'],
    controller: 'UibTimepickerController',
    controllerAs: 'timepicker',
    replace: true,
    scope: {},
    templateUrl: function templateUrl(element, attrs) {
      return attrs.templateUrl || uibTimepickerConfig.templateUrl;
    },
    link: function link(scope, element, attrs, ctrls) {
      var timepickerCtrl = ctrls[0],
        ngModelCtrl = ctrls[1];
      if (ngModelCtrl) {
        timepickerCtrl.init(ngModelCtrl, element.find('input'));
      }
    }
  };
}]);
angular.module('ui.bootstrap.typeahead', ['ui.bootstrap.debounce', 'ui.bootstrap.position'])

/**
 * A helper service that can parse typeahead's syntax (string provided by users)
 * Extracted to a separate service for ease of unit testing
 */.factory('uibTypeaheadParser', ['$parse', function ($parse) {
  //                      00000111000000000000022200000000000000003333333333333330000000000044000
  var TYPEAHEAD_REGEXP = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
  return {
    parse: function parse(input) {
      var match = input.match(TYPEAHEAD_REGEXP);
      if (!match) {
        throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_"' + ' but got "' + input + '".');
      }
      return {
        itemName: match[3],
        source: $parse(match[4]),
        viewMapper: $parse(match[2] || match[1]),
        modelMapper: $parse(match[1])
      };
    }
  };
}]).controller('UibTypeaheadController', ['$scope', '$element', '$attrs', '$compile', '$parse', '$q', '$timeout', '$document', '$window', '$rootScope', '$$debounce', '$uibPosition', 'uibTypeaheadParser', function (originalScope, element, attrs, $compile, $parse, $q, $timeout, $document, $window, $rootScope, $$debounce, $position, typeaheadParser) {
  var HOT_KEYS = [9, 13, 27, 38, 40];
  var eventDebounceTime = 200;
  var modelCtrl, ngModelOptions;
  //SUPPORTED ATTRIBUTES (OPTIONS)

  //minimal no of characters that needs to be entered before typeahead kicks-in
  var minLength = originalScope.$eval(attrs.typeaheadMinLength);
  if (!minLength && minLength !== 0) {
    minLength = 1;
  }

  //minimal wait time after last character typed before typeahead kicks-in
  var waitTime = originalScope.$eval(attrs.typeaheadWaitMs) || 0;

  //should it restrict model values to the ones selected from the popup only?
  var isEditable = originalScope.$eval(attrs.typeaheadEditable) !== false;
  originalScope.$watch(attrs.typeaheadEditable, function (newVal) {
    isEditable = newVal !== false;
  });

  //binding to a variable that indicates if matches are being retrieved asynchronously
  var isLoadingSetter = $parse(attrs.typeaheadLoading).assign || angular.noop;

  //a callback executed when a match is selected
  var onSelectCallback = $parse(attrs.typeaheadOnSelect);

  //should it select highlighted popup value when losing focus?
  var isSelectOnBlur = angular.isDefined(attrs.typeaheadSelectOnBlur) ? originalScope.$eval(attrs.typeaheadSelectOnBlur) : false;

  //binding to a variable that indicates if there were no results after the query is completed
  var isNoResultsSetter = $parse(attrs.typeaheadNoResults).assign || angular.noop;
  var inputFormatter = attrs.typeaheadInputFormatter ? $parse(attrs.typeaheadInputFormatter) : undefined;
  var appendToBody = attrs.typeaheadAppendToBody ? originalScope.$eval(attrs.typeaheadAppendToBody) : false;
  var appendTo = attrs.typeaheadAppendTo ? originalScope.$eval(attrs.typeaheadAppendTo) : null;
  var focusFirst = originalScope.$eval(attrs.typeaheadFocusFirst) !== false;

  //If input matches an item of the list exactly, select it automatically
  var selectOnExact = attrs.typeaheadSelectOnExact ? originalScope.$eval(attrs.typeaheadSelectOnExact) : false;

  //binding to a variable that indicates if dropdown is open
  var isOpenSetter = $parse(attrs.typeaheadIsOpen).assign || angular.noop;
  var showHint = originalScope.$eval(attrs.typeaheadShowHint) || false;

  //INTERNAL VARIABLES

  //model setter executed upon match selection
  var parsedModel = $parse(attrs.ngModel);
  var invokeModelSetter = $parse(attrs.ngModel + '($$$p)');
  var $setModelValue = function $setModelValue(scope, newValue) {
    if (angular.isFunction(parsedModel(originalScope)) && ngModelOptions && ngModelOptions.$options && ngModelOptions.$options.getterSetter) {
      return invokeModelSetter(scope, {
        $$$p: newValue
      });
    }
    return parsedModel.assign(scope, newValue);
  };

  //expressions used by typeahead
  var parserResult = typeaheadParser.parse(attrs.uibTypeahead);
  var hasFocus;

  //Used to avoid bug in iOS webview where iOS keyboard does not fire
  //mousedown & mouseup events
  //Issue #3699
  var selected;

  //create a child scope for the typeahead directive so we are not polluting original scope
  //with typeahead-specific data (matches, query etc.)
  var scope = originalScope.$new();
  var offDestroy = originalScope.$on('$destroy', function () {
    scope.$destroy();
  });
  scope.$on('$destroy', offDestroy);

  // WAI-ARIA
  var popupId = 'typeahead-' + scope.$id + '-' + Math.floor(Math.random() * 10000);
  element.attr({
    'aria-autocomplete': 'list',
    'aria-expanded': false,
    'aria-owns': popupId
  });
  var inputsContainer, hintInputElem;
  //add read-only input to show hint
  if (showHint) {
    inputsContainer = angular.element('<div></div>');
    inputsContainer.css('position', 'relative');
    element.after(inputsContainer);
    hintInputElem = element.clone();
    hintInputElem.attr('placeholder', '');
    hintInputElem.val('');
    hintInputElem.css({
      'position': 'absolute',
      'top': '0px',
      'left': '0px',
      'border-color': 'transparent',
      'box-shadow': 'none',
      'opacity': 1,
      'background': 'none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)',
      'color': '#999'
    });
    element.css({
      'position': 'relative',
      'vertical-align': 'top',
      'background-color': 'transparent'
    });
    inputsContainer.append(hintInputElem);
    hintInputElem.after(element);
  }

  //pop-up element used to display matches
  var popUpEl = angular.element('<div uib-typeahead-popup></div>');
  popUpEl.attr({
    id: popupId,
    matches: 'matches',
    active: 'activeIdx',
    select: 'select(activeIdx, evt)',
    'move-in-progress': 'moveInProgress',
    query: 'query',
    position: 'position',
    'assign-is-open': 'assignIsOpen(isOpen)',
    debounce: 'debounceUpdate'
  });
  //custom item template
  if (angular.isDefined(attrs.typeaheadTemplateUrl)) {
    popUpEl.attr('template-url', attrs.typeaheadTemplateUrl);
  }
  if (angular.isDefined(attrs.typeaheadPopupTemplateUrl)) {
    popUpEl.attr('popup-template-url', attrs.typeaheadPopupTemplateUrl);
  }
  var resetHint = function resetHint() {
    if (showHint) {
      hintInputElem.val('');
    }
  };
  var resetMatches = function resetMatches() {
    scope.matches = [];
    scope.activeIdx = -1;
    element.attr('aria-expanded', false);
    resetHint();
  };
  var getMatchId = function getMatchId(index) {
    return popupId + '-option-' + index;
  };

  // Indicate that the specified match is the active (pre-selected) item in the list owned by this typeahead.
  // This attribute is added or removed automatically when the `activeIdx` changes.
  scope.$watch('activeIdx', function (index) {
    if (index < 0) {
      element.removeAttr('aria-activedescendant');
    } else {
      element.attr('aria-activedescendant', getMatchId(index));
    }
  });
  var inputIsExactMatch = function inputIsExactMatch(inputValue, index) {
    if (scope.matches.length > index && inputValue) {
      return inputValue.toUpperCase() === scope.matches[index].label.toUpperCase();
    }
    return false;
  };
  var getMatchesAsync = function getMatchesAsync(inputValue, evt) {
    var locals = {
      $viewValue: inputValue
    };
    isLoadingSetter(originalScope, true);
    isNoResultsSetter(originalScope, false);
    $q.when(parserResult.source(originalScope, locals)).then(function (matches) {
      //it might happen that several async queries were in progress if a user were typing fast
      //but we are interested only in responses that correspond to the current view value
      var onCurrentRequest = inputValue === modelCtrl.$viewValue;
      if (onCurrentRequest && hasFocus) {
        if (matches && matches.length > 0) {
          scope.activeIdx = focusFirst ? 0 : -1;
          isNoResultsSetter(originalScope, false);
          scope.matches.length = 0;

          //transform labels
          for (var i = 0; i < matches.length; i++) {
            locals[parserResult.itemName] = matches[i];
            scope.matches.push({
              id: getMatchId(i),
              label: parserResult.viewMapper(scope, locals),
              model: matches[i]
            });
          }
          scope.query = inputValue;
          //position pop-up with matches - we need to re-calculate its position each time we are opening a window
          //with matches as a pop-up might be absolute-positioned and position of an input might have changed on a page
          //due to other elements being rendered
          recalculatePosition();
          element.attr('aria-expanded', true);

          //Select the single remaining option if user input matches
          if (selectOnExact && scope.matches.length === 1 && inputIsExactMatch(inputValue, 0)) {
            if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
              $$debounce(function () {
                scope.select(0, evt);
              }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
            } else {
              scope.select(0, evt);
            }
          }
          if (showHint) {
            var firstLabel = scope.matches[0].label;
            if (angular.isString(inputValue) && inputValue.length > 0 && firstLabel.slice(0, inputValue.length).toUpperCase() === inputValue.toUpperCase()) {
              hintInputElem.val(inputValue + firstLabel.slice(inputValue.length));
            } else {
              hintInputElem.val('');
            }
          }
        } else {
          resetMatches();
          isNoResultsSetter(originalScope, true);
        }
      }
      if (onCurrentRequest) {
        isLoadingSetter(originalScope, false);
      }
    }, function () {
      resetMatches();
      isLoadingSetter(originalScope, false);
      isNoResultsSetter(originalScope, true);
    });
  };

  // bind events only if appendToBody params exist - performance feature
  if (appendToBody) {
    angular.element($window).on('resize', fireRecalculating);
    $document.find('body').on('scroll', fireRecalculating);
  }

  // Declare the debounced function outside recalculating for
  // proper debouncing
  var debouncedRecalculate = $$debounce(function () {
    // if popup is visible
    if (scope.matches.length) {
      recalculatePosition();
    }
    scope.moveInProgress = false;
  }, eventDebounceTime);

  // Default progress type
  scope.moveInProgress = false;
  function fireRecalculating() {
    if (!scope.moveInProgress) {
      scope.moveInProgress = true;
      scope.$digest();
    }
    debouncedRecalculate();
  }

  // recalculate actual position and set new values to scope
  // after digest loop is popup in right position
  function recalculatePosition() {
    scope.position = appendToBody ? $position.offset(element) : $position.position(element);
    scope.position.top += element.prop('offsetHeight');
  }

  //we need to propagate user's query so we can higlight matches
  scope.query = undefined;

  //Declare the timeout promise var outside the function scope so that stacked calls can be cancelled later
  var timeoutPromise;
  var scheduleSearchWithTimeout = function scheduleSearchWithTimeout(inputValue) {
    timeoutPromise = $timeout(function () {
      getMatchesAsync(inputValue);
    }, waitTime);
  };
  var cancelPreviousTimeout = function cancelPreviousTimeout() {
    if (timeoutPromise) {
      $timeout.cancel(timeoutPromise);
    }
  };
  resetMatches();
  scope.assignIsOpen = function (isOpen) {
    isOpenSetter(originalScope, isOpen);
  };
  scope.select = function (activeIdx, evt) {
    //called from within the $digest() cycle
    var locals = {};
    var model, item;
    selected = true;
    locals[parserResult.itemName] = item = scope.matches[activeIdx].model;
    model = parserResult.modelMapper(originalScope, locals);
    $setModelValue(originalScope, model);
    modelCtrl.$setValidity('editable', true);
    modelCtrl.$setValidity('parse', true);
    onSelectCallback(originalScope, {
      $item: item,
      $model: model,
      $label: parserResult.viewMapper(originalScope, locals),
      $event: evt
    });
    resetMatches();

    //return focus to the input element if a match was selected via a mouse click event
    // use timeout to avoid $rootScope:inprog error
    if (scope.$eval(attrs.typeaheadFocusOnSelect) !== false) {
      $timeout(function () {
        element[0].focus();
      }, 0, false);
    }
  };

  //bind keyboard events: arrows up(38) / down(40), enter(13) and tab(9), esc(27)
  element.on('keydown', function (evt) {
    //typeahead is open and an "interesting" key was pressed
    if (scope.matches.length === 0 || HOT_KEYS.indexOf(evt.which) === -1) {
      return;
    }

    // if there's nothing selected (i.e. focusFirst) and enter or tab is hit, clear the results
    if (scope.activeIdx === -1 && (evt.which === 9 || evt.which === 13)) {
      resetMatches();
      scope.$digest();
      return;
    }
    evt.preventDefault();
    var target;
    switch (evt.which) {
      case 9:
      case 13:
        scope.$apply(function () {
          if (angular.isNumber(scope.debounceUpdate) || angular.isObject(scope.debounceUpdate)) {
            $$debounce(function () {
              scope.select(scope.activeIdx, evt);
            }, angular.isNumber(scope.debounceUpdate) ? scope.debounceUpdate : scope.debounceUpdate['default']);
          } else {
            scope.select(scope.activeIdx, evt);
          }
        });
        break;
      case 27:
        evt.stopPropagation();
        resetMatches();
        scope.$digest();
        break;
      case 38:
        scope.activeIdx = (scope.activeIdx > 0 ? scope.activeIdx : scope.matches.length) - 1;
        scope.$digest();
        target = popUpEl.find('li')[scope.activeIdx];
        target.parentNode.scrollTop = target.offsetTop;
        break;
      case 40:
        scope.activeIdx = (scope.activeIdx + 1) % scope.matches.length;
        scope.$digest();
        target = popUpEl.find('li')[scope.activeIdx];
        target.parentNode.scrollTop = target.offsetTop;
        break;
    }
  });
  element.bind('focus', function (evt) {
    hasFocus = true;
    if (minLength === 0 && !modelCtrl.$viewValue) {
      $timeout(function () {
        getMatchesAsync(modelCtrl.$viewValue, evt);
      }, 0);
    }
  });
  element.bind('blur', function (evt) {
    if (isSelectOnBlur && scope.matches.length && scope.activeIdx !== -1 && !selected) {
      selected = true;
      scope.$apply(function () {
        if (angular.isObject(scope.debounceUpdate) && angular.isNumber(scope.debounceUpdate.blur)) {
          $$debounce(function () {
            scope.select(scope.activeIdx, evt);
          }, scope.debounceUpdate.blur);
        } else {
          scope.select(scope.activeIdx, evt);
        }
      });
    }
    if (!isEditable && modelCtrl.$error.editable) {
      modelCtrl.$viewValue = '';
      element.val('');
    }
    hasFocus = false;
    selected = false;
  });

  // Keep reference to click handler to unbind it.
  var dismissClickHandler = function dismissClickHandler(evt) {
    // Issue #3973
    // Firefox treats right click as a click on document
    if (element[0] !== evt.target && evt.which !== 3 && scope.matches.length !== 0) {
      resetMatches();
      if (!$rootScope.$$phase) {
        scope.$digest();
      }
    }
  };
  $document.on('click', dismissClickHandler);
  originalScope.$on('$destroy', function () {
    $document.off('click', dismissClickHandler);
    if (appendToBody || appendTo) {
      $popup.remove();
    }
    if (appendToBody) {
      angular.element($window).off('resize', fireRecalculating);
      $document.find('body').off('scroll', fireRecalculating);
    }
    // Prevent jQuery cache memory leak
    popUpEl.remove();
    if (showHint) {
      inputsContainer.remove();
    }
  });
  var $popup = $compile(popUpEl)(scope);
  if (appendToBody) {
    $document.find('body').append($popup);
  } else if (appendTo) {
    angular.element(appendTo).eq(0).append($popup);
  } else {
    element.after($popup);
  }
  this.init = function (_modelCtrl, _ngModelOptions) {
    modelCtrl = _modelCtrl;
    ngModelOptions = _ngModelOptions;
    scope.debounceUpdate = modelCtrl.$options && $parse(modelCtrl.$options.debounce)(originalScope);

    //plug into $parsers pipeline to open a typeahead on view changes initiated from DOM
    //$parsers kick-in on all the changes coming from the view as well as manually triggered by $setViewValue
    modelCtrl.$parsers.unshift(function (inputValue) {
      hasFocus = true;
      if (minLength === 0 || inputValue && inputValue.length >= minLength) {
        if (waitTime > 0) {
          cancelPreviousTimeout();
          scheduleSearchWithTimeout(inputValue);
        } else {
          getMatchesAsync(inputValue);
        }
      } else {
        isLoadingSetter(originalScope, false);
        cancelPreviousTimeout();
        resetMatches();
      }
      if (isEditable) {
        return inputValue;
      }
      if (!inputValue) {
        // Reset in case user had typed something previously.
        modelCtrl.$setValidity('editable', true);
        return null;
      }
      modelCtrl.$setValidity('editable', false);
      return undefined;
    });
    modelCtrl.$formatters.push(function (modelValue) {
      var candidateViewValue, emptyViewValue;
      var locals = {};

      // The validity may be set to false via $parsers (see above) if
      // the model is restricted to selected values. If the model
      // is set manually it is considered to be valid.
      if (!isEditable) {
        modelCtrl.$setValidity('editable', true);
      }
      if (inputFormatter) {
        locals.$model = modelValue;
        return inputFormatter(originalScope, locals);
      }

      //it might happen that we don't have enough info to properly render input value
      //we need to check for this situation and simply return model value if we can't apply custom formatting
      locals[parserResult.itemName] = modelValue;
      candidateViewValue = parserResult.viewMapper(originalScope, locals);
      locals[parserResult.itemName] = undefined;
      emptyViewValue = parserResult.viewMapper(originalScope, locals);
      return candidateViewValue !== emptyViewValue ? candidateViewValue : modelValue;
    });
  };
}]).directive('uibTypeahead', function () {
  return {
    controller: 'UibTypeaheadController',
    require: ['ngModel', '^?ngModelOptions', 'uibTypeahead'],
    link: function link(originalScope, element, attrs, ctrls) {
      ctrls[2].init(ctrls[0], ctrls[1]);
    }
  };
}).directive('uibTypeaheadPopup', ['$$debounce', function ($$debounce) {
  return {
    scope: {
      matches: '=',
      query: '=',
      active: '=',
      position: '&',
      moveInProgress: '=',
      select: '&',
      assignIsOpen: '&',
      debounce: '&'
    },
    replace: true,
    templateUrl: function templateUrl(element, attrs) {
      return attrs.popupTemplateUrl || 'uib/template/typeahead/typeahead-popup.html';
    },
    link: function link(scope, element, attrs) {
      scope.templateUrl = attrs.templateUrl;
      scope.isOpen = function () {
        var isDropdownOpen = scope.matches.length > 0;
        scope.assignIsOpen({
          isOpen: isDropdownOpen
        });
        return isDropdownOpen;
      };
      scope.isActive = function (matchIdx) {
        return scope.active === matchIdx;
      };
      scope.selectActive = function (matchIdx) {
        scope.active = matchIdx;
      };
      scope.selectMatch = function (activeIdx, evt) {
        var debounce = scope.debounce();
        if (angular.isNumber(debounce) || angular.isObject(debounce)) {
          $$debounce(function () {
            scope.select({
              activeIdx: activeIdx,
              evt: evt
            });
          }, angular.isNumber(debounce) ? debounce : debounce['default']);
        } else {
          scope.select({
            activeIdx: activeIdx,
            evt: evt
          });
        }
      };
    }
  };
}]).directive('uibTypeaheadMatch', ['$templateRequest', '$compile', '$parse', function ($templateRequest, $compile, $parse) {
  return {
    scope: {
      index: '=',
      match: '=',
      query: '='
    },
    link: function link(scope, element, attrs) {
      var tplUrl = $parse(attrs.templateUrl)(scope.$parent) || 'uib/template/typeahead/typeahead-match.html';
      $templateRequest(tplUrl).then(function (tplContent) {
        var tplEl = angular.element(tplContent.trim());
        element.replaceWith(tplEl);
        $compile(tplEl)(scope);
      });
    }
  };
}]).filter('uibTypeaheadHighlight', ['$sce', '$injector', '$log', function ($sce, $injector, $log) {
  var isSanitizePresent;
  isSanitizePresent = $injector.has('$sanitize');
  function escapeRegexp(queryToEscape) {
    // Regex: capture the whole query string and replace it with the string that will be used to match
    // the results, for example if the capture is "a" the result will be \a
    return queryToEscape.replace(/([.?*+^$[\]\\(){}|-])/g, '\\$1');
  }
  function containsHtml(matchItem) {
    return /<.*>/g.test(matchItem);
  }
  return function (matchItem, query) {
    if (!isSanitizePresent && containsHtml(matchItem)) {
      $log.warn('Unsafe use of typeahead please use ngSanitize'); // Warn the user about the danger
    }
    matchItem = query ? ('' + matchItem).replace(new RegExp(escapeRegexp(query), 'gi'), '<strong>$&</strong>') : matchItem; // Replaces the capture string with a the same string inside of a "strong" tag
    if (!isSanitizePresent) {
      matchItem = $sce.trustAsHtml(matchItem); // If $sanitize is not present we pack the string in a $sce object for the ng-bind-html directive
    }
    return matchItem;
  };
}]);
angular.module('ui.bootstrap.carousel').run(function () {
  !angular.$$csp().noInlineStyle && angular.element(document).find('head').prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');
});
angular.module('ui.bootstrap.datepicker').run(function () {
  !angular.$$csp().noInlineStyle && angular.element(document).find('head').prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-datepicker-popup.dropdown-menu{display:block;}.uib-button-bar{padding:10px 9px 2px;}</style>');
});
angular.module('ui.bootstrap.timepicker').run(function () {
  !angular.$$csp().noInlineStyle && angular.element(document).find('head').prepend('<style type="text/css">.uib-time input{width:50px;}</style>');
});
angular.module('ui.bootstrap.typeahead').run(function () {
  !angular.$$csp().noInlineStyle && angular.element(document).find('head').prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>');
});
/*
 * angular-ui-bootstrap
 * http://angular-ui.github.io/bootstrap/

 * Version: 1.1.2 - 2016-02-01
 * License: MIT
 */
angular.module("ui.bootstrap", ["ui.bootstrap.tpls", "ui.bootstrap.collapse", "ui.bootstrap.accordion", "ui.bootstrap.alert", "ui.bootstrap.buttons", "ui.bootstrap.carousel", "ui.bootstrap.dateparser", "ui.bootstrap.isClass", "ui.bootstrap.position", "ui.bootstrap.datepicker", "ui.bootstrap.debounce", "ui.bootstrap.dropdown", "ui.bootstrap.stackedMap", "ui.bootstrap.modal", "ui.bootstrap.paging", "ui.bootstrap.pager", "ui.bootstrap.pagination", "ui.bootstrap.tooltip", "ui.bootstrap.popover", "ui.bootstrap.progressbar", "ui.bootstrap.rating", "ui.bootstrap.tabs", "ui.bootstrap.timepicker", "ui.bootstrap.typeahead"]), angular.module("ui.bootstrap.tpls", ["uib/template/accordion/accordion-group.html", "uib/template/accordion/accordion.html", "uib/template/alert/alert.html", "uib/template/carousel/carousel.html", "uib/template/carousel/slide.html", "uib/template/datepicker/datepicker.html", "uib/template/datepicker/day.html", "uib/template/datepicker/month.html", "uib/template/datepicker/popup.html", "uib/template/datepicker/year.html", "uib/template/modal/backdrop.html", "uib/template/modal/window.html", "uib/template/pager/pager.html", "uib/template/pagination/pagination.html", "uib/template/tooltip/tooltip-html-popup.html", "uib/template/tooltip/tooltip-popup.html", "uib/template/tooltip/tooltip-template-popup.html", "uib/template/popover/popover-html.html", "uib/template/popover/popover-template.html", "uib/template/popover/popover.html", "uib/template/progressbar/bar.html", "uib/template/progressbar/progress.html", "uib/template/progressbar/progressbar.html", "uib/template/rating/rating.html", "uib/template/tabs/tab.html", "uib/template/tabs/tabset.html", "uib/template/timepicker/timepicker.html", "uib/template/typeahead/typeahead-match.html", "uib/template/typeahead/typeahead-popup.html"]), angular.module("ui.bootstrap.collapse", []).directive("uibCollapse", ["$animate", "$q", "$parse", "$injector", function (a, b, c, d) {
  var e = d.has("$animateCss") ? d.get("$animateCss") : null;
  return {
    link: function link(d, f, g) {
      function h() {
        f.hasClass("collapse") && f.hasClass("in") || b.resolve(l(d)).then(function () {
          f.removeClass("collapse").addClass("collapsing").attr("aria-expanded", !0).attr("aria-hidden", !1), e ? e(f, {
            addClass: "in",
            easing: "ease",
            to: {
              height: f[0].scrollHeight + "px"
            }
          }).start()["finally"](i) : a.addClass(f, "in", {
            to: {
              height: f[0].scrollHeight + "px"
            }
          }).then(i);
        });
      }
      function i() {
        f.removeClass("collapsing").addClass("collapse").css({
          height: "auto"
        }), m(d);
      }
      function j() {
        return f.hasClass("collapse") || f.hasClass("in") ? void b.resolve(n(d)).then(function () {
          f.css({
            height: f[0].scrollHeight + "px"
          }).removeClass("collapse").addClass("collapsing").attr("aria-expanded", !1).attr("aria-hidden", !0), e ? e(f, {
            removeClass: "in",
            to: {
              height: "0"
            }
          }).start()["finally"](k) : a.removeClass(f, "in", {
            to: {
              height: "0"
            }
          }).then(k);
        }) : k();
      }
      function k() {
        f.css({
          height: "0"
        }), f.removeClass("collapsing").addClass("collapse"), o(d);
      }
      var l = c(g.expanding),
        m = c(g.expanded),
        n = c(g.collapsing),
        o = c(g.collapsed);
      d.$eval(g.uibCollapse) || f.addClass("in").addClass("collapse").attr("aria-expanded", !0).attr("aria-hidden", !1).css({
        height: "auto"
      }), d.$watch(g.uibCollapse, function (a) {
        a ? j() : h();
      });
    }
  };
}]), angular.module("ui.bootstrap.accordion", ["ui.bootstrap.collapse"]).constant("uibAccordionConfig", {
  closeOthers: !0
}).controller("UibAccordionController", ["$scope", "$attrs", "uibAccordionConfig", function (a, b, c) {
  this.groups = [], this.closeOthers = function (d) {
    var e = angular.isDefined(b.closeOthers) ? a.$eval(b.closeOthers) : c.closeOthers;
    e && angular.forEach(this.groups, function (a) {
      a !== d && (a.isOpen = !1);
    });
  }, this.addGroup = function (a) {
    var b = this;
    this.groups.push(a), a.$on("$destroy", function (c) {
      b.removeGroup(a);
    });
  }, this.removeGroup = function (a) {
    var b = this.groups.indexOf(a);
    -1 !== b && this.groups.splice(b, 1);
  };
}]).directive("uibAccordion", function () {
  return {
    controller: "UibAccordionController",
    controllerAs: "accordion",
    transclude: !0,
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/accordion/accordion.html";
    }
  };
}).directive("uibAccordionGroup", function () {
  return {
    require: "^uibAccordion",
    transclude: !0,
    replace: !0,
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/accordion/accordion-group.html";
    },
    scope: {
      heading: "@",
      isOpen: "=?",
      isDisabled: "=?"
    },
    controller: function controller() {
      this.setHeading = function (a) {
        this.heading = a;
      };
    },
    link: function link(a, b, c, d) {
      d.addGroup(a), a.openClass = c.openClass || "panel-open", a.panelClass = c.panelClass || "panel-default", a.$watch("isOpen", function (c) {
        b.toggleClass(a.openClass, !!c), c && d.closeOthers(a);
      }), a.toggleOpen = function (b) {
        a.isDisabled || b && 32 !== b.which || (a.isOpen = !a.isOpen);
      };
      var e = "accordiongroup-" + a.$id + "-" + Math.floor(1e4 * Math.random());
      a.headingId = e + "-tab", a.panelId = e + "-panel";
    }
  };
}).directive("uibAccordionHeading", function () {
  return {
    transclude: !0,
    template: "",
    replace: !0,
    require: "^uibAccordionGroup",
    link: function link(a, b, c, d, e) {
      d.setHeading(e(a, angular.noop));
    }
  };
}).directive("uibAccordionTransclude", function () {
  return {
    require: "^uibAccordionGroup",
    link: function link(a, b, c, d) {
      a.$watch(function () {
        return d[c.uibAccordionTransclude];
      }, function (a) {
        a && (b.find("span").html(""), b.find("span").append(a));
      });
    }
  };
}), angular.module("ui.bootstrap.alert", []).controller("UibAlertController", ["$scope", "$attrs", "$interpolate", "$timeout", function (a, b, c, d) {
  a.closeable = !!b.close;
  var e = angular.isDefined(b.dismissOnTimeout) ? c(b.dismissOnTimeout)(a.$parent) : null;
  e && d(function () {
    a.close();
  }, parseInt(e, 10));
}]).directive("uibAlert", function () {
  return {
    controller: "UibAlertController",
    controllerAs: "alert",
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/alert/alert.html";
    },
    transclude: !0,
    replace: !0,
    scope: {
      type: "@",
      close: "&"
    }
  };
}), angular.module("ui.bootstrap.buttons", []).constant("uibButtonConfig", {
  activeClass: "active",
  toggleEvent: "click"
}).controller("UibButtonsController", ["uibButtonConfig", function (a) {
  this.activeClass = a.activeClass || "active", this.toggleEvent = a.toggleEvent || "click";
}]).directive("uibBtnRadio", ["$parse", function (a) {
  return {
    require: ["uibBtnRadio", "ngModel"],
    controller: "UibButtonsController",
    controllerAs: "buttons",
    link: function link(b, c, d, e) {
      var f = e[0],
        g = e[1],
        h = a(d.uibUncheckable);
      c.find("input").css({
        display: "none"
      }), g.$render = function () {
        c.toggleClass(f.activeClass, angular.equals(g.$modelValue, b.$eval(d.uibBtnRadio)));
      }, c.on(f.toggleEvent, function () {
        if (!d.disabled) {
          var a = c.hasClass(f.activeClass);
          (!a || angular.isDefined(d.uncheckable)) && b.$apply(function () {
            g.$setViewValue(a ? null : b.$eval(d.uibBtnRadio)), g.$render();
          });
        }
      }), d.uibUncheckable && b.$watch(h, function (a) {
        d.$set("uncheckable", a ? "" : null);
      });
    }
  };
}]).directive("uibBtnCheckbox", function () {
  return {
    require: ["uibBtnCheckbox", "ngModel"],
    controller: "UibButtonsController",
    controllerAs: "button",
    link: function link(a, b, c, d) {
      function e() {
        return g(c.btnCheckboxTrue, !0);
      }
      function f() {
        return g(c.btnCheckboxFalse, !1);
      }
      function g(b, c) {
        return angular.isDefined(b) ? a.$eval(b) : c;
      }
      var h = d[0],
        i = d[1];
      b.find("input").css({
        display: "none"
      }), i.$render = function () {
        b.toggleClass(h.activeClass, angular.equals(i.$modelValue, e()));
      }, b.on(h.toggleEvent, function () {
        c.disabled || a.$apply(function () {
          i.$setViewValue(b.hasClass(h.activeClass) ? f() : e()), i.$render();
        });
      });
    }
  };
}), angular.module("ui.bootstrap.carousel", []).controller("UibCarouselController", ["$scope", "$element", "$interval", "$timeout", "$animate", function (a, b, c, d, e) {
  function f() {
    for (; s.length;) s.shift();
  }
  function g(a) {
    if (angular.isUndefined(p[a].index)) return p[a];
    for (var b = 0, c = p.length; c > b; ++b) if (p[b].index === a) return p[b];
  }
  function h(c, d, g) {
    t || (angular.extend(c, {
      direction: g,
      active: !0
    }), angular.extend(o.currentSlide || {}, {
      direction: g,
      active: !1
    }), e.enabled(b) && !a.$currentTransition && c.$element && o.slides.length > 1 && (c.$element.data(q, c.direction), o.currentSlide && o.currentSlide.$element && o.currentSlide.$element.data(q, c.direction), a.$currentTransition = !0, e.on("addClass", c.$element, function (b, c) {
      if ("close" === c && (a.$currentTransition = null, e.off("addClass", b), s.length)) {
        var d = s.pop(),
          g = a.indexOfSlide(d),
          i = g > o.getCurrentIndex() ? "next" : "prev";
        f(), h(d, g, i);
      }
    })), o.currentSlide = c, r = d, k());
  }
  function i() {
    m && (c.cancel(m), m = null);
  }
  function j(b) {
    b.length || (a.$currentTransition = null, f());
  }
  function k() {
    i();
    var b = +a.interval;
    !isNaN(b) && b > 0 && (m = c(l, b));
  }
  function l() {
    var b = +a.interval;
    n && !isNaN(b) && b > 0 && p.length ? a.next() : a.pause();
  }
  var m,
    n,
    o = this,
    p = o.slides = a.slides = [],
    q = "uib-slideDirection",
    r = -1,
    s = [];
  o.currentSlide = null;
  var t = !1;
  o.addSlide = function (b, c) {
    b.$element = c, p.push(b), 1 === p.length || b.active ? (a.$currentTransition && (a.$currentTransition = null), o.select(p[p.length - 1]), 1 === p.length && a.play()) : b.active = !1;
  }, o.getCurrentIndex = function () {
    return o.currentSlide && angular.isDefined(o.currentSlide.index) ? +o.currentSlide.index : r;
  }, o.next = a.next = function () {
    var b = (o.getCurrentIndex() + 1) % p.length;
    return 0 === b && a.noWrap() ? void a.pause() : o.select(g(b), "next");
  }, o.prev = a.prev = function () {
    var b = o.getCurrentIndex() - 1 < 0 ? p.length - 1 : o.getCurrentIndex() - 1;
    return a.noWrap() && b === p.length - 1 ? void a.pause() : o.select(g(b), "prev");
  }, o.removeSlide = function (a) {
    angular.isDefined(a.index) && p.sort(function (a, b) {
      return +a.index > +b.index;
    });
    var b = s.indexOf(a);
    -1 !== b && s.splice(b, 1);
    var c = p.indexOf(a);
    p.splice(c, 1), d(function () {
      p.length > 0 && a.active ? c >= p.length ? o.select(p[c - 1]) : o.select(p[c]) : r > c && r--;
    }), 0 === p.length && (o.currentSlide = null, f());
  }, o.select = a.select = function (b, c) {
    var d = a.indexOfSlide(b);
    void 0 === c && (c = d > o.getCurrentIndex() ? "next" : "prev"), b && b !== o.currentSlide && !a.$currentTransition ? h(b, d, c) : b && b !== o.currentSlide && a.$currentTransition && (s.push(b), b.active = !1);
  }, a.indexOfSlide = function (a) {
    return angular.isDefined(a.index) ? +a.index : p.indexOf(a);
  }, a.isActive = function (a) {
    return o.currentSlide === a;
  }, a.pause = function () {
    a.noPause || (n = !1, i());
  }, a.play = function () {
    n || (n = !0, k());
  }, a.$on("$destroy", function () {
    t = !0, i();
  }), a.$watch("noTransition", function (a) {
    e.enabled(b, !a);
  }), a.$watch("interval", k), a.$watchCollection("slides", j);
}]).directive("uibCarousel", function () {
  return {
    transclude: !0,
    replace: !0,
    controller: "UibCarouselController",
    controllerAs: "carousel",
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/carousel/carousel.html";
    },
    scope: {
      interval: "=",
      noTransition: "=",
      noPause: "=",
      noWrap: "&"
    }
  };
}).directive("uibSlide", function () {
  return {
    require: "^uibCarousel",
    transclude: !0,
    replace: !0,
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/carousel/slide.html";
    },
    scope: {
      active: "=?",
      actual: "=?",
      index: "=?"
    },
    link: function link(a, b, c, d) {
      d.addSlide(a, b), a.$on("$destroy", function () {
        d.removeSlide(a);
      }), a.$watch("active", function (b) {
        b && d.select(a);
      });
    }
  };
}).animation(".item", ["$animateCss", function (a) {
  function b(a, b, c) {
    a.removeClass(b), c && c();
  }
  var c = "uib-slideDirection";
  return {
    beforeAddClass: function beforeAddClass(d, e, f) {
      if ("active" === e) {
        var g = !1,
          h = d.data(c),
          i = "next" === h ? "left" : "right",
          j = b.bind(this, d, i + " " + h, f);
        return d.addClass(h), a(d, {
          addClass: i
        }).start().done(j), function () {
          g = !0;
        };
      }
      f();
    },
    beforeRemoveClass: function beforeRemoveClass(d, e, f) {
      if ("active" === e) {
        var g = !1,
          h = d.data(c),
          i = "next" === h ? "left" : "right",
          j = b.bind(this, d, i, f);
        return a(d, {
          addClass: i
        }).start().done(j), function () {
          g = !0;
        };
      }
      f();
    }
  };
}]), angular.module("ui.bootstrap.dateparser", []).service("uibDateParser", ["$log", "$locale", "dateFilter", "orderByFilter", function (a, b, c, d) {
  function e(a, b) {
    var c = [],
      e = a.split(""),
      f = a.indexOf("'");
    if (f > -1) {
      var g = !1;
      a = a.split("");
      for (var h = f; h < a.length; h++) g ? ("'" === a[h] && (h + 1 < a.length && "'" === a[h + 1] ? (a[h + 1] = "$", e[h + 1] = "") : (e[h] = "", g = !1)), a[h] = "$") : "'" === a[h] && (a[h] = "$", e[h] = "", g = !0);
      a = a.join("");
    }
    return angular.forEach(n, function (d) {
      var f = a.indexOf(d.key);
      if (f > -1) {
        a = a.split(""), e[f] = "(" + d.regex + ")", a[f] = "$";
        for (var g = f + 1, h = f + d.key.length; h > g; g++) e[g] = "", a[g] = "$";
        a = a.join(""), c.push({
          index: f,
          key: d.key,
          apply: d[b],
          matcher: d.regex
        });
      }
    }), {
      regex: new RegExp("^" + e.join("") + "$"),
      map: d(c, "index")
    };
  }
  function f(a, b, c) {
    return 1 > c ? !1 : 1 === b && c > 28 ? 29 === c && (a % 4 === 0 && a % 100 !== 0 || a % 400 === 0) : 3 === b || 5 === b || 8 === b || 10 === b ? 31 > c : !0;
  }
  function g(a) {
    return parseInt(a, 10);
  }
  function h(a, b) {
    return a && b ? l(a, b) : a;
  }
  function i(a, b) {
    return a && b ? l(a, b, !0) : a;
  }
  function j(a, b) {
    var c = Date.parse("Jan 01, 1970 00:00:00 " + a) / 6e4;
    return isNaN(c) ? b : c;
  }
  function k(a, b) {
    return a = new Date(a.getTime()), a.setMinutes(a.getMinutes() + b), a;
  }
  function l(a, b, c) {
    c = c ? -1 : 1;
    var d = j(b, a.getTimezoneOffset());
    return k(a, c * (d - a.getTimezoneOffset()));
  }
  var m,
    n,
    o = /[\\\^\$\*\+\?\|\[\]\(\)\.\{\}]/g;
  this.init = function () {
    m = b.id, this.parsers = {}, this.formatters = {}, n = [{
      key: "yyyy",
      regex: "\\d{4}",
      apply: function apply(a) {
        this.year = +a;
      },
      formatter: function formatter(a) {
        var b = new Date();
        return b.setFullYear(Math.abs(a.getFullYear())), c(b, "yyyy");
      }
    }, {
      key: "yy",
      regex: "\\d{2}",
      apply: function apply(a) {
        this.year = +a + 2e3;
      },
      formatter: function formatter(a) {
        var b = new Date();
        return b.setFullYear(Math.abs(a.getFullYear())), c(b, "yy");
      }
    }, {
      key: "y",
      regex: "\\d{1,4}",
      apply: function apply(a) {
        this.year = +a;
      },
      formatter: function formatter(a) {
        var b = new Date();
        return b.setFullYear(Math.abs(a.getFullYear())), c(b, "y");
      }
    }, {
      key: "M!",
      regex: "0?[1-9]|1[0-2]",
      apply: function apply(a) {
        this.month = a - 1;
      },
      formatter: function formatter(a) {
        var b = a.getMonth();
        return /^[0-9]$/.test(b) ? c(a, "MM") : c(a, "M");
      }
    }, {
      key: "MMMM",
      regex: b.DATETIME_FORMATS.MONTH.join("|"),
      apply: function apply(a) {
        this.month = b.DATETIME_FORMATS.MONTH.indexOf(a);
      },
      formatter: function formatter(a) {
        return c(a, "MMMM");
      }
    }, {
      key: "MMM",
      regex: b.DATETIME_FORMATS.SHORTMONTH.join("|"),
      apply: function apply(a) {
        this.month = b.DATETIME_FORMATS.SHORTMONTH.indexOf(a);
      },
      formatter: function formatter(a) {
        return c(a, "MMM");
      }
    }, {
      key: "MM",
      regex: "0[1-9]|1[0-2]",
      apply: function apply(a) {
        this.month = a - 1;
      },
      formatter: function formatter(a) {
        return c(a, "MM");
      }
    }, {
      key: "M",
      regex: "[1-9]|1[0-2]",
      apply: function apply(a) {
        this.month = a - 1;
      },
      formatter: function formatter(a) {
        return c(a, "M");
      }
    }, {
      key: "d!",
      regex: "[0-2]?[0-9]{1}|3[0-1]{1}",
      apply: function apply(a) {
        this.date = +a;
      },
      formatter: function formatter(a) {
        var b = a.getDate();
        return /^[1-9]$/.test(b) ? c(a, "dd") : c(a, "d");
      }
    }, {
      key: "dd",
      regex: "[0-2][0-9]{1}|3[0-1]{1}",
      apply: function apply(a) {
        this.date = +a;
      },
      formatter: function formatter(a) {
        return c(a, "dd");
      }
    }, {
      key: "d",
      regex: "[1-2]?[0-9]{1}|3[0-1]{1}",
      apply: function apply(a) {
        this.date = +a;
      },
      formatter: function formatter(a) {
        return c(a, "d");
      }
    }, {
      key: "EEEE",
      regex: b.DATETIME_FORMATS.DAY.join("|"),
      formatter: function formatter(a) {
        return c(a, "EEEE");
      }
    }, {
      key: "EEE",
      regex: b.DATETIME_FORMATS.SHORTDAY.join("|"),
      formatter: function formatter(a) {
        return c(a, "EEE");
      }
    }, {
      key: "HH",
      regex: "(?:0|1)[0-9]|2[0-3]",
      apply: function apply(a) {
        this.hours = +a;
      },
      formatter: function formatter(a) {
        return c(a, "HH");
      }
    }, {
      key: "hh",
      regex: "0[0-9]|1[0-2]",
      apply: function apply(a) {
        this.hours = +a;
      },
      formatter: function formatter(a) {
        return c(a, "hh");
      }
    }, {
      key: "H",
      regex: "1?[0-9]|2[0-3]",
      apply: function apply(a) {
        this.hours = +a;
      },
      formatter: function formatter(a) {
        return c(a, "H");
      }
    }, {
      key: "h",
      regex: "[0-9]|1[0-2]",
      apply: function apply(a) {
        this.hours = +a;
      },
      formatter: function formatter(a) {
        return c(a, "h");
      }
    }, {
      key: "mm",
      regex: "[0-5][0-9]",
      apply: function apply(a) {
        this.minutes = +a;
      },
      formatter: function formatter(a) {
        return c(a, "mm");
      }
    }, {
      key: "m",
      regex: "[0-9]|[1-5][0-9]",
      apply: function apply(a) {
        this.minutes = +a;
      },
      formatter: function formatter(a) {
        return c(a, "m");
      }
    }, {
      key: "sss",
      regex: "[0-9][0-9][0-9]",
      apply: function apply(a) {
        this.milliseconds = +a;
      },
      formatter: function formatter(a) {
        return c(a, "sss");
      }
    }, {
      key: "ss",
      regex: "[0-5][0-9]",
      apply: function apply(a) {
        this.seconds = +a;
      },
      formatter: function formatter(a) {
        return c(a, "ss");
      }
    }, {
      key: "s",
      regex: "[0-9]|[1-5][0-9]",
      apply: function apply(a) {
        this.seconds = +a;
      },
      formatter: function formatter(a) {
        return c(a, "s");
      }
    }, {
      key: "a",
      regex: b.DATETIME_FORMATS.AMPMS.join("|"),
      apply: function apply(a) {
        12 === this.hours && (this.hours = 0), "PM" === a && (this.hours += 12);
      },
      formatter: function formatter(a) {
        return c(a, "a");
      }
    }, {
      key: "Z",
      regex: "[+-]\\d{4}",
      apply: function apply(a) {
        var b = a.match(/([+-])(\d{2})(\d{2})/),
          c = b[1],
          d = b[2],
          e = b[3];
        this.hours += g(c + d), this.minutes += g(c + e);
      },
      formatter: function formatter(a) {
        return c(a, "Z");
      }
    }, {
      key: "ww",
      regex: "[0-4][0-9]|5[0-3]",
      formatter: function formatter(a) {
        return c(a, "ww");
      }
    }, {
      key: "w",
      regex: "[0-9]|[1-4][0-9]|5[0-3]",
      formatter: function formatter(a) {
        return c(a, "w");
      }
    }, {
      key: "GGGG",
      regex: b.DATETIME_FORMATS.ERANAMES.join("|").replace(/\s/g, "\\s"),
      formatter: function formatter(a) {
        return c(a, "GGGG");
      }
    }, {
      key: "GGG",
      regex: b.DATETIME_FORMATS.ERAS.join("|"),
      formatter: function formatter(a) {
        return c(a, "GGG");
      }
    }, {
      key: "GG",
      regex: b.DATETIME_FORMATS.ERAS.join("|"),
      formatter: function formatter(a) {
        return c(a, "GG");
      }
    }, {
      key: "G",
      regex: b.DATETIME_FORMATS.ERAS.join("|"),
      formatter: function formatter(a) {
        return c(a, "G");
      }
    }];
  }, this.init(), this.filter = function (a, c) {
    if (!angular.isDate(a) || isNaN(a) || !c) return "";
    c = b.DATETIME_FORMATS[c] || c, b.id !== m && this.init(), this.formatters[c] || (this.formatters[c] = e(c, "formatter"));
    var d = this.formatters[c],
      f = d.map,
      g = c;
    return f.reduce(function (b, c, d) {
      var e = g.match(new RegExp("(.*)" + c.key));
      return e && angular.isString(e[1]) && (b += e[1], g = g.replace(e[1] + c.key, "")), c.apply ? b + c.apply.call(null, a) : b;
    }, "");
  }, this.parse = function (c, d, g) {
    if (!angular.isString(c) || !d) return c;
    d = b.DATETIME_FORMATS[d] || d, d = d.replace(o, "\\$&"), b.id !== m && this.init(), this.parsers[d] || (this.parsers[d] = e(d, "apply"));
    var h = this.parsers[d],
      i = h.regex,
      j = h.map,
      k = c.match(i),
      l = !1;
    if (k && k.length) {
      var n, p;
      angular.isDate(g) && !isNaN(g.getTime()) ? n = {
        year: g.getFullYear(),
        month: g.getMonth(),
        date: g.getDate(),
        hours: g.getHours(),
        minutes: g.getMinutes(),
        seconds: g.getSeconds(),
        milliseconds: g.getMilliseconds()
      } : (g && a.warn("dateparser:", "baseDate is not a valid date"), n = {
        year: 1900,
        month: 0,
        date: 1,
        hours: 0,
        minutes: 0,
        seconds: 0,
        milliseconds: 0
      });
      for (var q = 1, r = k.length; r > q; q++) {
        var s = j[q - 1];
        "Z" === s.matcher && (l = !0), s.apply && s.apply.call(n, k[q]);
      }
      var t = l ? Date.prototype.setUTCFullYear : Date.prototype.setFullYear,
        u = l ? Date.prototype.setUTCHours : Date.prototype.setHours;
      return f(n.year, n.month, n.date) && (!angular.isDate(g) || isNaN(g.getTime()) || l ? (p = new Date(0), t.call(p, n.year, n.month, n.date), u.call(p, n.hours || 0, n.minutes || 0, n.seconds || 0, n.milliseconds || 0)) : (p = new Date(g), t.call(p, n.year, n.month, n.date), u.call(p, n.hours, n.minutes, n.seconds, n.milliseconds))), p;
    }
  }, this.toTimezone = h, this.fromTimezone = i, this.timezoneToOffset = j, this.addDateMinutes = k, this.convertTimezoneToLocal = l;
}]), angular.module("ui.bootstrap.isClass", []).directive("uibIsClass", ["$animate", function (a) {
  var b = /^\s*([\s\S]+?)\s+on\s+([\s\S]+?)\s*$/,
    c = /^\s*([\s\S]+?)\s+for\s+([\s\S]+?)\s*$/;
  return {
    restrict: "A",
    compile: function compile(d, e) {
      function f(a, b, c) {
        i.push(a), j.push({
          scope: a,
          element: b
        }), o.forEach(function (b, c) {
          g(b, a);
        }), a.$on("$destroy", h);
      }
      function g(b, d) {
        var e = b.match(c),
          f = d.$eval(e[1]),
          g = e[2],
          h = k[b];
        if (!h) {
          var i = function i(b) {
            var c = null;
            j.some(function (a) {
              var d = a.scope.$eval(m);
              return d === b ? (c = a, !0) : void 0;
            }), h.lastActivated !== c && (h.lastActivated && a.removeClass(h.lastActivated.element, f), c && a.addClass(c.element, f), h.lastActivated = c);
          };
          k[b] = h = {
            lastActivated: null,
            scope: d,
            watchFn: i,
            compareWithExp: g,
            watcher: d.$watch(g, i)
          };
        }
        h.watchFn(d.$eval(g));
      }
      function h(a) {
        var b = a.targetScope,
          c = i.indexOf(b);
        if (i.splice(c, 1), j.splice(c, 1), i.length) {
          var d = i[0];
          angular.forEach(k, function (a) {
            a.scope === b && (a.watcher = d.$watch(a.compareWithExp, a.watchFn), a.scope = d);
          });
        } else k = {};
      }
      var i = [],
        j = [],
        k = {},
        l = e.uibIsClass.match(b),
        m = l[2],
        n = l[1],
        o = n.split(",");
      return f;
    }
  };
}]), angular.module("ui.bootstrap.position", []).factory("$uibPosition", ["$document", "$window", function (a, b) {
  var c,
    d = {
      normal: /(auto|scroll)/,
      hidden: /(auto|scroll|hidden)/
    },
    e = {
      auto: /\s?auto?\s?/i,
      primary: /^(top|bottom|left|right)$/,
      secondary: /^(top|bottom|left|right|center)$/,
      vertical: /^(top|bottom)$/
    };
  return {
    getRawNode: function getRawNode(a) {
      return a[0] || a;
    },
    parseStyle: function parseStyle(a) {
      return a = parseFloat(a), isFinite(a) ? a : 0;
    },
    offsetParent: function offsetParent(c) {
      function d(a) {
        return "static" === (b.getComputedStyle(a).position || "static");
      }
      c = this.getRawNode(c);
      for (var e = c.offsetParent || a[0].documentElement; e && e !== a[0].documentElement && d(e);) e = e.offsetParent;
      return e || a[0].documentElement;
    },
    scrollbarWidth: function scrollbarWidth() {
      if (angular.isUndefined(c)) {
        var b = angular.element('<div style="position: absolute; top: -9999px; width: 50px; height: 50px; overflow: scroll;"></div>');
        a.find("body").append(b), c = b[0].offsetWidth - b[0].clientWidth, c = isFinite(c) ? c : 0, b.remove();
      }
      return c;
    },
    scrollParent: function scrollParent(c, e) {
      c = this.getRawNode(c);
      var f = e ? d.hidden : d.normal,
        g = a[0].documentElement,
        h = b.getComputedStyle(c),
        i = "absolute" === h.position,
        j = c.parentElement || g;
      if (j === g || "fixed" === h.position) return g;
      for (; j.parentElement && j !== g;) {
        var k = b.getComputedStyle(j);
        if (i && "static" !== k.position && (i = !1), !i && f.test(k.overflow + k.overflowY + k.overflowX)) break;
        j = j.parentElement;
      }
      return j;
    },
    position: function position(c, d) {
      c = this.getRawNode(c);
      var e = this.offset(c);
      if (d) {
        var f = b.getComputedStyle(c);
        e.top -= this.parseStyle(f.marginTop), e.left -= this.parseStyle(f.marginLeft);
      }
      var g = this.offsetParent(c),
        h = {
          top: 0,
          left: 0
        };
      return g !== a[0].documentElement && (h = this.offset(g), h.top += g.clientTop - g.scrollTop, h.left += g.clientLeft - g.scrollLeft), {
        width: Math.round(angular.isNumber(e.width) ? e.width : c.offsetWidth),
        height: Math.round(angular.isNumber(e.height) ? e.height : c.offsetHeight),
        top: Math.round(e.top - h.top),
        left: Math.round(e.left - h.left)
      };
    },
    offset: function offset(c) {
      c = this.getRawNode(c);
      var d = c.getBoundingClientRect();
      return {
        width: Math.round(angular.isNumber(d.width) ? d.width : c.offsetWidth),
        height: Math.round(angular.isNumber(d.height) ? d.height : c.offsetHeight),
        top: Math.round(d.top + (b.pageYOffset || a[0].documentElement.scrollTop)),
        left: Math.round(d.left + (b.pageXOffset || a[0].documentElement.scrollLeft))
      };
    },
    viewportOffset: function viewportOffset(c, d, e) {
      c = this.getRawNode(c), e = e !== !1 ? !0 : !1;
      var f = c.getBoundingClientRect(),
        g = {
          top: 0,
          left: 0,
          bottom: 0,
          right: 0
        },
        h = d ? a[0].documentElement : this.scrollParent(c),
        i = h.getBoundingClientRect();
      if (g.top = i.top + h.clientTop, g.left = i.left + h.clientLeft, h === a[0].documentElement && (g.top += b.pageYOffset, g.left += b.pageXOffset), g.bottom = g.top + h.clientHeight, g.right = g.left + h.clientWidth, e) {
        var j = b.getComputedStyle(h);
        g.top += this.parseStyle(j.paddingTop), g.bottom -= this.parseStyle(j.paddingBottom), g.left += this.parseStyle(j.paddingLeft), g.right -= this.parseStyle(j.paddingRight);
      }
      return {
        top: Math.round(f.top - g.top),
        bottom: Math.round(g.bottom - f.bottom),
        left: Math.round(f.left - g.left),
        right: Math.round(g.right - f.right)
      };
    },
    parsePlacement: function parsePlacement(a) {
      var b = e.auto.test(a);
      return b && (a = a.replace(e.auto, "")), a = a.split("-"), a[0] = a[0] || "top", e.primary.test(a[0]) || (a[0] = "top"), a[1] = a[1] || "center", e.secondary.test(a[1]) || (a[1] = "center"), b ? a[2] = !0 : a[2] = !1, a;
    },
    positionElements: function positionElements(a, c, d, f) {
      a = this.getRawNode(a), c = this.getRawNode(c);
      var g = angular.isDefined(c.offsetWidth) ? c.offsetWidth : c.prop("offsetWidth"),
        h = angular.isDefined(c.offsetHeight) ? c.offsetHeight : c.prop("offsetHeight");
      d = this.parsePlacement(d);
      var i = f ? this.offset(a) : this.position(a),
        j = {
          top: 0,
          left: 0,
          placement: ""
        };
      if (d[2]) {
        var k = this.viewportOffset(a),
          l = b.getComputedStyle(c),
          m = {
            width: g + Math.round(Math.abs(this.parseStyle(l.marginLeft) + this.parseStyle(l.marginRight))),
            height: h + Math.round(Math.abs(this.parseStyle(l.marginTop) + this.parseStyle(l.marginBottom)))
          };
        if (d[0] = "top" === d[0] && m.height > k.top && m.height <= k.bottom ? "bottom" : "bottom" === d[0] && m.height > k.bottom && m.height <= k.top ? "top" : "left" === d[0] && m.width > k.left && m.width <= k.right ? "right" : "right" === d[0] && m.width > k.right && m.width <= k.left ? "left" : d[0], d[1] = "top" === d[1] && m.height - i.height > k.bottom && m.height - i.height <= k.top ? "bottom" : "bottom" === d[1] && m.height - i.height > k.top && m.height - i.height <= k.bottom ? "top" : "left" === d[1] && m.width - i.width > k.right && m.width - i.width <= k.left ? "right" : "right" === d[1] && m.width - i.width > k.left && m.width - i.width <= k.right ? "left" : d[1], "center" === d[1]) if (e.vertical.test(d[0])) {
          var n = i.width / 2 - g / 2;
          k.left + n < 0 && m.width - i.width <= k.right ? d[1] = "left" : k.right + n < 0 && m.width - i.width <= k.left && (d[1] = "right");
        } else {
          var o = i.height / 2 - m.height / 2;
          k.top + o < 0 && m.height - i.height <= k.bottom ? d[1] = "top" : k.bottom + o < 0 && m.height - i.height <= k.top && (d[1] = "bottom");
        }
      }
      switch (d[0]) {
        case "top":
          j.top = i.top - h;
          break;
        case "bottom":
          j.top = i.top + i.height;
          break;
        case "left":
          j.left = i.left - g;
          break;
        case "right":
          j.left = i.left + i.width;
      }
      switch (d[1]) {
        case "top":
          j.top = i.top;
          break;
        case "bottom":
          j.top = i.top + i.height - h;
          break;
        case "left":
          j.left = i.left;
          break;
        case "right":
          j.left = i.left + i.width - g;
          break;
        case "center":
          e.vertical.test(d[0]) ? j.left = i.left + i.width / 2 - g / 2 : j.top = i.top + i.height / 2 - h / 2;
      }
      return j.top = Math.round(j.top), j.left = Math.round(j.left), j.placement = "center" === d[1] ? d[0] : d[0] + "-" + d[1], j;
    },
    positionArrow: function positionArrow(a, c) {
      a = this.getRawNode(a);
      var d = a.querySelector(".tooltip-inner, .popover-inner");
      if (d) {
        var f = angular.element(d).hasClass("tooltip-inner"),
          g = f ? a.querySelector(".tooltip-arrow") : a.querySelector(".arrow");
        if (g) {
          if (c = this.parsePlacement(c), "center" === c[1]) return void angular.element(g).css({
            top: "",
            bottom: "",
            right: "",
            left: "",
            margin: ""
          });
          var h = "border-" + c[0] + "-width",
            i = b.getComputedStyle(g)[h],
            j = "border-";
          j += e.vertical.test(c[0]) ? c[0] + "-" + c[1] : c[1] + "-" + c[0], j += "-radius";
          var k = b.getComputedStyle(f ? d : a)[j],
            l = {
              top: "auto",
              bottom: "auto",
              left: "auto",
              right: "auto",
              margin: 0
            };
          switch (c[0]) {
            case "top":
              l.bottom = f ? "0" : "-" + i;
              break;
            case "bottom":
              l.top = f ? "0" : "-" + i;
              break;
            case "left":
              l.right = f ? "0" : "-" + i;
              break;
            case "right":
              l.left = f ? "0" : "-" + i;
          }
          l[c[1]] = k, angular.element(g).css(l);
        }
      }
    }
  };
}]), angular.module("ui.bootstrap.datepicker", ["ui.bootstrap.dateparser", "ui.bootstrap.isClass", "ui.bootstrap.position"]).value("$datepickerSuppressError", !1).constant("uibDatepickerConfig", {
  datepickerMode: "day",
  formatDay: "dd",
  formatMonth: "MMMM",
  formatYear: "yyyy",
  formatDayHeader: "EEE",
  formatDayTitle: "MMMM yyyy",
  formatMonthTitle: "yyyy",
  maxDate: null,
  maxMode: "year",
  minDate: null,
  minMode: "day",
  ngModelOptions: {},
  shortcutPropagation: !1,
  showWeeks: !0,
  yearColumns: 5,
  yearRows: 4
}).controller("UibDatepickerController", ["$scope", "$attrs", "$parse", "$interpolate", "$locale", "$log", "dateFilter", "uibDatepickerConfig", "$datepickerSuppressError", "uibDateParser", function (a, b, c, d, e, f, g, h, i, j) {
  var k = this,
    l = {
      $setViewValue: angular.noop
    },
    m = {},
    n = [];
  this.modes = ["day", "month", "year"], b.datepickerOptions ? angular.forEach(["formatDay", "formatDayHeader", "formatDayTitle", "formatMonth", "formatMonthTitle", "formatYear", "initDate", "maxDate", "maxMode", "minDate", "minMode", "showWeeks", "shortcutPropagation", "startingDay", "yearColumns", "yearRows"], function (b) {
    switch (b) {
      case "formatDay":
      case "formatDayHeader":
      case "formatDayTitle":
      case "formatMonth":
      case "formatMonthTitle":
      case "formatYear":
        k[b] = angular.isDefined(a.datepickerOptions[b]) ? d(a.datepickerOptions[b])(a.$parent) : h[b];
        break;
      case "showWeeks":
      case "shortcutPropagation":
      case "yearColumns":
      case "yearRows":
        k[b] = angular.isDefined(a.datepickerOptions[b]) ? a.datepickerOptions[b] : h[b];
        break;
      case "startingDay":
        angular.isDefined(a.datepickerOptions.startingDay) ? k.startingDay = a.datepickerOptions.startingDay : angular.isNumber(h.startingDay) ? k.startingDay = h.startingDay : k.startingDay = (e.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7;
        break;
      case "maxDate":
      case "minDate":
        a.datepickerOptions[b] ? a.$watch(function () {
          return a.datepickerOptions[b];
        }, function (a) {
          a ? angular.isDate(a) ? k[b] = j.fromTimezone(new Date(a), m.timezone) : k[b] = new Date(g(a, "medium")) : k[b] = null, k.refreshView();
        }) : k[b] = h[b] ? j.fromTimezone(new Date(h[b]), m.timezone) : null;
        break;
      case "maxMode":
      case "minMode":
        a.datepickerOptions[b] ? a.$watch(function () {
          return a.datepickerOptions[b];
        }, function (c) {
          k[b] = a[b] = angular.isDefined(c) ? c : datepickerOptions[b], ("minMode" === b && k.modes.indexOf(a.datepickerMode) < k.modes.indexOf(k[b]) || "maxMode" === b && k.modes.indexOf(a.datepickerMode) > k.modes.indexOf(k[b])) && (a.datepickerMode = k[b]);
        }) : k[b] = a[b] = h[b] || null;
        break;
      case "initDate":
        a.datepickerOptions.initDate ? (this.activeDate = j.fromTimezone(a.datepickerOptions.initDate, m.timezone) || new Date(), a.$watch(function () {
          return a.datepickerOptions.initDate;
        }, function (a) {
          a && (l.$isEmpty(l.$modelValue) || l.$invalid) && (k.activeDate = j.fromTimezone(a, m.timezone), k.refreshView());
        })) : this.activeDate = new Date();
    }
  }) : (angular.forEach(["formatDay", "formatMonth", "formatYear", "formatDayHeader", "formatDayTitle", "formatMonthTitle"], function (c) {
    k[c] = angular.isDefined(b[c]) ? d(b[c])(a.$parent) : h[c];
  }), angular.forEach(["showWeeks", "yearRows", "yearColumns", "shortcutPropagation"], function (c) {
    k[c] = angular.isDefined(b[c]) ? a.$parent.$eval(b[c]) : h[c];
  }), angular.isDefined(b.startingDay) ? k.startingDay = a.$parent.$eval(b.startingDay) : angular.isNumber(h.startingDay) ? k.startingDay = h.startingDay : k.startingDay = (e.DATETIME_FORMATS.FIRSTDAYOFWEEK + 8) % 7, angular.forEach(["minDate", "maxDate"], function (c) {
    b[c] ? n.push(a.$parent.$watch(b[c], function (a) {
      a ? angular.isDate(a) ? k[c] = j.fromTimezone(new Date(a), m.timezone) : k[c] = new Date(g(a, "medium")) : k[c] = null, k.refreshView();
    })) : k[c] = h[c] ? j.fromTimezone(new Date(h[c]), m.timezone) : null;
  }), angular.forEach(["minMode", "maxMode"], function (c) {
    b[c] ? n.push(a.$parent.$watch(b[c], function (d) {
      k[c] = a[c] = angular.isDefined(d) ? d : b[c], ("minMode" === c && k.modes.indexOf(a.datepickerMode) < k.modes.indexOf(k[c]) || "maxMode" === c && k.modes.indexOf(a.datepickerMode) > k.modes.indexOf(k[c])) && (a.datepickerMode = k[c]);
    })) : k[c] = a[c] = h[c] || null;
  }), angular.isDefined(b.initDate) ? (this.activeDate = j.fromTimezone(a.$parent.$eval(b.initDate), m.timezone) || new Date(), n.push(a.$parent.$watch(b.initDate, function (a) {
    a && (l.$isEmpty(l.$modelValue) || l.$invalid) && (k.activeDate = j.fromTimezone(a, m.timezone), k.refreshView());
  }))) : this.activeDate = new Date()), a.datepickerMode = a.datepickerMode || h.datepickerMode, a.uniqueId = "datepicker-" + a.$id + "-" + Math.floor(1e4 * Math.random()), a.disabled = angular.isDefined(b.disabled) || !1, angular.isDefined(b.ngDisabled) && n.push(a.$parent.$watch(b.ngDisabled, function (b) {
    a.disabled = b, k.refreshView();
  })), a.isActive = function (b) {
    return 0 === k.compare(b.date, k.activeDate) ? (a.activeDateId = b.uid, !0) : !1;
  }, this.init = function (a) {
    l = a, m = a.$options || h.ngModelOptions, l.$modelValue && (this.activeDate = l.$modelValue), l.$render = function () {
      k.render();
    };
  }, this.render = function () {
    if (l.$viewValue) {
      var a = new Date(l.$viewValue),
        b = !isNaN(a);
      b ? this.activeDate = j.fromTimezone(a, m.timezone) : i || f.error('Datepicker directive: "ng-model" value must be a Date object');
    }
    this.refreshView();
  }, this.refreshView = function () {
    if (this.element) {
      a.selectedDt = null, this._refreshView(), a.activeDt && (a.activeDateId = a.activeDt.uid);
      var b = l.$viewValue ? new Date(l.$viewValue) : null;
      b = j.fromTimezone(b, m.timezone), l.$setValidity("dateDisabled", !b || this.element && !this.isDisabled(b));
    }
  }, this.createDateObject = function (b, c) {
    var d = l.$viewValue ? new Date(l.$viewValue) : null;
    d = j.fromTimezone(d, m.timezone);
    var e = {
      date: b,
      label: j.filter(b, c),
      selected: d && 0 === this.compare(b, d),
      disabled: this.isDisabled(b),
      current: 0 === this.compare(b, new Date()),
      customClass: this.customClass(b) || null
    };
    return d && 0 === this.compare(b, d) && (a.selectedDt = e), k.activeDate && 0 === this.compare(e.date, k.activeDate) && (a.activeDt = e), e;
  }, this.isDisabled = function (c) {
    return a.disabled || this.minDate && this.compare(c, this.minDate) < 0 || this.maxDate && this.compare(c, this.maxDate) > 0 || b.dateDisabled && a.dateDisabled({
      date: c,
      mode: a.datepickerMode
    });
  }, this.customClass = function (b) {
    return a.customClass({
      date: b,
      mode: a.datepickerMode
    });
  }, this.split = function (a, b) {
    for (var c = []; a.length > 0;) c.push(a.splice(0, b));
    return c;
  }, a.select = function (b) {
    if (a.datepickerMode === k.minMode) {
      var c = l.$viewValue ? j.fromTimezone(new Date(l.$viewValue), m.timezone) : new Date(0, 0, 0, 0, 0, 0, 0);
      c.setFullYear(b.getFullYear(), b.getMonth(), b.getDate()), c = j.toTimezone(c, m.timezone), l.$setViewValue(c), l.$render();
    } else k.activeDate = b, a.datepickerMode = k.modes[k.modes.indexOf(a.datepickerMode) - 1];
  }, a.move = function (a) {
    var b = k.activeDate.getFullYear() + a * (k.step.years || 0),
      c = k.activeDate.getMonth() + a * (k.step.months || 0);
    k.activeDate.setFullYear(b, c, 1), k.refreshView();
  }, a.toggleMode = function (b) {
    b = b || 1, a.datepickerMode === k.maxMode && 1 === b || a.datepickerMode === k.minMode && -1 === b || (a.datepickerMode = k.modes[k.modes.indexOf(a.datepickerMode) + b]);
  }, a.keys = {
    13: "enter",
    32: "space",
    33: "pageup",
    34: "pagedown",
    35: "end",
    36: "home",
    37: "left",
    38: "up",
    39: "right",
    40: "down"
  };
  var o = function o() {
    k.element[0].focus();
  };
  a.$on("uib:datepicker.focus", o), a.keydown = function (b) {
    var c = a.keys[b.which];
    if (c && !b.shiftKey && !b.altKey && !a.disabled) if (b.preventDefault(), k.shortcutPropagation || b.stopPropagation(), "enter" === c || "space" === c) {
      if (k.isDisabled(k.activeDate)) return;
      a.select(k.activeDate);
    } else !b.ctrlKey || "up" !== c && "down" !== c ? (k.handleKeyDown(c, b), k.refreshView()) : a.toggleMode("up" === c ? 1 : -1);
  }, a.$on("$destroy", function () {
    for (; n.length;) n.shift()();
  });
}]).controller("UibDaypickerController", ["$scope", "$element", "dateFilter", function (a, b, c) {
  function d(a, b) {
    return 1 !== b || a % 4 !== 0 || a % 100 === 0 && a % 400 !== 0 ? f[b] : 29;
  }
  function e(a) {
    var b = new Date(a);
    b.setDate(b.getDate() + 4 - (b.getDay() || 7));
    var c = b.getTime();
    return b.setMonth(0), b.setDate(1), Math.floor(Math.round((c - b) / 864e5) / 7) + 1;
  }
  var f = [31, 28, 31, 30, 31, 30, 31, 31, 30, 31, 30, 31];
  this.step = {
    months: 1
  }, this.element = b, this.init = function (b) {
    angular.extend(b, this), a.showWeeks = b.showWeeks, b.refreshView();
  }, this.getDates = function (a, b) {
    for (var c, d = new Array(b), e = new Date(a), f = 0; b > f;) c = new Date(e), d[f++] = c, e.setDate(e.getDate() + 1);
    return d;
  }, this._refreshView = function () {
    var b = this.activeDate.getFullYear(),
      d = this.activeDate.getMonth(),
      f = new Date(this.activeDate);
    f.setFullYear(b, d, 1);
    var g = this.startingDay - f.getDay(),
      h = g > 0 ? 7 - g : -g,
      i = new Date(f);
    h > 0 && i.setDate(-h + 1);
    for (var j = this.getDates(i, 42), k = 0; 42 > k; k++) j[k] = angular.extend(this.createDateObject(j[k], this.formatDay), {
      secondary: j[k].getMonth() !== d,
      uid: a.uniqueId + "-" + k
    });
    a.labels = new Array(7);
    for (var l = 0; 7 > l; l++) a.labels[l] = {
      abbr: c(j[l].date, this.formatDayHeader),
      full: c(j[l].date, "EEEE")
    };
    if (a.title = c(this.activeDate, this.formatDayTitle), a.rows = this.split(j, 7), a.showWeeks) {
      a.weekNumbers = [];
      for (var m = (11 - this.startingDay) % 7, n = a.rows.length, o = 0; n > o; o++) a.weekNumbers.push(e(a.rows[o][m].date));
    }
  }, this.compare = function (a, b) {
    var c = new Date(a.getFullYear(), a.getMonth(), a.getDate()),
      d = new Date(b.getFullYear(), b.getMonth(), b.getDate());
    return c.setFullYear(a.getFullYear()), d.setFullYear(b.getFullYear()), c - d;
  }, this.handleKeyDown = function (a, b) {
    var c = this.activeDate.getDate();
    if ("left" === a) c -= 1;else if ("up" === a) c -= 7;else if ("right" === a) c += 1;else if ("down" === a) c += 7;else if ("pageup" === a || "pagedown" === a) {
      var e = this.activeDate.getMonth() + ("pageup" === a ? -1 : 1);
      this.activeDate.setMonth(e, 1), c = Math.min(d(this.activeDate.getFullYear(), this.activeDate.getMonth()), c);
    } else "home" === a ? c = 1 : "end" === a && (c = d(this.activeDate.getFullYear(), this.activeDate.getMonth()));
    this.activeDate.setDate(c);
  };
}]).controller("UibMonthpickerController", ["$scope", "$element", "dateFilter", function (a, b, c) {
  this.step = {
    years: 1
  }, this.element = b, this.init = function (a) {
    angular.extend(a, this), a.refreshView();
  }, this._refreshView = function () {
    for (var b, d = new Array(12), e = this.activeDate.getFullYear(), f = 0; 12 > f; f++) b = new Date(this.activeDate), b.setFullYear(e, f, 1), d[f] = angular.extend(this.createDateObject(b, this.formatMonth), {
      uid: a.uniqueId + "-" + f
    });
    a.title = c(this.activeDate, this.formatMonthTitle), a.rows = this.split(d, 3);
  }, this.compare = function (a, b) {
    var c = new Date(a.getFullYear(), a.getMonth()),
      d = new Date(b.getFullYear(), b.getMonth());
    return c.setFullYear(a.getFullYear()), d.setFullYear(b.getFullYear()), c - d;
  }, this.handleKeyDown = function (a, b) {
    var c = this.activeDate.getMonth();
    if ("left" === a) c -= 1;else if ("up" === a) c -= 3;else if ("right" === a) c += 1;else if ("down" === a) c += 3;else if ("pageup" === a || "pagedown" === a) {
      var d = this.activeDate.getFullYear() + ("pageup" === a ? -1 : 1);
      this.activeDate.setFullYear(d);
    } else "home" === a ? c = 0 : "end" === a && (c = 11);
    this.activeDate.setMonth(c);
  };
}]).controller("UibYearpickerController", ["$scope", "$element", "dateFilter", function (a, b, c) {
  function d(a) {
    return parseInt((a - 1) / f, 10) * f + 1;
  }
  var e, f;
  this.element = b, this.yearpickerInit = function () {
    e = this.yearColumns, f = this.yearRows * e, this.step = {
      years: f
    };
  }, this._refreshView = function () {
    for (var b, c = new Array(f), g = 0, h = d(this.activeDate.getFullYear()); f > g; g++) b = new Date(this.activeDate), b.setFullYear(h + g, 0, 1), c[g] = angular.extend(this.createDateObject(b, this.formatYear), {
      uid: a.uniqueId + "-" + g
    });
    a.title = [c[0].label, c[f - 1].label].join(" - "), a.rows = this.split(c, e), a.columns = e;
  }, this.compare = function (a, b) {
    return a.getFullYear() - b.getFullYear();
  }, this.handleKeyDown = function (a, b) {
    var c = this.activeDate.getFullYear();
    "left" === a ? c -= 1 : "up" === a ? c -= e : "right" === a ? c += 1 : "down" === a ? c += e : "pageup" === a || "pagedown" === a ? c += ("pageup" === a ? -1 : 1) * f : "home" === a ? c = d(this.activeDate.getFullYear()) : "end" === a && (c = d(this.activeDate.getFullYear()) + f - 1), this.activeDate.setFullYear(c);
  };
}]).directive("uibDatepicker", function () {
  return {
    replace: !0,
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/datepicker/datepicker.html";
    },
    scope: {
      datepickerMode: "=?",
      datepickerOptions: "=?",
      dateDisabled: "&",
      customClass: "&",
      shortcutPropagation: "&?"
    },
    require: ["uibDatepicker", "^ngModel"],
    controller: "UibDatepickerController",
    controllerAs: "datepicker",
    link: function link(a, b, c, d) {
      var e = d[0],
        f = d[1];
      e.init(f);
    }
  };
}).directive("uibDaypicker", function () {
  return {
    replace: !0,
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/datepicker/day.html";
    },
    require: ["^uibDatepicker", "uibDaypicker"],
    controller: "UibDaypickerController",
    link: function link(a, b, c, d) {
      var e = d[0],
        f = d[1];
      f.init(e);
    }
  };
}).directive("uibMonthpicker", function () {
  return {
    replace: !0,
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/datepicker/month.html";
    },
    require: ["^uibDatepicker", "uibMonthpicker"],
    controller: "UibMonthpickerController",
    link: function link(a, b, c, d) {
      var e = d[0],
        f = d[1];
      f.init(e);
    }
  };
}).directive("uibYearpicker", function () {
  return {
    replace: !0,
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/datepicker/year.html";
    },
    require: ["^uibDatepicker", "uibYearpicker"],
    controller: "UibYearpickerController",
    link: function link(a, b, c, d) {
      var e = d[0];
      angular.extend(e, d[1]), e.yearpickerInit(), e.refreshView();
    }
  };
}).constant("uibDatepickerPopupConfig", {
  altInputFormats: [],
  appendToBody: !1,
  clearText: "Clear",
  closeOnDateSelection: !0,
  closeText: "Done",
  currentText: "Today",
  datepickerPopup: "yyyy-MM-dd",
  datepickerPopupTemplateUrl: "uib/template/datepicker/popup.html",
  datepickerTemplateUrl: "uib/template/datepicker/datepicker.html",
  html5Types: {
    date: "yyyy-MM-dd",
    "datetime-local": "yyyy-MM-ddTHH:mm:ss.sss",
    month: "yyyy-MM"
  },
  onOpenFocus: !0,
  showButtonBar: !0
}).controller("UibDatepickerPopupController", ["$scope", "$element", "$attrs", "$compile", "$parse", "$document", "$rootScope", "$uibPosition", "dateFilter", "uibDateParser", "uibDatepickerPopupConfig", "$timeout", "uibDatepickerConfig", function (a, b, c, d, e, f, g, h, i, j, k, l, m) {
  function n(a) {
    return a.replace(/([A-Z])/g, function (a) {
      return "-" + a.toLowerCase();
    });
  }
  function o(b) {
    var c = j.parse(b, t, a.date);
    if (isNaN(c)) for (var d = 0; d < E.length; d++) if (c = j.parse(b, E[d], a.date), !isNaN(c)) return c;
    return c;
  }
  function p(a) {
    if (angular.isNumber(a) && (a = new Date(a)), !a) return null;
    if (angular.isDate(a) && !isNaN(a)) return a;
    if (angular.isString(a)) {
      var b = o(a);
      if (!isNaN(b)) return j.toTimezone(b, C.timezone);
    }
    return B.$options && B.$options.allowInvalid ? a : void 0;
  }
  function q(a, b) {
    var d = a || b;
    return c.ngRequired || d ? (angular.isNumber(d) && (d = new Date(d)), d ? angular.isDate(d) && !isNaN(d) ? !0 : angular.isString(d) ? !isNaN(o(b)) : !1 : !0) : !0;
  }
  function r(c) {
    if (a.isOpen || !a.disabled) {
      var d = D[0],
        e = b[0].contains(c.target),
        f = void 0 !== d.contains && d.contains(c.target);
      !a.isOpen || e || f || a.$apply(function () {
        a.isOpen = !1;
      });
    }
  }
  function s(c) {
    27 === c.which && a.isOpen ? (c.preventDefault(), c.stopPropagation(), a.$apply(function () {
      a.isOpen = !1;
    }), b[0].focus()) : 40 !== c.which || a.isOpen || (c.preventDefault(), c.stopPropagation(), a.$apply(function () {
      a.isOpen = !0;
    }));
  }
  var t,
    u,
    v,
    w,
    x,
    y,
    z,
    A,
    B,
    C,
    D,
    E,
    F = {},
    G = !1,
    H = [];
  a.watchData = {}, this.init = function (h) {
    if (B = h, C = h.$options || m.ngModelOptions, u = angular.isDefined(c.closeOnDateSelection) ? a.$parent.$eval(c.closeOnDateSelection) : k.closeOnDateSelection, v = angular.isDefined(c.datepickerAppendToBody) ? a.$parent.$eval(c.datepickerAppendToBody) : k.appendToBody, w = angular.isDefined(c.onOpenFocus) ? a.$parent.$eval(c.onOpenFocus) : k.onOpenFocus, x = angular.isDefined(c.datepickerPopupTemplateUrl) ? c.datepickerPopupTemplateUrl : k.datepickerPopupTemplateUrl, y = angular.isDefined(c.datepickerTemplateUrl) ? c.datepickerTemplateUrl : k.datepickerTemplateUrl, E = angular.isDefined(c.altInputFormats) ? a.$parent.$eval(c.altInputFormats) : k.altInputFormats, a.showButtonBar = angular.isDefined(c.showButtonBar) ? a.$parent.$eval(c.showButtonBar) : k.showButtonBar, k.html5Types[c.type] ? (t = k.html5Types[c.type], G = !0) : (t = c.uibDatepickerPopup || k.datepickerPopup, c.$observe("uibDatepickerPopup", function (a, b) {
      var c = a || k.datepickerPopup;
      if (c !== t && (t = c, B.$modelValue = null, !t)) throw new Error("uibDatepickerPopup must have a date format specified.");
    })), !t) throw new Error("uibDatepickerPopup must have a date format specified.");
    if (G && c.uibDatepickerPopup) throw new Error("HTML5 date input types do not support custom formats.");
    z = angular.element("<div uib-datepicker-popup-wrap><div uib-datepicker></div></div>"), a.ngModelOptions = angular.copy(C), a.ngModelOptions.timezone = null, z.attr({
      "ng-model": "date",
      "ng-model-options": "ngModelOptions",
      "ng-change": "dateSelection(date)",
      "template-url": x
    }), A = angular.element(z.children()[0]), A.attr("template-url", y), G && "month" === c.type && (A.attr("datepicker-mode", '"month"'), A.attr("min-mode", "month")), a.datepickerOptions && angular.forEach(a.datepickerOptions, function (a, b) {
      -1 === ["minDate", "maxDate", "minMode", "maxMode", "initDate", "datepickerMode"].indexOf(b) ? A.attr(n(b), a) : A.attr(n(b), "datepickerOptions." + b);
    }), angular.forEach(["minMode", "maxMode", "datepickerMode", "shortcutPropagation"], function (b) {
      if (c[b]) {
        var d = e(c[b]),
          f = {
            get: function get() {
              return d(a.$parent);
            }
          };
        if (A.attr(n(b), "watchData." + b), "datepickerMode" === b) {
          var g = d.assign;
          f.set = function (b) {
            g(a.$parent, b);
          };
        }
        Object.defineProperty(a.watchData, b, f);
      }
    }), angular.forEach(["minDate", "maxDate", "initDate"], function (b) {
      if (c[b]) {
        var d = e(c[b]);
        H.push(a.$parent.$watch(d, function (c) {
          "minDate" === b || "maxDate" === b ? (null === c ? F[b] = null : angular.isDate(c) ? F[b] = j.fromTimezone(new Date(c), C.timezone) : F[b] = new Date(i(c, "medium")), a.watchData[b] = null === c ? null : F[b]) : a.watchData[b] = j.fromTimezone(new Date(c), C.timezone);
        })), A.attr(n(b), "watchData." + b);
      }
    }), c.dateDisabled && A.attr("date-disabled", "dateDisabled({ date: date, mode: mode })"), angular.forEach(["formatDay", "formatMonth", "formatYear", "formatDayHeader", "formatDayTitle", "formatMonthTitle", "showWeeks", "startingDay", "yearRows", "yearColumns"], function (a) {
      angular.isDefined(c[a]) && A.attr(n(a), c[a]);
    }), c.customClass && A.attr("custom-class", "customClass({ date: date, mode: mode })"), G ? B.$formatters.push(function (b) {
      return a.date = j.fromTimezone(b, C.timezone), b;
    }) : (B.$$parserName = "date", B.$validators.date = q, B.$parsers.unshift(p), B.$formatters.push(function (b) {
      return B.$isEmpty(b) ? (a.date = b, b) : (a.date = j.fromTimezone(b, C.timezone), angular.isNumber(a.date) && (a.date = new Date(a.date)), j.filter(a.date, t));
    })), B.$viewChangeListeners.push(function () {
      a.date = o(B.$viewValue);
    }), b.on("keydown", s), D = d(z)(a), z.remove(), v ? f.find("body").append(D) : b.after(D), a.$on("$destroy", function () {
      for (a.isOpen === !0 && (g.$$phase || a.$apply(function () {
        a.isOpen = !1;
      })), D.remove(), b.off("keydown", s), f.off("click", r); H.length;) H.shift()();
    });
  }, a.getText = function (b) {
    return a[b + "Text"] || k[b + "Text"];
  }, a.isDisabled = function (b) {
    return "today" === b && (b = new Date()), a.watchData.minDate && a.compare(b, F.minDate) < 0 || a.watchData.maxDate && a.compare(b, F.maxDate) > 0;
  }, a.compare = function (a, b) {
    return new Date(a.getFullYear(), a.getMonth(), a.getDate()) - new Date(b.getFullYear(), b.getMonth(), b.getDate());
  }, a.dateSelection = function (c) {
    angular.isDefined(c) && (a.date = c);
    var d = a.date ? j.filter(a.date, t) : null;
    b.val(d), B.$setViewValue(d), u && (a.isOpen = !1, b[0].focus());
  }, a.keydown = function (c) {
    27 === c.which && (c.stopPropagation(), a.isOpen = !1, b[0].focus());
  }, a.select = function (b) {
    if ("today" === b) {
      var c = new Date();
      angular.isDate(a.date) ? (b = new Date(a.date), b.setFullYear(c.getFullYear(), c.getMonth(), c.getDate())) : b = new Date(c.setHours(0, 0, 0, 0));
    }
    a.dateSelection(b);
  }, a.close = function () {
    a.isOpen = !1, b[0].focus();
  }, a.disabled = angular.isDefined(c.disabled) || !1, c.ngDisabled && H.push(a.$parent.$watch(e(c.ngDisabled), function (b) {
    a.disabled = b;
  })), a.$watch("isOpen", function (c) {
    c ? a.disabled ? a.isOpen = !1 : (a.position = v ? h.offset(b) : h.position(b), a.position.top = a.position.top + b.prop("offsetHeight"), l(function () {
      w && a.$broadcast("uib:datepicker.focus"), f.on("click", r);
    }, 0, !1)) : f.off("click", r);
  });
}]).directive("uibDatepickerPopup", function () {
  return {
    require: ["ngModel", "uibDatepickerPopup"],
    controller: "UibDatepickerPopupController",
    scope: {
      datepickerOptions: "=?",
      isOpen: "=?",
      currentText: "@",
      clearText: "@",
      closeText: "@",
      dateDisabled: "&",
      customClass: "&"
    },
    link: function link(a, b, c, d) {
      var e = d[0],
        f = d[1];
      f.init(e);
    }
  };
}).directive("uibDatepickerPopupWrap", function () {
  return {
    replace: !0,
    transclude: !0,
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/datepicker/popup.html";
    }
  };
}), angular.module("ui.bootstrap.debounce", []).factory("$$debounce", ["$timeout", function (a) {
  return function (b, c) {
    var d;
    return function () {
      var e = this,
        f = Array.prototype.slice.call(arguments);
      d && a.cancel(d), d = a(function () {
        b.apply(e, f);
      }, c);
    };
  };
}]), angular.module("ui.bootstrap.dropdown", ["ui.bootstrap.position"]).constant("uibDropdownConfig", {
  appendToOpenClass: "uib-dropdown-open",
  openClass: "open"
}).service("uibDropdownService", ["$document", "$rootScope", function (a, b) {
  var c = null;
  this.open = function (b) {
    c || (a.on("click", d), a.on("keydown", e)), c && c !== b && (c.isOpen = !1), c = b;
  }, this.close = function (b) {
    c === b && (c = null, a.off("click", d), a.off("keydown", e));
  };
  var d = function d(a) {
      if (c && !(a && "disabled" === c.getAutoClose() || a && 3 === a.which)) {
        var d = c.getToggleElement();
        if (!(a && d && d[0].contains(a.target))) {
          var e = c.getDropdownElement();
          a && "outsideClick" === c.getAutoClose() && e && e[0].contains(a.target) || (c.isOpen = !1, b.$$phase || c.$apply());
        }
      }
    },
    e = function e(a) {
      27 === a.which ? (c.focusToggleElement(), d()) : c.isKeynavEnabled() && -1 !== [38, 40].indexOf(a.which) && c.isOpen && (a.preventDefault(), a.stopPropagation(), c.focusDropdownEntry(a.which));
    };
}]).controller("UibDropdownController", ["$scope", "$element", "$attrs", "$parse", "uibDropdownConfig", "uibDropdownService", "$animate", "$uibPosition", "$document", "$compile", "$templateRequest", function (a, b, c, d, e, f, g, h, i, j, k) {
  var l,
    m,
    n = this,
    o = a.$new(),
    p = e.appendToOpenClass,
    q = e.openClass,
    r = angular.noop,
    s = c.onToggle ? d(c.onToggle) : angular.noop,
    t = !1,
    u = null,
    v = !1,
    w = i.find("body");
  b.addClass("dropdown"), this.init = function () {
    if (c.isOpen && (m = d(c.isOpen), r = m.assign, a.$watch(m, function (a) {
      o.isOpen = !!a;
    })), angular.isDefined(c.dropdownAppendTo)) {
      var e = d(c.dropdownAppendTo)(o);
      e && (u = angular.element(e));
    }
    t = angular.isDefined(c.dropdownAppendToBody), v = angular.isDefined(c.keyboardNav), t && !u && (u = w), u && n.dropdownMenu && (u.append(n.dropdownMenu), b.on("$destroy", function () {
      n.dropdownMenu.remove();
    }));
  }, this.toggle = function (a) {
    return o.isOpen = arguments.length ? !!a : !o.isOpen;
  }, this.isOpen = function () {
    return o.isOpen;
  }, o.getToggleElement = function () {
    return n.toggleElement;
  }, o.getAutoClose = function () {
    return c.autoClose || "always";
  }, o.getElement = function () {
    return b;
  }, o.isKeynavEnabled = function () {
    return v;
  }, o.focusDropdownEntry = function (a) {
    var c = n.dropdownMenu ? angular.element(n.dropdownMenu).find("a") : b.find("ul").eq(0).find("a");
    switch (a) {
      case 40:
        angular.isNumber(n.selectedOption) ? n.selectedOption = n.selectedOption === c.length - 1 ? n.selectedOption : n.selectedOption + 1 : n.selectedOption = 0;
        break;
      case 38:
        angular.isNumber(n.selectedOption) ? n.selectedOption = 0 === n.selectedOption ? 0 : n.selectedOption - 1 : n.selectedOption = c.length - 1;
    }
    c[n.selectedOption].focus();
  }, o.getDropdownElement = function () {
    return n.dropdownMenu;
  }, o.focusToggleElement = function () {
    n.toggleElement && n.toggleElement[0].focus();
  }, o.$watch("isOpen", function (c, d) {
    if (u && n.dropdownMenu) {
      var e,
        i,
        m = h.positionElements(b, n.dropdownMenu, "bottom-left", !0);
      if (e = {
        top: m.top + "px",
        display: c ? "block" : "none"
      }, i = n.dropdownMenu.hasClass("dropdown-menu-right"), i ? (e.left = "auto", e.right = window.innerWidth - (m.left + b.prop("offsetWidth")) + "px") : (e.left = m.left + "px", e.right = "auto"), !t) {
        var v = h.offset(u);
        e.top = m.top - v.top + "px", i ? e.right = window.innerWidth - (m.left - v.left + b.prop("offsetWidth")) + "px" : e.left = m.left - v.left + "px";
      }
      n.dropdownMenu.css(e);
    }
    var w = u ? u : b;
    if (g[c ? "addClass" : "removeClass"](w, u ? p : q).then(function () {
      angular.isDefined(c) && c !== d && s(a, {
        open: !!c
      });
    }), c) n.dropdownMenuTemplateUrl && k(n.dropdownMenuTemplateUrl).then(function (a) {
      l = o.$new(), j(a.trim())(l, function (a) {
        var b = a;
        n.dropdownMenu.replaceWith(b), n.dropdownMenu = b;
      });
    }), o.focusToggleElement(), f.open(o);else {
      if (n.dropdownMenuTemplateUrl) {
        l && l.$destroy();
        var x = angular.element('<ul class="dropdown-menu"></ul>');
        n.dropdownMenu.replaceWith(x), n.dropdownMenu = x;
      }
      f.close(o), n.selectedOption = null;
    }
    angular.isFunction(r) && r(a, c);
  }), a.$on("$locationChangeSuccess", function () {
    "disabled" !== o.getAutoClose() && (o.isOpen = !1);
  });
}]).directive("uibDropdown", function () {
  return {
    controller: "UibDropdownController",
    link: function link(a, b, c, d) {
      d.init();
    }
  };
}).directive("uibDropdownMenu", function () {
  return {
    restrict: "A",
    require: "?^uibDropdown",
    link: function link(a, b, c, d) {
      if (d && !angular.isDefined(c.dropdownNested)) {
        b.addClass("dropdown-menu");
        var e = c.templateUrl;
        e && (d.dropdownMenuTemplateUrl = e), d.dropdownMenu || (d.dropdownMenu = b);
      }
    }
  };
}).directive("uibDropdownToggle", function () {
  return {
    require: "?^uibDropdown",
    link: function link(a, b, c, d) {
      if (d) {
        b.addClass("dropdown-toggle"), d.toggleElement = b;
        var e = function e(_e) {
          _e.preventDefault(), b.hasClass("disabled") || c.disabled || a.$apply(function () {
            d.toggle();
          });
        };
        b.bind("click", e), b.attr({
          "aria-haspopup": !0,
          "aria-expanded": !1
        }), a.$watch(d.isOpen, function (a) {
          b.attr("aria-expanded", !!a);
        }), a.$on("$destroy", function () {
          b.unbind("click", e);
        });
      }
    }
  };
}), angular.module("ui.bootstrap.stackedMap", []).factory("$$stackedMap", function () {
  return {
    createNew: function createNew() {
      var a = [];
      return {
        add: function add(b, c) {
          a.push({
            key: b,
            value: c
          });
        },
        get: function get(b) {
          for (var c = 0; c < a.length; c++) if (b === a[c].key) return a[c];
        },
        keys: function keys() {
          for (var b = [], c = 0; c < a.length; c++) b.push(a[c].key);
          return b;
        },
        top: function top() {
          return a[a.length - 1];
        },
        remove: function remove(b) {
          for (var c = -1, d = 0; d < a.length; d++) if (b === a[d].key) {
            c = d;
            break;
          }
          return a.splice(c, 1)[0];
        },
        removeTop: function removeTop() {
          return a.splice(a.length - 1, 1)[0];
        },
        length: function length() {
          return a.length;
        }
      };
    }
  };
}), angular.module("ui.bootstrap.modal", ["ui.bootstrap.stackedMap"]).factory("$$multiMap", function () {
  return {
    createNew: function createNew() {
      var a = {};
      return {
        entries: function entries() {
          return Object.keys(a).map(function (b) {
            return {
              key: b,
              value: a[b]
            };
          });
        },
        get: function get(b) {
          return a[b];
        },
        hasKey: function hasKey(b) {
          return !!a[b];
        },
        keys: function keys() {
          return Object.keys(a);
        },
        put: function put(b, c) {
          a[b] || (a[b] = []), a[b].push(c);
        },
        remove: function remove(b, c) {
          var d = a[b];
          if (d) {
            var e = d.indexOf(c);
            -1 !== e && d.splice(e, 1), d.length || delete a[b];
          }
        }
      };
    }
  };
}).provider("$uibResolve", function () {
  var a = this;
  this.resolver = null, this.setResolver = function (a) {
    this.resolver = a;
  }, this.$get = ["$injector", "$q", function (b, c) {
    var d = a.resolver ? b.get(a.resolver) : null;
    return {
      resolve: function resolve(a, e, f, g) {
        if (d) return d.resolve(a, e, f, g);
        var h = [];
        return angular.forEach(a, function (a) {
          angular.isFunction(a) || angular.isArray(a) ? h.push(c.resolve(b.invoke(a))) : angular.isString(a) ? h.push(c.resolve(b.get(a))) : h.push(c.resolve(a));
        }), c.all(h).then(function (b) {
          var c = {},
            d = 0;
          return angular.forEach(a, function (a, e) {
            c[e] = b[d++];
          }), c;
        });
      }
    };
  }];
}).directive("uibModalBackdrop", ["$animateCss", "$injector", "$uibModalStack", function (a, b, c) {
  function d(b, d, e) {
    e.modalInClass && (a(d, {
      addClass: e.modalInClass
    }).start(), b.$on(c.NOW_CLOSING_EVENT, function (c, f) {
      var g = f();
      b.modalOptions.animation ? a(d, {
        removeClass: e.modalInClass
      }).start().then(g) : g();
    }));
  }
  return {
    replace: !0,
    templateUrl: "uib/template/modal/backdrop.html",
    compile: function compile(a, b) {
      return a.addClass(b.backdropClass), d;
    }
  };
}]).directive("uibModalWindow", ["$uibModalStack", "$q", "$animate", "$animateCss", "$document", function (a, b, c, d, e) {
  return {
    scope: {
      index: "@"
    },
    replace: !0,
    transclude: !0,
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/modal/window.html";
    },
    link: function link(f, g, h) {
      g.addClass(h.windowClass || ""), g.addClass(h.windowTopClass || ""), f.size = h.size, f.close = function (b) {
        var c = a.getTop();
        c && c.value.backdrop && "static" !== c.value.backdrop && b.target === b.currentTarget && (b.preventDefault(), b.stopPropagation(), a.dismiss(c.key, "backdrop click"));
      }, g.on("click", f.close), f.$isRendered = !0;
      var i = b.defer();
      h.$observe("modalRender", function (a) {
        "true" === a && i.resolve();
      }), i.promise.then(function () {
        var i = null;
        h.modalInClass && (i = d(g, {
          addClass: h.modalInClass
        }).start(), f.$on(a.NOW_CLOSING_EVENT, function (a, b) {
          var e = b();
          d ? d(g, {
            removeClass: h.modalInClass
          }).start().then(e) : c.removeClass(g, h.modalInClass).then(e);
        })), b.when(i).then(function () {
          if (!e[0].activeElement || !g[0].contains(e[0].activeElement)) {
            var a = g[0].querySelector("[autofocus]");
            a ? a.focus() : g[0].focus();
          }
        });
        var j = a.getTop();
        j && a.modalRendered(j.key);
      });
    }
  };
}]).directive("uibModalAnimationClass", function () {
  return {
    compile: function compile(a, b) {
      b.modalAnimation && a.addClass(b.uibModalAnimationClass);
    }
  };
}).directive("uibModalTransclude", function () {
  return {
    link: function link(a, b, c, d, e) {
      e(a.$parent, function (a) {
        b.empty(), b.append(a);
      });
    }
  };
}).factory("$uibModalStack", ["$animate", "$animateCss", "$document", "$compile", "$rootScope", "$q", "$$multiMap", "$$stackedMap", function (a, b, c, d, e, f, g, h) {
  function i() {
    for (var a = -1, b = t.keys(), c = 0; c < b.length; c++) t.get(b[c]).value.backdrop && (a = c);
    return a;
  }
  function j(a, b) {
    var c = t.get(a).value,
      d = c.appendTo;
    t.remove(a), m(c.modalDomEl, c.modalScope, function () {
      var b = c.openedClass || s;
      u.remove(b, a), d.toggleClass(b, u.hasKey(b)), k(!0);
    }, c.closedDeferred), l(), b && b.focus ? b.focus() : d.focus && d.focus();
  }
  function k(a) {
    var b;
    t.length() > 0 && (b = t.top().value, b.modalDomEl.toggleClass(b.windowTopClass || "", a));
  }
  function l() {
    if (p && -1 === i()) {
      var a = q;
      m(p, q, function () {
        a = null;
      }), p = void 0, q = void 0;
    }
  }
  function m(a, c, d, e) {
    function g() {
      g.done || (g.done = !0, b(a, {
        event: "leave"
      }).start().then(function () {
        a.remove(), e && e.resolve();
      }), c.$destroy(), d && d());
    }
    var h,
      i = null,
      j = function j() {
        return h || (h = f.defer(), i = h.promise), function () {
          h.resolve();
        };
      };
    return c.$broadcast(v.NOW_CLOSING_EVENT, j), f.when(i).then(g);
  }
  function n(a) {
    if (a.isDefaultPrevented()) return a;
    var b = t.top();
    if (b) switch (a.which) {
      case 27:
        b.value.keyboard && (a.preventDefault(), e.$apply(function () {
          v.dismiss(b.key, "escape key press");
        }));
        break;
      case 9:
        v.loadFocusElementList(b);
        var c = !1;
        a.shiftKey ? (v.isFocusInFirstItem(a) || v.isModalFocused(a, b)) && (c = v.focusLastFocusableElement()) : v.isFocusInLastItem(a) && (c = v.focusFirstFocusableElement()), c && (a.preventDefault(), a.stopPropagation());
    }
  }
  function o(a, b, c) {
    return !a.value.modalScope.$broadcast("modal.closing", b, c).defaultPrevented;
  }
  var p,
    q,
    r,
    s = "modal-open",
    t = h.createNew(),
    u = g.createNew(),
    v = {
      NOW_CLOSING_EVENT: "modal.stack.now-closing"
    },
    w = 0,
    x = "a[href], area[href], input:not([disabled]), button:not([disabled]),select:not([disabled]), textarea:not([disabled]), iframe, object, embed, *[tabindex], *[contenteditable=true]";
  return e.$watch(i, function (a) {
    q && (q.index = a);
  }), c.on("keydown", n), e.$on("$destroy", function () {
    c.off("keydown", n);
  }), v.open = function (b, f) {
    var g = c[0].activeElement,
      h = f.openedClass || s;
    k(!1), t.add(b, {
      deferred: f.deferred,
      renderDeferred: f.renderDeferred,
      closedDeferred: f.closedDeferred,
      modalScope: f.scope,
      backdrop: f.backdrop,
      keyboard: f.keyboard,
      openedClass: f.openedClass,
      windowTopClass: f.windowTopClass,
      animation: f.animation,
      appendTo: f.appendTo
    }), u.put(h, b);
    var j = f.appendTo,
      l = i();
    if (!j.length) throw new Error("appendTo element not found. Make sure that the element passed is in DOM.");
    l >= 0 && !p && (q = e.$new(!0), q.modalOptions = f, q.index = l, p = angular.element('<div uib-modal-backdrop="modal-backdrop"></div>'), p.attr("backdrop-class", f.backdropClass), f.animation && p.attr("modal-animation", "true"), d(p)(q), a.enter(p, j));
    var m = angular.element('<div uib-modal-window="modal-window"></div>');
    m.attr({
      "template-url": f.windowTemplateUrl,
      "window-class": f.windowClass,
      "window-top-class": f.windowTopClass,
      size: f.size,
      index: t.length() - 1,
      animate: "animate"
    }).html(f.content), f.animation && m.attr("modal-animation", "true"), a.enter(d(m)(f.scope), j).then(function () {
      a.addClass(j, h);
    }), t.top().value.modalDomEl = m, t.top().value.modalOpener = g, v.clearFocusListCache();
  }, v.close = function (a, b) {
    var c = t.get(a);
    return c && o(c, b, !0) ? (c.value.modalScope.$$uibDestructionScheduled = !0, c.value.deferred.resolve(b), j(a, c.value.modalOpener), !0) : !c;
  }, v.dismiss = function (a, b) {
    var c = t.get(a);
    return c && o(c, b, !1) ? (c.value.modalScope.$$uibDestructionScheduled = !0, c.value.deferred.reject(b), j(a, c.value.modalOpener), !0) : !c;
  }, v.dismissAll = function (a) {
    for (var b = this.getTop(); b && this.dismiss(b.key, a);) b = this.getTop();
  }, v.getTop = function () {
    return t.top();
  }, v.modalRendered = function (a) {
    var b = t.get(a);
    b && b.value.renderDeferred.resolve();
  }, v.focusFirstFocusableElement = function () {
    return r.length > 0 ? (r[0].focus(), !0) : !1;
  }, v.focusLastFocusableElement = function () {
    return r.length > 0 ? (r[r.length - 1].focus(), !0) : !1;
  }, v.isModalFocused = function (a, b) {
    if (a && b) {
      var c = b.value.modalDomEl;
      if (c && c.length) return (a.target || a.srcElement) === c[0];
    }
    return !1;
  }, v.isFocusInFirstItem = function (a) {
    return r.length > 0 ? (a.target || a.srcElement) === r[0] : !1;
  }, v.isFocusInLastItem = function (a) {
    return r.length > 0 ? (a.target || a.srcElement) === r[r.length - 1] : !1;
  }, v.clearFocusListCache = function () {
    r = [], w = 0;
  }, v.loadFocusElementList = function (a) {
    if ((void 0 === r || !r.length) && a) {
      var b = a.value.modalDomEl;
      b && b.length && (r = b[0].querySelectorAll(x));
    }
  }, v;
}]).provider("$uibModal", function () {
  var a = {
    options: {
      animation: !0,
      backdrop: !0,
      keyboard: !0
    },
    $get: ["$rootScope", "$q", "$document", "$templateRequest", "$controller", "$uibResolve", "$uibModalStack", function (b, c, d, e, f, g, h) {
      function i(a) {
        return a.template ? c.when(a.template) : e(angular.isFunction(a.templateUrl) ? a.templateUrl() : a.templateUrl);
      }
      var j = {},
        k = null;
      return j.getPromiseChain = function () {
        return k;
      }, j.open = function (e) {
        function j() {
          return r;
        }
        var l = c.defer(),
          m = c.defer(),
          n = c.defer(),
          o = c.defer(),
          p = {
            result: l.promise,
            opened: m.promise,
            closed: n.promise,
            rendered: o.promise,
            close: function close(a) {
              return h.close(p, a);
            },
            dismiss: function dismiss(a) {
              return h.dismiss(p, a);
            }
          };
        if (e = angular.extend({}, a.options, e), e.resolve = e.resolve || {}, e.appendTo = e.appendTo || d.find("body").eq(0), !e.template && !e.templateUrl) throw new Error("One of template or templateUrl options is required.");
        var q,
          r = c.all([i(e), g.resolve(e.resolve, {}, null, null)]);
        return q = k = c.all([k]).then(j, j).then(function (a) {
          var c = e.scope || b,
            d = c.$new();
          d.$close = p.close, d.$dismiss = p.dismiss, d.$on("$destroy", function () {
            d.$$uibDestructionScheduled || d.$dismiss("$uibUnscheduledDestruction");
          });
          var g,
            i = {};
          e.controller && (i.$scope = d, i.$uibModalInstance = p, angular.forEach(a[1], function (a, b) {
            i[b] = a;
          }), g = f(e.controller, i), e.controllerAs && (e.bindToController && (g.$close = d.$close, g.$dismiss = d.$dismiss, angular.extend(g, c)), d[e.controllerAs] = g)), h.open(p, {
            scope: d,
            deferred: l,
            renderDeferred: o,
            closedDeferred: n,
            content: a[0],
            animation: e.animation,
            backdrop: e.backdrop,
            keyboard: e.keyboard,
            backdropClass: e.backdropClass,
            windowTopClass: e.windowTopClass,
            windowClass: e.windowClass,
            windowTemplateUrl: e.windowTemplateUrl,
            size: e.size,
            openedClass: e.openedClass,
            appendTo: e.appendTo
          }), m.resolve(!0);
        }, function (a) {
          m.reject(a), l.reject(a);
        })["finally"](function () {
          k === q && (k = null);
        }), p;
      }, j;
    }]
  };
  return a;
}), angular.module("ui.bootstrap.paging", []).factory("uibPaging", ["$parse", function (a) {
  return {
    create: function create(b, c, d) {
      b.setNumPages = d.numPages ? a(d.numPages).assign : angular.noop, b.ngModelCtrl = {
        $setViewValue: angular.noop
      }, b._watchers = [], b.init = function (e, f) {
        b.ngModelCtrl = e, b.config = f, e.$render = function () {
          b.render();
        }, d.itemsPerPage ? b._watchers.push(c.$parent.$watch(a(d.itemsPerPage), function (a) {
          b.itemsPerPage = parseInt(a, 10), c.totalPages = b.calculateTotalPages(), b.updatePage();
        })) : b.itemsPerPage = f.itemsPerPage, c.$watch("totalItems", function (a, d) {
          (angular.isDefined(a) || a !== d) && (c.totalPages = b.calculateTotalPages(), b.updatePage());
        });
      }, b.calculateTotalPages = function () {
        var a = b.itemsPerPage < 1 ? 1 : Math.ceil(c.totalItems / b.itemsPerPage);
        return Math.max(a || 0, 1);
      }, b.render = function () {
        c.page = parseInt(b.ngModelCtrl.$viewValue, 10) || 1;
      }, c.selectPage = function (a, d) {
        d && d.preventDefault();
        var e = !c.ngDisabled || !d;
        e && c.page !== a && a > 0 && a <= c.totalPages && (d && d.target && d.target.blur(), b.ngModelCtrl.$setViewValue(a), b.ngModelCtrl.$render());
      }, c.getText = function (a) {
        return c[a + "Text"] || b.config[a + "Text"];
      }, c.noPrevious = function () {
        return 1 === c.page;
      }, c.noNext = function () {
        return c.page === c.totalPages;
      }, b.updatePage = function () {
        b.setNumPages(c.$parent, c.totalPages), c.page > c.totalPages ? c.selectPage(c.totalPages) : b.ngModelCtrl.$render();
      }, c.$on("$destroy", function () {
        for (; b._watchers.length;) b._watchers.shift()();
      });
    }
  };
}]), angular.module("ui.bootstrap.pager", ["ui.bootstrap.paging"]).controller("UibPagerController", ["$scope", "$attrs", "uibPaging", "uibPagerConfig", function (a, b, c, d) {
  a.align = angular.isDefined(b.align) ? a.$parent.$eval(b.align) : d.align, c.create(this, a, b);
}]).constant("uibPagerConfig", {
  itemsPerPage: 10,
  previousText: "« Previous",
  nextText: "Next »",
  align: !0
}).directive("uibPager", ["uibPagerConfig", function (a) {
  return {
    scope: {
      totalItems: "=",
      previousText: "@",
      nextText: "@",
      ngDisabled: "="
    },
    require: ["uibPager", "?ngModel"],
    controller: "UibPagerController",
    controllerAs: "pager",
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/pager/pager.html";
    },
    replace: !0,
    link: function link(b, c, d, e) {
      var f = e[0],
        g = e[1];
      g && f.init(g, a);
    }
  };
}]), angular.module("ui.bootstrap.pagination", ["ui.bootstrap.paging"]).controller("UibPaginationController", ["$scope", "$attrs", "$parse", "uibPaging", "uibPaginationConfig", function (a, b, c, d, e) {
  function f(a, b, c) {
    return {
      number: a,
      text: b,
      active: c
    };
  }
  function g(a, b) {
    var c = [],
      d = 1,
      e = b,
      g = angular.isDefined(i) && b > i;
    g && (j ? (d = Math.max(a - Math.floor(i / 2), 1), e = d + i - 1, e > b && (e = b, d = e - i + 1)) : (d = (Math.ceil(a / i) - 1) * i + 1, e = Math.min(d + i - 1, b)));
    for (var h = d; e >= h; h++) {
      var m = f(h, h, h === a);
      c.push(m);
    }
    if (g && i > 0 && (!j || k || l)) {
      if (d > 1) {
        if (!l || d > 3) {
          var n = f(d - 1, "...", !1);
          c.unshift(n);
        }
        if (l) {
          if (3 === d) {
            var o = f(2, "2", !1);
            c.unshift(o);
          }
          var p = f(1, "1", !1);
          c.unshift(p);
        }
      }
      if (b > e) {
        if (!l || b - 2 > e) {
          var q = f(e + 1, "...", !1);
          c.push(q);
        }
        if (l) {
          if (e === b - 2) {
            var r = f(b - 1, b - 1, !1);
            c.push(r);
          }
          var s = f(b, b, !1);
          c.push(s);
        }
      }
    }
    return c;
  }
  var h = this,
    i = angular.isDefined(b.maxSize) ? a.$parent.$eval(b.maxSize) : e.maxSize,
    j = angular.isDefined(b.rotate) ? a.$parent.$eval(b.rotate) : e.rotate,
    k = angular.isDefined(b.forceEllipses) ? a.$parent.$eval(b.forceEllipses) : e.forceEllipses,
    l = angular.isDefined(b.boundaryLinkNumbers) ? a.$parent.$eval(b.boundaryLinkNumbers) : e.boundaryLinkNumbers;
  a.boundaryLinks = angular.isDefined(b.boundaryLinks) ? a.$parent.$eval(b.boundaryLinks) : e.boundaryLinks, a.directionLinks = angular.isDefined(b.directionLinks) ? a.$parent.$eval(b.directionLinks) : e.directionLinks, d.create(this, a, b), b.maxSize && h._watchers.push(a.$parent.$watch(c(b.maxSize), function (a) {
    i = parseInt(a, 10), h.render();
  }));
  var m = this.render;
  this.render = function () {
    m(), a.page > 0 && a.page <= a.totalPages && (a.pages = g(a.page, a.totalPages));
  };
}]).constant("uibPaginationConfig", {
  itemsPerPage: 10,
  boundaryLinks: !1,
  boundaryLinkNumbers: !1,
  directionLinks: !0,
  firstText: "First",
  previousText: "Previous",
  nextText: "Next",
  lastText: "Last",
  rotate: !0,
  forceEllipses: !1
}).directive("uibPagination", ["$parse", "uibPaginationConfig", function (a, b) {
  return {
    scope: {
      totalItems: "=",
      firstText: "@",
      previousText: "@",
      nextText: "@",
      lastText: "@",
      ngDisabled: "="
    },
    require: ["uibPagination", "?ngModel"],
    controller: "UibPaginationController",
    controllerAs: "pagination",
    templateUrl: function templateUrl(a, b) {
      return b.templateUrl || "uib/template/pagination/pagination.html";
    },
    replace: !0,
    link: function link(a, c, d, e) {
      var f = e[0],
        g = e[1];
      g && f.init(g, b);
    }
  };
}]), angular.module("ui.bootstrap.tooltip", ["ui.bootstrap.position", "ui.bootstrap.stackedMap"]).provider("$uibTooltip", function () {
  function a(a) {
    var b = /[A-Z]/g,
      c = "-";
    return a.replace(b, function (a, b) {
      return (b ? c : "") + a.toLowerCase();
    });
  }
  var b = {
      placement: "top",
      placementClassPrefix: "",
      animation: !0,
      popupDelay: 0,
      popupCloseDelay: 0,
      useContentExp: !1
    },
    c = {
      mouseenter: "mouseleave",
      click: "click",
      outsideClick: "outsideClick",
      focus: "blur",
      none: ""
    },
    d = {};
  this.options = function (a) {
    angular.extend(d, a);
  }, this.setTriggers = function (a) {
    angular.extend(c, a);
  }, this.$get = ["$window", "$compile", "$timeout", "$document", "$uibPosition", "$interpolate", "$rootScope", "$parse", "$$stackedMap", function (e, f, g, h, i, j, k, l, m) {
    function n(a) {
      if (27 === a.which) {
        var b = o.top();
        b && (b.value.close(), o.removeTop(), b = null);
      }
    }
    var o = m.createNew();
    return h.on("keypress", n), k.$on("$destroy", function () {
      h.off("keypress", n);
    }), function (e, k, m, n) {
      function p(a) {
        var b = (a || n.trigger || m).split(" "),
          d = b.map(function (a) {
            return c[a] || a;
          });
        return {
          show: b,
          hide: d
        };
      }
      n = angular.extend({}, b, d, n);
      var q = a(e),
        r = j.startSymbol(),
        s = j.endSymbol(),
        t = "<div " + q + '-popup title="' + r + "title" + s + '" ' + (n.useContentExp ? 'content-exp="contentExp()" ' : 'content="' + r + "content" + s + '" ') + 'placement="' + r + "placement" + s + '" popup-class="' + r + "popupClass" + s + '" animation="animation" is-open="isOpen"origin-scope="origScope" style="visibility: hidden; display: block; top: -9999px; left: -9999px;"></div>';
      return {
        compile: function compile(a, b) {
          var c = f(t);
          return function (a, b, d, f) {
            function j() {
              M.isOpen ? q() : m();
            }
            function m() {
              (!L || a.$eval(d[k + "Enable"])) && (u(), x(), M.popupDelay ? G || (G = g(r, M.popupDelay, !1)) : r());
            }
            function q() {
              s(), M.popupCloseDelay ? H || (H = g(t, M.popupCloseDelay, !1)) : t();
            }
            function r() {
              return s(), u(), M.content ? (v(), void M.$evalAsync(function () {
                M.isOpen = !0, y(!0), R();
              })) : angular.noop;
            }
            function s() {
              G && (g.cancel(G), G = null), I && (g.cancel(I), I = null);
            }
            function t() {
              M && M.$evalAsync(function () {
                M && (M.isOpen = !1, y(!1), M.animation ? F || (F = g(w, 150, !1)) : w());
              });
            }
            function u() {
              H && (g.cancel(H), H = null), F && (g.cancel(F), F = null);
            }
            function v() {
              D || (E = M.$new(), D = c(E, function (a) {
                J ? h.find("body").append(a) : b.after(a);
              }), z());
            }
            function w() {
              s(), u(), A(), D && (D.remove(), D = null), E && (E.$destroy(), E = null);
            }
            function x() {
              M.title = d[k + "Title"], P ? M.content = P(a) : M.content = d[e], M.popupClass = d[k + "Class"], M.placement = angular.isDefined(d[k + "Placement"]) ? d[k + "Placement"] : n.placement;
              var b = parseInt(d[k + "PopupDelay"], 10),
                c = parseInt(d[k + "PopupCloseDelay"], 10);
              M.popupDelay = isNaN(b) ? n.popupDelay : b, M.popupCloseDelay = isNaN(c) ? n.popupCloseDelay : c;
            }
            function y(b) {
              O && angular.isFunction(O.assign) && O.assign(a, b);
            }
            function z() {
              Q.length = 0, P ? (Q.push(a.$watch(P, function (a) {
                M.content = a, !a && M.isOpen && t();
              })), Q.push(E.$watch(function () {
                N || (N = !0, E.$$postDigest(function () {
                  N = !1, M && M.isOpen && R();
                }));
              }))) : Q.push(d.$observe(e, function (a) {
                M.content = a, !a && M.isOpen ? t() : R();
              })), Q.push(d.$observe(k + "Title", function (a) {
                M.title = a, M.isOpen && R();
              })), Q.push(d.$observe(k + "Placement", function (a) {
                M.placement = a ? a : n.placement, M.isOpen && R();
              }));
            }
            function A() {
              Q.length && (angular.forEach(Q, function (a) {
                a();
              }), Q.length = 0);
            }
            function B(a) {
              M && M.isOpen && D && (b[0].contains(a.target) || D[0].contains(a.target) || q());
            }
            function C() {
              var a = d[k + "Trigger"];
              S(), K = p(a), "none" !== K.show && K.show.forEach(function (a, c) {
                "outsideClick" === a ? (b.on("click", j), h.on("click", B)) : a === K.hide[c] ? b.on(a, j) : a && (b.on(a, m), b.on(K.hide[c], q)), b.on("keypress", function (a) {
                  27 === a.which && q();
                });
              });
            }
            var D,
              E,
              F,
              G,
              H,
              I,
              J = angular.isDefined(n.appendToBody) ? n.appendToBody : !1,
              K = p(void 0),
              L = angular.isDefined(d[k + "Enable"]),
              M = a.$new(!0),
              N = !1,
              O = angular.isDefined(d[k + "IsOpen"]) ? l(d[k + "IsOpen"]) : !1,
              P = n.useContentExp ? l(d[e]) : !1,
              Q = [],
              R = function R() {
                D && D.html() && (I || (I = g(function () {
                  D.css({
                    top: 0,
                    left: 0
                  });
                  var a = i.positionElements(b, D, M.placement, J);
                  D.css({
                    top: a.top + "px",
                    left: a.left + "px",
                    visibility: "visible"
                  }), n.placementClassPrefix && D.removeClass("top bottom left right"), D.removeClass(n.placementClassPrefix + "top " + n.placementClassPrefix + "top-left " + n.placementClassPrefix + "top-right " + n.placementClassPrefix + "bottom " + n.placementClassPrefix + "bottom-left " + n.placementClassPrefix + "bottom-right " + n.placementClassPrefix + "left " + n.placementClassPrefix + "left-top " + n.placementClassPrefix + "left-bottom " + n.placementClassPrefix + "right " + n.placementClassPrefix + "right-top " + n.placementClassPrefix + "right-bottom");
                  var c = a.placement.split("-");
                  D.addClass(c[0] + " " + n.placementClassPrefix + a.placement), i.positionArrow(D, a.placement), I = null;
                }, 0, !1)));
              };
            M.origScope = a, M.isOpen = !1, o.add(M, {
              close: t
            }), M.contentExp = function () {
              return M.content;
            }, d.$observe("disabled", function (a) {
              a && s(), a && M.isOpen && t();
            }), O && a.$watch(O, function (a) {
              M && !a === M.isOpen && j();
            });
            var S = function S() {
              K.show.forEach(function (a) {
                "outsideClick" === a ? b.off("click", j) : (b.off(a, m), b.off(a, j));
              }), K.hide.forEach(function (a) {
                "outsideClick" === a ? h.off("click", B) : b.off(a, q);
              });
            };
            C();
            var T = a.$eval(d[k + "Animation"]);
            M.animation = angular.isDefined(T) ? !!T : n.animation;
            var U,
              V = k + "AppendToBody";
            U = V in d && void 0 === d[V] ? !0 : a.$eval(d[V]), J = angular.isDefined(U) ? U : J, a.$on("$destroy", function () {
              S(), w(), o.remove(M), M = null;
            });
          };
        }
      };
    };
  }];
}).directive("uibTooltipTemplateTransclude", ["$animate", "$sce", "$compile", "$templateRequest", function (a, b, c, d) {
  return {
    link: function link(e, f, g) {
      var h,
        i,
        j,
        k = e.$eval(g.tooltipTemplateTranscludeScope),
        l = 0,
        m = function m() {
          i && (i.remove(), i = null), h && (h.$destroy(), h = null), j && (a.leave(j).then(function () {
            i = null;
          }), i = j, j = null);
        };
      e.$watch(b.parseAsResourceUrl(g.uibTooltipTemplateTransclude), function (b) {
        var g = ++l;
        b ? (d(b, !0).then(function (d) {
          if (g === l) {
            var e = k.$new(),
              i = d,
              n = c(i)(e, function (b) {
                m(), a.enter(b, f);
              });
            h = e, j = n, h.$emit("$includeContentLoaded", b);
          }
        }, function () {
          g === l && (m(), e.$emit("$includeContentError", b));
        }), e.$emit("$includeContentRequested", b)) : m();
      }), e.$on("$destroy", m);
    }
  };
}]).directive("uibTooltipClasses", ["$uibPosition", function (a) {
  return {
    restrict: "A",
    link: function link(b, c, d) {
      if (b.placement) {
        var e = a.parsePlacement(b.placement);
        c.addClass(e[0]);
      } else c.addClass("top");
      b.popupClass && c.addClass(b.popupClass), b.animation() && c.addClass(d.tooltipAnimationClass);
    }
  };
}]).directive("uibTooltipPopup", function () {
  return {
    replace: !0,
    scope: {
      content: "@",
      placement: "@",
      popupClass: "@",
      animation: "&",
      isOpen: "&"
    },
    templateUrl: "uib/template/tooltip/tooltip-popup.html"
  };
}).directive("uibTooltip", ["$uibTooltip", function (a) {
  return a("uibTooltip", "tooltip", "mouseenter");
}]).directive("uibTooltipTemplatePopup", function () {
  return {
    replace: !0,
    scope: {
      contentExp: "&",
      placement: "@",
      popupClass: "@",
      animation: "&",
      isOpen: "&",
      originScope: "&"
    },
    templateUrl: "uib/template/tooltip/tooltip-template-popup.html"
  };
}).directive("uibTooltipTemplate", ["$uibTooltip", function (a) {
  return a("uibTooltipTemplate", "tooltip", "mouseenter", {
    useContentExp: !0
  });
}]).directive("uibTooltipHtmlPopup", function () {
  return {
    replace: !0,
    scope: {
      contentExp: "&",
      placement: "@",
      popupClass: "@",
      animation: "&",
      isOpen: "&"
    },
    templateUrl: "uib/template/tooltip/tooltip-html-popup.html"
  };
}).directive("uibTooltipHtml", ["$uibTooltip", function (a) {
  return a("uibTooltipHtml", "tooltip", "mouseenter", {
    useContentExp: !0
  });
}]), angular.module("ui.bootstrap.popover", ["ui.bootstrap.tooltip"]).directive("uibPopoverTemplatePopup", function () {
  return {
    replace: !0,
    scope: {
      title: "@",
      contentExp: "&",
      placement: "@",
      popupClass: "@",
      animation: "&",
      isOpen: "&",
      originScope: "&"
    },
    templateUrl: "uib/template/popover/popover-template.html"
  };
}).directive("uibPopoverTemplate", ["$uibTooltip", function (a) {
  return a("uibPopoverTemplate", "popover", "click", {
    useContentExp: !0
  });
}]).directive("uibPopoverHtmlPopup", function () {
  return {
    replace: !0,
    scope: {
      contentExp: "&",
      title: "@",
      placement: "@",
      popupClass: "@",
      animation: "&",
      isOpen: "&"
    },
    templateUrl: "uib/template/popover/popover-html.html"
  };
}).directive("uibPopoverHtml", ["$uibTooltip", function (a) {
  return a("uibPopoverHtml", "popover", "click", {
    useContentExp: !0
  });
}]).directive("uibPopoverPopup", function () {
  return {
    replace: !0,
    scope: {
      title: "@",
      content: "@",
      placement: "@",
      popupClass: "@",
      animation: "&",
      isOpen: "&"
    },
    templateUrl: "uib/template/popover/popover.html"
  };
}).directive("uibPopover", ["$uibTooltip", function (a) {
  return a("uibPopover", "popover", "click");
}]), angular.module("ui.bootstrap.progressbar", []).constant("uibProgressConfig", {
  animate: !0,
  max: 100
}).controller("UibProgressController", ["$scope", "$attrs", "uibProgressConfig", function (a, b, c) {
  var d = this,
    e = angular.isDefined(b.animate) ? a.$parent.$eval(b.animate) : c.animate;
  this.bars = [], a.max = angular.isDefined(a.max) ? a.max : c.max, this.addBar = function (b, c, f) {
    e || c.css({
      transition: "none"
    }), this.bars.push(b), b.max = a.max, b.title = f && angular.isDefined(f.title) ? f.title : "progressbar", b.$watch("value", function (a) {
      b.recalculatePercentage();
    }), b.recalculatePercentage = function () {
      var a = d.bars.reduce(function (a, b) {
        return b.percent = +(100 * b.value / b.max).toFixed(2), a + b.percent;
      }, 0);
      a > 100 && (b.percent -= a - 100);
    }, b.$on("$destroy", function () {
      c = null, d.removeBar(b);
    });
  }, this.removeBar = function (a) {
    this.bars.splice(this.bars.indexOf(a), 1), this.bars.forEach(function (a) {
      a.recalculatePercentage();
    });
  }, a.$watch("max", function (b) {
    d.bars.forEach(function (b) {
      b.max = a.max, b.recalculatePercentage();
    });
  });
}]).directive("uibProgress", function () {
  return {
    replace: !0,
    transclude: !0,
    controller: "UibProgressController",
    require: "uibProgress",
    scope: {
      max: "=?"
    },
    templateUrl: "uib/template/progressbar/progress.html"
  };
}).directive("uibBar", function () {
  return {
    replace: !0,
    transclude: !0,
    require: "^uibProgress",
    scope: {
      value: "=",
      type: "@"
    },
    templateUrl: "uib/template/progressbar/bar.html",
    link: function link(a, b, c, d) {
      d.addBar(a, b, c);
    }
  };
}).directive("uibProgressbar", function () {
  return {
    replace: !0,
    transclude: !0,
    controller: "UibProgressController",
    scope: {
      value: "=",
      max: "=?",
      type: "@"
    },
    templateUrl: "uib/template/progressbar/progressbar.html",
    link: function link(a, b, c, d) {
      d.addBar(a, angular.element(b.children()[0]), {
        title: c.title
      });
    }
  };
}), angular.module("ui.bootstrap.rating", []).constant("uibRatingConfig", {
  max: 5,
  stateOn: null,
  stateOff: null,
  titles: ["one", "two", "three", "four", "five"]
}).controller("UibRatingController", ["$scope", "$attrs", "uibRatingConfig", function (a, b, c) {
  var d = {
    $setViewValue: angular.noop
  };
  this.init = function (e) {
    d = e, d.$render = this.render, d.$formatters.push(function (a) {
      return angular.isNumber(a) && a << 0 !== a && (a = Math.round(a)), a;
    }), this.stateOn = angular.isDefined(b.stateOn) ? a.$parent.$eval(b.stateOn) : c.stateOn, this.stateOff = angular.isDefined(b.stateOff) ? a.$parent.$eval(b.stateOff) : c.stateOff;
    var f = angular.isDefined(b.titles) ? a.$parent.$eval(b.titles) : c.titles;
    this.titles = angular.isArray(f) && f.length > 0 ? f : c.titles;
    var g = angular.isDefined(b.ratingStates) ? a.$parent.$eval(b.ratingStates) : new Array(angular.isDefined(b.max) ? a.$parent.$eval(b.max) : c.max);
    a.range = this.buildTemplateObjects(g);
  }, this.buildTemplateObjects = function (a) {
    for (var b = 0, c = a.length; c > b; b++) a[b] = angular.extend({
      index: b
    }, {
      stateOn: this.stateOn,
      stateOff: this.stateOff,
      title: this.getTitle(b)
    }, a[b]);
    return a;
  }, this.getTitle = function (a) {
    return a >= this.titles.length ? a + 1 : this.titles[a];
  }, a.rate = function (b) {
    !a.readonly && b >= 0 && b <= a.range.length && (d.$setViewValue(d.$viewValue === b ? 0 : b), d.$render());
  }, a.enter = function (b) {
    a.readonly || (a.value = b), a.onHover({
      value: b
    });
  }, a.reset = function () {
    a.value = d.$viewValue, a.onLeave();
  }, a.onKeydown = function (b) {
    /(37|38|39|40)/.test(b.which) && (b.preventDefault(), b.stopPropagation(), a.rate(a.value + (38 === b.which || 39 === b.which ? 1 : -1)));
  }, this.render = function () {
    a.value = d.$viewValue;
  };
}]).directive("uibRating", function () {
  return {
    require: ["uibRating", "ngModel"],
    scope: {
      readonly: "=?",
      onHover: "&",
      onLeave: "&"
    },
    controller: "UibRatingController",
    templateUrl: "uib/template/rating/rating.html",
    replace: !0,
    link: function link(a, b, c, d) {
      var e = d[0],
        f = d[1];
      e.init(f);
    }
  };
}), angular.module("ui.bootstrap.tabs", []).controller("UibTabsetController", ["$scope", function (a) {
  var b = this,
    c = b.tabs = a.tabs = [];
  b.select = function (a) {
    angular.forEach(c, function (b) {
      b.active && b !== a && (b.active = !1, b.onDeselect(), a.selectCalled = !1);
    }), a.active = !0, a.selectCalled || (a.onSelect(), a.selectCalled = !0);
  }, b.addTab = function (a) {
    c.push(a), 1 === c.length && a.active !== !1 ? a.active = !0 : a.active ? b.select(a) : a.active = !1;
  }, b.removeTab = function (a) {
    var e = c.indexOf(a);
    if (a.active && c.length > 1 && !d) {
      var f = e === c.length - 1 ? e - 1 : e + 1;
      b.select(c[f]);
    }
    c.splice(e, 1);
  };
  var d;
  a.$on("$destroy", function () {
    d = !0;
  });
}]).directive("uibTabset", function () {
  return {
    transclude: !0,
    replace: !0,
    scope: {
      type: "@"
    },
    controller: "UibTabsetController",
    templateUrl: "uib/template/tabs/tabset.html",
    link: function link(a, b, c) {
      a.vertical = angular.isDefined(c.vertical) ? a.$parent.$eval(c.vertical) : !1, a.justified = angular.isDefined(c.justified) ? a.$parent.$eval(c.justified) : !1;
    }
  };
}).directive("uibTab", ["$parse", function (a) {
  return {
    require: "^uibTabset",
    replace: !0,
    templateUrl: "uib/template/tabs/tab.html",
    transclude: !0,
    scope: {
      active: "=?",
      heading: "@",
      onSelect: "&select",
      onDeselect: "&deselect"
    },
    controller: function controller() {},
    controllerAs: "tab",
    link: function link(b, c, d, e, f) {
      b.$watch("active", function (a) {
        a && e.select(b);
      }), b.disabled = !1, d.disable && b.$parent.$watch(a(d.disable), function (a) {
        b.disabled = !!a;
      }), b.select = function () {
        b.disabled || (b.active = !0);
      }, e.addTab(b), b.$on("$destroy", function () {
        e.removeTab(b);
      }), b.$transcludeFn = f;
    }
  };
}]).directive("uibTabHeadingTransclude", function () {
  return {
    restrict: "A",
    require: "^uibTab",
    link: function link(a, b) {
      a.$watch("headingElement", function (a) {
        a && (b.html(""), b.append(a));
      });
    }
  };
}).directive("uibTabContentTransclude", function () {
  function a(a) {
    return a.tagName && (a.hasAttribute("uib-tab-heading") || a.hasAttribute("data-uib-tab-heading") || a.hasAttribute("x-uib-tab-heading") || "uib-tab-heading" === a.tagName.toLowerCase() || "data-uib-tab-heading" === a.tagName.toLowerCase() || "x-uib-tab-heading" === a.tagName.toLowerCase());
  }
  return {
    restrict: "A",
    require: "^uibTabset",
    link: function link(b, c, d) {
      var e = b.$eval(d.uibTabContentTransclude);
      e.$transcludeFn(e.$parent, function (b) {
        angular.forEach(b, function (b) {
          a(b) ? e.headingElement = b : c.append(b);
        });
      });
    }
  };
}), angular.module("ui.bootstrap.timepicker", []).constant("uibTimepickerConfig", {
  hourStep: 1,
  minuteStep: 1,
  secondStep: 1,
  showMeridian: !0,
  showSeconds: !1,
  meridians: null,
  readonlyInput: !1,
  mousewheel: !0,
  arrowkeys: !0,
  showSpinners: !0,
  templateUrl: "uib/template/timepicker/timepicker.html"
}).controller("UibTimepickerController", ["$scope", "$element", "$attrs", "$parse", "$log", "$locale", "uibTimepickerConfig", function (a, b, c, d, e, f, g) {
  function h() {
    var b = +a.hours,
      c = a.showMeridian ? b > 0 && 13 > b : b >= 0 && 24 > b;
    return c ? (a.showMeridian && (12 === b && (b = 0), a.meridian === u[1] && (b += 12)), b) : void 0;
  }
  function i() {
    var b = +a.minutes;
    return b >= 0 && 60 > b ? b : void 0;
  }
  function j() {
    var b = +a.seconds;
    return b >= 0 && 60 > b ? b : void 0;
  }
  function k(a) {
    return null === a ? "" : angular.isDefined(a) && a.toString().length < 2 ? "0" + a : a.toString();
  }
  function l(a) {
    m(), t.$setViewValue(new Date(r)), n(a);
  }
  function m() {
    t.$setValidity("time", !0), a.invalidHours = !1, a.invalidMinutes = !1, a.invalidSeconds = !1;
  }
  function n(b) {
    if (t.$modelValue) {
      var c = r.getHours(),
        d = r.getMinutes(),
        e = r.getSeconds();
      a.showMeridian && (c = 0 === c || 12 === c ? 12 : c % 12), a.hours = "h" === b ? c : k(c), "m" !== b && (a.minutes = k(d)), a.meridian = r.getHours() < 12 ? u[0] : u[1], "s" !== b && (a.seconds = k(e)), a.meridian = r.getHours() < 12 ? u[0] : u[1];
    } else a.hours = null, a.minutes = null, a.seconds = null, a.meridian = u[0];
  }
  function o(a) {
    r = q(r, a), l();
  }
  function p(a, b) {
    return q(a, 60 * b);
  }
  function q(a, b) {
    var c = new Date(a.getTime() + 1e3 * b),
      d = new Date(a);
    return d.setHours(c.getHours(), c.getMinutes(), c.getSeconds()), d;
  }
  var r = new Date(),
    s = [],
    t = {
      $setViewValue: angular.noop
    },
    u = angular.isDefined(c.meridians) ? a.$parent.$eval(c.meridians) : g.meridians || f.DATETIME_FORMATS.AMPMS;
  a.tabindex = angular.isDefined(c.tabindex) ? c.tabindex : 0, b.removeAttr("tabindex"), this.init = function (b, d) {
    t = b, t.$render = this.render, t.$formatters.unshift(function (a) {
      return a ? new Date(a) : null;
    });
    var e = d.eq(0),
      f = d.eq(1),
      h = d.eq(2),
      i = angular.isDefined(c.mousewheel) ? a.$parent.$eval(c.mousewheel) : g.mousewheel;
    i && this.setupMousewheelEvents(e, f, h);
    var j = angular.isDefined(c.arrowkeys) ? a.$parent.$eval(c.arrowkeys) : g.arrowkeys;
    j && this.setupArrowkeyEvents(e, f, h), a.readonlyInput = angular.isDefined(c.readonlyInput) ? a.$parent.$eval(c.readonlyInput) : g.readonlyInput, this.setupInputEvents(e, f, h);
  };
  var v = g.hourStep;
  c.hourStep && s.push(a.$parent.$watch(d(c.hourStep), function (a) {
    v = +a;
  }));
  var w = g.minuteStep;
  c.minuteStep && s.push(a.$parent.$watch(d(c.minuteStep), function (a) {
    w = +a;
  }));
  var x;
  s.push(a.$parent.$watch(d(c.min), function (a) {
    var b = new Date(a);
    x = isNaN(b) ? void 0 : b;
  }));
  var y;
  s.push(a.$parent.$watch(d(c.max), function (a) {
    var b = new Date(a);
    y = isNaN(b) ? void 0 : b;
  }));
  var z = !1;
  c.ngDisabled && s.push(a.$parent.$watch(d(c.ngDisabled), function (a) {
    z = a;
  })), a.noIncrementHours = function () {
    var a = p(r, 60 * v);
    return z || a > y || r > a && x > a;
  }, a.noDecrementHours = function () {
    var a = p(r, 60 * -v);
    return z || x > a || a > r && a > y;
  }, a.noIncrementMinutes = function () {
    var a = p(r, w);
    return z || a > y || r > a && x > a;
  }, a.noDecrementMinutes = function () {
    var a = p(r, -w);
    return z || x > a || a > r && a > y;
  }, a.noIncrementSeconds = function () {
    var a = q(r, A);
    return z || a > y || r > a && x > a;
  }, a.noDecrementSeconds = function () {
    var a = q(r, -A);
    return z || x > a || a > r && a > y;
  }, a.noToggleMeridian = function () {
    return r.getHours() < 12 ? z || p(r, 720) > y : z || p(r, -720) < x;
  };
  var A = g.secondStep;
  c.secondStep && s.push(a.$parent.$watch(d(c.secondStep), function (a) {
    A = +a;
  })), a.showSeconds = g.showSeconds, c.showSeconds && s.push(a.$parent.$watch(d(c.showSeconds), function (b) {
    a.showSeconds = !!b;
  })), a.showMeridian = g.showMeridian, c.showMeridian && s.push(a.$parent.$watch(d(c.showMeridian), function (b) {
    if (a.showMeridian = !!b, t.$error.time) {
      var c = h(),
        d = i();
      angular.isDefined(c) && angular.isDefined(d) && (r.setHours(c), l());
    } else n();
  })), this.setupMousewheelEvents = function (b, c, d) {
    var e = function e(a) {
      a.originalEvent && (a = a.originalEvent);
      var b = a.wheelDelta ? a.wheelDelta : -a.deltaY;
      return a.detail || b > 0;
    };
    b.bind("mousewheel wheel", function (b) {
      z || a.$apply(e(b) ? a.incrementHours() : a.decrementHours()), b.preventDefault();
    }), c.bind("mousewheel wheel", function (b) {
      z || a.$apply(e(b) ? a.incrementMinutes() : a.decrementMinutes()), b.preventDefault();
    }), d.bind("mousewheel wheel", function (b) {
      z || a.$apply(e(b) ? a.incrementSeconds() : a.decrementSeconds()), b.preventDefault();
    });
  }, this.setupArrowkeyEvents = function (b, c, d) {
    b.bind("keydown", function (b) {
      z || (38 === b.which ? (b.preventDefault(), a.incrementHours(), a.$apply()) : 40 === b.which && (b.preventDefault(), a.decrementHours(), a.$apply()));
    }), c.bind("keydown", function (b) {
      z || (38 === b.which ? (b.preventDefault(), a.incrementMinutes(), a.$apply()) : 40 === b.which && (b.preventDefault(), a.decrementMinutes(), a.$apply()));
    }), d.bind("keydown", function (b) {
      z || (38 === b.which ? (b.preventDefault(), a.incrementSeconds(), a.$apply()) : 40 === b.which && (b.preventDefault(), a.decrementSeconds(), a.$apply()));
    });
  }, this.setupInputEvents = function (b, c, d) {
    if (a.readonlyInput) return a.updateHours = angular.noop, a.updateMinutes = angular.noop, void (a.updateSeconds = angular.noop);
    var e = function e(b, c, d) {
      t.$setViewValue(null), t.$setValidity("time", !1), angular.isDefined(b) && (a.invalidHours = b), angular.isDefined(c) && (a.invalidMinutes = c), angular.isDefined(d) && (a.invalidSeconds = d);
    };
    a.updateHours = function () {
      var a = h(),
        b = i();
      t.$setDirty(), angular.isDefined(a) && angular.isDefined(b) ? (r.setHours(a), r.setMinutes(b), x > r || r > y ? e(!0) : l("h")) : e(!0);
    }, b.bind("blur", function (b) {
      t.$setTouched(), null === a.hours || "" === a.hours ? e(!0) : !a.invalidHours && a.hours < 10 && a.$apply(function () {
        a.hours = k(a.hours);
      });
    }), a.updateMinutes = function () {
      var a = i(),
        b = h();
      t.$setDirty(), angular.isDefined(a) && angular.isDefined(b) ? (r.setHours(b), r.setMinutes(a), x > r || r > y ? e(void 0, !0) : l("m")) : e(void 0, !0);
    }, c.bind("blur", function (b) {
      t.$setTouched(), null === a.minutes ? e(void 0, !0) : !a.invalidMinutes && a.minutes < 10 && a.$apply(function () {
        a.minutes = k(a.minutes);
      });
    }), a.updateSeconds = function () {
      var a = j();
      t.$setDirty(), angular.isDefined(a) ? (r.setSeconds(a), l("s")) : e(void 0, void 0, !0);
    }, d.bind("blur", function (b) {
      !a.invalidSeconds && a.seconds < 10 && a.$apply(function () {
        a.seconds = k(a.seconds);
      });
    });
  }, this.render = function () {
    var b = t.$viewValue;
    isNaN(b) ? (t.$setValidity("time", !1), e.error('Timepicker directive: "ng-model" value must be a Date object, a number of milliseconds since 01.01.1970 or a string representing an RFC2822 or ISO 8601 date.')) : (b && (r = b), x > r || r > y ? (t.$setValidity("time", !1), a.invalidHours = !0, a.invalidMinutes = !0) : m(), n());
  }, a.showSpinners = angular.isDefined(c.showSpinners) ? a.$parent.$eval(c.showSpinners) : g.showSpinners, a.incrementHours = function () {
    a.noIncrementHours() || o(60 * v * 60);
  }, a.decrementHours = function () {
    a.noDecrementHours() || o(60 * -v * 60);
  }, a.incrementMinutes = function () {
    a.noIncrementMinutes() || o(60 * w);
  }, a.decrementMinutes = function () {
    a.noDecrementMinutes() || o(60 * -w);
  }, a.incrementSeconds = function () {
    a.noIncrementSeconds() || o(A);
  }, a.decrementSeconds = function () {
    a.noDecrementSeconds() || o(-A);
  }, a.toggleMeridian = function () {
    var b = i(),
      c = h();
    a.noToggleMeridian() || (angular.isDefined(b) && angular.isDefined(c) ? o(720 * (r.getHours() < 12 ? 60 : -60)) : a.meridian = a.meridian === u[0] ? u[1] : u[0]);
  }, a.blur = function () {
    t.$setTouched();
  }, a.$on("$destroy", function () {
    for (; s.length;) s.shift()();
  });
}]).directive("uibTimepicker", ["uibTimepickerConfig", function (a) {
  return {
    require: ["uibTimepicker", "?^ngModel"],
    controller: "UibTimepickerController",
    controllerAs: "timepicker",
    replace: !0,
    scope: {},
    templateUrl: function templateUrl(b, c) {
      return c.templateUrl || a.templateUrl;
    },
    link: function link(a, b, c, d) {
      var e = d[0],
        f = d[1];
      f && e.init(f, b.find("input"));
    }
  };
}]), angular.module("ui.bootstrap.typeahead", ["ui.bootstrap.debounce", "ui.bootstrap.position"]).factory("uibTypeaheadParser", ["$parse", function (a) {
  var b = /^\s*([\s\S]+?)(?:\s+as\s+([\s\S]+?))?\s+for\s+(?:([\$\w][\$\w\d]*))\s+in\s+([\s\S]+?)$/;
  return {
    parse: function parse(c) {
      var d = c.match(b);
      if (!d) throw new Error('Expected typeahead specification in form of "_modelValue_ (as _label_)? for _item_ in _collection_" but got "' + c + '".');
      return {
        itemName: d[3],
        source: a(d[4]),
        viewMapper: a(d[2] || d[1]),
        modelMapper: a(d[1])
      };
    }
  };
}]).controller("UibTypeaheadController", ["$scope", "$element", "$attrs", "$compile", "$parse", "$q", "$timeout", "$document", "$window", "$rootScope", "$$debounce", "$uibPosition", "uibTypeaheadParser", function (a, b, c, d, e, f, g, h, i, j, k, l, m) {
  function n() {
    N.moveInProgress || (N.moveInProgress = !0, N.$digest()), Y();
  }
  function o() {
    N.position = D ? l.offset(b) : l.position(b), N.position.top += b.prop("offsetHeight");
  }
  var p,
    q,
    r = [9, 13, 27, 38, 40],
    s = 200,
    t = a.$eval(c.typeaheadMinLength);
  t || 0 === t || (t = 1);
  var u = a.$eval(c.typeaheadWaitMs) || 0,
    v = a.$eval(c.typeaheadEditable) !== !1;
  a.$watch(c.typeaheadEditable, function (a) {
    v = a !== !1;
  });
  var w,
    x,
    y = e(c.typeaheadLoading).assign || angular.noop,
    z = e(c.typeaheadOnSelect),
    A = angular.isDefined(c.typeaheadSelectOnBlur) ? a.$eval(c.typeaheadSelectOnBlur) : !1,
    B = e(c.typeaheadNoResults).assign || angular.noop,
    C = c.typeaheadInputFormatter ? e(c.typeaheadInputFormatter) : void 0,
    D = c.typeaheadAppendToBody ? a.$eval(c.typeaheadAppendToBody) : !1,
    E = c.typeaheadAppendTo ? a.$eval(c.typeaheadAppendTo) : null,
    F = a.$eval(c.typeaheadFocusFirst) !== !1,
    G = c.typeaheadSelectOnExact ? a.$eval(c.typeaheadSelectOnExact) : !1,
    H = e(c.typeaheadIsOpen).assign || angular.noop,
    I = a.$eval(c.typeaheadShowHint) || !1,
    J = e(c.ngModel),
    K = e(c.ngModel + "($$$p)"),
    L = function L(b, c) {
      return angular.isFunction(J(a)) && q && q.$options && q.$options.getterSetter ? K(b, {
        $$$p: c
      }) : J.assign(b, c);
    },
    M = m.parse(c.uibTypeahead),
    N = a.$new(),
    O = a.$on("$destroy", function () {
      N.$destroy();
    });
  N.$on("$destroy", O);
  var P = "typeahead-" + N.$id + "-" + Math.floor(1e4 * Math.random());
  b.attr({
    "aria-autocomplete": "list",
    "aria-expanded": !1,
    "aria-owns": P
  });
  var Q, R;
  I && (Q = angular.element("<div></div>"), Q.css("position", "relative"), b.after(Q), R = b.clone(), R.attr("placeholder", ""), R.val(""), R.css({
    position: "absolute",
    top: "0px",
    left: "0px",
    "border-color": "transparent",
    "box-shadow": "none",
    opacity: 1,
    background: "none 0% 0% / auto repeat scroll padding-box border-box rgb(255, 255, 255)",
    color: "#999"
  }), b.css({
    position: "relative",
    "vertical-align": "top",
    "background-color": "transparent"
  }), Q.append(R), R.after(b));
  var S = angular.element("<div uib-typeahead-popup></div>");
  S.attr({
    id: P,
    matches: "matches",
    active: "activeIdx",
    select: "select(activeIdx, evt)",
    "move-in-progress": "moveInProgress",
    query: "query",
    position: "position",
    "assign-is-open": "assignIsOpen(isOpen)",
    debounce: "debounceUpdate"
  }), angular.isDefined(c.typeaheadTemplateUrl) && S.attr("template-url", c.typeaheadTemplateUrl), angular.isDefined(c.typeaheadPopupTemplateUrl) && S.attr("popup-template-url", c.typeaheadPopupTemplateUrl);
  var T = function T() {
      I && R.val("");
    },
    U = function U() {
      N.matches = [], N.activeIdx = -1, b.attr("aria-expanded", !1), T();
    },
    V = function V(a) {
      return P + "-option-" + a;
    };
  N.$watch("activeIdx", function (a) {
    0 > a ? b.removeAttr("aria-activedescendant") : b.attr("aria-activedescendant", V(a));
  });
  var W = function W(a, b) {
      return N.matches.length > b && a ? a.toUpperCase() === N.matches[b].label.toUpperCase() : !1;
    },
    X = function X(c, d) {
      var e = {
        $viewValue: c
      };
      y(a, !0), B(a, !1), f.when(M.source(a, e)).then(function (f) {
        var g = c === p.$viewValue;
        if (g && w) if (f && f.length > 0) {
          N.activeIdx = F ? 0 : -1, B(a, !1), N.matches.length = 0;
          for (var h = 0; h < f.length; h++) e[M.itemName] = f[h], N.matches.push({
            id: V(h),
            label: M.viewMapper(N, e),
            model: f[h]
          });
          if (N.query = c, o(), b.attr("aria-expanded", !0), G && 1 === N.matches.length && W(c, 0) && (angular.isNumber(N.debounceUpdate) || angular.isObject(N.debounceUpdate) ? k(function () {
            N.select(0, d);
          }, angular.isNumber(N.debounceUpdate) ? N.debounceUpdate : N.debounceUpdate["default"]) : N.select(0, d)), I) {
            var i = N.matches[0].label;
            angular.isString(c) && c.length > 0 && i.slice(0, c.length).toUpperCase() === c.toUpperCase() ? R.val(c + i.slice(c.length)) : R.val("");
          }
        } else U(), B(a, !0);
        g && y(a, !1);
      }, function () {
        U(), y(a, !1), B(a, !0);
      });
    };
  D && (angular.element(i).on("resize", n), h.find("body").on("scroll", n));
  var Y = k(function () {
    N.matches.length && o(), N.moveInProgress = !1;
  }, s);
  N.moveInProgress = !1, N.query = void 0;
  var Z,
    $ = function $(a) {
      Z = g(function () {
        X(a);
      }, u);
    },
    _ = function _() {
      Z && g.cancel(Z);
    };
  U(), N.assignIsOpen = function (b) {
    H(a, b);
  }, N.select = function (d, e) {
    var f,
      h,
      i = {};
    x = !0, i[M.itemName] = h = N.matches[d].model, f = M.modelMapper(a, i), L(a, f), p.$setValidity("editable", !0), p.$setValidity("parse", !0), z(a, {
      $item: h,
      $model: f,
      $label: M.viewMapper(a, i),
      $event: e
    }), U(), N.$eval(c.typeaheadFocusOnSelect) !== !1 && g(function () {
      b[0].focus();
    }, 0, !1);
  }, b.on("keydown", function (a) {
    if (0 !== N.matches.length && -1 !== r.indexOf(a.which)) {
      if (-1 === N.activeIdx && (9 === a.which || 13 === a.which)) return U(), void N.$digest();
      a.preventDefault();
      var b;
      switch (a.which) {
        case 9:
        case 13:
          N.$apply(function () {
            angular.isNumber(N.debounceUpdate) || angular.isObject(N.debounceUpdate) ? k(function () {
              N.select(N.activeIdx, a);
            }, angular.isNumber(N.debounceUpdate) ? N.debounceUpdate : N.debounceUpdate["default"]) : N.select(N.activeIdx, a);
          });
          break;
        case 27:
          a.stopPropagation(), U(), N.$digest();
          break;
        case 38:
          N.activeIdx = (N.activeIdx > 0 ? N.activeIdx : N.matches.length) - 1, N.$digest(), b = S.find("li")[N.activeIdx], b.parentNode.scrollTop = b.offsetTop;
          break;
        case 40:
          N.activeIdx = (N.activeIdx + 1) % N.matches.length, N.$digest(), b = S.find("li")[N.activeIdx], b.parentNode.scrollTop = b.offsetTop;
      }
    }
  }), b.bind("focus", function (a) {
    w = !0, 0 !== t || p.$viewValue || g(function () {
      X(p.$viewValue, a);
    }, 0);
  }), b.bind("blur", function (a) {
    A && N.matches.length && -1 !== N.activeIdx && !x && (x = !0, N.$apply(function () {
      angular.isObject(N.debounceUpdate) && angular.isNumber(N.debounceUpdate.blur) ? k(function () {
        N.select(N.activeIdx, a);
      }, N.debounceUpdate.blur) : N.select(N.activeIdx, a);
    })), !v && p.$error.editable && (p.$viewValue = "", b.val("")), w = !1, x = !1;
  });
  var aa = function aa(a) {
    b[0] !== a.target && 3 !== a.which && 0 !== N.matches.length && (U(), j.$$phase || N.$digest());
  };
  h.on("click", aa), a.$on("$destroy", function () {
    h.off("click", aa), (D || E) && ba.remove(), D && (angular.element(i).off("resize", n), h.find("body").off("scroll", n)), S.remove(), I && Q.remove();
  });
  var ba = d(S)(N);
  D ? h.find("body").append(ba) : E ? angular.element(E).eq(0).append(ba) : b.after(ba), this.init = function (b, c) {
    p = b, q = c, N.debounceUpdate = p.$options && e(p.$options.debounce)(a), p.$parsers.unshift(function (b) {
      return w = !0, 0 === t || b && b.length >= t ? u > 0 ? (_(), $(b)) : X(b) : (y(a, !1), _(), U()), v ? b : b ? void p.$setValidity("editable", !1) : (p.$setValidity("editable", !0), null);
    }), p.$formatters.push(function (b) {
      var c,
        d,
        e = {};
      return v || p.$setValidity("editable", !0), C ? (e.$model = b, C(a, e)) : (e[M.itemName] = b, c = M.viewMapper(a, e), e[M.itemName] = void 0, d = M.viewMapper(a, e), c !== d ? c : b);
    });
  };
}]).directive("uibTypeahead", function () {
  return {
    controller: "UibTypeaheadController",
    require: ["ngModel", "^?ngModelOptions", "uibTypeahead"],
    link: function link(a, b, c, d) {
      d[2].init(d[0], d[1]);
    }
  };
}).directive("uibTypeaheadPopup", ["$$debounce", function (a) {
  return {
    scope: {
      matches: "=",
      query: "=",
      active: "=",
      position: "&",
      moveInProgress: "=",
      select: "&",
      assignIsOpen: "&",
      debounce: "&"
    },
    replace: !0,
    templateUrl: function templateUrl(a, b) {
      return b.popupTemplateUrl || "uib/template/typeahead/typeahead-popup.html";
    },
    link: function link(b, c, d) {
      b.templateUrl = d.templateUrl, b.isOpen = function () {
        var a = b.matches.length > 0;
        return b.assignIsOpen({
          isOpen: a
        }), a;
      }, b.isActive = function (a) {
        return b.active === a;
      }, b.selectActive = function (a) {
        b.active = a;
      }, b.selectMatch = function (c, d) {
        var e = b.debounce();
        angular.isNumber(e) || angular.isObject(e) ? a(function () {
          b.select({
            activeIdx: c,
            evt: d
          });
        }, angular.isNumber(e) ? e : e["default"]) : b.select({
          activeIdx: c,
          evt: d
        });
      };
    }
  };
}]).directive("uibTypeaheadMatch", ["$templateRequest", "$compile", "$parse", function (a, b, c) {
  return {
    scope: {
      index: "=",
      match: "=",
      query: "="
    },
    link: function link(d, e, f) {
      var g = c(f.templateUrl)(d.$parent) || "uib/template/typeahead/typeahead-match.html";
      a(g).then(function (a) {
        var c = angular.element(a.trim());
        e.replaceWith(c), b(c)(d);
      });
    }
  };
}]).filter("uibTypeaheadHighlight", ["$sce", "$injector", "$log", function (a, b, c) {
  function d(a) {
    return a.replace(/([.?*+^$[\]\\(){}|-])/g, "\\$1");
  }
  function e(a) {
    return /<.*>/g.test(a);
  }
  var f;
  return f = b.has("$sanitize"), function (b, g) {
    return !f && e(b) && c.warn("Unsafe use of typeahead please use ngSanitize"), b = g ? ("" + b).replace(new RegExp(d(g), "gi"), "<strong>$&</strong>") : b, f || (b = a.trustAsHtml(b)), b;
  };
}]), angular.module("uib/template/accordion/accordion-group.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/accordion/accordion-group.html", '<div class="panel" ng-class="panelClass || \'panel-default\'">\n  <div role="tab" id="{{::headingId}}" aria-selected="{{isOpen}}" class="panel-heading" ng-keypress="toggleOpen($event)">\n    <h4 class="panel-title">\n      <a role="button" data-toggle="collapse" href aria-expanded="{{isOpen}}" aria-controls="{{::panelId}}" tabindex="0" class="accordion-toggle" ng-click="toggleOpen()" uib-accordion-transclude="heading"><span ng-class="{\'text-muted\': isDisabled}">{{heading}}</span></a>\n    </h4>\n  </div>\n  <div id="{{::panelId}}" aria-labelledby="{{::headingId}}" aria-hidden="{{!isOpen}}" role="tabpanel" class="panel-collapse collapse" uib-collapse="!isOpen">\n    <div class="panel-body" ng-transclude></div>\n  </div>\n</div>\n');
}]), angular.module("uib/template/accordion/accordion.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/accordion/accordion.html", '<div role="tablist" class="panel-group" ng-transclude></div>');
}]), angular.module("uib/template/alert/alert.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/alert/alert.html", '<div class="alert" ng-class="[\'alert-\' + (type || \'warning\'), closeable ? \'alert-dismissible\' : null]" role="alert">\n    <button ng-show="closeable" type="button" class="close" ng-click="close({$event: $event})">\n        <span aria-hidden="true">&times;</span>\n        <span class="sr-only">Close</span>\n    </button>\n    <div ng-transclude></div>\n</div>\n');
}]), angular.module("uib/template/carousel/carousel.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/carousel/carousel.html", '<div ng-mouseenter="pause()" ng-mouseleave="play()" class="carousel" ng-swipe-right="prev()" ng-swipe-left="next()">\n  <div class="carousel-inner" ng-transclude></div>\n  <a role="button" href class="left carousel-control" ng-click="prev()" ng-show="slides.length > 1">\n    <span aria-hidden="true" class="glyphicon glyphicon-chevron-left"></span>\n    <span class="sr-only">previous</span>\n  </a>\n  <a role="button" href class="right carousel-control" ng-click="next()" ng-show="slides.length > 1">\n    <span aria-hidden="true" class="glyphicon glyphicon-chevron-right"></span>\n    <span class="sr-only">next</span>\n  </a>\n  <ol class="carousel-indicators" ng-show="slides.length > 1">\n    <li ng-repeat="slide in slides | orderBy:indexOfSlide track by $index" ng-class="{ active: isActive(slide) }" ng-click="select(slide)">\n      <span class="sr-only">slide {{ $index + 1 }} of {{ slides.length }}<span ng-if="isActive(slide)">, currently active</span></span>\n    </li>\n  </ol>\n</div>');
}]), angular.module("uib/template/carousel/slide.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/carousel/slide.html", '<div ng-class="{\n    \'active\': active\n  }" class="item text-center" ng-transclude></div>\n');
}]), angular.module("uib/template/datepicker/datepicker.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/datepicker/datepicker.html", '<div class="uib-datepicker" ng-switch="datepickerMode" role="application" ng-keydown="keydown($event)">\n  <uib-daypicker ng-switch-when="day" tabindex="0"></uib-daypicker>\n  <uib-monthpicker ng-switch-when="month" tabindex="0"></uib-monthpicker>\n  <uib-yearpicker ng-switch-when="year" tabindex="0"></uib-yearpicker>\n</div>');
}]), angular.module("uib/template/datepicker/day.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/datepicker/day.html", '<table class="uib-daypicker" role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{::5 + showWeeks}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n    <tr>\n      <th ng-if="showWeeks" class="text-center"></th>\n      <th ng-repeat="label in ::labels track by $index" class="text-center"><small aria-label="{{::label.full}}">{{::label.abbr}}</small></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class="uib-weeks" ng-repeat="row in rows track by $index">\n      <td ng-if="showWeeks" class="text-center h6"><em>{{ weekNumbers[$index] }}</em></td>\n      <td ng-repeat="dt in row" class="uib-day text-center" role="gridcell"\n        id="{{::dt.uid}}"\n        ng-class="::dt.customClass">\n        <button type="button" class="btn btn-default btn-sm"\n          uib-is-class="\n            \'btn-info\' for selectedDt,\n            \'active\' for activeDt\n            on dt"\n          ng-click="select(dt.date)"\n          ng-disabled="::dt.disabled"\n          tabindex="-1"><span ng-class="::{\'text-muted\': dt.secondary, \'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n');
}]), angular.module("uib/template/datepicker/month.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/datepicker/month.html", '<table class="uib-monthpicker" role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class="uib-months" ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row" class="uib-month text-center" role="gridcell"\n        id="{{::dt.uid}}"\n        ng-class="::dt.customClass">\n        <button type="button" class="btn btn-default"\n          uib-is-class="\n            \'btn-info\' for selectedDt,\n            \'active\' for activeDt\n            on dt"\n          ng-click="select(dt.date)"\n          ng-disabled="::dt.disabled"\n          tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n');
}]), angular.module("uib/template/datepicker/popup.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/datepicker/popup.html", '<div>\n  <ul class="uib-datepicker-popup dropdown-menu" dropdown-nested ng-if="isOpen" ng-style="{top: position.top+\'px\', left: position.left+\'px\'}" ng-keydown="keydown($event)" ng-click="$event.stopPropagation()">\n    <li ng-transclude></li>\n    <li ng-if="showButtonBar" class="uib-button-bar">\n    <span class="btn-group pull-left">\n      <button type="button" class="btn btn-sm btn-info uib-datepicker-current" ng-click="select(\'today\')" ng-disabled="isDisabled(\'today\')">{{ getText(\'current\') }}</button>\n      <button type="button" class="btn btn-sm btn-danger uib-clear" ng-click="select(null)">{{ getText(\'clear\') }}</button>\n    </span>\n      <button type="button" class="btn btn-sm btn-success pull-right uib-close" ng-click="close()">{{ getText(\'close\') }}</button>\n    </li>\n  </ul>\n</div>\n');
}]), angular.module("uib/template/datepicker/year.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/datepicker/year.html", '<table class="uib-yearpicker" role="grid" aria-labelledby="{{::uniqueId}}-title" aria-activedescendant="{{activeDateId}}">\n  <thead>\n    <tr>\n      <th><button type="button" class="btn btn-default btn-sm pull-left uib-left" ng-click="move(-1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-left"></i></button></th>\n      <th colspan="{{::columns - 2}}"><button id="{{::uniqueId}}-title" role="heading" aria-live="assertive" aria-atomic="true" type="button" class="btn btn-default btn-sm uib-title" ng-click="toggleMode()" ng-disabled="datepickerMode === maxMode" tabindex="-1"><strong>{{title}}</strong></button></th>\n      <th><button type="button" class="btn btn-default btn-sm pull-right uib-right" ng-click="move(1)" tabindex="-1"><i class="glyphicon glyphicon-chevron-right"></i></button></th>\n    </tr>\n  </thead>\n  <tbody>\n    <tr class="uib-years" ng-repeat="row in rows track by $index">\n      <td ng-repeat="dt in row" class="uib-year text-center" role="gridcell"\n        id="{{::dt.uid}}"\n        ng-class="::dt.customClass">\n        <button type="button" class="btn btn-default"\n          uib-is-class="\n            \'btn-info\' for selectedDt,\n            \'active\' for activeDt\n            on dt"\n          ng-click="select(dt.date)"\n          ng-disabled="::dt.disabled"\n          tabindex="-1"><span ng-class="::{\'text-info\': dt.current}">{{::dt.label}}</span></button>\n      </td>\n    </tr>\n  </tbody>\n</table>\n');
}]), angular.module("uib/template/modal/backdrop.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/modal/backdrop.html", '<div class="modal-backdrop"\n     uib-modal-animation-class="fade"\n     modal-in-class="in"\n     ng-style="{\'z-index\': 1040 + (index && 1 || 0) + index*10}"\n></div>\n');
}]), angular.module("uib/template/modal/window.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/modal/window.html", '<div modal-render="{{$isRendered}}" tabindex="-1" role="dialog" class="modal"\n    uib-modal-animation-class="fade"\n    modal-in-class="in"\n    ng-style="{\'z-index\': 1050 + index*10, display: \'block\'}">\n    <div class="modal-dialog {{size ? \'modal-\' + size : \'\'}}"><div class="modal-content" uib-modal-transclude></div></div>\n</div>\n');
}]), angular.module("uib/template/pager/pager.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/pager/pager.html", '<ul class="pager">\n  <li ng-class="{disabled: noPrevious()||ngDisabled, previous: align}"><a href ng-click="selectPage(page - 1, $event)">{{::getText(\'previous\')}}</a></li>\n  <li ng-class="{disabled: noNext()||ngDisabled, next: align}"><a href ng-click="selectPage(page + 1, $event)">{{::getText(\'next\')}}</a></li>\n</ul>\n');
}]), angular.module("uib/template/pagination/pagination.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/pagination/pagination.html", '<ul class="pagination">\n  <li ng-if="::boundaryLinks" ng-class="{disabled: noPrevious()||ngDisabled}" class="pagination-first"><a href ng-click="selectPage(1, $event)">{{::getText(\'first\')}}</a></li>\n  <li ng-if="::directionLinks" ng-class="{disabled: noPrevious()||ngDisabled}" class="pagination-prev"><a href ng-click="selectPage(page - 1, $event)">{{::getText(\'previous\')}}</a></li>\n  <li ng-repeat="page in pages track by $index" ng-class="{active: page.active,disabled: ngDisabled&&!page.active}" class="pagination-page"><a href ng-click="selectPage(page.number, $event)">{{page.text}}</a></li>\n  <li ng-if="::directionLinks" ng-class="{disabled: noNext()||ngDisabled}" class="pagination-next"><a href ng-click="selectPage(page + 1, $event)">{{::getText(\'next\')}}</a></li>\n  <li ng-if="::boundaryLinks" ng-class="{disabled: noNext()||ngDisabled}" class="pagination-last"><a href ng-click="selectPage(totalPages, $event)">{{::getText(\'last\')}}</a></li>\n</ul>\n');
}]), angular.module("uib/template/tooltip/tooltip-html-popup.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/tooltip/tooltip-html-popup.html", '<div class="tooltip"\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind-html="contentExp()"></div>\n</div>\n');
}]), angular.module("uib/template/tooltip/tooltip-popup.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/tooltip/tooltip-popup.html", '<div class="tooltip"\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner" ng-bind="content"></div>\n</div>\n');
}]), angular.module("uib/template/tooltip/tooltip-template-popup.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/tooltip/tooltip-template-popup.html", '<div class="tooltip"\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="tooltip-arrow"></div>\n  <div class="tooltip-inner"\n    uib-tooltip-template-transclude="contentExp()"\n    tooltip-template-transclude-scope="originScope()"></div>\n</div>\n');
}]), angular.module("uib/template/popover/popover-html.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/popover/popover-html.html", '<div class="popover"\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content" ng-bind-html="contentExp()"></div>\n  </div>\n</div>\n');
}]), angular.module("uib/template/popover/popover-template.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/popover/popover-template.html", '<div class="popover"\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content"\n        uib-tooltip-template-transclude="contentExp()"\n        tooltip-template-transclude-scope="originScope()"></div>\n  </div>\n</div>\n');
}]), angular.module("uib/template/popover/popover.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/popover/popover.html", '<div class="popover"\n  tooltip-animation-class="fade"\n  uib-tooltip-classes\n  ng-class="{ in: isOpen() }">\n  <div class="arrow"></div>\n\n  <div class="popover-inner">\n      <h3 class="popover-title" ng-bind="title" ng-if="title"></h3>\n      <div class="popover-content" ng-bind="content"></div>\n  </div>\n</div>\n');
}]), angular.module("uib/template/progressbar/bar.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/progressbar/bar.html", '<div class="progress-bar" ng-class="type && \'progress-bar-\' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: (percent < 100 ? percent : 100) + \'%\'}" aria-valuetext="{{percent | number:0}}%" aria-labelledby="{{::title}}" ng-transclude></div>\n');
}]), angular.module("uib/template/progressbar/progress.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/progressbar/progress.html", '<div class="progress" ng-transclude aria-labelledby="{{::title}}"></div>');
}]), angular.module("uib/template/progressbar/progressbar.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/progressbar/progressbar.html", '<div class="progress">\n  <div class="progress-bar" ng-class="type && \'progress-bar-\' + type" role="progressbar" aria-valuenow="{{value}}" aria-valuemin="0" aria-valuemax="{{max}}" ng-style="{width: (percent < 100 ? percent : 100) + \'%\'}" aria-valuetext="{{percent | number:0}}%" aria-labelledby="{{::title}}" ng-transclude></div>\n</div>\n');
}]), angular.module("uib/template/rating/rating.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/rating/rating.html", '<span ng-mouseleave="reset()" ng-keydown="onKeydown($event)" tabindex="0" role="slider" aria-valuemin="0" aria-valuemax="{{range.length}}" aria-valuenow="{{value}}">\n    <span ng-repeat-start="r in range track by $index" class="sr-only">({{ $index < value ? \'*\' : \' \' }})</span>\n    <i ng-repeat-end ng-mouseenter="enter($index + 1)" ng-click="rate($index + 1)" class="glyphicon" ng-class="$index < value && (r.stateOn || \'glyphicon-star\') || (r.stateOff || \'glyphicon-star-empty\')" ng-attr-title="{{r.title}}" aria-valuetext="{{r.title}}"></i>\n</span>\n');
}]), angular.module("uib/template/tabs/tab.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/tabs/tab.html", '<li ng-class="{active: active, disabled: disabled}" class="uib-tab">\n  <a href ng-click="select()" uib-tab-heading-transclude>{{heading}}</a>\n</li>\n');
}]), angular.module("uib/template/tabs/tabset.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/tabs/tabset.html", '<div>\n  <ul class="nav nav-{{type || \'tabs\'}}" ng-class="{\'nav-stacked\': vertical, \'nav-justified\': justified}" ng-transclude></ul>\n  <div class="tab-content">\n    <div class="tab-pane" \n         ng-repeat="tab in tabs" \n         ng-class="{active: tab.active}"\n         uib-tab-content-transclude="tab">\n    </div>\n  </div>\n</div>\n');
}]), angular.module("uib/template/timepicker/timepicker.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/timepicker/timepicker.html", '<table class="uib-timepicker">\n  <tbody>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td class="uib-increment hours"><a ng-click="incrementHours()" ng-class="{disabled: noIncrementHours()}" class="btn btn-link" ng-disabled="noIncrementHours()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td>&nbsp;</td>\n      <td class="uib-increment minutes"><a ng-click="incrementMinutes()" ng-class="{disabled: noIncrementMinutes()}" class="btn btn-link" ng-disabled="noIncrementMinutes()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td ng-show="showSeconds">&nbsp;</td>\n      <td ng-show="showSeconds" class="uib-increment seconds"><a ng-click="incrementSeconds()" ng-class="{disabled: noIncrementSeconds()}" class="btn btn-link" ng-disabled="noIncrementSeconds()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-up"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n    <tr>\n      <td class="form-group uib-time hours" ng-class="{\'has-error\': invalidHours}">\n        <input style="width:50px;" type="text" placeholder="HH" ng-model="hours" ng-change="updateHours()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementHours()" ng-blur="blur()">\n      </td>\n      <td class="uib-separator">:</td>\n      <td class="form-group uib-time minutes" ng-class="{\'has-error\': invalidMinutes}">\n        <input style="width:50px;" type="text" placeholder="MM" ng-model="minutes" ng-change="updateMinutes()" class="form-control text-center" ng-readonly="::readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementMinutes()" ng-blur="blur()">\n      </td>\n      <td ng-show="showSeconds" class="uib-separator">:</td>\n      <td class="form-group uib-time seconds" ng-class="{\'has-error\': invalidSeconds}" ng-show="showSeconds">\n        <input style="width:50px;" type="text" placeholder="SS" ng-model="seconds" ng-change="updateSeconds()" class="form-control text-center" ng-readonly="readonlyInput" maxlength="2" tabindex="{{::tabindex}}" ng-disabled="noIncrementSeconds()" ng-blur="blur()">\n      </td>\n      <td ng-show="showMeridian" class="uib-time am-pm"><button type="button" ng-class="{disabled: noToggleMeridian()}" class="btn btn-default text-center" ng-click="toggleMeridian()" ng-disabled="noToggleMeridian()" tabindex="{{::tabindex}}">{{meridian}}</button></td>\n    </tr>\n    <tr class="text-center" ng-show="::showSpinners">\n      <td class="uib-decrement hours"><a ng-click="decrementHours()" ng-class="{disabled: noDecrementHours()}" class="btn btn-link" ng-disabled="noDecrementHours()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td>&nbsp;</td>\n      <td class="uib-decrement minutes"><a ng-click="decrementMinutes()" ng-class="{disabled: noDecrementMinutes()}" class="btn btn-link" ng-disabled="noDecrementMinutes()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td ng-show="showSeconds">&nbsp;</td>\n      <td ng-show="showSeconds" class="uib-decrement seconds"><a ng-click="decrementSeconds()" ng-class="{disabled: noDecrementSeconds()}" class="btn btn-link" ng-disabled="noDecrementSeconds()" tabindex="{{::tabindex}}"><span class="glyphicon glyphicon-chevron-down"></span></a></td>\n      <td ng-show="showMeridian"></td>\n    </tr>\n  </tbody>\n</table>\n');
}]), angular.module("uib/template/typeahead/typeahead-match.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/typeahead/typeahead-match.html", '<a href\n   tabindex="-1"\n   ng-bind-html="match.label | uibTypeaheadHighlight:query"\n   ng-attr-title="{{match.label}}"></a>\n');
}]), angular.module("uib/template/typeahead/typeahead-popup.html", []).run(["$templateCache", function (a) {
  a.put("uib/template/typeahead/typeahead-popup.html", '<ul class="dropdown-menu" ng-show="isOpen() && !moveInProgress" ng-style="{top: position().top+\'px\', left: position().left+\'px\'}" role="listbox" aria-hidden="{{!isOpen()}}">\n    <li ng-repeat="match in matches track by $index" ng-class="{active: isActive($index) }" ng-mouseenter="selectActive($index)" ng-click="selectMatch($index, $event)" role="option" id="{{::match.id}}">\n        <div uib-typeahead-match index="$index" match="match" query="query" template-url="templateUrl"></div>\n    </li>\n</ul>\n');
}]), angular.module("ui.bootstrap.carousel").run(function () {
  !angular.$$csp().noInlineStyle && angular.element(document).find("head").prepend('<style type="text/css">.ng-animate.item:not(.left):not(.right){-webkit-transition:0s ease-in-out left;transition:0s ease-in-out left}</style>');
}), angular.module("ui.bootstrap.datepicker").run(function () {
  !angular.$$csp().noInlineStyle && angular.element(document).find("head").prepend('<style type="text/css">.uib-datepicker .uib-title{width:100%;}.uib-day button,.uib-month button,.uib-year button{min-width:100%;}.uib-datepicker-popup.dropdown-menu{display:block;}.uib-button-bar{padding:10px 9px 2px;}</style>');
}), angular.module("ui.bootstrap.timepicker").run(function () {
  !angular.$$csp().noInlineStyle && angular.element(document).find("head").prepend('<style type="text/css">.uib-time input{width:50px;}</style>');
}), angular.module("ui.bootstrap.typeahead").run(function () {
  !angular.$$csp().noInlineStyle && angular.element(document).find("head").prepend('<style type="text/css">[uib-typeahead-popup].dropdown-menu{display:block;}</style>');
});
//! moment.js
//! version : 2.30.1
//! authors : Tim Wood, Iskren Chernev, Moment.js contributors
//! license : MIT
//! momentjs.com

;
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.moment = factory();
})(this, function () {
  'use strict';

  var hookCallback;
  function hooks() {
    return hookCallback.apply(null, arguments);
  }

  // This is done to register the method called with moment()
  // without creating circular dependencies.
  function setHookCallback(callback) {
    hookCallback = callback;
  }
  function isArray(input) {
    return input instanceof Array || Object.prototype.toString.call(input) === '[object Array]';
  }
  function isObject(input) {
    // IE8 will treat undefined and null as object if it wasn't for
    // input != null
    return input != null && Object.prototype.toString.call(input) === '[object Object]';
  }
  function hasOwnProp(a, b) {
    return Object.prototype.hasOwnProperty.call(a, b);
  }
  function isObjectEmpty(obj) {
    if (Object.getOwnPropertyNames) {
      return Object.getOwnPropertyNames(obj).length === 0;
    } else {
      var k;
      for (k in obj) {
        if (hasOwnProp(obj, k)) {
          return false;
        }
      }
      return true;
    }
  }
  function isUndefined(input) {
    return input === void 0;
  }
  function isNumber(input) {
    return typeof input === 'number' || Object.prototype.toString.call(input) === '[object Number]';
  }
  function isDate(input) {
    return input instanceof Date || Object.prototype.toString.call(input) === '[object Date]';
  }
  function map(arr, fn) {
    var res = [],
      i,
      arrLen = arr.length;
    for (i = 0; i < arrLen; ++i) {
      res.push(fn(arr[i], i));
    }
    return res;
  }
  function extend(a, b) {
    for (var i in b) {
      if (hasOwnProp(b, i)) {
        a[i] = b[i];
      }
    }
    if (hasOwnProp(b, 'toString')) {
      a.toString = b.toString;
    }
    if (hasOwnProp(b, 'valueOf')) {
      a.valueOf = b.valueOf;
    }
    return a;
  }
  function createUTC(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, true).utc();
  }
  function defaultParsingFlags() {
    // We need to deep clone this object.
    return {
      empty: false,
      unusedTokens: [],
      unusedInput: [],
      overflow: -2,
      charsLeftOver: 0,
      nullInput: false,
      invalidEra: null,
      invalidMonth: null,
      invalidFormat: false,
      userInvalidated: false,
      iso: false,
      parsedDateParts: [],
      era: null,
      meridiem: null,
      rfc2822: false,
      weekdayMismatch: false
    };
  }
  function getParsingFlags(m) {
    if (m._pf == null) {
      m._pf = defaultParsingFlags();
    }
    return m._pf;
  }
  var some;
  if (Array.prototype.some) {
    some = Array.prototype.some;
  } else {
    some = function some(fun) {
      var t = Object(this),
        len = t.length >>> 0,
        i;
      for (i = 0; i < len; i++) {
        if (i in t && fun.call(this, t[i], i, t)) {
          return true;
        }
      }
      return false;
    };
  }
  function isValid(m) {
    var flags = null,
      parsedParts = false,
      isNowValid = m._d && !isNaN(m._d.getTime());
    if (isNowValid) {
      flags = getParsingFlags(m);
      parsedParts = some.call(flags.parsedDateParts, function (i) {
        return i != null;
      });
      isNowValid = flags.overflow < 0 && !flags.empty && !flags.invalidEra && !flags.invalidMonth && !flags.invalidWeekday && !flags.weekdayMismatch && !flags.nullInput && !flags.invalidFormat && !flags.userInvalidated && (!flags.meridiem || flags.meridiem && parsedParts);
      if (m._strict) {
        isNowValid = isNowValid && flags.charsLeftOver === 0 && flags.unusedTokens.length === 0 && flags.bigHour === undefined;
      }
    }
    if (Object.isFrozen == null || !Object.isFrozen(m)) {
      m._isValid = isNowValid;
    } else {
      return isNowValid;
    }
    return m._isValid;
  }
  function createInvalid(flags) {
    var m = createUTC(NaN);
    if (flags != null) {
      extend(getParsingFlags(m), flags);
    } else {
      getParsingFlags(m).userInvalidated = true;
    }
    return m;
  }

  // Plugins that add properties should also add the key here (null value),
  // so we can properly clone ourselves.
  var momentProperties = hooks.momentProperties = [],
    updateInProgress = false;
  function copyConfig(to, from) {
    var i,
      prop,
      val,
      momentPropertiesLen = momentProperties.length;
    if (!isUndefined(from._isAMomentObject)) {
      to._isAMomentObject = from._isAMomentObject;
    }
    if (!isUndefined(from._i)) {
      to._i = from._i;
    }
    if (!isUndefined(from._f)) {
      to._f = from._f;
    }
    if (!isUndefined(from._l)) {
      to._l = from._l;
    }
    if (!isUndefined(from._strict)) {
      to._strict = from._strict;
    }
    if (!isUndefined(from._tzm)) {
      to._tzm = from._tzm;
    }
    if (!isUndefined(from._isUTC)) {
      to._isUTC = from._isUTC;
    }
    if (!isUndefined(from._offset)) {
      to._offset = from._offset;
    }
    if (!isUndefined(from._pf)) {
      to._pf = getParsingFlags(from);
    }
    if (!isUndefined(from._locale)) {
      to._locale = from._locale;
    }
    if (momentPropertiesLen > 0) {
      for (i = 0; i < momentPropertiesLen; i++) {
        prop = momentProperties[i];
        val = from[prop];
        if (!isUndefined(val)) {
          to[prop] = val;
        }
      }
    }
    return to;
  }

  // Moment prototype object
  function Moment(config) {
    copyConfig(this, config);
    this._d = new Date(config._d != null ? config._d.getTime() : NaN);
    if (!this.isValid()) {
      this._d = new Date(NaN);
    }
    // Prevent infinite loop in case updateOffset creates new moment
    // objects.
    if (updateInProgress === false) {
      updateInProgress = true;
      hooks.updateOffset(this);
      updateInProgress = false;
    }
  }
  function isMoment(obj) {
    return obj instanceof Moment || obj != null && obj._isAMomentObject != null;
  }
  function warn(msg) {
    if (hooks.suppressDeprecationWarnings === false && typeof console !== 'undefined' && console.warn) {
      console.warn('Deprecation warning: ' + msg);
    }
  }
  function deprecate(msg, fn) {
    var firstTime = true;
    return extend(function () {
      if (hooks.deprecationHandler != null) {
        hooks.deprecationHandler(null, msg);
      }
      if (firstTime) {
        var args = [],
          arg,
          i,
          key,
          argLen = arguments.length;
        for (i = 0; i < argLen; i++) {
          arg = '';
          if (_typeof(arguments[i]) === 'object') {
            arg += '\n[' + i + '] ';
            for (key in arguments[0]) {
              if (hasOwnProp(arguments[0], key)) {
                arg += key + ': ' + arguments[0][key] + ', ';
              }
            }
            arg = arg.slice(0, -2); // Remove trailing comma and space
          } else {
            arg = arguments[i];
          }
          args.push(arg);
        }
        warn(msg + '\nArguments: ' + Array.prototype.slice.call(args).join('') + '\n' + new Error().stack);
        firstTime = false;
      }
      return fn.apply(this, arguments);
    }, fn);
  }
  var deprecations = {};
  function deprecateSimple(name, msg) {
    if (hooks.deprecationHandler != null) {
      hooks.deprecationHandler(name, msg);
    }
    if (!deprecations[name]) {
      warn(msg);
      deprecations[name] = true;
    }
  }
  hooks.suppressDeprecationWarnings = false;
  hooks.deprecationHandler = null;
  function isFunction(input) {
    return typeof Function !== 'undefined' && input instanceof Function || Object.prototype.toString.call(input) === '[object Function]';
  }
  function set(config) {
    var prop, i;
    for (i in config) {
      if (hasOwnProp(config, i)) {
        prop = config[i];
        if (isFunction(prop)) {
          this[i] = prop;
        } else {
          this['_' + i] = prop;
        }
      }
    }
    this._config = config;
    // Lenient ordinal parsing accepts just a number in addition to
    // number + (possibly) stuff coming from _dayOfMonthOrdinalParse.
    // TODO: Remove "ordinalParse" fallback in next major release.
    this._dayOfMonthOrdinalParseLenient = new RegExp((this._dayOfMonthOrdinalParse.source || this._ordinalParse.source) + '|' + /\d{1,2}/.source);
  }
  function mergeConfigs(parentConfig, childConfig) {
    var res = extend({}, parentConfig),
      prop;
    for (prop in childConfig) {
      if (hasOwnProp(childConfig, prop)) {
        if (isObject(parentConfig[prop]) && isObject(childConfig[prop])) {
          res[prop] = {};
          extend(res[prop], parentConfig[prop]);
          extend(res[prop], childConfig[prop]);
        } else if (childConfig[prop] != null) {
          res[prop] = childConfig[prop];
        } else {
          delete res[prop];
        }
      }
    }
    for (prop in parentConfig) {
      if (hasOwnProp(parentConfig, prop) && !hasOwnProp(childConfig, prop) && isObject(parentConfig[prop])) {
        // make sure changes to properties don't modify parent config
        res[prop] = extend({}, res[prop]);
      }
    }
    return res;
  }
  function Locale(config) {
    if (config != null) {
      this.set(config);
    }
  }
  var keys;
  if (Object.keys) {
    keys = Object.keys;
  } else {
    keys = function keys(obj) {
      var i,
        res = [];
      for (i in obj) {
        if (hasOwnProp(obj, i)) {
          res.push(i);
        }
      }
      return res;
    };
  }
  var defaultCalendar = {
    sameDay: '[Today at] LT',
    nextDay: '[Tomorrow at] LT',
    nextWeek: 'dddd [at] LT',
    lastDay: '[Yesterday at] LT',
    lastWeek: '[Last] dddd [at] LT',
    sameElse: 'L'
  };
  function calendar(key, mom, now) {
    var output = this._calendar[key] || this._calendar['sameElse'];
    return isFunction(output) ? output.call(mom, now) : output;
  }
  function zeroFill(number, targetLength, forceSign) {
    var absNumber = '' + Math.abs(number),
      zerosToFill = targetLength - absNumber.length,
      sign = number >= 0;
    return (sign ? forceSign ? '+' : '' : '-') + Math.pow(10, Math.max(0, zerosToFill)).toString().substr(1) + absNumber;
  }
  var formattingTokens = /(\[[^\[]*\])|(\\)?([Hh]mm(ss)?|Mo|MM?M?M?|Do|DDDo|DD?D?D?|ddd?d?|do?|w[o|w]?|W[o|W]?|Qo?|N{1,5}|YYYYYY|YYYYY|YYYY|YY|y{2,4}|yo?|gg(ggg?)?|GG(GGG?)?|e|E|a|A|hh?|HH?|kk?|mm?|ss?|S{1,9}|x|X|zz?|ZZ?|.)/g,
    localFormattingTokens = /(\[[^\[]*\])|(\\)?(LTS|LT|LL?L?L?|l{1,4})/g,
    formatFunctions = {},
    formatTokenFunctions = {};

  // token:    'M'
  // padded:   ['MM', 2]
  // ordinal:  'Mo'
  // callback: function () { this.month() + 1 }
  function addFormatToken(token, padded, ordinal, callback) {
    var func = callback;
    if (typeof callback === 'string') {
      func = function func() {
        return this[callback]();
      };
    }
    if (token) {
      formatTokenFunctions[token] = func;
    }
    if (padded) {
      formatTokenFunctions[padded[0]] = function () {
        return zeroFill(func.apply(this, arguments), padded[1], padded[2]);
      };
    }
    if (ordinal) {
      formatTokenFunctions[ordinal] = function () {
        return this.localeData().ordinal(func.apply(this, arguments), token);
      };
    }
  }
  function removeFormattingTokens(input) {
    if (input.match(/\[[\s\S]/)) {
      return input.replace(/^\[|\]$/g, '');
    }
    return input.replace(/\\/g, '');
  }
  function makeFormatFunction(format) {
    var array = format.match(formattingTokens),
      i,
      length;
    for (i = 0, length = array.length; i < length; i++) {
      if (formatTokenFunctions[array[i]]) {
        array[i] = formatTokenFunctions[array[i]];
      } else {
        array[i] = removeFormattingTokens(array[i]);
      }
    }
    return function (mom) {
      var output = '',
        i;
      for (i = 0; i < length; i++) {
        output += isFunction(array[i]) ? array[i].call(mom, format) : array[i];
      }
      return output;
    };
  }

  // format date using native date object
  function formatMoment(m, format) {
    if (!m.isValid()) {
      return m.localeData().invalidDate();
    }
    format = expandFormat(format, m.localeData());
    formatFunctions[format] = formatFunctions[format] || makeFormatFunction(format);
    return formatFunctions[format](m);
  }
  function expandFormat(format, locale) {
    var i = 5;
    function replaceLongDateFormatTokens(input) {
      return locale.longDateFormat(input) || input;
    }
    localFormattingTokens.lastIndex = 0;
    while (i >= 0 && localFormattingTokens.test(format)) {
      format = format.replace(localFormattingTokens, replaceLongDateFormatTokens);
      localFormattingTokens.lastIndex = 0;
      i -= 1;
    }
    return format;
  }
  var defaultLongDateFormat = {
    LTS: 'h:mm:ss A',
    LT: 'h:mm A',
    L: 'MM/DD/YYYY',
    LL: 'MMMM D, YYYY',
    LLL: 'MMMM D, YYYY h:mm A',
    LLLL: 'dddd, MMMM D, YYYY h:mm A'
  };
  function longDateFormat(key) {
    var format = this._longDateFormat[key],
      formatUpper = this._longDateFormat[key.toUpperCase()];
    if (format || !formatUpper) {
      return format;
    }
    this._longDateFormat[key] = formatUpper.match(formattingTokens).map(function (tok) {
      if (tok === 'MMMM' || tok === 'MM' || tok === 'DD' || tok === 'dddd') {
        return tok.slice(1);
      }
      return tok;
    }).join('');
    return this._longDateFormat[key];
  }
  var defaultInvalidDate = 'Invalid date';
  function invalidDate() {
    return this._invalidDate;
  }
  var defaultOrdinal = '%d',
    defaultDayOfMonthOrdinalParse = /\d{1,2}/;
  function ordinal(number) {
    return this._ordinal.replace('%d', number);
  }
  var defaultRelativeTime = {
    future: 'in %s',
    past: '%s ago',
    s: 'a few seconds',
    ss: '%d seconds',
    m: 'a minute',
    mm: '%d minutes',
    h: 'an hour',
    hh: '%d hours',
    d: 'a day',
    dd: '%d days',
    w: 'a week',
    ww: '%d weeks',
    M: 'a month',
    MM: '%d months',
    y: 'a year',
    yy: '%d years'
  };
  function relativeTime(number, withoutSuffix, string, isFuture) {
    var output = this._relativeTime[string];
    return isFunction(output) ? output(number, withoutSuffix, string, isFuture) : output.replace(/%d/i, number);
  }
  function pastFuture(diff, output) {
    var format = this._relativeTime[diff > 0 ? 'future' : 'past'];
    return isFunction(format) ? format(output) : format.replace(/%s/i, output);
  }
  var aliases = {
    D: 'date',
    dates: 'date',
    date: 'date',
    d: 'day',
    days: 'day',
    day: 'day',
    e: 'weekday',
    weekdays: 'weekday',
    weekday: 'weekday',
    E: 'isoWeekday',
    isoweekdays: 'isoWeekday',
    isoweekday: 'isoWeekday',
    DDD: 'dayOfYear',
    dayofyears: 'dayOfYear',
    dayofyear: 'dayOfYear',
    h: 'hour',
    hours: 'hour',
    hour: 'hour',
    ms: 'millisecond',
    milliseconds: 'millisecond',
    millisecond: 'millisecond',
    m: 'minute',
    minutes: 'minute',
    minute: 'minute',
    M: 'month',
    months: 'month',
    month: 'month',
    Q: 'quarter',
    quarters: 'quarter',
    quarter: 'quarter',
    s: 'second',
    seconds: 'second',
    second: 'second',
    gg: 'weekYear',
    weekyears: 'weekYear',
    weekyear: 'weekYear',
    GG: 'isoWeekYear',
    isoweekyears: 'isoWeekYear',
    isoweekyear: 'isoWeekYear',
    w: 'week',
    weeks: 'week',
    week: 'week',
    W: 'isoWeek',
    isoweeks: 'isoWeek',
    isoweek: 'isoWeek',
    y: 'year',
    years: 'year',
    year: 'year'
  };
  function normalizeUnits(units) {
    return typeof units === 'string' ? aliases[units] || aliases[units.toLowerCase()] : undefined;
  }
  function normalizeObjectUnits(inputObject) {
    var normalizedInput = {},
      normalizedProp,
      prop;
    for (prop in inputObject) {
      if (hasOwnProp(inputObject, prop)) {
        normalizedProp = normalizeUnits(prop);
        if (normalizedProp) {
          normalizedInput[normalizedProp] = inputObject[prop];
        }
      }
    }
    return normalizedInput;
  }
  var priorities = {
    date: 9,
    day: 11,
    weekday: 11,
    isoWeekday: 11,
    dayOfYear: 4,
    hour: 13,
    millisecond: 16,
    minute: 14,
    month: 8,
    quarter: 7,
    second: 15,
    weekYear: 1,
    isoWeekYear: 1,
    week: 5,
    isoWeek: 5,
    year: 1
  };
  function getPrioritizedUnits(unitsObj) {
    var units = [],
      u;
    for (u in unitsObj) {
      if (hasOwnProp(unitsObj, u)) {
        units.push({
          unit: u,
          priority: priorities[u]
        });
      }
    }
    units.sort(function (a, b) {
      return a.priority - b.priority;
    });
    return units;
  }
  var match1 = /\d/,
    //       0 - 9
    match2 = /\d\d/,
    //      00 - 99
    match3 = /\d{3}/,
    //     000 - 999
    match4 = /\d{4}/,
    //    0000 - 9999
    match6 = /[+-]?\d{6}/,
    // -999999 - 999999
    match1to2 = /\d\d?/,
    //       0 - 99
    match3to4 = /\d\d\d\d?/,
    //     999 - 9999
    match5to6 = /\d\d\d\d\d\d?/,
    //   99999 - 999999
    match1to3 = /\d{1,3}/,
    //       0 - 999
    match1to4 = /\d{1,4}/,
    //       0 - 9999
    match1to6 = /[+-]?\d{1,6}/,
    // -999999 - 999999
    matchUnsigned = /\d+/,
    //       0 - inf
    matchSigned = /[+-]?\d+/,
    //    -inf - inf
    matchOffset = /Z|[+-]\d\d:?\d\d/gi,
    // +00:00 -00:00 +0000 -0000 or Z
    matchShortOffset = /Z|[+-]\d\d(?::?\d\d)?/gi,
    // +00 -00 +00:00 -00:00 +0000 -0000 or Z
    matchTimestamp = /[+-]?\d+(\.\d{1,3})?/,
    // 123456789 123456789.123
    // any word (or two) characters or numbers including two/three word month in arabic.
    // includes scottish gaelic two word and hyphenated months
    matchWord = /[0-9]{0,256}['a-z\u00A0-\u05FF\u0700-\uD7FF\uF900-\uFDCF\uFDF0-\uFF07\uFF10-\uFFEF]{1,256}|[\u0600-\u06FF\/]{1,256}(\s*?[\u0600-\u06FF]{1,256}){1,2}/i,
    match1to2NoLeadingZero = /^[1-9]\d?/,
    //         1-99
    match1to2HasZero = /^([1-9]\d|\d)/,
    //           0-99
    regexes;
  regexes = {};
  function addRegexToken(token, regex, strictRegex) {
    regexes[token] = isFunction(regex) ? regex : function (isStrict, localeData) {
      return isStrict && strictRegex ? strictRegex : regex;
    };
  }
  function getParseRegexForToken(token, config) {
    if (!hasOwnProp(regexes, token)) {
      return new RegExp(unescapeFormat(token));
    }
    return regexes[token](config._strict, config._locale);
  }

  // Code from http://stackoverflow.com/questions/3561493/is-there-a-regexp-escape-function-in-javascript
  function unescapeFormat(s) {
    return regexEscape(s.replace('\\', '').replace(/\\(\[)|\\(\])|\[([^\]\[]*)\]|\\(.)/g, function (matched, p1, p2, p3, p4) {
      return p1 || p2 || p3 || p4;
    }));
  }
  function regexEscape(s) {
    return s.replace(/[-\/\\^$*+?.()|[\]{}]/g, '\\$&');
  }
  function absFloor(number) {
    if (number < 0) {
      // -0 -> 0
      return Math.ceil(number) || 0;
    } else {
      return Math.floor(number);
    }
  }
  function toInt(argumentForCoercion) {
    var coercedNumber = +argumentForCoercion,
      value = 0;
    if (coercedNumber !== 0 && isFinite(coercedNumber)) {
      value = absFloor(coercedNumber);
    }
    return value;
  }
  var tokens = {};
  function addParseToken(token, callback) {
    var i,
      func = callback,
      tokenLen;
    if (typeof token === 'string') {
      token = [token];
    }
    if (isNumber(callback)) {
      func = function func(input, array) {
        array[callback] = toInt(input);
      };
    }
    tokenLen = token.length;
    for (i = 0; i < tokenLen; i++) {
      tokens[token[i]] = func;
    }
  }
  function addWeekParseToken(token, callback) {
    addParseToken(token, function (input, array, config, token) {
      config._w = config._w || {};
      callback(input, config._w, config, token);
    });
  }
  function addTimeToArrayFromToken(token, input, config) {
    if (input != null && hasOwnProp(tokens, token)) {
      tokens[token](input, config._a, config, token);
    }
  }
  function isLeapYear(year) {
    return year % 4 === 0 && year % 100 !== 0 || year % 400 === 0;
  }
  var YEAR = 0,
    MONTH = 1,
    DATE = 2,
    HOUR = 3,
    MINUTE = 4,
    SECOND = 5,
    MILLISECOND = 6,
    WEEK = 7,
    WEEKDAY = 8;

  // FORMATTING

  addFormatToken('Y', 0, 0, function () {
    var y = this.year();
    return y <= 9999 ? zeroFill(y, 4) : '+' + y;
  });
  addFormatToken(0, ['YY', 2], 0, function () {
    return this.year() % 100;
  });
  addFormatToken(0, ['YYYY', 4], 0, 'year');
  addFormatToken(0, ['YYYYY', 5], 0, 'year');
  addFormatToken(0, ['YYYYYY', 6, true], 0, 'year');

  // PARSING

  addRegexToken('Y', matchSigned);
  addRegexToken('YY', match1to2, match2);
  addRegexToken('YYYY', match1to4, match4);
  addRegexToken('YYYYY', match1to6, match6);
  addRegexToken('YYYYYY', match1to6, match6);
  addParseToken(['YYYYY', 'YYYYYY'], YEAR);
  addParseToken('YYYY', function (input, array) {
    array[YEAR] = input.length === 2 ? hooks.parseTwoDigitYear(input) : toInt(input);
  });
  addParseToken('YY', function (input, array) {
    array[YEAR] = hooks.parseTwoDigitYear(input);
  });
  addParseToken('Y', function (input, array) {
    array[YEAR] = parseInt(input, 10);
  });

  // HELPERS

  function daysInYear(year) {
    return isLeapYear(year) ? 366 : 365;
  }

  // HOOKS

  hooks.parseTwoDigitYear = function (input) {
    return toInt(input) + (toInt(input) > 68 ? 1900 : 2000);
  };

  // MOMENTS

  var getSetYear = makeGetSet('FullYear', true);
  function getIsLeapYear() {
    return isLeapYear(this.year());
  }
  function makeGetSet(unit, keepTime) {
    return function (value) {
      if (value != null) {
        set$1(this, unit, value);
        hooks.updateOffset(this, keepTime);
        return this;
      } else {
        return get(this, unit);
      }
    };
  }
  function get(mom, unit) {
    if (!mom.isValid()) {
      return NaN;
    }
    var d = mom._d,
      isUTC = mom._isUTC;
    switch (unit) {
      case 'Milliseconds':
        return isUTC ? d.getUTCMilliseconds() : d.getMilliseconds();
      case 'Seconds':
        return isUTC ? d.getUTCSeconds() : d.getSeconds();
      case 'Minutes':
        return isUTC ? d.getUTCMinutes() : d.getMinutes();
      case 'Hours':
        return isUTC ? d.getUTCHours() : d.getHours();
      case 'Date':
        return isUTC ? d.getUTCDate() : d.getDate();
      case 'Day':
        return isUTC ? d.getUTCDay() : d.getDay();
      case 'Month':
        return isUTC ? d.getUTCMonth() : d.getMonth();
      case 'FullYear':
        return isUTC ? d.getUTCFullYear() : d.getFullYear();
      default:
        return NaN;
      // Just in case
    }
  }
  function set$1(mom, unit, value) {
    var d, isUTC, year, month, date;
    if (!mom.isValid() || isNaN(value)) {
      return;
    }
    d = mom._d;
    isUTC = mom._isUTC;
    switch (unit) {
      case 'Milliseconds':
        return void (isUTC ? d.setUTCMilliseconds(value) : d.setMilliseconds(value));
      case 'Seconds':
        return void (isUTC ? d.setUTCSeconds(value) : d.setSeconds(value));
      case 'Minutes':
        return void (isUTC ? d.setUTCMinutes(value) : d.setMinutes(value));
      case 'Hours':
        return void (isUTC ? d.setUTCHours(value) : d.setHours(value));
      case 'Date':
        return void (isUTC ? d.setUTCDate(value) : d.setDate(value));
      // case 'Day': // Not real
      //    return void (isUTC ? d.setUTCDay(value) : d.setDay(value));
      // case 'Month': // Not used because we need to pass two variables
      //     return void (isUTC ? d.setUTCMonth(value) : d.setMonth(value));
      case 'FullYear':
        break;
      // See below ...
      default:
        return;
      // Just in case
    }
    year = value;
    month = mom.month();
    date = mom.date();
    date = date === 29 && month === 1 && !isLeapYear(year) ? 28 : date;
    void (isUTC ? d.setUTCFullYear(year, month, date) : d.setFullYear(year, month, date));
  }

  // MOMENTS

  function stringGet(units) {
    units = normalizeUnits(units);
    if (isFunction(this[units])) {
      return this[units]();
    }
    return this;
  }
  function stringSet(units, value) {
    if (_typeof(units) === 'object') {
      units = normalizeObjectUnits(units);
      var prioritized = getPrioritizedUnits(units),
        i,
        prioritizedLen = prioritized.length;
      for (i = 0; i < prioritizedLen; i++) {
        this[prioritized[i].unit](units[prioritized[i].unit]);
      }
    } else {
      units = normalizeUnits(units);
      if (isFunction(this[units])) {
        return this[units](value);
      }
    }
    return this;
  }
  function mod(n, x) {
    return (n % x + x) % x;
  }
  var indexOf;
  if (Array.prototype.indexOf) {
    indexOf = Array.prototype.indexOf;
  } else {
    indexOf = function indexOf(o) {
      // I know
      var i;
      for (i = 0; i < this.length; ++i) {
        if (this[i] === o) {
          return i;
        }
      }
      return -1;
    };
  }
  function daysInMonth(year, month) {
    if (isNaN(year) || isNaN(month)) {
      return NaN;
    }
    var modMonth = mod(month, 12);
    year += (month - modMonth) / 12;
    return modMonth === 1 ? isLeapYear(year) ? 29 : 28 : 31 - modMonth % 7 % 2;
  }

  // FORMATTING

  addFormatToken('M', ['MM', 2], 'Mo', function () {
    return this.month() + 1;
  });
  addFormatToken('MMM', 0, 0, function (format) {
    return this.localeData().monthsShort(this, format);
  });
  addFormatToken('MMMM', 0, 0, function (format) {
    return this.localeData().months(this, format);
  });

  // PARSING

  addRegexToken('M', match1to2, match1to2NoLeadingZero);
  addRegexToken('MM', match1to2, match2);
  addRegexToken('MMM', function (isStrict, locale) {
    return locale.monthsShortRegex(isStrict);
  });
  addRegexToken('MMMM', function (isStrict, locale) {
    return locale.monthsRegex(isStrict);
  });
  addParseToken(['M', 'MM'], function (input, array) {
    array[MONTH] = toInt(input) - 1;
  });
  addParseToken(['MMM', 'MMMM'], function (input, array, config, token) {
    var month = config._locale.monthsParse(input, token, config._strict);
    // if we didn't find a month name, mark the date as invalid.
    if (month != null) {
      array[MONTH] = month;
    } else {
      getParsingFlags(config).invalidMonth = input;
    }
  });

  // LOCALES

  var defaultLocaleMonths = 'January_February_March_April_May_June_July_August_September_October_November_December'.split('_'),
    defaultLocaleMonthsShort = 'Jan_Feb_Mar_Apr_May_Jun_Jul_Aug_Sep_Oct_Nov_Dec'.split('_'),
    MONTHS_IN_FORMAT = /D[oD]?(\[[^\[\]]*\]|\s)+MMMM?/,
    defaultMonthsShortRegex = matchWord,
    defaultMonthsRegex = matchWord;
  function localeMonths(m, format) {
    if (!m) {
      return isArray(this._months) ? this._months : this._months['standalone'];
    }
    return isArray(this._months) ? this._months[m.month()] : this._months[(this._months.isFormat || MONTHS_IN_FORMAT).test(format) ? 'format' : 'standalone'][m.month()];
  }
  function localeMonthsShort(m, format) {
    if (!m) {
      return isArray(this._monthsShort) ? this._monthsShort : this._monthsShort['standalone'];
    }
    return isArray(this._monthsShort) ? this._monthsShort[m.month()] : this._monthsShort[MONTHS_IN_FORMAT.test(format) ? 'format' : 'standalone'][m.month()];
  }
  function handleStrictParse(monthName, format, strict) {
    var i,
      ii,
      mom,
      llc = monthName.toLocaleLowerCase();
    if (!this._monthsParse) {
      // this is not used
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
      for (i = 0; i < 12; ++i) {
        mom = createUTC([2000, i]);
        this._shortMonthsParse[i] = this.monthsShort(mom, '').toLocaleLowerCase();
        this._longMonthsParse[i] = this.months(mom, '').toLocaleLowerCase();
      }
    }
    if (strict) {
      if (format === 'MMM') {
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === 'MMM') {
        ii = indexOf.call(this._shortMonthsParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._longMonthsParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._longMonthsParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortMonthsParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }
  function localeMonthsParse(monthName, format, strict) {
    var i, mom, regex;
    if (this._monthsParseExact) {
      return handleStrictParse.call(this, monthName, format, strict);
    }
    if (!this._monthsParse) {
      this._monthsParse = [];
      this._longMonthsParse = [];
      this._shortMonthsParse = [];
    }

    // TODO: add sorting
    // Sorting makes sure if one month (or abbr) is a prefix of another
    // see sorting in computeMonthsParse
    for (i = 0; i < 12; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, i]);
      if (strict && !this._longMonthsParse[i]) {
        this._longMonthsParse[i] = new RegExp('^' + this.months(mom, '').replace('.', '') + '$', 'i');
        this._shortMonthsParse[i] = new RegExp('^' + this.monthsShort(mom, '').replace('.', '') + '$', 'i');
      }
      if (!strict && !this._monthsParse[i]) {
        regex = '^' + this.months(mom, '') + '|^' + this.monthsShort(mom, '');
        this._monthsParse[i] = new RegExp(regex.replace('.', ''), 'i');
      }
      // test the regex
      if (strict && format === 'MMMM' && this._longMonthsParse[i].test(monthName)) {
        return i;
      } else if (strict && format === 'MMM' && this._shortMonthsParse[i].test(monthName)) {
        return i;
      } else if (!strict && this._monthsParse[i].test(monthName)) {
        return i;
      }
    }
  }

  // MOMENTS

  function setMonth(mom, value) {
    if (!mom.isValid()) {
      // No op
      return mom;
    }
    if (typeof value === 'string') {
      if (/^\d+$/.test(value)) {
        value = toInt(value);
      } else {
        value = mom.localeData().monthsParse(value);
        // TODO: Another silent failure?
        if (!isNumber(value)) {
          return mom;
        }
      }
    }
    var month = value,
      date = mom.date();
    date = date < 29 ? date : Math.min(date, daysInMonth(mom.year(), month));
    void (mom._isUTC ? mom._d.setUTCMonth(month, date) : mom._d.setMonth(month, date));
    return mom;
  }
  function getSetMonth(value) {
    if (value != null) {
      setMonth(this, value);
      hooks.updateOffset(this, true);
      return this;
    } else {
      return get(this, 'Month');
    }
  }
  function getDaysInMonth() {
    return daysInMonth(this.year(), this.month());
  }
  function monthsShortRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, '_monthsRegex')) {
        computeMonthsParse.call(this);
      }
      if (isStrict) {
        return this._monthsShortStrictRegex;
      } else {
        return this._monthsShortRegex;
      }
    } else {
      if (!hasOwnProp(this, '_monthsShortRegex')) {
        this._monthsShortRegex = defaultMonthsShortRegex;
      }
      return this._monthsShortStrictRegex && isStrict ? this._monthsShortStrictRegex : this._monthsShortRegex;
    }
  }
  function monthsRegex(isStrict) {
    if (this._monthsParseExact) {
      if (!hasOwnProp(this, '_monthsRegex')) {
        computeMonthsParse.call(this);
      }
      if (isStrict) {
        return this._monthsStrictRegex;
      } else {
        return this._monthsRegex;
      }
    } else {
      if (!hasOwnProp(this, '_monthsRegex')) {
        this._monthsRegex = defaultMonthsRegex;
      }
      return this._monthsStrictRegex && isStrict ? this._monthsStrictRegex : this._monthsRegex;
    }
  }
  function computeMonthsParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }
    var shortPieces = [],
      longPieces = [],
      mixedPieces = [],
      i,
      mom,
      shortP,
      longP;
    for (i = 0; i < 12; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, i]);
      shortP = regexEscape(this.monthsShort(mom, ''));
      longP = regexEscape(this.months(mom, ''));
      shortPieces.push(shortP);
      longPieces.push(longP);
      mixedPieces.push(longP);
      mixedPieces.push(shortP);
    }
    // Sorting makes sure if one month (or abbr) is a prefix of another it
    // will match the longer piece.
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    this._monthsRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._monthsShortRegex = this._monthsRegex;
    this._monthsStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._monthsShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
  }
  function createDate(y, m, d, h, M, s, ms) {
    // can't just apply() to create a date:
    // https://stackoverflow.com/q/181348
    var date;
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
      // preserve leap years using a full 400 year cycle, then reset
      date = new Date(y + 400, m, d, h, M, s, ms);
      if (isFinite(date.getFullYear())) {
        date.setFullYear(y);
      }
    } else {
      date = new Date(y, m, d, h, M, s, ms);
    }
    return date;
  }
  function createUTCDate(y) {
    var date, args;
    // the Date.UTC function remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
      args = Array.prototype.slice.call(arguments);
      // preserve leap years using a full 400 year cycle, then reset
      args[0] = y + 400;
      date = new Date(Date.UTC.apply(null, args));
      if (isFinite(date.getUTCFullYear())) {
        date.setUTCFullYear(y);
      }
    } else {
      date = new Date(Date.UTC.apply(null, arguments));
    }
    return date;
  }

  // start-of-first-week - start-of-year
  function firstWeekOffset(year, dow, doy) {
    var
      // first-week day -- which january is always in the first week (4 for iso, 1 for other)
      fwd = 7 + dow - doy,
      // first-week day local weekday -- which local weekday is fwd
      fwdlw = (7 + createUTCDate(year, 0, fwd).getUTCDay() - dow) % 7;
    return -fwdlw + fwd - 1;
  }

  // https://en.wikipedia.org/wiki/ISO_week_date#Calculating_a_date_given_the_year.2C_week_number_and_weekday
  function dayOfYearFromWeeks(year, week, weekday, dow, doy) {
    var localWeekday = (7 + weekday - dow) % 7,
      weekOffset = firstWeekOffset(year, dow, doy),
      dayOfYear = 1 + 7 * (week - 1) + localWeekday + weekOffset,
      resYear,
      resDayOfYear;
    if (dayOfYear <= 0) {
      resYear = year - 1;
      resDayOfYear = daysInYear(resYear) + dayOfYear;
    } else if (dayOfYear > daysInYear(year)) {
      resYear = year + 1;
      resDayOfYear = dayOfYear - daysInYear(year);
    } else {
      resYear = year;
      resDayOfYear = dayOfYear;
    }
    return {
      year: resYear,
      dayOfYear: resDayOfYear
    };
  }
  function weekOfYear(mom, dow, doy) {
    var weekOffset = firstWeekOffset(mom.year(), dow, doy),
      week = Math.floor((mom.dayOfYear() - weekOffset - 1) / 7) + 1,
      resWeek,
      resYear;
    if (week < 1) {
      resYear = mom.year() - 1;
      resWeek = week + weeksInYear(resYear, dow, doy);
    } else if (week > weeksInYear(mom.year(), dow, doy)) {
      resWeek = week - weeksInYear(mom.year(), dow, doy);
      resYear = mom.year() + 1;
    } else {
      resYear = mom.year();
      resWeek = week;
    }
    return {
      week: resWeek,
      year: resYear
    };
  }
  function weeksInYear(year, dow, doy) {
    var weekOffset = firstWeekOffset(year, dow, doy),
      weekOffsetNext = firstWeekOffset(year + 1, dow, doy);
    return (daysInYear(year) - weekOffset + weekOffsetNext) / 7;
  }

  // FORMATTING

  addFormatToken('w', ['ww', 2], 'wo', 'week');
  addFormatToken('W', ['WW', 2], 'Wo', 'isoWeek');

  // PARSING

  addRegexToken('w', match1to2, match1to2NoLeadingZero);
  addRegexToken('ww', match1to2, match2);
  addRegexToken('W', match1to2, match1to2NoLeadingZero);
  addRegexToken('WW', match1to2, match2);
  addWeekParseToken(['w', 'ww', 'W', 'WW'], function (input, week, config, token) {
    week[token.substr(0, 1)] = toInt(input);
  });

  // HELPERS

  // LOCALES

  function localeWeek(mom) {
    return weekOfYear(mom, this._week.dow, this._week.doy).week;
  }
  var defaultLocaleWeek = {
    dow: 0,
    // Sunday is the first day of the week.
    doy: 6 // The week that contains Jan 6th is the first week of the year.
  };
  function localeFirstDayOfWeek() {
    return this._week.dow;
  }
  function localeFirstDayOfYear() {
    return this._week.doy;
  }

  // MOMENTS

  function getSetWeek(input) {
    var week = this.localeData().week(this);
    return input == null ? week : this.add((input - week) * 7, 'd');
  }
  function getSetISOWeek(input) {
    var week = weekOfYear(this, 1, 4).week;
    return input == null ? week : this.add((input - week) * 7, 'd');
  }

  // FORMATTING

  addFormatToken('d', 0, 'do', 'day');
  addFormatToken('dd', 0, 0, function (format) {
    return this.localeData().weekdaysMin(this, format);
  });
  addFormatToken('ddd', 0, 0, function (format) {
    return this.localeData().weekdaysShort(this, format);
  });
  addFormatToken('dddd', 0, 0, function (format) {
    return this.localeData().weekdays(this, format);
  });
  addFormatToken('e', 0, 0, 'weekday');
  addFormatToken('E', 0, 0, 'isoWeekday');

  // PARSING

  addRegexToken('d', match1to2);
  addRegexToken('e', match1to2);
  addRegexToken('E', match1to2);
  addRegexToken('dd', function (isStrict, locale) {
    return locale.weekdaysMinRegex(isStrict);
  });
  addRegexToken('ddd', function (isStrict, locale) {
    return locale.weekdaysShortRegex(isStrict);
  });
  addRegexToken('dddd', function (isStrict, locale) {
    return locale.weekdaysRegex(isStrict);
  });
  addWeekParseToken(['dd', 'ddd', 'dddd'], function (input, week, config, token) {
    var weekday = config._locale.weekdaysParse(input, token, config._strict);
    // if we didn't get a weekday name, mark the date as invalid
    if (weekday != null) {
      week.d = weekday;
    } else {
      getParsingFlags(config).invalidWeekday = input;
    }
  });
  addWeekParseToken(['d', 'e', 'E'], function (input, week, config, token) {
    week[token] = toInt(input);
  });

  // HELPERS

  function parseWeekday(input, locale) {
    if (typeof input !== 'string') {
      return input;
    }
    if (!isNaN(input)) {
      return parseInt(input, 10);
    }
    input = locale.weekdaysParse(input);
    if (typeof input === 'number') {
      return input;
    }
    return null;
  }
  function parseIsoWeekday(input, locale) {
    if (typeof input === 'string') {
      return locale.weekdaysParse(input) % 7 || 7;
    }
    return isNaN(input) ? null : input;
  }

  // LOCALES
  function shiftWeekdays(ws, n) {
    return ws.slice(n, 7).concat(ws.slice(0, n));
  }
  var defaultLocaleWeekdays = 'Sunday_Monday_Tuesday_Wednesday_Thursday_Friday_Saturday'.split('_'),
    defaultLocaleWeekdaysShort = 'Sun_Mon_Tue_Wed_Thu_Fri_Sat'.split('_'),
    defaultLocaleWeekdaysMin = 'Su_Mo_Tu_We_Th_Fr_Sa'.split('_'),
    defaultWeekdaysRegex = matchWord,
    defaultWeekdaysShortRegex = matchWord,
    defaultWeekdaysMinRegex = matchWord;
  function localeWeekdays(m, format) {
    var weekdays = isArray(this._weekdays) ? this._weekdays : this._weekdays[m && m !== true && this._weekdays.isFormat.test(format) ? 'format' : 'standalone'];
    return m === true ? shiftWeekdays(weekdays, this._week.dow) : m ? weekdays[m.day()] : weekdays;
  }
  function localeWeekdaysShort(m) {
    return m === true ? shiftWeekdays(this._weekdaysShort, this._week.dow) : m ? this._weekdaysShort[m.day()] : this._weekdaysShort;
  }
  function localeWeekdaysMin(m) {
    return m === true ? shiftWeekdays(this._weekdaysMin, this._week.dow) : m ? this._weekdaysMin[m.day()] : this._weekdaysMin;
  }
  function handleStrictParse$1(weekdayName, format, strict) {
    var i,
      ii,
      mom,
      llc = weekdayName.toLocaleLowerCase();
    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._minWeekdaysParse = [];
      for (i = 0; i < 7; ++i) {
        mom = createUTC([2000, 1]).day(i);
        this._minWeekdaysParse[i] = this.weekdaysMin(mom, '').toLocaleLowerCase();
        this._shortWeekdaysParse[i] = this.weekdaysShort(mom, '').toLocaleLowerCase();
        this._weekdaysParse[i] = this.weekdays(mom, '').toLocaleLowerCase();
      }
    }
    if (strict) {
      if (format === 'dddd') {
        ii = indexOf.call(this._weekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === 'ddd') {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    } else {
      if (format === 'dddd') {
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else if (format === 'ddd') {
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._minWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      } else {
        ii = indexOf.call(this._minWeekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._weekdaysParse, llc);
        if (ii !== -1) {
          return ii;
        }
        ii = indexOf.call(this._shortWeekdaysParse, llc);
        return ii !== -1 ? ii : null;
      }
    }
  }
  function localeWeekdaysParse(weekdayName, format, strict) {
    var i, mom, regex;
    if (this._weekdaysParseExact) {
      return handleStrictParse$1.call(this, weekdayName, format, strict);
    }
    if (!this._weekdaysParse) {
      this._weekdaysParse = [];
      this._minWeekdaysParse = [];
      this._shortWeekdaysParse = [];
      this._fullWeekdaysParse = [];
    }
    for (i = 0; i < 7; i++) {
      // make the regex if we don't have it already

      mom = createUTC([2000, 1]).day(i);
      if (strict && !this._fullWeekdaysParse[i]) {
        this._fullWeekdaysParse[i] = new RegExp('^' + this.weekdays(mom, '').replace('.', '\\.?') + '$', 'i');
        this._shortWeekdaysParse[i] = new RegExp('^' + this.weekdaysShort(mom, '').replace('.', '\\.?') + '$', 'i');
        this._minWeekdaysParse[i] = new RegExp('^' + this.weekdaysMin(mom, '').replace('.', '\\.?') + '$', 'i');
      }
      if (!this._weekdaysParse[i]) {
        regex = '^' + this.weekdays(mom, '') + '|^' + this.weekdaysShort(mom, '') + '|^' + this.weekdaysMin(mom, '');
        this._weekdaysParse[i] = new RegExp(regex.replace('.', ''), 'i');
      }
      // test the regex
      if (strict && format === 'dddd' && this._fullWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === 'ddd' && this._shortWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (strict && format === 'dd' && this._minWeekdaysParse[i].test(weekdayName)) {
        return i;
      } else if (!strict && this._weekdaysParse[i].test(weekdayName)) {
        return i;
      }
    }
  }

  // MOMENTS

  function getSetDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    var day = get(this, 'Day');
    if (input != null) {
      input = parseWeekday(input, this.localeData());
      return this.add(input - day, 'd');
    } else {
      return day;
    }
  }
  function getSetLocaleDayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    var weekday = (this.day() + 7 - this.localeData()._week.dow) % 7;
    return input == null ? weekday : this.add(input - weekday, 'd');
  }
  function getSetISODayOfWeek(input) {
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }

    // behaves the same as moment#day except
    // as a getter, returns 7 instead of 0 (1-7 range instead of 0-6)
    // as a setter, sunday should belong to the previous week.

    if (input != null) {
      var weekday = parseIsoWeekday(input, this.localeData());
      return this.day(this.day() % 7 ? weekday : weekday - 7);
    } else {
      return this.day() || 7;
    }
  }
  function weekdaysRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysStrictRegex;
      } else {
        return this._weekdaysRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        this._weekdaysRegex = defaultWeekdaysRegex;
      }
      return this._weekdaysStrictRegex && isStrict ? this._weekdaysStrictRegex : this._weekdaysRegex;
    }
  }
  function weekdaysShortRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysShortStrictRegex;
      } else {
        return this._weekdaysShortRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysShortRegex')) {
        this._weekdaysShortRegex = defaultWeekdaysShortRegex;
      }
      return this._weekdaysShortStrictRegex && isStrict ? this._weekdaysShortStrictRegex : this._weekdaysShortRegex;
    }
  }
  function weekdaysMinRegex(isStrict) {
    if (this._weekdaysParseExact) {
      if (!hasOwnProp(this, '_weekdaysRegex')) {
        computeWeekdaysParse.call(this);
      }
      if (isStrict) {
        return this._weekdaysMinStrictRegex;
      } else {
        return this._weekdaysMinRegex;
      }
    } else {
      if (!hasOwnProp(this, '_weekdaysMinRegex')) {
        this._weekdaysMinRegex = defaultWeekdaysMinRegex;
      }
      return this._weekdaysMinStrictRegex && isStrict ? this._weekdaysMinStrictRegex : this._weekdaysMinRegex;
    }
  }
  function computeWeekdaysParse() {
    function cmpLenRev(a, b) {
      return b.length - a.length;
    }
    var minPieces = [],
      shortPieces = [],
      longPieces = [],
      mixedPieces = [],
      i,
      mom,
      minp,
      shortp,
      longp;
    for (i = 0; i < 7; i++) {
      // make the regex if we don't have it already
      mom = createUTC([2000, 1]).day(i);
      minp = regexEscape(this.weekdaysMin(mom, ''));
      shortp = regexEscape(this.weekdaysShort(mom, ''));
      longp = regexEscape(this.weekdays(mom, ''));
      minPieces.push(minp);
      shortPieces.push(shortp);
      longPieces.push(longp);
      mixedPieces.push(minp);
      mixedPieces.push(shortp);
      mixedPieces.push(longp);
    }
    // Sorting makes sure if one weekday (or abbr) is a prefix of another it
    // will match the longer piece.
    minPieces.sort(cmpLenRev);
    shortPieces.sort(cmpLenRev);
    longPieces.sort(cmpLenRev);
    mixedPieces.sort(cmpLenRev);
    this._weekdaysRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._weekdaysShortRegex = this._weekdaysRegex;
    this._weekdaysMinRegex = this._weekdaysRegex;
    this._weekdaysStrictRegex = new RegExp('^(' + longPieces.join('|') + ')', 'i');
    this._weekdaysShortStrictRegex = new RegExp('^(' + shortPieces.join('|') + ')', 'i');
    this._weekdaysMinStrictRegex = new RegExp('^(' + minPieces.join('|') + ')', 'i');
  }

  // FORMATTING

  function hFormat() {
    return this.hours() % 12 || 12;
  }
  function kFormat() {
    return this.hours() || 24;
  }
  addFormatToken('H', ['HH', 2], 0, 'hour');
  addFormatToken('h', ['hh', 2], 0, hFormat);
  addFormatToken('k', ['kk', 2], 0, kFormat);
  addFormatToken('hmm', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2);
  });
  addFormatToken('hmmss', 0, 0, function () {
    return '' + hFormat.apply(this) + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });
  addFormatToken('Hmm', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2);
  });
  addFormatToken('Hmmss', 0, 0, function () {
    return '' + this.hours() + zeroFill(this.minutes(), 2) + zeroFill(this.seconds(), 2);
  });
  function meridiem(token, lowercase) {
    addFormatToken(token, 0, 0, function () {
      return this.localeData().meridiem(this.hours(), this.minutes(), lowercase);
    });
  }
  meridiem('a', true);
  meridiem('A', false);

  // PARSING

  function matchMeridiem(isStrict, locale) {
    return locale._meridiemParse;
  }
  addRegexToken('a', matchMeridiem);
  addRegexToken('A', matchMeridiem);
  addRegexToken('H', match1to2, match1to2HasZero);
  addRegexToken('h', match1to2, match1to2NoLeadingZero);
  addRegexToken('k', match1to2, match1to2NoLeadingZero);
  addRegexToken('HH', match1to2, match2);
  addRegexToken('hh', match1to2, match2);
  addRegexToken('kk', match1to2, match2);
  addRegexToken('hmm', match3to4);
  addRegexToken('hmmss', match5to6);
  addRegexToken('Hmm', match3to4);
  addRegexToken('Hmmss', match5to6);
  addParseToken(['H', 'HH'], HOUR);
  addParseToken(['k', 'kk'], function (input, array, config) {
    var kInput = toInt(input);
    array[HOUR] = kInput === 24 ? 0 : kInput;
  });
  addParseToken(['a', 'A'], function (input, array, config) {
    config._isPm = config._locale.isPM(input);
    config._meridiem = input;
  });
  addParseToken(['h', 'hh'], function (input, array, config) {
    array[HOUR] = toInt(input);
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
      pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
    getParsingFlags(config).bigHour = true;
  });
  addParseToken('Hmm', function (input, array, config) {
    var pos = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos));
    array[MINUTE] = toInt(input.substr(pos));
  });
  addParseToken('Hmmss', function (input, array, config) {
    var pos1 = input.length - 4,
      pos2 = input.length - 2;
    array[HOUR] = toInt(input.substr(0, pos1));
    array[MINUTE] = toInt(input.substr(pos1, 2));
    array[SECOND] = toInt(input.substr(pos2));
  });

  // LOCALES

  function localeIsPM(input) {
    // IE8 Quirks Mode & IE7 Standards Mode do not allow accessing strings like arrays
    // Using charAt should be more compatible.
    return (input + '').toLowerCase().charAt(0) === 'p';
  }
  var defaultLocaleMeridiemParse = /[ap]\.?m?\.?/i,
    // Setting the hour should keep the time, because the user explicitly
    // specified which hour they want. So trying to maintain the same hour (in
    // a new timezone) makes sense. Adding/subtracting hours does not follow
    // this rule.
    getSetHour = makeGetSet('Hours', true);
  function localeMeridiem(hours, minutes, isLower) {
    if (hours > 11) {
      return isLower ? 'pm' : 'PM';
    } else {
      return isLower ? 'am' : 'AM';
    }
  }
  var baseConfig = {
    calendar: defaultCalendar,
    longDateFormat: defaultLongDateFormat,
    invalidDate: defaultInvalidDate,
    ordinal: defaultOrdinal,
    dayOfMonthOrdinalParse: defaultDayOfMonthOrdinalParse,
    relativeTime: defaultRelativeTime,
    months: defaultLocaleMonths,
    monthsShort: defaultLocaleMonthsShort,
    week: defaultLocaleWeek,
    weekdays: defaultLocaleWeekdays,
    weekdaysMin: defaultLocaleWeekdaysMin,
    weekdaysShort: defaultLocaleWeekdaysShort,
    meridiemParse: defaultLocaleMeridiemParse
  };

  // internal storage for locale config files
  var locales = {},
    localeFamilies = {},
    globalLocale;
  function commonPrefix(arr1, arr2) {
    var i,
      minl = Math.min(arr1.length, arr2.length);
    for (i = 0; i < minl; i += 1) {
      if (arr1[i] !== arr2[i]) {
        return i;
      }
    }
    return minl;
  }
  function normalizeLocale(key) {
    return key ? key.toLowerCase().replace('_', '-') : key;
  }

  // pick the locale from the array
  // try ['en-au', 'en-gb'] as 'en-au', 'en-gb', 'en', as in move through the list trying each
  // substring from most specific to least, but move to the next array item if it's a more specific variant than the current root
  function chooseLocale(names) {
    var i = 0,
      j,
      next,
      locale,
      split;
    while (i < names.length) {
      split = normalizeLocale(names[i]).split('-');
      j = split.length;
      next = normalizeLocale(names[i + 1]);
      next = next ? next.split('-') : null;
      while (j > 0) {
        locale = loadLocale(split.slice(0, j).join('-'));
        if (locale) {
          return locale;
        }
        if (next && next.length >= j && commonPrefix(split, next) >= j - 1) {
          //the next array item is better than a shallower substring of this one
          break;
        }
        j--;
      }
      i++;
    }
    return globalLocale;
  }
  function isLocaleNameSane(name) {
    // Prevent names that look like filesystem paths, i.e contain '/' or '\'
    // Ensure name is available and function returns boolean
    return !!(name && name.match('^[^/\\\\]*$'));
  }
  function loadLocale(name) {
    var oldLocale = null,
      aliasedRequire;
    // TODO: Find a better way to register and load all the locales in Node
    if (locales[name] === undefined && typeof module !== 'undefined' && module && module.exports && isLocaleNameSane(name)) {
      try {
        oldLocale = globalLocale._abbr;
        aliasedRequire = require;
        aliasedRequire('./locale/' + name);
        getSetGlobalLocale(oldLocale);
      } catch (e) {
        // mark as not found to avoid repeating expensive file require call causing high CPU
        // when trying to find en-US, en_US, en-us for every format call
        locales[name] = null; // null means not found
      }
    }
    return locales[name];
  }

  // This function will load locale and then set the global locale.  If
  // no arguments are passed in, it will simply return the current global
  // locale key.
  function getSetGlobalLocale(key, values) {
    var data;
    if (key) {
      if (isUndefined(values)) {
        data = getLocale(key);
      } else {
        data = defineLocale(key, values);
      }
      if (data) {
        // moment.duration._locale = moment._locale = data;
        globalLocale = data;
      } else {
        if (typeof console !== 'undefined' && console.warn) {
          //warn user if arguments are passed but the locale could not be set
          console.warn('Locale ' + key + ' not found. Did you forget to load it?');
        }
      }
    }
    return globalLocale._abbr;
  }
  function defineLocale(name, config) {
    if (config !== null) {
      var locale,
        parentConfig = baseConfig;
      config.abbr = name;
      if (locales[name] != null) {
        deprecateSimple('defineLocaleOverride', 'use moment.updateLocale(localeName, config) to change ' + 'an existing locale. moment.defineLocale(localeName, ' + 'config) should only be used for creating a new locale ' + 'See http://momentjs.com/guides/#/warnings/define-locale/ for more info.');
        parentConfig = locales[name]._config;
      } else if (config.parentLocale != null) {
        if (locales[config.parentLocale] != null) {
          parentConfig = locales[config.parentLocale]._config;
        } else {
          locale = loadLocale(config.parentLocale);
          if (locale != null) {
            parentConfig = locale._config;
          } else {
            if (!localeFamilies[config.parentLocale]) {
              localeFamilies[config.parentLocale] = [];
            }
            localeFamilies[config.parentLocale].push({
              name: name,
              config: config
            });
            return null;
          }
        }
      }
      locales[name] = new Locale(mergeConfigs(parentConfig, config));
      if (localeFamilies[name]) {
        localeFamilies[name].forEach(function (x) {
          defineLocale(x.name, x.config);
        });
      }

      // backwards compat for now: also set the locale
      // make sure we set the locale AFTER all child locales have been
      // created, so we won't end up with the child locale set.
      getSetGlobalLocale(name);
      return locales[name];
    } else {
      // useful for testing
      delete locales[name];
      return null;
    }
  }
  function updateLocale(name, config) {
    if (config != null) {
      var locale,
        tmpLocale,
        parentConfig = baseConfig;
      if (locales[name] != null && locales[name].parentLocale != null) {
        // Update existing child locale in-place to avoid memory-leaks
        locales[name].set(mergeConfigs(locales[name]._config, config));
      } else {
        // MERGE
        tmpLocale = loadLocale(name);
        if (tmpLocale != null) {
          parentConfig = tmpLocale._config;
        }
        config = mergeConfigs(parentConfig, config);
        if (tmpLocale == null) {
          // updateLocale is called for creating a new locale
          // Set abbr so it will have a name (getters return
          // undefined otherwise).
          config.abbr = name;
        }
        locale = new Locale(config);
        locale.parentLocale = locales[name];
        locales[name] = locale;
      }

      // backwards compat for now: also set the locale
      getSetGlobalLocale(name);
    } else {
      // pass null for config to unupdate, useful for tests
      if (locales[name] != null) {
        if (locales[name].parentLocale != null) {
          locales[name] = locales[name].parentLocale;
          if (name === getSetGlobalLocale()) {
            getSetGlobalLocale(name);
          }
        } else if (locales[name] != null) {
          delete locales[name];
        }
      }
    }
    return locales[name];
  }

  // returns locale data
  function getLocale(key) {
    var locale;
    if (key && key._locale && key._locale._abbr) {
      key = key._locale._abbr;
    }
    if (!key) {
      return globalLocale;
    }
    if (!isArray(key)) {
      //short-circuit everything else
      locale = loadLocale(key);
      if (locale) {
        return locale;
      }
      key = [key];
    }
    return chooseLocale(key);
  }
  function listLocales() {
    return keys(locales);
  }
  function checkOverflow(m) {
    var overflow,
      a = m._a;
    if (a && getParsingFlags(m).overflow === -2) {
      overflow = a[MONTH] < 0 || a[MONTH] > 11 ? MONTH : a[DATE] < 1 || a[DATE] > daysInMonth(a[YEAR], a[MONTH]) ? DATE : a[HOUR] < 0 || a[HOUR] > 24 || a[HOUR] === 24 && (a[MINUTE] !== 0 || a[SECOND] !== 0 || a[MILLISECOND] !== 0) ? HOUR : a[MINUTE] < 0 || a[MINUTE] > 59 ? MINUTE : a[SECOND] < 0 || a[SECOND] > 59 ? SECOND : a[MILLISECOND] < 0 || a[MILLISECOND] > 999 ? MILLISECOND : -1;
      if (getParsingFlags(m)._overflowDayOfYear && (overflow < YEAR || overflow > DATE)) {
        overflow = DATE;
      }
      if (getParsingFlags(m)._overflowWeeks && overflow === -1) {
        overflow = WEEK;
      }
      if (getParsingFlags(m)._overflowWeekday && overflow === -1) {
        overflow = WEEKDAY;
      }
      getParsingFlags(m).overflow = overflow;
    }
    return m;
  }

  // iso 8601 regex
  // 0000-00-00 0000-W00 or 0000-W00-0 + T + 00 or 00:00 or 00:00:00 or 00:00:00.000 + +00:00 or +0000 or +00)
  var extendedIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})-(?:\d\d-\d\d|W\d\d-\d|W\d\d|\d\d\d|\d\d))(?:(T| )(\d\d(?::\d\d(?::\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    basicIsoRegex = /^\s*((?:[+-]\d{6}|\d{4})(?:\d\d\d\d|W\d\d\d|W\d\d|\d\d\d|\d\d|))(?:(T| )(\d\d(?:\d\d(?:\d\d(?:[.,]\d+)?)?)?)([+-]\d\d(?::?\d\d)?|\s*Z)?)?$/,
    tzRegex = /Z|[+-]\d\d(?::?\d\d)?/,
    isoDates = [['YYYYYY-MM-DD', /[+-]\d{6}-\d\d-\d\d/], ['YYYY-MM-DD', /\d{4}-\d\d-\d\d/], ['GGGG-[W]WW-E', /\d{4}-W\d\d-\d/], ['GGGG-[W]WW', /\d{4}-W\d\d/, false], ['YYYY-DDD', /\d{4}-\d{3}/], ['YYYY-MM', /\d{4}-\d\d/, false], ['YYYYYYMMDD', /[+-]\d{10}/], ['YYYYMMDD', /\d{8}/], ['GGGG[W]WWE', /\d{4}W\d{3}/], ['GGGG[W]WW', /\d{4}W\d{2}/, false], ['YYYYDDD', /\d{7}/], ['YYYYMM', /\d{6}/, false], ['YYYY', /\d{4}/, false]],
    // iso time formats and regexes
    isoTimes = [['HH:mm:ss.SSSS', /\d\d:\d\d:\d\d\.\d+/], ['HH:mm:ss,SSSS', /\d\d:\d\d:\d\d,\d+/], ['HH:mm:ss', /\d\d:\d\d:\d\d/], ['HH:mm', /\d\d:\d\d/], ['HHmmss.SSSS', /\d\d\d\d\d\d\.\d+/], ['HHmmss,SSSS', /\d\d\d\d\d\d,\d+/], ['HHmmss', /\d\d\d\d\d\d/], ['HHmm', /\d\d\d\d/], ['HH', /\d\d/]],
    aspNetJsonRegex = /^\/?Date\((-?\d+)/i,
    // RFC 2822 regex: For details see https://tools.ietf.org/html/rfc2822#section-3.3
    rfc2822 = /^(?:(Mon|Tue|Wed|Thu|Fri|Sat|Sun),?\s)?(\d{1,2})\s(Jan|Feb|Mar|Apr|May|Jun|Jul|Aug|Sep|Oct|Nov|Dec)\s(\d{2,4})\s(\d\d):(\d\d)(?::(\d\d))?\s(?:(UT|GMT|[ECMP][SD]T)|([Zz])|([+-]\d{4}))$/,
    obsOffsets = {
      UT: 0,
      GMT: 0,
      EDT: -4 * 60,
      EST: -5 * 60,
      CDT: -5 * 60,
      CST: -6 * 60,
      MDT: -6 * 60,
      MST: -7 * 60,
      PDT: -7 * 60,
      PST: -8 * 60
    };

  // date from iso format
  function configFromISO(config) {
    var i,
      l,
      string = config._i,
      match = extendedIsoRegex.exec(string) || basicIsoRegex.exec(string),
      allowTime,
      dateFormat,
      timeFormat,
      tzFormat,
      isoDatesLen = isoDates.length,
      isoTimesLen = isoTimes.length;
    if (match) {
      getParsingFlags(config).iso = true;
      for (i = 0, l = isoDatesLen; i < l; i++) {
        if (isoDates[i][1].exec(match[1])) {
          dateFormat = isoDates[i][0];
          allowTime = isoDates[i][2] !== false;
          break;
        }
      }
      if (dateFormat == null) {
        config._isValid = false;
        return;
      }
      if (match[3]) {
        for (i = 0, l = isoTimesLen; i < l; i++) {
          if (isoTimes[i][1].exec(match[3])) {
            // match[2] should be 'T' or space
            timeFormat = (match[2] || ' ') + isoTimes[i][0];
            break;
          }
        }
        if (timeFormat == null) {
          config._isValid = false;
          return;
        }
      }
      if (!allowTime && timeFormat != null) {
        config._isValid = false;
        return;
      }
      if (match[4]) {
        if (tzRegex.exec(match[4])) {
          tzFormat = 'Z';
        } else {
          config._isValid = false;
          return;
        }
      }
      config._f = dateFormat + (timeFormat || '') + (tzFormat || '');
      configFromStringAndFormat(config);
    } else {
      config._isValid = false;
    }
  }
  function extractFromRFC2822Strings(yearStr, monthStr, dayStr, hourStr, minuteStr, secondStr) {
    var result = [untruncateYear(yearStr), defaultLocaleMonthsShort.indexOf(monthStr), parseInt(dayStr, 10), parseInt(hourStr, 10), parseInt(minuteStr, 10)];
    if (secondStr) {
      result.push(parseInt(secondStr, 10));
    }
    return result;
  }
  function untruncateYear(yearStr) {
    var year = parseInt(yearStr, 10);
    if (year <= 49) {
      return 2000 + year;
    } else if (year <= 999) {
      return 1900 + year;
    }
    return year;
  }
  function preprocessRFC2822(s) {
    // Remove comments and folding whitespace and replace multiple-spaces with a single space
    return s.replace(/\([^()]*\)|[\n\t]/g, ' ').replace(/(\s\s+)/g, ' ').replace(/^\s\s*/, '').replace(/\s\s*$/, '');
  }
  function checkWeekday(weekdayStr, parsedInput, config) {
    if (weekdayStr) {
      // TODO: Replace the vanilla JS Date object with an independent day-of-week check.
      var weekdayProvided = defaultLocaleWeekdaysShort.indexOf(weekdayStr),
        weekdayActual = new Date(parsedInput[0], parsedInput[1], parsedInput[2]).getDay();
      if (weekdayProvided !== weekdayActual) {
        getParsingFlags(config).weekdayMismatch = true;
        config._isValid = false;
        return false;
      }
    }
    return true;
  }
  function calculateOffset(obsOffset, militaryOffset, numOffset) {
    if (obsOffset) {
      return obsOffsets[obsOffset];
    } else if (militaryOffset) {
      // the only allowed military tz is Z
      return 0;
    } else {
      var hm = parseInt(numOffset, 10),
        m = hm % 100,
        h = (hm - m) / 100;
      return h * 60 + m;
    }
  }

  // date and time from ref 2822 format
  function configFromRFC2822(config) {
    var match = rfc2822.exec(preprocessRFC2822(config._i)),
      parsedArray;
    if (match) {
      parsedArray = extractFromRFC2822Strings(match[4], match[3], match[2], match[5], match[6], match[7]);
      if (!checkWeekday(match[1], parsedArray, config)) {
        return;
      }
      config._a = parsedArray;
      config._tzm = calculateOffset(match[8], match[9], match[10]);
      config._d = createUTCDate.apply(null, config._a);
      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
      getParsingFlags(config).rfc2822 = true;
    } else {
      config._isValid = false;
    }
  }

  // date from 1) ASP.NET, 2) ISO, 3) RFC 2822 formats, or 4) optional fallback if parsing isn't strict
  function configFromString(config) {
    var matched = aspNetJsonRegex.exec(config._i);
    if (matched !== null) {
      config._d = new Date(+matched[1]);
      return;
    }
    configFromISO(config);
    if (config._isValid === false) {
      delete config._isValid;
    } else {
      return;
    }
    configFromRFC2822(config);
    if (config._isValid === false) {
      delete config._isValid;
    } else {
      return;
    }
    if (config._strict) {
      config._isValid = false;
    } else {
      // Final attempt, use Input Fallback
      hooks.createFromInputFallback(config);
    }
  }
  hooks.createFromInputFallback = deprecate('value provided is not in a recognized RFC2822 or ISO format. moment construction falls back to js Date(), ' + 'which is not reliable across all browsers and versions. Non RFC2822/ISO date formats are ' + 'discouraged. Please refer to http://momentjs.com/guides/#/warnings/js-date/ for more info.', function (config) {
    config._d = new Date(config._i + (config._useUTC ? ' UTC' : ''));
  });

  // Pick the first defined of two or three arguments.
  function defaults(a, b, c) {
    if (a != null) {
      return a;
    }
    if (b != null) {
      return b;
    }
    return c;
  }
  function currentDateArray(config) {
    // hooks is actually the exported moment object
    var nowValue = new Date(hooks.now());
    if (config._useUTC) {
      return [nowValue.getUTCFullYear(), nowValue.getUTCMonth(), nowValue.getUTCDate()];
    }
    return [nowValue.getFullYear(), nowValue.getMonth(), nowValue.getDate()];
  }

  // convert an array to a date.
  // the array should mirror the parameters below
  // note: all values past the year are optional and will default to the lowest possible value.
  // [year, month, day , hour, minute, second, millisecond]
  function configFromArray(config) {
    var i,
      date,
      input = [],
      currentDate,
      expectedWeekday,
      yearToUse;
    if (config._d) {
      return;
    }
    currentDate = currentDateArray(config);

    //compute day of the year from weeks and weekdays
    if (config._w && config._a[DATE] == null && config._a[MONTH] == null) {
      dayOfYearFromWeekInfo(config);
    }

    //if the day of the year is set, figure out what it is
    if (config._dayOfYear != null) {
      yearToUse = defaults(config._a[YEAR], currentDate[YEAR]);
      if (config._dayOfYear > daysInYear(yearToUse) || config._dayOfYear === 0) {
        getParsingFlags(config)._overflowDayOfYear = true;
      }
      date = createUTCDate(yearToUse, 0, config._dayOfYear);
      config._a[MONTH] = date.getUTCMonth();
      config._a[DATE] = date.getUTCDate();
    }

    // Default to current date.
    // * if no year, month, day of month are given, default to today
    // * if day of month is given, default month and year
    // * if month is given, default only year
    // * if year is given, don't default anything
    for (i = 0; i < 3 && config._a[i] == null; ++i) {
      config._a[i] = input[i] = currentDate[i];
    }

    // Zero out whatever was not defaulted, including time
    for (; i < 7; i++) {
      config._a[i] = input[i] = config._a[i] == null ? i === 2 ? 1 : 0 : config._a[i];
    }

    // Check for 24:00:00.000
    if (config._a[HOUR] === 24 && config._a[MINUTE] === 0 && config._a[SECOND] === 0 && config._a[MILLISECOND] === 0) {
      config._nextDay = true;
      config._a[HOUR] = 0;
    }
    config._d = (config._useUTC ? createUTCDate : createDate).apply(null, input);
    expectedWeekday = config._useUTC ? config._d.getUTCDay() : config._d.getDay();

    // Apply timezone offset from input. The actual utcOffset can be changed
    // with parseZone.
    if (config._tzm != null) {
      config._d.setUTCMinutes(config._d.getUTCMinutes() - config._tzm);
    }
    if (config._nextDay) {
      config._a[HOUR] = 24;
    }

    // check for mismatching day of week
    if (config._w && typeof config._w.d !== 'undefined' && config._w.d !== expectedWeekday) {
      getParsingFlags(config).weekdayMismatch = true;
    }
  }
  function dayOfYearFromWeekInfo(config) {
    var w, weekYear, week, weekday, dow, doy, temp, weekdayOverflow, curWeek;
    w = config._w;
    if (w.GG != null || w.W != null || w.E != null) {
      dow = 1;
      doy = 4;

      // TODO: We need to take the current isoWeekYear, but that depends on
      // how we interpret now (local, utc, fixed offset). So create
      // a now version of current config (take local/utc/offset flags, and
      // create now).
      weekYear = defaults(w.GG, config._a[YEAR], weekOfYear(createLocal(), 1, 4).year);
      week = defaults(w.W, 1);
      weekday = defaults(w.E, 1);
      if (weekday < 1 || weekday > 7) {
        weekdayOverflow = true;
      }
    } else {
      dow = config._locale._week.dow;
      doy = config._locale._week.doy;
      curWeek = weekOfYear(createLocal(), dow, doy);
      weekYear = defaults(w.gg, config._a[YEAR], curWeek.year);

      // Default to current week.
      week = defaults(w.w, curWeek.week);
      if (w.d != null) {
        // weekday -- low day numbers are considered next week
        weekday = w.d;
        if (weekday < 0 || weekday > 6) {
          weekdayOverflow = true;
        }
      } else if (w.e != null) {
        // local weekday -- counting starts from beginning of week
        weekday = w.e + dow;
        if (w.e < 0 || w.e > 6) {
          weekdayOverflow = true;
        }
      } else {
        // default to beginning of week
        weekday = dow;
      }
    }
    if (week < 1 || week > weeksInYear(weekYear, dow, doy)) {
      getParsingFlags(config)._overflowWeeks = true;
    } else if (weekdayOverflow != null) {
      getParsingFlags(config)._overflowWeekday = true;
    } else {
      temp = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy);
      config._a[YEAR] = temp.year;
      config._dayOfYear = temp.dayOfYear;
    }
  }

  // constant that refers to the ISO standard
  hooks.ISO_8601 = function () {};

  // constant that refers to the RFC 2822 form
  hooks.RFC_2822 = function () {};

  // date from string and format string
  function configFromStringAndFormat(config) {
    // TODO: Move this to another part of the creation flow to prevent circular deps
    if (config._f === hooks.ISO_8601) {
      configFromISO(config);
      return;
    }
    if (config._f === hooks.RFC_2822) {
      configFromRFC2822(config);
      return;
    }
    config._a = [];
    getParsingFlags(config).empty = true;

    // This array is used to make a Date, either with `new Date` or `Date.UTC`
    var string = '' + config._i,
      i,
      parsedInput,
      tokens,
      token,
      skipped,
      stringLength = string.length,
      totalParsedInputLength = 0,
      era,
      tokenLen;
    tokens = expandFormat(config._f, config._locale).match(formattingTokens) || [];
    tokenLen = tokens.length;
    for (i = 0; i < tokenLen; i++) {
      token = tokens[i];
      parsedInput = (string.match(getParseRegexForToken(token, config)) || [])[0];
      if (parsedInput) {
        skipped = string.substr(0, string.indexOf(parsedInput));
        if (skipped.length > 0) {
          getParsingFlags(config).unusedInput.push(skipped);
        }
        string = string.slice(string.indexOf(parsedInput) + parsedInput.length);
        totalParsedInputLength += parsedInput.length;
      }
      // don't parse if it's not a known token
      if (formatTokenFunctions[token]) {
        if (parsedInput) {
          getParsingFlags(config).empty = false;
        } else {
          getParsingFlags(config).unusedTokens.push(token);
        }
        addTimeToArrayFromToken(token, parsedInput, config);
      } else if (config._strict && !parsedInput) {
        getParsingFlags(config).unusedTokens.push(token);
      }
    }

    // add remaining unparsed input length to the string
    getParsingFlags(config).charsLeftOver = stringLength - totalParsedInputLength;
    if (string.length > 0) {
      getParsingFlags(config).unusedInput.push(string);
    }

    // clear _12h flag if hour is <= 12
    if (config._a[HOUR] <= 12 && getParsingFlags(config).bigHour === true && config._a[HOUR] > 0) {
      getParsingFlags(config).bigHour = undefined;
    }
    getParsingFlags(config).parsedDateParts = config._a.slice(0);
    getParsingFlags(config).meridiem = config._meridiem;
    // handle meridiem
    config._a[HOUR] = meridiemFixWrap(config._locale, config._a[HOUR], config._meridiem);

    // handle era
    era = getParsingFlags(config).era;
    if (era !== null) {
      config._a[YEAR] = config._locale.erasConvertYear(era, config._a[YEAR]);
    }
    configFromArray(config);
    checkOverflow(config);
  }
  function meridiemFixWrap(locale, hour, meridiem) {
    var isPm;
    if (meridiem == null) {
      // nothing to do
      return hour;
    }
    if (locale.meridiemHour != null) {
      return locale.meridiemHour(hour, meridiem);
    } else if (locale.isPM != null) {
      // Fallback
      isPm = locale.isPM(meridiem);
      if (isPm && hour < 12) {
        hour += 12;
      }
      if (!isPm && hour === 12) {
        hour = 0;
      }
      return hour;
    } else {
      // this is not supposed to happen
      return hour;
    }
  }

  // date from string and array of format strings
  function configFromStringAndArray(config) {
    var tempConfig,
      bestMoment,
      scoreToBeat,
      i,
      currentScore,
      validFormatFound,
      bestFormatIsValid = false,
      configfLen = config._f.length;
    if (configfLen === 0) {
      getParsingFlags(config).invalidFormat = true;
      config._d = new Date(NaN);
      return;
    }
    for (i = 0; i < configfLen; i++) {
      currentScore = 0;
      validFormatFound = false;
      tempConfig = copyConfig({}, config);
      if (config._useUTC != null) {
        tempConfig._useUTC = config._useUTC;
      }
      tempConfig._f = config._f[i];
      configFromStringAndFormat(tempConfig);
      if (isValid(tempConfig)) {
        validFormatFound = true;
      }

      // if there is any input that was not parsed add a penalty for that format
      currentScore += getParsingFlags(tempConfig).charsLeftOver;

      //or tokens
      currentScore += getParsingFlags(tempConfig).unusedTokens.length * 10;
      getParsingFlags(tempConfig).score = currentScore;
      if (!bestFormatIsValid) {
        if (scoreToBeat == null || currentScore < scoreToBeat || validFormatFound) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;
          if (validFormatFound) {
            bestFormatIsValid = true;
          }
        }
      } else {
        if (currentScore < scoreToBeat) {
          scoreToBeat = currentScore;
          bestMoment = tempConfig;
        }
      }
    }
    extend(config, bestMoment || tempConfig);
  }
  function configFromObject(config) {
    if (config._d) {
      return;
    }
    var i = normalizeObjectUnits(config._i),
      dayOrDate = i.day === undefined ? i.date : i.day;
    config._a = map([i.year, i.month, dayOrDate, i.hour, i.minute, i.second, i.millisecond], function (obj) {
      return obj && parseInt(obj, 10);
    });
    configFromArray(config);
  }
  function createFromConfig(config) {
    var res = new Moment(checkOverflow(prepareConfig(config)));
    if (res._nextDay) {
      // Adding is smart enough around DST
      res.add(1, 'd');
      res._nextDay = undefined;
    }
    return res;
  }
  function prepareConfig(config) {
    var input = config._i,
      format = config._f;
    config._locale = config._locale || getLocale(config._l);
    if (input === null || format === undefined && input === '') {
      return createInvalid({
        nullInput: true
      });
    }
    if (typeof input === 'string') {
      config._i = input = config._locale.preparse(input);
    }
    if (isMoment(input)) {
      return new Moment(checkOverflow(input));
    } else if (isDate(input)) {
      config._d = input;
    } else if (isArray(format)) {
      configFromStringAndArray(config);
    } else if (format) {
      configFromStringAndFormat(config);
    } else {
      configFromInput(config);
    }
    if (!isValid(config)) {
      config._d = null;
    }
    return config;
  }
  function configFromInput(config) {
    var input = config._i;
    if (isUndefined(input)) {
      config._d = new Date(hooks.now());
    } else if (isDate(input)) {
      config._d = new Date(input.valueOf());
    } else if (typeof input === 'string') {
      configFromString(config);
    } else if (isArray(input)) {
      config._a = map(input.slice(0), function (obj) {
        return parseInt(obj, 10);
      });
      configFromArray(config);
    } else if (isObject(input)) {
      configFromObject(config);
    } else if (isNumber(input)) {
      // from milliseconds
      config._d = new Date(input);
    } else {
      hooks.createFromInputFallback(config);
    }
  }
  function createLocalOrUTC(input, format, locale, strict, isUTC) {
    var c = {};
    if (format === true || format === false) {
      strict = format;
      format = undefined;
    }
    if (locale === true || locale === false) {
      strict = locale;
      locale = undefined;
    }
    if (isObject(input) && isObjectEmpty(input) || isArray(input) && input.length === 0) {
      input = undefined;
    }
    // object construction must be done this way.
    // https://github.com/moment/moment/issues/1423
    c._isAMomentObject = true;
    c._useUTC = c._isUTC = isUTC;
    c._l = locale;
    c._i = input;
    c._f = format;
    c._strict = strict;
    return createFromConfig(c);
  }
  function createLocal(input, format, locale, strict) {
    return createLocalOrUTC(input, format, locale, strict, false);
  }
  var prototypeMin = deprecate('moment().min is deprecated, use moment.max instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
      var other = createLocal.apply(null, arguments);
      if (this.isValid() && other.isValid()) {
        return other < this ? this : other;
      } else {
        return createInvalid();
      }
    }),
    prototypeMax = deprecate('moment().max is deprecated, use moment.min instead. http://momentjs.com/guides/#/warnings/min-max/', function () {
      var other = createLocal.apply(null, arguments);
      if (this.isValid() && other.isValid()) {
        return other > this ? this : other;
      } else {
        return createInvalid();
      }
    });

  // Pick a moment m from moments so that m[fn](other) is true for all
  // other. This relies on the function fn to be transitive.
  //
  // moments should either be an array of moment objects or an array, whose
  // first element is an array of moment objects.
  function pickBy(fn, moments) {
    var res, i;
    if (moments.length === 1 && isArray(moments[0])) {
      moments = moments[0];
    }
    if (!moments.length) {
      return createLocal();
    }
    res = moments[0];
    for (i = 1; i < moments.length; ++i) {
      if (!moments[i].isValid() || moments[i][fn](res)) {
        res = moments[i];
      }
    }
    return res;
  }

  // TODO: Use [].sort instead?
  function min() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isBefore', args);
  }
  function max() {
    var args = [].slice.call(arguments, 0);
    return pickBy('isAfter', args);
  }
  var now = function now() {
    return Date.now ? Date.now() : +new Date();
  };
  var ordering = ['year', 'quarter', 'month', 'week', 'day', 'hour', 'minute', 'second', 'millisecond'];
  function isDurationValid(m) {
    var key,
      unitHasDecimal = false,
      i,
      orderLen = ordering.length;
    for (key in m) {
      if (hasOwnProp(m, key) && !(indexOf.call(ordering, key) !== -1 && (m[key] == null || !isNaN(m[key])))) {
        return false;
      }
    }
    for (i = 0; i < orderLen; ++i) {
      if (m[ordering[i]]) {
        if (unitHasDecimal) {
          return false; // only allow non-integers for smallest unit
        }
        if (parseFloat(m[ordering[i]]) !== toInt(m[ordering[i]])) {
          unitHasDecimal = true;
        }
      }
    }
    return true;
  }
  function isValid$1() {
    return this._isValid;
  }
  function createInvalid$1() {
    return createDuration(NaN);
  }
  function Duration(duration) {
    var normalizedInput = normalizeObjectUnits(duration),
      years = normalizedInput.year || 0,
      quarters = normalizedInput.quarter || 0,
      months = normalizedInput.month || 0,
      weeks = normalizedInput.week || normalizedInput.isoWeek || 0,
      days = normalizedInput.day || 0,
      hours = normalizedInput.hour || 0,
      minutes = normalizedInput.minute || 0,
      seconds = normalizedInput.second || 0,
      milliseconds = normalizedInput.millisecond || 0;
    this._isValid = isDurationValid(normalizedInput);

    // representation for dateAddRemove
    this._milliseconds = +milliseconds + seconds * 1e3 +
    // 1000
    minutes * 6e4 +
    // 1000 * 60
    hours * 1000 * 60 * 60; //using 1000 * 60 * 60 instead of 36e5 to avoid floating point rounding errors https://github.com/moment/moment/issues/2978
    // Because of dateAddRemove treats 24 hours as different from a
    // day when working around DST, we need to store them separately
    this._days = +days + weeks * 7;
    // It is impossible to translate months into days without knowing
    // which months you are are talking about, so we have to store
    // it separately.
    this._months = +months + quarters * 3 + years * 12;
    this._data = {};
    this._locale = getLocale();
    this._bubble();
  }
  function isDuration(obj) {
    return obj instanceof Duration;
  }
  function absRound(number) {
    if (number < 0) {
      return Math.round(-1 * number) * -1;
    } else {
      return Math.round(number);
    }
  }

  // compare two arrays, return the number of differences
  function compareArrays(array1, array2, dontConvert) {
    var len = Math.min(array1.length, array2.length),
      lengthDiff = Math.abs(array1.length - array2.length),
      diffs = 0,
      i;
    for (i = 0; i < len; i++) {
      if (dontConvert && array1[i] !== array2[i] || !dontConvert && toInt(array1[i]) !== toInt(array2[i])) {
        diffs++;
      }
    }
    return diffs + lengthDiff;
  }

  // FORMATTING

  function offset(token, separator) {
    addFormatToken(token, 0, 0, function () {
      var offset = this.utcOffset(),
        sign = '+';
      if (offset < 0) {
        offset = -offset;
        sign = '-';
      }
      return sign + zeroFill(~~(offset / 60), 2) + separator + zeroFill(~~offset % 60, 2);
    });
  }
  offset('Z', ':');
  offset('ZZ', '');

  // PARSING

  addRegexToken('Z', matchShortOffset);
  addRegexToken('ZZ', matchShortOffset);
  addParseToken(['Z', 'ZZ'], function (input, array, config) {
    config._useUTC = true;
    config._tzm = offsetFromString(matchShortOffset, input);
  });

  // HELPERS

  // timezone chunker
  // '+10:00' > ['10',  '00']
  // '-1530'  > ['-15', '30']
  var chunkOffset = /([\+\-]|\d\d)/gi;
  function offsetFromString(matcher, string) {
    var matches = (string || '').match(matcher),
      chunk,
      parts,
      minutes;
    if (matches === null) {
      return null;
    }
    chunk = matches[matches.length - 1] || [];
    parts = (chunk + '').match(chunkOffset) || ['-', 0, 0];
    minutes = +(parts[1] * 60) + toInt(parts[2]);
    return minutes === 0 ? 0 : parts[0] === '+' ? minutes : -minutes;
  }

  // Return a moment from input, that is local/utc/zone equivalent to model.
  function cloneWithOffset(input, model) {
    var res, diff;
    if (model._isUTC) {
      res = model.clone();
      diff = (isMoment(input) || isDate(input) ? input.valueOf() : createLocal(input).valueOf()) - res.valueOf();
      // Use low-level api, because this fn is low-level api.
      res._d.setTime(res._d.valueOf() + diff);
      hooks.updateOffset(res, false);
      return res;
    } else {
      return createLocal(input).local();
    }
  }
  function getDateOffset(m) {
    // On Firefox.24 Date#getTimezoneOffset returns a floating point.
    // https://github.com/moment/moment/pull/1871
    return -Math.round(m._d.getTimezoneOffset());
  }

  // HOOKS

  // This function will be called whenever a moment is mutated.
  // It is intended to keep the offset in sync with the timezone.
  hooks.updateOffset = function () {};

  // MOMENTS

  // keepLocalTime = true means only change the timezone, without
  // affecting the local hour. So 5:31:26 +0300 --[utcOffset(2, true)]-->
  // 5:31:26 +0200 It is possible that 5:31:26 doesn't exist with offset
  // +0200, so we adjust the time as needed, to be valid.
  //
  // Keeping the time actually adds/subtracts (one hour)
  // from the actual represented time. That is why we call updateOffset
  // a second time. In case it wants us to change the offset again
  // _changeInProgress == true case, then we have to adjust, because
  // there is no such time in the given timezone.
  function getSetOffset(input, keepLocalTime, keepMinutes) {
    var offset = this._offset || 0,
      localAdjust;
    if (!this.isValid()) {
      return input != null ? this : NaN;
    }
    if (input != null) {
      if (typeof input === 'string') {
        input = offsetFromString(matchShortOffset, input);
        if (input === null) {
          return this;
        }
      } else if (Math.abs(input) < 16 && !keepMinutes) {
        input = input * 60;
      }
      if (!this._isUTC && keepLocalTime) {
        localAdjust = getDateOffset(this);
      }
      this._offset = input;
      this._isUTC = true;
      if (localAdjust != null) {
        this.add(localAdjust, 'm');
      }
      if (offset !== input) {
        if (!keepLocalTime || this._changeInProgress) {
          addSubtract(this, createDuration(input - offset, 'm'), 1, false);
        } else if (!this._changeInProgress) {
          this._changeInProgress = true;
          hooks.updateOffset(this, true);
          this._changeInProgress = null;
        }
      }
      return this;
    } else {
      return this._isUTC ? offset : getDateOffset(this);
    }
  }
  function getSetZone(input, keepLocalTime) {
    if (input != null) {
      if (typeof input !== 'string') {
        input = -input;
      }
      this.utcOffset(input, keepLocalTime);
      return this;
    } else {
      return -this.utcOffset();
    }
  }
  function setOffsetToUTC(keepLocalTime) {
    return this.utcOffset(0, keepLocalTime);
  }
  function setOffsetToLocal(keepLocalTime) {
    if (this._isUTC) {
      this.utcOffset(0, keepLocalTime);
      this._isUTC = false;
      if (keepLocalTime) {
        this.subtract(getDateOffset(this), 'm');
      }
    }
    return this;
  }
  function setOffsetToParsedOffset() {
    if (this._tzm != null) {
      this.utcOffset(this._tzm, false, true);
    } else if (typeof this._i === 'string') {
      var tZone = offsetFromString(matchOffset, this._i);
      if (tZone != null) {
        this.utcOffset(tZone);
      } else {
        this.utcOffset(0, true);
      }
    }
    return this;
  }
  function hasAlignedHourOffset(input) {
    if (!this.isValid()) {
      return false;
    }
    input = input ? createLocal(input).utcOffset() : 0;
    return (this.utcOffset() - input) % 60 === 0;
  }
  function isDaylightSavingTime() {
    return this.utcOffset() > this.clone().month(0).utcOffset() || this.utcOffset() > this.clone().month(5).utcOffset();
  }
  function isDaylightSavingTimeShifted() {
    if (!isUndefined(this._isDSTShifted)) {
      return this._isDSTShifted;
    }
    var c = {},
      other;
    copyConfig(c, this);
    c = prepareConfig(c);
    if (c._a) {
      other = c._isUTC ? createUTC(c._a) : createLocal(c._a);
      this._isDSTShifted = this.isValid() && compareArrays(c._a, other.toArray()) > 0;
    } else {
      this._isDSTShifted = false;
    }
    return this._isDSTShifted;
  }
  function isLocal() {
    return this.isValid() ? !this._isUTC : false;
  }
  function isUtcOffset() {
    return this.isValid() ? this._isUTC : false;
  }
  function isUtc() {
    return this.isValid() ? this._isUTC && this._offset === 0 : false;
  }

  // ASP.NET json date format regex
  var aspNetRegex = /^(-|\+)?(?:(\d*)[. ])?(\d+):(\d+)(?::(\d+)(\.\d*)?)?$/,
    // from http://docs.closure-library.googlecode.com/git/closure_goog_date_date.js.source.html
    // somewhat more in line with 4.4.3.2 2004 spec, but allows decimal anywhere
    // and further modified to allow for strings containing both week and day
    isoRegex = /^(-|\+)?P(?:([-+]?[0-9,.]*)Y)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)W)?(?:([-+]?[0-9,.]*)D)?(?:T(?:([-+]?[0-9,.]*)H)?(?:([-+]?[0-9,.]*)M)?(?:([-+]?[0-9,.]*)S)?)?$/;
  function createDuration(input, key) {
    var duration = input,
      // matching against regexp is expensive, do it on demand
      match = null,
      sign,
      ret,
      diffRes;
    if (isDuration(input)) {
      duration = {
        ms: input._milliseconds,
        d: input._days,
        M: input._months
      };
    } else if (isNumber(input) || !isNaN(+input)) {
      duration = {};
      if (key) {
        duration[key] = +input;
      } else {
        duration.milliseconds = +input;
      }
    } else if (match = aspNetRegex.exec(input)) {
      sign = match[1] === '-' ? -1 : 1;
      duration = {
        y: 0,
        d: toInt(match[DATE]) * sign,
        h: toInt(match[HOUR]) * sign,
        m: toInt(match[MINUTE]) * sign,
        s: toInt(match[SECOND]) * sign,
        ms: toInt(absRound(match[MILLISECOND] * 1000)) * sign // the millisecond decimal point is included in the match
      };
    } else if (match = isoRegex.exec(input)) {
      sign = match[1] === '-' ? -1 : 1;
      duration = {
        y: parseIso(match[2], sign),
        M: parseIso(match[3], sign),
        w: parseIso(match[4], sign),
        d: parseIso(match[5], sign),
        h: parseIso(match[6], sign),
        m: parseIso(match[7], sign),
        s: parseIso(match[8], sign)
      };
    } else if (duration == null) {
      // checks for null or undefined
      duration = {};
    } else if (_typeof(duration) === 'object' && ('from' in duration || 'to' in duration)) {
      diffRes = momentsDifference(createLocal(duration.from), createLocal(duration.to));
      duration = {};
      duration.ms = diffRes.milliseconds;
      duration.M = diffRes.months;
    }
    ret = new Duration(duration);
    if (isDuration(input) && hasOwnProp(input, '_locale')) {
      ret._locale = input._locale;
    }
    if (isDuration(input) && hasOwnProp(input, '_isValid')) {
      ret._isValid = input._isValid;
    }
    return ret;
  }
  createDuration.fn = Duration.prototype;
  createDuration.invalid = createInvalid$1;
  function parseIso(inp, sign) {
    // We'd normally use ~~inp for this, but unfortunately it also
    // converts floats to ints.
    // inp may be undefined, so careful calling replace on it.
    var res = inp && parseFloat(inp.replace(',', '.'));
    // apply sign while we're at it
    return (isNaN(res) ? 0 : res) * sign;
  }
  function positiveMomentsDifference(base, other) {
    var res = {};
    res.months = other.month() - base.month() + (other.year() - base.year()) * 12;
    if (base.clone().add(res.months, 'M').isAfter(other)) {
      --res.months;
    }
    res.milliseconds = +other - +base.clone().add(res.months, 'M');
    return res;
  }
  function momentsDifference(base, other) {
    var res;
    if (!(base.isValid() && other.isValid())) {
      return {
        milliseconds: 0,
        months: 0
      };
    }
    other = cloneWithOffset(other, base);
    if (base.isBefore(other)) {
      res = positiveMomentsDifference(base, other);
    } else {
      res = positiveMomentsDifference(other, base);
      res.milliseconds = -res.milliseconds;
      res.months = -res.months;
    }
    return res;
  }

  // TODO: remove 'name' arg after deprecation is removed
  function createAdder(direction, name) {
    return function (val, period) {
      var dur, tmp;
      //invert the arguments, but complain about it
      if (period !== null && !isNaN(+period)) {
        deprecateSimple(name, 'moment().' + name + '(period, number) is deprecated. Please use moment().' + name + '(number, period). ' + 'See http://momentjs.com/guides/#/warnings/add-inverted-param/ for more info.');
        tmp = val;
        val = period;
        period = tmp;
      }
      dur = createDuration(val, period);
      addSubtract(this, dur, direction);
      return this;
    };
  }
  function addSubtract(mom, duration, isAdding, updateOffset) {
    var milliseconds = duration._milliseconds,
      days = absRound(duration._days),
      months = absRound(duration._months);
    if (!mom.isValid()) {
      // No op
      return;
    }
    updateOffset = updateOffset == null ? true : updateOffset;
    if (months) {
      setMonth(mom, get(mom, 'Month') + months * isAdding);
    }
    if (days) {
      set$1(mom, 'Date', get(mom, 'Date') + days * isAdding);
    }
    if (milliseconds) {
      mom._d.setTime(mom._d.valueOf() + milliseconds * isAdding);
    }
    if (updateOffset) {
      hooks.updateOffset(mom, days || months);
    }
  }
  var add = createAdder(1, 'add'),
    subtract = createAdder(-1, 'subtract');
  function isString(input) {
    return typeof input === 'string' || input instanceof String;
  }

  // type MomentInput = Moment | Date | string | number | (number | string)[] | MomentInputObject | void; // null | undefined
  function isMomentInput(input) {
    return isMoment(input) || isDate(input) || isString(input) || isNumber(input) || isNumberOrStringArray(input) || isMomentInputObject(input) || input === null || input === undefined;
  }
  function isMomentInputObject(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input),
      propertyTest = false,
      properties = ['years', 'year', 'y', 'months', 'month', 'M', 'days', 'day', 'd', 'dates', 'date', 'D', 'hours', 'hour', 'h', 'minutes', 'minute', 'm', 'seconds', 'second', 's', 'milliseconds', 'millisecond', 'ms'],
      i,
      property,
      propertyLen = properties.length;
    for (i = 0; i < propertyLen; i += 1) {
      property = properties[i];
      propertyTest = propertyTest || hasOwnProp(input, property);
    }
    return objectTest && propertyTest;
  }
  function isNumberOrStringArray(input) {
    var arrayTest = isArray(input),
      dataTypeTest = false;
    if (arrayTest) {
      dataTypeTest = input.filter(function (item) {
        return !isNumber(item) && isString(input);
      }).length === 0;
    }
    return arrayTest && dataTypeTest;
  }
  function isCalendarSpec(input) {
    var objectTest = isObject(input) && !isObjectEmpty(input),
      propertyTest = false,
      properties = ['sameDay', 'nextDay', 'lastDay', 'nextWeek', 'lastWeek', 'sameElse'],
      i,
      property;
    for (i = 0; i < properties.length; i += 1) {
      property = properties[i];
      propertyTest = propertyTest || hasOwnProp(input, property);
    }
    return objectTest && propertyTest;
  }
  function getCalendarFormat(myMoment, now) {
    var diff = myMoment.diff(now, 'days', true);
    return diff < -6 ? 'sameElse' : diff < -1 ? 'lastWeek' : diff < 0 ? 'lastDay' : diff < 1 ? 'sameDay' : diff < 2 ? 'nextDay' : diff < 7 ? 'nextWeek' : 'sameElse';
  }
  function calendar$1(time, formats) {
    // Support for single parameter, formats only overload to the calendar function
    if (arguments.length === 1) {
      if (!arguments[0]) {
        time = undefined;
        formats = undefined;
      } else if (isMomentInput(arguments[0])) {
        time = arguments[0];
        formats = undefined;
      } else if (isCalendarSpec(arguments[0])) {
        formats = arguments[0];
        time = undefined;
      }
    }
    // We want to compare the start of today, vs this.
    // Getting start-of-today depends on whether we're local/utc/offset or not.
    var now = time || createLocal(),
      sod = cloneWithOffset(now, this).startOf('day'),
      format = hooks.calendarFormat(this, sod) || 'sameElse',
      output = formats && (isFunction(formats[format]) ? formats[format].call(this, now) : formats[format]);
    return this.format(output || this.localeData().calendar(format, this, createLocal(now)));
  }
  function clone() {
    return new Moment(this);
  }
  function isAfter(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
      return this.valueOf() > localInput.valueOf();
    } else {
      return localInput.valueOf() < this.clone().startOf(units).valueOf();
    }
  }
  function isBefore(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input);
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
      return this.valueOf() < localInput.valueOf();
    } else {
      return this.clone().endOf(units).valueOf() < localInput.valueOf();
    }
  }
  function isBetween(from, to, units, inclusivity) {
    var localFrom = isMoment(from) ? from : createLocal(from),
      localTo = isMoment(to) ? to : createLocal(to);
    if (!(this.isValid() && localFrom.isValid() && localTo.isValid())) {
      return false;
    }
    inclusivity = inclusivity || '()';
    return (inclusivity[0] === '(' ? this.isAfter(localFrom, units) : !this.isBefore(localFrom, units)) && (inclusivity[1] === ')' ? this.isBefore(localTo, units) : !this.isAfter(localTo, units));
  }
  function isSame(input, units) {
    var localInput = isMoment(input) ? input : createLocal(input),
      inputMs;
    if (!(this.isValid() && localInput.isValid())) {
      return false;
    }
    units = normalizeUnits(units) || 'millisecond';
    if (units === 'millisecond') {
      return this.valueOf() === localInput.valueOf();
    } else {
      inputMs = localInput.valueOf();
      return this.clone().startOf(units).valueOf() <= inputMs && inputMs <= this.clone().endOf(units).valueOf();
    }
  }
  function isSameOrAfter(input, units) {
    return this.isSame(input, units) || this.isAfter(input, units);
  }
  function isSameOrBefore(input, units) {
    return this.isSame(input, units) || this.isBefore(input, units);
  }
  function diff(input, units, asFloat) {
    var that, zoneDelta, output;
    if (!this.isValid()) {
      return NaN;
    }
    that = cloneWithOffset(input, this);
    if (!that.isValid()) {
      return NaN;
    }
    zoneDelta = (that.utcOffset() - this.utcOffset()) * 6e4;
    units = normalizeUnits(units);
    switch (units) {
      case 'year':
        output = monthDiff(this, that) / 12;
        break;
      case 'month':
        output = monthDiff(this, that);
        break;
      case 'quarter':
        output = monthDiff(this, that) / 3;
        break;
      case 'second':
        output = (this - that) / 1e3;
        break;
      // 1000
      case 'minute':
        output = (this - that) / 6e4;
        break;
      // 1000 * 60
      case 'hour':
        output = (this - that) / 36e5;
        break;
      // 1000 * 60 * 60
      case 'day':
        output = (this - that - zoneDelta) / 864e5;
        break;
      // 1000 * 60 * 60 * 24, negate dst
      case 'week':
        output = (this - that - zoneDelta) / 6048e5;
        break;
      // 1000 * 60 * 60 * 24 * 7, negate dst
      default:
        output = this - that;
    }
    return asFloat ? output : absFloor(output);
  }
  function monthDiff(a, b) {
    if (a.date() < b.date()) {
      // end-of-month calculations work correct when the start month has more
      // days than the end month.
      return -monthDiff(b, a);
    }
    // difference in months
    var wholeMonthDiff = (b.year() - a.year()) * 12 + (b.month() - a.month()),
      // b is in (anchor - 1 month, anchor + 1 month)
      anchor = a.clone().add(wholeMonthDiff, 'months'),
      anchor2,
      adjust;
    if (b - anchor < 0) {
      anchor2 = a.clone().add(wholeMonthDiff - 1, 'months');
      // linear across the month
      adjust = (b - anchor) / (anchor - anchor2);
    } else {
      anchor2 = a.clone().add(wholeMonthDiff + 1, 'months');
      // linear across the month
      adjust = (b - anchor) / (anchor2 - anchor);
    }

    //check for negative zero, return zero if negative zero
    return -(wholeMonthDiff + adjust) || 0;
  }
  hooks.defaultFormat = 'YYYY-MM-DDTHH:mm:ssZ';
  hooks.defaultFormatUtc = 'YYYY-MM-DDTHH:mm:ss[Z]';
  function toString() {
    return this.clone().locale('en').format('ddd MMM DD YYYY HH:mm:ss [GMT]ZZ');
  }
  function toISOString(keepOffset) {
    if (!this.isValid()) {
      return null;
    }
    var utc = keepOffset !== true,
      m = utc ? this.clone().utc() : this;
    if (m.year() < 0 || m.year() > 9999) {
      return formatMoment(m, utc ? 'YYYYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYYYY-MM-DD[T]HH:mm:ss.SSSZ');
    }
    if (isFunction(Date.prototype.toISOString)) {
      // native implementation is ~50x faster, use it when we can
      if (utc) {
        return this.toDate().toISOString();
      } else {
        return new Date(this.valueOf() + this.utcOffset() * 60 * 1000).toISOString().replace('Z', formatMoment(m, 'Z'));
      }
    }
    return formatMoment(m, utc ? 'YYYY-MM-DD[T]HH:mm:ss.SSS[Z]' : 'YYYY-MM-DD[T]HH:mm:ss.SSSZ');
  }

  /**
   * Return a human readable representation of a moment that can
   * also be evaluated to get a new moment which is the same
   *
   * @link https://nodejs.org/dist/latest/docs/api/util.html#util_custom_inspect_function_on_objects
   */
  function inspect() {
    if (!this.isValid()) {
      return 'moment.invalid(/* ' + this._i + ' */)';
    }
    var func = 'moment',
      zone = '',
      prefix,
      year,
      datetime,
      suffix;
    if (!this.isLocal()) {
      func = this.utcOffset() === 0 ? 'moment.utc' : 'moment.parseZone';
      zone = 'Z';
    }
    prefix = '[' + func + '("]';
    year = 0 <= this.year() && this.year() <= 9999 ? 'YYYY' : 'YYYYYY';
    datetime = '-MM-DD[T]HH:mm:ss.SSS';
    suffix = zone + '[")]';
    return this.format(prefix + year + datetime + suffix);
  }
  function format(inputString) {
    if (!inputString) {
      inputString = this.isUtc() ? hooks.defaultFormatUtc : hooks.defaultFormat;
    }
    var output = formatMoment(this, inputString);
    return this.localeData().postformat(output);
  }
  function from(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
      return createDuration({
        to: this,
        from: time
      }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }
  function fromNow(withoutSuffix) {
    return this.from(createLocal(), withoutSuffix);
  }
  function to(time, withoutSuffix) {
    if (this.isValid() && (isMoment(time) && time.isValid() || createLocal(time).isValid())) {
      return createDuration({
        from: this,
        to: time
      }).locale(this.locale()).humanize(!withoutSuffix);
    } else {
      return this.localeData().invalidDate();
    }
  }
  function toNow(withoutSuffix) {
    return this.to(createLocal(), withoutSuffix);
  }

  // If passed a locale key, it will set the locale for this
  // instance.  Otherwise, it will return the locale configuration
  // variables for this instance.
  function locale(key) {
    var newLocaleData;
    if (key === undefined) {
      return this._locale._abbr;
    } else {
      newLocaleData = getLocale(key);
      if (newLocaleData != null) {
        this._locale = newLocaleData;
      }
      return this;
    }
  }
  var lang = deprecate('moment().lang() is deprecated. Instead, use moment().localeData() to get the language configuration. Use moment().locale() to change languages.', function (key) {
    if (key === undefined) {
      return this.localeData();
    } else {
      return this.locale(key);
    }
  });
  function localeData() {
    return this._locale;
  }
  var MS_PER_SECOND = 1000,
    MS_PER_MINUTE = 60 * MS_PER_SECOND,
    MS_PER_HOUR = 60 * MS_PER_MINUTE,
    MS_PER_400_YEARS = (365 * 400 + 97) * 24 * MS_PER_HOUR;

  // actual modulo - handles negative numbers (for dates before 1970):
  function mod$1(dividend, divisor) {
    return (dividend % divisor + divisor) % divisor;
  }
  function localStartOfDate(y, m, d) {
    // the date constructor remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
      // preserve leap years using a full 400 year cycle, then reset
      return new Date(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
      return new Date(y, m, d).valueOf();
    }
  }
  function utcStartOfDate(y, m, d) {
    // Date.UTC remaps years 0-99 to 1900-1999
    if (y < 100 && y >= 0) {
      // preserve leap years using a full 400 year cycle, then reset
      return Date.UTC(y + 400, m, d) - MS_PER_400_YEARS;
    } else {
      return Date.UTC(y, m, d);
    }
  }
  function startOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond' || !this.isValid()) {
      return this;
    }
    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
    switch (units) {
      case 'year':
        time = startOfDate(this.year(), 0, 1);
        break;
      case 'quarter':
        time = startOfDate(this.year(), this.month() - this.month() % 3, 1);
        break;
      case 'month':
        time = startOfDate(this.year(), this.month(), 1);
        break;
      case 'week':
        time = startOfDate(this.year(), this.month(), this.date() - this.weekday());
        break;
      case 'isoWeek':
        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1));
        break;
      case 'day':
      case 'date':
        time = startOfDate(this.year(), this.month(), this.date());
        break;
      case 'hour':
        time = this._d.valueOf();
        time -= mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR);
        break;
      case 'minute':
        time = this._d.valueOf();
        time -= mod$1(time, MS_PER_MINUTE);
        break;
      case 'second':
        time = this._d.valueOf();
        time -= mod$1(time, MS_PER_SECOND);
        break;
    }
    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
  }
  function endOf(units) {
    var time, startOfDate;
    units = normalizeUnits(units);
    if (units === undefined || units === 'millisecond' || !this.isValid()) {
      return this;
    }
    startOfDate = this._isUTC ? utcStartOfDate : localStartOfDate;
    switch (units) {
      case 'year':
        time = startOfDate(this.year() + 1, 0, 1) - 1;
        break;
      case 'quarter':
        time = startOfDate(this.year(), this.month() - this.month() % 3 + 3, 1) - 1;
        break;
      case 'month':
        time = startOfDate(this.year(), this.month() + 1, 1) - 1;
        break;
      case 'week':
        time = startOfDate(this.year(), this.month(), this.date() - this.weekday() + 7) - 1;
        break;
      case 'isoWeek':
        time = startOfDate(this.year(), this.month(), this.date() - (this.isoWeekday() - 1) + 7) - 1;
        break;
      case 'day':
      case 'date':
        time = startOfDate(this.year(), this.month(), this.date() + 1) - 1;
        break;
      case 'hour':
        time = this._d.valueOf();
        time += MS_PER_HOUR - mod$1(time + (this._isUTC ? 0 : this.utcOffset() * MS_PER_MINUTE), MS_PER_HOUR) - 1;
        break;
      case 'minute':
        time = this._d.valueOf();
        time += MS_PER_MINUTE - mod$1(time, MS_PER_MINUTE) - 1;
        break;
      case 'second':
        time = this._d.valueOf();
        time += MS_PER_SECOND - mod$1(time, MS_PER_SECOND) - 1;
        break;
    }
    this._d.setTime(time);
    hooks.updateOffset(this, true);
    return this;
  }
  function valueOf() {
    return this._d.valueOf() - (this._offset || 0) * 60000;
  }
  function unix() {
    return Math.floor(this.valueOf() / 1000);
  }
  function toDate() {
    return new Date(this.valueOf());
  }
  function toArray() {
    var m = this;
    return [m.year(), m.month(), m.date(), m.hour(), m.minute(), m.second(), m.millisecond()];
  }
  function toObject() {
    var m = this;
    return {
      years: m.year(),
      months: m.month(),
      date: m.date(),
      hours: m.hours(),
      minutes: m.minutes(),
      seconds: m.seconds(),
      milliseconds: m.milliseconds()
    };
  }
  function toJSON() {
    // new Date(NaN).toJSON() === null
    return this.isValid() ? this.toISOString() : null;
  }
  function isValid$2() {
    return isValid(this);
  }
  function parsingFlags() {
    return extend({}, getParsingFlags(this));
  }
  function invalidAt() {
    return getParsingFlags(this).overflow;
  }
  function creationData() {
    return {
      input: this._i,
      format: this._f,
      locale: this._locale,
      isUTC: this._isUTC,
      strict: this._strict
    };
  }
  addFormatToken('N', 0, 0, 'eraAbbr');
  addFormatToken('NN', 0, 0, 'eraAbbr');
  addFormatToken('NNN', 0, 0, 'eraAbbr');
  addFormatToken('NNNN', 0, 0, 'eraName');
  addFormatToken('NNNNN', 0, 0, 'eraNarrow');
  addFormatToken('y', ['y', 1], 'yo', 'eraYear');
  addFormatToken('y', ['yy', 2], 0, 'eraYear');
  addFormatToken('y', ['yyy', 3], 0, 'eraYear');
  addFormatToken('y', ['yyyy', 4], 0, 'eraYear');
  addRegexToken('N', matchEraAbbr);
  addRegexToken('NN', matchEraAbbr);
  addRegexToken('NNN', matchEraAbbr);
  addRegexToken('NNNN', matchEraName);
  addRegexToken('NNNNN', matchEraNarrow);
  addParseToken(['N', 'NN', 'NNN', 'NNNN', 'NNNNN'], function (input, array, config, token) {
    var era = config._locale.erasParse(input, token, config._strict);
    if (era) {
      getParsingFlags(config).era = era;
    } else {
      getParsingFlags(config).invalidEra = input;
    }
  });
  addRegexToken('y', matchUnsigned);
  addRegexToken('yy', matchUnsigned);
  addRegexToken('yyy', matchUnsigned);
  addRegexToken('yyyy', matchUnsigned);
  addRegexToken('yo', matchEraYearOrdinal);
  addParseToken(['y', 'yy', 'yyy', 'yyyy'], YEAR);
  addParseToken(['yo'], function (input, array, config, token) {
    var match;
    if (config._locale._eraYearOrdinalRegex) {
      match = input.match(config._locale._eraYearOrdinalRegex);
    }
    if (config._locale.eraYearOrdinalParse) {
      array[YEAR] = config._locale.eraYearOrdinalParse(input, match);
    } else {
      array[YEAR] = parseInt(input, 10);
    }
  });
  function localeEras(m, format) {
    var i,
      l,
      date,
      eras = this._eras || getLocale('en')._eras;
    for (i = 0, l = eras.length; i < l; ++i) {
      switch (_typeof(eras[i].since)) {
        case 'string':
          // truncate time
          date = hooks(eras[i].since).startOf('day');
          eras[i].since = date.valueOf();
          break;
      }
      switch (_typeof(eras[i].until)) {
        case 'undefined':
          eras[i].until = +Infinity;
          break;
        case 'string':
          // truncate time
          date = hooks(eras[i].until).startOf('day').valueOf();
          eras[i].until = date.valueOf();
          break;
      }
    }
    return eras;
  }
  function localeErasParse(eraName, format, strict) {
    var i,
      l,
      eras = this.eras(),
      name,
      abbr,
      narrow;
    eraName = eraName.toUpperCase();
    for (i = 0, l = eras.length; i < l; ++i) {
      name = eras[i].name.toUpperCase();
      abbr = eras[i].abbr.toUpperCase();
      narrow = eras[i].narrow.toUpperCase();
      if (strict) {
        switch (format) {
          case 'N':
          case 'NN':
          case 'NNN':
            if (abbr === eraName) {
              return eras[i];
            }
            break;
          case 'NNNN':
            if (name === eraName) {
              return eras[i];
            }
            break;
          case 'NNNNN':
            if (narrow === eraName) {
              return eras[i];
            }
            break;
        }
      } else if ([name, abbr, narrow].indexOf(eraName) >= 0) {
        return eras[i];
      }
    }
  }
  function localeErasConvertYear(era, year) {
    var dir = era.since <= era.until ? +1 : -1;
    if (year === undefined) {
      return hooks(era.since).year();
    } else {
      return hooks(era.since).year() + (year - era.offset) * dir;
    }
  }
  function getEraName() {
    var i,
      l,
      val,
      eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      // truncate time
      val = this.clone().startOf('day').valueOf();
      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].name;
      }
      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].name;
      }
    }
    return '';
  }
  function getEraNarrow() {
    var i,
      l,
      val,
      eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      // truncate time
      val = this.clone().startOf('day').valueOf();
      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].narrow;
      }
      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].narrow;
      }
    }
    return '';
  }
  function getEraAbbr() {
    var i,
      l,
      val,
      eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      // truncate time
      val = this.clone().startOf('day').valueOf();
      if (eras[i].since <= val && val <= eras[i].until) {
        return eras[i].abbr;
      }
      if (eras[i].until <= val && val <= eras[i].since) {
        return eras[i].abbr;
      }
    }
    return '';
  }
  function getEraYear() {
    var i,
      l,
      dir,
      val,
      eras = this.localeData().eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      dir = eras[i].since <= eras[i].until ? +1 : -1;

      // truncate time
      val = this.clone().startOf('day').valueOf();
      if (eras[i].since <= val && val <= eras[i].until || eras[i].until <= val && val <= eras[i].since) {
        return (this.year() - hooks(eras[i].since).year()) * dir + eras[i].offset;
      }
    }
    return this.year();
  }
  function erasNameRegex(isStrict) {
    if (!hasOwnProp(this, '_erasNameRegex')) {
      computeErasParse.call(this);
    }
    return isStrict ? this._erasNameRegex : this._erasRegex;
  }
  function erasAbbrRegex(isStrict) {
    if (!hasOwnProp(this, '_erasAbbrRegex')) {
      computeErasParse.call(this);
    }
    return isStrict ? this._erasAbbrRegex : this._erasRegex;
  }
  function erasNarrowRegex(isStrict) {
    if (!hasOwnProp(this, '_erasNarrowRegex')) {
      computeErasParse.call(this);
    }
    return isStrict ? this._erasNarrowRegex : this._erasRegex;
  }
  function matchEraAbbr(isStrict, locale) {
    return locale.erasAbbrRegex(isStrict);
  }
  function matchEraName(isStrict, locale) {
    return locale.erasNameRegex(isStrict);
  }
  function matchEraNarrow(isStrict, locale) {
    return locale.erasNarrowRegex(isStrict);
  }
  function matchEraYearOrdinal(isStrict, locale) {
    return locale._eraYearOrdinalRegex || matchUnsigned;
  }
  function computeErasParse() {
    var abbrPieces = [],
      namePieces = [],
      narrowPieces = [],
      mixedPieces = [],
      i,
      l,
      erasName,
      erasAbbr,
      erasNarrow,
      eras = this.eras();
    for (i = 0, l = eras.length; i < l; ++i) {
      erasName = regexEscape(eras[i].name);
      erasAbbr = regexEscape(eras[i].abbr);
      erasNarrow = regexEscape(eras[i].narrow);
      namePieces.push(erasName);
      abbrPieces.push(erasAbbr);
      narrowPieces.push(erasNarrow);
      mixedPieces.push(erasName);
      mixedPieces.push(erasAbbr);
      mixedPieces.push(erasNarrow);
    }
    this._erasRegex = new RegExp('^(' + mixedPieces.join('|') + ')', 'i');
    this._erasNameRegex = new RegExp('^(' + namePieces.join('|') + ')', 'i');
    this._erasAbbrRegex = new RegExp('^(' + abbrPieces.join('|') + ')', 'i');
    this._erasNarrowRegex = new RegExp('^(' + narrowPieces.join('|') + ')', 'i');
  }

  // FORMATTING

  addFormatToken(0, ['gg', 2], 0, function () {
    return this.weekYear() % 100;
  });
  addFormatToken(0, ['GG', 2], 0, function () {
    return this.isoWeekYear() % 100;
  });
  function addWeekYearFormatToken(token, getter) {
    addFormatToken(0, [token, token.length], 0, getter);
  }
  addWeekYearFormatToken('gggg', 'weekYear');
  addWeekYearFormatToken('ggggg', 'weekYear');
  addWeekYearFormatToken('GGGG', 'isoWeekYear');
  addWeekYearFormatToken('GGGGG', 'isoWeekYear');

  // ALIASES

  // PARSING

  addRegexToken('G', matchSigned);
  addRegexToken('g', matchSigned);
  addRegexToken('GG', match1to2, match2);
  addRegexToken('gg', match1to2, match2);
  addRegexToken('GGGG', match1to4, match4);
  addRegexToken('gggg', match1to4, match4);
  addRegexToken('GGGGG', match1to6, match6);
  addRegexToken('ggggg', match1to6, match6);
  addWeekParseToken(['gggg', 'ggggg', 'GGGG', 'GGGGG'], function (input, week, config, token) {
    week[token.substr(0, 2)] = toInt(input);
  });
  addWeekParseToken(['gg', 'GG'], function (input, week, config, token) {
    week[token] = hooks.parseTwoDigitYear(input);
  });

  // MOMENTS

  function getSetWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.week(), this.weekday() + this.localeData()._week.dow, this.localeData()._week.dow, this.localeData()._week.doy);
  }
  function getSetISOWeekYear(input) {
    return getSetWeekYearHelper.call(this, input, this.isoWeek(), this.isoWeekday(), 1, 4);
  }
  function getISOWeeksInYear() {
    return weeksInYear(this.year(), 1, 4);
  }
  function getISOWeeksInISOWeekYear() {
    return weeksInYear(this.isoWeekYear(), 1, 4);
  }
  function getWeeksInYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.year(), weekInfo.dow, weekInfo.doy);
  }
  function getWeeksInWeekYear() {
    var weekInfo = this.localeData()._week;
    return weeksInYear(this.weekYear(), weekInfo.dow, weekInfo.doy);
  }
  function getSetWeekYearHelper(input, week, weekday, dow, doy) {
    var weeksTarget;
    if (input == null) {
      return weekOfYear(this, dow, doy).year;
    } else {
      weeksTarget = weeksInYear(input, dow, doy);
      if (week > weeksTarget) {
        week = weeksTarget;
      }
      return setWeekAll.call(this, input, week, weekday, dow, doy);
    }
  }
  function setWeekAll(weekYear, week, weekday, dow, doy) {
    var dayOfYearData = dayOfYearFromWeeks(weekYear, week, weekday, dow, doy),
      date = createUTCDate(dayOfYearData.year, 0, dayOfYearData.dayOfYear);
    this.year(date.getUTCFullYear());
    this.month(date.getUTCMonth());
    this.date(date.getUTCDate());
    return this;
  }

  // FORMATTING

  addFormatToken('Q', 0, 'Qo', 'quarter');

  // PARSING

  addRegexToken('Q', match1);
  addParseToken('Q', function (input, array) {
    array[MONTH] = (toInt(input) - 1) * 3;
  });

  // MOMENTS

  function getSetQuarter(input) {
    return input == null ? Math.ceil((this.month() + 1) / 3) : this.month((input - 1) * 3 + this.month() % 3);
  }

  // FORMATTING

  addFormatToken('D', ['DD', 2], 'Do', 'date');

  // PARSING

  addRegexToken('D', match1to2, match1to2NoLeadingZero);
  addRegexToken('DD', match1to2, match2);
  addRegexToken('Do', function (isStrict, locale) {
    // TODO: Remove "ordinalParse" fallback in next major release.
    return isStrict ? locale._dayOfMonthOrdinalParse || locale._ordinalParse : locale._dayOfMonthOrdinalParseLenient;
  });
  addParseToken(['D', 'DD'], DATE);
  addParseToken('Do', function (input, array) {
    array[DATE] = toInt(input.match(match1to2)[0]);
  });

  // MOMENTS

  var getSetDayOfMonth = makeGetSet('Date', true);

  // FORMATTING

  addFormatToken('DDD', ['DDDD', 3], 'DDDo', 'dayOfYear');

  // PARSING

  addRegexToken('DDD', match1to3);
  addRegexToken('DDDD', match3);
  addParseToken(['DDD', 'DDDD'], function (input, array, config) {
    config._dayOfYear = toInt(input);
  });

  // HELPERS

  // MOMENTS

  function getSetDayOfYear(input) {
    var dayOfYear = Math.round((this.clone().startOf('day') - this.clone().startOf('year')) / 864e5) + 1;
    return input == null ? dayOfYear : this.add(input - dayOfYear, 'd');
  }

  // FORMATTING

  addFormatToken('m', ['mm', 2], 0, 'minute');

  // PARSING

  addRegexToken('m', match1to2, match1to2HasZero);
  addRegexToken('mm', match1to2, match2);
  addParseToken(['m', 'mm'], MINUTE);

  // MOMENTS

  var getSetMinute = makeGetSet('Minutes', false);

  // FORMATTING

  addFormatToken('s', ['ss', 2], 0, 'second');

  // PARSING

  addRegexToken('s', match1to2, match1to2HasZero);
  addRegexToken('ss', match1to2, match2);
  addParseToken(['s', 'ss'], SECOND);

  // MOMENTS

  var getSetSecond = makeGetSet('Seconds', false);

  // FORMATTING

  addFormatToken('S', 0, 0, function () {
    return ~~(this.millisecond() / 100);
  });
  addFormatToken(0, ['SS', 2], 0, function () {
    return ~~(this.millisecond() / 10);
  });
  addFormatToken(0, ['SSS', 3], 0, 'millisecond');
  addFormatToken(0, ['SSSS', 4], 0, function () {
    return this.millisecond() * 10;
  });
  addFormatToken(0, ['SSSSS', 5], 0, function () {
    return this.millisecond() * 100;
  });
  addFormatToken(0, ['SSSSSS', 6], 0, function () {
    return this.millisecond() * 1000;
  });
  addFormatToken(0, ['SSSSSSS', 7], 0, function () {
    return this.millisecond() * 10000;
  });
  addFormatToken(0, ['SSSSSSSS', 8], 0, function () {
    return this.millisecond() * 100000;
  });
  addFormatToken(0, ['SSSSSSSSS', 9], 0, function () {
    return this.millisecond() * 1000000;
  });

  // PARSING

  addRegexToken('S', match1to3, match1);
  addRegexToken('SS', match1to3, match2);
  addRegexToken('SSS', match1to3, match3);
  var token, getSetMillisecond;
  for (token = 'SSSS'; token.length <= 9; token += 'S') {
    addRegexToken(token, matchUnsigned);
  }
  function parseMs(input, array) {
    array[MILLISECOND] = toInt(('0.' + input) * 1000);
  }
  for (token = 'S'; token.length <= 9; token += 'S') {
    addParseToken(token, parseMs);
  }
  getSetMillisecond = makeGetSet('Milliseconds', false);

  // FORMATTING

  addFormatToken('z', 0, 0, 'zoneAbbr');
  addFormatToken('zz', 0, 0, 'zoneName');

  // MOMENTS

  function getZoneAbbr() {
    return this._isUTC ? 'UTC' : '';
  }
  function getZoneName() {
    return this._isUTC ? 'Coordinated Universal Time' : '';
  }
  var proto = Moment.prototype;
  proto.add = add;
  proto.calendar = calendar$1;
  proto.clone = clone;
  proto.diff = diff;
  proto.endOf = endOf;
  proto.format = format;
  proto.from = from;
  proto.fromNow = fromNow;
  proto.to = to;
  proto.toNow = toNow;
  proto.get = stringGet;
  proto.invalidAt = invalidAt;
  proto.isAfter = isAfter;
  proto.isBefore = isBefore;
  proto.isBetween = isBetween;
  proto.isSame = isSame;
  proto.isSameOrAfter = isSameOrAfter;
  proto.isSameOrBefore = isSameOrBefore;
  proto.isValid = isValid$2;
  proto.lang = lang;
  proto.locale = locale;
  proto.localeData = localeData;
  proto.max = prototypeMax;
  proto.min = prototypeMin;
  proto.parsingFlags = parsingFlags;
  proto.set = stringSet;
  proto.startOf = startOf;
  proto.subtract = subtract;
  proto.toArray = toArray;
  proto.toObject = toObject;
  proto.toDate = toDate;
  proto.toISOString = toISOString;
  proto.inspect = inspect;
  if (typeof Symbol !== 'undefined' && Symbol["for"] != null) {
    proto[Symbol["for"]('nodejs.util.inspect.custom')] = function () {
      return 'Moment<' + this.format() + '>';
    };
  }
  proto.toJSON = toJSON;
  proto.toString = toString;
  proto.unix = unix;
  proto.valueOf = valueOf;
  proto.creationData = creationData;
  proto.eraName = getEraName;
  proto.eraNarrow = getEraNarrow;
  proto.eraAbbr = getEraAbbr;
  proto.eraYear = getEraYear;
  proto.year = getSetYear;
  proto.isLeapYear = getIsLeapYear;
  proto.weekYear = getSetWeekYear;
  proto.isoWeekYear = getSetISOWeekYear;
  proto.quarter = proto.quarters = getSetQuarter;
  proto.month = getSetMonth;
  proto.daysInMonth = getDaysInMonth;
  proto.week = proto.weeks = getSetWeek;
  proto.isoWeek = proto.isoWeeks = getSetISOWeek;
  proto.weeksInYear = getWeeksInYear;
  proto.weeksInWeekYear = getWeeksInWeekYear;
  proto.isoWeeksInYear = getISOWeeksInYear;
  proto.isoWeeksInISOWeekYear = getISOWeeksInISOWeekYear;
  proto.date = getSetDayOfMonth;
  proto.day = proto.days = getSetDayOfWeek;
  proto.weekday = getSetLocaleDayOfWeek;
  proto.isoWeekday = getSetISODayOfWeek;
  proto.dayOfYear = getSetDayOfYear;
  proto.hour = proto.hours = getSetHour;
  proto.minute = proto.minutes = getSetMinute;
  proto.second = proto.seconds = getSetSecond;
  proto.millisecond = proto.milliseconds = getSetMillisecond;
  proto.utcOffset = getSetOffset;
  proto.utc = setOffsetToUTC;
  proto.local = setOffsetToLocal;
  proto.parseZone = setOffsetToParsedOffset;
  proto.hasAlignedHourOffset = hasAlignedHourOffset;
  proto.isDST = isDaylightSavingTime;
  proto.isLocal = isLocal;
  proto.isUtcOffset = isUtcOffset;
  proto.isUtc = isUtc;
  proto.isUTC = isUtc;
  proto.zoneAbbr = getZoneAbbr;
  proto.zoneName = getZoneName;
  proto.dates = deprecate('dates accessor is deprecated. Use date instead.', getSetDayOfMonth);
  proto.months = deprecate('months accessor is deprecated. Use month instead', getSetMonth);
  proto.years = deprecate('years accessor is deprecated. Use year instead', getSetYear);
  proto.zone = deprecate('moment().zone is deprecated, use moment().utcOffset instead. http://momentjs.com/guides/#/warnings/zone/', getSetZone);
  proto.isDSTShifted = deprecate('isDSTShifted is deprecated. See http://momentjs.com/guides/#/warnings/dst-shifted/ for more information', isDaylightSavingTimeShifted);
  function createUnix(input) {
    return createLocal(input * 1000);
  }
  function createInZone() {
    return createLocal.apply(null, arguments).parseZone();
  }
  function preParsePostFormat(string) {
    return string;
  }
  var proto$1 = Locale.prototype;
  proto$1.calendar = calendar;
  proto$1.longDateFormat = longDateFormat;
  proto$1.invalidDate = invalidDate;
  proto$1.ordinal = ordinal;
  proto$1.preparse = preParsePostFormat;
  proto$1.postformat = preParsePostFormat;
  proto$1.relativeTime = relativeTime;
  proto$1.pastFuture = pastFuture;
  proto$1.set = set;
  proto$1.eras = localeEras;
  proto$1.erasParse = localeErasParse;
  proto$1.erasConvertYear = localeErasConvertYear;
  proto$1.erasAbbrRegex = erasAbbrRegex;
  proto$1.erasNameRegex = erasNameRegex;
  proto$1.erasNarrowRegex = erasNarrowRegex;
  proto$1.months = localeMonths;
  proto$1.monthsShort = localeMonthsShort;
  proto$1.monthsParse = localeMonthsParse;
  proto$1.monthsRegex = monthsRegex;
  proto$1.monthsShortRegex = monthsShortRegex;
  proto$1.week = localeWeek;
  proto$1.firstDayOfYear = localeFirstDayOfYear;
  proto$1.firstDayOfWeek = localeFirstDayOfWeek;
  proto$1.weekdays = localeWeekdays;
  proto$1.weekdaysMin = localeWeekdaysMin;
  proto$1.weekdaysShort = localeWeekdaysShort;
  proto$1.weekdaysParse = localeWeekdaysParse;
  proto$1.weekdaysRegex = weekdaysRegex;
  proto$1.weekdaysShortRegex = weekdaysShortRegex;
  proto$1.weekdaysMinRegex = weekdaysMinRegex;
  proto$1.isPM = localeIsPM;
  proto$1.meridiem = localeMeridiem;
  function get$1(format, index, field, setter) {
    var locale = getLocale(),
      utc = createUTC().set(setter, index);
    return locale[field](utc, format);
  }
  function listMonthsImpl(format, index, field) {
    if (isNumber(format)) {
      index = format;
      format = undefined;
    }
    format = format || '';
    if (index != null) {
      return get$1(format, index, field, 'month');
    }
    var i,
      out = [];
    for (i = 0; i < 12; i++) {
      out[i] = get$1(format, i, field, 'month');
    }
    return out;
  }

  // ()
  // (5)
  // (fmt, 5)
  // (fmt)
  // (true)
  // (true, 5)
  // (true, fmt, 5)
  // (true, fmt)
  function listWeekdaysImpl(localeSorted, format, index, field) {
    if (typeof localeSorted === 'boolean') {
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }
      format = format || '';
    } else {
      format = localeSorted;
      index = format;
      localeSorted = false;
      if (isNumber(format)) {
        index = format;
        format = undefined;
      }
      format = format || '';
    }
    var locale = getLocale(),
      shift = localeSorted ? locale._week.dow : 0,
      i,
      out = [];
    if (index != null) {
      return get$1(format, (index + shift) % 7, field, 'day');
    }
    for (i = 0; i < 7; i++) {
      out[i] = get$1(format, (i + shift) % 7, field, 'day');
    }
    return out;
  }
  function listMonths(format, index) {
    return listMonthsImpl(format, index, 'months');
  }
  function listMonthsShort(format, index) {
    return listMonthsImpl(format, index, 'monthsShort');
  }
  function listWeekdays(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdays');
  }
  function listWeekdaysShort(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysShort');
  }
  function listWeekdaysMin(localeSorted, format, index) {
    return listWeekdaysImpl(localeSorted, format, index, 'weekdaysMin');
  }
  getSetGlobalLocale('en', {
    eras: [{
      since: '0001-01-01',
      until: +Infinity,
      offset: 1,
      name: 'Anno Domini',
      narrow: 'AD',
      abbr: 'AD'
    }, {
      since: '0000-12-31',
      until: -Infinity,
      offset: 1,
      name: 'Before Christ',
      narrow: 'BC',
      abbr: 'BC'
    }],
    dayOfMonthOrdinalParse: /\d{1,2}(th|st|nd|rd)/,
    ordinal: function ordinal(number) {
      var b = number % 10,
        output = toInt(number % 100 / 10) === 1 ? 'th' : b === 1 ? 'st' : b === 2 ? 'nd' : b === 3 ? 'rd' : 'th';
      return number + output;
    }
  });

  // Side effect imports

  hooks.lang = deprecate('moment.lang is deprecated. Use moment.locale instead.', getSetGlobalLocale);
  hooks.langData = deprecate('moment.langData is deprecated. Use moment.localeData instead.', getLocale);
  var mathAbs = Math.abs;
  function abs() {
    var data = this._data;
    this._milliseconds = mathAbs(this._milliseconds);
    this._days = mathAbs(this._days);
    this._months = mathAbs(this._months);
    data.milliseconds = mathAbs(data.milliseconds);
    data.seconds = mathAbs(data.seconds);
    data.minutes = mathAbs(data.minutes);
    data.hours = mathAbs(data.hours);
    data.months = mathAbs(data.months);
    data.years = mathAbs(data.years);
    return this;
  }
  function addSubtract$1(duration, input, value, direction) {
    var other = createDuration(input, value);
    duration._milliseconds += direction * other._milliseconds;
    duration._days += direction * other._days;
    duration._months += direction * other._months;
    return duration._bubble();
  }

  // supports only 2.0-style add(1, 's') or add(duration)
  function add$1(input, value) {
    return addSubtract$1(this, input, value, 1);
  }

  // supports only 2.0-style subtract(1, 's') or subtract(duration)
  function subtract$1(input, value) {
    return addSubtract$1(this, input, value, -1);
  }
  function absCeil(number) {
    if (number < 0) {
      return Math.floor(number);
    } else {
      return Math.ceil(number);
    }
  }
  function bubble() {
    var milliseconds = this._milliseconds,
      days = this._days,
      months = this._months,
      data = this._data,
      seconds,
      minutes,
      hours,
      years,
      monthsFromDays;

    // if we have a mix of positive and negative values, bubble down first
    // check: https://github.com/moment/moment/issues/2166
    if (!(milliseconds >= 0 && days >= 0 && months >= 0 || milliseconds <= 0 && days <= 0 && months <= 0)) {
      milliseconds += absCeil(monthsToDays(months) + days) * 864e5;
      days = 0;
      months = 0;
    }

    // The following code bubbles up values, see the tests for
    // examples of what that means.
    data.milliseconds = milliseconds % 1000;
    seconds = absFloor(milliseconds / 1000);
    data.seconds = seconds % 60;
    minutes = absFloor(seconds / 60);
    data.minutes = minutes % 60;
    hours = absFloor(minutes / 60);
    data.hours = hours % 24;
    days += absFloor(hours / 24);

    // convert days to months
    monthsFromDays = absFloor(daysToMonths(days));
    months += monthsFromDays;
    days -= absCeil(monthsToDays(monthsFromDays));

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;
    data.days = days;
    data.months = months;
    data.years = years;
    return this;
  }
  function daysToMonths(days) {
    // 400 years have 146097 days (taking into account leap year rules)
    // 400 years have 12 months === 4800
    return days * 4800 / 146097;
  }
  function monthsToDays(months) {
    // the reverse of daysToMonths
    return months * 146097 / 4800;
  }
  function as(units) {
    if (!this.isValid()) {
      return NaN;
    }
    var days,
      months,
      milliseconds = this._milliseconds;
    units = normalizeUnits(units);
    if (units === 'month' || units === 'quarter' || units === 'year') {
      days = this._days + milliseconds / 864e5;
      months = this._months + daysToMonths(days);
      switch (units) {
        case 'month':
          return months;
        case 'quarter':
          return months / 3;
        case 'year':
          return months / 12;
      }
    } else {
      // handle milliseconds separately because of floating point math errors (issue #1867)
      days = this._days + Math.round(monthsToDays(this._months));
      switch (units) {
        case 'week':
          return days / 7 + milliseconds / 6048e5;
        case 'day':
          return days + milliseconds / 864e5;
        case 'hour':
          return days * 24 + milliseconds / 36e5;
        case 'minute':
          return days * 1440 + milliseconds / 6e4;
        case 'second':
          return days * 86400 + milliseconds / 1000;
        // Math.floor prevents floating point math errors here
        case 'millisecond':
          return Math.floor(days * 864e5) + milliseconds;
        default:
          throw new Error('Unknown unit ' + units);
      }
    }
  }
  function makeAs(alias) {
    return function () {
      return this.as(alias);
    };
  }
  var asMilliseconds = makeAs('ms'),
    asSeconds = makeAs('s'),
    asMinutes = makeAs('m'),
    asHours = makeAs('h'),
    asDays = makeAs('d'),
    asWeeks = makeAs('w'),
    asMonths = makeAs('M'),
    asQuarters = makeAs('Q'),
    asYears = makeAs('y'),
    valueOf$1 = asMilliseconds;
  function clone$1() {
    return createDuration(this);
  }
  function get$2(units) {
    units = normalizeUnits(units);
    return this.isValid() ? this[units + 's']() : NaN;
  }
  function makeGetter(name) {
    return function () {
      return this.isValid() ? this._data[name] : NaN;
    };
  }
  var milliseconds = makeGetter('milliseconds'),
    seconds = makeGetter('seconds'),
    minutes = makeGetter('minutes'),
    hours = makeGetter('hours'),
    days = makeGetter('days'),
    months = makeGetter('months'),
    years = makeGetter('years');
  function weeks() {
    return absFloor(this.days() / 7);
  }
  var round = Math.round,
    thresholds = {
      ss: 44,
      // a few seconds to seconds
      s: 45,
      // seconds to minute
      m: 45,
      // minutes to hour
      h: 22,
      // hours to day
      d: 26,
      // days to month/week
      w: null,
      // weeks to month
      M: 11 // months to year
    };

  // helper function for moment.fn.from, moment.fn.fromNow, and moment.duration.fn.humanize
  function substituteTimeAgo(string, number, withoutSuffix, isFuture, locale) {
    return locale.relativeTime(number || 1, !!withoutSuffix, string, isFuture);
  }
  function relativeTime$1(posNegDuration, withoutSuffix, thresholds, locale) {
    var duration = createDuration(posNegDuration).abs(),
      seconds = round(duration.as('s')),
      minutes = round(duration.as('m')),
      hours = round(duration.as('h')),
      days = round(duration.as('d')),
      months = round(duration.as('M')),
      weeks = round(duration.as('w')),
      years = round(duration.as('y')),
      a = seconds <= thresholds.ss && ['s', seconds] || seconds < thresholds.s && ['ss', seconds] || minutes <= 1 && ['m'] || minutes < thresholds.m && ['mm', minutes] || hours <= 1 && ['h'] || hours < thresholds.h && ['hh', hours] || days <= 1 && ['d'] || days < thresholds.d && ['dd', days];
    if (thresholds.w != null) {
      a = a || weeks <= 1 && ['w'] || weeks < thresholds.w && ['ww', weeks];
    }
    a = a || months <= 1 && ['M'] || months < thresholds.M && ['MM', months] || years <= 1 && ['y'] || ['yy', years];
    a[2] = withoutSuffix;
    a[3] = +posNegDuration > 0;
    a[4] = locale;
    return substituteTimeAgo.apply(null, a);
  }

  // This function allows you to set the rounding function for relative time strings
  function getSetRelativeTimeRounding(roundingFunction) {
    if (roundingFunction === undefined) {
      return round;
    }
    if (typeof roundingFunction === 'function') {
      round = roundingFunction;
      return true;
    }
    return false;
  }

  // This function allows you to set a threshold for relative time strings
  function getSetRelativeTimeThreshold(threshold, limit) {
    if (thresholds[threshold] === undefined) {
      return false;
    }
    if (limit === undefined) {
      return thresholds[threshold];
    }
    thresholds[threshold] = limit;
    if (threshold === 's') {
      thresholds.ss = limit - 1;
    }
    return true;
  }
  function humanize(argWithSuffix, argThresholds) {
    if (!this.isValid()) {
      return this.localeData().invalidDate();
    }
    var withSuffix = false,
      th = thresholds,
      locale,
      output;
    if (_typeof(argWithSuffix) === 'object') {
      argThresholds = argWithSuffix;
      argWithSuffix = false;
    }
    if (typeof argWithSuffix === 'boolean') {
      withSuffix = argWithSuffix;
    }
    if (_typeof(argThresholds) === 'object') {
      th = Object.assign({}, thresholds, argThresholds);
      if (argThresholds.s != null && argThresholds.ss == null) {
        th.ss = argThresholds.s - 1;
      }
    }
    locale = this.localeData();
    output = relativeTime$1(this, !withSuffix, th, locale);
    if (withSuffix) {
      output = locale.pastFuture(+this, output);
    }
    return locale.postformat(output);
  }
  var abs$1 = Math.abs;
  function sign(x) {
    return (x > 0) - (x < 0) || +x;
  }
  function toISOString$1() {
    // for ISO strings we do not use the normal bubbling rules:
    //  * milliseconds bubble up until they become hours
    //  * days do not bubble at all
    //  * months bubble up until they become years
    // This is because there is no context-free conversion between hours and days
    // (think of clock changes)
    // and also not between days and months (28-31 days per month)
    if (!this.isValid()) {
      return this.localeData().invalidDate();
    }
    var seconds = abs$1(this._milliseconds) / 1000,
      days = abs$1(this._days),
      months = abs$1(this._months),
      minutes,
      hours,
      years,
      s,
      total = this.asSeconds(),
      totalSign,
      ymSign,
      daysSign,
      hmsSign;
    if (!total) {
      // this is the same as C#'s (Noda) and python (isodate)...
      // but not other JS (goog.date)
      return 'P0D';
    }

    // 3600 seconds -> 60 minutes -> 1 hour
    minutes = absFloor(seconds / 60);
    hours = absFloor(minutes / 60);
    seconds %= 60;
    minutes %= 60;

    // 12 months -> 1 year
    years = absFloor(months / 12);
    months %= 12;

    // inspired by https://github.com/dordille/moment-isoduration/blob/master/moment.isoduration.js
    s = seconds ? seconds.toFixed(3).replace(/\.?0+$/, '') : '';
    totalSign = total < 0 ? '-' : '';
    ymSign = sign(this._months) !== sign(total) ? '-' : '';
    daysSign = sign(this._days) !== sign(total) ? '-' : '';
    hmsSign = sign(this._milliseconds) !== sign(total) ? '-' : '';
    return totalSign + 'P' + (years ? ymSign + years + 'Y' : '') + (months ? ymSign + months + 'M' : '') + (days ? daysSign + days + 'D' : '') + (hours || minutes || seconds ? 'T' : '') + (hours ? hmsSign + hours + 'H' : '') + (minutes ? hmsSign + minutes + 'M' : '') + (seconds ? hmsSign + s + 'S' : '');
  }
  var proto$2 = Duration.prototype;
  proto$2.isValid = isValid$1;
  proto$2.abs = abs;
  proto$2.add = add$1;
  proto$2.subtract = subtract$1;
  proto$2.as = as;
  proto$2.asMilliseconds = asMilliseconds;
  proto$2.asSeconds = asSeconds;
  proto$2.asMinutes = asMinutes;
  proto$2.asHours = asHours;
  proto$2.asDays = asDays;
  proto$2.asWeeks = asWeeks;
  proto$2.asMonths = asMonths;
  proto$2.asQuarters = asQuarters;
  proto$2.asYears = asYears;
  proto$2.valueOf = valueOf$1;
  proto$2._bubble = bubble;
  proto$2.clone = clone$1;
  proto$2.get = get$2;
  proto$2.milliseconds = milliseconds;
  proto$2.seconds = seconds;
  proto$2.minutes = minutes;
  proto$2.hours = hours;
  proto$2.days = days;
  proto$2.weeks = weeks;
  proto$2.months = months;
  proto$2.years = years;
  proto$2.humanize = humanize;
  proto$2.toISOString = toISOString$1;
  proto$2.toString = toISOString$1;
  proto$2.toJSON = toISOString$1;
  proto$2.locale = locale;
  proto$2.localeData = localeData;
  proto$2.toIsoString = deprecate('toIsoString() is deprecated. Please use toISOString() instead (notice the capitals)', toISOString$1);
  proto$2.lang = lang;

  // FORMATTING

  addFormatToken('X', 0, 0, 'unix');
  addFormatToken('x', 0, 0, 'valueOf');

  // PARSING

  addRegexToken('x', matchSigned);
  addRegexToken('X', matchTimestamp);
  addParseToken('X', function (input, array, config) {
    config._d = new Date(parseFloat(input) * 1000);
  });
  addParseToken('x', function (input, array, config) {
    config._d = new Date(toInt(input));
  });

  //! moment.js

  hooks.version = '2.30.1';
  setHookCallback(createLocal);
  hooks.fn = proto;
  hooks.min = min;
  hooks.max = max;
  hooks.now = now;
  hooks.utc = createUTC;
  hooks.unix = createUnix;
  hooks.months = listMonths;
  hooks.isDate = isDate;
  hooks.locale = getSetGlobalLocale;
  hooks.invalid = createInvalid;
  hooks.duration = createDuration;
  hooks.isMoment = isMoment;
  hooks.weekdays = listWeekdays;
  hooks.parseZone = createInZone;
  hooks.localeData = getLocale;
  hooks.isDuration = isDuration;
  hooks.monthsShort = listMonthsShort;
  hooks.weekdaysMin = listWeekdaysMin;
  hooks.defineLocale = defineLocale;
  hooks.updateLocale = updateLocale;
  hooks.locales = listLocales;
  hooks.weekdaysShort = listWeekdaysShort;
  hooks.normalizeUnits = normalizeUnits;
  hooks.relativeTimeRounding = getSetRelativeTimeRounding;
  hooks.relativeTimeThreshold = getSetRelativeTimeThreshold;
  hooks.calendarFormat = getCalendarFormat;
  hooks.prototype = proto;

  // currently HTML5 input type only supports 24-hour formats
  hooks.HTML5_FMT = {
    DATETIME_LOCAL: 'YYYY-MM-DDTHH:mm',
    // <input type="datetime-local" />
    DATETIME_LOCAL_SECONDS: 'YYYY-MM-DDTHH:mm:ss',
    // <input type="datetime-local" step="1" />
    DATETIME_LOCAL_MS: 'YYYY-MM-DDTHH:mm:ss.SSS',
    // <input type="datetime-local" step="0.001" />
    DATE: 'YYYY-MM-DD',
    // <input type="date" />
    TIME: 'HH:mm',
    // <input type="time" />
    TIME_SECONDS: 'HH:mm:ss',
    // <input type="time" step="1" />
    TIME_MS: 'HH:mm:ss.SSS',
    // <input type="time" step="0.001" />
    WEEK: 'GGGG-[W]WW',
    // <input type="week" />
    MONTH: 'YYYY-MM' // <input type="month" />
  };
  return hooks;
});
(function () {
  var AjaxMonitor,
    Bar,
    DocumentMonitor,
    ElementMonitor,
    ElementTracker,
    EventLagMonitor,
    Evented,
    Events,
    NoTargetError,
    Pace,
    RequestIntercept,
    SOURCE_KEYS,
    Scaler,
    SocketRequestTracker,
    XHRRequestTracker,
    animation,
    avgAmplitude,
    bar,
    cancelAnimation,
    cancelAnimationFrame,
    defaultOptions,
    _extend2,
    extendNative,
    getFromDOM,
    getIntercept,
    handlePushState,
    ignoreStack,
    init,
    now,
    options,
    requestAnimationFrame,
    result,
    runAnimation,
    scalers,
    shouldIgnoreURL,
    shouldTrack,
    source,
    sources,
    uniScaler,
    _WebSocket,
    _XDomainRequest,
    _XMLHttpRequest,
    _i,
    _intercept,
    _len,
    _pushState,
    _ref,
    _ref1,
    _replaceState,
    __slice = [].slice,
    __hasProp = {}.hasOwnProperty,
    __extends = function __extends(child, parent) {
      for (var key in parent) {
        if (__hasProp.call(parent, key)) child[key] = parent[key];
      }
      function ctor() {
        this.constructor = child;
      }
      ctor.prototype = parent.prototype;
      child.prototype = new ctor();
      child.__super__ = parent.prototype;
      return child;
    },
    __indexOf = [].indexOf || function (item) {
      for (var i = 0, l = this.length; i < l; i++) {
        if (i in this && this[i] === item) return i;
      }
      return -1;
    };
  defaultOptions = {
    catchupTime: 100,
    initialRate: .03,
    minTime: 250,
    ghostTime: 100,
    maxProgressPerFrame: 20,
    easeFactor: 1.25,
    startOnPageLoad: true,
    restartOnPushState: true,
    restartOnRequestAfter: 500,
    target: 'body',
    elements: {
      checkInterval: 100,
      selectors: ['body']
    },
    eventLag: {
      minSamples: 10,
      sampleCount: 3,
      lagThreshold: 3
    },
    ajax: {
      trackMethods: ['GET'],
      trackWebSockets: true,
      ignoreURLs: []
    }
  };
  now = function now() {
    var _ref;
    return (_ref = typeof performance !== "undefined" && performance !== null ? typeof performance.now === "function" ? performance.now() : void 0 : void 0) != null ? _ref : +new Date();
  };
  requestAnimationFrame = window.requestAnimationFrame || window.mozRequestAnimationFrame || window.webkitRequestAnimationFrame || window.msRequestAnimationFrame;
  cancelAnimationFrame = window.cancelAnimationFrame || window.mozCancelAnimationFrame;
  if (requestAnimationFrame == null) {
    requestAnimationFrame = function requestAnimationFrame(fn) {
      return setTimeout(fn, 50);
    };
    cancelAnimationFrame = function cancelAnimationFrame(id) {
      return clearTimeout(id);
    };
  }
  runAnimation = function runAnimation(fn) {
    var last, _tick;
    last = now();
    _tick = function tick() {
      var diff;
      diff = now() - last;
      if (diff >= 33) {
        last = now();
        return fn(diff, function () {
          return requestAnimationFrame(_tick);
        });
      } else {
        return setTimeout(_tick, 33 - diff);
      }
    };
    return _tick();
  };
  result = function result() {
    var args, key, obj;
    obj = arguments[0], key = arguments[1], args = 3 <= arguments.length ? __slice.call(arguments, 2) : [];
    if (typeof obj[key] === 'function') {
      return obj[key].apply(obj, args);
    } else {
      return obj[key];
    }
  };
  _extend2 = function extend() {
    var key, out, source, sources, val, _i, _len;
    out = arguments[0], sources = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
    for (_i = 0, _len = sources.length; _i < _len; _i++) {
      source = sources[_i];
      if (source) {
        for (key in source) {
          if (!__hasProp.call(source, key)) continue;
          val = source[key];
          if (out[key] != null && _typeof(out[key]) === 'object' && val != null && _typeof(val) === 'object') {
            _extend2(out[key], val);
          } else {
            out[key] = val;
          }
        }
      }
    }
    return out;
  };
  avgAmplitude = function avgAmplitude(arr) {
    var count, sum, v, _i, _len;
    sum = count = 0;
    for (_i = 0, _len = arr.length; _i < _len; _i++) {
      v = arr[_i];
      sum += Math.abs(v);
      count++;
    }
    return sum / count;
  };
  getFromDOM = function getFromDOM(key, json) {
    var data, e, el;
    if (key == null) {
      key = 'options';
    }
    if (json == null) {
      json = true;
    }
    el = document.querySelector("[data-pace-" + key + "]");
    if (!el) {
      return;
    }
    data = el.getAttribute("data-pace-" + key);
    if (!json) {
      return data;
    }
    try {
      return JSON.parse(data);
    } catch (_error) {
      e = _error;
      return typeof console !== "undefined" && console !== null ? console.error("Error parsing inline pace options", e) : void 0;
    }
  };
  Evented = function () {
    function Evented() {}
    Evented.prototype.on = function (event, handler, ctx, once) {
      var _base;
      if (once == null) {
        once = false;
      }
      if (this.bindings == null) {
        this.bindings = {};
      }
      if ((_base = this.bindings)[event] == null) {
        _base[event] = [];
      }
      return this.bindings[event].push({
        handler: handler,
        ctx: ctx,
        once: once
      });
    };
    Evented.prototype.once = function (event, handler, ctx) {
      return this.on(event, handler, ctx, true);
    };
    Evented.prototype.off = function (event, handler) {
      var i, _ref, _results;
      if (((_ref = this.bindings) != null ? _ref[event] : void 0) == null) {
        return;
      }
      if (handler == null) {
        return delete this.bindings[event];
      } else {
        i = 0;
        _results = [];
        while (i < this.bindings[event].length) {
          if (this.bindings[event][i].handler === handler) {
            _results.push(this.bindings[event].splice(i, 1));
          } else {
            _results.push(i++);
          }
        }
        return _results;
      }
    };
    Evented.prototype.trigger = function () {
      var args, ctx, event, handler, i, once, _ref, _ref1, _results;
      event = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
      if ((_ref = this.bindings) != null ? _ref[event] : void 0) {
        i = 0;
        _results = [];
        while (i < this.bindings[event].length) {
          _ref1 = this.bindings[event][i], handler = _ref1.handler, ctx = _ref1.ctx, once = _ref1.once;
          handler.apply(ctx != null ? ctx : this, args);
          if (once) {
            _results.push(this.bindings[event].splice(i, 1));
          } else {
            _results.push(i++);
          }
        }
        return _results;
      }
    };
    return Evented;
  }();
  Pace = window.Pace || {};
  window.Pace = Pace;
  _extend2(Pace, Evented.prototype);
  options = Pace.options = _extend2({}, defaultOptions, window.paceOptions, getFromDOM());
  _ref = ['ajax', 'document', 'eventLag', 'elements'];
  for (_i = 0, _len = _ref.length; _i < _len; _i++) {
    source = _ref[_i];
    if (options[source] === true) {
      options[source] = defaultOptions[source];
    }
  }
  NoTargetError = function (_super) {
    __extends(NoTargetError, _super);
    function NoTargetError() {
      _ref1 = NoTargetError.__super__.constructor.apply(this, arguments);
      return _ref1;
    }
    return NoTargetError;
  }(Error);
  Bar = function () {
    function Bar() {
      this.progress = 0;
    }
    Bar.prototype.getElement = function () {
      var targetElement;
      if (this.el == null) {
        targetElement = document.querySelector(options.target);
        if (!targetElement) {
          throw new NoTargetError();
        }
        this.el = document.createElement('div');
        this.el.className = "pace pace-active";
        document.body.className = document.body.className.replace(/pace-done/g, '');
        document.body.className += ' pace-running';
        this.el.innerHTML = '<div class="pace-progress">\n  <div class="pace-progress-inner"></div>\n</div>\n<div class="pace-activity"></div>';
        if (targetElement.firstChild != null) {
          targetElement.insertBefore(this.el, targetElement.firstChild);
        } else {
          targetElement.appendChild(this.el);
        }
      }
      return this.el;
    };
    Bar.prototype.finish = function () {
      var el;
      el = this.getElement();
      el.className = el.className.replace('pace-active', '');
      el.className += ' pace-inactive';
      document.body.className = document.body.className.replace('pace-running', '');
      return document.body.className += ' pace-done';
    };
    Bar.prototype.update = function (prog) {
      this.progress = prog;
      return this.render();
    };
    Bar.prototype.destroy = function () {
      try {
        this.getElement().parentNode.removeChild(this.getElement());
      } catch (_error) {
        NoTargetError = _error;
      }
      return this.el = void 0;
    };
    Bar.prototype.render = function () {
      var el, key, progressStr, transform, _j, _len1, _ref2;
      if (document.querySelector(options.target) == null) {
        return false;
      }
      el = this.getElement();
      transform = "translate3d(" + this.progress + "%, 0, 0)";
      _ref2 = ['webkitTransform', 'msTransform', 'transform'];
      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
        key = _ref2[_j];
        el.children[0].style[key] = transform;
      }
      if (!this.lastRenderedProgress || this.lastRenderedProgress | 0 !== this.progress | 0) {
        el.children[0].setAttribute('data-progress-text', "" + (this.progress | 0) + "%");
        if (this.progress >= 100) {
          progressStr = '99';
        } else {
          progressStr = this.progress < 10 ? "0" : "";
          progressStr += this.progress | 0;
        }
        el.children[0].setAttribute('data-progress', "" + progressStr);
      }
      return this.lastRenderedProgress = this.progress;
    };
    Bar.prototype.done = function () {
      return this.progress >= 100;
    };
    return Bar;
  }();
  Events = function () {
    function Events() {
      this.bindings = {};
    }
    Events.prototype.trigger = function (name, val) {
      var binding, _j, _len1, _ref2, _results;
      if (this.bindings[name] != null) {
        _ref2 = this.bindings[name];
        _results = [];
        for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
          binding = _ref2[_j];
          _results.push(binding.call(this, val));
        }
        return _results;
      }
    };
    Events.prototype.on = function (name, fn) {
      var _base;
      if ((_base = this.bindings)[name] == null) {
        _base[name] = [];
      }
      return this.bindings[name].push(fn);
    };
    return Events;
  }();
  _XMLHttpRequest = window.XMLHttpRequest;
  _XDomainRequest = window.XDomainRequest;
  _WebSocket = window.WebSocket;
  extendNative = function extendNative(to, from) {
    var e, key, _results;
    _results = [];
    for (key in from.prototype) {
      try {
        if (to[key] == null && typeof from[key] !== 'function') {
          if (typeof Object.defineProperty === 'function') {
            _results.push(Object.defineProperty(to, key, {
              get: function get() {
                return from.prototype[key];
              },
              configurable: true,
              enumerable: true
            }));
          } else {
            _results.push(to[key] = from.prototype[key]);
          }
        } else {
          _results.push(void 0);
        }
      } catch (_error) {
        e = _error;
      }
    }
    return _results;
  };
  ignoreStack = [];
  Pace.ignore = function () {
    var args, fn, ret;
    fn = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
    ignoreStack.unshift('ignore');
    ret = fn.apply(null, args);
    ignoreStack.shift();
    return ret;
  };
  Pace.track = function () {
    var args, fn, ret;
    fn = arguments[0], args = 2 <= arguments.length ? __slice.call(arguments, 1) : [];
    ignoreStack.unshift('track');
    ret = fn.apply(null, args);
    ignoreStack.shift();
    return ret;
  };
  shouldTrack = function shouldTrack(method) {
    var _ref2;
    if (method == null) {
      method = 'GET';
    }
    if (ignoreStack[0] === 'track') {
      return 'force';
    }
    if (!ignoreStack.length && options.ajax) {
      if (method === 'socket' && options.ajax.trackWebSockets) {
        return true;
      } else if (_ref2 = method.toUpperCase(), __indexOf.call(options.ajax.trackMethods, _ref2) >= 0) {
        return true;
      }
    }
    return false;
  };
  RequestIntercept = function (_super) {
    __extends(RequestIntercept, _super);
    function RequestIntercept() {
      var monitorXHR,
        _this = this;
      RequestIntercept.__super__.constructor.apply(this, arguments);
      monitorXHR = function monitorXHR(req) {
        var _open;
        _open = req.open;
        return req.open = function (type, url, async) {
          if (shouldTrack(type)) {
            _this.trigger('request', {
              type: type,
              url: url,
              request: req
            });
          }
          return _open.apply(req, arguments);
        };
      };
      window.XMLHttpRequest = function (flags) {
        var req;
        req = new _XMLHttpRequest(flags);
        monitorXHR(req);
        return req;
      };
      try {
        extendNative(window.XMLHttpRequest, _XMLHttpRequest);
      } catch (_error) {}
      if (_XDomainRequest != null) {
        window.XDomainRequest = function () {
          var req;
          req = new _XDomainRequest();
          monitorXHR(req);
          return req;
        };
        try {
          extendNative(window.XDomainRequest, _XDomainRequest);
        } catch (_error) {}
      }
      if (_WebSocket != null && options.ajax.trackWebSockets) {
        window.WebSocket = function (url, protocols) {
          var req;
          if (protocols != null) {
            req = new _WebSocket(url, protocols);
          } else {
            req = new _WebSocket(url);
          }
          if (shouldTrack('socket')) {
            _this.trigger('request', {
              type: 'socket',
              url: url,
              protocols: protocols,
              request: req
            });
          }
          return req;
        };
        try {
          extendNative(window.WebSocket, _WebSocket);
        } catch (_error) {}
      }
    }
    return RequestIntercept;
  }(Events);
  _intercept = null;
  getIntercept = function getIntercept() {
    if (_intercept == null) {
      _intercept = new RequestIntercept();
    }
    return _intercept;
  };
  shouldIgnoreURL = function shouldIgnoreURL(url) {
    var pattern, _j, _len1, _ref2;
    _ref2 = options.ajax.ignoreURLs;
    for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
      pattern = _ref2[_j];
      if (typeof pattern === 'string') {
        if (url.indexOf(pattern) !== -1) {
          return true;
        }
      } else {
        if (pattern.test(url)) {
          return true;
        }
      }
    }
    return false;
  };
  getIntercept().on('request', function (_arg) {
    var after, args, request, type, url;
    type = _arg.type, request = _arg.request, url = _arg.url;
    if (shouldIgnoreURL(url)) {
      return;
    }
    if (!Pace.running && (options.restartOnRequestAfter !== false || shouldTrack(type) === 'force')) {
      args = arguments;
      after = options.restartOnRequestAfter || 0;
      if (typeof after === 'boolean') {
        after = 0;
      }
      return setTimeout(function () {
        var stillActive, _j, _len1, _ref2, _ref3, _results;
        if (type === 'socket') {
          stillActive = request.readyState < 2;
        } else {
          stillActive = 0 < (_ref2 = request.readyState) && _ref2 < 4;
        }
        if (stillActive) {
          Pace.restart();
          _ref3 = Pace.sources;
          _results = [];
          for (_j = 0, _len1 = _ref3.length; _j < _len1; _j++) {
            source = _ref3[_j];
            if (source instanceof AjaxMonitor) {
              source.watch.apply(source, args);
              break;
            } else {
              _results.push(void 0);
            }
          }
          return _results;
        }
      }, after);
    }
  });
  AjaxMonitor = function () {
    function AjaxMonitor() {
      var _this = this;
      this.elements = [];
      getIntercept().on('request', function () {
        return _this.watch.apply(_this, arguments);
      });
    }
    AjaxMonitor.prototype.watch = function (_arg) {
      var request, tracker, type, url;
      type = _arg.type, request = _arg.request, url = _arg.url;
      if (shouldIgnoreURL(url)) {
        return;
      }
      if (type === 'socket') {
        tracker = new SocketRequestTracker(request);
      } else {
        tracker = new XHRRequestTracker(request);
      }
      return this.elements.push(tracker);
    };
    return AjaxMonitor;
  }();
  XHRRequestTracker = function () {
    function XHRRequestTracker(request) {
      var event,
        size,
        _j,
        _len1,
        _onreadystatechange,
        _ref2,
        _this = this;
      this.progress = 0;
      if (window.ProgressEvent != null) {
        size = null;
        request.addEventListener('progress', function (evt) {
          if (evt.lengthComputable) {
            return _this.progress = 100 * evt.loaded / evt.total;
          } else {
            return _this.progress = _this.progress + (100 - _this.progress) / 2;
          }
        }, false);
        _ref2 = ['load', 'abort', 'timeout', 'error'];
        for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
          event = _ref2[_j];
          request.addEventListener(event, function () {
            return _this.progress = 100;
          }, false);
        }
      } else {
        _onreadystatechange = request.onreadystatechange;
        request.onreadystatechange = function () {
          var _ref3;
          if ((_ref3 = request.readyState) === 0 || _ref3 === 4) {
            _this.progress = 100;
          } else if (request.readyState === 3) {
            _this.progress = 50;
          }
          return typeof _onreadystatechange === "function" ? _onreadystatechange.apply(null, arguments) : void 0;
        };
      }
    }
    return XHRRequestTracker;
  }();
  SocketRequestTracker = function () {
    function SocketRequestTracker(request) {
      var event,
        _j,
        _len1,
        _ref2,
        _this = this;
      this.progress = 0;
      _ref2 = ['error', 'open'];
      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
        event = _ref2[_j];
        request.addEventListener(event, function () {
          return _this.progress = 100;
        }, false);
      }
    }
    return SocketRequestTracker;
  }();
  ElementMonitor = function () {
    function ElementMonitor(options) {
      var selector, _j, _len1, _ref2;
      if (options == null) {
        options = {};
      }
      this.elements = [];
      if (options.selectors == null) {
        options.selectors = [];
      }
      _ref2 = options.selectors;
      for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
        selector = _ref2[_j];
        this.elements.push(new ElementTracker(selector));
      }
    }
    return ElementMonitor;
  }();
  ElementTracker = function () {
    function ElementTracker(selector) {
      this.selector = selector;
      this.progress = 0;
      this.check();
    }
    ElementTracker.prototype.check = function () {
      var _this = this;
      if (document.querySelector(this.selector)) {
        return this.done();
      } else {
        return setTimeout(function () {
          return _this.check();
        }, options.elements.checkInterval);
      }
    };
    ElementTracker.prototype.done = function () {
      return this.progress = 100;
    };
    return ElementTracker;
  }();
  DocumentMonitor = function () {
    DocumentMonitor.prototype.states = {
      loading: 0,
      interactive: 50,
      complete: 100
    };
    function DocumentMonitor() {
      var _onreadystatechange,
        _ref2,
        _this = this;
      this.progress = (_ref2 = this.states[document.readyState]) != null ? _ref2 : 100;
      _onreadystatechange = document.onreadystatechange;
      document.onreadystatechange = function () {
        if (_this.states[document.readyState] != null) {
          _this.progress = _this.states[document.readyState];
        }
        return typeof _onreadystatechange === "function" ? _onreadystatechange.apply(null, arguments) : void 0;
      };
    }
    return DocumentMonitor;
  }();
  EventLagMonitor = function () {
    function EventLagMonitor() {
      var avg,
        interval,
        last,
        points,
        samples,
        _this = this;
      this.progress = 0;
      avg = 0;
      samples = [];
      points = 0;
      last = now();
      interval = setInterval(function () {
        var diff;
        diff = now() - last - 50;
        last = now();
        samples.push(diff);
        if (samples.length > options.eventLag.sampleCount) {
          samples.shift();
        }
        avg = avgAmplitude(samples);
        if (++points >= options.eventLag.minSamples && avg < options.eventLag.lagThreshold) {
          _this.progress = 100;
          return clearInterval(interval);
        } else {
          return _this.progress = 100 * (3 / (avg + 3));
        }
      }, 50);
    }
    return EventLagMonitor;
  }();
  Scaler = function () {
    function Scaler(source) {
      this.source = source;
      this.last = this.sinceLastUpdate = 0;
      this.rate = options.initialRate;
      this.catchup = 0;
      this.progress = this.lastProgress = 0;
      if (this.source != null) {
        this.progress = result(this.source, 'progress');
      }
    }
    Scaler.prototype.tick = function (frameTime, val) {
      var scaling;
      if (val == null) {
        val = result(this.source, 'progress');
      }
      if (val >= 100) {
        this.done = true;
      }
      if (val === this.last) {
        this.sinceLastUpdate += frameTime;
      } else {
        if (this.sinceLastUpdate) {
          this.rate = (val - this.last) / this.sinceLastUpdate;
        }
        this.catchup = (val - this.progress) / options.catchupTime;
        this.sinceLastUpdate = 0;
        this.last = val;
      }
      if (val > this.progress) {
        this.progress += this.catchup * frameTime;
      }
      scaling = 1 - Math.pow(this.progress / 100, options.easeFactor);
      this.progress += scaling * this.rate * frameTime;
      this.progress = Math.min(this.lastProgress + options.maxProgressPerFrame, this.progress);
      this.progress = Math.max(0, this.progress);
      this.progress = Math.min(100, this.progress);
      this.lastProgress = this.progress;
      return this.progress;
    };
    return Scaler;
  }();
  sources = null;
  scalers = null;
  bar = null;
  uniScaler = null;
  animation = null;
  cancelAnimation = null;
  Pace.running = false;
  handlePushState = function handlePushState() {
    if (options.restartOnPushState) {
      return Pace.restart();
    }
  };
  if (window.history.pushState != null) {
    _pushState = window.history.pushState;
    window.history.pushState = function () {
      handlePushState();
      return _pushState.apply(window.history, arguments);
    };
  }
  if (window.history.replaceState != null) {
    _replaceState = window.history.replaceState;
    window.history.replaceState = function () {
      handlePushState();
      return _replaceState.apply(window.history, arguments);
    };
  }
  SOURCE_KEYS = {
    ajax: AjaxMonitor,
    elements: ElementMonitor,
    document: DocumentMonitor,
    eventLag: EventLagMonitor
  };
  (init = function init() {
    var type, _j, _k, _len1, _len2, _ref2, _ref3, _ref4;
    Pace.sources = sources = [];
    _ref2 = ['ajax', 'elements', 'document', 'eventLag'];
    for (_j = 0, _len1 = _ref2.length; _j < _len1; _j++) {
      type = _ref2[_j];
      if (options[type] !== false) {
        sources.push(new SOURCE_KEYS[type](options[type]));
      }
    }
    _ref4 = (_ref3 = options.extraSources) != null ? _ref3 : [];
    for (_k = 0, _len2 = _ref4.length; _k < _len2; _k++) {
      source = _ref4[_k];
      sources.push(new source(options));
    }
    Pace.bar = bar = new Bar();
    scalers = [];
    return uniScaler = new Scaler();
  })();
  Pace.stop = function () {
    Pace.trigger('stop');
    Pace.running = false;
    bar.destroy();
    cancelAnimation = true;
    if (animation != null) {
      if (typeof cancelAnimationFrame === "function") {
        cancelAnimationFrame(animation);
      }
      animation = null;
    }
    return init();
  };
  Pace.restart = function () {
    Pace.trigger('restart');
    Pace.stop();
    return Pace.start();
  };
  Pace.go = function () {
    var start;
    Pace.running = true;
    bar.render();
    start = now();
    cancelAnimation = false;
    return animation = runAnimation(function (frameTime, enqueueNextFrame) {
      var avg, count, done, element, elements, i, j, remaining, scaler, scalerList, sum, _j, _k, _len1, _len2, _ref2;
      remaining = 100 - bar.progress;
      count = sum = 0;
      done = true;
      for (i = _j = 0, _len1 = sources.length; _j < _len1; i = ++_j) {
        source = sources[i];
        scalerList = scalers[i] != null ? scalers[i] : scalers[i] = [];
        elements = (_ref2 = source.elements) != null ? _ref2 : [source];
        for (j = _k = 0, _len2 = elements.length; _k < _len2; j = ++_k) {
          element = elements[j];
          scaler = scalerList[j] != null ? scalerList[j] : scalerList[j] = new Scaler(element);
          done &= scaler.done;
          if (scaler.done) {
            continue;
          }
          count++;
          sum += scaler.tick(frameTime);
        }
      }
      avg = sum / count;
      bar.update(uniScaler.tick(frameTime, avg));
      if (bar.done() || done || cancelAnimation) {
        bar.update(100);
        Pace.trigger('done');
        return setTimeout(function () {
          bar.finish();
          Pace.running = false;
          return Pace.trigger('hide');
        }, Math.max(options.ghostTime, Math.max(options.minTime - (now() - start), 0)));
      } else {
        return enqueueNextFrame();
      }
    });
  };
  Pace.start = function (_options) {
    _extend2(options, _options);
    Pace.running = true;
    try {
      bar.render();
    } catch (_error) {
      NoTargetError = _error;
    }
    if (!document.querySelector('.pace')) {
      return setTimeout(Pace.start, 50);
    } else {
      Pace.trigger('start');
      return Pace.go();
    }
  };
  if (typeof define === 'function' && define.amd) {
    define(['pace'], function () {
      return Pace;
    });
  } else if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object') {
    module.exports = Pace;
  } else {
    if (options.startOnPageLoad) {
      Pace.start();
    }
  }
}).call(this);

/*!
* metismenu https://github.com/onokumus/metismenu#readme
* A collapsible jQuery menu plugin
* @version 3.0.7
* @author Osman Nuri Okumus <onokumus@gmail.com> (https://github.com/onokumus)
* @license: MIT 
*/
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory(require('jquery')) : typeof define === 'function' && define.amd ? define(['jquery'], factory) : (global = typeof globalThis !== 'undefined' ? globalThis : global || self, global.metisMenu = factory(global.$));
})(this, function ($) {
  'use strict';

  function _interopDefaultLegacy(e) {
    return e && _typeof(e) === 'object' && 'default' in e ? e : {
      'default': e
    };
  }
  var $__default = /*#__PURE__*/_interopDefaultLegacy($);
  var Util = function ($) {
    // eslint-disable-line no-shadow
    var TRANSITION_END = 'transitionend';
    var Util = {
      // eslint-disable-line no-shadow
      TRANSITION_END: 'mmTransitionEnd',
      triggerTransitionEnd: function triggerTransitionEnd(element) {
        $(element).trigger(TRANSITION_END);
      },
      supportsTransitionEnd: function supportsTransitionEnd() {
        return Boolean(TRANSITION_END);
      }
    };
    function getSpecialTransitionEndEvent() {
      return {
        bindType: TRANSITION_END,
        delegateType: TRANSITION_END,
        handle: function handle(event) {
          if ($(event.target).is(this)) {
            return event.handleObj.handler.apply(this, arguments); // eslint-disable-line prefer-rest-params
          }
          return undefined;
        }
      };
    }
    function transitionEndEmulator(duration) {
      var _this2 = this;
      var called = false;
      $(this).one(Util.TRANSITION_END, function () {
        called = true;
      });
      setTimeout(function () {
        if (!called) {
          Util.triggerTransitionEnd(_this2);
        }
      }, duration);
      return this;
    }
    function setTransitionEndSupport() {
      $.fn.mmEmulateTransitionEnd = transitionEndEmulator; // eslint-disable-line no-param-reassign
      // eslint-disable-next-line no-param-reassign
      $.event.special[Util.TRANSITION_END] = getSpecialTransitionEndEvent();
    }
    setTransitionEndSupport();
    return Util;
  }($__default['default']);
  var NAME = 'metisMenu';
  var DATA_KEY = 'metisMenu';
  var EVENT_KEY = ".".concat(DATA_KEY);
  var DATA_API_KEY = '.data-api';
  var JQUERY_NO_CONFLICT = $__default['default'].fn[NAME];
  var TRANSITION_DURATION = 350;
  var Default = {
    toggle: true,
    preventDefault: true,
    triggerElement: 'a',
    parentTrigger: 'li',
    subMenu: 'ul'
  };
  var Event = {
    SHOW: "show".concat(EVENT_KEY),
    SHOWN: "shown".concat(EVENT_KEY),
    HIDE: "hide".concat(EVENT_KEY),
    HIDDEN: "hidden".concat(EVENT_KEY),
    CLICK_DATA_API: "click".concat(EVENT_KEY).concat(DATA_API_KEY)
  };
  var ClassName = {
    METIS: 'metismenu',
    ACTIVE: 'mm-active',
    SHOW: 'mm-show',
    COLLAPSE: 'mm-collapse',
    COLLAPSING: 'mm-collapsing',
    COLLAPSED: 'mm-collapsed'
  };
  var MetisMenu = /*#__PURE__*/function () {
    // eslint-disable-line no-shadow
    function MetisMenu(element, config) {
      _classCallCheck(this, MetisMenu);
      this.element = element;
      this.config = _objectSpread(_objectSpread({}, Default), config);
      this.transitioning = null;
      this.init();
    }
    return _createClass(MetisMenu, [{
      key: "init",
      value: function init() {
        var self = this;
        var conf = this.config;
        var el = $__default['default'](this.element);
        el.addClass(ClassName.METIS); // add metismenu class to element

        el.find("".concat(conf.parentTrigger, ".").concat(ClassName.ACTIVE)).children(conf.triggerElement).attr('aria-expanded', 'true'); // add attribute aria-expanded=true the trigger element

        el.find("".concat(conf.parentTrigger, ".").concat(ClassName.ACTIVE)).parents(conf.parentTrigger).addClass(ClassName.ACTIVE);
        el.find("".concat(conf.parentTrigger, ".").concat(ClassName.ACTIVE)).parents(conf.parentTrigger).children(conf.triggerElement).attr('aria-expanded', 'true'); // add attribute aria-expanded=true the triggers of all parents

        el.find("".concat(conf.parentTrigger, ".").concat(ClassName.ACTIVE)).has(conf.subMenu).children(conf.subMenu).addClass("".concat(ClassName.COLLAPSE, " ").concat(ClassName.SHOW));
        el.find(conf.parentTrigger).not(".".concat(ClassName.ACTIVE)).has(conf.subMenu).children(conf.subMenu).addClass(ClassName.COLLAPSE);
        el.find(conf.parentTrigger)
        // .has(conf.subMenu)
        .children(conf.triggerElement).on(Event.CLICK_DATA_API, function (e) {
          // eslint-disable-line func-names
          var eTar = $__default['default'](this);
          if (eTar.attr('aria-disabled') === 'true') {
            return;
          }
          if (conf.preventDefault && eTar.attr('href') === '#') {
            e.preventDefault();
          }
          var paRent = eTar.parent(conf.parentTrigger);
          var sibLi = paRent.siblings(conf.parentTrigger);
          var sibTrigger = sibLi.children(conf.triggerElement);
          if (paRent.hasClass(ClassName.ACTIVE)) {
            eTar.attr('aria-expanded', 'false');
            self.removeActive(paRent);
          } else {
            eTar.attr('aria-expanded', 'true');
            self.setActive(paRent);
            if (conf.toggle) {
              self.removeActive(sibLi);
              sibTrigger.attr('aria-expanded', 'false');
            }
          }
          if (conf.onTransitionStart) {
            conf.onTransitionStart(e);
          }
        });
      }
    }, {
      key: "setActive",
      value: function setActive(li) {
        $__default['default'](li).addClass(ClassName.ACTIVE);
        var ul = $__default['default'](li).children(this.config.subMenu);
        if (ul.length > 0 && !ul.hasClass(ClassName.SHOW)) {
          this.show(ul);
        }
      }
    }, {
      key: "removeActive",
      value: function removeActive(li) {
        $__default['default'](li).removeClass(ClassName.ACTIVE);
        var ul = $__default['default'](li).children("".concat(this.config.subMenu, ".").concat(ClassName.SHOW));
        if (ul.length > 0) {
          this.hide(ul);
        }
      }
    }, {
      key: "show",
      value: function show(element) {
        var _this3 = this;
        if (this.transitioning || $__default['default'](element).hasClass(ClassName.COLLAPSING)) {
          return;
        }
        var elem = $__default['default'](element);
        var startEvent = $__default['default'].Event(Event.SHOW);
        elem.trigger(startEvent);
        if (startEvent.isDefaultPrevented()) {
          return;
        }
        elem.parent(this.config.parentTrigger).addClass(ClassName.ACTIVE);
        if (this.config.toggle) {
          var toggleElem = elem.parent(this.config.parentTrigger).siblings().children("".concat(this.config.subMenu, ".").concat(ClassName.SHOW));
          this.hide(toggleElem);
        }
        elem.removeClass(ClassName.COLLAPSE).addClass(ClassName.COLLAPSING).height(0);
        this.setTransitioning(true);
        var complete = function complete() {
          // check if disposed
          if (!_this3.config || !_this3.element) {
            return;
          }
          elem.removeClass(ClassName.COLLAPSING).addClass("".concat(ClassName.COLLAPSE, " ").concat(ClassName.SHOW)).height('');
          _this3.setTransitioning(false);
          elem.trigger(Event.SHOWN);
        };
        elem.height(element[0].scrollHeight).one(Util.TRANSITION_END, complete).mmEmulateTransitionEnd(TRANSITION_DURATION);
      }
    }, {
      key: "hide",
      value: function hide(element) {
        var _this4 = this;
        if (this.transitioning || !$__default['default'](element).hasClass(ClassName.SHOW)) {
          return;
        }
        var elem = $__default['default'](element);
        var startEvent = $__default['default'].Event(Event.HIDE);
        elem.trigger(startEvent);
        if (startEvent.isDefaultPrevented()) {
          return;
        }
        elem.parent(this.config.parentTrigger).removeClass(ClassName.ACTIVE);
        // eslint-disable-next-line no-unused-expressions
        elem.height(elem.height())[0].offsetHeight;
        elem.addClass(ClassName.COLLAPSING).removeClass(ClassName.COLLAPSE).removeClass(ClassName.SHOW);
        this.setTransitioning(true);
        var complete = function complete() {
          // check if disposed
          if (!_this4.config || !_this4.element) {
            return;
          }
          if (_this4.transitioning && _this4.config.onTransitionEnd) {
            _this4.config.onTransitionEnd();
          }
          _this4.setTransitioning(false);
          elem.trigger(Event.HIDDEN);
          elem.removeClass(ClassName.COLLAPSING).addClass(ClassName.COLLAPSE);
        };
        if (elem.height() === 0 || elem.css('display') === 'none') {
          complete();
        } else {
          elem.height(0).one(Util.TRANSITION_END, complete).mmEmulateTransitionEnd(TRANSITION_DURATION);
        }
      }
    }, {
      key: "setTransitioning",
      value: function setTransitioning(isTransitioning) {
        this.transitioning = isTransitioning;
      }
    }, {
      key: "dispose",
      value: function dispose() {
        $__default['default'].removeData(this.element, DATA_KEY);
        $__default['default'](this.element).find(this.config.parentTrigger)
        // .has(this.config.subMenu)
        .children(this.config.triggerElement).off(Event.CLICK_DATA_API);
        this.transitioning = null;
        this.config = null;
        this.element = null;
      }
    }], [{
      key: "jQueryInterface",
      value: function jQueryInterface(config) {
        // eslint-disable-next-line func-names
        return this.each(function () {
          var $this = $__default['default'](this);
          var data = $this.data(DATA_KEY);
          var conf = _objectSpread(_objectSpread(_objectSpread({}, Default), $this.data()), _typeof(config) === 'object' && config ? config : {});
          if (!data) {
            data = new MetisMenu(this, conf);
            $this.data(DATA_KEY, data);
          }
          if (typeof config === 'string') {
            if (data[config] === undefined) {
              throw new Error("No method named \"".concat(config, "\""));
            }
            data[config]();
          }
        });
      }
    }]);
  }();
  /**
   * ------------------------------------------------------------------------
   * jQuery
   * ------------------------------------------------------------------------
   */
  $__default['default'].fn[NAME] = MetisMenu.jQueryInterface; // eslint-disable-line no-param-reassign
  $__default['default'].fn[NAME].Constructor = MetisMenu; // eslint-disable-line no-param-reassign
  $__default['default'].fn[NAME].noConflict = function () {
    // eslint-disable-line no-param-reassign
    $__default['default'].fn[NAME] = JQUERY_NO_CONFLICT; // eslint-disable-line no-param-reassign
    return MetisMenu.jQueryInterface;
  };
  return MetisMenu;
});


/*!
 * Masonry PACKAGED v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

/**
 * Bridget makes jQuery widgets
 * v2.0.1
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */

(function (window, factory) {
  // universal module definition
  /*jshint strict: false */ /* globals define, module, require */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define('jquery-bridget/jquery-bridget', ['jquery'], function (jQuery) {
      return factory(window, jQuery);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('jquery'));
  } else {
    // browser global
    window.jQueryBridget = factory(window, window.jQuery);
  }
})(window, function factory(window, jQuery) {
  'use strict';

  // ----- utils ----- //
  var arraySlice = Array.prototype.slice;

  // helper function for logging errors
  // $.error breaks jQuery chaining
  var console = window.console;
  var logError = typeof console == 'undefined' ? function () {} : function (message) {
    console.error(message);
  };

  // ----- jQueryBridget ----- //

  function jQueryBridget(namespace, PluginClass, $) {
    $ = $ || jQuery || window.jQuery;
    if (!$) {
      return;
    }

    // add option method -> $().plugin('option', {...})
    if (!PluginClass.prototype.option) {
      // option setter
      PluginClass.prototype.option = function (opts) {
        // bail out if not an object
        if (!$.isPlainObject(opts)) {
          return;
        }
        this.options = $.extend(true, this.options, opts);
      };
    }

    // make jQuery plugin
    $.fn[namespace] = function (arg0 /*, arg1 */) {
      if (typeof arg0 == 'string') {
        // method call $().plugin( 'methodName', { options } )
        // shift arguments by 1
        var args = arraySlice.call(arguments, 1);
        return methodCall(this, arg0, args);
      }
      // just $().plugin({ options })
      plainCall(this, arg0);
      return this;
    };

    // $().plugin('methodName')
    function methodCall($elems, methodName, args) {
      var returnValue;
      var pluginMethodStr = '$().' + namespace + '("' + methodName + '")';
      $elems.each(function (i, elem) {
        // get instance
        var instance = $.data(elem, namespace);
        if (!instance) {
          logError(namespace + ' not initialized. Cannot call methods, i.e. ' + pluginMethodStr);
          return;
        }
        var method = instance[methodName];
        if (!method || methodName.charAt(0) == '_') {
          logError(pluginMethodStr + ' is not a valid method');
          return;
        }

        // apply method, get return value
        var value = method.apply(instance, args);
        // set return value if value is returned, use only first value
        returnValue = returnValue === undefined ? value : returnValue;
      });
      return returnValue !== undefined ? returnValue : $elems;
    }
    function plainCall($elems, options) {
      $elems.each(function (i, elem) {
        var instance = $.data(elem, namespace);
        if (instance) {
          // set options & init
          instance.option(options);
          instance._init();
        } else {
          // initialize new instance
          instance = new PluginClass(elem, options);
          $.data(elem, namespace, instance);
        }
      });
    }
    updateJQuery($);
  }

  // ----- updateJQuery ----- //

  // set $.bridget for v1 backwards compatibility
  function updateJQuery($) {
    if (!$ || $ && $.bridget) {
      return;
    }
    $.bridget = jQueryBridget;
  }
  updateJQuery(jQuery || window.jQuery);

  // -----  ----- //

  return jQueryBridget;
});

/**
 * EvEmitter v1.1.0
 * Lil' event emitter
 * MIT License
 */

/* jshint unused: true, undef: true, strict: true */

(function (global, factory) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, window */
  if (typeof define == 'function' && define.amd) {
    // AMD - RequireJS
    define('ev-emitter/ev-emitter', factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS - Browserify, Webpack
    module.exports = factory();
  } else {
    // Browser globals
    global.EvEmitter = factory();
  }
})(typeof window != 'undefined' ? window : this, function () {
  function EvEmitter() {}
  var proto = EvEmitter.prototype;
  proto.on = function (eventName, listener) {
    if (!eventName || !listener) {
      return;
    }
    // set events hash
    var events = this._events = this._events || {};
    // set listeners array
    var listeners = events[eventName] = events[eventName] || [];
    // only add once
    if (listeners.indexOf(listener) == -1) {
      listeners.push(listener);
    }
    return this;
  };
  proto.once = function (eventName, listener) {
    if (!eventName || !listener) {
      return;
    }
    // add event
    this.on(eventName, listener);
    // set once flag
    // set onceEvents hash
    var onceEvents = this._onceEvents = this._onceEvents || {};
    // set onceListeners object
    var onceListeners = onceEvents[eventName] = onceEvents[eventName] || {};
    // set flag
    onceListeners[listener] = true;
    return this;
  };
  proto.off = function (eventName, listener) {
    var listeners = this._events && this._events[eventName];
    if (!listeners || !listeners.length) {
      return;
    }
    var index = listeners.indexOf(listener);
    if (index != -1) {
      listeners.splice(index, 1);
    }
    return this;
  };
  proto.emitEvent = function (eventName, args) {
    var listeners = this._events && this._events[eventName];
    if (!listeners || !listeners.length) {
      return;
    }
    // copy over to avoid interference if .off() in listener
    listeners = listeners.slice(0);
    args = args || [];
    // once stuff
    var onceListeners = this._onceEvents && this._onceEvents[eventName];
    for (var i = 0; i < listeners.length; i++) {
      var listener = listeners[i];
      var isOnce = onceListeners && onceListeners[listener];
      if (isOnce) {
        // remove listener
        // remove before trigger to prevent recursion
        this.off(eventName, listener);
        // unset once flag
        delete onceListeners[listener];
      }
      // trigger listener
      listener.apply(this, args);
    }
    return this;
  };
  proto.allOff = function () {
    delete this._events;
    delete this._onceEvents;
  };
  return EvEmitter;
});

/*!
 * getSize v2.0.3
 * measure size of elements
 * MIT license
 */

/* jshint browser: true, strict: true, undef: true, unused: true */
/* globals console: false */

(function (window, factory) {
  /* jshint strict: false */ /* globals define, module */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define('get-size/get-size', factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.getSize = factory();
  }
})(window, function factory() {
  'use strict';

  // -------------------------- helpers -------------------------- //

  // get a number from a string, not a percentage
  function getStyleSize(value) {
    var num = parseFloat(value);
    // not a percent like '100%', and a number
    var isValid = value.indexOf('%') == -1 && !isNaN(num);
    return isValid && num;
  }
  function noop() {}
  var logError = typeof console == 'undefined' ? noop : function (message) {
    console.error(message);
  };

  // -------------------------- measurements -------------------------- //

  var measurements = ['paddingLeft', 'paddingRight', 'paddingTop', 'paddingBottom', 'marginLeft', 'marginRight', 'marginTop', 'marginBottom', 'borderLeftWidth', 'borderRightWidth', 'borderTopWidth', 'borderBottomWidth'];
  var measurementsLength = measurements.length;
  function getZeroSize() {
    var size = {
      width: 0,
      height: 0,
      innerWidth: 0,
      innerHeight: 0,
      outerWidth: 0,
      outerHeight: 0
    };
    for (var i = 0; i < measurementsLength; i++) {
      var measurement = measurements[i];
      size[measurement] = 0;
    }
    return size;
  }

  // -------------------------- getStyle -------------------------- //

  /**
   * getStyle, get style of element, check for Firefox bug
   * https://bugzilla.mozilla.org/show_bug.cgi?id=548397
   */
  function getStyle(elem) {
    var style = getComputedStyle(elem);
    if (!style) {
      logError('Style returned ' + style + '. Are you running this code in a hidden iframe on Firefox? ' + 'See https://bit.ly/getsizebug1');
    }
    return style;
  }

  // -------------------------- setup -------------------------- //

  var isSetup = false;
  var isBoxSizeOuter;

  /**
   * setup
   * check isBoxSizerOuter
   * do on first getSize() rather than on page load for Firefox bug
   */
  function setup() {
    // setup once
    if (isSetup) {
      return;
    }
    isSetup = true;

    // -------------------------- box sizing -------------------------- //

    /**
     * Chrome & Safari measure the outer-width on style.width on border-box elems
     * IE11 & Firefox<29 measures the inner-width
     */
    var div = document.createElement('div');
    div.style.width = '200px';
    div.style.padding = '1px 2px 3px 4px';
    div.style.borderStyle = 'solid';
    div.style.borderWidth = '1px 2px 3px 4px';
    div.style.boxSizing = 'border-box';
    var body = document.body || document.documentElement;
    body.appendChild(div);
    var style = getStyle(div);
    // round value for browser zoom. desandro/masonry#928
    isBoxSizeOuter = Math.round(getStyleSize(style.width)) == 200;
    getSize.isBoxSizeOuter = isBoxSizeOuter;
    body.removeChild(div);
  }

  // -------------------------- getSize -------------------------- //

  function getSize(elem) {
    setup();

    // use querySeletor if elem is string
    if (typeof elem == 'string') {
      elem = document.querySelector(elem);
    }

    // do not proceed on non-objects
    if (!elem || _typeof(elem) != 'object' || !elem.nodeType) {
      return;
    }
    var style = getStyle(elem);

    // if hidden, everything is 0
    if (style.display == 'none') {
      return getZeroSize();
    }
    var size = {};
    size.width = elem.offsetWidth;
    size.height = elem.offsetHeight;
    var isBorderBox = size.isBorderBox = style.boxSizing == 'border-box';

    // get all measurements
    for (var i = 0; i < measurementsLength; i++) {
      var measurement = measurements[i];
      var value = style[measurement];
      var num = parseFloat(value);
      // any 'auto', 'medium' value will be 0
      size[measurement] = !isNaN(num) ? num : 0;
    }
    var paddingWidth = size.paddingLeft + size.paddingRight;
    var paddingHeight = size.paddingTop + size.paddingBottom;
    var marginWidth = size.marginLeft + size.marginRight;
    var marginHeight = size.marginTop + size.marginBottom;
    var borderWidth = size.borderLeftWidth + size.borderRightWidth;
    var borderHeight = size.borderTopWidth + size.borderBottomWidth;
    var isBorderBoxSizeOuter = isBorderBox && isBoxSizeOuter;

    // overwrite width and height if we can get it from style
    var styleWidth = getStyleSize(style.width);
    if (styleWidth !== false) {
      size.width = styleWidth + (
      // add padding and border unless it's already including it
      isBorderBoxSizeOuter ? 0 : paddingWidth + borderWidth);
    }
    var styleHeight = getStyleSize(style.height);
    if (styleHeight !== false) {
      size.height = styleHeight + (
      // add padding and border unless it's already including it
      isBorderBoxSizeOuter ? 0 : paddingHeight + borderHeight);
    }
    size.innerWidth = size.width - (paddingWidth + borderWidth);
    size.innerHeight = size.height - (paddingHeight + borderHeight);
    size.outerWidth = size.width + marginWidth;
    size.outerHeight = size.height + marginHeight;
    return size;
  }
  return getSize;
});

/**
 * matchesSelector v2.0.2
 * matchesSelector( element, '.selector' )
 * MIT license
 */

/*jshint browser: true, strict: true, undef: true, unused: true */

(function (window, factory) {
  /*global define: false, module: false */
  'use strict';

  // universal module definition
  if (typeof define == 'function' && define.amd) {
    // AMD
    define('desandro-matches-selector/matches-selector', factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory();
  } else {
    // browser global
    window.matchesSelector = factory();
  }
})(window, function factory() {
  'use strict';

  var matchesMethod = function () {
    var ElemProto = window.Element.prototype;
    // check for the standard method name first
    if (ElemProto.matches) {
      return 'matches';
    }
    // check un-prefixed
    if (ElemProto.matchesSelector) {
      return 'matchesSelector';
    }
    // check vendor prefixes
    var prefixes = ['webkit', 'moz', 'ms', 'o'];
    for (var i = 0; i < prefixes.length; i++) {
      var prefix = prefixes[i];
      var method = prefix + 'MatchesSelector';
      if (ElemProto[method]) {
        return method;
      }
    }
  }();
  return function matchesSelector(elem, selector) {
    return elem[matchesMethod](selector);
  };
});

/**
 * Fizzy UI utils v2.0.7
 * MIT license
 */

/*jshint browser: true, undef: true, unused: true, strict: true */

(function (window, factory) {
  // universal module definition
  /*jshint strict: false */ /*globals define, module, require */

  if (typeof define == 'function' && define.amd) {
    // AMD
    define('fizzy-ui-utils/utils', ['desandro-matches-selector/matches-selector'], function (matchesSelector) {
      return factory(window, matchesSelector);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(window, require('desandro-matches-selector'));
  } else {
    // browser global
    window.fizzyUIUtils = factory(window, window.matchesSelector);
  }
})(window, function factory(window, matchesSelector) {
  var utils = {};

  // ----- extend ----- //

  // extends objects
  utils.extend = function (a, b) {
    for (var prop in b) {
      a[prop] = b[prop];
    }
    return a;
  };

  // ----- modulo ----- //

  utils.modulo = function (num, div) {
    return (num % div + div) % div;
  };

  // ----- makeArray ----- //

  var arraySlice = Array.prototype.slice;

  // turn element or nodeList into an array
  utils.makeArray = function (obj) {
    if (Array.isArray(obj)) {
      // use object if already an array
      return obj;
    }
    // return empty array if undefined or null. #6
    if (obj === null || obj === undefined) {
      return [];
    }
    var isArrayLike = _typeof(obj) == 'object' && typeof obj.length == 'number';
    if (isArrayLike) {
      // convert nodeList to array
      return arraySlice.call(obj);
    }

    // array of single index
    return [obj];
  };

  // ----- removeFrom ----- //

  utils.removeFrom = function (ary, obj) {
    var index = ary.indexOf(obj);
    if (index != -1) {
      ary.splice(index, 1);
    }
  };

  // ----- getParent ----- //

  utils.getParent = function (elem, selector) {
    while (elem.parentNode && elem != document.body) {
      elem = elem.parentNode;
      if (matchesSelector(elem, selector)) {
        return elem;
      }
    }
  };

  // ----- getQueryElement ----- //

  // use element as selector string
  utils.getQueryElement = function (elem) {
    if (typeof elem == 'string') {
      return document.querySelector(elem);
    }
    return elem;
  };

  // ----- handleEvent ----- //

  // enable .ontype to trigger from .addEventListener( elem, 'type' )
  utils.handleEvent = function (event) {
    var method = 'on' + event.type;
    if (this[method]) {
      this[method](event);
    }
  };

  // ----- filterFindElements ----- //

  utils.filterFindElements = function (elems, selector) {
    // make array of elems
    elems = utils.makeArray(elems);
    var ffElems = [];
    elems.forEach(function (elem) {
      // check that elem is an actual element
      if (!(elem instanceof HTMLElement)) {
        return;
      }
      // add elem if no selector
      if (!selector) {
        ffElems.push(elem);
        return;
      }
      // filter & find items if we have a selector
      // filter
      if (matchesSelector(elem, selector)) {
        ffElems.push(elem);
      }
      // find children
      var childElems = elem.querySelectorAll(selector);
      // concat childElems to filterFound array
      for (var i = 0; i < childElems.length; i++) {
        ffElems.push(childElems[i]);
      }
    });
    return ffElems;
  };

  // ----- debounceMethod ----- //

  utils.debounceMethod = function (_class, methodName, threshold) {
    threshold = threshold || 100;
    // original method
    var method = _class.prototype[methodName];
    var timeoutName = methodName + 'Timeout';
    _class.prototype[methodName] = function () {
      var timeout = this[timeoutName];
      clearTimeout(timeout);
      var args = arguments;
      var _this = this;
      this[timeoutName] = setTimeout(function () {
        method.apply(_this, args);
        delete _this[timeoutName];
      }, threshold);
    };
  };

  // ----- docReady ----- //

  utils.docReady = function (callback) {
    var readyState = document.readyState;
    if (readyState == 'complete' || readyState == 'interactive') {
      // do async to allow for other scripts to run. metafizzy/flickity#441
      setTimeout(callback);
    } else {
      document.addEventListener('DOMContentLoaded', callback);
    }
  };

  // ----- htmlInit ----- //

  // http://jamesroberts.name/blog/2010/02/22/string-functions-for-javascript-trim-to-camel-case-to-dashed-and-to-underscore/
  utils.toDashed = function (str) {
    return str.replace(/(.)([A-Z])/g, function (match, $1, $2) {
      return $1 + '-' + $2;
    }).toLowerCase();
  };
  var console = window.console;
  /**
   * allow user to initialize classes via [data-namespace] or .js-namespace class
   * htmlInit( Widget, 'widgetName' )
   * options are parsed from data-namespace-options
   */
  utils.htmlInit = function (WidgetClass, namespace) {
    utils.docReady(function () {
      var dashedNamespace = utils.toDashed(namespace);
      var dataAttr = 'data-' + dashedNamespace;
      var dataAttrElems = document.querySelectorAll('[' + dataAttr + ']');
      var jsDashElems = document.querySelectorAll('.js-' + dashedNamespace);
      var elems = utils.makeArray(dataAttrElems).concat(utils.makeArray(jsDashElems));
      var dataOptionsAttr = dataAttr + '-options';
      var jQuery = window.jQuery;
      elems.forEach(function (elem) {
        var attr = elem.getAttribute(dataAttr) || elem.getAttribute(dataOptionsAttr);
        var options;
        try {
          options = attr && JSON.parse(attr);
        } catch (error) {
          // log error, do not initialize
          if (console) {
            console.error('Error parsing ' + dataAttr + ' on ' + elem.className + ': ' + error);
          }
          return;
        }
        // initialize
        var instance = new WidgetClass(elem, options);
        // make available via $().data('namespace')
        if (jQuery) {
          jQuery.data(elem, namespace, instance);
        }
      });
    });
  };

  // -----  ----- //

  return utils;
});

/**
 * Outlayer Item
 */

(function (window, factory) {
  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if (typeof define == 'function' && define.amd) {
    // AMD - RequireJS
    define('outlayer/item', ['ev-emitter/ev-emitter', 'get-size/get-size'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(require('ev-emitter'), require('get-size'));
  } else {
    // browser global
    window.Outlayer = {};
    window.Outlayer.Item = factory(window.EvEmitter, window.getSize);
  }
})(window, function factory(EvEmitter, getSize) {
  'use strict';

  // ----- helpers ----- //
  function isEmptyObj(obj) {
    for (var prop in obj) {
      return false;
    }
    prop = null;
    return true;
  }

  // -------------------------- CSS3 support -------------------------- //

  var docElemStyle = document.documentElement.style;
  var transitionProperty = typeof docElemStyle.transition == 'string' ? 'transition' : 'WebkitTransition';
  var transformProperty = typeof docElemStyle.transform == 'string' ? 'transform' : 'WebkitTransform';
  var transitionEndEvent = {
    WebkitTransition: 'webkitTransitionEnd',
    transition: 'transitionend'
  }[transitionProperty];

  // cache all vendor properties that could have vendor prefix
  var vendorProperties = {
    transform: transformProperty,
    transition: transitionProperty,
    transitionDuration: transitionProperty + 'Duration',
    transitionProperty: transitionProperty + 'Property',
    transitionDelay: transitionProperty + 'Delay'
  };

  // -------------------------- Item -------------------------- //

  function Item(element, layout) {
    if (!element) {
      return;
    }
    this.element = element;
    // parent layout class, i.e. Masonry, Isotope, or Packery
    this.layout = layout;
    this.position = {
      x: 0,
      y: 0
    };
    this._create();
  }

  // inherit EvEmitter
  var proto = Item.prototype = Object.create(EvEmitter.prototype);
  proto.constructor = Item;
  proto._create = function () {
    // transition objects
    this._transn = {
      ingProperties: {},
      clean: {},
      onEnd: {}
    };
    this.css({
      position: 'absolute'
    });
  };

  // trigger specified handler for event type
  proto.handleEvent = function (event) {
    var method = 'on' + event.type;
    if (this[method]) {
      this[method](event);
    }
  };
  proto.getSize = function () {
    this.size = getSize(this.element);
  };

  /**
   * apply CSS styles to element
   * @param {Object} style
   */
  proto.css = function (style) {
    var elemStyle = this.element.style;
    for (var prop in style) {
      // use vendor property if available
      var supportedProp = vendorProperties[prop] || prop;
      elemStyle[supportedProp] = style[prop];
    }
  };

  // measure position, and sets it
  proto.getPosition = function () {
    var style = getComputedStyle(this.element);
    var isOriginLeft = this.layout._getOption('originLeft');
    var isOriginTop = this.layout._getOption('originTop');
    var xValue = style[isOriginLeft ? 'left' : 'right'];
    var yValue = style[isOriginTop ? 'top' : 'bottom'];
    var x = parseFloat(xValue);
    var y = parseFloat(yValue);
    // convert percent to pixels
    var layoutSize = this.layout.size;
    if (xValue.indexOf('%') != -1) {
      x = x / 100 * layoutSize.width;
    }
    if (yValue.indexOf('%') != -1) {
      y = y / 100 * layoutSize.height;
    }
    // clean up 'auto' or other non-integer values
    x = isNaN(x) ? 0 : x;
    y = isNaN(y) ? 0 : y;
    // remove padding from measurement
    x -= isOriginLeft ? layoutSize.paddingLeft : layoutSize.paddingRight;
    y -= isOriginTop ? layoutSize.paddingTop : layoutSize.paddingBottom;
    this.position.x = x;
    this.position.y = y;
  };

  // set settled position, apply padding
  proto.layoutPosition = function () {
    var layoutSize = this.layout.size;
    var style = {};
    var isOriginLeft = this.layout._getOption('originLeft');
    var isOriginTop = this.layout._getOption('originTop');

    // x
    var xPadding = isOriginLeft ? 'paddingLeft' : 'paddingRight';
    var xProperty = isOriginLeft ? 'left' : 'right';
    var xResetProperty = isOriginLeft ? 'right' : 'left';
    var x = this.position.x + layoutSize[xPadding];
    // set in percentage or pixels
    style[xProperty] = this.getXValue(x);
    // reset other property
    style[xResetProperty] = '';

    // y
    var yPadding = isOriginTop ? 'paddingTop' : 'paddingBottom';
    var yProperty = isOriginTop ? 'top' : 'bottom';
    var yResetProperty = isOriginTop ? 'bottom' : 'top';
    var y = this.position.y + layoutSize[yPadding];
    // set in percentage or pixels
    style[yProperty] = this.getYValue(y);
    // reset other property
    style[yResetProperty] = '';
    this.css(style);
    this.emitEvent('layout', [this]);
  };
  proto.getXValue = function (x) {
    var isHorizontal = this.layout._getOption('horizontal');
    return this.layout.options.percentPosition && !isHorizontal ? x / this.layout.size.width * 100 + '%' : x + 'px';
  };
  proto.getYValue = function (y) {
    var isHorizontal = this.layout._getOption('horizontal');
    return this.layout.options.percentPosition && isHorizontal ? y / this.layout.size.height * 100 + '%' : y + 'px';
  };
  proto._transitionTo = function (x, y) {
    this.getPosition();
    // get current x & y from top/left
    var curX = this.position.x;
    var curY = this.position.y;
    var didNotMove = x == this.position.x && y == this.position.y;

    // save end position
    this.setPosition(x, y);

    // if did not move and not transitioning, just go to layout
    if (didNotMove && !this.isTransitioning) {
      this.layoutPosition();
      return;
    }
    var transX = x - curX;
    var transY = y - curY;
    var transitionStyle = {};
    transitionStyle.transform = this.getTranslate(transX, transY);
    this.transition({
      to: transitionStyle,
      onTransitionEnd: {
        transform: this.layoutPosition
      },
      isCleaning: true
    });
  };
  proto.getTranslate = function (x, y) {
    // flip cooridinates if origin on right or bottom
    var isOriginLeft = this.layout._getOption('originLeft');
    var isOriginTop = this.layout._getOption('originTop');
    x = isOriginLeft ? x : -x;
    y = isOriginTop ? y : -y;
    return 'translate3d(' + x + 'px, ' + y + 'px, 0)';
  };

  // non transition + transform support
  proto.goTo = function (x, y) {
    this.setPosition(x, y);
    this.layoutPosition();
  };
  proto.moveTo = proto._transitionTo;
  proto.setPosition = function (x, y) {
    this.position.x = parseFloat(x);
    this.position.y = parseFloat(y);
  };

  // ----- transition ----- //

  /**
   * @param {Object} style - CSS
   * @param {Function} onTransitionEnd
   */

  // non transition, just trigger callback
  proto._nonTransition = function (args) {
    this.css(args.to);
    if (args.isCleaning) {
      this._removeStyles(args.to);
    }
    for (var prop in args.onTransitionEnd) {
      args.onTransitionEnd[prop].call(this);
    }
  };

  /**
   * proper transition
   * @param {Object} args - arguments
   *   @param {Object} to - style to transition to
   *   @param {Object} from - style to start transition from
   *   @param {Boolean} isCleaning - removes transition styles after transition
   *   @param {Function} onTransitionEnd - callback
   */
  proto.transition = function (args) {
    // redirect to nonTransition if no transition duration
    if (!parseFloat(this.layout.options.transitionDuration)) {
      this._nonTransition(args);
      return;
    }
    var _transition = this._transn;
    // keep track of onTransitionEnd callback by css property
    for (var prop in args.onTransitionEnd) {
      _transition.onEnd[prop] = args.onTransitionEnd[prop];
    }
    // keep track of properties that are transitioning
    for (prop in args.to) {
      _transition.ingProperties[prop] = true;
      // keep track of properties to clean up when transition is done
      if (args.isCleaning) {
        _transition.clean[prop] = true;
      }
    }

    // set from styles
    if (args.from) {
      this.css(args.from);
      // force redraw. http://blog.alexmaccaw.com/css-transitions
      var h = this.element.offsetHeight;
      // hack for JSHint to hush about unused var
      h = null;
    }
    // enable transition
    this.enableTransition(args.to);
    // set styles that are transitioning
    this.css(args.to);
    this.isTransitioning = true;
  };

  // dash before all cap letters, including first for
  // WebkitTransform => -webkit-transform
  function toDashedAll(str) {
    return str.replace(/([A-Z])/g, function ($1) {
      return '-' + $1.toLowerCase();
    });
  }
  var transitionProps = 'opacity,' + toDashedAll(transformProperty);
  proto.enableTransition = function /* style */
  () {
    // HACK changing transitionProperty during a transition
    // will cause transition to jump
    if (this.isTransitioning) {
      return;
    }

    // make `transition: foo, bar, baz` from style object
    // HACK un-comment this when enableTransition can work
    // while a transition is happening
    // var transitionValues = [];
    // for ( var prop in style ) {
    //   // dash-ify camelCased properties like WebkitTransition
    //   prop = vendorProperties[ prop ] || prop;
    //   transitionValues.push( toDashedAll( prop ) );
    // }
    // munge number to millisecond, to match stagger
    var duration = this.layout.options.transitionDuration;
    duration = typeof duration == 'number' ? duration + 'ms' : duration;
    // enable transition styles
    this.css({
      transitionProperty: transitionProps,
      transitionDuration: duration,
      transitionDelay: this.staggerDelay || 0
    });
    // listen for transition end event
    this.element.addEventListener(transitionEndEvent, this, false);
  };

  // ----- events ----- //

  proto.onwebkitTransitionEnd = function (event) {
    this.ontransitionend(event);
  };
  proto.onotransitionend = function (event) {
    this.ontransitionend(event);
  };

  // properties that I munge to make my life easier
  var dashedVendorProperties = {
    '-webkit-transform': 'transform'
  };
  proto.ontransitionend = function (event) {
    // disregard bubbled events from children
    if (event.target !== this.element) {
      return;
    }
    var _transition = this._transn;
    // get property name of transitioned property, convert to prefix-free
    var propertyName = dashedVendorProperties[event.propertyName] || event.propertyName;

    // remove property that has completed transitioning
    delete _transition.ingProperties[propertyName];
    // check if any properties are still transitioning
    if (isEmptyObj(_transition.ingProperties)) {
      // all properties have completed transitioning
      this.disableTransition();
    }
    // clean style
    if (propertyName in _transition.clean) {
      // clean up style
      this.element.style[event.propertyName] = '';
      delete _transition.clean[propertyName];
    }
    // trigger onTransitionEnd callback
    if (propertyName in _transition.onEnd) {
      var onTransitionEnd = _transition.onEnd[propertyName];
      onTransitionEnd.call(this);
      delete _transition.onEnd[propertyName];
    }
    this.emitEvent('transitionEnd', [this]);
  };
  proto.disableTransition = function () {
    this.removeTransitionStyles();
    this.element.removeEventListener(transitionEndEvent, this, false);
    this.isTransitioning = false;
  };

  /**
   * removes style property from element
   * @param {Object} style
  **/
  proto._removeStyles = function (style) {
    // clean up transition styles
    var cleanStyle = {};
    for (var prop in style) {
      cleanStyle[prop] = '';
    }
    this.css(cleanStyle);
  };
  var cleanTransitionStyle = {
    transitionProperty: '',
    transitionDuration: '',
    transitionDelay: ''
  };
  proto.removeTransitionStyles = function () {
    // remove transition
    this.css(cleanTransitionStyle);
  };

  // ----- stagger ----- //

  proto.stagger = function (delay) {
    delay = isNaN(delay) ? 0 : delay;
    this.staggerDelay = delay + 'ms';
  };

  // ----- show/hide/remove ----- //

  // remove element from DOM
  proto.removeElem = function () {
    this.element.parentNode.removeChild(this.element);
    // remove display: none
    this.css({
      display: ''
    });
    this.emitEvent('remove', [this]);
  };
  proto.remove = function () {
    // just remove element if no transition support or no transition
    if (!transitionProperty || !parseFloat(this.layout.options.transitionDuration)) {
      this.removeElem();
      return;
    }

    // start transition
    this.once('transitionEnd', function () {
      this.removeElem();
    });
    this.hide();
  };
  proto.reveal = function () {
    delete this.isHidden;
    // remove display: none
    this.css({
      display: ''
    });
    var options = this.layout.options;
    var onTransitionEnd = {};
    var transitionEndProperty = this.getHideRevealTransitionEndProperty('visibleStyle');
    onTransitionEnd[transitionEndProperty] = this.onRevealTransitionEnd;
    this.transition({
      from: options.hiddenStyle,
      to: options.visibleStyle,
      isCleaning: true,
      onTransitionEnd: onTransitionEnd
    });
  };
  proto.onRevealTransitionEnd = function () {
    // check if still visible
    // during transition, item may have been hidden
    if (!this.isHidden) {
      this.emitEvent('reveal');
    }
  };

  /**
   * get style property use for hide/reveal transition end
   * @param {String} styleProperty - hiddenStyle/visibleStyle
   * @returns {String}
   */
  proto.getHideRevealTransitionEndProperty = function (styleProperty) {
    var optionStyle = this.layout.options[styleProperty];
    // use opacity
    if (optionStyle.opacity) {
      return 'opacity';
    }
    // get first property
    for (var prop in optionStyle) {
      return prop;
    }
  };
  proto.hide = function () {
    // set flag
    this.isHidden = true;
    // remove display: none
    this.css({
      display: ''
    });
    var options = this.layout.options;
    var onTransitionEnd = {};
    var transitionEndProperty = this.getHideRevealTransitionEndProperty('hiddenStyle');
    onTransitionEnd[transitionEndProperty] = this.onHideTransitionEnd;
    this.transition({
      from: options.visibleStyle,
      to: options.hiddenStyle,
      // keep hidden stuff hidden
      isCleaning: true,
      onTransitionEnd: onTransitionEnd
    });
  };
  proto.onHideTransitionEnd = function () {
    // check if still hidden
    // during transition, item may have been un-hidden
    if (this.isHidden) {
      this.css({
        display: 'none'
      });
      this.emitEvent('hide');
    }
  };
  proto.destroy = function () {
    this.css({
      position: '',
      left: '',
      right: '',
      top: '',
      bottom: '',
      transition: '',
      transform: ''
    });
  };
  return Item;
});

/*!
 * Outlayer v2.1.1
 * the brains and guts of a layout library
 * MIT license
 */

(function (window, factory) {
  'use strict';

  // universal module definition
  /* jshint strict: false */ /* globals define, module, require */
  if (typeof define == 'function' && define.amd) {
    // AMD - RequireJS
    define('outlayer/outlayer', ['ev-emitter/ev-emitter', 'get-size/get-size', 'fizzy-ui-utils/utils', './item'], function (EvEmitter, getSize, utils, Item) {
      return factory(window, EvEmitter, getSize, utils, Item);
    });
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS - Browserify, Webpack
    module.exports = factory(window, require('ev-emitter'), require('get-size'), require('fizzy-ui-utils'), require('./item'));
  } else {
    // browser global
    window.Outlayer = factory(window, window.EvEmitter, window.getSize, window.fizzyUIUtils, window.Outlayer.Item);
  }
})(window, function factory(window, EvEmitter, getSize, utils, Item) {
  'use strict';

  // ----- vars ----- //
  var console = window.console;
  var jQuery = window.jQuery;
  var noop = function noop() {};

  // -------------------------- Outlayer -------------------------- //

  // globally unique identifiers
  var GUID = 0;
  // internal store of all Outlayer intances
  var instances = {};

  /**
   * @param {Element, String} element
   * @param {Object} options
   * @constructor
   */
  function Outlayer(element, options) {
    var queryElement = utils.getQueryElement(element);
    if (!queryElement) {
      if (console) {
        console.error('Bad element for ' + this.constructor.namespace + ': ' + (queryElement || element));
      }
      return;
    }
    this.element = queryElement;
    // add jQuery
    if (jQuery) {
      this.$element = jQuery(this.element);
    }

    // options
    this.options = utils.extend({}, this.constructor.defaults);
    this.option(options);

    // add id for Outlayer.getFromElement
    var id = ++GUID;
    this.element.outlayerGUID = id; // expando
    instances[id] = this; // associate via id

    // kick it off
    this._create();
    var isInitLayout = this._getOption('initLayout');
    if (isInitLayout) {
      this.layout();
    }
  }

  // settings are for internal use only
  Outlayer.namespace = 'outlayer';
  Outlayer.Item = Item;

  // default options
  Outlayer.defaults = {
    containerStyle: {
      position: 'relative'
    },
    initLayout: true,
    originLeft: true,
    originTop: true,
    resize: true,
    resizeContainer: true,
    // item options
    transitionDuration: '0.4s',
    hiddenStyle: {
      opacity: 0,
      transform: 'scale(0.001)'
    },
    visibleStyle: {
      opacity: 1,
      transform: 'scale(1)'
    }
  };
  var proto = Outlayer.prototype;
  // inherit EvEmitter
  utils.extend(proto, EvEmitter.prototype);

  /**
   * set options
   * @param {Object} opts
   */
  proto.option = function (opts) {
    utils.extend(this.options, opts);
  };

  /**
   * get backwards compatible option value, check old name
   */
  proto._getOption = function (option) {
    var oldOption = this.constructor.compatOptions[option];
    return oldOption && this.options[oldOption] !== undefined ? this.options[oldOption] : this.options[option];
  };
  Outlayer.compatOptions = {
    // currentName: oldName
    initLayout: 'isInitLayout',
    horizontal: 'isHorizontal',
    layoutInstant: 'isLayoutInstant',
    originLeft: 'isOriginLeft',
    originTop: 'isOriginTop',
    resize: 'isResizeBound',
    resizeContainer: 'isResizingContainer'
  };
  proto._create = function () {
    // get items from children
    this.reloadItems();
    // elements that affect layout, but are not laid out
    this.stamps = [];
    this.stamp(this.options.stamp);
    // set container style
    utils.extend(this.element.style, this.options.containerStyle);

    // bind resize method
    var canBindResize = this._getOption('resize');
    if (canBindResize) {
      this.bindResize();
    }
  };

  // goes through all children again and gets bricks in proper order
  proto.reloadItems = function () {
    // collection of item elements
    this.items = this._itemize(this.element.children);
  };

  /**
   * turn elements into Outlayer.Items to be used in layout
   * @param {Array or NodeList or HTMLElement} elems
   * @returns {Array} items - collection of new Outlayer Items
   */
  proto._itemize = function (elems) {
    var itemElems = this._filterFindItemElements(elems);
    var Item = this.constructor.Item;

    // create new Outlayer Items for collection
    var items = [];
    for (var i = 0; i < itemElems.length; i++) {
      var elem = itemElems[i];
      var item = new Item(elem, this);
      items.push(item);
    }
    return items;
  };

  /**
   * get item elements to be used in layout
   * @param {Array or NodeList or HTMLElement} elems
   * @returns {Array} items - item elements
   */
  proto._filterFindItemElements = function (elems) {
    return utils.filterFindElements(elems, this.options.itemSelector);
  };

  /**
   * getter method for getting item elements
   * @returns {Array} elems - collection of item elements
   */
  proto.getItemElements = function () {
    return this.items.map(function (item) {
      return item.element;
    });
  };

  // ----- init & layout ----- //

  /**
   * lays out all items
   */
  proto.layout = function () {
    this._resetLayout();
    this._manageStamps();

    // don't animate first layout
    var layoutInstant = this._getOption('layoutInstant');
    var isInstant = layoutInstant !== undefined ? layoutInstant : !this._isLayoutInited;
    this.layoutItems(this.items, isInstant);

    // flag for initalized
    this._isLayoutInited = true;
  };

  // _init is alias for layout
  proto._init = proto.layout;

  /**
   * logic before any new layout
   */
  proto._resetLayout = function () {
    this.getSize();
  };
  proto.getSize = function () {
    this.size = getSize(this.element);
  };

  /**
   * get measurement from option, for columnWidth, rowHeight, gutter
   * if option is String -> get element from selector string, & get size of element
   * if option is Element -> get size of element
   * else use option as a number
   *
   * @param {String} measurement
   * @param {String} size - width or height
   * @private
   */
  proto._getMeasurement = function (measurement, size) {
    var option = this.options[measurement];
    var elem;
    if (!option) {
      // default to 0
      this[measurement] = 0;
    } else {
      // use option as an element
      if (typeof option == 'string') {
        elem = this.element.querySelector(option);
      } else if (option instanceof HTMLElement) {
        elem = option;
      }
      // use size of element, if element
      this[measurement] = elem ? getSize(elem)[size] : option;
    }
  };

  /**
   * layout a collection of item elements
   * @api public
   */
  proto.layoutItems = function (items, isInstant) {
    items = this._getItemsForLayout(items);
    this._layoutItems(items, isInstant);
    this._postLayout();
  };

  /**
   * get the items to be laid out
   * you may want to skip over some items
   * @param {Array} items
   * @returns {Array} items
   */
  proto._getItemsForLayout = function (items) {
    return items.filter(function (item) {
      return !item.isIgnored;
    });
  };

  /**
   * layout items
   * @param {Array} items
   * @param {Boolean} isInstant
   */
  proto._layoutItems = function (items, isInstant) {
    this._emitCompleteOnItems('layout', items);
    if (!items || !items.length) {
      // no items, emit event with empty array
      return;
    }
    var queue = [];
    items.forEach(function (item) {
      // get x/y object from method
      var position = this._getItemLayoutPosition(item);
      // enqueue
      position.item = item;
      position.isInstant = isInstant || item.isLayoutInstant;
      queue.push(position);
    }, this);
    this._processLayoutQueue(queue);
  };

  /**
   * get item layout position
   * @param {Outlayer.Item} item
   * @returns {Object} x and y position
   */
  proto._getItemLayoutPosition = function /* item */
  () {
    return {
      x: 0,
      y: 0
    };
  };

  /**
   * iterate over array and position each item
   * Reason being - separating this logic prevents 'layout invalidation'
   * thx @paul_irish
   * @param {Array} queue
   */
  proto._processLayoutQueue = function (queue) {
    this.updateStagger();
    queue.forEach(function (obj, i) {
      this._positionItem(obj.item, obj.x, obj.y, obj.isInstant, i);
    }, this);
  };

  // set stagger from option in milliseconds number
  proto.updateStagger = function () {
    var stagger = this.options.stagger;
    if (stagger === null || stagger === undefined) {
      this.stagger = 0;
      return;
    }
    this.stagger = getMilliseconds(stagger);
    return this.stagger;
  };

  /**
   * Sets position of item in DOM
   * @param {Outlayer.Item} item
   * @param {Number} x - horizontal position
   * @param {Number} y - vertical position
   * @param {Boolean} isInstant - disables transitions
   */
  proto._positionItem = function (item, x, y, isInstant, i) {
    if (isInstant) {
      // if not transition, just set CSS
      item.goTo(x, y);
    } else {
      item.stagger(i * this.stagger);
      item.moveTo(x, y);
    }
  };

  /**
   * Any logic you want to do after each layout,
   * i.e. size the container
   */
  proto._postLayout = function () {
    this.resizeContainer();
  };
  proto.resizeContainer = function () {
    var isResizingContainer = this._getOption('resizeContainer');
    if (!isResizingContainer) {
      return;
    }
    var size = this._getContainerSize();
    if (size) {
      this._setContainerMeasure(size.width, true);
      this._setContainerMeasure(size.height, false);
    }
  };

  /**
   * Sets width or height of container if returned
   * @returns {Object} size
   *   @param {Number} width
   *   @param {Number} height
   */
  proto._getContainerSize = noop;

  /**
   * @param {Number} measure - size of width or height
   * @param {Boolean} isWidth
   */
  proto._setContainerMeasure = function (measure, isWidth) {
    if (measure === undefined) {
      return;
    }
    var elemSize = this.size;
    // add padding and border width if border box
    if (elemSize.isBorderBox) {
      measure += isWidth ? elemSize.paddingLeft + elemSize.paddingRight + elemSize.borderLeftWidth + elemSize.borderRightWidth : elemSize.paddingBottom + elemSize.paddingTop + elemSize.borderTopWidth + elemSize.borderBottomWidth;
    }
    measure = Math.max(measure, 0);
    this.element.style[isWidth ? 'width' : 'height'] = measure + 'px';
  };

  /**
   * emit eventComplete on a collection of items events
   * @param {String} eventName
   * @param {Array} items - Outlayer.Items
   */
  proto._emitCompleteOnItems = function (eventName, items) {
    var _this = this;
    function onComplete() {
      _this.dispatchEvent(eventName + 'Complete', null, [items]);
    }
    var count = items.length;
    if (!items || !count) {
      onComplete();
      return;
    }
    var doneCount = 0;
    function tick() {
      doneCount++;
      if (doneCount == count) {
        onComplete();
      }
    }

    // bind callback
    items.forEach(function (item) {
      item.once(eventName, tick);
    });
  };

  /**
   * emits events via EvEmitter and jQuery events
   * @param {String} type - name of event
   * @param {Event} event - original event
   * @param {Array} args - extra arguments
   */
  proto.dispatchEvent = function (type, event, args) {
    // add original event to arguments
    var emitArgs = event ? [event].concat(args) : args;
    this.emitEvent(type, emitArgs);
    if (jQuery) {
      // set this.$element
      this.$element = this.$element || jQuery(this.element);
      if (event) {
        // create jQuery event
        var $event = jQuery.Event(event);
        $event.type = type;
        this.$element.trigger($event, args);
      } else {
        // just trigger with type if no event available
        this.$element.trigger(type, args);
      }
    }
  };

  // -------------------------- ignore & stamps -------------------------- //

  /**
   * keep item in collection, but do not lay it out
   * ignored items do not get skipped in layout
   * @param {Element} elem
   */
  proto.ignore = function (elem) {
    var item = this.getItem(elem);
    if (item) {
      item.isIgnored = true;
    }
  };

  /**
   * return item to layout collection
   * @param {Element} elem
   */
  proto.unignore = function (elem) {
    var item = this.getItem(elem);
    if (item) {
      delete item.isIgnored;
    }
  };

  /**
   * adds elements to stamps
   * @param {NodeList, Array, Element, or String} elems
   */
  proto.stamp = function (elems) {
    elems = this._find(elems);
    if (!elems) {
      return;
    }
    this.stamps = this.stamps.concat(elems);
    // ignore
    elems.forEach(this.ignore, this);
  };

  /**
   * removes elements to stamps
   * @param {NodeList, Array, or Element} elems
   */
  proto.unstamp = function (elems) {
    elems = this._find(elems);
    if (!elems) {
      return;
    }
    elems.forEach(function (elem) {
      // filter out removed stamp elements
      utils.removeFrom(this.stamps, elem);
      this.unignore(elem);
    }, this);
  };

  /**
   * finds child elements
   * @param {NodeList, Array, Element, or String} elems
   * @returns {Array} elems
   */
  proto._find = function (elems) {
    if (!elems) {
      return;
    }
    // if string, use argument as selector string
    if (typeof elems == 'string') {
      elems = this.element.querySelectorAll(elems);
    }
    elems = utils.makeArray(elems);
    return elems;
  };
  proto._manageStamps = function () {
    if (!this.stamps || !this.stamps.length) {
      return;
    }
    this._getBoundingRect();
    this.stamps.forEach(this._manageStamp, this);
  };

  // update boundingLeft / Top
  proto._getBoundingRect = function () {
    // get bounding rect for container element
    var boundingRect = this.element.getBoundingClientRect();
    var size = this.size;
    this._boundingRect = {
      left: boundingRect.left + size.paddingLeft + size.borderLeftWidth,
      top: boundingRect.top + size.paddingTop + size.borderTopWidth,
      right: boundingRect.right - (size.paddingRight + size.borderRightWidth),
      bottom: boundingRect.bottom - (size.paddingBottom + size.borderBottomWidth)
    };
  };

  /**
   * @param {Element} stamp
  **/
  proto._manageStamp = noop;

  /**
   * get x/y position of element relative to container element
   * @param {Element} elem
   * @returns {Object} offset - has left, top, right, bottom
   */
  proto._getElementOffset = function (elem) {
    var boundingRect = elem.getBoundingClientRect();
    var thisRect = this._boundingRect;
    var size = getSize(elem);
    var offset = {
      left: boundingRect.left - thisRect.left - size.marginLeft,
      top: boundingRect.top - thisRect.top - size.marginTop,
      right: thisRect.right - boundingRect.right - size.marginRight,
      bottom: thisRect.bottom - boundingRect.bottom - size.marginBottom
    };
    return offset;
  };

  // -------------------------- resize -------------------------- //

  // enable event handlers for listeners
  // i.e. resize -> onresize
  proto.handleEvent = utils.handleEvent;

  /**
   * Bind layout to window resizing
   */
  proto.bindResize = function () {
    window.addEventListener('resize', this);
    this.isResizeBound = true;
  };

  /**
   * Unbind layout to window resizing
   */
  proto.unbindResize = function () {
    window.removeEventListener('resize', this);
    this.isResizeBound = false;
  };
  proto.onresize = function () {
    this.resize();
  };
  utils.debounceMethod(Outlayer, 'onresize', 100);
  proto.resize = function () {
    // don't trigger if size did not change
    // or if resize was unbound. See #9
    if (!this.isResizeBound || !this.needsResizeLayout()) {
      return;
    }
    this.layout();
  };

  /**
   * check if layout is needed post layout
   * @returns Boolean
   */
  proto.needsResizeLayout = function () {
    var size = getSize(this.element);
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var hasSizes = this.size && size;
    return hasSizes && size.innerWidth !== this.size.innerWidth;
  };

  // -------------------------- methods -------------------------- //

  /**
   * add items to Outlayer instance
   * @param {Array or NodeList or Element} elems
   * @returns {Array} items - Outlayer.Items
  **/
  proto.addItems = function (elems) {
    var items = this._itemize(elems);
    // add items to collection
    if (items.length) {
      this.items = this.items.concat(items);
    }
    return items;
  };

  /**
   * Layout newly-appended item elements
   * @param {Array or NodeList or Element} elems
   */
  proto.appended = function (elems) {
    var items = this.addItems(elems);
    if (!items.length) {
      return;
    }
    // layout and reveal just the new items
    this.layoutItems(items, true);
    this.reveal(items);
  };

  /**
   * Layout prepended elements
   * @param {Array or NodeList or Element} elems
   */
  proto.prepended = function (elems) {
    var items = this._itemize(elems);
    if (!items.length) {
      return;
    }
    // add items to beginning of collection
    var previousItems = this.items.slice(0);
    this.items = items.concat(previousItems);
    // start new layout
    this._resetLayout();
    this._manageStamps();
    // layout new stuff without transition
    this.layoutItems(items, true);
    this.reveal(items);
    // layout previous items
    this.layoutItems(previousItems);
  };

  /**
   * reveal a collection of items
   * @param {Array of Outlayer.Items} items
   */
  proto.reveal = function (items) {
    this._emitCompleteOnItems('reveal', items);
    if (!items || !items.length) {
      return;
    }
    var stagger = this.updateStagger();
    items.forEach(function (item, i) {
      item.stagger(i * stagger);
      item.reveal();
    });
  };

  /**
   * hide a collection of items
   * @param {Array of Outlayer.Items} items
   */
  proto.hide = function (items) {
    this._emitCompleteOnItems('hide', items);
    if (!items || !items.length) {
      return;
    }
    var stagger = this.updateStagger();
    items.forEach(function (item, i) {
      item.stagger(i * stagger);
      item.hide();
    });
  };

  /**
   * reveal item elements
   * @param {Array}, {Element}, {NodeList} items
   */
  proto.revealItemElements = function (elems) {
    var items = this.getItems(elems);
    this.reveal(items);
  };

  /**
   * hide item elements
   * @param {Array}, {Element}, {NodeList} items
   */
  proto.hideItemElements = function (elems) {
    var items = this.getItems(elems);
    this.hide(items);
  };

  /**
   * get Outlayer.Item, given an Element
   * @param {Element} elem
   * @param {Function} callback
   * @returns {Outlayer.Item} item
   */
  proto.getItem = function (elem) {
    // loop through items to get the one that matches
    for (var i = 0; i < this.items.length; i++) {
      var item = this.items[i];
      if (item.element == elem) {
        // return item
        return item;
      }
    }
  };

  /**
   * get collection of Outlayer.Items, given Elements
   * @param {Array} elems
   * @returns {Array} items - Outlayer.Items
   */
  proto.getItems = function (elems) {
    elems = utils.makeArray(elems);
    var items = [];
    elems.forEach(function (elem) {
      var item = this.getItem(elem);
      if (item) {
        items.push(item);
      }
    }, this);
    return items;
  };

  /**
   * remove element(s) from instance and DOM
   * @param {Array or NodeList or Element} elems
   */
  proto.remove = function (elems) {
    var removeItems = this.getItems(elems);
    this._emitCompleteOnItems('remove', removeItems);

    // bail if no items to remove
    if (!removeItems || !removeItems.length) {
      return;
    }
    removeItems.forEach(function (item) {
      item.remove();
      // remove item from collection
      utils.removeFrom(this.items, item);
    }, this);
  };

  // ----- destroy ----- //

  // remove and disable Outlayer instance
  proto.destroy = function () {
    // clean up dynamic styles
    var style = this.element.style;
    style.height = '';
    style.position = '';
    style.width = '';
    // destroy items
    this.items.forEach(function (item) {
      item.destroy();
    });
    this.unbindResize();
    var id = this.element.outlayerGUID;
    delete instances[id]; // remove reference to instance by id
    delete this.element.outlayerGUID;
    // remove data for jQuery
    if (jQuery) {
      jQuery.removeData(this.element, this.constructor.namespace);
    }
  };

  // -------------------------- data -------------------------- //

  /**
   * get Outlayer instance from element
   * @param {Element} elem
   * @returns {Outlayer}
   */
  Outlayer.data = function (elem) {
    elem = utils.getQueryElement(elem);
    var id = elem && elem.outlayerGUID;
    return id && instances[id];
  };

  // -------------------------- create Outlayer class -------------------------- //

  /**
   * create a layout class
   * @param {String} namespace
   */
  Outlayer.create = function (namespace, options) {
    // sub-class Outlayer
    var Layout = subclass(Outlayer);
    // apply new options and compatOptions
    Layout.defaults = utils.extend({}, Outlayer.defaults);
    utils.extend(Layout.defaults, options);
    Layout.compatOptions = utils.extend({}, Outlayer.compatOptions);
    Layout.namespace = namespace;
    Layout.data = Outlayer.data;

    // sub-class Item
    Layout.Item = subclass(Item);

    // -------------------------- declarative -------------------------- //

    utils.htmlInit(Layout, namespace);

    // -------------------------- jQuery bridge -------------------------- //

    // make into jQuery plugin
    if (jQuery && jQuery.bridget) {
      jQuery.bridget(namespace, Layout);
    }
    return Layout;
  };
  function subclass(Parent) {
    function SubClass() {
      Parent.apply(this, arguments);
    }
    SubClass.prototype = Object.create(Parent.prototype);
    SubClass.prototype.constructor = SubClass;
    return SubClass;
  }

  // ----- helpers ----- //

  // how many milliseconds are in each unit
  var msUnits = {
    ms: 1,
    s: 1000
  };

  // munge time-like parameter into millisecond number
  // '0.4s' -> 40
  function getMilliseconds(time) {
    if (typeof time == 'number') {
      return time;
    }
    var matches = time.match(/(^\d*\.?\d*)(\w*)/);
    var num = matches && matches[1];
    var unit = matches && matches[2];
    if (!num.length) {
      return 0;
    }
    num = parseFloat(num);
    var mult = msUnits[unit] || 1;
    return num * mult;
  }

  // ----- fin ----- //

  // back in global
  Outlayer.Item = Item;
  return Outlayer;
});

/*!
 * Masonry v4.2.2
 * Cascading grid layout library
 * https://masonry.desandro.com
 * MIT License
 * by David DeSandro
 */

(function (window, factory) {
  // universal module definition
  /* jshint strict: false */ /*globals define, module, require */
  if (typeof define == 'function' && define.amd) {
    // AMD
    define(['outlayer/outlayer', 'get-size/get-size'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module.exports) {
    // CommonJS
    module.exports = factory(require('outlayer'), require('get-size'));
  } else {
    // browser global
    window.Masonry = factory(window.Outlayer, window.getSize);
  }
})(window, function factory(Outlayer, getSize) {
  // -------------------------- masonryDefinition -------------------------- //

  // create an Outlayer layout class
  var Masonry = Outlayer.create('masonry');
  // isFitWidth -> fitWidth
  Masonry.compatOptions.fitWidth = 'isFitWidth';
  var proto = Masonry.prototype;
  proto._resetLayout = function () {
    this.getSize();
    this._getMeasurement('columnWidth', 'outerWidth');
    this._getMeasurement('gutter', 'outerWidth');
    this.measureColumns();

    // reset column Y
    this.colYs = [];
    for (var i = 0; i < this.cols; i++) {
      this.colYs.push(0);
    }
    this.maxY = 0;
    this.horizontalColIndex = 0;
  };
  proto.measureColumns = function () {
    this.getContainerWidth();
    // if columnWidth is 0, default to outerWidth of first item
    if (!this.columnWidth) {
      var firstItem = this.items[0];
      var firstItemElem = firstItem && firstItem.element;
      // columnWidth fall back to item of first element
      this.columnWidth = firstItemElem && getSize(firstItemElem).outerWidth ||
      // if first elem has no width, default to size of container
      this.containerWidth;
    }
    var columnWidth = this.columnWidth += this.gutter;

    // calculate columns
    var containerWidth = this.containerWidth + this.gutter;
    var cols = containerWidth / columnWidth;
    // fix rounding errors, typically with gutters
    var excess = columnWidth - containerWidth % columnWidth;
    // if overshoot is less than a pixel, round up, otherwise floor it
    var mathMethod = excess && excess < 1 ? 'round' : 'floor';
    cols = Math[mathMethod](cols);
    this.cols = Math.max(cols, 1);
  };
  proto.getContainerWidth = function () {
    // container is parent if fit width
    var isFitWidth = this._getOption('fitWidth');
    var container = isFitWidth ? this.element.parentNode : this.element;
    // check that this.size and size are there
    // IE8 triggers resize on body size change, so they might not be
    var size = getSize(container);
    this.containerWidth = size && size.innerWidth;
  };
  proto._getItemLayoutPosition = function (item) {
    item.getSize();
    // how many columns does this brick span
    var remainder = item.size.outerWidth % this.columnWidth;
    var mathMethod = remainder && remainder < 1 ? 'round' : 'ceil';
    // round if off by 1 pixel, otherwise use ceil
    var colSpan = Math[mathMethod](item.size.outerWidth / this.columnWidth);
    colSpan = Math.min(colSpan, this.cols);
    // use horizontal or top column position
    var colPosMethod = this.options.horizontalOrder ? '_getHorizontalColPosition' : '_getTopColPosition';
    var colPosition = this[colPosMethod](colSpan, item);
    // position the brick
    var position = {
      x: this.columnWidth * colPosition.col,
      y: colPosition.y
    };
    // apply setHeight to necessary columns
    var setHeight = colPosition.y + item.size.outerHeight;
    var setMax = colSpan + colPosition.col;
    for (var i = colPosition.col; i < setMax; i++) {
      this.colYs[i] = setHeight;
    }
    return position;
  };
  proto._getTopColPosition = function (colSpan) {
    var colGroup = this._getTopColGroup(colSpan);
    // get the minimum Y value from the columns
    var minimumY = Math.min.apply(Math, colGroup);
    return {
      col: colGroup.indexOf(minimumY),
      y: minimumY
    };
  };

  /**
   * @param {Number} colSpan - number of columns the element spans
   * @returns {Array} colGroup
   */
  proto._getTopColGroup = function (colSpan) {
    if (colSpan < 2) {
      // if brick spans only one column, use all the column Ys
      return this.colYs;
    }
    var colGroup = [];
    // how many different places could this brick fit horizontally
    var groupCount = this.cols + 1 - colSpan;
    // for each group potential horizontal position
    for (var i = 0; i < groupCount; i++) {
      colGroup[i] = this._getColGroupY(i, colSpan);
    }
    return colGroup;
  };
  proto._getColGroupY = function (col, colSpan) {
    if (colSpan < 2) {
      return this.colYs[col];
    }
    // make an array of colY values for that one group
    var groupColYs = this.colYs.slice(col, col + colSpan);
    // and get the max value of the array
    return Math.max.apply(Math, groupColYs);
  };

  // get column position based on horizontal index. #873
  proto._getHorizontalColPosition = function (colSpan, item) {
    var col = this.horizontalColIndex % this.cols;
    var isOver = colSpan > 1 && col + colSpan > this.cols;
    // shift to next row if item can't fit on current row
    col = isOver ? 0 : col;
    // don't let zero-size items take up space
    var hasSize = item.size.outerWidth && item.size.outerHeight;
    this.horizontalColIndex = hasSize ? col + colSpan : this.horizontalColIndex;
    return {
      col: col,
      y: this._getColGroupY(col, colSpan)
    };
  };
  proto._manageStamp = function (stamp) {
    var stampSize = getSize(stamp);
    var offset = this._getElementOffset(stamp);
    // get the columns that this stamp affects
    var isOriginLeft = this._getOption('originLeft');
    var firstX = isOriginLeft ? offset.left : offset.right;
    var lastX = firstX + stampSize.outerWidth;
    var firstCol = Math.floor(firstX / this.columnWidth);
    firstCol = Math.max(0, firstCol);
    var lastCol = Math.floor(lastX / this.columnWidth);
    // lastCol should not go over if multiple of columnWidth #425
    lastCol -= lastX % this.columnWidth ? 0 : 1;
    lastCol = Math.min(this.cols - 1, lastCol);
    // set colYs to bottom of the stamp

    var isOriginTop = this._getOption('originTop');
    var stampMaxY = (isOriginTop ? offset.top : offset.bottom) + stampSize.outerHeight;
    for (var i = firstCol; i <= lastCol; i++) {
      this.colYs[i] = Math.max(stampMaxY, this.colYs[i]);
    }
  };
  proto._getContainerSize = function () {
    this.maxY = Math.max.apply(Math, this.colYs);
    var size = {
      height: this.maxY
    };
    if (this._getOption('fitWidth')) {
      size.width = this._getContainerFitWidth();
    }
    return size;
  };
  proto._getContainerFitWidth = function () {
    var unusedCols = 0;
    // count unused columns
    var i = this.cols;
    while (--i) {
      if (this.colYs[i] !== 0) {
        break;
      }
      unusedCols++;
    }
    // fit container to columns that have been used
    return (this.cols - unusedCols) * this.columnWidth - this.gutter;
  };
  proto.needsResizeLayout = function () {
    var previousWidth = this.containerWidth;
    this.getContainerWidth();
    return previousWidth != this.containerWidth;
  };
  return Masonry;
});
(function () {
  'use strict';

  angular.module('toastr', []).factory('toastr', toastr);
  toastr.$inject = ['$animate', '$injector', '$document', '$rootScope', '$sce', 'toastrConfig', '$q'];
  function toastr($animate, $injector, $document, $rootScope, $sce, toastrConfig, $q) {
    var container;
    var index = 0;
    var toasts = [];
    var previousToastMessage = '';
    var openToasts = {};
    var containerDefer = $q.defer();
    var toast = {
      active: active,
      clear: clear,
      error: error,
      info: info,
      remove: remove,
      success: success,
      warning: warning,
      refreshTimer: refreshTimer
    };
    return toast;

    /* Public API */
    function active() {
      return toasts.length;
    }
    function clear(toast) {
      // Bit of a hack, I will remove this soon with a BC
      if (arguments.length === 1 && !toast) {
        return;
      }
      if (toast) {
        remove(toast.toastId);
      } else {
        for (var i = 0; i < toasts.length; i++) {
          remove(toasts[i].toastId);
        }
      }
    }
    function error(message, title, optionsOverride) {
      var type = _getOptions().iconClasses.error;
      return _buildNotification(type, message, title, optionsOverride);
    }
    function info(message, title, optionsOverride) {
      var type = _getOptions().iconClasses.info;
      return _buildNotification(type, message, title, optionsOverride);
    }
    function success(message, title, optionsOverride) {
      var type = _getOptions().iconClasses.success;
      return _buildNotification(type, message, title, optionsOverride);
    }
    function warning(message, title, optionsOverride) {
      var type = _getOptions().iconClasses.warning;
      return _buildNotification(type, message, title, optionsOverride);
    }
    function refreshTimer(toast, newTime) {
      if (toast && toast.isOpened && toasts.indexOf(toast) >= 0) {
        toast.scope.refreshTimer(newTime);
      }
    }
    function remove(toastId, wasClicked) {
      var toast = findToast(toastId);
      if (toast && !toast.deleting) {
        // Avoid clicking when fading out
        toast.deleting = true;
        toast.isOpened = false;
        $animate.leave(toast.el).then(function () {
          if (toast.scope.options.onHidden) {
            toast.scope.options.onHidden(!!wasClicked, toast);
          }
          toast.scope.$destroy();
          var index = toasts.indexOf(toast);
          delete openToasts[toast.scope.message];
          toasts.splice(index, 1);
          var maxOpened = toastrConfig.maxOpened;
          if (maxOpened && toasts.length >= maxOpened) {
            toasts[maxOpened - 1].open.resolve();
          }
          if (lastToast()) {
            container.remove();
            container = null;
            containerDefer = $q.defer();
          }
        });
      }
      function findToast(toastId) {
        for (var i = 0; i < toasts.length; i++) {
          if (toasts[i].toastId === toastId) {
            return toasts[i];
          }
        }
      }
      function lastToast() {
        return !toasts.length;
      }
    }

    /* Internal functions */
    function _buildNotification(type, message, title, optionsOverride) {
      if (angular.isObject(title)) {
        optionsOverride = title;
        title = null;
      }
      return _notify({
        iconClass: type,
        message: message,
        optionsOverride: optionsOverride,
        title: title
      });
    }
    function _getOptions() {
      return angular.extend({}, toastrConfig);
    }
    function _createOrGetContainer(options) {
      if (container) {
        return containerDefer.promise;
      }
      container = angular.element('<div></div>');
      container.attr('id', options.containerId);
      container.addClass(options.positionClass);
      container.css({
        'pointer-events': 'auto'
      });
      var target = angular.element(document.querySelector(options.target));
      if (!target || !target.length) {
        throw 'Target for toasts doesn\'t exist';
      }
      $animate.enter(container, target).then(function () {
        containerDefer.resolve();
      });
      return containerDefer.promise;
    }
    function _notify(map) {
      var options = _getOptions();
      if (shouldExit()) {
        return;
      }
      var newToast = createToast();
      toasts.push(newToast);
      if (ifMaxOpenedAndAutoDismiss()) {
        var oldToasts = toasts.slice(0, toasts.length - options.maxOpened);
        for (var i = 0, len = oldToasts.length; i < len; i++) {
          remove(oldToasts[i].toastId);
        }
      }
      if (maxOpenedNotReached()) {
        newToast.open.resolve();
      }
      newToast.open.promise.then(function () {
        _createOrGetContainer(options).then(function () {
          newToast.isOpened = true;
          if (options.newestOnTop) {
            $animate.enter(newToast.el, container).then(function () {
              newToast.scope.init();
            });
          } else {
            var sibling = container[0].lastChild ? angular.element(container[0].lastChild) : null;
            $animate.enter(newToast.el, container, sibling).then(function () {
              newToast.scope.init();
            });
          }
        });
      });
      return newToast;
      function ifMaxOpenedAndAutoDismiss() {
        return options.autoDismiss && options.maxOpened && toasts.length > options.maxOpened;
      }
      function createScope(toast, map, options) {
        if (options.allowHtml) {
          toast.scope.allowHtml = true;
          toast.scope.title = $sce.trustAsHtml(map.title);
          toast.scope.message = $sce.trustAsHtml(map.message);
        } else {
          toast.scope.title = map.title;
          toast.scope.message = map.message;
        }
        toast.scope.toastType = toast.iconClass;
        toast.scope.toastId = toast.toastId;
        toast.scope.extraData = options.extraData;
        toast.scope.options = {
          extendedTimeOut: options.extendedTimeOut,
          messageClass: options.messageClass,
          onHidden: options.onHidden,
          onShown: generateEvent('onShown'),
          onTap: generateEvent('onTap'),
          progressBar: options.progressBar,
          tapToDismiss: options.tapToDismiss,
          timeOut: options.timeOut,
          titleClass: options.titleClass,
          toastClass: options.toastClass
        };
        if (options.closeButton) {
          toast.scope.options.closeHtml = options.closeHtml;
        }
        function generateEvent(event) {
          if (options[event]) {
            return function () {
              options[event](toast);
            };
          }
        }
      }
      function createToast() {
        var newToast = {
          toastId: index++,
          isOpened: false,
          scope: $rootScope.$new(),
          open: $q.defer()
        };
        newToast.iconClass = map.iconClass;
        if (map.optionsOverride) {
          angular.extend(options, cleanOptionsOverride(map.optionsOverride));
          newToast.iconClass = map.optionsOverride.iconClass || newToast.iconClass;
        }
        createScope(newToast, map, options);
        newToast.el = createToastEl(newToast.scope);
        return newToast;
        function cleanOptionsOverride(options) {
          var badOptions = ['containerId', 'iconClasses', 'maxOpened', 'newestOnTop', 'positionClass', 'preventDuplicates', 'preventOpenDuplicates', 'templates'];
          for (var i = 0, l = badOptions.length; i < l; i++) {
            delete options[badOptions[i]];
          }
          return options;
        }
      }
      function createToastEl(scope) {
        var angularDomEl = angular.element('<div toast></div>'),
          $compile = $injector.get('$compile');
        return $compile(angularDomEl)(scope);
      }
      function maxOpenedNotReached() {
        return options.maxOpened && toasts.length <= options.maxOpened || !options.maxOpened;
      }
      function shouldExit() {
        var isDuplicateOfLast = options.preventDuplicates && map.message === previousToastMessage;
        var isDuplicateOpen = options.preventOpenDuplicates && openToasts[map.message];
        if (isDuplicateOfLast || isDuplicateOpen) {
          return true;
        }
        previousToastMessage = map.message;
        openToasts[map.message] = true;
        return false;
      }
    }
  }
})();
(function () {
  'use strict';

  angular.module('toastr').constant('toastrConfig', {
    allowHtml: false,
    autoDismiss: false,
    closeButton: false,
    closeHtml: '<button>&times;</button>',
    containerId: 'toast-container',
    extendedTimeOut: 1000,
    iconClasses: {
      error: 'toast-error',
      info: 'toast-info',
      success: 'toast-success',
      warning: 'toast-warning'
    },
    maxOpened: 0,
    messageClass: 'toast-message',
    newestOnTop: true,
    onHidden: null,
    onShown: null,
    onTap: null,
    positionClass: 'toast-top-right',
    preventDuplicates: false,
    preventOpenDuplicates: false,
    progressBar: false,
    tapToDismiss: true,
    target: 'body',
    templates: {
      toast: 'directives/toast/toast.html',
      progressbar: 'directives/progressbar/progressbar.html'
    },
    timeOut: 5000,
    titleClass: 'toast-title',
    toastClass: 'toast'
  });
})();
(function () {
  'use strict';

  angular.module('toastr').directive('progressBar', progressBar);
  progressBar.$inject = ['toastrConfig'];
  function progressBar(toastrConfig) {
    return {
      require: '^toast',
      templateUrl: function templateUrl() {
        return toastrConfig.templates.progressbar;
      },
      link: linkFunction
    };
    function linkFunction(scope, element, attrs, toastCtrl) {
      var intervalId, currentTimeOut, hideTime;
      toastCtrl.progressBar = scope;
      scope.start = function (duration) {
        if (intervalId) {
          clearInterval(intervalId);
        }
        currentTimeOut = parseFloat(duration);
        hideTime = new Date().getTime() + currentTimeOut;
        intervalId = setInterval(updateProgress, 10);
      };
      scope.stop = function () {
        if (intervalId) {
          clearInterval(intervalId);
        }
      };
      function updateProgress() {
        var percentage = (hideTime - new Date().getTime()) / currentTimeOut * 100;
        element.css('width', percentage + '%');
      }
      scope.$on('$destroy', function () {
        // Failsafe stop
        clearInterval(intervalId);
      });
    }
  }
})();
(function () {
  'use strict';

  angular.module('toastr').controller('ToastController', ToastController);
  function ToastController() {
    this.progressBar = null;
    this.startProgressBar = function (duration) {
      if (this.progressBar) {
        this.progressBar.start(duration);
      }
    };
    this.stopProgressBar = function () {
      if (this.progressBar) {
        this.progressBar.stop();
      }
    };
  }
})();
(function () {
  'use strict';

  angular.module('toastr').directive('toast', toast);
  toast.$inject = ['$injector', '$interval', 'toastrConfig', 'toastr'];
  function toast($injector, $interval, toastrConfig, toastr) {
    return {
      templateUrl: function templateUrl() {
        return toastrConfig.templates.toast;
      },
      controller: 'ToastController',
      link: toastLinkFunction
    };
    function toastLinkFunction(scope, element, attrs, toastCtrl) {
      var timeout;
      scope.toastClass = scope.options.toastClass;
      scope.titleClass = scope.options.titleClass;
      scope.messageClass = scope.options.messageClass;
      scope.progressBar = scope.options.progressBar;
      if (wantsCloseButton()) {
        var button = angular.element(scope.options.closeHtml),
          $compile = $injector.get('$compile');
        button.addClass('toast-close-button');
        button.attr('ng-click', 'close(true, $event)');
        $compile(button)(scope);
        element.children().prepend(button);
      }
      scope.init = function () {
        if (scope.options.timeOut) {
          timeout = createTimeout(scope.options.timeOut);
        }
        if (scope.options.onShown) {
          scope.options.onShown();
        }
      };
      element.on('mouseenter', function () {
        hideAndStopProgressBar();
        if (timeout) {
          $interval.cancel(timeout);
        }
      });
      scope.tapToast = function () {
        if (angular.isFunction(scope.options.onTap)) {
          scope.options.onTap();
        }
        if (scope.options.tapToDismiss) {
          scope.close(true);
        }
      };
      scope.close = function (wasClicked, $event) {
        if ($event && angular.isFunction($event.stopPropagation)) {
          $event.stopPropagation();
        }
        toastr.remove(scope.toastId, wasClicked);
      };
      scope.refreshTimer = function (newTime) {
        if (timeout) {
          $interval.cancel(timeout);
          timeout = createTimeout(newTime || scope.options.timeOut);
        }
      };
      element.on('mouseleave', function () {
        if (scope.options.timeOut === 0 && scope.options.extendedTimeOut === 0) {
          return;
        }
        scope.$apply(function () {
          scope.progressBar = scope.options.progressBar;
        });
        timeout = createTimeout(scope.options.extendedTimeOut);
      });
      function createTimeout(time) {
        toastCtrl.startProgressBar(time);
        return $interval(function () {
          toastCtrl.stopProgressBar();
          toastr.remove(scope.toastId);
        }, time, 1);
      }
      function hideAndStopProgressBar() {
        scope.progressBar = false;
        toastCtrl.stopProgressBar();
      }
      function wantsCloseButton() {
        return scope.options.closeHtml;
      }
    }
  }
})();
angular.module("toastr").run(["$templateCache", function ($templateCache) {
  $templateCache.put("directives/progressbar/progressbar.html", "<div class=\"toast-progress\"></div>\n");
  $templateCache.put("directives/toast/toast.html", "<div class=\"{{toastClass}} {{toastType}}\" ng-click=\"tapToast()\">\n  <div ng-switch on=\"allowHtml\">\n    <div ng-switch-default ng-if=\"title\" class=\"{{titleClass}}\" aria-label=\"{{title}}\">{{title}}</div>\n    <div ng-switch-default class=\"{{messageClass}}\" aria-label=\"{{message}}\">{{message}}</div>\n    <div ng-switch-when=\"true\" ng-if=\"title\" class=\"{{titleClass}}\" ng-bind-html=\"title\"></div>\n    <div ng-switch-when=\"true\" class=\"{{messageClass}}\" ng-bind-html=\"message\"></div>\n  </div>\n  <progress-bar ng-if=\"progressBar\"></progress-bar>\n</div>\n");
}]);
/*!
 * FooTable - Awesome Responsive Tables
 * Version : 2.0.3
 * http://fooplugins.com/plugins/footable-jquery/
 *
 * Requires jQuery - http://jquery.com/
 *
 * Copyright 2014 Steven Usher & Brad Vincent
 * Released under the MIT license
 * You are free to use FooTable in commercial projects as long as this copyright header is left intact.
 *
 * Date: 11 Nov 2014
 */
(function ($, w, undefined) {
  w.footable = {
    options: {
      delay: 100,
      // The number of millseconds to wait before triggering the react event
      breakpoints: {
        // The different screen resolution breakpoints
        phone: 480,
        tablet: 1024
      },
      parsers: {
        // The default parser to parse the value out of a cell (values are used in building up row detail)
        alpha: function alpha(cell) {
          return $(cell).data('value') || $.trim($(cell).text());
        },
        numeric: function numeric(cell) {
          var val = $(cell).data('value') || $(cell).text().replace(/[^0-9.\-]/g, '');
          val = parseFloat(val);
          if (isNaN(val)) val = 0;
          return val;
        }
      },
      addRowToggle: true,
      calculateWidthOverride: null,
      toggleSelector: ' > tbody > tr:not(.footable-row-detail)',
      //the selector to show/hide the detail row
      columnDataSelector: '> thead > tr:last-child > th, > thead > tr:last-child > td',
      //the selector used to find the column data in the thead
      detailSeparator: ':',
      //the separator character used when building up the detail row
      toggleHTMLElement: '<span />',
      // override this if you want to insert a click target rather than use a background image.
      createGroupedDetail: function createGroupedDetail(data) {
        var groups = {
          '_none': {
            'name': null,
            'data': []
          }
        };
        for (var i = 0; i < data.length; i++) {
          var groupid = data[i].group;
          if (groupid !== null) {
            if (!(groupid in groups)) groups[groupid] = {
              'name': data[i].groupName || data[i].group,
              'data': []
            };
            groups[groupid].data.push(data[i]);
          } else {
            groups._none.data.push(data[i]);
          }
        }
        return groups;
      },
      createDetail: function createDetail(element, data, createGroupedDetail, separatorChar, classes) {
        /// <summary>This function is used by FooTable to generate the detail view seen when expanding a collapsed row.</summary>
        /// <param name="element">This is the div that contains all the detail row information, anything could be added to it.</param>
        /// <param name="data">
        ///  This is an array of objects containing the cell information for the current row.
        ///  These objects look like the below:
        ///    obj = {
        ///      'name': String, // The name of the column
        ///      'value': Object, // The value parsed from the cell using the parsers. This could be a string, a number or whatever the parser outputs.
        ///      'display': String, // This is the actual HTML from the cell, so if you have images etc you want moved this is the one to use and is the default value used.
        ///      'group': String, // This is the identifier used in the data-group attribute of the column.
        ///      'groupName': String // This is the actual name of the group the column belongs to.
        ///    }
        /// </param>
        /// <param name="createGroupedDetail">The grouping function to group the data</param>
        /// <param name="separatorChar">The separator charactor used</param>
        /// <param name="classes">The array of class names used to build up the detail row</param>

        var groups = createGroupedDetail(data);
        for (var group in groups) {
          if (groups[group].data.length === 0) continue;
          if (group !== '_none') element.append('<div class="' + classes.detailInnerGroup + '">' + groups[group].name + '</div>');
          for (var j = 0; j < groups[group].data.length; j++) {
            var separator = groups[group].data[j].name ? separatorChar : '';
            element.append($('<div></div>').addClass(classes.detailInnerRow).append($('<div></div>').addClass(classes.detailInnerName).append(groups[group].data[j].name + separator)).append($('<div></div>').addClass(classes.detailInnerValue).attr('data-bind-value', groups[group].data[j].bindName).append(groups[group].data[j].display)));
          }
        }
      },
      classes: {
        main: 'footable',
        loading: 'footable-loading',
        loaded: 'footable-loaded',
        toggle: 'footable-toggle',
        disabled: 'footable-disabled',
        detail: 'footable-row-detail',
        detailCell: 'footable-row-detail-cell',
        detailInner: 'footable-row-detail-inner',
        detailInnerRow: 'footable-row-detail-row',
        detailInnerGroup: 'footable-row-detail-group',
        detailInnerName: 'footable-row-detail-name',
        detailInnerValue: 'footable-row-detail-value',
        detailShow: 'footable-detail-show'
      },
      triggers: {
        initialize: 'footable_initialize',
        //trigger this event to force FooTable to reinitialize
        resize: 'footable_resize',
        //trigger this event to force FooTable to resize
        redraw: 'footable_redraw',
        //trigger this event to force FooTable to redraw
        toggleRow: 'footable_toggle_row',
        //trigger this event to force FooTable to toggle a row
        expandFirstRow: 'footable_expand_first_row',
        //trigger this event to force FooTable to expand the first row
        expandAll: 'footable_expand_all',
        //trigger this event to force FooTable to expand all rows
        collapseAll: 'footable_collapse_all' //trigger this event to force FooTable to collapse all rows
      },
      events: {
        alreadyInitialized: 'footable_already_initialized',
        //fires when the FooTable has already been initialized
        initializing: 'footable_initializing',
        //fires before FooTable starts initializing
        initialized: 'footable_initialized',
        //fires after FooTable has finished initializing
        resizing: 'footable_resizing',
        //fires before FooTable resizes
        resized: 'footable_resized',
        //fires after FooTable has resized
        redrawn: 'footable_redrawn',
        //fires after FooTable has redrawn
        breakpoint: 'footable_breakpoint',
        //fires inside the resize function, when a breakpoint is hit
        columnData: 'footable_column_data',
        //fires when setting up column data. Plugins should use this event to capture their own info about a column
        rowDetailUpdating: 'footable_row_detail_updating',
        //fires before a detail row is updated
        rowDetailUpdated: 'footable_row_detail_updated',
        //fires when a detail row is being updated
        rowCollapsed: 'footable_row_collapsed',
        //fires when a row is collapsed
        rowExpanded: 'footable_row_expanded',
        //fires when a row is expanded
        rowRemoved: 'footable_row_removed',
        //fires when a row is removed
        reset: 'footable_reset' //fires when FooTable is reset
      },
      debug: false,
      // Whether or not to log information to the console.
      log: null
    },
    version: {
      major: 0,
      minor: 5,
      toString: function toString() {
        return w.footable.version.major + '.' + w.footable.version.minor;
      },
      parse: function parse(str) {
        var version = /(\d+)\.?(\d+)?\.?(\d+)?/.exec(str);
        return {
          major: parseInt(version[1], 10) || 0,
          minor: parseInt(version[2], 10) || 0,
          patch: parseInt(version[3], 10) || 0
        };
      }
    },
    plugins: {
      _validate: function _validate(plugin) {
        ///<summary>Simple validation of the <paramref name="plugin"/> to make sure any members called by FooTable actually exist.</summary>
        ///<param name="plugin">The object defining the plugin, this should implement a string property called "name" and a function called "init".</param>

        if (!$.isFunction(plugin)) {
          if (w.footable.options.debug === true) console.error('Validation failed, expected type "function", received type "{0}".', _typeof(plugin));
          return false;
        }
        var p = new plugin();
        if (typeof p['name'] !== 'string') {
          if (w.footable.options.debug === true) console.error('Validation failed, plugin does not implement a string property called "name".', p);
          return false;
        }
        if (!$.isFunction(p['init'])) {
          if (w.footable.options.debug === true) console.error('Validation failed, plugin "' + p['name'] + '" does not implement a function called "init".', p);
          return false;
        }
        if (w.footable.options.debug === true) console.log('Validation succeeded for plugin "' + p['name'] + '".', p);
        return true;
      },
      registered: [],
      // An array containing all registered plugins.
      register: function register(plugin, options) {
        ///<summary>Registers a <paramref name="plugin"/> and its default <paramref name="options"/> with FooTable.</summary>
        ///<param name="plugin">The plugin that should implement a string property called "name" and a function called "init".</param>
        ///<param name="options">The default options to merge with the FooTable's base options.</param>

        if (w.footable.plugins._validate(plugin)) {
          w.footable.plugins.registered.push(plugin);
          if (_typeof(options) === 'object') $.extend(true, w.footable.options, options);
        }
      },
      load: function load(instance) {
        var loaded = [],
          registered,
          i;
        for (i = 0; i < w.footable.plugins.registered.length; i++) {
          try {
            registered = w.footable.plugins.registered[i];
            loaded.push(new registered(instance));
          } catch (err) {
            if (w.footable.options.debug === true) console.error(err);
          }
        }
        return loaded;
      },
      init: function init(instance) {
        ///<summary>Loops through all registered plugins and calls the "init" method supplying the current <paramref name="instance"/> of the FooTable as the first parameter.</summary>
        ///<param name="instance">The current instance of the FooTable that the plugin is being initialized for.</param>

        for (var i = 0; i < instance.plugins.length; i++) {
          try {
            instance.plugins[i]['init'](instance);
          } catch (err) {
            if (w.footable.options.debug === true) console.error(err);
          }
        }
      }
    }
  };
  var instanceCount = 0;
  $.fn.footable = function (options) {
    ///<summary>The main constructor call to initialize the plugin using the supplied <paramref name="options"/>.</summary>
    ///<param name="options">
    ///<para>A JSON object containing user defined options for the plugin to use. Any options not supplied will have a default value assigned.</para>
    ///<para>Check the documentation or the default options object above for more information on available options.</para>
    ///</param>

    options = options || {};
    var o = $.extend(true, {}, w.footable.options, options); //merge user and default options
    return this.each(function () {
      instanceCount++;
      var footable = new Footable(this, o, instanceCount);
      $(this).data('footable', footable);
    });
  };

  //helper for using timeouts
  function Timer() {
    ///<summary>Simple timer object created around a timeout.</summary>
    var t = this;
    t.id = null;
    t.busy = false;
    t.start = function (code, milliseconds) {
      ///<summary>Starts the timer and waits the specified amount of <paramref name="milliseconds"/> before executing the supplied <paramref name="code"/>.</summary>
      ///<param name="code">The code to execute once the timer runs out.</param>
      ///<param name="milliseconds">The time in milliseconds to wait before executing the supplied <paramref name="code"/>.</param>

      if (t.busy) {
        return;
      }
      t.stop();
      t.id = setTimeout(function () {
        code();
        t.id = null;
        t.busy = false;
      }, milliseconds);
      t.busy = true;
    };
    t.stop = function () {
      ///<summary>Stops the timer if its runnning and resets it back to its starting state.</summary>

      if (t.id !== null) {
        clearTimeout(t.id);
        t.id = null;
        t.busy = false;
      }
    };
  }
  function Footable(t, o, id) {
    ///<summary>Inits a new instance of the plugin.</summary>
    ///<param name="t">The main table element to apply this plugin to.</param>
    ///<param name="o">The options supplied to the plugin. Check the defaults object to see all available options.</param>
    ///<param name="id">The id to assign to this instance of the plugin.</param>

    var ft = this;
    ft.id = id;
    ft.table = t;
    ft.options = o;
    ft.breakpoints = [];
    ft.breakpointNames = '';
    ft.columns = {};
    ft.plugins = w.footable.plugins.load(ft);
    var opt = ft.options,
      cls = opt.classes,
      evt = opt.events,
      trg = opt.triggers,
      indexOffset = 0;

    // This object simply houses all the timers used in the FooTable.
    ft.timers = {
      resize: new Timer(),
      register: function register(name) {
        ft.timers[name] = new Timer();
        return ft.timers[name];
      }
    };
    ft.init = function () {
      var $window = $(w),
        $table = $(ft.table);
      w.footable.plugins.init(ft);
      if ($table.hasClass(cls.loaded)) {
        //already loaded FooTable for the table, so don't init again
        ft.raise(evt.alreadyInitialized);
        return;
      }

      //raise the initializing event
      ft.raise(evt.initializing);
      $table.addClass(cls.loading);

      // Get the column data once for the life time of the plugin
      $table.find(opt.columnDataSelector).each(function () {
        var data = ft.getColumnData(this);
        ft.columns[data.index] = data;
      });

      // Create a nice friendly array to work with out of the breakpoints object.
      for (var name in opt.breakpoints) {
        ft.breakpoints.push({
          'name': name,
          'width': opt.breakpoints[name]
        });
        ft.breakpointNames += name + ' ';
      }

      // Sort the breakpoints so the smallest is checked first
      ft.breakpoints.sort(function (a, b) {
        return a['width'] - b['width'];
      });
      $table.unbind(trg.initialize)
      //bind to FooTable initialize trigger
      .bind(trg.initialize, function () {
        //remove previous "state" (to "force" a resize)
        $table.removeData('footable_info');
        $table.data('breakpoint', '');

        //trigger the FooTable resize
        $table.trigger(trg.resize);

        //remove the loading class
        $table.removeClass(cls.loading);

        //add the FooTable and loaded class
        $table.addClass(cls.loaded).addClass(cls.main);

        //raise the initialized event
        ft.raise(evt.initialized);
      }).unbind(trg.redraw)
      //bind to FooTable redraw trigger
      .bind(trg.redraw, function () {
        ft.redraw();
      }).unbind(trg.resize)
      //bind to FooTable resize trigger
      .bind(trg.resize, function () {
        ft.resize();
      }).unbind(trg.expandFirstRow)
      //bind to FooTable expandFirstRow trigger
      .bind(trg.expandFirstRow, function () {
        $table.find(opt.toggleSelector).first().not('.' + cls.detailShow).trigger(trg.toggleRow);
      }).unbind(trg.expandAll)
      //bind to FooTable expandFirstRow trigger
      .bind(trg.expandAll, function () {
        $table.find(opt.toggleSelector).not('.' + cls.detailShow).trigger(trg.toggleRow);
      }).unbind(trg.collapseAll)
      //bind to FooTable expandFirstRow trigger
      .bind(trg.collapseAll, function () {
        $table.find('.' + cls.detailShow).trigger(trg.toggleRow);
      });

      //trigger a FooTable initialize
      $table.trigger(trg.initialize);

      //bind to window resize
      $window.bind('resize.footable', function () {
        ft.timers.resize.stop();
        ft.timers.resize.start(function () {
          ft.raise(trg.resize);
        }, opt.delay);
      });
    };
    ft.addRowToggle = function () {
      if (!opt.addRowToggle) return;
      var $table = $(ft.table),
        hasToggleColumn = false;

      //first remove all toggle spans
      $table.find('span.' + cls.toggle).remove();
      for (var c in ft.columns) {
        var col = ft.columns[c];
        if (col.toggle) {
          hasToggleColumn = true;
          var selector = '> tbody > tr:not(.' + cls.detail + ',.' + cls.disabled + ') > td:nth-child(' + (parseInt(col.index, 10) + 1) + '),' + '> tbody > tr:not(.' + cls.detail + ',.' + cls.disabled + ') > th:nth-child(' + (parseInt(col.index, 10) + 1) + ')';
          $table.find(selector).not('.' + cls.detailCell).prepend($(opt.toggleHTMLElement).addClass(cls.toggle));
          return;
        }
      }
      //check if we have an toggle column. If not then add it to the first column just to be safe
      if (!hasToggleColumn) {
        $table.find('> tbody > tr:not(.' + cls.detail + ',.' + cls.disabled + ') > td:first-child').add('> tbody > tr:not(.' + cls.detail + ',.' + cls.disabled + ') > th:first-child').not('.' + cls.detailCell).prepend($(opt.toggleHTMLElement).addClass(cls.toggle));
      }
    };
    ft.setColumnClasses = function () {
      var $table = $(ft.table);
      for (var c in ft.columns) {
        var col = ft.columns[c];
        if (col.className !== null) {
          var selector = '',
            first = true;
          $.each(col.matches, function (m, match) {
            //support for colspans
            if (!first) selector += ', ';
            selector += '> tbody > tr:not(.' + cls.detail + ') > td:nth-child(' + (parseInt(match, 10) + 1) + ')';
            first = false;
          });
          //add the className to the cells specified by data-class="blah"
          $table.find(selector).not('.' + cls.detailCell).addClass(col.className);
        }
      }
    };

    //moved this out into it's own function so that it can be called from other add-ons
    ft.bindToggleSelectors = function () {
      var $table = $(ft.table);
      if (!ft.hasAnyBreakpointColumn()) return;
      $table.find(opt.toggleSelector).unbind(trg.toggleRow).bind(trg.toggleRow, function (e) {
        var $row = $(this).is('tr') ? $(this) : $(this).parents('tr:first');
        ft.toggleDetail($row);
      });
      $table.find(opt.toggleSelector).unbind('click.footable').bind('click.footable', function (e) {
        if ($table.is('.breakpoint') && $(e.target).is('td,th,.' + cls.toggle)) {
          $(this).trigger(trg.toggleRow);
        }
      });
    };
    ft.parse = function (cell, column) {
      var parser = opt.parsers[column.type] || opt.parsers.alpha;
      return parser(cell);
    };
    ft.getColumnData = function (th) {
      var $th = $(th),
        hide = $th.data('hide'),
        index = $th.index();
      hide = hide || '';
      hide = jQuery.map(hide.split(','), function (a) {
        return jQuery.trim(a);
      });
      var data = {
        'index': index,
        'hide': {},
        'type': $th.data('type') || 'alpha',
        'name': $th.data('name') || $.trim($th.text()),
        'ignore': $th.data('ignore') || false,
        'toggle': $th.data('toggle') || false,
        'className': $th.data('class') || null,
        'matches': [],
        'names': {},
        'group': $th.data('group') || null,
        'groupName': null,
        'isEditable': $th.data('editable')
      };
      if (data.group !== null) {
        var $group = $(ft.table).find('> thead > tr.footable-group-row > th[data-group="' + data.group + '"], > thead > tr.footable-group-row > td[data-group="' + data.group + '"]').first();
        data.groupName = ft.parse($group, {
          'type': 'alpha'
        });
      }
      var pcolspan = parseInt($th.prev().attr('colspan') || 0, 10);
      indexOffset += pcolspan > 1 ? pcolspan - 1 : 0;
      var colspan = parseInt($th.attr('colspan') || 0, 10),
        curindex = data.index + indexOffset;
      if (colspan > 1) {
        var names = $th.data('names');
        names = names || '';
        names = names.split(',');
        for (var i = 0; i < colspan; i++) {
          data.matches.push(i + curindex);
          if (i < names.length) data.names[i + curindex] = names[i];
        }
      } else {
        data.matches.push(curindex);
      }
      data.hide['default'] = $th.data('hide') === "all" || $.inArray('default', hide) >= 0;
      var hasBreakpoint = false;
      for (var name in opt.breakpoints) {
        data.hide[name] = $th.data('hide') === "all" || $.inArray(name, hide) >= 0;
        hasBreakpoint = hasBreakpoint || data.hide[name];
      }
      data.hasBreakpoint = hasBreakpoint;
      var e = ft.raise(evt.columnData, {
        'column': {
          'data': data,
          'th': th
        }
      });
      return e.column.data;
    };
    ft.getViewportWidth = function () {
      return window.innerWidth || (document.body ? document.body.offsetWidth : 0);
    };
    ft.calculateWidth = function ($table, info) {
      if (jQuery.isFunction(opt.calculateWidthOverride)) {
        return opt.calculateWidthOverride($table, info);
      }
      if (info.viewportWidth < info.width) info.width = info.viewportWidth;
      if (info.parentWidth < info.width) info.width = info.parentWidth;
      return info;
    };
    ft.hasBreakpointColumn = function (breakpoint) {
      for (var c in ft.columns) {
        if (ft.columns[c].hide[breakpoint]) {
          if (ft.columns[c].ignore) {
            continue;
          }
          return true;
        }
      }
      return false;
    };
    ft.hasAnyBreakpointColumn = function () {
      for (var c in ft.columns) {
        if (ft.columns[c].hasBreakpoint) {
          return true;
        }
      }
      return false;
    };
    ft.resize = function () {
      var $table = $(ft.table);
      if (!$table.is(':visible')) {
        return;
      } //we only care about FooTables that are visible

      if (!ft.hasAnyBreakpointColumn()) {
        $table.trigger(trg.redraw);
        return;
      } //we only care about FooTables that have breakpoints

      var info = {
        'width': $table.width(),
        //the table width
        'viewportWidth': ft.getViewportWidth(),
        //the width of the viewport
        'parentWidth': $table.parent().width() //the width of the parent
      };
      info = ft.calculateWidth($table, info);
      var pinfo = $table.data('footable_info');
      $table.data('footable_info', info);
      ft.raise(evt.resizing, {
        'old': pinfo,
        'info': info
      });

      // This (if) statement is here purely to make sure events aren't raised twice as mobile safari seems to do
      if (!pinfo || pinfo && pinfo.width && pinfo.width !== info.width) {
        var current = null,
          breakpoint;
        for (var i = 0; i < ft.breakpoints.length; i++) {
          breakpoint = ft.breakpoints[i];
          if (breakpoint && breakpoint.width && info.width <= breakpoint.width) {
            current = breakpoint;
            break;
          }
        }
        var breakpointName = current === null ? 'default' : current['name'],
          hasBreakpointFired = ft.hasBreakpointColumn(breakpointName),
          previousBreakpoint = $table.data('breakpoint');
        $table.data('breakpoint', breakpointName).removeClass('default breakpoint').removeClass(ft.breakpointNames).addClass(breakpointName + (hasBreakpointFired ? ' breakpoint' : ''));

        //only do something if the breakpoint has changed
        if (breakpointName !== previousBreakpoint) {
          //trigger a redraw
          $table.trigger(trg.redraw);
          //raise a breakpoint event
          ft.raise(evt.breakpoint, {
            'breakpoint': breakpointName,
            'info': info
          });
        }
      }
      ft.raise(evt.resized, {
        'old': pinfo,
        'info': info
      });
    };
    ft.redraw = function () {
      //add the toggler to each row
      ft.addRowToggle();

      //bind the toggle selector click events
      ft.bindToggleSelectors();

      //set any cell classes defined for the columns
      ft.setColumnClasses();
      var $table = $(ft.table),
        breakpointName = $table.data('breakpoint'),
        hasBreakpointFired = ft.hasBreakpointColumn(breakpointName);
      $table.find('> tbody > tr:not(.' + cls.detail + ')').data('detail_created', false).end().find('> thead > tr:last-child > th').each(function () {
        var data = ft.columns[$(this).index()],
          selector = '',
          first = true;
        $.each(data.matches, function (m, match) {
          if (!first) {
            selector += ', ';
          }
          var count = match + 1;
          selector += '> tbody > tr:not(.' + cls.detail + ') > td:nth-child(' + count + ')';
          selector += ', > tfoot > tr:not(.' + cls.detail + ') > td:nth-child(' + count + ')';
          selector += ', > colgroup > col:nth-child(' + count + ')';
          first = false;
        });
        selector += ', > thead > tr[data-group-row="true"] > th[data-group="' + data.group + '"]';
        var $column = $table.find(selector).add(this);
        if (breakpointName !== '') {
          if (data.hide[breakpointName] === false) $column.addClass('footable-visible').show();else $column.removeClass('footable-visible').hide();
        }
        if ($table.find('> thead > tr.footable-group-row').length === 1) {
          var $groupcols = $table.find('> thead > tr:last-child > th[data-group="' + data.group + '"]:visible, > thead > tr:last-child > th[data-group="' + data.group + '"]:visible'),
            $group = $table.find('> thead > tr.footable-group-row > th[data-group="' + data.group + '"], > thead > tr.footable-group-row > td[data-group="' + data.group + '"]'),
            groupspan = 0;
          $.each($groupcols, function () {
            groupspan += parseInt($(this).attr('colspan') || 1, 10);
          });
          if (groupspan > 0) $group.attr('colspan', groupspan).show();else $group.hide();
        }
      }).end().find('> tbody > tr.' + cls.detailShow).each(function () {
        ft.createOrUpdateDetailRow(this);
      });
      $table.find("[data-bind-name]").each(function () {
        ft.toggleInput(this);
      });
      $table.find('> tbody > tr.' + cls.detailShow + ':visible').each(function () {
        var $next = $(this).next();
        if ($next.hasClass(cls.detail)) {
          if (!hasBreakpointFired) $next.hide();else $next.show();
        }
      });

      // adding .footable-first-column and .footable-last-column to the first and last th and td of each row in order to allow
      // for styling if the first or last column is hidden (which won't work using :first-child or :last-child)
      $table.find('> thead > tr > th.footable-last-column, > tbody > tr > td.footable-last-column').removeClass('footable-last-column');
      $table.find('> thead > tr > th.footable-first-column, > tbody > tr > td.footable-first-column').removeClass('footable-first-column');
      $table.find('> thead > tr, > tbody > tr').find('> th.footable-visible:last, > td.footable-visible:last').addClass('footable-last-column').end().find('> th.footable-visible:first, > td.footable-visible:first').addClass('footable-first-column');
      ft.raise(evt.redrawn);
    };
    ft.toggleDetail = function (row) {
      var $row = row.jquery ? row : $(row),
        $next = $row.next();

      //check if the row is already expanded
      if ($row.hasClass(cls.detailShow)) {
        $row.removeClass(cls.detailShow);

        //only hide the next row if it's a detail row
        if ($next.hasClass(cls.detail)) $next.hide();
        ft.raise(evt.rowCollapsed, {
          'row': $row[0]
        });
      } else {
        ft.createOrUpdateDetailRow($row[0]);
        $row.addClass(cls.detailShow).next().show();
        ft.raise(evt.rowExpanded, {
          'row': $row[0]
        });
      }
    };
    ft.removeRow = function (row) {
      var $row = row.jquery ? row : $(row);
      if ($row.hasClass(cls.detail)) {
        $row = $row.prev();
      }
      var $next = $row.next();
      if ($row.data('detail_created') === true) {
        //remove the detail row
        $next.remove();
      }
      $row.remove();

      //raise event
      ft.raise(evt.rowRemoved);
    };
    ft.appendRow = function (row) {
      var $row = row.jquery ? row : $(row);
      $(ft.table).find('tbody').append($row);

      //redraw the table
      ft.redraw();
    };
    ft.getColumnFromTdIndex = function (index) {
      /// <summary>Returns the correct column data for the supplied index taking into account colspans.</summary>
      /// <param name="index">The index to retrieve the column data for.</param>
      /// <returns type="json">A JSON object containing the column data for the supplied index.</returns>
      var result = null;
      for (var column in ft.columns) {
        if ($.inArray(index, ft.columns[column].matches) >= 0) {
          result = ft.columns[column];
          break;
        }
      }
      return result;
    };
    ft.createOrUpdateDetailRow = function (actualRow) {
      var $row = $(actualRow),
        $next = $row.next(),
        $detail,
        values = [];
      if ($row.data('detail_created') === true) return true;
      if ($row.is(':hidden')) return false; //if the row is hidden for some reason (perhaps filtered) then get out of here
      ft.raise(evt.rowDetailUpdating, {
        'row': $row,
        'detail': $next
      });
      $row.find('> td:hidden').each(function () {
        var index = $(this).index(),
          column = ft.getColumnFromTdIndex(index),
          name = column.name;
        if (column.ignore === true) return true;
        if (index in column.names) name = column.names[index];
        var bindName = $(this).attr("data-bind-name");
        if (bindName != null && $(this).is(':empty')) {
          var bindValue = $('.' + cls.detailInnerValue + '[' + 'data-bind-value="' + bindName + '"]');
          $(this).html($(bindValue).contents().detach());
        }
        var display;
        if (column.isEditable !== false && (column.isEditable || $(this).find(":input").length > 0)) {
          if (bindName == null) {
            bindName = "bind-" + $.now() + "-" + index;
            $(this).attr("data-bind-name", bindName);
          }
          display = $(this).contents().detach();
        }
        if (!display) display = $(this).contents().clone(true, true);
        values.push({
          'name': name,
          'value': ft.parse(this, column),
          'display': display,
          'group': column.group,
          'groupName': column.groupName,
          'bindName': bindName
        });
        return true;
      });
      if (values.length === 0) return false; //return if we don't have any data to show
      var colspan = $row.find('> td:visible').length;
      var exists = $next.hasClass(cls.detail);
      if (!exists) {
        // Create
        $next = $('<tr class="' + cls.detail + '"><td class="' + cls.detailCell + '"><div class="' + cls.detailInner + '"></div></td></tr>');
        $row.after($next);
      }
      $next.find('> td:first').attr('colspan', colspan);
      $detail = $next.find('.' + cls.detailInner).empty();
      opt.createDetail($detail, values, opt.createGroupedDetail, opt.detailSeparator, cls);
      $row.data('detail_created', true);
      ft.raise(evt.rowDetailUpdated, {
        'row': $row,
        'detail': $next
      });
      return !exists;
    };
    ft.raise = function (eventName, args) {
      if (ft.options.debug === true && $.isFunction(ft.options.log)) ft.options.log(eventName, 'event');
      args = args || {};
      var def = {
        'ft': ft
      };
      $.extend(true, def, args);
      var e = $.Event(eventName, def);
      if (!e.ft) {
        $.extend(true, e, def);
      } //pre jQuery 1.6 which did not allow data to be passed to event object constructor
      $(ft.table).trigger(e);
      return e;
    };

    //reset the state of FooTable
    ft.reset = function () {
      var $table = $(ft.table);
      $table.removeData('footable_info').data('breakpoint', '').removeClass(cls.loading).removeClass(cls.loaded);
      $table.find(opt.toggleSelector).unbind(trg.toggleRow).unbind('click.footable');
      $table.find('> tbody > tr').removeClass(cls.detailShow);
      $table.find('> tbody > tr.' + cls.detail).remove();
      ft.raise(evt.reset);
    };

    //Switch between row-detail and detail-show.
    ft.toggleInput = function (column) {
      var bindName = $(column).attr("data-bind-name");
      if (bindName != null) {
        var bindValue = $('.' + cls.detailInnerValue + '[' + 'data-bind-value="' + bindName + '"]');
        if (bindValue != null) {
          if ($(column).is(":visible")) {
            if (!$(bindValue).is(':empty')) $(column).html($(bindValue).contents().detach());
          } else if (!$(column).is(':empty')) {
            $(bindValue).html($(column).contents().detach());
          }
        }
      }
    };
    ft.init();
    return ft;
  }
})(jQuery, window);
!function (e) {
  if ("object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) && "undefined" != typeof module) module.exports = e();else if ("function" == typeof define && define.amd) define([], e);else {
    var o;
    "undefined" != typeof window ? o = window : "undefined" != typeof global ? o = global : "undefined" != typeof self && (o = self), o.angularFootable = e();
  }
}(function () {
  var define, module, exports;
  return function e(t, n, r) {
    function s(o, u) {
      if (!n[o]) {
        if (!t[o]) {
          var a = typeof require == "function" && require;
          if (!u && a) return a(o, !0);
          if (i) return i(o, !0);
          throw new Error("Cannot find module '" + o + "'");
        }
        var f = n[o] = {
          exports: {}
        };
        t[o][0].call(f.exports, function (e) {
          var n = t[o][1][e];
          return s(n ? n : e);
        }, f, f.exports, e, t, n, r);
      }
      return n[o].exports;
    }
    var i = typeof require == "function" && require;
    for (var o = 0; o < r.length; o++) s(r[o]);
    return s;
  }({
    1: [function (_dereq_, module, exports) {
      'use strict';

      angular.module('ui.footable', []).directive('footable', function () {
        var events = {
          beforeFiltering: 'footable_filtering'
        };
        var extractSpecOpts = function extractSpecOpts(opts, attrs) {
          var extracted = {},
            k;
          for (k in opts) {
            if (k !== 'filter' && !angular.isUndefined(events[k])) {
              if (!angular.isFunction(scope.$eval(attrs[k]))) {
                extracted[k] = attrs[k];
              }
            }
          }
          return extracted;
        };
        var bindEventHandler = function bindEventHandler(tableObj, scope, attrs) {
          var k;
          for (k in attrs) {
            if (k !== 'filter' && !angular.isUndefined(events[k])) {
              var targetEventName = events[k];
              if (angular.isFunction(scope.$eval(attrs[k]))) {
                tableObj.bind(targetEventName, scope.$eval(attrs[k]));
              }
            }
          }
        };
        return {
          restrict: 'C',
          link: function link(scope, element, attrs) {
            var tableOpts = {
              'event-filtering': null
            };
            angular.extend(tableOpts, footable.options);
            angular.extend(tableOpts, extractSpecOpts(tableOpts, attrs));
            var tableObj = element.footable(tableOpts);
            bindEventHandler(tableObj, scope, attrs);
          }
        };
      });
    }, {}]
  }, {}, [1])(1);
});

/**
 * Copyright (c) 2011-2014 Felix Gnass
 * Licensed under the MIT license
 */
(function (root, factory) {
  /* CommonJS */
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) == 'object') module.exports = factory();

  /* AMD module */else if (typeof define == 'function' && define.amd) define(factory);

  /* Browser global */else root.Spinner = factory();
})(this, function () {
  "use strict";

  var prefixes = ['webkit', 'Moz', 'ms', 'O'] /* Vendor prefixes */,
    animations = {} /* Animation rules keyed by their name */,
    useCssAnimations; /* Whether to use CSS animations or setTimeout */

  /**
   * Utility function to create elements. If no tag name is given,
   * a DIV is created. Optionally properties can be passed.
   */
  function createEl(tag, prop) {
    var el = document.createElement(tag || 'div'),
      n;
    for (n in prop) el[n] = prop[n];
    return el;
  }

  /**
   * Appends children and returns the parent.
   */
  function ins(parent /* child1, child2, ...*/) {
    for (var i = 1, n = arguments.length; i < n; i++) parent.appendChild(arguments[i]);
    return parent;
  }

  /**
   * Insert a new stylesheet to hold the @keyframe or VML rules.
   */
  var sheet = function () {
    var el = createEl('style', {
      type: 'text/css'
    });
    ins(document.getElementsByTagName('head')[0], el);
    return el.sheet || el.styleSheet;
  }();

  /**
   * Creates an opacity keyframe animation rule and returns its name.
   * Since most mobile Webkits have timing issues with animation-delay,
   * we create separate rules for each line/segment.
   */
  function addAnimation(alpha, trail, i, lines) {
    var name = ['opacity', trail, ~~(alpha * 100), i, lines].join('-'),
      start = 0.01 + i / lines * 100,
      z = Math.max(1 - (1 - alpha) / trail * (100 - start), alpha),
      prefix = useCssAnimations.substring(0, useCssAnimations.indexOf('Animation')).toLowerCase(),
      pre = prefix && '-' + prefix + '-' || '';
    if (!animations[name]) {
      sheet.insertRule('@' + pre + 'keyframes ' + name + '{' + '0%{opacity:' + z + '}' + start + '%{opacity:' + alpha + '}' + (start + 0.01) + '%{opacity:1}' + (start + trail) % 100 + '%{opacity:' + alpha + '}' + '100%{opacity:' + z + '}' + '}', sheet.cssRules.length);
      animations[name] = 1;
    }
    return name;
  }

  /**
   * Tries various vendor prefixes and returns the first supported property.
   */
  function vendor(el, prop) {
    var s = el.style,
      pp,
      i;
    prop = prop.charAt(0).toUpperCase() + prop.slice(1);
    for (i = 0; i < prefixes.length; i++) {
      pp = prefixes[i] + prop;
      if (s[pp] !== undefined) return pp;
    }
    if (s[prop] !== undefined) return prop;
  }

  /**
   * Sets multiple style properties at once.
   */
  function css(el, prop) {
    for (var n in prop) el.style[vendor(el, n) || n] = prop[n];
    return el;
  }

  /**
   * Fills in default values.
   */
  function merge(obj) {
    for (var i = 1; i < arguments.length; i++) {
      var def = arguments[i];
      for (var n in def) if (obj[n] === undefined) obj[n] = def[n];
    }
    return obj;
  }

  /**
   * Returns the line color from the given string or array.
   */
  function getColor(color, idx) {
    return typeof color == 'string' ? color : color[idx % color.length];
  }

  // Built-in defaults

  var defaults = {
    lines: 12,
    // The number of lines to draw
    length: 7,
    // The length of each line
    width: 5,
    // The line thickness
    radius: 10,
    // The radius of the inner circle
    rotate: 0,
    // Rotation offset
    corners: 1,
    // Roundness (0..1)
    color: '#000',
    // #rgb or #rrggbb
    direction: 1,
    // 1: clockwise, -1: counterclockwise
    speed: 1,
    // Rounds per second
    trail: 100,
    // Afterglow percentage
    opacity: 1 / 4,
    // Opacity of the lines
    fps: 20,
    // Frames per second when using setTimeout()
    zIndex: 2e9,
    // Use a high z-index by default
    className: 'spinner',
    // CSS class to assign to the element
    top: '50%',
    // center vertically
    left: '50%',
    // center horizontally
    position: 'absolute' // element position
  };

  /** The constructor */
  function Spinner(o) {
    this.opts = merge(o || {}, Spinner.defaults, defaults);
  }

  // Global defaults that override the built-ins:
  Spinner.defaults = {};
  merge(Spinner.prototype, {
    /**
     * Adds the spinner to the given target element. If this instance is already
     * spinning, it is automatically removed from its previous target b calling
     * stop() internally.
     */
    spin: function spin(target) {
      this.stop();
      var self = this,
        o = self.opts,
        el = self.el = css(createEl(0, {
          className: o.className
        }), {
          position: o.position,
          width: 0,
          zIndex: o.zIndex
        });
      css(el, {
        left: o.left,
        top: o.top
      });
      if (target) {
        target.insertBefore(el, target.firstChild || null);
      }
      el.setAttribute('role', 'progressbar');
      self.lines(el, self.opts);
      if (!useCssAnimations) {
        // No CSS animation support, use setTimeout() instead
        var i = 0,
          start = (o.lines - 1) * (1 - o.direction) / 2,
          alpha,
          fps = o.fps,
          f = fps / o.speed,
          ostep = (1 - o.opacity) / (f * o.trail / 100),
          astep = f / o.lines;
        (function anim() {
          i++;
          for (var j = 0; j < o.lines; j++) {
            alpha = Math.max(1 - (i + (o.lines - j) * astep) % f * ostep, o.opacity);
            self.opacity(el, j * o.direction + start, alpha, o);
          }
          self.timeout = self.el && setTimeout(anim, ~~(1000 / fps));
        })();
      }
      return self;
    },
    /**
     * Stops and removes the Spinner.
     */
    stop: function stop() {
      var el = this.el;
      if (el) {
        clearTimeout(this.timeout);
        if (el.parentNode) el.parentNode.removeChild(el);
        this.el = undefined;
      }
      return this;
    },
    /**
     * Internal method that draws the individual lines. Will be overwritten
     * in VML fallback mode below.
     */
    lines: function lines(el, o) {
      var i = 0,
        start = (o.lines - 1) * (1 - o.direction) / 2,
        seg;
      function fill(color, shadow) {
        return css(createEl(), {
          position: 'absolute',
          width: o.length + o.width + 'px',
          height: o.width + 'px',
          background: color,
          boxShadow: shadow,
          transformOrigin: 'left',
          transform: 'rotate(' + ~~(360 / o.lines * i + o.rotate) + 'deg) translate(' + o.radius + 'px' + ',0)',
          borderRadius: (o.corners * o.width >> 1) + 'px'
        });
      }
      for (; i < o.lines; i++) {
        seg = css(createEl(), {
          position: 'absolute',
          top: 1 + ~(o.width / 2) + 'px',
          transform: o.hwaccel ? 'translate3d(0,0,0)' : '',
          opacity: o.opacity,
          animation: useCssAnimations && addAnimation(o.opacity, o.trail, start + i * o.direction, o.lines) + ' ' + 1 / o.speed + 's linear infinite'
        });
        if (o.shadow) ins(seg, css(fill('#000', '0 0 4px ' + '#000'), {
          top: 2 + 'px'
        }));
        ins(el, ins(seg, fill(getColor(o.color, i), '0 0 1px rgba(0,0,0,.1)')));
      }
      return el;
    },
    /**
     * Internal method that adjusts the opacity of a single line.
     * Will be overwritten in VML fallback mode below.
     */
    opacity: function opacity(el, i, val) {
      if (i < el.childNodes.length) el.childNodes[i].style.opacity = val;
    }
  });
  function initVML() {
    /* Utility function to create a VML tag */
    function vml(tag, attr) {
      return createEl('<' + tag + ' xmlns="urn:schemas-microsoft.com:vml" class="spin-vml">', attr);
    }

    // No CSS transforms but VML support, add a CSS rule for VML elements:
    sheet.addRule('.spin-vml', 'behavior:url(#default#VML)');
    Spinner.prototype.lines = function (el, o) {
      var r = o.length + o.width,
        s = 2 * r;
      function grp() {
        return css(vml('group', {
          coordsize: s + ' ' + s,
          coordorigin: -r + ' ' + -r
        }), {
          width: s,
          height: s
        });
      }
      var margin = -(o.width + o.length) * 2 + 'px',
        g = css(grp(), {
          position: 'absolute',
          top: margin,
          left: margin
        }),
        i;
      function seg(i, dx, filter) {
        ins(g, ins(css(grp(), {
          rotation: 360 / o.lines * i + 'deg',
          left: ~~dx
        }), ins(css(vml('roundrect', {
          arcsize: o.corners
        }), {
          width: r,
          height: o.width,
          left: o.radius,
          top: -o.width >> 1,
          filter: filter
        }), vml('fill', {
          color: getColor(o.color, i),
          opacity: o.opacity
        }), vml('stroke', {
          opacity: 0
        }) // transparent stroke to fix color bleeding upon opacity change
        )));
      }
      if (o.shadow) for (i = 1; i <= o.lines; i++) seg(i, -2, 'progid:DXImageTransform.Microsoft.Blur(pixelradius=2,makeshadow=1,shadowopacity=.3)');
      for (i = 1; i <= o.lines; i++) seg(i);
      return ins(el, g);
    };
    Spinner.prototype.opacity = function (el, i, val, o) {
      var c = el.firstChild;
      o = o.shadow && o.lines || 0;
      if (c && i + o < c.childNodes.length) {
        c = c.childNodes[i + o];
        c = c && c.firstChild;
        c = c && c.firstChild;
        if (c) c.opacity = val;
      }
    };
  }
  var probe = css(createEl('group'), {
    behavior: 'url(#default#VML)'
  });
  if (!vendor(probe, 'transform') && probe.adj) initVML();else useCssAnimations = vendor(probe, 'animation');
  return Spinner;
});

/*!
 * Ladda 1.0.6 (2018-02-04, 13:15)
 * http://lab.hakim.se/ladda
 * MIT licensed
 *
 * Copyright (C) 2017 Hakim El Hattab, http://hakim.se
 */

!function (t, e) {
  "use strict";

  "object" == (typeof exports === "undefined" ? "undefined" : _typeof(exports)) ? module.exports = e(require("spin.js")) : "function" == typeof define && define.amd ? define(["spin"], e) : t.Ladda = e(t.Spinner);
}(this, function (t) {
  "use strict";

  var e = [];
  function a(a) {
    if (void 0 !== a) {
      if (/ladda-button/i.test(a.className) || (a.className += " ladda-button"), a.hasAttribute("data-style") || a.setAttribute("data-style", "expand-right"), !a.querySelector(".ladda-label")) {
        var u = document.createElement("span");
        u.className = "ladda-label", n = a, i = u, (r = document.createRange()).selectNodeContents(n), r.surroundContents(i), n.appendChild(i);
      }
      var n,
        i,
        r,
        d,
        o,
        s = a.querySelector(".ladda-spinner");
      s || ((s = document.createElement("span")).className = "ladda-spinner"), a.appendChild(s);
      var F = {
        start: function start() {
          return d || (d = function (e) {
            var a,
              u,
              n = e.offsetHeight;
            0 === n && (n = parseFloat(window.getComputedStyle(e).height));
            n > 32 && (n *= .8);
            e.hasAttribute("data-spinner-size") && (n = parseInt(e.getAttribute("data-spinner-size"), 10));
            e.hasAttribute("data-spinner-color") && (a = e.getAttribute("data-spinner-color"));
            e.hasAttribute("data-spinner-lines") && (u = parseInt(e.getAttribute("data-spinner-lines"), 10));
            var i = .2 * n;
            return new t({
              color: a || "#fff",
              lines: u || 12,
              radius: i,
              length: .6 * i,
              width: i < 7 ? 2 : 3,
              zIndex: "auto",
              top: "auto",
              left: "auto",
              className: ""
            });
          }(a)), a.disabled = !0, a.setAttribute("data-loading", ""), clearTimeout(o), d.spin(s), this.setProgress(0), this;
        },
        startAfter: function startAfter(t) {
          return clearTimeout(o), o = setTimeout(function () {
            F.start();
          }, t), this;
        },
        stop: function stop() {
          return F.isLoading() && (a.disabled = !1, a.removeAttribute("data-loading")), clearTimeout(o), d && (o = setTimeout(function () {
            d.stop();
          }, 1e3)), this;
        },
        toggle: function toggle() {
          return this.isLoading() ? this.stop() : this.start();
        },
        setProgress: function setProgress(t) {
          t = Math.max(Math.min(t, 1), 0);
          var e = a.querySelector(".ladda-progress");
          0 === t && e && e.parentNode ? e.parentNode.removeChild(e) : (e || ((e = document.createElement("div")).className = "ladda-progress", a.appendChild(e)), e.style.width = (t || 0) * a.offsetWidth + "px");
        },
        enable: function enable() {
          return this.stop();
        },
        disable: function disable() {
          return this.stop(), a.disabled = !0, this;
        },
        isLoading: function isLoading() {
          return a.hasAttribute("data-loading");
        },
        remove: function remove() {
          clearTimeout(o), a.disabled = !1, a.removeAttribute("data-loading"), d && (d.stop(), d = null), e.splice(e.indexOf(F), 1);
        }
      };
      return e.push(F), F;
    }
    console.warn("Ladda button target must be defined.");
  }
  function u(t, e) {
    if ("function" == typeof t.addEventListener) {
      var u = a(t),
        n = -1;
      t.addEventListener("click", function () {
        var a,
          i,
          r = !0,
          d = function (t, e) {
            for (; t.parentNode && t.tagName !== e;) t = t.parentNode;
            return e === t.tagName ? t : void 0;
          }(t, "FORM");
        if (void 0 !== d && !d.hasAttribute("novalidate")) if ("function" == typeof d.checkValidity) r = d.checkValidity();else for (var o = (a = d, i = [], ["input", "textarea", "select"].forEach(function (t) {
            for (var e = a.getElementsByTagName(t), u = 0; u < e.length; u++) e[u].hasAttribute("required") && i.push(e[u]);
          }), i), s = 0; s < o.length; s++) {
          var F = o[s],
            l = F.getAttribute("type");
          if ("" === F.value.replace(/^\s+|\s+$/g, "") && (r = !1), "checkbox" !== l && "radio" !== l || F.checked || (r = !1), "email" === l && (r = /^[a-z0-9!#$%&'*+/=?^_`{|}~.-]+@[a-z0-9-]+(\.[a-z0-9-]+)*$/i.test(F.value)), "url" === l && (r = /^([a-z]([a-z]|\d|\+|-|\.)*):(\/\/(((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:)*@)?((\[(|(v[\da-f]{1,}\.(([a-z]|\d|-|\.|_|~)|[!\$&'\(\)\*\+,;=]|:)+))\])|((\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5])\.(\d|[1-9]\d|1\d\d|2[0-4]\d|25[0-5]))|(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=])*)(:\d*)?)(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*|(\/((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)?)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)+(\/(([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)*)*)|((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)){0})(\?((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|[\uE000-\uF8FF]|\/|\?)*)?(\#((([a-z]|\d|-|\.|_|~|[\u00A0-\uD7FF\uF900-\uFDCF\uFDF0-\uFFEF])|(%[\da-f]{2})|[!\$&'\(\)\*\+,;=]|:|@)|\/|\?)*)?$/i.test(F.value)), !r) break;
        }
        r && (u.startAfter(1), "number" == typeof e.timeout && (clearTimeout(n), n = setTimeout(u.stop, e.timeout)), "function" == typeof e.callback && e.callback.apply(null, [u]));
      }, !1);
    }
  }
  return {
    bind: function bind(t, e) {
      var a;
      if ("string" == typeof t) a = document.querySelectorAll(t);else {
        if ("object" != _typeof(t)) throw new Error("target must be string or object");
        a = [t];
      }
      e = e || {};
      for (var n = 0; n < a.length; n++) u(a[n], e);
    },
    create: a,
    stopAll: function stopAll() {
      for (var t = 0, a = e.length; t < a; t++) e[t].stop();
    }
  };
});
/*!

JSZip v3.10.1 - A JavaScript class for generating and reading zip files
<http://stuartk.com/jszip>

(c) 2009-2016 Stuart Knightley <stuart [at] stuartk.com>
Dual licenced under the MIT license or GPLv3. See https://raw.github.com/Stuk/jszip/main/LICENSE.markdown.

JSZip uses the library pako released under the MIT license :
https://github.com/nodeca/pako/blob/main/LICENSE
*/

(function (f) {
  if ((typeof exports === "undefined" ? "undefined" : _typeof(exports)) === "object" && typeof module !== "undefined") {
    module.exports = f();
  } else if (typeof define === "function" && define.amd) {
    define([], f);
  } else {
    var g;
    if (typeof window !== "undefined") {
      g = window;
    } else if (typeof global !== "undefined") {
      g = global;
    } else if (typeof self !== "undefined") {
      g = self;
    } else {
      g = this;
    }
    g.JSZip = f();
  }
})(function () {
  var define, module, exports;
  return function e(t, n, r) {
    function s(o, u) {
      if (!n[o]) {
        if (!t[o]) {
          var a = typeof require == "function" && require;
          if (!u && a) return a(o, !0);
          if (i) return i(o, !0);
          var f = new Error("Cannot find module '" + o + "'");
          throw f.code = "MODULE_NOT_FOUND", f;
        }
        var l = n[o] = {
          exports: {}
        };
        t[o][0].call(l.exports, function (e) {
          var n = t[o][1][e];
          return s(n ? n : e);
        }, l, l.exports, e, t, n, r);
      }
      return n[o].exports;
    }
    var i = typeof require == "function" && require;
    for (var o = 0; o < r.length; o++) s(r[o]);
    return s;
  }({
    1: [function (require, module, exports) {
      "use strict";

      var utils = require("./utils");
      var support = require("./support");
      // private property
      var _keyStr = "ABCDEFGHIJKLMNOPQRSTUVWXYZabcdefghijklmnopqrstuvwxyz0123456789+/=";

      // public method for encoding
      exports.encode = function (input) {
        var output = [];
        var chr1, chr2, chr3, enc1, enc2, enc3, enc4;
        var i = 0,
          len = input.length,
          remainingBytes = len;
        var isArray = utils.getTypeOf(input) !== "string";
        while (i < input.length) {
          remainingBytes = len - i;
          if (!isArray) {
            chr1 = input.charCodeAt(i++);
            chr2 = i < len ? input.charCodeAt(i++) : 0;
            chr3 = i < len ? input.charCodeAt(i++) : 0;
          } else {
            chr1 = input[i++];
            chr2 = i < len ? input[i++] : 0;
            chr3 = i < len ? input[i++] : 0;
          }
          enc1 = chr1 >> 2;
          enc2 = (chr1 & 3) << 4 | chr2 >> 4;
          enc3 = remainingBytes > 1 ? (chr2 & 15) << 2 | chr3 >> 6 : 64;
          enc4 = remainingBytes > 2 ? chr3 & 63 : 64;
          output.push(_keyStr.charAt(enc1) + _keyStr.charAt(enc2) + _keyStr.charAt(enc3) + _keyStr.charAt(enc4));
        }
        return output.join("");
      };

      // public method for decoding
      exports.decode = function (input) {
        var chr1, chr2, chr3;
        var enc1, enc2, enc3, enc4;
        var i = 0,
          resultIndex = 0;
        var dataUrlPrefix = "data:";
        if (input.substr(0, dataUrlPrefix.length) === dataUrlPrefix) {
          // This is a common error: people give a data url
          // (data:image/png;base64,iVBOR...) with a {base64: true} and
          // wonders why things don't work.
          // We can detect that the string input looks like a data url but we
          // *can't* be sure it is one: removing everything up to the comma would
          // be too dangerous.
          throw new Error("Invalid base64 input, it looks like a data url.");
        }
        input = input.replace(/[^A-Za-z0-9+/=]/g, "");
        var totalLength = input.length * 3 / 4;
        if (input.charAt(input.length - 1) === _keyStr.charAt(64)) {
          totalLength--;
        }
        if (input.charAt(input.length - 2) === _keyStr.charAt(64)) {
          totalLength--;
        }
        if (totalLength % 1 !== 0) {
          // totalLength is not an integer, the length does not match a valid
          // base64 content. That can happen if:
          // - the input is not a base64 content
          // - the input is *almost* a base64 content, with a extra chars at the
          //   beginning or at the end
          // - the input uses a base64 variant (base64url for example)
          throw new Error("Invalid base64 input, bad content length.");
        }
        var output;
        if (support.uint8array) {
          output = new Uint8Array(totalLength | 0);
        } else {
          output = new Array(totalLength | 0);
        }
        while (i < input.length) {
          enc1 = _keyStr.indexOf(input.charAt(i++));
          enc2 = _keyStr.indexOf(input.charAt(i++));
          enc3 = _keyStr.indexOf(input.charAt(i++));
          enc4 = _keyStr.indexOf(input.charAt(i++));
          chr1 = enc1 << 2 | enc2 >> 4;
          chr2 = (enc2 & 15) << 4 | enc3 >> 2;
          chr3 = (enc3 & 3) << 6 | enc4;
          output[resultIndex++] = chr1;
          if (enc3 !== 64) {
            output[resultIndex++] = chr2;
          }
          if (enc4 !== 64) {
            output[resultIndex++] = chr3;
          }
        }
        return output;
      };
    }, {
      "./support": 30,
      "./utils": 32
    }],
    2: [function (require, module, exports) {
      "use strict";

      var external = require("./external");
      var DataWorker = require("./stream/DataWorker");
      var Crc32Probe = require("./stream/Crc32Probe");
      var DataLengthProbe = require("./stream/DataLengthProbe");

      /**
       * Represent a compressed object, with everything needed to decompress it.
       * @constructor
       * @param {number} compressedSize the size of the data compressed.
       * @param {number} uncompressedSize the size of the data after decompression.
       * @param {number} crc32 the crc32 of the decompressed file.
       * @param {object} compression the type of compression, see lib/compressions.js.
       * @param {String|ArrayBuffer|Uint8Array|Buffer} data the compressed data.
       */
      function CompressedObject(compressedSize, uncompressedSize, crc32, compression, data) {
        this.compressedSize = compressedSize;
        this.uncompressedSize = uncompressedSize;
        this.crc32 = crc32;
        this.compression = compression;
        this.compressedContent = data;
      }
      CompressedObject.prototype = {
        /**
         * Create a worker to get the uncompressed content.
         * @return {GenericWorker} the worker.
         */
        getContentWorker: function getContentWorker() {
          var worker = new DataWorker(external.Promise.resolve(this.compressedContent)).pipe(this.compression.uncompressWorker()).pipe(new DataLengthProbe("data_length"));
          var that = this;
          worker.on("end", function () {
            if (this.streamInfo["data_length"] !== that.uncompressedSize) {
              throw new Error("Bug : uncompressed data size mismatch");
            }
          });
          return worker;
        },
        /**
         * Create a worker to get the compressed content.
         * @return {GenericWorker} the worker.
         */
        getCompressedWorker: function getCompressedWorker() {
          return new DataWorker(external.Promise.resolve(this.compressedContent)).withStreamInfo("compressedSize", this.compressedSize).withStreamInfo("uncompressedSize", this.uncompressedSize).withStreamInfo("crc32", this.crc32).withStreamInfo("compression", this.compression);
        }
      };

      /**
       * Chain the given worker with other workers to compress the content with the
       * given compression.
       * @param {GenericWorker} uncompressedWorker the worker to pipe.
       * @param {Object} compression the compression object.
       * @param {Object} compressionOptions the options to use when compressing.
       * @return {GenericWorker} the new worker compressing the content.
       */
      CompressedObject.createWorkerFrom = function (uncompressedWorker, compression, compressionOptions) {
        return uncompressedWorker.pipe(new Crc32Probe()).pipe(new DataLengthProbe("uncompressedSize")).pipe(compression.compressWorker(compressionOptions)).pipe(new DataLengthProbe("compressedSize")).withStreamInfo("compression", compression);
      };
      module.exports = CompressedObject;
    }, {
      "./external": 6,
      "./stream/Crc32Probe": 25,
      "./stream/DataLengthProbe": 26,
      "./stream/DataWorker": 27
    }],
    3: [function (require, module, exports) {
      "use strict";

      var GenericWorker = require("./stream/GenericWorker");
      exports.STORE = {
        magic: "\x00\x00",
        compressWorker: function compressWorker() {
          return new GenericWorker("STORE compression");
        },
        uncompressWorker: function uncompressWorker() {
          return new GenericWorker("STORE decompression");
        }
      };
      exports.DEFLATE = require("./flate");
    }, {
      "./flate": 7,
      "./stream/GenericWorker": 28
    }],
    4: [function (require, module, exports) {
      "use strict";

      var utils = require("./utils");

      /**
       * The following functions come from pako, from pako/lib/zlib/crc32.js
       * released under the MIT license, see pako https://github.com/nodeca/pako/
       */

      // Use ordinary array, since untyped makes no boost here
      function makeTable() {
        var c,
          table = [];
        for (var n = 0; n < 256; n++) {
          c = n;
          for (var k = 0; k < 8; k++) {
            c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
          }
          table[n] = c;
        }
        return table;
      }

      // Create table on load. Just 255 signed longs. Not a problem.
      var crcTable = makeTable();
      function crc32(crc, buf, len, pos) {
        var t = crcTable,
          end = pos + len;
        crc = crc ^ -1;
        for (var i = pos; i < end; i++) {
          crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
        }
        return crc ^ -1; // >>> 0;
      }

      // That's all for the pako functions.

      /**
       * Compute the crc32 of a string.
       * This is almost the same as the function crc32, but for strings. Using the
       * same function for the two use cases leads to horrible performances.
       * @param {Number} crc the starting value of the crc.
       * @param {String} str the string to use.
       * @param {Number} len the length of the string.
       * @param {Number} pos the starting position for the crc32 computation.
       * @return {Number} the computed crc32.
       */
      function crc32str(crc, str, len, pos) {
        var t = crcTable,
          end = pos + len;
        crc = crc ^ -1;
        for (var i = pos; i < end; i++) {
          crc = crc >>> 8 ^ t[(crc ^ str.charCodeAt(i)) & 0xFF];
        }
        return crc ^ -1; // >>> 0;
      }
      module.exports = function crc32wrapper(input, crc) {
        if (typeof input === "undefined" || !input.length) {
          return 0;
        }
        var isArray = utils.getTypeOf(input) !== "string";
        if (isArray) {
          return crc32(crc | 0, input, input.length, 0);
        } else {
          return crc32str(crc | 0, input, input.length, 0);
        }
      };
    }, {
      "./utils": 32
    }],
    5: [function (require, module, exports) {
      "use strict";

      exports.base64 = false;
      exports.binary = false;
      exports.dir = false;
      exports.createFolders = true;
      exports.date = null;
      exports.compression = null;
      exports.compressionOptions = null;
      exports.comment = null;
      exports.unixPermissions = null;
      exports.dosPermissions = null;
    }, {}],
    6: [function (require, module, exports) {
      "use strict";

      // load the global object first:
      // - it should be better integrated in the system (unhandledRejection in node)
      // - the environment may have a custom Promise implementation (see zone.js)
      var ES6Promise = null;
      if (typeof Promise !== "undefined") {
        ES6Promise = Promise;
      } else {
        ES6Promise = require("lie");
      }

      /**
       * Let the user use/change some implementations.
       */
      module.exports = {
        Promise: ES6Promise
      };
    }, {
      "lie": 37
    }],
    7: [function (require, module, exports) {
      "use strict";

      var USE_TYPEDARRAY = typeof Uint8Array !== "undefined" && typeof Uint16Array !== "undefined" && typeof Uint32Array !== "undefined";
      var pako = require("pako");
      var utils = require("./utils");
      var GenericWorker = require("./stream/GenericWorker");
      var ARRAY_TYPE = USE_TYPEDARRAY ? "uint8array" : "array";
      exports.magic = "\x08\x00";

      /**
       * Create a worker that uses pako to inflate/deflate.
       * @constructor
       * @param {String} action the name of the pako function to call : either "Deflate" or "Inflate".
       * @param {Object} options the options to use when (de)compressing.
       */
      function FlateWorker(action, options) {
        GenericWorker.call(this, "FlateWorker/" + action);
        this._pako = null;
        this._pakoAction = action;
        this._pakoOptions = options;
        // the `meta` object from the last chunk received
        // this allow this worker to pass around metadata
        this.meta = {};
      }
      utils.inherits(FlateWorker, GenericWorker);

      /**
       * @see GenericWorker.processChunk
       */
      FlateWorker.prototype.processChunk = function (chunk) {
        this.meta = chunk.meta;
        if (this._pako === null) {
          this._createPako();
        }
        this._pako.push(utils.transformTo(ARRAY_TYPE, chunk.data), false);
      };

      /**
       * @see GenericWorker.flush
       */
      FlateWorker.prototype.flush = function () {
        GenericWorker.prototype.flush.call(this);
        if (this._pako === null) {
          this._createPako();
        }
        this._pako.push([], true);
      };
      /**
       * @see GenericWorker.cleanUp
       */
      FlateWorker.prototype.cleanUp = function () {
        GenericWorker.prototype.cleanUp.call(this);
        this._pako = null;
      };

      /**
       * Create the _pako object.
       * TODO: lazy-loading this object isn't the best solution but it's the
       * quickest. The best solution is to lazy-load the worker list. See also the
       * issue #446.
       */
      FlateWorker.prototype._createPako = function () {
        this._pako = new pako[this._pakoAction]({
          raw: true,
          level: this._pakoOptions.level || -1 // default compression
        });
        var self = this;
        this._pako.onData = function (data) {
          self.push({
            data: data,
            meta: self.meta
          });
        };
      };
      exports.compressWorker = function (compressionOptions) {
        return new FlateWorker("Deflate", compressionOptions);
      };
      exports.uncompressWorker = function () {
        return new FlateWorker("Inflate", {});
      };
    }, {
      "./stream/GenericWorker": 28,
      "./utils": 32,
      "pako": 38
    }],
    8: [function (require, module, exports) {
      "use strict";

      var utils = require("../utils");
      var GenericWorker = require("../stream/GenericWorker");
      var utf8 = require("../utf8");
      var crc32 = require("../crc32");
      var signature = require("../signature");

      /**
       * Transform an integer into a string in hexadecimal.
       * @private
       * @param {number} dec the number to convert.
       * @param {number} bytes the number of bytes to generate.
       * @returns {string} the result.
       */
      var decToHex = function decToHex(dec, bytes) {
        var hex = "",
          i;
        for (i = 0; i < bytes; i++) {
          hex += String.fromCharCode(dec & 0xff);
          dec = dec >>> 8;
        }
        return hex;
      };

      /**
       * Generate the UNIX part of the external file attributes.
       * @param {Object} unixPermissions the unix permissions or null.
       * @param {Boolean} isDir true if the entry is a directory, false otherwise.
       * @return {Number} a 32 bit integer.
       *
       * adapted from http://unix.stackexchange.com/questions/14705/the-zip-formats-external-file-attribute :
       *
       * TTTTsstrwxrwxrwx0000000000ADVSHR
       * ^^^^____________________________ file type, see zipinfo.c (UNX_*)
       *     ^^^_________________________ setuid, setgid, sticky
       *        ^^^^^^^^^________________ permissions
       *                 ^^^^^^^^^^______ not used ?
       *                           ^^^^^^ DOS attribute bits : Archive, Directory, Volume label, System file, Hidden, Read only
       */
      var generateUnixExternalFileAttr = function generateUnixExternalFileAttr(unixPermissions, isDir) {
        var result = unixPermissions;
        if (!unixPermissions) {
          // I can't use octal values in strict mode, hence the hexa.
          //  040775 => 0x41fd
          // 0100664 => 0x81b4
          result = isDir ? 0x41fd : 0x81b4;
        }
        return (result & 0xFFFF) << 16;
      };

      /**
       * Generate the DOS part of the external file attributes.
       * @param {Object} dosPermissions the dos permissions or null.
       * @param {Boolean} isDir true if the entry is a directory, false otherwise.
       * @return {Number} a 32 bit integer.
       *
       * Bit 0     Read-Only
       * Bit 1     Hidden
       * Bit 2     System
       * Bit 3     Volume Label
       * Bit 4     Directory
       * Bit 5     Archive
       */
      var generateDosExternalFileAttr = function generateDosExternalFileAttr(dosPermissions) {
        // the dir flag is already set for compatibility
        return (dosPermissions || 0) & 0x3F;
      };

      /**
       * Generate the various parts used in the construction of the final zip file.
       * @param {Object} streamInfo the hash with information about the compressed file.
       * @param {Boolean} streamedContent is the content streamed ?
       * @param {Boolean} streamingEnded is the stream finished ?
       * @param {number} offset the current offset from the start of the zip file.
       * @param {String} platform let's pretend we are this platform (change platform dependents fields)
       * @param {Function} encodeFileName the function to encode the file name / comment.
       * @return {Object} the zip parts.
       */
      var generateZipParts = function generateZipParts(streamInfo, streamedContent, streamingEnded, offset, platform, encodeFileName) {
        var file = streamInfo["file"],
          compression = streamInfo["compression"],
          useCustomEncoding = encodeFileName !== utf8.utf8encode,
          encodedFileName = utils.transformTo("string", encodeFileName(file.name)),
          utfEncodedFileName = utils.transformTo("string", utf8.utf8encode(file.name)),
          comment = file.comment,
          encodedComment = utils.transformTo("string", encodeFileName(comment)),
          utfEncodedComment = utils.transformTo("string", utf8.utf8encode(comment)),
          useUTF8ForFileName = utfEncodedFileName.length !== file.name.length,
          useUTF8ForComment = utfEncodedComment.length !== comment.length,
          dosTime,
          dosDate,
          extraFields = "",
          unicodePathExtraField = "",
          unicodeCommentExtraField = "",
          dir = file.dir,
          date = file.date;
        var dataInfo = {
          crc32: 0,
          compressedSize: 0,
          uncompressedSize: 0
        };

        // if the content is streamed, the sizes/crc32 are only available AFTER
        // the end of the stream.
        if (!streamedContent || streamingEnded) {
          dataInfo.crc32 = streamInfo["crc32"];
          dataInfo.compressedSize = streamInfo["compressedSize"];
          dataInfo.uncompressedSize = streamInfo["uncompressedSize"];
        }
        var bitflag = 0;
        if (streamedContent) {
          // Bit 3: the sizes/crc32 are set to zero in the local header.
          // The correct values are put in the data descriptor immediately
          // following the compressed data.
          bitflag |= 0x0008;
        }
        if (!useCustomEncoding && (useUTF8ForFileName || useUTF8ForComment)) {
          // Bit 11: Language encoding flag (EFS).
          bitflag |= 0x0800;
        }
        var extFileAttr = 0;
        var versionMadeBy = 0;
        if (dir) {
          // dos or unix, we set the dos dir flag
          extFileAttr |= 0x00010;
        }
        if (platform === "UNIX") {
          versionMadeBy = 0x031E; // UNIX, version 3.0
          extFileAttr |= generateUnixExternalFileAttr(file.unixPermissions, dir);
        } else {
          // DOS or other, fallback to DOS
          versionMadeBy = 0x0014; // DOS, version 2.0
          extFileAttr |= generateDosExternalFileAttr(file.dosPermissions, dir);
        }

        // date
        // @see http://www.delorie.com/djgpp/doc/rbinter/it/52/13.html
        // @see http://www.delorie.com/djgpp/doc/rbinter/it/65/16.html
        // @see http://www.delorie.com/djgpp/doc/rbinter/it/66/16.html

        dosTime = date.getUTCHours();
        dosTime = dosTime << 6;
        dosTime = dosTime | date.getUTCMinutes();
        dosTime = dosTime << 5;
        dosTime = dosTime | date.getUTCSeconds() / 2;
        dosDate = date.getUTCFullYear() - 1980;
        dosDate = dosDate << 4;
        dosDate = dosDate | date.getUTCMonth() + 1;
        dosDate = dosDate << 5;
        dosDate = dosDate | date.getUTCDate();
        if (useUTF8ForFileName) {
          // set the unicode path extra field. unzip needs at least one extra
          // field to correctly handle unicode path, so using the path is as good
          // as any other information. This could improve the situation with
          // other archive managers too.
          // This field is usually used without the utf8 flag, with a non
          // unicode path in the header (winrar, winzip). This helps (a bit)
          // with the messy Windows' default compressed folders feature but
          // breaks on p7zip which doesn't seek the unicode path extra field.
          // So for now, UTF-8 everywhere !
          unicodePathExtraField =
          // Version
          decToHex(1, 1) +
          // NameCRC32
          decToHex(crc32(encodedFileName), 4) +
          // UnicodeName
          utfEncodedFileName;
          extraFields +=
          // Info-ZIP Unicode Path Extra Field
          "\x75\x70" +
          // size
          decToHex(unicodePathExtraField.length, 2) +
          // content
          unicodePathExtraField;
        }
        if (useUTF8ForComment) {
          unicodeCommentExtraField =
          // Version
          decToHex(1, 1) +
          // CommentCRC32
          decToHex(crc32(encodedComment), 4) +
          // UnicodeName
          utfEncodedComment;
          extraFields +=
          // Info-ZIP Unicode Path Extra Field
          "\x75\x63" +
          // size
          decToHex(unicodeCommentExtraField.length, 2) +
          // content
          unicodeCommentExtraField;
        }
        var header = "";

        // version needed to extract
        header += "\x0A\x00";
        // general purpose bit flag
        header += decToHex(bitflag, 2);
        // compression method
        header += compression.magic;
        // last mod file time
        header += decToHex(dosTime, 2);
        // last mod file date
        header += decToHex(dosDate, 2);
        // crc-32
        header += decToHex(dataInfo.crc32, 4);
        // compressed size
        header += decToHex(dataInfo.compressedSize, 4);
        // uncompressed size
        header += decToHex(dataInfo.uncompressedSize, 4);
        // file name length
        header += decToHex(encodedFileName.length, 2);
        // extra field length
        header += decToHex(extraFields.length, 2);
        var fileRecord = signature.LOCAL_FILE_HEADER + header + encodedFileName + extraFields;
        var dirRecord = signature.CENTRAL_FILE_HEADER +
        // version made by (00: DOS)
        decToHex(versionMadeBy, 2) +
        // file header (common to file and central directory)
        header +
        // file comment length
        decToHex(encodedComment.length, 2) +
        // disk number start
        "\x00\x00" +
        // internal file attributes TODO
        "\x00\x00" +
        // external file attributes
        decToHex(extFileAttr, 4) +
        // relative offset of local header
        decToHex(offset, 4) +
        // file name
        encodedFileName +
        // extra field
        extraFields +
        // file comment
        encodedComment;
        return {
          fileRecord: fileRecord,
          dirRecord: dirRecord
        };
      };

      /**
       * Generate the EOCD record.
       * @param {Number} entriesCount the number of entries in the zip file.
       * @param {Number} centralDirLength the length (in bytes) of the central dir.
       * @param {Number} localDirLength the length (in bytes) of the local dir.
       * @param {String} comment the zip file comment as a binary string.
       * @param {Function} encodeFileName the function to encode the comment.
       * @return {String} the EOCD record.
       */
      var generateCentralDirectoryEnd = function generateCentralDirectoryEnd(entriesCount, centralDirLength, localDirLength, comment, encodeFileName) {
        var dirEnd = "";
        var encodedComment = utils.transformTo("string", encodeFileName(comment));

        // end of central dir signature
        dirEnd = signature.CENTRAL_DIRECTORY_END +
        // number of this disk
        "\x00\x00" +
        // number of the disk with the start of the central directory
        "\x00\x00" +
        // total number of entries in the central directory on this disk
        decToHex(entriesCount, 2) +
        // total number of entries in the central directory
        decToHex(entriesCount, 2) +
        // size of the central directory   4 bytes
        decToHex(centralDirLength, 4) +
        // offset of start of central directory with respect to the starting disk number
        decToHex(localDirLength, 4) +
        // .ZIP file comment length
        decToHex(encodedComment.length, 2) +
        // .ZIP file comment
        encodedComment;
        return dirEnd;
      };

      /**
       * Generate data descriptors for a file entry.
       * @param {Object} streamInfo the hash generated by a worker, containing information
       * on the file entry.
       * @return {String} the data descriptors.
       */
      var generateDataDescriptors = function generateDataDescriptors(streamInfo) {
        var descriptor = "";
        descriptor = signature.DATA_DESCRIPTOR +
        // crc-32                          4 bytes
        decToHex(streamInfo["crc32"], 4) +
        // compressed size                 4 bytes
        decToHex(streamInfo["compressedSize"], 4) +
        // uncompressed size               4 bytes
        decToHex(streamInfo["uncompressedSize"], 4);
        return descriptor;
      };

      /**
       * A worker to concatenate other workers to create a zip file.
       * @param {Boolean} streamFiles `true` to stream the content of the files,
       * `false` to accumulate it.
       * @param {String} comment the comment to use.
       * @param {String} platform the platform to use, "UNIX" or "DOS".
       * @param {Function} encodeFileName the function to encode file names and comments.
       */
      function ZipFileWorker(streamFiles, comment, platform, encodeFileName) {
        GenericWorker.call(this, "ZipFileWorker");
        // The number of bytes written so far. This doesn't count accumulated chunks.
        this.bytesWritten = 0;
        // The comment of the zip file
        this.zipComment = comment;
        // The platform "generating" the zip file.
        this.zipPlatform = platform;
        // the function to encode file names and comments.
        this.encodeFileName = encodeFileName;
        // Should we stream the content of the files ?
        this.streamFiles = streamFiles;
        // If `streamFiles` is false, we will need to accumulate the content of the
        // files to calculate sizes / crc32 (and write them *before* the content).
        // This boolean indicates if we are accumulating chunks (it will change a lot
        // during the lifetime of this worker).
        this.accumulate = false;
        // The buffer receiving chunks when accumulating content.
        this.contentBuffer = [];
        // The list of generated directory records.
        this.dirRecords = [];
        // The offset (in bytes) from the beginning of the zip file for the current source.
        this.currentSourceOffset = 0;
        // The total number of entries in this zip file.
        this.entriesCount = 0;
        // the name of the file currently being added, null when handling the end of the zip file.
        // Used for the emitted metadata.
        this.currentFile = null;
        this._sources = [];
      }
      utils.inherits(ZipFileWorker, GenericWorker);

      /**
       * @see GenericWorker.push
       */
      ZipFileWorker.prototype.push = function (chunk) {
        var currentFilePercent = chunk.meta.percent || 0;
        var entriesCount = this.entriesCount;
        var remainingFiles = this._sources.length;
        if (this.accumulate) {
          this.contentBuffer.push(chunk);
        } else {
          this.bytesWritten += chunk.data.length;
          GenericWorker.prototype.push.call(this, {
            data: chunk.data,
            meta: {
              currentFile: this.currentFile,
              percent: entriesCount ? (currentFilePercent + 100 * (entriesCount - remainingFiles - 1)) / entriesCount : 100
            }
          });
        }
      };

      /**
       * The worker started a new source (an other worker).
       * @param {Object} streamInfo the streamInfo object from the new source.
       */
      ZipFileWorker.prototype.openedSource = function (streamInfo) {
        this.currentSourceOffset = this.bytesWritten;
        this.currentFile = streamInfo["file"].name;
        var streamedContent = this.streamFiles && !streamInfo["file"].dir;

        // don't stream folders (because they don't have any content)
        if (streamedContent) {
          var record = generateZipParts(streamInfo, streamedContent, false, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
          this.push({
            data: record.fileRecord,
            meta: {
              percent: 0
            }
          });
        } else {
          // we need to wait for the whole file before pushing anything
          this.accumulate = true;
        }
      };

      /**
       * The worker finished a source (an other worker).
       * @param {Object} streamInfo the streamInfo object from the finished source.
       */
      ZipFileWorker.prototype.closedSource = function (streamInfo) {
        this.accumulate = false;
        var streamedContent = this.streamFiles && !streamInfo["file"].dir;
        var record = generateZipParts(streamInfo, streamedContent, true, this.currentSourceOffset, this.zipPlatform, this.encodeFileName);
        this.dirRecords.push(record.dirRecord);
        if (streamedContent) {
          // after the streamed file, we put data descriptors
          this.push({
            data: generateDataDescriptors(streamInfo),
            meta: {
              percent: 100
            }
          });
        } else {
          // the content wasn't streamed, we need to push everything now
          // first the file record, then the content
          this.push({
            data: record.fileRecord,
            meta: {
              percent: 0
            }
          });
          while (this.contentBuffer.length) {
            this.push(this.contentBuffer.shift());
          }
        }
        this.currentFile = null;
      };

      /**
       * @see GenericWorker.flush
       */
      ZipFileWorker.prototype.flush = function () {
        var localDirLength = this.bytesWritten;
        for (var i = 0; i < this.dirRecords.length; i++) {
          this.push({
            data: this.dirRecords[i],
            meta: {
              percent: 100
            }
          });
        }
        var centralDirLength = this.bytesWritten - localDirLength;
        var dirEnd = generateCentralDirectoryEnd(this.dirRecords.length, centralDirLength, localDirLength, this.zipComment, this.encodeFileName);
        this.push({
          data: dirEnd,
          meta: {
            percent: 100
          }
        });
      };

      /**
       * Prepare the next source to be read.
       */
      ZipFileWorker.prototype.prepareNextSource = function () {
        this.previous = this._sources.shift();
        this.openedSource(this.previous.streamInfo);
        if (this.isPaused) {
          this.previous.pause();
        } else {
          this.previous.resume();
        }
      };

      /**
       * @see GenericWorker.registerPrevious
       */
      ZipFileWorker.prototype.registerPrevious = function (previous) {
        this._sources.push(previous);
        var self = this;
        previous.on("data", function (chunk) {
          self.processChunk(chunk);
        });
        previous.on("end", function () {
          self.closedSource(self.previous.streamInfo);
          if (self._sources.length) {
            self.prepareNextSource();
          } else {
            self.end();
          }
        });
        previous.on("error", function (e) {
          self.error(e);
        });
        return this;
      };

      /**
       * @see GenericWorker.resume
       */
      ZipFileWorker.prototype.resume = function () {
        if (!GenericWorker.prototype.resume.call(this)) {
          return false;
        }
        if (!this.previous && this._sources.length) {
          this.prepareNextSource();
          return true;
        }
        if (!this.previous && !this._sources.length && !this.generatedError) {
          this.end();
          return true;
        }
      };

      /**
       * @see GenericWorker.error
       */
      ZipFileWorker.prototype.error = function (e) {
        var sources = this._sources;
        if (!GenericWorker.prototype.error.call(this, e)) {
          return false;
        }
        for (var i = 0; i < sources.length; i++) {
          try {
            sources[i].error(e);
          } catch (e) {
            // the `error` exploded, nothing to do
          }
        }
        return true;
      };

      /**
       * @see GenericWorker.lock
       */
      ZipFileWorker.prototype.lock = function () {
        GenericWorker.prototype.lock.call(this);
        var sources = this._sources;
        for (var i = 0; i < sources.length; i++) {
          sources[i].lock();
        }
      };
      module.exports = ZipFileWorker;
    }, {
      "../crc32": 4,
      "../signature": 23,
      "../stream/GenericWorker": 28,
      "../utf8": 31,
      "../utils": 32
    }],
    9: [function (require, module, exports) {
      "use strict";

      var compressions = require("../compressions");
      var ZipFileWorker = require("./ZipFileWorker");

      /**
       * Find the compression to use.
       * @param {String} fileCompression the compression defined at the file level, if any.
       * @param {String} zipCompression the compression defined at the load() level.
       * @return {Object} the compression object to use.
       */
      var getCompression = function getCompression(fileCompression, zipCompression) {
        var compressionName = fileCompression || zipCompression;
        var compression = compressions[compressionName];
        if (!compression) {
          throw new Error(compressionName + " is not a valid compression method !");
        }
        return compression;
      };

      /**
       * Create a worker to generate a zip file.
       * @param {JSZip} zip the JSZip instance at the right root level.
       * @param {Object} options to generate the zip file.
       * @param {String} comment the comment to use.
       */
      exports.generateWorker = function (zip, options, comment) {
        var zipFileWorker = new ZipFileWorker(options.streamFiles, comment, options.platform, options.encodeFileName);
        var entriesCount = 0;
        try {
          zip.forEach(function (relativePath, file) {
            entriesCount++;
            var compression = getCompression(file.options.compression, options.compression);
            var compressionOptions = file.options.compressionOptions || options.compressionOptions || {};
            var dir = file.dir,
              date = file.date;
            file._compressWorker(compression, compressionOptions).withStreamInfo("file", {
              name: relativePath,
              dir: dir,
              date: date,
              comment: file.comment || "",
              unixPermissions: file.unixPermissions,
              dosPermissions: file.dosPermissions
            }).pipe(zipFileWorker);
          });
          zipFileWorker.entriesCount = entriesCount;
        } catch (e) {
          zipFileWorker.error(e);
        }
        return zipFileWorker;
      };
    }, {
      "../compressions": 3,
      "./ZipFileWorker": 8
    }],
    10: [function (require, module, exports) {
      "use strict";

      /**
       * Representation a of zip file in js
       * @constructor
       */
      function JSZip() {
        // if this constructor is used without `new`, it adds `new` before itself:
        if (!(this instanceof JSZip)) {
          return new JSZip();
        }
        if (arguments.length) {
          throw new Error("The constructor with parameters has been removed in JSZip 3.0, please check the upgrade guide.");
        }

        // object containing the files :
        // {
        //   "folder/" : {...},
        //   "folder/data.txt" : {...}
        // }
        // NOTE: we use a null prototype because we do not
        // want filenames like "toString" coming from a zip file
        // to overwrite methods and attributes in a normal Object.
        this.files = Object.create(null);
        this.comment = null;

        // Where we are in the hierarchy
        this.root = "";
        this.clone = function () {
          var newObj = new JSZip();
          for (var i in this) {
            if (typeof this[i] !== "function") {
              newObj[i] = this[i];
            }
          }
          return newObj;
        };
      }
      JSZip.prototype = require("./object");
      JSZip.prototype.loadAsync = require("./load");
      JSZip.support = require("./support");
      JSZip.defaults = require("./defaults");

      // TODO find a better way to handle this version,
      // a require('package.json').version doesn't work with webpack, see #327
      JSZip.version = "3.10.1";
      JSZip.loadAsync = function (content, options) {
        return new JSZip().loadAsync(content, options);
      };
      JSZip.external = require("./external");
      module.exports = JSZip;
    }, {
      "./defaults": 5,
      "./external": 6,
      "./load": 11,
      "./object": 15,
      "./support": 30
    }],
    11: [function (require, module, exports) {
      "use strict";

      var utils = require("./utils");
      var external = require("./external");
      var utf8 = require("./utf8");
      var ZipEntries = require("./zipEntries");
      var Crc32Probe = require("./stream/Crc32Probe");
      var nodejsUtils = require("./nodejsUtils");

      /**
       * Check the CRC32 of an entry.
       * @param {ZipEntry} zipEntry the zip entry to check.
       * @return {Promise} the result.
       */
      function checkEntryCRC32(zipEntry) {
        return new external.Promise(function (resolve, reject) {
          var worker = zipEntry.decompressed.getContentWorker().pipe(new Crc32Probe());
          worker.on("error", function (e) {
            reject(e);
          }).on("end", function () {
            if (worker.streamInfo.crc32 !== zipEntry.decompressed.crc32) {
              reject(new Error("Corrupted zip : CRC32 mismatch"));
            } else {
              resolve();
            }
          }).resume();
        });
      }
      module.exports = function (data, options) {
        var zip = this;
        options = utils.extend(options || {}, {
          base64: false,
          checkCRC32: false,
          optimizedBinaryString: false,
          createFolders: false,
          decodeFileName: utf8.utf8decode
        });
        if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
          return external.Promise.reject(new Error("JSZip can't accept a stream when loading a zip file."));
        }
        return utils.prepareContent("the loaded zip file", data, true, options.optimizedBinaryString, options.base64).then(function (data) {
          var zipEntries = new ZipEntries(options);
          zipEntries.load(data);
          return zipEntries;
        }).then(function checkCRC32(zipEntries) {
          var promises = [external.Promise.resolve(zipEntries)];
          var files = zipEntries.files;
          if (options.checkCRC32) {
            for (var i = 0; i < files.length; i++) {
              promises.push(checkEntryCRC32(files[i]));
            }
          }
          return external.Promise.all(promises);
        }).then(function addFiles(results) {
          var zipEntries = results.shift();
          var files = zipEntries.files;
          for (var i = 0; i < files.length; i++) {
            var input = files[i];
            var unsafeName = input.fileNameStr;
            var safeName = utils.resolve(input.fileNameStr);
            zip.file(safeName, input.decompressed, {
              binary: true,
              optimizedBinaryString: true,
              date: input.date,
              dir: input.dir,
              comment: input.fileCommentStr.length ? input.fileCommentStr : null,
              unixPermissions: input.unixPermissions,
              dosPermissions: input.dosPermissions,
              createFolders: options.createFolders
            });
            if (!input.dir) {
              zip.file(safeName).unsafeOriginalName = unsafeName;
            }
          }
          if (zipEntries.zipComment.length) {
            zip.comment = zipEntries.zipComment;
          }
          return zip;
        });
      };
    }, {
      "./external": 6,
      "./nodejsUtils": 14,
      "./stream/Crc32Probe": 25,
      "./utf8": 31,
      "./utils": 32,
      "./zipEntries": 33
    }],
    12: [function (require, module, exports) {
      "use strict";

      var utils = require("../utils");
      var GenericWorker = require("../stream/GenericWorker");

      /**
       * A worker that use a nodejs stream as source.
       * @constructor
       * @param {String} filename the name of the file entry for this stream.
       * @param {Readable} stream the nodejs stream.
       */
      function NodejsStreamInputAdapter(filename, stream) {
        GenericWorker.call(this, "Nodejs stream input adapter for " + filename);
        this._upstreamEnded = false;
        this._bindStream(stream);
      }
      utils.inherits(NodejsStreamInputAdapter, GenericWorker);

      /**
       * Prepare the stream and bind the callbacks on it.
       * Do this ASAP on node 0.10 ! A lazy binding doesn't always work.
       * @param {Stream} stream the nodejs stream to use.
       */
      NodejsStreamInputAdapter.prototype._bindStream = function (stream) {
        var self = this;
        this._stream = stream;
        stream.pause();
        stream.on("data", function (chunk) {
          self.push({
            data: chunk,
            meta: {
              percent: 0
            }
          });
        }).on("error", function (e) {
          if (self.isPaused) {
            this.generatedError = e;
          } else {
            self.error(e);
          }
        }).on("end", function () {
          if (self.isPaused) {
            self._upstreamEnded = true;
          } else {
            self.end();
          }
        });
      };
      NodejsStreamInputAdapter.prototype.pause = function () {
        if (!GenericWorker.prototype.pause.call(this)) {
          return false;
        }
        this._stream.pause();
        return true;
      };
      NodejsStreamInputAdapter.prototype.resume = function () {
        if (!GenericWorker.prototype.resume.call(this)) {
          return false;
        }
        if (this._upstreamEnded) {
          this.end();
        } else {
          this._stream.resume();
        }
        return true;
      };
      module.exports = NodejsStreamInputAdapter;
    }, {
      "../stream/GenericWorker": 28,
      "../utils": 32
    }],
    13: [function (require, module, exports) {
      "use strict";

      var Readable = require("readable-stream").Readable;
      var utils = require("../utils");
      utils.inherits(NodejsStreamOutputAdapter, Readable);

      /**
      * A nodejs stream using a worker as source.
      * @see the SourceWrapper in http://nodejs.org/api/stream.html
      * @constructor
      * @param {StreamHelper} helper the helper wrapping the worker
      * @param {Object} options the nodejs stream options
      * @param {Function} updateCb the update callback.
      */
      function NodejsStreamOutputAdapter(helper, options, updateCb) {
        Readable.call(this, options);
        this._helper = helper;
        var self = this;
        helper.on("data", function (data, meta) {
          if (!self.push(data)) {
            self._helper.pause();
          }
          if (updateCb) {
            updateCb(meta);
          }
        }).on("error", function (e) {
          self.emit("error", e);
        }).on("end", function () {
          self.push(null);
        });
      }
      NodejsStreamOutputAdapter.prototype._read = function () {
        this._helper.resume();
      };
      module.exports = NodejsStreamOutputAdapter;
    }, {
      "../utils": 32,
      "readable-stream": 16
    }],
    14: [function (require, module, exports) {
      "use strict";

      module.exports = {
        /**
         * True if this is running in Nodejs, will be undefined in a browser.
         * In a browser, browserify won't include this file and the whole module
         * will be resolved an empty object.
         */
        isNode: typeof Buffer !== "undefined",
        /**
         * Create a new nodejs Buffer from an existing content.
         * @param {Object} data the data to pass to the constructor.
         * @param {String} encoding the encoding to use.
         * @return {Buffer} a new Buffer.
         */
        newBufferFrom: function newBufferFrom(data, encoding) {
          if (Buffer.from && Buffer.from !== Uint8Array.from) {
            return Buffer.from(data, encoding);
          } else {
            if (typeof data === "number") {
              // Safeguard for old Node.js versions. On newer versions,
              // Buffer.from(number) / Buffer(number, encoding) already throw.
              throw new Error("The \"data\" argument must not be a number");
            }
            return new Buffer(data, encoding);
          }
        },
        /**
         * Create a new nodejs Buffer with the specified size.
         * @param {Integer} size the size of the buffer.
         * @return {Buffer} a new Buffer.
         */
        allocBuffer: function allocBuffer(size) {
          if (Buffer.alloc) {
            return Buffer.alloc(size);
          } else {
            var buf = new Buffer(size);
            buf.fill(0);
            return buf;
          }
        },
        /**
         * Find out if an object is a Buffer.
         * @param {Object} b the object to test.
         * @return {Boolean} true if the object is a Buffer, false otherwise.
         */
        isBuffer: function isBuffer(b) {
          return Buffer.isBuffer(b);
        },
        isStream: function isStream(obj) {
          return obj && typeof obj.on === "function" && typeof obj.pause === "function" && typeof obj.resume === "function";
        }
      };
    }, {}],
    15: [function (require, module, exports) {
      "use strict";

      var utf8 = require("./utf8");
      var utils = require("./utils");
      var GenericWorker = require("./stream/GenericWorker");
      var StreamHelper = require("./stream/StreamHelper");
      var defaults = require("./defaults");
      var CompressedObject = require("./compressedObject");
      var ZipObject = require("./zipObject");
      var generate = require("./generate");
      var nodejsUtils = require("./nodejsUtils");
      var NodejsStreamInputAdapter = require("./nodejs/NodejsStreamInputAdapter");

      /**
       * Add a file in the current folder.
       * @private
       * @param {string} name the name of the file
       * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data of the file
       * @param {Object} originalOptions the options of the file
       * @return {Object} the new file.
       */
      var fileAdd = function fileAdd(name, data, originalOptions) {
        // be sure sub folders exist
        var dataType = utils.getTypeOf(data),
          parent;

        /*
         * Correct options.
         */

        var o = utils.extend(originalOptions || {}, defaults);
        o.date = o.date || new Date();
        if (o.compression !== null) {
          o.compression = o.compression.toUpperCase();
        }
        if (typeof o.unixPermissions === "string") {
          o.unixPermissions = parseInt(o.unixPermissions, 8);
        }

        // UNX_IFDIR  0040000 see zipinfo.c
        if (o.unixPermissions && o.unixPermissions & 0x4000) {
          o.dir = true;
        }
        // Bit 4    Directory
        if (o.dosPermissions && o.dosPermissions & 0x0010) {
          o.dir = true;
        }
        if (o.dir) {
          name = forceTrailingSlash(name);
        }
        if (o.createFolders && (parent = parentFolder(name))) {
          folderAdd.call(this, parent, true);
        }
        var isUnicodeString = dataType === "string" && o.binary === false && o.base64 === false;
        if (!originalOptions || typeof originalOptions.binary === "undefined") {
          o.binary = !isUnicodeString;
        }
        var isCompressedEmpty = data instanceof CompressedObject && data.uncompressedSize === 0;
        if (isCompressedEmpty || o.dir || !data || data.length === 0) {
          o.base64 = false;
          o.binary = true;
          data = "";
          o.compression = "STORE";
          dataType = "string";
        }

        /*
         * Convert content to fit.
         */

        var zipObjectContent = null;
        if (data instanceof CompressedObject || data instanceof GenericWorker) {
          zipObjectContent = data;
        } else if (nodejsUtils.isNode && nodejsUtils.isStream(data)) {
          zipObjectContent = new NodejsStreamInputAdapter(name, data);
        } else {
          zipObjectContent = utils.prepareContent(name, data, o.binary, o.optimizedBinaryString, o.base64);
        }
        var object = new ZipObject(name, zipObjectContent, o);
        this.files[name] = object;
        /*
        TODO: we can't throw an exception because we have async promises
        (we can have a promise of a Date() for example) but returning a
        promise is useless because file(name, data) returns the JSZip
        object for chaining. Should we break that to allow the user
        to catch the error ?
         return external.Promise.resolve(zipObjectContent)
        .then(function () {
            return object;
        });
        */
      };

      /**
       * Find the parent folder of the path.
       * @private
       * @param {string} path the path to use
       * @return {string} the parent folder, or ""
       */
      var parentFolder = function parentFolder(path) {
        if (path.slice(-1) === "/") {
          path = path.substring(0, path.length - 1);
        }
        var lastSlash = path.lastIndexOf("/");
        return lastSlash > 0 ? path.substring(0, lastSlash) : "";
      };

      /**
       * Returns the path with a slash at the end.
       * @private
       * @param {String} path the path to check.
       * @return {String} the path with a trailing slash.
       */
      var forceTrailingSlash = function forceTrailingSlash(path) {
        // Check the name ends with a /
        if (path.slice(-1) !== "/") {
          path += "/"; // IE doesn't like substr(-1)
        }
        return path;
      };

      /**
       * Add a (sub) folder in the current folder.
       * @private
       * @param {string} name the folder's name
       * @param {boolean=} [createFolders] If true, automatically create sub
       *  folders. Defaults to false.
       * @return {Object} the new folder.
       */
      var folderAdd = function folderAdd(name, createFolders) {
        createFolders = typeof createFolders !== "undefined" ? createFolders : defaults.createFolders;
        name = forceTrailingSlash(name);

        // Does this folder already exist?
        if (!this.files[name]) {
          fileAdd.call(this, name, null, {
            dir: true,
            createFolders: createFolders
          });
        }
        return this.files[name];
      };

      /**
      * Cross-window, cross-Node-context regular expression detection
      * @param  {Object}  object Anything
      * @return {Boolean}        true if the object is a regular expression,
      * false otherwise
      */
      function isRegExp(object) {
        return Object.prototype.toString.call(object) === "[object RegExp]";
      }

      // return the actual prototype of JSZip
      var out = {
        /**
         * @see loadAsync
         */
        load: function load() {
          throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
        },
        /**
         * Call a callback function for each entry at this folder level.
         * @param {Function} cb the callback function:
         * function (relativePath, file) {...}
         * It takes 2 arguments : the relative path and the file.
         */
        forEach: function forEach(cb) {
          var filename, relativePath, file;
          // ignore warning about unwanted properties because this.files is a null prototype object
          /* eslint-disable-next-line guard-for-in */
          for (filename in this.files) {
            file = this.files[filename];
            relativePath = filename.slice(this.root.length, filename.length);
            if (relativePath && filename.slice(0, this.root.length) === this.root) {
              // the file is in the current root
              cb(relativePath, file); // TODO reverse the parameters ? need to be clean AND consistent with the filter search fn...
            }
          }
        },
        /**
         * Filter nested files/folders with the specified function.
         * @param {Function} search the predicate to use :
         * function (relativePath, file) {...}
         * It takes 2 arguments : the relative path and the file.
         * @return {Array} An array of matching elements.
         */
        filter: function filter(search) {
          var result = [];
          this.forEach(function (relativePath, entry) {
            if (search(relativePath, entry)) {
              // the file matches the function
              result.push(entry);
            }
          });
          return result;
        },
        /**
         * Add a file to the zip file, or search a file.
         * @param   {string|RegExp} name The name of the file to add (if data is defined),
         * the name of the file to find (if no data) or a regex to match files.
         * @param   {String|ArrayBuffer|Uint8Array|Buffer} data  The file data, either raw or base64 encoded
         * @param   {Object} o     File options
         * @return  {JSZip|Object|Array} this JSZip object (when adding a file),
         * a file (when searching by string) or an array of files (when searching by regex).
         */
        file: function file(name, data, o) {
          if (arguments.length === 1) {
            if (isRegExp(name)) {
              var regexp = name;
              return this.filter(function (relativePath, file) {
                return !file.dir && regexp.test(relativePath);
              });
            } else {
              // text
              var obj = this.files[this.root + name];
              if (obj && !obj.dir) {
                return obj;
              } else {
                return null;
              }
            }
          } else {
            // more than one argument : we have data !
            name = this.root + name;
            fileAdd.call(this, name, data, o);
          }
          return this;
        },
        /**
         * Add a directory to the zip file, or search.
         * @param   {String|RegExp} arg The name of the directory to add, or a regex to search folders.
         * @return  {JSZip} an object with the new directory as the root, or an array containing matching folders.
         */
        folder: function folder(arg) {
          if (!arg) {
            return this;
          }
          if (isRegExp(arg)) {
            return this.filter(function (relativePath, file) {
              return file.dir && arg.test(relativePath);
            });
          }

          // else, name is a new folder
          var name = this.root + arg;
          var newFolder = folderAdd.call(this, name);

          // Allow chaining by returning a new object with this folder as the root
          var ret = this.clone();
          ret.root = newFolder.name;
          return ret;
        },
        /**
         * Delete a file, or a directory and all sub-files, from the zip
         * @param {string} name the name of the file to delete
         * @return {JSZip} this JSZip object
         */
        remove: function remove(name) {
          name = this.root + name;
          var file = this.files[name];
          if (!file) {
            // Look for any folders
            if (name.slice(-1) !== "/") {
              name += "/";
            }
            file = this.files[name];
          }
          if (file && !file.dir) {
            // file
            delete this.files[name];
          } else {
            // maybe a folder, delete recursively
            var kids = this.filter(function (relativePath, file) {
              return file.name.slice(0, name.length) === name;
            });
            for (var i = 0; i < kids.length; i++) {
              delete this.files[kids[i].name];
            }
          }
          return this;
        },
        /**
         * @deprecated This method has been removed in JSZip 3.0, please check the upgrade guide.
         */
        generate: function generate() {
          throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
        },
        /**
         * Generate the complete zip file as an internal stream.
         * @param {Object} options the options to generate the zip file :
         * - compression, "STORE" by default.
         * - type, "base64" by default. Values are : string, base64, uint8array, arraybuffer, blob.
         * @return {StreamHelper} the streamed zip file.
         */
        generateInternalStream: function generateInternalStream(options) {
          var worker,
            opts = {};
          try {
            opts = utils.extend(options || {}, {
              streamFiles: false,
              compression: "STORE",
              compressionOptions: null,
              type: "",
              platform: "DOS",
              comment: null,
              mimeType: "application/zip",
              encodeFileName: utf8.utf8encode
            });
            opts.type = opts.type.toLowerCase();
            opts.compression = opts.compression.toUpperCase();

            // "binarystring" is preferred but the internals use "string".
            if (opts.type === "binarystring") {
              opts.type = "string";
            }
            if (!opts.type) {
              throw new Error("No output type specified.");
            }
            utils.checkSupport(opts.type);

            // accept nodejs `process.platform`
            if (opts.platform === "darwin" || opts.platform === "freebsd" || opts.platform === "linux" || opts.platform === "sunos") {
              opts.platform = "UNIX";
            }
            if (opts.platform === "win32") {
              opts.platform = "DOS";
            }
            var comment = opts.comment || this.comment || "";
            worker = generate.generateWorker(this, opts, comment);
          } catch (e) {
            worker = new GenericWorker("error");
            worker.error(e);
          }
          return new StreamHelper(worker, opts.type || "string", opts.mimeType);
        },
        /**
         * Generate the complete zip file asynchronously.
         * @see generateInternalStream
         */
        generateAsync: function generateAsync(options, onUpdate) {
          return this.generateInternalStream(options).accumulate(onUpdate);
        },
        /**
         * Generate the complete zip file asynchronously.
         * @see generateInternalStream
         */
        generateNodeStream: function generateNodeStream(options, onUpdate) {
          options = options || {};
          if (!options.type) {
            options.type = "nodebuffer";
          }
          return this.generateInternalStream(options).toNodejsStream(onUpdate);
        }
      };
      module.exports = out;
    }, {
      "./compressedObject": 2,
      "./defaults": 5,
      "./generate": 9,
      "./nodejs/NodejsStreamInputAdapter": 12,
      "./nodejsUtils": 14,
      "./stream/GenericWorker": 28,
      "./stream/StreamHelper": 29,
      "./utf8": 31,
      "./utils": 32,
      "./zipObject": 35
    }],
    16: [function (require, module, exports) {
      "use strict";

      /*
       * This file is used by module bundlers (browserify/webpack/etc) when
       * including a stream implementation. We use "readable-stream" to get a
       * consistent behavior between nodejs versions but bundlers often have a shim
       * for "stream". Using this shim greatly improve the compatibility and greatly
       * reduce the final size of the bundle (only one stream implementation, not
       * two).
       */
      module.exports = require("stream");
    }, {
      "stream": undefined
    }],
    17: [function (require, module, exports) {
      "use strict";

      var DataReader = require("./DataReader");
      var utils = require("../utils");
      function ArrayReader(data) {
        DataReader.call(this, data);
        for (var i = 0; i < this.data.length; i++) {
          data[i] = data[i] & 0xFF;
        }
      }
      utils.inherits(ArrayReader, DataReader);
      /**
       * @see DataReader.byteAt
       */
      ArrayReader.prototype.byteAt = function (i) {
        return this.data[this.zero + i];
      };
      /**
       * @see DataReader.lastIndexOfSignature
       */
      ArrayReader.prototype.lastIndexOfSignature = function (sig) {
        var sig0 = sig.charCodeAt(0),
          sig1 = sig.charCodeAt(1),
          sig2 = sig.charCodeAt(2),
          sig3 = sig.charCodeAt(3);
        for (var i = this.length - 4; i >= 0; --i) {
          if (this.data[i] === sig0 && this.data[i + 1] === sig1 && this.data[i + 2] === sig2 && this.data[i + 3] === sig3) {
            return i - this.zero;
          }
        }
        return -1;
      };
      /**
       * @see DataReader.readAndCheckSignature
       */
      ArrayReader.prototype.readAndCheckSignature = function (sig) {
        var sig0 = sig.charCodeAt(0),
          sig1 = sig.charCodeAt(1),
          sig2 = sig.charCodeAt(2),
          sig3 = sig.charCodeAt(3),
          data = this.readData(4);
        return sig0 === data[0] && sig1 === data[1] && sig2 === data[2] && sig3 === data[3];
      };
      /**
       * @see DataReader.readData
       */
      ArrayReader.prototype.readData = function (size) {
        this.checkOffset(size);
        if (size === 0) {
          return [];
        }
        var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
        this.index += size;
        return result;
      };
      module.exports = ArrayReader;
    }, {
      "../utils": 32,
      "./DataReader": 18
    }],
    18: [function (require, module, exports) {
      "use strict";

      var utils = require("../utils");
      function DataReader(data) {
        this.data = data; // type : see implementation
        this.length = data.length;
        this.index = 0;
        this.zero = 0;
      }
      DataReader.prototype = {
        /**
         * Check that the offset will not go too far.
         * @param {string} offset the additional offset to check.
         * @throws {Error} an Error if the offset is out of bounds.
         */
        checkOffset: function checkOffset(offset) {
          this.checkIndex(this.index + offset);
        },
        /**
         * Check that the specified index will not be too far.
         * @param {string} newIndex the index to check.
         * @throws {Error} an Error if the index is out of bounds.
         */
        checkIndex: function checkIndex(newIndex) {
          if (this.length < this.zero + newIndex || newIndex < 0) {
            throw new Error("End of data reached (data length = " + this.length + ", asked index = " + newIndex + "). Corrupted zip ?");
          }
        },
        /**
         * Change the index.
         * @param {number} newIndex The new index.
         * @throws {Error} if the new index is out of the data.
         */
        setIndex: function setIndex(newIndex) {
          this.checkIndex(newIndex);
          this.index = newIndex;
        },
        /**
         * Skip the next n bytes.
         * @param {number} n the number of bytes to skip.
         * @throws {Error} if the new index is out of the data.
         */
        skip: function skip(n) {
          this.setIndex(this.index + n);
        },
        /**
         * Get the byte at the specified index.
         * @param {number} i the index to use.
         * @return {number} a byte.
         */
        byteAt: function byteAt() {
          // see implementations
        },
        /**
         * Get the next number with a given byte size.
         * @param {number} size the number of bytes to read.
         * @return {number} the corresponding number.
         */
        readInt: function readInt(size) {
          var result = 0,
            i;
          this.checkOffset(size);
          for (i = this.index + size - 1; i >= this.index; i--) {
            result = (result << 8) + this.byteAt(i);
          }
          this.index += size;
          return result;
        },
        /**
         * Get the next string with a given byte size.
         * @param {number} size the number of bytes to read.
         * @return {string} the corresponding string.
         */
        readString: function readString(size) {
          return utils.transformTo("string", this.readData(size));
        },
        /**
         * Get raw data without conversion, <size> bytes.
         * @param {number} size the number of bytes to read.
         * @return {Object} the raw data, implementation specific.
         */
        readData: function readData() {
          // see implementations
        },
        /**
         * Find the last occurrence of a zip signature (4 bytes).
         * @param {string} sig the signature to find.
         * @return {number} the index of the last occurrence, -1 if not found.
         */
        lastIndexOfSignature: function lastIndexOfSignature() {
          // see implementations
        },
        /**
         * Read the signature (4 bytes) at the current position and compare it with sig.
         * @param {string} sig the expected signature
         * @return {boolean} true if the signature matches, false otherwise.
         */
        readAndCheckSignature: function readAndCheckSignature() {
          // see implementations
        },
        /**
         * Get the next date.
         * @return {Date} the date.
         */
        readDate: function readDate() {
          var dostime = this.readInt(4);
          return new Date(Date.UTC((dostime >> 25 & 0x7f) + 1980,
          // year
          (dostime >> 21 & 0x0f) - 1,
          // month
          dostime >> 16 & 0x1f,
          // day
          dostime >> 11 & 0x1f,
          // hour
          dostime >> 5 & 0x3f,
          // minute
          (dostime & 0x1f) << 1)); // second
        }
      };
      module.exports = DataReader;
    }, {
      "../utils": 32
    }],
    19: [function (require, module, exports) {
      "use strict";

      var Uint8ArrayReader = require("./Uint8ArrayReader");
      var utils = require("../utils");
      function NodeBufferReader(data) {
        Uint8ArrayReader.call(this, data);
      }
      utils.inherits(NodeBufferReader, Uint8ArrayReader);

      /**
       * @see DataReader.readData
       */
      NodeBufferReader.prototype.readData = function (size) {
        this.checkOffset(size);
        var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
        this.index += size;
        return result;
      };
      module.exports = NodeBufferReader;
    }, {
      "../utils": 32,
      "./Uint8ArrayReader": 21
    }],
    20: [function (require, module, exports) {
      "use strict";

      var DataReader = require("./DataReader");
      var utils = require("../utils");
      function StringReader(data) {
        DataReader.call(this, data);
      }
      utils.inherits(StringReader, DataReader);
      /**
       * @see DataReader.byteAt
       */
      StringReader.prototype.byteAt = function (i) {
        return this.data.charCodeAt(this.zero + i);
      };
      /**
       * @see DataReader.lastIndexOfSignature
       */
      StringReader.prototype.lastIndexOfSignature = function (sig) {
        return this.data.lastIndexOf(sig) - this.zero;
      };
      /**
       * @see DataReader.readAndCheckSignature
       */
      StringReader.prototype.readAndCheckSignature = function (sig) {
        var data = this.readData(4);
        return sig === data;
      };
      /**
       * @see DataReader.readData
       */
      StringReader.prototype.readData = function (size) {
        this.checkOffset(size);
        // this will work because the constructor applied the "& 0xff" mask.
        var result = this.data.slice(this.zero + this.index, this.zero + this.index + size);
        this.index += size;
        return result;
      };
      module.exports = StringReader;
    }, {
      "../utils": 32,
      "./DataReader": 18
    }],
    21: [function (require, module, exports) {
      "use strict";

      var ArrayReader = require("./ArrayReader");
      var utils = require("../utils");
      function Uint8ArrayReader(data) {
        ArrayReader.call(this, data);
      }
      utils.inherits(Uint8ArrayReader, ArrayReader);
      /**
       * @see DataReader.readData
       */
      Uint8ArrayReader.prototype.readData = function (size) {
        this.checkOffset(size);
        if (size === 0) {
          // in IE10, when using subarray(idx, idx), we get the array [0x00] instead of [].
          return new Uint8Array(0);
        }
        var result = this.data.subarray(this.zero + this.index, this.zero + this.index + size);
        this.index += size;
        return result;
      };
      module.exports = Uint8ArrayReader;
    }, {
      "../utils": 32,
      "./ArrayReader": 17
    }],
    22: [function (require, module, exports) {
      "use strict";

      var utils = require("../utils");
      var support = require("../support");
      var ArrayReader = require("./ArrayReader");
      var StringReader = require("./StringReader");
      var NodeBufferReader = require("./NodeBufferReader");
      var Uint8ArrayReader = require("./Uint8ArrayReader");

      /**
       * Create a reader adapted to the data.
       * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data to read.
       * @return {DataReader} the data reader.
       */
      module.exports = function (data) {
        var type = utils.getTypeOf(data);
        utils.checkSupport(type);
        if (type === "string" && !support.uint8array) {
          return new StringReader(data);
        }
        if (type === "nodebuffer") {
          return new NodeBufferReader(data);
        }
        if (support.uint8array) {
          return new Uint8ArrayReader(utils.transformTo("uint8array", data));
        }
        return new ArrayReader(utils.transformTo("array", data));
      };
    }, {
      "../support": 30,
      "../utils": 32,
      "./ArrayReader": 17,
      "./NodeBufferReader": 19,
      "./StringReader": 20,
      "./Uint8ArrayReader": 21
    }],
    23: [function (require, module, exports) {
      "use strict";

      exports.LOCAL_FILE_HEADER = "PK\x03\x04";
      exports.CENTRAL_FILE_HEADER = "PK\x01\x02";
      exports.CENTRAL_DIRECTORY_END = "PK\x05\x06";
      exports.ZIP64_CENTRAL_DIRECTORY_LOCATOR = "PK\x06\x07";
      exports.ZIP64_CENTRAL_DIRECTORY_END = "PK\x06\x06";
      exports.DATA_DESCRIPTOR = "PK\x07\x08";
    }, {}],
    24: [function (require, module, exports) {
      "use strict";

      var GenericWorker = require("./GenericWorker");
      var utils = require("../utils");

      /**
       * A worker which convert chunks to a specified type.
       * @constructor
       * @param {String} destType the destination type.
       */
      function ConvertWorker(destType) {
        GenericWorker.call(this, "ConvertWorker to " + destType);
        this.destType = destType;
      }
      utils.inherits(ConvertWorker, GenericWorker);

      /**
       * @see GenericWorker.processChunk
       */
      ConvertWorker.prototype.processChunk = function (chunk) {
        this.push({
          data: utils.transformTo(this.destType, chunk.data),
          meta: chunk.meta
        });
      };
      module.exports = ConvertWorker;
    }, {
      "../utils": 32,
      "./GenericWorker": 28
    }],
    25: [function (require, module, exports) {
      "use strict";

      var GenericWorker = require("./GenericWorker");
      var crc32 = require("../crc32");
      var utils = require("../utils");

      /**
       * A worker which calculate the crc32 of the data flowing through.
       * @constructor
       */
      function Crc32Probe() {
        GenericWorker.call(this, "Crc32Probe");
        this.withStreamInfo("crc32", 0);
      }
      utils.inherits(Crc32Probe, GenericWorker);

      /**
       * @see GenericWorker.processChunk
       */
      Crc32Probe.prototype.processChunk = function (chunk) {
        this.streamInfo.crc32 = crc32(chunk.data, this.streamInfo.crc32 || 0);
        this.push(chunk);
      };
      module.exports = Crc32Probe;
    }, {
      "../crc32": 4,
      "../utils": 32,
      "./GenericWorker": 28
    }],
    26: [function (require, module, exports) {
      "use strict";

      var utils = require("../utils");
      var GenericWorker = require("./GenericWorker");

      /**
       * A worker which calculate the total length of the data flowing through.
       * @constructor
       * @param {String} propName the name used to expose the length
       */
      function DataLengthProbe(propName) {
        GenericWorker.call(this, "DataLengthProbe for " + propName);
        this.propName = propName;
        this.withStreamInfo(propName, 0);
      }
      utils.inherits(DataLengthProbe, GenericWorker);

      /**
       * @see GenericWorker.processChunk
       */
      DataLengthProbe.prototype.processChunk = function (chunk) {
        if (chunk) {
          var length = this.streamInfo[this.propName] || 0;
          this.streamInfo[this.propName] = length + chunk.data.length;
        }
        GenericWorker.prototype.processChunk.call(this, chunk);
      };
      module.exports = DataLengthProbe;
    }, {
      "../utils": 32,
      "./GenericWorker": 28
    }],
    27: [function (require, module, exports) {
      "use strict";

      var utils = require("../utils");
      var GenericWorker = require("./GenericWorker");

      // the size of the generated chunks
      // TODO expose this as a public variable
      var DEFAULT_BLOCK_SIZE = 16 * 1024;

      /**
       * A worker that reads a content and emits chunks.
       * @constructor
       * @param {Promise} dataP the promise of the data to split
       */
      function DataWorker(dataP) {
        GenericWorker.call(this, "DataWorker");
        var self = this;
        this.dataIsReady = false;
        this.index = 0;
        this.max = 0;
        this.data = null;
        this.type = "";
        this._tickScheduled = false;
        dataP.then(function (data) {
          self.dataIsReady = true;
          self.data = data;
          self.max = data && data.length || 0;
          self.type = utils.getTypeOf(data);
          if (!self.isPaused) {
            self._tickAndRepeat();
          }
        }, function (e) {
          self.error(e);
        });
      }
      utils.inherits(DataWorker, GenericWorker);

      /**
       * @see GenericWorker.cleanUp
       */
      DataWorker.prototype.cleanUp = function () {
        GenericWorker.prototype.cleanUp.call(this);
        this.data = null;
      };

      /**
       * @see GenericWorker.resume
       */
      DataWorker.prototype.resume = function () {
        if (!GenericWorker.prototype.resume.call(this)) {
          return false;
        }
        if (!this._tickScheduled && this.dataIsReady) {
          this._tickScheduled = true;
          utils.delay(this._tickAndRepeat, [], this);
        }
        return true;
      };

      /**
       * Trigger a tick a schedule an other call to this function.
       */
      DataWorker.prototype._tickAndRepeat = function () {
        this._tickScheduled = false;
        if (this.isPaused || this.isFinished) {
          return;
        }
        this._tick();
        if (!this.isFinished) {
          utils.delay(this._tickAndRepeat, [], this);
          this._tickScheduled = true;
        }
      };

      /**
       * Read and push a chunk.
       */
      DataWorker.prototype._tick = function () {
        if (this.isPaused || this.isFinished) {
          return false;
        }
        var size = DEFAULT_BLOCK_SIZE;
        var data = null,
          nextIndex = Math.min(this.max, this.index + size);
        if (this.index >= this.max) {
          // EOF
          return this.end();
        } else {
          switch (this.type) {
            case "string":
              data = this.data.substring(this.index, nextIndex);
              break;
            case "uint8array":
              data = this.data.subarray(this.index, nextIndex);
              break;
            case "array":
            case "nodebuffer":
              data = this.data.slice(this.index, nextIndex);
              break;
          }
          this.index = nextIndex;
          return this.push({
            data: data,
            meta: {
              percent: this.max ? this.index / this.max * 100 : 0
            }
          });
        }
      };
      module.exports = DataWorker;
    }, {
      "../utils": 32,
      "./GenericWorker": 28
    }],
    28: [function (require, module, exports) {
      "use strict";

      /**
       * A worker that does nothing but passing chunks to the next one. This is like
       * a nodejs stream but with some differences. On the good side :
       * - it works on IE 6-9 without any issue / polyfill
       * - it weights less than the full dependencies bundled with browserify
       * - it forwards errors (no need to declare an error handler EVERYWHERE)
       *
       * A chunk is an object with 2 attributes : `meta` and `data`. The former is an
       * object containing anything (`percent` for example), see each worker for more
       * details. The latter is the real data (String, Uint8Array, etc).
       *
       * @constructor
       * @param {String} name the name of the stream (mainly used for debugging purposes)
       */
      function GenericWorker(name) {
        // the name of the worker
        this.name = name || "default";
        // an object containing metadata about the workers chain
        this.streamInfo = {};
        // an error which happened when the worker was paused
        this.generatedError = null;
        // an object containing metadata to be merged by this worker into the general metadata
        this.extraStreamInfo = {};
        // true if the stream is paused (and should not do anything), false otherwise
        this.isPaused = true;
        // true if the stream is finished (and should not do anything), false otherwise
        this.isFinished = false;
        // true if the stream is locked to prevent further structure updates (pipe), false otherwise
        this.isLocked = false;
        // the event listeners
        this._listeners = {
          "data": [],
          "end": [],
          "error": []
        };
        // the previous worker, if any
        this.previous = null;
      }
      GenericWorker.prototype = {
        /**
         * Push a chunk to the next workers.
         * @param {Object} chunk the chunk to push
         */
        push: function push(chunk) {
          this.emit("data", chunk);
        },
        /**
         * End the stream.
         * @return {Boolean} true if this call ended the worker, false otherwise.
         */
        end: function end() {
          if (this.isFinished) {
            return false;
          }
          this.flush();
          try {
            this.emit("end");
            this.cleanUp();
            this.isFinished = true;
          } catch (e) {
            this.emit("error", e);
          }
          return true;
        },
        /**
         * End the stream with an error.
         * @param {Error} e the error which caused the premature end.
         * @return {Boolean} true if this call ended the worker with an error, false otherwise.
         */
        error: function error(e) {
          if (this.isFinished) {
            return false;
          }
          if (this.isPaused) {
            this.generatedError = e;
          } else {
            this.isFinished = true;
            this.emit("error", e);

            // in the workers chain exploded in the middle of the chain,
            // the error event will go downward but we also need to notify
            // workers upward that there has been an error.
            if (this.previous) {
              this.previous.error(e);
            }
            this.cleanUp();
          }
          return true;
        },
        /**
         * Add a callback on an event.
         * @param {String} name the name of the event (data, end, error)
         * @param {Function} listener the function to call when the event is triggered
         * @return {GenericWorker} the current object for chainability
         */
        on: function on(name, listener) {
          this._listeners[name].push(listener);
          return this;
        },
        /**
         * Clean any references when a worker is ending.
         */
        cleanUp: function cleanUp() {
          this.streamInfo = this.generatedError = this.extraStreamInfo = null;
          this._listeners = [];
        },
        /**
         * Trigger an event. This will call registered callback with the provided arg.
         * @param {String} name the name of the event (data, end, error)
         * @param {Object} arg the argument to call the callback with.
         */
        emit: function emit(name, arg) {
          if (this._listeners[name]) {
            for (var i = 0; i < this._listeners[name].length; i++) {
              this._listeners[name][i].call(this, arg);
            }
          }
        },
        /**
         * Chain a worker with an other.
         * @param {Worker} next the worker receiving events from the current one.
         * @return {worker} the next worker for chainability
         */
        pipe: function pipe(next) {
          return next.registerPrevious(this);
        },
        /**
         * Same as `pipe` in the other direction.
         * Using an API with `pipe(next)` is very easy.
         * Implementing the API with the point of view of the next one registering
         * a source is easier, see the ZipFileWorker.
         * @param {Worker} previous the previous worker, sending events to this one
         * @return {Worker} the current worker for chainability
         */
        registerPrevious: function registerPrevious(previous) {
          if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
          }

          // sharing the streamInfo...
          this.streamInfo = previous.streamInfo;
          // ... and adding our own bits
          this.mergeStreamInfo();
          this.previous = previous;
          var self = this;
          previous.on("data", function (chunk) {
            self.processChunk(chunk);
          });
          previous.on("end", function () {
            self.end();
          });
          previous.on("error", function (e) {
            self.error(e);
          });
          return this;
        },
        /**
         * Pause the stream so it doesn't send events anymore.
         * @return {Boolean} true if this call paused the worker, false otherwise.
         */
        pause: function pause() {
          if (this.isPaused || this.isFinished) {
            return false;
          }
          this.isPaused = true;
          if (this.previous) {
            this.previous.pause();
          }
          return true;
        },
        /**
         * Resume a paused stream.
         * @return {Boolean} true if this call resumed the worker, false otherwise.
         */
        resume: function resume() {
          if (!this.isPaused || this.isFinished) {
            return false;
          }
          this.isPaused = false;

          // if true, the worker tried to resume but failed
          var withError = false;
          if (this.generatedError) {
            this.error(this.generatedError);
            withError = true;
          }
          if (this.previous) {
            this.previous.resume();
          }
          return !withError;
        },
        /**
         * Flush any remaining bytes as the stream is ending.
         */
        flush: function flush() {},
        /**
         * Process a chunk. This is usually the method overridden.
         * @param {Object} chunk the chunk to process.
         */
        processChunk: function processChunk(chunk) {
          this.push(chunk);
        },
        /**
         * Add a key/value to be added in the workers chain streamInfo once activated.
         * @param {String} key the key to use
         * @param {Object} value the associated value
         * @return {Worker} the current worker for chainability
         */
        withStreamInfo: function withStreamInfo(key, value) {
          this.extraStreamInfo[key] = value;
          this.mergeStreamInfo();
          return this;
        },
        /**
         * Merge this worker's streamInfo into the chain's streamInfo.
         */
        mergeStreamInfo: function mergeStreamInfo() {
          for (var key in this.extraStreamInfo) {
            if (!Object.prototype.hasOwnProperty.call(this.extraStreamInfo, key)) {
              continue;
            }
            this.streamInfo[key] = this.extraStreamInfo[key];
          }
        },
        /**
         * Lock the stream to prevent further updates on the workers chain.
         * After calling this method, all calls to pipe will fail.
         */
        lock: function lock() {
          if (this.isLocked) {
            throw new Error("The stream '" + this + "' has already been used.");
          }
          this.isLocked = true;
          if (this.previous) {
            this.previous.lock();
          }
        },
        /**
         *
         * Pretty print the workers chain.
         */
        toString: function toString() {
          var me = "Worker " + this.name;
          if (this.previous) {
            return this.previous + " -> " + me;
          } else {
            return me;
          }
        }
      };
      module.exports = GenericWorker;
    }, {}],
    29: [function (require, module, exports) {
      "use strict";

      var utils = require("../utils");
      var ConvertWorker = require("./ConvertWorker");
      var GenericWorker = require("./GenericWorker");
      var base64 = require("../base64");
      var support = require("../support");
      var external = require("../external");
      var NodejsStreamOutputAdapter = null;
      if (support.nodestream) {
        try {
          NodejsStreamOutputAdapter = require("../nodejs/NodejsStreamOutputAdapter");
        } catch (e) {
          // ignore
        }
      }

      /**
       * Apply the final transformation of the data. If the user wants a Blob for
       * example, it's easier to work with an U8intArray and finally do the
       * ArrayBuffer/Blob conversion.
       * @param {String} type the name of the final type
       * @param {String|Uint8Array|Buffer} content the content to transform
       * @param {String} mimeType the mime type of the content, if applicable.
       * @return {String|Uint8Array|ArrayBuffer|Buffer|Blob} the content in the right format.
       */
      function transformZipOutput(type, content, mimeType) {
        switch (type) {
          case "blob":
            return utils.newBlob(utils.transformTo("arraybuffer", content), mimeType);
          case "base64":
            return base64.encode(content);
          default:
            return utils.transformTo(type, content);
        }
      }

      /**
       * Concatenate an array of data of the given type.
       * @param {String} type the type of the data in the given array.
       * @param {Array} dataArray the array containing the data chunks to concatenate
       * @return {String|Uint8Array|Buffer} the concatenated data
       * @throws Error if the asked type is unsupported
       */
      function concat(type, dataArray) {
        var i,
          index = 0,
          res = null,
          totalLength = 0;
        for (i = 0; i < dataArray.length; i++) {
          totalLength += dataArray[i].length;
        }
        switch (type) {
          case "string":
            return dataArray.join("");
          case "array":
            return Array.prototype.concat.apply([], dataArray);
          case "uint8array":
            res = new Uint8Array(totalLength);
            for (i = 0; i < dataArray.length; i++) {
              res.set(dataArray[i], index);
              index += dataArray[i].length;
            }
            return res;
          case "nodebuffer":
            return Buffer.concat(dataArray);
          default:
            throw new Error("concat : unsupported type '" + type + "'");
        }
      }

      /**
       * Listen a StreamHelper, accumulate its content and concatenate it into a
       * complete block.
       * @param {StreamHelper} helper the helper to use.
       * @param {Function} updateCallback a callback called on each update. Called
       * with one arg :
       * - the metadata linked to the update received.
       * @return Promise the promise for the accumulation.
       */
      function _accumulate(helper, updateCallback) {
        return new external.Promise(function (resolve, reject) {
          var dataArray = [];
          var chunkType = helper._internalType,
            resultType = helper._outputType,
            mimeType = helper._mimeType;
          helper.on("data", function (data, meta) {
            dataArray.push(data);
            if (updateCallback) {
              updateCallback(meta);
            }
          }).on("error", function (err) {
            dataArray = [];
            reject(err);
          }).on("end", function () {
            try {
              var result = transformZipOutput(resultType, concat(chunkType, dataArray), mimeType);
              resolve(result);
            } catch (e) {
              reject(e);
            }
            dataArray = [];
          }).resume();
        });
      }

      /**
       * An helper to easily use workers outside of JSZip.
       * @constructor
       * @param {Worker} worker the worker to wrap
       * @param {String} outputType the type of data expected by the use
       * @param {String} mimeType the mime type of the content, if applicable.
       */
      function StreamHelper(worker, outputType, mimeType) {
        var internalType = outputType;
        switch (outputType) {
          case "blob":
          case "arraybuffer":
            internalType = "uint8array";
            break;
          case "base64":
            internalType = "string";
            break;
        }
        try {
          // the type used internally
          this._internalType = internalType;
          // the type used to output results
          this._outputType = outputType;
          // the mime type
          this._mimeType = mimeType;
          utils.checkSupport(internalType);
          this._worker = worker.pipe(new ConvertWorker(internalType));
          // the last workers can be rewired without issues but we need to
          // prevent any updates on previous workers.
          worker.lock();
        } catch (e) {
          this._worker = new GenericWorker("error");
          this._worker.error(e);
        }
      }
      StreamHelper.prototype = {
        /**
         * Listen a StreamHelper, accumulate its content and concatenate it into a
         * complete block.
         * @param {Function} updateCb the update callback.
         * @return Promise the promise for the accumulation.
         */
        accumulate: function accumulate(updateCb) {
          return _accumulate(this, updateCb);
        },
        /**
         * Add a listener on an event triggered on a stream.
         * @param {String} evt the name of the event
         * @param {Function} fn the listener
         * @return {StreamHelper} the current helper.
         */
        on: function on(evt, fn) {
          var self = this;
          if (evt === "data") {
            this._worker.on(evt, function (chunk) {
              fn.call(self, chunk.data, chunk.meta);
            });
          } else {
            this._worker.on(evt, function () {
              utils.delay(fn, arguments, self);
            });
          }
          return this;
        },
        /**
         * Resume the flow of chunks.
         * @return {StreamHelper} the current helper.
         */
        resume: function resume() {
          utils.delay(this._worker.resume, [], this._worker);
          return this;
        },
        /**
         * Pause the flow of chunks.
         * @return {StreamHelper} the current helper.
         */
        pause: function pause() {
          this._worker.pause();
          return this;
        },
        /**
         * Return a nodejs stream for this helper.
         * @param {Function} updateCb the update callback.
         * @return {NodejsStreamOutputAdapter} the nodejs stream.
         */
        toNodejsStream: function toNodejsStream(updateCb) {
          utils.checkSupport("nodestream");
          if (this._outputType !== "nodebuffer") {
            // an object stream containing blob/arraybuffer/uint8array/string
            // is strange and I don't know if it would be useful.
            // I you find this comment and have a good usecase, please open a
            // bug report !
            throw new Error(this._outputType + " is not supported by this method");
          }
          return new NodejsStreamOutputAdapter(this, {
            objectMode: this._outputType !== "nodebuffer"
          }, updateCb);
        }
      };
      module.exports = StreamHelper;
    }, {
      "../base64": 1,
      "../external": 6,
      "../nodejs/NodejsStreamOutputAdapter": 13,
      "../support": 30,
      "../utils": 32,
      "./ConvertWorker": 24,
      "./GenericWorker": 28
    }],
    30: [function (require, module, exports) {
      "use strict";

      exports.base64 = true;
      exports.array = true;
      exports.string = true;
      exports.arraybuffer = typeof ArrayBuffer !== "undefined" && typeof Uint8Array !== "undefined";
      exports.nodebuffer = typeof Buffer !== "undefined";
      // contains true if JSZip can read/generate Uint8Array, false otherwise.
      exports.uint8array = typeof Uint8Array !== "undefined";
      if (typeof ArrayBuffer === "undefined") {
        exports.blob = false;
      } else {
        var buffer = new ArrayBuffer(0);
        try {
          exports.blob = new Blob([buffer], {
            type: "application/zip"
          }).size === 0;
        } catch (e) {
          try {
            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var builder = new Builder();
            builder.append(buffer);
            exports.blob = builder.getBlob("application/zip").size === 0;
          } catch (e) {
            exports.blob = false;
          }
        }
      }
      try {
        exports.nodestream = !!require("readable-stream").Readable;
      } catch (e) {
        exports.nodestream = false;
      }
    }, {
      "readable-stream": 16
    }],
    31: [function (require, module, exports) {
      "use strict";

      var utils = require("./utils");
      var support = require("./support");
      var nodejsUtils = require("./nodejsUtils");
      var GenericWorker = require("./stream/GenericWorker");

      /**
       * The following functions come from pako, from pako/lib/utils/strings
       * released under the MIT license, see pako https://github.com/nodeca/pako/
       */

      // Table with utf8 lengths (calculated by first byte of sequence)
      // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
      // because max possible codepoint is 0x10ffff
      var _utf8len = new Array(256);
      for (var i = 0; i < 256; i++) {
        _utf8len[i] = i >= 252 ? 6 : i >= 248 ? 5 : i >= 240 ? 4 : i >= 224 ? 3 : i >= 192 ? 2 : 1;
      }
      _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start

      // convert string to array (typed, when possible)
      var string2buf = function string2buf(str) {
        var buf,
          c,
          c2,
          m_pos,
          i,
          str_len = str.length,
          buf_len = 0;

        // count binary size
        for (m_pos = 0; m_pos < str_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }
          buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
        }

        // allocate buffer
        if (support.uint8array) {
          buf = new Uint8Array(buf_len);
        } else {
          buf = new Array(buf_len);
        }

        // convert
        for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }
          if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
          } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
          } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          } else {
            /* four bytes */
            buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          }
        }
        return buf;
      };

      // Calculate max possible position in utf8 buffer,
      // that will not break sequence. If that's not possible
      // - (very small limits) return max size as is.
      //
      // buf[] - utf8 bytes array
      // max   - length limit (mandatory);
      var utf8border = function utf8border(buf, max) {
        var pos;
        max = max || buf.length;
        if (max > buf.length) {
          max = buf.length;
        }

        // go back from last position, until start of sequence found
        pos = max - 1;
        while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) {
          pos--;
        }

        // Fuckup - very small and broken sequence,
        // return max, because we should return something anyway.
        if (pos < 0) {
          return max;
        }

        // If we came to start of buffer - that means vuffer is too small,
        // return max too.
        if (pos === 0) {
          return max;
        }
        return pos + _utf8len[buf[pos]] > max ? pos : max;
      };

      // convert array to string
      var buf2string = function buf2string(buf) {
        var i, out, c, c_len;
        var len = buf.length;

        // Reserve max possible length (2 words per char)
        // NB: by unknown reasons, Array is significantly faster for
        //     String.fromCharCode.apply than Uint16Array.
        var utf16buf = new Array(len * 2);
        for (out = 0, i = 0; i < len;) {
          c = buf[i++];
          // quick process ascii
          if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
          }
          c_len = _utf8len[c];
          // skip 5 & 6 byte codes
          if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
          }

          // apply mask on first byte
          c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
          // join the rest
          while (c_len > 1 && i < len) {
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
          }

          // terminated by end of string?
          if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
          }
          if (c < 0x10000) {
            utf16buf[out++] = c;
          } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
          }
        }

        // shrinkBuf(utf16buf, out)
        if (utf16buf.length !== out) {
          if (utf16buf.subarray) {
            utf16buf = utf16buf.subarray(0, out);
          } else {
            utf16buf.length = out;
          }
        }

        // return String.fromCharCode.apply(null, utf16buf);
        return utils.applyFromCharCode(utf16buf);
      };

      // That's all for the pako functions.

      /**
       * Transform a javascript string into an array (typed if possible) of bytes,
       * UTF-8 encoded.
       * @param {String} str the string to encode
       * @return {Array|Uint8Array|Buffer} the UTF-8 encoded string.
       */
      exports.utf8encode = function utf8encode(str) {
        if (support.nodebuffer) {
          return nodejsUtils.newBufferFrom(str, "utf-8");
        }
        return string2buf(str);
      };

      /**
       * Transform a bytes array (or a representation) representing an UTF-8 encoded
       * string into a javascript string.
       * @param {Array|Uint8Array|Buffer} buf the data de decode
       * @return {String} the decoded string.
       */
      exports.utf8decode = function utf8decode(buf) {
        if (support.nodebuffer) {
          return utils.transformTo("nodebuffer", buf).toString("utf-8");
        }
        buf = utils.transformTo(support.uint8array ? "uint8array" : "array", buf);
        return buf2string(buf);
      };

      /**
       * A worker to decode utf8 encoded binary chunks into string chunks.
       * @constructor
       */
      function Utf8DecodeWorker() {
        GenericWorker.call(this, "utf-8 decode");
        // the last bytes if a chunk didn't end with a complete codepoint.
        this.leftOver = null;
      }
      utils.inherits(Utf8DecodeWorker, GenericWorker);

      /**
       * @see GenericWorker.processChunk
       */
      Utf8DecodeWorker.prototype.processChunk = function (chunk) {
        var data = utils.transformTo(support.uint8array ? "uint8array" : "array", chunk.data);

        // 1st step, re-use what's left of the previous chunk
        if (this.leftOver && this.leftOver.length) {
          if (support.uint8array) {
            var previousData = data;
            data = new Uint8Array(previousData.length + this.leftOver.length);
            data.set(this.leftOver, 0);
            data.set(previousData, this.leftOver.length);
          } else {
            data = this.leftOver.concat(data);
          }
          this.leftOver = null;
        }
        var nextBoundary = utf8border(data);
        var usableData = data;
        if (nextBoundary !== data.length) {
          if (support.uint8array) {
            usableData = data.subarray(0, nextBoundary);
            this.leftOver = data.subarray(nextBoundary, data.length);
          } else {
            usableData = data.slice(0, nextBoundary);
            this.leftOver = data.slice(nextBoundary, data.length);
          }
        }
        this.push({
          data: exports.utf8decode(usableData),
          meta: chunk.meta
        });
      };

      /**
       * @see GenericWorker.flush
       */
      Utf8DecodeWorker.prototype.flush = function () {
        if (this.leftOver && this.leftOver.length) {
          this.push({
            data: exports.utf8decode(this.leftOver),
            meta: {}
          });
          this.leftOver = null;
        }
      };
      exports.Utf8DecodeWorker = Utf8DecodeWorker;

      /**
       * A worker to endcode string chunks into utf8 encoded binary chunks.
       * @constructor
       */
      function Utf8EncodeWorker() {
        GenericWorker.call(this, "utf-8 encode");
      }
      utils.inherits(Utf8EncodeWorker, GenericWorker);

      /**
       * @see GenericWorker.processChunk
       */
      Utf8EncodeWorker.prototype.processChunk = function (chunk) {
        this.push({
          data: exports.utf8encode(chunk.data),
          meta: chunk.meta
        });
      };
      exports.Utf8EncodeWorker = Utf8EncodeWorker;
    }, {
      "./nodejsUtils": 14,
      "./stream/GenericWorker": 28,
      "./support": 30,
      "./utils": 32
    }],
    32: [function (require, module, exports) {
      "use strict";

      var support = require("./support");
      var base64 = require("./base64");
      var nodejsUtils = require("./nodejsUtils");
      var external = require("./external");
      require("setimmediate");

      /**
       * Convert a string that pass as a "binary string": it should represent a byte
       * array but may have > 255 char codes. Be sure to take only the first byte
       * and returns the byte array.
       * @param {String} str the string to transform.
       * @return {Array|Uint8Array} the string in a binary format.
       */
      function string2binary(str) {
        var result = null;
        if (support.uint8array) {
          result = new Uint8Array(str.length);
        } else {
          result = new Array(str.length);
        }
        return stringToArrayLike(str, result);
      }

      /**
       * Create a new blob with the given content and the given type.
       * @param {String|ArrayBuffer} part the content to put in the blob. DO NOT use
       * an Uint8Array because the stock browser of android 4 won't accept it (it
       * will be silently converted to a string, "[object Uint8Array]").
       *
       * Use only ONE part to build the blob to avoid a memory leak in IE11 / Edge:
       * when a large amount of Array is used to create the Blob, the amount of
       * memory consumed is nearly 100 times the original data amount.
       *
       * @param {String} type the mime type of the blob.
       * @return {Blob} the created blob.
       */
      exports.newBlob = function (part, type) {
        exports.checkSupport("blob");
        try {
          // Blob constructor
          return new Blob([part], {
            type: type
          });
        } catch (e) {
          try {
            // deprecated, browser only, old way
            var Builder = self.BlobBuilder || self.WebKitBlobBuilder || self.MozBlobBuilder || self.MSBlobBuilder;
            var builder = new Builder();
            builder.append(part);
            return builder.getBlob(type);
          } catch (e) {
            // well, fuck ?!
            throw new Error("Bug : can't construct the Blob.");
          }
        }
      };
      /**
       * The identity function.
       * @param {Object} input the input.
       * @return {Object} the same input.
       */
      function identity(input) {
        return input;
      }

      /**
       * Fill in an array with a string.
       * @param {String} str the string to use.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to fill in (will be mutated).
       * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated array.
       */
      function stringToArrayLike(str, array) {
        for (var i = 0; i < str.length; ++i) {
          array[i] = str.charCodeAt(i) & 0xFF;
        }
        return array;
      }

      /**
       * An helper for the function arrayLikeToString.
       * This contains static information and functions that
       * can be optimized by the browser JIT compiler.
       */
      var arrayToStringHelper = {
        /**
         * Transform an array of int into a string, chunk by chunk.
         * See the performances notes on arrayLikeToString.
         * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
         * @param {String} type the type of the array.
         * @param {Integer} chunk the chunk size.
         * @return {String} the resulting string.
         * @throws Error if the chunk is too big for the stack.
         */
        stringifyByChunk: function stringifyByChunk(array, type, chunk) {
          var result = [],
            k = 0,
            len = array.length;
          // shortcut
          if (len <= chunk) {
            return String.fromCharCode.apply(null, array);
          }
          while (k < len) {
            if (type === "array" || type === "nodebuffer") {
              result.push(String.fromCharCode.apply(null, array.slice(k, Math.min(k + chunk, len))));
            } else {
              result.push(String.fromCharCode.apply(null, array.subarray(k, Math.min(k + chunk, len))));
            }
            k += chunk;
          }
          return result.join("");
        },
        /**
         * Call String.fromCharCode on every item in the array.
         * This is the naive implementation, which generate A LOT of intermediate string.
         * This should be used when everything else fail.
         * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
         * @return {String} the result.
         */
        stringifyByChar: function stringifyByChar(array) {
          var resultStr = "";
          for (var i = 0; i < array.length; i++) {
            resultStr += String.fromCharCode(array[i]);
          }
          return resultStr;
        },
        applyCanBeUsed: {
          /**
           * true if the browser accepts to use String.fromCharCode on Uint8Array
           */
          uint8array: function () {
            try {
              return support.uint8array && String.fromCharCode.apply(null, new Uint8Array(1)).length === 1;
            } catch (e) {
              return false;
            }
          }(),
          /**
           * true if the browser accepts to use String.fromCharCode on nodejs Buffer.
           */
          nodebuffer: function () {
            try {
              return support.nodebuffer && String.fromCharCode.apply(null, nodejsUtils.allocBuffer(1)).length === 1;
            } catch (e) {
              return false;
            }
          }()
        }
      };

      /**
       * Transform an array-like object to a string.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} array the array to transform.
       * @return {String} the result.
       */
      function arrayLikeToString(array) {
        // Performances notes :
        // --------------------
        // String.fromCharCode.apply(null, array) is the fastest, see
        // see http://jsperf.com/converting-a-uint8array-to-a-string/2
        // but the stack is limited (and we can get huge arrays !).
        //
        // result += String.fromCharCode(array[i]); generate too many strings !
        //
        // This code is inspired by http://jsperf.com/arraybuffer-to-string-apply-performance/2
        // TODO : we now have workers that split the work. Do we still need that ?
        var chunk = 65536,
          type = exports.getTypeOf(array),
          canUseApply = true;
        if (type === "uint8array") {
          canUseApply = arrayToStringHelper.applyCanBeUsed.uint8array;
        } else if (type === "nodebuffer") {
          canUseApply = arrayToStringHelper.applyCanBeUsed.nodebuffer;
        }
        if (canUseApply) {
          while (chunk > 1) {
            try {
              return arrayToStringHelper.stringifyByChunk(array, type, chunk);
            } catch (e) {
              chunk = Math.floor(chunk / 2);
            }
          }
        }

        // no apply or chunk error : slow and painful algorithm
        // default browser on android 4.*
        return arrayToStringHelper.stringifyByChar(array);
      }
      exports.applyFromCharCode = arrayLikeToString;

      /**
       * Copy the data from an array-like to an other array-like.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayFrom the origin array.
       * @param {Array|ArrayBuffer|Uint8Array|Buffer} arrayTo the destination array which will be mutated.
       * @return {Array|ArrayBuffer|Uint8Array|Buffer} the updated destination array.
       */
      function arrayLikeToArrayLike(arrayFrom, arrayTo) {
        for (var i = 0; i < arrayFrom.length; i++) {
          arrayTo[i] = arrayFrom[i];
        }
        return arrayTo;
      }

      // a matrix containing functions to transform everything into everything.
      var transform = {};

      // string to ?
      transform["string"] = {
        "string": identity,
        "array": function array(input) {
          return stringToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function arraybuffer(input) {
          return transform["string"]["uint8array"](input).buffer;
        },
        "uint8array": function uint8array(input) {
          return stringToArrayLike(input, new Uint8Array(input.length));
        },
        "nodebuffer": function nodebuffer(input) {
          return stringToArrayLike(input, nodejsUtils.allocBuffer(input.length));
        }
      };

      // array to ?
      transform["array"] = {
        "string": arrayLikeToString,
        "array": identity,
        "arraybuffer": function arraybuffer(input) {
          return new Uint8Array(input).buffer;
        },
        "uint8array": function uint8array(input) {
          return new Uint8Array(input);
        },
        "nodebuffer": function nodebuffer(input) {
          return nodejsUtils.newBufferFrom(input);
        }
      };

      // arraybuffer to ?
      transform["arraybuffer"] = {
        "string": function string(input) {
          return arrayLikeToString(new Uint8Array(input));
        },
        "array": function array(input) {
          return arrayLikeToArrayLike(new Uint8Array(input), new Array(input.byteLength));
        },
        "arraybuffer": identity,
        "uint8array": function uint8array(input) {
          return new Uint8Array(input);
        },
        "nodebuffer": function nodebuffer(input) {
          return nodejsUtils.newBufferFrom(new Uint8Array(input));
        }
      };

      // uint8array to ?
      transform["uint8array"] = {
        "string": arrayLikeToString,
        "array": function array(input) {
          return arrayLikeToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function arraybuffer(input) {
          return input.buffer;
        },
        "uint8array": identity,
        "nodebuffer": function nodebuffer(input) {
          return nodejsUtils.newBufferFrom(input);
        }
      };

      // nodebuffer to ?
      transform["nodebuffer"] = {
        "string": arrayLikeToString,
        "array": function array(input) {
          return arrayLikeToArrayLike(input, new Array(input.length));
        },
        "arraybuffer": function arraybuffer(input) {
          return transform["nodebuffer"]["uint8array"](input).buffer;
        },
        "uint8array": function uint8array(input) {
          return arrayLikeToArrayLike(input, new Uint8Array(input.length));
        },
        "nodebuffer": identity
      };

      /**
       * Transform an input into any type.
       * The supported output type are : string, array, uint8array, arraybuffer, nodebuffer.
       * If no output type is specified, the unmodified input will be returned.
       * @param {String} outputType the output type.
       * @param {String|Array|ArrayBuffer|Uint8Array|Buffer} input the input to convert.
       * @throws {Error} an Error if the browser doesn't support the requested output type.
       */
      exports.transformTo = function (outputType, input) {
        if (!input) {
          // undefined, null, etc
          // an empty string won't harm.
          input = "";
        }
        if (!outputType) {
          return input;
        }
        exports.checkSupport(outputType);
        var inputType = exports.getTypeOf(input);
        var result = transform[inputType][outputType](input);
        return result;
      };

      /**
       * Resolve all relative path components, "." and "..", in a path. If these relative components
       * traverse above the root then the resulting path will only contain the final path component.
       *
       * All empty components, e.g. "//", are removed.
       * @param {string} path A path with / or \ separators
       * @returns {string} The path with all relative path components resolved.
       */
      exports.resolve = function (path) {
        var parts = path.split("/");
        var result = [];
        for (var index = 0; index < parts.length; index++) {
          var part = parts[index];
          // Allow the first and last component to be empty for trailing slashes.
          if (part === "." || part === "" && index !== 0 && index !== parts.length - 1) {
            continue;
          } else if (part === "..") {
            result.pop();
          } else {
            result.push(part);
          }
        }
        return result.join("/");
      };

      /**
       * Return the type of the input.
       * The type will be in a format valid for JSZip.utils.transformTo : string, array, uint8array, arraybuffer.
       * @param {Object} input the input to identify.
       * @return {String} the (lowercase) type of the input.
       */
      exports.getTypeOf = function (input) {
        if (typeof input === "string") {
          return "string";
        }
        if (Object.prototype.toString.call(input) === "[object Array]") {
          return "array";
        }
        if (support.nodebuffer && nodejsUtils.isBuffer(input)) {
          return "nodebuffer";
        }
        if (support.uint8array && input instanceof Uint8Array) {
          return "uint8array";
        }
        if (support.arraybuffer && input instanceof ArrayBuffer) {
          return "arraybuffer";
        }
      };

      /**
       * Throw an exception if the type is not supported.
       * @param {String} type the type to check.
       * @throws {Error} an Error if the browser doesn't support the requested type.
       */
      exports.checkSupport = function (type) {
        var supported = support[type.toLowerCase()];
        if (!supported) {
          throw new Error(type + " is not supported by this platform");
        }
      };
      exports.MAX_VALUE_16BITS = 65535;
      exports.MAX_VALUE_32BITS = -1; // well, "\xFF\xFF\xFF\xFF\xFF\xFF\xFF\xFF" is parsed as -1

      /**
       * Prettify a string read as binary.
       * @param {string} str the string to prettify.
       * @return {string} a pretty string.
       */
      exports.pretty = function (str) {
        var res = "",
          code,
          i;
        for (i = 0; i < (str || "").length; i++) {
          code = str.charCodeAt(i);
          res += "\\x" + (code < 16 ? "0" : "") + code.toString(16).toUpperCase();
        }
        return res;
      };

      /**
       * Defer the call of a function.
       * @param {Function} callback the function to call asynchronously.
       * @param {Array} args the arguments to give to the callback.
       */
      exports.delay = function (callback, args, self) {
        setImmediate(function () {
          callback.apply(self || null, args || []);
        });
      };

      /**
       * Extends a prototype with an other, without calling a constructor with
       * side effects. Inspired by nodejs' `utils.inherits`
       * @param {Function} ctor the constructor to augment
       * @param {Function} superCtor the parent constructor to use
       */
      exports.inherits = function (ctor, superCtor) {
        var Obj = function Obj() {};
        Obj.prototype = superCtor.prototype;
        ctor.prototype = new Obj();
      };

      /**
       * Merge the objects passed as parameters into a new one.
       * @private
       * @param {...Object} var_args All objects to merge.
       * @return {Object} a new object with the data of the others.
       */
      exports.extend = function () {
        var result = {},
          i,
          attr;
        for (i = 0; i < arguments.length; i++) {
          // arguments is not enumerable in some browsers
          for (attr in arguments[i]) {
            if (Object.prototype.hasOwnProperty.call(arguments[i], attr) && typeof result[attr] === "undefined") {
              result[attr] = arguments[i][attr];
            }
          }
        }
        return result;
      };

      /**
       * Transform arbitrary content into a Promise.
       * @param {String} name a name for the content being processed.
       * @param {Object} inputData the content to process.
       * @param {Boolean} isBinary true if the content is not an unicode string
       * @param {Boolean} isOptimizedBinaryString true if the string content only has one byte per character.
       * @param {Boolean} isBase64 true if the string content is encoded with base64.
       * @return {Promise} a promise in a format usable by JSZip.
       */
      exports.prepareContent = function (name, inputData, isBinary, isOptimizedBinaryString, isBase64) {
        // if inputData is already a promise, this flatten it.
        var promise = external.Promise.resolve(inputData).then(function (data) {
          var isBlob = support.blob && (data instanceof Blob || ["[object File]", "[object Blob]"].indexOf(Object.prototype.toString.call(data)) !== -1);
          if (isBlob && typeof FileReader !== "undefined") {
            return new external.Promise(function (resolve, reject) {
              var reader = new FileReader();
              reader.onload = function (e) {
                resolve(e.target.result);
              };
              reader.onerror = function (e) {
                reject(e.target.error);
              };
              reader.readAsArrayBuffer(data);
            });
          } else {
            return data;
          }
        });
        return promise.then(function (data) {
          var dataType = exports.getTypeOf(data);
          if (!dataType) {
            return external.Promise.reject(new Error("Can't read the data of '" + name + "'. Is it " + "in a supported JavaScript type (String, Blob, ArrayBuffer, etc) ?"));
          }
          // special case : it's way easier to work with Uint8Array than with ArrayBuffer
          if (dataType === "arraybuffer") {
            data = exports.transformTo("uint8array", data);
          } else if (dataType === "string") {
            if (isBase64) {
              data = base64.decode(data);
            } else if (isBinary) {
              // optimizedBinaryString === true means that the file has already been filtered with a 0xFF mask
              if (isOptimizedBinaryString !== true) {
                // this is a string, not in a base64 format.
                // Be sure that this is a correct "binary string"
                data = string2binary(data);
              }
            }
          }
          return data;
        });
      };
    }, {
      "./base64": 1,
      "./external": 6,
      "./nodejsUtils": 14,
      "./support": 30,
      "setimmediate": 54
    }],
    33: [function (require, module, exports) {
      "use strict";

      var readerFor = require("./reader/readerFor");
      var utils = require("./utils");
      var sig = require("./signature");
      var ZipEntry = require("./zipEntry");
      var support = require("./support");
      //  class ZipEntries {{{
      /**
       * All the entries in the zip file.
       * @constructor
       * @param {Object} loadOptions Options for loading the stream.
       */
      function ZipEntries(loadOptions) {
        this.files = [];
        this.loadOptions = loadOptions;
      }
      ZipEntries.prototype = {
        /**
         * Check that the reader is on the specified signature.
         * @param {string} expectedSignature the expected signature.
         * @throws {Error} if it is an other signature.
         */
        checkSignature: function checkSignature(expectedSignature) {
          if (!this.reader.readAndCheckSignature(expectedSignature)) {
            this.reader.index -= 4;
            var signature = this.reader.readString(4);
            throw new Error("Corrupted zip or bug: unexpected signature " + "(" + utils.pretty(signature) + ", expected " + utils.pretty(expectedSignature) + ")");
          }
        },
        /**
         * Check if the given signature is at the given index.
         * @param {number} askedIndex the index to check.
         * @param {string} expectedSignature the signature to expect.
         * @return {boolean} true if the signature is here, false otherwise.
         */
        isSignature: function isSignature(askedIndex, expectedSignature) {
          var currentIndex = this.reader.index;
          this.reader.setIndex(askedIndex);
          var signature = this.reader.readString(4);
          var result = signature === expectedSignature;
          this.reader.setIndex(currentIndex);
          return result;
        },
        /**
         * Read the end of the central directory.
         */
        readBlockEndOfCentral: function readBlockEndOfCentral() {
          this.diskNumber = this.reader.readInt(2);
          this.diskWithCentralDirStart = this.reader.readInt(2);
          this.centralDirRecordsOnThisDisk = this.reader.readInt(2);
          this.centralDirRecords = this.reader.readInt(2);
          this.centralDirSize = this.reader.readInt(4);
          this.centralDirOffset = this.reader.readInt(4);
          this.zipCommentLength = this.reader.readInt(2);
          // warning : the encoding depends of the system locale
          // On a linux machine with LANG=en_US.utf8, this field is utf8 encoded.
          // On a windows machine, this field is encoded with the localized windows code page.
          var zipComment = this.reader.readData(this.zipCommentLength);
          var decodeParamType = support.uint8array ? "uint8array" : "array";
          // To get consistent behavior with the generation part, we will assume that
          // this is utf8 encoded unless specified otherwise.
          var decodeContent = utils.transformTo(decodeParamType, zipComment);
          this.zipComment = this.loadOptions.decodeFileName(decodeContent);
        },
        /**
         * Read the end of the Zip 64 central directory.
         * Not merged with the method readEndOfCentral :
         * The end of central can coexist with its Zip64 brother,
         * I don't want to read the wrong number of bytes !
         */
        readBlockZip64EndOfCentral: function readBlockZip64EndOfCentral() {
          this.zip64EndOfCentralSize = this.reader.readInt(8);
          this.reader.skip(4);
          // this.versionMadeBy = this.reader.readString(2);
          // this.versionNeeded = this.reader.readInt(2);
          this.diskNumber = this.reader.readInt(4);
          this.diskWithCentralDirStart = this.reader.readInt(4);
          this.centralDirRecordsOnThisDisk = this.reader.readInt(8);
          this.centralDirRecords = this.reader.readInt(8);
          this.centralDirSize = this.reader.readInt(8);
          this.centralDirOffset = this.reader.readInt(8);
          this.zip64ExtensibleData = {};
          var extraDataSize = this.zip64EndOfCentralSize - 44,
            index = 0,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
          while (index < extraDataSize) {
            extraFieldId = this.reader.readInt(2);
            extraFieldLength = this.reader.readInt(4);
            extraFieldValue = this.reader.readData(extraFieldLength);
            this.zip64ExtensibleData[extraFieldId] = {
              id: extraFieldId,
              length: extraFieldLength,
              value: extraFieldValue
            };
          }
        },
        /**
         * Read the end of the Zip 64 central directory locator.
         */
        readBlockZip64EndOfCentralLocator: function readBlockZip64EndOfCentralLocator() {
          this.diskWithZip64CentralDirStart = this.reader.readInt(4);
          this.relativeOffsetEndOfZip64CentralDir = this.reader.readInt(8);
          this.disksCount = this.reader.readInt(4);
          if (this.disksCount > 1) {
            throw new Error("Multi-volumes zip are not supported");
          }
        },
        /**
         * Read the local files, based on the offset read in the central part.
         */
        readLocalFiles: function readLocalFiles() {
          var i, file;
          for (i = 0; i < this.files.length; i++) {
            file = this.files[i];
            this.reader.setIndex(file.localHeaderOffset);
            this.checkSignature(sig.LOCAL_FILE_HEADER);
            file.readLocalPart(this.reader);
            file.handleUTF8();
            file.processAttributes();
          }
        },
        /**
         * Read the central directory.
         */
        readCentralDir: function readCentralDir() {
          var file;
          this.reader.setIndex(this.centralDirOffset);
          while (this.reader.readAndCheckSignature(sig.CENTRAL_FILE_HEADER)) {
            file = new ZipEntry({
              zip64: this.zip64
            }, this.loadOptions);
            file.readCentralPart(this.reader);
            this.files.push(file);
          }
          if (this.centralDirRecords !== this.files.length) {
            if (this.centralDirRecords !== 0 && this.files.length === 0) {
              // We expected some records but couldn't find ANY.
              // This is really suspicious, as if something went wrong.
              throw new Error("Corrupted zip or bug: expected " + this.centralDirRecords + " records in central dir, got " + this.files.length);
            } else {
              // We found some records but not all.
              // Something is wrong but we got something for the user: no error here.
              // console.warn("expected", this.centralDirRecords, "records in central dir, got", this.files.length);
            }
          }
        },
        /**
         * Read the end of central directory.
         */
        readEndOfCentral: function readEndOfCentral() {
          var offset = this.reader.lastIndexOfSignature(sig.CENTRAL_DIRECTORY_END);
          if (offset < 0) {
            // Check if the content is a truncated zip or complete garbage.
            // A "LOCAL_FILE_HEADER" is not required at the beginning (auto
            // extractible zip for example) but it can give a good hint.
            // If an ajax request was used without responseType, we will also
            // get unreadable data.
            var isGarbage = !this.isSignature(0, sig.LOCAL_FILE_HEADER);
            if (isGarbage) {
              throw new Error("Can't find end of central directory : is this a zip file ? " + "If it is, see https://stuk.github.io/jszip/documentation/howto/read_zip.html");
            } else {
              throw new Error("Corrupted zip: can't find end of central directory");
            }
          }
          this.reader.setIndex(offset);
          var endOfCentralDirOffset = offset;
          this.checkSignature(sig.CENTRAL_DIRECTORY_END);
          this.readBlockEndOfCentral();

          /* extract from the zip spec :
              4)  If one of the fields in the end of central directory
                  record is too small to hold required data, the field
                  should be set to -1 (0xFFFF or 0xFFFFFFFF) and the
                  ZIP64 format record should be created.
              5)  The end of central directory record and the
                  Zip64 end of central directory locator record must
                  reside on the same disk when splitting or spanning
                  an archive.
           */
          if (this.diskNumber === utils.MAX_VALUE_16BITS || this.diskWithCentralDirStart === utils.MAX_VALUE_16BITS || this.centralDirRecordsOnThisDisk === utils.MAX_VALUE_16BITS || this.centralDirRecords === utils.MAX_VALUE_16BITS || this.centralDirSize === utils.MAX_VALUE_32BITS || this.centralDirOffset === utils.MAX_VALUE_32BITS) {
            this.zip64 = true;

            /*
            Warning : the zip64 extension is supported, but ONLY if the 64bits integer read from
            the zip file can fit into a 32bits integer. This cannot be solved : JavaScript represents
            all numbers as 64-bit double precision IEEE 754 floating point numbers.
            So, we have 53bits for integers and bitwise operations treat everything as 32bits.
            see https://developer.mozilla.org/en-US/docs/JavaScript/Reference/Operators/Bitwise_Operators
            and http://www.ecma-international.org/publications/files/ECMA-ST/ECMA-262.pdf section 8.5
            */

            // should look for a zip64 EOCD locator
            offset = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            if (offset < 0) {
              throw new Error("Corrupted zip: can't find the ZIP64 end of central directory locator");
            }
            this.reader.setIndex(offset);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_LOCATOR);
            this.readBlockZip64EndOfCentralLocator();

            // now the zip64 EOCD record
            if (!this.isSignature(this.relativeOffsetEndOfZip64CentralDir, sig.ZIP64_CENTRAL_DIRECTORY_END)) {
              // console.warn("ZIP64 end of central directory not where expected.");
              this.relativeOffsetEndOfZip64CentralDir = this.reader.lastIndexOfSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
              if (this.relativeOffsetEndOfZip64CentralDir < 0) {
                throw new Error("Corrupted zip: can't find the ZIP64 end of central directory");
              }
            }
            this.reader.setIndex(this.relativeOffsetEndOfZip64CentralDir);
            this.checkSignature(sig.ZIP64_CENTRAL_DIRECTORY_END);
            this.readBlockZip64EndOfCentral();
          }
          var expectedEndOfCentralDirOffset = this.centralDirOffset + this.centralDirSize;
          if (this.zip64) {
            expectedEndOfCentralDirOffset += 20; // end of central dir 64 locator
            expectedEndOfCentralDirOffset += 12 /* should not include the leading 12 bytes */ + this.zip64EndOfCentralSize;
          }
          var extraBytes = endOfCentralDirOffset - expectedEndOfCentralDirOffset;
          if (extraBytes > 0) {
            // console.warn(extraBytes, "extra bytes at beginning or within zipfile");
            if (this.isSignature(endOfCentralDirOffset, sig.CENTRAL_FILE_HEADER)) {
              // The offsets seem wrong, but we have something at the specified offset.
              // So… we keep it.
            } else {
              // the offset is wrong, update the "zero" of the reader
              // this happens if data has been prepended (crx files for example)
              this.reader.zero = extraBytes;
            }
          } else if (extraBytes < 0) {
            throw new Error("Corrupted zip: missing " + Math.abs(extraBytes) + " bytes.");
          }
        },
        prepareReader: function prepareReader(data) {
          this.reader = readerFor(data);
        },
        /**
         * Read a zip file and create ZipEntries.
         * @param {String|ArrayBuffer|Uint8Array|Buffer} data the binary string representing a zip file.
         */
        load: function load(data) {
          this.prepareReader(data);
          this.readEndOfCentral();
          this.readCentralDir();
          this.readLocalFiles();
        }
      };
      // }}} end of ZipEntries
      module.exports = ZipEntries;
    }, {
      "./reader/readerFor": 22,
      "./signature": 23,
      "./support": 30,
      "./utils": 32,
      "./zipEntry": 34
    }],
    34: [function (require, module, exports) {
      "use strict";

      var readerFor = require("./reader/readerFor");
      var utils = require("./utils");
      var CompressedObject = require("./compressedObject");
      var crc32fn = require("./crc32");
      var utf8 = require("./utf8");
      var compressions = require("./compressions");
      var support = require("./support");
      var MADE_BY_DOS = 0x00;
      var MADE_BY_UNIX = 0x03;

      /**
       * Find a compression registered in JSZip.
       * @param {string} compressionMethod the method magic to find.
       * @return {Object|null} the JSZip compression object, null if none found.
       */
      var findCompression = function findCompression(compressionMethod) {
        for (var method in compressions) {
          if (!Object.prototype.hasOwnProperty.call(compressions, method)) {
            continue;
          }
          if (compressions[method].magic === compressionMethod) {
            return compressions[method];
          }
        }
        return null;
      };

      // class ZipEntry {{{
      /**
       * An entry in the zip file.
       * @constructor
       * @param {Object} options Options of the current file.
       * @param {Object} loadOptions Options for loading the stream.
       */
      function ZipEntry(options, loadOptions) {
        this.options = options;
        this.loadOptions = loadOptions;
      }
      ZipEntry.prototype = {
        /**
         * say if the file is encrypted.
         * @return {boolean} true if the file is encrypted, false otherwise.
         */
        isEncrypted: function isEncrypted() {
          // bit 1 is set
          return (this.bitFlag & 0x0001) === 0x0001;
        },
        /**
         * say if the file has utf-8 filename/comment.
         * @return {boolean} true if the filename/comment is in utf-8, false otherwise.
         */
        useUTF8: function useUTF8() {
          // bit 11 is set
          return (this.bitFlag & 0x0800) === 0x0800;
        },
        /**
         * Read the local part of a zip file and add the info in this object.
         * @param {DataReader} reader the reader to use.
         */
        readLocalPart: function readLocalPart(reader) {
          var compression, localExtraFieldsLength;

          // we already know everything from the central dir !
          // If the central dir data are false, we are doomed.
          // On the bright side, the local part is scary  : zip64, data descriptors, both, etc.
          // The less data we get here, the more reliable this should be.
          // Let's skip the whole header and dash to the data !
          reader.skip(22);
          // in some zip created on windows, the filename stored in the central dir contains \ instead of /.
          // Strangely, the filename here is OK.
          // I would love to treat these zip files as corrupted (see http://www.info-zip.org/FAQ.html#backslashes
          // or APPNOTE#4.4.17.1, "All slashes MUST be forward slashes '/'") but there are a lot of bad zip generators...
          // Search "unzip mismatching "local" filename continuing with "central" filename version" on
          // the internet.
          //
          // I think I see the logic here : the central directory is used to display
          // content and the local directory is used to extract the files. Mixing / and \
          // may be used to display \ to windows users and use / when extracting the files.
          // Unfortunately, this lead also to some issues : http://seclists.org/fulldisclosure/2009/Sep/394
          this.fileNameLength = reader.readInt(2);
          localExtraFieldsLength = reader.readInt(2); // can't be sure this will be the same as the central dir
          // the fileName is stored as binary data, the handleUTF8 method will take care of the encoding.
          this.fileName = reader.readData(this.fileNameLength);
          reader.skip(localExtraFieldsLength);
          if (this.compressedSize === -1 || this.uncompressedSize === -1) {
            throw new Error("Bug or corrupted zip : didn't get enough information from the central directory " + "(compressedSize === -1 || uncompressedSize === -1)");
          }
          compression = findCompression(this.compressionMethod);
          if (compression === null) {
            // no compression found
            throw new Error("Corrupted zip : compression " + utils.pretty(this.compressionMethod) + " unknown (inner file : " + utils.transformTo("string", this.fileName) + ")");
          }
          this.decompressed = new CompressedObject(this.compressedSize, this.uncompressedSize, this.crc32, compression, reader.readData(this.compressedSize));
        },
        /**
         * Read the central part of a zip file and add the info in this object.
         * @param {DataReader} reader the reader to use.
         */
        readCentralPart: function readCentralPart(reader) {
          this.versionMadeBy = reader.readInt(2);
          reader.skip(2);
          // this.versionNeeded = reader.readInt(2);
          this.bitFlag = reader.readInt(2);
          this.compressionMethod = reader.readString(2);
          this.date = reader.readDate();
          this.crc32 = reader.readInt(4);
          this.compressedSize = reader.readInt(4);
          this.uncompressedSize = reader.readInt(4);
          var fileNameLength = reader.readInt(2);
          this.extraFieldsLength = reader.readInt(2);
          this.fileCommentLength = reader.readInt(2);
          this.diskNumberStart = reader.readInt(2);
          this.internalFileAttributes = reader.readInt(2);
          this.externalFileAttributes = reader.readInt(4);
          this.localHeaderOffset = reader.readInt(4);
          if (this.isEncrypted()) {
            throw new Error("Encrypted zip are not supported");
          }

          // will be read in the local part, see the comments there
          reader.skip(fileNameLength);
          this.readExtraFields(reader);
          this.parseZIP64ExtraField(reader);
          this.fileComment = reader.readData(this.fileCommentLength);
        },
        /**
         * Parse the external file attributes and get the unix/dos permissions.
         */
        processAttributes: function processAttributes() {
          this.unixPermissions = null;
          this.dosPermissions = null;
          var madeBy = this.versionMadeBy >> 8;

          // Check if we have the DOS directory flag set.
          // We look for it in the DOS and UNIX permissions
          // but some unknown platform could set it as a compatibility flag.
          this.dir = this.externalFileAttributes & 0x0010 ? true : false;
          if (madeBy === MADE_BY_DOS) {
            // first 6 bits (0 to 5)
            this.dosPermissions = this.externalFileAttributes & 0x3F;
          }
          if (madeBy === MADE_BY_UNIX) {
            this.unixPermissions = this.externalFileAttributes >> 16 & 0xFFFF;
            // the octal permissions are in (this.unixPermissions & 0x01FF).toString(8);
          }

          // fail safe : if the name ends with a / it probably means a folder
          if (!this.dir && this.fileNameStr.slice(-1) === "/") {
            this.dir = true;
          }
        },
        /**
         * Parse the ZIP64 extra field and merge the info in the current ZipEntry.
         * @param {DataReader} reader the reader to use.
         */
        parseZIP64ExtraField: function parseZIP64ExtraField() {
          if (!this.extraFields[0x0001]) {
            return;
          }

          // should be something, preparing the extra reader
          var extraReader = readerFor(this.extraFields[0x0001].value);

          // I really hope that these 64bits integer can fit in 32 bits integer, because js
          // won't let us have more.
          if (this.uncompressedSize === utils.MAX_VALUE_32BITS) {
            this.uncompressedSize = extraReader.readInt(8);
          }
          if (this.compressedSize === utils.MAX_VALUE_32BITS) {
            this.compressedSize = extraReader.readInt(8);
          }
          if (this.localHeaderOffset === utils.MAX_VALUE_32BITS) {
            this.localHeaderOffset = extraReader.readInt(8);
          }
          if (this.diskNumberStart === utils.MAX_VALUE_32BITS) {
            this.diskNumberStart = extraReader.readInt(4);
          }
        },
        /**
         * Read the central part of a zip file and add the info in this object.
         * @param {DataReader} reader the reader to use.
         */
        readExtraFields: function readExtraFields(reader) {
          var end = reader.index + this.extraFieldsLength,
            extraFieldId,
            extraFieldLength,
            extraFieldValue;
          if (!this.extraFields) {
            this.extraFields = {};
          }
          while (reader.index + 4 < end) {
            extraFieldId = reader.readInt(2);
            extraFieldLength = reader.readInt(2);
            extraFieldValue = reader.readData(extraFieldLength);
            this.extraFields[extraFieldId] = {
              id: extraFieldId,
              length: extraFieldLength,
              value: extraFieldValue
            };
          }
          reader.setIndex(end);
        },
        /**
         * Apply an UTF8 transformation if needed.
         */
        handleUTF8: function handleUTF8() {
          var decodeParamType = support.uint8array ? "uint8array" : "array";
          if (this.useUTF8()) {
            this.fileNameStr = utf8.utf8decode(this.fileName);
            this.fileCommentStr = utf8.utf8decode(this.fileComment);
          } else {
            var upath = this.findExtraFieldUnicodePath();
            if (upath !== null) {
              this.fileNameStr = upath;
            } else {
              // ASCII text or unsupported code page
              var fileNameByteArray = utils.transformTo(decodeParamType, this.fileName);
              this.fileNameStr = this.loadOptions.decodeFileName(fileNameByteArray);
            }
            var ucomment = this.findExtraFieldUnicodeComment();
            if (ucomment !== null) {
              this.fileCommentStr = ucomment;
            } else {
              // ASCII text or unsupported code page
              var commentByteArray = utils.transformTo(decodeParamType, this.fileComment);
              this.fileCommentStr = this.loadOptions.decodeFileName(commentByteArray);
            }
          }
        },
        /**
         * Find the unicode path declared in the extra field, if any.
         * @return {String} the unicode path, null otherwise.
         */
        findExtraFieldUnicodePath: function findExtraFieldUnicodePath() {
          var upathField = this.extraFields[0x7075];
          if (upathField) {
            var extraReader = readerFor(upathField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
              return null;
            }

            // the crc of the filename changed, this field is out of date.
            if (crc32fn(this.fileName) !== extraReader.readInt(4)) {
              return null;
            }
            return utf8.utf8decode(extraReader.readData(upathField.length - 5));
          }
          return null;
        },
        /**
         * Find the unicode comment declared in the extra field, if any.
         * @return {String} the unicode comment, null otherwise.
         */
        findExtraFieldUnicodeComment: function findExtraFieldUnicodeComment() {
          var ucommentField = this.extraFields[0x6375];
          if (ucommentField) {
            var extraReader = readerFor(ucommentField.value);

            // wrong version
            if (extraReader.readInt(1) !== 1) {
              return null;
            }

            // the crc of the comment changed, this field is out of date.
            if (crc32fn(this.fileComment) !== extraReader.readInt(4)) {
              return null;
            }
            return utf8.utf8decode(extraReader.readData(ucommentField.length - 5));
          }
          return null;
        }
      };
      module.exports = ZipEntry;
    }, {
      "./compressedObject": 2,
      "./compressions": 3,
      "./crc32": 4,
      "./reader/readerFor": 22,
      "./support": 30,
      "./utf8": 31,
      "./utils": 32
    }],
    35: [function (require, module, exports) {
      "use strict";

      var StreamHelper = require("./stream/StreamHelper");
      var DataWorker = require("./stream/DataWorker");
      var utf8 = require("./utf8");
      var CompressedObject = require("./compressedObject");
      var GenericWorker = require("./stream/GenericWorker");

      /**
       * A simple object representing a file in the zip file.
       * @constructor
       * @param {string} name the name of the file
       * @param {String|ArrayBuffer|Uint8Array|Buffer} data the data
       * @param {Object} options the options of the file
       */
      var ZipObject = function ZipObject(name, data, options) {
        this.name = name;
        this.dir = options.dir;
        this.date = options.date;
        this.comment = options.comment;
        this.unixPermissions = options.unixPermissions;
        this.dosPermissions = options.dosPermissions;
        this._data = data;
        this._dataBinary = options.binary;
        // keep only the compression
        this.options = {
          compression: options.compression,
          compressionOptions: options.compressionOptions
        };
      };
      ZipObject.prototype = {
        /**
         * Create an internal stream for the content of this object.
         * @param {String} type the type of each chunk.
         * @return StreamHelper the stream.
         */
        internalStream: function internalStream(type) {
          var result = null,
            outputType = "string";
          try {
            if (!type) {
              throw new Error("No output type specified.");
            }
            outputType = type.toLowerCase();
            var askUnicodeString = outputType === "string" || outputType === "text";
            if (outputType === "binarystring" || outputType === "text") {
              outputType = "string";
            }
            result = this._decompressWorker();
            var isUnicodeString = !this._dataBinary;
            if (isUnicodeString && !askUnicodeString) {
              result = result.pipe(new utf8.Utf8EncodeWorker());
            }
            if (!isUnicodeString && askUnicodeString) {
              result = result.pipe(new utf8.Utf8DecodeWorker());
            }
          } catch (e) {
            result = new GenericWorker("error");
            result.error(e);
          }
          return new StreamHelper(result, outputType, "");
        },
        /**
         * Prepare the content in the asked type.
         * @param {String} type the type of the result.
         * @param {Function} onUpdate a function to call on each internal update.
         * @return Promise the promise of the result.
         */
        async: function async(type, onUpdate) {
          return this.internalStream(type).accumulate(onUpdate);
        },
        /**
         * Prepare the content as a nodejs stream.
         * @param {String} type the type of each chunk.
         * @param {Function} onUpdate a function to call on each internal update.
         * @return Stream the stream.
         */
        nodeStream: function nodeStream(type, onUpdate) {
          return this.internalStream(type || "nodebuffer").toNodejsStream(onUpdate);
        },
        /**
         * Return a worker for the compressed content.
         * @private
         * @param {Object} compression the compression object to use.
         * @param {Object} compressionOptions the options to use when compressing.
         * @return Worker the worker.
         */
        _compressWorker: function _compressWorker(compression, compressionOptions) {
          if (this._data instanceof CompressedObject && this._data.compression.magic === compression.magic) {
            return this._data.getCompressedWorker();
          } else {
            var result = this._decompressWorker();
            if (!this._dataBinary) {
              result = result.pipe(new utf8.Utf8EncodeWorker());
            }
            return CompressedObject.createWorkerFrom(result, compression, compressionOptions);
          }
        },
        /**
         * Return a worker for the decompressed content.
         * @private
         * @return Worker the worker.
         */
        _decompressWorker: function _decompressWorker() {
          if (this._data instanceof CompressedObject) {
            return this._data.getContentWorker();
          } else if (this._data instanceof GenericWorker) {
            return this._data;
          } else {
            return new DataWorker(this._data);
          }
        }
      };
      var removedMethods = ["asText", "asBinary", "asNodeBuffer", "asUint8Array", "asArrayBuffer"];
      var removedFn = function removedFn() {
        throw new Error("This method has been removed in JSZip 3.0, please check the upgrade guide.");
      };
      for (var i = 0; i < removedMethods.length; i++) {
        ZipObject.prototype[removedMethods[i]] = removedFn;
      }
      module.exports = ZipObject;
    }, {
      "./compressedObject": 2,
      "./stream/DataWorker": 27,
      "./stream/GenericWorker": 28,
      "./stream/StreamHelper": 29,
      "./utf8": 31
    }],
    36: [function (require, module, exports) {
      (function (global) {
        'use strict';

        var Mutation = global.MutationObserver || global.WebKitMutationObserver;
        var scheduleDrain;
        {
          if (Mutation) {
            var called = 0;
            var observer = new Mutation(nextTick);
            var element = global.document.createTextNode('');
            observer.observe(element, {
              characterData: true
            });
            scheduleDrain = function scheduleDrain() {
              element.data = called = ++called % 2;
            };
          } else if (!global.setImmediate && typeof global.MessageChannel !== 'undefined') {
            var channel = new global.MessageChannel();
            channel.port1.onmessage = nextTick;
            scheduleDrain = function scheduleDrain() {
              channel.port2.postMessage(0);
            };
          } else if ('document' in global && 'onreadystatechange' in global.document.createElement('script')) {
            scheduleDrain = function scheduleDrain() {
              // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
              // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
              var scriptEl = global.document.createElement('script');
              scriptEl.onreadystatechange = function () {
                nextTick();
                scriptEl.onreadystatechange = null;
                scriptEl.parentNode.removeChild(scriptEl);
                scriptEl = null;
              };
              global.document.documentElement.appendChild(scriptEl);
            };
          } else {
            scheduleDrain = function scheduleDrain() {
              setTimeout(nextTick, 0);
            };
          }
        }
        var draining;
        var queue = [];
        //named nextTick for less confusing stack traces
        function nextTick() {
          draining = true;
          var i, oldQueue;
          var len = queue.length;
          while (len) {
            oldQueue = queue;
            queue = [];
            i = -1;
            while (++i < len) {
              oldQueue[i]();
            }
            len = queue.length;
          }
          draining = false;
        }
        module.exports = immediate;
        function immediate(task) {
          if (queue.push(task) === 1 && !draining) {
            scheduleDrain();
          }
        }
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {}],
    37: [function (require, module, exports) {
      'use strict';

      var immediate = require('immediate');

      /* istanbul ignore next */
      function INTERNAL() {}
      var handlers = {};
      var REJECTED = ['REJECTED'];
      var FULFILLED = ['FULFILLED'];
      var PENDING = ['PENDING'];
      module.exports = Promise;
      function Promise(resolver) {
        if (typeof resolver !== 'function') {
          throw new TypeError('resolver must be a function');
        }
        this.state = PENDING;
        this.queue = [];
        this.outcome = void 0;
        if (resolver !== INTERNAL) {
          safelyResolveThenable(this, resolver);
        }
      }
      Promise.prototype["finally"] = function (callback) {
        if (typeof callback !== 'function') {
          return this;
        }
        var p = this.constructor;
        return this.then(resolve, reject);
        function resolve(value) {
          function yes() {
            return value;
          }
          return p.resolve(callback()).then(yes);
        }
        function reject(reason) {
          function no() {
            throw reason;
          }
          return p.resolve(callback()).then(no);
        }
      };
      Promise.prototype["catch"] = function (onRejected) {
        return this.then(null, onRejected);
      };
      Promise.prototype.then = function (onFulfilled, onRejected) {
        if (typeof onFulfilled !== 'function' && this.state === FULFILLED || typeof onRejected !== 'function' && this.state === REJECTED) {
          return this;
        }
        var promise = new this.constructor(INTERNAL);
        if (this.state !== PENDING) {
          var resolver = this.state === FULFILLED ? onFulfilled : onRejected;
          unwrap(promise, resolver, this.outcome);
        } else {
          this.queue.push(new QueueItem(promise, onFulfilled, onRejected));
        }
        return promise;
      };
      function QueueItem(promise, onFulfilled, onRejected) {
        this.promise = promise;
        if (typeof onFulfilled === 'function') {
          this.onFulfilled = onFulfilled;
          this.callFulfilled = this.otherCallFulfilled;
        }
        if (typeof onRejected === 'function') {
          this.onRejected = onRejected;
          this.callRejected = this.otherCallRejected;
        }
      }
      QueueItem.prototype.callFulfilled = function (value) {
        handlers.resolve(this.promise, value);
      };
      QueueItem.prototype.otherCallFulfilled = function (value) {
        unwrap(this.promise, this.onFulfilled, value);
      };
      QueueItem.prototype.callRejected = function (value) {
        handlers.reject(this.promise, value);
      };
      QueueItem.prototype.otherCallRejected = function (value) {
        unwrap(this.promise, this.onRejected, value);
      };
      function unwrap(promise, func, value) {
        immediate(function () {
          var returnValue;
          try {
            returnValue = func(value);
          } catch (e) {
            return handlers.reject(promise, e);
          }
          if (returnValue === promise) {
            handlers.reject(promise, new TypeError('Cannot resolve promise with itself'));
          } else {
            handlers.resolve(promise, returnValue);
          }
        });
      }
      handlers.resolve = function (self, value) {
        var result = tryCatch(getThen, value);
        if (result.status === 'error') {
          return handlers.reject(self, result.value);
        }
        var thenable = result.value;
        if (thenable) {
          safelyResolveThenable(self, thenable);
        } else {
          self.state = FULFILLED;
          self.outcome = value;
          var i = -1;
          var len = self.queue.length;
          while (++i < len) {
            self.queue[i].callFulfilled(value);
          }
        }
        return self;
      };
      handlers.reject = function (self, error) {
        self.state = REJECTED;
        self.outcome = error;
        var i = -1;
        var len = self.queue.length;
        while (++i < len) {
          self.queue[i].callRejected(error);
        }
        return self;
      };
      function getThen(obj) {
        // Make sure we only access the accessor once as required by the spec
        var then = obj && obj.then;
        if (obj && (_typeof(obj) === 'object' || typeof obj === 'function') && typeof then === 'function') {
          return function appyThen() {
            then.apply(obj, arguments);
          };
        }
      }
      function safelyResolveThenable(self, thenable) {
        // Either fulfill, reject or reject with error
        var called = false;
        function onError(value) {
          if (called) {
            return;
          }
          called = true;
          handlers.reject(self, value);
        }
        function onSuccess(value) {
          if (called) {
            return;
          }
          called = true;
          handlers.resolve(self, value);
        }
        function tryToUnwrap() {
          thenable(onSuccess, onError);
        }
        var result = tryCatch(tryToUnwrap);
        if (result.status === 'error') {
          onError(result.value);
        }
      }
      function tryCatch(func, value) {
        var out = {};
        try {
          out.value = func(value);
          out.status = 'success';
        } catch (e) {
          out.status = 'error';
          out.value = e;
        }
        return out;
      }
      Promise.resolve = resolve;
      function resolve(value) {
        if (value instanceof this) {
          return value;
        }
        return handlers.resolve(new this(INTERNAL), value);
      }
      Promise.reject = reject;
      function reject(reason) {
        var promise = new this(INTERNAL);
        return handlers.reject(promise, reason);
      }
      Promise.all = all;
      function all(iterable) {
        var self = this;
        if (Object.prototype.toString.call(iterable) !== '[object Array]') {
          return this.reject(new TypeError('must be an array'));
        }
        var len = iterable.length;
        var called = false;
        if (!len) {
          return this.resolve([]);
        }
        var values = new Array(len);
        var resolved = 0;
        var i = -1;
        var promise = new this(INTERNAL);
        while (++i < len) {
          allResolver(iterable[i], i);
        }
        return promise;
        function allResolver(value, i) {
          self.resolve(value).then(resolveFromAll, function (error) {
            if (!called) {
              called = true;
              handlers.reject(promise, error);
            }
          });
          function resolveFromAll(outValue) {
            values[i] = outValue;
            if (++resolved === len && !called) {
              called = true;
              handlers.resolve(promise, values);
            }
          }
        }
      }
      Promise.race = race;
      function race(iterable) {
        var self = this;
        if (Object.prototype.toString.call(iterable) !== '[object Array]') {
          return this.reject(new TypeError('must be an array'));
        }
        var len = iterable.length;
        var called = false;
        if (!len) {
          return this.resolve([]);
        }
        var i = -1;
        var promise = new this(INTERNAL);
        while (++i < len) {
          resolver(iterable[i]);
        }
        return promise;
        function resolver(value) {
          self.resolve(value).then(function (response) {
            if (!called) {
              called = true;
              handlers.resolve(promise, response);
            }
          }, function (error) {
            if (!called) {
              called = true;
              handlers.reject(promise, error);
            }
          });
        }
      }
    }, {
      "immediate": 36
    }],
    38: [function (require, module, exports) {
      // Top level file is just a mixin of submodules & constants
      'use strict';

      var assign = require('./lib/utils/common').assign;
      var deflate = require('./lib/deflate');
      var inflate = require('./lib/inflate');
      var constants = require('./lib/zlib/constants');
      var pako = {};
      assign(pako, deflate, inflate, constants);
      module.exports = pako;
    }, {
      "./lib/deflate": 39,
      "./lib/inflate": 40,
      "./lib/utils/common": 41,
      "./lib/zlib/constants": 44
    }],
    39: [function (require, module, exports) {
      'use strict';

      var zlib_deflate = require('./zlib/deflate');
      var utils = require('./utils/common');
      var strings = require('./utils/strings');
      var msg = require('./zlib/messages');
      var ZStream = require('./zlib/zstream');
      var toString = Object.prototype.toString;

      /* Public constants ==========================================================*/
      /* ===========================================================================*/

      var Z_NO_FLUSH = 0;
      var Z_FINISH = 4;
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      var Z_SYNC_FLUSH = 2;
      var Z_DEFAULT_COMPRESSION = -1;
      var Z_DEFAULT_STRATEGY = 0;
      var Z_DEFLATED = 8;

      /* ===========================================================================*/

      /**
       * class Deflate
       *
       * Generic JS-style wrapper for zlib calls. If you don't need
       * streaming behaviour - use more simple functions: [[deflate]],
       * [[deflateRaw]] and [[gzip]].
       **/

      /* internal
       * Deflate.chunks -> Array
       *
       * Chunks of output data, if [[Deflate#onData]] not overriden.
       **/

      /**
       * Deflate.result -> Uint8Array|Array
       *
       * Compressed result, generated by default [[Deflate#onData]]
       * and [[Deflate#onEnd]] handlers. Filled after you push last chunk
       * (call [[Deflate#push]] with `Z_FINISH` / `true` param)  or if you
       * push a chunk with explicit flush (call [[Deflate#push]] with
       * `Z_SYNC_FLUSH` param).
       **/

      /**
       * Deflate.err -> Number
       *
       * Error code after deflate finished. 0 (Z_OK) on success.
       * You will not need it in real life, because deflate errors
       * are possible only on wrong options or bad `onData` / `onEnd`
       * custom handlers.
       **/

      /**
       * Deflate.msg -> String
       *
       * Error message, if [[Deflate.err]] != 0
       **/

      /**
       * new Deflate(options)
       * - options (Object): zlib deflate options.
       *
       * Creates new deflator instance with specified params. Throws exception
       * on bad params. Supported options:
       *
       * - `level`
       * - `windowBits`
       * - `memLevel`
       * - `strategy`
       * - `dictionary`
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information on these.
       *
       * Additional options, for internal needs:
       *
       * - `chunkSize` - size of generated data chunks (16K by default)
       * - `raw` (Boolean) - do raw deflate
       * - `gzip` (Boolean) - create gzip wrapper
       * - `to` (String) - if equal to 'string', then result will be "binary string"
       *    (each char code [0..255])
       * - `header` (Object) - custom header for gzip
       *   - `text` (Boolean) - true if compressed data believed to be text
       *   - `time` (Number) - modification time, unix timestamp
       *   - `os` (Number) - operation system code
       *   - `extra` (Array) - array of bytes with extra data (max 65536)
       *   - `name` (String) - file name (binary string)
       *   - `comment` (String) - comment (binary string)
       *   - `hcrc` (Boolean) - true if header crc should be added
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
       *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
       *
       * var deflate = new pako.Deflate({ level: 3});
       *
       * deflate.push(chunk1, false);
       * deflate.push(chunk2, true);  // true -> last chunk
       *
       * if (deflate.err) { throw new Error(deflate.err); }
       *
       * console.log(deflate.result);
       * ```
       **/
      function Deflate(options) {
        if (!(this instanceof Deflate)) return new Deflate(options);
        this.options = utils.assign({
          level: Z_DEFAULT_COMPRESSION,
          method: Z_DEFLATED,
          chunkSize: 16384,
          windowBits: 15,
          memLevel: 8,
          strategy: Z_DEFAULT_STRATEGY,
          to: ''
        }, options || {});
        var opt = this.options;
        if (opt.raw && opt.windowBits > 0) {
          opt.windowBits = -opt.windowBits;
        } else if (opt.gzip && opt.windowBits > 0 && opt.windowBits < 16) {
          opt.windowBits += 16;
        }
        this.err = 0; // error code, if happens (0 = Z_OK)
        this.msg = ''; // error message
        this.ended = false; // used to avoid multiple onEnd() calls
        this.chunks = []; // chunks of compressed data

        this.strm = new ZStream();
        this.strm.avail_out = 0;
        var status = zlib_deflate.deflateInit2(this.strm, opt.level, opt.method, opt.windowBits, opt.memLevel, opt.strategy);
        if (status !== Z_OK) {
          throw new Error(msg[status]);
        }
        if (opt.header) {
          zlib_deflate.deflateSetHeader(this.strm, opt.header);
        }
        if (opt.dictionary) {
          var dict;
          // Convert data if needed
          if (typeof opt.dictionary === 'string') {
            // If we need to compress text, change encoding to utf8.
            dict = strings.string2buf(opt.dictionary);
          } else if (toString.call(opt.dictionary) === '[object ArrayBuffer]') {
            dict = new Uint8Array(opt.dictionary);
          } else {
            dict = opt.dictionary;
          }
          status = zlib_deflate.deflateSetDictionary(this.strm, dict);
          if (status !== Z_OK) {
            throw new Error(msg[status]);
          }
          this._dict_set = true;
        }
      }

      /**
       * Deflate#push(data[, mode]) -> Boolean
       * - data (Uint8Array|Array|ArrayBuffer|String): input data. Strings will be
       *   converted to utf8 byte sequence.
       * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
       *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
       *
       * Sends input data to deflate pipe, generating [[Deflate#onData]] calls with
       * new compressed chunks. Returns `true` on success. The last data block must have
       * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
       * [[Deflate#onEnd]]. For interim explicit flushes (without ending the stream) you
       * can use mode Z_SYNC_FLUSH, keeping the compression context.
       *
       * On fail call [[Deflate#onEnd]] with error code and return false.
       *
       * We strongly recommend to use `Uint8Array` on input for best speed (output
       * array format is detected automatically). Also, don't skip last param and always
       * use the same type in your code (boolean or number). That will improve JS speed.
       *
       * For regular `Array`-s make sure all elements are [0..255].
       *
       * ##### Example
       *
       * ```javascript
       * push(chunk, false); // push one of data chunks
       * ...
       * push(chunk, true);  // push last chunk
       * ```
       **/
      Deflate.prototype.push = function (data, mode) {
        var strm = this.strm;
        var chunkSize = this.options.chunkSize;
        var status, _mode;
        if (this.ended) {
          return false;
        }
        _mode = mode === ~~mode ? mode : mode === true ? Z_FINISH : Z_NO_FLUSH;

        // Convert data if needed
        if (typeof data === 'string') {
          // If we need to compress text, change encoding to utf8.
          strm.input = strings.string2buf(data);
        } else if (toString.call(data) === '[object ArrayBuffer]') {
          strm.input = new Uint8Array(data);
        } else {
          strm.input = data;
        }
        strm.next_in = 0;
        strm.avail_in = strm.input.length;
        do {
          if (strm.avail_out === 0) {
            strm.output = new utils.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
          }
          status = zlib_deflate.deflate(strm, _mode); /* no bad return value */

          if (status !== Z_STREAM_END && status !== Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
          }
          if (strm.avail_out === 0 || strm.avail_in === 0 && (_mode === Z_FINISH || _mode === Z_SYNC_FLUSH)) {
            if (this.options.to === 'string') {
              this.onData(strings.buf2binstring(utils.shrinkBuf(strm.output, strm.next_out)));
            } else {
              this.onData(utils.shrinkBuf(strm.output, strm.next_out));
            }
          }
        } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== Z_STREAM_END);

        // Finalize on the last chunk.
        if (_mode === Z_FINISH) {
          status = zlib_deflate.deflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return status === Z_OK;
        }

        // callback interim results if Z_SYNC_FLUSH.
        if (_mode === Z_SYNC_FLUSH) {
          this.onEnd(Z_OK);
          strm.avail_out = 0;
          return true;
        }
        return true;
      };

      /**
       * Deflate#onData(chunk) -> Void
       * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
       *   on js engine support. When string output requested, each chunk
       *   will be string.
       *
       * By default, stores data blocks in `chunks[]` property and glue
       * those in `onEnd`. Override this handler, if you need another behaviour.
       **/
      Deflate.prototype.onData = function (chunk) {
        this.chunks.push(chunk);
      };

      /**
       * Deflate#onEnd(status) -> Void
       * - status (Number): deflate status. 0 (Z_OK) on success,
       *   other if not.
       *
       * Called once after you tell deflate that the input stream is
       * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
       * or if an error happened. By default - join collected chunks,
       * free memory and fill `results` / `err` properties.
       **/
      Deflate.prototype.onEnd = function (status) {
        // On success - join
        if (status === Z_OK) {
          if (this.options.to === 'string') {
            this.result = this.chunks.join('');
          } else {
            this.result = utils.flattenChunks(this.chunks);
          }
        }
        this.chunks = [];
        this.err = status;
        this.msg = this.strm.msg;
      };

      /**
       * deflate(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to compress.
       * - options (Object): zlib deflate options.
       *
       * Compress `data` with deflate algorithm and `options`.
       *
       * Supported options are:
       *
       * - level
       * - windowBits
       * - memLevel
       * - strategy
       * - dictionary
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information on these.
       *
       * Sugar (options):
       *
       * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
       *   negative windowBits implicitly.
       * - `to` (String) - if equal to 'string', then result will be "binary string"
       *    (each char code [0..255])
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , data = Uint8Array([1,2,3,4,5,6,7,8,9]);
       *
       * console.log(pako.deflate(data));
       * ```
       **/
      function deflate(input, options) {
        var deflator = new Deflate(options);
        deflator.push(input, true);

        // That will never happens, if you don't cheat with options :)
        if (deflator.err) {
          throw deflator.msg || msg[deflator.err];
        }
        return deflator.result;
      }

      /**
       * deflateRaw(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to compress.
       * - options (Object): zlib deflate options.
       *
       * The same as [[deflate]], but creates raw data, without wrapper
       * (header and adler32 crc).
       **/
      function deflateRaw(input, options) {
        options = options || {};
        options.raw = true;
        return deflate(input, options);
      }

      /**
       * gzip(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to compress.
       * - options (Object): zlib deflate options.
       *
       * The same as [[deflate]], but create gzip wrapper instead of
       * deflate one.
       **/
      function gzip(input, options) {
        options = options || {};
        options.gzip = true;
        return deflate(input, options);
      }
      exports.Deflate = Deflate;
      exports.deflate = deflate;
      exports.deflateRaw = deflateRaw;
      exports.gzip = gzip;
    }, {
      "./utils/common": 41,
      "./utils/strings": 42,
      "./zlib/deflate": 46,
      "./zlib/messages": 51,
      "./zlib/zstream": 53
    }],
    40: [function (require, module, exports) {
      'use strict';

      var zlib_inflate = require('./zlib/inflate');
      var utils = require('./utils/common');
      var strings = require('./utils/strings');
      var c = require('./zlib/constants');
      var msg = require('./zlib/messages');
      var ZStream = require('./zlib/zstream');
      var GZheader = require('./zlib/gzheader');
      var toString = Object.prototype.toString;

      /**
       * class Inflate
       *
       * Generic JS-style wrapper for zlib calls. If you don't need
       * streaming behaviour - use more simple functions: [[inflate]]
       * and [[inflateRaw]].
       **/

      /* internal
       * inflate.chunks -> Array
       *
       * Chunks of output data, if [[Inflate#onData]] not overriden.
       **/

      /**
       * Inflate.result -> Uint8Array|Array|String
       *
       * Uncompressed result, generated by default [[Inflate#onData]]
       * and [[Inflate#onEnd]] handlers. Filled after you push last chunk
       * (call [[Inflate#push]] with `Z_FINISH` / `true` param) or if you
       * push a chunk with explicit flush (call [[Inflate#push]] with
       * `Z_SYNC_FLUSH` param).
       **/

      /**
       * Inflate.err -> Number
       *
       * Error code after inflate finished. 0 (Z_OK) on success.
       * Should be checked if broken data possible.
       **/

      /**
       * Inflate.msg -> String
       *
       * Error message, if [[Inflate.err]] != 0
       **/

      /**
       * new Inflate(options)
       * - options (Object): zlib inflate options.
       *
       * Creates new inflator instance with specified params. Throws exception
       * on bad params. Supported options:
       *
       * - `windowBits`
       * - `dictionary`
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information on these.
       *
       * Additional options, for internal needs:
       *
       * - `chunkSize` - size of generated data chunks (16K by default)
       * - `raw` (Boolean) - do raw inflate
       * - `to` (String) - if equal to 'string', then result will be converted
       *   from utf8 to utf16 (javascript) string. When string output requested,
       *   chunk length can differ from `chunkSize`, depending on content.
       *
       * By default, when no options set, autodetect deflate/gzip data format via
       * wrapper header.
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , chunk1 = Uint8Array([1,2,3,4,5,6,7,8,9])
       *   , chunk2 = Uint8Array([10,11,12,13,14,15,16,17,18,19]);
       *
       * var inflate = new pako.Inflate({ level: 3});
       *
       * inflate.push(chunk1, false);
       * inflate.push(chunk2, true);  // true -> last chunk
       *
       * if (inflate.err) { throw new Error(inflate.err); }
       *
       * console.log(inflate.result);
       * ```
       **/
      function Inflate(options) {
        if (!(this instanceof Inflate)) return new Inflate(options);
        this.options = utils.assign({
          chunkSize: 16384,
          windowBits: 0,
          to: ''
        }, options || {});
        var opt = this.options;

        // Force window size for `raw` data, if not set directly,
        // because we have no header for autodetect.
        if (opt.raw && opt.windowBits >= 0 && opt.windowBits < 16) {
          opt.windowBits = -opt.windowBits;
          if (opt.windowBits === 0) {
            opt.windowBits = -15;
          }
        }

        // If `windowBits` not defined (and mode not raw) - set autodetect flag for gzip/deflate
        if (opt.windowBits >= 0 && opt.windowBits < 16 && !(options && options.windowBits)) {
          opt.windowBits += 32;
        }

        // Gzip header has no info about windows size, we can do autodetect only
        // for deflate. So, if window size not set, force it to max when gzip possible
        if (opt.windowBits > 15 && opt.windowBits < 48) {
          // bit 3 (16) -> gzipped data
          // bit 4 (32) -> autodetect gzip/deflate
          if ((opt.windowBits & 15) === 0) {
            opt.windowBits |= 15;
          }
        }
        this.err = 0; // error code, if happens (0 = Z_OK)
        this.msg = ''; // error message
        this.ended = false; // used to avoid multiple onEnd() calls
        this.chunks = []; // chunks of compressed data

        this.strm = new ZStream();
        this.strm.avail_out = 0;
        var status = zlib_inflate.inflateInit2(this.strm, opt.windowBits);
        if (status !== c.Z_OK) {
          throw new Error(msg[status]);
        }
        this.header = new GZheader();
        zlib_inflate.inflateGetHeader(this.strm, this.header);
      }

      /**
       * Inflate#push(data[, mode]) -> Boolean
       * - data (Uint8Array|Array|ArrayBuffer|String): input data
       * - mode (Number|Boolean): 0..6 for corresponding Z_NO_FLUSH..Z_TREE modes.
       *   See constants. Skipped or `false` means Z_NO_FLUSH, `true` meansh Z_FINISH.
       *
       * Sends input data to inflate pipe, generating [[Inflate#onData]] calls with
       * new output chunks. Returns `true` on success. The last data block must have
       * mode Z_FINISH (or `true`). That will flush internal pending buffers and call
       * [[Inflate#onEnd]]. For interim explicit flushes (without ending the stream) you
       * can use mode Z_SYNC_FLUSH, keeping the decompression context.
       *
       * On fail call [[Inflate#onEnd]] with error code and return false.
       *
       * We strongly recommend to use `Uint8Array` on input for best speed (output
       * format is detected automatically). Also, don't skip last param and always
       * use the same type in your code (boolean or number). That will improve JS speed.
       *
       * For regular `Array`-s make sure all elements are [0..255].
       *
       * ##### Example
       *
       * ```javascript
       * push(chunk, false); // push one of data chunks
       * ...
       * push(chunk, true);  // push last chunk
       * ```
       **/
      Inflate.prototype.push = function (data, mode) {
        var strm = this.strm;
        var chunkSize = this.options.chunkSize;
        var dictionary = this.options.dictionary;
        var status, _mode;
        var next_out_utf8, tail, utf8str;
        var dict;

        // Flag to properly process Z_BUF_ERROR on testing inflate call
        // when we check that all output data was flushed.
        var allowBufError = false;
        if (this.ended) {
          return false;
        }
        _mode = mode === ~~mode ? mode : mode === true ? c.Z_FINISH : c.Z_NO_FLUSH;

        // Convert data if needed
        if (typeof data === 'string') {
          // Only binary strings can be decompressed on practice
          strm.input = strings.binstring2buf(data);
        } else if (toString.call(data) === '[object ArrayBuffer]') {
          strm.input = new Uint8Array(data);
        } else {
          strm.input = data;
        }
        strm.next_in = 0;
        strm.avail_in = strm.input.length;
        do {
          if (strm.avail_out === 0) {
            strm.output = new utils.Buf8(chunkSize);
            strm.next_out = 0;
            strm.avail_out = chunkSize;
          }
          status = zlib_inflate.inflate(strm, c.Z_NO_FLUSH); /* no bad return value */

          if (status === c.Z_NEED_DICT && dictionary) {
            // Convert data if needed
            if (typeof dictionary === 'string') {
              dict = strings.string2buf(dictionary);
            } else if (toString.call(dictionary) === '[object ArrayBuffer]') {
              dict = new Uint8Array(dictionary);
            } else {
              dict = dictionary;
            }
            status = zlib_inflate.inflateSetDictionary(this.strm, dict);
          }
          if (status === c.Z_BUF_ERROR && allowBufError === true) {
            status = c.Z_OK;
            allowBufError = false;
          }
          if (status !== c.Z_STREAM_END && status !== c.Z_OK) {
            this.onEnd(status);
            this.ended = true;
            return false;
          }
          if (strm.next_out) {
            if (strm.avail_out === 0 || status === c.Z_STREAM_END || strm.avail_in === 0 && (_mode === c.Z_FINISH || _mode === c.Z_SYNC_FLUSH)) {
              if (this.options.to === 'string') {
                next_out_utf8 = strings.utf8border(strm.output, strm.next_out);
                tail = strm.next_out - next_out_utf8;
                utf8str = strings.buf2string(strm.output, next_out_utf8);

                // move tail
                strm.next_out = tail;
                strm.avail_out = chunkSize - tail;
                if (tail) {
                  utils.arraySet(strm.output, strm.output, next_out_utf8, tail, 0);
                }
                this.onData(utf8str);
              } else {
                this.onData(utils.shrinkBuf(strm.output, strm.next_out));
              }
            }
          }

          // When no more input data, we should check that internal inflate buffers
          // are flushed. The only way to do it when avail_out = 0 - run one more
          // inflate pass. But if output data not exists, inflate return Z_BUF_ERROR.
          // Here we set flag to process this error properly.
          //
          // NOTE. Deflate does not return error in this case and does not needs such
          // logic.
          if (strm.avail_in === 0 && strm.avail_out === 0) {
            allowBufError = true;
          }
        } while ((strm.avail_in > 0 || strm.avail_out === 0) && status !== c.Z_STREAM_END);
        if (status === c.Z_STREAM_END) {
          _mode = c.Z_FINISH;
        }

        // Finalize on the last chunk.
        if (_mode === c.Z_FINISH) {
          status = zlib_inflate.inflateEnd(this.strm);
          this.onEnd(status);
          this.ended = true;
          return status === c.Z_OK;
        }

        // callback interim results if Z_SYNC_FLUSH.
        if (_mode === c.Z_SYNC_FLUSH) {
          this.onEnd(c.Z_OK);
          strm.avail_out = 0;
          return true;
        }
        return true;
      };

      /**
       * Inflate#onData(chunk) -> Void
       * - chunk (Uint8Array|Array|String): ouput data. Type of array depends
       *   on js engine support. When string output requested, each chunk
       *   will be string.
       *
       * By default, stores data blocks in `chunks[]` property and glue
       * those in `onEnd`. Override this handler, if you need another behaviour.
       **/
      Inflate.prototype.onData = function (chunk) {
        this.chunks.push(chunk);
      };

      /**
       * Inflate#onEnd(status) -> Void
       * - status (Number): inflate status. 0 (Z_OK) on success,
       *   other if not.
       *
       * Called either after you tell inflate that the input stream is
       * complete (Z_FINISH) or should be flushed (Z_SYNC_FLUSH)
       * or if an error happened. By default - join collected chunks,
       * free memory and fill `results` / `err` properties.
       **/
      Inflate.prototype.onEnd = function (status) {
        // On success - join
        if (status === c.Z_OK) {
          if (this.options.to === 'string') {
            // Glue & convert here, until we teach pako to send
            // utf8 alligned strings to onData
            this.result = this.chunks.join('');
          } else {
            this.result = utils.flattenChunks(this.chunks);
          }
        }
        this.chunks = [];
        this.err = status;
        this.msg = this.strm.msg;
      };

      /**
       * inflate(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to decompress.
       * - options (Object): zlib inflate options.
       *
       * Decompress `data` with inflate/ungzip and `options`. Autodetect
       * format via wrapper header by default. That's why we don't provide
       * separate `ungzip` method.
       *
       * Supported options are:
       *
       * - windowBits
       *
       * [http://zlib.net/manual.html#Advanced](http://zlib.net/manual.html#Advanced)
       * for more information.
       *
       * Sugar (options):
       *
       * - `raw` (Boolean) - say that we work with raw stream, if you don't wish to specify
       *   negative windowBits implicitly.
       * - `to` (String) - if equal to 'string', then result will be converted
       *   from utf8 to utf16 (javascript) string. When string output requested,
       *   chunk length can differ from `chunkSize`, depending on content.
       *
       *
       * ##### Example:
       *
       * ```javascript
       * var pako = require('pako')
       *   , input = pako.deflate([1,2,3,4,5,6,7,8,9])
       *   , output;
       *
       * try {
       *   output = pako.inflate(input);
       * } catch (err)
       *   console.log(err);
       * }
       * ```
       **/
      function inflate(input, options) {
        var inflator = new Inflate(options);
        inflator.push(input, true);

        // That will never happens, if you don't cheat with options :)
        if (inflator.err) {
          throw inflator.msg || msg[inflator.err];
        }
        return inflator.result;
      }

      /**
       * inflateRaw(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to decompress.
       * - options (Object): zlib inflate options.
       *
       * The same as [[inflate]], but creates raw data, without wrapper
       * (header and adler32 crc).
       **/
      function inflateRaw(input, options) {
        options = options || {};
        options.raw = true;
        return inflate(input, options);
      }

      /**
       * ungzip(data[, options]) -> Uint8Array|Array|String
       * - data (Uint8Array|Array|String): input data to decompress.
       * - options (Object): zlib inflate options.
       *
       * Just shortcut to [[inflate]], because it autodetects format
       * by header.content. Done for convenience.
       **/

      exports.Inflate = Inflate;
      exports.inflate = inflate;
      exports.inflateRaw = inflateRaw;
      exports.ungzip = inflate;
    }, {
      "./utils/common": 41,
      "./utils/strings": 42,
      "./zlib/constants": 44,
      "./zlib/gzheader": 47,
      "./zlib/inflate": 49,
      "./zlib/messages": 51,
      "./zlib/zstream": 53
    }],
    41: [function (require, module, exports) {
      'use strict';

      var TYPED_OK = typeof Uint8Array !== 'undefined' && typeof Uint16Array !== 'undefined' && typeof Int32Array !== 'undefined';
      exports.assign = function (obj /*from1, from2, from3, ...*/) {
        var sources = Array.prototype.slice.call(arguments, 1);
        while (sources.length) {
          var source = sources.shift();
          if (!source) {
            continue;
          }
          if (_typeof(source) !== 'object') {
            throw new TypeError(source + 'must be non-object');
          }
          for (var p in source) {
            if (source.hasOwnProperty(p)) {
              obj[p] = source[p];
            }
          }
        }
        return obj;
      };

      // reduce buffer size, avoiding mem copy
      exports.shrinkBuf = function (buf, size) {
        if (buf.length === size) {
          return buf;
        }
        if (buf.subarray) {
          return buf.subarray(0, size);
        }
        buf.length = size;
        return buf;
      };
      var fnTyped = {
        arraySet: function arraySet(dest, src, src_offs, len, dest_offs) {
          if (src.subarray && dest.subarray) {
            dest.set(src.subarray(src_offs, src_offs + len), dest_offs);
            return;
          }
          // Fallback to ordinary array
          for (var i = 0; i < len; i++) {
            dest[dest_offs + i] = src[src_offs + i];
          }
        },
        // Join array of chunks to single array.
        flattenChunks: function flattenChunks(chunks) {
          var i, l, len, pos, chunk, result;

          // calculate data length
          len = 0;
          for (i = 0, l = chunks.length; i < l; i++) {
            len += chunks[i].length;
          }

          // join chunks
          result = new Uint8Array(len);
          pos = 0;
          for (i = 0, l = chunks.length; i < l; i++) {
            chunk = chunks[i];
            result.set(chunk, pos);
            pos += chunk.length;
          }
          return result;
        }
      };
      var fnUntyped = {
        arraySet: function arraySet(dest, src, src_offs, len, dest_offs) {
          for (var i = 0; i < len; i++) {
            dest[dest_offs + i] = src[src_offs + i];
          }
        },
        // Join array of chunks to single array.
        flattenChunks: function flattenChunks(chunks) {
          return [].concat.apply([], chunks);
        }
      };

      // Enable/Disable typed arrays use, for testing
      //
      exports.setTyped = function (on) {
        if (on) {
          exports.Buf8 = Uint8Array;
          exports.Buf16 = Uint16Array;
          exports.Buf32 = Int32Array;
          exports.assign(exports, fnTyped);
        } else {
          exports.Buf8 = Array;
          exports.Buf16 = Array;
          exports.Buf32 = Array;
          exports.assign(exports, fnUntyped);
        }
      };
      exports.setTyped(TYPED_OK);
    }, {}],
    42: [function (require, module, exports) {
      // String encode/decode helpers
      'use strict';

      var utils = require('./common');

      // Quick check if we can use fast array to bin string conversion
      //
      // - apply(Array) can fail on Android 2.2
      // - apply(Uint8Array) can fail on iOS 5.1 Safary
      //
      var STR_APPLY_OK = true;
      var STR_APPLY_UIA_OK = true;
      try {
        String.fromCharCode.apply(null, [0]);
      } catch (__) {
        STR_APPLY_OK = false;
      }
      try {
        String.fromCharCode.apply(null, new Uint8Array(1));
      } catch (__) {
        STR_APPLY_UIA_OK = false;
      }

      // Table with utf8 lengths (calculated by first byte of sequence)
      // Note, that 5 & 6-byte values and some 4-byte values can not be represented in JS,
      // because max possible codepoint is 0x10ffff
      var _utf8len = new utils.Buf8(256);
      for (var q = 0; q < 256; q++) {
        _utf8len[q] = q >= 252 ? 6 : q >= 248 ? 5 : q >= 240 ? 4 : q >= 224 ? 3 : q >= 192 ? 2 : 1;
      }
      _utf8len[254] = _utf8len[254] = 1; // Invalid sequence start

      // convert string to array (typed, when possible)
      exports.string2buf = function (str) {
        var buf,
          c,
          c2,
          m_pos,
          i,
          str_len = str.length,
          buf_len = 0;

        // count binary size
        for (m_pos = 0; m_pos < str_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }
          buf_len += c < 0x80 ? 1 : c < 0x800 ? 2 : c < 0x10000 ? 3 : 4;
        }

        // allocate buffer
        buf = new utils.Buf8(buf_len);

        // convert
        for (i = 0, m_pos = 0; i < buf_len; m_pos++) {
          c = str.charCodeAt(m_pos);
          if ((c & 0xfc00) === 0xd800 && m_pos + 1 < str_len) {
            c2 = str.charCodeAt(m_pos + 1);
            if ((c2 & 0xfc00) === 0xdc00) {
              c = 0x10000 + (c - 0xd800 << 10) + (c2 - 0xdc00);
              m_pos++;
            }
          }
          if (c < 0x80) {
            /* one byte */
            buf[i++] = c;
          } else if (c < 0x800) {
            /* two bytes */
            buf[i++] = 0xC0 | c >>> 6;
            buf[i++] = 0x80 | c & 0x3f;
          } else if (c < 0x10000) {
            /* three bytes */
            buf[i++] = 0xE0 | c >>> 12;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          } else {
            /* four bytes */
            buf[i++] = 0xf0 | c >>> 18;
            buf[i++] = 0x80 | c >>> 12 & 0x3f;
            buf[i++] = 0x80 | c >>> 6 & 0x3f;
            buf[i++] = 0x80 | c & 0x3f;
          }
        }
        return buf;
      };

      // Helper (used in 2 places)
      function buf2binstring(buf, len) {
        // use fallback for big arrays to avoid stack overflow
        if (len < 65537) {
          if (buf.subarray && STR_APPLY_UIA_OK || !buf.subarray && STR_APPLY_OK) {
            return String.fromCharCode.apply(null, utils.shrinkBuf(buf, len));
          }
        }
        var result = '';
        for (var i = 0; i < len; i++) {
          result += String.fromCharCode(buf[i]);
        }
        return result;
      }

      // Convert byte array to binary string
      exports.buf2binstring = function (buf) {
        return buf2binstring(buf, buf.length);
      };

      // Convert binary string (typed, when possible)
      exports.binstring2buf = function (str) {
        var buf = new utils.Buf8(str.length);
        for (var i = 0, len = buf.length; i < len; i++) {
          buf[i] = str.charCodeAt(i);
        }
        return buf;
      };

      // convert array to string
      exports.buf2string = function (buf, max) {
        var i, out, c, c_len;
        var len = max || buf.length;

        // Reserve max possible length (2 words per char)
        // NB: by unknown reasons, Array is significantly faster for
        //     String.fromCharCode.apply than Uint16Array.
        var utf16buf = new Array(len * 2);
        for (out = 0, i = 0; i < len;) {
          c = buf[i++];
          // quick process ascii
          if (c < 0x80) {
            utf16buf[out++] = c;
            continue;
          }
          c_len = _utf8len[c];
          // skip 5 & 6 byte codes
          if (c_len > 4) {
            utf16buf[out++] = 0xfffd;
            i += c_len - 1;
            continue;
          }

          // apply mask on first byte
          c &= c_len === 2 ? 0x1f : c_len === 3 ? 0x0f : 0x07;
          // join the rest
          while (c_len > 1 && i < len) {
            c = c << 6 | buf[i++] & 0x3f;
            c_len--;
          }

          // terminated by end of string?
          if (c_len > 1) {
            utf16buf[out++] = 0xfffd;
            continue;
          }
          if (c < 0x10000) {
            utf16buf[out++] = c;
          } else {
            c -= 0x10000;
            utf16buf[out++] = 0xd800 | c >> 10 & 0x3ff;
            utf16buf[out++] = 0xdc00 | c & 0x3ff;
          }
        }
        return buf2binstring(utf16buf, out);
      };

      // Calculate max possible position in utf8 buffer,
      // that will not break sequence. If that's not possible
      // - (very small limits) return max size as is.
      //
      // buf[] - utf8 bytes array
      // max   - length limit (mandatory);
      exports.utf8border = function (buf, max) {
        var pos;
        max = max || buf.length;
        if (max > buf.length) {
          max = buf.length;
        }

        // go back from last position, until start of sequence found
        pos = max - 1;
        while (pos >= 0 && (buf[pos] & 0xC0) === 0x80) {
          pos--;
        }

        // Fuckup - very small and broken sequence,
        // return max, because we should return something anyway.
        if (pos < 0) {
          return max;
        }

        // If we came to start of buffer - that means vuffer is too small,
        // return max too.
        if (pos === 0) {
          return max;
        }
        return pos + _utf8len[buf[pos]] > max ? pos : max;
      };
    }, {
      "./common": 41
    }],
    43: [function (require, module, exports) {
      'use strict';

      // Note: adler32 takes 12% for level 0 and 2% for level 6.
      // It doesn't worth to make additional optimizationa as in original.
      // Small size is preferable.

      // (C) 1995-2013 Jean-loup Gailly and Mark Adler
      // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
      //
      // This software is provided 'as-is', without any express or implied
      // warranty. In no event will the authors be held liable for any damages
      // arising from the use of this software.
      //
      // Permission is granted to anyone to use this software for any purpose,
      // including commercial applications, and to alter it and redistribute it
      // freely, subject to the following restrictions:
      //
      // 1. The origin of this software must not be misrepresented; you must not
      //   claim that you wrote the original software. If you use this software
      //   in a product, an acknowledgment in the product documentation would be
      //   appreciated but is not required.
      // 2. Altered source versions must be plainly marked as such, and must not be
      //   misrepresented as being the original software.
      // 3. This notice may not be removed or altered from any source distribution.
      function adler32(adler, buf, len, pos) {
        var s1 = adler & 0xffff | 0,
          s2 = adler >>> 16 & 0xffff | 0,
          n = 0;
        while (len !== 0) {
          // Set limit ~ twice less than 5552, to keep
          // s2 in 31-bits, because we force signed ints.
          // in other case %= will fail.
          n = len > 2000 ? 2000 : len;
          len -= n;
          do {
            s1 = s1 + buf[pos++] | 0;
            s2 = s2 + s1 | 0;
          } while (--n);
          s1 %= 65521;
          s2 %= 65521;
        }
        return s1 | s2 << 16 | 0;
      }
      module.exports = adler32;
    }, {}],
    44: [function (require, module, exports) {
      'use strict';

      // (C) 1995-2013 Jean-loup Gailly and Mark Adler
      // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
      //
      // This software is provided 'as-is', without any express or implied
      // warranty. In no event will the authors be held liable for any damages
      // arising from the use of this software.
      //
      // Permission is granted to anyone to use this software for any purpose,
      // including commercial applications, and to alter it and redistribute it
      // freely, subject to the following restrictions:
      //
      // 1. The origin of this software must not be misrepresented; you must not
      //   claim that you wrote the original software. If you use this software
      //   in a product, an acknowledgment in the product documentation would be
      //   appreciated but is not required.
      // 2. Altered source versions must be plainly marked as such, and must not be
      //   misrepresented as being the original software.
      // 3. This notice may not be removed or altered from any source distribution.
      module.exports = {
        /* Allowed flush values; see deflate() and inflate() below for details */
        Z_NO_FLUSH: 0,
        Z_PARTIAL_FLUSH: 1,
        Z_SYNC_FLUSH: 2,
        Z_FULL_FLUSH: 3,
        Z_FINISH: 4,
        Z_BLOCK: 5,
        Z_TREES: 6,
        /* Return codes for the compression/decompression functions. Negative values
        * are errors, positive values are used for special but normal events.
        */
        Z_OK: 0,
        Z_STREAM_END: 1,
        Z_NEED_DICT: 2,
        Z_ERRNO: -1,
        Z_STREAM_ERROR: -2,
        Z_DATA_ERROR: -3,
        //Z_MEM_ERROR:     -4,
        Z_BUF_ERROR: -5,
        //Z_VERSION_ERROR: -6,

        /* compression levels */
        Z_NO_COMPRESSION: 0,
        Z_BEST_SPEED: 1,
        Z_BEST_COMPRESSION: 9,
        Z_DEFAULT_COMPRESSION: -1,
        Z_FILTERED: 1,
        Z_HUFFMAN_ONLY: 2,
        Z_RLE: 3,
        Z_FIXED: 4,
        Z_DEFAULT_STRATEGY: 0,
        /* Possible values of the data_type field (though see inflate()) */
        Z_BINARY: 0,
        Z_TEXT: 1,
        //Z_ASCII:                1, // = Z_TEXT (deprecated)
        Z_UNKNOWN: 2,
        /* The deflate compression method */
        Z_DEFLATED: 8
        //Z_NULL:                 null // Use -1 or null inline, depending on var type
      };
    }, {}],
    45: [function (require, module, exports) {
      'use strict';

      // Note: we can't get significant speed boost here.
      // So write code to minimize size - no pregenerated tables
      // and array tools dependencies.

      // (C) 1995-2013 Jean-loup Gailly and Mark Adler
      // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
      //
      // This software is provided 'as-is', without any express or implied
      // warranty. In no event will the authors be held liable for any damages
      // arising from the use of this software.
      //
      // Permission is granted to anyone to use this software for any purpose,
      // including commercial applications, and to alter it and redistribute it
      // freely, subject to the following restrictions:
      //
      // 1. The origin of this software must not be misrepresented; you must not
      //   claim that you wrote the original software. If you use this software
      //   in a product, an acknowledgment in the product documentation would be
      //   appreciated but is not required.
      // 2. Altered source versions must be plainly marked as such, and must not be
      //   misrepresented as being the original software.
      // 3. This notice may not be removed or altered from any source distribution.

      // Use ordinary array, since untyped makes no boost here
      function makeTable() {
        var c,
          table = [];
        for (var n = 0; n < 256; n++) {
          c = n;
          for (var k = 0; k < 8; k++) {
            c = c & 1 ? 0xEDB88320 ^ c >>> 1 : c >>> 1;
          }
          table[n] = c;
        }
        return table;
      }

      // Create table on load. Just 255 signed longs. Not a problem.
      var crcTable = makeTable();
      function crc32(crc, buf, len, pos) {
        var t = crcTable,
          end = pos + len;
        crc ^= -1;
        for (var i = pos; i < end; i++) {
          crc = crc >>> 8 ^ t[(crc ^ buf[i]) & 0xFF];
        }
        return crc ^ -1; // >>> 0;
      }
      module.exports = crc32;
    }, {}],
    46: [function (require, module, exports) {
      'use strict';

      // (C) 1995-2013 Jean-loup Gailly and Mark Adler
      // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
      //
      // This software is provided 'as-is', without any express or implied
      // warranty. In no event will the authors be held liable for any damages
      // arising from the use of this software.
      //
      // Permission is granted to anyone to use this software for any purpose,
      // including commercial applications, and to alter it and redistribute it
      // freely, subject to the following restrictions:
      //
      // 1. The origin of this software must not be misrepresented; you must not
      //   claim that you wrote the original software. If you use this software
      //   in a product, an acknowledgment in the product documentation would be
      //   appreciated but is not required.
      // 2. Altered source versions must be plainly marked as such, and must not be
      //   misrepresented as being the original software.
      // 3. This notice may not be removed or altered from any source distribution.
      var utils = require('../utils/common');
      var trees = require('./trees');
      var adler32 = require('./adler32');
      var crc32 = require('./crc32');
      var msg = require('./messages');

      /* Public constants ==========================================================*/
      /* ===========================================================================*/

      /* Allowed flush values; see deflate() and inflate() below for details */
      var Z_NO_FLUSH = 0;
      var Z_PARTIAL_FLUSH = 1;
      //var Z_SYNC_FLUSH    = 2;
      var Z_FULL_FLUSH = 3;
      var Z_FINISH = 4;
      var Z_BLOCK = 5;
      //var Z_TREES         = 6;

      /* Return codes for the compression/decompression functions. Negative values
       * are errors, positive values are used for special but normal events.
       */
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      //var Z_NEED_DICT     = 2;
      //var Z_ERRNO         = -1;
      var Z_STREAM_ERROR = -2;
      var Z_DATA_ERROR = -3;
      //var Z_MEM_ERROR     = -4;
      var Z_BUF_ERROR = -5;
      //var Z_VERSION_ERROR = -6;

      /* compression levels */
      //var Z_NO_COMPRESSION      = 0;
      //var Z_BEST_SPEED          = 1;
      //var Z_BEST_COMPRESSION    = 9;
      var Z_DEFAULT_COMPRESSION = -1;
      var Z_FILTERED = 1;
      var Z_HUFFMAN_ONLY = 2;
      var Z_RLE = 3;
      var Z_FIXED = 4;
      var Z_DEFAULT_STRATEGY = 0;

      /* Possible values of the data_type field (though see inflate()) */
      //var Z_BINARY              = 0;
      //var Z_TEXT                = 1;
      //var Z_ASCII               = 1; // = Z_TEXT
      var Z_UNKNOWN = 2;

      /* The deflate compression method */
      var Z_DEFLATED = 8;

      /*============================================================================*/

      var MAX_MEM_LEVEL = 9;
      /* Maximum value for memLevel in deflateInit2 */
      var MAX_WBITS = 15;
      /* 32K LZ77 window */
      var DEF_MEM_LEVEL = 8;
      var LENGTH_CODES = 29;
      /* number of length codes, not counting the special END_BLOCK code */
      var LITERALS = 256;
      /* number of literal bytes 0..255 */
      var L_CODES = LITERALS + 1 + LENGTH_CODES;
      /* number of Literal or Length codes, including the END_BLOCK code */
      var D_CODES = 30;
      /* number of distance codes */
      var BL_CODES = 19;
      /* number of codes used to transfer the bit lengths */
      var HEAP_SIZE = 2 * L_CODES + 1;
      /* maximum heap size */
      var MAX_BITS = 15;
      /* All codes must not exceed MAX_BITS bits */

      var MIN_MATCH = 3;
      var MAX_MATCH = 258;
      var MIN_LOOKAHEAD = MAX_MATCH + MIN_MATCH + 1;
      var PRESET_DICT = 0x20;
      var INIT_STATE = 42;
      var EXTRA_STATE = 69;
      var NAME_STATE = 73;
      var COMMENT_STATE = 91;
      var HCRC_STATE = 103;
      var BUSY_STATE = 113;
      var FINISH_STATE = 666;
      var BS_NEED_MORE = 1; /* block not completed, need more input or more output */
      var BS_BLOCK_DONE = 2; /* block flush performed */
      var BS_FINISH_STARTED = 3; /* finish started, need only more output at next deflate */
      var BS_FINISH_DONE = 4; /* finish done, accept no more input or output */

      var OS_CODE = 0x03; // Unix :) . Don't detect, use this default.

      function err(strm, errorCode) {
        strm.msg = msg[errorCode];
        return errorCode;
      }
      function rank(f) {
        return (f << 1) - (f > 4 ? 9 : 0);
      }
      function zero(buf) {
        var len = buf.length;
        while (--len >= 0) {
          buf[len] = 0;
        }
      }

      /* =========================================================================
       * Flush as much pending output as possible. All deflate() output goes
       * through this function so some applications may wish to modify it
       * to avoid allocating a large strm->output buffer and copying into it.
       * (See also read_buf()).
       */
      function flush_pending(strm) {
        var s = strm.state;

        //_tr_flush_bits(s);
        var len = s.pending;
        if (len > strm.avail_out) {
          len = strm.avail_out;
        }
        if (len === 0) {
          return;
        }
        utils.arraySet(strm.output, s.pending_buf, s.pending_out, len, strm.next_out);
        strm.next_out += len;
        s.pending_out += len;
        strm.total_out += len;
        strm.avail_out -= len;
        s.pending -= len;
        if (s.pending === 0) {
          s.pending_out = 0;
        }
      }
      function flush_block_only(s, last) {
        trees._tr_flush_block(s, s.block_start >= 0 ? s.block_start : -1, s.strstart - s.block_start, last);
        s.block_start = s.strstart;
        flush_pending(s.strm);
      }
      function put_byte(s, b) {
        s.pending_buf[s.pending++] = b;
      }

      /* =========================================================================
       * Put a short in the pending buffer. The 16-bit value is put in MSB order.
       * IN assertion: the stream state is correct and there is enough room in
       * pending_buf.
       */
      function putShortMSB(s, b) {
        //  put_byte(s, (Byte)(b >> 8));
        //  put_byte(s, (Byte)(b & 0xff));
        s.pending_buf[s.pending++] = b >>> 8 & 0xff;
        s.pending_buf[s.pending++] = b & 0xff;
      }

      /* ===========================================================================
       * Read a new buffer from the current input stream, update the adler32
       * and total number of bytes read.  All deflate() input goes through
       * this function so some applications may wish to modify it to avoid
       * allocating a large strm->input buffer and copying from it.
       * (See also flush_pending()).
       */
      function read_buf(strm, buf, start, size) {
        var len = strm.avail_in;
        if (len > size) {
          len = size;
        }
        if (len === 0) {
          return 0;
        }
        strm.avail_in -= len;

        // zmemcpy(buf, strm->next_in, len);
        utils.arraySet(buf, strm.input, strm.next_in, len, start);
        if (strm.state.wrap === 1) {
          strm.adler = adler32(strm.adler, buf, len, start);
        } else if (strm.state.wrap === 2) {
          strm.adler = crc32(strm.adler, buf, len, start);
        }
        strm.next_in += len;
        strm.total_in += len;
        return len;
      }

      /* ===========================================================================
       * Set match_start to the longest match starting at the given string and
       * return its length. Matches shorter or equal to prev_length are discarded,
       * in which case the result is equal to prev_length and match_start is
       * garbage.
       * IN assertions: cur_match is the head of the hash chain for the current
       *   string (strstart) and its distance is <= MAX_DIST, and prev_length >= 1
       * OUT assertion: the match length is not greater than s->lookahead.
       */
      function longest_match(s, cur_match) {
        var chain_length = s.max_chain_length; /* max hash chain length */
        var scan = s.strstart; /* current string */
        var match; /* matched string */
        var len; /* length of current match */
        var best_len = s.prev_length; /* best match length so far */
        var nice_match = s.nice_match; /* stop if match long enough */
        var limit = s.strstart > s.w_size - MIN_LOOKAHEAD ? s.strstart - (s.w_size - MIN_LOOKAHEAD) : 0 /*NIL*/;
        var _win = s.window; // shortcut

        var wmask = s.w_mask;
        var prev = s.prev;

        /* Stop when cur_match becomes <= limit. To simplify the code,
         * we prevent matches with the string of window index 0.
         */

        var strend = s.strstart + MAX_MATCH;
        var scan_end1 = _win[scan + best_len - 1];
        var scan_end = _win[scan + best_len];

        /* The code is optimized for HASH_BITS >= 8 and MAX_MATCH-2 multiple of 16.
         * It is easy to get rid of this optimization if necessary.
         */
        // Assert(s->hash_bits >= 8 && MAX_MATCH == 258, "Code too clever");

        /* Do not waste too much time if we already have a good match: */
        if (s.prev_length >= s.good_match) {
          chain_length >>= 2;
        }
        /* Do not look for matches beyond the end of the input. This is necessary
         * to make deflate deterministic.
         */
        if (nice_match > s.lookahead) {
          nice_match = s.lookahead;
        }

        // Assert((ulg)s->strstart <= s->window_size-MIN_LOOKAHEAD, "need lookahead");

        do {
          // Assert(cur_match < s->strstart, "no future");
          match = cur_match;

          /* Skip to next match if the match length cannot increase
           * or if the match length is less than 2.  Note that the checks below
           * for insufficient lookahead only occur occasionally for performance
           * reasons.  Therefore uninitialized memory will be accessed, and
           * conditional jumps will be made that depend on those values.
           * However the length of the match is limited to the lookahead, so
           * the output of deflate is not affected by the uninitialized values.
           */

          if (_win[match + best_len] !== scan_end || _win[match + best_len - 1] !== scan_end1 || _win[match] !== _win[scan] || _win[++match] !== _win[scan + 1]) {
            continue;
          }

          /* The check at best_len-1 can be removed because it will be made
           * again later. (This heuristic is not always a win.)
           * It is not necessary to compare scan[2] and match[2] since they
           * are always equal when the other bytes match, given that
           * the hash keys are equal and that HASH_BITS >= 8.
           */
          scan += 2;
          match++;
          // Assert(*scan == *match, "match[2]?");

          /* We check for insufficient lookahead only every 8th comparison;
           * the 256th check will be made at strstart+258.
           */
          do {
            /*jshint noempty:false*/
          } while (_win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && _win[++scan] === _win[++match] && scan < strend);

          // Assert(scan <= s->window+(unsigned)(s->window_size-1), "wild scan");

          len = MAX_MATCH - (strend - scan);
          scan = strend - MAX_MATCH;
          if (len > best_len) {
            s.match_start = cur_match;
            best_len = len;
            if (len >= nice_match) {
              break;
            }
            scan_end1 = _win[scan + best_len - 1];
            scan_end = _win[scan + best_len];
          }
        } while ((cur_match = prev[cur_match & wmask]) > limit && --chain_length !== 0);
        if (best_len <= s.lookahead) {
          return best_len;
        }
        return s.lookahead;
      }

      /* ===========================================================================
       * Fill the window when the lookahead becomes insufficient.
       * Updates strstart and lookahead.
       *
       * IN assertion: lookahead < MIN_LOOKAHEAD
       * OUT assertions: strstart <= window_size-MIN_LOOKAHEAD
       *    At least one byte has been read, or avail_in == 0; reads are
       *    performed for at least two bytes (required for the zip translate_eol
       *    option -- not supported here).
       */
      function fill_window(s) {
        var _w_size = s.w_size;
        var p, n, m, more, str;

        //Assert(s->lookahead < MIN_LOOKAHEAD, "already enough lookahead");

        do {
          more = s.window_size - s.lookahead - s.strstart;

          // JS ints have 32 bit, block below not needed
          /* Deal with !@#$% 64K limit: */
          //if (sizeof(int) <= 2) {
          //    if (more == 0 && s->strstart == 0 && s->lookahead == 0) {
          //        more = wsize;
          //
          //  } else if (more == (unsigned)(-1)) {
          //        /* Very unlikely, but possible on 16 bit machine if
          //         * strstart == 0 && lookahead == 1 (input done a byte at time)
          //         */
          //        more--;
          //    }
          //}

          /* If the window is almost full and there is insufficient lookahead,
           * move the upper half to the lower one to make room in the upper half.
           */
          if (s.strstart >= _w_size + (_w_size - MIN_LOOKAHEAD)) {
            utils.arraySet(s.window, s.window, _w_size, _w_size, 0);
            s.match_start -= _w_size;
            s.strstart -= _w_size;
            /* we now have strstart >= MAX_DIST */
            s.block_start -= _w_size;

            /* Slide the hash table (could be avoided with 32 bit values
             at the expense of memory usage). We slide even when level == 0
             to keep the hash table consistent if we switch back to level > 0
             later. (Using level 0 permanently is not an optimal usage of
             zlib, so we don't care about this pathological case.)
             */

            n = s.hash_size;
            p = n;
            do {
              m = s.head[--p];
              s.head[p] = m >= _w_size ? m - _w_size : 0;
            } while (--n);
            n = _w_size;
            p = n;
            do {
              m = s.prev[--p];
              s.prev[p] = m >= _w_size ? m - _w_size : 0;
              /* If n is not on any hash chain, prev[n] is garbage but
               * its value will never be used.
               */
            } while (--n);
            more += _w_size;
          }
          if (s.strm.avail_in === 0) {
            break;
          }

          /* If there was no sliding:
           *    strstart <= WSIZE+MAX_DIST-1 && lookahead <= MIN_LOOKAHEAD - 1 &&
           *    more == window_size - lookahead - strstart
           * => more >= window_size - (MIN_LOOKAHEAD-1 + WSIZE + MAX_DIST-1)
           * => more >= window_size - 2*WSIZE + 2
           * In the BIG_MEM or MMAP case (not yet supported),
           *   window_size == input_size + MIN_LOOKAHEAD  &&
           *   strstart + s->lookahead <= input_size => more >= MIN_LOOKAHEAD.
           * Otherwise, window_size == 2*WSIZE so more >= 2.
           * If there was sliding, more >= WSIZE. So in all cases, more >= 2.
           */
          //Assert(more >= 2, "more < 2");
          n = read_buf(s.strm, s.window, s.strstart + s.lookahead, more);
          s.lookahead += n;

          /* Initialize the hash value now that we have some input: */
          if (s.lookahead + s.insert >= MIN_MATCH) {
            str = s.strstart - s.insert;
            s.ins_h = s.window[str];

            /* UPDATE_HASH(s, s->ins_h, s->window[str + 1]); */
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + 1]) & s.hash_mask;
            //#if MIN_MATCH != 3
            //        Call update_hash() MIN_MATCH-3 more times
            //#endif
            while (s.insert) {
              /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
              s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
              s.prev[str & s.w_mask] = s.head[s.ins_h];
              s.head[s.ins_h] = str;
              str++;
              s.insert--;
              if (s.lookahead + s.insert < MIN_MATCH) {
                break;
              }
            }
          }
          /* If the whole input has less than MIN_MATCH bytes, ins_h is garbage,
           * but this is not important since only literal bytes will be emitted.
           */
        } while (s.lookahead < MIN_LOOKAHEAD && s.strm.avail_in !== 0);

        /* If the WIN_INIT bytes after the end of the current data have never been
         * written, then zero those bytes in order to avoid memory check reports of
         * the use of uninitialized (or uninitialised as Julian writes) bytes by
         * the longest match routines.  Update the high water mark for the next
         * time through here.  WIN_INIT is set to MAX_MATCH since the longest match
         * routines allow scanning to strstart + MAX_MATCH, ignoring lookahead.
         */
        //  if (s.high_water < s.window_size) {
        //    var curr = s.strstart + s.lookahead;
        //    var init = 0;
        //
        //    if (s.high_water < curr) {
        //      /* Previous high water mark below current data -- zero WIN_INIT
        //       * bytes or up to end of window, whichever is less.
        //       */
        //      init = s.window_size - curr;
        //      if (init > WIN_INIT)
        //        init = WIN_INIT;
        //      zmemzero(s->window + curr, (unsigned)init);
        //      s->high_water = curr + init;
        //    }
        //    else if (s->high_water < (ulg)curr + WIN_INIT) {
        //      /* High water mark at or above current data, but below current data
        //       * plus WIN_INIT -- zero out to current data plus WIN_INIT, or up
        //       * to end of window, whichever is less.
        //       */
        //      init = (ulg)curr + WIN_INIT - s->high_water;
        //      if (init > s->window_size - s->high_water)
        //        init = s->window_size - s->high_water;
        //      zmemzero(s->window + s->high_water, (unsigned)init);
        //      s->high_water += init;
        //    }
        //  }
        //
        //  Assert((ulg)s->strstart <= s->window_size - MIN_LOOKAHEAD,
        //    "not enough room for search");
      }

      /* ===========================================================================
       * Copy without compression as much as possible from the input stream, return
       * the current block state.
       * This function does not insert new strings in the dictionary since
       * uncompressible data is probably not useful. This function is used
       * only for the level=0 compression option.
       * NOTE: this function should be optimized to avoid extra copying from
       * window to pending_buf.
       */
      function deflate_stored(s, flush) {
        /* Stored blocks are limited to 0xffff bytes, pending_buf is limited
         * to pending_buf_size, and each stored block has a 5 byte header:
         */
        var max_block_size = 0xffff;
        if (max_block_size > s.pending_buf_size - 5) {
          max_block_size = s.pending_buf_size - 5;
        }

        /* Copy as much as possible from input to output: */
        for (;;) {
          /* Fill the window as much as possible: */
          if (s.lookahead <= 1) {
            //Assert(s->strstart < s->w_size+MAX_DIST(s) ||
            //  s->block_start >= (long)s->w_size, "slide too late");
            //      if (!(s.strstart < s.w_size + (s.w_size - MIN_LOOKAHEAD) ||
            //        s.block_start >= s.w_size)) {
            //        throw  new Error("slide too late");
            //      }

            fill_window(s);
            if (s.lookahead === 0 && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s.lookahead === 0) {
              break;
            }
            /* flush the current block */
          }
          //Assert(s->block_start >= 0L, "block gone");
          //    if (s.block_start < 0) throw new Error("block gone");

          s.strstart += s.lookahead;
          s.lookahead = 0;

          /* Emit a stored block if pending_buf will be full: */
          var max_start = s.block_start + max_block_size;
          if (s.strstart === 0 || s.strstart >= max_start) {
            /* strstart == 0 is possible when wraparound on 16-bit machine */
            s.lookahead = s.strstart - max_start;
            s.strstart = max_start;
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
          /* Flush if we may have to slide, otherwise block_start may become
           * negative and the data will be gone:
           */
          if (s.strstart - s.block_start >= s.w_size - MIN_LOOKAHEAD) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
        }
        s.insert = 0;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.strstart > s.block_start) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }
        return BS_NEED_MORE;
      }

      /* ===========================================================================
       * Compress as much as possible from the input stream, return the current
       * block state.
       * This function does not perform lazy evaluation of matches and inserts
       * new strings in the dictionary only for unmatched strings or for short
       * matches. It is used only for the fast compression options.
       */
      function deflate_fast(s, flush) {
        var hash_head; /* head of the hash chain */
        var bflush; /* set if current block must be flushed */

        for (;;) {
          /* Make sure that we always have enough lookahead, except
           * at the end of the input file. We need MAX_MATCH bytes
           * for the next match, plus MIN_MATCH bytes to insert the
           * string following the next match.
           */
          if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s.lookahead === 0) {
              break; /* flush the current block */
            }
          }

          /* Insert the string window[strstart .. strstart+2] in the
           * dictionary, and set hash_head to the head of the hash chain:
           */
          hash_head = 0 /*NIL*/;
          if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
            /***/
          }

          /* Find the longest match, discarding those <= prev_length.
           * At this point we have always match_length < MIN_MATCH
           */
          if (hash_head !== 0 /*NIL*/ && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD) {
            /* To simplify the code, we prevent matches with the string
             * of window index 0 (in particular we have to avoid a match
             * of the string with itself at the start of the input file).
             */
            s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */
          }
          if (s.match_length >= MIN_MATCH) {
            // check_match(s, s.strstart, s.match_start, s.match_length); // for debug only

            /*** _tr_tally_dist(s, s.strstart - s.match_start,
                           s.match_length - MIN_MATCH, bflush); ***/
            bflush = trees._tr_tally(s, s.strstart - s.match_start, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;

            /* Insert new strings in the hash table only if the match length
             * is not too large. This saves time but degrades compression.
             */
            if (s.match_length <= s.max_lazy_match /*max_insert_length*/ && s.lookahead >= MIN_MATCH) {
              s.match_length--; /* string at strstart already in table */
              do {
                s.strstart++;
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
                /***/
                /* strstart never exceeds WSIZE-MAX_MATCH, so there are
                 * always MIN_MATCH bytes ahead.
                 */
              } while (--s.match_length !== 0);
              s.strstart++;
            } else {
              s.strstart += s.match_length;
              s.match_length = 0;
              s.ins_h = s.window[s.strstart];
              /* UPDATE_HASH(s, s.ins_h, s.window[s.strstart+1]); */
              s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + 1]) & s.hash_mask;

              //#if MIN_MATCH != 3
              //                Call UPDATE_HASH() MIN_MATCH-3 more times
              //#endif
              /* If lookahead < MIN_MATCH, ins_h is garbage, but it does not
               * matter since it will be recomputed at next deflate call.
               */
            }
          } else {
            /* No match, output a literal byte */
            //Tracevv((stderr,"%c", s.window[s.strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
            bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
          }
          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
        }
        s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }
        return BS_BLOCK_DONE;
      }

      /* ===========================================================================
       * Same as above, but achieves better compression. We use a lazy
       * evaluation for matches: a match is finally adopted only if there is
       * no better match at the next window position.
       */
      function deflate_slow(s, flush) {
        var hash_head; /* head of hash chain */
        var bflush; /* set if current block must be flushed */

        var max_insert;

        /* Process the input block. */
        for (;;) {
          /* Make sure that we always have enough lookahead, except
           * at the end of the input file. We need MAX_MATCH bytes
           * for the next match, plus MIN_MATCH bytes to insert the
           * string following the next match.
           */
          if (s.lookahead < MIN_LOOKAHEAD) {
            fill_window(s);
            if (s.lookahead < MIN_LOOKAHEAD && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s.lookahead === 0) {
              break;
            } /* flush the current block */
          }

          /* Insert the string window[strstart .. strstart+2] in the
           * dictionary, and set hash_head to the head of the hash chain:
           */
          hash_head = 0 /*NIL*/;
          if (s.lookahead >= MIN_MATCH) {
            /*** INSERT_STRING(s, s.strstart, hash_head); ***/
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
            hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = s.strstart;
            /***/
          }

          /* Find the longest match, discarding those <= prev_length.
           */
          s.prev_length = s.match_length;
          s.prev_match = s.match_start;
          s.match_length = MIN_MATCH - 1;
          if (hash_head !== 0 /*NIL*/ && s.prev_length < s.max_lazy_match && s.strstart - hash_head <= s.w_size - MIN_LOOKAHEAD /*MAX_DIST(s)*/) {
            /* To simplify the code, we prevent matches with the string
             * of window index 0 (in particular we have to avoid a match
             * of the string with itself at the start of the input file).
             */
            s.match_length = longest_match(s, hash_head);
            /* longest_match() sets match_start */

            if (s.match_length <= 5 && (s.strategy === Z_FILTERED || s.match_length === MIN_MATCH && s.strstart - s.match_start > 4096 /*TOO_FAR*/)) {
              /* If prev_match is also MIN_MATCH, match_start is garbage
               * but we will ignore the current match anyway.
               */
              s.match_length = MIN_MATCH - 1;
            }
          }
          /* If there was a match at the previous step and the current
           * match is not better, output the previous match:
           */
          if (s.prev_length >= MIN_MATCH && s.match_length <= s.prev_length) {
            max_insert = s.strstart + s.lookahead - MIN_MATCH;
            /* Do not insert strings in hash table beyond this. */

            //check_match(s, s.strstart-1, s.prev_match, s.prev_length);

            /***_tr_tally_dist(s, s.strstart - 1 - s.prev_match,
                           s.prev_length - MIN_MATCH, bflush);***/
            bflush = trees._tr_tally(s, s.strstart - 1 - s.prev_match, s.prev_length - MIN_MATCH);
            /* Insert in hash table all strings up to the end of the match.
             * strstart-1 and strstart are already inserted. If there is not
             * enough lookahead, the last two strings are not inserted in
             * the hash table.
             */
            s.lookahead -= s.prev_length - 1;
            s.prev_length -= 2;
            do {
              if (++s.strstart <= max_insert) {
                /*** INSERT_STRING(s, s.strstart, hash_head); ***/
                s.ins_h = (s.ins_h << s.hash_shift ^ s.window[s.strstart + MIN_MATCH - 1]) & s.hash_mask;
                hash_head = s.prev[s.strstart & s.w_mask] = s.head[s.ins_h];
                s.head[s.ins_h] = s.strstart;
                /***/
              }
            } while (--s.prev_length !== 0);
            s.match_available = 0;
            s.match_length = MIN_MATCH - 1;
            s.strstart++;
            if (bflush) {
              /*** FLUSH_BLOCK(s, 0); ***/
              flush_block_only(s, false);
              if (s.strm.avail_out === 0) {
                return BS_NEED_MORE;
              }
              /***/
            }
          } else if (s.match_available) {
            /* If there was no match at the previous position, output a
             * single literal. If there was a match but the current match
             * is longer, truncate the previous match to a single literal.
             */
            //Tracevv((stderr,"%c", s->window[s->strstart-1]));
            /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
            bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
            if (bflush) {
              /*** FLUSH_BLOCK_ONLY(s, 0) ***/
              flush_block_only(s, false);
              /***/
            }
            s.strstart++;
            s.lookahead--;
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
          } else {
            /* There is no previous match to compare with, wait for
             * the next step to decide.
             */
            s.match_available = 1;
            s.strstart++;
            s.lookahead--;
          }
        }
        //Assert (flush != Z_NO_FLUSH, "no flush?");
        if (s.match_available) {
          //Tracevv((stderr,"%c", s->window[s->strstart-1]));
          /*** _tr_tally_lit(s, s.window[s.strstart-1], bflush); ***/
          bflush = trees._tr_tally(s, 0, s.window[s.strstart - 1]);
          s.match_available = 0;
        }
        s.insert = s.strstart < MIN_MATCH - 1 ? s.strstart : MIN_MATCH - 1;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }
        return BS_BLOCK_DONE;
      }

      /* ===========================================================================
       * For Z_RLE, simply look for runs of bytes, generate matches only of distance
       * one.  Do not maintain a hash table.  (It will be regenerated if this run of
       * deflate switches away from Z_RLE.)
       */
      function deflate_rle(s, flush) {
        var bflush; /* set if current block must be flushed */
        var prev; /* byte at distance one to match */
        var scan, strend; /* scan goes up to strend for length of run */

        var _win = s.window;
        for (;;) {
          /* Make sure that we always have enough lookahead, except
           * at the end of the input file. We need MAX_MATCH bytes
           * for the longest run, plus one for the unrolled loop.
           */
          if (s.lookahead <= MAX_MATCH) {
            fill_window(s);
            if (s.lookahead <= MAX_MATCH && flush === Z_NO_FLUSH) {
              return BS_NEED_MORE;
            }
            if (s.lookahead === 0) {
              break;
            } /* flush the current block */
          }

          /* See how many times the previous byte repeats */
          s.match_length = 0;
          if (s.lookahead >= MIN_MATCH && s.strstart > 0) {
            scan = s.strstart - 1;
            prev = _win[scan];
            if (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan]) {
              strend = s.strstart + MAX_MATCH;
              do {
                /*jshint noempty:false*/
              } while (prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && prev === _win[++scan] && scan < strend);
              s.match_length = MAX_MATCH - (strend - scan);
              if (s.match_length > s.lookahead) {
                s.match_length = s.lookahead;
              }
            }
            //Assert(scan <= s->window+(uInt)(s->window_size-1), "wild scan");
          }

          /* Emit match if have run of MIN_MATCH or longer, else emit literal */
          if (s.match_length >= MIN_MATCH) {
            //check_match(s, s.strstart, s.strstart - 1, s.match_length);

            /*** _tr_tally_dist(s, 1, s.match_length - MIN_MATCH, bflush); ***/
            bflush = trees._tr_tally(s, 1, s.match_length - MIN_MATCH);
            s.lookahead -= s.match_length;
            s.strstart += s.match_length;
            s.match_length = 0;
          } else {
            /* No match, output a literal byte */
            //Tracevv((stderr,"%c", s->window[s->strstart]));
            /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
            bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
            s.lookahead--;
            s.strstart++;
          }
          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
        }
        s.insert = 0;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }
        return BS_BLOCK_DONE;
      }

      /* ===========================================================================
       * For Z_HUFFMAN_ONLY, do not look for matches.  Do not maintain a hash table.
       * (It will be regenerated if this run of deflate switches away from Huffman.)
       */
      function deflate_huff(s, flush) {
        var bflush; /* set if current block must be flushed */

        for (;;) {
          /* Make sure that we have a literal to write. */
          if (s.lookahead === 0) {
            fill_window(s);
            if (s.lookahead === 0) {
              if (flush === Z_NO_FLUSH) {
                return BS_NEED_MORE;
              }
              break; /* flush the current block */
            }
          }

          /* Output a literal byte */
          s.match_length = 0;
          //Tracevv((stderr,"%c", s->window[s->strstart]));
          /*** _tr_tally_lit(s, s.window[s.strstart], bflush); ***/
          bflush = trees._tr_tally(s, 0, s.window[s.strstart]);
          s.lookahead--;
          s.strstart++;
          if (bflush) {
            /*** FLUSH_BLOCK(s, 0); ***/
            flush_block_only(s, false);
            if (s.strm.avail_out === 0) {
              return BS_NEED_MORE;
            }
            /***/
          }
        }
        s.insert = 0;
        if (flush === Z_FINISH) {
          /*** FLUSH_BLOCK(s, 1); ***/
          flush_block_only(s, true);
          if (s.strm.avail_out === 0) {
            return BS_FINISH_STARTED;
          }
          /***/
          return BS_FINISH_DONE;
        }
        if (s.last_lit) {
          /*** FLUSH_BLOCK(s, 0); ***/
          flush_block_only(s, false);
          if (s.strm.avail_out === 0) {
            return BS_NEED_MORE;
          }
          /***/
        }
        return BS_BLOCK_DONE;
      }

      /* Values for max_lazy_match, good_match and max_chain_length, depending on
       * the desired pack level (0..9). The values given below have been tuned to
       * exclude worst case performance for pathological files. Better values may be
       * found for specific files.
       */
      function Config(good_length, max_lazy, nice_length, max_chain, func) {
        this.good_length = good_length;
        this.max_lazy = max_lazy;
        this.nice_length = nice_length;
        this.max_chain = max_chain;
        this.func = func;
      }
      var configuration_table;
      configuration_table = [/*      good lazy nice chain */
      new Config(0, 0, 0, 0, deflate_stored), /* 0 store only */
      new Config(4, 4, 8, 4, deflate_fast), /* 1 max speed, no lazy matches */
      new Config(4, 5, 16, 8, deflate_fast), /* 2 */
      new Config(4, 6, 32, 32, deflate_fast), /* 3 */

      new Config(4, 4, 16, 16, deflate_slow), /* 4 lazy matches */
      new Config(8, 16, 32, 32, deflate_slow), /* 5 */
      new Config(8, 16, 128, 128, deflate_slow), /* 6 */
      new Config(8, 32, 128, 256, deflate_slow), /* 7 */
      new Config(32, 128, 258, 1024, deflate_slow), /* 8 */
      new Config(32, 258, 258, 4096, deflate_slow) /* 9 max compression */];

      /* ===========================================================================
       * Initialize the "longest match" routines for a new zlib stream
       */
      function lm_init(s) {
        s.window_size = 2 * s.w_size;

        /*** CLEAR_HASH(s); ***/
        zero(s.head); // Fill with NIL (= 0);

        /* Set the default configuration parameters:
         */
        s.max_lazy_match = configuration_table[s.level].max_lazy;
        s.good_match = configuration_table[s.level].good_length;
        s.nice_match = configuration_table[s.level].nice_length;
        s.max_chain_length = configuration_table[s.level].max_chain;
        s.strstart = 0;
        s.block_start = 0;
        s.lookahead = 0;
        s.insert = 0;
        s.match_length = s.prev_length = MIN_MATCH - 1;
        s.match_available = 0;
        s.ins_h = 0;
      }
      function DeflateState() {
        this.strm = null; /* pointer back to this zlib stream */
        this.status = 0; /* as the name implies */
        this.pending_buf = null; /* output still pending */
        this.pending_buf_size = 0; /* size of pending_buf */
        this.pending_out = 0; /* next pending byte to output to the stream */
        this.pending = 0; /* nb of bytes in the pending buffer */
        this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */
        this.gzhead = null; /* gzip header information to write */
        this.gzindex = 0; /* where in extra, name, or comment */
        this.method = Z_DEFLATED; /* can only be DEFLATED */
        this.last_flush = -1; /* value of flush param for previous deflate call */

        this.w_size = 0; /* LZ77 window size (32K by default) */
        this.w_bits = 0; /* log2(w_size)  (8..16) */
        this.w_mask = 0; /* w_size - 1 */

        this.window = null;
        /* Sliding window. Input bytes are read into the second half of the window,
         * and move to the first half later to keep a dictionary of at least wSize
         * bytes. With this organization, matches are limited to a distance of
         * wSize-MAX_MATCH bytes, but this ensures that IO is always
         * performed with a length multiple of the block size.
         */

        this.window_size = 0;
        /* Actual size of window: 2*wSize, except when the user input buffer
         * is directly used as sliding window.
         */

        this.prev = null;
        /* Link to older string with same hash index. To limit the size of this
         * array to 64K, this link is maintained only for the last 32K strings.
         * An index in this array is thus a window index modulo 32K.
         */

        this.head = null; /* Heads of the hash chains or NIL. */

        this.ins_h = 0; /* hash index of string to be inserted */
        this.hash_size = 0; /* number of elements in hash table */
        this.hash_bits = 0; /* log2(hash_size) */
        this.hash_mask = 0; /* hash_size-1 */

        this.hash_shift = 0;
        /* Number of bits by which ins_h must be shifted at each input
         * step. It must be such that after MIN_MATCH steps, the oldest
         * byte no longer takes part in the hash key, that is:
         *   hash_shift * MIN_MATCH >= hash_bits
         */

        this.block_start = 0;
        /* Window position at the beginning of the current output block. Gets
         * negative when the window is moved backwards.
         */

        this.match_length = 0; /* length of best match */
        this.prev_match = 0; /* previous match */
        this.match_available = 0; /* set if previous match exists */
        this.strstart = 0; /* start of string to insert */
        this.match_start = 0; /* start of matching string */
        this.lookahead = 0; /* number of valid bytes ahead in window */

        this.prev_length = 0;
        /* Length of the best match at previous step. Matches not greater than this
         * are discarded. This is used in the lazy match evaluation.
         */

        this.max_chain_length = 0;
        /* To speed up deflation, hash chains are never searched beyond this
         * length.  A higher limit improves compression ratio but degrades the
         * speed.
         */

        this.max_lazy_match = 0;
        /* Attempt to find a better match only when the current match is strictly
         * smaller than this value. This mechanism is used only for compression
         * levels >= 4.
         */
        // That's alias to max_lazy_match, don't use directly
        //this.max_insert_length = 0;
        /* Insert new strings in the hash table only if the match length is not
         * greater than this length. This saves time but degrades compression.
         * max_insert_length is used only for compression levels <= 3.
         */

        this.level = 0; /* compression level (1..9) */
        this.strategy = 0; /* favor or force Huffman coding*/

        this.good_match = 0;
        /* Use a faster search when the previous match is longer than this */

        this.nice_match = 0; /* Stop searching when current match exceeds this */

        /* used by trees.c: */

        /* Didn't use ct_data typedef below to suppress compiler warning */

        // struct ct_data_s dyn_ltree[HEAP_SIZE];   /* literal and length tree */
        // struct ct_data_s dyn_dtree[2*D_CODES+1]; /* distance tree */
        // struct ct_data_s bl_tree[2*BL_CODES+1];  /* Huffman tree for bit lengths */

        // Use flat array of DOUBLE size, with interleaved fata,
        // because JS does not support effective
        this.dyn_ltree = new utils.Buf16(HEAP_SIZE * 2);
        this.dyn_dtree = new utils.Buf16((2 * D_CODES + 1) * 2);
        this.bl_tree = new utils.Buf16((2 * BL_CODES + 1) * 2);
        zero(this.dyn_ltree);
        zero(this.dyn_dtree);
        zero(this.bl_tree);
        this.l_desc = null; /* desc. for literal tree */
        this.d_desc = null; /* desc. for distance tree */
        this.bl_desc = null; /* desc. for bit length tree */

        //ush bl_count[MAX_BITS+1];
        this.bl_count = new utils.Buf16(MAX_BITS + 1);
        /* number of codes at each bit length for an optimal tree */

        //int heap[2*L_CODES+1];      /* heap used to build the Huffman trees */
        this.heap = new utils.Buf16(2 * L_CODES + 1); /* heap used to build the Huffman trees */
        zero(this.heap);
        this.heap_len = 0; /* number of elements in the heap */
        this.heap_max = 0; /* element of largest frequency */
        /* The sons of heap[n] are heap[2*n] and heap[2*n+1]. heap[0] is not used.
         * The same heap array is used to build all trees.
         */

        this.depth = new utils.Buf16(2 * L_CODES + 1); //uch depth[2*L_CODES+1];
        zero(this.depth);
        /* Depth of each subtree used as tie breaker for trees of equal frequency
         */

        this.l_buf = 0; /* buffer index for literals or lengths */

        this.lit_bufsize = 0;
        /* Size of match buffer for literals/lengths.  There are 4 reasons for
         * limiting lit_bufsize to 64K:
         *   - frequencies can be kept in 16 bit counters
         *   - if compression is not successful for the first block, all input
         *     data is still in the window so we can still emit a stored block even
         *     when input comes from standard input.  (This can also be done for
         *     all blocks if lit_bufsize is not greater than 32K.)
         *   - if compression is not successful for a file smaller than 64K, we can
         *     even emit a stored file instead of a stored block (saving 5 bytes).
         *     This is applicable only for zip (not gzip or zlib).
         *   - creating new Huffman trees less frequently may not provide fast
         *     adaptation to changes in the input data statistics. (Take for
         *     example a binary file with poorly compressible code followed by
         *     a highly compressible string table.) Smaller buffer sizes give
         *     fast adaptation but have of course the overhead of transmitting
         *     trees more frequently.
         *   - I can't count above 4
         */

        this.last_lit = 0; /* running index in l_buf */

        this.d_buf = 0;
        /* Buffer index for distances. To simplify the code, d_buf and l_buf have
         * the same number of elements. To use different lengths, an extra flag
         * array would be necessary.
         */

        this.opt_len = 0; /* bit length of current block with optimal trees */
        this.static_len = 0; /* bit length of current block with static trees */
        this.matches = 0; /* number of string matches in current block */
        this.insert = 0; /* bytes at end of window left to insert */

        this.bi_buf = 0;
        /* Output buffer. bits are inserted starting at the bottom (least
         * significant bits).
         */
        this.bi_valid = 0;
        /* Number of valid bits in bi_buf.  All bits above the last valid bit
         * are always zero.
         */

        // Used for window memory init. We safely ignore it for JS. That makes
        // sense only for pointers and memory check tools.
        //this.high_water = 0;
        /* High water mark offset in window for initialized bytes -- bytes above
         * this are set to zero in order to avoid memory check warnings when
         * longest match routines access bytes past the input.  This is then
         * updated to the new high water mark.
         */
      }
      function deflateResetKeep(strm) {
        var s;
        if (!strm || !strm.state) {
          return err(strm, Z_STREAM_ERROR);
        }
        strm.total_in = strm.total_out = 0;
        strm.data_type = Z_UNKNOWN;
        s = strm.state;
        s.pending = 0;
        s.pending_out = 0;
        if (s.wrap < 0) {
          s.wrap = -s.wrap;
          /* was made negative by deflate(..., Z_FINISH); */
        }
        s.status = s.wrap ? INIT_STATE : BUSY_STATE;
        strm.adler = s.wrap === 2 ? 0 // crc32(0, Z_NULL, 0)
        : 1; // adler32(0, Z_NULL, 0)
        s.last_flush = Z_NO_FLUSH;
        trees._tr_init(s);
        return Z_OK;
      }
      function deflateReset(strm) {
        var ret = deflateResetKeep(strm);
        if (ret === Z_OK) {
          lm_init(strm.state);
        }
        return ret;
      }
      function deflateSetHeader(strm, head) {
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        if (strm.state.wrap !== 2) {
          return Z_STREAM_ERROR;
        }
        strm.state.gzhead = head;
        return Z_OK;
      }
      function deflateInit2(strm, level, method, windowBits, memLevel, strategy) {
        if (!strm) {
          // === Z_NULL
          return Z_STREAM_ERROR;
        }
        var wrap = 1;
        if (level === Z_DEFAULT_COMPRESSION) {
          level = 6;
        }
        if (windowBits < 0) {
          /* suppress zlib wrapper */
          wrap = 0;
          windowBits = -windowBits;
        } else if (windowBits > 15) {
          wrap = 2; /* write gzip wrapper instead */
          windowBits -= 16;
        }
        if (memLevel < 1 || memLevel > MAX_MEM_LEVEL || method !== Z_DEFLATED || windowBits < 8 || windowBits > 15 || level < 0 || level > 9 || strategy < 0 || strategy > Z_FIXED) {
          return err(strm, Z_STREAM_ERROR);
        }
        if (windowBits === 8) {
          windowBits = 9;
        }
        /* until 256-byte window bug fixed */

        var s = new DeflateState();
        strm.state = s;
        s.strm = strm;
        s.wrap = wrap;
        s.gzhead = null;
        s.w_bits = windowBits;
        s.w_size = 1 << s.w_bits;
        s.w_mask = s.w_size - 1;
        s.hash_bits = memLevel + 7;
        s.hash_size = 1 << s.hash_bits;
        s.hash_mask = s.hash_size - 1;
        s.hash_shift = ~~((s.hash_bits + MIN_MATCH - 1) / MIN_MATCH);
        s.window = new utils.Buf8(s.w_size * 2);
        s.head = new utils.Buf16(s.hash_size);
        s.prev = new utils.Buf16(s.w_size);

        // Don't need mem init magic for JS.
        //s.high_water = 0;  /* nothing written to s->window yet */

        s.lit_bufsize = 1 << memLevel + 6; /* 16K elements by default */

        s.pending_buf_size = s.lit_bufsize * 4;

        //overlay = (ushf *) ZALLOC(strm, s->lit_bufsize, sizeof(ush)+2);
        //s->pending_buf = (uchf *) overlay;
        s.pending_buf = new utils.Buf8(s.pending_buf_size);

        // It is offset from `s.pending_buf` (size is `s.lit_bufsize * 2`)
        //s->d_buf = overlay + s->lit_bufsize/sizeof(ush);
        s.d_buf = 1 * s.lit_bufsize;

        //s->l_buf = s->pending_buf + (1+sizeof(ush))*s->lit_bufsize;
        s.l_buf = (1 + 2) * s.lit_bufsize;
        s.level = level;
        s.strategy = strategy;
        s.method = method;
        return deflateReset(strm);
      }
      function deflateInit(strm, level) {
        return deflateInit2(strm, level, Z_DEFLATED, MAX_WBITS, DEF_MEM_LEVEL, Z_DEFAULT_STRATEGY);
      }
      function deflate(strm, flush) {
        var old_flush, s;
        var beg, val; // for gzip header write only

        if (!strm || !strm.state || flush > Z_BLOCK || flush < 0) {
          return strm ? err(strm, Z_STREAM_ERROR) : Z_STREAM_ERROR;
        }
        s = strm.state;
        if (!strm.output || !strm.input && strm.avail_in !== 0 || s.status === FINISH_STATE && flush !== Z_FINISH) {
          return err(strm, strm.avail_out === 0 ? Z_BUF_ERROR : Z_STREAM_ERROR);
        }
        s.strm = strm; /* just in case */
        old_flush = s.last_flush;
        s.last_flush = flush;

        /* Write the header */
        if (s.status === INIT_STATE) {
          if (s.wrap === 2) {
            // GZIP header
            strm.adler = 0; //crc32(0L, Z_NULL, 0);
            put_byte(s, 31);
            put_byte(s, 139);
            put_byte(s, 8);
            if (!s.gzhead) {
              // s->gzhead == Z_NULL
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, 0);
              put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
              put_byte(s, OS_CODE);
              s.status = BUSY_STATE;
            } else {
              put_byte(s, (s.gzhead.text ? 1 : 0) + (s.gzhead.hcrc ? 2 : 0) + (!s.gzhead.extra ? 0 : 4) + (!s.gzhead.name ? 0 : 8) + (!s.gzhead.comment ? 0 : 16));
              put_byte(s, s.gzhead.time & 0xff);
              put_byte(s, s.gzhead.time >> 8 & 0xff);
              put_byte(s, s.gzhead.time >> 16 & 0xff);
              put_byte(s, s.gzhead.time >> 24 & 0xff);
              put_byte(s, s.level === 9 ? 2 : s.strategy >= Z_HUFFMAN_ONLY || s.level < 2 ? 4 : 0);
              put_byte(s, s.gzhead.os & 0xff);
              if (s.gzhead.extra && s.gzhead.extra.length) {
                put_byte(s, s.gzhead.extra.length & 0xff);
                put_byte(s, s.gzhead.extra.length >> 8 & 0xff);
              }
              if (s.gzhead.hcrc) {
                strm.adler = crc32(strm.adler, s.pending_buf, s.pending, 0);
              }
              s.gzindex = 0;
              s.status = EXTRA_STATE;
            }
          } else
            // DEFLATE header
            {
              var header = Z_DEFLATED + (s.w_bits - 8 << 4) << 8;
              var level_flags = -1;
              if (s.strategy >= Z_HUFFMAN_ONLY || s.level < 2) {
                level_flags = 0;
              } else if (s.level < 6) {
                level_flags = 1;
              } else if (s.level === 6) {
                level_flags = 2;
              } else {
                level_flags = 3;
              }
              header |= level_flags << 6;
              if (s.strstart !== 0) {
                header |= PRESET_DICT;
              }
              header += 31 - header % 31;
              s.status = BUSY_STATE;
              putShortMSB(s, header);

              /* Save the adler32 of the preset dictionary: */
              if (s.strstart !== 0) {
                putShortMSB(s, strm.adler >>> 16);
                putShortMSB(s, strm.adler & 0xffff);
              }
              strm.adler = 1; // adler32(0L, Z_NULL, 0);
            }
        }

        //#ifdef GZIP
        if (s.status === EXTRA_STATE) {
          if (s.gzhead.extra /* != Z_NULL*/) {
            beg = s.pending; /* start of bytes to update crc */

            while (s.gzindex < (s.gzhead.extra.length & 0xffff)) {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                }
                flush_pending(strm);
                beg = s.pending;
                if (s.pending === s.pending_buf_size) {
                  break;
                }
              }
              put_byte(s, s.gzhead.extra[s.gzindex] & 0xff);
              s.gzindex++;
            }
            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            }
            if (s.gzindex === s.gzhead.extra.length) {
              s.gzindex = 0;
              s.status = NAME_STATE;
            }
          } else {
            s.status = NAME_STATE;
          }
        }
        if (s.status === NAME_STATE) {
          if (s.gzhead.name /* != Z_NULL*/) {
            beg = s.pending; /* start of bytes to update crc */
            //int val;

            do {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                }
                flush_pending(strm);
                beg = s.pending;
                if (s.pending === s.pending_buf_size) {
                  val = 1;
                  break;
                }
              }
              // JS specific: little magic to add zero terminator to end of string
              if (s.gzindex < s.gzhead.name.length) {
                val = s.gzhead.name.charCodeAt(s.gzindex++) & 0xff;
              } else {
                val = 0;
              }
              put_byte(s, val);
            } while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            }
            if (val === 0) {
              s.gzindex = 0;
              s.status = COMMENT_STATE;
            }
          } else {
            s.status = COMMENT_STATE;
          }
        }
        if (s.status === COMMENT_STATE) {
          if (s.gzhead.comment /* != Z_NULL*/) {
            beg = s.pending; /* start of bytes to update crc */
            //int val;

            do {
              if (s.pending === s.pending_buf_size) {
                if (s.gzhead.hcrc && s.pending > beg) {
                  strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
                }
                flush_pending(strm);
                beg = s.pending;
                if (s.pending === s.pending_buf_size) {
                  val = 1;
                  break;
                }
              }
              // JS specific: little magic to add zero terminator to end of string
              if (s.gzindex < s.gzhead.comment.length) {
                val = s.gzhead.comment.charCodeAt(s.gzindex++) & 0xff;
              } else {
                val = 0;
              }
              put_byte(s, val);
            } while (val !== 0);
            if (s.gzhead.hcrc && s.pending > beg) {
              strm.adler = crc32(strm.adler, s.pending_buf, s.pending - beg, beg);
            }
            if (val === 0) {
              s.status = HCRC_STATE;
            }
          } else {
            s.status = HCRC_STATE;
          }
        }
        if (s.status === HCRC_STATE) {
          if (s.gzhead.hcrc) {
            if (s.pending + 2 > s.pending_buf_size) {
              flush_pending(strm);
            }
            if (s.pending + 2 <= s.pending_buf_size) {
              put_byte(s, strm.adler & 0xff);
              put_byte(s, strm.adler >> 8 & 0xff);
              strm.adler = 0; //crc32(0L, Z_NULL, 0);
              s.status = BUSY_STATE;
            }
          } else {
            s.status = BUSY_STATE;
          }
        }
        //#endif

        /* Flush as much pending output as possible */
        if (s.pending !== 0) {
          flush_pending(strm);
          if (strm.avail_out === 0) {
            /* Since avail_out is 0, deflate will be called again with
             * more output space, but possibly with both pending and
             * avail_in equal to zero. There won't be anything to do,
             * but this is not an error situation so make sure we
             * return OK instead of BUF_ERROR at next call of deflate:
             */
            s.last_flush = -1;
            return Z_OK;
          }

          /* Make sure there is something to do and avoid duplicate consecutive
           * flushes. For repeated and useless calls with Z_FINISH, we keep
           * returning Z_STREAM_END instead of Z_BUF_ERROR.
           */
        } else if (strm.avail_in === 0 && rank(flush) <= rank(old_flush) && flush !== Z_FINISH) {
          return err(strm, Z_BUF_ERROR);
        }

        /* User must not provide more input after the first FINISH: */
        if (s.status === FINISH_STATE && strm.avail_in !== 0) {
          return err(strm, Z_BUF_ERROR);
        }

        /* Start a new block or continue the current one.
         */
        if (strm.avail_in !== 0 || s.lookahead !== 0 || flush !== Z_NO_FLUSH && s.status !== FINISH_STATE) {
          var bstate = s.strategy === Z_HUFFMAN_ONLY ? deflate_huff(s, flush) : s.strategy === Z_RLE ? deflate_rle(s, flush) : configuration_table[s.level].func(s, flush);
          if (bstate === BS_FINISH_STARTED || bstate === BS_FINISH_DONE) {
            s.status = FINISH_STATE;
          }
          if (bstate === BS_NEED_MORE || bstate === BS_FINISH_STARTED) {
            if (strm.avail_out === 0) {
              s.last_flush = -1;
              /* avoid BUF_ERROR next call, see above */
            }
            return Z_OK;
            /* If flush != Z_NO_FLUSH && avail_out == 0, the next call
             * of deflate should use the same flush parameter to make sure
             * that the flush is complete. So we don't have to output an
             * empty block here, this will be done at next call. This also
             * ensures that for a very small output buffer, we emit at most
             * one empty block.
             */
          }
          if (bstate === BS_BLOCK_DONE) {
            if (flush === Z_PARTIAL_FLUSH) {
              trees._tr_align(s);
            } else if (flush !== Z_BLOCK) {
              /* FULL_FLUSH or SYNC_FLUSH */

              trees._tr_stored_block(s, 0, 0, false);
              /* For a full flush, this empty block will be recognized
               * as a special marker by inflate_sync().
               */
              if (flush === Z_FULL_FLUSH) {
                /*** CLEAR_HASH(s); ***/ /* forget history */
                zero(s.head); // Fill with NIL (= 0);

                if (s.lookahead === 0) {
                  s.strstart = 0;
                  s.block_start = 0;
                  s.insert = 0;
                }
              }
            }
            flush_pending(strm);
            if (strm.avail_out === 0) {
              s.last_flush = -1; /* avoid BUF_ERROR at next call, see above */
              return Z_OK;
            }
          }
        }
        //Assert(strm->avail_out > 0, "bug2");
        //if (strm.avail_out <= 0) { throw new Error("bug2");}

        if (flush !== Z_FINISH) {
          return Z_OK;
        }
        if (s.wrap <= 0) {
          return Z_STREAM_END;
        }

        /* Write the trailer */
        if (s.wrap === 2) {
          put_byte(s, strm.adler & 0xff);
          put_byte(s, strm.adler >> 8 & 0xff);
          put_byte(s, strm.adler >> 16 & 0xff);
          put_byte(s, strm.adler >> 24 & 0xff);
          put_byte(s, strm.total_in & 0xff);
          put_byte(s, strm.total_in >> 8 & 0xff);
          put_byte(s, strm.total_in >> 16 & 0xff);
          put_byte(s, strm.total_in >> 24 & 0xff);
        } else {
          putShortMSB(s, strm.adler >>> 16);
          putShortMSB(s, strm.adler & 0xffff);
        }
        flush_pending(strm);
        /* If avail_out is zero, the application will call deflate again
         * to flush the rest.
         */
        if (s.wrap > 0) {
          s.wrap = -s.wrap;
        }
        /* write the trailer only once! */
        return s.pending !== 0 ? Z_OK : Z_STREAM_END;
      }
      function deflateEnd(strm) {
        var status;
        if (!strm /*== Z_NULL*/ || !strm.state /*== Z_NULL*/) {
          return Z_STREAM_ERROR;
        }
        status = strm.state.status;
        if (status !== INIT_STATE && status !== EXTRA_STATE && status !== NAME_STATE && status !== COMMENT_STATE && status !== HCRC_STATE && status !== BUSY_STATE && status !== FINISH_STATE) {
          return err(strm, Z_STREAM_ERROR);
        }
        strm.state = null;
        return status === BUSY_STATE ? err(strm, Z_DATA_ERROR) : Z_OK;
      }

      /* =========================================================================
       * Initializes the compression dictionary from the given byte
       * sequence without producing any compressed output.
       */
      function deflateSetDictionary(strm, dictionary) {
        var dictLength = dictionary.length;
        var s;
        var str, n;
        var wrap;
        var avail;
        var next;
        var input;
        var tmpDict;
        if (!strm /*== Z_NULL*/ || !strm.state /*== Z_NULL*/) {
          return Z_STREAM_ERROR;
        }
        s = strm.state;
        wrap = s.wrap;
        if (wrap === 2 || wrap === 1 && s.status !== INIT_STATE || s.lookahead) {
          return Z_STREAM_ERROR;
        }

        /* when using zlib wrappers, compute Adler-32 for provided dictionary */
        if (wrap === 1) {
          /* adler32(strm->adler, dictionary, dictLength); */
          strm.adler = adler32(strm.adler, dictionary, dictLength, 0);
        }
        s.wrap = 0; /* avoid computing Adler-32 in read_buf */

        /* if dictionary would fill window, just replace the history */
        if (dictLength >= s.w_size) {
          if (wrap === 0) {
            /* already empty otherwise */
            /*** CLEAR_HASH(s); ***/
            zero(s.head); // Fill with NIL (= 0);
            s.strstart = 0;
            s.block_start = 0;
            s.insert = 0;
          }
          /* use the tail */
          // dictionary = dictionary.slice(dictLength - s.w_size);
          tmpDict = new utils.Buf8(s.w_size);
          utils.arraySet(tmpDict, dictionary, dictLength - s.w_size, s.w_size, 0);
          dictionary = tmpDict;
          dictLength = s.w_size;
        }
        /* insert dictionary into window and hash */
        avail = strm.avail_in;
        next = strm.next_in;
        input = strm.input;
        strm.avail_in = dictLength;
        strm.next_in = 0;
        strm.input = dictionary;
        fill_window(s);
        while (s.lookahead >= MIN_MATCH) {
          str = s.strstart;
          n = s.lookahead - (MIN_MATCH - 1);
          do {
            /* UPDATE_HASH(s, s->ins_h, s->window[str + MIN_MATCH-1]); */
            s.ins_h = (s.ins_h << s.hash_shift ^ s.window[str + MIN_MATCH - 1]) & s.hash_mask;
            s.prev[str & s.w_mask] = s.head[s.ins_h];
            s.head[s.ins_h] = str;
            str++;
          } while (--n);
          s.strstart = str;
          s.lookahead = MIN_MATCH - 1;
          fill_window(s);
        }
        s.strstart += s.lookahead;
        s.block_start = s.strstart;
        s.insert = s.lookahead;
        s.lookahead = 0;
        s.match_length = s.prev_length = MIN_MATCH - 1;
        s.match_available = 0;
        strm.next_in = next;
        strm.input = input;
        strm.avail_in = avail;
        s.wrap = wrap;
        return Z_OK;
      }
      exports.deflateInit = deflateInit;
      exports.deflateInit2 = deflateInit2;
      exports.deflateReset = deflateReset;
      exports.deflateResetKeep = deflateResetKeep;
      exports.deflateSetHeader = deflateSetHeader;
      exports.deflate = deflate;
      exports.deflateEnd = deflateEnd;
      exports.deflateSetDictionary = deflateSetDictionary;
      exports.deflateInfo = 'pako deflate (from Nodeca project)';

      /* Not implemented
      exports.deflateBound = deflateBound;
      exports.deflateCopy = deflateCopy;
      exports.deflateParams = deflateParams;
      exports.deflatePending = deflatePending;
      exports.deflatePrime = deflatePrime;
      exports.deflateTune = deflateTune;
      */
    }, {
      "../utils/common": 41,
      "./adler32": 43,
      "./crc32": 45,
      "./messages": 51,
      "./trees": 52
    }],
    47: [function (require, module, exports) {
      'use strict';

      // (C) 1995-2013 Jean-loup Gailly and Mark Adler
      // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
      //
      // This software is provided 'as-is', without any express or implied
      // warranty. In no event will the authors be held liable for any damages
      // arising from the use of this software.
      //
      // Permission is granted to anyone to use this software for any purpose,
      // including commercial applications, and to alter it and redistribute it
      // freely, subject to the following restrictions:
      //
      // 1. The origin of this software must not be misrepresented; you must not
      //   claim that you wrote the original software. If you use this software
      //   in a product, an acknowledgment in the product documentation would be
      //   appreciated but is not required.
      // 2. Altered source versions must be plainly marked as such, and must not be
      //   misrepresented as being the original software.
      // 3. This notice may not be removed or altered from any source distribution.
      function GZheader() {
        /* true if compressed data believed to be text */
        this.text = 0;
        /* modification time */
        this.time = 0;
        /* extra flags (not used when writing a gzip file) */
        this.xflags = 0;
        /* operating system */
        this.os = 0;
        /* pointer to extra field or Z_NULL if none */
        this.extra = null;
        /* extra field length (valid if extra != Z_NULL) */
        this.extra_len = 0; // Actually, we don't need it in JS,
        // but leave for few code modifications

        //
        // Setup limits is not necessary because in js we should not preallocate memory
        // for inflate use constant limit in 65536 bytes
        //

        /* space at extra (only when reading header) */
        // this.extra_max  = 0;
        /* pointer to zero-terminated file name or Z_NULL */
        this.name = '';
        /* space at name (only when reading header) */
        // this.name_max   = 0;
        /* pointer to zero-terminated comment or Z_NULL */
        this.comment = '';
        /* space at comment (only when reading header) */
        // this.comm_max   = 0;
        /* true if there was or will be a header crc */
        this.hcrc = 0;
        /* true when done reading gzip header (not used when writing a gzip file) */
        this.done = false;
      }
      module.exports = GZheader;
    }, {}],
    48: [function (require, module, exports) {
      'use strict';

      // (C) 1995-2013 Jean-loup Gailly and Mark Adler
      // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
      //
      // This software is provided 'as-is', without any express or implied
      // warranty. In no event will the authors be held liable for any damages
      // arising from the use of this software.
      //
      // Permission is granted to anyone to use this software for any purpose,
      // including commercial applications, and to alter it and redistribute it
      // freely, subject to the following restrictions:
      //
      // 1. The origin of this software must not be misrepresented; you must not
      //   claim that you wrote the original software. If you use this software
      //   in a product, an acknowledgment in the product documentation would be
      //   appreciated but is not required.
      // 2. Altered source versions must be plainly marked as such, and must not be
      //   misrepresented as being the original software.
      // 3. This notice may not be removed or altered from any source distribution.

      // See state defs from inflate.js
      var BAD = 30; /* got a data error -- remain here until reset */
      var TYPE = 12; /* i: waiting for type bits, including last-flag bit */

      /*
         Decode literal, length, and distance codes and write out the resulting
         literal and match bytes until either not enough input or output is
         available, an end-of-block is encountered, or a data error is encountered.
         When large enough input and output buffers are supplied to inflate(), for
         example, a 16K input buffer and a 64K output buffer, more than 95% of the
         inflate execution time is spent in this routine.
      
         Entry assumptions:
      
              state.mode === LEN
              strm.avail_in >= 6
              strm.avail_out >= 258
              start >= strm.avail_out
              state.bits < 8
      
         On return, state.mode is one of:
      
              LEN -- ran out of enough output space or enough available input
              TYPE -- reached end of block code, inflate() to interpret next block
              BAD -- error in block data
      
         Notes:
      
          - The maximum input bits used by a length/distance pair is 15 bits for the
            length code, 5 bits for the length extra, 15 bits for the distance code,
            and 13 bits for the distance extra.  This totals 48 bits, or six bytes.
            Therefore if strm.avail_in >= 6, then there is enough input to avoid
            checking for available input while decoding.
      
          - The maximum bytes that a single length/distance pair can output is 258
            bytes, which is the maximum length that can be coded.  inflate_fast()
            requires strm.avail_out >= 258 for each loop to avoid checking for
            output space.
       */
      module.exports = function inflate_fast(strm, start) {
        var state;
        var _in; /* local strm.input */
        var last; /* have enough input while in < last */
        var _out; /* local strm.output */
        var beg; /* inflate()'s initial strm.output */
        var end; /* while out < end, enough space available */
        //#ifdef INFLATE_STRICT
        var dmax; /* maximum distance from zlib header */
        //#endif
        var wsize; /* window size or zero if not using window */
        var whave; /* valid bytes in the window */
        var wnext; /* window write index */
        // Use `s_window` instead `window`, avoid conflict with instrumentation tools
        var s_window; /* allocated sliding window, if wsize != 0 */
        var hold; /* local strm.hold */
        var bits; /* local strm.bits */
        var lcode; /* local strm.lencode */
        var dcode; /* local strm.distcode */
        var lmask; /* mask for first level of length codes */
        var dmask; /* mask for first level of distance codes */
        var here; /* retrieved table entry */
        var op; /* code bits, operation, extra bits, or */
        /*  window position, window bytes to copy */
        var len; /* match length, unused bytes */
        var dist; /* match distance */
        var from; /* where to copy match from */
        var from_source;
        var input, output; // JS specific, because we have no pointers

        /* copy state to local variables */
        state = strm.state;
        //here = state.here;
        _in = strm.next_in;
        input = strm.input;
        last = _in + (strm.avail_in - 5);
        _out = strm.next_out;
        output = strm.output;
        beg = _out - (start - strm.avail_out);
        end = _out + (strm.avail_out - 257);
        //#ifdef INFLATE_STRICT
        dmax = state.dmax;
        //#endif
        wsize = state.wsize;
        whave = state.whave;
        wnext = state.wnext;
        s_window = state.window;
        hold = state.hold;
        bits = state.bits;
        lcode = state.lencode;
        dcode = state.distcode;
        lmask = (1 << state.lenbits) - 1;
        dmask = (1 << state.distbits) - 1;

        /* decode literals and length/distances until end-of-block or not enough
           input data or output space */

        top: do {
          if (bits < 15) {
            hold += input[_in++] << bits;
            bits += 8;
            hold += input[_in++] << bits;
            bits += 8;
          }
          here = lcode[hold & lmask];
          dolen: for (;;) {
            // Goto emulation
            op = here >>> 24 /*here.bits*/;
            hold >>>= op;
            bits -= op;
            op = here >>> 16 & 0xff /*here.op*/;
            if (op === 0) {
              /* literal */
              //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
              //        "inflate:         literal '%c'\n" :
              //        "inflate:         literal 0x%02x\n", here.val));
              output[_out++] = here & 0xffff /*here.val*/;
            } else if (op & 16) {
              /* length base */
              len = here & 0xffff /*here.val*/;
              op &= 15; /* number of extra bits */
              if (op) {
                if (bits < op) {
                  hold += input[_in++] << bits;
                  bits += 8;
                }
                len += hold & (1 << op) - 1;
                hold >>>= op;
                bits -= op;
              }
              //Tracevv((stderr, "inflate:         length %u\n", len));
              if (bits < 15) {
                hold += input[_in++] << bits;
                bits += 8;
                hold += input[_in++] << bits;
                bits += 8;
              }
              here = dcode[hold & dmask];
              dodist: for (;;) {
                // goto emulation
                op = here >>> 24 /*here.bits*/;
                hold >>>= op;
                bits -= op;
                op = here >>> 16 & 0xff /*here.op*/;
                if (op & 16) {
                  /* distance base */
                  dist = here & 0xffff /*here.val*/;
                  op &= 15; /* number of extra bits */
                  if (bits < op) {
                    hold += input[_in++] << bits;
                    bits += 8;
                    if (bits < op) {
                      hold += input[_in++] << bits;
                      bits += 8;
                    }
                  }
                  dist += hold & (1 << op) - 1;
                  //#ifdef INFLATE_STRICT
                  if (dist > dmax) {
                    strm.msg = 'invalid distance too far back';
                    state.mode = BAD;
                    break top;
                  }
                  //#endif
                  hold >>>= op;
                  bits -= op;
                  //Tracevv((stderr, "inflate:         distance %u\n", dist));
                  op = _out - beg; /* max distance in output */
                  if (dist > op) {
                    /* see if copy from window */
                    op = dist - op; /* distance back in window */
                    if (op > whave) {
                      if (state.sane) {
                        strm.msg = 'invalid distance too far back';
                        state.mode = BAD;
                        break top;
                      }

                      // (!) This block is disabled in zlib defailts,
                      // don't enable it for binary compatibility
                      //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                      //                if (len <= op - whave) {
                      //                  do {
                      //                    output[_out++] = 0;
                      //                  } while (--len);
                      //                  continue top;
                      //                }
                      //                len -= op - whave;
                      //                do {
                      //                  output[_out++] = 0;
                      //                } while (--op > whave);
                      //                if (op === 0) {
                      //                  from = _out - dist;
                      //                  do {
                      //                    output[_out++] = output[from++];
                      //                  } while (--len);
                      //                  continue top;
                      //                }
                      //#endif
                    }
                    from = 0; // window index
                    from_source = s_window;
                    if (wnext === 0) {
                      /* very common case */
                      from += wsize - op;
                      if (op < len) {
                        /* some from window */
                        len -= op;
                        do {
                          output[_out++] = s_window[from++];
                        } while (--op);
                        from = _out - dist; /* rest from output */
                        from_source = output;
                      }
                    } else if (wnext < op) {
                      /* wrap around window */
                      from += wsize + wnext - op;
                      op -= wnext;
                      if (op < len) {
                        /* some from end of window */
                        len -= op;
                        do {
                          output[_out++] = s_window[from++];
                        } while (--op);
                        from = 0;
                        if (wnext < len) {
                          /* some from start of window */
                          op = wnext;
                          len -= op;
                          do {
                            output[_out++] = s_window[from++];
                          } while (--op);
                          from = _out - dist; /* rest from output */
                          from_source = output;
                        }
                      }
                    } else {
                      /* contiguous in window */
                      from += wnext - op;
                      if (op < len) {
                        /* some from window */
                        len -= op;
                        do {
                          output[_out++] = s_window[from++];
                        } while (--op);
                        from = _out - dist; /* rest from output */
                        from_source = output;
                      }
                    }
                    while (len > 2) {
                      output[_out++] = from_source[from++];
                      output[_out++] = from_source[from++];
                      output[_out++] = from_source[from++];
                      len -= 3;
                    }
                    if (len) {
                      output[_out++] = from_source[from++];
                      if (len > 1) {
                        output[_out++] = from_source[from++];
                      }
                    }
                  } else {
                    from = _out - dist; /* copy direct from output */
                    do {
                      /* minimum length is three */
                      output[_out++] = output[from++];
                      output[_out++] = output[from++];
                      output[_out++] = output[from++];
                      len -= 3;
                    } while (len > 2);
                    if (len) {
                      output[_out++] = output[from++];
                      if (len > 1) {
                        output[_out++] = output[from++];
                      }
                    }
                  }
                } else if ((op & 64) === 0) {
                  /* 2nd level distance code */
                  here = dcode[(here & 0xffff /*here.val*/) + (hold & (1 << op) - 1)];
                  continue dodist;
                } else {
                  strm.msg = 'invalid distance code';
                  state.mode = BAD;
                  break top;
                }
                break; // need to emulate goto via "continue"
              }
            } else if ((op & 64) === 0) {
              /* 2nd level length code */
              here = lcode[(here & 0xffff /*here.val*/) + (hold & (1 << op) - 1)];
              continue dolen;
            } else if (op & 32) {
              /* end-of-block */
              //Tracevv((stderr, "inflate:         end of block\n"));
              state.mode = TYPE;
              break top;
            } else {
              strm.msg = 'invalid literal/length code';
              state.mode = BAD;
              break top;
            }
            break; // need to emulate goto via "continue"
          }
        } while (_in < last && _out < end);

        /* return unused bytes (on entry, bits < 8, so in won't go too far back) */
        len = bits >> 3;
        _in -= len;
        bits -= len << 3;
        hold &= (1 << bits) - 1;

        /* update state and return */
        strm.next_in = _in;
        strm.next_out = _out;
        strm.avail_in = _in < last ? 5 + (last - _in) : 5 - (_in - last);
        strm.avail_out = _out < end ? 257 + (end - _out) : 257 - (_out - end);
        state.hold = hold;
        state.bits = bits;
        return;
      };
    }, {}],
    49: [function (require, module, exports) {
      'use strict';

      // (C) 1995-2013 Jean-loup Gailly and Mark Adler
      // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
      //
      // This software is provided 'as-is', without any express or implied
      // warranty. In no event will the authors be held liable for any damages
      // arising from the use of this software.
      //
      // Permission is granted to anyone to use this software for any purpose,
      // including commercial applications, and to alter it and redistribute it
      // freely, subject to the following restrictions:
      //
      // 1. The origin of this software must not be misrepresented; you must not
      //   claim that you wrote the original software. If you use this software
      //   in a product, an acknowledgment in the product documentation would be
      //   appreciated but is not required.
      // 2. Altered source versions must be plainly marked as such, and must not be
      //   misrepresented as being the original software.
      // 3. This notice may not be removed or altered from any source distribution.
      var utils = require('../utils/common');
      var adler32 = require('./adler32');
      var crc32 = require('./crc32');
      var inflate_fast = require('./inffast');
      var inflate_table = require('./inftrees');
      var CODES = 0;
      var LENS = 1;
      var DISTS = 2;

      /* Public constants ==========================================================*/
      /* ===========================================================================*/

      /* Allowed flush values; see deflate() and inflate() below for details */
      //var Z_NO_FLUSH      = 0;
      //var Z_PARTIAL_FLUSH = 1;
      //var Z_SYNC_FLUSH    = 2;
      //var Z_FULL_FLUSH    = 3;
      var Z_FINISH = 4;
      var Z_BLOCK = 5;
      var Z_TREES = 6;

      /* Return codes for the compression/decompression functions. Negative values
       * are errors, positive values are used for special but normal events.
       */
      var Z_OK = 0;
      var Z_STREAM_END = 1;
      var Z_NEED_DICT = 2;
      //var Z_ERRNO         = -1;
      var Z_STREAM_ERROR = -2;
      var Z_DATA_ERROR = -3;
      var Z_MEM_ERROR = -4;
      var Z_BUF_ERROR = -5;
      //var Z_VERSION_ERROR = -6;

      /* The deflate compression method */
      var Z_DEFLATED = 8;

      /* STATES ====================================================================*/
      /* ===========================================================================*/

      var HEAD = 1; /* i: waiting for magic header */
      var FLAGS = 2; /* i: waiting for method and flags (gzip) */
      var TIME = 3; /* i: waiting for modification time (gzip) */
      var OS = 4; /* i: waiting for extra flags and operating system (gzip) */
      var EXLEN = 5; /* i: waiting for extra length (gzip) */
      var EXTRA = 6; /* i: waiting for extra bytes (gzip) */
      var NAME = 7; /* i: waiting for end of file name (gzip) */
      var COMMENT = 8; /* i: waiting for end of comment (gzip) */
      var HCRC = 9; /* i: waiting for header crc (gzip) */
      var DICTID = 10; /* i: waiting for dictionary check value */
      var DICT = 11; /* waiting for inflateSetDictionary() call */
      var TYPE = 12; /* i: waiting for type bits, including last-flag bit */
      var TYPEDO = 13; /* i: same, but skip check to exit inflate on new block */
      var STORED = 14; /* i: waiting for stored size (length and complement) */
      var COPY_ = 15; /* i/o: same as COPY below, but only first time in */
      var COPY = 16; /* i/o: waiting for input or output to copy stored block */
      var TABLE = 17; /* i: waiting for dynamic block table lengths */
      var LENLENS = 18; /* i: waiting for code length code lengths */
      var CODELENS = 19; /* i: waiting for length/lit and distance code lengths */
      var LEN_ = 20; /* i: same as LEN below, but only first time in */
      var LEN = 21; /* i: waiting for length/lit/eob code */
      var LENEXT = 22; /* i: waiting for length extra bits */
      var DIST = 23; /* i: waiting for distance code */
      var DISTEXT = 24; /* i: waiting for distance extra bits */
      var MATCH = 25; /* o: waiting for output space to copy string */
      var LIT = 26; /* o: waiting for output space to write literal */
      var CHECK = 27; /* i: waiting for 32-bit check value */
      var LENGTH = 28; /* i: waiting for 32-bit length (gzip) */
      var DONE = 29; /* finished check, done -- remain here until reset */
      var BAD = 30; /* got a data error -- remain here until reset */
      var MEM = 31; /* got an inflate() memory error -- remain here until reset */
      var SYNC = 32; /* looking for synchronization bytes to restart inflate() */

      /* ===========================================================================*/

      var ENOUGH_LENS = 852;
      var ENOUGH_DISTS = 592;
      //var ENOUGH =  (ENOUGH_LENS+ENOUGH_DISTS);

      var MAX_WBITS = 15;
      /* 32K LZ77 window */
      var DEF_WBITS = MAX_WBITS;
      function zswap32(q) {
        return (q >>> 24 & 0xff) + (q >>> 8 & 0xff00) + ((q & 0xff00) << 8) + ((q & 0xff) << 24);
      }
      function InflateState() {
        this.mode = 0; /* current inflate mode */
        this.last = false; /* true if processing last block */
        this.wrap = 0; /* bit 0 true for zlib, bit 1 true for gzip */
        this.havedict = false; /* true if dictionary provided */
        this.flags = 0; /* gzip header method and flags (0 if zlib) */
        this.dmax = 0; /* zlib header max distance (INFLATE_STRICT) */
        this.check = 0; /* protected copy of check value */
        this.total = 0; /* protected copy of output count */
        // TODO: may be {}
        this.head = null; /* where to save gzip header information */

        /* sliding window */
        this.wbits = 0; /* log base 2 of requested window size */
        this.wsize = 0; /* window size or zero if not using window */
        this.whave = 0; /* valid bytes in the window */
        this.wnext = 0; /* window write index */
        this.window = null; /* allocated sliding window, if needed */

        /* bit accumulator */
        this.hold = 0; /* input bit accumulator */
        this.bits = 0; /* number of bits in "in" */

        /* for string and stored block copying */
        this.length = 0; /* literal or length of data to copy */
        this.offset = 0; /* distance back to copy string from */

        /* for table and code decoding */
        this.extra = 0; /* extra bits needed */

        /* fixed and dynamic code tables */
        this.lencode = null; /* starting table for length/literal codes */
        this.distcode = null; /* starting table for distance codes */
        this.lenbits = 0; /* index bits for lencode */
        this.distbits = 0; /* index bits for distcode */

        /* dynamic table building */
        this.ncode = 0; /* number of code length code lengths */
        this.nlen = 0; /* number of length code lengths */
        this.ndist = 0; /* number of distance code lengths */
        this.have = 0; /* number of code lengths in lens[] */
        this.next = null; /* next available space in codes[] */

        this.lens = new utils.Buf16(320); /* temporary storage for code lengths */
        this.work = new utils.Buf16(288); /* work area for code table building */

        /*
         because we don't have pointers in js, we use lencode and distcode directly
         as buffers so we don't need codes
        */
        //this.codes = new utils.Buf32(ENOUGH);       /* space for code tables */
        this.lendyn = null; /* dynamic table for length/literal codes (JS specific) */
        this.distdyn = null; /* dynamic table for distance codes (JS specific) */
        this.sane = 0; /* if false, allow invalid distance too far */
        this.back = 0; /* bits back of last unprocessed length/lit */
        this.was = 0; /* initial length of match */
      }
      function inflateResetKeep(strm) {
        var state;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        strm.total_in = strm.total_out = state.total = 0;
        strm.msg = ''; /*Z_NULL*/
        if (state.wrap) {
          /* to support ill-conceived Java test suite */
          strm.adler = state.wrap & 1;
        }
        state.mode = HEAD;
        state.last = 0;
        state.havedict = 0;
        state.dmax = 32768;
        state.head = null /*Z_NULL*/;
        state.hold = 0;
        state.bits = 0;
        //state.lencode = state.distcode = state.next = state.codes;
        state.lencode = state.lendyn = new utils.Buf32(ENOUGH_LENS);
        state.distcode = state.distdyn = new utils.Buf32(ENOUGH_DISTS);
        state.sane = 1;
        state.back = -1;
        //Tracev((stderr, "inflate: reset\n"));
        return Z_OK;
      }
      function inflateReset(strm) {
        var state;
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        state.wsize = 0;
        state.whave = 0;
        state.wnext = 0;
        return inflateResetKeep(strm);
      }
      function inflateReset2(strm, windowBits) {
        var wrap;
        var state;

        /* get the state */
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;

        /* extract wrap request from windowBits parameter */
        if (windowBits < 0) {
          wrap = 0;
          windowBits = -windowBits;
        } else {
          wrap = (windowBits >> 4) + 1;
          if (windowBits < 48) {
            windowBits &= 15;
          }
        }

        /* set number of window bits, free window if different */
        if (windowBits && (windowBits < 8 || windowBits > 15)) {
          return Z_STREAM_ERROR;
        }
        if (state.window !== null && state.wbits !== windowBits) {
          state.window = null;
        }

        /* update state and reset the rest of it */
        state.wrap = wrap;
        state.wbits = windowBits;
        return inflateReset(strm);
      }
      function inflateInit2(strm, windowBits) {
        var ret;
        var state;
        if (!strm) {
          return Z_STREAM_ERROR;
        }
        //strm.msg = Z_NULL;                 /* in case we return an error */

        state = new InflateState();

        //if (state === Z_NULL) return Z_MEM_ERROR;
        //Tracev((stderr, "inflate: allocated\n"));
        strm.state = state;
        state.window = null /*Z_NULL*/;
        ret = inflateReset2(strm, windowBits);
        if (ret !== Z_OK) {
          strm.state = null /*Z_NULL*/;
        }
        return ret;
      }
      function inflateInit(strm) {
        return inflateInit2(strm, DEF_WBITS);
      }

      /*
       Return state with length and distance decoding tables and index sizes set to
       fixed code decoding.  Normally this returns fixed tables from inffixed.h.
       If BUILDFIXED is defined, then instead this routine builds the tables the
       first time it's called, and returns those tables the first time and
       thereafter.  This reduces the size of the code by about 2K bytes, in
       exchange for a little execution time.  However, BUILDFIXED should not be
       used for threaded applications, since the rewriting of the tables and virgin
       may not be thread-safe.
       */
      var virgin = true;
      var lenfix, distfix; // We have no pointers in JS, so keep tables separate

      function fixedtables(state) {
        /* build fixed huffman tables if first call (may not be thread safe) */
        if (virgin) {
          var sym;
          lenfix = new utils.Buf32(512);
          distfix = new utils.Buf32(32);

          /* literal/length table */
          sym = 0;
          while (sym < 144) {
            state.lens[sym++] = 8;
          }
          while (sym < 256) {
            state.lens[sym++] = 9;
          }
          while (sym < 280) {
            state.lens[sym++] = 7;
          }
          while (sym < 288) {
            state.lens[sym++] = 8;
          }
          inflate_table(LENS, state.lens, 0, 288, lenfix, 0, state.work, {
            bits: 9
          });

          /* distance table */
          sym = 0;
          while (sym < 32) {
            state.lens[sym++] = 5;
          }
          inflate_table(DISTS, state.lens, 0, 32, distfix, 0, state.work, {
            bits: 5
          });

          /* do this just once */
          virgin = false;
        }
        state.lencode = lenfix;
        state.lenbits = 9;
        state.distcode = distfix;
        state.distbits = 5;
      }

      /*
       Update the window with the last wsize (normally 32K) bytes written before
       returning.  If window does not exist yet, create it.  This is only called
       when a window is already in use, or when output has been written during this
       inflate call, but the end of the deflate stream has not been reached yet.
       It is also called to create a window for dictionary data when a dictionary
       is loaded.
      
       Providing output buffers larger than 32K to inflate() should provide a speed
       advantage, since only the last 32K of output is copied to the sliding window
       upon return from inflate(), and since all distances after the first 32K of
       output will fall in the output data, making match copies simpler and faster.
       The advantage may be dependent on the size of the processor's data caches.
       */
      function updatewindow(strm, src, end, copy) {
        var dist;
        var state = strm.state;

        /* if it hasn't been done already, allocate space for the window */
        if (state.window === null) {
          state.wsize = 1 << state.wbits;
          state.wnext = 0;
          state.whave = 0;
          state.window = new utils.Buf8(state.wsize);
        }

        /* copy state->wsize or less output bytes into the circular window */
        if (copy >= state.wsize) {
          utils.arraySet(state.window, src, end - state.wsize, state.wsize, 0);
          state.wnext = 0;
          state.whave = state.wsize;
        } else {
          dist = state.wsize - state.wnext;
          if (dist > copy) {
            dist = copy;
          }
          //zmemcpy(state->window + state->wnext, end - copy, dist);
          utils.arraySet(state.window, src, end - copy, dist, state.wnext);
          copy -= dist;
          if (copy) {
            //zmemcpy(state->window, end - copy, copy);
            utils.arraySet(state.window, src, end - copy, copy, 0);
            state.wnext = copy;
            state.whave = state.wsize;
          } else {
            state.wnext += dist;
            if (state.wnext === state.wsize) {
              state.wnext = 0;
            }
            if (state.whave < state.wsize) {
              state.whave += dist;
            }
          }
        }
        return 0;
      }
      function inflate(strm, flush) {
        var state;
        var input, output; // input/output buffers
        var next; /* next input INDEX */
        var put; /* next output INDEX */
        var have, left; /* available input and output */
        var hold; /* bit buffer */
        var bits; /* bits in bit buffer */
        var _in, _out; /* save starting available input and output */
        var copy; /* number of stored or match bytes to copy */
        var from; /* where to copy match bytes from */
        var from_source;
        var here = 0; /* current decoding table entry */
        var here_bits, here_op, here_val; // paked "here" denormalized (JS specific)
        //var last;                   /* parent table entry */
        var last_bits, last_op, last_val; // paked "last" denormalized (JS specific)
        var len; /* length to copy for repeats, bits to drop */
        var ret; /* return code */
        var hbuf = new utils.Buf8(4); /* buffer for gzip header crc calculation */
        var opts;
        var n; // temporary var for NEED_BITS

        var order = /* permutation of code lengths */
        [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
        if (!strm || !strm.state || !strm.output || !strm.input && strm.avail_in !== 0) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        if (state.mode === TYPE) {
          state.mode = TYPEDO;
        } /* skip check */

        //--- LOAD() ---
        put = strm.next_out;
        output = strm.output;
        left = strm.avail_out;
        next = strm.next_in;
        input = strm.input;
        have = strm.avail_in;
        hold = state.hold;
        bits = state.bits;
        //---

        _in = have;
        _out = left;
        ret = Z_OK;
        inf_leave:
        // goto emulation
        for (;;) {
          switch (state.mode) {
            case HEAD:
              if (state.wrap === 0) {
                state.mode = TYPEDO;
                break;
              }
              //=== NEEDBITS(16);
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if (state.wrap & 2 && hold === 0x8b1f) {
                /* gzip header */
                state.check = 0 /*crc32(0L, Z_NULL, 0)*/;
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//

                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                state.mode = FLAGS;
                break;
              }
              state.flags = 0; /* expect zlib header */
              if (state.head) {
                state.head.done = false;
              }
              if (!(state.wrap & 1) || /* check if zlib header allowed */
              (((hold & 0xff /*BITS(8)*/) << 8) + (hold >> 8)) % 31) {
                strm.msg = 'incorrect header check';
                state.mode = BAD;
                break;
              }
              if ((hold & 0x0f /*BITS(4)*/) !== Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = BAD;
                break;
              }
              //--- DROPBITS(4) ---//
              hold >>>= 4;
              bits -= 4;
              //---//
              len = (hold & 0x0f /*BITS(4)*/) + 8;
              if (state.wbits === 0) {
                state.wbits = len;
              } else if (len > state.wbits) {
                strm.msg = 'invalid window size';
                state.mode = BAD;
                break;
              }
              state.dmax = 1 << len;
              //Tracev((stderr, "inflate:   zlib header ok\n"));
              strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/;
              state.mode = hold & 0x200 ? DICTID : TYPE;
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              break;
            case FLAGS:
              //=== NEEDBITS(16); */
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.flags = hold;
              if ((state.flags & 0xff) !== Z_DEFLATED) {
                strm.msg = 'unknown compression method';
                state.mode = BAD;
                break;
              }
              if (state.flags & 0xe000) {
                strm.msg = 'unknown header flags set';
                state.mode = BAD;
                break;
              }
              if (state.head) {
                state.head.text = hold >> 8 & 1;
              }
              if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = TIME;
            /* falls through */
            case TIME:
              //=== NEEDBITS(32); */
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if (state.head) {
                state.head.time = hold;
              }
              if (state.flags & 0x0200) {
                //=== CRC4(state.check, hold)
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                hbuf[2] = hold >>> 16 & 0xff;
                hbuf[3] = hold >>> 24 & 0xff;
                state.check = crc32(state.check, hbuf, 4, 0);
                //===
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = OS;
            /* falls through */
            case OS:
              //=== NEEDBITS(16); */
              while (bits < 16) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if (state.head) {
                state.head.xflags = hold & 0xff;
                state.head.os = hold >> 8;
              }
              if (state.flags & 0x0200) {
                //=== CRC2(state.check, hold);
                hbuf[0] = hold & 0xff;
                hbuf[1] = hold >>> 8 & 0xff;
                state.check = crc32(state.check, hbuf, 2, 0);
                //===//
              }
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = EXLEN;
            /* falls through */
            case EXLEN:
              if (state.flags & 0x0400) {
                //=== NEEDBITS(16); */
                while (bits < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                state.length = hold;
                if (state.head) {
                  state.head.extra_len = hold;
                }
                if (state.flags & 0x0200) {
                  //=== CRC2(state.check, hold);
                  hbuf[0] = hold & 0xff;
                  hbuf[1] = hold >>> 8 & 0xff;
                  state.check = crc32(state.check, hbuf, 2, 0);
                  //===//
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
              } else if (state.head) {
                state.head.extra = null /*Z_NULL*/;
              }
              state.mode = EXTRA;
            /* falls through */
            case EXTRA:
              if (state.flags & 0x0400) {
                copy = state.length;
                if (copy > have) {
                  copy = have;
                }
                if (copy) {
                  if (state.head) {
                    len = state.head.extra_len - state.length;
                    if (!state.head.extra) {
                      // Use untyped array for more conveniend processing later
                      state.head.extra = new Array(state.head.extra_len);
                    }
                    utils.arraySet(state.head.extra, input, next,
                    // extra field is limited to 65536 bytes
                    // - no need for additional size check
                    copy, /*len + copy > state.head.extra_max - len ? state.head.extra_max : copy,*/
                    len);
                    //zmemcpy(state.head.extra + len, next,
                    //        len + copy > state.head.extra_max ?
                    //        state.head.extra_max - len : copy);
                  }
                  if (state.flags & 0x0200) {
                    state.check = crc32(state.check, input, copy, next);
                  }
                  have -= copy;
                  next += copy;
                  state.length -= copy;
                }
                if (state.length) {
                  break inf_leave;
                }
              }
              state.length = 0;
              state.mode = NAME;
            /* falls through */
            case NAME:
              if (state.flags & 0x0800) {
                if (have === 0) {
                  break inf_leave;
                }
                copy = 0;
                do {
                  // TODO: 2 or 1 bytes?
                  len = input[next + copy++];
                  /* use constant limit because in js we should not preallocate memory */
                  if (state.head && len && state.length < 65536 /*state.head.name_max*/) {
                    state.head.name += String.fromCharCode(len);
                  }
                } while (len && copy < have);
                if (state.flags & 0x0200) {
                  state.check = crc32(state.check, input, copy, next);
                }
                have -= copy;
                next += copy;
                if (len) {
                  break inf_leave;
                }
              } else if (state.head) {
                state.head.name = null;
              }
              state.length = 0;
              state.mode = COMMENT;
            /* falls through */
            case COMMENT:
              if (state.flags & 0x1000) {
                if (have === 0) {
                  break inf_leave;
                }
                copy = 0;
                do {
                  len = input[next + copy++];
                  /* use constant limit because in js we should not preallocate memory */
                  if (state.head && len && state.length < 65536 /*state.head.comm_max*/) {
                    state.head.comment += String.fromCharCode(len);
                  }
                } while (len && copy < have);
                if (state.flags & 0x0200) {
                  state.check = crc32(state.check, input, copy, next);
                }
                have -= copy;
                next += copy;
                if (len) {
                  break inf_leave;
                }
              } else if (state.head) {
                state.head.comment = null;
              }
              state.mode = HCRC;
            /* falls through */
            case HCRC:
              if (state.flags & 0x0200) {
                //=== NEEDBITS(16); */
                while (bits < 16) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                if (hold !== (state.check & 0xffff)) {
                  strm.msg = 'header crc mismatch';
                  state.mode = BAD;
                  break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
              }
              if (state.head) {
                state.head.hcrc = state.flags >> 9 & 1;
                state.head.done = true;
              }
              strm.adler = state.check = 0;
              state.mode = TYPE;
              break;
            case DICTID:
              //=== NEEDBITS(32); */
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              strm.adler = state.check = zswap32(hold);
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = DICT;
            /* falls through */
            case DICT:
              if (state.havedict === 0) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                return Z_NEED_DICT;
              }
              strm.adler = state.check = 1 /*adler32(0L, Z_NULL, 0)*/;
              state.mode = TYPE;
            /* falls through */
            case TYPE:
              if (flush === Z_BLOCK || flush === Z_TREES) {
                break inf_leave;
              }
            /* falls through */
            case TYPEDO:
              if (state.last) {
                //--- BYTEBITS() ---//
                hold >>>= bits & 7;
                bits -= bits & 7;
                //---//
                state.mode = CHECK;
                break;
              }
              //=== NEEDBITS(3); */
              while (bits < 3) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.last = hold & 0x01 /*BITS(1)*/;
              //--- DROPBITS(1) ---//
              hold >>>= 1;
              bits -= 1;
              //---//

              switch (hold & 0x03 /*BITS(2)*/) {
                case 0:
                  /* stored block */
                  //Tracev((stderr, "inflate:     stored block%s\n",
                  //        state.last ? " (last)" : ""));
                  state.mode = STORED;
                  break;
                case 1:
                  /* fixed block */
                  fixedtables(state);
                  //Tracev((stderr, "inflate:     fixed codes block%s\n",
                  //        state.last ? " (last)" : ""));
                  state.mode = LEN_; /* decode codes */
                  if (flush === Z_TREES) {
                    //--- DROPBITS(2) ---//
                    hold >>>= 2;
                    bits -= 2;
                    //---//
                    break inf_leave;
                  }
                  break;
                case 2:
                  /* dynamic block */
                  //Tracev((stderr, "inflate:     dynamic codes block%s\n",
                  //        state.last ? " (last)" : ""));
                  state.mode = TABLE;
                  break;
                case 3:
                  strm.msg = 'invalid block type';
                  state.mode = BAD;
              }
              //--- DROPBITS(2) ---//
              hold >>>= 2;
              bits -= 2;
              //---//
              break;
            case STORED:
              //--- BYTEBITS() ---// /* go to byte boundary */
              hold >>>= bits & 7;
              bits -= bits & 7;
              //---//
              //=== NEEDBITS(32); */
              while (bits < 32) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              if ((hold & 0xffff) !== (hold >>> 16 ^ 0xffff)) {
                strm.msg = 'invalid stored block lengths';
                state.mode = BAD;
                break;
              }
              state.length = hold & 0xffff;
              //Tracev((stderr, "inflate:       stored length %u\n",
              //        state.length));
              //=== INITBITS();
              hold = 0;
              bits = 0;
              //===//
              state.mode = COPY_;
              if (flush === Z_TREES) {
                break inf_leave;
              }
            /* falls through */
            case COPY_:
              state.mode = COPY;
            /* falls through */
            case COPY:
              copy = state.length;
              if (copy) {
                if (copy > have) {
                  copy = have;
                }
                if (copy > left) {
                  copy = left;
                }
                if (copy === 0) {
                  break inf_leave;
                }
                //--- zmemcpy(put, next, copy); ---
                utils.arraySet(output, input, next, copy, put);
                //---//
                have -= copy;
                next += copy;
                left -= copy;
                put += copy;
                state.length -= copy;
                break;
              }
              //Tracev((stderr, "inflate:       stored end\n"));
              state.mode = TYPE;
              break;
            case TABLE:
              //=== NEEDBITS(14); */
              while (bits < 14) {
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
              }
              //===//
              state.nlen = (hold & 0x1f /*BITS(5)*/) + 257;
              //--- DROPBITS(5) ---//
              hold >>>= 5;
              bits -= 5;
              //---//
              state.ndist = (hold & 0x1f /*BITS(5)*/) + 1;
              //--- DROPBITS(5) ---//
              hold >>>= 5;
              bits -= 5;
              //---//
              state.ncode = (hold & 0x0f /*BITS(4)*/) + 4;
              //--- DROPBITS(4) ---//
              hold >>>= 4;
              bits -= 4;
              //---//
              //#ifndef PKZIP_BUG_WORKAROUND
              if (state.nlen > 286 || state.ndist > 30) {
                strm.msg = 'too many length or distance symbols';
                state.mode = BAD;
                break;
              }
              //#endif
              //Tracev((stderr, "inflate:       table sizes ok\n"));
              state.have = 0;
              state.mode = LENLENS;
            /* falls through */
            case LENLENS:
              while (state.have < state.ncode) {
                //=== NEEDBITS(3);
                while (bits < 3) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                state.lens[order[state.have++]] = hold & 0x07; //BITS(3);
                //--- DROPBITS(3) ---//
                hold >>>= 3;
                bits -= 3;
                //---//
              }
              while (state.have < 19) {
                state.lens[order[state.have++]] = 0;
              }
              // We have separate tables & no pointers. 2 commented lines below not needed.
              //state.next = state.codes;
              //state.lencode = state.next;
              // Switch to use dynamic table
              state.lencode = state.lendyn;
              state.lenbits = 7;
              opts = {
                bits: state.lenbits
              };
              ret = inflate_table(CODES, state.lens, 0, 19, state.lencode, 0, state.work, opts);
              state.lenbits = opts.bits;
              if (ret) {
                strm.msg = 'invalid code lengths set';
                state.mode = BAD;
                break;
              }
              //Tracev((stderr, "inflate:       code lengths ok\n"));
              state.have = 0;
              state.mode = CODELENS;
            /* falls through */
            case CODELENS:
              while (state.have < state.nlen + state.ndist) {
                for (;;) {
                  here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 0xff;
                  here_val = here & 0xffff;
                  if (here_bits <= bits) {
                    break;
                  }
                  //--- PULLBYTE() ---//
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                  //---//
                }
                if (here_val < 16) {
                  //--- DROPBITS(here.bits) ---//
                  hold >>>= here_bits;
                  bits -= here_bits;
                  //---//
                  state.lens[state.have++] = here_val;
                } else {
                  if (here_val === 16) {
                    //=== NEEDBITS(here.bits + 2);
                    n = here_bits + 2;
                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    if (state.have === 0) {
                      strm.msg = 'invalid bit length repeat';
                      state.mode = BAD;
                      break;
                    }
                    len = state.lens[state.have - 1];
                    copy = 3 + (hold & 0x03); //BITS(2);
                    //--- DROPBITS(2) ---//
                    hold >>>= 2;
                    bits -= 2;
                    //---//
                  } else if (here_val === 17) {
                    //=== NEEDBITS(here.bits + 3);
                    n = here_bits + 3;
                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    len = 0;
                    copy = 3 + (hold & 0x07); //BITS(3);
                    //--- DROPBITS(3) ---//
                    hold >>>= 3;
                    bits -= 3;
                    //---//
                  } else {
                    //=== NEEDBITS(here.bits + 7);
                    n = here_bits + 7;
                    while (bits < n) {
                      if (have === 0) {
                        break inf_leave;
                      }
                      have--;
                      hold += input[next++] << bits;
                      bits += 8;
                    }
                    //===//
                    //--- DROPBITS(here.bits) ---//
                    hold >>>= here_bits;
                    bits -= here_bits;
                    //---//
                    len = 0;
                    copy = 11 + (hold & 0x7f); //BITS(7);
                    //--- DROPBITS(7) ---//
                    hold >>>= 7;
                    bits -= 7;
                    //---//
                  }
                  if (state.have + copy > state.nlen + state.ndist) {
                    strm.msg = 'invalid bit length repeat';
                    state.mode = BAD;
                    break;
                  }
                  while (copy--) {
                    state.lens[state.have++] = len;
                  }
                }
              }

              /* handle error breaks in while */
              if (state.mode === BAD) {
                break;
              }

              /* check for end-of-block code (better have one) */
              if (state.lens[256] === 0) {
                strm.msg = 'invalid code -- missing end-of-block';
                state.mode = BAD;
                break;
              }

              /* build code tables -- note: do not change the lenbits or distbits
                 values here (9 and 6) without reading the comments in inftrees.h
                 concerning the ENOUGH constants, which depend on those values */
              state.lenbits = 9;
              opts = {
                bits: state.lenbits
              };
              ret = inflate_table(LENS, state.lens, 0, state.nlen, state.lencode, 0, state.work, opts);
              // We have separate tables & no pointers. 2 commented lines below not needed.
              // state.next_index = opts.table_index;
              state.lenbits = opts.bits;
              // state.lencode = state.next;

              if (ret) {
                strm.msg = 'invalid literal/lengths set';
                state.mode = BAD;
                break;
              }
              state.distbits = 6;
              //state.distcode.copy(state.codes);
              // Switch to use dynamic table
              state.distcode = state.distdyn;
              opts = {
                bits: state.distbits
              };
              ret = inflate_table(DISTS, state.lens, state.nlen, state.ndist, state.distcode, 0, state.work, opts);
              // We have separate tables & no pointers. 2 commented lines below not needed.
              // state.next_index = opts.table_index;
              state.distbits = opts.bits;
              // state.distcode = state.next;

              if (ret) {
                strm.msg = 'invalid distances set';
                state.mode = BAD;
                break;
              }
              //Tracev((stderr, 'inflate:       codes ok\n'));
              state.mode = LEN_;
              if (flush === Z_TREES) {
                break inf_leave;
              }
            /* falls through */
            case LEN_:
              state.mode = LEN;
            /* falls through */
            case LEN:
              if (have >= 6 && left >= 258) {
                //--- RESTORE() ---
                strm.next_out = put;
                strm.avail_out = left;
                strm.next_in = next;
                strm.avail_in = have;
                state.hold = hold;
                state.bits = bits;
                //---
                inflate_fast(strm, _out);
                //--- LOAD() ---
                put = strm.next_out;
                output = strm.output;
                left = strm.avail_out;
                next = strm.next_in;
                input = strm.input;
                have = strm.avail_in;
                hold = state.hold;
                bits = state.bits;
                //---

                if (state.mode === TYPE) {
                  state.back = -1;
                }
                break;
              }
              state.back = 0;
              for (;;) {
                here = state.lencode[hold & (1 << state.lenbits) - 1]; /*BITS(state.lenbits)*/
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) {
                  break;
                }
                //--- PULLBYTE() ---//
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
                //---//
              }
              if (here_op && (here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for (;;) {
                  here = state.lencode[last_val + ((hold & (1 << last_bits + last_op) - 1 /*BITS(last.bits + last.op)*/) >> last_bits)];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 0xff;
                  here_val = here & 0xffff;
                  if (last_bits + here_bits <= bits) {
                    break;
                  }
                  //--- PULLBYTE() ---//
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                  //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
              }
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              state.back += here_bits;
              state.length = here_val;
              if (here_op === 0) {
                //Tracevv((stderr, here.val >= 0x20 && here.val < 0x7f ?
                //        "inflate:         literal '%c'\n" :
                //        "inflate:         literal 0x%02x\n", here.val));
                state.mode = LIT;
                break;
              }
              if (here_op & 32) {
                //Tracevv((stderr, "inflate:         end of block\n"));
                state.back = -1;
                state.mode = TYPE;
                break;
              }
              if (here_op & 64) {
                strm.msg = 'invalid literal/length code';
                state.mode = BAD;
                break;
              }
              state.extra = here_op & 15;
              state.mode = LENEXT;
            /* falls through */
            case LENEXT:
              if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                state.length += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
              }
              //Tracevv((stderr, "inflate:         length %u\n", state.length));
              state.was = state.length;
              state.mode = DIST;
            /* falls through */
            case DIST:
              for (;;) {
                here = state.distcode[hold & (1 << state.distbits) - 1]; /*BITS(state.distbits)*/
                here_bits = here >>> 24;
                here_op = here >>> 16 & 0xff;
                here_val = here & 0xffff;
                if (here_bits <= bits) {
                  break;
                }
                //--- PULLBYTE() ---//
                if (have === 0) {
                  break inf_leave;
                }
                have--;
                hold += input[next++] << bits;
                bits += 8;
                //---//
              }
              if ((here_op & 0xf0) === 0) {
                last_bits = here_bits;
                last_op = here_op;
                last_val = here_val;
                for (;;) {
                  here = state.distcode[last_val + ((hold & (1 << last_bits + last_op) - 1 /*BITS(last.bits + last.op)*/) >> last_bits)];
                  here_bits = here >>> 24;
                  here_op = here >>> 16 & 0xff;
                  here_val = here & 0xffff;
                  if (last_bits + here_bits <= bits) {
                    break;
                  }
                  //--- PULLBYTE() ---//
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                  //---//
                }
                //--- DROPBITS(last.bits) ---//
                hold >>>= last_bits;
                bits -= last_bits;
                //---//
                state.back += last_bits;
              }
              //--- DROPBITS(here.bits) ---//
              hold >>>= here_bits;
              bits -= here_bits;
              //---//
              state.back += here_bits;
              if (here_op & 64) {
                strm.msg = 'invalid distance code';
                state.mode = BAD;
                break;
              }
              state.offset = here_val;
              state.extra = here_op & 15;
              state.mode = DISTEXT;
            /* falls through */
            case DISTEXT:
              if (state.extra) {
                //=== NEEDBITS(state.extra);
                n = state.extra;
                while (bits < n) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                state.offset += hold & (1 << state.extra) - 1 /*BITS(state.extra)*/;
                //--- DROPBITS(state.extra) ---//
                hold >>>= state.extra;
                bits -= state.extra;
                //---//
                state.back += state.extra;
              }
              //#ifdef INFLATE_STRICT
              if (state.offset > state.dmax) {
                strm.msg = 'invalid distance too far back';
                state.mode = BAD;
                break;
              }
              //#endif
              //Tracevv((stderr, "inflate:         distance %u\n", state.offset));
              state.mode = MATCH;
            /* falls through */
            case MATCH:
              if (left === 0) {
                break inf_leave;
              }
              copy = _out - left;
              if (state.offset > copy) {
                /* copy from window */
                copy = state.offset - copy;
                if (copy > state.whave) {
                  if (state.sane) {
                    strm.msg = 'invalid distance too far back';
                    state.mode = BAD;
                    break;
                  }
                  // (!) This block is disabled in zlib defailts,
                  // don't enable it for binary compatibility
                  //#ifdef INFLATE_ALLOW_INVALID_DISTANCE_TOOFAR_ARRR
                  //          Trace((stderr, "inflate.c too far\n"));
                  //          copy -= state.whave;
                  //          if (copy > state.length) { copy = state.length; }
                  //          if (copy > left) { copy = left; }
                  //          left -= copy;
                  //          state.length -= copy;
                  //          do {
                  //            output[put++] = 0;
                  //          } while (--copy);
                  //          if (state.length === 0) { state.mode = LEN; }
                  //          break;
                  //#endif
                }
                if (copy > state.wnext) {
                  copy -= state.wnext;
                  from = state.wsize - copy;
                } else {
                  from = state.wnext - copy;
                }
                if (copy > state.length) {
                  copy = state.length;
                }
                from_source = state.window;
              } else {
                /* copy from output */
                from_source = output;
                from = put - state.offset;
                copy = state.length;
              }
              if (copy > left) {
                copy = left;
              }
              left -= copy;
              state.length -= copy;
              do {
                output[put++] = from_source[from++];
              } while (--copy);
              if (state.length === 0) {
                state.mode = LEN;
              }
              break;
            case LIT:
              if (left === 0) {
                break inf_leave;
              }
              output[put++] = state.length;
              left--;
              state.mode = LEN;
              break;
            case CHECK:
              if (state.wrap) {
                //=== NEEDBITS(32);
                while (bits < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  // Use '|' insdead of '+' to make sure that result is signed
                  hold |= input[next++] << bits;
                  bits += 8;
                }
                //===//
                _out -= left;
                strm.total_out += _out;
                state.total += _out;
                if (_out) {
                  strm.adler = state.check = /*UPDATE(state.check, put - _out, _out);*/
                  state.flags ? crc32(state.check, output, _out, put - _out) : adler32(state.check, output, _out, put - _out);
                }
                _out = left;
                // NB: crc32 stored as signed 32-bit int, zswap32 returns signed too
                if ((state.flags ? hold : zswap32(hold)) !== state.check) {
                  strm.msg = 'incorrect data check';
                  state.mode = BAD;
                  break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                //Tracev((stderr, "inflate:   check matches trailer\n"));
              }
              state.mode = LENGTH;
            /* falls through */
            case LENGTH:
              if (state.wrap && state.flags) {
                //=== NEEDBITS(32);
                while (bits < 32) {
                  if (have === 0) {
                    break inf_leave;
                  }
                  have--;
                  hold += input[next++] << bits;
                  bits += 8;
                }
                //===//
                if (hold !== (state.total & 0xffffffff)) {
                  strm.msg = 'incorrect length check';
                  state.mode = BAD;
                  break;
                }
                //=== INITBITS();
                hold = 0;
                bits = 0;
                //===//
                //Tracev((stderr, "inflate:   length matches trailer\n"));
              }
              state.mode = DONE;
            /* falls through */
            case DONE:
              ret = Z_STREAM_END;
              break inf_leave;
            case BAD:
              ret = Z_DATA_ERROR;
              break inf_leave;
            case MEM:
              return Z_MEM_ERROR;
            case SYNC:
            /* falls through */
            default:
              return Z_STREAM_ERROR;
          }
        }

        // inf_leave <- here is real place for "goto inf_leave", emulated via "break inf_leave"

        /*
           Return from inflate(), updating the total counts and the check value.
           If there was no progress during the inflate() call, return a buffer
           error.  Call updatewindow() to create and/or update the window state.
           Note: a memory error from inflate() is non-recoverable.
         */

        //--- RESTORE() ---
        strm.next_out = put;
        strm.avail_out = left;
        strm.next_in = next;
        strm.avail_in = have;
        state.hold = hold;
        state.bits = bits;
        //---

        if (state.wsize || _out !== strm.avail_out && state.mode < BAD && (state.mode < CHECK || flush !== Z_FINISH)) {
          if (updatewindow(strm, strm.output, strm.next_out, _out - strm.avail_out)) {
            state.mode = MEM;
            return Z_MEM_ERROR;
          }
        }
        _in -= strm.avail_in;
        _out -= strm.avail_out;
        strm.total_in += _in;
        strm.total_out += _out;
        state.total += _out;
        if (state.wrap && _out) {
          strm.adler = state.check = /*UPDATE(state.check, strm.next_out - _out, _out);*/
          state.flags ? crc32(state.check, output, _out, strm.next_out - _out) : adler32(state.check, output, _out, strm.next_out - _out);
        }
        strm.data_type = state.bits + (state.last ? 64 : 0) + (state.mode === TYPE ? 128 : 0) + (state.mode === LEN_ || state.mode === COPY_ ? 256 : 0);
        if ((_in === 0 && _out === 0 || flush === Z_FINISH) && ret === Z_OK) {
          ret = Z_BUF_ERROR;
        }
        return ret;
      }
      function inflateEnd(strm) {
        if (!strm || !strm.state /*|| strm->zfree == (free_func)0*/) {
          return Z_STREAM_ERROR;
        }
        var state = strm.state;
        if (state.window) {
          state.window = null;
        }
        strm.state = null;
        return Z_OK;
      }
      function inflateGetHeader(strm, head) {
        var state;

        /* check state */
        if (!strm || !strm.state) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        if ((state.wrap & 2) === 0) {
          return Z_STREAM_ERROR;
        }

        /* save header structure */
        state.head = head;
        head.done = false;
        return Z_OK;
      }
      function inflateSetDictionary(strm, dictionary) {
        var dictLength = dictionary.length;
        var state;
        var dictid;
        var ret;

        /* check state */
        if (!strm /* == Z_NULL */ || !strm.state /* == Z_NULL */) {
          return Z_STREAM_ERROR;
        }
        state = strm.state;
        if (state.wrap !== 0 && state.mode !== DICT) {
          return Z_STREAM_ERROR;
        }

        /* check for correct dictionary identifier */
        if (state.mode === DICT) {
          dictid = 1; /* adler32(0, null, 0)*/
          /* dictid = adler32(dictid, dictionary, dictLength); */
          dictid = adler32(dictid, dictionary, dictLength, 0);
          if (dictid !== state.check) {
            return Z_DATA_ERROR;
          }
        }
        /* copy dictionary to window using updatewindow(), which will amend the
         existing dictionary if appropriate */
        ret = updatewindow(strm, dictionary, dictLength, dictLength);
        if (ret) {
          state.mode = MEM;
          return Z_MEM_ERROR;
        }
        state.havedict = 1;
        // Tracev((stderr, "inflate:   dictionary set\n"));
        return Z_OK;
      }
      exports.inflateReset = inflateReset;
      exports.inflateReset2 = inflateReset2;
      exports.inflateResetKeep = inflateResetKeep;
      exports.inflateInit = inflateInit;
      exports.inflateInit2 = inflateInit2;
      exports.inflate = inflate;
      exports.inflateEnd = inflateEnd;
      exports.inflateGetHeader = inflateGetHeader;
      exports.inflateSetDictionary = inflateSetDictionary;
      exports.inflateInfo = 'pako inflate (from Nodeca project)';

      /* Not implemented
      exports.inflateCopy = inflateCopy;
      exports.inflateGetDictionary = inflateGetDictionary;
      exports.inflateMark = inflateMark;
      exports.inflatePrime = inflatePrime;
      exports.inflateSync = inflateSync;
      exports.inflateSyncPoint = inflateSyncPoint;
      exports.inflateUndermine = inflateUndermine;
      */
    }, {
      "../utils/common": 41,
      "./adler32": 43,
      "./crc32": 45,
      "./inffast": 48,
      "./inftrees": 50
    }],
    50: [function (require, module, exports) {
      'use strict';

      // (C) 1995-2013 Jean-loup Gailly and Mark Adler
      // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
      //
      // This software is provided 'as-is', without any express or implied
      // warranty. In no event will the authors be held liable for any damages
      // arising from the use of this software.
      //
      // Permission is granted to anyone to use this software for any purpose,
      // including commercial applications, and to alter it and redistribute it
      // freely, subject to the following restrictions:
      //
      // 1. The origin of this software must not be misrepresented; you must not
      //   claim that you wrote the original software. If you use this software
      //   in a product, an acknowledgment in the product documentation would be
      //   appreciated but is not required.
      // 2. Altered source versions must be plainly marked as such, and must not be
      //   misrepresented as being the original software.
      // 3. This notice may not be removed or altered from any source distribution.
      var utils = require('../utils/common');
      var MAXBITS = 15;
      var ENOUGH_LENS = 852;
      var ENOUGH_DISTS = 592;
      //var ENOUGH = (ENOUGH_LENS+ENOUGH_DISTS);

      var CODES = 0;
      var LENS = 1;
      var DISTS = 2;
      var lbase = [/* Length codes 257..285 base */
      3, 4, 5, 6, 7, 8, 9, 10, 11, 13, 15, 17, 19, 23, 27, 31, 35, 43, 51, 59, 67, 83, 99, 115, 131, 163, 195, 227, 258, 0, 0];
      var lext = [/* Length codes 257..285 extra */
      16, 16, 16, 16, 16, 16, 16, 16, 17, 17, 17, 17, 18, 18, 18, 18, 19, 19, 19, 19, 20, 20, 20, 20, 21, 21, 21, 21, 16, 72, 78];
      var dbase = [/* Distance codes 0..29 base */
      1, 2, 3, 4, 5, 7, 9, 13, 17, 25, 33, 49, 65, 97, 129, 193, 257, 385, 513, 769, 1025, 1537, 2049, 3073, 4097, 6145, 8193, 12289, 16385, 24577, 0, 0];
      var dext = [/* Distance codes 0..29 extra */
      16, 16, 16, 16, 17, 17, 18, 18, 19, 19, 20, 20, 21, 21, 22, 22, 23, 23, 24, 24, 25, 25, 26, 26, 27, 27, 28, 28, 29, 29, 64, 64];
      module.exports = function inflate_table(type, lens, lens_index, codes, table, table_index, work, opts) {
        var bits = opts.bits;
        //here = opts.here; /* table entry for duplication */

        var len = 0; /* a code's length in bits */
        var sym = 0; /* index of code symbols */
        var min = 0,
          max = 0; /* minimum and maximum code lengths */
        var root = 0; /* number of index bits for root table */
        var curr = 0; /* number of index bits for current table */
        var drop = 0; /* code bits to drop for sub-table */
        var left = 0; /* number of prefix codes available */
        var used = 0; /* code entries in table used */
        var huff = 0; /* Huffman code */
        var incr; /* for incrementing code, index */
        var fill; /* index for replicating entries */
        var low; /* low bits for current root entry */
        var mask; /* mask for low root bits */
        var next; /* next available space in table */
        var base = null; /* base value table to use */
        var base_index = 0;
        //  var shoextra;    /* extra bits table to use */
        var end; /* use base and extra for symbol > end */
        var count = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];    /* number of codes of each length */
        var offs = new utils.Buf16(MAXBITS + 1); //[MAXBITS+1];     /* offsets in table for each length */
        var extra = null;
        var extra_index = 0;
        var here_bits, here_op, here_val;

        /*
         Process a set of code lengths to create a canonical Huffman code.  The
         code lengths are lens[0..codes-1].  Each length corresponds to the
         symbols 0..codes-1.  The Huffman code is generated by first sorting the
         symbols by length from short to long, and retaining the symbol order
         for codes with equal lengths.  Then the code starts with all zero bits
         for the first code of the shortest length, and the codes are integer
         increments for the same length, and zeros are appended as the length
         increases.  For the deflate format, these bits are stored backwards
         from their more natural integer increment ordering, and so when the
         decoding tables are built in the large loop below, the integer codes
         are incremented backwards.
          This routine assumes, but does not check, that all of the entries in
         lens[] are in the range 0..MAXBITS.  The caller must assure this.
         1..MAXBITS is interpreted as that code length.  zero means that that
         symbol does not occur in this code.
          The codes are sorted by computing a count of codes for each length,
         creating from that a table of starting indices for each length in the
         sorted table, and then entering the symbols in order in the sorted
         table.  The sorted table is work[], with that space being provided by
         the caller.
          The length counts are used for other purposes as well, i.e. finding
         the minimum and maximum length codes, determining if there are any
         codes at all, checking for a valid set of lengths, and looking ahead
         at length counts to determine sub-table sizes when building the
         decoding tables.
         */

        /* accumulate lengths for codes (assumes lens[] all in 0..MAXBITS) */
        for (len = 0; len <= MAXBITS; len++) {
          count[len] = 0;
        }
        for (sym = 0; sym < codes; sym++) {
          count[lens[lens_index + sym]]++;
        }

        /* bound code lengths, force root to be within code lengths */
        root = bits;
        for (max = MAXBITS; max >= 1; max--) {
          if (count[max] !== 0) {
            break;
          }
        }
        if (root > max) {
          root = max;
        }
        if (max === 0) {
          /* no symbols to code at all */
          //table.op[opts.table_index] = 64;  //here.op = (var char)64;    /* invalid code marker */
          //table.bits[opts.table_index] = 1;   //here.bits = (var char)1;
          //table.val[opts.table_index++] = 0;   //here.val = (var short)0;
          table[table_index++] = 1 << 24 | 64 << 16 | 0;

          //table.op[opts.table_index] = 64;
          //table.bits[opts.table_index] = 1;
          //table.val[opts.table_index++] = 0;
          table[table_index++] = 1 << 24 | 64 << 16 | 0;
          opts.bits = 1;
          return 0; /* no symbols, but wait for decoding to report error */
        }
        for (min = 1; min < max; min++) {
          if (count[min] !== 0) {
            break;
          }
        }
        if (root < min) {
          root = min;
        }

        /* check for an over-subscribed or incomplete set of lengths */
        left = 1;
        for (len = 1; len <= MAXBITS; len++) {
          left <<= 1;
          left -= count[len];
          if (left < 0) {
            return -1;
          } /* over-subscribed */
        }
        if (left > 0 && (type === CODES || max !== 1)) {
          return -1; /* incomplete set */
        }

        /* generate offsets into symbol table for each length for sorting */
        offs[1] = 0;
        for (len = 1; len < MAXBITS; len++) {
          offs[len + 1] = offs[len] + count[len];
        }

        /* sort symbols by length, by symbol order within each length */
        for (sym = 0; sym < codes; sym++) {
          if (lens[lens_index + sym] !== 0) {
            work[offs[lens[lens_index + sym]]++] = sym;
          }
        }

        /*
         Create and fill in decoding tables.  In this loop, the table being
         filled is at next and has curr index bits.  The code being used is huff
         with length len.  That code is converted to an index by dropping drop
         bits off of the bottom.  For codes where len is less than drop + curr,
         those top drop + curr - len bits are incremented through all values to
         fill the table with replicated entries.
          root is the number of index bits for the root table.  When len exceeds
         root, sub-tables are created pointed to by the root entry with an index
         of the low root bits of huff.  This is saved in low to check for when a
         new sub-table should be started.  drop is zero when the root table is
         being filled, and drop is root when sub-tables are being filled.
          When a new sub-table is needed, it is necessary to look ahead in the
         code lengths to determine what size sub-table is needed.  The length
         counts are used for this, and so count[] is decremented as codes are
         entered in the tables.
          used keeps track of how many table entries have been allocated from the
         provided *table space.  It is checked for LENS and DIST tables against
         the constants ENOUGH_LENS and ENOUGH_DISTS to guard against changes in
         the initial root table size constants.  See the comments in inftrees.h
         for more information.
          sym increments through all symbols, and the loop terminates when
         all codes of length max, i.e. all codes, have been processed.  This
         routine permits incomplete codes, so another loop after this one fills
         in the rest of the decoding tables with invalid code markers.
         */

        /* set up for code type */
        // poor man optimization - use if-else instead of switch,
        // to avoid deopts in old v8
        if (type === CODES) {
          base = extra = work; /* dummy value--not used */
          end = 19;
        } else if (type === LENS) {
          base = lbase;
          base_index -= 257;
          extra = lext;
          extra_index -= 257;
          end = 256;
        } else {
          /* DISTS */
          base = dbase;
          extra = dext;
          end = -1;
        }

        /* initialize opts for loop */
        huff = 0; /* starting code */
        sym = 0; /* starting code symbol */
        len = min; /* starting code length */
        next = table_index; /* current table to fill in */
        curr = root; /* current table index bits */
        drop = 0; /* current bits to drop from code for index */
        low = -1; /* trigger new sub-table when len > root */
        used = 1 << root; /* use root table entries */
        mask = used - 1; /* mask for comparing low */

        /* check available table space */
        if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
          return 1;
        }

        /* process all codes and make table entries */
        for (;;) {
          /* create table entry */
          here_bits = len - drop;
          if (work[sym] < end) {
            here_op = 0;
            here_val = work[sym];
          } else if (work[sym] > end) {
            here_op = extra[extra_index + work[sym]];
            here_val = base[base_index + work[sym]];
          } else {
            here_op = 32 + 64; /* end of block */
            here_val = 0;
          }

          /* replicate for those indices with low len bits equal to huff */
          incr = 1 << len - drop;
          fill = 1 << curr;
          min = fill; /* save offset to next table */
          do {
            fill -= incr;
            table[next + (huff >> drop) + fill] = here_bits << 24 | here_op << 16 | here_val | 0;
          } while (fill !== 0);

          /* backwards increment the len-bit code huff */
          incr = 1 << len - 1;
          while (huff & incr) {
            incr >>= 1;
          }
          if (incr !== 0) {
            huff &= incr - 1;
            huff += incr;
          } else {
            huff = 0;
          }

          /* go to next symbol, update count, len */
          sym++;
          if (--count[len] === 0) {
            if (len === max) {
              break;
            }
            len = lens[lens_index + work[sym]];
          }

          /* create new sub-table if needed */
          if (len > root && (huff & mask) !== low) {
            /* if first time, transition to sub-tables */
            if (drop === 0) {
              drop = root;
            }

            /* increment past last table */
            next += min; /* here min is 1 << curr */

            /* determine length of next table */
            curr = len - drop;
            left = 1 << curr;
            while (curr + drop < max) {
              left -= count[curr + drop];
              if (left <= 0) {
                break;
              }
              curr++;
              left <<= 1;
            }

            /* check for enough space */
            used += 1 << curr;
            if (type === LENS && used > ENOUGH_LENS || type === DISTS && used > ENOUGH_DISTS) {
              return 1;
            }

            /* point entry in root table to sub-table */
            low = huff & mask;
            /*table.op[low] = curr;
            table.bits[low] = root;
            table.val[low] = next - opts.table_index;*/
            table[low] = root << 24 | curr << 16 | next - table_index | 0;
          }
        }

        /* fill in remaining table entry if code is incomplete (guaranteed to have
         at most one remaining entry, since if the code is incomplete, the
         maximum code length that was allowed to get this far is one bit) */
        if (huff !== 0) {
          //table.op[next + huff] = 64;            /* invalid code marker */
          //table.bits[next + huff] = len - drop;
          //table.val[next + huff] = 0;
          table[next + huff] = len - drop << 24 | 64 << 16 | 0;
        }

        /* set return parameters */
        //opts.table_index += used;
        opts.bits = root;
        return 0;
      };
    }, {
      "../utils/common": 41
    }],
    51: [function (require, module, exports) {
      'use strict';

      // (C) 1995-2013 Jean-loup Gailly and Mark Adler
      // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
      //
      // This software is provided 'as-is', without any express or implied
      // warranty. In no event will the authors be held liable for any damages
      // arising from the use of this software.
      //
      // Permission is granted to anyone to use this software for any purpose,
      // including commercial applications, and to alter it and redistribute it
      // freely, subject to the following restrictions:
      //
      // 1. The origin of this software must not be misrepresented; you must not
      //   claim that you wrote the original software. If you use this software
      //   in a product, an acknowledgment in the product documentation would be
      //   appreciated but is not required.
      // 2. Altered source versions must be plainly marked as such, and must not be
      //   misrepresented as being the original software.
      // 3. This notice may not be removed or altered from any source distribution.
      module.exports = {
        2: 'need dictionary',
        /* Z_NEED_DICT       2  */
        1: 'stream end',
        /* Z_STREAM_END      1  */
        0: '',
        /* Z_OK              0  */
        '-1': 'file error',
        /* Z_ERRNO         (-1) */
        '-2': 'stream error',
        /* Z_STREAM_ERROR  (-2) */
        '-3': 'data error',
        /* Z_DATA_ERROR    (-3) */
        '-4': 'insufficient memory',
        /* Z_MEM_ERROR     (-4) */
        '-5': 'buffer error',
        /* Z_BUF_ERROR     (-5) */
        '-6': 'incompatible version' /* Z_VERSION_ERROR (-6) */
      };
    }, {}],
    52: [function (require, module, exports) {
      'use strict';

      // (C) 1995-2013 Jean-loup Gailly and Mark Adler
      // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
      //
      // This software is provided 'as-is', without any express or implied
      // warranty. In no event will the authors be held liable for any damages
      // arising from the use of this software.
      //
      // Permission is granted to anyone to use this software for any purpose,
      // including commercial applications, and to alter it and redistribute it
      // freely, subject to the following restrictions:
      //
      // 1. The origin of this software must not be misrepresented; you must not
      //   claim that you wrote the original software. If you use this software
      //   in a product, an acknowledgment in the product documentation would be
      //   appreciated but is not required.
      // 2. Altered source versions must be plainly marked as such, and must not be
      //   misrepresented as being the original software.
      // 3. This notice may not be removed or altered from any source distribution.
      var utils = require('../utils/common');

      /* Public constants ==========================================================*/
      /* ===========================================================================*/

      //var Z_FILTERED          = 1;
      //var Z_HUFFMAN_ONLY      = 2;
      //var Z_RLE               = 3;
      var Z_FIXED = 4;
      //var Z_DEFAULT_STRATEGY  = 0;

      /* Possible values of the data_type field (though see inflate()) */
      var Z_BINARY = 0;
      var Z_TEXT = 1;
      //var Z_ASCII             = 1; // = Z_TEXT
      var Z_UNKNOWN = 2;

      /*============================================================================*/

      function zero(buf) {
        var len = buf.length;
        while (--len >= 0) {
          buf[len] = 0;
        }
      }

      // From zutil.h

      var STORED_BLOCK = 0;
      var STATIC_TREES = 1;
      var DYN_TREES = 2;
      /* The three kinds of block type */

      var MIN_MATCH = 3;
      var MAX_MATCH = 258;
      /* The minimum and maximum match lengths */

      // From deflate.h
      /* ===========================================================================
       * Internal compression state.
       */

      var LENGTH_CODES = 29;
      /* number of length codes, not counting the special END_BLOCK code */

      var LITERALS = 256;
      /* number of literal bytes 0..255 */

      var L_CODES = LITERALS + 1 + LENGTH_CODES;
      /* number of Literal or Length codes, including the END_BLOCK code */

      var D_CODES = 30;
      /* number of distance codes */

      var BL_CODES = 19;
      /* number of codes used to transfer the bit lengths */

      var HEAP_SIZE = 2 * L_CODES + 1;
      /* maximum heap size */

      var MAX_BITS = 15;
      /* All codes must not exceed MAX_BITS bits */

      var Buf_size = 16;
      /* size of bit buffer in bi_buf */

      /* ===========================================================================
       * Constants
       */

      var MAX_BL_BITS = 7;
      /* Bit length codes must not exceed MAX_BL_BITS bits */

      var END_BLOCK = 256;
      /* end of block literal code */

      var REP_3_6 = 16;
      /* repeat previous bit length 3-6 times (2 bits of repeat count) */

      var REPZ_3_10 = 17;
      /* repeat a zero length 3-10 times  (3 bits of repeat count) */

      var REPZ_11_138 = 18;
      /* repeat a zero length 11-138 times  (7 bits of repeat count) */

      /* eslint-disable comma-spacing,array-bracket-spacing */
      var extra_lbits = /* extra bits for each length code */
      [0, 0, 0, 0, 0, 0, 0, 0, 1, 1, 1, 1, 2, 2, 2, 2, 3, 3, 3, 3, 4, 4, 4, 4, 5, 5, 5, 5, 0];
      var extra_dbits = /* extra bits for each distance code */
      [0, 0, 0, 0, 1, 1, 2, 2, 3, 3, 4, 4, 5, 5, 6, 6, 7, 7, 8, 8, 9, 9, 10, 10, 11, 11, 12, 12, 13, 13];
      var extra_blbits = /* extra bits for each bit length code */
      [0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 0, 2, 3, 7];
      var bl_order = [16, 17, 18, 0, 8, 7, 9, 6, 10, 5, 11, 4, 12, 3, 13, 2, 14, 1, 15];
      /* eslint-enable comma-spacing,array-bracket-spacing */

      /* The lengths of the bit length codes are sent in order of decreasing
       * probability, to avoid transmitting the lengths for unused bit length codes.
       */

      /* ===========================================================================
       * Local data. These are initialized only once.
       */

      // We pre-fill arrays with 0 to avoid uninitialized gaps

      var DIST_CODE_LEN = 512; /* see definition of array dist_code below */

      // !!!! Use flat array insdead of structure, Freq = i*2, Len = i*2+1
      var static_ltree = new Array((L_CODES + 2) * 2);
      zero(static_ltree);
      /* The static literal tree. Since the bit lengths are imposed, there is no
       * need for the L_CODES extra codes used during heap construction. However
       * The codes 286 and 287 are needed to build a canonical tree (see _tr_init
       * below).
       */

      var static_dtree = new Array(D_CODES * 2);
      zero(static_dtree);
      /* The static distance tree. (Actually a trivial tree since all codes use
       * 5 bits.)
       */

      var _dist_code = new Array(DIST_CODE_LEN);
      zero(_dist_code);
      /* Distance codes. The first 256 values correspond to the distances
       * 3 .. 258, the last 256 values correspond to the top 8 bits of
       * the 15 bit distances.
       */

      var _length_code = new Array(MAX_MATCH - MIN_MATCH + 1);
      zero(_length_code);
      /* length code for each normalized match length (0 == MIN_MATCH) */

      var base_length = new Array(LENGTH_CODES);
      zero(base_length);
      /* First normalized length for each code (0 = MIN_MATCH) */

      var base_dist = new Array(D_CODES);
      zero(base_dist);
      /* First normalized distance for each code (0 = distance of 1) */

      function StaticTreeDesc(static_tree, extra_bits, extra_base, elems, max_length) {
        this.static_tree = static_tree; /* static tree or NULL */
        this.extra_bits = extra_bits; /* extra bits for each code or NULL */
        this.extra_base = extra_base; /* base index for extra_bits */
        this.elems = elems; /* max number of elements in the tree */
        this.max_length = max_length; /* max bit length for the codes */

        // show if `static_tree` has data or dummy - needed for monomorphic objects
        this.has_stree = static_tree && static_tree.length;
      }
      var static_l_desc;
      var static_d_desc;
      var static_bl_desc;
      function TreeDesc(dyn_tree, stat_desc) {
        this.dyn_tree = dyn_tree; /* the dynamic tree */
        this.max_code = 0; /* largest code with non zero frequency */
        this.stat_desc = stat_desc; /* the corresponding static tree */
      }
      function d_code(dist) {
        return dist < 256 ? _dist_code[dist] : _dist_code[256 + (dist >>> 7)];
      }

      /* ===========================================================================
       * Output a short LSB first on the stream.
       * IN assertion: there is enough room in pendingBuf.
       */
      function put_short(s, w) {
        //    put_byte(s, (uch)((w) & 0xff));
        //    put_byte(s, (uch)((ush)(w) >> 8));
        s.pending_buf[s.pending++] = w & 0xff;
        s.pending_buf[s.pending++] = w >>> 8 & 0xff;
      }

      /* ===========================================================================
       * Send a value on a given number of bits.
       * IN assertion: length <= 16 and value fits in length bits.
       */
      function send_bits(s, value, length) {
        if (s.bi_valid > Buf_size - length) {
          s.bi_buf |= value << s.bi_valid & 0xffff;
          put_short(s, s.bi_buf);
          s.bi_buf = value >> Buf_size - s.bi_valid;
          s.bi_valid += length - Buf_size;
        } else {
          s.bi_buf |= value << s.bi_valid & 0xffff;
          s.bi_valid += length;
        }
      }
      function send_code(s, c, tree) {
        send_bits(s, tree[c * 2] /*.Code*/, tree[c * 2 + 1] /*.Len*/);
      }

      /* ===========================================================================
       * Reverse the first len bits of a code, using straightforward code (a faster
       * method would use a table)
       * IN assertion: 1 <= len <= 15
       */
      function bi_reverse(code, len) {
        var res = 0;
        do {
          res |= code & 1;
          code >>>= 1;
          res <<= 1;
        } while (--len > 0);
        return res >>> 1;
      }

      /* ===========================================================================
       * Flush the bit buffer, keeping at most 7 bits in it.
       */
      function bi_flush(s) {
        if (s.bi_valid === 16) {
          put_short(s, s.bi_buf);
          s.bi_buf = 0;
          s.bi_valid = 0;
        } else if (s.bi_valid >= 8) {
          s.pending_buf[s.pending++] = s.bi_buf & 0xff;
          s.bi_buf >>= 8;
          s.bi_valid -= 8;
        }
      }

      /* ===========================================================================
       * Compute the optimal bit lengths for a tree and update the total bit length
       * for the current block.
       * IN assertion: the fields freq and dad are set, heap[heap_max] and
       *    above are the tree nodes sorted by increasing frequency.
       * OUT assertions: the field len is set to the optimal bit length, the
       *     array bl_count contains the frequencies for each bit length.
       *     The length opt_len is updated; static_len is also updated if stree is
       *     not null.
       */
      function gen_bitlen(s, desc)
      //    deflate_state *s;
      //    tree_desc *desc;    /* the tree descriptor */
      {
        var tree = desc.dyn_tree;
        var max_code = desc.max_code;
        var stree = desc.stat_desc.static_tree;
        var has_stree = desc.stat_desc.has_stree;
        var extra = desc.stat_desc.extra_bits;
        var base = desc.stat_desc.extra_base;
        var max_length = desc.stat_desc.max_length;
        var h; /* heap index */
        var n, m; /* iterate over the tree elements */
        var bits; /* bit length */
        var xbits; /* extra bits */
        var f; /* frequency */
        var overflow = 0; /* number of elements with bit length too large */

        for (bits = 0; bits <= MAX_BITS; bits++) {
          s.bl_count[bits] = 0;
        }

        /* In a first pass, compute the optimal bit lengths (which may
         * overflow in the case of the bit length tree).
         */
        tree[s.heap[s.heap_max] * 2 + 1] /*.Len*/ = 0; /* root of the heap */

        for (h = s.heap_max + 1; h < HEAP_SIZE; h++) {
          n = s.heap[h];
          bits = tree[tree[n * 2 + 1] /*.Dad*/ * 2 + 1] /*.Len*/ + 1;
          if (bits > max_length) {
            bits = max_length;
            overflow++;
          }
          tree[n * 2 + 1] /*.Len*/ = bits;
          /* We overwrite tree[n].Dad which is no longer needed */

          if (n > max_code) {
            continue;
          } /* not a leaf node */

          s.bl_count[bits]++;
          xbits = 0;
          if (n >= base) {
            xbits = extra[n - base];
          }
          f = tree[n * 2] /*.Freq*/;
          s.opt_len += f * (bits + xbits);
          if (has_stree) {
            s.static_len += f * (stree[n * 2 + 1] /*.Len*/ + xbits);
          }
        }
        if (overflow === 0) {
          return;
        }

        // Trace((stderr,"\nbit length overflow\n"));
        /* This happens for example on obj2 and pic of the Calgary corpus */

        /* Find the first bit length which could increase: */
        do {
          bits = max_length - 1;
          while (s.bl_count[bits] === 0) {
            bits--;
          }
          s.bl_count[bits]--; /* move one leaf down the tree */
          s.bl_count[bits + 1] += 2; /* move one overflow item as its brother */
          s.bl_count[max_length]--;
          /* The brother of the overflow item also moves one step up,
           * but this does not affect bl_count[max_length]
           */
          overflow -= 2;
        } while (overflow > 0);

        /* Now recompute all bit lengths, scanning in increasing frequency.
         * h is still equal to HEAP_SIZE. (It is simpler to reconstruct all
         * lengths instead of fixing only the wrong ones. This idea is taken
         * from 'ar' written by Haruhiko Okumura.)
         */
        for (bits = max_length; bits !== 0; bits--) {
          n = s.bl_count[bits];
          while (n !== 0) {
            m = s.heap[--h];
            if (m > max_code) {
              continue;
            }
            if (tree[m * 2 + 1] /*.Len*/ !== bits) {
              // Trace((stderr,"code %d bits %d->%d\n", m, tree[m].Len, bits));
              s.opt_len += (bits - tree[m * 2 + 1] /*.Len*/) * tree[m * 2] /*.Freq*/;
              tree[m * 2 + 1] /*.Len*/ = bits;
            }
            n--;
          }
        }
      }

      /* ===========================================================================
       * Generate the codes for a given tree and bit counts (which need not be
       * optimal).
       * IN assertion: the array bl_count contains the bit length statistics for
       * the given tree and the field len is set for all tree elements.
       * OUT assertion: the field code is set for all tree elements of non
       *     zero code length.
       */
      function gen_codes(tree, max_code, bl_count)
      //    ct_data *tree;             /* the tree to decorate */
      //    int max_code;              /* largest code with non zero frequency */
      //    ushf *bl_count;            /* number of codes at each bit length */
      {
        var next_code = new Array(MAX_BITS + 1); /* next code value for each bit length */
        var code = 0; /* running code value */
        var bits; /* bit index */
        var n; /* code index */

        /* The distribution counts are first used to generate the code values
         * without bit reversal.
         */
        for (bits = 1; bits <= MAX_BITS; bits++) {
          next_code[bits] = code = code + bl_count[bits - 1] << 1;
        }
        /* Check that the bit counts in bl_count are consistent. The last code
         * must be all ones.
         */
        //Assert (code + bl_count[MAX_BITS]-1 == (1<<MAX_BITS)-1,
        //        "inconsistent bit counts");
        //Tracev((stderr,"\ngen_codes: max_code %d ", max_code));

        for (n = 0; n <= max_code; n++) {
          var len = tree[n * 2 + 1] /*.Len*/;
          if (len === 0) {
            continue;
          }
          /* Now reverse the bits */
          tree[n * 2] /*.Code*/ = bi_reverse(next_code[len]++, len);

          //Tracecv(tree != static_ltree, (stderr,"\nn %3d %c l %2d c %4x (%x) ",
          //     n, (isgraph(n) ? n : ' '), len, tree[n].Code, next_code[len]-1));
        }
      }

      /* ===========================================================================
       * Initialize the various 'constant' tables.
       */
      function tr_static_init() {
        var n; /* iterates over tree elements */
        var bits; /* bit counter */
        var length; /* length value */
        var code; /* code value */
        var dist; /* distance index */
        var bl_count = new Array(MAX_BITS + 1);
        /* number of codes at each bit length for an optimal tree */

        // do check in _tr_init()
        //if (static_init_done) return;

        /* For some embedded targets, global variables are not initialized: */
        /*#ifdef NO_INIT_GLOBAL_POINTERS
          static_l_desc.static_tree = static_ltree;
          static_l_desc.extra_bits = extra_lbits;
          static_d_desc.static_tree = static_dtree;
          static_d_desc.extra_bits = extra_dbits;
          static_bl_desc.extra_bits = extra_blbits;
        #endif*/

        /* Initialize the mapping length (0..255) -> length code (0..28) */
        length = 0;
        for (code = 0; code < LENGTH_CODES - 1; code++) {
          base_length[code] = length;
          for (n = 0; n < 1 << extra_lbits[code]; n++) {
            _length_code[length++] = code;
          }
        }
        //Assert (length == 256, "tr_static_init: length != 256");
        /* Note that the length 255 (match length 258) can be represented
         * in two different ways: code 284 + 5 bits or code 285, so we
         * overwrite length_code[255] to use the best encoding:
         */
        _length_code[length - 1] = code;

        /* Initialize the mapping dist (0..32K) -> dist code (0..29) */
        dist = 0;
        for (code = 0; code < 16; code++) {
          base_dist[code] = dist;
          for (n = 0; n < 1 << extra_dbits[code]; n++) {
            _dist_code[dist++] = code;
          }
        }
        //Assert (dist == 256, "tr_static_init: dist != 256");
        dist >>= 7; /* from now on, all distances are divided by 128 */
        for (; code < D_CODES; code++) {
          base_dist[code] = dist << 7;
          for (n = 0; n < 1 << extra_dbits[code] - 7; n++) {
            _dist_code[256 + dist++] = code;
          }
        }
        //Assert (dist == 256, "tr_static_init: 256+dist != 512");

        /* Construct the codes of the static literal tree */
        for (bits = 0; bits <= MAX_BITS; bits++) {
          bl_count[bits] = 0;
        }
        n = 0;
        while (n <= 143) {
          static_ltree[n * 2 + 1] /*.Len*/ = 8;
          n++;
          bl_count[8]++;
        }
        while (n <= 255) {
          static_ltree[n * 2 + 1] /*.Len*/ = 9;
          n++;
          bl_count[9]++;
        }
        while (n <= 279) {
          static_ltree[n * 2 + 1] /*.Len*/ = 7;
          n++;
          bl_count[7]++;
        }
        while (n <= 287) {
          static_ltree[n * 2 + 1] /*.Len*/ = 8;
          n++;
          bl_count[8]++;
        }
        /* Codes 286 and 287 do not exist, but we must include them in the
         * tree construction to get a canonical Huffman tree (longest code
         * all ones)
         */
        gen_codes(static_ltree, L_CODES + 1, bl_count);

        /* The static distance tree is trivial: */
        for (n = 0; n < D_CODES; n++) {
          static_dtree[n * 2 + 1] /*.Len*/ = 5;
          static_dtree[n * 2] /*.Code*/ = bi_reverse(n, 5);
        }

        // Now data ready and we can init static trees
        static_l_desc = new StaticTreeDesc(static_ltree, extra_lbits, LITERALS + 1, L_CODES, MAX_BITS);
        static_d_desc = new StaticTreeDesc(static_dtree, extra_dbits, 0, D_CODES, MAX_BITS);
        static_bl_desc = new StaticTreeDesc(new Array(0), extra_blbits, 0, BL_CODES, MAX_BL_BITS);

        //static_init_done = true;
      }

      /* ===========================================================================
       * Initialize a new block.
       */
      function init_block(s) {
        var n; /* iterates over tree elements */

        /* Initialize the trees. */
        for (n = 0; n < L_CODES; n++) {
          s.dyn_ltree[n * 2] /*.Freq*/ = 0;
        }
        for (n = 0; n < D_CODES; n++) {
          s.dyn_dtree[n * 2] /*.Freq*/ = 0;
        }
        for (n = 0; n < BL_CODES; n++) {
          s.bl_tree[n * 2] /*.Freq*/ = 0;
        }
        s.dyn_ltree[END_BLOCK * 2] /*.Freq*/ = 1;
        s.opt_len = s.static_len = 0;
        s.last_lit = s.matches = 0;
      }

      /* ===========================================================================
       * Flush the bit buffer and align the output on a byte boundary
       */
      function bi_windup(s) {
        if (s.bi_valid > 8) {
          put_short(s, s.bi_buf);
        } else if (s.bi_valid > 0) {
          //put_byte(s, (Byte)s->bi_buf);
          s.pending_buf[s.pending++] = s.bi_buf;
        }
        s.bi_buf = 0;
        s.bi_valid = 0;
      }

      /* ===========================================================================
       * Copy a stored block, storing first the length and its
       * one's complement if requested.
       */
      function copy_block(s, buf, len, header)
      //DeflateState *s;
      //charf    *buf;    /* the input data */
      //unsigned len;     /* its length */
      //int      header;  /* true if block header must be written */
      {
        bi_windup(s); /* align on byte boundary */

        if (header) {
          put_short(s, len);
          put_short(s, ~len);
        }
        //  while (len--) {
        //    put_byte(s, *buf++);
        //  }
        utils.arraySet(s.pending_buf, s.window, buf, len, s.pending);
        s.pending += len;
      }

      /* ===========================================================================
       * Compares to subtrees, using the tree depth as tie breaker when
       * the subtrees have equal frequency. This minimizes the worst case length.
       */
      function smaller(tree, n, m, depth) {
        var _n2 = n * 2;
        var _m2 = m * 2;
        return tree[_n2] /*.Freq*/ < tree[_m2] /*.Freq*/ || tree[_n2] /*.Freq*/ === tree[_m2] /*.Freq*/ && depth[n] <= depth[m];
      }

      /* ===========================================================================
       * Restore the heap property by moving down the tree starting at node k,
       * exchanging a node with the smallest of its two sons if necessary, stopping
       * when the heap property is re-established (each father smaller than its
       * two sons).
       */
      function pqdownheap(s, tree, k)
      //    deflate_state *s;
      //    ct_data *tree;  /* the tree to restore */
      //    int k;               /* node to move down */
      {
        var v = s.heap[k];
        var j = k << 1; /* left son of k */
        while (j <= s.heap_len) {
          /* Set j to the smallest of the two sons: */
          if (j < s.heap_len && smaller(tree, s.heap[j + 1], s.heap[j], s.depth)) {
            j++;
          }
          /* Exit if v is smaller than both sons */
          if (smaller(tree, v, s.heap[j], s.depth)) {
            break;
          }

          /* Exchange v with the smallest son */
          s.heap[k] = s.heap[j];
          k = j;

          /* And continue down the tree, setting j to the left son of k */
          j <<= 1;
        }
        s.heap[k] = v;
      }

      // inlined manually
      // var SMALLEST = 1;

      /* ===========================================================================
       * Send the block data compressed using the given Huffman trees
       */
      function compress_block(s, ltree, dtree)
      //    deflate_state *s;
      //    const ct_data *ltree; /* literal tree */
      //    const ct_data *dtree; /* distance tree */
      {
        var dist; /* distance of matched string */
        var lc; /* match length or unmatched char (if dist == 0) */
        var lx = 0; /* running index in l_buf */
        var code; /* the code to send */
        var extra; /* number of extra bits to send */

        if (s.last_lit !== 0) {
          do {
            dist = s.pending_buf[s.d_buf + lx * 2] << 8 | s.pending_buf[s.d_buf + lx * 2 + 1];
            lc = s.pending_buf[s.l_buf + lx];
            lx++;
            if (dist === 0) {
              send_code(s, lc, ltree); /* send a literal byte */
              //Tracecv(isgraph(lc), (stderr," '%c' ", lc));
            } else {
              /* Here, lc is the match length - MIN_MATCH */
              code = _length_code[lc];
              send_code(s, code + LITERALS + 1, ltree); /* send the length code */
              extra = extra_lbits[code];
              if (extra !== 0) {
                lc -= base_length[code];
                send_bits(s, lc, extra); /* send the extra length bits */
              }
              dist--; /* dist is now the match distance - 1 */
              code = d_code(dist);
              //Assert (code < D_CODES, "bad d_code");

              send_code(s, code, dtree); /* send the distance code */
              extra = extra_dbits[code];
              if (extra !== 0) {
                dist -= base_dist[code];
                send_bits(s, dist, extra); /* send the extra distance bits */
              }
            } /* literal or match pair ? */

            /* Check that the overlay between pending_buf and d_buf+l_buf is ok: */
            //Assert((uInt)(s->pending) < s->lit_bufsize + 2*lx,
            //       "pendingBuf overflow");
          } while (lx < s.last_lit);
        }
        send_code(s, END_BLOCK, ltree);
      }

      /* ===========================================================================
       * Construct one Huffman tree and assigns the code bit strings and lengths.
       * Update the total bit length for the current block.
       * IN assertion: the field freq is set for all tree elements.
       * OUT assertions: the fields len and code are set to the optimal bit length
       *     and corresponding code. The length opt_len is updated; static_len is
       *     also updated if stree is not null. The field max_code is set.
       */
      function build_tree(s, desc)
      //    deflate_state *s;
      //    tree_desc *desc; /* the tree descriptor */
      {
        var tree = desc.dyn_tree;
        var stree = desc.stat_desc.static_tree;
        var has_stree = desc.stat_desc.has_stree;
        var elems = desc.stat_desc.elems;
        var n, m; /* iterate over heap elements */
        var max_code = -1; /* largest code with non zero frequency */
        var node; /* new node being created */

        /* Construct the initial heap, with least frequent element in
         * heap[SMALLEST]. The sons of heap[n] are heap[2*n] and heap[2*n+1].
         * heap[0] is not used.
         */
        s.heap_len = 0;
        s.heap_max = HEAP_SIZE;
        for (n = 0; n < elems; n++) {
          if (tree[n * 2] /*.Freq*/ !== 0) {
            s.heap[++s.heap_len] = max_code = n;
            s.depth[n] = 0;
          } else {
            tree[n * 2 + 1] /*.Len*/ = 0;
          }
        }

        /* The pkzip format requires that at least one distance code exists,
         * and that at least one bit should be sent even if there is only one
         * possible code. So to avoid special checks later on we force at least
         * two codes of non zero frequency.
         */
        while (s.heap_len < 2) {
          node = s.heap[++s.heap_len] = max_code < 2 ? ++max_code : 0;
          tree[node * 2] /*.Freq*/ = 1;
          s.depth[node] = 0;
          s.opt_len--;
          if (has_stree) {
            s.static_len -= stree[node * 2 + 1] /*.Len*/;
          }
          /* node is 0 or 1 so it does not have extra bits */
        }
        desc.max_code = max_code;

        /* The elements heap[heap_len/2+1 .. heap_len] are leaves of the tree,
         * establish sub-heaps of increasing lengths:
         */
        for (n = s.heap_len >> 1 /*int /2*/; n >= 1; n--) {
          pqdownheap(s, tree, n);
        }

        /* Construct the Huffman tree by repeatedly combining the least two
         * frequent nodes.
         */
        node = elems; /* next internal node of the tree */
        do {
          //pqremove(s, tree, n);  /* n = node of least frequency */
          /*** pqremove ***/
          n = s.heap[1 /*SMALLEST*/];
          s.heap[1 /*SMALLEST*/] = s.heap[s.heap_len--];
          pqdownheap(s, tree, 1 /*SMALLEST*/);
          /***/

          m = s.heap[1 /*SMALLEST*/]; /* m = node of next least frequency */

          s.heap[--s.heap_max] = n; /* keep the nodes sorted by frequency */
          s.heap[--s.heap_max] = m;

          /* Create a new node father of n and m */
          tree[node * 2] /*.Freq*/ = tree[n * 2] /*.Freq*/ + tree[m * 2] /*.Freq*/;
          s.depth[node] = (s.depth[n] >= s.depth[m] ? s.depth[n] : s.depth[m]) + 1;
          tree[n * 2 + 1] /*.Dad*/ = tree[m * 2 + 1] /*.Dad*/ = node;

          /* and insert the new node in the heap */
          s.heap[1 /*SMALLEST*/] = node++;
          pqdownheap(s, tree, 1 /*SMALLEST*/);
        } while (s.heap_len >= 2);
        s.heap[--s.heap_max] = s.heap[1 /*SMALLEST*/];

        /* At this point, the fields freq and dad are set. We can now
         * generate the bit lengths.
         */
        gen_bitlen(s, desc);

        /* The field len is now set, we can generate the bit codes */
        gen_codes(tree, max_code, s.bl_count);
      }

      /* ===========================================================================
       * Scan a literal or distance tree to determine the frequencies of the codes
       * in the bit length tree.
       */
      function scan_tree(s, tree, max_code)
      //    deflate_state *s;
      //    ct_data *tree;   /* the tree to be scanned */
      //    int max_code;    /* and its largest code of non zero frequency */
      {
        var n; /* iterates over all tree elements */
        var prevlen = -1; /* last emitted length */
        var curlen; /* length of current code */

        var nextlen = tree[0 * 2 + 1] /*.Len*/; /* length of next code */

        var count = 0; /* repeat count of the current code */
        var max_count = 7; /* max repeat count */
        var min_count = 4; /* min repeat count */

        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        }
        tree[(max_code + 1) * 2 + 1] /*.Len*/ = 0xffff; /* guard */

        for (n = 0; n <= max_code; n++) {
          curlen = nextlen;
          nextlen = tree[(n + 1) * 2 + 1] /*.Len*/;
          if (++count < max_count && curlen === nextlen) {
            continue;
          } else if (count < min_count) {
            s.bl_tree[curlen * 2] /*.Freq*/ += count;
          } else if (curlen !== 0) {
            if (curlen !== prevlen) {
              s.bl_tree[curlen * 2] /*.Freq*/++;
            }
            s.bl_tree[REP_3_6 * 2] /*.Freq*/++;
          } else if (count <= 10) {
            s.bl_tree[REPZ_3_10 * 2] /*.Freq*/++;
          } else {
            s.bl_tree[REPZ_11_138 * 2] /*.Freq*/++;
          }
          count = 0;
          prevlen = curlen;
          if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
          } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
          } else {
            max_count = 7;
            min_count = 4;
          }
        }
      }

      /* ===========================================================================
       * Send a literal or distance tree in compressed form, using the codes in
       * bl_tree.
       */
      function send_tree(s, tree, max_code)
      //    deflate_state *s;
      //    ct_data *tree; /* the tree to be scanned */
      //    int max_code;       /* and its largest code of non zero frequency */
      {
        var n; /* iterates over all tree elements */
        var prevlen = -1; /* last emitted length */
        var curlen; /* length of current code */

        var nextlen = tree[0 * 2 + 1] /*.Len*/; /* length of next code */

        var count = 0; /* repeat count of the current code */
        var max_count = 7; /* max repeat count */
        var min_count = 4; /* min repeat count */

        /* tree[max_code+1].Len = -1; */ /* guard already set */
        if (nextlen === 0) {
          max_count = 138;
          min_count = 3;
        }
        for (n = 0; n <= max_code; n++) {
          curlen = nextlen;
          nextlen = tree[(n + 1) * 2 + 1] /*.Len*/;
          if (++count < max_count && curlen === nextlen) {
            continue;
          } else if (count < min_count) {
            do {
              send_code(s, curlen, s.bl_tree);
            } while (--count !== 0);
          } else if (curlen !== 0) {
            if (curlen !== prevlen) {
              send_code(s, curlen, s.bl_tree);
              count--;
            }
            //Assert(count >= 3 && count <= 6, " 3_6?");
            send_code(s, REP_3_6, s.bl_tree);
            send_bits(s, count - 3, 2);
          } else if (count <= 10) {
            send_code(s, REPZ_3_10, s.bl_tree);
            send_bits(s, count - 3, 3);
          } else {
            send_code(s, REPZ_11_138, s.bl_tree);
            send_bits(s, count - 11, 7);
          }
          count = 0;
          prevlen = curlen;
          if (nextlen === 0) {
            max_count = 138;
            min_count = 3;
          } else if (curlen === nextlen) {
            max_count = 6;
            min_count = 3;
          } else {
            max_count = 7;
            min_count = 4;
          }
        }
      }

      /* ===========================================================================
       * Construct the Huffman tree for the bit lengths and return the index in
       * bl_order of the last bit length code to send.
       */
      function build_bl_tree(s) {
        var max_blindex; /* index of last bit length code of non zero freq */

        /* Determine the bit length frequencies for literal and distance trees */
        scan_tree(s, s.dyn_ltree, s.l_desc.max_code);
        scan_tree(s, s.dyn_dtree, s.d_desc.max_code);

        /* Build the bit length tree: */
        build_tree(s, s.bl_desc);
        /* opt_len now includes the length of the tree representations, except
         * the lengths of the bit lengths codes and the 5+5+4 bits for the counts.
         */

        /* Determine the number of bit length codes to send. The pkzip format
         * requires that at least 4 bit length codes be sent. (appnote.txt says
         * 3 but the actual value used is 4.)
         */
        for (max_blindex = BL_CODES - 1; max_blindex >= 3; max_blindex--) {
          if (s.bl_tree[bl_order[max_blindex] * 2 + 1] /*.Len*/ !== 0) {
            break;
          }
        }
        /* Update opt_len to include the bit length tree and counts */
        s.opt_len += 3 * (max_blindex + 1) + 5 + 5 + 4;
        //Tracev((stderr, "\ndyn trees: dyn %ld, stat %ld",
        //        s->opt_len, s->static_len));

        return max_blindex;
      }

      /* ===========================================================================
       * Send the header for a block using dynamic Huffman trees: the counts, the
       * lengths of the bit length codes, the literal tree and the distance tree.
       * IN assertion: lcodes >= 257, dcodes >= 1, blcodes >= 4.
       */
      function send_all_trees(s, lcodes, dcodes, blcodes)
      //    deflate_state *s;
      //    int lcodes, dcodes, blcodes; /* number of codes for each tree */
      {
        var rank; /* index in bl_order */

        //Assert (lcodes >= 257 && dcodes >= 1 && blcodes >= 4, "not enough codes");
        //Assert (lcodes <= L_CODES && dcodes <= D_CODES && blcodes <= BL_CODES,
        //        "too many codes");
        //Tracev((stderr, "\nbl counts: "));
        send_bits(s, lcodes - 257, 5); /* not +255 as stated in appnote.txt */
        send_bits(s, dcodes - 1, 5);
        send_bits(s, blcodes - 4, 4); /* not -3 as stated in appnote.txt */
        for (rank = 0; rank < blcodes; rank++) {
          //Tracev((stderr, "\nbl code %2d ", bl_order[rank]));
          send_bits(s, s.bl_tree[bl_order[rank] * 2 + 1] /*.Len*/, 3);
        }
        //Tracev((stderr, "\nbl tree: sent %ld", s->bits_sent));

        send_tree(s, s.dyn_ltree, lcodes - 1); /* literal tree */
        //Tracev((stderr, "\nlit tree: sent %ld", s->bits_sent));

        send_tree(s, s.dyn_dtree, dcodes - 1); /* distance tree */
        //Tracev((stderr, "\ndist tree: sent %ld", s->bits_sent));
      }

      /* ===========================================================================
       * Check if the data type is TEXT or BINARY, using the following algorithm:
       * - TEXT if the two conditions below are satisfied:
       *    a) There are no non-portable control characters belonging to the
       *       "black list" (0..6, 14..25, 28..31).
       *    b) There is at least one printable character belonging to the
       *       "white list" (9 {TAB}, 10 {LF}, 13 {CR}, 32..255).
       * - BINARY otherwise.
       * - The following partially-portable control characters form a
       *   "gray list" that is ignored in this detection algorithm:
       *   (7 {BEL}, 8 {BS}, 11 {VT}, 12 {FF}, 26 {SUB}, 27 {ESC}).
       * IN assertion: the fields Freq of dyn_ltree are set.
       */
      function detect_data_type(s) {
        /* black_mask is the bit mask of black-listed bytes
         * set bits 0..6, 14..25, and 28..31
         * 0xf3ffc07f = binary 11110011111111111100000001111111
         */
        var black_mask = 0xf3ffc07f;
        var n;

        /* Check for non-textual ("black-listed") bytes. */
        for (n = 0; n <= 31; n++, black_mask >>>= 1) {
          if (black_mask & 1 && s.dyn_ltree[n * 2] /*.Freq*/ !== 0) {
            return Z_BINARY;
          }
        }

        /* Check for textual ("white-listed") bytes. */
        if (s.dyn_ltree[9 * 2] /*.Freq*/ !== 0 || s.dyn_ltree[10 * 2] /*.Freq*/ !== 0 || s.dyn_ltree[13 * 2] /*.Freq*/ !== 0) {
          return Z_TEXT;
        }
        for (n = 32; n < LITERALS; n++) {
          if (s.dyn_ltree[n * 2] /*.Freq*/ !== 0) {
            return Z_TEXT;
          }
        }

        /* There are no "black-listed" or "white-listed" bytes:
         * this stream either is empty or has tolerated ("gray-listed") bytes only.
         */
        return Z_BINARY;
      }
      var static_init_done = false;

      /* ===========================================================================
       * Initialize the tree data structures for a new zlib stream.
       */
      function _tr_init(s) {
        if (!static_init_done) {
          tr_static_init();
          static_init_done = true;
        }
        s.l_desc = new TreeDesc(s.dyn_ltree, static_l_desc);
        s.d_desc = new TreeDesc(s.dyn_dtree, static_d_desc);
        s.bl_desc = new TreeDesc(s.bl_tree, static_bl_desc);
        s.bi_buf = 0;
        s.bi_valid = 0;

        /* Initialize the first block of the first file: */
        init_block(s);
      }

      /* ===========================================================================
       * Send a stored block
       */
      function _tr_stored_block(s, buf, stored_len, last)
      //DeflateState *s;
      //charf *buf;       /* input block */
      //ulg stored_len;   /* length of input block */
      //int last;         /* one if this is the last block for a file */
      {
        send_bits(s, (STORED_BLOCK << 1) + (last ? 1 : 0), 3); /* send block type */
        copy_block(s, buf, stored_len, true); /* with header */
      }

      /* ===========================================================================
       * Send one empty static block to give enough lookahead for inflate.
       * This takes 10 bits, of which 7 may remain in the bit buffer.
       */
      function _tr_align(s) {
        send_bits(s, STATIC_TREES << 1, 3);
        send_code(s, END_BLOCK, static_ltree);
        bi_flush(s);
      }

      /* ===========================================================================
       * Determine the best encoding for the current block: dynamic trees, static
       * trees or store, and output the encoded block to the zip file.
       */
      function _tr_flush_block(s, buf, stored_len, last)
      //DeflateState *s;
      //charf *buf;       /* input block, or NULL if too old */
      //ulg stored_len;   /* length of input block */
      //int last;         /* one if this is the last block for a file */
      {
        var opt_lenb, static_lenb; /* opt_len and static_len in bytes */
        var max_blindex = 0; /* index of last bit length code of non zero freq */

        /* Build the Huffman trees unless a stored block is forced */
        if (s.level > 0) {
          /* Check if the file is binary or text */
          if (s.strm.data_type === Z_UNKNOWN) {
            s.strm.data_type = detect_data_type(s);
          }

          /* Construct the literal and distance trees */
          build_tree(s, s.l_desc);
          // Tracev((stderr, "\nlit data: dyn %ld, stat %ld", s->opt_len,
          //        s->static_len));

          build_tree(s, s.d_desc);
          // Tracev((stderr, "\ndist data: dyn %ld, stat %ld", s->opt_len,
          //        s->static_len));
          /* At this point, opt_len and static_len are the total bit lengths of
           * the compressed block data, excluding the tree representations.
           */

          /* Build the bit length tree for the above two trees, and get the index
           * in bl_order of the last bit length code to send.
           */
          max_blindex = build_bl_tree(s);

          /* Determine the best encoding. Compute the block lengths in bytes. */
          opt_lenb = s.opt_len + 3 + 7 >>> 3;
          static_lenb = s.static_len + 3 + 7 >>> 3;

          // Tracev((stderr, "\nopt %lu(%lu) stat %lu(%lu) stored %lu lit %u ",
          //        opt_lenb, s->opt_len, static_lenb, s->static_len, stored_len,
          //        s->last_lit));

          if (static_lenb <= opt_lenb) {
            opt_lenb = static_lenb;
          }
        } else {
          // Assert(buf != (char*)0, "lost buf");
          opt_lenb = static_lenb = stored_len + 5; /* force a stored block */
        }
        if (stored_len + 4 <= opt_lenb && buf !== -1) {
          /* 4: two words for the lengths */

          /* The test buf != NULL is only necessary if LIT_BUFSIZE > WSIZE.
           * Otherwise we can't have processed more than WSIZE input bytes since
           * the last block flush, because compression would have been
           * successful. If LIT_BUFSIZE <= WSIZE, it is never too late to
           * transform a block into a stored block.
           */
          _tr_stored_block(s, buf, stored_len, last);
        } else if (s.strategy === Z_FIXED || static_lenb === opt_lenb) {
          send_bits(s, (STATIC_TREES << 1) + (last ? 1 : 0), 3);
          compress_block(s, static_ltree, static_dtree);
        } else {
          send_bits(s, (DYN_TREES << 1) + (last ? 1 : 0), 3);
          send_all_trees(s, s.l_desc.max_code + 1, s.d_desc.max_code + 1, max_blindex + 1);
          compress_block(s, s.dyn_ltree, s.dyn_dtree);
        }
        // Assert (s->compressed_len == s->bits_sent, "bad compressed size");
        /* The above check is made mod 2^32, for files larger than 512 MB
         * and uLong implemented on 32 bits.
         */
        init_block(s);
        if (last) {
          bi_windup(s);
        }
        // Tracev((stderr,"\ncomprlen %lu(%lu) ", s->compressed_len>>3,
        //       s->compressed_len-7*last));
      }

      /* ===========================================================================
       * Save the match info and tally the frequency counts. Return true if
       * the current block must be flushed.
       */
      function _tr_tally(s, dist, lc)
      //    deflate_state *s;
      //    unsigned dist;  /* distance of matched string */
      //    unsigned lc;    /* match length-MIN_MATCH or unmatched char (if dist==0) */
      {
        //var out_length, in_length, dcode;

        s.pending_buf[s.d_buf + s.last_lit * 2] = dist >>> 8 & 0xff;
        s.pending_buf[s.d_buf + s.last_lit * 2 + 1] = dist & 0xff;
        s.pending_buf[s.l_buf + s.last_lit] = lc & 0xff;
        s.last_lit++;
        if (dist === 0) {
          /* lc is the unmatched char */
          s.dyn_ltree[lc * 2] /*.Freq*/++;
        } else {
          s.matches++;
          /* Here, lc is the match length - MIN_MATCH */
          dist--; /* dist = match distance - 1 */
          //Assert((ush)dist < (ush)MAX_DIST(s) &&
          //       (ush)lc <= (ush)(MAX_MATCH-MIN_MATCH) &&
          //       (ush)d_code(dist) < (ush)D_CODES,  "_tr_tally: bad match");

          s.dyn_ltree[(_length_code[lc] + LITERALS + 1) * 2] /*.Freq*/++;
          s.dyn_dtree[d_code(dist) * 2] /*.Freq*/++;
        }

        // (!) This block is disabled in zlib defailts,
        // don't enable it for binary compatibility

        //#ifdef TRUNCATE_BLOCK
        //  /* Try to guess if it is profitable to stop the current block here */
        //  if ((s.last_lit & 0x1fff) === 0 && s.level > 2) {
        //    /* Compute an upper bound for the compressed length */
        //    out_length = s.last_lit*8;
        //    in_length = s.strstart - s.block_start;
        //
        //    for (dcode = 0; dcode < D_CODES; dcode++) {
        //      out_length += s.dyn_dtree[dcode*2]/*.Freq*/ * (5 + extra_dbits[dcode]);
        //    }
        //    out_length >>>= 3;
        //    //Tracev((stderr,"\nlast_lit %u, in %ld, out ~%ld(%ld%%) ",
        //    //       s->last_lit, in_length, out_length,
        //    //       100L - out_length*100L/in_length));
        //    if (s.matches < (s.last_lit>>1)/*int /2*/ && out_length < (in_length>>1)/*int /2*/) {
        //      return true;
        //    }
        //  }
        //#endif

        return s.last_lit === s.lit_bufsize - 1;
        /* We avoid equality with lit_bufsize because of wraparound at 64K
         * on 16 bit machines and because stored blocks are restricted to
         * 64K-1 bytes.
         */
      }
      exports._tr_init = _tr_init;
      exports._tr_stored_block = _tr_stored_block;
      exports._tr_flush_block = _tr_flush_block;
      exports._tr_tally = _tr_tally;
      exports._tr_align = _tr_align;
    }, {
      "../utils/common": 41
    }],
    53: [function (require, module, exports) {
      'use strict';

      // (C) 1995-2013 Jean-loup Gailly and Mark Adler
      // (C) 2014-2017 Vitaly Puzrin and Andrey Tupitsin
      //
      // This software is provided 'as-is', without any express or implied
      // warranty. In no event will the authors be held liable for any damages
      // arising from the use of this software.
      //
      // Permission is granted to anyone to use this software for any purpose,
      // including commercial applications, and to alter it and redistribute it
      // freely, subject to the following restrictions:
      //
      // 1. The origin of this software must not be misrepresented; you must not
      //   claim that you wrote the original software. If you use this software
      //   in a product, an acknowledgment in the product documentation would be
      //   appreciated but is not required.
      // 2. Altered source versions must be plainly marked as such, and must not be
      //   misrepresented as being the original software.
      // 3. This notice may not be removed or altered from any source distribution.
      function ZStream() {
        /* next input byte */
        this.input = null; // JS specific, because we have no pointers
        this.next_in = 0;
        /* number of bytes available at input */
        this.avail_in = 0;
        /* total number of input bytes read so far */
        this.total_in = 0;
        /* next output byte should be put there */
        this.output = null; // JS specific, because we have no pointers
        this.next_out = 0;
        /* remaining free space at output */
        this.avail_out = 0;
        /* total number of bytes output so far */
        this.total_out = 0;
        /* last error message, NULL if no error */
        this.msg = '' /*Z_NULL*/;
        /* not visible by applications */
        this.state = null;
        /* best guess about the data type: binary or text */
        this.data_type = 2 /*Z_UNKNOWN*/;
        /* adler32 value of the uncompressed data */
        this.adler = 0;
      }
      module.exports = ZStream;
    }, {}],
    54: [function (require, module, exports) {
      (function (global) {
        (function (global, undefined) {
          "use strict";

          if (global.setImmediate) {
            return;
          }
          var nextHandle = 1; // Spec says greater than zero
          var tasksByHandle = {};
          var currentlyRunningATask = false;
          var doc = global.document;
          var registerImmediate;
          function setImmediate(callback) {
            // Callback can either be a function or a string
            if (typeof callback !== "function") {
              callback = new Function("" + callback);
            }
            // Copy function arguments
            var args = new Array(arguments.length - 1);
            for (var i = 0; i < args.length; i++) {
              args[i] = arguments[i + 1];
            }
            // Store and register the task
            var task = {
              callback: callback,
              args: args
            };
            tasksByHandle[nextHandle] = task;
            registerImmediate(nextHandle);
            return nextHandle++;
          }
          function clearImmediate(handle) {
            delete tasksByHandle[handle];
          }
          function run(task) {
            var callback = task.callback;
            var args = task.args;
            switch (args.length) {
              case 0:
                callback();
                break;
              case 1:
                callback(args[0]);
                break;
              case 2:
                callback(args[0], args[1]);
                break;
              case 3:
                callback(args[0], args[1], args[2]);
                break;
              default:
                callback.apply(undefined, args);
                break;
            }
          }
          function runIfPresent(handle) {
            // From the spec: "Wait until any invocations of this algorithm started before this one have completed."
            // So if we're currently running a task, we'll need to delay this invocation.
            if (currentlyRunningATask) {
              // Delay by doing a setTimeout. setImmediate was tried instead, but in Firefox 7 it generated a
              // "too much recursion" error.
              setTimeout(runIfPresent, 0, handle);
            } else {
              var task = tasksByHandle[handle];
              if (task) {
                currentlyRunningATask = true;
                try {
                  run(task);
                } finally {
                  clearImmediate(handle);
                  currentlyRunningATask = false;
                }
              }
            }
          }
          function installNextTickImplementation() {
            registerImmediate = function registerImmediate(handle) {
              process.nextTick(function () {
                runIfPresent(handle);
              });
            };
          }
          function canUsePostMessage() {
            // The test against `importScripts` prevents this implementation from being installed inside a web worker,
            // where `global.postMessage` means something completely different and can't be used for this purpose.
            if (global.postMessage && !global.importScripts) {
              var postMessageIsAsynchronous = true;
              var oldOnMessage = global.onmessage;
              global.onmessage = function () {
                postMessageIsAsynchronous = false;
              };
              global.postMessage("", "*");
              global.onmessage = oldOnMessage;
              return postMessageIsAsynchronous;
            }
          }
          function installPostMessageImplementation() {
            // Installs an event handler on `global` for the `message` event: see
            // * https://developer.mozilla.org/en/DOM/window.postMessage
            // * http://www.whatwg.org/specs/web-apps/current-work/multipage/comms.html#crossDocumentMessages

            var messagePrefix = "setImmediate$" + Math.random() + "$";
            var onGlobalMessage = function onGlobalMessage(event) {
              if (event.source === global && typeof event.data === "string" && event.data.indexOf(messagePrefix) === 0) {
                runIfPresent(+event.data.slice(messagePrefix.length));
              }
            };
            if (global.addEventListener) {
              global.addEventListener("message", onGlobalMessage, false);
            } else {
              global.attachEvent("onmessage", onGlobalMessage);
            }
            registerImmediate = function registerImmediate(handle) {
              global.postMessage(messagePrefix + handle, "*");
            };
          }
          function installMessageChannelImplementation() {
            var channel = new MessageChannel();
            channel.port1.onmessage = function (event) {
              var handle = event.data;
              runIfPresent(handle);
            };
            registerImmediate = function registerImmediate(handle) {
              channel.port2.postMessage(handle);
            };
          }
          function installReadyStateChangeImplementation() {
            var html = doc.documentElement;
            registerImmediate = function registerImmediate(handle) {
              // Create a <script> element; its readystatechange event will be fired asynchronously once it is inserted
              // into the document. Do so, thus queuing up the task. Remember to clean up once it's been called.
              var script = doc.createElement("script");
              script.onreadystatechange = function () {
                runIfPresent(handle);
                script.onreadystatechange = null;
                html.removeChild(script);
                script = null;
              };
              html.appendChild(script);
            };
          }
          function installSetTimeoutImplementation() {
            registerImmediate = function registerImmediate(handle) {
              setTimeout(runIfPresent, 0, handle);
            };
          }

          // If supported, we should attach to the prototype of global, since that is where setTimeout et al. live.
          var attachTo = Object.getPrototypeOf && Object.getPrototypeOf(global);
          attachTo = attachTo && attachTo.setTimeout ? attachTo : global;

          // Don't get fooled by e.g. browserify environments.
          if ({}.toString.call(global.process) === "[object process]") {
            // For Node.js before 0.9
            installNextTickImplementation();
          } else if (canUsePostMessage()) {
            // For non-IE10 modern browsers
            installPostMessageImplementation();
          } else if (global.MessageChannel) {
            // For web workers, where supported
            installMessageChannelImplementation();
          } else if (doc && "onreadystatechange" in doc.createElement("script")) {
            // For IE 6–8
            installReadyStateChangeImplementation();
          } else {
            // For older browsers
            installSetTimeoutImplementation();
          }
          attachTo.setImmediate = setImmediate;
          attachTo.clearImmediate = clearImmediate;
        })(typeof self === "undefined" ? typeof global === "undefined" ? this : global : self);
      }).call(this, typeof global !== "undefined" ? global : typeof self !== "undefined" ? self : typeof window !== "undefined" ? window : {});
    }, {}]
  }, {}, [10])(10);
});
/*!
 * @overview es6-promise - a tiny implementation of Promises/A+.
 * @copyright Copyright (c) 2014 Yehuda Katz, Tom Dale, Stefan Penner and contributors (Conversion to ES6 API by Jake Archibald)
 * @license   Licensed under MIT license
 *            See https://raw.githubusercontent.com/stefanpenner/es6-promise/master/LICENSE
 * @version   v4.2.4+314e4831
 */

(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.ES6Promise = factory();
})(this, function () {
  'use strict';

  function objectOrFunction(x) {
    var type = _typeof(x);
    return x !== null && (type === 'object' || type === 'function');
  }
  function isFunction(x) {
    return typeof x === 'function';
  }
  var _isArray = void 0;
  if (Array.isArray) {
    _isArray = Array.isArray;
  } else {
    _isArray = function _isArray(x) {
      return Object.prototype.toString.call(x) === '[object Array]';
    };
  }
  var isArray = _isArray;
  var len = 0;
  var vertxNext = void 0;
  var customSchedulerFn = void 0;
  var asap = function asap(callback, arg) {
    queue[len] = callback;
    queue[len + 1] = arg;
    len += 2;
    if (len === 2) {
      // If len is 2, that means that we need to schedule an async flush.
      // If additional callbacks are queued before the queue is flushed, they
      // will be processed by this flush that we are scheduling.
      if (customSchedulerFn) {
        customSchedulerFn(flush);
      } else {
        scheduleFlush();
      }
    }
  };
  function setScheduler(scheduleFn) {
    customSchedulerFn = scheduleFn;
  }
  function setAsap(asapFn) {
    asap = asapFn;
  }
  var browserWindow = typeof window !== 'undefined' ? window : undefined;
  var browserGlobal = browserWindow || {};
  var BrowserMutationObserver = browserGlobal.MutationObserver || browserGlobal.WebKitMutationObserver;
  var isNode = typeof self === 'undefined' && typeof process !== 'undefined' && {}.toString.call(process) === '[object process]';

  // test for web worker but not in IE10
  var isWorker = typeof Uint8ClampedArray !== 'undefined' && typeof importScripts !== 'undefined' && typeof MessageChannel !== 'undefined';

  // node
  function useNextTick() {
    // node version 0.10.x displays a deprecation warning when nextTick is used recursively
    // see https://github.com/cujojs/when/issues/410 for details
    return function () {
      return process.nextTick(flush);
    };
  }

  // vertx
  function useVertxTimer() {
    if (typeof vertxNext !== 'undefined') {
      return function () {
        vertxNext(flush);
      };
    }
    return useSetTimeout();
  }
  function useMutationObserver() {
    var iterations = 0;
    var observer = new BrowserMutationObserver(flush);
    var node = document.createTextNode('');
    observer.observe(node, {
      characterData: true
    });
    return function () {
      node.data = iterations = ++iterations % 2;
    };
  }

  // web worker
  function useMessageChannel() {
    var channel = new MessageChannel();
    channel.port1.onmessage = flush;
    return function () {
      return channel.port2.postMessage(0);
    };
  }
  function useSetTimeout() {
    // Store setTimeout reference so es6-promise will be unaffected by
    // other code modifying setTimeout (like sinon.useFakeTimers())
    var globalSetTimeout = setTimeout;
    return function () {
      return globalSetTimeout(flush, 1);
    };
  }
  var queue = new Array(1000);
  function flush() {
    for (var i = 0; i < len; i += 2) {
      var callback = queue[i];
      var arg = queue[i + 1];
      callback(arg);
      queue[i] = undefined;
      queue[i + 1] = undefined;
    }
    len = 0;
  }
  function attemptVertx() {
    try {
      var vertx = Function('return this')().require('vertx');
      vertxNext = vertx.runOnLoop || vertx.runOnContext;
      return useVertxTimer();
    } catch (e) {
      return useSetTimeout();
    }
  }
  var scheduleFlush = void 0;
  // Decide what async method to use to triggering processing of queued callbacks:
  if (isNode) {
    scheduleFlush = useNextTick();
  } else if (BrowserMutationObserver) {
    scheduleFlush = useMutationObserver();
  } else if (isWorker) {
    scheduleFlush = useMessageChannel();
  } else if (browserWindow === undefined && typeof require === 'function') {
    scheduleFlush = attemptVertx();
  } else {
    scheduleFlush = useSetTimeout();
  }
  function then(onFulfillment, onRejection) {
    var parent = this;
    var child = new this.constructor(noop);
    if (child[PROMISE_ID] === undefined) {
      makePromise(child);
    }
    var _state = parent._state;
    if (_state) {
      var callback = arguments[_state - 1];
      asap(function () {
        return invokeCallback(_state, child, callback, parent._result);
      });
    } else {
      subscribe(parent, child, onFulfillment, onRejection);
    }
    return child;
  }

  /**
    `Promise.resolve` returns a promise that will become resolved with the
    passed `value`. It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      resolve(1);
    });
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.resolve(1);
  
    promise.then(function(value){
      // value === 1
    });
    ```
  
    @method resolve
    @static
    @param {Any} value value that the returned promise will be resolved with
    Useful for tooling.
    @return {Promise} a promise that will become fulfilled with the given
    `value`
  */
  function resolve$1(object) {
    /*jshint validthis:true */
    var Constructor = this;
    if (object && _typeof(object) === 'object' && object.constructor === Constructor) {
      return object;
    }
    var promise = new Constructor(noop);
    resolve(promise, object);
    return promise;
  }
  var PROMISE_ID = Math.random().toString(36).substring(2);
  function noop() {}
  var PENDING = void 0;
  var FULFILLED = 1;
  var REJECTED = 2;
  var TRY_CATCH_ERROR = {
    error: null
  };
  function selfFulfillment() {
    return new TypeError("You cannot resolve a promise with itself");
  }
  function cannotReturnOwn() {
    return new TypeError('A promises callback cannot return that same promise.');
  }
  function getThen(promise) {
    try {
      return promise.then;
    } catch (error) {
      TRY_CATCH_ERROR.error = error;
      return TRY_CATCH_ERROR;
    }
  }
  function tryThen(then$$1, value, fulfillmentHandler, rejectionHandler) {
    try {
      then$$1.call(value, fulfillmentHandler, rejectionHandler);
    } catch (e) {
      return e;
    }
  }
  function handleForeignThenable(promise, thenable, then$$1) {
    asap(function (promise) {
      var sealed = false;
      var error = tryThen(then$$1, thenable, function (value) {
        if (sealed) {
          return;
        }
        sealed = true;
        if (thenable !== value) {
          resolve(promise, value);
        } else {
          fulfill(promise, value);
        }
      }, function (reason) {
        if (sealed) {
          return;
        }
        sealed = true;
        reject(promise, reason);
      }, 'Settle: ' + (promise._label || ' unknown promise'));
      if (!sealed && error) {
        sealed = true;
        reject(promise, error);
      }
    }, promise);
  }
  function handleOwnThenable(promise, thenable) {
    if (thenable._state === FULFILLED) {
      fulfill(promise, thenable._result);
    } else if (thenable._state === REJECTED) {
      reject(promise, thenable._result);
    } else {
      subscribe(thenable, undefined, function (value) {
        return resolve(promise, value);
      }, function (reason) {
        return reject(promise, reason);
      });
    }
  }
  function handleMaybeThenable(promise, maybeThenable, then$$1) {
    if (maybeThenable.constructor === promise.constructor && then$$1 === then && maybeThenable.constructor.resolve === resolve$1) {
      handleOwnThenable(promise, maybeThenable);
    } else {
      if (then$$1 === TRY_CATCH_ERROR) {
        reject(promise, TRY_CATCH_ERROR.error);
        TRY_CATCH_ERROR.error = null;
      } else if (then$$1 === undefined) {
        fulfill(promise, maybeThenable);
      } else if (isFunction(then$$1)) {
        handleForeignThenable(promise, maybeThenable, then$$1);
      } else {
        fulfill(promise, maybeThenable);
      }
    }
  }
  function resolve(promise, value) {
    if (promise === value) {
      reject(promise, selfFulfillment());
    } else if (objectOrFunction(value)) {
      handleMaybeThenable(promise, value, getThen(value));
    } else {
      fulfill(promise, value);
    }
  }
  function publishRejection(promise) {
    if (promise._onerror) {
      promise._onerror(promise._result);
    }
    publish(promise);
  }
  function fulfill(promise, value) {
    if (promise._state !== PENDING) {
      return;
    }
    promise._result = value;
    promise._state = FULFILLED;
    if (promise._subscribers.length !== 0) {
      asap(publish, promise);
    }
  }
  function reject(promise, reason) {
    if (promise._state !== PENDING) {
      return;
    }
    promise._state = REJECTED;
    promise._result = reason;
    asap(publishRejection, promise);
  }
  function subscribe(parent, child, onFulfillment, onRejection) {
    var _subscribers = parent._subscribers;
    var length = _subscribers.length;
    parent._onerror = null;
    _subscribers[length] = child;
    _subscribers[length + FULFILLED] = onFulfillment;
    _subscribers[length + REJECTED] = onRejection;
    if (length === 0 && parent._state) {
      asap(publish, parent);
    }
  }
  function publish(promise) {
    var subscribers = promise._subscribers;
    var settled = promise._state;
    if (subscribers.length === 0) {
      return;
    }
    var child = void 0,
      callback = void 0,
      detail = promise._result;
    for (var i = 0; i < subscribers.length; i += 3) {
      child = subscribers[i];
      callback = subscribers[i + settled];
      if (child) {
        invokeCallback(settled, child, callback, detail);
      } else {
        callback(detail);
      }
    }
    promise._subscribers.length = 0;
  }
  function tryCatch(callback, detail) {
    try {
      return callback(detail);
    } catch (e) {
      TRY_CATCH_ERROR.error = e;
      return TRY_CATCH_ERROR;
    }
  }
  function invokeCallback(settled, promise, callback, detail) {
    var hasCallback = isFunction(callback),
      value = void 0,
      error = void 0,
      succeeded = void 0,
      failed = void 0;
    if (hasCallback) {
      value = tryCatch(callback, detail);
      if (value === TRY_CATCH_ERROR) {
        failed = true;
        error = value.error;
        value.error = null;
      } else {
        succeeded = true;
      }
      if (promise === value) {
        reject(promise, cannotReturnOwn());
        return;
      }
    } else {
      value = detail;
      succeeded = true;
    }
    if (promise._state !== PENDING) {
      // noop
    } else if (hasCallback && succeeded) {
      resolve(promise, value);
    } else if (failed) {
      reject(promise, error);
    } else if (settled === FULFILLED) {
      fulfill(promise, value);
    } else if (settled === REJECTED) {
      reject(promise, value);
    }
  }
  function initializePromise(promise, resolver) {
    try {
      resolver(function resolvePromise(value) {
        resolve(promise, value);
      }, function rejectPromise(reason) {
        reject(promise, reason);
      });
    } catch (e) {
      reject(promise, e);
    }
  }
  var id = 0;
  function nextId() {
    return id++;
  }
  function makePromise(promise) {
    promise[PROMISE_ID] = id++;
    promise._state = undefined;
    promise._result = undefined;
    promise._subscribers = [];
  }
  function validationError() {
    return new Error('Array Methods must be provided an Array');
  }
  var Enumerator = function () {
    function Enumerator(Constructor, input) {
      this._instanceConstructor = Constructor;
      this.promise = new Constructor(noop);
      if (!this.promise[PROMISE_ID]) {
        makePromise(this.promise);
      }
      if (isArray(input)) {
        this.length = input.length;
        this._remaining = input.length;
        this._result = new Array(this.length);
        if (this.length === 0) {
          fulfill(this.promise, this._result);
        } else {
          this.length = this.length || 0;
          this._enumerate(input);
          if (this._remaining === 0) {
            fulfill(this.promise, this._result);
          }
        }
      } else {
        reject(this.promise, validationError());
      }
    }
    Enumerator.prototype._enumerate = function _enumerate(input) {
      for (var i = 0; this._state === PENDING && i < input.length; i++) {
        this._eachEntry(input[i], i);
      }
    };
    Enumerator.prototype._eachEntry = function _eachEntry(entry, i) {
      var c = this._instanceConstructor;
      var resolve$$1 = c.resolve;
      if (resolve$$1 === resolve$1) {
        var _then = getThen(entry);
        if (_then === then && entry._state !== PENDING) {
          this._settledAt(entry._state, i, entry._result);
        } else if (typeof _then !== 'function') {
          this._remaining--;
          this._result[i] = entry;
        } else if (c === Promise$1) {
          var promise = new c(noop);
          handleMaybeThenable(promise, entry, _then);
          this._willSettleAt(promise, i);
        } else {
          this._willSettleAt(new c(function (resolve$$1) {
            return resolve$$1(entry);
          }), i);
        }
      } else {
        this._willSettleAt(resolve$$1(entry), i);
      }
    };
    Enumerator.prototype._settledAt = function _settledAt(state, i, value) {
      var promise = this.promise;
      if (promise._state === PENDING) {
        this._remaining--;
        if (state === REJECTED) {
          reject(promise, value);
        } else {
          this._result[i] = value;
        }
      }
      if (this._remaining === 0) {
        fulfill(promise, this._result);
      }
    };
    Enumerator.prototype._willSettleAt = function _willSettleAt(promise, i) {
      var enumerator = this;
      subscribe(promise, undefined, function (value) {
        return enumerator._settledAt(FULFILLED, i, value);
      }, function (reason) {
        return enumerator._settledAt(REJECTED, i, reason);
      });
    };
    return Enumerator;
  }();

  /**
    `Promise.all` accepts an array of promises, and returns a new promise which
    is fulfilled with an array of fulfillment values for the passed promises, or
    rejected with the reason of the first passed promise to be rejected. It casts all
    elements of the passed iterable to promises as it runs this algorithm.
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = resolve(2);
    let promise3 = resolve(3);
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // The array here would be [ 1, 2, 3 ];
    });
    ```
  
    If any of the `promises` given to `all` are rejected, the first promise
    that is rejected will be given as an argument to the returned promises's
    rejection handler. For example:
  
    Example:
  
    ```javascript
    let promise1 = resolve(1);
    let promise2 = reject(new Error("2"));
    let promise3 = reject(new Error("3"));
    let promises = [ promise1, promise2, promise3 ];
  
    Promise.all(promises).then(function(array){
      // Code here never runs because there are rejected promises!
    }, function(error) {
      // error.message === "2"
    });
    ```
  
    @method all
    @static
    @param {Array} entries array of promises
    @param {String} label optional string for labeling the promise.
    Useful for tooling.
    @return {Promise} promise that is fulfilled when all `promises` have been
    fulfilled, or rejected if any of them become rejected.
    @static
  */
  function all(entries) {
    return new Enumerator(this, entries).promise;
  }

  /**
    `Promise.race` returns a new promise which is settled in the same way as the
    first passed promise to settle.
  
    Example:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 2');
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // result === 'promise 2' because it was resolved before promise1
      // was resolved.
    });
    ```
  
    `Promise.race` is deterministic in that only the state of the first
    settled promise matters. For example, even if other promises given to the
    `promises` array argument are resolved, but the first settled promise has
    become rejected before the other promises became fulfilled, the returned
    promise will become rejected:
  
    ```javascript
    let promise1 = new Promise(function(resolve, reject){
      setTimeout(function(){
        resolve('promise 1');
      }, 200);
    });
  
    let promise2 = new Promise(function(resolve, reject){
      setTimeout(function(){
        reject(new Error('promise 2'));
      }, 100);
    });
  
    Promise.race([promise1, promise2]).then(function(result){
      // Code here never runs
    }, function(reason){
      // reason.message === 'promise 2' because promise 2 became rejected before
      // promise 1 became fulfilled
    });
    ```
  
    An example real-world use case is implementing timeouts:
  
    ```javascript
    Promise.race([ajax('foo.json'), timeout(5000)])
    ```
  
    @method race
    @static
    @param {Array} promises array of promises to observe
    Useful for tooling.
    @return {Promise} a promise which settles in the same way as the first passed
    promise to settle.
  */
  function race(entries) {
    /*jshint validthis:true */
    var Constructor = this;
    if (!isArray(entries)) {
      return new Constructor(function (_, reject) {
        return reject(new TypeError('You must pass an array to race.'));
      });
    } else {
      return new Constructor(function (resolve, reject) {
        var length = entries.length;
        for (var i = 0; i < length; i++) {
          Constructor.resolve(entries[i]).then(resolve, reject);
        }
      });
    }
  }

  /**
    `Promise.reject` returns a promise rejected with the passed `reason`.
    It is shorthand for the following:
  
    ```javascript
    let promise = new Promise(function(resolve, reject){
      reject(new Error('WHOOPS'));
    });
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    Instead of writing the above, your code now simply becomes the following:
  
    ```javascript
    let promise = Promise.reject(new Error('WHOOPS'));
  
    promise.then(function(value){
      // Code here doesn't run because the promise is rejected!
    }, function(reason){
      // reason.message === 'WHOOPS'
    });
    ```
  
    @method reject
    @static
    @param {Any} reason value that the returned promise will be rejected with.
    Useful for tooling.
    @return {Promise} a promise rejected with the given `reason`.
  */
  function reject$1(reason) {
    /*jshint validthis:true */
    var Constructor = this;
    var promise = new Constructor(noop);
    reject(promise, reason);
    return promise;
  }
  function needsResolver() {
    throw new TypeError('You must pass a resolver function as the first argument to the promise constructor');
  }
  function needsNew() {
    throw new TypeError("Failed to construct 'Promise': Please use the 'new' operator, this object constructor cannot be called as a function.");
  }

  /**
    Promise objects represent the eventual result of an asynchronous operation. The
    primary way of interacting with a promise is through its `then` method, which
    registers callbacks to receive either a promise's eventual value or the reason
    why the promise cannot be fulfilled.
  
    Terminology
    -----------
  
    - `promise` is an object or function with a `then` method whose behavior conforms to this specification.
    - `thenable` is an object or function that defines a `then` method.
    - `value` is any legal JavaScript value (including undefined, a thenable, or a promise).
    - `exception` is a value that is thrown using the throw statement.
    - `reason` is a value that indicates why a promise was rejected.
    - `settled` the final resting state of a promise, fulfilled or rejected.
  
    A promise can be in one of three states: pending, fulfilled, or rejected.
  
    Promises that are fulfilled have a fulfillment value and are in the fulfilled
    state.  Promises that are rejected have a rejection reason and are in the
    rejected state.  A fulfillment value is never a thenable.
  
    Promises can also be said to *resolve* a value.  If this value is also a
    promise, then the original promise's settled state will match the value's
    settled state.  So a promise that *resolves* a promise that rejects will
    itself reject, and a promise that *resolves* a promise that fulfills will
    itself fulfill.
  
  
    Basic Usage:
    ------------
  
    ```js
    let promise = new Promise(function(resolve, reject) {
      // on success
      resolve(value);
  
      // on failure
      reject(reason);
    });
  
    promise.then(function(value) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Advanced Usage:
    ---------------
  
    Promises shine when abstracting away asynchronous interactions such as
    `XMLHttpRequest`s.
  
    ```js
    function getJSON(url) {
      return new Promise(function(resolve, reject){
        let xhr = new XMLHttpRequest();
  
        xhr.open('GET', url);
        xhr.onreadystatechange = handler;
        xhr.responseType = 'json';
        xhr.setRequestHeader('Accept', 'application/json');
        xhr.send();
  
        function handler() {
          if (this.readyState === this.DONE) {
            if (this.status === 200) {
              resolve(this.response);
            } else {
              reject(new Error('getJSON: `' + url + '` failed with status: [' + this.status + ']'));
            }
          }
        };
      });
    }
  
    getJSON('/posts.json').then(function(json) {
      // on fulfillment
    }, function(reason) {
      // on rejection
    });
    ```
  
    Unlike callbacks, promises are great composable primitives.
  
    ```js
    Promise.all([
      getJSON('/posts'),
      getJSON('/comments')
    ]).then(function(values){
      values[0] // => postsJSON
      values[1] // => commentsJSON
  
      return values;
    });
    ```
  
    @class Promise
    @param {Function} resolver
    Useful for tooling.
    @constructor
  */

  var Promise$1 = function () {
    function Promise(resolver) {
      this[PROMISE_ID] = nextId();
      this._result = this._state = undefined;
      this._subscribers = [];
      if (noop !== resolver) {
        typeof resolver !== 'function' && needsResolver();
        this instanceof Promise ? initializePromise(this, resolver) : needsNew();
      }
    }

    /**
    The primary way of interacting with a promise is through its `then` method,
    which registers callbacks to receive either a promise's eventual value or the
    reason why the promise cannot be fulfilled.
     ```js
    findUser().then(function(user){
      // user is available
    }, function(reason){
      // user is unavailable, and you are given the reason why
    });
    ```
     Chaining
    --------
     The return value of `then` is itself a promise.  This second, 'downstream'
    promise is resolved with the return value of the first promise's fulfillment
    or rejection handler, or rejected if the handler throws an exception.
     ```js
    findUser().then(function (user) {
      return user.name;
    }, function (reason) {
      return 'default name';
    }).then(function (userName) {
      // If `findUser` fulfilled, `userName` will be the user's name, otherwise it
      // will be `'default name'`
    });
     findUser().then(function (user) {
      throw new Error('Found user, but still unhappy');
    }, function (reason) {
      throw new Error('`findUser` rejected and we're unhappy');
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // if `findUser` fulfilled, `reason` will be 'Found user, but still unhappy'.
      // If `findUser` rejected, `reason` will be '`findUser` rejected and we're unhappy'.
    });
    ```
    If the downstream promise does not specify a rejection handler, rejection reasons will be propagated further downstream.
     ```js
    findUser().then(function (user) {
      throw new PedagogicalException('Upstream error');
    }).then(function (value) {
      // never reached
    }).then(function (value) {
      // never reached
    }, function (reason) {
      // The `PedgagocialException` is propagated all the way down to here
    });
    ```
     Assimilation
    ------------
     Sometimes the value you want to propagate to a downstream promise can only be
    retrieved asynchronously. This can be achieved by returning a promise in the
    fulfillment or rejection handler. The downstream promise will then be pending
    until the returned promise is settled. This is called *assimilation*.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // The user's comments are now available
    });
    ```
     If the assimliated promise rejects, then the downstream promise will also reject.
     ```js
    findUser().then(function (user) {
      return findCommentsByAuthor(user);
    }).then(function (comments) {
      // If `findCommentsByAuthor` fulfills, we'll have the value here
    }, function (reason) {
      // If `findCommentsByAuthor` rejects, we'll have the reason here
    });
    ```
     Simple Example
    --------------
     Synchronous Example
     ```javascript
    let result;
     try {
      result = findResult();
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
    findResult(function(result, err){
      if (err) {
        // failure
      } else {
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findResult().then(function(result){
      // success
    }, function(reason){
      // failure
    });
    ```
     Advanced Example
    --------------
     Synchronous Example
     ```javascript
    let author, books;
     try {
      author = findAuthor();
      books  = findBooksByAuthor(author);
      // success
    } catch(reason) {
      // failure
    }
    ```
     Errback Example
     ```js
     function foundBooks(books) {
     }
     function failure(reason) {
     }
     findAuthor(function(author, err){
      if (err) {
        failure(err);
        // failure
      } else {
        try {
          findBoooksByAuthor(author, function(books, err) {
            if (err) {
              failure(err);
            } else {
              try {
                foundBooks(books);
              } catch(reason) {
                failure(reason);
              }
            }
          });
        } catch(error) {
          failure(err);
        }
        // success
      }
    });
    ```
     Promise Example;
     ```javascript
    findAuthor().
      then(findBooksByAuthor).
      then(function(books){
        // found books
    }).catch(function(reason){
      // something went wrong
    });
    ```
     @method then
    @param {Function} onFulfilled
    @param {Function} onRejected
    Useful for tooling.
    @return {Promise}
    */

    /**
    `catch` is simply sugar for `then(undefined, onRejection)` which makes it the same
    as the catch block of a try/catch statement.
    ```js
    function findAuthor(){
    throw new Error('couldn't find that author');
    }
    // synchronous
    try {
    findAuthor();
    } catch(reason) {
    // something went wrong
    }
    // async with promises
    findAuthor().catch(function(reason){
    // something went wrong
    });
    ```
    @method catch
    @param {Function} onRejection
    Useful for tooling.
    @return {Promise}
    */

    Promise.prototype["catch"] = function _catch(onRejection) {
      return this.then(null, onRejection);
    };

    /**
      `finally` will be invoked regardless of the promise's fate just as native
      try/catch/finally behaves
    
      Synchronous example:
    
      ```js
      findAuthor() {
        if (Math.random() > 0.5) {
          throw new Error();
        }
        return new Author();
      }
    
      try {
        return findAuthor(); // succeed or fail
      } catch(error) {
        return findOtherAuther();
      } finally {
        // always runs
        // doesn't affect the return value
      }
      ```
    
      Asynchronous example:
    
      ```js
      findAuthor().catch(function(reason){
        return findOtherAuther();
      }).finally(function(){
        // author was either found, or not
      });
      ```
    
      @method finally
      @param {Function} callback
      @return {Promise}
    */

    Promise.prototype["finally"] = function _finally(callback) {
      var promise = this;
      var constructor = promise.constructor;
      return promise.then(function (value) {
        return constructor.resolve(callback()).then(function () {
          return value;
        });
      }, function (reason) {
        return constructor.resolve(callback()).then(function () {
          throw reason;
        });
      });
    };
    return Promise;
  }();
  Promise$1.prototype.then = then;
  Promise$1.all = all;
  Promise$1.race = race;
  Promise$1.resolve = resolve$1;
  Promise$1.reject = reject$1;
  Promise$1._setScheduler = setScheduler;
  Promise$1._setAsap = setAsap;
  Promise$1._asap = asap;

  /*global self*/
  function polyfill() {
    var local = void 0;
    if (typeof global !== 'undefined') {
      local = global;
    } else if (typeof self !== 'undefined') {
      local = self;
    } else {
      try {
        local = Function('return this')();
      } catch (e) {
        throw new Error('polyfill failed because global object is unavailable in this environment');
      }
    }
    var P = local.Promise;
    if (P) {
      var promiseToString = null;
      try {
        promiseToString = Object.prototype.toString.call(P.resolve());
      } catch (e) {
        // silently ignored
      }
      if (promiseToString === '[object Promise]' && !P.cast) {
        return;
      }
    }
    local.Promise = Promise$1;
  }

  // Strange compat..
  Promise$1.polyfill = polyfill;
  Promise$1.Promise = Promise$1;
  return Promise$1;
});



/*!
 * sweetalert2 v5.3.8
 * Released under the MIT License.
 */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory() : typeof define === 'function' && define.amd ? define(factory) : global.Sweetalert2 = factory();
})(this, function () {
  'use strict';

  var swalPrefix = 'swal2-';
  var prefix = function prefix(items) {
    var result = {};
    for (var i in items) {
      result[items[i]] = swalPrefix + items[i];
    }
    return result;
  };
  var swalClasses = prefix(['container', 'in', 'iosfix', 'modal', 'overlay', 'fade', 'show', 'hide', 'noanimation', 'close', 'content', 'spacer', 'confirm', 'cancel', 'icon', 'image', 'input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea', 'inputerror', 'validationerror', 'progresssteps', 'activeprogressstep', 'progresscircle', 'progressline', 'loading', 'styled']);
  var iconTypes = prefix(['success', 'warning', 'info', 'question', 'error']);
  var defaultParams = {
    title: '',
    text: '',
    html: '',
    type: null,
    customClass: '',
    animation: true,
    allowOutsideClick: true,
    allowEscapeKey: true,
    showConfirmButton: true,
    showCancelButton: false,
    preConfirm: null,
    confirmButtonText: 'OK',
    confirmButtonColor: '#3085d6',
    confirmButtonClass: null,
    cancelButtonText: 'Cancel',
    cancelButtonColor: '#aaa',
    cancelButtonClass: null,
    buttonsStyling: true,
    reverseButtons: false,
    focusCancel: false,
    showCloseButton: false,
    showLoaderOnConfirm: false,
    imageUrl: null,
    imageWidth: null,
    imageHeight: null,
    imageClass: null,
    timer: null,
    width: 500,
    padding: 20,
    background: '#fff',
    input: null,
    inputPlaceholder: '',
    inputValue: '',
    inputOptions: {},
    inputAutoTrim: true,
    inputClass: null,
    inputAttributes: {},
    inputValidator: null,
    progressSteps: [],
    currentProgressStep: null,
    progressStepsDistance: '40px',
    onOpen: null,
    onClose: null
  };
  var sweetHTML = '<div class="' + swalClasses.modal + '" style="display: none" tabIndex="-1">' + '<ul class="' + swalClasses.progresssteps + '"></ul>' + '<div class="' + swalClasses.icon + ' ' + iconTypes.error + '">' + '<span class="x-mark"><span class="line left"></span><span class="line right"></span></span>' + '</div>' + '<div class="' + swalClasses.icon + ' ' + iconTypes.question + '">?</div>' + '<div class="' + swalClasses.icon + ' ' + iconTypes.warning + '">!</div>' + '<div class="' + swalClasses.icon + ' ' + iconTypes.info + '">i</div>' + '<div class="' + swalClasses.icon + ' ' + iconTypes.success + '">' + '<span class="line tip"></span> <span class="line long"></span>' + '<div class="placeholder"></div> <div class="fix"></div>' + '</div>' + '<img class="' + swalClasses.image + '">' + '<h2></h2>' + '<div class="' + swalClasses.content + '"></div>' + '<input class="' + swalClasses.input + '">' + '<input type="file" class="' + swalClasses.file + '">' + '<div class="' + swalClasses.range + '">' + '<output></output>' + '<input type="range">' + '</div>' + '<select class="' + swalClasses.select + '"></select>' + '<div class="' + swalClasses.radio + '"></div>' + '<label for="' + swalClasses.checkbox + '" class="' + swalClasses.checkbox + '">' + '<input type="checkbox">' + '</label>' + '<textarea class="' + swalClasses.textarea + '"></textarea>' + '<div class="' + swalClasses.validationerror + '"></div>' + '<hr class="' + swalClasses.spacer + '">' + '<button type="button" class="' + swalClasses.confirm + '">OK</button>' + '<button type="button" class="' + swalClasses.cancel + '">Cancel</button>' + '<span class="' + swalClasses.close + '">&times;</span>' + '</div>';
  var sweetContainer;
  var existingSweetContainers = document.getElementsByClassName(swalClasses.container);
  if (existingSweetContainers.length) {
    sweetContainer = existingSweetContainers[0];
  } else {
    sweetContainer = document.createElement('div');
    sweetContainer.className = swalClasses.container;
    sweetContainer.innerHTML = sweetHTML;
  }
  var extend = function extend(a, b) {
    for (var key in b) {
      if (b.hasOwnProperty(key)) {
        a[key] = b[key];
      }
    }
    return a;
  };

  /*
   * Set hover, active and focus-states for buttons (source: http://www.sitepoint.com/javascript-generate-lighter-darker-color)
   */
  var colorLuminance = function colorLuminance(hex, lum) {
    // Validate hex string
    hex = String(hex).replace(/[^0-9a-f]/gi, '');
    if (hex.length < 6) {
      hex = hex[0] + hex[0] + hex[1] + hex[1] + hex[2] + hex[2];
    }
    lum = lum || 0;

    // Convert to decimal and change luminosity
    var rgb = '#';
    for (var i = 0; i < 3; i++) {
      var c = parseInt(hex.substr(i * 2, 2), 16);
      c = Math.round(Math.min(Math.max(0, c + c * lum), 255)).toString(16);
      rgb += ('00' + c).substr(c.length);
    }
    return rgb;
  };

  // Remember state in cases where opening and handling a modal will fiddle with it.
  var states = {
    previousWindowKeyDown: null,
    previousActiveElement: null,
    previousBodyPadding: null
  };

  /*
   * Add modal + overlay to DOM
   */
  var init = function init() {
    if (typeof document === 'undefined') {
      console.error('SweetAlert2 requires document to initialize');
      return;
    } else if (document.getElementsByClassName(swalClasses.container).length) {
      return;
    }
    document.body.appendChild(sweetContainer);
    var modal = getModal();
    var input = getChildByClass(modal, swalClasses.input);
    var file = getChildByClass(modal, swalClasses.file);
    var range = modal.querySelector('.' + swalClasses.range + ' input');
    var select = getChildByClass(modal, swalClasses.select);
    var checkbox = modal.querySelector('.' + swalClasses.checkbox + ' input');
    var textarea = getChildByClass(modal, swalClasses.textarea);
    input.oninput = function () {
      sweetAlert.resetValidationError();
    };
    input.onkeydown = function (event) {
      setTimeout(function () {
        if (event.keyCode === 13) {
          event.stopPropagation();
          sweetAlert.clickConfirm();
        }
      }, 0);
    };
    file.onchange = function () {
      sweetAlert.resetValidationError();
    };
    range.oninput = function () {
      sweetAlert.resetValidationError();
      range.previousSibling.value = range.value;
    };
    range.onchange = function () {
      sweetAlert.resetValidationError();
      range.previousSibling.value = range.value;
    };
    select.onchange = function () {
      sweetAlert.resetValidationError();
    };
    checkbox.onchange = function () {
      sweetAlert.resetValidationError();
    };
    textarea.oninput = function () {
      sweetAlert.resetValidationError();
    };
    return modal;
  };

  /*
   * Manipulate DOM
   */
  var elementByClass = function elementByClass(className) {
    return sweetContainer.querySelector('.' + className);
  };
  var getModal = function getModal() {
    return document.body.querySelector('.' + swalClasses.modal) || init();
  };
  var getIcons = function getIcons() {
    var modal = getModal();
    return modal.querySelectorAll('.' + swalClasses.icon);
  };
  var getSpacer = function getSpacer() {
    return elementByClass(swalClasses.spacer);
  };
  var getProgressSteps = function getProgressSteps() {
    return elementByClass(swalClasses.progresssteps);
  };
  var getValidationError = function getValidationError() {
    return elementByClass(swalClasses.validationerror);
  };
  var getConfirmButton = function getConfirmButton() {
    return elementByClass(swalClasses.confirm);
  };
  var getCancelButton = function getCancelButton() {
    return elementByClass(swalClasses.cancel);
  };
  var getCloseButton = function getCloseButton() {
    return elementByClass(swalClasses.close);
  };
  var getFocusableElements = function getFocusableElements(focusCancel) {
    var buttons = [getConfirmButton(), getCancelButton()];
    if (focusCancel) {
      buttons.reverse();
    }
    return buttons.concat(Array.prototype.slice.call(getModal().querySelectorAll('button:not([class^=' + swalPrefix + ']), input:not([type=hidden]), textarea, select')));
  };
  var hasClass = function hasClass(elem, className) {
    return elem.classList.contains(className);
  };
  var focusInput = function focusInput(input) {
    input.focus();

    // place cursor at end of text in text input
    if (input.type !== 'file') {
      // http://stackoverflow.com/a/2345915/1331425
      var val = input.value;
      input.value = '';
      input.value = val;
    }
  };
  var addClass = function addClass(elem, className) {
    if (!elem || !className) {
      return;
    }
    var classes = className.split(/\s+/);
    classes.forEach(function (className) {
      elem.classList.add(className);
    });
  };
  var removeClass = function removeClass(elem, className) {
    if (!elem || !className) {
      return;
    }
    var classes = className.split(/\s+/);
    classes.forEach(function (className) {
      elem.classList.remove(className);
    });
  };
  var getChildByClass = function getChildByClass(elem, className) {
    for (var i = 0; i < elem.childNodes.length; i++) {
      if (hasClass(elem.childNodes[i], className)) {
        return elem.childNodes[i];
      }
    }
  };
  var show = function show(elem, display) {
    if (!display) {
      display = 'block';
    }
    elem.style.opacity = '';
    elem.style.display = display;
  };
  var hide = function hide(elem) {
    elem.style.opacity = '';
    elem.style.display = 'none';
  };
  var empty = function empty(elem) {
    while (elem.firstChild) {
      elem.removeChild(elem.firstChild);
    }
  };

  // borrowed from jqeury $(elem).is(':visible') implementation
  var isVisible = function isVisible(elem) {
    return elem.offsetWidth || elem.offsetHeight || elem.getClientRects().length;
  };
  var removeStyleProperty = function removeStyleProperty(elem, property) {
    if (elem.style.removeProperty) {
      elem.style.removeProperty(property);
    } else {
      elem.style.removeAttribute(property);
    }
  };
  var fireClick = function fireClick(node) {
    // Taken from http://www.nonobtrusive.com/2011/11/29/programatically-fire-crossbrowser-click-event-with-javascript/
    // Then fixed for today's Chrome browser.
    if (typeof MouseEvent === 'function') {
      // Up-to-date approach
      var mevt = new MouseEvent('click', {
        view: window,
        bubbles: false,
        cancelable: true
      });
      node.dispatchEvent(mevt);
    } else if (document.createEvent) {
      // Fallback
      var evt = document.createEvent('MouseEvents');
      evt.initEvent('click', false, false);
      node.dispatchEvent(evt);
    } else if (document.createEventObject) {
      node.fireEvent('onclick');
    } else if (typeof node.onclick === 'function') {
      node.onclick();
    }
  };
  var stopEventPropagation = function stopEventPropagation(e) {
    // In particular, make sure the space bar doesn't scroll the main window.
    if (typeof e.stopPropagation === 'function') {
      e.stopPropagation();
      e.preventDefault();
    } else if (window.event && window.event.hasOwnProperty('cancelBubble')) {
      window.event.cancelBubble = true;
    }
  };
  var animationEndEvent = function () {
    var testEl = document.createElement('div');
    var transEndEventNames = {
      'WebkitAnimation': 'webkitAnimationEnd',
      'OAnimation': 'oAnimationEnd oanimationend',
      'msAnimation': 'MSAnimationEnd',
      'animation': 'animationend'
    };
    for (var i in transEndEventNames) {
      if (transEndEventNames.hasOwnProperty(i) && testEl.style[i] !== undefined) {
        return transEndEventNames[i];
      }
    }
    return false;
  }();

  // Reset the page to its previous state
  var resetPrevState = function resetPrevState() {
    var modal = getModal();
    window.onkeydown = states.previousWindowKeyDown;
    if (states.previousActiveElement && states.previousActiveElement.focus) {
      states.previousActiveElement.focus();
    }
    clearTimeout(modal.timeout);
  };

  // Measure width of scrollbar
  // https://github.com/twbs/bootstrap/blob/master/js/modal.js#L279-L286
  var measureScrollbar = function measureScrollbar() {
    var scrollDiv = document.createElement('div');
    scrollDiv.style.width = '50px';
    scrollDiv.style.height = '50px';
    scrollDiv.style.overflow = 'scroll';
    document.body.appendChild(scrollDiv);
    var scrollbarWidth = scrollDiv.offsetWidth - scrollDiv.clientWidth;
    document.body.removeChild(scrollDiv);
    return scrollbarWidth;
  };

  // JavaScript Debounce Function
  // https://davidwalsh.name/javascript-debounce-function
  var debounce = function debounce(func, wait, immediate) {
    var timeout;
    return function () {
      var context = this;
      var args = arguments;
      var later = function later() {
        timeout = null;
        if (!immediate) func.apply(context, args);
      };
      var callNow = immediate && !timeout;
      clearTimeout(timeout);
      timeout = setTimeout(later, wait);
      if (callNow) func.apply(context, args);
    };
  };
  var modalParams = extend({}, defaultParams);
  var queue = [];
  var swal2Observer;

  /*
   * Set type, text and actions on modal
   */
  var setParameters = function setParameters(params) {
    var modal = getModal();
    for (var param in params) {
      if (!defaultParams.hasOwnProperty(param) && param !== 'extraParams') {
        console.warn('SweetAlert2: Unknown parameter "' + param + '"');
      }
    }

    // set modal width and margin-left
    modal.style.width = typeof params.width === 'number' ? params.width + 'px' : params.width;
    modal.style.padding = params.padding + 'px';
    modal.style.background = params.background;
    var $title = modal.querySelector('h2');
    var $content = modal.querySelector('.' + swalClasses.content);
    var $confirmBtn = getConfirmButton();
    var $cancelBtn = getCancelButton();
    var $closeButton = modal.querySelector('.' + swalClasses.close);

    // Title
    $title.innerHTML = params.title.split('\n').join('<br>');

    // Content
    var i;
    if (params.text || params.html) {
      if (_typeof(params.html) === 'object') {
        $content.innerHTML = '';
        if (0 in params.html) {
          for (i = 0; i in params.html; i++) {
            $content.appendChild(params.html[i].cloneNode(true));
          }
        } else {
          $content.appendChild(params.html.cloneNode(true));
        }
      } else {
        $content.innerHTML = params.html || params.text.split('\n').join('<br>');
      }
      show($content);
    } else {
      hide($content);
    }

    // Close button
    if (params.showCloseButton) {
      show($closeButton);
    } else {
      hide($closeButton);
    }

    // Custom Class
    modal.className = swalClasses.modal;
    if (params.customClass) {
      addClass(modal, params.customClass);
    }

    // Progress steps
    var progressStepsContainer = getProgressSteps();
    var currentProgressStep = parseInt(params.currentProgressStep === null ? sweetAlert.getQueueStep() : params.currentProgressStep, 10);
    if (params.progressSteps.length) {
      show(progressStepsContainer);
      empty(progressStepsContainer);
      if (currentProgressStep >= params.progressSteps.length) {
        console.warn('SweetAlert2: Invalid currentProgressStep parameter, it should be less than progressSteps.length ' + '(currentProgressStep like JS arrays starts from 0)');
      }
      params.progressSteps.forEach(function (step, index) {
        var circle = document.createElement('li');
        addClass(circle, swalClasses.progresscircle);
        circle.innerHTML = step;
        if (index === currentProgressStep) {
          addClass(circle, swalClasses.activeprogressstep);
        }
        progressStepsContainer.appendChild(circle);
        if (index !== params.progressSteps.length - 1) {
          var line = document.createElement('li');
          addClass(line, swalClasses.progressline);
          line.style.width = params.progressStepsDistance;
          progressStepsContainer.appendChild(line);
        }
      });
    } else {
      hide(progressStepsContainer);
    }

    // Icon
    var icons = getIcons();
    for (i = 0; i < icons.length; i++) {
      hide(icons[i]);
    }
    if (params.type) {
      var validType = false;
      for (var iconType in iconTypes) {
        if (params.type === iconType) {
          validType = true;
          break;
        }
      }
      if (!validType) {
        console.error('SweetAlert2: Unknown alert type: ' + params.type);
        return false;
      }
      var $icon = modal.querySelector('.' + swalClasses.icon + '.' + iconTypes[params.type]);
      show($icon);

      // Animate icon
      switch (params.type) {
        case 'success':
          addClass($icon, 'animate');
          addClass($icon.querySelector('.tip'), 'animate-success-tip');
          addClass($icon.querySelector('.long'), 'animate-success-long');
          break;
        case 'error':
          addClass($icon, 'animate-error-icon');
          addClass($icon.querySelector('.x-mark'), 'animate-x-mark');
          break;
        case 'warning':
          addClass($icon, 'pulse-warning');
          break;
        default:
          break;
      }
    }

    // Custom image
    var $customImage = modal.querySelector('.' + swalClasses.image);
    if (params.imageUrl) {
      $customImage.setAttribute('src', params.imageUrl);
      show($customImage);
      if (params.imageWidth) {
        $customImage.setAttribute('width', params.imageWidth);
      } else {
        $customImage.removeAttribute('width');
      }
      if (params.imageHeight) {
        $customImage.setAttribute('height', params.imageHeight);
      } else {
        $customImage.removeAttribute('height');
      }
      $customImage.className = swalClasses.image;
      if (params.imageClass) {
        addClass($customImage, params.imageClass);
      }
    } else {
      hide($customImage);
    }

    // Cancel button
    if (params.showCancelButton) {
      $cancelBtn.style.display = 'inline-block';
    } else {
      hide($cancelBtn);
    }

    // Confirm button
    if (params.showConfirmButton) {
      removeStyleProperty($confirmBtn, 'display');
    } else {
      hide($confirmBtn);
    }

    // Buttons spacer
    var spacer = getSpacer();
    if (!params.showConfirmButton && !params.showCancelButton) {
      hide(spacer);
    } else {
      show(spacer);
    }

    // Edit text on cancel and confirm buttons
    $confirmBtn.innerHTML = params.confirmButtonText;
    $cancelBtn.innerHTML = params.cancelButtonText;

    // Set buttons to selected background colors
    if (params.buttonsStyling) {
      $confirmBtn.style.backgroundColor = params.confirmButtonColor;
      $cancelBtn.style.backgroundColor = params.cancelButtonColor;
    }

    // Add buttons custom classes
    $confirmBtn.className = swalClasses.confirm;
    addClass($confirmBtn, params.confirmButtonClass);
    $cancelBtn.className = swalClasses.cancel;
    addClass($cancelBtn, params.cancelButtonClass);

    // Buttons styling
    if (params.buttonsStyling) {
      addClass($confirmBtn, swalClasses.styled);
      addClass($cancelBtn, swalClasses.styled);
    } else {
      removeClass($confirmBtn, swalClasses.styled);
      removeClass($cancelBtn, swalClasses.styled);
      $confirmBtn.style.backgroundColor = $confirmBtn.style.borderLeftColor = $confirmBtn.style.borderRightColor = '';
      $cancelBtn.style.backgroundColor = $cancelBtn.style.borderLeftColor = $cancelBtn.style.borderRightColor = '';
    }

    // CSS animation
    if (params.animation === true) {
      removeClass(modal, swalClasses.noanimation);
    } else {
      addClass(modal, swalClasses.noanimation);
    }
  };

  /*
   * Animations
   */
  var openModal = function openModal(animation, onComplete) {
    var modal = getModal();
    if (animation) {
      addClass(modal, swalClasses.show);
      addClass(sweetContainer, swalClasses.fade);
      removeClass(modal, swalClasses.hide);
    } else {
      removeClass(modal, swalClasses.fade);
    }
    show(modal);

    // scrolling is 'hidden' until animation is done, after that 'auto'
    sweetContainer.style.overflowY = 'hidden';
    if (animationEndEvent && !hasClass(modal, swalClasses.noanimation)) {
      modal.addEventListener(animationEndEvent, function swalCloseEventFinished() {
        modal.removeEventListener(animationEndEvent, swalCloseEventFinished);
        sweetContainer.style.overflowY = 'auto';
      });
    } else {
      sweetContainer.style.overflowY = 'auto';
    }
    addClass(sweetContainer, swalClasses["in"]);
    addClass(document.body, swalClasses["in"]);
    fixScrollbar();
    iOSfix();
    states.previousActiveElement = document.activeElement;
    if (onComplete !== null && typeof onComplete === 'function') {
      onComplete.call(this, modal);
    }
  };
  function fixScrollbar() {
    // for queues, do not do this more than once
    if (states.previousBodyPadding !== null) {
      return;
    }
    // if the body has overflow
    if (document.body.scrollHeight > window.innerHeight) {
      // add padding so the content doesn't shift after removal of scrollbar
      states.previousBodyPadding = document.body.style.paddingRight;
      document.body.style.paddingRight = measureScrollbar() + 'px';
    }
  }
  function undoScrollbar() {
    if (states.previousBodyPadding !== null) {
      document.body.style.paddingRight = states.previousBodyPadding;
      states.previousBodyPadding = null;
    }
  }

  // Fix iOS scrolling http://stackoverflow.com/q/39626302/1331425
  function iOSfix() {
    var iOS = /iPad|iPhone|iPod/.test(navigator.userAgent) && !window.MSStream;
    if (iOS && !hasClass(document.body, swalClasses.iosfix)) {
      var offset = document.body.scrollTop;
      document.body.style.top = offset * -1 + 'px';
      addClass(document.body, swalClasses.iosfix);
    }
  }
  function undoIOSfix() {
    if (hasClass(document.body, swalClasses.iosfix)) {
      var offset = parseInt(document.body.style.top, 10);
      removeClass(document.body, swalClasses.iosfix);
      document.body.scrollTop = offset * -1;
    }
  }
  function modalDependant() {
    if (arguments[0] === undefined) {
      console.error('SweetAlert2 expects at least 1 attribute!');
      return false;
    }
    var params = extend({}, modalParams);
    switch (_typeof(arguments[0])) {
      case 'string':
        params.title = arguments[0];
        params.text = arguments[1] || '';
        params.type = arguments[2] || '';
        break;
      case 'object':
        extend(params, arguments[0]);
        params.extraParams = arguments[0].extraParams;
        if (params.input === 'email' && params.inputValidator === null) {
          params.inputValidator = function (email) {
            return new Promise(function (resolve, reject) {
              var emailRegex = /^[a-zA-Z0-9._-]+@[a-zA-Z0-9.-]+\.[a-zA-Z]{2,6}$/;
              if (emailRegex.test(email)) {
                resolve();
              } else {
                reject('Invalid email address');
              }
            });
          };
        }
        break;
      default:
        console.error('SweetAlert2: Unexpected type of argument! Expected "string" or "object", got ' + _typeof(arguments[0]));
        return false;
    }
    setParameters(params);

    // Modal interactions
    var modal = getModal();
    return new Promise(function (resolve, reject) {
      // Close on timer
      if (params.timer) {
        modal.timeout = setTimeout(function () {
          sweetAlert.closeModal(params.onClose);
          reject('timer');
        }, params.timer);
      }

      // Get input element by specified type or, if type isn't specified, by params.input
      var getInput = function getInput(inputType) {
        inputType = inputType || params.input;
        switch (inputType) {
          case 'select':
          case 'textarea':
          case 'file':
            return getChildByClass(modal, swalClasses[inputType]);
          case 'checkbox':
            return modal.querySelector('.' + swalClasses.checkbox + ' input');
          case 'radio':
            return modal.querySelector('.' + swalClasses.radio + ' input:checked') || modal.querySelector('.' + swalClasses.radio + ' input:first-child');
          case 'range':
            return modal.querySelector('.' + swalClasses.range + ' input');
          default:
            return getChildByClass(modal, swalClasses.input);
        }
      };

      // Get the value of the modal input
      var getInputValue = function getInputValue() {
        var input = getInput();
        if (!input) {
          return null;
        }
        switch (params.input) {
          case 'checkbox':
            return input.checked ? 1 : 0;
          case 'radio':
            return input.checked ? input.value : null;
          case 'file':
            return input.files.length ? input.files[0] : null;
          default:
            return params.inputAutoTrim ? input.value.trim() : input.value;
        }
      };

      // input autofocus
      if (params.input) {
        setTimeout(function () {
          var input = getInput();
          if (input) {
            focusInput(input);
          }
        }, 0);
      }
      var confirm = function confirm(value) {
        if (params.showLoaderOnConfirm) {
          sweetAlert.showLoading();
        }
        if (params.preConfirm) {
          params.preConfirm(value, params.extraParams).then(function (preConfirmValue) {
            sweetAlert.closeModal(params.onClose);
            resolve(preConfirmValue || value);
          }, function (error) {
            sweetAlert.hideLoading();
            if (error) {
              sweetAlert.showValidationError(error);
            }
          });
        } else {
          sweetAlert.closeModal(params.onClose);
          resolve(value);
        }
      };

      // Mouse interactions
      var onButtonEvent = function onButtonEvent(event) {
        var e = event || window.event;
        var target = e.target || e.srcElement;
        var confirmBtn = getConfirmButton();
        var cancelBtn = getCancelButton();
        var targetedConfirm = confirmBtn === target || confirmBtn.contains(target);
        var targetedCancel = cancelBtn === target || cancelBtn.contains(target);
        switch (e.type) {
          case 'mouseover':
          case 'mouseup':
            if (params.buttonsStyling) {
              if (targetedConfirm) {
                confirmBtn.style.backgroundColor = colorLuminance(params.confirmButtonColor, -0.1);
              } else if (targetedCancel) {
                cancelBtn.style.backgroundColor = colorLuminance(params.cancelButtonColor, -0.1);
              }
            }
            break;
          case 'mouseout':
            if (params.buttonsStyling) {
              if (targetedConfirm) {
                confirmBtn.style.backgroundColor = params.confirmButtonColor;
              } else if (targetedCancel) {
                cancelBtn.style.backgroundColor = params.cancelButtonColor;
              }
            }
            break;
          case 'mousedown':
            if (params.buttonsStyling) {
              if (targetedConfirm) {
                confirmBtn.style.backgroundColor = colorLuminance(params.confirmButtonColor, -0.2);
              } else if (targetedCancel) {
                cancelBtn.style.backgroundColor = colorLuminance(params.cancelButtonColor, -0.2);
              }
            }
            break;
          case 'click':
            // Clicked 'confirm'
            if (targetedConfirm && sweetAlert.isVisible()) {
              if (params.input) {
                var inputValue = getInputValue();
                if (params.inputValidator) {
                  sweetAlert.disableInput();
                  params.inputValidator(inputValue, params.extraParams).then(function () {
                    sweetAlert.enableInput();
                    confirm(inputValue);
                  }, function (error) {
                    sweetAlert.enableInput();
                    if (error) {
                      sweetAlert.showValidationError(error);
                    }
                  });
                } else {
                  confirm(inputValue);
                }
              } else {
                confirm(true);
              }

              // Clicked 'cancel'
            } else if (targetedCancel && sweetAlert.isVisible()) {
              sweetAlert.closeModal(params.onClose);
              reject('cancel');
            }
            break;
          default:
        }
      };
      var $buttons = modal.querySelectorAll('button');
      var i;
      for (i = 0; i < $buttons.length; i++) {
        $buttons[i].onclick = onButtonEvent;
        $buttons[i].onmouseover = onButtonEvent;
        $buttons[i].onmouseout = onButtonEvent;
        $buttons[i].onmousedown = onButtonEvent;
      }

      // Closing modal by close button
      getCloseButton().onclick = function () {
        sweetAlert.closeModal(params.onClose);
        reject('close');
      };

      // Closing modal by overlay click
      sweetContainer.onclick = function (e) {
        if (e.target !== sweetContainer) {
          return;
        }
        if (params.allowOutsideClick) {
          sweetAlert.closeModal(params.onClose);
          reject('overlay');
        }
      };
      var $confirmButton = getConfirmButton();
      var $cancelButton = getCancelButton();

      // Reverse buttons if neede d
      if (params.reverseButtons) {
        $confirmButton.parentNode.insertBefore($cancelButton, $confirmButton);
      } else {
        $confirmButton.parentNode.insertBefore($confirmButton, $cancelButton);
      }

      // Focus handling
      function setFocus(index, increment) {
        var focusableElements = getFocusableElements(params.focusCancel);
        // search for visible elements and select the next possible match
        for (var i = 0; i < focusableElements.length; i++) {
          index = index + increment;

          // rollover to first item
          if (index === focusableElements.length) {
            index = 0;

            // go to last item
          } else if (index === -1) {
            index = focusableElements.length - 1;
          }

          // determine if element is visible
          var el = focusableElements[index];
          if (isVisible(el)) {
            return el.focus();
          }
        }
      }
      function handleKeyDown(event) {
        var e = event || window.event;
        var keyCode = e.keyCode || e.which;
        if ([9, 13, 32, 27].indexOf(keyCode) === -1) {
          // Don't do work on keys we don't care about.
          return;
        }
        var $targetElement = e.target || e.srcElement;
        var focusableElements = getFocusableElements(params.focusCancel);
        var btnIndex = -1; // Find the button - note, this is a nodelist, not an array.
        for (var i = 0; i < focusableElements.length; i++) {
          if ($targetElement === focusableElements[i]) {
            btnIndex = i;
            break;
          }
        }

        // TAB
        if (keyCode === 9) {
          if (!e.shiftKey) {
            // Cycle to the next button
            setFocus(btnIndex, 1);
          } else {
            // Cycle to the prev button
            setFocus(btnIndex, -1);
          }
          stopEventPropagation(e);
        } else {
          if (keyCode === 13 || keyCode === 32) {
            if (btnIndex === -1) {
              // ENTER/SPACE clicked outside of a button.
              if (params.focusCancel) {
                fireClick($cancelButton, e);
              } else {
                fireClick($confirmButton, e);
              }
            }
          } else if (keyCode === 27 && params.allowEscapeKey === true) {
            sweetAlert.closeModal(params.onClose);
            reject('esc');
          }
        }
      }
      states.previousWindowKeyDown = window.onkeydown;
      window.onkeydown = handleKeyDown;

      // Loading state
      if (params.buttonsStyling) {
        $confirmButton.style.borderLeftColor = params.confirmButtonColor;
        $confirmButton.style.borderRightColor = params.confirmButtonColor;
      }

      /**
       * Show spinner instead of Confirm button and disable Cancel button
       */
      sweetAlert.showLoading = sweetAlert.enableLoading = function () {
        show(getSpacer());
        show($confirmButton, 'inline-block');
        addClass($confirmButton, swalClasses.loading);
        addClass(modal, swalClasses.loading);
        $confirmButton.disabled = true;
        $cancelButton.disabled = true;
      };

      /**
       * Show spinner instead of Confirm button and disable Cancel button
       */
      sweetAlert.hideLoading = sweetAlert.disableLoading = function () {
        if (!params.showConfirmButton) {
          hide($confirmButton);
          if (!params.showCancelButton) {
            hide(getSpacer());
          }
        }
        removeClass($confirmButton, swalClasses.loading);
        removeClass(modal, swalClasses.loading);
        $confirmButton.disabled = false;
        $cancelButton.disabled = false;
      };
      sweetAlert.enableButtons = function () {
        $confirmButton.disabled = false;
        $cancelButton.disabled = false;
      };
      sweetAlert.disableButtons = function () {
        $confirmButton.disabled = true;
        $cancelButton.disabled = true;
      };
      sweetAlert.enableConfirmButton = function () {
        $confirmButton.disabled = false;
      };
      sweetAlert.disableConfirmButton = function () {
        $confirmButton.disabled = true;
      };
      sweetAlert.enableInput = function () {
        var input = getInput();
        if (!input) {
          return false;
        }
        if (input.type === 'radio') {
          var radiosContainer = input.parentNode.parentNode;
          var radios = radiosContainer.querySelectorAll('input');
          for (var i = 0; i < radios.length; i++) {
            radios[i].disabled = false;
          }
        } else {
          input.disabled = false;
        }
      };
      sweetAlert.disableInput = function () {
        var input = getInput();
        if (!input) {
          return false;
        }
        if (input && input.type === 'radio') {
          var radiosContainer = input.parentNode.parentNode;
          var radios = radiosContainer.querySelectorAll('input');
          for (var i = 0; i < radios.length; i++) {
            radios[i].disabled = true;
          }
        } else {
          input.disabled = true;
        }
      };

      // Set modal min-height to disable scrolling inside the modal
      sweetAlert.recalculateHeight = debounce(function () {
        var modal = getModal();
        var prevState = modal.style.display;
        modal.style.minHeight = '';
        show(modal);
        modal.style.minHeight = modal.scrollHeight + 1 + 'px';
        modal.style.display = prevState;
      }, 50);

      // Show block with validation error
      sweetAlert.showValidationError = function (error) {
        var validationError = getValidationError();
        validationError.innerHTML = error;
        show(validationError);
        var input = getInput();
        focusInput(input);
        addClass(input, swalClasses.inputerror);
      };

      // Hide block with validation error
      sweetAlert.resetValidationError = function () {
        var validationError = getValidationError();
        hide(validationError);
        sweetAlert.recalculateHeight();
        var input = getInput();
        if (input) {
          removeClass(input, swalClasses.inputerror);
        }
      };
      sweetAlert.getProgressSteps = function () {
        return params.progressSteps;
      };
      sweetAlert.setProgressSteps = function (progressSteps) {
        params.progressSteps = progressSteps;
        setParameters(params);
      };
      sweetAlert.showProgressSteps = function () {
        show(getProgressSteps());
      };
      sweetAlert.hideProgressSteps = function () {
        hide(getProgressSteps());
      };
      sweetAlert.enableButtons();
      sweetAlert.hideLoading();
      sweetAlert.resetValidationError();

      // inputs
      var inputTypes = ['input', 'file', 'range', 'select', 'radio', 'checkbox', 'textarea'];
      var input;
      for (i = 0; i < inputTypes.length; i++) {
        var inputClass = swalClasses[inputTypes[i]];
        var inputContainer = getChildByClass(modal, inputClass);
        input = getInput(inputTypes[i]);

        // set attributes
        if (input) {
          for (var j in input.attributes) {
            if (input.attributes.hasOwnProperty(j)) {
              var attrName = input.attributes[j].name;
              if (attrName !== 'type' && attrName !== 'value') {
                input.removeAttribute(attrName);
              }
            }
          }
          for (var attr in params.inputAttributes) {
            input.setAttribute(attr, params.inputAttributes[attr]);
          }
        }

        // set class
        inputContainer.className = inputClass;
        if (params.inputClass) {
          addClass(inputContainer, params.inputClass);
        }
        hide(inputContainer);
      }
      var populateInputOptions;
      switch (params.input) {
        case 'text':
        case 'email':
        case 'password':
        case 'number':
        case 'tel':
          input = getChildByClass(modal, swalClasses.input);
          input.value = params.inputValue;
          input.placeholder = params.inputPlaceholder;
          input.type = params.input;
          show(input);
          break;
        case 'file':
          input = getChildByClass(modal, swalClasses.file);
          input.placeholder = params.inputPlaceholder;
          input.type = params.input;
          show(input);
          break;
        case 'range':
          var range = getChildByClass(modal, swalClasses.range);
          var rangeInput = range.querySelector('input');
          var rangeOutput = range.querySelector('output');
          rangeInput.value = params.inputValue;
          rangeInput.type = params.input;
          rangeOutput.value = params.inputValue;
          show(range);
          break;
        case 'select':
          var select = getChildByClass(modal, swalClasses.select);
          select.innerHTML = '';
          if (params.inputPlaceholder) {
            var placeholder = document.createElement('option');
            placeholder.innerHTML = params.inputPlaceholder;
            placeholder.value = '';
            placeholder.disabled = true;
            placeholder.selected = true;
            select.appendChild(placeholder);
          }
          populateInputOptions = function populateInputOptions(inputOptions) {
            for (var optionValue in inputOptions) {
              var option = document.createElement('option');
              option.value = optionValue;
              option.innerHTML = inputOptions[optionValue];
              if (params.inputValue === optionValue) {
                option.selected = true;
              }
              select.appendChild(option);
            }
            show(select);
            select.focus();
          };
          break;
        case 'radio':
          var radio = getChildByClass(modal, swalClasses.radio);
          radio.innerHTML = '';
          populateInputOptions = function populateInputOptions(inputOptions) {
            for (var radioValue in inputOptions) {
              var id = 1;
              var radioInput = document.createElement('input');
              var radioLabel = document.createElement('label');
              var radioLabelSpan = document.createElement('span');
              radioInput.type = 'radio';
              radioInput.name = swalClasses.radio;
              radioInput.value = radioValue;
              radioInput.id = swalClasses.radio + '-' + id++;
              if (params.inputValue === radioValue) {
                radioInput.checked = true;
              }
              radioLabelSpan.innerHTML = inputOptions[radioValue];
              radioLabel.appendChild(radioInput);
              radioLabel.appendChild(radioLabelSpan);
              radioLabel["for"] = radioInput.id;
              radio.appendChild(radioLabel);
            }
            show(radio);
            var radios = radio.querySelectorAll('input');
            if (radios.length) {
              radios[0].focus();
            }
          };
          break;
        case 'checkbox':
          var checkbox = getChildByClass(modal, swalClasses.checkbox);
          var checkboxInput = getInput('checkbox');
          checkboxInput.type = 'checkbox';
          checkboxInput.value = 1;
          checkboxInput.id = swalClasses.checkbox;
          checkboxInput.checked = Boolean(params.inputValue);
          var label = checkbox.getElementsByTagName('span');
          if (label.length) {
            checkbox.removeChild(label[0]);
          }
          label = document.createElement('span');
          label.innerHTML = params.inputPlaceholder;
          checkbox.appendChild(label);
          show(checkbox);
          break;
        case 'textarea':
          var textarea = getChildByClass(modal, swalClasses.textarea);
          textarea.value = params.inputValue;
          textarea.placeholder = params.inputPlaceholder;
          show(textarea);
          break;
        case null:
          break;
        default:
          console.error('SweetAlert2: Unexpected type of input! Expected "text" or "email" or "password", "select", "checkbox", "textarea" or "file", got "' + params.input + '"');
          break;
      }
      if (params.input === 'select' || params.input === 'radio') {
        if (params.inputOptions instanceof Promise) {
          sweetAlert.showLoading();
          params.inputOptions.then(function (inputOptions) {
            sweetAlert.hideLoading();
            populateInputOptions(inputOptions);
          });
        } else if (_typeof(params.inputOptions) === 'object') {
          populateInputOptions(params.inputOptions);
        } else {
          console.error('SweetAlert2: Unexpected type of inputOptions! Expected object or Promise, got ' + _typeof(params.inputOptions));
        }
      }
      openModal(params.animation, params.onOpen);

      // Focus the first element (input or button)
      setFocus(-1, 1);

      // fix scroll
      sweetContainer.scrollTop = 0;

      // Observe changes inside the modal and adjust height
      if (typeof MutationObserver !== 'undefined' && !swal2Observer) {
        swal2Observer = new MutationObserver(sweetAlert.recalculateHeight);
        swal2Observer.observe(modal, {
          childList: true,
          characterData: true,
          subtree: true
        });
      }
    });
  }

  // SweetAlert function
  function sweetAlert() {
    // Copy arguments to the local args variable
    var args = arguments;
    if (sweetAlert.isVisible()) {
      sweetAlert.close();
    }
    return modalDependant.apply(this, args);
  }

  /*
   * Global function to determine if swal2 modal is visible
   */
  sweetAlert.isVisible = function () {
    var modal = getModal();
    return isVisible(modal);
  };

  /*
   * Global function for chaining sweetAlert modals
   */
  sweetAlert.queue = function (steps) {
    queue = steps;
    var modal = getModal();
    var resetQueue = function resetQueue() {
      queue = [];
      modal.removeAttribute('data-queue-step');
    };
    var queueResult = [];
    return new Promise(function (resolve, reject) {
      (function step(i, callback) {
        if (i < queue.length) {
          modal.setAttribute('data-queue-step', i);
          sweetAlert(queue[i]).then(function (result) {
            queueResult.push(result);
            step(i + 1, callback);
          }, function (dismiss) {
            resetQueue();
            reject(dismiss);
          });
        } else {
          resetQueue();
          resolve(queueResult);
        }
      })(0);
    });
  };

  /*
   * Global function for getting the index of current modal in queue
   */
  sweetAlert.getQueueStep = function () {
    return getModal().getAttribute('data-queue-step');
  };

  /*
   * Global function for inserting a modal to the queue
   */
  sweetAlert.insertQueueStep = function (step, index) {
    if (index && index < queue.length) {
      return queue.splice(index, 0, step);
    }
    return queue.push(step);
  };

  /*
   * Global function for deleting a modal from the queue
   */
  sweetAlert.deleteQueueStep = function (index) {
    if (typeof queue[index] !== 'undefined') {
      queue.splice(index, 1);
    }
  };

  /*
   * Global function to close sweetAlert
   */
  sweetAlert.close = sweetAlert.closeModal = function (onComplete) {
    var modal = getModal();
    removeClass(modal, swalClasses.show);
    addClass(modal, swalClasses.hide);

    // Reset icon animations
    var $successIcon = modal.querySelector('.' + swalClasses.icon + '.' + iconTypes.success);
    removeClass($successIcon, 'animate');
    removeClass($successIcon.querySelector('.tip'), 'animate-success-tip');
    removeClass($successIcon.querySelector('.long'), 'animate-success-long');
    var $errorIcon = modal.querySelector('.' + swalClasses.icon + '.' + iconTypes.error);
    removeClass($errorIcon, 'animate-error-icon');
    removeClass($errorIcon.querySelector('.x-mark'), 'animate-x-mark');
    var $warningIcon = modal.querySelector('.' + swalClasses.icon + '.' + iconTypes.warning);
    removeClass($warningIcon, 'pulse-warning');
    resetPrevState();
    var hideModalAndResetState = function hideModalAndResetState() {
      hide(modal);
      modal.style.minHeight = '';
      removeClass(sweetContainer, swalClasses["in"]);
      removeClass(document.body, swalClasses["in"]);
      undoScrollbar();
      undoIOSfix();
    };

    // If animation is supported, animate
    if (animationEndEvent && !hasClass(modal, swalClasses.noanimation)) {
      modal.addEventListener(animationEndEvent, function swalCloseEventFinished() {
        modal.removeEventListener(animationEndEvent, swalCloseEventFinished);
        if (hasClass(modal, swalClasses.hide)) {
          hideModalAndResetState();
        }
      });
    } else {
      // Otherwise, hide immediately
      hideModalAndResetState();
    }
    if (onComplete !== null && typeof onComplete === 'function') {
      onComplete.call(this, modal);
    }
  };

  /*
   * Global function to click 'Confirm' button
   */
  sweetAlert.clickConfirm = function () {
    getConfirmButton().click();
  };

  /*
   * Global function to click 'Cancel' button
   */
  sweetAlert.clickCancel = function () {
    getCancelButton().click();
  };

  /**
   * Set default params for each popup
   * @param {Object} userParams
   */
  sweetAlert.setDefaults = function (userParams) {
    if (!userParams) {
      throw new Error('userParams is required');
    }
    if (_typeof(userParams) !== 'object') {
      throw new Error('userParams has to be a object');
    }
    extend(modalParams, userParams);
  };

  /**
   * Reset default params for each popup
   */
  sweetAlert.resetDefaults = function () {
    modalParams = extend({}, defaultParams);
  };
  sweetAlert.noop = function () {};
  sweetAlert.version = '5.3.8';
  if (typeof Promise === 'function') {
    Promise.prototype.done = Promise.prototype.done || function () {
      // eslint-disable-line
      return this["catch"](function () {
        // Catch promise rejections silently.
        // https://github.com/limonte/sweetalert2/issues/177
      });
    };
  } else {
    console.warn('SweetAlert2: Please inlude Promise polyfill BEFORE including sweetalert2.js if IE10+ support needed.');
  }
  return sweetAlert;
});
if (window.Sweetalert2) window.sweetAlert = window.swal = window.Sweetalert2;
!function (a, i) {
  "use strict";

  "object" == (typeof module === "undefined" ? "undefined" : _typeof(module)) && module.exports ? module.exports = i(require("moment")) : "function" == typeof define && define.amd ? define(["moment"], i) : i(a.moment);
}(this, function (o) {
  "use strict";

  void 0 === o.version && o["default"] && (o = o["default"]);
  var i,
    s = {},
    c = {},
    A = {},
    u = {},
    m = {},
    a = (o && "string" == typeof o.version || y("Moment Timezone requires Moment.js. See https://momentjs.com/timezone/docs/#/use-it/browser/"), o.version.split(".")),
    r = +a[0],
    e = +a[1];
  function n(a) {
    return 96 < a ? a - 87 : 64 < a ? a - 29 : a - 48;
  }
  function t(a) {
    var i = 0,
      r = a.split("."),
      e = r[0],
      o = r[1] || "",
      c = 1,
      A = 0,
      r = 1;
    for (45 === a.charCodeAt(0) && (r = -(i = 1)); i < e.length; i++) A = 60 * A + n(e.charCodeAt(i));
    for (i = 0; i < o.length; i++) c /= 60, A += n(o.charCodeAt(i)) * c;
    return A * r;
  }
  function l(a) {
    for (var i = 0; i < a.length; i++) a[i] = t(a[i]);
  }
  function f(a, i) {
    for (var r = [], e = 0; e < i.length; e++) r[e] = a[i[e]];
    return r;
  }
  function p(a) {
    for (var a = a.split("|"), i = a[2].split(" "), r = a[3].split(""), e = a[4].split(" "), o = (l(i), l(r), l(e), e), c = r.length, A = 0; A < c; A++) o[A] = Math.round((o[A - 1] || 0) + 6e4 * o[A]);
    return o[c - 1] = 1 / 0, {
      name: a[0],
      abbrs: f(a[1].split(" "), r),
      offsets: f(i, r),
      untils: e,
      population: 0 | a[5]
    };
  }
  function M(a) {
    a && this._set(p(a));
  }
  function b(a, i) {
    this.name = a, this.zones = i;
  }
  function h(a) {
    var i = a.toTimeString(),
      r = i.match(/\([a-z ]+\)/i);
    "GMT" === (r = r && r[0] ? (r = r[0].match(/[A-Z]/g)) ? r.join("") : void 0 : (r = i.match(/[A-Z]{3,5}/g)) ? r[0] : void 0) && (r = void 0), this.at = +a, this.abbr = r, this.offset = a.getTimezoneOffset();
  }
  function d(a) {
    this.zone = a, this.offsetScore = 0, this.abbrScore = 0;
  }
  function E() {
    for (var a, i, r, e = new Date().getFullYear() - 2, o = new h(new Date(e, 0, 1)), c = o.offset, A = [o], n = 1; n < 48; n++) (r = new Date(e, n, 1).getTimezoneOffset()) !== c && (a = function (a, i) {
      for (var r; r = 6e4 * ((i.at - a.at) / 12e4 | 0);) (r = new h(new Date(a.at + r))).offset === a.offset ? a = r : i = r;
      return a;
    }(o, i = new h(new Date(e, n, 1))), A.push(a), A.push(new h(new Date(a.at + 6e4))), o = i, c = r);
    for (n = 0; n < 4; n++) A.push(new h(new Date(e + n, 0, 1))), A.push(new h(new Date(e + n, 6, 1)));
    return A;
  }
  function g(a, i) {
    return a.offsetScore !== i.offsetScore ? a.offsetScore - i.offsetScore : a.abbrScore !== i.abbrScore ? a.abbrScore - i.abbrScore : a.zone.population !== i.zone.population ? i.zone.population - a.zone.population : i.zone.name.localeCompare(a.zone.name);
  }
  function P() {
    try {
      var a = Intl.DateTimeFormat().resolvedOptions().timeZone;
      if (a && 3 < a.length) {
        var i = u[S(a)];
        if (i) return i;
        y("Moment Timezone found " + a + " from the Intl api, but did not have that data loaded.");
      }
    } catch (a) {}
    for (var r, e, o = E(), c = o.length, A = function (a) {
        for (var i, r, e, o = a.length, c = {}, A = [], n = {}, t = 0; t < o; t++) if (r = a[t].offset, !n.hasOwnProperty(r)) {
          for (i in e = m[r] || {}) e.hasOwnProperty(i) && (c[i] = !0);
          n[r] = !0;
        }
        for (t in c) c.hasOwnProperty(t) && A.push(u[t]);
        return A;
      }(o), n = [], t = 0; t < A.length; t++) {
      for (r = new d(k(A[t])), e = 0; e < c; e++) r.scoreOffsetAt(o[e]);
      n.push(r);
    }
    return n.sort(g), 0 < n.length ? n[0].zone.name : void 0;
  }
  function S(a) {
    return (a || "").toLowerCase().replace(/\//g, "_");
  }
  function _(a) {
    var i, r, e, o;
    for ("string" == typeof a && (a = [a]), i = 0; i < a.length; i++) {
      o = S(r = (e = a[i].split("|"))[0]), s[o] = a[i], u[o] = r, A = c = t = n = void 0;
      var c,
        A,
        n = o,
        t = e[2].split(" ");
      for (l(t), c = 0; c < t.length; c++) A = t[c], m[A] = m[A] || {}, m[A][n] = !0;
    }
  }
  function k(a, i) {
    a = S(a);
    var r = s[a];
    return r instanceof M ? r : "string" == typeof r ? (r = new M(r), s[a] = r) : c[a] && i !== k && (i = k(c[a], k)) ? ((r = s[a] = new M())._set(i), r.name = u[a], r) : null;
  }
  function T(a) {
    var i, r, e, o;
    for ("string" == typeof a && (a = [a]), i = 0; i < a.length; i++) e = S((r = a[i].split("|"))[0]), o = S(r[1]), c[e] = o, u[e] = r[0], c[o] = e, u[o] = r[1];
  }
  function z(a) {
    _(a.zones), T(a.links);
    var i,
      r,
      e,
      o = a.countries;
    if (o && o.length) for (i = 0; i < o.length; i++) r = (e = o[i].split("|"))[0].toUpperCase(), e = e[1].split(" "), A[r] = new b(r, e);
    L.dataVersion = a.version;
  }
  function C(a) {
    return C.didShowError || (C.didShowError = !0, y("moment.tz.zoneExists('" + a + "') has been deprecated in favor of !moment.tz.zone('" + a + "')")), !!k(a);
  }
  function B(a) {
    var i = "X" === a._f || "x" === a._f;
    return !(!a._a || void 0 !== a._tzm || i);
  }
  function y(a) {
    "undefined" != typeof console && "function" == typeof console.error && console.error(a);
  }
  function L(a) {
    var i = Array.prototype.slice.call(arguments, 0, -1),
      r = arguments[arguments.length - 1],
      i = o.utc.apply(null, i);
    return !o.isMoment(a) && B(i) && (a = k(r)) && i.add(a.parse(i), "minutes"), i.tz(r), i;
  }
  (r < 2 || 2 == r && e < 6) && y("Moment Timezone requires Moment.js >= 2.6.0. You are using Moment.js " + o.version + ". See momentjs.com"), M.prototype = {
    _set: function _set(a) {
      this.name = a.name, this.abbrs = a.abbrs, this.untils = a.untils, this.offsets = a.offsets, this.population = a.population;
    },
    _index: function _index(a) {
      a = function (a, i) {
        var r,
          e = i.length;
        if (a < i[0]) return 0;
        if (1 < e && i[e - 1] === 1 / 0 && a >= i[e - 2]) return e - 1;
        if (a >= i[e - 1]) return -1;
        for (var o = 0, c = e - 1; 1 < c - o;) i[r = Math.floor((o + c) / 2)] <= a ? o = r : c = r;
        return c;
      }(+a, this.untils);
      if (0 <= a) return a;
    },
    countries: function countries() {
      var i = this.name;
      return Object.keys(A).filter(function (a) {
        return -1 !== A[a].zones.indexOf(i);
      });
    },
    parse: function parse(a) {
      for (var i, r, e, o = +a, c = this.offsets, A = this.untils, n = A.length - 1, t = 0; t < n; t++) if (i = c[t], r = c[t + 1], e = c[t && t - 1], i < r && L.moveAmbiguousForward ? i = r : e < i && L.moveInvalidForward && (i = e), o < A[t] - 6e4 * i) return c[t];
      return c[n];
    },
    abbr: function abbr(a) {
      return this.abbrs[this._index(a)];
    },
    offset: function offset(a) {
      return y("zone.offset has been deprecated in favor of zone.utcOffset"), this.offsets[this._index(a)];
    },
    utcOffset: function utcOffset(a) {
      return this.offsets[this._index(a)];
    }
  }, d.prototype.scoreOffsetAt = function (a) {
    this.offsetScore += Math.abs(this.zone.utcOffset(a.at) - a.offset), this.zone.abbr(a.at).replace(/[^A-Z]/g, "") !== a.abbr && this.abbrScore++;
  }, L.version = "0.5.48", L.dataVersion = "", L._zones = s, L._links = c, L._names = u, L._countries = A, L.add = _, L.link = T, L.load = z, L.zone = k, L.zoneExists = C, L.guess = function (a) {
    return i = i && !a ? i : P();
  }, L.names = function () {
    var a,
      i = [];
    for (a in u) u.hasOwnProperty(a) && (s[a] || s[c[a]]) && u[a] && i.push(u[a]);
    return i.sort();
  }, L.Zone = M, L.unpack = p, L.unpackBase60 = t, L.needsOffset = B, L.moveInvalidForward = !0, L.moveAmbiguousForward = !1, L.countries = function () {
    return Object.keys(A);
  }, L.zonesForCountry = function (a, i) {
    var r;
    return r = (r = a).toUpperCase(), (a = A[r] || null) ? (r = a.zones.sort(), i ? r.map(function (a) {
      return {
        name: a,
        offset: k(a).utcOffset(new Date())
      };
    }) : r) : null;
  };
  var D,
    a = o.fn;
  function N(a) {
    return function () {
      return this._z ? this._z.abbr(this) : a.call(this);
    };
  }
  function v(a) {
    return function () {
      return this._z = null, a.apply(this, arguments);
    };
  }
  o.tz = L, o.defaultZone = null, o.updateOffset = function (a, i) {
    var r,
      e = o.defaultZone;
    void 0 === a._z && (e && B(a) && !a._isUTC && a.isValid() && (a._d = o.utc(a._a)._d, a.utc().add(e.parse(a), "minutes")), a._z = e), a._z && (e = a._z.utcOffset(a), Math.abs(e) < 16 && (e /= 60), void 0 !== a.utcOffset ? (r = a._z, a.utcOffset(-e, i), a._z = r) : a.zone(e, i));
  }, a.tz = function (a, i) {
    if (a) {
      if ("string" != typeof a) throw new Error("Time zone name must be a string, got " + a + " [" + _typeof(a) + "]");
      return this._z = k(a), this._z ? o.updateOffset(this, i) : y("Moment Timezone has no data for " + a + ". See http://momentjs.com/timezone/docs/#/data-loading/."), this;
    }
    if (this._z) return this._z.name;
  }, a.zoneName = N(a.zoneName), a.zoneAbbr = N(a.zoneAbbr), a.utc = v(a.utc), a.local = v(a.local), a.utcOffset = (D = a.utcOffset, function () {
    return 0 < arguments.length && (this._z = null), D.apply(this, arguments);
  }), o.tz.setDefault = function (a) {
    return (r < 2 || 2 == r && e < 9) && y("Moment Timezone setDefault() requires Moment.js >= 2.9.0. You are using Moment.js " + o.version + "."), o.defaultZone = a ? k(a) : null, o;
  };
  a = o.momentProperties;
  return "[object Array]" === Object.prototype.toString.call(a) ? (a.push("_z"), a.push("_a")) : a && (a._z = null), z({
    version: "2025b",
    zones: ["Africa/Abidjan|GMT|0|0||48e5", "Africa/Nairobi|EAT|-30|0||47e5", "Africa/Algiers|CET|-10|0||26e5", "Africa/Lagos|WAT|-10|0||17e6", "Africa/Khartoum|CAT|-20|0||51e5", "Africa/Cairo|EET EEST|-20 -30|01010101010101010|29NW0 1cL0 1cN0 1fz0 1a10 1fz0 1a10 1fz0 1cN0 1cL0 1cN0 1cL0 1cN0 1cL0 1cN0 1fz0|15e6", "Africa/Casablanca|+01 +00|-10 0|010101010101010101010101|22sq0 gM0 2600 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 28M0 e00 2600 gM0 2600 e00 2600 gM0 2600|32e5", "Europe/Paris|CET CEST|-10 -20|01010101010101010101010|22k10 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|11e6", "Africa/Johannesburg|SAST|-20|0||84e5", "Africa/Juba|EAT CAT|-30 -20|01|24nx0|", "Africa/Tripoli|EET|-20|0||11e5", "America/Adak|HST HDT|a0 90|01010101010101010101010|22bM0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|326", "America/Anchorage|AKST AKDT|90 80|01010101010101010101010|22bL0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|30e4", "America/Santo_Domingo|AST|40|0||29e5", "America/Sao_Paulo|-03|30|0||20e6", "America/Asuncion|-03 -04|30 40|01010101010|22hf0 1ip0 19X0 1fB0 19X0 1fB0 19X0 1fB0 19X0 1ip0|28e5", "America/Panama|EST|50|0||15e5", "America/Mexico_City|CST CDT|60 50|0101010|22mU0 1lb0 14p0 1nX0 11B0 1nX0|20e6", "America/Managua|CST|60|0||22e5", "America/Caracas|-04|40|0||29e5", "America/Lima|-05|50|0||11e6", "America/Denver|MST MDT|70 60|01010101010101010101010|22bJ0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|26e5", "America/Chicago|CST CDT|60 50|01010101010101010101010|22bI0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|92e5", "America/Chihuahua|MST MDT CST|70 60 60|0101012|22mV0 1lb0 14p0 1nX0 11B0 1nX0|81e4", "America/Ciudad_Juarez|MST MDT CST|70 60 60|010101201010101010101010|22bJ0 1zb0 Rd0 1zb0 Op0 1wn0 cm0 EP0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|", "America/Coyhaique|-03 -04|30 40|01010101010|22mP0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0|", "America/Phoenix|MST|70|0||42e5", "America/Whitehorse|PST PDT MST|80 70 70|012|22bK0 1z90|23e3", "America/New_York|EST EDT|50 40|01010101010101010101010|22bH0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|21e6", "America/Los_Angeles|PST PDT|80 70|01010101010101010101010|22bK0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|15e6", "America/Halifax|AST ADT|40 30|01010101010101010101010|22bG0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|39e4", "America/Godthab|-03 -02 -01|30 20 10|0101010121212121212121|22k10 1o00 11A0 1qM0 WM0 1qM0 WM0 2so0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|17e3", "America/Havana|CST CDT|50 40|01010101010101010101010|22bF0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0 Rc0 1zc0 Oo0 1zc0 Oo0 1zc0 Oo0 1zc0|21e5", "America/Mazatlan|MST MDT|70 60|0101010|22mV0 1lb0 14p0 1nX0 11B0 1nX0|44e4", "America/Miquelon|-03 -02|30 20|01010101010101010101010|22bF0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|61e2", "America/Noronha|-02|20|0||30e2", "America/Ojinaga|MST MDT CST CDT|70 60 60 50|01010123232323232323232|22bJ0 1zb0 Rd0 1zb0 Op0 1wn0 Rc0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|23e3", "America/Santiago|-03 -04|30 40|01010101010101010101010|22mP0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0|62e5", "America/Scoresbysund|-01 +00 -02|10 0 20|0101010102020202020202|22k10 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 2pA0 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|452", "America/St_Johns|NST NDT|3u 2u|01010101010101010101010|22bFu 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0 Rd0 1zb0 Op0 1zb0 Op0 1zb0 Op0 1zb0|11e4", "Antarctica/Casey|+11 +08|-b0 -80|01010101|22bs0 1o01 14kX 1lf1 14kX 1lf1 13bX|10", "Asia/Bangkok|+07|-70|0||15e6", "Asia/Vladivostok|+10|-a0|0||60e4", "Australia/Sydney|AEDT AEST|-b0 -a0|01010101010101010101010|22mE0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|40e5", "Asia/Tashkent|+05|-50|0||23e5", "Pacific/Auckland|NZDT NZST|-d0 -c0|01010101010101010101010|22mC0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00|14e5", "Europe/Istanbul|+03|-30|0||13e6", "Antarctica/Troll|+00 +02|0 -20|01010101010101010101010|22k10 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|40", "Antarctica/Vostok|+07 +05|-70 -50|01|2bnv0|25", "Asia/Almaty|+06 +05|-60 -50|01|2bR60|15e5", "Asia/Amman|EET EEST +03|-20 -30 -30|0101012|22ja0 1qM0 WM0 1qM0 LA0 1C00|25e5", "Asia/Kamchatka|+12|-c0|0||18e4", "Asia/Dubai|+04|-40|0||39e5", "Asia/Beirut|EET EEST|-20 -30|01010101010101010101010|22jW0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0|22e5", "Asia/Dhaka|+06|-60|0||16e6", "Asia/Kuala_Lumpur|+08|-80|0||71e5", "Asia/Kolkata|IST|-5u|0||15e6", "Asia/Chita|+09|-90|0||33e4", "Asia/Shanghai|CST|-80|0||23e6", "Asia/Colombo|+0530|-5u|0||22e5", "Asia/Damascus|EET EEST +03|-20 -30 -30|0101012|22ja0 1qL0 WN0 1qL0 WN0 1qL0|26e5", "Europe/Athens|EET EEST|-20 -30|01010101010101010101010|22k10 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|35e5", "Asia/Gaza|EET EEST|-20 -30|01010101010101010101010|22jy0 1o00 11A0 1qo0 XA0 1qp0 1cN0 1cL0 1a10 1fz0 17d0 1in0 11B0 1nX0 11B0 1qL0 WN0 1qL0 WN0 1qL0 11B0 1nX0|18e5", "Asia/Hong_Kong|HKT|-80|0||73e5", "Asia/Jakarta|WIB|-70|0||31e6", "Asia/Jayapura|WIT|-90|0||26e4", "Asia/Jerusalem|IST IDT|-20 -30|01010101010101010101010|22jc0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0 10N0 1oL0 10N0 1oL0 10N0 1rz0 W10 1rz0 W10 1rz0 10N0 1oL0|81e4", "Asia/Kabul|+0430|-4u|0||46e5", "Asia/Karachi|PKT|-50|0||24e6", "Asia/Kathmandu|+0545|-5J|0||12e5", "Asia/Sakhalin|+11|-b0|0||58e4", "Asia/Makassar|WITA|-80|0||15e5", "Asia/Manila|PST|-80|0||24e6", "Asia/Seoul|KST|-90|0||23e6", "Asia/Rangoon|+0630|-6u|0||48e5", "Asia/Tehran|+0330 +0430|-3u -4u|0101010|22gIu 1dz0 1cN0 1dz0 1cp0 1dz0|14e6", "Asia/Tokyo|JST|-90|0||38e6", "Atlantic/Azores|-01 +00|10 0|01010101010101010101010|22k10 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|25e4", "Europe/Lisbon|WET WEST|0 -10|01010101010101010101010|22k10 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|27e5", "Atlantic/Cape_Verde|-01|10|0||50e4", "Australia/Adelaide|ACDT ACST|-au -9u|01010101010101010101010|22mEu 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|11e5", "Australia/Brisbane|AEST|-a0|0||20e5", "Australia/Darwin|ACST|-9u|0||12e4", "Australia/Eucla|+0845|-8J|0||368", "Australia/Lord_Howe|+11 +1030|-b0 -au|01010101010101010101010|22mD0 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1fzu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1cMu 1cLu 1fAu 1cLu 1cMu|347", "Australia/Perth|AWST|-80|0||18e5", "Pacific/Easter|-05 -06|50 60|01010101010101010101010|22mP0 11B0 1nX0 11B0 1nX0 14p0 1lb0 11B0 1qL0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1nX0 11B0 1qL0 WN0 1qL0 11B0|30e2", "Europe/Dublin|GMT IST|0 -10|01010101010101010101010|22k10 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|12e5", "Etc/GMT-1|+01|-10|0||", "Pacific/Tongatapu|+13|-d0|0||75e3", "Pacific/Kiritimati|+14|-e0|0||51e2", "Etc/GMT-2|+02|-20|0||", "Pacific/Tahiti|-10|a0|0||18e4", "Pacific/Niue|-11|b0|0||12e2", "Etc/GMT+12|-12|c0|0||", "Pacific/Galapagos|-06|60|0||25e3", "Etc/GMT+7|-07|70|0||", "Pacific/Pitcairn|-08|80|0||56", "Pacific/Gambier|-09|90|0||125", "Etc/UTC|UTC|0|0||", "Europe/London|GMT BST|0 -10|01010101010101010101010|22k10 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|10e6", "Europe/Chisinau|EET EEST|-20 -30|01010101010101010101010|22k00 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00 11A0 1o00 11A0 1o00 11A0 1qM0 WM0 1qM0 WM0 1qM0 11A0 1o00|67e4", "Europe/Moscow|MSK|-30|0||16e6", "Europe/Volgograd|+04 MSK|-40 -30|01|249a0|10e5", "Pacific/Honolulu|HST|a0|0||37e4", "Pacific/Chatham|+1345 +1245|-dJ -cJ|01010101010101010101010|22mC0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1io0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1a00 1fA0 1cM0 1fA0 1a00|600", "Pacific/Apia|+14 +13|-e0 -d0|0101|22mC0 1a00 1fA0|37e3", "Pacific/Fiji|+13 +12|-d0 -c0|0101|21N20 2hc0 bc0|88e4", "Pacific/Guam|ChST|-a0|0||17e4", "Pacific/Marquesas|-0930|9u|0||86e2", "Pacific/Pago_Pago|SST|b0|0||37e2", "Pacific/Norfolk|+12 +11|-c0 -b0|01010101010101010101010|22mD0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1cM0 1fA0 1cM0 1cM0|25e4"],
    links: ["Africa/Abidjan|Africa/Accra", "Africa/Abidjan|Africa/Bamako", "Africa/Abidjan|Africa/Banjul", "Africa/Abidjan|Africa/Bissau", "Africa/Abidjan|Africa/Conakry", "Africa/Abidjan|Africa/Dakar", "Africa/Abidjan|Africa/Freetown", "Africa/Abidjan|Africa/Lome", "Africa/Abidjan|Africa/Monrovia", "Africa/Abidjan|Africa/Nouakchott", "Africa/Abidjan|Africa/Ouagadougou", "Africa/Abidjan|Africa/Sao_Tome", "Africa/Abidjan|Africa/Timbuktu", "Africa/Abidjan|America/Danmarkshavn", "Africa/Abidjan|Atlantic/Reykjavik", "Africa/Abidjan|Atlantic/St_Helena", "Africa/Abidjan|Etc/GMT", "Africa/Abidjan|Etc/GMT+0", "Africa/Abidjan|Etc/GMT-0", "Africa/Abidjan|Etc/GMT0", "Africa/Abidjan|Etc/Greenwich", "Africa/Abidjan|GMT", "Africa/Abidjan|GMT+0", "Africa/Abidjan|GMT-0", "Africa/Abidjan|GMT0", "Africa/Abidjan|Greenwich", "Africa/Abidjan|Iceland", "Africa/Algiers|Africa/Tunis", "Africa/Cairo|Egypt", "Africa/Casablanca|Africa/El_Aaiun", "Africa/Johannesburg|Africa/Maseru", "Africa/Johannesburg|Africa/Mbabane", "Africa/Khartoum|Africa/Blantyre", "Africa/Khartoum|Africa/Bujumbura", "Africa/Khartoum|Africa/Gaborone", "Africa/Khartoum|Africa/Harare", "Africa/Khartoum|Africa/Kigali", "Africa/Khartoum|Africa/Lubumbashi", "Africa/Khartoum|Africa/Lusaka", "Africa/Khartoum|Africa/Maputo", "Africa/Khartoum|Africa/Windhoek", "Africa/Lagos|Africa/Bangui", "Africa/Lagos|Africa/Brazzaville", "Africa/Lagos|Africa/Douala", "Africa/Lagos|Africa/Kinshasa", "Africa/Lagos|Africa/Libreville", "Africa/Lagos|Africa/Luanda", "Africa/Lagos|Africa/Malabo", "Africa/Lagos|Africa/Ndjamena", "Africa/Lagos|Africa/Niamey", "Africa/Lagos|Africa/Porto-Novo", "Africa/Nairobi|Africa/Addis_Ababa", "Africa/Nairobi|Africa/Asmara", "Africa/Nairobi|Africa/Asmera", "Africa/Nairobi|Africa/Dar_es_Salaam", "Africa/Nairobi|Africa/Djibouti", "Africa/Nairobi|Africa/Kampala", "Africa/Nairobi|Africa/Mogadishu", "Africa/Nairobi|Indian/Antananarivo", "Africa/Nairobi|Indian/Comoro", "Africa/Nairobi|Indian/Mayotte", "Africa/Tripoli|Europe/Kaliningrad", "Africa/Tripoli|Libya", "America/Adak|America/Atka", "America/Adak|US/Aleutian", "America/Anchorage|America/Juneau", "America/Anchorage|America/Metlakatla", "America/Anchorage|America/Nome", "America/Anchorage|America/Sitka", "America/Anchorage|America/Yakutat", "America/Anchorage|US/Alaska", "America/Caracas|America/Boa_Vista", "America/Caracas|America/Campo_Grande", "America/Caracas|America/Cuiaba", "America/Caracas|America/Guyana", "America/Caracas|America/La_Paz", "America/Caracas|America/Manaus", "America/Caracas|America/Porto_Velho", "America/Caracas|Brazil/West", "America/Caracas|Etc/GMT+4", "America/Chicago|America/Indiana/Knox", "America/Chicago|America/Indiana/Tell_City", "America/Chicago|America/Knox_IN", "America/Chicago|America/Matamoros", "America/Chicago|America/Menominee", "America/Chicago|America/North_Dakota/Beulah", "America/Chicago|America/North_Dakota/Center", "America/Chicago|America/North_Dakota/New_Salem", "America/Chicago|America/Rainy_River", "America/Chicago|America/Rankin_Inlet", "America/Chicago|America/Resolute", "America/Chicago|America/Winnipeg", "America/Chicago|CST6CDT", "America/Chicago|Canada/Central", "America/Chicago|US/Central", "America/Chicago|US/Indiana-Starke", "America/Denver|America/Boise", "America/Denver|America/Cambridge_Bay", "America/Denver|America/Edmonton", "America/Denver|America/Inuvik", "America/Denver|America/Shiprock", "America/Denver|America/Yellowknife", "America/Denver|Canada/Mountain", "America/Denver|MST7MDT", "America/Denver|Navajo", "America/Denver|US/Mountain", "America/Godthab|America/Nuuk", "America/Halifax|America/Glace_Bay", "America/Halifax|America/Goose_Bay", "America/Halifax|America/Moncton", "America/Halifax|America/Thule", "America/Halifax|Atlantic/Bermuda", "America/Halifax|Canada/Atlantic", "America/Havana|Cuba", "America/Lima|America/Bogota", "America/Lima|America/Eirunepe", "America/Lima|America/Guayaquil", "America/Lima|America/Porto_Acre", "America/Lima|America/Rio_Branco", "America/Lima|Brazil/Acre", "America/Lima|Etc/GMT+5", "America/Los_Angeles|America/Ensenada", "America/Los_Angeles|America/Santa_Isabel", "America/Los_Angeles|America/Tijuana", "America/Los_Angeles|America/Vancouver", "America/Los_Angeles|Canada/Pacific", "America/Los_Angeles|Mexico/BajaNorte", "America/Los_Angeles|PST8PDT", "America/Los_Angeles|US/Pacific", "America/Managua|America/Belize", "America/Managua|America/Costa_Rica", "America/Managua|America/El_Salvador", "America/Managua|America/Guatemala", "America/Managua|America/Regina", "America/Managua|America/Swift_Current", "America/Managua|America/Tegucigalpa", "America/Managua|Canada/Saskatchewan", "America/Mazatlan|Mexico/BajaSur", "America/Mexico_City|America/Bahia_Banderas", "America/Mexico_City|America/Merida", "America/Mexico_City|America/Monterrey", "America/Mexico_City|Mexico/General", "America/New_York|America/Detroit", "America/New_York|America/Fort_Wayne", "America/New_York|America/Grand_Turk", "America/New_York|America/Indiana/Indianapolis", "America/New_York|America/Indiana/Marengo", "America/New_York|America/Indiana/Petersburg", "America/New_York|America/Indiana/Vevay", "America/New_York|America/Indiana/Vincennes", "America/New_York|America/Indiana/Winamac", "America/New_York|America/Indianapolis", "America/New_York|America/Iqaluit", "America/New_York|America/Kentucky/Louisville", "America/New_York|America/Kentucky/Monticello", "America/New_York|America/Louisville", "America/New_York|America/Montreal", "America/New_York|America/Nassau", "America/New_York|America/Nipigon", "America/New_York|America/Pangnirtung", "America/New_York|America/Port-au-Prince", "America/New_York|America/Thunder_Bay", "America/New_York|America/Toronto", "America/New_York|Canada/Eastern", "America/New_York|EST5EDT", "America/New_York|US/East-Indiana", "America/New_York|US/Eastern", "America/New_York|US/Michigan", "America/Noronha|Atlantic/South_Georgia", "America/Noronha|Brazil/DeNoronha", "America/Noronha|Etc/GMT+2", "America/Panama|America/Atikokan", "America/Panama|America/Cancun", "America/Panama|America/Cayman", "America/Panama|America/Coral_Harbour", "America/Panama|America/Jamaica", "America/Panama|EST", "America/Panama|Jamaica", "America/Phoenix|America/Creston", "America/Phoenix|America/Dawson_Creek", "America/Phoenix|America/Fort_Nelson", "America/Phoenix|America/Hermosillo", "America/Phoenix|MST", "America/Phoenix|US/Arizona", "America/Santiago|Chile/Continental", "America/Santo_Domingo|America/Anguilla", "America/Santo_Domingo|America/Antigua", "America/Santo_Domingo|America/Aruba", "America/Santo_Domingo|America/Barbados", "America/Santo_Domingo|America/Blanc-Sablon", "America/Santo_Domingo|America/Curacao", "America/Santo_Domingo|America/Dominica", "America/Santo_Domingo|America/Grenada", "America/Santo_Domingo|America/Guadeloupe", "America/Santo_Domingo|America/Kralendijk", "America/Santo_Domingo|America/Lower_Princes", "America/Santo_Domingo|America/Marigot", "America/Santo_Domingo|America/Martinique", "America/Santo_Domingo|America/Montserrat", "America/Santo_Domingo|America/Port_of_Spain", "America/Santo_Domingo|America/Puerto_Rico", "America/Santo_Domingo|America/St_Barthelemy", "America/Santo_Domingo|America/St_Kitts", "America/Santo_Domingo|America/St_Lucia", "America/Santo_Domingo|America/St_Thomas", "America/Santo_Domingo|America/St_Vincent", "America/Santo_Domingo|America/Tortola", "America/Santo_Domingo|America/Virgin", "America/Sao_Paulo|America/Araguaina", "America/Sao_Paulo|America/Argentina/Buenos_Aires", "America/Sao_Paulo|America/Argentina/Catamarca", "America/Sao_Paulo|America/Argentina/ComodRivadavia", "America/Sao_Paulo|America/Argentina/Cordoba", "America/Sao_Paulo|America/Argentina/Jujuy", "America/Sao_Paulo|America/Argentina/La_Rioja", "America/Sao_Paulo|America/Argentina/Mendoza", "America/Sao_Paulo|America/Argentina/Rio_Gallegos", "America/Sao_Paulo|America/Argentina/Salta", "America/Sao_Paulo|America/Argentina/San_Juan", "America/Sao_Paulo|America/Argentina/San_Luis", "America/Sao_Paulo|America/Argentina/Tucuman", "America/Sao_Paulo|America/Argentina/Ushuaia", "America/Sao_Paulo|America/Bahia", "America/Sao_Paulo|America/Belem", "America/Sao_Paulo|America/Buenos_Aires", "America/Sao_Paulo|America/Catamarca", "America/Sao_Paulo|America/Cayenne", "America/Sao_Paulo|America/Cordoba", "America/Sao_Paulo|America/Fortaleza", "America/Sao_Paulo|America/Jujuy", "America/Sao_Paulo|America/Maceio", "America/Sao_Paulo|America/Mendoza", "America/Sao_Paulo|America/Montevideo", "America/Sao_Paulo|America/Paramaribo", "America/Sao_Paulo|America/Punta_Arenas", "America/Sao_Paulo|America/Recife", "America/Sao_Paulo|America/Rosario", "America/Sao_Paulo|America/Santarem", "America/Sao_Paulo|Antarctica/Palmer", "America/Sao_Paulo|Antarctica/Rothera", "America/Sao_Paulo|Atlantic/Stanley", "America/Sao_Paulo|Brazil/East", "America/Sao_Paulo|Etc/GMT+3", "America/St_Johns|Canada/Newfoundland", "America/Whitehorse|America/Dawson", "America/Whitehorse|Canada/Yukon", "Asia/Almaty|Asia/Qostanay", "Asia/Bangkok|Antarctica/Davis", "Asia/Bangkok|Asia/Barnaul", "Asia/Bangkok|Asia/Ho_Chi_Minh", "Asia/Bangkok|Asia/Hovd", "Asia/Bangkok|Asia/Krasnoyarsk", "Asia/Bangkok|Asia/Novokuznetsk", "Asia/Bangkok|Asia/Novosibirsk", "Asia/Bangkok|Asia/Phnom_Penh", "Asia/Bangkok|Asia/Saigon", "Asia/Bangkok|Asia/Tomsk", "Asia/Bangkok|Asia/Vientiane", "Asia/Bangkok|Etc/GMT-7", "Asia/Bangkok|Indian/Christmas", "Asia/Chita|Asia/Dili", "Asia/Chita|Asia/Khandyga", "Asia/Chita|Asia/Yakutsk", "Asia/Chita|Etc/GMT-9", "Asia/Chita|Pacific/Palau", "Asia/Dhaka|Asia/Bishkek", "Asia/Dhaka|Asia/Dacca", "Asia/Dhaka|Asia/Kashgar", "Asia/Dhaka|Asia/Omsk", "Asia/Dhaka|Asia/Thimbu", "Asia/Dhaka|Asia/Thimphu", "Asia/Dhaka|Asia/Urumqi", "Asia/Dhaka|Etc/GMT-6", "Asia/Dhaka|Indian/Chagos", "Asia/Dubai|Asia/Baku", "Asia/Dubai|Asia/Muscat", "Asia/Dubai|Asia/Tbilisi", "Asia/Dubai|Asia/Yerevan", "Asia/Dubai|Etc/GMT-4", "Asia/Dubai|Europe/Astrakhan", "Asia/Dubai|Europe/Samara", "Asia/Dubai|Europe/Saratov", "Asia/Dubai|Europe/Ulyanovsk", "Asia/Dubai|Indian/Mahe", "Asia/Dubai|Indian/Mauritius", "Asia/Dubai|Indian/Reunion", "Asia/Gaza|Asia/Hebron", "Asia/Hong_Kong|Hongkong", "Asia/Jakarta|Asia/Pontianak", "Asia/Jerusalem|Asia/Tel_Aviv", "Asia/Jerusalem|Israel", "Asia/Kamchatka|Asia/Anadyr", "Asia/Kamchatka|Etc/GMT-12", "Asia/Kamchatka|Kwajalein", "Asia/Kamchatka|Pacific/Funafuti", "Asia/Kamchatka|Pacific/Kwajalein", "Asia/Kamchatka|Pacific/Majuro", "Asia/Kamchatka|Pacific/Nauru", "Asia/Kamchatka|Pacific/Tarawa", "Asia/Kamchatka|Pacific/Wake", "Asia/Kamchatka|Pacific/Wallis", "Asia/Kathmandu|Asia/Katmandu", "Asia/Kolkata|Asia/Calcutta", "Asia/Kuala_Lumpur|Asia/Brunei", "Asia/Kuala_Lumpur|Asia/Choibalsan", "Asia/Kuala_Lumpur|Asia/Irkutsk", "Asia/Kuala_Lumpur|Asia/Kuching", "Asia/Kuala_Lumpur|Asia/Singapore", "Asia/Kuala_Lumpur|Asia/Ulaanbaatar", "Asia/Kuala_Lumpur|Asia/Ulan_Bator", "Asia/Kuala_Lumpur|Etc/GMT-8", "Asia/Kuala_Lumpur|Singapore", "Asia/Makassar|Asia/Ujung_Pandang", "Asia/Rangoon|Asia/Yangon", "Asia/Rangoon|Indian/Cocos", "Asia/Sakhalin|Asia/Magadan", "Asia/Sakhalin|Asia/Srednekolymsk", "Asia/Sakhalin|Etc/GMT-11", "Asia/Sakhalin|Pacific/Bougainville", "Asia/Sakhalin|Pacific/Efate", "Asia/Sakhalin|Pacific/Guadalcanal", "Asia/Sakhalin|Pacific/Kosrae", "Asia/Sakhalin|Pacific/Noumea", "Asia/Sakhalin|Pacific/Pohnpei", "Asia/Sakhalin|Pacific/Ponape", "Asia/Seoul|Asia/Pyongyang", "Asia/Seoul|ROK", "Asia/Shanghai|Asia/Chongqing", "Asia/Shanghai|Asia/Chungking", "Asia/Shanghai|Asia/Harbin", "Asia/Shanghai|Asia/Macao", "Asia/Shanghai|Asia/Macau", "Asia/Shanghai|Asia/Taipei", "Asia/Shanghai|PRC", "Asia/Shanghai|ROC", "Asia/Tashkent|Antarctica/Mawson", "Asia/Tashkent|Asia/Aqtau", "Asia/Tashkent|Asia/Aqtobe", "Asia/Tashkent|Asia/Ashgabat", "Asia/Tashkent|Asia/Ashkhabad", "Asia/Tashkent|Asia/Atyrau", "Asia/Tashkent|Asia/Dushanbe", "Asia/Tashkent|Asia/Oral", "Asia/Tashkent|Asia/Qyzylorda", "Asia/Tashkent|Asia/Samarkand", "Asia/Tashkent|Asia/Yekaterinburg", "Asia/Tashkent|Etc/GMT-5", "Asia/Tashkent|Indian/Kerguelen", "Asia/Tashkent|Indian/Maldives", "Asia/Tehran|Iran", "Asia/Tokyo|Japan", "Asia/Vladivostok|Antarctica/DumontDUrville", "Asia/Vladivostok|Asia/Ust-Nera", "Asia/Vladivostok|Etc/GMT-10", "Asia/Vladivostok|Pacific/Chuuk", "Asia/Vladivostok|Pacific/Port_Moresby", "Asia/Vladivostok|Pacific/Truk", "Asia/Vladivostok|Pacific/Yap", "Atlantic/Cape_Verde|Etc/GMT+1", "Australia/Adelaide|Australia/Broken_Hill", "Australia/Adelaide|Australia/South", "Australia/Adelaide|Australia/Yancowinna", "Australia/Brisbane|Australia/Lindeman", "Australia/Brisbane|Australia/Queensland", "Australia/Darwin|Australia/North", "Australia/Lord_Howe|Australia/LHI", "Australia/Perth|Australia/West", "Australia/Sydney|Antarctica/Macquarie", "Australia/Sydney|Australia/ACT", "Australia/Sydney|Australia/Canberra", "Australia/Sydney|Australia/Currie", "Australia/Sydney|Australia/Hobart", "Australia/Sydney|Australia/Melbourne", "Australia/Sydney|Australia/NSW", "Australia/Sydney|Australia/Tasmania", "Australia/Sydney|Australia/Victoria", "Etc/UTC|Etc/UCT", "Etc/UTC|Etc/Universal", "Etc/UTC|Etc/Zulu", "Etc/UTC|UCT", "Etc/UTC|UTC", "Etc/UTC|Universal", "Etc/UTC|Zulu", "Europe/Athens|Asia/Famagusta", "Europe/Athens|Asia/Nicosia", "Europe/Athens|EET", "Europe/Athens|Europe/Bucharest", "Europe/Athens|Europe/Helsinki", "Europe/Athens|Europe/Kiev", "Europe/Athens|Europe/Kyiv", "Europe/Athens|Europe/Mariehamn", "Europe/Athens|Europe/Nicosia", "Europe/Athens|Europe/Riga", "Europe/Athens|Europe/Sofia", "Europe/Athens|Europe/Tallinn", "Europe/Athens|Europe/Uzhgorod", "Europe/Athens|Europe/Vilnius", "Europe/Athens|Europe/Zaporozhye", "Europe/Chisinau|Europe/Tiraspol", "Europe/Dublin|Eire", "Europe/Istanbul|Antarctica/Syowa", "Europe/Istanbul|Asia/Aden", "Europe/Istanbul|Asia/Baghdad", "Europe/Istanbul|Asia/Bahrain", "Europe/Istanbul|Asia/Istanbul", "Europe/Istanbul|Asia/Kuwait", "Europe/Istanbul|Asia/Qatar", "Europe/Istanbul|Asia/Riyadh", "Europe/Istanbul|Etc/GMT-3", "Europe/Istanbul|Europe/Minsk", "Europe/Istanbul|Turkey", "Europe/Lisbon|Atlantic/Canary", "Europe/Lisbon|Atlantic/Faeroe", "Europe/Lisbon|Atlantic/Faroe", "Europe/Lisbon|Atlantic/Madeira", "Europe/Lisbon|Portugal", "Europe/Lisbon|WET", "Europe/London|Europe/Belfast", "Europe/London|Europe/Guernsey", "Europe/London|Europe/Isle_of_Man", "Europe/London|Europe/Jersey", "Europe/London|GB", "Europe/London|GB-Eire", "Europe/Moscow|Europe/Kirov", "Europe/Moscow|Europe/Simferopol", "Europe/Moscow|W-SU", "Europe/Paris|Africa/Ceuta", "Europe/Paris|Arctic/Longyearbyen", "Europe/Paris|Atlantic/Jan_Mayen", "Europe/Paris|CET", "Europe/Paris|Europe/Amsterdam", "Europe/Paris|Europe/Andorra", "Europe/Paris|Europe/Belgrade", "Europe/Paris|Europe/Berlin", "Europe/Paris|Europe/Bratislava", "Europe/Paris|Europe/Brussels", "Europe/Paris|Europe/Budapest", "Europe/Paris|Europe/Busingen", "Europe/Paris|Europe/Copenhagen", "Europe/Paris|Europe/Gibraltar", "Europe/Paris|Europe/Ljubljana", "Europe/Paris|Europe/Luxembourg", "Europe/Paris|Europe/Madrid", "Europe/Paris|Europe/Malta", "Europe/Paris|Europe/Monaco", "Europe/Paris|Europe/Oslo", "Europe/Paris|Europe/Podgorica", "Europe/Paris|Europe/Prague", "Europe/Paris|Europe/Rome", "Europe/Paris|Europe/San_Marino", "Europe/Paris|Europe/Sarajevo", "Europe/Paris|Europe/Skopje", "Europe/Paris|Europe/Stockholm", "Europe/Paris|Europe/Tirane", "Europe/Paris|Europe/Vaduz", "Europe/Paris|Europe/Vatican", "Europe/Paris|Europe/Vienna", "Europe/Paris|Europe/Warsaw", "Europe/Paris|Europe/Zagreb", "Europe/Paris|Europe/Zurich", "Europe/Paris|MET", "Europe/Paris|Poland", "Pacific/Auckland|Antarctica/McMurdo", "Pacific/Auckland|Antarctica/South_Pole", "Pacific/Auckland|NZ", "Pacific/Chatham|NZ-CHAT", "Pacific/Easter|Chile/EasterIsland", "Pacific/Galapagos|Etc/GMT+6", "Pacific/Gambier|Etc/GMT+9", "Pacific/Guam|Pacific/Saipan", "Pacific/Honolulu|HST", "Pacific/Honolulu|Pacific/Johnston", "Pacific/Honolulu|US/Hawaii", "Pacific/Kiritimati|Etc/GMT-14", "Pacific/Niue|Etc/GMT+11", "Pacific/Pago_Pago|Pacific/Midway", "Pacific/Pago_Pago|Pacific/Samoa", "Pacific/Pago_Pago|US/Samoa", "Pacific/Pitcairn|Etc/GMT+8", "Pacific/Tahiti|Etc/GMT+10", "Pacific/Tahiti|Pacific/Rarotonga", "Pacific/Tongatapu|Etc/GMT-13", "Pacific/Tongatapu|Pacific/Enderbury", "Pacific/Tongatapu|Pacific/Fakaofo", "Pacific/Tongatapu|Pacific/Kanton"],
    countries: ["AD|Europe/Andorra", "AE|Asia/Dubai", "AF|Asia/Kabul", "AG|America/Puerto_Rico America/Antigua", "AI|America/Puerto_Rico America/Anguilla", "AL|Europe/Tirane", "AM|Asia/Yerevan", "AO|Africa/Lagos Africa/Luanda", "AQ|Antarctica/Casey Antarctica/Davis Antarctica/Mawson Antarctica/Palmer Antarctica/Rothera Antarctica/Troll Antarctica/Vostok Pacific/Auckland Pacific/Port_Moresby Asia/Riyadh Asia/Singapore Antarctica/McMurdo Antarctica/DumontDUrville Antarctica/Syowa", "AR|America/Argentina/Buenos_Aires America/Argentina/Cordoba America/Argentina/Salta America/Argentina/Jujuy America/Argentina/Tucuman America/Argentina/Catamarca America/Argentina/La_Rioja America/Argentina/San_Juan America/Argentina/Mendoza America/Argentina/San_Luis America/Argentina/Rio_Gallegos America/Argentina/Ushuaia", "AS|Pacific/Pago_Pago", "AT|Europe/Vienna", "AU|Australia/Lord_Howe Antarctica/Macquarie Australia/Hobart Australia/Melbourne Australia/Sydney Australia/Broken_Hill Australia/Brisbane Australia/Lindeman Australia/Adelaide Australia/Darwin Australia/Perth Australia/Eucla Asia/Tokyo", "AW|America/Puerto_Rico America/Aruba", "AX|Europe/Helsinki Europe/Mariehamn", "AZ|Asia/Baku", "BA|Europe/Belgrade Europe/Sarajevo", "BB|America/Barbados", "BD|Asia/Dhaka", "BE|Europe/Brussels", "BF|Africa/Abidjan Africa/Ouagadougou", "BG|Europe/Sofia", "BH|Asia/Qatar Asia/Bahrain", "BI|Africa/Maputo Africa/Bujumbura", "BJ|Africa/Lagos Africa/Porto-Novo", "BL|America/Puerto_Rico America/St_Barthelemy", "BM|Atlantic/Bermuda", "BN|Asia/Kuching Asia/Brunei", "BO|America/La_Paz", "BQ|America/Puerto_Rico America/Kralendijk", "BR|America/Noronha America/Belem America/Fortaleza America/Recife America/Araguaina America/Maceio America/Bahia America/Sao_Paulo America/Campo_Grande America/Cuiaba America/Santarem America/Porto_Velho America/Boa_Vista America/Manaus America/Eirunepe America/Rio_Branco", "BS|America/Toronto America/Nassau", "BT|Asia/Thimphu", "BW|Africa/Maputo Africa/Gaborone", "BY|Europe/Minsk", "BZ|America/Belize", "CA|America/St_Johns America/Halifax America/Glace_Bay America/Moncton America/Goose_Bay America/Toronto America/Iqaluit America/Winnipeg America/Resolute America/Rankin_Inlet America/Regina America/Swift_Current America/Edmonton America/Cambridge_Bay America/Inuvik America/Dawson_Creek America/Fort_Nelson America/Whitehorse America/Dawson America/Vancouver America/Panama America/Puerto_Rico America/Phoenix America/Blanc-Sablon America/Atikokan America/Creston", "CC|Asia/Yangon Indian/Cocos", "CD|Africa/Maputo Africa/Lagos Africa/Kinshasa Africa/Lubumbashi", "CF|Africa/Lagos Africa/Bangui", "CG|Africa/Lagos Africa/Brazzaville", "CH|Europe/Zurich", "CI|Africa/Abidjan", "CK|Pacific/Rarotonga", "CL|America/Santiago America/Coyhaique America/Punta_Arenas Pacific/Easter", "CM|Africa/Lagos Africa/Douala", "CN|Asia/Shanghai Asia/Urumqi", "CO|America/Bogota", "CR|America/Costa_Rica", "CU|America/Havana", "CV|Atlantic/Cape_Verde", "CW|America/Puerto_Rico America/Curacao", "CX|Asia/Bangkok Indian/Christmas", "CY|Asia/Nicosia Asia/Famagusta", "CZ|Europe/Prague", "DE|Europe/Zurich Europe/Berlin Europe/Busingen", "DJ|Africa/Nairobi Africa/Djibouti", "DK|Europe/Berlin Europe/Copenhagen", "DM|America/Puerto_Rico America/Dominica", "DO|America/Santo_Domingo", "DZ|Africa/Algiers", "EC|America/Guayaquil Pacific/Galapagos", "EE|Europe/Tallinn", "EG|Africa/Cairo", "EH|Africa/El_Aaiun", "ER|Africa/Nairobi Africa/Asmara", "ES|Europe/Madrid Africa/Ceuta Atlantic/Canary", "ET|Africa/Nairobi Africa/Addis_Ababa", "FI|Europe/Helsinki", "FJ|Pacific/Fiji", "FK|Atlantic/Stanley", "FM|Pacific/Kosrae Pacific/Port_Moresby Pacific/Guadalcanal Pacific/Chuuk Pacific/Pohnpei", "FO|Atlantic/Faroe", "FR|Europe/Paris", "GA|Africa/Lagos Africa/Libreville", "GB|Europe/London", "GD|America/Puerto_Rico America/Grenada", "GE|Asia/Tbilisi", "GF|America/Cayenne", "GG|Europe/London Europe/Guernsey", "GH|Africa/Abidjan Africa/Accra", "GI|Europe/Gibraltar", "GL|America/Nuuk America/Danmarkshavn America/Scoresbysund America/Thule", "GM|Africa/Abidjan Africa/Banjul", "GN|Africa/Abidjan Africa/Conakry", "GP|America/Puerto_Rico America/Guadeloupe", "GQ|Africa/Lagos Africa/Malabo", "GR|Europe/Athens", "GS|Atlantic/South_Georgia", "GT|America/Guatemala", "GU|Pacific/Guam", "GW|Africa/Bissau", "GY|America/Guyana", "HK|Asia/Hong_Kong", "HN|America/Tegucigalpa", "HR|Europe/Belgrade Europe/Zagreb", "HT|America/Port-au-Prince", "HU|Europe/Budapest", "ID|Asia/Jakarta Asia/Pontianak Asia/Makassar Asia/Jayapura", "IE|Europe/Dublin", "IL|Asia/Jerusalem", "IM|Europe/London Europe/Isle_of_Man", "IN|Asia/Kolkata", "IO|Indian/Chagos", "IQ|Asia/Baghdad", "IR|Asia/Tehran", "IS|Africa/Abidjan Atlantic/Reykjavik", "IT|Europe/Rome", "JE|Europe/London Europe/Jersey", "JM|America/Jamaica", "JO|Asia/Amman", "JP|Asia/Tokyo", "KE|Africa/Nairobi", "KG|Asia/Bishkek", "KH|Asia/Bangkok Asia/Phnom_Penh", "KI|Pacific/Tarawa Pacific/Kanton Pacific/Kiritimati", "KM|Africa/Nairobi Indian/Comoro", "KN|America/Puerto_Rico America/St_Kitts", "KP|Asia/Pyongyang", "KR|Asia/Seoul", "KW|Asia/Riyadh Asia/Kuwait", "KY|America/Panama America/Cayman", "KZ|Asia/Almaty Asia/Qyzylorda Asia/Qostanay Asia/Aqtobe Asia/Aqtau Asia/Atyrau Asia/Oral", "LA|Asia/Bangkok Asia/Vientiane", "LB|Asia/Beirut", "LC|America/Puerto_Rico America/St_Lucia", "LI|Europe/Zurich Europe/Vaduz", "LK|Asia/Colombo", "LR|Africa/Monrovia", "LS|Africa/Johannesburg Africa/Maseru", "LT|Europe/Vilnius", "LU|Europe/Brussels Europe/Luxembourg", "LV|Europe/Riga", "LY|Africa/Tripoli", "MA|Africa/Casablanca", "MC|Europe/Paris Europe/Monaco", "MD|Europe/Chisinau", "ME|Europe/Belgrade Europe/Podgorica", "MF|America/Puerto_Rico America/Marigot", "MG|Africa/Nairobi Indian/Antananarivo", "MH|Pacific/Tarawa Pacific/Kwajalein Pacific/Majuro", "MK|Europe/Belgrade Europe/Skopje", "ML|Africa/Abidjan Africa/Bamako", "MM|Asia/Yangon", "MN|Asia/Ulaanbaatar Asia/Hovd", "MO|Asia/Macau", "MP|Pacific/Guam Pacific/Saipan", "MQ|America/Martinique", "MR|Africa/Abidjan Africa/Nouakchott", "MS|America/Puerto_Rico America/Montserrat", "MT|Europe/Malta", "MU|Indian/Mauritius", "MV|Indian/Maldives", "MW|Africa/Maputo Africa/Blantyre", "MX|America/Mexico_City America/Cancun America/Merida America/Monterrey America/Matamoros America/Chihuahua America/Ciudad_Juarez America/Ojinaga America/Mazatlan America/Bahia_Banderas America/Hermosillo America/Tijuana", "MY|Asia/Kuching Asia/Singapore Asia/Kuala_Lumpur", "MZ|Africa/Maputo", "NA|Africa/Windhoek", "NC|Pacific/Noumea", "NE|Africa/Lagos Africa/Niamey", "NF|Pacific/Norfolk", "NG|Africa/Lagos", "NI|America/Managua", "NL|Europe/Brussels Europe/Amsterdam", "NO|Europe/Berlin Europe/Oslo", "NP|Asia/Kathmandu", "NR|Pacific/Nauru", "NU|Pacific/Niue", "NZ|Pacific/Auckland Pacific/Chatham", "OM|Asia/Dubai Asia/Muscat", "PA|America/Panama", "PE|America/Lima", "PF|Pacific/Tahiti Pacific/Marquesas Pacific/Gambier", "PG|Pacific/Port_Moresby Pacific/Bougainville", "PH|Asia/Manila", "PK|Asia/Karachi", "PL|Europe/Warsaw", "PM|America/Miquelon", "PN|Pacific/Pitcairn", "PR|America/Puerto_Rico", "PS|Asia/Gaza Asia/Hebron", "PT|Europe/Lisbon Atlantic/Madeira Atlantic/Azores", "PW|Pacific/Palau", "PY|America/Asuncion", "QA|Asia/Qatar", "RE|Asia/Dubai Indian/Reunion", "RO|Europe/Bucharest", "RS|Europe/Belgrade", "RU|Europe/Kaliningrad Europe/Moscow Europe/Simferopol Europe/Kirov Europe/Volgograd Europe/Astrakhan Europe/Saratov Europe/Ulyanovsk Europe/Samara Asia/Yekaterinburg Asia/Omsk Asia/Novosibirsk Asia/Barnaul Asia/Tomsk Asia/Novokuznetsk Asia/Krasnoyarsk Asia/Irkutsk Asia/Chita Asia/Yakutsk Asia/Khandyga Asia/Vladivostok Asia/Ust-Nera Asia/Magadan Asia/Sakhalin Asia/Srednekolymsk Asia/Kamchatka Asia/Anadyr", "RW|Africa/Maputo Africa/Kigali", "SA|Asia/Riyadh", "SB|Pacific/Guadalcanal", "SC|Asia/Dubai Indian/Mahe", "SD|Africa/Khartoum", "SE|Europe/Berlin Europe/Stockholm", "SG|Asia/Singapore", "SH|Africa/Abidjan Atlantic/St_Helena", "SI|Europe/Belgrade Europe/Ljubljana", "SJ|Europe/Berlin Arctic/Longyearbyen", "SK|Europe/Prague Europe/Bratislava", "SL|Africa/Abidjan Africa/Freetown", "SM|Europe/Rome Europe/San_Marino", "SN|Africa/Abidjan Africa/Dakar", "SO|Africa/Nairobi Africa/Mogadishu", "SR|America/Paramaribo", "SS|Africa/Juba", "ST|Africa/Sao_Tome", "SV|America/El_Salvador", "SX|America/Puerto_Rico America/Lower_Princes", "SY|Asia/Damascus", "SZ|Africa/Johannesburg Africa/Mbabane", "TC|America/Grand_Turk", "TD|Africa/Ndjamena", "TF|Asia/Dubai Indian/Maldives Indian/Kerguelen", "TG|Africa/Abidjan Africa/Lome", "TH|Asia/Bangkok", "TJ|Asia/Dushanbe", "TK|Pacific/Fakaofo", "TL|Asia/Dili", "TM|Asia/Ashgabat", "TN|Africa/Tunis", "TO|Pacific/Tongatapu", "TR|Europe/Istanbul", "TT|America/Puerto_Rico America/Port_of_Spain", "TV|Pacific/Tarawa Pacific/Funafuti", "TW|Asia/Taipei", "TZ|Africa/Nairobi Africa/Dar_es_Salaam", "UA|Europe/Simferopol Europe/Kyiv", "UG|Africa/Nairobi Africa/Kampala", "UM|Pacific/Pago_Pago Pacific/Tarawa Pacific/Midway Pacific/Wake", "US|America/New_York America/Detroit America/Kentucky/Louisville America/Kentucky/Monticello America/Indiana/Indianapolis America/Indiana/Vincennes America/Indiana/Winamac America/Indiana/Marengo America/Indiana/Petersburg America/Indiana/Vevay America/Chicago America/Indiana/Tell_City America/Indiana/Knox America/Menominee America/North_Dakota/Center America/North_Dakota/New_Salem America/North_Dakota/Beulah America/Denver America/Boise America/Phoenix America/Los_Angeles America/Anchorage America/Juneau America/Sitka America/Metlakatla America/Yakutat America/Nome America/Adak Pacific/Honolulu", "UY|America/Montevideo", "UZ|Asia/Samarkand Asia/Tashkent", "VA|Europe/Rome Europe/Vatican", "VC|America/Puerto_Rico America/St_Vincent", "VE|America/Caracas", "VG|America/Puerto_Rico America/Tortola", "VI|America/Puerto_Rico America/St_Thomas", "VN|Asia/Bangkok Asia/Ho_Chi_Minh", "VU|Pacific/Efate", "WF|Pacific/Tarawa Pacific/Wallis", "WS|Pacific/Apia", "YE|Asia/Riyadh Asia/Aden", "YT|Africa/Nairobi Indian/Mayotte", "ZA|Africa/Johannesburg", "ZM|Africa/Maputo Africa/Lusaka", "ZW|Africa/Maputo Africa/Harare"]
  }), o;
});
/*! 
 * jQuery Steps v1.1.0 - 09/04/2014
 * Copyright (c) 2014 Rafael Staib (http://www.jquery-steps.com)
 * Licensed under MIT http://www.opensource.org/licenses/MIT
 */
;
(function ($, undefined) {
  $.fn.extend({
    _aria: function _aria(name, value) {
      return this.attr("aria-" + name, value);
    },
    _removeAria: function _removeAria(name) {
      return this.removeAttr("aria-" + name);
    },
    _enableAria: function _enableAria(enable) {
      return enable == null || enable ? this.removeClass("disabled")._aria("disabled", "false") : this.addClass("disabled")._aria("disabled", "true");
    },
    _showAria: function _showAria(show) {
      return show == null || show ? this.show()._aria("hidden", "false") : this.hide()._aria("hidden", "true");
    },
    _selectAria: function _selectAria(select) {
      return select == null || select ? this.addClass("current")._aria("selected", "true") : this.removeClass("current")._aria("selected", "false");
    },
    _id: function _id(id) {
      return id ? this.attr("id", id) : this.attr("id");
    }
  });
  if (!String.prototype.format) {
    String.prototype.format = function () {
      var args = arguments.length === 1 && $.isArray(arguments[0]) ? arguments[0] : arguments;
      var formattedString = this;
      for (var i = 0; i < args.length; i++) {
        var pattern = new RegExp("\\{" + i + "\\}", "gm");
        formattedString = formattedString.replace(pattern, args[i]);
      }
      return formattedString;
    };
  }

  /**
   * A global unique id count.
   *
   * @static
   * @private
   * @property _uniqueId
   * @type Integer
   **/
  var _uniqueId = 0;

  /**
   * The plugin prefix for cookies.
   *
   * @final
   * @private
   * @property _cookiePrefix
   * @type String
   **/
  var _cookiePrefix = "jQu3ry_5teps_St@te_";

  /**
   * Suffix for the unique tab id.
   *
   * @final
   * @private
   * @property _tabSuffix
   * @type String
   * @since 0.9.7
   **/
  var _tabSuffix = "-t-";

  /**
   * Suffix for the unique tabpanel id.
   *
   * @final
   * @private
   * @property _tabpanelSuffix
   * @type String
   * @since 0.9.7
   **/
  var _tabpanelSuffix = "-p-";

  /**
   * Suffix for the unique title id.
   *
   * @final
   * @private
   * @property _titleSuffix
   * @type String
   * @since 0.9.7
   **/
  var _titleSuffix = "-h-";

  /**
   * An error message for an "index out of range" error.
   *
   * @final
   * @private
   * @property _indexOutOfRangeErrorMessage
   * @type String
   **/
  var _indexOutOfRangeErrorMessage = "Index out of range.";

  /**
   * An error message for an "missing corresponding element" error.
   *
   * @final
   * @private
   * @property _missingCorrespondingElementErrorMessage
   * @type String
   **/
  var _missingCorrespondingElementErrorMessage = "One or more corresponding step {0} are missing.";

  /**
   * Adds a step to the cache.
   *
   * @static
   * @private
   * @method addStepToCache
   * @param wizard {Object} A jQuery wizard object
   * @param step {Object} The step object to add
   **/
  function addStepToCache(wizard, step) {
    getSteps(wizard).push(step);
  }
  function analyzeData(wizard, options, state) {
    var stepTitles = wizard.children(options.headerTag),
      stepContents = wizard.children(options.bodyTag);

    // Validate content
    if (stepTitles.length > stepContents.length) {
      throwError(_missingCorrespondingElementErrorMessage, "contents");
    } else if (stepTitles.length < stepContents.length) {
      throwError(_missingCorrespondingElementErrorMessage, "titles");
    }
    var startIndex = options.startIndex;
    state.stepCount = stepTitles.length;

    // Tries to load the saved state (step position)
    if (options.saveState && $.cookie) {
      var savedState = $.cookie(_cookiePrefix + getUniqueId(wizard));
      // Sets the saved position to the start index if not undefined or out of range 
      var savedIndex = parseInt(savedState, 0);
      if (!isNaN(savedIndex) && savedIndex < state.stepCount) {
        startIndex = savedIndex;
      }
    }
    state.currentIndex = startIndex;
    stepTitles.each(function (index) {
      var item = $(this),
        // item == header
        content = stepContents.eq(index),
        modeData = content.data("mode"),
        mode = modeData == null ? contentMode.html : getValidEnumValue(contentMode, /^\s*$/.test(modeData) || isNaN(modeData) ? modeData : parseInt(modeData, 0)),
        contentUrl = mode === contentMode.html || content.data("url") === undefined ? "" : content.data("url"),
        contentLoaded = mode !== contentMode.html && content.data("loaded") === "1",
        step = $.extend({}, stepModel, {
          title: item.html(),
          content: mode === contentMode.html ? content.html() : "",
          contentUrl: contentUrl,
          contentMode: mode,
          contentLoaded: contentLoaded
        });
      addStepToCache(wizard, step);
    });
  }

  /**
   * Triggers the onCanceled event.
   *
   * @static
   * @private
   * @method cancel
   * @param wizard {Object} The jQuery wizard object
   **/
  function cancel(wizard) {
    wizard.triggerHandler("canceled");
  }
  function decreaseCurrentIndexBy(state, decreaseBy) {
    return state.currentIndex - decreaseBy;
  }

  /**
   * Removes the control functionality completely and transforms the current state to the initial HTML structure.
   *
   * @static
   * @private
   * @method destroy
   * @param wizard {Object} A jQuery wizard object
   **/
  function destroy(wizard, options) {
    var eventNamespace = getEventNamespace(wizard);

    // Remove virtual data objects from the wizard
    wizard.unbind(eventNamespace).removeData("uid").removeData("options").removeData("state").removeData("steps").removeData("eventNamespace").find(".actions a").unbind(eventNamespace);

    // Remove attributes and CSS classes from the wizard
    wizard.removeClass(options.clearFixCssClass + " vertical");
    var contents = wizard.find(".content > *");

    // Remove virtual data objects from panels and their titles
    contents.removeData("loaded").removeData("mode").removeData("url");

    // Remove attributes, CSS classes and reset inline styles on all panels and their titles
    contents.removeAttr("id").removeAttr("role").removeAttr("tabindex").removeAttr("class").removeAttr("style")._removeAria("labelledby")._removeAria("hidden");

    // Empty panels if the mode is set to 'async' or 'iframe'
    wizard.find(".content > [data-mode='async'],.content > [data-mode='iframe']").empty();
    var wizardSubstitute = $("<{0} class=\"{1}\"></{0}>".format(wizard.get(0).tagName, wizard.attr("class")));
    var wizardId = wizard._id();
    if (wizardId != null && wizardId !== "") {
      wizardSubstitute._id(wizardId);
    }
    wizardSubstitute.html(wizard.find(".content").html());
    wizard.after(wizardSubstitute);
    wizard.remove();
    return wizardSubstitute;
  }

  /**
   * Triggers the onFinishing and onFinished event.
   *
   * @static
   * @private
   * @method finishStep
   * @param wizard {Object} The jQuery wizard object
   * @param state {Object} The state container of the current wizard
   **/
  function finishStep(wizard, state) {
    var currentStep = wizard.find(".steps li").eq(state.currentIndex);
    if (wizard.triggerHandler("finishing", [state.currentIndex])) {
      currentStep.addClass("done").removeClass("error");
      wizard.triggerHandler("finished", [state.currentIndex]);
    } else {
      currentStep.addClass("error");
    }
  }

  /**
   * Gets or creates if not exist an unique event namespace for the given wizard instance.
   *
   * @static
   * @private
   * @method getEventNamespace
   * @param wizard {Object} A jQuery wizard object
   * @return {String} Returns the unique event namespace for the given wizard
   */
  function getEventNamespace(wizard) {
    var eventNamespace = wizard.data("eventNamespace");
    if (eventNamespace == null) {
      eventNamespace = "." + getUniqueId(wizard);
      wizard.data("eventNamespace", eventNamespace);
    }
    return eventNamespace;
  }
  function getStepAnchor(wizard, index) {
    var uniqueId = getUniqueId(wizard);
    return wizard.find("#" + uniqueId + _tabSuffix + index);
  }
  function getStepPanel(wizard, index) {
    var uniqueId = getUniqueId(wizard);
    return wizard.find("#" + uniqueId + _tabpanelSuffix + index);
  }
  function getStepTitle(wizard, index) {
    var uniqueId = getUniqueId(wizard);
    return wizard.find("#" + uniqueId + _titleSuffix + index);
  }
  function getOptions(wizard) {
    return wizard.data("options");
  }
  function getState(wizard) {
    return wizard.data("state");
  }
  function getSteps(wizard) {
    return wizard.data("steps");
  }

  /**
   * Gets a specific step object by index.
   *
   * @static
   * @private
   * @method getStep
   * @param index {Integer} An integer that belongs to the position of a step
   * @return {Object} A specific step object
   **/
  function getStep(wizard, index) {
    var steps = getSteps(wizard);
    if (index < 0 || index >= steps.length) {
      throwError(_indexOutOfRangeErrorMessage);
    }
    return steps[index];
  }

  /**
   * Gets or creates if not exist an unique id from the given wizard instance.
   *
   * @static
   * @private
   * @method getUniqueId
   * @param wizard {Object} A jQuery wizard object
   * @return {String} Returns the unique id for the given wizard
   */
  function getUniqueId(wizard) {
    var uniqueId = wizard.data("uid");
    if (uniqueId == null) {
      uniqueId = wizard._id();
      if (uniqueId == null) {
        uniqueId = "steps-uid-".concat(_uniqueId);
        wizard._id(uniqueId);
      }
      _uniqueId++;
      wizard.data("uid", uniqueId);
    }
    return uniqueId;
  }

  /**
   * Gets a valid enum value by checking a specific enum key or value.
   * 
   * @static
   * @private
   * @method getValidEnumValue
   * @param enumType {Object} Type of enum
   * @param keyOrValue {Object} Key as `String` or value as `Integer` to check for
   */
  function getValidEnumValue(enumType, keyOrValue) {
    validateArgument("enumType", enumType);
    validateArgument("keyOrValue", keyOrValue);

    // Is key
    if (typeof keyOrValue === "string") {
      var value = enumType[keyOrValue];
      if (value === undefined) {
        throwError("The enum key '{0}' does not exist.", keyOrValue);
      }
      return value;
    }
    // Is value
    else if (typeof keyOrValue === "number") {
      for (var key in enumType) {
        if (enumType[key] === keyOrValue) {
          return keyOrValue;
        }
      }
      throwError("Invalid enum value '{0}'.", keyOrValue);
    }
    // Type is not supported
    else {
      throwError("Invalid key or value type.");
    }
  }

  /**
   * Routes to the next step.
   *
   * @static
   * @private
   * @method goToNextStep
   * @param wizard {Object} The jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   * @return {Boolean} Indicates whether the action executed
   **/
  function goToNextStep(wizard, options, state) {
    return paginationClick(wizard, options, state, increaseCurrentIndexBy(state, 1));
  }

  /**
   * Routes to the previous step.
   *
   * @static
   * @private
   * @method goToPreviousStep
   * @param wizard {Object} The jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   * @return {Boolean} Indicates whether the action executed
   **/
  function goToPreviousStep(wizard, options, state) {
    return paginationClick(wizard, options, state, decreaseCurrentIndexBy(state, 1));
  }

  /**
   * Routes to a specific step by a given index.
   *
   * @static
   * @private
   * @method goToStep
   * @param wizard {Object} The jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   * @param index {Integer} The position (zero-based) to route to
   * @return {Boolean} Indicates whether the action succeeded or failed
   **/
  function goToStep(wizard, options, state, index) {
    if (index < 0 || index >= state.stepCount) {
      throwError(_indexOutOfRangeErrorMessage);
    }
    if (options.forceMoveForward && index < state.currentIndex) {
      return;
    }
    var oldIndex = state.currentIndex;
    if (wizard.triggerHandler("stepChanging", [state.currentIndex, index])) {
      // Save new state
      state.currentIndex = index;
      saveCurrentStateToCookie(wizard, options, state);

      // Change visualisation
      refreshStepNavigation(wizard, options, state, oldIndex);
      refreshPagination(wizard, options, state);
      loadAsyncContent(wizard, options, state);
      startTransitionEffect(wizard, options, state, index, oldIndex, function () {
        wizard.triggerHandler("stepChanged", [index, oldIndex]);
      });
    } else {
      wizard.find(".steps li").eq(oldIndex).addClass("error");
    }
    return true;
  }
  function increaseCurrentIndexBy(state, increaseBy) {
    return state.currentIndex + increaseBy;
  }

  /**
   * Initializes the component.
   *
   * @static
   * @private
   * @method initialize
   * @param options {Object} The component settings
   **/
  function initialize(options) {
    /*jshint -W040 */
    var opts = $.extend(true, {}, defaults, options);
    return this.each(function () {
      var wizard = $(this);
      var state = {
        currentIndex: opts.startIndex,
        currentStep: null,
        stepCount: 0,
        transitionElement: null
      };

      // Create data container
      wizard.data("options", opts);
      wizard.data("state", state);
      wizard.data("steps", []);
      analyzeData(wizard, opts, state);
      render(wizard, opts, state);
      registerEvents(wizard, opts);

      // Trigger focus
      if (opts.autoFocus && _uniqueId === 0) {
        getStepAnchor(wizard, opts.startIndex).focus();
      }
      wizard.triggerHandler("init", [opts.startIndex]);
    });
  }

  /**
   * Inserts a new step to a specific position.
   *
   * @static
   * @private
   * @method insertStep
   * @param wizard {Object} The jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   * @param index {Integer} The position (zero-based) to add
   * @param step {Object} The step object to add
   * @example
   *     $("#wizard").steps().insert(0, {
   *         title: "Title",
   *         content: "", // optional
   *         contentMode: "async", // optional
   *         contentUrl: "/Content/Step/1" // optional
   *     });
   * @chainable
   **/
  function insertStep(wizard, options, state, index, step) {
    if (index < 0 || index > state.stepCount) {
      throwError(_indexOutOfRangeErrorMessage);
    }

    // TODO: Validate step object

    // Change data
    step = $.extend({}, stepModel, step);
    insertStepToCache(wizard, index, step);
    if (state.currentIndex !== state.stepCount && state.currentIndex >= index) {
      state.currentIndex++;
      saveCurrentStateToCookie(wizard, options, state);
    }
    state.stepCount++;
    var contentContainer = wizard.find(".content"),
      header = $("<{0}>{1}</{0}>".format(options.headerTag, step.title)),
      body = $("<{0}></{0}>".format(options.bodyTag));
    if (step.contentMode == null || step.contentMode === contentMode.html) {
      body.html(step.content);
    }
    if (index === 0) {
      contentContainer.prepend(body).prepend(header);
    } else {
      getStepPanel(wizard, index - 1).after(body).after(header);
    }
    renderBody(wizard, state, body, index);
    renderTitle(wizard, options, state, header, index);
    refreshSteps(wizard, options, state, index);
    if (index === state.currentIndex) {
      refreshStepNavigation(wizard, options, state);
    }
    refreshPagination(wizard, options, state);
    return wizard;
  }

  /**
   * Inserts a step object to the cache at a specific position.
   *
   * @static
   * @private
   * @method insertStepToCache
   * @param wizard {Object} A jQuery wizard object
   * @param index {Integer} The position (zero-based) to add
   * @param step {Object} The step object to add
   **/
  function insertStepToCache(wizard, index, step) {
    getSteps(wizard).splice(index, 0, step);
  }

  /**
   * Handles the keyup DOM event for pagination.
   *
   * @static
   * @private
   * @event keyup
   * @param event {Object} An event object
   */
  function keyUpHandler(event) {
    var wizard = $(this),
      options = getOptions(wizard),
      state = getState(wizard);
    if (options.suppressPaginationOnFocus && wizard.find(":focus").is(":input")) {
      event.preventDefault();
      return false;
    }
    var keyCodes = {
      left: 37,
      right: 39
    };
    if (event.keyCode === keyCodes.left) {
      event.preventDefault();
      goToPreviousStep(wizard, options, state);
    } else if (event.keyCode === keyCodes.right) {
      event.preventDefault();
      goToNextStep(wizard, options, state);
    }
  }

  /**
   * Loads and includes async content.
   *
   * @static
   * @private
   * @method loadAsyncContent
   * @param wizard {Object} A jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   */
  function loadAsyncContent(wizard, options, state) {
    if (state.stepCount > 0) {
      var currentIndex = state.currentIndex,
        currentStep = getStep(wizard, currentIndex);
      if (!options.enableContentCache || !currentStep.contentLoaded) {
        switch (getValidEnumValue(contentMode, currentStep.contentMode)) {
          case contentMode.iframe:
            wizard.find(".content > .body").eq(state.currentIndex).empty().html("<iframe src=\"" + currentStep.contentUrl + "\" frameborder=\"0\" scrolling=\"no\" />").data("loaded", "1");
            break;
          case contentMode.async:
            var currentStepContent = getStepPanel(wizard, currentIndex)._aria("busy", "true").empty().append(renderTemplate(options.loadingTemplate, {
              text: options.labels.loading
            }));
            $.ajax({
              url: currentStep.contentUrl,
              cache: false
            }).done(function (data) {
              currentStepContent.empty().html(data)._aria("busy", "false").data("loaded", "1");
              wizard.triggerHandler("contentLoaded", [currentIndex]);
            });
            break;
        }
      }
    }
  }

  /**
   * Fires the action next or previous click event.
   *
   * @static
   * @private
   * @method paginationClick
   * @param wizard {Object} The jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   * @param index {Integer} The position (zero-based) to route to
   * @return {Boolean} Indicates whether the event fired successfully or not
   **/
  function paginationClick(wizard, options, state, index) {
    var oldIndex = state.currentIndex;
    if (index >= 0 && index < state.stepCount && !(options.forceMoveForward && index < state.currentIndex)) {
      var anchor = getStepAnchor(wizard, index),
        parent = anchor.parent(),
        isDisabled = parent.hasClass("disabled");

      // Enable the step to make the anchor clickable!
      parent._enableAria();
      anchor.click();

      // An error occured
      if (oldIndex === state.currentIndex && isDisabled) {
        // Disable the step again if current index has not changed; prevents click action.
        parent._enableAria(false);
        return false;
      }
      return true;
    }
    return false;
  }

  /**
   * Fires when a pagination click happens.
   *
   * @static
   * @private
   * @event click
   * @param event {Object} An event object
   */
  function paginationClickHandler(event) {
    event.preventDefault();
    var anchor = $(this),
      wizard = anchor.parent().parent().parent().parent(),
      options = getOptions(wizard),
      state = getState(wizard),
      href = anchor.attr("href");
    switch (href.substring(href.lastIndexOf("#") + 1)) {
      case "cancel":
        cancel(wizard);
        break;
      case "finish":
        finishStep(wizard, state);
        break;
      case "next":
        goToNextStep(wizard, options, state);
        break;
      case "previous":
        goToPreviousStep(wizard, options, state);
        break;
    }
  }

  /**
   * Refreshs the visualization state for the entire pagination.
   *
   * @static
   * @private
   * @method refreshPagination
   * @param wizard {Object} A jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   */
  function refreshPagination(wizard, options, state) {
    if (options.enablePagination) {
      var finish = wizard.find(".actions a[href$='#finish']").parent(),
        next = wizard.find(".actions a[href$='#next']").parent();
      if (!options.forceMoveForward) {
        var previous = wizard.find(".actions a[href$='#previous']").parent();
        previous._enableAria(state.currentIndex > 0);
      }
      if (options.enableFinishButton && options.showFinishButtonAlways) {
        finish._enableAria(state.stepCount > 0);
        next._enableAria(state.stepCount > 1 && state.stepCount > state.currentIndex + 1);
      } else {
        finish._showAria(options.enableFinishButton && state.stepCount === state.currentIndex + 1);
        next._showAria(state.stepCount === 0 || state.stepCount > state.currentIndex + 1)._enableAria(state.stepCount > state.currentIndex + 1 || !options.enableFinishButton);
      }
    }
  }

  /**
   * Refreshs the visualization state for the step navigation (tabs).
   *
   * @static
   * @private
   * @method refreshStepNavigation
   * @param wizard {Object} A jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   * @param [oldIndex] {Integer} The index of the prior step
   */
  function refreshStepNavigation(wizard, options, state, oldIndex) {
    var currentOrNewStepAnchor = getStepAnchor(wizard, state.currentIndex),
      currentInfo = $("<span class=\"current-info audible\">" + options.labels.current + " </span>"),
      stepTitles = wizard.find(".content > .title");
    if (oldIndex != null) {
      var oldStepAnchor = getStepAnchor(wizard, oldIndex);
      oldStepAnchor.parent().addClass("done").removeClass("error")._selectAria(false);
      stepTitles.eq(oldIndex).removeClass("current").next(".body").removeClass("current");
      currentInfo = oldStepAnchor.find(".current-info");
      currentOrNewStepAnchor.focus();
    }
    currentOrNewStepAnchor.prepend(currentInfo).parent()._selectAria().removeClass("done")._enableAria();
    stepTitles.eq(state.currentIndex).addClass("current").next(".body").addClass("current");
  }

  /**
   * Refreshes step buttons and their related titles beyond a certain position.
   *
   * @static
   * @private
   * @method refreshSteps
   * @param wizard {Object} A jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   * @param index {Integer} The start point for refreshing ids
   */
  function refreshSteps(wizard, options, state, index) {
    var uniqueId = getUniqueId(wizard);
    for (var i = index; i < state.stepCount; i++) {
      var uniqueStepId = uniqueId + _tabSuffix + i,
        uniqueBodyId = uniqueId + _tabpanelSuffix + i,
        uniqueHeaderId = uniqueId + _titleSuffix + i,
        title = wizard.find(".title").eq(i)._id(uniqueHeaderId);
      wizard.find(".steps a").eq(i)._id(uniqueStepId)._aria("controls", uniqueBodyId).attr("href", "#" + uniqueHeaderId).html(renderTemplate(options.titleTemplate, {
        index: i + 1,
        title: title.html()
      }));
      wizard.find(".body").eq(i)._id(uniqueBodyId)._aria("labelledby", uniqueHeaderId);
    }
  }
  function registerEvents(wizard, options) {
    var eventNamespace = getEventNamespace(wizard);
    wizard.bind("canceled" + eventNamespace, options.onCanceled);
    wizard.bind("contentLoaded" + eventNamespace, options.onContentLoaded);
    wizard.bind("finishing" + eventNamespace, options.onFinishing);
    wizard.bind("finished" + eventNamespace, options.onFinished);
    wizard.bind("init" + eventNamespace, options.onInit);
    wizard.bind("stepChanging" + eventNamespace, options.onStepChanging);
    wizard.bind("stepChanged" + eventNamespace, options.onStepChanged);
    if (options.enableKeyNavigation) {
      wizard.bind("keyup" + eventNamespace, keyUpHandler);
    }
    wizard.find(".actions a").bind("click" + eventNamespace, paginationClickHandler);
  }

  /**
   * Removes a specific step by an given index.
   *
   * @static
   * @private
   * @method removeStep
   * @param wizard {Object} A jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   * @param index {Integer} The position (zero-based) of the step to remove
   * @return Indecates whether the item is removed.
   **/
  function removeStep(wizard, options, state, index) {
    // Index out of range and try deleting current item will return false.
    if (index < 0 || index >= state.stepCount || state.currentIndex === index) {
      return false;
    }

    // Change data
    removeStepFromCache(wizard, index);
    if (state.currentIndex > index) {
      state.currentIndex--;
      saveCurrentStateToCookie(wizard, options, state);
    }
    state.stepCount--;
    getStepTitle(wizard, index).remove();
    getStepPanel(wizard, index).remove();
    getStepAnchor(wizard, index).parent().remove();

    // Set the "first" class to the new first step button 
    if (index === 0) {
      wizard.find(".steps li").first().addClass("first");
    }

    // Set the "last" class to the new last step button 
    if (index === state.stepCount) {
      wizard.find(".steps li").eq(index).addClass("last");
    }
    refreshSteps(wizard, options, state, index);
    refreshPagination(wizard, options, state);
    return true;
  }
  function removeStepFromCache(wizard, index) {
    getSteps(wizard).splice(index, 1);
  }

  /**
   * Transforms the base html structure to a more sensible html structure.
   *
   * @static
   * @private
   * @method render
   * @param wizard {Object} A jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   **/
  function render(wizard, options, state) {
    // Create a content wrapper and copy HTML from the intial wizard structure
    var wrapperTemplate = "<{0} class=\"{1}\">{2}</{0}>",
      orientation = getValidEnumValue(stepsOrientation, options.stepsOrientation),
      verticalCssClass = orientation === stepsOrientation.vertical ? " vertical" : "",
      contentWrapper = $(wrapperTemplate.format(options.contentContainerTag, "content " + options.clearFixCssClass, wizard.html())),
      stepsWrapper = $(wrapperTemplate.format(options.stepsContainerTag, "steps " + options.clearFixCssClass, "<ul role=\"tablist\"></ul>")),
      stepTitles = contentWrapper.children(options.headerTag),
      stepContents = contentWrapper.children(options.bodyTag);

    // Transform the wizard wrapper and remove the inner HTML
    wizard.attr("role", "application").empty().append(stepsWrapper).append(contentWrapper).addClass(options.cssClass + " " + options.clearFixCssClass + verticalCssClass);

    // Add WIA-ARIA support
    stepContents.each(function (index) {
      renderBody(wizard, state, $(this), index);
    });
    stepTitles.each(function (index) {
      renderTitle(wizard, options, state, $(this), index);
    });
    refreshStepNavigation(wizard, options, state);
    renderPagination(wizard, options, state);
  }

  /**
   * Transforms the body to a proper tabpanel.
   *
   * @static
   * @private
   * @method renderBody
   * @param wizard {Object} A jQuery wizard object
   * @param body {Object} A jQuery body object
   * @param index {Integer} The position of the body
   */
  function renderBody(wizard, state, body, index) {
    var uniqueId = getUniqueId(wizard),
      uniqueBodyId = uniqueId + _tabpanelSuffix + index,
      uniqueHeaderId = uniqueId + _titleSuffix + index;
    body._id(uniqueBodyId).attr("role", "tabpanel")._aria("labelledby", uniqueHeaderId).addClass("body")._showAria(state.currentIndex === index);
  }

  /**
   * Renders a pagination if enabled.
   *
   * @static
   * @private
   * @method renderPagination
   * @param wizard {Object} A jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   */
  function renderPagination(wizard, options, state) {
    if (options.enablePagination) {
      var pagination = "<{0} class=\"actions {1}\"><ul role=\"menu\" aria-label=\"{2}\">{3}</ul></{0}>",
        buttonTemplate = "<li><a href=\"#{0}\" role=\"menuitem\">{1}</a></li>",
        buttons = "";
      if (!options.forceMoveForward) {
        buttons += buttonTemplate.format("previous", options.labels.previous);
      }
      buttons += buttonTemplate.format("next", options.labels.next);
      if (options.enableFinishButton) {
        buttons += buttonTemplate.format("finish", options.labels.finish);
      }
      if (options.enableCancelButton) {
        buttons += buttonTemplate.format("cancel", options.labels.cancel);
      }
      wizard.append(pagination.format(options.actionContainerTag, options.clearFixCssClass, options.labels.pagination, buttons));
      refreshPagination(wizard, options, state);
      loadAsyncContent(wizard, options, state);
    }
  }

  /**
   * Renders a template and replaces all placeholder.
   *
   * @static
   * @private
   * @method renderTemplate
   * @param template {String} A template
   * @param substitutes {Object} A list of substitute
   * @return {String} The rendered template
   */
  function renderTemplate(template, substitutes) {
    var matches = template.match(/#([a-z]*)#/gi);
    for (var i = 0; i < matches.length; i++) {
      var match = matches[i],
        key = match.substring(1, match.length - 1);
      if (substitutes[key] === undefined) {
        throwError("The key '{0}' does not exist in the substitute collection!", key);
      }
      template = template.replace(match, substitutes[key]);
    }
    return template;
  }

  /**
   * Transforms the title to a step item button.
   *
   * @static
   * @private
   * @method renderTitle
   * @param wizard {Object} A jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   * @param header {Object} A jQuery header object
   * @param index {Integer} The position of the header
   */
  function renderTitle(wizard, options, state, header, index) {
    var uniqueId = getUniqueId(wizard),
      uniqueStepId = uniqueId + _tabSuffix + index,
      uniqueBodyId = uniqueId + _tabpanelSuffix + index,
      uniqueHeaderId = uniqueId + _titleSuffix + index,
      stepCollection = wizard.find(".steps > ul"),
      title = renderTemplate(options.titleTemplate, {
        index: index + 1,
        title: header.html()
      }),
      stepItem = $("<li role=\"tab\"><a id=\"" + uniqueStepId + "\" href=\"#" + uniqueHeaderId + "\" aria-controls=\"" + uniqueBodyId + "\">" + title + "</a></li>");
    stepItem._enableAria(options.enableAllSteps || state.currentIndex > index);
    if (state.currentIndex > index) {
      stepItem.addClass("done");
    }
    header._id(uniqueHeaderId).attr("tabindex", "-1").addClass("title");
    if (index === 0) {
      stepCollection.prepend(stepItem);
    } else {
      stepCollection.find("li").eq(index - 1).after(stepItem);
    }

    // Set the "first" class to the new first step button
    if (index === 0) {
      stepCollection.find("li").removeClass("first").eq(index).addClass("first");
    }

    // Set the "last" class to the new last step button
    if (index === state.stepCount - 1) {
      stepCollection.find("li").removeClass("last").eq(index).addClass("last");
    }

    // Register click event
    stepItem.children("a").bind("click" + getEventNamespace(wizard), stepClickHandler);
  }

  /**
   * Saves the current state to a cookie.
   *
   * @static
   * @private
   * @method saveCurrentStateToCookie
   * @param wizard {Object} A jQuery wizard object
   * @param options {Object} Settings of the current wizard
   * @param state {Object} The state container of the current wizard
   */
  function saveCurrentStateToCookie(wizard, options, state) {
    if (options.saveState && $.cookie) {
      $.cookie(_cookiePrefix + getUniqueId(wizard), state.currentIndex);
    }
  }
  function startTransitionEffect(wizard, options, state, index, oldIndex, doneCallback) {
    var stepContents = wizard.find(".content > .body"),
      effect = getValidEnumValue(transitionEffect, options.transitionEffect),
      effectSpeed = options.transitionEffectSpeed,
      newStep = stepContents.eq(index),
      currentStep = stepContents.eq(oldIndex);
    switch (effect) {
      case transitionEffect.fade:
      case transitionEffect.slide:
        var hide = effect === transitionEffect.fade ? "fadeOut" : "slideUp",
          show = effect === transitionEffect.fade ? "fadeIn" : "slideDown";
        state.transitionElement = newStep;
        currentStep[hide](effectSpeed, function () {
          var wizard = $(this)._showAria(false).parent().parent(),
            state = getState(wizard);
          if (state.transitionElement) {
            state.transitionElement[show](effectSpeed, function () {
              $(this)._showAria();
            }).promise().done(doneCallback);
            state.transitionElement = null;
          }
        });
        break;
      case transitionEffect.slideLeft:
        var outerWidth = currentStep.outerWidth(true),
          posFadeOut = index > oldIndex ? -outerWidth : outerWidth,
          posFadeIn = index > oldIndex ? outerWidth : -outerWidth;
        $.when(currentStep.animate({
          left: posFadeOut
        }, effectSpeed, function () {
          $(this)._showAria(false);
        }), newStep.css("left", posFadeIn + "px")._showAria().animate({
          left: 0
        }, effectSpeed)).done(doneCallback);
        break;
      default:
        $.when(currentStep._showAria(false), newStep._showAria()).done(doneCallback);
        break;
    }
  }

  /**
   * Fires when a step click happens.
   *
   * @static
   * @private
   * @event click
   * @param event {Object} An event object
   */
  function stepClickHandler(event) {
    event.preventDefault();
    var anchor = $(this),
      wizard = anchor.parent().parent().parent().parent(),
      options = getOptions(wizard),
      state = getState(wizard),
      oldIndex = state.currentIndex;
    if (anchor.parent().is(":not(.disabled):not(.current)")) {
      var href = anchor.attr("href"),
        position = parseInt(href.substring(href.lastIndexOf("-") + 1), 0);
      goToStep(wizard, options, state, position);
    }

    // If nothing has changed
    if (oldIndex === state.currentIndex) {
      getStepAnchor(wizard, oldIndex).focus();
      return false;
    }
  }
  function throwError(message) {
    if (arguments.length > 1) {
      message = message.format(Array.prototype.slice.call(arguments, 1));
    }
    throw new Error(message);
  }

  /**
   * Checks an argument for null or undefined and throws an error if one check applies.
   *
   * @static
   * @private
   * @method validateArgument
   * @param argumentName {String} The name of the given argument
   * @param argumentValue {Object} The argument itself
   */
  function validateArgument(argumentName, argumentValue) {
    if (argumentValue == null) {
      throwError("The argument '{0}' is null or undefined.", argumentName);
    }
  }

  /**
   * Represents a jQuery wizard plugin.
   *
   * @class steps
   * @constructor
   * @param [method={}] The name of the method as `String` or an JSON object for initialization
   * @param [params=]* {Array} Additional arguments for a method call
   * @chainable
   **/
  $.fn.steps = function (method) {
    if ($.fn.steps[method]) {
      return $.fn.steps[method].apply(this, Array.prototype.slice.call(arguments, 1));
    } else if (_typeof(method) === "object" || !method) {
      return initialize.apply(this, arguments);
    } else {
      $.error("Method " + method + " does not exist on jQuery.steps");
    }
  };

  /**
   * Adds a new step.
   *
   * @method add
   * @param step {Object} The step object to add
   * @chainable
   **/
  $.fn.steps.add = function (step) {
    var state = getState(this);
    return insertStep(this, getOptions(this), state, state.stepCount, step);
  };

  /**
   * Removes the control functionality completely and transforms the current state to the initial HTML structure.
   *
   * @method destroy
   * @chainable
   **/
  $.fn.steps.destroy = function () {
    return destroy(this, getOptions(this));
  };

  /**
   * Triggers the onFinishing and onFinished event.
   *
   * @method finish
   **/
  $.fn.steps.finish = function () {
    finishStep(this, getState(this));
  };

  /**
   * Gets the current step index.
   *
   * @method getCurrentIndex
   * @return {Integer} The actual step index (zero-based)
   * @for steps
   **/
  $.fn.steps.getCurrentIndex = function () {
    return getState(this).currentIndex;
  };

  /**
   * Gets the current step object.
   *
   * @method getCurrentStep
   * @return {Object} The actual step object
   **/
  $.fn.steps.getCurrentStep = function () {
    return getStep(this, getState(this).currentIndex);
  };

  /**
   * Gets a specific step object by index.
   *
   * @method getStep
   * @param index {Integer} An integer that belongs to the position of a step
   * @return {Object} A specific step object
   **/
  $.fn.steps.getStep = function (index) {
    return getStep(this, index);
  };

  /**
   * Inserts a new step to a specific position.
   *
   * @method insert
   * @param index {Integer} The position (zero-based) to add
   * @param step {Object} The step object to add
   * @example
   *     $("#wizard").steps().insert(0, {
   *         title: "Title",
   *         content: "", // optional
   *         contentMode: "async", // optional
   *         contentUrl: "/Content/Step/1" // optional
   *     });
   * @chainable
   **/
  $.fn.steps.insert = function (index, step) {
    return insertStep(this, getOptions(this), getState(this), index, step);
  };

  /**
   * Routes to the next step.
   *
   * @method next
   * @return {Boolean} Indicates whether the action executed
   **/
  $.fn.steps.next = function () {
    return goToNextStep(this, getOptions(this), getState(this));
  };

  /**
   * Routes to the previous step.
   *
   * @method previous
   * @return {Boolean} Indicates whether the action executed
   **/
  $.fn.steps.previous = function () {
    return goToPreviousStep(this, getOptions(this), getState(this));
  };

  /**
   * Removes a specific step by an given index.
   *
   * @method remove
   * @param index {Integer} The position (zero-based) of the step to remove
   * @return Indecates whether the item is removed.
   **/
  $.fn.steps.remove = function (index) {
    return removeStep(this, getOptions(this), getState(this), index);
  };

  /**
   * Sets a specific step object by index.
   *
   * @method setStep
   * @param index {Integer} An integer that belongs to the position of a step
   * @param step {Object} The step object to change
   **/
  $.fn.steps.setStep = function (index, step) {
    throw new Error("Not yet implemented!");
  };

  /**
   * Skips an certain amount of steps.
   *
   * @method skip
   * @param count {Integer} The amount of steps that should be skipped
   * @return {Boolean} Indicates whether the action executed
   **/
  $.fn.steps.skip = function (count) {
    throw new Error("Not yet implemented!");
  };

  /**
   * An enum represents the different content types of a step and their loading mechanisms.
   *
   * @class contentMode
   * @for steps
   **/
  var contentMode = $.fn.steps.contentMode = {
    /**
     * HTML embedded content
     *
     * @readOnly
     * @property html
     * @type Integer
     * @for contentMode
     **/
    html: 0,
    /**
     * IFrame embedded content
     *
     * @readOnly
     * @property iframe
     * @type Integer
     * @for contentMode
     **/
    iframe: 1,
    /**
     * Async embedded content
     *
     * @readOnly
     * @property async
     * @type Integer
     * @for contentMode
     **/
    async: 2
  };

  /**
   * An enum represents the orientation of the steps navigation.
   *
   * @class stepsOrientation
   * @for steps
   **/
  var stepsOrientation = $.fn.steps.stepsOrientation = {
    /**
     * Horizontal orientation
     *
     * @readOnly
     * @property horizontal
     * @type Integer
     * @for stepsOrientation
     **/
    horizontal: 0,
    /**
     * Vertical orientation
     *
     * @readOnly
     * @property vertical
     * @type Integer
     * @for stepsOrientation
     **/
    vertical: 1
  };

  /**
   * An enum that represents the various transition animations.
   *
   * @class transitionEffect
   * @for steps
   **/
  var transitionEffect = $.fn.steps.transitionEffect = {
    /**
     * No transition animation
     *
     * @readOnly
     * @property none
     * @type Integer
     * @for transitionEffect
     **/
    none: 0,
    /**
     * Fade in transition
     *
     * @readOnly
     * @property fade
     * @type Integer
     * @for transitionEffect
     **/
    fade: 1,
    /**
     * Slide up transition
     *
     * @readOnly
     * @property slide
     * @type Integer
     * @for transitionEffect
     **/
    slide: 2,
    /**
     * Slide left transition
     *
     * @readOnly
     * @property slideLeft
     * @type Integer
     * @for transitionEffect
     **/
    slideLeft: 3
  };
  var stepModel = $.fn.steps.stepModel = {
    title: "",
    content: "",
    contentUrl: "",
    contentMode: contentMode.html,
    contentLoaded: false
  };

  /**
   * An object that represents the default settings.
   * There are two possibities to override the sub-properties.
   * Either by doing it generally (global) or on initialization.
   *
   * @static
   * @class defaults
   * @for steps
   * @example
   *   // Global approach
   *   $.steps.defaults.headerTag = "h3";
   * @example
   *   // Initialization approach
   *   $("#wizard").steps({ headerTag: "h3" });
   **/
  var defaults = $.fn.steps.defaults = {
    /**
     * The header tag is used to find the step button text within the declared wizard area.
     *
     * @property headerTag
     * @type String
     * @default "h1"
     * @for defaults
     **/
    headerTag: "h1",
    /**
     * The body tag is used to find the step content within the declared wizard area.
     *
     * @property bodyTag
     * @type String
     * @default "div"
     * @for defaults
     **/
    bodyTag: "div",
    /**
     * The content container tag which will be used to wrap all step contents.
     *
     * @property contentContainerTag
     * @type String
     * @default "div"
     * @for defaults
     **/
    contentContainerTag: "div",
    /**
     * The action container tag which will be used to wrap the pagination navigation.
     *
     * @property actionContainerTag
     * @type String
     * @default "div"
     * @for defaults
     **/
    actionContainerTag: "div",
    /**
     * The steps container tag which will be used to wrap the steps navigation.
     *
     * @property stepsContainerTag
     * @type String
     * @default "div"
     * @for defaults
     **/
    stepsContainerTag: "div",
    /**
     * The css class which will be added to the outer component wrapper.
     *
     * @property cssClass
     * @type String
     * @default "wizard"
     * @for defaults
     * @example
     *     <div class="wizard">
     *         ...
     *     </div>
     **/
    cssClass: "wizard",
    /**
     * The css class which will be used for floating scenarios.
     *
     * @property clearFixCssClass
     * @type String
     * @default "clearfix"
     * @for defaults
     **/
    clearFixCssClass: "clearfix",
    /**
     * Determines whether the steps are vertically or horizontally oriented.
     *
     * @property stepsOrientation
     * @type stepsOrientation
     * @default horizontal
     * @for defaults
     * @since 1.0.0
     **/
    stepsOrientation: stepsOrientation.horizontal,
    /*
     * Tempplates
     */

    /**
     * The title template which will be used to create a step button.
     *
     * @property titleTemplate
     * @type String
     * @default "<span class=\"number\">#index#.</span> #title#"
     * @for defaults
     **/
    titleTemplate: "<span class=\"number\">#index#.</span> #title#",
    /**
     * The loading template which will be used to create the loading animation.
     *
     * @property loadingTemplate
     * @type String
     * @default "<span class=\"spinner\"></span> #text#"
     * @for defaults
     **/
    loadingTemplate: "<span class=\"spinner\"></span> #text#",
    /*
     * Behaviour
     */

    /**
     * Sets the focus to the first wizard instance in order to enable the key navigation from the begining if `true`. 
     *
     * @property autoFocus
     * @type Boolean
     * @default false
     * @for defaults
     * @since 0.9.4
     **/
    autoFocus: false,
    /**
     * Enables all steps from the begining if `true` (all steps are clickable).
     *
     * @property enableAllSteps
     * @type Boolean
     * @default false
     * @for defaults
     **/
    enableAllSteps: false,
    /**
     * Enables keyboard navigation if `true` (arrow left and arrow right).
     *
     * @property enableKeyNavigation
     * @type Boolean
     * @default true
     * @for defaults
     **/
    enableKeyNavigation: true,
    /**
     * Enables pagination if `true`.
     *
     * @property enablePagination
     * @type Boolean
     * @default true
     * @for defaults
     **/
    enablePagination: true,
    /**
     * Suppresses pagination if a form field is focused.
     *
     * @property suppressPaginationOnFocus
     * @type Boolean
     * @default true
     * @for defaults
     **/
    suppressPaginationOnFocus: true,
    /**
     * Enables cache for async loaded or iframe embedded content.
     *
     * @property enableContentCache
     * @type Boolean
     * @default true
     * @for defaults
     **/
    enableContentCache: true,
    /**
     * Shows the cancel button if enabled.
     *
     * @property enableCancelButton
     * @type Boolean
     * @default false
     * @for defaults
     **/
    enableCancelButton: false,
    /**
     * Shows the finish button if enabled.
     *
     * @property enableFinishButton
     * @type Boolean
     * @default true
     * @for defaults
     **/
    enableFinishButton: true,
    /**
     * Not yet implemented.
     *
     * @property preloadContent
     * @type Boolean
     * @default false
     * @for defaults
     **/
    preloadContent: false,
    /**
     * Shows the finish button always (on each step; right beside the next button) if `true`. 
     * Otherwise the next button will be replaced by the finish button if the last step becomes active.
     *
     * @property showFinishButtonAlways
     * @type Boolean
     * @default false
     * @for defaults
     **/
    showFinishButtonAlways: false,
    /**
     * Prevents jumping to a previous step.
     *
     * @property forceMoveForward
     * @type Boolean
     * @default false
     * @for defaults
     **/
    forceMoveForward: false,
    /**
     * Saves the current state (step position) to a cookie.
     * By coming next time the last active step becomes activated.
     *
     * @property saveState
     * @type Boolean
     * @default false
     * @for defaults
     **/
    saveState: false,
    /**
     * The position to start on (zero-based).
     *
     * @property startIndex
     * @type Integer
     * @default 0
     * @for defaults
     **/
    startIndex: 0,
    /*
     * Animation Effect Configuration
     */

    /**
     * The animation effect which will be used for step transitions.
     *
     * @property transitionEffect
     * @type transitionEffect
     * @default none
     * @for defaults
     **/
    transitionEffect: transitionEffect.none,
    /**
     * Animation speed for step transitions (in milliseconds).
     *
     * @property transitionEffectSpeed
     * @type Integer
     * @default 200
     * @for defaults
     **/
    transitionEffectSpeed: 200,
    /*
     * Events
     */

    /**
     * Fires before the step changes and can be used to prevent step changing by returning `false`. 
     * Very useful for form validation. 
     *
     * @property onStepChanging
     * @type Event
     * @default function (event, currentIndex, newIndex) { return true; }
     * @for defaults
     **/
    onStepChanging: function onStepChanging(event, currentIndex, newIndex) {
      return true;
    },
    /**
     * Fires after the step has change. 
     *
     * @property onStepChanged
     * @type Event
     * @default function (event, currentIndex, priorIndex) { }
     * @for defaults
     **/
    onStepChanged: function onStepChanged(event, currentIndex, priorIndex) {},
    /**
     * Fires after cancelation. 
     *
     * @property onCanceled
     * @type Event
     * @default function (event) { }
     * @for defaults
     **/
    onCanceled: function onCanceled(event) {},
    /**
     * Fires before finishing and can be used to prevent completion by returning `false`. 
     * Very useful for form validation. 
     *
     * @property onFinishing
     * @type Event
     * @default function (event, currentIndex) { return true; }
     * @for defaults
     **/
    onFinishing: function onFinishing(event, currentIndex) {
      return true;
    },
    /**
     * Fires after completion. 
     *
     * @property onFinished
     * @type Event
     * @default function (event, currentIndex) { }
     * @for defaults
     **/
    onFinished: function onFinished(event, currentIndex) {},
    /**
     * Fires after async content is loaded. 
     *
     * @property onContentLoaded
     * @type Event
     * @default function (event, index) { }
     * @for defaults
     **/
    onContentLoaded: function onContentLoaded(event, currentIndex) {},
    /**
     * Fires when the wizard is initialized. 
     *
     * @property onInit
     * @type Event
     * @default function (event) { }
     * @for defaults
     **/
    onInit: function onInit(event, currentIndex) {},
    /**
     * Contains all labels. 
     *
     * @property labels
     * @type Object
     * @for defaults
     **/
    labels: {
      /**
       * Label for the cancel button.
       *
       * @property cancel
       * @type String
       * @default "Cancel"
       * @for defaults
       **/
      cancel: "Cancel",
      /**
       * This label is important for accessability reasons.
       * Indicates which step is activated.
       *
       * @property current
       * @type String
       * @default "current step:"
       * @for defaults
       **/
      current: "current step:",
      /**
       * This label is important for accessability reasons and describes the kind of navigation.
       *
       * @property pagination
       * @type String
       * @default "Pagination"
       * @for defaults
       * @since 0.9.7
       **/
      pagination: "Pagination",
      /**
       * Label for the finish button.
       *
       * @property finish
       * @type String
       * @default "Finish"
       * @for defaults
       **/
      finish: "Finish",
      /**
       * Label for the next button.
       *
       * @property next
       * @type String
       * @default "Next"
       * @for defaults
       **/
      next: "Next",
      /**
       * Label for the previous button.
       *
       * @property previous
       * @type String
       * @default "Previous"
       * @for defaults
       **/
      previous: "Previous",
      /**
       * Label for the loading animation.
       *
       * @property loading
       * @type String
       * @default "Loading ..."
       * @for defaults
       **/
      loading: "Loading ..."
    }
  };
})(jQuery);
/**
 * @license Kasper Lewau
 * (c) 2015 Kasper Lewau https://github.com/kasperlewau
 * License: MIT
 */

(function () {
  'use strict';

  /**
   * @ngdoc method
   * @name  setupNotifier
   * @kind function
   * @description
   *
   * Utility method to setup watcher(s) on the given scope
   * and register a $broadcast callback for the watcher(s).
   *
   * @param {Object} scope - the scope to attach watchers and broadcast from
   * @param {Object} notifierMap - key:value mapping of notifiers and expressions to watch.
   */
  function setupNotifier(scope, notifierMap) {
    function handler(notifierKey, newValue, oldValue) {
      if (newValue !== oldValue) {
        scope.$broadcast('$$rebind::' + notifierKey);
      }
    }
    Object.keys(notifierMap).forEach(function (k) {
      scope.$watch(notifierMap[k], handler.bind(null, k), _typeof(scope[notifierMap[k]]) === 'object');
    });
  }

  /**
   * @ngdoc method
   * @name dynamicWatcher
   * @kind function
   * @description
   *
   * Utility method that extends a regular oneTimeWatchDelegate function with
   * scope listeners for each of the given notifier keys. When an event in the format of
   * '$$rebind::[notifierKey]' is caught in the associated $scope, a oneTimeWatchDelegate
   * will be called with the original options and reevaluate the given expression.
   *
   * If the given expr.$$watchDelegate has already been flagged as 'wrapped', we're hitting this
   * function again due to some caching behaviour of Angular expressions. In which case,
   * we should not register additional $on listeners, nor should we re-wrap the given expression.
   * Exit early o/
   *
   * @param {String|Function} expr - The expression to evaluate. Can be either a string or a function.
   * @param {Array} notifierKeys - An array of keys to setup $on listeners for.
   *
   * @returns {Function} wrap - A decorated oneTimeWatchDelegate function.
   */
  function dynamicWatcher(expr, notifierKeys) {
    if (expr.$$watchDelegate.wrapped) {
      return expr.$$watchDelegate;
    }
    function setupListeners(scope, cb) {
      notifierKeys.forEach(function (nk) {
        scope.$on('$$rebind::' + nk, cb);
      });
    }
    function wrapDelegate(watchDelegate, scope, listener, objectEquality, parsedExpression) {
      var delegateCall = watchDelegate.bind(this, scope, listener, objectEquality, parsedExpression);
      setupListeners(scope, delegateCall);
      return delegateCall();
    }
    var delegate = wrapDelegate.bind(this, expr.$$watchDelegate);
    delegate.wrapped = true;
    return delegate;
  }

  /**
   * Decorate the $parse service to allow to use our custom bind-notifier
   * syntax in the given application.
   *
   * It parses out all the leading notifiers and the last expression to be reevaluated
   * whenever the notifiers trigger it.
   *
   * @example Single Notifiers
   * ng-bind=":notifier:expression"
   * ng-repeat="x in :notifier:expression"
   * <span>{{:notifier:expression}}</span>
   *
   * @example Multiple Notifiers
   * ng-bind=":n1:n2:n3:expression"
   * ng-repeat="x in :n1:n2:n3:expression"
   * <span>{{:n1:n2:n3:expression}}</span>
   *
   * @example Object literals
   * ng-class=":n1:{ x: xExpr, y: yExpr }"
   * ng-bind=":n1:'string' | translate: { translate-value: 'x' }"
   */
  ParseDecorator.$inject = ['$provide'];
  function ParseDecorator($provide) {
    $parseDecorator.$inject = ['$delegate', 'bindNotifierRegex', 'bindNotifierKeyRegex'];
    function $parseDecorator($delegate, bindNotifierRegex, bindNotifierKeyRegex) {
      function wrapParse(parse, exp, interceptor) {
        var parts, part, expression, rawExpression, notifiers;
        if (typeof exp !== 'string' || !bindNotifierRegex.test(exp)) {
          return parse.call(this, exp, interceptor);
        }
        parts = exp.split(':');
        notifiers = [];
        while (parts.length) {
          part = parts.shift();
          if (part && part.trim()) {
            if (!bindNotifierKeyRegex.test(part)) {
              rawExpression = [part].concat(parts).join(':');
              break;
            }
            notifiers.push(part);
          }
        }
        if (!rawExpression) {
          rawExpression = notifiers.splice(-1, 1)[0];
        }
        expression = parse.call(this, '::' + rawExpression, interceptor);
        expression.$$watchDelegate = dynamicWatcher(expression, notifiers);
        return expression;
      }
      return wrapParse.bind(null, $delegate);
    }
    $provide.decorator('$parse', $parseDecorator);
  }

  /**
   * @ngdoc directive
   * @name bindNotifier
   * @restrict A
   * @priority 0
   * @description
   *
   * Adds the ability to notify all notifier-bindings within the newly
   * created child scope.
   *
   * Expects an object of the following format:
   *
   * { n1: expr1, n2: expr2 }
   *
   * where multiple keys can be supplied so as to allow for multiple
   * namespaces within the given scope. bind-notifier directives can be nested
   * at will.
   */
  function bindNotifierDirective() {
    return {
      restrict: 'A',
      scope: true,
      compile: function compile(element, attrs) {
        var notifierMap = {};
        var keyValues = attrs.bindNotifier.replace(/[\{\}\s]/g, '').split(',');
        keyValues.forEach(function (kv) {
          var split = kv.split(':');
          notifierMap[split[0]] = split[1];
        });
        return function (scope) {
          setupNotifier(scope, notifierMap);
        };
      }
    };
  }

  /**
   * @ngdoc factory
   * @name  $NotifierFactory
   * @kind function
   * @description
   *
   * Factory method, returning a $Notifier constructor fn.
   * Injected into controllers/directives for setting up
   * namespaced bindings without manual $broadcast work and/or
   * the usage of a notifier directive.
   *
   * @param {Object} scope - the scope to latch onto.
   * @param {Object} notifierMap - key:value mapping of notifiers and expressions to watch.
   *
   * @throws {Error} Throws an error if no scope was given.
   * @throws {Error} Throws an error if no notifierMap object was given.
   *
   * @returns {Function} $Notifier - $Notifier constructor function.
   *
   * @example
   *
    .controller('someCtrl', function ($scope, $Notifier) {
      scope.v1 = 'a';
      scope.v2 = 'b';
       new $Notifier($scope, {
        v1NameSpace: 'v1',
        v2NameSpace: 'v2'
      });
    });
   *
   */
  function $NotifierFactory() {
    return function $Notifier(scope, notifierMap) {
      if (!scope) {
        throw new Error('No $scope given');
      }
      if (!notifierMap) {
        throw new Error('No notifier object given');
      }
      setupNotifier(scope, notifierMap);
    };
  }

  /**
   * @ngdoc module
   * @name angular.bind.notifier
   * @module angular.bind.notifier
   * @description
   *
   * Third party Angular module filling the gap between static/dynamic
   * data binding by introducing a new pub/sub based syntax.
   *
   * The syntax builds upon the one-time binding syntax introduced in Angular 1.3
   * with the ability to set up a notification system (or, namespace) said
   * binds. This is done by passing in the namespace(s) between the first and second
   * one-time-bind colon's (::).
   *
   * Useful when model data is so seldomly updated that a regular
   * two-way binding is not warranted due to the internal $watcher required.
   */
  angular.module('angular.bind.notifier', []).constant('bindNotifierKeyRegex', /^[a-zA-Z0-9][\w-]*$/).constant('bindNotifierRegex', /^[\s]*:([a-zA-Z0-9][\w-]*):(.+\n?)+$/).factory('$Notifier', $NotifierFactory).directive('bindNotifier', bindNotifierDirective).config(ParseDecorator);
})();

/*
 *
 * https://github.com/fatlinesofcode/ngDraggable
 */
angular.module("ngDraggable", []).service('ngDraggable', [function () {
  var scope = this;
  scope.inputEvent = function (event) {
    if (angular.isDefined(event.touches)) {
      return event.touches[0];
    }
    //Checking both is not redundent. If only check if touches isDefined, angularjs isDefnied will return error and stop the remaining scripty if event.originalEvent is not defined.
    else if (angular.isDefined(event.originalEvent) && angular.isDefined(event.originalEvent.touches)) {
      return event.originalEvent.touches[0];
    }
    return event;
  };
  scope.touchTimeout = 100;
}]).directive('ngDrag', ['$rootScope', '$parse', '$document', '$window', 'ngDraggable', function ($rootScope, $parse, $document, $window, ngDraggable) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      scope.value = attrs.ngDrag;
      var offset,
        _centerAnchor = false,
        _mx,
        _my,
        _tx,
        _ty,
        _mrx,
        _mry;
      var _hasTouch = 'ontouchstart' in window || window.DocumentTouch && document instanceof DocumentTouch;
      var _pressEvents = 'touchstart mousedown';
      var _moveEvents = 'touchmove mousemove';
      var _releaseEvents = 'touchend mouseup';
      var _dragHandle;

      // to identify the element in order to prevent getting superflous events when a single element has both drag and drop directives on it.
      var _myid = scope.$id;
      var _data = null;
      var _dragOffset = null;
      var _dragEnabled = false;
      var _pressTimer = null;
      var onDragStartCallback = $parse(attrs.ngDragStart) || null;
      var onDragStopCallback = $parse(attrs.ngDragStop) || null;
      var onDragSuccessCallback = $parse(attrs.ngDragSuccess) || null;
      var allowTransform = angular.isDefined(attrs.allowTransform) ? scope.$eval(attrs.allowTransform) : true;
      var getDragData = $parse(attrs.ngDragData);

      // deregistration function for mouse move events in $rootScope triggered by jqLite trigger handler
      var _deregisterRootMoveListener = angular.noop;
      var initialize = function initialize() {
        element.attr('draggable', 'false'); // prevent native drag
        // check to see if drag handle(s) was specified
        // if querySelectorAll is available, we use this instead of find
        // as JQLite find is limited to tagnames
        if (element[0].querySelectorAll) {
          var dragHandles = angular.element(element[0].querySelectorAll('[ng-drag-handle]'));
        } else {
          var dragHandles = element.find('[ng-drag-handle]');
        }
        if (dragHandles.length) {
          _dragHandle = dragHandles;
        }
        toggleListeners(true);
      };
      var toggleListeners = function toggleListeners(enable) {
        if (!enable) return;
        // add listeners.

        scope.$on('$destroy', onDestroy);
        scope.$watch(attrs.ngDrag, onEnableChange);
        scope.$watch(attrs.ngCenterAnchor, onCenterAnchor);
        // wire up touch events
        if (_dragHandle) {
          // handle(s) specified, use those to initiate drag
          _dragHandle.on(_pressEvents, onpress);
        } else {
          // no handle(s) specified, use the element as the handle
          element.on(_pressEvents, onpress);
        }
        // if(! _hasTouch && element[0].nodeName.toLowerCase() == "img"){
        if (element[0].nodeName.toLowerCase() == "img") {
          element.on('mousedown', function () {
            return false;
          }); // prevent native drag for images
        }
      };
      var onDestroy = function onDestroy(enable) {
        toggleListeners(false);
      };
      var onEnableChange = function onEnableChange(newVal, oldVal) {
        _dragEnabled = newVal;
      };
      var onCenterAnchor = function onCenterAnchor(newVal, oldVal) {
        if (angular.isDefined(newVal)) _centerAnchor = newVal || 'true';
      };
      var isClickableElement = function isClickableElement(evt) {
        return angular.isDefined(angular.element(evt.target).attr("ng-cancel-drag"));
      };
      /*
       * When the element is clicked start the drag behaviour
       * On touch devices as a small delay so as not to prevent native window scrolling
       */
      var onpress = function onpress(evt) {
        // console.log("110"+" onpress: "+Math.random()+" "+ evt.type);
        if (!_dragEnabled) return;
        if (isClickableElement(evt)) {
          return;
        }
        if (evt.type == "mousedown" && evt.button != 0) {
          // Do not start dragging on right-click
          return;
        }
        var useTouch = evt.type === 'touchstart' ? true : false;
        if (useTouch) {
          _cancelPress();
          _pressTimer = setTimeout(function () {
            _cancelPress();
            onlongpress(evt);
          }, ngDraggable.touchTimeout);
          $document.on(_moveEvents, _cancelPress);
          $document.on(_releaseEvents, _cancelPress);
        } else {
          onlongpress(evt);
        }
      };
      var _cancelPress = function cancelPress() {
        clearTimeout(_pressTimer);
        $document.off(_moveEvents, _cancelPress);
        $document.off(_releaseEvents, _cancelPress);
      };
      var onlongpress = function onlongpress(evt) {
        if (!_dragEnabled) return;
        evt.preventDefault();
        offset = element[0].getBoundingClientRect();
        if (allowTransform) _dragOffset = offset;else {
          _dragOffset = {
            left: document.body.scrollLeft,
            top: document.body.scrollTop
          };
        }
        element.centerX = element[0].offsetWidth / 2;
        element.centerY = element[0].offsetHeight / 2;
        _mx = ngDraggable.inputEvent(evt).pageX; //ngDraggable.getEventProp(evt, 'pageX');
        _my = ngDraggable.inputEvent(evt).pageY; //ngDraggable.getEventProp(evt, 'pageY');
        _mrx = _mx - offset.left;
        _mry = _my - offset.top;
        if (_centerAnchor) {
          _tx = _mx - element.centerX - $window.pageXOffset;
          _ty = _my - element.centerY - $window.pageYOffset;
        } else {
          _tx = _mx - _mrx - $window.pageXOffset;
          _ty = _my - _mry - $window.pageYOffset;
        }
        $document.on(_moveEvents, onmove);
        $document.on(_releaseEvents, _onrelease);
        // This event is used to receive manually triggered mouse move events
        // jqLite unfortunately only supports triggerHandler(...)
        // See http://api.jquery.com/triggerHandler/
        // _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', onmove);
        _deregisterRootMoveListener = $rootScope.$on('draggable:_triggerHandlerMove', function (event, origEvent) {
          onmove(origEvent);
        });
      };
      var onmove = function onmove(evt) {
        if (!_dragEnabled) return;
        evt.preventDefault();
        if (!element.hasClass('dragging')) {
          _data = getDragData(scope);
          element.addClass('dragging');
          $rootScope.$broadcast('draggable:start', {
            x: _mx,
            y: _my,
            tx: _tx,
            ty: _ty,
            event: evt,
            element: element,
            data: _data
          });
          if (onDragStartCallback) {
            scope.$apply(function () {
              onDragStartCallback(scope, {
                $data: _data,
                $event: evt
              });
            });
          }
        }
        _mx = ngDraggable.inputEvent(evt).pageX; //ngDraggable.getEventProp(evt, 'pageX');
        _my = ngDraggable.inputEvent(evt).pageY; //ngDraggable.getEventProp(evt, 'pageY');

        if (_centerAnchor) {
          _tx = _mx - element.centerX - _dragOffset.left;
          _ty = _my - element.centerY - _dragOffset.top;
        } else {
          _tx = _mx - _mrx - _dragOffset.left;
          _ty = _my - _mry - _dragOffset.top;
        }
        moveElement(_tx, _ty);
        $rootScope.$broadcast('draggable:move', {
          x: _mx,
          y: _my,
          tx: _tx,
          ty: _ty,
          event: evt,
          element: element,
          data: _data,
          uid: _myid,
          dragOffset: _dragOffset
        });
      };
      var _onrelease = function onrelease(evt) {
        if (!_dragEnabled) return;
        evt.preventDefault();
        $rootScope.$broadcast('draggable:end', {
          x: _mx,
          y: _my,
          tx: _tx,
          ty: _ty,
          event: evt,
          element: element,
          data: _data,
          callback: onDragComplete,
          uid: _myid
        });
        element.removeClass('dragging');
        element.parent().find('.drag-enter').removeClass('drag-enter');
        reset();
        $document.off(_moveEvents, onmove);
        $document.off(_releaseEvents, _onrelease);
        if (onDragStopCallback) {
          scope.$apply(function () {
            onDragStopCallback(scope, {
              $data: _data,
              $event: evt
            });
          });
        }
        _deregisterRootMoveListener();
      };
      var onDragComplete = function onDragComplete(evt) {
        if (!onDragSuccessCallback) return;
        scope.$apply(function () {
          onDragSuccessCallback(scope, {
            $data: _data,
            $event: evt
          });
        });
      };
      var reset = function reset() {
        if (allowTransform) element.css({
          transform: '',
          'z-index': '',
          '-webkit-transform': '',
          '-ms-transform': ''
        });else element.css({
          'position': '',
          top: '',
          left: ''
        });
      };
      var moveElement = function moveElement(x, y) {
        if (allowTransform) {
          element.css({
            transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
            'z-index': 99999,
            '-webkit-transform': 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
            '-ms-transform': 'matrix(1, 0, 0, 1, ' + x + ', ' + y + ')'
          });
        } else {
          element.css({
            'left': x + 'px',
            'top': y + 'px',
            'position': 'fixed'
          });
        }
      };
      initialize();
    }
  };
}]).directive('ngDrop', ['$parse', '$timeout', '$window', '$document', 'ngDraggable', function ($parse, $timeout, $window, $document, ngDraggable) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      scope.value = attrs.ngDrop;
      scope.isTouching = false;
      var _lastDropTouch = null;
      var _myid = scope.$id;
      var _dropEnabled = false;
      var onDropCallback = $parse(attrs.ngDropSuccess); // || function(){};

      var onDragStartCallback = $parse(attrs.ngDragStart);
      var onDragStopCallback = $parse(attrs.ngDragStop);
      var onDragMoveCallback = $parse(attrs.ngDragMove);
      var initialize = function initialize() {
        toggleListeners(true);
      };
      var toggleListeners = function toggleListeners(enable) {
        // remove listeners

        if (!enable) return;
        // add listeners.
        scope.$watch(attrs.ngDrop, onEnableChange);
        scope.$on('$destroy', onDestroy);
        scope.$on('draggable:start', onDragStart);
        scope.$on('draggable:move', onDragMove);
        scope.$on('draggable:end', onDragEnd);
      };
      var onDestroy = function onDestroy(enable) {
        toggleListeners(false);
      };
      var onEnableChange = function onEnableChange(newVal, oldVal) {
        _dropEnabled = newVal;
      };
      var onDragStart = function onDragStart(evt, obj) {
        if (!_dropEnabled) return;
        isTouching(obj.x, obj.y, obj.element);
        if (attrs.ngDragStart) {
          $timeout(function () {
            onDragStartCallback(scope, {
              $data: obj.data,
              $event: obj
            });
          });
        }
      };
      var onDragMove = function onDragMove(evt, obj) {
        if (!_dropEnabled) return;
        isTouching(obj.x, obj.y, obj.element);
        if (attrs.ngDragMove) {
          $timeout(function () {
            onDragMoveCallback(scope, {
              $data: obj.data,
              $event: obj
            });
          });
        }
      };
      var onDragEnd = function onDragEnd(evt, obj) {
        // don't listen to drop events if this is the element being dragged
        // only update the styles and return
        if (!_dropEnabled || _myid === obj.uid) {
          updateDragStyles(false, obj.element);
          return;
        }
        if (isTouching(obj.x, obj.y, obj.element)) {
          // call the ngDraggable ngDragSuccess element callback
          if (obj.callback) {
            obj.callback(obj);
          }
          if (attrs.ngDropSuccess) {
            $timeout(function () {
              onDropCallback(scope, {
                $data: obj.data,
                $event: obj,
                $target: scope.$eval(scope.value)
              });
            });
          }
        }
        if (attrs.ngDragStop) {
          $timeout(function () {
            onDragStopCallback(scope, {
              $data: obj.data,
              $event: obj
            });
          });
        }
        updateDragStyles(false, obj.element);
      };
      var isTouching = function isTouching(mouseX, mouseY, dragElement) {
        var touching = hitTest(mouseX, mouseY);
        scope.isTouching = touching;
        if (touching) {
          _lastDropTouch = element;
        }
        updateDragStyles(touching, dragElement);
        return touching;
      };
      var updateDragStyles = function updateDragStyles(touching, dragElement) {
        if (touching) {
          element.addClass('drag-enter');
          dragElement.addClass('drag-over');
        } else if (_lastDropTouch == element) {
          _lastDropTouch = null;
          element.removeClass('drag-enter');
          dragElement.removeClass('drag-over');
        }
      };
      var hitTest = function hitTest(x, y) {
        var bounds = element[0].getBoundingClientRect(); // ngDraggable.getPrivOffset(element);
        x -= $document[0].body.scrollLeft + $document[0].documentElement.scrollLeft;
        y -= $document[0].body.scrollTop + $document[0].documentElement.scrollTop;
        return x >= bounds.left && x <= bounds.right && y <= bounds.bottom && y >= bounds.top;
      };
      initialize();
    }
  };
}]).directive('ngDragClone', ['$parse', '$timeout', 'ngDraggable', function ($parse, $timeout, ngDraggable) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var img,
        _allowClone = true;
      var _dragOffset = null;
      scope.clonedData = {};
      var initialize = function initialize() {
        img = element.find('img');
        element.attr('draggable', 'false');
        img.attr('draggable', 'false');
        reset();
        toggleListeners(true);
      };
      var toggleListeners = function toggleListeners(enable) {
        // remove listeners

        if (!enable) return;
        // add listeners.
        scope.$on('draggable:start', onDragStart);
        scope.$on('draggable:move', onDragMove);
        scope.$on('draggable:end', onDragEnd);
        preventContextMenu();
      };
      var preventContextMenu = function preventContextMenu() {
        //  element.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
        img.off('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
        //  element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
        img.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
      };
      var onDragStart = function onDragStart(evt, obj, elm) {
        _allowClone = true;
        if (angular.isDefined(obj.data.allowClone)) {
          _allowClone = obj.data.allowClone;
        }
        if (_allowClone) {
          scope.$apply(function () {
            scope.clonedData = obj.data;
          });
          element.css('width', obj.element[0].offsetWidth);
          element.css('height', obj.element[0].offsetHeight);
          moveElement(obj.tx, obj.ty);
        }
      };
      var onDragMove = function onDragMove(evt, obj) {
        if (_allowClone) {
          _tx = obj.tx + obj.dragOffset.left;
          _ty = obj.ty + obj.dragOffset.top;
          moveElement(_tx, _ty);
        }
      };
      var onDragEnd = function onDragEnd(evt, obj) {
        //moveElement(obj.tx,obj.ty);
        if (_allowClone) {
          reset();
        }
      };
      var reset = function reset() {
        element.css({
          left: 0,
          top: 0,
          position: 'fixed',
          'z-index': -1,
          visibility: 'hidden'
        });
      };
      var moveElement = function moveElement(x, y) {
        element.css({
          transform: 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
          'z-index': 99999,
          'visibility': 'visible',
          '-webkit-transform': 'matrix3d(1, 0, 0, 0, 0, 1, 0, 0, 0, 0, 1, 0, ' + x + ', ' + y + ', 0, 1)',
          '-ms-transform': 'matrix(1, 0, 0, 1, ' + x + ', ' + y + ')'
          //,margin: '0'  don't monkey with the margin,
        });
      };
      var absorbEvent_ = function absorbEvent_(event) {
        var e = event; //.originalEvent;
        e.preventDefault && e.preventDefault();
        e.stopPropagation && e.stopPropagation();
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
      };
      initialize();
    }
  };
}]).directive('ngPreventDrag', ['$parse', '$timeout', function ($parse, $timeout) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var initialize = function initialize() {
        element.attr('draggable', 'false');
        toggleListeners(true);
      };
      var toggleListeners = function toggleListeners(enable) {
        // remove listeners

        if (!enable) return;
        // add listeners.
        element.on('mousedown touchstart touchmove touchend touchcancel', absorbEvent_);
      };
      var absorbEvent_ = function absorbEvent_(event) {
        var e = event.originalEvent;
        e.preventDefault && e.preventDefault();
        e.stopPropagation && e.stopPropagation();
        e.cancelBubble = true;
        e.returnValue = false;
        return false;
      };
      initialize();
    }
  };
}]).directive('ngCancelDrag', [function () {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      element.find('*').attr('ng-cancel-drag', 'ng-cancel-drag');
    }
  };
}]).directive('ngDragScroll', ['$window', '$interval', '$timeout', '$document', '$rootScope', function ($window, $interval, $timeout, $document, $rootScope) {
  return {
    restrict: 'A',
    link: function link(scope, element, attrs) {
      var intervalPromise = null;
      var lastMouseEvent = null;
      var config = {
        verticalScroll: attrs.verticalScroll || true,
        horizontalScroll: attrs.horizontalScroll || true,
        activationDistance: attrs.activationDistance || 75,
        scrollDistance: attrs.scrollDistance || 15
      };
      var reqAnimFrame = function () {
        return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (/* function FrameRequestCallback */callback, /* DOMElement Element */element) {
          window.setTimeout(callback, 1000 / 60);
        };
      }();
      var animationIsOn = false;
      var createInterval = function createInterval() {
        animationIsOn = true;
        function nextFrame(callback) {
          var args = Array.prototype.slice.call(arguments);
          if (animationIsOn) {
            reqAnimFrame(function () {
              $rootScope.$apply(function () {
                callback.apply(null, args);
                nextFrame(callback);
              });
            });
          }
        }
        nextFrame(function () {
          if (!lastMouseEvent) return;
          var viewportWidth = Math.max(document.documentElement.clientWidth, window.innerWidth || 0);
          var viewportHeight = Math.max(document.documentElement.clientHeight, window.innerHeight || 0);
          var scrollX = 0;
          var scrollY = 0;
          if (config.horizontalScroll) {
            // If horizontal scrolling is active.
            if (lastMouseEvent.clientX < config.activationDistance) {
              // If the mouse is on the left of the viewport within the activation distance.
              scrollX = -config.scrollDistance;
            } else if (lastMouseEvent.clientX > viewportWidth - config.activationDistance) {
              // If the mouse is on the right of the viewport within the activation distance.
              scrollX = config.scrollDistance;
            }
          }
          if (config.verticalScroll) {
            // If vertical scrolling is active.
            if (lastMouseEvent.clientY < config.activationDistance) {
              // If the mouse is on the top of the viewport within the activation distance.
              scrollY = -config.scrollDistance;
            } else if (lastMouseEvent.clientY > viewportHeight - config.activationDistance) {
              // If the mouse is on the bottom of the viewport within the activation distance.
              scrollY = config.scrollDistance;
            }
          }
          if (scrollX !== 0 || scrollY !== 0) {
            // Record the current scroll position.
            var currentScrollLeft = $window.pageXOffset || $document[0].documentElement.scrollLeft;
            var currentScrollTop = $window.pageYOffset || $document[0].documentElement.scrollTop;

            // Remove the transformation from the element, scroll the window by the scroll distance
            // record how far we scrolled, then reapply the element transformation.
            var elementTransform = element.css('transform');
            element.css('transform', 'initial');
            $window.scrollBy(scrollX, scrollY);
            var horizontalScrollAmount = ($window.pageXOffset || $document[0].documentElement.scrollLeft) - currentScrollLeft;
            var verticalScrollAmount = ($window.pageYOffset || $document[0].documentElement.scrollTop) - currentScrollTop;
            element.css('transform', elementTransform);
            lastMouseEvent.pageX += horizontalScrollAmount;
            lastMouseEvent.pageY += verticalScrollAmount;
            $rootScope.$emit('draggable:_triggerHandlerMove', lastMouseEvent);
          }
        });
      };
      var clearInterval = function clearInterval() {
        animationIsOn = false;
      };
      scope.$on('draggable:start', function (event, obj) {
        // Ignore this event if it's not for this element.
        if (obj.element[0] !== element[0]) return;
        if (!animationIsOn) createInterval();
      });
      scope.$on('draggable:end', function (event, obj) {
        // Ignore this event if it's not for this element.
        if (obj.element[0] !== element[0]) return;
        if (animationIsOn) clearInterval();
      });
      scope.$on('draggable:move', function (event, obj) {
        // Ignore this event if it's not for this element.
        if (obj.element[0] !== element[0]) return;
        lastMouseEvent = obj.event;
      });
    }
  };
}]);

/*
 * Copyright (c) 2009 Nicholas C. Zakas
 *
 * Permission is hereby granted, free of charge, to any person obtaining a copy
 * of this software and associated documentation files (the "Software"), to deal
 * in the Software without restriction, including without limitation the rights
 * to use, copy, modify, merge, publish, distribute, sub-license, and/or sell
 * copies of the Software, and to permit persons to whom the Software is
 * furnished to do so, subject to the following conditions:
 *
 * The above copyright notice and this permission notice shall be included in
 * all copies or substantial portions of the Software.
 *
 * THE SOFTWARE IS PROVIDED "AS IS", WITHOUT WARRANTY OF ANY KIND, EXPRESS OR
 * IMPLIED, INCLUDING BUT NOT LIMITED TO THE WARRANTIES OF MERCHANTABILITY,
 * FITNESS FOR A PARTICULAR PURPOSE AND NONINFRINGEMENT. IN NO EVENT SHALL THE
 * AUTHORS OR COPYRIGHT HOLDERS BE LIABLE FOR ANY CLAIM, DAMAGES OR OTHER
 * LIABILITY, WHETHER IN AN ACTION OF CONTRACT, TORT OR OTHERWISE, ARISING FROM,
 * OUT OF OR IN CONNECTION WITH THE SOFTWARE OR THE USE OR OTHER DEALINGS IN
 * THE SOFTWARE.
 */
/*
	mousewheel (deprecated) -> IE6.0, Chrome, Opera, Safari
	DOMMouseScroll (deprecated) -> Firefox 1.0
	wheel (standard) -> Chrome 31, Firefox 17, IE9, Firefox Mobile 17.0

	//No need to use, use DOMMouseScroll
	MozMousePixelScroll -> Firefox 3.5, Firefox Mobile 1.0

	//Events
	WheelEvent -> see wheel
	MouseWheelEvent -> see mousewheel
	MouseScrollEvent -> Firefox 3.5, Firefox Mobile 1.0
*/
(function ($) {
  $.idleTimer = function (firstParam, elem, uniqueId) {
    var opts;
    if (_typeof(firstParam) === "object") {
      opts = firstParam;
      firstParam = null;
    } else if (typeof firstParam === "number") {
      opts = {
        timeout: firstParam
      };
      firstParam = null;
    }

    // element to watch
    elem = elem || document;
    uniqueId = uniqueId || "";

    // defaults that are to be stored as instance props on the elem
    opts = $.extend({
      idle: false,
      // indicates if the user is idle
      timeout: 30000,
      // the amount of time (ms) before the user is considered idle
      events: "mousemove keydown wheel DOMMouseScroll mousewheel mousedown touchstart touchmove MSPointerDown MSPointerMove" // define active events
    }, opts);
    var jqElem = $(elem),
      obj = jqElem.data("idleTimerObj" + uniqueId) || {},
      /* (intentionally not documented)
       * Toggles the idle state and fires an appropriate event.
       * @return {void}
       */
      toggleIdleState = function toggleIdleState(e) {
        var obj = $.data(elem, "idleTimerObj" + uniqueId) || {};

        // toggle the state
        obj.idle = !obj.idle;

        // store toggle state date time
        obj.olddate = +new Date();

        // create a custom event, with state and name space
        var event = $.Event((obj.idle ? "idle" : "active") + ".idleTimer" + uniqueId);

        // trigger event on object with elem and copy of obj
        $(elem).trigger(event, [elem, $.extend({}, obj), e]);
      },
      /**
       * Handle event triggers
       * @return {void}
       * @method event
       * @static
       */
      handleEvent = function handleEvent(e) {
        var obj = $.data(elem, "idleTimerObj" + uniqueId) || {};

        // ignore writting to storage unless related to idleTimer
        if (e.type === "storage" && e.originalEvent.key !== obj.timerSyncId) {
          return;
        }

        // this is already paused, ignore events for now
        if (obj.remaining != null) {
          return;
        }

        /*
        mousemove is kinda buggy, it can be triggered when it should be idle.
        Typically is happening between 115 - 150 milliseconds after idle triggered.
        @psyafter & @kaellis report "always triggered if using modal (jQuery ui, with overlay)"
        @thorst has similar issues on ios7 "after $.scrollTop() on text area"
        */
        if (e.type === "mousemove") {
          // if coord are same, it didn't move
          if (e.pageX === obj.pageX && e.pageY === obj.pageY) {
            return;
          }
          // if coord don't exist how could it move
          if (typeof e.pageX === "undefined" && typeof e.pageY === "undefined") {
            return;
          }
          // under 200 ms is hard to do, and you would have to stop, as continuous activity will bypass this
          var elapsed = +new Date() - obj.olddate;
          if (elapsed < 200) {
            return;
          }
        }

        // clear any existing timeout
        clearTimeout(obj.tId);

        // if the idle timer is enabled, flip
        if (obj.idle) {
          toggleIdleState(e);
        }

        // store when user was last active
        obj.lastActive = +new Date();

        // update mouse coord
        obj.pageX = e.pageX;
        obj.pageY = e.pageY;

        // sync lastActive
        if (e.type !== "storage" && obj.timerSyncId) {
          if (typeof localStorage !== "undefined") {
            localStorage.setItem(obj.timerSyncId, obj.lastActive);
          }
        }

        // set a new timeout
        obj.tId = setTimeout(toggleIdleState, obj.timeout);
      },
      /**
       * Restore initial settings and restart timer
       * @return {void}
       * @method reset
       * @static
       */
      reset = function reset() {
        var obj = $.data(elem, "idleTimerObj" + uniqueId) || {};

        // reset settings
        obj.idle = obj.idleBackup;
        obj.olddate = +new Date();
        obj.lastActive = obj.olddate;
        obj.remaining = null;

        // reset Timers
        clearTimeout(obj.tId);
        if (!obj.idle) {
          obj.tId = setTimeout(toggleIdleState, obj.timeout);
        }
      },
      /**
       * Store remaining time, stop timer
       * You can pause from an idle OR active state
       * @return {void}
       * @method pause
       * @static
       */
      pause = function pause() {
        var obj = $.data(elem, "idleTimerObj" + uniqueId) || {};

        // this is already paused
        if (obj.remaining != null) {
          return;
        }

        // define how much is left on the timer
        obj.remaining = obj.timeout - (+new Date() - obj.olddate);

        // clear any existing timeout
        clearTimeout(obj.tId);
      },
      /**
       * Start timer with remaining value
       * @return {void}
       * @method resume
       * @static
       */
      resume = function resume() {
        var obj = $.data(elem, "idleTimerObj" + uniqueId) || {};

        // this isn't paused yet
        if (obj.remaining == null) {
          return;
        }

        // start timer
        if (!obj.idle) {
          obj.tId = setTimeout(toggleIdleState, obj.remaining);
        }

        // clear remaining
        obj.remaining = null;
      },
      /**
       * Stops the idle timer. This removes appropriate event handlers
       * and cancels any pending timeouts.
       * @return {void}
       * @method destroy
       * @static
       */
      destroy = function destroy() {
        var obj = $.data(elem, "idleTimerObj" + uniqueId) || {};

        //clear any pending timeouts
        clearTimeout(obj.tId);

        //Remove data
        jqElem.removeData("idleTimerObj" + uniqueId);

        //detach the event handlers
        jqElem.off("._idleTimer" + uniqueId);
      },
      /**
      * Returns the time until becoming idle
      * @return {number}
      * @method remainingtime
      * @static
      */
      remainingtime = function remainingtime() {
        var obj = $.data(elem, "idleTimerObj" + uniqueId) || {};

        //If idle there is no time remaining
        if (obj.idle) {
          return 0;
        }

        //If its paused just return that
        if (obj.remaining != null) {
          return obj.remaining;
        }

        //Determine remaining, if negative idle didn't finish flipping, just return 0
        var remaining = obj.timeout - (+new Date() - obj.lastActive);
        if (remaining < 0) {
          remaining = 0;
        }

        //If this is paused return that number, else return current remaining
        return remaining;
      };

    // determine which function to call
    if (firstParam === null && typeof obj.idle !== "undefined") {
      // they think they want to init, but it already is, just reset
      reset();
      return jqElem;
    } else if (firstParam === null) {
      // they want to init
    } else if (firstParam !== null && typeof obj.idle === "undefined") {
      // they want to do something, but it isnt init
      // not sure the best way to handle this
      return false;
    } else if (firstParam === "destroy") {
      destroy();
      return jqElem;
    } else if (firstParam === "pause") {
      pause();
      return jqElem;
    } else if (firstParam === "resume") {
      resume();
      return jqElem;
    } else if (firstParam === "reset") {
      reset();
      return jqElem;
    } else if (firstParam === "getRemainingTime") {
      return remainingtime();
    } else if (firstParam === "getElapsedTime") {
      return +new Date() - obj.olddate;
    } else if (firstParam === "getLastActiveTime") {
      return obj.lastActive;
    } else if (firstParam === "isIdle") {
      return obj.idle;
    }

    // Test via a getter in the options object to see if the passive property is accessed
    // This isnt working in jquery, though is planned for 4.0
    // https://github.com/jquery/jquery/issues/2871
    /*var supportsPassive = false;
    try {
        var Popts = Object.defineProperty({}, "passive", {
            get: function() {
                supportsPassive = true;
            }
        });
        window.addEventListener("test", null, Popts);
    } catch (e) {}
    */

    /* (intentionally not documented)
     * Handles a user event indicating that the user isn't idle. namespaced with internal idleTimer
     * @param {Event} event A DOM2-normalized event object.
     * @return {void}
     */
    jqElem.on((opts.events + " ").split(" ").join("._idleTimer" + uniqueId + " ").trim(), function (e) {
      handleEvent(e);
    });
    //}, supportsPassive ? { passive: true } : false);

    if (opts.timerSyncId) {
      $(window).on("storage", handleEvent);
    }

    // Internal Object Properties, This isn't all necessary, but we
    // explicitly define all keys here so we know what we are working with
    obj = $.extend({}, {
      olddate: +new Date(),
      // the last time state changed
      lastActive: +new Date(),
      // the last time timer was active
      idle: opts.idle,
      // current state
      idleBackup: opts.idle,
      // backup of idle parameter since it gets modified
      timeout: opts.timeout,
      // the interval to change state
      remaining: null,
      // how long until state changes
      timerSyncId: opts.timerSyncId,
      // localStorage key to use for syncing this timer
      tId: null,
      // the idle timer setTimeout
      pageX: null,
      // used to store the mouse coord
      pageY: null
    });

    // set a timeout to toggle state. May wish to omit this in some situations
    if (!obj.idle) {
      obj.tId = setTimeout(toggleIdleState, obj.timeout);
    }

    // store our instance on the object
    $.data(elem, "idleTimerObj" + uniqueId, obj);
    return jqElem;
  };

  // This allows binding to element
  $.fn.idleTimer = function (firstParam, uniqueId) {
    if (this[0]) {
      return $.idleTimer(firstParam, this[0], uniqueId);
    }
    return this;
  };
})(jQuery);

/*!
 * Chart.js v2.9.4
 * https://www.chartjs.org
 * (c) 2020 Chart.js Contributors
 * Released under the MIT License
 */
(function (global, factory) {
  (typeof exports === "undefined" ? "undefined" : _typeof(exports)) === 'object' && typeof module !== 'undefined' ? module.exports = factory(function () {
    try {
      return require('moment');
    } catch (e) {}
  }()) : typeof define === 'function' && define.amd ? define(['require'], function (require) {
    return factory(function () {
      try {
        return require('moment');
      } catch (e) {}
    }());
  }) : (global = global || self, global.Chart = factory(global.moment));
})(this, function (moment) {
  'use strict';

  moment = moment && moment.hasOwnProperty('default') ? moment['default'] : moment;
  function createCommonjsModule(fn, module) {
    return module = {
      exports: {}
    }, fn(module, module.exports), module.exports;
  }
  function getCjsExportFromNamespace(n) {
    return n && n['default'] || n;
  }
  var colorName = {
    "aliceblue": [240, 248, 255],
    "antiquewhite": [250, 235, 215],
    "aqua": [0, 255, 255],
    "aquamarine": [127, 255, 212],
    "azure": [240, 255, 255],
    "beige": [245, 245, 220],
    "bisque": [255, 228, 196],
    "black": [0, 0, 0],
    "blanchedalmond": [255, 235, 205],
    "blue": [0, 0, 255],
    "blueviolet": [138, 43, 226],
    "brown": [165, 42, 42],
    "burlywood": [222, 184, 135],
    "cadetblue": [95, 158, 160],
    "chartreuse": [127, 255, 0],
    "chocolate": [210, 105, 30],
    "coral": [255, 127, 80],
    "cornflowerblue": [100, 149, 237],
    "cornsilk": [255, 248, 220],
    "crimson": [220, 20, 60],
    "cyan": [0, 255, 255],
    "darkblue": [0, 0, 139],
    "darkcyan": [0, 139, 139],
    "darkgoldenrod": [184, 134, 11],
    "darkgray": [169, 169, 169],
    "darkgreen": [0, 100, 0],
    "darkgrey": [169, 169, 169],
    "darkkhaki": [189, 183, 107],
    "darkmagenta": [139, 0, 139],
    "darkolivegreen": [85, 107, 47],
    "darkorange": [255, 140, 0],
    "darkorchid": [153, 50, 204],
    "darkred": [139, 0, 0],
    "darksalmon": [233, 150, 122],
    "darkseagreen": [143, 188, 143],
    "darkslateblue": [72, 61, 139],
    "darkslategray": [47, 79, 79],
    "darkslategrey": [47, 79, 79],
    "darkturquoise": [0, 206, 209],
    "darkviolet": [148, 0, 211],
    "deeppink": [255, 20, 147],
    "deepskyblue": [0, 191, 255],
    "dimgray": [105, 105, 105],
    "dimgrey": [105, 105, 105],
    "dodgerblue": [30, 144, 255],
    "firebrick": [178, 34, 34],
    "floralwhite": [255, 250, 240],
    "forestgreen": [34, 139, 34],
    "fuchsia": [255, 0, 255],
    "gainsboro": [220, 220, 220],
    "ghostwhite": [248, 248, 255],
    "gold": [255, 215, 0],
    "goldenrod": [218, 165, 32],
    "gray": [128, 128, 128],
    "green": [0, 128, 0],
    "greenyellow": [173, 255, 47],
    "grey": [128, 128, 128],
    "honeydew": [240, 255, 240],
    "hotpink": [255, 105, 180],
    "indianred": [205, 92, 92],
    "indigo": [75, 0, 130],
    "ivory": [255, 255, 240],
    "khaki": [240, 230, 140],
    "lavender": [230, 230, 250],
    "lavenderblush": [255, 240, 245],
    "lawngreen": [124, 252, 0],
    "lemonchiffon": [255, 250, 205],
    "lightblue": [173, 216, 230],
    "lightcoral": [240, 128, 128],
    "lightcyan": [224, 255, 255],
    "lightgoldenrodyellow": [250, 250, 210],
    "lightgray": [211, 211, 211],
    "lightgreen": [144, 238, 144],
    "lightgrey": [211, 211, 211],
    "lightpink": [255, 182, 193],
    "lightsalmon": [255, 160, 122],
    "lightseagreen": [32, 178, 170],
    "lightskyblue": [135, 206, 250],
    "lightslategray": [119, 136, 153],
    "lightslategrey": [119, 136, 153],
    "lightsteelblue": [176, 196, 222],
    "lightyellow": [255, 255, 224],
    "lime": [0, 255, 0],
    "limegreen": [50, 205, 50],
    "linen": [250, 240, 230],
    "magenta": [255, 0, 255],
    "maroon": [128, 0, 0],
    "mediumaquamarine": [102, 205, 170],
    "mediumblue": [0, 0, 205],
    "mediumorchid": [186, 85, 211],
    "mediumpurple": [147, 112, 219],
    "mediumseagreen": [60, 179, 113],
    "mediumslateblue": [123, 104, 238],
    "mediumspringgreen": [0, 250, 154],
    "mediumturquoise": [72, 209, 204],
    "mediumvioletred": [199, 21, 133],
    "midnightblue": [25, 25, 112],
    "mintcream": [245, 255, 250],
    "mistyrose": [255, 228, 225],
    "moccasin": [255, 228, 181],
    "navajowhite": [255, 222, 173],
    "navy": [0, 0, 128],
    "oldlace": [253, 245, 230],
    "olive": [128, 128, 0],
    "olivedrab": [107, 142, 35],
    "orange": [255, 165, 0],
    "orangered": [255, 69, 0],
    "orchid": [218, 112, 214],
    "palegoldenrod": [238, 232, 170],
    "palegreen": [152, 251, 152],
    "paleturquoise": [175, 238, 238],
    "palevioletred": [219, 112, 147],
    "papayawhip": [255, 239, 213],
    "peachpuff": [255, 218, 185],
    "peru": [205, 133, 63],
    "pink": [255, 192, 203],
    "plum": [221, 160, 221],
    "powderblue": [176, 224, 230],
    "purple": [128, 0, 128],
    "rebeccapurple": [102, 51, 153],
    "red": [255, 0, 0],
    "rosybrown": [188, 143, 143],
    "royalblue": [65, 105, 225],
    "saddlebrown": [139, 69, 19],
    "salmon": [250, 128, 114],
    "sandybrown": [244, 164, 96],
    "seagreen": [46, 139, 87],
    "seashell": [255, 245, 238],
    "sienna": [160, 82, 45],
    "silver": [192, 192, 192],
    "skyblue": [135, 206, 235],
    "slateblue": [106, 90, 205],
    "slategray": [112, 128, 144],
    "slategrey": [112, 128, 144],
    "snow": [255, 250, 250],
    "springgreen": [0, 255, 127],
    "steelblue": [70, 130, 180],
    "tan": [210, 180, 140],
    "teal": [0, 128, 128],
    "thistle": [216, 191, 216],
    "tomato": [255, 99, 71],
    "turquoise": [64, 224, 208],
    "violet": [238, 130, 238],
    "wheat": [245, 222, 179],
    "white": [255, 255, 255],
    "whitesmoke": [245, 245, 245],
    "yellow": [255, 255, 0],
    "yellowgreen": [154, 205, 50]
  };
  var conversions = createCommonjsModule(function (module) {
    /* MIT license */

    // NOTE: conversions should only return primitive values (i.e. arrays, or
    //       values that give correct `typeof` results).
    //       do not use box values types (i.e. Number(), String(), etc.)

    var reverseKeywords = {};
    for (var key in colorName) {
      if (colorName.hasOwnProperty(key)) {
        reverseKeywords[colorName[key]] = key;
      }
    }
    var convert = module.exports = {
      rgb: {
        channels: 3,
        labels: 'rgb'
      },
      hsl: {
        channels: 3,
        labels: 'hsl'
      },
      hsv: {
        channels: 3,
        labels: 'hsv'
      },
      hwb: {
        channels: 3,
        labels: 'hwb'
      },
      cmyk: {
        channels: 4,
        labels: 'cmyk'
      },
      xyz: {
        channels: 3,
        labels: 'xyz'
      },
      lab: {
        channels: 3,
        labels: 'lab'
      },
      lch: {
        channels: 3,
        labels: 'lch'
      },
      hex: {
        channels: 1,
        labels: ['hex']
      },
      keyword: {
        channels: 1,
        labels: ['keyword']
      },
      ansi16: {
        channels: 1,
        labels: ['ansi16']
      },
      ansi256: {
        channels: 1,
        labels: ['ansi256']
      },
      hcg: {
        channels: 3,
        labels: ['h', 'c', 'g']
      },
      apple: {
        channels: 3,
        labels: ['r16', 'g16', 'b16']
      },
      gray: {
        channels: 1,
        labels: ['gray']
      }
    };

    // hide .channels and .labels properties
    for (var model in convert) {
      if (convert.hasOwnProperty(model)) {
        if (!('channels' in convert[model])) {
          throw new Error('missing channels property: ' + model);
        }
        if (!('labels' in convert[model])) {
          throw new Error('missing channel labels property: ' + model);
        }
        if (convert[model].labels.length !== convert[model].channels) {
          throw new Error('channel and label counts mismatch: ' + model);
        }
        var channels = convert[model].channels;
        var labels = convert[model].labels;
        delete convert[model].channels;
        delete convert[model].labels;
        Object.defineProperty(convert[model], 'channels', {
          value: channels
        });
        Object.defineProperty(convert[model], 'labels', {
          value: labels
        });
      }
    }
    convert.rgb.hsl = function (rgb) {
      var r = rgb[0] / 255;
      var g = rgb[1] / 255;
      var b = rgb[2] / 255;
      var min = Math.min(r, g, b);
      var max = Math.max(r, g, b);
      var delta = max - min;
      var h;
      var s;
      var l;
      if (max === min) {
        h = 0;
      } else if (r === max) {
        h = (g - b) / delta;
      } else if (g === max) {
        h = 2 + (b - r) / delta;
      } else if (b === max) {
        h = 4 + (r - g) / delta;
      }
      h = Math.min(h * 60, 360);
      if (h < 0) {
        h += 360;
      }
      l = (min + max) / 2;
      if (max === min) {
        s = 0;
      } else if (l <= 0.5) {
        s = delta / (max + min);
      } else {
        s = delta / (2 - max - min);
      }
      return [h, s * 100, l * 100];
    };
    convert.rgb.hsv = function (rgb) {
      var rdif;
      var gdif;
      var bdif;
      var h;
      var s;
      var r = rgb[0] / 255;
      var g = rgb[1] / 255;
      var b = rgb[2] / 255;
      var v = Math.max(r, g, b);
      var diff = v - Math.min(r, g, b);
      var diffc = function diffc(c) {
        return (v - c) / 6 / diff + 1 / 2;
      };
      if (diff === 0) {
        h = s = 0;
      } else {
        s = diff / v;
        rdif = diffc(r);
        gdif = diffc(g);
        bdif = diffc(b);
        if (r === v) {
          h = bdif - gdif;
        } else if (g === v) {
          h = 1 / 3 + rdif - bdif;
        } else if (b === v) {
          h = 2 / 3 + gdif - rdif;
        }
        if (h < 0) {
          h += 1;
        } else if (h > 1) {
          h -= 1;
        }
      }
      return [h * 360, s * 100, v * 100];
    };
    convert.rgb.hwb = function (rgb) {
      var r = rgb[0];
      var g = rgb[1];
      var b = rgb[2];
      var h = convert.rgb.hsl(rgb)[0];
      var w = 1 / 255 * Math.min(r, Math.min(g, b));
      b = 1 - 1 / 255 * Math.max(r, Math.max(g, b));
      return [h, w * 100, b * 100];
    };
    convert.rgb.cmyk = function (rgb) {
      var r = rgb[0] / 255;
      var g = rgb[1] / 255;
      var b = rgb[2] / 255;
      var c;
      var m;
      var y;
      var k;
      k = Math.min(1 - r, 1 - g, 1 - b);
      c = (1 - r - k) / (1 - k) || 0;
      m = (1 - g - k) / (1 - k) || 0;
      y = (1 - b - k) / (1 - k) || 0;
      return [c * 100, m * 100, y * 100, k * 100];
    };

    /**
     * See https://en.m.wikipedia.org/wiki/Euclidean_distance#Squared_Euclidean_distance
     * */
    function comparativeDistance(x, y) {
      return Math.pow(x[0] - y[0], 2) + Math.pow(x[1] - y[1], 2) + Math.pow(x[2] - y[2], 2);
    }
    convert.rgb.keyword = function (rgb) {
      var reversed = reverseKeywords[rgb];
      if (reversed) {
        return reversed;
      }
      var currentClosestDistance = Infinity;
      var currentClosestKeyword;
      for (var keyword in colorName) {
        if (colorName.hasOwnProperty(keyword)) {
          var value = colorName[keyword];

          // Compute comparative distance
          var distance = comparativeDistance(rgb, value);

          // Check if its less, if so set as closest
          if (distance < currentClosestDistance) {
            currentClosestDistance = distance;
            currentClosestKeyword = keyword;
          }
        }
      }
      return currentClosestKeyword;
    };
    convert.keyword.rgb = function (keyword) {
      return colorName[keyword];
    };
    convert.rgb.xyz = function (rgb) {
      var r = rgb[0] / 255;
      var g = rgb[1] / 255;
      var b = rgb[2] / 255;

      // assume sRGB
      r = r > 0.04045 ? Math.pow((r + 0.055) / 1.055, 2.4) : r / 12.92;
      g = g > 0.04045 ? Math.pow((g + 0.055) / 1.055, 2.4) : g / 12.92;
      b = b > 0.04045 ? Math.pow((b + 0.055) / 1.055, 2.4) : b / 12.92;
      var x = r * 0.4124 + g * 0.3576 + b * 0.1805;
      var y = r * 0.2126 + g * 0.7152 + b * 0.0722;
      var z = r * 0.0193 + g * 0.1192 + b * 0.9505;
      return [x * 100, y * 100, z * 100];
    };
    convert.rgb.lab = function (rgb) {
      var xyz = convert.rgb.xyz(rgb);
      var x = xyz[0];
      var y = xyz[1];
      var z = xyz[2];
      var l;
      var a;
      var b;
      x /= 95.047;
      y /= 100;
      z /= 108.883;
      x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
      y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
      z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
      l = 116 * y - 16;
      a = 500 * (x - y);
      b = 200 * (y - z);
      return [l, a, b];
    };
    convert.hsl.rgb = function (hsl) {
      var h = hsl[0] / 360;
      var s = hsl[1] / 100;
      var l = hsl[2] / 100;
      var t1;
      var t2;
      var t3;
      var rgb;
      var val;
      if (s === 0) {
        val = l * 255;
        return [val, val, val];
      }
      if (l < 0.5) {
        t2 = l * (1 + s);
      } else {
        t2 = l + s - l * s;
      }
      t1 = 2 * l - t2;
      rgb = [0, 0, 0];
      for (var i = 0; i < 3; i++) {
        t3 = h + 1 / 3 * -(i - 1);
        if (t3 < 0) {
          t3++;
        }
        if (t3 > 1) {
          t3--;
        }
        if (6 * t3 < 1) {
          val = t1 + (t2 - t1) * 6 * t3;
        } else if (2 * t3 < 1) {
          val = t2;
        } else if (3 * t3 < 2) {
          val = t1 + (t2 - t1) * (2 / 3 - t3) * 6;
        } else {
          val = t1;
        }
        rgb[i] = val * 255;
      }
      return rgb;
    };
    convert.hsl.hsv = function (hsl) {
      var h = hsl[0];
      var s = hsl[1] / 100;
      var l = hsl[2] / 100;
      var smin = s;
      var lmin = Math.max(l, 0.01);
      var sv;
      var v;
      l *= 2;
      s *= l <= 1 ? l : 2 - l;
      smin *= lmin <= 1 ? lmin : 2 - lmin;
      v = (l + s) / 2;
      sv = l === 0 ? 2 * smin / (lmin + smin) : 2 * s / (l + s);
      return [h, sv * 100, v * 100];
    };
    convert.hsv.rgb = function (hsv) {
      var h = hsv[0] / 60;
      var s = hsv[1] / 100;
      var v = hsv[2] / 100;
      var hi = Math.floor(h) % 6;
      var f = h - Math.floor(h);
      var p = 255 * v * (1 - s);
      var q = 255 * v * (1 - s * f);
      var t = 255 * v * (1 - s * (1 - f));
      v *= 255;
      switch (hi) {
        case 0:
          return [v, t, p];
        case 1:
          return [q, v, p];
        case 2:
          return [p, v, t];
        case 3:
          return [p, q, v];
        case 4:
          return [t, p, v];
        case 5:
          return [v, p, q];
      }
    };
    convert.hsv.hsl = function (hsv) {
      var h = hsv[0];
      var s = hsv[1] / 100;
      var v = hsv[2] / 100;
      var vmin = Math.max(v, 0.01);
      var lmin;
      var sl;
      var l;
      l = (2 - s) * v;
      lmin = (2 - s) * vmin;
      sl = s * vmin;
      sl /= lmin <= 1 ? lmin : 2 - lmin;
      sl = sl || 0;
      l /= 2;
      return [h, sl * 100, l * 100];
    };

    // http://dev.w3.org/csswg/css-color/#hwb-to-rgb
    convert.hwb.rgb = function (hwb) {
      var h = hwb[0] / 360;
      var wh = hwb[1] / 100;
      var bl = hwb[2] / 100;
      var ratio = wh + bl;
      var i;
      var v;
      var f;
      var n;

      // wh + bl cant be > 1
      if (ratio > 1) {
        wh /= ratio;
        bl /= ratio;
      }
      i = Math.floor(6 * h);
      v = 1 - bl;
      f = 6 * h - i;
      if ((i & 0x01) !== 0) {
        f = 1 - f;
      }
      n = wh + f * (v - wh); // linear interpolation

      var r;
      var g;
      var b;
      switch (i) {
        default:
        case 6:
        case 0:
          r = v;
          g = n;
          b = wh;
          break;
        case 1:
          r = n;
          g = v;
          b = wh;
          break;
        case 2:
          r = wh;
          g = v;
          b = n;
          break;
        case 3:
          r = wh;
          g = n;
          b = v;
          break;
        case 4:
          r = n;
          g = wh;
          b = v;
          break;
        case 5:
          r = v;
          g = wh;
          b = n;
          break;
      }
      return [r * 255, g * 255, b * 255];
    };
    convert.cmyk.rgb = function (cmyk) {
      var c = cmyk[0] / 100;
      var m = cmyk[1] / 100;
      var y = cmyk[2] / 100;
      var k = cmyk[3] / 100;
      var r;
      var g;
      var b;
      r = 1 - Math.min(1, c * (1 - k) + k);
      g = 1 - Math.min(1, m * (1 - k) + k);
      b = 1 - Math.min(1, y * (1 - k) + k);
      return [r * 255, g * 255, b * 255];
    };
    convert.xyz.rgb = function (xyz) {
      var x = xyz[0] / 100;
      var y = xyz[1] / 100;
      var z = xyz[2] / 100;
      var r;
      var g;
      var b;
      r = x * 3.2406 + y * -1.5372 + z * -0.4986;
      g = x * -0.9689 + y * 1.8758 + z * 0.0415;
      b = x * 0.0557 + y * -0.2040 + z * 1.0570;

      // assume sRGB
      r = r > 0.0031308 ? 1.055 * Math.pow(r, 1.0 / 2.4) - 0.055 : r * 12.92;
      g = g > 0.0031308 ? 1.055 * Math.pow(g, 1.0 / 2.4) - 0.055 : g * 12.92;
      b = b > 0.0031308 ? 1.055 * Math.pow(b, 1.0 / 2.4) - 0.055 : b * 12.92;
      r = Math.min(Math.max(0, r), 1);
      g = Math.min(Math.max(0, g), 1);
      b = Math.min(Math.max(0, b), 1);
      return [r * 255, g * 255, b * 255];
    };
    convert.xyz.lab = function (xyz) {
      var x = xyz[0];
      var y = xyz[1];
      var z = xyz[2];
      var l;
      var a;
      var b;
      x /= 95.047;
      y /= 100;
      z /= 108.883;
      x = x > 0.008856 ? Math.pow(x, 1 / 3) : 7.787 * x + 16 / 116;
      y = y > 0.008856 ? Math.pow(y, 1 / 3) : 7.787 * y + 16 / 116;
      z = z > 0.008856 ? Math.pow(z, 1 / 3) : 7.787 * z + 16 / 116;
      l = 116 * y - 16;
      a = 500 * (x - y);
      b = 200 * (y - z);
      return [l, a, b];
    };
    convert.lab.xyz = function (lab) {
      var l = lab[0];
      var a = lab[1];
      var b = lab[2];
      var x;
      var y;
      var z;
      y = (l + 16) / 116;
      x = a / 500 + y;
      z = y - b / 200;
      var y2 = Math.pow(y, 3);
      var x2 = Math.pow(x, 3);
      var z2 = Math.pow(z, 3);
      y = y2 > 0.008856 ? y2 : (y - 16 / 116) / 7.787;
      x = x2 > 0.008856 ? x2 : (x - 16 / 116) / 7.787;
      z = z2 > 0.008856 ? z2 : (z - 16 / 116) / 7.787;
      x *= 95.047;
      y *= 100;
      z *= 108.883;
      return [x, y, z];
    };
    convert.lab.lch = function (lab) {
      var l = lab[0];
      var a = lab[1];
      var b = lab[2];
      var hr;
      var h;
      var c;
      hr = Math.atan2(b, a);
      h = hr * 360 / 2 / Math.PI;
      if (h < 0) {
        h += 360;
      }
      c = Math.sqrt(a * a + b * b);
      return [l, c, h];
    };
    convert.lch.lab = function (lch) {
      var l = lch[0];
      var c = lch[1];
      var h = lch[2];
      var a;
      var b;
      var hr;
      hr = h / 360 * 2 * Math.PI;
      a = c * Math.cos(hr);
      b = c * Math.sin(hr);
      return [l, a, b];
    };
    convert.rgb.ansi16 = function (args) {
      var r = args[0];
      var g = args[1];
      var b = args[2];
      var value = 1 in arguments ? arguments[1] : convert.rgb.hsv(args)[2]; // hsv -> ansi16 optimization

      value = Math.round(value / 50);
      if (value === 0) {
        return 30;
      }
      var ansi = 30 + (Math.round(b / 255) << 2 | Math.round(g / 255) << 1 | Math.round(r / 255));
      if (value === 2) {
        ansi += 60;
      }
      return ansi;
    };
    convert.hsv.ansi16 = function (args) {
      // optimization here; we already know the value and don't need to get
      // it converted for us.
      return convert.rgb.ansi16(convert.hsv.rgb(args), args[2]);
    };
    convert.rgb.ansi256 = function (args) {
      var r = args[0];
      var g = args[1];
      var b = args[2];

      // we use the extended greyscale palette here, with the exception of
      // black and white. normal palette only has 4 greyscale shades.
      if (r === g && g === b) {
        if (r < 8) {
          return 16;
        }
        if (r > 248) {
          return 231;
        }
        return Math.round((r - 8) / 247 * 24) + 232;
      }
      var ansi = 16 + 36 * Math.round(r / 255 * 5) + 6 * Math.round(g / 255 * 5) + Math.round(b / 255 * 5);
      return ansi;
    };
    convert.ansi16.rgb = function (args) {
      var color = args % 10;

      // handle greyscale
      if (color === 0 || color === 7) {
        if (args > 50) {
          color += 3.5;
        }
        color = color / 10.5 * 255;
        return [color, color, color];
      }
      var mult = (~~(args > 50) + 1) * 0.5;
      var r = (color & 1) * mult * 255;
      var g = (color >> 1 & 1) * mult * 255;
      var b = (color >> 2 & 1) * mult * 255;
      return [r, g, b];
    };
    convert.ansi256.rgb = function (args) {
      // handle greyscale
      if (args >= 232) {
        var c = (args - 232) * 10 + 8;
        return [c, c, c];
      }
      args -= 16;
      var rem;
      var r = Math.floor(args / 36) / 5 * 255;
      var g = Math.floor((rem = args % 36) / 6) / 5 * 255;
      var b = rem % 6 / 5 * 255;
      return [r, g, b];
    };
    convert.rgb.hex = function (args) {
      var integer = ((Math.round(args[0]) & 0xFF) << 16) + ((Math.round(args[1]) & 0xFF) << 8) + (Math.round(args[2]) & 0xFF);
      var string = integer.toString(16).toUpperCase();
      return '000000'.substring(string.length) + string;
    };
    convert.hex.rgb = function (args) {
      var match = args.toString(16).match(/[a-f0-9]{6}|[a-f0-9]{3}/i);
      if (!match) {
        return [0, 0, 0];
      }
      var colorString = match[0];
      if (match[0].length === 3) {
        colorString = colorString.split('').map(function (_char2) {
          return _char2 + _char2;
        }).join('');
      }
      var integer = parseInt(colorString, 16);
      var r = integer >> 16 & 0xFF;
      var g = integer >> 8 & 0xFF;
      var b = integer & 0xFF;
      return [r, g, b];
    };
    convert.rgb.hcg = function (rgb) {
      var r = rgb[0] / 255;
      var g = rgb[1] / 255;
      var b = rgb[2] / 255;
      var max = Math.max(Math.max(r, g), b);
      var min = Math.min(Math.min(r, g), b);
      var chroma = max - min;
      var grayscale;
      var hue;
      if (chroma < 1) {
        grayscale = min / (1 - chroma);
      } else {
        grayscale = 0;
      }
      if (chroma <= 0) {
        hue = 0;
      } else if (max === r) {
        hue = (g - b) / chroma % 6;
      } else if (max === g) {
        hue = 2 + (b - r) / chroma;
      } else {
        hue = 4 + (r - g) / chroma + 4;
      }
      hue /= 6;
      hue %= 1;
      return [hue * 360, chroma * 100, grayscale * 100];
    };
    convert.hsl.hcg = function (hsl) {
      var s = hsl[1] / 100;
      var l = hsl[2] / 100;
      var c = 1;
      var f = 0;
      if (l < 0.5) {
        c = 2.0 * s * l;
      } else {
        c = 2.0 * s * (1.0 - l);
      }
      if (c < 1.0) {
        f = (l - 0.5 * c) / (1.0 - c);
      }
      return [hsl[0], c * 100, f * 100];
    };
    convert.hsv.hcg = function (hsv) {
      var s = hsv[1] / 100;
      var v = hsv[2] / 100;
      var c = s * v;
      var f = 0;
      if (c < 1.0) {
        f = (v - c) / (1 - c);
      }
      return [hsv[0], c * 100, f * 100];
    };
    convert.hcg.rgb = function (hcg) {
      var h = hcg[0] / 360;
      var c = hcg[1] / 100;
      var g = hcg[2] / 100;
      if (c === 0.0) {
        return [g * 255, g * 255, g * 255];
      }
      var pure = [0, 0, 0];
      var hi = h % 1 * 6;
      var v = hi % 1;
      var w = 1 - v;
      var mg = 0;
      switch (Math.floor(hi)) {
        case 0:
          pure[0] = 1;
          pure[1] = v;
          pure[2] = 0;
          break;
        case 1:
          pure[0] = w;
          pure[1] = 1;
          pure[2] = 0;
          break;
        case 2:
          pure[0] = 0;
          pure[1] = 1;
          pure[2] = v;
          break;
        case 3:
          pure[0] = 0;
          pure[1] = w;
          pure[2] = 1;
          break;
        case 4:
          pure[0] = v;
          pure[1] = 0;
          pure[2] = 1;
          break;
        default:
          pure[0] = 1;
          pure[1] = 0;
          pure[2] = w;
      }
      mg = (1.0 - c) * g;
      return [(c * pure[0] + mg) * 255, (c * pure[1] + mg) * 255, (c * pure[2] + mg) * 255];
    };
    convert.hcg.hsv = function (hcg) {
      var c = hcg[1] / 100;
      var g = hcg[2] / 100;
      var v = c + g * (1.0 - c);
      var f = 0;
      if (v > 0.0) {
        f = c / v;
      }
      return [hcg[0], f * 100, v * 100];
    };
    convert.hcg.hsl = function (hcg) {
      var c = hcg[1] / 100;
      var g = hcg[2] / 100;
      var l = g * (1.0 - c) + 0.5 * c;
      var s = 0;
      if (l > 0.0 && l < 0.5) {
        s = c / (2 * l);
      } else if (l >= 0.5 && l < 1.0) {
        s = c / (2 * (1 - l));
      }
      return [hcg[0], s * 100, l * 100];
    };
    convert.hcg.hwb = function (hcg) {
      var c = hcg[1] / 100;
      var g = hcg[2] / 100;
      var v = c + g * (1.0 - c);
      return [hcg[0], (v - c) * 100, (1 - v) * 100];
    };
    convert.hwb.hcg = function (hwb) {
      var w = hwb[1] / 100;
      var b = hwb[2] / 100;
      var v = 1 - b;
      var c = v - w;
      var g = 0;
      if (c < 1) {
        g = (v - c) / (1 - c);
      }
      return [hwb[0], c * 100, g * 100];
    };
    convert.apple.rgb = function (apple) {
      return [apple[0] / 65535 * 255, apple[1] / 65535 * 255, apple[2] / 65535 * 255];
    };
    convert.rgb.apple = function (rgb) {
      return [rgb[0] / 255 * 65535, rgb[1] / 255 * 65535, rgb[2] / 255 * 65535];
    };
    convert.gray.rgb = function (args) {
      return [args[0] / 100 * 255, args[0] / 100 * 255, args[0] / 100 * 255];
    };
    convert.gray.hsl = convert.gray.hsv = function (args) {
      return [0, 0, args[0]];
    };
    convert.gray.hwb = function (gray) {
      return [0, 100, gray[0]];
    };
    convert.gray.cmyk = function (gray) {
      return [0, 0, 0, gray[0]];
    };
    convert.gray.lab = function (gray) {
      return [gray[0], 0, 0];
    };
    convert.gray.hex = function (gray) {
      var val = Math.round(gray[0] / 100 * 255) & 0xFF;
      var integer = (val << 16) + (val << 8) + val;
      var string = integer.toString(16).toUpperCase();
      return '000000'.substring(string.length) + string;
    };
    convert.rgb.gray = function (rgb) {
      var val = (rgb[0] + rgb[1] + rgb[2]) / 3;
      return [val / 255 * 100];
    };
  });
  var conversions_1 = conversions.rgb;
  var conversions_2 = conversions.hsl;
  var conversions_3 = conversions.hsv;
  var conversions_4 = conversions.hwb;
  var conversions_5 = conversions.cmyk;
  var conversions_6 = conversions.xyz;
  var conversions_7 = conversions.lab;
  var conversions_8 = conversions.lch;
  var conversions_9 = conversions.hex;
  var conversions_10 = conversions.keyword;
  var conversions_11 = conversions.ansi16;
  var conversions_12 = conversions.ansi256;
  var conversions_13 = conversions.hcg;
  var conversions_14 = conversions.apple;
  var conversions_15 = conversions.gray;

  /*
  	this function routes a model to all other models.
  
  	all functions that are routed have a property `.conversion` attached
  	to the returned synthetic function. This property is an array
  	of strings, each with the steps in between the 'from' and 'to'
  	color models (inclusive).
  
  	conversions that are not possible simply are not included.
  */

  function buildGraph() {
    var graph = {};
    // https://jsperf.com/object-keys-vs-for-in-with-closure/3
    var models = Object.keys(conversions);
    for (var len = models.length, i = 0; i < len; i++) {
      graph[models[i]] = {
        // http://jsperf.com/1-vs-infinity
        // micro-opt, but this is simple.
        distance: -1,
        parent: null
      };
    }
    return graph;
  }

  // https://en.wikipedia.org/wiki/Breadth-first_search
  function deriveBFS(fromModel) {
    var graph = buildGraph();
    var queue = [fromModel]; // unshift -> queue -> pop

    graph[fromModel].distance = 0;
    while (queue.length) {
      var current = queue.pop();
      var adjacents = Object.keys(conversions[current]);
      for (var len = adjacents.length, i = 0; i < len; i++) {
        var adjacent = adjacents[i];
        var node = graph[adjacent];
        if (node.distance === -1) {
          node.distance = graph[current].distance + 1;
          node.parent = current;
          queue.unshift(adjacent);
        }
      }
    }
    return graph;
  }
  function link(from, to) {
    return function (args) {
      return to(from(args));
    };
  }
  function wrapConversion(toModel, graph) {
    var path = [graph[toModel].parent, toModel];
    var fn = conversions[graph[toModel].parent][toModel];
    var cur = graph[toModel].parent;
    while (graph[cur].parent) {
      path.unshift(graph[cur].parent);
      fn = link(conversions[graph[cur].parent][cur], fn);
      cur = graph[cur].parent;
    }
    fn.conversion = path;
    return fn;
  }
  var route = function route(fromModel) {
    var graph = deriveBFS(fromModel);
    var conversion = {};
    var models = Object.keys(graph);
    for (var len = models.length, i = 0; i < len; i++) {
      var toModel = models[i];
      var node = graph[toModel];
      if (node.parent === null) {
        // no possible conversion, or this node is the source model.
        continue;
      }
      conversion[toModel] = wrapConversion(toModel, graph);
    }
    return conversion;
  };
  var convert = {};
  var models = Object.keys(conversions);
  function wrapRaw(fn) {
    var wrappedFn = function wrappedFn(args) {
      if (args === undefined || args === null) {
        return args;
      }
      if (arguments.length > 1) {
        args = Array.prototype.slice.call(arguments);
      }
      return fn(args);
    };

    // preserve .conversion property if there is one
    if ('conversion' in fn) {
      wrappedFn.conversion = fn.conversion;
    }
    return wrappedFn;
  }
  function wrapRounded(fn) {
    var wrappedFn = function wrappedFn(args) {
      if (args === undefined || args === null) {
        return args;
      }
      if (arguments.length > 1) {
        args = Array.prototype.slice.call(arguments);
      }
      var result = fn(args);

      // we're assuming the result is an array here.
      // see notice in conversions.js; don't use box types
      // in conversion functions.
      if (_typeof(result) === 'object') {
        for (var len = result.length, i = 0; i < len; i++) {
          result[i] = Math.round(result[i]);
        }
      }
      return result;
    };

    // preserve .conversion property if there is one
    if ('conversion' in fn) {
      wrappedFn.conversion = fn.conversion;
    }
    return wrappedFn;
  }
  models.forEach(function (fromModel) {
    convert[fromModel] = {};
    Object.defineProperty(convert[fromModel], 'channels', {
      value: conversions[fromModel].channels
    });
    Object.defineProperty(convert[fromModel], 'labels', {
      value: conversions[fromModel].labels
    });
    var routes = route(fromModel);
    var routeModels = Object.keys(routes);
    routeModels.forEach(function (toModel) {
      var fn = routes[toModel];
      convert[fromModel][toModel] = wrapRounded(fn);
      convert[fromModel][toModel].raw = wrapRaw(fn);
    });
  });
  var colorConvert = convert;
  var colorName$1 = {
    "aliceblue": [240, 248, 255],
    "antiquewhite": [250, 235, 215],
    "aqua": [0, 255, 255],
    "aquamarine": [127, 255, 212],
    "azure": [240, 255, 255],
    "beige": [245, 245, 220],
    "bisque": [255, 228, 196],
    "black": [0, 0, 0],
    "blanchedalmond": [255, 235, 205],
    "blue": [0, 0, 255],
    "blueviolet": [138, 43, 226],
    "brown": [165, 42, 42],
    "burlywood": [222, 184, 135],
    "cadetblue": [95, 158, 160],
    "chartreuse": [127, 255, 0],
    "chocolate": [210, 105, 30],
    "coral": [255, 127, 80],
    "cornflowerblue": [100, 149, 237],
    "cornsilk": [255, 248, 220],
    "crimson": [220, 20, 60],
    "cyan": [0, 255, 255],
    "darkblue": [0, 0, 139],
    "darkcyan": [0, 139, 139],
    "darkgoldenrod": [184, 134, 11],
    "darkgray": [169, 169, 169],
    "darkgreen": [0, 100, 0],
    "darkgrey": [169, 169, 169],
    "darkkhaki": [189, 183, 107],
    "darkmagenta": [139, 0, 139],
    "darkolivegreen": [85, 107, 47],
    "darkorange": [255, 140, 0],
    "darkorchid": [153, 50, 204],
    "darkred": [139, 0, 0],
    "darksalmon": [233, 150, 122],
    "darkseagreen": [143, 188, 143],
    "darkslateblue": [72, 61, 139],
    "darkslategray": [47, 79, 79],
    "darkslategrey": [47, 79, 79],
    "darkturquoise": [0, 206, 209],
    "darkviolet": [148, 0, 211],
    "deeppink": [255, 20, 147],
    "deepskyblue": [0, 191, 255],
    "dimgray": [105, 105, 105],
    "dimgrey": [105, 105, 105],
    "dodgerblue": [30, 144, 255],
    "firebrick": [178, 34, 34],
    "floralwhite": [255, 250, 240],
    "forestgreen": [34, 139, 34],
    "fuchsia": [255, 0, 255],
    "gainsboro": [220, 220, 220],
    "ghostwhite": [248, 248, 255],
    "gold": [255, 215, 0],
    "goldenrod": [218, 165, 32],
    "gray": [128, 128, 128],
    "green": [0, 128, 0],
    "greenyellow": [173, 255, 47],
    "grey": [128, 128, 128],
    "honeydew": [240, 255, 240],
    "hotpink": [255, 105, 180],
    "indianred": [205, 92, 92],
    "indigo": [75, 0, 130],
    "ivory": [255, 255, 240],
    "khaki": [240, 230, 140],
    "lavender": [230, 230, 250],
    "lavenderblush": [255, 240, 245],
    "lawngreen": [124, 252, 0],
    "lemonchiffon": [255, 250, 205],
    "lightblue": [173, 216, 230],
    "lightcoral": [240, 128, 128],
    "lightcyan": [224, 255, 255],
    "lightgoldenrodyellow": [250, 250, 210],
    "lightgray": [211, 211, 211],
    "lightgreen": [144, 238, 144],
    "lightgrey": [211, 211, 211],
    "lightpink": [255, 182, 193],
    "lightsalmon": [255, 160, 122],
    "lightseagreen": [32, 178, 170],
    "lightskyblue": [135, 206, 250],
    "lightslategray": [119, 136, 153],
    "lightslategrey": [119, 136, 153],
    "lightsteelblue": [176, 196, 222],
    "lightyellow": [255, 255, 224],
    "lime": [0, 255, 0],
    "limegreen": [50, 205, 50],
    "linen": [250, 240, 230],
    "magenta": [255, 0, 255],
    "maroon": [128, 0, 0],
    "mediumaquamarine": [102, 205, 170],
    "mediumblue": [0, 0, 205],
    "mediumorchid": [186, 85, 211],
    "mediumpurple": [147, 112, 219],
    "mediumseagreen": [60, 179, 113],
    "mediumslateblue": [123, 104, 238],
    "mediumspringgreen": [0, 250, 154],
    "mediumturquoise": [72, 209, 204],
    "mediumvioletred": [199, 21, 133],
    "midnightblue": [25, 25, 112],
    "mintcream": [245, 255, 250],
    "mistyrose": [255, 228, 225],
    "moccasin": [255, 228, 181],
    "navajowhite": [255, 222, 173],
    "navy": [0, 0, 128],
    "oldlace": [253, 245, 230],
    "olive": [128, 128, 0],
    "olivedrab": [107, 142, 35],
    "orange": [255, 165, 0],
    "orangered": [255, 69, 0],
    "orchid": [218, 112, 214],
    "palegoldenrod": [238, 232, 170],
    "palegreen": [152, 251, 152],
    "paleturquoise": [175, 238, 238],
    "palevioletred": [219, 112, 147],
    "papayawhip": [255, 239, 213],
    "peachpuff": [255, 218, 185],
    "peru": [205, 133, 63],
    "pink": [255, 192, 203],
    "plum": [221, 160, 221],
    "powderblue": [176, 224, 230],
    "purple": [128, 0, 128],
    "rebeccapurple": [102, 51, 153],
    "red": [255, 0, 0],
    "rosybrown": [188, 143, 143],
    "royalblue": [65, 105, 225],
    "saddlebrown": [139, 69, 19],
    "salmon": [250, 128, 114],
    "sandybrown": [244, 164, 96],
    "seagreen": [46, 139, 87],
    "seashell": [255, 245, 238],
    "sienna": [160, 82, 45],
    "silver": [192, 192, 192],
    "skyblue": [135, 206, 235],
    "slateblue": [106, 90, 205],
    "slategray": [112, 128, 144],
    "slategrey": [112, 128, 144],
    "snow": [255, 250, 250],
    "springgreen": [0, 255, 127],
    "steelblue": [70, 130, 180],
    "tan": [210, 180, 140],
    "teal": [0, 128, 128],
    "thistle": [216, 191, 216],
    "tomato": [255, 99, 71],
    "turquoise": [64, 224, 208],
    "violet": [238, 130, 238],
    "wheat": [245, 222, 179],
    "white": [255, 255, 255],
    "whitesmoke": [245, 245, 245],
    "yellow": [255, 255, 0],
    "yellowgreen": [154, 205, 50]
  };

  /* MIT license */

  var colorString = {
    getRgba: getRgba,
    getHsla: getHsla,
    getRgb: getRgb,
    getHsl: getHsl,
    getHwb: getHwb,
    getAlpha: getAlpha,
    hexString: hexString,
    rgbString: rgbString,
    rgbaString: rgbaString,
    percentString: percentString,
    percentaString: percentaString,
    hslString: hslString,
    hslaString: hslaString,
    hwbString: hwbString,
    keyword: keyword
  };
  function getRgba(string) {
    if (!string) {
      return;
    }
    var abbr = /^#([a-fA-F0-9]{3,4})$/i,
      hex = /^#([a-fA-F0-9]{6}([a-fA-F0-9]{2})?)$/i,
      rgba = /^rgba?\(\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*,\s*([+-]?\d+)\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
      per = /^rgba?\(\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*,\s*([+-]?[\d\.]+)\%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)$/i,
      keyword = /(\w+)/;
    var rgb = [0, 0, 0],
      a = 1,
      match = string.match(abbr),
      hexAlpha = "";
    if (match) {
      match = match[1];
      hexAlpha = match[3];
      for (var i = 0; i < rgb.length; i++) {
        rgb[i] = parseInt(match[i] + match[i], 16);
      }
      if (hexAlpha) {
        a = Math.round(parseInt(hexAlpha + hexAlpha, 16) / 255 * 100) / 100;
      }
    } else if (match = string.match(hex)) {
      hexAlpha = match[2];
      match = match[1];
      for (var i = 0; i < rgb.length; i++) {
        rgb[i] = parseInt(match.slice(i * 2, i * 2 + 2), 16);
      }
      if (hexAlpha) {
        a = Math.round(parseInt(hexAlpha, 16) / 255 * 100) / 100;
      }
    } else if (match = string.match(rgba)) {
      for (var i = 0; i < rgb.length; i++) {
        rgb[i] = parseInt(match[i + 1]);
      }
      a = parseFloat(match[4]);
    } else if (match = string.match(per)) {
      for (var i = 0; i < rgb.length; i++) {
        rgb[i] = Math.round(parseFloat(match[i + 1]) * 2.55);
      }
      a = parseFloat(match[4]);
    } else if (match = string.match(keyword)) {
      if (match[1] == "transparent") {
        return [0, 0, 0, 0];
      }
      rgb = colorName$1[match[1]];
      if (!rgb) {
        return;
      }
    }
    for (var i = 0; i < rgb.length; i++) {
      rgb[i] = scale(rgb[i], 0, 255);
    }
    if (!a && a != 0) {
      a = 1;
    } else {
      a = scale(a, 0, 1);
    }
    rgb[3] = a;
    return rgb;
  }
  function getHsla(string) {
    if (!string) {
      return;
    }
    var hsl = /^hsla?\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
    var match = string.match(hsl);
    if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
        s = scale(parseFloat(match[2]), 0, 100),
        l = scale(parseFloat(match[3]), 0, 100),
        a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, s, l, a];
    }
  }
  function getHwb(string) {
    if (!string) {
      return;
    }
    var hwb = /^hwb\(\s*([+-]?\d+)(?:deg)?\s*,\s*([+-]?[\d\.]+)%\s*,\s*([+-]?[\d\.]+)%\s*(?:,\s*([+-]?[\d\.]+)\s*)?\)/;
    var match = string.match(hwb);
    if (match) {
      var alpha = parseFloat(match[4]);
      var h = scale(parseInt(match[1]), 0, 360),
        w = scale(parseFloat(match[2]), 0, 100),
        b = scale(parseFloat(match[3]), 0, 100),
        a = scale(isNaN(alpha) ? 1 : alpha, 0, 1);
      return [h, w, b, a];
    }
  }
  function getRgb(string) {
    var rgba = getRgba(string);
    return rgba && rgba.slice(0, 3);
  }
  function getHsl(string) {
    var hsla = getHsla(string);
    return hsla && hsla.slice(0, 3);
  }
  function getAlpha(string) {
    var vals = getRgba(string);
    if (vals) {
      return vals[3];
    } else if (vals = getHsla(string)) {
      return vals[3];
    } else if (vals = getHwb(string)) {
      return vals[3];
    }
  }

  // generators
  function hexString(rgba, a) {
    var a = a !== undefined && rgba.length === 3 ? a : rgba[3];
    return "#" + hexDouble(rgba[0]) + hexDouble(rgba[1]) + hexDouble(rgba[2]) + (a >= 0 && a < 1 ? hexDouble(Math.round(a * 255)) : "");
  }
  function rgbString(rgba, alpha) {
    if (alpha < 1 || rgba[3] && rgba[3] < 1) {
      return rgbaString(rgba, alpha);
    }
    return "rgb(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ")";
  }
  function rgbaString(rgba, alpha) {
    if (alpha === undefined) {
      alpha = rgba[3] !== undefined ? rgba[3] : 1;
    }
    return "rgba(" + rgba[0] + ", " + rgba[1] + ", " + rgba[2] + ", " + alpha + ")";
  }
  function percentString(rgba, alpha) {
    if (alpha < 1 || rgba[3] && rgba[3] < 1) {
      return percentaString(rgba, alpha);
    }
    var r = Math.round(rgba[0] / 255 * 100),
      g = Math.round(rgba[1] / 255 * 100),
      b = Math.round(rgba[2] / 255 * 100);
    return "rgb(" + r + "%, " + g + "%, " + b + "%)";
  }
  function percentaString(rgba, alpha) {
    var r = Math.round(rgba[0] / 255 * 100),
      g = Math.round(rgba[1] / 255 * 100),
      b = Math.round(rgba[2] / 255 * 100);
    return "rgba(" + r + "%, " + g + "%, " + b + "%, " + (alpha || rgba[3] || 1) + ")";
  }
  function hslString(hsla, alpha) {
    if (alpha < 1 || hsla[3] && hsla[3] < 1) {
      return hslaString(hsla, alpha);
    }
    return "hsl(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%)";
  }
  function hslaString(hsla, alpha) {
    if (alpha === undefined) {
      alpha = hsla[3] !== undefined ? hsla[3] : 1;
    }
    return "hsla(" + hsla[0] + ", " + hsla[1] + "%, " + hsla[2] + "%, " + alpha + ")";
  }

  // hwb is a bit different than rgb(a) & hsl(a) since there is no alpha specific syntax
  // (hwb have alpha optional & 1 is default value)
  function hwbString(hwb, alpha) {
    if (alpha === undefined) {
      alpha = hwb[3] !== undefined ? hwb[3] : 1;
    }
    return "hwb(" + hwb[0] + ", " + hwb[1] + "%, " + hwb[2] + "%" + (alpha !== undefined && alpha !== 1 ? ", " + alpha : "") + ")";
  }
  function keyword(rgb) {
    return reverseNames[rgb.slice(0, 3)];
  }

  // helpers
  function scale(num, min, max) {
    return Math.min(Math.max(min, num), max);
  }
  function hexDouble(num) {
    var str = num.toString(16).toUpperCase();
    return str.length < 2 ? "0" + str : str;
  }

  //create a list of reverse color names
  var reverseNames = {};
  for (var name in colorName$1) {
    reverseNames[colorName$1[name]] = name;
  }

  /* MIT license */

  var _Color = function Color(obj) {
    if (obj instanceof _Color) {
      return obj;
    }
    if (!(this instanceof _Color)) {
      return new _Color(obj);
    }
    this.valid = false;
    this.values = {
      rgb: [0, 0, 0],
      hsl: [0, 0, 0],
      hsv: [0, 0, 0],
      hwb: [0, 0, 0],
      cmyk: [0, 0, 0, 0],
      alpha: 1
    };

    // parse Color() argument
    var vals;
    if (typeof obj === 'string') {
      vals = colorString.getRgba(obj);
      if (vals) {
        this.setValues('rgb', vals);
      } else if (vals = colorString.getHsla(obj)) {
        this.setValues('hsl', vals);
      } else if (vals = colorString.getHwb(obj)) {
        this.setValues('hwb', vals);
      }
    } else if (_typeof(obj) === 'object') {
      vals = obj;
      if (vals.r !== undefined || vals.red !== undefined) {
        this.setValues('rgb', vals);
      } else if (vals.l !== undefined || vals.lightness !== undefined) {
        this.setValues('hsl', vals);
      } else if (vals.v !== undefined || vals.value !== undefined) {
        this.setValues('hsv', vals);
      } else if (vals.w !== undefined || vals.whiteness !== undefined) {
        this.setValues('hwb', vals);
      } else if (vals.c !== undefined || vals.cyan !== undefined) {
        this.setValues('cmyk', vals);
      }
    }
  };
  _Color.prototype = {
    isValid: function isValid() {
      return this.valid;
    },
    rgb: function rgb() {
      return this.setSpace('rgb', arguments);
    },
    hsl: function hsl() {
      return this.setSpace('hsl', arguments);
    },
    hsv: function hsv() {
      return this.setSpace('hsv', arguments);
    },
    hwb: function hwb() {
      return this.setSpace('hwb', arguments);
    },
    cmyk: function cmyk() {
      return this.setSpace('cmyk', arguments);
    },
    rgbArray: function rgbArray() {
      return this.values.rgb;
    },
    hslArray: function hslArray() {
      return this.values.hsl;
    },
    hsvArray: function hsvArray() {
      return this.values.hsv;
    },
    hwbArray: function hwbArray() {
      var values = this.values;
      if (values.alpha !== 1) {
        return values.hwb.concat([values.alpha]);
      }
      return values.hwb;
    },
    cmykArray: function cmykArray() {
      return this.values.cmyk;
    },
    rgbaArray: function rgbaArray() {
      var values = this.values;
      return values.rgb.concat([values.alpha]);
    },
    hslaArray: function hslaArray() {
      var values = this.values;
      return values.hsl.concat([values.alpha]);
    },
    alpha: function alpha(val) {
      if (val === undefined) {
        return this.values.alpha;
      }
      this.setValues('alpha', val);
      return this;
    },
    red: function red(val) {
      return this.setChannel('rgb', 0, val);
    },
    green: function green(val) {
      return this.setChannel('rgb', 1, val);
    },
    blue: function blue(val) {
      return this.setChannel('rgb', 2, val);
    },
    hue: function hue(val) {
      if (val) {
        val %= 360;
        val = val < 0 ? 360 + val : val;
      }
      return this.setChannel('hsl', 0, val);
    },
    saturation: function saturation(val) {
      return this.setChannel('hsl', 1, val);
    },
    lightness: function lightness(val) {
      return this.setChannel('hsl', 2, val);
    },
    saturationv: function saturationv(val) {
      return this.setChannel('hsv', 1, val);
    },
    whiteness: function whiteness(val) {
      return this.setChannel('hwb', 1, val);
    },
    blackness: function blackness(val) {
      return this.setChannel('hwb', 2, val);
    },
    value: function value(val) {
      return this.setChannel('hsv', 2, val);
    },
    cyan: function cyan(val) {
      return this.setChannel('cmyk', 0, val);
    },
    magenta: function magenta(val) {
      return this.setChannel('cmyk', 1, val);
    },
    yellow: function yellow(val) {
      return this.setChannel('cmyk', 2, val);
    },
    black: function black(val) {
      return this.setChannel('cmyk', 3, val);
    },
    hexString: function hexString() {
      return colorString.hexString(this.values.rgb);
    },
    rgbString: function rgbString() {
      return colorString.rgbString(this.values.rgb, this.values.alpha);
    },
    rgbaString: function rgbaString() {
      return colorString.rgbaString(this.values.rgb, this.values.alpha);
    },
    percentString: function percentString() {
      return colorString.percentString(this.values.rgb, this.values.alpha);
    },
    hslString: function hslString() {
      return colorString.hslString(this.values.hsl, this.values.alpha);
    },
    hslaString: function hslaString() {
      return colorString.hslaString(this.values.hsl, this.values.alpha);
    },
    hwbString: function hwbString() {
      return colorString.hwbString(this.values.hwb, this.values.alpha);
    },
    keyword: function keyword() {
      return colorString.keyword(this.values.rgb, this.values.alpha);
    },
    rgbNumber: function rgbNumber() {
      var rgb = this.values.rgb;
      return rgb[0] << 16 | rgb[1] << 8 | rgb[2];
    },
    luminosity: function luminosity() {
      // http://www.w3.org/TR/WCAG20/#relativeluminancedef
      var rgb = this.values.rgb;
      var lum = [];
      for (var i = 0; i < rgb.length; i++) {
        var chan = rgb[i] / 255;
        lum[i] = chan <= 0.03928 ? chan / 12.92 : Math.pow((chan + 0.055) / 1.055, 2.4);
      }
      return 0.2126 * lum[0] + 0.7152 * lum[1] + 0.0722 * lum[2];
    },
    contrast: function contrast(color2) {
      // http://www.w3.org/TR/WCAG20/#contrast-ratiodef
      var lum1 = this.luminosity();
      var lum2 = color2.luminosity();
      if (lum1 > lum2) {
        return (lum1 + 0.05) / (lum2 + 0.05);
      }
      return (lum2 + 0.05) / (lum1 + 0.05);
    },
    level: function level(color2) {
      var contrastRatio = this.contrast(color2);
      if (contrastRatio >= 7.1) {
        return 'AAA';
      }
      return contrastRatio >= 4.5 ? 'AA' : '';
    },
    dark: function dark() {
      // YIQ equation from http://24ways.org/2010/calculating-color-contrast
      var rgb = this.values.rgb;
      var yiq = (rgb[0] * 299 + rgb[1] * 587 + rgb[2] * 114) / 1000;
      return yiq < 128;
    },
    light: function light() {
      return !this.dark();
    },
    negate: function negate() {
      var rgb = [];
      for (var i = 0; i < 3; i++) {
        rgb[i] = 255 - this.values.rgb[i];
      }
      this.setValues('rgb', rgb);
      return this;
    },
    lighten: function lighten(ratio) {
      var hsl = this.values.hsl;
      hsl[2] += hsl[2] * ratio;
      this.setValues('hsl', hsl);
      return this;
    },
    darken: function darken(ratio) {
      var hsl = this.values.hsl;
      hsl[2] -= hsl[2] * ratio;
      this.setValues('hsl', hsl);
      return this;
    },
    saturate: function saturate(ratio) {
      var hsl = this.values.hsl;
      hsl[1] += hsl[1] * ratio;
      this.setValues('hsl', hsl);
      return this;
    },
    desaturate: function desaturate(ratio) {
      var hsl = this.values.hsl;
      hsl[1] -= hsl[1] * ratio;
      this.setValues('hsl', hsl);
      return this;
    },
    whiten: function whiten(ratio) {
      var hwb = this.values.hwb;
      hwb[1] += hwb[1] * ratio;
      this.setValues('hwb', hwb);
      return this;
    },
    blacken: function blacken(ratio) {
      var hwb = this.values.hwb;
      hwb[2] += hwb[2] * ratio;
      this.setValues('hwb', hwb);
      return this;
    },
    greyscale: function greyscale() {
      var rgb = this.values.rgb;
      // http://en.wikipedia.org/wiki/Grayscale#Converting_color_to_grayscale
      var val = rgb[0] * 0.3 + rgb[1] * 0.59 + rgb[2] * 0.11;
      this.setValues('rgb', [val, val, val]);
      return this;
    },
    clearer: function clearer(ratio) {
      var alpha = this.values.alpha;
      this.setValues('alpha', alpha - alpha * ratio);
      return this;
    },
    opaquer: function opaquer(ratio) {
      var alpha = this.values.alpha;
      this.setValues('alpha', alpha + alpha * ratio);
      return this;
    },
    rotate: function rotate(degrees) {
      var hsl = this.values.hsl;
      var hue = (hsl[0] + degrees) % 360;
      hsl[0] = hue < 0 ? 360 + hue : hue;
      this.setValues('hsl', hsl);
      return this;
    },
    /**
     * Ported from sass implementation in C
     * https://github.com/sass/libsass/blob/0e6b4a2850092356aa3ece07c6b249f0221caced/functions.cpp#L209
     */
    mix: function mix(mixinColor, weight) {
      var color1 = this;
      var color2 = mixinColor;
      var p = weight === undefined ? 0.5 : weight;
      var w = 2 * p - 1;
      var a = color1.alpha() - color2.alpha();
      var w1 = ((w * a === -1 ? w : (w + a) / (1 + w * a)) + 1) / 2.0;
      var w2 = 1 - w1;
      return this.rgb(w1 * color1.red() + w2 * color2.red(), w1 * color1.green() + w2 * color2.green(), w1 * color1.blue() + w2 * color2.blue()).alpha(color1.alpha() * p + color2.alpha() * (1 - p));
    },
    toJSON: function toJSON() {
      return this.rgb();
    },
    clone: function clone() {
      // NOTE(SB): using node-clone creates a dependency to Buffer when using browserify,
      // making the final build way to big to embed in Chart.js. So let's do it manually,
      // assuming that values to clone are 1 dimension arrays containing only numbers,
      // except 'alpha' which is a number.
      var result = new _Color();
      var source = this.values;
      var target = result.values;
      var value, type;
      for (var prop in source) {
        if (source.hasOwnProperty(prop)) {
          value = source[prop];
          type = {}.toString.call(value);
          if (type === '[object Array]') {
            target[prop] = value.slice(0);
          } else if (type === '[object Number]') {
            target[prop] = value;
          } else {
            console.error('unexpected color value:', value);
          }
        }
      }
      return result;
    }
  };
  _Color.prototype.spaces = {
    rgb: ['red', 'green', 'blue'],
    hsl: ['hue', 'saturation', 'lightness'],
    hsv: ['hue', 'saturation', 'value'],
    hwb: ['hue', 'whiteness', 'blackness'],
    cmyk: ['cyan', 'magenta', 'yellow', 'black']
  };
  _Color.prototype.maxes = {
    rgb: [255, 255, 255],
    hsl: [360, 100, 100],
    hsv: [360, 100, 100],
    hwb: [360, 100, 100],
    cmyk: [100, 100, 100, 100]
  };
  _Color.prototype.getValues = function (space) {
    var values = this.values;
    var vals = {};
    for (var i = 0; i < space.length; i++) {
      vals[space.charAt(i)] = values[space][i];
    }
    if (values.alpha !== 1) {
      vals.a = values.alpha;
    }

    // {r: 255, g: 255, b: 255, a: 0.4}
    return vals;
  };
  _Color.prototype.setValues = function (space, vals) {
    var values = this.values;
    var spaces = this.spaces;
    var maxes = this.maxes;
    var alpha = 1;
    var i;
    this.valid = true;
    if (space === 'alpha') {
      alpha = vals;
    } else if (vals.length) {
      // [10, 10, 10]
      values[space] = vals.slice(0, space.length);
      alpha = vals[space.length];
    } else if (vals[space.charAt(0)] !== undefined) {
      // {r: 10, g: 10, b: 10}
      for (i = 0; i < space.length; i++) {
        values[space][i] = vals[space.charAt(i)];
      }
      alpha = vals.a;
    } else if (vals[spaces[space][0]] !== undefined) {
      // {red: 10, green: 10, blue: 10}
      var chans = spaces[space];
      for (i = 0; i < space.length; i++) {
        values[space][i] = vals[chans[i]];
      }
      alpha = vals.alpha;
    }
    values.alpha = Math.max(0, Math.min(1, alpha === undefined ? values.alpha : alpha));
    if (space === 'alpha') {
      return false;
    }
    var capped;

    // cap values of the space prior converting all values
    for (i = 0; i < space.length; i++) {
      capped = Math.max(0, Math.min(maxes[space][i], values[space][i]));
      values[space][i] = Math.round(capped);
    }

    // convert to all the other color spaces
    for (var sname in spaces) {
      if (sname !== space) {
        values[sname] = colorConvert[space][sname](values[space]);
      }
    }
    return true;
  };
  _Color.prototype.setSpace = function (space, args) {
    var vals = args[0];
    if (vals === undefined) {
      // color.rgb()
      return this.getValues(space);
    }

    // color.rgb(10, 10, 10)
    if (typeof vals === 'number') {
      vals = Array.prototype.slice.call(args);
    }
    this.setValues(space, vals);
    return this;
  };
  _Color.prototype.setChannel = function (space, index, val) {
    var svalues = this.values[space];
    if (val === undefined) {
      // color.red()
      return svalues[index];
    } else if (val === svalues[index]) {
      // color.red(color.red())
      return this;
    }

    // color.red(100)
    svalues[index] = val;
    this.setValues(space, svalues);
    return this;
  };
  if (typeof window !== 'undefined') {
    window.Color = _Color;
  }
  var chartjsColor = _Color;
  function isValidKey(key) {
    return ['__proto__', 'prototype', 'constructor'].indexOf(key) === -1;
  }

  /**
   * @namespace Chart.helpers
   */
  var helpers = {
    /**
     * An empty function that can be used, for example, for optional callback.
     */
    noop: function noop() {},
    /**
     * Returns a unique id, sequentially generated from a global variable.
     * @returns {number}
     * @function
     */
    uid: function () {
      var id = 0;
      return function () {
        return id++;
      };
    }(),
    /**
     * Returns true if `value` is neither null nor undefined, else returns false.
     * @param {*} value - The value to test.
     * @returns {boolean}
     * @since 2.7.0
     */
    isNullOrUndef: function isNullOrUndef(value) {
      return value === null || typeof value === 'undefined';
    },
    /**
     * Returns true if `value` is an array (including typed arrays), else returns false.
     * @param {*} value - The value to test.
     * @returns {boolean}
     * @function
     */
    isArray: function isArray(value) {
      if (Array.isArray && Array.isArray(value)) {
        return true;
      }
      var type = Object.prototype.toString.call(value);
      if (type.substr(0, 7) === '[object' && type.substr(-6) === 'Array]') {
        return true;
      }
      return false;
    },
    /**
     * Returns true if `value` is an object (excluding null), else returns false.
     * @param {*} value - The value to test.
     * @returns {boolean}
     * @since 2.7.0
     */
    isObject: function isObject(value) {
      return value !== null && Object.prototype.toString.call(value) === '[object Object]';
    },
    /**
     * Returns true if `value` is a finite number, else returns false
     * @param {*} value  - The value to test.
     * @returns {boolean}
     */
    isFinite: function (_isFinite) {
      function isFinite(_x3) {
        return _isFinite.apply(this, arguments);
      }
      isFinite.toString = function () {
        return _isFinite.toString();
      };
      return isFinite;
    }(function (value) {
      return (typeof value === 'number' || value instanceof Number) && isFinite(value);
    }),
    /**
     * Returns `value` if defined, else returns `defaultValue`.
     * @param {*} value - The value to return if defined.
     * @param {*} defaultValue - The value to return if `value` is undefined.
     * @returns {*}
     */
    valueOrDefault: function valueOrDefault(value, defaultValue) {
      return typeof value === 'undefined' ? defaultValue : value;
    },
    /**
     * Returns value at the given `index` in array if defined, else returns `defaultValue`.
     * @param {Array} value - The array to lookup for value at `index`.
     * @param {number} index - The index in `value` to lookup for value.
     * @param {*} defaultValue - The value to return if `value[index]` is undefined.
     * @returns {*}
     */
    valueAtIndexOrDefault: function valueAtIndexOrDefault(value, index, defaultValue) {
      return helpers.valueOrDefault(helpers.isArray(value) ? value[index] : value, defaultValue);
    },
    /**
     * Calls `fn` with the given `args` in the scope defined by `thisArg` and returns the
     * value returned by `fn`. If `fn` is not a function, this method returns undefined.
     * @param {function} fn - The function to call.
     * @param {Array|undefined|null} args - The arguments with which `fn` should be called.
     * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
     * @returns {*}
     */
    callback: function callback(fn, args, thisArg) {
      if (fn && typeof fn.call === 'function') {
        return fn.apply(thisArg, args);
      }
    },
    /**
     * Note(SB) for performance sake, this method should only be used when loopable type
     * is unknown or in none intensive code (not called often and small loopable). Else
     * it's preferable to use a regular for() loop and save extra function calls.
     * @param {object|Array} loopable - The object or array to be iterated.
     * @param {function} fn - The function to call for each item.
     * @param {object} [thisArg] - The value of `this` provided for the call to `fn`.
     * @param {boolean} [reverse] - If true, iterates backward on the loopable.
     */
    each: function each(loopable, fn, thisArg, reverse) {
      var i, len, keys;
      if (helpers.isArray(loopable)) {
        len = loopable.length;
        if (reverse) {
          for (i = len - 1; i >= 0; i--) {
            fn.call(thisArg, loopable[i], i);
          }
        } else {
          for (i = 0; i < len; i++) {
            fn.call(thisArg, loopable[i], i);
          }
        }
      } else if (helpers.isObject(loopable)) {
        keys = Object.keys(loopable);
        len = keys.length;
        for (i = 0; i < len; i++) {
          fn.call(thisArg, loopable[keys[i]], keys[i]);
        }
      }
    },
    /**
     * Returns true if the `a0` and `a1` arrays have the same content, else returns false.
     * @see https://stackoverflow.com/a/14853974
     * @param {Array} a0 - The array to compare
     * @param {Array} a1 - The array to compare
     * @returns {boolean}
     */
    arrayEquals: function arrayEquals(a0, a1) {
      var i, ilen, v0, v1;
      if (!a0 || !a1 || a0.length !== a1.length) {
        return false;
      }
      for (i = 0, ilen = a0.length; i < ilen; ++i) {
        v0 = a0[i];
        v1 = a1[i];
        if (v0 instanceof Array && v1 instanceof Array) {
          if (!helpers.arrayEquals(v0, v1)) {
            return false;
          }
        } else if (v0 !== v1) {
          // NOTE: two different object instances will never be equal: {x:20} != {x:20}
          return false;
        }
      }
      return true;
    },
    /**
     * Returns a deep copy of `source` without keeping references on objects and arrays.
     * @param {*} source - The value to clone.
     * @returns {*}
     */
    clone: function clone(source) {
      if (helpers.isArray(source)) {
        return source.map(helpers.clone);
      }
      if (helpers.isObject(source)) {
        var target = Object.create(source);
        var keys = Object.keys(source);
        var klen = keys.length;
        var k = 0;
        for (; k < klen; ++k) {
          target[keys[k]] = helpers.clone(source[keys[k]]);
        }
        return target;
      }
      return source;
    },
    /**
     * The default merger when Chart.helpers.merge is called without merger option.
     * Note(SB): also used by mergeConfig and mergeScaleConfig as fallback.
     * @private
     */
    _merger: function _merger(key, target, source, options) {
      if (!isValidKey(key)) {
        // We want to ensure we do not copy prototypes over
        // as this can pollute global namespaces
        return;
      }
      var tval = target[key];
      var sval = source[key];
      if (helpers.isObject(tval) && helpers.isObject(sval)) {
        helpers.merge(tval, sval, options);
      } else {
        target[key] = helpers.clone(sval);
      }
    },
    /**
     * Merges source[key] in target[key] only if target[key] is undefined.
     * @private
     */
    _mergerIf: function _mergerIf(key, target, source) {
      if (!isValidKey(key)) {
        // We want to ensure we do not copy prototypes over
        // as this can pollute global namespaces
        return;
      }
      var tval = target[key];
      var sval = source[key];
      if (helpers.isObject(tval) && helpers.isObject(sval)) {
        helpers.mergeIf(tval, sval);
      } else if (!target.hasOwnProperty(key)) {
        target[key] = helpers.clone(sval);
      }
    },
    /**
     * Recursively deep copies `source` properties into `target` with the given `options`.
     * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
     * @param {object} target - The target object in which all sources are merged into.
     * @param {object|object[]} source - Object(s) to merge into `target`.
     * @param {object} [options] - Merging options:
     * @param {function} [options.merger] - The merge method (key, target, source, options)
     * @returns {object} The `target` object.
     */
    merge: function merge(target, source, options) {
      var sources = helpers.isArray(source) ? source : [source];
      var ilen = sources.length;
      var merge, i, keys, klen, k;
      if (!helpers.isObject(target)) {
        return target;
      }
      options = options || {};
      merge = options.merger || helpers._merger;
      for (i = 0; i < ilen; ++i) {
        source = sources[i];
        if (!helpers.isObject(source)) {
          continue;
        }
        keys = Object.keys(source);
        for (k = 0, klen = keys.length; k < klen; ++k) {
          merge(keys[k], target, source, options);
        }
      }
      return target;
    },
    /**
     * Recursively deep copies `source` properties into `target` *only* if not defined in target.
     * IMPORTANT: `target` is not cloned and will be updated with `source` properties.
     * @param {object} target - The target object in which all sources are merged into.
     * @param {object|object[]} source - Object(s) to merge into `target`.
     * @returns {object} The `target` object.
     */
    mergeIf: function mergeIf(target, source) {
      return helpers.merge(target, source, {
        merger: helpers._mergerIf
      });
    },
    /**
     * Applies the contents of two or more objects together into the first object.
     * @param {object} target - The target object in which all objects are merged into.
     * @param {object} arg1 - Object containing additional properties to merge in target.
     * @param {object} argN - Additional objects containing properties to merge in target.
     * @returns {object} The `target` object.
     */
    extend: Object.assign || function (target) {
      return helpers.merge(target, [].slice.call(arguments, 1), {
        merger: function merger(key, dst, src) {
          dst[key] = src[key];
        }
      });
    },
    /**
     * Basic javascript inheritance based on the model created in Backbone.js
     */
    inherits: function inherits(extensions) {
      var me = this;
      var ChartElement = extensions && extensions.hasOwnProperty('constructor') ? extensions.constructor : function () {
        return me.apply(this, arguments);
      };
      var Surrogate = function Surrogate() {
        this.constructor = ChartElement;
      };
      Surrogate.prototype = me.prototype;
      ChartElement.prototype = new Surrogate();
      ChartElement.extend = helpers.inherits;
      if (extensions) {
        helpers.extend(ChartElement.prototype, extensions);
      }
      ChartElement.__super__ = me.prototype;
      return ChartElement;
    },
    _deprecated: function _deprecated(scope, value, previous, current) {
      if (value !== undefined) {
        console.warn(scope + ': "' + previous + '" is deprecated. Please use "' + current + '" instead');
      }
    }
  };
  var helpers_core = helpers;

  // DEPRECATIONS

  /**
   * Provided for backward compatibility, use Chart.helpers.callback instead.
   * @function Chart.helpers.callCallback
   * @deprecated since version 2.6.0
   * @todo remove at version 3
   * @private
   */
  helpers.callCallback = helpers.callback;

  /**
   * Provided for backward compatibility, use Array.prototype.indexOf instead.
   * Array.prototype.indexOf compatibility: Chrome, Opera, Safari, FF1.5+, IE9+
   * @function Chart.helpers.indexOf
   * @deprecated since version 2.7.0
   * @todo remove at version 3
   * @private
   */
  helpers.indexOf = function (array, item, fromIndex) {
    return Array.prototype.indexOf.call(array, item, fromIndex);
  };

  /**
   * Provided for backward compatibility, use Chart.helpers.valueOrDefault instead.
   * @function Chart.helpers.getValueOrDefault
   * @deprecated since version 2.7.0
   * @todo remove at version 3
   * @private
   */
  helpers.getValueOrDefault = helpers.valueOrDefault;

  /**
   * Provided for backward compatibility, use Chart.helpers.valueAtIndexOrDefault instead.
   * @function Chart.helpers.getValueAtIndexOrDefault
   * @deprecated since version 2.7.0
   * @todo remove at version 3
   * @private
   */
  helpers.getValueAtIndexOrDefault = helpers.valueAtIndexOrDefault;

  /**
   * Easing functions adapted from Robert Penner's easing equations.
   * @namespace Chart.helpers.easingEffects
   * @see http://www.robertpenner.com/easing/
   */
  var effects = {
    linear: function linear(t) {
      return t;
    },
    easeInQuad: function easeInQuad(t) {
      return t * t;
    },
    easeOutQuad: function easeOutQuad(t) {
      return -t * (t - 2);
    },
    easeInOutQuad: function easeInOutQuad(t) {
      if ((t /= 0.5) < 1) {
        return 0.5 * t * t;
      }
      return -0.5 * (--t * (t - 2) - 1);
    },
    easeInCubic: function easeInCubic(t) {
      return t * t * t;
    },
    easeOutCubic: function easeOutCubic(t) {
      return (t = t - 1) * t * t + 1;
    },
    easeInOutCubic: function easeInOutCubic(t) {
      if ((t /= 0.5) < 1) {
        return 0.5 * t * t * t;
      }
      return 0.5 * ((t -= 2) * t * t + 2);
    },
    easeInQuart: function easeInQuart(t) {
      return t * t * t * t;
    },
    easeOutQuart: function easeOutQuart(t) {
      return -((t = t - 1) * t * t * t - 1);
    },
    easeInOutQuart: function easeInOutQuart(t) {
      if ((t /= 0.5) < 1) {
        return 0.5 * t * t * t * t;
      }
      return -0.5 * ((t -= 2) * t * t * t - 2);
    },
    easeInQuint: function easeInQuint(t) {
      return t * t * t * t * t;
    },
    easeOutQuint: function easeOutQuint(t) {
      return (t = t - 1) * t * t * t * t + 1;
    },
    easeInOutQuint: function easeInOutQuint(t) {
      if ((t /= 0.5) < 1) {
        return 0.5 * t * t * t * t * t;
      }
      return 0.5 * ((t -= 2) * t * t * t * t + 2);
    },
    easeInSine: function easeInSine(t) {
      return -Math.cos(t * (Math.PI / 2)) + 1;
    },
    easeOutSine: function easeOutSine(t) {
      return Math.sin(t * (Math.PI / 2));
    },
    easeInOutSine: function easeInOutSine(t) {
      return -0.5 * (Math.cos(Math.PI * t) - 1);
    },
    easeInExpo: function easeInExpo(t) {
      return t === 0 ? 0 : Math.pow(2, 10 * (t - 1));
    },
    easeOutExpo: function easeOutExpo(t) {
      return t === 1 ? 1 : -Math.pow(2, -10 * t) + 1;
    },
    easeInOutExpo: function easeInOutExpo(t) {
      if (t === 0) {
        return 0;
      }
      if (t === 1) {
        return 1;
      }
      if ((t /= 0.5) < 1) {
        return 0.5 * Math.pow(2, 10 * (t - 1));
      }
      return 0.5 * (-Math.pow(2, -10 * --t) + 2);
    },
    easeInCirc: function easeInCirc(t) {
      if (t >= 1) {
        return t;
      }
      return -(Math.sqrt(1 - t * t) - 1);
    },
    easeOutCirc: function easeOutCirc(t) {
      return Math.sqrt(1 - (t = t - 1) * t);
    },
    easeInOutCirc: function easeInOutCirc(t) {
      if ((t /= 0.5) < 1) {
        return -0.5 * (Math.sqrt(1 - t * t) - 1);
      }
      return 0.5 * (Math.sqrt(1 - (t -= 2) * t) + 1);
    },
    easeInElastic: function easeInElastic(t) {
      var s = 1.70158;
      var p = 0;
      var a = 1;
      if (t === 0) {
        return 0;
      }
      if (t === 1) {
        return 1;
      }
      if (!p) {
        p = 0.3;
      }
      if (a < 1) {
        a = 1;
        s = p / 4;
      } else {
        s = p / (2 * Math.PI) * Math.asin(1 / a);
      }
      return -(a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
    },
    easeOutElastic: function easeOutElastic(t) {
      var s = 1.70158;
      var p = 0;
      var a = 1;
      if (t === 0) {
        return 0;
      }
      if (t === 1) {
        return 1;
      }
      if (!p) {
        p = 0.3;
      }
      if (a < 1) {
        a = 1;
        s = p / 4;
      } else {
        s = p / (2 * Math.PI) * Math.asin(1 / a);
      }
      return a * Math.pow(2, -10 * t) * Math.sin((t - s) * (2 * Math.PI) / p) + 1;
    },
    easeInOutElastic: function easeInOutElastic(t) {
      var s = 1.70158;
      var p = 0;
      var a = 1;
      if (t === 0) {
        return 0;
      }
      if ((t /= 0.5) === 2) {
        return 1;
      }
      if (!p) {
        p = 0.45;
      }
      if (a < 1) {
        a = 1;
        s = p / 4;
      } else {
        s = p / (2 * Math.PI) * Math.asin(1 / a);
      }
      if (t < 1) {
        return -0.5 * (a * Math.pow(2, 10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p));
      }
      return a * Math.pow(2, -10 * (t -= 1)) * Math.sin((t - s) * (2 * Math.PI) / p) * 0.5 + 1;
    },
    easeInBack: function easeInBack(t) {
      var s = 1.70158;
      return t * t * ((s + 1) * t - s);
    },
    easeOutBack: function easeOutBack(t) {
      var s = 1.70158;
      return (t = t - 1) * t * ((s + 1) * t + s) + 1;
    },
    easeInOutBack: function easeInOutBack(t) {
      var s = 1.70158;
      if ((t /= 0.5) < 1) {
        return 0.5 * (t * t * (((s *= 1.525) + 1) * t - s));
      }
      return 0.5 * ((t -= 2) * t * (((s *= 1.525) + 1) * t + s) + 2);
    },
    easeInBounce: function easeInBounce(t) {
      return 1 - effects.easeOutBounce(1 - t);
    },
    easeOutBounce: function easeOutBounce(t) {
      if (t < 1 / 2.75) {
        return 7.5625 * t * t;
      }
      if (t < 2 / 2.75) {
        return 7.5625 * (t -= 1.5 / 2.75) * t + 0.75;
      }
      if (t < 2.5 / 2.75) {
        return 7.5625 * (t -= 2.25 / 2.75) * t + 0.9375;
      }
      return 7.5625 * (t -= 2.625 / 2.75) * t + 0.984375;
    },
    easeInOutBounce: function easeInOutBounce(t) {
      if (t < 0.5) {
        return effects.easeInBounce(t * 2) * 0.5;
      }
      return effects.easeOutBounce(t * 2 - 1) * 0.5 + 0.5;
    }
  };
  var helpers_easing = {
    effects: effects
  };

  // DEPRECATIONS

  /**
   * Provided for backward compatibility, use Chart.helpers.easing.effects instead.
   * @function Chart.helpers.easingEffects
   * @deprecated since version 2.7.0
   * @todo remove at version 3
   * @private
   */
  helpers_core.easingEffects = effects;
  var PI = Math.PI;
  var RAD_PER_DEG = PI / 180;
  var DOUBLE_PI = PI * 2;
  var HALF_PI = PI / 2;
  var QUARTER_PI = PI / 4;
  var TWO_THIRDS_PI = PI * 2 / 3;

  /**
   * @namespace Chart.helpers.canvas
   */
  var exports$1 = {
    /**
     * Clears the entire canvas associated to the given `chart`.
     * @param {Chart} chart - The chart for which to clear the canvas.
     */
    clear: function clear(chart) {
      chart.ctx.clearRect(0, 0, chart.width, chart.height);
    },
    /**
     * Creates a "path" for a rectangle with rounded corners at position (x, y) with a
     * given size (width, height) and the same `radius` for all corners.
     * @param {CanvasRenderingContext2D} ctx - The canvas 2D Context.
     * @param {number} x - The x axis of the coordinate for the rectangle starting point.
     * @param {number} y - The y axis of the coordinate for the rectangle starting point.
     * @param {number} width - The rectangle's width.
     * @param {number} height - The rectangle's height.
     * @param {number} radius - The rounded amount (in pixels) for the four corners.
     * @todo handle `radius` as top-left, top-right, bottom-right, bottom-left array/object?
     */
    roundedRect: function roundedRect(ctx, x, y, width, height, radius) {
      if (radius) {
        var r = Math.min(radius, height / 2, width / 2);
        var left = x + r;
        var top = y + r;
        var right = x + width - r;
        var bottom = y + height - r;
        ctx.moveTo(x, top);
        if (left < right && top < bottom) {
          ctx.arc(left, top, r, -PI, -HALF_PI);
          ctx.arc(right, top, r, -HALF_PI, 0);
          ctx.arc(right, bottom, r, 0, HALF_PI);
          ctx.arc(left, bottom, r, HALF_PI, PI);
        } else if (left < right) {
          ctx.moveTo(left, y);
          ctx.arc(right, top, r, -HALF_PI, HALF_PI);
          ctx.arc(left, top, r, HALF_PI, PI + HALF_PI);
        } else if (top < bottom) {
          ctx.arc(left, top, r, -PI, 0);
          ctx.arc(left, bottom, r, 0, PI);
        } else {
          ctx.arc(left, top, r, -PI, PI);
        }
        ctx.closePath();
        ctx.moveTo(x, y);
      } else {
        ctx.rect(x, y, width, height);
      }
    },
    drawPoint: function drawPoint(ctx, style, radius, x, y, rotation) {
      var type, xOffset, yOffset, size, cornerRadius;
      var rad = (rotation || 0) * RAD_PER_DEG;
      if (style && _typeof(style) === 'object') {
        type = style.toString();
        if (type === '[object HTMLImageElement]' || type === '[object HTMLCanvasElement]') {
          ctx.save();
          ctx.translate(x, y);
          ctx.rotate(rad);
          ctx.drawImage(style, -style.width / 2, -style.height / 2, style.width, style.height);
          ctx.restore();
          return;
        }
      }
      if (isNaN(radius) || radius <= 0) {
        return;
      }
      ctx.beginPath();
      switch (style) {
        // Default includes circle
        default:
          ctx.arc(x, y, radius, 0, DOUBLE_PI);
          ctx.closePath();
          break;
        case 'triangle':
          ctx.moveTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
          rad += TWO_THIRDS_PI;
          ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
          rad += TWO_THIRDS_PI;
          ctx.lineTo(x + Math.sin(rad) * radius, y - Math.cos(rad) * radius);
          ctx.closePath();
          break;
        case 'rectRounded':
          // NOTE: the rounded rect implementation changed to use `arc` instead of
          // `quadraticCurveTo` since it generates better results when rect is
          // almost a circle. 0.516 (instead of 0.5) produces results with visually
          // closer proportion to the previous impl and it is inscribed in the
          // circle with `radius`. For more details, see the following PRs:
          // https://github.com/chartjs/Chart.js/issues/5597
          // https://github.com/chartjs/Chart.js/issues/5858
          cornerRadius = radius * 0.516;
          size = radius - cornerRadius;
          xOffset = Math.cos(rad + QUARTER_PI) * size;
          yOffset = Math.sin(rad + QUARTER_PI) * size;
          ctx.arc(x - xOffset, y - yOffset, cornerRadius, rad - PI, rad - HALF_PI);
          ctx.arc(x + yOffset, y - xOffset, cornerRadius, rad - HALF_PI, rad);
          ctx.arc(x + xOffset, y + yOffset, cornerRadius, rad, rad + HALF_PI);
          ctx.arc(x - yOffset, y + xOffset, cornerRadius, rad + HALF_PI, rad + PI);
          ctx.closePath();
          break;
        case 'rect':
          if (!rotation) {
            size = Math.SQRT1_2 * radius;
            ctx.rect(x - size, y - size, 2 * size, 2 * size);
            break;
          }
          rad += QUARTER_PI;
        /* falls through */
        case 'rectRot':
          xOffset = Math.cos(rad) * radius;
          yOffset = Math.sin(rad) * radius;
          ctx.moveTo(x - xOffset, y - yOffset);
          ctx.lineTo(x + yOffset, y - xOffset);
          ctx.lineTo(x + xOffset, y + yOffset);
          ctx.lineTo(x - yOffset, y + xOffset);
          ctx.closePath();
          break;
        case 'crossRot':
          rad += QUARTER_PI;
        /* falls through */
        case 'cross':
          xOffset = Math.cos(rad) * radius;
          yOffset = Math.sin(rad) * radius;
          ctx.moveTo(x - xOffset, y - yOffset);
          ctx.lineTo(x + xOffset, y + yOffset);
          ctx.moveTo(x + yOffset, y - xOffset);
          ctx.lineTo(x - yOffset, y + xOffset);
          break;
        case 'star':
          xOffset = Math.cos(rad) * radius;
          yOffset = Math.sin(rad) * radius;
          ctx.moveTo(x - xOffset, y - yOffset);
          ctx.lineTo(x + xOffset, y + yOffset);
          ctx.moveTo(x + yOffset, y - xOffset);
          ctx.lineTo(x - yOffset, y + xOffset);
          rad += QUARTER_PI;
          xOffset = Math.cos(rad) * radius;
          yOffset = Math.sin(rad) * radius;
          ctx.moveTo(x - xOffset, y - yOffset);
          ctx.lineTo(x + xOffset, y + yOffset);
          ctx.moveTo(x + yOffset, y - xOffset);
          ctx.lineTo(x - yOffset, y + xOffset);
          break;
        case 'line':
          xOffset = Math.cos(rad) * radius;
          yOffset = Math.sin(rad) * radius;
          ctx.moveTo(x - xOffset, y - yOffset);
          ctx.lineTo(x + xOffset, y + yOffset);
          break;
        case 'dash':
          ctx.moveTo(x, y);
          ctx.lineTo(x + Math.cos(rad) * radius, y + Math.sin(rad) * radius);
          break;
      }
      ctx.fill();
      ctx.stroke();
    },
    /**
     * Returns true if the point is inside the rectangle
     * @param {object} point - The point to test
     * @param {object} area - The rectangle
     * @returns {boolean}
     * @private
     */
    _isPointInArea: function _isPointInArea(point, area) {
      var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.

      return point.x > area.left - epsilon && point.x < area.right + epsilon && point.y > area.top - epsilon && point.y < area.bottom + epsilon;
    },
    clipArea: function clipArea(ctx, area) {
      ctx.save();
      ctx.beginPath();
      ctx.rect(area.left, area.top, area.right - area.left, area.bottom - area.top);
      ctx.clip();
    },
    unclipArea: function unclipArea(ctx) {
      ctx.restore();
    },
    lineTo: function lineTo(ctx, previous, target, flip) {
      var stepped = target.steppedLine;
      if (stepped) {
        if (stepped === 'middle') {
          var midpoint = (previous.x + target.x) / 2.0;
          ctx.lineTo(midpoint, flip ? target.y : previous.y);
          ctx.lineTo(midpoint, flip ? previous.y : target.y);
        } else if (stepped === 'after' && !flip || stepped !== 'after' && flip) {
          ctx.lineTo(previous.x, target.y);
        } else {
          ctx.lineTo(target.x, previous.y);
        }
        ctx.lineTo(target.x, target.y);
        return;
      }
      if (!target.tension) {
        ctx.lineTo(target.x, target.y);
        return;
      }
      ctx.bezierCurveTo(flip ? previous.controlPointPreviousX : previous.controlPointNextX, flip ? previous.controlPointPreviousY : previous.controlPointNextY, flip ? target.controlPointNextX : target.controlPointPreviousX, flip ? target.controlPointNextY : target.controlPointPreviousY, target.x, target.y);
    }
  };
  var helpers_canvas = exports$1;

  // DEPRECATIONS

  /**
   * Provided for backward compatibility, use Chart.helpers.canvas.clear instead.
   * @namespace Chart.helpers.clear
   * @deprecated since version 2.7.0
   * @todo remove at version 3
   * @private
   */
  helpers_core.clear = exports$1.clear;

  /**
   * Provided for backward compatibility, use Chart.helpers.canvas.roundedRect instead.
   * @namespace Chart.helpers.drawRoundedRectangle
   * @deprecated since version 2.7.0
   * @todo remove at version 3
   * @private
   */
  helpers_core.drawRoundedRectangle = function (ctx) {
    ctx.beginPath();
    exports$1.roundedRect.apply(exports$1, arguments);
  };
  var defaults = {
    /**
     * @private
     */
    _set: function _set(scope, values) {
      return helpers_core.merge(this[scope] || (this[scope] = {}), values);
    }
  };

  // TODO(v3): remove 'global' from namespace.  all default are global and
  // there's inconsistency around which options are under 'global'
  defaults._set('global', {
    defaultColor: 'rgba(0,0,0,0.1)',
    defaultFontColor: '#666',
    defaultFontFamily: "'Helvetica Neue', 'Helvetica', 'Arial', sans-serif",
    defaultFontSize: 12,
    defaultFontStyle: 'normal',
    defaultLineHeight: 1.2,
    showLines: true
  });
  var core_defaults = defaults;
  var valueOrDefault = helpers_core.valueOrDefault;

  /**
   * Converts the given font object into a CSS font string.
   * @param {object} font - A font object.
   * @return {string} The CSS font string. See https://developer.mozilla.org/en-US/docs/Web/CSS/font
   * @private
   */
  function toFontString(font) {
    if (!font || helpers_core.isNullOrUndef(font.size) || helpers_core.isNullOrUndef(font.family)) {
      return null;
    }
    return (font.style ? font.style + ' ' : '') + (font.weight ? font.weight + ' ' : '') + font.size + 'px ' + font.family;
  }

  /**
   * @alias Chart.helpers.options
   * @namespace
   */
  var helpers_options = {
    /**
     * Converts the given line height `value` in pixels for a specific font `size`.
     * @param {number|string} value - The lineHeight to parse (eg. 1.6, '14px', '75%', '1.6em').
     * @param {number} size - The font size (in pixels) used to resolve relative `value`.
     * @returns {number} The effective line height in pixels (size * 1.2 if value is invalid).
     * @see https://developer.mozilla.org/en-US/docs/Web/CSS/line-height
     * @since 2.7.0
     */
    toLineHeight: function toLineHeight(value, size) {
      var matches = ('' + value).match(/^(normal|(\d+(?:\.\d+)?)(px|em|%)?)$/);
      if (!matches || matches[1] === 'normal') {
        return size * 1.2;
      }
      value = +matches[2];
      switch (matches[3]) {
        case 'px':
          return value;
        case '%':
          value /= 100;
          break;
      }
      return size * value;
    },
    /**
     * Converts the given value into a padding object with pre-computed width/height.
     * @param {number|object} value - If a number, set the value to all TRBL component,
     *  else, if and object, use defined properties and sets undefined ones to 0.
     * @returns {object} The padding values (top, right, bottom, left, width, height)
     * @since 2.7.0
     */
    toPadding: function toPadding(value) {
      var t, r, b, l;
      if (helpers_core.isObject(value)) {
        t = +value.top || 0;
        r = +value.right || 0;
        b = +value.bottom || 0;
        l = +value.left || 0;
      } else {
        t = r = b = l = +value || 0;
      }
      return {
        top: t,
        right: r,
        bottom: b,
        left: l,
        height: t + b,
        width: l + r
      };
    },
    /**
     * Parses font options and returns the font object.
     * @param {object} options - A object that contains font options to be parsed.
     * @return {object} The font object.
     * @todo Support font.* options and renamed to toFont().
     * @private
     */
    _parseFont: function _parseFont(options) {
      var globalDefaults = core_defaults.global;
      var size = valueOrDefault(options.fontSize, globalDefaults.defaultFontSize);
      var font = {
        family: valueOrDefault(options.fontFamily, globalDefaults.defaultFontFamily),
        lineHeight: helpers_core.options.toLineHeight(valueOrDefault(options.lineHeight, globalDefaults.defaultLineHeight), size),
        size: size,
        style: valueOrDefault(options.fontStyle, globalDefaults.defaultFontStyle),
        weight: null,
        string: ''
      };
      font.string = toFontString(font);
      return font;
    },
    /**
     * Evaluates the given `inputs` sequentially and returns the first defined value.
     * @param {Array} inputs - An array of values, falling back to the last value.
     * @param {object} [context] - If defined and the current value is a function, the value
     * is called with `context` as first argument and the result becomes the new input.
     * @param {number} [index] - If defined and the current value is an array, the value
     * at `index` become the new input.
     * @param {object} [info] - object to return information about resolution in
     * @param {boolean} [info.cacheable] - Will be set to `false` if option is not cacheable.
     * @since 2.7.0
     */
    resolve: function resolve(inputs, context, index, info) {
      var cacheable = true;
      var i, ilen, value;
      for (i = 0, ilen = inputs.length; i < ilen; ++i) {
        value = inputs[i];
        if (value === undefined) {
          continue;
        }
        if (context !== undefined && typeof value === 'function') {
          value = value(context);
          cacheable = false;
        }
        if (index !== undefined && helpers_core.isArray(value)) {
          value = value[index];
          cacheable = false;
        }
        if (value !== undefined) {
          if (info && !cacheable) {
            info.cacheable = false;
          }
          return value;
        }
      }
    }
  };

  /**
   * @alias Chart.helpers.math
   * @namespace
   */
  var exports$2 = {
    /**
     * Returns an array of factors sorted from 1 to sqrt(value)
     * @private
     */
    _factorize: function _factorize(value) {
      var result = [];
      var sqrt = Math.sqrt(value);
      var i;
      for (i = 1; i < sqrt; i++) {
        if (value % i === 0) {
          result.push(i);
          result.push(value / i);
        }
      }
      if (sqrt === (sqrt | 0)) {
        // if value is a square number
        result.push(sqrt);
      }
      result.sort(function (a, b) {
        return a - b;
      }).pop();
      return result;
    },
    log10: Math.log10 || function (x) {
      var exponent = Math.log(x) * Math.LOG10E; // Math.LOG10E = 1 / Math.LN10.
      // Check for whole powers of 10,
      // which due to floating point rounding error should be corrected.
      var powerOf10 = Math.round(exponent);
      var isPowerOf10 = x === Math.pow(10, powerOf10);
      return isPowerOf10 ? powerOf10 : exponent;
    }
  };
  var helpers_math = exports$2;

  // DEPRECATIONS

  /**
   * Provided for backward compatibility, use Chart.helpers.math.log10 instead.
   * @namespace Chart.helpers.log10
   * @deprecated since version 2.9.0
   * @todo remove at version 3
   * @private
   */
  helpers_core.log10 = exports$2.log10;
  var getRtlAdapter = function getRtlAdapter(rectX, width) {
    return {
      x: function x(_x4) {
        return rectX + rectX + width - _x4;
      },
      setWidth: function setWidth(w) {
        width = w;
      },
      textAlign: function textAlign(align) {
        if (align === 'center') {
          return align;
        }
        return align === 'right' ? 'left' : 'right';
      },
      xPlus: function xPlus(x, value) {
        return x - value;
      },
      leftForLtr: function leftForLtr(x, itemWidth) {
        return x - itemWidth;
      }
    };
  };
  var getLtrAdapter = function getLtrAdapter() {
    return {
      x: function x(_x5) {
        return _x5;
      },
      setWidth: function setWidth(w) {// eslint-disable-line no-unused-vars
      },
      textAlign: function textAlign(align) {
        return align;
      },
      xPlus: function xPlus(x, value) {
        return x + value;
      },
      leftForLtr: function leftForLtr(x, _itemWidth) {
        // eslint-disable-line no-unused-vars
        return x;
      }
    };
  };
  var getAdapter = function getAdapter(rtl, rectX, width) {
    return rtl ? getRtlAdapter(rectX, width) : getLtrAdapter();
  };
  var overrideTextDirection = function overrideTextDirection(ctx, direction) {
    var style, original;
    if (direction === 'ltr' || direction === 'rtl') {
      style = ctx.canvas.style;
      original = [style.getPropertyValue('direction'), style.getPropertyPriority('direction')];
      style.setProperty('direction', direction, 'important');
      ctx.prevTextDirection = original;
    }
  };
  var restoreTextDirection = function restoreTextDirection(ctx) {
    var original = ctx.prevTextDirection;
    if (original !== undefined) {
      delete ctx.prevTextDirection;
      ctx.canvas.style.setProperty('direction', original[0], original[1]);
    }
  };
  var helpers_rtl = {
    getRtlAdapter: getAdapter,
    overrideTextDirection: overrideTextDirection,
    restoreTextDirection: restoreTextDirection
  };
  var helpers$1 = helpers_core;
  var easing = helpers_easing;
  var canvas = helpers_canvas;
  var options = helpers_options;
  var math = helpers_math;
  var rtl = helpers_rtl;
  helpers$1.easing = easing;
  helpers$1.canvas = canvas;
  helpers$1.options = options;
  helpers$1.math = math;
  helpers$1.rtl = rtl;
  function interpolate(start, view, model, ease) {
    var keys = Object.keys(model);
    var i, ilen, key, actual, origin, target, type, c0, c1;
    for (i = 0, ilen = keys.length; i < ilen; ++i) {
      key = keys[i];
      target = model[key];

      // if a value is added to the model after pivot() has been called, the view
      // doesn't contain it, so let's initialize the view to the target value.
      if (!view.hasOwnProperty(key)) {
        view[key] = target;
      }
      actual = view[key];
      if (actual === target || key[0] === '_') {
        continue;
      }
      if (!start.hasOwnProperty(key)) {
        start[key] = actual;
      }
      origin = start[key];
      type = _typeof(target);
      if (type === _typeof(origin)) {
        if (type === 'string') {
          c0 = chartjsColor(origin);
          if (c0.valid) {
            c1 = chartjsColor(target);
            if (c1.valid) {
              view[key] = c1.mix(c0, ease).rgbString();
              continue;
            }
          }
        } else if (helpers$1.isFinite(origin) && helpers$1.isFinite(target)) {
          view[key] = origin + (target - origin) * ease;
          continue;
        }
      }
      view[key] = target;
    }
  }
  var Element = function Element(configuration) {
    helpers$1.extend(this, configuration);
    this.initialize.apply(this, arguments);
  };
  helpers$1.extend(Element.prototype, {
    _type: undefined,
    initialize: function initialize() {
      this.hidden = false;
    },
    pivot: function pivot() {
      var me = this;
      if (!me._view) {
        me._view = helpers$1.extend({}, me._model);
      }
      me._start = {};
      return me;
    },
    transition: function transition(ease) {
      var me = this;
      var model = me._model;
      var start = me._start;
      var view = me._view;

      // No animation -> No Transition
      if (!model || ease === 1) {
        me._view = helpers$1.extend({}, model);
        me._start = null;
        return me;
      }
      if (!view) {
        view = me._view = {};
      }
      if (!start) {
        start = me._start = {};
      }
      interpolate(start, view, model, ease);
      return me;
    },
    tooltipPosition: function tooltipPosition() {
      return {
        x: this._model.x,
        y: this._model.y
      };
    },
    hasValue: function hasValue() {
      return helpers$1.isNumber(this._model.x) && helpers$1.isNumber(this._model.y);
    }
  });
  Element.extend = helpers$1.inherits;
  var core_element = Element;
  var exports$3 = core_element.extend({
    chart: null,
    // the animation associated chart instance
    currentStep: 0,
    // the current animation step
    numSteps: 60,
    // default number of steps
    easing: '',
    // the easing to use for this animation
    render: null,
    // render function used by the animation service

    onAnimationProgress: null,
    // user specified callback to fire on each step of the animation
    onAnimationComplete: null // user specified callback to fire when the animation finishes
  });
  var core_animation = exports$3;

  // DEPRECATIONS

  /**
   * Provided for backward compatibility, use Chart.Animation instead
   * @prop Chart.Animation#animationObject
   * @deprecated since version 2.6.0
   * @todo remove at version 3
   */
  Object.defineProperty(exports$3.prototype, 'animationObject', {
    get: function get() {
      return this;
    }
  });

  /**
   * Provided for backward compatibility, use Chart.Animation#chart instead
   * @prop Chart.Animation#chartInstance
   * @deprecated since version 2.6.0
   * @todo remove at version 3
   */
  Object.defineProperty(exports$3.prototype, 'chartInstance', {
    get: function get() {
      return this.chart;
    },
    set: function set(value) {
      this.chart = value;
    }
  });
  core_defaults._set('global', {
    animation: {
      duration: 1000,
      easing: 'easeOutQuart',
      onProgress: helpers$1.noop,
      onComplete: helpers$1.noop
    }
  });
  var core_animations = {
    animations: [],
    request: null,
    /**
     * @param {Chart} chart - The chart to animate.
     * @param {Chart.Animation} animation - The animation that we will animate.
     * @param {number} duration - The animation duration in ms.
     * @param {boolean} lazy - if true, the chart is not marked as animating to enable more responsive interactions
     */
    addAnimation: function addAnimation(chart, animation, duration, lazy) {
      var animations = this.animations;
      var i, ilen;
      animation.chart = chart;
      animation.startTime = Date.now();
      animation.duration = duration;
      if (!lazy) {
        chart.animating = true;
      }
      for (i = 0, ilen = animations.length; i < ilen; ++i) {
        if (animations[i].chart === chart) {
          animations[i] = animation;
          return;
        }
      }
      animations.push(animation);

      // If there are no animations queued, manually kickstart a digest, for lack of a better word
      if (animations.length === 1) {
        this.requestAnimationFrame();
      }
    },
    cancelAnimation: function cancelAnimation(chart) {
      var index = helpers$1.findIndex(this.animations, function (animation) {
        return animation.chart === chart;
      });
      if (index !== -1) {
        this.animations.splice(index, 1);
        chart.animating = false;
      }
    },
    requestAnimationFrame: function requestAnimationFrame() {
      var me = this;
      if (me.request === null) {
        // Skip animation frame requests until the active one is executed.
        // This can happen when processing mouse events, e.g. 'mousemove'
        // and 'mouseout' events will trigger multiple renders.
        me.request = helpers$1.requestAnimFrame.call(window, function () {
          me.request = null;
          me.startDigest();
        });
      }
    },
    /**
     * @private
     */
    startDigest: function startDigest() {
      var me = this;
      me.advance();

      // Do we have more stuff to animate?
      if (me.animations.length > 0) {
        me.requestAnimationFrame();
      }
    },
    /**
     * @private
     */
    advance: function advance() {
      var animations = this.animations;
      var animation, chart, numSteps, nextStep;
      var i = 0;

      // 1 animation per chart, so we are looping charts here
      while (i < animations.length) {
        animation = animations[i];
        chart = animation.chart;
        numSteps = animation.numSteps;

        // Make sure that currentStep starts at 1
        // https://github.com/chartjs/Chart.js/issues/6104
        nextStep = Math.floor((Date.now() - animation.startTime) / animation.duration * numSteps) + 1;
        animation.currentStep = Math.min(nextStep, numSteps);
        helpers$1.callback(animation.render, [chart, animation], chart);
        helpers$1.callback(animation.onAnimationProgress, [animation], chart);
        if (animation.currentStep >= numSteps) {
          helpers$1.callback(animation.onAnimationComplete, [animation], chart);
          chart.animating = false;
          animations.splice(i, 1);
        } else {
          ++i;
        }
      }
    }
  };
  var resolve = helpers$1.options.resolve;
  var arrayEvents = ['push', 'pop', 'shift', 'splice', 'unshift'];

  /**
   * Hooks the array methods that add or remove values ('push', pop', 'shift', 'splice',
   * 'unshift') and notify the listener AFTER the array has been altered. Listeners are
   * called on the 'onData*' callbacks (e.g. onDataPush, etc.) with same arguments.
   */
  function listenArrayEvents(array, listener) {
    if (array._chartjs) {
      array._chartjs.listeners.push(listener);
      return;
    }
    Object.defineProperty(array, '_chartjs', {
      configurable: true,
      enumerable: false,
      value: {
        listeners: [listener]
      }
    });
    arrayEvents.forEach(function (key) {
      var method = 'onData' + key.charAt(0).toUpperCase() + key.slice(1);
      var base = array[key];
      Object.defineProperty(array, key, {
        configurable: true,
        enumerable: false,
        value: function value() {
          var args = Array.prototype.slice.call(arguments);
          var res = base.apply(this, args);
          helpers$1.each(array._chartjs.listeners, function (object) {
            if (typeof object[method] === 'function') {
              object[method].apply(object, args);
            }
          });
          return res;
        }
      });
    });
  }

  /**
   * Removes the given array event listener and cleanup extra attached properties (such as
   * the _chartjs stub and overridden methods) if array doesn't have any more listeners.
   */
  function unlistenArrayEvents(array, listener) {
    var stub = array._chartjs;
    if (!stub) {
      return;
    }
    var listeners = stub.listeners;
    var index = listeners.indexOf(listener);
    if (index !== -1) {
      listeners.splice(index, 1);
    }
    if (listeners.length > 0) {
      return;
    }
    arrayEvents.forEach(function (key) {
      delete array[key];
    });
    delete array._chartjs;
  }

  // Base class for all dataset controllers (line, bar, etc)
  var DatasetController = function DatasetController(chart, datasetIndex) {
    this.initialize(chart, datasetIndex);
  };
  helpers$1.extend(DatasetController.prototype, {
    /**
     * Element type used to generate a meta dataset (e.g. Chart.element.Line).
     * @type {Chart.core.element}
     */
    datasetElementType: null,
    /**
     * Element type used to generate a meta data (e.g. Chart.element.Point).
     * @type {Chart.core.element}
     */
    dataElementType: null,
    /**
     * Dataset element option keys to be resolved in _resolveDatasetElementOptions.
     * A derived controller may override this to resolve controller-specific options.
     * The keys defined here are for backward compatibility for legend styles.
     * @private
     */
    _datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth'],
    /**
     * Data element option keys to be resolved in _resolveDataElementOptions.
     * A derived controller may override this to resolve controller-specific options.
     * The keys defined here are for backward compatibility for legend styles.
     * @private
     */
    _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'pointStyle'],
    initialize: function initialize(chart, datasetIndex) {
      var me = this;
      me.chart = chart;
      me.index = datasetIndex;
      me.linkScales();
      me.addElements();
      me._type = me.getMeta().type;
    },
    updateIndex: function updateIndex(datasetIndex) {
      this.index = datasetIndex;
    },
    linkScales: function linkScales() {
      var me = this;
      var meta = me.getMeta();
      var chart = me.chart;
      var scales = chart.scales;
      var dataset = me.getDataset();
      var scalesOpts = chart.options.scales;
      if (meta.xAxisID === null || !(meta.xAxisID in scales) || dataset.xAxisID) {
        meta.xAxisID = dataset.xAxisID || scalesOpts.xAxes[0].id;
      }
      if (meta.yAxisID === null || !(meta.yAxisID in scales) || dataset.yAxisID) {
        meta.yAxisID = dataset.yAxisID || scalesOpts.yAxes[0].id;
      }
    },
    getDataset: function getDataset() {
      return this.chart.data.datasets[this.index];
    },
    getMeta: function getMeta() {
      return this.chart.getDatasetMeta(this.index);
    },
    getScaleForId: function getScaleForId(scaleID) {
      return this.chart.scales[scaleID];
    },
    /**
     * @private
     */
    _getValueScaleId: function _getValueScaleId() {
      return this.getMeta().yAxisID;
    },
    /**
     * @private
     */
    _getIndexScaleId: function _getIndexScaleId() {
      return this.getMeta().xAxisID;
    },
    /**
     * @private
     */
    _getValueScale: function _getValueScale() {
      return this.getScaleForId(this._getValueScaleId());
    },
    /**
     * @private
     */
    _getIndexScale: function _getIndexScale() {
      return this.getScaleForId(this._getIndexScaleId());
    },
    reset: function reset() {
      this._update(true);
    },
    /**
     * @private
     */
    destroy: function destroy() {
      if (this._data) {
        unlistenArrayEvents(this._data, this);
      }
    },
    createMetaDataset: function createMetaDataset() {
      var me = this;
      var type = me.datasetElementType;
      return type && new type({
        _chart: me.chart,
        _datasetIndex: me.index
      });
    },
    createMetaData: function createMetaData(index) {
      var me = this;
      var type = me.dataElementType;
      return type && new type({
        _chart: me.chart,
        _datasetIndex: me.index,
        _index: index
      });
    },
    addElements: function addElements() {
      var me = this;
      var meta = me.getMeta();
      var data = me.getDataset().data || [];
      var metaData = meta.data;
      var i, ilen;
      for (i = 0, ilen = data.length; i < ilen; ++i) {
        metaData[i] = metaData[i] || me.createMetaData(i);
      }
      meta.dataset = meta.dataset || me.createMetaDataset();
    },
    addElementAndReset: function addElementAndReset(index) {
      var element = this.createMetaData(index);
      this.getMeta().data.splice(index, 0, element);
      this.updateElement(element, index, true);
    },
    buildOrUpdateElements: function buildOrUpdateElements() {
      var me = this;
      var dataset = me.getDataset();
      var data = dataset.data || (dataset.data = []);

      // In order to correctly handle data addition/deletion animation (an thus simulate
      // real-time charts), we need to monitor these data modifications and synchronize
      // the internal meta data accordingly.
      if (me._data !== data) {
        if (me._data) {
          // This case happens when the user replaced the data array instance.
          unlistenArrayEvents(me._data, me);
        }
        if (data && Object.isExtensible(data)) {
          listenArrayEvents(data, me);
        }
        me._data = data;
      }

      // Re-sync meta data in case the user replaced the data array or if we missed
      // any updates and so make sure that we handle number of datapoints changing.
      me.resyncElements();
    },
    /**
     * Returns the merged user-supplied and default dataset-level options
     * @private
     */
    _configure: function _configure() {
      var me = this;
      me._config = helpers$1.merge(Object.create(null), [me.chart.options.datasets[me._type], me.getDataset()], {
        merger: function merger(key, target, source) {
          if (key !== '_meta' && key !== 'data') {
            helpers$1._merger(key, target, source);
          }
        }
      });
    },
    _update: function _update(reset) {
      var me = this;
      me._configure();
      me._cachedDataOpts = null;
      me.update(reset);
    },
    update: helpers$1.noop,
    transition: function transition(easingValue) {
      var meta = this.getMeta();
      var elements = meta.data || [];
      var ilen = elements.length;
      var i = 0;
      for (; i < ilen; ++i) {
        elements[i].transition(easingValue);
      }
      if (meta.dataset) {
        meta.dataset.transition(easingValue);
      }
    },
    draw: function draw() {
      var meta = this.getMeta();
      var elements = meta.data || [];
      var ilen = elements.length;
      var i = 0;
      if (meta.dataset) {
        meta.dataset.draw();
      }
      for (; i < ilen; ++i) {
        elements[i].draw();
      }
    },
    /**
     * Returns a set of predefined style properties that should be used to represent the dataset
     * or the data if the index is specified
     * @param {number} index - data index
     * @return {IStyleInterface} style object
     */
    getStyle: function getStyle(index) {
      var me = this;
      var meta = me.getMeta();
      var dataset = meta.dataset;
      var style;
      me._configure();
      if (dataset && index === undefined) {
        style = me._resolveDatasetElementOptions(dataset || {});
      } else {
        index = index || 0;
        style = me._resolveDataElementOptions(meta.data[index] || {}, index);
      }
      if (style.fill === false || style.fill === null) {
        style.backgroundColor = style.borderColor;
      }
      return style;
    },
    /**
     * @private
     */
    _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element, hover) {
      var me = this;
      var chart = me.chart;
      var datasetOpts = me._config;
      var custom = element.custom || {};
      var options = chart.options.elements[me.datasetElementType.prototype._type] || {};
      var elementOptions = me._datasetElementOptions;
      var values = {};
      var i, ilen, key, readKey;

      // Scriptable options
      var context = {
        chart: chart,
        dataset: me.getDataset(),
        datasetIndex: me.index,
        hover: hover
      };
      for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
        key = elementOptions[i];
        readKey = hover ? 'hover' + key.charAt(0).toUpperCase() + key.slice(1) : key;
        values[key] = resolve([custom[readKey], datasetOpts[readKey], options[readKey]], context);
      }
      return values;
    },
    /**
     * @private
     */
    _resolveDataElementOptions: function _resolveDataElementOptions(element, index) {
      var me = this;
      var custom = element && element.custom;
      var cached = me._cachedDataOpts;
      if (cached && !custom) {
        return cached;
      }
      var chart = me.chart;
      var datasetOpts = me._config;
      var options = chart.options.elements[me.dataElementType.prototype._type] || {};
      var elementOptions = me._dataElementOptions;
      var values = {};

      // Scriptable options
      var context = {
        chart: chart,
        dataIndex: index,
        dataset: me.getDataset(),
        datasetIndex: me.index
      };

      // `resolve` sets cacheable to `false` if any option is indexed or scripted
      var info = {
        cacheable: !custom
      };
      var keys, i, ilen, key;
      custom = custom || {};
      if (helpers$1.isArray(elementOptions)) {
        for (i = 0, ilen = elementOptions.length; i < ilen; ++i) {
          key = elementOptions[i];
          values[key] = resolve([custom[key], datasetOpts[key], options[key]], context, index, info);
        }
      } else {
        keys = Object.keys(elementOptions);
        for (i = 0, ilen = keys.length; i < ilen; ++i) {
          key = keys[i];
          values[key] = resolve([custom[key], datasetOpts[elementOptions[key]], datasetOpts[key], options[key]], context, index, info);
        }
      }
      if (info.cacheable) {
        me._cachedDataOpts = Object.freeze(values);
      }
      return values;
    },
    removeHoverStyle: function removeHoverStyle(element) {
      helpers$1.merge(element._model, element.$previousStyle || {});
      delete element.$previousStyle;
    },
    setHoverStyle: function setHoverStyle(element) {
      var dataset = this.chart.data.datasets[element._datasetIndex];
      var index = element._index;
      var custom = element.custom || {};
      var model = element._model;
      var getHoverColor = helpers$1.getHoverColor;
      element.$previousStyle = {
        backgroundColor: model.backgroundColor,
        borderColor: model.borderColor,
        borderWidth: model.borderWidth
      };
      model.backgroundColor = resolve([custom.hoverBackgroundColor, dataset.hoverBackgroundColor, getHoverColor(model.backgroundColor)], undefined, index);
      model.borderColor = resolve([custom.hoverBorderColor, dataset.hoverBorderColor, getHoverColor(model.borderColor)], undefined, index);
      model.borderWidth = resolve([custom.hoverBorderWidth, dataset.hoverBorderWidth, model.borderWidth], undefined, index);
    },
    /**
     * @private
     */
    _removeDatasetHoverStyle: function _removeDatasetHoverStyle() {
      var element = this.getMeta().dataset;
      if (element) {
        this.removeHoverStyle(element);
      }
    },
    /**
     * @private
     */
    _setDatasetHoverStyle: function _setDatasetHoverStyle() {
      var element = this.getMeta().dataset;
      var prev = {};
      var i, ilen, key, keys, hoverOptions, model;
      if (!element) {
        return;
      }
      model = element._model;
      hoverOptions = this._resolveDatasetElementOptions(element, true);
      keys = Object.keys(hoverOptions);
      for (i = 0, ilen = keys.length; i < ilen; ++i) {
        key = keys[i];
        prev[key] = model[key];
        model[key] = hoverOptions[key];
      }
      element.$previousStyle = prev;
    },
    /**
     * @private
     */
    resyncElements: function resyncElements() {
      var me = this;
      var meta = me.getMeta();
      var data = me.getDataset().data;
      var numMeta = meta.data.length;
      var numData = data.length;
      if (numData < numMeta) {
        meta.data.splice(numData, numMeta - numData);
      } else if (numData > numMeta) {
        me.insertElements(numMeta, numData - numMeta);
      }
    },
    /**
     * @private
     */
    insertElements: function insertElements(start, count) {
      for (var i = 0; i < count; ++i) {
        this.addElementAndReset(start + i);
      }
    },
    /**
     * @private
     */
    onDataPush: function onDataPush() {
      var count = arguments.length;
      this.insertElements(this.getDataset().data.length - count, count);
    },
    /**
     * @private
     */
    onDataPop: function onDataPop() {
      this.getMeta().data.pop();
    },
    /**
     * @private
     */
    onDataShift: function onDataShift() {
      this.getMeta().data.shift();
    },
    /**
     * @private
     */
    onDataSplice: function onDataSplice(start, count) {
      this.getMeta().data.splice(start, count);
      this.insertElements(start, arguments.length - 2);
    },
    /**
     * @private
     */
    onDataUnshift: function onDataUnshift() {
      this.insertElements(0, arguments.length);
    }
  });
  DatasetController.extend = helpers$1.inherits;
  var core_datasetController = DatasetController;
  var TAU = Math.PI * 2;
  core_defaults._set('global', {
    elements: {
      arc: {
        backgroundColor: core_defaults.global.defaultColor,
        borderColor: '#fff',
        borderWidth: 2,
        borderAlign: 'center'
      }
    }
  });
  function clipArc(ctx, arc) {
    var startAngle = arc.startAngle;
    var endAngle = arc.endAngle;
    var pixelMargin = arc.pixelMargin;
    var angleMargin = pixelMargin / arc.outerRadius;
    var x = arc.x;
    var y = arc.y;

    // Draw an inner border by cliping the arc and drawing a double-width border
    // Enlarge the clipping arc by 0.33 pixels to eliminate glitches between borders
    ctx.beginPath();
    ctx.arc(x, y, arc.outerRadius, startAngle - angleMargin, endAngle + angleMargin);
    if (arc.innerRadius > pixelMargin) {
      angleMargin = pixelMargin / arc.innerRadius;
      ctx.arc(x, y, arc.innerRadius - pixelMargin, endAngle + angleMargin, startAngle - angleMargin, true);
    } else {
      ctx.arc(x, y, pixelMargin, endAngle + Math.PI / 2, startAngle - Math.PI / 2);
    }
    ctx.closePath();
    ctx.clip();
  }
  function drawFullCircleBorders(ctx, vm, arc, inner) {
    var endAngle = arc.endAngle;
    var i;
    if (inner) {
      arc.endAngle = arc.startAngle + TAU;
      clipArc(ctx, arc);
      arc.endAngle = endAngle;
      if (arc.endAngle === arc.startAngle && arc.fullCircles) {
        arc.endAngle += TAU;
        arc.fullCircles--;
      }
    }
    ctx.beginPath();
    ctx.arc(arc.x, arc.y, arc.innerRadius, arc.startAngle + TAU, arc.startAngle, true);
    for (i = 0; i < arc.fullCircles; ++i) {
      ctx.stroke();
    }
    ctx.beginPath();
    ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.startAngle + TAU);
    for (i = 0; i < arc.fullCircles; ++i) {
      ctx.stroke();
    }
  }
  function drawBorder(ctx, vm, arc) {
    var inner = vm.borderAlign === 'inner';
    if (inner) {
      ctx.lineWidth = vm.borderWidth * 2;
      ctx.lineJoin = 'round';
    } else {
      ctx.lineWidth = vm.borderWidth;
      ctx.lineJoin = 'bevel';
    }
    if (arc.fullCircles) {
      drawFullCircleBorders(ctx, vm, arc, inner);
    }
    if (inner) {
      clipArc(ctx, arc);
    }
    ctx.beginPath();
    ctx.arc(arc.x, arc.y, vm.outerRadius, arc.startAngle, arc.endAngle);
    ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
    ctx.closePath();
    ctx.stroke();
  }
  var element_arc = core_element.extend({
    _type: 'arc',
    inLabelRange: function inLabelRange(mouseX) {
      var vm = this._view;
      if (vm) {
        return Math.pow(mouseX - vm.x, 2) < Math.pow(vm.radius + vm.hoverRadius, 2);
      }
      return false;
    },
    inRange: function inRange(chartX, chartY) {
      var vm = this._view;
      if (vm) {
        var pointRelativePosition = helpers$1.getAngleFromPoint(vm, {
          x: chartX,
          y: chartY
        });
        var angle = pointRelativePosition.angle;
        var distance = pointRelativePosition.distance;

        // Sanitise angle range
        var startAngle = vm.startAngle;
        var endAngle = vm.endAngle;
        while (endAngle < startAngle) {
          endAngle += TAU;
        }
        while (angle > endAngle) {
          angle -= TAU;
        }
        while (angle < startAngle) {
          angle += TAU;
        }

        // Check if within the range of the open/close angle
        var betweenAngles = angle >= startAngle && angle <= endAngle;
        var withinRadius = distance >= vm.innerRadius && distance <= vm.outerRadius;
        return betweenAngles && withinRadius;
      }
      return false;
    },
    getCenterPoint: function getCenterPoint() {
      var vm = this._view;
      var halfAngle = (vm.startAngle + vm.endAngle) / 2;
      var halfRadius = (vm.innerRadius + vm.outerRadius) / 2;
      return {
        x: vm.x + Math.cos(halfAngle) * halfRadius,
        y: vm.y + Math.sin(halfAngle) * halfRadius
      };
    },
    getArea: function getArea() {
      var vm = this._view;
      return Math.PI * ((vm.endAngle - vm.startAngle) / (2 * Math.PI)) * (Math.pow(vm.outerRadius, 2) - Math.pow(vm.innerRadius, 2));
    },
    tooltipPosition: function tooltipPosition() {
      var vm = this._view;
      var centreAngle = vm.startAngle + (vm.endAngle - vm.startAngle) / 2;
      var rangeFromCentre = (vm.outerRadius - vm.innerRadius) / 2 + vm.innerRadius;
      return {
        x: vm.x + Math.cos(centreAngle) * rangeFromCentre,
        y: vm.y + Math.sin(centreAngle) * rangeFromCentre
      };
    },
    draw: function draw() {
      var ctx = this._chart.ctx;
      var vm = this._view;
      var pixelMargin = vm.borderAlign === 'inner' ? 0.33 : 0;
      var arc = {
        x: vm.x,
        y: vm.y,
        innerRadius: vm.innerRadius,
        outerRadius: Math.max(vm.outerRadius - pixelMargin, 0),
        pixelMargin: pixelMargin,
        startAngle: vm.startAngle,
        endAngle: vm.endAngle,
        fullCircles: Math.floor(vm.circumference / TAU)
      };
      var i;
      ctx.save();
      ctx.fillStyle = vm.backgroundColor;
      ctx.strokeStyle = vm.borderColor;
      if (arc.fullCircles) {
        arc.endAngle = arc.startAngle + TAU;
        ctx.beginPath();
        ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
        ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
        ctx.closePath();
        for (i = 0; i < arc.fullCircles; ++i) {
          ctx.fill();
        }
        arc.endAngle = arc.startAngle + vm.circumference % TAU;
      }
      ctx.beginPath();
      ctx.arc(arc.x, arc.y, arc.outerRadius, arc.startAngle, arc.endAngle);
      ctx.arc(arc.x, arc.y, arc.innerRadius, arc.endAngle, arc.startAngle, true);
      ctx.closePath();
      ctx.fill();
      if (vm.borderWidth) {
        drawBorder(ctx, vm, arc);
      }
      ctx.restore();
    }
  });
  var valueOrDefault$1 = helpers$1.valueOrDefault;
  var defaultColor = core_defaults.global.defaultColor;
  core_defaults._set('global', {
    elements: {
      line: {
        tension: 0.4,
        backgroundColor: defaultColor,
        borderWidth: 3,
        borderColor: defaultColor,
        borderCapStyle: 'butt',
        borderDash: [],
        borderDashOffset: 0.0,
        borderJoinStyle: 'miter',
        capBezierPoints: true,
        fill: true // do we fill in the area between the line and its base axis
      }
    }
  });
  var element_line = core_element.extend({
    _type: 'line',
    draw: function draw() {
      var me = this;
      var vm = me._view;
      var ctx = me._chart.ctx;
      var spanGaps = vm.spanGaps;
      var points = me._children.slice(); // clone array
      var globalDefaults = core_defaults.global;
      var globalOptionLineElements = globalDefaults.elements.line;
      var lastDrawnIndex = -1;
      var closePath = me._loop;
      var index, previous, currentVM;
      if (!points.length) {
        return;
      }
      if (me._loop) {
        for (index = 0; index < points.length; ++index) {
          previous = helpers$1.previousItem(points, index);
          // If the line has an open path, shift the point array
          if (!points[index]._view.skip && previous._view.skip) {
            points = points.slice(index).concat(points.slice(0, index));
            closePath = spanGaps;
            break;
          }
        }
        // If the line has a close path, add the first point again
        if (closePath) {
          points.push(points[0]);
        }
      }
      ctx.save();

      // Stroke Line Options
      ctx.lineCap = vm.borderCapStyle || globalOptionLineElements.borderCapStyle;

      // IE 9 and 10 do not support line dash
      if (ctx.setLineDash) {
        ctx.setLineDash(vm.borderDash || globalOptionLineElements.borderDash);
      }
      ctx.lineDashOffset = valueOrDefault$1(vm.borderDashOffset, globalOptionLineElements.borderDashOffset);
      ctx.lineJoin = vm.borderJoinStyle || globalOptionLineElements.borderJoinStyle;
      ctx.lineWidth = valueOrDefault$1(vm.borderWidth, globalOptionLineElements.borderWidth);
      ctx.strokeStyle = vm.borderColor || globalDefaults.defaultColor;

      // Stroke Line
      ctx.beginPath();

      // First point moves to it's starting position no matter what
      currentVM = points[0]._view;
      if (!currentVM.skip) {
        ctx.moveTo(currentVM.x, currentVM.y);
        lastDrawnIndex = 0;
      }
      for (index = 1; index < points.length; ++index) {
        currentVM = points[index]._view;
        previous = lastDrawnIndex === -1 ? helpers$1.previousItem(points, index) : points[lastDrawnIndex];
        if (!currentVM.skip) {
          if (lastDrawnIndex !== index - 1 && !spanGaps || lastDrawnIndex === -1) {
            // There was a gap and this is the first point after the gap
            ctx.moveTo(currentVM.x, currentVM.y);
          } else {
            // Line to next point
            helpers$1.canvas.lineTo(ctx, previous._view, currentVM);
          }
          lastDrawnIndex = index;
        }
      }
      if (closePath) {
        ctx.closePath();
      }
      ctx.stroke();
      ctx.restore();
    }
  });
  var valueOrDefault$2 = helpers$1.valueOrDefault;
  var defaultColor$1 = core_defaults.global.defaultColor;
  core_defaults._set('global', {
    elements: {
      point: {
        radius: 3,
        pointStyle: 'circle',
        backgroundColor: defaultColor$1,
        borderColor: defaultColor$1,
        borderWidth: 1,
        // Hover
        hitRadius: 1,
        hoverRadius: 4,
        hoverBorderWidth: 1
      }
    }
  });
  function xRange(mouseX) {
    var vm = this._view;
    return vm ? Math.abs(mouseX - vm.x) < vm.radius + vm.hitRadius : false;
  }
  function yRange(mouseY) {
    var vm = this._view;
    return vm ? Math.abs(mouseY - vm.y) < vm.radius + vm.hitRadius : false;
  }
  var element_point = core_element.extend({
    _type: 'point',
    inRange: function inRange(mouseX, mouseY) {
      var vm = this._view;
      return vm ? Math.pow(mouseX - vm.x, 2) + Math.pow(mouseY - vm.y, 2) < Math.pow(vm.hitRadius + vm.radius, 2) : false;
    },
    inLabelRange: xRange,
    inXRange: xRange,
    inYRange: yRange,
    getCenterPoint: function getCenterPoint() {
      var vm = this._view;
      return {
        x: vm.x,
        y: vm.y
      };
    },
    getArea: function getArea() {
      return Math.PI * Math.pow(this._view.radius, 2);
    },
    tooltipPosition: function tooltipPosition() {
      var vm = this._view;
      return {
        x: vm.x,
        y: vm.y,
        padding: vm.radius + vm.borderWidth
      };
    },
    draw: function draw(chartArea) {
      var vm = this._view;
      var ctx = this._chart.ctx;
      var pointStyle = vm.pointStyle;
      var rotation = vm.rotation;
      var radius = vm.radius;
      var x = vm.x;
      var y = vm.y;
      var globalDefaults = core_defaults.global;
      var defaultColor = globalDefaults.defaultColor; // eslint-disable-line no-shadow

      if (vm.skip) {
        return;
      }

      // Clipping for Points.
      if (chartArea === undefined || helpers$1.canvas._isPointInArea(vm, chartArea)) {
        ctx.strokeStyle = vm.borderColor || defaultColor;
        ctx.lineWidth = valueOrDefault$2(vm.borderWidth, globalDefaults.elements.point.borderWidth);
        ctx.fillStyle = vm.backgroundColor || defaultColor;
        helpers$1.canvas.drawPoint(ctx, pointStyle, radius, x, y, rotation);
      }
    }
  });
  var defaultColor$2 = core_defaults.global.defaultColor;
  core_defaults._set('global', {
    elements: {
      rectangle: {
        backgroundColor: defaultColor$2,
        borderColor: defaultColor$2,
        borderSkipped: 'bottom',
        borderWidth: 0
      }
    }
  });
  function isVertical(vm) {
    return vm && vm.width !== undefined;
  }

  /**
   * Helper function to get the bounds of the bar regardless of the orientation
   * @param bar {Chart.Element.Rectangle} the bar
   * @return {Bounds} bounds of the bar
   * @private
   */
  function getBarBounds(vm) {
    var x1, x2, y1, y2, half;
    if (isVertical(vm)) {
      half = vm.width / 2;
      x1 = vm.x - half;
      x2 = vm.x + half;
      y1 = Math.min(vm.y, vm.base);
      y2 = Math.max(vm.y, vm.base);
    } else {
      half = vm.height / 2;
      x1 = Math.min(vm.x, vm.base);
      x2 = Math.max(vm.x, vm.base);
      y1 = vm.y - half;
      y2 = vm.y + half;
    }
    return {
      left: x1,
      top: y1,
      right: x2,
      bottom: y2
    };
  }
  function swap(orig, v1, v2) {
    return orig === v1 ? v2 : orig === v2 ? v1 : orig;
  }
  function parseBorderSkipped(vm) {
    var edge = vm.borderSkipped;
    var res = {};
    if (!edge) {
      return res;
    }
    if (vm.horizontal) {
      if (vm.base > vm.x) {
        edge = swap(edge, 'left', 'right');
      }
    } else if (vm.base < vm.y) {
      edge = swap(edge, 'bottom', 'top');
    }
    res[edge] = true;
    return res;
  }
  function parseBorderWidth(vm, maxW, maxH) {
    var value = vm.borderWidth;
    var skip = parseBorderSkipped(vm);
    var t, r, b, l;
    if (helpers$1.isObject(value)) {
      t = +value.top || 0;
      r = +value.right || 0;
      b = +value.bottom || 0;
      l = +value.left || 0;
    } else {
      t = r = b = l = +value || 0;
    }
    return {
      t: skip.top || t < 0 ? 0 : t > maxH ? maxH : t,
      r: skip.right || r < 0 ? 0 : r > maxW ? maxW : r,
      b: skip.bottom || b < 0 ? 0 : b > maxH ? maxH : b,
      l: skip.left || l < 0 ? 0 : l > maxW ? maxW : l
    };
  }
  function boundingRects(vm) {
    var bounds = getBarBounds(vm);
    var width = bounds.right - bounds.left;
    var height = bounds.bottom - bounds.top;
    var border = parseBorderWidth(vm, width / 2, height / 2);
    return {
      outer: {
        x: bounds.left,
        y: bounds.top,
        w: width,
        h: height
      },
      inner: {
        x: bounds.left + border.l,
        y: bounds.top + border.t,
        w: width - border.l - border.r,
        h: height - border.t - border.b
      }
    };
  }
  function _inRange(vm, x, y) {
    var skipX = x === null;
    var skipY = y === null;
    var bounds = !vm || skipX && skipY ? false : getBarBounds(vm);
    return bounds && (skipX || x >= bounds.left && x <= bounds.right) && (skipY || y >= bounds.top && y <= bounds.bottom);
  }
  var element_rectangle = core_element.extend({
    _type: 'rectangle',
    draw: function draw() {
      var ctx = this._chart.ctx;
      var vm = this._view;
      var rects = boundingRects(vm);
      var outer = rects.outer;
      var inner = rects.inner;
      ctx.fillStyle = vm.backgroundColor;
      ctx.fillRect(outer.x, outer.y, outer.w, outer.h);
      if (outer.w === inner.w && outer.h === inner.h) {
        return;
      }
      ctx.save();
      ctx.beginPath();
      ctx.rect(outer.x, outer.y, outer.w, outer.h);
      ctx.clip();
      ctx.fillStyle = vm.borderColor;
      ctx.rect(inner.x, inner.y, inner.w, inner.h);
      ctx.fill('evenodd');
      ctx.restore();
    },
    height: function height() {
      var vm = this._view;
      return vm.base - vm.y;
    },
    inRange: function inRange(mouseX, mouseY) {
      return _inRange(this._view, mouseX, mouseY);
    },
    inLabelRange: function inLabelRange(mouseX, mouseY) {
      var vm = this._view;
      return isVertical(vm) ? _inRange(vm, mouseX, null) : _inRange(vm, null, mouseY);
    },
    inXRange: function inXRange(mouseX) {
      return _inRange(this._view, mouseX, null);
    },
    inYRange: function inYRange(mouseY) {
      return _inRange(this._view, null, mouseY);
    },
    getCenterPoint: function getCenterPoint() {
      var vm = this._view;
      var x, y;
      if (isVertical(vm)) {
        x = vm.x;
        y = (vm.y + vm.base) / 2;
      } else {
        x = (vm.x + vm.base) / 2;
        y = vm.y;
      }
      return {
        x: x,
        y: y
      };
    },
    getArea: function getArea() {
      var vm = this._view;
      return isVertical(vm) ? vm.width * Math.abs(vm.y - vm.base) : vm.height * Math.abs(vm.x - vm.base);
    },
    tooltipPosition: function tooltipPosition() {
      var vm = this._view;
      return {
        x: vm.x,
        y: vm.y
      };
    }
  });
  var elements = {};
  var Arc = element_arc;
  var Line = element_line;
  var Point = element_point;
  var Rectangle = element_rectangle;
  elements.Arc = Arc;
  elements.Line = Line;
  elements.Point = Point;
  elements.Rectangle = Rectangle;
  var deprecated = helpers$1._deprecated;
  var valueOrDefault$3 = helpers$1.valueOrDefault;
  core_defaults._set('bar', {
    hover: {
      mode: 'label'
    },
    scales: {
      xAxes: [{
        type: 'category',
        offset: true,
        gridLines: {
          offsetGridLines: true
        }
      }],
      yAxes: [{
        type: 'linear'
      }]
    }
  });
  core_defaults._set('global', {
    datasets: {
      bar: {
        categoryPercentage: 0.8,
        barPercentage: 0.9
      }
    }
  });

  /**
   * Computes the "optimal" sample size to maintain bars equally sized while preventing overlap.
   * @private
   */
  function computeMinSampleSize(scale, pixels) {
    var min = scale._length;
    var prev, curr, i, ilen;
    for (i = 1, ilen = pixels.length; i < ilen; ++i) {
      min = Math.min(min, Math.abs(pixels[i] - pixels[i - 1]));
    }
    for (i = 0, ilen = scale.getTicks().length; i < ilen; ++i) {
      curr = scale.getPixelForTick(i);
      min = i > 0 ? Math.min(min, Math.abs(curr - prev)) : min;
      prev = curr;
    }
    return min;
  }

  /**
   * Computes an "ideal" category based on the absolute bar thickness or, if undefined or null,
   * uses the smallest interval (see computeMinSampleSize) that prevents bar overlapping. This
   * mode currently always generates bars equally sized (until we introduce scriptable options?).
   * @private
   */
  function computeFitCategoryTraits(index, ruler, options) {
    var thickness = options.barThickness;
    var count = ruler.stackCount;
    var curr = ruler.pixels[index];
    var min = helpers$1.isNullOrUndef(thickness) ? computeMinSampleSize(ruler.scale, ruler.pixels) : -1;
    var size, ratio;
    if (helpers$1.isNullOrUndef(thickness)) {
      size = min * options.categoryPercentage;
      ratio = options.barPercentage;
    } else {
      // When bar thickness is enforced, category and bar percentages are ignored.
      // Note(SB): we could add support for relative bar thickness (e.g. barThickness: '50%')
      // and deprecate barPercentage since this value is ignored when thickness is absolute.
      size = thickness * count;
      ratio = 1;
    }
    return {
      chunk: size / count,
      ratio: ratio,
      start: curr - size / 2
    };
  }

  /**
   * Computes an "optimal" category that globally arranges bars side by side (no gap when
   * percentage options are 1), based on the previous and following categories. This mode
   * generates bars with different widths when data are not evenly spaced.
   * @private
   */
  function computeFlexCategoryTraits(index, ruler, options) {
    var pixels = ruler.pixels;
    var curr = pixels[index];
    var prev = index > 0 ? pixels[index - 1] : null;
    var next = index < pixels.length - 1 ? pixels[index + 1] : null;
    var percent = options.categoryPercentage;
    var start, size;
    if (prev === null) {
      // first data: its size is double based on the next point or,
      // if it's also the last data, we use the scale size.
      prev = curr - (next === null ? ruler.end - ruler.start : next - curr);
    }
    if (next === null) {
      // last data: its size is also double based on the previous point.
      next = curr + curr - prev;
    }
    start = curr - (curr - Math.min(prev, next)) / 2 * percent;
    size = Math.abs(next - prev) / 2 * percent;
    return {
      chunk: size / ruler.stackCount,
      ratio: options.barPercentage,
      start: start
    };
  }
  var controller_bar = core_datasetController.extend({
    dataElementType: elements.Rectangle,
    /**
     * @private
     */
    _dataElementOptions: ['backgroundColor', 'borderColor', 'borderSkipped', 'borderWidth', 'barPercentage', 'barThickness', 'categoryPercentage', 'maxBarThickness', 'minBarLength'],
    initialize: function initialize() {
      var me = this;
      var meta, scaleOpts;
      core_datasetController.prototype.initialize.apply(me, arguments);
      meta = me.getMeta();
      meta.stack = me.getDataset().stack;
      meta.bar = true;
      scaleOpts = me._getIndexScale().options;
      deprecated('bar chart', scaleOpts.barPercentage, 'scales.[x/y]Axes.barPercentage', 'dataset.barPercentage');
      deprecated('bar chart', scaleOpts.barThickness, 'scales.[x/y]Axes.barThickness', 'dataset.barThickness');
      deprecated('bar chart', scaleOpts.categoryPercentage, 'scales.[x/y]Axes.categoryPercentage', 'dataset.categoryPercentage');
      deprecated('bar chart', me._getValueScale().options.minBarLength, 'scales.[x/y]Axes.minBarLength', 'dataset.minBarLength');
      deprecated('bar chart', scaleOpts.maxBarThickness, 'scales.[x/y]Axes.maxBarThickness', 'dataset.maxBarThickness');
    },
    update: function update(reset) {
      var me = this;
      var rects = me.getMeta().data;
      var i, ilen;
      me._ruler = me.getRuler();
      for (i = 0, ilen = rects.length; i < ilen; ++i) {
        me.updateElement(rects[i], i, reset);
      }
    },
    updateElement: function updateElement(rectangle, index, reset) {
      var me = this;
      var meta = me.getMeta();
      var dataset = me.getDataset();
      var options = me._resolveDataElementOptions(rectangle, index);
      rectangle._xScale = me.getScaleForId(meta.xAxisID);
      rectangle._yScale = me.getScaleForId(meta.yAxisID);
      rectangle._datasetIndex = me.index;
      rectangle._index = index;
      rectangle._model = {
        backgroundColor: options.backgroundColor,
        borderColor: options.borderColor,
        borderSkipped: options.borderSkipped,
        borderWidth: options.borderWidth,
        datasetLabel: dataset.label,
        label: me.chart.data.labels[index]
      };
      if (helpers$1.isArray(dataset.data[index])) {
        rectangle._model.borderSkipped = null;
      }
      me._updateElementGeometry(rectangle, index, reset, options);
      rectangle.pivot();
    },
    /**
     * @private
     */
    _updateElementGeometry: function _updateElementGeometry(rectangle, index, reset, options) {
      var me = this;
      var model = rectangle._model;
      var vscale = me._getValueScale();
      var base = vscale.getBasePixel();
      var horizontal = vscale.isHorizontal();
      var ruler = me._ruler || me.getRuler();
      var vpixels = me.calculateBarValuePixels(me.index, index, options);
      var ipixels = me.calculateBarIndexPixels(me.index, index, ruler, options);
      model.horizontal = horizontal;
      model.base = reset ? base : vpixels.base;
      model.x = horizontal ? reset ? base : vpixels.head : ipixels.center;
      model.y = horizontal ? ipixels.center : reset ? base : vpixels.head;
      model.height = horizontal ? ipixels.size : undefined;
      model.width = horizontal ? undefined : ipixels.size;
    },
    /**
     * Returns the stacks based on groups and bar visibility.
     * @param {number} [last] - The dataset index
     * @returns {string[]} The list of stack IDs
     * @private
     */
    _getStacks: function _getStacks(last) {
      var me = this;
      var scale = me._getIndexScale();
      var metasets = scale._getMatchingVisibleMetas(me._type);
      var stacked = scale.options.stacked;
      var ilen = metasets.length;
      var stacks = [];
      var i, meta;
      for (i = 0; i < ilen; ++i) {
        meta = metasets[i];
        // stacked   | meta.stack
        //           | found | not found | undefined
        // false     |   x   |     x     |     x
        // true      |       |     x     |
        // undefined |       |     x     |     x
        if (stacked === false || stacks.indexOf(meta.stack) === -1 || stacked === undefined && meta.stack === undefined) {
          stacks.push(meta.stack);
        }
        if (meta.index === last) {
          break;
        }
      }
      return stacks;
    },
    /**
     * Returns the effective number of stacks based on groups and bar visibility.
     * @private
     */
    getStackCount: function getStackCount() {
      return this._getStacks().length;
    },
    /**
     * Returns the stack index for the given dataset based on groups and bar visibility.
     * @param {number} [datasetIndex] - The dataset index
     * @param {string} [name] - The stack name to find
     * @returns {number} The stack index
     * @private
     */
    getStackIndex: function getStackIndex(datasetIndex, name) {
      var stacks = this._getStacks(datasetIndex);
      var index = name !== undefined ? stacks.indexOf(name) : -1; // indexOf returns -1 if element is not present

      return index === -1 ? stacks.length - 1 : index;
    },
    /**
     * @private
     */
    getRuler: function getRuler() {
      var me = this;
      var scale = me._getIndexScale();
      var pixels = [];
      var i, ilen;
      for (i = 0, ilen = me.getMeta().data.length; i < ilen; ++i) {
        pixels.push(scale.getPixelForValue(null, i, me.index));
      }
      return {
        pixels: pixels,
        start: scale._startPixel,
        end: scale._endPixel,
        stackCount: me.getStackCount(),
        scale: scale
      };
    },
    /**
     * Note: pixel values are not clamped to the scale area.
     * @private
     */
    calculateBarValuePixels: function calculateBarValuePixels(datasetIndex, index, options) {
      var me = this;
      var chart = me.chart;
      var scale = me._getValueScale();
      var isHorizontal = scale.isHorizontal();
      var datasets = chart.data.datasets;
      var metasets = scale._getMatchingVisibleMetas(me._type);
      var value = scale._parseValue(datasets[datasetIndex].data[index]);
      var minBarLength = options.minBarLength;
      var stacked = scale.options.stacked;
      var stack = me.getMeta().stack;
      var start = value.start === undefined ? 0 : value.max >= 0 && value.min >= 0 ? value.min : value.max;
      var length = value.start === undefined ? value.end : value.max >= 0 && value.min >= 0 ? value.max - value.min : value.min - value.max;
      var ilen = metasets.length;
      var i, imeta, ivalue, base, head, size, stackLength;
      if (stacked || stacked === undefined && stack !== undefined) {
        for (i = 0; i < ilen; ++i) {
          imeta = metasets[i];
          if (imeta.index === datasetIndex) {
            break;
          }
          if (imeta.stack === stack) {
            stackLength = scale._parseValue(datasets[imeta.index].data[index]);
            ivalue = stackLength.start === undefined ? stackLength.end : stackLength.min >= 0 && stackLength.max >= 0 ? stackLength.max : stackLength.min;
            if (value.min < 0 && ivalue < 0 || value.max >= 0 && ivalue > 0) {
              start += ivalue;
            }
          }
        }
      }
      base = scale.getPixelForValue(start);
      head = scale.getPixelForValue(start + length);
      size = head - base;
      if (minBarLength !== undefined && Math.abs(size) < minBarLength) {
        size = minBarLength;
        if (length >= 0 && !isHorizontal || length < 0 && isHorizontal) {
          head = base - minBarLength;
        } else {
          head = base + minBarLength;
        }
      }
      return {
        size: size,
        base: base,
        head: head,
        center: head + size / 2
      };
    },
    /**
     * @private
     */
    calculateBarIndexPixels: function calculateBarIndexPixels(datasetIndex, index, ruler, options) {
      var me = this;
      var range = options.barThickness === 'flex' ? computeFlexCategoryTraits(index, ruler, options) : computeFitCategoryTraits(index, ruler, options);
      var stackIndex = me.getStackIndex(datasetIndex, me.getMeta().stack);
      var center = range.start + range.chunk * stackIndex + range.chunk / 2;
      var size = Math.min(valueOrDefault$3(options.maxBarThickness, Infinity), range.chunk * range.ratio);
      return {
        base: center - size / 2,
        head: center + size / 2,
        center: center,
        size: size
      };
    },
    draw: function draw() {
      var me = this;
      var chart = me.chart;
      var scale = me._getValueScale();
      var rects = me.getMeta().data;
      var dataset = me.getDataset();
      var ilen = rects.length;
      var i = 0;
      helpers$1.canvas.clipArea(chart.ctx, chart.chartArea);
      for (; i < ilen; ++i) {
        var val = scale._parseValue(dataset.data[i]);
        if (!isNaN(val.min) && !isNaN(val.max)) {
          rects[i].draw();
        }
      }
      helpers$1.canvas.unclipArea(chart.ctx);
    },
    /**
     * @private
     */
    _resolveDataElementOptions: function _resolveDataElementOptions() {
      var me = this;
      var values = helpers$1.extend({}, core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments));
      var indexOpts = me._getIndexScale().options;
      var valueOpts = me._getValueScale().options;
      values.barPercentage = valueOrDefault$3(indexOpts.barPercentage, values.barPercentage);
      values.barThickness = valueOrDefault$3(indexOpts.barThickness, values.barThickness);
      values.categoryPercentage = valueOrDefault$3(indexOpts.categoryPercentage, values.categoryPercentage);
      values.maxBarThickness = valueOrDefault$3(indexOpts.maxBarThickness, values.maxBarThickness);
      values.minBarLength = valueOrDefault$3(valueOpts.minBarLength, values.minBarLength);
      return values;
    }
  });
  var valueOrDefault$4 = helpers$1.valueOrDefault;
  var resolve$1 = helpers$1.options.resolve;
  core_defaults._set('bubble', {
    hover: {
      mode: 'single'
    },
    scales: {
      xAxes: [{
        type: 'linear',
        // bubble should probably use a linear scale by default
        position: 'bottom',
        id: 'x-axis-0' // need an ID so datasets can reference the scale
      }],
      yAxes: [{
        type: 'linear',
        position: 'left',
        id: 'y-axis-0'
      }]
    },
    tooltips: {
      callbacks: {
        title: function title() {
          // Title doesn't make sense for scatter since we format the data as a point
          return '';
        },
        label: function label(item, data) {
          var datasetLabel = data.datasets[item.datasetIndex].label || '';
          var dataPoint = data.datasets[item.datasetIndex].data[item.index];
          return datasetLabel + ': (' + item.xLabel + ', ' + item.yLabel + ', ' + dataPoint.r + ')';
        }
      }
    }
  });
  var controller_bubble = core_datasetController.extend({
    /**
     * @protected
     */
    dataElementType: elements.Point,
    /**
     * @private
     */
    _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth', 'hoverRadius', 'hitRadius', 'pointStyle', 'rotation'],
    /**
     * @protected
     */
    update: function update(reset) {
      var me = this;
      var meta = me.getMeta();
      var points = meta.data;

      // Update Points
      helpers$1.each(points, function (point, index) {
        me.updateElement(point, index, reset);
      });
    },
    /**
     * @protected
     */
    updateElement: function updateElement(point, index, reset) {
      var me = this;
      var meta = me.getMeta();
      var custom = point.custom || {};
      var xScale = me.getScaleForId(meta.xAxisID);
      var yScale = me.getScaleForId(meta.yAxisID);
      var options = me._resolveDataElementOptions(point, index);
      var data = me.getDataset().data[index];
      var dsIndex = me.index;
      var x = reset ? xScale.getPixelForDecimal(0.5) : xScale.getPixelForValue(_typeof(data) === 'object' ? data : NaN, index, dsIndex);
      var y = reset ? yScale.getBasePixel() : yScale.getPixelForValue(data, index, dsIndex);
      point._xScale = xScale;
      point._yScale = yScale;
      point._options = options;
      point._datasetIndex = dsIndex;
      point._index = index;
      point._model = {
        backgroundColor: options.backgroundColor,
        borderColor: options.borderColor,
        borderWidth: options.borderWidth,
        hitRadius: options.hitRadius,
        pointStyle: options.pointStyle,
        rotation: options.rotation,
        radius: reset ? 0 : options.radius,
        skip: custom.skip || isNaN(x) || isNaN(y),
        x: x,
        y: y
      };
      point.pivot();
    },
    /**
     * @protected
     */
    setHoverStyle: function setHoverStyle(point) {
      var model = point._model;
      var options = point._options;
      var getHoverColor = helpers$1.getHoverColor;
      point.$previousStyle = {
        backgroundColor: model.backgroundColor,
        borderColor: model.borderColor,
        borderWidth: model.borderWidth,
        radius: model.radius
      };
      model.backgroundColor = valueOrDefault$4(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
      model.borderColor = valueOrDefault$4(options.hoverBorderColor, getHoverColor(options.borderColor));
      model.borderWidth = valueOrDefault$4(options.hoverBorderWidth, options.borderWidth);
      model.radius = options.radius + options.hoverRadius;
    },
    /**
     * @private
     */
    _resolveDataElementOptions: function _resolveDataElementOptions(point, index) {
      var me = this;
      var chart = me.chart;
      var dataset = me.getDataset();
      var custom = point.custom || {};
      var data = dataset.data[index] || {};
      var values = core_datasetController.prototype._resolveDataElementOptions.apply(me, arguments);

      // Scriptable options
      var context = {
        chart: chart,
        dataIndex: index,
        dataset: dataset,
        datasetIndex: me.index
      };

      // In case values were cached (and thus frozen), we need to clone the values
      if (me._cachedDataOpts === values) {
        values = helpers$1.extend({}, values);
      }

      // Custom radius resolution
      values.radius = resolve$1([custom.radius, data.r, me._config.radius, chart.options.elements.point.radius], context, index);
      return values;
    }
  });
  var valueOrDefault$5 = helpers$1.valueOrDefault;
  var PI$1 = Math.PI;
  var DOUBLE_PI$1 = PI$1 * 2;
  var HALF_PI$1 = PI$1 / 2;
  core_defaults._set('doughnut', {
    animation: {
      // Boolean - Whether we animate the rotation of the Doughnut
      animateRotate: true,
      // Boolean - Whether we animate scaling the Doughnut from the centre
      animateScale: false
    },
    hover: {
      mode: 'single'
    },
    legendCallback: function legendCallback(chart) {
      var list = document.createElement('ul');
      var data = chart.data;
      var datasets = data.datasets;
      var labels = data.labels;
      var i, ilen, listItem, listItemSpan;
      list.setAttribute('class', chart.id + '-legend');
      if (datasets.length) {
        for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
          listItem = list.appendChild(document.createElement('li'));
          listItemSpan = listItem.appendChild(document.createElement('span'));
          listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
          if (labels[i]) {
            listItem.appendChild(document.createTextNode(labels[i]));
          }
        }
      }
      return list.outerHTML;
    },
    legend: {
      labels: {
        generateLabels: function generateLabels(chart) {
          var data = chart.data;
          if (data.labels.length && data.datasets.length) {
            return data.labels.map(function (label, i) {
              var meta = chart.getDatasetMeta(0);
              var style = meta.controller.getStyle(i);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                lineWidth: style.borderWidth,
                hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                // Extra data used for toggling the correct item
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick: function onClick(e, legendItem) {
        var index = legendItem.index;
        var chart = this.chart;
        var i, ilen, meta;
        for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
          meta = chart.getDatasetMeta(i);
          // toggle visibility of index if exists
          if (meta.data[index]) {
            meta.data[index].hidden = !meta.data[index].hidden;
          }
        }
        chart.update();
      }
    },
    // The percentage of the chart that we cut out of the middle.
    cutoutPercentage: 50,
    // The rotation of the chart, where the first data arc begins.
    rotation: -HALF_PI$1,
    // The total circumference of the chart.
    circumference: DOUBLE_PI$1,
    // Need to override these to give a nice default
    tooltips: {
      callbacks: {
        title: function title() {
          return '';
        },
        label: function label(tooltipItem, data) {
          var dataLabel = data.labels[tooltipItem.index];
          var value = ': ' + data.datasets[tooltipItem.datasetIndex].data[tooltipItem.index];
          if (helpers$1.isArray(dataLabel)) {
            // show value on first line of multiline label
            // need to clone because we are changing the value
            dataLabel = dataLabel.slice();
            dataLabel[0] += value;
          } else {
            dataLabel += value;
          }
          return dataLabel;
        }
      }
    }
  });
  var controller_doughnut = core_datasetController.extend({
    dataElementType: elements.Arc,
    linkScales: helpers$1.noop,
    /**
     * @private
     */
    _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],
    // Get index of the dataset in relation to the visible datasets. This allows determining the inner and outer radius correctly
    getRingIndex: function getRingIndex(datasetIndex) {
      var ringIndex = 0;
      for (var j = 0; j < datasetIndex; ++j) {
        if (this.chart.isDatasetVisible(j)) {
          ++ringIndex;
        }
      }
      return ringIndex;
    },
    update: function update(reset) {
      var me = this;
      var chart = me.chart;
      var chartArea = chart.chartArea;
      var opts = chart.options;
      var ratioX = 1;
      var ratioY = 1;
      var offsetX = 0;
      var offsetY = 0;
      var meta = me.getMeta();
      var arcs = meta.data;
      var cutout = opts.cutoutPercentage / 100 || 0;
      var circumference = opts.circumference;
      var chartWeight = me._getRingWeight(me.index);
      var maxWidth, maxHeight, i, ilen;

      // If the chart's circumference isn't a full circle, calculate size as a ratio of the width/height of the arc
      if (circumference < DOUBLE_PI$1) {
        var startAngle = opts.rotation % DOUBLE_PI$1;
        startAngle += startAngle >= PI$1 ? -DOUBLE_PI$1 : startAngle < -PI$1 ? DOUBLE_PI$1 : 0;
        var endAngle = startAngle + circumference;
        var startX = Math.cos(startAngle);
        var startY = Math.sin(startAngle);
        var endX = Math.cos(endAngle);
        var endY = Math.sin(endAngle);
        var contains0 = startAngle <= 0 && endAngle >= 0 || endAngle >= DOUBLE_PI$1;
        var contains90 = startAngle <= HALF_PI$1 && endAngle >= HALF_PI$1 || endAngle >= DOUBLE_PI$1 + HALF_PI$1;
        var contains180 = startAngle === -PI$1 || endAngle >= PI$1;
        var contains270 = startAngle <= -HALF_PI$1 && endAngle >= -HALF_PI$1 || endAngle >= PI$1 + HALF_PI$1;
        var minX = contains180 ? -1 : Math.min(startX, startX * cutout, endX, endX * cutout);
        var minY = contains270 ? -1 : Math.min(startY, startY * cutout, endY, endY * cutout);
        var maxX = contains0 ? 1 : Math.max(startX, startX * cutout, endX, endX * cutout);
        var maxY = contains90 ? 1 : Math.max(startY, startY * cutout, endY, endY * cutout);
        ratioX = (maxX - minX) / 2;
        ratioY = (maxY - minY) / 2;
        offsetX = -(maxX + minX) / 2;
        offsetY = -(maxY + minY) / 2;
      }
      for (i = 0, ilen = arcs.length; i < ilen; ++i) {
        arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
      }
      chart.borderWidth = me.getMaxBorderWidth();
      maxWidth = (chartArea.right - chartArea.left - chart.borderWidth) / ratioX;
      maxHeight = (chartArea.bottom - chartArea.top - chart.borderWidth) / ratioY;
      chart.outerRadius = Math.max(Math.min(maxWidth, maxHeight) / 2, 0);
      chart.innerRadius = Math.max(chart.outerRadius * cutout, 0);
      chart.radiusLength = (chart.outerRadius - chart.innerRadius) / (me._getVisibleDatasetWeightTotal() || 1);
      chart.offsetX = offsetX * chart.outerRadius;
      chart.offsetY = offsetY * chart.outerRadius;
      meta.total = me.calculateTotal();
      me.outerRadius = chart.outerRadius - chart.radiusLength * me._getRingWeightOffset(me.index);
      me.innerRadius = Math.max(me.outerRadius - chart.radiusLength * chartWeight, 0);
      for (i = 0, ilen = arcs.length; i < ilen; ++i) {
        me.updateElement(arcs[i], i, reset);
      }
    },
    updateElement: function updateElement(arc, index, reset) {
      var me = this;
      var chart = me.chart;
      var chartArea = chart.chartArea;
      var opts = chart.options;
      var animationOpts = opts.animation;
      var centerX = (chartArea.left + chartArea.right) / 2;
      var centerY = (chartArea.top + chartArea.bottom) / 2;
      var startAngle = opts.rotation; // non reset case handled later
      var endAngle = opts.rotation; // non reset case handled later
      var dataset = me.getDataset();
      var circumference = reset && animationOpts.animateRotate ? 0 : arc.hidden ? 0 : me.calculateCircumference(dataset.data[index]) * (opts.circumference / DOUBLE_PI$1);
      var innerRadius = reset && animationOpts.animateScale ? 0 : me.innerRadius;
      var outerRadius = reset && animationOpts.animateScale ? 0 : me.outerRadius;
      var options = arc._options || {};
      helpers$1.extend(arc, {
        // Utility
        _datasetIndex: me.index,
        _index: index,
        // Desired view properties
        _model: {
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          borderAlign: options.borderAlign,
          x: centerX + chart.offsetX,
          y: centerY + chart.offsetY,
          startAngle: startAngle,
          endAngle: endAngle,
          circumference: circumference,
          outerRadius: outerRadius,
          innerRadius: innerRadius,
          label: helpers$1.valueAtIndexOrDefault(dataset.label, index, chart.data.labels[index])
        }
      });
      var model = arc._model;

      // Set correct angles if not resetting
      if (!reset || !animationOpts.animateRotate) {
        if (index === 0) {
          model.startAngle = opts.rotation;
        } else {
          model.startAngle = me.getMeta().data[index - 1]._model.endAngle;
        }
        model.endAngle = model.startAngle + model.circumference;
      }
      arc.pivot();
    },
    calculateTotal: function calculateTotal() {
      var dataset = this.getDataset();
      var meta = this.getMeta();
      var total = 0;
      var value;
      helpers$1.each(meta.data, function (element, index) {
        value = dataset.data[index];
        if (!isNaN(value) && !element.hidden) {
          total += Math.abs(value);
        }
      });

      /* if (total === 0) {
      	total = NaN;
      }*/

      return total;
    },
    calculateCircumference: function calculateCircumference(value) {
      var total = this.getMeta().total;
      if (total > 0 && !isNaN(value)) {
        return DOUBLE_PI$1 * (Math.abs(value) / total);
      }
      return 0;
    },
    // gets the max border or hover width to properly scale pie charts
    getMaxBorderWidth: function getMaxBorderWidth(arcs) {
      var me = this;
      var max = 0;
      var chart = me.chart;
      var i, ilen, meta, arc, controller, options, borderWidth, hoverWidth;
      if (!arcs) {
        // Find the outmost visible dataset
        for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
          if (chart.isDatasetVisible(i)) {
            meta = chart.getDatasetMeta(i);
            arcs = meta.data;
            if (i !== me.index) {
              controller = meta.controller;
            }
            break;
          }
        }
      }
      if (!arcs) {
        return 0;
      }
      for (i = 0, ilen = arcs.length; i < ilen; ++i) {
        arc = arcs[i];
        if (controller) {
          controller._configure();
          options = controller._resolveDataElementOptions(arc, i);
        } else {
          options = arc._options;
        }
        if (options.borderAlign !== 'inner') {
          borderWidth = options.borderWidth;
          hoverWidth = options.hoverBorderWidth;
          max = borderWidth > max ? borderWidth : max;
          max = hoverWidth > max ? hoverWidth : max;
        }
      }
      return max;
    },
    /**
     * @protected
     */
    setHoverStyle: function setHoverStyle(arc) {
      var model = arc._model;
      var options = arc._options;
      var getHoverColor = helpers$1.getHoverColor;
      arc.$previousStyle = {
        backgroundColor: model.backgroundColor,
        borderColor: model.borderColor,
        borderWidth: model.borderWidth
      };
      model.backgroundColor = valueOrDefault$5(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
      model.borderColor = valueOrDefault$5(options.hoverBorderColor, getHoverColor(options.borderColor));
      model.borderWidth = valueOrDefault$5(options.hoverBorderWidth, options.borderWidth);
    },
    /**
     * Get radius length offset of the dataset in relation to the visible datasets weights. This allows determining the inner and outer radius correctly
     * @private
     */
    _getRingWeightOffset: function _getRingWeightOffset(datasetIndex) {
      var ringWeightOffset = 0;
      for (var i = 0; i < datasetIndex; ++i) {
        if (this.chart.isDatasetVisible(i)) {
          ringWeightOffset += this._getRingWeight(i);
        }
      }
      return ringWeightOffset;
    },
    /**
     * @private
     */
    _getRingWeight: function _getRingWeight(dataSetIndex) {
      return Math.max(valueOrDefault$5(this.chart.data.datasets[dataSetIndex].weight, 1), 0);
    },
    /**
     * Returns the sum of all visibile data set weights.  This value can be 0.
     * @private
     */
    _getVisibleDatasetWeightTotal: function _getVisibleDatasetWeightTotal() {
      return this._getRingWeightOffset(this.chart.data.datasets.length);
    }
  });
  core_defaults._set('horizontalBar', {
    hover: {
      mode: 'index',
      axis: 'y'
    },
    scales: {
      xAxes: [{
        type: 'linear',
        position: 'bottom'
      }],
      yAxes: [{
        type: 'category',
        position: 'left',
        offset: true,
        gridLines: {
          offsetGridLines: true
        }
      }]
    },
    elements: {
      rectangle: {
        borderSkipped: 'left'
      }
    },
    tooltips: {
      mode: 'index',
      axis: 'y'
    }
  });
  core_defaults._set('global', {
    datasets: {
      horizontalBar: {
        categoryPercentage: 0.8,
        barPercentage: 0.9
      }
    }
  });
  var controller_horizontalBar = controller_bar.extend({
    /**
     * @private
     */
    _getValueScaleId: function _getValueScaleId() {
      return this.getMeta().xAxisID;
    },
    /**
     * @private
     */
    _getIndexScaleId: function _getIndexScaleId() {
      return this.getMeta().yAxisID;
    }
  });
  var valueOrDefault$6 = helpers$1.valueOrDefault;
  var resolve$2 = helpers$1.options.resolve;
  var isPointInArea = helpers$1.canvas._isPointInArea;
  core_defaults._set('line', {
    showLines: true,
    spanGaps: false,
    hover: {
      mode: 'label'
    },
    scales: {
      xAxes: [{
        type: 'category',
        id: 'x-axis-0'
      }],
      yAxes: [{
        type: 'linear',
        id: 'y-axis-0'
      }]
    }
  });
  function scaleClip(scale, halfBorderWidth) {
    var tickOpts = scale && scale.options.ticks || {};
    var reverse = tickOpts.reverse;
    var min = tickOpts.min === undefined ? halfBorderWidth : 0;
    var max = tickOpts.max === undefined ? halfBorderWidth : 0;
    return {
      start: reverse ? max : min,
      end: reverse ? min : max
    };
  }
  function defaultClip(xScale, yScale, borderWidth) {
    var halfBorderWidth = borderWidth / 2;
    var x = scaleClip(xScale, halfBorderWidth);
    var y = scaleClip(yScale, halfBorderWidth);
    return {
      top: y.end,
      right: x.end,
      bottom: y.start,
      left: x.start
    };
  }
  function toClip(value) {
    var t, r, b, l;
    if (helpers$1.isObject(value)) {
      t = value.top;
      r = value.right;
      b = value.bottom;
      l = value.left;
    } else {
      t = r = b = l = value;
    }
    return {
      top: t,
      right: r,
      bottom: b,
      left: l
    };
  }
  var controller_line = core_datasetController.extend({
    datasetElementType: elements.Line,
    dataElementType: elements.Point,
    /**
     * @private
     */
    _datasetElementOptions: ['backgroundColor', 'borderCapStyle', 'borderColor', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'borderWidth', 'cubicInterpolationMode', 'fill'],
    /**
     * @private
     */
    _dataElementOptions: {
      backgroundColor: 'pointBackgroundColor',
      borderColor: 'pointBorderColor',
      borderWidth: 'pointBorderWidth',
      hitRadius: 'pointHitRadius',
      hoverBackgroundColor: 'pointHoverBackgroundColor',
      hoverBorderColor: 'pointHoverBorderColor',
      hoverBorderWidth: 'pointHoverBorderWidth',
      hoverRadius: 'pointHoverRadius',
      pointStyle: 'pointStyle',
      radius: 'pointRadius',
      rotation: 'pointRotation'
    },
    update: function update(reset) {
      var me = this;
      var meta = me.getMeta();
      var line = meta.dataset;
      var points = meta.data || [];
      var options = me.chart.options;
      var config = me._config;
      var showLine = me._showLine = valueOrDefault$6(config.showLine, options.showLines);
      var i, ilen;
      me._xScale = me.getScaleForId(meta.xAxisID);
      me._yScale = me.getScaleForId(meta.yAxisID);

      // Update Line
      if (showLine) {
        // Compatibility: If the properties are defined with only the old name, use those values
        if (config.tension !== undefined && config.lineTension === undefined) {
          config.lineTension = config.tension;
        }

        // Utility
        line._scale = me._yScale;
        line._datasetIndex = me.index;
        // Data
        line._children = points;
        // Model
        line._model = me._resolveDatasetElementOptions(line);
        line.pivot();
      }

      // Update Points
      for (i = 0, ilen = points.length; i < ilen; ++i) {
        me.updateElement(points[i], i, reset);
      }
      if (showLine && line._model.tension !== 0) {
        me.updateBezierControlPoints();
      }

      // Now pivot the point for animation
      for (i = 0, ilen = points.length; i < ilen; ++i) {
        points[i].pivot();
      }
    },
    updateElement: function updateElement(point, index, reset) {
      var me = this;
      var meta = me.getMeta();
      var custom = point.custom || {};
      var dataset = me.getDataset();
      var datasetIndex = me.index;
      var value = dataset.data[index];
      var xScale = me._xScale;
      var yScale = me._yScale;
      var lineModel = meta.dataset._model;
      var x, y;
      var options = me._resolveDataElementOptions(point, index);
      x = xScale.getPixelForValue(_typeof(value) === 'object' ? value : NaN, index, datasetIndex);
      y = reset ? yScale.getBasePixel() : me.calculatePointY(value, index, datasetIndex);

      // Utility
      point._xScale = xScale;
      point._yScale = yScale;
      point._options = options;
      point._datasetIndex = datasetIndex;
      point._index = index;

      // Desired view properties
      point._model = {
        x: x,
        y: y,
        skip: custom.skip || isNaN(x) || isNaN(y),
        // Appearance
        radius: options.radius,
        pointStyle: options.pointStyle,
        rotation: options.rotation,
        backgroundColor: options.backgroundColor,
        borderColor: options.borderColor,
        borderWidth: options.borderWidth,
        tension: valueOrDefault$6(custom.tension, lineModel ? lineModel.tension : 0),
        steppedLine: lineModel ? lineModel.steppedLine : false,
        // Tooltip
        hitRadius: options.hitRadius
      };
    },
    /**
     * @private
     */
    _resolveDatasetElementOptions: function _resolveDatasetElementOptions(element) {
      var me = this;
      var config = me._config;
      var custom = element.custom || {};
      var options = me.chart.options;
      var lineOptions = options.elements.line;
      var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);

      // The default behavior of lines is to break at null values, according
      // to https://github.com/chartjs/Chart.js/issues/2435#issuecomment-216718158
      // This option gives lines the ability to span gaps
      values.spanGaps = valueOrDefault$6(config.spanGaps, options.spanGaps);
      values.tension = valueOrDefault$6(config.lineTension, lineOptions.tension);
      values.steppedLine = resolve$2([custom.steppedLine, config.steppedLine, lineOptions.stepped]);
      values.clip = toClip(valueOrDefault$6(config.clip, defaultClip(me._xScale, me._yScale, values.borderWidth)));
      return values;
    },
    calculatePointY: function calculatePointY(value, index, datasetIndex) {
      var me = this;
      var chart = me.chart;
      var yScale = me._yScale;
      var sumPos = 0;
      var sumNeg = 0;
      var i, ds, dsMeta, stackedRightValue, rightValue, metasets, ilen;
      if (yScale.options.stacked) {
        rightValue = +yScale.getRightValue(value);
        metasets = chart._getSortedVisibleDatasetMetas();
        ilen = metasets.length;
        for (i = 0; i < ilen; ++i) {
          dsMeta = metasets[i];
          if (dsMeta.index === datasetIndex) {
            break;
          }
          ds = chart.data.datasets[dsMeta.index];
          if (dsMeta.type === 'line' && dsMeta.yAxisID === yScale.id) {
            stackedRightValue = +yScale.getRightValue(ds.data[index]);
            if (stackedRightValue < 0) {
              sumNeg += stackedRightValue || 0;
            } else {
              sumPos += stackedRightValue || 0;
            }
          }
        }
        if (rightValue < 0) {
          return yScale.getPixelForValue(sumNeg + rightValue);
        }
        return yScale.getPixelForValue(sumPos + rightValue);
      }
      return yScale.getPixelForValue(value);
    },
    updateBezierControlPoints: function updateBezierControlPoints() {
      var me = this;
      var chart = me.chart;
      var meta = me.getMeta();
      var lineModel = meta.dataset._model;
      var area = chart.chartArea;
      var points = meta.data || [];
      var i, ilen, model, controlPoints;

      // Only consider points that are drawn in case the spanGaps option is used
      if (lineModel.spanGaps) {
        points = points.filter(function (pt) {
          return !pt._model.skip;
        });
      }
      function capControlPoint(pt, min, max) {
        return Math.max(Math.min(pt, max), min);
      }
      if (lineModel.cubicInterpolationMode === 'monotone') {
        helpers$1.splineCurveMonotone(points);
      } else {
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          model = points[i]._model;
          controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i)._model, model, helpers$1.nextItem(points, i)._model, lineModel.tension);
          model.controlPointPreviousX = controlPoints.previous.x;
          model.controlPointPreviousY = controlPoints.previous.y;
          model.controlPointNextX = controlPoints.next.x;
          model.controlPointNextY = controlPoints.next.y;
        }
      }
      if (chart.options.elements.line.capBezierPoints) {
        for (i = 0, ilen = points.length; i < ilen; ++i) {
          model = points[i]._model;
          if (isPointInArea(model, area)) {
            if (i > 0 && isPointInArea(points[i - 1]._model, area)) {
              model.controlPointPreviousX = capControlPoint(model.controlPointPreviousX, area.left, area.right);
              model.controlPointPreviousY = capControlPoint(model.controlPointPreviousY, area.top, area.bottom);
            }
            if (i < points.length - 1 && isPointInArea(points[i + 1]._model, area)) {
              model.controlPointNextX = capControlPoint(model.controlPointNextX, area.left, area.right);
              model.controlPointNextY = capControlPoint(model.controlPointNextY, area.top, area.bottom);
            }
          }
        }
      }
    },
    draw: function draw() {
      var me = this;
      var chart = me.chart;
      var meta = me.getMeta();
      var points = meta.data || [];
      var area = chart.chartArea;
      var canvas = chart.canvas;
      var i = 0;
      var ilen = points.length;
      var clip;
      if (me._showLine) {
        clip = meta.dataset._model.clip;
        helpers$1.canvas.clipArea(chart.ctx, {
          left: clip.left === false ? 0 : area.left - clip.left,
          right: clip.right === false ? canvas.width : area.right + clip.right,
          top: clip.top === false ? 0 : area.top - clip.top,
          bottom: clip.bottom === false ? canvas.height : area.bottom + clip.bottom
        });
        meta.dataset.draw();
        helpers$1.canvas.unclipArea(chart.ctx);
      }

      // Draw the points
      for (; i < ilen; ++i) {
        points[i].draw(area);
      }
    },
    /**
     * @protected
     */
    setHoverStyle: function setHoverStyle(point) {
      var model = point._model;
      var options = point._options;
      var getHoverColor = helpers$1.getHoverColor;
      point.$previousStyle = {
        backgroundColor: model.backgroundColor,
        borderColor: model.borderColor,
        borderWidth: model.borderWidth,
        radius: model.radius
      };
      model.backgroundColor = valueOrDefault$6(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
      model.borderColor = valueOrDefault$6(options.hoverBorderColor, getHoverColor(options.borderColor));
      model.borderWidth = valueOrDefault$6(options.hoverBorderWidth, options.borderWidth);
      model.radius = valueOrDefault$6(options.hoverRadius, options.radius);
    }
  });
  var resolve$3 = helpers$1.options.resolve;
  core_defaults._set('polarArea', {
    scale: {
      type: 'radialLinear',
      angleLines: {
        display: false
      },
      gridLines: {
        circular: true
      },
      pointLabels: {
        display: false
      },
      ticks: {
        beginAtZero: true
      }
    },
    // Boolean - Whether to animate the rotation of the chart
    animation: {
      animateRotate: true,
      animateScale: true
    },
    startAngle: -0.5 * Math.PI,
    legendCallback: function legendCallback(chart) {
      var list = document.createElement('ul');
      var data = chart.data;
      var datasets = data.datasets;
      var labels = data.labels;
      var i, ilen, listItem, listItemSpan;
      list.setAttribute('class', chart.id + '-legend');
      if (datasets.length) {
        for (i = 0, ilen = datasets[0].data.length; i < ilen; ++i) {
          listItem = list.appendChild(document.createElement('li'));
          listItemSpan = listItem.appendChild(document.createElement('span'));
          listItemSpan.style.backgroundColor = datasets[0].backgroundColor[i];
          if (labels[i]) {
            listItem.appendChild(document.createTextNode(labels[i]));
          }
        }
      }
      return list.outerHTML;
    },
    legend: {
      labels: {
        generateLabels: function generateLabels(chart) {
          var data = chart.data;
          if (data.labels.length && data.datasets.length) {
            return data.labels.map(function (label, i) {
              var meta = chart.getDatasetMeta(0);
              var style = meta.controller.getStyle(i);
              return {
                text: label,
                fillStyle: style.backgroundColor,
                strokeStyle: style.borderColor,
                lineWidth: style.borderWidth,
                hidden: isNaN(data.datasets[0].data[i]) || meta.data[i].hidden,
                // Extra data used for toggling the correct item
                index: i
              };
            });
          }
          return [];
        }
      },
      onClick: function onClick(e, legendItem) {
        var index = legendItem.index;
        var chart = this.chart;
        var i, ilen, meta;
        for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
          meta = chart.getDatasetMeta(i);
          meta.data[index].hidden = !meta.data[index].hidden;
        }
        chart.update();
      }
    },
    // Need to override these to give a nice default
    tooltips: {
      callbacks: {
        title: function title() {
          return '';
        },
        label: function label(item, data) {
          return data.labels[item.index] + ': ' + item.yLabel;
        }
      }
    }
  });
  var controller_polarArea = core_datasetController.extend({
    dataElementType: elements.Arc,
    linkScales: helpers$1.noop,
    /**
     * @private
     */
    _dataElementOptions: ['backgroundColor', 'borderColor', 'borderWidth', 'borderAlign', 'hoverBackgroundColor', 'hoverBorderColor', 'hoverBorderWidth'],
    /**
     * @private
     */
    _getIndexScaleId: function _getIndexScaleId() {
      return this.chart.scale.id;
    },
    /**
     * @private
     */
    _getValueScaleId: function _getValueScaleId() {
      return this.chart.scale.id;
    },
    update: function update(reset) {
      var me = this;
      var dataset = me.getDataset();
      var meta = me.getMeta();
      var start = me.chart.options.startAngle || 0;
      var starts = me._starts = [];
      var angles = me._angles = [];
      var arcs = meta.data;
      var i, ilen, angle;
      me._updateRadius();
      meta.count = me.countVisibleElements();
      for (i = 0, ilen = dataset.data.length; i < ilen; i++) {
        starts[i] = start;
        angle = me._computeAngle(i);
        angles[i] = angle;
        start += angle;
      }
      for (i = 0, ilen = arcs.length; i < ilen; ++i) {
        arcs[i]._options = me._resolveDataElementOptions(arcs[i], i);
        me.updateElement(arcs[i], i, reset);
      }
    },
    /**
     * @private
     */
    _updateRadius: function _updateRadius() {
      var me = this;
      var chart = me.chart;
      var chartArea = chart.chartArea;
      var opts = chart.options;
      var minSize = Math.min(chartArea.right - chartArea.left, chartArea.bottom - chartArea.top);
      chart.outerRadius = Math.max(minSize / 2, 0);
      chart.innerRadius = Math.max(opts.cutoutPercentage ? chart.outerRadius / 100 * opts.cutoutPercentage : 1, 0);
      chart.radiusLength = (chart.outerRadius - chart.innerRadius) / chart.getVisibleDatasetCount();
      me.outerRadius = chart.outerRadius - chart.radiusLength * me.index;
      me.innerRadius = me.outerRadius - chart.radiusLength;
    },
    updateElement: function updateElement(arc, index, reset) {
      var me = this;
      var chart = me.chart;
      var dataset = me.getDataset();
      var opts = chart.options;
      var animationOpts = opts.animation;
      var scale = chart.scale;
      var labels = chart.data.labels;
      var centerX = scale.xCenter;
      var centerY = scale.yCenter;

      // var negHalfPI = -0.5 * Math.PI;
      var datasetStartAngle = opts.startAngle;
      var distance = arc.hidden ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
      var startAngle = me._starts[index];
      var endAngle = startAngle + (arc.hidden ? 0 : me._angles[index]);
      var resetRadius = animationOpts.animateScale ? 0 : scale.getDistanceFromCenterForValue(dataset.data[index]);
      var options = arc._options || {};
      helpers$1.extend(arc, {
        // Utility
        _datasetIndex: me.index,
        _index: index,
        _scale: scale,
        // Desired view properties
        _model: {
          backgroundColor: options.backgroundColor,
          borderColor: options.borderColor,
          borderWidth: options.borderWidth,
          borderAlign: options.borderAlign,
          x: centerX,
          y: centerY,
          innerRadius: 0,
          outerRadius: reset ? resetRadius : distance,
          startAngle: reset && animationOpts.animateRotate ? datasetStartAngle : startAngle,
          endAngle: reset && animationOpts.animateRotate ? datasetStartAngle : endAngle,
          label: helpers$1.valueAtIndexOrDefault(labels, index, labels[index])
        }
      });
      arc.pivot();
    },
    countVisibleElements: function countVisibleElements() {
      var dataset = this.getDataset();
      var meta = this.getMeta();
      var count = 0;
      helpers$1.each(meta.data, function (element, index) {
        if (!isNaN(dataset.data[index]) && !element.hidden) {
          count++;
        }
      });
      return count;
    },
    /**
     * @protected
     */
    setHoverStyle: function setHoverStyle(arc) {
      var model = arc._model;
      var options = arc._options;
      var getHoverColor = helpers$1.getHoverColor;
      var valueOrDefault = helpers$1.valueOrDefault;
      arc.$previousStyle = {
        backgroundColor: model.backgroundColor,
        borderColor: model.borderColor,
        borderWidth: model.borderWidth
      };
      model.backgroundColor = valueOrDefault(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
      model.borderColor = valueOrDefault(options.hoverBorderColor, getHoverColor(options.borderColor));
      model.borderWidth = valueOrDefault(options.hoverBorderWidth, options.borderWidth);
    },
    /**
     * @private
     */
    _computeAngle: function _computeAngle(index) {
      var me = this;
      var count = this.getMeta().count;
      var dataset = me.getDataset();
      var meta = me.getMeta();
      if (isNaN(dataset.data[index]) || meta.data[index].hidden) {
        return 0;
      }

      // Scriptable options
      var context = {
        chart: me.chart,
        dataIndex: index,
        dataset: dataset,
        datasetIndex: me.index
      };
      return resolve$3([me.chart.options.elements.arc.angle, 2 * Math.PI / count], context, index);
    }
  });
  core_defaults._set('pie', helpers$1.clone(core_defaults.doughnut));
  core_defaults._set('pie', {
    cutoutPercentage: 0
  });

  // Pie charts are Doughnut chart with different defaults
  var controller_pie = controller_doughnut;
  var valueOrDefault$7 = helpers$1.valueOrDefault;
  core_defaults._set('radar', {
    spanGaps: false,
    scale: {
      type: 'radialLinear'
    },
    elements: {
      line: {
        fill: 'start',
        tension: 0 // no bezier in radar
      }
    }
  });
  var controller_radar = core_datasetController.extend({
    datasetElementType: elements.Line,
    dataElementType: elements.Point,
    linkScales: helpers$1.noop,
    /**
     * @private
     */
    _datasetElementOptions: ['backgroundColor', 'borderWidth', 'borderColor', 'borderCapStyle', 'borderDash', 'borderDashOffset', 'borderJoinStyle', 'fill'],
    /**
     * @private
     */
    _dataElementOptions: {
      backgroundColor: 'pointBackgroundColor',
      borderColor: 'pointBorderColor',
      borderWidth: 'pointBorderWidth',
      hitRadius: 'pointHitRadius',
      hoverBackgroundColor: 'pointHoverBackgroundColor',
      hoverBorderColor: 'pointHoverBorderColor',
      hoverBorderWidth: 'pointHoverBorderWidth',
      hoverRadius: 'pointHoverRadius',
      pointStyle: 'pointStyle',
      radius: 'pointRadius',
      rotation: 'pointRotation'
    },
    /**
     * @private
     */
    _getIndexScaleId: function _getIndexScaleId() {
      return this.chart.scale.id;
    },
    /**
     * @private
     */
    _getValueScaleId: function _getValueScaleId() {
      return this.chart.scale.id;
    },
    update: function update(reset) {
      var me = this;
      var meta = me.getMeta();
      var line = meta.dataset;
      var points = meta.data || [];
      var scale = me.chart.scale;
      var config = me._config;
      var i, ilen;

      // Compatibility: If the properties are defined with only the old name, use those values
      if (config.tension !== undefined && config.lineTension === undefined) {
        config.lineTension = config.tension;
      }

      // Utility
      line._scale = scale;
      line._datasetIndex = me.index;
      // Data
      line._children = points;
      line._loop = true;
      // Model
      line._model = me._resolveDatasetElementOptions(line);
      line.pivot();

      // Update Points
      for (i = 0, ilen = points.length; i < ilen; ++i) {
        me.updateElement(points[i], i, reset);
      }

      // Update bezier control points
      me.updateBezierControlPoints();

      // Now pivot the point for animation
      for (i = 0, ilen = points.length; i < ilen; ++i) {
        points[i].pivot();
      }
    },
    updateElement: function updateElement(point, index, reset) {
      var me = this;
      var custom = point.custom || {};
      var dataset = me.getDataset();
      var scale = me.chart.scale;
      var pointPosition = scale.getPointPositionForValue(index, dataset.data[index]);
      var options = me._resolveDataElementOptions(point, index);
      var lineModel = me.getMeta().dataset._model;
      var x = reset ? scale.xCenter : pointPosition.x;
      var y = reset ? scale.yCenter : pointPosition.y;

      // Utility
      point._scale = scale;
      point._options = options;
      point._datasetIndex = me.index;
      point._index = index;

      // Desired view properties
      point._model = {
        x: x,
        // value not used in dataset scale, but we want a consistent API between scales
        y: y,
        skip: custom.skip || isNaN(x) || isNaN(y),
        // Appearance
        radius: options.radius,
        pointStyle: options.pointStyle,
        rotation: options.rotation,
        backgroundColor: options.backgroundColor,
        borderColor: options.borderColor,
        borderWidth: options.borderWidth,
        tension: valueOrDefault$7(custom.tension, lineModel ? lineModel.tension : 0),
        // Tooltip
        hitRadius: options.hitRadius
      };
    },
    /**
     * @private
     */
    _resolveDatasetElementOptions: function _resolveDatasetElementOptions() {
      var me = this;
      var config = me._config;
      var options = me.chart.options;
      var values = core_datasetController.prototype._resolveDatasetElementOptions.apply(me, arguments);
      values.spanGaps = valueOrDefault$7(config.spanGaps, options.spanGaps);
      values.tension = valueOrDefault$7(config.lineTension, options.elements.line.tension);
      return values;
    },
    updateBezierControlPoints: function updateBezierControlPoints() {
      var me = this;
      var meta = me.getMeta();
      var area = me.chart.chartArea;
      var points = meta.data || [];
      var i, ilen, model, controlPoints;

      // Only consider points that are drawn in case the spanGaps option is used
      if (meta.dataset._model.spanGaps) {
        points = points.filter(function (pt) {
          return !pt._model.skip;
        });
      }
      function capControlPoint(pt, min, max) {
        return Math.max(Math.min(pt, max), min);
      }
      for (i = 0, ilen = points.length; i < ilen; ++i) {
        model = points[i]._model;
        controlPoints = helpers$1.splineCurve(helpers$1.previousItem(points, i, true)._model, model, helpers$1.nextItem(points, i, true)._model, model.tension);

        // Prevent the bezier going outside of the bounds of the graph
        model.controlPointPreviousX = capControlPoint(controlPoints.previous.x, area.left, area.right);
        model.controlPointPreviousY = capControlPoint(controlPoints.previous.y, area.top, area.bottom);
        model.controlPointNextX = capControlPoint(controlPoints.next.x, area.left, area.right);
        model.controlPointNextY = capControlPoint(controlPoints.next.y, area.top, area.bottom);
      }
    },
    setHoverStyle: function setHoverStyle(point) {
      var model = point._model;
      var options = point._options;
      var getHoverColor = helpers$1.getHoverColor;
      point.$previousStyle = {
        backgroundColor: model.backgroundColor,
        borderColor: model.borderColor,
        borderWidth: model.borderWidth,
        radius: model.radius
      };
      model.backgroundColor = valueOrDefault$7(options.hoverBackgroundColor, getHoverColor(options.backgroundColor));
      model.borderColor = valueOrDefault$7(options.hoverBorderColor, getHoverColor(options.borderColor));
      model.borderWidth = valueOrDefault$7(options.hoverBorderWidth, options.borderWidth);
      model.radius = valueOrDefault$7(options.hoverRadius, options.radius);
    }
  });
  core_defaults._set('scatter', {
    hover: {
      mode: 'single'
    },
    scales: {
      xAxes: [{
        id: 'x-axis-1',
        // need an ID so datasets can reference the scale
        type: 'linear',
        // scatter should not use a category axis
        position: 'bottom'
      }],
      yAxes: [{
        id: 'y-axis-1',
        type: 'linear',
        position: 'left'
      }]
    },
    tooltips: {
      callbacks: {
        title: function title() {
          return ''; // doesn't make sense for scatter since data are formatted as a point
        },
        label: function label(item) {
          return '(' + item.xLabel + ', ' + item.yLabel + ')';
        }
      }
    }
  });
  core_defaults._set('global', {
    datasets: {
      scatter: {
        showLine: false
      }
    }
  });

  // Scatter charts use line controllers
  var controller_scatter = controller_line;

  // NOTE export a map in which the key represents the controller type, not
  // the class, and so must be CamelCase in order to be correctly retrieved
  // by the controller in core.controller.js (`controllers[meta.type]`).

  var controllers = {
    bar: controller_bar,
    bubble: controller_bubble,
    doughnut: controller_doughnut,
    horizontalBar: controller_horizontalBar,
    line: controller_line,
    polarArea: controller_polarArea,
    pie: controller_pie,
    radar: controller_radar,
    scatter: controller_scatter
  };

  /**
   * Helper function to get relative position for an event
   * @param {Event|IEvent} event - The event to get the position for
   * @param {Chart} chart - The chart
   * @returns {object} the event position
   */
  function getRelativePosition(e, chart) {
    if (e["native"]) {
      return {
        x: e.x,
        y: e.y
      };
    }
    return helpers$1.getRelativePosition(e, chart);
  }

  /**
   * Helper function to traverse all of the visible elements in the chart
   * @param {Chart} chart - the chart
   * @param {function} handler - the callback to execute for each visible item
   */
  function parseVisibleItems(chart, handler) {
    var metasets = chart._getSortedVisibleDatasetMetas();
    var metadata, i, j, ilen, jlen, element;
    for (i = 0, ilen = metasets.length; i < ilen; ++i) {
      metadata = metasets[i].data;
      for (j = 0, jlen = metadata.length; j < jlen; ++j) {
        element = metadata[j];
        if (!element._view.skip) {
          handler(element);
        }
      }
    }
  }

  /**
   * Helper function to get the items that intersect the event position
   * @param {ChartElement[]} items - elements to filter
   * @param {object} position - the point to be nearest to
   * @return {ChartElement[]} the nearest items
   */
  function getIntersectItems(chart, position) {
    var elements = [];
    parseVisibleItems(chart, function (element) {
      if (element.inRange(position.x, position.y)) {
        elements.push(element);
      }
    });
    return elements;
  }

  /**
   * Helper function to get the items nearest to the event position considering all visible items in teh chart
   * @param {Chart} chart - the chart to look at elements from
   * @param {object} position - the point to be nearest to
   * @param {boolean} intersect - if true, only consider items that intersect the position
   * @param {function} distanceMetric - function to provide the distance between points
   * @return {ChartElement[]} the nearest items
   */
  function getNearestItems(chart, position, intersect, distanceMetric) {
    var minDistance = Number.POSITIVE_INFINITY;
    var nearestItems = [];
    parseVisibleItems(chart, function (element) {
      if (intersect && !element.inRange(position.x, position.y)) {
        return;
      }
      var center = element.getCenterPoint();
      var distance = distanceMetric(position, center);
      if (distance < minDistance) {
        nearestItems = [element];
        minDistance = distance;
      } else if (distance === minDistance) {
        // Can have multiple items at the same distance in which case we sort by size
        nearestItems.push(element);
      }
    });
    return nearestItems;
  }

  /**
   * Get a distance metric function for two points based on the
   * axis mode setting
   * @param {string} axis - the axis mode. x|y|xy
   */
  function getDistanceMetricForAxis(axis) {
    var useX = axis.indexOf('x') !== -1;
    var useY = axis.indexOf('y') !== -1;
    return function (pt1, pt2) {
      var deltaX = useX ? Math.abs(pt1.x - pt2.x) : 0;
      var deltaY = useY ? Math.abs(pt1.y - pt2.y) : 0;
      return Math.sqrt(Math.pow(deltaX, 2) + Math.pow(deltaY, 2));
    };
  }
  function indexMode(chart, e, options) {
    var position = getRelativePosition(e, chart);
    // Default axis for index mode is 'x' to match old behaviour
    options.axis = options.axis || 'x';
    var distanceMetric = getDistanceMetricForAxis(options.axis);
    var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
    var elements = [];
    if (!items.length) {
      return [];
    }
    chart._getSortedVisibleDatasetMetas().forEach(function (meta) {
      var element = meta.data[items[0]._index];

      // don't count items that are skipped (null data)
      if (element && !element._view.skip) {
        elements.push(element);
      }
    });
    return elements;
  }

  /**
   * @interface IInteractionOptions
   */
  /**
   * If true, only consider items that intersect the point
   * @name IInterfaceOptions#boolean
   * @type Boolean
   */

  /**
   * Contains interaction related functions
   * @namespace Chart.Interaction
   */
  var core_interaction = {
    // Helper function for different modes
    modes: {
      single: function single(chart, e) {
        var position = getRelativePosition(e, chart);
        var elements = [];
        parseVisibleItems(chart, function (element) {
          if (element.inRange(position.x, position.y)) {
            elements.push(element);
            return elements;
          }
        });
        return elements.slice(0, 1);
      },
      /**
       * @function Chart.Interaction.modes.label
       * @deprecated since version 2.4.0
       * @todo remove at version 3
       * @private
       */
      label: indexMode,
      /**
       * Returns items at the same index. If the options.intersect parameter is true, we only return items if we intersect something
       * If the options.intersect mode is false, we find the nearest item and return the items at the same index as that item
       * @function Chart.Interaction.modes.index
       * @since v2.4.0
       * @param {Chart} chart - the chart we are returning items from
       * @param {Event} e - the event we are find things at
       * @param {IInteractionOptions} options - options to use during interaction
       * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
       */
      index: indexMode,
      /**
       * Returns items in the same dataset. If the options.intersect parameter is true, we only return items if we intersect something
       * If the options.intersect is false, we find the nearest item and return the items in that dataset
       * @function Chart.Interaction.modes.dataset
       * @param {Chart} chart - the chart we are returning items from
       * @param {Event} e - the event we are find things at
       * @param {IInteractionOptions} options - options to use during interaction
       * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
       */
      dataset: function dataset(chart, e, options) {
        var position = getRelativePosition(e, chart);
        options.axis = options.axis || 'xy';
        var distanceMetric = getDistanceMetricForAxis(options.axis);
        var items = options.intersect ? getIntersectItems(chart, position) : getNearestItems(chart, position, false, distanceMetric);
        if (items.length > 0) {
          items = chart.getDatasetMeta(items[0]._datasetIndex).data;
        }
        return items;
      },
      /**
       * @function Chart.Interaction.modes.x-axis
       * @deprecated since version 2.4.0. Use index mode and intersect == true
       * @todo remove at version 3
       * @private
       */
      'x-axis': function xAxis(chart, e) {
        return indexMode(chart, e, {
          intersect: false
        });
      },
      /**
       * Point mode returns all elements that hit test based on the event position
       * of the event
       * @function Chart.Interaction.modes.intersect
       * @param {Chart} chart - the chart we are returning items from
       * @param {Event} e - the event we are find things at
       * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
       */
      point: function point(chart, e) {
        var position = getRelativePosition(e, chart);
        return getIntersectItems(chart, position);
      },
      /**
       * nearest mode returns the element closest to the point
       * @function Chart.Interaction.modes.intersect
       * @param {Chart} chart - the chart we are returning items from
       * @param {Event} e - the event we are find things at
       * @param {IInteractionOptions} options - options to use
       * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
       */
      nearest: function nearest(chart, e, options) {
        var position = getRelativePosition(e, chart);
        options.axis = options.axis || 'xy';
        var distanceMetric = getDistanceMetricForAxis(options.axis);
        return getNearestItems(chart, position, options.intersect, distanceMetric);
      },
      /**
       * x mode returns the elements that hit-test at the current x coordinate
       * @function Chart.Interaction.modes.x
       * @param {Chart} chart - the chart we are returning items from
       * @param {Event} e - the event we are find things at
       * @param {IInteractionOptions} options - options to use
       * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
       */
      x: function x(chart, e, options) {
        var position = getRelativePosition(e, chart);
        var items = [];
        var intersectsItem = false;
        parseVisibleItems(chart, function (element) {
          if (element.inXRange(position.x)) {
            items.push(element);
          }
          if (element.inRange(position.x, position.y)) {
            intersectsItem = true;
          }
        });

        // If we want to trigger on an intersect and we don't have any items
        // that intersect the position, return nothing
        if (options.intersect && !intersectsItem) {
          items = [];
        }
        return items;
      },
      /**
       * y mode returns the elements that hit-test at the current y coordinate
       * @function Chart.Interaction.modes.y
       * @param {Chart} chart - the chart we are returning items from
       * @param {Event} e - the event we are find things at
       * @param {IInteractionOptions} options - options to use
       * @return {Chart.Element[]} Array of elements that are under the point. If none are found, an empty array is returned
       */
      y: function y(chart, e, options) {
        var position = getRelativePosition(e, chart);
        var items = [];
        var intersectsItem = false;
        parseVisibleItems(chart, function (element) {
          if (element.inYRange(position.y)) {
            items.push(element);
          }
          if (element.inRange(position.x, position.y)) {
            intersectsItem = true;
          }
        });

        // If we want to trigger on an intersect and we don't have any items
        // that intersect the position, return nothing
        if (options.intersect && !intersectsItem) {
          items = [];
        }
        return items;
      }
    }
  };
  var extend = helpers$1.extend;
  function filterByPosition(array, position) {
    return helpers$1.where(array, function (v) {
      return v.pos === position;
    });
  }
  function sortByWeight(array, reverse) {
    return array.sort(function (a, b) {
      var v0 = reverse ? b : a;
      var v1 = reverse ? a : b;
      return v0.weight === v1.weight ? v0.index - v1.index : v0.weight - v1.weight;
    });
  }
  function wrapBoxes(boxes) {
    var layoutBoxes = [];
    var i, ilen, box;
    for (i = 0, ilen = (boxes || []).length; i < ilen; ++i) {
      box = boxes[i];
      layoutBoxes.push({
        index: i,
        box: box,
        pos: box.position,
        horizontal: box.isHorizontal(),
        weight: box.weight
      });
    }
    return layoutBoxes;
  }
  function setLayoutDims(layouts, params) {
    var i, ilen, layout;
    for (i = 0, ilen = layouts.length; i < ilen; ++i) {
      layout = layouts[i];
      // store width used instead of chartArea.w in fitBoxes
      layout.width = layout.horizontal ? layout.box.fullWidth && params.availableWidth : params.vBoxMaxWidth;
      // store height used instead of chartArea.h in fitBoxes
      layout.height = layout.horizontal && params.hBoxMaxHeight;
    }
  }
  function buildLayoutBoxes(boxes) {
    var layoutBoxes = wrapBoxes(boxes);
    var left = sortByWeight(filterByPosition(layoutBoxes, 'left'), true);
    var right = sortByWeight(filterByPosition(layoutBoxes, 'right'));
    var top = sortByWeight(filterByPosition(layoutBoxes, 'top'), true);
    var bottom = sortByWeight(filterByPosition(layoutBoxes, 'bottom'));
    return {
      leftAndTop: left.concat(top),
      rightAndBottom: right.concat(bottom),
      chartArea: filterByPosition(layoutBoxes, 'chartArea'),
      vertical: left.concat(right),
      horizontal: top.concat(bottom)
    };
  }
  function getCombinedMax(maxPadding, chartArea, a, b) {
    return Math.max(maxPadding[a], chartArea[a]) + Math.max(maxPadding[b], chartArea[b]);
  }
  function updateDims(chartArea, params, layout) {
    var box = layout.box;
    var maxPadding = chartArea.maxPadding;
    var newWidth, newHeight;
    if (layout.size) {
      // this layout was already counted for, lets first reduce old size
      chartArea[layout.pos] -= layout.size;
    }
    layout.size = layout.horizontal ? box.height : box.width;
    chartArea[layout.pos] += layout.size;
    if (box.getPadding) {
      var boxPadding = box.getPadding();
      maxPadding.top = Math.max(maxPadding.top, boxPadding.top);
      maxPadding.left = Math.max(maxPadding.left, boxPadding.left);
      maxPadding.bottom = Math.max(maxPadding.bottom, boxPadding.bottom);
      maxPadding.right = Math.max(maxPadding.right, boxPadding.right);
    }
    newWidth = params.outerWidth - getCombinedMax(maxPadding, chartArea, 'left', 'right');
    newHeight = params.outerHeight - getCombinedMax(maxPadding, chartArea, 'top', 'bottom');
    if (newWidth !== chartArea.w || newHeight !== chartArea.h) {
      chartArea.w = newWidth;
      chartArea.h = newHeight;

      // return true if chart area changed in layout's direction
      var sizes = layout.horizontal ? [newWidth, chartArea.w] : [newHeight, chartArea.h];
      return sizes[0] !== sizes[1] && (!isNaN(sizes[0]) || !isNaN(sizes[1]));
    }
  }
  function handleMaxPadding(chartArea) {
    var maxPadding = chartArea.maxPadding;
    function updatePos(pos) {
      var change = Math.max(maxPadding[pos] - chartArea[pos], 0);
      chartArea[pos] += change;
      return change;
    }
    chartArea.y += updatePos('top');
    chartArea.x += updatePos('left');
    updatePos('right');
    updatePos('bottom');
  }
  function getMargins(horizontal, chartArea) {
    var maxPadding = chartArea.maxPadding;
    function marginForPositions(positions) {
      var margin = {
        left: 0,
        top: 0,
        right: 0,
        bottom: 0
      };
      positions.forEach(function (pos) {
        margin[pos] = Math.max(chartArea[pos], maxPadding[pos]);
      });
      return margin;
    }
    return horizontal ? marginForPositions(['left', 'right']) : marginForPositions(['top', 'bottom']);
  }
  function fitBoxes(boxes, chartArea, params) {
    var refitBoxes = [];
    var i, ilen, layout, box, refit, changed;
    for (i = 0, ilen = boxes.length; i < ilen; ++i) {
      layout = boxes[i];
      box = layout.box;
      box.update(layout.width || chartArea.w, layout.height || chartArea.h, getMargins(layout.horizontal, chartArea));
      if (updateDims(chartArea, params, layout)) {
        changed = true;
        if (refitBoxes.length) {
          // Dimensions changed and there were non full width boxes before this
          // -> we have to refit those
          refit = true;
        }
      }
      if (!box.fullWidth) {
        // fullWidth boxes don't need to be re-fitted in any case
        refitBoxes.push(layout);
      }
    }
    return refit ? fitBoxes(refitBoxes, chartArea, params) || changed : changed;
  }
  function placeBoxes(boxes, chartArea, params) {
    var userPadding = params.padding;
    var x = chartArea.x;
    var y = chartArea.y;
    var i, ilen, layout, box;
    for (i = 0, ilen = boxes.length; i < ilen; ++i) {
      layout = boxes[i];
      box = layout.box;
      if (layout.horizontal) {
        box.left = box.fullWidth ? userPadding.left : chartArea.left;
        box.right = box.fullWidth ? params.outerWidth - userPadding.right : chartArea.left + chartArea.w;
        box.top = y;
        box.bottom = y + box.height;
        box.width = box.right - box.left;
        y = box.bottom;
      } else {
        box.left = x;
        box.right = x + box.width;
        box.top = chartArea.top;
        box.bottom = chartArea.top + chartArea.h;
        box.height = box.bottom - box.top;
        x = box.right;
      }
    }
    chartArea.x = x;
    chartArea.y = y;
  }
  core_defaults._set('global', {
    layout: {
      padding: {
        top: 0,
        right: 0,
        bottom: 0,
        left: 0
      }
    }
  });

  /**
   * @interface ILayoutItem
   * @prop {string} position - The position of the item in the chart layout. Possible values are
   * 'left', 'top', 'right', 'bottom', and 'chartArea'
   * @prop {number} weight - The weight used to sort the item. Higher weights are further away from the chart area
   * @prop {boolean} fullWidth - if true, and the item is horizontal, then push vertical boxes down
   * @prop {function} isHorizontal - returns true if the layout item is horizontal (ie. top or bottom)
   * @prop {function} update - Takes two parameters: width and height. Returns size of item
   * @prop {function} getPadding -  Returns an object with padding on the edges
   * @prop {number} width - Width of item. Must be valid after update()
   * @prop {number} height - Height of item. Must be valid after update()
   * @prop {number} left - Left edge of the item. Set by layout system and cannot be used in update
   * @prop {number} top - Top edge of the item. Set by layout system and cannot be used in update
   * @prop {number} right - Right edge of the item. Set by layout system and cannot be used in update
   * @prop {number} bottom - Bottom edge of the item. Set by layout system and cannot be used in update
   */

  // The layout service is very self explanatory.  It's responsible for the layout within a chart.
  // Scales, Legends and Plugins all rely on the layout service and can easily register to be placed anywhere they need
  // It is this service's responsibility of carrying out that layout.
  var core_layouts = {
    defaults: {},
    /**
     * Register a box to a chart.
     * A box is simply a reference to an object that requires layout. eg. Scales, Legend, Title.
     * @param {Chart} chart - the chart to use
     * @param {ILayoutItem} item - the item to add to be layed out
     */
    addBox: function addBox(chart, item) {
      if (!chart.boxes) {
        chart.boxes = [];
      }

      // initialize item with default values
      item.fullWidth = item.fullWidth || false;
      item.position = item.position || 'top';
      item.weight = item.weight || 0;
      item._layers = item._layers || function () {
        return [{
          z: 0,
          draw: function draw() {
            item.draw.apply(item, arguments);
          }
        }];
      };
      chart.boxes.push(item);
    },
    /**
     * Remove a layoutItem from a chart
     * @param {Chart} chart - the chart to remove the box from
     * @param {ILayoutItem} layoutItem - the item to remove from the layout
     */
    removeBox: function removeBox(chart, layoutItem) {
      var index = chart.boxes ? chart.boxes.indexOf(layoutItem) : -1;
      if (index !== -1) {
        chart.boxes.splice(index, 1);
      }
    },
    /**
     * Sets (or updates) options on the given `item`.
     * @param {Chart} chart - the chart in which the item lives (or will be added to)
     * @param {ILayoutItem} item - the item to configure with the given options
     * @param {object} options - the new item options.
     */
    configure: function configure(chart, item, options) {
      var props = ['fullWidth', 'position', 'weight'];
      var ilen = props.length;
      var i = 0;
      var prop;
      for (; i < ilen; ++i) {
        prop = props[i];
        if (options.hasOwnProperty(prop)) {
          item[prop] = options[prop];
        }
      }
    },
    /**
     * Fits boxes of the given chart into the given size by having each box measure itself
     * then running a fitting algorithm
     * @param {Chart} chart - the chart
     * @param {number} width - the width to fit into
     * @param {number} height - the height to fit into
     */
    update: function update(chart, width, height) {
      if (!chart) {
        return;
      }
      var layoutOptions = chart.options.layout || {};
      var padding = helpers$1.options.toPadding(layoutOptions.padding);
      var availableWidth = width - padding.width;
      var availableHeight = height - padding.height;
      var boxes = buildLayoutBoxes(chart.boxes);
      var verticalBoxes = boxes.vertical;
      var horizontalBoxes = boxes.horizontal;

      // Essentially we now have any number of boxes on each of the 4 sides.
      // Our canvas looks like the following.
      // The areas L1 and L2 are the left axes. R1 is the right axis, T1 is the top axis and
      // B1 is the bottom axis
      // There are also 4 quadrant-like locations (left to right instead of clockwise) reserved for chart overlays
      // These locations are single-box locations only, when trying to register a chartArea location that is already taken,
      // an error will be thrown.
      //
      // |----------------------------------------------------|
      // |                  T1 (Full Width)                   |
      // |----------------------------------------------------|
      // |    |    |                 T2                  |    |
      // |    |----|-------------------------------------|----|
      // |    |    | C1 |                           | C2 |    |
      // |    |    |----|                           |----|    |
      // |    |    |                                     |    |
      // | L1 | L2 |           ChartArea (C0)            | R1 |
      // |    |    |                                     |    |
      // |    |    |----|                           |----|    |
      // |    |    | C3 |                           | C4 |    |
      // |    |----|-------------------------------------|----|
      // |    |    |                 B1                  |    |
      // |----------------------------------------------------|
      // |                  B2 (Full Width)                   |
      // |----------------------------------------------------|
      //

      var params = Object.freeze({
        outerWidth: width,
        outerHeight: height,
        padding: padding,
        availableWidth: availableWidth,
        vBoxMaxWidth: availableWidth / 2 / verticalBoxes.length,
        hBoxMaxHeight: availableHeight / 2
      });
      var chartArea = extend({
        maxPadding: extend({}, padding),
        w: availableWidth,
        h: availableHeight,
        x: padding.left,
        y: padding.top
      }, padding);
      setLayoutDims(verticalBoxes.concat(horizontalBoxes), params);

      // First fit vertical boxes
      fitBoxes(verticalBoxes, chartArea, params);

      // Then fit horizontal boxes
      if (fitBoxes(horizontalBoxes, chartArea, params)) {
        // if the area changed, re-fit vertical boxes
        fitBoxes(verticalBoxes, chartArea, params);
      }
      handleMaxPadding(chartArea);

      // Finally place the boxes to correct coordinates
      placeBoxes(boxes.leftAndTop, chartArea, params);

      // Move to opposite side of chart
      chartArea.x += chartArea.w;
      chartArea.y += chartArea.h;
      placeBoxes(boxes.rightAndBottom, chartArea, params);
      chart.chartArea = {
        left: chartArea.left,
        top: chartArea.top,
        right: chartArea.left + chartArea.w,
        bottom: chartArea.top + chartArea.h
      };

      // Finally update boxes in chartArea (radial scale for example)
      helpers$1.each(boxes.chartArea, function (layout) {
        var box = layout.box;
        extend(box, chart.chartArea);
        box.update(chartArea.w, chartArea.h);
      });
    }
  };

  /**
   * Platform fallback implementation (minimal).
   * @see https://github.com/chartjs/Chart.js/pull/4591#issuecomment-319575939
   */

  var platform_basic = {
    acquireContext: function acquireContext(item) {
      if (item && item.canvas) {
        // Support for any object associated to a canvas (including a context2d)
        item = item.canvas;
      }
      return item && item.getContext('2d') || null;
    }
  };
  var platform_dom = "/*\n * DOM element rendering detection\n * https://davidwalsh.name/detect-node-insertion\n */\n@keyframes chartjs-render-animation {\n\tfrom { opacity: 0.99; }\n\tto { opacity: 1; }\n}\n\n.chartjs-render-monitor {\n\tanimation: chartjs-render-animation 0.001s;\n}\n\n/*\n * DOM element resizing detection\n * https://github.com/marcj/css-element-queries\n */\n.chartjs-size-monitor,\n.chartjs-size-monitor-expand,\n.chartjs-size-monitor-shrink {\n\tposition: absolute;\n\tdirection: ltr;\n\tleft: 0;\n\ttop: 0;\n\tright: 0;\n\tbottom: 0;\n\toverflow: hidden;\n\tpointer-events: none;\n\tvisibility: hidden;\n\tz-index: -1;\n}\n\n.chartjs-size-monitor-expand > div {\n\tposition: absolute;\n\twidth: 1000000px;\n\theight: 1000000px;\n\tleft: 0;\n\ttop: 0;\n}\n\n.chartjs-size-monitor-shrink > div {\n\tposition: absolute;\n\twidth: 200%;\n\theight: 200%;\n\tleft: 0;\n\ttop: 0;\n}\n";
  var platform_dom$1 = /*#__PURE__*/Object.freeze({
    __proto__: null,
    'default': platform_dom
  });
  var stylesheet = getCjsExportFromNamespace(platform_dom$1);
  var EXPANDO_KEY = '$chartjs';
  var CSS_PREFIX = 'chartjs-';
  var CSS_SIZE_MONITOR = CSS_PREFIX + 'size-monitor';
  var CSS_RENDER_MONITOR = CSS_PREFIX + 'render-monitor';
  var CSS_RENDER_ANIMATION = CSS_PREFIX + 'render-animation';
  var ANIMATION_START_EVENTS = ['animationstart', 'webkitAnimationStart'];

  /**
   * DOM event types -> Chart.js event types.
   * Note: only events with different types are mapped.
   * @see https://developer.mozilla.org/en-US/docs/Web/Events
   */
  var EVENT_TYPES = {
    touchstart: 'mousedown',
    touchmove: 'mousemove',
    touchend: 'mouseup',
    pointerenter: 'mouseenter',
    pointerdown: 'mousedown',
    pointermove: 'mousemove',
    pointerup: 'mouseup',
    pointerleave: 'mouseout',
    pointerout: 'mouseout'
  };

  /**
   * The "used" size is the final value of a dimension property after all calculations have
   * been performed. This method uses the computed style of `element` but returns undefined
   * if the computed style is not expressed in pixels. That can happen in some cases where
   * `element` has a size relative to its parent and this last one is not yet displayed,
   * for example because of `display: none` on a parent node.
   * @see https://developer.mozilla.org/en-US/docs/Web/CSS/used_value
   * @returns {number} Size in pixels or undefined if unknown.
   */
  function readUsedSize(element, property) {
    var value = helpers$1.getStyle(element, property);
    var matches = value && value.match(/^(\d+)(\.\d+)?px$/);
    return matches ? Number(matches[1]) : undefined;
  }

  /**
   * Initializes the canvas style and render size without modifying the canvas display size,
   * since responsiveness is handled by the controller.resize() method. The config is used
   * to determine the aspect ratio to apply in case no explicit height has been specified.
   */
  function initCanvas(canvas, config) {
    var style = canvas.style;

    // NOTE(SB) canvas.getAttribute('width') !== canvas.width: in the first case it
    // returns null or '' if no explicit value has been set to the canvas attribute.
    var renderHeight = canvas.getAttribute('height');
    var renderWidth = canvas.getAttribute('width');

    // Chart.js modifies some canvas values that we want to restore on destroy
    canvas[EXPANDO_KEY] = {
      initial: {
        height: renderHeight,
        width: renderWidth,
        style: {
          display: style.display,
          height: style.height,
          width: style.width
        }
      }
    };

    // Force canvas to display as block to avoid extra space caused by inline
    // elements, which would interfere with the responsive resize process.
    // https://github.com/chartjs/Chart.js/issues/2538
    style.display = style.display || 'block';
    if (renderWidth === null || renderWidth === '') {
      var displayWidth = readUsedSize(canvas, 'width');
      if (displayWidth !== undefined) {
        canvas.width = displayWidth;
      }
    }
    if (renderHeight === null || renderHeight === '') {
      if (canvas.style.height === '') {
        // If no explicit render height and style height, let's apply the aspect ratio,
        // which one can be specified by the user but also by charts as default option
        // (i.e. options.aspectRatio). If not specified, use canvas aspect ratio of 2.
        canvas.height = canvas.width / (config.options.aspectRatio || 2);
      } else {
        var displayHeight = readUsedSize(canvas, 'height');
        if (displayWidth !== undefined) {
          canvas.height = displayHeight;
        }
      }
    }
    return canvas;
  }

  /**
   * Detects support for options object argument in addEventListener.
   * https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener#Safely_detecting_option_support
   * @private
   */
  var supportsEventListenerOptions = function () {
    var supports = false;
    try {
      var options = Object.defineProperty({}, 'passive', {
        // eslint-disable-next-line getter-return
        get: function get() {
          supports = true;
        }
      });
      window.addEventListener('e', null, options);
    } catch (e) {
      // continue regardless of error
    }
    return supports;
  }();

  // Default passive to true as expected by Chrome for 'touchstart' and 'touchend' events.
  // https://github.com/chartjs/Chart.js/issues/4287
  var eventListenerOptions = supportsEventListenerOptions ? {
    passive: true
  } : false;
  function addListener(node, type, listener) {
    node.addEventListener(type, listener, eventListenerOptions);
  }
  function removeListener(node, type, listener) {
    node.removeEventListener(type, listener, eventListenerOptions);
  }
  function createEvent(type, chart, x, y, nativeEvent) {
    return {
      type: type,
      chart: chart,
      "native": nativeEvent || null,
      x: x !== undefined ? x : null,
      y: y !== undefined ? y : null
    };
  }
  function fromNativeEvent(event, chart) {
    var type = EVENT_TYPES[event.type] || event.type;
    var pos = helpers$1.getRelativePosition(event, chart);
    return createEvent(type, chart, pos.x, pos.y, event);
  }
  function throttled(fn, thisArg) {
    var ticking = false;
    var args = [];
    return function () {
      args = Array.prototype.slice.call(arguments);
      thisArg = thisArg || this;
      if (!ticking) {
        ticking = true;
        helpers$1.requestAnimFrame.call(window, function () {
          ticking = false;
          fn.apply(thisArg, args);
        });
      }
    };
  }
  function createDiv(cls) {
    var el = document.createElement('div');
    el.className = cls || '';
    return el;
  }

  // Implementation based on https://github.com/marcj/css-element-queries
  function createResizer(handler) {
    var maxSize = 1000000;

    // NOTE(SB) Don't use innerHTML because it could be considered unsafe.
    // https://github.com/chartjs/Chart.js/issues/5902
    var resizer = createDiv(CSS_SIZE_MONITOR);
    var expand = createDiv(CSS_SIZE_MONITOR + '-expand');
    var shrink = createDiv(CSS_SIZE_MONITOR + '-shrink');
    expand.appendChild(createDiv());
    shrink.appendChild(createDiv());
    resizer.appendChild(expand);
    resizer.appendChild(shrink);
    resizer._reset = function () {
      expand.scrollLeft = maxSize;
      expand.scrollTop = maxSize;
      shrink.scrollLeft = maxSize;
      shrink.scrollTop = maxSize;
    };
    var onScroll = function onScroll() {
      resizer._reset();
      handler();
    };
    addListener(expand, 'scroll', onScroll.bind(expand, 'expand'));
    addListener(shrink, 'scroll', onScroll.bind(shrink, 'shrink'));
    return resizer;
  }

  // https://davidwalsh.name/detect-node-insertion
  function watchForRender(node, handler) {
    var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});
    var proxy = expando.renderProxy = function (e) {
      if (e.animationName === CSS_RENDER_ANIMATION) {
        handler();
      }
    };
    helpers$1.each(ANIMATION_START_EVENTS, function (type) {
      addListener(node, type, proxy);
    });

    // #4737: Chrome might skip the CSS animation when the CSS_RENDER_MONITOR class
    // is removed then added back immediately (same animation frame?). Accessing the
    // `offsetParent` property will force a reflow and re-evaluate the CSS animation.
    // https://gist.github.com/paulirish/5d52fb081b3570c81e3a#box-metrics
    // https://github.com/chartjs/Chart.js/issues/4737
    expando.reflow = !!node.offsetParent;
    node.classList.add(CSS_RENDER_MONITOR);
  }
  function unwatchForRender(node) {
    var expando = node[EXPANDO_KEY] || {};
    var proxy = expando.renderProxy;
    if (proxy) {
      helpers$1.each(ANIMATION_START_EVENTS, function (type) {
        removeListener(node, type, proxy);
      });
      delete expando.renderProxy;
    }
    node.classList.remove(CSS_RENDER_MONITOR);
  }
  function addResizeListener(node, listener, chart) {
    var expando = node[EXPANDO_KEY] || (node[EXPANDO_KEY] = {});

    // Let's keep track of this added resizer and thus avoid DOM query when removing it.
    var resizer = expando.resizer = createResizer(throttled(function () {
      if (expando.resizer) {
        var container = chart.options.maintainAspectRatio && node.parentNode;
        var w = container ? container.clientWidth : 0;
        listener(createEvent('resize', chart));
        if (container && container.clientWidth < w && chart.canvas) {
          // If the container size shrank during chart resize, let's assume
          // scrollbar appeared. So we resize again with the scrollbar visible -
          // effectively making chart smaller and the scrollbar hidden again.
          // Because we are inside `throttled`, and currently `ticking`, scroll
          // events are ignored during this whole 2 resize process.
          // If we assumed wrong and something else happened, we are resizing
          // twice in a frame (potential performance issue)
          listener(createEvent('resize', chart));
        }
      }
    }));

    // The resizer needs to be attached to the node parent, so we first need to be
    // sure that `node` is attached to the DOM before injecting the resizer element.
    watchForRender(node, function () {
      if (expando.resizer) {
        var container = node.parentNode;
        if (container && container !== resizer.parentNode) {
          container.insertBefore(resizer, container.firstChild);
        }

        // The container size might have changed, let's reset the resizer state.
        resizer._reset();
      }
    });
  }
  function removeResizeListener(node) {
    var expando = node[EXPANDO_KEY] || {};
    var resizer = expando.resizer;
    delete expando.resizer;
    unwatchForRender(node);
    if (resizer && resizer.parentNode) {
      resizer.parentNode.removeChild(resizer);
    }
  }

  /**
   * Injects CSS styles inline if the styles are not already present.
   * @param {HTMLDocument|ShadowRoot} rootNode - the node to contain the <style>.
   * @param {string} css - the CSS to be injected.
   */
  function injectCSS(rootNode, css) {
    // https://stackoverflow.com/q/3922139
    var expando = rootNode[EXPANDO_KEY] || (rootNode[EXPANDO_KEY] = {});
    if (!expando.containsStyles) {
      expando.containsStyles = true;
      css = '/* Chart.js */\n' + css;
      var style = document.createElement('style');
      style.setAttribute('type', 'text/css');
      style.appendChild(document.createTextNode(css));
      rootNode.appendChild(style);
    }
  }
  var platform_dom$2 = {
    /**
     * When `true`, prevents the automatic injection of the stylesheet required to
     * correctly detect when the chart is added to the DOM and then resized. This
     * switch has been added to allow external stylesheet (`dist/Chart(.min)?.js`)
     * to be manually imported to make this library compatible with any CSP.
     * See https://github.com/chartjs/Chart.js/issues/5208
     */
    disableCSSInjection: false,
    /**
     * This property holds whether this platform is enabled for the current environment.
     * Currently used by platform.js to select the proper implementation.
     * @private
     */
    _enabled: typeof window !== 'undefined' && typeof document !== 'undefined',
    /**
     * Initializes resources that depend on platform options.
     * @param {HTMLCanvasElement} canvas - The Canvas element.
     * @private
     */
    _ensureLoaded: function _ensureLoaded(canvas) {
      if (!this.disableCSSInjection) {
        // If the canvas is in a shadow DOM, then the styles must also be inserted
        // into the same shadow DOM.
        // https://github.com/chartjs/Chart.js/issues/5763
        var root = canvas.getRootNode ? canvas.getRootNode() : document;
        var targetNode = root.host ? root : document.head;
        injectCSS(targetNode, stylesheet);
      }
    },
    acquireContext: function acquireContext(item, config) {
      if (typeof item === 'string') {
        item = document.getElementById(item);
      } else if (item.length) {
        // Support for array based queries (such as jQuery)
        item = item[0];
      }
      if (item && item.canvas) {
        // Support for any object associated to a canvas (including a context2d)
        item = item.canvas;
      }

      // To prevent canvas fingerprinting, some add-ons undefine the getContext
      // method, for example: https://github.com/kkapsner/CanvasBlocker
      // https://github.com/chartjs/Chart.js/issues/2807
      var context = item && item.getContext && item.getContext('2d');

      // `instanceof HTMLCanvasElement/CanvasRenderingContext2D` fails when the item is
      // inside an iframe or when running in a protected environment. We could guess the
      // types from their toString() value but let's keep things flexible and assume it's
      // a sufficient condition if the item has a context2D which has item as `canvas`.
      // https://github.com/chartjs/Chart.js/issues/3887
      // https://github.com/chartjs/Chart.js/issues/4102
      // https://github.com/chartjs/Chart.js/issues/4152
      if (context && context.canvas === item) {
        // Load platform resources on first chart creation, to make it possible to
        // import the library before setting platform options.
        this._ensureLoaded(item);
        initCanvas(item, config);
        return context;
      }
      return null;
    },
    releaseContext: function releaseContext(context) {
      var canvas = context.canvas;
      if (!canvas[EXPANDO_KEY]) {
        return;
      }
      var initial = canvas[EXPANDO_KEY].initial;
      ['height', 'width'].forEach(function (prop) {
        var value = initial[prop];
        if (helpers$1.isNullOrUndef(value)) {
          canvas.removeAttribute(prop);
        } else {
          canvas.setAttribute(prop, value);
        }
      });
      helpers$1.each(initial.style || {}, function (value, key) {
        canvas.style[key] = value;
      });

      // The canvas render size might have been changed (and thus the state stack discarded),
      // we can't use save() and restore() to restore the initial state. So make sure that at
      // least the canvas context is reset to the default state by setting the canvas width.
      // https://www.w3.org/TR/2011/WD-html5-20110525/the-canvas-element.html
      // eslint-disable-next-line no-self-assign
      canvas.width = canvas.width;
      delete canvas[EXPANDO_KEY];
    },
    addEventListener: function addEventListener(chart, type, listener) {
      var canvas = chart.canvas;
      if (type === 'resize') {
        // Note: the resize event is not supported on all browsers.
        addResizeListener(canvas, listener, chart);
        return;
      }
      var expando = listener[EXPANDO_KEY] || (listener[EXPANDO_KEY] = {});
      var proxies = expando.proxies || (expando.proxies = {});
      var proxy = proxies[chart.id + '_' + type] = function (event) {
        listener(fromNativeEvent(event, chart));
      };
      addListener(canvas, type, proxy);
    },
    removeEventListener: function removeEventListener(chart, type, listener) {
      var canvas = chart.canvas;
      if (type === 'resize') {
        // Note: the resize event is not supported on all browsers.
        removeResizeListener(canvas);
        return;
      }
      var expando = listener[EXPANDO_KEY] || {};
      var proxies = expando.proxies || {};
      var proxy = proxies[chart.id + '_' + type];
      if (!proxy) {
        return;
      }
      removeListener(canvas, type, proxy);
    }
  };

  // DEPRECATIONS

  /**
   * Provided for backward compatibility, use EventTarget.addEventListener instead.
   * EventTarget.addEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
   * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/addEventListener
   * @function Chart.helpers.addEvent
   * @deprecated since version 2.7.0
   * @todo remove at version 3
   * @private
   */
  helpers$1.addEvent = addListener;

  /**
   * Provided for backward compatibility, use EventTarget.removeEventListener instead.
   * EventTarget.removeEventListener compatibility: Chrome, Opera 7, Safari, FF1.5+, IE9+
   * @see https://developer.mozilla.org/en-US/docs/Web/API/EventTarget/removeEventListener
   * @function Chart.helpers.removeEvent
   * @deprecated since version 2.7.0
   * @todo remove at version 3
   * @private
   */
  helpers$1.removeEvent = removeListener;

  // @TODO Make possible to select another platform at build time.
  var implementation = platform_dom$2._enabled ? platform_dom$2 : platform_basic;

  /**
   * @namespace Chart.platform
   * @see https://chartjs.gitbooks.io/proposals/content/Platform.html
   * @since 2.4.0
   */
  var platform = helpers$1.extend({
    /**
     * @since 2.7.0
     */
    initialize: function initialize() {},
    /**
     * Called at chart construction time, returns a context2d instance implementing
     * the [W3C Canvas 2D Context API standard]{@link https://www.w3.org/TR/2dcontext/}.
     * @param {*} item - The native item from which to acquire context (platform specific)
     * @param {object} options - The chart options
     * @returns {CanvasRenderingContext2D} context2d instance
     */
    acquireContext: function acquireContext() {},
    /**
     * Called at chart destruction time, releases any resources associated to the context
     * previously returned by the acquireContext() method.
     * @param {CanvasRenderingContext2D} context - The context2d instance
     * @returns {boolean} true if the method succeeded, else false
     */
    releaseContext: function releaseContext() {},
    /**
     * Registers the specified listener on the given chart.
     * @param {Chart} chart - Chart from which to listen for event
     * @param {string} type - The ({@link IEvent}) type to listen for
     * @param {function} listener - Receives a notification (an object that implements
     * the {@link IEvent} interface) when an event of the specified type occurs.
     */
    addEventListener: function addEventListener() {},
    /**
     * Removes the specified listener previously registered with addEventListener.
     * @param {Chart} chart - Chart from which to remove the listener
     * @param {string} type - The ({@link IEvent}) type to remove
     * @param {function} listener - The listener function to remove from the event target.
     */
    removeEventListener: function removeEventListener() {}
  }, implementation);
  core_defaults._set('global', {
    plugins: {}
  });

  /**
   * The plugin service singleton
   * @namespace Chart.plugins
   * @since 2.1.0
   */
  var core_plugins = {
    /**
     * Globally registered plugins.
     * @private
     */
    _plugins: [],
    /**
     * This identifier is used to invalidate the descriptors cache attached to each chart
     * when a global plugin is registered or unregistered. In this case, the cache ID is
     * incremented and descriptors are regenerated during following API calls.
     * @private
     */
    _cacheId: 0,
    /**
     * Registers the given plugin(s) if not already registered.
     * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
     */
    register: function register(plugins) {
      var p = this._plugins;
      [].concat(plugins).forEach(function (plugin) {
        if (p.indexOf(plugin) === -1) {
          p.push(plugin);
        }
      });
      this._cacheId++;
    },
    /**
     * Unregisters the given plugin(s) only if registered.
     * @param {IPlugin[]|IPlugin} plugins plugin instance(s).
     */
    unregister: function unregister(plugins) {
      var p = this._plugins;
      [].concat(plugins).forEach(function (plugin) {
        var idx = p.indexOf(plugin);
        if (idx !== -1) {
          p.splice(idx, 1);
        }
      });
      this._cacheId++;
    },
    /**
     * Remove all registered plugins.
     * @since 2.1.5
     */
    clear: function clear() {
      this._plugins = [];
      this._cacheId++;
    },
    /**
     * Returns the number of registered plugins?
     * @returns {number}
     * @since 2.1.5
     */
    count: function count() {
      return this._plugins.length;
    },
    /**
     * Returns all registered plugin instances.
     * @returns {IPlugin[]} array of plugin objects.
     * @since 2.1.5
     */
    getAll: function getAll() {
      return this._plugins;
    },
    /**
     * Calls enabled plugins for `chart` on the specified hook and with the given args.
     * This method immediately returns as soon as a plugin explicitly returns false. The
     * returned value can be used, for instance, to interrupt the current action.
     * @param {Chart} chart - The chart instance for which plugins should be called.
     * @param {string} hook - The name of the plugin method to call (e.g. 'beforeUpdate').
     * @param {Array} [args] - Extra arguments to apply to the hook call.
     * @returns {boolean} false if any of the plugins return false, else returns true.
     */
    notify: function notify(chart, hook, args) {
      var descriptors = this.descriptors(chart);
      var ilen = descriptors.length;
      var i, descriptor, plugin, params, method;
      for (i = 0; i < ilen; ++i) {
        descriptor = descriptors[i];
        plugin = descriptor.plugin;
        method = plugin[hook];
        if (typeof method === 'function') {
          params = [chart].concat(args || []);
          params.push(descriptor.options);
          if (method.apply(plugin, params) === false) {
            return false;
          }
        }
      }
      return true;
    },
    /**
     * Returns descriptors of enabled plugins for the given chart.
     * @returns {object[]} [{ plugin, options }]
     * @private
     */
    descriptors: function descriptors(chart) {
      var cache = chart.$plugins || (chart.$plugins = {});
      if (cache.id === this._cacheId) {
        return cache.descriptors;
      }
      var plugins = [];
      var descriptors = [];
      var config = chart && chart.config || {};
      var options = config.options && config.options.plugins || {};
      this._plugins.concat(config.plugins || []).forEach(function (plugin) {
        var idx = plugins.indexOf(plugin);
        if (idx !== -1) {
          return;
        }
        var id = plugin.id;
        var opts = options[id];
        if (opts === false) {
          return;
        }
        if (opts === true) {
          opts = helpers$1.clone(core_defaults.global.plugins[id]);
        }
        plugins.push(plugin);
        descriptors.push({
          plugin: plugin,
          options: opts || {}
        });
      });
      cache.descriptors = descriptors;
      cache.id = this._cacheId;
      return descriptors;
    },
    /**
     * Invalidates cache for the given chart: descriptors hold a reference on plugin option,
     * but in some cases, this reference can be changed by the user when updating options.
     * https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
     * @private
     */
    _invalidate: function _invalidate(chart) {
      delete chart.$plugins;
    }
  };
  var core_scaleService = {
    // Scale registration object. Extensions can register new scale types (such as log or DB scales) and then
    // use the new chart options to grab the correct scale
    constructors: {},
    // Use a registration function so that we can move to an ES6 map when we no longer need to support
    // old browsers

    // Scale config defaults
    defaults: {},
    registerScaleType: function registerScaleType(type, scaleConstructor, scaleDefaults) {
      this.constructors[type] = scaleConstructor;
      this.defaults[type] = helpers$1.clone(scaleDefaults);
    },
    getScaleConstructor: function getScaleConstructor(type) {
      return this.constructors.hasOwnProperty(type) ? this.constructors[type] : undefined;
    },
    getScaleDefaults: function getScaleDefaults(type) {
      // Return the scale defaults merged with the global settings so that we always use the latest ones
      return this.defaults.hasOwnProperty(type) ? helpers$1.merge(Object.create(null), [core_defaults.scale, this.defaults[type]]) : {};
    },
    updateScaleDefaults: function updateScaleDefaults(type, additions) {
      var me = this;
      if (me.defaults.hasOwnProperty(type)) {
        me.defaults[type] = helpers$1.extend(me.defaults[type], additions);
      }
    },
    addScalesToLayout: function addScalesToLayout(chart) {
      // Adds each scale to the chart.boxes array to be sized accordingly
      helpers$1.each(chart.scales, function (scale) {
        // Set ILayoutItem parameters for backwards compatibility
        scale.fullWidth = scale.options.fullWidth;
        scale.position = scale.options.position;
        scale.weight = scale.options.weight;
        core_layouts.addBox(chart, scale);
      });
    }
  };
  var valueOrDefault$8 = helpers$1.valueOrDefault;
  var getRtlHelper = helpers$1.rtl.getRtlAdapter;
  core_defaults._set('global', {
    tooltips: {
      enabled: true,
      custom: null,
      mode: 'nearest',
      position: 'average',
      intersect: true,
      backgroundColor: 'rgba(0,0,0,0.8)',
      titleFontStyle: 'bold',
      titleSpacing: 2,
      titleMarginBottom: 6,
      titleFontColor: '#fff',
      titleAlign: 'left',
      bodySpacing: 2,
      bodyFontColor: '#fff',
      bodyAlign: 'left',
      footerFontStyle: 'bold',
      footerSpacing: 2,
      footerMarginTop: 6,
      footerFontColor: '#fff',
      footerAlign: 'left',
      yPadding: 6,
      xPadding: 6,
      caretPadding: 2,
      caretSize: 5,
      cornerRadius: 6,
      multiKeyBackground: '#fff',
      displayColors: true,
      borderColor: 'rgba(0,0,0,0)',
      borderWidth: 0,
      callbacks: {
        // Args are: (tooltipItems, data)
        beforeTitle: helpers$1.noop,
        title: function title(tooltipItems, data) {
          var title = '';
          var labels = data.labels;
          var labelCount = labels ? labels.length : 0;
          if (tooltipItems.length > 0) {
            var item = tooltipItems[0];
            if (item.label) {
              title = item.label;
            } else if (item.xLabel) {
              title = item.xLabel;
            } else if (labelCount > 0 && item.index < labelCount) {
              title = labels[item.index];
            }
          }
          return title;
        },
        afterTitle: helpers$1.noop,
        // Args are: (tooltipItems, data)
        beforeBody: helpers$1.noop,
        // Args are: (tooltipItem, data)
        beforeLabel: helpers$1.noop,
        label: function label(tooltipItem, data) {
          var label = data.datasets[tooltipItem.datasetIndex].label || '';
          if (label) {
            label += ': ';
          }
          if (!helpers$1.isNullOrUndef(tooltipItem.value)) {
            label += tooltipItem.value;
          } else {
            label += tooltipItem.yLabel;
          }
          return label;
        },
        labelColor: function labelColor(tooltipItem, chart) {
          var meta = chart.getDatasetMeta(tooltipItem.datasetIndex);
          var activeElement = meta.data[tooltipItem.index];
          var view = activeElement._view;
          return {
            borderColor: view.borderColor,
            backgroundColor: view.backgroundColor
          };
        },
        labelTextColor: function labelTextColor() {
          return this._options.bodyFontColor;
        },
        afterLabel: helpers$1.noop,
        // Args are: (tooltipItems, data)
        afterBody: helpers$1.noop,
        // Args are: (tooltipItems, data)
        beforeFooter: helpers$1.noop,
        footer: helpers$1.noop,
        afterFooter: helpers$1.noop
      }
    }
  });
  var positioners = {
    /**
     * Average mode places the tooltip at the average position of the elements shown
     * @function Chart.Tooltip.positioners.average
     * @param elements {ChartElement[]} the elements being displayed in the tooltip
     * @returns {object} tooltip position
     */
    average: function average(elements) {
      if (!elements.length) {
        return false;
      }
      var i, len;
      var x = 0;
      var y = 0;
      var count = 0;
      for (i = 0, len = elements.length; i < len; ++i) {
        var el = elements[i];
        if (el && el.hasValue()) {
          var pos = el.tooltipPosition();
          x += pos.x;
          y += pos.y;
          ++count;
        }
      }
      return {
        x: x / count,
        y: y / count
      };
    },
    /**
     * Gets the tooltip position nearest of the item nearest to the event position
     * @function Chart.Tooltip.positioners.nearest
     * @param elements {Chart.Element[]} the tooltip elements
     * @param eventPosition {object} the position of the event in canvas coordinates
     * @returns {object} the tooltip position
     */
    nearest: function nearest(elements, eventPosition) {
      var x = eventPosition.x;
      var y = eventPosition.y;
      var minDistance = Number.POSITIVE_INFINITY;
      var i, len, nearestElement;
      for (i = 0, len = elements.length; i < len; ++i) {
        var el = elements[i];
        if (el && el.hasValue()) {
          var center = el.getCenterPoint();
          var d = helpers$1.distanceBetweenPoints(eventPosition, center);
          if (d < minDistance) {
            minDistance = d;
            nearestElement = el;
          }
        }
      }
      if (nearestElement) {
        var tp = nearestElement.tooltipPosition();
        x = tp.x;
        y = tp.y;
      }
      return {
        x: x,
        y: y
      };
    }
  };

  // Helper to push or concat based on if the 2nd parameter is an array or not
  function pushOrConcat(base, toPush) {
    if (toPush) {
      if (helpers$1.isArray(toPush)) {
        // base = base.concat(toPush);
        Array.prototype.push.apply(base, toPush);
      } else {
        base.push(toPush);
      }
    }
    return base;
  }

  /**
   * Returns array of strings split by newline
   * @param {string} value - The value to split by newline.
   * @returns {string[]} value if newline present - Returned from String split() method
   * @function
   */
  function splitNewlines(str) {
    if ((typeof str === 'string' || str instanceof String) && str.indexOf('\n') > -1) {
      return str.split('\n');
    }
    return str;
  }

  /**
   * Private helper to create a tooltip item model
   * @param element - the chart element (point, arc, bar) to create the tooltip item for
   * @return new tooltip item
   */
  function createTooltipItem(element) {
    var xScale = element._xScale;
    var yScale = element._yScale || element._scale; // handle radar || polarArea charts
    var index = element._index;
    var datasetIndex = element._datasetIndex;
    var controller = element._chart.getDatasetMeta(datasetIndex).controller;
    var indexScale = controller._getIndexScale();
    var valueScale = controller._getValueScale();
    return {
      xLabel: xScale ? xScale.getLabelForIndex(index, datasetIndex) : '',
      yLabel: yScale ? yScale.getLabelForIndex(index, datasetIndex) : '',
      label: indexScale ? '' + indexScale.getLabelForIndex(index, datasetIndex) : '',
      value: valueScale ? '' + valueScale.getLabelForIndex(index, datasetIndex) : '',
      index: index,
      datasetIndex: datasetIndex,
      x: element._model.x,
      y: element._model.y
    };
  }

  /**
   * Helper to get the reset model for the tooltip
   * @param tooltipOpts {object} the tooltip options
   */
  function getBaseModel(tooltipOpts) {
    var globalDefaults = core_defaults.global;
    return {
      // Positioning
      xPadding: tooltipOpts.xPadding,
      yPadding: tooltipOpts.yPadding,
      xAlign: tooltipOpts.xAlign,
      yAlign: tooltipOpts.yAlign,
      // Drawing direction and text direction
      rtl: tooltipOpts.rtl,
      textDirection: tooltipOpts.textDirection,
      // Body
      bodyFontColor: tooltipOpts.bodyFontColor,
      _bodyFontFamily: valueOrDefault$8(tooltipOpts.bodyFontFamily, globalDefaults.defaultFontFamily),
      _bodyFontStyle: valueOrDefault$8(tooltipOpts.bodyFontStyle, globalDefaults.defaultFontStyle),
      _bodyAlign: tooltipOpts.bodyAlign,
      bodyFontSize: valueOrDefault$8(tooltipOpts.bodyFontSize, globalDefaults.defaultFontSize),
      bodySpacing: tooltipOpts.bodySpacing,
      // Title
      titleFontColor: tooltipOpts.titleFontColor,
      _titleFontFamily: valueOrDefault$8(tooltipOpts.titleFontFamily, globalDefaults.defaultFontFamily),
      _titleFontStyle: valueOrDefault$8(tooltipOpts.titleFontStyle, globalDefaults.defaultFontStyle),
      titleFontSize: valueOrDefault$8(tooltipOpts.titleFontSize, globalDefaults.defaultFontSize),
      _titleAlign: tooltipOpts.titleAlign,
      titleSpacing: tooltipOpts.titleSpacing,
      titleMarginBottom: tooltipOpts.titleMarginBottom,
      // Footer
      footerFontColor: tooltipOpts.footerFontColor,
      _footerFontFamily: valueOrDefault$8(tooltipOpts.footerFontFamily, globalDefaults.defaultFontFamily),
      _footerFontStyle: valueOrDefault$8(tooltipOpts.footerFontStyle, globalDefaults.defaultFontStyle),
      footerFontSize: valueOrDefault$8(tooltipOpts.footerFontSize, globalDefaults.defaultFontSize),
      _footerAlign: tooltipOpts.footerAlign,
      footerSpacing: tooltipOpts.footerSpacing,
      footerMarginTop: tooltipOpts.footerMarginTop,
      // Appearance
      caretSize: tooltipOpts.caretSize,
      cornerRadius: tooltipOpts.cornerRadius,
      backgroundColor: tooltipOpts.backgroundColor,
      opacity: 0,
      legendColorBackground: tooltipOpts.multiKeyBackground,
      displayColors: tooltipOpts.displayColors,
      borderColor: tooltipOpts.borderColor,
      borderWidth: tooltipOpts.borderWidth
    };
  }

  /**
   * Get the size of the tooltip
   */
  function getTooltipSize(tooltip, model) {
    var ctx = tooltip._chart.ctx;
    var height = model.yPadding * 2; // Tooltip Padding
    var width = 0;

    // Count of all lines in the body
    var body = model.body;
    var combinedBodyLength = body.reduce(function (count, bodyItem) {
      return count + bodyItem.before.length + bodyItem.lines.length + bodyItem.after.length;
    }, 0);
    combinedBodyLength += model.beforeBody.length + model.afterBody.length;
    var titleLineCount = model.title.length;
    var footerLineCount = model.footer.length;
    var titleFontSize = model.titleFontSize;
    var bodyFontSize = model.bodyFontSize;
    var footerFontSize = model.footerFontSize;
    height += titleLineCount * titleFontSize; // Title Lines
    height += titleLineCount ? (titleLineCount - 1) * model.titleSpacing : 0; // Title Line Spacing
    height += titleLineCount ? model.titleMarginBottom : 0; // Title's bottom Margin
    height += combinedBodyLength * bodyFontSize; // Body Lines
    height += combinedBodyLength ? (combinedBodyLength - 1) * model.bodySpacing : 0; // Body Line Spacing
    height += footerLineCount ? model.footerMarginTop : 0; // Footer Margin
    height += footerLineCount * footerFontSize; // Footer Lines
    height += footerLineCount ? (footerLineCount - 1) * model.footerSpacing : 0; // Footer Line Spacing

    // Title width
    var widthPadding = 0;
    var maxLineWidth = function maxLineWidth(line) {
      width = Math.max(width, ctx.measureText(line).width + widthPadding);
    };
    ctx.font = helpers$1.fontString(titleFontSize, model._titleFontStyle, model._titleFontFamily);
    helpers$1.each(model.title, maxLineWidth);

    // Body width
    ctx.font = helpers$1.fontString(bodyFontSize, model._bodyFontStyle, model._bodyFontFamily);
    helpers$1.each(model.beforeBody.concat(model.afterBody), maxLineWidth);

    // Body lines may include some extra width due to the color box
    widthPadding = model.displayColors ? bodyFontSize + 2 : 0;
    helpers$1.each(body, function (bodyItem) {
      helpers$1.each(bodyItem.before, maxLineWidth);
      helpers$1.each(bodyItem.lines, maxLineWidth);
      helpers$1.each(bodyItem.after, maxLineWidth);
    });

    // Reset back to 0
    widthPadding = 0;

    // Footer width
    ctx.font = helpers$1.fontString(footerFontSize, model._footerFontStyle, model._footerFontFamily);
    helpers$1.each(model.footer, maxLineWidth);

    // Add padding
    width += 2 * model.xPadding;
    return {
      width: width,
      height: height
    };
  }

  /**
   * Helper to get the alignment of a tooltip given the size
   */
  function determineAlignment(tooltip, size) {
    var model = tooltip._model;
    var chart = tooltip._chart;
    var chartArea = tooltip._chart.chartArea;
    var xAlign = 'center';
    var yAlign = 'center';
    if (model.y < size.height) {
      yAlign = 'top';
    } else if (model.y > chart.height - size.height) {
      yAlign = 'bottom';
    }
    var lf, rf; // functions to determine left, right alignment
    var olf, orf; // functions to determine if left/right alignment causes tooltip to go outside chart
    var yf; // function to get the y alignment if the tooltip goes outside of the left or right edges
    var midX = (chartArea.left + chartArea.right) / 2;
    var midY = (chartArea.top + chartArea.bottom) / 2;
    if (yAlign === 'center') {
      lf = function lf(x) {
        return x <= midX;
      };
      rf = function rf(x) {
        return x > midX;
      };
    } else {
      lf = function lf(x) {
        return x <= size.width / 2;
      };
      rf = function rf(x) {
        return x >= chart.width - size.width / 2;
      };
    }
    olf = function olf(x) {
      return x + size.width + model.caretSize + model.caretPadding > chart.width;
    };
    orf = function orf(x) {
      return x - size.width - model.caretSize - model.caretPadding < 0;
    };
    yf = function yf(y) {
      return y <= midY ? 'top' : 'bottom';
    };
    if (lf(model.x)) {
      xAlign = 'left';

      // Is tooltip too wide and goes over the right side of the chart.?
      if (olf(model.x)) {
        xAlign = 'center';
        yAlign = yf(model.y);
      }
    } else if (rf(model.x)) {
      xAlign = 'right';

      // Is tooltip too wide and goes outside left edge of canvas?
      if (orf(model.x)) {
        xAlign = 'center';
        yAlign = yf(model.y);
      }
    }
    var opts = tooltip._options;
    return {
      xAlign: opts.xAlign ? opts.xAlign : xAlign,
      yAlign: opts.yAlign ? opts.yAlign : yAlign
    };
  }

  /**
   * Helper to get the location a tooltip needs to be placed at given the initial position (via the vm) and the size and alignment
   */
  function getBackgroundPoint(vm, size, alignment, chart) {
    // Background Position
    var x = vm.x;
    var y = vm.y;
    var caretSize = vm.caretSize;
    var caretPadding = vm.caretPadding;
    var cornerRadius = vm.cornerRadius;
    var xAlign = alignment.xAlign;
    var yAlign = alignment.yAlign;
    var paddingAndSize = caretSize + caretPadding;
    var radiusAndPadding = cornerRadius + caretPadding;
    if (xAlign === 'right') {
      x -= size.width;
    } else if (xAlign === 'center') {
      x -= size.width / 2;
      if (x + size.width > chart.width) {
        x = chart.width - size.width;
      }
      if (x < 0) {
        x = 0;
      }
    }
    if (yAlign === 'top') {
      y += paddingAndSize;
    } else if (yAlign === 'bottom') {
      y -= size.height + paddingAndSize;
    } else {
      y -= size.height / 2;
    }
    if (yAlign === 'center') {
      if (xAlign === 'left') {
        x += paddingAndSize;
      } else if (xAlign === 'right') {
        x -= paddingAndSize;
      }
    } else if (xAlign === 'left') {
      x -= radiusAndPadding;
    } else if (xAlign === 'right') {
      x += radiusAndPadding;
    }
    return {
      x: x,
      y: y
    };
  }
  function getAlignedX(vm, align) {
    return align === 'center' ? vm.x + vm.width / 2 : align === 'right' ? vm.x + vm.width - vm.xPadding : vm.x + vm.xPadding;
  }

  /**
   * Helper to build before and after body lines
   */
  function getBeforeAfterBodyLines(callback) {
    return pushOrConcat([], splitNewlines(callback));
  }
  var exports$4 = core_element.extend({
    initialize: function initialize() {
      this._model = getBaseModel(this._options);
      this._lastActive = [];
    },
    // Get the title
    // Args are: (tooltipItem, data)
    getTitle: function getTitle() {
      var me = this;
      var opts = me._options;
      var callbacks = opts.callbacks;
      var beforeTitle = callbacks.beforeTitle.apply(me, arguments);
      var title = callbacks.title.apply(me, arguments);
      var afterTitle = callbacks.afterTitle.apply(me, arguments);
      var lines = [];
      lines = pushOrConcat(lines, splitNewlines(beforeTitle));
      lines = pushOrConcat(lines, splitNewlines(title));
      lines = pushOrConcat(lines, splitNewlines(afterTitle));
      return lines;
    },
    // Args are: (tooltipItem, data)
    getBeforeBody: function getBeforeBody() {
      return getBeforeAfterBodyLines(this._options.callbacks.beforeBody.apply(this, arguments));
    },
    // Args are: (tooltipItem, data)
    getBody: function getBody(tooltipItems, data) {
      var me = this;
      var callbacks = me._options.callbacks;
      var bodyItems = [];
      helpers$1.each(tooltipItems, function (tooltipItem) {
        var bodyItem = {
          before: [],
          lines: [],
          after: []
        };
        pushOrConcat(bodyItem.before, splitNewlines(callbacks.beforeLabel.call(me, tooltipItem, data)));
        pushOrConcat(bodyItem.lines, callbacks.label.call(me, tooltipItem, data));
        pushOrConcat(bodyItem.after, splitNewlines(callbacks.afterLabel.call(me, tooltipItem, data)));
        bodyItems.push(bodyItem);
      });
      return bodyItems;
    },
    // Args are: (tooltipItem, data)
    getAfterBody: function getAfterBody() {
      return getBeforeAfterBodyLines(this._options.callbacks.afterBody.apply(this, arguments));
    },
    // Get the footer and beforeFooter and afterFooter lines
    // Args are: (tooltipItem, data)
    getFooter: function getFooter() {
      var me = this;
      var callbacks = me._options.callbacks;
      var beforeFooter = callbacks.beforeFooter.apply(me, arguments);
      var footer = callbacks.footer.apply(me, arguments);
      var afterFooter = callbacks.afterFooter.apply(me, arguments);
      var lines = [];
      lines = pushOrConcat(lines, splitNewlines(beforeFooter));
      lines = pushOrConcat(lines, splitNewlines(footer));
      lines = pushOrConcat(lines, splitNewlines(afterFooter));
      return lines;
    },
    update: function update(changed) {
      var me = this;
      var opts = me._options;

      // Need to regenerate the model because its faster than using extend and it is necessary due to the optimization in Chart.Element.transition
      // that does _view = _model if ease === 1. This causes the 2nd tooltip update to set properties in both the view and model at the same time
      // which breaks any animations.
      var existingModel = me._model;
      var model = me._model = getBaseModel(opts);
      var active = me._active;
      var data = me._data;

      // In the case where active.length === 0 we need to keep these at existing values for good animations
      var alignment = {
        xAlign: existingModel.xAlign,
        yAlign: existingModel.yAlign
      };
      var backgroundPoint = {
        x: existingModel.x,
        y: existingModel.y
      };
      var tooltipSize = {
        width: existingModel.width,
        height: existingModel.height
      };
      var tooltipPosition = {
        x: existingModel.caretX,
        y: existingModel.caretY
      };
      var i, len;
      if (active.length) {
        model.opacity = 1;
        var labelColors = [];
        var labelTextColors = [];
        tooltipPosition = positioners[opts.position].call(me, active, me._eventPosition);
        var tooltipItems = [];
        for (i = 0, len = active.length; i < len; ++i) {
          tooltipItems.push(createTooltipItem(active[i]));
        }

        // If the user provided a filter function, use it to modify the tooltip items
        if (opts.filter) {
          tooltipItems = tooltipItems.filter(function (a) {
            return opts.filter(a, data);
          });
        }

        // If the user provided a sorting function, use it to modify the tooltip items
        if (opts.itemSort) {
          tooltipItems = tooltipItems.sort(function (a, b) {
            return opts.itemSort(a, b, data);
          });
        }

        // Determine colors for boxes
        helpers$1.each(tooltipItems, function (tooltipItem) {
          labelColors.push(opts.callbacks.labelColor.call(me, tooltipItem, me._chart));
          labelTextColors.push(opts.callbacks.labelTextColor.call(me, tooltipItem, me._chart));
        });

        // Build the Text Lines
        model.title = me.getTitle(tooltipItems, data);
        model.beforeBody = me.getBeforeBody(tooltipItems, data);
        model.body = me.getBody(tooltipItems, data);
        model.afterBody = me.getAfterBody(tooltipItems, data);
        model.footer = me.getFooter(tooltipItems, data);

        // Initial positioning and colors
        model.x = tooltipPosition.x;
        model.y = tooltipPosition.y;
        model.caretPadding = opts.caretPadding;
        model.labelColors = labelColors;
        model.labelTextColors = labelTextColors;

        // data points
        model.dataPoints = tooltipItems;

        // We need to determine alignment of the tooltip
        tooltipSize = getTooltipSize(this, model);
        alignment = determineAlignment(this, tooltipSize);
        // Final Size and Position
        backgroundPoint = getBackgroundPoint(model, tooltipSize, alignment, me._chart);
      } else {
        model.opacity = 0;
      }
      model.xAlign = alignment.xAlign;
      model.yAlign = alignment.yAlign;
      model.x = backgroundPoint.x;
      model.y = backgroundPoint.y;
      model.width = tooltipSize.width;
      model.height = tooltipSize.height;

      // Point where the caret on the tooltip points to
      model.caretX = tooltipPosition.x;
      model.caretY = tooltipPosition.y;
      me._model = model;
      if (changed && opts.custom) {
        opts.custom.call(me, model);
      }
      return me;
    },
    drawCaret: function drawCaret(tooltipPoint, size) {
      var ctx = this._chart.ctx;
      var vm = this._view;
      var caretPosition = this.getCaretPosition(tooltipPoint, size, vm);
      ctx.lineTo(caretPosition.x1, caretPosition.y1);
      ctx.lineTo(caretPosition.x2, caretPosition.y2);
      ctx.lineTo(caretPosition.x3, caretPosition.y3);
    },
    getCaretPosition: function getCaretPosition(tooltipPoint, size, vm) {
      var x1, x2, x3, y1, y2, y3;
      var caretSize = vm.caretSize;
      var cornerRadius = vm.cornerRadius;
      var xAlign = vm.xAlign;
      var yAlign = vm.yAlign;
      var ptX = tooltipPoint.x;
      var ptY = tooltipPoint.y;
      var width = size.width;
      var height = size.height;
      if (yAlign === 'center') {
        y2 = ptY + height / 2;
        if (xAlign === 'left') {
          x1 = ptX;
          x2 = x1 - caretSize;
          x3 = x1;
          y1 = y2 + caretSize;
          y3 = y2 - caretSize;
        } else {
          x1 = ptX + width;
          x2 = x1 + caretSize;
          x3 = x1;
          y1 = y2 - caretSize;
          y3 = y2 + caretSize;
        }
      } else {
        if (xAlign === 'left') {
          x2 = ptX + cornerRadius + caretSize;
          x1 = x2 - caretSize;
          x3 = x2 + caretSize;
        } else if (xAlign === 'right') {
          x2 = ptX + width - cornerRadius - caretSize;
          x1 = x2 - caretSize;
          x3 = x2 + caretSize;
        } else {
          x2 = vm.caretX;
          x1 = x2 - caretSize;
          x3 = x2 + caretSize;
        }
        if (yAlign === 'top') {
          y1 = ptY;
          y2 = y1 - caretSize;
          y3 = y1;
        } else {
          y1 = ptY + height;
          y2 = y1 + caretSize;
          y3 = y1;
          // invert drawing order
          var tmp = x3;
          x3 = x1;
          x1 = tmp;
        }
      }
      return {
        x1: x1,
        x2: x2,
        x3: x3,
        y1: y1,
        y2: y2,
        y3: y3
      };
    },
    drawTitle: function drawTitle(pt, vm, ctx) {
      var title = vm.title;
      var length = title.length;
      var titleFontSize, titleSpacing, i;
      if (length) {
        var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
        pt.x = getAlignedX(vm, vm._titleAlign);
        ctx.textAlign = rtlHelper.textAlign(vm._titleAlign);
        ctx.textBaseline = 'middle';
        titleFontSize = vm.titleFontSize;
        titleSpacing = vm.titleSpacing;
        ctx.fillStyle = vm.titleFontColor;
        ctx.font = helpers$1.fontString(titleFontSize, vm._titleFontStyle, vm._titleFontFamily);
        for (i = 0; i < length; ++i) {
          ctx.fillText(title[i], rtlHelper.x(pt.x), pt.y + titleFontSize / 2);
          pt.y += titleFontSize + titleSpacing; // Line Height and spacing

          if (i + 1 === length) {
            pt.y += vm.titleMarginBottom - titleSpacing; // If Last, add margin, remove spacing
          }
        }
      }
    },
    drawBody: function drawBody(pt, vm, ctx) {
      var bodyFontSize = vm.bodyFontSize;
      var bodySpacing = vm.bodySpacing;
      var bodyAlign = vm._bodyAlign;
      var body = vm.body;
      var drawColorBoxes = vm.displayColors;
      var xLinePadding = 0;
      var colorX = drawColorBoxes ? getAlignedX(vm, 'left') : 0;
      var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
      var fillLineOfText = function fillLineOfText(line) {
        ctx.fillText(line, rtlHelper.x(pt.x + xLinePadding), pt.y + bodyFontSize / 2);
        pt.y += bodyFontSize + bodySpacing;
      };
      var bodyItem, textColor, labelColors, lines, i, j, ilen, jlen;
      var bodyAlignForCalculation = rtlHelper.textAlign(bodyAlign);
      ctx.textAlign = bodyAlign;
      ctx.textBaseline = 'middle';
      ctx.font = helpers$1.fontString(bodyFontSize, vm._bodyFontStyle, vm._bodyFontFamily);
      pt.x = getAlignedX(vm, bodyAlignForCalculation);

      // Before body lines
      ctx.fillStyle = vm.bodyFontColor;
      helpers$1.each(vm.beforeBody, fillLineOfText);
      xLinePadding = drawColorBoxes && bodyAlignForCalculation !== 'right' ? bodyAlign === 'center' ? bodyFontSize / 2 + 1 : bodyFontSize + 2 : 0;

      // Draw body lines now
      for (i = 0, ilen = body.length; i < ilen; ++i) {
        bodyItem = body[i];
        textColor = vm.labelTextColors[i];
        labelColors = vm.labelColors[i];
        ctx.fillStyle = textColor;
        helpers$1.each(bodyItem.before, fillLineOfText);
        lines = bodyItem.lines;
        for (j = 0, jlen = lines.length; j < jlen; ++j) {
          // Draw Legend-like boxes if needed
          if (drawColorBoxes) {
            var rtlColorX = rtlHelper.x(colorX);

            // Fill a white rect so that colours merge nicely if the opacity is < 1
            ctx.fillStyle = vm.legendColorBackground;
            ctx.fillRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

            // Border
            ctx.lineWidth = 1;
            ctx.strokeStyle = labelColors.borderColor;
            ctx.strokeRect(rtlHelper.leftForLtr(rtlColorX, bodyFontSize), pt.y, bodyFontSize, bodyFontSize);

            // Inner square
            ctx.fillStyle = labelColors.backgroundColor;
            ctx.fillRect(rtlHelper.leftForLtr(rtlHelper.xPlus(rtlColorX, 1), bodyFontSize - 2), pt.y + 1, bodyFontSize - 2, bodyFontSize - 2);
            ctx.fillStyle = textColor;
          }
          fillLineOfText(lines[j]);
        }
        helpers$1.each(bodyItem.after, fillLineOfText);
      }

      // Reset back to 0 for after body
      xLinePadding = 0;

      // After body lines
      helpers$1.each(vm.afterBody, fillLineOfText);
      pt.y -= bodySpacing; // Remove last body spacing
    },
    drawFooter: function drawFooter(pt, vm, ctx) {
      var footer = vm.footer;
      var length = footer.length;
      var footerFontSize, i;
      if (length) {
        var rtlHelper = getRtlHelper(vm.rtl, vm.x, vm.width);
        pt.x = getAlignedX(vm, vm._footerAlign);
        pt.y += vm.footerMarginTop;
        ctx.textAlign = rtlHelper.textAlign(vm._footerAlign);
        ctx.textBaseline = 'middle';
        footerFontSize = vm.footerFontSize;
        ctx.fillStyle = vm.footerFontColor;
        ctx.font = helpers$1.fontString(footerFontSize, vm._footerFontStyle, vm._footerFontFamily);
        for (i = 0; i < length; ++i) {
          ctx.fillText(footer[i], rtlHelper.x(pt.x), pt.y + footerFontSize / 2);
          pt.y += footerFontSize + vm.footerSpacing;
        }
      }
    },
    drawBackground: function drawBackground(pt, vm, ctx, tooltipSize) {
      ctx.fillStyle = vm.backgroundColor;
      ctx.strokeStyle = vm.borderColor;
      ctx.lineWidth = vm.borderWidth;
      var xAlign = vm.xAlign;
      var yAlign = vm.yAlign;
      var x = pt.x;
      var y = pt.y;
      var width = tooltipSize.width;
      var height = tooltipSize.height;
      var radius = vm.cornerRadius;
      ctx.beginPath();
      ctx.moveTo(x + radius, y);
      if (yAlign === 'top') {
        this.drawCaret(pt, tooltipSize);
      }
      ctx.lineTo(x + width - radius, y);
      ctx.quadraticCurveTo(x + width, y, x + width, y + radius);
      if (yAlign === 'center' && xAlign === 'right') {
        this.drawCaret(pt, tooltipSize);
      }
      ctx.lineTo(x + width, y + height - radius);
      ctx.quadraticCurveTo(x + width, y + height, x + width - radius, y + height);
      if (yAlign === 'bottom') {
        this.drawCaret(pt, tooltipSize);
      }
      ctx.lineTo(x + radius, y + height);
      ctx.quadraticCurveTo(x, y + height, x, y + height - radius);
      if (yAlign === 'center' && xAlign === 'left') {
        this.drawCaret(pt, tooltipSize);
      }
      ctx.lineTo(x, y + radius);
      ctx.quadraticCurveTo(x, y, x + radius, y);
      ctx.closePath();
      ctx.fill();
      if (vm.borderWidth > 0) {
        ctx.stroke();
      }
    },
    draw: function draw() {
      var ctx = this._chart.ctx;
      var vm = this._view;
      if (vm.opacity === 0) {
        return;
      }
      var tooltipSize = {
        width: vm.width,
        height: vm.height
      };
      var pt = {
        x: vm.x,
        y: vm.y
      };

      // IE11/Edge does not like very small opacities, so snap to 0
      var opacity = Math.abs(vm.opacity < 1e-3) ? 0 : vm.opacity;

      // Truthy/falsey value for empty tooltip
      var hasTooltipContent = vm.title.length || vm.beforeBody.length || vm.body.length || vm.afterBody.length || vm.footer.length;
      if (this._options.enabled && hasTooltipContent) {
        ctx.save();
        ctx.globalAlpha = opacity;

        // Draw Background
        this.drawBackground(pt, vm, ctx, tooltipSize);

        // Draw Title, Body, and Footer
        pt.y += vm.yPadding;
        helpers$1.rtl.overrideTextDirection(ctx, vm.textDirection);

        // Titles
        this.drawTitle(pt, vm, ctx);

        // Body
        this.drawBody(pt, vm, ctx);

        // Footer
        this.drawFooter(pt, vm, ctx);
        helpers$1.rtl.restoreTextDirection(ctx, vm.textDirection);
        ctx.restore();
      }
    },
    /**
     * Handle an event
     * @private
     * @param {IEvent} event - The event to handle
     * @returns {boolean} true if the tooltip changed
     */
    handleEvent: function handleEvent(e) {
      var me = this;
      var options = me._options;
      var changed = false;
      me._lastActive = me._lastActive || [];

      // Find Active Elements for tooltips
      if (e.type === 'mouseout') {
        me._active = [];
      } else {
        me._active = me._chart.getElementsAtEventForMode(e, options.mode, options);
        if (options.reverse) {
          me._active.reverse();
        }
      }

      // Remember Last Actives
      changed = !helpers$1.arrayEquals(me._active, me._lastActive);

      // Only handle target event on tooltip change
      if (changed) {
        me._lastActive = me._active;
        if (options.enabled || options.custom) {
          me._eventPosition = {
            x: e.x,
            y: e.y
          };
          me.update(true);
          me.pivot();
        }
      }
      return changed;
    }
  });

  /**
   * @namespace Chart.Tooltip.positioners
   */
  var positioners_1 = positioners;
  var core_tooltip = exports$4;
  core_tooltip.positioners = positioners_1;
  var valueOrDefault$9 = helpers$1.valueOrDefault;
  core_defaults._set('global', {
    elements: {},
    events: ['mousemove', 'mouseout', 'click', 'touchstart', 'touchmove'],
    hover: {
      onHover: null,
      mode: 'nearest',
      intersect: true,
      animationDuration: 400
    },
    onClick: null,
    maintainAspectRatio: true,
    responsive: true,
    responsiveAnimationDuration: 0
  });

  /**
   * Recursively merge the given config objects representing the `scales` option
   * by incorporating scale defaults in `xAxes` and `yAxes` array items, then
   * returns a deep copy of the result, thus doesn't alter inputs.
   */
  function mergeScaleConfig(/* config objects ... */
  ) {
    return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
      merger: function merger(key, target, source, options) {
        if (key === 'xAxes' || key === 'yAxes') {
          var slen = source[key].length;
          var i, type, scale;
          if (!target[key]) {
            target[key] = [];
          }
          for (i = 0; i < slen; ++i) {
            scale = source[key][i];
            type = valueOrDefault$9(scale.type, key === 'xAxes' ? 'category' : 'linear');
            if (i >= target[key].length) {
              target[key].push({});
            }
            if (!target[key][i].type || scale.type && scale.type !== target[key][i].type) {
              // new/untyped scale or type changed: let's apply the new defaults
              // then merge source scale to correctly overwrite the defaults.
              helpers$1.merge(target[key][i], [core_scaleService.getScaleDefaults(type), scale]);
            } else {
              // scales type are the same
              helpers$1.merge(target[key][i], scale);
            }
          }
        } else {
          helpers$1._merger(key, target, source, options);
        }
      }
    });
  }

  /**
   * Recursively merge the given config objects as the root options by handling
   * default scale options for the `scales` and `scale` properties, then returns
   * a deep copy of the result, thus doesn't alter inputs.
   */
  function mergeConfig(/* config objects ... */
  ) {
    return helpers$1.merge(Object.create(null), [].slice.call(arguments), {
      merger: function merger(key, target, source, options) {
        var tval = target[key] || Object.create(null);
        var sval = source[key];
        if (key === 'scales') {
          // scale config merging is complex. Add our own function here for that
          target[key] = mergeScaleConfig(tval, sval);
        } else if (key === 'scale') {
          // used in polar area & radar charts since there is only one scale
          target[key] = helpers$1.merge(tval, [core_scaleService.getScaleDefaults(sval.type), sval]);
        } else {
          helpers$1._merger(key, target, source, options);
        }
      }
    });
  }
  function initConfig(config) {
    config = config || Object.create(null);

    // Do NOT use mergeConfig for the data object because this method merges arrays
    // and so would change references to labels and datasets, preventing data updates.
    var data = config.data = config.data || {};
    data.datasets = data.datasets || [];
    data.labels = data.labels || [];
    config.options = mergeConfig(core_defaults.global, core_defaults[config.type], config.options || {});
    return config;
  }
  function updateConfig(chart) {
    var newOptions = chart.options;
    helpers$1.each(chart.scales, function (scale) {
      core_layouts.removeBox(chart, scale);
    });
    newOptions = mergeConfig(core_defaults.global, core_defaults[chart.config.type], newOptions);
    chart.options = chart.config.options = newOptions;
    chart.ensureScalesHaveIDs();
    chart.buildOrUpdateScales();

    // Tooltip
    chart.tooltip._options = newOptions.tooltips;
    chart.tooltip.initialize();
  }
  function nextAvailableScaleId(axesOpts, prefix, index) {
    var id;
    var hasId = function hasId(obj) {
      return obj.id === id;
    };
    do {
      id = prefix + index++;
    } while (helpers$1.findIndex(axesOpts, hasId) >= 0);
    return id;
  }
  function positionIsHorizontal(position) {
    return position === 'top' || position === 'bottom';
  }
  function compare2Level(l1, l2) {
    return function (a, b) {
      return a[l1] === b[l1] ? a[l2] - b[l2] : a[l1] - b[l1];
    };
  }
  var Chart = function Chart(item, config) {
    this.construct(item, config);
    return this;
  };
  helpers$1.extend(Chart.prototype, /** @lends Chart */{
    /**
     * @private
     */
    construct: function construct(item, config) {
      var me = this;
      config = initConfig(config);
      var context = platform.acquireContext(item, config);
      var canvas = context && context.canvas;
      var height = canvas && canvas.height;
      var width = canvas && canvas.width;
      me.id = helpers$1.uid();
      me.ctx = context;
      me.canvas = canvas;
      me.config = config;
      me.width = width;
      me.height = height;
      me.aspectRatio = height ? width / height : null;
      me.options = config.options;
      me._bufferedRender = false;
      me._layers = [];

      /**
       * Provided for backward compatibility, Chart and Chart.Controller have been merged,
       * the "instance" still need to be defined since it might be called from plugins.
       * @prop Chart#chart
       * @deprecated since version 2.6.0
       * @todo remove at version 3
       * @private
       */
      me.chart = me;
      me.controller = me; // chart.chart.controller #inception

      // Add the chart instance to the global namespace
      Chart.instances[me.id] = me;

      // Define alias to the config data: `chart.data === chart.config.data`
      Object.defineProperty(me, 'data', {
        get: function get() {
          return me.config.data;
        },
        set: function set(value) {
          me.config.data = value;
        }
      });
      if (!context || !canvas) {
        // The given item is not a compatible context2d element, let's return before finalizing
        // the chart initialization but after setting basic chart / controller properties that
        // can help to figure out that the chart is not valid (e.g chart.canvas !== null);
        // https://github.com/chartjs/Chart.js/issues/2807
        console.error("Failed to create chart: can't acquire context from the given item");
        return;
      }
      me.initialize();
      me.update();
    },
    /**
     * @private
     */
    initialize: function initialize() {
      var me = this;

      // Before init plugin notification
      core_plugins.notify(me, 'beforeInit');
      helpers$1.retinaScale(me, me.options.devicePixelRatio);
      me.bindEvents();
      if (me.options.responsive) {
        // Initial resize before chart draws (must be silent to preserve initial animations).
        me.resize(true);
      }
      me.initToolTip();

      // After init plugin notification
      core_plugins.notify(me, 'afterInit');
      return me;
    },
    clear: function clear() {
      helpers$1.canvas.clear(this);
      return this;
    },
    stop: function stop() {
      // Stops any current animation loop occurring
      core_animations.cancelAnimation(this);
      return this;
    },
    resize: function resize(silent) {
      var me = this;
      var options = me.options;
      var canvas = me.canvas;
      var aspectRatio = options.maintainAspectRatio && me.aspectRatio || null;

      // the canvas render width and height will be casted to integers so make sure that
      // the canvas display style uses the same integer values to avoid blurring effect.

      // Set to 0 instead of canvas.size because the size defaults to 300x150 if the element is collapsed
      var newWidth = Math.max(0, Math.floor(helpers$1.getMaximumWidth(canvas)));
      var newHeight = Math.max(0, Math.floor(aspectRatio ? newWidth / aspectRatio : helpers$1.getMaximumHeight(canvas)));
      if (me.width === newWidth && me.height === newHeight) {
        return;
      }
      canvas.width = me.width = newWidth;
      canvas.height = me.height = newHeight;
      canvas.style.width = newWidth + 'px';
      canvas.style.height = newHeight + 'px';
      helpers$1.retinaScale(me, options.devicePixelRatio);
      if (!silent) {
        // Notify any plugins about the resize
        var newSize = {
          width: newWidth,
          height: newHeight
        };
        core_plugins.notify(me, 'resize', [newSize]);

        // Notify of resize
        if (options.onResize) {
          options.onResize(me, newSize);
        }
        me.stop();
        me.update({
          duration: options.responsiveAnimationDuration
        });
      }
    },
    ensureScalesHaveIDs: function ensureScalesHaveIDs() {
      var options = this.options;
      var scalesOptions = options.scales || {};
      var scaleOptions = options.scale;
      helpers$1.each(scalesOptions.xAxes, function (xAxisOptions, index) {
        if (!xAxisOptions.id) {
          xAxisOptions.id = nextAvailableScaleId(scalesOptions.xAxes, 'x-axis-', index);
        }
      });
      helpers$1.each(scalesOptions.yAxes, function (yAxisOptions, index) {
        if (!yAxisOptions.id) {
          yAxisOptions.id = nextAvailableScaleId(scalesOptions.yAxes, 'y-axis-', index);
        }
      });
      if (scaleOptions) {
        scaleOptions.id = scaleOptions.id || 'scale';
      }
    },
    /**
     * Builds a map of scale ID to scale object for future lookup.
     */
    buildOrUpdateScales: function buildOrUpdateScales() {
      var me = this;
      var options = me.options;
      var scales = me.scales || {};
      var items = [];
      var updated = Object.keys(scales).reduce(function (obj, id) {
        obj[id] = false;
        return obj;
      }, {});
      if (options.scales) {
        items = items.concat((options.scales.xAxes || []).map(function (xAxisOptions) {
          return {
            options: xAxisOptions,
            dtype: 'category',
            dposition: 'bottom'
          };
        }), (options.scales.yAxes || []).map(function (yAxisOptions) {
          return {
            options: yAxisOptions,
            dtype: 'linear',
            dposition: 'left'
          };
        }));
      }
      if (options.scale) {
        items.push({
          options: options.scale,
          dtype: 'radialLinear',
          isDefault: true,
          dposition: 'chartArea'
        });
      }
      helpers$1.each(items, function (item) {
        var scaleOptions = item.options;
        var id = scaleOptions.id;
        var scaleType = valueOrDefault$9(scaleOptions.type, item.dtype);
        if (positionIsHorizontal(scaleOptions.position) !== positionIsHorizontal(item.dposition)) {
          scaleOptions.position = item.dposition;
        }
        updated[id] = true;
        var scale = null;
        if (id in scales && scales[id].type === scaleType) {
          scale = scales[id];
          scale.options = scaleOptions;
          scale.ctx = me.ctx;
          scale.chart = me;
        } else {
          var scaleClass = core_scaleService.getScaleConstructor(scaleType);
          if (!scaleClass) {
            return;
          }
          scale = new scaleClass({
            id: id,
            type: scaleType,
            options: scaleOptions,
            ctx: me.ctx,
            chart: me
          });
          scales[scale.id] = scale;
        }
        scale.mergeTicksOptions();

        // TODO(SB): I think we should be able to remove this custom case (options.scale)
        // and consider it as a regular scale part of the "scales"" map only! This would
        // make the logic easier and remove some useless? custom code.
        if (item.isDefault) {
          me.scale = scale;
        }
      });
      // clear up discarded scales
      helpers$1.each(updated, function (hasUpdated, id) {
        if (!hasUpdated) {
          delete scales[id];
        }
      });
      me.scales = scales;
      core_scaleService.addScalesToLayout(this);
    },
    buildOrUpdateControllers: function buildOrUpdateControllers() {
      var me = this;
      var newControllers = [];
      var datasets = me.data.datasets;
      var i, ilen;
      for (i = 0, ilen = datasets.length; i < ilen; i++) {
        var dataset = datasets[i];
        var meta = me.getDatasetMeta(i);
        var type = dataset.type || me.config.type;
        if (meta.type && meta.type !== type) {
          me.destroyDatasetMeta(i);
          meta = me.getDatasetMeta(i);
        }
        meta.type = type;
        meta.order = dataset.order || 0;
        meta.index = i;
        if (meta.controller) {
          meta.controller.updateIndex(i);
          meta.controller.linkScales();
        } else {
          var ControllerClass = controllers[meta.type];
          if (ControllerClass === undefined) {
            throw new Error('"' + meta.type + '" is not a chart type.');
          }
          meta.controller = new ControllerClass(me, i);
          newControllers.push(meta.controller);
        }
      }
      return newControllers;
    },
    /**
     * Reset the elements of all datasets
     * @private
     */
    resetElements: function resetElements() {
      var me = this;
      helpers$1.each(me.data.datasets, function (dataset, datasetIndex) {
        me.getDatasetMeta(datasetIndex).controller.reset();
      }, me);
    },
    /**
    * Resets the chart back to it's state before the initial animation
    */
    reset: function reset() {
      this.resetElements();
      this.tooltip.initialize();
    },
    update: function update(config) {
      var me = this;
      var i, ilen;
      if (!config || _typeof(config) !== 'object') {
        // backwards compatibility
        config = {
          duration: config,
          lazy: arguments[1]
        };
      }
      updateConfig(me);

      // plugins options references might have change, let's invalidate the cache
      // https://github.com/chartjs/Chart.js/issues/5111#issuecomment-355934167
      core_plugins._invalidate(me);
      if (core_plugins.notify(me, 'beforeUpdate') === false) {
        return;
      }

      // In case the entire data object changed
      me.tooltip._data = me.data;

      // Make sure dataset controllers are updated and new controllers are reset
      var newControllers = me.buildOrUpdateControllers();

      // Make sure all dataset controllers have correct meta data counts
      for (i = 0, ilen = me.data.datasets.length; i < ilen; i++) {
        me.getDatasetMeta(i).controller.buildOrUpdateElements();
      }
      me.updateLayout();

      // Can only reset the new controllers after the scales have been updated
      if (me.options.animation && me.options.animation.duration) {
        helpers$1.each(newControllers, function (controller) {
          controller.reset();
        });
      }
      me.updateDatasets();

      // Need to reset tooltip in case it is displayed with elements that are removed
      // after update.
      me.tooltip.initialize();

      // Last active contains items that were previously in the tooltip.
      // When we reset the tooltip, we need to clear it
      me.lastActive = [];

      // Do this before render so that any plugins that need final scale updates can use it
      core_plugins.notify(me, 'afterUpdate');
      me._layers.sort(compare2Level('z', '_idx'));
      if (me._bufferedRender) {
        me._bufferedRequest = {
          duration: config.duration,
          easing: config.easing,
          lazy: config.lazy
        };
      } else {
        me.render(config);
      }
    },
    /**
     * Updates the chart layout unless a plugin returns `false` to the `beforeLayout`
     * hook, in which case, plugins will not be called on `afterLayout`.
     * @private
     */
    updateLayout: function updateLayout() {
      var me = this;
      if (core_plugins.notify(me, 'beforeLayout') === false) {
        return;
      }
      core_layouts.update(this, this.width, this.height);
      me._layers = [];
      helpers$1.each(me.boxes, function (box) {
        // _configure is called twice, once in core.scale.update and once here.
        // Here the boxes are fully updated and at their final positions.
        if (box._configure) {
          box._configure();
        }
        me._layers.push.apply(me._layers, box._layers());
      }, me);
      me._layers.forEach(function (item, index) {
        item._idx = index;
      });

      /**
       * Provided for backward compatibility, use `afterLayout` instead.
       * @method IPlugin#afterScaleUpdate
       * @deprecated since version 2.5.0
       * @todo remove at version 3
       * @private
       */
      core_plugins.notify(me, 'afterScaleUpdate');
      core_plugins.notify(me, 'afterLayout');
    },
    /**
     * Updates all datasets unless a plugin returns `false` to the `beforeDatasetsUpdate`
     * hook, in which case, plugins will not be called on `afterDatasetsUpdate`.
     * @private
     */
    updateDatasets: function updateDatasets() {
      var me = this;
      if (core_plugins.notify(me, 'beforeDatasetsUpdate') === false) {
        return;
      }
      for (var i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
        me.updateDataset(i);
      }
      core_plugins.notify(me, 'afterDatasetsUpdate');
    },
    /**
     * Updates dataset at index unless a plugin returns `false` to the `beforeDatasetUpdate`
     * hook, in which case, plugins will not be called on `afterDatasetUpdate`.
     * @private
     */
    updateDataset: function updateDataset(index) {
      var me = this;
      var meta = me.getDatasetMeta(index);
      var args = {
        meta: meta,
        index: index
      };
      if (core_plugins.notify(me, 'beforeDatasetUpdate', [args]) === false) {
        return;
      }
      meta.controller._update();
      core_plugins.notify(me, 'afterDatasetUpdate', [args]);
    },
    render: function render(config) {
      var me = this;
      if (!config || _typeof(config) !== 'object') {
        // backwards compatibility
        config = {
          duration: config,
          lazy: arguments[1]
        };
      }
      var animationOptions = me.options.animation;
      var duration = valueOrDefault$9(config.duration, animationOptions && animationOptions.duration);
      var lazy = config.lazy;
      if (core_plugins.notify(me, 'beforeRender') === false) {
        return;
      }
      var onComplete = function onComplete(animation) {
        core_plugins.notify(me, 'afterRender');
        helpers$1.callback(animationOptions && animationOptions.onComplete, [animation], me);
      };
      if (animationOptions && duration) {
        var animation = new core_animation({
          numSteps: duration / 16.66,
          // 60 fps
          easing: config.easing || animationOptions.easing,
          render: function render(chart, animationObject) {
            var easingFunction = helpers$1.easing.effects[animationObject.easing];
            var currentStep = animationObject.currentStep;
            var stepDecimal = currentStep / animationObject.numSteps;
            chart.draw(easingFunction(stepDecimal), stepDecimal, currentStep);
          },
          onAnimationProgress: animationOptions.onProgress,
          onAnimationComplete: onComplete
        });
        core_animations.addAnimation(me, animation, duration, lazy);
      } else {
        me.draw();

        // See https://github.com/chartjs/Chart.js/issues/3781
        onComplete(new core_animation({
          numSteps: 0,
          chart: me
        }));
      }
      return me;
    },
    draw: function draw(easingValue) {
      var me = this;
      var i, layers;
      me.clear();
      if (helpers$1.isNullOrUndef(easingValue)) {
        easingValue = 1;
      }
      me.transition(easingValue);
      if (me.width <= 0 || me.height <= 0) {
        return;
      }
      if (core_plugins.notify(me, 'beforeDraw', [easingValue]) === false) {
        return;
      }

      // Because of plugin hooks (before/afterDatasetsDraw), datasets can't
      // currently be part of layers. Instead, we draw
      // layers <= 0 before(default, backward compat), and the rest after
      layers = me._layers;
      for (i = 0; i < layers.length && layers[i].z <= 0; ++i) {
        layers[i].draw(me.chartArea);
      }
      me.drawDatasets(easingValue);

      // Rest of layers
      for (; i < layers.length; ++i) {
        layers[i].draw(me.chartArea);
      }
      me._drawTooltip(easingValue);
      core_plugins.notify(me, 'afterDraw', [easingValue]);
    },
    /**
     * @private
     */
    transition: function transition(easingValue) {
      var me = this;
      for (var i = 0, ilen = (me.data.datasets || []).length; i < ilen; ++i) {
        if (me.isDatasetVisible(i)) {
          me.getDatasetMeta(i).controller.transition(easingValue);
        }
      }
      me.tooltip.transition(easingValue);
    },
    /**
     * @private
     */
    _getSortedDatasetMetas: function _getSortedDatasetMetas(filterVisible) {
      var me = this;
      var datasets = me.data.datasets || [];
      var result = [];
      var i, ilen;
      for (i = 0, ilen = datasets.length; i < ilen; ++i) {
        if (!filterVisible || me.isDatasetVisible(i)) {
          result.push(me.getDatasetMeta(i));
        }
      }
      result.sort(compare2Level('order', 'index'));
      return result;
    },
    /**
     * @private
     */
    _getSortedVisibleDatasetMetas: function _getSortedVisibleDatasetMetas() {
      return this._getSortedDatasetMetas(true);
    },
    /**
     * Draws all datasets unless a plugin returns `false` to the `beforeDatasetsDraw`
     * hook, in which case, plugins will not be called on `afterDatasetsDraw`.
     * @private
     */
    drawDatasets: function drawDatasets(easingValue) {
      var me = this;
      var metasets, i;
      if (core_plugins.notify(me, 'beforeDatasetsDraw', [easingValue]) === false) {
        return;
      }
      metasets = me._getSortedVisibleDatasetMetas();
      for (i = metasets.length - 1; i >= 0; --i) {
        me.drawDataset(metasets[i], easingValue);
      }
      core_plugins.notify(me, 'afterDatasetsDraw', [easingValue]);
    },
    /**
     * Draws dataset at index unless a plugin returns `false` to the `beforeDatasetDraw`
     * hook, in which case, plugins will not be called on `afterDatasetDraw`.
     * @private
     */
    drawDataset: function drawDataset(meta, easingValue) {
      var me = this;
      var args = {
        meta: meta,
        index: meta.index,
        easingValue: easingValue
      };
      if (core_plugins.notify(me, 'beforeDatasetDraw', [args]) === false) {
        return;
      }
      meta.controller.draw(easingValue);
      core_plugins.notify(me, 'afterDatasetDraw', [args]);
    },
    /**
     * Draws tooltip unless a plugin returns `false` to the `beforeTooltipDraw`
     * hook, in which case, plugins will not be called on `afterTooltipDraw`.
     * @private
     */
    _drawTooltip: function _drawTooltip(easingValue) {
      var me = this;
      var tooltip = me.tooltip;
      var args = {
        tooltip: tooltip,
        easingValue: easingValue
      };
      if (core_plugins.notify(me, 'beforeTooltipDraw', [args]) === false) {
        return;
      }
      tooltip.draw();
      core_plugins.notify(me, 'afterTooltipDraw', [args]);
    },
    /**
     * Get the single element that was clicked on
     * @return An object containing the dataset index and element index of the matching element. Also contains the rectangle that was draw
     */
    getElementAtEvent: function getElementAtEvent(e) {
      return core_interaction.modes.single(this, e);
    },
    getElementsAtEvent: function getElementsAtEvent(e) {
      return core_interaction.modes.label(this, e, {
        intersect: true
      });
    },
    getElementsAtXAxis: function getElementsAtXAxis(e) {
      return core_interaction.modes['x-axis'](this, e, {
        intersect: true
      });
    },
    getElementsAtEventForMode: function getElementsAtEventForMode(e, mode, options) {
      var method = core_interaction.modes[mode];
      if (typeof method === 'function') {
        return method(this, e, options);
      }
      return [];
    },
    getDatasetAtEvent: function getDatasetAtEvent(e) {
      return core_interaction.modes.dataset(this, e, {
        intersect: true
      });
    },
    getDatasetMeta: function getDatasetMeta(datasetIndex) {
      var me = this;
      var dataset = me.data.datasets[datasetIndex];
      if (!dataset._meta) {
        dataset._meta = {};
      }
      var meta = dataset._meta[me.id];
      if (!meta) {
        meta = dataset._meta[me.id] = {
          type: null,
          data: [],
          dataset: null,
          controller: null,
          hidden: null,
          // See isDatasetVisible() comment
          xAxisID: null,
          yAxisID: null,
          order: dataset.order || 0,
          index: datasetIndex
        };
      }
      return meta;
    },
    getVisibleDatasetCount: function getVisibleDatasetCount() {
      var count = 0;
      for (var i = 0, ilen = this.data.datasets.length; i < ilen; ++i) {
        if (this.isDatasetVisible(i)) {
          count++;
        }
      }
      return count;
    },
    isDatasetVisible: function isDatasetVisible(datasetIndex) {
      var meta = this.getDatasetMeta(datasetIndex);

      // meta.hidden is a per chart dataset hidden flag override with 3 states: if true or false,
      // the dataset.hidden value is ignored, else if null, the dataset hidden state is returned.
      return typeof meta.hidden === 'boolean' ? !meta.hidden : !this.data.datasets[datasetIndex].hidden;
    },
    generateLegend: function generateLegend() {
      return this.options.legendCallback(this);
    },
    /**
     * @private
     */
    destroyDatasetMeta: function destroyDatasetMeta(datasetIndex) {
      var id = this.id;
      var dataset = this.data.datasets[datasetIndex];
      var meta = dataset._meta && dataset._meta[id];
      if (meta) {
        meta.controller.destroy();
        delete dataset._meta[id];
      }
    },
    destroy: function destroy() {
      var me = this;
      var canvas = me.canvas;
      var i, ilen;
      me.stop();

      // dataset controllers need to cleanup associated data
      for (i = 0, ilen = me.data.datasets.length; i < ilen; ++i) {
        me.destroyDatasetMeta(i);
      }
      if (canvas) {
        me.unbindEvents();
        helpers$1.canvas.clear(me);
        platform.releaseContext(me.ctx);
        me.canvas = null;
        me.ctx = null;
      }
      core_plugins.notify(me, 'destroy');
      delete Chart.instances[me.id];
    },
    toBase64Image: function toBase64Image() {
      return this.canvas.toDataURL.apply(this.canvas, arguments);
    },
    initToolTip: function initToolTip() {
      var me = this;
      me.tooltip = new core_tooltip({
        _chart: me,
        _chartInstance: me,
        // deprecated, backward compatibility
        _data: me.data,
        _options: me.options.tooltips
      }, me);
    },
    /**
     * @private
     */
    bindEvents: function bindEvents() {
      var me = this;
      var listeners = me._listeners = {};
      var listener = function listener() {
        me.eventHandler.apply(me, arguments);
      };
      helpers$1.each(me.options.events, function (type) {
        platform.addEventListener(me, type, listener);
        listeners[type] = listener;
      });

      // Elements used to detect size change should not be injected for non responsive charts.
      // See https://github.com/chartjs/Chart.js/issues/2210
      if (me.options.responsive) {
        listener = function listener() {
          me.resize();
        };
        platform.addEventListener(me, 'resize', listener);
        listeners.resize = listener;
      }
    },
    /**
     * @private
     */
    unbindEvents: function unbindEvents() {
      var me = this;
      var listeners = me._listeners;
      if (!listeners) {
        return;
      }
      delete me._listeners;
      helpers$1.each(listeners, function (listener, type) {
        platform.removeEventListener(me, type, listener);
      });
    },
    updateHoverStyle: function updateHoverStyle(elements, mode, enabled) {
      var prefix = enabled ? 'set' : 'remove';
      var element, i, ilen;
      for (i = 0, ilen = elements.length; i < ilen; ++i) {
        element = elements[i];
        if (element) {
          this.getDatasetMeta(element._datasetIndex).controller[prefix + 'HoverStyle'](element);
        }
      }
      if (mode === 'dataset') {
        this.getDatasetMeta(elements[0]._datasetIndex).controller['_' + prefix + 'DatasetHoverStyle']();
      }
    },
    /**
     * @private
     */
    eventHandler: function eventHandler(e) {
      var me = this;
      var tooltip = me.tooltip;
      if (core_plugins.notify(me, 'beforeEvent', [e]) === false) {
        return;
      }

      // Buffer any update calls so that renders do not occur
      me._bufferedRender = true;
      me._bufferedRequest = null;
      var changed = me.handleEvent(e);
      // for smooth tooltip animations issue #4989
      // the tooltip should be the source of change
      // Animation check workaround:
      // tooltip._start will be null when tooltip isn't animating
      if (tooltip) {
        changed = tooltip._start ? tooltip.handleEvent(e) : changed | tooltip.handleEvent(e);
      }
      core_plugins.notify(me, 'afterEvent', [e]);
      var bufferedRequest = me._bufferedRequest;
      if (bufferedRequest) {
        // If we have an update that was triggered, we need to do a normal render
        me.render(bufferedRequest);
      } else if (changed && !me.animating) {
        // If entering, leaving, or changing elements, animate the change via pivot
        me.stop();

        // We only need to render at this point. Updating will cause scales to be
        // recomputed generating flicker & using more memory than necessary.
        me.render({
          duration: me.options.hover.animationDuration,
          lazy: true
        });
      }
      me._bufferedRender = false;
      me._bufferedRequest = null;
      return me;
    },
    /**
     * Handle an event
     * @private
     * @param {IEvent} event the event to handle
     * @return {boolean} true if the chart needs to re-render
     */
    handleEvent: function handleEvent(e) {
      var me = this;
      var options = me.options || {};
      var hoverOptions = options.hover;
      var changed = false;
      me.lastActive = me.lastActive || [];

      // Find Active Elements for hover and tooltips
      if (e.type === 'mouseout') {
        me.active = [];
      } else {
        me.active = me.getElementsAtEventForMode(e, hoverOptions.mode, hoverOptions);
      }

      // Invoke onHover hook
      // Need to call with native event here to not break backwards compatibility
      helpers$1.callback(options.onHover || options.hover.onHover, [e["native"], me.active], me);
      if (e.type === 'mouseup' || e.type === 'click') {
        if (options.onClick) {
          // Use e.native here for backwards compatibility
          options.onClick.call(me, e["native"], me.active);
        }
      }

      // Remove styling for last active (even if it may still be active)
      if (me.lastActive.length) {
        me.updateHoverStyle(me.lastActive, hoverOptions.mode, false);
      }

      // Built in hover styling
      if (me.active.length && hoverOptions.mode) {
        me.updateHoverStyle(me.active, hoverOptions.mode, true);
      }
      changed = !helpers$1.arrayEquals(me.active, me.lastActive);

      // Remember Last Actives
      me.lastActive = me.active;
      return changed;
    }
  });

  /**
   * NOTE(SB) We actually don't use this container anymore but we need to keep it
   * for backward compatibility. Though, it can still be useful for plugins that
   * would need to work on multiple charts?!
   */
  Chart.instances = {};
  var core_controller = Chart;

  // DEPRECATIONS

  /**
   * Provided for backward compatibility, use Chart instead.
   * @class Chart.Controller
   * @deprecated since version 2.6
   * @todo remove at version 3
   * @private
   */
  Chart.Controller = Chart;

  /**
   * Provided for backward compatibility, not available anymore.
   * @namespace Chart
   * @deprecated since version 2.8
   * @todo remove at version 3
   * @private
   */
  Chart.types = {};

  /**
   * Provided for backward compatibility, not available anymore.
   * @namespace Chart.helpers.configMerge
   * @deprecated since version 2.8.0
   * @todo remove at version 3
   * @private
   */
  helpers$1.configMerge = mergeConfig;

  /**
   * Provided for backward compatibility, not available anymore.
   * @namespace Chart.helpers.scaleMerge
   * @deprecated since version 2.8.0
   * @todo remove at version 3
   * @private
   */
  helpers$1.scaleMerge = mergeScaleConfig;
  var core_helpers = function core_helpers() {
    // -- Basic js utility methods

    helpers$1.where = function (collection, filterCallback) {
      if (helpers$1.isArray(collection) && Array.prototype.filter) {
        return collection.filter(filterCallback);
      }
      var filtered = [];
      helpers$1.each(collection, function (item) {
        if (filterCallback(item)) {
          filtered.push(item);
        }
      });
      return filtered;
    };
    helpers$1.findIndex = Array.prototype.findIndex ? function (array, callback, scope) {
      return array.findIndex(callback, scope);
    } : function (array, callback, scope) {
      scope = scope === undefined ? array : scope;
      for (var i = 0, ilen = array.length; i < ilen; ++i) {
        if (callback.call(scope, array[i], i, array)) {
          return i;
        }
      }
      return -1;
    };
    helpers$1.findNextWhere = function (arrayToSearch, filterCallback, startIndex) {
      // Default to start of the array
      if (helpers$1.isNullOrUndef(startIndex)) {
        startIndex = -1;
      }
      for (var i = startIndex + 1; i < arrayToSearch.length; i++) {
        var currentItem = arrayToSearch[i];
        if (filterCallback(currentItem)) {
          return currentItem;
        }
      }
    };
    helpers$1.findPreviousWhere = function (arrayToSearch, filterCallback, startIndex) {
      // Default to end of the array
      if (helpers$1.isNullOrUndef(startIndex)) {
        startIndex = arrayToSearch.length;
      }
      for (var i = startIndex - 1; i >= 0; i--) {
        var currentItem = arrayToSearch[i];
        if (filterCallback(currentItem)) {
          return currentItem;
        }
      }
    };

    // -- Math methods
    helpers$1.isNumber = function (n) {
      return !isNaN(parseFloat(n)) && isFinite(n);
    };
    helpers$1.almostEquals = function (x, y, epsilon) {
      return Math.abs(x - y) < epsilon;
    };
    helpers$1.almostWhole = function (x, epsilon) {
      var rounded = Math.round(x);
      return rounded - epsilon <= x && rounded + epsilon >= x;
    };
    helpers$1.max = function (array) {
      return array.reduce(function (max, value) {
        if (!isNaN(value)) {
          return Math.max(max, value);
        }
        return max;
      }, Number.NEGATIVE_INFINITY);
    };
    helpers$1.min = function (array) {
      return array.reduce(function (min, value) {
        if (!isNaN(value)) {
          return Math.min(min, value);
        }
        return min;
      }, Number.POSITIVE_INFINITY);
    };
    helpers$1.sign = Math.sign ? function (x) {
      return Math.sign(x);
    } : function (x) {
      x = +x; // convert to a number
      if (x === 0 || isNaN(x)) {
        return x;
      }
      return x > 0 ? 1 : -1;
    };
    helpers$1.toRadians = function (degrees) {
      return degrees * (Math.PI / 180);
    };
    helpers$1.toDegrees = function (radians) {
      return radians * (180 / Math.PI);
    };

    /**
     * Returns the number of decimal places
     * i.e. the number of digits after the decimal point, of the value of this Number.
     * @param {number} x - A number.
     * @returns {number} The number of decimal places.
     * @private
     */
    helpers$1._decimalPlaces = function (x) {
      if (!helpers$1.isFinite(x)) {
        return;
      }
      var e = 1;
      var p = 0;
      while (Math.round(x * e) / e !== x) {
        e *= 10;
        p++;
      }
      return p;
    };

    // Gets the angle from vertical upright to the point about a centre.
    helpers$1.getAngleFromPoint = function (centrePoint, anglePoint) {
      var distanceFromXCenter = anglePoint.x - centrePoint.x;
      var distanceFromYCenter = anglePoint.y - centrePoint.y;
      var radialDistanceFromCenter = Math.sqrt(distanceFromXCenter * distanceFromXCenter + distanceFromYCenter * distanceFromYCenter);
      var angle = Math.atan2(distanceFromYCenter, distanceFromXCenter);
      if (angle < -0.5 * Math.PI) {
        angle += 2.0 * Math.PI; // make sure the returned angle is in the range of (-PI/2, 3PI/2]
      }
      return {
        angle: angle,
        distance: radialDistanceFromCenter
      };
    };
    helpers$1.distanceBetweenPoints = function (pt1, pt2) {
      return Math.sqrt(Math.pow(pt2.x - pt1.x, 2) + Math.pow(pt2.y - pt1.y, 2));
    };

    /**
     * Provided for backward compatibility, not available anymore
     * @function Chart.helpers.aliasPixel
     * @deprecated since version 2.8.0
     * @todo remove at version 3
     */
    helpers$1.aliasPixel = function (pixelWidth) {
      return pixelWidth % 2 === 0 ? 0 : 0.5;
    };

    /**
     * Returns the aligned pixel value to avoid anti-aliasing blur
     * @param {Chart} chart - The chart instance.
     * @param {number} pixel - A pixel value.
     * @param {number} width - The width of the element.
     * @returns {number} The aligned pixel value.
     * @private
     */
    helpers$1._alignPixel = function (chart, pixel, width) {
      var devicePixelRatio = chart.currentDevicePixelRatio;
      var halfWidth = width / 2;
      return Math.round((pixel - halfWidth) * devicePixelRatio) / devicePixelRatio + halfWidth;
    };
    helpers$1.splineCurve = function (firstPoint, middlePoint, afterPoint, t) {
      // Props to Rob Spencer at scaled innovation for his post on splining between points
      // http://scaledinnovation.com/analytics/splines/aboutSplines.html

      // This function must also respect "skipped" points

      var previous = firstPoint.skip ? middlePoint : firstPoint;
      var current = middlePoint;
      var next = afterPoint.skip ? middlePoint : afterPoint;
      var d01 = Math.sqrt(Math.pow(current.x - previous.x, 2) + Math.pow(current.y - previous.y, 2));
      var d12 = Math.sqrt(Math.pow(next.x - current.x, 2) + Math.pow(next.y - current.y, 2));
      var s01 = d01 / (d01 + d12);
      var s12 = d12 / (d01 + d12);

      // If all points are the same, s01 & s02 will be inf
      s01 = isNaN(s01) ? 0 : s01;
      s12 = isNaN(s12) ? 0 : s12;
      var fa = t * s01; // scaling factor for triangle Ta
      var fb = t * s12;
      return {
        previous: {
          x: current.x - fa * (next.x - previous.x),
          y: current.y - fa * (next.y - previous.y)
        },
        next: {
          x: current.x + fb * (next.x - previous.x),
          y: current.y + fb * (next.y - previous.y)
        }
      };
    };
    helpers$1.EPSILON = Number.EPSILON || 1e-14;
    helpers$1.splineCurveMonotone = function (points) {
      // This function calculates Bézier control points in a similar way than |splineCurve|,
      // but preserves monotonicity of the provided data and ensures no local extremums are added
      // between the dataset discrete points due to the interpolation.
      // See : https://en.wikipedia.org/wiki/Monotone_cubic_interpolation

      var pointsWithTangents = (points || []).map(function (point) {
        return {
          model: point._model,
          deltaK: 0,
          mK: 0
        };
      });

      // Calculate slopes (deltaK) and initialize tangents (mK)
      var pointsLen = pointsWithTangents.length;
      var i, pointBefore, pointCurrent, pointAfter;
      for (i = 0; i < pointsLen; ++i) {
        pointCurrent = pointsWithTangents[i];
        if (pointCurrent.model.skip) {
          continue;
        }
        pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
        pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
        if (pointAfter && !pointAfter.model.skip) {
          var slopeDeltaX = pointAfter.model.x - pointCurrent.model.x;

          // In the case of two points that appear at the same x pixel, slopeDeltaX is 0
          pointCurrent.deltaK = slopeDeltaX !== 0 ? (pointAfter.model.y - pointCurrent.model.y) / slopeDeltaX : 0;
        }
        if (!pointBefore || pointBefore.model.skip) {
          pointCurrent.mK = pointCurrent.deltaK;
        } else if (!pointAfter || pointAfter.model.skip) {
          pointCurrent.mK = pointBefore.deltaK;
        } else if (this.sign(pointBefore.deltaK) !== this.sign(pointCurrent.deltaK)) {
          pointCurrent.mK = 0;
        } else {
          pointCurrent.mK = (pointBefore.deltaK + pointCurrent.deltaK) / 2;
        }
      }

      // Adjust tangents to ensure monotonic properties
      var alphaK, betaK, tauK, squaredMagnitude;
      for (i = 0; i < pointsLen - 1; ++i) {
        pointCurrent = pointsWithTangents[i];
        pointAfter = pointsWithTangents[i + 1];
        if (pointCurrent.model.skip || pointAfter.model.skip) {
          continue;
        }
        if (helpers$1.almostEquals(pointCurrent.deltaK, 0, this.EPSILON)) {
          pointCurrent.mK = pointAfter.mK = 0;
          continue;
        }
        alphaK = pointCurrent.mK / pointCurrent.deltaK;
        betaK = pointAfter.mK / pointCurrent.deltaK;
        squaredMagnitude = Math.pow(alphaK, 2) + Math.pow(betaK, 2);
        if (squaredMagnitude <= 9) {
          continue;
        }
        tauK = 3 / Math.sqrt(squaredMagnitude);
        pointCurrent.mK = alphaK * tauK * pointCurrent.deltaK;
        pointAfter.mK = betaK * tauK * pointCurrent.deltaK;
      }

      // Compute control points
      var deltaX;
      for (i = 0; i < pointsLen; ++i) {
        pointCurrent = pointsWithTangents[i];
        if (pointCurrent.model.skip) {
          continue;
        }
        pointBefore = i > 0 ? pointsWithTangents[i - 1] : null;
        pointAfter = i < pointsLen - 1 ? pointsWithTangents[i + 1] : null;
        if (pointBefore && !pointBefore.model.skip) {
          deltaX = (pointCurrent.model.x - pointBefore.model.x) / 3;
          pointCurrent.model.controlPointPreviousX = pointCurrent.model.x - deltaX;
          pointCurrent.model.controlPointPreviousY = pointCurrent.model.y - deltaX * pointCurrent.mK;
        }
        if (pointAfter && !pointAfter.model.skip) {
          deltaX = (pointAfter.model.x - pointCurrent.model.x) / 3;
          pointCurrent.model.controlPointNextX = pointCurrent.model.x + deltaX;
          pointCurrent.model.controlPointNextY = pointCurrent.model.y + deltaX * pointCurrent.mK;
        }
      }
    };
    helpers$1.nextItem = function (collection, index, loop) {
      if (loop) {
        return index >= collection.length - 1 ? collection[0] : collection[index + 1];
      }
      return index >= collection.length - 1 ? collection[collection.length - 1] : collection[index + 1];
    };
    helpers$1.previousItem = function (collection, index, loop) {
      if (loop) {
        return index <= 0 ? collection[collection.length - 1] : collection[index - 1];
      }
      return index <= 0 ? collection[0] : collection[index - 1];
    };
    // Implementation of the nice number algorithm used in determining where axis labels will go
    helpers$1.niceNum = function (range, round) {
      var exponent = Math.floor(helpers$1.log10(range));
      var fraction = range / Math.pow(10, exponent);
      var niceFraction;
      if (round) {
        if (fraction < 1.5) {
          niceFraction = 1;
        } else if (fraction < 3) {
          niceFraction = 2;
        } else if (fraction < 7) {
          niceFraction = 5;
        } else {
          niceFraction = 10;
        }
      } else if (fraction <= 1.0) {
        niceFraction = 1;
      } else if (fraction <= 2) {
        niceFraction = 2;
      } else if (fraction <= 5) {
        niceFraction = 5;
      } else {
        niceFraction = 10;
      }
      return niceFraction * Math.pow(10, exponent);
    };
    // Request animation polyfill - https://www.paulirish.com/2011/requestanimationframe-for-smart-animating/
    helpers$1.requestAnimFrame = function () {
      if (typeof window === 'undefined') {
        return function (callback) {
          callback();
        };
      }
      return window.requestAnimationFrame || window.webkitRequestAnimationFrame || window.mozRequestAnimationFrame || window.oRequestAnimationFrame || window.msRequestAnimationFrame || function (callback) {
        return window.setTimeout(callback, 1000 / 60);
      };
    }();
    // -- DOM methods
    helpers$1.getRelativePosition = function (evt, chart) {
      var mouseX, mouseY;
      var e = evt.originalEvent || evt;
      var canvas = evt.target || evt.srcElement;
      var boundingRect = canvas.getBoundingClientRect();
      var touches = e.touches;
      if (touches && touches.length > 0) {
        mouseX = touches[0].clientX;
        mouseY = touches[0].clientY;
      } else {
        mouseX = e.clientX;
        mouseY = e.clientY;
      }

      // Scale mouse coordinates into canvas coordinates
      // by following the pattern laid out by 'jerryj' in the comments of
      // https://www.html5canvastutorials.com/advanced/html5-canvas-mouse-coordinates/
      var paddingLeft = parseFloat(helpers$1.getStyle(canvas, 'padding-left'));
      var paddingTop = parseFloat(helpers$1.getStyle(canvas, 'padding-top'));
      var paddingRight = parseFloat(helpers$1.getStyle(canvas, 'padding-right'));
      var paddingBottom = parseFloat(helpers$1.getStyle(canvas, 'padding-bottom'));
      var width = boundingRect.right - boundingRect.left - paddingLeft - paddingRight;
      var height = boundingRect.bottom - boundingRect.top - paddingTop - paddingBottom;

      // We divide by the current device pixel ratio, because the canvas is scaled up by that amount in each direction. However
      // the backend model is in unscaled coordinates. Since we are going to deal with our model coordinates, we go back here
      mouseX = Math.round((mouseX - boundingRect.left - paddingLeft) / width * canvas.width / chart.currentDevicePixelRatio);
      mouseY = Math.round((mouseY - boundingRect.top - paddingTop) / height * canvas.height / chart.currentDevicePixelRatio);
      return {
        x: mouseX,
        y: mouseY
      };
    };

    // Private helper function to convert max-width/max-height values that may be percentages into a number
    function parseMaxStyle(styleValue, node, parentProperty) {
      var valueInPixels;
      if (typeof styleValue === 'string') {
        valueInPixels = parseInt(styleValue, 10);
        if (styleValue.indexOf('%') !== -1) {
          // percentage * size in dimension
          valueInPixels = valueInPixels / 100 * node.parentNode[parentProperty];
        }
      } else {
        valueInPixels = styleValue;
      }
      return valueInPixels;
    }

    /**
     * Returns if the given value contains an effective constraint.
     * @private
     */
    function isConstrainedValue(value) {
      return value !== undefined && value !== null && value !== 'none';
    }

    /**
     * Returns the max width or height of the given DOM node in a cross-browser compatible fashion
     * @param {HTMLElement} domNode - the node to check the constraint on
     * @param {string} maxStyle - the style that defines the maximum for the direction we are using ('max-width' / 'max-height')
     * @param {string} percentageProperty - property of parent to use when calculating width as a percentage
     * @see {@link https://www.nathanaeljones.com/blog/2013/reading-max-width-cross-browser}
     */
    function getConstraintDimension(domNode, maxStyle, percentageProperty) {
      var view = document.defaultView;
      var parentNode = helpers$1._getParentNode(domNode);
      var constrainedNode = view.getComputedStyle(domNode)[maxStyle];
      var constrainedContainer = view.getComputedStyle(parentNode)[maxStyle];
      var hasCNode = isConstrainedValue(constrainedNode);
      var hasCContainer = isConstrainedValue(constrainedContainer);
      var infinity = Number.POSITIVE_INFINITY;
      if (hasCNode || hasCContainer) {
        return Math.min(hasCNode ? parseMaxStyle(constrainedNode, domNode, percentageProperty) : infinity, hasCContainer ? parseMaxStyle(constrainedContainer, parentNode, percentageProperty) : infinity);
      }
      return 'none';
    }
    // returns Number or undefined if no constraint
    helpers$1.getConstraintWidth = function (domNode) {
      return getConstraintDimension(domNode, 'max-width', 'clientWidth');
    };
    // returns Number or undefined if no constraint
    helpers$1.getConstraintHeight = function (domNode) {
      return getConstraintDimension(domNode, 'max-height', 'clientHeight');
    };
    /**
     * @private
    	 */
    helpers$1._calculatePadding = function (container, padding, parentDimension) {
      padding = helpers$1.getStyle(container, padding);
      return padding.indexOf('%') > -1 ? parentDimension * parseInt(padding, 10) / 100 : parseInt(padding, 10);
    };
    /**
     * @private
     */
    helpers$1._getParentNode = function (domNode) {
      var parent = domNode.parentNode;
      if (parent && parent.toString() === '[object ShadowRoot]') {
        parent = parent.host;
      }
      return parent;
    };
    helpers$1.getMaximumWidth = function (domNode) {
      var container = helpers$1._getParentNode(domNode);
      if (!container) {
        return domNode.clientWidth;
      }
      var clientWidth = container.clientWidth;
      var paddingLeft = helpers$1._calculatePadding(container, 'padding-left', clientWidth);
      var paddingRight = helpers$1._calculatePadding(container, 'padding-right', clientWidth);
      var w = clientWidth - paddingLeft - paddingRight;
      var cw = helpers$1.getConstraintWidth(domNode);
      return isNaN(cw) ? w : Math.min(w, cw);
    };
    helpers$1.getMaximumHeight = function (domNode) {
      var container = helpers$1._getParentNode(domNode);
      if (!container) {
        return domNode.clientHeight;
      }
      var clientHeight = container.clientHeight;
      var paddingTop = helpers$1._calculatePadding(container, 'padding-top', clientHeight);
      var paddingBottom = helpers$1._calculatePadding(container, 'padding-bottom', clientHeight);
      var h = clientHeight - paddingTop - paddingBottom;
      var ch = helpers$1.getConstraintHeight(domNode);
      return isNaN(ch) ? h : Math.min(h, ch);
    };
    helpers$1.getStyle = function (el, property) {
      return el.currentStyle ? el.currentStyle[property] : document.defaultView.getComputedStyle(el, null).getPropertyValue(property);
    };
    helpers$1.retinaScale = function (chart, forceRatio) {
      var pixelRatio = chart.currentDevicePixelRatio = forceRatio || typeof window !== 'undefined' && window.devicePixelRatio || 1;
      if (pixelRatio === 1) {
        return;
      }
      var canvas = chart.canvas;
      var height = chart.height;
      var width = chart.width;
      canvas.height = height * pixelRatio;
      canvas.width = width * pixelRatio;
      chart.ctx.scale(pixelRatio, pixelRatio);

      // If no style has been set on the canvas, the render size is used as display size,
      // making the chart visually bigger, so let's enforce it to the "correct" values.
      // See https://github.com/chartjs/Chart.js/issues/3575
      if (!canvas.style.height && !canvas.style.width) {
        canvas.style.height = height + 'px';
        canvas.style.width = width + 'px';
      }
    };
    // -- Canvas methods
    helpers$1.fontString = function (pixelSize, fontStyle, fontFamily) {
      return fontStyle + ' ' + pixelSize + 'px ' + fontFamily;
    };
    helpers$1.longestText = function (ctx, font, arrayOfThings, cache) {
      cache = cache || {};
      var data = cache.data = cache.data || {};
      var gc = cache.garbageCollect = cache.garbageCollect || [];
      if (cache.font !== font) {
        data = cache.data = {};
        gc = cache.garbageCollect = [];
        cache.font = font;
      }
      ctx.font = font;
      var longest = 0;
      var ilen = arrayOfThings.length;
      var i, j, jlen, thing, nestedThing;
      for (i = 0; i < ilen; i++) {
        thing = arrayOfThings[i];

        // Undefined strings and arrays should not be measured
        if (thing !== undefined && thing !== null && helpers$1.isArray(thing) !== true) {
          longest = helpers$1.measureText(ctx, data, gc, longest, thing);
        } else if (helpers$1.isArray(thing)) {
          // if it is an array lets measure each element
          // to do maybe simplify this function a bit so we can do this more recursively?
          for (j = 0, jlen = thing.length; j < jlen; j++) {
            nestedThing = thing[j];
            // Undefined strings and arrays should not be measured
            if (nestedThing !== undefined && nestedThing !== null && !helpers$1.isArray(nestedThing)) {
              longest = helpers$1.measureText(ctx, data, gc, longest, nestedThing);
            }
          }
        }
      }
      var gcLen = gc.length / 2;
      if (gcLen > arrayOfThings.length) {
        for (i = 0; i < gcLen; i++) {
          delete data[gc[i]];
        }
        gc.splice(0, gcLen);
      }
      return longest;
    };
    helpers$1.measureText = function (ctx, data, gc, longest, string) {
      var textWidth = data[string];
      if (!textWidth) {
        textWidth = data[string] = ctx.measureText(string).width;
        gc.push(string);
      }
      if (textWidth > longest) {
        longest = textWidth;
      }
      return longest;
    };

    /**
     * @deprecated
     */
    helpers$1.numberOfLabelLines = function (arrayOfThings) {
      var numberOfLines = 1;
      helpers$1.each(arrayOfThings, function (thing) {
        if (helpers$1.isArray(thing)) {
          if (thing.length > numberOfLines) {
            numberOfLines = thing.length;
          }
        }
      });
      return numberOfLines;
    };
    helpers$1.color = !chartjsColor ? function (value) {
      console.error('Color.js not found!');
      return value;
    } : function (value) {
      /* global CanvasGradient */
      if (value instanceof CanvasGradient) {
        value = core_defaults.global.defaultColor;
      }
      return chartjsColor(value);
    };
    helpers$1.getHoverColor = function (colorValue) {
      /* global CanvasPattern */
      return colorValue instanceof CanvasPattern || colorValue instanceof CanvasGradient ? colorValue : helpers$1.color(colorValue).saturate(0.5).darken(0.1).rgbString();
    };
  };
  function _abstract() {
    throw new Error('This method is not implemented: either no adapter can ' + 'be found or an incomplete integration was provided.');
  }

  /**
   * Date adapter (current used by the time scale)
   * @namespace Chart._adapters._date
   * @memberof Chart._adapters
   * @private
   */

  /**
   * Currently supported unit string values.
   * @typedef {('millisecond'|'second'|'minute'|'hour'|'day'|'week'|'month'|'quarter'|'year')}
   * @memberof Chart._adapters._date
   * @name Unit
   */

  /**
   * @class
   */
  function DateAdapter(options) {
    this.options = options || {};
  }
  helpers$1.extend(DateAdapter.prototype, /** @lends DateAdapter */{
    /**
     * Returns a map of time formats for the supported formatting units defined
     * in Unit as well as 'datetime' representing a detailed date/time string.
     * @returns {{string: string}}
     */
    formats: _abstract,
    /**
     * Parses the given `value` and return the associated timestamp.
     * @param {any} value - the value to parse (usually comes from the data)
     * @param {string} [format] - the expected data format
     * @returns {(number|null)}
     * @function
     */
    parse: _abstract,
    /**
     * Returns the formatted date in the specified `format` for a given `timestamp`.
     * @param {number} timestamp - the timestamp to format
     * @param {string} format - the date/time token
     * @return {string}
     * @function
     */
    format: _abstract,
    /**
     * Adds the specified `amount` of `unit` to the given `timestamp`.
     * @param {number} timestamp - the input timestamp
     * @param {number} amount - the amount to add
     * @param {Unit} unit - the unit as string
     * @return {number}
     * @function
     */
    add: _abstract,
    /**
     * Returns the number of `unit` between the given timestamps.
     * @param {number} max - the input timestamp (reference)
     * @param {number} min - the timestamp to substract
     * @param {Unit} unit - the unit as string
     * @return {number}
     * @function
     */
    diff: _abstract,
    /**
     * Returns start of `unit` for the given `timestamp`.
     * @param {number} timestamp - the input timestamp
     * @param {Unit} unit - the unit as string
     * @param {number} [weekday] - the ISO day of the week with 1 being Monday
     * and 7 being Sunday (only needed if param *unit* is `isoWeek`).
     * @function
     */
    startOf: _abstract,
    /**
     * Returns end of `unit` for the given `timestamp`.
     * @param {number} timestamp - the input timestamp
     * @param {Unit} unit - the unit as string
     * @function
     */
    endOf: _abstract,
    // DEPRECATIONS

    /**
     * Provided for backward compatibility for scale.getValueForPixel(),
     * this method should be overridden only by the moment adapter.
     * @deprecated since version 2.8.0
     * @todo remove at version 3
     * @private
     */
    _create: function _create(value) {
      return value;
    }
  });
  DateAdapter.override = function (members) {
    helpers$1.extend(DateAdapter.prototype, members);
  };
  var _date = DateAdapter;
  var core_adapters = {
    _date: _date
  };

  /**
   * Namespace to hold static tick generation functions
   * @namespace Chart.Ticks
   */
  var core_ticks = {
    /**
     * Namespace to hold formatters for different types of ticks
     * @namespace Chart.Ticks.formatters
     */
    formatters: {
      /**
       * Formatter for value labels
       * @method Chart.Ticks.formatters.values
       * @param value the value to display
       * @return {string|string[]} the label to display
       */
      values: function values(value) {
        return helpers$1.isArray(value) ? value : '' + value;
      },
      /**
       * Formatter for linear numeric ticks
       * @method Chart.Ticks.formatters.linear
       * @param tickValue {number} the value to be formatted
       * @param index {number} the position of the tickValue parameter in the ticks array
       * @param ticks {number[]} the list of ticks being converted
       * @return {string} string representation of the tickValue parameter
       */
      linear: function linear(tickValue, index, ticks) {
        // If we have lots of ticks, don't use the ones
        var delta = ticks.length > 3 ? ticks[2] - ticks[1] : ticks[1] - ticks[0];

        // If we have a number like 2.5 as the delta, figure out how many decimal places we need
        if (Math.abs(delta) > 1) {
          if (tickValue !== Math.floor(tickValue)) {
            // not an integer
            delta = tickValue - Math.floor(tickValue);
          }
        }
        var logDelta = helpers$1.log10(Math.abs(delta));
        var tickString = '';
        if (tickValue !== 0) {
          var maxTick = Math.max(Math.abs(ticks[0]), Math.abs(ticks[ticks.length - 1]));
          if (maxTick < 1e-4) {
            // all ticks are small numbers; use scientific notation
            var logTick = helpers$1.log10(Math.abs(tickValue));
            var numExponential = Math.floor(logTick) - Math.floor(logDelta);
            numExponential = Math.max(Math.min(numExponential, 20), 0);
            tickString = tickValue.toExponential(numExponential);
          } else {
            var numDecimal = -1 * Math.floor(logDelta);
            numDecimal = Math.max(Math.min(numDecimal, 20), 0); // toFixed has a max of 20 decimal places
            tickString = tickValue.toFixed(numDecimal);
          }
        } else {
          tickString = '0'; // never show decimal places for 0
        }
        return tickString;
      },
      logarithmic: function logarithmic(tickValue, index, ticks) {
        var remain = tickValue / Math.pow(10, Math.floor(helpers$1.log10(tickValue)));
        if (tickValue === 0) {
          return '0';
        } else if (remain === 1 || remain === 2 || remain === 5 || index === 0 || index === ticks.length - 1) {
          return tickValue.toExponential();
        }
        return '';
      }
    }
  };
  var isArray = helpers$1.isArray;
  var isNullOrUndef = helpers$1.isNullOrUndef;
  var valueOrDefault$a = helpers$1.valueOrDefault;
  var valueAtIndexOrDefault = helpers$1.valueAtIndexOrDefault;
  core_defaults._set('scale', {
    display: true,
    position: 'left',
    offset: false,
    // grid line settings
    gridLines: {
      display: true,
      color: 'rgba(0,0,0,0.1)',
      lineWidth: 1,
      drawBorder: true,
      drawOnChartArea: true,
      drawTicks: true,
      tickMarkLength: 10,
      zeroLineWidth: 1,
      zeroLineColor: 'rgba(0,0,0,0.25)',
      zeroLineBorderDash: [],
      zeroLineBorderDashOffset: 0.0,
      offsetGridLines: false,
      borderDash: [],
      borderDashOffset: 0.0
    },
    // scale label
    scaleLabel: {
      // display property
      display: false,
      // actual label
      labelString: '',
      // top/bottom padding
      padding: {
        top: 4,
        bottom: 4
      }
    },
    // label settings
    ticks: {
      beginAtZero: false,
      minRotation: 0,
      maxRotation: 50,
      mirror: false,
      padding: 0,
      reverse: false,
      display: true,
      autoSkip: true,
      autoSkipPadding: 0,
      labelOffset: 0,
      // We pass through arrays to be rendered as multiline labels, we convert Others to strings here.
      callback: core_ticks.formatters.values,
      minor: {},
      major: {}
    }
  });

  /** Returns a new array containing numItems from arr */
  function sample(arr, numItems) {
    var result = [];
    var increment = arr.length / numItems;
    var i = 0;
    var len = arr.length;
    for (; i < len; i += increment) {
      result.push(arr[Math.floor(i)]);
    }
    return result;
  }
  function getPixelForGridLine(scale, index, offsetGridLines) {
    var length = scale.getTicks().length;
    var validIndex = Math.min(index, length - 1);
    var lineValue = scale.getPixelForTick(validIndex);
    var start = scale._startPixel;
    var end = scale._endPixel;
    var epsilon = 1e-6; // 1e-6 is margin in pixels for accumulated error.
    var offset;
    if (offsetGridLines) {
      if (length === 1) {
        offset = Math.max(lineValue - start, end - lineValue);
      } else if (index === 0) {
        offset = (scale.getPixelForTick(1) - lineValue) / 2;
      } else {
        offset = (lineValue - scale.getPixelForTick(validIndex - 1)) / 2;
      }
      lineValue += validIndex < index ? offset : -offset;

      // Return undefined if the pixel is out of the range
      if (lineValue < start - epsilon || lineValue > end + epsilon) {
        return;
      }
    }
    return lineValue;
  }
  function garbageCollect(caches, length) {
    helpers$1.each(caches, function (cache) {
      var gc = cache.gc;
      var gcLen = gc.length / 2;
      var i;
      if (gcLen > length) {
        for (i = 0; i < gcLen; ++i) {
          delete cache.data[gc[i]];
        }
        gc.splice(0, gcLen);
      }
    });
  }

  /**
   * Returns {width, height, offset} objects for the first, last, widest, highest tick
   * labels where offset indicates the anchor point offset from the top in pixels.
   */
  function computeLabelSizes(ctx, tickFonts, ticks, caches) {
    var length = ticks.length;
    var widths = [];
    var heights = [];
    var offsets = [];
    var widestLabelSize = 0;
    var highestLabelSize = 0;
    var i, j, jlen, label, tickFont, fontString, cache, lineHeight, width, height, nestedLabel, widest, highest;
    for (i = 0; i < length; ++i) {
      label = ticks[i].label;
      tickFont = ticks[i].major ? tickFonts.major : tickFonts.minor;
      ctx.font = fontString = tickFont.string;
      cache = caches[fontString] = caches[fontString] || {
        data: {},
        gc: []
      };
      lineHeight = tickFont.lineHeight;
      width = height = 0;
      // Undefined labels and arrays should not be measured
      if (!isNullOrUndef(label) && !isArray(label)) {
        width = helpers$1.measureText(ctx, cache.data, cache.gc, width, label);
        height = lineHeight;
      } else if (isArray(label)) {
        // if it is an array let's measure each element
        for (j = 0, jlen = label.length; j < jlen; ++j) {
          nestedLabel = label[j];
          // Undefined labels and arrays should not be measured
          if (!isNullOrUndef(nestedLabel) && !isArray(nestedLabel)) {
            width = helpers$1.measureText(ctx, cache.data, cache.gc, width, nestedLabel);
            height += lineHeight;
          }
        }
      }
      widths.push(width);
      heights.push(height);
      offsets.push(lineHeight / 2);
      widestLabelSize = Math.max(width, widestLabelSize);
      highestLabelSize = Math.max(height, highestLabelSize);
    }
    garbageCollect(caches, length);
    widest = widths.indexOf(widestLabelSize);
    highest = heights.indexOf(highestLabelSize);
    function valueAt(idx) {
      return {
        width: widths[idx] || 0,
        height: heights[idx] || 0,
        offset: offsets[idx] || 0
      };
    }
    return {
      first: valueAt(0),
      last: valueAt(length - 1),
      widest: valueAt(widest),
      highest: valueAt(highest)
    };
  }
  function getTickMarkLength(options) {
    return options.drawTicks ? options.tickMarkLength : 0;
  }
  function getScaleLabelHeight(options) {
    var font, padding;
    if (!options.display) {
      return 0;
    }
    font = helpers$1.options._parseFont(options);
    padding = helpers$1.options.toPadding(options.padding);
    return font.lineHeight + padding.height;
  }
  function parseFontOptions(options, nestedOpts) {
    return helpers$1.extend(helpers$1.options._parseFont({
      fontFamily: valueOrDefault$a(nestedOpts.fontFamily, options.fontFamily),
      fontSize: valueOrDefault$a(nestedOpts.fontSize, options.fontSize),
      fontStyle: valueOrDefault$a(nestedOpts.fontStyle, options.fontStyle),
      lineHeight: valueOrDefault$a(nestedOpts.lineHeight, options.lineHeight)
    }), {
      color: helpers$1.options.resolve([nestedOpts.fontColor, options.fontColor, core_defaults.global.defaultFontColor])
    });
  }
  function parseTickFontOptions(options) {
    var minor = parseFontOptions(options, options.minor);
    var major = options.major.enabled ? parseFontOptions(options, options.major) : minor;
    return {
      minor: minor,
      major: major
    };
  }
  function nonSkipped(ticksToFilter) {
    var filtered = [];
    var item, index, len;
    for (index = 0, len = ticksToFilter.length; index < len; ++index) {
      item = ticksToFilter[index];
      if (typeof item._index !== 'undefined') {
        filtered.push(item);
      }
    }
    return filtered;
  }
  function getEvenSpacing(arr) {
    var len = arr.length;
    var i, diff;
    if (len < 2) {
      return false;
    }
    for (diff = arr[0], i = 1; i < len; ++i) {
      if (arr[i] - arr[i - 1] !== diff) {
        return false;
      }
    }
    return diff;
  }
  function calculateSpacing(majorIndices, ticks, axisLength, ticksLimit) {
    var evenMajorSpacing = getEvenSpacing(majorIndices);
    var spacing = (ticks.length - 1) / ticksLimit;
    var factors, factor, i, ilen;

    // If the major ticks are evenly spaced apart, place the minor ticks
    // so that they divide the major ticks into even chunks
    if (!evenMajorSpacing) {
      return Math.max(spacing, 1);
    }
    factors = helpers$1.math._factorize(evenMajorSpacing);
    for (i = 0, ilen = factors.length - 1; i < ilen; i++) {
      factor = factors[i];
      if (factor > spacing) {
        return factor;
      }
    }
    return Math.max(spacing, 1);
  }
  function getMajorIndices(ticks) {
    var result = [];
    var i, ilen;
    for (i = 0, ilen = ticks.length; i < ilen; i++) {
      if (ticks[i].major) {
        result.push(i);
      }
    }
    return result;
  }
  function skipMajors(ticks, majorIndices, spacing) {
    var count = 0;
    var next = majorIndices[0];
    var i, tick;
    spacing = Math.ceil(spacing);
    for (i = 0; i < ticks.length; i++) {
      tick = ticks[i];
      if (i === next) {
        tick._index = i;
        count++;
        next = majorIndices[count * spacing];
      } else {
        delete tick.label;
      }
    }
  }
  function skip(ticks, spacing, majorStart, majorEnd) {
    var start = valueOrDefault$a(majorStart, 0);
    var end = Math.min(valueOrDefault$a(majorEnd, ticks.length), ticks.length);
    var count = 0;
    var length, i, tick, next;
    spacing = Math.ceil(spacing);
    if (majorEnd) {
      length = majorEnd - majorStart;
      spacing = length / Math.floor(length / spacing);
    }
    next = start;
    while (next < 0) {
      count++;
      next = Math.round(start + count * spacing);
    }
    for (i = Math.max(start, 0); i < end; i++) {
      tick = ticks[i];
      if (i === next) {
        tick._index = i;
        count++;
        next = Math.round(start + count * spacing);
      } else {
        delete tick.label;
      }
    }
  }
  var Scale = core_element.extend({
    zeroLineIndex: 0,
    /**
     * Get the padding needed for the scale
     * @method getPadding
     * @private
     * @returns {Padding} the necessary padding
     */
    getPadding: function getPadding() {
      var me = this;
      return {
        left: me.paddingLeft || 0,
        top: me.paddingTop || 0,
        right: me.paddingRight || 0,
        bottom: me.paddingBottom || 0
      };
    },
    /**
     * Returns the scale tick objects ({label, major})
     * @since 2.7
     */
    getTicks: function getTicks() {
      return this._ticks;
    },
    /**
    * @private
    */
    _getLabels: function _getLabels() {
      var data = this.chart.data;
      return this.options.labels || (this.isHorizontal() ? data.xLabels : data.yLabels) || data.labels || [];
    },
    // These methods are ordered by lifecyle. Utilities then follow.
    // Any function defined here is inherited by all scale types.
    // Any function can be extended by the scale type

    /**
     * Provided for backward compatibility, not available anymore
     * @function Chart.Scale.mergeTicksOptions
     * @deprecated since version 2.8.0
     * @todo remove at version 3
     */
    mergeTicksOptions: function mergeTicksOptions() {
      // noop
    },
    beforeUpdate: function beforeUpdate() {
      helpers$1.callback(this.options.beforeUpdate, [this]);
    },
    /**
     * @param {number} maxWidth - the max width in pixels
     * @param {number} maxHeight - the max height in pixels
     * @param {object} margins - the space between the edge of the other scales and edge of the chart
     *   This space comes from two sources:
     *     - padding - space that's required to show the labels at the edges of the scale
     *     - thickness of scales or legends in another orientation
     */
    update: function update(maxWidth, maxHeight, margins) {
      var me = this;
      var tickOpts = me.options.ticks;
      var sampleSize = tickOpts.sampleSize;
      var i, ilen, labels, ticks, samplingEnabled;

      // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
      me.beforeUpdate();

      // Absorb the master measurements
      me.maxWidth = maxWidth;
      me.maxHeight = maxHeight;
      me.margins = helpers$1.extend({
        left: 0,
        right: 0,
        top: 0,
        bottom: 0
      }, margins);
      me._ticks = null;
      me.ticks = null;
      me._labelSizes = null;
      me._maxLabelLines = 0;
      me.longestLabelWidth = 0;
      me.longestTextCache = me.longestTextCache || {};
      me._gridLineItems = null;
      me._labelItems = null;

      // Dimensions
      me.beforeSetDimensions();
      me.setDimensions();
      me.afterSetDimensions();

      // Data min/max
      me.beforeDataLimits();
      me.determineDataLimits();
      me.afterDataLimits();

      // Ticks - `this.ticks` is now DEPRECATED!
      // Internal ticks are now stored as objects in the PRIVATE `this._ticks` member
      // and must not be accessed directly from outside this class. `this.ticks` being
      // around for long time and not marked as private, we can't change its structure
      // without unexpected breaking changes. If you need to access the scale ticks,
      // use scale.getTicks() instead.

      me.beforeBuildTicks();

      // New implementations should return an array of objects but for BACKWARD COMPAT,
      // we still support no return (`this.ticks` internally set by calling this method).
      ticks = me.buildTicks() || [];

      // Allow modification of ticks in callback.
      ticks = me.afterBuildTicks(ticks) || ticks;

      // Ensure ticks contains ticks in new tick format
      if ((!ticks || !ticks.length) && me.ticks) {
        ticks = [];
        for (i = 0, ilen = me.ticks.length; i < ilen; ++i) {
          ticks.push({
            value: me.ticks[i],
            major: false
          });
        }
      }
      me._ticks = ticks;

      // Compute tick rotation and fit using a sampled subset of labels
      // We generally don't need to compute the size of every single label for determining scale size
      samplingEnabled = sampleSize < ticks.length;
      labels = me._convertTicksToLabels(samplingEnabled ? sample(ticks, sampleSize) : ticks);

      // _configure is called twice, once here, once from core.controller.updateLayout.
      // Here we haven't been positioned yet, but dimensions are correct.
      // Variables set in _configure are needed for calculateTickRotation, and
      // it's ok that coordinates are not correct there, only dimensions matter.
      me._configure();

      // Tick Rotation
      me.beforeCalculateTickRotation();
      me.calculateTickRotation();
      me.afterCalculateTickRotation();
      me.beforeFit();
      me.fit();
      me.afterFit();

      // Auto-skip
      me._ticksToDraw = tickOpts.display && (tickOpts.autoSkip || tickOpts.source === 'auto') ? me._autoSkip(ticks) : ticks;
      if (samplingEnabled) {
        // Generate labels using all non-skipped ticks
        labels = me._convertTicksToLabels(me._ticksToDraw);
      }
      me.ticks = labels; // BACKWARD COMPATIBILITY

      // IMPORTANT: after this point, we consider that `this.ticks` will NEVER change!

      me.afterUpdate();

      // TODO(v3): remove minSize as a public property and return value from all layout boxes. It is unused
      // make maxWidth and maxHeight private
      return me.minSize;
    },
    /**
     * @private
     */
    _configure: function _configure() {
      var me = this;
      var reversePixels = me.options.ticks.reverse;
      var startPixel, endPixel;
      if (me.isHorizontal()) {
        startPixel = me.left;
        endPixel = me.right;
      } else {
        startPixel = me.top;
        endPixel = me.bottom;
        // by default vertical scales are from bottom to top, so pixels are reversed
        reversePixels = !reversePixels;
      }
      me._startPixel = startPixel;
      me._endPixel = endPixel;
      me._reversePixels = reversePixels;
      me._length = endPixel - startPixel;
    },
    afterUpdate: function afterUpdate() {
      helpers$1.callback(this.options.afterUpdate, [this]);
    },
    //

    beforeSetDimensions: function beforeSetDimensions() {
      helpers$1.callback(this.options.beforeSetDimensions, [this]);
    },
    setDimensions: function setDimensions() {
      var me = this;
      // Set the unconstrained dimension before label rotation
      if (me.isHorizontal()) {
        // Reset position before calculating rotation
        me.width = me.maxWidth;
        me.left = 0;
        me.right = me.width;
      } else {
        me.height = me.maxHeight;

        // Reset position before calculating rotation
        me.top = 0;
        me.bottom = me.height;
      }

      // Reset padding
      me.paddingLeft = 0;
      me.paddingTop = 0;
      me.paddingRight = 0;
      me.paddingBottom = 0;
    },
    afterSetDimensions: function afterSetDimensions() {
      helpers$1.callback(this.options.afterSetDimensions, [this]);
    },
    // Data limits
    beforeDataLimits: function beforeDataLimits() {
      helpers$1.callback(this.options.beforeDataLimits, [this]);
    },
    determineDataLimits: helpers$1.noop,
    afterDataLimits: function afterDataLimits() {
      helpers$1.callback(this.options.afterDataLimits, [this]);
    },
    //
    beforeBuildTicks: function beforeBuildTicks() {
      helpers$1.callback(this.options.beforeBuildTicks, [this]);
    },
    buildTicks: helpers$1.noop,
    afterBuildTicks: function afterBuildTicks(ticks) {
      var me = this;
      // ticks is empty for old axis implementations here
      if (isArray(ticks) && ticks.length) {
        return helpers$1.callback(me.options.afterBuildTicks, [me, ticks]);
      }
      // Support old implementations (that modified `this.ticks` directly in buildTicks)
      me.ticks = helpers$1.callback(me.options.afterBuildTicks, [me, me.ticks]) || me.ticks;
      return ticks;
    },
    beforeTickToLabelConversion: function beforeTickToLabelConversion() {
      helpers$1.callback(this.options.beforeTickToLabelConversion, [this]);
    },
    convertTicksToLabels: function convertTicksToLabels() {
      var me = this;
      // Convert ticks to strings
      var tickOpts = me.options.ticks;
      me.ticks = me.ticks.map(tickOpts.userCallback || tickOpts.callback, this);
    },
    afterTickToLabelConversion: function afterTickToLabelConversion() {
      helpers$1.callback(this.options.afterTickToLabelConversion, [this]);
    },
    //

    beforeCalculateTickRotation: function beforeCalculateTickRotation() {
      helpers$1.callback(this.options.beforeCalculateTickRotation, [this]);
    },
    calculateTickRotation: function calculateTickRotation() {
      var me = this;
      var options = me.options;
      var tickOpts = options.ticks;
      var numTicks = me.getTicks().length;
      var minRotation = tickOpts.minRotation || 0;
      var maxRotation = tickOpts.maxRotation;
      var labelRotation = minRotation;
      var labelSizes, maxLabelWidth, maxLabelHeight, maxWidth, tickWidth, maxHeight, maxLabelDiagonal;
      if (!me._isVisible() || !tickOpts.display || minRotation >= maxRotation || numTicks <= 1 || !me.isHorizontal()) {
        me.labelRotation = minRotation;
        return;
      }
      labelSizes = me._getLabelSizes();
      maxLabelWidth = labelSizes.widest.width;
      maxLabelHeight = labelSizes.highest.height - labelSizes.highest.offset;

      // Estimate the width of each grid based on the canvas width, the maximum
      // label width and the number of tick intervals
      maxWidth = Math.min(me.maxWidth, me.chart.width - maxLabelWidth);
      tickWidth = options.offset ? me.maxWidth / numTicks : maxWidth / (numTicks - 1);

      // Allow 3 pixels x2 padding either side for label readability
      if (maxLabelWidth + 6 > tickWidth) {
        tickWidth = maxWidth / (numTicks - (options.offset ? 0.5 : 1));
        maxHeight = me.maxHeight - getTickMarkLength(options.gridLines) - tickOpts.padding - getScaleLabelHeight(options.scaleLabel);
        maxLabelDiagonal = Math.sqrt(maxLabelWidth * maxLabelWidth + maxLabelHeight * maxLabelHeight);
        labelRotation = helpers$1.toDegrees(Math.min(Math.asin(Math.min((labelSizes.highest.height + 6) / tickWidth, 1)), Math.asin(Math.min(maxHeight / maxLabelDiagonal, 1)) - Math.asin(maxLabelHeight / maxLabelDiagonal)));
        labelRotation = Math.max(minRotation, Math.min(maxRotation, labelRotation));
      }
      me.labelRotation = labelRotation;
    },
    afterCalculateTickRotation: function afterCalculateTickRotation() {
      helpers$1.callback(this.options.afterCalculateTickRotation, [this]);
    },
    //

    beforeFit: function beforeFit() {
      helpers$1.callback(this.options.beforeFit, [this]);
    },
    fit: function fit() {
      var me = this;
      // Reset
      var minSize = me.minSize = {
        width: 0,
        height: 0
      };
      var chart = me.chart;
      var opts = me.options;
      var tickOpts = opts.ticks;
      var scaleLabelOpts = opts.scaleLabel;
      var gridLineOpts = opts.gridLines;
      var display = me._isVisible();
      var isBottom = opts.position === 'bottom';
      var isHorizontal = me.isHorizontal();

      // Width
      if (isHorizontal) {
        minSize.width = me.maxWidth;
      } else if (display) {
        minSize.width = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
      }

      // height
      if (!isHorizontal) {
        minSize.height = me.maxHeight; // fill all the height
      } else if (display) {
        minSize.height = getTickMarkLength(gridLineOpts) + getScaleLabelHeight(scaleLabelOpts);
      }

      // Don't bother fitting the ticks if we are not showing the labels
      if (tickOpts.display && display) {
        var tickFonts = parseTickFontOptions(tickOpts);
        var labelSizes = me._getLabelSizes();
        var firstLabelSize = labelSizes.first;
        var lastLabelSize = labelSizes.last;
        var widestLabelSize = labelSizes.widest;
        var highestLabelSize = labelSizes.highest;
        var lineSpace = tickFonts.minor.lineHeight * 0.4;
        var tickPadding = tickOpts.padding;
        if (isHorizontal) {
          // A horizontal axis is more constrained by the height.
          var isRotated = me.labelRotation !== 0;
          var angleRadians = helpers$1.toRadians(me.labelRotation);
          var cosRotation = Math.cos(angleRadians);
          var sinRotation = Math.sin(angleRadians);
          var labelHeight = sinRotation * widestLabelSize.width + cosRotation * (highestLabelSize.height - (isRotated ? highestLabelSize.offset : 0)) + (isRotated ? 0 : lineSpace); // padding

          minSize.height = Math.min(me.maxHeight, minSize.height + labelHeight + tickPadding);
          var offsetLeft = me.getPixelForTick(0) - me.left;
          var offsetRight = me.right - me.getPixelForTick(me.getTicks().length - 1);
          var paddingLeft, paddingRight;

          // Ensure that our ticks are always inside the canvas. When rotated, ticks are right aligned
          // which means that the right padding is dominated by the font height
          if (isRotated) {
            paddingLeft = isBottom ? cosRotation * firstLabelSize.width + sinRotation * firstLabelSize.offset : sinRotation * (firstLabelSize.height - firstLabelSize.offset);
            paddingRight = isBottom ? sinRotation * (lastLabelSize.height - lastLabelSize.offset) : cosRotation * lastLabelSize.width + sinRotation * lastLabelSize.offset;
          } else {
            paddingLeft = firstLabelSize.width / 2;
            paddingRight = lastLabelSize.width / 2;
          }

          // Adjust padding taking into account changes in offsets
          // and add 3 px to move away from canvas edges
          me.paddingLeft = Math.max((paddingLeft - offsetLeft) * me.width / (me.width - offsetLeft), 0) + 3;
          me.paddingRight = Math.max((paddingRight - offsetRight) * me.width / (me.width - offsetRight), 0) + 3;
        } else {
          // A vertical axis is more constrained by the width. Labels are the
          // dominant factor here, so get that length first and account for padding
          var labelWidth = tickOpts.mirror ? 0 :
          // use lineSpace for consistency with horizontal axis
          // tickPadding is not implemented for horizontal
          widestLabelSize.width + tickPadding + lineSpace;
          minSize.width = Math.min(me.maxWidth, minSize.width + labelWidth);
          me.paddingTop = firstLabelSize.height / 2;
          me.paddingBottom = lastLabelSize.height / 2;
        }
      }
      me.handleMargins();
      if (isHorizontal) {
        me.width = me._length = chart.width - me.margins.left - me.margins.right;
        me.height = minSize.height;
      } else {
        me.width = minSize.width;
        me.height = me._length = chart.height - me.margins.top - me.margins.bottom;
      }
    },
    /**
     * Handle margins and padding interactions
     * @private
     */
    handleMargins: function handleMargins() {
      var me = this;
      if (me.margins) {
        me.margins.left = Math.max(me.paddingLeft, me.margins.left);
        me.margins.top = Math.max(me.paddingTop, me.margins.top);
        me.margins.right = Math.max(me.paddingRight, me.margins.right);
        me.margins.bottom = Math.max(me.paddingBottom, me.margins.bottom);
      }
    },
    afterFit: function afterFit() {
      helpers$1.callback(this.options.afterFit, [this]);
    },
    // Shared Methods
    isHorizontal: function isHorizontal() {
      var pos = this.options.position;
      return pos === 'top' || pos === 'bottom';
    },
    isFullWidth: function isFullWidth() {
      return this.options.fullWidth;
    },
    // Get the correct value. NaN bad inputs, If the value type is object get the x or y based on whether we are horizontal or not
    getRightValue: function getRightValue(rawValue) {
      // Null and undefined values first
      if (isNullOrUndef(rawValue)) {
        return NaN;
      }
      // isNaN(object) returns true, so make sure NaN is checking for a number; Discard Infinite values
      if ((typeof rawValue === 'number' || rawValue instanceof Number) && !isFinite(rawValue)) {
        return NaN;
      }

      // If it is in fact an object, dive in one more level
      if (rawValue) {
        if (this.isHorizontal()) {
          if (rawValue.x !== undefined) {
            return this.getRightValue(rawValue.x);
          }
        } else if (rawValue.y !== undefined) {
          return this.getRightValue(rawValue.y);
        }
      }

      // Value is good, return it
      return rawValue;
    },
    _convertTicksToLabels: function _convertTicksToLabels(ticks) {
      var me = this;
      var labels, i, ilen;
      me.ticks = ticks.map(function (tick) {
        return tick.value;
      });
      me.beforeTickToLabelConversion();

      // New implementations should return the formatted tick labels but for BACKWARD
      // COMPAT, we still support no return (`this.ticks` internally changed by calling
      // this method and supposed to contain only string values).
      labels = me.convertTicksToLabels(ticks) || me.ticks;
      me.afterTickToLabelConversion();

      // BACKWARD COMPAT: synchronize `_ticks` with labels (so potentially `this.ticks`)
      for (i = 0, ilen = ticks.length; i < ilen; ++i) {
        ticks[i].label = labels[i];
      }
      return labels;
    },
    /**
     * @private
     */
    _getLabelSizes: function _getLabelSizes() {
      var me = this;
      var labelSizes = me._labelSizes;
      if (!labelSizes) {
        me._labelSizes = labelSizes = computeLabelSizes(me.ctx, parseTickFontOptions(me.options.ticks), me.getTicks(), me.longestTextCache);
        me.longestLabelWidth = labelSizes.widest.width;
      }
      return labelSizes;
    },
    /**
     * @private
     */
    _parseValue: function _parseValue(value) {
      var start, end, min, max;
      if (isArray(value)) {
        start = +this.getRightValue(value[0]);
        end = +this.getRightValue(value[1]);
        min = Math.min(start, end);
        max = Math.max(start, end);
      } else {
        value = +this.getRightValue(value);
        start = undefined;
        end = value;
        min = value;
        max = value;
      }
      return {
        min: min,
        max: max,
        start: start,
        end: end
      };
    },
    /**
    * @private
    */
    _getScaleLabel: function _getScaleLabel(rawValue) {
      var v = this._parseValue(rawValue);
      if (v.start !== undefined) {
        return '[' + v.start + ', ' + v.end + ']';
      }
      return +this.getRightValue(rawValue);
    },
    /**
     * Used to get the value to display in the tooltip for the data at the given index
     * @param index
     * @param datasetIndex
     */
    getLabelForIndex: helpers$1.noop,
    /**
     * Returns the location of the given data point. Value can either be an index or a numerical value
     * The coordinate (0, 0) is at the upper-left corner of the canvas
     * @param value
     * @param index
     * @param datasetIndex
     */
    getPixelForValue: helpers$1.noop,
    /**
     * Used to get the data value from a given pixel. This is the inverse of getPixelForValue
     * The coordinate (0, 0) is at the upper-left corner of the canvas
     * @param pixel
     */
    getValueForPixel: helpers$1.noop,
    /**
     * Returns the location of the tick at the given index
     * The coordinate (0, 0) is at the upper-left corner of the canvas
     */
    getPixelForTick: function getPixelForTick(index) {
      var me = this;
      var offset = me.options.offset;
      var numTicks = me._ticks.length;
      var tickWidth = 1 / Math.max(numTicks - (offset ? 0 : 1), 1);
      return index < 0 || index > numTicks - 1 ? null : me.getPixelForDecimal(index * tickWidth + (offset ? tickWidth / 2 : 0));
    },
    /**
     * Utility for getting the pixel location of a percentage of scale
     * The coordinate (0, 0) is at the upper-left corner of the canvas
     */
    getPixelForDecimal: function getPixelForDecimal(decimal) {
      var me = this;
      if (me._reversePixels) {
        decimal = 1 - decimal;
      }
      return me._startPixel + decimal * me._length;
    },
    getDecimalForPixel: function getDecimalForPixel(pixel) {
      var decimal = (pixel - this._startPixel) / this._length;
      return this._reversePixels ? 1 - decimal : decimal;
    },
    /**
     * Returns the pixel for the minimum chart value
     * The coordinate (0, 0) is at the upper-left corner of the canvas
     */
    getBasePixel: function getBasePixel() {
      return this.getPixelForValue(this.getBaseValue());
    },
    getBaseValue: function getBaseValue() {
      var me = this;
      var min = me.min;
      var max = me.max;
      return me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0;
    },
    /**
     * Returns a subset of ticks to be plotted to avoid overlapping labels.
     * @private
     */
    _autoSkip: function _autoSkip(ticks) {
      var me = this;
      var tickOpts = me.options.ticks;
      var axisLength = me._length;
      var ticksLimit = tickOpts.maxTicksLimit || axisLength / me._tickSize() + 1;
      var majorIndices = tickOpts.major.enabled ? getMajorIndices(ticks) : [];
      var numMajorIndices = majorIndices.length;
      var first = majorIndices[0];
      var last = majorIndices[numMajorIndices - 1];
      var i, ilen, spacing, avgMajorSpacing;

      // If there are too many major ticks to display them all
      if (numMajorIndices > ticksLimit) {
        skipMajors(ticks, majorIndices, numMajorIndices / ticksLimit);
        return nonSkipped(ticks);
      }
      spacing = calculateSpacing(majorIndices, ticks, axisLength, ticksLimit);
      if (numMajorIndices > 0) {
        for (i = 0, ilen = numMajorIndices - 1; i < ilen; i++) {
          skip(ticks, spacing, majorIndices[i], majorIndices[i + 1]);
        }
        avgMajorSpacing = numMajorIndices > 1 ? (last - first) / (numMajorIndices - 1) : null;
        skip(ticks, spacing, helpers$1.isNullOrUndef(avgMajorSpacing) ? 0 : first - avgMajorSpacing, first);
        skip(ticks, spacing, last, helpers$1.isNullOrUndef(avgMajorSpacing) ? ticks.length : last + avgMajorSpacing);
        return nonSkipped(ticks);
      }
      skip(ticks, spacing);
      return nonSkipped(ticks);
    },
    /**
     * @private
     */
    _tickSize: function _tickSize() {
      var me = this;
      var optionTicks = me.options.ticks;

      // Calculate space needed by label in axis direction.
      var rot = helpers$1.toRadians(me.labelRotation);
      var cos = Math.abs(Math.cos(rot));
      var sin = Math.abs(Math.sin(rot));
      var labelSizes = me._getLabelSizes();
      var padding = optionTicks.autoSkipPadding || 0;
      var w = labelSizes ? labelSizes.widest.width + padding : 0;
      var h = labelSizes ? labelSizes.highest.height + padding : 0;

      // Calculate space needed for 1 tick in axis direction.
      return me.isHorizontal() ? h * cos > w * sin ? w / cos : h / sin : h * sin < w * cos ? h / cos : w / sin;
    },
    /**
     * @private
     */
    _isVisible: function _isVisible() {
      var me = this;
      var chart = me.chart;
      var display = me.options.display;
      var i, ilen, meta;
      if (display !== 'auto') {
        return !!display;
      }

      // When 'auto', the scale is visible if at least one associated dataset is visible.
      for (i = 0, ilen = chart.data.datasets.length; i < ilen; ++i) {
        if (chart.isDatasetVisible(i)) {
          meta = chart.getDatasetMeta(i);
          if (meta.xAxisID === me.id || meta.yAxisID === me.id) {
            return true;
          }
        }
      }
      return false;
    },
    /**
     * @private
     */
    _computeGridLineItems: function _computeGridLineItems(chartArea) {
      var me = this;
      var chart = me.chart;
      var options = me.options;
      var gridLines = options.gridLines;
      var position = options.position;
      var offsetGridLines = gridLines.offsetGridLines;
      var isHorizontal = me.isHorizontal();
      var ticks = me._ticksToDraw;
      var ticksLength = ticks.length + (offsetGridLines ? 1 : 0);
      var tl = getTickMarkLength(gridLines);
      var items = [];
      var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
      var axisHalfWidth = axisWidth / 2;
      var alignPixel = helpers$1._alignPixel;
      var alignBorderValue = function alignBorderValue(pixel) {
        return alignPixel(chart, pixel, axisWidth);
      };
      var borderValue, i, tick, lineValue, alignedLineValue;
      var tx1, ty1, tx2, ty2, x1, y1, x2, y2, lineWidth, lineColor, borderDash, borderDashOffset;
      if (position === 'top') {
        borderValue = alignBorderValue(me.bottom);
        ty1 = me.bottom - tl;
        ty2 = borderValue - axisHalfWidth;
        y1 = alignBorderValue(chartArea.top) + axisHalfWidth;
        y2 = chartArea.bottom;
      } else if (position === 'bottom') {
        borderValue = alignBorderValue(me.top);
        y1 = chartArea.top;
        y2 = alignBorderValue(chartArea.bottom) - axisHalfWidth;
        ty1 = borderValue + axisHalfWidth;
        ty2 = me.top + tl;
      } else if (position === 'left') {
        borderValue = alignBorderValue(me.right);
        tx1 = me.right - tl;
        tx2 = borderValue - axisHalfWidth;
        x1 = alignBorderValue(chartArea.left) + axisHalfWidth;
        x2 = chartArea.right;
      } else {
        borderValue = alignBorderValue(me.left);
        x1 = chartArea.left;
        x2 = alignBorderValue(chartArea.right) - axisHalfWidth;
        tx1 = borderValue + axisHalfWidth;
        tx2 = me.left + tl;
      }
      for (i = 0; i < ticksLength; ++i) {
        tick = ticks[i] || {};

        // autoskipper skipped this tick (#4635)
        if (isNullOrUndef(tick.label) && i < ticks.length) {
          continue;
        }
        if (i === me.zeroLineIndex && options.offset === offsetGridLines) {
          // Draw the first index specially
          lineWidth = gridLines.zeroLineWidth;
          lineColor = gridLines.zeroLineColor;
          borderDash = gridLines.zeroLineBorderDash || [];
          borderDashOffset = gridLines.zeroLineBorderDashOffset || 0.0;
        } else {
          lineWidth = valueAtIndexOrDefault(gridLines.lineWidth, i, 1);
          lineColor = valueAtIndexOrDefault(gridLines.color, i, 'rgba(0,0,0,0.1)');
          borderDash = gridLines.borderDash || [];
          borderDashOffset = gridLines.borderDashOffset || 0.0;
        }
        lineValue = getPixelForGridLine(me, tick._index || i, offsetGridLines);

        // Skip if the pixel is out of the range
        if (lineValue === undefined) {
          continue;
        }
        alignedLineValue = alignPixel(chart, lineValue, lineWidth);
        if (isHorizontal) {
          tx1 = tx2 = x1 = x2 = alignedLineValue;
        } else {
          ty1 = ty2 = y1 = y2 = alignedLineValue;
        }
        items.push({
          tx1: tx1,
          ty1: ty1,
          tx2: tx2,
          ty2: ty2,
          x1: x1,
          y1: y1,
          x2: x2,
          y2: y2,
          width: lineWidth,
          color: lineColor,
          borderDash: borderDash,
          borderDashOffset: borderDashOffset
        });
      }
      items.ticksLength = ticksLength;
      items.borderValue = borderValue;
      return items;
    },
    /**
     * @private
     */
    _computeLabelItems: function _computeLabelItems() {
      var me = this;
      var options = me.options;
      var optionTicks = options.ticks;
      var position = options.position;
      var isMirrored = optionTicks.mirror;
      var isHorizontal = me.isHorizontal();
      var ticks = me._ticksToDraw;
      var fonts = parseTickFontOptions(optionTicks);
      var tickPadding = optionTicks.padding;
      var tl = getTickMarkLength(options.gridLines);
      var rotation = -helpers$1.toRadians(me.labelRotation);
      var items = [];
      var i, ilen, tick, label, x, y, textAlign, pixel, font, lineHeight, lineCount, textOffset;
      if (position === 'top') {
        y = me.bottom - tl - tickPadding;
        textAlign = !rotation ? 'center' : 'left';
      } else if (position === 'bottom') {
        y = me.top + tl + tickPadding;
        textAlign = !rotation ? 'center' : 'right';
      } else if (position === 'left') {
        x = me.right - (isMirrored ? 0 : tl) - tickPadding;
        textAlign = isMirrored ? 'left' : 'right';
      } else {
        x = me.left + (isMirrored ? 0 : tl) + tickPadding;
        textAlign = isMirrored ? 'right' : 'left';
      }
      for (i = 0, ilen = ticks.length; i < ilen; ++i) {
        tick = ticks[i];
        label = tick.label;

        // autoskipper skipped this tick (#4635)
        if (isNullOrUndef(label)) {
          continue;
        }
        pixel = me.getPixelForTick(tick._index || i) + optionTicks.labelOffset;
        font = tick.major ? fonts.major : fonts.minor;
        lineHeight = font.lineHeight;
        lineCount = isArray(label) ? label.length : 1;
        if (isHorizontal) {
          x = pixel;
          textOffset = position === 'top' ? ((!rotation ? 0.5 : 1) - lineCount) * lineHeight : (!rotation ? 0.5 : 0) * lineHeight;
        } else {
          y = pixel;
          textOffset = (1 - lineCount) * lineHeight / 2;
        }
        items.push({
          x: x,
          y: y,
          rotation: rotation,
          label: label,
          font: font,
          textOffset: textOffset,
          textAlign: textAlign
        });
      }
      return items;
    },
    /**
     * @private
     */
    _drawGrid: function _drawGrid(chartArea) {
      var me = this;
      var gridLines = me.options.gridLines;
      if (!gridLines.display) {
        return;
      }
      var ctx = me.ctx;
      var chart = me.chart;
      var alignPixel = helpers$1._alignPixel;
      var axisWidth = gridLines.drawBorder ? valueAtIndexOrDefault(gridLines.lineWidth, 0, 0) : 0;
      var items = me._gridLineItems || (me._gridLineItems = me._computeGridLineItems(chartArea));
      var width, color, i, ilen, item;
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        item = items[i];
        width = item.width;
        color = item.color;
        if (width && color) {
          ctx.save();
          ctx.lineWidth = width;
          ctx.strokeStyle = color;
          if (ctx.setLineDash) {
            ctx.setLineDash(item.borderDash);
            ctx.lineDashOffset = item.borderDashOffset;
          }
          ctx.beginPath();
          if (gridLines.drawTicks) {
            ctx.moveTo(item.tx1, item.ty1);
            ctx.lineTo(item.tx2, item.ty2);
          }
          if (gridLines.drawOnChartArea) {
            ctx.moveTo(item.x1, item.y1);
            ctx.lineTo(item.x2, item.y2);
          }
          ctx.stroke();
          ctx.restore();
        }
      }
      if (axisWidth) {
        // Draw the line at the edge of the axis
        var firstLineWidth = axisWidth;
        var lastLineWidth = valueAtIndexOrDefault(gridLines.lineWidth, items.ticksLength - 1, 1);
        var borderValue = items.borderValue;
        var x1, x2, y1, y2;
        if (me.isHorizontal()) {
          x1 = alignPixel(chart, me.left, firstLineWidth) - firstLineWidth / 2;
          x2 = alignPixel(chart, me.right, lastLineWidth) + lastLineWidth / 2;
          y1 = y2 = borderValue;
        } else {
          y1 = alignPixel(chart, me.top, firstLineWidth) - firstLineWidth / 2;
          y2 = alignPixel(chart, me.bottom, lastLineWidth) + lastLineWidth / 2;
          x1 = x2 = borderValue;
        }
        ctx.lineWidth = axisWidth;
        ctx.strokeStyle = valueAtIndexOrDefault(gridLines.color, 0);
        ctx.beginPath();
        ctx.moveTo(x1, y1);
        ctx.lineTo(x2, y2);
        ctx.stroke();
      }
    },
    /**
     * @private
     */
    _drawLabels: function _drawLabels() {
      var me = this;
      var optionTicks = me.options.ticks;
      if (!optionTicks.display) {
        return;
      }
      var ctx = me.ctx;
      var items = me._labelItems || (me._labelItems = me._computeLabelItems());
      var i, j, ilen, jlen, item, tickFont, label, y;
      for (i = 0, ilen = items.length; i < ilen; ++i) {
        item = items[i];
        tickFont = item.font;

        // Make sure we draw text in the correct color and font
        ctx.save();
        ctx.translate(item.x, item.y);
        ctx.rotate(item.rotation);
        ctx.font = tickFont.string;
        ctx.fillStyle = tickFont.color;
        ctx.textBaseline = 'middle';
        ctx.textAlign = item.textAlign;
        label = item.label;
        y = item.textOffset;
        if (isArray(label)) {
          for (j = 0, jlen = label.length; j < jlen; ++j) {
            // We just make sure the multiline element is a string here..
            ctx.fillText('' + label[j], 0, y);
            y += tickFont.lineHeight;
          }
        } else {
          ctx.fillText(label, 0, y);
        }
        ctx.restore();
      }
    },
    /**
     * @private
     */
    _drawTitle: function _drawTitle() {
      var me = this;
      var ctx = me.ctx;
      var options = me.options;
      var scaleLabel = options.scaleLabel;
      if (!scaleLabel.display) {
        return;
      }
      var scaleLabelFontColor = valueOrDefault$a(scaleLabel.fontColor, core_defaults.global.defaultFontColor);
      var scaleLabelFont = helpers$1.options._parseFont(scaleLabel);
      var scaleLabelPadding = helpers$1.options.toPadding(scaleLabel.padding);
      var halfLineHeight = scaleLabelFont.lineHeight / 2;
      var position = options.position;
      var rotation = 0;
      var scaleLabelX, scaleLabelY;
      if (me.isHorizontal()) {
        scaleLabelX = me.left + me.width / 2; // midpoint of the width
        scaleLabelY = position === 'bottom' ? me.bottom - halfLineHeight - scaleLabelPadding.bottom : me.top + halfLineHeight + scaleLabelPadding.top;
      } else {
        var isLeft = position === 'left';
        scaleLabelX = isLeft ? me.left + halfLineHeight + scaleLabelPadding.top : me.right - halfLineHeight - scaleLabelPadding.top;
        scaleLabelY = me.top + me.height / 2;
        rotation = isLeft ? -0.5 * Math.PI : 0.5 * Math.PI;
      }
      ctx.save();
      ctx.translate(scaleLabelX, scaleLabelY);
      ctx.rotate(rotation);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      ctx.fillStyle = scaleLabelFontColor; // render in correct colour
      ctx.font = scaleLabelFont.string;
      ctx.fillText(scaleLabel.labelString, 0, 0);
      ctx.restore();
    },
    draw: function draw(chartArea) {
      var me = this;
      if (!me._isVisible()) {
        return;
      }
      me._drawGrid(chartArea);
      me._drawTitle();
      me._drawLabels();
    },
    /**
     * @private
     */
    _layers: function _layers() {
      var me = this;
      var opts = me.options;
      var tz = opts.ticks && opts.ticks.z || 0;
      var gz = opts.gridLines && opts.gridLines.z || 0;
      if (!me._isVisible() || tz === gz || me.draw !== me._draw) {
        // backward compatibility: draw has been overridden by custom scale
        return [{
          z: tz,
          draw: function draw() {
            me.draw.apply(me, arguments);
          }
        }];
      }
      return [{
        z: gz,
        draw: function draw() {
          me._drawGrid.apply(me, arguments);
          me._drawTitle.apply(me, arguments);
        }
      }, {
        z: tz,
        draw: function draw() {
          me._drawLabels.apply(me, arguments);
        }
      }];
    },
    /**
     * @private
     */
    _getMatchingVisibleMetas: function _getMatchingVisibleMetas(type) {
      var me = this;
      var isHorizontal = me.isHorizontal();
      return me.chart._getSortedVisibleDatasetMetas().filter(function (meta) {
        return (!type || meta.type === type) && (isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id);
      });
    }
  });
  Scale.prototype._draw = Scale.prototype.draw;
  var core_scale = Scale;
  var isNullOrUndef$1 = helpers$1.isNullOrUndef;
  var defaultConfig = {
    position: 'bottom'
  };
  var scale_category = core_scale.extend({
    determineDataLimits: function determineDataLimits() {
      var me = this;
      var labels = me._getLabels();
      var ticksOpts = me.options.ticks;
      var min = ticksOpts.min;
      var max = ticksOpts.max;
      var minIndex = 0;
      var maxIndex = labels.length - 1;
      var findIndex;
      if (min !== undefined) {
        // user specified min value
        findIndex = labels.indexOf(min);
        if (findIndex >= 0) {
          minIndex = findIndex;
        }
      }
      if (max !== undefined) {
        // user specified max value
        findIndex = labels.indexOf(max);
        if (findIndex >= 0) {
          maxIndex = findIndex;
        }
      }
      me.minIndex = minIndex;
      me.maxIndex = maxIndex;
      me.min = labels[minIndex];
      me.max = labels[maxIndex];
    },
    buildTicks: function buildTicks() {
      var me = this;
      var labels = me._getLabels();
      var minIndex = me.minIndex;
      var maxIndex = me.maxIndex;

      // If we are viewing some subset of labels, slice the original array
      me.ticks = minIndex === 0 && maxIndex === labels.length - 1 ? labels : labels.slice(minIndex, maxIndex + 1);
    },
    getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
      var me = this;
      var chart = me.chart;
      if (chart.getDatasetMeta(datasetIndex).controller._getValueScaleId() === me.id) {
        return me.getRightValue(chart.data.datasets[datasetIndex].data[index]);
      }
      return me._getLabels()[index];
    },
    _configure: function _configure() {
      var me = this;
      var offset = me.options.offset;
      var ticks = me.ticks;
      core_scale.prototype._configure.call(me);
      if (!me.isHorizontal()) {
        // For backward compatibility, vertical category scale reverse is inverted.
        me._reversePixels = !me._reversePixels;
      }
      if (!ticks) {
        return;
      }
      me._startValue = me.minIndex - (offset ? 0.5 : 0);
      me._valueRange = Math.max(ticks.length - (offset ? 0 : 1), 1);
    },
    // Used to get data value locations.  Value can either be an index or a numerical value
    getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
      var me = this;
      var valueCategory, labels, idx;
      if (!isNullOrUndef$1(index) && !isNullOrUndef$1(datasetIndex)) {
        value = me.chart.data.datasets[datasetIndex].data[index];
      }

      // If value is a data object, then index is the index in the data array,
      // not the index of the scale. We need to change that.
      if (!isNullOrUndef$1(value)) {
        valueCategory = me.isHorizontal() ? value.x : value.y;
      }
      if (valueCategory !== undefined || value !== undefined && isNaN(index)) {
        labels = me._getLabels();
        value = helpers$1.valueOrDefault(valueCategory, value);
        idx = labels.indexOf(value);
        index = idx !== -1 ? idx : index;
        if (isNaN(index)) {
          index = value;
        }
      }
      return me.getPixelForDecimal((index - me._startValue) / me._valueRange);
    },
    getPixelForTick: function getPixelForTick(index) {
      var ticks = this.ticks;
      return index < 0 || index > ticks.length - 1 ? null : this.getPixelForValue(ticks[index], index + this.minIndex);
    },
    getValueForPixel: function getValueForPixel(pixel) {
      var me = this;
      var value = Math.round(me._startValue + me.getDecimalForPixel(pixel) * me._valueRange);
      return Math.min(Math.max(value, 0), me.ticks.length - 1);
    },
    getBasePixel: function getBasePixel() {
      return this.bottom;
    }
  });

  // INTERNAL: static default options, registered in src/index.js
  var _defaults = defaultConfig;
  scale_category._defaults = _defaults;
  var noop = helpers$1.noop;
  var isNullOrUndef$2 = helpers$1.isNullOrUndef;

  /**
   * Generate a set of linear ticks
   * @param generationOptions the options used to generate the ticks
   * @param dataRange the range of the data
   * @returns {number[]} array of tick values
   */
  function generateTicks(generationOptions, dataRange) {
    var ticks = [];
    // To get a "nice" value for the tick spacing, we will use the appropriately named
    // "nice number" algorithm. See https://stackoverflow.com/questions/8506881/nice-label-algorithm-for-charts-with-minimum-ticks
    // for details.

    var MIN_SPACING = 1e-14;
    var stepSize = generationOptions.stepSize;
    var unit = stepSize || 1;
    var maxNumSpaces = generationOptions.maxTicks - 1;
    var min = generationOptions.min;
    var max = generationOptions.max;
    var precision = generationOptions.precision;
    var rmin = dataRange.min;
    var rmax = dataRange.max;
    var spacing = helpers$1.niceNum((rmax - rmin) / maxNumSpaces / unit) * unit;
    var factor, niceMin, niceMax, numSpaces;

    // Beyond MIN_SPACING floating point numbers being to lose precision
    // such that we can't do the math necessary to generate ticks
    if (spacing < MIN_SPACING && isNullOrUndef$2(min) && isNullOrUndef$2(max)) {
      return [rmin, rmax];
    }
    numSpaces = Math.ceil(rmax / spacing) - Math.floor(rmin / spacing);
    if (numSpaces > maxNumSpaces) {
      // If the calculated num of spaces exceeds maxNumSpaces, recalculate it
      spacing = helpers$1.niceNum(numSpaces * spacing / maxNumSpaces / unit) * unit;
    }
    if (stepSize || isNullOrUndef$2(precision)) {
      // If a precision is not specified, calculate factor based on spacing
      factor = Math.pow(10, helpers$1._decimalPlaces(spacing));
    } else {
      // If the user specified a precision, round to that number of decimal places
      factor = Math.pow(10, precision);
      spacing = Math.ceil(spacing * factor) / factor;
    }
    niceMin = Math.floor(rmin / spacing) * spacing;
    niceMax = Math.ceil(rmax / spacing) * spacing;

    // If min, max and stepSize is set and they make an evenly spaced scale use it.
    if (stepSize) {
      // If very close to our whole number, use it.
      if (!isNullOrUndef$2(min) && helpers$1.almostWhole(min / spacing, spacing / 1000)) {
        niceMin = min;
      }
      if (!isNullOrUndef$2(max) && helpers$1.almostWhole(max / spacing, spacing / 1000)) {
        niceMax = max;
      }
    }
    numSpaces = (niceMax - niceMin) / spacing;
    // If very close to our rounded value, use it.
    if (helpers$1.almostEquals(numSpaces, Math.round(numSpaces), spacing / 1000)) {
      numSpaces = Math.round(numSpaces);
    } else {
      numSpaces = Math.ceil(numSpaces);
    }
    niceMin = Math.round(niceMin * factor) / factor;
    niceMax = Math.round(niceMax * factor) / factor;
    ticks.push(isNullOrUndef$2(min) ? niceMin : min);
    for (var j = 1; j < numSpaces; ++j) {
      ticks.push(Math.round((niceMin + j * spacing) * factor) / factor);
    }
    ticks.push(isNullOrUndef$2(max) ? niceMax : max);
    return ticks;
  }
  var scale_linearbase = core_scale.extend({
    getRightValue: function getRightValue(value) {
      if (typeof value === 'string') {
        return +value;
      }
      return core_scale.prototype.getRightValue.call(this, value);
    },
    handleTickRangeOptions: function handleTickRangeOptions() {
      var me = this;
      var opts = me.options;
      var tickOpts = opts.ticks;

      // If we are forcing it to begin at 0, but 0 will already be rendered on the chart,
      // do nothing since that would make the chart weird. If the user really wants a weird chart
      // axis, they can manually override it
      if (tickOpts.beginAtZero) {
        var minSign = helpers$1.sign(me.min);
        var maxSign = helpers$1.sign(me.max);
        if (minSign < 0 && maxSign < 0) {
          // move the top up to 0
          me.max = 0;
        } else if (minSign > 0 && maxSign > 0) {
          // move the bottom down to 0
          me.min = 0;
        }
      }
      var setMin = tickOpts.min !== undefined || tickOpts.suggestedMin !== undefined;
      var setMax = tickOpts.max !== undefined || tickOpts.suggestedMax !== undefined;
      if (tickOpts.min !== undefined) {
        me.min = tickOpts.min;
      } else if (tickOpts.suggestedMin !== undefined) {
        if (me.min === null) {
          me.min = tickOpts.suggestedMin;
        } else {
          me.min = Math.min(me.min, tickOpts.suggestedMin);
        }
      }
      if (tickOpts.max !== undefined) {
        me.max = tickOpts.max;
      } else if (tickOpts.suggestedMax !== undefined) {
        if (me.max === null) {
          me.max = tickOpts.suggestedMax;
        } else {
          me.max = Math.max(me.max, tickOpts.suggestedMax);
        }
      }
      if (setMin !== setMax) {
        // We set the min or the max but not both.
        // So ensure that our range is good
        // Inverted or 0 length range can happen when
        // ticks.min is set, and no datasets are visible
        if (me.min >= me.max) {
          if (setMin) {
            me.max = me.min + 1;
          } else {
            me.min = me.max - 1;
          }
        }
      }
      if (me.min === me.max) {
        me.max++;
        if (!tickOpts.beginAtZero) {
          me.min--;
        }
      }
    },
    getTickLimit: function getTickLimit() {
      var me = this;
      var tickOpts = me.options.ticks;
      var stepSize = tickOpts.stepSize;
      var maxTicksLimit = tickOpts.maxTicksLimit;
      var maxTicks;
      if (stepSize) {
        maxTicks = Math.ceil(me.max / stepSize) - Math.floor(me.min / stepSize) + 1;
      } else {
        maxTicks = me._computeTickLimit();
        maxTicksLimit = maxTicksLimit || 11;
      }
      if (maxTicksLimit) {
        maxTicks = Math.min(maxTicksLimit, maxTicks);
      }
      return maxTicks;
    },
    _computeTickLimit: function _computeTickLimit() {
      return Number.POSITIVE_INFINITY;
    },
    handleDirectionalChanges: noop,
    buildTicks: function buildTicks() {
      var me = this;
      var opts = me.options;
      var tickOpts = opts.ticks;

      // Figure out what the max number of ticks we can support it is based on the size of
      // the axis area. For now, we say that the minimum tick spacing in pixels must be 40
      // We also limit the maximum number of ticks to 11 which gives a nice 10 squares on
      // the graph. Make sure we always have at least 2 ticks
      var maxTicks = me.getTickLimit();
      maxTicks = Math.max(2, maxTicks);
      var numericGeneratorOptions = {
        maxTicks: maxTicks,
        min: tickOpts.min,
        max: tickOpts.max,
        precision: tickOpts.precision,
        stepSize: helpers$1.valueOrDefault(tickOpts.fixedStepSize, tickOpts.stepSize)
      };
      var ticks = me.ticks = generateTicks(numericGeneratorOptions, me);
      me.handleDirectionalChanges();

      // At this point, we need to update our max and min given the tick values since we have expanded the
      // range of the scale
      me.max = helpers$1.max(ticks);
      me.min = helpers$1.min(ticks);
      if (tickOpts.reverse) {
        ticks.reverse();
        me.start = me.max;
        me.end = me.min;
      } else {
        me.start = me.min;
        me.end = me.max;
      }
    },
    convertTicksToLabels: function convertTicksToLabels() {
      var me = this;
      me.ticksAsNumbers = me.ticks.slice();
      me.zeroLineIndex = me.ticks.indexOf(0);
      core_scale.prototype.convertTicksToLabels.call(me);
    },
    _configure: function _configure() {
      var me = this;
      var ticks = me.getTicks();
      var start = me.min;
      var end = me.max;
      var offset;
      core_scale.prototype._configure.call(me);
      if (me.options.offset && ticks.length) {
        offset = (end - start) / Math.max(ticks.length - 1, 1) / 2;
        start -= offset;
        end += offset;
      }
      me._startValue = start;
      me._endValue = end;
      me._valueRange = end - start;
    }
  });
  var defaultConfig$1 = {
    position: 'left',
    ticks: {
      callback: core_ticks.formatters.linear
    }
  };
  var DEFAULT_MIN = 0;
  var DEFAULT_MAX = 1;
  function getOrCreateStack(stacks, stacked, meta) {
    var key = [meta.type,
    // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
    stacked === undefined && meta.stack === undefined ? meta.index : '', meta.stack].join('.');
    if (stacks[key] === undefined) {
      stacks[key] = {
        pos: [],
        neg: []
      };
    }
    return stacks[key];
  }
  function stackData(scale, stacks, meta, data) {
    var opts = scale.options;
    var stacked = opts.stacked;
    var stack = getOrCreateStack(stacks, stacked, meta);
    var pos = stack.pos;
    var neg = stack.neg;
    var ilen = data.length;
    var i, value;
    for (i = 0; i < ilen; ++i) {
      value = scale._parseValue(data[i]);
      if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
        continue;
      }
      pos[i] = pos[i] || 0;
      neg[i] = neg[i] || 0;
      if (opts.relativePoints) {
        pos[i] = 100;
      } else if (value.min < 0 || value.max < 0) {
        neg[i] += value.min;
      } else {
        pos[i] += value.max;
      }
    }
  }
  function updateMinMax(scale, meta, data) {
    var ilen = data.length;
    var i, value;
    for (i = 0; i < ilen; ++i) {
      value = scale._parseValue(data[i]);
      if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden) {
        continue;
      }
      scale.min = Math.min(scale.min, value.min);
      scale.max = Math.max(scale.max, value.max);
    }
  }
  var scale_linear = scale_linearbase.extend({
    determineDataLimits: function determineDataLimits() {
      var me = this;
      var opts = me.options;
      var chart = me.chart;
      var datasets = chart.data.datasets;
      var metasets = me._getMatchingVisibleMetas();
      var hasStacks = opts.stacked;
      var stacks = {};
      var ilen = metasets.length;
      var i, meta, data, values;
      me.min = Number.POSITIVE_INFINITY;
      me.max = Number.NEGATIVE_INFINITY;
      if (hasStacks === undefined) {
        for (i = 0; !hasStacks && i < ilen; ++i) {
          meta = metasets[i];
          hasStacks = meta.stack !== undefined;
        }
      }
      for (i = 0; i < ilen; ++i) {
        meta = metasets[i];
        data = datasets[meta.index].data;
        if (hasStacks) {
          stackData(me, stacks, meta, data);
        } else {
          updateMinMax(me, meta, data);
        }
      }
      helpers$1.each(stacks, function (stackValues) {
        values = stackValues.pos.concat(stackValues.neg);
        me.min = Math.min(me.min, helpers$1.min(values));
        me.max = Math.max(me.max, helpers$1.max(values));
      });
      me.min = helpers$1.isFinite(me.min) && !isNaN(me.min) ? me.min : DEFAULT_MIN;
      me.max = helpers$1.isFinite(me.max) && !isNaN(me.max) ? me.max : DEFAULT_MAX;

      // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
      me.handleTickRangeOptions();
    },
    // Returns the maximum number of ticks based on the scale dimension
    _computeTickLimit: function _computeTickLimit() {
      var me = this;
      var tickFont;
      if (me.isHorizontal()) {
        return Math.ceil(me.width / 40);
      }
      tickFont = helpers$1.options._parseFont(me.options.ticks);
      return Math.ceil(me.height / tickFont.lineHeight);
    },
    // Called after the ticks are built. We need
    handleDirectionalChanges: function handleDirectionalChanges() {
      if (!this.isHorizontal()) {
        // We are in a vertical orientation. The top value is the highest. So reverse the array
        this.ticks.reverse();
      }
    },
    getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
      return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
    },
    // Utils
    getPixelForValue: function getPixelForValue(value) {
      var me = this;
      return me.getPixelForDecimal((+me.getRightValue(value) - me._startValue) / me._valueRange);
    },
    getValueForPixel: function getValueForPixel(pixel) {
      return this._startValue + this.getDecimalForPixel(pixel) * this._valueRange;
    },
    getPixelForTick: function getPixelForTick(index) {
      var ticks = this.ticksAsNumbers;
      if (index < 0 || index > ticks.length - 1) {
        return null;
      }
      return this.getPixelForValue(ticks[index]);
    }
  });

  // INTERNAL: static default options, registered in src/index.js
  var _defaults$1 = defaultConfig$1;
  scale_linear._defaults = _defaults$1;
  var valueOrDefault$b = helpers$1.valueOrDefault;
  var log10 = helpers$1.math.log10;

  /**
   * Generate a set of logarithmic ticks
   * @param generationOptions the options used to generate the ticks
   * @param dataRange the range of the data
   * @returns {number[]} array of tick values
   */
  function generateTicks$1(generationOptions, dataRange) {
    var ticks = [];
    var tickVal = valueOrDefault$b(generationOptions.min, Math.pow(10, Math.floor(log10(dataRange.min))));
    var endExp = Math.floor(log10(dataRange.max));
    var endSignificand = Math.ceil(dataRange.max / Math.pow(10, endExp));
    var exp, significand;
    if (tickVal === 0) {
      exp = Math.floor(log10(dataRange.minNotZero));
      significand = Math.floor(dataRange.minNotZero / Math.pow(10, exp));
      ticks.push(tickVal);
      tickVal = significand * Math.pow(10, exp);
    } else {
      exp = Math.floor(log10(tickVal));
      significand = Math.floor(tickVal / Math.pow(10, exp));
    }
    var precision = exp < 0 ? Math.pow(10, Math.abs(exp)) : 1;
    do {
      ticks.push(tickVal);
      ++significand;
      if (significand === 10) {
        significand = 1;
        ++exp;
        precision = exp >= 0 ? 1 : precision;
      }
      tickVal = Math.round(significand * Math.pow(10, exp) * precision) / precision;
    } while (exp < endExp || exp === endExp && significand < endSignificand);
    var lastTick = valueOrDefault$b(generationOptions.max, tickVal);
    ticks.push(lastTick);
    return ticks;
  }
  var defaultConfig$2 = {
    position: 'left',
    // label settings
    ticks: {
      callback: core_ticks.formatters.logarithmic
    }
  };

  // TODO(v3): change this to positiveOrDefault
  function nonNegativeOrDefault(value, defaultValue) {
    return helpers$1.isFinite(value) && value >= 0 ? value : defaultValue;
  }
  var scale_logarithmic = core_scale.extend({
    determineDataLimits: function determineDataLimits() {
      var me = this;
      var opts = me.options;
      var chart = me.chart;
      var datasets = chart.data.datasets;
      var isHorizontal = me.isHorizontal();
      function IDMatches(meta) {
        return isHorizontal ? meta.xAxisID === me.id : meta.yAxisID === me.id;
      }
      var datasetIndex, meta, value, data, i, ilen;

      // Calculate Range
      me.min = Number.POSITIVE_INFINITY;
      me.max = Number.NEGATIVE_INFINITY;
      me.minNotZero = Number.POSITIVE_INFINITY;
      var hasStacks = opts.stacked;
      if (hasStacks === undefined) {
        for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
          meta = chart.getDatasetMeta(datasetIndex);
          if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta) && meta.stack !== undefined) {
            hasStacks = true;
            break;
          }
        }
      }
      if (opts.stacked || hasStacks) {
        var valuesPerStack = {};
        for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
          meta = chart.getDatasetMeta(datasetIndex);
          var key = [meta.type,
          // we have a separate stack for stack=undefined datasets when the opts.stacked is undefined
          opts.stacked === undefined && meta.stack === undefined ? datasetIndex : '', meta.stack].join('.');
          if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
            if (valuesPerStack[key] === undefined) {
              valuesPerStack[key] = [];
            }
            data = datasets[datasetIndex].data;
            for (i = 0, ilen = data.length; i < ilen; i++) {
              var values = valuesPerStack[key];
              value = me._parseValue(data[i]);
              // invalid, hidden and negative values are ignored
              if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
                continue;
              }
              values[i] = values[i] || 0;
              values[i] += value.max;
            }
          }
        }
        helpers$1.each(valuesPerStack, function (valuesForType) {
          if (valuesForType.length > 0) {
            var minVal = helpers$1.min(valuesForType);
            var maxVal = helpers$1.max(valuesForType);
            me.min = Math.min(me.min, minVal);
            me.max = Math.max(me.max, maxVal);
          }
        });
      } else {
        for (datasetIndex = 0; datasetIndex < datasets.length; datasetIndex++) {
          meta = chart.getDatasetMeta(datasetIndex);
          if (chart.isDatasetVisible(datasetIndex) && IDMatches(meta)) {
            data = datasets[datasetIndex].data;
            for (i = 0, ilen = data.length; i < ilen; i++) {
              value = me._parseValue(data[i]);
              // invalid, hidden and negative values are ignored
              if (isNaN(value.min) || isNaN(value.max) || meta.data[i].hidden || value.min < 0 || value.max < 0) {
                continue;
              }
              me.min = Math.min(value.min, me.min);
              me.max = Math.max(value.max, me.max);
              if (value.min !== 0) {
                me.minNotZero = Math.min(value.min, me.minNotZero);
              }
            }
          }
        }
      }
      me.min = helpers$1.isFinite(me.min) ? me.min : null;
      me.max = helpers$1.isFinite(me.max) ? me.max : null;
      me.minNotZero = helpers$1.isFinite(me.minNotZero) ? me.minNotZero : null;

      // Common base implementation to handle ticks.min, ticks.max
      this.handleTickRangeOptions();
    },
    handleTickRangeOptions: function handleTickRangeOptions() {
      var me = this;
      var tickOpts = me.options.ticks;
      var DEFAULT_MIN = 1;
      var DEFAULT_MAX = 10;
      me.min = nonNegativeOrDefault(tickOpts.min, me.min);
      me.max = nonNegativeOrDefault(tickOpts.max, me.max);
      if (me.min === me.max) {
        if (me.min !== 0 && me.min !== null) {
          me.min = Math.pow(10, Math.floor(log10(me.min)) - 1);
          me.max = Math.pow(10, Math.floor(log10(me.max)) + 1);
        } else {
          me.min = DEFAULT_MIN;
          me.max = DEFAULT_MAX;
        }
      }
      if (me.min === null) {
        me.min = Math.pow(10, Math.floor(log10(me.max)) - 1);
      }
      if (me.max === null) {
        me.max = me.min !== 0 ? Math.pow(10, Math.floor(log10(me.min)) + 1) : DEFAULT_MAX;
      }
      if (me.minNotZero === null) {
        if (me.min > 0) {
          me.minNotZero = me.min;
        } else if (me.max < 1) {
          me.minNotZero = Math.pow(10, Math.floor(log10(me.max)));
        } else {
          me.minNotZero = DEFAULT_MIN;
        }
      }
    },
    buildTicks: function buildTicks() {
      var me = this;
      var tickOpts = me.options.ticks;
      var reverse = !me.isHorizontal();
      var generationOptions = {
        min: nonNegativeOrDefault(tickOpts.min),
        max: nonNegativeOrDefault(tickOpts.max)
      };
      var ticks = me.ticks = generateTicks$1(generationOptions, me);

      // At this point, we need to update our max and min given the tick values since we have expanded the
      // range of the scale
      me.max = helpers$1.max(ticks);
      me.min = helpers$1.min(ticks);
      if (tickOpts.reverse) {
        reverse = !reverse;
        me.start = me.max;
        me.end = me.min;
      } else {
        me.start = me.min;
        me.end = me.max;
      }
      if (reverse) {
        ticks.reverse();
      }
    },
    convertTicksToLabels: function convertTicksToLabels() {
      this.tickValues = this.ticks.slice();
      core_scale.prototype.convertTicksToLabels.call(this);
    },
    // Get the correct tooltip label
    getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
      return this._getScaleLabel(this.chart.data.datasets[datasetIndex].data[index]);
    },
    getPixelForTick: function getPixelForTick(index) {
      var ticks = this.tickValues;
      if (index < 0 || index > ticks.length - 1) {
        return null;
      }
      return this.getPixelForValue(ticks[index]);
    },
    /**
     * Returns the value of the first tick.
     * @param {number} value - The minimum not zero value.
     * @return {number} The first tick value.
     * @private
     */
    _getFirstTickValue: function _getFirstTickValue(value) {
      var exp = Math.floor(log10(value));
      var significand = Math.floor(value / Math.pow(10, exp));
      return significand * Math.pow(10, exp);
    },
    _configure: function _configure() {
      var me = this;
      var start = me.min;
      var offset = 0;
      core_scale.prototype._configure.call(me);
      if (start === 0) {
        start = me._getFirstTickValue(me.minNotZero);
        offset = valueOrDefault$b(me.options.ticks.fontSize, core_defaults.global.defaultFontSize) / me._length;
      }
      me._startValue = log10(start);
      me._valueOffset = offset;
      me._valueRange = (log10(me.max) - log10(start)) / (1 - offset);
    },
    getPixelForValue: function getPixelForValue(value) {
      var me = this;
      var decimal = 0;
      value = +me.getRightValue(value);
      if (value > me.min && value > 0) {
        decimal = (log10(value) - me._startValue) / me._valueRange + me._valueOffset;
      }
      return me.getPixelForDecimal(decimal);
    },
    getValueForPixel: function getValueForPixel(pixel) {
      var me = this;
      var decimal = me.getDecimalForPixel(pixel);
      return decimal === 0 && me.min === 0 ? 0 : Math.pow(10, me._startValue + (decimal - me._valueOffset) * me._valueRange);
    }
  });

  // INTERNAL: static default options, registered in src/index.js
  var _defaults$2 = defaultConfig$2;
  scale_logarithmic._defaults = _defaults$2;
  var valueOrDefault$c = helpers$1.valueOrDefault;
  var valueAtIndexOrDefault$1 = helpers$1.valueAtIndexOrDefault;
  var resolve$4 = helpers$1.options.resolve;
  var defaultConfig$3 = {
    display: true,
    // Boolean - Whether to animate scaling the chart from the centre
    animate: true,
    position: 'chartArea',
    angleLines: {
      display: true,
      color: 'rgba(0,0,0,0.1)',
      lineWidth: 1,
      borderDash: [],
      borderDashOffset: 0.0
    },
    gridLines: {
      circular: false
    },
    // label settings
    ticks: {
      // Boolean - Show a backdrop to the scale label
      showLabelBackdrop: true,
      // String - The colour of the label backdrop
      backdropColor: 'rgba(255,255,255,0.75)',
      // Number - The backdrop padding above & below the label in pixels
      backdropPaddingY: 2,
      // Number - The backdrop padding to the side of the label in pixels
      backdropPaddingX: 2,
      callback: core_ticks.formatters.linear
    },
    pointLabels: {
      // Boolean - if true, show point labels
      display: true,
      // Number - Point label font size in pixels
      fontSize: 10,
      // Function - Used to convert point labels
      callback: function callback(label) {
        return label;
      }
    }
  };
  function getTickBackdropHeight(opts) {
    var tickOpts = opts.ticks;
    if (tickOpts.display && opts.display) {
      return valueOrDefault$c(tickOpts.fontSize, core_defaults.global.defaultFontSize) + tickOpts.backdropPaddingY * 2;
    }
    return 0;
  }
  function measureLabelSize(ctx, lineHeight, label) {
    if (helpers$1.isArray(label)) {
      return {
        w: helpers$1.longestText(ctx, ctx.font, label),
        h: label.length * lineHeight
      };
    }
    return {
      w: ctx.measureText(label).width,
      h: lineHeight
    };
  }
  function determineLimits(angle, pos, size, min, max) {
    if (angle === min || angle === max) {
      return {
        start: pos - size / 2,
        end: pos + size / 2
      };
    } else if (angle < min || angle > max) {
      return {
        start: pos - size,
        end: pos
      };
    }
    return {
      start: pos,
      end: pos + size
    };
  }

  /**
   * Helper function to fit a radial linear scale with point labels
   */
  function fitWithPointLabels(scale) {
    // Right, this is really confusing and there is a lot of maths going on here
    // The gist of the problem is here: https://gist.github.com/nnnick/696cc9c55f4b0beb8fe9
    //
    // Reaction: https://dl.dropboxusercontent.com/u/34601363/toomuchscience.gif
    //
    // Solution:
    //
    // We assume the radius of the polygon is half the size of the canvas at first
    // at each index we check if the text overlaps.
    //
    // Where it does, we store that angle and that index.
    //
    // After finding the largest index and angle we calculate how much we need to remove
    // from the shape radius to move the point inwards by that x.
    //
    // We average the left and right distances to get the maximum shape radius that can fit in the box
    // along with labels.
    //
    // Once we have that, we can find the centre point for the chart, by taking the x text protrusion
    // on each side, removing that from the size, halving it and adding the left x protrusion width.
    //
    // This will mean we have a shape fitted to the canvas, as large as it can be with the labels
    // and position it in the most space efficient manner
    //
    // https://dl.dropboxusercontent.com/u/34601363/yeahscience.gif

    var plFont = helpers$1.options._parseFont(scale.options.pointLabels);

    // Get maximum radius of the polygon. Either half the height (minus the text width) or half the width.
    // Use this to calculate the offset + change. - Make sure L/R protrusion is at least 0 to stop issues with centre points
    var furthestLimits = {
      l: 0,
      r: scale.width,
      t: 0,
      b: scale.height - scale.paddingTop
    };
    var furthestAngles = {};
    var i, textSize, pointPosition;
    scale.ctx.font = plFont.string;
    scale._pointLabelSizes = [];
    var valueCount = scale.chart.data.labels.length;
    for (i = 0; i < valueCount; i++) {
      pointPosition = scale.getPointPosition(i, scale.drawingArea + 5);
      textSize = measureLabelSize(scale.ctx, plFont.lineHeight, scale.pointLabels[i]);
      scale._pointLabelSizes[i] = textSize;

      // Add quarter circle to make degree 0 mean top of circle
      var angleRadians = scale.getIndexAngle(i);
      var angle = helpers$1.toDegrees(angleRadians) % 360;
      var hLimits = determineLimits(angle, pointPosition.x, textSize.w, 0, 180);
      var vLimits = determineLimits(angle, pointPosition.y, textSize.h, 90, 270);
      if (hLimits.start < furthestLimits.l) {
        furthestLimits.l = hLimits.start;
        furthestAngles.l = angleRadians;
      }
      if (hLimits.end > furthestLimits.r) {
        furthestLimits.r = hLimits.end;
        furthestAngles.r = angleRadians;
      }
      if (vLimits.start < furthestLimits.t) {
        furthestLimits.t = vLimits.start;
        furthestAngles.t = angleRadians;
      }
      if (vLimits.end > furthestLimits.b) {
        furthestLimits.b = vLimits.end;
        furthestAngles.b = angleRadians;
      }
    }
    scale.setReductions(scale.drawingArea, furthestLimits, furthestAngles);
  }
  function getTextAlignForAngle(angle) {
    if (angle === 0 || angle === 180) {
      return 'center';
    } else if (angle < 180) {
      return 'left';
    }
    return 'right';
  }
  function fillText(ctx, text, position, lineHeight) {
    var y = position.y + lineHeight / 2;
    var i, ilen;
    if (helpers$1.isArray(text)) {
      for (i = 0, ilen = text.length; i < ilen; ++i) {
        ctx.fillText(text[i], position.x, y);
        y += lineHeight;
      }
    } else {
      ctx.fillText(text, position.x, y);
    }
  }
  function adjustPointPositionForLabelHeight(angle, textSize, position) {
    if (angle === 90 || angle === 270) {
      position.y -= textSize.h / 2;
    } else if (angle > 270 || angle < 90) {
      position.y -= textSize.h;
    }
  }
  function drawPointLabels(scale) {
    var ctx = scale.ctx;
    var opts = scale.options;
    var pointLabelOpts = opts.pointLabels;
    var tickBackdropHeight = getTickBackdropHeight(opts);
    var outerDistance = scale.getDistanceFromCenterForValue(opts.ticks.reverse ? scale.min : scale.max);
    var plFont = helpers$1.options._parseFont(pointLabelOpts);
    ctx.save();
    ctx.font = plFont.string;
    ctx.textBaseline = 'middle';
    for (var i = scale.chart.data.labels.length - 1; i >= 0; i--) {
      // Extra pixels out for some label spacing
      var extra = i === 0 ? tickBackdropHeight / 2 : 0;
      var pointLabelPosition = scale.getPointPosition(i, outerDistance + extra + 5);

      // Keep this in loop since we may support array properties here
      var pointLabelFontColor = valueAtIndexOrDefault$1(pointLabelOpts.fontColor, i, core_defaults.global.defaultFontColor);
      ctx.fillStyle = pointLabelFontColor;
      var angleRadians = scale.getIndexAngle(i);
      var angle = helpers$1.toDegrees(angleRadians);
      ctx.textAlign = getTextAlignForAngle(angle);
      adjustPointPositionForLabelHeight(angle, scale._pointLabelSizes[i], pointLabelPosition);
      fillText(ctx, scale.pointLabels[i], pointLabelPosition, plFont.lineHeight);
    }
    ctx.restore();
  }
  function drawRadiusLine(scale, gridLineOpts, radius, index) {
    var ctx = scale.ctx;
    var circular = gridLineOpts.circular;
    var valueCount = scale.chart.data.labels.length;
    var lineColor = valueAtIndexOrDefault$1(gridLineOpts.color, index - 1);
    var lineWidth = valueAtIndexOrDefault$1(gridLineOpts.lineWidth, index - 1);
    var pointPosition;
    if (!circular && !valueCount || !lineColor || !lineWidth) {
      return;
    }
    ctx.save();
    ctx.strokeStyle = lineColor;
    ctx.lineWidth = lineWidth;
    if (ctx.setLineDash) {
      ctx.setLineDash(gridLineOpts.borderDash || []);
      ctx.lineDashOffset = gridLineOpts.borderDashOffset || 0.0;
    }
    ctx.beginPath();
    if (circular) {
      // Draw circular arcs between the points
      ctx.arc(scale.xCenter, scale.yCenter, radius, 0, Math.PI * 2);
    } else {
      // Draw straight lines connecting each index
      pointPosition = scale.getPointPosition(0, radius);
      ctx.moveTo(pointPosition.x, pointPosition.y);
      for (var i = 1; i < valueCount; i++) {
        pointPosition = scale.getPointPosition(i, radius);
        ctx.lineTo(pointPosition.x, pointPosition.y);
      }
    }
    ctx.closePath();
    ctx.stroke();
    ctx.restore();
  }
  function numberOrZero(param) {
    return helpers$1.isNumber(param) ? param : 0;
  }
  var scale_radialLinear = scale_linearbase.extend({
    setDimensions: function setDimensions() {
      var me = this;

      // Set the unconstrained dimension before label rotation
      me.width = me.maxWidth;
      me.height = me.maxHeight;
      me.paddingTop = getTickBackdropHeight(me.options) / 2;
      me.xCenter = Math.floor(me.width / 2);
      me.yCenter = Math.floor((me.height - me.paddingTop) / 2);
      me.drawingArea = Math.min(me.height - me.paddingTop, me.width) / 2;
    },
    determineDataLimits: function determineDataLimits() {
      var me = this;
      var chart = me.chart;
      var min = Number.POSITIVE_INFINITY;
      var max = Number.NEGATIVE_INFINITY;
      helpers$1.each(chart.data.datasets, function (dataset, datasetIndex) {
        if (chart.isDatasetVisible(datasetIndex)) {
          var meta = chart.getDatasetMeta(datasetIndex);
          helpers$1.each(dataset.data, function (rawValue, index) {
            var value = +me.getRightValue(rawValue);
            if (isNaN(value) || meta.data[index].hidden) {
              return;
            }
            min = Math.min(value, min);
            max = Math.max(value, max);
          });
        }
      });
      me.min = min === Number.POSITIVE_INFINITY ? 0 : min;
      me.max = max === Number.NEGATIVE_INFINITY ? 0 : max;

      // Common base implementation to handle ticks.min, ticks.max, ticks.beginAtZero
      me.handleTickRangeOptions();
    },
    // Returns the maximum number of ticks based on the scale dimension
    _computeTickLimit: function _computeTickLimit() {
      return Math.ceil(this.drawingArea / getTickBackdropHeight(this.options));
    },
    convertTicksToLabels: function convertTicksToLabels() {
      var me = this;
      scale_linearbase.prototype.convertTicksToLabels.call(me);

      // Point labels
      me.pointLabels = me.chart.data.labels.map(function () {
        var label = helpers$1.callback(me.options.pointLabels.callback, arguments, me);
        return label || label === 0 ? label : '';
      });
    },
    getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
      return +this.getRightValue(this.chart.data.datasets[datasetIndex].data[index]);
    },
    fit: function fit() {
      var me = this;
      var opts = me.options;
      if (opts.display && opts.pointLabels.display) {
        fitWithPointLabels(me);
      } else {
        me.setCenterPoint(0, 0, 0, 0);
      }
    },
    /**
     * Set radius reductions and determine new radius and center point
     * @private
     */
    setReductions: function setReductions(largestPossibleRadius, furthestLimits, furthestAngles) {
      var me = this;
      var radiusReductionLeft = furthestLimits.l / Math.sin(furthestAngles.l);
      var radiusReductionRight = Math.max(furthestLimits.r - me.width, 0) / Math.sin(furthestAngles.r);
      var radiusReductionTop = -furthestLimits.t / Math.cos(furthestAngles.t);
      var radiusReductionBottom = -Math.max(furthestLimits.b - (me.height - me.paddingTop), 0) / Math.cos(furthestAngles.b);
      radiusReductionLeft = numberOrZero(radiusReductionLeft);
      radiusReductionRight = numberOrZero(radiusReductionRight);
      radiusReductionTop = numberOrZero(radiusReductionTop);
      radiusReductionBottom = numberOrZero(radiusReductionBottom);
      me.drawingArea = Math.min(Math.floor(largestPossibleRadius - (radiusReductionLeft + radiusReductionRight) / 2), Math.floor(largestPossibleRadius - (radiusReductionTop + radiusReductionBottom) / 2));
      me.setCenterPoint(radiusReductionLeft, radiusReductionRight, radiusReductionTop, radiusReductionBottom);
    },
    setCenterPoint: function setCenterPoint(leftMovement, rightMovement, topMovement, bottomMovement) {
      var me = this;
      var maxRight = me.width - rightMovement - me.drawingArea;
      var maxLeft = leftMovement + me.drawingArea;
      var maxTop = topMovement + me.drawingArea;
      var maxBottom = me.height - me.paddingTop - bottomMovement - me.drawingArea;
      me.xCenter = Math.floor((maxLeft + maxRight) / 2 + me.left);
      me.yCenter = Math.floor((maxTop + maxBottom) / 2 + me.top + me.paddingTop);
    },
    getIndexAngle: function getIndexAngle(index) {
      var chart = this.chart;
      var angleMultiplier = 360 / chart.data.labels.length;
      var options = chart.options || {};
      var startAngle = options.startAngle || 0;

      // Start from the top instead of right, so remove a quarter of the circle
      var angle = (index * angleMultiplier + startAngle) % 360;
      return (angle < 0 ? angle + 360 : angle) * Math.PI * 2 / 360;
    },
    getDistanceFromCenterForValue: function getDistanceFromCenterForValue(value) {
      var me = this;
      if (helpers$1.isNullOrUndef(value)) {
        return NaN;
      }

      // Take into account half font size + the yPadding of the top value
      var scalingFactor = me.drawingArea / (me.max - me.min);
      if (me.options.ticks.reverse) {
        return (me.max - value) * scalingFactor;
      }
      return (value - me.min) * scalingFactor;
    },
    getPointPosition: function getPointPosition(index, distanceFromCenter) {
      var me = this;
      var thisAngle = me.getIndexAngle(index) - Math.PI / 2;
      return {
        x: Math.cos(thisAngle) * distanceFromCenter + me.xCenter,
        y: Math.sin(thisAngle) * distanceFromCenter + me.yCenter
      };
    },
    getPointPositionForValue: function getPointPositionForValue(index, value) {
      return this.getPointPosition(index, this.getDistanceFromCenterForValue(value));
    },
    getBasePosition: function getBasePosition(index) {
      var me = this;
      var min = me.min;
      var max = me.max;
      return me.getPointPositionForValue(index || 0, me.beginAtZero ? 0 : min < 0 && max < 0 ? max : min > 0 && max > 0 ? min : 0);
    },
    /**
     * @private
     */
    _drawGrid: function _drawGrid() {
      var me = this;
      var ctx = me.ctx;
      var opts = me.options;
      var gridLineOpts = opts.gridLines;
      var angleLineOpts = opts.angleLines;
      var lineWidth = valueOrDefault$c(angleLineOpts.lineWidth, gridLineOpts.lineWidth);
      var lineColor = valueOrDefault$c(angleLineOpts.color, gridLineOpts.color);
      var i, offset, position;
      if (opts.pointLabels.display) {
        drawPointLabels(me);
      }
      if (gridLineOpts.display) {
        helpers$1.each(me.ticks, function (label, index) {
          if (index !== 0) {
            offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
            drawRadiusLine(me, gridLineOpts, offset, index);
          }
        });
      }
      if (angleLineOpts.display && lineWidth && lineColor) {
        ctx.save();
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = lineColor;
        if (ctx.setLineDash) {
          ctx.setLineDash(resolve$4([angleLineOpts.borderDash, gridLineOpts.borderDash, []]));
          ctx.lineDashOffset = resolve$4([angleLineOpts.borderDashOffset, gridLineOpts.borderDashOffset, 0.0]);
        }
        for (i = me.chart.data.labels.length - 1; i >= 0; i--) {
          offset = me.getDistanceFromCenterForValue(opts.ticks.reverse ? me.min : me.max);
          position = me.getPointPosition(i, offset);
          ctx.beginPath();
          ctx.moveTo(me.xCenter, me.yCenter);
          ctx.lineTo(position.x, position.y);
          ctx.stroke();
        }
        ctx.restore();
      }
    },
    /**
     * @private
     */
    _drawLabels: function _drawLabels() {
      var me = this;
      var ctx = me.ctx;
      var opts = me.options;
      var tickOpts = opts.ticks;
      if (!tickOpts.display) {
        return;
      }
      var startAngle = me.getIndexAngle(0);
      var tickFont = helpers$1.options._parseFont(tickOpts);
      var tickFontColor = valueOrDefault$c(tickOpts.fontColor, core_defaults.global.defaultFontColor);
      var offset, width;
      ctx.save();
      ctx.font = tickFont.string;
      ctx.translate(me.xCenter, me.yCenter);
      ctx.rotate(startAngle);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      helpers$1.each(me.ticks, function (label, index) {
        if (index === 0 && !tickOpts.reverse) {
          return;
        }
        offset = me.getDistanceFromCenterForValue(me.ticksAsNumbers[index]);
        if (tickOpts.showLabelBackdrop) {
          width = ctx.measureText(label).width;
          ctx.fillStyle = tickOpts.backdropColor;
          ctx.fillRect(-width / 2 - tickOpts.backdropPaddingX, -offset - tickFont.size / 2 - tickOpts.backdropPaddingY, width + tickOpts.backdropPaddingX * 2, tickFont.size + tickOpts.backdropPaddingY * 2);
        }
        ctx.fillStyle = tickFontColor;
        ctx.fillText(label, 0, -offset);
      });
      ctx.restore();
    },
    /**
     * @private
     */
    _drawTitle: helpers$1.noop
  });

  // INTERNAL: static default options, registered in src/index.js
  var _defaults$3 = defaultConfig$3;
  scale_radialLinear._defaults = _defaults$3;
  var deprecated$1 = helpers$1._deprecated;
  var resolve$5 = helpers$1.options.resolve;
  var valueOrDefault$d = helpers$1.valueOrDefault;

  // Integer constants are from the ES6 spec.
  var MIN_INTEGER = Number.MIN_SAFE_INTEGER || -9007199254740991;
  var MAX_INTEGER = Number.MAX_SAFE_INTEGER || 9007199254740991;
  var INTERVALS = {
    millisecond: {
      common: true,
      size: 1,
      steps: 1000
    },
    second: {
      common: true,
      size: 1000,
      steps: 60
    },
    minute: {
      common: true,
      size: 60000,
      steps: 60
    },
    hour: {
      common: true,
      size: 3600000,
      steps: 24
    },
    day: {
      common: true,
      size: 86400000,
      steps: 30
    },
    week: {
      common: false,
      size: 604800000,
      steps: 4
    },
    month: {
      common: true,
      size: 2.628e9,
      steps: 12
    },
    quarter: {
      common: false,
      size: 7.884e9,
      steps: 4
    },
    year: {
      common: true,
      size: 3.154e10
    }
  };
  var UNITS = Object.keys(INTERVALS);
  function sorter(a, b) {
    return a - b;
  }
  function arrayUnique(items) {
    var hash = {};
    var out = [];
    var i, ilen, item;
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      item = items[i];
      if (!hash[item]) {
        hash[item] = true;
        out.push(item);
      }
    }
    return out;
  }
  function getMin(options) {
    return helpers$1.valueOrDefault(options.time.min, options.ticks.min);
  }
  function getMax(options) {
    return helpers$1.valueOrDefault(options.time.max, options.ticks.max);
  }

  /**
   * Returns an array of {time, pos} objects used to interpolate a specific `time` or position
   * (`pos`) on the scale, by searching entries before and after the requested value. `pos` is
   * a decimal between 0 and 1: 0 being the start of the scale (left or top) and 1 the other
   * extremity (left + width or top + height). Note that it would be more optimized to directly
   * store pre-computed pixels, but the scale dimensions are not guaranteed at the time we need
   * to create the lookup table. The table ALWAYS contains at least two items: min and max.
   *
   * @param {number[]} timestamps - timestamps sorted from lowest to highest.
   * @param {string} distribution - If 'linear', timestamps will be spread linearly along the min
   * and max range, so basically, the table will contains only two items: {min, 0} and {max, 1}.
   * If 'series', timestamps will be positioned at the same distance from each other. In this
   * case, only timestamps that break the time linearity are registered, meaning that in the
   * best case, all timestamps are linear, the table contains only min and max.
   */
  function buildLookupTable(timestamps, min, max, distribution) {
    if (distribution === 'linear' || !timestamps.length) {
      return [{
        time: min,
        pos: 0
      }, {
        time: max,
        pos: 1
      }];
    }
    var table = [];
    var items = [min];
    var i, ilen, prev, curr, next;
    for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
      curr = timestamps[i];
      if (curr > min && curr < max) {
        items.push(curr);
      }
    }
    items.push(max);
    for (i = 0, ilen = items.length; i < ilen; ++i) {
      next = items[i + 1];
      prev = items[i - 1];
      curr = items[i];

      // only add points that breaks the scale linearity
      if (prev === undefined || next === undefined || Math.round((next + prev) / 2) !== curr) {
        table.push({
          time: curr,
          pos: i / (ilen - 1)
        });
      }
    }
    return table;
  }

  // @see adapted from https://www.anujgakhar.com/2014/03/01/binary-search-in-javascript/
  function lookup(table, key, value) {
    var lo = 0;
    var hi = table.length - 1;
    var mid, i0, i1;
    while (lo >= 0 && lo <= hi) {
      mid = lo + hi >> 1;
      i0 = table[mid - 1] || null;
      i1 = table[mid];
      if (!i0) {
        // given value is outside table (before first item)
        return {
          lo: null,
          hi: i1
        };
      } else if (i1[key] < value) {
        lo = mid + 1;
      } else if (i0[key] > value) {
        hi = mid - 1;
      } else {
        return {
          lo: i0,
          hi: i1
        };
      }
    }

    // given value is outside table (after last item)
    return {
      lo: i1,
      hi: null
    };
  }

  /**
   * Linearly interpolates the given source `value` using the table items `skey` values and
   * returns the associated `tkey` value. For example, interpolate(table, 'time', 42, 'pos')
   * returns the position for a timestamp equal to 42. If value is out of bounds, values at
   * index [0, 1] or [n - 1, n] are used for the interpolation.
   */
  function interpolate$1(table, skey, sval, tkey) {
    var range = lookup(table, skey, sval);

    // Note: the lookup table ALWAYS contains at least 2 items (min and max)
    var prev = !range.lo ? table[0] : !range.hi ? table[table.length - 2] : range.lo;
    var next = !range.lo ? table[1] : !range.hi ? table[table.length - 1] : range.hi;
    var span = next[skey] - prev[skey];
    var ratio = span ? (sval - prev[skey]) / span : 0;
    var offset = (next[tkey] - prev[tkey]) * ratio;
    return prev[tkey] + offset;
  }
  function toTimestamp(scale, input) {
    var adapter = scale._adapter;
    var options = scale.options.time;
    var parser = options.parser;
    var format = parser || options.format;
    var value = input;
    if (typeof parser === 'function') {
      value = parser(value);
    }

    // Only parse if its not a timestamp already
    if (!helpers$1.isFinite(value)) {
      value = typeof format === 'string' ? adapter.parse(value, format) : adapter.parse(value);
    }
    if (value !== null) {
      return +value;
    }

    // Labels are in an incompatible format and no `parser` has been provided.
    // The user might still use the deprecated `format` option for parsing.
    if (!parser && typeof format === 'function') {
      value = format(input);

      // `format` could return something else than a timestamp, if so, parse it
      if (!helpers$1.isFinite(value)) {
        value = adapter.parse(value);
      }
    }
    return value;
  }
  function parse(scale, input) {
    if (helpers$1.isNullOrUndef(input)) {
      return null;
    }
    var options = scale.options.time;
    var value = toTimestamp(scale, scale.getRightValue(input));
    if (value === null) {
      return value;
    }
    if (options.round) {
      value = +scale._adapter.startOf(value, options.round);
    }
    return value;
  }

  /**
   * Figures out what unit results in an appropriate number of auto-generated ticks
   */
  function determineUnitForAutoTicks(minUnit, min, max, capacity) {
    var ilen = UNITS.length;
    var i, interval, factor;
    for (i = UNITS.indexOf(minUnit); i < ilen - 1; ++i) {
      interval = INTERVALS[UNITS[i]];
      factor = interval.steps ? interval.steps : MAX_INTEGER;
      if (interval.common && Math.ceil((max - min) / (factor * interval.size)) <= capacity) {
        return UNITS[i];
      }
    }
    return UNITS[ilen - 1];
  }

  /**
   * Figures out what unit to format a set of ticks with
   */
  function determineUnitForFormatting(scale, numTicks, minUnit, min, max) {
    var i, unit;
    for (i = UNITS.length - 1; i >= UNITS.indexOf(minUnit); i--) {
      unit = UNITS[i];
      if (INTERVALS[unit].common && scale._adapter.diff(max, min, unit) >= numTicks - 1) {
        return unit;
      }
    }
    return UNITS[minUnit ? UNITS.indexOf(minUnit) : 0];
  }
  function determineMajorUnit(unit) {
    for (var i = UNITS.indexOf(unit) + 1, ilen = UNITS.length; i < ilen; ++i) {
      if (INTERVALS[UNITS[i]].common) {
        return UNITS[i];
      }
    }
  }

  /**
   * Generates a maximum of `capacity` timestamps between min and max, rounded to the
   * `minor` unit using the given scale time `options`.
   * Important: this method can return ticks outside the min and max range, it's the
   * responsibility of the calling code to clamp values if needed.
   */
  function generate(scale, min, max, capacity) {
    var adapter = scale._adapter;
    var options = scale.options;
    var timeOpts = options.time;
    var minor = timeOpts.unit || determineUnitForAutoTicks(timeOpts.minUnit, min, max, capacity);
    var stepSize = resolve$5([timeOpts.stepSize, timeOpts.unitStepSize, 1]);
    var weekday = minor === 'week' ? timeOpts.isoWeekday : false;
    var first = min;
    var ticks = [];
    var time;

    // For 'week' unit, handle the first day of week option
    if (weekday) {
      first = +adapter.startOf(first, 'isoWeek', weekday);
    }

    // Align first ticks on unit
    first = +adapter.startOf(first, weekday ? 'day' : minor);

    // Prevent browser from freezing in case user options request millions of milliseconds
    if (adapter.diff(max, min, minor) > 100000 * stepSize) {
      throw min + ' and ' + max + ' are too far apart with stepSize of ' + stepSize + ' ' + minor;
    }
    for (time = first; time < max; time = +adapter.add(time, stepSize, minor)) {
      ticks.push(time);
    }
    if (time === max || options.bounds === 'ticks') {
      ticks.push(time);
    }
    return ticks;
  }

  /**
   * Returns the start and end offsets from edges in the form of {start, end}
   * where each value is a relative width to the scale and ranges between 0 and 1.
   * They add extra margins on the both sides by scaling down the original scale.
   * Offsets are added when the `offset` option is true.
   */
  function computeOffsets(table, ticks, min, max, options) {
    var start = 0;
    var end = 0;
    var first, last;
    if (options.offset && ticks.length) {
      first = interpolate$1(table, 'time', ticks[0], 'pos');
      if (ticks.length === 1) {
        start = 1 - first;
      } else {
        start = (interpolate$1(table, 'time', ticks[1], 'pos') - first) / 2;
      }
      last = interpolate$1(table, 'time', ticks[ticks.length - 1], 'pos');
      if (ticks.length === 1) {
        end = last;
      } else {
        end = (last - interpolate$1(table, 'time', ticks[ticks.length - 2], 'pos')) / 2;
      }
    }
    return {
      start: start,
      end: end,
      factor: 1 / (start + 1 + end)
    };
  }
  function setMajorTicks(scale, ticks, map, majorUnit) {
    var adapter = scale._adapter;
    var first = +adapter.startOf(ticks[0].value, majorUnit);
    var last = ticks[ticks.length - 1].value;
    var major, index;
    for (major = first; major <= last; major = +adapter.add(major, 1, majorUnit)) {
      index = map[major];
      if (index >= 0) {
        ticks[index].major = true;
      }
    }
    return ticks;
  }
  function ticksFromTimestamps(scale, values, majorUnit) {
    var ticks = [];
    var map = {};
    var ilen = values.length;
    var i, value;
    for (i = 0; i < ilen; ++i) {
      value = values[i];
      map[value] = i;
      ticks.push({
        value: value,
        major: false
      });
    }

    // We set the major ticks separately from the above loop because calling startOf for every tick
    // is expensive when there is a large number of ticks
    return ilen === 0 || !majorUnit ? ticks : setMajorTicks(scale, ticks, map, majorUnit);
  }
  var defaultConfig$4 = {
    position: 'bottom',
    /**
     * Data distribution along the scale:
     * - 'linear': data are spread according to their time (distances can vary),
     * - 'series': data are spread at the same distance from each other.
     * @see https://github.com/chartjs/Chart.js/pull/4507
     * @since 2.7.0
     */
    distribution: 'linear',
    /**
     * Scale boundary strategy (bypassed by min/max time options)
     * - `data`: make sure data are fully visible, ticks outside are removed
     * - `ticks`: make sure ticks are fully visible, data outside are truncated
     * @see https://github.com/chartjs/Chart.js/pull/4556
     * @since 2.7.0
     */
    bounds: 'data',
    adapters: {},
    time: {
      parser: false,
      // false == a pattern string from https://momentjs.com/docs/#/parsing/string-format/ or a custom callback that converts its argument to a moment
      unit: false,
      // false == automatic or override with week, month, year, etc.
      round: false,
      // none, or override with week, month, year, etc.
      displayFormat: false,
      // DEPRECATED
      isoWeekday: false,
      // override week start day - see https://momentjs.com/docs/#/get-set/iso-weekday/
      minUnit: 'millisecond',
      displayFormats: {}
    },
    ticks: {
      autoSkip: false,
      /**
       * Ticks generation input values:
       * - 'auto': generates "optimal" ticks based on scale size and time options.
       * - 'data': generates ticks from data (including labels from data {t|x|y} objects).
       * - 'labels': generates ticks from user given `data.labels` values ONLY.
       * @see https://github.com/chartjs/Chart.js/pull/4507
       * @since 2.7.0
       */
      source: 'auto',
      major: {
        enabled: false
      }
    }
  };
  var scale_time = core_scale.extend({
    initialize: function initialize() {
      this.mergeTicksOptions();
      core_scale.prototype.initialize.call(this);
    },
    update: function update() {
      var me = this;
      var options = me.options;
      var time = options.time || (options.time = {});
      var adapter = me._adapter = new core_adapters._date(options.adapters.date);

      // DEPRECATIONS: output a message only one time per update
      deprecated$1('time scale', time.format, 'time.format', 'time.parser');
      deprecated$1('time scale', time.min, 'time.min', 'ticks.min');
      deprecated$1('time scale', time.max, 'time.max', 'ticks.max');

      // Backward compatibility: before introducing adapter, `displayFormats` was
      // supposed to contain *all* unit/string pairs but this can't be resolved
      // when loading the scale (adapters are loaded afterward), so let's populate
      // missing formats on update
      helpers$1.mergeIf(time.displayFormats, adapter.formats());
      return core_scale.prototype.update.apply(me, arguments);
    },
    /**
     * Allows data to be referenced via 't' attribute
     */
    getRightValue: function getRightValue(rawValue) {
      if (rawValue && rawValue.t !== undefined) {
        rawValue = rawValue.t;
      }
      return core_scale.prototype.getRightValue.call(this, rawValue);
    },
    determineDataLimits: function determineDataLimits() {
      var me = this;
      var chart = me.chart;
      var adapter = me._adapter;
      var options = me.options;
      var unit = options.time.unit || 'day';
      var min = MAX_INTEGER;
      var max = MIN_INTEGER;
      var timestamps = [];
      var datasets = [];
      var labels = [];
      var i, j, ilen, jlen, data, timestamp, labelsAdded;
      var dataLabels = me._getLabels();
      for (i = 0, ilen = dataLabels.length; i < ilen; ++i) {
        labels.push(parse(me, dataLabels[i]));
      }
      for (i = 0, ilen = (chart.data.datasets || []).length; i < ilen; ++i) {
        if (chart.isDatasetVisible(i)) {
          data = chart.data.datasets[i].data;

          // Let's consider that all data have the same format.
          if (helpers$1.isObject(data[0])) {
            datasets[i] = [];
            for (j = 0, jlen = data.length; j < jlen; ++j) {
              timestamp = parse(me, data[j]);
              timestamps.push(timestamp);
              datasets[i][j] = timestamp;
            }
          } else {
            datasets[i] = labels.slice(0);
            if (!labelsAdded) {
              timestamps = timestamps.concat(labels);
              labelsAdded = true;
            }
          }
        } else {
          datasets[i] = [];
        }
      }
      if (labels.length) {
        min = Math.min(min, labels[0]);
        max = Math.max(max, labels[labels.length - 1]);
      }
      if (timestamps.length) {
        timestamps = ilen > 1 ? arrayUnique(timestamps).sort(sorter) : timestamps.sort(sorter);
        min = Math.min(min, timestamps[0]);
        max = Math.max(max, timestamps[timestamps.length - 1]);
      }
      min = parse(me, getMin(options)) || min;
      max = parse(me, getMax(options)) || max;

      // In case there is no valid min/max, set limits based on unit time option
      min = min === MAX_INTEGER ? +adapter.startOf(Date.now(), unit) : min;
      max = max === MIN_INTEGER ? +adapter.endOf(Date.now(), unit) + 1 : max;

      // Make sure that max is strictly higher than min (required by the lookup table)
      me.min = Math.min(min, max);
      me.max = Math.max(min + 1, max);

      // PRIVATE
      me._table = [];
      me._timestamps = {
        data: timestamps,
        datasets: datasets,
        labels: labels
      };
    },
    buildTicks: function buildTicks() {
      var me = this;
      var min = me.min;
      var max = me.max;
      var options = me.options;
      var tickOpts = options.ticks;
      var timeOpts = options.time;
      var timestamps = me._timestamps;
      var ticks = [];
      var capacity = me.getLabelCapacity(min);
      var source = tickOpts.source;
      var distribution = options.distribution;
      var i, ilen, timestamp;
      if (source === 'data' || source === 'auto' && distribution === 'series') {
        timestamps = timestamps.data;
      } else if (source === 'labels') {
        timestamps = timestamps.labels;
      } else {
        timestamps = generate(me, min, max, capacity);
      }
      if (options.bounds === 'ticks' && timestamps.length) {
        min = timestamps[0];
        max = timestamps[timestamps.length - 1];
      }

      // Enforce limits with user min/max options
      min = parse(me, getMin(options)) || min;
      max = parse(me, getMax(options)) || max;

      // Remove ticks outside the min/max range
      for (i = 0, ilen = timestamps.length; i < ilen; ++i) {
        timestamp = timestamps[i];
        if (timestamp >= min && timestamp <= max) {
          ticks.push(timestamp);
        }
      }
      me.min = min;
      me.max = max;

      // PRIVATE
      // determineUnitForFormatting relies on the number of ticks so we don't use it when
      // autoSkip is enabled because we don't yet know what the final number of ticks will be
      me._unit = timeOpts.unit || (tickOpts.autoSkip ? determineUnitForAutoTicks(timeOpts.minUnit, me.min, me.max, capacity) : determineUnitForFormatting(me, ticks.length, timeOpts.minUnit, me.min, me.max));
      me._majorUnit = !tickOpts.major.enabled || me._unit === 'year' ? undefined : determineMajorUnit(me._unit);
      me._table = buildLookupTable(me._timestamps.data, min, max, distribution);
      me._offsets = computeOffsets(me._table, ticks, min, max, options);
      if (tickOpts.reverse) {
        ticks.reverse();
      }
      return ticksFromTimestamps(me, ticks, me._majorUnit);
    },
    getLabelForIndex: function getLabelForIndex(index, datasetIndex) {
      var me = this;
      var adapter = me._adapter;
      var data = me.chart.data;
      var timeOpts = me.options.time;
      var label = data.labels && index < data.labels.length ? data.labels[index] : '';
      var value = data.datasets[datasetIndex].data[index];
      if (helpers$1.isObject(value)) {
        label = me.getRightValue(value);
      }
      if (timeOpts.tooltipFormat) {
        return adapter.format(toTimestamp(me, label), timeOpts.tooltipFormat);
      }
      if (typeof label === 'string') {
        return label;
      }
      return adapter.format(toTimestamp(me, label), timeOpts.displayFormats.datetime);
    },
    /**
     * Function to format an individual tick mark
     * @private
     */
    tickFormatFunction: function tickFormatFunction(time, index, ticks, format) {
      var me = this;
      var adapter = me._adapter;
      var options = me.options;
      var formats = options.time.displayFormats;
      var minorFormat = formats[me._unit];
      var majorUnit = me._majorUnit;
      var majorFormat = formats[majorUnit];
      var tick = ticks[index];
      var tickOpts = options.ticks;
      var major = majorUnit && majorFormat && tick && tick.major;
      var label = adapter.format(time, format ? format : major ? majorFormat : minorFormat);
      var nestedTickOpts = major ? tickOpts.major : tickOpts.minor;
      var formatter = resolve$5([nestedTickOpts.callback, nestedTickOpts.userCallback, tickOpts.callback, tickOpts.userCallback]);
      return formatter ? formatter(label, index, ticks) : label;
    },
    convertTicksToLabels: function convertTicksToLabels(ticks) {
      var labels = [];
      var i, ilen;
      for (i = 0, ilen = ticks.length; i < ilen; ++i) {
        labels.push(this.tickFormatFunction(ticks[i].value, i, ticks));
      }
      return labels;
    },
    /**
     * @private
     */
    getPixelForOffset: function getPixelForOffset(time) {
      var me = this;
      var offsets = me._offsets;
      var pos = interpolate$1(me._table, 'time', time, 'pos');
      return me.getPixelForDecimal((offsets.start + pos) * offsets.factor);
    },
    getPixelForValue: function getPixelForValue(value, index, datasetIndex) {
      var me = this;
      var time = null;
      if (index !== undefined && datasetIndex !== undefined) {
        time = me._timestamps.datasets[datasetIndex][index];
      }
      if (time === null) {
        time = parse(me, value);
      }
      if (time !== null) {
        return me.getPixelForOffset(time);
      }
    },
    getPixelForTick: function getPixelForTick(index) {
      var ticks = this.getTicks();
      return index >= 0 && index < ticks.length ? this.getPixelForOffset(ticks[index].value) : null;
    },
    getValueForPixel: function getValueForPixel(pixel) {
      var me = this;
      var offsets = me._offsets;
      var pos = me.getDecimalForPixel(pixel) / offsets.factor - offsets.end;
      var time = interpolate$1(me._table, 'pos', pos, 'time');

      // DEPRECATION, we should return time directly
      return me._adapter._create(time);
    },
    /**
     * @private
     */
    _getLabelSize: function _getLabelSize(label) {
      var me = this;
      var ticksOpts = me.options.ticks;
      var tickLabelWidth = me.ctx.measureText(label).width;
      var angle = helpers$1.toRadians(me.isHorizontal() ? ticksOpts.maxRotation : ticksOpts.minRotation);
      var cosRotation = Math.cos(angle);
      var sinRotation = Math.sin(angle);
      var tickFontSize = valueOrDefault$d(ticksOpts.fontSize, core_defaults.global.defaultFontSize);
      return {
        w: tickLabelWidth * cosRotation + tickFontSize * sinRotation,
        h: tickLabelWidth * sinRotation + tickFontSize * cosRotation
      };
    },
    /**
     * Crude approximation of what the label width might be
     * @private
     */
    getLabelWidth: function getLabelWidth(label) {
      return this._getLabelSize(label).w;
    },
    /**
     * @private
     */
    getLabelCapacity: function getLabelCapacity(exampleTime) {
      var me = this;
      var timeOpts = me.options.time;
      var displayFormats = timeOpts.displayFormats;

      // pick the longest format (milliseconds) for guestimation
      var format = displayFormats[timeOpts.unit] || displayFormats.millisecond;
      var exampleLabel = me.tickFormatFunction(exampleTime, 0, ticksFromTimestamps(me, [exampleTime], me._majorUnit), format);
      var size = me._getLabelSize(exampleLabel);
      var capacity = Math.floor(me.isHorizontal() ? me.width / size.w : me.height / size.h);
      if (me.options.offset) {
        capacity--;
      }
      return capacity > 0 ? capacity : 1;
    }
  });

  // INTERNAL: static default options, registered in src/index.js
  var _defaults$4 = defaultConfig$4;
  scale_time._defaults = _defaults$4;
  var scales = {
    category: scale_category,
    linear: scale_linear,
    logarithmic: scale_logarithmic,
    radialLinear: scale_radialLinear,
    time: scale_time
  };
  var FORMATS = {
    datetime: 'MMM D, YYYY, h:mm:ss a',
    millisecond: 'h:mm:ss.SSS a',
    second: 'h:mm:ss a',
    minute: 'h:mm a',
    hour: 'hA',
    day: 'MMM D',
    week: 'll',
    month: 'MMM YYYY',
    quarter: '[Q]Q - YYYY',
    year: 'YYYY'
  };
  core_adapters._date.override(typeof moment === 'function' ? {
    _id: 'moment',
    // DEBUG ONLY

    formats: function formats() {
      return FORMATS;
    },
    parse: function parse(value, format) {
      if (typeof value === 'string' && typeof format === 'string') {
        value = moment(value, format);
      } else if (!(value instanceof moment)) {
        value = moment(value);
      }
      return value.isValid() ? value.valueOf() : null;
    },
    format: function format(time, _format2) {
      return moment(time).format(_format2);
    },
    add: function add(time, amount, unit) {
      return moment(time).add(amount, unit).valueOf();
    },
    diff: function diff(max, min, unit) {
      return moment(max).diff(moment(min), unit);
    },
    startOf: function startOf(time, unit, weekday) {
      time = moment(time);
      if (unit === 'isoWeek') {
        return time.isoWeekday(weekday).valueOf();
      }
      return time.startOf(unit).valueOf();
    },
    endOf: function endOf(time, unit) {
      return moment(time).endOf(unit).valueOf();
    },
    // DEPRECATIONS

    /**
     * Provided for backward compatibility with scale.getValueForPixel().
     * @deprecated since version 2.8.0
     * @todo remove at version 3
     * @private
     */
    _create: function _create(time) {
      return moment(time);
    }
  } : {});
  core_defaults._set('global', {
    plugins: {
      filler: {
        propagate: true
      }
    }
  });
  var mappers = {
    dataset: function dataset(source) {
      var index = source.fill;
      var chart = source.chart;
      var meta = chart.getDatasetMeta(index);
      var visible = meta && chart.isDatasetVisible(index);
      var points = visible && meta.dataset._children || [];
      var length = points.length || 0;
      return !length ? null : function (point, i) {
        return i < length && points[i]._view || null;
      };
    },
    boundary: function boundary(source) {
      var boundary = source.boundary;
      var x = boundary ? boundary.x : null;
      var y = boundary ? boundary.y : null;
      if (helpers$1.isArray(boundary)) {
        return function (point, i) {
          return boundary[i];
        };
      }
      return function (point) {
        return {
          x: x === null ? point.x : x,
          y: y === null ? point.y : y
        };
      };
    }
  };

  // @todo if (fill[0] === '#')
  function decodeFill(el, index, count) {
    var model = el._model || {};
    var fill = model.fill;
    var target;
    if (fill === undefined) {
      fill = !!model.backgroundColor;
    }
    if (fill === false || fill === null) {
      return false;
    }
    if (fill === true) {
      return 'origin';
    }
    target = parseFloat(fill, 10);
    if (isFinite(target) && Math.floor(target) === target) {
      if (fill[0] === '-' || fill[0] === '+') {
        target = index + target;
      }
      if (target === index || target < 0 || target >= count) {
        return false;
      }
      return target;
    }
    switch (fill) {
      // compatibility
      case 'bottom':
        return 'start';
      case 'top':
        return 'end';
      case 'zero':
        return 'origin';
      // supported boundaries
      case 'origin':
      case 'start':
      case 'end':
        return fill;
      // invalid fill values
      default:
        return false;
    }
  }
  function computeLinearBoundary(source) {
    var model = source.el._model || {};
    var scale = source.el._scale || {};
    var fill = source.fill;
    var target = null;
    var horizontal;
    if (isFinite(fill)) {
      return null;
    }

    // Backward compatibility: until v3, we still need to support boundary values set on
    // the model (scaleTop, scaleBottom and scaleZero) because some external plugins and
    // controllers might still use it (e.g. the Smith chart).

    if (fill === 'start') {
      target = model.scaleBottom === undefined ? scale.bottom : model.scaleBottom;
    } else if (fill === 'end') {
      target = model.scaleTop === undefined ? scale.top : model.scaleTop;
    } else if (model.scaleZero !== undefined) {
      target = model.scaleZero;
    } else if (scale.getBasePixel) {
      target = scale.getBasePixel();
    }
    if (target !== undefined && target !== null) {
      if (target.x !== undefined && target.y !== undefined) {
        return target;
      }
      if (helpers$1.isFinite(target)) {
        horizontal = scale.isHorizontal();
        return {
          x: horizontal ? target : null,
          y: horizontal ? null : target
        };
      }
    }
    return null;
  }
  function computeCircularBoundary(source) {
    var scale = source.el._scale;
    var options = scale.options;
    var length = scale.chart.data.labels.length;
    var fill = source.fill;
    var target = [];
    var start, end, center, i, point;
    if (!length) {
      return null;
    }
    start = options.ticks.reverse ? scale.max : scale.min;
    end = options.ticks.reverse ? scale.min : scale.max;
    center = scale.getPointPositionForValue(0, start);
    for (i = 0; i < length; ++i) {
      point = fill === 'start' || fill === 'end' ? scale.getPointPositionForValue(i, fill === 'start' ? start : end) : scale.getBasePosition(i);
      if (options.gridLines.circular) {
        point.cx = center.x;
        point.cy = center.y;
        point.angle = scale.getIndexAngle(i) - Math.PI / 2;
      }
      target.push(point);
    }
    return target;
  }
  function computeBoundary(source) {
    var scale = source.el._scale || {};
    if (scale.getPointPositionForValue) {
      return computeCircularBoundary(source);
    }
    return computeLinearBoundary(source);
  }
  function resolveTarget(sources, index, propagate) {
    var source = sources[index];
    var fill = source.fill;
    var visited = [index];
    var target;
    if (!propagate) {
      return fill;
    }
    while (fill !== false && visited.indexOf(fill) === -1) {
      if (!isFinite(fill)) {
        return fill;
      }
      target = sources[fill];
      if (!target) {
        return false;
      }
      if (target.visible) {
        return fill;
      }
      visited.push(fill);
      fill = target.fill;
    }
    return false;
  }
  function createMapper(source) {
    var fill = source.fill;
    var type = 'dataset';
    if (fill === false) {
      return null;
    }
    if (!isFinite(fill)) {
      type = 'boundary';
    }
    return mappers[type](source);
  }
  function isDrawable(point) {
    return point && !point.skip;
  }
  function drawArea(ctx, curve0, curve1, len0, len1) {
    var i, cx, cy, r;
    if (!len0 || !len1) {
      return;
    }

    // building first area curve (normal)
    ctx.moveTo(curve0[0].x, curve0[0].y);
    for (i = 1; i < len0; ++i) {
      helpers$1.canvas.lineTo(ctx, curve0[i - 1], curve0[i]);
    }
    if (curve1[0].angle !== undefined) {
      cx = curve1[0].cx;
      cy = curve1[0].cy;
      r = Math.sqrt(Math.pow(curve1[0].x - cx, 2) + Math.pow(curve1[0].y - cy, 2));
      for (i = len1 - 1; i > 0; --i) {
        ctx.arc(cx, cy, r, curve1[i].angle, curve1[i - 1].angle, true);
      }
      return;
    }

    // joining the two area curves
    ctx.lineTo(curve1[len1 - 1].x, curve1[len1 - 1].y);

    // building opposite area curve (reverse)
    for (i = len1 - 1; i > 0; --i) {
      helpers$1.canvas.lineTo(ctx, curve1[i], curve1[i - 1], true);
    }
  }
  function doFill(ctx, points, mapper, view, color, loop) {
    var count = points.length;
    var span = view.spanGaps;
    var curve0 = [];
    var curve1 = [];
    var len0 = 0;
    var len1 = 0;
    var i, ilen, index, p0, p1, d0, d1, loopOffset;
    ctx.beginPath();
    for (i = 0, ilen = count; i < ilen; ++i) {
      index = i % count;
      p0 = points[index]._view;
      p1 = mapper(p0, index, view);
      d0 = isDrawable(p0);
      d1 = isDrawable(p1);
      if (loop && loopOffset === undefined && d0) {
        loopOffset = i + 1;
        ilen = count + loopOffset;
      }
      if (d0 && d1) {
        len0 = curve0.push(p0);
        len1 = curve1.push(p1);
      } else if (len0 && len1) {
        if (!span) {
          drawArea(ctx, curve0, curve1, len0, len1);
          len0 = len1 = 0;
          curve0 = [];
          curve1 = [];
        } else {
          if (d0) {
            curve0.push(p0);
          }
          if (d1) {
            curve1.push(p1);
          }
        }
      }
    }
    drawArea(ctx, curve0, curve1, len0, len1);
    ctx.closePath();
    ctx.fillStyle = color;
    ctx.fill();
  }
  var plugin_filler = {
    id: 'filler',
    afterDatasetsUpdate: function afterDatasetsUpdate(chart, options) {
      var count = (chart.data.datasets || []).length;
      var propagate = options.propagate;
      var sources = [];
      var meta, i, el, source;
      for (i = 0; i < count; ++i) {
        meta = chart.getDatasetMeta(i);
        el = meta.dataset;
        source = null;
        if (el && el._model && el instanceof elements.Line) {
          source = {
            visible: chart.isDatasetVisible(i),
            fill: decodeFill(el, i, count),
            chart: chart,
            el: el
          };
        }
        meta.$filler = source;
        sources.push(source);
      }
      for (i = 0; i < count; ++i) {
        source = sources[i];
        if (!source) {
          continue;
        }
        source.fill = resolveTarget(sources, i, propagate);
        source.boundary = computeBoundary(source);
        source.mapper = createMapper(source);
      }
    },
    beforeDatasetsDraw: function beforeDatasetsDraw(chart) {
      var metasets = chart._getSortedVisibleDatasetMetas();
      var ctx = chart.ctx;
      var meta, i, el, view, points, mapper, color;
      for (i = metasets.length - 1; i >= 0; --i) {
        meta = metasets[i].$filler;
        if (!meta || !meta.visible) {
          continue;
        }
        el = meta.el;
        view = el._view;
        points = el._children || [];
        mapper = meta.mapper;
        color = view.backgroundColor || core_defaults.global.defaultColor;
        if (mapper && color && points.length) {
          helpers$1.canvas.clipArea(ctx, chart.chartArea);
          doFill(ctx, points, mapper, view, color, el._loop);
          helpers$1.canvas.unclipArea(ctx);
        }
      }
    }
  };
  var getRtlHelper$1 = helpers$1.rtl.getRtlAdapter;
  var noop$1 = helpers$1.noop;
  var valueOrDefault$e = helpers$1.valueOrDefault;
  core_defaults._set('global', {
    legend: {
      display: true,
      position: 'top',
      align: 'center',
      fullWidth: true,
      reverse: false,
      weight: 1000,
      // a callback that will handle
      onClick: function onClick(e, legendItem) {
        var index = legendItem.datasetIndex;
        var ci = this.chart;
        var meta = ci.getDatasetMeta(index);

        // See controller.isDatasetVisible comment
        meta.hidden = meta.hidden === null ? !ci.data.datasets[index].hidden : null;

        // We hid a dataset ... rerender the chart
        ci.update();
      },
      onHover: null,
      onLeave: null,
      labels: {
        boxWidth: 40,
        padding: 10,
        // Generates labels shown in the legend
        // Valid properties to return:
        // text : text to display
        // fillStyle : fill of coloured box
        // strokeStyle: stroke of coloured box
        // hidden : if this legend item refers to a hidden item
        // lineCap : cap style for line
        // lineDash
        // lineDashOffset :
        // lineJoin :
        // lineWidth :
        generateLabels: function generateLabels(chart) {
          var datasets = chart.data.datasets;
          var options = chart.options.legend || {};
          var usePointStyle = options.labels && options.labels.usePointStyle;
          return chart._getSortedDatasetMetas().map(function (meta) {
            var style = meta.controller.getStyle(usePointStyle ? 0 : undefined);
            return {
              text: datasets[meta.index].label,
              fillStyle: style.backgroundColor,
              hidden: !chart.isDatasetVisible(meta.index),
              lineCap: style.borderCapStyle,
              lineDash: style.borderDash,
              lineDashOffset: style.borderDashOffset,
              lineJoin: style.borderJoinStyle,
              lineWidth: style.borderWidth,
              strokeStyle: style.borderColor,
              pointStyle: style.pointStyle,
              rotation: style.rotation,
              // Below is extra data used for toggling the datasets
              datasetIndex: meta.index
            };
          }, this);
        }
      }
    },
    legendCallback: function legendCallback(chart) {
      var list = document.createElement('ul');
      var datasets = chart.data.datasets;
      var i, ilen, listItem, listItemSpan;
      list.setAttribute('class', chart.id + '-legend');
      for (i = 0, ilen = datasets.length; i < ilen; i++) {
        listItem = list.appendChild(document.createElement('li'));
        listItemSpan = listItem.appendChild(document.createElement('span'));
        listItemSpan.style.backgroundColor = datasets[i].backgroundColor;
        if (datasets[i].label) {
          listItem.appendChild(document.createTextNode(datasets[i].label));
        }
      }
      return list.outerHTML;
    }
  });

  /**
   * Helper function to get the box width based on the usePointStyle option
   * @param {object} labelopts - the label options on the legend
   * @param {number} fontSize - the label font size
   * @return {number} width of the color box area
   */
  function getBoxWidth(labelOpts, fontSize) {
    return labelOpts.usePointStyle && labelOpts.boxWidth > fontSize ? fontSize : labelOpts.boxWidth;
  }

  /**
   * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
   */
  var Legend = core_element.extend({
    initialize: function initialize(config) {
      var me = this;
      helpers$1.extend(me, config);

      // Contains hit boxes for each dataset (in dataset order)
      me.legendHitBoxes = [];

      /**
      	 * @private
      	 */
      me._hoveredItem = null;

      // Are we in doughnut mode which has a different data type
      me.doughnutMode = false;
    },
    // These methods are ordered by lifecycle. Utilities then follow.
    // Any function defined here is inherited by all legend types.
    // Any function can be extended by the legend type

    beforeUpdate: noop$1,
    update: function update(maxWidth, maxHeight, margins) {
      var me = this;

      // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
      me.beforeUpdate();

      // Absorb the master measurements
      me.maxWidth = maxWidth;
      me.maxHeight = maxHeight;
      me.margins = margins;

      // Dimensions
      me.beforeSetDimensions();
      me.setDimensions();
      me.afterSetDimensions();
      // Labels
      me.beforeBuildLabels();
      me.buildLabels();
      me.afterBuildLabels();

      // Fit
      me.beforeFit();
      me.fit();
      me.afterFit();
      //
      me.afterUpdate();
      return me.minSize;
    },
    afterUpdate: noop$1,
    //

    beforeSetDimensions: noop$1,
    setDimensions: function setDimensions() {
      var me = this;
      // Set the unconstrained dimension before label rotation
      if (me.isHorizontal()) {
        // Reset position before calculating rotation
        me.width = me.maxWidth;
        me.left = 0;
        me.right = me.width;
      } else {
        me.height = me.maxHeight;

        // Reset position before calculating rotation
        me.top = 0;
        me.bottom = me.height;
      }

      // Reset padding
      me.paddingLeft = 0;
      me.paddingTop = 0;
      me.paddingRight = 0;
      me.paddingBottom = 0;

      // Reset minSize
      me.minSize = {
        width: 0,
        height: 0
      };
    },
    afterSetDimensions: noop$1,
    //

    beforeBuildLabels: noop$1,
    buildLabels: function buildLabels() {
      var me = this;
      var labelOpts = me.options.labels || {};
      var legendItems = helpers$1.callback(labelOpts.generateLabels, [me.chart], me) || [];
      if (labelOpts.filter) {
        legendItems = legendItems.filter(function (item) {
          return labelOpts.filter(item, me.chart.data);
        });
      }
      if (me.options.reverse) {
        legendItems.reverse();
      }
      me.legendItems = legendItems;
    },
    afterBuildLabels: noop$1,
    //

    beforeFit: noop$1,
    fit: function fit() {
      var me = this;
      var opts = me.options;
      var labelOpts = opts.labels;
      var display = opts.display;
      var ctx = me.ctx;
      var labelFont = helpers$1.options._parseFont(labelOpts);
      var fontSize = labelFont.size;

      // Reset hit boxes
      var hitboxes = me.legendHitBoxes = [];
      var minSize = me.minSize;
      var isHorizontal = me.isHorizontal();
      if (isHorizontal) {
        minSize.width = me.maxWidth; // fill all the width
        minSize.height = display ? 10 : 0;
      } else {
        minSize.width = display ? 10 : 0;
        minSize.height = me.maxHeight; // fill all the height
      }

      // Increase sizes here
      if (!display) {
        me.width = minSize.width = me.height = minSize.height = 0;
        return;
      }
      ctx.font = labelFont.string;
      if (isHorizontal) {
        // Labels

        // Width of each line of legend boxes. Labels wrap onto multiple lines when there are too many to fit on one
        var lineWidths = me.lineWidths = [0];
        var totalHeight = 0;
        ctx.textAlign = 'left';
        ctx.textBaseline = 'middle';
        helpers$1.each(me.legendItems, function (legendItem, i) {
          var boxWidth = getBoxWidth(labelOpts, fontSize);
          var width = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;
          if (i === 0 || lineWidths[lineWidths.length - 1] + width + 2 * labelOpts.padding > minSize.width) {
            totalHeight += fontSize + labelOpts.padding;
            lineWidths[lineWidths.length - (i > 0 ? 0 : 1)] = 0;
          }

          // Store the hitbox width and height here. Final position will be updated in `draw`
          hitboxes[i] = {
            left: 0,
            top: 0,
            width: width,
            height: fontSize
          };
          lineWidths[lineWidths.length - 1] += width + labelOpts.padding;
        });
        minSize.height += totalHeight;
      } else {
        var vPadding = labelOpts.padding;
        var columnWidths = me.columnWidths = [];
        var columnHeights = me.columnHeights = [];
        var totalWidth = labelOpts.padding;
        var currentColWidth = 0;
        var currentColHeight = 0;
        helpers$1.each(me.legendItems, function (legendItem, i) {
          var boxWidth = getBoxWidth(labelOpts, fontSize);
          var itemWidth = boxWidth + fontSize / 2 + ctx.measureText(legendItem.text).width;

          // If too tall, go to new column
          if (i > 0 && currentColHeight + fontSize + 2 * vPadding > minSize.height) {
            totalWidth += currentColWidth + labelOpts.padding;
            columnWidths.push(currentColWidth); // previous column width
            columnHeights.push(currentColHeight);
            currentColWidth = 0;
            currentColHeight = 0;
          }

          // Get max width
          currentColWidth = Math.max(currentColWidth, itemWidth);
          currentColHeight += fontSize + vPadding;

          // Store the hitbox width and height here. Final position will be updated in `draw`
          hitboxes[i] = {
            left: 0,
            top: 0,
            width: itemWidth,
            height: fontSize
          };
        });
        totalWidth += currentColWidth;
        columnWidths.push(currentColWidth);
        columnHeights.push(currentColHeight);
        minSize.width += totalWidth;
      }
      me.width = minSize.width;
      me.height = minSize.height;
    },
    afterFit: noop$1,
    // Shared Methods
    isHorizontal: function isHorizontal() {
      return this.options.position === 'top' || this.options.position === 'bottom';
    },
    // Actually draw the legend on the canvas
    draw: function draw() {
      var me = this;
      var opts = me.options;
      var labelOpts = opts.labels;
      var globalDefaults = core_defaults.global;
      var defaultColor = globalDefaults.defaultColor;
      var lineDefault = globalDefaults.elements.line;
      var legendHeight = me.height;
      var columnHeights = me.columnHeights;
      var legendWidth = me.width;
      var lineWidths = me.lineWidths;
      if (!opts.display) {
        return;
      }
      var rtlHelper = getRtlHelper$1(opts.rtl, me.left, me.minSize.width);
      var ctx = me.ctx;
      var fontColor = valueOrDefault$e(labelOpts.fontColor, globalDefaults.defaultFontColor);
      var labelFont = helpers$1.options._parseFont(labelOpts);
      var fontSize = labelFont.size;
      var cursor;

      // Canvas setup
      ctx.textAlign = rtlHelper.textAlign('left');
      ctx.textBaseline = 'middle';
      ctx.lineWidth = 0.5;
      ctx.strokeStyle = fontColor; // for strikethrough effect
      ctx.fillStyle = fontColor; // render in correct colour
      ctx.font = labelFont.string;
      var boxWidth = getBoxWidth(labelOpts, fontSize);
      var hitboxes = me.legendHitBoxes;

      // current position
      var drawLegendBox = function drawLegendBox(x, y, legendItem) {
        if (isNaN(boxWidth) || boxWidth <= 0) {
          return;
        }

        // Set the ctx for the box
        ctx.save();
        var lineWidth = valueOrDefault$e(legendItem.lineWidth, lineDefault.borderWidth);
        ctx.fillStyle = valueOrDefault$e(legendItem.fillStyle, defaultColor);
        ctx.lineCap = valueOrDefault$e(legendItem.lineCap, lineDefault.borderCapStyle);
        ctx.lineDashOffset = valueOrDefault$e(legendItem.lineDashOffset, lineDefault.borderDashOffset);
        ctx.lineJoin = valueOrDefault$e(legendItem.lineJoin, lineDefault.borderJoinStyle);
        ctx.lineWidth = lineWidth;
        ctx.strokeStyle = valueOrDefault$e(legendItem.strokeStyle, defaultColor);
        if (ctx.setLineDash) {
          // IE 9 and 10 do not support line dash
          ctx.setLineDash(valueOrDefault$e(legendItem.lineDash, lineDefault.borderDash));
        }
        if (labelOpts && labelOpts.usePointStyle) {
          // Recalculate x and y for drawPoint() because its expecting
          // x and y to be center of figure (instead of top left)
          var radius = boxWidth * Math.SQRT2 / 2;
          var centerX = rtlHelper.xPlus(x, boxWidth / 2);
          var centerY = y + fontSize / 2;

          // Draw pointStyle as legend symbol
          helpers$1.canvas.drawPoint(ctx, legendItem.pointStyle, radius, centerX, centerY, legendItem.rotation);
        } else {
          // Draw box as legend symbol
          ctx.fillRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
          if (lineWidth !== 0) {
            ctx.strokeRect(rtlHelper.leftForLtr(x, boxWidth), y, boxWidth, fontSize);
          }
        }
        ctx.restore();
      };
      var fillText = function fillText(x, y, legendItem, textWidth) {
        var halfFontSize = fontSize / 2;
        var xLeft = rtlHelper.xPlus(x, boxWidth + halfFontSize);
        var yMiddle = y + halfFontSize;
        ctx.fillText(legendItem.text, xLeft, yMiddle);
        if (legendItem.hidden) {
          // Strikethrough the text if hidden
          ctx.beginPath();
          ctx.lineWidth = 2;
          ctx.moveTo(xLeft, yMiddle);
          ctx.lineTo(rtlHelper.xPlus(xLeft, textWidth), yMiddle);
          ctx.stroke();
        }
      };
      var alignmentOffset = function alignmentOffset(dimension, blockSize) {
        switch (opts.align) {
          case 'start':
            return labelOpts.padding;
          case 'end':
            return dimension - blockSize;
          default:
            // center
            return (dimension - blockSize + labelOpts.padding) / 2;
        }
      };

      // Horizontal
      var isHorizontal = me.isHorizontal();
      if (isHorizontal) {
        cursor = {
          x: me.left + alignmentOffset(legendWidth, lineWidths[0]),
          y: me.top + labelOpts.padding,
          line: 0
        };
      } else {
        cursor = {
          x: me.left + labelOpts.padding,
          y: me.top + alignmentOffset(legendHeight, columnHeights[0]),
          line: 0
        };
      }
      helpers$1.rtl.overrideTextDirection(me.ctx, opts.textDirection);
      var itemHeight = fontSize + labelOpts.padding;
      helpers$1.each(me.legendItems, function (legendItem, i) {
        var textWidth = ctx.measureText(legendItem.text).width;
        var width = boxWidth + fontSize / 2 + textWidth;
        var x = cursor.x;
        var y = cursor.y;
        rtlHelper.setWidth(me.minSize.width);

        // Use (me.left + me.minSize.width) and (me.top + me.minSize.height)
        // instead of me.right and me.bottom because me.width and me.height
        // may have been changed since me.minSize was calculated
        if (isHorizontal) {
          if (i > 0 && x + width + labelOpts.padding > me.left + me.minSize.width) {
            y = cursor.y += itemHeight;
            cursor.line++;
            x = cursor.x = me.left + alignmentOffset(legendWidth, lineWidths[cursor.line]);
          }
        } else if (i > 0 && y + itemHeight > me.top + me.minSize.height) {
          x = cursor.x = x + me.columnWidths[cursor.line] + labelOpts.padding;
          cursor.line++;
          y = cursor.y = me.top + alignmentOffset(legendHeight, columnHeights[cursor.line]);
        }
        var realX = rtlHelper.x(x);
        drawLegendBox(realX, y, legendItem);
        hitboxes[i].left = rtlHelper.leftForLtr(realX, hitboxes[i].width);
        hitboxes[i].top = y;

        // Fill the actual label
        fillText(realX, y, legendItem, textWidth);
        if (isHorizontal) {
          cursor.x += width + labelOpts.padding;
        } else {
          cursor.y += itemHeight;
        }
      });
      helpers$1.rtl.restoreTextDirection(me.ctx, opts.textDirection);
    },
    /**
     * @private
     */
    _getLegendItemAt: function _getLegendItemAt(x, y) {
      var me = this;
      var i, hitBox, lh;
      if (x >= me.left && x <= me.right && y >= me.top && y <= me.bottom) {
        // See if we are touching one of the dataset boxes
        lh = me.legendHitBoxes;
        for (i = 0; i < lh.length; ++i) {
          hitBox = lh[i];
          if (x >= hitBox.left && x <= hitBox.left + hitBox.width && y >= hitBox.top && y <= hitBox.top + hitBox.height) {
            // Touching an element
            return me.legendItems[i];
          }
        }
      }
      return null;
    },
    /**
     * Handle an event
     * @private
     * @param {IEvent} event - The event to handle
     */
    handleEvent: function handleEvent(e) {
      var me = this;
      var opts = me.options;
      var type = e.type === 'mouseup' ? 'click' : e.type;
      var hoveredItem;
      if (type === 'mousemove') {
        if (!opts.onHover && !opts.onLeave) {
          return;
        }
      } else if (type === 'click') {
        if (!opts.onClick) {
          return;
        }
      } else {
        return;
      }

      // Chart event already has relative position in it
      hoveredItem = me._getLegendItemAt(e.x, e.y);
      if (type === 'click') {
        if (hoveredItem && opts.onClick) {
          // use e.native for backwards compatibility
          opts.onClick.call(me, e["native"], hoveredItem);
        }
      } else {
        if (opts.onLeave && hoveredItem !== me._hoveredItem) {
          if (me._hoveredItem) {
            opts.onLeave.call(me, e["native"], me._hoveredItem);
          }
          me._hoveredItem = hoveredItem;
        }
        if (opts.onHover && hoveredItem) {
          // use e.native for backwards compatibility
          opts.onHover.call(me, e["native"], hoveredItem);
        }
      }
    }
  });
  function createNewLegendAndAttach(chart, legendOpts) {
    var legend = new Legend({
      ctx: chart.ctx,
      options: legendOpts,
      chart: chart
    });
    core_layouts.configure(chart, legend, legendOpts);
    core_layouts.addBox(chart, legend);
    chart.legend = legend;
  }
  var plugin_legend = {
    id: 'legend',
    /**
     * Backward compatibility: since 2.1.5, the legend is registered as a plugin, making
     * Chart.Legend obsolete. To avoid a breaking change, we export the Legend as part of
     * the plugin, which one will be re-exposed in the chart.js file.
     * https://github.com/chartjs/Chart.js/pull/2640
     * @private
     */
    _element: Legend,
    beforeInit: function beforeInit(chart) {
      var legendOpts = chart.options.legend;
      if (legendOpts) {
        createNewLegendAndAttach(chart, legendOpts);
      }
    },
    beforeUpdate: function beforeUpdate(chart) {
      var legendOpts = chart.options.legend;
      var legend = chart.legend;
      if (legendOpts) {
        helpers$1.mergeIf(legendOpts, core_defaults.global.legend);
        if (legend) {
          core_layouts.configure(chart, legend, legendOpts);
          legend.options = legendOpts;
        } else {
          createNewLegendAndAttach(chart, legendOpts);
        }
      } else if (legend) {
        core_layouts.removeBox(chart, legend);
        delete chart.legend;
      }
    },
    afterEvent: function afterEvent(chart, e) {
      var legend = chart.legend;
      if (legend) {
        legend.handleEvent(e);
      }
    }
  };
  var noop$2 = helpers$1.noop;
  core_defaults._set('global', {
    title: {
      display: false,
      fontStyle: 'bold',
      fullWidth: true,
      padding: 10,
      position: 'top',
      text: '',
      weight: 2000 // by default greater than legend (1000) to be above
    }
  });

  /**
   * IMPORTANT: this class is exposed publicly as Chart.Legend, backward compatibility required!
   */
  var Title = core_element.extend({
    initialize: function initialize(config) {
      var me = this;
      helpers$1.extend(me, config);

      // Contains hit boxes for each dataset (in dataset order)
      me.legendHitBoxes = [];
    },
    // These methods are ordered by lifecycle. Utilities then follow.

    beforeUpdate: noop$2,
    update: function update(maxWidth, maxHeight, margins) {
      var me = this;

      // Update Lifecycle - Probably don't want to ever extend or overwrite this function ;)
      me.beforeUpdate();

      // Absorb the master measurements
      me.maxWidth = maxWidth;
      me.maxHeight = maxHeight;
      me.margins = margins;

      // Dimensions
      me.beforeSetDimensions();
      me.setDimensions();
      me.afterSetDimensions();
      // Labels
      me.beforeBuildLabels();
      me.buildLabels();
      me.afterBuildLabels();

      // Fit
      me.beforeFit();
      me.fit();
      me.afterFit();
      //
      me.afterUpdate();
      return me.minSize;
    },
    afterUpdate: noop$2,
    //

    beforeSetDimensions: noop$2,
    setDimensions: function setDimensions() {
      var me = this;
      // Set the unconstrained dimension before label rotation
      if (me.isHorizontal()) {
        // Reset position before calculating rotation
        me.width = me.maxWidth;
        me.left = 0;
        me.right = me.width;
      } else {
        me.height = me.maxHeight;

        // Reset position before calculating rotation
        me.top = 0;
        me.bottom = me.height;
      }

      // Reset padding
      me.paddingLeft = 0;
      me.paddingTop = 0;
      me.paddingRight = 0;
      me.paddingBottom = 0;

      // Reset minSize
      me.minSize = {
        width: 0,
        height: 0
      };
    },
    afterSetDimensions: noop$2,
    //

    beforeBuildLabels: noop$2,
    buildLabels: noop$2,
    afterBuildLabels: noop$2,
    //

    beforeFit: noop$2,
    fit: function fit() {
      var me = this;
      var opts = me.options;
      var minSize = me.minSize = {};
      var isHorizontal = me.isHorizontal();
      var lineCount, textSize;
      if (!opts.display) {
        me.width = minSize.width = me.height = minSize.height = 0;
        return;
      }
      lineCount = helpers$1.isArray(opts.text) ? opts.text.length : 1;
      textSize = lineCount * helpers$1.options._parseFont(opts).lineHeight + opts.padding * 2;
      me.width = minSize.width = isHorizontal ? me.maxWidth : textSize;
      me.height = minSize.height = isHorizontal ? textSize : me.maxHeight;
    },
    afterFit: noop$2,
    // Shared Methods
    isHorizontal: function isHorizontal() {
      var pos = this.options.position;
      return pos === 'top' || pos === 'bottom';
    },
    // Actually draw the title block on the canvas
    draw: function draw() {
      var me = this;
      var ctx = me.ctx;
      var opts = me.options;
      if (!opts.display) {
        return;
      }
      var fontOpts = helpers$1.options._parseFont(opts);
      var lineHeight = fontOpts.lineHeight;
      var offset = lineHeight / 2 + opts.padding;
      var rotation = 0;
      var top = me.top;
      var left = me.left;
      var bottom = me.bottom;
      var right = me.right;
      var maxWidth, titleX, titleY;
      ctx.fillStyle = helpers$1.valueOrDefault(opts.fontColor, core_defaults.global.defaultFontColor); // render in correct colour
      ctx.font = fontOpts.string;

      // Horizontal
      if (me.isHorizontal()) {
        titleX = left + (right - left) / 2; // midpoint of the width
        titleY = top + offset;
        maxWidth = right - left;
      } else {
        titleX = opts.position === 'left' ? left + offset : right - offset;
        titleY = top + (bottom - top) / 2;
        maxWidth = bottom - top;
        rotation = Math.PI * (opts.position === 'left' ? -0.5 : 0.5);
      }
      ctx.save();
      ctx.translate(titleX, titleY);
      ctx.rotate(rotation);
      ctx.textAlign = 'center';
      ctx.textBaseline = 'middle';
      var text = opts.text;
      if (helpers$1.isArray(text)) {
        var y = 0;
        for (var i = 0; i < text.length; ++i) {
          ctx.fillText(text[i], 0, y, maxWidth);
          y += lineHeight;
        }
      } else {
        ctx.fillText(text, 0, 0, maxWidth);
      }
      ctx.restore();
    }
  });
  function createNewTitleBlockAndAttach(chart, titleOpts) {
    var title = new Title({
      ctx: chart.ctx,
      options: titleOpts,
      chart: chart
    });
    core_layouts.configure(chart, title, titleOpts);
    core_layouts.addBox(chart, title);
    chart.titleBlock = title;
  }
  var plugin_title = {
    id: 'title',
    /**
     * Backward compatibility: since 2.1.5, the title is registered as a plugin, making
     * Chart.Title obsolete. To avoid a breaking change, we export the Title as part of
     * the plugin, which one will be re-exposed in the chart.js file.
     * https://github.com/chartjs/Chart.js/pull/2640
     * @private
     */
    _element: Title,
    beforeInit: function beforeInit(chart) {
      var titleOpts = chart.options.title;
      if (titleOpts) {
        createNewTitleBlockAndAttach(chart, titleOpts);
      }
    },
    beforeUpdate: function beforeUpdate(chart) {
      var titleOpts = chart.options.title;
      var titleBlock = chart.titleBlock;
      if (titleOpts) {
        helpers$1.mergeIf(titleOpts, core_defaults.global.title);
        if (titleBlock) {
          core_layouts.configure(chart, titleBlock, titleOpts);
          titleBlock.options = titleOpts;
        } else {
          createNewTitleBlockAndAttach(chart, titleOpts);
        }
      } else if (titleBlock) {
        core_layouts.removeBox(chart, titleBlock);
        delete chart.titleBlock;
      }
    }
  };
  var plugins = {};
  var filler = plugin_filler;
  var legend = plugin_legend;
  var title = plugin_title;
  plugins.filler = filler;
  plugins.legend = legend;
  plugins.title = title;

  /**
   * @namespace Chart
   */

  core_controller.helpers = helpers$1;

  // @todo dispatch these helpers into appropriated helpers/helpers.* file and write unit tests!
  core_helpers();
  core_controller._adapters = core_adapters;
  core_controller.Animation = core_animation;
  core_controller.animationService = core_animations;
  core_controller.controllers = controllers;
  core_controller.DatasetController = core_datasetController;
  core_controller.defaults = core_defaults;
  core_controller.Element = core_element;
  core_controller.elements = elements;
  core_controller.Interaction = core_interaction;
  core_controller.layouts = core_layouts;
  core_controller.platform = platform;
  core_controller.plugins = core_plugins;
  core_controller.Scale = core_scale;
  core_controller.scaleService = core_scaleService;
  core_controller.Ticks = core_ticks;
  core_controller.Tooltip = core_tooltip;

  // Register built-in scales

  core_controller.helpers.each(scales, function (scale, type) {
    core_controller.scaleService.registerScaleType(type, scale, scale._defaults);
  });

  // Load to register built-in adapters (as side effects)

  // Loading built-in plugins

  for (var k in plugins) {
    if (plugins.hasOwnProperty(k)) {
      core_controller.plugins.register(plugins[k]);
    }
  }
  core_controller.platform.initialize();
  var src = core_controller;
  if (typeof window !== 'undefined') {
    window.Chart = core_controller;
  }

  // DEPRECATIONS

  /**
   * Provided for backward compatibility, not available anymore
   * @namespace Chart.Chart
   * @deprecated since version 2.8.0
   * @todo remove at version 3
   * @private
   */
  core_controller.Chart = core_controller;

  /**
   * Provided for backward compatibility, not available anymore
   * @namespace Chart.Legend
   * @deprecated since version 2.1.5
   * @todo remove at version 3
   * @private
   */
  core_controller.Legend = plugins.legend._element;

  /**
   * Provided for backward compatibility, not available anymore
   * @namespace Chart.Title
   * @deprecated since version 2.1.5
   * @todo remove at version 3
   * @private
   */
  core_controller.Title = plugins.title._element;

  /**
   * Provided for backward compatibility, use Chart.plugins instead
   * @namespace Chart.pluginService
   * @deprecated since version 2.1.5
   * @todo remove at version 3
   * @private
   */
  core_controller.pluginService = core_controller.plugins;

  /**
   * Provided for backward compatibility, inheriting from Chart.PlugingBase has no
   * effect, instead simply create/register plugins via plain JavaScript objects.
   * @interface Chart.PluginBase
   * @deprecated since version 2.5.0
   * @todo remove at version 3
   * @private
   */
  core_controller.PluginBase = core_controller.Element.extend({});

  /**
   * Provided for backward compatibility, use Chart.helpers.canvas instead.
   * @namespace Chart.canvasHelpers
   * @deprecated since version 2.6.0
   * @todo remove at version 3
   * @private
   */
  core_controller.canvasHelpers = core_controller.helpers.canvas;

  /**
   * Provided for backward compatibility, use Chart.layouts instead.
   * @namespace Chart.layoutService
   * @deprecated since version 2.7.3
   * @todo remove at version 3
   * @private
   */
  core_controller.layoutService = core_controller.layouts;

  /**
   * Provided for backward compatibility, not available anymore.
   * @namespace Chart.LinearScaleBase
   * @deprecated since version 2.8
   * @todo remove at version 3
   * @private
   */
  core_controller.LinearScaleBase = scale_linearbase;

  /**
   * Provided for backward compatibility, instead we should create a new Chart
   * by setting the type in the config (`new Chart(id, {type: '{chart-type}'}`).
   * @deprecated since version 2.8.0
   * @todo remove at version 3
   */
  core_controller.helpers.each(['Bar', 'Bubble', 'Doughnut', 'Line', 'PolarArea', 'Radar', 'Scatter'], function (klass) {
    core_controller[klass] = function (ctx, cfg) {
      return new core_controller(ctx, core_controller.helpers.merge(cfg || {}, {
        type: klass.charAt(0).toLowerCase() + klass.slice(1)
      }));
    };
  });
  return src;
});

/*! angularjs-slider - v7.1.0 - 
 (c) Rafal Zajac <rzajac@gmail.com>, Valentin Hervieu <valentin@hervi.eu>, Jussi Saarivirta <jusasi@gmail.com>, Angelin Sirbu <angelin.sirbu@gmail.com> - 
 https://github.com/angular-slider/angularjs-slider - 
 2022-05-26 */
/*jslint unparam: true */
/*global angular: false, console: false, define, module */
;
(function (root, factory) {
  'use strict';

  /* istanbul ignore next */
  if (typeof define === 'function' && define.amd) {
    // AMD. Register as an anonymous module.
    define(['angular'], factory);
  } else if ((typeof module === "undefined" ? "undefined" : _typeof(module)) === 'object' && module.exports) {
    // Node. Does not work with strict CommonJS, but
    // only CommonJS-like environments that support module.exports,
    // like Node.
    // to support bundler like browserify
    var angularObj = angular || require('angular');
    if ((!angularObj || !angularObj.module) && typeof angular != 'undefined') {
      angularObj = angular;
    }
    module.exports = factory(angularObj);
  } else {
    // Browser globals (root is window)
    factory(root.angular);
  }
})(this, function (angular) {
  'use strict';

  var module = angular.module('rzSlider', []).factory('RzSliderOptions', function () {
    var defaultOptions = {
      floor: 0,
      ceil: null,
      //defaults to rz-slider-model
      step: 1,
      precision: 0,
      minRange: null,
      maxRange: null,
      restrictedRange: null,
      skipRestrictedRangesWithArrowKeys: null,
      pushRange: false,
      minLimit: null,
      maxLimit: null,
      id: null,
      translate: null,
      getLegend: null,
      stepsArray: null,
      bindIndexForStepsArray: false,
      draggableRange: false,
      draggableRangeOnly: false,
      showSelectionBar: false,
      showSelectionBarEnd: false,
      showSelectionBarFromValue: null,
      showOuterSelectionBars: false,
      hidePointerLabels: false,
      hideLimitLabels: false,
      autoHideLimitLabels: true,
      readOnly: false,
      disabled: false,
      interval: 350,
      showTicks: false,
      showTicksValues: false,
      ticksArray: null,
      ticksTooltip: null,
      ticksValuesTooltip: null,
      vertical: false,
      getSelectionBarColor: null,
      getTickColor: null,
      getPointerColor: null,
      keyboardSupport: true,
      scale: 1,
      enforceStep: true,
      enforceRange: false,
      noSwitching: false,
      onlyBindHandles: false,
      disableAnimation: false,
      onStart: null,
      onChange: null,
      onEnd: null,
      rightToLeft: false,
      reversedControls: false,
      boundPointerLabels: true,
      mergeRangeLabelsIfSame: false,
      labelOverlapSeparator: ' - ',
      customTemplateScope: null,
      logScale: false,
      customValueToPosition: null,
      customPositionToValue: null,
      selectionBarGradient: null,
      ariaLabel: null,
      ariaLabelledBy: null,
      ariaLabelHigh: null,
      ariaLabelledByHigh: null
    };
    var globalOptions = {};
    var factory = {};
    /**
     * `options({})` allows global configuration of all sliders in the
     * application.
     *
     *   var app = angular.module( 'App', ['rzSlider'], function( RzSliderOptions ) {
     *     // show ticks for all sliders
     *     RzSliderOptions.options( { showTicks: true } );
     *   });
     */
    factory.options = function (value) {
      angular.extend(globalOptions, value);
    };
    factory.getOptions = function (options) {
      return angular.extend({}, defaultOptions, globalOptions, options);
    };
    return factory;
  }).factory('rzThrottle', ['$timeout', function ($timeout) {
    /**
     * rzThrottle
     *
     * Taken from underscore project
     *
     * @param {Function} func
     * @param {number} wait
     * @param {ThrottleOptions} options
     * @returns {Function}
     */
    return function (func, wait, options) {
      'use strict';

      /* istanbul ignore next */
      var getTime = Date.now || function () {
        return new Date().getTime();
      };
      var context, args, result;
      var timeout = null;
      var previous = 0;
      options = options || {};
      var later = function later() {
        previous = getTime();
        timeout = null;
        result = func.apply(context, args);
        context = args = null;
      };
      return function () {
        var now = getTime();
        var remaining = wait - (now - previous);
        context = this;
        args = arguments;
        if (remaining <= 0) {
          $timeout.cancel(timeout);
          timeout = null;
          previous = now;
          result = func.apply(context, args);
          context = args = null;
        } else if (!timeout && options.trailing !== false) {
          timeout = $timeout(later, remaining);
        }
        return result;
      };
    };
  }]).factory('RzSlider', ['$timeout', '$document', '$window', '$compile', 'RzSliderOptions', 'rzThrottle', function ($timeout, $document, $window, $compile, RzSliderOptions, rzThrottle) {
    'use strict';

    /**
     * Slider
     *
     * @param {ngScope} scope            The AngularJS scope
     * @param {Element} sliderElem The slider directive element wrapped in jqLite
     * @constructor
     */
    var Slider = function Slider(scope, sliderElem) {
      /**
       * The slider's scope
       *
       * @type {ngScope}
       */
      this.scope = scope;

      /**
       * The slider inner low value (linked to rzSliderModel)
       * @type {number}
       */
      this.lowValue = 0;

      /**
       * The slider inner high value (linked to rzSliderHigh)
       * @type {number}
       */
      this.highValue = 0;

      /**
       * Slider element wrapped in jqLite
       *
       * @type {jqLite}
       */
      this.sliderElem = sliderElem;

      /**
       * Slider type
       *
       * @type {boolean} Set to true for range slider
       */
      this.range = this.scope.rzSliderModel !== undefined && this.scope.rzSliderHigh !== undefined;

      /**
       * Values recorded when first dragging the bar
       *
       * @type {Object}
       */
      this.dragging = {
        active: false,
        value: 0,
        difference: 0,
        position: 0,
        lowLimit: 0,
        highLimit: 0
      };

      /**
       * property that handle position (defaults to left for horizontal)
       * @type {string}
       */
      this.positionProperty = 'left';

      /**
       * property that handle dimension (defaults to width for horizontal)
       * @type {string}
       */
      this.dimensionProperty = 'width';

      /**
       * Half of the width or height of the slider handles
       *
       * @type {number}
       */
      this.handleHalfDim = 0;

      /**
       * Maximum position the slider handle can have
       *
       * @type {number}
       */
      this.maxPos = 0;

      /**
       * Precision
       *
       * @type {number}
       */
      this.precision = 0;

      /**
       * Step
       *
       * @type {number}
       */
      this.step = 1;

      /**
       * The name of the handle we are currently tracking
       *
       * @type {string}
       */
      this.tracking = '';

      /**
       * Minimum value (floor) of the model
       *
       * @type {number}
       */
      this.minValue = 0;

      /**
       * Maximum value (ceiling) of the model
       *
       * @type {number}
       */
      this.maxValue = 0;

      /**
       * The delta between min and max value
       *
       * @type {number}
       */
      this.valueRange = 0;

      /**
       * If showTicks/showTicksValues options are number.
       * In this case, ticks values should be displayed below the slider.
       * @type {boolean}
       */
      this.intermediateTicks = false;

      /**
       * Set to true if init method already executed
       *
       * @type {boolean}
       */
      this.initHasRun = false;

      /**
       * Used to call onStart on the first keydown event
       *
       * @type {boolean}
       */
      this.firstKeyDown = false;

      /**
       * Internal flag to prevent watchers to be called when the sliders value are modified internally.
       * @type {boolean}
       */
      this.internalChange = false;

      /**
       * Internal flag to keep track of the visibility of combo label
       * @type {boolean}
       */
      this.cmbLabelShown = false;

      /**
       * Internal variable to keep track of the focus element
       */
      this.currentFocusElement = null;

      /**
       * Internal variable to know if we are already moving
       */
      this.moving = false;

      // Slider DOM elements wrapped in jqLite
      this.fullBar = null; // The whole slider bar
      this.selBar = null; // Highlight between two handles
      this.minH = null; // Left slider handle
      this.maxH = null; // Right slider handle
      this.flrLab = null; // Floor label
      this.ceilLab = null; // Ceiling label
      this.minLab = null; // Label above the low value
      this.maxLab = null; // Label above the high value
      this.cmbLab = null; // Combined label
      this.ticks = null; // The ticks

      // Initialize slider
      this.init();
    };

    // Add instance methods
    Slider.prototype = {
      /**
       * Initialize slider
       *
       * @returns {undefined}
       */
      init: function init() {
        var thrLow,
          thrHigh,
          self = this;
        var calcDimFn = function calcDimFn() {
          self.calcViewDimensions();
        };
        this.applyOptions();
        this.syncLowValue();
        if (this.range) this.syncHighValue();
        this.initElemHandles();
        this.manageElementsStyle();
        this.setDisabledState();
        this.calcViewDimensions();
        this.setMinAndMax();
        this.updateRestrictionBar();
        this.addAccessibility();
        this.updateCeilLab();
        this.updateFloorLab();
        this.initHandles();
        this.manageEventsBindings();

        // Recalculate slider view dimensions
        this.scope.$on('reCalcViewDimensions', calcDimFn);

        // Recalculate stuff if view port dimensions have changed
        angular.element($window).on('resize', calcDimFn);
        this.initHasRun = true;
        if (this.options.disableAnimation) {
          this.sliderElem.addClass('noanimate');
        }

        // Watch for changes to the model
        thrLow = rzThrottle(function () {
          self.onLowHandleChange();
        }, self.options.interval);
        thrHigh = rzThrottle(function () {
          self.onHighHandleChange();
        }, self.options.interval);
        this.scope.$on('rzSliderForceRender', function () {
          self.resetLabelsValue();
          thrLow();
          if (self.range) {
            thrHigh();
          }
          self.resetSlider();
        });

        // Watchers (order is important because in case of simultaneous change,
        // watchers will be called in the same order)
        this.scope.$watchCollection('rzSliderOptions()', function (newValue, oldValue) {
          if (newValue === oldValue) return;
          self.applyOptions(); // need to be called before synchronizing the values
          self.syncLowValue();
          if (self.range) self.syncHighValue();
          self.resetSlider();
        });
        this.scope.$watch('rzSliderModel', function (newValue, oldValue) {
          if (self.internalChange) return;
          if (newValue === oldValue) return;
          thrLow();
        });
        this.scope.$watch('rzSliderHigh', function (newValue, oldValue) {
          if (self.internalChange) return;
          if (newValue === oldValue) return;
          if (newValue != null) thrHigh();
          if (self.range && newValue == null || !self.range && newValue != null) {
            self.applyOptions();
            self.resetSlider();
          }
        });
        this.scope.$on('$destroy', function () {
          self.unbindEvents();
          angular.element($window).off('resize', calcDimFn);
          self.currentFocusElement = null;
        });
      },
      findStepIndex: function findStepIndex(modelValue) {
        var index = 0;
        for (var i = 0; i < this.options.stepsArray.length; i++) {
          var step = this.options.stepsArray[i];
          if (step === modelValue) {
            index = i;
            break;
          } else if (angular.isDate(step)) {
            if (step.getTime() === modelValue.getTime()) {
              index = i;
              break;
            }
          } else if (angular.isObject(step)) {
            if (angular.isDate(step.value) && step.value.getTime() === modelValue.getTime() || step.value === modelValue) {
              index = i;
              break;
            }
          }
        }
        return index;
      },
      syncLowValue: function syncLowValue() {
        if (this.options.stepsArray) {
          if (!this.options.bindIndexForStepsArray) this.lowValue = this.findStepIndex(this.scope.rzSliderModel);else this.lowValue = this.scope.rzSliderModel;
        } else this.lowValue = this.scope.rzSliderModel;
      },
      syncHighValue: function syncHighValue() {
        if (this.options.stepsArray) {
          if (!this.options.bindIndexForStepsArray) this.highValue = this.findStepIndex(this.scope.rzSliderHigh);else this.highValue = this.scope.rzSliderHigh;
        } else this.highValue = this.scope.rzSliderHigh;
      },
      getStepValue: function getStepValue(sliderValue) {
        var step = this.options.stepsArray[sliderValue];
        if (angular.isDate(step)) return step;
        if (angular.isObject(step)) return step.value;
        return step;
      },
      applyLowValue: function applyLowValue() {
        if (this.options.stepsArray) {
          if (!this.options.bindIndexForStepsArray) this.scope.rzSliderModel = this.getStepValue(this.lowValue);else this.scope.rzSliderModel = this.lowValue;
        } else this.scope.rzSliderModel = this.lowValue;
      },
      applyHighValue: function applyHighValue() {
        if (this.options.stepsArray) {
          if (!this.options.bindIndexForStepsArray) this.scope.rzSliderHigh = this.getStepValue(this.highValue);else this.scope.rzSliderHigh = this.highValue;
        } else this.scope.rzSliderHigh = this.highValue;
      },
      /*
       * Reflow the slider when the low handle changes (called with throttle)
       */
      onLowHandleChange: function onLowHandleChange() {
        this.syncLowValue();
        if (this.range) this.syncHighValue();
        this.setMinAndMax();
        this.updateLowHandle(this.valueToPosition(this.lowValue));
        this.updateSelectionBar();
        this.updateTicksScale();
        this.updateAriaAttributes();
        if (this.range) {
          this.updateCmbLabel();
        }
      },
      /*
       * Reflow the slider when the high handle changes (called with throttle)
       */
      onHighHandleChange: function onHighHandleChange() {
        this.syncLowValue();
        this.syncHighValue();
        this.setMinAndMax();
        this.updateHighHandle(this.valueToPosition(this.highValue));
        this.updateSelectionBar();
        this.updateTicksScale();
        this.updateCmbLabel();
        this.updateAriaAttributes();
      },
      /**
       * Read the user options and apply them to the slider model
       */
      applyOptions: function applyOptions() {
        var sliderOptions;
        if (this.scope.rzSliderOptions) sliderOptions = this.scope.rzSliderOptions();else sliderOptions = {};
        this.options = RzSliderOptions.getOptions(sliderOptions);
        if (this.options.step <= 0) this.options.step = 1;
        this.range = this.scope.rzSliderModel !== undefined && this.scope.rzSliderHigh !== undefined;
        this.options.draggableRange = this.range && this.options.draggableRange;
        this.options.draggableRangeOnly = this.range && this.options.draggableRangeOnly;
        if (this.options.draggableRangeOnly) {
          this.options.draggableRange = true;
        }
        this.options.showTicks = this.options.showTicks || this.options.showTicksValues || !!this.options.ticksArray;
        this.scope.showTicks = this.options.showTicks; //scope is used in the template
        if (angular.isNumber(this.options.showTicks) || this.options.ticksArray) this.intermediateTicks = true;
        this.options.showSelectionBar = this.options.showSelectionBar || this.options.showSelectionBarEnd || this.options.showSelectionBarFromValue !== null;
        if (this.options.stepsArray) {
          this.parseStepsArray();
        } else {
          if (this.options.translate) this.customTrFn = this.options.translate;else this.customTrFn = function (value) {
            return String(value);
          };
          this.getLegend = this.options.getLegend;
        }
        if (this.options.vertical) {
          this.positionProperty = 'bottom';
          this.dimensionProperty = 'height';
        } else {
          this.positionProperty = 'left';
          this.dimensionProperty = 'width';
        }
        if (this.options.customTemplateScope) this.scope.custom = this.options.customTemplateScope;
      },
      parseStepsArray: function parseStepsArray() {
        this.options.floor = 0;
        this.options.ceil = this.options.stepsArray.length - 1;
        this.options.step = 1;
        if (this.options.translate) {
          this.customTrFn = this.options.translate;
        } else {
          this.customTrFn = function (modelValue) {
            if (this.options.bindIndexForStepsArray) return this.getStepValue(modelValue);
            return modelValue;
          };
        }
        this.getLegend = function (index) {
          var step = this.options.stepsArray[index];
          if (angular.isObject(step)) return step.legend;
          return null;
        };
      },
      /**
       * Resets slider
       *
       * @returns {undefined}
       */
      resetSlider: function resetSlider() {
        this.resetLabelsValue();
        this.manageElementsStyle();
        this.addAccessibility();
        this.setMinAndMax();
        this.updateCeilLab();
        this.updateFloorLab();
        this.unbindEvents();
        this.manageEventsBindings();
        this.setDisabledState();
        this.calcViewDimensions();
        this.updateRestrictionBar();
        this.refocusPointerIfNeeded();
      },
      refocusPointerIfNeeded: function refocusPointerIfNeeded() {
        if (this.currentFocusElement) {
          this.onPointerFocus(this.currentFocusElement.pointer, this.currentFocusElement.ref);
          this.focusElement(this.currentFocusElement.pointer);
        }
      },
      /**
       * Check if the restrictedRange option using multiple or not
       *
       * Run only once during initialization and only in case 4
       *
       * @returns {undefined}
       */

      ensureRestrictedBarIsArray: function ensureRestrictedBarIsArray(elem) {
        var jElem = angular.element(elem);
        this.restrictedBar = [];
        if (this.options.restrictedRange) {
          // this.options.restrictedRange converting to an array even if it's not entered as array.
          this.options.restrictedRange = !Array.isArray(this.options.restrictedRange) ? [this.options.restrictedRange] : this.options.restrictedRange;
          this.restrictedBar[0] = jElem;
          var mainDiv = elem.parentElement;
          for (var i = 1; i < this.options.restrictedRange.length; i++) {
            var sp = document.createElement('span');
            sp.setAttribute('class', 'rz-bar-wrapper');
            sp.innerHTML = '<span class="rz-bar rz-restricted" ng-style="restrictionStyle"></span>';
            mainDiv.appendChild(sp);
            this.restrictedBar[i] = angular.element(sp);
          }
        } else {
          elem.style.visibility = 'hidden';
          this.restrictedBar = null;
        }
      },
      /**
       * Set the slider children to variables for easy access
       *
       * Run only once during initialization
       *
       * @returns {undefined}
       */
      initElemHandles: function initElemHandles() {
        // Assign all slider elements to object properties for easy access
        angular.forEach(this.sliderElem.children(), function (elem, index) {
          var jElem = angular.element(elem);
          switch (index) {
            case 0:
              this.leftOutSelBar = jElem;
              break;
            case 1:
              this.rightOutSelBar = jElem;
              break;
            case 2:
              this.fullBar = jElem;
              break;
            case 3:
              this.selBar = jElem;
              break;
            case 4:
              this.ensureRestrictedBarIsArray(elem);
              break;
            case 5:
              this.minH = jElem;
              break;
            case 6:
              this.maxH = jElem;
              break;
            case 7:
              this.flrLab = jElem;
              break;
            case 8:
              this.ceilLab = jElem;
              break;
            case 9:
              this.minLab = jElem;
              break;
            case 10:
              this.maxLab = jElem;
              break;
            case 11:
              this.cmbLab = jElem;
              break;
            case 12:
              this.ticks = jElem;
              break;
          }
        }, this);

        // Initialize position cache properties
        this.selBar.rzsp = 0;
        this.minH.rzsp = 0;
        this.maxH.rzsp = 0;
        this.flrLab.rzsp = 0;
        this.ceilLab.rzsp = 0;
        this.minLab.rzsp = 0;
        this.maxLab.rzsp = 0;
        this.cmbLab.rzsp = 0;
      },
      /**
       * Update each elements style based on options
       */
      manageElementsStyle: function manageElementsStyle() {
        if (!this.range) this.maxH.css('display', 'none');else this.maxH.css('display', '');
        this.alwaysHide(this.flrLab, this.options.showTicksValues || this.options.hideLimitLabels);
        this.alwaysHide(this.ceilLab, this.options.showTicksValues || this.options.hideLimitLabels);
        var hideLabelsForTicks = this.options.showTicksValues && !this.intermediateTicks;
        this.alwaysHide(this.minLab, hideLabelsForTicks || this.options.hidePointerLabels);
        this.alwaysHide(this.maxLab, hideLabelsForTicks || !this.range || this.options.hidePointerLabels);
        this.alwaysHide(this.cmbLab, hideLabelsForTicks || !this.range || this.options.hidePointerLabels);
        this.alwaysHide(this.selBar, !this.range && !this.options.showSelectionBar);
        this.alwaysHide(this.leftOutSelBar, !this.range || !this.options.showOuterSelectionBars);

        // this.restrictedBar is everytime an array
        for (var r in this.restrictedBar) {
          if (this.restrictedBar[r]) this.alwaysHide(this.restrictedBar[r], !this.options.restrictedRange[r]);
        }
        this.alwaysHide(this.rightOutSelBar, !this.range || !this.options.showOuterSelectionBars);
        if (this.range && this.options.showOuterSelectionBars) {
          this.fullBar.addClass('rz-transparent');
        }
        if (this.options.vertical) {
          this.sliderElem.addClass('rz-vertical');
        } else {
          this.sliderElem.removeClass('rz-vertical');
        }
        if (this.options.draggableRange) this.selBar.addClass('rz-draggable');else this.selBar.removeClass('rz-draggable');
        if (this.intermediateTicks && this.options.showTicksValues) this.ticks.addClass('rz-ticks-values-under');
      },
      alwaysHide: function alwaysHide(el, hide) {
        el.rzAlwaysHide = hide;
        if (hide) this.hideEl(el);else this.showEl(el);
      },
      /**
       * Manage the events bindings based on readOnly and disabled options
       *
       * @returns {undefined}
       */
      manageEventsBindings: function manageEventsBindings() {
        if (this.options.disabled || this.options.readOnly) this.unbindEvents();else this.bindEvents();
      },
      /**
       * Set the disabled state based on rzSliderDisabled
       *
       * @returns {undefined}
       */
      setDisabledState: function setDisabledState() {
        if (this.options.disabled) {
          this.sliderElem.attr('disabled', 'disabled');
        } else {
          this.sliderElem.attr('disabled', null);
        }
      },
      /**
       * Reset label values
       *
       * @return {undefined}
       */
      resetLabelsValue: function resetLabelsValue() {
        this.minLab.rzsv = undefined;
        this.maxLab.rzsv = undefined;
        this.flrLab.rzsv = undefined;
        this.ceilLab.rzsv = undefined;
        this.cmbLab.rzsv = undefined;
        this.resetPosition(this.flrLab);
        this.resetPosition(this.ceilLab);
        this.resetPosition(this.cmbLab);
        this.resetPosition(this.minLab);
        this.resetPosition(this.maxLab);
      },
      /**
       * Initialize slider handles positions and labels
       *
       * Run only once during initialization and every time view port changes size
       *
       * @returns {undefined}
       */
      initHandles: function initHandles() {
        this.updateLowHandle(this.valueToPosition(this.lowValue));

        /*
        the order here is important since the selection bar should be
        updated after the high handle but before the combined label
        */
        if (this.range) this.updateHighHandle(this.valueToPosition(this.highValue));
        this.updateSelectionBar();
        if (this.range) this.updateCmbLabel();
        this.updateTicksScale();
      },
      /**
       * Translate value to human readable format
       *
       * @param {number|string} value
       * @param {jqLite} label
       * @param {String} which
       * @param {boolean} [useCustomTr]
       * @returns {undefined}
       */
      translateFn: function translateFn(value, label, which, useCustomTr) {
        useCustomTr = useCustomTr === undefined ? true : useCustomTr;
        var valStr = '',
          getDimension = false,
          noLabelInjection = label.hasClass('no-label-injection');
        if (useCustomTr) {
          if (this.options.stepsArray && !this.options.bindIndexForStepsArray) value = this.getStepValue(value);
          valStr = String(this.customTrFn(value, this.options.id, which));
        } else {
          valStr = String(value);
        }
        if (label.rzsv === undefined || label.rzsv.length !== valStr.length || label.rzsv.length > 0 && label.rzsd === 0) {
          getDimension = true;
          label.rzsv = valStr;
        }
        if (!noLabelInjection) {
          label.html(valStr);
        }
        this.scope[which + 'Label'] = valStr;

        // Update width only when length of the label have changed
        if (getDimension) {
          this.getDimension(label);
        }
      },
      /**
       * Set maximum and minimum values for the slider and ensure the model and high
       * value match these limits
       * @returns {undefined}
       */
      setMinAndMax: function setMinAndMax() {
        this.step = +this.options.step;
        this.precision = +this.options.precision;
        this.minValue = this.options.floor;
        if (this.options.logScale && this.minValue === 0) throw Error("Can't use floor=0 with logarithmic scale");
        if (this.options.enforceStep) {
          this.lowValue = this.roundStep(this.lowValue);
          if (this.range) this.highValue = this.roundStep(this.highValue);
        }
        if (this.options.ceil != null) this.maxValue = this.options.ceil;else this.maxValue = this.options.ceil = this.range ? this.highValue : this.lowValue;
        if (this.options.enforceRange) {
          this.lowValue = this.sanitizeValue(this.lowValue);
          if (this.range) this.highValue = this.sanitizeValue(this.highValue);
        }
        this.applyLowValue();
        if (this.range) this.applyHighValue();
        this.valueRange = this.maxValue - this.minValue;
      },
      /**
       * Adds accessibility attributes
       *
       * Run only once during initialization
       *
       * @returns {undefined}
       */
      addAccessibility: function addAccessibility() {
        this.minH.attr('role', 'slider');
        this.updateAriaAttributes();
        if (this.options.keyboardSupport && !(this.options.readOnly || this.options.disabled)) this.minH.attr('tabindex', '0');else this.minH.attr('tabindex', '');
        if (this.options.vertical) {
          this.minH.attr('aria-orientation', 'vertical');
        } else {
          this.minH.attr('aria-orientation', 'horizontal');
        }
        if (this.options.ariaLabel) this.minH.attr('aria-label', this.options.ariaLabel);else if (this.options.ariaLabelledBy) this.minH.attr('aria-labelledby', this.options.ariaLabelledBy);
        if (this.range) {
          this.maxH.attr('role', 'slider');
          if (this.options.keyboardSupport && !(this.options.readOnly || this.options.disabled)) this.maxH.attr('tabindex', '0');else this.maxH.attr('tabindex', '');
          if (this.options.vertical) this.maxH.attr('aria-orientation', 'vertical');else this.maxH.attr('aria-orientation', 'horizontal');
          if (this.options.ariaLabelHigh) this.maxH.attr('aria-label', this.options.ariaLabelHigh);else if (this.options.ariaLabelledByHigh) this.maxH.attr('aria-labelledby', this.options.ariaLabelledByHigh);
        }
      },
      /**
       * Updates aria attributes according to current values
       */
      updateAriaAttributes: function updateAriaAttributes() {
        this.minH.attr({
          'aria-valuenow': this.scope.rzSliderModel,
          'aria-valuetext': this.customTrFn(this.scope.rzSliderModel, this.options.id, 'model'),
          'aria-valuemin': this.minValue,
          'aria-valuemax': this.maxValue
        });
        if (this.range) {
          this.maxH.attr({
            'aria-valuenow': this.scope.rzSliderHigh,
            'aria-valuetext': this.customTrFn(this.scope.rzSliderHigh, this.options.id, 'high'),
            'aria-valuemin': this.minValue,
            'aria-valuemax': this.maxValue
          });
        }
      },
      /**
       * Calculate dimensions that are dependent on view port size
       *
       * Run once during initialization and every time view port changes size.
       *
       * @returns {undefined}
       */
      calcViewDimensions: function calcViewDimensions() {
        var handleWidth = this.getDimension(this.minH);
        this.handleHalfDim = handleWidth / 2;
        this.barDimension = this.getDimension(this.fullBar);
        this.maxPos = this.barDimension - handleWidth;
        this.getDimension(this.sliderElem);
        this.sliderElem.rzsp = this.sliderElem[0].getBoundingClientRect()[this.positionProperty];
        if (this.initHasRun) {
          this.updateFloorLab();
          this.updateCeilLab();
          this.initHandles();
          var self = this;
          $timeout(function () {
            self.updateTicksScale();
          });
        }
      },
      /**
       * Update the ticks position
       *
       * @returns {undefined}
       */
      updateTicksScale: function updateTicksScale() {
        if (!this.options.showTicks) return;
        var ticksArray = this.options.ticksArray || this.getTicksArray(),
          translate = this.options.vertical ? 'translateY' : 'translateX',
          self = this;
        if (this.options.rightToLeft) ticksArray.reverse();
        this.scope.ticks = ticksArray.map(function (value) {
          var legend = null;
          if (angular.isObject(value)) {
            legend = value.legend;
            value = value.value;
          }
          var position = self.valueToPosition(value);
          if (self.options.vertical) position = self.maxPos - position;
          var translation = translate + '(' + Math.round(position) + 'px)';
          var tick = {
            legend: legend,
            selected: self.isTickSelected(value),
            style: {
              '-webkit-transform': translation,
              '-moz-transform': translation,
              '-o-transform': translation,
              '-ms-transform': translation,
              transform: translation
            }
          };
          if (tick.selected && self.options.getSelectionBarColor) {
            tick.style['background-color'] = self.getSelectionBarColor();
          }
          if (!tick.selected && self.options.getTickColor) {
            tick.style['background-color'] = self.getTickColor(value);
          }
          if (self.options.ticksTooltip) {
            tick.tooltip = self.options.ticksTooltip(value);
            tick.tooltipPlacement = self.options.vertical ? 'right' : 'top';
          }
          if (self.options.showTicksValues === true || value % self.options.showTicksValues === 0) {
            tick.value = self.getDisplayValue(value, 'tick-value');
            if (self.options.ticksValuesTooltip) {
              tick.valueTooltip = self.options.ticksValuesTooltip(value);
              tick.valueTooltipPlacement = self.options.vertical ? 'right' : 'top';
            }
          }
          if (self.getLegend) {
            legend = self.getLegend(value, self.options.id);
            if (legend) tick.legend = legend;
          }
          return tick;
        });
      },
      getTicksArray: function getTicksArray() {
        var step = this.step,
          ticksArray = [];
        if (this.intermediateTicks) step = this.options.showTicks;
        for (var value = this.minValue; value <= this.maxValue; value += step) {
          ticksArray.push(value);
        }
        return ticksArray;
      },
      isTickSelected: function isTickSelected(value) {
        if (!this.range) {
          if (this.options.showSelectionBarFromValue !== null) {
            var center = this.options.showSelectionBarFromValue;
            if (this.lowValue > center && value >= center && value <= this.lowValue) return true;else if (this.lowValue < center && value <= center && value >= this.lowValue) return true;
          } else if (this.options.showSelectionBarEnd) {
            if (value >= this.lowValue) return true;
          } else if (this.options.showSelectionBar && value <= this.lowValue) return true;
        }
        if (this.range && value >= this.lowValue && value <= this.highValue) return true;
        return false;
      },
      /**
       * Update position of the floor label
       *
       * @returns {undefined}
       */
      updateFloorLab: function updateFloorLab() {
        this.translateFn(this.minValue, this.flrLab, 'floor');
        this.getDimension(this.flrLab);
        var position = this.options.rightToLeft ? this.barDimension - this.flrLab.rzsd : 0;
        this.setPosition(this.flrLab, position);
      },
      /**
       * Update position of the ceiling label
       *
       * @returns {undefined}
       */
      updateCeilLab: function updateCeilLab() {
        this.translateFn(this.maxValue, this.ceilLab, 'ceil');
        this.getDimension(this.ceilLab);
        var position = this.options.rightToLeft ? 0 : this.barDimension - this.ceilLab.rzsd;
        this.setPosition(this.ceilLab, position);
      },
      /**
       * Update slider handles and label positions
       *
       * @param {string} which
       * @param {number} newPos
       */
      updateHandles: function updateHandles(which, newPos) {
        if (which === 'lowValue') this.updateLowHandle(newPos);else this.updateHighHandle(newPos);
        this.updateSelectionBar();
        this.updateTicksScale();
        if (this.range) this.updateCmbLabel();
      },
      /**
       * Helper function to work out the position for handle labels depending on RTL or not
       *
       * @param {string} labelName maxLab or minLab
       * @param newPos
       *
       * @returns {number}
       */
      getHandleLabelPos: function getHandleLabelPos(labelName, newPos) {
        var labelRzsd = this[labelName].rzsd,
          nearHandlePos = newPos - labelRzsd / 2 + this.handleHalfDim,
          endOfBarPos = this.barDimension - labelRzsd;
        if (!this.options.boundPointerLabels) return nearHandlePos;
        if (this.options.rightToLeft && labelName === 'minLab' || !this.options.rightToLeft && labelName === 'maxLab') {
          return Math.min(nearHandlePos, endOfBarPos);
        } else {
          return Math.min(Math.max(nearHandlePos, 0), endOfBarPos);
        }
      },
      /**
       * Update low slider handle position and label
       *
       * @param {number} newPos
       * @returns {undefined}
       */
      updateLowHandle: function updateLowHandle(newPos) {
        this.setPosition(this.minH, newPos);
        this.translateFn(this.lowValue, this.minLab, 'model');
        this.setPosition(this.minLab, this.getHandleLabelPos('minLab', newPos));
        if (this.options.getPointerColor) {
          var pointercolor = this.getPointerColor('min');
          this.scope.minPointerStyle = {
            backgroundColor: pointercolor
          };
        }
        if (this.options.autoHideLimitLabels) {
          this.shFloorCeil();
        }
      },
      /**
       * Update high slider handle position and label
       *
       * @param {number} newPos
       * @returns {undefined}
       */
      updateHighHandle: function updateHighHandle(newPos) {
        this.setPosition(this.maxH, newPos);
        this.translateFn(this.highValue, this.maxLab, 'high');
        this.setPosition(this.maxLab, this.getHandleLabelPos('maxLab', newPos));
        if (this.options.getPointerColor) {
          var pointercolor = this.getPointerColor('max');
          this.scope.maxPointerStyle = {
            backgroundColor: pointercolor
          };
        }
        if (this.options.autoHideLimitLabels) {
          this.shFloorCeil();
        }
      },
      /**
       * Show/hide floor/ceiling label
       *
       * @returns {undefined}
       */
      shFloorCeil: function shFloorCeil() {
        // Show based only on hideLimitLabels if pointer labels are hidden
        if (this.options.hidePointerLabels) {
          return;
        }
        var flHidden = false,
          clHidden = false,
          isMinLabAtFloor = this.isLabelBelowFloorLab(this.minLab),
          isMinLabAtCeil = this.isLabelAboveCeilLab(this.minLab),
          isMaxLabAtCeil = this.isLabelAboveCeilLab(this.maxLab),
          isCmbLabAtFloor = this.isLabelBelowFloorLab(this.cmbLab),
          isCmbLabAtCeil = this.isLabelAboveCeilLab(this.cmbLab);
        if (isMinLabAtFloor) {
          flHidden = true;
          this.hideEl(this.flrLab);
        } else {
          flHidden = false;
          this.showEl(this.flrLab);
        }
        if (isMinLabAtCeil) {
          clHidden = true;
          this.hideEl(this.ceilLab);
        } else {
          clHidden = false;
          this.showEl(this.ceilLab);
        }
        if (this.range) {
          var hideCeil = this.cmbLabelShown ? isCmbLabAtCeil : isMaxLabAtCeil;
          var hideFloor = this.cmbLabelShown ? isCmbLabAtFloor : isMinLabAtFloor;
          if (hideCeil) {
            this.hideEl(this.ceilLab);
          } else if (!clHidden) {
            this.showEl(this.ceilLab);
          }

          // Hide or show floor label
          if (hideFloor) {
            this.hideEl(this.flrLab);
          } else if (!flHidden) {
            this.showEl(this.flrLab);
          }
        }
      },
      isLabelBelowFloorLab: function isLabelBelowFloorLab(label) {
        var isRTL = this.options.rightToLeft,
          pos = label.rzsp,
          dim = label.rzsd,
          floorPos = this.flrLab.rzsp,
          floorDim = this.flrLab.rzsd;
        return isRTL ? pos + dim >= floorPos - 2 : pos <= floorPos + floorDim + 2;
      },
      isLabelAboveCeilLab: function isLabelAboveCeilLab(label) {
        var isRTL = this.options.rightToLeft,
          pos = label.rzsp,
          dim = label.rzsd,
          ceilPos = this.ceilLab.rzsp,
          ceilDim = this.ceilLab.rzsd;
        return isRTL ? pos <= ceilPos + ceilDim + 2 : pos + dim >= ceilPos - 2;
      },
      /**
       * Update restricted area bar
       *
       * @returns {undefined}
       */
      updateRestrictionBar: function updateRestrictionBar() {
        var position = 0,
          dimension = 0;
        if (this.options.restrictedRange) {
          this.options.restrictedRange = !Array.isArray(this.options.restrictedRange) ? [this.options.restrictedRange] : this.options.restrictedRange;
          for (var i in this.options.restrictedRange) {
            var from = this.valueToPosition(this.options.restrictedRange[i].from),
              to = this.valueToPosition(this.options.restrictedRange[i].to);
            dimension = Math.abs(to - from);
            position = this.options.rightToLeft ? to + this.handleHalfDim : from + this.handleHalfDim;
            this.setDimension(this.restrictedBar[i], dimension);
            this.setPosition(this.restrictedBar[i], position);
          }
        }
      },
      /**
       * Update slider selection bar, combined label and range label
       *
       * @returns {undefined}
       */
      updateSelectionBar: function updateSelectionBar() {
        var position = 0,
          dimension = 0,
          isSelectionBarFromRight = this.options.rightToLeft ? !this.options.showSelectionBarEnd : this.options.showSelectionBarEnd,
          positionForRange = this.options.rightToLeft ? this.maxH.rzsp + this.handleHalfDim : this.minH.rzsp + this.handleHalfDim;
        if (this.range) {
          dimension = Math.abs(this.maxH.rzsp - this.minH.rzsp);
          position = positionForRange;
        } else {
          if (this.options.showSelectionBarFromValue !== null) {
            var center = this.options.showSelectionBarFromValue,
              centerPosition = this.valueToPosition(center),
              isModelGreaterThanCenter = this.options.rightToLeft ? this.lowValue <= center : this.lowValue > center;
            if (isModelGreaterThanCenter) {
              dimension = this.minH.rzsp - centerPosition;
              position = centerPosition + this.handleHalfDim;
            } else {
              dimension = centerPosition - this.minH.rzsp;
              position = this.minH.rzsp + this.handleHalfDim;
            }
          } else if (isSelectionBarFromRight) {
            dimension = Math.abs(this.maxPos - this.minH.rzsp) + this.handleHalfDim;
            position = this.minH.rzsp + this.handleHalfDim;
          } else {
            dimension = this.minH.rzsp + this.handleHalfDim;
            position = 0;
          }
        }
        this.setDimension(this.selBar, dimension);
        this.setPosition(this.selBar, position);
        if (this.range && this.options.showOuterSelectionBars) {
          if (this.options.rightToLeft) {
            this.setDimension(this.rightOutSelBar, position);
            this.setPosition(this.rightOutSelBar, 0);
            this.setDimension(this.leftOutSelBar, this.getDimension(this.fullBar) - (position + dimension));
            this.setPosition(this.leftOutSelBar, position + dimension);
          } else {
            this.setDimension(this.leftOutSelBar, position);
            this.setPosition(this.leftOutSelBar, 0);
            this.setDimension(this.rightOutSelBar, this.getDimension(this.fullBar) - (position + dimension));
            this.setPosition(this.rightOutSelBar, position + dimension);
          }
        }
        if (this.options.getSelectionBarColor) {
          var color = this.getSelectionBarColor();
          this.scope.barStyle = {
            backgroundColor: color
          };
        } else if (this.options.selectionBarGradient) {
          var offset = this.options.showSelectionBarFromValue !== null ? this.valueToPosition(this.options.showSelectionBarFromValue) : 0,
            reversed = offset - position > 0 ^ isSelectionBarFromRight,
            direction = this.options.vertical ? reversed ? 'bottom' : 'top' : reversed ? 'left' : 'right';
          this.scope.barStyle = {
            backgroundImage: 'linear-gradient(to ' + direction + ', ' + this.options.selectionBarGradient.from + ' 0%,' + this.options.selectionBarGradient.to + ' 100%)'
          };
          if (this.options.vertical) {
            this.scope.barStyle.backgroundPosition = 'center ' + (offset + dimension + position + (reversed ? -this.handleHalfDim : 0)) + 'px';
            this.scope.barStyle.backgroundSize = '100% ' + (this.barDimension - this.handleHalfDim) + 'px';
          } else {
            this.scope.barStyle.backgroundPosition = offset - position + (reversed ? this.handleHalfDim : 0) + 'px center';
            this.scope.barStyle.backgroundSize = this.barDimension - this.handleHalfDim + 'px 100%';
          }
        }
      },
      /**
       * Wrapper around the getSelectionBarColor of the user to pass to
       * correct parameters
       */
      getSelectionBarColor: function getSelectionBarColor() {
        if (this.range) return this.options.getSelectionBarColor(this.scope.rzSliderModel, this.scope.rzSliderHigh);
        return this.options.getSelectionBarColor(this.scope.rzSliderModel);
      },
      /**
       * Wrapper around the getPointerColor of the user to pass to
       * correct parameters
       */
      getPointerColor: function getPointerColor(pointerType) {
        if (pointerType === 'max') {
          return this.options.getPointerColor(this.scope.rzSliderHigh, pointerType);
        }
        return this.options.getPointerColor(this.scope.rzSliderModel, pointerType);
      },
      /**
       * Wrapper around the getTickColor of the user to pass to
       * correct parameters
       */
      getTickColor: function getTickColor(value) {
        return this.options.getTickColor(value);
      },
      /**
       * Update combined label position and value
       *
       * @returns {undefined}
       */
      updateCmbLabel: function updateCmbLabel() {
        var isLabelOverlap = null;
        if (this.options.rightToLeft) {
          isLabelOverlap = this.minLab.rzsp - this.minLab.rzsd - 10 <= this.maxLab.rzsp;
        } else {
          isLabelOverlap = this.minLab.rzsp + this.minLab.rzsd + 10 >= this.maxLab.rzsp;
        }
        if (isLabelOverlap) {
          var lowTr = this.getDisplayValue(this.lowValue, 'model'),
            highTr = this.getDisplayValue(this.highValue, 'high'),
            labelVal = '';
          if (this.options.mergeRangeLabelsIfSame && lowTr === highTr) {
            labelVal = lowTr;
          } else {
            labelVal = this.options.rightToLeft ? highTr + this.options.labelOverlapSeparator + lowTr : lowTr + this.options.labelOverlapSeparator + highTr;
          }
          this.translateFn(labelVal, this.cmbLab, 'cmb', false);
          var pos = this.options.boundPointerLabels ? Math.min(Math.max(this.selBar.rzsp + this.selBar.rzsd / 2 - this.cmbLab.rzsd / 2, 0), this.barDimension - this.cmbLab.rzsd) : this.selBar.rzsp + this.selBar.rzsd / 2 - this.cmbLab.rzsd / 2;
          this.setPosition(this.cmbLab, pos);
          this.cmbLabelShown = true;
          this.hideEl(this.minLab);
          this.hideEl(this.maxLab);
          this.showEl(this.cmbLab);
        } else {
          this.cmbLabelShown = false;
          this.updateHighHandle(this.valueToPosition(this.highValue));
          this.updateLowHandle(this.valueToPosition(this.lowValue));
          this.showEl(this.maxLab);
          this.showEl(this.minLab);
          this.hideEl(this.cmbLab);
        }
        if (this.options.autoHideLimitLabels) {
          this.shFloorCeil();
        }
      },
      /**
       * Return the translated value if a translate function is provided else the original value
       * @param value
       * @param which if it's min or max handle
       * @returns {*}
       */
      getDisplayValue: function getDisplayValue(value, which) {
        if (this.options.stepsArray && !this.options.bindIndexForStepsArray) {
          value = this.getStepValue(value);
        }
        return this.customTrFn(value, this.options.id, which);
      },
      /**
       * Round value to step and precision based on minValue
       *
       * @param {number} value
       * @param {number} customStep a custom step to override the defined step
       * @returns {number}
       */
      roundStep: function roundStep(value, customStep) {
        var step = customStep ? customStep : this.step,
          steppedDifference = parseFloat((value - this.minValue) / step).toPrecision(12);
        steppedDifference = Math.round(+steppedDifference) * step;
        var newValue = (this.minValue + steppedDifference).toFixed(this.precision);
        return +newValue;
      },
      /**
       * Hide element
       *
       * @param element
       * @returns {jqLite} The jqLite wrapped DOM element
       */
      hideEl: function hideEl(element) {
        return element.css({
          visibility: 'hidden'
        });
      },
      /**
       * Show element
       *
       * @param element The jqLite wrapped DOM element
       * @returns {jqLite} The jqLite
       */
      showEl: function showEl(element) {
        if (!!element.rzAlwaysHide) {
          return element;
        }
        return element.css({
          visibility: 'visible'
        });
      },
      /**
       * Set element left/top position depending on whether slider is horizontal or vertical
       *
       * @param {jqLite} elem The jqLite wrapped DOM element
       * @param {number} pos
       * @returns {number}
       */
      setPosition: function setPosition(elem, pos) {
        elem.rzsp = pos;
        var css = {};
        css[this.positionProperty] = Math.round(pos) + 'px';
        elem.css(css);
        return pos;
      },
      resetPosition: function resetPosition(elem) {
        elem.css({
          left: null,
          bottom: null
        });
      },
      /**
       * Get element width/height depending on whether slider is horizontal or vertical
       *
       * @param {jqLite} elem The jqLite wrapped DOM element
       * @returns {number}
       */
      getDimension: function getDimension(elem) {
        var val = elem[0].getBoundingClientRect();
        if (this.options.vertical) elem.rzsd = (val.bottom - val.top) * this.options.scale;else elem.rzsd = (val.right - val.left) * this.options.scale;
        return elem.rzsd;
      },
      /**
       * Set element width/height depending on whether slider is horizontal or vertical
       *
       * @param {jqLite} elem  The jqLite wrapped DOM element
       * @param {number} dim
       * @returns {number}
       */
      setDimension: function setDimension(elem, dim) {
        elem.rzsd = dim;
        var css = {};
        css[this.dimensionProperty] = Math.round(dim) + 'px';
        elem.css(css);
        return dim;
      },
      /**
       * Returns a value that is within slider range
       *
       * @param {number} val
       * @returns {number}
       */
      sanitizeValue: function sanitizeValue(val) {
        return Math.min(Math.max(val, this.minValue), this.maxValue);
      },
      /**
       * Translate value to pixel position
       *
       * @param {number} val
       * @returns {number}
       */
      valueToPosition: function valueToPosition(val) {
        var fn = this.linearValueToPosition;
        if (this.options.customValueToPosition) fn = this.options.customValueToPosition;else if (this.options.logScale) fn = this.logValueToPosition;
        val = this.sanitizeValue(val);
        var percent = fn(val, this.minValue, this.maxValue) || 0;
        if (this.options.rightToLeft) percent = 1 - percent;
        return percent * this.maxPos;
      },
      linearValueToPosition: function linearValueToPosition(val, minVal, maxVal) {
        var range = maxVal - minVal;
        return (val - minVal) / range;
      },
      logValueToPosition: function logValueToPosition(val, minVal, maxVal) {
        val = Math.log(val);
        minVal = Math.log(minVal);
        maxVal = Math.log(maxVal);
        var range = maxVal - minVal;
        return (val - minVal) / range;
      },
      /**
       * Translate position to model value
       *
       * @param {number} position
       * @returns {number}
       */
      positionToValue: function positionToValue(position) {
        var percent = position / this.maxPos;
        if (this.options.rightToLeft) percent = 1 - percent;
        var fn = this.linearPositionToValue;
        if (this.options.customPositionToValue) fn = this.options.customPositionToValue;else if (this.options.logScale) fn = this.logPositionToValue;
        return fn(percent, this.minValue, this.maxValue) || 0;
      },
      linearPositionToValue: function linearPositionToValue(percent, minVal, maxVal) {
        return percent * (maxVal - minVal) + minVal;
      },
      logPositionToValue: function logPositionToValue(percent, minVal, maxVal) {
        minVal = Math.log(minVal);
        maxVal = Math.log(maxVal);
        var value = percent * (maxVal - minVal) + minVal;
        return Math.exp(value);
      },
      getEventAttr: function getEventAttr(event, attr) {
        return event.originalEvent === undefined ? event[attr] : event.originalEvent[attr];
      },
      // Events
      /**
       * Get the X-coordinate or Y-coordinate of an event
       *
       * @param {Object} event  The event
       * @param targetTouchId The identifier of the touch with the X/Y coordinates
       * @returns {number}
       */
      getEventXY: function getEventXY(event, targetTouchId) {
        /* http://stackoverflow.com/a/12336075/282882 */
        //noinspection JSLint
        var clientXY = this.options.vertical ? 'clientY' : 'clientX';
        if (event[clientXY] !== undefined) {
          return event[clientXY];
        }
        var touches = this.getEventAttr(event, 'touches');
        if (targetTouchId !== undefined) {
          for (var i = 0; i < touches.length; i++) {
            if (touches[i].identifier === targetTouchId) {
              return touches[i][clientXY];
            }
          }
        }

        // If no target touch or the target touch was not found in the event
        // returns the coordinates of the first touch
        return touches[0][clientXY];
      },
      /**
       * Compute the event position depending on whether the slider is horizontal or vertical
       * @param event
       * @param targetTouchId If targetTouchId is provided it will be considered the position of that
       * @returns {number}
       */
      getEventPosition: function getEventPosition(event, targetTouchId) {
        var sliderPos = this.sliderElem.rzsp,
          eventPos = 0;
        if (this.options.vertical) eventPos = -this.getEventXY(event, targetTouchId) + sliderPos;else eventPos = this.getEventXY(event, targetTouchId) - sliderPos;
        return eventPos * this.options.scale - this.handleHalfDim; // #346 handleHalfDim is already scaled
      },
      /**
       * Get event names for move and event end
       *
       * @param {Event}    event    The event
       *
       * @return {{moveEvent: string, endEvent: string}}
       */
      getEventNames: function getEventNames(event) {
        var eventNames = {
          moveEvent: '',
          endEvent: ''
        };
        if (this.getEventAttr(event, 'touches')) {
          eventNames.moveEvent = 'touchmove';
          eventNames.endEvent = 'touchend';
        } else {
          eventNames.moveEvent = 'mousemove';
          eventNames.endEvent = 'mouseup';
        }
        return eventNames;
      },
      /**
       * Get the handle closest to an event.
       *
       * @param event {Event} The event
       * @returns {jqLite} The handle closest to the event.
       */
      getNearestHandle: function getNearestHandle(event) {
        if (!this.range) {
          return this.minH;
        }
        var position = this.getEventPosition(event),
          distanceMin = Math.abs(position - this.minH.rzsp),
          distanceMax = Math.abs(position - this.maxH.rzsp);
        if (distanceMin < distanceMax) return this.minH;else if (distanceMin > distanceMax) return this.maxH;else if (!this.options.rightToLeft)
          //if event is at the same distance from min/max then if it's at left of minH, we return minH else maxH
          return position < this.minH.rzsp ? this.minH : this.maxH;
          //reverse in rtl
        else return position > this.minH.rzsp ? this.minH : this.maxH;
      },
      /**
       * Wrapper function to focus an angular element
       *
       * @param el {AngularElement} the element to focus
       */
      focusElement: function focusElement(el) {
        var DOM_ELEMENT = 0;
        el[DOM_ELEMENT].focus();
      },
      /**
       * Bind mouse and touch events to slider handles
       *
       * @returns {undefined}
       */
      bindEvents: function bindEvents() {
        var barTracking, barStart, barMove;
        if (this.options.draggableRange) {
          barTracking = 'rzSliderDrag';
          barStart = this.onDragStart;
          barMove = this.onDragMove;
        } else {
          barTracking = 'lowValue';
          barStart = this.onStart;
          barMove = this.onMove;
        }
        if (!this.options.onlyBindHandles) {
          this.selBar.on('mousedown', angular.bind(this, barStart, null, barTracking));
          this.selBar.on('mousedown', angular.bind(this, barMove, this.selBar));
        }
        if (this.options.draggableRangeOnly) {
          this.minH.on('mousedown', angular.bind(this, barStart, null, barTracking));
          this.maxH.on('mousedown', angular.bind(this, barStart, null, barTracking));
        } else {
          this.minH.on('mousedown', angular.bind(this, this.onStart, this.minH, 'lowValue'));
          if (this.range) {
            this.maxH.on('mousedown', angular.bind(this, this.onStart, this.maxH, 'highValue'));
          }
          if (!this.options.onlyBindHandles) {
            this.fullBar.on('mousedown', angular.bind(this, this.onStart, null, null));
            this.fullBar.on('mousedown', angular.bind(this, this.onMove, this.fullBar));
            this.ticks.on('mousedown', angular.bind(this, this.onStart, null, null));
            this.ticks.on('mousedown', angular.bind(this, this.onTickClick, this.ticks));
          }
        }
        if (!this.options.onlyBindHandles) {
          this.selBar.on('touchstart', angular.bind(this, barStart, null, barTracking));
          this.selBar.on('touchstart', angular.bind(this, barMove, this.selBar));
        }
        if (this.options.draggableRangeOnly) {
          this.minH.on('touchstart', angular.bind(this, barStart, null, barTracking));
          this.maxH.on('touchstart', angular.bind(this, barStart, null, barTracking));
        } else {
          this.minH.on('touchstart', angular.bind(this, this.onStart, this.minH, 'lowValue'));
          if (this.range) {
            this.maxH.on('touchstart', angular.bind(this, this.onStart, this.maxH, 'highValue'));
          }
          if (!this.options.onlyBindHandles) {
            this.fullBar.on('touchstart', angular.bind(this, this.onStart, null, null));
            this.fullBar.on('touchstart', angular.bind(this, this.onMove, this.fullBar));
            this.ticks.on('touchstart', angular.bind(this, this.onStart, null, null));
            this.ticks.on('touchstart', angular.bind(this, this.onTickClick, this.ticks));
          }
        }
        if (this.options.keyboardSupport) {
          this.minH.on('focus', angular.bind(this, this.onPointerFocus, this.minH, 'lowValue'));
          if (this.range) {
            this.maxH.on('focus', angular.bind(this, this.onPointerFocus, this.maxH, 'highValue'));
          }
        }
      },
      /**
       * Unbind mouse and touch events to slider handles
       *
       * @returns {undefined}
       */
      unbindEvents: function unbindEvents() {
        this.minH.off();
        this.maxH.off();
        this.fullBar.off();
        this.selBar.off();
        this.ticks.off();
      },
      /**
       * onStart event handler
       *
       * @param {?Object} pointer The jqLite wrapped DOM element; if null, the closest handle is used
       * @param {?string} ref     The name of the handle being changed; if null, the closest handle's value is modified
       * @param {Event}   event   The event
       * @returns {undefined}
       */
      onStart: function onStart(pointer, ref, event) {
        var ehMove,
          ehEnd,
          eventNames = this.getEventNames(event);
        event.stopPropagation();
        event.preventDefault();

        // We have to do this in case the HTML where the sliders are on
        // have been animated into view.
        this.calcViewDimensions();
        if (pointer) {
          this.tracking = ref;
        } else {
          pointer = this.getNearestHandle(event);
          this.tracking = pointer === this.minH ? 'lowValue' : 'highValue';
        }
        pointer.addClass('rz-active');
        if (this.options.keyboardSupport) this.focusElement(pointer);
        ehMove = angular.bind(this, this.dragging.active ? this.onDragMove : this.onMove, pointer);
        ehEnd = angular.bind(this, this.onEnd, ehMove);
        $document.on(eventNames.moveEvent, ehMove);
        $document.on(eventNames.endEvent, ehEnd);
        this.endHandlerToBeRemovedOnEnd = ehEnd;
        this.callOnStart();
        var changedTouches = this.getEventAttr(event, 'changedTouches');
        if (changedTouches) {
          // Store the touch identifier
          if (!this.touchId) {
            this.isDragging = true;
            this.touchId = changedTouches[0].identifier;
          }
        }
      },
      /**
       * onMove event handler
       *
       * @param {jqLite} pointer
       * @param {Event}  event The event
       * @param {boolean}  fromTick if the event occured on a tick or not
       * @returns {undefined}
       */
      onMove: function onMove(pointer, event, fromTick) {
        if (!this.options.disableAnimation) {
          if (this.moving) {
            this.sliderElem.addClass('noanimate');
          }
        }
        this.moving = true;
        var changedTouches = this.getEventAttr(event, 'changedTouches');
        var touchForThisSlider;
        if (changedTouches) {
          for (var i = 0; i < changedTouches.length; i++) {
            if (changedTouches[i].identifier === this.touchId) {
              touchForThisSlider = changedTouches[i];
              break;
            }
          }
        }
        if (changedTouches && !touchForThisSlider) {
          return;
        }
        var newPos = this.getEventPosition(event, touchForThisSlider ? touchForThisSlider.identifier : undefined),
          newValue,
          ceilValue = this.options.rightToLeft ? this.minValue : this.maxValue,
          flrValue = this.options.rightToLeft ? this.maxValue : this.minValue;
        if (newPos <= 0) {
          newValue = flrValue;
        } else if (newPos >= this.maxPos) {
          newValue = ceilValue;
        } else {
          newValue = this.positionToValue(newPos);
          if (fromTick && angular.isNumber(this.options.showTicks)) newValue = this.roundStep(newValue, this.options.showTicks);else newValue = this.roundStep(newValue);
        }
        this.positionTrackingHandle(newValue);
      },
      /**
       * onEnd event handler
       *
       * @param {Event}    event    The event
       * @param {Function} ehMove   The bound move event handler
       * @returns {undefined}
       */
      onEnd: function onEnd(ehMove, event) {
        this.moving = false;
        if (!this.options.disableAnimation) {
          this.sliderElem.removeClass('noanimate');
        }
        var changedTouches = this.getEventAttr(event, 'changedTouches');
        if (changedTouches && changedTouches[0].identifier !== this.touchId) {
          return;
        }
        this.isDragging = false;
        this.touchId = null;
        if (!this.options.keyboardSupport) {
          this.minH.removeClass('rz-active');
          this.maxH.removeClass('rz-active');
          this.tracking = '';
        }
        this.dragging.active = false;
        var eventName = this.getEventNames(event);
        $document.off(eventName.moveEvent, ehMove);
        $document.off(eventName.endEvent, this.endHandlerToBeRemovedOnEnd);
        this.endHandlerToBeRemovedOnEnd = null;
        this.callOnEnd();
      },
      onTickClick: function onTickClick(pointer, event) {
        this.onMove(pointer, event, true);
      },
      onPointerFocus: function onPointerFocus(pointer, ref) {
        this.tracking = ref;
        pointer.one('blur', angular.bind(this, this.onPointerBlur, pointer));
        pointer.on('keydown', angular.bind(this, this.onKeyboardEvent));
        pointer.on('keyup', angular.bind(this, this.onKeyUp));
        this.firstKeyDown = true;
        pointer.addClass('rz-active');
        this.currentFocusElement = {
          pointer: pointer,
          ref: ref
        };
      },
      onKeyUp: function onKeyUp() {
        this.firstKeyDown = true;
        this.callOnEnd();
      },
      onPointerBlur: function onPointerBlur(pointer) {
        pointer.off('keydown');
        pointer.off('keyup');
        pointer.removeClass('rz-active');
        if (!this.isDragging) {
          this.tracking = '';
          this.currentFocusElement = null;
        }
      },
      /**
       * Skip restricted range function when arrow keys use
       *
       * @param {number} currentValue value of the slider
       * @param {number} key arrow key used
       *
       * @returns {number} currentValue value of the slider
       */

      skipRestrictedRanges: function skipRestrictedRanges(key, currentValue) {
        if (this.options.restrictedRange && Array.isArray(this.options.restrictedRange)) {
          for (var i in this.options.restrictedRange) {
            var range = this.options.restrictedRange[i];
            // if it first or last value
            if (range.from === 0 && currentValue === 0 && [37, 40].includes(key) ||
            // LEFT or DOWN
            range.to >= this.options.restrictedRange[this.options.restrictedRange.length - 1].to && currentValue >= this.options.restrictedRange[this.options.restrictedRange.length - 1].to && [38, 39].includes(key) // UP or RIGHT
            ) {
              return currentValue;
            }
            if (range.to > currentValue && currentValue > range.from) {
              if (Math.abs(range.to - currentValue) > Math.abs(range.from - currentValue)) {
                currentValue = range.to;
              } else {
                currentValue = range.from;
              }
            }
          }
        }
        return currentValue;
      },
      /**
       * Key actions helper function
       *
       * @param {number} currentValue value of the slider
       *
       * @returns {?Object} action value mappings
       */
      getKeyActions: function getKeyActions(currentValue) {
        var increaseStep = currentValue + this.step,
          decreaseStep = currentValue - this.step,
          increasePage = currentValue + this.valueRange / 10,
          decreasePage = currentValue - this.valueRange / 10;
        if (this.options.reversedControls) {
          increaseStep = currentValue - this.step;
          decreaseStep = currentValue + this.step;
          increasePage = currentValue - this.valueRange / 10;
          decreasePage = currentValue + this.valueRange / 10;
        }

        //Left to right default actions
        var actions = {
          UP: increaseStep,
          DOWN: decreaseStep,
          LEFT: decreaseStep,
          RIGHT: increaseStep,
          PAGEUP: increasePage,
          PAGEDOWN: decreasePage,
          HOME: this.options.reversedControls ? this.maxValue : this.minValue,
          END: this.options.reversedControls ? this.minValue : this.maxValue
        };
        //right to left means swapping right and left arrows
        if (this.options.rightToLeft) {
          actions.LEFT = increaseStep;
          actions.RIGHT = decreaseStep;
          // right to left and vertical means we also swap up and down
          if (this.options.vertical) {
            actions.UP = decreaseStep;
            actions.DOWN = increaseStep;
          }
        }
        return actions;
      },
      onKeyboardEvent: function onKeyboardEvent(event) {
        var keyCode = event.keyCode || event.which;
        var currentValue = this[this.tracking];
        var keys = {
            38: 'UP',
            40: 'DOWN',
            37: 'LEFT',
            39: 'RIGHT',
            33: 'PAGEUP',
            34: 'PAGEDOWN',
            36: 'HOME',
            35: 'END'
          },
          actions = this.getKeyActions(currentValue),
          key = keys[keyCode],
          action = actions[key];
        if (action == null || this.tracking === '') return;
        event.preventDefault();
        if (this.firstKeyDown) {
          this.firstKeyDown = false;
          this.callOnStart();
        }
        var self = this;
        $timeout(function () {
          var newValue = self.roundStep(self.sanitizeValue(action));
          newValue = self.options.skipRestrictedRangesWithArrowKeys ? self.skipRestrictedRanges(keyCode, newValue) : newValue;
          if (!self.options.draggableRangeOnly) {
            self.positionTrackingHandle(newValue);
          } else {
            var difference = self.highValue - self.lowValue,
              newMinValue,
              newMaxValue;
            if (self.tracking === 'lowValue') {
              newMinValue = newValue;
              newMaxValue = newValue + difference;
              if (newMaxValue > self.maxValue) {
                newMaxValue = self.maxValue;
                newMinValue = newMaxValue - difference;
              }
            } else {
              newMaxValue = newValue;
              newMinValue = newValue - difference;
              if (newMinValue < self.minValue) {
                newMinValue = self.minValue;
                newMaxValue = newMinValue + difference;
              }
            }
            self.positionTrackingBar(newMinValue, newMaxValue);
          }
        });
      },
      /**
       * onDragStart event handler
       *
       * Handles dragging of the middle bar.
       *
       * @param {Object} pointer The jqLite wrapped DOM element
       * @param {string} ref     One of the refLow, refHigh values
       * @param {Event}  event   The event
       * @returns {undefined}
       */
      onDragStart: function onDragStart(pointer, ref, event) {
        var position = this.getEventPosition(event);
        this.dragging = {
          active: true,
          value: this.positionToValue(position),
          difference: this.highValue - this.lowValue,
          lowLimit: this.options.rightToLeft ? this.minH.rzsp - position : position - this.minH.rzsp,
          highLimit: this.options.rightToLeft ? position - this.maxH.rzsp : this.maxH.rzsp - position
        };
        this.onStart(pointer, ref, event);
      },
      /**
       * getValue helper function
       *
       * gets max or min value depending on whether the newPos is outOfBounds above or below the bar and rightToLeft
       *
       * @param {string} type 'max' || 'min' The value we are calculating
       * @param {number} newPos  The new position
       * @param {boolean} outOfBounds Is the new position above or below the max/min?
       * @param {boolean} isAbove Is the new position above the bar if out of bounds?
       *
       * @returns {number}
       */
      getValue: function getValue(type, newPos, outOfBounds, isAbove) {
        var isRTL = this.options.rightToLeft,
          value = null;
        if (type === 'min') {
          if (outOfBounds) {
            if (isAbove) {
              value = isRTL ? this.minValue : this.maxValue - this.dragging.difference;
            } else {
              value = isRTL ? this.maxValue - this.dragging.difference : this.minValue;
            }
          } else {
            value = isRTL ? this.positionToValue(newPos + this.dragging.lowLimit) : this.positionToValue(newPos - this.dragging.lowLimit);
          }
        } else {
          if (outOfBounds) {
            if (isAbove) {
              value = isRTL ? this.minValue + this.dragging.difference : this.maxValue;
            } else {
              value = isRTL ? this.maxValue : this.minValue + this.dragging.difference;
            }
          } else {
            if (isRTL) {
              value = this.positionToValue(newPos + this.dragging.lowLimit) + this.dragging.difference;
            } else {
              value = this.positionToValue(newPos - this.dragging.lowLimit) + this.dragging.difference;
            }
          }
        }
        return this.roundStep(value);
      },
      /**
       * onDragMove event handler
       *
       * Handles dragging of the middle bar.
       *
       * @param {jqLite} pointer
       * @param {Event}  event The event
       * @returns {undefined}
       */
      onDragMove: function onDragMove(pointer, event) {
        if (!this.options.disableAnimation) {
          if (this.moving) {
            this.sliderElem.addClass('noanimate');
          }
        }
        this.moving = true;
        var newPos = this.getEventPosition(event),
          newMinValue,
          newMaxValue,
          ceilLimit,
          flrLimit,
          isUnderFlrLimit,
          isOverCeilLimit,
          flrH,
          ceilH;
        if (this.options.rightToLeft) {
          ceilLimit = this.dragging.lowLimit;
          flrLimit = this.dragging.highLimit;
          flrH = this.maxH;
          ceilH = this.minH;
        } else {
          ceilLimit = this.dragging.highLimit;
          flrLimit = this.dragging.lowLimit;
          flrH = this.minH;
          ceilH = this.maxH;
        }
        isUnderFlrLimit = newPos <= flrLimit;
        isOverCeilLimit = newPos >= this.maxPos - ceilLimit;
        if (isUnderFlrLimit) {
          if (flrH.rzsp === 0) return;
          newMinValue = this.getValue('min', newPos, true, false);
          newMaxValue = this.getValue('max', newPos, true, false);
        } else if (isOverCeilLimit) {
          if (ceilH.rzsp === this.maxPos) return;
          newMaxValue = this.getValue('max', newPos, true, true);
          newMinValue = this.getValue('min', newPos, true, true);
        } else {
          newMinValue = this.getValue('min', newPos, false);
          newMaxValue = this.getValue('max', newPos, false);
        }
        this.positionTrackingBar(newMinValue, newMaxValue);
      },
      /**
       * Set the new value and position for the entire bar
       *
       * @param {number} newMinValue   the new minimum value
       * @param {number} newMaxValue   the new maximum value
       */
      positionTrackingBar: function positionTrackingBar(newMinValue, newMaxValue) {
        if (this.options.minLimit != null && newMinValue < this.options.minLimit) {
          newMinValue = this.options.minLimit;
          newMaxValue = newMinValue + this.dragging.difference;
        }
        if (this.options.maxLimit != null && newMaxValue > this.options.maxLimit) {
          newMaxValue = this.options.maxLimit;
          newMinValue = newMaxValue - this.dragging.difference;
        }
        this.lowValue = newMinValue;
        this.highValue = newMaxValue;
        this.applyLowValue();
        if (this.range) this.applyHighValue();
        this.applyModel(true);
        this.updateHandles('lowValue', this.valueToPosition(newMinValue));
        this.updateHandles('highValue', this.valueToPosition(newMaxValue));
      },
      /**
       * Set the new value and position to the current tracking handle
       *
       * @param {number} newValue new model value
       */
      positionTrackingHandle: function positionTrackingHandle(newValue) {
        var valueChanged = false;
        newValue = this.applyMinMaxLimit(newValue);
        newValue = this.applyRestrictedRange(newValue);
        if (this.range) {
          if (this.options.pushRange) {
            newValue = this.applyPushRange(newValue);
            valueChanged = true;
          } else {
            if (this.options.noSwitching) {
              if (this.tracking === 'lowValue' && newValue > this.highValue) newValue = this.applyMinMaxRange(this.highValue);else if (this.tracking === 'highValue' && newValue < this.lowValue) newValue = this.applyMinMaxRange(this.lowValue);
            }
            newValue = this.applyMinMaxRange(newValue);
            /* This is to check if we need to switch the min and max handles */
            if (this.tracking === 'lowValue' && newValue > this.highValue) {
              this.lowValue = this.highValue;
              this.applyLowValue();
              this.applyModel();
              this.updateHandles(this.tracking, this.maxH.rzsp);
              this.updateAriaAttributes();
              this.tracking = 'highValue';
              this.minH.removeClass('rz-active');
              this.maxH.addClass('rz-active');
              if (this.options.keyboardSupport) this.focusElement(this.maxH);
              valueChanged = true;
            } else if (this.tracking === 'highValue' && newValue < this.lowValue) {
              this.highValue = this.lowValue;
              this.applyHighValue();
              this.applyModel();
              this.updateHandles(this.tracking, this.minH.rzsp);
              this.updateAriaAttributes();
              this.tracking = 'lowValue';
              this.maxH.removeClass('rz-active');
              this.minH.addClass('rz-active');
              if (this.options.keyboardSupport) this.focusElement(this.minH);
              valueChanged = true;
            }
          }
        }
        if (this[this.tracking] !== newValue) {
          this[this.tracking] = newValue;
          if (this.tracking === 'lowValue') this.applyLowValue();else this.applyHighValue();
          this.applyModel();
          this.updateHandles(this.tracking, this.valueToPosition(newValue));
          this.updateAriaAttributes();
          valueChanged = true;
        }
        if (valueChanged) this.applyModel(true);
      },
      applyMinMaxLimit: function applyMinMaxLimit(newValue) {
        if (this.options.minLimit != null && newValue < this.options.minLimit) return this.options.minLimit;
        if (this.options.maxLimit != null && newValue > this.options.maxLimit) return this.options.maxLimit;
        return newValue;
      },
      applyMinMaxRange: function applyMinMaxRange(newValue) {
        var oppositeValue = this.tracking === 'lowValue' ? this.highValue : this.lowValue,
          difference = Math.abs(newValue - oppositeValue);
        if (this.options.minRange != null) {
          if (difference < this.options.minRange) {
            if (this.tracking === 'lowValue') return this.highValue - this.options.minRange;else return this.lowValue + this.options.minRange;
          }
        }
        if (this.options.maxRange != null) {
          if (difference > this.options.maxRange) {
            if (this.tracking === 'lowValue') return this.highValue - this.options.maxRange;else return this.lowValue + this.options.maxRange;
          }
        }
        return newValue;
      },
      applyRestrictedRange: function applyRestrictedRange(newValue) {
        for (var i in this.options.restrictedRange) {
          if (this.options.restrictedRange[i] != null && newValue > this.options.restrictedRange[i].from && newValue < this.options.restrictedRange[i].to) {
            var halfWidth = (this.options.restrictedRange[i].to - this.options.restrictedRange[i].from) / 2;
            if (this.tracking === 'lowValue') {
              return newValue > this.options.restrictedRange[i].from + halfWidth ? this.options.restrictedRange[i].to : this.options.restrictedRange[i].from;
            }
            if (this.tracking === 'highValue') {
              return newValue < this.options.restrictedRange[i].to - halfWidth ? this.options.restrictedRange[i].from : this.options.restrictedRange[i].to;
            }
          }
        }
        return newValue;
      },
      applyPushRange: function applyPushRange(newValue) {
        var difference = this.tracking === 'lowValue' ? this.highValue - newValue : newValue - this.lowValue,
          minRange = this.options.minRange !== null ? this.options.minRange : this.options.step,
          maxRange = this.options.maxRange;
        // if smaller than minRange
        if (difference < minRange) {
          if (this.tracking === 'lowValue') {
            this.highValue = Math.min(newValue + minRange, this.maxValue);
            newValue = this.highValue - minRange;
            this.applyHighValue();
            this.updateHandles('highValue', this.valueToPosition(this.highValue));
          } else {
            this.lowValue = Math.max(newValue - minRange, this.minValue);
            newValue = this.lowValue + minRange;
            this.applyLowValue();
            this.updateHandles('lowValue', this.valueToPosition(this.lowValue));
          }
          this.updateAriaAttributes();
        } else if (maxRange !== null && difference > maxRange) {
          // if greater than maxRange
          if (this.tracking === 'lowValue') {
            this.highValue = newValue + maxRange;
            this.applyHighValue();
            this.updateHandles('highValue', this.valueToPosition(this.highValue));
          } else {
            this.lowValue = newValue - maxRange;
            this.applyLowValue();
            this.updateHandles('lowValue', this.valueToPosition(this.lowValue));
          }
          this.updateAriaAttributes();
        }
        return newValue;
      },
      /**
       * Apply the model values using scope.$apply.
       * We wrap it with the internalChange flag to avoid the watchers to be called
       */
      applyModel: function applyModel(callOnChange) {
        this.internalChange = true;
        this.scope.$apply();
        callOnChange && this.callOnChange();
        this.internalChange = false;
      },
      /**
       * Call the onStart callback if defined
       * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
       *
       * @returns {undefined}
       */
      callOnStart: function callOnStart() {
        if (this.options.onStart) {
          var self = this,
            pointerType = this.tracking === 'lowValue' ? 'min' : 'max';
          this.scope.$evalAsync(function () {
            self.options.onStart(self.options.id, self.scope.rzSliderModel, self.scope.rzSliderHigh, pointerType);
          });
        }
      },
      /**
       * Call the onChange callback if defined
       * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
       *
       * @returns {undefined}
       */
      callOnChange: function callOnChange() {
        if (this.options.onChange) {
          var self = this,
            pointerType = this.tracking === 'lowValue' ? 'min' : 'max';
          this.scope.$evalAsync(function () {
            self.options.onChange(self.options.id, self.scope.rzSliderModel, self.scope.rzSliderHigh, pointerType);
          });
        }
      },
      /**
       * Call the onEnd callback if defined
       * The callback call is wrapped in a $evalAsync to ensure that its result will be applied to the scope.
       *
       * @returns {undefined}
       */
      callOnEnd: function callOnEnd() {
        if (this.options.onEnd) {
          var self = this,
            pointerType = this.tracking === 'lowValue' ? 'min' : 'max';
          this.scope.$evalAsync(function () {
            self.options.onEnd(self.options.id, self.scope.rzSliderModel, self.scope.rzSliderHigh, pointerType);
          });
        }
        this.scope.$emit('slideEnded');
      }
    };
    return Slider;
  }]).directive('rzslider', ['RzSlider', function (RzSlider) {
    'use strict';

    return {
      restrict: 'AE',
      replace: true,
      scope: {
        rzSliderModel: '=?',
        rzSliderHigh: '=?',
        rzSliderOptions: '&?',
        rzSliderTplUrl: '@'
      },
      /**
       * Return template URL
       *
       * @param {jqLite} elem
       * @param {Object} attrs
       * @return {string}
       */
      templateUrl: function templateUrl(elem, attrs) {
        //noinspection JSUnresolvedVariable
        return attrs.rzSliderTplUrl || 'rzSliderTpl.html';
      },
      link: function link(scope, elem) {
        scope.slider = new RzSlider(scope, elem); //attach on scope so we can test it
      }
    };
  }]);

  // IDE assist

  /**
   * @name ngScope
   *
   * @property {number} rzSliderModel
   * @property {number} rzSliderHigh
   * @property {Object} rzSliderOptions
   */

  /**
   * @name jqLite
   *
   * @property {number|undefined} rzsp rzslider label position position
   * @property {number|undefined} rzsd rzslider element dimension
   * @property {string|undefined} rzsv rzslider label value/text
   * @property {Function} css
   * @property {Function} text
   */

  /**
   * @name Event
   * @property {Array} touches
   * @property {Event} originalEvent
   */

  /**
   * @name ThrottleOptions
   *
   * @property {boolean} leading
   * @property {boolean} trailing
   */

  module.run(['$templateCache', function ($templateCache) {
    'use strict';

    $templateCache.put('rzSliderTpl.html', "<div class=rzslider><span class=\"rz-bar-wrapper rz-left-out-selection\"><span class=rz-bar></span></span> <span class=\"rz-bar-wrapper rz-right-out-selection\"><span class=rz-bar></span></span> <span class=rz-bar-wrapper><span class=rz-bar></span></span> <span class=rz-bar-wrapper><span class=\"rz-bar rz-selection\" ng-style=barStyle></span></span> <span class=rz-bar-wrapper><span class=\"rz-bar rz-restricted\" ng-style=restrictionStyle></span></span> <span class=\"rz-pointer rz-pointer-min\" ng-style=minPointerStyle></span> <span class=\"rz-pointer rz-pointer-max\" ng-style=maxPointerStyle></span> <span class=\"rz-bubble rz-limit rz-floor\"></span> <span class=\"rz-bubble rz-limit rz-ceil\"></span> <span class=\"rz-bubble rz-model-value\"></span> <span class=\"rz-bubble rz-model-high\"></span> <span class=rz-bubble></span><ul ng-show=showTicks class=rz-ticks><li ng-repeat=\"t in ticks track by $index\" class=rz-tick ng-class=\"{'rz-selected': t.selected}\" ng-style=t.style ng-attr-uib-tooltip=\"{{ t.tooltip }}\" ng-attr-tooltip-placement={{t.tooltipPlacement}} ng-attr-tooltip-append-to-body=\"{{ t.tooltip ? true : undefined}}\"><span ng-if=\"t.value != null\" class=rz-tick-value ng-attr-uib-tooltip=\"{{ t.valueTooltip }}\" ng-attr-tooltip-placement={{t.valueTooltipPlacement}}>{{ t.value }}</span> <span ng-if=\"t.legend != null\" class=rz-tick-legend>{{ t.legend }}</span></li></ul></div>");
  }]);
  return module.name;
});
/**
 * @license
 * Lodash <https://lodash.com/>
 * Copyright OpenJS Foundation and other contributors <https://openjsf.org/>
 * Released under MIT license <https://lodash.com/license>
 * Based on Underscore.js 1.8.3 <http://underscorejs.org/LICENSE>
 * Copyright Jeremy Ashkenas, DocumentCloud and Investigative Reporters & Editors
 */
;
(function () {
  /** Used as a safe reference for `undefined` in pre-ES5 environments. */
  var undefined;

  /** Used as the semantic version number. */
  var VERSION = '4.17.21';

  /** Used as the size to enable large array optimizations. */
  var LARGE_ARRAY_SIZE = 200;

  /** Error message constants. */
  var CORE_ERROR_TEXT = 'Unsupported core-js use. Try https://npms.io/search?q=ponyfill.',
    FUNC_ERROR_TEXT = 'Expected a function',
    INVALID_TEMPL_VAR_ERROR_TEXT = 'Invalid `variable` option passed into `_.template`';

  /** Used to stand-in for `undefined` hash values. */
  var HASH_UNDEFINED = '__lodash_hash_undefined__';

  /** Used as the maximum memoize cache size. */
  var MAX_MEMOIZE_SIZE = 500;

  /** Used as the internal argument placeholder. */
  var PLACEHOLDER = '__lodash_placeholder__';

  /** Used to compose bitmasks for cloning. */
  var CLONE_DEEP_FLAG = 1,
    CLONE_FLAT_FLAG = 2,
    CLONE_SYMBOLS_FLAG = 4;

  /** Used to compose bitmasks for value comparisons. */
  var COMPARE_PARTIAL_FLAG = 1,
    COMPARE_UNORDERED_FLAG = 2;

  /** Used to compose bitmasks for function metadata. */
  var WRAP_BIND_FLAG = 1,
    WRAP_BIND_KEY_FLAG = 2,
    WRAP_CURRY_BOUND_FLAG = 4,
    WRAP_CURRY_FLAG = 8,
    WRAP_CURRY_RIGHT_FLAG = 16,
    WRAP_PARTIAL_FLAG = 32,
    WRAP_PARTIAL_RIGHT_FLAG = 64,
    WRAP_ARY_FLAG = 128,
    WRAP_REARG_FLAG = 256,
    WRAP_FLIP_FLAG = 512;

  /** Used as default options for `_.truncate`. */
  var DEFAULT_TRUNC_LENGTH = 30,
    DEFAULT_TRUNC_OMISSION = '...';

  /** Used to detect hot functions by number of calls within a span of milliseconds. */
  var HOT_COUNT = 800,
    HOT_SPAN = 16;

  /** Used to indicate the type of lazy iteratees. */
  var LAZY_FILTER_FLAG = 1,
    LAZY_MAP_FLAG = 2,
    LAZY_WHILE_FLAG = 3;

  /** Used as references for various `Number` constants. */
  var INFINITY = 1 / 0,
    MAX_SAFE_INTEGER = 9007199254740991,
    MAX_INTEGER = 1.7976931348623157e+308,
    NAN = 0 / 0;

  /** Used as references for the maximum length and index of an array. */
  var MAX_ARRAY_LENGTH = 4294967295,
    MAX_ARRAY_INDEX = MAX_ARRAY_LENGTH - 1,
    HALF_MAX_ARRAY_LENGTH = MAX_ARRAY_LENGTH >>> 1;

  /** Used to associate wrap methods with their bit flags. */
  var wrapFlags = [['ary', WRAP_ARY_FLAG], ['bind', WRAP_BIND_FLAG], ['bindKey', WRAP_BIND_KEY_FLAG], ['curry', WRAP_CURRY_FLAG], ['curryRight', WRAP_CURRY_RIGHT_FLAG], ['flip', WRAP_FLIP_FLAG], ['partial', WRAP_PARTIAL_FLAG], ['partialRight', WRAP_PARTIAL_RIGHT_FLAG], ['rearg', WRAP_REARG_FLAG]];

  /** `Object#toString` result references. */
  var argsTag = '[object Arguments]',
    arrayTag = '[object Array]',
    asyncTag = '[object AsyncFunction]',
    boolTag = '[object Boolean]',
    dateTag = '[object Date]',
    domExcTag = '[object DOMException]',
    errorTag = '[object Error]',
    funcTag = '[object Function]',
    genTag = '[object GeneratorFunction]',
    mapTag = '[object Map]',
    numberTag = '[object Number]',
    nullTag = '[object Null]',
    objectTag = '[object Object]',
    promiseTag = '[object Promise]',
    proxyTag = '[object Proxy]',
    regexpTag = '[object RegExp]',
    setTag = '[object Set]',
    stringTag = '[object String]',
    symbolTag = '[object Symbol]',
    undefinedTag = '[object Undefined]',
    weakMapTag = '[object WeakMap]',
    weakSetTag = '[object WeakSet]';
  var arrayBufferTag = '[object ArrayBuffer]',
    dataViewTag = '[object DataView]',
    float32Tag = '[object Float32Array]',
    float64Tag = '[object Float64Array]',
    int8Tag = '[object Int8Array]',
    int16Tag = '[object Int16Array]',
    int32Tag = '[object Int32Array]',
    uint8Tag = '[object Uint8Array]',
    uint8ClampedTag = '[object Uint8ClampedArray]',
    uint16Tag = '[object Uint16Array]',
    uint32Tag = '[object Uint32Array]';

  /** Used to match empty string literals in compiled template source. */
  var reEmptyStringLeading = /\b__p \+= '';/g,
    reEmptyStringMiddle = /\b(__p \+=) '' \+/g,
    reEmptyStringTrailing = /(__e\(.*?\)|\b__t\)) \+\n'';/g;

  /** Used to match HTML entities and HTML characters. */
  var reEscapedHtml = /&(?:amp|lt|gt|quot|#39);/g,
    reUnescapedHtml = /[&<>"']/g,
    reHasEscapedHtml = RegExp(reEscapedHtml.source),
    reHasUnescapedHtml = RegExp(reUnescapedHtml.source);

  /** Used to match template delimiters. */
  var reEscape = /<%-([\s\S]+?)%>/g,
    reEvaluate = /<%([\s\S]+?)%>/g,
    reInterpolate = /<%=([\s\S]+?)%>/g;

  /** Used to match property names within property paths. */
  var reIsDeepProp = /\.|\[(?:[^[\]]*|(["'])(?:(?!\1)[^\\]|\\.)*?\1)\]/,
    reIsPlainProp = /^\w*$/,
    rePropName = /[^.[\]]+|\[(?:(-?\d+(?:\.\d+)?)|(["'])((?:(?!\2)[^\\]|\\.)*?)\2)\]|(?=(?:\.|\[\])(?:\.|\[\]|$))/g;

  /**
   * Used to match `RegExp`
   * [syntax characters](http://ecma-international.org/ecma-262/7.0/#sec-patterns).
   */
  var reRegExpChar = /[\\^$.*+?()[\]{}|]/g,
    reHasRegExpChar = RegExp(reRegExpChar.source);

  /** Used to match leading whitespace. */
  var reTrimStart = /^\s+/;

  /** Used to match a single whitespace character. */
  var reWhitespace = /\s/;

  /** Used to match wrap detail comments. */
  var reWrapComment = /\{(?:\n\/\* \[wrapped with .+\] \*\/)?\n?/,
    reWrapDetails = /\{\n\/\* \[wrapped with (.+)\] \*/,
    reSplitDetails = /,? & /;

  /** Used to match words composed of alphanumeric characters. */
  var reAsciiWord = /[^\x00-\x2f\x3a-\x40\x5b-\x60\x7b-\x7f]+/g;

  /**
   * Used to validate the `validate` option in `_.template` variable.
   *
   * Forbids characters which could potentially change the meaning of the function argument definition:
   * - "()," (modification of function parameters)
   * - "=" (default value)
   * - "[]{}" (destructuring of function parameters)
   * - "/" (beginning of a comment)
   * - whitespace
   */
  var reForbiddenIdentifierChars = /[()=,{}\[\]\/\s]/;

  /** Used to match backslashes in property paths. */
  var reEscapeChar = /\\(\\)?/g;

  /**
   * Used to match
   * [ES template delimiters](http://ecma-international.org/ecma-262/7.0/#sec-template-literal-lexical-components).
   */
  var reEsTemplate = /\$\{([^\\}]*(?:\\.[^\\}]*)*)\}/g;

  /** Used to match `RegExp` flags from their coerced string values. */
  var reFlags = /\w*$/;

  /** Used to detect bad signed hexadecimal string values. */
  var reIsBadHex = /^[-+]0x[0-9a-f]+$/i;

  /** Used to detect binary string values. */
  var reIsBinary = /^0b[01]+$/i;

  /** Used to detect host constructors (Safari). */
  var reIsHostCtor = /^\[object .+?Constructor\]$/;

  /** Used to detect octal string values. */
  var reIsOctal = /^0o[0-7]+$/i;

  /** Used to detect unsigned integer values. */
  var reIsUint = /^(?:0|[1-9]\d*)$/;

  /** Used to match Latin Unicode letters (excluding mathematical operators). */
  var reLatin = /[\xc0-\xd6\xd8-\xf6\xf8-\xff\u0100-\u017f]/g;

  /** Used to ensure capturing order of template delimiters. */
  var reNoMatch = /($^)/;

  /** Used to match unescaped characters in compiled string literals. */
  var reUnescapedString = /['\n\r\u2028\u2029\\]/g;

  /** Used to compose unicode character classes. */
  var rsAstralRange = "\\ud800-\\udfff",
    rsComboMarksRange = "\\u0300-\\u036f",
    reComboHalfMarksRange = "\\ufe20-\\ufe2f",
    rsComboSymbolsRange = "\\u20d0-\\u20ff",
    rsComboRange = rsComboMarksRange + reComboHalfMarksRange + rsComboSymbolsRange,
    rsDingbatRange = "\\u2700-\\u27bf",
    rsLowerRange = 'a-z\\xdf-\\xf6\\xf8-\\xff',
    rsMathOpRange = '\\xac\\xb1\\xd7\\xf7',
    rsNonCharRange = '\\x00-\\x2f\\x3a-\\x40\\x5b-\\x60\\x7b-\\xbf',
    rsPunctuationRange = "\\u2000-\\u206f",
    rsSpaceRange = " \\t\\x0b\\f\\xa0\\ufeff\\n\\r\\u2028\\u2029\\u1680\\u180e\\u2000\\u2001\\u2002\\u2003\\u2004\\u2005\\u2006\\u2007\\u2008\\u2009\\u200a\\u202f\\u205f\\u3000",
    rsUpperRange = 'A-Z\\xc0-\\xd6\\xd8-\\xde',
    rsVarRange = "\\ufe0e\\ufe0f",
    rsBreakRange = rsMathOpRange + rsNonCharRange + rsPunctuationRange + rsSpaceRange;

  /** Used to compose unicode capture groups. */
  var rsApos = "['\u2019]",
    rsAstral = '[' + rsAstralRange + ']',
    rsBreak = '[' + rsBreakRange + ']',
    rsCombo = '[' + rsComboRange + ']',
    rsDigits = '\\d+',
    rsDingbat = '[' + rsDingbatRange + ']',
    rsLower = '[' + rsLowerRange + ']',
    rsMisc = '[^' + rsAstralRange + rsBreakRange + rsDigits + rsDingbatRange + rsLowerRange + rsUpperRange + ']',
    rsFitz = "\\ud83c[\\udffb-\\udfff]",
    rsModifier = '(?:' + rsCombo + '|' + rsFitz + ')',
    rsNonAstral = '[^' + rsAstralRange + ']',
    rsRegional = "(?:\\ud83c[\\udde6-\\uddff]){2}",
    rsSurrPair = "[\\ud800-\\udbff][\\udc00-\\udfff]",
    rsUpper = '[' + rsUpperRange + ']',
    rsZWJ = "\\u200d";

  /** Used to compose unicode regexes. */
  var rsMiscLower = '(?:' + rsLower + '|' + rsMisc + ')',
    rsMiscUpper = '(?:' + rsUpper + '|' + rsMisc + ')',
    rsOptContrLower = '(?:' + rsApos + '(?:d|ll|m|re|s|t|ve))?',
    rsOptContrUpper = '(?:' + rsApos + '(?:D|LL|M|RE|S|T|VE))?',
    reOptMod = rsModifier + '?',
    rsOptVar = '[' + rsVarRange + ']?',
    rsOptJoin = '(?:' + rsZWJ + '(?:' + [rsNonAstral, rsRegional, rsSurrPair].join('|') + ')' + rsOptVar + reOptMod + ')*',
    rsOrdLower = '\\d*(?:1st|2nd|3rd|(?![123])\\dth)(?=\\b|[A-Z_])',
    rsOrdUpper = '\\d*(?:1ST|2ND|3RD|(?![123])\\dTH)(?=\\b|[a-z_])',
    rsSeq = rsOptVar + reOptMod + rsOptJoin,
    rsEmoji = '(?:' + [rsDingbat, rsRegional, rsSurrPair].join('|') + ')' + rsSeq,
    rsSymbol = '(?:' + [rsNonAstral + rsCombo + '?', rsCombo, rsRegional, rsSurrPair, rsAstral].join('|') + ')';

  /** Used to match apostrophes. */
  var reApos = RegExp(rsApos, 'g');

  /**
   * Used to match [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks) and
   * [combining diacritical marks for symbols](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks_for_Symbols).
   */
  var reComboMark = RegExp(rsCombo, 'g');

  /** Used to match [string symbols](https://mathiasbynens.be/notes/javascript-unicode). */
  var reUnicode = RegExp(rsFitz + '(?=' + rsFitz + ')|' + rsSymbol + rsSeq, 'g');

  /** Used to match complex or compound words. */
  var reUnicodeWord = RegExp([rsUpper + '?' + rsLower + '+' + rsOptContrLower + '(?=' + [rsBreak, rsUpper, '$'].join('|') + ')', rsMiscUpper + '+' + rsOptContrUpper + '(?=' + [rsBreak, rsUpper + rsMiscLower, '$'].join('|') + ')', rsUpper + '?' + rsMiscLower + '+' + rsOptContrLower, rsUpper + '+' + rsOptContrUpper, rsOrdUpper, rsOrdLower, rsDigits, rsEmoji].join('|'), 'g');

  /** Used to detect strings with [zero-width joiners or code points from the astral planes](http://eev.ee/blog/2015/09/12/dark-corners-of-unicode/). */
  var reHasUnicode = RegExp('[' + rsZWJ + rsAstralRange + rsComboRange + rsVarRange + ']');

  /** Used to detect strings that need a more robust regexp to match words. */
  var reHasUnicodeWord = /[a-z][A-Z]|[A-Z]{2}[a-z]|[0-9][a-zA-Z]|[a-zA-Z][0-9]|[^a-zA-Z0-9 ]/;

  /** Used to assign default `context` object properties. */
  var contextProps = ['Array', 'Buffer', 'DataView', 'Date', 'Error', 'Float32Array', 'Float64Array', 'Function', 'Int8Array', 'Int16Array', 'Int32Array', 'Map', 'Math', 'Object', 'Promise', 'RegExp', 'Set', 'String', 'Symbol', 'TypeError', 'Uint8Array', 'Uint8ClampedArray', 'Uint16Array', 'Uint32Array', 'WeakMap', '_', 'clearTimeout', 'isFinite', 'parseInt', 'setTimeout'];

  /** Used to make template sourceURLs easier to identify. */
  var templateCounter = -1;

  /** Used to identify `toStringTag` values of typed arrays. */
  var typedArrayTags = {};
  typedArrayTags[float32Tag] = typedArrayTags[float64Tag] = typedArrayTags[int8Tag] = typedArrayTags[int16Tag] = typedArrayTags[int32Tag] = typedArrayTags[uint8Tag] = typedArrayTags[uint8ClampedTag] = typedArrayTags[uint16Tag] = typedArrayTags[uint32Tag] = true;
  typedArrayTags[argsTag] = typedArrayTags[arrayTag] = typedArrayTags[arrayBufferTag] = typedArrayTags[boolTag] = typedArrayTags[dataViewTag] = typedArrayTags[dateTag] = typedArrayTags[errorTag] = typedArrayTags[funcTag] = typedArrayTags[mapTag] = typedArrayTags[numberTag] = typedArrayTags[objectTag] = typedArrayTags[regexpTag] = typedArrayTags[setTag] = typedArrayTags[stringTag] = typedArrayTags[weakMapTag] = false;

  /** Used to identify `toStringTag` values supported by `_.clone`. */
  var cloneableTags = {};
  cloneableTags[argsTag] = cloneableTags[arrayTag] = cloneableTags[arrayBufferTag] = cloneableTags[dataViewTag] = cloneableTags[boolTag] = cloneableTags[dateTag] = cloneableTags[float32Tag] = cloneableTags[float64Tag] = cloneableTags[int8Tag] = cloneableTags[int16Tag] = cloneableTags[int32Tag] = cloneableTags[mapTag] = cloneableTags[numberTag] = cloneableTags[objectTag] = cloneableTags[regexpTag] = cloneableTags[setTag] = cloneableTags[stringTag] = cloneableTags[symbolTag] = cloneableTags[uint8Tag] = cloneableTags[uint8ClampedTag] = cloneableTags[uint16Tag] = cloneableTags[uint32Tag] = true;
  cloneableTags[errorTag] = cloneableTags[funcTag] = cloneableTags[weakMapTag] = false;

  /** Used to map Latin Unicode letters to basic Latin letters. */
  var deburredLetters = {
    // Latin-1 Supplement block.
    '\xc0': 'A',
    '\xc1': 'A',
    '\xc2': 'A',
    '\xc3': 'A',
    '\xc4': 'A',
    '\xc5': 'A',
    '\xe0': 'a',
    '\xe1': 'a',
    '\xe2': 'a',
    '\xe3': 'a',
    '\xe4': 'a',
    '\xe5': 'a',
    '\xc7': 'C',
    '\xe7': 'c',
    '\xd0': 'D',
    '\xf0': 'd',
    '\xc8': 'E',
    '\xc9': 'E',
    '\xca': 'E',
    '\xcb': 'E',
    '\xe8': 'e',
    '\xe9': 'e',
    '\xea': 'e',
    '\xeb': 'e',
    '\xcc': 'I',
    '\xcd': 'I',
    '\xce': 'I',
    '\xcf': 'I',
    '\xec': 'i',
    '\xed': 'i',
    '\xee': 'i',
    '\xef': 'i',
    '\xd1': 'N',
    '\xf1': 'n',
    '\xd2': 'O',
    '\xd3': 'O',
    '\xd4': 'O',
    '\xd5': 'O',
    '\xd6': 'O',
    '\xd8': 'O',
    '\xf2': 'o',
    '\xf3': 'o',
    '\xf4': 'o',
    '\xf5': 'o',
    '\xf6': 'o',
    '\xf8': 'o',
    '\xd9': 'U',
    '\xda': 'U',
    '\xdb': 'U',
    '\xdc': 'U',
    '\xf9': 'u',
    '\xfa': 'u',
    '\xfb': 'u',
    '\xfc': 'u',
    '\xdd': 'Y',
    '\xfd': 'y',
    '\xff': 'y',
    '\xc6': 'Ae',
    '\xe6': 'ae',
    '\xde': 'Th',
    '\xfe': 'th',
    '\xdf': 'ss',
    // Latin Extended-A block.
    "\u0100": 'A',
    "\u0102": 'A',
    "\u0104": 'A',
    "\u0101": 'a',
    "\u0103": 'a',
    "\u0105": 'a',
    "\u0106": 'C',
    "\u0108": 'C',
    "\u010A": 'C',
    "\u010C": 'C',
    "\u0107": 'c',
    "\u0109": 'c',
    "\u010B": 'c',
    "\u010D": 'c',
    "\u010E": 'D',
    "\u0110": 'D',
    "\u010F": 'd',
    "\u0111": 'd',
    "\u0112": 'E',
    "\u0114": 'E',
    "\u0116": 'E',
    "\u0118": 'E',
    "\u011A": 'E',
    "\u0113": 'e',
    "\u0115": 'e',
    "\u0117": 'e',
    "\u0119": 'e',
    "\u011B": 'e',
    "\u011C": 'G',
    "\u011E": 'G',
    "\u0120": 'G',
    "\u0122": 'G',
    "\u011D": 'g',
    "\u011F": 'g',
    "\u0121": 'g',
    "\u0123": 'g',
    "\u0124": 'H',
    "\u0126": 'H',
    "\u0125": 'h',
    "\u0127": 'h',
    "\u0128": 'I',
    "\u012A": 'I',
    "\u012C": 'I',
    "\u012E": 'I',
    "\u0130": 'I',
    "\u0129": 'i',
    "\u012B": 'i',
    "\u012D": 'i',
    "\u012F": 'i',
    "\u0131": 'i',
    "\u0134": 'J',
    "\u0135": 'j',
    "\u0136": 'K',
    "\u0137": 'k',
    "\u0138": 'k',
    "\u0139": 'L',
    "\u013B": 'L',
    "\u013D": 'L',
    "\u013F": 'L',
    "\u0141": 'L',
    "\u013A": 'l',
    "\u013C": 'l',
    "\u013E": 'l',
    "\u0140": 'l',
    "\u0142": 'l',
    "\u0143": 'N',
    "\u0145": 'N',
    "\u0147": 'N',
    "\u014A": 'N',
    "\u0144": 'n',
    "\u0146": 'n',
    "\u0148": 'n',
    "\u014B": 'n',
    "\u014C": 'O',
    "\u014E": 'O',
    "\u0150": 'O',
    "\u014D": 'o',
    "\u014F": 'o',
    "\u0151": 'o',
    "\u0154": 'R',
    "\u0156": 'R',
    "\u0158": 'R',
    "\u0155": 'r',
    "\u0157": 'r',
    "\u0159": 'r',
    "\u015A": 'S',
    "\u015C": 'S',
    "\u015E": 'S',
    "\u0160": 'S',
    "\u015B": 's',
    "\u015D": 's',
    "\u015F": 's',
    "\u0161": 's',
    "\u0162": 'T',
    "\u0164": 'T',
    "\u0166": 'T',
    "\u0163": 't',
    "\u0165": 't',
    "\u0167": 't',
    "\u0168": 'U',
    "\u016A": 'U',
    "\u016C": 'U',
    "\u016E": 'U',
    "\u0170": 'U',
    "\u0172": 'U',
    "\u0169": 'u',
    "\u016B": 'u',
    "\u016D": 'u',
    "\u016F": 'u',
    "\u0171": 'u',
    "\u0173": 'u',
    "\u0174": 'W',
    "\u0175": 'w',
    "\u0176": 'Y',
    "\u0177": 'y',
    "\u0178": 'Y',
    "\u0179": 'Z',
    "\u017B": 'Z',
    "\u017D": 'Z',
    "\u017A": 'z',
    "\u017C": 'z',
    "\u017E": 'z',
    "\u0132": 'IJ',
    "\u0133": 'ij',
    "\u0152": 'Oe',
    "\u0153": 'oe',
    "\u0149": "'n",
    "\u017F": 's'
  };

  /** Used to map characters to HTML entities. */
  var htmlEscapes = {
    '&': '&amp;',
    '<': '&lt;',
    '>': '&gt;',
    '"': '&quot;',
    "'": '&#39;'
  };

  /** Used to map HTML entities to characters. */
  var htmlUnescapes = {
    '&amp;': '&',
    '&lt;': '<',
    '&gt;': '>',
    '&quot;': '"',
    '&#39;': "'"
  };

  /** Used to escape characters for inclusion in compiled string literals. */
  var stringEscapes = {
    '\\': '\\',
    "'": "'",
    '\n': 'n',
    '\r': 'r',
    "\u2028": 'u2028',
    "\u2029": 'u2029'
  };

  /** Built-in method references without a dependency on `root`. */
  var freeParseFloat = parseFloat,
    freeParseInt = parseInt;

  /** Detect free variable `global` from Node.js. */
  var freeGlobal = (typeof global === "undefined" ? "undefined" : _typeof(global)) == 'object' && global && global.Object === Object && global;

  /** Detect free variable `self`. */
  var freeSelf = (typeof self === "undefined" ? "undefined" : _typeof(self)) == 'object' && self && self.Object === Object && self;

  /** Used as a reference to the global object. */
  var root = freeGlobal || freeSelf || Function('return this')();

  /** Detect free variable `exports`. */
  var freeExports = (typeof exports === "undefined" ? "undefined" : _typeof(exports)) == 'object' && exports && !exports.nodeType && exports;

  /** Detect free variable `module`. */
  var freeModule = freeExports && (typeof module === "undefined" ? "undefined" : _typeof(module)) == 'object' && module && !module.nodeType && module;

  /** Detect the popular CommonJS extension `module.exports`. */
  var moduleExports = freeModule && freeModule.exports === freeExports;

  /** Detect free variable `process` from Node.js. */
  var freeProcess = moduleExports && freeGlobal.process;

  /** Used to access faster Node.js helpers. */
  var nodeUtil = function () {
    try {
      // Use `util.types` for Node.js 10+.
      var types = freeModule && freeModule.require && freeModule.require('util').types;
      if (types) {
        return types;
      }

      // Legacy `process.binding('util')` for Node.js < 10.
      return freeProcess && freeProcess.binding && freeProcess.binding('util');
    } catch (e) {}
  }();

  /* Node.js helper references. */
  var nodeIsArrayBuffer = nodeUtil && nodeUtil.isArrayBuffer,
    nodeIsDate = nodeUtil && nodeUtil.isDate,
    nodeIsMap = nodeUtil && nodeUtil.isMap,
    nodeIsRegExp = nodeUtil && nodeUtil.isRegExp,
    nodeIsSet = nodeUtil && nodeUtil.isSet,
    nodeIsTypedArray = nodeUtil && nodeUtil.isTypedArray;

  /*--------------------------------------------------------------------------*/

  /**
   * A faster alternative to `Function#apply`, this function invokes `func`
   * with the `this` binding of `thisArg` and the arguments of `args`.
   *
   * @private
   * @param {Function} func The function to invoke.
   * @param {*} thisArg The `this` binding of `func`.
   * @param {Array} args The arguments to invoke `func` with.
   * @returns {*} Returns the result of `func`.
   */
  function apply(func, thisArg, args) {
    switch (args.length) {
      case 0:
        return func.call(thisArg);
      case 1:
        return func.call(thisArg, args[0]);
      case 2:
        return func.call(thisArg, args[0], args[1]);
      case 3:
        return func.call(thisArg, args[0], args[1], args[2]);
    }
    return func.apply(thisArg, args);
  }

  /**
   * A specialized version of `baseAggregator` for arrays.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} setter The function to set `accumulator` values.
   * @param {Function} iteratee The iteratee to transform keys.
   * @param {Object} accumulator The initial aggregated object.
   * @returns {Function} Returns `accumulator`.
   */
  function arrayAggregator(array, setter, iteratee, accumulator) {
    var index = -1,
      length = array == null ? 0 : array.length;
    while (++index < length) {
      var value = array[index];
      setter(accumulator, value, iteratee(value), array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.forEach` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEach(array, iteratee) {
    var index = -1,
      length = array == null ? 0 : array.length;
    while (++index < length) {
      if (iteratee(array[index], index, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.forEachRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns `array`.
   */
  function arrayEachRight(array, iteratee) {
    var length = array == null ? 0 : array.length;
    while (length--) {
      if (iteratee(array[length], length, array) === false) {
        break;
      }
    }
    return array;
  }

  /**
   * A specialized version of `_.every` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if all elements pass the predicate check,
   *  else `false`.
   */
  function arrayEvery(array, predicate) {
    var index = -1,
      length = array == null ? 0 : array.length;
    while (++index < length) {
      if (!predicate(array[index], index, array)) {
        return false;
      }
    }
    return true;
  }

  /**
   * A specialized version of `_.filter` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {Array} Returns the new filtered array.
   */
  function arrayFilter(array, predicate) {
    var index = -1,
      length = array == null ? 0 : array.length,
      resIndex = 0,
      result = [];
    while (++index < length) {
      var value = array[index];
      if (predicate(value, index, array)) {
        result[resIndex++] = value;
      }
    }
    return result;
  }

  /**
   * A specialized version of `_.includes` for arrays without support for
   * specifying an index to search from.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludes(array, value) {
    var length = array == null ? 0 : array.length;
    return !!length && baseIndexOf(array, value, 0) > -1;
  }

  /**
   * This function is like `arrayIncludes` except that it accepts a comparator.
   *
   * @private
   * @param {Array} [array] The array to inspect.
   * @param {*} target The value to search for.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {boolean} Returns `true` if `target` is found, else `false`.
   */
  function arrayIncludesWith(array, value, comparator) {
    var index = -1,
      length = array == null ? 0 : array.length;
    while (++index < length) {
      if (comparator(value, array[index])) {
        return true;
      }
    }
    return false;
  }

  /**
   * A specialized version of `_.map` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the new mapped array.
   */
  function arrayMap(array, iteratee) {
    var index = -1,
      length = array == null ? 0 : array.length,
      result = Array(length);
    while (++index < length) {
      result[index] = iteratee(array[index], index, array);
    }
    return result;
  }

  /**
   * Appends the elements of `values` to `array`.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {Array} values The values to append.
   * @returns {Array} Returns `array`.
   */
  function arrayPush(array, values) {
    var index = -1,
      length = values.length,
      offset = array.length;
    while (++index < length) {
      array[offset + index] = values[index];
    }
    return array;
  }

  /**
   * A specialized version of `_.reduce` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the first element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduce(array, iteratee, accumulator, initAccum) {
    var index = -1,
      length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[++index];
    }
    while (++index < length) {
      accumulator = iteratee(accumulator, array[index], index, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.reduceRight` for arrays without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} [accumulator] The initial value.
   * @param {boolean} [initAccum] Specify using the last element of `array` as
   *  the initial value.
   * @returns {*} Returns the accumulated value.
   */
  function arrayReduceRight(array, iteratee, accumulator, initAccum) {
    var length = array == null ? 0 : array.length;
    if (initAccum && length) {
      accumulator = array[--length];
    }
    while (length--) {
      accumulator = iteratee(accumulator, array[length], length, array);
    }
    return accumulator;
  }

  /**
   * A specialized version of `_.some` for arrays without support for iteratee
   * shorthands.
   *
   * @private
   * @param {Array} [array] The array to iterate over.
   * @param {Function} predicate The function invoked per iteration.
   * @returns {boolean} Returns `true` if any element passes the predicate check,
   *  else `false`.
   */
  function arraySome(array, predicate) {
    var index = -1,
      length = array == null ? 0 : array.length;
    while (++index < length) {
      if (predicate(array[index], index, array)) {
        return true;
      }
    }
    return false;
  }

  /**
   * Gets the size of an ASCII `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  var asciiSize = baseProperty('length');

  /**
   * Converts an ASCII `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function asciiToArray(string) {
    return string.split('');
  }

  /**
   * Splits an ASCII `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function asciiWords(string) {
    return string.match(reAsciiWord) || [];
  }

  /**
   * The base implementation of methods like `_.findKey` and `_.findLastKey`,
   * without support for iteratee shorthands, which iterates over `collection`
   * using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the found element or its key, else `undefined`.
   */
  function baseFindKey(collection, predicate, eachFunc) {
    var result;
    eachFunc(collection, function (value, key, collection) {
      if (predicate(value, key, collection)) {
        result = key;
        return false;
      }
    });
    return result;
  }

  /**
   * The base implementation of `_.findIndex` and `_.findLastIndex` without
   * support for iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {Function} predicate The function invoked per iteration.
   * @param {number} fromIndex The index to search from.
   * @param {boolean} [fromRight] Specify iterating from right to left.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseFindIndex(array, predicate, fromIndex, fromRight) {
    var length = array.length,
      index = fromIndex + (fromRight ? 1 : -1);
    while (fromRight ? index-- : ++index < length) {
      if (predicate(array[index], index, array)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.indexOf` without `fromIndex` bounds checks.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOf(array, value, fromIndex) {
    return value === value ? strictIndexOf(array, value, fromIndex) : baseFindIndex(array, baseIsNaN, fromIndex);
  }

  /**
   * This function is like `baseIndexOf` except that it accepts a comparator.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @param {Function} comparator The comparator invoked per element.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function baseIndexOfWith(array, value, fromIndex, comparator) {
    var index = fromIndex - 1,
      length = array.length;
    while (++index < length) {
      if (comparator(array[index], value)) {
        return index;
      }
    }
    return -1;
  }

  /**
   * The base implementation of `_.isNaN` without support for number objects.
   *
   * @private
   * @param {*} value The value to check.
   * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
   */
  function baseIsNaN(value) {
    return value !== value;
  }

  /**
   * The base implementation of `_.mean` and `_.meanBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the mean.
   */
  function baseMean(array, iteratee) {
    var length = array == null ? 0 : array.length;
    return length ? baseSum(array, iteratee) / length : NAN;
  }

  /**
   * The base implementation of `_.property` without support for deep paths.
   *
   * @private
   * @param {string} key The key of the property to get.
   * @returns {Function} Returns the new accessor function.
   */
  function baseProperty(key) {
    return function (object) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.propertyOf` without support for deep paths.
   *
   * @private
   * @param {Object} object The object to query.
   * @returns {Function} Returns the new accessor function.
   */
  function basePropertyOf(object) {
    return function (key) {
      return object == null ? undefined : object[key];
    };
  }

  /**
   * The base implementation of `_.reduce` and `_.reduceRight`, without support
   * for iteratee shorthands, which iterates over `collection` using `eachFunc`.
   *
   * @private
   * @param {Array|Object} collection The collection to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @param {*} accumulator The initial value.
   * @param {boolean} initAccum Specify using the first or last element of
   *  `collection` as the initial value.
   * @param {Function} eachFunc The function to iterate over `collection`.
   * @returns {*} Returns the accumulated value.
   */
  function baseReduce(collection, iteratee, accumulator, initAccum, eachFunc) {
    eachFunc(collection, function (value, index, collection) {
      accumulator = initAccum ? (initAccum = false, value) : iteratee(accumulator, value, index, collection);
    });
    return accumulator;
  }

  /**
   * The base implementation of `_.sortBy` which uses `comparer` to define the
   * sort order of `array` and replaces criteria objects with their corresponding
   * values.
   *
   * @private
   * @param {Array} array The array to sort.
   * @param {Function} comparer The function to define sort order.
   * @returns {Array} Returns `array`.
   */
  function baseSortBy(array, comparer) {
    var length = array.length;
    array.sort(comparer);
    while (length--) {
      array[length] = array[length].value;
    }
    return array;
  }

  /**
   * The base implementation of `_.sum` and `_.sumBy` without support for
   * iteratee shorthands.
   *
   * @private
   * @param {Array} array The array to iterate over.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {number} Returns the sum.
   */
  function baseSum(array, iteratee) {
    var result,
      index = -1,
      length = array.length;
    while (++index < length) {
      var current = iteratee(array[index]);
      if (current !== undefined) {
        result = result === undefined ? current : result + current;
      }
    }
    return result;
  }

  /**
   * The base implementation of `_.times` without support for iteratee shorthands
   * or max array length checks.
   *
   * @private
   * @param {number} n The number of times to invoke `iteratee`.
   * @param {Function} iteratee The function invoked per iteration.
   * @returns {Array} Returns the array of results.
   */
  function baseTimes(n, iteratee) {
    var index = -1,
      result = Array(n);
    while (++index < n) {
      result[index] = iteratee(index);
    }
    return result;
  }

  /**
   * The base implementation of `_.toPairs` and `_.toPairsIn` which creates an array
   * of key-value pairs for `object` corresponding to the property names of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the key-value pairs.
   */
  function baseToPairs(object, props) {
    return arrayMap(props, function (key) {
      return [key, object[key]];
    });
  }

  /**
   * The base implementation of `_.trim`.
   *
   * @private
   * @param {string} string The string to trim.
   * @returns {string} Returns the trimmed string.
   */
  function baseTrim(string) {
    return string ? string.slice(0, trimmedEndIndex(string) + 1).replace(reTrimStart, '') : string;
  }

  /**
   * The base implementation of `_.unary` without support for storing metadata.
   *
   * @private
   * @param {Function} func The function to cap arguments for.
   * @returns {Function} Returns the new capped function.
   */
  function baseUnary(func) {
    return function (value) {
      return func(value);
    };
  }

  /**
   * The base implementation of `_.values` and `_.valuesIn` which creates an
   * array of `object` property values corresponding to the property names
   * of `props`.
   *
   * @private
   * @param {Object} object The object to query.
   * @param {Array} props The property names to get values for.
   * @returns {Object} Returns the array of property values.
   */
  function baseValues(object, props) {
    return arrayMap(props, function (key) {
      return object[key];
    });
  }

  /**
   * Checks if a `cache` value for `key` exists.
   *
   * @private
   * @param {Object} cache The cache to query.
   * @param {string} key The key of the entry to check.
   * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
   */
  function cacheHas(cache, key) {
    return cache.has(key);
  }

  /**
   * Used by `_.trim` and `_.trimStart` to get the index of the first string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the first unmatched string symbol.
   */
  function charsStartIndex(strSymbols, chrSymbols) {
    var index = -1,
      length = strSymbols.length;
    while (++index < length && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last string symbol
   * that is not found in the character symbols.
   *
   * @private
   * @param {Array} strSymbols The string symbols to inspect.
   * @param {Array} chrSymbols The character symbols to find.
   * @returns {number} Returns the index of the last unmatched string symbol.
   */
  function charsEndIndex(strSymbols, chrSymbols) {
    var index = strSymbols.length;
    while (index-- && baseIndexOf(chrSymbols, strSymbols[index], 0) > -1) {}
    return index;
  }

  /**
   * Gets the number of `placeholder` occurrences in `array`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} placeholder The placeholder to search for.
   * @returns {number} Returns the placeholder count.
   */
  function countHolders(array, placeholder) {
    var length = array.length,
      result = 0;
    while (length--) {
      if (array[length] === placeholder) {
        ++result;
      }
    }
    return result;
  }

  /**
   * Used by `_.deburr` to convert Latin-1 Supplement and Latin Extended-A
   * letters to basic Latin letters.
   *
   * @private
   * @param {string} letter The matched letter to deburr.
   * @returns {string} Returns the deburred letter.
   */
  var deburrLetter = basePropertyOf(deburredLetters);

  /**
   * Used by `_.escape` to convert characters to HTML entities.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  var escapeHtmlChar = basePropertyOf(htmlEscapes);

  /**
   * Used by `_.template` to escape characters for inclusion in compiled string literals.
   *
   * @private
   * @param {string} chr The matched character to escape.
   * @returns {string} Returns the escaped character.
   */
  function escapeStringChar(chr) {
    return '\\' + stringEscapes[chr];
  }

  /**
   * Gets the value at `key` of `object`.
   *
   * @private
   * @param {Object} [object] The object to query.
   * @param {string} key The key of the property to get.
   * @returns {*} Returns the property value.
   */
  function getValue(object, key) {
    return object == null ? undefined : object[key];
  }

  /**
   * Checks if `string` contains Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a symbol is found, else `false`.
   */
  function hasUnicode(string) {
    return reHasUnicode.test(string);
  }

  /**
   * Checks if `string` contains a word composed of Unicode symbols.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {boolean} Returns `true` if a word is found, else `false`.
   */
  function hasUnicodeWord(string) {
    return reHasUnicodeWord.test(string);
  }

  /**
   * Converts `iterator` to an array.
   *
   * @private
   * @param {Object} iterator The iterator to convert.
   * @returns {Array} Returns the converted array.
   */
  function iteratorToArray(iterator) {
    var data,
      result = [];
    while (!(data = iterator.next()).done) {
      result.push(data.value);
    }
    return result;
  }

  /**
   * Converts `map` to its key-value pairs.
   *
   * @private
   * @param {Object} map The map to convert.
   * @returns {Array} Returns the key-value pairs.
   */
  function mapToArray(map) {
    var index = -1,
      result = Array(map.size);
    map.forEach(function (value, key) {
      result[++index] = [key, value];
    });
    return result;
  }

  /**
   * Creates a unary function that invokes `func` with its argument transformed.
   *
   * @private
   * @param {Function} func The function to wrap.
   * @param {Function} transform The argument transform.
   * @returns {Function} Returns the new function.
   */
  function overArg(func, transform) {
    return function (arg) {
      return func(transform(arg));
    };
  }

  /**
   * Replaces all `placeholder` elements in `array` with an internal placeholder
   * and returns an array of their indexes.
   *
   * @private
   * @param {Array} array The array to modify.
   * @param {*} placeholder The placeholder to replace.
   * @returns {Array} Returns the new array of placeholder indexes.
   */
  function replaceHolders(array, placeholder) {
    var index = -1,
      length = array.length,
      resIndex = 0,
      result = [];
    while (++index < length) {
      var value = array[index];
      if (value === placeholder || value === PLACEHOLDER) {
        array[index] = PLACEHOLDER;
        result[resIndex++] = index;
      }
    }
    return result;
  }

  /**
   * Converts `set` to an array of its values.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the values.
   */
  function setToArray(set) {
    var index = -1,
      result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = value;
    });
    return result;
  }

  /**
   * Converts `set` to its value-value pairs.
   *
   * @private
   * @param {Object} set The set to convert.
   * @returns {Array} Returns the value-value pairs.
   */
  function setToPairs(set) {
    var index = -1,
      result = Array(set.size);
    set.forEach(function (value) {
      result[++index] = [value, value];
    });
    return result;
  }

  /**
   * A specialized version of `_.indexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictIndexOf(array, value, fromIndex) {
    var index = fromIndex - 1,
      length = array.length;
    while (++index < length) {
      if (array[index] === value) {
        return index;
      }
    }
    return -1;
  }

  /**
   * A specialized version of `_.lastIndexOf` which performs strict equality
   * comparisons of values, i.e. `===`.
   *
   * @private
   * @param {Array} array The array to inspect.
   * @param {*} value The value to search for.
   * @param {number} fromIndex The index to search from.
   * @returns {number} Returns the index of the matched value, else `-1`.
   */
  function strictLastIndexOf(array, value, fromIndex) {
    var index = fromIndex + 1;
    while (index--) {
      if (array[index] === value) {
        return index;
      }
    }
    return index;
  }

  /**
   * Gets the number of symbols in `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the string size.
   */
  function stringSize(string) {
    return hasUnicode(string) ? unicodeSize(string) : asciiSize(string);
  }

  /**
   * Converts `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function stringToArray(string) {
    return hasUnicode(string) ? unicodeToArray(string) : asciiToArray(string);
  }

  /**
   * Used by `_.trim` and `_.trimEnd` to get the index of the last non-whitespace
   * character of `string`.
   *
   * @private
   * @param {string} string The string to inspect.
   * @returns {number} Returns the index of the last non-whitespace character.
   */
  function trimmedEndIndex(string) {
    var index = string.length;
    while (index-- && reWhitespace.test(string.charAt(index))) {}
    return index;
  }

  /**
   * Used by `_.unescape` to convert HTML entities to characters.
   *
   * @private
   * @param {string} chr The matched character to unescape.
   * @returns {string} Returns the unescaped character.
   */
  var unescapeHtmlChar = basePropertyOf(htmlUnescapes);

  /**
   * Gets the size of a Unicode `string`.
   *
   * @private
   * @param {string} string The string inspect.
   * @returns {number} Returns the string size.
   */
  function unicodeSize(string) {
    var result = reUnicode.lastIndex = 0;
    while (reUnicode.test(string)) {
      ++result;
    }
    return result;
  }

  /**
   * Converts a Unicode `string` to an array.
   *
   * @private
   * @param {string} string The string to convert.
   * @returns {Array} Returns the converted array.
   */
  function unicodeToArray(string) {
    return string.match(reUnicode) || [];
  }

  /**
   * Splits a Unicode `string` into an array of its words.
   *
   * @private
   * @param {string} The string to inspect.
   * @returns {Array} Returns the words of `string`.
   */
  function unicodeWords(string) {
    return string.match(reUnicodeWord) || [];
  }

  /*--------------------------------------------------------------------------*/

  /**
   * Create a new pristine `lodash` function using the `context` object.
   *
   * @static
   * @memberOf _
   * @since 1.1.0
   * @category Util
   * @param {Object} [context=root] The context object.
   * @returns {Function} Returns a new `lodash` function.
   * @example
   *
   * _.mixin({ 'foo': _.constant('foo') });
   *
   * var lodash = _.runInContext();
   * lodash.mixin({ 'bar': lodash.constant('bar') });
   *
   * _.isFunction(_.foo);
   * // => true
   * _.isFunction(_.bar);
   * // => false
   *
   * lodash.isFunction(lodash.foo);
   * // => false
   * lodash.isFunction(lodash.bar);
   * // => true
   *
   * // Create a suped-up `defer` in Node.js.
   * var defer = _.runInContext({ 'setTimeout': setImmediate }).defer;
   */
  var runInContext = function runInContext(context) {
    context = context == null ? root : _.defaults(root.Object(), context, _.pick(root, contextProps));

    /** Built-in constructor references. */
    var Array = context.Array,
      Date = context.Date,
      Error = context.Error,
      Function = context.Function,
      Math = context.Math,
      Object = context.Object,
      RegExp = context.RegExp,
      String = context.String,
      TypeError = context.TypeError;

    /** Used for built-in method references. */
    var arrayProto = Array.prototype,
      funcProto = Function.prototype,
      objectProto = Object.prototype;

    /** Used to detect overreaching core-js shims. */
    var coreJsData = context['__core-js_shared__'];

    /** Used to resolve the decompiled source of functions. */
    var funcToString = funcProto.toString;

    /** Used to check objects for own properties. */
    var hasOwnProperty = objectProto.hasOwnProperty;

    /** Used to generate unique IDs. */
    var idCounter = 0;

    /** Used to detect methods masquerading as native. */
    var maskSrcKey = function () {
      var uid = /[^.]+$/.exec(coreJsData && coreJsData.keys && coreJsData.keys.IE_PROTO || '');
      return uid ? 'Symbol(src)_1.' + uid : '';
    }();

    /**
     * Used to resolve the
     * [`toStringTag`](http://ecma-international.org/ecma-262/7.0/#sec-object.prototype.tostring)
     * of values.
     */
    var nativeObjectToString = objectProto.toString;

    /** Used to infer the `Object` constructor. */
    var objectCtorString = funcToString.call(Object);

    /** Used to restore the original `_` reference in `_.noConflict`. */
    var oldDash = root._;

    /** Used to detect if a method is native. */
    var reIsNative = RegExp('^' + funcToString.call(hasOwnProperty).replace(reRegExpChar, '\\$&').replace(/hasOwnProperty|(function).*?(?=\\\()| for .+?(?=\\\])/g, '$1.*?') + '$');

    /** Built-in value references. */
    var Buffer = moduleExports ? context.Buffer : undefined,
      _Symbol = context.Symbol,
      Uint8Array = context.Uint8Array,
      allocUnsafe = Buffer ? Buffer.allocUnsafe : undefined,
      getPrototype = overArg(Object.getPrototypeOf, Object),
      objectCreate = Object.create,
      propertyIsEnumerable = objectProto.propertyIsEnumerable,
      splice = arrayProto.splice,
      spreadableSymbol = _Symbol ? _Symbol.isConcatSpreadable : undefined,
      symIterator = _Symbol ? _Symbol.iterator : undefined,
      symToStringTag = _Symbol ? _Symbol.toStringTag : undefined;
    var defineProperty = function () {
      try {
        var func = getNative(Object, 'defineProperty');
        func({}, '', {});
        return func;
      } catch (e) {}
    }();

    /** Mocked built-ins. */
    var ctxClearTimeout = context.clearTimeout !== root.clearTimeout && context.clearTimeout,
      ctxNow = Date && Date.now !== root.Date.now && Date.now,
      ctxSetTimeout = context.setTimeout !== root.setTimeout && context.setTimeout;

    /* Built-in method references for those with the same name as other `lodash` methods. */
    var nativeCeil = Math.ceil,
      nativeFloor = Math.floor,
      nativeGetSymbols = Object.getOwnPropertySymbols,
      nativeIsBuffer = Buffer ? Buffer.isBuffer : undefined,
      nativeIsFinite = context.isFinite,
      nativeJoin = arrayProto.join,
      nativeKeys = overArg(Object.keys, Object),
      nativeMax = Math.max,
      nativeMin = Math.min,
      nativeNow = Date.now,
      nativeParseInt = context.parseInt,
      nativeRandom = Math.random,
      nativeReverse = arrayProto.reverse;

    /* Built-in method references that are verified to be native. */
    var DataView = getNative(context, 'DataView'),
      Map = getNative(context, 'Map'),
      Promise = getNative(context, 'Promise'),
      Set = getNative(context, 'Set'),
      WeakMap = getNative(context, 'WeakMap'),
      nativeCreate = getNative(Object, 'create');

    /** Used to store function metadata. */
    var metaMap = WeakMap && new WeakMap();

    /** Used to lookup unminified function names. */
    var realNames = {};

    /** Used to detect maps, sets, and weakmaps. */
    var dataViewCtorString = toSource(DataView),
      mapCtorString = toSource(Map),
      promiseCtorString = toSource(Promise),
      setCtorString = toSource(Set),
      weakMapCtorString = toSource(WeakMap);

    /** Used to convert symbols to primitives and strings. */
    var symbolProto = _Symbol ? _Symbol.prototype : undefined,
      symbolValueOf = symbolProto ? symbolProto.valueOf : undefined,
      symbolToString = symbolProto ? symbolProto.toString : undefined;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` object which wraps `value` to enable implicit method
     * chain sequences. Methods that operate on and return arrays, collections,
     * and functions can be chained together. Methods that retrieve a single value
     * or may return a primitive value will automatically end the chain sequence
     * and return the unwrapped value. Otherwise, the value must be unwrapped
     * with `_#value`.
     *
     * Explicit chain sequences, which must be unwrapped with `_#value`, may be
     * enabled using `_.chain`.
     *
     * The execution of chained methods is lazy, that is, it's deferred until
     * `_#value` is implicitly or explicitly called.
     *
     * Lazy evaluation allows several methods to support shortcut fusion.
     * Shortcut fusion is an optimization to merge iteratee calls; this avoids
     * the creation of intermediate arrays and can greatly reduce the number of
     * iteratee executions. Sections of a chain sequence qualify for shortcut
     * fusion if the section is applied to an array and iteratees accept only
     * one argument. The heuristic for whether a section qualifies for shortcut
     * fusion is subject to change.
     *
     * Chaining is supported in custom builds as long as the `_#value` method is
     * directly or indirectly included in the build.
     *
     * In addition to lodash methods, wrappers have `Array` and `String` methods.
     *
     * The wrapper `Array` methods are:
     * `concat`, `join`, `pop`, `push`, `shift`, `sort`, `splice`, and `unshift`
     *
     * The wrapper `String` methods are:
     * `replace` and `split`
     *
     * The wrapper methods that support shortcut fusion are:
     * `at`, `compact`, `drop`, `dropRight`, `dropWhile`, `filter`, `find`,
     * `findLast`, `head`, `initial`, `last`, `map`, `reject`, `reverse`, `slice`,
     * `tail`, `take`, `takeRight`, `takeRightWhile`, `takeWhile`, and `toArray`
     *
     * The chainable wrapper methods are:
     * `after`, `ary`, `assign`, `assignIn`, `assignInWith`, `assignWith`, `at`,
     * `before`, `bind`, `bindAll`, `bindKey`, `castArray`, `chain`, `chunk`,
     * `commit`, `compact`, `concat`, `conforms`, `constant`, `countBy`, `create`,
     * `curry`, `debounce`, `defaults`, `defaultsDeep`, `defer`, `delay`,
     * `difference`, `differenceBy`, `differenceWith`, `drop`, `dropRight`,
     * `dropRightWhile`, `dropWhile`, `extend`, `extendWith`, `fill`, `filter`,
     * `flatMap`, `flatMapDeep`, `flatMapDepth`, `flatten`, `flattenDeep`,
     * `flattenDepth`, `flip`, `flow`, `flowRight`, `fromPairs`, `functions`,
     * `functionsIn`, `groupBy`, `initial`, `intersection`, `intersectionBy`,
     * `intersectionWith`, `invert`, `invertBy`, `invokeMap`, `iteratee`, `keyBy`,
     * `keys`, `keysIn`, `map`, `mapKeys`, `mapValues`, `matches`, `matchesProperty`,
     * `memoize`, `merge`, `mergeWith`, `method`, `methodOf`, `mixin`, `negate`,
     * `nthArg`, `omit`, `omitBy`, `once`, `orderBy`, `over`, `overArgs`,
     * `overEvery`, `overSome`, `partial`, `partialRight`, `partition`, `pick`,
     * `pickBy`, `plant`, `property`, `propertyOf`, `pull`, `pullAll`, `pullAllBy`,
     * `pullAllWith`, `pullAt`, `push`, `range`, `rangeRight`, `rearg`, `reject`,
     * `remove`, `rest`, `reverse`, `sampleSize`, `set`, `setWith`, `shuffle`,
     * `slice`, `sort`, `sortBy`, `splice`, `spread`, `tail`, `take`, `takeRight`,
     * `takeRightWhile`, `takeWhile`, `tap`, `throttle`, `thru`, `toArray`,
     * `toPairs`, `toPairsIn`, `toPath`, `toPlainObject`, `transform`, `unary`,
     * `union`, `unionBy`, `unionWith`, `uniq`, `uniqBy`, `uniqWith`, `unset`,
     * `unshift`, `unzip`, `unzipWith`, `update`, `updateWith`, `values`,
     * `valuesIn`, `without`, `wrap`, `xor`, `xorBy`, `xorWith`, `zip`,
     * `zipObject`, `zipObjectDeep`, and `zipWith`
     *
     * The wrapper methods that are **not** chainable by default are:
     * `add`, `attempt`, `camelCase`, `capitalize`, `ceil`, `clamp`, `clone`,
     * `cloneDeep`, `cloneDeepWith`, `cloneWith`, `conformsTo`, `deburr`,
     * `defaultTo`, `divide`, `each`, `eachRight`, `endsWith`, `eq`, `escape`,
     * `escapeRegExp`, `every`, `find`, `findIndex`, `findKey`, `findLast`,
     * `findLastIndex`, `findLastKey`, `first`, `floor`, `forEach`, `forEachRight`,
     * `forIn`, `forInRight`, `forOwn`, `forOwnRight`, `get`, `gt`, `gte`, `has`,
     * `hasIn`, `head`, `identity`, `includes`, `indexOf`, `inRange`, `invoke`,
     * `isArguments`, `isArray`, `isArrayBuffer`, `isArrayLike`, `isArrayLikeObject`,
     * `isBoolean`, `isBuffer`, `isDate`, `isElement`, `isEmpty`, `isEqual`,
     * `isEqualWith`, `isError`, `isFinite`, `isFunction`, `isInteger`, `isLength`,
     * `isMap`, `isMatch`, `isMatchWith`, `isNaN`, `isNative`, `isNil`, `isNull`,
     * `isNumber`, `isObject`, `isObjectLike`, `isPlainObject`, `isRegExp`,
     * `isSafeInteger`, `isSet`, `isString`, `isUndefined`, `isTypedArray`,
     * `isWeakMap`, `isWeakSet`, `join`, `kebabCase`, `last`, `lastIndexOf`,
     * `lowerCase`, `lowerFirst`, `lt`, `lte`, `max`, `maxBy`, `mean`, `meanBy`,
     * `min`, `minBy`, `multiply`, `noConflict`, `noop`, `now`, `nth`, `pad`,
     * `padEnd`, `padStart`, `parseInt`, `pop`, `random`, `reduce`, `reduceRight`,
     * `repeat`, `result`, `round`, `runInContext`, `sample`, `shift`, `size`,
     * `snakeCase`, `some`, `sortedIndex`, `sortedIndexBy`, `sortedLastIndex`,
     * `sortedLastIndexBy`, `startCase`, `startsWith`, `stubArray`, `stubFalse`,
     * `stubObject`, `stubString`, `stubTrue`, `subtract`, `sum`, `sumBy`,
     * `template`, `times`, `toFinite`, `toInteger`, `toJSON`, `toLength`,
     * `toLower`, `toNumber`, `toSafeInteger`, `toString`, `toUpper`, `trim`,
     * `trimEnd`, `trimStart`, `truncate`, `unescape`, `uniqueId`, `upperCase`,
     * `upperFirst`, `value`, and `words`
     *
     * @name _
     * @constructor
     * @category Seq
     * @param {*} value The value to wrap in a `lodash` instance.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2, 3]);
     *
     * // Returns an unwrapped value.
     * wrapped.reduce(_.add);
     * // => 6
     *
     * // Returns a wrapped value.
     * var squares = wrapped.map(square);
     *
     * _.isArray(squares);
     * // => false
     *
     * _.isArray(squares.value());
     * // => true
     */
    function lodash(value) {
      if (isObjectLike(value) && !isArray(value) && !(value instanceof LazyWrapper)) {
        if (value instanceof LodashWrapper) {
          return value;
        }
        if (hasOwnProperty.call(value, '__wrapped__')) {
          return wrapperClone(value);
        }
      }
      return new LodashWrapper(value);
    }

    /**
     * The base implementation of `_.create` without support for assigning
     * properties to the created object.
     *
     * @private
     * @param {Object} proto The object to inherit from.
     * @returns {Object} Returns the new object.
     */
    var baseCreate = function () {
      function object() {}
      return function (proto) {
        if (!isObject(proto)) {
          return {};
        }
        if (objectCreate) {
          return objectCreate(proto);
        }
        object.prototype = proto;
        var result = new object();
        object.prototype = undefined;
        return result;
      };
    }();

    /**
     * The function whose prototype chain sequence wrappers inherit from.
     *
     * @private
     */
    function baseLodash() {
      // No operation performed.
    }

    /**
     * The base constructor for creating `lodash` wrapper objects.
     *
     * @private
     * @param {*} value The value to wrap.
     * @param {boolean} [chainAll] Enable explicit method chain sequences.
     */
    function LodashWrapper(value, chainAll) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__chain__ = !!chainAll;
      this.__index__ = 0;
      this.__values__ = undefined;
    }

    /**
     * By default, the template delimiters used by lodash are like those in
     * embedded Ruby (ERB) as well as ES2015 template strings. Change the
     * following template settings to use alternative delimiters.
     *
     * @static
     * @memberOf _
     * @type {Object}
     */
    lodash.templateSettings = {
      /**
       * Used to detect `data` property values to be HTML-escaped.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'escape': reEscape,
      /**
       * Used to detect code to be evaluated.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'evaluate': reEvaluate,
      /**
       * Used to detect `data` property values to inject.
       *
       * @memberOf _.templateSettings
       * @type {RegExp}
       */
      'interpolate': reInterpolate,
      /**
       * Used to reference the data object in the template text.
       *
       * @memberOf _.templateSettings
       * @type {string}
       */
      'variable': '',
      /**
       * Used to import variables into the compiled template.
       *
       * @memberOf _.templateSettings
       * @type {Object}
       */
      'imports': {
        /**
         * A reference to the `lodash` function.
         *
         * @memberOf _.templateSettings.imports
         * @type {Function}
         */
        '_': lodash
      }
    };

    // Ensure wrappers are instances of `baseLodash`.
    lodash.prototype = baseLodash.prototype;
    lodash.prototype.constructor = lodash;
    LodashWrapper.prototype = baseCreate(baseLodash.prototype);
    LodashWrapper.prototype.constructor = LodashWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a lazy wrapper object which wraps `value` to enable lazy evaluation.
     *
     * @private
     * @constructor
     * @param {*} value The value to wrap.
     */
    function LazyWrapper(value) {
      this.__wrapped__ = value;
      this.__actions__ = [];
      this.__dir__ = 1;
      this.__filtered__ = false;
      this.__iteratees__ = [];
      this.__takeCount__ = MAX_ARRAY_LENGTH;
      this.__views__ = [];
    }

    /**
     * Creates a clone of the lazy wrapper object.
     *
     * @private
     * @name clone
     * @memberOf LazyWrapper
     * @returns {Object} Returns the cloned `LazyWrapper` object.
     */
    function lazyClone() {
      var result = new LazyWrapper(this.__wrapped__);
      result.__actions__ = copyArray(this.__actions__);
      result.__dir__ = this.__dir__;
      result.__filtered__ = this.__filtered__;
      result.__iteratees__ = copyArray(this.__iteratees__);
      result.__takeCount__ = this.__takeCount__;
      result.__views__ = copyArray(this.__views__);
      return result;
    }

    /**
     * Reverses the direction of lazy iteration.
     *
     * @private
     * @name reverse
     * @memberOf LazyWrapper
     * @returns {Object} Returns the new reversed `LazyWrapper` object.
     */
    function lazyReverse() {
      if (this.__filtered__) {
        var result = new LazyWrapper(this);
        result.__dir__ = -1;
        result.__filtered__ = true;
      } else {
        result = this.clone();
        result.__dir__ *= -1;
      }
      return result;
    }

    /**
     * Extracts the unwrapped value from its lazy wrapper.
     *
     * @private
     * @name value
     * @memberOf LazyWrapper
     * @returns {*} Returns the unwrapped value.
     */
    function lazyValue() {
      var array = this.__wrapped__.value(),
        dir = this.__dir__,
        isArr = isArray(array),
        isRight = dir < 0,
        arrLength = isArr ? array.length : 0,
        view = getView(0, arrLength, this.__views__),
        start = view.start,
        end = view.end,
        length = end - start,
        index = isRight ? end : start - 1,
        iteratees = this.__iteratees__,
        iterLength = iteratees.length,
        resIndex = 0,
        takeCount = nativeMin(length, this.__takeCount__);
      if (!isArr || !isRight && arrLength == length && takeCount == length) {
        return baseWrapperValue(array, this.__actions__);
      }
      var result = [];
      outer: while (length-- && resIndex < takeCount) {
        index += dir;
        var iterIndex = -1,
          value = array[index];
        while (++iterIndex < iterLength) {
          var data = iteratees[iterIndex],
            iteratee = data.iteratee,
            type = data.type,
            computed = iteratee(value);
          if (type == LAZY_MAP_FLAG) {
            value = computed;
          } else if (!computed) {
            if (type == LAZY_FILTER_FLAG) {
              continue outer;
            } else {
              break outer;
            }
          }
        }
        result[resIndex++] = value;
      }
      return result;
    }

    // Ensure `LazyWrapper` is an instance of `baseLodash`.
    LazyWrapper.prototype = baseCreate(baseLodash.prototype);
    LazyWrapper.prototype.constructor = LazyWrapper;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a hash object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Hash(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the hash.
     *
     * @private
     * @name clear
     * @memberOf Hash
     */
    function hashClear() {
      this.__data__ = nativeCreate ? nativeCreate(null) : {};
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the hash.
     *
     * @private
     * @name delete
     * @memberOf Hash
     * @param {Object} hash The hash to modify.
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function hashDelete(key) {
      var result = this.has(key) && delete this.__data__[key];
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the hash value for `key`.
     *
     * @private
     * @name get
     * @memberOf Hash
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function hashGet(key) {
      var data = this.__data__;
      if (nativeCreate) {
        var result = data[key];
        return result === HASH_UNDEFINED ? undefined : result;
      }
      return hasOwnProperty.call(data, key) ? data[key] : undefined;
    }

    /**
     * Checks if a hash value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Hash
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function hashHas(key) {
      var data = this.__data__;
      return nativeCreate ? data[key] !== undefined : hasOwnProperty.call(data, key);
    }

    /**
     * Sets the hash `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Hash
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the hash instance.
     */
    function hashSet(key, value) {
      var data = this.__data__;
      this.size += this.has(key) ? 0 : 1;
      data[key] = nativeCreate && value === undefined ? HASH_UNDEFINED : value;
      return this;
    }

    // Add methods to `Hash`.
    Hash.prototype.clear = hashClear;
    Hash.prototype['delete'] = hashDelete;
    Hash.prototype.get = hashGet;
    Hash.prototype.has = hashHas;
    Hash.prototype.set = hashSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an list cache object.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function ListCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the list cache.
     *
     * @private
     * @name clear
     * @memberOf ListCache
     */
    function listCacheClear() {
      this.__data__ = [];
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the list cache.
     *
     * @private
     * @name delete
     * @memberOf ListCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function listCacheDelete(key) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      if (index < 0) {
        return false;
      }
      var lastIndex = data.length - 1;
      if (index == lastIndex) {
        data.pop();
      } else {
        splice.call(data, index, 1);
      }
      --this.size;
      return true;
    }

    /**
     * Gets the list cache value for `key`.
     *
     * @private
     * @name get
     * @memberOf ListCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function listCacheGet(key) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      return index < 0 ? undefined : data[index][1];
    }

    /**
     * Checks if a list cache value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf ListCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function listCacheHas(key) {
      return assocIndexOf(this.__data__, key) > -1;
    }

    /**
     * Sets the list cache `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf ListCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the list cache instance.
     */
    function listCacheSet(key, value) {
      var data = this.__data__,
        index = assocIndexOf(data, key);
      if (index < 0) {
        ++this.size;
        data.push([key, value]);
      } else {
        data[index][1] = value;
      }
      return this;
    }

    // Add methods to `ListCache`.
    ListCache.prototype.clear = listCacheClear;
    ListCache.prototype['delete'] = listCacheDelete;
    ListCache.prototype.get = listCacheGet;
    ListCache.prototype.has = listCacheHas;
    ListCache.prototype.set = listCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a map cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function MapCache(entries) {
      var index = -1,
        length = entries == null ? 0 : entries.length;
      this.clear();
      while (++index < length) {
        var entry = entries[index];
        this.set(entry[0], entry[1]);
      }
    }

    /**
     * Removes all key-value entries from the map.
     *
     * @private
     * @name clear
     * @memberOf MapCache
     */
    function mapCacheClear() {
      this.size = 0;
      this.__data__ = {
        'hash': new Hash(),
        'map': new (Map || ListCache)(),
        'string': new Hash()
      };
    }

    /**
     * Removes `key` and its value from the map.
     *
     * @private
     * @name delete
     * @memberOf MapCache
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function mapCacheDelete(key) {
      var result = getMapData(this, key)['delete'](key);
      this.size -= result ? 1 : 0;
      return result;
    }

    /**
     * Gets the map value for `key`.
     *
     * @private
     * @name get
     * @memberOf MapCache
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function mapCacheGet(key) {
      return getMapData(this, key).get(key);
    }

    /**
     * Checks if a map value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf MapCache
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function mapCacheHas(key) {
      return getMapData(this, key).has(key);
    }

    /**
     * Sets the map `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf MapCache
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the map cache instance.
     */
    function mapCacheSet(key, value) {
      var data = getMapData(this, key),
        size = data.size;
      data.set(key, value);
      this.size += data.size == size ? 0 : 1;
      return this;
    }

    // Add methods to `MapCache`.
    MapCache.prototype.clear = mapCacheClear;
    MapCache.prototype['delete'] = mapCacheDelete;
    MapCache.prototype.get = mapCacheGet;
    MapCache.prototype.has = mapCacheHas;
    MapCache.prototype.set = mapCacheSet;

    /*------------------------------------------------------------------------*/

    /**
     *
     * Creates an array cache object to store unique values.
     *
     * @private
     * @constructor
     * @param {Array} [values] The values to cache.
     */
    function SetCache(values) {
      var index = -1,
        length = values == null ? 0 : values.length;
      this.__data__ = new MapCache();
      while (++index < length) {
        this.add(values[index]);
      }
    }

    /**
     * Adds `value` to the array cache.
     *
     * @private
     * @name add
     * @memberOf SetCache
     * @alias push
     * @param {*} value The value to cache.
     * @returns {Object} Returns the cache instance.
     */
    function setCacheAdd(value) {
      this.__data__.set(value, HASH_UNDEFINED);
      return this;
    }

    /**
     * Checks if `value` is in the array cache.
     *
     * @private
     * @name has
     * @memberOf SetCache
     * @param {*} value The value to search for.
     * @returns {number} Returns `true` if `value` is found, else `false`.
     */
    function setCacheHas(value) {
      return this.__data__.has(value);
    }

    // Add methods to `SetCache`.
    SetCache.prototype.add = SetCache.prototype.push = setCacheAdd;
    SetCache.prototype.has = setCacheHas;

    /*------------------------------------------------------------------------*/

    /**
     * Creates a stack cache object to store key-value pairs.
     *
     * @private
     * @constructor
     * @param {Array} [entries] The key-value pairs to cache.
     */
    function Stack(entries) {
      var data = this.__data__ = new ListCache(entries);
      this.size = data.size;
    }

    /**
     * Removes all key-value entries from the stack.
     *
     * @private
     * @name clear
     * @memberOf Stack
     */
    function stackClear() {
      this.__data__ = new ListCache();
      this.size = 0;
    }

    /**
     * Removes `key` and its value from the stack.
     *
     * @private
     * @name delete
     * @memberOf Stack
     * @param {string} key The key of the value to remove.
     * @returns {boolean} Returns `true` if the entry was removed, else `false`.
     */
    function stackDelete(key) {
      var data = this.__data__,
        result = data['delete'](key);
      this.size = data.size;
      return result;
    }

    /**
     * Gets the stack value for `key`.
     *
     * @private
     * @name get
     * @memberOf Stack
     * @param {string} key The key of the value to get.
     * @returns {*} Returns the entry value.
     */
    function stackGet(key) {
      return this.__data__.get(key);
    }

    /**
     * Checks if a stack value for `key` exists.
     *
     * @private
     * @name has
     * @memberOf Stack
     * @param {string} key The key of the entry to check.
     * @returns {boolean} Returns `true` if an entry for `key` exists, else `false`.
     */
    function stackHas(key) {
      return this.__data__.has(key);
    }

    /**
     * Sets the stack `key` to `value`.
     *
     * @private
     * @name set
     * @memberOf Stack
     * @param {string} key The key of the value to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns the stack cache instance.
     */
    function stackSet(key, value) {
      var data = this.__data__;
      if (data instanceof ListCache) {
        var pairs = data.__data__;
        if (!Map || pairs.length < LARGE_ARRAY_SIZE - 1) {
          pairs.push([key, value]);
          this.size = ++data.size;
          return this;
        }
        data = this.__data__ = new MapCache(pairs);
      }
      data.set(key, value);
      this.size = data.size;
      return this;
    }

    // Add methods to `Stack`.
    Stack.prototype.clear = stackClear;
    Stack.prototype['delete'] = stackDelete;
    Stack.prototype.get = stackGet;
    Stack.prototype.has = stackHas;
    Stack.prototype.set = stackSet;

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of the enumerable property names of the array-like `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @param {boolean} inherited Specify returning inherited property names.
     * @returns {Array} Returns the array of property names.
     */
    function arrayLikeKeys(value, inherited) {
      var isArr = isArray(value),
        isArg = !isArr && isArguments(value),
        isBuff = !isArr && !isArg && isBuffer(value),
        isType = !isArr && !isArg && !isBuff && isTypedArray(value),
        skipIndexes = isArr || isArg || isBuff || isType,
        result = skipIndexes ? baseTimes(value.length, String) : [],
        length = result.length;
      for (var key in value) {
        if ((inherited || hasOwnProperty.call(value, key)) && !(skipIndexes && (
        // Safari 9 has enumerable `arguments.length` in strict mode.
        key == 'length' ||
        // Node.js 0.10 has enumerable non-index properties on buffers.
        isBuff && (key == 'offset' || key == 'parent') ||
        // PhantomJS 2 has enumerable non-index properties on typed arrays.
        isType && (key == 'buffer' || key == 'byteLength' || key == 'byteOffset') ||
        // Skip index properties.
        isIndex(key, length)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * A specialized version of `_.sample` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @returns {*} Returns the random element.
     */
    function arraySample(array) {
      var length = array.length;
      return length ? array[baseRandom(0, length - 1)] : undefined;
    }

    /**
     * A specialized version of `_.sampleSize` for arrays.
     *
     * @private
     * @param {Array} array The array to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function arraySampleSize(array, n) {
      return shuffleSelf(copyArray(array), baseClamp(n, 0, array.length));
    }

    /**
     * A specialized version of `_.shuffle` for arrays.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function arrayShuffle(array) {
      return shuffleSelf(copyArray(array));
    }

    /**
     * This function is like `assignValue` except that it doesn't assign
     * `undefined` values.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignMergeValue(object, key, value) {
      if (value !== undefined && !eq(object[key], value) || value === undefined && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Assigns `value` to `key` of `object` if the existing value is not equivalent
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function assignValue(object, key, value) {
      var objValue = object[key];
      if (!(hasOwnProperty.call(object, key) && eq(objValue, value)) || value === undefined && !(key in object)) {
        baseAssignValue(object, key, value);
      }
    }

    /**
     * Gets the index at which the `key` is found in `array` of key-value pairs.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {*} key The key to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     */
    function assocIndexOf(array, key) {
      var length = array.length;
      while (length--) {
        if (eq(array[length][0], key)) {
          return length;
        }
      }
      return -1;
    }

    /**
     * Aggregates elements of `collection` on `accumulator` with keys transformed
     * by `iteratee` and values set by `setter`.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform keys.
     * @param {Object} accumulator The initial aggregated object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseAggregator(collection, setter, iteratee, accumulator) {
      baseEach(collection, function (value, key, collection) {
        setter(accumulator, value, iteratee(value), collection);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.assign` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssign(object, source) {
      return object && copyObject(source, keys(source), object);
    }

    /**
     * The base implementation of `_.assignIn` without support for multiple sources
     * or `customizer` functions.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @returns {Object} Returns `object`.
     */
    function baseAssignIn(object, source) {
      return object && copyObject(source, keysIn(source), object);
    }

    /**
     * The base implementation of `assignValue` and `assignMergeValue` without
     * value checks.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {string} key The key of the property to assign.
     * @param {*} value The value to assign.
     */
    function baseAssignValue(object, key, value) {
      if (key == '__proto__' && defineProperty) {
        defineProperty(object, key, {
          'configurable': true,
          'enumerable': true,
          'value': value,
          'writable': true
        });
      } else {
        object[key] = value;
      }
    }

    /**
     * The base implementation of `_.at` without support for individual paths.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {string[]} paths The property paths to pick.
     * @returns {Array} Returns the picked elements.
     */
    function baseAt(object, paths) {
      var index = -1,
        length = paths.length,
        result = Array(length),
        skip = object == null;
      while (++index < length) {
        result[index] = skip ? undefined : get(object, paths[index]);
      }
      return result;
    }

    /**
     * The base implementation of `_.clamp` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     */
    function baseClamp(number, lower, upper) {
      if (number === number) {
        if (upper !== undefined) {
          number = number <= upper ? number : upper;
        }
        if (lower !== undefined) {
          number = number >= lower ? number : lower;
        }
      }
      return number;
    }

    /**
     * The base implementation of `_.clone` and `_.cloneDeep` which tracks
     * traversed objects.
     *
     * @private
     * @param {*} value The value to clone.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Deep clone
     *  2 - Flatten inherited properties
     *  4 - Clone symbols
     * @param {Function} [customizer] The function to customize cloning.
     * @param {string} [key] The key of `value`.
     * @param {Object} [object] The parent object of `value`.
     * @param {Object} [stack] Tracks traversed objects and their clone counterparts.
     * @returns {*} Returns the cloned value.
     */
    function baseClone(value, bitmask, customizer, key, object, stack) {
      var result,
        isDeep = bitmask & CLONE_DEEP_FLAG,
        isFlat = bitmask & CLONE_FLAT_FLAG,
        isFull = bitmask & CLONE_SYMBOLS_FLAG;
      if (customizer) {
        result = object ? customizer(value, key, object, stack) : customizer(value);
      }
      if (result !== undefined) {
        return result;
      }
      if (!isObject(value)) {
        return value;
      }
      var isArr = isArray(value);
      if (isArr) {
        result = initCloneArray(value);
        if (!isDeep) {
          return copyArray(value, result);
        }
      } else {
        var tag = getTag(value),
          isFunc = tag == funcTag || tag == genTag;
        if (isBuffer(value)) {
          return cloneBuffer(value, isDeep);
        }
        if (tag == objectTag || tag == argsTag || isFunc && !object) {
          result = isFlat || isFunc ? {} : initCloneObject(value);
          if (!isDeep) {
            return isFlat ? copySymbolsIn(value, baseAssignIn(result, value)) : copySymbols(value, baseAssign(result, value));
          }
        } else {
          if (!cloneableTags[tag]) {
            return object ? value : {};
          }
          result = initCloneByTag(value, tag, isDeep);
        }
      }
      // Check for circular references and return its corresponding clone.
      stack || (stack = new Stack());
      var stacked = stack.get(value);
      if (stacked) {
        return stacked;
      }
      stack.set(value, result);
      if (isSet(value)) {
        value.forEach(function (subValue) {
          result.add(baseClone(subValue, bitmask, customizer, subValue, value, stack));
        });
      } else if (isMap(value)) {
        value.forEach(function (subValue, key) {
          result.set(key, baseClone(subValue, bitmask, customizer, key, value, stack));
        });
      }
      var keysFunc = isFull ? isFlat ? getAllKeysIn : getAllKeys : isFlat ? keysIn : keys;
      var props = isArr ? undefined : keysFunc(value);
      arrayEach(props || value, function (subValue, key) {
        if (props) {
          key = subValue;
          subValue = value[key];
        }
        // Recursively populate clone (susceptible to call stack limits).
        assignValue(result, key, baseClone(subValue, bitmask, customizer, key, value, stack));
      });
      return result;
    }

    /**
     * The base implementation of `_.conforms` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     */
    function baseConforms(source) {
      var props = keys(source);
      return function (object) {
        return baseConformsTo(object, source, props);
      };
    }

    /**
     * The base implementation of `_.conformsTo` which accepts `props` to check.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     */
    function baseConformsTo(object, source, props) {
      var length = props.length;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (length--) {
        var key = props[length],
          predicate = source[key],
          value = object[key];
        if (value === undefined && !(key in object) || !predicate(value)) {
          return false;
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.delay` and `_.defer` which accepts `args`
     * to provide to `func`.
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {Array} args The arguments to provide to `func`.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    function baseDelay(func, wait, args) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return setTimeout(function () {
        func.apply(undefined, args);
      }, wait);
    }

    /**
     * The base implementation of methods like `_.difference` without support
     * for excluding multiple arrays or iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Array} values The values to exclude.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     */
    function baseDifference(array, values, iteratee, comparator) {
      var index = -1,
        includes = arrayIncludes,
        isCommon = true,
        length = array.length,
        result = [],
        valuesLength = values.length;
      if (!length) {
        return result;
      }
      if (iteratee) {
        values = arrayMap(values, baseUnary(iteratee));
      }
      if (comparator) {
        includes = arrayIncludesWith;
        isCommon = false;
      } else if (values.length >= LARGE_ARRAY_SIZE) {
        includes = cacheHas;
        isCommon = false;
        values = new SetCache(values);
      }
      outer: while (++index < length) {
        var value = array[index],
          computed = iteratee == null ? value : iteratee(value);
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
          var valuesIndex = valuesLength;
          while (valuesIndex--) {
            if (values[valuesIndex] === computed) {
              continue outer;
            }
          }
          result.push(value);
        } else if (!includes(values, computed, comparator)) {
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.forEach` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEach = createBaseEach(baseForOwn);

    /**
     * The base implementation of `_.forEachRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     */
    var baseEachRight = createBaseEach(baseForOwnRight, true);

    /**
     * The base implementation of `_.every` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`
     */
    function baseEvery(collection, predicate) {
      var result = true;
      baseEach(collection, function (value, index, collection) {
        result = !!predicate(value, index, collection);
        return result;
      });
      return result;
    }

    /**
     * The base implementation of methods like `_.max` and `_.min` which accepts a
     * `comparator` to determine the extremum value.
     *
     * @private
     * @param {Array} array The array to iterate over.
     * @param {Function} iteratee The iteratee invoked per iteration.
     * @param {Function} comparator The comparator used to compare values.
     * @returns {*} Returns the extremum value.
     */
    function baseExtremum(array, iteratee, comparator) {
      var index = -1,
        length = array.length;
      while (++index < length) {
        var value = array[index],
          current = iteratee(value);
        if (current != null && (computed === undefined ? current === current && !isSymbol(current) : comparator(current, computed))) {
          var computed = current,
            result = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.fill` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     */
    function baseFill(array, value, start, end) {
      var length = array.length;
      start = toInteger(start);
      if (start < 0) {
        start = -start > length ? 0 : length + start;
      }
      end = end === undefined || end > length ? length : toInteger(end);
      if (end < 0) {
        end += length;
      }
      end = start > end ? 0 : toLength(end);
      while (start < end) {
        array[start++] = value;
      }
      return array;
    }

    /**
     * The base implementation of `_.filter` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     */
    function baseFilter(collection, predicate) {
      var result = [];
      baseEach(collection, function (value, index, collection) {
        if (predicate(value, index, collection)) {
          result.push(value);
        }
      });
      return result;
    }

    /**
     * The base implementation of `_.flatten` with support for restricting flattening.
     *
     * @private
     * @param {Array} array The array to flatten.
     * @param {number} depth The maximum recursion depth.
     * @param {boolean} [predicate=isFlattenable] The function invoked per iteration.
     * @param {boolean} [isStrict] Restrict to values that pass `predicate` checks.
     * @param {Array} [result=[]] The initial result value.
     * @returns {Array} Returns the new flattened array.
     */
    function baseFlatten(array, depth, predicate, isStrict, result) {
      var index = -1,
        length = array.length;
      predicate || (predicate = isFlattenable);
      result || (result = []);
      while (++index < length) {
        var value = array[index];
        if (depth > 0 && predicate(value)) {
          if (depth > 1) {
            // Recursively flatten arrays (susceptible to call stack limits).
            baseFlatten(value, depth - 1, predicate, isStrict, result);
          } else {
            arrayPush(result, value);
          }
        } else if (!isStrict) {
          result[result.length] = value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `baseForOwn` which iterates over `object`
     * properties returned by `keysFunc` and invokes `iteratee` for each property.
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseFor = createBaseFor();

    /**
     * This function is like `baseFor` except that it iterates over properties
     * in the opposite order.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @returns {Object} Returns `object`.
     */
    var baseForRight = createBaseFor(true);

    /**
     * The base implementation of `_.forOwn` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwn(object, iteratee) {
      return object && baseFor(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.forOwnRight` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Object} Returns `object`.
     */
    function baseForOwnRight(object, iteratee) {
      return object && baseForRight(object, iteratee, keys);
    }

    /**
     * The base implementation of `_.functions` which creates an array of
     * `object` function property names filtered from `props`.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Array} props The property names to filter.
     * @returns {Array} Returns the function names.
     */
    function baseFunctions(object, props) {
      return arrayFilter(props, function (key) {
        return isFunction(object[key]);
      });
    }

    /**
     * The base implementation of `_.get` without support for default values.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @returns {*} Returns the resolved value.
     */
    function baseGet(object, path) {
      path = castPath(path, object);
      var index = 0,
        length = path.length;
      while (object != null && index < length) {
        object = object[toKey(path[index++])];
      }
      return index && index == length ? object : undefined;
    }

    /**
     * The base implementation of `getAllKeys` and `getAllKeysIn` which uses
     * `keysFunc` and `symbolsFunc` to get the enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Function} keysFunc The function to get the keys of `object`.
     * @param {Function} symbolsFunc The function to get the symbols of `object`.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function baseGetAllKeys(object, keysFunc, symbolsFunc) {
      var result = keysFunc(object);
      return isArray(object) ? result : arrayPush(result, symbolsFunc(object));
    }

    /**
     * The base implementation of `getTag` without fallbacks for buggy environments.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    function baseGetTag(value) {
      if (value == null) {
        return value === undefined ? undefinedTag : nullTag;
      }
      return symToStringTag && symToStringTag in Object(value) ? getRawTag(value) : objectToString(value);
    }

    /**
     * The base implementation of `_.gt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     */
    function baseGt(value, other) {
      return value > other;
    }

    /**
     * The base implementation of `_.has` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHas(object, key) {
      return object != null && hasOwnProperty.call(object, key);
    }

    /**
     * The base implementation of `_.hasIn` without support for deep paths.
     *
     * @private
     * @param {Object} [object] The object to query.
     * @param {Array|string} key The key to check.
     * @returns {boolean} Returns `true` if `key` exists, else `false`.
     */
    function baseHasIn(object, key) {
      return object != null && key in Object(object);
    }

    /**
     * The base implementation of `_.inRange` which doesn't coerce arguments.
     *
     * @private
     * @param {number} number The number to check.
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     */
    function baseInRange(number, start, end) {
      return number >= nativeMin(start, end) && number < nativeMax(start, end);
    }

    /**
     * The base implementation of methods like `_.intersection`, without support
     * for iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of shared values.
     */
    function baseIntersection(arrays, iteratee, comparator) {
      var includes = comparator ? arrayIncludesWith : arrayIncludes,
        length = arrays[0].length,
        othLength = arrays.length,
        othIndex = othLength,
        caches = Array(othLength),
        maxLength = Infinity,
        result = [];
      while (othIndex--) {
        var array = arrays[othIndex];
        if (othIndex && iteratee) {
          array = arrayMap(array, baseUnary(iteratee));
        }
        maxLength = nativeMin(array.length, maxLength);
        caches[othIndex] = !comparator && (iteratee || length >= 120 && array.length >= 120) ? new SetCache(othIndex && array) : undefined;
      }
      array = arrays[0];
      var index = -1,
        seen = caches[0];
      outer: while (++index < length && result.length < maxLength) {
        var value = array[index],
          computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (!(seen ? cacheHas(seen, computed) : includes(result, computed, comparator))) {
          othIndex = othLength;
          while (--othIndex) {
            var cache = caches[othIndex];
            if (!(cache ? cacheHas(cache, computed) : includes(arrays[othIndex], computed, comparator))) {
              continue outer;
            }
          }
          if (seen) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.invert` and `_.invertBy` which inverts
     * `object` with values transformed by `iteratee` and set by `setter`.
     *
     * @private
     * @param {Object} object The object to iterate over.
     * @param {Function} setter The function to set `accumulator` values.
     * @param {Function} iteratee The iteratee to transform values.
     * @param {Object} accumulator The initial inverted object.
     * @returns {Function} Returns `accumulator`.
     */
    function baseInverter(object, setter, iteratee, accumulator) {
      baseForOwn(object, function (value, key, object) {
        setter(accumulator, iteratee(value), key, object);
      });
      return accumulator;
    }

    /**
     * The base implementation of `_.invoke` without support for individual
     * method arguments.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {Array} args The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     */
    function baseInvoke(object, path, args) {
      path = castPath(path, object);
      object = parent(object, path);
      var func = object == null ? object : object[toKey(last(path))];
      return func == null ? undefined : apply(func, object, args);
    }

    /**
     * The base implementation of `_.isArguments`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     */
    function baseIsArguments(value) {
      return isObjectLike(value) && baseGetTag(value) == argsTag;
    }

    /**
     * The base implementation of `_.isArrayBuffer` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     */
    function baseIsArrayBuffer(value) {
      return isObjectLike(value) && baseGetTag(value) == arrayBufferTag;
    }

    /**
     * The base implementation of `_.isDate` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     */
    function baseIsDate(value) {
      return isObjectLike(value) && baseGetTag(value) == dateTag;
    }

    /**
     * The base implementation of `_.isEqual` which supports partial comparisons
     * and tracks traversed objects.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {boolean} bitmask The bitmask flags.
     *  1 - Unordered comparison
     *  2 - Partial comparison
     * @param {Function} [customizer] The function to customize comparisons.
     * @param {Object} [stack] Tracks traversed `value` and `other` objects.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     */
    function baseIsEqual(value, other, bitmask, customizer, stack) {
      if (value === other) {
        return true;
      }
      if (value == null || other == null || !isObjectLike(value) && !isObjectLike(other)) {
        return value !== value && other !== other;
      }
      return baseIsEqualDeep(value, other, bitmask, customizer, baseIsEqual, stack);
    }

    /**
     * A specialized version of `baseIsEqual` for arrays and objects which performs
     * deep comparisons and tracks traversed objects enabling objects with circular
     * references to be compared.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} [stack] Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function baseIsEqualDeep(object, other, bitmask, customizer, equalFunc, stack) {
      var objIsArr = isArray(object),
        othIsArr = isArray(other),
        objTag = objIsArr ? arrayTag : getTag(object),
        othTag = othIsArr ? arrayTag : getTag(other);
      objTag = objTag == argsTag ? objectTag : objTag;
      othTag = othTag == argsTag ? objectTag : othTag;
      var objIsObj = objTag == objectTag,
        othIsObj = othTag == objectTag,
        isSameTag = objTag == othTag;
      if (isSameTag && isBuffer(object)) {
        if (!isBuffer(other)) {
          return false;
        }
        objIsArr = true;
        objIsObj = false;
      }
      if (isSameTag && !objIsObj) {
        stack || (stack = new Stack());
        return objIsArr || isTypedArray(object) ? equalArrays(object, other, bitmask, customizer, equalFunc, stack) : equalByTag(object, other, objTag, bitmask, customizer, equalFunc, stack);
      }
      if (!(bitmask & COMPARE_PARTIAL_FLAG)) {
        var objIsWrapped = objIsObj && hasOwnProperty.call(object, '__wrapped__'),
          othIsWrapped = othIsObj && hasOwnProperty.call(other, '__wrapped__');
        if (objIsWrapped || othIsWrapped) {
          var objUnwrapped = objIsWrapped ? object.value() : object,
            othUnwrapped = othIsWrapped ? other.value() : other;
          stack || (stack = new Stack());
          return equalFunc(objUnwrapped, othUnwrapped, bitmask, customizer, stack);
        }
      }
      if (!isSameTag) {
        return false;
      }
      stack || (stack = new Stack());
      return equalObjects(object, other, bitmask, customizer, equalFunc, stack);
    }

    /**
     * The base implementation of `_.isMap` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     */
    function baseIsMap(value) {
      return isObjectLike(value) && getTag(value) == mapTag;
    }

    /**
     * The base implementation of `_.isMatch` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Array} matchData The property names, values, and compare flags to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     */
    function baseIsMatch(object, source, matchData, customizer) {
      var index = matchData.length,
        length = index,
        noCustomizer = !customizer;
      if (object == null) {
        return !length;
      }
      object = Object(object);
      while (index--) {
        var data = matchData[index];
        if (noCustomizer && data[2] ? data[1] !== object[data[0]] : !(data[0] in object)) {
          return false;
        }
      }
      while (++index < length) {
        data = matchData[index];
        var key = data[0],
          objValue = object[key],
          srcValue = data[1];
        if (noCustomizer && data[2]) {
          if (objValue === undefined && !(key in object)) {
            return false;
          }
        } else {
          var stack = new Stack();
          if (customizer) {
            var result = customizer(objValue, srcValue, key, object, source, stack);
          }
          if (!(result === undefined ? baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG, customizer, stack) : result)) {
            return false;
          }
        }
      }
      return true;
    }

    /**
     * The base implementation of `_.isNative` without bad shim checks.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     */
    function baseIsNative(value) {
      if (!isObject(value) || isMasked(value)) {
        return false;
      }
      var pattern = isFunction(value) ? reIsNative : reIsHostCtor;
      return pattern.test(toSource(value));
    }

    /**
     * The base implementation of `_.isRegExp` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     */
    function baseIsRegExp(value) {
      return isObjectLike(value) && baseGetTag(value) == regexpTag;
    }

    /**
     * The base implementation of `_.isSet` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     */
    function baseIsSet(value) {
      return isObjectLike(value) && getTag(value) == setTag;
    }

    /**
     * The base implementation of `_.isTypedArray` without Node.js optimizations.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     */
    function baseIsTypedArray(value) {
      return isObjectLike(value) && isLength(value.length) && !!typedArrayTags[baseGetTag(value)];
    }

    /**
     * The base implementation of `_.iteratee`.
     *
     * @private
     * @param {*} [value=_.identity] The value to convert to an iteratee.
     * @returns {Function} Returns the iteratee.
     */
    function baseIteratee(value) {
      // Don't store the `typeof` result in a variable to avoid a JIT bug in Safari 9.
      // See https://bugs.webkit.org/show_bug.cgi?id=156034 for more details.
      if (typeof value == 'function') {
        return value;
      }
      if (value == null) {
        return identity;
      }
      if (_typeof(value) == 'object') {
        return isArray(value) ? baseMatchesProperty(value[0], value[1]) : baseMatches(value);
      }
      return property(value);
    }

    /**
     * The base implementation of `_.keys` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeys(object) {
      if (!isPrototype(object)) {
        return nativeKeys(object);
      }
      var result = [];
      for (var key in Object(object)) {
        if (hasOwnProperty.call(object, key) && key != 'constructor') {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.keysIn` which doesn't treat sparse arrays as dense.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function baseKeysIn(object) {
      if (!isObject(object)) {
        return nativeKeysIn(object);
      }
      var isProto = isPrototype(object),
        result = [];
      for (var key in object) {
        if (!(key == 'constructor' && (isProto || !hasOwnProperty.call(object, key)))) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.lt` which doesn't coerce arguments.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     */
    function baseLt(value, other) {
      return value < other;
    }

    /**
     * The base implementation of `_.map` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} iteratee The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     */
    function baseMap(collection, iteratee) {
      var index = -1,
        result = isArrayLike(collection) ? Array(collection.length) : [];
      baseEach(collection, function (value, key, collection) {
        result[++index] = iteratee(value, key, collection);
      });
      return result;
    }

    /**
     * The base implementation of `_.matches` which doesn't clone `source`.
     *
     * @private
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatches(source) {
      var matchData = getMatchData(source);
      if (matchData.length == 1 && matchData[0][2]) {
        return matchesStrictComparable(matchData[0][0], matchData[0][1]);
      }
      return function (object) {
        return object === source || baseIsMatch(object, source, matchData);
      };
    }

    /**
     * The base implementation of `_.matchesProperty` which doesn't clone `srcValue`.
     *
     * @private
     * @param {string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function baseMatchesProperty(path, srcValue) {
      if (isKey(path) && isStrictComparable(srcValue)) {
        return matchesStrictComparable(toKey(path), srcValue);
      }
      return function (object) {
        var objValue = get(object, path);
        return objValue === undefined && objValue === srcValue ? hasIn(object, path) : baseIsEqual(srcValue, objValue, COMPARE_PARTIAL_FLAG | COMPARE_UNORDERED_FLAG);
      };
    }

    /**
     * The base implementation of `_.merge` without support for multiple sources.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} [customizer] The function to customize merged values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMerge(object, source, srcIndex, customizer, stack) {
      if (object === source) {
        return;
      }
      baseFor(source, function (srcValue, key) {
        stack || (stack = new Stack());
        if (isObject(srcValue)) {
          baseMergeDeep(object, source, key, srcIndex, baseMerge, customizer, stack);
        } else {
          var newValue = customizer ? customizer(safeGet(object, key), srcValue, key + '', object, source, stack) : undefined;
          if (newValue === undefined) {
            newValue = srcValue;
          }
          assignMergeValue(object, key, newValue);
        }
      }, keysIn);
    }

    /**
     * A specialized version of `baseMerge` for arrays and objects which performs
     * deep merges and tracks traversed objects enabling objects with circular
     * references to be merged.
     *
     * @private
     * @param {Object} object The destination object.
     * @param {Object} source The source object.
     * @param {string} key The key of the value to merge.
     * @param {number} srcIndex The index of `source`.
     * @param {Function} mergeFunc The function to merge values.
     * @param {Function} [customizer] The function to customize assigned values.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     */
    function baseMergeDeep(object, source, key, srcIndex, mergeFunc, customizer, stack) {
      var objValue = safeGet(object, key),
        srcValue = safeGet(source, key),
        stacked = stack.get(srcValue);
      if (stacked) {
        assignMergeValue(object, key, stacked);
        return;
      }
      var newValue = customizer ? customizer(objValue, srcValue, key + '', object, source, stack) : undefined;
      var isCommon = newValue === undefined;
      if (isCommon) {
        var isArr = isArray(srcValue),
          isBuff = !isArr && isBuffer(srcValue),
          isTyped = !isArr && !isBuff && isTypedArray(srcValue);
        newValue = srcValue;
        if (isArr || isBuff || isTyped) {
          if (isArray(objValue)) {
            newValue = objValue;
          } else if (isArrayLikeObject(objValue)) {
            newValue = copyArray(objValue);
          } else if (isBuff) {
            isCommon = false;
            newValue = cloneBuffer(srcValue, true);
          } else if (isTyped) {
            isCommon = false;
            newValue = cloneTypedArray(srcValue, true);
          } else {
            newValue = [];
          }
        } else if (isPlainObject(srcValue) || isArguments(srcValue)) {
          newValue = objValue;
          if (isArguments(objValue)) {
            newValue = toPlainObject(objValue);
          } else if (!isObject(objValue) || isFunction(objValue)) {
            newValue = initCloneObject(srcValue);
          }
        } else {
          isCommon = false;
        }
      }
      if (isCommon) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, newValue);
        mergeFunc(newValue, srcValue, srcIndex, customizer, stack);
        stack['delete'](srcValue);
      }
      assignMergeValue(object, key, newValue);
    }

    /**
     * The base implementation of `_.nth` which doesn't coerce arguments.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {number} n The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     */
    function baseNth(array, n) {
      var length = array.length;
      if (!length) {
        return;
      }
      n += n < 0 ? length : 0;
      return isIndex(n, length) ? array[n] : undefined;
    }

    /**
     * The base implementation of `_.orderBy` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function[]|Object[]|string[]} iteratees The iteratees to sort by.
     * @param {string[]} orders The sort orders of `iteratees`.
     * @returns {Array} Returns the new sorted array.
     */
    function baseOrderBy(collection, iteratees, orders) {
      if (iteratees.length) {
        iteratees = arrayMap(iteratees, function (iteratee) {
          if (isArray(iteratee)) {
            return function (value) {
              return baseGet(value, iteratee.length === 1 ? iteratee[0] : iteratee);
            };
          }
          return iteratee;
        });
      } else {
        iteratees = [identity];
      }
      var index = -1;
      iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
      var result = baseMap(collection, function (value, key, collection) {
        var criteria = arrayMap(iteratees, function (iteratee) {
          return iteratee(value);
        });
        return {
          'criteria': criteria,
          'index': ++index,
          'value': value
        };
      });
      return baseSortBy(result, function (object, other) {
        return compareMultiple(object, other, orders);
      });
    }

    /**
     * The base implementation of `_.pick` without support for individual
     * property identifiers.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @returns {Object} Returns the new object.
     */
    function basePick(object, paths) {
      return basePickBy(object, paths, function (value, path) {
        return hasIn(object, path);
      });
    }

    /**
     * The base implementation of  `_.pickBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Object} object The source object.
     * @param {string[]} paths The property paths to pick.
     * @param {Function} predicate The function invoked per property.
     * @returns {Object} Returns the new object.
     */
    function basePickBy(object, paths, predicate) {
      var index = -1,
        length = paths.length,
        result = {};
      while (++index < length) {
        var path = paths[index],
          value = baseGet(object, path);
        if (predicate(value, path)) {
          baseSet(result, castPath(path, object), value);
        }
      }
      return result;
    }

    /**
     * A specialized version of `baseProperty` which supports deep paths.
     *
     * @private
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     */
    function basePropertyDeep(path) {
      return function (object) {
        return baseGet(object, path);
      };
    }

    /**
     * The base implementation of `_.pullAllBy` without support for iteratee
     * shorthands.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     */
    function basePullAll(array, values, iteratee, comparator) {
      var indexOf = comparator ? baseIndexOfWith : baseIndexOf,
        index = -1,
        length = values.length,
        seen = array;
      if (array === values) {
        values = copyArray(values);
      }
      if (iteratee) {
        seen = arrayMap(array, baseUnary(iteratee));
      }
      while (++index < length) {
        var fromIndex = 0,
          value = values[index],
          computed = iteratee ? iteratee(value) : value;
        while ((fromIndex = indexOf(seen, computed, fromIndex, comparator)) > -1) {
          if (seen !== array) {
            splice.call(seen, fromIndex, 1);
          }
          splice.call(array, fromIndex, 1);
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.pullAt` without support for individual
     * indexes or capturing the removed elements.
     *
     * @private
     * @param {Array} array The array to modify.
     * @param {number[]} indexes The indexes of elements to remove.
     * @returns {Array} Returns `array`.
     */
    function basePullAt(array, indexes) {
      var length = array ? indexes.length : 0,
        lastIndex = length - 1;
      while (length--) {
        var index = indexes[length];
        if (length == lastIndex || index !== previous) {
          var previous = index;
          if (isIndex(index)) {
            splice.call(array, index, 1);
          } else {
            baseUnset(array, index);
          }
        }
      }
      return array;
    }

    /**
     * The base implementation of `_.random` without support for returning
     * floating-point numbers.
     *
     * @private
     * @param {number} lower The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the random number.
     */
    function baseRandom(lower, upper) {
      return lower + nativeFloor(nativeRandom() * (upper - lower + 1));
    }

    /**
     * The base implementation of `_.range` and `_.rangeRight` which doesn't
     * coerce arguments.
     *
     * @private
     * @param {number} start The start of the range.
     * @param {number} end The end of the range.
     * @param {number} step The value to increment or decrement by.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the range of numbers.
     */
    function baseRange(start, end, step, fromRight) {
      var index = -1,
        length = nativeMax(nativeCeil((end - start) / (step || 1)), 0),
        result = Array(length);
      while (length--) {
        result[fromRight ? length : ++index] = start;
        start += step;
      }
      return result;
    }

    /**
     * The base implementation of `_.repeat` which doesn't coerce arguments.
     *
     * @private
     * @param {string} string The string to repeat.
     * @param {number} n The number of times to repeat the string.
     * @returns {string} Returns the repeated string.
     */
    function baseRepeat(string, n) {
      var result = '';
      if (!string || n < 1 || n > MAX_SAFE_INTEGER) {
        return result;
      }
      // Leverage the exponentiation by squaring algorithm for a faster repeat.
      // See https://en.wikipedia.org/wiki/Exponentiation_by_squaring for more details.
      do {
        if (n % 2) {
          result += string;
        }
        n = nativeFloor(n / 2);
        if (n) {
          string += string;
        }
      } while (n);
      return result;
    }

    /**
     * The base implementation of `_.rest` which doesn't validate or coerce arguments.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     */
    function baseRest(func, start) {
      return setToString(overRest(func, start, identity), func + '');
    }

    /**
     * The base implementation of `_.sample`.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     */
    function baseSample(collection) {
      return arraySample(values(collection));
    }

    /**
     * The base implementation of `_.sampleSize` without param guards.
     *
     * @private
     * @param {Array|Object} collection The collection to sample.
     * @param {number} n The number of elements to sample.
     * @returns {Array} Returns the random elements.
     */
    function baseSampleSize(collection, n) {
      var array = values(collection);
      return shuffleSelf(array, baseClamp(n, 0, array.length));
    }

    /**
     * The base implementation of `_.set`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseSet(object, path, value, customizer) {
      if (!isObject(object)) {
        return object;
      }
      path = castPath(path, object);
      var index = -1,
        length = path.length,
        lastIndex = length - 1,
        nested = object;
      while (nested != null && ++index < length) {
        var key = toKey(path[index]),
          newValue = value;
        if (key === '__proto__' || key === 'constructor' || key === 'prototype') {
          return object;
        }
        if (index != lastIndex) {
          var objValue = nested[key];
          newValue = customizer ? customizer(objValue, key, nested) : undefined;
          if (newValue === undefined) {
            newValue = isObject(objValue) ? objValue : isIndex(path[index + 1]) ? [] : {};
          }
        }
        assignValue(nested, key, newValue);
        nested = nested[key];
      }
      return object;
    }

    /**
     * The base implementation of `setData` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var baseSetData = !metaMap ? identity : function (func, data) {
      metaMap.set(func, data);
      return func;
    };

    /**
     * The base implementation of `setToString` without support for hot loop shorting.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var baseSetToString = !defineProperty ? identity : function (func, string) {
      return defineProperty(func, 'toString', {
        'configurable': true,
        'enumerable': false,
        'value': constant(string),
        'writable': true
      });
    };

    /**
     * The base implementation of `_.shuffle`.
     *
     * @private
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     */
    function baseShuffle(collection) {
      return shuffleSelf(values(collection));
    }

    /**
     * The base implementation of `_.slice` without an iteratee call guard.
     *
     * @private
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseSlice(array, start, end) {
      var index = -1,
        length = array.length;
      if (start < 0) {
        start = -start > length ? 0 : length + start;
      }
      end = end > length ? length : end;
      if (end < 0) {
        end += length;
      }
      length = start > end ? 0 : end - start >>> 0;
      start >>>= 0;
      var result = Array(length);
      while (++index < length) {
        result[index] = array[index + start];
      }
      return result;
    }

    /**
     * The base implementation of `_.some` without support for iteratee shorthands.
     *
     * @private
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} predicate The function invoked per iteration.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     */
    function baseSome(collection, predicate) {
      var result;
      baseEach(collection, function (value, index, collection) {
        result = predicate(value, index, collection);
        return !result;
      });
      return !!result;
    }

    /**
     * The base implementation of `_.sortedIndex` and `_.sortedLastIndex` which
     * performs a binary search of `array` to determine the index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndex(array, value, retHighest) {
      var low = 0,
        high = array == null ? low : array.length;
      if (typeof value == 'number' && value === value && high <= HALF_MAX_ARRAY_LENGTH) {
        while (low < high) {
          var mid = low + high >>> 1,
            computed = array[mid];
          if (computed !== null && !isSymbol(computed) && (retHighest ? computed <= value : computed < value)) {
            low = mid + 1;
          } else {
            high = mid;
          }
        }
        return high;
      }
      return baseSortedIndexBy(array, value, identity, retHighest);
    }

    /**
     * The base implementation of `_.sortedIndexBy` and `_.sortedLastIndexBy`
     * which invokes `iteratee` for `value` and each element of `array` to compute
     * their sort ranking. The iteratee is invoked with one argument; (value).
     *
     * @private
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} iteratee The iteratee invoked per element.
     * @param {boolean} [retHighest] Specify returning the highest qualified index.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     */
    function baseSortedIndexBy(array, value, iteratee, retHighest) {
      var low = 0,
        high = array == null ? 0 : array.length;
      if (high === 0) {
        return 0;
      }
      value = iteratee(value);
      var valIsNaN = value !== value,
        valIsNull = value === null,
        valIsSymbol = isSymbol(value),
        valIsUndefined = value === undefined;
      while (low < high) {
        var mid = nativeFloor((low + high) / 2),
          computed = iteratee(array[mid]),
          othIsDefined = computed !== undefined,
          othIsNull = computed === null,
          othIsReflexive = computed === computed,
          othIsSymbol = isSymbol(computed);
        if (valIsNaN) {
          var setLow = retHighest || othIsReflexive;
        } else if (valIsUndefined) {
          setLow = othIsReflexive && (retHighest || othIsDefined);
        } else if (valIsNull) {
          setLow = othIsReflexive && othIsDefined && (retHighest || !othIsNull);
        } else if (valIsSymbol) {
          setLow = othIsReflexive && othIsDefined && !othIsNull && (retHighest || !othIsSymbol);
        } else if (othIsNull || othIsSymbol) {
          setLow = false;
        } else {
          setLow = retHighest ? computed <= value : computed < value;
        }
        if (setLow) {
          low = mid + 1;
        } else {
          high = mid;
        }
      }
      return nativeMin(high, MAX_ARRAY_INDEX);
    }

    /**
     * The base implementation of `_.sortedUniq` and `_.sortedUniqBy` without
     * support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseSortedUniq(array, iteratee) {
      var index = -1,
        length = array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index],
          computed = iteratee ? iteratee(value) : value;
        if (!index || !eq(computed, seen)) {
          var seen = computed;
          result[resIndex++] = value === 0 ? 0 : value;
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.toNumber` which doesn't ensure correct
     * conversions of binary, hexadecimal, or octal string values.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     */
    function baseToNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      return +value;
    }

    /**
     * The base implementation of `_.toString` which doesn't convert nullish
     * values to empty strings.
     *
     * @private
     * @param {*} value The value to process.
     * @returns {string} Returns the string.
     */
    function baseToString(value) {
      // Exit early for strings to avoid a performance hit in some environments.
      if (typeof value == 'string') {
        return value;
      }
      if (isArray(value)) {
        // Recursively convert values (susceptible to call stack limits).
        return arrayMap(value, baseToString) + '';
      }
      if (isSymbol(value)) {
        return symbolToString ? symbolToString.call(value) : '';
      }
      var result = value + '';
      return result == '0' && 1 / value == -INFINITY ? '-0' : result;
    }

    /**
     * The base implementation of `_.uniqBy` without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     */
    function baseUniq(array, iteratee, comparator) {
      var index = -1,
        includes = arrayIncludes,
        length = array.length,
        isCommon = true,
        result = [],
        seen = result;
      if (comparator) {
        isCommon = false;
        includes = arrayIncludesWith;
      } else if (length >= LARGE_ARRAY_SIZE) {
        var set = iteratee ? null : createSet(array);
        if (set) {
          return setToArray(set);
        }
        isCommon = false;
        includes = cacheHas;
        seen = new SetCache();
      } else {
        seen = iteratee ? [] : result;
      }
      outer: while (++index < length) {
        var value = array[index],
          computed = iteratee ? iteratee(value) : value;
        value = comparator || value !== 0 ? value : 0;
        if (isCommon && computed === computed) {
          var seenIndex = seen.length;
          while (seenIndex--) {
            if (seen[seenIndex] === computed) {
              continue outer;
            }
          }
          if (iteratee) {
            seen.push(computed);
          }
          result.push(value);
        } else if (!includes(seen, computed, comparator)) {
          if (seen !== result) {
            seen.push(computed);
          }
          result.push(value);
        }
      }
      return result;
    }

    /**
     * The base implementation of `_.unset`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The property path to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     */
    function baseUnset(object, path) {
      path = castPath(path, object);
      object = parent(object, path);
      return object == null || delete object[toKey(last(path))];
    }

    /**
     * The base implementation of `_.update`.
     *
     * @private
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to update.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize path creation.
     * @returns {Object} Returns `object`.
     */
    function baseUpdate(object, path, updater, customizer) {
      return baseSet(object, path, updater(baseGet(object, path)), customizer);
    }

    /**
     * The base implementation of methods like `_.dropWhile` and `_.takeWhile`
     * without support for iteratee shorthands.
     *
     * @private
     * @param {Array} array The array to query.
     * @param {Function} predicate The function invoked per iteration.
     * @param {boolean} [isDrop] Specify dropping elements instead of taking them.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Array} Returns the slice of `array`.
     */
    function baseWhile(array, predicate, isDrop, fromRight) {
      var length = array.length,
        index = fromRight ? length : -1;
      while ((fromRight ? index-- : ++index < length) && predicate(array[index], index, array)) {}
      return isDrop ? baseSlice(array, fromRight ? 0 : index, fromRight ? index + 1 : length) : baseSlice(array, fromRight ? index + 1 : 0, fromRight ? length : index);
    }

    /**
     * The base implementation of `wrapperValue` which returns the result of
     * performing a sequence of actions on the unwrapped `value`, where each
     * successive action is supplied the return value of the previous.
     *
     * @private
     * @param {*} value The unwrapped value.
     * @param {Array} actions Actions to perform to resolve the unwrapped value.
     * @returns {*} Returns the resolved value.
     */
    function baseWrapperValue(value, actions) {
      var result = value;
      if (result instanceof LazyWrapper) {
        result = result.value();
      }
      return arrayReduce(actions, function (result, action) {
        return action.func.apply(action.thisArg, arrayPush([result], action.args));
      }, result);
    }

    /**
     * The base implementation of methods like `_.xor`, without support for
     * iteratee shorthands, that accepts an array of arrays to inspect.
     *
     * @private
     * @param {Array} arrays The arrays to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of values.
     */
    function baseXor(arrays, iteratee, comparator) {
      var length = arrays.length;
      if (length < 2) {
        return length ? baseUniq(arrays[0]) : [];
      }
      var index = -1,
        result = Array(length);
      while (++index < length) {
        var array = arrays[index],
          othIndex = -1;
        while (++othIndex < length) {
          if (othIndex != index) {
            result[index] = baseDifference(result[index] || array, arrays[othIndex], iteratee, comparator);
          }
        }
      }
      return baseUniq(baseFlatten(result, 1), iteratee, comparator);
    }

    /**
     * This base implementation of `_.zipObject` which assigns values using `assignFunc`.
     *
     * @private
     * @param {Array} props The property identifiers.
     * @param {Array} values The property values.
     * @param {Function} assignFunc The function to assign values.
     * @returns {Object} Returns the new object.
     */
    function baseZipObject(props, values, assignFunc) {
      var index = -1,
        length = props.length,
        valsLength = values.length,
        result = {};
      while (++index < length) {
        var value = index < valsLength ? values[index] : undefined;
        assignFunc(result, props[index], value);
      }
      return result;
    }

    /**
     * Casts `value` to an empty array if it's not an array like object.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Array|Object} Returns the cast array-like object.
     */
    function castArrayLikeObject(value) {
      return isArrayLikeObject(value) ? value : [];
    }

    /**
     * Casts `value` to `identity` if it's not a function.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {Function} Returns cast function.
     */
    function castFunction(value) {
      return typeof value == 'function' ? value : identity;
    }

    /**
     * Casts `value` to a path array if it's not one.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {Object} [object] The object to query keys on.
     * @returns {Array} Returns the cast property path array.
     */
    function castPath(value, object) {
      if (isArray(value)) {
        return value;
      }
      return isKey(value, object) ? [value] : stringToPath(toString(value));
    }

    /**
     * A `baseRest` alias which can be replaced with `identity` by module
     * replacement plugins.
     *
     * @private
     * @type {Function}
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    var castRest = baseRest;

    /**
     * Casts `array` to a slice if it's needed.
     *
     * @private
     * @param {Array} array The array to inspect.
     * @param {number} start The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the cast slice.
     */
    function castSlice(array, start, end) {
      var length = array.length;
      end = end === undefined ? length : end;
      return !start && end >= length ? array : baseSlice(array, start, end);
    }

    /**
     * A simple wrapper around the global [`clearTimeout`](https://mdn.io/clearTimeout).
     *
     * @private
     * @param {number|Object} id The timer id or timeout object of the timer to clear.
     */
    var clearTimeout = ctxClearTimeout || function (id) {
      return root.clearTimeout(id);
    };

    /**
     * Creates a clone of  `buffer`.
     *
     * @private
     * @param {Buffer} buffer The buffer to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Buffer} Returns the cloned buffer.
     */
    function cloneBuffer(buffer, isDeep) {
      if (isDeep) {
        return buffer.slice();
      }
      var length = buffer.length,
        result = allocUnsafe ? allocUnsafe(length) : new buffer.constructor(length);
      buffer.copy(result);
      return result;
    }

    /**
     * Creates a clone of `arrayBuffer`.
     *
     * @private
     * @param {ArrayBuffer} arrayBuffer The array buffer to clone.
     * @returns {ArrayBuffer} Returns the cloned array buffer.
     */
    function cloneArrayBuffer(arrayBuffer) {
      var result = new arrayBuffer.constructor(arrayBuffer.byteLength);
      new Uint8Array(result).set(new Uint8Array(arrayBuffer));
      return result;
    }

    /**
     * Creates a clone of `dataView`.
     *
     * @private
     * @param {Object} dataView The data view to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned data view.
     */
    function cloneDataView(dataView, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(dataView.buffer) : dataView.buffer;
      return new dataView.constructor(buffer, dataView.byteOffset, dataView.byteLength);
    }

    /**
     * Creates a clone of `regexp`.
     *
     * @private
     * @param {Object} regexp The regexp to clone.
     * @returns {Object} Returns the cloned regexp.
     */
    function cloneRegExp(regexp) {
      var result = new regexp.constructor(regexp.source, reFlags.exec(regexp));
      result.lastIndex = regexp.lastIndex;
      return result;
    }

    /**
     * Creates a clone of the `symbol` object.
     *
     * @private
     * @param {Object} symbol The symbol object to clone.
     * @returns {Object} Returns the cloned symbol object.
     */
    function cloneSymbol(symbol) {
      return symbolValueOf ? Object(symbolValueOf.call(symbol)) : {};
    }

    /**
     * Creates a clone of `typedArray`.
     *
     * @private
     * @param {Object} typedArray The typed array to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the cloned typed array.
     */
    function cloneTypedArray(typedArray, isDeep) {
      var buffer = isDeep ? cloneArrayBuffer(typedArray.buffer) : typedArray.buffer;
      return new typedArray.constructor(buffer, typedArray.byteOffset, typedArray.length);
    }

    /**
     * Compares values to sort them in ascending order.
     *
     * @private
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {number} Returns the sort order indicator for `value`.
     */
    function compareAscending(value, other) {
      if (value !== other) {
        var valIsDefined = value !== undefined,
          valIsNull = value === null,
          valIsReflexive = value === value,
          valIsSymbol = isSymbol(value);
        var othIsDefined = other !== undefined,
          othIsNull = other === null,
          othIsReflexive = other === other,
          othIsSymbol = isSymbol(other);
        if (!othIsNull && !othIsSymbol && !valIsSymbol && value > other || valIsSymbol && othIsDefined && othIsReflexive && !othIsNull && !othIsSymbol || valIsNull && othIsDefined && othIsReflexive || !valIsDefined && othIsReflexive || !valIsReflexive) {
          return 1;
        }
        if (!valIsNull && !valIsSymbol && !othIsSymbol && value < other || othIsSymbol && valIsDefined && valIsReflexive && !valIsNull && !valIsSymbol || othIsNull && valIsDefined && valIsReflexive || !othIsDefined && valIsReflexive || !othIsReflexive) {
          return -1;
        }
      }
      return 0;
    }

    /**
     * Used by `_.orderBy` to compare multiple properties of a value to another
     * and stable sort them.
     *
     * If `orders` is unspecified, all values are sorted in ascending order. Otherwise,
     * specify an order of "desc" for descending or "asc" for ascending sort order
     * of corresponding values.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {boolean[]|string[]} orders The order to sort by for each property.
     * @returns {number} Returns the sort order indicator for `object`.
     */
    function compareMultiple(object, other, orders) {
      var index = -1,
        objCriteria = object.criteria,
        othCriteria = other.criteria,
        length = objCriteria.length,
        ordersLength = orders.length;
      while (++index < length) {
        var result = compareAscending(objCriteria[index], othCriteria[index]);
        if (result) {
          if (index >= ordersLength) {
            return result;
          }
          var order = orders[index];
          return result * (order == 'desc' ? -1 : 1);
        }
      }
      // Fixes an `Array#sort` bug in the JS engine embedded in Adobe applications
      // that causes it, under certain circumstances, to provide the same value for
      // `object` and `other`. See https://github.com/jashkenas/underscore/pull/1247
      // for more details.
      //
      // This also ensures a stable sort in V8 and other engines.
      // See https://bugs.chromium.org/p/v8/issues/detail?id=90 for more details.
      return object.index - other.index;
    }

    /**
     * Creates an array that is the composition of partially applied arguments,
     * placeholders, and provided arguments into a single array of arguments.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to prepend to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgs(args, partials, holders, isCurried) {
      var argsIndex = -1,
        argsLength = args.length,
        holdersLength = holders.length,
        leftIndex = -1,
        leftLength = partials.length,
        rangeLength = nativeMax(argsLength - holdersLength, 0),
        result = Array(leftLength + rangeLength),
        isUncurried = !isCurried;
      while (++leftIndex < leftLength) {
        result[leftIndex] = partials[leftIndex];
      }
      while (++argsIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[holders[argsIndex]] = args[argsIndex];
        }
      }
      while (rangeLength--) {
        result[leftIndex++] = args[argsIndex++];
      }
      return result;
    }

    /**
     * This function is like `composeArgs` except that the arguments composition
     * is tailored for `_.partialRight`.
     *
     * @private
     * @param {Array} args The provided arguments.
     * @param {Array} partials The arguments to append to those provided.
     * @param {Array} holders The `partials` placeholder indexes.
     * @params {boolean} [isCurried] Specify composing for a curried function.
     * @returns {Array} Returns the new array of composed arguments.
     */
    function composeArgsRight(args, partials, holders, isCurried) {
      var argsIndex = -1,
        argsLength = args.length,
        holdersIndex = -1,
        holdersLength = holders.length,
        rightIndex = -1,
        rightLength = partials.length,
        rangeLength = nativeMax(argsLength - holdersLength, 0),
        result = Array(rangeLength + rightLength),
        isUncurried = !isCurried;
      while (++argsIndex < rangeLength) {
        result[argsIndex] = args[argsIndex];
      }
      var offset = argsIndex;
      while (++rightIndex < rightLength) {
        result[offset + rightIndex] = partials[rightIndex];
      }
      while (++holdersIndex < holdersLength) {
        if (isUncurried || argsIndex < argsLength) {
          result[offset + holders[holdersIndex]] = args[argsIndex++];
        }
      }
      return result;
    }

    /**
     * Copies the values of `source` to `array`.
     *
     * @private
     * @param {Array} source The array to copy values from.
     * @param {Array} [array=[]] The array to copy values to.
     * @returns {Array} Returns `array`.
     */
    function copyArray(source, array) {
      var index = -1,
        length = source.length;
      array || (array = Array(length));
      while (++index < length) {
        array[index] = source[index];
      }
      return array;
    }

    /**
     * Copies properties of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy properties from.
     * @param {Array} props The property identifiers to copy.
     * @param {Object} [object={}] The object to copy properties to.
     * @param {Function} [customizer] The function to customize copied values.
     * @returns {Object} Returns `object`.
     */
    function copyObject(source, props, object, customizer) {
      var isNew = !object;
      object || (object = {});
      var index = -1,
        length = props.length;
      while (++index < length) {
        var key = props[index];
        var newValue = customizer ? customizer(object[key], source[key], key, object, source) : undefined;
        if (newValue === undefined) {
          newValue = source[key];
        }
        if (isNew) {
          baseAssignValue(object, key, newValue);
        } else {
          assignValue(object, key, newValue);
        }
      }
      return object;
    }

    /**
     * Copies own symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbols(source, object) {
      return copyObject(source, getSymbols(source), object);
    }

    /**
     * Copies own and inherited symbols of `source` to `object`.
     *
     * @private
     * @param {Object} source The object to copy symbols from.
     * @param {Object} [object={}] The object to copy symbols to.
     * @returns {Object} Returns `object`.
     */
    function copySymbolsIn(source, object) {
      return copyObject(source, getSymbolsIn(source), object);
    }

    /**
     * Creates a function like `_.groupBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} [initializer] The accumulator object initializer.
     * @returns {Function} Returns the new aggregator function.
     */
    function createAggregator(setter, initializer) {
      return function (collection, iteratee) {
        var func = isArray(collection) ? arrayAggregator : baseAggregator,
          accumulator = initializer ? initializer() : {};
        return func(collection, setter, getIteratee(iteratee, 2), accumulator);
      };
    }

    /**
     * Creates a function like `_.assign`.
     *
     * @private
     * @param {Function} assigner The function to assign values.
     * @returns {Function} Returns the new assigner function.
     */
    function createAssigner(assigner) {
      return baseRest(function (object, sources) {
        var index = -1,
          length = sources.length,
          customizer = length > 1 ? sources[length - 1] : undefined,
          guard = length > 2 ? sources[2] : undefined;
        customizer = assigner.length > 3 && typeof customizer == 'function' ? (length--, customizer) : undefined;
        if (guard && isIterateeCall(sources[0], sources[1], guard)) {
          customizer = length < 3 ? undefined : customizer;
          length = 1;
        }
        object = Object(object);
        while (++index < length) {
          var source = sources[index];
          if (source) {
            assigner(object, source, index, customizer);
          }
        }
        return object;
      });
    }

    /**
     * Creates a `baseEach` or `baseEachRight` function.
     *
     * @private
     * @param {Function} eachFunc The function to iterate over a collection.
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseEach(eachFunc, fromRight) {
      return function (collection, iteratee) {
        if (collection == null) {
          return collection;
        }
        if (!isArrayLike(collection)) {
          return eachFunc(collection, iteratee);
        }
        var length = collection.length,
          index = fromRight ? length : -1,
          iterable = Object(collection);
        while (fromRight ? index-- : ++index < length) {
          if (iteratee(iterable[index], index, iterable) === false) {
            break;
          }
        }
        return collection;
      };
    }

    /**
     * Creates a base function for methods like `_.forIn` and `_.forOwn`.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new base function.
     */
    function createBaseFor(fromRight) {
      return function (object, iteratee, keysFunc) {
        var index = -1,
          iterable = Object(object),
          props = keysFunc(object),
          length = props.length;
        while (length--) {
          var key = props[fromRight ? length : ++index];
          if (iteratee(iterable[key], key, iterable) === false) {
            break;
          }
        }
        return object;
      };
    }

    /**
     * Creates a function that wraps `func` to invoke it with the optional `this`
     * binding of `thisArg`.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createBind(func, bitmask, thisArg) {
      var isBind = bitmask & WRAP_BIND_FLAG,
        Ctor = createCtor(func);
      function wrapper() {
        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        return fn.apply(isBind ? thisArg : this, arguments);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.lowerFirst`.
     *
     * @private
     * @param {string} methodName The name of the `String` case method to use.
     * @returns {Function} Returns the new case function.
     */
    function createCaseFirst(methodName) {
      return function (string) {
        string = toString(string);
        var strSymbols = hasUnicode(string) ? stringToArray(string) : undefined;
        var chr = strSymbols ? strSymbols[0] : string.charAt(0);
        var trailing = strSymbols ? castSlice(strSymbols, 1).join('') : string.slice(1);
        return chr[methodName]() + trailing;
      };
    }

    /**
     * Creates a function like `_.camelCase`.
     *
     * @private
     * @param {Function} callback The function to combine each word.
     * @returns {Function} Returns the new compounder function.
     */
    function createCompounder(callback) {
      return function (string) {
        return arrayReduce(words(deburr(string).replace(reApos, '')), callback, '');
      };
    }

    /**
     * Creates a function that produces an instance of `Ctor` regardless of
     * whether it was invoked as part of a `new` expression or by `call` or `apply`.
     *
     * @private
     * @param {Function} Ctor The constructor to wrap.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCtor(Ctor) {
      return function () {
        // Use a `switch` statement to work with class constructors. See
        // http://ecma-international.org/ecma-262/7.0/#sec-ecmascript-function-objects-call-thisargument-argumentslist
        // for more details.
        var args = arguments;
        switch (args.length) {
          case 0:
            return new Ctor();
          case 1:
            return new Ctor(args[0]);
          case 2:
            return new Ctor(args[0], args[1]);
          case 3:
            return new Ctor(args[0], args[1], args[2]);
          case 4:
            return new Ctor(args[0], args[1], args[2], args[3]);
          case 5:
            return new Ctor(args[0], args[1], args[2], args[3], args[4]);
          case 6:
            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5]);
          case 7:
            return new Ctor(args[0], args[1], args[2], args[3], args[4], args[5], args[6]);
        }
        var thisBinding = baseCreate(Ctor.prototype),
          result = Ctor.apply(thisBinding, args);

        // Mimic the constructor's `return` behavior.
        // See https://es5.github.io/#x13.2.2 for more details.
        return isObject(result) ? result : thisBinding;
      };
    }

    /**
     * Creates a function that wraps `func` to enable currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {number} arity The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createCurry(func, bitmask, arity) {
      var Ctor = createCtor(func);
      function wrapper() {
        var length = arguments.length,
          args = Array(length),
          index = length,
          placeholder = getHolder(wrapper);
        while (index--) {
          args[index] = arguments[index];
        }
        var holders = length < 3 && args[0] !== placeholder && args[length - 1] !== placeholder ? [] : replaceHolders(args, placeholder);
        length -= holders.length;
        if (length < arity) {
          return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, undefined, args, holders, undefined, undefined, arity - length);
        }
        var fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        return apply(fn, this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.find` or `_.findLast` function.
     *
     * @private
     * @param {Function} findIndexFunc The function to find the collection index.
     * @returns {Function} Returns the new find function.
     */
    function createFind(findIndexFunc) {
      return function (collection, predicate, fromIndex) {
        var iterable = Object(collection);
        if (!isArrayLike(collection)) {
          var iteratee = getIteratee(predicate, 3);
          collection = keys(collection);
          predicate = function predicate(key) {
            return iteratee(iterable[key], key, iterable);
          };
        }
        var index = findIndexFunc(collection, predicate, fromIndex);
        return index > -1 ? iterable[iteratee ? collection[index] : index] : undefined;
      };
    }

    /**
     * Creates a `_.flow` or `_.flowRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new flow function.
     */
    function createFlow(fromRight) {
      return flatRest(function (funcs) {
        var length = funcs.length,
          index = length,
          prereq = LodashWrapper.prototype.thru;
        if (fromRight) {
          funcs.reverse();
        }
        while (index--) {
          var func = funcs[index];
          if (typeof func != 'function') {
            throw new TypeError(FUNC_ERROR_TEXT);
          }
          if (prereq && !wrapper && getFuncName(func) == 'wrapper') {
            var wrapper = new LodashWrapper([], true);
          }
        }
        index = wrapper ? index : length;
        while (++index < length) {
          func = funcs[index];
          var funcName = getFuncName(func),
            data = funcName == 'wrapper' ? getData(func) : undefined;
          if (data && isLaziable(data[0]) && data[1] == (WRAP_ARY_FLAG | WRAP_CURRY_FLAG | WRAP_PARTIAL_FLAG | WRAP_REARG_FLAG) && !data[4].length && data[9] == 1) {
            wrapper = wrapper[getFuncName(data[0])].apply(wrapper, data[3]);
          } else {
            wrapper = func.length == 1 && isLaziable(func) ? wrapper[funcName]() : wrapper.thru(func);
          }
        }
        return function () {
          var args = arguments,
            value = args[0];
          if (wrapper && args.length == 1 && isArray(value)) {
            return wrapper.plant(value).value();
          }
          var index = 0,
            result = length ? funcs[index].apply(this, args) : value;
          while (++index < length) {
            result = funcs[index].call(this, result);
          }
          return result;
        };
      });
    }

    /**
     * Creates a function that wraps `func` to invoke it with optional `this`
     * binding of `thisArg`, partial application, and currying.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [partialsRight] The arguments to append to those provided
     *  to the new function.
     * @param {Array} [holdersRight] The `partialsRight` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createHybrid(func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity) {
      var isAry = bitmask & WRAP_ARY_FLAG,
        isBind = bitmask & WRAP_BIND_FLAG,
        isBindKey = bitmask & WRAP_BIND_KEY_FLAG,
        isCurried = bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG),
        isFlip = bitmask & WRAP_FLIP_FLAG,
        Ctor = isBindKey ? undefined : createCtor(func);
      function wrapper() {
        var length = arguments.length,
          args = Array(length),
          index = length;
        while (index--) {
          args[index] = arguments[index];
        }
        if (isCurried) {
          var placeholder = getHolder(wrapper),
            holdersCount = countHolders(args, placeholder);
        }
        if (partials) {
          args = composeArgs(args, partials, holders, isCurried);
        }
        if (partialsRight) {
          args = composeArgsRight(args, partialsRight, holdersRight, isCurried);
        }
        length -= holdersCount;
        if (isCurried && length < arity) {
          var newHolders = replaceHolders(args, placeholder);
          return createRecurry(func, bitmask, createHybrid, wrapper.placeholder, thisArg, args, newHolders, argPos, ary, arity - length);
        }
        var thisBinding = isBind ? thisArg : this,
          fn = isBindKey ? thisBinding[func] : func;
        length = args.length;
        if (argPos) {
          args = reorder(args, argPos);
        } else if (isFlip && length > 1) {
          args.reverse();
        }
        if (isAry && ary < length) {
          args.length = ary;
        }
        if (this && this !== root && this instanceof wrapper) {
          fn = Ctor || createCtor(fn);
        }
        return fn.apply(thisBinding, args);
      }
      return wrapper;
    }

    /**
     * Creates a function like `_.invertBy`.
     *
     * @private
     * @param {Function} setter The function to set accumulator values.
     * @param {Function} toIteratee The function to resolve iteratees.
     * @returns {Function} Returns the new inverter function.
     */
    function createInverter(setter, toIteratee) {
      return function (object, iteratee) {
        return baseInverter(object, setter, toIteratee(iteratee), {});
      };
    }

    /**
     * Creates a function that performs a mathematical operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @param {number} [defaultValue] The value used for `undefined` arguments.
     * @returns {Function} Returns the new mathematical operation function.
     */
    function createMathOperation(operator, defaultValue) {
      return function (value, other) {
        var result;
        if (value === undefined && other === undefined) {
          return defaultValue;
        }
        if (value !== undefined) {
          result = value;
        }
        if (other !== undefined) {
          if (result === undefined) {
            return other;
          }
          if (typeof value == 'string' || typeof other == 'string') {
            value = baseToString(value);
            other = baseToString(other);
          } else {
            value = baseToNumber(value);
            other = baseToNumber(other);
          }
          result = operator(value, other);
        }
        return result;
      };
    }

    /**
     * Creates a function like `_.over`.
     *
     * @private
     * @param {Function} arrayFunc The function to iterate over iteratees.
     * @returns {Function} Returns the new over function.
     */
    function createOver(arrayFunc) {
      return flatRest(function (iteratees) {
        iteratees = arrayMap(iteratees, baseUnary(getIteratee()));
        return baseRest(function (args) {
          var thisArg = this;
          return arrayFunc(iteratees, function (iteratee) {
            return apply(iteratee, thisArg, args);
          });
        });
      });
    }

    /**
     * Creates the padding for `string` based on `length`. The `chars` string
     * is truncated if the number of characters exceeds `length`.
     *
     * @private
     * @param {number} length The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padding for `string`.
     */
    function createPadding(length, chars) {
      chars = chars === undefined ? ' ' : baseToString(chars);
      var charsLength = chars.length;
      if (charsLength < 2) {
        return charsLength ? baseRepeat(chars, length) : chars;
      }
      var result = baseRepeat(chars, nativeCeil(length / stringSize(chars)));
      return hasUnicode(chars) ? castSlice(stringToArray(result), 0, length).join('') : result.slice(0, length);
    }

    /**
     * Creates a function that wraps `func` to invoke it with the `this` binding
     * of `thisArg` and `partials` prepended to the arguments it receives.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {Array} partials The arguments to prepend to those provided to
     *  the new function.
     * @returns {Function} Returns the new wrapped function.
     */
    function createPartial(func, bitmask, thisArg, partials) {
      var isBind = bitmask & WRAP_BIND_FLAG,
        Ctor = createCtor(func);
      function wrapper() {
        var argsIndex = -1,
          argsLength = arguments.length,
          leftIndex = -1,
          leftLength = partials.length,
          args = Array(leftLength + argsLength),
          fn = this && this !== root && this instanceof wrapper ? Ctor : func;
        while (++leftIndex < leftLength) {
          args[leftIndex] = partials[leftIndex];
        }
        while (argsLength--) {
          args[leftIndex++] = arguments[++argsIndex];
        }
        return apply(fn, isBind ? thisArg : this, args);
      }
      return wrapper;
    }

    /**
     * Creates a `_.range` or `_.rangeRight` function.
     *
     * @private
     * @param {boolean} [fromRight] Specify iterating from right to left.
     * @returns {Function} Returns the new range function.
     */
    function createRange(fromRight) {
      return function (start, end, step) {
        if (step && typeof step != 'number' && isIterateeCall(start, end, step)) {
          end = step = undefined;
        }
        // Ensure the sign of `-0` is preserved.
        start = toFinite(start);
        if (end === undefined) {
          end = start;
          start = 0;
        } else {
          end = toFinite(end);
        }
        step = step === undefined ? start < end ? 1 : -1 : toFinite(step);
        return baseRange(start, end, step, fromRight);
      };
    }

    /**
     * Creates a function that performs a relational operation on two values.
     *
     * @private
     * @param {Function} operator The function to perform the operation.
     * @returns {Function} Returns the new relational operation function.
     */
    function createRelationalOperation(operator) {
      return function (value, other) {
        if (!(typeof value == 'string' && typeof other == 'string')) {
          value = toNumber(value);
          other = toNumber(other);
        }
        return operator(value, other);
      };
    }

    /**
     * Creates a function that wraps `func` to continue currying.
     *
     * @private
     * @param {Function} func The function to wrap.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @param {Function} wrapFunc The function to create the `func` wrapper.
     * @param {*} placeholder The placeholder value.
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to prepend to those provided to
     *  the new function.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createRecurry(func, bitmask, wrapFunc, placeholder, thisArg, partials, holders, argPos, ary, arity) {
      var isCurry = bitmask & WRAP_CURRY_FLAG,
        newHolders = isCurry ? holders : undefined,
        newHoldersRight = isCurry ? undefined : holders,
        newPartials = isCurry ? partials : undefined,
        newPartialsRight = isCurry ? undefined : partials;
      bitmask |= isCurry ? WRAP_PARTIAL_FLAG : WRAP_PARTIAL_RIGHT_FLAG;
      bitmask &= ~(isCurry ? WRAP_PARTIAL_RIGHT_FLAG : WRAP_PARTIAL_FLAG);
      if (!(bitmask & WRAP_CURRY_BOUND_FLAG)) {
        bitmask &= ~(WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG);
      }
      var newData = [func, bitmask, thisArg, newPartials, newHolders, newPartialsRight, newHoldersRight, argPos, ary, arity];
      var result = wrapFunc.apply(undefined, newData);
      if (isLaziable(func)) {
        setData(result, newData);
      }
      result.placeholder = placeholder;
      return setWrapToString(result, func, bitmask);
    }

    /**
     * Creates a function like `_.round`.
     *
     * @private
     * @param {string} methodName The name of the `Math` method to use when rounding.
     * @returns {Function} Returns the new round function.
     */
    function createRound(methodName) {
      var func = Math[methodName];
      return function (number, precision) {
        number = toNumber(number);
        precision = precision == null ? 0 : nativeMin(toInteger(precision), 292);
        if (precision && nativeIsFinite(number)) {
          // Shift with exponential notation to avoid floating-point issues.
          // See [MDN](https://mdn.io/round#Examples) for more details.
          var pair = (toString(number) + 'e').split('e'),
            value = func(pair[0] + 'e' + (+pair[1] + precision));
          pair = (toString(value) + 'e').split('e');
          return +(pair[0] + 'e' + (+pair[1] - precision));
        }
        return func(number);
      };
    }

    /**
     * Creates a set object of `values`.
     *
     * @private
     * @param {Array} values The values to add to the set.
     * @returns {Object} Returns the new set.
     */
    var createSet = !(Set && 1 / setToArray(new Set([, -0]))[1] == INFINITY) ? noop : function (values) {
      return new Set(values);
    };

    /**
     * Creates a `_.toPairs` or `_.toPairsIn` function.
     *
     * @private
     * @param {Function} keysFunc The function to get the keys of a given object.
     * @returns {Function} Returns the new pairs function.
     */
    function createToPairs(keysFunc) {
      return function (object) {
        var tag = getTag(object);
        if (tag == mapTag) {
          return mapToArray(object);
        }
        if (tag == setTag) {
          return setToPairs(object);
        }
        return baseToPairs(object, keysFunc(object));
      };
    }

    /**
     * Creates a function that either curries or invokes `func` with optional
     * `this` binding and partially applied arguments.
     *
     * @private
     * @param {Function|string} func The function or method name to wrap.
     * @param {number} bitmask The bitmask flags.
     *    1 - `_.bind`
     *    2 - `_.bindKey`
     *    4 - `_.curry` or `_.curryRight` of a bound function
     *    8 - `_.curry`
     *   16 - `_.curryRight`
     *   32 - `_.partial`
     *   64 - `_.partialRight`
     *  128 - `_.rearg`
     *  256 - `_.ary`
     *  512 - `_.flip`
     * @param {*} [thisArg] The `this` binding of `func`.
     * @param {Array} [partials] The arguments to be partially applied.
     * @param {Array} [holders] The `partials` placeholder indexes.
     * @param {Array} [argPos] The argument positions of the new function.
     * @param {number} [ary] The arity cap of `func`.
     * @param {number} [arity] The arity of `func`.
     * @returns {Function} Returns the new wrapped function.
     */
    function createWrap(func, bitmask, thisArg, partials, holders, argPos, ary, arity) {
      var isBindKey = bitmask & WRAP_BIND_KEY_FLAG;
      if (!isBindKey && typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var length = partials ? partials.length : 0;
      if (!length) {
        bitmask &= ~(WRAP_PARTIAL_FLAG | WRAP_PARTIAL_RIGHT_FLAG);
        partials = holders = undefined;
      }
      ary = ary === undefined ? ary : nativeMax(toInteger(ary), 0);
      arity = arity === undefined ? arity : toInteger(arity);
      length -= holders ? holders.length : 0;
      if (bitmask & WRAP_PARTIAL_RIGHT_FLAG) {
        var partialsRight = partials,
          holdersRight = holders;
        partials = holders = undefined;
      }
      var data = isBindKey ? undefined : getData(func);
      var newData = [func, bitmask, thisArg, partials, holders, partialsRight, holdersRight, argPos, ary, arity];
      if (data) {
        mergeData(newData, data);
      }
      func = newData[0];
      bitmask = newData[1];
      thisArg = newData[2];
      partials = newData[3];
      holders = newData[4];
      arity = newData[9] = newData[9] === undefined ? isBindKey ? 0 : func.length : nativeMax(newData[9] - length, 0);
      if (!arity && bitmask & (WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG)) {
        bitmask &= ~(WRAP_CURRY_FLAG | WRAP_CURRY_RIGHT_FLAG);
      }
      if (!bitmask || bitmask == WRAP_BIND_FLAG) {
        var result = createBind(func, bitmask, thisArg);
      } else if (bitmask == WRAP_CURRY_FLAG || bitmask == WRAP_CURRY_RIGHT_FLAG) {
        result = createCurry(func, bitmask, arity);
      } else if ((bitmask == WRAP_PARTIAL_FLAG || bitmask == (WRAP_BIND_FLAG | WRAP_PARTIAL_FLAG)) && !holders.length) {
        result = createPartial(func, bitmask, thisArg, partials);
      } else {
        result = createHybrid.apply(undefined, newData);
      }
      var setter = data ? baseSetData : setData;
      return setWrapToString(setter(result, newData), func, bitmask);
    }

    /**
     * Used by `_.defaults` to customize its `_.assignIn` use to assign properties
     * of source objects to the destination object for all destination properties
     * that resolve to `undefined`.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to assign.
     * @param {Object} object The parent object of `objValue`.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsAssignIn(objValue, srcValue, key, object) {
      if (objValue === undefined || eq(objValue, objectProto[key]) && !hasOwnProperty.call(object, key)) {
        return srcValue;
      }
      return objValue;
    }

    /**
     * Used by `_.defaultsDeep` to customize its `_.merge` use to merge source
     * objects into destination objects that are passed thru.
     *
     * @private
     * @param {*} objValue The destination value.
     * @param {*} srcValue The source value.
     * @param {string} key The key of the property to merge.
     * @param {Object} object The parent object of `objValue`.
     * @param {Object} source The parent object of `srcValue`.
     * @param {Object} [stack] Tracks traversed source values and their merged
     *  counterparts.
     * @returns {*} Returns the value to assign.
     */
    function customDefaultsMerge(objValue, srcValue, key, object, source, stack) {
      if (isObject(objValue) && isObject(srcValue)) {
        // Recursively merge objects and arrays (susceptible to call stack limits).
        stack.set(srcValue, objValue);
        baseMerge(objValue, srcValue, undefined, customDefaultsMerge, stack);
        stack['delete'](srcValue);
      }
      return objValue;
    }

    /**
     * Used by `_.omit` to customize its `_.cloneDeep` use to only clone plain
     * objects.
     *
     * @private
     * @param {*} value The value to inspect.
     * @param {string} key The key of the property to inspect.
     * @returns {*} Returns the uncloned value or `undefined` to defer cloning to `_.cloneDeep`.
     */
    function customOmitClone(value) {
      return isPlainObject(value) ? undefined : value;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for arrays with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Array} array The array to compare.
     * @param {Array} other The other array to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `array` and `other` objects.
     * @returns {boolean} Returns `true` if the arrays are equivalent, else `false`.
     */
    function equalArrays(array, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        arrLength = array.length,
        othLength = other.length;
      if (arrLength != othLength && !(isPartial && othLength > arrLength)) {
        return false;
      }
      // Check that cyclic values are equal.
      var arrStacked = stack.get(array);
      var othStacked = stack.get(other);
      if (arrStacked && othStacked) {
        return arrStacked == other && othStacked == array;
      }
      var index = -1,
        result = true,
        seen = bitmask & COMPARE_UNORDERED_FLAG ? new SetCache() : undefined;
      stack.set(array, other);
      stack.set(other, array);

      // Ignore non-index properties.
      while (++index < arrLength) {
        var arrValue = array[index],
          othValue = other[index];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, arrValue, index, other, array, stack) : customizer(arrValue, othValue, index, array, other, stack);
        }
        if (compared !== undefined) {
          if (compared) {
            continue;
          }
          result = false;
          break;
        }
        // Recursively compare arrays (susceptible to call stack limits).
        if (seen) {
          if (!arraySome(other, function (othValue, othIndex) {
            if (!cacheHas(seen, othIndex) && (arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
              return seen.push(othIndex);
            }
          })) {
            result = false;
            break;
          }
        } else if (!(arrValue === othValue || equalFunc(arrValue, othValue, bitmask, customizer, stack))) {
          result = false;
          break;
        }
      }
      stack['delete'](array);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for comparing objects of
     * the same `toStringTag`.
     *
     * **Note:** This function only supports comparing values with tags of
     * `Boolean`, `Date`, `Error`, `Number`, `RegExp`, or `String`.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {string} tag The `toStringTag` of the objects to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalByTag(object, other, tag, bitmask, customizer, equalFunc, stack) {
      switch (tag) {
        case dataViewTag:
          if (object.byteLength != other.byteLength || object.byteOffset != other.byteOffset) {
            return false;
          }
          object = object.buffer;
          other = other.buffer;
        case arrayBufferTag:
          if (object.byteLength != other.byteLength || !equalFunc(new Uint8Array(object), new Uint8Array(other))) {
            return false;
          }
          return true;
        case boolTag:
        case dateTag:
        case numberTag:
          // Coerce booleans to `1` or `0` and dates to milliseconds.
          // Invalid dates are coerced to `NaN`.
          return eq(+object, +other);
        case errorTag:
          return object.name == other.name && object.message == other.message;
        case regexpTag:
        case stringTag:
          // Coerce regexes to strings and treat strings, primitives and objects,
          // as equal. See http://www.ecma-international.org/ecma-262/7.0/#sec-regexp.prototype.tostring
          // for more details.
          return object == other + '';
        case mapTag:
          var convert = mapToArray;
        case setTag:
          var isPartial = bitmask & COMPARE_PARTIAL_FLAG;
          convert || (convert = setToArray);
          if (object.size != other.size && !isPartial) {
            return false;
          }
          // Assume cyclic values are equal.
          var stacked = stack.get(object);
          if (stacked) {
            return stacked == other;
          }
          bitmask |= COMPARE_UNORDERED_FLAG;

          // Recursively compare objects (susceptible to call stack limits).
          stack.set(object, other);
          var result = equalArrays(convert(object), convert(other), bitmask, customizer, equalFunc, stack);
          stack['delete'](object);
          return result;
        case symbolTag:
          if (symbolValueOf) {
            return symbolValueOf.call(object) == symbolValueOf.call(other);
          }
      }
      return false;
    }

    /**
     * A specialized version of `baseIsEqualDeep` for objects with support for
     * partial deep comparisons.
     *
     * @private
     * @param {Object} object The object to compare.
     * @param {Object} other The other object to compare.
     * @param {number} bitmask The bitmask flags. See `baseIsEqual` for more details.
     * @param {Function} customizer The function to customize comparisons.
     * @param {Function} equalFunc The function to determine equivalents of values.
     * @param {Object} stack Tracks traversed `object` and `other` objects.
     * @returns {boolean} Returns `true` if the objects are equivalent, else `false`.
     */
    function equalObjects(object, other, bitmask, customizer, equalFunc, stack) {
      var isPartial = bitmask & COMPARE_PARTIAL_FLAG,
        objProps = getAllKeys(object),
        objLength = objProps.length,
        othProps = getAllKeys(other),
        othLength = othProps.length;
      if (objLength != othLength && !isPartial) {
        return false;
      }
      var index = objLength;
      while (index--) {
        var key = objProps[index];
        if (!(isPartial ? key in other : hasOwnProperty.call(other, key))) {
          return false;
        }
      }
      // Check that cyclic values are equal.
      var objStacked = stack.get(object);
      var othStacked = stack.get(other);
      if (objStacked && othStacked) {
        return objStacked == other && othStacked == object;
      }
      var result = true;
      stack.set(object, other);
      stack.set(other, object);
      var skipCtor = isPartial;
      while (++index < objLength) {
        key = objProps[index];
        var objValue = object[key],
          othValue = other[key];
        if (customizer) {
          var compared = isPartial ? customizer(othValue, objValue, key, other, object, stack) : customizer(objValue, othValue, key, object, other, stack);
        }
        // Recursively compare objects (susceptible to call stack limits).
        if (!(compared === undefined ? objValue === othValue || equalFunc(objValue, othValue, bitmask, customizer, stack) : compared)) {
          result = false;
          break;
        }
        skipCtor || (skipCtor = key == 'constructor');
      }
      if (result && !skipCtor) {
        var objCtor = object.constructor,
          othCtor = other.constructor;

        // Non `Object` object instances with different constructors are not equal.
        if (objCtor != othCtor && 'constructor' in object && 'constructor' in other && !(typeof objCtor == 'function' && objCtor instanceof objCtor && typeof othCtor == 'function' && othCtor instanceof othCtor)) {
          result = false;
        }
      }
      stack['delete'](object);
      stack['delete'](other);
      return result;
    }

    /**
     * A specialized version of `baseRest` which flattens the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @returns {Function} Returns the new function.
     */
    function flatRest(func) {
      return setToString(overRest(func, undefined, flatten), func + '');
    }

    /**
     * Creates an array of own enumerable property names and symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeys(object) {
      return baseGetAllKeys(object, keys, getSymbols);
    }

    /**
     * Creates an array of own and inherited enumerable property names and
     * symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names and symbols.
     */
    function getAllKeysIn(object) {
      return baseGetAllKeys(object, keysIn, getSymbolsIn);
    }

    /**
     * Gets metadata for `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {*} Returns the metadata for `func`.
     */
    var getData = !metaMap ? noop : function (func) {
      return metaMap.get(func);
    };

    /**
     * Gets the name of `func`.
     *
     * @private
     * @param {Function} func The function to query.
     * @returns {string} Returns the function name.
     */
    function getFuncName(func) {
      var result = func.name + '',
        array = realNames[result],
        length = hasOwnProperty.call(realNames, result) ? array.length : 0;
      while (length--) {
        var data = array[length],
          otherFunc = data.func;
        if (otherFunc == null || otherFunc == func) {
          return data.name;
        }
      }
      return result;
    }

    /**
     * Gets the argument placeholder value for `func`.
     *
     * @private
     * @param {Function} func The function to inspect.
     * @returns {*} Returns the placeholder value.
     */
    function getHolder(func) {
      var object = hasOwnProperty.call(lodash, 'placeholder') ? lodash : func;
      return object.placeholder;
    }

    /**
     * Gets the appropriate "iteratee" function. If `_.iteratee` is customized,
     * this function returns the custom method, otherwise it returns `baseIteratee`.
     * If arguments are provided, the chosen function is invoked with them and
     * its result is returned.
     *
     * @private
     * @param {*} [value] The value to convert to an iteratee.
     * @param {number} [arity] The arity of the created iteratee.
     * @returns {Function} Returns the chosen function or its result.
     */
    function getIteratee() {
      var result = lodash.iteratee || iteratee;
      result = result === iteratee ? baseIteratee : result;
      return arguments.length ? result(arguments[0], arguments[1]) : result;
    }

    /**
     * Gets the data for `map`.
     *
     * @private
     * @param {Object} map The map to query.
     * @param {string} key The reference key.
     * @returns {*} Returns the map data.
     */
    function getMapData(map, key) {
      var data = map.__data__;
      return isKeyable(key) ? data[typeof key == 'string' ? 'string' : 'hash'] : data.map;
    }

    /**
     * Gets the property names, values, and compare flags of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the match data of `object`.
     */
    function getMatchData(object) {
      var result = keys(object),
        length = result.length;
      while (length--) {
        var key = result[length],
          value = object[key];
        result[length] = [key, value, isStrictComparable(value)];
      }
      return result;
    }

    /**
     * Gets the native function at `key` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the method to get.
     * @returns {*} Returns the function if it's native, else `undefined`.
     */
    function getNative(object, key) {
      var value = getValue(object, key);
      return baseIsNative(value) ? value : undefined;
    }

    /**
     * A specialized version of `baseGetTag` which ignores `Symbol.toStringTag` values.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the raw `toStringTag`.
     */
    function getRawTag(value) {
      var isOwn = hasOwnProperty.call(value, symToStringTag),
        tag = value[symToStringTag];
      try {
        value[symToStringTag] = undefined;
        var unmasked = true;
      } catch (e) {}
      var result = nativeObjectToString.call(value);
      if (unmasked) {
        if (isOwn) {
          value[symToStringTag] = tag;
        } else {
          delete value[symToStringTag];
        }
      }
      return result;
    }

    /**
     * Creates an array of the own enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbols = !nativeGetSymbols ? stubArray : function (object) {
      if (object == null) {
        return [];
      }
      object = Object(object);
      return arrayFilter(nativeGetSymbols(object), function (symbol) {
        return propertyIsEnumerable.call(object, symbol);
      });
    };

    /**
     * Creates an array of the own and inherited enumerable symbols of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of symbols.
     */
    var getSymbolsIn = !nativeGetSymbols ? stubArray : function (object) {
      var result = [];
      while (object) {
        arrayPush(result, getSymbols(object));
        object = getPrototype(object);
      }
      return result;
    };

    /**
     * Gets the `toStringTag` of `value`.
     *
     * @private
     * @param {*} value The value to query.
     * @returns {string} Returns the `toStringTag`.
     */
    var getTag = baseGetTag;

    // Fallback for data views, maps, sets, and weak maps in IE 11 and promises in Node.js < 6.
    if (DataView && getTag(new DataView(new ArrayBuffer(1))) != dataViewTag || Map && getTag(new Map()) != mapTag || Promise && getTag(Promise.resolve()) != promiseTag || Set && getTag(new Set()) != setTag || WeakMap && getTag(new WeakMap()) != weakMapTag) {
      getTag = function getTag(value) {
        var result = baseGetTag(value),
          Ctor = result == objectTag ? value.constructor : undefined,
          ctorString = Ctor ? toSource(Ctor) : '';
        if (ctorString) {
          switch (ctorString) {
            case dataViewCtorString:
              return dataViewTag;
            case mapCtorString:
              return mapTag;
            case promiseCtorString:
              return promiseTag;
            case setCtorString:
              return setTag;
            case weakMapCtorString:
              return weakMapTag;
          }
        }
        return result;
      };
    }

    /**
     * Gets the view, applying any `transforms` to the `start` and `end` positions.
     *
     * @private
     * @param {number} start The start of the view.
     * @param {number} end The end of the view.
     * @param {Array} transforms The transformations to apply to the view.
     * @returns {Object} Returns an object containing the `start` and `end`
     *  positions of the view.
     */
    function getView(start, end, transforms) {
      var index = -1,
        length = transforms.length;
      while (++index < length) {
        var data = transforms[index],
          size = data.size;
        switch (data.type) {
          case 'drop':
            start += size;
            break;
          case 'dropRight':
            end -= size;
            break;
          case 'take':
            end = nativeMin(end, start + size);
            break;
          case 'takeRight':
            start = nativeMax(start, end - size);
            break;
        }
      }
      return {
        'start': start,
        'end': end
      };
    }

    /**
     * Extracts wrapper details from the `source` body comment.
     *
     * @private
     * @param {string} source The source to inspect.
     * @returns {Array} Returns the wrapper details.
     */
    function getWrapDetails(source) {
      var match = source.match(reWrapDetails);
      return match ? match[1].split(reSplitDetails) : [];
    }

    /**
     * Checks if `path` exists on `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @param {Function} hasFunc The function to check properties.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     */
    function hasPath(object, path, hasFunc) {
      path = castPath(path, object);
      var index = -1,
        length = path.length,
        result = false;
      while (++index < length) {
        var key = toKey(path[index]);
        if (!(result = object != null && hasFunc(object, key))) {
          break;
        }
        object = object[key];
      }
      if (result || ++index != length) {
        return result;
      }
      length = object == null ? 0 : object.length;
      return !!length && isLength(length) && isIndex(key, length) && (isArray(object) || isArguments(object));
    }

    /**
     * Initializes an array clone.
     *
     * @private
     * @param {Array} array The array to clone.
     * @returns {Array} Returns the initialized clone.
     */
    function initCloneArray(array) {
      var length = array.length,
        result = new array.constructor(length);

      // Add properties assigned by `RegExp#exec`.
      if (length && typeof array[0] == 'string' && hasOwnProperty.call(array, 'index')) {
        result.index = array.index;
        result.input = array.input;
      }
      return result;
    }

    /**
     * Initializes an object clone.
     *
     * @private
     * @param {Object} object The object to clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneObject(object) {
      return typeof object.constructor == 'function' && !isPrototype(object) ? baseCreate(getPrototype(object)) : {};
    }

    /**
     * Initializes an object clone based on its `toStringTag`.
     *
     * **Note:** This function only supports cloning values with tags of
     * `Boolean`, `Date`, `Error`, `Map`, `Number`, `RegExp`, `Set`, or `String`.
     *
     * @private
     * @param {Object} object The object to clone.
     * @param {string} tag The `toStringTag` of the object to clone.
     * @param {boolean} [isDeep] Specify a deep clone.
     * @returns {Object} Returns the initialized clone.
     */
    function initCloneByTag(object, tag, isDeep) {
      var Ctor = object.constructor;
      switch (tag) {
        case arrayBufferTag:
          return cloneArrayBuffer(object);
        case boolTag:
        case dateTag:
          return new Ctor(+object);
        case dataViewTag:
          return cloneDataView(object, isDeep);
        case float32Tag:
        case float64Tag:
        case int8Tag:
        case int16Tag:
        case int32Tag:
        case uint8Tag:
        case uint8ClampedTag:
        case uint16Tag:
        case uint32Tag:
          return cloneTypedArray(object, isDeep);
        case mapTag:
          return new Ctor();
        case numberTag:
        case stringTag:
          return new Ctor(object);
        case regexpTag:
          return cloneRegExp(object);
        case setTag:
          return new Ctor();
        case symbolTag:
          return cloneSymbol(object);
      }
    }

    /**
     * Inserts wrapper `details` in a comment at the top of the `source` body.
     *
     * @private
     * @param {string} source The source to modify.
     * @returns {Array} details The details to insert.
     * @returns {string} Returns the modified source.
     */
    function insertWrapDetails(source, details) {
      var length = details.length;
      if (!length) {
        return source;
      }
      var lastIndex = length - 1;
      details[lastIndex] = (length > 1 ? '& ' : '') + details[lastIndex];
      details = details.join(length > 2 ? ', ' : ' ');
      return source.replace(reWrapComment, '{\n/* [wrapped with ' + details + '] */\n');
    }

    /**
     * Checks if `value` is a flattenable `arguments` object or array.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is flattenable, else `false`.
     */
    function isFlattenable(value) {
      return isArray(value) || isArguments(value) || !!(spreadableSymbol && value && value[spreadableSymbol]);
    }

    /**
     * Checks if `value` is a valid array-like index.
     *
     * @private
     * @param {*} value The value to check.
     * @param {number} [length=MAX_SAFE_INTEGER] The upper bounds of a valid index.
     * @returns {boolean} Returns `true` if `value` is a valid index, else `false`.
     */
    function isIndex(value, length) {
      var type = _typeof(value);
      length = length == null ? MAX_SAFE_INTEGER : length;
      return !!length && (type == 'number' || type != 'symbol' && reIsUint.test(value)) && value > -1 && value % 1 == 0 && value < length;
    }

    /**
     * Checks if the given arguments are from an iteratee call.
     *
     * @private
     * @param {*} value The potential iteratee value argument.
     * @param {*} index The potential iteratee index or key argument.
     * @param {*} object The potential iteratee object argument.
     * @returns {boolean} Returns `true` if the arguments are from an iteratee call,
     *  else `false`.
     */
    function isIterateeCall(value, index, object) {
      if (!isObject(object)) {
        return false;
      }
      var type = _typeof(index);
      if (type == 'number' ? isArrayLike(object) && isIndex(index, object.length) : type == 'string' && index in object) {
        return eq(object[index], value);
      }
      return false;
    }

    /**
     * Checks if `value` is a property name and not a property path.
     *
     * @private
     * @param {*} value The value to check.
     * @param {Object} [object] The object to query keys on.
     * @returns {boolean} Returns `true` if `value` is a property name, else `false`.
     */
    function isKey(value, object) {
      if (isArray(value)) {
        return false;
      }
      var type = _typeof(value);
      if (type == 'number' || type == 'symbol' || type == 'boolean' || value == null || isSymbol(value)) {
        return true;
      }
      return reIsPlainProp.test(value) || !reIsDeepProp.test(value) || object != null && value in Object(object);
    }

    /**
     * Checks if `value` is suitable for use as unique object key.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is suitable, else `false`.
     */
    function isKeyable(value) {
      var type = _typeof(value);
      return type == 'string' || type == 'number' || type == 'symbol' || type == 'boolean' ? value !== '__proto__' : value === null;
    }

    /**
     * Checks if `func` has a lazy counterpart.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` has a lazy counterpart,
     *  else `false`.
     */
    function isLaziable(func) {
      var funcName = getFuncName(func),
        other = lodash[funcName];
      if (typeof other != 'function' || !(funcName in LazyWrapper.prototype)) {
        return false;
      }
      if (func === other) {
        return true;
      }
      var data = getData(other);
      return !!data && func === data[0];
    }

    /**
     * Checks if `func` has its source masked.
     *
     * @private
     * @param {Function} func The function to check.
     * @returns {boolean} Returns `true` if `func` is masked, else `false`.
     */
    function isMasked(func) {
      return !!maskSrcKey && maskSrcKey in func;
    }

    /**
     * Checks if `func` is capable of being masked.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `func` is maskable, else `false`.
     */
    var isMaskable = coreJsData ? isFunction : stubFalse;

    /**
     * Checks if `value` is likely a prototype object.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a prototype, else `false`.
     */
    function isPrototype(value) {
      var Ctor = value && value.constructor,
        proto = typeof Ctor == 'function' && Ctor.prototype || objectProto;
      return value === proto;
    }

    /**
     * Checks if `value` is suitable for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` if suitable for strict
     *  equality comparisons, else `false`.
     */
    function isStrictComparable(value) {
      return value === value && !isObject(value);
    }

    /**
     * A specialized version of `matchesProperty` for source values suitable
     * for strict equality comparisons, i.e. `===`.
     *
     * @private
     * @param {string} key The key of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     */
    function matchesStrictComparable(key, srcValue) {
      return function (object) {
        if (object == null) {
          return false;
        }
        return object[key] === srcValue && (srcValue !== undefined || key in Object(object));
      };
    }

    /**
     * A specialized version of `_.memoize` which clears the memoized function's
     * cache when it exceeds `MAX_MEMOIZE_SIZE`.
     *
     * @private
     * @param {Function} func The function to have its output memoized.
     * @returns {Function} Returns the new memoized function.
     */
    function memoizeCapped(func) {
      var result = memoize(func, function (key) {
        if (cache.size === MAX_MEMOIZE_SIZE) {
          cache.clear();
        }
        return key;
      });
      var cache = result.cache;
      return result;
    }

    /**
     * Merges the function metadata of `source` into `data`.
     *
     * Merging metadata reduces the number of wrappers used to invoke a function.
     * This is possible because methods like `_.bind`, `_.curry`, and `_.partial`
     * may be applied regardless of execution order. Methods like `_.ary` and
     * `_.rearg` modify function arguments, making the order in which they are
     * executed important, preventing the merging of metadata. However, we make
     * an exception for a safe combined case where curried functions have `_.ary`
     * and or `_.rearg` applied.
     *
     * @private
     * @param {Array} data The destination metadata.
     * @param {Array} source The source metadata.
     * @returns {Array} Returns `data`.
     */
    function mergeData(data, source) {
      var bitmask = data[1],
        srcBitmask = source[1],
        newBitmask = bitmask | srcBitmask,
        isCommon = newBitmask < (WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG | WRAP_ARY_FLAG);
      var isCombo = srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_CURRY_FLAG || srcBitmask == WRAP_ARY_FLAG && bitmask == WRAP_REARG_FLAG && data[7].length <= source[8] || srcBitmask == (WRAP_ARY_FLAG | WRAP_REARG_FLAG) && source[7].length <= source[8] && bitmask == WRAP_CURRY_FLAG;

      // Exit early if metadata can't be merged.
      if (!(isCommon || isCombo)) {
        return data;
      }
      // Use source `thisArg` if available.
      if (srcBitmask & WRAP_BIND_FLAG) {
        data[2] = source[2];
        // Set when currying a bound function.
        newBitmask |= bitmask & WRAP_BIND_FLAG ? 0 : WRAP_CURRY_BOUND_FLAG;
      }
      // Compose partial arguments.
      var value = source[3];
      if (value) {
        var partials = data[3];
        data[3] = partials ? composeArgs(partials, value, source[4]) : value;
        data[4] = partials ? replaceHolders(data[3], PLACEHOLDER) : source[4];
      }
      // Compose partial right arguments.
      value = source[5];
      if (value) {
        partials = data[5];
        data[5] = partials ? composeArgsRight(partials, value, source[6]) : value;
        data[6] = partials ? replaceHolders(data[5], PLACEHOLDER) : source[6];
      }
      // Use source `argPos` if available.
      value = source[7];
      if (value) {
        data[7] = value;
      }
      // Use source `ary` if it's smaller.
      if (srcBitmask & WRAP_ARY_FLAG) {
        data[8] = data[8] == null ? source[8] : nativeMin(data[8], source[8]);
      }
      // Use source `arity` if one is not provided.
      if (data[9] == null) {
        data[9] = source[9];
      }
      // Use source `func` and merge bitmasks.
      data[0] = source[0];
      data[1] = newBitmask;
      return data;
    }

    /**
     * This function is like
     * [`Object.keys`](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * except that it includes inherited enumerable properties.
     *
     * @private
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     */
    function nativeKeysIn(object) {
      var result = [];
      if (object != null) {
        for (var key in Object(object)) {
          result.push(key);
        }
      }
      return result;
    }

    /**
     * Converts `value` to a string using `Object.prototype.toString`.
     *
     * @private
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     */
    function objectToString(value) {
      return nativeObjectToString.call(value);
    }

    /**
     * A specialized version of `baseRest` which transforms the rest array.
     *
     * @private
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @param {Function} transform The rest array transform.
     * @returns {Function} Returns the new function.
     */
    function overRest(func, start, transform) {
      start = nativeMax(start === undefined ? func.length - 1 : start, 0);
      return function () {
        var args = arguments,
          index = -1,
          length = nativeMax(args.length - start, 0),
          array = Array(length);
        while (++index < length) {
          array[index] = args[start + index];
        }
        index = -1;
        var otherArgs = Array(start + 1);
        while (++index < start) {
          otherArgs[index] = args[index];
        }
        otherArgs[start] = transform(array);
        return apply(func, this, otherArgs);
      };
    }

    /**
     * Gets the parent value at `path` of `object`.
     *
     * @private
     * @param {Object} object The object to query.
     * @param {Array} path The path to get the parent value of.
     * @returns {*} Returns the parent value.
     */
    function parent(object, path) {
      return path.length < 2 ? object : baseGet(object, baseSlice(path, 0, -1));
    }

    /**
     * Reorder `array` according to the specified indexes where the element at
     * the first index is assigned as the first element, the element at
     * the second index is assigned as the second element, and so on.
     *
     * @private
     * @param {Array} array The array to reorder.
     * @param {Array} indexes The arranged array indexes.
     * @returns {Array} Returns `array`.
     */
    function reorder(array, indexes) {
      var arrLength = array.length,
        length = nativeMin(indexes.length, arrLength),
        oldArray = copyArray(array);
      while (length--) {
        var index = indexes[length];
        array[length] = isIndex(index, arrLength) ? oldArray[index] : undefined;
      }
      return array;
    }

    /**
     * Gets the value at `key`, unless `key` is "__proto__" or "constructor".
     *
     * @private
     * @param {Object} object The object to query.
     * @param {string} key The key of the property to get.
     * @returns {*} Returns the property value.
     */
    function safeGet(object, key) {
      if (key === 'constructor' && typeof object[key] === 'function') {
        return;
      }
      if (key == '__proto__') {
        return;
      }
      return object[key];
    }

    /**
     * Sets metadata for `func`.
     *
     * **Note:** If this function becomes hot, i.e. is invoked a lot in a short
     * period of time, it will trip its breaker and transition to an identity
     * function to avoid garbage collection pauses in V8. See
     * [V8 issue 2070](https://bugs.chromium.org/p/v8/issues/detail?id=2070)
     * for more details.
     *
     * @private
     * @param {Function} func The function to associate metadata with.
     * @param {*} data The metadata.
     * @returns {Function} Returns `func`.
     */
    var setData = shortOut(baseSetData);

    /**
     * A simple wrapper around the global [`setTimeout`](https://mdn.io/setTimeout).
     *
     * @private
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @returns {number|Object} Returns the timer id or timeout object.
     */
    var setTimeout = ctxSetTimeout || function (func, wait) {
      return root.setTimeout(func, wait);
    };

    /**
     * Sets the `toString` method of `func` to return `string`.
     *
     * @private
     * @param {Function} func The function to modify.
     * @param {Function} string The `toString` result.
     * @returns {Function} Returns `func`.
     */
    var setToString = shortOut(baseSetToString);

    /**
     * Sets the `toString` method of `wrapper` to mimic the source of `reference`
     * with wrapper details in a comment at the top of the source body.
     *
     * @private
     * @param {Function} wrapper The function to modify.
     * @param {Function} reference The reference function.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Function} Returns `wrapper`.
     */
    function setWrapToString(wrapper, reference, bitmask) {
      var source = reference + '';
      return setToString(wrapper, insertWrapDetails(source, updateWrapDetails(getWrapDetails(source), bitmask)));
    }

    /**
     * Creates a function that'll short out and invoke `identity` instead
     * of `func` when it's called `HOT_COUNT` or more times in `HOT_SPAN`
     * milliseconds.
     *
     * @private
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new shortable function.
     */
    function shortOut(func) {
      var count = 0,
        lastCalled = 0;
      return function () {
        var stamp = nativeNow(),
          remaining = HOT_SPAN - (stamp - lastCalled);
        lastCalled = stamp;
        if (remaining > 0) {
          if (++count >= HOT_COUNT) {
            return arguments[0];
          }
        } else {
          count = 0;
        }
        return func.apply(undefined, arguments);
      };
    }

    /**
     * A specialized version of `_.shuffle` which mutates and sets the size of `array`.
     *
     * @private
     * @param {Array} array The array to shuffle.
     * @param {number} [size=array.length] The size of `array`.
     * @returns {Array} Returns `array`.
     */
    function shuffleSelf(array, size) {
      var index = -1,
        length = array.length,
        lastIndex = length - 1;
      size = size === undefined ? length : size;
      while (++index < size) {
        var rand = baseRandom(index, lastIndex),
          value = array[rand];
        array[rand] = array[index];
        array[index] = value;
      }
      array.length = size;
      return array;
    }

    /**
     * Converts `string` to a property path array.
     *
     * @private
     * @param {string} string The string to convert.
     * @returns {Array} Returns the property path array.
     */
    var stringToPath = memoizeCapped(function (string) {
      var result = [];
      if (string.charCodeAt(0) === 46 /* . */) {
        result.push('');
      }
      string.replace(rePropName, function (match, number, quote, subString) {
        result.push(quote ? subString.replace(reEscapeChar, '$1') : number || match);
      });
      return result;
    });

    /**
     * Converts `value` to a string key if it's not a string or symbol.
     *
     * @private
     * @param {*} value The value to inspect.
     * @returns {string|symbol} Returns the key.
     */
    function toKey(value) {
      if (typeof value == 'string' || isSymbol(value)) {
        return value;
      }
      var result = value + '';
      return result == '0' && 1 / value == -INFINITY ? '-0' : result;
    }

    /**
     * Converts `func` to its source code.
     *
     * @private
     * @param {Function} func The function to convert.
     * @returns {string} Returns the source code.
     */
    function toSource(func) {
      if (func != null) {
        try {
          return funcToString.call(func);
        } catch (e) {}
        try {
          return func + '';
        } catch (e) {}
      }
      return '';
    }

    /**
     * Updates wrapper `details` based on `bitmask` flags.
     *
     * @private
     * @returns {Array} details The details to modify.
     * @param {number} bitmask The bitmask flags. See `createWrap` for more details.
     * @returns {Array} Returns `details`.
     */
    function updateWrapDetails(details, bitmask) {
      arrayEach(wrapFlags, function (pair) {
        var value = '_.' + pair[0];
        if (bitmask & pair[1] && !arrayIncludes(details, value)) {
          details.push(value);
        }
      });
      return details.sort();
    }

    /**
     * Creates a clone of `wrapper`.
     *
     * @private
     * @param {Object} wrapper The wrapper to clone.
     * @returns {Object} Returns the cloned wrapper.
     */
    function wrapperClone(wrapper) {
      if (wrapper instanceof LazyWrapper) {
        return wrapper.clone();
      }
      var result = new LodashWrapper(wrapper.__wrapped__, wrapper.__chain__);
      result.__actions__ = copyArray(wrapper.__actions__);
      result.__index__ = wrapper.__index__;
      result.__values__ = wrapper.__values__;
      return result;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an array of elements split into groups the length of `size`.
     * If `array` can't be split evenly, the final chunk will be the remaining
     * elements.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to process.
     * @param {number} [size=1] The length of each chunk
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the new array of chunks.
     * @example
     *
     * _.chunk(['a', 'b', 'c', 'd'], 2);
     * // => [['a', 'b'], ['c', 'd']]
     *
     * _.chunk(['a', 'b', 'c', 'd'], 3);
     * // => [['a', 'b', 'c'], ['d']]
     */
    function chunk(array, size, guard) {
      if (guard ? isIterateeCall(array, size, guard) : size === undefined) {
        size = 1;
      } else {
        size = nativeMax(toInteger(size), 0);
      }
      var length = array == null ? 0 : array.length;
      if (!length || size < 1) {
        return [];
      }
      var index = 0,
        resIndex = 0,
        result = Array(nativeCeil(length / size));
      while (index < length) {
        result[resIndex++] = baseSlice(array, index, index += size);
      }
      return result;
    }

    /**
     * Creates an array with all falsey values removed. The values `false`, `null`,
     * `0`, `""`, `undefined`, and `NaN` are falsey.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to compact.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.compact([0, 1, false, 2, '', 3]);
     * // => [1, 2, 3]
     */
    function compact(array) {
      var index = -1,
        length = array == null ? 0 : array.length,
        resIndex = 0,
        result = [];
      while (++index < length) {
        var value = array[index];
        if (value) {
          result[resIndex++] = value;
        }
      }
      return result;
    }

    /**
     * Creates a new array concatenating `array` with any additional arrays
     * and/or values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to concatenate.
     * @param {...*} [values] The values to concatenate.
     * @returns {Array} Returns the new concatenated array.
     * @example
     *
     * var array = [1];
     * var other = _.concat(array, 2, [3], [[4]]);
     *
     * console.log(other);
     * // => [1, 2, 3, [4]]
     *
     * console.log(array);
     * // => [1]
     */
    function concat() {
      var length = arguments.length;
      if (!length) {
        return [];
      }
      var args = Array(length - 1),
        array = arguments[0],
        index = length;
      while (index--) {
        args[index - 1] = arguments[index];
      }
      return arrayPush(isArray(array) ? copyArray(array) : [array], baseFlatten(args, 1));
    }

    /**
     * Creates an array of `array` values not included in the other given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * **Note:** Unlike `_.pullAll`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.without, _.xor
     * @example
     *
     * _.difference([2, 1], [2, 3]);
     * // => [1]
     */
    var difference = baseRest(function (array, values) {
      return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true)) : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `iteratee` which
     * is invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * **Note:** Unlike `_.pullAllBy`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.differenceBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.differenceBy([{ 'x': 2 }, { 'x': 1 }], [{ 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var differenceBy = baseRest(function (array, values) {
      var iteratee = last(values);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), getIteratee(iteratee, 2)) : [];
    });

    /**
     * This method is like `_.difference` except that it accepts `comparator`
     * which is invoked to compare elements of `array` to `values`. The order and
     * references of result values are determined by the first array. The comparator
     * is invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.pullAllWith`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...Array} [values] The values to exclude.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     *
     * _.differenceWith(objects, [{ 'x': 1, 'y': 2 }], _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }]
     */
    var differenceWith = baseRest(function (array, values) {
      var comparator = last(values);
      if (isArrayLikeObject(comparator)) {
        comparator = undefined;
      }
      return isArrayLikeObject(array) ? baseDifference(array, baseFlatten(values, 1, isArrayLikeObject, true), undefined, comparator) : [];
    });

    /**
     * Creates a slice of `array` with `n` elements dropped from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.drop([1, 2, 3]);
     * // => [2, 3]
     *
     * _.drop([1, 2, 3], 2);
     * // => [3]
     *
     * _.drop([1, 2, 3], 5);
     * // => []
     *
     * _.drop([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function drop(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = guard || n === undefined ? 1 : toInteger(n);
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with `n` elements dropped from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to drop.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.dropRight([1, 2, 3]);
     * // => [1, 2]
     *
     * _.dropRight([1, 2, 3], 2);
     * // => [1]
     *
     * _.dropRight([1, 2, 3], 5);
     * // => []
     *
     * _.dropRight([1, 2, 3], 0);
     * // => [1, 2, 3]
     */
    function dropRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = guard || n === undefined ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the end.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.dropRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropRightWhile(users, ['active', false]);
     * // => objects for ['barney']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropRightWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropRightWhile(array, predicate) {
      return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true, true) : [];
    }

    /**
     * Creates a slice of `array` excluding elements dropped from the beginning.
     * Elements are dropped until `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.dropWhile(users, function(o) { return !o.active; });
     * // => objects for ['pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.dropWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.dropWhile(users, ['active', false]);
     * // => objects for ['pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.dropWhile(users, 'active');
     * // => objects for ['barney', 'fred', 'pebbles']
     */
    function dropWhile(array, predicate) {
      return array && array.length ? baseWhile(array, getIteratee(predicate, 3), true) : [];
    }

    /**
     * Fills elements of `array` with `value` from `start` up to, but not
     * including, `end`.
     *
     * **Note:** This method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Array
     * @param {Array} array The array to fill.
     * @param {*} value The value to fill `array` with.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.fill(array, 'a');
     * console.log(array);
     * // => ['a', 'a', 'a']
     *
     * _.fill(Array(3), 2);
     * // => [2, 2, 2]
     *
     * _.fill([4, 6, 8, 10], '*', 1, 3);
     * // => [4, '*', '*', 10]
     */
    function fill(array, value, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (start && typeof start != 'number' && isIterateeCall(array, value, start)) {
        start = 0;
        end = length;
      }
      return baseFill(array, value, start, end);
    }

    /**
     * This method is like `_.find` except that it returns the index of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.findIndex(users, function(o) { return o.user == 'barney'; });
     * // => 0
     *
     * // The `_.matches` iteratee shorthand.
     * _.findIndex(users, { 'user': 'fred', 'active': false });
     * // => 1
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findIndex(users, ['active', false]);
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.findIndex(users, 'active');
     * // => 2
     */
    function findIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index);
    }

    /**
     * This method is like `_.findIndex` except that it iterates over elements
     * of `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the found element, else `-1`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.findLastIndex(users, function(o) { return o.user == 'pebbles'; });
     * // => 2
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastIndex(users, { 'user': 'barney', 'active': true });
     * // => 0
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastIndex(users, ['active', false]);
     * // => 2
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastIndex(users, 'active');
     * // => 0
     */
    function findLastIndex(array, predicate, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length - 1;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = fromIndex < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return baseFindIndex(array, getIteratee(predicate, 3), index, true);
    }

    /**
     * Flattens `array` a single level deep.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flatten([1, [2, [3, [4]], 5]]);
     * // => [1, 2, [3, [4]], 5]
     */
    function flatten(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, 1) : [];
    }

    /**
     * Recursively flattens `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * _.flattenDeep([1, [2, [3, [4]], 5]]);
     * // => [1, 2, 3, 4, 5]
     */
    function flattenDeep(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseFlatten(array, INFINITY) : [];
    }

    /**
     * Recursively flatten `array` up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Array
     * @param {Array} array The array to flatten.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * var array = [1, [2, [3, [4]], 5]];
     *
     * _.flattenDepth(array, 1);
     * // => [1, 2, [3, [4]], 5]
     *
     * _.flattenDepth(array, 2);
     * // => [1, 2, 3, [4], 5]
     */
    function flattenDepth(array, depth) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(array, depth);
    }

    /**
     * The inverse of `_.toPairs`; this method returns an object composed
     * from key-value `pairs`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} pairs The key-value pairs.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.fromPairs([['a', 1], ['b', 2]]);
     * // => { 'a': 1, 'b': 2 }
     */
    function fromPairs(pairs) {
      var index = -1,
        length = pairs == null ? 0 : pairs.length,
        result = {};
      while (++index < length) {
        var pair = pairs[index];
        result[pair[0]] = pair[1];
      }
      return result;
    }

    /**
     * Gets the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias first
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the first element of `array`.
     * @example
     *
     * _.head([1, 2, 3]);
     * // => 1
     *
     * _.head([]);
     * // => undefined
     */
    function head(array) {
      return array && array.length ? array[0] : undefined;
    }

    /**
     * Gets the index at which the first occurrence of `value` is found in `array`
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. If `fromIndex` is negative, it's used as the
     * offset from the end of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.indexOf([1, 2, 1, 2], 2);
     * // => 1
     *
     * // Search from the `fromIndex`.
     * _.indexOf([1, 2, 1, 2], 2, 2);
     * // => 3
     */
    function indexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = fromIndex == null ? 0 : toInteger(fromIndex);
      if (index < 0) {
        index = nativeMax(length + index, 0);
      }
      return baseIndexOf(array, value, index);
    }

    /**
     * Gets all but the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.initial([1, 2, 3]);
     * // => [1, 2]
     */
    function initial(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 0, -1) : [];
    }

    /**
     * Creates an array of unique values that are included in all given arrays
     * using [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons. The order and references of result values are
     * determined by the first array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersection([2, 1], [2, 3]);
     * // => [2]
     */
    var intersection = baseRest(function (arrays) {
      var mapped = arrayMap(arrays, castArrayLikeObject);
      return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped) : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `iteratee`
     * which is invoked for each element of each `arrays` to generate the criterion
     * by which they're compared. The order and references of result values are
     * determined by the first array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * _.intersectionBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [2.1]
     *
     * // The `_.property` iteratee shorthand.
     * _.intersectionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }]
     */
    var intersectionBy = baseRest(function (arrays) {
      var iteratee = last(arrays),
        mapped = arrayMap(arrays, castArrayLikeObject);
      if (iteratee === last(mapped)) {
        iteratee = undefined;
      } else {
        mapped.pop();
      }
      return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, getIteratee(iteratee, 2)) : [];
    });

    /**
     * This method is like `_.intersection` except that it accepts `comparator`
     * which is invoked to compare elements of `arrays`. The order and references
     * of result values are determined by the first array. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of intersecting values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.intersectionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }]
     */
    var intersectionWith = baseRest(function (arrays) {
      var comparator = last(arrays),
        mapped = arrayMap(arrays, castArrayLikeObject);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      if (comparator) {
        mapped.pop();
      }
      return mapped.length && mapped[0] === arrays[0] ? baseIntersection(mapped, undefined, comparator) : [];
    });

    /**
     * Converts all elements in `array` into a string separated by `separator`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to convert.
     * @param {string} [separator=','] The element separator.
     * @returns {string} Returns the joined string.
     * @example
     *
     * _.join(['a', 'b', 'c'], '~');
     * // => 'a~b~c'
     */
    function join(array, separator) {
      return array == null ? '' : nativeJoin.call(array, separator);
    }

    /**
     * Gets the last element of `array`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {*} Returns the last element of `array`.
     * @example
     *
     * _.last([1, 2, 3]);
     * // => 3
     */
    function last(array) {
      var length = array == null ? 0 : array.length;
      return length ? array[length - 1] : undefined;
    }

    /**
     * This method is like `_.indexOf` except that it iterates over elements of
     * `array` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=array.length-1] The index to search from.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.lastIndexOf([1, 2, 1, 2], 2);
     * // => 3
     *
     * // Search from the `fromIndex`.
     * _.lastIndexOf([1, 2, 1, 2], 2, 2);
     * // => 1
     */
    function lastIndexOf(array, value, fromIndex) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return -1;
      }
      var index = length;
      if (fromIndex !== undefined) {
        index = toInteger(fromIndex);
        index = index < 0 ? nativeMax(length + index, 0) : nativeMin(index, length - 1);
      }
      return value === value ? strictLastIndexOf(array, value, index) : baseFindIndex(array, baseIsNaN, index, true);
    }

    /**
     * Gets the element at index `n` of `array`. If `n` is negative, the nth
     * element from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.11.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=0] The index of the element to return.
     * @returns {*} Returns the nth element of `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     *
     * _.nth(array, 1);
     * // => 'b'
     *
     * _.nth(array, -2);
     * // => 'c';
     */
    function nth(array, n) {
      return array && array.length ? baseNth(array, toInteger(n)) : undefined;
    }

    /**
     * Removes all given values from `array` using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.without`, this method mutates `array`. Use `_.remove`
     * to remove elements from an array by predicate.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...*} [values] The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pull(array, 'a', 'c');
     * console.log(array);
     * // => ['b', 'b']
     */
    var pull = baseRest(pullAll);

    /**
     * This method is like `_.pull` except that it accepts an array of values to remove.
     *
     * **Note:** Unlike `_.difference`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = ['a', 'b', 'c', 'a', 'b', 'c'];
     *
     * _.pullAll(array, ['a', 'c']);
     * console.log(array);
     * // => ['b', 'b']
     */
    function pullAll(array, values) {
      return array && array.length && values && values.length ? basePullAll(array, values) : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `iteratee` which is
     * invoked for each element of `array` and `values` to generate the criterion
     * by which they're compared. The iteratee is invoked with one argument: (value).
     *
     * **Note:** Unlike `_.differenceBy`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1 }, { 'x': 2 }, { 'x': 3 }, { 'x': 1 }];
     *
     * _.pullAllBy(array, [{ 'x': 1 }, { 'x': 3 }], 'x');
     * console.log(array);
     * // => [{ 'x': 2 }]
     */
    function pullAllBy(array, values, iteratee) {
      return array && array.length && values && values.length ? basePullAll(array, values, getIteratee(iteratee, 2)) : array;
    }

    /**
     * This method is like `_.pullAll` except that it accepts `comparator` which
     * is invoked to compare elements of `array` to `values`. The comparator is
     * invoked with two arguments: (arrVal, othVal).
     *
     * **Note:** Unlike `_.differenceWith`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Array} values The values to remove.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [{ 'x': 1, 'y': 2 }, { 'x': 3, 'y': 4 }, { 'x': 5, 'y': 6 }];
     *
     * _.pullAllWith(array, [{ 'x': 3, 'y': 4 }], _.isEqual);
     * console.log(array);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 5, 'y': 6 }]
     */
    function pullAllWith(array, values, comparator) {
      return array && array.length && values && values.length ? basePullAll(array, values, undefined, comparator) : array;
    }

    /**
     * Removes elements from `array` corresponding to `indexes` and returns an
     * array of removed elements.
     *
     * **Note:** Unlike `_.at`, this method mutates `array`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {...(number|number[])} [indexes] The indexes of elements to remove.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = ['a', 'b', 'c', 'd'];
     * var pulled = _.pullAt(array, [1, 3]);
     *
     * console.log(array);
     * // => ['a', 'c']
     *
     * console.log(pulled);
     * // => ['b', 'd']
     */
    var pullAt = flatRest(function (array, indexes) {
      var length = array == null ? 0 : array.length,
        result = baseAt(array, indexes);
      basePullAt(array, arrayMap(indexes, function (index) {
        return isIndex(index, length) ? +index : index;
      }).sort(compareAscending));
      return result;
    });

    /**
     * Removes all elements from `array` that `predicate` returns truthy for
     * and returns an array of the removed elements. The predicate is invoked
     * with three arguments: (value, index, array).
     *
     * **Note:** Unlike `_.filter`, this method mutates `array`. Use `_.pull`
     * to pull elements from an array by value.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new array of removed elements.
     * @example
     *
     * var array = [1, 2, 3, 4];
     * var evens = _.remove(array, function(n) {
     *   return n % 2 == 0;
     * });
     *
     * console.log(array);
     * // => [1, 3]
     *
     * console.log(evens);
     * // => [2, 4]
     */
    function remove(array, predicate) {
      var result = [];
      if (!(array && array.length)) {
        return result;
      }
      var index = -1,
        indexes = [],
        length = array.length;
      predicate = getIteratee(predicate, 3);
      while (++index < length) {
        var value = array[index];
        if (predicate(value, index, array)) {
          result.push(value);
          indexes.push(index);
        }
      }
      basePullAt(array, indexes);
      return result;
    }

    /**
     * Reverses `array` so that the first element becomes the last, the second
     * element becomes the second to last, and so on.
     *
     * **Note:** This method mutates `array` and is based on
     * [`Array#reverse`](https://mdn.io/Array/reverse).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to modify.
     * @returns {Array} Returns `array`.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _.reverse(array);
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function reverse(array) {
      return array == null ? array : nativeReverse.call(array);
    }

    /**
     * Creates a slice of `array` from `start` up to, but not including, `end`.
     *
     * **Note:** This method is used instead of
     * [`Array#slice`](https://mdn.io/Array/slice) to ensure dense arrays are
     * returned.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to slice.
     * @param {number} [start=0] The start position.
     * @param {number} [end=array.length] The end position.
     * @returns {Array} Returns the slice of `array`.
     */
    function slice(array, start, end) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      if (end && typeof end != 'number' && isIterateeCall(array, start, end)) {
        start = 0;
        end = length;
      } else {
        start = start == null ? 0 : toInteger(start);
        end = end === undefined ? length : toInteger(end);
      }
      return baseSlice(array, start, end);
    }

    /**
     * Uses a binary search to determine the lowest index at which `value`
     * should be inserted into `array` in order to maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedIndex([30, 50], 40);
     * // => 1
     */
    function sortedIndex(array, value) {
      return baseSortedIndex(array, value);
    }

    /**
     * This method is like `_.sortedIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 0
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedIndexBy(objects, { 'x': 4 }, 'x');
     * // => 0
     */
    function sortedIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2));
    }

    /**
     * This method is like `_.indexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedIndexOf([4, 5, 5, 5, 6], 5);
     * // => 1
     */
    function sortedIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value);
        if (index < length && eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.sortedIndex` except that it returns the highest
     * index at which `value` should be inserted into `array` in order to
     * maintain its sort order.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * _.sortedLastIndex([4, 5, 5, 5, 6], 5);
     * // => 4
     */
    function sortedLastIndex(array, value) {
      return baseSortedIndex(array, value, true);
    }

    /**
     * This method is like `_.sortedLastIndex` except that it accepts `iteratee`
     * which is invoked for `value` and each element of `array` to compute their
     * sort ranking. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The sorted array to inspect.
     * @param {*} value The value to evaluate.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the index at which `value` should be inserted
     *  into `array`.
     * @example
     *
     * var objects = [{ 'x': 4 }, { 'x': 5 }];
     *
     * _.sortedLastIndexBy(objects, { 'x': 4 }, function(o) { return o.x; });
     * // => 1
     *
     * // The `_.property` iteratee shorthand.
     * _.sortedLastIndexBy(objects, { 'x': 4 }, 'x');
     * // => 1
     */
    function sortedLastIndexBy(array, value, iteratee) {
      return baseSortedIndexBy(array, value, getIteratee(iteratee, 2), true);
    }

    /**
     * This method is like `_.lastIndexOf` except that it performs a binary
     * search on a sorted `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {*} value The value to search for.
     * @returns {number} Returns the index of the matched value, else `-1`.
     * @example
     *
     * _.sortedLastIndexOf([4, 5, 5, 5, 6], 5);
     * // => 3
     */
    function sortedLastIndexOf(array, value) {
      var length = array == null ? 0 : array.length;
      if (length) {
        var index = baseSortedIndex(array, value, true) - 1;
        if (eq(array[index], value)) {
          return index;
        }
      }
      return -1;
    }

    /**
     * This method is like `_.uniq` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniq([1, 1, 2]);
     * // => [1, 2]
     */
    function sortedUniq(array) {
      return array && array.length ? baseSortedUniq(array) : [];
    }

    /**
     * This method is like `_.uniqBy` except that it's designed and optimized
     * for sorted arrays.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.sortedUniqBy([1.1, 1.2, 2.3, 2.4], Math.floor);
     * // => [1.1, 2.3]
     */
    function sortedUniqBy(array, iteratee) {
      return array && array.length ? baseSortedUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * Gets all but the first element of `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.tail([1, 2, 3]);
     * // => [2, 3]
     */
    function tail(array) {
      var length = array == null ? 0 : array.length;
      return length ? baseSlice(array, 1, length) : [];
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the beginning.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.take([1, 2, 3]);
     * // => [1]
     *
     * _.take([1, 2, 3], 2);
     * // => [1, 2]
     *
     * _.take([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.take([1, 2, 3], 0);
     * // => []
     */
    function take(array, n, guard) {
      if (!(array && array.length)) {
        return [];
      }
      n = guard || n === undefined ? 1 : toInteger(n);
      return baseSlice(array, 0, n < 0 ? 0 : n);
    }

    /**
     * Creates a slice of `array` with `n` elements taken from the end.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {number} [n=1] The number of elements to take.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * _.takeRight([1, 2, 3]);
     * // => [3]
     *
     * _.takeRight([1, 2, 3], 2);
     * // => [2, 3]
     *
     * _.takeRight([1, 2, 3], 5);
     * // => [1, 2, 3]
     *
     * _.takeRight([1, 2, 3], 0);
     * // => []
     */
    function takeRight(array, n, guard) {
      var length = array == null ? 0 : array.length;
      if (!length) {
        return [];
      }
      n = guard || n === undefined ? 1 : toInteger(n);
      n = length - n;
      return baseSlice(array, n < 0 ? 0 : n, length);
    }

    /**
     * Creates a slice of `array` with elements taken from the end. Elements are
     * taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': true },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': false }
     * ];
     *
     * _.takeRightWhile(users, function(o) { return !o.active; });
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeRightWhile(users, { 'user': 'pebbles', 'active': false });
     * // => objects for ['pebbles']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeRightWhile(users, ['active', false]);
     * // => objects for ['fred', 'pebbles']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeRightWhile(users, 'active');
     * // => []
     */
    function takeRightWhile(array, predicate) {
      return array && array.length ? baseWhile(array, getIteratee(predicate, 3), false, true) : [];
    }

    /**
     * Creates a slice of `array` with elements taken from the beginning. Elements
     * are taken until `predicate` returns falsey. The predicate is invoked with
     * three arguments: (value, index, array).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Array
     * @param {Array} array The array to query.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the slice of `array`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'active': false },
     *   { 'user': 'fred',    'active': false },
     *   { 'user': 'pebbles', 'active': true }
     * ];
     *
     * _.takeWhile(users, function(o) { return !o.active; });
     * // => objects for ['barney', 'fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.takeWhile(users, { 'user': 'barney', 'active': false });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.takeWhile(users, ['active', false]);
     * // => objects for ['barney', 'fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.takeWhile(users, 'active');
     * // => []
     */
    function takeWhile(array, predicate) {
      return array && array.length ? baseWhile(array, getIteratee(predicate, 3)) : [];
    }

    /**
     * Creates an array of unique values, in order, from all given arrays using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.union([2], [1, 2]);
     * // => [2, 1]
     */
    var union = baseRest(function (arrays) {
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true));
    });

    /**
     * This method is like `_.union` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which uniqueness is computed. Result values are chosen from the first
     * array in which the value occurs. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * _.unionBy([2.1], [1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.unionBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    var unionBy = baseRest(function (arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.union` except that it accepts `comparator` which
     * is invoked to compare elements of `arrays`. Result values are chosen from
     * the first array in which the value occurs. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of combined values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.unionWith(objects, others, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var unionWith = baseRest(function (arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseUniq(baseFlatten(arrays, 1, isArrayLikeObject, true), undefined, comparator);
    });

    /**
     * Creates a duplicate-free version of an array, using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons, in which only the first occurrence of each element
     * is kept. The order of result values is determined by the order they occur
     * in the array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniq([2, 1, 2]);
     * // => [2, 1]
     */
    function uniq(array) {
      return array && array.length ? baseUniq(array) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * uniqueness is computed. The order of result values is determined by the
     * order they occur in the array. The iteratee is invoked with one argument:
     * (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * _.uniqBy([2.1, 1.2, 2.3], Math.floor);
     * // => [2.1, 1.2]
     *
     * // The `_.property` iteratee shorthand.
     * _.uniqBy([{ 'x': 1 }, { 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 1 }, { 'x': 2 }]
     */
    function uniqBy(array, iteratee) {
      return array && array.length ? baseUniq(array, getIteratee(iteratee, 2)) : [];
    }

    /**
     * This method is like `_.uniq` except that it accepts `comparator` which
     * is invoked to compare elements of `array`. The order of result values is
     * determined by the order they occur in the array.The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new duplicate free array.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.uniqWith(objects, _.isEqual);
     * // => [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }]
     */
    function uniqWith(array, comparator) {
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return array && array.length ? baseUniq(array, undefined, comparator) : [];
    }

    /**
     * This method is like `_.zip` except that it accepts an array of grouped
     * elements and creates an array regrouping the elements to their pre-zip
     * configuration.
     *
     * @static
     * @memberOf _
     * @since 1.2.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     *
     * _.unzip(zipped);
     * // => [['a', 'b'], [1, 2], [true, false]]
     */
    function unzip(array) {
      if (!(array && array.length)) {
        return [];
      }
      var length = 0;
      array = arrayFilter(array, function (group) {
        if (isArrayLikeObject(group)) {
          length = nativeMax(group.length, length);
          return true;
        }
      });
      return baseTimes(length, function (index) {
        return arrayMap(array, baseProperty(index));
      });
    }

    /**
     * This method is like `_.unzip` except that it accepts `iteratee` to specify
     * how regrouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {Array} array The array of grouped elements to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  regrouped values.
     * @returns {Array} Returns the new array of regrouped elements.
     * @example
     *
     * var zipped = _.zip([1, 2], [10, 20], [100, 200]);
     * // => [[1, 10, 100], [2, 20, 200]]
     *
     * _.unzipWith(zipped, _.add);
     * // => [3, 30, 300]
     */
    function unzipWith(array, iteratee) {
      if (!(array && array.length)) {
        return [];
      }
      var result = unzip(array);
      if (iteratee == null) {
        return result;
      }
      return arrayMap(result, function (group) {
        return apply(iteratee, undefined, group);
      });
    }

    /**
     * Creates an array excluding all given values using
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * for equality comparisons.
     *
     * **Note:** Unlike `_.pull`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {Array} array The array to inspect.
     * @param {...*} [values] The values to exclude.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.xor
     * @example
     *
     * _.without([2, 1, 2, 3], 1, 2);
     * // => [3]
     */
    var without = baseRest(function (array, values) {
      return isArrayLikeObject(array) ? baseDifference(array, values) : [];
    });

    /**
     * Creates an array of unique values that is the
     * [symmetric difference](https://en.wikipedia.org/wiki/Symmetric_difference)
     * of the given arrays. The order of result values is determined by the order
     * they occur in the arrays.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @returns {Array} Returns the new array of filtered values.
     * @see _.difference, _.without
     * @example
     *
     * _.xor([2, 1], [2, 3]);
     * // => [1, 3]
     */
    var xor = baseRest(function (arrays) {
      return baseXor(arrayFilter(arrays, isArrayLikeObject));
    });

    /**
     * This method is like `_.xor` except that it accepts `iteratee` which is
     * invoked for each element of each `arrays` to generate the criterion by
     * which by which they're compared. The order of result values is determined
     * by the order they occur in the arrays. The iteratee is invoked with one
     * argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * _.xorBy([2.1, 1.2], [2.3, 3.4], Math.floor);
     * // => [1.2, 3.4]
     *
     * // The `_.property` iteratee shorthand.
     * _.xorBy([{ 'x': 1 }], [{ 'x': 2 }, { 'x': 1 }], 'x');
     * // => [{ 'x': 2 }]
     */
    var xorBy = baseRest(function (arrays) {
      var iteratee = last(arrays);
      if (isArrayLikeObject(iteratee)) {
        iteratee = undefined;
      }
      return baseXor(arrayFilter(arrays, isArrayLikeObject), getIteratee(iteratee, 2));
    });

    /**
     * This method is like `_.xor` except that it accepts `comparator` which is
     * invoked to compare elements of `arrays`. The order of result values is
     * determined by the order they occur in the arrays. The comparator is invoked
     * with two arguments: (arrVal, othVal).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Array
     * @param {...Array} [arrays] The arrays to inspect.
     * @param {Function} [comparator] The comparator invoked per element.
     * @returns {Array} Returns the new array of filtered values.
     * @example
     *
     * var objects = [{ 'x': 1, 'y': 2 }, { 'x': 2, 'y': 1 }];
     * var others = [{ 'x': 1, 'y': 1 }, { 'x': 1, 'y': 2 }];
     *
     * _.xorWith(objects, others, _.isEqual);
     * // => [{ 'x': 2, 'y': 1 }, { 'x': 1, 'y': 1 }]
     */
    var xorWith = baseRest(function (arrays) {
      var comparator = last(arrays);
      comparator = typeof comparator == 'function' ? comparator : undefined;
      return baseXor(arrayFilter(arrays, isArrayLikeObject), undefined, comparator);
    });

    /**
     * Creates an array of grouped elements, the first of which contains the
     * first elements of the given arrays, the second of which contains the
     * second elements of the given arrays, and so on.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zip(['a', 'b'], [1, 2], [true, false]);
     * // => [['a', 1, true], ['b', 2, false]]
     */
    var zip = baseRest(unzip);

    /**
     * This method is like `_.fromPairs` except that it accepts two arrays,
     * one of property identifiers and one of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 0.4.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObject(['a', 'b'], [1, 2]);
     * // => { 'a': 1, 'b': 2 }
     */
    function zipObject(props, values) {
      return baseZipObject(props || [], values || [], assignValue);
    }

    /**
     * This method is like `_.zipObject` except that it supports property paths.
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Array
     * @param {Array} [props=[]] The property identifiers.
     * @param {Array} [values=[]] The property values.
     * @returns {Object} Returns the new object.
     * @example
     *
     * _.zipObjectDeep(['a.b[0].c', 'a.b[1].d'], [1, 2]);
     * // => { 'a': { 'b': [{ 'c': 1 }, { 'd': 2 }] } }
     */
    function zipObjectDeep(props, values) {
      return baseZipObject(props || [], values || [], baseSet);
    }

    /**
     * This method is like `_.zip` except that it accepts `iteratee` to specify
     * how grouped values should be combined. The iteratee is invoked with the
     * elements of each group: (...group).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Array
     * @param {...Array} [arrays] The arrays to process.
     * @param {Function} [iteratee=_.identity] The function to combine
     *  grouped values.
     * @returns {Array} Returns the new array of grouped elements.
     * @example
     *
     * _.zipWith([1, 2], [10, 20], [100, 200], function(a, b, c) {
     *   return a + b + c;
     * });
     * // => [111, 222]
     */
    var zipWith = baseRest(function (arrays) {
      var length = arrays.length,
        iteratee = length > 1 ? arrays[length - 1] : undefined;
      iteratee = typeof iteratee == 'function' ? (arrays.pop(), iteratee) : undefined;
      return unzipWith(arrays, iteratee);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Creates a `lodash` wrapper instance that wraps `value` with explicit method
     * chain sequences enabled. The result of such sequences must be unwrapped
     * with `_#value`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Seq
     * @param {*} value The value to wrap.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36 },
     *   { 'user': 'fred',    'age': 40 },
     *   { 'user': 'pebbles', 'age': 1 }
     * ];
     *
     * var youngest = _
     *   .chain(users)
     *   .sortBy('age')
     *   .map(function(o) {
     *     return o.user + ' is ' + o.age;
     *   })
     *   .head()
     *   .value();
     * // => 'pebbles is 1'
     */
    function chain(value) {
      var result = lodash(value);
      result.__chain__ = true;
      return result;
    }

    /**
     * This method invokes `interceptor` and returns `value`. The interceptor
     * is invoked with one argument; (value). The purpose of this method is to
     * "tap into" a method chain sequence in order to modify intermediate results.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns `value`.
     * @example
     *
     * _([1, 2, 3])
     *  .tap(function(array) {
     *    // Mutate input array.
     *    array.pop();
     *  })
     *  .reverse()
     *  .value();
     * // => [2, 1]
     */
    function tap(value, interceptor) {
      interceptor(value);
      return value;
    }

    /**
     * This method is like `_.tap` except that it returns the result of `interceptor`.
     * The purpose of this method is to "pass thru" values replacing intermediate
     * results in a method chain sequence.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Seq
     * @param {*} value The value to provide to `interceptor`.
     * @param {Function} interceptor The function to invoke.
     * @returns {*} Returns the result of `interceptor`.
     * @example
     *
     * _('  abc  ')
     *  .chain()
     *  .trim()
     *  .thru(function(value) {
     *    return [value];
     *  })
     *  .value();
     * // => ['abc']
     */
    function thru(value, interceptor) {
      return interceptor(value);
    }

    /**
     * This method is the wrapper version of `_.at`.
     *
     * @name at
     * @memberOf _
     * @since 1.0.0
     * @category Seq
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _(object).at(['a[0].b.c', 'a[1]']).value();
     * // => [3, 4]
     */
    var wrapperAt = flatRest(function (paths) {
      var length = paths.length,
        start = length ? paths[0] : 0,
        value = this.__wrapped__,
        interceptor = function interceptor(object) {
          return baseAt(object, paths);
        };
      if (length > 1 || this.__actions__.length || !(value instanceof LazyWrapper) || !isIndex(start)) {
        return this.thru(interceptor);
      }
      value = value.slice(start, +start + (length ? 1 : 0));
      value.__actions__.push({
        'func': thru,
        'args': [interceptor],
        'thisArg': undefined
      });
      return new LodashWrapper(value, this.__chain__).thru(function (array) {
        if (length && !array.length) {
          array.push(undefined);
        }
        return array;
      });
    });

    /**
     * Creates a `lodash` wrapper instance with explicit method chain sequences enabled.
     *
     * @name chain
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 40 }
     * ];
     *
     * // A sequence without explicit chaining.
     * _(users).head();
     * // => { 'user': 'barney', 'age': 36 }
     *
     * // A sequence with explicit chaining.
     * _(users)
     *   .chain()
     *   .head()
     *   .pick('user')
     *   .value();
     * // => { 'user': 'barney' }
     */
    function wrapperChain() {
      return chain(this);
    }

    /**
     * Executes the chain sequence and returns the wrapped result.
     *
     * @name commit
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2];
     * var wrapped = _(array).push(3);
     *
     * console.log(array);
     * // => [1, 2]
     *
     * wrapped = wrapped.commit();
     * console.log(array);
     * // => [1, 2, 3]
     *
     * wrapped.last();
     * // => 3
     *
     * console.log(array);
     * // => [1, 2, 3]
     */
    function wrapperCommit() {
      return new LodashWrapper(this.value(), this.__chain__);
    }

    /**
     * Gets the next value on a wrapped object following the
     * [iterator protocol](https://mdn.io/iteration_protocols#iterator).
     *
     * @name next
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the next iterator value.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 1 }
     *
     * wrapped.next();
     * // => { 'done': false, 'value': 2 }
     *
     * wrapped.next();
     * // => { 'done': true, 'value': undefined }
     */
    function wrapperNext() {
      if (this.__values__ === undefined) {
        this.__values__ = toArray(this.value());
      }
      var done = this.__index__ >= this.__values__.length,
        value = done ? undefined : this.__values__[this.__index__++];
      return {
        'done': done,
        'value': value
      };
    }

    /**
     * Enables the wrapper to be iterable.
     *
     * @name Symbol.iterator
     * @memberOf _
     * @since 4.0.0
     * @category Seq
     * @returns {Object} Returns the wrapper object.
     * @example
     *
     * var wrapped = _([1, 2]);
     *
     * wrapped[Symbol.iterator]() === wrapped;
     * // => true
     *
     * Array.from(wrapped);
     * // => [1, 2]
     */
    function wrapperToIterator() {
      return this;
    }

    /**
     * Creates a clone of the chain sequence planting `value` as the wrapped value.
     *
     * @name plant
     * @memberOf _
     * @since 3.2.0
     * @category Seq
     * @param {*} value The value to plant.
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var wrapped = _([1, 2]).map(square);
     * var other = wrapped.plant([3, 4]);
     *
     * other.value();
     * // => [9, 16]
     *
     * wrapped.value();
     * // => [1, 4]
     */
    function wrapperPlant(value) {
      var result,
        parent = this;
      while (parent instanceof baseLodash) {
        var clone = wrapperClone(parent);
        clone.__index__ = 0;
        clone.__values__ = undefined;
        if (result) {
          previous.__wrapped__ = clone;
        } else {
          result = clone;
        }
        var previous = clone;
        parent = parent.__wrapped__;
      }
      previous.__wrapped__ = value;
      return result;
    }

    /**
     * This method is the wrapper version of `_.reverse`.
     *
     * **Note:** This method mutates the wrapped array.
     *
     * @name reverse
     * @memberOf _
     * @since 0.1.0
     * @category Seq
     * @returns {Object} Returns the new `lodash` wrapper instance.
     * @example
     *
     * var array = [1, 2, 3];
     *
     * _(array).reverse().value()
     * // => [3, 2, 1]
     *
     * console.log(array);
     * // => [3, 2, 1]
     */
    function wrapperReverse() {
      var value = this.__wrapped__;
      if (value instanceof LazyWrapper) {
        var wrapped = value;
        if (this.__actions__.length) {
          wrapped = new LazyWrapper(this);
        }
        wrapped = wrapped.reverse();
        wrapped.__actions__.push({
          'func': thru,
          'args': [reverse],
          'thisArg': undefined
        });
        return new LodashWrapper(wrapped, this.__chain__);
      }
      return this.thru(reverse);
    }

    /**
     * Executes the chain sequence to resolve the unwrapped value.
     *
     * @name value
     * @memberOf _
     * @since 0.1.0
     * @alias toJSON, valueOf
     * @category Seq
     * @returns {*} Returns the resolved unwrapped value.
     * @example
     *
     * _([1, 2, 3]).value();
     * // => [1, 2, 3]
     */
    function wrapperValue() {
      return baseWrapperValue(this.__wrapped__, this.__actions__);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the number of times the key was returned by `iteratee`. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.countBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': 1, '6': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.countBy(['one', 'two', 'three'], 'length');
     * // => { '3': 2, '5': 1 }
     */
    var countBy = createAggregator(function (result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        ++result[key];
      } else {
        baseAssignValue(result, key, 1);
      }
    });

    /**
     * Checks if `predicate` returns truthy for **all** elements of `collection`.
     * Iteration is stopped once `predicate` returns falsey. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * **Note:** This method returns `true` for
     * [empty collections](https://en.wikipedia.org/wiki/Empty_set) because
     * [everything is true](https://en.wikipedia.org/wiki/Vacuous_truth) of
     * elements of empty collections.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if all elements pass the predicate check,
     *  else `false`.
     * @example
     *
     * _.every([true, 1, null, 'yes'], Boolean);
     * // => false
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.every(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.every(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.every(users, 'active');
     * // => false
     */
    function every(collection, predicate, guard) {
      var func = isArray(collection) ? arrayEvery : baseEvery;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning an array of all elements
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * **Note:** Unlike `_.remove`, this method returns a new array.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.reject
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * _.filter(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, { 'age': 36, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.filter(users, 'active');
     * // => objects for ['barney']
     *
     * // Combining several predicates using `_.overEvery` or `_.overSome`.
     * _.filter(users, _.overSome([{ 'age': 36 }, ['age', 40]]));
     * // => objects for ['fred', 'barney']
     */
    function filter(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Iterates over elements of `collection`, returning the first element
     * `predicate` returns truthy for. The predicate is invoked with three
     * arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=0] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': true },
     *   { 'user': 'fred',    'age': 40, 'active': false },
     *   { 'user': 'pebbles', 'age': 1,  'active': true }
     * ];
     *
     * _.find(users, function(o) { return o.age < 40; });
     * // => object for 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.find(users, { 'age': 1, 'active': true });
     * // => object for 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.find(users, ['active', false]);
     * // => object for 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.find(users, 'active');
     * // => object for 'barney'
     */
    var find = createFind(findIndex);

    /**
     * This method is like `_.find` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param {number} [fromIndex=collection.length-1] The index to search from.
     * @returns {*} Returns the matched element, else `undefined`.
     * @example
     *
     * _.findLast([1, 2, 3, 4], function(n) {
     *   return n % 2 == 1;
     * });
     * // => 3
     */
    var findLast = createFind(findLastIndex);

    /**
     * Creates a flattened array of values by running each element in `collection`
     * thru `iteratee` and flattening the mapped results. The iteratee is invoked
     * with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [n, n];
     * }
     *
     * _.flatMap([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMap(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), 1);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDeep([1, 2], duplicate);
     * // => [1, 1, 2, 2]
     */
    function flatMapDeep(collection, iteratee) {
      return baseFlatten(map(collection, iteratee), INFINITY);
    }

    /**
     * This method is like `_.flatMap` except that it recursively flattens the
     * mapped results up to `depth` times.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {number} [depth=1] The maximum recursion depth.
     * @returns {Array} Returns the new flattened array.
     * @example
     *
     * function duplicate(n) {
     *   return [[[n, n]]];
     * }
     *
     * _.flatMapDepth([1, 2], duplicate, 2);
     * // => [[1, 1], [2, 2]]
     */
    function flatMapDepth(collection, iteratee, depth) {
      depth = depth === undefined ? 1 : toInteger(depth);
      return baseFlatten(map(collection, iteratee), depth);
    }

    /**
     * Iterates over elements of `collection` and invokes `iteratee` for each element.
     * The iteratee is invoked with three arguments: (value, index|key, collection).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * **Note:** As with other "Collections" methods, objects with a "length"
     * property are iterated like arrays. To avoid this behavior use `_.forIn`
     * or `_.forOwn` for object iteration.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @alias each
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEachRight
     * @example
     *
     * _.forEach([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `1` then `2`.
     *
     * _.forEach({ 'a': 1, 'b': 2 }, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forEach(collection, iteratee) {
      var func = isArray(collection) ? arrayEach : baseEach;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forEach` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @alias eachRight
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array|Object} Returns `collection`.
     * @see _.forEach
     * @example
     *
     * _.forEachRight([1, 2], function(value) {
     *   console.log(value);
     * });
     * // => Logs `2` then `1`.
     */
    function forEachRight(collection, iteratee) {
      var func = isArray(collection) ? arrayEachRight : baseEachRight;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The order of grouped values
     * is determined by the order they occur in `collection`. The corresponding
     * value of each key is an array of elements responsible for generating the
     * key. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * _.groupBy([6.1, 4.2, 6.3], Math.floor);
     * // => { '4': [4.2], '6': [6.1, 6.3] }
     *
     * // The `_.property` iteratee shorthand.
     * _.groupBy(['one', 'two', 'three'], 'length');
     * // => { '3': ['one', 'two'], '5': ['three'] }
     */
    var groupBy = createAggregator(function (result, value, key) {
      if (hasOwnProperty.call(result, key)) {
        result[key].push(value);
      } else {
        baseAssignValue(result, key, [value]);
      }
    });

    /**
     * Checks if `value` is in `collection`. If `collection` is a string, it's
     * checked for a substring of `value`, otherwise
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * is used for equality comparisons. If `fromIndex` is negative, it's used as
     * the offset from the end of `collection`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @param {*} value The value to search for.
     * @param {number} [fromIndex=0] The index to search from.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {boolean} Returns `true` if `value` is found, else `false`.
     * @example
     *
     * _.includes([1, 2, 3], 1);
     * // => true
     *
     * _.includes([1, 2, 3], 1, 2);
     * // => false
     *
     * _.includes({ 'a': 1, 'b': 2 }, 1);
     * // => true
     *
     * _.includes('abcd', 'bc');
     * // => true
     */
    function includes(collection, value, fromIndex, guard) {
      collection = isArrayLike(collection) ? collection : values(collection);
      fromIndex = fromIndex && !guard ? toInteger(fromIndex) : 0;
      var length = collection.length;
      if (fromIndex < 0) {
        fromIndex = nativeMax(length + fromIndex, 0);
      }
      return isString(collection) ? fromIndex <= length && collection.indexOf(value, fromIndex) > -1 : !!length && baseIndexOf(collection, value, fromIndex) > -1;
    }

    /**
     * Invokes the method at `path` of each element in `collection`, returning
     * an array of the results of each invoked method. Any additional arguments
     * are provided to each invoked method. If `path` is a function, it's invoked
     * for, and `this` bound to, each element in `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array|Function|string} path The path of the method to invoke or
     *  the function invoked per iteration.
     * @param {...*} [args] The arguments to invoke each method with.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.invokeMap([[5, 1, 7], [3, 2, 1]], 'sort');
     * // => [[1, 5, 7], [1, 2, 3]]
     *
     * _.invokeMap([123, 456], String.prototype.split, '');
     * // => [['1', '2', '3'], ['4', '5', '6']]
     */
    var invokeMap = baseRest(function (collection, path, args) {
      var index = -1,
        isFunc = typeof path == 'function',
        result = isArrayLike(collection) ? Array(collection.length) : [];
      baseEach(collection, function (value) {
        result[++index] = isFunc ? apply(path, value, args) : baseInvoke(value, path, args);
      });
      return result;
    });

    /**
     * Creates an object composed of keys generated from the results of running
     * each element of `collection` thru `iteratee`. The corresponding value of
     * each key is the last element responsible for generating the key. The
     * iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee to transform keys.
     * @returns {Object} Returns the composed aggregate object.
     * @example
     *
     * var array = [
     *   { 'dir': 'left', 'code': 97 },
     *   { 'dir': 'right', 'code': 100 }
     * ];
     *
     * _.keyBy(array, function(o) {
     *   return String.fromCharCode(o.code);
     * });
     * // => { 'a': { 'dir': 'left', 'code': 97 }, 'd': { 'dir': 'right', 'code': 100 } }
     *
     * _.keyBy(array, 'dir');
     * // => { 'left': { 'dir': 'left', 'code': 97 }, 'right': { 'dir': 'right', 'code': 100 } }
     */
    var keyBy = createAggregator(function (result, value, key) {
      baseAssignValue(result, key, value);
    });

    /**
     * Creates an array of values by running each element in `collection` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.every`, `_.filter`, `_.map`, `_.mapValues`, `_.reject`, and `_.some`.
     *
     * The guarded methods are:
     * `ary`, `chunk`, `curry`, `curryRight`, `drop`, `dropRight`, `every`,
     * `fill`, `invert`, `parseInt`, `random`, `range`, `rangeRight`, `repeat`,
     * `sampleSize`, `slice`, `some`, `sortBy`, `split`, `take`, `takeRight`,
     * `template`, `trim`, `trimEnd`, `trimStart`, and `words`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new mapped array.
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * _.map([4, 8], square);
     * // => [16, 64]
     *
     * _.map({ 'a': 4, 'b': 8 }, square);
     * // => [16, 64] (iteration order is not guaranteed)
     *
     * var users = [
     *   { 'user': 'barney' },
     *   { 'user': 'fred' }
     * ];
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, 'user');
     * // => ['barney', 'fred']
     */
    function map(collection, iteratee) {
      var func = isArray(collection) ? arrayMap : baseMap;
      return func(collection, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.sortBy` except that it allows specifying the sort
     * orders of the iteratees to sort by. If `orders` is unspecified, all values
     * are sorted in ascending order. Otherwise, specify an order of "desc" for
     * descending or "asc" for ascending sort order of corresponding values.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Array[]|Function[]|Object[]|string[]} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @param {string[]} [orders] The sort orders of `iteratees`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.reduce`.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 34 },
     *   { 'user': 'fred',   'age': 40 },
     *   { 'user': 'barney', 'age': 36 }
     * ];
     *
     * // Sort by `user` in ascending order and by `age` in descending order.
     * _.orderBy(users, ['user', 'age'], ['asc', 'desc']);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 40]]
     */
    function orderBy(collection, iteratees, orders, guard) {
      if (collection == null) {
        return [];
      }
      if (!isArray(iteratees)) {
        iteratees = iteratees == null ? [] : [iteratees];
      }
      orders = guard ? undefined : orders;
      if (!isArray(orders)) {
        orders = orders == null ? [] : [orders];
      }
      return baseOrderBy(collection, iteratees, orders);
    }

    /**
     * Creates an array of elements split into two groups, the first of which
     * contains elements `predicate` returns truthy for, the second of which
     * contains elements `predicate` returns falsey for. The predicate is
     * invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of grouped elements.
     * @example
     *
     * var users = [
     *   { 'user': 'barney',  'age': 36, 'active': false },
     *   { 'user': 'fred',    'age': 40, 'active': true },
     *   { 'user': 'pebbles', 'age': 1,  'active': false }
     * ];
     *
     * _.partition(users, function(o) { return o.active; });
     * // => objects for [['fred'], ['barney', 'pebbles']]
     *
     * // The `_.matches` iteratee shorthand.
     * _.partition(users, { 'age': 1, 'active': false });
     * // => objects for [['pebbles'], ['barney', 'fred']]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.partition(users, ['active', false]);
     * // => objects for [['barney', 'pebbles'], ['fred']]
     *
     * // The `_.property` iteratee shorthand.
     * _.partition(users, 'active');
     * // => objects for [['fred'], ['barney', 'pebbles']]
     */
    var partition = createAggregator(function (result, value, key) {
      result[key ? 0 : 1].push(value);
    }, function () {
      return [[], []];
    });

    /**
     * Reduces `collection` to a value which is the accumulated result of running
     * each element in `collection` thru `iteratee`, where each successive
     * invocation is supplied the return value of the previous. If `accumulator`
     * is not given, the first element of `collection` is used as the initial
     * value. The iteratee is invoked with four arguments:
     * (accumulator, value, index|key, collection).
     *
     * Many lodash methods are guarded to work as iteratees for methods like
     * `_.reduce`, `_.reduceRight`, and `_.transform`.
     *
     * The guarded methods are:
     * `assign`, `defaults`, `defaultsDeep`, `includes`, `merge`, `orderBy`,
     * and `sortBy`
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduceRight
     * @example
     *
     * _.reduce([1, 2], function(sum, n) {
     *   return sum + n;
     * }, 0);
     * // => 3
     *
     * _.reduce({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     *   return result;
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] } (iteration order is not guaranteed)
     */
    function reduce(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduce : baseReduce,
        initAccum = arguments.length < 3;
      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEach);
    }

    /**
     * This method is like `_.reduce` except that it iterates over elements of
     * `collection` from right to left.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The initial value.
     * @returns {*} Returns the accumulated value.
     * @see _.reduce
     * @example
     *
     * var array = [[0, 1], [2, 3], [4, 5]];
     *
     * _.reduceRight(array, function(flattened, other) {
     *   return flattened.concat(other);
     * }, []);
     * // => [4, 5, 2, 3, 0, 1]
     */
    function reduceRight(collection, iteratee, accumulator) {
      var func = isArray(collection) ? arrayReduceRight : baseReduce,
        initAccum = arguments.length < 3;
      return func(collection, getIteratee(iteratee, 4), accumulator, initAccum, baseEachRight);
    }

    /**
     * The opposite of `_.filter`; this method returns the elements of `collection`
     * that `predicate` does **not** return truthy for.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the new filtered array.
     * @see _.filter
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': false },
     *   { 'user': 'fred',   'age': 40, 'active': true }
     * ];
     *
     * _.reject(users, function(o) { return !o.active; });
     * // => objects for ['fred']
     *
     * // The `_.matches` iteratee shorthand.
     * _.reject(users, { 'age': 40, 'active': true });
     * // => objects for ['barney']
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.reject(users, ['active', false]);
     * // => objects for ['fred']
     *
     * // The `_.property` iteratee shorthand.
     * _.reject(users, 'active');
     * // => objects for ['barney']
     */
    function reject(collection, predicate) {
      var func = isArray(collection) ? arrayFilter : baseFilter;
      return func(collection, negate(getIteratee(predicate, 3)));
    }

    /**
     * Gets a random element from `collection`.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @returns {*} Returns the random element.
     * @example
     *
     * _.sample([1, 2, 3, 4]);
     * // => 2
     */
    function sample(collection) {
      var func = isArray(collection) ? arraySample : baseSample;
      return func(collection);
    }

    /**
     * Gets `n` random elements at unique keys from `collection` up to the
     * size of `collection`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Collection
     * @param {Array|Object} collection The collection to sample.
     * @param {number} [n=1] The number of elements to sample.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the random elements.
     * @example
     *
     * _.sampleSize([1, 2, 3], 2);
     * // => [3, 1]
     *
     * _.sampleSize([1, 2, 3], 4);
     * // => [2, 3, 1]
     */
    function sampleSize(collection, n, guard) {
      if (guard ? isIterateeCall(collection, n, guard) : n === undefined) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      var func = isArray(collection) ? arraySampleSize : baseSampleSize;
      return func(collection, n);
    }

    /**
     * Creates an array of shuffled values, using a version of the
     * [Fisher-Yates shuffle](https://en.wikipedia.org/wiki/Fisher-Yates_shuffle).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to shuffle.
     * @returns {Array} Returns the new shuffled array.
     * @example
     *
     * _.shuffle([1, 2, 3, 4]);
     * // => [4, 1, 3, 2]
     */
    function shuffle(collection) {
      var func = isArray(collection) ? arrayShuffle : baseShuffle;
      return func(collection);
    }

    /**
     * Gets the size of `collection` by returning its length for array-like
     * values or the number of own enumerable string keyed properties for objects.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object|string} collection The collection to inspect.
     * @returns {number} Returns the collection size.
     * @example
     *
     * _.size([1, 2, 3]);
     * // => 3
     *
     * _.size({ 'a': 1, 'b': 2 });
     * // => 2
     *
     * _.size('pebbles');
     * // => 7
     */
    function size(collection) {
      if (collection == null) {
        return 0;
      }
      if (isArrayLike(collection)) {
        return isString(collection) ? stringSize(collection) : collection.length;
      }
      var tag = getTag(collection);
      if (tag == mapTag || tag == setTag) {
        return collection.size;
      }
      return baseKeys(collection).length;
    }

    /**
     * Checks if `predicate` returns truthy for **any** element of `collection`.
     * Iteration is stopped once `predicate` returns truthy. The predicate is
     * invoked with three arguments: (value, index|key, collection).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {boolean} Returns `true` if any element passes the predicate check,
     *  else `false`.
     * @example
     *
     * _.some([null, 0, 'yes', false], Boolean);
     * // => true
     *
     * var users = [
     *   { 'user': 'barney', 'active': true },
     *   { 'user': 'fred',   'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.some(users, { 'user': 'barney', 'active': false });
     * // => false
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.some(users, ['active', false]);
     * // => true
     *
     * // The `_.property` iteratee shorthand.
     * _.some(users, 'active');
     * // => true
     */
    function some(collection, predicate, guard) {
      var func = isArray(collection) ? arraySome : baseSome;
      if (guard && isIterateeCall(collection, predicate, guard)) {
        predicate = undefined;
      }
      return func(collection, getIteratee(predicate, 3));
    }

    /**
     * Creates an array of elements, sorted in ascending order by the results of
     * running each element in a collection thru each iteratee. This method
     * performs a stable sort, that is, it preserves the original sort order of
     * equal elements. The iteratees are invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Collection
     * @param {Array|Object} collection The collection to iterate over.
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to sort by.
     * @returns {Array} Returns the new sorted array.
     * @example
     *
     * var users = [
     *   { 'user': 'fred',   'age': 48 },
     *   { 'user': 'barney', 'age': 36 },
     *   { 'user': 'fred',   'age': 30 },
     *   { 'user': 'barney', 'age': 34 }
     * ];
     *
     * _.sortBy(users, [function(o) { return o.user; }]);
     * // => objects for [['barney', 36], ['barney', 34], ['fred', 48], ['fred', 30]]
     *
     * _.sortBy(users, ['user', 'age']);
     * // => objects for [['barney', 34], ['barney', 36], ['fred', 30], ['fred', 48]]
     */
    var sortBy = baseRest(function (collection, iteratees) {
      if (collection == null) {
        return [];
      }
      var length = iteratees.length;
      if (length > 1 && isIterateeCall(collection, iteratees[0], iteratees[1])) {
        iteratees = [];
      } else if (length > 2 && isIterateeCall(iteratees[0], iteratees[1], iteratees[2])) {
        iteratees = [iteratees[0]];
      }
      return baseOrderBy(collection, baseFlatten(iteratees, 1), []);
    });

    /*------------------------------------------------------------------------*/

    /**
     * Gets the timestamp of the number of milliseconds that have elapsed since
     * the Unix epoch (1 January 1970 00:00:00 UTC).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Date
     * @returns {number} Returns the timestamp.
     * @example
     *
     * _.defer(function(stamp) {
     *   console.log(_.now() - stamp);
     * }, _.now());
     * // => Logs the number of milliseconds it took for the deferred invocation.
     */
    var now = ctxNow || function () {
      return root.Date.now();
    };

    /*------------------------------------------------------------------------*/

    /**
     * The opposite of `_.before`; this method creates a function that invokes
     * `func` once it's called `n` or more times.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {number} n The number of calls before `func` is invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var saves = ['profile', 'settings'];
     *
     * var done = _.after(saves.length, function() {
     *   console.log('done saving!');
     * });
     *
     * _.forEach(saves, function(type) {
     *   asyncSave({ 'type': type, 'complete': done });
     * });
     * // => Logs 'done saving!' after the two async saves have completed.
     */
    function after(n, func) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function () {
        if (--n < 1) {
          return func.apply(this, arguments);
        }
      };
    }

    /**
     * Creates a function that invokes `func`, with up to `n` arguments,
     * ignoring any additional arguments.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @param {number} [n=func.length] The arity cap.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.ary(parseInt, 1));
     * // => [6, 8, 10]
     */
    function ary(func, n, guard) {
      n = guard ? undefined : n;
      n = func && n == null ? func.length : n;
      return createWrap(func, WRAP_ARY_FLAG, undefined, undefined, undefined, undefined, n);
    }

    /**
     * Creates a function that invokes `func`, with the `this` binding and arguments
     * of the created function, while it's called less than `n` times. Subsequent
     * calls to the created function return the result of the last `func` invocation.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {number} n The number of calls at which `func` is no longer invoked.
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * jQuery(element).on('click', _.before(5, addContactToList));
     * // => Allows adding up to 4 contacts to the list.
     */
    function before(n, func) {
      var result;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      n = toInteger(n);
      return function () {
        if (--n > 0) {
          result = func.apply(this, arguments);
        }
        if (n <= 1) {
          func = undefined;
        }
        return result;
      };
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of `thisArg`
     * and `partials` prepended to the arguments it receives.
     *
     * The `_.bind.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for partially applied arguments.
     *
     * **Note:** Unlike native `Function#bind`, this method doesn't set the "length"
     * property of bound functions.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to bind.
     * @param {*} thisArg The `this` binding of `func`.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * function greet(greeting, punctuation) {
     *   return greeting + ' ' + this.user + punctuation;
     * }
     *
     * var object = { 'user': 'fred' };
     *
     * var bound = _.bind(greet, object, 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bind(greet, object, _, '!');
     * bound('hi');
     * // => 'hi fred!'
     */
    var bind = baseRest(function (func, thisArg, partials) {
      var bitmask = WRAP_BIND_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bind));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(func, bitmask, thisArg, partials, holders);
    });

    /**
     * Creates a function that invokes the method at `object[key]` with `partials`
     * prepended to the arguments it receives.
     *
     * This method differs from `_.bind` by allowing bound functions to reference
     * methods that may be redefined or don't yet exist. See
     * [Peter Michaux's article](http://peter.michaux.ca/articles/lazy-function-definition-pattern)
     * for more details.
     *
     * The `_.bindKey.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Function
     * @param {Object} object The object to invoke the method on.
     * @param {string} key The key of the method.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new bound function.
     * @example
     *
     * var object = {
     *   'user': 'fred',
     *   'greet': function(greeting, punctuation) {
     *     return greeting + ' ' + this.user + punctuation;
     *   }
     * };
     *
     * var bound = _.bindKey(object, 'greet', 'hi');
     * bound('!');
     * // => 'hi fred!'
     *
     * object.greet = function(greeting, punctuation) {
     *   return greeting + 'ya ' + this.user + punctuation;
     * };
     *
     * bound('!');
     * // => 'hiya fred!'
     *
     * // Bound with placeholders.
     * var bound = _.bindKey(object, 'greet', _, '!');
     * bound('hi');
     * // => 'hiya fred!'
     */
    var bindKey = baseRest(function (object, key, partials) {
      var bitmask = WRAP_BIND_FLAG | WRAP_BIND_KEY_FLAG;
      if (partials.length) {
        var holders = replaceHolders(partials, getHolder(bindKey));
        bitmask |= WRAP_PARTIAL_FLAG;
      }
      return createWrap(key, bitmask, object, partials, holders);
    });

    /**
     * Creates a function that accepts arguments of `func` and either invokes
     * `func` returning its result, if at least `arity` number of arguments have
     * been provided, or returns a function that accepts the remaining `func`
     * arguments, and so on. The arity of `func` may be specified if `func.length`
     * is not sufficient.
     *
     * The `_.curry.placeholder` value, which defaults to `_` in monolithic builds,
     * may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curry(abc);
     *
     * curried(1)(2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2)(3);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(1)(_, 3)(2);
     * // => [1, 2, 3]
     */
    function curry(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curry.placeholder;
      return result;
    }

    /**
     * This method is like `_.curry` except that arguments are applied to `func`
     * in the manner of `_.partialRight` instead of `_.partial`.
     *
     * The `_.curryRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for provided arguments.
     *
     * **Note:** This method doesn't set the "length" property of curried functions.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to curry.
     * @param {number} [arity=func.length] The arity of `func`.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the new curried function.
     * @example
     *
     * var abc = function(a, b, c) {
     *   return [a, b, c];
     * };
     *
     * var curried = _.curryRight(abc);
     *
     * curried(3)(2)(1);
     * // => [1, 2, 3]
     *
     * curried(2, 3)(1);
     * // => [1, 2, 3]
     *
     * curried(1, 2, 3);
     * // => [1, 2, 3]
     *
     * // Curried with placeholders.
     * curried(3)(1, _)(2);
     * // => [1, 2, 3]
     */
    function curryRight(func, arity, guard) {
      arity = guard ? undefined : arity;
      var result = createWrap(func, WRAP_CURRY_RIGHT_FLAG, undefined, undefined, undefined, undefined, undefined, arity);
      result.placeholder = curryRight.placeholder;
      return result;
    }

    /**
     * Creates a debounced function that delays invoking `func` until after `wait`
     * milliseconds have elapsed since the last time the debounced function was
     * invoked. The debounced function comes with a `cancel` method to cancel
     * delayed `func` invocations and a `flush` method to immediately invoke them.
     * Provide `options` to indicate whether `func` should be invoked on the
     * leading and/or trailing edge of the `wait` timeout. The `func` is invoked
     * with the last arguments provided to the debounced function. Subsequent
     * calls to the debounced function return the result of the last `func`
     * invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the debounced function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.debounce` and `_.throttle`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to debounce.
     * @param {number} [wait=0] The number of milliseconds to delay.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=false]
     *  Specify invoking on the leading edge of the timeout.
     * @param {number} [options.maxWait]
     *  The maximum time `func` is allowed to be delayed before it's invoked.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new debounced function.
     * @example
     *
     * // Avoid costly calculations while the window size is in flux.
     * jQuery(window).on('resize', _.debounce(calculateLayout, 150));
     *
     * // Invoke `sendMail` when clicked, debouncing subsequent calls.
     * jQuery(element).on('click', _.debounce(sendMail, 300, {
     *   'leading': true,
     *   'trailing': false
     * }));
     *
     * // Ensure `batchLog` is invoked once after 1 second of debounced calls.
     * var debounced = _.debounce(batchLog, 250, { 'maxWait': 1000 });
     * var source = new EventSource('/stream');
     * jQuery(source).on('message', debounced);
     *
     * // Cancel the trailing debounced invocation.
     * jQuery(window).on('popstate', debounced.cancel);
     */
    function debounce(func, wait, options) {
      var lastArgs,
        lastThis,
        maxWait,
        result,
        timerId,
        lastCallTime,
        lastInvokeTime = 0,
        leading = false,
        maxing = false,
        trailing = true;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      wait = toNumber(wait) || 0;
      if (isObject(options)) {
        leading = !!options.leading;
        maxing = 'maxWait' in options;
        maxWait = maxing ? nativeMax(toNumber(options.maxWait) || 0, wait) : maxWait;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      function invokeFunc(time) {
        var args = lastArgs,
          thisArg = lastThis;
        lastArgs = lastThis = undefined;
        lastInvokeTime = time;
        result = func.apply(thisArg, args);
        return result;
      }
      function leadingEdge(time) {
        // Reset any `maxWait` timer.
        lastInvokeTime = time;
        // Start the timer for the trailing edge.
        timerId = setTimeout(timerExpired, wait);
        // Invoke the leading edge.
        return leading ? invokeFunc(time) : result;
      }
      function remainingWait(time) {
        var timeSinceLastCall = time - lastCallTime,
          timeSinceLastInvoke = time - lastInvokeTime,
          timeWaiting = wait - timeSinceLastCall;
        return maxing ? nativeMin(timeWaiting, maxWait - timeSinceLastInvoke) : timeWaiting;
      }
      function shouldInvoke(time) {
        var timeSinceLastCall = time - lastCallTime,
          timeSinceLastInvoke = time - lastInvokeTime;

        // Either this is the first call, activity has stopped and we're at the
        // trailing edge, the system time has gone backwards and we're treating
        // it as the trailing edge, or we've hit the `maxWait` limit.
        return lastCallTime === undefined || timeSinceLastCall >= wait || timeSinceLastCall < 0 || maxing && timeSinceLastInvoke >= maxWait;
      }
      function timerExpired() {
        var time = now();
        if (shouldInvoke(time)) {
          return trailingEdge(time);
        }
        // Restart the timer.
        timerId = setTimeout(timerExpired, remainingWait(time));
      }
      function trailingEdge(time) {
        timerId = undefined;

        // Only invoke if we have `lastArgs` which means `func` has been
        // debounced at least once.
        if (trailing && lastArgs) {
          return invokeFunc(time);
        }
        lastArgs = lastThis = undefined;
        return result;
      }
      function cancel() {
        if (timerId !== undefined) {
          clearTimeout(timerId);
        }
        lastInvokeTime = 0;
        lastArgs = lastCallTime = lastThis = timerId = undefined;
      }
      function flush() {
        return timerId === undefined ? result : trailingEdge(now());
      }
      function debounced() {
        var time = now(),
          isInvoking = shouldInvoke(time);
        lastArgs = arguments;
        lastThis = this;
        lastCallTime = time;
        if (isInvoking) {
          if (timerId === undefined) {
            return leadingEdge(lastCallTime);
          }
          if (maxing) {
            // Handle invocations in a tight loop.
            clearTimeout(timerId);
            timerId = setTimeout(timerExpired, wait);
            return invokeFunc(lastCallTime);
          }
        }
        if (timerId === undefined) {
          timerId = setTimeout(timerExpired, wait);
        }
        return result;
      }
      debounced.cancel = cancel;
      debounced.flush = flush;
      return debounced;
    }

    /**
     * Defers invoking the `func` until the current call stack has cleared. Any
     * additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to defer.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.defer(function(text) {
     *   console.log(text);
     * }, 'deferred');
     * // => Logs 'deferred' after one millisecond.
     */
    var defer = baseRest(function (func, args) {
      return baseDelay(func, 1, args);
    });

    /**
     * Invokes `func` after `wait` milliseconds. Any additional arguments are
     * provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to delay.
     * @param {number} wait The number of milliseconds to delay invocation.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {number} Returns the timer id.
     * @example
     *
     * _.delay(function(text) {
     *   console.log(text);
     * }, 1000, 'later');
     * // => Logs 'later' after one second.
     */
    var delay = baseRest(function (func, wait, args) {
      return baseDelay(func, toNumber(wait) || 0, args);
    });

    /**
     * Creates a function that invokes `func` with arguments reversed.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to flip arguments for.
     * @returns {Function} Returns the new flipped function.
     * @example
     *
     * var flipped = _.flip(function() {
     *   return _.toArray(arguments);
     * });
     *
     * flipped('a', 'b', 'c', 'd');
     * // => ['d', 'c', 'b', 'a']
     */
    function flip(func) {
      return createWrap(func, WRAP_FLIP_FLAG);
    }

    /**
     * Creates a function that memoizes the result of `func`. If `resolver` is
     * provided, it determines the cache key for storing the result based on the
     * arguments provided to the memoized function. By default, the first argument
     * provided to the memoized function is used as the map cache key. The `func`
     * is invoked with the `this` binding of the memoized function.
     *
     * **Note:** The cache is exposed as the `cache` property on the memoized
     * function. Its creation may be customized by replacing the `_.memoize.Cache`
     * constructor with one whose instances implement the
     * [`Map`](http://ecma-international.org/ecma-262/7.0/#sec-properties-of-the-map-prototype-object)
     * method interface of `clear`, `delete`, `get`, `has`, and `set`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to have its output memoized.
     * @param {Function} [resolver] The function to resolve the cache key.
     * @returns {Function} Returns the new memoized function.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     * var other = { 'c': 3, 'd': 4 };
     *
     * var values = _.memoize(_.values);
     * values(object);
     * // => [1, 2]
     *
     * values(other);
     * // => [3, 4]
     *
     * object.a = 2;
     * values(object);
     * // => [1, 2]
     *
     * // Modify the result cache.
     * values.cache.set(object, ['a', 'b']);
     * values(object);
     * // => ['a', 'b']
     *
     * // Replace `_.memoize.Cache`.
     * _.memoize.Cache = WeakMap;
     */
    function memoize(func, resolver) {
      if (typeof func != 'function' || resolver != null && typeof resolver != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      var _memoized = function memoized() {
        var args = arguments,
          key = resolver ? resolver.apply(this, args) : args[0],
          cache = _memoized.cache;
        if (cache.has(key)) {
          return cache.get(key);
        }
        var result = func.apply(this, args);
        _memoized.cache = cache.set(key, result) || cache;
        return result;
      };
      _memoized.cache = new (memoize.Cache || MapCache)();
      return _memoized;
    }

    // Expose `MapCache`.
    memoize.Cache = MapCache;

    /**
     * Creates a function that negates the result of the predicate `func`. The
     * `func` predicate is invoked with the `this` binding and arguments of the
     * created function.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} predicate The predicate to negate.
     * @returns {Function} Returns the new negated function.
     * @example
     *
     * function isEven(n) {
     *   return n % 2 == 0;
     * }
     *
     * _.filter([1, 2, 3, 4, 5, 6], _.negate(isEven));
     * // => [1, 3, 5]
     */
    function negate(predicate) {
      if (typeof predicate != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      return function () {
        var args = arguments;
        switch (args.length) {
          case 0:
            return !predicate.call(this);
          case 1:
            return !predicate.call(this, args[0]);
          case 2:
            return !predicate.call(this, args[0], args[1]);
          case 3:
            return !predicate.call(this, args[0], args[1], args[2]);
        }
        return !predicate.apply(this, args);
      };
    }

    /**
     * Creates a function that is restricted to invoking `func` once. Repeat calls
     * to the function return the value of the first invocation. The `func` is
     * invoked with the `this` binding and arguments of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to restrict.
     * @returns {Function} Returns the new restricted function.
     * @example
     *
     * var initialize = _.once(createApplication);
     * initialize();
     * initialize();
     * // => `createApplication` is invoked once
     */
    function once(func) {
      return before(2, func);
    }

    /**
     * Creates a function that invokes `func` with its arguments transformed.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Function
     * @param {Function} func The function to wrap.
     * @param {...(Function|Function[])} [transforms=[_.identity]]
     *  The argument transforms.
     * @returns {Function} Returns the new function.
     * @example
     *
     * function doubled(n) {
     *   return n * 2;
     * }
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var func = _.overArgs(function(x, y) {
     *   return [x, y];
     * }, [square, doubled]);
     *
     * func(9, 3);
     * // => [81, 6]
     *
     * func(10, 5);
     * // => [100, 10]
     */
    var overArgs = castRest(function (func, transforms) {
      transforms = transforms.length == 1 && isArray(transforms[0]) ? arrayMap(transforms[0], baseUnary(getIteratee())) : arrayMap(baseFlatten(transforms, 1), baseUnary(getIteratee()));
      var funcsLength = transforms.length;
      return baseRest(function (args) {
        var index = -1,
          length = nativeMin(args.length, funcsLength);
        while (++index < length) {
          args[index] = transforms[index].call(this, args[index]);
        }
        return apply(func, this, args);
      });
    });

    /**
     * Creates a function that invokes `func` with `partials` prepended to the
     * arguments it receives. This method is like `_.bind` except it does **not**
     * alter the `this` binding.
     *
     * The `_.partial.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 0.2.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var sayHelloTo = _.partial(greet, 'hello');
     * sayHelloTo('fred');
     * // => 'hello fred'
     *
     * // Partially applied with placeholders.
     * var greetFred = _.partial(greet, _, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     */
    var partial = baseRest(function (func, partials) {
      var holders = replaceHolders(partials, getHolder(partial));
      return createWrap(func, WRAP_PARTIAL_FLAG, undefined, partials, holders);
    });

    /**
     * This method is like `_.partial` except that partially applied arguments
     * are appended to the arguments it receives.
     *
     * The `_.partialRight.placeholder` value, which defaults to `_` in monolithic
     * builds, may be used as a placeholder for partially applied arguments.
     *
     * **Note:** This method doesn't set the "length" property of partially
     * applied functions.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Function
     * @param {Function} func The function to partially apply arguments to.
     * @param {...*} [partials] The arguments to be partially applied.
     * @returns {Function} Returns the new partially applied function.
     * @example
     *
     * function greet(greeting, name) {
     *   return greeting + ' ' + name;
     * }
     *
     * var greetFred = _.partialRight(greet, 'fred');
     * greetFred('hi');
     * // => 'hi fred'
     *
     * // Partially applied with placeholders.
     * var sayHelloTo = _.partialRight(greet, 'hello', _);
     * sayHelloTo('fred');
     * // => 'hello fred'
     */
    var partialRight = baseRest(function (func, partials) {
      var holders = replaceHolders(partials, getHolder(partialRight));
      return createWrap(func, WRAP_PARTIAL_RIGHT_FLAG, undefined, partials, holders);
    });

    /**
     * Creates a function that invokes `func` with arguments arranged according
     * to the specified `indexes` where the argument value at the first index is
     * provided as the first argument, the argument value at the second index is
     * provided as the second argument, and so on.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Function
     * @param {Function} func The function to rearrange arguments for.
     * @param {...(number|number[])} indexes The arranged argument indexes.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var rearged = _.rearg(function(a, b, c) {
     *   return [a, b, c];
     * }, [2, 0, 1]);
     *
     * rearged('b', 'c', 'a')
     * // => ['a', 'b', 'c']
     */
    var rearg = flatRest(function (func, indexes) {
      return createWrap(func, WRAP_REARG_FLAG, undefined, undefined, undefined, indexes);
    });

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * created function and arguments from `start` and beyond provided as
     * an array.
     *
     * **Note:** This method is based on the
     * [rest parameter](https://mdn.io/rest_parameters).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to apply a rest parameter to.
     * @param {number} [start=func.length-1] The start position of the rest parameter.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.rest(function(what, names) {
     *   return what + ' ' + _.initial(names).join(', ') +
     *     (_.size(names) > 1 ? ', & ' : '') + _.last(names);
     * });
     *
     * say('hello', 'fred', 'barney', 'pebbles');
     * // => 'hello fred, barney, & pebbles'
     */
    function rest(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start === undefined ? start : toInteger(start);
      return baseRest(func, start);
    }

    /**
     * Creates a function that invokes `func` with the `this` binding of the
     * create function and an array of arguments much like
     * [`Function#apply`](http://www.ecma-international.org/ecma-262/7.0/#sec-function.prototype.apply).
     *
     * **Note:** This method is based on the
     * [spread operator](https://mdn.io/spread_operator).
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Function
     * @param {Function} func The function to spread arguments over.
     * @param {number} [start=0] The start position of the spread.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var say = _.spread(function(who, what) {
     *   return who + ' says ' + what;
     * });
     *
     * say(['fred', 'hello']);
     * // => 'fred says hello'
     *
     * var numbers = Promise.all([
     *   Promise.resolve(40),
     *   Promise.resolve(36)
     * ]);
     *
     * numbers.then(_.spread(function(x, y) {
     *   return x + y;
     * }));
     * // => a Promise of 76
     */
    function spread(func, start) {
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      start = start == null ? 0 : nativeMax(toInteger(start), 0);
      return baseRest(function (args) {
        var array = args[start],
          otherArgs = castSlice(args, 0, start);
        if (array) {
          arrayPush(otherArgs, array);
        }
        return apply(func, this, otherArgs);
      });
    }

    /**
     * Creates a throttled function that only invokes `func` at most once per
     * every `wait` milliseconds. The throttled function comes with a `cancel`
     * method to cancel delayed `func` invocations and a `flush` method to
     * immediately invoke them. Provide `options` to indicate whether `func`
     * should be invoked on the leading and/or trailing edge of the `wait`
     * timeout. The `func` is invoked with the last arguments provided to the
     * throttled function. Subsequent calls to the throttled function return the
     * result of the last `func` invocation.
     *
     * **Note:** If `leading` and `trailing` options are `true`, `func` is
     * invoked on the trailing edge of the timeout only if the throttled function
     * is invoked more than once during the `wait` timeout.
     *
     * If `wait` is `0` and `leading` is `false`, `func` invocation is deferred
     * until to the next tick, similar to `setTimeout` with a timeout of `0`.
     *
     * See [David Corbacho's article](https://css-tricks.com/debouncing-throttling-explained-examples/)
     * for details over the differences between `_.throttle` and `_.debounce`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {Function} func The function to throttle.
     * @param {number} [wait=0] The number of milliseconds to throttle invocations to.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.leading=true]
     *  Specify invoking on the leading edge of the timeout.
     * @param {boolean} [options.trailing=true]
     *  Specify invoking on the trailing edge of the timeout.
     * @returns {Function} Returns the new throttled function.
     * @example
     *
     * // Avoid excessively updating the position while scrolling.
     * jQuery(window).on('scroll', _.throttle(updatePosition, 100));
     *
     * // Invoke `renewToken` when the click event is fired, but not more than once every 5 minutes.
     * var throttled = _.throttle(renewToken, 300000, { 'trailing': false });
     * jQuery(element).on('click', throttled);
     *
     * // Cancel the trailing throttled invocation.
     * jQuery(window).on('popstate', throttled.cancel);
     */
    function throttle(func, wait, options) {
      var leading = true,
        trailing = true;
      if (typeof func != 'function') {
        throw new TypeError(FUNC_ERROR_TEXT);
      }
      if (isObject(options)) {
        leading = 'leading' in options ? !!options.leading : leading;
        trailing = 'trailing' in options ? !!options.trailing : trailing;
      }
      return debounce(func, wait, {
        'leading': leading,
        'maxWait': wait,
        'trailing': trailing
      });
    }

    /**
     * Creates a function that accepts up to one argument, ignoring any
     * additional arguments.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Function
     * @param {Function} func The function to cap arguments for.
     * @returns {Function} Returns the new capped function.
     * @example
     *
     * _.map(['6', '8', '10'], _.unary(parseInt));
     * // => [6, 8, 10]
     */
    function unary(func) {
      return ary(func, 1);
    }

    /**
     * Creates a function that provides `value` to `wrapper` as its first
     * argument. Any additional arguments provided to the function are appended
     * to those provided to the `wrapper`. The wrapper is invoked with the `this`
     * binding of the created function.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Function
     * @param {*} value The value to wrap.
     * @param {Function} [wrapper=identity] The wrapper function.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var p = _.wrap(_.escape, function(func, text) {
     *   return '<p>' + func(text) + '</p>';
     * });
     *
     * p('fred, barney, & pebbles');
     * // => '<p>fred, barney, &amp; pebbles</p>'
     */
    function wrap(value, wrapper) {
      return partial(castFunction(wrapper), value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Casts `value` as an array if it's not one.
     *
     * @static
     * @memberOf _
     * @since 4.4.0
     * @category Lang
     * @param {*} value The value to inspect.
     * @returns {Array} Returns the cast array.
     * @example
     *
     * _.castArray(1);
     * // => [1]
     *
     * _.castArray({ 'a': 1 });
     * // => [{ 'a': 1 }]
     *
     * _.castArray('abc');
     * // => ['abc']
     *
     * _.castArray(null);
     * // => [null]
     *
     * _.castArray(undefined);
     * // => [undefined]
     *
     * _.castArray();
     * // => []
     *
     * var array = [1, 2, 3];
     * console.log(_.castArray(array) === array);
     * // => true
     */
    function castArray() {
      if (!arguments.length) {
        return [];
      }
      var value = arguments[0];
      return isArray(value) ? value : [value];
    }

    /**
     * Creates a shallow clone of `value`.
     *
     * **Note:** This method is loosely based on the
     * [structured clone algorithm](https://mdn.io/Structured_clone_algorithm)
     * and supports cloning arrays, array buffers, booleans, date objects, maps,
     * numbers, `Object` objects, regexes, sets, strings, symbols, and typed
     * arrays. The own enumerable properties of `arguments` objects are cloned
     * as plain objects. An empty object is returned for uncloneable values such
     * as error objects, functions, DOM nodes, and WeakMaps.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to clone.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeep
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var shallow = _.clone(objects);
     * console.log(shallow[0] === objects[0]);
     * // => true
     */
    function clone(value) {
      return baseClone(value, CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.clone` except that it accepts `customizer` which
     * is invoked to produce the cloned value. If `customizer` returns `undefined`,
     * cloning is handled by the method instead. The `customizer` is invoked with
     * up to four arguments; (value [, index|key, object, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the cloned value.
     * @see _.cloneDeepWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(false);
     *   }
     * }
     *
     * var el = _.cloneWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 0
     */
    function cloneWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * This method is like `_.clone` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @returns {*} Returns the deep cloned value.
     * @see _.clone
     * @example
     *
     * var objects = [{ 'a': 1 }, { 'b': 2 }];
     *
     * var deep = _.cloneDeep(objects);
     * console.log(deep[0] === objects[0]);
     * // => false
     */
    function cloneDeep(value) {
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG);
    }

    /**
     * This method is like `_.cloneWith` except that it recursively clones `value`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to recursively clone.
     * @param {Function} [customizer] The function to customize cloning.
     * @returns {*} Returns the deep cloned value.
     * @see _.cloneWith
     * @example
     *
     * function customizer(value) {
     *   if (_.isElement(value)) {
     *     return value.cloneNode(true);
     *   }
     * }
     *
     * var el = _.cloneDeepWith(document.body, customizer);
     *
     * console.log(el === document.body);
     * // => false
     * console.log(el.nodeName);
     * // => 'BODY'
     * console.log(el.childNodes.length);
     * // => 20
     */
    function cloneDeepWith(value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseClone(value, CLONE_DEEP_FLAG | CLONE_SYMBOLS_FLAG, customizer);
    }

    /**
     * Checks if `object` conforms to `source` by invoking the predicate
     * properties of `source` with the corresponding property values of `object`.
     *
     * **Note:** This method is equivalent to `_.conforms` when `source` is
     * partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property predicates to conform to.
     * @returns {boolean} Returns `true` if `object` conforms, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 1; } });
     * // => true
     *
     * _.conformsTo(object, { 'b': function(n) { return n > 2; } });
     * // => false
     */
    function conformsTo(object, source) {
      return source == null || baseConformsTo(object, source, keys(source));
    }

    /**
     * Performs a
     * [`SameValueZero`](http://ecma-international.org/ecma-262/7.0/#sec-samevaluezero)
     * comparison between two values to determine if they are equivalent.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.eq(object, object);
     * // => true
     *
     * _.eq(object, other);
     * // => false
     *
     * _.eq('a', 'a');
     * // => true
     *
     * _.eq('a', Object('a'));
     * // => false
     *
     * _.eq(NaN, NaN);
     * // => true
     */
    function eq(value, other) {
      return value === other || value !== value && other !== other;
    }

    /**
     * Checks if `value` is greater than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than `other`,
     *  else `false`.
     * @see _.lt
     * @example
     *
     * _.gt(3, 1);
     * // => true
     *
     * _.gt(3, 3);
     * // => false
     *
     * _.gt(1, 3);
     * // => false
     */
    var gt = createRelationalOperation(baseGt);

    /**
     * Checks if `value` is greater than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is greater than or equal to
     *  `other`, else `false`.
     * @see _.lte
     * @example
     *
     * _.gte(3, 1);
     * // => true
     *
     * _.gte(3, 3);
     * // => true
     *
     * _.gte(1, 3);
     * // => false
     */
    var gte = createRelationalOperation(function (value, other) {
      return value >= other;
    });

    /**
     * Checks if `value` is likely an `arguments` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an `arguments` object,
     *  else `false`.
     * @example
     *
     * _.isArguments(function() { return arguments; }());
     * // => true
     *
     * _.isArguments([1, 2, 3]);
     * // => false
     */
    var isArguments = baseIsArguments(function () {
      return arguments;
    }()) ? baseIsArguments : function (value) {
      return isObjectLike(value) && hasOwnProperty.call(value, 'callee') && !propertyIsEnumerable.call(value, 'callee');
    };

    /**
     * Checks if `value` is classified as an `Array` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array, else `false`.
     * @example
     *
     * _.isArray([1, 2, 3]);
     * // => true
     *
     * _.isArray(document.body.children);
     * // => false
     *
     * _.isArray('abc');
     * // => false
     *
     * _.isArray(_.noop);
     * // => false
     */
    var isArray = Array.isArray;

    /**
     * Checks if `value` is classified as an `ArrayBuffer` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array buffer, else `false`.
     * @example
     *
     * _.isArrayBuffer(new ArrayBuffer(2));
     * // => true
     *
     * _.isArrayBuffer(new Array(2));
     * // => false
     */
    var isArrayBuffer = nodeIsArrayBuffer ? baseUnary(nodeIsArrayBuffer) : baseIsArrayBuffer;

    /**
     * Checks if `value` is array-like. A value is considered array-like if it's
     * not a function and has a `value.length` that's an integer greater than or
     * equal to `0` and less than or equal to `Number.MAX_SAFE_INTEGER`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is array-like, else `false`.
     * @example
     *
     * _.isArrayLike([1, 2, 3]);
     * // => true
     *
     * _.isArrayLike(document.body.children);
     * // => true
     *
     * _.isArrayLike('abc');
     * // => true
     *
     * _.isArrayLike(_.noop);
     * // => false
     */
    function isArrayLike(value) {
      return value != null && isLength(value.length) && !isFunction(value);
    }

    /**
     * This method is like `_.isArrayLike` except that it also checks if `value`
     * is an object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an array-like object,
     *  else `false`.
     * @example
     *
     * _.isArrayLikeObject([1, 2, 3]);
     * // => true
     *
     * _.isArrayLikeObject(document.body.children);
     * // => true
     *
     * _.isArrayLikeObject('abc');
     * // => false
     *
     * _.isArrayLikeObject(_.noop);
     * // => false
     */
    function isArrayLikeObject(value) {
      return isObjectLike(value) && isArrayLike(value);
    }

    /**
     * Checks if `value` is classified as a boolean primitive or object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a boolean, else `false`.
     * @example
     *
     * _.isBoolean(false);
     * // => true
     *
     * _.isBoolean(null);
     * // => false
     */
    function isBoolean(value) {
      return value === true || value === false || isObjectLike(value) && baseGetTag(value) == boolTag;
    }

    /**
     * Checks if `value` is a buffer.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a buffer, else `false`.
     * @example
     *
     * _.isBuffer(new Buffer(2));
     * // => true
     *
     * _.isBuffer(new Uint8Array(2));
     * // => false
     */
    var isBuffer = nativeIsBuffer || stubFalse;

    /**
     * Checks if `value` is classified as a `Date` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a date object, else `false`.
     * @example
     *
     * _.isDate(new Date);
     * // => true
     *
     * _.isDate('Mon April 23 2012');
     * // => false
     */
    var isDate = nodeIsDate ? baseUnary(nodeIsDate) : baseIsDate;

    /**
     * Checks if `value` is likely a DOM element.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a DOM element, else `false`.
     * @example
     *
     * _.isElement(document.body);
     * // => true
     *
     * _.isElement('<body>');
     * // => false
     */
    function isElement(value) {
      return isObjectLike(value) && value.nodeType === 1 && !isPlainObject(value);
    }

    /**
     * Checks if `value` is an empty object, collection, map, or set.
     *
     * Objects are considered empty if they have no own enumerable string keyed
     * properties.
     *
     * Array-like values such as `arguments` objects, arrays, buffers, strings, or
     * jQuery-like collections are considered empty if they have a `length` of `0`.
     * Similarly, maps and sets are considered empty if they have a `size` of `0`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is empty, else `false`.
     * @example
     *
     * _.isEmpty(null);
     * // => true
     *
     * _.isEmpty(true);
     * // => true
     *
     * _.isEmpty(1);
     * // => true
     *
     * _.isEmpty([1, 2, 3]);
     * // => false
     *
     * _.isEmpty({ 'a': 1 });
     * // => false
     */
    function isEmpty(value) {
      if (value == null) {
        return true;
      }
      if (isArrayLike(value) && (isArray(value) || typeof value == 'string' || typeof value.splice == 'function' || isBuffer(value) || isTypedArray(value) || isArguments(value))) {
        return !value.length;
      }
      var tag = getTag(value);
      if (tag == mapTag || tag == setTag) {
        return !value.size;
      }
      if (isPrototype(value)) {
        return !baseKeys(value).length;
      }
      for (var key in value) {
        if (hasOwnProperty.call(value, key)) {
          return false;
        }
      }
      return true;
    }

    /**
     * Performs a deep comparison between two values to determine if they are
     * equivalent.
     *
     * **Note:** This method supports comparing arrays, array buffers, booleans,
     * date objects, error objects, maps, numbers, `Object` objects, regexes,
     * sets, strings, symbols, and typed arrays. `Object` objects are compared
     * by their own, not inherited, enumerable properties. Functions and DOM
     * nodes are compared by strict equality, i.e. `===`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * var object = { 'a': 1 };
     * var other = { 'a': 1 };
     *
     * _.isEqual(object, other);
     * // => true
     *
     * object === other;
     * // => false
     */
    function isEqual(value, other) {
      return baseIsEqual(value, other);
    }

    /**
     * This method is like `_.isEqual` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with up to
     * six arguments: (objValue, othValue [, index|key, object, other, stack]).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if the values are equivalent, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, othValue) {
     *   if (isGreeting(objValue) && isGreeting(othValue)) {
     *     return true;
     *   }
     * }
     *
     * var array = ['hello', 'goodbye'];
     * var other = ['hi', 'goodbye'];
     *
     * _.isEqualWith(array, other, customizer);
     * // => true
     */
    function isEqualWith(value, other, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      var result = customizer ? customizer(value, other) : undefined;
      return result === undefined ? baseIsEqual(value, other, undefined, customizer) : !!result;
    }

    /**
     * Checks if `value` is an `Error`, `EvalError`, `RangeError`, `ReferenceError`,
     * `SyntaxError`, `TypeError`, or `URIError` object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an error object, else `false`.
     * @example
     *
     * _.isError(new Error);
     * // => true
     *
     * _.isError(Error);
     * // => false
     */
    function isError(value) {
      if (!isObjectLike(value)) {
        return false;
      }
      var tag = baseGetTag(value);
      return tag == errorTag || tag == domExcTag || typeof value.message == 'string' && typeof value.name == 'string' && !isPlainObject(value);
    }

    /**
     * Checks if `value` is a finite primitive number.
     *
     * **Note:** This method is based on
     * [`Number.isFinite`](https://mdn.io/Number/isFinite).
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a finite number, else `false`.
     * @example
     *
     * _.isFinite(3);
     * // => true
     *
     * _.isFinite(Number.MIN_VALUE);
     * // => true
     *
     * _.isFinite(Infinity);
     * // => false
     *
     * _.isFinite('3');
     * // => false
     */
    function isFinite(value) {
      return typeof value == 'number' && nativeIsFinite(value);
    }

    /**
     * Checks if `value` is classified as a `Function` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a function, else `false`.
     * @example
     *
     * _.isFunction(_);
     * // => true
     *
     * _.isFunction(/abc/);
     * // => false
     */
    function isFunction(value) {
      if (!isObject(value)) {
        return false;
      }
      // The use of `Object#toString` avoids issues with the `typeof` operator
      // in Safari 9 which returns 'object' for typed arrays and other constructors.
      var tag = baseGetTag(value);
      return tag == funcTag || tag == genTag || tag == asyncTag || tag == proxyTag;
    }

    /**
     * Checks if `value` is an integer.
     *
     * **Note:** This method is based on
     * [`Number.isInteger`](https://mdn.io/Number/isInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an integer, else `false`.
     * @example
     *
     * _.isInteger(3);
     * // => true
     *
     * _.isInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isInteger(Infinity);
     * // => false
     *
     * _.isInteger('3');
     * // => false
     */
    function isInteger(value) {
      return typeof value == 'number' && value == toInteger(value);
    }

    /**
     * Checks if `value` is a valid array-like length.
     *
     * **Note:** This method is loosely based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a valid length, else `false`.
     * @example
     *
     * _.isLength(3);
     * // => true
     *
     * _.isLength(Number.MIN_VALUE);
     * // => false
     *
     * _.isLength(Infinity);
     * // => false
     *
     * _.isLength('3');
     * // => false
     */
    function isLength(value) {
      return typeof value == 'number' && value > -1 && value % 1 == 0 && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is the
     * [language type](http://www.ecma-international.org/ecma-262/7.0/#sec-ecmascript-language-types)
     * of `Object`. (e.g. arrays, functions, objects, regexes, `new Number(0)`, and `new String('')`)
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is an object, else `false`.
     * @example
     *
     * _.isObject({});
     * // => true
     *
     * _.isObject([1, 2, 3]);
     * // => true
     *
     * _.isObject(_.noop);
     * // => true
     *
     * _.isObject(null);
     * // => false
     */
    function isObject(value) {
      var type = _typeof(value);
      return value != null && (type == 'object' || type == 'function');
    }

    /**
     * Checks if `value` is object-like. A value is object-like if it's not `null`
     * and has a `typeof` result of "object".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is object-like, else `false`.
     * @example
     *
     * _.isObjectLike({});
     * // => true
     *
     * _.isObjectLike([1, 2, 3]);
     * // => true
     *
     * _.isObjectLike(_.noop);
     * // => false
     *
     * _.isObjectLike(null);
     * // => false
     */
    function isObjectLike(value) {
      return value != null && _typeof(value) == 'object';
    }

    /**
     * Checks if `value` is classified as a `Map` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a map, else `false`.
     * @example
     *
     * _.isMap(new Map);
     * // => true
     *
     * _.isMap(new WeakMap);
     * // => false
     */
    var isMap = nodeIsMap ? baseUnary(nodeIsMap) : baseIsMap;

    /**
     * Performs a partial deep comparison between `object` and `source` to
     * determine if `object` contains equivalent property values.
     *
     * **Note:** This method is equivalent to `_.matches` when `source` is
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * var object = { 'a': 1, 'b': 2 };
     *
     * _.isMatch(object, { 'b': 2 });
     * // => true
     *
     * _.isMatch(object, { 'b': 1 });
     * // => false
     */
    function isMatch(object, source) {
      return object === source || baseIsMatch(object, source, getMatchData(source));
    }

    /**
     * This method is like `_.isMatch` except that it accepts `customizer` which
     * is invoked to compare values. If `customizer` returns `undefined`, comparisons
     * are handled by the method instead. The `customizer` is invoked with five
     * arguments: (objValue, srcValue, index|key, object, source).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {Object} object The object to inspect.
     * @param {Object} source The object of property values to match.
     * @param {Function} [customizer] The function to customize comparisons.
     * @returns {boolean} Returns `true` if `object` is a match, else `false`.
     * @example
     *
     * function isGreeting(value) {
     *   return /^h(?:i|ello)$/.test(value);
     * }
     *
     * function customizer(objValue, srcValue) {
     *   if (isGreeting(objValue) && isGreeting(srcValue)) {
     *     return true;
     *   }
     * }
     *
     * var object = { 'greeting': 'hello' };
     * var source = { 'greeting': 'hi' };
     *
     * _.isMatchWith(object, source, customizer);
     * // => true
     */
    function isMatchWith(object, source, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return baseIsMatch(object, source, getMatchData(source), customizer);
    }

    /**
     * Checks if `value` is `NaN`.
     *
     * **Note:** This method is based on
     * [`Number.isNaN`](https://mdn.io/Number/isNaN) and is not the same as
     * global [`isNaN`](https://mdn.io/isNaN) which returns `true` for
     * `undefined` and other non-number values.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `NaN`, else `false`.
     * @example
     *
     * _.isNaN(NaN);
     * // => true
     *
     * _.isNaN(new Number(NaN));
     * // => true
     *
     * isNaN(undefined);
     * // => true
     *
     * _.isNaN(undefined);
     * // => false
     */
    function isNaN(value) {
      // An `NaN` primitive is the only value that is not equal to itself.
      // Perform the `toStringTag` check first to avoid errors with some
      // ActiveX objects in IE.
      return isNumber(value) && value != +value;
    }

    /**
     * Checks if `value` is a pristine native function.
     *
     * **Note:** This method can't reliably detect native functions in the presence
     * of the core-js package because core-js circumvents this kind of detection.
     * Despite multiple requests, the core-js maintainer has made it clear: any
     * attempt to fix the detection will be obstructed. As a result, we're left
     * with little choice but to throw an error. Unfortunately, this also affects
     * packages, like [babel-polyfill](https://www.npmjs.com/package/babel-polyfill),
     * which rely on core-js.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a native function,
     *  else `false`.
     * @example
     *
     * _.isNative(Array.prototype.push);
     * // => true
     *
     * _.isNative(_);
     * // => false
     */
    function isNative(value) {
      if (isMaskable(value)) {
        throw new Error(CORE_ERROR_TEXT);
      }
      return baseIsNative(value);
    }

    /**
     * Checks if `value` is `null`.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `null`, else `false`.
     * @example
     *
     * _.isNull(null);
     * // => true
     *
     * _.isNull(void 0);
     * // => false
     */
    function isNull(value) {
      return value === null;
    }

    /**
     * Checks if `value` is `null` or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is nullish, else `false`.
     * @example
     *
     * _.isNil(null);
     * // => true
     *
     * _.isNil(void 0);
     * // => true
     *
     * _.isNil(NaN);
     * // => false
     */
    function isNil(value) {
      return value == null;
    }

    /**
     * Checks if `value` is classified as a `Number` primitive or object.
     *
     * **Note:** To exclude `Infinity`, `-Infinity`, and `NaN`, which are
     * classified as numbers, use the `_.isFinite` method.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a number, else `false`.
     * @example
     *
     * _.isNumber(3);
     * // => true
     *
     * _.isNumber(Number.MIN_VALUE);
     * // => true
     *
     * _.isNumber(Infinity);
     * // => true
     *
     * _.isNumber('3');
     * // => false
     */
    function isNumber(value) {
      return typeof value == 'number' || isObjectLike(value) && baseGetTag(value) == numberTag;
    }

    /**
     * Checks if `value` is a plain object, that is, an object created by the
     * `Object` constructor or one with a `[[Prototype]]` of `null`.
     *
     * @static
     * @memberOf _
     * @since 0.8.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a plain object, else `false`.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * _.isPlainObject(new Foo);
     * // => false
     *
     * _.isPlainObject([1, 2, 3]);
     * // => false
     *
     * _.isPlainObject({ 'x': 0, 'y': 0 });
     * // => true
     *
     * _.isPlainObject(Object.create(null));
     * // => true
     */
    function isPlainObject(value) {
      if (!isObjectLike(value) || baseGetTag(value) != objectTag) {
        return false;
      }
      var proto = getPrototype(value);
      if (proto === null) {
        return true;
      }
      var Ctor = hasOwnProperty.call(proto, 'constructor') && proto.constructor;
      return typeof Ctor == 'function' && Ctor instanceof Ctor && funcToString.call(Ctor) == objectCtorString;
    }

    /**
     * Checks if `value` is classified as a `RegExp` object.
     *
     * @static
     * @memberOf _
     * @since 0.1.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a regexp, else `false`.
     * @example
     *
     * _.isRegExp(/abc/);
     * // => true
     *
     * _.isRegExp('/abc/');
     * // => false
     */
    var isRegExp = nodeIsRegExp ? baseUnary(nodeIsRegExp) : baseIsRegExp;

    /**
     * Checks if `value` is a safe integer. An integer is safe if it's an IEEE-754
     * double precision number which isn't the result of a rounded unsafe integer.
     *
     * **Note:** This method is based on
     * [`Number.isSafeInteger`](https://mdn.io/Number/isSafeInteger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a safe integer, else `false`.
     * @example
     *
     * _.isSafeInteger(3);
     * // => true
     *
     * _.isSafeInteger(Number.MIN_VALUE);
     * // => false
     *
     * _.isSafeInteger(Infinity);
     * // => false
     *
     * _.isSafeInteger('3');
     * // => false
     */
    function isSafeInteger(value) {
      return isInteger(value) && value >= -MAX_SAFE_INTEGER && value <= MAX_SAFE_INTEGER;
    }

    /**
     * Checks if `value` is classified as a `Set` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a set, else `false`.
     * @example
     *
     * _.isSet(new Set);
     * // => true
     *
     * _.isSet(new WeakSet);
     * // => false
     */
    var isSet = nodeIsSet ? baseUnary(nodeIsSet) : baseIsSet;

    /**
     * Checks if `value` is classified as a `String` primitive or object.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a string, else `false`.
     * @example
     *
     * _.isString('abc');
     * // => true
     *
     * _.isString(1);
     * // => false
     */
    function isString(value) {
      return typeof value == 'string' || !isArray(value) && isObjectLike(value) && baseGetTag(value) == stringTag;
    }

    /**
     * Checks if `value` is classified as a `Symbol` primitive or object.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a symbol, else `false`.
     * @example
     *
     * _.isSymbol(Symbol.iterator);
     * // => true
     *
     * _.isSymbol('abc');
     * // => false
     */
    function isSymbol(value) {
      return _typeof(value) == 'symbol' || isObjectLike(value) && baseGetTag(value) == symbolTag;
    }

    /**
     * Checks if `value` is classified as a typed array.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a typed array, else `false`.
     * @example
     *
     * _.isTypedArray(new Uint8Array);
     * // => true
     *
     * _.isTypedArray([]);
     * // => false
     */
    var isTypedArray = nodeIsTypedArray ? baseUnary(nodeIsTypedArray) : baseIsTypedArray;

    /**
     * Checks if `value` is `undefined`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is `undefined`, else `false`.
     * @example
     *
     * _.isUndefined(void 0);
     * // => true
     *
     * _.isUndefined(null);
     * // => false
     */
    function isUndefined(value) {
      return value === undefined;
    }

    /**
     * Checks if `value` is classified as a `WeakMap` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak map, else `false`.
     * @example
     *
     * _.isWeakMap(new WeakMap);
     * // => true
     *
     * _.isWeakMap(new Map);
     * // => false
     */
    function isWeakMap(value) {
      return isObjectLike(value) && getTag(value) == weakMapTag;
    }

    /**
     * Checks if `value` is classified as a `WeakSet` object.
     *
     * @static
     * @memberOf _
     * @since 4.3.0
     * @category Lang
     * @param {*} value The value to check.
     * @returns {boolean} Returns `true` if `value` is a weak set, else `false`.
     * @example
     *
     * _.isWeakSet(new WeakSet);
     * // => true
     *
     * _.isWeakSet(new Set);
     * // => false
     */
    function isWeakSet(value) {
      return isObjectLike(value) && baseGetTag(value) == weakSetTag;
    }

    /**
     * Checks if `value` is less than `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than `other`,
     *  else `false`.
     * @see _.gt
     * @example
     *
     * _.lt(1, 3);
     * // => true
     *
     * _.lt(3, 3);
     * // => false
     *
     * _.lt(3, 1);
     * // => false
     */
    var lt = createRelationalOperation(baseLt);

    /**
     * Checks if `value` is less than or equal to `other`.
     *
     * @static
     * @memberOf _
     * @since 3.9.0
     * @category Lang
     * @param {*} value The value to compare.
     * @param {*} other The other value to compare.
     * @returns {boolean} Returns `true` if `value` is less than or equal to
     *  `other`, else `false`.
     * @see _.gte
     * @example
     *
     * _.lte(1, 3);
     * // => true
     *
     * _.lte(3, 3);
     * // => true
     *
     * _.lte(3, 1);
     * // => false
     */
    var lte = createRelationalOperation(function (value, other) {
      return value <= other;
    });

    /**
     * Converts `value` to an array.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Array} Returns the converted array.
     * @example
     *
     * _.toArray({ 'a': 1, 'b': 2 });
     * // => [1, 2]
     *
     * _.toArray('abc');
     * // => ['a', 'b', 'c']
     *
     * _.toArray(1);
     * // => []
     *
     * _.toArray(null);
     * // => []
     */
    function toArray(value) {
      if (!value) {
        return [];
      }
      if (isArrayLike(value)) {
        return isString(value) ? stringToArray(value) : copyArray(value);
      }
      if (symIterator && value[symIterator]) {
        return iteratorToArray(value[symIterator]());
      }
      var tag = getTag(value),
        func = tag == mapTag ? mapToArray : tag == setTag ? setToArray : values;
      return func(value);
    }

    /**
     * Converts `value` to a finite number.
     *
     * @static
     * @memberOf _
     * @since 4.12.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted number.
     * @example
     *
     * _.toFinite(3.2);
     * // => 3.2
     *
     * _.toFinite(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toFinite(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toFinite('3.2');
     * // => 3.2
     */
    function toFinite(value) {
      if (!value) {
        return value === 0 ? value : 0;
      }
      value = toNumber(value);
      if (value === INFINITY || value === -INFINITY) {
        var sign = value < 0 ? -1 : 1;
        return sign * MAX_INTEGER;
      }
      return value === value ? value : 0;
    }

    /**
     * Converts `value` to an integer.
     *
     * **Note:** This method is loosely based on
     * [`ToInteger`](http://www.ecma-international.org/ecma-262/7.0/#sec-tointeger).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toInteger(3.2);
     * // => 3
     *
     * _.toInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toInteger(Infinity);
     * // => 1.7976931348623157e+308
     *
     * _.toInteger('3.2');
     * // => 3
     */
    function toInteger(value) {
      var result = toFinite(value),
        remainder = result % 1;
      return result === result ? remainder ? result - remainder : result : 0;
    }

    /**
     * Converts `value` to an integer suitable for use as the length of an
     * array-like object.
     *
     * **Note:** This method is based on
     * [`ToLength`](http://ecma-international.org/ecma-262/7.0/#sec-tolength).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toLength(3.2);
     * // => 3
     *
     * _.toLength(Number.MIN_VALUE);
     * // => 0
     *
     * _.toLength(Infinity);
     * // => 4294967295
     *
     * _.toLength('3.2');
     * // => 3
     */
    function toLength(value) {
      return value ? baseClamp(toInteger(value), 0, MAX_ARRAY_LENGTH) : 0;
    }

    /**
     * Converts `value` to a number.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to process.
     * @returns {number} Returns the number.
     * @example
     *
     * _.toNumber(3.2);
     * // => 3.2
     *
     * _.toNumber(Number.MIN_VALUE);
     * // => 5e-324
     *
     * _.toNumber(Infinity);
     * // => Infinity
     *
     * _.toNumber('3.2');
     * // => 3.2
     */
    function toNumber(value) {
      if (typeof value == 'number') {
        return value;
      }
      if (isSymbol(value)) {
        return NAN;
      }
      if (isObject(value)) {
        var other = typeof value.valueOf == 'function' ? value.valueOf() : value;
        value = isObject(other) ? other + '' : other;
      }
      if (typeof value != 'string') {
        return value === 0 ? value : +value;
      }
      value = baseTrim(value);
      var isBinary = reIsBinary.test(value);
      return isBinary || reIsOctal.test(value) ? freeParseInt(value.slice(2), isBinary ? 2 : 8) : reIsBadHex.test(value) ? NAN : +value;
    }

    /**
     * Converts `value` to a plain object flattening inherited enumerable string
     * keyed properties of `value` to own properties of the plain object.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {Object} Returns the converted plain object.
     * @example
     *
     * function Foo() {
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.assign({ 'a': 1 }, new Foo);
     * // => { 'a': 1, 'b': 2 }
     *
     * _.assign({ 'a': 1 }, _.toPlainObject(new Foo));
     * // => { 'a': 1, 'b': 2, 'c': 3 }
     */
    function toPlainObject(value) {
      return copyObject(value, keysIn(value));
    }

    /**
     * Converts `value` to a safe integer. A safe integer can be compared and
     * represented correctly.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.toSafeInteger(3.2);
     * // => 3
     *
     * _.toSafeInteger(Number.MIN_VALUE);
     * // => 0
     *
     * _.toSafeInteger(Infinity);
     * // => 9007199254740991
     *
     * _.toSafeInteger('3.2');
     * // => 3
     */
    function toSafeInteger(value) {
      return value ? baseClamp(toInteger(value), -MAX_SAFE_INTEGER, MAX_SAFE_INTEGER) : value === 0 ? value : 0;
    }

    /**
     * Converts `value` to a string. An empty string is returned for `null`
     * and `undefined` values. The sign of `-0` is preserved.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Lang
     * @param {*} value The value to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.toString(null);
     * // => ''
     *
     * _.toString(-0);
     * // => '-0'
     *
     * _.toString([1, 2, 3]);
     * // => '1,2,3'
     */
    function toString(value) {
      return value == null ? '' : baseToString(value);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Assigns own enumerable string keyed properties of source objects to the
     * destination object. Source objects are applied from left to right.
     * Subsequent sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object` and is loosely based on
     * [`Object.assign`](https://mdn.io/Object/assign).
     *
     * @static
     * @memberOf _
     * @since 0.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assignIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assign({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'c': 3 }
     */
    var assign = createAssigner(function (object, source) {
      if (isPrototype(source) || isArrayLike(source)) {
        copyObject(source, keys(source), object);
        return;
      }
      for (var key in source) {
        if (hasOwnProperty.call(source, key)) {
          assignValue(object, key, source[key]);
        }
      }
    });

    /**
     * This method is like `_.assign` except that it iterates over own and
     * inherited source properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extend
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.assign
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     * }
     *
     * function Bar() {
     *   this.c = 3;
     * }
     *
     * Foo.prototype.b = 2;
     * Bar.prototype.d = 4;
     *
     * _.assignIn({ 'a': 0 }, new Foo, new Bar);
     * // => { 'a': 1, 'b': 2, 'c': 3, 'd': 4 }
     */
    var assignIn = createAssigner(function (object, source) {
      copyObject(source, keysIn(source), object);
    });

    /**
     * This method is like `_.assignIn` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias extendWith
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignInWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignInWith = createAssigner(function (object, source, srcIndex, customizer) {
      copyObject(source, keysIn(source), object, customizer);
    });

    /**
     * This method is like `_.assign` except that it accepts `customizer`
     * which is invoked to produce the assigned values. If `customizer` returns
     * `undefined`, assignment is handled by the method instead. The `customizer`
     * is invoked with five arguments: (objValue, srcValue, key, object, source).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @see _.assignInWith
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   return _.isUndefined(objValue) ? srcValue : objValue;
     * }
     *
     * var defaults = _.partialRight(_.assignWith, customizer);
     *
     * defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var assignWith = createAssigner(function (object, source, srcIndex, customizer) {
      copyObject(source, keys(source), object, customizer);
    });

    /**
     * Creates an array of values corresponding to `paths` of `object`.
     *
     * @static
     * @memberOf _
     * @since 1.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Array} Returns the picked values.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }, 4] };
     *
     * _.at(object, ['a[0].b.c', 'a[1]']);
     * // => [3, 4]
     */
    var at = flatRest(baseAt);

    /**
     * Creates an object that inherits from the `prototype` object. If a
     * `properties` object is given, its own enumerable string keyed properties
     * are assigned to the created object.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Object
     * @param {Object} prototype The object to inherit from.
     * @param {Object} [properties] The properties to assign to the object.
     * @returns {Object} Returns the new object.
     * @example
     *
     * function Shape() {
     *   this.x = 0;
     *   this.y = 0;
     * }
     *
     * function Circle() {
     *   Shape.call(this);
     * }
     *
     * Circle.prototype = _.create(Shape.prototype, {
     *   'constructor': Circle
     * });
     *
     * var circle = new Circle;
     * circle instanceof Circle;
     * // => true
     *
     * circle instanceof Shape;
     * // => true
     */
    function create(prototype, properties) {
      var result = baseCreate(prototype);
      return properties == null ? result : baseAssign(result, properties);
    }

    /**
     * Assigns own and inherited enumerable string keyed properties of source
     * objects to the destination object for all destination properties that
     * resolve to `undefined`. Source objects are applied from left to right.
     * Once a property is set, additional values of the same property are ignored.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaultsDeep
     * @example
     *
     * _.defaults({ 'a': 1 }, { 'b': 2 }, { 'a': 3 });
     * // => { 'a': 1, 'b': 2 }
     */
    var defaults = baseRest(function (object, sources) {
      object = Object(object);
      var index = -1;
      var length = sources.length;
      var guard = length > 2 ? sources[2] : undefined;
      if (guard && isIterateeCall(sources[0], sources[1], guard)) {
        length = 1;
      }
      while (++index < length) {
        var source = sources[index];
        var props = keysIn(source);
        var propsIndex = -1;
        var propsLength = props.length;
        while (++propsIndex < propsLength) {
          var key = props[propsIndex];
          var value = object[key];
          if (value === undefined || eq(value, objectProto[key]) && !hasOwnProperty.call(object, key)) {
            object[key] = source[key];
          }
        }
      }
      return object;
    });

    /**
     * This method is like `_.defaults` except that it recursively assigns
     * default properties.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @see _.defaults
     * @example
     *
     * _.defaultsDeep({ 'a': { 'b': 2 } }, { 'a': { 'b': 1, 'c': 3 } });
     * // => { 'a': { 'b': 2, 'c': 3 } }
     */
    var defaultsDeep = baseRest(function (args) {
      args.push(undefined, customDefaultsMerge);
      return apply(mergeWith, undefined, args);
    });

    /**
     * This method is like `_.find` except that it returns the key of the first
     * element `predicate` returns truthy for instead of the element itself.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findKey(users, function(o) { return o.age < 40; });
     * // => 'barney' (iteration order is not guaranteed)
     *
     * // The `_.matches` iteratee shorthand.
     * _.findKey(users, { 'age': 1, 'active': true });
     * // => 'pebbles'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findKey(users, 'active');
     * // => 'barney'
     */
    function findKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwn);
    }

    /**
     * This method is like `_.findKey` except that it iterates over elements of
     * a collection in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @param {Function} [predicate=_.identity] The function invoked per iteration.
     * @returns {string|undefined} Returns the key of the matched element,
     *  else `undefined`.
     * @example
     *
     * var users = {
     *   'barney':  { 'age': 36, 'active': true },
     *   'fred':    { 'age': 40, 'active': false },
     *   'pebbles': { 'age': 1,  'active': true }
     * };
     *
     * _.findLastKey(users, function(o) { return o.age < 40; });
     * // => returns 'pebbles' assuming `_.findKey` returns 'barney'
     *
     * // The `_.matches` iteratee shorthand.
     * _.findLastKey(users, { 'age': 36, 'active': true });
     * // => 'barney'
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.findLastKey(users, ['active', false]);
     * // => 'fred'
     *
     * // The `_.property` iteratee shorthand.
     * _.findLastKey(users, 'active');
     * // => 'pebbles'
     */
    function findLastKey(object, predicate) {
      return baseFindKey(object, getIteratee(predicate, 3), baseForOwnRight);
    }

    /**
     * Iterates over own and inherited enumerable string keyed properties of an
     * object and invokes `iteratee` for each property. The iteratee is invoked
     * with three arguments: (value, key, object). Iteratee functions may exit
     * iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forInRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forIn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a', 'b', then 'c' (iteration order is not guaranteed).
     */
    function forIn(object, iteratee) {
      return object == null ? object : baseFor(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * This method is like `_.forIn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forIn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forInRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'c', 'b', then 'a' assuming `_.forIn` logs 'a', 'b', then 'c'.
     */
    function forInRight(object, iteratee) {
      return object == null ? object : baseForRight(object, getIteratee(iteratee, 3), keysIn);
    }

    /**
     * Iterates over own enumerable string keyed properties of an object and
     * invokes `iteratee` for each property. The iteratee is invoked with three
     * arguments: (value, key, object). Iteratee functions may exit iteration
     * early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 0.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwnRight
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwn(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'a' then 'b' (iteration order is not guaranteed).
     */
    function forOwn(object, iteratee) {
      return object && baseForOwn(object, getIteratee(iteratee, 3));
    }

    /**
     * This method is like `_.forOwn` except that it iterates over properties of
     * `object` in the opposite order.
     *
     * @static
     * @memberOf _
     * @since 2.0.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns `object`.
     * @see _.forOwn
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.forOwnRight(new Foo, function(value, key) {
     *   console.log(key);
     * });
     * // => Logs 'b' then 'a' assuming `_.forOwn` logs 'a' then 'b'.
     */
    function forOwnRight(object, iteratee) {
      return object && baseForOwnRight(object, getIteratee(iteratee, 3));
    }

    /**
     * Creates an array of function property names from own enumerable properties
     * of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functionsIn
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functions(new Foo);
     * // => ['a', 'b']
     */
    function functions(object) {
      return object == null ? [] : baseFunctions(object, keys(object));
    }

    /**
     * Creates an array of function property names from own and inherited
     * enumerable properties of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to inspect.
     * @returns {Array} Returns the function names.
     * @see _.functions
     * @example
     *
     * function Foo() {
     *   this.a = _.constant('a');
     *   this.b = _.constant('b');
     * }
     *
     * Foo.prototype.c = _.constant('c');
     *
     * _.functionsIn(new Foo);
     * // => ['a', 'b', 'c']
     */
    function functionsIn(object) {
      return object == null ? [] : baseFunctions(object, keysIn(object));
    }

    /**
     * Gets the value at `path` of `object`. If the resolved value is
     * `undefined`, the `defaultValue` is returned in its place.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to get.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.get(object, 'a[0].b.c');
     * // => 3
     *
     * _.get(object, ['a', '0', 'b', 'c']);
     * // => 3
     *
     * _.get(object, 'a.b.c', 'default');
     * // => 'default'
     */
    function get(object, path, defaultValue) {
      var result = object == null ? undefined : baseGet(object, path);
      return result === undefined ? defaultValue : result;
    }

    /**
     * Checks if `path` is a direct property of `object`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = { 'a': { 'b': 2 } };
     * var other = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.has(object, 'a');
     * // => true
     *
     * _.has(object, 'a.b');
     * // => true
     *
     * _.has(object, ['a', 'b']);
     * // => true
     *
     * _.has(other, 'a');
     * // => false
     */
    function has(object, path) {
      return object != null && hasPath(object, path, baseHas);
    }

    /**
     * Checks if `path` is a direct or inherited property of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path to check.
     * @returns {boolean} Returns `true` if `path` exists, else `false`.
     * @example
     *
     * var object = _.create({ 'a': _.create({ 'b': 2 }) });
     *
     * _.hasIn(object, 'a');
     * // => true
     *
     * _.hasIn(object, 'a.b');
     * // => true
     *
     * _.hasIn(object, ['a', 'b']);
     * // => true
     *
     * _.hasIn(object, 'b');
     * // => false
     */
    function hasIn(object, path) {
      return object != null && hasPath(object, path, baseHasIn);
    }

    /**
     * Creates an object composed of the inverted keys and values of `object`.
     * If `object` contains duplicate values, subsequent values overwrite
     * property assignments of previous values.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Object
     * @param {Object} object The object to invert.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invert(object);
     * // => { '1': 'c', '2': 'b' }
     */
    var invert = createInverter(function (result, value, key) {
      if (value != null && typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }
      result[value] = key;
    }, constant(identity));

    /**
     * This method is like `_.invert` except that the inverted object is generated
     * from the results of running each element of `object` thru `iteratee`. The
     * corresponding inverted value of each inverted key is an array of keys
     * responsible for generating the inverted value. The iteratee is invoked
     * with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.1.0
     * @category Object
     * @param {Object} object The object to invert.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {Object} Returns the new inverted object.
     * @example
     *
     * var object = { 'a': 1, 'b': 2, 'c': 1 };
     *
     * _.invertBy(object);
     * // => { '1': ['a', 'c'], '2': ['b'] }
     *
     * _.invertBy(object, function(value) {
     *   return 'group' + value;
     * });
     * // => { 'group1': ['a', 'c'], 'group2': ['b'] }
     */
    var invertBy = createInverter(function (result, value, key) {
      if (value != null && typeof value.toString != 'function') {
        value = nativeObjectToString.call(value);
      }
      if (hasOwnProperty.call(result, value)) {
        result[value].push(key);
      } else {
        result[value] = [key];
      }
    }, getIteratee);

    /**
     * Invokes the method at `path` of `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {*} Returns the result of the invoked method.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': [1, 2, 3, 4] } }] };
     *
     * _.invoke(object, 'a[0].b.c.slice', 1, 3);
     * // => [2, 3]
     */
    var invoke = baseRest(baseInvoke);

    /**
     * Creates an array of the own enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects. See the
     * [ES spec](http://ecma-international.org/ecma-262/7.0/#sec-object.keys)
     * for more details.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keys(new Foo);
     * // => ['a', 'b'] (iteration order is not guaranteed)
     *
     * _.keys('hi');
     * // => ['0', '1']
     */
    function keys(object) {
      return isArrayLike(object) ? arrayLikeKeys(object) : baseKeys(object);
    }

    /**
     * Creates an array of the own and inherited enumerable property names of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property names.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.keysIn(new Foo);
     * // => ['a', 'b', 'c'] (iteration order is not guaranteed)
     */
    function keysIn(object) {
      return isArrayLike(object) ? arrayLikeKeys(object, true) : baseKeysIn(object);
    }

    /**
     * The opposite of `_.mapValues`; this method creates an object with the
     * same values as `object` and keys generated by running each own enumerable
     * string keyed property of `object` thru `iteratee`. The iteratee is invoked
     * with three arguments: (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 3.8.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapValues
     * @example
     *
     * _.mapKeys({ 'a': 1, 'b': 2 }, function(value, key) {
     *   return key + value;
     * });
     * // => { 'a1': 1, 'b2': 2 }
     */
    function mapKeys(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);
      baseForOwn(object, function (value, key, object) {
        baseAssignValue(result, iteratee(value, key, object), value);
      });
      return result;
    }

    /**
     * Creates an object with the same keys as `object` and values generated
     * by running each own enumerable string keyed property of `object` thru
     * `iteratee`. The iteratee is invoked with three arguments:
     * (value, key, object).
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Object} Returns the new mapped object.
     * @see _.mapKeys
     * @example
     *
     * var users = {
     *   'fred':    { 'user': 'fred',    'age': 40 },
     *   'pebbles': { 'user': 'pebbles', 'age': 1 }
     * };
     *
     * _.mapValues(users, function(o) { return o.age; });
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     *
     * // The `_.property` iteratee shorthand.
     * _.mapValues(users, 'age');
     * // => { 'fred': 40, 'pebbles': 1 } (iteration order is not guaranteed)
     */
    function mapValues(object, iteratee) {
      var result = {};
      iteratee = getIteratee(iteratee, 3);
      baseForOwn(object, function (value, key, object) {
        baseAssignValue(result, key, iteratee(value, key, object));
      });
      return result;
    }

    /**
     * This method is like `_.assign` except that it recursively merges own and
     * inherited enumerable string keyed properties of source objects into the
     * destination object. Source properties that resolve to `undefined` are
     * skipped if a destination value exists. Array and plain object properties
     * are merged recursively. Other objects and value types are overridden by
     * assignment. Source objects are applied from left to right. Subsequent
     * sources overwrite property assignments of previous sources.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 0.5.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} [sources] The source objects.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {
     *   'a': [{ 'b': 2 }, { 'd': 4 }]
     * };
     *
     * var other = {
     *   'a': [{ 'c': 3 }, { 'e': 5 }]
     * };
     *
     * _.merge(object, other);
     * // => { 'a': [{ 'b': 2, 'c': 3 }, { 'd': 4, 'e': 5 }] }
     */
    var merge = createAssigner(function (object, source, srcIndex) {
      baseMerge(object, source, srcIndex);
    });

    /**
     * This method is like `_.merge` except that it accepts `customizer` which
     * is invoked to produce the merged values of the destination and source
     * properties. If `customizer` returns `undefined`, merging is handled by the
     * method instead. The `customizer` is invoked with six arguments:
     * (objValue, srcValue, key, object, source, stack).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The destination object.
     * @param {...Object} sources The source objects.
     * @param {Function} customizer The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * function customizer(objValue, srcValue) {
     *   if (_.isArray(objValue)) {
     *     return objValue.concat(srcValue);
     *   }
     * }
     *
     * var object = { 'a': [1], 'b': [2] };
     * var other = { 'a': [3], 'b': [4] };
     *
     * _.mergeWith(object, other, customizer);
     * // => { 'a': [1, 3], 'b': [2, 4] }
     */
    var mergeWith = createAssigner(function (object, source, srcIndex, customizer) {
      baseMerge(object, source, srcIndex, customizer);
    });

    /**
     * The opposite of `_.pick`; this method creates an object composed of the
     * own and inherited enumerable property paths of `object` that are not omitted.
     *
     * **Note:** This method is considerably slower than `_.pick`.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to omit.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omit(object, ['a', 'c']);
     * // => { 'b': '2' }
     */
    var omit = flatRest(function (object, paths) {
      var result = {};
      if (object == null) {
        return result;
      }
      var isDeep = false;
      paths = arrayMap(paths, function (path) {
        path = castPath(path, object);
        isDeep || (isDeep = path.length > 1);
        return path;
      });
      copyObject(object, getAllKeysIn(object), result);
      if (isDeep) {
        result = baseClone(result, CLONE_DEEP_FLAG | CLONE_FLAT_FLAG | CLONE_SYMBOLS_FLAG, customOmitClone);
      }
      var length = paths.length;
      while (length--) {
        baseUnset(result, paths[length]);
      }
      return result;
    });

    /**
     * The opposite of `_.pickBy`; this method creates an object composed of
     * the own and inherited enumerable string keyed properties of `object` that
     * `predicate` doesn't return truthy for. The predicate is invoked with two
     * arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.omitBy(object, _.isNumber);
     * // => { 'b': '2' }
     */
    function omitBy(object, predicate) {
      return pickBy(object, negate(getIteratee(predicate)));
    }

    /**
     * Creates an object composed of the picked `object` properties.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The source object.
     * @param {...(string|string[])} [paths] The property paths to pick.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pick(object, ['a', 'c']);
     * // => { 'a': 1, 'c': 3 }
     */
    var pick = flatRest(function (object, paths) {
      return object == null ? {} : basePick(object, paths);
    });

    /**
     * Creates an object composed of the `object` properties `predicate` returns
     * truthy for. The predicate is invoked with two arguments: (value, key).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The source object.
     * @param {Function} [predicate=_.identity] The function invoked per property.
     * @returns {Object} Returns the new object.
     * @example
     *
     * var object = { 'a': 1, 'b': '2', 'c': 3 };
     *
     * _.pickBy(object, _.isNumber);
     * // => { 'a': 1, 'c': 3 }
     */
    function pickBy(object, predicate) {
      if (object == null) {
        return {};
      }
      var props = arrayMap(getAllKeysIn(object), function (prop) {
        return [prop];
      });
      predicate = getIteratee(predicate);
      return basePickBy(object, props, function (value, path) {
        return predicate(value, path[0]);
      });
    }

    /**
     * This method is like `_.get` except that if the resolved value is a
     * function it's invoked with the `this` binding of its parent object and
     * its result is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @param {Array|string} path The path of the property to resolve.
     * @param {*} [defaultValue] The value returned for `undefined` resolved values.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c1': 3, 'c2': _.constant(4) } }] };
     *
     * _.result(object, 'a[0].b.c1');
     * // => 3
     *
     * _.result(object, 'a[0].b.c2');
     * // => 4
     *
     * _.result(object, 'a[0].b.c3', 'default');
     * // => 'default'
     *
     * _.result(object, 'a[0].b.c3', _.constant('default'));
     * // => 'default'
     */
    function result(object, path, defaultValue) {
      path = castPath(path, object);
      var index = -1,
        length = path.length;

      // Ensure the loop is entered when path is empty.
      if (!length) {
        length = 1;
        object = undefined;
      }
      while (++index < length) {
        var value = object == null ? undefined : object[toKey(path[index])];
        if (value === undefined) {
          index = length;
          value = defaultValue;
        }
        object = isFunction(value) ? value.call(object) : value;
      }
      return object;
    }

    /**
     * Sets the value at `path` of `object`. If a portion of `path` doesn't exist,
     * it's created. Arrays are created for missing index properties while objects
     * are created for all other missing properties. Use `_.setWith` to customize
     * `path` creation.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.set(object, 'a[0].b.c', 4);
     * console.log(object.a[0].b.c);
     * // => 4
     *
     * _.set(object, ['x', '0', 'y', 'z'], 5);
     * console.log(object.x[0].y.z);
     * // => 5
     */
    function set(object, path, value) {
      return object == null ? object : baseSet(object, path, value);
    }

    /**
     * This method is like `_.set` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {*} value The value to set.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.setWith(object, '[0][1]', 'a', Object);
     * // => { '0': { '1': 'a' } }
     */
    function setWith(object, path, value, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseSet(object, path, value, customizer);
    }

    /**
     * Creates an array of own enumerable string keyed-value pairs for `object`
     * which can be consumed by `_.fromPairs`. If `object` is a map or set, its
     * entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entries
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairs(new Foo);
     * // => [['a', 1], ['b', 2]] (iteration order is not guaranteed)
     */
    var toPairs = createToPairs(keys);

    /**
     * Creates an array of own and inherited enumerable string keyed-value pairs
     * for `object` which can be consumed by `_.fromPairs`. If `object` is a map
     * or set, its entries are returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @alias entriesIn
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the key-value pairs.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.toPairsIn(new Foo);
     * // => [['a', 1], ['b', 2], ['c', 3]] (iteration order is not guaranteed)
     */
    var toPairsIn = createToPairs(keysIn);

    /**
     * An alternative to `_.reduce`; this method transforms `object` to a new
     * `accumulator` object which is the result of running each of its own
     * enumerable string keyed properties thru `iteratee`, with each invocation
     * potentially mutating the `accumulator` object. If `accumulator` is not
     * provided, a new object with the same `[[Prototype]]` will be used. The
     * iteratee is invoked with four arguments: (accumulator, value, key, object).
     * Iteratee functions may exit iteration early by explicitly returning `false`.
     *
     * @static
     * @memberOf _
     * @since 1.3.0
     * @category Object
     * @param {Object} object The object to iterate over.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @param {*} [accumulator] The custom accumulator value.
     * @returns {*} Returns the accumulated value.
     * @example
     *
     * _.transform([2, 3, 4], function(result, n) {
     *   result.push(n *= n);
     *   return n % 2 == 0;
     * }, []);
     * // => [4, 9]
     *
     * _.transform({ 'a': 1, 'b': 2, 'c': 1 }, function(result, value, key) {
     *   (result[value] || (result[value] = [])).push(key);
     * }, {});
     * // => { '1': ['a', 'c'], '2': ['b'] }
     */
    function transform(object, iteratee, accumulator) {
      var isArr = isArray(object),
        isArrLike = isArr || isBuffer(object) || isTypedArray(object);
      iteratee = getIteratee(iteratee, 4);
      if (accumulator == null) {
        var Ctor = object && object.constructor;
        if (isArrLike) {
          accumulator = isArr ? new Ctor() : [];
        } else if (isObject(object)) {
          accumulator = isFunction(Ctor) ? baseCreate(getPrototype(object)) : {};
        } else {
          accumulator = {};
        }
      }
      (isArrLike ? arrayEach : baseForOwn)(object, function (value, index, object) {
        return iteratee(accumulator, value, index, object);
      });
      return accumulator;
    }

    /**
     * Removes the property at `path` of `object`.
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to unset.
     * @returns {boolean} Returns `true` if the property is deleted, else `false`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 7 } }] };
     * _.unset(object, 'a[0].b.c');
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     *
     * _.unset(object, ['a', '0', 'b', 'c']);
     * // => true
     *
     * console.log(object);
     * // => { 'a': [{ 'b': {} }] };
     */
    function unset(object, path) {
      return object == null ? true : baseUnset(object, path);
    }

    /**
     * This method is like `_.set` except that accepts `updater` to produce the
     * value to set. Use `_.updateWith` to customize `path` creation. The `updater`
     * is invoked with one argument: (value).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = { 'a': [{ 'b': { 'c': 3 } }] };
     *
     * _.update(object, 'a[0].b.c', function(n) { return n * n; });
     * console.log(object.a[0].b.c);
     * // => 9
     *
     * _.update(object, 'x[0].y.z', function(n) { return n ? n + 1 : 0; });
     * console.log(object.x[0].y.z);
     * // => 0
     */
    function update(object, path, updater) {
      return object == null ? object : baseUpdate(object, path, castFunction(updater));
    }

    /**
     * This method is like `_.update` except that it accepts `customizer` which is
     * invoked to produce the objects of `path`.  If `customizer` returns `undefined`
     * path creation is handled by the method instead. The `customizer` is invoked
     * with three arguments: (nsValue, key, nsObject).
     *
     * **Note:** This method mutates `object`.
     *
     * @static
     * @memberOf _
     * @since 4.6.0
     * @category Object
     * @param {Object} object The object to modify.
     * @param {Array|string} path The path of the property to set.
     * @param {Function} updater The function to produce the updated value.
     * @param {Function} [customizer] The function to customize assigned values.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var object = {};
     *
     * _.updateWith(object, '[0][1]', _.constant('a'), Object);
     * // => { '0': { '1': 'a' } }
     */
    function updateWith(object, path, updater, customizer) {
      customizer = typeof customizer == 'function' ? customizer : undefined;
      return object == null ? object : baseUpdate(object, path, castFunction(updater), customizer);
    }

    /**
     * Creates an array of the own enumerable string keyed property values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.values(new Foo);
     * // => [1, 2] (iteration order is not guaranteed)
     *
     * _.values('hi');
     * // => ['h', 'i']
     */
    function values(object) {
      return object == null ? [] : baseValues(object, keys(object));
    }

    /**
     * Creates an array of the own and inherited enumerable string keyed property
     * values of `object`.
     *
     * **Note:** Non-object values are coerced to objects.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Object
     * @param {Object} object The object to query.
     * @returns {Array} Returns the array of property values.
     * @example
     *
     * function Foo() {
     *   this.a = 1;
     *   this.b = 2;
     * }
     *
     * Foo.prototype.c = 3;
     *
     * _.valuesIn(new Foo);
     * // => [1, 2, 3] (iteration order is not guaranteed)
     */
    function valuesIn(object) {
      return object == null ? [] : baseValues(object, keysIn(object));
    }

    /*------------------------------------------------------------------------*/

    /**
     * Clamps `number` within the inclusive `lower` and `upper` bounds.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Number
     * @param {number} number The number to clamp.
     * @param {number} [lower] The lower bound.
     * @param {number} upper The upper bound.
     * @returns {number} Returns the clamped number.
     * @example
     *
     * _.clamp(-10, -5, 5);
     * // => -5
     *
     * _.clamp(10, -5, 5);
     * // => 5
     */
    function clamp(number, lower, upper) {
      if (upper === undefined) {
        upper = lower;
        lower = undefined;
      }
      if (upper !== undefined) {
        upper = toNumber(upper);
        upper = upper === upper ? upper : 0;
      }
      if (lower !== undefined) {
        lower = toNumber(lower);
        lower = lower === lower ? lower : 0;
      }
      return baseClamp(toNumber(number), lower, upper);
    }

    /**
     * Checks if `n` is between `start` and up to, but not including, `end`. If
     * `end` is not specified, it's set to `start` with `start` then set to `0`.
     * If `start` is greater than `end` the params are swapped to support
     * negative ranges.
     *
     * @static
     * @memberOf _
     * @since 3.3.0
     * @category Number
     * @param {number} number The number to check.
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @returns {boolean} Returns `true` if `number` is in the range, else `false`.
     * @see _.range, _.rangeRight
     * @example
     *
     * _.inRange(3, 2, 4);
     * // => true
     *
     * _.inRange(4, 8);
     * // => true
     *
     * _.inRange(4, 2);
     * // => false
     *
     * _.inRange(2, 2);
     * // => false
     *
     * _.inRange(1.2, 2);
     * // => true
     *
     * _.inRange(5.2, 4);
     * // => false
     *
     * _.inRange(-3, -2, -6);
     * // => true
     */
    function inRange(number, start, end) {
      start = toFinite(start);
      if (end === undefined) {
        end = start;
        start = 0;
      } else {
        end = toFinite(end);
      }
      number = toNumber(number);
      return baseInRange(number, start, end);
    }

    /**
     * Produces a random number between the inclusive `lower` and `upper` bounds.
     * If only one argument is provided a number between `0` and the given number
     * is returned. If `floating` is `true`, or either `lower` or `upper` are
     * floats, a floating-point number is returned instead of an integer.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @memberOf _
     * @since 0.7.0
     * @category Number
     * @param {number} [lower=0] The lower bound.
     * @param {number} [upper=1] The upper bound.
     * @param {boolean} [floating] Specify returning a floating-point number.
     * @returns {number} Returns the random number.
     * @example
     *
     * _.random(0, 5);
     * // => an integer between 0 and 5
     *
     * _.random(5);
     * // => also an integer between 0 and 5
     *
     * _.random(5, true);
     * // => a floating-point number between 0 and 5
     *
     * _.random(1.2, 5.2);
     * // => a floating-point number between 1.2 and 5.2
     */
    function random(lower, upper, floating) {
      if (floating && typeof floating != 'boolean' && isIterateeCall(lower, upper, floating)) {
        upper = floating = undefined;
      }
      if (floating === undefined) {
        if (typeof upper == 'boolean') {
          floating = upper;
          upper = undefined;
        } else if (typeof lower == 'boolean') {
          floating = lower;
          lower = undefined;
        }
      }
      if (lower === undefined && upper === undefined) {
        lower = 0;
        upper = 1;
      } else {
        lower = toFinite(lower);
        if (upper === undefined) {
          upper = lower;
          lower = 0;
        } else {
          upper = toFinite(upper);
        }
      }
      if (lower > upper) {
        var temp = lower;
        lower = upper;
        upper = temp;
      }
      if (floating || lower % 1 || upper % 1) {
        var rand = nativeRandom();
        return nativeMin(lower + rand * (upper - lower + freeParseFloat('1e-' + ((rand + '').length - 1))), upper);
      }
      return baseRandom(lower, upper);
    }

    /*------------------------------------------------------------------------*/

    /**
     * Converts `string` to [camel case](https://en.wikipedia.org/wiki/CamelCase).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the camel cased string.
     * @example
     *
     * _.camelCase('Foo Bar');
     * // => 'fooBar'
     *
     * _.camelCase('--foo-bar--');
     * // => 'fooBar'
     *
     * _.camelCase('__FOO_BAR__');
     * // => 'fooBar'
     */
    var camelCase = createCompounder(function (result, word, index) {
      word = word.toLowerCase();
      return result + (index ? capitalize(word) : word);
    });

    /**
     * Converts the first character of `string` to upper case and the remaining
     * to lower case.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to capitalize.
     * @returns {string} Returns the capitalized string.
     * @example
     *
     * _.capitalize('FRED');
     * // => 'Fred'
     */
    function capitalize(string) {
      return upperFirst(toString(string).toLowerCase());
    }

    /**
     * Deburrs `string` by converting
     * [Latin-1 Supplement](https://en.wikipedia.org/wiki/Latin-1_Supplement_(Unicode_block)#Character_table)
     * and [Latin Extended-A](https://en.wikipedia.org/wiki/Latin_Extended-A)
     * letters to basic Latin letters and removing
     * [combining diacritical marks](https://en.wikipedia.org/wiki/Combining_Diacritical_Marks).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to deburr.
     * @returns {string} Returns the deburred string.
     * @example
     *
     * _.deburr('déjà vu');
     * // => 'deja vu'
     */
    function deburr(string) {
      string = toString(string);
      return string && string.replace(reLatin, deburrLetter).replace(reComboMark, '');
    }

    /**
     * Checks if `string` ends with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=string.length] The position to search up to.
     * @returns {boolean} Returns `true` if `string` ends with `target`,
     *  else `false`.
     * @example
     *
     * _.endsWith('abc', 'c');
     * // => true
     *
     * _.endsWith('abc', 'b');
     * // => false
     *
     * _.endsWith('abc', 'b', 2);
     * // => true
     */
    function endsWith(string, target, position) {
      string = toString(string);
      target = baseToString(target);
      var length = string.length;
      position = position === undefined ? length : baseClamp(toInteger(position), 0, length);
      var end = position;
      position -= target.length;
      return position >= 0 && string.slice(position, end) == target;
    }

    /**
     * Converts the characters "&", "<", ">", '"', and "'" in `string` to their
     * corresponding HTML entities.
     *
     * **Note:** No other characters are escaped. To escape additional
     * characters use a third-party library like [_he_](https://mths.be/he).
     *
     * Though the ">" character is escaped for symmetry, characters like
     * ">" and "/" don't need escaping in HTML and have no special meaning
     * unless they're part of a tag or unquoted attribute value. See
     * [Mathias Bynens's article](https://mathiasbynens.be/notes/ambiguous-ampersands)
     * (under "semi-related fun fact") for more details.
     *
     * When working with HTML you should always
     * [quote attribute values](http://wonko.com/post/html-escaping) to reduce
     * XSS vectors.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escape('fred, barney, & pebbles');
     * // => 'fred, barney, &amp; pebbles'
     */
    function escape(string) {
      string = toString(string);
      return string && reHasUnescapedHtml.test(string) ? string.replace(reUnescapedHtml, escapeHtmlChar) : string;
    }

    /**
     * Escapes the `RegExp` special characters "^", "$", "\", ".", "*", "+",
     * "?", "(", ")", "[", "]", "{", "}", and "|" in `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to escape.
     * @returns {string} Returns the escaped string.
     * @example
     *
     * _.escapeRegExp('[lodash](https://lodash.com/)');
     * // => '\[lodash\]\(https://lodash\.com/\)'
     */
    function escapeRegExp(string) {
      string = toString(string);
      return string && reHasRegExpChar.test(string) ? string.replace(reRegExpChar, '\\$&') : string;
    }

    /**
     * Converts `string` to
     * [kebab case](https://en.wikipedia.org/wiki/Letter_case#Special_case_styles).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the kebab cased string.
     * @example
     *
     * _.kebabCase('Foo Bar');
     * // => 'foo-bar'
     *
     * _.kebabCase('fooBar');
     * // => 'foo-bar'
     *
     * _.kebabCase('__FOO_BAR__');
     * // => 'foo-bar'
     */
    var kebabCase = createCompounder(function (result, word, index) {
      return result + (index ? '-' : '') + word.toLowerCase();
    });

    /**
     * Converts `string`, as space separated words, to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.lowerCase('--Foo-Bar--');
     * // => 'foo bar'
     *
     * _.lowerCase('fooBar');
     * // => 'foo bar'
     *
     * _.lowerCase('__FOO_BAR__');
     * // => 'foo bar'
     */
    var lowerCase = createCompounder(function (result, word, index) {
      return result + (index ? ' ' : '') + word.toLowerCase();
    });

    /**
     * Converts the first character of `string` to lower case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.lowerFirst('Fred');
     * // => 'fred'
     *
     * _.lowerFirst('FRED');
     * // => 'fRED'
     */
    var lowerFirst = createCaseFirst('toLowerCase');

    /**
     * Pads `string` on the left and right sides if it's shorter than `length`.
     * Padding characters are truncated if they can't be evenly divided by `length`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.pad('abc', 8);
     * // => '  abc   '
     *
     * _.pad('abc', 8, '_-');
     * // => '_-abc_-_'
     *
     * _.pad('abc', 3);
     * // => 'abc'
     */
    function pad(string, length, chars) {
      string = toString(string);
      length = toInteger(length);
      var strLength = length ? stringSize(string) : 0;
      if (!length || strLength >= length) {
        return string;
      }
      var mid = (length - strLength) / 2;
      return createPadding(nativeFloor(mid), chars) + string + createPadding(nativeCeil(mid), chars);
    }

    /**
     * Pads `string` on the right side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padEnd('abc', 6);
     * // => 'abc   '
     *
     * _.padEnd('abc', 6, '_-');
     * // => 'abc_-_'
     *
     * _.padEnd('abc', 3);
     * // => 'abc'
     */
    function padEnd(string, length, chars) {
      string = toString(string);
      length = toInteger(length);
      var strLength = length ? stringSize(string) : 0;
      return length && strLength < length ? string + createPadding(length - strLength, chars) : string;
    }

    /**
     * Pads `string` on the left side if it's shorter than `length`. Padding
     * characters are truncated if they exceed `length`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to pad.
     * @param {number} [length=0] The padding length.
     * @param {string} [chars=' '] The string used as padding.
     * @returns {string} Returns the padded string.
     * @example
     *
     * _.padStart('abc', 6);
     * // => '   abc'
     *
     * _.padStart('abc', 6, '_-');
     * // => '_-_abc'
     *
     * _.padStart('abc', 3);
     * // => 'abc'
     */
    function padStart(string, length, chars) {
      string = toString(string);
      length = toInteger(length);
      var strLength = length ? stringSize(string) : 0;
      return length && strLength < length ? createPadding(length - strLength, chars) + string : string;
    }

    /**
     * Converts `string` to an integer of the specified radix. If `radix` is
     * `undefined` or `0`, a `radix` of `10` is used unless `value` is a
     * hexadecimal, in which case a `radix` of `16` is used.
     *
     * **Note:** This method aligns with the
     * [ES5 implementation](https://es5.github.io/#x15.1.2.2) of `parseInt`.
     *
     * @static
     * @memberOf _
     * @since 1.1.0
     * @category String
     * @param {string} string The string to convert.
     * @param {number} [radix=10] The radix to interpret `value` by.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {number} Returns the converted integer.
     * @example
     *
     * _.parseInt('08');
     * // => 8
     *
     * _.map(['6', '08', '10'], _.parseInt);
     * // => [6, 8, 10]
     */
    function parseInt(string, radix, guard) {
      if (guard || radix == null) {
        radix = 0;
      } else if (radix) {
        radix = +radix;
      }
      return nativeParseInt(toString(string).replace(reTrimStart, ''), radix || 0);
    }

    /**
     * Repeats the given string `n` times.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to repeat.
     * @param {number} [n=1] The number of times to repeat the string.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the repeated string.
     * @example
     *
     * _.repeat('*', 3);
     * // => '***'
     *
     * _.repeat('abc', 2);
     * // => 'abcabc'
     *
     * _.repeat('abc', 0);
     * // => ''
     */
    function repeat(string, n, guard) {
      if (guard ? isIterateeCall(string, n, guard) : n === undefined) {
        n = 1;
      } else {
        n = toInteger(n);
      }
      return baseRepeat(toString(string), n);
    }

    /**
     * Replaces matches for `pattern` in `string` with `replacement`.
     *
     * **Note:** This method is based on
     * [`String#replace`](https://mdn.io/String/replace).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to modify.
     * @param {RegExp|string} pattern The pattern to replace.
     * @param {Function|string} replacement The match replacement.
     * @returns {string} Returns the modified string.
     * @example
     *
     * _.replace('Hi Fred', 'Fred', 'Barney');
     * // => 'Hi Barney'
     */
    function replace() {
      var args = arguments,
        string = toString(args[0]);
      return args.length < 3 ? string : string.replace(args[1], args[2]);
    }

    /**
     * Converts `string` to
     * [snake case](https://en.wikipedia.org/wiki/Snake_case).
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the snake cased string.
     * @example
     *
     * _.snakeCase('Foo Bar');
     * // => 'foo_bar'
     *
     * _.snakeCase('fooBar');
     * // => 'foo_bar'
     *
     * _.snakeCase('--FOO-BAR--');
     * // => 'foo_bar'
     */
    var snakeCase = createCompounder(function (result, word, index) {
      return result + (index ? '_' : '') + word.toLowerCase();
    });

    /**
     * Splits `string` by `separator`.
     *
     * **Note:** This method is based on
     * [`String#split`](https://mdn.io/String/split).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to split.
     * @param {RegExp|string} separator The separator pattern to split by.
     * @param {number} [limit] The length to truncate results to.
     * @returns {Array} Returns the string segments.
     * @example
     *
     * _.split('a-b-c', '-', 2);
     * // => ['a', 'b']
     */
    function split(string, separator, limit) {
      if (limit && typeof limit != 'number' && isIterateeCall(string, separator, limit)) {
        separator = limit = undefined;
      }
      limit = limit === undefined ? MAX_ARRAY_LENGTH : limit >>> 0;
      if (!limit) {
        return [];
      }
      string = toString(string);
      if (string && (typeof separator == 'string' || separator != null && !isRegExp(separator))) {
        separator = baseToString(separator);
        if (!separator && hasUnicode(string)) {
          return castSlice(stringToArray(string), 0, limit);
        }
      }
      return string.split(separator, limit);
    }

    /**
     * Converts `string` to
     * [start case](https://en.wikipedia.org/wiki/Letter_case#Stylistic_or_specialised_usage).
     *
     * @static
     * @memberOf _
     * @since 3.1.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the start cased string.
     * @example
     *
     * _.startCase('--foo-bar--');
     * // => 'Foo Bar'
     *
     * _.startCase('fooBar');
     * // => 'Foo Bar'
     *
     * _.startCase('__FOO_BAR__');
     * // => 'FOO BAR'
     */
    var startCase = createCompounder(function (result, word, index) {
      return result + (index ? ' ' : '') + upperFirst(word);
    });

    /**
     * Checks if `string` starts with the given target string.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {string} [target] The string to search for.
     * @param {number} [position=0] The position to search from.
     * @returns {boolean} Returns `true` if `string` starts with `target`,
     *  else `false`.
     * @example
     *
     * _.startsWith('abc', 'a');
     * // => true
     *
     * _.startsWith('abc', 'b');
     * // => false
     *
     * _.startsWith('abc', 'b', 1);
     * // => true
     */
    function startsWith(string, target, position) {
      string = toString(string);
      position = position == null ? 0 : baseClamp(toInteger(position), 0, string.length);
      target = baseToString(target);
      return string.slice(position, position + target.length) == target;
    }

    /**
     * Creates a compiled template function that can interpolate data properties
     * in "interpolate" delimiters, HTML-escape interpolated data properties in
     * "escape" delimiters, and execute JavaScript in "evaluate" delimiters. Data
     * properties may be accessed as free variables in the template. If a setting
     * object is given, it takes precedence over `_.templateSettings` values.
     *
     * **Note:** In the development build `_.template` utilizes
     * [sourceURLs](http://www.html5rocks.com/en/tutorials/developertools/sourcemaps/#toc-sourceurl)
     * for easier debugging.
     *
     * For more information on precompiling templates see
     * [lodash's custom builds documentation](https://lodash.com/custom-builds).
     *
     * For more information on Chrome extension sandboxes see
     * [Chrome's extensions documentation](https://developer.chrome.com/extensions/sandboxingEval).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category String
     * @param {string} [string=''] The template string.
     * @param {Object} [options={}] The options object.
     * @param {RegExp} [options.escape=_.templateSettings.escape]
     *  The HTML "escape" delimiter.
     * @param {RegExp} [options.evaluate=_.templateSettings.evaluate]
     *  The "evaluate" delimiter.
     * @param {Object} [options.imports=_.templateSettings.imports]
     *  An object to import into the template as free variables.
     * @param {RegExp} [options.interpolate=_.templateSettings.interpolate]
     *  The "interpolate" delimiter.
     * @param {string} [options.sourceURL='lodash.templateSources[n]']
     *  The sourceURL of the compiled template.
     * @param {string} [options.variable='obj']
     *  The data object variable name.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Function} Returns the compiled template function.
     * @example
     *
     * // Use the "interpolate" delimiter to create a compiled template.
     * var compiled = _.template('hello <%= user %>!');
     * compiled({ 'user': 'fred' });
     * // => 'hello fred!'
     *
     * // Use the HTML "escape" delimiter to escape data property values.
     * var compiled = _.template('<b><%- value %></b>');
     * compiled({ 'value': '<script>' });
     * // => '<b>&lt;script&gt;</b>'
     *
     * // Use the "evaluate" delimiter to execute JavaScript and generate HTML.
     * var compiled = _.template('<% _.forEach(users, function(user) { %><li><%- user %></li><% }); %>');
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the internal `print` function in "evaluate" delimiters.
     * var compiled = _.template('<% print("hello " + user); %>!');
     * compiled({ 'user': 'barney' });
     * // => 'hello barney!'
     *
     * // Use the ES template literal delimiter as an "interpolate" delimiter.
     * // Disable support by replacing the "interpolate" delimiter.
     * var compiled = _.template('hello ${ user }!');
     * compiled({ 'user': 'pebbles' });
     * // => 'hello pebbles!'
     *
     * // Use backslashes to treat delimiters as plain text.
     * var compiled = _.template('<%= "\\<%- value %\\>" %>');
     * compiled({ 'value': 'ignored' });
     * // => '<%- value %>'
     *
     * // Use the `imports` option to import `jQuery` as `jq`.
     * var text = '<% jq.each(users, function(user) { %><li><%- user %></li><% }); %>';
     * var compiled = _.template(text, { 'imports': { 'jq': jQuery } });
     * compiled({ 'users': ['fred', 'barney'] });
     * // => '<li>fred</li><li>barney</li>'
     *
     * // Use the `sourceURL` option to specify a custom sourceURL for the template.
     * var compiled = _.template('hello <%= user %>!', { 'sourceURL': '/basic/greeting.jst' });
     * compiled(data);
     * // => Find the source of "greeting.jst" under the Sources tab or Resources panel of the web inspector.
     *
     * // Use the `variable` option to ensure a with-statement isn't used in the compiled template.
     * var compiled = _.template('hi <%= data.user %>!', { 'variable': 'data' });
     * compiled.source;
     * // => function(data) {
     * //   var __t, __p = '';
     * //   __p += 'hi ' + ((__t = ( data.user )) == null ? '' : __t) + '!';
     * //   return __p;
     * // }
     *
     * // Use custom template delimiters.
     * _.templateSettings.interpolate = /{{([\s\S]+?)}}/g;
     * var compiled = _.template('hello {{ user }}!');
     * compiled({ 'user': 'mustache' });
     * // => 'hello mustache!'
     *
     * // Use the `source` property to inline compiled templates for meaningful
     * // line numbers in error messages and stack traces.
     * fs.writeFileSync(path.join(process.cwd(), 'jst.js'), '\
     *   var JST = {\
     *     "main": ' + _.template(mainText).source + '\
     *   };\
     * ');
     */
    function template(string, options, guard) {
      // Based on John Resig's `tmpl` implementation
      // (http://ejohn.org/blog/javascript-micro-templating/)
      // and Laura Doktorova's doT.js (https://github.com/olado/doT).
      var settings = lodash.templateSettings;
      if (guard && isIterateeCall(string, options, guard)) {
        options = undefined;
      }
      string = toString(string);
      options = assignInWith({}, options, settings, customDefaultsAssignIn);
      var imports = assignInWith({}, options.imports, settings.imports, customDefaultsAssignIn),
        importsKeys = keys(imports),
        importsValues = baseValues(imports, importsKeys);
      var isEscaping,
        isEvaluating,
        index = 0,
        interpolate = options.interpolate || reNoMatch,
        source = "__p += '";

      // Compile the regexp to match each delimiter.
      var reDelimiters = RegExp((options.escape || reNoMatch).source + '|' + interpolate.source + '|' + (interpolate === reInterpolate ? reEsTemplate : reNoMatch).source + '|' + (options.evaluate || reNoMatch).source + '|$', 'g');

      // Use a sourceURL for easier debugging.
      // The sourceURL gets injected into the source that's eval-ed, so be careful
      // to normalize all kinds of whitespace, so e.g. newlines (and unicode versions of it) can't sneak in
      // and escape the comment, thus injecting code that gets evaled.
      var sourceURL = '//# sourceURL=' + (hasOwnProperty.call(options, 'sourceURL') ? (options.sourceURL + '').replace(/\s/g, ' ') : 'lodash.templateSources[' + ++templateCounter + ']') + '\n';
      string.replace(reDelimiters, function (match, escapeValue, interpolateValue, esTemplateValue, evaluateValue, offset) {
        interpolateValue || (interpolateValue = esTemplateValue);

        // Escape characters that can't be included in string literals.
        source += string.slice(index, offset).replace(reUnescapedString, escapeStringChar);

        // Replace delimiters with snippets.
        if (escapeValue) {
          isEscaping = true;
          source += "' +\n__e(" + escapeValue + ") +\n'";
        }
        if (evaluateValue) {
          isEvaluating = true;
          source += "';\n" + evaluateValue + ";\n__p += '";
        }
        if (interpolateValue) {
          source += "' +\n((__t = (" + interpolateValue + ")) == null ? '' : __t) +\n'";
        }
        index = offset + match.length;

        // The JS engine embedded in Adobe products needs `match` returned in
        // order to produce the correct `offset` value.
        return match;
      });
      source += "';\n";

      // If `variable` is not specified wrap a with-statement around the generated
      // code to add the data object to the top of the scope chain.
      var variable = hasOwnProperty.call(options, 'variable') && options.variable;
      if (!variable) {
        source = 'with (obj) {\n' + source + '\n}\n';
      }
      // Throw an error if a forbidden character was found in `variable`, to prevent
      // potential command injection attacks.
      else if (reForbiddenIdentifierChars.test(variable)) {
        throw new Error(INVALID_TEMPL_VAR_ERROR_TEXT);
      }

      // Cleanup code by stripping empty strings.
      source = (isEvaluating ? source.replace(reEmptyStringLeading, '') : source).replace(reEmptyStringMiddle, '$1').replace(reEmptyStringTrailing, '$1;');

      // Frame code as the function body.
      source = 'function(' + (variable || 'obj') + ') {\n' + (variable ? '' : 'obj || (obj = {});\n') + "var __t, __p = ''" + (isEscaping ? ', __e = _.escape' : '') + (isEvaluating ? ', __j = Array.prototype.join;\n' + "function print() { __p += __j.call(arguments, '') }\n" : ';\n') + source + 'return __p\n}';
      var result = attempt(function () {
        return Function(importsKeys, sourceURL + 'return ' + source).apply(undefined, importsValues);
      });

      // Provide the compiled function's source by its `toString` method or
      // the `source` property as a convenience for inlining compiled templates.
      result.source = source;
      if (isError(result)) {
        throw result;
      }
      return result;
    }

    /**
     * Converts `string`, as a whole, to lower case just like
     * [String#toLowerCase](https://mdn.io/toLowerCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the lower cased string.
     * @example
     *
     * _.toLower('--Foo-Bar--');
     * // => '--foo-bar--'
     *
     * _.toLower('fooBar');
     * // => 'foobar'
     *
     * _.toLower('__FOO_BAR__');
     * // => '__foo_bar__'
     */
    function toLower(value) {
      return toString(value).toLowerCase();
    }

    /**
     * Converts `string`, as a whole, to upper case just like
     * [String#toUpperCase](https://mdn.io/toUpperCase).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.toUpper('--foo-bar--');
     * // => '--FOO-BAR--'
     *
     * _.toUpper('fooBar');
     * // => 'FOOBAR'
     *
     * _.toUpper('__foo_bar__');
     * // => '__FOO_BAR__'
     */
    function toUpper(value) {
      return toString(value).toUpperCase();
    }

    /**
     * Removes leading and trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trim('  abc  ');
     * // => 'abc'
     *
     * _.trim('-_-abc-_-', '_-');
     * // => 'abc'
     *
     * _.map(['  foo  ', '  bar  '], _.trim);
     * // => ['foo', 'bar']
     */
    function trim(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return baseTrim(string);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
        chrSymbols = stringToArray(chars),
        start = charsStartIndex(strSymbols, chrSymbols),
        end = charsEndIndex(strSymbols, chrSymbols) + 1;
      return castSlice(strSymbols, start, end).join('');
    }

    /**
     * Removes trailing whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimEnd('  abc  ');
     * // => '  abc'
     *
     * _.trimEnd('-_-abc-_-', '_-');
     * // => '-_-abc'
     */
    function trimEnd(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.slice(0, trimmedEndIndex(string) + 1);
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
        end = charsEndIndex(strSymbols, stringToArray(chars)) + 1;
      return castSlice(strSymbols, 0, end).join('');
    }

    /**
     * Removes leading whitespace or specified characters from `string`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to trim.
     * @param {string} [chars=whitespace] The characters to trim.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {string} Returns the trimmed string.
     * @example
     *
     * _.trimStart('  abc  ');
     * // => 'abc  '
     *
     * _.trimStart('-_-abc-_-', '_-');
     * // => 'abc-_-'
     */
    function trimStart(string, chars, guard) {
      string = toString(string);
      if (string && (guard || chars === undefined)) {
        return string.replace(reTrimStart, '');
      }
      if (!string || !(chars = baseToString(chars))) {
        return string;
      }
      var strSymbols = stringToArray(string),
        start = charsStartIndex(strSymbols, stringToArray(chars));
      return castSlice(strSymbols, start).join('');
    }

    /**
     * Truncates `string` if it's longer than the given maximum string length.
     * The last characters of the truncated string are replaced with the omission
     * string which defaults to "...".
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to truncate.
     * @param {Object} [options={}] The options object.
     * @param {number} [options.length=30] The maximum string length.
     * @param {string} [options.omission='...'] The string to indicate text is omitted.
     * @param {RegExp|string} [options.separator] The separator pattern to truncate to.
     * @returns {string} Returns the truncated string.
     * @example
     *
     * _.truncate('hi-diddly-ho there, neighborino');
     * // => 'hi-diddly-ho there, neighbo...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': ' '
     * });
     * // => 'hi-diddly-ho there,...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'length': 24,
     *   'separator': /,? +/
     * });
     * // => 'hi-diddly-ho there...'
     *
     * _.truncate('hi-diddly-ho there, neighborino', {
     *   'omission': ' [...]'
     * });
     * // => 'hi-diddly-ho there, neig [...]'
     */
    function truncate(string, options) {
      var length = DEFAULT_TRUNC_LENGTH,
        omission = DEFAULT_TRUNC_OMISSION;
      if (isObject(options)) {
        var separator = 'separator' in options ? options.separator : separator;
        length = 'length' in options ? toInteger(options.length) : length;
        omission = 'omission' in options ? baseToString(options.omission) : omission;
      }
      string = toString(string);
      var strLength = string.length;
      if (hasUnicode(string)) {
        var strSymbols = stringToArray(string);
        strLength = strSymbols.length;
      }
      if (length >= strLength) {
        return string;
      }
      var end = length - stringSize(omission);
      if (end < 1) {
        return omission;
      }
      var result = strSymbols ? castSlice(strSymbols, 0, end).join('') : string.slice(0, end);
      if (separator === undefined) {
        return result + omission;
      }
      if (strSymbols) {
        end += result.length - end;
      }
      if (isRegExp(separator)) {
        if (string.slice(end).search(separator)) {
          var match,
            substring = result;
          if (!separator.global) {
            separator = RegExp(separator.source, toString(reFlags.exec(separator)) + 'g');
          }
          separator.lastIndex = 0;
          while (match = separator.exec(substring)) {
            var newEnd = match.index;
          }
          result = result.slice(0, newEnd === undefined ? end : newEnd);
        }
      } else if (string.indexOf(baseToString(separator), end) != end) {
        var index = result.lastIndexOf(separator);
        if (index > -1) {
          result = result.slice(0, index);
        }
      }
      return result + omission;
    }

    /**
     * The inverse of `_.escape`; this method converts the HTML entities
     * `&amp;`, `&lt;`, `&gt;`, `&quot;`, and `&#39;` in `string` to
     * their corresponding characters.
     *
     * **Note:** No other HTML entities are unescaped. To unescape additional
     * HTML entities use a third-party library like [_he_](https://mths.be/he).
     *
     * @static
     * @memberOf _
     * @since 0.6.0
     * @category String
     * @param {string} [string=''] The string to unescape.
     * @returns {string} Returns the unescaped string.
     * @example
     *
     * _.unescape('fred, barney, &amp; pebbles');
     * // => 'fred, barney, & pebbles'
     */
    function unescape(string) {
      string = toString(string);
      return string && reHasEscapedHtml.test(string) ? string.replace(reEscapedHtml, unescapeHtmlChar) : string;
    }

    /**
     * Converts `string`, as space separated words, to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the upper cased string.
     * @example
     *
     * _.upperCase('--foo-bar');
     * // => 'FOO BAR'
     *
     * _.upperCase('fooBar');
     * // => 'FOO BAR'
     *
     * _.upperCase('__foo_bar__');
     * // => 'FOO BAR'
     */
    var upperCase = createCompounder(function (result, word, index) {
      return result + (index ? ' ' : '') + word.toUpperCase();
    });

    /**
     * Converts the first character of `string` to upper case.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category String
     * @param {string} [string=''] The string to convert.
     * @returns {string} Returns the converted string.
     * @example
     *
     * _.upperFirst('fred');
     * // => 'Fred'
     *
     * _.upperFirst('FRED');
     * // => 'FRED'
     */
    var upperFirst = createCaseFirst('toUpperCase');

    /**
     * Splits `string` into an array of its words.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category String
     * @param {string} [string=''] The string to inspect.
     * @param {RegExp|string} [pattern] The pattern to match words.
     * @param- {Object} [guard] Enables use as an iteratee for methods like `_.map`.
     * @returns {Array} Returns the words of `string`.
     * @example
     *
     * _.words('fred, barney, & pebbles');
     * // => ['fred', 'barney', 'pebbles']
     *
     * _.words('fred, barney, & pebbles', /[^, ]+/g);
     * // => ['fred', 'barney', '&', 'pebbles']
     */
    function words(string, pattern, guard) {
      string = toString(string);
      pattern = guard ? undefined : pattern;
      if (pattern === undefined) {
        return hasUnicodeWord(string) ? unicodeWords(string) : asciiWords(string);
      }
      return string.match(pattern) || [];
    }

    /*------------------------------------------------------------------------*/

    /**
     * Attempts to invoke `func`, returning either the result or the caught error
     * object. Any additional arguments are provided to `func` when it's invoked.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Function} func The function to attempt.
     * @param {...*} [args] The arguments to invoke `func` with.
     * @returns {*} Returns the `func` result or error object.
     * @example
     *
     * // Avoid throwing errors for invalid selectors.
     * var elements = _.attempt(function(selector) {
     *   return document.querySelectorAll(selector);
     * }, '>_>');
     *
     * if (_.isError(elements)) {
     *   elements = [];
     * }
     */
    var attempt = baseRest(function (func, args) {
      try {
        return apply(func, undefined, args);
      } catch (e) {
        return isError(e) ? e : new Error(e);
      }
    });

    /**
     * Binds methods of an object to the object itself, overwriting the existing
     * method.
     *
     * **Note:** This method doesn't set the "length" property of bound functions.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Object} object The object to bind and assign the bound methods to.
     * @param {...(string|string[])} methodNames The object method names to bind.
     * @returns {Object} Returns `object`.
     * @example
     *
     * var view = {
     *   'label': 'docs',
     *   'click': function() {
     *     console.log('clicked ' + this.label);
     *   }
     * };
     *
     * _.bindAll(view, ['click']);
     * jQuery(element).on('click', view.click);
     * // => Logs 'clicked docs' when clicked.
     */
    var bindAll = flatRest(function (object, methodNames) {
      arrayEach(methodNames, function (key) {
        key = toKey(key);
        baseAssignValue(object, key, bind(object[key], object));
      });
      return object;
    });

    /**
     * Creates a function that iterates over `pairs` and invokes the corresponding
     * function of the first predicate to return truthy. The predicate-function
     * pairs are invoked with the `this` binding and arguments of the created
     * function.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Array} pairs The predicate-function pairs.
     * @returns {Function} Returns the new composite function.
     * @example
     *
     * var func = _.cond([
     *   [_.matches({ 'a': 1 }),           _.constant('matches A')],
     *   [_.conforms({ 'b': _.isNumber }), _.constant('matches B')],
     *   [_.stubTrue,                      _.constant('no match')]
     * ]);
     *
     * func({ 'a': 1, 'b': 2 });
     * // => 'matches A'
     *
     * func({ 'a': 0, 'b': 1 });
     * // => 'matches B'
     *
     * func({ 'a': '1', 'b': '2' });
     * // => 'no match'
     */
    function cond(pairs) {
      var length = pairs == null ? 0 : pairs.length,
        toIteratee = getIteratee();
      pairs = !length ? [] : arrayMap(pairs, function (pair) {
        if (typeof pair[1] != 'function') {
          throw new TypeError(FUNC_ERROR_TEXT);
        }
        return [toIteratee(pair[0]), pair[1]];
      });
      return baseRest(function (args) {
        var index = -1;
        while (++index < length) {
          var pair = pairs[index];
          if (apply(pair[0], this, args)) {
            return apply(pair[1], this, args);
          }
        }
      });
    }

    /**
     * Creates a function that invokes the predicate properties of `source` with
     * the corresponding property values of a given object, returning `true` if
     * all predicates return truthy, else `false`.
     *
     * **Note:** The created function is equivalent to `_.conformsTo` with
     * `source` partially applied.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {Object} source The object of property predicates to conform to.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 2, 'b': 1 },
     *   { 'a': 1, 'b': 2 }
     * ];
     *
     * _.filter(objects, _.conforms({ 'b': function(n) { return n > 1; } }));
     * // => [{ 'a': 1, 'b': 2 }]
     */
    function conforms(source) {
      return baseConforms(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that returns `value`.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {*} value The value to return from the new function.
     * @returns {Function} Returns the new constant function.
     * @example
     *
     * var objects = _.times(2, _.constant({ 'a': 1 }));
     *
     * console.log(objects);
     * // => [{ 'a': 1 }, { 'a': 1 }]
     *
     * console.log(objects[0] === objects[1]);
     * // => true
     */
    function constant(value) {
      return function () {
        return value;
      };
    }

    /**
     * Checks `value` to determine whether a default value should be returned in
     * its place. The `defaultValue` is returned if `value` is `NaN`, `null`,
     * or `undefined`.
     *
     * @static
     * @memberOf _
     * @since 4.14.0
     * @category Util
     * @param {*} value The value to check.
     * @param {*} defaultValue The default value.
     * @returns {*} Returns the resolved value.
     * @example
     *
     * _.defaultTo(1, 10);
     * // => 1
     *
     * _.defaultTo(undefined, 10);
     * // => 10
     */
    function defaultTo(value, defaultValue) {
      return value == null || value !== value ? defaultValue : value;
    }

    /**
     * Creates a function that returns the result of invoking the given functions
     * with the `this` binding of the created function, where each successive
     * invocation is supplied the return value of the previous.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flowRight
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flow([_.add, square]);
     * addSquare(1, 2);
     * // => 9
     */
    var flow = createFlow();

    /**
     * This method is like `_.flow` except that it creates a function that
     * invokes the given functions from right to left.
     *
     * @static
     * @since 3.0.0
     * @memberOf _
     * @category Util
     * @param {...(Function|Function[])} [funcs] The functions to invoke.
     * @returns {Function} Returns the new composite function.
     * @see _.flow
     * @example
     *
     * function square(n) {
     *   return n * n;
     * }
     *
     * var addSquare = _.flowRight([square, _.add]);
     * addSquare(1, 2);
     * // => 9
     */
    var flowRight = createFlow(true);

    /**
     * This method returns the first argument it receives.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {*} value Any value.
     * @returns {*} Returns `value`.
     * @example
     *
     * var object = { 'a': 1 };
     *
     * console.log(_.identity(object) === object);
     * // => true
     */
    function identity(value) {
      return value;
    }

    /**
     * Creates a function that invokes `func` with the arguments of the created
     * function. If `func` is a property name, the created function returns the
     * property value for a given element. If `func` is an array or object, the
     * created function returns `true` for elements that contain the equivalent
     * source properties, otherwise it returns `false`.
     *
     * @static
     * @since 4.0.0
     * @memberOf _
     * @category Util
     * @param {*} [func=_.identity] The value to convert to a callback.
     * @returns {Function} Returns the callback.
     * @example
     *
     * var users = [
     *   { 'user': 'barney', 'age': 36, 'active': true },
     *   { 'user': 'fred',   'age': 40, 'active': false }
     * ];
     *
     * // The `_.matches` iteratee shorthand.
     * _.filter(users, _.iteratee({ 'user': 'barney', 'active': true }));
     * // => [{ 'user': 'barney', 'age': 36, 'active': true }]
     *
     * // The `_.matchesProperty` iteratee shorthand.
     * _.filter(users, _.iteratee(['user', 'fred']));
     * // => [{ 'user': 'fred', 'age': 40 }]
     *
     * // The `_.property` iteratee shorthand.
     * _.map(users, _.iteratee('user'));
     * // => ['barney', 'fred']
     *
     * // Create custom iteratee shorthands.
     * _.iteratee = _.wrap(_.iteratee, function(iteratee, func) {
     *   return !_.isRegExp(func) ? iteratee(func) : function(string) {
     *     return func.test(string);
     *   };
     * });
     *
     * _.filter(['abc', 'def'], /ef/);
     * // => ['def']
     */
    function iteratee(func) {
      return baseIteratee(typeof func == 'function' ? func : baseClone(func, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between a given
     * object and `source`, returning `true` if the given object has equivalent
     * property values, else `false`.
     *
     * **Note:** The created function is equivalent to `_.isMatch` with `source`
     * partially applied.
     *
     * Partial comparisons will match empty array and empty object `source`
     * values against any array or object value, respectively. See `_.isEqual`
     * for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} source The object of property values to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.filter(objects, _.matches({ 'a': 4, 'c': 6 }));
     * // => [{ 'a': 4, 'b': 5, 'c': 6 }]
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matches({ 'a': 1 }), _.matches({ 'a': 4 })]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matches(source) {
      return baseMatches(baseClone(source, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that performs a partial deep comparison between the
     * value at `path` of a given object to `srcValue`, returning `true` if the
     * object value is equivalent, else `false`.
     *
     * **Note:** Partial comparisons will match empty array and empty object
     * `srcValue` values against any array or object value, respectively. See
     * `_.isEqual` for a list of supported value comparisons.
     *
     * **Note:** Multiple values can be checked by combining several matchers
     * using `_.overSome`
     *
     * @static
     * @memberOf _
     * @since 3.2.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @param {*} srcValue The value to match.
     * @returns {Function} Returns the new spec function.
     * @example
     *
     * var objects = [
     *   { 'a': 1, 'b': 2, 'c': 3 },
     *   { 'a': 4, 'b': 5, 'c': 6 }
     * ];
     *
     * _.find(objects, _.matchesProperty('a', 4));
     * // => { 'a': 4, 'b': 5, 'c': 6 }
     *
     * // Checking for several possible values
     * _.filter(objects, _.overSome([_.matchesProperty('a', 1), _.matchesProperty('a', 4)]));
     * // => [{ 'a': 1, 'b': 2, 'c': 3 }, { 'a': 4, 'b': 5, 'c': 6 }]
     */
    function matchesProperty(path, srcValue) {
      return baseMatchesProperty(path, baseClone(srcValue, CLONE_DEEP_FLAG));
    }

    /**
     * Creates a function that invokes the method at `path` of a given object.
     * Any additional arguments are provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Array|string} path The path of the method to invoke.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': _.constant(2) } },
     *   { 'a': { 'b': _.constant(1) } }
     * ];
     *
     * _.map(objects, _.method('a.b'));
     * // => [2, 1]
     *
     * _.map(objects, _.method(['a', 'b']));
     * // => [2, 1]
     */
    var method = baseRest(function (path, args) {
      return function (object) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * The opposite of `_.method`; this method creates a function that invokes
     * the method at a given path of `object`. Any additional arguments are
     * provided to the invoked method.
     *
     * @static
     * @memberOf _
     * @since 3.7.0
     * @category Util
     * @param {Object} object The object to query.
     * @param {...*} [args] The arguments to invoke the method with.
     * @returns {Function} Returns the new invoker function.
     * @example
     *
     * var array = _.times(3, _.constant),
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.methodOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.methodOf(object));
     * // => [2, 0]
     */
    var methodOf = baseRest(function (object, args) {
      return function (path) {
        return baseInvoke(object, path, args);
      };
    });

    /**
     * Adds all own enumerable string keyed function properties of a source
     * object to the destination object. If `object` is a function, then methods
     * are added to its prototype as well.
     *
     * **Note:** Use `_.runInContext` to create a pristine `lodash` function to
     * avoid conflicts caused by modifying the original.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {Function|Object} [object=lodash] The destination object.
     * @param {Object} source The object of functions to add.
     * @param {Object} [options={}] The options object.
     * @param {boolean} [options.chain=true] Specify whether mixins are chainable.
     * @returns {Function|Object} Returns `object`.
     * @example
     *
     * function vowels(string) {
     *   return _.filter(string, function(v) {
     *     return /[aeiou]/i.test(v);
     *   });
     * }
     *
     * _.mixin({ 'vowels': vowels });
     * _.vowels('fred');
     * // => ['e']
     *
     * _('fred').vowels().value();
     * // => ['e']
     *
     * _.mixin({ 'vowels': vowels }, { 'chain': false });
     * _('fred').vowels();
     * // => ['e']
     */
    function mixin(object, source, options) {
      var props = keys(source),
        methodNames = baseFunctions(source, props);
      if (options == null && !(isObject(source) && (methodNames.length || !props.length))) {
        options = source;
        source = object;
        object = this;
        methodNames = baseFunctions(source, keys(source));
      }
      var chain = !(isObject(options) && 'chain' in options) || !!options.chain,
        isFunc = isFunction(object);
      arrayEach(methodNames, function (methodName) {
        var func = source[methodName];
        object[methodName] = func;
        if (isFunc) {
          object.prototype[methodName] = function () {
            var chainAll = this.__chain__;
            if (chain || chainAll) {
              var result = object(this.__wrapped__),
                actions = result.__actions__ = copyArray(this.__actions__);
              actions.push({
                'func': func,
                'args': arguments,
                'thisArg': object
              });
              result.__chain__ = chainAll;
              return result;
            }
            return func.apply(object, arrayPush([this.value()], arguments));
          };
        }
      });
      return object;
    }

    /**
     * Reverts the `_` variable to its previous value and returns a reference to
     * the `lodash` function.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @returns {Function} Returns the `lodash` function.
     * @example
     *
     * var lodash = _.noConflict();
     */
    function noConflict() {
      if (root._ === this) {
        root._ = oldDash;
      }
      return this;
    }

    /**
     * This method returns `undefined`.
     *
     * @static
     * @memberOf _
     * @since 2.3.0
     * @category Util
     * @example
     *
     * _.times(2, _.noop);
     * // => [undefined, undefined]
     */
    function noop() {
      // No operation performed.
    }

    /**
     * Creates a function that gets the argument at index `n`. If `n` is negative,
     * the nth argument from the end is returned.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [n=0] The index of the argument to return.
     * @returns {Function} Returns the new pass-thru function.
     * @example
     *
     * var func = _.nthArg(1);
     * func('a', 'b', 'c', 'd');
     * // => 'b'
     *
     * var func = _.nthArg(-2);
     * func('a', 'b', 'c', 'd');
     * // => 'c'
     */
    function nthArg(n) {
      n = toInteger(n);
      return baseRest(function (args) {
        return baseNth(args, n);
      });
    }

    /**
     * Creates a function that invokes `iteratees` with the arguments it receives
     * and returns their results.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [iteratees=[_.identity]]
     *  The iteratees to invoke.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.over([Math.max, Math.min]);
     *
     * func(1, 2, 3, 4);
     * // => [4, 1]
     */
    var over = createOver(arrayMap);

    /**
     * Creates a function that checks if **all** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overEvery([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => false
     *
     * func(NaN);
     * // => false
     */
    var overEvery = createOver(arrayEvery);

    /**
     * Creates a function that checks if **any** of the `predicates` return
     * truthy when invoked with the arguments it receives.
     *
     * Following shorthands are possible for providing predicates.
     * Pass an `Object` and it will be used as an parameter for `_.matches` to create the predicate.
     * Pass an `Array` of parameters for `_.matchesProperty` and the predicate will be created using them.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {...(Function|Function[])} [predicates=[_.identity]]
     *  The predicates to check.
     * @returns {Function} Returns the new function.
     * @example
     *
     * var func = _.overSome([Boolean, isFinite]);
     *
     * func('1');
     * // => true
     *
     * func(null);
     * // => true
     *
     * func(NaN);
     * // => false
     *
     * var matchesFunc = _.overSome([{ 'a': 1 }, { 'a': 2 }])
     * var matchesPropertyFunc = _.overSome([['a', 1], ['a', 2]])
     */
    var overSome = createOver(arraySome);

    /**
     * Creates a function that returns the value at `path` of a given object.
     *
     * @static
     * @memberOf _
     * @since 2.4.0
     * @category Util
     * @param {Array|string} path The path of the property to get.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var objects = [
     *   { 'a': { 'b': 2 } },
     *   { 'a': { 'b': 1 } }
     * ];
     *
     * _.map(objects, _.property('a.b'));
     * // => [2, 1]
     *
     * _.map(_.sortBy(objects, _.property(['a', 'b'])), 'a.b');
     * // => [1, 2]
     */
    function property(path) {
      return isKey(path) ? baseProperty(toKey(path)) : basePropertyDeep(path);
    }

    /**
     * The opposite of `_.property`; this method creates a function that returns
     * the value at a given path of `object`.
     *
     * @static
     * @memberOf _
     * @since 3.0.0
     * @category Util
     * @param {Object} object The object to query.
     * @returns {Function} Returns the new accessor function.
     * @example
     *
     * var array = [0, 1, 2],
     *     object = { 'a': array, 'b': array, 'c': array };
     *
     * _.map(['a[2]', 'c[0]'], _.propertyOf(object));
     * // => [2, 0]
     *
     * _.map([['a', '2'], ['c', '0']], _.propertyOf(object));
     * // => [2, 0]
     */
    function propertyOf(object) {
      return function (path) {
        return object == null ? undefined : baseGet(object, path);
      };
    }

    /**
     * Creates an array of numbers (positive and/or negative) progressing from
     * `start` up to, but not including, `end`. A step of `-1` is used if a negative
     * `start` is specified without an `end` or `step`. If `end` is not specified,
     * it's set to `start` with `start` then set to `0`.
     *
     * **Note:** JavaScript follows the IEEE-754 standard for resolving
     * floating-point values which can produce unexpected results.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.rangeRight
     * @example
     *
     * _.range(4);
     * // => [0, 1, 2, 3]
     *
     * _.range(-4);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 5);
     * // => [1, 2, 3, 4]
     *
     * _.range(0, 20, 5);
     * // => [0, 5, 10, 15]
     *
     * _.range(0, -4, -1);
     * // => [0, -1, -2, -3]
     *
     * _.range(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.range(0);
     * // => []
     */
    var range = createRange();

    /**
     * This method is like `_.range` except that it populates values in
     * descending order.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {number} [start=0] The start of the range.
     * @param {number} end The end of the range.
     * @param {number} [step=1] The value to increment or decrement by.
     * @returns {Array} Returns the range of numbers.
     * @see _.inRange, _.range
     * @example
     *
     * _.rangeRight(4);
     * // => [3, 2, 1, 0]
     *
     * _.rangeRight(-4);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 5);
     * // => [4, 3, 2, 1]
     *
     * _.rangeRight(0, 20, 5);
     * // => [15, 10, 5, 0]
     *
     * _.rangeRight(0, -4, -1);
     * // => [-3, -2, -1, 0]
     *
     * _.rangeRight(1, 4, 0);
     * // => [1, 1, 1]
     *
     * _.rangeRight(0);
     * // => []
     */
    var rangeRight = createRange(true);

    /**
     * This method returns a new empty array.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Array} Returns the new empty array.
     * @example
     *
     * var arrays = _.times(2, _.stubArray);
     *
     * console.log(arrays);
     * // => [[], []]
     *
     * console.log(arrays[0] === arrays[1]);
     * // => false
     */
    function stubArray() {
      return [];
    }

    /**
     * This method returns `false`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `false`.
     * @example
     *
     * _.times(2, _.stubFalse);
     * // => [false, false]
     */
    function stubFalse() {
      return false;
    }

    /**
     * This method returns a new empty object.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {Object} Returns the new empty object.
     * @example
     *
     * var objects = _.times(2, _.stubObject);
     *
     * console.log(objects);
     * // => [{}, {}]
     *
     * console.log(objects[0] === objects[1]);
     * // => false
     */
    function stubObject() {
      return {};
    }

    /**
     * This method returns an empty string.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {string} Returns the empty string.
     * @example
     *
     * _.times(2, _.stubString);
     * // => ['', '']
     */
    function stubString() {
      return '';
    }

    /**
     * This method returns `true`.
     *
     * @static
     * @memberOf _
     * @since 4.13.0
     * @category Util
     * @returns {boolean} Returns `true`.
     * @example
     *
     * _.times(2, _.stubTrue);
     * // => [true, true]
     */
    function stubTrue() {
      return true;
    }

    /**
     * Invokes the iteratee `n` times, returning an array of the results of
     * each invocation. The iteratee is invoked with one argument; (index).
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {number} n The number of times to invoke `iteratee`.
     * @param {Function} [iteratee=_.identity] The function invoked per iteration.
     * @returns {Array} Returns the array of results.
     * @example
     *
     * _.times(3, String);
     * // => ['0', '1', '2']
     *
     *  _.times(4, _.constant(0));
     * // => [0, 0, 0, 0]
     */
    function times(n, iteratee) {
      n = toInteger(n);
      if (n < 1 || n > MAX_SAFE_INTEGER) {
        return [];
      }
      var index = MAX_ARRAY_LENGTH,
        length = nativeMin(n, MAX_ARRAY_LENGTH);
      iteratee = getIteratee(iteratee);
      n -= MAX_ARRAY_LENGTH;
      var result = baseTimes(length, iteratee);
      while (++index < n) {
        iteratee(index);
      }
      return result;
    }

    /**
     * Converts `value` to a property path array.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Util
     * @param {*} value The value to convert.
     * @returns {Array} Returns the new property path array.
     * @example
     *
     * _.toPath('a.b.c');
     * // => ['a', 'b', 'c']
     *
     * _.toPath('a[0].b.c');
     * // => ['a', '0', 'b', 'c']
     */
    function toPath(value) {
      if (isArray(value)) {
        return arrayMap(value, toKey);
      }
      return isSymbol(value) ? [value] : copyArray(stringToPath(toString(value)));
    }

    /**
     * Generates a unique ID. If `prefix` is given, the ID is appended to it.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Util
     * @param {string} [prefix=''] The value to prefix the ID with.
     * @returns {string} Returns the unique ID.
     * @example
     *
     * _.uniqueId('contact_');
     * // => 'contact_104'
     *
     * _.uniqueId();
     * // => '105'
     */
    function uniqueId(prefix) {
      var id = ++idCounter;
      return toString(prefix) + id;
    }

    /*------------------------------------------------------------------------*/

    /**
     * Adds two numbers.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {number} augend The first number in an addition.
     * @param {number} addend The second number in an addition.
     * @returns {number} Returns the total.
     * @example
     *
     * _.add(6, 4);
     * // => 10
     */
    var add = createMathOperation(function (augend, addend) {
      return augend + addend;
    }, 0);

    /**
     * Computes `number` rounded up to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round up.
     * @param {number} [precision=0] The precision to round up to.
     * @returns {number} Returns the rounded up number.
     * @example
     *
     * _.ceil(4.006);
     * // => 5
     *
     * _.ceil(6.004, 2);
     * // => 6.01
     *
     * _.ceil(6040, -2);
     * // => 6100
     */
    var ceil = createRound('ceil');

    /**
     * Divide two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} dividend The first number in a division.
     * @param {number} divisor The second number in a division.
     * @returns {number} Returns the quotient.
     * @example
     *
     * _.divide(6, 4);
     * // => 1.5
     */
    var divide = createMathOperation(function (dividend, divisor) {
      return dividend / divisor;
    }, 1);

    /**
     * Computes `number` rounded down to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round down.
     * @param {number} [precision=0] The precision to round down to.
     * @returns {number} Returns the rounded down number.
     * @example
     *
     * _.floor(4.006);
     * // => 4
     *
     * _.floor(0.046, 2);
     * // => 0.04
     *
     * _.floor(4060, -2);
     * // => 4000
     */
    var floor = createRound('floor');

    /**
     * Computes the maximum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * _.max([4, 2, 8, 6]);
     * // => 8
     *
     * _.max([]);
     * // => undefined
     */
    function max(array) {
      return array && array.length ? baseExtremum(array, identity, baseGt) : undefined;
    }

    /**
     * This method is like `_.max` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the maximum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.maxBy(objects, function(o) { return o.n; });
     * // => { 'n': 2 }
     *
     * // The `_.property` iteratee shorthand.
     * _.maxBy(objects, 'n');
     * // => { 'n': 2 }
     */
    function maxBy(array, iteratee) {
      return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseGt) : undefined;
    }

    /**
     * Computes the mean of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the mean.
     * @example
     *
     * _.mean([4, 2, 8, 6]);
     * // => 5
     */
    function mean(array) {
      return baseMean(array, identity);
    }

    /**
     * This method is like `_.mean` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be averaged.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the mean.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.meanBy(objects, function(o) { return o.n; });
     * // => 5
     *
     * // The `_.property` iteratee shorthand.
     * _.meanBy(objects, 'n');
     * // => 5
     */
    function meanBy(array, iteratee) {
      return baseMean(array, getIteratee(iteratee, 2));
    }

    /**
     * Computes the minimum value of `array`. If `array` is empty or falsey,
     * `undefined` is returned.
     *
     * @static
     * @since 0.1.0
     * @memberOf _
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * _.min([4, 2, 8, 6]);
     * // => 2
     *
     * _.min([]);
     * // => undefined
     */
    function min(array) {
      return array && array.length ? baseExtremum(array, identity, baseLt) : undefined;
    }

    /**
     * This method is like `_.min` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the criterion by which
     * the value is ranked. The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {*} Returns the minimum value.
     * @example
     *
     * var objects = [{ 'n': 1 }, { 'n': 2 }];
     *
     * _.minBy(objects, function(o) { return o.n; });
     * // => { 'n': 1 }
     *
     * // The `_.property` iteratee shorthand.
     * _.minBy(objects, 'n');
     * // => { 'n': 1 }
     */
    function minBy(array, iteratee) {
      return array && array.length ? baseExtremum(array, getIteratee(iteratee, 2), baseLt) : undefined;
    }

    /**
     * Multiply two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.7.0
     * @category Math
     * @param {number} multiplier The first number in a multiplication.
     * @param {number} multiplicand The second number in a multiplication.
     * @returns {number} Returns the product.
     * @example
     *
     * _.multiply(6, 4);
     * // => 24
     */
    var multiply = createMathOperation(function (multiplier, multiplicand) {
      return multiplier * multiplicand;
    }, 1);

    /**
     * Computes `number` rounded to `precision`.
     *
     * @static
     * @memberOf _
     * @since 3.10.0
     * @category Math
     * @param {number} number The number to round.
     * @param {number} [precision=0] The precision to round to.
     * @returns {number} Returns the rounded number.
     * @example
     *
     * _.round(4.006);
     * // => 4
     *
     * _.round(4.006, 2);
     * // => 4.01
     *
     * _.round(4060, -2);
     * // => 4100
     */
    var round = createRound('round');

    /**
     * Subtract two numbers.
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {number} minuend The first number in a subtraction.
     * @param {number} subtrahend The second number in a subtraction.
     * @returns {number} Returns the difference.
     * @example
     *
     * _.subtract(6, 4);
     * // => 2
     */
    var subtract = createMathOperation(function (minuend, subtrahend) {
      return minuend - subtrahend;
    }, 0);

    /**
     * Computes the sum of the values in `array`.
     *
     * @static
     * @memberOf _
     * @since 3.4.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @returns {number} Returns the sum.
     * @example
     *
     * _.sum([4, 2, 8, 6]);
     * // => 20
     */
    function sum(array) {
      return array && array.length ? baseSum(array, identity) : 0;
    }

    /**
     * This method is like `_.sum` except that it accepts `iteratee` which is
     * invoked for each element in `array` to generate the value to be summed.
     * The iteratee is invoked with one argument: (value).
     *
     * @static
     * @memberOf _
     * @since 4.0.0
     * @category Math
     * @param {Array} array The array to iterate over.
     * @param {Function} [iteratee=_.identity] The iteratee invoked per element.
     * @returns {number} Returns the sum.
     * @example
     *
     * var objects = [{ 'n': 4 }, { 'n': 2 }, { 'n': 8 }, { 'n': 6 }];
     *
     * _.sumBy(objects, function(o) { return o.n; });
     * // => 20
     *
     * // The `_.property` iteratee shorthand.
     * _.sumBy(objects, 'n');
     * // => 20
     */
    function sumBy(array, iteratee) {
      return array && array.length ? baseSum(array, getIteratee(iteratee, 2)) : 0;
    }

    /*------------------------------------------------------------------------*/

    // Add methods that return wrapped values in chain sequences.
    lodash.after = after;
    lodash.ary = ary;
    lodash.assign = assign;
    lodash.assignIn = assignIn;
    lodash.assignInWith = assignInWith;
    lodash.assignWith = assignWith;
    lodash.at = at;
    lodash.before = before;
    lodash.bind = bind;
    lodash.bindAll = bindAll;
    lodash.bindKey = bindKey;
    lodash.castArray = castArray;
    lodash.chain = chain;
    lodash.chunk = chunk;
    lodash.compact = compact;
    lodash.concat = concat;
    lodash.cond = cond;
    lodash.conforms = conforms;
    lodash.constant = constant;
    lodash.countBy = countBy;
    lodash.create = create;
    lodash.curry = curry;
    lodash.curryRight = curryRight;
    lodash.debounce = debounce;
    lodash.defaults = defaults;
    lodash.defaultsDeep = defaultsDeep;
    lodash.defer = defer;
    lodash.delay = delay;
    lodash.difference = difference;
    lodash.differenceBy = differenceBy;
    lodash.differenceWith = differenceWith;
    lodash.drop = drop;
    lodash.dropRight = dropRight;
    lodash.dropRightWhile = dropRightWhile;
    lodash.dropWhile = dropWhile;
    lodash.fill = fill;
    lodash.filter = filter;
    lodash.flatMap = flatMap;
    lodash.flatMapDeep = flatMapDeep;
    lodash.flatMapDepth = flatMapDepth;
    lodash.flatten = flatten;
    lodash.flattenDeep = flattenDeep;
    lodash.flattenDepth = flattenDepth;
    lodash.flip = flip;
    lodash.flow = flow;
    lodash.flowRight = flowRight;
    lodash.fromPairs = fromPairs;
    lodash.functions = functions;
    lodash.functionsIn = functionsIn;
    lodash.groupBy = groupBy;
    lodash.initial = initial;
    lodash.intersection = intersection;
    lodash.intersectionBy = intersectionBy;
    lodash.intersectionWith = intersectionWith;
    lodash.invert = invert;
    lodash.invertBy = invertBy;
    lodash.invokeMap = invokeMap;
    lodash.iteratee = iteratee;
    lodash.keyBy = keyBy;
    lodash.keys = keys;
    lodash.keysIn = keysIn;
    lodash.map = map;
    lodash.mapKeys = mapKeys;
    lodash.mapValues = mapValues;
    lodash.matches = matches;
    lodash.matchesProperty = matchesProperty;
    lodash.memoize = memoize;
    lodash.merge = merge;
    lodash.mergeWith = mergeWith;
    lodash.method = method;
    lodash.methodOf = methodOf;
    lodash.mixin = mixin;
    lodash.negate = negate;
    lodash.nthArg = nthArg;
    lodash.omit = omit;
    lodash.omitBy = omitBy;
    lodash.once = once;
    lodash.orderBy = orderBy;
    lodash.over = over;
    lodash.overArgs = overArgs;
    lodash.overEvery = overEvery;
    lodash.overSome = overSome;
    lodash.partial = partial;
    lodash.partialRight = partialRight;
    lodash.partition = partition;
    lodash.pick = pick;
    lodash.pickBy = pickBy;
    lodash.property = property;
    lodash.propertyOf = propertyOf;
    lodash.pull = pull;
    lodash.pullAll = pullAll;
    lodash.pullAllBy = pullAllBy;
    lodash.pullAllWith = pullAllWith;
    lodash.pullAt = pullAt;
    lodash.range = range;
    lodash.rangeRight = rangeRight;
    lodash.rearg = rearg;
    lodash.reject = reject;
    lodash.remove = remove;
    lodash.rest = rest;
    lodash.reverse = reverse;
    lodash.sampleSize = sampleSize;
    lodash.set = set;
    lodash.setWith = setWith;
    lodash.shuffle = shuffle;
    lodash.slice = slice;
    lodash.sortBy = sortBy;
    lodash.sortedUniq = sortedUniq;
    lodash.sortedUniqBy = sortedUniqBy;
    lodash.split = split;
    lodash.spread = spread;
    lodash.tail = tail;
    lodash.take = take;
    lodash.takeRight = takeRight;
    lodash.takeRightWhile = takeRightWhile;
    lodash.takeWhile = takeWhile;
    lodash.tap = tap;
    lodash.throttle = throttle;
    lodash.thru = thru;
    lodash.toArray = toArray;
    lodash.toPairs = toPairs;
    lodash.toPairsIn = toPairsIn;
    lodash.toPath = toPath;
    lodash.toPlainObject = toPlainObject;
    lodash.transform = transform;
    lodash.unary = unary;
    lodash.union = union;
    lodash.unionBy = unionBy;
    lodash.unionWith = unionWith;
    lodash.uniq = uniq;
    lodash.uniqBy = uniqBy;
    lodash.uniqWith = uniqWith;
    lodash.unset = unset;
    lodash.unzip = unzip;
    lodash.unzipWith = unzipWith;
    lodash.update = update;
    lodash.updateWith = updateWith;
    lodash.values = values;
    lodash.valuesIn = valuesIn;
    lodash.without = without;
    lodash.words = words;
    lodash.wrap = wrap;
    lodash.xor = xor;
    lodash.xorBy = xorBy;
    lodash.xorWith = xorWith;
    lodash.zip = zip;
    lodash.zipObject = zipObject;
    lodash.zipObjectDeep = zipObjectDeep;
    lodash.zipWith = zipWith;

    // Add aliases.
    lodash.entries = toPairs;
    lodash.entriesIn = toPairsIn;
    lodash.extend = assignIn;
    lodash.extendWith = assignInWith;

    // Add methods to `lodash.prototype`.
    mixin(lodash, lodash);

    /*------------------------------------------------------------------------*/

    // Add methods that return unwrapped values in chain sequences.
    lodash.add = add;
    lodash.attempt = attempt;
    lodash.camelCase = camelCase;
    lodash.capitalize = capitalize;
    lodash.ceil = ceil;
    lodash.clamp = clamp;
    lodash.clone = clone;
    lodash.cloneDeep = cloneDeep;
    lodash.cloneDeepWith = cloneDeepWith;
    lodash.cloneWith = cloneWith;
    lodash.conformsTo = conformsTo;
    lodash.deburr = deburr;
    lodash.defaultTo = defaultTo;
    lodash.divide = divide;
    lodash.endsWith = endsWith;
    lodash.eq = eq;
    lodash.escape = escape;
    lodash.escapeRegExp = escapeRegExp;
    lodash.every = every;
    lodash.find = find;
    lodash.findIndex = findIndex;
    lodash.findKey = findKey;
    lodash.findLast = findLast;
    lodash.findLastIndex = findLastIndex;
    lodash.findLastKey = findLastKey;
    lodash.floor = floor;
    lodash.forEach = forEach;
    lodash.forEachRight = forEachRight;
    lodash.forIn = forIn;
    lodash.forInRight = forInRight;
    lodash.forOwn = forOwn;
    lodash.forOwnRight = forOwnRight;
    lodash.get = get;
    lodash.gt = gt;
    lodash.gte = gte;
    lodash.has = has;
    lodash.hasIn = hasIn;
    lodash.head = head;
    lodash.identity = identity;
    lodash.includes = includes;
    lodash.indexOf = indexOf;
    lodash.inRange = inRange;
    lodash.invoke = invoke;
    lodash.isArguments = isArguments;
    lodash.isArray = isArray;
    lodash.isArrayBuffer = isArrayBuffer;
    lodash.isArrayLike = isArrayLike;
    lodash.isArrayLikeObject = isArrayLikeObject;
    lodash.isBoolean = isBoolean;
    lodash.isBuffer = isBuffer;
    lodash.isDate = isDate;
    lodash.isElement = isElement;
    lodash.isEmpty = isEmpty;
    lodash.isEqual = isEqual;
    lodash.isEqualWith = isEqualWith;
    lodash.isError = isError;
    lodash.isFinite = isFinite;
    lodash.isFunction = isFunction;
    lodash.isInteger = isInteger;
    lodash.isLength = isLength;
    lodash.isMap = isMap;
    lodash.isMatch = isMatch;
    lodash.isMatchWith = isMatchWith;
    lodash.isNaN = isNaN;
    lodash.isNative = isNative;
    lodash.isNil = isNil;
    lodash.isNull = isNull;
    lodash.isNumber = isNumber;
    lodash.isObject = isObject;
    lodash.isObjectLike = isObjectLike;
    lodash.isPlainObject = isPlainObject;
    lodash.isRegExp = isRegExp;
    lodash.isSafeInteger = isSafeInteger;
    lodash.isSet = isSet;
    lodash.isString = isString;
    lodash.isSymbol = isSymbol;
    lodash.isTypedArray = isTypedArray;
    lodash.isUndefined = isUndefined;
    lodash.isWeakMap = isWeakMap;
    lodash.isWeakSet = isWeakSet;
    lodash.join = join;
    lodash.kebabCase = kebabCase;
    lodash.last = last;
    lodash.lastIndexOf = lastIndexOf;
    lodash.lowerCase = lowerCase;
    lodash.lowerFirst = lowerFirst;
    lodash.lt = lt;
    lodash.lte = lte;
    lodash.max = max;
    lodash.maxBy = maxBy;
    lodash.mean = mean;
    lodash.meanBy = meanBy;
    lodash.min = min;
    lodash.minBy = minBy;
    lodash.stubArray = stubArray;
    lodash.stubFalse = stubFalse;
    lodash.stubObject = stubObject;
    lodash.stubString = stubString;
    lodash.stubTrue = stubTrue;
    lodash.multiply = multiply;
    lodash.nth = nth;
    lodash.noConflict = noConflict;
    lodash.noop = noop;
    lodash.now = now;
    lodash.pad = pad;
    lodash.padEnd = padEnd;
    lodash.padStart = padStart;
    lodash.parseInt = parseInt;
    lodash.random = random;
    lodash.reduce = reduce;
    lodash.reduceRight = reduceRight;
    lodash.repeat = repeat;
    lodash.replace = replace;
    lodash.result = result;
    lodash.round = round;
    lodash.runInContext = runInContext;
    lodash.sample = sample;
    lodash.size = size;
    lodash.snakeCase = snakeCase;
    lodash.some = some;
    lodash.sortedIndex = sortedIndex;
    lodash.sortedIndexBy = sortedIndexBy;
    lodash.sortedIndexOf = sortedIndexOf;
    lodash.sortedLastIndex = sortedLastIndex;
    lodash.sortedLastIndexBy = sortedLastIndexBy;
    lodash.sortedLastIndexOf = sortedLastIndexOf;
    lodash.startCase = startCase;
    lodash.startsWith = startsWith;
    lodash.subtract = subtract;
    lodash.sum = sum;
    lodash.sumBy = sumBy;
    lodash.template = template;
    lodash.times = times;
    lodash.toFinite = toFinite;
    lodash.toInteger = toInteger;
    lodash.toLength = toLength;
    lodash.toLower = toLower;
    lodash.toNumber = toNumber;
    lodash.toSafeInteger = toSafeInteger;
    lodash.toString = toString;
    lodash.toUpper = toUpper;
    lodash.trim = trim;
    lodash.trimEnd = trimEnd;
    lodash.trimStart = trimStart;
    lodash.truncate = truncate;
    lodash.unescape = unescape;
    lodash.uniqueId = uniqueId;
    lodash.upperCase = upperCase;
    lodash.upperFirst = upperFirst;

    // Add aliases.
    lodash.each = forEach;
    lodash.eachRight = forEachRight;
    lodash.first = head;
    mixin(lodash, function () {
      var source = {};
      baseForOwn(lodash, function (func, methodName) {
        if (!hasOwnProperty.call(lodash.prototype, methodName)) {
          source[methodName] = func;
        }
      });
      return source;
    }(), {
      'chain': false
    });

    /*------------------------------------------------------------------------*/

    /**
     * The semantic version number.
     *
     * @static
     * @memberOf _
     * @type {string}
     */
    lodash.VERSION = VERSION;

    // Assign default placeholders.
    arrayEach(['bind', 'bindKey', 'curry', 'curryRight', 'partial', 'partialRight'], function (methodName) {
      lodash[methodName].placeholder = lodash;
    });

    // Add `LazyWrapper` methods for `_.drop` and `_.take` variants.
    arrayEach(['drop', 'take'], function (methodName, index) {
      LazyWrapper.prototype[methodName] = function (n) {
        n = n === undefined ? 1 : nativeMax(toInteger(n), 0);
        var result = this.__filtered__ && !index ? new LazyWrapper(this) : this.clone();
        if (result.__filtered__) {
          result.__takeCount__ = nativeMin(n, result.__takeCount__);
        } else {
          result.__views__.push({
            'size': nativeMin(n, MAX_ARRAY_LENGTH),
            'type': methodName + (result.__dir__ < 0 ? 'Right' : '')
          });
        }
        return result;
      };
      LazyWrapper.prototype[methodName + 'Right'] = function (n) {
        return this.reverse()[methodName](n).reverse();
      };
    });

    // Add `LazyWrapper` methods that accept an `iteratee` value.
    arrayEach(['filter', 'map', 'takeWhile'], function (methodName, index) {
      var type = index + 1,
        isFilter = type == LAZY_FILTER_FLAG || type == LAZY_WHILE_FLAG;
      LazyWrapper.prototype[methodName] = function (iteratee) {
        var result = this.clone();
        result.__iteratees__.push({
          'iteratee': getIteratee(iteratee, 3),
          'type': type
        });
        result.__filtered__ = result.__filtered__ || isFilter;
        return result;
      };
    });

    // Add `LazyWrapper` methods for `_.head` and `_.last`.
    arrayEach(['head', 'last'], function (methodName, index) {
      var takeName = 'take' + (index ? 'Right' : '');
      LazyWrapper.prototype[methodName] = function () {
        return this[takeName](1).value()[0];
      };
    });

    // Add `LazyWrapper` methods for `_.initial` and `_.tail`.
    arrayEach(['initial', 'tail'], function (methodName, index) {
      var dropName = 'drop' + (index ? '' : 'Right');
      LazyWrapper.prototype[methodName] = function () {
        return this.__filtered__ ? new LazyWrapper(this) : this[dropName](1);
      };
    });
    LazyWrapper.prototype.compact = function () {
      return this.filter(identity);
    };
    LazyWrapper.prototype.find = function (predicate) {
      return this.filter(predicate).head();
    };
    LazyWrapper.prototype.findLast = function (predicate) {
      return this.reverse().find(predicate);
    };
    LazyWrapper.prototype.invokeMap = baseRest(function (path, args) {
      if (typeof path == 'function') {
        return new LazyWrapper(this);
      }
      return this.map(function (value) {
        return baseInvoke(value, path, args);
      });
    });
    LazyWrapper.prototype.reject = function (predicate) {
      return this.filter(negate(getIteratee(predicate)));
    };
    LazyWrapper.prototype.slice = function (start, end) {
      start = toInteger(start);
      var result = this;
      if (result.__filtered__ && (start > 0 || end < 0)) {
        return new LazyWrapper(result);
      }
      if (start < 0) {
        result = result.takeRight(-start);
      } else if (start) {
        result = result.drop(start);
      }
      if (end !== undefined) {
        end = toInteger(end);
        result = end < 0 ? result.dropRight(-end) : result.take(end - start);
      }
      return result;
    };
    LazyWrapper.prototype.takeRightWhile = function (predicate) {
      return this.reverse().takeWhile(predicate).reverse();
    };
    LazyWrapper.prototype.toArray = function () {
      return this.take(MAX_ARRAY_LENGTH);
    };

    // Add `LazyWrapper` methods to `lodash.prototype`.
    baseForOwn(LazyWrapper.prototype, function (func, methodName) {
      var checkIteratee = /^(?:filter|find|map|reject)|While$/.test(methodName),
        isTaker = /^(?:head|last)$/.test(methodName),
        lodashFunc = lodash[isTaker ? 'take' + (methodName == 'last' ? 'Right' : '') : methodName],
        retUnwrapped = isTaker || /^find/.test(methodName);
      if (!lodashFunc) {
        return;
      }
      lodash.prototype[methodName] = function () {
        var value = this.__wrapped__,
          args = isTaker ? [1] : arguments,
          isLazy = value instanceof LazyWrapper,
          iteratee = args[0],
          useLazy = isLazy || isArray(value);
        var interceptor = function interceptor(value) {
          var result = lodashFunc.apply(lodash, arrayPush([value], args));
          return isTaker && chainAll ? result[0] : result;
        };
        if (useLazy && checkIteratee && typeof iteratee == 'function' && iteratee.length != 1) {
          // Avoid lazy use if the iteratee has a "length" value other than `1`.
          isLazy = useLazy = false;
        }
        var chainAll = this.__chain__,
          isHybrid = !!this.__actions__.length,
          isUnwrapped = retUnwrapped && !chainAll,
          onlyLazy = isLazy && !isHybrid;
        if (!retUnwrapped && useLazy) {
          value = onlyLazy ? value : new LazyWrapper(this);
          var result = func.apply(value, args);
          result.__actions__.push({
            'func': thru,
            'args': [interceptor],
            'thisArg': undefined
          });
          return new LodashWrapper(result, chainAll);
        }
        if (isUnwrapped && onlyLazy) {
          return func.apply(this, args);
        }
        result = this.thru(interceptor);
        return isUnwrapped ? isTaker ? result.value()[0] : result.value() : result;
      };
    });

    // Add `Array` methods to `lodash.prototype`.
    arrayEach(['pop', 'push', 'shift', 'sort', 'splice', 'unshift'], function (methodName) {
      var func = arrayProto[methodName],
        chainName = /^(?:push|sort|unshift)$/.test(methodName) ? 'tap' : 'thru',
        retUnwrapped = /^(?:pop|shift)$/.test(methodName);
      lodash.prototype[methodName] = function () {
        var args = arguments;
        if (retUnwrapped && !this.__chain__) {
          var value = this.value();
          return func.apply(isArray(value) ? value : [], args);
        }
        return this[chainName](function (value) {
          return func.apply(isArray(value) ? value : [], args);
        });
      };
    });

    // Map minified method names to their real names.
    baseForOwn(LazyWrapper.prototype, function (func, methodName) {
      var lodashFunc = lodash[methodName];
      if (lodashFunc) {
        var key = lodashFunc.name + '';
        if (!hasOwnProperty.call(realNames, key)) {
          realNames[key] = [];
        }
        realNames[key].push({
          'name': methodName,
          'func': lodashFunc
        });
      }
    });
    realNames[createHybrid(undefined, WRAP_BIND_KEY_FLAG).name] = [{
      'name': 'wrapper',
      'func': undefined
    }];

    // Add methods to `LazyWrapper`.
    LazyWrapper.prototype.clone = lazyClone;
    LazyWrapper.prototype.reverse = lazyReverse;
    LazyWrapper.prototype.value = lazyValue;

    // Add chain sequence methods to the `lodash` wrapper.
    lodash.prototype.at = wrapperAt;
    lodash.prototype.chain = wrapperChain;
    lodash.prototype.commit = wrapperCommit;
    lodash.prototype.next = wrapperNext;
    lodash.prototype.plant = wrapperPlant;
    lodash.prototype.reverse = wrapperReverse;
    lodash.prototype.toJSON = lodash.prototype.valueOf = lodash.prototype.value = wrapperValue;

    // Add lazy aliases.
    lodash.prototype.first = lodash.prototype.head;
    if (symIterator) {
      lodash.prototype[symIterator] = wrapperToIterator;
    }
    return lodash;
  };

  /*--------------------------------------------------------------------------*/

  // Export lodash.
  var _ = runInContext();

  // Some AMD build optimizers, like r.js, check for condition patterns like:
  if (typeof define == 'function' && _typeof(define.amd) == 'object' && define.amd) {
    // Expose Lodash on the global object to prevent errors when Lodash is
    // loaded by a script tag in the presence of an AMD loader.
    // See http://requirejs.org/docs/errors.html#mismatch for more details.
    // Use `_.noConflict` to remove Lodash from the global object.
    root._ = _;

    // Define as an anonymous module so, through path mapping, it can be
    // referenced as the "underscore" module.
    define(function () {
      return _;
    });
  }
  // Check for `exports` after `define` in case a build optimizer adds it.
  else if (freeModule) {
    // Export for Node.js.
    (freeModule.exports = _)._ = _;
    // Export for CommonJS support.
    freeExports._ = _;
  } else {
    // Export to the global object.
    root._ = _;
  }
}).call(this);

/*!
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function () {
  'use strict';

  /** Global Methods **/
  /***************************************************************************/

  /**
   * Create the global controller. All contained methods and properties apply
   * to all sounds that are currently playing or will be in the future.
   */
  var HowlerGlobal = function HowlerGlobal() {
    this.init();
  };
  HowlerGlobal.prototype = {
    /**
     * Initialize the global Howler object.
     * @return {Howler}
     */
    init: function init() {
      var self = this || Howler;

      // Create a global ID counter.
      self._counter = 1000;

      // Pool of unlocked HTML5 Audio objects.
      self._html5AudioPool = [];
      self.html5PoolSize = 10;

      // Internal properties.
      self._codecs = {};
      self._howls = [];
      self._muted = false;
      self._volume = 1;
      self._canPlayEvent = 'canplaythrough';
      self._navigator = typeof window !== 'undefined' && window.navigator ? window.navigator : null;

      // Public properties.
      self.masterGain = null;
      self.noAudio = false;
      self.usingWebAudio = true;
      self.autoSuspend = true;
      self.ctx = null;

      // Set to false to disable the auto audio unlocker.
      self.autoUnlock = true;

      // Setup the various state values for global tracking.
      self._setup();
      return self;
    },
    /**
     * Get/set the global volume for all sounds.
     * @param  {Float} vol Volume from 0.0 to 1.0.
     * @return {Howler/Float}     Returns self or current volume.
     */
    volume: function volume(vol) {
      var self = this || Howler;
      vol = parseFloat(vol);

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }
      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        self._volume = vol;

        // Don't update any of the nodes if we are muted.
        if (self._muted) {
          return self;
        }

        // When using Web Audio, we just need to adjust the master gain.
        if (self.usingWebAudio) {
          self.masterGain.gain.setValueAtTime(vol, Howler.ctx.currentTime);
        }

        // Loop through and change volume for all HTML5 audio nodes.
        for (var i = 0; i < self._howls.length; i++) {
          if (!self._howls[i]._webAudio) {
            // Get all of the sounds in this Howl group.
            var ids = self._howls[i]._getSoundIds();

            // Loop through all sounds and change the volumes.
            for (var j = 0; j < ids.length; j++) {
              var sound = self._howls[i]._soundById(ids[j]);
              if (sound && sound._node) {
                sound._node.volume = sound._volume * vol;
              }
            }
          }
        }
        return self;
      }
      return self._volume;
    },
    /**
     * Handle muting and unmuting globally.
     * @param  {Boolean} muted Is muted or not.
     */
    mute: function mute(muted) {
      var self = this || Howler;

      // If we don't have an AudioContext created yet, run the setup.
      if (!self.ctx) {
        setupAudioContext();
      }
      self._muted = muted;

      // With Web Audio, we just need to mute the master gain.
      if (self.usingWebAudio) {
        self.masterGain.gain.setValueAtTime(muted ? 0 : self._volume, Howler.ctx.currentTime);
      }

      // Loop through and mute all HTML5 Audio nodes.
      for (var i = 0; i < self._howls.length; i++) {
        if (!self._howls[i]._webAudio) {
          // Get all of the sounds in this Howl group.
          var ids = self._howls[i]._getSoundIds();

          // Loop through all sounds and mark the audio node as muted.
          for (var j = 0; j < ids.length; j++) {
            var sound = self._howls[i]._soundById(ids[j]);
            if (sound && sound._node) {
              sound._node.muted = muted ? true : sound._muted;
            }
          }
        }
      }
      return self;
    },
    /**
     * Handle stopping all sounds globally.
     */
    stop: function stop() {
      var self = this || Howler;

      // Loop through all Howls and stop them.
      for (var i = 0; i < self._howls.length; i++) {
        self._howls[i].stop();
      }
      return self;
    },
    /**
     * Unload and destroy all currently loaded Howl objects.
     * @return {Howler}
     */
    unload: function unload() {
      var self = this || Howler;
      for (var i = self._howls.length - 1; i >= 0; i--) {
        self._howls[i].unload();
      }

      // Create a new AudioContext to make sure it is fully reset.
      if (self.usingWebAudio && self.ctx && typeof self.ctx.close !== 'undefined') {
        self.ctx.close();
        self.ctx = null;
        setupAudioContext();
      }
      return self;
    },
    /**
     * Check for codec support of specific extension.
     * @param  {String} ext Audio file extention.
     * @return {Boolean}
     */
    codecs: function codecs(ext) {
      return (this || Howler)._codecs[ext.replace(/^x-/, '')];
    },
    /**
     * Setup various state values for global tracking.
     * @return {Howler}
     */
    _setup: function _setup() {
      var self = this || Howler;

      // Keeps track of the suspend/resume state of the AudioContext.
      self.state = self.ctx ? self.ctx.state || 'suspended' : 'suspended';

      // Automatically begin the 30-second suspend process
      self._autoSuspend();

      // Check if audio is available.
      if (!self.usingWebAudio) {
        // No audio is available on this system if noAudio is set to true.
        if (typeof Audio !== 'undefined') {
          try {
            var test = new Audio();

            // Check if the canplaythrough event is available.
            if (typeof test.oncanplaythrough === 'undefined') {
              self._canPlayEvent = 'canplay';
            }
          } catch (e) {
            self.noAudio = true;
          }
        } else {
          self.noAudio = true;
        }
      }

      // Test to make sure audio isn't disabled in Internet Explorer.
      try {
        var test = new Audio();
        if (test.muted) {
          self.noAudio = true;
        }
      } catch (e) {}

      // Check for supported codecs.
      if (!self.noAudio) {
        self._setupCodecs();
      }
      return self;
    },
    /**
     * Check for browser support for various codecs and cache the results.
     * @return {Howler}
     */
    _setupCodecs: function _setupCodecs() {
      var self = this || Howler;
      var audioTest = null;

      // Must wrap in a try/catch because IE11 in server mode throws an error.
      try {
        audioTest = typeof Audio !== 'undefined' ? new Audio() : null;
      } catch (err) {
        return self;
      }
      if (!audioTest || typeof audioTest.canPlayType !== 'function') {
        return self;
      }
      var mpegTest = audioTest.canPlayType('audio/mpeg;').replace(/^no$/, '');

      // Opera version <33 has mixed MP3 support, so we need to check for and block it.
      var ua = self._navigator ? self._navigator.userAgent : '';
      var checkOpera = ua.match(/OPR\/(\d+)/g);
      var isOldOpera = checkOpera && parseInt(checkOpera[0].split('/')[1], 10) < 33;
      var checkSafari = ua.indexOf('Safari') !== -1 && ua.indexOf('Chrome') === -1;
      var safariVersion = ua.match(/Version\/(.*?) /);
      var isOldSafari = checkSafari && safariVersion && parseInt(safariVersion[1], 10) < 15;
      self._codecs = {
        mp3: !!(!isOldOpera && (mpegTest || audioTest.canPlayType('audio/mp3;').replace(/^no$/, ''))),
        mpeg: !!mpegTest,
        opus: !!audioTest.canPlayType('audio/ogg; codecs="opus"').replace(/^no$/, ''),
        ogg: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        oga: !!audioTest.canPlayType('audio/ogg; codecs="vorbis"').replace(/^no$/, ''),
        wav: !!(audioTest.canPlayType('audio/wav; codecs="1"') || audioTest.canPlayType('audio/wav')).replace(/^no$/, ''),
        aac: !!audioTest.canPlayType('audio/aac;').replace(/^no$/, ''),
        caf: !!audioTest.canPlayType('audio/x-caf;').replace(/^no$/, ''),
        m4a: !!(audioTest.canPlayType('audio/x-m4a;') || audioTest.canPlayType('audio/m4a;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        m4b: !!(audioTest.canPlayType('audio/x-m4b;') || audioTest.canPlayType('audio/m4b;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        mp4: !!(audioTest.canPlayType('audio/x-mp4;') || audioTest.canPlayType('audio/mp4;') || audioTest.canPlayType('audio/aac;')).replace(/^no$/, ''),
        weba: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
        webm: !!(!isOldSafari && audioTest.canPlayType('audio/webm; codecs="vorbis"').replace(/^no$/, '')),
        dolby: !!audioTest.canPlayType('audio/mp4; codecs="ec-3"').replace(/^no$/, ''),
        flac: !!(audioTest.canPlayType('audio/x-flac;') || audioTest.canPlayType('audio/flac;')).replace(/^no$/, '')
      };
      return self;
    },
    /**
     * Some browsers/devices will only allow audio to be played after a user interaction.
     * Attempt to automatically unlock audio on the first user interaction.
     * Concept from: http://paulbakaus.com/tutorials/html5/web-audio-on-ios/
     * @return {Howler}
     */
    _unlockAudio: function _unlockAudio() {
      var self = this || Howler;

      // Only run this if Web Audio is supported and it hasn't already been unlocked.
      if (self._audioUnlocked || !self.ctx) {
        return;
      }
      self._audioUnlocked = false;
      self.autoUnlock = false;

      // Some mobile devices/platforms have distortion issues when opening/closing tabs and/or web views.
      // Bugs in the browser (especially Mobile Safari) can cause the sampleRate to change from 44100 to 48000.
      // By calling Howler.unload(), we create a new AudioContext with the correct sampleRate.
      if (!self._mobileUnloaded && self.ctx.sampleRate !== 44100) {
        self._mobileUnloaded = true;
        self.unload();
      }

      // Scratch buffer for enabling iOS to dispose of web audio buffers correctly, as per:
      // http://stackoverflow.com/questions/24119684
      self._scratchBuffer = self.ctx.createBuffer(1, 1, 22050);

      // Call this method on touch start to create and play a buffer,
      // then check if the audio actually played to determine if
      // audio has now been unlocked on iOS, Android, etc.
      var _unlock = function unlock(e) {
        // Create a pool of unlocked HTML5 Audio objects that can
        // be used for playing sounds without user interaction. HTML5
        // Audio objects must be individually unlocked, as opposed
        // to the WebAudio API which only needs a single activation.
        // This must occur before WebAudio setup or the source.onended
        // event will not fire.
        while (self._html5AudioPool.length < self.html5PoolSize) {
          try {
            var audioNode = new Audio();

            // Mark this Audio object as unlocked to ensure it can get returned
            // to the unlocked pool when released.
            audioNode._unlocked = true;

            // Add the audio node to the pool.
            self._releaseHtml5Audio(audioNode);
          } catch (e) {
            self.noAudio = true;
            break;
          }
        }

        // Loop through any assigned audio nodes and unlock them.
        for (var i = 0; i < self._howls.length; i++) {
          if (!self._howls[i]._webAudio) {
            // Get all of the sounds in this Howl group.
            var ids = self._howls[i]._getSoundIds();

            // Loop through all sounds and unlock the audio nodes.
            for (var j = 0; j < ids.length; j++) {
              var sound = self._howls[i]._soundById(ids[j]);
              if (sound && sound._node && !sound._node._unlocked) {
                sound._node._unlocked = true;
                sound._node.load();
              }
            }
          }
        }

        // Fix Android can not play in suspend state.
        self._autoResume();

        // Create an empty buffer.
        var source = self.ctx.createBufferSource();
        source.buffer = self._scratchBuffer;
        source.connect(self.ctx.destination);

        // Play the empty buffer.
        if (typeof source.start === 'undefined') {
          source.noteOn(0);
        } else {
          source.start(0);
        }

        // Calling resume() on a stack initiated by user gesture is what actually unlocks the audio on Android Chrome >= 55.
        if (typeof self.ctx.resume === 'function') {
          self.ctx.resume();
        }

        // Setup a timeout to check that we are unlocked on the next event loop.
        source.onended = function () {
          source.disconnect(0);

          // Update the unlocked state and prevent this check from happening again.
          self._audioUnlocked = true;

          // Remove the touch start listener.
          document.removeEventListener('touchstart', _unlock, true);
          document.removeEventListener('touchend', _unlock, true);
          document.removeEventListener('click', _unlock, true);
          document.removeEventListener('keydown', _unlock, true);

          // Let all sounds know that audio has been unlocked.
          for (var i = 0; i < self._howls.length; i++) {
            self._howls[i]._emit('unlock');
          }
        };
      };

      // Setup a touch start listener to attempt an unlock in.
      document.addEventListener('touchstart', _unlock, true);
      document.addEventListener('touchend', _unlock, true);
      document.addEventListener('click', _unlock, true);
      document.addEventListener('keydown', _unlock, true);
      return self;
    },
    /**
     * Get an unlocked HTML5 Audio object from the pool. If none are left,
     * return a new Audio object and throw a warning.
     * @return {Audio} HTML5 Audio object.
     */
    _obtainHtml5Audio: function _obtainHtml5Audio() {
      var self = this || Howler;

      // Return the next object from the pool if one exists.
      if (self._html5AudioPool.length) {
        return self._html5AudioPool.pop();
      }

      //.Check if the audio is locked and throw a warning.
      var testPlay = new Audio().play();
      if (testPlay && typeof Promise !== 'undefined' && (testPlay instanceof Promise || typeof testPlay.then === 'function')) {
        testPlay["catch"](function () {
          console.warn('HTML5 Audio pool exhausted, returning potentially locked audio object.');
        });
      }
      return new Audio();
    },
    /**
     * Return an activated HTML5 Audio object to the pool.
     * @return {Howler}
     */
    _releaseHtml5Audio: function _releaseHtml5Audio(audio) {
      var self = this || Howler;

      // Don't add audio to the pool if we don't know if it has been unlocked.
      if (audio._unlocked) {
        self._html5AudioPool.push(audio);
      }
      return self;
    },
    /**
     * Automatically suspend the Web Audio AudioContext after no sound has played for 30 seconds.
     * This saves processing/energy and fixes various browser-specific bugs with audio getting stuck.
     * @return {Howler}
     */
    _autoSuspend: function _autoSuspend() {
      var self = this;
      if (!self.autoSuspend || !self.ctx || typeof self.ctx.suspend === 'undefined' || !Howler.usingWebAudio) {
        return;
      }

      // Check if any sounds are playing.
      for (var i = 0; i < self._howls.length; i++) {
        if (self._howls[i]._webAudio) {
          for (var j = 0; j < self._howls[i]._sounds.length; j++) {
            if (!self._howls[i]._sounds[j]._paused) {
              return self;
            }
          }
        }
      }
      if (self._suspendTimer) {
        clearTimeout(self._suspendTimer);
      }

      // If no sound has played after 30 seconds, suspend the context.
      self._suspendTimer = setTimeout(function () {
        if (!self.autoSuspend) {
          return;
        }
        self._suspendTimer = null;
        self.state = 'suspending';

        // Handle updating the state of the audio context after suspending.
        var handleSuspension = function handleSuspension() {
          self.state = 'suspended';
          if (self._resumeAfterSuspend) {
            delete self._resumeAfterSuspend;
            self._autoResume();
          }
        };

        // Either the state gets suspended or it is interrupted.
        // Either way, we need to update the state to suspended.
        self.ctx.suspend().then(handleSuspension, handleSuspension);
      }, 30000);
      return self;
    },
    /**
     * Automatically resume the Web Audio AudioContext when a new sound is played.
     * @return {Howler}
     */
    _autoResume: function _autoResume() {
      var self = this;
      if (!self.ctx || typeof self.ctx.resume === 'undefined' || !Howler.usingWebAudio) {
        return;
      }
      if (self.state === 'running' && self.ctx.state !== 'interrupted' && self._suspendTimer) {
        clearTimeout(self._suspendTimer);
        self._suspendTimer = null;
      } else if (self.state === 'suspended' || self.state === 'running' && self.ctx.state === 'interrupted') {
        self.ctx.resume().then(function () {
          self.state = 'running';

          // Emit to all Howls that the audio has resumed.
          for (var i = 0; i < self._howls.length; i++) {
            self._howls[i]._emit('resume');
          }
        });
        if (self._suspendTimer) {
          clearTimeout(self._suspendTimer);
          self._suspendTimer = null;
        }
      } else if (self.state === 'suspending') {
        self._resumeAfterSuspend = true;
      }
      return self;
    }
  };

  // Setup the global audio controller.
  var Howler = new HowlerGlobal();

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Create an audio group controller.
   * @param {Object} o Passed in properties for this group.
   */
  var Howl = function Howl(o) {
    var self = this;

    // Throw an error if no source is provided.
    if (!o.src || o.src.length === 0) {
      console.error('An array of source files must be passed with any new Howl.');
      return;
    }
    self.init(o);
  };
  Howl.prototype = {
    /**
     * Initialize a new Howl group object.
     * @param  {Object} o Passed in properties for this group.
     * @return {Howl}
     */
    init: function init(o) {
      var self = this;

      // If we don't have an AudioContext created yet, run the setup.
      if (!Howler.ctx) {
        setupAudioContext();
      }

      // Setup user-defined default properties.
      self._autoplay = o.autoplay || false;
      self._format = typeof o.format !== 'string' ? o.format : [o.format];
      self._html5 = o.html5 || false;
      self._muted = o.mute || false;
      self._loop = o.loop || false;
      self._pool = o.pool || 5;
      self._preload = typeof o.preload === 'boolean' || o.preload === 'metadata' ? o.preload : true;
      self._rate = o.rate || 1;
      self._sprite = o.sprite || {};
      self._src = typeof o.src !== 'string' ? o.src : [o.src];
      self._volume = o.volume !== undefined ? o.volume : 1;
      self._xhr = {
        method: o.xhr && o.xhr.method ? o.xhr.method : 'GET',
        headers: o.xhr && o.xhr.headers ? o.xhr.headers : null,
        withCredentials: o.xhr && o.xhr.withCredentials ? o.xhr.withCredentials : false
      };

      // Setup all other default properties.
      self._duration = 0;
      self._state = 'unloaded';
      self._sounds = [];
      self._endTimers = {};
      self._queue = [];
      self._playLock = false;

      // Setup event listeners.
      self._onend = o.onend ? [{
        fn: o.onend
      }] : [];
      self._onfade = o.onfade ? [{
        fn: o.onfade
      }] : [];
      self._onload = o.onload ? [{
        fn: o.onload
      }] : [];
      self._onloaderror = o.onloaderror ? [{
        fn: o.onloaderror
      }] : [];
      self._onplayerror = o.onplayerror ? [{
        fn: o.onplayerror
      }] : [];
      self._onpause = o.onpause ? [{
        fn: o.onpause
      }] : [];
      self._onplay = o.onplay ? [{
        fn: o.onplay
      }] : [];
      self._onstop = o.onstop ? [{
        fn: o.onstop
      }] : [];
      self._onmute = o.onmute ? [{
        fn: o.onmute
      }] : [];
      self._onvolume = o.onvolume ? [{
        fn: o.onvolume
      }] : [];
      self._onrate = o.onrate ? [{
        fn: o.onrate
      }] : [];
      self._onseek = o.onseek ? [{
        fn: o.onseek
      }] : [];
      self._onunlock = o.onunlock ? [{
        fn: o.onunlock
      }] : [];
      self._onresume = [];

      // Web Audio or HTML5 Audio?
      self._webAudio = Howler.usingWebAudio && !self._html5;

      // Automatically try to enable audio.
      if (typeof Howler.ctx !== 'undefined' && Howler.ctx && Howler.autoUnlock) {
        Howler._unlockAudio();
      }

      // Keep track of this Howl group in the global controller.
      Howler._howls.push(self);

      // If they selected autoplay, add a play event to the load queue.
      if (self._autoplay) {
        self._queue.push({
          event: 'play',
          action: function action() {
            self.play();
          }
        });
      }

      // Load the source file unless otherwise specified.
      if (self._preload && self._preload !== 'none') {
        self.load();
      }
      return self;
    },
    /**
     * Load the audio file.
     * @return {Howler}
     */
    load: function load() {
      var self = this;
      var url = null;

      // If no audio is available, quit immediately.
      if (Howler.noAudio) {
        self._emit('loaderror', null, 'No audio support.');
        return;
      }

      // Make sure our source is in an array.
      if (typeof self._src === 'string') {
        self._src = [self._src];
      }

      // Loop through the sources and pick the first one that is compatible.
      for (var i = 0; i < self._src.length; i++) {
        var ext, str;
        if (self._format && self._format[i]) {
          // If an extension was specified, use that instead.
          ext = self._format[i];
        } else {
          // Make sure the source is a string.
          str = self._src[i];
          if (typeof str !== 'string') {
            self._emit('loaderror', null, 'Non-string found in selected audio sources - ignoring.');
            continue;
          }

          // Extract the file extension from the URL or base64 data URI.
          ext = /^data:audio\/([^;,]+);/i.exec(str);
          if (!ext) {
            ext = /\.([^.]+)$/.exec(str.split('?', 1)[0]);
          }
          if (ext) {
            ext = ext[1].toLowerCase();
          }
        }

        // Log a warning if no extension was found.
        if (!ext) {
          console.warn('No file extension was found. Consider using the "format" property or specify an extension.');
        }

        // Check if this extension is available.
        if (ext && Howler.codecs(ext)) {
          url = self._src[i];
          break;
        }
      }
      if (!url) {
        self._emit('loaderror', null, 'No codec support for selected audio sources.');
        return;
      }
      self._src = url;
      self._state = 'loading';

      // If the hosting page is HTTPS and the source isn't,
      // drop down to HTML5 Audio to avoid Mixed Content errors.
      if (window.location.protocol === 'https:' && url.slice(0, 5) === 'http:') {
        self._html5 = true;
        self._webAudio = false;
      }

      // Create a new sound object and add it to the pool.
      new Sound(self);

      // Load and decode the audio data for playback.
      if (self._webAudio) {
        loadBuffer(self);
      }
      return self;
    },
    /**
     * Play a sound or resume previous playback.
     * @param  {String/Number} sprite   Sprite name for sprite playback or sound id to continue previous.
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Number}          Sound ID.
     */
    play: function play(sprite, internal) {
      var self = this;
      var id = null;

      // Determine if a sprite, sound id or nothing was passed
      if (typeof sprite === 'number') {
        id = sprite;
        sprite = null;
      } else if (typeof sprite === 'string' && self._state === 'loaded' && !self._sprite[sprite]) {
        // If the passed sprite doesn't exist, do nothing.
        return null;
      } else if (typeof sprite === 'undefined') {
        // Use the default sound sprite (plays the full audio length).
        sprite = '__default';

        // Check if there is a single paused sound that isn't ended.
        // If there is, play that sound. If not, continue as usual.
        if (!self._playLock) {
          var num = 0;
          for (var i = 0; i < self._sounds.length; i++) {
            if (self._sounds[i]._paused && !self._sounds[i]._ended) {
              num++;
              id = self._sounds[i]._id;
            }
          }
          if (num === 1) {
            sprite = null;
          } else {
            id = null;
          }
        }
      }

      // Get the selected node, or get one from the pool.
      var sound = id ? self._soundById(id) : self._inactiveSound();

      // If the sound doesn't exist, do nothing.
      if (!sound) {
        return null;
      }

      // Select the sprite definition.
      if (id && !sprite) {
        sprite = sound._sprite || '__default';
      }

      // If the sound hasn't loaded, we must wait to get the audio's duration.
      // We also need to wait to make sure we don't run into race conditions with
      // the order of function calls.
      if (self._state !== 'loaded') {
        // Set the sprite value on this sound.
        sound._sprite = sprite;

        // Mark this sound as not ended in case another sound is played before this one loads.
        sound._ended = false;

        // Add the sound to the queue to be played on load.
        var soundId = sound._id;
        self._queue.push({
          event: 'play',
          action: function action() {
            self.play(soundId);
          }
        });
        return soundId;
      }

      // Don't play the sound if an id was passed and it is already playing.
      if (id && !sound._paused) {
        // Trigger the play event, in order to keep iterating through queue.
        if (!internal) {
          self._loadQueue('play');
        }
        return sound._id;
      }

      // Make sure the AudioContext isn't suspended, and resume it if it is.
      if (self._webAudio) {
        Howler._autoResume();
      }

      // Determine how long to play for and where to start playing.
      var seek = Math.max(0, sound._seek > 0 ? sound._seek : self._sprite[sprite][0] / 1000);
      var duration = Math.max(0, (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000 - seek);
      var timeout = duration * 1000 / Math.abs(sound._rate);
      var start = self._sprite[sprite][0] / 1000;
      var stop = (self._sprite[sprite][0] + self._sprite[sprite][1]) / 1000;
      sound._sprite = sprite;

      // Mark the sound as ended instantly so that this async playback
      // doesn't get grabbed by another call to play while this one waits to start.
      sound._ended = false;

      // Update the parameters of the sound.
      var setParams = function setParams() {
        sound._paused = false;
        sound._seek = seek;
        sound._start = start;
        sound._stop = stop;
        sound._loop = !!(sound._loop || self._sprite[sprite][2]);
      };

      // End the sound instantly if seek is at the end.
      if (seek >= stop) {
        self._ended(sound);
        return;
      }

      // Begin the actual playback.
      var node = sound._node;
      if (self._webAudio) {
        // Fire this when the sound is ready to play to begin Web Audio playback.
        var playWebAudio = function playWebAudio() {
          self._playLock = false;
          setParams();
          self._refreshBuffer(sound);

          // Setup the playback params.
          var vol = sound._muted || self._muted ? 0 : sound._volume;
          node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
          sound._playStart = Howler.ctx.currentTime;

          // Play the sound using the supported method.
          if (typeof node.bufferSource.start === 'undefined') {
            sound._loop ? node.bufferSource.noteGrainOn(0, seek, 86400) : node.bufferSource.noteGrainOn(0, seek, duration);
          } else {
            sound._loop ? node.bufferSource.start(0, seek, 86400) : node.bufferSource.start(0, seek, duration);
          }

          // Start a new timer if none is present.
          if (timeout !== Infinity) {
            self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
          }
          if (!internal) {
            setTimeout(function () {
              self._emit('play', sound._id);
              self._loadQueue();
            }, 0);
          }
        };
        if (Howler.state === 'running' && Howler.ctx.state !== 'interrupted') {
          playWebAudio();
        } else {
          self._playLock = true;

          // Wait for the audio context to resume before playing.
          self.once('resume', playWebAudio);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      } else {
        // Fire this when the sound is ready to play to begin HTML5 Audio playback.
        var playHtml5 = function playHtml5() {
          node.currentTime = seek;
          node.muted = sound._muted || self._muted || Howler._muted || node.muted;
          node.volume = sound._volume * Howler.volume();
          node.playbackRate = sound._rate;

          // Some browsers will throw an error if this is called without user interaction.
          try {
            var play = node.play();

            // Support older browsers that don't support promises, and thus don't have this issue.
            if (play && typeof Promise !== 'undefined' && (play instanceof Promise || typeof play.then === 'function')) {
              // Implements a lock to prevent DOMException: The play() request was interrupted by a call to pause().
              self._playLock = true;

              // Set param values immediately.
              setParams();

              // Releases the lock and executes queued actions.
              play.then(function () {
                self._playLock = false;
                node._unlocked = true;
                if (!internal) {
                  self._emit('play', sound._id);
                } else {
                  self._loadQueue();
                }
              })["catch"](function () {
                self._playLock = false;
                self._emit('playerror', sound._id, 'Playback was unable to start. This is most commonly an issue ' + 'on mobile devices and Chrome where playback was not within a user interaction.');

                // Reset the ended and paused values.
                sound._ended = true;
                sound._paused = true;
              });
            } else if (!internal) {
              self._playLock = false;
              setParams();
              self._emit('play', sound._id);
            }

            // Setting rate before playing won't work in IE, so we set it again here.
            node.playbackRate = sound._rate;

            // If the node is still paused, then we can assume there was a playback issue.
            if (node.paused) {
              self._emit('playerror', sound._id, 'Playback was unable to start. This is most commonly an issue ' + 'on mobile devices and Chrome where playback was not within a user interaction.');
              return;
            }

            // Setup the end timer on sprites or listen for the ended event.
            if (sprite !== '__default' || sound._loop) {
              self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
            } else {
              self._endTimers[sound._id] = function () {
                // Fire ended on this audio node.
                self._ended(sound);

                // Clear this listener.
                node.removeEventListener('ended', self._endTimers[sound._id], false);
              };
              node.addEventListener('ended', self._endTimers[sound._id], false);
            }
          } catch (err) {
            self._emit('playerror', sound._id, err);
          }
        };

        // If this is streaming audio, make sure the src is set and load again.
        if (node.src === 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA') {
          node.src = self._src;
          node.load();
        }

        // Play immediately if ready, or wait for the 'canplaythrough'e vent.
        var loadedNoReadyState = window && window.ejecta || !node.readyState && Howler._navigator.isCocoonJS;
        if (node.readyState >= 3 || loadedNoReadyState) {
          playHtml5();
        } else {
          self._playLock = true;
          self._state = 'loading';
          var _listener = function listener() {
            self._state = 'loaded';

            // Begin playback.
            playHtml5();

            // Clear this listener.
            node.removeEventListener(Howler._canPlayEvent, _listener, false);
          };
          node.addEventListener(Howler._canPlayEvent, _listener, false);

          // Cancel the end timer.
          self._clearTimer(sound._id);
        }
      }
      return sound._id;
    },
    /**
     * Pause playback and save current position.
     * @param  {Number} id The sound ID (empty to pause all in group).
     * @return {Howl}
     */
    pause: function pause(id) {
      var self = this;

      // If the sound hasn't loaded or a play() promise is pending, add it to the load queue to pause when capable.
      if (self._state !== 'loaded' || self._playLock) {
        self._queue.push({
          event: 'pause',
          action: function action() {
            self.pause(id);
          }
        });
        return self;
      }

      // If no id is passed, get all ID's to be paused.
      var ids = self._getSoundIds(id);
      for (var i = 0; i < ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);
        if (sound && !sound._paused) {
          // Reset the seek position.
          sound._seek = self.seek(ids[i]);
          sound._rateSeek = 0;
          sound._paused = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);
          if (sound._node) {
            if (self._webAudio) {
              // Make sure the sound has been created.
              if (!sound._node.bufferSource) {
                continue;
              }
              if (typeof sound._node.bufferSource.stop === 'undefined') {
                sound._node.bufferSource.noteOff(0);
              } else {
                sound._node.bufferSource.stop(0);
              }

              // Clean up the buffer source.
              self._cleanBuffer(sound._node);
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.pause();
            }
          }
        }

        // Fire the pause event, unless `true` is passed as the 2nd argument.
        if (!arguments[1]) {
          self._emit('pause', sound ? sound._id : null);
        }
      }
      return self;
    },
    /**
     * Stop playback and reset to start.
     * @param  {Number} id The sound ID (empty to stop all in group).
     * @param  {Boolean} internal Internal Use: true prevents event firing.
     * @return {Howl}
     */
    stop: function stop(id, internal) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to stop when capable.
      if (self._state !== 'loaded' || self._playLock) {
        self._queue.push({
          event: 'stop',
          action: function action() {
            self.stop(id);
          }
        });
        return self;
      }

      // If no id is passed, get all ID's to be stopped.
      var ids = self._getSoundIds(id);
      for (var i = 0; i < ids.length; i++) {
        // Clear the end timer.
        self._clearTimer(ids[i]);

        // Get the sound.
        var sound = self._soundById(ids[i]);
        if (sound) {
          // Reset the seek position.
          sound._seek = sound._start || 0;
          sound._rateSeek = 0;
          sound._paused = true;
          sound._ended = true;

          // Stop currently running fades.
          self._stopFade(ids[i]);
          if (sound._node) {
            if (self._webAudio) {
              // Make sure the sound's AudioBufferSourceNode has been created.
              if (sound._node.bufferSource) {
                if (typeof sound._node.bufferSource.stop === 'undefined') {
                  sound._node.bufferSource.noteOff(0);
                } else {
                  sound._node.bufferSource.stop(0);
                }

                // Clean up the buffer source.
                self._cleanBuffer(sound._node);
              }
            } else if (!isNaN(sound._node.duration) || sound._node.duration === Infinity) {
              sound._node.currentTime = sound._start || 0;
              sound._node.pause();

              // If this is a live stream, stop download once the audio is stopped.
              if (sound._node.duration === Infinity) {
                self._clearSound(sound._node);
              }
            }
          }
          if (!internal) {
            self._emit('stop', sound._id);
          }
        }
      }
      return self;
    },
    /**
     * Mute/unmute a single sound or all sounds in this Howl group.
     * @param  {Boolean} muted Set to true to mute and false to unmute.
     * @param  {Number} id    The sound ID to update (omit to mute/unmute all).
     * @return {Howl}
     */
    mute: function mute(muted, id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to mute when capable.
      if (self._state !== 'loaded' || self._playLock) {
        self._queue.push({
          event: 'mute',
          action: function action() {
            self.mute(muted, id);
          }
        });
        return self;
      }

      // If applying mute/unmute to all sounds, update the group's value.
      if (typeof id === 'undefined') {
        if (typeof muted === 'boolean') {
          self._muted = muted;
        } else {
          return self._muted;
        }
      }

      // If no id is passed, get all ID's to be muted.
      var ids = self._getSoundIds(id);
      for (var i = 0; i < ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);
        if (sound) {
          sound._muted = muted;

          // Cancel active fade and set the volume to the end value.
          if (sound._interval) {
            self._stopFade(sound._id);
          }
          if (self._webAudio && sound._node) {
            sound._node.gain.setValueAtTime(muted ? 0 : sound._volume, Howler.ctx.currentTime);
          } else if (sound._node) {
            sound._node.muted = Howler._muted ? true : muted;
          }
          self._emit('mute', sound._id);
        }
      }
      return self;
    },
    /**
     * Get/set the volume of this sound or of the Howl group. This method can optionally take 0, 1 or 2 arguments.
     *   volume() -> Returns the group's volume value.
     *   volume(id) -> Returns the sound id's current volume.
     *   volume(vol) -> Sets the volume of all sounds in this Howl group.
     *   volume(vol, id) -> Sets the volume of passed sound id.
     * @return {Howl/Number} Returns self or current volume.
     */
    volume: function volume() {
      var self = this;
      var args = arguments;
      var vol, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // Return the value of the groups' volume.
        return self._volume;
      } else if (args.length === 1 || args.length === 2 && typeof args[1] === 'undefined') {
        // First check if this is an ID, and if not, assume it is a new volume.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          vol = parseFloat(args[0]);
        }
      } else if (args.length >= 2) {
        vol = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the volume or return the current volume.
      var sound;
      if (typeof vol !== 'undefined' && vol >= 0 && vol <= 1) {
        // If the sound hasn't loaded, add it to the load queue to change volume when capable.
        if (self._state !== 'loaded' || self._playLock) {
          self._queue.push({
            event: 'volume',
            action: function action() {
              self.volume.apply(self, args);
            }
          });
          return self;
        }

        // Set the group volume.
        if (typeof id === 'undefined') {
          self._volume = vol;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i = 0; i < id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);
          if (sound) {
            sound._volume = vol;

            // Stop currently running fades.
            if (!args[2]) {
              self._stopFade(id[i]);
            }
            if (self._webAudio && sound._node && !sound._muted) {
              sound._node.gain.setValueAtTime(vol, Howler.ctx.currentTime);
            } else if (sound._node && !sound._muted) {
              sound._node.volume = vol * Howler.volume();
            }
            self._emit('volume', sound._id);
          }
        }
      } else {
        sound = id ? self._soundById(id) : self._sounds[0];
        return sound ? sound._volume : 0;
      }
      return self;
    },
    /**
     * Fade a currently playing sound between two volumes (if no id is passed, all sounds will fade).
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id (omit to fade all sounds).
     * @return {Howl}
     */
    fade: function fade(from, to, len, id) {
      var self = this;

      // If the sound hasn't loaded, add it to the load queue to fade when capable.
      if (self._state !== 'loaded' || self._playLock) {
        self._queue.push({
          event: 'fade',
          action: function action() {
            self.fade(from, to, len, id);
          }
        });
        return self;
      }

      // Make sure the to/from/len values are numbers.
      from = Math.min(Math.max(0, parseFloat(from)), 1);
      to = Math.min(Math.max(0, parseFloat(to)), 1);
      len = parseFloat(len);

      // Set the volume to the start position.
      self.volume(from, id);

      // Fade the volume of one or all sounds.
      var ids = self._getSoundIds(id);
      for (var i = 0; i < ids.length; i++) {
        // Get the sound.
        var sound = self._soundById(ids[i]);

        // Create a linear fade or fall back to timeouts with HTML5 Audio.
        if (sound) {
          // Stop the previous fade if no sprite is being used (otherwise, volume handles this).
          if (!id) {
            self._stopFade(ids[i]);
          }

          // If we are using Web Audio, let the native methods do the actual fade.
          if (self._webAudio && !sound._muted) {
            var currentTime = Howler.ctx.currentTime;
            var end = currentTime + len / 1000;
            sound._volume = from;
            sound._node.gain.setValueAtTime(from, currentTime);
            sound._node.gain.linearRampToValueAtTime(to, end);
          }
          self._startFadeInterval(sound, from, to, len, ids[i], typeof id === 'undefined');
        }
      }
      return self;
    },
    /**
     * Starts the internal interval to fade a sound.
     * @param  {Object} sound Reference to sound to fade.
     * @param  {Number} from The value to fade from (0.0 to 1.0).
     * @param  {Number} to   The volume to fade to (0.0 to 1.0).
     * @param  {Number} len  Time in milliseconds to fade.
     * @param  {Number} id   The sound id to fade.
     * @param  {Boolean} isGroup   If true, set the volume on the group.
     */
    _startFadeInterval: function _startFadeInterval(sound, from, to, len, id, isGroup) {
      var self = this;
      var vol = from;
      var diff = to - from;
      var steps = Math.abs(diff / 0.01);
      var stepLen = Math.max(4, steps > 0 ? len / steps : len);
      var lastTick = Date.now();

      // Store the value being faded to.
      sound._fadeTo = to;

      // Update the volume value on each interval tick.
      sound._interval = setInterval(function () {
        // Update the volume based on the time since the last tick.
        var tick = (Date.now() - lastTick) / len;
        lastTick = Date.now();
        vol += diff * tick;

        // Round to within 2 decimal points.
        vol = Math.round(vol * 100) / 100;

        // Make sure the volume is in the right bounds.
        if (diff < 0) {
          vol = Math.max(to, vol);
        } else {
          vol = Math.min(to, vol);
        }

        // Change the volume.
        if (self._webAudio) {
          sound._volume = vol;
        } else {
          self.volume(vol, sound._id, true);
        }

        // Set the group's volume.
        if (isGroup) {
          self._volume = vol;
        }

        // When the fade is complete, stop it and fire event.
        if (to < from && vol <= to || to > from && vol >= to) {
          clearInterval(sound._interval);
          sound._interval = null;
          sound._fadeTo = null;
          self.volume(to, sound._id);
          self._emit('fade', sound._id);
        }
      }, stepLen);
    },
    /**
     * Internal method that stops the currently playing fade when
     * a new fade starts, volume is changed or the sound is stopped.
     * @param  {Number} id The sound id.
     * @return {Howl}
     */
    _stopFade: function _stopFade(id) {
      var self = this;
      var sound = self._soundById(id);
      if (sound && sound._interval) {
        if (self._webAudio) {
          sound._node.gain.cancelScheduledValues(Howler.ctx.currentTime);
        }
        clearInterval(sound._interval);
        sound._interval = null;
        self.volume(sound._fadeTo, id);
        sound._fadeTo = null;
        self._emit('fade', id);
      }
      return self;
    },
    /**
     * Get/set the loop parameter on a sound. This method can optionally take 0, 1 or 2 arguments.
     *   loop() -> Returns the group's loop value.
     *   loop(id) -> Returns the sound id's loop value.
     *   loop(loop) -> Sets the loop value for all sounds in this Howl group.
     *   loop(loop, id) -> Sets the loop value of passed sound id.
     * @return {Howl/Boolean} Returns self or current loop value.
     */
    loop: function loop() {
      var self = this;
      var args = arguments;
      var loop, id, sound;

      // Determine the values for loop and id.
      if (args.length === 0) {
        // Return the grou's loop value.
        return self._loop;
      } else if (args.length === 1) {
        if (typeof args[0] === 'boolean') {
          loop = args[0];
          self._loop = loop;
        } else {
          // Return this sound's loop value.
          sound = self._soundById(parseInt(args[0], 10));
          return sound ? sound._loop : false;
        }
      } else if (args.length === 2) {
        loop = args[0];
        id = parseInt(args[1], 10);
      }

      // If no id is passed, get all ID's to be looped.
      var ids = self._getSoundIds(id);
      for (var i = 0; i < ids.length; i++) {
        sound = self._soundById(ids[i]);
        if (sound) {
          sound._loop = loop;
          if (self._webAudio && sound._node && sound._node.bufferSource) {
            sound._node.bufferSource.loop = loop;
            if (loop) {
              sound._node.bufferSource.loopStart = sound._start || 0;
              sound._node.bufferSource.loopEnd = sound._stop;

              // If playing, restart playback to ensure looping updates.
              if (self.playing(ids[i])) {
                self.pause(ids[i], true);
                self.play(ids[i], true);
              }
            }
          }
        }
      }
      return self;
    },
    /**
     * Get/set the playback rate of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   rate() -> Returns the first sound node's current playback rate.
     *   rate(id) -> Returns the sound id's current playback rate.
     *   rate(rate) -> Sets the playback rate of all sounds in this Howl group.
     *   rate(rate, id) -> Sets the playback rate of passed sound id.
     * @return {Howl/Number} Returns self or the current playback rate.
     */
    rate: function rate() {
      var self = this;
      var args = arguments;
      var rate, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current rate of the first node.
        id = self._sounds[0]._id;
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new rate value.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else {
          rate = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        rate = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // Update the playback rate or return the current value.
      var sound;
      if (typeof rate === 'number') {
        // If the sound hasn't loaded, add it to the load queue to change playback rate when capable.
        if (self._state !== 'loaded' || self._playLock) {
          self._queue.push({
            event: 'rate',
            action: function action() {
              self.rate.apply(self, args);
            }
          });
          return self;
        }

        // Set the group rate.
        if (typeof id === 'undefined') {
          self._rate = rate;
        }

        // Update one or all volumes.
        id = self._getSoundIds(id);
        for (var i = 0; i < id.length; i++) {
          // Get the sound.
          sound = self._soundById(id[i]);
          if (sound) {
            // Keep track of our position when the rate changed and update the playback
            // start position so we can properly adjust the seek position for time elapsed.
            if (self.playing(id[i])) {
              sound._rateSeek = self.seek(id[i]);
              sound._playStart = self._webAudio ? Howler.ctx.currentTime : sound._playStart;
            }
            sound._rate = rate;

            // Change the playback rate.
            if (self._webAudio && sound._node && sound._node.bufferSource) {
              sound._node.bufferSource.playbackRate.setValueAtTime(rate, Howler.ctx.currentTime);
            } else if (sound._node) {
              sound._node.playbackRate = rate;
            }

            // Reset the timers.
            var seek = self.seek(id[i]);
            var duration = (self._sprite[sound._sprite][0] + self._sprite[sound._sprite][1]) / 1000 - seek;
            var timeout = duration * 1000 / Math.abs(sound._rate);

            // Start a new end timer if sound is already playing.
            if (self._endTimers[id[i]] || !sound._paused) {
              self._clearTimer(id[i]);
              self._endTimers[id[i]] = setTimeout(self._ended.bind(self, sound), timeout);
            }
            self._emit('rate', sound._id);
          }
        }
      } else {
        sound = self._soundById(id);
        return sound ? sound._rate : self._rate;
      }
      return self;
    },
    /**
     * Get/set the seek position of a sound. This method can optionally take 0, 1 or 2 arguments.
     *   seek() -> Returns the first sound node's current seek position.
     *   seek(id) -> Returns the sound id's current seek position.
     *   seek(seek) -> Sets the seek position of the first sound node.
     *   seek(seek, id) -> Sets the seek position of passed sound id.
     * @return {Howl/Number} Returns self or the current seek position.
     */
    seek: function seek() {
      var self = this;
      var args = arguments;
      var seek, id;

      // Determine the values based on arguments.
      if (args.length === 0) {
        // We will simply return the current position of the first node.
        if (self._sounds.length) {
          id = self._sounds[0]._id;
        }
      } else if (args.length === 1) {
        // First check if this is an ID, and if not, assume it is a new seek position.
        var ids = self._getSoundIds();
        var index = ids.indexOf(args[0]);
        if (index >= 0) {
          id = parseInt(args[0], 10);
        } else if (self._sounds.length) {
          id = self._sounds[0]._id;
          seek = parseFloat(args[0]);
        }
      } else if (args.length === 2) {
        seek = parseFloat(args[0]);
        id = parseInt(args[1], 10);
      }

      // If there is no ID, bail out.
      if (typeof id === 'undefined') {
        return 0;
      }

      // If the sound hasn't loaded, add it to the load queue to seek when capable.
      if (typeof seek === 'number' && (self._state !== 'loaded' || self._playLock)) {
        self._queue.push({
          event: 'seek',
          action: function action() {
            self.seek.apply(self, args);
          }
        });
        return self;
      }

      // Get the sound.
      var sound = self._soundById(id);
      if (sound) {
        if (typeof seek === 'number' && seek >= 0) {
          // Pause the sound and update position for restarting playback.
          var playing = self.playing(id);
          if (playing) {
            self.pause(id, true);
          }

          // Move the position of the track and cancel timer.
          sound._seek = seek;
          sound._ended = false;
          self._clearTimer(id);

          // Update the seek position for HTML5 Audio.
          if (!self._webAudio && sound._node && !isNaN(sound._node.duration)) {
            sound._node.currentTime = seek;
          }

          // Seek and emit when ready.
          var seekAndEmit = function seekAndEmit() {
            // Restart the playback if the sound was playing.
            if (playing) {
              self.play(id, true);
            }
            self._emit('seek', id);
          };

          // Wait for the play lock to be unset before emitting (HTML5 Audio).
          if (playing && !self._webAudio) {
            var _emitSeek = function emitSeek() {
              if (!self._playLock) {
                seekAndEmit();
              } else {
                setTimeout(_emitSeek, 0);
              }
            };
            setTimeout(_emitSeek, 0);
          } else {
            seekAndEmit();
          }
        } else {
          if (self._webAudio) {
            var realTime = self.playing(id) ? Howler.ctx.currentTime - sound._playStart : 0;
            var rateSeek = sound._rateSeek ? sound._rateSeek - sound._seek : 0;
            return sound._seek + (rateSeek + realTime * Math.abs(sound._rate));
          } else {
            return sound._node.currentTime;
          }
        }
      }
      return self;
    },
    /**
     * Check if a specific sound is currently playing or not (if id is provided), or check if at least one of the sounds in the group is playing or not.
     * @param  {Number}  id The sound id to check. If none is passed, the whole sound group is checked.
     * @return {Boolean} True if playing and false if not.
     */
    playing: function playing(id) {
      var self = this;

      // Check the passed sound ID (if any).
      if (typeof id === 'number') {
        var sound = self._soundById(id);
        return sound ? !sound._paused : false;
      }

      // Otherwise, loop through all sounds and check if any are playing.
      for (var i = 0; i < self._sounds.length; i++) {
        if (!self._sounds[i]._paused) {
          return true;
        }
      }
      return false;
    },
    /**
     * Get the duration of this sound. Passing a sound id will return the sprite duration.
     * @param  {Number} id The sound id to check. If none is passed, return full source duration.
     * @return {Number} Audio duration in seconds.
     */
    duration: function duration(id) {
      var self = this;
      var duration = self._duration;

      // If we pass an ID, get the sound and return the sprite length.
      var sound = self._soundById(id);
      if (sound) {
        duration = self._sprite[sound._sprite][1] / 1000;
      }
      return duration;
    },
    /**
     * Returns the current loaded state of this Howl.
     * @return {String} 'unloaded', 'loading', 'loaded'
     */
    state: function state() {
      return this._state;
    },
    /**
     * Unload and destroy the current Howl object.
     * This will immediately stop all sound instances attached to this group.
     */
    unload: function unload() {
      var self = this;

      // Stop playing any active sounds.
      var sounds = self._sounds;
      for (var i = 0; i < sounds.length; i++) {
        // Stop the sound if it is currently playing.
        if (!sounds[i]._paused) {
          self.stop(sounds[i]._id);
        }

        // Remove the source or disconnect.
        if (!self._webAudio) {
          // Set the source to 0-second silence to stop any downloading (except in IE).
          self._clearSound(sounds[i]._node);

          // Remove any event listeners.
          sounds[i]._node.removeEventListener('error', sounds[i]._errorFn, false);
          sounds[i]._node.removeEventListener(Howler._canPlayEvent, sounds[i]._loadFn, false);
          sounds[i]._node.removeEventListener('ended', sounds[i]._endFn, false);

          // Release the Audio object back to the pool.
          Howler._releaseHtml5Audio(sounds[i]._node);
        }

        // Empty out all of the nodes.
        delete sounds[i]._node;

        // Make sure all timers are cleared out.
        self._clearTimer(sounds[i]._id);
      }

      // Remove the references in the global Howler object.
      var index = Howler._howls.indexOf(self);
      if (index >= 0) {
        Howler._howls.splice(index, 1);
      }

      // Delete this sound from the cache (if no other Howl is using it).
      var remCache = true;
      for (i = 0; i < Howler._howls.length; i++) {
        if (Howler._howls[i]._src === self._src || self._src.indexOf(Howler._howls[i]._src) >= 0) {
          remCache = false;
          break;
        }
      }
      if (cache && remCache) {
        delete cache[self._src];
      }

      // Clear global errors.
      Howler.noAudio = false;

      // Clear out `self`.
      self._state = 'unloaded';
      self._sounds = [];
      self = null;
      return null;
    },
    /**
     * Listen to a custom event.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @param  {Number}   once  (INTERNAL) Marks event to fire only once.
     * @return {Howl}
     */
    on: function on(event, fn, id, once) {
      var self = this;
      var events = self['_on' + event];
      if (typeof fn === 'function') {
        events.push(once ? {
          id: id,
          fn: fn,
          once: once
        } : {
          id: id,
          fn: fn
        });
      }
      return self;
    },
    /**
     * Remove a custom event. Call without parameters to remove all events.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to remove. Leave empty to remove all.
     * @param  {Number}   id    (optional) Only remove events for this sound.
     * @return {Howl}
     */
    off: function off(event, fn, id) {
      var self = this;
      var events = self['_on' + event];
      var i = 0;

      // Allow passing just an event and ID.
      if (typeof fn === 'number') {
        id = fn;
        fn = null;
      }
      if (fn || id) {
        // Loop through event store and remove the passed function.
        for (i = 0; i < events.length; i++) {
          var isId = id === events[i].id;
          if (fn === events[i].fn && isId || !fn && isId) {
            events.splice(i, 1);
            break;
          }
        }
      } else if (event) {
        // Clear out all events of this type.
        self['_on' + event] = [];
      } else {
        // Clear out all events of every type.
        var keys = Object.keys(self);
        for (i = 0; i < keys.length; i++) {
          if (keys[i].indexOf('_on') === 0 && Array.isArray(self[keys[i]])) {
            self[keys[i]] = [];
          }
        }
      }
      return self;
    },
    /**
     * Listen to a custom event and remove it once fired.
     * @param  {String}   event Event name.
     * @param  {Function} fn    Listener to call.
     * @param  {Number}   id    (optional) Only listen to events for this sound.
     * @return {Howl}
     */
    once: function once(event, fn, id) {
      var self = this;

      // Setup the event listener.
      self.on(event, fn, id, 1);
      return self;
    },
    /**
     * Emit all events of a specific type and pass the sound id.
     * @param  {String} event Event name.
     * @param  {Number} id    Sound ID.
     * @param  {Number} msg   Message to go with event.
     * @return {Howl}
     */
    _emit: function _emit(event, id, msg) {
      var self = this;
      var events = self['_on' + event];

      // Loop through event store and fire all functions.
      for (var i = events.length - 1; i >= 0; i--) {
        // Only fire the listener if the correct ID is used.
        if (!events[i].id || events[i].id === id || event === 'load') {
          setTimeout(function (fn) {
            fn.call(this, id, msg);
          }.bind(self, events[i].fn), 0);

          // If this event was setup with `once`, remove it.
          if (events[i].once) {
            self.off(event, events[i].fn, events[i].id);
          }
        }
      }

      // Pass the event type into load queue so that it can continue stepping.
      self._loadQueue(event);
      return self;
    },
    /**
     * Queue of actions initiated before the sound has loaded.
     * These will be called in sequence, with the next only firing
     * after the previous has finished executing (even if async like play).
     * @return {Howl}
     */
    _loadQueue: function _loadQueue(event) {
      var self = this;
      if (self._queue.length > 0) {
        var task = self._queue[0];

        // Remove this task if a matching event was passed.
        if (task.event === event) {
          self._queue.shift();
          self._loadQueue();
        }

        // Run the task if no event type is passed.
        if (!event) {
          task.action();
        }
      }
      return self;
    },
    /**
     * Fired when playback ends at the end of the duration.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _ended: function _ended(sound) {
      var self = this;
      var sprite = sound._sprite;

      // If we are using IE and there was network latency we may be clipping
      // audio before it completes playing. Lets check the node to make sure it
      // believes it has completed, before ending the playback.
      if (!self._webAudio && sound._node && !sound._node.paused && !sound._node.ended && sound._node.currentTime < sound._stop) {
        setTimeout(self._ended.bind(self, sound), 100);
        return self;
      }

      // Should this sound loop?
      var loop = !!(sound._loop || self._sprite[sprite][2]);

      // Fire the ended event.
      self._emit('end', sound._id);

      // Restart the playback for HTML5 Audio loop.
      if (!self._webAudio && loop) {
        self.stop(sound._id, true).play(sound._id);
      }

      // Restart this timer if on a Web Audio loop.
      if (self._webAudio && loop) {
        self._emit('play', sound._id);
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        sound._playStart = Howler.ctx.currentTime;
        var timeout = (sound._stop - sound._start) * 1000 / Math.abs(sound._rate);
        self._endTimers[sound._id] = setTimeout(self._ended.bind(self, sound), timeout);
      }

      // Mark the node as paused.
      if (self._webAudio && !loop) {
        sound._paused = true;
        sound._ended = true;
        sound._seek = sound._start || 0;
        sound._rateSeek = 0;
        self._clearTimer(sound._id);

        // Clean up the buffer source.
        self._cleanBuffer(sound._node);

        // Attempt to auto-suspend AudioContext if no sounds are still playing.
        Howler._autoSuspend();
      }

      // When using a sprite, end the track.
      if (!self._webAudio && !loop) {
        self.stop(sound._id, true);
      }
      return self;
    },
    /**
     * Clear the end timer for a sound playback.
     * @param  {Number} id The sound ID.
     * @return {Howl}
     */
    _clearTimer: function _clearTimer(id) {
      var self = this;
      if (self._endTimers[id]) {
        // Clear the timeout or remove the ended listener.
        if (typeof self._endTimers[id] !== 'function') {
          clearTimeout(self._endTimers[id]);
        } else {
          var sound = self._soundById(id);
          if (sound && sound._node) {
            sound._node.removeEventListener('ended', self._endTimers[id], false);
          }
        }
        delete self._endTimers[id];
      }
      return self;
    },
    /**
     * Return the sound identified by this ID, or return null.
     * @param  {Number} id Sound ID
     * @return {Object}    Sound object or null.
     */
    _soundById: function _soundById(id) {
      var self = this;

      // Loop through all sounds and find the one with this ID.
      for (var i = 0; i < self._sounds.length; i++) {
        if (id === self._sounds[i]._id) {
          return self._sounds[i];
        }
      }
      return null;
    },
    /**
     * Return an inactive sound from the pool or create a new one.
     * @return {Sound} Sound playback object.
     */
    _inactiveSound: function _inactiveSound() {
      var self = this;
      self._drain();

      // Find the first inactive node to recycle.
      for (var i = 0; i < self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          return self._sounds[i].reset();
        }
      }

      // If no inactive node was found, create a new one.
      return new Sound(self);
    },
    /**
     * Drain excess inactive sounds from the pool.
     */
    _drain: function _drain() {
      var self = this;
      var limit = self._pool;
      var cnt = 0;
      var i = 0;

      // If there are less sounds than the max pool size, we are done.
      if (self._sounds.length < limit) {
        return;
      }

      // Count the number of inactive sounds.
      for (i = 0; i < self._sounds.length; i++) {
        if (self._sounds[i]._ended) {
          cnt++;
        }
      }

      // Remove excess inactive sounds, going in reverse order.
      for (i = self._sounds.length - 1; i >= 0; i--) {
        if (cnt <= limit) {
          return;
        }
        if (self._sounds[i]._ended) {
          // Disconnect the audio source when using Web Audio.
          if (self._webAudio && self._sounds[i]._node) {
            self._sounds[i]._node.disconnect(0);
          }

          // Remove sounds until we have the pool size.
          self._sounds.splice(i, 1);
          cnt--;
        }
      }
    },
    /**
     * Get all ID's from the sounds pool.
     * @param  {Number} id Only return one ID if one is passed.
     * @return {Array}    Array of IDs.
     */
    _getSoundIds: function _getSoundIds(id) {
      var self = this;
      if (typeof id === 'undefined') {
        var ids = [];
        for (var i = 0; i < self._sounds.length; i++) {
          ids.push(self._sounds[i]._id);
        }
        return ids;
      } else {
        return [id];
      }
    },
    /**
     * Load the sound back into the buffer source.
     * @param  {Sound} sound The sound object to work with.
     * @return {Howl}
     */
    _refreshBuffer: function _refreshBuffer(sound) {
      var self = this;

      // Setup the buffer source for playback.
      sound._node.bufferSource = Howler.ctx.createBufferSource();
      sound._node.bufferSource.buffer = cache[self._src];

      // Connect to the correct node.
      if (sound._panner) {
        sound._node.bufferSource.connect(sound._panner);
      } else {
        sound._node.bufferSource.connect(sound._node);
      }

      // Setup looping and playback rate.
      sound._node.bufferSource.loop = sound._loop;
      if (sound._loop) {
        sound._node.bufferSource.loopStart = sound._start || 0;
        sound._node.bufferSource.loopEnd = sound._stop || 0;
      }
      sound._node.bufferSource.playbackRate.setValueAtTime(sound._rate, Howler.ctx.currentTime);
      return self;
    },
    /**
     * Prevent memory leaks by cleaning up the buffer source after playback.
     * @param  {Object} node Sound's audio node containing the buffer source.
     * @return {Howl}
     */
    _cleanBuffer: function _cleanBuffer(node) {
      var self = this;
      var isIOS = Howler._navigator && Howler._navigator.vendor.indexOf('Apple') >= 0;
      if (!node.bufferSource) {
        return self;
      }
      if (Howler._scratchBuffer && node.bufferSource) {
        node.bufferSource.onended = null;
        node.bufferSource.disconnect(0);
        if (isIOS) {
          try {
            node.bufferSource.buffer = Howler._scratchBuffer;
          } catch (e) {}
        }
      }
      node.bufferSource = null;
      return self;
    },
    /**
     * Set the source to a 0-second silence to stop any downloading (except in IE).
     * @param  {Object} node Audio node to clear.
     */
    _clearSound: function _clearSound(node) {
      var checkIE = /MSIE |Trident\//.test(Howler._navigator && Howler._navigator.userAgent);
      if (!checkIE) {
        node.src = 'data:audio/wav;base64,UklGRigAAABXQVZFZm10IBIAAAABAAEARKwAAIhYAQACABAAAABkYXRhAgAAAAEA';
      }
    }
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Setup the sound object, which each node attached to a Howl group is contained in.
   * @param {Object} howl The Howl parent group.
   */
  var Sound = function Sound(howl) {
    this._parent = howl;
    this.init();
  };
  Sound.prototype = {
    /**
     * Initialize a new Sound object.
     * @return {Sound}
     */
    init: function init() {
      var self = this;
      var parent = self._parent;

      // Setup the default parameters.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._rate = parent._rate;
      self._seek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a unique ID for this sound.
      self._id = ++Howler._counter;

      // Add itself to the parent's pool.
      parent._sounds.push(self);

      // Create the new node.
      self.create();
      return self;
    },
    /**
     * Create and setup a new sound object, whether HTML5 Audio or Web Audio.
     * @return {Sound}
     */
    create: function create() {
      var self = this;
      var parent = self._parent;
      var volume = Howler._muted || self._muted || self._parent._muted ? 0 : self._volume;
      if (parent._webAudio) {
        // Create the gain node for controlling volume (the source will connect to this).
        self._node = typeof Howler.ctx.createGain === 'undefined' ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
        self._node.gain.setValueAtTime(volume, Howler.ctx.currentTime);
        self._node.paused = true;
        self._node.connect(Howler.masterGain);
      } else if (!Howler.noAudio) {
        // Get an unlocked Audio object from the pool.
        self._node = Howler._obtainHtml5Audio();

        // Listen for errors (http://dev.w3.org/html5/spec-author-view/spec.html#mediaerror).
        self._errorFn = self._errorListener.bind(self);
        self._node.addEventListener('error', self._errorFn, false);

        // Listen for 'canplaythrough' event to let us know the sound is ready.
        self._loadFn = self._loadListener.bind(self);
        self._node.addEventListener(Howler._canPlayEvent, self._loadFn, false);

        // Listen for the 'ended' event on the sound to account for edge-case where
        // a finite sound has a duration of Infinity.
        self._endFn = self._endListener.bind(self);
        self._node.addEventListener('ended', self._endFn, false);

        // Setup the new audio node.
        self._node.src = parent._src;
        self._node.preload = parent._preload === true ? 'auto' : parent._preload;
        self._node.volume = volume * Howler.volume();

        // Begin loading the source.
        self._node.load();
      }
      return self;
    },
    /**
     * Reset the parameters of this sound to the original state (for recycle).
     * @return {Sound}
     */
    reset: function reset() {
      var self = this;
      var parent = self._parent;

      // Reset all of the parameters of this sound.
      self._muted = parent._muted;
      self._loop = parent._loop;
      self._volume = parent._volume;
      self._rate = parent._rate;
      self._seek = 0;
      self._rateSeek = 0;
      self._paused = true;
      self._ended = true;
      self._sprite = '__default';

      // Generate a new ID so that it isn't confused with the previous sound.
      self._id = ++Howler._counter;
      return self;
    },
    /**
     * HTML5 Audio error listener callback.
     */
    _errorListener: function _errorListener() {
      var self = this;

      // Fire an error event and pass back the code.
      self._parent._emit('loaderror', self._id, self._node.error ? self._node.error.code : 0);

      // Clear the event listener.
      self._node.removeEventListener('error', self._errorFn, false);
    },
    /**
     * HTML5 Audio canplaythrough listener callback.
     */
    _loadListener: function _loadListener() {
      var self = this;
      var parent = self._parent;

      // Round up the duration to account for the lower precision in HTML5 Audio.
      parent._duration = Math.ceil(self._node.duration * 10) / 10;

      // Setup a sprite if none is defined.
      if (Object.keys(parent._sprite).length === 0) {
        parent._sprite = {
          __default: [0, parent._duration * 1000]
        };
      }
      if (parent._state !== 'loaded') {
        parent._state = 'loaded';
        parent._emit('load');
        parent._loadQueue();
      }

      // Clear the event listener.
      self._node.removeEventListener(Howler._canPlayEvent, self._loadFn, false);
    },
    /**
     * HTML5 Audio ended listener callback.
     */
    _endListener: function _endListener() {
      var self = this;
      var parent = self._parent;

      // Only handle the `ended`` event if the duration is Infinity.
      if (parent._duration === Infinity) {
        // Update the parent duration to match the real audio duration.
        // Round up the duration to account for the lower precision in HTML5 Audio.
        parent._duration = Math.ceil(self._node.duration * 10) / 10;

        // Update the sprite that corresponds to the real duration.
        if (parent._sprite.__default[1] === Infinity) {
          parent._sprite.__default[1] = parent._duration * 1000;
        }

        // Run the regular ended method.
        parent._ended(self);
      }

      // Clear the event listener since the duration is now correct.
      self._node.removeEventListener('ended', self._endFn, false);
    }
  };

  /** Helper Methods **/
  /***************************************************************************/

  var cache = {};

  /**
   * Buffer a sound from URL, Data URI or cache and decode to audio source (Web Audio API).
   * @param  {Howl} self
   */
  var loadBuffer = function loadBuffer(self) {
    var url = self._src;

    // Check if the buffer has already been cached and use it instead.
    if (cache[url]) {
      // Set the duration from the cache.
      self._duration = cache[url].duration;

      // Load the sound into this Howl.
      loadSound(self);
      return;
    }
    if (/^data:[^;]+;base64,/.test(url)) {
      // Decode the base64 data URI without XHR, since some browsers don't support it.
      var data = atob(url.split(',')[1]);
      var dataView = new Uint8Array(data.length);
      for (var i = 0; i < data.length; ++i) {
        dataView[i] = data.charCodeAt(i);
      }
      decodeAudioData(dataView.buffer, self);
    } else {
      // Load the buffer from the URL.
      var xhr = new XMLHttpRequest();
      xhr.open(self._xhr.method, url, true);
      xhr.withCredentials = self._xhr.withCredentials;
      xhr.responseType = 'arraybuffer';

      // Apply any custom headers to the request.
      if (self._xhr.headers) {
        Object.keys(self._xhr.headers).forEach(function (key) {
          xhr.setRequestHeader(key, self._xhr.headers[key]);
        });
      }
      xhr.onload = function () {
        // Make sure we get a successful response back.
        var code = (xhr.status + '')[0];
        if (code !== '0' && code !== '2' && code !== '3') {
          self._emit('loaderror', null, 'Failed loading audio file with status: ' + xhr.status + '.');
          return;
        }
        decodeAudioData(xhr.response, self);
      };
      xhr.onerror = function () {
        // If there is an error, switch to HTML5 Audio.
        if (self._webAudio) {
          self._html5 = true;
          self._webAudio = false;
          self._sounds = [];
          delete cache[url];
          self.load();
        }
      };
      safeXhrSend(xhr);
    }
  };

  /**
   * Send the XHR request wrapped in a try/catch.
   * @param  {Object} xhr XHR to send.
   */
  var safeXhrSend = function safeXhrSend(xhr) {
    try {
      xhr.send();
    } catch (e) {
      xhr.onerror();
    }
  };

  /**
   * Decode audio data from an array buffer.
   * @param  {ArrayBuffer} arraybuffer The audio data.
   * @param  {Howl}        self
   */
  var decodeAudioData = function decodeAudioData(arraybuffer, self) {
    // Fire a load error if something broke.
    var error = function error() {
      self._emit('loaderror', null, 'Decoding audio data failed.');
    };

    // Load the sound on success.
    var success = function success(buffer) {
      if (buffer && self._sounds.length > 0) {
        cache[self._src] = buffer;
        loadSound(self, buffer);
      } else {
        error();
      }
    };

    // Decode the buffer into an audio source.
    if (typeof Promise !== 'undefined' && Howler.ctx.decodeAudioData.length === 1) {
      Howler.ctx.decodeAudioData(arraybuffer).then(success)["catch"](error);
    } else {
      Howler.ctx.decodeAudioData(arraybuffer, success, error);
    }
  };

  /**
   * Sound is now loaded, so finish setting everything up and fire the loaded event.
   * @param  {Howl} self
   * @param  {Object} buffer The decoded buffer sound source.
   */
  var loadSound = function loadSound(self, buffer) {
    // Set the duration.
    if (buffer && !self._duration) {
      self._duration = buffer.duration;
    }

    // Setup a sprite if none is defined.
    if (Object.keys(self._sprite).length === 0) {
      self._sprite = {
        __default: [0, self._duration * 1000]
      };
    }

    // Fire the loaded event.
    if (self._state !== 'loaded') {
      self._state = 'loaded';
      self._emit('load');
      self._loadQueue();
    }
  };

  /**
   * Setup the audio context when available, or switch to HTML5 Audio mode.
   */
  var setupAudioContext = function setupAudioContext() {
    // If we have already detected that Web Audio isn't supported, don't run this step again.
    if (!Howler.usingWebAudio) {
      return;
    }

    // Check if we are using Web Audio and setup the AudioContext if we are.
    try {
      if (typeof AudioContext !== 'undefined') {
        Howler.ctx = new AudioContext();
      } else if (typeof webkitAudioContext !== 'undefined') {
        Howler.ctx = new webkitAudioContext();
      } else {
        Howler.usingWebAudio = false;
      }
    } catch (e) {
      Howler.usingWebAudio = false;
    }

    // If the audio context creation still failed, set using web audio to false.
    if (!Howler.ctx) {
      Howler.usingWebAudio = false;
    }

    // Check if a webview is being used on iOS8 or earlier (rather than the browser).
    // If it is, disable Web Audio as it causes crashing.
    var iOS = /iP(hone|od|ad)/.test(Howler._navigator && Howler._navigator.platform);
    var appVersion = Howler._navigator && Howler._navigator.appVersion.match(/OS (\d+)_(\d+)_?(\d+)?/);
    var version = appVersion ? parseInt(appVersion[1], 10) : null;
    if (iOS && version && version < 9) {
      var safari = /safari/.test(Howler._navigator && Howler._navigator.userAgent.toLowerCase());
      if (Howler._navigator && !safari) {
        Howler.usingWebAudio = false;
      }
    }

    // Create and expose the master GainNode when using Web Audio (useful for plugins or advanced usage).
    if (Howler.usingWebAudio) {
      Howler.masterGain = typeof Howler.ctx.createGain === 'undefined' ? Howler.ctx.createGainNode() : Howler.ctx.createGain();
      Howler.masterGain.gain.setValueAtTime(Howler._muted ? 0 : Howler._volume, Howler.ctx.currentTime);
      Howler.masterGain.connect(Howler.ctx.destination);
    }

    // Re-run the setup on Howler.
    Howler._setup();
  };

  // Add support for AMD (Asynchronous Module Definition) libraries such as require.js.
  if (typeof define === 'function' && define.amd) {
    define([], function () {
      return {
        Howler: Howler,
        Howl: Howl
      };
    });
  }

  // Add support for CommonJS libraries such as browserify.
  if (typeof exports !== 'undefined') {
    exports.Howler = Howler;
    exports.Howl = Howl;
  }

  // Add to global in Node.js (for testing, etc).
  if (typeof global !== 'undefined') {
    global.HowlerGlobal = HowlerGlobal;
    global.Howler = Howler;
    global.Howl = Howl;
    global.Sound = Sound;
  } else if (typeof window !== 'undefined') {
    // Define globally in case AMD is not available or unused.
    window.HowlerGlobal = HowlerGlobal;
    window.Howler = Howler;
    window.Howl = Howl;
    window.Sound = Sound;
  }
})();

/*!
 *  Spatial Plugin - Adds support for stereo and 3D audio where Web Audio is supported.
 *  
 *  howler.js v2.2.4
 *  howlerjs.com
 *
 *  (c) 2013-2020, James Simpson of GoldFire Studios
 *  goldfirestudios.com
 *
 *  MIT License
 */

(function () {
  'use strict';

  // Setup default properties.
  HowlerGlobal.prototype._pos = [0, 0, 0];
  HowlerGlobal.prototype._orientation = [0, 0, -1, 0, 1, 0];

  /** Global Methods **/
  /***************************************************************************/

  /**
   * Helper method to update the stereo panning position of all current Howls.
   * Future Howls will not use this value unless explicitly set.
   * @param  {Number} pan A value of -1.0 is all the way left and 1.0 is all the way right.
   * @return {Howler/Number}     Self or current stereo panning value.
   */
  HowlerGlobal.prototype.stereo = function (pan) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Loop through all Howls and update their stereo panning.
    for (var i = self._howls.length - 1; i >= 0; i--) {
      self._howls[i].stereo(pan);
    }
    return self;
  };

  /**
   * Get/set the position of the listener in 3D cartesian space. Sounds using
   * 3D position will be relative to the listener's position.
   * @param  {Number} x The x-position of the listener.
   * @param  {Number} y The y-position of the listener.
   * @param  {Number} z The z-position of the listener.
   * @return {Howler/Array}   Self or current listener position.
   */
  HowlerGlobal.prototype.pos = function (x, y, z) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = typeof y !== 'number' ? self._pos[1] : y;
    z = typeof z !== 'number' ? self._pos[2] : z;
    if (typeof x === 'number') {
      self._pos = [x, y, z];
      if (typeof self.ctx.listener.positionX !== 'undefined') {
        self.ctx.listener.positionX.setTargetAtTime(self._pos[0], Howler.ctx.currentTime, 0.1);
        self.ctx.listener.positionY.setTargetAtTime(self._pos[1], Howler.ctx.currentTime, 0.1);
        self.ctx.listener.positionZ.setTargetAtTime(self._pos[2], Howler.ctx.currentTime, 0.1);
      } else {
        self.ctx.listener.setPosition(self._pos[0], self._pos[1], self._pos[2]);
      }
    } else {
      return self._pos;
    }
    return self;
  };

  /**
   * Get/set the direction the listener is pointing in the 3D cartesian space.
   * A front and up vector must be provided. The front is the direction the
   * face of the listener is pointing, and up is the direction the top of the
   * listener is pointing. Thus, these values are expected to be at right angles
   * from each other.
   * @param  {Number} x   The x-orientation of the listener.
   * @param  {Number} y   The y-orientation of the listener.
   * @param  {Number} z   The z-orientation of the listener.
   * @param  {Number} xUp The x-orientation of the top of the listener.
   * @param  {Number} yUp The y-orientation of the top of the listener.
   * @param  {Number} zUp The z-orientation of the top of the listener.
   * @return {Howler/Array}     Returns self or the current orientation vectors.
   */
  HowlerGlobal.prototype.orientation = function (x, y, z, xUp, yUp, zUp) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self.ctx || !self.ctx.listener) {
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    var or = self._orientation;
    y = typeof y !== 'number' ? or[1] : y;
    z = typeof z !== 'number' ? or[2] : z;
    xUp = typeof xUp !== 'number' ? or[3] : xUp;
    yUp = typeof yUp !== 'number' ? or[4] : yUp;
    zUp = typeof zUp !== 'number' ? or[5] : zUp;
    if (typeof x === 'number') {
      self._orientation = [x, y, z, xUp, yUp, zUp];
      if (typeof self.ctx.listener.forwardX !== 'undefined') {
        self.ctx.listener.forwardX.setTargetAtTime(x, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.forwardY.setTargetAtTime(y, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.forwardZ.setTargetAtTime(z, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.upX.setTargetAtTime(xUp, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.upY.setTargetAtTime(yUp, Howler.ctx.currentTime, 0.1);
        self.ctx.listener.upZ.setTargetAtTime(zUp, Howler.ctx.currentTime, 0.1);
      } else {
        self.ctx.listener.setOrientation(x, y, z, xUp, yUp, zUp);
      }
    } else {
      return or;
    }
    return self;
  };

  /** Group Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core init.
   * @param  {Function} _super Core init method.
   * @return {Howl}
   */
  Howl.prototype.init = function (_super) {
    return function (o) {
      var self = this;

      // Setup user-defined default properties.
      self._orientation = o.orientation || [1, 0, 0];
      self._stereo = o.stereo || null;
      self._pos = o.pos || null;
      self._pannerAttr = {
        coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : 360,
        coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : 360,
        coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : 0,
        distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : 'inverse',
        maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : 10000,
        panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : 'HRTF',
        refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : 1,
        rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : 1
      };

      // Setup event listeners.
      self._onstereo = o.onstereo ? [{
        fn: o.onstereo
      }] : [];
      self._onpos = o.onpos ? [{
        fn: o.onpos
      }] : [];
      self._onorientation = o.onorientation ? [{
        fn: o.onorientation
      }] : [];

      // Complete initilization with howler.js core's init function.
      return _super.call(this, o);
    };
  }(Howl.prototype.init);

  /**
   * Get/set the stereo panning of the audio source for this sound or all in the group.
   * @param  {Number} pan  A value of -1.0 is all the way left and 1.0 is all the way right.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Number}    Returns self or the current stereo panning value.
   */
  Howl.prototype.stereo = function (pan, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change stereo pan when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'stereo',
        action: function action() {
          self.stereo(pan, id);
        }
      });
      return self;
    }

    // Check for PannerStereoNode support and fallback to PannerNode if it doesn't exist.
    var pannerType = typeof Howler.ctx.createStereoPanner === 'undefined' ? 'spatial' : 'stereo';

    // Setup the group's stereo panning if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's stereo panning if no parameters are passed.
      if (typeof pan === 'number') {
        self._stereo = pan;
        self._pos = [pan, 0, 0];
      } else {
        return self._stereo;
      }
    }

    // Change the streo panning of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i = 0; i < ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);
      if (sound) {
        if (typeof pan === 'number') {
          sound._stereo = pan;
          sound._pos = [pan, 0, 0];
          if (sound._node) {
            // If we are falling back, make sure the panningModel is equalpower.
            sound._pannerAttr.panningModel = 'equalpower';

            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || !sound._panner.pan) {
              setupPanner(sound, pannerType);
            }
            if (pannerType === 'spatial') {
              if (typeof sound._panner.positionX !== 'undefined') {
                sound._panner.positionX.setValueAtTime(pan, Howler.ctx.currentTime);
                sound._panner.positionY.setValueAtTime(0, Howler.ctx.currentTime);
                sound._panner.positionZ.setValueAtTime(0, Howler.ctx.currentTime);
              } else {
                sound._panner.setPosition(pan, 0, 0);
              }
            } else {
              sound._panner.pan.setValueAtTime(pan, Howler.ctx.currentTime);
            }
          }
          self._emit('stereo', sound._id);
        } else {
          return sound._stereo;
        }
      }
    }
    return self;
  };

  /**
   * Get/set the 3D spatial position of the audio source for this sound or group relative to the global listener.
   * @param  {Number} x  The x-position of the audio source.
   * @param  {Number} y  The y-position of the audio source.
   * @param  {Number} z  The z-position of the audio source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial position: [x, y, z].
   */
  Howl.prototype.pos = function (x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change position when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'pos',
        action: function action() {
          self.pos(x, y, z, id);
        }
      });
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = typeof y !== 'number' ? 0 : y;
    z = typeof z !== 'number' ? -0.5 : z;

    // Setup the group's spatial position if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial position if no parameters are passed.
      if (typeof x === 'number') {
        self._pos = [x, y, z];
      } else {
        return self._pos;
      }
    }

    // Change the spatial position of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i = 0; i < ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);
      if (sound) {
        if (typeof x === 'number') {
          sound._pos = [x, y, z];
          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner || sound._panner.pan) {
              setupPanner(sound, 'spatial');
            }
            if (typeof sound._panner.positionX !== 'undefined') {
              sound._panner.positionX.setValueAtTime(x, Howler.ctx.currentTime);
              sound._panner.positionY.setValueAtTime(y, Howler.ctx.currentTime);
              sound._panner.positionZ.setValueAtTime(z, Howler.ctx.currentTime);
            } else {
              sound._panner.setPosition(x, y, z);
            }
          }
          self._emit('pos', sound._id);
        } else {
          return sound._pos;
        }
      }
    }
    return self;
  };

  /**
   * Get/set the direction the audio source is pointing in the 3D cartesian coordinate
   * space. Depending on how direction the sound is, based on the `cone` attributes,
   * a sound pointing away from the listener can be quiet or silent.
   * @param  {Number} x  The x-orientation of the source.
   * @param  {Number} y  The y-orientation of the source.
   * @param  {Number} z  The z-orientation of the source.
   * @param  {Number} id (optional) The sound ID. If none is passed, all in group will be updated.
   * @return {Howl/Array}    Returns self or the current 3D spatial orientation: [x, y, z].
   */
  Howl.prototype.orientation = function (x, y, z, id) {
    var self = this;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // If the sound hasn't loaded, add it to the load queue to change orientation when capable.
    if (self._state !== 'loaded') {
      self._queue.push({
        event: 'orientation',
        action: function action() {
          self.orientation(x, y, z, id);
        }
      });
      return self;
    }

    // Set the defaults for optional 'y' & 'z'.
    y = typeof y !== 'number' ? self._orientation[1] : y;
    z = typeof z !== 'number' ? self._orientation[2] : z;

    // Setup the group's spatial orientation if no ID is passed.
    if (typeof id === 'undefined') {
      // Return the group's spatial orientation if no parameters are passed.
      if (typeof x === 'number') {
        self._orientation = [x, y, z];
      } else {
        return self._orientation;
      }
    }

    // Change the spatial orientation of one or all sounds in group.
    var ids = self._getSoundIds(id);
    for (var i = 0; i < ids.length; i++) {
      // Get the sound.
      var sound = self._soundById(ids[i]);
      if (sound) {
        if (typeof x === 'number') {
          sound._orientation = [x, y, z];
          if (sound._node) {
            // Check if there is a panner setup and create a new one if not.
            if (!sound._panner) {
              // Make sure we have a position to setup the node with.
              if (!sound._pos) {
                sound._pos = self._pos || [0, 0, -0.5];
              }
              setupPanner(sound, 'spatial');
            }
            if (typeof sound._panner.orientationX !== 'undefined') {
              sound._panner.orientationX.setValueAtTime(x, Howler.ctx.currentTime);
              sound._panner.orientationY.setValueAtTime(y, Howler.ctx.currentTime);
              sound._panner.orientationZ.setValueAtTime(z, Howler.ctx.currentTime);
            } else {
              sound._panner.setOrientation(x, y, z);
            }
          }
          self._emit('orientation', sound._id);
        } else {
          return sound._orientation;
        }
      }
    }
    return self;
  };

  /**
   * Get/set the panner node's attributes for a sound or group of sounds.
   * This method can optionall take 0, 1 or 2 arguments.
   *   pannerAttr() -> Returns the group's values.
   *   pannerAttr(id) -> Returns the sound id's values.
   *   pannerAttr(o) -> Set's the values of all sounds in this Howl group.
   *   pannerAttr(o, id) -> Set's the values of passed sound id.
   *
   *   Attributes:
   *     coneInnerAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      inside of which there will be no volume reduction.
   *     coneOuterAngle - (360 by default) A parameter for directional audio sources, this is an angle, in degrees,
   *                      outside of which the volume will be reduced to a constant value of `coneOuterGain`.
   *     coneOuterGain - (0 by default) A parameter for directional audio sources, this is the gain outside of the
   *                     `coneOuterAngle`. It is a linear value in the range `[0, 1]`.
   *     distanceModel - ('inverse' by default) Determines algorithm used to reduce volume as audio moves away from
   *                     listener. Can be `linear`, `inverse` or `exponential.
   *     maxDistance - (10000 by default) The maximum distance between source and listener, after which the volume
   *                   will not be reduced any further.
   *     refDistance - (1 by default) A reference distance for reducing volume as source moves further from the listener.
   *                   This is simply a variable of the distance model and has a different effect depending on which model
   *                   is used and the scale of your coordinates. Generally, volume will be equal to 1 at this distance.
   *     rolloffFactor - (1 by default) How quickly the volume reduces as source moves from listener. This is simply a
   *                     variable of the distance model and can be in the range of `[0, 1]` with `linear` and `[0, ∞]`
   *                     with `inverse` and `exponential`.
   *     panningModel - ('HRTF' by default) Determines which spatialization algorithm is used to position audio.
   *                     Can be `HRTF` or `equalpower`.
   *
   * @return {Howl/Object} Returns self or current panner attributes.
   */
  Howl.prototype.pannerAttr = function () {
    var self = this;
    var args = arguments;
    var o, id, sound;

    // Stop right here if not using Web Audio.
    if (!self._webAudio) {
      return self;
    }

    // Determine the values based on arguments.
    if (args.length === 0) {
      // Return the group's panner attribute values.
      return self._pannerAttr;
    } else if (args.length === 1) {
      if (_typeof(args[0]) === 'object') {
        o = args[0];

        // Set the grou's panner attribute values.
        if (typeof id === 'undefined') {
          if (!o.pannerAttr) {
            o.pannerAttr = {
              coneInnerAngle: o.coneInnerAngle,
              coneOuterAngle: o.coneOuterAngle,
              coneOuterGain: o.coneOuterGain,
              distanceModel: o.distanceModel,
              maxDistance: o.maxDistance,
              refDistance: o.refDistance,
              rolloffFactor: o.rolloffFactor,
              panningModel: o.panningModel
            };
          }
          self._pannerAttr = {
            coneInnerAngle: typeof o.pannerAttr.coneInnerAngle !== 'undefined' ? o.pannerAttr.coneInnerAngle : self._coneInnerAngle,
            coneOuterAngle: typeof o.pannerAttr.coneOuterAngle !== 'undefined' ? o.pannerAttr.coneOuterAngle : self._coneOuterAngle,
            coneOuterGain: typeof o.pannerAttr.coneOuterGain !== 'undefined' ? o.pannerAttr.coneOuterGain : self._coneOuterGain,
            distanceModel: typeof o.pannerAttr.distanceModel !== 'undefined' ? o.pannerAttr.distanceModel : self._distanceModel,
            maxDistance: typeof o.pannerAttr.maxDistance !== 'undefined' ? o.pannerAttr.maxDistance : self._maxDistance,
            refDistance: typeof o.pannerAttr.refDistance !== 'undefined' ? o.pannerAttr.refDistance : self._refDistance,
            rolloffFactor: typeof o.pannerAttr.rolloffFactor !== 'undefined' ? o.pannerAttr.rolloffFactor : self._rolloffFactor,
            panningModel: typeof o.pannerAttr.panningModel !== 'undefined' ? o.pannerAttr.panningModel : self._panningModel
          };
        }
      } else {
        // Return this sound's panner attribute values.
        sound = self._soundById(parseInt(args[0], 10));
        return sound ? sound._pannerAttr : self._pannerAttr;
      }
    } else if (args.length === 2) {
      o = args[0];
      id = parseInt(args[1], 10);
    }

    // Update the values of the specified sounds.
    var ids = self._getSoundIds(id);
    for (var i = 0; i < ids.length; i++) {
      sound = self._soundById(ids[i]);
      if (sound) {
        // Merge the new values into the sound.
        var pa = sound._pannerAttr;
        pa = {
          coneInnerAngle: typeof o.coneInnerAngle !== 'undefined' ? o.coneInnerAngle : pa.coneInnerAngle,
          coneOuterAngle: typeof o.coneOuterAngle !== 'undefined' ? o.coneOuterAngle : pa.coneOuterAngle,
          coneOuterGain: typeof o.coneOuterGain !== 'undefined' ? o.coneOuterGain : pa.coneOuterGain,
          distanceModel: typeof o.distanceModel !== 'undefined' ? o.distanceModel : pa.distanceModel,
          maxDistance: typeof o.maxDistance !== 'undefined' ? o.maxDistance : pa.maxDistance,
          refDistance: typeof o.refDistance !== 'undefined' ? o.refDistance : pa.refDistance,
          rolloffFactor: typeof o.rolloffFactor !== 'undefined' ? o.rolloffFactor : pa.rolloffFactor,
          panningModel: typeof o.panningModel !== 'undefined' ? o.panningModel : pa.panningModel
        };

        // Create a new panner node if one doesn't already exist.
        var panner = sound._panner;
        if (!panner) {
          // Make sure we have a position to setup the node with.
          if (!sound._pos) {
            sound._pos = self._pos || [0, 0, -0.5];
          }

          // Create a new panner node.
          setupPanner(sound, 'spatial');
          panner = sound._panner;
        }

        // Update the panner values or create a new panner if none exists.
        panner.coneInnerAngle = pa.coneInnerAngle;
        panner.coneOuterAngle = pa.coneOuterAngle;
        panner.coneOuterGain = pa.coneOuterGain;
        panner.distanceModel = pa.distanceModel;
        panner.maxDistance = pa.maxDistance;
        panner.refDistance = pa.refDistance;
        panner.rolloffFactor = pa.rolloffFactor;
        panner.panningModel = pa.panningModel;
      }
    }
    return self;
  };

  /** Single Sound Methods **/
  /***************************************************************************/

  /**
   * Add new properties to the core Sound init.
   * @param  {Function} _super Core Sound init method.
   * @return {Sound}
   */
  Sound.prototype.init = function (_super) {
    return function () {
      var self = this;
      var parent = self._parent;

      // Setup user-defined default properties.
      self._orientation = parent._orientation;
      self._stereo = parent._stereo;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // Complete initilization with howler.js core Sound's init function.
      _super.call(this);

      // If a stereo or position was specified, set it up.
      if (self._stereo) {
        parent.stereo(self._stereo);
      } else if (self._pos) {
        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
      }
    };
  }(Sound.prototype.init);

  /**
   * Override the Sound.reset method to clean up properties from the spatial plugin.
   * @param  {Function} _super Sound reset method.
   * @return {Sound}
   */
  Sound.prototype.reset = function (_super) {
    return function () {
      var self = this;
      var parent = self._parent;

      // Reset all spatial plugin properties on this sound.
      self._orientation = parent._orientation;
      self._stereo = parent._stereo;
      self._pos = parent._pos;
      self._pannerAttr = parent._pannerAttr;

      // If a stereo or position was specified, set it up.
      if (self._stereo) {
        parent.stereo(self._stereo);
      } else if (self._pos) {
        parent.pos(self._pos[0], self._pos[1], self._pos[2], self._id);
      } else if (self._panner) {
        // Disconnect the panner.
        self._panner.disconnect(0);
        self._panner = undefined;
        parent._refreshBuffer(self);
      }

      // Complete resetting of the sound.
      return _super.call(this);
    };
  }(Sound.prototype.reset);

  /** Helper Methods **/
  /***************************************************************************/

  /**
   * Create a new panner node and save it on the sound.
   * @param  {Sound} sound Specific sound to setup panning on.
   * @param {String} type Type of panner to create: 'stereo' or 'spatial'.
   */
  var setupPanner = function setupPanner(sound, type) {
    type = type || 'spatial';

    // Create the new panner node.
    if (type === 'spatial') {
      sound._panner = Howler.ctx.createPanner();
      sound._panner.coneInnerAngle = sound._pannerAttr.coneInnerAngle;
      sound._panner.coneOuterAngle = sound._pannerAttr.coneOuterAngle;
      sound._panner.coneOuterGain = sound._pannerAttr.coneOuterGain;
      sound._panner.distanceModel = sound._pannerAttr.distanceModel;
      sound._panner.maxDistance = sound._pannerAttr.maxDistance;
      sound._panner.refDistance = sound._pannerAttr.refDistance;
      sound._panner.rolloffFactor = sound._pannerAttr.rolloffFactor;
      sound._panner.panningModel = sound._pannerAttr.panningModel;
      if (typeof sound._panner.positionX !== 'undefined') {
        sound._panner.positionX.setValueAtTime(sound._pos[0], Howler.ctx.currentTime);
        sound._panner.positionY.setValueAtTime(sound._pos[1], Howler.ctx.currentTime);
        sound._panner.positionZ.setValueAtTime(sound._pos[2], Howler.ctx.currentTime);
      } else {
        sound._panner.setPosition(sound._pos[0], sound._pos[1], sound._pos[2]);
      }
      if (typeof sound._panner.orientationX !== 'undefined') {
        sound._panner.orientationX.setValueAtTime(sound._orientation[0], Howler.ctx.currentTime);
        sound._panner.orientationY.setValueAtTime(sound._orientation[1], Howler.ctx.currentTime);
        sound._panner.orientationZ.setValueAtTime(sound._orientation[2], Howler.ctx.currentTime);
      } else {
        sound._panner.setOrientation(sound._orientation[0], sound._orientation[1], sound._orientation[2]);
      }
    } else {
      sound._panner = Howler.ctx.createStereoPanner();
      sound._panner.pan.setValueAtTime(sound._stereo, Howler.ctx.currentTime);
    }
    sound._panner.connect(sound._node);

    // Update the connections.
    if (!sound._paused) {
      sound._parent.pause(sound._id, true).play(sound._id, true);
    }
  };
})();